webpackJsonp([1,0,2,3],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(20);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(3);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _vueRouter = __webpack_require__(660);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _app = __webpack_require__(606);
	
	var _app2 = _interopRequireDefault(_app);
	
	__webpack_require__(445);
	
	var _elementUi = __webpack_require__(386);
	
	var _elementUi2 = _interopRequireDefault(_elementUi);
	
	var _vueEcharts = __webpack_require__(605);
	
	var _vueEcharts2 = _interopRequireDefault(_vueEcharts);
	
	__webpack_require__(403);
	
	var _vueResource = __webpack_require__(659);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _store = __webpack_require__(11);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _echartsWalden = __webpack_require__(449);
	
	var _echartsWalden2 = _interopRequireDefault(_echartsWalden);
	
	var _SSOUtil = __webpack_require__(99);
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _home = __webpack_require__(184);
	
	var _home2 = _interopRequireDefault(_home);
	
	var _baselineRepair = __webpack_require__(611);
	
	var _baselineRepair2 = _interopRequireDefault(_baselineRepair);
	
	var _terminalIllegal = __webpack_require__(626);
	
	var _terminalIllegal2 = _interopRequireDefault(_terminalIllegal);
	
	var _moaInstallForMac = __webpack_require__(617);
	
	var _moaInstallForMac2 = _interopRequireDefault(_moaInstallForMac);
	
	var _moaInstallForWin = __webpack_require__(618);
	
	var _moaInstallForWin2 = _interopRequireDefault(_moaInstallForWin);
	
	var _dataLeakInstallForWin = __webpack_require__(613);
	
	var _dataLeakInstallForWin2 = _interopRequireDefault(_dataLeakInstallForWin);
	
	var _dataLeakInstallForMac = __webpack_require__(612);
	
	var _dataLeakInstallForMac2 = _interopRequireDefault(_dataLeakInstallForMac);
	
	var _saimenInstallForWin = __webpack_require__(624);
	
	var _saimenInstallForWin2 = _interopRequireDefault(_saimenInstallForWin);
	
	var _saimenInstallForMac = __webpack_require__(623);
	
	var _saimenInstallForMac2 = _interopRequireDefault(_saimenInstallForMac);
	
	var _whiteApply = __webpack_require__(630);
	
	var _whiteApply2 = _interopRequireDefault(_whiteApply);
	
	var _moaUninstall = __webpack_require__(619);
	
	var _moaUninstall2 = _interopRequireDefault(_moaUninstall);
	
	var _verifyMoaIsInstall = __webpack_require__(621);
	
	var _verifyMoaIsInstall2 = _interopRequireDefault(_verifyMoaIsInstall);
	
	var _moaVersionView = __webpack_require__(620);
	
	var _moaVersionView2 = _interopRequireDefault(_moaVersionView);
	
	var _macOS_FAQ = __webpack_require__(616);
	
	var _macOS_FAQ2 = _interopRequireDefault(_macOS_FAQ);
	
	var _windows_FAQ = __webpack_require__(631);
	
	var _windows_FAQ2 = _interopRequireDefault(_windows_FAQ);
	
	var _other_FAQ = __webpack_require__(622);
	
	var _other_FAQ2 = _interopRequireDefault(_other_FAQ);
	
	var _userCertApply = __webpack_require__(629);
	
	var _userCertApply2 = _interopRequireDefault(_userCertApply);
	
	var _callback = __webpack_require__(607);
	
	var _callback2 = _interopRequireDefault(_callback);
	
	var _addItem = __webpack_require__(608);
	
	var _addItem2 = _interopRequireDefault(_addItem);
	
	var _editorItem = __webpack_require__(615);
	
	var _editorItem2 = _interopRequireDefault(_editorItem);
	
	var _templateHtml = __webpack_require__(625);
	
	var _templateHtml2 = _interopRequireDefault(_templateHtml);
	
	var _updateDocument = __webpack_require__(627);
	
	var _updateDocument2 = _interopRequireDefault(_updateDocument);
	
	var _deleteItem = __webpack_require__(614);
	
	var _deleteItem2 = _interopRequireDefault(_deleteItem);
	
	var _updateItem = __webpack_require__(628);
	
	var _updateItem2 = _interopRequireDefault(_updateItem);
	
	var _addLangIndex = __webpack_require__(609);
	
	var _addLangIndex2 = _interopRequireDefault(_addLangIndex);
	
	var _ai = __webpack_require__(610);
	
	var _ai2 = _interopRequireDefault(_ai);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_elementUi2.default);
	_vue2.default.use(_vueRouter2.default);
	_vue2.default.use(_vueResource2.default);
	_vue2.default.use(_vuex2.default);
	
	_vue2.default.config.debug = true;
	
	_vueEcharts2.default.registerTheme('walden', _echartsWalden2.default);
	_vue2.default.component('chart', _vueEcharts2.default);
	
	var routers = new _vueRouter2.default({
	    routes: [{ path: '/', redirect: 'terminalRepairTips', component: _terminalIllegal2.default }, { path: '/home', name: 'home', component: _home2.default }, { path: '/terminalRepairTips', name: 'terminalRepairTips', component: _terminalIllegal2.default }, { path: '/moaUninstall', name: 'moaUninstall', component: _moaUninstall2.default }, { path: '/verifyMoaIsInstall', name: 'verifyMoaIsInstall', component: _verifyMoaIsInstall2.default }, { path: '/moaVersionView', name: 'moaVersionView', component: _moaVersionView2.default }, { path: '/baselineRepair', name: 'baselineRepair', component: _baselineRepair2.default }, { path: '/callback', name: 'cb', component: _callback2.default }, { path: '/moaInstallForWin', component: _moaInstallForWin2.default, name: 'Win安装方法' }, { path: '/moaInstallForMac', component: _moaInstallForMac2.default, name: 'Mac安装方法' }, { path: '/dataLeakInstallForWin', component: _dataLeakInstallForWin2.default, name: 'Win安装方法' }, { path: '/dataLeakInstallForMac', component: _dataLeakInstallForMac2.default, name: 'Mac安装方法' }, { path: '/saimenInstallForWin', component: _saimenInstallForWin2.default, name: 'Win安装方法' }, { path: '/saimenInstallForMac', component: _saimenInstallForMac2.default, name: 'Mac安装方法' }, { path: '/macOS_FAQ', component: _macOS_FAQ2.default, name: 'moaOS常见问题' }, { path: '/windows_FAQ', component: _windows_FAQ2.default, name: 'windows常见问题' }, { path: '/whiteApply', component: _whiteApply2.default, name: '临时白名单申请' }, { path: '/other_FAQ', component: _other_FAQ2.default, name: '其他常见问题' }, { path: '/templateHtml', name: 'template', component: _templateHtml2.default }, { path: '/addItem', name: 'addItem', component: _addItem2.default }, { path: '/editorItem', name: 'editorItem', component: _editorItem2.default }, { path: '/updateDocument', name: 'update', component: _updateDocument2.default }, { path: '/updateItem', name: 'updateItem', component: _updateItem2.default }, { path: '/deleteItem', name: 'delete', component: _deleteItem2.default }, { path: '/whiteApply', name: 'whiteApply', component: _whiteApply2.default }, { path: '/addLangIndex', name: 'addLangIndex', component: _addLangIndex2.default }, { path: '/ai', name: 'ai', component: _ai2.default }]
	});
	
	_SSOUtil.ssoWeb.login().then(function (ssoid) {
	    if (ssoid && typeof ssoid === 'string') {
	        _SSOUtil.sso.setSsoid(ssoid);
	        _axios2.default.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
	        _axios2.default.defaults.headers.common['access-token'] = ssoid;
	        _axios2.default.defaults.headers.common['client-id'] = _SSOUtil.sso.clientId;
	        new _vue2.default({
	            router: routers,
	            store: _store2.default,
	            render: function render(h) {
	                return h(_app2.default);
	            }
	        }).$mount('#app');
	    }
	});

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/LICENSE
	
	// This is CodeMirror (https://codemirror.net), a code editor
	// implemented in JavaScript on top of the browser's DOM.
	//
	// You can find some technical background for some of the code below
	// at http://marijnhaverbeke.nl/blog/#cm-internals .
	
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (global = global || self, global.CodeMirror = factory());
	}(this, (function () { 'use strict';
	
	  // Kludges for bugs and behavior differences that can't be feature
	  // detected are enabled based on userAgent etc sniffing.
	  var userAgent = navigator.userAgent;
	  var platform = navigator.platform;
	
	  var gecko = /gecko\/\d/i.test(userAgent);
	  var ie_upto10 = /MSIE \d/.test(userAgent);
	  var ie_11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(userAgent);
	  var edge = /Edge\/(\d+)/.exec(userAgent);
	  var ie = ie_upto10 || ie_11up || edge;
	  var ie_version = ie && (ie_upto10 ? document.documentMode || 6 : +(edge || ie_11up)[1]);
	  var webkit = !edge && /WebKit\//.test(userAgent);
	  var qtwebkit = webkit && /Qt\/\d+\.\d+/.test(userAgent);
	  var chrome = !edge && /Chrome\//.test(userAgent);
	  var presto = /Opera\//.test(userAgent);
	  var safari = /Apple Computer/.test(navigator.vendor);
	  var mac_geMountainLion = /Mac OS X 1\d\D([8-9]|\d\d)\D/.test(userAgent);
	  var phantom = /PhantomJS/.test(userAgent);
	
	  var ios = !edge && /AppleWebKit/.test(userAgent) && /Mobile\/\w+/.test(userAgent);
	  var android = /Android/.test(userAgent);
	  // This is woefully incomplete. Suggestions for alternative methods welcome.
	  var mobile = ios || android || /webOS|BlackBerry|Opera Mini|Opera Mobi|IEMobile/i.test(userAgent);
	  var mac = ios || /Mac/.test(platform);
	  var chromeOS = /\bCrOS\b/.test(userAgent);
	  var windows = /win/i.test(platform);
	
	  var presto_version = presto && userAgent.match(/Version\/(\d*\.\d*)/);
	  if (presto_version) { presto_version = Number(presto_version[1]); }
	  if (presto_version && presto_version >= 15) { presto = false; webkit = true; }
	  // Some browsers use the wrong event properties to signal cmd/ctrl on OS X
	  var flipCtrlCmd = mac && (qtwebkit || presto && (presto_version == null || presto_version < 12.11));
	  var captureRightClick = gecko || (ie && ie_version >= 9);
	
	  function classTest(cls) { return new RegExp("(^|\\s)" + cls + "(?:$|\\s)\\s*") }
	
	  var rmClass = function(node, cls) {
	    var current = node.className;
	    var match = classTest(cls).exec(current);
	    if (match) {
	      var after = current.slice(match.index + match[0].length);
	      node.className = current.slice(0, match.index) + (after ? match[1] + after : "");
	    }
	  };
	
	  function removeChildren(e) {
	    for (var count = e.childNodes.length; count > 0; --count)
	      { e.removeChild(e.firstChild); }
	    return e
	  }
	
	  function removeChildrenAndAdd(parent, e) {
	    return removeChildren(parent).appendChild(e)
	  }
	
	  function elt(tag, content, className, style) {
	    var e = document.createElement(tag);
	    if (className) { e.className = className; }
	    if (style) { e.style.cssText = style; }
	    if (typeof content == "string") { e.appendChild(document.createTextNode(content)); }
	    else if (content) { for (var i = 0; i < content.length; ++i) { e.appendChild(content[i]); } }
	    return e
	  }
	  // wrapper for elt, which removes the elt from the accessibility tree
	  function eltP(tag, content, className, style) {
	    var e = elt(tag, content, className, style);
	    e.setAttribute("role", "presentation");
	    return e
	  }
	
	  var range;
	  if (document.createRange) { range = function(node, start, end, endNode) {
	    var r = document.createRange();
	    r.setEnd(endNode || node, end);
	    r.setStart(node, start);
	    return r
	  }; }
	  else { range = function(node, start, end) {
	    var r = document.body.createTextRange();
	    try { r.moveToElementText(node.parentNode); }
	    catch(e) { return r }
	    r.collapse(true);
	    r.moveEnd("character", end);
	    r.moveStart("character", start);
	    return r
	  }; }
	
	  function contains(parent, child) {
	    if (child.nodeType == 3) // Android browser always returns false when child is a textnode
	      { child = child.parentNode; }
	    if (parent.contains)
	      { return parent.contains(child) }
	    do {
	      if (child.nodeType == 11) { child = child.host; }
	      if (child == parent) { return true }
	    } while (child = child.parentNode)
	  }
	
	  function activeElt() {
	    // IE and Edge may throw an "Unspecified Error" when accessing document.activeElement.
	    // IE < 10 will throw when accessed while the page is loading or in an iframe.
	    // IE > 9 and Edge will throw when accessed in an iframe if document.body is unavailable.
	    var activeElement;
	    try {
	      activeElement = document.activeElement;
	    } catch(e) {
	      activeElement = document.body || null;
	    }
	    while (activeElement && activeElement.shadowRoot && activeElement.shadowRoot.activeElement)
	      { activeElement = activeElement.shadowRoot.activeElement; }
	    return activeElement
	  }
	
	  function addClass(node, cls) {
	    var current = node.className;
	    if (!classTest(cls).test(current)) { node.className += (current ? " " : "") + cls; }
	  }
	  function joinClasses(a, b) {
	    var as = a.split(" ");
	    for (var i = 0; i < as.length; i++)
	      { if (as[i] && !classTest(as[i]).test(b)) { b += " " + as[i]; } }
	    return b
	  }
	
	  var selectInput = function(node) { node.select(); };
	  if (ios) // Mobile Safari apparently has a bug where select() is broken.
	    { selectInput = function(node) { node.selectionStart = 0; node.selectionEnd = node.value.length; }; }
	  else if (ie) // Suppress mysterious IE10 errors
	    { selectInput = function(node) { try { node.select(); } catch(_e) {} }; }
	
	  function bind(f) {
	    var args = Array.prototype.slice.call(arguments, 1);
	    return function(){return f.apply(null, args)}
	  }
	
	  function copyObj(obj, target, overwrite) {
	    if (!target) { target = {}; }
	    for (var prop in obj)
	      { if (obj.hasOwnProperty(prop) && (overwrite !== false || !target.hasOwnProperty(prop)))
	        { target[prop] = obj[prop]; } }
	    return target
	  }
	
	  // Counts the column offset in a string, taking tabs into account.
	  // Used mostly to find indentation.
	  function countColumn(string, end, tabSize, startIndex, startValue) {
	    if (end == null) {
	      end = string.search(/[^\s\u00a0]/);
	      if (end == -1) { end = string.length; }
	    }
	    for (var i = startIndex || 0, n = startValue || 0;;) {
	      var nextTab = string.indexOf("\t", i);
	      if (nextTab < 0 || nextTab >= end)
	        { return n + (end - i) }
	      n += nextTab - i;
	      n += tabSize - (n % tabSize);
	      i = nextTab + 1;
	    }
	  }
	
	  var Delayed = function() {
	    this.id = null;
	    this.f = null;
	    this.time = 0;
	    this.handler = bind(this.onTimeout, this);
	  };
	  Delayed.prototype.onTimeout = function (self) {
	    self.id = 0;
	    if (self.time <= +new Date) {
	      self.f();
	    } else {
	      setTimeout(self.handler, self.time - +new Date);
	    }
	  };
	  Delayed.prototype.set = function (ms, f) {
	    this.f = f;
	    var time = +new Date + ms;
	    if (!this.id || time < this.time) {
	      clearTimeout(this.id);
	      this.id = setTimeout(this.handler, ms);
	      this.time = time;
	    }
	  };
	
	  function indexOf(array, elt) {
	    for (var i = 0; i < array.length; ++i)
	      { if (array[i] == elt) { return i } }
	    return -1
	  }
	
	  // Number of pixels added to scroller and sizer to hide scrollbar
	  var scrollerGap = 30;
	
	  // Returned or thrown by various protocols to signal 'I'm not
	  // handling this'.
	  var Pass = {toString: function(){return "CodeMirror.Pass"}};
	
	  // Reused option objects for setSelection & friends
	  var sel_dontScroll = {scroll: false}, sel_mouse = {origin: "*mouse"}, sel_move = {origin: "+move"};
	
	  // The inverse of countColumn -- find the offset that corresponds to
	  // a particular column.
	  function findColumn(string, goal, tabSize) {
	    for (var pos = 0, col = 0;;) {
	      var nextTab = string.indexOf("\t", pos);
	      if (nextTab == -1) { nextTab = string.length; }
	      var skipped = nextTab - pos;
	      if (nextTab == string.length || col + skipped >= goal)
	        { return pos + Math.min(skipped, goal - col) }
	      col += nextTab - pos;
	      col += tabSize - (col % tabSize);
	      pos = nextTab + 1;
	      if (col >= goal) { return pos }
	    }
	  }
	
	  var spaceStrs = [""];
	  function spaceStr(n) {
	    while (spaceStrs.length <= n)
	      { spaceStrs.push(lst(spaceStrs) + " "); }
	    return spaceStrs[n]
	  }
	
	  function lst(arr) { return arr[arr.length-1] }
	
	  function map(array, f) {
	    var out = [];
	    for (var i = 0; i < array.length; i++) { out[i] = f(array[i], i); }
	    return out
	  }
	
	  function insertSorted(array, value, score) {
	    var pos = 0, priority = score(value);
	    while (pos < array.length && score(array[pos]) <= priority) { pos++; }
	    array.splice(pos, 0, value);
	  }
	
	  function nothing() {}
	
	  function createObj(base, props) {
	    var inst;
	    if (Object.create) {
	      inst = Object.create(base);
	    } else {
	      nothing.prototype = base;
	      inst = new nothing();
	    }
	    if (props) { copyObj(props, inst); }
	    return inst
	  }
	
	  var nonASCIISingleCaseWordChar = /[\u00df\u0587\u0590-\u05f4\u0600-\u06ff\u3040-\u309f\u30a0-\u30ff\u3400-\u4db5\u4e00-\u9fcc\uac00-\ud7af]/;
	  function isWordCharBasic(ch) {
	    return /\w/.test(ch) || ch > "\x80" &&
	      (ch.toUpperCase() != ch.toLowerCase() || nonASCIISingleCaseWordChar.test(ch))
	  }
	  function isWordChar(ch, helper) {
	    if (!helper) { return isWordCharBasic(ch) }
	    if (helper.source.indexOf("\\w") > -1 && isWordCharBasic(ch)) { return true }
	    return helper.test(ch)
	  }
	
	  function isEmpty(obj) {
	    for (var n in obj) { if (obj.hasOwnProperty(n) && obj[n]) { return false } }
	    return true
	  }
	
	  // Extending unicode characters. A series of a non-extending char +
	  // any number of extending chars is treated as a single unit as far
	  // as editing and measuring is concerned. This is not fully correct,
	  // since some scripts/fonts/browsers also treat other configurations
	  // of code points as a group.
	  var extendingChars = /[\u0300-\u036f\u0483-\u0489\u0591-\u05bd\u05bf\u05c1\u05c2\u05c4\u05c5\u05c7\u0610-\u061a\u064b-\u065e\u0670\u06d6-\u06dc\u06de-\u06e4\u06e7\u06e8\u06ea-\u06ed\u0711\u0730-\u074a\u07a6-\u07b0\u07eb-\u07f3\u0816-\u0819\u081b-\u0823\u0825-\u0827\u0829-\u082d\u0900-\u0902\u093c\u0941-\u0948\u094d\u0951-\u0955\u0962\u0963\u0981\u09bc\u09be\u09c1-\u09c4\u09cd\u09d7\u09e2\u09e3\u0a01\u0a02\u0a3c\u0a41\u0a42\u0a47\u0a48\u0a4b-\u0a4d\u0a51\u0a70\u0a71\u0a75\u0a81\u0a82\u0abc\u0ac1-\u0ac5\u0ac7\u0ac8\u0acd\u0ae2\u0ae3\u0b01\u0b3c\u0b3e\u0b3f\u0b41-\u0b44\u0b4d\u0b56\u0b57\u0b62\u0b63\u0b82\u0bbe\u0bc0\u0bcd\u0bd7\u0c3e-\u0c40\u0c46-\u0c48\u0c4a-\u0c4d\u0c55\u0c56\u0c62\u0c63\u0cbc\u0cbf\u0cc2\u0cc6\u0ccc\u0ccd\u0cd5\u0cd6\u0ce2\u0ce3\u0d3e\u0d41-\u0d44\u0d4d\u0d57\u0d62\u0d63\u0dca\u0dcf\u0dd2-\u0dd4\u0dd6\u0ddf\u0e31\u0e34-\u0e3a\u0e47-\u0e4e\u0eb1\u0eb4-\u0eb9\u0ebb\u0ebc\u0ec8-\u0ecd\u0f18\u0f19\u0f35\u0f37\u0f39\u0f71-\u0f7e\u0f80-\u0f84\u0f86\u0f87\u0f90-\u0f97\u0f99-\u0fbc\u0fc6\u102d-\u1030\u1032-\u1037\u1039\u103a\u103d\u103e\u1058\u1059\u105e-\u1060\u1071-\u1074\u1082\u1085\u1086\u108d\u109d\u135f\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17b7-\u17bd\u17c6\u17c9-\u17d3\u17dd\u180b-\u180d\u18a9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193b\u1a17\u1a18\u1a56\u1a58-\u1a5e\u1a60\u1a62\u1a65-\u1a6c\u1a73-\u1a7c\u1a7f\u1b00-\u1b03\u1b34\u1b36-\u1b3a\u1b3c\u1b42\u1b6b-\u1b73\u1b80\u1b81\u1ba2-\u1ba5\u1ba8\u1ba9\u1c2c-\u1c33\u1c36\u1c37\u1cd0-\u1cd2\u1cd4-\u1ce0\u1ce2-\u1ce8\u1ced\u1dc0-\u1de6\u1dfd-\u1dff\u200c\u200d\u20d0-\u20f0\u2cef-\u2cf1\u2de0-\u2dff\u302a-\u302f\u3099\u309a\ua66f-\ua672\ua67c\ua67d\ua6f0\ua6f1\ua802\ua806\ua80b\ua825\ua826\ua8c4\ua8e0-\ua8f1\ua926-\ua92d\ua947-\ua951\ua980-\ua982\ua9b3\ua9b6-\ua9b9\ua9bc\uaa29-\uaa2e\uaa31\uaa32\uaa35\uaa36\uaa43\uaa4c\uaab0\uaab2-\uaab4\uaab7\uaab8\uaabe\uaabf\uaac1\uabe5\uabe8\uabed\udc00-\udfff\ufb1e\ufe00-\ufe0f\ufe20-\ufe26\uff9e\uff9f]/;
	  function isExtendingChar(ch) { return ch.charCodeAt(0) >= 768 && extendingChars.test(ch) }
	
	  // Returns a number from the range [`0`; `str.length`] unless `pos` is outside that range.
	  function skipExtendingChars(str, pos, dir) {
	    while ((dir < 0 ? pos > 0 : pos < str.length) && isExtendingChar(str.charAt(pos))) { pos += dir; }
	    return pos
	  }
	
	  // Returns the value from the range [`from`; `to`] that satisfies
	  // `pred` and is closest to `from`. Assumes that at least `to`
	  // satisfies `pred`. Supports `from` being greater than `to`.
	  function findFirst(pred, from, to) {
	    // At any point we are certain `to` satisfies `pred`, don't know
	    // whether `from` does.
	    var dir = from > to ? -1 : 1;
	    for (;;) {
	      if (from == to) { return from }
	      var midF = (from + to) / 2, mid = dir < 0 ? Math.ceil(midF) : Math.floor(midF);
	      if (mid == from) { return pred(mid) ? from : to }
	      if (pred(mid)) { to = mid; }
	      else { from = mid + dir; }
	    }
	  }
	
	  // BIDI HELPERS
	
	  function iterateBidiSections(order, from, to, f) {
	    if (!order) { return f(from, to, "ltr", 0) }
	    var found = false;
	    for (var i = 0; i < order.length; ++i) {
	      var part = order[i];
	      if (part.from < to && part.to > from || from == to && part.to == from) {
	        f(Math.max(part.from, from), Math.min(part.to, to), part.level == 1 ? "rtl" : "ltr", i);
	        found = true;
	      }
	    }
	    if (!found) { f(from, to, "ltr"); }
	  }
	
	  var bidiOther = null;
	  function getBidiPartAt(order, ch, sticky) {
	    var found;
	    bidiOther = null;
	    for (var i = 0; i < order.length; ++i) {
	      var cur = order[i];
	      if (cur.from < ch && cur.to > ch) { return i }
	      if (cur.to == ch) {
	        if (cur.from != cur.to && sticky == "before") { found = i; }
	        else { bidiOther = i; }
	      }
	      if (cur.from == ch) {
	        if (cur.from != cur.to && sticky != "before") { found = i; }
	        else { bidiOther = i; }
	      }
	    }
	    return found != null ? found : bidiOther
	  }
	
	  // Bidirectional ordering algorithm
	  // See http://unicode.org/reports/tr9/tr9-13.html for the algorithm
	  // that this (partially) implements.
	
	  // One-char codes used for character types:
	  // L (L):   Left-to-Right
	  // R (R):   Right-to-Left
	  // r (AL):  Right-to-Left Arabic
	  // 1 (EN):  European Number
	  // + (ES):  European Number Separator
	  // % (ET):  European Number Terminator
	  // n (AN):  Arabic Number
	  // , (CS):  Common Number Separator
	  // m (NSM): Non-Spacing Mark
	  // b (BN):  Boundary Neutral
	  // s (B):   Paragraph Separator
	  // t (S):   Segment Separator
	  // w (WS):  Whitespace
	  // N (ON):  Other Neutrals
	
	  // Returns null if characters are ordered as they appear
	  // (left-to-right), or an array of sections ({from, to, level}
	  // objects) in the order in which they occur visually.
	  var bidiOrdering = (function() {
	    // Character types for codepoints 0 to 0xff
	    var lowTypes = "bbbbbbbbbtstwsbbbbbbbbbbbbbbssstwNN%%%NNNNNN,N,N1111111111NNNNNNNLLLLLLLLLLLLLLLLLLLLLLLLLLNNNNNNLLLLLLLLLLLLLLLLLLLLLLLLLLNNNNbbbbbbsbbbbbbbbbbbbbbbbbbbbbbbbbb,N%%%%NNNNLNNNNN%%11NLNNN1LNNNNNLLLLLLLLLLLLLLLLLLLLLLLNLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLN";
	    // Character types for codepoints 0x600 to 0x6f9
	    var arabicTypes = "nnnnnnNNr%%r,rNNmmmmmmmmmmmrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrmmmmmmmmmmmmmmmmmmmmmnnnnnnnnnn%nnrrrmrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrmmmmmmmnNmmmmmmrrmmNmmmmrr1111111111";
	    function charType(code) {
	      if (code <= 0xf7) { return lowTypes.charAt(code) }
	      else if (0x590 <= code && code <= 0x5f4) { return "R" }
	      else if (0x600 <= code && code <= 0x6f9) { return arabicTypes.charAt(code - 0x600) }
	      else if (0x6ee <= code && code <= 0x8ac) { return "r" }
	      else if (0x2000 <= code && code <= 0x200b) { return "w" }
	      else if (code == 0x200c) { return "b" }
	      else { return "L" }
	    }
	
	    var bidiRE = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
	    var isNeutral = /[stwN]/, isStrong = /[LRr]/, countsAsLeft = /[Lb1n]/, countsAsNum = /[1n]/;
	
	    function BidiSpan(level, from, to) {
	      this.level = level;
	      this.from = from; this.to = to;
	    }
	
	    return function(str, direction) {
	      var outerType = direction == "ltr" ? "L" : "R";
	
	      if (str.length == 0 || direction == "ltr" && !bidiRE.test(str)) { return false }
	      var len = str.length, types = [];
	      for (var i = 0; i < len; ++i)
	        { types.push(charType(str.charCodeAt(i))); }
	
	      // W1. Examine each non-spacing mark (NSM) in the level run, and
	      // change the type of the NSM to the type of the previous
	      // character. If the NSM is at the start of the level run, it will
	      // get the type of sor.
	      for (var i$1 = 0, prev = outerType; i$1 < len; ++i$1) {
	        var type = types[i$1];
	        if (type == "m") { types[i$1] = prev; }
	        else { prev = type; }
	      }
	
	      // W2. Search backwards from each instance of a European number
	      // until the first strong type (R, L, AL, or sor) is found. If an
	      // AL is found, change the type of the European number to Arabic
	      // number.
	      // W3. Change all ALs to R.
	      for (var i$2 = 0, cur = outerType; i$2 < len; ++i$2) {
	        var type$1 = types[i$2];
	        if (type$1 == "1" && cur == "r") { types[i$2] = "n"; }
	        else if (isStrong.test(type$1)) { cur = type$1; if (type$1 == "r") { types[i$2] = "R"; } }
	      }
	
	      // W4. A single European separator between two European numbers
	      // changes to a European number. A single common separator between
	      // two numbers of the same type changes to that type.
	      for (var i$3 = 1, prev$1 = types[0]; i$3 < len - 1; ++i$3) {
	        var type$2 = types[i$3];
	        if (type$2 == "+" && prev$1 == "1" && types[i$3+1] == "1") { types[i$3] = "1"; }
	        else if (type$2 == "," && prev$1 == types[i$3+1] &&
	                 (prev$1 == "1" || prev$1 == "n")) { types[i$3] = prev$1; }
	        prev$1 = type$2;
	      }
	
	      // W5. A sequence of European terminators adjacent to European
	      // numbers changes to all European numbers.
	      // W6. Otherwise, separators and terminators change to Other
	      // Neutral.
	      for (var i$4 = 0; i$4 < len; ++i$4) {
	        var type$3 = types[i$4];
	        if (type$3 == ",") { types[i$4] = "N"; }
	        else if (type$3 == "%") {
	          var end = (void 0);
	          for (end = i$4 + 1; end < len && types[end] == "%"; ++end) {}
	          var replace = (i$4 && types[i$4-1] == "!") || (end < len && types[end] == "1") ? "1" : "N";
	          for (var j = i$4; j < end; ++j) { types[j] = replace; }
	          i$4 = end - 1;
	        }
	      }
	
	      // W7. Search backwards from each instance of a European number
	      // until the first strong type (R, L, or sor) is found. If an L is
	      // found, then change the type of the European number to L.
	      for (var i$5 = 0, cur$1 = outerType; i$5 < len; ++i$5) {
	        var type$4 = types[i$5];
	        if (cur$1 == "L" && type$4 == "1") { types[i$5] = "L"; }
	        else if (isStrong.test(type$4)) { cur$1 = type$4; }
	      }
	
	      // N1. A sequence of neutrals takes the direction of the
	      // surrounding strong text if the text on both sides has the same
	      // direction. European and Arabic numbers act as if they were R in
	      // terms of their influence on neutrals. Start-of-level-run (sor)
	      // and end-of-level-run (eor) are used at level run boundaries.
	      // N2. Any remaining neutrals take the embedding direction.
	      for (var i$6 = 0; i$6 < len; ++i$6) {
	        if (isNeutral.test(types[i$6])) {
	          var end$1 = (void 0);
	          for (end$1 = i$6 + 1; end$1 < len && isNeutral.test(types[end$1]); ++end$1) {}
	          var before = (i$6 ? types[i$6-1] : outerType) == "L";
	          var after = (end$1 < len ? types[end$1] : outerType) == "L";
	          var replace$1 = before == after ? (before ? "L" : "R") : outerType;
	          for (var j$1 = i$6; j$1 < end$1; ++j$1) { types[j$1] = replace$1; }
	          i$6 = end$1 - 1;
	        }
	      }
	
	      // Here we depart from the documented algorithm, in order to avoid
	      // building up an actual levels array. Since there are only three
	      // levels (0, 1, 2) in an implementation that doesn't take
	      // explicit embedding into account, we can build up the order on
	      // the fly, without following the level-based algorithm.
	      var order = [], m;
	      for (var i$7 = 0; i$7 < len;) {
	        if (countsAsLeft.test(types[i$7])) {
	          var start = i$7;
	          for (++i$7; i$7 < len && countsAsLeft.test(types[i$7]); ++i$7) {}
	          order.push(new BidiSpan(0, start, i$7));
	        } else {
	          var pos = i$7, at = order.length, isRTL = direction == "rtl" ? 1 : 0;
	          for (++i$7; i$7 < len && types[i$7] != "L"; ++i$7) {}
	          for (var j$2 = pos; j$2 < i$7;) {
	            if (countsAsNum.test(types[j$2])) {
	              if (pos < j$2) { order.splice(at, 0, new BidiSpan(1, pos, j$2)); at += isRTL; }
	              var nstart = j$2;
	              for (++j$2; j$2 < i$7 && countsAsNum.test(types[j$2]); ++j$2) {}
	              order.splice(at, 0, new BidiSpan(2, nstart, j$2));
	              at += isRTL;
	              pos = j$2;
	            } else { ++j$2; }
	          }
	          if (pos < i$7) { order.splice(at, 0, new BidiSpan(1, pos, i$7)); }
	        }
	      }
	      if (direction == "ltr") {
	        if (order[0].level == 1 && (m = str.match(/^\s+/))) {
	          order[0].from = m[0].length;
	          order.unshift(new BidiSpan(0, 0, m[0].length));
	        }
	        if (lst(order).level == 1 && (m = str.match(/\s+$/))) {
	          lst(order).to -= m[0].length;
	          order.push(new BidiSpan(0, len - m[0].length, len));
	        }
	      }
	
	      return direction == "rtl" ? order.reverse() : order
	    }
	  })();
	
	  // Get the bidi ordering for the given line (and cache it). Returns
	  // false for lines that are fully left-to-right, and an array of
	  // BidiSpan objects otherwise.
	  function getOrder(line, direction) {
	    var order = line.order;
	    if (order == null) { order = line.order = bidiOrdering(line.text, direction); }
	    return order
	  }
	
	  // EVENT HANDLING
	
	  // Lightweight event framework. on/off also work on DOM nodes,
	  // registering native DOM handlers.
	
	  var noHandlers = [];
	
	  var on = function(emitter, type, f) {
	    if (emitter.addEventListener) {
	      emitter.addEventListener(type, f, false);
	    } else if (emitter.attachEvent) {
	      emitter.attachEvent("on" + type, f);
	    } else {
	      var map = emitter._handlers || (emitter._handlers = {});
	      map[type] = (map[type] || noHandlers).concat(f);
	    }
	  };
	
	  function getHandlers(emitter, type) {
	    return emitter._handlers && emitter._handlers[type] || noHandlers
	  }
	
	  function off(emitter, type, f) {
	    if (emitter.removeEventListener) {
	      emitter.removeEventListener(type, f, false);
	    } else if (emitter.detachEvent) {
	      emitter.detachEvent("on" + type, f);
	    } else {
	      var map = emitter._handlers, arr = map && map[type];
	      if (arr) {
	        var index = indexOf(arr, f);
	        if (index > -1)
	          { map[type] = arr.slice(0, index).concat(arr.slice(index + 1)); }
	      }
	    }
	  }
	
	  function signal(emitter, type /*, values...*/) {
	    var handlers = getHandlers(emitter, type);
	    if (!handlers.length) { return }
	    var args = Array.prototype.slice.call(arguments, 2);
	    for (var i = 0; i < handlers.length; ++i) { handlers[i].apply(null, args); }
	  }
	
	  // The DOM events that CodeMirror handles can be overridden by
	  // registering a (non-DOM) handler on the editor for the event name,
	  // and preventDefault-ing the event in that handler.
	  function signalDOMEvent(cm, e, override) {
	    if (typeof e == "string")
	      { e = {type: e, preventDefault: function() { this.defaultPrevented = true; }}; }
	    signal(cm, override || e.type, cm, e);
	    return e_defaultPrevented(e) || e.codemirrorIgnore
	  }
	
	  function signalCursorActivity(cm) {
	    var arr = cm._handlers && cm._handlers.cursorActivity;
	    if (!arr) { return }
	    var set = cm.curOp.cursorActivityHandlers || (cm.curOp.cursorActivityHandlers = []);
	    for (var i = 0; i < arr.length; ++i) { if (indexOf(set, arr[i]) == -1)
	      { set.push(arr[i]); } }
	  }
	
	  function hasHandler(emitter, type) {
	    return getHandlers(emitter, type).length > 0
	  }
	
	  // Add on and off methods to a constructor's prototype, to make
	  // registering events on such objects more convenient.
	  function eventMixin(ctor) {
	    ctor.prototype.on = function(type, f) {on(this, type, f);};
	    ctor.prototype.off = function(type, f) {off(this, type, f);};
	  }
	
	  // Due to the fact that we still support jurassic IE versions, some
	  // compatibility wrappers are needed.
	
	  function e_preventDefault(e) {
	    if (e.preventDefault) { e.preventDefault(); }
	    else { e.returnValue = false; }
	  }
	  function e_stopPropagation(e) {
	    if (e.stopPropagation) { e.stopPropagation(); }
	    else { e.cancelBubble = true; }
	  }
	  function e_defaultPrevented(e) {
	    return e.defaultPrevented != null ? e.defaultPrevented : e.returnValue == false
	  }
	  function e_stop(e) {e_preventDefault(e); e_stopPropagation(e);}
	
	  function e_target(e) {return e.target || e.srcElement}
	  function e_button(e) {
	    var b = e.which;
	    if (b == null) {
	      if (e.button & 1) { b = 1; }
	      else if (e.button & 2) { b = 3; }
	      else if (e.button & 4) { b = 2; }
	    }
	    if (mac && e.ctrlKey && b == 1) { b = 3; }
	    return b
	  }
	
	  // Detect drag-and-drop
	  var dragAndDrop = function() {
	    // There is *some* kind of drag-and-drop support in IE6-8, but I
	    // couldn't get it to work yet.
	    if (ie && ie_version < 9) { return false }
	    var div = elt('div');
	    return "draggable" in div || "dragDrop" in div
	  }();
	
	  var zwspSupported;
	  function zeroWidthElement(measure) {
	    if (zwspSupported == null) {
	      var test = elt("span", "\u200b");
	      removeChildrenAndAdd(measure, elt("span", [test, document.createTextNode("x")]));
	      if (measure.firstChild.offsetHeight != 0)
	        { zwspSupported = test.offsetWidth <= 1 && test.offsetHeight > 2 && !(ie && ie_version < 8); }
	    }
	    var node = zwspSupported ? elt("span", "\u200b") :
	      elt("span", "\u00a0", null, "display: inline-block; width: 1px; margin-right: -1px");
	    node.setAttribute("cm-text", "");
	    return node
	  }
	
	  // Feature-detect IE's crummy client rect reporting for bidi text
	  var badBidiRects;
	  function hasBadBidiRects(measure) {
	    if (badBidiRects != null) { return badBidiRects }
	    var txt = removeChildrenAndAdd(measure, document.createTextNode("A\u062eA"));
	    var r0 = range(txt, 0, 1).getBoundingClientRect();
	    var r1 = range(txt, 1, 2).getBoundingClientRect();
	    removeChildren(measure);
	    if (!r0 || r0.left == r0.right) { return false } // Safari returns null in some cases (#2780)
	    return badBidiRects = (r1.right - r0.right < 3)
	  }
	
	  // See if "".split is the broken IE version, if so, provide an
	  // alternative way to split lines.
	  var splitLinesAuto = "\n\nb".split(/\n/).length != 3 ? function (string) {
	    var pos = 0, result = [], l = string.length;
	    while (pos <= l) {
	      var nl = string.indexOf("\n", pos);
	      if (nl == -1) { nl = string.length; }
	      var line = string.slice(pos, string.charAt(nl - 1) == "\r" ? nl - 1 : nl);
	      var rt = line.indexOf("\r");
	      if (rt != -1) {
	        result.push(line.slice(0, rt));
	        pos += rt + 1;
	      } else {
	        result.push(line);
	        pos = nl + 1;
	      }
	    }
	    return result
	  } : function (string) { return string.split(/\r\n?|\n/); };
	
	  var hasSelection = window.getSelection ? function (te) {
	    try { return te.selectionStart != te.selectionEnd }
	    catch(e) { return false }
	  } : function (te) {
	    var range;
	    try {range = te.ownerDocument.selection.createRange();}
	    catch(e) {}
	    if (!range || range.parentElement() != te) { return false }
	    return range.compareEndPoints("StartToEnd", range) != 0
	  };
	
	  var hasCopyEvent = (function () {
	    var e = elt("div");
	    if ("oncopy" in e) { return true }
	    e.setAttribute("oncopy", "return;");
	    return typeof e.oncopy == "function"
	  })();
	
	  var badZoomedRects = null;
	  function hasBadZoomedRects(measure) {
	    if (badZoomedRects != null) { return badZoomedRects }
	    var node = removeChildrenAndAdd(measure, elt("span", "x"));
	    var normal = node.getBoundingClientRect();
	    var fromRange = range(node, 0, 1).getBoundingClientRect();
	    return badZoomedRects = Math.abs(normal.left - fromRange.left) > 1
	  }
	
	  // Known modes, by name and by MIME
	  var modes = {}, mimeModes = {};
	
	  // Extra arguments are stored as the mode's dependencies, which is
	  // used by (legacy) mechanisms like loadmode.js to automatically
	  // load a mode. (Preferred mechanism is the require/define calls.)
	  function defineMode(name, mode) {
	    if (arguments.length > 2)
	      { mode.dependencies = Array.prototype.slice.call(arguments, 2); }
	    modes[name] = mode;
	  }
	
	  function defineMIME(mime, spec) {
	    mimeModes[mime] = spec;
	  }
	
	  // Given a MIME type, a {name, ...options} config object, or a name
	  // string, return a mode config object.
	  function resolveMode(spec) {
	    if (typeof spec == "string" && mimeModes.hasOwnProperty(spec)) {
	      spec = mimeModes[spec];
	    } else if (spec && typeof spec.name == "string" && mimeModes.hasOwnProperty(spec.name)) {
	      var found = mimeModes[spec.name];
	      if (typeof found == "string") { found = {name: found}; }
	      spec = createObj(found, spec);
	      spec.name = found.name;
	    } else if (typeof spec == "string" && /^[\w\-]+\/[\w\-]+\+xml$/.test(spec)) {
	      return resolveMode("application/xml")
	    } else if (typeof spec == "string" && /^[\w\-]+\/[\w\-]+\+json$/.test(spec)) {
	      return resolveMode("application/json")
	    }
	    if (typeof spec == "string") { return {name: spec} }
	    else { return spec || {name: "null"} }
	  }
	
	  // Given a mode spec (anything that resolveMode accepts), find and
	  // initialize an actual mode object.
	  function getMode(options, spec) {
	    spec = resolveMode(spec);
	    var mfactory = modes[spec.name];
	    if (!mfactory) { return getMode(options, "text/plain") }
	    var modeObj = mfactory(options, spec);
	    if (modeExtensions.hasOwnProperty(spec.name)) {
	      var exts = modeExtensions[spec.name];
	      for (var prop in exts) {
	        if (!exts.hasOwnProperty(prop)) { continue }
	        if (modeObj.hasOwnProperty(prop)) { modeObj["_" + prop] = modeObj[prop]; }
	        modeObj[prop] = exts[prop];
	      }
	    }
	    modeObj.name = spec.name;
	    if (spec.helperType) { modeObj.helperType = spec.helperType; }
	    if (spec.modeProps) { for (var prop$1 in spec.modeProps)
	      { modeObj[prop$1] = spec.modeProps[prop$1]; } }
	
	    return modeObj
	  }
	
	  // This can be used to attach properties to mode objects from
	  // outside the actual mode definition.
	  var modeExtensions = {};
	  function extendMode(mode, properties) {
	    var exts = modeExtensions.hasOwnProperty(mode) ? modeExtensions[mode] : (modeExtensions[mode] = {});
	    copyObj(properties, exts);
	  }
	
	  function copyState(mode, state) {
	    if (state === true) { return state }
	    if (mode.copyState) { return mode.copyState(state) }
	    var nstate = {};
	    for (var n in state) {
	      var val = state[n];
	      if (val instanceof Array) { val = val.concat([]); }
	      nstate[n] = val;
	    }
	    return nstate
	  }
	
	  // Given a mode and a state (for that mode), find the inner mode and
	  // state at the position that the state refers to.
	  function innerMode(mode, state) {
	    var info;
	    while (mode.innerMode) {
	      info = mode.innerMode(state);
	      if (!info || info.mode == mode) { break }
	      state = info.state;
	      mode = info.mode;
	    }
	    return info || {mode: mode, state: state}
	  }
	
	  function startState(mode, a1, a2) {
	    return mode.startState ? mode.startState(a1, a2) : true
	  }
	
	  // STRING STREAM
	
	  // Fed to the mode parsers, provides helper functions to make
	  // parsers more succinct.
	
	  var StringStream = function(string, tabSize, lineOracle) {
	    this.pos = this.start = 0;
	    this.string = string;
	    this.tabSize = tabSize || 8;
	    this.lastColumnPos = this.lastColumnValue = 0;
	    this.lineStart = 0;
	    this.lineOracle = lineOracle;
	  };
	
	  StringStream.prototype.eol = function () {return this.pos >= this.string.length};
	  StringStream.prototype.sol = function () {return this.pos == this.lineStart};
	  StringStream.prototype.peek = function () {return this.string.charAt(this.pos) || undefined};
	  StringStream.prototype.next = function () {
	    if (this.pos < this.string.length)
	      { return this.string.charAt(this.pos++) }
	  };
	  StringStream.prototype.eat = function (match) {
	    var ch = this.string.charAt(this.pos);
	    var ok;
	    if (typeof match == "string") { ok = ch == match; }
	    else { ok = ch && (match.test ? match.test(ch) : match(ch)); }
	    if (ok) {++this.pos; return ch}
	  };
	  StringStream.prototype.eatWhile = function (match) {
	    var start = this.pos;
	    while (this.eat(match)){}
	    return this.pos > start
	  };
	  StringStream.prototype.eatSpace = function () {
	    var start = this.pos;
	    while (/[\s\u00a0]/.test(this.string.charAt(this.pos))) { ++this.pos; }
	    return this.pos > start
	  };
	  StringStream.prototype.skipToEnd = function () {this.pos = this.string.length;};
	  StringStream.prototype.skipTo = function (ch) {
	    var found = this.string.indexOf(ch, this.pos);
	    if (found > -1) {this.pos = found; return true}
	  };
	  StringStream.prototype.backUp = function (n) {this.pos -= n;};
	  StringStream.prototype.column = function () {
	    if (this.lastColumnPos < this.start) {
	      this.lastColumnValue = countColumn(this.string, this.start, this.tabSize, this.lastColumnPos, this.lastColumnValue);
	      this.lastColumnPos = this.start;
	    }
	    return this.lastColumnValue - (this.lineStart ? countColumn(this.string, this.lineStart, this.tabSize) : 0)
	  };
	  StringStream.prototype.indentation = function () {
	    return countColumn(this.string, null, this.tabSize) -
	      (this.lineStart ? countColumn(this.string, this.lineStart, this.tabSize) : 0)
	  };
	  StringStream.prototype.match = function (pattern, consume, caseInsensitive) {
	    if (typeof pattern == "string") {
	      var cased = function (str) { return caseInsensitive ? str.toLowerCase() : str; };
	      var substr = this.string.substr(this.pos, pattern.length);
	      if (cased(substr) == cased(pattern)) {
	        if (consume !== false) { this.pos += pattern.length; }
	        return true
	      }
	    } else {
	      var match = this.string.slice(this.pos).match(pattern);
	      if (match && match.index > 0) { return null }
	      if (match && consume !== false) { this.pos += match[0].length; }
	      return match
	    }
	  };
	  StringStream.prototype.current = function (){return this.string.slice(this.start, this.pos)};
	  StringStream.prototype.hideFirstChars = function (n, inner) {
	    this.lineStart += n;
	    try { return inner() }
	    finally { this.lineStart -= n; }
	  };
	  StringStream.prototype.lookAhead = function (n) {
	    var oracle = this.lineOracle;
	    return oracle && oracle.lookAhead(n)
	  };
	  StringStream.prototype.baseToken = function () {
	    var oracle = this.lineOracle;
	    return oracle && oracle.baseToken(this.pos)
	  };
	
	  // Find the line object corresponding to the given line number.
	  function getLine(doc, n) {
	    n -= doc.first;
	    if (n < 0 || n >= doc.size) { throw new Error("There is no line " + (n + doc.first) + " in the document.") }
	    var chunk = doc;
	    while (!chunk.lines) {
	      for (var i = 0;; ++i) {
	        var child = chunk.children[i], sz = child.chunkSize();
	        if (n < sz) { chunk = child; break }
	        n -= sz;
	      }
	    }
	    return chunk.lines[n]
	  }
	
	  // Get the part of a document between two positions, as an array of
	  // strings.
	  function getBetween(doc, start, end) {
	    var out = [], n = start.line;
	    doc.iter(start.line, end.line + 1, function (line) {
	      var text = line.text;
	      if (n == end.line) { text = text.slice(0, end.ch); }
	      if (n == start.line) { text = text.slice(start.ch); }
	      out.push(text);
	      ++n;
	    });
	    return out
	  }
	  // Get the lines between from and to, as array of strings.
	  function getLines(doc, from, to) {
	    var out = [];
	    doc.iter(from, to, function (line) { out.push(line.text); }); // iter aborts when callback returns truthy value
	    return out
	  }
	
	  // Update the height of a line, propagating the height change
	  // upwards to parent nodes.
	  function updateLineHeight(line, height) {
	    var diff = height - line.height;
	    if (diff) { for (var n = line; n; n = n.parent) { n.height += diff; } }
	  }
	
	  // Given a line object, find its line number by walking up through
	  // its parent links.
	  function lineNo(line) {
	    if (line.parent == null) { return null }
	    var cur = line.parent, no = indexOf(cur.lines, line);
	    for (var chunk = cur.parent; chunk; cur = chunk, chunk = chunk.parent) {
	      for (var i = 0;; ++i) {
	        if (chunk.children[i] == cur) { break }
	        no += chunk.children[i].chunkSize();
	      }
	    }
	    return no + cur.first
	  }
	
	  // Find the line at the given vertical position, using the height
	  // information in the document tree.
	  function lineAtHeight(chunk, h) {
	    var n = chunk.first;
	    outer: do {
	      for (var i$1 = 0; i$1 < chunk.children.length; ++i$1) {
	        var child = chunk.children[i$1], ch = child.height;
	        if (h < ch) { chunk = child; continue outer }
	        h -= ch;
	        n += child.chunkSize();
	      }
	      return n
	    } while (!chunk.lines)
	    var i = 0;
	    for (; i < chunk.lines.length; ++i) {
	      var line = chunk.lines[i], lh = line.height;
	      if (h < lh) { break }
	      h -= lh;
	    }
	    return n + i
	  }
	
	  function isLine(doc, l) {return l >= doc.first && l < doc.first + doc.size}
	
	  function lineNumberFor(options, i) {
	    return String(options.lineNumberFormatter(i + options.firstLineNumber))
	  }
	
	  // A Pos instance represents a position within the text.
	  function Pos(line, ch, sticky) {
	    if ( sticky === void 0 ) sticky = null;
	
	    if (!(this instanceof Pos)) { return new Pos(line, ch, sticky) }
	    this.line = line;
	    this.ch = ch;
	    this.sticky = sticky;
	  }
	
	  // Compare two positions, return 0 if they are the same, a negative
	  // number when a is less, and a positive number otherwise.
	  function cmp(a, b) { return a.line - b.line || a.ch - b.ch }
	
	  function equalCursorPos(a, b) { return a.sticky == b.sticky && cmp(a, b) == 0 }
	
	  function copyPos(x) {return Pos(x.line, x.ch)}
	  function maxPos(a, b) { return cmp(a, b) < 0 ? b : a }
	  function minPos(a, b) { return cmp(a, b) < 0 ? a : b }
	
	  // Most of the external API clips given positions to make sure they
	  // actually exist within the document.
	  function clipLine(doc, n) {return Math.max(doc.first, Math.min(n, doc.first + doc.size - 1))}
	  function clipPos(doc, pos) {
	    if (pos.line < doc.first) { return Pos(doc.first, 0) }
	    var last = doc.first + doc.size - 1;
	    if (pos.line > last) { return Pos(last, getLine(doc, last).text.length) }
	    return clipToLen(pos, getLine(doc, pos.line).text.length)
	  }
	  function clipToLen(pos, linelen) {
	    var ch = pos.ch;
	    if (ch == null || ch > linelen) { return Pos(pos.line, linelen) }
	    else if (ch < 0) { return Pos(pos.line, 0) }
	    else { return pos }
	  }
	  function clipPosArray(doc, array) {
	    var out = [];
	    for (var i = 0; i < array.length; i++) { out[i] = clipPos(doc, array[i]); }
	    return out
	  }
	
	  var SavedContext = function(state, lookAhead) {
	    this.state = state;
	    this.lookAhead = lookAhead;
	  };
	
	  var Context = function(doc, state, line, lookAhead) {
	    this.state = state;
	    this.doc = doc;
	    this.line = line;
	    this.maxLookAhead = lookAhead || 0;
	    this.baseTokens = null;
	    this.baseTokenPos = 1;
	  };
	
	  Context.prototype.lookAhead = function (n) {
	    var line = this.doc.getLine(this.line + n);
	    if (line != null && n > this.maxLookAhead) { this.maxLookAhead = n; }
	    return line
	  };
	
	  Context.prototype.baseToken = function (n) {
	    if (!this.baseTokens) { return null }
	    while (this.baseTokens[this.baseTokenPos] <= n)
	      { this.baseTokenPos += 2; }
	    var type = this.baseTokens[this.baseTokenPos + 1];
	    return {type: type && type.replace(/( |^)overlay .*/, ""),
	            size: this.baseTokens[this.baseTokenPos] - n}
	  };
	
	  Context.prototype.nextLine = function () {
	    this.line++;
	    if (this.maxLookAhead > 0) { this.maxLookAhead--; }
	  };
	
	  Context.fromSaved = function (doc, saved, line) {
	    if (saved instanceof SavedContext)
	      { return new Context(doc, copyState(doc.mode, saved.state), line, saved.lookAhead) }
	    else
	      { return new Context(doc, copyState(doc.mode, saved), line) }
	  };
	
	  Context.prototype.save = function (copy) {
	    var state = copy !== false ? copyState(this.doc.mode, this.state) : this.state;
	    return this.maxLookAhead > 0 ? new SavedContext(state, this.maxLookAhead) : state
	  };
	
	
	  // Compute a style array (an array starting with a mode generation
	  // -- for invalidation -- followed by pairs of end positions and
	  // style strings), which is used to highlight the tokens on the
	  // line.
	  function highlightLine(cm, line, context, forceToEnd) {
	    // A styles array always starts with a number identifying the
	    // mode/overlays that it is based on (for easy invalidation).
	    var st = [cm.state.modeGen], lineClasses = {};
	    // Compute the base array of styles
	    runMode(cm, line.text, cm.doc.mode, context, function (end, style) { return st.push(end, style); },
	            lineClasses, forceToEnd);
	    var state = context.state;
	
	    // Run overlays, adjust style array.
	    var loop = function ( o ) {
	      context.baseTokens = st;
	      var overlay = cm.state.overlays[o], i = 1, at = 0;
	      context.state = true;
	      runMode(cm, line.text, overlay.mode, context, function (end, style) {
	        var start = i;
	        // Ensure there's a token end at the current position, and that i points at it
	        while (at < end) {
	          var i_end = st[i];
	          if (i_end > end)
	            { st.splice(i, 1, end, st[i+1], i_end); }
	          i += 2;
	          at = Math.min(end, i_end);
	        }
	        if (!style) { return }
	        if (overlay.opaque) {
	          st.splice(start, i - start, end, "overlay " + style);
	          i = start + 2;
	        } else {
	          for (; start < i; start += 2) {
	            var cur = st[start+1];
	            st[start+1] = (cur ? cur + " " : "") + "overlay " + style;
	          }
	        }
	      }, lineClasses);
	      context.state = state;
	      context.baseTokens = null;
	      context.baseTokenPos = 1;
	    };
	
	    for (var o = 0; o < cm.state.overlays.length; ++o) loop( o );
	
	    return {styles: st, classes: lineClasses.bgClass || lineClasses.textClass ? lineClasses : null}
	  }
	
	  function getLineStyles(cm, line, updateFrontier) {
	    if (!line.styles || line.styles[0] != cm.state.modeGen) {
	      var context = getContextBefore(cm, lineNo(line));
	      var resetState = line.text.length > cm.options.maxHighlightLength && copyState(cm.doc.mode, context.state);
	      var result = highlightLine(cm, line, context);
	      if (resetState) { context.state = resetState; }
	      line.stateAfter = context.save(!resetState);
	      line.styles = result.styles;
	      if (result.classes) { line.styleClasses = result.classes; }
	      else if (line.styleClasses) { line.styleClasses = null; }
	      if (updateFrontier === cm.doc.highlightFrontier)
	        { cm.doc.modeFrontier = Math.max(cm.doc.modeFrontier, ++cm.doc.highlightFrontier); }
	    }
	    return line.styles
	  }
	
	  function getContextBefore(cm, n, precise) {
	    var doc = cm.doc, display = cm.display;
	    if (!doc.mode.startState) { return new Context(doc, true, n) }
	    var start = findStartLine(cm, n, precise);
	    var saved = start > doc.first && getLine(doc, start - 1).stateAfter;
	    var context = saved ? Context.fromSaved(doc, saved, start) : new Context(doc, startState(doc.mode), start);
	
	    doc.iter(start, n, function (line) {
	      processLine(cm, line.text, context);
	      var pos = context.line;
	      line.stateAfter = pos == n - 1 || pos % 5 == 0 || pos >= display.viewFrom && pos < display.viewTo ? context.save() : null;
	      context.nextLine();
	    });
	    if (precise) { doc.modeFrontier = context.line; }
	    return context
	  }
	
	  // Lightweight form of highlight -- proceed over this line and
	  // update state, but don't save a style array. Used for lines that
	  // aren't currently visible.
	  function processLine(cm, text, context, startAt) {
	    var mode = cm.doc.mode;
	    var stream = new StringStream(text, cm.options.tabSize, context);
	    stream.start = stream.pos = startAt || 0;
	    if (text == "") { callBlankLine(mode, context.state); }
	    while (!stream.eol()) {
	      readToken(mode, stream, context.state);
	      stream.start = stream.pos;
	    }
	  }
	
	  function callBlankLine(mode, state) {
	    if (mode.blankLine) { return mode.blankLine(state) }
	    if (!mode.innerMode) { return }
	    var inner = innerMode(mode, state);
	    if (inner.mode.blankLine) { return inner.mode.blankLine(inner.state) }
	  }
	
	  function readToken(mode, stream, state, inner) {
	    for (var i = 0; i < 10; i++) {
	      if (inner) { inner[0] = innerMode(mode, state).mode; }
	      var style = mode.token(stream, state);
	      if (stream.pos > stream.start) { return style }
	    }
	    throw new Error("Mode " + mode.name + " failed to advance stream.")
	  }
	
	  var Token = function(stream, type, state) {
	    this.start = stream.start; this.end = stream.pos;
	    this.string = stream.current();
	    this.type = type || null;
	    this.state = state;
	  };
	
	  // Utility for getTokenAt and getLineTokens
	  function takeToken(cm, pos, precise, asArray) {
	    var doc = cm.doc, mode = doc.mode, style;
	    pos = clipPos(doc, pos);
	    var line = getLine(doc, pos.line), context = getContextBefore(cm, pos.line, precise);
	    var stream = new StringStream(line.text, cm.options.tabSize, context), tokens;
	    if (asArray) { tokens = []; }
	    while ((asArray || stream.pos < pos.ch) && !stream.eol()) {
	      stream.start = stream.pos;
	      style = readToken(mode, stream, context.state);
	      if (asArray) { tokens.push(new Token(stream, style, copyState(doc.mode, context.state))); }
	    }
	    return asArray ? tokens : new Token(stream, style, context.state)
	  }
	
	  function extractLineClasses(type, output) {
	    if (type) { for (;;) {
	      var lineClass = type.match(/(?:^|\s+)line-(background-)?(\S+)/);
	      if (!lineClass) { break }
	      type = type.slice(0, lineClass.index) + type.slice(lineClass.index + lineClass[0].length);
	      var prop = lineClass[1] ? "bgClass" : "textClass";
	      if (output[prop] == null)
	        { output[prop] = lineClass[2]; }
	      else if (!(new RegExp("(?:^|\s)" + lineClass[2] + "(?:$|\s)")).test(output[prop]))
	        { output[prop] += " " + lineClass[2]; }
	    } }
	    return type
	  }
	
	  // Run the given mode's parser over a line, calling f for each token.
	  function runMode(cm, text, mode, context, f, lineClasses, forceToEnd) {
	    var flattenSpans = mode.flattenSpans;
	    if (flattenSpans == null) { flattenSpans = cm.options.flattenSpans; }
	    var curStart = 0, curStyle = null;
	    var stream = new StringStream(text, cm.options.tabSize, context), style;
	    var inner = cm.options.addModeClass && [null];
	    if (text == "") { extractLineClasses(callBlankLine(mode, context.state), lineClasses); }
	    while (!stream.eol()) {
	      if (stream.pos > cm.options.maxHighlightLength) {
	        flattenSpans = false;
	        if (forceToEnd) { processLine(cm, text, context, stream.pos); }
	        stream.pos = text.length;
	        style = null;
	      } else {
	        style = extractLineClasses(readToken(mode, stream, context.state, inner), lineClasses);
	      }
	      if (inner) {
	        var mName = inner[0].name;
	        if (mName) { style = "m-" + (style ? mName + " " + style : mName); }
	      }
	      if (!flattenSpans || curStyle != style) {
	        while (curStart < stream.start) {
	          curStart = Math.min(stream.start, curStart + 5000);
	          f(curStart, curStyle);
	        }
	        curStyle = style;
	      }
	      stream.start = stream.pos;
	    }
	    while (curStart < stream.pos) {
	      // Webkit seems to refuse to render text nodes longer than 57444
	      // characters, and returns inaccurate measurements in nodes
	      // starting around 5000 chars.
	      var pos = Math.min(stream.pos, curStart + 5000);
	      f(pos, curStyle);
	      curStart = pos;
	    }
	  }
	
	  // Finds the line to start with when starting a parse. Tries to
	  // find a line with a stateAfter, so that it can start with a
	  // valid state. If that fails, it returns the line with the
	  // smallest indentation, which tends to need the least context to
	  // parse correctly.
	  function findStartLine(cm, n, precise) {
	    var minindent, minline, doc = cm.doc;
	    var lim = precise ? -1 : n - (cm.doc.mode.innerMode ? 1000 : 100);
	    for (var search = n; search > lim; --search) {
	      if (search <= doc.first) { return doc.first }
	      var line = getLine(doc, search - 1), after = line.stateAfter;
	      if (after && (!precise || search + (after instanceof SavedContext ? after.lookAhead : 0) <= doc.modeFrontier))
	        { return search }
	      var indented = countColumn(line.text, null, cm.options.tabSize);
	      if (minline == null || minindent > indented) {
	        minline = search - 1;
	        minindent = indented;
	      }
	    }
	    return minline
	  }
	
	  function retreatFrontier(doc, n) {
	    doc.modeFrontier = Math.min(doc.modeFrontier, n);
	    if (doc.highlightFrontier < n - 10) { return }
	    var start = doc.first;
	    for (var line = n - 1; line > start; line--) {
	      var saved = getLine(doc, line).stateAfter;
	      // change is on 3
	      // state on line 1 looked ahead 2 -- so saw 3
	      // test 1 + 2 < 3 should cover this
	      if (saved && (!(saved instanceof SavedContext) || line + saved.lookAhead < n)) {
	        start = line + 1;
	        break
	      }
	    }
	    doc.highlightFrontier = Math.min(doc.highlightFrontier, start);
	  }
	
	  // Optimize some code when these features are not used.
	  var sawReadOnlySpans = false, sawCollapsedSpans = false;
	
	  function seeReadOnlySpans() {
	    sawReadOnlySpans = true;
	  }
	
	  function seeCollapsedSpans() {
	    sawCollapsedSpans = true;
	  }
	
	  // TEXTMARKER SPANS
	
	  function MarkedSpan(marker, from, to) {
	    this.marker = marker;
	    this.from = from; this.to = to;
	  }
	
	  // Search an array of spans for a span matching the given marker.
	  function getMarkedSpanFor(spans, marker) {
	    if (spans) { for (var i = 0; i < spans.length; ++i) {
	      var span = spans[i];
	      if (span.marker == marker) { return span }
	    } }
	  }
	  // Remove a span from an array, returning undefined if no spans are
	  // left (we don't store arrays for lines without spans).
	  function removeMarkedSpan(spans, span) {
	    var r;
	    for (var i = 0; i < spans.length; ++i)
	      { if (spans[i] != span) { (r || (r = [])).push(spans[i]); } }
	    return r
	  }
	  // Add a span to a line.
	  function addMarkedSpan(line, span) {
	    line.markedSpans = line.markedSpans ? line.markedSpans.concat([span]) : [span];
	    span.marker.attachLine(line);
	  }
	
	  // Used for the algorithm that adjusts markers for a change in the
	  // document. These functions cut an array of spans at a given
	  // character position, returning an array of remaining chunks (or
	  // undefined if nothing remains).
	  function markedSpansBefore(old, startCh, isInsert) {
	    var nw;
	    if (old) { for (var i = 0; i < old.length; ++i) {
	      var span = old[i], marker = span.marker;
	      var startsBefore = span.from == null || (marker.inclusiveLeft ? span.from <= startCh : span.from < startCh);
	      if (startsBefore || span.from == startCh && marker.type == "bookmark" && (!isInsert || !span.marker.insertLeft)) {
	        var endsAfter = span.to == null || (marker.inclusiveRight ? span.to >= startCh : span.to > startCh)
	        ;(nw || (nw = [])).push(new MarkedSpan(marker, span.from, endsAfter ? null : span.to));
	      }
	    } }
	    return nw
	  }
	  function markedSpansAfter(old, endCh, isInsert) {
	    var nw;
	    if (old) { for (var i = 0; i < old.length; ++i) {
	      var span = old[i], marker = span.marker;
	      var endsAfter = span.to == null || (marker.inclusiveRight ? span.to >= endCh : span.to > endCh);
	      if (endsAfter || span.from == endCh && marker.type == "bookmark" && (!isInsert || span.marker.insertLeft)) {
	        var startsBefore = span.from == null || (marker.inclusiveLeft ? span.from <= endCh : span.from < endCh)
	        ;(nw || (nw = [])).push(new MarkedSpan(marker, startsBefore ? null : span.from - endCh,
	                                              span.to == null ? null : span.to - endCh));
	      }
	    } }
	    return nw
	  }
	
	  // Given a change object, compute the new set of marker spans that
	  // cover the line in which the change took place. Removes spans
	  // entirely within the change, reconnects spans belonging to the
	  // same marker that appear on both sides of the change, and cuts off
	  // spans partially within the change. Returns an array of span
	  // arrays with one element for each line in (after) the change.
	  function stretchSpansOverChange(doc, change) {
	    if (change.full) { return null }
	    var oldFirst = isLine(doc, change.from.line) && getLine(doc, change.from.line).markedSpans;
	    var oldLast = isLine(doc, change.to.line) && getLine(doc, change.to.line).markedSpans;
	    if (!oldFirst && !oldLast) { return null }
	
	    var startCh = change.from.ch, endCh = change.to.ch, isInsert = cmp(change.from, change.to) == 0;
	    // Get the spans that 'stick out' on both sides
	    var first = markedSpansBefore(oldFirst, startCh, isInsert);
	    var last = markedSpansAfter(oldLast, endCh, isInsert);
	
	    // Next, merge those two ends
	    var sameLine = change.text.length == 1, offset = lst(change.text).length + (sameLine ? startCh : 0);
	    if (first) {
	      // Fix up .to properties of first
	      for (var i = 0; i < first.length; ++i) {
	        var span = first[i];
	        if (span.to == null) {
	          var found = getMarkedSpanFor(last, span.marker);
	          if (!found) { span.to = startCh; }
	          else if (sameLine) { span.to = found.to == null ? null : found.to + offset; }
	        }
	      }
	    }
	    if (last) {
	      // Fix up .from in last (or move them into first in case of sameLine)
	      for (var i$1 = 0; i$1 < last.length; ++i$1) {
	        var span$1 = last[i$1];
	        if (span$1.to != null) { span$1.to += offset; }
	        if (span$1.from == null) {
	          var found$1 = getMarkedSpanFor(first, span$1.marker);
	          if (!found$1) {
	            span$1.from = offset;
	            if (sameLine) { (first || (first = [])).push(span$1); }
	          }
	        } else {
	          span$1.from += offset;
	          if (sameLine) { (first || (first = [])).push(span$1); }
	        }
	      }
	    }
	    // Make sure we didn't create any zero-length spans
	    if (first) { first = clearEmptySpans(first); }
	    if (last && last != first) { last = clearEmptySpans(last); }
	
	    var newMarkers = [first];
	    if (!sameLine) {
	      // Fill gap with whole-line-spans
	      var gap = change.text.length - 2, gapMarkers;
	      if (gap > 0 && first)
	        { for (var i$2 = 0; i$2 < first.length; ++i$2)
	          { if (first[i$2].to == null)
	            { (gapMarkers || (gapMarkers = [])).push(new MarkedSpan(first[i$2].marker, null, null)); } } }
	      for (var i$3 = 0; i$3 < gap; ++i$3)
	        { newMarkers.push(gapMarkers); }
	      newMarkers.push(last);
	    }
	    return newMarkers
	  }
	
	  // Remove spans that are empty and don't have a clearWhenEmpty
	  // option of false.
	  function clearEmptySpans(spans) {
	    for (var i = 0; i < spans.length; ++i) {
	      var span = spans[i];
	      if (span.from != null && span.from == span.to && span.marker.clearWhenEmpty !== false)
	        { spans.splice(i--, 1); }
	    }
	    if (!spans.length) { return null }
	    return spans
	  }
	
	  // Used to 'clip' out readOnly ranges when making a change.
	  function removeReadOnlyRanges(doc, from, to) {
	    var markers = null;
	    doc.iter(from.line, to.line + 1, function (line) {
	      if (line.markedSpans) { for (var i = 0; i < line.markedSpans.length; ++i) {
	        var mark = line.markedSpans[i].marker;
	        if (mark.readOnly && (!markers || indexOf(markers, mark) == -1))
	          { (markers || (markers = [])).push(mark); }
	      } }
	    });
	    if (!markers) { return null }
	    var parts = [{from: from, to: to}];
	    for (var i = 0; i < markers.length; ++i) {
	      var mk = markers[i], m = mk.find(0);
	      for (var j = 0; j < parts.length; ++j) {
	        var p = parts[j];
	        if (cmp(p.to, m.from) < 0 || cmp(p.from, m.to) > 0) { continue }
	        var newParts = [j, 1], dfrom = cmp(p.from, m.from), dto = cmp(p.to, m.to);
	        if (dfrom < 0 || !mk.inclusiveLeft && !dfrom)
	          { newParts.push({from: p.from, to: m.from}); }
	        if (dto > 0 || !mk.inclusiveRight && !dto)
	          { newParts.push({from: m.to, to: p.to}); }
	        parts.splice.apply(parts, newParts);
	        j += newParts.length - 3;
	      }
	    }
	    return parts
	  }
	
	  // Connect or disconnect spans from a line.
	  function detachMarkedSpans(line) {
	    var spans = line.markedSpans;
	    if (!spans) { return }
	    for (var i = 0; i < spans.length; ++i)
	      { spans[i].marker.detachLine(line); }
	    line.markedSpans = null;
	  }
	  function attachMarkedSpans(line, spans) {
	    if (!spans) { return }
	    for (var i = 0; i < spans.length; ++i)
	      { spans[i].marker.attachLine(line); }
	    line.markedSpans = spans;
	  }
	
	  // Helpers used when computing which overlapping collapsed span
	  // counts as the larger one.
	  function extraLeft(marker) { return marker.inclusiveLeft ? -1 : 0 }
	  function extraRight(marker) { return marker.inclusiveRight ? 1 : 0 }
	
	  // Returns a number indicating which of two overlapping collapsed
	  // spans is larger (and thus includes the other). Falls back to
	  // comparing ids when the spans cover exactly the same range.
	  function compareCollapsedMarkers(a, b) {
	    var lenDiff = a.lines.length - b.lines.length;
	    if (lenDiff != 0) { return lenDiff }
	    var aPos = a.find(), bPos = b.find();
	    var fromCmp = cmp(aPos.from, bPos.from) || extraLeft(a) - extraLeft(b);
	    if (fromCmp) { return -fromCmp }
	    var toCmp = cmp(aPos.to, bPos.to) || extraRight(a) - extraRight(b);
	    if (toCmp) { return toCmp }
	    return b.id - a.id
	  }
	
	  // Find out whether a line ends or starts in a collapsed span. If
	  // so, return the marker for that span.
	  function collapsedSpanAtSide(line, start) {
	    var sps = sawCollapsedSpans && line.markedSpans, found;
	    if (sps) { for (var sp = (void 0), i = 0; i < sps.length; ++i) {
	      sp = sps[i];
	      if (sp.marker.collapsed && (start ? sp.from : sp.to) == null &&
	          (!found || compareCollapsedMarkers(found, sp.marker) < 0))
	        { found = sp.marker; }
	    } }
	    return found
	  }
	  function collapsedSpanAtStart(line) { return collapsedSpanAtSide(line, true) }
	  function collapsedSpanAtEnd(line) { return collapsedSpanAtSide(line, false) }
	
	  function collapsedSpanAround(line, ch) {
	    var sps = sawCollapsedSpans && line.markedSpans, found;
	    if (sps) { for (var i = 0; i < sps.length; ++i) {
	      var sp = sps[i];
	      if (sp.marker.collapsed && (sp.from == null || sp.from < ch) && (sp.to == null || sp.to > ch) &&
	          (!found || compareCollapsedMarkers(found, sp.marker) < 0)) { found = sp.marker; }
	    } }
	    return found
	  }
	
	  // Test whether there exists a collapsed span that partially
	  // overlaps (covers the start or end, but not both) of a new span.
	  // Such overlap is not allowed.
	  function conflictingCollapsedRange(doc, lineNo, from, to, marker) {
	    var line = getLine(doc, lineNo);
	    var sps = sawCollapsedSpans && line.markedSpans;
	    if (sps) { for (var i = 0; i < sps.length; ++i) {
	      var sp = sps[i];
	      if (!sp.marker.collapsed) { continue }
	      var found = sp.marker.find(0);
	      var fromCmp = cmp(found.from, from) || extraLeft(sp.marker) - extraLeft(marker);
	      var toCmp = cmp(found.to, to) || extraRight(sp.marker) - extraRight(marker);
	      if (fromCmp >= 0 && toCmp <= 0 || fromCmp <= 0 && toCmp >= 0) { continue }
	      if (fromCmp <= 0 && (sp.marker.inclusiveRight && marker.inclusiveLeft ? cmp(found.to, from) >= 0 : cmp(found.to, from) > 0) ||
	          fromCmp >= 0 && (sp.marker.inclusiveRight && marker.inclusiveLeft ? cmp(found.from, to) <= 0 : cmp(found.from, to) < 0))
	        { return true }
	    } }
	  }
	
	  // A visual line is a line as drawn on the screen. Folding, for
	  // example, can cause multiple logical lines to appear on the same
	  // visual line. This finds the start of the visual line that the
	  // given line is part of (usually that is the line itself).
	  function visualLine(line) {
	    var merged;
	    while (merged = collapsedSpanAtStart(line))
	      { line = merged.find(-1, true).line; }
	    return line
	  }
	
	  function visualLineEnd(line) {
	    var merged;
	    while (merged = collapsedSpanAtEnd(line))
	      { line = merged.find(1, true).line; }
	    return line
	  }
	
	  // Returns an array of logical lines that continue the visual line
	  // started by the argument, or undefined if there are no such lines.
	  function visualLineContinued(line) {
	    var merged, lines;
	    while (merged = collapsedSpanAtEnd(line)) {
	      line = merged.find(1, true).line
	      ;(lines || (lines = [])).push(line);
	    }
	    return lines
	  }
	
	  // Get the line number of the start of the visual line that the
	  // given line number is part of.
	  function visualLineNo(doc, lineN) {
	    var line = getLine(doc, lineN), vis = visualLine(line);
	    if (line == vis) { return lineN }
	    return lineNo(vis)
	  }
	
	  // Get the line number of the start of the next visual line after
	  // the given line.
	  function visualLineEndNo(doc, lineN) {
	    if (lineN > doc.lastLine()) { return lineN }
	    var line = getLine(doc, lineN), merged;
	    if (!lineIsHidden(doc, line)) { return lineN }
	    while (merged = collapsedSpanAtEnd(line))
	      { line = merged.find(1, true).line; }
	    return lineNo(line) + 1
	  }
	
	  // Compute whether a line is hidden. Lines count as hidden when they
	  // are part of a visual line that starts with another line, or when
	  // they are entirely covered by collapsed, non-widget span.
	  function lineIsHidden(doc, line) {
	    var sps = sawCollapsedSpans && line.markedSpans;
	    if (sps) { for (var sp = (void 0), i = 0; i < sps.length; ++i) {
	      sp = sps[i];
	      if (!sp.marker.collapsed) { continue }
	      if (sp.from == null) { return true }
	      if (sp.marker.widgetNode) { continue }
	      if (sp.from == 0 && sp.marker.inclusiveLeft && lineIsHiddenInner(doc, line, sp))
	        { return true }
	    } }
	  }
	  function lineIsHiddenInner(doc, line, span) {
	    if (span.to == null) {
	      var end = span.marker.find(1, true);
	      return lineIsHiddenInner(doc, end.line, getMarkedSpanFor(end.line.markedSpans, span.marker))
	    }
	    if (span.marker.inclusiveRight && span.to == line.text.length)
	      { return true }
	    for (var sp = (void 0), i = 0; i < line.markedSpans.length; ++i) {
	      sp = line.markedSpans[i];
	      if (sp.marker.collapsed && !sp.marker.widgetNode && sp.from == span.to &&
	          (sp.to == null || sp.to != span.from) &&
	          (sp.marker.inclusiveLeft || span.marker.inclusiveRight) &&
	          lineIsHiddenInner(doc, line, sp)) { return true }
	    }
	  }
	
	  // Find the height above the given line.
	  function heightAtLine(lineObj) {
	    lineObj = visualLine(lineObj);
	
	    var h = 0, chunk = lineObj.parent;
	    for (var i = 0; i < chunk.lines.length; ++i) {
	      var line = chunk.lines[i];
	      if (line == lineObj) { break }
	      else { h += line.height; }
	    }
	    for (var p = chunk.parent; p; chunk = p, p = chunk.parent) {
	      for (var i$1 = 0; i$1 < p.children.length; ++i$1) {
	        var cur = p.children[i$1];
	        if (cur == chunk) { break }
	        else { h += cur.height; }
	      }
	    }
	    return h
	  }
	
	  // Compute the character length of a line, taking into account
	  // collapsed ranges (see markText) that might hide parts, and join
	  // other lines onto it.
	  function lineLength(line) {
	    if (line.height == 0) { return 0 }
	    var len = line.text.length, merged, cur = line;
	    while (merged = collapsedSpanAtStart(cur)) {
	      var found = merged.find(0, true);
	      cur = found.from.line;
	      len += found.from.ch - found.to.ch;
	    }
	    cur = line;
	    while (merged = collapsedSpanAtEnd(cur)) {
	      var found$1 = merged.find(0, true);
	      len -= cur.text.length - found$1.from.ch;
	      cur = found$1.to.line;
	      len += cur.text.length - found$1.to.ch;
	    }
	    return len
	  }
	
	  // Find the longest line in the document.
	  function findMaxLine(cm) {
	    var d = cm.display, doc = cm.doc;
	    d.maxLine = getLine(doc, doc.first);
	    d.maxLineLength = lineLength(d.maxLine);
	    d.maxLineChanged = true;
	    doc.iter(function (line) {
	      var len = lineLength(line);
	      if (len > d.maxLineLength) {
	        d.maxLineLength = len;
	        d.maxLine = line;
	      }
	    });
	  }
	
	  // LINE DATA STRUCTURE
	
	  // Line objects. These hold state related to a line, including
	  // highlighting info (the styles array).
	  var Line = function(text, markedSpans, estimateHeight) {
	    this.text = text;
	    attachMarkedSpans(this, markedSpans);
	    this.height = estimateHeight ? estimateHeight(this) : 1;
	  };
	
	  Line.prototype.lineNo = function () { return lineNo(this) };
	  eventMixin(Line);
	
	  // Change the content (text, markers) of a line. Automatically
	  // invalidates cached information and tries to re-estimate the
	  // line's height.
	  function updateLine(line, text, markedSpans, estimateHeight) {
	    line.text = text;
	    if (line.stateAfter) { line.stateAfter = null; }
	    if (line.styles) { line.styles = null; }
	    if (line.order != null) { line.order = null; }
	    detachMarkedSpans(line);
	    attachMarkedSpans(line, markedSpans);
	    var estHeight = estimateHeight ? estimateHeight(line) : 1;
	    if (estHeight != line.height) { updateLineHeight(line, estHeight); }
	  }
	
	  // Detach a line from the document tree and its markers.
	  function cleanUpLine(line) {
	    line.parent = null;
	    detachMarkedSpans(line);
	  }
	
	  // Convert a style as returned by a mode (either null, or a string
	  // containing one or more styles) to a CSS style. This is cached,
	  // and also looks for line-wide styles.
	  var styleToClassCache = {}, styleToClassCacheWithMode = {};
	  function interpretTokenStyle(style, options) {
	    if (!style || /^\s*$/.test(style)) { return null }
	    var cache = options.addModeClass ? styleToClassCacheWithMode : styleToClassCache;
	    return cache[style] ||
	      (cache[style] = style.replace(/\S+/g, "cm-$&"))
	  }
	
	  // Render the DOM representation of the text of a line. Also builds
	  // up a 'line map', which points at the DOM nodes that represent
	  // specific stretches of text, and is used by the measuring code.
	  // The returned object contains the DOM node, this map, and
	  // information about line-wide styles that were set by the mode.
	  function buildLineContent(cm, lineView) {
	    // The padding-right forces the element to have a 'border', which
	    // is needed on Webkit to be able to get line-level bounding
	    // rectangles for it (in measureChar).
	    var content = eltP("span", null, null, webkit ? "padding-right: .1px" : null);
	    var builder = {pre: eltP("pre", [content], "CodeMirror-line"), content: content,
	                   col: 0, pos: 0, cm: cm,
	                   trailingSpace: false,
	                   splitSpaces: cm.getOption("lineWrapping")};
	    lineView.measure = {};
	
	    // Iterate over the logical lines that make up this visual line.
	    for (var i = 0; i <= (lineView.rest ? lineView.rest.length : 0); i++) {
	      var line = i ? lineView.rest[i - 1] : lineView.line, order = (void 0);
	      builder.pos = 0;
	      builder.addToken = buildToken;
	      // Optionally wire in some hacks into the token-rendering
	      // algorithm, to deal with browser quirks.
	      if (hasBadBidiRects(cm.display.measure) && (order = getOrder(line, cm.doc.direction)))
	        { builder.addToken = buildTokenBadBidi(builder.addToken, order); }
	      builder.map = [];
	      var allowFrontierUpdate = lineView != cm.display.externalMeasured && lineNo(line);
	      insertLineContent(line, builder, getLineStyles(cm, line, allowFrontierUpdate));
	      if (line.styleClasses) {
	        if (line.styleClasses.bgClass)
	          { builder.bgClass = joinClasses(line.styleClasses.bgClass, builder.bgClass || ""); }
	        if (line.styleClasses.textClass)
	          { builder.textClass = joinClasses(line.styleClasses.textClass, builder.textClass || ""); }
	      }
	
	      // Ensure at least a single node is present, for measuring.
	      if (builder.map.length == 0)
	        { builder.map.push(0, 0, builder.content.appendChild(zeroWidthElement(cm.display.measure))); }
	
	      // Store the map and a cache object for the current logical line
	      if (i == 0) {
	        lineView.measure.map = builder.map;
	        lineView.measure.cache = {};
	      } else {
	  (lineView.measure.maps || (lineView.measure.maps = [])).push(builder.map)
	        ;(lineView.measure.caches || (lineView.measure.caches = [])).push({});
	      }
	    }
	
	    // See issue #2901
	    if (webkit) {
	      var last = builder.content.lastChild;
	      if (/\bcm-tab\b/.test(last.className) || (last.querySelector && last.querySelector(".cm-tab")))
	        { builder.content.className = "cm-tab-wrap-hack"; }
	    }
	
	    signal(cm, "renderLine", cm, lineView.line, builder.pre);
	    if (builder.pre.className)
	      { builder.textClass = joinClasses(builder.pre.className, builder.textClass || ""); }
	
	    return builder
	  }
	
	  function defaultSpecialCharPlaceholder(ch) {
	    var token = elt("span", "\u2022", "cm-invalidchar");
	    token.title = "\\u" + ch.charCodeAt(0).toString(16);
	    token.setAttribute("aria-label", token.title);
	    return token
	  }
	
	  // Build up the DOM representation for a single token, and add it to
	  // the line map. Takes care to render special characters separately.
	  function buildToken(builder, text, style, startStyle, endStyle, css, attributes) {
	    if (!text) { return }
	    var displayText = builder.splitSpaces ? splitSpaces(text, builder.trailingSpace) : text;
	    var special = builder.cm.state.specialChars, mustWrap = false;
	    var content;
	    if (!special.test(text)) {
	      builder.col += text.length;
	      content = document.createTextNode(displayText);
	      builder.map.push(builder.pos, builder.pos + text.length, content);
	      if (ie && ie_version < 9) { mustWrap = true; }
	      builder.pos += text.length;
	    } else {
	      content = document.createDocumentFragment();
	      var pos = 0;
	      while (true) {
	        special.lastIndex = pos;
	        var m = special.exec(text);
	        var skipped = m ? m.index - pos : text.length - pos;
	        if (skipped) {
	          var txt = document.createTextNode(displayText.slice(pos, pos + skipped));
	          if (ie && ie_version < 9) { content.appendChild(elt("span", [txt])); }
	          else { content.appendChild(txt); }
	          builder.map.push(builder.pos, builder.pos + skipped, txt);
	          builder.col += skipped;
	          builder.pos += skipped;
	        }
	        if (!m) { break }
	        pos += skipped + 1;
	        var txt$1 = (void 0);
	        if (m[0] == "\t") {
	          var tabSize = builder.cm.options.tabSize, tabWidth = tabSize - builder.col % tabSize;
	          txt$1 = content.appendChild(elt("span", spaceStr(tabWidth), "cm-tab"));
	          txt$1.setAttribute("role", "presentation");
	          txt$1.setAttribute("cm-text", "\t");
	          builder.col += tabWidth;
	        } else if (m[0] == "\r" || m[0] == "\n") {
	          txt$1 = content.appendChild(elt("span", m[0] == "\r" ? "\u240d" : "\u2424", "cm-invalidchar"));
	          txt$1.setAttribute("cm-text", m[0]);
	          builder.col += 1;
	        } else {
	          txt$1 = builder.cm.options.specialCharPlaceholder(m[0]);
	          txt$1.setAttribute("cm-text", m[0]);
	          if (ie && ie_version < 9) { content.appendChild(elt("span", [txt$1])); }
	          else { content.appendChild(txt$1); }
	          builder.col += 1;
	        }
	        builder.map.push(builder.pos, builder.pos + 1, txt$1);
	        builder.pos++;
	      }
	    }
	    builder.trailingSpace = displayText.charCodeAt(text.length - 1) == 32;
	    if (style || startStyle || endStyle || mustWrap || css) {
	      var fullStyle = style || "";
	      if (startStyle) { fullStyle += startStyle; }
	      if (endStyle) { fullStyle += endStyle; }
	      var token = elt("span", [content], fullStyle, css);
	      if (attributes) {
	        for (var attr in attributes) { if (attributes.hasOwnProperty(attr) && attr != "style" && attr != "class")
	          { token.setAttribute(attr, attributes[attr]); } }
	      }
	      return builder.content.appendChild(token)
	    }
	    builder.content.appendChild(content);
	  }
	
	  // Change some spaces to NBSP to prevent the browser from collapsing
	  // trailing spaces at the end of a line when rendering text (issue #1362).
	  function splitSpaces(text, trailingBefore) {
	    if (text.length > 1 && !/  /.test(text)) { return text }
	    var spaceBefore = trailingBefore, result = "";
	    for (var i = 0; i < text.length; i++) {
	      var ch = text.charAt(i);
	      if (ch == " " && spaceBefore && (i == text.length - 1 || text.charCodeAt(i + 1) == 32))
	        { ch = "\u00a0"; }
	      result += ch;
	      spaceBefore = ch == " ";
	    }
	    return result
	  }
	
	  // Work around nonsense dimensions being reported for stretches of
	  // right-to-left text.
	  function buildTokenBadBidi(inner, order) {
	    return function (builder, text, style, startStyle, endStyle, css, attributes) {
	      style = style ? style + " cm-force-border" : "cm-force-border";
	      var start = builder.pos, end = start + text.length;
	      for (;;) {
	        // Find the part that overlaps with the start of this text
	        var part = (void 0);
	        for (var i = 0; i < order.length; i++) {
	          part = order[i];
	          if (part.to > start && part.from <= start) { break }
	        }
	        if (part.to >= end) { return inner(builder, text, style, startStyle, endStyle, css, attributes) }
	        inner(builder, text.slice(0, part.to - start), style, startStyle, null, css, attributes);
	        startStyle = null;
	        text = text.slice(part.to - start);
	        start = part.to;
	      }
	    }
	  }
	
	  function buildCollapsedSpan(builder, size, marker, ignoreWidget) {
	    var widget = !ignoreWidget && marker.widgetNode;
	    if (widget) { builder.map.push(builder.pos, builder.pos + size, widget); }
	    if (!ignoreWidget && builder.cm.display.input.needsContentAttribute) {
	      if (!widget)
	        { widget = builder.content.appendChild(document.createElement("span")); }
	      widget.setAttribute("cm-marker", marker.id);
	    }
	    if (widget) {
	      builder.cm.display.input.setUneditable(widget);
	      builder.content.appendChild(widget);
	    }
	    builder.pos += size;
	    builder.trailingSpace = false;
	  }
	
	  // Outputs a number of spans to make up a line, taking highlighting
	  // and marked text into account.
	  function insertLineContent(line, builder, styles) {
	    var spans = line.markedSpans, allText = line.text, at = 0;
	    if (!spans) {
	      for (var i$1 = 1; i$1 < styles.length; i$1+=2)
	        { builder.addToken(builder, allText.slice(at, at = styles[i$1]), interpretTokenStyle(styles[i$1+1], builder.cm.options)); }
	      return
	    }
	
	    var len = allText.length, pos = 0, i = 1, text = "", style, css;
	    var nextChange = 0, spanStyle, spanEndStyle, spanStartStyle, collapsed, attributes;
	    for (;;) {
	      if (nextChange == pos) { // Update current marker set
	        spanStyle = spanEndStyle = spanStartStyle = css = "";
	        attributes = null;
	        collapsed = null; nextChange = Infinity;
	        var foundBookmarks = [], endStyles = (void 0);
	        for (var j = 0; j < spans.length; ++j) {
	          var sp = spans[j], m = sp.marker;
	          if (m.type == "bookmark" && sp.from == pos && m.widgetNode) {
	            foundBookmarks.push(m);
	          } else if (sp.from <= pos && (sp.to == null || sp.to > pos || m.collapsed && sp.to == pos && sp.from == pos)) {
	            if (sp.to != null && sp.to != pos && nextChange > sp.to) {
	              nextChange = sp.to;
	              spanEndStyle = "";
	            }
	            if (m.className) { spanStyle += " " + m.className; }
	            if (m.css) { css = (css ? css + ";" : "") + m.css; }
	            if (m.startStyle && sp.from == pos) { spanStartStyle += " " + m.startStyle; }
	            if (m.endStyle && sp.to == nextChange) { (endStyles || (endStyles = [])).push(m.endStyle, sp.to); }
	            // support for the old title property
	            // https://github.com/codemirror/CodeMirror/pull/5673
	            if (m.title) { (attributes || (attributes = {})).title = m.title; }
	            if (m.attributes) {
	              for (var attr in m.attributes)
	                { (attributes || (attributes = {}))[attr] = m.attributes[attr]; }
	            }
	            if (m.collapsed && (!collapsed || compareCollapsedMarkers(collapsed.marker, m) < 0))
	              { collapsed = sp; }
	          } else if (sp.from > pos && nextChange > sp.from) {
	            nextChange = sp.from;
	          }
	        }
	        if (endStyles) { for (var j$1 = 0; j$1 < endStyles.length; j$1 += 2)
	          { if (endStyles[j$1 + 1] == nextChange) { spanEndStyle += " " + endStyles[j$1]; } } }
	
	        if (!collapsed || collapsed.from == pos) { for (var j$2 = 0; j$2 < foundBookmarks.length; ++j$2)
	          { buildCollapsedSpan(builder, 0, foundBookmarks[j$2]); } }
	        if (collapsed && (collapsed.from || 0) == pos) {
	          buildCollapsedSpan(builder, (collapsed.to == null ? len + 1 : collapsed.to) - pos,
	                             collapsed.marker, collapsed.from == null);
	          if (collapsed.to == null) { return }
	          if (collapsed.to == pos) { collapsed = false; }
	        }
	      }
	      if (pos >= len) { break }
	
	      var upto = Math.min(len, nextChange);
	      while (true) {
	        if (text) {
	          var end = pos + text.length;
	          if (!collapsed) {
	            var tokenText = end > upto ? text.slice(0, upto - pos) : text;
	            builder.addToken(builder, tokenText, style ? style + spanStyle : spanStyle,
	                             spanStartStyle, pos + tokenText.length == nextChange ? spanEndStyle : "", css, attributes);
	          }
	          if (end >= upto) {text = text.slice(upto - pos); pos = upto; break}
	          pos = end;
	          spanStartStyle = "";
	        }
	        text = allText.slice(at, at = styles[i++]);
	        style = interpretTokenStyle(styles[i++], builder.cm.options);
	      }
	    }
	  }
	
	
	  // These objects are used to represent the visible (currently drawn)
	  // part of the document. A LineView may correspond to multiple
	  // logical lines, if those are connected by collapsed ranges.
	  function LineView(doc, line, lineN) {
	    // The starting line
	    this.line = line;
	    // Continuing lines, if any
	    this.rest = visualLineContinued(line);
	    // Number of logical lines in this visual line
	    this.size = this.rest ? lineNo(lst(this.rest)) - lineN + 1 : 1;
	    this.node = this.text = null;
	    this.hidden = lineIsHidden(doc, line);
	  }
	
	  // Create a range of LineView objects for the given lines.
	  function buildViewArray(cm, from, to) {
	    var array = [], nextPos;
	    for (var pos = from; pos < to; pos = nextPos) {
	      var view = new LineView(cm.doc, getLine(cm.doc, pos), pos);
	      nextPos = pos + view.size;
	      array.push(view);
	    }
	    return array
	  }
	
	  var operationGroup = null;
	
	  function pushOperation(op) {
	    if (operationGroup) {
	      operationGroup.ops.push(op);
	    } else {
	      op.ownsGroup = operationGroup = {
	        ops: [op],
	        delayedCallbacks: []
	      };
	    }
	  }
	
	  function fireCallbacksForOps(group) {
	    // Calls delayed callbacks and cursorActivity handlers until no
	    // new ones appear
	    var callbacks = group.delayedCallbacks, i = 0;
	    do {
	      for (; i < callbacks.length; i++)
	        { callbacks[i].call(null); }
	      for (var j = 0; j < group.ops.length; j++) {
	        var op = group.ops[j];
	        if (op.cursorActivityHandlers)
	          { while (op.cursorActivityCalled < op.cursorActivityHandlers.length)
	            { op.cursorActivityHandlers[op.cursorActivityCalled++].call(null, op.cm); } }
	      }
	    } while (i < callbacks.length)
	  }
	
	  function finishOperation(op, endCb) {
	    var group = op.ownsGroup;
	    if (!group) { return }
	
	    try { fireCallbacksForOps(group); }
	    finally {
	      operationGroup = null;
	      endCb(group);
	    }
	  }
	
	  var orphanDelayedCallbacks = null;
	
	  // Often, we want to signal events at a point where we are in the
	  // middle of some work, but don't want the handler to start calling
	  // other methods on the editor, which might be in an inconsistent
	  // state or simply not expect any other events to happen.
	  // signalLater looks whether there are any handlers, and schedules
	  // them to be executed when the last operation ends, or, if no
	  // operation is active, when a timeout fires.
	  function signalLater(emitter, type /*, values...*/) {
	    var arr = getHandlers(emitter, type);
	    if (!arr.length) { return }
	    var args = Array.prototype.slice.call(arguments, 2), list;
	    if (operationGroup) {
	      list = operationGroup.delayedCallbacks;
	    } else if (orphanDelayedCallbacks) {
	      list = orphanDelayedCallbacks;
	    } else {
	      list = orphanDelayedCallbacks = [];
	      setTimeout(fireOrphanDelayed, 0);
	    }
	    var loop = function ( i ) {
	      list.push(function () { return arr[i].apply(null, args); });
	    };
	
	    for (var i = 0; i < arr.length; ++i)
	      loop( i );
	  }
	
	  function fireOrphanDelayed() {
	    var delayed = orphanDelayedCallbacks;
	    orphanDelayedCallbacks = null;
	    for (var i = 0; i < delayed.length; ++i) { delayed[i](); }
	  }
	
	  // When an aspect of a line changes, a string is added to
	  // lineView.changes. This updates the relevant part of the line's
	  // DOM structure.
	  function updateLineForChanges(cm, lineView, lineN, dims) {
	    for (var j = 0; j < lineView.changes.length; j++) {
	      var type = lineView.changes[j];
	      if (type == "text") { updateLineText(cm, lineView); }
	      else if (type == "gutter") { updateLineGutter(cm, lineView, lineN, dims); }
	      else if (type == "class") { updateLineClasses(cm, lineView); }
	      else if (type == "widget") { updateLineWidgets(cm, lineView, dims); }
	    }
	    lineView.changes = null;
	  }
	
	  // Lines with gutter elements, widgets or a background class need to
	  // be wrapped, and have the extra elements added to the wrapper div
	  function ensureLineWrapped(lineView) {
	    if (lineView.node == lineView.text) {
	      lineView.node = elt("div", null, null, "position: relative");
	      if (lineView.text.parentNode)
	        { lineView.text.parentNode.replaceChild(lineView.node, lineView.text); }
	      lineView.node.appendChild(lineView.text);
	      if (ie && ie_version < 8) { lineView.node.style.zIndex = 2; }
	    }
	    return lineView.node
	  }
	
	  function updateLineBackground(cm, lineView) {
	    var cls = lineView.bgClass ? lineView.bgClass + " " + (lineView.line.bgClass || "") : lineView.line.bgClass;
	    if (cls) { cls += " CodeMirror-linebackground"; }
	    if (lineView.background) {
	      if (cls) { lineView.background.className = cls; }
	      else { lineView.background.parentNode.removeChild(lineView.background); lineView.background = null; }
	    } else if (cls) {
	      var wrap = ensureLineWrapped(lineView);
	      lineView.background = wrap.insertBefore(elt("div", null, cls), wrap.firstChild);
	      cm.display.input.setUneditable(lineView.background);
	    }
	  }
	
	  // Wrapper around buildLineContent which will reuse the structure
	  // in display.externalMeasured when possible.
	  function getLineContent(cm, lineView) {
	    var ext = cm.display.externalMeasured;
	    if (ext && ext.line == lineView.line) {
	      cm.display.externalMeasured = null;
	      lineView.measure = ext.measure;
	      return ext.built
	    }
	    return buildLineContent(cm, lineView)
	  }
	
	  // Redraw the line's text. Interacts with the background and text
	  // classes because the mode may output tokens that influence these
	  // classes.
	  function updateLineText(cm, lineView) {
	    var cls = lineView.text.className;
	    var built = getLineContent(cm, lineView);
	    if (lineView.text == lineView.node) { lineView.node = built.pre; }
	    lineView.text.parentNode.replaceChild(built.pre, lineView.text);
	    lineView.text = built.pre;
	    if (built.bgClass != lineView.bgClass || built.textClass != lineView.textClass) {
	      lineView.bgClass = built.bgClass;
	      lineView.textClass = built.textClass;
	      updateLineClasses(cm, lineView);
	    } else if (cls) {
	      lineView.text.className = cls;
	    }
	  }
	
	  function updateLineClasses(cm, lineView) {
	    updateLineBackground(cm, lineView);
	    if (lineView.line.wrapClass)
	      { ensureLineWrapped(lineView).className = lineView.line.wrapClass; }
	    else if (lineView.node != lineView.text)
	      { lineView.node.className = ""; }
	    var textClass = lineView.textClass ? lineView.textClass + " " + (lineView.line.textClass || "") : lineView.line.textClass;
	    lineView.text.className = textClass || "";
	  }
	
	  function updateLineGutter(cm, lineView, lineN, dims) {
	    if (lineView.gutter) {
	      lineView.node.removeChild(lineView.gutter);
	      lineView.gutter = null;
	    }
	    if (lineView.gutterBackground) {
	      lineView.node.removeChild(lineView.gutterBackground);
	      lineView.gutterBackground = null;
	    }
	    if (lineView.line.gutterClass) {
	      var wrap = ensureLineWrapped(lineView);
	      lineView.gutterBackground = elt("div", null, "CodeMirror-gutter-background " + lineView.line.gutterClass,
	                                      ("left: " + (cm.options.fixedGutter ? dims.fixedPos : -dims.gutterTotalWidth) + "px; width: " + (dims.gutterTotalWidth) + "px"));
	      cm.display.input.setUneditable(lineView.gutterBackground);
	      wrap.insertBefore(lineView.gutterBackground, lineView.text);
	    }
	    var markers = lineView.line.gutterMarkers;
	    if (cm.options.lineNumbers || markers) {
	      var wrap$1 = ensureLineWrapped(lineView);
	      var gutterWrap = lineView.gutter = elt("div", null, "CodeMirror-gutter-wrapper", ("left: " + (cm.options.fixedGutter ? dims.fixedPos : -dims.gutterTotalWidth) + "px"));
	      cm.display.input.setUneditable(gutterWrap);
	      wrap$1.insertBefore(gutterWrap, lineView.text);
	      if (lineView.line.gutterClass)
	        { gutterWrap.className += " " + lineView.line.gutterClass; }
	      if (cm.options.lineNumbers && (!markers || !markers["CodeMirror-linenumbers"]))
	        { lineView.lineNumber = gutterWrap.appendChild(
	          elt("div", lineNumberFor(cm.options, lineN),
	              "CodeMirror-linenumber CodeMirror-gutter-elt",
	              ("left: " + (dims.gutterLeft["CodeMirror-linenumbers"]) + "px; width: " + (cm.display.lineNumInnerWidth) + "px"))); }
	      if (markers) { for (var k = 0; k < cm.display.gutterSpecs.length; ++k) {
	        var id = cm.display.gutterSpecs[k].className, found = markers.hasOwnProperty(id) && markers[id];
	        if (found)
	          { gutterWrap.appendChild(elt("div", [found], "CodeMirror-gutter-elt",
	                                     ("left: " + (dims.gutterLeft[id]) + "px; width: " + (dims.gutterWidth[id]) + "px"))); }
	      } }
	    }
	  }
	
	  function updateLineWidgets(cm, lineView, dims) {
	    if (lineView.alignable) { lineView.alignable = null; }
	    var isWidget = classTest("CodeMirror-linewidget");
	    for (var node = lineView.node.firstChild, next = (void 0); node; node = next) {
	      next = node.nextSibling;
	      if (isWidget.test(node.className)) { lineView.node.removeChild(node); }
	    }
	    insertLineWidgets(cm, lineView, dims);
	  }
	
	  // Build a line's DOM representation from scratch
	  function buildLineElement(cm, lineView, lineN, dims) {
	    var built = getLineContent(cm, lineView);
	    lineView.text = lineView.node = built.pre;
	    if (built.bgClass) { lineView.bgClass = built.bgClass; }
	    if (built.textClass) { lineView.textClass = built.textClass; }
	
	    updateLineClasses(cm, lineView);
	    updateLineGutter(cm, lineView, lineN, dims);
	    insertLineWidgets(cm, lineView, dims);
	    return lineView.node
	  }
	
	  // A lineView may contain multiple logical lines (when merged by
	  // collapsed spans). The widgets for all of them need to be drawn.
	  function insertLineWidgets(cm, lineView, dims) {
	    insertLineWidgetsFor(cm, lineView.line, lineView, dims, true);
	    if (lineView.rest) { for (var i = 0; i < lineView.rest.length; i++)
	      { insertLineWidgetsFor(cm, lineView.rest[i], lineView, dims, false); } }
	  }
	
	  function insertLineWidgetsFor(cm, line, lineView, dims, allowAbove) {
	    if (!line.widgets) { return }
	    var wrap = ensureLineWrapped(lineView);
	    for (var i = 0, ws = line.widgets; i < ws.length; ++i) {
	      var widget = ws[i], node = elt("div", [widget.node], "CodeMirror-linewidget" + (widget.className ? " " + widget.className : ""));
	      if (!widget.handleMouseEvents) { node.setAttribute("cm-ignore-events", "true"); }
	      positionLineWidget(widget, node, lineView, dims);
	      cm.display.input.setUneditable(node);
	      if (allowAbove && widget.above)
	        { wrap.insertBefore(node, lineView.gutter || lineView.text); }
	      else
	        { wrap.appendChild(node); }
	      signalLater(widget, "redraw");
	    }
	  }
	
	  function positionLineWidget(widget, node, lineView, dims) {
	    if (widget.noHScroll) {
	  (lineView.alignable || (lineView.alignable = [])).push(node);
	      var width = dims.wrapperWidth;
	      node.style.left = dims.fixedPos + "px";
	      if (!widget.coverGutter) {
	        width -= dims.gutterTotalWidth;
	        node.style.paddingLeft = dims.gutterTotalWidth + "px";
	      }
	      node.style.width = width + "px";
	    }
	    if (widget.coverGutter) {
	      node.style.zIndex = 5;
	      node.style.position = "relative";
	      if (!widget.noHScroll) { node.style.marginLeft = -dims.gutterTotalWidth + "px"; }
	    }
	  }
	
	  function widgetHeight(widget) {
	    if (widget.height != null) { return widget.height }
	    var cm = widget.doc.cm;
	    if (!cm) { return 0 }
	    if (!contains(document.body, widget.node)) {
	      var parentStyle = "position: relative;";
	      if (widget.coverGutter)
	        { parentStyle += "margin-left: -" + cm.display.gutters.offsetWidth + "px;"; }
	      if (widget.noHScroll)
	        { parentStyle += "width: " + cm.display.wrapper.clientWidth + "px;"; }
	      removeChildrenAndAdd(cm.display.measure, elt("div", [widget.node], null, parentStyle));
	    }
	    return widget.height = widget.node.parentNode.offsetHeight
	  }
	
	  // Return true when the given mouse event happened in a widget
	  function eventInWidget(display, e) {
	    for (var n = e_target(e); n != display.wrapper; n = n.parentNode) {
	      if (!n || (n.nodeType == 1 && n.getAttribute("cm-ignore-events") == "true") ||
	          (n.parentNode == display.sizer && n != display.mover))
	        { return true }
	    }
	  }
	
	  // POSITION MEASUREMENT
	
	  function paddingTop(display) {return display.lineSpace.offsetTop}
	  function paddingVert(display) {return display.mover.offsetHeight - display.lineSpace.offsetHeight}
	  function paddingH(display) {
	    if (display.cachedPaddingH) { return display.cachedPaddingH }
	    var e = removeChildrenAndAdd(display.measure, elt("pre", "x", "CodeMirror-line-like"));
	    var style = window.getComputedStyle ? window.getComputedStyle(e) : e.currentStyle;
	    var data = {left: parseInt(style.paddingLeft), right: parseInt(style.paddingRight)};
	    if (!isNaN(data.left) && !isNaN(data.right)) { display.cachedPaddingH = data; }
	    return data
	  }
	
	  function scrollGap(cm) { return scrollerGap - cm.display.nativeBarWidth }
	  function displayWidth(cm) {
	    return cm.display.scroller.clientWidth - scrollGap(cm) - cm.display.barWidth
	  }
	  function displayHeight(cm) {
	    return cm.display.scroller.clientHeight - scrollGap(cm) - cm.display.barHeight
	  }
	
	  // Ensure the lineView.wrapping.heights array is populated. This is
	  // an array of bottom offsets for the lines that make up a drawn
	  // line. When lineWrapping is on, there might be more than one
	  // height.
	  function ensureLineHeights(cm, lineView, rect) {
	    var wrapping = cm.options.lineWrapping;
	    var curWidth = wrapping && displayWidth(cm);
	    if (!lineView.measure.heights || wrapping && lineView.measure.width != curWidth) {
	      var heights = lineView.measure.heights = [];
	      if (wrapping) {
	        lineView.measure.width = curWidth;
	        var rects = lineView.text.firstChild.getClientRects();
	        for (var i = 0; i < rects.length - 1; i++) {
	          var cur = rects[i], next = rects[i + 1];
	          if (Math.abs(cur.bottom - next.bottom) > 2)
	            { heights.push((cur.bottom + next.top) / 2 - rect.top); }
	        }
	      }
	      heights.push(rect.bottom - rect.top);
	    }
	  }
	
	  // Find a line map (mapping character offsets to text nodes) and a
	  // measurement cache for the given line number. (A line view might
	  // contain multiple lines when collapsed ranges are present.)
	  function mapFromLineView(lineView, line, lineN) {
	    if (lineView.line == line)
	      { return {map: lineView.measure.map, cache: lineView.measure.cache} }
	    for (var i = 0; i < lineView.rest.length; i++)
	      { if (lineView.rest[i] == line)
	        { return {map: lineView.measure.maps[i], cache: lineView.measure.caches[i]} } }
	    for (var i$1 = 0; i$1 < lineView.rest.length; i$1++)
	      { if (lineNo(lineView.rest[i$1]) > lineN)
	        { return {map: lineView.measure.maps[i$1], cache: lineView.measure.caches[i$1], before: true} } }
	  }
	
	  // Render a line into the hidden node display.externalMeasured. Used
	  // when measurement is needed for a line that's not in the viewport.
	  function updateExternalMeasurement(cm, line) {
	    line = visualLine(line);
	    var lineN = lineNo(line);
	    var view = cm.display.externalMeasured = new LineView(cm.doc, line, lineN);
	    view.lineN = lineN;
	    var built = view.built = buildLineContent(cm, view);
	    view.text = built.pre;
	    removeChildrenAndAdd(cm.display.lineMeasure, built.pre);
	    return view
	  }
	
	  // Get a {top, bottom, left, right} box (in line-local coordinates)
	  // for a given character.
	  function measureChar(cm, line, ch, bias) {
	    return measureCharPrepared(cm, prepareMeasureForLine(cm, line), ch, bias)
	  }
	
	  // Find a line view that corresponds to the given line number.
	  function findViewForLine(cm, lineN) {
	    if (lineN >= cm.display.viewFrom && lineN < cm.display.viewTo)
	      { return cm.display.view[findViewIndex(cm, lineN)] }
	    var ext = cm.display.externalMeasured;
	    if (ext && lineN >= ext.lineN && lineN < ext.lineN + ext.size)
	      { return ext }
	  }
	
	  // Measurement can be split in two steps, the set-up work that
	  // applies to the whole line, and the measurement of the actual
	  // character. Functions like coordsChar, that need to do a lot of
	  // measurements in a row, can thus ensure that the set-up work is
	  // only done once.
	  function prepareMeasureForLine(cm, line) {
	    var lineN = lineNo(line);
	    var view = findViewForLine(cm, lineN);
	    if (view && !view.text) {
	      view = null;
	    } else if (view && view.changes) {
	      updateLineForChanges(cm, view, lineN, getDimensions(cm));
	      cm.curOp.forceUpdate = true;
	    }
	    if (!view)
	      { view = updateExternalMeasurement(cm, line); }
	
	    var info = mapFromLineView(view, line, lineN);
	    return {
	      line: line, view: view, rect: null,
	      map: info.map, cache: info.cache, before: info.before,
	      hasHeights: false
	    }
	  }
	
	  // Given a prepared measurement object, measures the position of an
	  // actual character (or fetches it from the cache).
	  function measureCharPrepared(cm, prepared, ch, bias, varHeight) {
	    if (prepared.before) { ch = -1; }
	    var key = ch + (bias || ""), found;
	    if (prepared.cache.hasOwnProperty(key)) {
	      found = prepared.cache[key];
	    } else {
	      if (!prepared.rect)
	        { prepared.rect = prepared.view.text.getBoundingClientRect(); }
	      if (!prepared.hasHeights) {
	        ensureLineHeights(cm, prepared.view, prepared.rect);
	        prepared.hasHeights = true;
	      }
	      found = measureCharInner(cm, prepared, ch, bias);
	      if (!found.bogus) { prepared.cache[key] = found; }
	    }
	    return {left: found.left, right: found.right,
	            top: varHeight ? found.rtop : found.top,
	            bottom: varHeight ? found.rbottom : found.bottom}
	  }
	
	  var nullRect = {left: 0, right: 0, top: 0, bottom: 0};
	
	  function nodeAndOffsetInLineMap(map, ch, bias) {
	    var node, start, end, collapse, mStart, mEnd;
	    // First, search the line map for the text node corresponding to,
	    // or closest to, the target character.
	    for (var i = 0; i < map.length; i += 3) {
	      mStart = map[i];
	      mEnd = map[i + 1];
	      if (ch < mStart) {
	        start = 0; end = 1;
	        collapse = "left";
	      } else if (ch < mEnd) {
	        start = ch - mStart;
	        end = start + 1;
	      } else if (i == map.length - 3 || ch == mEnd && map[i + 3] > ch) {
	        end = mEnd - mStart;
	        start = end - 1;
	        if (ch >= mEnd) { collapse = "right"; }
	      }
	      if (start != null) {
	        node = map[i + 2];
	        if (mStart == mEnd && bias == (node.insertLeft ? "left" : "right"))
	          { collapse = bias; }
	        if (bias == "left" && start == 0)
	          { while (i && map[i - 2] == map[i - 3] && map[i - 1].insertLeft) {
	            node = map[(i -= 3) + 2];
	            collapse = "left";
	          } }
	        if (bias == "right" && start == mEnd - mStart)
	          { while (i < map.length - 3 && map[i + 3] == map[i + 4] && !map[i + 5].insertLeft) {
	            node = map[(i += 3) + 2];
	            collapse = "right";
	          } }
	        break
	      }
	    }
	    return {node: node, start: start, end: end, collapse: collapse, coverStart: mStart, coverEnd: mEnd}
	  }
	
	  function getUsefulRect(rects, bias) {
	    var rect = nullRect;
	    if (bias == "left") { for (var i = 0; i < rects.length; i++) {
	      if ((rect = rects[i]).left != rect.right) { break }
	    } } else { for (var i$1 = rects.length - 1; i$1 >= 0; i$1--) {
	      if ((rect = rects[i$1]).left != rect.right) { break }
	    } }
	    return rect
	  }
	
	  function measureCharInner(cm, prepared, ch, bias) {
	    var place = nodeAndOffsetInLineMap(prepared.map, ch, bias);
	    var node = place.node, start = place.start, end = place.end, collapse = place.collapse;
	
	    var rect;
	    if (node.nodeType == 3) { // If it is a text node, use a range to retrieve the coordinates.
	      for (var i$1 = 0; i$1 < 4; i$1++) { // Retry a maximum of 4 times when nonsense rectangles are returned
	        while (start && isExtendingChar(prepared.line.text.charAt(place.coverStart + start))) { --start; }
	        while (place.coverStart + end < place.coverEnd && isExtendingChar(prepared.line.text.charAt(place.coverStart + end))) { ++end; }
	        if (ie && ie_version < 9 && start == 0 && end == place.coverEnd - place.coverStart)
	          { rect = node.parentNode.getBoundingClientRect(); }
	        else
	          { rect = getUsefulRect(range(node, start, end).getClientRects(), bias); }
	        if (rect.left || rect.right || start == 0) { break }
	        end = start;
	        start = start - 1;
	        collapse = "right";
	      }
	      if (ie && ie_version < 11) { rect = maybeUpdateRectForZooming(cm.display.measure, rect); }
	    } else { // If it is a widget, simply get the box for the whole widget.
	      if (start > 0) { collapse = bias = "right"; }
	      var rects;
	      if (cm.options.lineWrapping && (rects = node.getClientRects()).length > 1)
	        { rect = rects[bias == "right" ? rects.length - 1 : 0]; }
	      else
	        { rect = node.getBoundingClientRect(); }
	    }
	    if (ie && ie_version < 9 && !start && (!rect || !rect.left && !rect.right)) {
	      var rSpan = node.parentNode.getClientRects()[0];
	      if (rSpan)
	        { rect = {left: rSpan.left, right: rSpan.left + charWidth(cm.display), top: rSpan.top, bottom: rSpan.bottom}; }
	      else
	        { rect = nullRect; }
	    }
	
	    var rtop = rect.top - prepared.rect.top, rbot = rect.bottom - prepared.rect.top;
	    var mid = (rtop + rbot) / 2;
	    var heights = prepared.view.measure.heights;
	    var i = 0;
	    for (; i < heights.length - 1; i++)
	      { if (mid < heights[i]) { break } }
	    var top = i ? heights[i - 1] : 0, bot = heights[i];
	    var result = {left: (collapse == "right" ? rect.right : rect.left) - prepared.rect.left,
	                  right: (collapse == "left" ? rect.left : rect.right) - prepared.rect.left,
	                  top: top, bottom: bot};
	    if (!rect.left && !rect.right) { result.bogus = true; }
	    if (!cm.options.singleCursorHeightPerLine) { result.rtop = rtop; result.rbottom = rbot; }
	
	    return result
	  }
	
	  // Work around problem with bounding client rects on ranges being
	  // returned incorrectly when zoomed on IE10 and below.
	  function maybeUpdateRectForZooming(measure, rect) {
	    if (!window.screen || screen.logicalXDPI == null ||
	        screen.logicalXDPI == screen.deviceXDPI || !hasBadZoomedRects(measure))
	      { return rect }
	    var scaleX = screen.logicalXDPI / screen.deviceXDPI;
	    var scaleY = screen.logicalYDPI / screen.deviceYDPI;
	    return {left: rect.left * scaleX, right: rect.right * scaleX,
	            top: rect.top * scaleY, bottom: rect.bottom * scaleY}
	  }
	
	  function clearLineMeasurementCacheFor(lineView) {
	    if (lineView.measure) {
	      lineView.measure.cache = {};
	      lineView.measure.heights = null;
	      if (lineView.rest) { for (var i = 0; i < lineView.rest.length; i++)
	        { lineView.measure.caches[i] = {}; } }
	    }
	  }
	
	  function clearLineMeasurementCache(cm) {
	    cm.display.externalMeasure = null;
	    removeChildren(cm.display.lineMeasure);
	    for (var i = 0; i < cm.display.view.length; i++)
	      { clearLineMeasurementCacheFor(cm.display.view[i]); }
	  }
	
	  function clearCaches(cm) {
	    clearLineMeasurementCache(cm);
	    cm.display.cachedCharWidth = cm.display.cachedTextHeight = cm.display.cachedPaddingH = null;
	    if (!cm.options.lineWrapping) { cm.display.maxLineChanged = true; }
	    cm.display.lineNumChars = null;
	  }
	
	  function pageScrollX() {
	    // Work around https://bugs.chromium.org/p/chromium/issues/detail?id=489206
	    // which causes page_Offset and bounding client rects to use
	    // different reference viewports and invalidate our calculations.
	    if (chrome && android) { return -(document.body.getBoundingClientRect().left - parseInt(getComputedStyle(document.body).marginLeft)) }
	    return window.pageXOffset || (document.documentElement || document.body).scrollLeft
	  }
	  function pageScrollY() {
	    if (chrome && android) { return -(document.body.getBoundingClientRect().top - parseInt(getComputedStyle(document.body).marginTop)) }
	    return window.pageYOffset || (document.documentElement || document.body).scrollTop
	  }
	
	  function widgetTopHeight(lineObj) {
	    var height = 0;
	    if (lineObj.widgets) { for (var i = 0; i < lineObj.widgets.length; ++i) { if (lineObj.widgets[i].above)
	      { height += widgetHeight(lineObj.widgets[i]); } } }
	    return height
	  }
	
	  // Converts a {top, bottom, left, right} box from line-local
	  // coordinates into another coordinate system. Context may be one of
	  // "line", "div" (display.lineDiv), "local"./null (editor), "window",
	  // or "page".
	  function intoCoordSystem(cm, lineObj, rect, context, includeWidgets) {
	    if (!includeWidgets) {
	      var height = widgetTopHeight(lineObj);
	      rect.top += height; rect.bottom += height;
	    }
	    if (context == "line") { return rect }
	    if (!context) { context = "local"; }
	    var yOff = heightAtLine(lineObj);
	    if (context == "local") { yOff += paddingTop(cm.display); }
	    else { yOff -= cm.display.viewOffset; }
	    if (context == "page" || context == "window") {
	      var lOff = cm.display.lineSpace.getBoundingClientRect();
	      yOff += lOff.top + (context == "window" ? 0 : pageScrollY());
	      var xOff = lOff.left + (context == "window" ? 0 : pageScrollX());
	      rect.left += xOff; rect.right += xOff;
	    }
	    rect.top += yOff; rect.bottom += yOff;
	    return rect
	  }
	
	  // Coverts a box from "div" coords to another coordinate system.
	  // Context may be "window", "page", "div", or "local"./null.
	  function fromCoordSystem(cm, coords, context) {
	    if (context == "div") { return coords }
	    var left = coords.left, top = coords.top;
	    // First move into "page" coordinate system
	    if (context == "page") {
	      left -= pageScrollX();
	      top -= pageScrollY();
	    } else if (context == "local" || !context) {
	      var localBox = cm.display.sizer.getBoundingClientRect();
	      left += localBox.left;
	      top += localBox.top;
	    }
	
	    var lineSpaceBox = cm.display.lineSpace.getBoundingClientRect();
	    return {left: left - lineSpaceBox.left, top: top - lineSpaceBox.top}
	  }
	
	  function charCoords(cm, pos, context, lineObj, bias) {
	    if (!lineObj) { lineObj = getLine(cm.doc, pos.line); }
	    return intoCoordSystem(cm, lineObj, measureChar(cm, lineObj, pos.ch, bias), context)
	  }
	
	  // Returns a box for a given cursor position, which may have an
	  // 'other' property containing the position of the secondary cursor
	  // on a bidi boundary.
	  // A cursor Pos(line, char, "before") is on the same visual line as `char - 1`
	  // and after `char - 1` in writing order of `char - 1`
	  // A cursor Pos(line, char, "after") is on the same visual line as `char`
	  // and before `char` in writing order of `char`
	  // Examples (upper-case letters are RTL, lower-case are LTR):
	  //     Pos(0, 1, ...)
	  //     before   after
	  // ab     a|b     a|b
	  // aB     a|B     aB|
	  // Ab     |Ab     A|b
	  // AB     B|A     B|A
	  // Every position after the last character on a line is considered to stick
	  // to the last character on the line.
	  function cursorCoords(cm, pos, context, lineObj, preparedMeasure, varHeight) {
	    lineObj = lineObj || getLine(cm.doc, pos.line);
	    if (!preparedMeasure) { preparedMeasure = prepareMeasureForLine(cm, lineObj); }
	    function get(ch, right) {
	      var m = measureCharPrepared(cm, preparedMeasure, ch, right ? "right" : "left", varHeight);
	      if (right) { m.left = m.right; } else { m.right = m.left; }
	      return intoCoordSystem(cm, lineObj, m, context)
	    }
	    var order = getOrder(lineObj, cm.doc.direction), ch = pos.ch, sticky = pos.sticky;
	    if (ch >= lineObj.text.length) {
	      ch = lineObj.text.length;
	      sticky = "before";
	    } else if (ch <= 0) {
	      ch = 0;
	      sticky = "after";
	    }
	    if (!order) { return get(sticky == "before" ? ch - 1 : ch, sticky == "before") }
	
	    function getBidi(ch, partPos, invert) {
	      var part = order[partPos], right = part.level == 1;
	      return get(invert ? ch - 1 : ch, right != invert)
	    }
	    var partPos = getBidiPartAt(order, ch, sticky);
	    var other = bidiOther;
	    var val = getBidi(ch, partPos, sticky == "before");
	    if (other != null) { val.other = getBidi(ch, other, sticky != "before"); }
	    return val
	  }
	
	  // Used to cheaply estimate the coordinates for a position. Used for
	  // intermediate scroll updates.
	  function estimateCoords(cm, pos) {
	    var left = 0;
	    pos = clipPos(cm.doc, pos);
	    if (!cm.options.lineWrapping) { left = charWidth(cm.display) * pos.ch; }
	    var lineObj = getLine(cm.doc, pos.line);
	    var top = heightAtLine(lineObj) + paddingTop(cm.display);
	    return {left: left, right: left, top: top, bottom: top + lineObj.height}
	  }
	
	  // Positions returned by coordsChar contain some extra information.
	  // xRel is the relative x position of the input coordinates compared
	  // to the found position (so xRel > 0 means the coordinates are to
	  // the right of the character position, for example). When outside
	  // is true, that means the coordinates lie outside the line's
	  // vertical range.
	  function PosWithInfo(line, ch, sticky, outside, xRel) {
	    var pos = Pos(line, ch, sticky);
	    pos.xRel = xRel;
	    if (outside) { pos.outside = outside; }
	    return pos
	  }
	
	  // Compute the character position closest to the given coordinates.
	  // Input must be lineSpace-local ("div" coordinate system).
	  function coordsChar(cm, x, y) {
	    var doc = cm.doc;
	    y += cm.display.viewOffset;
	    if (y < 0) { return PosWithInfo(doc.first, 0, null, -1, -1) }
	    var lineN = lineAtHeight(doc, y), last = doc.first + doc.size - 1;
	    if (lineN > last)
	      { return PosWithInfo(doc.first + doc.size - 1, getLine(doc, last).text.length, null, 1, 1) }
	    if (x < 0) { x = 0; }
	
	    var lineObj = getLine(doc, lineN);
	    for (;;) {
	      var found = coordsCharInner(cm, lineObj, lineN, x, y);
	      var collapsed = collapsedSpanAround(lineObj, found.ch + (found.xRel > 0 || found.outside > 0 ? 1 : 0));
	      if (!collapsed) { return found }
	      var rangeEnd = collapsed.find(1);
	      if (rangeEnd.line == lineN) { return rangeEnd }
	      lineObj = getLine(doc, lineN = rangeEnd.line);
	    }
	  }
	
	  function wrappedLineExtent(cm, lineObj, preparedMeasure, y) {
	    y -= widgetTopHeight(lineObj);
	    var end = lineObj.text.length;
	    var begin = findFirst(function (ch) { return measureCharPrepared(cm, preparedMeasure, ch - 1).bottom <= y; }, end, 0);
	    end = findFirst(function (ch) { return measureCharPrepared(cm, preparedMeasure, ch).top > y; }, begin, end);
	    return {begin: begin, end: end}
	  }
	
	  function wrappedLineExtentChar(cm, lineObj, preparedMeasure, target) {
	    if (!preparedMeasure) { preparedMeasure = prepareMeasureForLine(cm, lineObj); }
	    var targetTop = intoCoordSystem(cm, lineObj, measureCharPrepared(cm, preparedMeasure, target), "line").top;
	    return wrappedLineExtent(cm, lineObj, preparedMeasure, targetTop)
	  }
	
	  // Returns true if the given side of a box is after the given
	  // coordinates, in top-to-bottom, left-to-right order.
	  function boxIsAfter(box, x, y, left) {
	    return box.bottom <= y ? false : box.top > y ? true : (left ? box.left : box.right) > x
	  }
	
	  function coordsCharInner(cm, lineObj, lineNo, x, y) {
	    // Move y into line-local coordinate space
	    y -= heightAtLine(lineObj);
	    var preparedMeasure = prepareMeasureForLine(cm, lineObj);
	    // When directly calling `measureCharPrepared`, we have to adjust
	    // for the widgets at this line.
	    var widgetHeight = widgetTopHeight(lineObj);
	    var begin = 0, end = lineObj.text.length, ltr = true;
	
	    var order = getOrder(lineObj, cm.doc.direction);
	    // If the line isn't plain left-to-right text, first figure out
	    // which bidi section the coordinates fall into.
	    if (order) {
	      var part = (cm.options.lineWrapping ? coordsBidiPartWrapped : coordsBidiPart)
	                   (cm, lineObj, lineNo, preparedMeasure, order, x, y);
	      ltr = part.level != 1;
	      // The awkward -1 offsets are needed because findFirst (called
	      // on these below) will treat its first bound as inclusive,
	      // second as exclusive, but we want to actually address the
	      // characters in the part's range
	      begin = ltr ? part.from : part.to - 1;
	      end = ltr ? part.to : part.from - 1;
	    }
	
	    // A binary search to find the first character whose bounding box
	    // starts after the coordinates. If we run across any whose box wrap
	    // the coordinates, store that.
	    var chAround = null, boxAround = null;
	    var ch = findFirst(function (ch) {
	      var box = measureCharPrepared(cm, preparedMeasure, ch);
	      box.top += widgetHeight; box.bottom += widgetHeight;
	      if (!boxIsAfter(box, x, y, false)) { return false }
	      if (box.top <= y && box.left <= x) {
	        chAround = ch;
	        boxAround = box;
	      }
	      return true
	    }, begin, end);
	
	    var baseX, sticky, outside = false;
	    // If a box around the coordinates was found, use that
	    if (boxAround) {
	      // Distinguish coordinates nearer to the left or right side of the box
	      var atLeft = x - boxAround.left < boxAround.right - x, atStart = atLeft == ltr;
	      ch = chAround + (atStart ? 0 : 1);
	      sticky = atStart ? "after" : "before";
	      baseX = atLeft ? boxAround.left : boxAround.right;
	    } else {
	      // (Adjust for extended bound, if necessary.)
	      if (!ltr && (ch == end || ch == begin)) { ch++; }
	      // To determine which side to associate with, get the box to the
	      // left of the character and compare it's vertical position to the
	      // coordinates
	      sticky = ch == 0 ? "after" : ch == lineObj.text.length ? "before" :
	        (measureCharPrepared(cm, preparedMeasure, ch - (ltr ? 1 : 0)).bottom + widgetHeight <= y) == ltr ?
	        "after" : "before";
	      // Now get accurate coordinates for this place, in order to get a
	      // base X position
	      var coords = cursorCoords(cm, Pos(lineNo, ch, sticky), "line", lineObj, preparedMeasure);
	      baseX = coords.left;
	      outside = y < coords.top ? -1 : y >= coords.bottom ? 1 : 0;
	    }
	
	    ch = skipExtendingChars(lineObj.text, ch, 1);
	    return PosWithInfo(lineNo, ch, sticky, outside, x - baseX)
	  }
	
	  function coordsBidiPart(cm, lineObj, lineNo, preparedMeasure, order, x, y) {
	    // Bidi parts are sorted left-to-right, and in a non-line-wrapping
	    // situation, we can take this ordering to correspond to the visual
	    // ordering. This finds the first part whose end is after the given
	    // coordinates.
	    var index = findFirst(function (i) {
	      var part = order[i], ltr = part.level != 1;
	      return boxIsAfter(cursorCoords(cm, Pos(lineNo, ltr ? part.to : part.from, ltr ? "before" : "after"),
	                                     "line", lineObj, preparedMeasure), x, y, true)
	    }, 0, order.length - 1);
	    var part = order[index];
	    // If this isn't the first part, the part's start is also after
	    // the coordinates, and the coordinates aren't on the same line as
	    // that start, move one part back.
	    if (index > 0) {
	      var ltr = part.level != 1;
	      var start = cursorCoords(cm, Pos(lineNo, ltr ? part.from : part.to, ltr ? "after" : "before"),
	                               "line", lineObj, preparedMeasure);
	      if (boxIsAfter(start, x, y, true) && start.top > y)
	        { part = order[index - 1]; }
	    }
	    return part
	  }
	
	  function coordsBidiPartWrapped(cm, lineObj, _lineNo, preparedMeasure, order, x, y) {
	    // In a wrapped line, rtl text on wrapping boundaries can do things
	    // that don't correspond to the ordering in our `order` array at
	    // all, so a binary search doesn't work, and we want to return a
	    // part that only spans one line so that the binary search in
	    // coordsCharInner is safe. As such, we first find the extent of the
	    // wrapped line, and then do a flat search in which we discard any
	    // spans that aren't on the line.
	    var ref = wrappedLineExtent(cm, lineObj, preparedMeasure, y);
	    var begin = ref.begin;
	    var end = ref.end;
	    if (/\s/.test(lineObj.text.charAt(end - 1))) { end--; }
	    var part = null, closestDist = null;
	    for (var i = 0; i < order.length; i++) {
	      var p = order[i];
	      if (p.from >= end || p.to <= begin) { continue }
	      var ltr = p.level != 1;
	      var endX = measureCharPrepared(cm, preparedMeasure, ltr ? Math.min(end, p.to) - 1 : Math.max(begin, p.from)).right;
	      // Weigh against spans ending before this, so that they are only
	      // picked if nothing ends after
	      var dist = endX < x ? x - endX + 1e9 : endX - x;
	      if (!part || closestDist > dist) {
	        part = p;
	        closestDist = dist;
	      }
	    }
	    if (!part) { part = order[order.length - 1]; }
	    // Clip the part to the wrapped line.
	    if (part.from < begin) { part = {from: begin, to: part.to, level: part.level}; }
	    if (part.to > end) { part = {from: part.from, to: end, level: part.level}; }
	    return part
	  }
	
	  var measureText;
	  // Compute the default text height.
	  function textHeight(display) {
	    if (display.cachedTextHeight != null) { return display.cachedTextHeight }
	    if (measureText == null) {
	      measureText = elt("pre", null, "CodeMirror-line-like");
	      // Measure a bunch of lines, for browsers that compute
	      // fractional heights.
	      for (var i = 0; i < 49; ++i) {
	        measureText.appendChild(document.createTextNode("x"));
	        measureText.appendChild(elt("br"));
	      }
	      measureText.appendChild(document.createTextNode("x"));
	    }
	    removeChildrenAndAdd(display.measure, measureText);
	    var height = measureText.offsetHeight / 50;
	    if (height > 3) { display.cachedTextHeight = height; }
	    removeChildren(display.measure);
	    return height || 1
	  }
	
	  // Compute the default character width.
	  function charWidth(display) {
	    if (display.cachedCharWidth != null) { return display.cachedCharWidth }
	    var anchor = elt("span", "xxxxxxxxxx");
	    var pre = elt("pre", [anchor], "CodeMirror-line-like");
	    removeChildrenAndAdd(display.measure, pre);
	    var rect = anchor.getBoundingClientRect(), width = (rect.right - rect.left) / 10;
	    if (width > 2) { display.cachedCharWidth = width; }
	    return width || 10
	  }
	
	  // Do a bulk-read of the DOM positions and sizes needed to draw the
	  // view, so that we don't interleave reading and writing to the DOM.
	  function getDimensions(cm) {
	    var d = cm.display, left = {}, width = {};
	    var gutterLeft = d.gutters.clientLeft;
	    for (var n = d.gutters.firstChild, i = 0; n; n = n.nextSibling, ++i) {
	      var id = cm.display.gutterSpecs[i].className;
	      left[id] = n.offsetLeft + n.clientLeft + gutterLeft;
	      width[id] = n.clientWidth;
	    }
	    return {fixedPos: compensateForHScroll(d),
	            gutterTotalWidth: d.gutters.offsetWidth,
	            gutterLeft: left,
	            gutterWidth: width,
	            wrapperWidth: d.wrapper.clientWidth}
	  }
	
	  // Computes display.scroller.scrollLeft + display.gutters.offsetWidth,
	  // but using getBoundingClientRect to get a sub-pixel-accurate
	  // result.
	  function compensateForHScroll(display) {
	    return display.scroller.getBoundingClientRect().left - display.sizer.getBoundingClientRect().left
	  }
	
	  // Returns a function that estimates the height of a line, to use as
	  // first approximation until the line becomes visible (and is thus
	  // properly measurable).
	  function estimateHeight(cm) {
	    var th = textHeight(cm.display), wrapping = cm.options.lineWrapping;
	    var perLine = wrapping && Math.max(5, cm.display.scroller.clientWidth / charWidth(cm.display) - 3);
	    return function (line) {
	      if (lineIsHidden(cm.doc, line)) { return 0 }
	
	      var widgetsHeight = 0;
	      if (line.widgets) { for (var i = 0; i < line.widgets.length; i++) {
	        if (line.widgets[i].height) { widgetsHeight += line.widgets[i].height; }
	      } }
	
	      if (wrapping)
	        { return widgetsHeight + (Math.ceil(line.text.length / perLine) || 1) * th }
	      else
	        { return widgetsHeight + th }
	    }
	  }
	
	  function estimateLineHeights(cm) {
	    var doc = cm.doc, est = estimateHeight(cm);
	    doc.iter(function (line) {
	      var estHeight = est(line);
	      if (estHeight != line.height) { updateLineHeight(line, estHeight); }
	    });
	  }
	
	  // Given a mouse event, find the corresponding position. If liberal
	  // is false, it checks whether a gutter or scrollbar was clicked,
	  // and returns null if it was. forRect is used by rectangular
	  // selections, and tries to estimate a character position even for
	  // coordinates beyond the right of the text.
	  function posFromMouse(cm, e, liberal, forRect) {
	    var display = cm.display;
	    if (!liberal && e_target(e).getAttribute("cm-not-content") == "true") { return null }
	
	    var x, y, space = display.lineSpace.getBoundingClientRect();
	    // Fails unpredictably on IE[67] when mouse is dragged around quickly.
	    try { x = e.clientX - space.left; y = e.clientY - space.top; }
	    catch (e) { return null }
	    var coords = coordsChar(cm, x, y), line;
	    if (forRect && coords.xRel > 0 && (line = getLine(cm.doc, coords.line).text).length == coords.ch) {
	      var colDiff = countColumn(line, line.length, cm.options.tabSize) - line.length;
	      coords = Pos(coords.line, Math.max(0, Math.round((x - paddingH(cm.display).left) / charWidth(cm.display)) - colDiff));
	    }
	    return coords
	  }
	
	  // Find the view element corresponding to a given line. Return null
	  // when the line isn't visible.
	  function findViewIndex(cm, n) {
	    if (n >= cm.display.viewTo) { return null }
	    n -= cm.display.viewFrom;
	    if (n < 0) { return null }
	    var view = cm.display.view;
	    for (var i = 0; i < view.length; i++) {
	      n -= view[i].size;
	      if (n < 0) { return i }
	    }
	  }
	
	  // Updates the display.view data structure for a given change to the
	  // document. From and to are in pre-change coordinates. Lendiff is
	  // the amount of lines added or subtracted by the change. This is
	  // used for changes that span multiple lines, or change the way
	  // lines are divided into visual lines. regLineChange (below)
	  // registers single-line changes.
	  function regChange(cm, from, to, lendiff) {
	    if (from == null) { from = cm.doc.first; }
	    if (to == null) { to = cm.doc.first + cm.doc.size; }
	    if (!lendiff) { lendiff = 0; }
	
	    var display = cm.display;
	    if (lendiff && to < display.viewTo &&
	        (display.updateLineNumbers == null || display.updateLineNumbers > from))
	      { display.updateLineNumbers = from; }
	
	    cm.curOp.viewChanged = true;
	
	    if (from >= display.viewTo) { // Change after
	      if (sawCollapsedSpans && visualLineNo(cm.doc, from) < display.viewTo)
	        { resetView(cm); }
	    } else if (to <= display.viewFrom) { // Change before
	      if (sawCollapsedSpans && visualLineEndNo(cm.doc, to + lendiff) > display.viewFrom) {
	        resetView(cm);
	      } else {
	        display.viewFrom += lendiff;
	        display.viewTo += lendiff;
	      }
	    } else if (from <= display.viewFrom && to >= display.viewTo) { // Full overlap
	      resetView(cm);
	    } else if (from <= display.viewFrom) { // Top overlap
	      var cut = viewCuttingPoint(cm, to, to + lendiff, 1);
	      if (cut) {
	        display.view = display.view.slice(cut.index);
	        display.viewFrom = cut.lineN;
	        display.viewTo += lendiff;
	      } else {
	        resetView(cm);
	      }
	    } else if (to >= display.viewTo) { // Bottom overlap
	      var cut$1 = viewCuttingPoint(cm, from, from, -1);
	      if (cut$1) {
	        display.view = display.view.slice(0, cut$1.index);
	        display.viewTo = cut$1.lineN;
	      } else {
	        resetView(cm);
	      }
	    } else { // Gap in the middle
	      var cutTop = viewCuttingPoint(cm, from, from, -1);
	      var cutBot = viewCuttingPoint(cm, to, to + lendiff, 1);
	      if (cutTop && cutBot) {
	        display.view = display.view.slice(0, cutTop.index)
	          .concat(buildViewArray(cm, cutTop.lineN, cutBot.lineN))
	          .concat(display.view.slice(cutBot.index));
	        display.viewTo += lendiff;
	      } else {
	        resetView(cm);
	      }
	    }
	
	    var ext = display.externalMeasured;
	    if (ext) {
	      if (to < ext.lineN)
	        { ext.lineN += lendiff; }
	      else if (from < ext.lineN + ext.size)
	        { display.externalMeasured = null; }
	    }
	  }
	
	  // Register a change to a single line. Type must be one of "text",
	  // "gutter", "class", "widget"
	  function regLineChange(cm, line, type) {
	    cm.curOp.viewChanged = true;
	    var display = cm.display, ext = cm.display.externalMeasured;
	    if (ext && line >= ext.lineN && line < ext.lineN + ext.size)
	      { display.externalMeasured = null; }
	
	    if (line < display.viewFrom || line >= display.viewTo) { return }
	    var lineView = display.view[findViewIndex(cm, line)];
	    if (lineView.node == null) { return }
	    var arr = lineView.changes || (lineView.changes = []);
	    if (indexOf(arr, type) == -1) { arr.push(type); }
	  }
	
	  // Clear the view.
	  function resetView(cm) {
	    cm.display.viewFrom = cm.display.viewTo = cm.doc.first;
	    cm.display.view = [];
	    cm.display.viewOffset = 0;
	  }
	
	  function viewCuttingPoint(cm, oldN, newN, dir) {
	    var index = findViewIndex(cm, oldN), diff, view = cm.display.view;
	    if (!sawCollapsedSpans || newN == cm.doc.first + cm.doc.size)
	      { return {index: index, lineN: newN} }
	    var n = cm.display.viewFrom;
	    for (var i = 0; i < index; i++)
	      { n += view[i].size; }
	    if (n != oldN) {
	      if (dir > 0) {
	        if (index == view.length - 1) { return null }
	        diff = (n + view[index].size) - oldN;
	        index++;
	      } else {
	        diff = n - oldN;
	      }
	      oldN += diff; newN += diff;
	    }
	    while (visualLineNo(cm.doc, newN) != newN) {
	      if (index == (dir < 0 ? 0 : view.length - 1)) { return null }
	      newN += dir * view[index - (dir < 0 ? 1 : 0)].size;
	      index += dir;
	    }
	    return {index: index, lineN: newN}
	  }
	
	  // Force the view to cover a given range, adding empty view element
	  // or clipping off existing ones as needed.
	  function adjustView(cm, from, to) {
	    var display = cm.display, view = display.view;
	    if (view.length == 0 || from >= display.viewTo || to <= display.viewFrom) {
	      display.view = buildViewArray(cm, from, to);
	      display.viewFrom = from;
	    } else {
	      if (display.viewFrom > from)
	        { display.view = buildViewArray(cm, from, display.viewFrom).concat(display.view); }
	      else if (display.viewFrom < from)
	        { display.view = display.view.slice(findViewIndex(cm, from)); }
	      display.viewFrom = from;
	      if (display.viewTo < to)
	        { display.view = display.view.concat(buildViewArray(cm, display.viewTo, to)); }
	      else if (display.viewTo > to)
	        { display.view = display.view.slice(0, findViewIndex(cm, to)); }
	    }
	    display.viewTo = to;
	  }
	
	  // Count the number of lines in the view whose DOM representation is
	  // out of date (or nonexistent).
	  function countDirtyView(cm) {
	    var view = cm.display.view, dirty = 0;
	    for (var i = 0; i < view.length; i++) {
	      var lineView = view[i];
	      if (!lineView.hidden && (!lineView.node || lineView.changes)) { ++dirty; }
	    }
	    return dirty
	  }
	
	  function updateSelection(cm) {
	    cm.display.input.showSelection(cm.display.input.prepareSelection());
	  }
	
	  function prepareSelection(cm, primary) {
	    if ( primary === void 0 ) primary = true;
	
	    var doc = cm.doc, result = {};
	    var curFragment = result.cursors = document.createDocumentFragment();
	    var selFragment = result.selection = document.createDocumentFragment();
	
	    for (var i = 0; i < doc.sel.ranges.length; i++) {
	      if (!primary && i == doc.sel.primIndex) { continue }
	      var range = doc.sel.ranges[i];
	      if (range.from().line >= cm.display.viewTo || range.to().line < cm.display.viewFrom) { continue }
	      var collapsed = range.empty();
	      if (collapsed || cm.options.showCursorWhenSelecting)
	        { drawSelectionCursor(cm, range.head, curFragment); }
	      if (!collapsed)
	        { drawSelectionRange(cm, range, selFragment); }
	    }
	    return result
	  }
	
	  // Draws a cursor for the given range
	  function drawSelectionCursor(cm, head, output) {
	    var pos = cursorCoords(cm, head, "div", null, null, !cm.options.singleCursorHeightPerLine);
	
	    var cursor = output.appendChild(elt("div", "\u00a0", "CodeMirror-cursor"));
	    cursor.style.left = pos.left + "px";
	    cursor.style.top = pos.top + "px";
	    cursor.style.height = Math.max(0, pos.bottom - pos.top) * cm.options.cursorHeight + "px";
	
	    if (pos.other) {
	      // Secondary cursor, shown when on a 'jump' in bi-directional text
	      var otherCursor = output.appendChild(elt("div", "\u00a0", "CodeMirror-cursor CodeMirror-secondarycursor"));
	      otherCursor.style.display = "";
	      otherCursor.style.left = pos.other.left + "px";
	      otherCursor.style.top = pos.other.top + "px";
	      otherCursor.style.height = (pos.other.bottom - pos.other.top) * .85 + "px";
	    }
	  }
	
	  function cmpCoords(a, b) { return a.top - b.top || a.left - b.left }
	
	  // Draws the given range as a highlighted selection
	  function drawSelectionRange(cm, range, output) {
	    var display = cm.display, doc = cm.doc;
	    var fragment = document.createDocumentFragment();
	    var padding = paddingH(cm.display), leftSide = padding.left;
	    var rightSide = Math.max(display.sizerWidth, displayWidth(cm) - display.sizer.offsetLeft) - padding.right;
	    var docLTR = doc.direction == "ltr";
	
	    function add(left, top, width, bottom) {
	      if (top < 0) { top = 0; }
	      top = Math.round(top);
	      bottom = Math.round(bottom);
	      fragment.appendChild(elt("div", null, "CodeMirror-selected", ("position: absolute; left: " + left + "px;\n                             top: " + top + "px; width: " + (width == null ? rightSide - left : width) + "px;\n                             height: " + (bottom - top) + "px")));
	    }
	
	    function drawForLine(line, fromArg, toArg) {
	      var lineObj = getLine(doc, line);
	      var lineLen = lineObj.text.length;
	      var start, end;
	      function coords(ch, bias) {
	        return charCoords(cm, Pos(line, ch), "div", lineObj, bias)
	      }
	
	      function wrapX(pos, dir, side) {
	        var extent = wrappedLineExtentChar(cm, lineObj, null, pos);
	        var prop = (dir == "ltr") == (side == "after") ? "left" : "right";
	        var ch = side == "after" ? extent.begin : extent.end - (/\s/.test(lineObj.text.charAt(extent.end - 1)) ? 2 : 1);
	        return coords(ch, prop)[prop]
	      }
	
	      var order = getOrder(lineObj, doc.direction);
	      iterateBidiSections(order, fromArg || 0, toArg == null ? lineLen : toArg, function (from, to, dir, i) {
	        var ltr = dir == "ltr";
	        var fromPos = coords(from, ltr ? "left" : "right");
	        var toPos = coords(to - 1, ltr ? "right" : "left");
	
	        var openStart = fromArg == null && from == 0, openEnd = toArg == null && to == lineLen;
	        var first = i == 0, last = !order || i == order.length - 1;
	        if (toPos.top - fromPos.top <= 3) { // Single line
	          var openLeft = (docLTR ? openStart : openEnd) && first;
	          var openRight = (docLTR ? openEnd : openStart) && last;
	          var left = openLeft ? leftSide : (ltr ? fromPos : toPos).left;
	          var right = openRight ? rightSide : (ltr ? toPos : fromPos).right;
	          add(left, fromPos.top, right - left, fromPos.bottom);
	        } else { // Multiple lines
	          var topLeft, topRight, botLeft, botRight;
	          if (ltr) {
	            topLeft = docLTR && openStart && first ? leftSide : fromPos.left;
	            topRight = docLTR ? rightSide : wrapX(from, dir, "before");
	            botLeft = docLTR ? leftSide : wrapX(to, dir, "after");
	            botRight = docLTR && openEnd && last ? rightSide : toPos.right;
	          } else {
	            topLeft = !docLTR ? leftSide : wrapX(from, dir, "before");
	            topRight = !docLTR && openStart && first ? rightSide : fromPos.right;
	            botLeft = !docLTR && openEnd && last ? leftSide : toPos.left;
	            botRight = !docLTR ? rightSide : wrapX(to, dir, "after");
	          }
	          add(topLeft, fromPos.top, topRight - topLeft, fromPos.bottom);
	          if (fromPos.bottom < toPos.top) { add(leftSide, fromPos.bottom, null, toPos.top); }
	          add(botLeft, toPos.top, botRight - botLeft, toPos.bottom);
	        }
	
	        if (!start || cmpCoords(fromPos, start) < 0) { start = fromPos; }
	        if (cmpCoords(toPos, start) < 0) { start = toPos; }
	        if (!end || cmpCoords(fromPos, end) < 0) { end = fromPos; }
	        if (cmpCoords(toPos, end) < 0) { end = toPos; }
	      });
	      return {start: start, end: end}
	    }
	
	    var sFrom = range.from(), sTo = range.to();
	    if (sFrom.line == sTo.line) {
	      drawForLine(sFrom.line, sFrom.ch, sTo.ch);
	    } else {
	      var fromLine = getLine(doc, sFrom.line), toLine = getLine(doc, sTo.line);
	      var singleVLine = visualLine(fromLine) == visualLine(toLine);
	      var leftEnd = drawForLine(sFrom.line, sFrom.ch, singleVLine ? fromLine.text.length + 1 : null).end;
	      var rightStart = drawForLine(sTo.line, singleVLine ? 0 : null, sTo.ch).start;
	      if (singleVLine) {
	        if (leftEnd.top < rightStart.top - 2) {
	          add(leftEnd.right, leftEnd.top, null, leftEnd.bottom);
	          add(leftSide, rightStart.top, rightStart.left, rightStart.bottom);
	        } else {
	          add(leftEnd.right, leftEnd.top, rightStart.left - leftEnd.right, leftEnd.bottom);
	        }
	      }
	      if (leftEnd.bottom < rightStart.top)
	        { add(leftSide, leftEnd.bottom, null, rightStart.top); }
	    }
	
	    output.appendChild(fragment);
	  }
	
	  // Cursor-blinking
	  function restartBlink(cm) {
	    if (!cm.state.focused) { return }
	    var display = cm.display;
	    clearInterval(display.blinker);
	    var on = true;
	    display.cursorDiv.style.visibility = "";
	    if (cm.options.cursorBlinkRate > 0)
	      { display.blinker = setInterval(function () { return display.cursorDiv.style.visibility = (on = !on) ? "" : "hidden"; },
	        cm.options.cursorBlinkRate); }
	    else if (cm.options.cursorBlinkRate < 0)
	      { display.cursorDiv.style.visibility = "hidden"; }
	  }
	
	  function ensureFocus(cm) {
	    if (!cm.state.focused) { cm.display.input.focus(); onFocus(cm); }
	  }
	
	  function delayBlurEvent(cm) {
	    cm.state.delayingBlurEvent = true;
	    setTimeout(function () { if (cm.state.delayingBlurEvent) {
	      cm.state.delayingBlurEvent = false;
	      onBlur(cm);
	    } }, 100);
	  }
	
	  function onFocus(cm, e) {
	    if (cm.state.delayingBlurEvent) { cm.state.delayingBlurEvent = false; }
	
	    if (cm.options.readOnly == "nocursor") { return }
	    if (!cm.state.focused) {
	      signal(cm, "focus", cm, e);
	      cm.state.focused = true;
	      addClass(cm.display.wrapper, "CodeMirror-focused");
	      // This test prevents this from firing when a context
	      // menu is closed (since the input reset would kill the
	      // select-all detection hack)
	      if (!cm.curOp && cm.display.selForContextMenu != cm.doc.sel) {
	        cm.display.input.reset();
	        if (webkit) { setTimeout(function () { return cm.display.input.reset(true); }, 20); } // Issue #1730
	      }
	      cm.display.input.receivedFocus();
	    }
	    restartBlink(cm);
	  }
	  function onBlur(cm, e) {
	    if (cm.state.delayingBlurEvent) { return }
	
	    if (cm.state.focused) {
	      signal(cm, "blur", cm, e);
	      cm.state.focused = false;
	      rmClass(cm.display.wrapper, "CodeMirror-focused");
	    }
	    clearInterval(cm.display.blinker);
	    setTimeout(function () { if (!cm.state.focused) { cm.display.shift = false; } }, 150);
	  }
	
	  // Read the actual heights of the rendered lines, and update their
	  // stored heights to match.
	  function updateHeightsInViewport(cm) {
	    var display = cm.display;
	    var prevBottom = display.lineDiv.offsetTop;
	    for (var i = 0; i < display.view.length; i++) {
	      var cur = display.view[i], wrapping = cm.options.lineWrapping;
	      var height = (void 0), width = 0;
	      if (cur.hidden) { continue }
	      if (ie && ie_version < 8) {
	        var bot = cur.node.offsetTop + cur.node.offsetHeight;
	        height = bot - prevBottom;
	        prevBottom = bot;
	      } else {
	        var box = cur.node.getBoundingClientRect();
	        height = box.bottom - box.top;
	        // Check that lines don't extend past the right of the current
	        // editor width
	        if (!wrapping && cur.text.firstChild)
	          { width = cur.text.firstChild.getBoundingClientRect().right - box.left - 1; }
	      }
	      var diff = cur.line.height - height;
	      if (diff > .005 || diff < -.005) {
	        updateLineHeight(cur.line, height);
	        updateWidgetHeight(cur.line);
	        if (cur.rest) { for (var j = 0; j < cur.rest.length; j++)
	          { updateWidgetHeight(cur.rest[j]); } }
	      }
	      if (width > cm.display.sizerWidth) {
	        var chWidth = Math.ceil(width / charWidth(cm.display));
	        if (chWidth > cm.display.maxLineLength) {
	          cm.display.maxLineLength = chWidth;
	          cm.display.maxLine = cur.line;
	          cm.display.maxLineChanged = true;
	        }
	      }
	    }
	  }
	
	  // Read and store the height of line widgets associated with the
	  // given line.
	  function updateWidgetHeight(line) {
	    if (line.widgets) { for (var i = 0; i < line.widgets.length; ++i) {
	      var w = line.widgets[i], parent = w.node.parentNode;
	      if (parent) { w.height = parent.offsetHeight; }
	    } }
	  }
	
	  // Compute the lines that are visible in a given viewport (defaults
	  // the the current scroll position). viewport may contain top,
	  // height, and ensure (see op.scrollToPos) properties.
	  function visibleLines(display, doc, viewport) {
	    var top = viewport && viewport.top != null ? Math.max(0, viewport.top) : display.scroller.scrollTop;
	    top = Math.floor(top - paddingTop(display));
	    var bottom = viewport && viewport.bottom != null ? viewport.bottom : top + display.wrapper.clientHeight;
	
	    var from = lineAtHeight(doc, top), to = lineAtHeight(doc, bottom);
	    // Ensure is a {from: {line, ch}, to: {line, ch}} object, and
	    // forces those lines into the viewport (if possible).
	    if (viewport && viewport.ensure) {
	      var ensureFrom = viewport.ensure.from.line, ensureTo = viewport.ensure.to.line;
	      if (ensureFrom < from) {
	        from = ensureFrom;
	        to = lineAtHeight(doc, heightAtLine(getLine(doc, ensureFrom)) + display.wrapper.clientHeight);
	      } else if (Math.min(ensureTo, doc.lastLine()) >= to) {
	        from = lineAtHeight(doc, heightAtLine(getLine(doc, ensureTo)) - display.wrapper.clientHeight);
	        to = ensureTo;
	      }
	    }
	    return {from: from, to: Math.max(to, from + 1)}
	  }
	
	  // SCROLLING THINGS INTO VIEW
	
	  // If an editor sits on the top or bottom of the window, partially
	  // scrolled out of view, this ensures that the cursor is visible.
	  function maybeScrollWindow(cm, rect) {
	    if (signalDOMEvent(cm, "scrollCursorIntoView")) { return }
	
	    var display = cm.display, box = display.sizer.getBoundingClientRect(), doScroll = null;
	    if (rect.top + box.top < 0) { doScroll = true; }
	    else if (rect.bottom + box.top > (window.innerHeight || document.documentElement.clientHeight)) { doScroll = false; }
	    if (doScroll != null && !phantom) {
	      var scrollNode = elt("div", "\u200b", null, ("position: absolute;\n                         top: " + (rect.top - display.viewOffset - paddingTop(cm.display)) + "px;\n                         height: " + (rect.bottom - rect.top + scrollGap(cm) + display.barHeight) + "px;\n                         left: " + (rect.left) + "px; width: " + (Math.max(2, rect.right - rect.left)) + "px;"));
	      cm.display.lineSpace.appendChild(scrollNode);
	      scrollNode.scrollIntoView(doScroll);
	      cm.display.lineSpace.removeChild(scrollNode);
	    }
	  }
	
	  // Scroll a given position into view (immediately), verifying that
	  // it actually became visible (as line heights are accurately
	  // measured, the position of something may 'drift' during drawing).
	  function scrollPosIntoView(cm, pos, end, margin) {
	    if (margin == null) { margin = 0; }
	    var rect;
	    if (!cm.options.lineWrapping && pos == end) {
	      // Set pos and end to the cursor positions around the character pos sticks to
	      // If pos.sticky == "before", that is around pos.ch - 1, otherwise around pos.ch
	      // If pos == Pos(_, 0, "before"), pos and end are unchanged
	      pos = pos.ch ? Pos(pos.line, pos.sticky == "before" ? pos.ch - 1 : pos.ch, "after") : pos;
	      end = pos.sticky == "before" ? Pos(pos.line, pos.ch + 1, "before") : pos;
	    }
	    for (var limit = 0; limit < 5; limit++) {
	      var changed = false;
	      var coords = cursorCoords(cm, pos);
	      var endCoords = !end || end == pos ? coords : cursorCoords(cm, end);
	      rect = {left: Math.min(coords.left, endCoords.left),
	              top: Math.min(coords.top, endCoords.top) - margin,
	              right: Math.max(coords.left, endCoords.left),
	              bottom: Math.max(coords.bottom, endCoords.bottom) + margin};
	      var scrollPos = calculateScrollPos(cm, rect);
	      var startTop = cm.doc.scrollTop, startLeft = cm.doc.scrollLeft;
	      if (scrollPos.scrollTop != null) {
	        updateScrollTop(cm, scrollPos.scrollTop);
	        if (Math.abs(cm.doc.scrollTop - startTop) > 1) { changed = true; }
	      }
	      if (scrollPos.scrollLeft != null) {
	        setScrollLeft(cm, scrollPos.scrollLeft);
	        if (Math.abs(cm.doc.scrollLeft - startLeft) > 1) { changed = true; }
	      }
	      if (!changed) { break }
	    }
	    return rect
	  }
	
	  // Scroll a given set of coordinates into view (immediately).
	  function scrollIntoView(cm, rect) {
	    var scrollPos = calculateScrollPos(cm, rect);
	    if (scrollPos.scrollTop != null) { updateScrollTop(cm, scrollPos.scrollTop); }
	    if (scrollPos.scrollLeft != null) { setScrollLeft(cm, scrollPos.scrollLeft); }
	  }
	
	  // Calculate a new scroll position needed to scroll the given
	  // rectangle into view. Returns an object with scrollTop and
	  // scrollLeft properties. When these are undefined, the
	  // vertical/horizontal position does not need to be adjusted.
	  function calculateScrollPos(cm, rect) {
	    var display = cm.display, snapMargin = textHeight(cm.display);
	    if (rect.top < 0) { rect.top = 0; }
	    var screentop = cm.curOp && cm.curOp.scrollTop != null ? cm.curOp.scrollTop : display.scroller.scrollTop;
	    var screen = displayHeight(cm), result = {};
	    if (rect.bottom - rect.top > screen) { rect.bottom = rect.top + screen; }
	    var docBottom = cm.doc.height + paddingVert(display);
	    var atTop = rect.top < snapMargin, atBottom = rect.bottom > docBottom - snapMargin;
	    if (rect.top < screentop) {
	      result.scrollTop = atTop ? 0 : rect.top;
	    } else if (rect.bottom > screentop + screen) {
	      var newTop = Math.min(rect.top, (atBottom ? docBottom : rect.bottom) - screen);
	      if (newTop != screentop) { result.scrollTop = newTop; }
	    }
	
	    var screenleft = cm.curOp && cm.curOp.scrollLeft != null ? cm.curOp.scrollLeft : display.scroller.scrollLeft;
	    var screenw = displayWidth(cm) - (cm.options.fixedGutter ? display.gutters.offsetWidth : 0);
	    var tooWide = rect.right - rect.left > screenw;
	    if (tooWide) { rect.right = rect.left + screenw; }
	    if (rect.left < 10)
	      { result.scrollLeft = 0; }
	    else if (rect.left < screenleft)
	      { result.scrollLeft = Math.max(0, rect.left - (tooWide ? 0 : 10)); }
	    else if (rect.right > screenw + screenleft - 3)
	      { result.scrollLeft = rect.right + (tooWide ? 0 : 10) - screenw; }
	    return result
	  }
	
	  // Store a relative adjustment to the scroll position in the current
	  // operation (to be applied when the operation finishes).
	  function addToScrollTop(cm, top) {
	    if (top == null) { return }
	    resolveScrollToPos(cm);
	    cm.curOp.scrollTop = (cm.curOp.scrollTop == null ? cm.doc.scrollTop : cm.curOp.scrollTop) + top;
	  }
	
	  // Make sure that at the end of the operation the current cursor is
	  // shown.
	  function ensureCursorVisible(cm) {
	    resolveScrollToPos(cm);
	    var cur = cm.getCursor();
	    cm.curOp.scrollToPos = {from: cur, to: cur, margin: cm.options.cursorScrollMargin};
	  }
	
	  function scrollToCoords(cm, x, y) {
	    if (x != null || y != null) { resolveScrollToPos(cm); }
	    if (x != null) { cm.curOp.scrollLeft = x; }
	    if (y != null) { cm.curOp.scrollTop = y; }
	  }
	
	  function scrollToRange(cm, range) {
	    resolveScrollToPos(cm);
	    cm.curOp.scrollToPos = range;
	  }
	
	  // When an operation has its scrollToPos property set, and another
	  // scroll action is applied before the end of the operation, this
	  // 'simulates' scrolling that position into view in a cheap way, so
	  // that the effect of intermediate scroll commands is not ignored.
	  function resolveScrollToPos(cm) {
	    var range = cm.curOp.scrollToPos;
	    if (range) {
	      cm.curOp.scrollToPos = null;
	      var from = estimateCoords(cm, range.from), to = estimateCoords(cm, range.to);
	      scrollToCoordsRange(cm, from, to, range.margin);
	    }
	  }
	
	  function scrollToCoordsRange(cm, from, to, margin) {
	    var sPos = calculateScrollPos(cm, {
	      left: Math.min(from.left, to.left),
	      top: Math.min(from.top, to.top) - margin,
	      right: Math.max(from.right, to.right),
	      bottom: Math.max(from.bottom, to.bottom) + margin
	    });
	    scrollToCoords(cm, sPos.scrollLeft, sPos.scrollTop);
	  }
	
	  // Sync the scrollable area and scrollbars, ensure the viewport
	  // covers the visible area.
	  function updateScrollTop(cm, val) {
	    if (Math.abs(cm.doc.scrollTop - val) < 2) { return }
	    if (!gecko) { updateDisplaySimple(cm, {top: val}); }
	    setScrollTop(cm, val, true);
	    if (gecko) { updateDisplaySimple(cm); }
	    startWorker(cm, 100);
	  }
	
	  function setScrollTop(cm, val, forceScroll) {
	    val = Math.max(0, Math.min(cm.display.scroller.scrollHeight - cm.display.scroller.clientHeight, val));
	    if (cm.display.scroller.scrollTop == val && !forceScroll) { return }
	    cm.doc.scrollTop = val;
	    cm.display.scrollbars.setScrollTop(val);
	    if (cm.display.scroller.scrollTop != val) { cm.display.scroller.scrollTop = val; }
	  }
	
	  // Sync scroller and scrollbar, ensure the gutter elements are
	  // aligned.
	  function setScrollLeft(cm, val, isScroller, forceScroll) {
	    val = Math.max(0, Math.min(val, cm.display.scroller.scrollWidth - cm.display.scroller.clientWidth));
	    if ((isScroller ? val == cm.doc.scrollLeft : Math.abs(cm.doc.scrollLeft - val) < 2) && !forceScroll) { return }
	    cm.doc.scrollLeft = val;
	    alignHorizontally(cm);
	    if (cm.display.scroller.scrollLeft != val) { cm.display.scroller.scrollLeft = val; }
	    cm.display.scrollbars.setScrollLeft(val);
	  }
	
	  // SCROLLBARS
	
	  // Prepare DOM reads needed to update the scrollbars. Done in one
	  // shot to minimize update/measure roundtrips.
	  function measureForScrollbars(cm) {
	    var d = cm.display, gutterW = d.gutters.offsetWidth;
	    var docH = Math.round(cm.doc.height + paddingVert(cm.display));
	    return {
	      clientHeight: d.scroller.clientHeight,
	      viewHeight: d.wrapper.clientHeight,
	      scrollWidth: d.scroller.scrollWidth, clientWidth: d.scroller.clientWidth,
	      viewWidth: d.wrapper.clientWidth,
	      barLeft: cm.options.fixedGutter ? gutterW : 0,
	      docHeight: docH,
	      scrollHeight: docH + scrollGap(cm) + d.barHeight,
	      nativeBarWidth: d.nativeBarWidth,
	      gutterWidth: gutterW
	    }
	  }
	
	  var NativeScrollbars = function(place, scroll, cm) {
	    this.cm = cm;
	    var vert = this.vert = elt("div", [elt("div", null, null, "min-width: 1px")], "CodeMirror-vscrollbar");
	    var horiz = this.horiz = elt("div", [elt("div", null, null, "height: 100%; min-height: 1px")], "CodeMirror-hscrollbar");
	    vert.tabIndex = horiz.tabIndex = -1;
	    place(vert); place(horiz);
	
	    on(vert, "scroll", function () {
	      if (vert.clientHeight) { scroll(vert.scrollTop, "vertical"); }
	    });
	    on(horiz, "scroll", function () {
	      if (horiz.clientWidth) { scroll(horiz.scrollLeft, "horizontal"); }
	    });
	
	    this.checkedZeroWidth = false;
	    // Need to set a minimum width to see the scrollbar on IE7 (but must not set it on IE8).
	    if (ie && ie_version < 8) { this.horiz.style.minHeight = this.vert.style.minWidth = "18px"; }
	  };
	
	  NativeScrollbars.prototype.update = function (measure) {
	    var needsH = measure.scrollWidth > measure.clientWidth + 1;
	    var needsV = measure.scrollHeight > measure.clientHeight + 1;
	    var sWidth = measure.nativeBarWidth;
	
	    if (needsV) {
	      this.vert.style.display = "block";
	      this.vert.style.bottom = needsH ? sWidth + "px" : "0";
	      var totalHeight = measure.viewHeight - (needsH ? sWidth : 0);
	      // A bug in IE8 can cause this value to be negative, so guard it.
	      this.vert.firstChild.style.height =
	        Math.max(0, measure.scrollHeight - measure.clientHeight + totalHeight) + "px";
	    } else {
	      this.vert.style.display = "";
	      this.vert.firstChild.style.height = "0";
	    }
	
	    if (needsH) {
	      this.horiz.style.display = "block";
	      this.horiz.style.right = needsV ? sWidth + "px" : "0";
	      this.horiz.style.left = measure.barLeft + "px";
	      var totalWidth = measure.viewWidth - measure.barLeft - (needsV ? sWidth : 0);
	      this.horiz.firstChild.style.width =
	        Math.max(0, measure.scrollWidth - measure.clientWidth + totalWidth) + "px";
	    } else {
	      this.horiz.style.display = "";
	      this.horiz.firstChild.style.width = "0";
	    }
	
	    if (!this.checkedZeroWidth && measure.clientHeight > 0) {
	      if (sWidth == 0) { this.zeroWidthHack(); }
	      this.checkedZeroWidth = true;
	    }
	
	    return {right: needsV ? sWidth : 0, bottom: needsH ? sWidth : 0}
	  };
	
	  NativeScrollbars.prototype.setScrollLeft = function (pos) {
	    if (this.horiz.scrollLeft != pos) { this.horiz.scrollLeft = pos; }
	    if (this.disableHoriz) { this.enableZeroWidthBar(this.horiz, this.disableHoriz, "horiz"); }
	  };
	
	  NativeScrollbars.prototype.setScrollTop = function (pos) {
	    if (this.vert.scrollTop != pos) { this.vert.scrollTop = pos; }
	    if (this.disableVert) { this.enableZeroWidthBar(this.vert, this.disableVert, "vert"); }
	  };
	
	  NativeScrollbars.prototype.zeroWidthHack = function () {
	    var w = mac && !mac_geMountainLion ? "12px" : "18px";
	    this.horiz.style.height = this.vert.style.width = w;
	    this.horiz.style.pointerEvents = this.vert.style.pointerEvents = "none";
	    this.disableHoriz = new Delayed;
	    this.disableVert = new Delayed;
	  };
	
	  NativeScrollbars.prototype.enableZeroWidthBar = function (bar, delay, type) {
	    bar.style.pointerEvents = "auto";
	    function maybeDisable() {
	      // To find out whether the scrollbar is still visible, we
	      // check whether the element under the pixel in the bottom
	      // right corner of the scrollbar box is the scrollbar box
	      // itself (when the bar is still visible) or its filler child
	      // (when the bar is hidden). If it is still visible, we keep
	      // it enabled, if it's hidden, we disable pointer events.
	      var box = bar.getBoundingClientRect();
	      var elt = type == "vert" ? document.elementFromPoint(box.right - 1, (box.top + box.bottom) / 2)
	          : document.elementFromPoint((box.right + box.left) / 2, box.bottom - 1);
	      if (elt != bar) { bar.style.pointerEvents = "none"; }
	      else { delay.set(1000, maybeDisable); }
	    }
	    delay.set(1000, maybeDisable);
	  };
	
	  NativeScrollbars.prototype.clear = function () {
	    var parent = this.horiz.parentNode;
	    parent.removeChild(this.horiz);
	    parent.removeChild(this.vert);
	  };
	
	  var NullScrollbars = function () {};
	
	  NullScrollbars.prototype.update = function () { return {bottom: 0, right: 0} };
	  NullScrollbars.prototype.setScrollLeft = function () {};
	  NullScrollbars.prototype.setScrollTop = function () {};
	  NullScrollbars.prototype.clear = function () {};
	
	  function updateScrollbars(cm, measure) {
	    if (!measure) { measure = measureForScrollbars(cm); }
	    var startWidth = cm.display.barWidth, startHeight = cm.display.barHeight;
	    updateScrollbarsInner(cm, measure);
	    for (var i = 0; i < 4 && startWidth != cm.display.barWidth || startHeight != cm.display.barHeight; i++) {
	      if (startWidth != cm.display.barWidth && cm.options.lineWrapping)
	        { updateHeightsInViewport(cm); }
	      updateScrollbarsInner(cm, measureForScrollbars(cm));
	      startWidth = cm.display.barWidth; startHeight = cm.display.barHeight;
	    }
	  }
	
	  // Re-synchronize the fake scrollbars with the actual size of the
	  // content.
	  function updateScrollbarsInner(cm, measure) {
	    var d = cm.display;
	    var sizes = d.scrollbars.update(measure);
	
	    d.sizer.style.paddingRight = (d.barWidth = sizes.right) + "px";
	    d.sizer.style.paddingBottom = (d.barHeight = sizes.bottom) + "px";
	    d.heightForcer.style.borderBottom = sizes.bottom + "px solid transparent";
	
	    if (sizes.right && sizes.bottom) {
	      d.scrollbarFiller.style.display = "block";
	      d.scrollbarFiller.style.height = sizes.bottom + "px";
	      d.scrollbarFiller.style.width = sizes.right + "px";
	    } else { d.scrollbarFiller.style.display = ""; }
	    if (sizes.bottom && cm.options.coverGutterNextToScrollbar && cm.options.fixedGutter) {
	      d.gutterFiller.style.display = "block";
	      d.gutterFiller.style.height = sizes.bottom + "px";
	      d.gutterFiller.style.width = measure.gutterWidth + "px";
	    } else { d.gutterFiller.style.display = ""; }
	  }
	
	  var scrollbarModel = {"native": NativeScrollbars, "null": NullScrollbars};
	
	  function initScrollbars(cm) {
	    if (cm.display.scrollbars) {
	      cm.display.scrollbars.clear();
	      if (cm.display.scrollbars.addClass)
	        { rmClass(cm.display.wrapper, cm.display.scrollbars.addClass); }
	    }
	
	    cm.display.scrollbars = new scrollbarModel[cm.options.scrollbarStyle](function (node) {
	      cm.display.wrapper.insertBefore(node, cm.display.scrollbarFiller);
	      // Prevent clicks in the scrollbars from killing focus
	      on(node, "mousedown", function () {
	        if (cm.state.focused) { setTimeout(function () { return cm.display.input.focus(); }, 0); }
	      });
	      node.setAttribute("cm-not-content", "true");
	    }, function (pos, axis) {
	      if (axis == "horizontal") { setScrollLeft(cm, pos); }
	      else { updateScrollTop(cm, pos); }
	    }, cm);
	    if (cm.display.scrollbars.addClass)
	      { addClass(cm.display.wrapper, cm.display.scrollbars.addClass); }
	  }
	
	  // Operations are used to wrap a series of changes to the editor
	  // state in such a way that each change won't have to update the
	  // cursor and display (which would be awkward, slow, and
	  // error-prone). Instead, display updates are batched and then all
	  // combined and executed at once.
	
	  var nextOpId = 0;
	  // Start a new operation.
	  function startOperation(cm) {
	    cm.curOp = {
	      cm: cm,
	      viewChanged: false,      // Flag that indicates that lines might need to be redrawn
	      startHeight: cm.doc.height, // Used to detect need to update scrollbar
	      forceUpdate: false,      // Used to force a redraw
	      updateInput: 0,       // Whether to reset the input textarea
	      typing: false,           // Whether this reset should be careful to leave existing text (for compositing)
	      changeObjs: null,        // Accumulated changes, for firing change events
	      cursorActivityHandlers: null, // Set of handlers to fire cursorActivity on
	      cursorActivityCalled: 0, // Tracks which cursorActivity handlers have been called already
	      selectionChanged: false, // Whether the selection needs to be redrawn
	      updateMaxLine: false,    // Set when the widest line needs to be determined anew
	      scrollLeft: null, scrollTop: null, // Intermediate scroll position, not pushed to DOM yet
	      scrollToPos: null,       // Used to scroll to a specific position
	      focus: false,
	      id: ++nextOpId           // Unique ID
	    };
	    pushOperation(cm.curOp);
	  }
	
	  // Finish an operation, updating the display and signalling delayed events
	  function endOperation(cm) {
	    var op = cm.curOp;
	    if (op) { finishOperation(op, function (group) {
	      for (var i = 0; i < group.ops.length; i++)
	        { group.ops[i].cm.curOp = null; }
	      endOperations(group);
	    }); }
	  }
	
	  // The DOM updates done when an operation finishes are batched so
	  // that the minimum number of relayouts are required.
	  function endOperations(group) {
	    var ops = group.ops;
	    for (var i = 0; i < ops.length; i++) // Read DOM
	      { endOperation_R1(ops[i]); }
	    for (var i$1 = 0; i$1 < ops.length; i$1++) // Write DOM (maybe)
	      { endOperation_W1(ops[i$1]); }
	    for (var i$2 = 0; i$2 < ops.length; i$2++) // Read DOM
	      { endOperation_R2(ops[i$2]); }
	    for (var i$3 = 0; i$3 < ops.length; i$3++) // Write DOM (maybe)
	      { endOperation_W2(ops[i$3]); }
	    for (var i$4 = 0; i$4 < ops.length; i$4++) // Read DOM
	      { endOperation_finish(ops[i$4]); }
	  }
	
	  function endOperation_R1(op) {
	    var cm = op.cm, display = cm.display;
	    maybeClipScrollbars(cm);
	    if (op.updateMaxLine) { findMaxLine(cm); }
	
	    op.mustUpdate = op.viewChanged || op.forceUpdate || op.scrollTop != null ||
	      op.scrollToPos && (op.scrollToPos.from.line < display.viewFrom ||
	                         op.scrollToPos.to.line >= display.viewTo) ||
	      display.maxLineChanged && cm.options.lineWrapping;
	    op.update = op.mustUpdate &&
	      new DisplayUpdate(cm, op.mustUpdate && {top: op.scrollTop, ensure: op.scrollToPos}, op.forceUpdate);
	  }
	
	  function endOperation_W1(op) {
	    op.updatedDisplay = op.mustUpdate && updateDisplayIfNeeded(op.cm, op.update);
	  }
	
	  function endOperation_R2(op) {
	    var cm = op.cm, display = cm.display;
	    if (op.updatedDisplay) { updateHeightsInViewport(cm); }
	
	    op.barMeasure = measureForScrollbars(cm);
	
	    // If the max line changed since it was last measured, measure it,
	    // and ensure the document's width matches it.
	    // updateDisplay_W2 will use these properties to do the actual resizing
	    if (display.maxLineChanged && !cm.options.lineWrapping) {
	      op.adjustWidthTo = measureChar(cm, display.maxLine, display.maxLine.text.length).left + 3;
	      cm.display.sizerWidth = op.adjustWidthTo;
	      op.barMeasure.scrollWidth =
	        Math.max(display.scroller.clientWidth, display.sizer.offsetLeft + op.adjustWidthTo + scrollGap(cm) + cm.display.barWidth);
	      op.maxScrollLeft = Math.max(0, display.sizer.offsetLeft + op.adjustWidthTo - displayWidth(cm));
	    }
	
	    if (op.updatedDisplay || op.selectionChanged)
	      { op.preparedSelection = display.input.prepareSelection(); }
	  }
	
	  function endOperation_W2(op) {
	    var cm = op.cm;
	
	    if (op.adjustWidthTo != null) {
	      cm.display.sizer.style.minWidth = op.adjustWidthTo + "px";
	      if (op.maxScrollLeft < cm.doc.scrollLeft)
	        { setScrollLeft(cm, Math.min(cm.display.scroller.scrollLeft, op.maxScrollLeft), true); }
	      cm.display.maxLineChanged = false;
	    }
	
	    var takeFocus = op.focus && op.focus == activeElt();
	    if (op.preparedSelection)
	      { cm.display.input.showSelection(op.preparedSelection, takeFocus); }
	    if (op.updatedDisplay || op.startHeight != cm.doc.height)
	      { updateScrollbars(cm, op.barMeasure); }
	    if (op.updatedDisplay)
	      { setDocumentHeight(cm, op.barMeasure); }
	
	    if (op.selectionChanged) { restartBlink(cm); }
	
	    if (cm.state.focused && op.updateInput)
	      { cm.display.input.reset(op.typing); }
	    if (takeFocus) { ensureFocus(op.cm); }
	  }
	
	  function endOperation_finish(op) {
	    var cm = op.cm, display = cm.display, doc = cm.doc;
	
	    if (op.updatedDisplay) { postUpdateDisplay(cm, op.update); }
	
	    // Abort mouse wheel delta measurement, when scrolling explicitly
	    if (display.wheelStartX != null && (op.scrollTop != null || op.scrollLeft != null || op.scrollToPos))
	      { display.wheelStartX = display.wheelStartY = null; }
	
	    // Propagate the scroll position to the actual DOM scroller
	    if (op.scrollTop != null) { setScrollTop(cm, op.scrollTop, op.forceScroll); }
	
	    if (op.scrollLeft != null) { setScrollLeft(cm, op.scrollLeft, true, true); }
	    // If we need to scroll a specific position into view, do so.
	    if (op.scrollToPos) {
	      var rect = scrollPosIntoView(cm, clipPos(doc, op.scrollToPos.from),
	                                   clipPos(doc, op.scrollToPos.to), op.scrollToPos.margin);
	      maybeScrollWindow(cm, rect);
	    }
	
	    // Fire events for markers that are hidden/unidden by editing or
	    // undoing
	    var hidden = op.maybeHiddenMarkers, unhidden = op.maybeUnhiddenMarkers;
	    if (hidden) { for (var i = 0; i < hidden.length; ++i)
	      { if (!hidden[i].lines.length) { signal(hidden[i], "hide"); } } }
	    if (unhidden) { for (var i$1 = 0; i$1 < unhidden.length; ++i$1)
	      { if (unhidden[i$1].lines.length) { signal(unhidden[i$1], "unhide"); } } }
	
	    if (display.wrapper.offsetHeight)
	      { doc.scrollTop = cm.display.scroller.scrollTop; }
	
	    // Fire change events, and delayed event handlers
	    if (op.changeObjs)
	      { signal(cm, "changes", cm, op.changeObjs); }
	    if (op.update)
	      { op.update.finish(); }
	  }
	
	  // Run the given function in an operation
	  function runInOp(cm, f) {
	    if (cm.curOp) { return f() }
	    startOperation(cm);
	    try { return f() }
	    finally { endOperation(cm); }
	  }
	  // Wraps a function in an operation. Returns the wrapped function.
	  function operation(cm, f) {
	    return function() {
	      if (cm.curOp) { return f.apply(cm, arguments) }
	      startOperation(cm);
	      try { return f.apply(cm, arguments) }
	      finally { endOperation(cm); }
	    }
	  }
	  // Used to add methods to editor and doc instances, wrapping them in
	  // operations.
	  function methodOp(f) {
	    return function() {
	      if (this.curOp) { return f.apply(this, arguments) }
	      startOperation(this);
	      try { return f.apply(this, arguments) }
	      finally { endOperation(this); }
	    }
	  }
	  function docMethodOp(f) {
	    return function() {
	      var cm = this.cm;
	      if (!cm || cm.curOp) { return f.apply(this, arguments) }
	      startOperation(cm);
	      try { return f.apply(this, arguments) }
	      finally { endOperation(cm); }
	    }
	  }
	
	  // HIGHLIGHT WORKER
	
	  function startWorker(cm, time) {
	    if (cm.doc.highlightFrontier < cm.display.viewTo)
	      { cm.state.highlight.set(time, bind(highlightWorker, cm)); }
	  }
	
	  function highlightWorker(cm) {
	    var doc = cm.doc;
	    if (doc.highlightFrontier >= cm.display.viewTo) { return }
	    var end = +new Date + cm.options.workTime;
	    var context = getContextBefore(cm, doc.highlightFrontier);
	    var changedLines = [];
	
	    doc.iter(context.line, Math.min(doc.first + doc.size, cm.display.viewTo + 500), function (line) {
	      if (context.line >= cm.display.viewFrom) { // Visible
	        var oldStyles = line.styles;
	        var resetState = line.text.length > cm.options.maxHighlightLength ? copyState(doc.mode, context.state) : null;
	        var highlighted = highlightLine(cm, line, context, true);
	        if (resetState) { context.state = resetState; }
	        line.styles = highlighted.styles;
	        var oldCls = line.styleClasses, newCls = highlighted.classes;
	        if (newCls) { line.styleClasses = newCls; }
	        else if (oldCls) { line.styleClasses = null; }
	        var ischange = !oldStyles || oldStyles.length != line.styles.length ||
	          oldCls != newCls && (!oldCls || !newCls || oldCls.bgClass != newCls.bgClass || oldCls.textClass != newCls.textClass);
	        for (var i = 0; !ischange && i < oldStyles.length; ++i) { ischange = oldStyles[i] != line.styles[i]; }
	        if (ischange) { changedLines.push(context.line); }
	        line.stateAfter = context.save();
	        context.nextLine();
	      } else {
	        if (line.text.length <= cm.options.maxHighlightLength)
	          { processLine(cm, line.text, context); }
	        line.stateAfter = context.line % 5 == 0 ? context.save() : null;
	        context.nextLine();
	      }
	      if (+new Date > end) {
	        startWorker(cm, cm.options.workDelay);
	        return true
	      }
	    });
	    doc.highlightFrontier = context.line;
	    doc.modeFrontier = Math.max(doc.modeFrontier, context.line);
	    if (changedLines.length) { runInOp(cm, function () {
	      for (var i = 0; i < changedLines.length; i++)
	        { regLineChange(cm, changedLines[i], "text"); }
	    }); }
	  }
	
	  // DISPLAY DRAWING
	
	  var DisplayUpdate = function(cm, viewport, force) {
	    var display = cm.display;
	
	    this.viewport = viewport;
	    // Store some values that we'll need later (but don't want to force a relayout for)
	    this.visible = visibleLines(display, cm.doc, viewport);
	    this.editorIsHidden = !display.wrapper.offsetWidth;
	    this.wrapperHeight = display.wrapper.clientHeight;
	    this.wrapperWidth = display.wrapper.clientWidth;
	    this.oldDisplayWidth = displayWidth(cm);
	    this.force = force;
	    this.dims = getDimensions(cm);
	    this.events = [];
	  };
	
	  DisplayUpdate.prototype.signal = function (emitter, type) {
	    if (hasHandler(emitter, type))
	      { this.events.push(arguments); }
	  };
	  DisplayUpdate.prototype.finish = function () {
	    for (var i = 0; i < this.events.length; i++)
	      { signal.apply(null, this.events[i]); }
	  };
	
	  function maybeClipScrollbars(cm) {
	    var display = cm.display;
	    if (!display.scrollbarsClipped && display.scroller.offsetWidth) {
	      display.nativeBarWidth = display.scroller.offsetWidth - display.scroller.clientWidth;
	      display.heightForcer.style.height = scrollGap(cm) + "px";
	      display.sizer.style.marginBottom = -display.nativeBarWidth + "px";
	      display.sizer.style.borderRightWidth = scrollGap(cm) + "px";
	      display.scrollbarsClipped = true;
	    }
	  }
	
	  function selectionSnapshot(cm) {
	    if (cm.hasFocus()) { return null }
	    var active = activeElt();
	    if (!active || !contains(cm.display.lineDiv, active)) { return null }
	    var result = {activeElt: active};
	    if (window.getSelection) {
	      var sel = window.getSelection();
	      if (sel.anchorNode && sel.extend && contains(cm.display.lineDiv, sel.anchorNode)) {
	        result.anchorNode = sel.anchorNode;
	        result.anchorOffset = sel.anchorOffset;
	        result.focusNode = sel.focusNode;
	        result.focusOffset = sel.focusOffset;
	      }
	    }
	    return result
	  }
	
	  function restoreSelection(snapshot) {
	    if (!snapshot || !snapshot.activeElt || snapshot.activeElt == activeElt()) { return }
	    snapshot.activeElt.focus();
	    if (snapshot.anchorNode && contains(document.body, snapshot.anchorNode) && contains(document.body, snapshot.focusNode)) {
	      var sel = window.getSelection(), range = document.createRange();
	      range.setEnd(snapshot.anchorNode, snapshot.anchorOffset);
	      range.collapse(false);
	      sel.removeAllRanges();
	      sel.addRange(range);
	      sel.extend(snapshot.focusNode, snapshot.focusOffset);
	    }
	  }
	
	  // Does the actual updating of the line display. Bails out
	  // (returning false) when there is nothing to be done and forced is
	  // false.
	  function updateDisplayIfNeeded(cm, update) {
	    var display = cm.display, doc = cm.doc;
	
	    if (update.editorIsHidden) {
	      resetView(cm);
	      return false
	    }
	
	    // Bail out if the visible area is already rendered and nothing changed.
	    if (!update.force &&
	        update.visible.from >= display.viewFrom && update.visible.to <= display.viewTo &&
	        (display.updateLineNumbers == null || display.updateLineNumbers >= display.viewTo) &&
	        display.renderedView == display.view && countDirtyView(cm) == 0)
	      { return false }
	
	    if (maybeUpdateLineNumberWidth(cm)) {
	      resetView(cm);
	      update.dims = getDimensions(cm);
	    }
	
	    // Compute a suitable new viewport (from & to)
	    var end = doc.first + doc.size;
	    var from = Math.max(update.visible.from - cm.options.viewportMargin, doc.first);
	    var to = Math.min(end, update.visible.to + cm.options.viewportMargin);
	    if (display.viewFrom < from && from - display.viewFrom < 20) { from = Math.max(doc.first, display.viewFrom); }
	    if (display.viewTo > to && display.viewTo - to < 20) { to = Math.min(end, display.viewTo); }
	    if (sawCollapsedSpans) {
	      from = visualLineNo(cm.doc, from);
	      to = visualLineEndNo(cm.doc, to);
	    }
	
	    var different = from != display.viewFrom || to != display.viewTo ||
	      display.lastWrapHeight != update.wrapperHeight || display.lastWrapWidth != update.wrapperWidth;
	    adjustView(cm, from, to);
	
	    display.viewOffset = heightAtLine(getLine(cm.doc, display.viewFrom));
	    // Position the mover div to align with the current scroll position
	    cm.display.mover.style.top = display.viewOffset + "px";
	
	    var toUpdate = countDirtyView(cm);
	    if (!different && toUpdate == 0 && !update.force && display.renderedView == display.view &&
	        (display.updateLineNumbers == null || display.updateLineNumbers >= display.viewTo))
	      { return false }
	
	    // For big changes, we hide the enclosing element during the
	    // update, since that speeds up the operations on most browsers.
	    var selSnapshot = selectionSnapshot(cm);
	    if (toUpdate > 4) { display.lineDiv.style.display = "none"; }
	    patchDisplay(cm, display.updateLineNumbers, update.dims);
	    if (toUpdate > 4) { display.lineDiv.style.display = ""; }
	    display.renderedView = display.view;
	    // There might have been a widget with a focused element that got
	    // hidden or updated, if so re-focus it.
	    restoreSelection(selSnapshot);
	
	    // Prevent selection and cursors from interfering with the scroll
	    // width and height.
	    removeChildren(display.cursorDiv);
	    removeChildren(display.selectionDiv);
	    display.gutters.style.height = display.sizer.style.minHeight = 0;
	
	    if (different) {
	      display.lastWrapHeight = update.wrapperHeight;
	      display.lastWrapWidth = update.wrapperWidth;
	      startWorker(cm, 400);
	    }
	
	    display.updateLineNumbers = null;
	
	    return true
	  }
	
	  function postUpdateDisplay(cm, update) {
	    var viewport = update.viewport;
	
	    for (var first = true;; first = false) {
	      if (!first || !cm.options.lineWrapping || update.oldDisplayWidth == displayWidth(cm)) {
	        // Clip forced viewport to actual scrollable area.
	        if (viewport && viewport.top != null)
	          { viewport = {top: Math.min(cm.doc.height + paddingVert(cm.display) - displayHeight(cm), viewport.top)}; }
	        // Updated line heights might result in the drawn area not
	        // actually covering the viewport. Keep looping until it does.
	        update.visible = visibleLines(cm.display, cm.doc, viewport);
	        if (update.visible.from >= cm.display.viewFrom && update.visible.to <= cm.display.viewTo)
	          { break }
	      } else if (first) {
	        update.visible = visibleLines(cm.display, cm.doc, viewport);
	      }
	      if (!updateDisplayIfNeeded(cm, update)) { break }
	      updateHeightsInViewport(cm);
	      var barMeasure = measureForScrollbars(cm);
	      updateSelection(cm);
	      updateScrollbars(cm, barMeasure);
	      setDocumentHeight(cm, barMeasure);
	      update.force = false;
	    }
	
	    update.signal(cm, "update", cm);
	    if (cm.display.viewFrom != cm.display.reportedViewFrom || cm.display.viewTo != cm.display.reportedViewTo) {
	      update.signal(cm, "viewportChange", cm, cm.display.viewFrom, cm.display.viewTo);
	      cm.display.reportedViewFrom = cm.display.viewFrom; cm.display.reportedViewTo = cm.display.viewTo;
	    }
	  }
	
	  function updateDisplaySimple(cm, viewport) {
	    var update = new DisplayUpdate(cm, viewport);
	    if (updateDisplayIfNeeded(cm, update)) {
	      updateHeightsInViewport(cm);
	      postUpdateDisplay(cm, update);
	      var barMeasure = measureForScrollbars(cm);
	      updateSelection(cm);
	      updateScrollbars(cm, barMeasure);
	      setDocumentHeight(cm, barMeasure);
	      update.finish();
	    }
	  }
	
	  // Sync the actual display DOM structure with display.view, removing
	  // nodes for lines that are no longer in view, and creating the ones
	  // that are not there yet, and updating the ones that are out of
	  // date.
	  function patchDisplay(cm, updateNumbersFrom, dims) {
	    var display = cm.display, lineNumbers = cm.options.lineNumbers;
	    var container = display.lineDiv, cur = container.firstChild;
	
	    function rm(node) {
	      var next = node.nextSibling;
	      // Works around a throw-scroll bug in OS X Webkit
	      if (webkit && mac && cm.display.currentWheelTarget == node)
	        { node.style.display = "none"; }
	      else
	        { node.parentNode.removeChild(node); }
	      return next
	    }
	
	    var view = display.view, lineN = display.viewFrom;
	    // Loop over the elements in the view, syncing cur (the DOM nodes
	    // in display.lineDiv) with the view as we go.
	    for (var i = 0; i < view.length; i++) {
	      var lineView = view[i];
	      if (lineView.hidden) ; else if (!lineView.node || lineView.node.parentNode != container) { // Not drawn yet
	        var node = buildLineElement(cm, lineView, lineN, dims);
	        container.insertBefore(node, cur);
	      } else { // Already drawn
	        while (cur != lineView.node) { cur = rm(cur); }
	        var updateNumber = lineNumbers && updateNumbersFrom != null &&
	          updateNumbersFrom <= lineN && lineView.lineNumber;
	        if (lineView.changes) {
	          if (indexOf(lineView.changes, "gutter") > -1) { updateNumber = false; }
	          updateLineForChanges(cm, lineView, lineN, dims);
	        }
	        if (updateNumber) {
	          removeChildren(lineView.lineNumber);
	          lineView.lineNumber.appendChild(document.createTextNode(lineNumberFor(cm.options, lineN)));
	        }
	        cur = lineView.node.nextSibling;
	      }
	      lineN += lineView.size;
	    }
	    while (cur) { cur = rm(cur); }
	  }
	
	  function updateGutterSpace(display) {
	    var width = display.gutters.offsetWidth;
	    display.sizer.style.marginLeft = width + "px";
	  }
	
	  function setDocumentHeight(cm, measure) {
	    cm.display.sizer.style.minHeight = measure.docHeight + "px";
	    cm.display.heightForcer.style.top = measure.docHeight + "px";
	    cm.display.gutters.style.height = (measure.docHeight + cm.display.barHeight + scrollGap(cm)) + "px";
	  }
	
	  // Re-align line numbers and gutter marks to compensate for
	  // horizontal scrolling.
	  function alignHorizontally(cm) {
	    var display = cm.display, view = display.view;
	    if (!display.alignWidgets && (!display.gutters.firstChild || !cm.options.fixedGutter)) { return }
	    var comp = compensateForHScroll(display) - display.scroller.scrollLeft + cm.doc.scrollLeft;
	    var gutterW = display.gutters.offsetWidth, left = comp + "px";
	    for (var i = 0; i < view.length; i++) { if (!view[i].hidden) {
	      if (cm.options.fixedGutter) {
	        if (view[i].gutter)
	          { view[i].gutter.style.left = left; }
	        if (view[i].gutterBackground)
	          { view[i].gutterBackground.style.left = left; }
	      }
	      var align = view[i].alignable;
	      if (align) { for (var j = 0; j < align.length; j++)
	        { align[j].style.left = left; } }
	    } }
	    if (cm.options.fixedGutter)
	      { display.gutters.style.left = (comp + gutterW) + "px"; }
	  }
	
	  // Used to ensure that the line number gutter is still the right
	  // size for the current document size. Returns true when an update
	  // is needed.
	  function maybeUpdateLineNumberWidth(cm) {
	    if (!cm.options.lineNumbers) { return false }
	    var doc = cm.doc, last = lineNumberFor(cm.options, doc.first + doc.size - 1), display = cm.display;
	    if (last.length != display.lineNumChars) {
	      var test = display.measure.appendChild(elt("div", [elt("div", last)],
	                                                 "CodeMirror-linenumber CodeMirror-gutter-elt"));
	      var innerW = test.firstChild.offsetWidth, padding = test.offsetWidth - innerW;
	      display.lineGutter.style.width = "";
	      display.lineNumInnerWidth = Math.max(innerW, display.lineGutter.offsetWidth - padding) + 1;
	      display.lineNumWidth = display.lineNumInnerWidth + padding;
	      display.lineNumChars = display.lineNumInnerWidth ? last.length : -1;
	      display.lineGutter.style.width = display.lineNumWidth + "px";
	      updateGutterSpace(cm.display);
	      return true
	    }
	    return false
	  }
	
	  function getGutters(gutters, lineNumbers) {
	    var result = [], sawLineNumbers = false;
	    for (var i = 0; i < gutters.length; i++) {
	      var name = gutters[i], style = null;
	      if (typeof name != "string") { style = name.style; name = name.className; }
	      if (name == "CodeMirror-linenumbers") {
	        if (!lineNumbers) { continue }
	        else { sawLineNumbers = true; }
	      }
	      result.push({className: name, style: style});
	    }
	    if (lineNumbers && !sawLineNumbers) { result.push({className: "CodeMirror-linenumbers", style: null}); }
	    return result
	  }
	
	  // Rebuild the gutter elements, ensure the margin to the left of the
	  // code matches their width.
	  function renderGutters(display) {
	    var gutters = display.gutters, specs = display.gutterSpecs;
	    removeChildren(gutters);
	    display.lineGutter = null;
	    for (var i = 0; i < specs.length; ++i) {
	      var ref = specs[i];
	      var className = ref.className;
	      var style = ref.style;
	      var gElt = gutters.appendChild(elt("div", null, "CodeMirror-gutter " + className));
	      if (style) { gElt.style.cssText = style; }
	      if (className == "CodeMirror-linenumbers") {
	        display.lineGutter = gElt;
	        gElt.style.width = (display.lineNumWidth || 1) + "px";
	      }
	    }
	    gutters.style.display = specs.length ? "" : "none";
	    updateGutterSpace(display);
	  }
	
	  function updateGutters(cm) {
	    renderGutters(cm.display);
	    regChange(cm);
	    alignHorizontally(cm);
	  }
	
	  // The display handles the DOM integration, both for input reading
	  // and content drawing. It holds references to DOM nodes and
	  // display-related state.
	
	  function Display(place, doc, input, options) {
	    var d = this;
	    this.input = input;
	
	    // Covers bottom-right square when both scrollbars are present.
	    d.scrollbarFiller = elt("div", null, "CodeMirror-scrollbar-filler");
	    d.scrollbarFiller.setAttribute("cm-not-content", "true");
	    // Covers bottom of gutter when coverGutterNextToScrollbar is on
	    // and h scrollbar is present.
	    d.gutterFiller = elt("div", null, "CodeMirror-gutter-filler");
	    d.gutterFiller.setAttribute("cm-not-content", "true");
	    // Will contain the actual code, positioned to cover the viewport.
	    d.lineDiv = eltP("div", null, "CodeMirror-code");
	    // Elements are added to these to represent selection and cursors.
	    d.selectionDiv = elt("div", null, null, "position: relative; z-index: 1");
	    d.cursorDiv = elt("div", null, "CodeMirror-cursors");
	    // A visibility: hidden element used to find the size of things.
	    d.measure = elt("div", null, "CodeMirror-measure");
	    // When lines outside of the viewport are measured, they are drawn in this.
	    d.lineMeasure = elt("div", null, "CodeMirror-measure");
	    // Wraps everything that needs to exist inside the vertically-padded coordinate system
	    d.lineSpace = eltP("div", [d.measure, d.lineMeasure, d.selectionDiv, d.cursorDiv, d.lineDiv],
	                      null, "position: relative; outline: none");
	    var lines = eltP("div", [d.lineSpace], "CodeMirror-lines");
	    // Moved around its parent to cover visible view.
	    d.mover = elt("div", [lines], null, "position: relative");
	    // Set to the height of the document, allowing scrolling.
	    d.sizer = elt("div", [d.mover], "CodeMirror-sizer");
	    d.sizerWidth = null;
	    // Behavior of elts with overflow: auto and padding is
	    // inconsistent across browsers. This is used to ensure the
	    // scrollable area is big enough.
	    d.heightForcer = elt("div", null, null, "position: absolute; height: " + scrollerGap + "px; width: 1px;");
	    // Will contain the gutters, if any.
	    d.gutters = elt("div", null, "CodeMirror-gutters");
	    d.lineGutter = null;
	    // Actual scrollable element.
	    d.scroller = elt("div", [d.sizer, d.heightForcer, d.gutters], "CodeMirror-scroll");
	    d.scroller.setAttribute("tabIndex", "-1");
	    // The element in which the editor lives.
	    d.wrapper = elt("div", [d.scrollbarFiller, d.gutterFiller, d.scroller], "CodeMirror");
	
	    // Work around IE7 z-index bug (not perfect, hence IE7 not really being supported)
	    if (ie && ie_version < 8) { d.gutters.style.zIndex = -1; d.scroller.style.paddingRight = 0; }
	    if (!webkit && !(gecko && mobile)) { d.scroller.draggable = true; }
	
	    if (place) {
	      if (place.appendChild) { place.appendChild(d.wrapper); }
	      else { place(d.wrapper); }
	    }
	
	    // Current rendered range (may be bigger than the view window).
	    d.viewFrom = d.viewTo = doc.first;
	    d.reportedViewFrom = d.reportedViewTo = doc.first;
	    // Information about the rendered lines.
	    d.view = [];
	    d.renderedView = null;
	    // Holds info about a single rendered line when it was rendered
	    // for measurement, while not in view.
	    d.externalMeasured = null;
	    // Empty space (in pixels) above the view
	    d.viewOffset = 0;
	    d.lastWrapHeight = d.lastWrapWidth = 0;
	    d.updateLineNumbers = null;
	
	    d.nativeBarWidth = d.barHeight = d.barWidth = 0;
	    d.scrollbarsClipped = false;
	
	    // Used to only resize the line number gutter when necessary (when
	    // the amount of lines crosses a boundary that makes its width change)
	    d.lineNumWidth = d.lineNumInnerWidth = d.lineNumChars = null;
	    // Set to true when a non-horizontal-scrolling line widget is
	    // added. As an optimization, line widget aligning is skipped when
	    // this is false.
	    d.alignWidgets = false;
	
	    d.cachedCharWidth = d.cachedTextHeight = d.cachedPaddingH = null;
	
	    // Tracks the maximum line length so that the horizontal scrollbar
	    // can be kept static when scrolling.
	    d.maxLine = null;
	    d.maxLineLength = 0;
	    d.maxLineChanged = false;
	
	    // Used for measuring wheel scrolling granularity
	    d.wheelDX = d.wheelDY = d.wheelStartX = d.wheelStartY = null;
	
	    // True when shift is held down.
	    d.shift = false;
	
	    // Used to track whether anything happened since the context menu
	    // was opened.
	    d.selForContextMenu = null;
	
	    d.activeTouch = null;
	
	    d.gutterSpecs = getGutters(options.gutters, options.lineNumbers);
	    renderGutters(d);
	
	    input.init(d);
	  }
	
	  // Since the delta values reported on mouse wheel events are
	  // unstandardized between browsers and even browser versions, and
	  // generally horribly unpredictable, this code starts by measuring
	  // the scroll effect that the first few mouse wheel events have,
	  // and, from that, detects the way it can convert deltas to pixel
	  // offsets afterwards.
	  //
	  // The reason we want to know the amount a wheel event will scroll
	  // is that it gives us a chance to update the display before the
	  // actual scrolling happens, reducing flickering.
	
	  var wheelSamples = 0, wheelPixelsPerUnit = null;
	  // Fill in a browser-detected starting value on browsers where we
	  // know one. These don't have to be accurate -- the result of them
	  // being wrong would just be a slight flicker on the first wheel
	  // scroll (if it is large enough).
	  if (ie) { wheelPixelsPerUnit = -.53; }
	  else if (gecko) { wheelPixelsPerUnit = 15; }
	  else if (chrome) { wheelPixelsPerUnit = -.7; }
	  else if (safari) { wheelPixelsPerUnit = -1/3; }
	
	  function wheelEventDelta(e) {
	    var dx = e.wheelDeltaX, dy = e.wheelDeltaY;
	    if (dx == null && e.detail && e.axis == e.HORIZONTAL_AXIS) { dx = e.detail; }
	    if (dy == null && e.detail && e.axis == e.VERTICAL_AXIS) { dy = e.detail; }
	    else if (dy == null) { dy = e.wheelDelta; }
	    return {x: dx, y: dy}
	  }
	  function wheelEventPixels(e) {
	    var delta = wheelEventDelta(e);
	    delta.x *= wheelPixelsPerUnit;
	    delta.y *= wheelPixelsPerUnit;
	    return delta
	  }
	
	  function onScrollWheel(cm, e) {
	    var delta = wheelEventDelta(e), dx = delta.x, dy = delta.y;
	
	    var display = cm.display, scroll = display.scroller;
	    // Quit if there's nothing to scroll here
	    var canScrollX = scroll.scrollWidth > scroll.clientWidth;
	    var canScrollY = scroll.scrollHeight > scroll.clientHeight;
	    if (!(dx && canScrollX || dy && canScrollY)) { return }
	
	    // Webkit browsers on OS X abort momentum scrolls when the target
	    // of the scroll event is removed from the scrollable element.
	    // This hack (see related code in patchDisplay) makes sure the
	    // element is kept around.
	    if (dy && mac && webkit) {
	      outer: for (var cur = e.target, view = display.view; cur != scroll; cur = cur.parentNode) {
	        for (var i = 0; i < view.length; i++) {
	          if (view[i].node == cur) {
	            cm.display.currentWheelTarget = cur;
	            break outer
	          }
	        }
	      }
	    }
	
	    // On some browsers, horizontal scrolling will cause redraws to
	    // happen before the gutter has been realigned, causing it to
	    // wriggle around in a most unseemly way. When we have an
	    // estimated pixels/delta value, we just handle horizontal
	    // scrolling entirely here. It'll be slightly off from native, but
	    // better than glitching out.
	    if (dx && !gecko && !presto && wheelPixelsPerUnit != null) {
	      if (dy && canScrollY)
	        { updateScrollTop(cm, Math.max(0, scroll.scrollTop + dy * wheelPixelsPerUnit)); }
	      setScrollLeft(cm, Math.max(0, scroll.scrollLeft + dx * wheelPixelsPerUnit));
	      // Only prevent default scrolling if vertical scrolling is
	      // actually possible. Otherwise, it causes vertical scroll
	      // jitter on OSX trackpads when deltaX is small and deltaY
	      // is large (issue #3579)
	      if (!dy || (dy && canScrollY))
	        { e_preventDefault(e); }
	      display.wheelStartX = null; // Abort measurement, if in progress
	      return
	    }
	
	    // 'Project' the visible viewport to cover the area that is being
	    // scrolled into view (if we know enough to estimate it).
	    if (dy && wheelPixelsPerUnit != null) {
	      var pixels = dy * wheelPixelsPerUnit;
	      var top = cm.doc.scrollTop, bot = top + display.wrapper.clientHeight;
	      if (pixels < 0) { top = Math.max(0, top + pixels - 50); }
	      else { bot = Math.min(cm.doc.height, bot + pixels + 50); }
	      updateDisplaySimple(cm, {top: top, bottom: bot});
	    }
	
	    if (wheelSamples < 20) {
	      if (display.wheelStartX == null) {
	        display.wheelStartX = scroll.scrollLeft; display.wheelStartY = scroll.scrollTop;
	        display.wheelDX = dx; display.wheelDY = dy;
	        setTimeout(function () {
	          if (display.wheelStartX == null) { return }
	          var movedX = scroll.scrollLeft - display.wheelStartX;
	          var movedY = scroll.scrollTop - display.wheelStartY;
	          var sample = (movedY && display.wheelDY && movedY / display.wheelDY) ||
	            (movedX && display.wheelDX && movedX / display.wheelDX);
	          display.wheelStartX = display.wheelStartY = null;
	          if (!sample) { return }
	          wheelPixelsPerUnit = (wheelPixelsPerUnit * wheelSamples + sample) / (wheelSamples + 1);
	          ++wheelSamples;
	        }, 200);
	      } else {
	        display.wheelDX += dx; display.wheelDY += dy;
	      }
	    }
	  }
	
	  // Selection objects are immutable. A new one is created every time
	  // the selection changes. A selection is one or more non-overlapping
	  // (and non-touching) ranges, sorted, and an integer that indicates
	  // which one is the primary selection (the one that's scrolled into
	  // view, that getCursor returns, etc).
	  var Selection = function(ranges, primIndex) {
	    this.ranges = ranges;
	    this.primIndex = primIndex;
	  };
	
	  Selection.prototype.primary = function () { return this.ranges[this.primIndex] };
	
	  Selection.prototype.equals = function (other) {
	    if (other == this) { return true }
	    if (other.primIndex != this.primIndex || other.ranges.length != this.ranges.length) { return false }
	    for (var i = 0; i < this.ranges.length; i++) {
	      var here = this.ranges[i], there = other.ranges[i];
	      if (!equalCursorPos(here.anchor, there.anchor) || !equalCursorPos(here.head, there.head)) { return false }
	    }
	    return true
	  };
	
	  Selection.prototype.deepCopy = function () {
	    var out = [];
	    for (var i = 0; i < this.ranges.length; i++)
	      { out[i] = new Range(copyPos(this.ranges[i].anchor), copyPos(this.ranges[i].head)); }
	    return new Selection(out, this.primIndex)
	  };
	
	  Selection.prototype.somethingSelected = function () {
	    for (var i = 0; i < this.ranges.length; i++)
	      { if (!this.ranges[i].empty()) { return true } }
	    return false
	  };
	
	  Selection.prototype.contains = function (pos, end) {
	    if (!end) { end = pos; }
	    for (var i = 0; i < this.ranges.length; i++) {
	      var range = this.ranges[i];
	      if (cmp(end, range.from()) >= 0 && cmp(pos, range.to()) <= 0)
	        { return i }
	    }
	    return -1
	  };
	
	  var Range = function(anchor, head) {
	    this.anchor = anchor; this.head = head;
	  };
	
	  Range.prototype.from = function () { return minPos(this.anchor, this.head) };
	  Range.prototype.to = function () { return maxPos(this.anchor, this.head) };
	  Range.prototype.empty = function () { return this.head.line == this.anchor.line && this.head.ch == this.anchor.ch };
	
	  // Take an unsorted, potentially overlapping set of ranges, and
	  // build a selection out of it. 'Consumes' ranges array (modifying
	  // it).
	  function normalizeSelection(cm, ranges, primIndex) {
	    var mayTouch = cm && cm.options.selectionsMayTouch;
	    var prim = ranges[primIndex];
	    ranges.sort(function (a, b) { return cmp(a.from(), b.from()); });
	    primIndex = indexOf(ranges, prim);
	    for (var i = 1; i < ranges.length; i++) {
	      var cur = ranges[i], prev = ranges[i - 1];
	      var diff = cmp(prev.to(), cur.from());
	      if (mayTouch && !cur.empty() ? diff > 0 : diff >= 0) {
	        var from = minPos(prev.from(), cur.from()), to = maxPos(prev.to(), cur.to());
	        var inv = prev.empty() ? cur.from() == cur.head : prev.from() == prev.head;
	        if (i <= primIndex) { --primIndex; }
	        ranges.splice(--i, 2, new Range(inv ? to : from, inv ? from : to));
	      }
	    }
	    return new Selection(ranges, primIndex)
	  }
	
	  function simpleSelection(anchor, head) {
	    return new Selection([new Range(anchor, head || anchor)], 0)
	  }
	
	  // Compute the position of the end of a change (its 'to' property
	  // refers to the pre-change end).
	  function changeEnd(change) {
	    if (!change.text) { return change.to }
	    return Pos(change.from.line + change.text.length - 1,
	               lst(change.text).length + (change.text.length == 1 ? change.from.ch : 0))
	  }
	
	  // Adjust a position to refer to the post-change position of the
	  // same text, or the end of the change if the change covers it.
	  function adjustForChange(pos, change) {
	    if (cmp(pos, change.from) < 0) { return pos }
	    if (cmp(pos, change.to) <= 0) { return changeEnd(change) }
	
	    var line = pos.line + change.text.length - (change.to.line - change.from.line) - 1, ch = pos.ch;
	    if (pos.line == change.to.line) { ch += changeEnd(change).ch - change.to.ch; }
	    return Pos(line, ch)
	  }
	
	  function computeSelAfterChange(doc, change) {
	    var out = [];
	    for (var i = 0; i < doc.sel.ranges.length; i++) {
	      var range = doc.sel.ranges[i];
	      out.push(new Range(adjustForChange(range.anchor, change),
	                         adjustForChange(range.head, change)));
	    }
	    return normalizeSelection(doc.cm, out, doc.sel.primIndex)
	  }
	
	  function offsetPos(pos, old, nw) {
	    if (pos.line == old.line)
	      { return Pos(nw.line, pos.ch - old.ch + nw.ch) }
	    else
	      { return Pos(nw.line + (pos.line - old.line), pos.ch) }
	  }
	
	  // Used by replaceSelections to allow moving the selection to the
	  // start or around the replaced test. Hint may be "start" or "around".
	  function computeReplacedSel(doc, changes, hint) {
	    var out = [];
	    var oldPrev = Pos(doc.first, 0), newPrev = oldPrev;
	    for (var i = 0; i < changes.length; i++) {
	      var change = changes[i];
	      var from = offsetPos(change.from, oldPrev, newPrev);
	      var to = offsetPos(changeEnd(change), oldPrev, newPrev);
	      oldPrev = change.to;
	      newPrev = to;
	      if (hint == "around") {
	        var range = doc.sel.ranges[i], inv = cmp(range.head, range.anchor) < 0;
	        out[i] = new Range(inv ? to : from, inv ? from : to);
	      } else {
	        out[i] = new Range(from, from);
	      }
	    }
	    return new Selection(out, doc.sel.primIndex)
	  }
	
	  // Used to get the editor into a consistent state again when options change.
	
	  function loadMode(cm) {
	    cm.doc.mode = getMode(cm.options, cm.doc.modeOption);
	    resetModeState(cm);
	  }
	
	  function resetModeState(cm) {
	    cm.doc.iter(function (line) {
	      if (line.stateAfter) { line.stateAfter = null; }
	      if (line.styles) { line.styles = null; }
	    });
	    cm.doc.modeFrontier = cm.doc.highlightFrontier = cm.doc.first;
	    startWorker(cm, 100);
	    cm.state.modeGen++;
	    if (cm.curOp) { regChange(cm); }
	  }
	
	  // DOCUMENT DATA STRUCTURE
	
	  // By default, updates that start and end at the beginning of a line
	  // are treated specially, in order to make the association of line
	  // widgets and marker elements with the text behave more intuitive.
	  function isWholeLineUpdate(doc, change) {
	    return change.from.ch == 0 && change.to.ch == 0 && lst(change.text) == "" &&
	      (!doc.cm || doc.cm.options.wholeLineUpdateBefore)
	  }
	
	  // Perform a change on the document data structure.
	  function updateDoc(doc, change, markedSpans, estimateHeight) {
	    function spansFor(n) {return markedSpans ? markedSpans[n] : null}
	    function update(line, text, spans) {
	      updateLine(line, text, spans, estimateHeight);
	      signalLater(line, "change", line, change);
	    }
	    function linesFor(start, end) {
	      var result = [];
	      for (var i = start; i < end; ++i)
	        { result.push(new Line(text[i], spansFor(i), estimateHeight)); }
	      return result
	    }
	
	    var from = change.from, to = change.to, text = change.text;
	    var firstLine = getLine(doc, from.line), lastLine = getLine(doc, to.line);
	    var lastText = lst(text), lastSpans = spansFor(text.length - 1), nlines = to.line - from.line;
	
	    // Adjust the line structure
	    if (change.full) {
	      doc.insert(0, linesFor(0, text.length));
	      doc.remove(text.length, doc.size - text.length);
	    } else if (isWholeLineUpdate(doc, change)) {
	      // This is a whole-line replace. Treated specially to make
	      // sure line objects move the way they are supposed to.
	      var added = linesFor(0, text.length - 1);
	      update(lastLine, lastLine.text, lastSpans);
	      if (nlines) { doc.remove(from.line, nlines); }
	      if (added.length) { doc.insert(from.line, added); }
	    } else if (firstLine == lastLine) {
	      if (text.length == 1) {
	        update(firstLine, firstLine.text.slice(0, from.ch) + lastText + firstLine.text.slice(to.ch), lastSpans);
	      } else {
	        var added$1 = linesFor(1, text.length - 1);
	        added$1.push(new Line(lastText + firstLine.text.slice(to.ch), lastSpans, estimateHeight));
	        update(firstLine, firstLine.text.slice(0, from.ch) + text[0], spansFor(0));
	        doc.insert(from.line + 1, added$1);
	      }
	    } else if (text.length == 1) {
	      update(firstLine, firstLine.text.slice(0, from.ch) + text[0] + lastLine.text.slice(to.ch), spansFor(0));
	      doc.remove(from.line + 1, nlines);
	    } else {
	      update(firstLine, firstLine.text.slice(0, from.ch) + text[0], spansFor(0));
	      update(lastLine, lastText + lastLine.text.slice(to.ch), lastSpans);
	      var added$2 = linesFor(1, text.length - 1);
	      if (nlines > 1) { doc.remove(from.line + 1, nlines - 1); }
	      doc.insert(from.line + 1, added$2);
	    }
	
	    signalLater(doc, "change", doc, change);
	  }
	
	  // Call f for all linked documents.
	  function linkedDocs(doc, f, sharedHistOnly) {
	    function propagate(doc, skip, sharedHist) {
	      if (doc.linked) { for (var i = 0; i < doc.linked.length; ++i) {
	        var rel = doc.linked[i];
	        if (rel.doc == skip) { continue }
	        var shared = sharedHist && rel.sharedHist;
	        if (sharedHistOnly && !shared) { continue }
	        f(rel.doc, shared);
	        propagate(rel.doc, doc, shared);
	      } }
	    }
	    propagate(doc, null, true);
	  }
	
	  // Attach a document to an editor.
	  function attachDoc(cm, doc) {
	    if (doc.cm) { throw new Error("This document is already in use.") }
	    cm.doc = doc;
	    doc.cm = cm;
	    estimateLineHeights(cm);
	    loadMode(cm);
	    setDirectionClass(cm);
	    if (!cm.options.lineWrapping) { findMaxLine(cm); }
	    cm.options.mode = doc.modeOption;
	    regChange(cm);
	  }
	
	  function setDirectionClass(cm) {
	  (cm.doc.direction == "rtl" ? addClass : rmClass)(cm.display.lineDiv, "CodeMirror-rtl");
	  }
	
	  function directionChanged(cm) {
	    runInOp(cm, function () {
	      setDirectionClass(cm);
	      regChange(cm);
	    });
	  }
	
	  function History(startGen) {
	    // Arrays of change events and selections. Doing something adds an
	    // event to done and clears undo. Undoing moves events from done
	    // to undone, redoing moves them in the other direction.
	    this.done = []; this.undone = [];
	    this.undoDepth = Infinity;
	    // Used to track when changes can be merged into a single undo
	    // event
	    this.lastModTime = this.lastSelTime = 0;
	    this.lastOp = this.lastSelOp = null;
	    this.lastOrigin = this.lastSelOrigin = null;
	    // Used by the isClean() method
	    this.generation = this.maxGeneration = startGen || 1;
	  }
	
	  // Create a history change event from an updateDoc-style change
	  // object.
	  function historyChangeFromChange(doc, change) {
	    var histChange = {from: copyPos(change.from), to: changeEnd(change), text: getBetween(doc, change.from, change.to)};
	    attachLocalSpans(doc, histChange, change.from.line, change.to.line + 1);
	    linkedDocs(doc, function (doc) { return attachLocalSpans(doc, histChange, change.from.line, change.to.line + 1); }, true);
	    return histChange
	  }
	
	  // Pop all selection events off the end of a history array. Stop at
	  // a change event.
	  function clearSelectionEvents(array) {
	    while (array.length) {
	      var last = lst(array);
	      if (last.ranges) { array.pop(); }
	      else { break }
	    }
	  }
	
	  // Find the top change event in the history. Pop off selection
	  // events that are in the way.
	  function lastChangeEvent(hist, force) {
	    if (force) {
	      clearSelectionEvents(hist.done);
	      return lst(hist.done)
	    } else if (hist.done.length && !lst(hist.done).ranges) {
	      return lst(hist.done)
	    } else if (hist.done.length > 1 && !hist.done[hist.done.length - 2].ranges) {
	      hist.done.pop();
	      return lst(hist.done)
	    }
	  }
	
	  // Register a change in the history. Merges changes that are within
	  // a single operation, or are close together with an origin that
	  // allows merging (starting with "+") into a single event.
	  function addChangeToHistory(doc, change, selAfter, opId) {
	    var hist = doc.history;
	    hist.undone.length = 0;
	    var time = +new Date, cur;
	    var last;
	
	    if ((hist.lastOp == opId ||
	         hist.lastOrigin == change.origin && change.origin &&
	         ((change.origin.charAt(0) == "+" && hist.lastModTime > time - (doc.cm ? doc.cm.options.historyEventDelay : 500)) ||
	          change.origin.charAt(0) == "*")) &&
	        (cur = lastChangeEvent(hist, hist.lastOp == opId))) {
	      // Merge this change into the last event
	      last = lst(cur.changes);
	      if (cmp(change.from, change.to) == 0 && cmp(change.from, last.to) == 0) {
	        // Optimized case for simple insertion -- don't want to add
	        // new changesets for every character typed
	        last.to = changeEnd(change);
	      } else {
	        // Add new sub-event
	        cur.changes.push(historyChangeFromChange(doc, change));
	      }
	    } else {
	      // Can not be merged, start a new event.
	      var before = lst(hist.done);
	      if (!before || !before.ranges)
	        { pushSelectionToHistory(doc.sel, hist.done); }
	      cur = {changes: [historyChangeFromChange(doc, change)],
	             generation: hist.generation};
	      hist.done.push(cur);
	      while (hist.done.length > hist.undoDepth) {
	        hist.done.shift();
	        if (!hist.done[0].ranges) { hist.done.shift(); }
	      }
	    }
	    hist.done.push(selAfter);
	    hist.generation = ++hist.maxGeneration;
	    hist.lastModTime = hist.lastSelTime = time;
	    hist.lastOp = hist.lastSelOp = opId;
	    hist.lastOrigin = hist.lastSelOrigin = change.origin;
	
	    if (!last) { signal(doc, "historyAdded"); }
	  }
	
	  function selectionEventCanBeMerged(doc, origin, prev, sel) {
	    var ch = origin.charAt(0);
	    return ch == "*" ||
	      ch == "+" &&
	      prev.ranges.length == sel.ranges.length &&
	      prev.somethingSelected() == sel.somethingSelected() &&
	      new Date - doc.history.lastSelTime <= (doc.cm ? doc.cm.options.historyEventDelay : 500)
	  }
	
	  // Called whenever the selection changes, sets the new selection as
	  // the pending selection in the history, and pushes the old pending
	  // selection into the 'done' array when it was significantly
	  // different (in number of selected ranges, emptiness, or time).
	  function addSelectionToHistory(doc, sel, opId, options) {
	    var hist = doc.history, origin = options && options.origin;
	
	    // A new event is started when the previous origin does not match
	    // the current, or the origins don't allow matching. Origins
	    // starting with * are always merged, those starting with + are
	    // merged when similar and close together in time.
	    if (opId == hist.lastSelOp ||
	        (origin && hist.lastSelOrigin == origin &&
	         (hist.lastModTime == hist.lastSelTime && hist.lastOrigin == origin ||
	          selectionEventCanBeMerged(doc, origin, lst(hist.done), sel))))
	      { hist.done[hist.done.length - 1] = sel; }
	    else
	      { pushSelectionToHistory(sel, hist.done); }
	
	    hist.lastSelTime = +new Date;
	    hist.lastSelOrigin = origin;
	    hist.lastSelOp = opId;
	    if (options && options.clearRedo !== false)
	      { clearSelectionEvents(hist.undone); }
	  }
	
	  function pushSelectionToHistory(sel, dest) {
	    var top = lst(dest);
	    if (!(top && top.ranges && top.equals(sel)))
	      { dest.push(sel); }
	  }
	
	  // Used to store marked span information in the history.
	  function attachLocalSpans(doc, change, from, to) {
	    var existing = change["spans_" + doc.id], n = 0;
	    doc.iter(Math.max(doc.first, from), Math.min(doc.first + doc.size, to), function (line) {
	      if (line.markedSpans)
	        { (existing || (existing = change["spans_" + doc.id] = {}))[n] = line.markedSpans; }
	      ++n;
	    });
	  }
	
	  // When un/re-doing restores text containing marked spans, those
	  // that have been explicitly cleared should not be restored.
	  function removeClearedSpans(spans) {
	    if (!spans) { return null }
	    var out;
	    for (var i = 0; i < spans.length; ++i) {
	      if (spans[i].marker.explicitlyCleared) { if (!out) { out = spans.slice(0, i); } }
	      else if (out) { out.push(spans[i]); }
	    }
	    return !out ? spans : out.length ? out : null
	  }
	
	  // Retrieve and filter the old marked spans stored in a change event.
	  function getOldSpans(doc, change) {
	    var found = change["spans_" + doc.id];
	    if (!found) { return null }
	    var nw = [];
	    for (var i = 0; i < change.text.length; ++i)
	      { nw.push(removeClearedSpans(found[i])); }
	    return nw
	  }
	
	  // Used for un/re-doing changes from the history. Combines the
	  // result of computing the existing spans with the set of spans that
	  // existed in the history (so that deleting around a span and then
	  // undoing brings back the span).
	  function mergeOldSpans(doc, change) {
	    var old = getOldSpans(doc, change);
	    var stretched = stretchSpansOverChange(doc, change);
	    if (!old) { return stretched }
	    if (!stretched) { return old }
	
	    for (var i = 0; i < old.length; ++i) {
	      var oldCur = old[i], stretchCur = stretched[i];
	      if (oldCur && stretchCur) {
	        spans: for (var j = 0; j < stretchCur.length; ++j) {
	          var span = stretchCur[j];
	          for (var k = 0; k < oldCur.length; ++k)
	            { if (oldCur[k].marker == span.marker) { continue spans } }
	          oldCur.push(span);
	        }
	      } else if (stretchCur) {
	        old[i] = stretchCur;
	      }
	    }
	    return old
	  }
	
	  // Used both to provide a JSON-safe object in .getHistory, and, when
	  // detaching a document, to split the history in two
	  function copyHistoryArray(events, newGroup, instantiateSel) {
	    var copy = [];
	    for (var i = 0; i < events.length; ++i) {
	      var event = events[i];
	      if (event.ranges) {
	        copy.push(instantiateSel ? Selection.prototype.deepCopy.call(event) : event);
	        continue
	      }
	      var changes = event.changes, newChanges = [];
	      copy.push({changes: newChanges});
	      for (var j = 0; j < changes.length; ++j) {
	        var change = changes[j], m = (void 0);
	        newChanges.push({from: change.from, to: change.to, text: change.text});
	        if (newGroup) { for (var prop in change) { if (m = prop.match(/^spans_(\d+)$/)) {
	          if (indexOf(newGroup, Number(m[1])) > -1) {
	            lst(newChanges)[prop] = change[prop];
	            delete change[prop];
	          }
	        } } }
	      }
	    }
	    return copy
	  }
	
	  // The 'scroll' parameter given to many of these indicated whether
	  // the new cursor position should be scrolled into view after
	  // modifying the selection.
	
	  // If shift is held or the extend flag is set, extends a range to
	  // include a given position (and optionally a second position).
	  // Otherwise, simply returns the range between the given positions.
	  // Used for cursor motion and such.
	  function extendRange(range, head, other, extend) {
	    if (extend) {
	      var anchor = range.anchor;
	      if (other) {
	        var posBefore = cmp(head, anchor) < 0;
	        if (posBefore != (cmp(other, anchor) < 0)) {
	          anchor = head;
	          head = other;
	        } else if (posBefore != (cmp(head, other) < 0)) {
	          head = other;
	        }
	      }
	      return new Range(anchor, head)
	    } else {
	      return new Range(other || head, head)
	    }
	  }
	
	  // Extend the primary selection range, discard the rest.
	  function extendSelection(doc, head, other, options, extend) {
	    if (extend == null) { extend = doc.cm && (doc.cm.display.shift || doc.extend); }
	    setSelection(doc, new Selection([extendRange(doc.sel.primary(), head, other, extend)], 0), options);
	  }
	
	  // Extend all selections (pos is an array of selections with length
	  // equal the number of selections)
	  function extendSelections(doc, heads, options) {
	    var out = [];
	    var extend = doc.cm && (doc.cm.display.shift || doc.extend);
	    for (var i = 0; i < doc.sel.ranges.length; i++)
	      { out[i] = extendRange(doc.sel.ranges[i], heads[i], null, extend); }
	    var newSel = normalizeSelection(doc.cm, out, doc.sel.primIndex);
	    setSelection(doc, newSel, options);
	  }
	
	  // Updates a single range in the selection.
	  function replaceOneSelection(doc, i, range, options) {
	    var ranges = doc.sel.ranges.slice(0);
	    ranges[i] = range;
	    setSelection(doc, normalizeSelection(doc.cm, ranges, doc.sel.primIndex), options);
	  }
	
	  // Reset the selection to a single range.
	  function setSimpleSelection(doc, anchor, head, options) {
	    setSelection(doc, simpleSelection(anchor, head), options);
	  }
	
	  // Give beforeSelectionChange handlers a change to influence a
	  // selection update.
	  function filterSelectionChange(doc, sel, options) {
	    var obj = {
	      ranges: sel.ranges,
	      update: function(ranges) {
	        this.ranges = [];
	        for (var i = 0; i < ranges.length; i++)
	          { this.ranges[i] = new Range(clipPos(doc, ranges[i].anchor),
	                                     clipPos(doc, ranges[i].head)); }
	      },
	      origin: options && options.origin
	    };
	    signal(doc, "beforeSelectionChange", doc, obj);
	    if (doc.cm) { signal(doc.cm, "beforeSelectionChange", doc.cm, obj); }
	    if (obj.ranges != sel.ranges) { return normalizeSelection(doc.cm, obj.ranges, obj.ranges.length - 1) }
	    else { return sel }
	  }
	
	  function setSelectionReplaceHistory(doc, sel, options) {
	    var done = doc.history.done, last = lst(done);
	    if (last && last.ranges) {
	      done[done.length - 1] = sel;
	      setSelectionNoUndo(doc, sel, options);
	    } else {
	      setSelection(doc, sel, options);
	    }
	  }
	
	  // Set a new selection.
	  function setSelection(doc, sel, options) {
	    setSelectionNoUndo(doc, sel, options);
	    addSelectionToHistory(doc, doc.sel, doc.cm ? doc.cm.curOp.id : NaN, options);
	  }
	
	  function setSelectionNoUndo(doc, sel, options) {
	    if (hasHandler(doc, "beforeSelectionChange") || doc.cm && hasHandler(doc.cm, "beforeSelectionChange"))
	      { sel = filterSelectionChange(doc, sel, options); }
	
	    var bias = options && options.bias ||
	      (cmp(sel.primary().head, doc.sel.primary().head) < 0 ? -1 : 1);
	    setSelectionInner(doc, skipAtomicInSelection(doc, sel, bias, true));
	
	    if (!(options && options.scroll === false) && doc.cm)
	      { ensureCursorVisible(doc.cm); }
	  }
	
	  function setSelectionInner(doc, sel) {
	    if (sel.equals(doc.sel)) { return }
	
	    doc.sel = sel;
	
	    if (doc.cm) {
	      doc.cm.curOp.updateInput = 1;
	      doc.cm.curOp.selectionChanged = true;
	      signalCursorActivity(doc.cm);
	    }
	    signalLater(doc, "cursorActivity", doc);
	  }
	
	  // Verify that the selection does not partially select any atomic
	  // marked ranges.
	  function reCheckSelection(doc) {
	    setSelectionInner(doc, skipAtomicInSelection(doc, doc.sel, null, false));
	  }
	
	  // Return a selection that does not partially select any atomic
	  // ranges.
	  function skipAtomicInSelection(doc, sel, bias, mayClear) {
	    var out;
	    for (var i = 0; i < sel.ranges.length; i++) {
	      var range = sel.ranges[i];
	      var old = sel.ranges.length == doc.sel.ranges.length && doc.sel.ranges[i];
	      var newAnchor = skipAtomic(doc, range.anchor, old && old.anchor, bias, mayClear);
	      var newHead = skipAtomic(doc, range.head, old && old.head, bias, mayClear);
	      if (out || newAnchor != range.anchor || newHead != range.head) {
	        if (!out) { out = sel.ranges.slice(0, i); }
	        out[i] = new Range(newAnchor, newHead);
	      }
	    }
	    return out ? normalizeSelection(doc.cm, out, sel.primIndex) : sel
	  }
	
	  function skipAtomicInner(doc, pos, oldPos, dir, mayClear) {
	    var line = getLine(doc, pos.line);
	    if (line.markedSpans) { for (var i = 0; i < line.markedSpans.length; ++i) {
	      var sp = line.markedSpans[i], m = sp.marker;
	
	      // Determine if we should prevent the cursor being placed to the left/right of an atomic marker
	      // Historically this was determined using the inclusiveLeft/Right option, but the new way to control it
	      // is with selectLeft/Right
	      var preventCursorLeft = ("selectLeft" in m) ? !m.selectLeft : m.inclusiveLeft;
	      var preventCursorRight = ("selectRight" in m) ? !m.selectRight : m.inclusiveRight;
	
	      if ((sp.from == null || (preventCursorLeft ? sp.from <= pos.ch : sp.from < pos.ch)) &&
	          (sp.to == null || (preventCursorRight ? sp.to >= pos.ch : sp.to > pos.ch))) {
	        if (mayClear) {
	          signal(m, "beforeCursorEnter");
	          if (m.explicitlyCleared) {
	            if (!line.markedSpans) { break }
	            else {--i; continue}
	          }
	        }
	        if (!m.atomic) { continue }
	
	        if (oldPos) {
	          var near = m.find(dir < 0 ? 1 : -1), diff = (void 0);
	          if (dir < 0 ? preventCursorRight : preventCursorLeft)
	            { near = movePos(doc, near, -dir, near && near.line == pos.line ? line : null); }
	          if (near && near.line == pos.line && (diff = cmp(near, oldPos)) && (dir < 0 ? diff < 0 : diff > 0))
	            { return skipAtomicInner(doc, near, pos, dir, mayClear) }
	        }
	
	        var far = m.find(dir < 0 ? -1 : 1);
	        if (dir < 0 ? preventCursorLeft : preventCursorRight)
	          { far = movePos(doc, far, dir, far.line == pos.line ? line : null); }
	        return far ? skipAtomicInner(doc, far, pos, dir, mayClear) : null
	      }
	    } }
	    return pos
	  }
	
	  // Ensure a given position is not inside an atomic range.
	  function skipAtomic(doc, pos, oldPos, bias, mayClear) {
	    var dir = bias || 1;
	    var found = skipAtomicInner(doc, pos, oldPos, dir, mayClear) ||
	        (!mayClear && skipAtomicInner(doc, pos, oldPos, dir, true)) ||
	        skipAtomicInner(doc, pos, oldPos, -dir, mayClear) ||
	        (!mayClear && skipAtomicInner(doc, pos, oldPos, -dir, true));
	    if (!found) {
	      doc.cantEdit = true;
	      return Pos(doc.first, 0)
	    }
	    return found
	  }
	
	  function movePos(doc, pos, dir, line) {
	    if (dir < 0 && pos.ch == 0) {
	      if (pos.line > doc.first) { return clipPos(doc, Pos(pos.line - 1)) }
	      else { return null }
	    } else if (dir > 0 && pos.ch == (line || getLine(doc, pos.line)).text.length) {
	      if (pos.line < doc.first + doc.size - 1) { return Pos(pos.line + 1, 0) }
	      else { return null }
	    } else {
	      return new Pos(pos.line, pos.ch + dir)
	    }
	  }
	
	  function selectAll(cm) {
	    cm.setSelection(Pos(cm.firstLine(), 0), Pos(cm.lastLine()), sel_dontScroll);
	  }
	
	  // UPDATING
	
	  // Allow "beforeChange" event handlers to influence a change
	  function filterChange(doc, change, update) {
	    var obj = {
	      canceled: false,
	      from: change.from,
	      to: change.to,
	      text: change.text,
	      origin: change.origin,
	      cancel: function () { return obj.canceled = true; }
	    };
	    if (update) { obj.update = function (from, to, text, origin) {
	      if (from) { obj.from = clipPos(doc, from); }
	      if (to) { obj.to = clipPos(doc, to); }
	      if (text) { obj.text = text; }
	      if (origin !== undefined) { obj.origin = origin; }
	    }; }
	    signal(doc, "beforeChange", doc, obj);
	    if (doc.cm) { signal(doc.cm, "beforeChange", doc.cm, obj); }
	
	    if (obj.canceled) {
	      if (doc.cm) { doc.cm.curOp.updateInput = 2; }
	      return null
	    }
	    return {from: obj.from, to: obj.to, text: obj.text, origin: obj.origin}
	  }
	
	  // Apply a change to a document, and add it to the document's
	  // history, and propagating it to all linked documents.
	  function makeChange(doc, change, ignoreReadOnly) {
	    if (doc.cm) {
	      if (!doc.cm.curOp) { return operation(doc.cm, makeChange)(doc, change, ignoreReadOnly) }
	      if (doc.cm.state.suppressEdits) { return }
	    }
	
	    if (hasHandler(doc, "beforeChange") || doc.cm && hasHandler(doc.cm, "beforeChange")) {
	      change = filterChange(doc, change, true);
	      if (!change) { return }
	    }
	
	    // Possibly split or suppress the update based on the presence
	    // of read-only spans in its range.
	    var split = sawReadOnlySpans && !ignoreReadOnly && removeReadOnlyRanges(doc, change.from, change.to);
	    if (split) {
	      for (var i = split.length - 1; i >= 0; --i)
	        { makeChangeInner(doc, {from: split[i].from, to: split[i].to, text: i ? [""] : change.text, origin: change.origin}); }
	    } else {
	      makeChangeInner(doc, change);
	    }
	  }
	
	  function makeChangeInner(doc, change) {
	    if (change.text.length == 1 && change.text[0] == "" && cmp(change.from, change.to) == 0) { return }
	    var selAfter = computeSelAfterChange(doc, change);
	    addChangeToHistory(doc, change, selAfter, doc.cm ? doc.cm.curOp.id : NaN);
	
	    makeChangeSingleDoc(doc, change, selAfter, stretchSpansOverChange(doc, change));
	    var rebased = [];
	
	    linkedDocs(doc, function (doc, sharedHist) {
	      if (!sharedHist && indexOf(rebased, doc.history) == -1) {
	        rebaseHist(doc.history, change);
	        rebased.push(doc.history);
	      }
	      makeChangeSingleDoc(doc, change, null, stretchSpansOverChange(doc, change));
	    });
	  }
	
	  // Revert a change stored in a document's history.
	  function makeChangeFromHistory(doc, type, allowSelectionOnly) {
	    var suppress = doc.cm && doc.cm.state.suppressEdits;
	    if (suppress && !allowSelectionOnly) { return }
	
	    var hist = doc.history, event, selAfter = doc.sel;
	    var source = type == "undo" ? hist.done : hist.undone, dest = type == "undo" ? hist.undone : hist.done;
	
	    // Verify that there is a useable event (so that ctrl-z won't
	    // needlessly clear selection events)
	    var i = 0;
	    for (; i < source.length; i++) {
	      event = source[i];
	      if (allowSelectionOnly ? event.ranges && !event.equals(doc.sel) : !event.ranges)
	        { break }
	    }
	    if (i == source.length) { return }
	    hist.lastOrigin = hist.lastSelOrigin = null;
	
	    for (;;) {
	      event = source.pop();
	      if (event.ranges) {
	        pushSelectionToHistory(event, dest);
	        if (allowSelectionOnly && !event.equals(doc.sel)) {
	          setSelection(doc, event, {clearRedo: false});
	          return
	        }
	        selAfter = event;
	      } else if (suppress) {
	        source.push(event);
	        return
	      } else { break }
	    }
	
	    // Build up a reverse change object to add to the opposite history
	    // stack (redo when undoing, and vice versa).
	    var antiChanges = [];
	    pushSelectionToHistory(selAfter, dest);
	    dest.push({changes: antiChanges, generation: hist.generation});
	    hist.generation = event.generation || ++hist.maxGeneration;
	
	    var filter = hasHandler(doc, "beforeChange") || doc.cm && hasHandler(doc.cm, "beforeChange");
	
	    var loop = function ( i ) {
	      var change = event.changes[i];
	      change.origin = type;
	      if (filter && !filterChange(doc, change, false)) {
	        source.length = 0;
	        return {}
	      }
	
	      antiChanges.push(historyChangeFromChange(doc, change));
	
	      var after = i ? computeSelAfterChange(doc, change) : lst(source);
	      makeChangeSingleDoc(doc, change, after, mergeOldSpans(doc, change));
	      if (!i && doc.cm) { doc.cm.scrollIntoView({from: change.from, to: changeEnd(change)}); }
	      var rebased = [];
	
	      // Propagate to the linked documents
	      linkedDocs(doc, function (doc, sharedHist) {
	        if (!sharedHist && indexOf(rebased, doc.history) == -1) {
	          rebaseHist(doc.history, change);
	          rebased.push(doc.history);
	        }
	        makeChangeSingleDoc(doc, change, null, mergeOldSpans(doc, change));
	      });
	    };
	
	    for (var i$1 = event.changes.length - 1; i$1 >= 0; --i$1) {
	      var returned = loop( i$1 );
	
	      if ( returned ) return returned.v;
	    }
	  }
	
	  // Sub-views need their line numbers shifted when text is added
	  // above or below them in the parent document.
	  function shiftDoc(doc, distance) {
	    if (distance == 0) { return }
	    doc.first += distance;
	    doc.sel = new Selection(map(doc.sel.ranges, function (range) { return new Range(
	      Pos(range.anchor.line + distance, range.anchor.ch),
	      Pos(range.head.line + distance, range.head.ch)
	    ); }), doc.sel.primIndex);
	    if (doc.cm) {
	      regChange(doc.cm, doc.first, doc.first - distance, distance);
	      for (var d = doc.cm.display, l = d.viewFrom; l < d.viewTo; l++)
	        { regLineChange(doc.cm, l, "gutter"); }
	    }
	  }
	
	  // More lower-level change function, handling only a single document
	  // (not linked ones).
	  function makeChangeSingleDoc(doc, change, selAfter, spans) {
	    if (doc.cm && !doc.cm.curOp)
	      { return operation(doc.cm, makeChangeSingleDoc)(doc, change, selAfter, spans) }
	
	    if (change.to.line < doc.first) {
	      shiftDoc(doc, change.text.length - 1 - (change.to.line - change.from.line));
	      return
	    }
	    if (change.from.line > doc.lastLine()) { return }
	
	    // Clip the change to the size of this doc
	    if (change.from.line < doc.first) {
	      var shift = change.text.length - 1 - (doc.first - change.from.line);
	      shiftDoc(doc, shift);
	      change = {from: Pos(doc.first, 0), to: Pos(change.to.line + shift, change.to.ch),
	                text: [lst(change.text)], origin: change.origin};
	    }
	    var last = doc.lastLine();
	    if (change.to.line > last) {
	      change = {from: change.from, to: Pos(last, getLine(doc, last).text.length),
	                text: [change.text[0]], origin: change.origin};
	    }
	
	    change.removed = getBetween(doc, change.from, change.to);
	
	    if (!selAfter) { selAfter = computeSelAfterChange(doc, change); }
	    if (doc.cm) { makeChangeSingleDocInEditor(doc.cm, change, spans); }
	    else { updateDoc(doc, change, spans); }
	    setSelectionNoUndo(doc, selAfter, sel_dontScroll);
	
	    if (doc.cantEdit && skipAtomic(doc, Pos(doc.firstLine(), 0)))
	      { doc.cantEdit = false; }
	  }
	
	  // Handle the interaction of a change to a document with the editor
	  // that this document is part of.
	  function makeChangeSingleDocInEditor(cm, change, spans) {
	    var doc = cm.doc, display = cm.display, from = change.from, to = change.to;
	
	    var recomputeMaxLength = false, checkWidthStart = from.line;
	    if (!cm.options.lineWrapping) {
	      checkWidthStart = lineNo(visualLine(getLine(doc, from.line)));
	      doc.iter(checkWidthStart, to.line + 1, function (line) {
	        if (line == display.maxLine) {
	          recomputeMaxLength = true;
	          return true
	        }
	      });
	    }
	
	    if (doc.sel.contains(change.from, change.to) > -1)
	      { signalCursorActivity(cm); }
	
	    updateDoc(doc, change, spans, estimateHeight(cm));
	
	    if (!cm.options.lineWrapping) {
	      doc.iter(checkWidthStart, from.line + change.text.length, function (line) {
	        var len = lineLength(line);
	        if (len > display.maxLineLength) {
	          display.maxLine = line;
	          display.maxLineLength = len;
	          display.maxLineChanged = true;
	          recomputeMaxLength = false;
	        }
	      });
	      if (recomputeMaxLength) { cm.curOp.updateMaxLine = true; }
	    }
	
	    retreatFrontier(doc, from.line);
	    startWorker(cm, 400);
	
	    var lendiff = change.text.length - (to.line - from.line) - 1;
	    // Remember that these lines changed, for updating the display
	    if (change.full)
	      { regChange(cm); }
	    else if (from.line == to.line && change.text.length == 1 && !isWholeLineUpdate(cm.doc, change))
	      { regLineChange(cm, from.line, "text"); }
	    else
	      { regChange(cm, from.line, to.line + 1, lendiff); }
	
	    var changesHandler = hasHandler(cm, "changes"), changeHandler = hasHandler(cm, "change");
	    if (changeHandler || changesHandler) {
	      var obj = {
	        from: from, to: to,
	        text: change.text,
	        removed: change.removed,
	        origin: change.origin
	      };
	      if (changeHandler) { signalLater(cm, "change", cm, obj); }
	      if (changesHandler) { (cm.curOp.changeObjs || (cm.curOp.changeObjs = [])).push(obj); }
	    }
	    cm.display.selForContextMenu = null;
	  }
	
	  function replaceRange(doc, code, from, to, origin) {
	    var assign;
	
	    if (!to) { to = from; }
	    if (cmp(to, from) < 0) { (assign = [to, from], from = assign[0], to = assign[1]); }
	    if (typeof code == "string") { code = doc.splitLines(code); }
	    makeChange(doc, {from: from, to: to, text: code, origin: origin});
	  }
	
	  // Rebasing/resetting history to deal with externally-sourced changes
	
	  function rebaseHistSelSingle(pos, from, to, diff) {
	    if (to < pos.line) {
	      pos.line += diff;
	    } else if (from < pos.line) {
	      pos.line = from;
	      pos.ch = 0;
	    }
	  }
	
	  // Tries to rebase an array of history events given a change in the
	  // document. If the change touches the same lines as the event, the
	  // event, and everything 'behind' it, is discarded. If the change is
	  // before the event, the event's positions are updated. Uses a
	  // copy-on-write scheme for the positions, to avoid having to
	  // reallocate them all on every rebase, but also avoid problems with
	  // shared position objects being unsafely updated.
	  function rebaseHistArray(array, from, to, diff) {
	    for (var i = 0; i < array.length; ++i) {
	      var sub = array[i], ok = true;
	      if (sub.ranges) {
	        if (!sub.copied) { sub = array[i] = sub.deepCopy(); sub.copied = true; }
	        for (var j = 0; j < sub.ranges.length; j++) {
	          rebaseHistSelSingle(sub.ranges[j].anchor, from, to, diff);
	          rebaseHistSelSingle(sub.ranges[j].head, from, to, diff);
	        }
	        continue
	      }
	      for (var j$1 = 0; j$1 < sub.changes.length; ++j$1) {
	        var cur = sub.changes[j$1];
	        if (to < cur.from.line) {
	          cur.from = Pos(cur.from.line + diff, cur.from.ch);
	          cur.to = Pos(cur.to.line + diff, cur.to.ch);
	        } else if (from <= cur.to.line) {
	          ok = false;
	          break
	        }
	      }
	      if (!ok) {
	        array.splice(0, i + 1);
	        i = 0;
	      }
	    }
	  }
	
	  function rebaseHist(hist, change) {
	    var from = change.from.line, to = change.to.line, diff = change.text.length - (to - from) - 1;
	    rebaseHistArray(hist.done, from, to, diff);
	    rebaseHistArray(hist.undone, from, to, diff);
	  }
	
	  // Utility for applying a change to a line by handle or number,
	  // returning the number and optionally registering the line as
	  // changed.
	  function changeLine(doc, handle, changeType, op) {
	    var no = handle, line = handle;
	    if (typeof handle == "number") { line = getLine(doc, clipLine(doc, handle)); }
	    else { no = lineNo(handle); }
	    if (no == null) { return null }
	    if (op(line, no) && doc.cm) { regLineChange(doc.cm, no, changeType); }
	    return line
	  }
	
	  // The document is represented as a BTree consisting of leaves, with
	  // chunk of lines in them, and branches, with up to ten leaves or
	  // other branch nodes below them. The top node is always a branch
	  // node, and is the document object itself (meaning it has
	  // additional methods and properties).
	  //
	  // All nodes have parent links. The tree is used both to go from
	  // line numbers to line objects, and to go from objects to numbers.
	  // It also indexes by height, and is used to convert between height
	  // and line object, and to find the total height of the document.
	  //
	  // See also http://marijnhaverbeke.nl/blog/codemirror-line-tree.html
	
	  function LeafChunk(lines) {
	    this.lines = lines;
	    this.parent = null;
	    var height = 0;
	    for (var i = 0; i < lines.length; ++i) {
	      lines[i].parent = this;
	      height += lines[i].height;
	    }
	    this.height = height;
	  }
	
	  LeafChunk.prototype = {
	    chunkSize: function() { return this.lines.length },
	
	    // Remove the n lines at offset 'at'.
	    removeInner: function(at, n) {
	      for (var i = at, e = at + n; i < e; ++i) {
	        var line = this.lines[i];
	        this.height -= line.height;
	        cleanUpLine(line);
	        signalLater(line, "delete");
	      }
	      this.lines.splice(at, n);
	    },
	
	    // Helper used to collapse a small branch into a single leaf.
	    collapse: function(lines) {
	      lines.push.apply(lines, this.lines);
	    },
	
	    // Insert the given array of lines at offset 'at', count them as
	    // having the given height.
	    insertInner: function(at, lines, height) {
	      this.height += height;
	      this.lines = this.lines.slice(0, at).concat(lines).concat(this.lines.slice(at));
	      for (var i = 0; i < lines.length; ++i) { lines[i].parent = this; }
	    },
	
	    // Used to iterate over a part of the tree.
	    iterN: function(at, n, op) {
	      for (var e = at + n; at < e; ++at)
	        { if (op(this.lines[at])) { return true } }
	    }
	  };
	
	  function BranchChunk(children) {
	    this.children = children;
	    var size = 0, height = 0;
	    for (var i = 0; i < children.length; ++i) {
	      var ch = children[i];
	      size += ch.chunkSize(); height += ch.height;
	      ch.parent = this;
	    }
	    this.size = size;
	    this.height = height;
	    this.parent = null;
	  }
	
	  BranchChunk.prototype = {
	    chunkSize: function() { return this.size },
	
	    removeInner: function(at, n) {
	      this.size -= n;
	      for (var i = 0; i < this.children.length; ++i) {
	        var child = this.children[i], sz = child.chunkSize();
	        if (at < sz) {
	          var rm = Math.min(n, sz - at), oldHeight = child.height;
	          child.removeInner(at, rm);
	          this.height -= oldHeight - child.height;
	          if (sz == rm) { this.children.splice(i--, 1); child.parent = null; }
	          if ((n -= rm) == 0) { break }
	          at = 0;
	        } else { at -= sz; }
	      }
	      // If the result is smaller than 25 lines, ensure that it is a
	      // single leaf node.
	      if (this.size - n < 25 &&
	          (this.children.length > 1 || !(this.children[0] instanceof LeafChunk))) {
	        var lines = [];
	        this.collapse(lines);
	        this.children = [new LeafChunk(lines)];
	        this.children[0].parent = this;
	      }
	    },
	
	    collapse: function(lines) {
	      for (var i = 0; i < this.children.length; ++i) { this.children[i].collapse(lines); }
	    },
	
	    insertInner: function(at, lines, height) {
	      this.size += lines.length;
	      this.height += height;
	      for (var i = 0; i < this.children.length; ++i) {
	        var child = this.children[i], sz = child.chunkSize();
	        if (at <= sz) {
	          child.insertInner(at, lines, height);
	          if (child.lines && child.lines.length > 50) {
	            // To avoid memory thrashing when child.lines is huge (e.g. first view of a large file), it's never spliced.
	            // Instead, small slices are taken. They're taken in order because sequential memory accesses are fastest.
	            var remaining = child.lines.length % 25 + 25;
	            for (var pos = remaining; pos < child.lines.length;) {
	              var leaf = new LeafChunk(child.lines.slice(pos, pos += 25));
	              child.height -= leaf.height;
	              this.children.splice(++i, 0, leaf);
	              leaf.parent = this;
	            }
	            child.lines = child.lines.slice(0, remaining);
	            this.maybeSpill();
	          }
	          break
	        }
	        at -= sz;
	      }
	    },
	
	    // When a node has grown, check whether it should be split.
	    maybeSpill: function() {
	      if (this.children.length <= 10) { return }
	      var me = this;
	      do {
	        var spilled = me.children.splice(me.children.length - 5, 5);
	        var sibling = new BranchChunk(spilled);
	        if (!me.parent) { // Become the parent node
	          var copy = new BranchChunk(me.children);
	          copy.parent = me;
	          me.children = [copy, sibling];
	          me = copy;
	       } else {
	          me.size -= sibling.size;
	          me.height -= sibling.height;
	          var myIndex = indexOf(me.parent.children, me);
	          me.parent.children.splice(myIndex + 1, 0, sibling);
	        }
	        sibling.parent = me.parent;
	      } while (me.children.length > 10)
	      me.parent.maybeSpill();
	    },
	
	    iterN: function(at, n, op) {
	      for (var i = 0; i < this.children.length; ++i) {
	        var child = this.children[i], sz = child.chunkSize();
	        if (at < sz) {
	          var used = Math.min(n, sz - at);
	          if (child.iterN(at, used, op)) { return true }
	          if ((n -= used) == 0) { break }
	          at = 0;
	        } else { at -= sz; }
	      }
	    }
	  };
	
	  // Line widgets are block elements displayed above or below a line.
	
	  var LineWidget = function(doc, node, options) {
	    if (options) { for (var opt in options) { if (options.hasOwnProperty(opt))
	      { this[opt] = options[opt]; } } }
	    this.doc = doc;
	    this.node = node;
	  };
	
	  LineWidget.prototype.clear = function () {
	    var cm = this.doc.cm, ws = this.line.widgets, line = this.line, no = lineNo(line);
	    if (no == null || !ws) { return }
	    for (var i = 0; i < ws.length; ++i) { if (ws[i] == this) { ws.splice(i--, 1); } }
	    if (!ws.length) { line.widgets = null; }
	    var height = widgetHeight(this);
	    updateLineHeight(line, Math.max(0, line.height - height));
	    if (cm) {
	      runInOp(cm, function () {
	        adjustScrollWhenAboveVisible(cm, line, -height);
	        regLineChange(cm, no, "widget");
	      });
	      signalLater(cm, "lineWidgetCleared", cm, this, no);
	    }
	  };
	
	  LineWidget.prototype.changed = function () {
	      var this$1 = this;
	
	    var oldH = this.height, cm = this.doc.cm, line = this.line;
	    this.height = null;
	    var diff = widgetHeight(this) - oldH;
	    if (!diff) { return }
	    if (!lineIsHidden(this.doc, line)) { updateLineHeight(line, line.height + diff); }
	    if (cm) {
	      runInOp(cm, function () {
	        cm.curOp.forceUpdate = true;
	        adjustScrollWhenAboveVisible(cm, line, diff);
	        signalLater(cm, "lineWidgetChanged", cm, this$1, lineNo(line));
	      });
	    }
	  };
	  eventMixin(LineWidget);
	
	  function adjustScrollWhenAboveVisible(cm, line, diff) {
	    if (heightAtLine(line) < ((cm.curOp && cm.curOp.scrollTop) || cm.doc.scrollTop))
	      { addToScrollTop(cm, diff); }
	  }
	
	  function addLineWidget(doc, handle, node, options) {
	    var widget = new LineWidget(doc, node, options);
	    var cm = doc.cm;
	    if (cm && widget.noHScroll) { cm.display.alignWidgets = true; }
	    changeLine(doc, handle, "widget", function (line) {
	      var widgets = line.widgets || (line.widgets = []);
	      if (widget.insertAt == null) { widgets.push(widget); }
	      else { widgets.splice(Math.min(widgets.length - 1, Math.max(0, widget.insertAt)), 0, widget); }
	      widget.line = line;
	      if (cm && !lineIsHidden(doc, line)) {
	        var aboveVisible = heightAtLine(line) < doc.scrollTop;
	        updateLineHeight(line, line.height + widgetHeight(widget));
	        if (aboveVisible) { addToScrollTop(cm, widget.height); }
	        cm.curOp.forceUpdate = true;
	      }
	      return true
	    });
	    if (cm) { signalLater(cm, "lineWidgetAdded", cm, widget, typeof handle == "number" ? handle : lineNo(handle)); }
	    return widget
	  }
	
	  // TEXTMARKERS
	
	  // Created with markText and setBookmark methods. A TextMarker is a
	  // handle that can be used to clear or find a marked position in the
	  // document. Line objects hold arrays (markedSpans) containing
	  // {from, to, marker} object pointing to such marker objects, and
	  // indicating that such a marker is present on that line. Multiple
	  // lines may point to the same marker when it spans across lines.
	  // The spans will have null for their from/to properties when the
	  // marker continues beyond the start/end of the line. Markers have
	  // links back to the lines they currently touch.
	
	  // Collapsed markers have unique ids, in order to be able to order
	  // them, which is needed for uniquely determining an outer marker
	  // when they overlap (they may nest, but not partially overlap).
	  var nextMarkerId = 0;
	
	  var TextMarker = function(doc, type) {
	    this.lines = [];
	    this.type = type;
	    this.doc = doc;
	    this.id = ++nextMarkerId;
	  };
	
	  // Clear the marker.
	  TextMarker.prototype.clear = function () {
	    if (this.explicitlyCleared) { return }
	    var cm = this.doc.cm, withOp = cm && !cm.curOp;
	    if (withOp) { startOperation(cm); }
	    if (hasHandler(this, "clear")) {
	      var found = this.find();
	      if (found) { signalLater(this, "clear", found.from, found.to); }
	    }
	    var min = null, max = null;
	    for (var i = 0; i < this.lines.length; ++i) {
	      var line = this.lines[i];
	      var span = getMarkedSpanFor(line.markedSpans, this);
	      if (cm && !this.collapsed) { regLineChange(cm, lineNo(line), "text"); }
	      else if (cm) {
	        if (span.to != null) { max = lineNo(line); }
	        if (span.from != null) { min = lineNo(line); }
	      }
	      line.markedSpans = removeMarkedSpan(line.markedSpans, span);
	      if (span.from == null && this.collapsed && !lineIsHidden(this.doc, line) && cm)
	        { updateLineHeight(line, textHeight(cm.display)); }
	    }
	    if (cm && this.collapsed && !cm.options.lineWrapping) { for (var i$1 = 0; i$1 < this.lines.length; ++i$1) {
	      var visual = visualLine(this.lines[i$1]), len = lineLength(visual);
	      if (len > cm.display.maxLineLength) {
	        cm.display.maxLine = visual;
	        cm.display.maxLineLength = len;
	        cm.display.maxLineChanged = true;
	      }
	    } }
	
	    if (min != null && cm && this.collapsed) { regChange(cm, min, max + 1); }
	    this.lines.length = 0;
	    this.explicitlyCleared = true;
	    if (this.atomic && this.doc.cantEdit) {
	      this.doc.cantEdit = false;
	      if (cm) { reCheckSelection(cm.doc); }
	    }
	    if (cm) { signalLater(cm, "markerCleared", cm, this, min, max); }
	    if (withOp) { endOperation(cm); }
	    if (this.parent) { this.parent.clear(); }
	  };
	
	  // Find the position of the marker in the document. Returns a {from,
	  // to} object by default. Side can be passed to get a specific side
	  // -- 0 (both), -1 (left), or 1 (right). When lineObj is true, the
	  // Pos objects returned contain a line object, rather than a line
	  // number (used to prevent looking up the same line twice).
	  TextMarker.prototype.find = function (side, lineObj) {
	    if (side == null && this.type == "bookmark") { side = 1; }
	    var from, to;
	    for (var i = 0; i < this.lines.length; ++i) {
	      var line = this.lines[i];
	      var span = getMarkedSpanFor(line.markedSpans, this);
	      if (span.from != null) {
	        from = Pos(lineObj ? line : lineNo(line), span.from);
	        if (side == -1) { return from }
	      }
	      if (span.to != null) {
	        to = Pos(lineObj ? line : lineNo(line), span.to);
	        if (side == 1) { return to }
	      }
	    }
	    return from && {from: from, to: to}
	  };
	
	  // Signals that the marker's widget changed, and surrounding layout
	  // should be recomputed.
	  TextMarker.prototype.changed = function () {
	      var this$1 = this;
	
	    var pos = this.find(-1, true), widget = this, cm = this.doc.cm;
	    if (!pos || !cm) { return }
	    runInOp(cm, function () {
	      var line = pos.line, lineN = lineNo(pos.line);
	      var view = findViewForLine(cm, lineN);
	      if (view) {
	        clearLineMeasurementCacheFor(view);
	        cm.curOp.selectionChanged = cm.curOp.forceUpdate = true;
	      }
	      cm.curOp.updateMaxLine = true;
	      if (!lineIsHidden(widget.doc, line) && widget.height != null) {
	        var oldHeight = widget.height;
	        widget.height = null;
	        var dHeight = widgetHeight(widget) - oldHeight;
	        if (dHeight)
	          { updateLineHeight(line, line.height + dHeight); }
	      }
	      signalLater(cm, "markerChanged", cm, this$1);
	    });
	  };
	
	  TextMarker.prototype.attachLine = function (line) {
	    if (!this.lines.length && this.doc.cm) {
	      var op = this.doc.cm.curOp;
	      if (!op.maybeHiddenMarkers || indexOf(op.maybeHiddenMarkers, this) == -1)
	        { (op.maybeUnhiddenMarkers || (op.maybeUnhiddenMarkers = [])).push(this); }
	    }
	    this.lines.push(line);
	  };
	
	  TextMarker.prototype.detachLine = function (line) {
	    this.lines.splice(indexOf(this.lines, line), 1);
	    if (!this.lines.length && this.doc.cm) {
	      var op = this.doc.cm.curOp
	      ;(op.maybeHiddenMarkers || (op.maybeHiddenMarkers = [])).push(this);
	    }
	  };
	  eventMixin(TextMarker);
	
	  // Create a marker, wire it up to the right lines, and
	  function markText(doc, from, to, options, type) {
	    // Shared markers (across linked documents) are handled separately
	    // (markTextShared will call out to this again, once per
	    // document).
	    if (options && options.shared) { return markTextShared(doc, from, to, options, type) }
	    // Ensure we are in an operation.
	    if (doc.cm && !doc.cm.curOp) { return operation(doc.cm, markText)(doc, from, to, options, type) }
	
	    var marker = new TextMarker(doc, type), diff = cmp(from, to);
	    if (options) { copyObj(options, marker, false); }
	    // Don't connect empty markers unless clearWhenEmpty is false
	    if (diff > 0 || diff == 0 && marker.clearWhenEmpty !== false)
	      { return marker }
	    if (marker.replacedWith) {
	      // Showing up as a widget implies collapsed (widget replaces text)
	      marker.collapsed = true;
	      marker.widgetNode = eltP("span", [marker.replacedWith], "CodeMirror-widget");
	      if (!options.handleMouseEvents) { marker.widgetNode.setAttribute("cm-ignore-events", "true"); }
	      if (options.insertLeft) { marker.widgetNode.insertLeft = true; }
	    }
	    if (marker.collapsed) {
	      if (conflictingCollapsedRange(doc, from.line, from, to, marker) ||
	          from.line != to.line && conflictingCollapsedRange(doc, to.line, from, to, marker))
	        { throw new Error("Inserting collapsed marker partially overlapping an existing one") }
	      seeCollapsedSpans();
	    }
	
	    if (marker.addToHistory)
	      { addChangeToHistory(doc, {from: from, to: to, origin: "markText"}, doc.sel, NaN); }
	
	    var curLine = from.line, cm = doc.cm, updateMaxLine;
	    doc.iter(curLine, to.line + 1, function (line) {
	      if (cm && marker.collapsed && !cm.options.lineWrapping && visualLine(line) == cm.display.maxLine)
	        { updateMaxLine = true; }
	      if (marker.collapsed && curLine != from.line) { updateLineHeight(line, 0); }
	      addMarkedSpan(line, new MarkedSpan(marker,
	                                         curLine == from.line ? from.ch : null,
	                                         curLine == to.line ? to.ch : null));
	      ++curLine;
	    });
	    // lineIsHidden depends on the presence of the spans, so needs a second pass
	    if (marker.collapsed) { doc.iter(from.line, to.line + 1, function (line) {
	      if (lineIsHidden(doc, line)) { updateLineHeight(line, 0); }
	    }); }
	
	    if (marker.clearOnEnter) { on(marker, "beforeCursorEnter", function () { return marker.clear(); }); }
	
	    if (marker.readOnly) {
	      seeReadOnlySpans();
	      if (doc.history.done.length || doc.history.undone.length)
	        { doc.clearHistory(); }
	    }
	    if (marker.collapsed) {
	      marker.id = ++nextMarkerId;
	      marker.atomic = true;
	    }
	    if (cm) {
	      // Sync editor state
	      if (updateMaxLine) { cm.curOp.updateMaxLine = true; }
	      if (marker.collapsed)
	        { regChange(cm, from.line, to.line + 1); }
	      else if (marker.className || marker.startStyle || marker.endStyle || marker.css ||
	               marker.attributes || marker.title)
	        { for (var i = from.line; i <= to.line; i++) { regLineChange(cm, i, "text"); } }
	      if (marker.atomic) { reCheckSelection(cm.doc); }
	      signalLater(cm, "markerAdded", cm, marker);
	    }
	    return marker
	  }
	
	  // SHARED TEXTMARKERS
	
	  // A shared marker spans multiple linked documents. It is
	  // implemented as a meta-marker-object controlling multiple normal
	  // markers.
	  var SharedTextMarker = function(markers, primary) {
	    this.markers = markers;
	    this.primary = primary;
	    for (var i = 0; i < markers.length; ++i)
	      { markers[i].parent = this; }
	  };
	
	  SharedTextMarker.prototype.clear = function () {
	    if (this.explicitlyCleared) { return }
	    this.explicitlyCleared = true;
	    for (var i = 0; i < this.markers.length; ++i)
	      { this.markers[i].clear(); }
	    signalLater(this, "clear");
	  };
	
	  SharedTextMarker.prototype.find = function (side, lineObj) {
	    return this.primary.find(side, lineObj)
	  };
	  eventMixin(SharedTextMarker);
	
	  function markTextShared(doc, from, to, options, type) {
	    options = copyObj(options);
	    options.shared = false;
	    var markers = [markText(doc, from, to, options, type)], primary = markers[0];
	    var widget = options.widgetNode;
	    linkedDocs(doc, function (doc) {
	      if (widget) { options.widgetNode = widget.cloneNode(true); }
	      markers.push(markText(doc, clipPos(doc, from), clipPos(doc, to), options, type));
	      for (var i = 0; i < doc.linked.length; ++i)
	        { if (doc.linked[i].isParent) { return } }
	      primary = lst(markers);
	    });
	    return new SharedTextMarker(markers, primary)
	  }
	
	  function findSharedMarkers(doc) {
	    return doc.findMarks(Pos(doc.first, 0), doc.clipPos(Pos(doc.lastLine())), function (m) { return m.parent; })
	  }
	
	  function copySharedMarkers(doc, markers) {
	    for (var i = 0; i < markers.length; i++) {
	      var marker = markers[i], pos = marker.find();
	      var mFrom = doc.clipPos(pos.from), mTo = doc.clipPos(pos.to);
	      if (cmp(mFrom, mTo)) {
	        var subMark = markText(doc, mFrom, mTo, marker.primary, marker.primary.type);
	        marker.markers.push(subMark);
	        subMark.parent = marker;
	      }
	    }
	  }
	
	  function detachSharedMarkers(markers) {
	    var loop = function ( i ) {
	      var marker = markers[i], linked = [marker.primary.doc];
	      linkedDocs(marker.primary.doc, function (d) { return linked.push(d); });
	      for (var j = 0; j < marker.markers.length; j++) {
	        var subMarker = marker.markers[j];
	        if (indexOf(linked, subMarker.doc) == -1) {
	          subMarker.parent = null;
	          marker.markers.splice(j--, 1);
	        }
	      }
	    };
	
	    for (var i = 0; i < markers.length; i++) loop( i );
	  }
	
	  var nextDocId = 0;
	  var Doc = function(text, mode, firstLine, lineSep, direction) {
	    if (!(this instanceof Doc)) { return new Doc(text, mode, firstLine, lineSep, direction) }
	    if (firstLine == null) { firstLine = 0; }
	
	    BranchChunk.call(this, [new LeafChunk([new Line("", null)])]);
	    this.first = firstLine;
	    this.scrollTop = this.scrollLeft = 0;
	    this.cantEdit = false;
	    this.cleanGeneration = 1;
	    this.modeFrontier = this.highlightFrontier = firstLine;
	    var start = Pos(firstLine, 0);
	    this.sel = simpleSelection(start);
	    this.history = new History(null);
	    this.id = ++nextDocId;
	    this.modeOption = mode;
	    this.lineSep = lineSep;
	    this.direction = (direction == "rtl") ? "rtl" : "ltr";
	    this.extend = false;
	
	    if (typeof text == "string") { text = this.splitLines(text); }
	    updateDoc(this, {from: start, to: start, text: text});
	    setSelection(this, simpleSelection(start), sel_dontScroll);
	  };
	
	  Doc.prototype = createObj(BranchChunk.prototype, {
	    constructor: Doc,
	    // Iterate over the document. Supports two forms -- with only one
	    // argument, it calls that for each line in the document. With
	    // three, it iterates over the range given by the first two (with
	    // the second being non-inclusive).
	    iter: function(from, to, op) {
	      if (op) { this.iterN(from - this.first, to - from, op); }
	      else { this.iterN(this.first, this.first + this.size, from); }
	    },
	
	    // Non-public interface for adding and removing lines.
	    insert: function(at, lines) {
	      var height = 0;
	      for (var i = 0; i < lines.length; ++i) { height += lines[i].height; }
	      this.insertInner(at - this.first, lines, height);
	    },
	    remove: function(at, n) { this.removeInner(at - this.first, n); },
	
	    // From here, the methods are part of the public interface. Most
	    // are also available from CodeMirror (editor) instances.
	
	    getValue: function(lineSep) {
	      var lines = getLines(this, this.first, this.first + this.size);
	      if (lineSep === false) { return lines }
	      return lines.join(lineSep || this.lineSeparator())
	    },
	    setValue: docMethodOp(function(code) {
	      var top = Pos(this.first, 0), last = this.first + this.size - 1;
	      makeChange(this, {from: top, to: Pos(last, getLine(this, last).text.length),
	                        text: this.splitLines(code), origin: "setValue", full: true}, true);
	      if (this.cm) { scrollToCoords(this.cm, 0, 0); }
	      setSelection(this, simpleSelection(top), sel_dontScroll);
	    }),
	    replaceRange: function(code, from, to, origin) {
	      from = clipPos(this, from);
	      to = to ? clipPos(this, to) : from;
	      replaceRange(this, code, from, to, origin);
	    },
	    getRange: function(from, to, lineSep) {
	      var lines = getBetween(this, clipPos(this, from), clipPos(this, to));
	      if (lineSep === false) { return lines }
	      return lines.join(lineSep || this.lineSeparator())
	    },
	
	    getLine: function(line) {var l = this.getLineHandle(line); return l && l.text},
	
	    getLineHandle: function(line) {if (isLine(this, line)) { return getLine(this, line) }},
	    getLineNumber: function(line) {return lineNo(line)},
	
	    getLineHandleVisualStart: function(line) {
	      if (typeof line == "number") { line = getLine(this, line); }
	      return visualLine(line)
	    },
	
	    lineCount: function() {return this.size},
	    firstLine: function() {return this.first},
	    lastLine: function() {return this.first + this.size - 1},
	
	    clipPos: function(pos) {return clipPos(this, pos)},
	
	    getCursor: function(start) {
	      var range = this.sel.primary(), pos;
	      if (start == null || start == "head") { pos = range.head; }
	      else if (start == "anchor") { pos = range.anchor; }
	      else if (start == "end" || start == "to" || start === false) { pos = range.to(); }
	      else { pos = range.from(); }
	      return pos
	    },
	    listSelections: function() { return this.sel.ranges },
	    somethingSelected: function() {return this.sel.somethingSelected()},
	
	    setCursor: docMethodOp(function(line, ch, options) {
	      setSimpleSelection(this, clipPos(this, typeof line == "number" ? Pos(line, ch || 0) : line), null, options);
	    }),
	    setSelection: docMethodOp(function(anchor, head, options) {
	      setSimpleSelection(this, clipPos(this, anchor), clipPos(this, head || anchor), options);
	    }),
	    extendSelection: docMethodOp(function(head, other, options) {
	      extendSelection(this, clipPos(this, head), other && clipPos(this, other), options);
	    }),
	    extendSelections: docMethodOp(function(heads, options) {
	      extendSelections(this, clipPosArray(this, heads), options);
	    }),
	    extendSelectionsBy: docMethodOp(function(f, options) {
	      var heads = map(this.sel.ranges, f);
	      extendSelections(this, clipPosArray(this, heads), options);
	    }),
	    setSelections: docMethodOp(function(ranges, primary, options) {
	      if (!ranges.length) { return }
	      var out = [];
	      for (var i = 0; i < ranges.length; i++)
	        { out[i] = new Range(clipPos(this, ranges[i].anchor),
	                           clipPos(this, ranges[i].head)); }
	      if (primary == null) { primary = Math.min(ranges.length - 1, this.sel.primIndex); }
	      setSelection(this, normalizeSelection(this.cm, out, primary), options);
	    }),
	    addSelection: docMethodOp(function(anchor, head, options) {
	      var ranges = this.sel.ranges.slice(0);
	      ranges.push(new Range(clipPos(this, anchor), clipPos(this, head || anchor)));
	      setSelection(this, normalizeSelection(this.cm, ranges, ranges.length - 1), options);
	    }),
	
	    getSelection: function(lineSep) {
	      var ranges = this.sel.ranges, lines;
	      for (var i = 0; i < ranges.length; i++) {
	        var sel = getBetween(this, ranges[i].from(), ranges[i].to());
	        lines = lines ? lines.concat(sel) : sel;
	      }
	      if (lineSep === false) { return lines }
	      else { return lines.join(lineSep || this.lineSeparator()) }
	    },
	    getSelections: function(lineSep) {
	      var parts = [], ranges = this.sel.ranges;
	      for (var i = 0; i < ranges.length; i++) {
	        var sel = getBetween(this, ranges[i].from(), ranges[i].to());
	        if (lineSep !== false) { sel = sel.join(lineSep || this.lineSeparator()); }
	        parts[i] = sel;
	      }
	      return parts
	    },
	    replaceSelection: function(code, collapse, origin) {
	      var dup = [];
	      for (var i = 0; i < this.sel.ranges.length; i++)
	        { dup[i] = code; }
	      this.replaceSelections(dup, collapse, origin || "+input");
	    },
	    replaceSelections: docMethodOp(function(code, collapse, origin) {
	      var changes = [], sel = this.sel;
	      for (var i = 0; i < sel.ranges.length; i++) {
	        var range = sel.ranges[i];
	        changes[i] = {from: range.from(), to: range.to(), text: this.splitLines(code[i]), origin: origin};
	      }
	      var newSel = collapse && collapse != "end" && computeReplacedSel(this, changes, collapse);
	      for (var i$1 = changes.length - 1; i$1 >= 0; i$1--)
	        { makeChange(this, changes[i$1]); }
	      if (newSel) { setSelectionReplaceHistory(this, newSel); }
	      else if (this.cm) { ensureCursorVisible(this.cm); }
	    }),
	    undo: docMethodOp(function() {makeChangeFromHistory(this, "undo");}),
	    redo: docMethodOp(function() {makeChangeFromHistory(this, "redo");}),
	    undoSelection: docMethodOp(function() {makeChangeFromHistory(this, "undo", true);}),
	    redoSelection: docMethodOp(function() {makeChangeFromHistory(this, "redo", true);}),
	
	    setExtending: function(val) {this.extend = val;},
	    getExtending: function() {return this.extend},
	
	    historySize: function() {
	      var hist = this.history, done = 0, undone = 0;
	      for (var i = 0; i < hist.done.length; i++) { if (!hist.done[i].ranges) { ++done; } }
	      for (var i$1 = 0; i$1 < hist.undone.length; i$1++) { if (!hist.undone[i$1].ranges) { ++undone; } }
	      return {undo: done, redo: undone}
	    },
	    clearHistory: function() {
	      var this$1 = this;
	
	      this.history = new History(this.history.maxGeneration);
	      linkedDocs(this, function (doc) { return doc.history = this$1.history; }, true);
	    },
	
	    markClean: function() {
	      this.cleanGeneration = this.changeGeneration(true);
	    },
	    changeGeneration: function(forceSplit) {
	      if (forceSplit)
	        { this.history.lastOp = this.history.lastSelOp = this.history.lastOrigin = null; }
	      return this.history.generation
	    },
	    isClean: function (gen) {
	      return this.history.generation == (gen || this.cleanGeneration)
	    },
	
	    getHistory: function() {
	      return {done: copyHistoryArray(this.history.done),
	              undone: copyHistoryArray(this.history.undone)}
	    },
	    setHistory: function(histData) {
	      var hist = this.history = new History(this.history.maxGeneration);
	      hist.done = copyHistoryArray(histData.done.slice(0), null, true);
	      hist.undone = copyHistoryArray(histData.undone.slice(0), null, true);
	    },
	
	    setGutterMarker: docMethodOp(function(line, gutterID, value) {
	      return changeLine(this, line, "gutter", function (line) {
	        var markers = line.gutterMarkers || (line.gutterMarkers = {});
	        markers[gutterID] = value;
	        if (!value && isEmpty(markers)) { line.gutterMarkers = null; }
	        return true
	      })
	    }),
	
	    clearGutter: docMethodOp(function(gutterID) {
	      var this$1 = this;
	
	      this.iter(function (line) {
	        if (line.gutterMarkers && line.gutterMarkers[gutterID]) {
	          changeLine(this$1, line, "gutter", function () {
	            line.gutterMarkers[gutterID] = null;
	            if (isEmpty(line.gutterMarkers)) { line.gutterMarkers = null; }
	            return true
	          });
	        }
	      });
	    }),
	
	    lineInfo: function(line) {
	      var n;
	      if (typeof line == "number") {
	        if (!isLine(this, line)) { return null }
	        n = line;
	        line = getLine(this, line);
	        if (!line) { return null }
	      } else {
	        n = lineNo(line);
	        if (n == null) { return null }
	      }
	      return {line: n, handle: line, text: line.text, gutterMarkers: line.gutterMarkers,
	              textClass: line.textClass, bgClass: line.bgClass, wrapClass: line.wrapClass,
	              widgets: line.widgets}
	    },
	
	    addLineClass: docMethodOp(function(handle, where, cls) {
	      return changeLine(this, handle, where == "gutter" ? "gutter" : "class", function (line) {
	        var prop = where == "text" ? "textClass"
	                 : where == "background" ? "bgClass"
	                 : where == "gutter" ? "gutterClass" : "wrapClass";
	        if (!line[prop]) { line[prop] = cls; }
	        else if (classTest(cls).test(line[prop])) { return false }
	        else { line[prop] += " " + cls; }
	        return true
	      })
	    }),
	    removeLineClass: docMethodOp(function(handle, where, cls) {
	      return changeLine(this, handle, where == "gutter" ? "gutter" : "class", function (line) {
	        var prop = where == "text" ? "textClass"
	                 : where == "background" ? "bgClass"
	                 : where == "gutter" ? "gutterClass" : "wrapClass";
	        var cur = line[prop];
	        if (!cur) { return false }
	        else if (cls == null) { line[prop] = null; }
	        else {
	          var found = cur.match(classTest(cls));
	          if (!found) { return false }
	          var end = found.index + found[0].length;
	          line[prop] = cur.slice(0, found.index) + (!found.index || end == cur.length ? "" : " ") + cur.slice(end) || null;
	        }
	        return true
	      })
	    }),
	
	    addLineWidget: docMethodOp(function(handle, node, options) {
	      return addLineWidget(this, handle, node, options)
	    }),
	    removeLineWidget: function(widget) { widget.clear(); },
	
	    markText: function(from, to, options) {
	      return markText(this, clipPos(this, from), clipPos(this, to), options, options && options.type || "range")
	    },
	    setBookmark: function(pos, options) {
	      var realOpts = {replacedWith: options && (options.nodeType == null ? options.widget : options),
	                      insertLeft: options && options.insertLeft,
	                      clearWhenEmpty: false, shared: options && options.shared,
	                      handleMouseEvents: options && options.handleMouseEvents};
	      pos = clipPos(this, pos);
	      return markText(this, pos, pos, realOpts, "bookmark")
	    },
	    findMarksAt: function(pos) {
	      pos = clipPos(this, pos);
	      var markers = [], spans = getLine(this, pos.line).markedSpans;
	      if (spans) { for (var i = 0; i < spans.length; ++i) {
	        var span = spans[i];
	        if ((span.from == null || span.from <= pos.ch) &&
	            (span.to == null || span.to >= pos.ch))
	          { markers.push(span.marker.parent || span.marker); }
	      } }
	      return markers
	    },
	    findMarks: function(from, to, filter) {
	      from = clipPos(this, from); to = clipPos(this, to);
	      var found = [], lineNo = from.line;
	      this.iter(from.line, to.line + 1, function (line) {
	        var spans = line.markedSpans;
	        if (spans) { for (var i = 0; i < spans.length; i++) {
	          var span = spans[i];
	          if (!(span.to != null && lineNo == from.line && from.ch >= span.to ||
	                span.from == null && lineNo != from.line ||
	                span.from != null && lineNo == to.line && span.from >= to.ch) &&
	              (!filter || filter(span.marker)))
	            { found.push(span.marker.parent || span.marker); }
	        } }
	        ++lineNo;
	      });
	      return found
	    },
	    getAllMarks: function() {
	      var markers = [];
	      this.iter(function (line) {
	        var sps = line.markedSpans;
	        if (sps) { for (var i = 0; i < sps.length; ++i)
	          { if (sps[i].from != null) { markers.push(sps[i].marker); } } }
	      });
	      return markers
	    },
	
	    posFromIndex: function(off) {
	      var ch, lineNo = this.first, sepSize = this.lineSeparator().length;
	      this.iter(function (line) {
	        var sz = line.text.length + sepSize;
	        if (sz > off) { ch = off; return true }
	        off -= sz;
	        ++lineNo;
	      });
	      return clipPos(this, Pos(lineNo, ch))
	    },
	    indexFromPos: function (coords) {
	      coords = clipPos(this, coords);
	      var index = coords.ch;
	      if (coords.line < this.first || coords.ch < 0) { return 0 }
	      var sepSize = this.lineSeparator().length;
	      this.iter(this.first, coords.line, function (line) { // iter aborts when callback returns a truthy value
	        index += line.text.length + sepSize;
	      });
	      return index
	    },
	
	    copy: function(copyHistory) {
	      var doc = new Doc(getLines(this, this.first, this.first + this.size),
	                        this.modeOption, this.first, this.lineSep, this.direction);
	      doc.scrollTop = this.scrollTop; doc.scrollLeft = this.scrollLeft;
	      doc.sel = this.sel;
	      doc.extend = false;
	      if (copyHistory) {
	        doc.history.undoDepth = this.history.undoDepth;
	        doc.setHistory(this.getHistory());
	      }
	      return doc
	    },
	
	    linkedDoc: function(options) {
	      if (!options) { options = {}; }
	      var from = this.first, to = this.first + this.size;
	      if (options.from != null && options.from > from) { from = options.from; }
	      if (options.to != null && options.to < to) { to = options.to; }
	      var copy = new Doc(getLines(this, from, to), options.mode || this.modeOption, from, this.lineSep, this.direction);
	      if (options.sharedHist) { copy.history = this.history
	      ; }(this.linked || (this.linked = [])).push({doc: copy, sharedHist: options.sharedHist});
	      copy.linked = [{doc: this, isParent: true, sharedHist: options.sharedHist}];
	      copySharedMarkers(copy, findSharedMarkers(this));
	      return copy
	    },
	    unlinkDoc: function(other) {
	      if (other instanceof CodeMirror) { other = other.doc; }
	      if (this.linked) { for (var i = 0; i < this.linked.length; ++i) {
	        var link = this.linked[i];
	        if (link.doc != other) { continue }
	        this.linked.splice(i, 1);
	        other.unlinkDoc(this);
	        detachSharedMarkers(findSharedMarkers(this));
	        break
	      } }
	      // If the histories were shared, split them again
	      if (other.history == this.history) {
	        var splitIds = [other.id];
	        linkedDocs(other, function (doc) { return splitIds.push(doc.id); }, true);
	        other.history = new History(null);
	        other.history.done = copyHistoryArray(this.history.done, splitIds);
	        other.history.undone = copyHistoryArray(this.history.undone, splitIds);
	      }
	    },
	    iterLinkedDocs: function(f) {linkedDocs(this, f);},
	
	    getMode: function() {return this.mode},
	    getEditor: function() {return this.cm},
	
	    splitLines: function(str) {
	      if (this.lineSep) { return str.split(this.lineSep) }
	      return splitLinesAuto(str)
	    },
	    lineSeparator: function() { return this.lineSep || "\n" },
	
	    setDirection: docMethodOp(function (dir) {
	      if (dir != "rtl") { dir = "ltr"; }
	      if (dir == this.direction) { return }
	      this.direction = dir;
	      this.iter(function (line) { return line.order = null; });
	      if (this.cm) { directionChanged(this.cm); }
	    })
	  });
	
	  // Public alias.
	  Doc.prototype.eachLine = Doc.prototype.iter;
	
	  // Kludge to work around strange IE behavior where it'll sometimes
	  // re-fire a series of drag-related events right after the drop (#1551)
	  var lastDrop = 0;
	
	  function onDrop(e) {
	    var cm = this;
	    clearDragCursor(cm);
	    if (signalDOMEvent(cm, e) || eventInWidget(cm.display, e))
	      { return }
	    e_preventDefault(e);
	    if (ie) { lastDrop = +new Date; }
	    var pos = posFromMouse(cm, e, true), files = e.dataTransfer.files;
	    if (!pos || cm.isReadOnly()) { return }
	    // Might be a file drop, in which case we simply extract the text
	    // and insert it.
	    if (files && files.length && window.FileReader && window.File) {
	      var n = files.length, text = Array(n), read = 0;
	      var markAsReadAndPasteIfAllFilesAreRead = function () {
	        if (++read == n) {
	          operation(cm, function () {
	            pos = clipPos(cm.doc, pos);
	            var change = {from: pos, to: pos,
	                          text: cm.doc.splitLines(
	                              text.filter(function (t) { return t != null; }).join(cm.doc.lineSeparator())),
	                          origin: "paste"};
	            makeChange(cm.doc, change);
	            setSelectionReplaceHistory(cm.doc, simpleSelection(clipPos(cm.doc, pos), clipPos(cm.doc, changeEnd(change))));
	          })();
	        }
	      };
	      var readTextFromFile = function (file, i) {
	        if (cm.options.allowDropFileTypes &&
	            indexOf(cm.options.allowDropFileTypes, file.type) == -1) {
	          markAsReadAndPasteIfAllFilesAreRead();
	          return
	        }
	        var reader = new FileReader;
	        reader.onerror = function () { return markAsReadAndPasteIfAllFilesAreRead(); };
	        reader.onload = function () {
	          var content = reader.result;
	          if (/[\x00-\x08\x0e-\x1f]{2}/.test(content)) {
	            markAsReadAndPasteIfAllFilesAreRead();
	            return
	          }
	          text[i] = content;
	          markAsReadAndPasteIfAllFilesAreRead();
	        };
	        reader.readAsText(file);
	      };
	      for (var i = 0; i < files.length; i++) { readTextFromFile(files[i], i); }
	    } else { // Normal drop
	      // Don't do a replace if the drop happened inside of the selected text.
	      if (cm.state.draggingText && cm.doc.sel.contains(pos) > -1) {
	        cm.state.draggingText(e);
	        // Ensure the editor is re-focused
	        setTimeout(function () { return cm.display.input.focus(); }, 20);
	        return
	      }
	      try {
	        var text$1 = e.dataTransfer.getData("Text");
	        if (text$1) {
	          var selected;
	          if (cm.state.draggingText && !cm.state.draggingText.copy)
	            { selected = cm.listSelections(); }
	          setSelectionNoUndo(cm.doc, simpleSelection(pos, pos));
	          if (selected) { for (var i$1 = 0; i$1 < selected.length; ++i$1)
	            { replaceRange(cm.doc, "", selected[i$1].anchor, selected[i$1].head, "drag"); } }
	          cm.replaceSelection(text$1, "around", "paste");
	          cm.display.input.focus();
	        }
	      }
	      catch(e){}
	    }
	  }
	
	  function onDragStart(cm, e) {
	    if (ie && (!cm.state.draggingText || +new Date - lastDrop < 100)) { e_stop(e); return }
	    if (signalDOMEvent(cm, e) || eventInWidget(cm.display, e)) { return }
	
	    e.dataTransfer.setData("Text", cm.getSelection());
	    e.dataTransfer.effectAllowed = "copyMove";
	
	    // Use dummy image instead of default browsers image.
	    // Recent Safari (~6.0.2) have a tendency to segfault when this happens, so we don't do it there.
	    if (e.dataTransfer.setDragImage && !safari) {
	      var img = elt("img", null, null, "position: fixed; left: 0; top: 0;");
	      img.src = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
	      if (presto) {
	        img.width = img.height = 1;
	        cm.display.wrapper.appendChild(img);
	        // Force a relayout, or Opera won't use our image for some obscure reason
	        img._top = img.offsetTop;
	      }
	      e.dataTransfer.setDragImage(img, 0, 0);
	      if (presto) { img.parentNode.removeChild(img); }
	    }
	  }
	
	  function onDragOver(cm, e) {
	    var pos = posFromMouse(cm, e);
	    if (!pos) { return }
	    var frag = document.createDocumentFragment();
	    drawSelectionCursor(cm, pos, frag);
	    if (!cm.display.dragCursor) {
	      cm.display.dragCursor = elt("div", null, "CodeMirror-cursors CodeMirror-dragcursors");
	      cm.display.lineSpace.insertBefore(cm.display.dragCursor, cm.display.cursorDiv);
	    }
	    removeChildrenAndAdd(cm.display.dragCursor, frag);
	  }
	
	  function clearDragCursor(cm) {
	    if (cm.display.dragCursor) {
	      cm.display.lineSpace.removeChild(cm.display.dragCursor);
	      cm.display.dragCursor = null;
	    }
	  }
	
	  // These must be handled carefully, because naively registering a
	  // handler for each editor will cause the editors to never be
	  // garbage collected.
	
	  function forEachCodeMirror(f) {
	    if (!document.getElementsByClassName) { return }
	    var byClass = document.getElementsByClassName("CodeMirror"), editors = [];
	    for (var i = 0; i < byClass.length; i++) {
	      var cm = byClass[i].CodeMirror;
	      if (cm) { editors.push(cm); }
	    }
	    if (editors.length) { editors[0].operation(function () {
	      for (var i = 0; i < editors.length; i++) { f(editors[i]); }
	    }); }
	  }
	
	  var globalsRegistered = false;
	  function ensureGlobalHandlers() {
	    if (globalsRegistered) { return }
	    registerGlobalHandlers();
	    globalsRegistered = true;
	  }
	  function registerGlobalHandlers() {
	    // When the window resizes, we need to refresh active editors.
	    var resizeTimer;
	    on(window, "resize", function () {
	      if (resizeTimer == null) { resizeTimer = setTimeout(function () {
	        resizeTimer = null;
	        forEachCodeMirror(onResize);
	      }, 100); }
	    });
	    // When the window loses focus, we want to show the editor as blurred
	    on(window, "blur", function () { return forEachCodeMirror(onBlur); });
	  }
	  // Called when the window resizes
	  function onResize(cm) {
	    var d = cm.display;
	    // Might be a text scaling operation, clear size caches.
	    d.cachedCharWidth = d.cachedTextHeight = d.cachedPaddingH = null;
	    d.scrollbarsClipped = false;
	    cm.setSize();
	  }
	
	  var keyNames = {
	    3: "Pause", 8: "Backspace", 9: "Tab", 13: "Enter", 16: "Shift", 17: "Ctrl", 18: "Alt",
	    19: "Pause", 20: "CapsLock", 27: "Esc", 32: "Space", 33: "PageUp", 34: "PageDown", 35: "End",
	    36: "Home", 37: "Left", 38: "Up", 39: "Right", 40: "Down", 44: "PrintScrn", 45: "Insert",
	    46: "Delete", 59: ";", 61: "=", 91: "Mod", 92: "Mod", 93: "Mod",
	    106: "*", 107: "=", 109: "-", 110: ".", 111: "/", 145: "ScrollLock",
	    173: "-", 186: ";", 187: "=", 188: ",", 189: "-", 190: ".", 191: "/", 192: "`", 219: "[", 220: "\\",
	    221: "]", 222: "'", 63232: "Up", 63233: "Down", 63234: "Left", 63235: "Right", 63272: "Delete",
	    63273: "Home", 63275: "End", 63276: "PageUp", 63277: "PageDown", 63302: "Insert"
	  };
	
	  // Number keys
	  for (var i = 0; i < 10; i++) { keyNames[i + 48] = keyNames[i + 96] = String(i); }
	  // Alphabetic keys
	  for (var i$1 = 65; i$1 <= 90; i$1++) { keyNames[i$1] = String.fromCharCode(i$1); }
	  // Function keys
	  for (var i$2 = 1; i$2 <= 12; i$2++) { keyNames[i$2 + 111] = keyNames[i$2 + 63235] = "F" + i$2; }
	
	  var keyMap = {};
	
	  keyMap.basic = {
	    "Left": "goCharLeft", "Right": "goCharRight", "Up": "goLineUp", "Down": "goLineDown",
	    "End": "goLineEnd", "Home": "goLineStartSmart", "PageUp": "goPageUp", "PageDown": "goPageDown",
	    "Delete": "delCharAfter", "Backspace": "delCharBefore", "Shift-Backspace": "delCharBefore",
	    "Tab": "defaultTab", "Shift-Tab": "indentAuto",
	    "Enter": "newlineAndIndent", "Insert": "toggleOverwrite",
	    "Esc": "singleSelection"
	  };
	  // Note that the save and find-related commands aren't defined by
	  // default. User code or addons can define them. Unknown commands
	  // are simply ignored.
	  keyMap.pcDefault = {
	    "Ctrl-A": "selectAll", "Ctrl-D": "deleteLine", "Ctrl-Z": "undo", "Shift-Ctrl-Z": "redo", "Ctrl-Y": "redo",
	    "Ctrl-Home": "goDocStart", "Ctrl-End": "goDocEnd", "Ctrl-Up": "goLineUp", "Ctrl-Down": "goLineDown",
	    "Ctrl-Left": "goGroupLeft", "Ctrl-Right": "goGroupRight", "Alt-Left": "goLineStart", "Alt-Right": "goLineEnd",
	    "Ctrl-Backspace": "delGroupBefore", "Ctrl-Delete": "delGroupAfter", "Ctrl-S": "save", "Ctrl-F": "find",
	    "Ctrl-G": "findNext", "Shift-Ctrl-G": "findPrev", "Shift-Ctrl-F": "replace", "Shift-Ctrl-R": "replaceAll",
	    "Ctrl-[": "indentLess", "Ctrl-]": "indentMore",
	    "Ctrl-U": "undoSelection", "Shift-Ctrl-U": "redoSelection", "Alt-U": "redoSelection",
	    "fallthrough": "basic"
	  };
	  // Very basic readline/emacs-style bindings, which are standard on Mac.
	  keyMap.emacsy = {
	    "Ctrl-F": "goCharRight", "Ctrl-B": "goCharLeft", "Ctrl-P": "goLineUp", "Ctrl-N": "goLineDown",
	    "Alt-F": "goWordRight", "Alt-B": "goWordLeft", "Ctrl-A": "goLineStart", "Ctrl-E": "goLineEnd",
	    "Ctrl-V": "goPageDown", "Shift-Ctrl-V": "goPageUp", "Ctrl-D": "delCharAfter", "Ctrl-H": "delCharBefore",
	    "Alt-D": "delWordAfter", "Alt-Backspace": "delWordBefore", "Ctrl-K": "killLine", "Ctrl-T": "transposeChars",
	    "Ctrl-O": "openLine"
	  };
	  keyMap.macDefault = {
	    "Cmd-A": "selectAll", "Cmd-D": "deleteLine", "Cmd-Z": "undo", "Shift-Cmd-Z": "redo", "Cmd-Y": "redo",
	    "Cmd-Home": "goDocStart", "Cmd-Up": "goDocStart", "Cmd-End": "goDocEnd", "Cmd-Down": "goDocEnd", "Alt-Left": "goGroupLeft",
	    "Alt-Right": "goGroupRight", "Cmd-Left": "goLineLeft", "Cmd-Right": "goLineRight", "Alt-Backspace": "delGroupBefore",
	    "Ctrl-Alt-Backspace": "delGroupAfter", "Alt-Delete": "delGroupAfter", "Cmd-S": "save", "Cmd-F": "find",
	    "Cmd-G": "findNext", "Shift-Cmd-G": "findPrev", "Cmd-Alt-F": "replace", "Shift-Cmd-Alt-F": "replaceAll",
	    "Cmd-[": "indentLess", "Cmd-]": "indentMore", "Cmd-Backspace": "delWrappedLineLeft", "Cmd-Delete": "delWrappedLineRight",
	    "Cmd-U": "undoSelection", "Shift-Cmd-U": "redoSelection", "Ctrl-Up": "goDocStart", "Ctrl-Down": "goDocEnd",
	    "fallthrough": ["basic", "emacsy"]
	  };
	  keyMap["default"] = mac ? keyMap.macDefault : keyMap.pcDefault;
	
	  // KEYMAP DISPATCH
	
	  function normalizeKeyName(name) {
	    var parts = name.split(/-(?!$)/);
	    name = parts[parts.length - 1];
	    var alt, ctrl, shift, cmd;
	    for (var i = 0; i < parts.length - 1; i++) {
	      var mod = parts[i];
	      if (/^(cmd|meta|m)$/i.test(mod)) { cmd = true; }
	      else if (/^a(lt)?$/i.test(mod)) { alt = true; }
	      else if (/^(c|ctrl|control)$/i.test(mod)) { ctrl = true; }
	      else if (/^s(hift)?$/i.test(mod)) { shift = true; }
	      else { throw new Error("Unrecognized modifier name: " + mod) }
	    }
	    if (alt) { name = "Alt-" + name; }
	    if (ctrl) { name = "Ctrl-" + name; }
	    if (cmd) { name = "Cmd-" + name; }
	    if (shift) { name = "Shift-" + name; }
	    return name
	  }
	
	  // This is a kludge to keep keymaps mostly working as raw objects
	  // (backwards compatibility) while at the same time support features
	  // like normalization and multi-stroke key bindings. It compiles a
	  // new normalized keymap, and then updates the old object to reflect
	  // this.
	  function normalizeKeyMap(keymap) {
	    var copy = {};
	    for (var keyname in keymap) { if (keymap.hasOwnProperty(keyname)) {
	      var value = keymap[keyname];
	      if (/^(name|fallthrough|(de|at)tach)$/.test(keyname)) { continue }
	      if (value == "...") { delete keymap[keyname]; continue }
	
	      var keys = map(keyname.split(" "), normalizeKeyName);
	      for (var i = 0; i < keys.length; i++) {
	        var val = (void 0), name = (void 0);
	        if (i == keys.length - 1) {
	          name = keys.join(" ");
	          val = value;
	        } else {
	          name = keys.slice(0, i + 1).join(" ");
	          val = "...";
	        }
	        var prev = copy[name];
	        if (!prev) { copy[name] = val; }
	        else if (prev != val) { throw new Error("Inconsistent bindings for " + name) }
	      }
	      delete keymap[keyname];
	    } }
	    for (var prop in copy) { keymap[prop] = copy[prop]; }
	    return keymap
	  }
	
	  function lookupKey(key, map, handle, context) {
	    map = getKeyMap(map);
	    var found = map.call ? map.call(key, context) : map[key];
	    if (found === false) { return "nothing" }
	    if (found === "...") { return "multi" }
	    if (found != null && handle(found)) { return "handled" }
	
	    if (map.fallthrough) {
	      if (Object.prototype.toString.call(map.fallthrough) != "[object Array]")
	        { return lookupKey(key, map.fallthrough, handle, context) }
	      for (var i = 0; i < map.fallthrough.length; i++) {
	        var result = lookupKey(key, map.fallthrough[i], handle, context);
	        if (result) { return result }
	      }
	    }
	  }
	
	  // Modifier key presses don't count as 'real' key presses for the
	  // purpose of keymap fallthrough.
	  function isModifierKey(value) {
	    var name = typeof value == "string" ? value : keyNames[value.keyCode];
	    return name == "Ctrl" || name == "Alt" || name == "Shift" || name == "Mod"
	  }
	
	  function addModifierNames(name, event, noShift) {
	    var base = name;
	    if (event.altKey && base != "Alt") { name = "Alt-" + name; }
	    if ((flipCtrlCmd ? event.metaKey : event.ctrlKey) && base != "Ctrl") { name = "Ctrl-" + name; }
	    if ((flipCtrlCmd ? event.ctrlKey : event.metaKey) && base != "Cmd") { name = "Cmd-" + name; }
	    if (!noShift && event.shiftKey && base != "Shift") { name = "Shift-" + name; }
	    return name
	  }
	
	  // Look up the name of a key as indicated by an event object.
	  function keyName(event, noShift) {
	    if (presto && event.keyCode == 34 && event["char"]) { return false }
	    var name = keyNames[event.keyCode];
	    if (name == null || event.altGraphKey) { return false }
	    // Ctrl-ScrollLock has keyCode 3, same as Ctrl-Pause,
	    // so we'll use event.code when available (Chrome 48+, FF 38+, Safari 10.1+)
	    if (event.keyCode == 3 && event.code) { name = event.code; }
	    return addModifierNames(name, event, noShift)
	  }
	
	  function getKeyMap(val) {
	    return typeof val == "string" ? keyMap[val] : val
	  }
	
	  // Helper for deleting text near the selection(s), used to implement
	  // backspace, delete, and similar functionality.
	  function deleteNearSelection(cm, compute) {
	    var ranges = cm.doc.sel.ranges, kill = [];
	    // Build up a set of ranges to kill first, merging overlapping
	    // ranges.
	    for (var i = 0; i < ranges.length; i++) {
	      var toKill = compute(ranges[i]);
	      while (kill.length && cmp(toKill.from, lst(kill).to) <= 0) {
	        var replaced = kill.pop();
	        if (cmp(replaced.from, toKill.from) < 0) {
	          toKill.from = replaced.from;
	          break
	        }
	      }
	      kill.push(toKill);
	    }
	    // Next, remove those actual ranges.
	    runInOp(cm, function () {
	      for (var i = kill.length - 1; i >= 0; i--)
	        { replaceRange(cm.doc, "", kill[i].from, kill[i].to, "+delete"); }
	      ensureCursorVisible(cm);
	    });
	  }
	
	  function moveCharLogically(line, ch, dir) {
	    var target = skipExtendingChars(line.text, ch + dir, dir);
	    return target < 0 || target > line.text.length ? null : target
	  }
	
	  function moveLogically(line, start, dir) {
	    var ch = moveCharLogically(line, start.ch, dir);
	    return ch == null ? null : new Pos(start.line, ch, dir < 0 ? "after" : "before")
	  }
	
	  function endOfLine(visually, cm, lineObj, lineNo, dir) {
	    if (visually) {
	      if (cm.doc.direction == "rtl") { dir = -dir; }
	      var order = getOrder(lineObj, cm.doc.direction);
	      if (order) {
	        var part = dir < 0 ? lst(order) : order[0];
	        var moveInStorageOrder = (dir < 0) == (part.level == 1);
	        var sticky = moveInStorageOrder ? "after" : "before";
	        var ch;
	        // With a wrapped rtl chunk (possibly spanning multiple bidi parts),
	        // it could be that the last bidi part is not on the last visual line,
	        // since visual lines contain content order-consecutive chunks.
	        // Thus, in rtl, we are looking for the first (content-order) character
	        // in the rtl chunk that is on the last line (that is, the same line
	        // as the last (content-order) character).
	        if (part.level > 0 || cm.doc.direction == "rtl") {
	          var prep = prepareMeasureForLine(cm, lineObj);
	          ch = dir < 0 ? lineObj.text.length - 1 : 0;
	          var targetTop = measureCharPrepared(cm, prep, ch).top;
	          ch = findFirst(function (ch) { return measureCharPrepared(cm, prep, ch).top == targetTop; }, (dir < 0) == (part.level == 1) ? part.from : part.to - 1, ch);
	          if (sticky == "before") { ch = moveCharLogically(lineObj, ch, 1); }
	        } else { ch = dir < 0 ? part.to : part.from; }
	        return new Pos(lineNo, ch, sticky)
	      }
	    }
	    return new Pos(lineNo, dir < 0 ? lineObj.text.length : 0, dir < 0 ? "before" : "after")
	  }
	
	  function moveVisually(cm, line, start, dir) {
	    var bidi = getOrder(line, cm.doc.direction);
	    if (!bidi) { return moveLogically(line, start, dir) }
	    if (start.ch >= line.text.length) {
	      start.ch = line.text.length;
	      start.sticky = "before";
	    } else if (start.ch <= 0) {
	      start.ch = 0;
	      start.sticky = "after";
	    }
	    var partPos = getBidiPartAt(bidi, start.ch, start.sticky), part = bidi[partPos];
	    if (cm.doc.direction == "ltr" && part.level % 2 == 0 && (dir > 0 ? part.to > start.ch : part.from < start.ch)) {
	      // Case 1: We move within an ltr part in an ltr editor. Even with wrapped lines,
	      // nothing interesting happens.
	      return moveLogically(line, start, dir)
	    }
	
	    var mv = function (pos, dir) { return moveCharLogically(line, pos instanceof Pos ? pos.ch : pos, dir); };
	    var prep;
	    var getWrappedLineExtent = function (ch) {
	      if (!cm.options.lineWrapping) { return {begin: 0, end: line.text.length} }
	      prep = prep || prepareMeasureForLine(cm, line);
	      return wrappedLineExtentChar(cm, line, prep, ch)
	    };
	    var wrappedLineExtent = getWrappedLineExtent(start.sticky == "before" ? mv(start, -1) : start.ch);
	
	    if (cm.doc.direction == "rtl" || part.level == 1) {
	      var moveInStorageOrder = (part.level == 1) == (dir < 0);
	      var ch = mv(start, moveInStorageOrder ? 1 : -1);
	      if (ch != null && (!moveInStorageOrder ? ch >= part.from && ch >= wrappedLineExtent.begin : ch <= part.to && ch <= wrappedLineExtent.end)) {
	        // Case 2: We move within an rtl part or in an rtl editor on the same visual line
	        var sticky = moveInStorageOrder ? "before" : "after";
	        return new Pos(start.line, ch, sticky)
	      }
	    }
	
	    // Case 3: Could not move within this bidi part in this visual line, so leave
	    // the current bidi part
	
	    var searchInVisualLine = function (partPos, dir, wrappedLineExtent) {
	      var getRes = function (ch, moveInStorageOrder) { return moveInStorageOrder
	        ? new Pos(start.line, mv(ch, 1), "before")
	        : new Pos(start.line, ch, "after"); };
	
	      for (; partPos >= 0 && partPos < bidi.length; partPos += dir) {
	        var part = bidi[partPos];
	        var moveInStorageOrder = (dir > 0) == (part.level != 1);
	        var ch = moveInStorageOrder ? wrappedLineExtent.begin : mv(wrappedLineExtent.end, -1);
	        if (part.from <= ch && ch < part.to) { return getRes(ch, moveInStorageOrder) }
	        ch = moveInStorageOrder ? part.from : mv(part.to, -1);
	        if (wrappedLineExtent.begin <= ch && ch < wrappedLineExtent.end) { return getRes(ch, moveInStorageOrder) }
	      }
	    };
	
	    // Case 3a: Look for other bidi parts on the same visual line
	    var res = searchInVisualLine(partPos + dir, dir, wrappedLineExtent);
	    if (res) { return res }
	
	    // Case 3b: Look for other bidi parts on the next visual line
	    var nextCh = dir > 0 ? wrappedLineExtent.end : mv(wrappedLineExtent.begin, -1);
	    if (nextCh != null && !(dir > 0 && nextCh == line.text.length)) {
	      res = searchInVisualLine(dir > 0 ? 0 : bidi.length - 1, dir, getWrappedLineExtent(nextCh));
	      if (res) { return res }
	    }
	
	    // Case 4: Nowhere to move
	    return null
	  }
	
	  // Commands are parameter-less actions that can be performed on an
	  // editor, mostly used for keybindings.
	  var commands = {
	    selectAll: selectAll,
	    singleSelection: function (cm) { return cm.setSelection(cm.getCursor("anchor"), cm.getCursor("head"), sel_dontScroll); },
	    killLine: function (cm) { return deleteNearSelection(cm, function (range) {
	      if (range.empty()) {
	        var len = getLine(cm.doc, range.head.line).text.length;
	        if (range.head.ch == len && range.head.line < cm.lastLine())
	          { return {from: range.head, to: Pos(range.head.line + 1, 0)} }
	        else
	          { return {from: range.head, to: Pos(range.head.line, len)} }
	      } else {
	        return {from: range.from(), to: range.to()}
	      }
	    }); },
	    deleteLine: function (cm) { return deleteNearSelection(cm, function (range) { return ({
	      from: Pos(range.from().line, 0),
	      to: clipPos(cm.doc, Pos(range.to().line + 1, 0))
	    }); }); },
	    delLineLeft: function (cm) { return deleteNearSelection(cm, function (range) { return ({
	      from: Pos(range.from().line, 0), to: range.from()
	    }); }); },
	    delWrappedLineLeft: function (cm) { return deleteNearSelection(cm, function (range) {
	      var top = cm.charCoords(range.head, "div").top + 5;
	      var leftPos = cm.coordsChar({left: 0, top: top}, "div");
	      return {from: leftPos, to: range.from()}
	    }); },
	    delWrappedLineRight: function (cm) { return deleteNearSelection(cm, function (range) {
	      var top = cm.charCoords(range.head, "div").top + 5;
	      var rightPos = cm.coordsChar({left: cm.display.lineDiv.offsetWidth + 100, top: top}, "div");
	      return {from: range.from(), to: rightPos }
	    }); },
	    undo: function (cm) { return cm.undo(); },
	    redo: function (cm) { return cm.redo(); },
	    undoSelection: function (cm) { return cm.undoSelection(); },
	    redoSelection: function (cm) { return cm.redoSelection(); },
	    goDocStart: function (cm) { return cm.extendSelection(Pos(cm.firstLine(), 0)); },
	    goDocEnd: function (cm) { return cm.extendSelection(Pos(cm.lastLine())); },
	    goLineStart: function (cm) { return cm.extendSelectionsBy(function (range) { return lineStart(cm, range.head.line); },
	      {origin: "+move", bias: 1}
	    ); },
	    goLineStartSmart: function (cm) { return cm.extendSelectionsBy(function (range) { return lineStartSmart(cm, range.head); },
	      {origin: "+move", bias: 1}
	    ); },
	    goLineEnd: function (cm) { return cm.extendSelectionsBy(function (range) { return lineEnd(cm, range.head.line); },
	      {origin: "+move", bias: -1}
	    ); },
	    goLineRight: function (cm) { return cm.extendSelectionsBy(function (range) {
	      var top = cm.cursorCoords(range.head, "div").top + 5;
	      return cm.coordsChar({left: cm.display.lineDiv.offsetWidth + 100, top: top}, "div")
	    }, sel_move); },
	    goLineLeft: function (cm) { return cm.extendSelectionsBy(function (range) {
	      var top = cm.cursorCoords(range.head, "div").top + 5;
	      return cm.coordsChar({left: 0, top: top}, "div")
	    }, sel_move); },
	    goLineLeftSmart: function (cm) { return cm.extendSelectionsBy(function (range) {
	      var top = cm.cursorCoords(range.head, "div").top + 5;
	      var pos = cm.coordsChar({left: 0, top: top}, "div");
	      if (pos.ch < cm.getLine(pos.line).search(/\S/)) { return lineStartSmart(cm, range.head) }
	      return pos
	    }, sel_move); },
	    goLineUp: function (cm) { return cm.moveV(-1, "line"); },
	    goLineDown: function (cm) { return cm.moveV(1, "line"); },
	    goPageUp: function (cm) { return cm.moveV(-1, "page"); },
	    goPageDown: function (cm) { return cm.moveV(1, "page"); },
	    goCharLeft: function (cm) { return cm.moveH(-1, "char"); },
	    goCharRight: function (cm) { return cm.moveH(1, "char"); },
	    goColumnLeft: function (cm) { return cm.moveH(-1, "column"); },
	    goColumnRight: function (cm) { return cm.moveH(1, "column"); },
	    goWordLeft: function (cm) { return cm.moveH(-1, "word"); },
	    goGroupRight: function (cm) { return cm.moveH(1, "group"); },
	    goGroupLeft: function (cm) { return cm.moveH(-1, "group"); },
	    goWordRight: function (cm) { return cm.moveH(1, "word"); },
	    delCharBefore: function (cm) { return cm.deleteH(-1, "char"); },
	    delCharAfter: function (cm) { return cm.deleteH(1, "char"); },
	    delWordBefore: function (cm) { return cm.deleteH(-1, "word"); },
	    delWordAfter: function (cm) { return cm.deleteH(1, "word"); },
	    delGroupBefore: function (cm) { return cm.deleteH(-1, "group"); },
	    delGroupAfter: function (cm) { return cm.deleteH(1, "group"); },
	    indentAuto: function (cm) { return cm.indentSelection("smart"); },
	    indentMore: function (cm) { return cm.indentSelection("add"); },
	    indentLess: function (cm) { return cm.indentSelection("subtract"); },
	    insertTab: function (cm) { return cm.replaceSelection("\t"); },
	    insertSoftTab: function (cm) {
	      var spaces = [], ranges = cm.listSelections(), tabSize = cm.options.tabSize;
	      for (var i = 0; i < ranges.length; i++) {
	        var pos = ranges[i].from();
	        var col = countColumn(cm.getLine(pos.line), pos.ch, tabSize);
	        spaces.push(spaceStr(tabSize - col % tabSize));
	      }
	      cm.replaceSelections(spaces);
	    },
	    defaultTab: function (cm) {
	      if (cm.somethingSelected()) { cm.indentSelection("add"); }
	      else { cm.execCommand("insertTab"); }
	    },
	    // Swap the two chars left and right of each selection's head.
	    // Move cursor behind the two swapped characters afterwards.
	    //
	    // Doesn't consider line feeds a character.
	    // Doesn't scan more than one line above to find a character.
	    // Doesn't do anything on an empty line.
	    // Doesn't do anything with non-empty selections.
	    transposeChars: function (cm) { return runInOp(cm, function () {
	      var ranges = cm.listSelections(), newSel = [];
	      for (var i = 0; i < ranges.length; i++) {
	        if (!ranges[i].empty()) { continue }
	        var cur = ranges[i].head, line = getLine(cm.doc, cur.line).text;
	        if (line) {
	          if (cur.ch == line.length) { cur = new Pos(cur.line, cur.ch - 1); }
	          if (cur.ch > 0) {
	            cur = new Pos(cur.line, cur.ch + 1);
	            cm.replaceRange(line.charAt(cur.ch - 1) + line.charAt(cur.ch - 2),
	                            Pos(cur.line, cur.ch - 2), cur, "+transpose");
	          } else if (cur.line > cm.doc.first) {
	            var prev = getLine(cm.doc, cur.line - 1).text;
	            if (prev) {
	              cur = new Pos(cur.line, 1);
	              cm.replaceRange(line.charAt(0) + cm.doc.lineSeparator() +
	                              prev.charAt(prev.length - 1),
	                              Pos(cur.line - 1, prev.length - 1), cur, "+transpose");
	            }
	          }
	        }
	        newSel.push(new Range(cur, cur));
	      }
	      cm.setSelections(newSel);
	    }); },
	    newlineAndIndent: function (cm) { return runInOp(cm, function () {
	      var sels = cm.listSelections();
	      for (var i = sels.length - 1; i >= 0; i--)
	        { cm.replaceRange(cm.doc.lineSeparator(), sels[i].anchor, sels[i].head, "+input"); }
	      sels = cm.listSelections();
	      for (var i$1 = 0; i$1 < sels.length; i$1++)
	        { cm.indentLine(sels[i$1].from().line, null, true); }
	      ensureCursorVisible(cm);
	    }); },
	    openLine: function (cm) { return cm.replaceSelection("\n", "start"); },
	    toggleOverwrite: function (cm) { return cm.toggleOverwrite(); }
	  };
	
	
	  function lineStart(cm, lineN) {
	    var line = getLine(cm.doc, lineN);
	    var visual = visualLine(line);
	    if (visual != line) { lineN = lineNo(visual); }
	    return endOfLine(true, cm, visual, lineN, 1)
	  }
	  function lineEnd(cm, lineN) {
	    var line = getLine(cm.doc, lineN);
	    var visual = visualLineEnd(line);
	    if (visual != line) { lineN = lineNo(visual); }
	    return endOfLine(true, cm, line, lineN, -1)
	  }
	  function lineStartSmart(cm, pos) {
	    var start = lineStart(cm, pos.line);
	    var line = getLine(cm.doc, start.line);
	    var order = getOrder(line, cm.doc.direction);
	    if (!order || order[0].level == 0) {
	      var firstNonWS = Math.max(start.ch, line.text.search(/\S/));
	      var inWS = pos.line == start.line && pos.ch <= firstNonWS && pos.ch;
	      return Pos(start.line, inWS ? 0 : firstNonWS, start.sticky)
	    }
	    return start
	  }
	
	  // Run a handler that was bound to a key.
	  function doHandleBinding(cm, bound, dropShift) {
	    if (typeof bound == "string") {
	      bound = commands[bound];
	      if (!bound) { return false }
	    }
	    // Ensure previous input has been read, so that the handler sees a
	    // consistent view of the document
	    cm.display.input.ensurePolled();
	    var prevShift = cm.display.shift, done = false;
	    try {
	      if (cm.isReadOnly()) { cm.state.suppressEdits = true; }
	      if (dropShift) { cm.display.shift = false; }
	      done = bound(cm) != Pass;
	    } finally {
	      cm.display.shift = prevShift;
	      cm.state.suppressEdits = false;
	    }
	    return done
	  }
	
	  function lookupKeyForEditor(cm, name, handle) {
	    for (var i = 0; i < cm.state.keyMaps.length; i++) {
	      var result = lookupKey(name, cm.state.keyMaps[i], handle, cm);
	      if (result) { return result }
	    }
	    return (cm.options.extraKeys && lookupKey(name, cm.options.extraKeys, handle, cm))
	      || lookupKey(name, cm.options.keyMap, handle, cm)
	  }
	
	  // Note that, despite the name, this function is also used to check
	  // for bound mouse clicks.
	
	  var stopSeq = new Delayed;
	
	  function dispatchKey(cm, name, e, handle) {
	    var seq = cm.state.keySeq;
	    if (seq) {
	      if (isModifierKey(name)) { return "handled" }
	      if (/\'$/.test(name))
	        { cm.state.keySeq = null; }
	      else
	        { stopSeq.set(50, function () {
	          if (cm.state.keySeq == seq) {
	            cm.state.keySeq = null;
	            cm.display.input.reset();
	          }
	        }); }
	      if (dispatchKeyInner(cm, seq + " " + name, e, handle)) { return true }
	    }
	    return dispatchKeyInner(cm, name, e, handle)
	  }
	
	  function dispatchKeyInner(cm, name, e, handle) {
	    var result = lookupKeyForEditor(cm, name, handle);
	
	    if (result == "multi")
	      { cm.state.keySeq = name; }
	    if (result == "handled")
	      { signalLater(cm, "keyHandled", cm, name, e); }
	
	    if (result == "handled" || result == "multi") {
	      e_preventDefault(e);
	      restartBlink(cm);
	    }
	
	    return !!result
	  }
	
	  // Handle a key from the keydown event.
	  function handleKeyBinding(cm, e) {
	    var name = keyName(e, true);
	    if (!name) { return false }
	
	    if (e.shiftKey && !cm.state.keySeq) {
	      // First try to resolve full name (including 'Shift-'). Failing
	      // that, see if there is a cursor-motion command (starting with
	      // 'go') bound to the keyname without 'Shift-'.
	      return dispatchKey(cm, "Shift-" + name, e, function (b) { return doHandleBinding(cm, b, true); })
	          || dispatchKey(cm, name, e, function (b) {
	               if (typeof b == "string" ? /^go[A-Z]/.test(b) : b.motion)
	                 { return doHandleBinding(cm, b) }
	             })
	    } else {
	      return dispatchKey(cm, name, e, function (b) { return doHandleBinding(cm, b); })
	    }
	  }
	
	  // Handle a key from the keypress event
	  function handleCharBinding(cm, e, ch) {
	    return dispatchKey(cm, "'" + ch + "'", e, function (b) { return doHandleBinding(cm, b, true); })
	  }
	
	  var lastStoppedKey = null;
	  function onKeyDown(e) {
	    var cm = this;
	    cm.curOp.focus = activeElt();
	    if (signalDOMEvent(cm, e)) { return }
	    // IE does strange things with escape.
	    if (ie && ie_version < 11 && e.keyCode == 27) { e.returnValue = false; }
	    var code = e.keyCode;
	    cm.display.shift = code == 16 || e.shiftKey;
	    var handled = handleKeyBinding(cm, e);
	    if (presto) {
	      lastStoppedKey = handled ? code : null;
	      // Opera has no cut event... we try to at least catch the key combo
	      if (!handled && code == 88 && !hasCopyEvent && (mac ? e.metaKey : e.ctrlKey))
	        { cm.replaceSelection("", null, "cut"); }
	    }
	    if (gecko && !mac && !handled && code == 46 && e.shiftKey && !e.ctrlKey && document.execCommand)
	      { document.execCommand("cut"); }
	
	    // Turn mouse into crosshair when Alt is held on Mac.
	    if (code == 18 && !/\bCodeMirror-crosshair\b/.test(cm.display.lineDiv.className))
	      { showCrossHair(cm); }
	  }
	
	  function showCrossHair(cm) {
	    var lineDiv = cm.display.lineDiv;
	    addClass(lineDiv, "CodeMirror-crosshair");
	
	    function up(e) {
	      if (e.keyCode == 18 || !e.altKey) {
	        rmClass(lineDiv, "CodeMirror-crosshair");
	        off(document, "keyup", up);
	        off(document, "mouseover", up);
	      }
	    }
	    on(document, "keyup", up);
	    on(document, "mouseover", up);
	  }
	
	  function onKeyUp(e) {
	    if (e.keyCode == 16) { this.doc.sel.shift = false; }
	    signalDOMEvent(this, e);
	  }
	
	  function onKeyPress(e) {
	    var cm = this;
	    if (eventInWidget(cm.display, e) || signalDOMEvent(cm, e) || e.ctrlKey && !e.altKey || mac && e.metaKey) { return }
	    var keyCode = e.keyCode, charCode = e.charCode;
	    if (presto && keyCode == lastStoppedKey) {lastStoppedKey = null; e_preventDefault(e); return}
	    if ((presto && (!e.which || e.which < 10)) && handleKeyBinding(cm, e)) { return }
	    var ch = String.fromCharCode(charCode == null ? keyCode : charCode);
	    // Some browsers fire keypress events for backspace
	    if (ch == "\x08") { return }
	    if (handleCharBinding(cm, e, ch)) { return }
	    cm.display.input.onKeyPress(e);
	  }
	
	  var DOUBLECLICK_DELAY = 400;
	
	  var PastClick = function(time, pos, button) {
	    this.time = time;
	    this.pos = pos;
	    this.button = button;
	  };
	
	  PastClick.prototype.compare = function (time, pos, button) {
	    return this.time + DOUBLECLICK_DELAY > time &&
	      cmp(pos, this.pos) == 0 && button == this.button
	  };
	
	  var lastClick, lastDoubleClick;
	  function clickRepeat(pos, button) {
	    var now = +new Date;
	    if (lastDoubleClick && lastDoubleClick.compare(now, pos, button)) {
	      lastClick = lastDoubleClick = null;
	      return "triple"
	    } else if (lastClick && lastClick.compare(now, pos, button)) {
	      lastDoubleClick = new PastClick(now, pos, button);
	      lastClick = null;
	      return "double"
	    } else {
	      lastClick = new PastClick(now, pos, button);
	      lastDoubleClick = null;
	      return "single"
	    }
	  }
	
	  // A mouse down can be a single click, double click, triple click,
	  // start of selection drag, start of text drag, new cursor
	  // (ctrl-click), rectangle drag (alt-drag), or xwin
	  // middle-click-paste. Or it might be a click on something we should
	  // not interfere with, such as a scrollbar or widget.
	  function onMouseDown(e) {
	    var cm = this, display = cm.display;
	    if (signalDOMEvent(cm, e) || display.activeTouch && display.input.supportsTouch()) { return }
	    display.input.ensurePolled();
	    display.shift = e.shiftKey;
	
	    if (eventInWidget(display, e)) {
	      if (!webkit) {
	        // Briefly turn off draggability, to allow widgets to do
	        // normal dragging things.
	        display.scroller.draggable = false;
	        setTimeout(function () { return display.scroller.draggable = true; }, 100);
	      }
	      return
	    }
	    if (clickInGutter(cm, e)) { return }
	    var pos = posFromMouse(cm, e), button = e_button(e), repeat = pos ? clickRepeat(pos, button) : "single";
	    window.focus();
	
	    // #3261: make sure, that we're not starting a second selection
	    if (button == 1 && cm.state.selectingText)
	      { cm.state.selectingText(e); }
	
	    if (pos && handleMappedButton(cm, button, pos, repeat, e)) { return }
	
	    if (button == 1) {
	      if (pos) { leftButtonDown(cm, pos, repeat, e); }
	      else if (e_target(e) == display.scroller) { e_preventDefault(e); }
	    } else if (button == 2) {
	      if (pos) { extendSelection(cm.doc, pos); }
	      setTimeout(function () { return display.input.focus(); }, 20);
	    } else if (button == 3) {
	      if (captureRightClick) { cm.display.input.onContextMenu(e); }
	      else { delayBlurEvent(cm); }
	    }
	  }
	
	  function handleMappedButton(cm, button, pos, repeat, event) {
	    var name = "Click";
	    if (repeat == "double") { name = "Double" + name; }
	    else if (repeat == "triple") { name = "Triple" + name; }
	    name = (button == 1 ? "Left" : button == 2 ? "Middle" : "Right") + name;
	
	    return dispatchKey(cm,  addModifierNames(name, event), event, function (bound) {
	      if (typeof bound == "string") { bound = commands[bound]; }
	      if (!bound) { return false }
	      var done = false;
	      try {
	        if (cm.isReadOnly()) { cm.state.suppressEdits = true; }
	        done = bound(cm, pos) != Pass;
	      } finally {
	        cm.state.suppressEdits = false;
	      }
	      return done
	    })
	  }
	
	  function configureMouse(cm, repeat, event) {
	    var option = cm.getOption("configureMouse");
	    var value = option ? option(cm, repeat, event) : {};
	    if (value.unit == null) {
	      var rect = chromeOS ? event.shiftKey && event.metaKey : event.altKey;
	      value.unit = rect ? "rectangle" : repeat == "single" ? "char" : repeat == "double" ? "word" : "line";
	    }
	    if (value.extend == null || cm.doc.extend) { value.extend = cm.doc.extend || event.shiftKey; }
	    if (value.addNew == null) { value.addNew = mac ? event.metaKey : event.ctrlKey; }
	    if (value.moveOnDrag == null) { value.moveOnDrag = !(mac ? event.altKey : event.ctrlKey); }
	    return value
	  }
	
	  function leftButtonDown(cm, pos, repeat, event) {
	    if (ie) { setTimeout(bind(ensureFocus, cm), 0); }
	    else { cm.curOp.focus = activeElt(); }
	
	    var behavior = configureMouse(cm, repeat, event);
	
	    var sel = cm.doc.sel, contained;
	    if (cm.options.dragDrop && dragAndDrop && !cm.isReadOnly() &&
	        repeat == "single" && (contained = sel.contains(pos)) > -1 &&
	        (cmp((contained = sel.ranges[contained]).from(), pos) < 0 || pos.xRel > 0) &&
	        (cmp(contained.to(), pos) > 0 || pos.xRel < 0))
	      { leftButtonStartDrag(cm, event, pos, behavior); }
	    else
	      { leftButtonSelect(cm, event, pos, behavior); }
	  }
	
	  // Start a text drag. When it ends, see if any dragging actually
	  // happen, and treat as a click if it didn't.
	  function leftButtonStartDrag(cm, event, pos, behavior) {
	    var display = cm.display, moved = false;
	    var dragEnd = operation(cm, function (e) {
	      if (webkit) { display.scroller.draggable = false; }
	      cm.state.draggingText = false;
	      off(display.wrapper.ownerDocument, "mouseup", dragEnd);
	      off(display.wrapper.ownerDocument, "mousemove", mouseMove);
	      off(display.scroller, "dragstart", dragStart);
	      off(display.scroller, "drop", dragEnd);
	      if (!moved) {
	        e_preventDefault(e);
	        if (!behavior.addNew)
	          { extendSelection(cm.doc, pos, null, null, behavior.extend); }
	        // Work around unexplainable focus problem in IE9 (#2127) and Chrome (#3081)
	        if (webkit || ie && ie_version == 9)
	          { setTimeout(function () {display.wrapper.ownerDocument.body.focus(); display.input.focus();}, 20); }
	        else
	          { display.input.focus(); }
	      }
	    });
	    var mouseMove = function(e2) {
	      moved = moved || Math.abs(event.clientX - e2.clientX) + Math.abs(event.clientY - e2.clientY) >= 10;
	    };
	    var dragStart = function () { return moved = true; };
	    // Let the drag handler handle this.
	    if (webkit) { display.scroller.draggable = true; }
	    cm.state.draggingText = dragEnd;
	    dragEnd.copy = !behavior.moveOnDrag;
	    // IE's approach to draggable
	    if (display.scroller.dragDrop) { display.scroller.dragDrop(); }
	    on(display.wrapper.ownerDocument, "mouseup", dragEnd);
	    on(display.wrapper.ownerDocument, "mousemove", mouseMove);
	    on(display.scroller, "dragstart", dragStart);
	    on(display.scroller, "drop", dragEnd);
	
	    delayBlurEvent(cm);
	    setTimeout(function () { return display.input.focus(); }, 20);
	  }
	
	  function rangeForUnit(cm, pos, unit) {
	    if (unit == "char") { return new Range(pos, pos) }
	    if (unit == "word") { return cm.findWordAt(pos) }
	    if (unit == "line") { return new Range(Pos(pos.line, 0), clipPos(cm.doc, Pos(pos.line + 1, 0))) }
	    var result = unit(cm, pos);
	    return new Range(result.from, result.to)
	  }
	
	  // Normal selection, as opposed to text dragging.
	  function leftButtonSelect(cm, event, start, behavior) {
	    var display = cm.display, doc = cm.doc;
	    e_preventDefault(event);
	
	    var ourRange, ourIndex, startSel = doc.sel, ranges = startSel.ranges;
	    if (behavior.addNew && !behavior.extend) {
	      ourIndex = doc.sel.contains(start);
	      if (ourIndex > -1)
	        { ourRange = ranges[ourIndex]; }
	      else
	        { ourRange = new Range(start, start); }
	    } else {
	      ourRange = doc.sel.primary();
	      ourIndex = doc.sel.primIndex;
	    }
	
	    if (behavior.unit == "rectangle") {
	      if (!behavior.addNew) { ourRange = new Range(start, start); }
	      start = posFromMouse(cm, event, true, true);
	      ourIndex = -1;
	    } else {
	      var range = rangeForUnit(cm, start, behavior.unit);
	      if (behavior.extend)
	        { ourRange = extendRange(ourRange, range.anchor, range.head, behavior.extend); }
	      else
	        { ourRange = range; }
	    }
	
	    if (!behavior.addNew) {
	      ourIndex = 0;
	      setSelection(doc, new Selection([ourRange], 0), sel_mouse);
	      startSel = doc.sel;
	    } else if (ourIndex == -1) {
	      ourIndex = ranges.length;
	      setSelection(doc, normalizeSelection(cm, ranges.concat([ourRange]), ourIndex),
	                   {scroll: false, origin: "*mouse"});
	    } else if (ranges.length > 1 && ranges[ourIndex].empty() && behavior.unit == "char" && !behavior.extend) {
	      setSelection(doc, normalizeSelection(cm, ranges.slice(0, ourIndex).concat(ranges.slice(ourIndex + 1)), 0),
	                   {scroll: false, origin: "*mouse"});
	      startSel = doc.sel;
	    } else {
	      replaceOneSelection(doc, ourIndex, ourRange, sel_mouse);
	    }
	
	    var lastPos = start;
	    function extendTo(pos) {
	      if (cmp(lastPos, pos) == 0) { return }
	      lastPos = pos;
	
	      if (behavior.unit == "rectangle") {
	        var ranges = [], tabSize = cm.options.tabSize;
	        var startCol = countColumn(getLine(doc, start.line).text, start.ch, tabSize);
	        var posCol = countColumn(getLine(doc, pos.line).text, pos.ch, tabSize);
	        var left = Math.min(startCol, posCol), right = Math.max(startCol, posCol);
	        for (var line = Math.min(start.line, pos.line), end = Math.min(cm.lastLine(), Math.max(start.line, pos.line));
	             line <= end; line++) {
	          var text = getLine(doc, line).text, leftPos = findColumn(text, left, tabSize);
	          if (left == right)
	            { ranges.push(new Range(Pos(line, leftPos), Pos(line, leftPos))); }
	          else if (text.length > leftPos)
	            { ranges.push(new Range(Pos(line, leftPos), Pos(line, findColumn(text, right, tabSize)))); }
	        }
	        if (!ranges.length) { ranges.push(new Range(start, start)); }
	        setSelection(doc, normalizeSelection(cm, startSel.ranges.slice(0, ourIndex).concat(ranges), ourIndex),
	                     {origin: "*mouse", scroll: false});
	        cm.scrollIntoView(pos);
	      } else {
	        var oldRange = ourRange;
	        var range = rangeForUnit(cm, pos, behavior.unit);
	        var anchor = oldRange.anchor, head;
	        if (cmp(range.anchor, anchor) > 0) {
	          head = range.head;
	          anchor = minPos(oldRange.from(), range.anchor);
	        } else {
	          head = range.anchor;
	          anchor = maxPos(oldRange.to(), range.head);
	        }
	        var ranges$1 = startSel.ranges.slice(0);
	        ranges$1[ourIndex] = bidiSimplify(cm, new Range(clipPos(doc, anchor), head));
	        setSelection(doc, normalizeSelection(cm, ranges$1, ourIndex), sel_mouse);
	      }
	    }
	
	    var editorSize = display.wrapper.getBoundingClientRect();
	    // Used to ensure timeout re-tries don't fire when another extend
	    // happened in the meantime (clearTimeout isn't reliable -- at
	    // least on Chrome, the timeouts still happen even when cleared,
	    // if the clear happens after their scheduled firing time).
	    var counter = 0;
	
	    function extend(e) {
	      var curCount = ++counter;
	      var cur = posFromMouse(cm, e, true, behavior.unit == "rectangle");
	      if (!cur) { return }
	      if (cmp(cur, lastPos) != 0) {
	        cm.curOp.focus = activeElt();
	        extendTo(cur);
	        var visible = visibleLines(display, doc);
	        if (cur.line >= visible.to || cur.line < visible.from)
	          { setTimeout(operation(cm, function () {if (counter == curCount) { extend(e); }}), 150); }
	      } else {
	        var outside = e.clientY < editorSize.top ? -20 : e.clientY > editorSize.bottom ? 20 : 0;
	        if (outside) { setTimeout(operation(cm, function () {
	          if (counter != curCount) { return }
	          display.scroller.scrollTop += outside;
	          extend(e);
	        }), 50); }
	      }
	    }
	
	    function done(e) {
	      cm.state.selectingText = false;
	      counter = Infinity;
	      // If e is null or undefined we interpret this as someone trying
	      // to explicitly cancel the selection rather than the user
	      // letting go of the mouse button.
	      if (e) {
	        e_preventDefault(e);
	        display.input.focus();
	      }
	      off(display.wrapper.ownerDocument, "mousemove", move);
	      off(display.wrapper.ownerDocument, "mouseup", up);
	      doc.history.lastSelOrigin = null;
	    }
	
	    var move = operation(cm, function (e) {
	      if (e.buttons === 0 || !e_button(e)) { done(e); }
	      else { extend(e); }
	    });
	    var up = operation(cm, done);
	    cm.state.selectingText = up;
	    on(display.wrapper.ownerDocument, "mousemove", move);
	    on(display.wrapper.ownerDocument, "mouseup", up);
	  }
	
	  // Used when mouse-selecting to adjust the anchor to the proper side
	  // of a bidi jump depending on the visual position of the head.
	  function bidiSimplify(cm, range) {
	    var anchor = range.anchor;
	    var head = range.head;
	    var anchorLine = getLine(cm.doc, anchor.line);
	    if (cmp(anchor, head) == 0 && anchor.sticky == head.sticky) { return range }
	    var order = getOrder(anchorLine);
	    if (!order) { return range }
	    var index = getBidiPartAt(order, anchor.ch, anchor.sticky), part = order[index];
	    if (part.from != anchor.ch && part.to != anchor.ch) { return range }
	    var boundary = index + ((part.from == anchor.ch) == (part.level != 1) ? 0 : 1);
	    if (boundary == 0 || boundary == order.length) { return range }
	
	    // Compute the relative visual position of the head compared to the
	    // anchor (<0 is to the left, >0 to the right)
	    var leftSide;
	    if (head.line != anchor.line) {
	      leftSide = (head.line - anchor.line) * (cm.doc.direction == "ltr" ? 1 : -1) > 0;
	    } else {
	      var headIndex = getBidiPartAt(order, head.ch, head.sticky);
	      var dir = headIndex - index || (head.ch - anchor.ch) * (part.level == 1 ? -1 : 1);
	      if (headIndex == boundary - 1 || headIndex == boundary)
	        { leftSide = dir < 0; }
	      else
	        { leftSide = dir > 0; }
	    }
	
	    var usePart = order[boundary + (leftSide ? -1 : 0)];
	    var from = leftSide == (usePart.level == 1);
	    var ch = from ? usePart.from : usePart.to, sticky = from ? "after" : "before";
	    return anchor.ch == ch && anchor.sticky == sticky ? range : new Range(new Pos(anchor.line, ch, sticky), head)
	  }
	
	
	  // Determines whether an event happened in the gutter, and fires the
	  // handlers for the corresponding event.
	  function gutterEvent(cm, e, type, prevent) {
	    var mX, mY;
	    if (e.touches) {
	      mX = e.touches[0].clientX;
	      mY = e.touches[0].clientY;
	    } else {
	      try { mX = e.clientX; mY = e.clientY; }
	      catch(e) { return false }
	    }
	    if (mX >= Math.floor(cm.display.gutters.getBoundingClientRect().right)) { return false }
	    if (prevent) { e_preventDefault(e); }
	
	    var display = cm.display;
	    var lineBox = display.lineDiv.getBoundingClientRect();
	
	    if (mY > lineBox.bottom || !hasHandler(cm, type)) { return e_defaultPrevented(e) }
	    mY -= lineBox.top - display.viewOffset;
	
	    for (var i = 0; i < cm.display.gutterSpecs.length; ++i) {
	      var g = display.gutters.childNodes[i];
	      if (g && g.getBoundingClientRect().right >= mX) {
	        var line = lineAtHeight(cm.doc, mY);
	        var gutter = cm.display.gutterSpecs[i];
	        signal(cm, type, cm, line, gutter.className, e);
	        return e_defaultPrevented(e)
	      }
	    }
	  }
	
	  function clickInGutter(cm, e) {
	    return gutterEvent(cm, e, "gutterClick", true)
	  }
	
	  // CONTEXT MENU HANDLING
	
	  // To make the context menu work, we need to briefly unhide the
	  // textarea (making it as unobtrusive as possible) to let the
	  // right-click take effect on it.
	  function onContextMenu(cm, e) {
	    if (eventInWidget(cm.display, e) || contextMenuInGutter(cm, e)) { return }
	    if (signalDOMEvent(cm, e, "contextmenu")) { return }
	    if (!captureRightClick) { cm.display.input.onContextMenu(e); }
	  }
	
	  function contextMenuInGutter(cm, e) {
	    if (!hasHandler(cm, "gutterContextMenu")) { return false }
	    return gutterEvent(cm, e, "gutterContextMenu", false)
	  }
	
	  function themeChanged(cm) {
	    cm.display.wrapper.className = cm.display.wrapper.className.replace(/\s*cm-s-\S+/g, "") +
	      cm.options.theme.replace(/(^|\s)\s*/g, " cm-s-");
	    clearCaches(cm);
	  }
	
	  var Init = {toString: function(){return "CodeMirror.Init"}};
	
	  var defaults = {};
	  var optionHandlers = {};
	
	  function defineOptions(CodeMirror) {
	    var optionHandlers = CodeMirror.optionHandlers;
	
	    function option(name, deflt, handle, notOnInit) {
	      CodeMirror.defaults[name] = deflt;
	      if (handle) { optionHandlers[name] =
	        notOnInit ? function (cm, val, old) {if (old != Init) { handle(cm, val, old); }} : handle; }
	    }
	
	    CodeMirror.defineOption = option;
	
	    // Passed to option handlers when there is no old value.
	    CodeMirror.Init = Init;
	
	    // These two are, on init, called from the constructor because they
	    // have to be initialized before the editor can start at all.
	    option("value", "", function (cm, val) { return cm.setValue(val); }, true);
	    option("mode", null, function (cm, val) {
	      cm.doc.modeOption = val;
	      loadMode(cm);
	    }, true);
	
	    option("indentUnit", 2, loadMode, true);
	    option("indentWithTabs", false);
	    option("smartIndent", true);
	    option("tabSize", 4, function (cm) {
	      resetModeState(cm);
	      clearCaches(cm);
	      regChange(cm);
	    }, true);
	
	    option("lineSeparator", null, function (cm, val) {
	      cm.doc.lineSep = val;
	      if (!val) { return }
	      var newBreaks = [], lineNo = cm.doc.first;
	      cm.doc.iter(function (line) {
	        for (var pos = 0;;) {
	          var found = line.text.indexOf(val, pos);
	          if (found == -1) { break }
	          pos = found + val.length;
	          newBreaks.push(Pos(lineNo, found));
	        }
	        lineNo++;
	      });
	      for (var i = newBreaks.length - 1; i >= 0; i--)
	        { replaceRange(cm.doc, val, newBreaks[i], Pos(newBreaks[i].line, newBreaks[i].ch + val.length)); }
	    });
	    option("specialChars", /[\u0000-\u001f\u007f-\u009f\u00ad\u061c\u200b-\u200f\u2028\u2029\ufeff\ufff9-\ufffc]/g, function (cm, val, old) {
	      cm.state.specialChars = new RegExp(val.source + (val.test("\t") ? "" : "|\t"), "g");
	      if (old != Init) { cm.refresh(); }
	    });
	    option("specialCharPlaceholder", defaultSpecialCharPlaceholder, function (cm) { return cm.refresh(); }, true);
	    option("electricChars", true);
	    option("inputStyle", mobile ? "contenteditable" : "textarea", function () {
	      throw new Error("inputStyle can not (yet) be changed in a running editor") // FIXME
	    }, true);
	    option("spellcheck", false, function (cm, val) { return cm.getInputField().spellcheck = val; }, true);
	    option("autocorrect", false, function (cm, val) { return cm.getInputField().autocorrect = val; }, true);
	    option("autocapitalize", false, function (cm, val) { return cm.getInputField().autocapitalize = val; }, true);
	    option("rtlMoveVisually", !windows);
	    option("wholeLineUpdateBefore", true);
	
	    option("theme", "default", function (cm) {
	      themeChanged(cm);
	      updateGutters(cm);
	    }, true);
	    option("keyMap", "default", function (cm, val, old) {
	      var next = getKeyMap(val);
	      var prev = old != Init && getKeyMap(old);
	      if (prev && prev.detach) { prev.detach(cm, next); }
	      if (next.attach) { next.attach(cm, prev || null); }
	    });
	    option("extraKeys", null);
	    option("configureMouse", null);
	
	    option("lineWrapping", false, wrappingChanged, true);
	    option("gutters", [], function (cm, val) {
	      cm.display.gutterSpecs = getGutters(val, cm.options.lineNumbers);
	      updateGutters(cm);
	    }, true);
	    option("fixedGutter", true, function (cm, val) {
	      cm.display.gutters.style.left = val ? compensateForHScroll(cm.display) + "px" : "0";
	      cm.refresh();
	    }, true);
	    option("coverGutterNextToScrollbar", false, function (cm) { return updateScrollbars(cm); }, true);
	    option("scrollbarStyle", "native", function (cm) {
	      initScrollbars(cm);
	      updateScrollbars(cm);
	      cm.display.scrollbars.setScrollTop(cm.doc.scrollTop);
	      cm.display.scrollbars.setScrollLeft(cm.doc.scrollLeft);
	    }, true);
	    option("lineNumbers", false, function (cm, val) {
	      cm.display.gutterSpecs = getGutters(cm.options.gutters, val);
	      updateGutters(cm);
	    }, true);
	    option("firstLineNumber", 1, updateGutters, true);
	    option("lineNumberFormatter", function (integer) { return integer; }, updateGutters, true);
	    option("showCursorWhenSelecting", false, updateSelection, true);
	
	    option("resetSelectionOnContextMenu", true);
	    option("lineWiseCopyCut", true);
	    option("pasteLinesPerSelection", true);
	    option("selectionsMayTouch", false);
	
	    option("readOnly", false, function (cm, val) {
	      if (val == "nocursor") {
	        onBlur(cm);
	        cm.display.input.blur();
	      }
	      cm.display.input.readOnlyChanged(val);
	    });
	    option("disableInput", false, function (cm, val) {if (!val) { cm.display.input.reset(); }}, true);
	    option("dragDrop", true, dragDropChanged);
	    option("allowDropFileTypes", null);
	
	    option("cursorBlinkRate", 530);
	    option("cursorScrollMargin", 0);
	    option("cursorHeight", 1, updateSelection, true);
	    option("singleCursorHeightPerLine", true, updateSelection, true);
	    option("workTime", 100);
	    option("workDelay", 100);
	    option("flattenSpans", true, resetModeState, true);
	    option("addModeClass", false, resetModeState, true);
	    option("pollInterval", 100);
	    option("undoDepth", 200, function (cm, val) { return cm.doc.history.undoDepth = val; });
	    option("historyEventDelay", 1250);
	    option("viewportMargin", 10, function (cm) { return cm.refresh(); }, true);
	    option("maxHighlightLength", 10000, resetModeState, true);
	    option("moveInputWithCursor", true, function (cm, val) {
	      if (!val) { cm.display.input.resetPosition(); }
	    });
	
	    option("tabindex", null, function (cm, val) { return cm.display.input.getField().tabIndex = val || ""; });
	    option("autofocus", null);
	    option("direction", "ltr", function (cm, val) { return cm.doc.setDirection(val); }, true);
	    option("phrases", null);
	  }
	
	  function dragDropChanged(cm, value, old) {
	    var wasOn = old && old != Init;
	    if (!value != !wasOn) {
	      var funcs = cm.display.dragFunctions;
	      var toggle = value ? on : off;
	      toggle(cm.display.scroller, "dragstart", funcs.start);
	      toggle(cm.display.scroller, "dragenter", funcs.enter);
	      toggle(cm.display.scroller, "dragover", funcs.over);
	      toggle(cm.display.scroller, "dragleave", funcs.leave);
	      toggle(cm.display.scroller, "drop", funcs.drop);
	    }
	  }
	
	  function wrappingChanged(cm) {
	    if (cm.options.lineWrapping) {
	      addClass(cm.display.wrapper, "CodeMirror-wrap");
	      cm.display.sizer.style.minWidth = "";
	      cm.display.sizerWidth = null;
	    } else {
	      rmClass(cm.display.wrapper, "CodeMirror-wrap");
	      findMaxLine(cm);
	    }
	    estimateLineHeights(cm);
	    regChange(cm);
	    clearCaches(cm);
	    setTimeout(function () { return updateScrollbars(cm); }, 100);
	  }
	
	  // A CodeMirror instance represents an editor. This is the object
	  // that user code is usually dealing with.
	
	  function CodeMirror(place, options) {
	    var this$1 = this;
	
	    if (!(this instanceof CodeMirror)) { return new CodeMirror(place, options) }
	
	    this.options = options = options ? copyObj(options) : {};
	    // Determine effective options based on given values and defaults.
	    copyObj(defaults, options, false);
	
	    var doc = options.value;
	    if (typeof doc == "string") { doc = new Doc(doc, options.mode, null, options.lineSeparator, options.direction); }
	    else if (options.mode) { doc.modeOption = options.mode; }
	    this.doc = doc;
	
	    var input = new CodeMirror.inputStyles[options.inputStyle](this);
	    var display = this.display = new Display(place, doc, input, options);
	    display.wrapper.CodeMirror = this;
	    themeChanged(this);
	    if (options.lineWrapping)
	      { this.display.wrapper.className += " CodeMirror-wrap"; }
	    initScrollbars(this);
	
	    this.state = {
	      keyMaps: [],  // stores maps added by addKeyMap
	      overlays: [], // highlighting overlays, as added by addOverlay
	      modeGen: 0,   // bumped when mode/overlay changes, used to invalidate highlighting info
	      overwrite: false,
	      delayingBlurEvent: false,
	      focused: false,
	      suppressEdits: false, // used to disable editing during key handlers when in readOnly mode
	      pasteIncoming: -1, cutIncoming: -1, // help recognize paste/cut edits in input.poll
	      selectingText: false,
	      draggingText: false,
	      highlight: new Delayed(), // stores highlight worker timeout
	      keySeq: null,  // Unfinished key sequence
	      specialChars: null
	    };
	
	    if (options.autofocus && !mobile) { display.input.focus(); }
	
	    // Override magic textarea content restore that IE sometimes does
	    // on our hidden textarea on reload
	    if (ie && ie_version < 11) { setTimeout(function () { return this$1.display.input.reset(true); }, 20); }
	
	    registerEventHandlers(this);
	    ensureGlobalHandlers();
	
	    startOperation(this);
	    this.curOp.forceUpdate = true;
	    attachDoc(this, doc);
	
	    if ((options.autofocus && !mobile) || this.hasFocus())
	      { setTimeout(bind(onFocus, this), 20); }
	    else
	      { onBlur(this); }
	
	    for (var opt in optionHandlers) { if (optionHandlers.hasOwnProperty(opt))
	      { optionHandlers[opt](this, options[opt], Init); } }
	    maybeUpdateLineNumberWidth(this);
	    if (options.finishInit) { options.finishInit(this); }
	    for (var i = 0; i < initHooks.length; ++i) { initHooks[i](this); }
	    endOperation(this);
	    // Suppress optimizelegibility in Webkit, since it breaks text
	    // measuring on line wrapping boundaries.
	    if (webkit && options.lineWrapping &&
	        getComputedStyle(display.lineDiv).textRendering == "optimizelegibility")
	      { display.lineDiv.style.textRendering = "auto"; }
	  }
	
	  // The default configuration options.
	  CodeMirror.defaults = defaults;
	  // Functions to run when options are changed.
	  CodeMirror.optionHandlers = optionHandlers;
	
	  // Attach the necessary event handlers when initializing the editor
	  function registerEventHandlers(cm) {
	    var d = cm.display;
	    on(d.scroller, "mousedown", operation(cm, onMouseDown));
	    // Older IE's will not fire a second mousedown for a double click
	    if (ie && ie_version < 11)
	      { on(d.scroller, "dblclick", operation(cm, function (e) {
	        if (signalDOMEvent(cm, e)) { return }
	        var pos = posFromMouse(cm, e);
	        if (!pos || clickInGutter(cm, e) || eventInWidget(cm.display, e)) { return }
	        e_preventDefault(e);
	        var word = cm.findWordAt(pos);
	        extendSelection(cm.doc, word.anchor, word.head);
	      })); }
	    else
	      { on(d.scroller, "dblclick", function (e) { return signalDOMEvent(cm, e) || e_preventDefault(e); }); }
	    // Some browsers fire contextmenu *after* opening the menu, at
	    // which point we can't mess with it anymore. Context menu is
	    // handled in onMouseDown for these browsers.
	    on(d.scroller, "contextmenu", function (e) { return onContextMenu(cm, e); });
	    on(d.input.getField(), "contextmenu", function (e) {
	      if (!d.scroller.contains(e.target)) { onContextMenu(cm, e); }
	    });
	
	    // Used to suppress mouse event handling when a touch happens
	    var touchFinished, prevTouch = {end: 0};
	    function finishTouch() {
	      if (d.activeTouch) {
	        touchFinished = setTimeout(function () { return d.activeTouch = null; }, 1000);
	        prevTouch = d.activeTouch;
	        prevTouch.end = +new Date;
	      }
	    }
	    function isMouseLikeTouchEvent(e) {
	      if (e.touches.length != 1) { return false }
	      var touch = e.touches[0];
	      return touch.radiusX <= 1 && touch.radiusY <= 1
	    }
	    function farAway(touch, other) {
	      if (other.left == null) { return true }
	      var dx = other.left - touch.left, dy = other.top - touch.top;
	      return dx * dx + dy * dy > 20 * 20
	    }
	    on(d.scroller, "touchstart", function (e) {
	      if (!signalDOMEvent(cm, e) && !isMouseLikeTouchEvent(e) && !clickInGutter(cm, e)) {
	        d.input.ensurePolled();
	        clearTimeout(touchFinished);
	        var now = +new Date;
	        d.activeTouch = {start: now, moved: false,
	                         prev: now - prevTouch.end <= 300 ? prevTouch : null};
	        if (e.touches.length == 1) {
	          d.activeTouch.left = e.touches[0].pageX;
	          d.activeTouch.top = e.touches[0].pageY;
	        }
	      }
	    });
	    on(d.scroller, "touchmove", function () {
	      if (d.activeTouch) { d.activeTouch.moved = true; }
	    });
	    on(d.scroller, "touchend", function (e) {
	      var touch = d.activeTouch;
	      if (touch && !eventInWidget(d, e) && touch.left != null &&
	          !touch.moved && new Date - touch.start < 300) {
	        var pos = cm.coordsChar(d.activeTouch, "page"), range;
	        if (!touch.prev || farAway(touch, touch.prev)) // Single tap
	          { range = new Range(pos, pos); }
	        else if (!touch.prev.prev || farAway(touch, touch.prev.prev)) // Double tap
	          { range = cm.findWordAt(pos); }
	        else // Triple tap
	          { range = new Range(Pos(pos.line, 0), clipPos(cm.doc, Pos(pos.line + 1, 0))); }
	        cm.setSelection(range.anchor, range.head);
	        cm.focus();
	        e_preventDefault(e);
	      }
	      finishTouch();
	    });
	    on(d.scroller, "touchcancel", finishTouch);
	
	    // Sync scrolling between fake scrollbars and real scrollable
	    // area, ensure viewport is updated when scrolling.
	    on(d.scroller, "scroll", function () {
	      if (d.scroller.clientHeight) {
	        updateScrollTop(cm, d.scroller.scrollTop);
	        setScrollLeft(cm, d.scroller.scrollLeft, true);
	        signal(cm, "scroll", cm);
	      }
	    });
	
	    // Listen to wheel events in order to try and update the viewport on time.
	    on(d.scroller, "mousewheel", function (e) { return onScrollWheel(cm, e); });
	    on(d.scroller, "DOMMouseScroll", function (e) { return onScrollWheel(cm, e); });
	
	    // Prevent wrapper from ever scrolling
	    on(d.wrapper, "scroll", function () { return d.wrapper.scrollTop = d.wrapper.scrollLeft = 0; });
	
	    d.dragFunctions = {
	      enter: function (e) {if (!signalDOMEvent(cm, e)) { e_stop(e); }},
	      over: function (e) {if (!signalDOMEvent(cm, e)) { onDragOver(cm, e); e_stop(e); }},
	      start: function (e) { return onDragStart(cm, e); },
	      drop: operation(cm, onDrop),
	      leave: function (e) {if (!signalDOMEvent(cm, e)) { clearDragCursor(cm); }}
	    };
	
	    var inp = d.input.getField();
	    on(inp, "keyup", function (e) { return onKeyUp.call(cm, e); });
	    on(inp, "keydown", operation(cm, onKeyDown));
	    on(inp, "keypress", operation(cm, onKeyPress));
	    on(inp, "focus", function (e) { return onFocus(cm, e); });
	    on(inp, "blur", function (e) { return onBlur(cm, e); });
	  }
	
	  var initHooks = [];
	  CodeMirror.defineInitHook = function (f) { return initHooks.push(f); };
	
	  // Indent the given line. The how parameter can be "smart",
	  // "add"/null, "subtract", or "prev". When aggressive is false
	  // (typically set to true for forced single-line indents), empty
	  // lines are not indented, and places where the mode returns Pass
	  // are left alone.
	  function indentLine(cm, n, how, aggressive) {
	    var doc = cm.doc, state;
	    if (how == null) { how = "add"; }
	    if (how == "smart") {
	      // Fall back to "prev" when the mode doesn't have an indentation
	      // method.
	      if (!doc.mode.indent) { how = "prev"; }
	      else { state = getContextBefore(cm, n).state; }
	    }
	
	    var tabSize = cm.options.tabSize;
	    var line = getLine(doc, n), curSpace = countColumn(line.text, null, tabSize);
	    if (line.stateAfter) { line.stateAfter = null; }
	    var curSpaceString = line.text.match(/^\s*/)[0], indentation;
	    if (!aggressive && !/\S/.test(line.text)) {
	      indentation = 0;
	      how = "not";
	    } else if (how == "smart") {
	      indentation = doc.mode.indent(state, line.text.slice(curSpaceString.length), line.text);
	      if (indentation == Pass || indentation > 150) {
	        if (!aggressive) { return }
	        how = "prev";
	      }
	    }
	    if (how == "prev") {
	      if (n > doc.first) { indentation = countColumn(getLine(doc, n-1).text, null, tabSize); }
	      else { indentation = 0; }
	    } else if (how == "add") {
	      indentation = curSpace + cm.options.indentUnit;
	    } else if (how == "subtract") {
	      indentation = curSpace - cm.options.indentUnit;
	    } else if (typeof how == "number") {
	      indentation = curSpace + how;
	    }
	    indentation = Math.max(0, indentation);
	
	    var indentString = "", pos = 0;
	    if (cm.options.indentWithTabs)
	      { for (var i = Math.floor(indentation / tabSize); i; --i) {pos += tabSize; indentString += "\t";} }
	    if (pos < indentation) { indentString += spaceStr(indentation - pos); }
	
	    if (indentString != curSpaceString) {
	      replaceRange(doc, indentString, Pos(n, 0), Pos(n, curSpaceString.length), "+input");
	      line.stateAfter = null;
	      return true
	    } else {
	      // Ensure that, if the cursor was in the whitespace at the start
	      // of the line, it is moved to the end of that space.
	      for (var i$1 = 0; i$1 < doc.sel.ranges.length; i$1++) {
	        var range = doc.sel.ranges[i$1];
	        if (range.head.line == n && range.head.ch < curSpaceString.length) {
	          var pos$1 = Pos(n, curSpaceString.length);
	          replaceOneSelection(doc, i$1, new Range(pos$1, pos$1));
	          break
	        }
	      }
	    }
	  }
	
	  // This will be set to a {lineWise: bool, text: [string]} object, so
	  // that, when pasting, we know what kind of selections the copied
	  // text was made out of.
	  var lastCopied = null;
	
	  function setLastCopied(newLastCopied) {
	    lastCopied = newLastCopied;
	  }
	
	  function applyTextInput(cm, inserted, deleted, sel, origin) {
	    var doc = cm.doc;
	    cm.display.shift = false;
	    if (!sel) { sel = doc.sel; }
	
	    var recent = +new Date - 200;
	    var paste = origin == "paste" || cm.state.pasteIncoming > recent;
	    var textLines = splitLinesAuto(inserted), multiPaste = null;
	    // When pasting N lines into N selections, insert one line per selection
	    if (paste && sel.ranges.length > 1) {
	      if (lastCopied && lastCopied.text.join("\n") == inserted) {
	        if (sel.ranges.length % lastCopied.text.length == 0) {
	          multiPaste = [];
	          for (var i = 0; i < lastCopied.text.length; i++)
	            { multiPaste.push(doc.splitLines(lastCopied.text[i])); }
	        }
	      } else if (textLines.length == sel.ranges.length && cm.options.pasteLinesPerSelection) {
	        multiPaste = map(textLines, function (l) { return [l]; });
	      }
	    }
	
	    var updateInput = cm.curOp.updateInput;
	    // Normal behavior is to insert the new text into every selection
	    for (var i$1 = sel.ranges.length - 1; i$1 >= 0; i$1--) {
	      var range = sel.ranges[i$1];
	      var from = range.from(), to = range.to();
	      if (range.empty()) {
	        if (deleted && deleted > 0) // Handle deletion
	          { from = Pos(from.line, from.ch - deleted); }
	        else if (cm.state.overwrite && !paste) // Handle overwrite
	          { to = Pos(to.line, Math.min(getLine(doc, to.line).text.length, to.ch + lst(textLines).length)); }
	        else if (paste && lastCopied && lastCopied.lineWise && lastCopied.text.join("\n") == inserted)
	          { from = to = Pos(from.line, 0); }
	      }
	      var changeEvent = {from: from, to: to, text: multiPaste ? multiPaste[i$1 % multiPaste.length] : textLines,
	                         origin: origin || (paste ? "paste" : cm.state.cutIncoming > recent ? "cut" : "+input")};
	      makeChange(cm.doc, changeEvent);
	      signalLater(cm, "inputRead", cm, changeEvent);
	    }
	    if (inserted && !paste)
	      { triggerElectric(cm, inserted); }
	
	    ensureCursorVisible(cm);
	    if (cm.curOp.updateInput < 2) { cm.curOp.updateInput = updateInput; }
	    cm.curOp.typing = true;
	    cm.state.pasteIncoming = cm.state.cutIncoming = -1;
	  }
	
	  function handlePaste(e, cm) {
	    var pasted = e.clipboardData && e.clipboardData.getData("Text");
	    if (pasted) {
	      e.preventDefault();
	      if (!cm.isReadOnly() && !cm.options.disableInput)
	        { runInOp(cm, function () { return applyTextInput(cm, pasted, 0, null, "paste"); }); }
	      return true
	    }
	  }
	
	  function triggerElectric(cm, inserted) {
	    // When an 'electric' character is inserted, immediately trigger a reindent
	    if (!cm.options.electricChars || !cm.options.smartIndent) { return }
	    var sel = cm.doc.sel;
	
	    for (var i = sel.ranges.length - 1; i >= 0; i--) {
	      var range = sel.ranges[i];
	      if (range.head.ch > 100 || (i && sel.ranges[i - 1].head.line == range.head.line)) { continue }
	      var mode = cm.getModeAt(range.head);
	      var indented = false;
	      if (mode.electricChars) {
	        for (var j = 0; j < mode.electricChars.length; j++)
	          { if (inserted.indexOf(mode.electricChars.charAt(j)) > -1) {
	            indented = indentLine(cm, range.head.line, "smart");
	            break
	          } }
	      } else if (mode.electricInput) {
	        if (mode.electricInput.test(getLine(cm.doc, range.head.line).text.slice(0, range.head.ch)))
	          { indented = indentLine(cm, range.head.line, "smart"); }
	      }
	      if (indented) { signalLater(cm, "electricInput", cm, range.head.line); }
	    }
	  }
	
	  function copyableRanges(cm) {
	    var text = [], ranges = [];
	    for (var i = 0; i < cm.doc.sel.ranges.length; i++) {
	      var line = cm.doc.sel.ranges[i].head.line;
	      var lineRange = {anchor: Pos(line, 0), head: Pos(line + 1, 0)};
	      ranges.push(lineRange);
	      text.push(cm.getRange(lineRange.anchor, lineRange.head));
	    }
	    return {text: text, ranges: ranges}
	  }
	
	  function disableBrowserMagic(field, spellcheck, autocorrect, autocapitalize) {
	    field.setAttribute("autocorrect", autocorrect ? "" : "off");
	    field.setAttribute("autocapitalize", autocapitalize ? "" : "off");
	    field.setAttribute("spellcheck", !!spellcheck);
	  }
	
	  function hiddenTextarea() {
	    var te = elt("textarea", null, null, "position: absolute; bottom: -1em; padding: 0; width: 1px; height: 1em; outline: none");
	    var div = elt("div", [te], null, "overflow: hidden; position: relative; width: 3px; height: 0px;");
	    // The textarea is kept positioned near the cursor to prevent the
	    // fact that it'll be scrolled into view on input from scrolling
	    // our fake cursor out of view. On webkit, when wrap=off, paste is
	    // very slow. So make the area wide instead.
	    if (webkit) { te.style.width = "1000px"; }
	    else { te.setAttribute("wrap", "off"); }
	    // If border: 0; -- iOS fails to open keyboard (issue #1287)
	    if (ios) { te.style.border = "1px solid black"; }
	    disableBrowserMagic(te);
	    return div
	  }
	
	  // The publicly visible API. Note that methodOp(f) means
	  // 'wrap f in an operation, performed on its `this` parameter'.
	
	  // This is not the complete set of editor methods. Most of the
	  // methods defined on the Doc type are also injected into
	  // CodeMirror.prototype, for backwards compatibility and
	  // convenience.
	
	  function addEditorMethods(CodeMirror) {
	    var optionHandlers = CodeMirror.optionHandlers;
	
	    var helpers = CodeMirror.helpers = {};
	
	    CodeMirror.prototype = {
	      constructor: CodeMirror,
	      focus: function(){window.focus(); this.display.input.focus();},
	
	      setOption: function(option, value) {
	        var options = this.options, old = options[option];
	        if (options[option] == value && option != "mode") { return }
	        options[option] = value;
	        if (optionHandlers.hasOwnProperty(option))
	          { operation(this, optionHandlers[option])(this, value, old); }
	        signal(this, "optionChange", this, option);
	      },
	
	      getOption: function(option) {return this.options[option]},
	      getDoc: function() {return this.doc},
	
	      addKeyMap: function(map, bottom) {
	        this.state.keyMaps[bottom ? "push" : "unshift"](getKeyMap(map));
	      },
	      removeKeyMap: function(map) {
	        var maps = this.state.keyMaps;
	        for (var i = 0; i < maps.length; ++i)
	          { if (maps[i] == map || maps[i].name == map) {
	            maps.splice(i, 1);
	            return true
	          } }
	      },
	
	      addOverlay: methodOp(function(spec, options) {
	        var mode = spec.token ? spec : CodeMirror.getMode(this.options, spec);
	        if (mode.startState) { throw new Error("Overlays may not be stateful.") }
	        insertSorted(this.state.overlays,
	                     {mode: mode, modeSpec: spec, opaque: options && options.opaque,
	                      priority: (options && options.priority) || 0},
	                     function (overlay) { return overlay.priority; });
	        this.state.modeGen++;
	        regChange(this);
	      }),
	      removeOverlay: methodOp(function(spec) {
	        var overlays = this.state.overlays;
	        for (var i = 0; i < overlays.length; ++i) {
	          var cur = overlays[i].modeSpec;
	          if (cur == spec || typeof spec == "string" && cur.name == spec) {
	            overlays.splice(i, 1);
	            this.state.modeGen++;
	            regChange(this);
	            return
	          }
	        }
	      }),
	
	      indentLine: methodOp(function(n, dir, aggressive) {
	        if (typeof dir != "string" && typeof dir != "number") {
	          if (dir == null) { dir = this.options.smartIndent ? "smart" : "prev"; }
	          else { dir = dir ? "add" : "subtract"; }
	        }
	        if (isLine(this.doc, n)) { indentLine(this, n, dir, aggressive); }
	      }),
	      indentSelection: methodOp(function(how) {
	        var ranges = this.doc.sel.ranges, end = -1;
	        for (var i = 0; i < ranges.length; i++) {
	          var range = ranges[i];
	          if (!range.empty()) {
	            var from = range.from(), to = range.to();
	            var start = Math.max(end, from.line);
	            end = Math.min(this.lastLine(), to.line - (to.ch ? 0 : 1)) + 1;
	            for (var j = start; j < end; ++j)
	              { indentLine(this, j, how); }
	            var newRanges = this.doc.sel.ranges;
	            if (from.ch == 0 && ranges.length == newRanges.length && newRanges[i].from().ch > 0)
	              { replaceOneSelection(this.doc, i, new Range(from, newRanges[i].to()), sel_dontScroll); }
	          } else if (range.head.line > end) {
	            indentLine(this, range.head.line, how, true);
	            end = range.head.line;
	            if (i == this.doc.sel.primIndex) { ensureCursorVisible(this); }
	          }
	        }
	      }),
	
	      // Fetch the parser token for a given character. Useful for hacks
	      // that want to inspect the mode state (say, for completion).
	      getTokenAt: function(pos, precise) {
	        return takeToken(this, pos, precise)
	      },
	
	      getLineTokens: function(line, precise) {
	        return takeToken(this, Pos(line), precise, true)
	      },
	
	      getTokenTypeAt: function(pos) {
	        pos = clipPos(this.doc, pos);
	        var styles = getLineStyles(this, getLine(this.doc, pos.line));
	        var before = 0, after = (styles.length - 1) / 2, ch = pos.ch;
	        var type;
	        if (ch == 0) { type = styles[2]; }
	        else { for (;;) {
	          var mid = (before + after) >> 1;
	          if ((mid ? styles[mid * 2 - 1] : 0) >= ch) { after = mid; }
	          else if (styles[mid * 2 + 1] < ch) { before = mid + 1; }
	          else { type = styles[mid * 2 + 2]; break }
	        } }
	        var cut = type ? type.indexOf("overlay ") : -1;
	        return cut < 0 ? type : cut == 0 ? null : type.slice(0, cut - 1)
	      },
	
	      getModeAt: function(pos) {
	        var mode = this.doc.mode;
	        if (!mode.innerMode) { return mode }
	        return CodeMirror.innerMode(mode, this.getTokenAt(pos).state).mode
	      },
	
	      getHelper: function(pos, type) {
	        return this.getHelpers(pos, type)[0]
	      },
	
	      getHelpers: function(pos, type) {
	        var found = [];
	        if (!helpers.hasOwnProperty(type)) { return found }
	        var help = helpers[type], mode = this.getModeAt(pos);
	        if (typeof mode[type] == "string") {
	          if (help[mode[type]]) { found.push(help[mode[type]]); }
	        } else if (mode[type]) {
	          for (var i = 0; i < mode[type].length; i++) {
	            var val = help[mode[type][i]];
	            if (val) { found.push(val); }
	          }
	        } else if (mode.helperType && help[mode.helperType]) {
	          found.push(help[mode.helperType]);
	        } else if (help[mode.name]) {
	          found.push(help[mode.name]);
	        }
	        for (var i$1 = 0; i$1 < help._global.length; i$1++) {
	          var cur = help._global[i$1];
	          if (cur.pred(mode, this) && indexOf(found, cur.val) == -1)
	            { found.push(cur.val); }
	        }
	        return found
	      },
	
	      getStateAfter: function(line, precise) {
	        var doc = this.doc;
	        line = clipLine(doc, line == null ? doc.first + doc.size - 1: line);
	        return getContextBefore(this, line + 1, precise).state
	      },
	
	      cursorCoords: function(start, mode) {
	        var pos, range = this.doc.sel.primary();
	        if (start == null) { pos = range.head; }
	        else if (typeof start == "object") { pos = clipPos(this.doc, start); }
	        else { pos = start ? range.from() : range.to(); }
	        return cursorCoords(this, pos, mode || "page")
	      },
	
	      charCoords: function(pos, mode) {
	        return charCoords(this, clipPos(this.doc, pos), mode || "page")
	      },
	
	      coordsChar: function(coords, mode) {
	        coords = fromCoordSystem(this, coords, mode || "page");
	        return coordsChar(this, coords.left, coords.top)
	      },
	
	      lineAtHeight: function(height, mode) {
	        height = fromCoordSystem(this, {top: height, left: 0}, mode || "page").top;
	        return lineAtHeight(this.doc, height + this.display.viewOffset)
	      },
	      heightAtLine: function(line, mode, includeWidgets) {
	        var end = false, lineObj;
	        if (typeof line == "number") {
	          var last = this.doc.first + this.doc.size - 1;
	          if (line < this.doc.first) { line = this.doc.first; }
	          else if (line > last) { line = last; end = true; }
	          lineObj = getLine(this.doc, line);
	        } else {
	          lineObj = line;
	        }
	        return intoCoordSystem(this, lineObj, {top: 0, left: 0}, mode || "page", includeWidgets || end).top +
	          (end ? this.doc.height - heightAtLine(lineObj) : 0)
	      },
	
	      defaultTextHeight: function() { return textHeight(this.display) },
	      defaultCharWidth: function() { return charWidth(this.display) },
	
	      getViewport: function() { return {from: this.display.viewFrom, to: this.display.viewTo}},
	
	      addWidget: function(pos, node, scroll, vert, horiz) {
	        var display = this.display;
	        pos = cursorCoords(this, clipPos(this.doc, pos));
	        var top = pos.bottom, left = pos.left;
	        node.style.position = "absolute";
	        node.setAttribute("cm-ignore-events", "true");
	        this.display.input.setUneditable(node);
	        display.sizer.appendChild(node);
	        if (vert == "over") {
	          top = pos.top;
	        } else if (vert == "above" || vert == "near") {
	          var vspace = Math.max(display.wrapper.clientHeight, this.doc.height),
	          hspace = Math.max(display.sizer.clientWidth, display.lineSpace.clientWidth);
	          // Default to positioning above (if specified and possible); otherwise default to positioning below
	          if ((vert == 'above' || pos.bottom + node.offsetHeight > vspace) && pos.top > node.offsetHeight)
	            { top = pos.top - node.offsetHeight; }
	          else if (pos.bottom + node.offsetHeight <= vspace)
	            { top = pos.bottom; }
	          if (left + node.offsetWidth > hspace)
	            { left = hspace - node.offsetWidth; }
	        }
	        node.style.top = top + "px";
	        node.style.left = node.style.right = "";
	        if (horiz == "right") {
	          left = display.sizer.clientWidth - node.offsetWidth;
	          node.style.right = "0px";
	        } else {
	          if (horiz == "left") { left = 0; }
	          else if (horiz == "middle") { left = (display.sizer.clientWidth - node.offsetWidth) / 2; }
	          node.style.left = left + "px";
	        }
	        if (scroll)
	          { scrollIntoView(this, {left: left, top: top, right: left + node.offsetWidth, bottom: top + node.offsetHeight}); }
	      },
	
	      triggerOnKeyDown: methodOp(onKeyDown),
	      triggerOnKeyPress: methodOp(onKeyPress),
	      triggerOnKeyUp: onKeyUp,
	      triggerOnMouseDown: methodOp(onMouseDown),
	
	      execCommand: function(cmd) {
	        if (commands.hasOwnProperty(cmd))
	          { return commands[cmd].call(null, this) }
	      },
	
	      triggerElectric: methodOp(function(text) { triggerElectric(this, text); }),
	
	      findPosH: function(from, amount, unit, visually) {
	        var dir = 1;
	        if (amount < 0) { dir = -1; amount = -amount; }
	        var cur = clipPos(this.doc, from);
	        for (var i = 0; i < amount; ++i) {
	          cur = findPosH(this.doc, cur, dir, unit, visually);
	          if (cur.hitSide) { break }
	        }
	        return cur
	      },
	
	      moveH: methodOp(function(dir, unit) {
	        var this$1 = this;
	
	        this.extendSelectionsBy(function (range) {
	          if (this$1.display.shift || this$1.doc.extend || range.empty())
	            { return findPosH(this$1.doc, range.head, dir, unit, this$1.options.rtlMoveVisually) }
	          else
	            { return dir < 0 ? range.from() : range.to() }
	        }, sel_move);
	      }),
	
	      deleteH: methodOp(function(dir, unit) {
	        var sel = this.doc.sel, doc = this.doc;
	        if (sel.somethingSelected())
	          { doc.replaceSelection("", null, "+delete"); }
	        else
	          { deleteNearSelection(this, function (range) {
	            var other = findPosH(doc, range.head, dir, unit, false);
	            return dir < 0 ? {from: other, to: range.head} : {from: range.head, to: other}
	          }); }
	      }),
	
	      findPosV: function(from, amount, unit, goalColumn) {
	        var dir = 1, x = goalColumn;
	        if (amount < 0) { dir = -1; amount = -amount; }
	        var cur = clipPos(this.doc, from);
	        for (var i = 0; i < amount; ++i) {
	          var coords = cursorCoords(this, cur, "div");
	          if (x == null) { x = coords.left; }
	          else { coords.left = x; }
	          cur = findPosV(this, coords, dir, unit);
	          if (cur.hitSide) { break }
	        }
	        return cur
	      },
	
	      moveV: methodOp(function(dir, unit) {
	        var this$1 = this;
	
	        var doc = this.doc, goals = [];
	        var collapse = !this.display.shift && !doc.extend && doc.sel.somethingSelected();
	        doc.extendSelectionsBy(function (range) {
	          if (collapse)
	            { return dir < 0 ? range.from() : range.to() }
	          var headPos = cursorCoords(this$1, range.head, "div");
	          if (range.goalColumn != null) { headPos.left = range.goalColumn; }
	          goals.push(headPos.left);
	          var pos = findPosV(this$1, headPos, dir, unit);
	          if (unit == "page" && range == doc.sel.primary())
	            { addToScrollTop(this$1, charCoords(this$1, pos, "div").top - headPos.top); }
	          return pos
	        }, sel_move);
	        if (goals.length) { for (var i = 0; i < doc.sel.ranges.length; i++)
	          { doc.sel.ranges[i].goalColumn = goals[i]; } }
	      }),
	
	      // Find the word at the given position (as returned by coordsChar).
	      findWordAt: function(pos) {
	        var doc = this.doc, line = getLine(doc, pos.line).text;
	        var start = pos.ch, end = pos.ch;
	        if (line) {
	          var helper = this.getHelper(pos, "wordChars");
	          if ((pos.sticky == "before" || end == line.length) && start) { --start; } else { ++end; }
	          var startChar = line.charAt(start);
	          var check = isWordChar(startChar, helper)
	            ? function (ch) { return isWordChar(ch, helper); }
	            : /\s/.test(startChar) ? function (ch) { return /\s/.test(ch); }
	            : function (ch) { return (!/\s/.test(ch) && !isWordChar(ch)); };
	          while (start > 0 && check(line.charAt(start - 1))) { --start; }
	          while (end < line.length && check(line.charAt(end))) { ++end; }
	        }
	        return new Range(Pos(pos.line, start), Pos(pos.line, end))
	      },
	
	      toggleOverwrite: function(value) {
	        if (value != null && value == this.state.overwrite) { return }
	        if (this.state.overwrite = !this.state.overwrite)
	          { addClass(this.display.cursorDiv, "CodeMirror-overwrite"); }
	        else
	          { rmClass(this.display.cursorDiv, "CodeMirror-overwrite"); }
	
	        signal(this, "overwriteToggle", this, this.state.overwrite);
	      },
	      hasFocus: function() { return this.display.input.getField() == activeElt() },
	      isReadOnly: function() { return !!(this.options.readOnly || this.doc.cantEdit) },
	
	      scrollTo: methodOp(function (x, y) { scrollToCoords(this, x, y); }),
	      getScrollInfo: function() {
	        var scroller = this.display.scroller;
	        return {left: scroller.scrollLeft, top: scroller.scrollTop,
	                height: scroller.scrollHeight - scrollGap(this) - this.display.barHeight,
	                width: scroller.scrollWidth - scrollGap(this) - this.display.barWidth,
	                clientHeight: displayHeight(this), clientWidth: displayWidth(this)}
	      },
	
	      scrollIntoView: methodOp(function(range, margin) {
	        if (range == null) {
	          range = {from: this.doc.sel.primary().head, to: null};
	          if (margin == null) { margin = this.options.cursorScrollMargin; }
	        } else if (typeof range == "number") {
	          range = {from: Pos(range, 0), to: null};
	        } else if (range.from == null) {
	          range = {from: range, to: null};
	        }
	        if (!range.to) { range.to = range.from; }
	        range.margin = margin || 0;
	
	        if (range.from.line != null) {
	          scrollToRange(this, range);
	        } else {
	          scrollToCoordsRange(this, range.from, range.to, range.margin);
	        }
	      }),
	
	      setSize: methodOp(function(width, height) {
	        var this$1 = this;
	
	        var interpret = function (val) { return typeof val == "number" || /^\d+$/.test(String(val)) ? val + "px" : val; };
	        if (width != null) { this.display.wrapper.style.width = interpret(width); }
	        if (height != null) { this.display.wrapper.style.height = interpret(height); }
	        if (this.options.lineWrapping) { clearLineMeasurementCache(this); }
	        var lineNo = this.display.viewFrom;
	        this.doc.iter(lineNo, this.display.viewTo, function (line) {
	          if (line.widgets) { for (var i = 0; i < line.widgets.length; i++)
	            { if (line.widgets[i].noHScroll) { regLineChange(this$1, lineNo, "widget"); break } } }
	          ++lineNo;
	        });
	        this.curOp.forceUpdate = true;
	        signal(this, "refresh", this);
	      }),
	
	      operation: function(f){return runInOp(this, f)},
	      startOperation: function(){return startOperation(this)},
	      endOperation: function(){return endOperation(this)},
	
	      refresh: methodOp(function() {
	        var oldHeight = this.display.cachedTextHeight;
	        regChange(this);
	        this.curOp.forceUpdate = true;
	        clearCaches(this);
	        scrollToCoords(this, this.doc.scrollLeft, this.doc.scrollTop);
	        updateGutterSpace(this.display);
	        if (oldHeight == null || Math.abs(oldHeight - textHeight(this.display)) > .5)
	          { estimateLineHeights(this); }
	        signal(this, "refresh", this);
	      }),
	
	      swapDoc: methodOp(function(doc) {
	        var old = this.doc;
	        old.cm = null;
	        // Cancel the current text selection if any (#5821)
	        if (this.state.selectingText) { this.state.selectingText(); }
	        attachDoc(this, doc);
	        clearCaches(this);
	        this.display.input.reset();
	        scrollToCoords(this, doc.scrollLeft, doc.scrollTop);
	        this.curOp.forceScroll = true;
	        signalLater(this, "swapDoc", this, old);
	        return old
	      }),
	
	      phrase: function(phraseText) {
	        var phrases = this.options.phrases;
	        return phrases && Object.prototype.hasOwnProperty.call(phrases, phraseText) ? phrases[phraseText] : phraseText
	      },
	
	      getInputField: function(){return this.display.input.getField()},
	      getWrapperElement: function(){return this.display.wrapper},
	      getScrollerElement: function(){return this.display.scroller},
	      getGutterElement: function(){return this.display.gutters}
	    };
	    eventMixin(CodeMirror);
	
	    CodeMirror.registerHelper = function(type, name, value) {
	      if (!helpers.hasOwnProperty(type)) { helpers[type] = CodeMirror[type] = {_global: []}; }
	      helpers[type][name] = value;
	    };
	    CodeMirror.registerGlobalHelper = function(type, name, predicate, value) {
	      CodeMirror.registerHelper(type, name, value);
	      helpers[type]._global.push({pred: predicate, val: value});
	    };
	  }
	
	  // Used for horizontal relative motion. Dir is -1 or 1 (left or
	  // right), unit can be "char", "column" (like char, but doesn't
	  // cross line boundaries), "word" (across next word), or "group" (to
	  // the start of next group of word or non-word-non-whitespace
	  // chars). The visually param controls whether, in right-to-left
	  // text, direction 1 means to move towards the next index in the
	  // string, or towards the character to the right of the current
	  // position. The resulting position will have a hitSide=true
	  // property if it reached the end of the document.
	  function findPosH(doc, pos, dir, unit, visually) {
	    var oldPos = pos;
	    var origDir = dir;
	    var lineObj = getLine(doc, pos.line);
	    var lineDir = visually && doc.direction == "rtl" ? -dir : dir;
	    function findNextLine() {
	      var l = pos.line + lineDir;
	      if (l < doc.first || l >= doc.first + doc.size) { return false }
	      pos = new Pos(l, pos.ch, pos.sticky);
	      return lineObj = getLine(doc, l)
	    }
	    function moveOnce(boundToLine) {
	      var next;
	      if (visually) {
	        next = moveVisually(doc.cm, lineObj, pos, dir);
	      } else {
	        next = moveLogically(lineObj, pos, dir);
	      }
	      if (next == null) {
	        if (!boundToLine && findNextLine())
	          { pos = endOfLine(visually, doc.cm, lineObj, pos.line, lineDir); }
	        else
	          { return false }
	      } else {
	        pos = next;
	      }
	      return true
	    }
	
	    if (unit == "char") {
	      moveOnce();
	    } else if (unit == "column") {
	      moveOnce(true);
	    } else if (unit == "word" || unit == "group") {
	      var sawType = null, group = unit == "group";
	      var helper = doc.cm && doc.cm.getHelper(pos, "wordChars");
	      for (var first = true;; first = false) {
	        if (dir < 0 && !moveOnce(!first)) { break }
	        var cur = lineObj.text.charAt(pos.ch) || "\n";
	        var type = isWordChar(cur, helper) ? "w"
	          : group && cur == "\n" ? "n"
	          : !group || /\s/.test(cur) ? null
	          : "p";
	        if (group && !first && !type) { type = "s"; }
	        if (sawType && sawType != type) {
	          if (dir < 0) {dir = 1; moveOnce(); pos.sticky = "after";}
	          break
	        }
	
	        if (type) { sawType = type; }
	        if (dir > 0 && !moveOnce(!first)) { break }
	      }
	    }
	    var result = skipAtomic(doc, pos, oldPos, origDir, true);
	    if (equalCursorPos(oldPos, result)) { result.hitSide = true; }
	    return result
	  }
	
	  // For relative vertical movement. Dir may be -1 or 1. Unit can be
	  // "page" or "line". The resulting position will have a hitSide=true
	  // property if it reached the end of the document.
	  function findPosV(cm, pos, dir, unit) {
	    var doc = cm.doc, x = pos.left, y;
	    if (unit == "page") {
	      var pageSize = Math.min(cm.display.wrapper.clientHeight, window.innerHeight || document.documentElement.clientHeight);
	      var moveAmount = Math.max(pageSize - .5 * textHeight(cm.display), 3);
	      y = (dir > 0 ? pos.bottom : pos.top) + dir * moveAmount;
	
	    } else if (unit == "line") {
	      y = dir > 0 ? pos.bottom + 3 : pos.top - 3;
	    }
	    var target;
	    for (;;) {
	      target = coordsChar(cm, x, y);
	      if (!target.outside) { break }
	      if (dir < 0 ? y <= 0 : y >= doc.height) { target.hitSide = true; break }
	      y += dir * 5;
	    }
	    return target
	  }
	
	  // CONTENTEDITABLE INPUT STYLE
	
	  var ContentEditableInput = function(cm) {
	    this.cm = cm;
	    this.lastAnchorNode = this.lastAnchorOffset = this.lastFocusNode = this.lastFocusOffset = null;
	    this.polling = new Delayed();
	    this.composing = null;
	    this.gracePeriod = false;
	    this.readDOMTimeout = null;
	  };
	
	  ContentEditableInput.prototype.init = function (display) {
	      var this$1 = this;
	
	    var input = this, cm = input.cm;
	    var div = input.div = display.lineDiv;
	    disableBrowserMagic(div, cm.options.spellcheck, cm.options.autocorrect, cm.options.autocapitalize);
	
	    on(div, "paste", function (e) {
	      if (signalDOMEvent(cm, e) || handlePaste(e, cm)) { return }
	      // IE doesn't fire input events, so we schedule a read for the pasted content in this way
	      if (ie_version <= 11) { setTimeout(operation(cm, function () { return this$1.updateFromDOM(); }), 20); }
	    });
	
	    on(div, "compositionstart", function (e) {
	      this$1.composing = {data: e.data, done: false};
	    });
	    on(div, "compositionupdate", function (e) {
	      if (!this$1.composing) { this$1.composing = {data: e.data, done: false}; }
	    });
	    on(div, "compositionend", function (e) {
	      if (this$1.composing) {
	        if (e.data != this$1.composing.data) { this$1.readFromDOMSoon(); }
	        this$1.composing.done = true;
	      }
	    });
	
	    on(div, "touchstart", function () { return input.forceCompositionEnd(); });
	
	    on(div, "input", function () {
	      if (!this$1.composing) { this$1.readFromDOMSoon(); }
	    });
	
	    function onCopyCut(e) {
	      if (signalDOMEvent(cm, e)) { return }
	      if (cm.somethingSelected()) {
	        setLastCopied({lineWise: false, text: cm.getSelections()});
	        if (e.type == "cut") { cm.replaceSelection("", null, "cut"); }
	      } else if (!cm.options.lineWiseCopyCut) {
	        return
	      } else {
	        var ranges = copyableRanges(cm);
	        setLastCopied({lineWise: true, text: ranges.text});
	        if (e.type == "cut") {
	          cm.operation(function () {
	            cm.setSelections(ranges.ranges, 0, sel_dontScroll);
	            cm.replaceSelection("", null, "cut");
	          });
	        }
	      }
	      if (e.clipboardData) {
	        e.clipboardData.clearData();
	        var content = lastCopied.text.join("\n");
	        // iOS exposes the clipboard API, but seems to discard content inserted into it
	        e.clipboardData.setData("Text", content);
	        if (e.clipboardData.getData("Text") == content) {
	          e.preventDefault();
	          return
	        }
	      }
	      // Old-fashioned briefly-focus-a-textarea hack
	      var kludge = hiddenTextarea(), te = kludge.firstChild;
	      cm.display.lineSpace.insertBefore(kludge, cm.display.lineSpace.firstChild);
	      te.value = lastCopied.text.join("\n");
	      var hadFocus = document.activeElement;
	      selectInput(te);
	      setTimeout(function () {
	        cm.display.lineSpace.removeChild(kludge);
	        hadFocus.focus();
	        if (hadFocus == div) { input.showPrimarySelection(); }
	      }, 50);
	    }
	    on(div, "copy", onCopyCut);
	    on(div, "cut", onCopyCut);
	  };
	
	  ContentEditableInput.prototype.prepareSelection = function () {
	    var result = prepareSelection(this.cm, false);
	    result.focus = document.activeElement == this.div;
	    return result
	  };
	
	  ContentEditableInput.prototype.showSelection = function (info, takeFocus) {
	    if (!info || !this.cm.display.view.length) { return }
	    if (info.focus || takeFocus) { this.showPrimarySelection(); }
	    this.showMultipleSelections(info);
	  };
	
	  ContentEditableInput.prototype.getSelection = function () {
	    return this.cm.display.wrapper.ownerDocument.getSelection()
	  };
	
	  ContentEditableInput.prototype.showPrimarySelection = function () {
	    var sel = this.getSelection(), cm = this.cm, prim = cm.doc.sel.primary();
	    var from = prim.from(), to = prim.to();
	
	    if (cm.display.viewTo == cm.display.viewFrom || from.line >= cm.display.viewTo || to.line < cm.display.viewFrom) {
	      sel.removeAllRanges();
	      return
	    }
	
	    var curAnchor = domToPos(cm, sel.anchorNode, sel.anchorOffset);
	    var curFocus = domToPos(cm, sel.focusNode, sel.focusOffset);
	    if (curAnchor && !curAnchor.bad && curFocus && !curFocus.bad &&
	        cmp(minPos(curAnchor, curFocus), from) == 0 &&
	        cmp(maxPos(curAnchor, curFocus), to) == 0)
	      { return }
	
	    var view = cm.display.view;
	    var start = (from.line >= cm.display.viewFrom && posToDOM(cm, from)) ||
	        {node: view[0].measure.map[2], offset: 0};
	    var end = to.line < cm.display.viewTo && posToDOM(cm, to);
	    if (!end) {
	      var measure = view[view.length - 1].measure;
	      var map = measure.maps ? measure.maps[measure.maps.length - 1] : measure.map;
	      end = {node: map[map.length - 1], offset: map[map.length - 2] - map[map.length - 3]};
	    }
	
	    if (!start || !end) {
	      sel.removeAllRanges();
	      return
	    }
	
	    var old = sel.rangeCount && sel.getRangeAt(0), rng;
	    try { rng = range(start.node, start.offset, end.offset, end.node); }
	    catch(e) {} // Our model of the DOM might be outdated, in which case the range we try to set can be impossible
	    if (rng) {
	      if (!gecko && cm.state.focused) {
	        sel.collapse(start.node, start.offset);
	        if (!rng.collapsed) {
	          sel.removeAllRanges();
	          sel.addRange(rng);
	        }
	      } else {
	        sel.removeAllRanges();
	        sel.addRange(rng);
	      }
	      if (old && sel.anchorNode == null) { sel.addRange(old); }
	      else if (gecko) { this.startGracePeriod(); }
	    }
	    this.rememberSelection();
	  };
	
	  ContentEditableInput.prototype.startGracePeriod = function () {
	      var this$1 = this;
	
	    clearTimeout(this.gracePeriod);
	    this.gracePeriod = setTimeout(function () {
	      this$1.gracePeriod = false;
	      if (this$1.selectionChanged())
	        { this$1.cm.operation(function () { return this$1.cm.curOp.selectionChanged = true; }); }
	    }, 20);
	  };
	
	  ContentEditableInput.prototype.showMultipleSelections = function (info) {
	    removeChildrenAndAdd(this.cm.display.cursorDiv, info.cursors);
	    removeChildrenAndAdd(this.cm.display.selectionDiv, info.selection);
	  };
	
	  ContentEditableInput.prototype.rememberSelection = function () {
	    var sel = this.getSelection();
	    this.lastAnchorNode = sel.anchorNode; this.lastAnchorOffset = sel.anchorOffset;
	    this.lastFocusNode = sel.focusNode; this.lastFocusOffset = sel.focusOffset;
	  };
	
	  ContentEditableInput.prototype.selectionInEditor = function () {
	    var sel = this.getSelection();
	    if (!sel.rangeCount) { return false }
	    var node = sel.getRangeAt(0).commonAncestorContainer;
	    return contains(this.div, node)
	  };
	
	  ContentEditableInput.prototype.focus = function () {
	    if (this.cm.options.readOnly != "nocursor") {
	      if (!this.selectionInEditor() || document.activeElement != this.div)
	        { this.showSelection(this.prepareSelection(), true); }
	      this.div.focus();
	    }
	  };
	  ContentEditableInput.prototype.blur = function () { this.div.blur(); };
	  ContentEditableInput.prototype.getField = function () { return this.div };
	
	  ContentEditableInput.prototype.supportsTouch = function () { return true };
	
	  ContentEditableInput.prototype.receivedFocus = function () {
	    var input = this;
	    if (this.selectionInEditor())
	      { this.pollSelection(); }
	    else
	      { runInOp(this.cm, function () { return input.cm.curOp.selectionChanged = true; }); }
	
	    function poll() {
	      if (input.cm.state.focused) {
	        input.pollSelection();
	        input.polling.set(input.cm.options.pollInterval, poll);
	      }
	    }
	    this.polling.set(this.cm.options.pollInterval, poll);
	  };
	
	  ContentEditableInput.prototype.selectionChanged = function () {
	    var sel = this.getSelection();
	    return sel.anchorNode != this.lastAnchorNode || sel.anchorOffset != this.lastAnchorOffset ||
	      sel.focusNode != this.lastFocusNode || sel.focusOffset != this.lastFocusOffset
	  };
	
	  ContentEditableInput.prototype.pollSelection = function () {
	    if (this.readDOMTimeout != null || this.gracePeriod || !this.selectionChanged()) { return }
	    var sel = this.getSelection(), cm = this.cm;
	    // On Android Chrome (version 56, at least), backspacing into an
	    // uneditable block element will put the cursor in that element,
	    // and then, because it's not editable, hide the virtual keyboard.
	    // Because Android doesn't allow us to actually detect backspace
	    // presses in a sane way, this code checks for when that happens
	    // and simulates a backspace press in this case.
	    if (android && chrome && this.cm.display.gutterSpecs.length && isInGutter(sel.anchorNode)) {
	      this.cm.triggerOnKeyDown({type: "keydown", keyCode: 8, preventDefault: Math.abs});
	      this.blur();
	      this.focus();
	      return
	    }
	    if (this.composing) { return }
	    this.rememberSelection();
	    var anchor = domToPos(cm, sel.anchorNode, sel.anchorOffset);
	    var head = domToPos(cm, sel.focusNode, sel.focusOffset);
	    if (anchor && head) { runInOp(cm, function () {
	      setSelection(cm.doc, simpleSelection(anchor, head), sel_dontScroll);
	      if (anchor.bad || head.bad) { cm.curOp.selectionChanged = true; }
	    }); }
	  };
	
	  ContentEditableInput.prototype.pollContent = function () {
	    if (this.readDOMTimeout != null) {
	      clearTimeout(this.readDOMTimeout);
	      this.readDOMTimeout = null;
	    }
	
	    var cm = this.cm, display = cm.display, sel = cm.doc.sel.primary();
	    var from = sel.from(), to = sel.to();
	    if (from.ch == 0 && from.line > cm.firstLine())
	      { from = Pos(from.line - 1, getLine(cm.doc, from.line - 1).length); }
	    if (to.ch == getLine(cm.doc, to.line).text.length && to.line < cm.lastLine())
	      { to = Pos(to.line + 1, 0); }
	    if (from.line < display.viewFrom || to.line > display.viewTo - 1) { return false }
	
	    var fromIndex, fromLine, fromNode;
	    if (from.line == display.viewFrom || (fromIndex = findViewIndex(cm, from.line)) == 0) {
	      fromLine = lineNo(display.view[0].line);
	      fromNode = display.view[0].node;
	    } else {
	      fromLine = lineNo(display.view[fromIndex].line);
	      fromNode = display.view[fromIndex - 1].node.nextSibling;
	    }
	    var toIndex = findViewIndex(cm, to.line);
	    var toLine, toNode;
	    if (toIndex == display.view.length - 1) {
	      toLine = display.viewTo - 1;
	      toNode = display.lineDiv.lastChild;
	    } else {
	      toLine = lineNo(display.view[toIndex + 1].line) - 1;
	      toNode = display.view[toIndex + 1].node.previousSibling;
	    }
	
	    if (!fromNode) { return false }
	    var newText = cm.doc.splitLines(domTextBetween(cm, fromNode, toNode, fromLine, toLine));
	    var oldText = getBetween(cm.doc, Pos(fromLine, 0), Pos(toLine, getLine(cm.doc, toLine).text.length));
	    while (newText.length > 1 && oldText.length > 1) {
	      if (lst(newText) == lst(oldText)) { newText.pop(); oldText.pop(); toLine--; }
	      else if (newText[0] == oldText[0]) { newText.shift(); oldText.shift(); fromLine++; }
	      else { break }
	    }
	
	    var cutFront = 0, cutEnd = 0;
	    var newTop = newText[0], oldTop = oldText[0], maxCutFront = Math.min(newTop.length, oldTop.length);
	    while (cutFront < maxCutFront && newTop.charCodeAt(cutFront) == oldTop.charCodeAt(cutFront))
	      { ++cutFront; }
	    var newBot = lst(newText), oldBot = lst(oldText);
	    var maxCutEnd = Math.min(newBot.length - (newText.length == 1 ? cutFront : 0),
	                             oldBot.length - (oldText.length == 1 ? cutFront : 0));
	    while (cutEnd < maxCutEnd &&
	           newBot.charCodeAt(newBot.length - cutEnd - 1) == oldBot.charCodeAt(oldBot.length - cutEnd - 1))
	      { ++cutEnd; }
	    // Try to move start of change to start of selection if ambiguous
	    if (newText.length == 1 && oldText.length == 1 && fromLine == from.line) {
	      while (cutFront && cutFront > from.ch &&
	             newBot.charCodeAt(newBot.length - cutEnd - 1) == oldBot.charCodeAt(oldBot.length - cutEnd - 1)) {
	        cutFront--;
	        cutEnd++;
	      }
	    }
	
	    newText[newText.length - 1] = newBot.slice(0, newBot.length - cutEnd).replace(/^\u200b+/, "");
	    newText[0] = newText[0].slice(cutFront).replace(/\u200b+$/, "");
	
	    var chFrom = Pos(fromLine, cutFront);
	    var chTo = Pos(toLine, oldText.length ? lst(oldText).length - cutEnd : 0);
	    if (newText.length > 1 || newText[0] || cmp(chFrom, chTo)) {
	      replaceRange(cm.doc, newText, chFrom, chTo, "+input");
	      return true
	    }
	  };
	
	  ContentEditableInput.prototype.ensurePolled = function () {
	    this.forceCompositionEnd();
	  };
	  ContentEditableInput.prototype.reset = function () {
	    this.forceCompositionEnd();
	  };
	  ContentEditableInput.prototype.forceCompositionEnd = function () {
	    if (!this.composing) { return }
	    clearTimeout(this.readDOMTimeout);
	    this.composing = null;
	    this.updateFromDOM();
	    this.div.blur();
	    this.div.focus();
	  };
	  ContentEditableInput.prototype.readFromDOMSoon = function () {
	      var this$1 = this;
	
	    if (this.readDOMTimeout != null) { return }
	    this.readDOMTimeout = setTimeout(function () {
	      this$1.readDOMTimeout = null;
	      if (this$1.composing) {
	        if (this$1.composing.done) { this$1.composing = null; }
	        else { return }
	      }
	      this$1.updateFromDOM();
	    }, 80);
	  };
	
	  ContentEditableInput.prototype.updateFromDOM = function () {
	      var this$1 = this;
	
	    if (this.cm.isReadOnly() || !this.pollContent())
	      { runInOp(this.cm, function () { return regChange(this$1.cm); }); }
	  };
	
	  ContentEditableInput.prototype.setUneditable = function (node) {
	    node.contentEditable = "false";
	  };
	
	  ContentEditableInput.prototype.onKeyPress = function (e) {
	    if (e.charCode == 0 || this.composing) { return }
	    e.preventDefault();
	    if (!this.cm.isReadOnly())
	      { operation(this.cm, applyTextInput)(this.cm, String.fromCharCode(e.charCode == null ? e.keyCode : e.charCode), 0); }
	  };
	
	  ContentEditableInput.prototype.readOnlyChanged = function (val) {
	    this.div.contentEditable = String(val != "nocursor");
	  };
	
	  ContentEditableInput.prototype.onContextMenu = function () {};
	  ContentEditableInput.prototype.resetPosition = function () {};
	
	  ContentEditableInput.prototype.needsContentAttribute = true;
	
	  function posToDOM(cm, pos) {
	    var view = findViewForLine(cm, pos.line);
	    if (!view || view.hidden) { return null }
	    var line = getLine(cm.doc, pos.line);
	    var info = mapFromLineView(view, line, pos.line);
	
	    var order = getOrder(line, cm.doc.direction), side = "left";
	    if (order) {
	      var partPos = getBidiPartAt(order, pos.ch);
	      side = partPos % 2 ? "right" : "left";
	    }
	    var result = nodeAndOffsetInLineMap(info.map, pos.ch, side);
	    result.offset = result.collapse == "right" ? result.end : result.start;
	    return result
	  }
	
	  function isInGutter(node) {
	    for (var scan = node; scan; scan = scan.parentNode)
	      { if (/CodeMirror-gutter-wrapper/.test(scan.className)) { return true } }
	    return false
	  }
	
	  function badPos(pos, bad) { if (bad) { pos.bad = true; } return pos }
	
	  function domTextBetween(cm, from, to, fromLine, toLine) {
	    var text = "", closing = false, lineSep = cm.doc.lineSeparator(), extraLinebreak = false;
	    function recognizeMarker(id) { return function (marker) { return marker.id == id; } }
	    function close() {
	      if (closing) {
	        text += lineSep;
	        if (extraLinebreak) { text += lineSep; }
	        closing = extraLinebreak = false;
	      }
	    }
	    function addText(str) {
	      if (str) {
	        close();
	        text += str;
	      }
	    }
	    function walk(node) {
	      if (node.nodeType == 1) {
	        var cmText = node.getAttribute("cm-text");
	        if (cmText) {
	          addText(cmText);
	          return
	        }
	        var markerID = node.getAttribute("cm-marker"), range;
	        if (markerID) {
	          var found = cm.findMarks(Pos(fromLine, 0), Pos(toLine + 1, 0), recognizeMarker(+markerID));
	          if (found.length && (range = found[0].find(0)))
	            { addText(getBetween(cm.doc, range.from, range.to).join(lineSep)); }
	          return
	        }
	        if (node.getAttribute("contenteditable") == "false") { return }
	        var isBlock = /^(pre|div|p|li|table|br)$/i.test(node.nodeName);
	        if (!/^br$/i.test(node.nodeName) && node.textContent.length == 0) { return }
	
	        if (isBlock) { close(); }
	        for (var i = 0; i < node.childNodes.length; i++)
	          { walk(node.childNodes[i]); }
	
	        if (/^(pre|p)$/i.test(node.nodeName)) { extraLinebreak = true; }
	        if (isBlock) { closing = true; }
	      } else if (node.nodeType == 3) {
	        addText(node.nodeValue.replace(/\u200b/g, "").replace(/\u00a0/g, " "));
	      }
	    }
	    for (;;) {
	      walk(from);
	      if (from == to) { break }
	      from = from.nextSibling;
	      extraLinebreak = false;
	    }
	    return text
	  }
	
	  function domToPos(cm, node, offset) {
	    var lineNode;
	    if (node == cm.display.lineDiv) {
	      lineNode = cm.display.lineDiv.childNodes[offset];
	      if (!lineNode) { return badPos(cm.clipPos(Pos(cm.display.viewTo - 1)), true) }
	      node = null; offset = 0;
	    } else {
	      for (lineNode = node;; lineNode = lineNode.parentNode) {
	        if (!lineNode || lineNode == cm.display.lineDiv) { return null }
	        if (lineNode.parentNode && lineNode.parentNode == cm.display.lineDiv) { break }
	      }
	    }
	    for (var i = 0; i < cm.display.view.length; i++) {
	      var lineView = cm.display.view[i];
	      if (lineView.node == lineNode)
	        { return locateNodeInLineView(lineView, node, offset) }
	    }
	  }
	
	  function locateNodeInLineView(lineView, node, offset) {
	    var wrapper = lineView.text.firstChild, bad = false;
	    if (!node || !contains(wrapper, node)) { return badPos(Pos(lineNo(lineView.line), 0), true) }
	    if (node == wrapper) {
	      bad = true;
	      node = wrapper.childNodes[offset];
	      offset = 0;
	      if (!node) {
	        var line = lineView.rest ? lst(lineView.rest) : lineView.line;
	        return badPos(Pos(lineNo(line), line.text.length), bad)
	      }
	    }
	
	    var textNode = node.nodeType == 3 ? node : null, topNode = node;
	    if (!textNode && node.childNodes.length == 1 && node.firstChild.nodeType == 3) {
	      textNode = node.firstChild;
	      if (offset) { offset = textNode.nodeValue.length; }
	    }
	    while (topNode.parentNode != wrapper) { topNode = topNode.parentNode; }
	    var measure = lineView.measure, maps = measure.maps;
	
	    function find(textNode, topNode, offset) {
	      for (var i = -1; i < (maps ? maps.length : 0); i++) {
	        var map = i < 0 ? measure.map : maps[i];
	        for (var j = 0; j < map.length; j += 3) {
	          var curNode = map[j + 2];
	          if (curNode == textNode || curNode == topNode) {
	            var line = lineNo(i < 0 ? lineView.line : lineView.rest[i]);
	            var ch = map[j] + offset;
	            if (offset < 0 || curNode != textNode) { ch = map[j + (offset ? 1 : 0)]; }
	            return Pos(line, ch)
	          }
	        }
	      }
	    }
	    var found = find(textNode, topNode, offset);
	    if (found) { return badPos(found, bad) }
	
	    // FIXME this is all really shaky. might handle the few cases it needs to handle, but likely to cause problems
	    for (var after = topNode.nextSibling, dist = textNode ? textNode.nodeValue.length - offset : 0; after; after = after.nextSibling) {
	      found = find(after, after.firstChild, 0);
	      if (found)
	        { return badPos(Pos(found.line, found.ch - dist), bad) }
	      else
	        { dist += after.textContent.length; }
	    }
	    for (var before = topNode.previousSibling, dist$1 = offset; before; before = before.previousSibling) {
	      found = find(before, before.firstChild, -1);
	      if (found)
	        { return badPos(Pos(found.line, found.ch + dist$1), bad) }
	      else
	        { dist$1 += before.textContent.length; }
	    }
	  }
	
	  // TEXTAREA INPUT STYLE
	
	  var TextareaInput = function(cm) {
	    this.cm = cm;
	    // See input.poll and input.reset
	    this.prevInput = "";
	
	    // Flag that indicates whether we expect input to appear real soon
	    // now (after some event like 'keypress' or 'input') and are
	    // polling intensively.
	    this.pollingFast = false;
	    // Self-resetting timeout for the poller
	    this.polling = new Delayed();
	    // Used to work around IE issue with selection being forgotten when focus moves away from textarea
	    this.hasSelection = false;
	    this.composing = null;
	  };
	
	  TextareaInput.prototype.init = function (display) {
	      var this$1 = this;
	
	    var input = this, cm = this.cm;
	    this.createField(display);
	    var te = this.textarea;
	
	    display.wrapper.insertBefore(this.wrapper, display.wrapper.firstChild);
	
	    // Needed to hide big blue blinking cursor on Mobile Safari (doesn't seem to work in iOS 8 anymore)
	    if (ios) { te.style.width = "0px"; }
	
	    on(te, "input", function () {
	      if (ie && ie_version >= 9 && this$1.hasSelection) { this$1.hasSelection = null; }
	      input.poll();
	    });
	
	    on(te, "paste", function (e) {
	      if (signalDOMEvent(cm, e) || handlePaste(e, cm)) { return }
	
	      cm.state.pasteIncoming = +new Date;
	      input.fastPoll();
	    });
	
	    function prepareCopyCut(e) {
	      if (signalDOMEvent(cm, e)) { return }
	      if (cm.somethingSelected()) {
	        setLastCopied({lineWise: false, text: cm.getSelections()});
	      } else if (!cm.options.lineWiseCopyCut) {
	        return
	      } else {
	        var ranges = copyableRanges(cm);
	        setLastCopied({lineWise: true, text: ranges.text});
	        if (e.type == "cut") {
	          cm.setSelections(ranges.ranges, null, sel_dontScroll);
	        } else {
	          input.prevInput = "";
	          te.value = ranges.text.join("\n");
	          selectInput(te);
	        }
	      }
	      if (e.type == "cut") { cm.state.cutIncoming = +new Date; }
	    }
	    on(te, "cut", prepareCopyCut);
	    on(te, "copy", prepareCopyCut);
	
	    on(display.scroller, "paste", function (e) {
	      if (eventInWidget(display, e) || signalDOMEvent(cm, e)) { return }
	      if (!te.dispatchEvent) {
	        cm.state.pasteIncoming = +new Date;
	        input.focus();
	        return
	      }
	
	      // Pass the `paste` event to the textarea so it's handled by its event listener.
	      var event = new Event("paste");
	      event.clipboardData = e.clipboardData;
	      te.dispatchEvent(event);
	    });
	
	    // Prevent normal selection in the editor (we handle our own)
	    on(display.lineSpace, "selectstart", function (e) {
	      if (!eventInWidget(display, e)) { e_preventDefault(e); }
	    });
	
	    on(te, "compositionstart", function () {
	      var start = cm.getCursor("from");
	      if (input.composing) { input.composing.range.clear(); }
	      input.composing = {
	        start: start,
	        range: cm.markText(start, cm.getCursor("to"), {className: "CodeMirror-composing"})
	      };
	    });
	    on(te, "compositionend", function () {
	      if (input.composing) {
	        input.poll();
	        input.composing.range.clear();
	        input.composing = null;
	      }
	    });
	  };
	
	  TextareaInput.prototype.createField = function (_display) {
	    // Wraps and hides input textarea
	    this.wrapper = hiddenTextarea();
	    // The semihidden textarea that is focused when the editor is
	    // focused, and receives input.
	    this.textarea = this.wrapper.firstChild;
	  };
	
	  TextareaInput.prototype.prepareSelection = function () {
	    // Redraw the selection and/or cursor
	    var cm = this.cm, display = cm.display, doc = cm.doc;
	    var result = prepareSelection(cm);
	
	    // Move the hidden textarea near the cursor to prevent scrolling artifacts
	    if (cm.options.moveInputWithCursor) {
	      var headPos = cursorCoords(cm, doc.sel.primary().head, "div");
	      var wrapOff = display.wrapper.getBoundingClientRect(), lineOff = display.lineDiv.getBoundingClientRect();
	      result.teTop = Math.max(0, Math.min(display.wrapper.clientHeight - 10,
	                                          headPos.top + lineOff.top - wrapOff.top));
	      result.teLeft = Math.max(0, Math.min(display.wrapper.clientWidth - 10,
	                                           headPos.left + lineOff.left - wrapOff.left));
	    }
	
	    return result
	  };
	
	  TextareaInput.prototype.showSelection = function (drawn) {
	    var cm = this.cm, display = cm.display;
	    removeChildrenAndAdd(display.cursorDiv, drawn.cursors);
	    removeChildrenAndAdd(display.selectionDiv, drawn.selection);
	    if (drawn.teTop != null) {
	      this.wrapper.style.top = drawn.teTop + "px";
	      this.wrapper.style.left = drawn.teLeft + "px";
	    }
	  };
	
	  // Reset the input to correspond to the selection (or to be empty,
	  // when not typing and nothing is selected)
	  TextareaInput.prototype.reset = function (typing) {
	    if (this.contextMenuPending || this.composing) { return }
	    var cm = this.cm;
	    if (cm.somethingSelected()) {
	      this.prevInput = "";
	      var content = cm.getSelection();
	      this.textarea.value = content;
	      if (cm.state.focused) { selectInput(this.textarea); }
	      if (ie && ie_version >= 9) { this.hasSelection = content; }
	    } else if (!typing) {
	      this.prevInput = this.textarea.value = "";
	      if (ie && ie_version >= 9) { this.hasSelection = null; }
	    }
	  };
	
	  TextareaInput.prototype.getField = function () { return this.textarea };
	
	  TextareaInput.prototype.supportsTouch = function () { return false };
	
	  TextareaInput.prototype.focus = function () {
	    if (this.cm.options.readOnly != "nocursor" && (!mobile || activeElt() != this.textarea)) {
	      try { this.textarea.focus(); }
	      catch (e) {} // IE8 will throw if the textarea is display: none or not in DOM
	    }
	  };
	
	  TextareaInput.prototype.blur = function () { this.textarea.blur(); };
	
	  TextareaInput.prototype.resetPosition = function () {
	    this.wrapper.style.top = this.wrapper.style.left = 0;
	  };
	
	  TextareaInput.prototype.receivedFocus = function () { this.slowPoll(); };
	
	  // Poll for input changes, using the normal rate of polling. This
	  // runs as long as the editor is focused.
	  TextareaInput.prototype.slowPoll = function () {
	      var this$1 = this;
	
	    if (this.pollingFast) { return }
	    this.polling.set(this.cm.options.pollInterval, function () {
	      this$1.poll();
	      if (this$1.cm.state.focused) { this$1.slowPoll(); }
	    });
	  };
	
	  // When an event has just come in that is likely to add or change
	  // something in the input textarea, we poll faster, to ensure that
	  // the change appears on the screen quickly.
	  TextareaInput.prototype.fastPoll = function () {
	    var missed = false, input = this;
	    input.pollingFast = true;
	    function p() {
	      var changed = input.poll();
	      if (!changed && !missed) {missed = true; input.polling.set(60, p);}
	      else {input.pollingFast = false; input.slowPoll();}
	    }
	    input.polling.set(20, p);
	  };
	
	  // Read input from the textarea, and update the document to match.
	  // When something is selected, it is present in the textarea, and
	  // selected (unless it is huge, in which case a placeholder is
	  // used). When nothing is selected, the cursor sits after previously
	  // seen text (can be empty), which is stored in prevInput (we must
	  // not reset the textarea when typing, because that breaks IME).
	  TextareaInput.prototype.poll = function () {
	      var this$1 = this;
	
	    var cm = this.cm, input = this.textarea, prevInput = this.prevInput;
	    // Since this is called a *lot*, try to bail out as cheaply as
	    // possible when it is clear that nothing happened. hasSelection
	    // will be the case when there is a lot of text in the textarea,
	    // in which case reading its value would be expensive.
	    if (this.contextMenuPending || !cm.state.focused ||
	        (hasSelection(input) && !prevInput && !this.composing) ||
	        cm.isReadOnly() || cm.options.disableInput || cm.state.keySeq)
	      { return false }
	
	    var text = input.value;
	    // If nothing changed, bail.
	    if (text == prevInput && !cm.somethingSelected()) { return false }
	    // Work around nonsensical selection resetting in IE9/10, and
	    // inexplicable appearance of private area unicode characters on
	    // some key combos in Mac (#2689).
	    if (ie && ie_version >= 9 && this.hasSelection === text ||
	        mac && /[\uf700-\uf7ff]/.test(text)) {
	      cm.display.input.reset();
	      return false
	    }
	
	    if (cm.doc.sel == cm.display.selForContextMenu) {
	      var first = text.charCodeAt(0);
	      if (first == 0x200b && !prevInput) { prevInput = "\u200b"; }
	      if (first == 0x21da) { this.reset(); return this.cm.execCommand("undo") }
	    }
	    // Find the part of the input that is actually new
	    var same = 0, l = Math.min(prevInput.length, text.length);
	    while (same < l && prevInput.charCodeAt(same) == text.charCodeAt(same)) { ++same; }
	
	    runInOp(cm, function () {
	      applyTextInput(cm, text.slice(same), prevInput.length - same,
	                     null, this$1.composing ? "*compose" : null);
	
	      // Don't leave long text in the textarea, since it makes further polling slow
	      if (text.length > 1000 || text.indexOf("\n") > -1) { input.value = this$1.prevInput = ""; }
	      else { this$1.prevInput = text; }
	
	      if (this$1.composing) {
	        this$1.composing.range.clear();
	        this$1.composing.range = cm.markText(this$1.composing.start, cm.getCursor("to"),
	                                           {className: "CodeMirror-composing"});
	      }
	    });
	    return true
	  };
	
	  TextareaInput.prototype.ensurePolled = function () {
	    if (this.pollingFast && this.poll()) { this.pollingFast = false; }
	  };
	
	  TextareaInput.prototype.onKeyPress = function () {
	    if (ie && ie_version >= 9) { this.hasSelection = null; }
	    this.fastPoll();
	  };
	
	  TextareaInput.prototype.onContextMenu = function (e) {
	    var input = this, cm = input.cm, display = cm.display, te = input.textarea;
	    if (input.contextMenuPending) { input.contextMenuPending(); }
	    var pos = posFromMouse(cm, e), scrollPos = display.scroller.scrollTop;
	    if (!pos || presto) { return } // Opera is difficult.
	
	    // Reset the current text selection only if the click is done outside of the selection
	    // and 'resetSelectionOnContextMenu' option is true.
	    var reset = cm.options.resetSelectionOnContextMenu;
	    if (reset && cm.doc.sel.contains(pos) == -1)
	      { operation(cm, setSelection)(cm.doc, simpleSelection(pos), sel_dontScroll); }
	
	    var oldCSS = te.style.cssText, oldWrapperCSS = input.wrapper.style.cssText;
	    var wrapperBox = input.wrapper.offsetParent.getBoundingClientRect();
	    input.wrapper.style.cssText = "position: static";
	    te.style.cssText = "position: absolute; width: 30px; height: 30px;\n      top: " + (e.clientY - wrapperBox.top - 5) + "px; left: " + (e.clientX - wrapperBox.left - 5) + "px;\n      z-index: 1000; background: " + (ie ? "rgba(255, 255, 255, .05)" : "transparent") + ";\n      outline: none; border-width: 0; outline: none; overflow: hidden; opacity: .05; filter: alpha(opacity=5);";
	    var oldScrollY;
	    if (webkit) { oldScrollY = window.scrollY; } // Work around Chrome issue (#2712)
	    display.input.focus();
	    if (webkit) { window.scrollTo(null, oldScrollY); }
	    display.input.reset();
	    // Adds "Select all" to context menu in FF
	    if (!cm.somethingSelected()) { te.value = input.prevInput = " "; }
	    input.contextMenuPending = rehide;
	    display.selForContextMenu = cm.doc.sel;
	    clearTimeout(display.detectingSelectAll);
	
	    // Select-all will be greyed out if there's nothing to select, so
	    // this adds a zero-width space so that we can later check whether
	    // it got selected.
	    function prepareSelectAllHack() {
	      if (te.selectionStart != null) {
	        var selected = cm.somethingSelected();
	        var extval = "\u200b" + (selected ? te.value : "");
	        te.value = "\u21da"; // Used to catch context-menu undo
	        te.value = extval;
	        input.prevInput = selected ? "" : "\u200b";
	        te.selectionStart = 1; te.selectionEnd = extval.length;
	        // Re-set this, in case some other handler touched the
	        // selection in the meantime.
	        display.selForContextMenu = cm.doc.sel;
	      }
	    }
	    function rehide() {
	      if (input.contextMenuPending != rehide) { return }
	      input.contextMenuPending = false;
	      input.wrapper.style.cssText = oldWrapperCSS;
	      te.style.cssText = oldCSS;
	      if (ie && ie_version < 9) { display.scrollbars.setScrollTop(display.scroller.scrollTop = scrollPos); }
	
	      // Try to detect the user choosing select-all
	      if (te.selectionStart != null) {
	        if (!ie || (ie && ie_version < 9)) { prepareSelectAllHack(); }
	        var i = 0, poll = function () {
	          if (display.selForContextMenu == cm.doc.sel && te.selectionStart == 0 &&
	              te.selectionEnd > 0 && input.prevInput == "\u200b") {
	            operation(cm, selectAll)(cm);
	          } else if (i++ < 10) {
	            display.detectingSelectAll = setTimeout(poll, 500);
	          } else {
	            display.selForContextMenu = null;
	            display.input.reset();
	          }
	        };
	        display.detectingSelectAll = setTimeout(poll, 200);
	      }
	    }
	
	    if (ie && ie_version >= 9) { prepareSelectAllHack(); }
	    if (captureRightClick) {
	      e_stop(e);
	      var mouseup = function () {
	        off(window, "mouseup", mouseup);
	        setTimeout(rehide, 20);
	      };
	      on(window, "mouseup", mouseup);
	    } else {
	      setTimeout(rehide, 50);
	    }
	  };
	
	  TextareaInput.prototype.readOnlyChanged = function (val) {
	    if (!val) { this.reset(); }
	    this.textarea.disabled = val == "nocursor";
	  };
	
	  TextareaInput.prototype.setUneditable = function () {};
	
	  TextareaInput.prototype.needsContentAttribute = false;
	
	  function fromTextArea(textarea, options) {
	    options = options ? copyObj(options) : {};
	    options.value = textarea.value;
	    if (!options.tabindex && textarea.tabIndex)
	      { options.tabindex = textarea.tabIndex; }
	    if (!options.placeholder && textarea.placeholder)
	      { options.placeholder = textarea.placeholder; }
	    // Set autofocus to true if this textarea is focused, or if it has
	    // autofocus and no other element is focused.
	    if (options.autofocus == null) {
	      var hasFocus = activeElt();
	      options.autofocus = hasFocus == textarea ||
	        textarea.getAttribute("autofocus") != null && hasFocus == document.body;
	    }
	
	    function save() {textarea.value = cm.getValue();}
	
	    var realSubmit;
	    if (textarea.form) {
	      on(textarea.form, "submit", save);
	      // Deplorable hack to make the submit method do the right thing.
	      if (!options.leaveSubmitMethodAlone) {
	        var form = textarea.form;
	        realSubmit = form.submit;
	        try {
	          var wrappedSubmit = form.submit = function () {
	            save();
	            form.submit = realSubmit;
	            form.submit();
	            form.submit = wrappedSubmit;
	          };
	        } catch(e) {}
	      }
	    }
	
	    options.finishInit = function (cm) {
	      cm.save = save;
	      cm.getTextArea = function () { return textarea; };
	      cm.toTextArea = function () {
	        cm.toTextArea = isNaN; // Prevent this from being ran twice
	        save();
	        textarea.parentNode.removeChild(cm.getWrapperElement());
	        textarea.style.display = "";
	        if (textarea.form) {
	          off(textarea.form, "submit", save);
	          if (!options.leaveSubmitMethodAlone && typeof textarea.form.submit == "function")
	            { textarea.form.submit = realSubmit; }
	        }
	      };
	    };
	
	    textarea.style.display = "none";
	    var cm = CodeMirror(function (node) { return textarea.parentNode.insertBefore(node, textarea.nextSibling); },
	      options);
	    return cm
	  }
	
	  function addLegacyProps(CodeMirror) {
	    CodeMirror.off = off;
	    CodeMirror.on = on;
	    CodeMirror.wheelEventPixels = wheelEventPixels;
	    CodeMirror.Doc = Doc;
	    CodeMirror.splitLines = splitLinesAuto;
	    CodeMirror.countColumn = countColumn;
	    CodeMirror.findColumn = findColumn;
	    CodeMirror.isWordChar = isWordCharBasic;
	    CodeMirror.Pass = Pass;
	    CodeMirror.signal = signal;
	    CodeMirror.Line = Line;
	    CodeMirror.changeEnd = changeEnd;
	    CodeMirror.scrollbarModel = scrollbarModel;
	    CodeMirror.Pos = Pos;
	    CodeMirror.cmpPos = cmp;
	    CodeMirror.modes = modes;
	    CodeMirror.mimeModes = mimeModes;
	    CodeMirror.resolveMode = resolveMode;
	    CodeMirror.getMode = getMode;
	    CodeMirror.modeExtensions = modeExtensions;
	    CodeMirror.extendMode = extendMode;
	    CodeMirror.copyState = copyState;
	    CodeMirror.startState = startState;
	    CodeMirror.innerMode = innerMode;
	    CodeMirror.commands = commands;
	    CodeMirror.keyMap = keyMap;
	    CodeMirror.keyName = keyName;
	    CodeMirror.isModifierKey = isModifierKey;
	    CodeMirror.lookupKey = lookupKey;
	    CodeMirror.normalizeKeyMap = normalizeKeyMap;
	    CodeMirror.StringStream = StringStream;
	    CodeMirror.SharedTextMarker = SharedTextMarker;
	    CodeMirror.TextMarker = TextMarker;
	    CodeMirror.LineWidget = LineWidget;
	    CodeMirror.e_preventDefault = e_preventDefault;
	    CodeMirror.e_stopPropagation = e_stopPropagation;
	    CodeMirror.e_stop = e_stop;
	    CodeMirror.addClass = addClass;
	    CodeMirror.contains = contains;
	    CodeMirror.rmClass = rmClass;
	    CodeMirror.keyNames = keyNames;
	  }
	
	  // EDITOR CONSTRUCTOR
	
	  defineOptions(CodeMirror);
	
	  addEditorMethods(CodeMirror);
	
	  // Set up methods on CodeMirror's prototype to redirect to the editor's document.
	  var dontDelegate = "iter insert remove copy getEditor constructor".split(" ");
	  for (var prop in Doc.prototype) { if (Doc.prototype.hasOwnProperty(prop) && indexOf(dontDelegate, prop) < 0)
	    { CodeMirror.prototype[prop] = (function(method) {
	      return function() {return method.apply(this.doc, arguments)}
	    })(Doc.prototype[prop]); } }
	
	  eventMixin(Doc);
	  CodeMirror.inputStyles = {"textarea": TextareaInput, "contenteditable": ContentEditableInput};
	
	  // Extra arguments are stored as the mode's dependencies, which is
	  // used by (legacy) mechanisms like loadmode.js to automatically
	  // load a mode. (Preferred mechanism is the require/define calls.)
	  CodeMirror.defineMode = function(name/*, mode, …*/) {
	    if (!CodeMirror.defaults.mode && name != "null") { CodeMirror.defaults.mode = name; }
	    defineMode.apply(this, arguments);
	  };
	
	  CodeMirror.defineMIME = defineMIME;
	
	  // Minimal default mode.
	  CodeMirror.defineMode("null", function () { return ({token: function (stream) { return stream.skipToEnd(); }}); });
	  CodeMirror.defineMIME("text/plain", "null");
	
	  // EXTENSIONS
	
	  CodeMirror.defineExtension = function (name, func) {
	    CodeMirror.prototype[name] = func;
	  };
	  CodeMirror.defineDocExtension = function (name, func) {
	    Doc.prototype[name] = func;
	  };
	
	  CodeMirror.fromTextArea = fromTextArea;
	
	  addLegacyProps(CodeMirror);
	
	  CodeMirror.version = "5.52.2";
	
	  return CodeMirror;
	
	})));


/***/ }),
/* 2 */
/***/ (function(module, exports) {

	module.exports = function normalizeComponent (
	  rawScriptExports,
	  compiledTemplate,
	  scopeId,
	  cssModules
	) {
	  var esModule
	  var scriptExports = rawScriptExports = rawScriptExports || {}
	
	  // ES6 modules interop
	  var type = typeof rawScriptExports.default
	  if (type === 'object' || type === 'function') {
	    esModule = rawScriptExports
	    scriptExports = rawScriptExports.default
	  }
	
	  // Vue.extend constructor export interop
	  var options = typeof scriptExports === 'function'
	    ? scriptExports.options
	    : scriptExports
	
	  // render functions
	  if (compiledTemplate) {
	    options.render = compiledTemplate.render
	    options.staticRenderFns = compiledTemplate.staticRenderFns
	  }
	
	  // scopedId
	  if (scopeId) {
	    options._scopeId = scopeId
	  }
	
	  // inject cssModules
	  if (cssModules) {
	    var computed = options.computed || (options.computed = {})
	    Object.keys(cssModules).forEach(function (key) {
	      var module = cssModules[key]
	      computed[key] = function () { return module }
	    })
	  }
	
	  return {
	    esModule: esModule,
	    exports: scriptExports,
	    options: options
	  }
	}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * vuex v2.5.0
	 * (c) 2017 Evan You
	 * @license MIT
	 */
	'use strict';
	
	var applyMixin = function (Vue) {
	  var version = Number(Vue.version.split('.')[0]);
	
	  if (version >= 2) {
	    Vue.mixin({ beforeCreate: vuexInit });
	  } else {
	    // override init and inject vuex init procedure
	    // for 1.x backwards compatibility.
	    var _init = Vue.prototype._init;
	    Vue.prototype._init = function (options) {
	      if ( options === void 0 ) options = {};
	
	      options.init = options.init
	        ? [vuexInit].concat(options.init)
	        : vuexInit;
	      _init.call(this, options);
	    };
	  }
	
	  /**
	   * Vuex init hook, injected into each instances init hooks list.
	   */
	
	  function vuexInit () {
	    var options = this.$options;
	    // store injection
	    if (options.store) {
	      this.$store = typeof options.store === 'function'
	        ? options.store()
	        : options.store;
	    } else if (options.parent && options.parent.$store) {
	      this.$store = options.parent.$store;
	    }
	  }
	};
	
	var devtoolHook =
	  typeof window !== 'undefined' &&
	  window.__VUE_DEVTOOLS_GLOBAL_HOOK__;
	
	function devtoolPlugin (store) {
	  if (!devtoolHook) { return }
	
	  store._devtoolHook = devtoolHook;
	
	  devtoolHook.emit('vuex:init', store);
	
	  devtoolHook.on('vuex:travel-to-state', function (targetState) {
	    store.replaceState(targetState);
	  });
	
	  store.subscribe(function (mutation, state) {
	    devtoolHook.emit('vuex:mutation', mutation, state);
	  });
	}
	
	/**
	 * Get the first item that pass the test
	 * by second argument function
	 *
	 * @param {Array} list
	 * @param {Function} f
	 * @return {*}
	 */
	/**
	 * Deep copy the given object considering circular structure.
	 * This function caches all nested objects and its copies.
	 * If it detects circular structure, use cached copy to avoid infinite loop.
	 *
	 * @param {*} obj
	 * @param {Array<Object>} cache
	 * @return {*}
	 */
	
	
	/**
	 * forEach for object
	 */
	function forEachValue (obj, fn) {
	  Object.keys(obj).forEach(function (key) { return fn(obj[key], key); });
	}
	
	function isObject (obj) {
	  return obj !== null && typeof obj === 'object'
	}
	
	function isPromise (val) {
	  return val && typeof val.then === 'function'
	}
	
	function assert (condition, msg) {
	  if (!condition) { throw new Error(("[vuex] " + msg)) }
	}
	
	var Module = function Module (rawModule, runtime) {
	  this.runtime = runtime;
	  this._children = Object.create(null);
	  this._rawModule = rawModule;
	  var rawState = rawModule.state;
	  this.state = (typeof rawState === 'function' ? rawState() : rawState) || {};
	};
	
	var prototypeAccessors$1 = { namespaced: { configurable: true } };
	
	prototypeAccessors$1.namespaced.get = function () {
	  return !!this._rawModule.namespaced
	};
	
	Module.prototype.addChild = function addChild (key, module) {
	  this._children[key] = module;
	};
	
	Module.prototype.removeChild = function removeChild (key) {
	  delete this._children[key];
	};
	
	Module.prototype.getChild = function getChild (key) {
	  return this._children[key]
	};
	
	Module.prototype.update = function update (rawModule) {
	  this._rawModule.namespaced = rawModule.namespaced;
	  if (rawModule.actions) {
	    this._rawModule.actions = rawModule.actions;
	  }
	  if (rawModule.mutations) {
	    this._rawModule.mutations = rawModule.mutations;
	  }
	  if (rawModule.getters) {
	    this._rawModule.getters = rawModule.getters;
	  }
	};
	
	Module.prototype.forEachChild = function forEachChild (fn) {
	  forEachValue(this._children, fn);
	};
	
	Module.prototype.forEachGetter = function forEachGetter (fn) {
	  if (this._rawModule.getters) {
	    forEachValue(this._rawModule.getters, fn);
	  }
	};
	
	Module.prototype.forEachAction = function forEachAction (fn) {
	  if (this._rawModule.actions) {
	    forEachValue(this._rawModule.actions, fn);
	  }
	};
	
	Module.prototype.forEachMutation = function forEachMutation (fn) {
	  if (this._rawModule.mutations) {
	    forEachValue(this._rawModule.mutations, fn);
	  }
	};
	
	Object.defineProperties( Module.prototype, prototypeAccessors$1 );
	
	var ModuleCollection = function ModuleCollection (rawRootModule) {
	  // register root module (Vuex.Store options)
	  this.register([], rawRootModule, false);
	};
	
	ModuleCollection.prototype.get = function get (path) {
	  return path.reduce(function (module, key) {
	    return module.getChild(key)
	  }, this.root)
	};
	
	ModuleCollection.prototype.getNamespace = function getNamespace (path) {
	  var module = this.root;
	  return path.reduce(function (namespace, key) {
	    module = module.getChild(key);
	    return namespace + (module.namespaced ? key + '/' : '')
	  }, '')
	};
	
	ModuleCollection.prototype.update = function update$1 (rawRootModule) {
	  update([], this.root, rawRootModule);
	};
	
	ModuleCollection.prototype.register = function register (path, rawModule, runtime) {
	    var this$1 = this;
	    if ( runtime === void 0 ) runtime = true;
	
	  if (false) {
	    assertRawModule(path, rawModule);
	  }
	
	  var newModule = new Module(rawModule, runtime);
	  if (path.length === 0) {
	    this.root = newModule;
	  } else {
	    var parent = this.get(path.slice(0, -1));
	    parent.addChild(path[path.length - 1], newModule);
	  }
	
	  // register nested modules
	  if (rawModule.modules) {
	    forEachValue(rawModule.modules, function (rawChildModule, key) {
	      this$1.register(path.concat(key), rawChildModule, runtime);
	    });
	  }
	};
	
	ModuleCollection.prototype.unregister = function unregister (path) {
	  var parent = this.get(path.slice(0, -1));
	  var key = path[path.length - 1];
	  if (!parent.getChild(key).runtime) { return }
	
	  parent.removeChild(key);
	};
	
	function update (path, targetModule, newModule) {
	  if (false) {
	    assertRawModule(path, newModule);
	  }
	
	  // update target module
	  targetModule.update(newModule);
	
	  // update nested modules
	  if (newModule.modules) {
	    for (var key in newModule.modules) {
	      if (!targetModule.getChild(key)) {
	        if (false) {
	          console.warn(
	            "[vuex] trying to add a new module '" + key + "' on hot reloading, " +
	            'manual reload is needed'
	          );
	        }
	        return
	      }
	      update(
	        path.concat(key),
	        targetModule.getChild(key),
	        newModule.modules[key]
	      );
	    }
	  }
	}
	
	var functionAssert = {
	  assert: function (value) { return typeof value === 'function'; },
	  expected: 'function'
	};
	
	var objectAssert = {
	  assert: function (value) { return typeof value === 'function' ||
	    (typeof value === 'object' && typeof value.handler === 'function'); },
	  expected: 'function or object with "handler" function'
	};
	
	var assertTypes = {
	  getters: functionAssert,
	  mutations: functionAssert,
	  actions: objectAssert
	};
	
	function assertRawModule (path, rawModule) {
	  Object.keys(assertTypes).forEach(function (key) {
	    if (!rawModule[key]) { return }
	
	    var assertOptions = assertTypes[key];
	
	    forEachValue(rawModule[key], function (value, type) {
	      assert(
	        assertOptions.assert(value),
	        makeAssertionMessage(path, key, type, value, assertOptions.expected)
	      );
	    });
	  });
	}
	
	function makeAssertionMessage (path, key, type, value, expected) {
	  var buf = key + " should be " + expected + " but \"" + key + "." + type + "\"";
	  if (path.length > 0) {
	    buf += " in module \"" + (path.join('.')) + "\"";
	  }
	  buf += " is " + (JSON.stringify(value)) + ".";
	  return buf
	}
	
	var Vue; // bind on install
	
	var Store = function Store (options) {
	  var this$1 = this;
	  if ( options === void 0 ) options = {};
	
	  // Auto install if it is not done yet and `window` has `Vue`.
	  // To allow users to avoid auto-installation in some cases,
	  // this code should be placed here. See #731
	  if (!Vue && typeof window !== 'undefined' && window.Vue) {
	    install(window.Vue);
	  }
	
	  if (false) {
	    assert(Vue, "must call Vue.use(Vuex) before creating a store instance.");
	    assert(typeof Promise !== 'undefined', "vuex requires a Promise polyfill in this browser.");
	    assert(this instanceof Store, "Store must be called with the new operator.");
	  }
	
	  var plugins = options.plugins; if ( plugins === void 0 ) plugins = [];
	  var strict = options.strict; if ( strict === void 0 ) strict = false;
	
	  var state = options.state; if ( state === void 0 ) state = {};
	  if (typeof state === 'function') {
	    state = state() || {};
	  }
	
	  // store internal state
	  this._committing = false;
	  this._actions = Object.create(null);
	  this._actionSubscribers = [];
	  this._mutations = Object.create(null);
	  this._wrappedGetters = Object.create(null);
	  this._modules = new ModuleCollection(options);
	  this._modulesNamespaceMap = Object.create(null);
	  this._subscribers = [];
	  this._watcherVM = new Vue();
	
	  // bind commit and dispatch to self
	  var store = this;
	  var ref = this;
	  var dispatch = ref.dispatch;
	  var commit = ref.commit;
	  this.dispatch = function boundDispatch (type, payload) {
	    return dispatch.call(store, type, payload)
	  };
	  this.commit = function boundCommit (type, payload, options) {
	    return commit.call(store, type, payload, options)
	  };
	
	  // strict mode
	  this.strict = strict;
	
	  // init root module.
	  // this also recursively registers all sub-modules
	  // and collects all module getters inside this._wrappedGetters
	  installModule(this, state, [], this._modules.root);
	
	  // initialize the store vm, which is responsible for the reactivity
	  // (also registers _wrappedGetters as computed properties)
	  resetStoreVM(this, state);
	
	  // apply plugins
	  plugins.forEach(function (plugin) { return plugin(this$1); });
	
	  if (Vue.config.devtools) {
	    devtoolPlugin(this);
	  }
	};
	
	var prototypeAccessors = { state: { configurable: true } };
	
	prototypeAccessors.state.get = function () {
	  return this._vm._data.$$state
	};
	
	prototypeAccessors.state.set = function (v) {
	  if (false) {
	    assert(false, "Use store.replaceState() to explicit replace store state.");
	  }
	};
	
	Store.prototype.commit = function commit (_type, _payload, _options) {
	    var this$1 = this;
	
	  // check object-style commit
	  var ref = unifyObjectStyle(_type, _payload, _options);
	    var type = ref.type;
	    var payload = ref.payload;
	    var options = ref.options;
	
	  var mutation = { type: type, payload: payload };
	  var entry = this._mutations[type];
	  if (!entry) {
	    if (false) {
	      console.error(("[vuex] unknown mutation type: " + type));
	    }
	    return
	  }
	  this._withCommit(function () {
	    entry.forEach(function commitIterator (handler) {
	      handler(payload);
	    });
	  });
	  this._subscribers.forEach(function (sub) { return sub(mutation, this$1.state); });
	
	  if (
	    false
	  ) {
	    console.warn(
	      "[vuex] mutation type: " + type + ". Silent option has been removed. " +
	      'Use the filter functionality in the vue-devtools'
	    );
	  }
	};
	
	Store.prototype.dispatch = function dispatch (_type, _payload) {
	    var this$1 = this;
	
	  // check object-style dispatch
	  var ref = unifyObjectStyle(_type, _payload);
	    var type = ref.type;
	    var payload = ref.payload;
	
	  var action = { type: type, payload: payload };
	  var entry = this._actions[type];
	  if (!entry) {
	    if (false) {
	      console.error(("[vuex] unknown action type: " + type));
	    }
	    return
	  }
	
	  this._actionSubscribers.forEach(function (sub) { return sub(action, this$1.state); });
	
	  return entry.length > 1
	    ? Promise.all(entry.map(function (handler) { return handler(payload); }))
	    : entry[0](payload)
	};
	
	Store.prototype.subscribe = function subscribe (fn) {
	  return genericSubscribe(fn, this._subscribers)
	};
	
	Store.prototype.subscribeAction = function subscribeAction (fn) {
	  return genericSubscribe(fn, this._actionSubscribers)
	};
	
	Store.prototype.watch = function watch (getter, cb, options) {
	    var this$1 = this;
	
	  if (false) {
	    assert(typeof getter === 'function', "store.watch only accepts a function.");
	  }
	  return this._watcherVM.$watch(function () { return getter(this$1.state, this$1.getters); }, cb, options)
	};
	
	Store.prototype.replaceState = function replaceState (state) {
	    var this$1 = this;
	
	  this._withCommit(function () {
	    this$1._vm._data.$$state = state;
	  });
	};
	
	Store.prototype.registerModule = function registerModule (path, rawModule, options) {
	    if ( options === void 0 ) options = {};
	
	  if (typeof path === 'string') { path = [path]; }
	
	  if (false) {
	    assert(Array.isArray(path), "module path must be a string or an Array.");
	    assert(path.length > 0, 'cannot register the root module by using registerModule.');
	  }
	
	  this._modules.register(path, rawModule);
	  installModule(this, this.state, path, this._modules.get(path), options.preserveState);
	  // reset store to update getters...
	  resetStoreVM(this, this.state);
	};
	
	Store.prototype.unregisterModule = function unregisterModule (path) {
	    var this$1 = this;
	
	  if (typeof path === 'string') { path = [path]; }
	
	  if (false) {
	    assert(Array.isArray(path), "module path must be a string or an Array.");
	  }
	
	  this._modules.unregister(path);
	  this._withCommit(function () {
	    var parentState = getNestedState(this$1.state, path.slice(0, -1));
	    Vue.delete(parentState, path[path.length - 1]);
	  });
	  resetStore(this);
	};
	
	Store.prototype.hotUpdate = function hotUpdate (newOptions) {
	  this._modules.update(newOptions);
	  resetStore(this, true);
	};
	
	Store.prototype._withCommit = function _withCommit (fn) {
	  var committing = this._committing;
	  this._committing = true;
	  fn();
	  this._committing = committing;
	};
	
	Object.defineProperties( Store.prototype, prototypeAccessors );
	
	function genericSubscribe (fn, subs) {
	  if (subs.indexOf(fn) < 0) {
	    subs.push(fn);
	  }
	  return function () {
	    var i = subs.indexOf(fn);
	    if (i > -1) {
	      subs.splice(i, 1);
	    }
	  }
	}
	
	function resetStore (store, hot) {
	  store._actions = Object.create(null);
	  store._mutations = Object.create(null);
	  store._wrappedGetters = Object.create(null);
	  store._modulesNamespaceMap = Object.create(null);
	  var state = store.state;
	  // init all modules
	  installModule(store, state, [], store._modules.root, true);
	  // reset vm
	  resetStoreVM(store, state, hot);
	}
	
	function resetStoreVM (store, state, hot) {
	  var oldVm = store._vm;
	
	  // bind store public getters
	  store.getters = {};
	  var wrappedGetters = store._wrappedGetters;
	  var computed = {};
	  forEachValue(wrappedGetters, function (fn, key) {
	    // use computed to leverage its lazy-caching mechanism
	    computed[key] = function () { return fn(store); };
	    Object.defineProperty(store.getters, key, {
	      get: function () { return store._vm[key]; },
	      enumerable: true // for local getters
	    });
	  });
	
	  // use a Vue instance to store the state tree
	  // suppress warnings just in case the user has added
	  // some funky global mixins
	  var silent = Vue.config.silent;
	  Vue.config.silent = true;
	  store._vm = new Vue({
	    data: {
	      $$state: state
	    },
	    computed: computed
	  });
	  Vue.config.silent = silent;
	
	  // enable strict mode for new vm
	  if (store.strict) {
	    enableStrictMode(store);
	  }
	
	  if (oldVm) {
	    if (hot) {
	      // dispatch changes in all subscribed watchers
	      // to force getter re-evaluation for hot reloading.
	      store._withCommit(function () {
	        oldVm._data.$$state = null;
	      });
	    }
	    Vue.nextTick(function () { return oldVm.$destroy(); });
	  }
	}
	
	function installModule (store, rootState, path, module, hot) {
	  var isRoot = !path.length;
	  var namespace = store._modules.getNamespace(path);
	
	  // register in namespace map
	  if (module.namespaced) {
	    store._modulesNamespaceMap[namespace] = module;
	  }
	
	  // set state
	  if (!isRoot && !hot) {
	    var parentState = getNestedState(rootState, path.slice(0, -1));
	    var moduleName = path[path.length - 1];
	    store._withCommit(function () {
	      Vue.set(parentState, moduleName, module.state);
	    });
	  }
	
	  var local = module.context = makeLocalContext(store, namespace, path);
	
	  module.forEachMutation(function (mutation, key) {
	    var namespacedType = namespace + key;
	    registerMutation(store, namespacedType, mutation, local);
	  });
	
	  module.forEachAction(function (action, key) {
	    var type = action.root ? key : namespace + key;
	    var handler = action.handler || action;
	    registerAction(store, type, handler, local);
	  });
	
	  module.forEachGetter(function (getter, key) {
	    var namespacedType = namespace + key;
	    registerGetter(store, namespacedType, getter, local);
	  });
	
	  module.forEachChild(function (child, key) {
	    installModule(store, rootState, path.concat(key), child, hot);
	  });
	}
	
	/**
	 * make localized dispatch, commit, getters and state
	 * if there is no namespace, just use root ones
	 */
	function makeLocalContext (store, namespace, path) {
	  var noNamespace = namespace === '';
	
	  var local = {
	    dispatch: noNamespace ? store.dispatch : function (_type, _payload, _options) {
	      var args = unifyObjectStyle(_type, _payload, _options);
	      var payload = args.payload;
	      var options = args.options;
	      var type = args.type;
	
	      if (!options || !options.root) {
	        type = namespace + type;
	        if (false) {
	          console.error(("[vuex] unknown local action type: " + (args.type) + ", global type: " + type));
	          return
	        }
	      }
	
	      return store.dispatch(type, payload)
	    },
	
	    commit: noNamespace ? store.commit : function (_type, _payload, _options) {
	      var args = unifyObjectStyle(_type, _payload, _options);
	      var payload = args.payload;
	      var options = args.options;
	      var type = args.type;
	
	      if (!options || !options.root) {
	        type = namespace + type;
	        if (false) {
	          console.error(("[vuex] unknown local mutation type: " + (args.type) + ", global type: " + type));
	          return
	        }
	      }
	
	      store.commit(type, payload, options);
	    }
	  };
	
	  // getters and state object must be gotten lazily
	  // because they will be changed by vm update
	  Object.defineProperties(local, {
	    getters: {
	      get: noNamespace
	        ? function () { return store.getters; }
	        : function () { return makeLocalGetters(store, namespace); }
	    },
	    state: {
	      get: function () { return getNestedState(store.state, path); }
	    }
	  });
	
	  return local
	}
	
	function makeLocalGetters (store, namespace) {
	  var gettersProxy = {};
	
	  var splitPos = namespace.length;
	  Object.keys(store.getters).forEach(function (type) {
	    // skip if the target getter is not match this namespace
	    if (type.slice(0, splitPos) !== namespace) { return }
	
	    // extract local getter type
	    var localType = type.slice(splitPos);
	
	    // Add a port to the getters proxy.
	    // Define as getter property because
	    // we do not want to evaluate the getters in this time.
	    Object.defineProperty(gettersProxy, localType, {
	      get: function () { return store.getters[type]; },
	      enumerable: true
	    });
	  });
	
	  return gettersProxy
	}
	
	function registerMutation (store, type, handler, local) {
	  var entry = store._mutations[type] || (store._mutations[type] = []);
	  entry.push(function wrappedMutationHandler (payload) {
	    handler.call(store, local.state, payload);
	  });
	}
	
	function registerAction (store, type, handler, local) {
	  var entry = store._actions[type] || (store._actions[type] = []);
	  entry.push(function wrappedActionHandler (payload, cb) {
	    var res = handler.call(store, {
	      dispatch: local.dispatch,
	      commit: local.commit,
	      getters: local.getters,
	      state: local.state,
	      rootGetters: store.getters,
	      rootState: store.state
	    }, payload, cb);
	    if (!isPromise(res)) {
	      res = Promise.resolve(res);
	    }
	    if (store._devtoolHook) {
	      return res.catch(function (err) {
	        store._devtoolHook.emit('vuex:error', err);
	        throw err
	      })
	    } else {
	      return res
	    }
	  });
	}
	
	function registerGetter (store, type, rawGetter, local) {
	  if (store._wrappedGetters[type]) {
	    if (false) {
	      console.error(("[vuex] duplicate getter key: " + type));
	    }
	    return
	  }
	  store._wrappedGetters[type] = function wrappedGetter (store) {
	    return rawGetter(
	      local.state, // local state
	      local.getters, // local getters
	      store.state, // root state
	      store.getters // root getters
	    )
	  };
	}
	
	function enableStrictMode (store) {
	  store._vm.$watch(function () { return this._data.$$state }, function () {
	    if (false) {
	      assert(store._committing, "Do not mutate vuex store state outside mutation handlers.");
	    }
	  }, { deep: true, sync: true });
	}
	
	function getNestedState (state, path) {
	  return path.length
	    ? path.reduce(function (state, key) { return state[key]; }, state)
	    : state
	}
	
	function unifyObjectStyle (type, payload, options) {
	  if (isObject(type) && type.type) {
	    options = payload;
	    payload = type;
	    type = type.type;
	  }
	
	  if (false) {
	    assert(typeof type === 'string', ("Expects string as the type, but found " + (typeof type) + "."));
	  }
	
	  return { type: type, payload: payload, options: options }
	}
	
	function install (_Vue) {
	  if (Vue && _Vue === Vue) {
	    if (false) {
	      console.error(
	        '[vuex] already installed. Vue.use(Vuex) should be called only once.'
	      );
	    }
	    return
	  }
	  Vue = _Vue;
	  applyMixin(Vue);
	}
	
	var mapState = normalizeNamespace(function (namespace, states) {
	  var res = {};
	  normalizeMap(states).forEach(function (ref) {
	    var key = ref.key;
	    var val = ref.val;
	
	    res[key] = function mappedState () {
	      var state = this.$store.state;
	      var getters = this.$store.getters;
	      if (namespace) {
	        var module = getModuleByNamespace(this.$store, 'mapState', namespace);
	        if (!module) {
	          return
	        }
	        state = module.context.state;
	        getters = module.context.getters;
	      }
	      return typeof val === 'function'
	        ? val.call(this, state, getters)
	        : state[val]
	    };
	    // mark vuex getter for devtools
	    res[key].vuex = true;
	  });
	  return res
	});
	
	var mapMutations = normalizeNamespace(function (namespace, mutations) {
	  var res = {};
	  normalizeMap(mutations).forEach(function (ref) {
	    var key = ref.key;
	    var val = ref.val;
	
	    res[key] = function mappedMutation () {
	      var args = [], len = arguments.length;
	      while ( len-- ) args[ len ] = arguments[ len ];
	
	      var commit = this.$store.commit;
	      if (namespace) {
	        var module = getModuleByNamespace(this.$store, 'mapMutations', namespace);
	        if (!module) {
	          return
	        }
	        commit = module.context.commit;
	      }
	      return typeof val === 'function'
	        ? val.apply(this, [commit].concat(args))
	        : commit.apply(this.$store, [val].concat(args))
	    };
	  });
	  return res
	});
	
	var mapGetters = normalizeNamespace(function (namespace, getters) {
	  var res = {};
	  normalizeMap(getters).forEach(function (ref) {
	    var key = ref.key;
	    var val = ref.val;
	
	    val = namespace + val;
	    res[key] = function mappedGetter () {
	      if (namespace && !getModuleByNamespace(this.$store, 'mapGetters', namespace)) {
	        return
	      }
	      if (false) {
	        console.error(("[vuex] unknown getter: " + val));
	        return
	      }
	      return this.$store.getters[val]
	    };
	    // mark vuex getter for devtools
	    res[key].vuex = true;
	  });
	  return res
	});
	
	var mapActions = normalizeNamespace(function (namespace, actions) {
	  var res = {};
	  normalizeMap(actions).forEach(function (ref) {
	    var key = ref.key;
	    var val = ref.val;
	
	    res[key] = function mappedAction () {
	      var args = [], len = arguments.length;
	      while ( len-- ) args[ len ] = arguments[ len ];
	
	      var dispatch = this.$store.dispatch;
	      if (namespace) {
	        var module = getModuleByNamespace(this.$store, 'mapActions', namespace);
	        if (!module) {
	          return
	        }
	        dispatch = module.context.dispatch;
	      }
	      return typeof val === 'function'
	        ? val.apply(this, [dispatch].concat(args))
	        : dispatch.apply(this.$store, [val].concat(args))
	    };
	  });
	  return res
	});
	
	var createNamespacedHelpers = function (namespace) { return ({
	  mapState: mapState.bind(null, namespace),
	  mapGetters: mapGetters.bind(null, namespace),
	  mapMutations: mapMutations.bind(null, namespace),
	  mapActions: mapActions.bind(null, namespace)
	}); };
	
	function normalizeMap (map) {
	  return Array.isArray(map)
	    ? map.map(function (key) { return ({ key: key, val: key }); })
	    : Object.keys(map).map(function (key) { return ({ key: key, val: map[key] }); })
	}
	
	function normalizeNamespace (fn) {
	  return function (namespace, map) {
	    if (typeof namespace !== 'string') {
	      map = namespace;
	      namespace = '';
	    } else if (namespace.charAt(namespace.length - 1) !== '/') {
	      namespace += '/';
	    }
	    return fn(namespace, map)
	  }
	}
	
	function getModuleByNamespace (store, helper, namespace) {
	  var module = store._modulesNamespaceMap[namespace];
	  if (false) {
	    console.error(("[vuex] module namespace not found in " + helper + "(): " + namespace));
	  }
	  return module
	}
	
	var index = {
	  Store: Store,
	  install: install,
	  version: '2.5.0',
	  mapState: mapState,
	  mapMutations: mapMutations,
	  mapGetters: mapGetters,
	  mapActions: mapActions,
	  createNamespacedHelpers: createNamespacedHelpers
	};
	
	module.exports = index;


/***/ }),
/* 4 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.6.11' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(207);

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var prosemirrorModel = __webpack_require__(12);
	var prosemirrorTransform = __webpack_require__(25);
	
	var classesById = Object.create(null);
	
	// ::- Superclass for editor selections. Every selection type should
	// extend this. Should not be instantiated directly.
	var Selection = function Selection($anchor, $head, ranges) {
	  // :: [SelectionRange]
	  // The ranges covered by the selection.
	  this.ranges = ranges || [new SelectionRange($anchor.min($head), $anchor.max($head))];
	  // :: ResolvedPos
	  // The resolved anchor of the selection (the side that stays in
	  // place when the selection is modified).
	  this.$anchor = $anchor;
	  // :: ResolvedPos
	  // The resolved head of the selection (the side that moves when
	  // the selection is modified).
	  this.$head = $head;
	};
	
	var prototypeAccessors = { anchor: { configurable: true },head: { configurable: true },from: { configurable: true },to: { configurable: true },$from: { configurable: true },$to: { configurable: true },empty: { configurable: true } };
	
	// :: number
	// The selection's anchor, as an unresolved position.
	prototypeAccessors.anchor.get = function () { return this.$anchor.pos };
	
	// :: number
	// The selection's head.
	prototypeAccessors.head.get = function () { return this.$head.pos };
	
	// :: number
	// The lower bound of the selection's main range.
	prototypeAccessors.from.get = function () { return this.$from.pos };
	
	// :: number
	// The upper bound of the selection's main range.
	prototypeAccessors.to.get = function () { return this.$to.pos };
	
	// :: ResolvedPos
	// The resolved lowerbound of the selection's main range.
	prototypeAccessors.$from.get = function () {
	  return this.ranges[0].$from
	};
	
	// :: ResolvedPos
	// The resolved upper bound of the selection's main range.
	prototypeAccessors.$to.get = function () {
	  return this.ranges[0].$to
	};
	
	// :: bool
	// Indicates whether the selection contains any content.
	prototypeAccessors.empty.get = function () {
	  var ranges = this.ranges;
	  for (var i = 0; i < ranges.length; i++)
	    { if (ranges[i].$from.pos != ranges[i].$to.pos) { return false } }
	  return true
	};
	
	// eq:: (Selection) → bool
	// Test whether the selection is the same as another selection.
	
	// map:: (doc: Node, mapping: Mappable) → Selection
	// Map this selection through a [mappable](#transform.Mappable) thing. `doc`
	// should be the new document to which we are mapping.
	
	// :: () → Slice
	// Get the content of this selection as a slice.
	Selection.prototype.content = function content () {
	  return this.$from.node(0).slice(this.from, this.to, true)
	};
	
	// :: (Transaction, ?Slice)
	// Replace the selection with a slice or, if no slice is given,
	// delete the selection. Will append to the given transaction.
	Selection.prototype.replace = function replace (tr, content) {
	    if ( content === void 0 ) content = prosemirrorModel.Slice.empty;
	
	  // Put the new selection at the position after the inserted
	  // content. When that ended in an inline node, search backwards,
	  // to get the position after that node. If not, search forward.
	  var lastNode = content.content.lastChild, lastParent = null;
	  for (var i = 0; i < content.openEnd; i++) {
	    lastParent = lastNode;
	    lastNode = lastNode.lastChild;
	  }
	
	  var mapFrom = tr.steps.length, ranges = this.ranges;
	  for (var i$1 = 0; i$1 < ranges.length; i$1++) {
	    var ref = ranges[i$1];
	      var $from = ref.$from;
	      var $to = ref.$to;
	      var mapping = tr.mapping.slice(mapFrom);
	    tr.replaceRange(mapping.map($from.pos), mapping.map($to.pos), i$1 ? prosemirrorModel.Slice.empty : content);
	    if (i$1 == 0)
	      { selectionToInsertionEnd(tr, mapFrom, (lastNode ? lastNode.isInline : lastParent && lastParent.isTextblock) ? -1 : 1); }
	  }
	};
	
	// :: (Transaction, Node)
	// Replace the selection with the given node, appending the changes
	// to the given transaction.
	Selection.prototype.replaceWith = function replaceWith (tr, node) {
	  var mapFrom = tr.steps.length, ranges = this.ranges;
	  for (var i = 0; i < ranges.length; i++) {
	    var ref = ranges[i];
	      var $from = ref.$from;
	      var $to = ref.$to;
	      var mapping = tr.mapping.slice(mapFrom);
	    var from = mapping.map($from.pos), to = mapping.map($to.pos);
	    if (i) {
	      tr.deleteRange(from, to);
	    } else {
	      tr.replaceRangeWith(from, to, node);
	      selectionToInsertionEnd(tr, mapFrom, node.isInline ? -1 : 1);
	    }
	  }
	};
	
	// toJSON:: () → Object
	// Convert the selection to a JSON representation. When implementing
	// this for a custom selection class, make sure to give the object a
	// `type` property whose value matches the ID under which you
	// [registered](#state.Selection^jsonID) your class.
	
	// :: (ResolvedPos, number, ?bool) → ?Selection
	// Find a valid cursor or leaf node selection starting at the given
	// position and searching back if `dir` is negative, and forward if
	// positive. When `textOnly` is true, only consider cursor
	// selections. Will return null when no valid selection position is
	// found.
	Selection.findFrom = function findFrom ($pos, dir, textOnly) {
	  var inner = $pos.parent.inlineContent ? new TextSelection($pos)
	      : findSelectionIn($pos.node(0), $pos.parent, $pos.pos, $pos.index(), dir, textOnly);
	  if (inner) { return inner }
	
	  for (var depth = $pos.depth - 1; depth >= 0; depth--) {
	    var found = dir < 0
	        ? findSelectionIn($pos.node(0), $pos.node(depth), $pos.before(depth + 1), $pos.index(depth), dir, textOnly)
	        : findSelectionIn($pos.node(0), $pos.node(depth), $pos.after(depth + 1), $pos.index(depth) + 1, dir, textOnly);
	    if (found) { return found }
	  }
	};
	
	// :: (ResolvedPos, ?number) → Selection
	// Find a valid cursor or leaf node selection near the given
	// position. Searches forward first by default, but if `bias` is
	// negative, it will search backwards first.
	Selection.near = function near ($pos, bias) {
	    if ( bias === void 0 ) bias = 1;
	
	  return this.findFrom($pos, bias) || this.findFrom($pos, -bias) || new AllSelection($pos.node(0))
	};
	
	// :: (Node) → Selection
	// Find the cursor or leaf node selection closest to the start of
	// the given document. Will return an
	// [`AllSelection`](#state.AllSelection) if no valid position
	// exists.
	Selection.atStart = function atStart (doc) {
	  return findSelectionIn(doc, doc, 0, 0, 1) || new AllSelection(doc)
	};
	
	// :: (Node) → Selection
	// Find the cursor or leaf node selection closest to the end of the
	// given document.
	Selection.atEnd = function atEnd (doc) {
	  return findSelectionIn(doc, doc, doc.content.size, doc.childCount, -1) || new AllSelection(doc)
	};
	
	// :: (Node, Object) → Selection
	// Deserialize the JSON representation of a selection. Must be
	// implemented for custom classes (as a static class method).
	Selection.fromJSON = function fromJSON (doc, json) {
	  if (!json || !json.type) { throw new RangeError("Invalid input for Selection.fromJSON") }
	  var cls = classesById[json.type];
	  if (!cls) { throw new RangeError(("No selection type " + (json.type) + " defined")) }
	  return cls.fromJSON(doc, json)
	};
	
	// :: (string, constructor<Selection>)
	// To be able to deserialize selections from JSON, custom selection
	// classes must register themselves with an ID string, so that they
	// can be disambiguated. Try to pick something that's unlikely to
	// clash with classes from other modules.
	Selection.jsonID = function jsonID (id, selectionClass) {
	  if (id in classesById) { throw new RangeError("Duplicate use of selection JSON ID " + id) }
	  classesById[id] = selectionClass;
	  selectionClass.prototype.jsonID = id;
	  return selectionClass
	};
	
	// :: () → SelectionBookmark
	// Get a [bookmark](#state.SelectionBookmark) for this selection,
	// which is a value that can be mapped without having access to a
	// current document, and later resolved to a real selection for a
	// given document again. (This is used mostly by the history to
	// track and restore old selections.) The default implementation of
	// this method just converts the selection to a text selection and
	// returns the bookmark for that.
	Selection.prototype.getBookmark = function getBookmark () {
	  return TextSelection.between(this.$anchor, this.$head).getBookmark()
	};
	
	Object.defineProperties( Selection.prototype, prototypeAccessors );
	
	// :: bool
	// Controls whether, when a selection of this type is active in the
	// browser, the selected range should be visible to the user. Defaults
	// to `true`.
	Selection.prototype.visible = true;
	
	// SelectionBookmark:: interface
	// A lightweight, document-independent representation of a selection.
	// You can define a custom bookmark type for a custom selection class
	// to make the history handle it well.
	//
	//   map:: (mapping: Mapping) → SelectionBookmark
	//   Map the bookmark through a set of changes.
	//
	//   resolve:: (doc: Node) → Selection
	//   Resolve the bookmark to a real selection again. This may need to
	//   do some error checking and may fall back to a default (usually
	//   [`TextSelection.between`](#state.TextSelection^between)) if
	//   mapping made the bookmark invalid.
	
	// ::- Represents a selected range in a document.
	var SelectionRange = function SelectionRange($from, $to) {
	  // :: ResolvedPos
	  // The lower bound of the range.
	  this.$from = $from;
	  // :: ResolvedPos
	  // The upper bound of the range.
	  this.$to = $to;
	};
	
	// ::- A text selection represents a classical editor selection, with
	// a head (the moving side) and anchor (immobile side), both of which
	// point into textblock nodes. It can be empty (a regular cursor
	// position).
	var TextSelection = /*@__PURE__*/(function (Selection) {
	  function TextSelection($anchor, $head) {
	    if ( $head === void 0 ) $head = $anchor;
	
	    Selection.call(this, $anchor, $head);
	  }
	
	  if ( Selection ) TextSelection.__proto__ = Selection;
	  TextSelection.prototype = Object.create( Selection && Selection.prototype );
	  TextSelection.prototype.constructor = TextSelection;
	
	  var prototypeAccessors$1 = { $cursor: { configurable: true } };
	
	  // :: ?ResolvedPos
	  // Returns a resolved position if this is a cursor selection (an
	  // empty text selection), and null otherwise.
	  prototypeAccessors$1.$cursor.get = function () { return this.$anchor.pos == this.$head.pos ? this.$head : null };
	
	  TextSelection.prototype.map = function map (doc, mapping) {
	    var $head = doc.resolve(mapping.map(this.head));
	    if (!$head.parent.inlineContent) { return Selection.near($head) }
	    var $anchor = doc.resolve(mapping.map(this.anchor));
	    return new TextSelection($anchor.parent.inlineContent ? $anchor : $head, $head)
	  };
	
	  TextSelection.prototype.replace = function replace (tr, content) {
	    if ( content === void 0 ) content = prosemirrorModel.Slice.empty;
	
	    Selection.prototype.replace.call(this, tr, content);
	    if (content == prosemirrorModel.Slice.empty) {
	      var marks = this.$from.marksAcross(this.$to);
	      if (marks) { tr.ensureMarks(marks); }
	    }
	  };
	
	  TextSelection.prototype.eq = function eq (other) {
	    return other instanceof TextSelection && other.anchor == this.anchor && other.head == this.head
	  };
	
	  TextSelection.prototype.getBookmark = function getBookmark () {
	    return new TextBookmark(this.anchor, this.head)
	  };
	
	  TextSelection.prototype.toJSON = function toJSON () {
	    return {type: "text", anchor: this.anchor, head: this.head}
	  };
	
	  TextSelection.fromJSON = function fromJSON (doc, json) {
	    if (typeof json.anchor != "number" || typeof json.head != "number")
	      { throw new RangeError("Invalid input for TextSelection.fromJSON") }
	    return new TextSelection(doc.resolve(json.anchor), doc.resolve(json.head))
	  };
	
	  // :: (Node, number, ?number) → TextSelection
	  // Create a text selection from non-resolved positions.
	  TextSelection.create = function create (doc, anchor, head) {
	    if ( head === void 0 ) head = anchor;
	
	    var $anchor = doc.resolve(anchor);
	    return new this($anchor, head == anchor ? $anchor : doc.resolve(head))
	  };
	
	  // :: (ResolvedPos, ResolvedPos, ?number) → Selection
	  // Return a text selection that spans the given positions or, if
	  // they aren't text positions, find a text selection near them.
	  // `bias` determines whether the method searches forward (default)
	  // or backwards (negative number) first. Will fall back to calling
	  // [`Selection.near`](#state.Selection^near) when the document
	  // doesn't contain a valid text position.
	  TextSelection.between = function between ($anchor, $head, bias) {
	    var dPos = $anchor.pos - $head.pos;
	    if (!bias || dPos) { bias = dPos >= 0 ? 1 : -1; }
	    if (!$head.parent.inlineContent) {
	      var found = Selection.findFrom($head, bias, true) || Selection.findFrom($head, -bias, true);
	      if (found) { $head = found.$head; }
	      else { return Selection.near($head, bias) }
	    }
	    if (!$anchor.parent.inlineContent) {
	      if (dPos == 0) {
	        $anchor = $head;
	      } else {
	        $anchor = (Selection.findFrom($anchor, -bias, true) || Selection.findFrom($anchor, bias, true)).$anchor;
	        if (($anchor.pos < $head.pos) != (dPos < 0)) { $anchor = $head; }
	      }
	    }
	    return new TextSelection($anchor, $head)
	  };
	
	  Object.defineProperties( TextSelection.prototype, prototypeAccessors$1 );
	
	  return TextSelection;
	}(Selection));
	
	Selection.jsonID("text", TextSelection);
	
	var TextBookmark = function TextBookmark(anchor, head) {
	  this.anchor = anchor;
	  this.head = head;
	};
	TextBookmark.prototype.map = function map (mapping) {
	  return new TextBookmark(mapping.map(this.anchor), mapping.map(this.head))
	};
	TextBookmark.prototype.resolve = function resolve (doc) {
	  return TextSelection.between(doc.resolve(this.anchor), doc.resolve(this.head))
	};
	
	// ::- A node selection is a selection that points at a single node.
	// All nodes marked [selectable](#model.NodeSpec.selectable) can be
	// the target of a node selection. In such a selection, `from` and
	// `to` point directly before and after the selected node, `anchor`
	// equals `from`, and `head` equals `to`..
	var NodeSelection = /*@__PURE__*/(function (Selection) {
	  function NodeSelection($pos) {
	    var node = $pos.nodeAfter;
	    var $end = $pos.node(0).resolve($pos.pos + node.nodeSize);
	    Selection.call(this, $pos, $end);
	    // :: Node The selected node.
	    this.node = node;
	  }
	
	  if ( Selection ) NodeSelection.__proto__ = Selection;
	  NodeSelection.prototype = Object.create( Selection && Selection.prototype );
	  NodeSelection.prototype.constructor = NodeSelection;
	
	  NodeSelection.prototype.map = function map (doc, mapping) {
	    var ref = mapping.mapResult(this.anchor);
	    var deleted = ref.deleted;
	    var pos = ref.pos;
	    var $pos = doc.resolve(pos);
	    if (deleted) { return Selection.near($pos) }
	    return new NodeSelection($pos)
	  };
	
	  NodeSelection.prototype.content = function content () {
	    return new prosemirrorModel.Slice(prosemirrorModel.Fragment.from(this.node), 0, 0)
	  };
	
	  NodeSelection.prototype.eq = function eq (other) {
	    return other instanceof NodeSelection && other.anchor == this.anchor
	  };
	
	  NodeSelection.prototype.toJSON = function toJSON () {
	    return {type: "node", anchor: this.anchor}
	  };
	
	  NodeSelection.prototype.getBookmark = function getBookmark () { return new NodeBookmark(this.anchor) };
	
	  NodeSelection.fromJSON = function fromJSON (doc, json) {
	    if (typeof json.anchor != "number")
	      { throw new RangeError("Invalid input for NodeSelection.fromJSON") }
	    return new NodeSelection(doc.resolve(json.anchor))
	  };
	
	  // :: (Node, number) → NodeSelection
	  // Create a node selection from non-resolved positions.
	  NodeSelection.create = function create (doc, from) {
	    return new this(doc.resolve(from))
	  };
	
	  // :: (Node) → bool
	  // Determines whether the given node may be selected as a node
	  // selection.
	  NodeSelection.isSelectable = function isSelectable (node) {
	    return !node.isText && node.type.spec.selectable !== false
	  };
	
	  return NodeSelection;
	}(Selection));
	
	NodeSelection.prototype.visible = false;
	
	Selection.jsonID("node", NodeSelection);
	
	var NodeBookmark = function NodeBookmark(anchor) {
	  this.anchor = anchor;
	};
	NodeBookmark.prototype.map = function map (mapping) {
	  var ref = mapping.mapResult(this.anchor);
	    var deleted = ref.deleted;
	    var pos = ref.pos;
	  return deleted ? new TextBookmark(pos, pos) : new NodeBookmark(pos)
	};
	NodeBookmark.prototype.resolve = function resolve (doc) {
	  var $pos = doc.resolve(this.anchor), node = $pos.nodeAfter;
	  if (node && NodeSelection.isSelectable(node)) { return new NodeSelection($pos) }
	  return Selection.near($pos)
	};
	
	// ::- A selection type that represents selecting the whole document
	// (which can not necessarily be expressed with a text selection, when
	// there are for example leaf block nodes at the start or end of the
	// document).
	var AllSelection = /*@__PURE__*/(function (Selection) {
	  function AllSelection(doc) {
	    Selection.call(this, doc.resolve(0), doc.resolve(doc.content.size));
	  }
	
	  if ( Selection ) AllSelection.__proto__ = Selection;
	  AllSelection.prototype = Object.create( Selection && Selection.prototype );
	  AllSelection.prototype.constructor = AllSelection;
	
	  AllSelection.prototype.replace = function replace (tr, content) {
	    if ( content === void 0 ) content = prosemirrorModel.Slice.empty;
	
	    if (content == prosemirrorModel.Slice.empty) {
	      tr.delete(0, tr.doc.content.size);
	      var sel = Selection.atStart(tr.doc);
	      if (!sel.eq(tr.selection)) { tr.setSelection(sel); }
	    } else {
	      Selection.prototype.replace.call(this, tr, content);
	    }
	  };
	
	  AllSelection.prototype.toJSON = function toJSON () { return {type: "all"} };
	
	  AllSelection.fromJSON = function fromJSON (doc) { return new AllSelection(doc) };
	
	  AllSelection.prototype.map = function map (doc) { return new AllSelection(doc) };
	
	  AllSelection.prototype.eq = function eq (other) { return other instanceof AllSelection };
	
	  AllSelection.prototype.getBookmark = function getBookmark () { return AllBookmark };
	
	  return AllSelection;
	}(Selection));
	
	Selection.jsonID("all", AllSelection);
	
	var AllBookmark = {
	  map: function map() { return this },
	  resolve: function resolve(doc) { return new AllSelection(doc) }
	};
	
	// FIXME we'll need some awareness of text direction when scanning for selections
	
	// Try to find a selection inside the given node. `pos` points at the
	// position where the search starts. When `text` is true, only return
	// text selections.
	function findSelectionIn(doc, node, pos, index, dir, text) {
	  if (node.inlineContent) { return TextSelection.create(doc, pos) }
	  for (var i = index - (dir > 0 ? 0 : 1); dir > 0 ? i < node.childCount : i >= 0; i += dir) {
	    var child = node.child(i);
	    if (!child.isAtom) {
	      var inner = findSelectionIn(doc, child, pos + dir, dir < 0 ? child.childCount : 0, dir, text);
	      if (inner) { return inner }
	    } else if (!text && NodeSelection.isSelectable(child)) {
	      return NodeSelection.create(doc, pos - (dir < 0 ? child.nodeSize : 0))
	    }
	    pos += child.nodeSize * dir;
	  }
	}
	
	function selectionToInsertionEnd(tr, startLen, bias) {
	  var last = tr.steps.length - 1;
	  if (last < startLen) { return }
	  var step = tr.steps[last];
	  if (!(step instanceof prosemirrorTransform.ReplaceStep || step instanceof prosemirrorTransform.ReplaceAroundStep)) { return }
	  var map = tr.mapping.maps[last], end;
	  map.forEach(function (_from, _to, _newFrom, newTo) { if (end == null) { end = newTo; } });
	  tr.setSelection(Selection.near(tr.doc.resolve(end), bias));
	}
	
	var UPDATED_SEL = 1, UPDATED_MARKS = 2, UPDATED_SCROLL = 4;
	
	// ::- An editor state transaction, which can be applied to a state to
	// create an updated state. Use
	// [`EditorState.tr`](#state.EditorState.tr) to create an instance.
	//
	// Transactions track changes to the document (they are a subclass of
	// [`Transform`](#transform.Transform)), but also other state changes,
	// like selection updates and adjustments of the set of [stored
	// marks](#state.EditorState.storedMarks). In addition, you can store
	// metadata properties in a transaction, which are extra pieces of
	// information that client code or plugins can use to describe what a
	// transacion represents, so that they can update their [own
	// state](#state.StateField) accordingly.
	//
	// The [editor view](#view.EditorView) uses a few metadata properties:
	// it will attach a property `"pointer"` with the value `true` to
	// selection transactions directly caused by mouse or touch input, and
	// a `"uiEvent"` property of that may be `"paste"`, `"cut"`, or `"drop"`.
	var Transaction = /*@__PURE__*/(function (Transform) {
	  function Transaction(state) {
	    Transform.call(this, state.doc);
	    // :: number
	    // The timestamp associated with this transaction, in the same
	    // format as `Date.now()`.
	    this.time = Date.now();
	    this.curSelection = state.selection;
	    // The step count for which the current selection is valid.
	    this.curSelectionFor = 0;
	    // :: ?[Mark]
	    // The stored marks set by this transaction, if any.
	    this.storedMarks = state.storedMarks;
	    // Bitfield to track which aspects of the state were updated by
	    // this transaction.
	    this.updated = 0;
	    // Object used to store metadata properties for the transaction.
	    this.meta = Object.create(null);
	  }
	
	  if ( Transform ) Transaction.__proto__ = Transform;
	  Transaction.prototype = Object.create( Transform && Transform.prototype );
	  Transaction.prototype.constructor = Transaction;
	
	  var prototypeAccessors = { selection: { configurable: true },selectionSet: { configurable: true },storedMarksSet: { configurable: true },isGeneric: { configurable: true },scrolledIntoView: { configurable: true } };
	
	  // :: Selection
	  // The transaction's current selection. This defaults to the editor
	  // selection [mapped](#state.Selection.map) through the steps in the
	  // transaction, but can be overwritten with
	  // [`setSelection`](#state.Transaction.setSelection).
	  prototypeAccessors.selection.get = function () {
	    if (this.curSelectionFor < this.steps.length) {
	      this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor));
	      this.curSelectionFor = this.steps.length;
	    }
	    return this.curSelection
	  };
	
	  // :: (Selection) → Transaction
	  // Update the transaction's current selection. Will determine the
	  // selection that the editor gets when the transaction is applied.
	  Transaction.prototype.setSelection = function setSelection (selection) {
	    if (selection.$from.doc != this.doc)
	      { throw new RangeError("Selection passed to setSelection must point at the current document") }
	    this.curSelection = selection;
	    this.curSelectionFor = this.steps.length;
	    this.updated = (this.updated | UPDATED_SEL) & ~UPDATED_MARKS;
	    this.storedMarks = null;
	    return this
	  };
	
	  // :: bool
	  // Whether the selection was explicitly updated by this transaction.
	  prototypeAccessors.selectionSet.get = function () {
	    return (this.updated & UPDATED_SEL) > 0
	  };
	
	  // :: (?[Mark]) → Transaction
	  // Set the current stored marks.
	  Transaction.prototype.setStoredMarks = function setStoredMarks (marks) {
	    this.storedMarks = marks;
	    this.updated |= UPDATED_MARKS;
	    return this
	  };
	
	  // :: ([Mark]) → Transaction
	  // Make sure the current stored marks or, if that is null, the marks
	  // at the selection, match the given set of marks. Does nothing if
	  // this is already the case.
	  Transaction.prototype.ensureMarks = function ensureMarks (marks) {
	    if (!prosemirrorModel.Mark.sameSet(this.storedMarks || this.selection.$from.marks(), marks))
	      { this.setStoredMarks(marks); }
	    return this
	  };
	
	  // :: (Mark) → Transaction
	  // Add a mark to the set of stored marks.
	  Transaction.prototype.addStoredMark = function addStoredMark (mark) {
	    return this.ensureMarks(mark.addToSet(this.storedMarks || this.selection.$head.marks()))
	  };
	
	  // :: (union<Mark, MarkType>) → Transaction
	  // Remove a mark or mark type from the set of stored marks.
	  Transaction.prototype.removeStoredMark = function removeStoredMark (mark) {
	    return this.ensureMarks(mark.removeFromSet(this.storedMarks || this.selection.$head.marks()))
	  };
	
	  // :: bool
	  // Whether the stored marks were explicitly set for this transaction.
	  prototypeAccessors.storedMarksSet.get = function () {
	    return (this.updated & UPDATED_MARKS) > 0
	  };
	
	  Transaction.prototype.addStep = function addStep (step, doc) {
	    Transform.prototype.addStep.call(this, step, doc);
	    this.updated = this.updated & ~UPDATED_MARKS;
	    this.storedMarks = null;
	  };
	
	  // :: (number) → Transaction
	  // Update the timestamp for the transaction.
	  Transaction.prototype.setTime = function setTime (time) {
	    this.time = time;
	    return this
	  };
	
	  // :: (Slice) → Transaction
	  // Replace the current selection with the given slice.
	  Transaction.prototype.replaceSelection = function replaceSelection (slice) {
	    this.selection.replace(this, slice);
	    return this
	  };
	
	  // :: (Node, ?bool) → Transaction
	  // Replace the selection with the given node. When `inheritMarks` is
	  // true and the content is inline, it inherits the marks from the
	  // place where it is inserted.
	  Transaction.prototype.replaceSelectionWith = function replaceSelectionWith (node, inheritMarks) {
	    var selection = this.selection;
	    if (inheritMarks !== false)
	      { node = node.mark(this.storedMarks || (selection.empty ? selection.$from.marks() : (selection.$from.marksAcross(selection.$to) || prosemirrorModel.Mark.none))); }
	    selection.replaceWith(this, node);
	    return this
	  };
	
	  // :: () → Transaction
	  // Delete the selection.
	  Transaction.prototype.deleteSelection = function deleteSelection () {
	    this.selection.replace(this);
	    return this
	  };
	
	  // :: (string, from: ?number, to: ?number) → Transaction
	  // Replace the given range, or the selection if no range is given,
	  // with a text node containing the given string.
	  Transaction.prototype.insertText = function insertText (text, from, to) {
	    if ( to === void 0 ) to = from;
	
	    var schema = this.doc.type.schema;
	    if (from == null) {
	      if (!text) { return this.deleteSelection() }
	      return this.replaceSelectionWith(schema.text(text), true)
	    } else {
	      if (!text) { return this.deleteRange(from, to) }
	      var marks = this.storedMarks;
	      if (!marks) {
	        var $from = this.doc.resolve(from);
	        marks = to == from ? $from.marks() : $from.marksAcross(this.doc.resolve(to));
	      }
	      this.replaceRangeWith(from, to, schema.text(text, marks));
	      if (!this.selection.empty) { this.setSelection(Selection.near(this.selection.$to)); }
	      return this
	    }
	  };
	
	  // :: (union<string, Plugin, PluginKey>, any) → Transaction
	  // Store a metadata property in this transaction, keyed either by
	  // name or by plugin.
	  Transaction.prototype.setMeta = function setMeta (key, value) {
	    this.meta[typeof key == "string" ? key : key.key] = value;
	    return this
	  };
	
	  // :: (union<string, Plugin, PluginKey>) → any
	  // Retrieve a metadata property for a given name or plugin.
	  Transaction.prototype.getMeta = function getMeta (key) {
	    return this.meta[typeof key == "string" ? key : key.key]
	  };
	
	  // :: bool
	  // Returns true if this transaction doesn't contain any metadata,
	  // and can thus safely be extended.
	  prototypeAccessors.isGeneric.get = function () {
	    for (var _ in this.meta) { return false }
	    return true
	  };
	
	  // :: () → Transaction
	  // Indicate that the editor should scroll the selection into view
	  // when updated to the state produced by this transaction.
	  Transaction.prototype.scrollIntoView = function scrollIntoView () {
	    this.updated |= UPDATED_SCROLL;
	    return this
	  };
	
	  prototypeAccessors.scrolledIntoView.get = function () {
	    return (this.updated & UPDATED_SCROLL) > 0
	  };
	
	  Object.defineProperties( Transaction.prototype, prototypeAccessors );
	
	  return Transaction;
	}(prosemirrorTransform.Transform));
	
	function bind(f, self) {
	  return !self || !f ? f : f.bind(self)
	}
	
	var FieldDesc = function FieldDesc(name, desc, self) {
	  this.name = name;
	  this.init = bind(desc.init, self);
	  this.apply = bind(desc.apply, self);
	};
	
	var baseFields = [
	  new FieldDesc("doc", {
	    init: function init(config) { return config.doc || config.schema.topNodeType.createAndFill() },
	    apply: function apply(tr) { return tr.doc }
	  }),
	
	  new FieldDesc("selection", {
	    init: function init(config, instance) { return config.selection || Selection.atStart(instance.doc) },
	    apply: function apply(tr) { return tr.selection }
	  }),
	
	  new FieldDesc("storedMarks", {
	    init: function init(config) { return config.storedMarks || null },
	    apply: function apply(tr, _marks, _old, state) { return state.selection.$cursor ? tr.storedMarks : null }
	  }),
	
	  new FieldDesc("scrollToSelection", {
	    init: function init() { return 0 },
	    apply: function apply(tr, prev) { return tr.scrolledIntoView ? prev + 1 : prev }
	  })
	];
	
	// Object wrapping the part of a state object that stays the same
	// across transactions. Stored in the state's `config` property.
	var Configuration = function Configuration(schema, plugins) {
	  var this$1 = this;
	
	  this.schema = schema;
	  this.fields = baseFields.concat();
	  this.plugins = [];
	  this.pluginsByKey = Object.create(null);
	  if (plugins) { plugins.forEach(function (plugin) {
	    if (this$1.pluginsByKey[plugin.key])
	      { throw new RangeError("Adding different instances of a keyed plugin (" + plugin.key + ")") }
	    this$1.plugins.push(plugin);
	    this$1.pluginsByKey[plugin.key] = plugin;
	    if (plugin.spec.state)
	      { this$1.fields.push(new FieldDesc(plugin.key, plugin.spec.state, plugin)); }
	  }); }
	};
	
	// ::- The state of a ProseMirror editor is represented by an object
	// of this type. A state is a persistent data structure—it isn't
	// updated, but rather a new state value is computed from an old one
	// using the [`apply`](#state.EditorState.apply) method.
	//
	// A state holds a number of built-in fields, and plugins can
	// [define](#state.PluginSpec.state) additional fields.
	var EditorState = function EditorState(config) {
	  this.config = config;
	};
	
	var prototypeAccessors$1 = { schema: { configurable: true },plugins: { configurable: true },tr: { configurable: true } };
	
	// doc:: Node
	// The current document.
	
	// selection:: Selection
	// The selection.
	
	// storedMarks:: ?[Mark]
	// A set of marks to apply to the next input. Will be null when
	// no explicit marks have been set.
	
	// :: Schema
	// The schema of the state's document.
	prototypeAccessors$1.schema.get = function () {
	  return this.config.schema
	};
	
	// :: [Plugin]
	// The plugins that are active in this state.
	prototypeAccessors$1.plugins.get = function () {
	  return this.config.plugins
	};
	
	// :: (Transaction) → EditorState
	// Apply the given transaction to produce a new state.
	EditorState.prototype.apply = function apply (tr) {
	  return this.applyTransaction(tr).state
	};
	
	// : (Transaction) → bool
	EditorState.prototype.filterTransaction = function filterTransaction (tr, ignore) {
	    if ( ignore === void 0 ) ignore = -1;
	
	  for (var i = 0; i < this.config.plugins.length; i++) { if (i != ignore) {
	    var plugin = this.config.plugins[i];
	    if (plugin.spec.filterTransaction && !plugin.spec.filterTransaction.call(plugin, tr, this))
	      { return false }
	  } }
	  return true
	};
	
	// :: (Transaction) → {state: EditorState, transactions: [Transaction]}
	// Verbose variant of [`apply`](#state.EditorState.apply) that
	// returns the precise transactions that were applied (which might
	// be influenced by the [transaction
	// hooks](#state.PluginSpec.filterTransaction) of
	// plugins) along with the new state.
	EditorState.prototype.applyTransaction = function applyTransaction (rootTr) {
	  if (!this.filterTransaction(rootTr)) { return {state: this, transactions: []} }
	
	  var trs = [rootTr], newState = this.applyInner(rootTr), seen = null;
	  // This loop repeatedly gives plugins a chance to respond to
	  // transactions as new transactions are added, making sure to only
	  // pass the transactions the plugin did not see before.
	   for (;;) {
	    var haveNew = false;
	    for (var i = 0; i < this.config.plugins.length; i++) {
	      var plugin = this.config.plugins[i];
	      if (plugin.spec.appendTransaction) {
	        var n = seen ? seen[i].n : 0, oldState = seen ? seen[i].state : this;
	        var tr = n < trs.length &&
	            plugin.spec.appendTransaction.call(plugin, n ? trs.slice(n) : trs, oldState, newState);
	        if (tr && newState.filterTransaction(tr, i)) {
	          tr.setMeta("appendedTransaction", rootTr);
	          if (!seen) {
	            seen = [];
	            for (var j = 0; j < this.config.plugins.length; j++)
	              { seen.push(j < i ? {state: newState, n: trs.length} : {state: this, n: 0}); }
	          }
	          trs.push(tr);
	          newState = newState.applyInner(tr);
	          haveNew = true;
	        }
	        if (seen) { seen[i] = {state: newState, n: trs.length}; }
	      }
	    }
	    if (!haveNew) { return {state: newState, transactions: trs} }
	  }
	};
	
	// : (Transaction) → EditorState
	EditorState.prototype.applyInner = function applyInner (tr) {
	  if (!tr.before.eq(this.doc)) { throw new RangeError("Applying a mismatched transaction") }
	  var newInstance = new EditorState(this.config), fields = this.config.fields;
	  for (var i = 0; i < fields.length; i++) {
	    var field = fields[i];
	    newInstance[field.name] = field.apply(tr, this[field.name], this, newInstance);
	  }
	  for (var i$1 = 0; i$1 < applyListeners.length; i$1++) { applyListeners[i$1](this, tr, newInstance); }
	  return newInstance
	};
	
	// :: Transaction
	// Start a [transaction](#state.Transaction) from this state.
	prototypeAccessors$1.tr.get = function () { return new Transaction(this) };
	
	// :: (Object) → EditorState
	// Create a new state.
	//
	// config::- Configuration options. Must contain `schema` or `doc` (or both).
	//
	//    schema:: ?Schema
	//    The schema to use.
	//
	//    doc:: ?Node
	//    The starting document.
	//
	//    selection:: ?Selection
	//    A valid selection in the document.
	//
	//    storedMarks:: ?[Mark]
	//    The initial set of [stored marks](#state.EditorState.storedMarks).
	//
	//    plugins:: ?[Plugin]
	//    The plugins that should be active in this state.
	EditorState.create = function create (config) {
	  var $config = new Configuration(config.schema || config.doc.type.schema, config.plugins);
	  var instance = new EditorState($config);
	  for (var i = 0; i < $config.fields.length; i++)
	    { instance[$config.fields[i].name] = $config.fields[i].init(config, instance); }
	  return instance
	};
	
	// :: (Object) → EditorState
	// Create a new state based on this one, but with an adjusted set of
	// active plugins. State fields that exist in both sets of plugins
	// are kept unchanged. Those that no longer exist are dropped, and
	// those that are new are initialized using their
	// [`init`](#state.StateField.init) method, passing in the new
	// configuration object..
	//
	// config::- configuration options
	//
	//   schema:: ?Schema
	//   New schema to use.
	//
	//   plugins:: ?[Plugin]
	//   New set of active plugins.
	EditorState.prototype.reconfigure = function reconfigure (config) {
	  var $config = new Configuration(config.schema || this.schema, config.plugins);
	  var fields = $config.fields, instance = new EditorState($config);
	  for (var i = 0; i < fields.length; i++) {
	    var name = fields[i].name;
	    instance[name] = this.hasOwnProperty(name) ? this[name] : fields[i].init(config, instance);
	  }
	  return instance
	};
	
	// :: (?union<Object<Plugin>, string, number>) → Object
	// Serialize this state to JSON. If you want to serialize the state
	// of plugins, pass an object mapping property names to use in the
	// resulting JSON object to plugin objects. The argument may also be
	// a string or number, in which case it is ignored, to support the
	// way `JSON.stringify` calls `toString` methods.
	EditorState.prototype.toJSON = function toJSON (pluginFields) {
	  var result = {doc: this.doc.toJSON(), selection: this.selection.toJSON()};
	  if (this.storedMarks) { result.storedMarks = this.storedMarks.map(function (m) { return m.toJSON(); }); }
	  if (pluginFields && typeof pluginFields == 'object') { for (var prop in pluginFields) {
	    if (prop == "doc" || prop == "selection")
	      { throw new RangeError("The JSON fields `doc` and `selection` are reserved") }
	    var plugin = pluginFields[prop], state = plugin.spec.state;
	    if (state && state.toJSON) { result[prop] = state.toJSON.call(plugin, this[plugin.key]); }
	  } }
	  return result
	};
	
	// :: (Object, Object, ?Object<Plugin>) → EditorState
	// Deserialize a JSON representation of a state. `config` should
	// have at least a `schema` field, and should contain array of
	// plugins to initialize the state with. `pluginFields` can be used
	// to deserialize the state of plugins, by associating plugin
	// instances with the property names they use in the JSON object.
	//
	// config::- configuration options
	//
	//   schema:: Schema
	//   The schema to use.
	//
	//   plugins:: ?[Plugin]
	//   The set of active plugins.
	EditorState.fromJSON = function fromJSON (config, json, pluginFields) {
	  if (!json) { throw new RangeError("Invalid input for EditorState.fromJSON") }
	  if (!config.schema) { throw new RangeError("Required config field 'schema' missing") }
	  var $config = new Configuration(config.schema, config.plugins);
	  var instance = new EditorState($config);
	  $config.fields.forEach(function (field) {
	    if (field.name == "doc") {
	      instance.doc = prosemirrorModel.Node.fromJSON(config.schema, json.doc);
	    } else if (field.name == "selection") {
	      instance.selection = Selection.fromJSON(instance.doc, json.selection);
	    } else if (field.name == "storedMarks") {
	      if (json.storedMarks) { instance.storedMarks = json.storedMarks.map(config.schema.markFromJSON); }
	    } else {
	      if (pluginFields) { for (var prop in pluginFields) {
	        var plugin = pluginFields[prop], state = plugin.spec.state;
	        if (plugin.key == field.name && state && state.fromJSON &&
	            Object.prototype.hasOwnProperty.call(json, prop)) {
	          // This field belongs to a plugin mapped to a JSON field, read it from there.
	          instance[field.name] = state.fromJSON.call(plugin, config, json[prop], instance);
	          return
	        }
	      } }
	      instance[field.name] = field.init(config, instance);
	    }
	  });
	  return instance
	};
	
	// Kludge to allow the view to track mappings between different
	// instances of a state.
	//
	// FIXME this is no longer needed as of prosemirror-view 1.9.0,
	// though due to backwards-compat we should probably keep it around
	// for a while (if only as a no-op)
	EditorState.addApplyListener = function addApplyListener (f) {
	  applyListeners.push(f);
	};
	EditorState.removeApplyListener = function removeApplyListener (f) {
	  var found = applyListeners.indexOf(f);
	  if (found > -1) { applyListeners.splice(found, 1); }
	};
	
	Object.defineProperties( EditorState.prototype, prototypeAccessors$1 );
	
	var applyListeners = [];
	
	// PluginSpec:: interface
	//
	// This is the type passed to the [`Plugin`](#state.Plugin)
	// constructor. It provides a definition for a plugin.
	//
	//   props:: ?EditorProps
	//   The [view props](#view.EditorProps) added by this plugin. Props
	//   that are functions will be bound to have the plugin instance as
	//   their `this` binding.
	//
	//   state:: ?StateField<any>
	//   Allows a plugin to define a [state field](#state.StateField), an
	//   extra slot in the state object in which it can keep its own data.
	//
	//   key:: ?PluginKey
	//   Can be used to make this a keyed plugin. You can have only one
	//   plugin with a given key in a given state, but it is possible to
	//   access the plugin's configuration and state through the key,
	//   without having access to the plugin instance object.
	//
	//   view:: ?(EditorView) → Object
	//   When the plugin needs to interact with the editor view, or
	//   set something up in the DOM, use this field. The function
	//   will be called when the plugin's state is associated with an
	//   editor view.
	//
	//     return::-
	//     Should return an object with the following optional
	//     properties:
	//
	//       update:: ?(view: EditorView, prevState: EditorState)
	//       Called whenever the view's state is updated.
	//
	//       destroy:: ?()
	//       Called when the view is destroyed or receives a state
	//       with different plugins.
	//
	//   filterTransaction:: ?(Transaction, EditorState) → bool
	//   When present, this will be called before a transaction is
	//   applied by the state, allowing the plugin to cancel it (by
	//   returning false).
	//
	//   appendTransaction:: ?(transactions: [Transaction], oldState: EditorState, newState: EditorState) → ?Transaction
	//   Allows the plugin to append another transaction to be applied
	//   after the given array of transactions. When another plugin
	//   appends a transaction after this was called, it is called again
	//   with the new state and new transactions—but only the new
	//   transactions, i.e. it won't be passed transactions that it
	//   already saw.
	
	function bindProps(obj, self, target) {
	  for (var prop in obj) {
	    var val = obj[prop];
	    if (val instanceof Function) { val = val.bind(self); }
	    else if (prop == "handleDOMEvents") { val = bindProps(val, self, {}); }
	    target[prop] = val;
	  }
	  return target
	}
	
	// ::- Plugins bundle functionality that can be added to an editor.
	// They are part of the [editor state](#state.EditorState) and
	// may influence that state and the view that contains it.
	var Plugin = function Plugin(spec) {
	  // :: EditorProps
	  // The [props](#view.EditorProps) exported by this plugin.
	  this.props = {};
	  if (spec.props) { bindProps(spec.props, this, this.props); }
	  // :: Object
	  // The plugin's [spec object](#state.PluginSpec).
	  this.spec = spec;
	  this.key = spec.key ? spec.key.key : createKey("plugin");
	};
	
	// :: (EditorState) → any
	// Extract the plugin's state field from an editor state.
	Plugin.prototype.getState = function getState (state) { return state[this.key] };
	
	// StateField:: interface<T>
	// A plugin spec may provide a state field (under its
	// [`state`](#state.PluginSpec.state) property) of this type, which
	// describes the state it wants to keep. Functions provided here are
	// always called with the plugin instance as their `this` binding.
	//
	//   init:: (config: Object, instance: EditorState) → T
	//   Initialize the value of the field. `config` will be the object
	//   passed to [`EditorState.create`](#state.EditorState^create). Note
	//   that `instance` is a half-initialized state instance, and will
	//   not have values for plugin fields initialized after this one.
	//
	//   apply:: (tr: Transaction, value: T, oldState: EditorState, newState: EditorState) → T
	//   Apply the given transaction to this state field, producing a new
	//   field value. Note that the `newState` argument is again a partially
	//   constructed state does not yet contain the state from plugins
	//   coming after this one.
	//
	//   toJSON:: ?(value: T) → *
	//   Convert this field to JSON. Optional, can be left off to disable
	//   JSON serialization for the field.
	//
	//   fromJSON:: ?(config: Object, value: *, state: EditorState) → T
	//   Deserialize the JSON representation of this field. Note that the
	//   `state` argument is again a half-initialized state.
	
	var keys = Object.create(null);
	
	function createKey(name) {
	  if (name in keys) { return name + "$" + ++keys[name] }
	  keys[name] = 0;
	  return name + "$"
	}
	
	// ::- A key is used to [tag](#state.PluginSpec.key)
	// plugins in a way that makes it possible to find them, given an
	// editor state. Assigning a key does mean only one plugin of that
	// type can be active in a state.
	var PluginKey = function PluginKey(name) {
	if ( name === void 0 ) name = "key";
	 this.key = createKey(name); };
	
	// :: (EditorState) → ?Plugin
	// Get the active plugin with this key, if any, from an editor
	// state.
	PluginKey.prototype.get = function get (state) { return state.config.pluginsByKey[this.key] };
	
	// :: (EditorState) → ?any
	// Get the plugin's state from an editor state.
	PluginKey.prototype.getState = function getState (state) { return state[this.key] };
	
	exports.AllSelection = AllSelection;
	exports.EditorState = EditorState;
	exports.NodeSelection = NodeSelection;
	exports.Plugin = Plugin;
	exports.PluginKey = PluginKey;
	exports.Selection = Selection;
	exports.SelectionRange = SelectionRange;
	exports.TextSelection = TextSelection;
	exports.Transaction = Transaction;
	//# sourceMappingURL=index.js.map


/***/ }),
/* 7 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(82);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(81);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.warning = undefined;
	
	var _extends2 = __webpack_require__(83);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _typeof2 = __webpack_require__(8);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	exports.format = format;
	exports.isEmptyValue = isEmptyValue;
	exports.isEmptyObject = isEmptyObject;
	exports.asyncMap = asyncMap;
	exports.complementError = complementError;
	exports.deepMerge = deepMerge;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var formatRegExp = /%[sdj%]/g;
	
	var warning = exports.warning = function warning() {};
	
	// don't print warning message when in production env or node runtime
	if (false) {
	  exports.warning = warning = function warning(type, errors) {
	    if (typeof console !== 'undefined' && console.warn) {
	      if (errors.every(function (e) {
	        return typeof e === 'string';
	      })) {
	        console.warn(type, errors);
	      }
	    }
	  };
	}
	
	function format() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  var i = 1;
	  var f = args[0];
	  var len = args.length;
	  if (typeof f === 'function') {
	    return f.apply(null, args.slice(1));
	  }
	  if (typeof f === 'string') {
	    var str = String(f).replace(formatRegExp, function (x) {
	      if (x === '%%') {
	        return '%';
	      }
	      if (i >= len) {
	        return x;
	      }
	      switch (x) {
	        case '%s':
	          return String(args[i++]);
	        case '%d':
	          return Number(args[i++]);
	        case '%j':
	          try {
	            return JSON.stringify(args[i++]);
	          } catch (_) {
	            return '[Circular]';
	          }
	          break;
	        default:
	          return x;
	      }
	    });
	    for (var arg = args[i]; i < len; arg = args[++i]) {
	      str += ' ' + arg;
	    }
	    return str;
	  }
	  return f;
	}
	
	function isNativeStringType(type) {
	  return type === 'string' || type === 'url' || type === 'hex' || type === 'email' || type === 'pattern';
	}
	
	function isEmptyValue(value, type) {
	  if (value === undefined || value === null) {
	    return true;
	  }
	  if (type === 'array' && Array.isArray(value) && !value.length) {
	    return true;
	  }
	  if (isNativeStringType(type) && typeof value === 'string' && !value) {
	    return true;
	  }
	  return false;
	}
	
	function isEmptyObject(obj) {
	  return Object.keys(obj).length === 0;
	}
	
	function asyncParallelArray(arr, func, callback) {
	  var results = [];
	  var total = 0;
	  var arrLength = arr.length;
	
	  function count(errors) {
	    results.push.apply(results, errors);
	    total++;
	    if (total === arrLength) {
	      callback(results);
	    }
	  }
	
	  arr.forEach(function (a) {
	    func(a, count);
	  });
	}
	
	function asyncSerialArray(arr, func, callback) {
	  var index = 0;
	  var arrLength = arr.length;
	
	  function next(errors) {
	    if (errors && errors.length) {
	      callback(errors);
	      return;
	    }
	    var original = index;
	    index = index + 1;
	    if (original < arrLength) {
	      func(arr[original], next);
	    } else {
	      callback([]);
	    }
	  }
	
	  next([]);
	}
	
	function flattenObjArr(objArr) {
	  var ret = [];
	  Object.keys(objArr).forEach(function (k) {
	    ret.push.apply(ret, objArr[k]);
	  });
	  return ret;
	}
	
	function asyncMap(objArr, option, func, callback) {
	  if (option.first) {
	    var flattenArr = flattenObjArr(objArr);
	    return asyncSerialArray(flattenArr, func, callback);
	  }
	  var firstFields = option.firstFields || [];
	  if (firstFields === true) {
	    firstFields = Object.keys(objArr);
	  }
	  var objArrKeys = Object.keys(objArr);
	  var objArrLength = objArrKeys.length;
	  var total = 0;
	  var results = [];
	  var next = function next(errors) {
	    results.push.apply(results, errors);
	    total++;
	    if (total === objArrLength) {
	      callback(results);
	    }
	  };
	  objArrKeys.forEach(function (key) {
	    var arr = objArr[key];
	    if (firstFields.indexOf(key) !== -1) {
	      asyncSerialArray(arr, func, next);
	    } else {
	      asyncParallelArray(arr, func, next);
	    }
	  });
	}
	
	function complementError(rule) {
	  return function (oe) {
	    if (oe && oe.message) {
	      oe.field = oe.field || rule.fullField;
	      return oe;
	    }
	    return {
	      message: oe,
	      field: oe.field || rule.fullField
	    };
	  };
	}
	
	function deepMerge(target, source) {
	  if (source) {
	    for (var s in source) {
	      if (source.hasOwnProperty(s)) {
	        var value = source[s];
	        if ((typeof value === 'undefined' ? 'undefined' : (0, _typeof3['default'])(value)) === 'object' && (0, _typeof3['default'])(target[s]) === 'object') {
	          target[s] = (0, _extends3['default'])({}, target[s], value);
	        } else {
	          target[s] = value;
	        }
	      }
	    }
	  }
	  return target;
	}

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(15);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(20);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(3);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var config = __webpack_require__(275);
	
	
	_vue2.default.use(_vuex2.default);
	
	var serverHost = config.serverHost;
	var agentServerHost = config.agentServerHost;
	
	var state = {
	    user: "",
	    token: '',
	    hostInfo: {},
	    activeItem: '',
	    openItems: [],
	    is_manager: false,
	    loginRediret: config.loginRedirect,
	    logoutRediret: config.logoutRedirect,
	
	    addWhiteListAPI: serverHost + '/itsec/temporaryWhite/addWhiteList',
	    getuserAPI: serverHost + '/itsec/temporaryWhite/queryLoginUser',
	    cookieName: "currentURL=",
	    selectItemList: serverHost + '/itsec/item/selectItemList',
	    selectDirItems: serverHost + '/itsec/item/selectDirItems',
	    updateItem: serverHost + '/itsec/item/updateItem',
	    addItem: serverHost + '/itsec/item/addItem',
	    deleteDocument: serverHost + "/itsec/document/deleteDocument",
	    addDocument: serverHost + '/itsec/document/addDocument',
	    selectDocument: serverHost + '/itsec/document/selectDocument',
	    updateDocument: serverHost + '/itsec/document/updateDocument',
	    tokenAPI: serverHost + "/sso/callback",
	    userCertAddOne: agentServerHost + "/itsec/userCert/addOne",
	    userCertGetUrl: agentServerHost + "/itsec/userCert/getS3Url",
	    uploadImage: serverHost + '/itsec/document/uploadImage',
	    addLangRelation: serverHost + '/itsec/item/addLangRelation',
	    checkLangRelation: serverHost + '/itsec/item/checkLangRelation',
	    currentLang: 'zh' };
	
	var mutations = {
	    UPDATETOKEN: function UPDATETOKEN(state, token) {
	        state.token = token;
	    },
	    UPDATEUSER: function UPDATEUSER(state, name) {
	        state.user = name;
	    },
	    changeActiveItem: function changeActiveItem(state, activeItem) {
	        state.activeItem = activeItem;
	    },
	    changeOpenItems: function changeOpenItems(state, openItems) {
	        state.openItems = openItems;
	    },
	    managerAuthority: function managerAuthority(state, is_manager) {
	        state.is_manager = is_manager;
	    },
	    UPDATE_LANGUAGE: function UPDATE_LANGUAGE(state, lang) {
	        state.currentLang = lang;
	    }
	};
	
	var moduleCard = {
	    state: state,
	    getters: getters,
	    mutations: mutations,
	    actions: actions
	};
	
	var store = new _vuex2.default.Store({
	    state: state,
	    getters: getters,
	    mutations: mutations,
	    actions: actions
	});
	
	var actions = {
	    updateUser: function updateUser(_ref) {
	        var dispatch = _ref.dispatch,
	            state = _ref.state;
	
	        dispatch('UPDATEUSER');
	    },
	    updateToken: function updateToken(_ref2) {
	        var dispatch = _ref2.dispatch;
	
	        dispatch('UPDATETOKEN');
	    },
	    updateActiveItem: function updateActiveItem(context, value) {
	        context.commit('changeActiveItem', value);
	    },
	    updateOpenItems: function updateOpenItems(context, value) {
	        context.commit('changeOpenItems', value);
	    }
	};
	
	var getters = {
	    getUser: function getUser(state) {
	        return state.user;
	    },
	    getToken: function getToken(state) {
	        return state.token;
	    },
	    getDocumentItem: function getDocumentItem(state) {
	        return state.documentItem;
	    }
	};
	
	module.exports = store;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var OrderedMap = _interopDefault(__webpack_require__(456));
	
	function findDiffStart(a, b, pos) {
	  for (var i = 0;; i++) {
	    if (i == a.childCount || i == b.childCount)
	      { return a.childCount == b.childCount ? null : pos }
	
	    var childA = a.child(i), childB = b.child(i);
	    if (childA == childB) { pos += childA.nodeSize; continue }
	
	    if (!childA.sameMarkup(childB)) { return pos }
	
	    if (childA.isText && childA.text != childB.text) {
	      for (var j = 0; childA.text[j] == childB.text[j]; j++)
	        { pos++; }
	      return pos
	    }
	    if (childA.content.size || childB.content.size) {
	      var inner = findDiffStart(childA.content, childB.content, pos + 1);
	      if (inner != null) { return inner }
	    }
	    pos += childA.nodeSize;
	  }
	}
	
	function findDiffEnd(a, b, posA, posB) {
	  for (var iA = a.childCount, iB = b.childCount;;) {
	    if (iA == 0 || iB == 0)
	      { return iA == iB ? null : {a: posA, b: posB} }
	
	    var childA = a.child(--iA), childB = b.child(--iB), size = childA.nodeSize;
	    if (childA == childB) {
	      posA -= size; posB -= size;
	      continue
	    }
	
	    if (!childA.sameMarkup(childB)) { return {a: posA, b: posB} }
	
	    if (childA.isText && childA.text != childB.text) {
	      var same = 0, minSize = Math.min(childA.text.length, childB.text.length);
	      while (same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]) {
	        same++; posA--; posB--;
	      }
	      return {a: posA, b: posB}
	    }
	    if (childA.content.size || childB.content.size) {
	      var inner = findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
	      if (inner) { return inner }
	    }
	    posA -= size; posB -= size;
	  }
	}
	
	// ::- A fragment represents a node's collection of child nodes.
	//
	// Like nodes, fragments are persistent data structures, and you
	// should not mutate them or their content. Rather, you create new
	// instances whenever needed. The API tries to make this easy.
	var Fragment = function Fragment(content, size) {
	  this.content = content;
	  // :: number
	  // The size of the fragment, which is the total of the size of its
	  // content nodes.
	  this.size = size || 0;
	  if (size == null) { for (var i = 0; i < content.length; i++)
	    { this.size += content[i].nodeSize; } }
	};
	
	var prototypeAccessors = { firstChild: { configurable: true },lastChild: { configurable: true },childCount: { configurable: true } };
	
	// :: (number, number, (node: Node, start: number, parent: Node, index: number) → ?bool, ?number)
	// Invoke a callback for all descendant nodes between the given two
	// positions (relative to start of this fragment). Doesn't descend
	// into a node when the callback returns `false`.
	Fragment.prototype.nodesBetween = function nodesBetween (from, to, f, nodeStart, parent) {
	    if ( nodeStart === void 0 ) nodeStart = 0;
	
	  for (var i = 0, pos = 0; pos < to; i++) {
	    var child = this.content[i], end = pos + child.nodeSize;
	    if (end > from && f(child, nodeStart + pos, parent, i) !== false && child.content.size) {
	      var start = pos + 1;
	      child.nodesBetween(Math.max(0, from - start),
	                         Math.min(child.content.size, to - start),
	                         f, nodeStart + start);
	    }
	    pos = end;
	  }
	};
	
	// :: ((node: Node, pos: number, parent: Node) → ?bool)
	// Call the given callback for every descendant node. The callback
	// may return `false` to prevent traversal of a given node's children.
	Fragment.prototype.descendants = function descendants (f) {
	  this.nodesBetween(0, this.size, f);
	};
	
	// : (number, number, ?string, ?string) → string
	Fragment.prototype.textBetween = function textBetween (from, to, blockSeparator, leafText) {
	  var text = "", separated = true;
	  this.nodesBetween(from, to, function (node, pos) {
	    if (node.isText) {
	      text += node.text.slice(Math.max(from, pos) - pos, to - pos);
	      separated = !blockSeparator;
	    } else if (node.isLeaf && leafText) {
	      text += leafText;
	      separated = !blockSeparator;
	    } else if (!separated && node.isBlock) {
	      text += blockSeparator;
	      separated = true;
	    }
	  }, 0);
	  return text
	};
	
	// :: (Fragment) → Fragment
	// Create a new fragment containing the combined content of this
	// fragment and the other.
	Fragment.prototype.append = function append (other) {
	  if (!other.size) { return this }
	  if (!this.size) { return other }
	  var last = this.lastChild, first = other.firstChild, content = this.content.slice(), i = 0;
	  if (last.isText && last.sameMarkup(first)) {
	    content[content.length - 1] = last.withText(last.text + first.text);
	    i = 1;
	  }
	  for (; i < other.content.length; i++) { content.push(other.content[i]); }
	  return new Fragment(content, this.size + other.size)
	};
	
	// :: (number, ?number) → Fragment
	// Cut out the sub-fragment between the two given positions.
	Fragment.prototype.cut = function cut (from, to) {
	  if (to == null) { to = this.size; }
	  if (from == 0 && to == this.size) { return this }
	  var result = [], size = 0;
	  if (to > from) { for (var i = 0, pos = 0; pos < to; i++) {
	    var child = this.content[i], end = pos + child.nodeSize;
	    if (end > from) {
	      if (pos < from || end > to) {
	        if (child.isText)
	          { child = child.cut(Math.max(0, from - pos), Math.min(child.text.length, to - pos)); }
	        else
	          { child = child.cut(Math.max(0, from - pos - 1), Math.min(child.content.size, to - pos - 1)); }
	      }
	      result.push(child);
	      size += child.nodeSize;
	    }
	    pos = end;
	  } }
	  return new Fragment(result, size)
	};
	
	Fragment.prototype.cutByIndex = function cutByIndex (from, to) {
	  if (from == to) { return Fragment.empty }
	  if (from == 0 && to == this.content.length) { return this }
	  return new Fragment(this.content.slice(from, to))
	};
	
	// :: (number, Node) → Fragment
	// Create a new fragment in which the node at the given index is
	// replaced by the given node.
	Fragment.prototype.replaceChild = function replaceChild (index, node) {
	  var current = this.content[index];
	  if (current == node) { return this }
	  var copy = this.content.slice();
	  var size = this.size + node.nodeSize - current.nodeSize;
	  copy[index] = node;
	  return new Fragment(copy, size)
	};
	
	// : (Node) → Fragment
	// Create a new fragment by prepending the given node to this
	// fragment.
	Fragment.prototype.addToStart = function addToStart (node) {
	  return new Fragment([node].concat(this.content), this.size + node.nodeSize)
	};
	
	// : (Node) → Fragment
	// Create a new fragment by appending the given node to this
	// fragment.
	Fragment.prototype.addToEnd = function addToEnd (node) {
	  return new Fragment(this.content.concat(node), this.size + node.nodeSize)
	};
	
	// :: (Fragment) → bool
	// Compare this fragment to another one.
	Fragment.prototype.eq = function eq (other) {
	  if (this.content.length != other.content.length) { return false }
	  for (var i = 0; i < this.content.length; i++)
	    { if (!this.content[i].eq(other.content[i])) { return false } }
	  return true
	};
	
	// :: ?Node
	// The first child of the fragment, or `null` if it is empty.
	prototypeAccessors.firstChild.get = function () { return this.content.length ? this.content[0] : null };
	
	// :: ?Node
	// The last child of the fragment, or `null` if it is empty.
	prototypeAccessors.lastChild.get = function () { return this.content.length ? this.content[this.content.length - 1] : null };
	
	// :: number
	// The number of child nodes in this fragment.
	prototypeAccessors.childCount.get = function () { return this.content.length };
	
	// :: (number) → Node
	// Get the child node at the given index. Raise an error when the
	// index is out of range.
	Fragment.prototype.child = function child (index) {
	  var found = this.content[index];
	  if (!found) { throw new RangeError("Index " + index + " out of range for " + this) }
	  return found
	};
	
	// :: (number) → ?Node
	// Get the child node at the given index, if it exists.
	Fragment.prototype.maybeChild = function maybeChild (index) {
	  return this.content[index]
	};
	
	// :: ((node: Node, offset: number, index: number))
	// Call `f` for every child node, passing the node, its offset
	// into this parent node, and its index.
	Fragment.prototype.forEach = function forEach (f) {
	  for (var i = 0, p = 0; i < this.content.length; i++) {
	    var child = this.content[i];
	    f(child, p, i);
	    p += child.nodeSize;
	  }
	};
	
	// :: (Fragment) → ?number
	// Find the first position at which this fragment and another
	// fragment differ, or `null` if they are the same.
	Fragment.prototype.findDiffStart = function findDiffStart$1 (other, pos) {
	    if ( pos === void 0 ) pos = 0;
	
	  return findDiffStart(this, other, pos)
	};
	
	// :: (Fragment) → ?{a: number, b: number}
	// Find the first position, searching from the end, at which this
	// fragment and the given fragment differ, or `null` if they are the
	// same. Since this position will not be the same in both nodes, an
	// object with two separate positions is returned.
	Fragment.prototype.findDiffEnd = function findDiffEnd$1 (other, pos, otherPos) {
	    if ( pos === void 0 ) pos = this.size;
	    if ( otherPos === void 0 ) otherPos = other.size;
	
	  return findDiffEnd(this, other, pos, otherPos)
	};
	
	// : (number, ?number) → {index: number, offset: number}
	// Find the index and inner offset corresponding to a given relative
	// position in this fragment. The result object will be reused
	// (overwritten) the next time the function is called. (Not public.)
	Fragment.prototype.findIndex = function findIndex (pos, round) {
	    if ( round === void 0 ) round = -1;
	
	  if (pos == 0) { return retIndex(0, pos) }
	  if (pos == this.size) { return retIndex(this.content.length, pos) }
	  if (pos > this.size || pos < 0) { throw new RangeError(("Position " + pos + " outside of fragment (" + (this) + ")")) }
	  for (var i = 0, curPos = 0;; i++) {
	    var cur = this.child(i), end = curPos + cur.nodeSize;
	    if (end >= pos) {
	      if (end == pos || round > 0) { return retIndex(i + 1, end) }
	      return retIndex(i, curPos)
	    }
	    curPos = end;
	  }
	};
	
	// :: () → string
	// Return a debugging string that describes this fragment.
	Fragment.prototype.toString = function toString () { return "<" + this.toStringInner() + ">" };
	
	Fragment.prototype.toStringInner = function toStringInner () { return this.content.join(", ") };
	
	// :: () → ?Object
	// Create a JSON-serializeable representation of this fragment.
	Fragment.prototype.toJSON = function toJSON () {
	  return this.content.length ? this.content.map(function (n) { return n.toJSON(); }) : null
	};
	
	// :: (Schema, ?Object) → Fragment
	// Deserialize a fragment from its JSON representation.
	Fragment.fromJSON = function fromJSON (schema, value) {
	  if (!value) { return Fragment.empty }
	  if (!Array.isArray(value)) { throw new RangeError("Invalid input for Fragment.fromJSON") }
	  return new Fragment(value.map(schema.nodeFromJSON))
	};
	
	// :: ([Node]) → Fragment
	// Build a fragment from an array of nodes. Ensures that adjacent
	// text nodes with the same marks are joined together.
	Fragment.fromArray = function fromArray (array) {
	  if (!array.length) { return Fragment.empty }
	  var joined, size = 0;
	  for (var i = 0; i < array.length; i++) {
	    var node = array[i];
	    size += node.nodeSize;
	    if (i && node.isText && array[i - 1].sameMarkup(node)) {
	      if (!joined) { joined = array.slice(0, i); }
	      joined[joined.length - 1] = node.withText(joined[joined.length - 1].text + node.text);
	    } else if (joined) {
	      joined.push(node);
	    }
	  }
	  return new Fragment(joined || array, size)
	};
	
	// :: (?union<Fragment, Node, [Node]>) → Fragment
	// Create a fragment from something that can be interpreted as a set
	// of nodes. For `null`, it returns the empty fragment. For a
	// fragment, the fragment itself. For a node or array of nodes, a
	// fragment containing those nodes.
	Fragment.from = function from (nodes) {
	  if (!nodes) { return Fragment.empty }
	  if (nodes instanceof Fragment) { return nodes }
	  if (Array.isArray(nodes)) { return this.fromArray(nodes) }
	  if (nodes.attrs) { return new Fragment([nodes], nodes.nodeSize) }
	  throw new RangeError("Can not convert " + nodes + " to a Fragment" +
	                       (nodes.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""))
	};
	
	Object.defineProperties( Fragment.prototype, prototypeAccessors );
	
	var found = {index: 0, offset: 0};
	function retIndex(index, offset) {
	  found.index = index;
	  found.offset = offset;
	  return found
	}
	
	// :: Fragment
	// An empty fragment. Intended to be reused whenever a node doesn't
	// contain anything (rather than allocating a new empty fragment for
	// each leaf node).
	Fragment.empty = new Fragment([], 0);
	
	function compareDeep(a, b) {
	  if (a === b) { return true }
	  if (!(a && typeof a == "object") ||
	      !(b && typeof b == "object")) { return false }
	  var array = Array.isArray(a);
	  if (Array.isArray(b) != array) { return false }
	  if (array) {
	    if (a.length != b.length) { return false }
	    for (var i = 0; i < a.length; i++) { if (!compareDeep(a[i], b[i])) { return false } }
	  } else {
	    for (var p in a) { if (!(p in b) || !compareDeep(a[p], b[p])) { return false } }
	    for (var p$1 in b) { if (!(p$1 in a)) { return false } }
	  }
	  return true
	}
	
	// ::- A mark is a piece of information that can be attached to a node,
	// such as it being emphasized, in code font, or a link. It has a type
	// and optionally a set of attributes that provide further information
	// (such as the target of the link). Marks are created through a
	// `Schema`, which controls which types exist and which
	// attributes they have.
	var Mark = function Mark(type, attrs) {
	  // :: MarkType
	  // The type of this mark.
	  this.type = type;
	  // :: Object
	  // The attributes associated with this mark.
	  this.attrs = attrs;
	};
	
	// :: ([Mark]) → [Mark]
	// Given a set of marks, create a new set which contains this one as
	// well, in the right position. If this mark is already in the set,
	// the set itself is returned. If any marks that are set to be
	// [exclusive](#model.MarkSpec.excludes) with this mark are present,
	// those are replaced by this one.
	Mark.prototype.addToSet = function addToSet (set) {
	  var copy, placed = false;
	  for (var i = 0; i < set.length; i++) {
	    var other = set[i];
	    if (this.eq(other)) { return set }
	    if (this.type.excludes(other.type)) {
	      if (!copy) { copy = set.slice(0, i); }
	    } else if (other.type.excludes(this.type)) {
	      return set
	    } else {
	      if (!placed && other.type.rank > this.type.rank) {
	        if (!copy) { copy = set.slice(0, i); }
	        copy.push(this);
	        placed = true;
	      }
	      if (copy) { copy.push(other); }
	    }
	  }
	  if (!copy) { copy = set.slice(); }
	  if (!placed) { copy.push(this); }
	  return copy
	};
	
	// :: ([Mark]) → [Mark]
	// Remove this mark from the given set, returning a new set. If this
	// mark is not in the set, the set itself is returned.
	Mark.prototype.removeFromSet = function removeFromSet (set) {
	  for (var i = 0; i < set.length; i++)
	    { if (this.eq(set[i]))
	      { return set.slice(0, i).concat(set.slice(i + 1)) } }
	  return set
	};
	
	// :: ([Mark]) → bool
	// Test whether this mark is in the given set of marks.
	Mark.prototype.isInSet = function isInSet (set) {
	  for (var i = 0; i < set.length; i++)
	    { if (this.eq(set[i])) { return true } }
	  return false
	};
	
	// :: (Mark) → bool
	// Test whether this mark has the same type and attributes as
	// another mark.
	Mark.prototype.eq = function eq (other) {
	  return this == other ||
	    (this.type == other.type && compareDeep(this.attrs, other.attrs))
	};
	
	// :: () → Object
	// Convert this mark to a JSON-serializeable representation.
	Mark.prototype.toJSON = function toJSON () {
	  var obj = {type: this.type.name};
	  for (var _ in this.attrs) {
	    obj.attrs = this.attrs;
	    break
	  }
	  return obj
	};
	
	// :: (Schema, Object) → Mark
	Mark.fromJSON = function fromJSON (schema, json) {
	  if (!json) { throw new RangeError("Invalid input for Mark.fromJSON") }
	  var type = schema.marks[json.type];
	  if (!type) { throw new RangeError(("There is no mark type " + (json.type) + " in this schema")) }
	  return type.create(json.attrs)
	};
	
	// :: ([Mark], [Mark]) → bool
	// Test whether two sets of marks are identical.
	Mark.sameSet = function sameSet (a, b) {
	  if (a == b) { return true }
	  if (a.length != b.length) { return false }
	  for (var i = 0; i < a.length; i++)
	    { if (!a[i].eq(b[i])) { return false } }
	  return true
	};
	
	// :: (?union<Mark, [Mark]>) → [Mark]
	// Create a properly sorted mark set from null, a single mark, or an
	// unsorted array of marks.
	Mark.setFrom = function setFrom (marks) {
	  if (!marks || marks.length == 0) { return Mark.none }
	  if (marks instanceof Mark) { return [marks] }
	  var copy = marks.slice();
	  copy.sort(function (a, b) { return a.type.rank - b.type.rank; });
	  return copy
	};
	
	// :: [Mark] The empty set of marks.
	Mark.none = [];
	
	// ReplaceError:: class extends Error
	// Error type raised by [`Node.replace`](#model.Node.replace) when
	// given an invalid replacement.
	
	function ReplaceError(message) {
	  var err = Error.call(this, message);
	  err.__proto__ = ReplaceError.prototype;
	  return err
	}
	
	ReplaceError.prototype = Object.create(Error.prototype);
	ReplaceError.prototype.constructor = ReplaceError;
	ReplaceError.prototype.name = "ReplaceError";
	
	// ::- A slice represents a piece cut out of a larger document. It
	// stores not only a fragment, but also the depth up to which nodes on
	// both side are ‘open’ (cut through).
	var Slice = function Slice(content, openStart, openEnd) {
	  // :: Fragment The slice's content.
	  this.content = content;
	  // :: number The open depth at the start.
	  this.openStart = openStart;
	  // :: number The open depth at the end.
	  this.openEnd = openEnd;
	};
	
	var prototypeAccessors$1 = { size: { configurable: true } };
	
	// :: number
	// The size this slice would add when inserted into a document.
	prototypeAccessors$1.size.get = function () {
	  return this.content.size - this.openStart - this.openEnd
	};
	
	Slice.prototype.insertAt = function insertAt (pos, fragment) {
	  var content = insertInto(this.content, pos + this.openStart, fragment, null);
	  return content && new Slice(content, this.openStart, this.openEnd)
	};
	
	Slice.prototype.removeBetween = function removeBetween (from, to) {
	  return new Slice(removeRange(this.content, from + this.openStart, to + this.openStart), this.openStart, this.openEnd)
	};
	
	// :: (Slice) → bool
	// Tests whether this slice is equal to another slice.
	Slice.prototype.eq = function eq (other) {
	  return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd
	};
	
	Slice.prototype.toString = function toString () {
	  return this.content + "(" + this.openStart + "," + this.openEnd + ")"
	};
	
	// :: () → ?Object
	// Convert a slice to a JSON-serializable representation.
	Slice.prototype.toJSON = function toJSON () {
	  if (!this.content.size) { return null }
	  var json = {content: this.content.toJSON()};
	  if (this.openStart > 0) { json.openStart = this.openStart; }
	  if (this.openEnd > 0) { json.openEnd = this.openEnd; }
	  return json
	};
	
	// :: (Schema, ?Object) → Slice
	// Deserialize a slice from its JSON representation.
	Slice.fromJSON = function fromJSON (schema, json) {
	  if (!json) { return Slice.empty }
	  var openStart = json.openStart || 0, openEnd = json.openEnd || 0;
	  if (typeof openStart != "number" || typeof openEnd != "number")
	    { throw new RangeError("Invalid input for Slice.fromJSON") }
	  return new Slice(Fragment.fromJSON(schema, json.content), json.openStart || 0, json.openEnd || 0)
	};
	
	// :: (Fragment, ?bool) → Slice
	// Create a slice from a fragment by taking the maximum possible
	// open value on both side of the fragment.
	Slice.maxOpen = function maxOpen (fragment, openIsolating) {
	    if ( openIsolating === void 0 ) openIsolating=true;
	
	  var openStart = 0, openEnd = 0;
	  for (var n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild) { openStart++; }
	  for (var n$1 = fragment.lastChild; n$1 && !n$1.isLeaf && (openIsolating || !n$1.type.spec.isolating); n$1 = n$1.lastChild) { openEnd++; }
	  return new Slice(fragment, openStart, openEnd)
	};
	
	Object.defineProperties( Slice.prototype, prototypeAccessors$1 );
	
	function removeRange(content, from, to) {
	  var ref = content.findIndex(from);
	  var index = ref.index;
	  var offset = ref.offset;
	  var child = content.maybeChild(index);
	  var ref$1 = content.findIndex(to);
	  var indexTo = ref$1.index;
	  var offsetTo = ref$1.offset;
	  if (offset == from || child.isText) {
	    if (offsetTo != to && !content.child(indexTo).isText) { throw new RangeError("Removing non-flat range") }
	    return content.cut(0, from).append(content.cut(to))
	  }
	  if (index != indexTo) { throw new RangeError("Removing non-flat range") }
	  return content.replaceChild(index, child.copy(removeRange(child.content, from - offset - 1, to - offset - 1)))
	}
	
	function insertInto(content, dist, insert, parent) {
	  var ref = content.findIndex(dist);
	  var index = ref.index;
	  var offset = ref.offset;
	  var child = content.maybeChild(index);
	  if (offset == dist || child.isText) {
	    if (parent && !parent.canReplace(index, index, insert)) { return null }
	    return content.cut(0, dist).append(insert).append(content.cut(dist))
	  }
	  var inner = insertInto(child.content, dist - offset - 1, insert);
	  return inner && content.replaceChild(index, child.copy(inner))
	}
	
	// :: Slice
	// The empty slice.
	Slice.empty = new Slice(Fragment.empty, 0, 0);
	
	function replace($from, $to, slice) {
	  if (slice.openStart > $from.depth)
	    { throw new ReplaceError("Inserted content deeper than insertion position") }
	  if ($from.depth - slice.openStart != $to.depth - slice.openEnd)
	    { throw new ReplaceError("Inconsistent open depths") }
	  return replaceOuter($from, $to, slice, 0)
	}
	
	function replaceOuter($from, $to, slice, depth) {
	  var index = $from.index(depth), node = $from.node(depth);
	  if (index == $to.index(depth) && depth < $from.depth - slice.openStart) {
	    var inner = replaceOuter($from, $to, slice, depth + 1);
	    return node.copy(node.content.replaceChild(index, inner))
	  } else if (!slice.content.size) {
	    return close(node, replaceTwoWay($from, $to, depth))
	  } else if (!slice.openStart && !slice.openEnd && $from.depth == depth && $to.depth == depth) { // Simple, flat case
	    var parent = $from.parent, content = parent.content;
	    return close(parent, content.cut(0, $from.parentOffset).append(slice.content).append(content.cut($to.parentOffset)))
	  } else {
	    var ref = prepareSliceForReplace(slice, $from);
	    var start = ref.start;
	    var end = ref.end;
	    return close(node, replaceThreeWay($from, start, end, $to, depth))
	  }
	}
	
	function checkJoin(main, sub) {
	  if (!sub.type.compatibleContent(main.type))
	    { throw new ReplaceError("Cannot join " + sub.type.name + " onto " + main.type.name) }
	}
	
	function joinable($before, $after, depth) {
	  var node = $before.node(depth);
	  checkJoin(node, $after.node(depth));
	  return node
	}
	
	function addNode(child, target) {
	  var last = target.length - 1;
	  if (last >= 0 && child.isText && child.sameMarkup(target[last]))
	    { target[last] = child.withText(target[last].text + child.text); }
	  else
	    { target.push(child); }
	}
	
	function addRange($start, $end, depth, target) {
	  var node = ($end || $start).node(depth);
	  var startIndex = 0, endIndex = $end ? $end.index(depth) : node.childCount;
	  if ($start) {
	    startIndex = $start.index(depth);
	    if ($start.depth > depth) {
	      startIndex++;
	    } else if ($start.textOffset) {
	      addNode($start.nodeAfter, target);
	      startIndex++;
	    }
	  }
	  for (var i = startIndex; i < endIndex; i++) { addNode(node.child(i), target); }
	  if ($end && $end.depth == depth && $end.textOffset)
	    { addNode($end.nodeBefore, target); }
	}
	
	function close(node, content) {
	  if (!node.type.validContent(content))
	    { throw new ReplaceError("Invalid content for node " + node.type.name) }
	  return node.copy(content)
	}
	
	function replaceThreeWay($from, $start, $end, $to, depth) {
	  var openStart = $from.depth > depth && joinable($from, $start, depth + 1);
	  var openEnd = $to.depth > depth && joinable($end, $to, depth + 1);
	
	  var content = [];
	  addRange(null, $from, depth, content);
	  if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
	    checkJoin(openStart, openEnd);
	    addNode(close(openStart, replaceThreeWay($from, $start, $end, $to, depth + 1)), content);
	  } else {
	    if (openStart)
	      { addNode(close(openStart, replaceTwoWay($from, $start, depth + 1)), content); }
	    addRange($start, $end, depth, content);
	    if (openEnd)
	      { addNode(close(openEnd, replaceTwoWay($end, $to, depth + 1)), content); }
	  }
	  addRange($to, null, depth, content);
	  return new Fragment(content)
	}
	
	function replaceTwoWay($from, $to, depth) {
	  var content = [];
	  addRange(null, $from, depth, content);
	  if ($from.depth > depth) {
	    var type = joinable($from, $to, depth + 1);
	    addNode(close(type, replaceTwoWay($from, $to, depth + 1)), content);
	  }
	  addRange($to, null, depth, content);
	  return new Fragment(content)
	}
	
	function prepareSliceForReplace(slice, $along) {
	  var extra = $along.depth - slice.openStart, parent = $along.node(extra);
	  var node = parent.copy(slice.content);
	  for (var i = extra - 1; i >= 0; i--)
	    { node = $along.node(i).copy(Fragment.from(node)); }
	  return {start: node.resolveNoCache(slice.openStart + extra),
	          end: node.resolveNoCache(node.content.size - slice.openEnd - extra)}
	}
	
	// ::- You can [_resolve_](#model.Node.resolve) a position to get more
	// information about it. Objects of this class represent such a
	// resolved position, providing various pieces of context information,
	// and some helper methods.
	//
	// Throughout this interface, methods that take an optional `depth`
	// parameter will interpret undefined as `this.depth` and negative
	// numbers as `this.depth + value`.
	var ResolvedPos = function ResolvedPos(pos, path, parentOffset) {
	  // :: number The position that was resolved.
	  this.pos = pos;
	  this.path = path;
	  // :: number
	  // The number of levels the parent node is from the root. If this
	  // position points directly into the root node, it is 0. If it
	  // points into a top-level paragraph, 1, and so on.
	  this.depth = path.length / 3 - 1;
	  // :: number The offset this position has into its parent node.
	  this.parentOffset = parentOffset;
	};
	
	var prototypeAccessors$2 = { parent: { configurable: true },doc: { configurable: true },textOffset: { configurable: true },nodeAfter: { configurable: true },nodeBefore: { configurable: true } };
	
	ResolvedPos.prototype.resolveDepth = function resolveDepth (val) {
	  if (val == null) { return this.depth }
	  if (val < 0) { return this.depth + val }
	  return val
	};
	
	// :: Node
	// The parent node that the position points into. Note that even if
	// a position points into a text node, that node is not considered
	// the parent—text nodes are ‘flat’ in this model, and have no content.
	prototypeAccessors$2.parent.get = function () { return this.node(this.depth) };
	
	// :: Node
	// The root node in which the position was resolved.
	prototypeAccessors$2.doc.get = function () { return this.node(0) };
	
	// :: (?number) → Node
	// The ancestor node at the given level. `p.node(p.depth)` is the
	// same as `p.parent`.
	ResolvedPos.prototype.node = function node (depth) { return this.path[this.resolveDepth(depth) * 3] };
	
	// :: (?number) → number
	// The index into the ancestor at the given level. If this points at
	// the 3rd node in the 2nd paragraph on the top level, for example,
	// `p.index(0)` is 1 and `p.index(1)` is 2.
	ResolvedPos.prototype.index = function index (depth) { return this.path[this.resolveDepth(depth) * 3 + 1] };
	
	// :: (?number) → number
	// The index pointing after this position into the ancestor at the
	// given level.
	ResolvedPos.prototype.indexAfter = function indexAfter (depth) {
	  depth = this.resolveDepth(depth);
	  return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1)
	};
	
	// :: (?number) → number
	// The (absolute) position at the start of the node at the given
	// level.
	ResolvedPos.prototype.start = function start (depth) {
	  depth = this.resolveDepth(depth);
	  return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1
	};
	
	// :: (?number) → number
	// The (absolute) position at the end of the node at the given
	// level.
	ResolvedPos.prototype.end = function end (depth) {
	  depth = this.resolveDepth(depth);
	  return this.start(depth) + this.node(depth).content.size
	};
	
	// :: (?number) → number
	// The (absolute) position directly before the wrapping node at the
	// given level, or, when `depth` is `this.depth + 1`, the original
	// position.
	ResolvedPos.prototype.before = function before (depth) {
	  depth = this.resolveDepth(depth);
	  if (!depth) { throw new RangeError("There is no position before the top-level node") }
	  return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1]
	};
	
	// :: (?number) → number
	// The (absolute) position directly after the wrapping node at the
	// given level, or the original position when `depth` is `this.depth + 1`.
	ResolvedPos.prototype.after = function after (depth) {
	  depth = this.resolveDepth(depth);
	  if (!depth) { throw new RangeError("There is no position after the top-level node") }
	  return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize
	};
	
	// :: number
	// When this position points into a text node, this returns the
	// distance between the position and the start of the text node.
	// Will be zero for positions that point between nodes.
	prototypeAccessors$2.textOffset.get = function () { return this.pos - this.path[this.path.length - 1] };
	
	// :: ?Node
	// Get the node directly after the position, if any. If the position
	// points into a text node, only the part of that node after the
	// position is returned.
	prototypeAccessors$2.nodeAfter.get = function () {
	  var parent = this.parent, index = this.index(this.depth);
	  if (index == parent.childCount) { return null }
	  var dOff = this.pos - this.path[this.path.length - 1], child = parent.child(index);
	  return dOff ? parent.child(index).cut(dOff) : child
	};
	
	// :: ?Node
	// Get the node directly before the position, if any. If the
	// position points into a text node, only the part of that node
	// before the position is returned.
	prototypeAccessors$2.nodeBefore.get = function () {
	  var index = this.index(this.depth);
	  var dOff = this.pos - this.path[this.path.length - 1];
	  if (dOff) { return this.parent.child(index).cut(0, dOff) }
	  return index == 0 ? null : this.parent.child(index - 1)
	};
	
	// :: () → [Mark]
	// Get the marks at this position, factoring in the surrounding
	// marks' [`inclusive`](#model.MarkSpec.inclusive) property. If the
	// position is at the start of a non-empty node, the marks of the
	// node after it (if any) are returned.
	ResolvedPos.prototype.marks = function marks () {
	  var parent = this.parent, index = this.index();
	
	  // In an empty parent, return the empty array
	  if (parent.content.size == 0) { return Mark.none }
	
	  // When inside a text node, just return the text node's marks
	  if (this.textOffset) { return parent.child(index).marks }
	
	  var main = parent.maybeChild(index - 1), other = parent.maybeChild(index);
	  // If the `after` flag is true of there is no node before, make
	  // the node after this position the main reference.
	  if (!main) { var tmp = main; main = other; other = tmp; }
	
	  // Use all marks in the main node, except those that have
	  // `inclusive` set to false and are not present in the other node.
	  var marks = main.marks;
	  for (var i = 0; i < marks.length; i++)
	    { if (marks[i].type.spec.inclusive === false && (!other || !marks[i].isInSet(other.marks)))
	      { marks = marks[i--].removeFromSet(marks); } }
	
	  return marks
	};
	
	// :: (ResolvedPos) → ?[Mark]
	// Get the marks after the current position, if any, except those
	// that are non-inclusive and not present at position `$end`. This
	// is mostly useful for getting the set of marks to preserve after a
	// deletion. Will return `null` if this position is at the end of
	// its parent node or its parent node isn't a textblock (in which
	// case no marks should be preserved).
	ResolvedPos.prototype.marksAcross = function marksAcross ($end) {
	  var after = this.parent.maybeChild(this.index());
	  if (!after || !after.isInline) { return null }
	
	  var marks = after.marks, next = $end.parent.maybeChild($end.index());
	  for (var i = 0; i < marks.length; i++)
	    { if (marks[i].type.spec.inclusive === false && (!next || !marks[i].isInSet(next.marks)))
	      { marks = marks[i--].removeFromSet(marks); } }
	  return marks
	};
	
	// :: (number) → number
	// The depth up to which this position and the given (non-resolved)
	// position share the same parent nodes.
	ResolvedPos.prototype.sharedDepth = function sharedDepth (pos) {
	  for (var depth = this.depth; depth > 0; depth--)
	    { if (this.start(depth) <= pos && this.end(depth) >= pos) { return depth } }
	  return 0
	};
	
	// :: (?ResolvedPos, ?(Node) → bool) → ?NodeRange
	// Returns a range based on the place where this position and the
	// given position diverge around block content. If both point into
	// the same textblock, for example, a range around that textblock
	// will be returned. If they point into different blocks, the range
	// around those blocks in their shared ancestor is returned. You can
	// pass in an optional predicate that will be called with a parent
	// node to see if a range into that parent is acceptable.
	ResolvedPos.prototype.blockRange = function blockRange (other, pred) {
	    if ( other === void 0 ) other = this;
	
	  if (other.pos < this.pos) { return other.blockRange(this) }
	  for (var d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--)
	    { if (other.pos <= this.end(d) && (!pred || pred(this.node(d))))
	      { return new NodeRange(this, other, d) } }
	};
	
	// :: (ResolvedPos) → bool
	// Query whether the given position shares the same parent node.
	ResolvedPos.prototype.sameParent = function sameParent (other) {
	  return this.pos - this.parentOffset == other.pos - other.parentOffset
	};
	
	// :: (ResolvedPos) → ResolvedPos
	// Return the greater of this and the given position.
	ResolvedPos.prototype.max = function max (other) {
	  return other.pos > this.pos ? other : this
	};
	
	// :: (ResolvedPos) → ResolvedPos
	// Return the smaller of this and the given position.
	ResolvedPos.prototype.min = function min (other) {
	  return other.pos < this.pos ? other : this
	};
	
	ResolvedPos.prototype.toString = function toString () {
	  var str = "";
	  for (var i = 1; i <= this.depth; i++)
	    { str += (str ? "/" : "") + this.node(i).type.name + "_" + this.index(i - 1); }
	  return str + ":" + this.parentOffset
	};
	
	ResolvedPos.resolve = function resolve (doc, pos) {
	  if (!(pos >= 0 && pos <= doc.content.size)) { throw new RangeError("Position " + pos + " out of range") }
	  var path = [];
	  var start = 0, parentOffset = pos;
	  for (var node = doc;;) {
	    var ref = node.content.findIndex(parentOffset);
	      var index = ref.index;
	      var offset = ref.offset;
	    var rem = parentOffset - offset;
	    path.push(node, index, start + offset);
	    if (!rem) { break }
	    node = node.child(index);
	    if (node.isText) { break }
	    parentOffset = rem - 1;
	    start += offset + 1;
	  }
	  return new ResolvedPos(pos, path, parentOffset)
	};
	
	ResolvedPos.resolveCached = function resolveCached (doc, pos) {
	  for (var i = 0; i < resolveCache.length; i++) {
	    var cached = resolveCache[i];
	    if (cached.pos == pos && cached.doc == doc) { return cached }
	  }
	  var result = resolveCache[resolveCachePos] = ResolvedPos.resolve(doc, pos);
	  resolveCachePos = (resolveCachePos + 1) % resolveCacheSize;
	  return result
	};
	
	Object.defineProperties( ResolvedPos.prototype, prototypeAccessors$2 );
	
	var resolveCache = [], resolveCachePos = 0, resolveCacheSize = 12;
	
	// ::- Represents a flat range of content, i.e. one that starts and
	// ends in the same node.
	var NodeRange = function NodeRange($from, $to, depth) {
	  // :: ResolvedPos A resolved position along the start of the
	  // content. May have a `depth` greater than this object's `depth`
	  // property, since these are the positions that were used to
	  // compute the range, not re-resolved positions directly at its
	  // boundaries.
	  this.$from = $from;
	  // :: ResolvedPos A position along the end of the content. See
	  // caveat for [`$from`](#model.NodeRange.$from).
	  this.$to = $to;
	  // :: number The depth of the node that this range points into.
	  this.depth = depth;
	};
	
	var prototypeAccessors$1$1 = { start: { configurable: true },end: { configurable: true },parent: { configurable: true },startIndex: { configurable: true },endIndex: { configurable: true } };
	
	// :: number The position at the start of the range.
	prototypeAccessors$1$1.start.get = function () { return this.$from.before(this.depth + 1) };
	// :: number The position at the end of the range.
	prototypeAccessors$1$1.end.get = function () { return this.$to.after(this.depth + 1) };
	
	// :: Node The parent node that the range points into.
	prototypeAccessors$1$1.parent.get = function () { return this.$from.node(this.depth) };
	// :: number The start index of the range in the parent node.
	prototypeAccessors$1$1.startIndex.get = function () { return this.$from.index(this.depth) };
	// :: number The end index of the range in the parent node.
	prototypeAccessors$1$1.endIndex.get = function () { return this.$to.indexAfter(this.depth) };
	
	Object.defineProperties( NodeRange.prototype, prototypeAccessors$1$1 );
	
	var emptyAttrs = Object.create(null);
	
	// ::- This class represents a node in the tree that makes up a
	// ProseMirror document. So a document is an instance of `Node`, with
	// children that are also instances of `Node`.
	//
	// Nodes are persistent data structures. Instead of changing them, you
	// create new ones with the content you want. Old ones keep pointing
	// at the old document shape. This is made cheaper by sharing
	// structure between the old and new data as much as possible, which a
	// tree shape like this (without back pointers) makes easy.
	//
	// **Do not** directly mutate the properties of a `Node` object. See
	// [the guide](/docs/guide/#doc) for more information.
	var Node = function Node(type, attrs, content, marks) {
	  // :: NodeType
	  // The type of node that this is.
	  this.type = type;
	
	  // :: Object
	  // An object mapping attribute names to values. The kind of
	  // attributes allowed and required are
	  // [determined](#model.NodeSpec.attrs) by the node type.
	  this.attrs = attrs;
	
	  // :: Fragment
	  // A container holding the node's children.
	  this.content = content || Fragment.empty;
	
	  // :: [Mark]
	  // The marks (things like whether it is emphasized or part of a
	  // link) applied to this node.
	  this.marks = marks || Mark.none;
	};
	
	var prototypeAccessors$3 = { nodeSize: { configurable: true },childCount: { configurable: true },textContent: { configurable: true },firstChild: { configurable: true },lastChild: { configurable: true },isBlock: { configurable: true },isTextblock: { configurable: true },inlineContent: { configurable: true },isInline: { configurable: true },isText: { configurable: true },isLeaf: { configurable: true },isAtom: { configurable: true } };
	
	// text:: ?string
	// For text nodes, this contains the node's text content.
	
	// :: number
	// The size of this node, as defined by the integer-based [indexing
	// scheme](/docs/guide/#doc.indexing). For text nodes, this is the
	// amount of characters. For other leaf nodes, it is one. For
	// non-leaf nodes, it is the size of the content plus two (the start
	// and end token).
	prototypeAccessors$3.nodeSize.get = function () { return this.isLeaf ? 1 : 2 + this.content.size };
	
	// :: number
	// The number of children that the node has.
	prototypeAccessors$3.childCount.get = function () { return this.content.childCount };
	
	// :: (number) → Node
	// Get the child node at the given index. Raises an error when the
	// index is out of range.
	Node.prototype.child = function child (index) { return this.content.child(index) };
	
	// :: (number) → ?Node
	// Get the child node at the given index, if it exists.
	Node.prototype.maybeChild = function maybeChild (index) { return this.content.maybeChild(index) };
	
	// :: ((node: Node, offset: number, index: number))
	// Call `f` for every child node, passing the node, its offset
	// into this parent node, and its index.
	Node.prototype.forEach = function forEach (f) { this.content.forEach(f); };
	
	// :: (number, number, (node: Node, pos: number, parent: Node, index: number) → ?bool, ?number)
	// Invoke a callback for all descendant nodes recursively between
	// the given two positions that are relative to start of this node's
	// content. The callback is invoked with the node, its
	// parent-relative position, its parent node, and its child index.
	// When the callback returns false for a given node, that node's
	// children will not be recursed over. The last parameter can be
	// used to specify a starting position to count from.
	Node.prototype.nodesBetween = function nodesBetween (from, to, f, startPos) {
	    if ( startPos === void 0 ) startPos = 0;
	
	  this.content.nodesBetween(from, to, f, startPos, this);
	};
	
	// :: ((node: Node, pos: number, parent: Node) → ?bool)
	// Call the given callback for every descendant node. Doesn't
	// descend into a node when the callback returns `false`.
	Node.prototype.descendants = function descendants (f) {
	  this.nodesBetween(0, this.content.size, f);
	};
	
	// :: string
	// Concatenates all the text nodes found in this fragment and its
	// children.
	prototypeAccessors$3.textContent.get = function () { return this.textBetween(0, this.content.size, "") };
	
	// :: (number, number, ?string, ?string) → string
	// Get all text between positions `from` and `to`. When
	// `blockSeparator` is given, it will be inserted whenever a new
	// block node is started. When `leafText` is given, it'll be
	// inserted for every non-text leaf node encountered.
	Node.prototype.textBetween = function textBetween (from, to, blockSeparator, leafText) {
	  return this.content.textBetween(from, to, blockSeparator, leafText)
	};
	
	// :: ?Node
	// Returns this node's first child, or `null` if there are no
	// children.
	prototypeAccessors$3.firstChild.get = function () { return this.content.firstChild };
	
	// :: ?Node
	// Returns this node's last child, or `null` if there are no
	// children.
	prototypeAccessors$3.lastChild.get = function () { return this.content.lastChild };
	
	// :: (Node) → bool
	// Test whether two nodes represent the same piece of document.
	Node.prototype.eq = function eq (other) {
	  return this == other || (this.sameMarkup(other) && this.content.eq(other.content))
	};
	
	// :: (Node) → bool
	// Compare the markup (type, attributes, and marks) of this node to
	// those of another. Returns `true` if both have the same markup.
	Node.prototype.sameMarkup = function sameMarkup (other) {
	  return this.hasMarkup(other.type, other.attrs, other.marks)
	};
	
	// :: (NodeType, ?Object, ?[Mark]) → bool
	// Check whether this node's markup correspond to the given type,
	// attributes, and marks.
	Node.prototype.hasMarkup = function hasMarkup (type, attrs, marks) {
	  return this.type == type &&
	    compareDeep(this.attrs, attrs || type.defaultAttrs || emptyAttrs) &&
	    Mark.sameSet(this.marks, marks || Mark.none)
	};
	
	// :: (?Fragment) → Node
	// Create a new node with the same markup as this node, containing
	// the given content (or empty, if no content is given).
	Node.prototype.copy = function copy (content) {
	    if ( content === void 0 ) content = null;
	
	  if (content == this.content) { return this }
	  return new this.constructor(this.type, this.attrs, content, this.marks)
	};
	
	// :: ([Mark]) → Node
	// Create a copy of this node, with the given set of marks instead
	// of the node's own marks.
	Node.prototype.mark = function mark (marks) {
	  return marks == this.marks ? this : new this.constructor(this.type, this.attrs, this.content, marks)
	};
	
	// :: (number, ?number) → Node
	// Create a copy of this node with only the content between the
	// given positions. If `to` is not given, it defaults to the end of
	// the node.
	Node.prototype.cut = function cut (from, to) {
	  if (from == 0 && to == this.content.size) { return this }
	  return this.copy(this.content.cut(from, to))
	};
	
	// :: (number, ?number) → Slice
	// Cut out the part of the document between the given positions, and
	// return it as a `Slice` object.
	Node.prototype.slice = function slice (from, to, includeParents) {
	    if ( to === void 0 ) to = this.content.size;
	    if ( includeParents === void 0 ) includeParents = false;
	
	  if (from == to) { return Slice.empty }
	
	  var $from = this.resolve(from), $to = this.resolve(to);
	  var depth = includeParents ? 0 : $from.sharedDepth(to);
	  var start = $from.start(depth), node = $from.node(depth);
	  var content = node.content.cut($from.pos - start, $to.pos - start);
	  return new Slice(content, $from.depth - depth, $to.depth - depth)
	};
	
	// :: (number, number, Slice) → Node
	// Replace the part of the document between the given positions with
	// the given slice. The slice must 'fit', meaning its open sides
	// must be able to connect to the surrounding content, and its
	// content nodes must be valid children for the node they are placed
	// into. If any of this is violated, an error of type
	// [`ReplaceError`](#model.ReplaceError) is thrown.
	Node.prototype.replace = function replace$1 (from, to, slice) {
	  return replace(this.resolve(from), this.resolve(to), slice)
	};
	
	// :: (number) → ?Node
	// Find the node directly after the given position.
	Node.prototype.nodeAt = function nodeAt (pos) {
	  for (var node = this;;) {
	    var ref = node.content.findIndex(pos);
	      var index = ref.index;
	      var offset = ref.offset;
	    node = node.maybeChild(index);
	    if (!node) { return null }
	    if (offset == pos || node.isText) { return node }
	    pos -= offset + 1;
	  }
	};
	
	// :: (number) → {node: ?Node, index: number, offset: number}
	// Find the (direct) child node after the given offset, if any,
	// and return it along with its index and offset relative to this
	// node.
	Node.prototype.childAfter = function childAfter (pos) {
	  var ref = this.content.findIndex(pos);
	    var index = ref.index;
	    var offset = ref.offset;
	  return {node: this.content.maybeChild(index), index: index, offset: offset}
	};
	
	// :: (number) → {node: ?Node, index: number, offset: number}
	// Find the (direct) child node before the given offset, if any,
	// and return it along with its index and offset relative to this
	// node.
	Node.prototype.childBefore = function childBefore (pos) {
	  if (pos == 0) { return {node: null, index: 0, offset: 0} }
	  var ref = this.content.findIndex(pos);
	    var index = ref.index;
	    var offset = ref.offset;
	  if (offset < pos) { return {node: this.content.child(index), index: index, offset: offset} }
	  var node = this.content.child(index - 1);
	  return {node: node, index: index - 1, offset: offset - node.nodeSize}
	};
	
	// :: (number) → ResolvedPos
	// Resolve the given position in the document, returning an
	// [object](#model.ResolvedPos) with information about its context.
	Node.prototype.resolve = function resolve (pos) { return ResolvedPos.resolveCached(this, pos) };
	
	Node.prototype.resolveNoCache = function resolveNoCache (pos) { return ResolvedPos.resolve(this, pos) };
	
	// :: (number, number, MarkType) → bool
	// Test whether a mark of the given type occurs in this document
	// between the two given positions.
	Node.prototype.rangeHasMark = function rangeHasMark (from, to, type) {
	  var found = false;
	  if (to > from) { this.nodesBetween(from, to, function (node) {
	    if (type.isInSet(node.marks)) { found = true; }
	    return !found
	  }); }
	  return found
	};
	
	// :: bool
	// True when this is a block (non-inline node)
	prototypeAccessors$3.isBlock.get = function () { return this.type.isBlock };
	
	// :: bool
	// True when this is a textblock node, a block node with inline
	// content.
	prototypeAccessors$3.isTextblock.get = function () { return this.type.isTextblock };
	
	// :: bool
	// True when this node allows inline content.
	prototypeAccessors$3.inlineContent.get = function () { return this.type.inlineContent };
	
	// :: bool
	// True when this is an inline node (a text node or a node that can
	// appear among text).
	prototypeAccessors$3.isInline.get = function () { return this.type.isInline };
	
	// :: bool
	// True when this is a text node.
	prototypeAccessors$3.isText.get = function () { return this.type.isText };
	
	// :: bool
	// True when this is a leaf node.
	prototypeAccessors$3.isLeaf.get = function () { return this.type.isLeaf };
	
	// :: bool
	// True when this is an atom, i.e. when it does not have directly
	// editable content. This is usually the same as `isLeaf`, but can
	// be configured with the [`atom` property](#model.NodeSpec.atom) on
	// a node's spec (typically used when the node is displayed as an
	// uneditable [node view](#view.NodeView)).
	prototypeAccessors$3.isAtom.get = function () { return this.type.isAtom };
	
	// :: () → string
	// Return a string representation of this node for debugging
	// purposes.
	Node.prototype.toString = function toString () {
	  if (this.type.spec.toDebugString) { return this.type.spec.toDebugString(this) }
	  var name = this.type.name;
	  if (this.content.size)
	    { name += "(" + this.content.toStringInner() + ")"; }
	  return wrapMarks(this.marks, name)
	};
	
	// :: (number) → ContentMatch
	// Get the content match in this node at the given index.
	Node.prototype.contentMatchAt = function contentMatchAt (index) {
	  var match = this.type.contentMatch.matchFragment(this.content, 0, index);
	  if (!match) { throw new Error("Called contentMatchAt on a node with invalid content") }
	  return match
	};
	
	// :: (number, number, ?Fragment, ?number, ?number) → bool
	// Test whether replacing the range between `from` and `to` (by
	// child index) with the given replacement fragment (which defaults
	// to the empty fragment) would leave the node's content valid. You
	// can optionally pass `start` and `end` indices into the
	// replacement fragment.
	Node.prototype.canReplace = function canReplace (from, to, replacement, start, end) {
	    if ( replacement === void 0 ) replacement = Fragment.empty;
	    if ( start === void 0 ) start = 0;
	    if ( end === void 0 ) end = replacement.childCount;
	
	  var one = this.contentMatchAt(from).matchFragment(replacement, start, end);
	  var two = one && one.matchFragment(this.content, to);
	  if (!two || !two.validEnd) { return false }
	  for (var i = start; i < end; i++) { if (!this.type.allowsMarks(replacement.child(i).marks)) { return false } }
	  return true
	};
	
	// :: (number, number, NodeType, ?[Mark]) → bool
	// Test whether replacing the range `from` to `to` (by index) with a
	// node of the given type would leave the node's content valid.
	Node.prototype.canReplaceWith = function canReplaceWith (from, to, type, marks) {
	  if (marks && !this.type.allowsMarks(marks)) { return false }
	  var start = this.contentMatchAt(from).matchType(type);
	  var end = start && start.matchFragment(this.content, to);
	  return end ? end.validEnd : false
	};
	
	// :: (Node) → bool
	// Test whether the given node's content could be appended to this
	// node. If that node is empty, this will only return true if there
	// is at least one node type that can appear in both nodes (to avoid
	// merging completely incompatible nodes).
	Node.prototype.canAppend = function canAppend (other) {
	  if (other.content.size) { return this.canReplace(this.childCount, this.childCount, other.content) }
	  else { return this.type.compatibleContent(other.type) }
	};
	
	// :: ()
	// Check whether this node and its descendants conform to the
	// schema, and raise error when they do not.
	Node.prototype.check = function check () {
	  if (!this.type.validContent(this.content))
	    { throw new RangeError(("Invalid content for node " + (this.type.name) + ": " + (this.content.toString().slice(0, 50)))) }
	  this.content.forEach(function (node) { return node.check(); });
	};
	
	// :: () → Object
	// Return a JSON-serializeable representation of this node.
	Node.prototype.toJSON = function toJSON () {
	  var obj = {type: this.type.name};
	  for (var _ in this.attrs) {
	    obj.attrs = this.attrs;
	    break
	  }
	  if (this.content.size)
	    { obj.content = this.content.toJSON(); }
	  if (this.marks.length)
	    { obj.marks = this.marks.map(function (n) { return n.toJSON(); }); }
	  return obj
	};
	
	// :: (Schema, Object) → Node
	// Deserialize a node from its JSON representation.
	Node.fromJSON = function fromJSON (schema, json) {
	  if (!json) { throw new RangeError("Invalid input for Node.fromJSON") }
	  var marks = null;
	  if (json.marks) {
	    if (!Array.isArray(json.marks)) { throw new RangeError("Invalid mark data for Node.fromJSON") }
	    marks = json.marks.map(schema.markFromJSON);
	  }
	  if (json.type == "text") {
	    if (typeof json.text != "string") { throw new RangeError("Invalid text node in JSON") }
	    return schema.text(json.text, marks)
	  }
	  var content = Fragment.fromJSON(schema, json.content);
	  return schema.nodeType(json.type).create(json.attrs, content, marks)
	};
	
	Object.defineProperties( Node.prototype, prototypeAccessors$3 );
	
	var TextNode = /*@__PURE__*/(function (Node) {
	  function TextNode(type, attrs, content, marks) {
	    Node.call(this, type, attrs, null, marks);
	
	    if (!content) { throw new RangeError("Empty text nodes are not allowed") }
	
	    this.text = content;
	  }
	
	  if ( Node ) TextNode.__proto__ = Node;
	  TextNode.prototype = Object.create( Node && Node.prototype );
	  TextNode.prototype.constructor = TextNode;
	
	  var prototypeAccessors$1 = { textContent: { configurable: true },nodeSize: { configurable: true } };
	
	  TextNode.prototype.toString = function toString () {
	    if (this.type.spec.toDebugString) { return this.type.spec.toDebugString(this) }
	    return wrapMarks(this.marks, JSON.stringify(this.text))
	  };
	
	  prototypeAccessors$1.textContent.get = function () { return this.text };
	
	  TextNode.prototype.textBetween = function textBetween (from, to) { return this.text.slice(from, to) };
	
	  prototypeAccessors$1.nodeSize.get = function () { return this.text.length };
	
	  TextNode.prototype.mark = function mark (marks) {
	    return marks == this.marks ? this : new TextNode(this.type, this.attrs, this.text, marks)
	  };
	
	  TextNode.prototype.withText = function withText (text) {
	    if (text == this.text) { return this }
	    return new TextNode(this.type, this.attrs, text, this.marks)
	  };
	
	  TextNode.prototype.cut = function cut (from, to) {
	    if ( from === void 0 ) from = 0;
	    if ( to === void 0 ) to = this.text.length;
	
	    if (from == 0 && to == this.text.length) { return this }
	    return this.withText(this.text.slice(from, to))
	  };
	
	  TextNode.prototype.eq = function eq (other) {
	    return this.sameMarkup(other) && this.text == other.text
	  };
	
	  TextNode.prototype.toJSON = function toJSON () {
	    var base = Node.prototype.toJSON.call(this);
	    base.text = this.text;
	    return base
	  };
	
	  Object.defineProperties( TextNode.prototype, prototypeAccessors$1 );
	
	  return TextNode;
	}(Node));
	
	function wrapMarks(marks, str) {
	  for (var i = marks.length - 1; i >= 0; i--)
	    { str = marks[i].type.name + "(" + str + ")"; }
	  return str
	}
	
	// ::- Instances of this class represent a match state of a node
	// type's [content expression](#model.NodeSpec.content), and can be
	// used to find out whether further content matches here, and whether
	// a given position is a valid end of the node.
	var ContentMatch = function ContentMatch(validEnd) {
	  // :: bool
	  // True when this match state represents a valid end of the node.
	  this.validEnd = validEnd;
	  this.next = [];
	  this.wrapCache = [];
	};
	
	var prototypeAccessors$4 = { inlineContent: { configurable: true },defaultType: { configurable: true },edgeCount: { configurable: true } };
	
	ContentMatch.parse = function parse (string, nodeTypes) {
	  var stream = new TokenStream(string, nodeTypes);
	  if (stream.next == null) { return ContentMatch.empty }
	  var expr = parseExpr(stream);
	  if (stream.next) { stream.err("Unexpected trailing text"); }
	  var match = dfa(nfa(expr));
	  checkForDeadEnds(match, stream);
	  return match
	};
	
	// :: (NodeType) → ?ContentMatch
	// Match a node type, returning a match after that node if
	// successful.
	ContentMatch.prototype.matchType = function matchType (type) {
	  for (var i = 0; i < this.next.length; i += 2)
	    { if (this.next[i] == type) { return this.next[i + 1] } }
	  return null
	};
	
	// :: (Fragment, ?number, ?number) → ?ContentMatch
	// Try to match a fragment. Returns the resulting match when
	// successful.
	ContentMatch.prototype.matchFragment = function matchFragment (frag, start, end) {
	    if ( start === void 0 ) start = 0;
	    if ( end === void 0 ) end = frag.childCount;
	
	  var cur = this;
	  for (var i = start; cur && i < end; i++)
	    { cur = cur.matchType(frag.child(i).type); }
	  return cur
	};
	
	prototypeAccessors$4.inlineContent.get = function () {
	  var first = this.next[0];
	  return first ? first.isInline : false
	};
	
	// :: ?NodeType
	// Get the first matching node type at this match position that can
	// be generated.
	prototypeAccessors$4.defaultType.get = function () {
	  for (var i = 0; i < this.next.length; i += 2) {
	    var type = this.next[i];
	    if (!(type.isText || type.hasRequiredAttrs())) { return type }
	  }
	};
	
	ContentMatch.prototype.compatible = function compatible (other) {
	  for (var i = 0; i < this.next.length; i += 2)
	    { for (var j = 0; j < other.next.length; j += 2)
	      { if (this.next[i] == other.next[j]) { return true } } }
	  return false
	};
	
	// :: (Fragment, bool, ?number) → ?Fragment
	// Try to match the given fragment, and if that fails, see if it can
	// be made to match by inserting nodes in front of it. When
	// successful, return a fragment of inserted nodes (which may be
	// empty if nothing had to be inserted). When `toEnd` is true, only
	// return a fragment if the resulting match goes to the end of the
	// content expression.
	ContentMatch.prototype.fillBefore = function fillBefore (after, toEnd, startIndex) {
	    if ( toEnd === void 0 ) toEnd = false;
	    if ( startIndex === void 0 ) startIndex = 0;
	
	  var seen = [this];
	  function search(match, types) {
	    var finished = match.matchFragment(after, startIndex);
	    if (finished && (!toEnd || finished.validEnd))
	      { return Fragment.from(types.map(function (tp) { return tp.createAndFill(); })) }
	
	    for (var i = 0; i < match.next.length; i += 2) {
	      var type = match.next[i], next = match.next[i + 1];
	      if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
	        seen.push(next);
	        var found = search(next, types.concat(type));
	        if (found) { return found }
	      }
	    }
	  }
	
	  return search(this, [])
	};
	
	// :: (NodeType) → ?[NodeType]
	// Find a set of wrapping node types that would allow a node of the
	// given type to appear at this position. The result may be empty
	// (when it fits directly) and will be null when no such wrapping
	// exists.
	ContentMatch.prototype.findWrapping = function findWrapping (target) {
	  for (var i = 0; i < this.wrapCache.length; i += 2)
	    { if (this.wrapCache[i] == target) { return this.wrapCache[i + 1] } }
	  var computed = this.computeWrapping(target);
	  this.wrapCache.push(target, computed);
	  return computed
	};
	
	ContentMatch.prototype.computeWrapping = function computeWrapping (target) {
	  var seen = Object.create(null), active = [{match: this, type: null, via: null}];
	  while (active.length) {
	    var current = active.shift(), match = current.match;
	    if (match.matchType(target)) {
	      var result = [];
	      for (var obj = current; obj.type; obj = obj.via)
	        { result.push(obj.type); }
	      return result.reverse()
	    }
	    for (var i = 0; i < match.next.length; i += 2) {
	      var type = match.next[i];
	      if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || match.next[i + 1].validEnd)) {
	        active.push({match: type.contentMatch, type: type, via: current});
	        seen[type.name] = true;
	      }
	    }
	  }
	};
	
	// :: number
	// The number of outgoing edges this node has in the finite
	// automaton that describes the content expression.
	prototypeAccessors$4.edgeCount.get = function () {
	  return this.next.length >> 1
	};
	
	// :: (number) → {type: NodeType, next: ContentMatch}
	// Get the _n_​th outgoing edge from this node in the finite
	// automaton that describes the content expression.
	ContentMatch.prototype.edge = function edge (n) {
	  var i = n << 1;
	  if (i >= this.next.length) { throw new RangeError(("There's no " + n + "th edge in this content match")) }
	  return {type: this.next[i], next: this.next[i + 1]}
	};
	
	ContentMatch.prototype.toString = function toString () {
	  var seen = [];
	  function scan(m) {
	    seen.push(m);
	    for (var i = 1; i < m.next.length; i += 2)
	      { if (seen.indexOf(m.next[i]) == -1) { scan(m.next[i]); } }
	  }
	  scan(this);
	  return seen.map(function (m, i) {
	    var out = i + (m.validEnd ? "*" : " ") + " ";
	    for (var i$1 = 0; i$1 < m.next.length; i$1 += 2)
	      { out += (i$1 ? ", " : "") + m.next[i$1].name + "->" + seen.indexOf(m.next[i$1 + 1]); }
	    return out
	  }).join("\n")
	};
	
	Object.defineProperties( ContentMatch.prototype, prototypeAccessors$4 );
	
	ContentMatch.empty = new ContentMatch(true);
	
	var TokenStream = function TokenStream(string, nodeTypes) {
	  this.string = string;
	  this.nodeTypes = nodeTypes;
	  this.inline = null;
	  this.pos = 0;
	  this.tokens = string.split(/\s*(?=\b|\W|$)/);
	  if (this.tokens[this.tokens.length - 1] == "") { this.tokens.pop(); }
	  if (this.tokens[0] == "") { this.tokens.unshift(); }
	};
	
	var prototypeAccessors$1$2 = { next: { configurable: true } };
	
	prototypeAccessors$1$2.next.get = function () { return this.tokens[this.pos] };
	
	TokenStream.prototype.eat = function eat (tok) { return this.next == tok && (this.pos++ || true) };
	
	TokenStream.prototype.err = function err (str) { throw new SyntaxError(str + " (in content expression '" + this.string + "')") };
	
	Object.defineProperties( TokenStream.prototype, prototypeAccessors$1$2 );
	
	function parseExpr(stream) {
	  var exprs = [];
	  do { exprs.push(parseExprSeq(stream)); }
	  while (stream.eat("|"))
	  return exprs.length == 1 ? exprs[0] : {type: "choice", exprs: exprs}
	}
	
	function parseExprSeq(stream) {
	  var exprs = [];
	  do { exprs.push(parseExprSubscript(stream)); }
	  while (stream.next && stream.next != ")" && stream.next != "|")
	  return exprs.length == 1 ? exprs[0] : {type: "seq", exprs: exprs}
	}
	
	function parseExprSubscript(stream) {
	  var expr = parseExprAtom(stream);
	  for (;;) {
	    if (stream.eat("+"))
	      { expr = {type: "plus", expr: expr}; }
	    else if (stream.eat("*"))
	      { expr = {type: "star", expr: expr}; }
	    else if (stream.eat("?"))
	      { expr = {type: "opt", expr: expr}; }
	    else if (stream.eat("{"))
	      { expr = parseExprRange(stream, expr); }
	    else { break }
	  }
	  return expr
	}
	
	function parseNum(stream) {
	  if (/\D/.test(stream.next)) { stream.err("Expected number, got '" + stream.next + "'"); }
	  var result = Number(stream.next);
	  stream.pos++;
	  return result
	}
	
	function parseExprRange(stream, expr) {
	  var min = parseNum(stream), max = min;
	  if (stream.eat(",")) {
	    if (stream.next != "}") { max = parseNum(stream); }
	    else { max = -1; }
	  }
	  if (!stream.eat("}")) { stream.err("Unclosed braced range"); }
	  return {type: "range", min: min, max: max, expr: expr}
	}
	
	function resolveName(stream, name) {
	  var types = stream.nodeTypes, type = types[name];
	  if (type) { return [type] }
	  var result = [];
	  for (var typeName in types) {
	    var type$1 = types[typeName];
	    if (type$1.groups.indexOf(name) > -1) { result.push(type$1); }
	  }
	  if (result.length == 0) { stream.err("No node type or group '" + name + "' found"); }
	  return result
	}
	
	function parseExprAtom(stream) {
	  if (stream.eat("(")) {
	    var expr = parseExpr(stream);
	    if (!stream.eat(")")) { stream.err("Missing closing paren"); }
	    return expr
	  } else if (!/\W/.test(stream.next)) {
	    var exprs = resolveName(stream, stream.next).map(function (type) {
	      if (stream.inline == null) { stream.inline = type.isInline; }
	      else if (stream.inline != type.isInline) { stream.err("Mixing inline and block content"); }
	      return {type: "name", value: type}
	    });
	    stream.pos++;
	    return exprs.length == 1 ? exprs[0] : {type: "choice", exprs: exprs}
	  } else {
	    stream.err("Unexpected token '" + stream.next + "'");
	  }
	}
	
	// The code below helps compile a regular-expression-like language
	// into a deterministic finite automaton. For a good introduction to
	// these concepts, see https://swtch.com/~rsc/regexp/regexp1.html
	
	// : (Object) → [[{term: ?any, to: number}]]
	// Construct an NFA from an expression as returned by the parser. The
	// NFA is represented as an array of states, which are themselves
	// arrays of edges, which are `{term, to}` objects. The first state is
	// the entry state and the last node is the success state.
	//
	// Note that unlike typical NFAs, the edge ordering in this one is
	// significant, in that it is used to contruct filler content when
	// necessary.
	function nfa(expr) {
	  var nfa = [[]];
	  connect(compile(expr, 0), node());
	  return nfa
	
	  function node() { return nfa.push([]) - 1 }
	  function edge(from, to, term) {
	    var edge = {term: term, to: to};
	    nfa[from].push(edge);
	    return edge
	  }
	  function connect(edges, to) { edges.forEach(function (edge) { return edge.to = to; }); }
	
	  function compile(expr, from) {
	    if (expr.type == "choice") {
	      return expr.exprs.reduce(function (out, expr) { return out.concat(compile(expr, from)); }, [])
	    } else if (expr.type == "seq") {
	      for (var i = 0;; i++) {
	        var next = compile(expr.exprs[i], from);
	        if (i == expr.exprs.length - 1) { return next }
	        connect(next, from = node());
	      }
	    } else if (expr.type == "star") {
	      var loop = node();
	      edge(from, loop);
	      connect(compile(expr.expr, loop), loop);
	      return [edge(loop)]
	    } else if (expr.type == "plus") {
	      var loop$1 = node();
	      connect(compile(expr.expr, from), loop$1);
	      connect(compile(expr.expr, loop$1), loop$1);
	      return [edge(loop$1)]
	    } else if (expr.type == "opt") {
	      return [edge(from)].concat(compile(expr.expr, from))
	    } else if (expr.type == "range") {
	      var cur = from;
	      for (var i$1 = 0; i$1 < expr.min; i$1++) {
	        var next$1 = node();
	        connect(compile(expr.expr, cur), next$1);
	        cur = next$1;
	      }
	      if (expr.max == -1) {
	        connect(compile(expr.expr, cur), cur);
	      } else {
	        for (var i$2 = expr.min; i$2 < expr.max; i$2++) {
	          var next$2 = node();
	          edge(cur, next$2);
	          connect(compile(expr.expr, cur), next$2);
	          cur = next$2;
	        }
	      }
	      return [edge(cur)]
	    } else if (expr.type == "name") {
	      return [edge(from, null, expr.value)]
	    }
	  }
	}
	
	function cmp(a, b) { return b - a }
	
	// Get the set of nodes reachable by null edges from `node`. Omit
	// nodes with only a single null-out-edge, since they may lead to
	// needless duplicated nodes.
	function nullFrom(nfa, node) {
	  var result = [];
	  scan(node);
	  return result.sort(cmp)
	
	  function scan(node) {
	    var edges = nfa[node];
	    if (edges.length == 1 && !edges[0].term) { return scan(edges[0].to) }
	    result.push(node);
	    for (var i = 0; i < edges.length; i++) {
	      var ref = edges[i];
	      var term = ref.term;
	      var to = ref.to;
	      if (!term && result.indexOf(to) == -1) { scan(to); }
	    }
	  }
	}
	
	// : ([[{term: ?any, to: number}]]) → ContentMatch
	// Compiles an NFA as produced by `nfa` into a DFA, modeled as a set
	// of state objects (`ContentMatch` instances) with transitions
	// between them.
	function dfa(nfa) {
	  var labeled = Object.create(null);
	  return explore(nullFrom(nfa, 0))
	
	  function explore(states) {
	    var out = [];
	    states.forEach(function (node) {
	      nfa[node].forEach(function (ref) {
	        var term = ref.term;
	        var to = ref.to;
	
	        if (!term) { return }
	        var known = out.indexOf(term), set = known > -1 && out[known + 1];
	        nullFrom(nfa, to).forEach(function (node) {
	          if (!set) { out.push(term, set = []); }
	          if (set.indexOf(node) == -1) { set.push(node); }
	        });
	      });
	    });
	    var state = labeled[states.join(",")] = new ContentMatch(states.indexOf(nfa.length - 1) > -1);
	    for (var i = 0; i < out.length; i += 2) {
	      var states$1 = out[i + 1].sort(cmp);
	      state.next.push(out[i], labeled[states$1.join(",")] || explore(states$1));
	    }
	    return state
	  }
	}
	
	function checkForDeadEnds(match, stream) {
	  for (var i = 0, work = [match]; i < work.length; i++) {
	    var state = work[i], dead = !state.validEnd, nodes = [];
	    for (var j = 0; j < state.next.length; j += 2) {
	      var node = state.next[j], next = state.next[j + 1];
	      nodes.push(node.name);
	      if (dead && !(node.isText || node.hasRequiredAttrs())) { dead = false; }
	      if (work.indexOf(next) == -1) { work.push(next); }
	    }
	    if (dead) { stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position"); }
	  }
	}
	
	// For node types where all attrs have a default value (or which don't
	// have any attributes), build up a single reusable default attribute
	// object, and use it for all nodes that don't specify specific
	// attributes.
	function defaultAttrs(attrs) {
	  var defaults = Object.create(null);
	  for (var attrName in attrs) {
	    var attr = attrs[attrName];
	    if (!attr.hasDefault) { return null }
	    defaults[attrName] = attr.default;
	  }
	  return defaults
	}
	
	function computeAttrs(attrs, value) {
	  var built = Object.create(null);
	  for (var name in attrs) {
	    var given = value && value[name];
	    if (given === undefined) {
	      var attr = attrs[name];
	      if (attr.hasDefault) { given = attr.default; }
	      else { throw new RangeError("No value supplied for attribute " + name) }
	    }
	    built[name] = given;
	  }
	  return built
	}
	
	function initAttrs(attrs) {
	  var result = Object.create(null);
	  if (attrs) { for (var name in attrs) { result[name] = new Attribute(attrs[name]); } }
	  return result
	}
	
	// ::- Node types are objects allocated once per `Schema` and used to
	// [tag](#model.Node.type) `Node` instances. They contain information
	// about the node type, such as its name and what kind of node it
	// represents.
	var NodeType = function NodeType(name, schema, spec) {
	  // :: string
	  // The name the node type has in this schema.
	  this.name = name;
	
	  // :: Schema
	  // A link back to the `Schema` the node type belongs to.
	  this.schema = schema;
	
	  // :: NodeSpec
	  // The spec that this type is based on
	  this.spec = spec;
	
	  this.groups = spec.group ? spec.group.split(" ") : [];
	  this.attrs = initAttrs(spec.attrs);
	
	  this.defaultAttrs = defaultAttrs(this.attrs);
	
	  // :: ContentMatch
	  // The starting match of the node type's content expression.
	  this.contentMatch = null;
	
	  // : ?[MarkType]
	  // The set of marks allowed in this node. `null` means all marks
	  // are allowed.
	  this.markSet = null;
	
	  // :: bool
	  // True if this node type has inline content.
	  this.inlineContent = null;
	
	  // :: bool
	  // True if this is a block type
	  this.isBlock = !(spec.inline || name == "text");
	
	  // :: bool
	  // True if this is the text node type.
	  this.isText = name == "text";
	};
	
	var prototypeAccessors$5 = { isInline: { configurable: true },isTextblock: { configurable: true },isLeaf: { configurable: true },isAtom: { configurable: true } };
	
	// :: bool
	// True if this is an inline type.
	prototypeAccessors$5.isInline.get = function () { return !this.isBlock };
	
	// :: bool
	// True if this is a textblock type, a block that contains inline
	// content.
	prototypeAccessors$5.isTextblock.get = function () { return this.isBlock && this.inlineContent };
	
	// :: bool
	// True for node types that allow no content.
	prototypeAccessors$5.isLeaf.get = function () { return this.contentMatch == ContentMatch.empty };
	
	// :: bool
	// True when this node is an atom, i.e. when it does not have
	// directly editable content.
	prototypeAccessors$5.isAtom.get = function () { return this.isLeaf || this.spec.atom };
	
	// :: () → bool
	// Tells you whether this node type has any required attributes.
	NodeType.prototype.hasRequiredAttrs = function hasRequiredAttrs () {
	  for (var n in this.attrs) { if (this.attrs[n].isRequired) { return true } }
	  return false
	};
	
	NodeType.prototype.compatibleContent = function compatibleContent (other) {
	  return this == other || this.contentMatch.compatible(other.contentMatch)
	};
	
	NodeType.prototype.computeAttrs = function computeAttrs$1 (attrs) {
	  if (!attrs && this.defaultAttrs) { return this.defaultAttrs }
	  else { return computeAttrs(this.attrs, attrs) }
	};
	
	// :: (?Object, ?union<Fragment, Node, [Node]>, ?[Mark]) → Node
	// Create a `Node` of this type. The given attributes are
	// checked and defaulted (you can pass `null` to use the type's
	// defaults entirely, if no required attributes exist). `content`
	// may be a `Fragment`, a node, an array of nodes, or
	// `null`. Similarly `marks` may be `null` to default to the empty
	// set of marks.
	NodeType.prototype.create = function create (attrs, content, marks) {
	  if (this.isText) { throw new Error("NodeType.create can't construct text nodes") }
	  return new Node(this, this.computeAttrs(attrs), Fragment.from(content), Mark.setFrom(marks))
	};
	
	// :: (?Object, ?union<Fragment, Node, [Node]>, ?[Mark]) → Node
	// Like [`create`](#model.NodeType.create), but check the given content
	// against the node type's content restrictions, and throw an error
	// if it doesn't match.
	NodeType.prototype.createChecked = function createChecked (attrs, content, marks) {
	  content = Fragment.from(content);
	  if (!this.validContent(content))
	    { throw new RangeError("Invalid content for node " + this.name) }
	  return new Node(this, this.computeAttrs(attrs), content, Mark.setFrom(marks))
	};
	
	// :: (?Object, ?union<Fragment, Node, [Node]>, ?[Mark]) → ?Node
	// Like [`create`](#model.NodeType.create), but see if it is necessary to
	// add nodes to the start or end of the given fragment to make it
	// fit the node. If no fitting wrapping can be found, return null.
	// Note that, due to the fact that required nodes can always be
	// created, this will always succeed if you pass null or
	// `Fragment.empty` as content.
	NodeType.prototype.createAndFill = function createAndFill (attrs, content, marks) {
	  attrs = this.computeAttrs(attrs);
	  content = Fragment.from(content);
	  if (content.size) {
	    var before = this.contentMatch.fillBefore(content);
	    if (!before) { return null }
	    content = before.append(content);
	  }
	  var after = this.contentMatch.matchFragment(content).fillBefore(Fragment.empty, true);
	  if (!after) { return null }
	  return new Node(this, attrs, content.append(after), Mark.setFrom(marks))
	};
	
	// :: (Fragment) → bool
	// Returns true if the given fragment is valid content for this node
	// type with the given attributes.
	NodeType.prototype.validContent = function validContent (content) {
	  var result = this.contentMatch.matchFragment(content);
	  if (!result || !result.validEnd) { return false }
	  for (var i = 0; i < content.childCount; i++)
	    { if (!this.allowsMarks(content.child(i).marks)) { return false } }
	  return true
	};
	
	// :: (MarkType) → bool
	// Check whether the given mark type is allowed in this node.
	NodeType.prototype.allowsMarkType = function allowsMarkType (markType) {
	  return this.markSet == null || this.markSet.indexOf(markType) > -1
	};
	
	// :: ([Mark]) → bool
	// Test whether the given set of marks are allowed in this node.
	NodeType.prototype.allowsMarks = function allowsMarks (marks) {
	  if (this.markSet == null) { return true }
	  for (var i = 0; i < marks.length; i++) { if (!this.allowsMarkType(marks[i].type)) { return false } }
	  return true
	};
	
	// :: ([Mark]) → [Mark]
	// Removes the marks that are not allowed in this node from the given set.
	NodeType.prototype.allowedMarks = function allowedMarks (marks) {
	  if (this.markSet == null) { return marks }
	  var copy;
	  for (var i = 0; i < marks.length; i++) {
	    if (!this.allowsMarkType(marks[i].type)) {
	      if (!copy) { copy = marks.slice(0, i); }
	    } else if (copy) {
	      copy.push(marks[i]);
	    }
	  }
	  return !copy ? marks : copy.length ? copy : Mark.empty
	};
	
	NodeType.compile = function compile (nodes, schema) {
	  var result = Object.create(null);
	  nodes.forEach(function (name, spec) { return result[name] = new NodeType(name, schema, spec); });
	
	  var topType = schema.spec.topNode || "doc";
	  if (!result[topType]) { throw new RangeError("Schema is missing its top node type ('" + topType + "')") }
	  if (!result.text) { throw new RangeError("Every schema needs a 'text' type") }
	  for (var _ in result.text.attrs) { throw new RangeError("The text node type should not have attributes") }
	
	  return result
	};
	
	Object.defineProperties( NodeType.prototype, prototypeAccessors$5 );
	
	// Attribute descriptors
	
	var Attribute = function Attribute(options) {
	  this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
	  this.default = options.default;
	};
	
	var prototypeAccessors$1$3 = { isRequired: { configurable: true } };
	
	prototypeAccessors$1$3.isRequired.get = function () {
	  return !this.hasDefault
	};
	
	Object.defineProperties( Attribute.prototype, prototypeAccessors$1$3 );
	
	// Marks
	
	// ::- Like nodes, marks (which are associated with nodes to signify
	// things like emphasis or being part of a link) are
	// [tagged](#model.Mark.type) with type objects, which are
	// instantiated once per `Schema`.
	var MarkType = function MarkType(name, rank, schema, spec) {
	  // :: string
	  // The name of the mark type.
	  this.name = name;
	
	  // :: Schema
	  // The schema that this mark type instance is part of.
	  this.schema = schema;
	
	  // :: MarkSpec
	  // The spec on which the type is based.
	  this.spec = spec;
	
	  this.attrs = initAttrs(spec.attrs);
	
	  this.rank = rank;
	  this.excluded = null;
	  var defaults = defaultAttrs(this.attrs);
	  this.instance = defaults && new Mark(this, defaults);
	};
	
	// :: (?Object) → Mark
	// Create a mark of this type. `attrs` may be `null` or an object
	// containing only some of the mark's attributes. The others, if
	// they have defaults, will be added.
	MarkType.prototype.create = function create (attrs) {
	  if (!attrs && this.instance) { return this.instance }
	  return new Mark(this, computeAttrs(this.attrs, attrs))
	};
	
	MarkType.compile = function compile (marks, schema) {
	  var result = Object.create(null), rank = 0;
	  marks.forEach(function (name, spec) { return result[name] = new MarkType(name, rank++, schema, spec); });
	  return result
	};
	
	// :: ([Mark]) → [Mark]
	// When there is a mark of this type in the given set, a new set
	// without it is returned. Otherwise, the input set is returned.
	MarkType.prototype.removeFromSet = function removeFromSet (set) {
	  for (var i = 0; i < set.length; i++)
	    { if (set[i].type == this)
	      { return set.slice(0, i).concat(set.slice(i + 1)) } }
	  return set
	};
	
	// :: ([Mark]) → ?Mark
	// Tests whether there is a mark of this type in the given set.
	MarkType.prototype.isInSet = function isInSet (set) {
	  for (var i = 0; i < set.length; i++)
	    { if (set[i].type == this) { return set[i] } }
	};
	
	// :: (MarkType) → bool
	// Queries whether a given mark type is
	// [excluded](#model.MarkSpec.excludes) by this one.
	MarkType.prototype.excludes = function excludes (other) {
	  return this.excluded.indexOf(other) > -1
	};
	
	// SchemaSpec:: interface
	// An object describing a schema, as passed to the [`Schema`](#model.Schema)
	// constructor.
	//
	//   nodes:: union<Object<NodeSpec>, OrderedMap<NodeSpec>>
	//   The node types in this schema. Maps names to
	//   [`NodeSpec`](#model.NodeSpec) objects that describe the node type
	//   associated with that name. Their order is significant—it
	//   determines which [parse rules](#model.NodeSpec.parseDOM) take
	//   precedence by default, and which nodes come first in a given
	//   [group](#model.NodeSpec.group).
	//
	//   marks:: ?union<Object<MarkSpec>, OrderedMap<MarkSpec>>
	//   The mark types that exist in this schema. The order in which they
	//   are provided determines the order in which [mark
	//   sets](#model.Mark.addToSet) are sorted and in which [parse
	//   rules](#model.MarkSpec.parseDOM) are tried.
	//
	//   topNode:: ?string
	//   The name of the default top-level node for the schema. Defaults
	//   to `"doc"`.
	
	// NodeSpec:: interface
	//
	//   content:: ?string
	//   The content expression for this node, as described in the [schema
	//   guide](/docs/guide/#schema.content_expressions). When not given,
	//   the node does not allow any content.
	//
	//   marks:: ?string
	//   The marks that are allowed inside of this node. May be a
	//   space-separated string referring to mark names or groups, `"_"`
	//   to explicitly allow all marks, or `""` to disallow marks. When
	//   not given, nodes with inline content default to allowing all
	//   marks, other nodes default to not allowing marks.
	//
	//   group:: ?string
	//   The group or space-separated groups to which this node belongs,
	//   which can be referred to in the content expressions for the
	//   schema.
	//
	//   inline:: ?bool
	//   Should be set to true for inline nodes. (Implied for text nodes.)
	//
	//   atom:: ?bool
	//   Can be set to true to indicate that, though this isn't a [leaf
	//   node](#model.NodeType.isLeaf), it doesn't have directly editable
	//   content and should be treated as a single unit in the view.
	//
	//   attrs:: ?Object<AttributeSpec>
	//   The attributes that nodes of this type get.
	//
	//   selectable:: ?bool
	//   Controls whether nodes of this type can be selected as a [node
	//   selection](#state.NodeSelection). Defaults to true for non-text
	//   nodes.
	//
	//   draggable:: ?bool
	//   Determines whether nodes of this type can be dragged without
	//   being selected. Defaults to false.
	//
	//   code:: ?bool
	//   Can be used to indicate that this node contains code, which
	//   causes some commands to behave differently.
	//
	//   defining:: ?bool
	//   Determines whether this node is considered an important parent
	//   node during replace operations (such as paste). Non-defining (the
	//   default) nodes get dropped when their entire content is replaced,
	//   whereas defining nodes persist and wrap the inserted content.
	//   Likewise, in _inserted_ content the defining parents of the
	//   content are preserved when possible. Typically,
	//   non-default-paragraph textblock types, and possibly list items,
	//   are marked as defining.
	//
	//   isolating:: ?bool
	//   When enabled (default is false), the sides of nodes of this type
	//   count as boundaries that regular editing operations, like
	//   backspacing or lifting, won't cross. An example of a node that
	//   should probably have this enabled is a table cell.
	//
	//   toDOM:: ?(node: Node) → DOMOutputSpec
	//   Defines the default way a node of this type should be serialized
	//   to DOM/HTML (as used by
	//   [`DOMSerializer.fromSchema`](#model.DOMSerializer^fromSchema)).
	//   Should return a DOM node or an [array
	//   structure](#model.DOMOutputSpec) that describes one, with an
	//   optional number zero (“hole”) in it to indicate where the node's
	//   content should be inserted.
	//
	//   For text nodes, the default is to create a text DOM node. Though
	//   it is possible to create a serializer where text is rendered
	//   differently, this is not supported inside the editor, so you
	//   shouldn't override that in your text node spec.
	//
	//   parseDOM:: ?[ParseRule]
	//   Associates DOM parser information with this node, which can be
	//   used by [`DOMParser.fromSchema`](#model.DOMParser^fromSchema) to
	//   automatically derive a parser. The `node` field in the rules is
	//   implied (the name of this node will be filled in automatically).
	//   If you supply your own parser, you do not need to also specify
	//   parsing rules in your schema.
	//
	//   toDebugString:: ?(node: Node) -> string
	//   Defines the default way a node of this type should be serialized
	//   to a string representation for debugging (e.g. in error messages).
	
	// MarkSpec:: interface
	//
	//   attrs:: ?Object<AttributeSpec>
	//   The attributes that marks of this type get.
	//
	//   inclusive:: ?bool
	//   Whether this mark should be active when the cursor is positioned
	//   at its end (or at its start when that is also the start of the
	//   parent node). Defaults to true.
	//
	//   excludes:: ?string
	//   Determines which other marks this mark can coexist with. Should
	//   be a space-separated strings naming other marks or groups of marks.
	//   When a mark is [added](#model.Mark.addToSet) to a set, all marks
	//   that it excludes are removed in the process. If the set contains
	//   any mark that excludes the new mark but is not, itself, excluded
	//   by the new mark, the mark can not be added an the set. You can
	//   use the value `"_"` to indicate that the mark excludes all
	//   marks in the schema.
	//
	//   Defaults to only being exclusive with marks of the same type. You
	//   can set it to an empty string (or any string not containing the
	//   mark's own name) to allow multiple marks of a given type to
	//   coexist (as long as they have different attributes).
	//
	//   group:: ?string
	//   The group or space-separated groups to which this mark belongs.
	//
	//   spanning:: ?bool
	//   Determines whether marks of this type can span multiple adjacent
	//   nodes when serialized to DOM/HTML. Defaults to true.
	//
	//   toDOM:: ?(mark: Mark, inline: bool) → DOMOutputSpec
	//   Defines the default way marks of this type should be serialized
	//   to DOM/HTML. When the resulting spec contains a hole, that is
	//   where the marked content is placed. Otherwise, it is appended to
	//   the top node.
	//
	//   parseDOM:: ?[ParseRule]
	//   Associates DOM parser information with this mark (see the
	//   corresponding [node spec field](#model.NodeSpec.parseDOM)). The
	//   `mark` field in the rules is implied.
	
	// AttributeSpec:: interface
	//
	// Used to [define](#model.NodeSpec.attrs) attributes on nodes or
	// marks.
	//
	//   default:: ?any
	//   The default value for this attribute, to use when no explicit
	//   value is provided. Attributes that have no default must be
	//   provided whenever a node or mark of a type that has them is
	//   created.
	
	// ::- A document schema. Holds [node](#model.NodeType) and [mark
	// type](#model.MarkType) objects for the nodes and marks that may
	// occur in conforming documents, and provides functionality for
	// creating and deserializing such documents.
	var Schema = function Schema(spec) {
	  // :: SchemaSpec
	  // The [spec](#model.SchemaSpec) on which the schema is based,
	  // with the added guarantee that its `nodes` and `marks`
	  // properties are
	  // [`OrderedMap`](https://github.com/marijnh/orderedmap) instances
	  // (not raw objects).
	  this.spec = {};
	  for (var prop in spec) { this.spec[prop] = spec[prop]; }
	  this.spec.nodes = OrderedMap.from(spec.nodes);
	  this.spec.marks = OrderedMap.from(spec.marks);
	
	  // :: Object<NodeType>
	  // An object mapping the schema's node names to node type objects.
	  this.nodes = NodeType.compile(this.spec.nodes, this);
	
	  // :: Object<MarkType>
	  // A map from mark names to mark type objects.
	  this.marks = MarkType.compile(this.spec.marks, this);
	
	  var contentExprCache = Object.create(null);
	  for (var prop$1 in this.nodes) {
	    if (prop$1 in this.marks)
	      { throw new RangeError(prop$1 + " can not be both a node and a mark") }
	    var type = this.nodes[prop$1], contentExpr = type.spec.content || "", markExpr = type.spec.marks;
	    type.contentMatch = contentExprCache[contentExpr] ||
	      (contentExprCache[contentExpr] = ContentMatch.parse(contentExpr, this.nodes));
	    type.inlineContent = type.contentMatch.inlineContent;
	    type.markSet = markExpr == "_" ? null :
	      markExpr ? gatherMarks(this, markExpr.split(" ")) :
	      markExpr == "" || !type.inlineContent ? [] : null;
	  }
	  for (var prop$2 in this.marks) {
	    var type$1 = this.marks[prop$2], excl = type$1.spec.excludes;
	    type$1.excluded = excl == null ? [type$1] : excl == "" ? [] : gatherMarks(this, excl.split(" "));
	  }
	
	  this.nodeFromJSON = this.nodeFromJSON.bind(this);
	  this.markFromJSON = this.markFromJSON.bind(this);
	
	  // :: NodeType
	  // The type of the [default top node](#model.SchemaSpec.topNode)
	  // for this schema.
	  this.topNodeType = this.nodes[this.spec.topNode || "doc"];
	
	  // :: Object
	  // An object for storing whatever values modules may want to
	  // compute and cache per schema. (If you want to store something
	  // in it, try to use property names unlikely to clash.)
	  this.cached = Object.create(null);
	  this.cached.wrappings = Object.create(null);
	};
	
	// :: (union<string, NodeType>, ?Object, ?union<Fragment, Node, [Node]>, ?[Mark]) → Node
	// Create a node in this schema. The `type` may be a string or a
	// `NodeType` instance. Attributes will be extended
	// with defaults, `content` may be a `Fragment`,
	// `null`, a `Node`, or an array of nodes.
	Schema.prototype.node = function node (type, attrs, content, marks) {
	  if (typeof type == "string")
	    { type = this.nodeType(type); }
	  else if (!(type instanceof NodeType))
	    { throw new RangeError("Invalid node type: " + type) }
	  else if (type.schema != this)
	    { throw new RangeError("Node type from different schema used (" + type.name + ")") }
	
	  return type.createChecked(attrs, content, marks)
	};
	
	// :: (string, ?[Mark]) → Node
	// Create a text node in the schema. Empty text nodes are not
	// allowed.
	Schema.prototype.text = function text (text$1, marks) {
	  var type = this.nodes.text;
	  return new TextNode(type, type.defaultAttrs, text$1, Mark.setFrom(marks))
	};
	
	// :: (union<string, MarkType>, ?Object) → Mark
	// Create a mark with the given type and attributes.
	Schema.prototype.mark = function mark (type, attrs) {
	  if (typeof type == "string") { type = this.marks[type]; }
	  return type.create(attrs)
	};
	
	// :: (Object) → Node
	// Deserialize a node from its JSON representation. This method is
	// bound.
	Schema.prototype.nodeFromJSON = function nodeFromJSON (json) {
	  return Node.fromJSON(this, json)
	};
	
	// :: (Object) → Mark
	// Deserialize a mark from its JSON representation. This method is
	// bound.
	Schema.prototype.markFromJSON = function markFromJSON (json) {
	  return Mark.fromJSON(this, json)
	};
	
	Schema.prototype.nodeType = function nodeType (name) {
	  var found = this.nodes[name];
	  if (!found) { throw new RangeError("Unknown node type: " + name) }
	  return found
	};
	
	function gatherMarks(schema, marks) {
	  var found = [];
	  for (var i = 0; i < marks.length; i++) {
	    var name = marks[i], mark = schema.marks[name], ok = mark;
	    if (mark) {
	      found.push(mark);
	    } else {
	      for (var prop in schema.marks) {
	        var mark$1 = schema.marks[prop];
	        if (name == "_" || (mark$1.spec.group && mark$1.spec.group.split(" ").indexOf(name) > -1))
	          { found.push(ok = mark$1); }
	      }
	    }
	    if (!ok) { throw new SyntaxError("Unknown mark type: '" + marks[i] + "'") }
	  }
	  return found
	}
	
	// ParseOptions:: interface
	// These are the options recognized by the
	// [`parse`](#model.DOMParser.parse) and
	// [`parseSlice`](#model.DOMParser.parseSlice) methods.
	//
	//   preserveWhitespace:: ?union<bool, "full">
	//   By default, whitespace is collapsed as per HTML's rules. Pass
	//   `true` to preserve whitespace, but normalize newlines to
	//   spaces, and `"full"` to preserve whitespace entirely.
	//
	//   findPositions:: ?[{node: dom.Node, offset: number}]
	//   When given, the parser will, beside parsing the content,
	//   record the document positions of the given DOM positions. It
	//   will do so by writing to the objects, adding a `pos` property
	//   that holds the document position. DOM positions that are not
	//   in the parsed content will not be written to.
	//
	//   from:: ?number
	//   The child node index to start parsing from.
	//
	//   to:: ?number
	//   The child node index to stop parsing at.
	//
	//   topNode:: ?Node
	//   By default, the content is parsed into the schema's default
	//   [top node type](#model.Schema.topNodeType). You can pass this
	//   option to use the type and attributes from a different node
	//   as the top container.
	//
	//   topMatch:: ?ContentMatch
	//   Provide the starting content match that content parsed into the
	//   top node is matched against.
	//
	//   context:: ?ResolvedPos
	//   A set of additional nodes to count as
	//   [context](#model.ParseRule.context) when parsing, above the
	//   given [top node](#model.ParseOptions.topNode).
	
	// ParseRule:: interface
	// A value that describes how to parse a given DOM node or inline
	// style as a ProseMirror node or mark.
	//
	//   tag:: ?string
	//   A CSS selector describing the kind of DOM elements to match. A
	//   single rule should have _either_ a `tag` or a `style` property.
	//
	//   namespace:: ?string
	//   The namespace to match. This should be used with `tag`.
	//   Nodes are only matched when the namespace matches or this property
	//   is null.
	//
	//   style:: ?string
	//   A CSS property name to match. When given, this rule matches
	//   inline styles that list that property. May also have the form
	//   `"property=value"`, in which case the rule only matches if the
	//   propery's value exactly matches the given value. (For more
	//   complicated filters, use [`getAttrs`](#model.ParseRule.getAttrs)
	//   and return false to indicate that the match failed.)
	//
	//   priority:: ?number
	//   Can be used to change the order in which the parse rules in a
	//   schema are tried. Those with higher priority come first. Rules
	//   without a priority are counted as having priority 50. This
	//   property is only meaningful in a schema—when directly
	//   constructing a parser, the order of the rule array is used.
	//
	//   context:: ?string
	//   When given, restricts this rule to only match when the current
	//   context—the parent nodes into which the content is being
	//   parsed—matches this expression. Should contain one or more node
	//   names or node group names followed by single or double slashes.
	//   For example `"paragraph/"` means the rule only matches when the
	//   parent node is a paragraph, `"blockquote/paragraph/"` restricts
	//   it to be in a paragraph that is inside a blockquote, and
	//   `"section//"` matches any position inside a section—a double
	//   slash matches any sequence of ancestor nodes. To allow multiple
	//   different contexts, they can be separated by a pipe (`|`)
	//   character, as in `"blockquote/|list_item/"`.
	//
	//   node:: ?string
	//   The name of the node type to create when this rule matches. Only
	//   valid for rules with a `tag` property, not for style rules. Each
	//   rule should have one of a `node`, `mark`, or `ignore` property
	//   (except when it appears in a [node](#model.NodeSpec.parseDOM) or
	//   [mark spec](#model.MarkSpec.parseDOM), in which case the `node`
	//   or `mark` property will be derived from its position).
	//
	//   mark:: ?string
	//   The name of the mark type to wrap the matched content in.
	//
	//   ignore:: ?bool
	//   When true, ignore content that matches this rule.
	//
	//   skip:: ?bool
	//   When true, ignore the node that matches this rule, but do parse
	//   its content.
	//
	//   attrs:: ?Object
	//   Attributes for the node or mark created by this rule. When
	//   `getAttrs` is provided, it takes precedence.
	//
	//   getAttrs:: ?(union<dom.Node, string>) → ?union<Object, false>
	//   A function used to compute the attributes for the node or mark
	//   created by this rule. Can also be used to describe further
	//   conditions the DOM element or style must match. When it returns
	//   `false`, the rule won't match. When it returns null or undefined,
	//   that is interpreted as an empty/default set of attributes.
	//
	//   Called with a DOM Element for `tag` rules, and with a string (the
	//   style's value) for `style` rules.
	//
	//   contentElement:: ?union<string, (dom.Node) → dom.Node>
	//   For `tag` rules that produce non-leaf nodes or marks, by default
	//   the content of the DOM element is parsed as content of the mark
	//   or node. If the child nodes are in a descendent node, this may be
	//   a CSS selector string that the parser must use to find the actual
	//   content element, or a function that returns the actual content
	//   element to the parser.
	//
	//   getContent:: ?(dom.Node, schema: Schema) → Fragment
	//   Can be used to override the content of a matched node. When
	//   present, instead of parsing the node's child nodes, the result of
	//   this function is used.
	//
	//   preserveWhitespace:: ?union<bool, "full">
	//   Controls whether whitespace should be preserved when parsing the
	//   content inside the matched element. `false` means whitespace may
	//   be collapsed, `true` means that whitespace should be preserved
	//   but newlines normalized to spaces, and `"full"` means that
	//   newlines should also be preserved.
	
	// ::- A DOM parser represents a strategy for parsing DOM content into
	// a ProseMirror document conforming to a given schema. Its behavior
	// is defined by an array of [rules](#model.ParseRule).
	var DOMParser = function DOMParser(schema, rules) {
	  var this$1 = this;
	
	  // :: Schema
	  // The schema into which the parser parses.
	  this.schema = schema;
	  // :: [ParseRule]
	  // The set of [parse rules](#model.ParseRule) that the parser
	  // uses, in order of precedence.
	  this.rules = rules;
	  this.tags = [];
	  this.styles = [];
	
	  rules.forEach(function (rule) {
	    if (rule.tag) { this$1.tags.push(rule); }
	    else if (rule.style) { this$1.styles.push(rule); }
	  });
	};
	
	// :: (dom.Node, ?ParseOptions) → Node
	// Parse a document from the content of a DOM node.
	DOMParser.prototype.parse = function parse (dom, options) {
	    if ( options === void 0 ) options = {};
	
	  var context = new ParseContext(this, options, false);
	  context.addAll(dom, null, options.from, options.to);
	  return context.finish()
	};
	
	// :: (dom.Node, ?ParseOptions) → Slice
	// Parses the content of the given DOM node, like
	// [`parse`](#model.DOMParser.parse), and takes the same set of
	// options. But unlike that method, which produces a whole node,
	// this one returns a slice that is open at the sides, meaning that
	// the schema constraints aren't applied to the start of nodes to
	// the left of the input and the end of nodes at the end.
	DOMParser.prototype.parseSlice = function parseSlice (dom, options) {
	    if ( options === void 0 ) options = {};
	
	  var context = new ParseContext(this, options, true);
	  context.addAll(dom, null, options.from, options.to);
	  return Slice.maxOpen(context.finish())
	};
	
	DOMParser.prototype.matchTag = function matchTag (dom, context) {
	  for (var i = 0; i < this.tags.length; i++) {
	    var rule = this.tags[i];
	    if (matches(dom, rule.tag) &&
	        (rule.namespace === undefined || dom.namespaceURI == rule.namespace) &&
	        (!rule.context || context.matchesContext(rule.context))) {
	      if (rule.getAttrs) {
	        var result = rule.getAttrs(dom);
	        if (result === false) { continue }
	        rule.attrs = result;
	      }
	      return rule
	    }
	  }
	};
	
	DOMParser.prototype.matchStyle = function matchStyle (prop, value, context) {
	  for (var i = 0; i < this.styles.length; i++) {
	    var rule = this.styles[i];
	    if (rule.style.indexOf(prop) != 0 ||
	        rule.context && !context.matchesContext(rule.context) ||
	        // Test that the style string either precisely matches the prop,
	        // or has an '=' sign after the prop, followed by the given
	        // value.
	        rule.style.length > prop.length &&
	        (rule.style.charCodeAt(prop.length) != 61 || rule.style.slice(prop.length + 1) != value))
	      { continue }
	    if (rule.getAttrs) {
	      var result = rule.getAttrs(value);
	      if (result === false) { continue }
	      rule.attrs = result;
	    }
	    return rule
	  }
	};
	
	// : (Schema) → [ParseRule]
	DOMParser.schemaRules = function schemaRules (schema) {
	  var result = [];
	  function insert(rule) {
	    var priority = rule.priority == null ? 50 : rule.priority, i = 0;
	    for (; i < result.length; i++) {
	      var next = result[i], nextPriority = next.priority == null ? 50 : next.priority;
	      if (nextPriority < priority) { break }
	    }
	    result.splice(i, 0, rule);
	  }
	
	  var loop = function ( name ) {
	    var rules = schema.marks[name].spec.parseDOM;
	    if (rules) { rules.forEach(function (rule) {
	      insert(rule = copy(rule));
	      rule.mark = name;
	    }); }
	  };
	
	    for (var name in schema.marks) loop( name );
	  var loop$1 = function ( name ) {
	    var rules$1 = schema.nodes[name$1].spec.parseDOM;
	    if (rules$1) { rules$1.forEach(function (rule) {
	      insert(rule = copy(rule));
	      rule.node = name$1;
	    }); }
	  };
	
	    for (var name$1 in schema.nodes) loop$1();
	  return result
	};
	
	// :: (Schema) → DOMParser
	// Construct a DOM parser using the parsing rules listed in a
	// schema's [node specs](#model.NodeSpec.parseDOM), reordered by
	// [priority](#model.ParseRule.priority).
	DOMParser.fromSchema = function fromSchema (schema) {
	  return schema.cached.domParser ||
	    (schema.cached.domParser = new DOMParser(schema, DOMParser.schemaRules(schema)))
	};
	
	// : Object<bool> The block-level tags in HTML5
	var blockTags = {
	  address: true, article: true, aside: true, blockquote: true, canvas: true,
	  dd: true, div: true, dl: true, fieldset: true, figcaption: true, figure: true,
	  footer: true, form: true, h1: true, h2: true, h3: true, h4: true, h5: true,
	  h6: true, header: true, hgroup: true, hr: true, li: true, noscript: true, ol: true,
	  output: true, p: true, pre: true, section: true, table: true, tfoot: true, ul: true
	};
	
	// : Object<bool> The tags that we normally ignore.
	var ignoreTags = {
	  head: true, noscript: true, object: true, script: true, style: true, title: true
	};
	
	// : Object<bool> List tags.
	var listTags = {ol: true, ul: true};
	
	// Using a bitfield for node context options
	var OPT_PRESERVE_WS = 1, OPT_PRESERVE_WS_FULL = 2, OPT_OPEN_LEFT = 4;
	
	function wsOptionsFor(preserveWhitespace) {
	  return (preserveWhitespace ? OPT_PRESERVE_WS : 0) | (preserveWhitespace === "full" ? OPT_PRESERVE_WS_FULL : 0)
	}
	
	var NodeContext = function NodeContext(type, attrs, marks, pendingMarks, solid, match, options) {
	  this.type = type;
	  this.attrs = attrs;
	  this.solid = solid;
	  this.match = match || (options & OPT_OPEN_LEFT ? null : type.contentMatch);
	  this.options = options;
	  this.content = [];
	  // Marks applied to this node itself
	  this.marks = marks;
	  // Marks applied to its children
	  this.activeMarks = Mark.none;
	  // Marks that can't apply here, but will be used in children if possible
	  this.pendingMarks = pendingMarks;
	};
	
	NodeContext.prototype.findWrapping = function findWrapping (node) {
	  if (!this.match) {
	    if (!this.type) { return [] }
	    var fill = this.type.contentMatch.fillBefore(Fragment.from(node));
	    if (fill) {
	      this.match = this.type.contentMatch.matchFragment(fill);
	    } else {
	      var start = this.type.contentMatch, wrap;
	      if (wrap = start.findWrapping(node.type)) {
	        this.match = start;
	        return wrap
	      } else {
	        return null
	      }
	    }
	  }
	  return this.match.findWrapping(node.type)
	};
	
	NodeContext.prototype.finish = function finish (openEnd) {
	  if (!(this.options & OPT_PRESERVE_WS)) { // Strip trailing whitespace
	    var last = this.content[this.content.length - 1], m;
	    if (last && last.isText && (m = /[ \t\r\n\u000c]+$/.exec(last.text))) {
	      if (last.text.length == m[0].length) { this.content.pop(); }
	      else { this.content[this.content.length - 1] = last.withText(last.text.slice(0, last.text.length - m[0].length)); }
	    }
	  }
	  var content = Fragment.from(this.content);
	  if (!openEnd && this.match)
	    { content = content.append(this.match.fillBefore(Fragment.empty, true)); }
	  return this.type ? this.type.create(this.attrs, content, this.marks) : content
	};
	
	NodeContext.prototype.applyPending = function applyPending (nextType) {
	  for (var i = 0, pending = this.pendingMarks; i < pending.length; i++) {
	    var mark = pending[i];
	    if ((this.type ? this.type.allowsMarkType(mark.type) : markMayApply(mark.type, nextType)) &&
	        !mark.isInSet(this.activeMarks)) {
	      this.activeMarks = mark.addToSet(this.activeMarks);
	      this.pendingMarks = mark.removeFromSet(this.pendingMarks);
	    }
	  }
	};
	
	var ParseContext = function ParseContext(parser, options, open) {
	  // : DOMParser The parser we are using.
	  this.parser = parser;
	  // : Object The options passed to this parse.
	  this.options = options;
	  this.isOpen = open;
	  var topNode = options.topNode, topContext;
	  var topOptions = wsOptionsFor(options.preserveWhitespace) | (open ? OPT_OPEN_LEFT : 0);
	  if (topNode)
	    { topContext = new NodeContext(topNode.type, topNode.attrs, Mark.none, Mark.none, true,
	                                 options.topMatch || topNode.type.contentMatch, topOptions); }
	  else if (open)
	    { topContext = new NodeContext(null, null, Mark.none, Mark.none, true, null, topOptions); }
	  else
	    { topContext = new NodeContext(parser.schema.topNodeType, null, Mark.none, Mark.none, true, null, topOptions); }
	  this.nodes = [topContext];
	  // : [Mark] The current set of marks
	  this.open = 0;
	  this.find = options.findPositions;
	  this.needsBlock = false;
	};
	
	var prototypeAccessors$6 = { top: { configurable: true },currentPos: { configurable: true } };
	
	prototypeAccessors$6.top.get = function () {
	  return this.nodes[this.open]
	};
	
	// : (dom.Node)
	// Add a DOM node to the content. Text is inserted as text node,
	// otherwise, the node is passed to `addElement` or, if it has a
	// `style` attribute, `addElementWithStyles`.
	ParseContext.prototype.addDOM = function addDOM (dom) {
	  if (dom.nodeType == 3) {
	    this.addTextNode(dom);
	  } else if (dom.nodeType == 1) {
	    var style = dom.getAttribute("style");
	    var marks = style ? this.readStyles(parseStyles(style)) : null, top = this.top;
	    if (marks != null) { for (var i = 0; i < marks.length; i++) { this.addPendingMark(marks[i]); } }
	    this.addElement(dom);
	    if (marks != null) { for (var i$1 = 0; i$1 < marks.length; i$1++) { this.removePendingMark(marks[i$1], top); } }
	  }
	};
	
	ParseContext.prototype.addTextNode = function addTextNode (dom) {
	  var value = dom.nodeValue;
	  var top = this.top;
	  if ((top.type ? top.type.inlineContent : top.content.length && top.content[0].isInline) || /[^ \t\r\n\u000c]/.test(value)) {
	    if (!(top.options & OPT_PRESERVE_WS)) {
	      value = value.replace(/[ \t\r\n\u000c]+/g, " ");
	      // If this starts with whitespace, and there is no node before it, or
	      // a hard break, or a text node that ends with whitespace, strip the
	      // leading space.
	      if (/^[ \t\r\n\u000c]/.test(value) && this.open == this.nodes.length - 1) {
	        var nodeBefore = top.content[top.content.length - 1];
	        var domNodeBefore = dom.previousSibling;
	        if (!nodeBefore ||
	            (domNodeBefore && domNodeBefore.nodeName == 'BR') ||
	            (nodeBefore.isText && /[ \t\r\n\u000c]$/.test(nodeBefore.text)))
	          { value = value.slice(1); }
	      }
	    } else if (!(top.options & OPT_PRESERVE_WS_FULL)) {
	      value = value.replace(/\r?\n|\r/g, " ");
	    }
	    if (value) { this.insertNode(this.parser.schema.text(value)); }
	    this.findInText(dom);
	  } else {
	    this.findInside(dom);
	  }
	};
	
	// : (dom.Element)
	// Try to find a handler for the given tag and use that to parse. If
	// none is found, the element's content nodes are added directly.
	ParseContext.prototype.addElement = function addElement (dom) {
	  var name = dom.nodeName.toLowerCase();
	  if (listTags.hasOwnProperty(name)) { normalizeList(dom); }
	  var rule = (this.options.ruleFromNode && this.options.ruleFromNode(dom)) || this.parser.matchTag(dom, this);
	  if (rule ? rule.ignore : ignoreTags.hasOwnProperty(name)) {
	    this.findInside(dom);
	  } else if (!rule || rule.skip) {
	    if (rule && rule.skip.nodeType) { dom = rule.skip; }
	    var sync, top = this.top, oldNeedsBlock = this.needsBlock;
	    if (blockTags.hasOwnProperty(name)) {
	      sync = true;
	      if (!top.type) { this.needsBlock = true; }
	    } else if (!dom.firstChild) {
	      this.leafFallback(dom);
	      return
	    }
	    this.addAll(dom);
	    if (sync) { this.sync(top); }
	    this.needsBlock = oldNeedsBlock;
	  } else {
	    this.addElementByRule(dom, rule);
	  }
	};
	
	// Called for leaf DOM nodes that would otherwise be ignored
	ParseContext.prototype.leafFallback = function leafFallback (dom) {
	  if (dom.nodeName == "BR" && this.top.type && this.top.type.inlineContent)
	    { this.addTextNode(dom.ownerDocument.createTextNode("\n")); }
	};
	
	// Run any style parser associated with the node's styles. Either
	// return an array of marks, or null to indicate some of the styles
	// had a rule with `ignore` set.
	ParseContext.prototype.readStyles = function readStyles (styles) {
	  var marks = Mark.none;
	  for (var i = 0; i < styles.length; i += 2) {
	    var rule = this.parser.matchStyle(styles[i], styles[i + 1], this);
	    if (!rule) { continue }
	    if (rule.ignore) { return null }
	    marks = this.parser.schema.marks[rule.mark].create(rule.attrs).addToSet(marks);
	  }
	  return marks
	};
	
	// : (dom.Element, ParseRule) → bool
	// Look up a handler for the given node. If none are found, return
	// false. Otherwise, apply it, use its return value to drive the way
	// the node's content is wrapped, and return true.
	ParseContext.prototype.addElementByRule = function addElementByRule (dom, rule) {
	    var this$1 = this;
	
	  var sync, nodeType, markType, mark;
	  if (rule.node) {
	    nodeType = this.parser.schema.nodes[rule.node];
	    if (!nodeType.isLeaf) {
	      sync = this.enter(nodeType, rule.attrs, rule.preserveWhitespace);
	    } else if (!this.insertNode(nodeType.create(rule.attrs))) {
	      this.leafFallback(dom);
	    }
	  } else {
	    markType = this.parser.schema.marks[rule.mark];
	    mark = markType.create(rule.attrs);
	    this.addPendingMark(mark);
	  }
	  var startIn = this.top;
	
	  if (nodeType && nodeType.isLeaf) {
	    this.findInside(dom);
	  } else if (rule.getContent) {
	    this.findInside(dom);
	    rule.getContent(dom, this.parser.schema).forEach(function (node) { return this$1.insertNode(node); });
	  } else {
	    var contentDOM = rule.contentElement;
	    if (typeof contentDOM == "string") { contentDOM = dom.querySelector(contentDOM); }
	    else if (typeof contentDOM == "function") { contentDOM = contentDOM(dom); }
	    if (!contentDOM) { contentDOM = dom; }
	    this.findAround(dom, contentDOM, true);
	    this.addAll(contentDOM, sync);
	  }
	  if (sync) { this.sync(startIn); this.open--; }
	  if (mark) { this.removePendingMark(mark, startIn); }
	};
	
	// : (dom.Node, ?NodeBuilder, ?number, ?number)
	// Add all child nodes between `startIndex` and `endIndex` (or the
	// whole node, if not given). If `sync` is passed, use it to
	// synchronize after every block element.
	ParseContext.prototype.addAll = function addAll (parent, sync, startIndex, endIndex) {
	  var index = startIndex || 0;
	  for (var dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild,
	           end = endIndex == null ? null : parent.childNodes[endIndex];
	       dom != end; dom = dom.nextSibling, ++index) {
	    this.findAtPoint(parent, index);
	    this.addDOM(dom);
	    if (sync && blockTags.hasOwnProperty(dom.nodeName.toLowerCase()))
	      { this.sync(sync); }
	  }
	  this.findAtPoint(parent, index);
	};
	
	// Try to find a way to fit the given node type into the current
	// context. May add intermediate wrappers and/or leave non-solid
	// nodes that we're in.
	ParseContext.prototype.findPlace = function findPlace (node) {
	  var route, sync;
	  for (var depth = this.open; depth >= 0; depth--) {
	    var cx = this.nodes[depth];
	    var found = cx.findWrapping(node);
	    if (found && (!route || route.length > found.length)) {
	      route = found;
	      sync = cx;
	      if (!found.length) { break }
	    }
	    if (cx.solid) { break }
	  }
	  if (!route) { return false }
	  this.sync(sync);
	  for (var i = 0; i < route.length; i++)
	    { this.enterInner(route[i], null, false); }
	  return true
	};
	
	// : (Node) → ?Node
	// Try to insert the given node, adjusting the context when needed.
	ParseContext.prototype.insertNode = function insertNode (node) {
	  if (node.isInline && this.needsBlock && !this.top.type) {
	    var block = this.textblockFromContext();
	    if (block) { this.enterInner(block); }
	  }
	  if (this.findPlace(node)) {
	    this.closeExtra();
	    var top = this.top;
	    top.applyPending(node.type);
	    if (top.match) { top.match = top.match.matchType(node.type); }
	    var marks = top.activeMarks;
	    for (var i = 0; i < node.marks.length; i++)
	      { if (!top.type || top.type.allowsMarkType(node.marks[i].type))
	        { marks = node.marks[i].addToSet(marks); } }
	    top.content.push(node.mark(marks));
	    return true
	  }
	  return false
	};
	
	// : (NodeType, ?Object) → bool
	// Try to start a node of the given type, adjusting the context when
	// necessary.
	ParseContext.prototype.enter = function enter (type, attrs, preserveWS) {
	  var ok = this.findPlace(type.create(attrs));
	  if (ok) { this.enterInner(type, attrs, true, preserveWS); }
	  return ok
	};
	
	// Open a node of the given type
	ParseContext.prototype.enterInner = function enterInner (type, attrs, solid, preserveWS) {
	  this.closeExtra();
	  var top = this.top;
	  top.applyPending(type);
	  top.match = top.match && top.match.matchType(type, attrs);
	  var options = preserveWS == null ? top.options & ~OPT_OPEN_LEFT : wsOptionsFor(preserveWS);
	  if ((top.options & OPT_OPEN_LEFT) && top.content.length == 0) { options |= OPT_OPEN_LEFT; }
	  this.nodes.push(new NodeContext(type, attrs, top.activeMarks, top.pendingMarks, solid, null, options));
	  this.open++;
	};
	
	// Make sure all nodes above this.open are finished and added to
	// their parents
	ParseContext.prototype.closeExtra = function closeExtra (openEnd) {
	  var i = this.nodes.length - 1;
	  if (i > this.open) {
	    for (; i > this.open; i--) { this.nodes[i - 1].content.push(this.nodes[i].finish(openEnd)); }
	    this.nodes.length = this.open + 1;
	  }
	};
	
	ParseContext.prototype.finish = function finish () {
	  this.open = 0;
	  this.closeExtra(this.isOpen);
	  return this.nodes[0].finish(this.isOpen || this.options.topOpen)
	};
	
	ParseContext.prototype.sync = function sync (to) {
	  for (var i = this.open; i >= 0; i--) { if (this.nodes[i] == to) {
	    this.open = i;
	    return
	  } }
	};
	
	prototypeAccessors$6.currentPos.get = function () {
	  this.closeExtra();
	  var pos = 0;
	  for (var i = this.open; i >= 0; i--) {
	    var content = this.nodes[i].content;
	    for (var j = content.length - 1; j >= 0; j--)
	      { pos += content[j].nodeSize; }
	    if (i) { pos++; }
	  }
	  return pos
	};
	
	ParseContext.prototype.findAtPoint = function findAtPoint (parent, offset) {
	  if (this.find) { for (var i = 0; i < this.find.length; i++) {
	    if (this.find[i].node == parent && this.find[i].offset == offset)
	      { this.find[i].pos = this.currentPos; }
	  } }
	};
	
	ParseContext.prototype.findInside = function findInside (parent) {
	  if (this.find) { for (var i = 0; i < this.find.length; i++) {
	    if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node))
	      { this.find[i].pos = this.currentPos; }
	  } }
	};
	
	ParseContext.prototype.findAround = function findAround (parent, content, before) {
	  if (parent != content && this.find) { for (var i = 0; i < this.find.length; i++) {
	    if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) {
	      var pos = content.compareDocumentPosition(this.find[i].node);
	      if (pos & (before ? 2 : 4))
	        { this.find[i].pos = this.currentPos; }
	    }
	  } }
	};
	
	ParseContext.prototype.findInText = function findInText (textNode) {
	  if (this.find) { for (var i = 0; i < this.find.length; i++) {
	    if (this.find[i].node == textNode)
	      { this.find[i].pos = this.currentPos - (textNode.nodeValue.length - this.find[i].offset); }
	  } }
	};
	
	// : (string) → bool
	// Determines whether the given [context
	// string](#ParseRule.context) matches this context.
	ParseContext.prototype.matchesContext = function matchesContext (context) {
	    var this$1 = this;
	
	  if (context.indexOf("|") > -1)
	    { return context.split(/\s*\|\s*/).some(this.matchesContext, this) }
	
	  var parts = context.split("/");
	  var option = this.options.context;
	  var useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
	  var minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
	  var match = function (i, depth) {
	    for (; i >= 0; i--) {
	      var part = parts[i];
	      if (part == "") {
	        if (i == parts.length - 1 || i == 0) { continue }
	        for (; depth >= minDepth; depth--)
	          { if (match(i - 1, depth)) { return true } }
	        return false
	      } else {
	        var next = depth > 0 || (depth == 0 && useRoot) ? this$1.nodes[depth].type
	            : option && depth >= minDepth ? option.node(depth - minDepth).type
	            : null;
	        if (!next || (next.name != part && next.groups.indexOf(part) == -1))
	          { return false }
	        depth--;
	      }
	    }
	    return true
	  };
	  return match(parts.length - 1, this.open)
	};
	
	ParseContext.prototype.textblockFromContext = function textblockFromContext () {
	  var $context = this.options.context;
	  if ($context) { for (var d = $context.depth; d >= 0; d--) {
	    var deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;
	    if (deflt && deflt.isTextblock && deflt.defaultAttrs) { return deflt }
	  } }
	  for (var name in this.parser.schema.nodes) {
	    var type = this.parser.schema.nodes[name];
	    if (type.isTextblock && type.defaultAttrs) { return type }
	  }
	};
	
	ParseContext.prototype.addPendingMark = function addPendingMark (mark) {
	  this.top.pendingMarks = mark.addToSet(this.top.pendingMarks);
	};
	
	ParseContext.prototype.removePendingMark = function removePendingMark (mark, upto) {
	  for (var depth = this.open; depth >= 0; depth--) {
	    var level = this.nodes[depth];
	    var found = level.pendingMarks.lastIndexOf(mark);
	    if (found > -1) { level.pendingMarks = mark.removeFromSet(level.pendingMarks); }
	    else { level.activeMarks = mark.removeFromSet(level.activeMarks); }
	    if (level == upto) { break }
	  }
	};
	
	Object.defineProperties( ParseContext.prototype, prototypeAccessors$6 );
	
	// Kludge to work around directly nested list nodes produced by some
	// tools and allowed by browsers to mean that the nested list is
	// actually part of the list item above it.
	function normalizeList(dom) {
	  for (var child = dom.firstChild, prevItem = null; child; child = child.nextSibling) {
	    var name = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;
	    if (name && listTags.hasOwnProperty(name) && prevItem) {
	      prevItem.appendChild(child);
	      child = prevItem;
	    } else if (name == "li") {
	      prevItem = child;
	    } else if (name) {
	      prevItem = null;
	    }
	  }
	}
	
	// Apply a CSS selector.
	function matches(dom, selector) {
	  return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector)
	}
	
	// : (string) → [string]
	// Tokenize a style attribute into property/value pairs.
	function parseStyles(style) {
	  var re = /\s*([\w-]+)\s*:\s*([^;]+)/g, m, result = [];
	  while (m = re.exec(style)) { result.push(m[1], m[2].trim()); }
	  return result
	}
	
	function copy(obj) {
	  var copy = {};
	  for (var prop in obj) { copy[prop] = obj[prop]; }
	  return copy
	}
	
	// Used when finding a mark at the top level of a fragment parse.
	// Checks whether it would be reasonable to apply a given mark type to
	// a given node, by looking at the way the mark occurs in the schema.
	function markMayApply(markType, nodeType) {
	  var nodes = nodeType.schema.nodes;
	  var loop = function ( name ) {
	    var parent = nodes[name];
	    if (!parent.allowsMarkType(markType)) { return }
	    var seen = [], scan = function (match) {
	      seen.push(match);
	      for (var i = 0; i < match.edgeCount; i++) {
	        var ref = match.edge(i);
	        var type = ref.type;
	        var next = ref.next;
	        if (type == nodeType) { return true }
	        if (seen.indexOf(next) < 0 && scan(next)) { return true }
	      }
	    };
	    if (scan(parent.contentMatch)) { return { v: true } }
	  };
	
	  for (var name in nodes) {
	    var returned = loop( name );
	
	    if ( returned ) return returned.v;
	  }
	}
	
	// DOMOutputSpec:: interface
	// A description of a DOM structure. Can be either a string, which is
	// interpreted as a text node, a DOM node, which is interpreted as
	// itself, or an array.
	//
	// An array describes a DOM element. The first value in the array
	// should be a string—the name of the DOM element, optionally prefixed
	// by a namespace URL and a space. If the second element is plain
	// object, it is interpreted as a set of attributes for the element.
	// Any elements after that (including the 2nd if it's not an attribute
	// object) are interpreted as children of the DOM elements, and must
	// either be valid `DOMOutputSpec` values, or the number zero.
	//
	// The number zero (pronounced “hole”) is used to indicate the place
	// where a node's child nodes should be inserted. If it occurs in an
	// output spec, it should be the only child element in its parent
	// node.
	
	// ::- A DOM serializer knows how to convert ProseMirror nodes and
	// marks of various types to DOM nodes.
	var DOMSerializer = function DOMSerializer(nodes, marks) {
	  // :: Object<(node: Node) → DOMOutputSpec>
	  // The node serialization functions.
	  this.nodes = nodes || {};
	  // :: Object<?(mark: Mark, inline: bool) → DOMOutputSpec>
	  // The mark serialization functions.
	  this.marks = marks || {};
	};
	
	// :: (Fragment, ?Object) → dom.DocumentFragment
	// Serialize the content of this fragment to a DOM fragment. When
	// not in the browser, the `document` option, containing a DOM
	// document, should be passed so that the serializer can create
	// nodes.
	DOMSerializer.prototype.serializeFragment = function serializeFragment (fragment, options, target) {
	    var this$1 = this;
	    if ( options === void 0 ) options = {};
	
	  if (!target) { target = doc(options).createDocumentFragment(); }
	
	  var top = target, active = null;
	  fragment.forEach(function (node) {
	    if (active || node.marks.length) {
	      if (!active) { active = []; }
	      var keep = 0, rendered = 0;
	      while (keep < active.length && rendered < node.marks.length) {
	        var next = node.marks[rendered];
	        if (!this$1.marks[next.type.name]) { rendered++; continue }
	        if (!next.eq(active[keep]) || next.type.spec.spanning === false) { break }
	        keep += 2; rendered++;
	      }
	      while (keep < active.length) {
	        top = active.pop();
	        active.pop();
	      }
	      while (rendered < node.marks.length) {
	        var add = node.marks[rendered++];
	        var markDOM = this$1.serializeMark(add, node.isInline, options);
	        if (markDOM) {
	          active.push(add, top);
	          top.appendChild(markDOM.dom);
	          top = markDOM.contentDOM || markDOM.dom;
	        }
	      }
	    }
	    top.appendChild(this$1.serializeNode(node, options));
	  });
	
	  return target
	};
	
	// :: (Node, ?Object) → dom.Node
	// Serialize this node to a DOM node. This can be useful when you
	// need to serialize a part of a document, as opposed to the whole
	// document. To serialize a whole document, use
	// [`serializeFragment`](#model.DOMSerializer.serializeFragment) on
	// its [content](#model.Node.content).
	DOMSerializer.prototype.serializeNode = function serializeNode (node, options) {
	    if ( options === void 0 ) options = {};
	
	  var ref =
	      DOMSerializer.renderSpec(doc(options), this.nodes[node.type.name](node));
	    var dom = ref.dom;
	    var contentDOM = ref.contentDOM;
	  if (contentDOM) {
	    if (node.isLeaf)
	      { throw new RangeError("Content hole not allowed in a leaf node spec") }
	    if (options.onContent)
	      { options.onContent(node, contentDOM, options); }
	    else
	      { this.serializeFragment(node.content, options, contentDOM); }
	  }
	  return dom
	};
	
	DOMSerializer.prototype.serializeNodeAndMarks = function serializeNodeAndMarks (node, options) {
	    if ( options === void 0 ) options = {};
	
	  var dom = this.serializeNode(node, options);
	  for (var i = node.marks.length - 1; i >= 0; i--) {
	    var wrap = this.serializeMark(node.marks[i], node.isInline, options);
	    if (wrap) {
	(wrap.contentDOM || wrap.dom).appendChild(dom);
	      dom = wrap.dom;
	    }
	  }
	  return dom
	};
	
	DOMSerializer.prototype.serializeMark = function serializeMark (mark, inline, options) {
	    if ( options === void 0 ) options = {};
	
	  var toDOM = this.marks[mark.type.name];
	  return toDOM && DOMSerializer.renderSpec(doc(options), toDOM(mark, inline))
	};
	
	// :: (dom.Document, DOMOutputSpec) → {dom: dom.Node, contentDOM: ?dom.Node}
	// Render an [output spec](#model.DOMOutputSpec) to a DOM node. If
	// the spec has a hole (zero) in it, `contentDOM` will point at the
	// node with the hole.
	DOMSerializer.renderSpec = function renderSpec (doc, structure, xmlNS) {
	    if ( xmlNS === void 0 ) xmlNS = null;
	
	  if (typeof structure == "string")
	    { return {dom: doc.createTextNode(structure)} }
	  if (structure.nodeType != null)
	    { return {dom: structure} }
	  var tagName = structure[0], space = tagName.indexOf(" ");
	  if (space > 0) {
	    xmlNS = tagName.slice(0, space);
	    tagName = tagName.slice(space + 1);
	  }
	  var contentDOM = null, dom = xmlNS ? doc.createElementNS(xmlNS, tagName) : doc.createElement(tagName);
	  var attrs = structure[1], start = 1;
	  if (attrs && typeof attrs == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
	    start = 2;
	    for (var name in attrs) { if (attrs[name] != null) {
	      var space$1 = name.indexOf(" ");
	      if (space$1 > 0) { dom.setAttributeNS(name.slice(0, space$1), name.slice(space$1 + 1), attrs[name]); }
	      else { dom.setAttribute(name, attrs[name]); }
	    } }
	  }
	  for (var i = start; i < structure.length; i++) {
	    var child = structure[i];
	    if (child === 0) {
	      if (i < structure.length - 1 || i > start)
	        { throw new RangeError("Content hole must be the only child of its parent node") }
	      return {dom: dom, contentDOM: dom}
	    } else {
	      var ref = DOMSerializer.renderSpec(doc, child, xmlNS);
	        var inner = ref.dom;
	        var innerContent = ref.contentDOM;
	      dom.appendChild(inner);
	      if (innerContent) {
	        if (contentDOM) { throw new RangeError("Multiple content holes") }
	        contentDOM = innerContent;
	      }
	    }
	  }
	  return {dom: dom, contentDOM: contentDOM}
	};
	
	// :: (Schema) → DOMSerializer
	// Build a serializer using the [`toDOM`](#model.NodeSpec.toDOM)
	// properties in a schema's node and mark specs.
	DOMSerializer.fromSchema = function fromSchema (schema) {
	  return schema.cached.domSerializer ||
	    (schema.cached.domSerializer = new DOMSerializer(this.nodesFromSchema(schema), this.marksFromSchema(schema)))
	};
	
	// : (Schema) → Object<(node: Node) → DOMOutputSpec>
	// Gather the serializers in a schema's node specs into an object.
	// This can be useful as a base to build a custom serializer from.
	DOMSerializer.nodesFromSchema = function nodesFromSchema (schema) {
	  var result = gatherToDOM(schema.nodes);
	  if (!result.text) { result.text = function (node) { return node.text; }; }
	  return result
	};
	
	// : (Schema) → Object<(mark: Mark) → DOMOutputSpec>
	// Gather the serializers in a schema's mark specs into an object.
	DOMSerializer.marksFromSchema = function marksFromSchema (schema) {
	  return gatherToDOM(schema.marks)
	};
	
	function gatherToDOM(obj) {
	  var result = {};
	  for (var name in obj) {
	    var toDOM = obj[name].spec.toDOM;
	    if (toDOM) { result[name] = toDOM; }
	  }
	  return result
	}
	
	function doc(options) {
	  // declare global: window
	  return options.document || window.document
	}
	
	exports.ContentMatch = ContentMatch;
	exports.DOMParser = DOMParser;
	exports.DOMSerializer = DOMSerializer;
	exports.Fragment = Fragment;
	exports.Mark = Mark;
	exports.MarkType = MarkType;
	exports.Node = Node;
	exports.NodeRange = NodeRange;
	exports.NodeType = NodeType;
	exports.ReplaceError = ReplaceError;
	exports.ResolvedPos = ResolvedPos;
	exports.Schema = Schema;
	exports.Slice = Slice;
	//# sourceMappingURL=index.js.map


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(326), __esModule: true };

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(17);
	var core = __webpack_require__(4);
	var ctx = __webpack_require__(41);
	var hide = __webpack_require__(46);
	var has = __webpack_require__(45);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(321), __esModule: true };

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(324), __esModule: true };

/***/ }),
/* 17 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 18 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var IDC_EXPLAIN = {
	  xh: '徐汇-xh',
	  gq: '桂桥-gq',
	  dba: '数北A-dba',
	  sdyd: '山东移动-sdyd',
	  gz: '广州-gz',
	  cd: '成都-cd',
	  gg: '硅谷-gg',
	  tencent: '腾讯-tencent',
	  cq: '次渠-cq',
	  zw: '中卫-zw',
	  gh: '光环-gh',
	  nh: '南汇-nh',
	  sdlt: '山东联通-sdlt',
	  nj: '南京-nj',
	  tx: '上海一区-tx',
	  dld: '多伦多一区-dld',
	  ts: '唐山-ts',
	  rz: '润泽-rz',
	  wj: '望京-wj',
	  yf: '永丰-yf',
	  yy: '易园-yy',
	  hk: '香港一区-hk',
	  yz: '扬州-yz',
	  dx: '大兴-dx',
	  bs: '宝山-bs',
	  yp: '月浦-yp',
	  sjz: '石家庄-sjz',
	  kh: '科华-kh',
	  sb: '市北-sb',
	  kx: '天津-kx'
	};
	var STATUS_EXPLAIN = {
	  0: '已停止', 1: '运行状态', 2: 'worker更新中',
	  3: '异常停止',
	  4: '手动停止',
	  5: '依赖不存在',
	  6: '停止命令下发中',
	  7: '状态不存在',
	  8: '进程停止',
	  9: '命令下发失败'
	};
	
	var COLOR_EXPLAIN = {
	  0: '#BEBEBE',
	  1: '#A1D6E4',
	  2: '#01DFD7',
	  3: '#F7ba2a',
	  4: '#F78181',
	  5: '#F5A9A9',
	  6: '#01DFD7',
	  8: '#878D99'
	};
	exports.default = {
	  idcExplain: function idcExplain(idc) {
	    return IDC_EXPLAIN[idc] ? IDC_EXPLAIN[idc] : idc;
	  },
	  timeFormat: function timeFormat(val) {
	    var date = new Date(val);
	    var Y = date.getFullYear() + '-';
	    var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
	    var D = (Array(2).join(0) + date.getDate()).slice(-2) + ' ';
	    var h = (Array(2).join(0) + date.getHours()).slice(-2) + ':';
	    var m = (Array(2).join(0) + date.getMinutes()).slice(-2) + ':';
	    var s = (Array(2).join(0) + date.getSeconds()).slice(-2);
	    return Y + M + D + h + m + s;
	  },
	  switchColor: function switchColor(val) {
	    return COLOR_EXPLAIN[val] ? COLOR_EXPLAIN[val] : '#FA5555';
	  },
	  statusExplain: function statusExplain(val) {
	    return STATUS_EXPLAIN[val] ? STATUS_EXPLAIN[val] : '无效状态';
	  }
	};

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(119)('wks');
	var uid = __webpack_require__(89);
	var Symbol = __webpack_require__(17).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	if (true) {
	  module.exports = __webpack_require__(661)
	} else {
	  module.exports = require('./vue.common.dev.js')
	}


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _required = __webpack_require__(135);
	
	var _required2 = _interopRequireDefault(_required);
	
	var _whitespace = __webpack_require__(191);
	
	var _whitespace2 = _interopRequireDefault(_whitespace);
	
	var _type = __webpack_require__(190);
	
	var _type2 = _interopRequireDefault(_type);
	
	var _range = __webpack_require__(189);
	
	var _range2 = _interopRequireDefault(_range);
	
	var _enum = __webpack_require__(187);
	
	var _enum2 = _interopRequireDefault(_enum);
	
	var _pattern = __webpack_require__(188);
	
	var _pattern2 = _interopRequireDefault(_pattern);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = {
	  required: _required2['default'],
	  whitespace: _whitespace2['default'],
	  type: _type2['default'],
	  range: _range2['default'],
	  'enum': _enum2['default'],
	  pattern: _pattern2['default']
	};
	module.exports = exports['default'];

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _regenerator = __webpack_require__(40);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(39);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _entries = __webpack_require__(63);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _from = __webpack_require__(43);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _promise = __webpack_require__(35);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _assign = __webpack_require__(26);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getIterator2 = __webpack_require__(62);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _getOwnPropertyDescriptor = __webpack_require__(23);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getOwnPropertySymbols = __webpack_require__(16);
	
	var _getOwnPropertySymbols2 = _interopRequireDefault(_getOwnPropertySymbols);
	
	var _keys = __webpack_require__(13);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _defineProperty3 = __webpack_require__(15);
	
	var _defineProperty4 = _interopRequireDefault(_defineProperty3);
	
	var _slicedToArray2 = __webpack_require__(65);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _classCallCheck2 = __webpack_require__(7);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(10);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _defineProperty5 = __webpack_require__(44);
	
	var _defineProperty6 = _interopRequireDefault(_defineProperty5);
	
	var _typeof2 = __webpack_require__(8);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault(ex) {
	  return ex && (typeof ex === 'undefined' ? 'undefined' : (0, _typeof3.default)(ex)) === 'object' && 'default' in ex ? ex['default'] : ex;
	}
	
	var prosemirrorState = __webpack_require__(6);
	var prosemirrorModel = __webpack_require__(12);
	var preact = __webpack_require__(24);
	var classNames = _interopDefault(__webpack_require__(49));
	var index_ts = __webpack_require__(96);
	var throttle = _interopDefault(__webpack_require__(78));
	
	function getContentWidth($elem) {
	  var computedStyle = window.getComputedStyle($elem);
	  var width = +computedStyle.width.replace('px', '');
	  var paddingLeft = +computedStyle.paddingLeft.replace('px', '');
	  var paddingRight = +computedStyle.paddingRight.replace('px', '');
	  return width - paddingLeft - paddingRight;
	}
	
	function findParentNode(path, assert) {
	  for (var i = path.length - 1; i >= 0; i--) {
	    if (assert(path[i])) {
	      return {
	        node: path[i],
	        pos: path[i - 1]
	      };
	    }
	  }
	
	  return null;
	}
	
	var findParentDOM = function findParentDOM(targetDOM, assert) {
	  var dom = targetDOM;
	
	  while (true) {
	    if (!dom || dom.classList && dom.classList.contains('ProseMirror')) return false;
	    if (assert(dom)) return dom;
	    dom = dom.parentNode;
	  }
	};
	
	var findParentBlockNode = function findParentBlockNode(targetDOM) {
	  var dom = targetDOM.parentNode;
	  var flag = 0;
	
	  while (flag < 40) {
	    if (!dom || dom.classList && dom.classList.contains('ProseMirror')) return false;
	    if (['block', 'flex'].includes(getComputedStyle(dom).display)) return dom;
	    dom = dom.parentNode;
	    flag++;
	  }
	};
	
	function setBetweenAttrs(from, to, tr, assert, attrsGetter) {
	  tr.doc.nodesBetween(from, to, function (node, pos, parent) {
	    if (assert(node, pos, parent)) {
	      var newAttrs = attrsGetter(node.attrs);
	
	      try {
	        tr.setNodeMarkup(pos, null, newAttrs);
	      } catch (error) {
	        console.error(error);
	      }
	    }
	  });
	}
	function getInsertBlockSlice(state, node) {
	  var schema = state.schema,
	      selection = state.selection,
	      doc = state.doc;
	  var paragraph = schema.nodes.paragraph;
	  var $from = selection.$from,
	      $to = selection.$to,
	      to = selection.to;
	
	  var beforeNode = $from.nodeBefore;
	  var afterNode = $to.nodeAfter;
	  var fromNodeGrandParent = $from.node(-1);
	  var fromNodeParent = $from.node();
	
	  if ((!beforeNode || !beforeNode.isText && !beforeNode.isTextblock && !beforeNode.isInline) && (!afterNode || !afterNode.isText && !afterNode.isTextblock && !afterNode.isInline)) {
	    var nodes = [node, paragraph.create()];
	
	    var isInTail = to === doc.content.size - 1 || (fromNodeGrandParent && fromNodeGrandParent.lastChild) === fromNodeParent;
	    if (isInTail) return new prosemirrorModel.Slice(prosemirrorModel.Fragment.from(nodes), 0, 0);
	
	    var nextBlockNode = to < doc.content.size ? doc.nodeAt(to + 1) : null;
	
	    if (nextBlockNode && !nextBlockNode.isTextblock && !nextBlockNode.isText) {
	      return new prosemirrorModel.Slice(prosemirrorModel.Fragment.from(nodes), 0, 0);
	    }
	  }
	
	  return new prosemirrorModel.Slice(prosemirrorModel.Fragment.from([node]), 0, 0);
	}
	
	function insertBlock(state, node, headNoSpace) {
	  var tr = state.tr,
	      schema = state.schema,
	      selection = state.selection;
	  var _schema$nodes = schema.nodes,
	      table = _schema$nodes.table,
	      code_block = _schema$nodes.code_block,
	      status = _schema$nodes.status,
	      note = _schema$nodes.note,
	      note_title = _schema$nodes.note_title,
	      collapse_title = _schema$nodes.collapse_title;
	  var to = selection.to,
	      $from = selection.$from;
	
	  var nodeBefore = $from.nodeBefore;
	
	  var parentNode = $from.parent;
	  var textBlocks = [code_block, status, note_title, collapse_title];
	
	  if (textBlocks.includes(parentNode.type)) return false;
	  var transaction = tr.setStoredMarks([]);
	
	  var slice = getInsertBlockSlice(state, node, headNoSpace);
	  transaction = transaction.replaceSelection(slice);
	
	  var newPos = nodeBefore ? 2 : 0;
	  newPos = selection.constructor.name === 'GapCursor' ? to : to + newPos;
	
	  if (node.type.isLeaf) {
	    newPos += 1;
	  } else if (node.type === note) {
	    newPos += 4;
	  } else if (node.type === table) {
	    newPos += 3;
	  }
	
	  transaction = transaction.setSelection(prosemirrorState.TextSelection.create(transaction.doc, newPos));
	  return {
	    transaction: transaction,
	    newPos: newPos
	  };
	}
	
	function canInsertTypes(state) {
	  var schema = state.schema,
	      selection = state.selection;
	  var $from = selection.$from;
	  var _schema$nodes2 = schema.nodes,
	      status = _schema$nodes2.status,
	      code_block = _schema$nodes2.code_block,
	      note_title = _schema$nodes2.note_title,
	      collapse_title = _schema$nodes2.collapse_title;
	
	  var parentNode = $from.parent;
	  var texBlocks = [status, code_block, note_title, collapse_title];
	
	  return !texBlocks.includes(parentNode.type);
	}
	
	var isChild = function isChild(child, parent) {
	  var is = false;
	
	  var dfs = function dfs(node) {
	    if (is) return;
	    var content = node.content.content;
	
	    for (var i = 0; i < content.length; i++) {
	      var n = content[i];
	
	      if (n === child) {
	        is = true;
	        break;
	      }
	
	      dfs(n);
	    }
	  };
	
	  dfs(parent);
	  return is;
	};
	
	var getBlockNode = function getBlockNode(state, from, to) {
	  var tr = state.tr,
	      selection = state.selection;
	
	  var fromParentNode = selection.$from.node(-1);
	  var newFrom = from < 0 ? 0 : from;
	  var newTo = to > tr.doc.content.size ? tr.doc.content.size : to;
	  var is = null;
	  tr.doc.nodesBetween(newFrom, newTo, function (node) {
	    var nodeType = node.type;
	    if (nodeType && nodeType.spec.insertBlock && !isChild(fromParentNode, node)) is = node;
	    return !is;
	  });
	  return is;
	};
	
	function styleInject(css, ref) {
	  if (ref === void 0) ref = {};
	  var insertAt = ref.insertAt;
	
	  if (!css || typeof document === 'undefined') {
	    return;
	  }
	
	  var head = document.head || document.getElementsByTagName('head')[0];
	  var style = document.createElement('style');
	  style.type = 'text/css';
	
	  if (insertAt === 'top') {
	    if (head.firstChild) {
	      head.insertBefore(style, head.firstChild);
	    } else {
	      head.appendChild(style);
	    }
	  } else {
	    head.appendChild(style);
	  }
	
	  if (style.styleSheet) {
	    style.styleSheet.cssText = css;
	  } else {
	    style.appendChild(document.createTextNode(css));
	  }
	}
	
	var css = ".ct-toastr{position:relative;display:flex;flex-direction:row;flex-wrap:wrap;background:#fff;border-radius:4px;box-shadow:0 4px 12px rgba(0,0,0,.15);padding:10px;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;left:50%;top:55px;-webkit-transform:translateX(-50%);transform:translateX(-50%);z-index:9000}.ct-toastr .ct-toastr-success{margin-right:10px;width:16px;height:16px;background:url(\"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTYuOTQgOC44NjVMNC44MDEgNi43MjhhMS4yMDMgMS4yMDMgMCAwIDAtMS42OTQuMDAzIDEuMTk1IDEuMTk1IDAgMCAwLS4wMDMgMS42OTRMNi4wOCAxMS40Yy4yMzUuMjM1LjU0OC4zNTEuODYxLjM0Ny4zMTIuMDA0LjYyNC0uMTEzLjg2MS0uMzVMMTIuODk4IDYuM2ExLjIwMyAxLjIwMyAwIDAgMC0uMDAyLTEuNjk0IDEuMTk1IDEuMTk1IDAgMCAwLTEuNjk1LS4wMDNMNi45NCA4Ljg2NXpNMTYgOGMwIDEuNDUxLS4zNTggMi43OS0xLjA3MyA0LjAxNmE3Ljk2NCA3Ljk2NCAwIDAgMS0yLjkxMSAyLjkxMUE3LjgyNiA3LjgyNiAwIDAgMSA4IDE2YTcuODI2IDcuODI2IDAgMCAxLTQuMDE2LTEuMDczIDcuOTY0IDcuOTY0IDAgMCAxLTIuOTExLTIuOTExQTcuODI2IDcuODI2IDAgMCAxIDAgOGMwLTEuNDUxLjM1OC0yLjc5IDEuMDczLTQuMDE2YTcuOTY0IDcuOTY0IDAgMCAxIDIuOTExLTIuOTExQTcuODI2IDcuODI2IDAgMCAxIDggMGMxLjQ1MSAwIDIuNzkuMzU4IDQuMDE2IDEuMDczYTcuOTY0IDcuOTY0IDAgMCAxIDIuOTExIDIuOTExQTcuODI2IDcuODI2IDAgMCAxIDE2IDh6IiBmaWxsPSIjNzBCMTIzIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=\") no-repeat 0}.ct-toastr .ct-toastr-error{margin-right:10px;width:16px;height:16px;background:url(\"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTggMGE4IDggMCAxIDEgMCAxNkE4IDggMCAwIDEgOCAwek0zLjIgOGMwIC42NjcuNTM2IDEuMiAxLjE5NiAxLjJoNy4yMDhjLjY1MiAwIDEuMTk2LS41MzcgMS4xOTYtMS4yIDAtLjY2Ny0uNTM2LTEuMi0xLjE5Ni0xLjJINC4zOTZDMy43NDQgNi44IDMuMiA3LjMzNyAzLjIgOHoiIGZpbGw9IiNGMDVFNTAiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==\") no-repeat 0}";
	styleInject(css);
	
	var uuid = function uuid() {
	  var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".split("");
	  var id = [];
	
	  for (var i = 0; i < 8; i++) {
	    id.push(chars[parseInt('' + Math.random() * chars.length, 10)]);
	  }
	
	  return id.join("");
	};
	
	var createContainer = function createContainer() {
	  var dom = document.createElement('div');
	  dom.setAttribute('class', 'ct-toast-container');
	  dom.setAttribute('style', 'position:absolute;top:0;left:0;width:100%');
	  document.body.appendChild(dom);
	  return dom;
	};
	
	var clearToast = function clearToast(id, container, delay) {
	  setTimeout(function () {
	    var dom = document.querySelector('#' + id);
	    if (!dom) return;
	    preact.render(null, container, dom);
	  }, delay * 1000);
	};
	
	var ToastrContent = function ToastrContent(props) {
	  return preact.h("div", {
	    className: "ct-toastr",
	    id: props.id
	  }, preact.h("div", {
	    className: classNames((0, _defineProperty6.default)({}, 'ct-toastr-' + props.type, true))
	  }), preact.h("span", null, props.text));
	};
	
	var Toastr = function () {
	  function Toastr() {
	    (0, _classCallCheck3.default)(this, Toastr);
	  }
	
	  (0, _createClass3.default)(Toastr, null, [{
	    key: 'success',
	    value: function success(str) {
	      var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1.5;
	
	      var dom = document.querySelector('.ct-toast-container');
	      if (!dom) dom = createContainer();
	      var id = uuid();
	      preact.render(preact.h(ToastrContent, {
	        id: id,
	        type: "success",
	        text: str
	      }), dom);
	      clearToast(id, dom, delay);
	    }
	  }, {
	    key: 'error',
	    value: function error(str) {
	      var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1.5;
	
	      var dom = document.querySelector('.ct-toast-container');
	      if (!dom) dom = createContainer();
	      var id = uuid();
	      preact.render(preact.h(ToastrContent, {
	        id: id,
	        type: "error",
	        text: str
	      }), dom);
	      clearToast(id, dom, delay);
	    }
	  }]);
	  return Toastr;
	}();
	
	var config = window.__CLIENT_CONFIG__ || {};
	
	function getSystemInfo() {
	  var nVer = navigator.appVersion;
	  var nAgt = navigator.userAgent;
	  var browser = navigator.appName;
	  var version = '' + parseFloat(navigator.appVersion);
	  var nameOffset = void 0,
	      verOffset = void 0,
	      ix = void 0;
	  var isMobile = nAgt.toLowerCase().indexOf("mobile") !== -1;
	
	  if ((verOffset = nAgt.indexOf("Opera")) !== -1) {
	    browser = "Opera";
	    version = nAgt.substring(verOffset + 6);
	
	    if ((verOffset = nAgt.indexOf("Version")) !== -1) {
	      version = nAgt.substring(verOffset + 8);
	    }
	  }
	
	  if ((verOffset = nAgt.indexOf("OPR")) !== -1) {
	    browser = "Opera";
	    version = nAgt.substring(verOffset + 4);
	  } else if ((verOffset = nAgt.indexOf("Edge")) !== -1) {
	    browser = "Microsoft Edge";
	    version = nAgt.substring(verOffset + 5);
	  } else if ((verOffset = nAgt.indexOf("MSIE")) !== -1) {
	    browser = "Microsoft Internet Explorer";
	    version = nAgt.substring(verOffset + 5);
	  } else if ((verOffset = nAgt.indexOf("Chrome")) !== -1) {
	    browser = "Chrome";
	    version = nAgt.substring(verOffset + 7);
	  } else if ((verOffset = nAgt.indexOf("Safari")) !== -1) {
	    browser = "Safari";
	    version = nAgt.substring(verOffset + 7);
	
	    if ((verOffset = nAgt.indexOf("Version")) !== -1) {
	      version = nAgt.substring(verOffset + 8);
	    }
	  } else if ((verOffset = nAgt.indexOf("Firefox")) !== -1) {
	    browser = "Firefox";
	    version = nAgt.substring(verOffset + 8);
	  } else if (nAgt.indexOf("Trident/") !== -1) {
	    browser = "Microsoft Internet Explorer";
	    version = nAgt.substring(nAgt.indexOf("rv:") + 3);
	  } else if ((nameOffset = nAgt.lastIndexOf(" ") + 1) < (verOffset = nAgt.lastIndexOf("/"))) {
	    browser = nAgt.substring(nameOffset, verOffset);
	    version = nAgt.substring(verOffset + 1);
	
	    if (browser.toLowerCase() === browser.toUpperCase()) {
	      browser = navigator.appName;
	    }
	  }
	
	  if ((ix = version.indexOf(";")) !== -1) {
	    version = version.substring(0, ix);
	  }
	
	  if ((ix = version.indexOf(" ")) !== -1) {
	    version = version.substring(0, ix);
	  }
	
	  if ((ix = version.indexOf(")")) !== -1) {
	    version = version.substring(0, ix);
	  }
	
	  var os = "unknown";
	  var clientStrings = [{
	    s: "Windows 10",
	    r: /(Windows 10.0|Windows NT 10.0)/
	  }, {
	    s: "Windows 8.1",
	    r: /(Windows 8.1|Windows NT 6.3)/
	  }, {
	    s: "Windows 8",
	    r: /(Windows 8|Windows NT 6.2)/
	  }, {
	    s: "Windows 7",
	    r: /(Windows 7|Windows NT 6.1)/
	  }, {
	    s: "Windows Vista",
	    r: /Windows NT 6.0/
	  }, {
	    s: "Windows Server 2003",
	    r: /Windows NT 5.2/
	  }, {
	    s: "Windows XP",
	    r: /(Windows NT 5.1|Windows XP)/
	  }, {
	    s: "Windows 2000",
	    r: /(Windows NT 5.0|Windows 2000)/
	  }, {
	    s: "Windows ME",
	    r: /(Win 9x 4.90|Windows ME)/
	  }, {
	    s: "Windows 98",
	    r: /(Windows 98|Win98)/
	  }, {
	    s: "Windows 95",
	    r: /(Windows 95|Win95|Windows_95)/
	  }, {
	    s: "Windows NT 4.0",
	    r: /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/
	  }, {
	    s: "Windows CE",
	    r: /Windows CE/
	  }, {
	    s: "Windows 3.11",
	    r: /Win16/
	  }, {
	    s: "Android",
	    r: /Android/
	  }, {
	    s: "Open BSD",
	    r: /OpenBSD/
	  }, {
	    s: "Sun OS",
	    r: /SunOS/
	  }, {
	    s: "Linux",
	    r: /(Linux|X11)/
	  }, {
	    s: "iOS",
	    r: /(iPhone|iPad|iPod)/
	  }, {
	    s: "Mac OS X",
	    r: /Mac OS X/
	  }, {
	    s: "Mac OS",
	    r: /(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/
	  }, {
	    s: "QNX",
	    r: /QNX/
	  }, {
	    s: "UNIX",
	    r: /UNIX/
	  }, {
	    s: "BeOS",
	    r: /BeOS/
	  }, {
	    s: "OS/2",
	    r: /OS\/2/
	  }, {
	    s: "Search Bot",
	    r: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/
	  }];
	
	  for (var id in clientStrings) {
	    var cs = clientStrings[id];
	
	    if (cs.r.test(nAgt)) {
	      os = cs.s;
	      break;
	    }
	  }
	
	  var osVersion = "unknown";
	
	  if (/Windows/.test(os)) {
	    osVersion = /Windows (.*)/.exec(os)[1];
	    os = "Windows";
	  }
	
	  switch (os) {
	    case "Mac OS X":
	      osVersion = /Mac OS X (10[._\d]+)/.exec(nAgt)[1];
	      break;
	
	    case "Android":
	      osVersion = /Android ([._\d]+)/.exec(nAgt)[1];
	      break;
	
	    case "iOS":
	      osVersion = /OS (\d+)_(\d+)_?(\d+)?/.exec(nVer);
	      osVersion = osVersion[1] + '.' + osVersion[2] + '.' + (osVersion[3] | 0);
	      break;
	
	    default:
	      break;
	  }
	
	  return {
	    browser: browser || "unknown",
	    browserVersion: version || "unknown",
	    os: os || "unknown",
	    osVersion: osVersion || "unknown",
	    isMobile: isMobile
	  };
	}
	
	function isPrintableKey(evt) {
	  var key = evt.which || evt.keyCode;
	  return !(evt.altKey || evt.ctrlKey || evt.metaKey || evt.shiftKey) && (key === 32 || key >= 48 && key <= 57 || key >= 65 && key <= 90 || key >= 96 && key <= 105 || key === 106 || key >= 186 && key <= 192 || key >= 219 || key <= 222);
	}
	
	function compute(origin) {
	  if (origin >= 1024 * 1024) {
	    return (origin / (1024 * 1024)).toFixed(2) + 'MB';
	  } else if (origin >= 1024) {
	    return (origin / 1024).toFixed(2) + 'KB';
	  }
	
	  return (origin || 0) + 'B';
	}
	
	var getTargetLeft = function getTargetLeft(target) {
	  var left = 0;
	  var dom = target;
	
	  while (dom != null) {
	    var offsetParent = dom.offsetParent;
	    var parent = dom.parentNode;
	    left += dom.offsetLeft - dom.scrollLeft;
	
	    while (parent && parent !== offsetParent) {
	      var pOffsetLeft = parent.scrollLeft;
	
	      if (pOffsetLeft) {
	        left -= pOffsetLeft;
	      }
	
	      parent = parent.parentNode;
	    }
	
	    dom = offsetParent;
	  }
	
	  return left;
	};
	
	var checkConfig = function checkConfig(config, rule) {
	  for (var key in rule) {
	    var value = config[key];
	    var type = rule[key];
	
	    if (!value) {
	      throw new TypeError('Missing configuration item ' + key);
	    }
	
	    if (typeof type === "string") {
	      if (Object.prototype.toString.call(value).slice(8, -1) !== rule[key]) {
	        throw new TypeError('Configuration item ' + key + ' type must be ' + rule[key]);
	      }
	    } else if (!(value instanceof type)) {
	      throw new TypeError('Configuration item ' + key + ' type must be ' + rule[key]);
	    }
	  }
	};
	
	function uuid$1() {
	  var chars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".split("");
	  var id = [];
	
	  for (var i = 0; i < 8; i++) {
	    id.push(chars[parseInt('' + Math.random() * chars.length, 10)]);
	  }
	
	  return id.join("");
	}
	var getSizeFromSvg = function getSizeFromSvg(svgStr) {
	  var width = 0;
	  var height = 0;
	  var widthRes = svgStr.match(/width="([^"]+)"/);
	  var heightRes = svgStr.match(/height="([^"]+)"/);
	
	  if (widthRes && heightRes) {
	    width = parseInt(widthRes[1], 10);
	    height = parseInt(heightRes[1], 10);
	  }
	
	  if (!width || !height) {
	    var viewBox = svgStr.match(/viewBox="([^'"]*)"/);
	    var sizeStr = viewBox ? viewBox[1] : "0, 0";
	    var sizes = sizeStr.match(/\d+/g);
	    height = +sizes.pop();
	    width = +sizes.pop();
	  }
	
	  return {
	    width: width,
	    height: height
	  };
	};
	
	var fixSvgScale = function fixSvgScale(svgStr) {
	  return svgStr.replace(/width="[^'"]+"/, 'width="100%"').replace(/height="[^"']+"/, "");
	};
	
	function fixSvgRatio(_ref) {
	  var svgStr = _ref.svgStr,
	      width = _ref.width,
	      height = _ref.height;
	
	  svgStr = svgStr.slice(4);
	  var prefix = "<svg ";
	
	  if (!width || !height) {
	    var sizeInfo = getSizeFromSvg(svgStr);
	    width = sizeInfo.width;
	    height = sizeInfo.height;
	  }
	
	  if (!svgStr.includes("xMidYMid slice")) {
	    prefix += 'preserveAspectRatio="xMidYMid slice" ';
	  }
	
	  if (!svgStr.includes("viewBox")) {
	    prefix += 'viewBox="0, 0, ' + width + ', ' + height + '"';
	  } else {
	    svgStr = svgStr.replace(/viewBox="[^"]+"/, 'viewBox="0, 0, ' + width + ', ' + height + '"');
	  }
	
	  return prefix + fixSvgScale(svgStr);
	}
	
	
	function getSvgSizeAfterEdit(_ref2) {
	  var displayWidth = _ref2.displayWidth,
	      newSvgStr = _ref2.newSvgStr,
	      hadResize = _ref2.hadResize,
	      _ref2$formatted = _ref2.formatted,
	      formatted = _ref2$formatted === undefined ? false : _ref2$formatted;
	
	  var _getSizeFromSvg = getSizeFromSvg(newSvgStr),
	      newWidth = _getSizeFromSvg.width,
	      newHeight = _getSizeFromSvg.height;
	
	  if (!hadResize) {
	    return undefined;
	  }
	
	  var scale = displayWidth / newWidth;
	  var width = displayWidth;
	  var height = newHeight * scale;
	
	  if (formatted) {
	    width = width + 'px';
	    height = height + 'px';
	  }
	
	  return {
	    width: width,
	    height: height
	  };
	}
	
	function getDynamicSrc(url) {
	  var href = window.location.href;
	  var isNewContent = ['production'].includes(config.env) ? href.includes('create') : config.env;
	
	  if (url.includes('api/file/cdn')) {
	    url += '&isNewContent=' + isNewContent;
	    if (href.includes('template') && !href.includes('create') && !url.includes('template')) url += '&template=1';
	    return url;
	  }
	
	  var urlReg = /^https:\/\/km.*\.meituan\.net.*contentId=(\d+)&attachmentId=(\d+).*&contentType=(\d)/i;
	
	  var _urlReg$exec = urlReg.exec(url),
	      _urlReg$exec2 = (0, _slicedToArray3.default)(_urlReg$exec, 4),
	      _ = _urlReg$exec2[0],
	      contentId = _urlReg$exec2[1],
	      attachmentId = _urlReg$exec2[2],
	      contentType = _urlReg$exec2[3];
	
	  return window.location.origin + '/api/file/cdn/' + contentId + '/' + attachmentId + '?contentType=' + contentType + '&isNewContent=' + isNewContent;
	}
	
	var mobileCopyToClipboard = function mobileCopyToClipboard(content, successStr, event) {
	  var clip = new ClipBoard('.btn', {
	    text: function text() {
	      return content;
	    }
	  });
	  clip.on('success', function (e) {
	    Toast.info(successStr || '复制成功');
	    e.clearSelection();
	  });
	  clip.on('error', function (err) {
	    Toast.info('当前浏览器不支持快捷复制,请手动复制');
	    console.error(err);
	  });
	  clip.onClick(event);
	  clip.destroy();
	};
	
	var copyToClipboard = function copyToClipboard(content, successStr) {
	  var inputEle = document.createElement('input');
	  inputEle.value = content;
	  document.body.appendChild(inputEle);
	  inputEle.select();
	
	  try {
	    document.execCommand('Copy');
	    Toastr.success(successStr || '复制成功');
	  } catch (err) {
	    Toastr.success('当前浏览器不支持快捷复制,请手动复制');
	    console.error(err);
	  }
	
	  document.body.removeChild(inputEle);
	};
	
	function handleBackspaceCreator(nodeTypeName, titleNodeTypeName, contentNodeTypeName) {
	  return function handleBackspace(state, dispatch) {
	    var tr = state.tr,
	        schema = state.schema,
	        selection = state.selection;
	    var paragraph = schema.nodes.paragraph;
	
	    var note = schema.nodes[nodeTypeName];
	    var note_title = schema.nodes[titleNodeTypeName];
	    var note_content = schema.nodes[contentNodeTypeName];
	    var $cursor = selection.$cursor,
	        $from = selection.$from,
	        $to = selection.$to,
	        from = selection.from,
	        to = selection.to;
	
	
	    var assert1 = function assert1(node) {
	      return node.type === note;
	    };
	
	    var assert2 = function assert2(node) {
	      return node.type === note_title;
	    };
	
	    var assert3 = function assert3(node) {
	      return node.type === note_content;
	    };
	
	    if ($cursor) {
	      var parentType = $cursor.parent.type;
	      var plus = parentType.isInline ? 2 : 1;
	      var contentNode = $cursor.node(-plus);
	
	      if (!$cursor.nodeBefore && (parentType === note_title || parentType === note_content || contentNode && contentNode.type === note_content && contentNode.firstChild === $cursor.node(-plus + 1))) {
	        return true;
	      }
	    } else {
	      var fromNoteNode = findParentNode($from.path, assert1);
	      var toNoteNode = findParentNode($to.path, assert1);
	
	      if (fromNoteNode && toNoteNode && fromNoteNode.pos !== toNoteNode.pos || !fromNoteNode && toNoteNode || fromNoteNode && !toNoteNode) {
	        var newFrom = from;
	        var newTo = to;
	        if (fromNoteNode) newFrom = fromNoteNode.pos;
	        if (toNoteNode) newTo = toNoteNode.pos + toNoteNode.node.nodeSize;
	        dispatch(tr.delete(newFrom, newTo));
	        return true;
	      } else if (fromNoteNode) {
	        var noteNode = fromNoteNode.node;
	        var fromNoteTitleNode = findParentNode($from.path, assert2);
	        var toNoteContentNode = findParentNode($to.path, assert3);
	
	        if (fromNoteTitleNode && toNoteContentNode && noteNode.firstChild === fromNoteTitleNode.node && noteNode.lastChild === toNoteContentNode.node) {
	          var end = fromNoteTitleNode.pos + fromNoteTitleNode.node.nodeSize - 1;
	          var dis = end - from;
	          tr.delete(from, end);
	          tr.delete(toNoteContentNode.pos - dis, to - dis);
	          tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, from));
	          dispatch(tr);
	          return true;
	        }
	
	        if (toNoteContentNode && from - toNoteContentNode.pos < 3 && toNoteContentNode.pos + toNoteContentNode.node.nodeSize - to < 3) {
	          var start = toNoteContentNode.pos + 1;
	          var _end = toNoteContentNode.pos + toNoteContentNode.node.nodeSize - 1;
	          tr.replaceWith(start, _end, paragraph.create());
	          tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, from));
	          dispatch(tr);
	          return true;
	        }
	      }
	    }
	
	    return false;
	  };
	}
	function handleDeleteCreator(nodeTypeName, titleNodeTypeName, contentNodeTypeName) {
	  return function handleDelete(state, dispatch) {
	    var tr = state.tr,
	        schema = state.schema,
	        selection = state.selection;
	
	    var note = schema.nodes[nodeTypeName];
	    var note_title = schema.nodes[titleNodeTypeName];
	    var note_content = schema.nodes[contentNodeTypeName];
	    var $cursor = selection.$cursor,
	        $from = selection.$from,
	        $to = selection.$to,
	        from = selection.from,
	        to = selection.to;
	
	
	    var assert1 = function assert1(node) {
	      return node.type === note;
	    };
	
	    var assert2 = function assert2(node) {
	      return node.type === note_title;
	    };
	
	    var assert3 = function assert3(node) {
	      return node.type === note_content;
	    };
	
	    if ($cursor) {
	      var parentType = $cursor.parent.type;
	      var plus = parentType.isInline ? 2 : 1;
	
	      if (!$cursor.nodeAfter && ($cursor.parent.type === note_title || $cursor.node(-plus).type === note_content)) {
	        return true;
	      }
	    } else {
	      var fromNoteNode = findParentNode($from.path, assert1);
	      var toNoteNode = findParentNode($to.path, assert1);
	
	      if (fromNoteNode && toNoteNode && fromNoteNode.pos !== toNoteNode.pos || !fromNoteNode && toNoteNode || fromNoteNode && !toNoteNode) {
	        var newFrom = from;
	        var newTo = to;
	        if (fromNoteNode) newFrom = fromNoteNode.pos;
	        if (toNoteNode) newTo = toNoteNode.pos + toNoteNode.node.nodeSize;
	        dispatch(tr.delete(newFrom, newTo));
	        return true;
	      }
	
	      var fromNoteTitleNode = findParentNode($from.path, assert2);
	      var toNoteContentNode = findParentNode($to.path, assert3);
	
	      if (fromNoteTitleNode && toNoteContentNode) {
	        var end = fromNoteTitleNode.pos + fromNoteTitleNode.node.nodeSize - 1;
	        var dis = end - from;
	        tr.delete(from, end);
	        tr.delete(toNoteContentNode.pos - dis, to - dis);
	        tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, from));
	        dispatch(tr);
	        return true;
	      }
	
	      if (toNoteContentNode && toNoteContentNode.pos + 1 === from && toNoteContentNode.pos + toNoteContentNode.node.nodeSize - 1 === to) {
	        tr.delete(from + 1, to - 1);
	        tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, from));
	        dispatch(tr);
	        return true;
	      }
	    }
	
	    return false;
	  };
	}
	function handleTabCreator(nodeTypeName, titleNodeTypeName, contentNodeTypeName) {
	  return function handleTab(state, dispatch) {
	    var tr = state.tr,
	        schema = state.schema,
	        selection = state.selection;
	
	    var note_title = schema.nodes[titleNodeTypeName];
	    var $from = selection.$from;
	
	
	    var assert = function assert(node) {
	      return node.type === note_title;
	    };
	
	    var foundNode = findParentNode($from.path, assert);
	
	    if (foundNode) {
	      tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, foundNode.pos + foundNode.node.nodeSize + 2));
	      dispatch(tr);
	      return true;
	    }
	
	    return false;
	  };
	}
	function handleEnterCreator(nodeTypeName, titleNodeTypeName, contentNodeTypeName) {
	  return function handleEnter(state, dispatch, view) {
	    var tr = state.tr,
	        schema = state.schema,
	        selection = state.selection;
	    var $from = selection.$from;
	
	    var note_title = schema.nodes[titleNodeTypeName];
	    var foundNode = findParentNode($from.path, function (node) {
	      return node.type === note_title;
	    });
	
	    if (foundNode) {
	      var node = foundNode.node,
	          pos = foundNode.pos;
	
	      var newSelection = prosemirrorState.TextSelection.create(tr.doc, pos + node.nodeSize + 1);
	      dispatch(tr.setSelection(newSelection));
	      view.focus();
	      return true;
	    }
	
	    return false;
	  };
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    (0, _defineProperty4.default)(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	var defineProperty = _defineProperty;
	
	function _objectSpread(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? arguments[i] : {};
	    var ownKeys = (0, _keys2.default)(source);
	
	    if (typeof _getOwnPropertySymbols2.default === 'function') {
	      ownKeys = ownKeys.concat((0, _getOwnPropertySymbols2.default)(source).filter(function (sym) {
	        return (0, _getOwnPropertyDescriptor2.default)(source, sym).enumerable;
	      }));
	    }
	
	    ownKeys.forEach(function (key) {
	      defineProperty(target, key, source[key]);
	    });
	  }
	
	  return target;
	}
	
	var objectSpread = _objectSpread;
	
	var uploadHelper = function uploadHelper(config) {
	  var preUpload = function preUpload() {
	    return '';
	  };
	
	  var onProgress = function onProgress() {
	    return null;
	  };
	
	  var finishUpload = function finishUpload() {};
	
	  var suffixes = config.suffixes,
	      limitSize = config.limitSize,
	      onSuffixError = config.onSuffixError,
	      onSizeError = config.onSizeError;
	
	
	  var setter = function setter(files) {
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = (0, _getIterator3.default)(files), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var file = _step.value;
	
	        if (suffixes && !checkSuffix(file.name, suffixes)) {
	          if (onSuffixError) onSuffixError(file.name);
	          continue;
	        }
	
	        if (limitSize && file.size / (1024 * 1024) > limitSize) {
	          if (onSizeError) onSizeError(file.size);
	          continue;
	        }
	
	        doUpload(file, config, {
	          preUpload: preUpload,
	          onProgress: onProgress,
	          finishUpload: finishUpload
	        });
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	  };
	
	  var getter = function getter(pre, on, finish) {
	    preUpload = pre;
	    onProgress = on;
	    finishUpload = finish;
	    return setter;
	  };
	
	  return [getter, setter];
	};
	
	var checkSuffix = function checkSuffix(name, suffixes) {
	  var temp = /\.[^.]+$/.exec(name);
	
	  if (temp) {
	    var suffix = temp[0].slice(1).toLowerCase();
	    return suffixes.findIndex(function (s) {
	      return suffix === s;
	    }) > -1;
	  }
	
	  return false;
	};
	
	var doUpload = function doUpload(file, config, hooks) {
	  var uploadUrl = config.uploadUrl,
	      onUploadError = config.onUploadError;
	  var preUpload = hooks.preUpload,
	      _onProgress = hooks.onProgress,
	      finishUpload = hooks.finishUpload;
	
	  var isImage = file.type.indexOf('image') > -1;
	  var key = preUpload({
	    file: file,
	    isImage: isImage
	  });
	  upload({
	    uploadUrl: uploadUrl,
	    onProgress: function onProgress(e) {
	      return _onProgress({
	        file: file,
	        isImage: isImage,
	        key: key
	      }, e);
	    },
	    addition: {}
	  }, file).then(function (res) {
	    finishUpload(objectSpread({
	      key: key,
	      res: res,
	      file: file,
	      isImage: isImage,
	      size: file.size
	    }, config));
	  }).catch(function (err) {
	    return onUploadError && onUploadError(err, key);
	  });
	};
	
	function upload() {
	  var conf = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var file = arguments[1];
	
	  var config = (0, _assign2.default)({}, defaultConf, conf);
	  var uploadUrl = config.uploadUrl,
	      addition = config.addition,
	      onProgress = config.onProgress;
	
	  var formData = fileFormBuilder(addition, file);
	  return uploadFile(uploadUrl, {
	    body: formData
	  }, onProgress);
	}
	
	var defaultConf = {
	  uploadUrl: '',
	  onProgress: function onProgress() {}
	};
	
	function fileFormBuilder() {
	  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var file = arguments[1];
	
	  var formData = new FormData();
	  var name = data.name || 'file';
	
	  if (data.filename) {
	    formData.append(name, file, data.filename);
	  } else {
	    formData.append(name, file);
	  }
	
	  (0, _keys2.default)(data).forEach(function (key) {
	    if (key !== 'name' && key !== 'filename') {
	      formData.append(key, data[key]);
	    }
	  });
	  return formData;
	}
	
	function uploadFile(url) {
	  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var onProgress = arguments[2];
	
	  return new _promise2.default(function (resolve, reject) {
	    var xhr = new XMLHttpRequest();
	    xhr.open('post', url);
	    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	
	    for (var k in opts.headers || {}) {
	      xhr.setRequestHeader(k, opts.headers[k]);
	    }
	
	    xhr.onload = function () {
	      if (xhr.status === 401 || xhr.message === 'auth failed') {
	        reject(xhr);
	      } else {
	        try {
	          resolve(JSON.parse(xhr.responseText));
	        } catch (error) {
	          resolve(xhr.responseText);
	        }
	      }
	    };
	
	    xhr.onerror = function () {
	      reject(xhr);
	    };
	
	    xhr.ontimeout = function () {
	      reject(xhr);
	    };
	
	    if (xhr.upload && onProgress) {
	      xhr.upload.onprogress = onProgress;
	    }
	
	    xhr.send(opts.body);
	  });
	}
	
	var PopoverStore = function () {
	  function PopoverStore() {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, PopoverStore);
	
	    this.view = null;
	    this.modules = null;
	    this.$scroll = null;
	    this.popover = null;
	    this.domNode = null;
	    this.isShow = false;
	    this.scrollTop = 0;
	
	    this.handleScroll = function () {
	      if (!_this.isShow) return;
	      var scrollTop = _this.$scroll.scrollTop;
	      _this.popover.style.top = parseFloat(_this.popover.style.top) + _this.scrollTop - scrollTop + 'px';
	      _this.scrollTop = scrollTop;
	    };
	  }
	
	  (0, _createClass3.default)(PopoverStore, [{
	    key: 'init',
	    value: function init(moduleManager) {
	      this.view = moduleManager.view;
	      this.$scroll = moduleManager.$scroll;
	      this.modules = moduleManager.modules;
	
	      if (this.$scroll.tagName === 'HTML') {
	        window.addEventListener('scroll', this.handleScroll);
	      } else {
	        this.$scroll.addEventListener('scroll', this.handleScroll);
	      }
	    }
	  }, {
	    key: 'onCreatePopover',
	    value: function onCreatePopover(popover) {
	      this.popover = popover;
	    }
	  }, {
	    key: 'onRemovePopover',
	    value: function onRemovePopover() {
	      this.hidePopover();
	
	      if (this.$scroll.tagName === 'HTML') {
	        window.removeEventListener('scroll', this.handleScroll);
	      } else {
	        this.$scroll.removeEventListener('scroll', this.handleScroll);
	      }
	    }
	  }, {
	    key: 'reShowPopover',
	    value: function reShowPopover() {
	      if (this.domNode) this.showPopover(this.domNode);
	    }
	  }, {
	    key: 'showPopover',
	    value: function showPopover(domNode) {
	      if (this.popover) {
	        this.popover.style.display = 'block';
	        this.domNode = domNode;
	        this.isShow = true;
	        this.scrollTop = this.$scroll.$scrollTop;
	      }
	    }
	  }, {
	    key: 'hidePopover',
	    value: function hidePopover() {
	      if (this.popover) {
	        this.popover.style.display = 'none';
	        this.isShow = false;
	      }
	    }
	  }]);
	  return PopoverStore;
	}();
	
	var createPlaceholder = function createPlaceholder(view, plugin, key, pos) {
	  var state = view.state,
	      dispatch = view.dispatch;
	
	  var placeholderPlugin = state.config.pluginsByKey[plugin];
	  dispatch(state.tr.setMeta(placeholderPlugin, {
	    add: {
	      key: key,
	      pos: pos
	    }
	  }).insertText('\u200B', pos).scrollIntoView());
	  view.focus();
	};
	var deletePlaceholder = function deletePlaceholder(view, plugin, key) {
	  var state = view.state,
	      dispatch = view.dispatch;
	
	  var placeholderPlugin = state.config.pluginsByKey[plugin];
	
	  try {
	    var transaction = state.tr.setMeta(placeholderPlugin, {
	      remove: {
	        key: key
	      }
	    });
	    dispatch(transaction);
	    view.focus();
	  } catch (err) {
	    console.error("placeholder maybe deleted", err);
	  }
	};
	var findPlaceholder = function findPlaceholder(view, plugin, key) {
	  var state = view.state;
	
	  var placeholderPlugin = state.config.pluginsByKey[plugin];
	  var found = placeholderPlugin.getState(state).find(null, null, function (spec) {
	    return spec.key === key;
	  });
	
	  if (found.length) {
	    return {
	      pos: found[0].from,
	      node: found[0].type.toDOM
	    };
	  }
	
	  return null;
	};
	
	var createShadowDOM = function createShadowDOM(_ref3) {
	  var dom = _ref3.dom,
	      content = _ref3.content;
	
	  if (!document.body.attachShadow) {
	    dom.innerHTML = content;
	    return;
	  }
	
	  var shadowWrapper = document.createElement("div");
	  shadowWrapper.setAttribute("class", index_ts.SHADOWDOM_CLASS);
	  var shadowRoot = shadowWrapper.attachShadow({
	    mode: "open"
	  });
	  shadowRoot.innerHTML = "<style>svg { width: 100%; height: 100%; } svg * { user-select: none }</style>";
	  shadowRoot.innerHTML += content;
	  dom.appendChild(shadowWrapper);
	};
	var getElementFromDOM = function getElementFromDOM(_ref4) {
	  var selector = _ref4.selector,
	      dom = _ref4.dom;
	
	  var shawdowWrapper = dom.querySelector('.' + index_ts.SHADOWDOM_CLASS);
	
	  if (shawdowWrapper && shawdowWrapper.shadowRoot) {
	    return shawdowWrapper.shadowRoot.querySelector(selector);
	  }
	
	  if (selector === "div") {
	    return dom;
	  }
	
	  return dom.querySelector(selector);
	};
	
	var DEFAULT_OPTIONS = {
	  method: "GET",
	  credentials: "include",
	  headers: {
	    "Cache-Control": "no-cache",
	    "X-Requested-With": "XMLHttpRequest"
	  }
	};
	var DEFAULT_TIMEOUT = 1e4;
	function advancedFetch(fetchPromise, timeout) {
	  var abortFn = function abortFn() {};
	
	  var abortPromise = new _promise2.default(function (resolve, reject) {
	    abortFn = function abortFn() {
	      reject(new Error("abort promise"));
	    };
	  });
	  var abortablePromise = _promise2.default.race([fetchPromise, abortPromise]);
	  var timer = setTimeout(function () {
	    abortFn();
	  }, timeout || DEFAULT_TIMEOUT);
	  return abortablePromise.then(function (data) {
	    clearTimeout(timer);
	    return data;
	  });
	}
	
	var text2JSON = function text2JSON(resText) {
	  var resJson = void 0;
	
	  try {
	    resJson = JSON.parse(resText);
	
	    if (resJson.status !== 0) {
	      var _resJson$data = resJson.data,
	          errorCode = _resJson$data.errorCode,
	          message = _resJson$data.message;
	
	      return _promise2.default.reject(console.error(errorCode, message));
	    }
	  } catch (err) {
	    return _promise2.default.resolve(resText);
	  }
	
	  if (resJson.data !== undefined) {
	    return _promise2.default.resolve(resJson.data);
	  }
	
	  return _promise2.default.resolve(resJson);
	};
	
	function transform(query) {
	  return (0, _keys2.default)(query).map(function (key) {
	    return key + '=' + query[key];
	  });
	}
	
	var send = function send(url, options) {
	  var isRedirect = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	  var timeout = arguments[3];
	
	  var fetchUrl = url;
	
	  if (options && options.query) {
	    fetchUrl += '?' + transform(options.query).join('&');
	  }
	
	  var fetchOptions = (0, _assign2.default)({}, DEFAULT_OPTIONS, options);
	  return advancedFetch(fetch(fetchUrl, fetchOptions), timeout).then(function (response) {
	    if (response.ok) {
	      return response.text();
	    }
	
	    return response.text().then(text2JSON).then(function (resJson) {
	      return _promise2.default.reject(new Error('status: ' + response.status + ', message: ' + resJson.message + ' }'));
	    });
	  }).then(text2JSON).catch(function (error) {
	    if (error.message === "auth failed") {
	      if (isRedirect) {
	        location.reload();
	      }
	    }
	
	    return _promise2.default.reject(error);
	  });
	};
	
	function createToolbar(onMouseDown) {
	  var $imgEditor = document.createElement("span");
	  $imgEditor.className = index_ts.RESIZER_CLASS;
	  $imgEditor.innerHTML = '\n      <span class="info info-rb"></span>\n      <span class="resizer resizer-lt"></span>\n      <span class="resizer resizer-lb"></span>\n      <span class="resizer resizer-rt"></span>\n      <span class="resizer resizer-rb"></span>\n    ';
	  $imgEditor.addEventListener("mousedown", onMouseDown, false);
	  return $imgEditor;
	}
	
	function calculateWidth(width, diff, isAdd, max, min) {
	  var result = isAdd ? width + diff : width - diff;
	
	  if (result <= min) {
	    return min;
	  } else if (result >= max) {
	    return max;
	  }
	
	  return result;
	}
	function calculateHeight(height, diffY, isAddY, max, min) {
	  var result = isAddY ? height + diffY : height - diffY;
	
	  if (result <= min) {
	    return min;
	  } else if (result >= max) {
	    return max;
	  }
	
	  return result;
	}
	function getContentDisplaySize(_ref5) {
	  var type = _ref5.type,
	      dom = _ref5.dom,
	      resizer = _ref5.resizer,
	      clientX = _ref5.clientX,
	      clientY = _ref5.clientY;
	
	  var imgNode = getElementFromDOM({
	    dom: dom,
	    selector: type
	  });
	  var isAdd = resizer.isAdd,
	      isAddY = resizer.isAddY,
	      startX = resizer.startX,
	      startY = resizer.startY,
	      originalWidth = resizer.originalWidth,
	      originalHeight = resizer.originalHeight,
	      maxWidth = resizer.maxWidth;
	
	  var diff = clientX - startX;
	  var diffY = clientY - startY;
	  var naturalHeight = 0;
	  var naturalWidth = 0;
	  var width = 0;
	  var height = 0;
	
	  switch (type) {
	    case "img":
	      naturalWidth = imgNode.naturalWidth;
	      naturalHeight = imgNode.naturalHeight;
	      break;
	
	    case "svg":
	      {
	        naturalWidth = imgNode.viewBox.baseVal.width;
	        naturalHeight = imgNode.viewBox.baseVal.height;
	        break;
	      }
	
	    case "div":
	      {
	        naturalWidth = imgNode.offsetWidth;
	        naturalHeight = imgNode.offsetHeight;
	        break;
	      }
	  }
	
	  var minWidth = naturalWidth;
	
	  if (naturalWidth < 5 || naturalWidth > 20) {
	    minWidth = index_ts.IMAGE_MIN_WIDTH;
	  }
	
	  width = calculateWidth(originalWidth, diff, isAdd, maxWidth, minWidth);
	
	  if (type !== "div") {
	    if (naturalHeight) {
	      height = width / naturalWidth * naturalHeight;
	    }
	  } else {
	    if (naturalHeight) {
	      height = calculateHeight(originalHeight, diffY, isAddY, 600, 150);
	      width = width < 320 ? 320 : width;
	    }
	  }
	
	  return {
	    width: width,
	    height: height,
	    imgNode: imgNode
	  };
	}
	
	var css$1 = ".ct-resizer{display:block;position:absolute;left:0;right:0;top:0;bottom:0;z-index:11;outline:1px dashed #aaa;pointer-events:none}.ct-resizer .resizer{position:absolute;width:24px;height:24px;pointer-events:auto}.ct-resizer .resizer:after{box-sizing:border-box;content:\" \";position:absolute;display:block;top:5px;left:5px;width:14px;height:14px;border-radius:7px;border:2px solid #fff;box-shadow:0 1px 2px 0;background-color:#333}.ct-resizer .info{position:absolute;padding:5px;font-size:12px;color:#fff;background:rgba(0,0,0,.7)}.ct-resizer .info-lt{left:8px;top:8px}.ct-resizer .info-lb{left:8px;bottom:8px}.ct-resizer .info-rt{right:8px;top:8px}.ct-resizer .info-rb{right:8px;bottom:8px}.ct-resizer .resizer-lt{left:-12px;top:-12px;cursor:nwse-resize}.ct-resizer .resizer-lb{left:-12px;bottom:-12px;cursor:nesw-resize}.ct-resizer .resizer-rt{right:-12px;top:-12px;cursor:nesw-resize}.ct-resizer .resizer-rb{right:-12px;bottom:-12px;cursor:nwse-resize}";
	styleInject(css$1);
	
	var RESIZING = "resizing";
	function resizer(constructor) {
	  constructor.prototype.ctShowResizer = showResizer;
	  constructor.prototype.ctHideResizer = hideResizer;
	  constructor.prototype.ctToggleDisplayOfImageInfo = toggleDisplayOfImageInfo;
	  constructor.prototype.ctResizeType = "img";
	  constructor.prototype.resizer = null;
	  constructor.prototype.node = null;
	  constructor.prototype.$imageInfo = null;
	  constructor.prototype.$resizer = null;
	  constructor.prototype.startMoveCallback = null;
	  constructor.prototype.endMoveCallback = null;
	
	  constructor.prototype.setStartMoveCallback = function (cb) {
	    this.startMoveCallback = cb;
	  };
	
	  constructor.prototype.setEndMoveCallback = function (cb) {
	    this.endMoveCallback = cb;
	  };
	
	  return constructor;
	}
	var onMouseDown = void 0;
	var onMouseMove = void 0;
	var onMouseUp = void 0;
	
	function resizerOnMouseDown(e) {
	  if (!e.target) {
	    return;
	  }
	
	  var classList = e.target.classList;
	
	  if (!classList.contains("resizer")) {
	    return;
	  }
	
	  if (!this.$imageInfo) {
	    return;
	  }
	
	  e.preventDefault();
	  var isLeftTop = classList.contains("resizer-lt");
	  var isLeftBottom = classList.contains("resizer-lb");
	  var isRightTop = classList.contains("resizer-rt");
	  var isRightBottom = classList.contains("resizer-rb");
	  var isAdd = isRightTop || isRightBottom;
	  var isAddY = isLeftBottom || isRightBottom;
	
	  if (isLeftTop) {
	    this.$imageInfo.className = "info info-lt";
	  } else if (isLeftBottom) {
	    this.$imageInfo.className = "info info-lb";
	  } else if (isRightTop) {
	    this.$imageInfo.className = "info info-rt";
	  } else if (isRightBottom) {
	    this.$imageInfo.className = "info info-rb";
	  }
	
	  var blockNode = findParentBlockNode(this.node.dom);
	
	  if (!blockNode) {
	    return;
	  }
	
	  var parentTagName = blockNode.parentNode.tagName.toLowerCase();
	  var maxWidth = blockNode.clientWidth - index_ts.IMAGE_OFFSET;
	
	  if ((parentTagName === "td" || parentTagName === "th") && blockNode.closest("table").classList.contains("responsive")) {
	    maxWidth = 1920;
	  }
	
	  this.resizer = {
	    maxWidth: maxWidth,
	    isAdd: isAdd,
	    isAddY: isAddY,
	    isResizing: false,
	    startX: e.clientX,
	    startY: e.clientY,
	    originalWidth: this.node.dom.clientWidth,
	    originalHeight: this.node.dom.clientHeight
	  };
	  setResizerState();
	  window.addEventListener("mousemove", onMouseMove);
	  window.addEventListener("mouseup", onMouseUp);
	}
	
	var resizerOnMouseMove = function resizerOnMouseMove(e) {
	  if (!this.resizer) {
	    return;
	  }
	
	  if (this.node.dom.querySelector(".ct-editor-loading")) {
	    return;
	  }
	
	  var _getContentDisplaySiz = getContentDisplaySize({
	    type: this.ctResizeType,
	    dom: this.node.dom,
	    resizer: this.resizer,
	    clientX: e.clientX,
	    clientY: e.clientY
	  }),
	      width = _getContentDisplaySiz.width,
	      height = _getContentDisplaySiz.height;
	
	  this.resizer.width = width;
	
	  if (height) {
	    this.resizer.height = height;
	  }
	
	  this.node.dom.style.width = this.resizer.width + 'px';
	
	  if (height) {
	    this.node.dom.style.height = this.resizer.height + 'px';
	  }
	
	  if (this.startMoveCallback) {
	    this.startMoveCallback(height, width);
	  }
	
	  this.ctToggleDisplayOfImageInfo();
	  this.resizer.isResizing = true;
	};
	
	resizerOnMouseMove = throttle(resizerOnMouseMove, 16);
	
	function resizerOnMouseUp() {
	  if (!this.resizer) {
	    return;
	  }
	
	  if (!this.resizer.isResizing) {
	    this.resizer = null;
	    return;
	  }
	
	  var _resizer = this.resizer,
	      isResizing = _resizer.isResizing,
	      width = _resizer.width;
	
	
	  if (!isResizing || !width) {
	    return;
	  }
	
	  this.resizer.isResizing = false;
	  var imgNode = getElementFromDOM({
	    dom: this.node.dom,
	    selector: this.ctResizeType
	  });
	
	  if (imgNode) {
	    try {
	      this.updateAttrs({
	        width: imgNode.clientWidth,
	        height: imgNode.clientHeight,
	        hadResize: true
	      });
	    } catch (err) {
	      console.error(err);
	    }
	  }
	
	  dropResizerState();
	
	  if (this.endMoveCallback) {
	    this.endMoveCallback();
	  }
	
	  window.removeEventListener("mousemove", onMouseMove);
	  window.removeEventListener("mouseup", onMouseUp);
	}
	
	function toggleDisplayOfImageInfo() {
	  var spanDOM = this.node.dom;
	  var styleWidth = parseInt(spanDOM.style.width, 10);
	  var width = spanDOM.clientWidth;
	  var height = spanDOM.clientHeight;
	
	  if (styleWidth && width !== styleWidth) {
	    height = parseInt('' + styleWidth / width * height, 10);
	    width = styleWidth;
	  }
	
	  var textContent = width + ' \xD7 ' + height;
	
	  if (spanDOM.clientWidth < textContent.length * 8 + 10 || spanDOM.clientHeight < index_ts.IMAGE_INFO_DISPLAY_MIN_HEIGHT_SIZE) {
	    this.$imageInfo.style.display = "none";
	  } else {
	    this.$imageInfo.style.display = "block";
	    this.$imageInfo.textContent = textContent;
	  }
	}
	
	function hideResizer() {
	  if (this.$resizer) {
	    this.$resizer.remove();
	    this.$resizer = null;
	    this.$imageInfo = null;
	    this.resizer = null;
	  }
	}
	
	function showResizer(config) {
	  if (config) {
	    if (config.node) {
	      this.node = config.node;
	    }
	
	    this.ctResizeType = config.type;
	  }
	
	  onMouseDown = resizerOnMouseDown.bind(this);
	  onMouseMove = resizerOnMouseMove.bind(this);
	  onMouseUp = resizerOnMouseUp.bind(this);
	  this.$resizer = createToolbar(onMouseDown);
	  this.$imageInfo = this.$resizer.firstElementChild;
	  this.node.dom.appendChild(this.$resizer);
	  this.ctToggleDisplayOfImageInfo();
	}
	
	function setResizerState() {
	  var popovers = document.getElementsByClassName(index_ts.POPOVER_CLASS);
	  window.ctImgResizing = true;
	
	  (0, _from2.default)(popovers).forEach(function (node) {
	    if (node.childNodes.length > 0) {
	      node.classList.add(RESIZING);
	    }
	  });
	}
	
	function dropResizerState() {
	  var popovers = document.getElementsByClassName(index_ts.POPOVER_CLASS);
	  window.ctImgResizing = false;
	
	  (0, _from2.default)(popovers).forEach(function (node) {
	    if (node.classList.contains(RESIZING)) {
	      node.classList.remove(RESIZING);
	    }
	  });
	}
	
	var css$2 = ".ct-toolbox-popover{display:none;position:absolute;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;height:-webkit-fit-content;height:-moz-fit-content;height:fit-content;pointer-events:none;background:transparent;z-index:98;transition:opacity .2s ease}.ct-toolbox-popover.resizing{height:-webkit-fit-content!important;height:-moz-fit-content!important;height:fit-content!important}.ct-toolbox-popover .ct-toolbox{position:-webkit-sticky;position:sticky;display:flex;top:0;flex-direction:row;align-items:center;background:#fff;font-size:12px;box-shadow:0 4px 16px 0 rgba(106,93,73,.2),0 8px 20px 0 rgba(106,93,73,.1);border-radius:1px;pointer-events:all}.ct-toolbox-popover .ct-toolbox.in-table{top:30px}.ct-toolbox-popover .ct-toolbox.nosticky{position:relative}.ct-toolbox-popover .ct-toolbox.nosticky.in-table{top:0}";
	styleInject(css$2);
	
	var getDOMOffset = function getDOMOffset(_ref6) {
	  var offsetParent = _ref6.offsetParent,
	      dom = _ref6.dom,
	      toolboxHeight = _ref6.toolboxHeight,
	      _ref6$bottomFirst = _ref6.bottomFirst,
	      bottomFirst = _ref6$bottomFirst === undefined ? false : _ref6$bottomFirst,
	      popoverWidth = _ref6.popoverWidth;
	
	  var top = 0;
	  var left = 0;
	  var right = "auto";
	
	  var _dom$getBoundingClien = dom.getBoundingClientRect(),
	      domLeft = _dom$getBoundingClien.left,
	      domTop = _dom$getBoundingClien.top,
	      domBottom = _dom$getBoundingClien.bottom;
	
	  var _offsetParent$getBoun = offsetParent.getBoundingClientRect(),
	      parentLeft = _offsetParent$getBoun.left,
	      parentTop = _offsetParent$getBoun.top,
	      parentRight = _offsetParent$getBoun.right;
	
	  var avHeight = window.innerHeight;
	  top = domTop - parentTop;
	
	  left = domLeft - parentLeft;
	
	  if (bottomFirst && avHeight - domBottom - 50 > toolboxHeight) {
	    top = domBottom - parentTop + 2;
	  } else {
	    top = top - toolboxHeight - 2;
	  }
	
	  var rightWidth = parentRight - domLeft;
	
	  if (rightWidth < popoverWidth) {
	    left = "auto";
	    right = 0;
	  }
	
	  if (left < 0) {
	    left = 0;
	    right = "auto";
	  }
	
	  return {
	    left: left,
	    top: top,
	    right: right
	  };
	};
	var setPopoverStyle = function setPopoverStyle(_ref7) {
	  var $popover = _ref7.$popover,
	      dom = _ref7.dom,
	      customStyle = _ref7.customStyle,
	      offsetParent = _ref7.offsetParent,
	      toolboxHeight = _ref7.toolboxHeight,
	      bottomFirst = _ref7.bottomFirst,
	      popoverWidth = _ref7.popoverWidth;
	
	  $popover.style.display = "block";
	
	  if (dom) {
	    var height = dom.offsetHeight + toolboxHeight;
	
	    if (!offsetParent || !$popover) {
	      return;
	    }
	
	    var style = getDOMOffset({
	      offsetParent: offsetParent,
	      dom: dom,
	      toolboxHeight: toolboxHeight,
	      bottomFirst: bottomFirst,
	      popoverWidth: popoverWidth
	    });
	    (0, _entries2.default)(style).forEach(function (_ref8) {
	      var _ref9 = (0, _slicedToArray3.default)(_ref8, 2),
	          key = _ref9[0],
	          value = _ref9[1];
	
	      if (/[0-9]+/.test(value)) {
	        $popover.style[key] = value + 'px';
	      } else {
	        $popover.style[key] = '' + value;
	      }
	    });
	    $popover.style.height = height + 'px';
	  } else if (customStyle) {
	    (0, _keys2.default)(customStyle).forEach(function (key) {
	      $popover.style[key] = customStyle[key];
	    });
	  }
	};
	var emptyDOM = function emptyDOM(renderDOM) {
	  if (renderDOM.firstElementChild) {
	    preact.render(null, renderDOM, renderDOM.firstElementChild);
	  }
	};
	
	var SHOW = "show";
	var HIDE = "hide";
	var TOOLBOX_HEIGHT = 34;
	
	var Popover = function () {
	  function Popover(_ref10) {
	    var _this2 = this;
	
	    var view = _ref10.view,
	        store = _ref10.store,
	        className = _ref10.className,
	        height = _ref10.height,
	        _ref10$autoControl = _ref10.autoControl,
	        autoControl = _ref10$autoControl === undefined ? true : _ref10$autoControl,
	        _ref10$bottomFirst = _ref10.bottomFirst,
	        bottomFirst = _ref10$bottomFirst === undefined ? false : _ref10$bottomFirst,
	        _ref10$sticky = _ref10.sticky,
	        sticky = _ref10$sticky === undefined ? true : _ref10$sticky,
	        getToolboxHeightFn = _ref10.getToolboxHeightFn;
	    (0, _classCallCheck3.default)(this, Popover);
	
	    this.toolboxHeight = void 0;
	    this.getToolboxHeightFn = void 0;
	    this.offsetParent = void 0;
	    this.offsetParentRect = void 0;
	    this.$popover = void 0;
	    this.store = void 0;
	    this.view = void 0;
	    this.pluginName = void 0;
	    this.isAutoControl = void 0;
	    this.isBottomFirst = void 0;
	    this.isSticky = void 0;
	    this.tableWrapper = void 0;
	    this.popoverWidth = void 0;
	    this.tableOffset = void 0;
	    this.popoverState = HIDE;
	
	    this.setPopoverState = function (state) {
	      _this2.popoverState = state;
	    };
	
	    this.checkTable = function (dom) {
	      if (!dom) {
	        return;
	      }
	
	      _this2.tableWrapper = dom.closest(".ct-table-wrapper");
	    };
	
	    this.fixTableScroll = function () {
	      if (!_this2.isAutoControl) {
	        return;
	      }
	
	      if (_this2.$popover.firstElementChild) {
	        if (_this2.tableWrapper) {
	          _this2.$popover.firstElementChild.classList.add("in-table");
	          _this2.tableWrapper.addEventListener("scroll", _this2.updatePopover);
	        } else {
	          _this2.tableOffset = null;
	          _this2.$popover.firstElementChild.classList.remove("in-table");
	        }
	      }
	    };
	
	    this.updatePopover = function () {
	      var node = objectSpread({}, _this2.store.node);
	
	      _this2.store.hidePopover();
	      _this2.store.showPopover(node);
	    };
	
	    this.toolboxHeight = height || TOOLBOX_HEIGHT;
	    this.getToolboxHeightFn = getToolboxHeightFn;
	    this.isAutoControl = autoControl;
	    this.isBottomFirst = bottomFirst;
	    this.isSticky = sticky;
	    this.updatePopover = throttle(this.updatePopover, 16);
	    this.tableOffset = null;
	    this.store = store;
	    this.view = view;
	    this.$popover = document.createElement("div");
	    this.$popover.className = 'ct-toolbox-popover ' + (className || "");
	    this.store.ctPopover = this;
	
	    if (view.dom.parentElement) {
	      view.dom.parentElement.appendChild(this.$popover);
	    }
	  }
	
	  (0, _createClass3.default)(Popover, [{
	    key: 'show',
	    value: function show(_ref11) {
	      var dom = _ref11.dom,
	          content = _ref11.content,
	          customStyle = _ref11.customStyle,
	          _ref11$forceUpdate = _ref11.forceUpdate,
	          forceUpdate = _ref11$forceUpdate === undefined ? false : _ref11$forceUpdate;
	
	      if (this.popoverState === SHOW && !forceUpdate) {
	        return;
	      }
	
	      if (this.popoverState === HIDE) {
	        var offsetParent = this.view.dom.parentElement;
	        this.checkTable(dom);
	        var toolboxHeight = this.toolboxHeight;
	
	        if (this.getToolboxHeightFn) {
	          toolboxHeight = this.getToolboxHeightFn();
	        }
	
	        setPopoverStyle({
	          $popover: this.$popover,
	          dom: dom,
	          customStyle: customStyle,
	          offsetParent: offsetParent,
	          toolboxHeight: toolboxHeight,
	          bottomFirst: this.isBottomFirst,
	          popoverWidth: this.popoverWidth
	        });
	      }
	
	      if (forceUpdate) {
	        emptyDOM(this.$popover);
	      }
	
	      preact.render(content, this.$popover);
	
	      if (this.$popover.firstElementChild) {
	        var $child = this.$popover.firstElementChild;
	        $child.classList.add("ct-toolbox");
	
	        if (!this.isSticky) {
	          $child.classList.add("nosticky");
	        }
	
	        this.fixTableScroll();
	        this.setPopoverState(SHOW);
	      }
	
	      if (!this.popoverWidth) {
	        this.updatePopover();
	      }
	    }
	  }, {
	    key: 'hide',
	    value: function hide() {
	      if (this.popoverState === HIDE) {
	        return;
	      }
	
	      this.popoverWidth = this.$popover.offsetWidth;
	      emptyDOM(this.$popover);
	
	      if (this.isAutoControl && this.tableWrapper) {
	        this.tableWrapper.removeEventListener("scroll", this.updatePopover);
	      }
	
	      this.$popover.setAttribute("style", "");
	      this.$popover.style.display = "none";
	      this.setPopoverState(HIDE);
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      this.$popover.remove();
	    }
	  }, {
	    key: 'update',
	    value: function update(view) {
	      var selection = view.state.selection;
	
	      var selNode = selection.node;
	
	      if (this.store.handleViewUpdate) {
	        this.store.handleViewUpdate({
	          view: view,
	          selNode: selNode,
	          selection: selection
	        });
	      } else if (this.isAutoControl && this.store.pluginName) {
	        try {
	          var pluginName = this.store.pluginName.match(/([a-z|A-Z]+)/)[0].toLowerCase();
	          var pos = null;
	          var attrs = {};
	          var dom = null;
	
	          if (selection.node && selection.node.type.name.toLowerCase() === pluginName) {
	            var $from = selection.$from;
	
	            pos = $from.pos;
	            var nodeAfter = $from.nodeAfter;
	
	            attrs = nodeAfter.attrs;
	          }
	
	          if (pos === null) {
	            var findResult = findParentNode(selection.$anchor.path, function (item) {
	              return item.type && item.type.name === pluginName;
	            });
	
	            if (findResult) {
	              pos = findResult.pos;
	              attrs = findResult.node.attrs;
	            }
	          }
	
	          dom = view.nodeDOM(pos);
	
	          if (dom && dom.classList && !dom.classList.contains("failed")) {
	            var _attrs = attrs,
	                content = _attrs.content;
	
	            this.store.hidePopover();
	            this.store.showPopover({
	              dom: dom,
	              pos: pos,
	              data: content,
	              attrs: attrs,
	              view: view
	            });
	          } else if (this.store.hidePopover) {
	            this.store.hidePopover();
	          }
	        } catch (err) {
	          console.error("showPopover failed", err);
	        }
	      }
	    }
	  }]);
	  return Popover;
	}();
	
	function calculateSize(originWidth, originHeight, containerWidth) {
	  var imageMaxHeight = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : index_ts.IMAGE_MAX_HEIGHT;
	
	  var result = {
	    newOriginHeight: 0,
	    newOriginWidth: 0,
	    height: 0,
	    width: 0
	  };
	
	  if (originHeight < imageMaxHeight) {
	    result.newOriginWidth = originWidth;
	    result.newOriginHeight = originHeight;
	
	    if (originWidth > containerWidth) {
	      result.width = containerWidth;
	      result.height = +(originHeight * containerWidth / originWidth).toFixed(2);
	    } else {
	      result.width = originWidth;
	      result.height = originHeight;
	    }
	  } else {
	    result.width = +(originWidth * imageMaxHeight / originHeight).toFixed(2);
	    result.height = imageMaxHeight;
	    result.newOriginWidth = result.width;
	    result.newOriginHeight = imageMaxHeight;
	
	    if (result.width > containerWidth) {
	      result.width = containerWidth;
	
	      result.height = +(containerWidth / originWidth * originHeight).toFixed(2);
	    }
	  }
	
	  return result;
	}
	
	function calculatePercent(total, loaded) {
	  var percent = "0";
	
	  if (total) {
	    if (loaded === total) {
	      percent = "99";
	    } else {
	      percent = (loaded / total * 100).toFixed(2);
	    }
	  }
	
	  return percent + '%';
	}
	function createUploadMask() {
	  var widget = document.createElement("span");
	  widget.setAttribute("class", "ct-image");
	  widget.setAttribute("data-type", "ct-progress");
	  widget.innerHTML = '\n    <img src="" />\n    <div class="ct-image-mask image">\n      <span class="ct-image-loading"></span>\n      <span class="ct-image-progress">0%</span>\n      <span class="ct-image-load-failed">\u62B1\u6B49\uFF0C\u56FE\u7247\u4E0A\u4F20\u5931\u8D25\uFF01<br style="line-height:0">\u5982\u679C\u662F\u4ECE\u5916\u90E8\u62D6\u52A8\u3001\u7C98\u8D34\u8FC7\u6765\u7684\u56FE\u7247\uFF0C\u8BF7\u4E0B\u8F7D\u539F\u56FE\u5E76\u91CD\u65B0\u4E0A\u4F20\u3002<br style="line-height:0">\u5426\u5219\uFF0C\u8BF7\u70B9\u51FB\u4E0B\u65B9\u6309\u94AE\u8FDB\u884C\u91CD\u8BD5\u3002\n      </span>\n      <button class="ct-image-reupload">\u91CD\u8BD5</button>\n    </div>\n  ';
	  return widget;
	}
	
	function uploader(constructor) {
	  constructor.prototype.insertFiles = insertFiles;
	  constructor.prototype.prepare = prepare;
	  constructor.prototype.onprogress = onprogress;
	  constructor.prototype.failed = failed;
	  return constructor;
	}
	
	function insertFiles(files, style) {
	  var _this3 = this;
	
	  var customUpload = this.config.customUpload;
	  var uploadCheck = this.config.customUploadCheck;
	  return _promise2.default.all((0, _from2.default)(files).map(function () {
	    var _ref12 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(file) {
	      var key, failedHandle;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.t0 = !uploadCheck;
	
	              if (_context.t0) {
	                _context.next = 5;
	                break;
	              }
	
	              _context.next = 4;
	              return uploadCheck(file);
	
	            case 4:
	              _context.t0 = _context.sent;
	
	            case 5:
	              if (!_context.t0) {
	                _context.next = 10;
	                break;
	              }
	
	              key = uuid$1();
	
	              _this3.prepare({
	                key: key,
	                file: file,
	                style: style
	              });
	              failedHandle = _this3.failed(key, file);
	              return _context.abrupt('return', customUpload({
	                file: file,
	                onprogress: _this3.onprogress(key),
	                insert: _this3.insertToDoc(key, file.name, failedHandle),
	                failedHandle: failedHandle
	              }));
	
	            case 10:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this3);
	    }));
	
	    return function (_x8) {
	      return _ref12.apply(this, arguments);
	    };
	  }()));
	}
	
	function prepare(_ref13) {
	  var key = _ref13.key,
	      file = _ref13.file,
	      url = _ref13.url,
	      position = _ref13.position,
	      style = _ref13.style;
	  var _view = this.view,
	      tr = _view.state.tr,
	      dispatch = _view.dispatch;
	
	  var pos = typeof position === "number" ? position : tr.selection.from;
	  var src = url || URL.createObjectURL(file);
	
	  if (!tr.selection.empty) {
	    tr.deleteSelection();
	    dispatch(tr);
	  }
	
	  createPlaceholder(this.view, this.pluginName, key, pos);
	  var placeholderInfo = findPlaceholder(this.view, this.pluginName, key);
	
	  if (!placeholderInfo) {
	    return;
	  }
	
	  if (this.uploadingDisplay) {
	    this.uploadingDisplay({
	      key: key,
	      file: file,
	      placeholderInfo: placeholderInfo
	    });
	  } else {
	    var node = placeholderInfo.node;
	
	    var $img = node.querySelector("img");
	    $img.src = src;
	
	    if (style) {
	      (0, _entries2.default)(style).forEach(function (_ref14) {
	        var _ref15 = (0, _slicedToArray3.default)(_ref14, 2),
	            name = _ref15[0],
	            rule = _ref15[1];
	
	        $img.style[name] = rule;
	      });
	    }
	  }
	
	  return key;
	}
	
	function onprogress(key) {
	  var _this4 = this;
	
	  return function (_ref16) {
	    var total = _ref16.total,
	        loaded = _ref16.loaded;
	
	    var placeholder = findPlaceholder(_this4.view, _this4.pluginName, key);
	
	    if (!placeholder) {
	      return;
	    }
	
	    placeholder.node.querySelector(".ct-image-progress").innerText = calculatePercent(total, loaded);
	  };
	}
	
	function failed(key, file, customReupload) {
	  var _this5 = this;
	
	  return function (msg) {
	    var placeholder = findPlaceholder(_this5.view, _this5.pluginName, key);
	
	    if (!placeholder) {
	      return;
	    }
	
	    var node = placeholder.node;
	
	    var $progress = node.querySelector(".ct-image-progress");
	    var $loading = node.querySelector(".ct-image-loading");
	    var $loadFailed = node.querySelector(".ct-image-load-failed");
	    var $btnUpload = node.querySelector(".ct-image-reupload");
	    $loading.style.display = "none";
	    $progress.style.display = "none";
	    $loadFailed.style.display = "block";
	    $btnUpload.style.display = "block";
	    $btnUpload.addEventListener("click", function () {
	      deletePlaceholder(_this5.view, _this5.pluginName, key);
	
	      if (customReupload) {
	        customReupload();
	      } else {
	        _this5.insertFiles([file]);
	      }
	    });
	  };
	}
	
	var computeSliceMinWidth = function computeSliceMinWidth(slice) {
	  var result = 0;
	  slice.content.forEach(function (node) {
	    var name = node.type.name;
	    var braceWidth = node.type.schema.nodes[name].spec.braceWidth;
	    var width = parseInt(node.attrs.width, 10) || braceWidth || 0;
	
	    if (width > result) {
	      result = width;
	    }
	  });
	  return result;
	};
	
	var $CtLoading = function () {
	  var div = document.createElement("div");
	  div.classList.add("ct-editor-loading");
	  div.innerHTML = '<div class="loading-wrapper"><i></i><i></i><i></i></div>';
	  return div;
	}();
	
	function download(src, otherAttributes, useOpen) {
	  var url = '' + src + (src.indexOf('?') > -1 ? '&' : '?') + 'download=true';
	
	  if (useOpen) {
	    window.open(url);
	    return;
	  }
	
	  var aEl = document.createElement('a');
	  aEl.setAttribute('href', url);
	
	  if (typeof otherAttributes === 'string') {
	    aEl.setAttribute('download', otherAttributes);
	    aEl.download = otherAttributes;
	  }
	
	  if ((typeof otherAttributes === 'undefined' ? 'undefined' : (0, _typeof3.default)(otherAttributes)) === 'object') {
	    (0, _keys2.default)(otherAttributes).forEach(function (attrKey) {
	      return aEl.setAttribute(attrKey, otherAttributes[attrKey]);
	    });
	  }
	
	  aEl.click();
	}
	
	var css$3 = ".ct-toolbar-tooltip{position:absolute;left:50%;-webkit-transform:translate(-50%);transform:translate(-50%);bottom:-35px;height:25px;padding:0 10px;line-height:25px;white-space:nowrap;vertical-align:middle;color:#fff;font-size:12px;background:rgba(0,0,0,.7);border-radius:4px;z-index:1}.ct-toolbar-tooltip:after{position:absolute;width:0;top:-5px;right:50%;-webkit-transform:translate(50%);transform:translate(50%);display:block;border-color:rgba(0,0,0,.7) transparent;border-style:solid;border-width:0 5px 5px;content:\"\";z-index:1}.ct-input{border:1px solid #ddd;border-radius:2px}.ct-web-dangers-shadow-wrapper{width:100%;height:100%}.ct-image.ProseMirror-widget{vertical-align:bottom}.ct-img-failed{display:inline-block;width:100%;height:100%}:.ct-img-failed:before{content:\"\";position:absolute;left:0;top:0;display:block;width:100%;height:100%;background:#f6f6f6;z-index:1}.ct-img-failed:after{content:\"\";position:absolute;left:12px;top:12px;display:block;width:28px;height:20px;z-index:2;background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg class='icon' viewBox='0 0 1380 1024' xmlns='http://www.w3.org/2000/svg' width='26.953' height='20'%3E%3Cdefs%3E%3Cstyle/%3E%3C/defs%3E%3Cpath d='M526.889 315.732l165.016 171.024a66.785 66.785 0 0 1 18.724 46.371V737.77l135.664-202.254-123.399-162.635a66.78 66.78 0 0 1-8.027-67.029L830.58 40.121C841.19 15.756 865.235.001 891.809.001h338.475c82.394 0 149.89 65.742 149.89 147.731V876.27c0 81.989-67.496 147.731-149.89 147.731H149.89C67.496 1024.001 0 958.259 0 876.27V147.732C0 65.743 67.496.001 149.89.001h393.258c45.99 0 78.216 45.4 63.044 88.815L526.89 315.733z' fill='%237F9496'/%3E%3Cpath d='M543.148 66.783l-83.824 239.855a44.52 44.52 0 0 0 9.99 45.602l174.532 180.887v277.792a44.52 44.52 0 0 0 19.721 36.974c20.42 13.697 48.078 8.247 61.775-12.173l185.264-276.199c10.592-15.791 9.987-36.565-1.506-51.712L776.096 332.515 891.809 66.784h338.475c45.899 0 83.107 36.242 83.107 80.949v728.538c0 44.707-37.208 80.949-83.107 80.949H149.89c-45.899 0-83.107-36.242-83.107-80.949V147.733c0-44.707 37.208-80.949 83.107-80.949h393.258z' fill='%23FFF'/%3E%3Cpath d='M496.955 289.391l252.816 398.046 196.047-178.035 300.791 358.771H133.566z' fill='%23DDD'/%3E%3Cpath d='M526.889 315.732l165.016 171.024a66.785 66.785 0 0 1 18.724 46.371V737.77l135.664-202.254-123.399-162.635a66.78 66.78 0 0 1-8.027-67.029L830.58 40.121C841.19 15.756 865.235.001 891.809.001h338.475c82.394 0 149.89 65.742 149.89 147.731V876.27c0 81.989-67.496 147.731-149.89 147.731H149.89C67.496 1024.001 0 958.259 0 876.27V147.732C0 65.743 67.496.001 149.89.001h393.258c45.99 0 78.216 45.4 63.044 88.815L526.89 315.733zm16.259-248.949H149.89c-45.899 0-83.107 36.242-83.107 80.949V876.27c0 44.707 37.208 80.949 83.107 80.949h1080.394c45.899 0 83.107-36.242 83.107-80.949V147.732c0-44.707-37.208-80.949-83.107-80.949H891.809L776.096 332.514 909.1 507.808c11.493 15.147 12.098 35.922 1.506 51.712L725.342 835.719c-13.697 20.42-41.355 25.871-61.775 12.173a44.522 44.522 0 0 1-19.721-36.974V533.126L469.314 352.239a44.523 44.523 0 0 1-9.99-45.602l83.824-239.855z' fill='%237F9496'/%3E%3Cpath d='M1230.284 309.628c0 67.06-55.813 121.423-124.661 121.423s-124.661-54.363-124.661-121.423 55.813-121.423 124.661-121.423 124.661 54.363 124.661 121.423z' fill='%23EEE'/%3E%3C/svg%3E\") no-repeat 0 0}.ct-editor-loading{display:inline-block;font-size:12px;position:absolute;bottom:0;left:0;right:0;top:0;z-index:9;text-align:center;white-space:nowrap;background:#f6f6f6}.ct-editor-loading .loading-wrapper{position:absolute;left:0;right:0;top:50%;height:-webkit-fit-content;height:-moz-fit-content;height:fit-content;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.ct-editor-loading .loading-wrapper>i{display:none;vertical-align:middle}.ct-editor-loading .loading-wrapper>i:after,.ct-editor-loading .loading-wrapper>i:before{content:\" \";display:inline-block;height:100%;margin-left:-.25em;vertical-align:middle}.ct-editor-loading .loading-wrapper i:nth-child(-n+3){display:inline-block;width:1em;height:1em;background:#00a7cd;border-radius:50%;-webkit-animation:bounce-delay 1.4s ease-in-out infinite both;animation:bounce-delay 1.4s ease-in-out infinite both}.ct-editor-loading .loading-wrapper i:not(:last-child){margin-right:.4em}.ct-editor-loading .loading-wrapper i:first-child{-webkit-animation-delay:-.32s;animation-delay:-.32s}.ct-editor-loading .loading-wrapper i:nth-child(2){-webkit-animation-delay:-.16s;animation-delay:-.16s}@-webkit-keyframes bounce-delay{0%,80%,to{-webkit-transform:scale(0);transform:scale(0)}40%{-webkit-transform:scale(1);transform:scale(1)}}@keyframes bounce-delay{0%,80%,to{-webkit-transform:scale(0);transform:scale(0)}40%{-webkit-transform:scale(1);transform:scale(1)}}";
	styleInject(css$3);
	
	exports.getContentWidth = getContentWidth;
	exports.findParentNode = findParentNode;
	exports.findParentDOM = findParentDOM;
	exports.findParentBlockNode = findParentBlockNode;
	exports.setBetweenAttrs = setBetweenAttrs;
	exports.getInsertBlockSlice = getInsertBlockSlice;
	exports.insertBlock = insertBlock;
	exports.canInsertTypes = canInsertTypes;
	exports.getBlockNode = getBlockNode;
	exports.isChild = isChild;
	exports.getSystemInfo = getSystemInfo;
	exports.isPrintableKey = isPrintableKey;
	exports.compute = compute;
	exports.getTargetLeft = getTargetLeft;
	exports.checkConfig = checkConfig;
	exports.uuid = uuid$1;
	exports.fixSvgRatio = fixSvgRatio;
	exports.getSizeFromSvg = getSizeFromSvg;
	exports.getSvgSizeAfterEdit = getSvgSizeAfterEdit;
	exports.getDynamicSrc = getDynamicSrc;
	exports.copyToClipboard = copyToClipboard;
	exports.mobileCopyToClipboard = mobileCopyToClipboard;
	exports.handleBackspaceCreator = handleBackspaceCreator;
	exports.handleDeleteCreator = handleDeleteCreator;
	exports.handleTabCreator = handleTabCreator;
	exports.handleEnterCreator = handleEnterCreator;
	exports.uploadHelper = uploadHelper;
	exports.PopoverStore = PopoverStore;
	exports.createPlaceholder = createPlaceholder;
	exports.findPlaceholder = findPlaceholder;
	exports.deletePlaceholder = deletePlaceholder;
	exports.createShadowDOM = createShadowDOM;
	exports.getElementFromDOM = getElementFromDOM;
	exports.send = send;
	exports.resizer = resizer;
	exports.calculateWidth = calculateWidth;
	exports.Popover = Popover;
	exports.uploader = uploader;
	exports.calculateSize = calculateSize;
	exports.createUploadMask = createUploadMask;
	exports.computeSliceMinWidth = computeSliceMinWidth;
	exports.$CtLoading = $CtLoading;
	exports.download = download;
	exports.config = config;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(323), __esModule: true };

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	!function() {
	    'use strict';
	    function h(nodeName, attributes) {
	        var lastSimple, child, simple, i, children = EMPTY_CHILDREN;
	        for (i = arguments.length; i-- > 2; ) stack.push(arguments[i]);
	        if (attributes && null != attributes.children) {
	            if (!stack.length) stack.push(attributes.children);
	            delete attributes.children;
	        }
	        while (stack.length) if ((child = stack.pop()) && void 0 !== child.pop) for (i = child.length; i--; ) stack.push(child[i]); else {
	            if ('boolean' == typeof child) child = null;
	            if (simple = 'function' != typeof nodeName) if (null == child) child = ''; else if ('number' == typeof child) child = String(child); else if ('string' != typeof child) simple = !1;
	            if (simple && lastSimple) children[children.length - 1] += child; else if (children === EMPTY_CHILDREN) children = [ child ]; else children.push(child);
	            lastSimple = simple;
	        }
	        var p = new VNode();
	        p.nodeName = nodeName;
	        p.children = children;
	        p.attributes = null == attributes ? void 0 : attributes;
	        p.key = null == attributes ? void 0 : attributes.key;
	        if (void 0 !== options.vnode) options.vnode(p);
	        return p;
	    }
	    function extend(obj, props) {
	        for (var i in props) obj[i] = props[i];
	        return obj;
	    }
	    function applyRef(ref, value) {
	        if (ref) if ('function' == typeof ref) ref(value); else ref.current = value;
	    }
	    function cloneElement(vnode, props) {
	        return h(vnode.nodeName, extend(extend({}, vnode.attributes), props), arguments.length > 2 ? [].slice.call(arguments, 2) : vnode.children);
	    }
	    function enqueueRender(component) {
	        if (!component.__d && (component.__d = !0) && 1 == items.push(component)) (options.debounceRendering || defer)(rerender);
	    }
	    function rerender() {
	        var p;
	        while (p = items.pop()) if (p.__d) renderComponent(p);
	    }
	    function isSameNodeType(node, vnode, hydrating) {
	        if ('string' == typeof vnode || 'number' == typeof vnode) return void 0 !== node.splitText;
	        if ('string' == typeof vnode.nodeName) return !node._componentConstructor && isNamedNode(node, vnode.nodeName); else return hydrating || node._componentConstructor === vnode.nodeName;
	    }
	    function isNamedNode(node, nodeName) {
	        return node.__n === nodeName || node.nodeName.toLowerCase() === nodeName.toLowerCase();
	    }
	    function getNodeProps(vnode) {
	        var props = extend({}, vnode.attributes);
	        props.children = vnode.children;
	        var defaultProps = vnode.nodeName.defaultProps;
	        if (void 0 !== defaultProps) for (var i in defaultProps) if (void 0 === props[i]) props[i] = defaultProps[i];
	        return props;
	    }
	    function createNode(nodeName, isSvg) {
	        var node = isSvg ? document.createElementNS('http://www.w3.org/2000/svg', nodeName) : document.createElement(nodeName);
	        node.__n = nodeName;
	        return node;
	    }
	    function removeNode(node) {
	        var parentNode = node.parentNode;
	        if (parentNode) parentNode.removeChild(node);
	    }
	    function setAccessor(node, name, old, value, isSvg) {
	        if ('className' === name) name = 'class';
	        if ('key' === name) ; else if ('ref' === name) {
	            applyRef(old, null);
	            applyRef(value, node);
	        } else if ('class' === name && !isSvg) node.className = value || ''; else if ('style' === name) {
	            if (!value || 'string' == typeof value || 'string' == typeof old) node.style.cssText = value || '';
	            if (value && 'object' == typeof value) {
	                if ('string' != typeof old) for (var i in old) if (!(i in value)) node.style[i] = '';
	                for (var i in value) node.style[i] = 'number' == typeof value[i] && !1 === IS_NON_DIMENSIONAL.test(i) ? value[i] + 'px' : value[i];
	            }
	        } else if ('dangerouslySetInnerHTML' === name) {
	            if (value) node.innerHTML = value.__html || '';
	        } else if ('o' == name[0] && 'n' == name[1]) {
	            var useCapture = name !== (name = name.replace(/Capture$/, ''));
	            name = name.toLowerCase().substring(2);
	            if (value) {
	                if (!old) node.addEventListener(name, eventProxy, useCapture);
	            } else node.removeEventListener(name, eventProxy, useCapture);
	            (node.__l || (node.__l = {}))[name] = value;
	        } else if ('list' !== name && 'type' !== name && !isSvg && name in node) {
	            try {
	                node[name] = null == value ? '' : value;
	            } catch (e) {}
	            if ((null == value || !1 === value) && 'spellcheck' != name) node.removeAttribute(name);
	        } else {
	            var ns = isSvg && name !== (name = name.replace(/^xlink:?/, ''));
	            if (null == value || !1 === value) if (ns) node.removeAttributeNS('http://www.w3.org/1999/xlink', name.toLowerCase()); else node.removeAttribute(name); else if ('function' != typeof value) if (ns) node.setAttributeNS('http://www.w3.org/1999/xlink', name.toLowerCase(), value); else node.setAttribute(name, value);
	        }
	    }
	    function eventProxy(e) {
	        return this.__l[e.type](options.event && options.event(e) || e);
	    }
	    function flushMounts() {
	        var c;
	        while (c = mounts.shift()) {
	            if (options.afterMount) options.afterMount(c);
	            if (c.componentDidMount) c.componentDidMount();
	        }
	    }
	    function diff(dom, vnode, context, mountAll, parent, componentRoot) {
	        if (!diffLevel++) {
	            isSvgMode = null != parent && void 0 !== parent.ownerSVGElement;
	            hydrating = null != dom && !('__preactattr_' in dom);
	        }
	        var ret = idiff(dom, vnode, context, mountAll, componentRoot);
	        if (parent && ret.parentNode !== parent) parent.appendChild(ret);
	        if (!--diffLevel) {
	            hydrating = !1;
	            if (!componentRoot) flushMounts();
	        }
	        return ret;
	    }
	    function idiff(dom, vnode, context, mountAll, componentRoot) {
	        var out = dom, prevSvgMode = isSvgMode;
	        if (null == vnode || 'boolean' == typeof vnode) vnode = '';
	        if ('string' == typeof vnode || 'number' == typeof vnode) {
	            if (dom && void 0 !== dom.splitText && dom.parentNode && (!dom._component || componentRoot)) {
	                if (dom.nodeValue != vnode) dom.nodeValue = vnode;
	            } else {
	                out = document.createTextNode(vnode);
	                if (dom) {
	                    if (dom.parentNode) dom.parentNode.replaceChild(out, dom);
	                    recollectNodeTree(dom, !0);
	                }
	            }
	            out.__preactattr_ = !0;
	            return out;
	        }
	        var vnodeName = vnode.nodeName;
	        if ('function' == typeof vnodeName) return buildComponentFromVNode(dom, vnode, context, mountAll);
	        isSvgMode = 'svg' === vnodeName ? !0 : 'foreignObject' === vnodeName ? !1 : isSvgMode;
	        vnodeName = String(vnodeName);
	        if (!dom || !isNamedNode(dom, vnodeName)) {
	            out = createNode(vnodeName, isSvgMode);
	            if (dom) {
	                while (dom.firstChild) out.appendChild(dom.firstChild);
	                if (dom.parentNode) dom.parentNode.replaceChild(out, dom);
	                recollectNodeTree(dom, !0);
	            }
	        }
	        var fc = out.firstChild, props = out.__preactattr_, vchildren = vnode.children;
	        if (null == props) {
	            props = out.__preactattr_ = {};
	            for (var a = out.attributes, i = a.length; i--; ) props[a[i].name] = a[i].value;
	        }
	        if (!hydrating && vchildren && 1 === vchildren.length && 'string' == typeof vchildren[0] && null != fc && void 0 !== fc.splitText && null == fc.nextSibling) {
	            if (fc.nodeValue != vchildren[0]) fc.nodeValue = vchildren[0];
	        } else if (vchildren && vchildren.length || null != fc) innerDiffNode(out, vchildren, context, mountAll, hydrating || null != props.dangerouslySetInnerHTML);
	        diffAttributes(out, vnode.attributes, props);
	        isSvgMode = prevSvgMode;
	        return out;
	    }
	    function innerDiffNode(dom, vchildren, context, mountAll, isHydrating) {
	        var j, c, f, vchild, child, originalChildren = dom.childNodes, children = [], keyed = {}, keyedLen = 0, min = 0, len = originalChildren.length, childrenLen = 0, vlen = vchildren ? vchildren.length : 0;
	        if (0 !== len) for (var i = 0; i < len; i++) {
	            var _child = originalChildren[i], props = _child.__preactattr_, key = vlen && props ? _child._component ? _child._component.__k : props.key : null;
	            if (null != key) {
	                keyedLen++;
	                keyed[key] = _child;
	            } else if (props || (void 0 !== _child.splitText ? isHydrating ? _child.nodeValue.trim() : !0 : isHydrating)) children[childrenLen++] = _child;
	        }
	        if (0 !== vlen) for (var i = 0; i < vlen; i++) {
	            vchild = vchildren[i];
	            child = null;
	            var key = vchild.key;
	            if (null != key) {
	                if (keyedLen && void 0 !== keyed[key]) {
	                    child = keyed[key];
	                    keyed[key] = void 0;
	                    keyedLen--;
	                }
	            } else if (min < childrenLen) for (j = min; j < childrenLen; j++) if (void 0 !== children[j] && isSameNodeType(c = children[j], vchild, isHydrating)) {
	                child = c;
	                children[j] = void 0;
	                if (j === childrenLen - 1) childrenLen--;
	                if (j === min) min++;
	                break;
	            }
	            child = idiff(child, vchild, context, mountAll);
	            f = originalChildren[i];
	            if (child && child !== dom && child !== f) if (null == f) dom.appendChild(child); else if (child === f.nextSibling) removeNode(f); else dom.insertBefore(child, f);
	        }
	        if (keyedLen) for (var i in keyed) if (void 0 !== keyed[i]) recollectNodeTree(keyed[i], !1);
	        while (min <= childrenLen) if (void 0 !== (child = children[childrenLen--])) recollectNodeTree(child, !1);
	    }
	    function recollectNodeTree(node, unmountOnly) {
	        var component = node._component;
	        if (component) unmountComponent(component); else {
	            if (null != node.__preactattr_) applyRef(node.__preactattr_.ref, null);
	            if (!1 === unmountOnly || null == node.__preactattr_) removeNode(node);
	            removeChildren(node);
	        }
	    }
	    function removeChildren(node) {
	        node = node.lastChild;
	        while (node) {
	            var next = node.previousSibling;
	            recollectNodeTree(node, !0);
	            node = next;
	        }
	    }
	    function diffAttributes(dom, attrs, old) {
	        var name;
	        for (name in old) if ((!attrs || null == attrs[name]) && null != old[name]) setAccessor(dom, name, old[name], old[name] = void 0, isSvgMode);
	        for (name in attrs) if (!('children' === name || 'innerHTML' === name || name in old && attrs[name] === ('value' === name || 'checked' === name ? dom[name] : old[name]))) setAccessor(dom, name, old[name], old[name] = attrs[name], isSvgMode);
	    }
	    function createComponent(Ctor, props, context) {
	        var inst, i = recyclerComponents.length;
	        if (Ctor.prototype && Ctor.prototype.render) {
	            inst = new Ctor(props, context);
	            Component.call(inst, props, context);
	        } else {
	            inst = new Component(props, context);
	            inst.constructor = Ctor;
	            inst.render = doRender;
	        }
	        while (i--) if (recyclerComponents[i].constructor === Ctor) {
	            inst.__b = recyclerComponents[i].__b;
	            recyclerComponents.splice(i, 1);
	            return inst;
	        }
	        return inst;
	    }
	    function doRender(props, state, context) {
	        return this.constructor(props, context);
	    }
	    function setComponentProps(component, props, renderMode, context, mountAll) {
	        if (!component.__x) {
	            component.__x = !0;
	            component.__r = props.ref;
	            component.__k = props.key;
	            delete props.ref;
	            delete props.key;
	            if (void 0 === component.constructor.getDerivedStateFromProps) if (!component.base || mountAll) {
	                if (component.componentWillMount) component.componentWillMount();
	            } else if (component.componentWillReceiveProps) component.componentWillReceiveProps(props, context);
	            if (context && context !== component.context) {
	                if (!component.__c) component.__c = component.context;
	                component.context = context;
	            }
	            if (!component.__p) component.__p = component.props;
	            component.props = props;
	            component.__x = !1;
	            if (0 !== renderMode) if (1 === renderMode || !1 !== options.syncComponentUpdates || !component.base) renderComponent(component, 1, mountAll); else enqueueRender(component);
	            applyRef(component.__r, component);
	        }
	    }
	    function renderComponent(component, renderMode, mountAll, isChild) {
	        if (!component.__x) {
	            var rendered, inst, cbase, props = component.props, state = component.state, context = component.context, previousProps = component.__p || props, previousState = component.__s || state, previousContext = component.__c || context, isUpdate = component.base, nextBase = component.__b, initialBase = isUpdate || nextBase, initialChildComponent = component._component, skip = !1, snapshot = previousContext;
	            if (component.constructor.getDerivedStateFromProps) {
	                state = extend(extend({}, state), component.constructor.getDerivedStateFromProps(props, state));
	                component.state = state;
	            }
	            if (isUpdate) {
	                component.props = previousProps;
	                component.state = previousState;
	                component.context = previousContext;
	                if (2 !== renderMode && component.shouldComponentUpdate && !1 === component.shouldComponentUpdate(props, state, context)) skip = !0; else if (component.componentWillUpdate) component.componentWillUpdate(props, state, context);
	                component.props = props;
	                component.state = state;
	                component.context = context;
	            }
	            component.__p = component.__s = component.__c = component.__b = null;
	            component.__d = !1;
	            if (!skip) {
	                rendered = component.render(props, state, context);
	                if (component.getChildContext) context = extend(extend({}, context), component.getChildContext());
	                if (isUpdate && component.getSnapshotBeforeUpdate) snapshot = component.getSnapshotBeforeUpdate(previousProps, previousState);
	                var toUnmount, base, childComponent = rendered && rendered.nodeName;
	                if ('function' == typeof childComponent) {
	                    var childProps = getNodeProps(rendered);
	                    inst = initialChildComponent;
	                    if (inst && inst.constructor === childComponent && childProps.key == inst.__k) setComponentProps(inst, childProps, 1, context, !1); else {
	                        toUnmount = inst;
	                        component._component = inst = createComponent(childComponent, childProps, context);
	                        inst.__b = inst.__b || nextBase;
	                        inst.__u = component;
	                        setComponentProps(inst, childProps, 0, context, !1);
	                        renderComponent(inst, 1, mountAll, !0);
	                    }
	                    base = inst.base;
	                } else {
	                    cbase = initialBase;
	                    toUnmount = initialChildComponent;
	                    if (toUnmount) cbase = component._component = null;
	                    if (initialBase || 1 === renderMode) {
	                        if (cbase) cbase._component = null;
	                        base = diff(cbase, rendered, context, mountAll || !isUpdate, initialBase && initialBase.parentNode, !0);
	                    }
	                }
	                if (initialBase && base !== initialBase && inst !== initialChildComponent) {
	                    var baseParent = initialBase.parentNode;
	                    if (baseParent && base !== baseParent) {
	                        baseParent.replaceChild(base, initialBase);
	                        if (!toUnmount) {
	                            initialBase._component = null;
	                            recollectNodeTree(initialBase, !1);
	                        }
	                    }
	                }
	                if (toUnmount) unmountComponent(toUnmount);
	                component.base = base;
	                if (base && !isChild) {
	                    var componentRef = component, t = component;
	                    while (t = t.__u) (componentRef = t).base = base;
	                    base._component = componentRef;
	                    base._componentConstructor = componentRef.constructor;
	                }
	            }
	            if (!isUpdate || mountAll) mounts.push(component); else if (!skip) {
	                if (component.componentDidUpdate) component.componentDidUpdate(previousProps, previousState, snapshot);
	                if (options.afterUpdate) options.afterUpdate(component);
	            }
	            while (component.__h.length) component.__h.pop().call(component);
	            if (!diffLevel && !isChild) flushMounts();
	        }
	    }
	    function buildComponentFromVNode(dom, vnode, context, mountAll) {
	        var c = dom && dom._component, originalComponent = c, oldDom = dom, isDirectOwner = c && dom._componentConstructor === vnode.nodeName, isOwner = isDirectOwner, props = getNodeProps(vnode);
	        while (c && !isOwner && (c = c.__u)) isOwner = c.constructor === vnode.nodeName;
	        if (c && isOwner && (!mountAll || c._component)) {
	            setComponentProps(c, props, 3, context, mountAll);
	            dom = c.base;
	        } else {
	            if (originalComponent && !isDirectOwner) {
	                unmountComponent(originalComponent);
	                dom = oldDom = null;
	            }
	            c = createComponent(vnode.nodeName, props, context);
	            if (dom && !c.__b) {
	                c.__b = dom;
	                oldDom = null;
	            }
	            setComponentProps(c, props, 1, context, mountAll);
	            dom = c.base;
	            if (oldDom && dom !== oldDom) {
	                oldDom._component = null;
	                recollectNodeTree(oldDom, !1);
	            }
	        }
	        return dom;
	    }
	    function unmountComponent(component) {
	        if (options.beforeUnmount) options.beforeUnmount(component);
	        var base = component.base;
	        component.__x = !0;
	        if (component.componentWillUnmount) component.componentWillUnmount();
	        component.base = null;
	        var inner = component._component;
	        if (inner) unmountComponent(inner); else if (base) {
	            if (null != base.__preactattr_) applyRef(base.__preactattr_.ref, null);
	            component.__b = base;
	            removeNode(base);
	            recyclerComponents.push(component);
	            removeChildren(base);
	        }
	        applyRef(component.__r, null);
	    }
	    function Component(props, context) {
	        this.__d = !0;
	        this.context = context;
	        this.props = props;
	        this.state = this.state || {};
	        this.__h = [];
	    }
	    function render(vnode, parent, merge) {
	        return diff(merge, vnode, {}, !1, parent, !1);
	    }
	    function createRef() {
	        return {};
	    }
	    var VNode = function() {};
	    var options = {};
	    var stack = [];
	    var EMPTY_CHILDREN = [];
	    var defer = 'function' == typeof Promise ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout;
	    var IS_NON_DIMENSIONAL = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i;
	    var items = [];
	    var mounts = [];
	    var diffLevel = 0;
	    var isSvgMode = !1;
	    var hydrating = !1;
	    var recyclerComponents = [];
	    extend(Component.prototype, {
	        setState: function(state, callback) {
	            if (!this.__s) this.__s = this.state;
	            this.state = extend(extend({}, this.state), 'function' == typeof state ? state(this.state, this.props) : state);
	            if (callback) this.__h.push(callback);
	            enqueueRender(this);
	        },
	        forceUpdate: function(callback) {
	            if (callback) this.__h.push(callback);
	            renderComponent(this, 2);
	        },
	        render: function() {}
	    });
	    var preact = {
	        h: h,
	        createElement: h,
	        cloneElement: cloneElement,
	        createRef: createRef,
	        Component: Component,
	        render: render,
	        rerender: rerender,
	        options: options
	    };
	    if (true) module.exports = preact; else self.preact = preact;
	}();
	//# sourceMappingURL=preact.js.map

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var prosemirrorModel = __webpack_require__(12);
	
	// Mappable:: interface
	// There are several things that positions can be mapped through.
	// Such objects conform to this interface.
	//
	//   map:: (pos: number, assoc: ?number) → number
	//   Map a position through this object. When given, `assoc` (should
	//   be -1 or 1, defaults to 1) determines with which side the
	//   position is associated, which determines in which direction to
	//   move when a chunk of content is inserted at the mapped position.
	//
	//   mapResult:: (pos: number, assoc: ?number) → MapResult
	//   Map a position, and return an object containing additional
	//   information about the mapping. The result's `deleted` field tells
	//   you whether the position was deleted (completely enclosed in a
	//   replaced range) during the mapping. When content on only one side
	//   is deleted, the position itself is only considered deleted when
	//   `assoc` points in the direction of the deleted content.
	
	// Recovery values encode a range index and an offset. They are
	// represented as numbers, because tons of them will be created when
	// mapping, for example, a large number of decorations. The number's
	// lower 16 bits provide the index, the remaining bits the offset.
	//
	// Note: We intentionally don't use bit shift operators to en- and
	// decode these, since those clip to 32 bits, which we might in rare
	// cases want to overflow. A 64-bit float can represent 48-bit
	// integers precisely.
	
	var lower16 = 0xffff;
	var factor16 = Math.pow(2, 16);
	
	function makeRecover(index, offset) { return index + offset * factor16 }
	function recoverIndex(value) { return value & lower16 }
	function recoverOffset(value) { return (value - (value & lower16)) / factor16 }
	
	// ::- An object representing a mapped position with extra
	// information.
	var MapResult = function MapResult(pos, deleted, recover) {
	  if ( deleted === void 0 ) deleted = false;
	  if ( recover === void 0 ) recover = null;
	
	  // :: number The mapped version of the position.
	  this.pos = pos;
	  // :: bool Tells you whether the position was deleted, that is,
	  // whether the step removed its surroundings from the document.
	  this.deleted = deleted;
	  this.recover = recover;
	};
	
	// :: class extends Mappable
	// A map describing the deletions and insertions made by a step, which
	// can be used to find the correspondence between positions in the
	// pre-step version of a document and the same position in the
	// post-step version.
	var StepMap = function StepMap(ranges, inverted) {
	  if ( inverted === void 0 ) inverted = false;
	
	  this.ranges = ranges;
	  this.inverted = inverted;
	};
	
	StepMap.prototype.recover = function recover (value) {
	  var diff = 0, index = recoverIndex(value);
	  if (!this.inverted) { for (var i = 0; i < index; i++)
	    { diff += this.ranges[i * 3 + 2] - this.ranges[i * 3 + 1]; } }
	  return this.ranges[index * 3] + diff + recoverOffset(value)
	};
	
	// : (number, ?number) → MapResult
	StepMap.prototype.mapResult = function mapResult (pos, assoc) {
	  if ( assoc === void 0 ) assoc = 1;
	 return this._map(pos, assoc, false) };
	
	// : (number, ?number) → number
	StepMap.prototype.map = function map (pos, assoc) {
	  if ( assoc === void 0 ) assoc = 1;
	 return this._map(pos, assoc, true) };
	
	StepMap.prototype._map = function _map (pos, assoc, simple) {
	  var diff = 0, oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
	  for (var i = 0; i < this.ranges.length; i += 3) {
	    var start = this.ranges[i] - (this.inverted ? diff : 0);
	    if (start > pos) { break }
	    var oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex], end = start + oldSize;
	    if (pos <= end) {
	      var side = !oldSize ? assoc : pos == start ? -1 : pos == end ? 1 : assoc;
	      var result = start + diff + (side < 0 ? 0 : newSize);
	      if (simple) { return result }
	      var recover = makeRecover(i / 3, pos - start);
	      return new MapResult(result, assoc < 0 ? pos != start : pos != end, recover)
	    }
	    diff += newSize - oldSize;
	  }
	  return simple ? pos + diff : new MapResult(pos + diff)
	};
	
	StepMap.prototype.touches = function touches (pos, recover) {
	  var diff = 0, index = recoverIndex(recover);
	  var oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
	  for (var i = 0; i < this.ranges.length; i += 3) {
	    var start = this.ranges[i] - (this.inverted ? diff : 0);
	    if (start > pos) { break }
	    var oldSize = this.ranges[i + oldIndex], end = start + oldSize;
	    if (pos <= end && i == index * 3) { return true }
	    diff += this.ranges[i + newIndex] - oldSize;
	  }
	  return false
	};
	
	// :: ((oldStart: number, oldEnd: number, newStart: number, newEnd: number))
	// Calls the given function on each of the changed ranges included in
	// this map.
	StepMap.prototype.forEach = function forEach (f) {
	  var oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
	  for (var i = 0, diff = 0; i < this.ranges.length; i += 3) {
	    var start = this.ranges[i], oldStart = start - (this.inverted ? diff : 0), newStart = start + (this.inverted ? 0 : diff);
	    var oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex];
	    f(oldStart, oldStart + oldSize, newStart, newStart + newSize);
	    diff += newSize - oldSize;
	  }
	};
	
	// :: () → StepMap
	// Create an inverted version of this map. The result can be used to
	// map positions in the post-step document to the pre-step document.
	StepMap.prototype.invert = function invert () {
	  return new StepMap(this.ranges, !this.inverted)
	};
	
	StepMap.prototype.toString = function toString () {
	  return (this.inverted ? "-" : "") + JSON.stringify(this.ranges)
	};
	
	// :: (n: number) → StepMap
	// Create a map that moves all positions by offset `n` (which may be
	// negative). This can be useful when applying steps meant for a
	// sub-document to a larger document, or vice-versa.
	StepMap.offset = function offset (n) {
	  return n == 0 ? StepMap.empty : new StepMap(n < 0 ? [0, -n, 0] : [0, 0, n])
	};
	
	StepMap.empty = new StepMap([]);
	
	// :: class extends Mappable
	// A mapping represents a pipeline of zero or more [step
	// maps](#transform.StepMap). It has special provisions for losslessly
	// handling mapping positions through a series of steps in which some
	// steps are inverted versions of earlier steps. (This comes up when
	// ‘[rebasing](/docs/guide/#transform.rebasing)’ steps for
	// collaboration or history management.)
	var Mapping = function Mapping(maps, mirror, from, to) {
	  // :: [StepMap]
	  // The step maps in this mapping.
	  this.maps = maps || [];
	  // :: number
	  // The starting position in the `maps` array, used when `map` or
	  // `mapResult` is called.
	  this.from = from || 0;
	  // :: number
	  // The end position in the `maps` array.
	  this.to = to == null ? this.maps.length : to;
	  this.mirror = mirror;
	};
	
	// :: (?number, ?number) → Mapping
	// Create a mapping that maps only through a part of this one.
	Mapping.prototype.slice = function slice (from, to) {
	    if ( from === void 0 ) from = 0;
	    if ( to === void 0 ) to = this.maps.length;
	
	  return new Mapping(this.maps, this.mirror, from, to)
	};
	
	Mapping.prototype.copy = function copy () {
	  return new Mapping(this.maps.slice(), this.mirror && this.mirror.slice(), this.from, this.to)
	};
	
	// :: (StepMap, ?number)
	// Add a step map to the end of this mapping. If `mirrors` is
	// given, it should be the index of the step map that is the mirror
	// image of this one.
	Mapping.prototype.appendMap = function appendMap (map, mirrors) {
	  this.to = this.maps.push(map);
	  if (mirrors != null) { this.setMirror(this.maps.length - 1, mirrors); }
	};
	
	// :: (Mapping)
	// Add all the step maps in a given mapping to this one (preserving
	// mirroring information).
	Mapping.prototype.appendMapping = function appendMapping (mapping) {
	  for (var i = 0, startSize = this.maps.length; i < mapping.maps.length; i++) {
	    var mirr = mapping.getMirror(i);
	    this.appendMap(mapping.maps[i], mirr != null && mirr < i ? startSize + mirr : null);
	  }
	};
	
	// :: (number) → ?number
	// Finds the offset of the step map that mirrors the map at the
	// given offset, in this mapping (as per the second argument to
	// `appendMap`).
	Mapping.prototype.getMirror = function getMirror (n) {
	  if (this.mirror) { for (var i = 0; i < this.mirror.length; i++)
	    { if (this.mirror[i] == n) { return this.mirror[i + (i % 2 ? -1 : 1)] } } }
	};
	
	Mapping.prototype.setMirror = function setMirror (n, m) {
	  if (!this.mirror) { this.mirror = []; }
	  this.mirror.push(n, m);
	};
	
	// :: (Mapping)
	// Append the inverse of the given mapping to this one.
	Mapping.prototype.appendMappingInverted = function appendMappingInverted (mapping) {
	  for (var i = mapping.maps.length - 1, totalSize = this.maps.length + mapping.maps.length; i >= 0; i--) {
	    var mirr = mapping.getMirror(i);
	    this.appendMap(mapping.maps[i].invert(), mirr != null && mirr > i ? totalSize - mirr - 1 : null);
	  }
	};
	
	// :: () → Mapping
	// Create an inverted version of this mapping.
	Mapping.prototype.invert = function invert () {
	  var inverse = new Mapping;
	  inverse.appendMappingInverted(this);
	  return inverse
	};
	
	// : (number, ?number) → number
	// Map a position through this mapping.
	Mapping.prototype.map = function map (pos, assoc) {
	    if ( assoc === void 0 ) assoc = 1;
	
	  if (this.mirror) { return this._map(pos, assoc, true) }
	  for (var i = this.from; i < this.to; i++)
	    { pos = this.maps[i].map(pos, assoc); }
	  return pos
	};
	
	// : (number, ?number) → MapResult
	// Map a position through this mapping, returning a mapping
	// result.
	Mapping.prototype.mapResult = function mapResult (pos, assoc) {
	  if ( assoc === void 0 ) assoc = 1;
	 return this._map(pos, assoc, false) };
	
	Mapping.prototype._map = function _map (pos, assoc, simple) {
	  var deleted = false, recoverables = null;
	
	  for (var i = this.from; i < this.to; i++) {
	    var map = this.maps[i], rec = recoverables && recoverables[i];
	    if (rec != null && map.touches(pos, rec)) {
	      pos = map.recover(rec);
	      continue
	    }
	
	    var result = map.mapResult(pos, assoc);
	    if (result.recover != null) {
	      var corr = this.getMirror(i);
	      if (corr != null && corr > i && corr < this.to) {
	        if (result.deleted) {
	          i = corr;
	          pos = this.maps[corr].recover(result.recover);
	          continue
	        } else {
	(recoverables || (recoverables = Object.create(null)))[corr] = result.recover;
	        }
	      }
	    }
	
	    if (result.deleted) { deleted = true; }
	    pos = result.pos;
	  }
	
	  return simple ? pos : new MapResult(pos, deleted)
	};
	
	function TransformError(message) {
	  var err = Error.call(this, message);
	  err.__proto__ = TransformError.prototype;
	  return err
	}
	
	TransformError.prototype = Object.create(Error.prototype);
	TransformError.prototype.constructor = TransformError;
	TransformError.prototype.name = "TransformError";
	
	// ::- Abstraction to build up and track an array of
	// [steps](#transform.Step) representing a document transformation.
	//
	// Most transforming methods return the `Transform` object itself, so
	// that they can be chained.
	var Transform = function Transform(doc) {
	  // :: Node
	  // The current document (the result of applying the steps in the
	  // transform).
	  this.doc = doc;
	  // :: [Step]
	  // The steps in this transform.
	  this.steps = [];
	  // :: [Node]
	  // The documents before each of the steps.
	  this.docs = [];
	  // :: Mapping
	  // A mapping with the maps for each of the steps in this transform.
	  this.mapping = new Mapping;
	};
	
	var prototypeAccessors = { before: { configurable: true },docChanged: { configurable: true } };
	
	// :: Node The starting document.
	prototypeAccessors.before.get = function () { return this.docs.length ? this.docs[0] : this.doc };
	
	// :: (step: Step) → this
	// Apply a new step in this transform, saving the result. Throws an
	// error when the step fails.
	Transform.prototype.step = function step (object) {
	  var result = this.maybeStep(object);
	  if (result.failed) { throw new TransformError(result.failed) }
	  return this
	};
	
	// :: (Step) → StepResult
	// Try to apply a step in this transformation, ignoring it if it
	// fails. Returns the step result.
	Transform.prototype.maybeStep = function maybeStep (step) {
	  var result = step.apply(this.doc);
	  if (!result.failed) { this.addStep(step, result.doc); }
	  return result
	};
	
	// :: bool
	// True when the document has been changed (when there are any
	// steps).
	prototypeAccessors.docChanged.get = function () {
	  return this.steps.length > 0
	};
	
	Transform.prototype.addStep = function addStep (step, doc) {
	  this.docs.push(this.doc);
	  this.steps.push(step);
	  this.mapping.appendMap(step.getMap());
	  this.doc = doc;
	};
	
	Object.defineProperties( Transform.prototype, prototypeAccessors );
	
	function mustOverride() { throw new Error("Override me") }
	
	var stepsByID = Object.create(null);
	
	// ::- A step object represents an atomic change. It generally applies
	// only to the document it was created for, since the positions
	// stored in it will only make sense for that document.
	//
	// New steps are defined by creating classes that extend `Step`,
	// overriding the `apply`, `invert`, `map`, `getMap` and `fromJSON`
	// methods, and registering your class with a unique
	// JSON-serialization identifier using
	// [`Step.jsonID`](#transform.Step^jsonID).
	var Step = function Step () {};
	
	Step.prototype.apply = function apply (_doc) { return mustOverride() };
	
	// :: () → StepMap
	// Get the step map that represents the changes made by this step,
	// and which can be used to transform between positions in the old
	// and the new document.
	Step.prototype.getMap = function getMap () { return StepMap.empty };
	
	// :: (doc: Node) → Step
	// Create an inverted version of this step. Needs the document as it
	// was before the step as argument.
	Step.prototype.invert = function invert (_doc) { return mustOverride() };
	
	// :: (mapping: Mappable) → ?Step
	// Map this step through a mappable thing, returning either a
	// version of that step with its positions adjusted, or `null` if
	// the step was entirely deleted by the mapping.
	Step.prototype.map = function map (_mapping) { return mustOverride() };
	
	// :: (other: Step) → ?Step
	// Try to merge this step with another one, to be applied directly
	// after it. Returns the merged step when possible, null if the
	// steps can't be merged.
	Step.prototype.merge = function merge (_other) { return null };
	
	// :: () → Object
	// Create a JSON-serializeable representation of this step. When
	// defining this for a custom subclass, make sure the result object
	// includes the step type's [JSON id](#transform.Step^jsonID) under
	// the `stepType` property.
	Step.prototype.toJSON = function toJSON () { return mustOverride() };
	
	// :: (Schema, Object) → Step
	// Deserialize a step from its JSON representation. Will call
	// through to the step class' own implementation of this method.
	Step.fromJSON = function fromJSON (schema, json) {
	  if (!json || !json.stepType) { throw new RangeError("Invalid input for Step.fromJSON") }
	  var type = stepsByID[json.stepType];
	  if (!type) { throw new RangeError(("No step type " + (json.stepType) + " defined")) }
	  return type.fromJSON(schema, json)
	};
	
	// :: (string, constructor<Step>)
	// To be able to serialize steps to JSON, each step needs a string
	// ID to attach to its JSON representation. Use this method to
	// register an ID for your step classes. Try to pick something
	// that's unlikely to clash with steps from other modules.
	Step.jsonID = function jsonID (id, stepClass) {
	  if (id in stepsByID) { throw new RangeError("Duplicate use of step JSON ID " + id) }
	  stepsByID[id] = stepClass;
	  stepClass.prototype.jsonID = id;
	  return stepClass
	};
	
	// ::- The result of [applying](#transform.Step.apply) a step. Contains either a
	// new document or a failure value.
	var StepResult = function StepResult(doc, failed) {
	  // :: ?Node The transformed document.
	  this.doc = doc;
	  // :: ?string Text providing information about a failed step.
	  this.failed = failed;
	};
	
	// :: (Node) → StepResult
	// Create a successful step result.
	StepResult.ok = function ok (doc) { return new StepResult(doc, null) };
	
	// :: (string) → StepResult
	// Create a failed step result.
	StepResult.fail = function fail (message) { return new StepResult(null, message) };
	
	// :: (Node, number, number, Slice) → StepResult
	// Call [`Node.replace`](#model.Node.replace) with the given
	// arguments. Create a successful result if it succeeds, and a
	// failed one if it throws a `ReplaceError`.
	StepResult.fromReplace = function fromReplace (doc, from, to, slice) {
	  try {
	    return StepResult.ok(doc.replace(from, to, slice))
	  } catch (e) {
	    if (e instanceof prosemirrorModel.ReplaceError) { return StepResult.fail(e.message) }
	    throw e
	  }
	};
	
	// ::- Replace a part of the document with a slice of new content.
	var ReplaceStep = /*@__PURE__*/(function (Step) {
	  function ReplaceStep(from, to, slice, structure) {
	    Step.call(this);
	    this.from = from;
	    this.to = to;
	    this.slice = slice;
	    this.structure = !!structure;
	  }
	
	  if ( Step ) ReplaceStep.__proto__ = Step;
	  ReplaceStep.prototype = Object.create( Step && Step.prototype );
	  ReplaceStep.prototype.constructor = ReplaceStep;
	
	  ReplaceStep.prototype.apply = function apply (doc) {
	    if (this.structure && contentBetween(doc, this.from, this.to))
	      { return StepResult.fail("Structure replace would overwrite content") }
	    return StepResult.fromReplace(doc, this.from, this.to, this.slice)
	  };
	
	  ReplaceStep.prototype.getMap = function getMap () {
	    return new StepMap([this.from, this.to - this.from, this.slice.size])
	  };
	
	  ReplaceStep.prototype.invert = function invert (doc) {
	    return new ReplaceStep(this.from, this.from + this.slice.size, doc.slice(this.from, this.to))
	  };
	
	  ReplaceStep.prototype.map = function map (mapping) {
	    var from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
	    if (from.deleted && to.deleted) { return null }
	    return new ReplaceStep(from.pos, Math.max(from.pos, to.pos), this.slice)
	  };
	
	  ReplaceStep.prototype.merge = function merge (other) {
	    if (!(other instanceof ReplaceStep) || other.structure != this.structure) { return null }
	
	    if (this.from + this.slice.size == other.from && !this.slice.openEnd && !other.slice.openStart) {
	      var slice = this.slice.size + other.slice.size == 0 ? prosemirrorModel.Slice.empty
	          : new prosemirrorModel.Slice(this.slice.content.append(other.slice.content), this.slice.openStart, other.slice.openEnd);
	      return new ReplaceStep(this.from, this.to + (other.to - other.from), slice, this.structure)
	    } else if (other.to == this.from && !this.slice.openStart && !other.slice.openEnd) {
	      var slice$1 = this.slice.size + other.slice.size == 0 ? prosemirrorModel.Slice.empty
	          : new prosemirrorModel.Slice(other.slice.content.append(this.slice.content), other.slice.openStart, this.slice.openEnd);
	      return new ReplaceStep(other.from, this.to, slice$1, this.structure)
	    } else {
	      return null
	    }
	  };
	
	  ReplaceStep.prototype.toJSON = function toJSON () {
	    var json = {stepType: "replace", from: this.from, to: this.to};
	    if (this.slice.size) { json.slice = this.slice.toJSON(); }
	    if (this.structure) { json.structure = true; }
	    return json
	  };
	
	  ReplaceStep.fromJSON = function fromJSON (schema, json) {
	    if (typeof json.from != "number" || typeof json.to != "number")
	      { throw new RangeError("Invalid input for ReplaceStep.fromJSON") }
	    return new ReplaceStep(json.from, json.to, prosemirrorModel.Slice.fromJSON(schema, json.slice), !!json.structure)
	  };
	
	  return ReplaceStep;
	}(Step));
	
	Step.jsonID("replace", ReplaceStep);
	
	// ::- Replace a part of the document with a slice of content, but
	// preserve a range of the replaced content by moving it into the
	// slice.
	var ReplaceAroundStep = /*@__PURE__*/(function (Step) {
	  function ReplaceAroundStep(from, to, gapFrom, gapTo, slice, insert, structure) {
	    Step.call(this);
	    this.from = from;
	    this.to = to;
	    this.gapFrom = gapFrom;
	    this.gapTo = gapTo;
	    this.slice = slice;
	    this.insert = insert;
	    this.structure = !!structure;
	  }
	
	  if ( Step ) ReplaceAroundStep.__proto__ = Step;
	  ReplaceAroundStep.prototype = Object.create( Step && Step.prototype );
	  ReplaceAroundStep.prototype.constructor = ReplaceAroundStep;
	
	  ReplaceAroundStep.prototype.apply = function apply (doc) {
	    if (this.structure && (contentBetween(doc, this.from, this.gapFrom) ||
	                           contentBetween(doc, this.gapTo, this.to)))
	      { return StepResult.fail("Structure gap-replace would overwrite content") }
	
	    var gap = doc.slice(this.gapFrom, this.gapTo);
	    if (gap.openStart || gap.openEnd)
	      { return StepResult.fail("Gap is not a flat range") }
	    var inserted = this.slice.insertAt(this.insert, gap.content);
	    if (!inserted) { return StepResult.fail("Content does not fit in gap") }
	    return StepResult.fromReplace(doc, this.from, this.to, inserted)
	  };
	
	  ReplaceAroundStep.prototype.getMap = function getMap () {
	    return new StepMap([this.from, this.gapFrom - this.from, this.insert,
	                        this.gapTo, this.to - this.gapTo, this.slice.size - this.insert])
	  };
	
	  ReplaceAroundStep.prototype.invert = function invert (doc) {
	    var gap = this.gapTo - this.gapFrom;
	    return new ReplaceAroundStep(this.from, this.from + this.slice.size + gap,
	                                 this.from + this.insert, this.from + this.insert + gap,
	                                 doc.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from),
	                                 this.gapFrom - this.from, this.structure)
	  };
	
	  ReplaceAroundStep.prototype.map = function map (mapping) {
	    var from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
	    var gapFrom = mapping.map(this.gapFrom, -1), gapTo = mapping.map(this.gapTo, 1);
	    if ((from.deleted && to.deleted) || gapFrom < from.pos || gapTo > to.pos) { return null }
	    return new ReplaceAroundStep(from.pos, to.pos, gapFrom, gapTo, this.slice, this.insert, this.structure)
	  };
	
	  ReplaceAroundStep.prototype.toJSON = function toJSON () {
	    var json = {stepType: "replaceAround", from: this.from, to: this.to,
	                gapFrom: this.gapFrom, gapTo: this.gapTo, insert: this.insert};
	    if (this.slice.size) { json.slice = this.slice.toJSON(); }
	    if (this.structure) { json.structure = true; }
	    return json
	  };
	
	  ReplaceAroundStep.fromJSON = function fromJSON (schema, json) {
	    if (typeof json.from != "number" || typeof json.to != "number" ||
	        typeof json.gapFrom != "number" || typeof json.gapTo != "number" || typeof json.insert != "number")
	      { throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON") }
	    return new ReplaceAroundStep(json.from, json.to, json.gapFrom, json.gapTo,
	                                 prosemirrorModel.Slice.fromJSON(schema, json.slice), json.insert, !!json.structure)
	  };
	
	  return ReplaceAroundStep;
	}(Step));
	
	Step.jsonID("replaceAround", ReplaceAroundStep);
	
	function contentBetween(doc, from, to) {
	  var $from = doc.resolve(from), dist = to - from, depth = $from.depth;
	  while (dist > 0 && depth > 0 && $from.indexAfter(depth) == $from.node(depth).childCount) {
	    depth--;
	    dist--;
	  }
	  if (dist > 0) {
	    var next = $from.node(depth).maybeChild($from.indexAfter(depth));
	    while (dist > 0) {
	      if (!next || next.isLeaf) { return true }
	      next = next.firstChild;
	      dist--;
	    }
	  }
	  return false
	}
	
	function canCut(node, start, end) {
	  return (start == 0 || node.canReplace(start, node.childCount)) &&
	    (end == node.childCount || node.canReplace(0, end))
	}
	
	// :: (NodeRange) → ?number
	// Try to find a target depth to which the content in the given range
	// can be lifted. Will not go across
	// [isolating](#model.NodeSpec.isolating) parent nodes.
	function liftTarget(range) {
	  var parent = range.parent;
	  var content = parent.content.cutByIndex(range.startIndex, range.endIndex);
	  for (var depth = range.depth;; --depth) {
	    var node = range.$from.node(depth);
	    var index = range.$from.index(depth), endIndex = range.$to.indexAfter(depth);
	    if (depth < range.depth && node.canReplace(index, endIndex, content))
	      { return depth }
	    if (depth == 0 || node.type.spec.isolating || !canCut(node, index, endIndex)) { break }
	  }
	}
	
	// :: (NodeRange, number) → this
	// Split the content in the given range off from its parent, if there
	// is sibling content before or after it, and move it up the tree to
	// the depth specified by `target`. You'll probably want to use
	// [`liftTarget`](#transform.liftTarget) to compute `target`, to make
	// sure the lift is valid.
	Transform.prototype.lift = function(range, target) {
	  var $from = range.$from;
	  var $to = range.$to;
	  var depth = range.depth;
	
	  var gapStart = $from.before(depth + 1), gapEnd = $to.after(depth + 1);
	  var start = gapStart, end = gapEnd;
	
	  var before = prosemirrorModel.Fragment.empty, openStart = 0;
	  for (var d = depth, splitting = false; d > target; d--)
	    { if (splitting || $from.index(d) > 0) {
	      splitting = true;
	      before = prosemirrorModel.Fragment.from($from.node(d).copy(before));
	      openStart++;
	    } else {
	      start--;
	    } }
	  var after = prosemirrorModel.Fragment.empty, openEnd = 0;
	  for (var d$1 = depth, splitting$1 = false; d$1 > target; d$1--)
	    { if (splitting$1 || $to.after(d$1 + 1) < $to.end(d$1)) {
	      splitting$1 = true;
	      after = prosemirrorModel.Fragment.from($to.node(d$1).copy(after));
	      openEnd++;
	    } else {
	      end++;
	    } }
	
	  return this.step(new ReplaceAroundStep(start, end, gapStart, gapEnd,
	                                         new prosemirrorModel.Slice(before.append(after), openStart, openEnd),
	                                         before.size - openStart, true))
	};
	
	// :: (NodeRange, NodeType, ?Object, ?NodeRange) → ?[{type: NodeType, attrs: ?Object}]
	// Try to find a valid way to wrap the content in the given range in a
	// node of the given type. May introduce extra nodes around and inside
	// the wrapper node, if necessary. Returns null if no valid wrapping
	// could be found. When `innerRange` is given, that range's content is
	// used as the content to fit into the wrapping, instead of the
	// content of `range`.
	function findWrapping(range, nodeType, attrs, innerRange) {
	  if ( innerRange === void 0 ) innerRange = range;
	
	  var around = findWrappingOutside(range, nodeType);
	  var inner = around && findWrappingInside(innerRange, nodeType);
	  if (!inner) { return null }
	  return around.map(withAttrs).concat({type: nodeType, attrs: attrs}).concat(inner.map(withAttrs))
	}
	
	function withAttrs(type) { return {type: type, attrs: null} }
	
	function findWrappingOutside(range, type) {
	  var parent = range.parent;
	  var startIndex = range.startIndex;
	  var endIndex = range.endIndex;
	  var around = parent.contentMatchAt(startIndex).findWrapping(type);
	  if (!around) { return null }
	  var outer = around.length ? around[0] : type;
	  return parent.canReplaceWith(startIndex, endIndex, outer) ? around : null
	}
	
	function findWrappingInside(range, type) {
	  var parent = range.parent;
	  var startIndex = range.startIndex;
	  var endIndex = range.endIndex;
	  var inner = parent.child(startIndex);
	  var inside = type.contentMatch.findWrapping(inner.type);
	  if (!inside) { return null }
	  var lastType = inside.length ? inside[inside.length - 1] : type;
	  var innerMatch = lastType.contentMatch;
	  for (var i = startIndex; innerMatch && i < endIndex; i++)
	    { innerMatch = innerMatch.matchType(parent.child(i).type); }
	  if (!innerMatch || !innerMatch.validEnd) { return null }
	  return inside
	}
	
	// :: (NodeRange, [{type: NodeType, attrs: ?Object}]) → this
	// Wrap the given [range](#model.NodeRange) in the given set of wrappers.
	// The wrappers are assumed to be valid in this position, and should
	// probably be computed with [`findWrapping`](#transform.findWrapping).
	Transform.prototype.wrap = function(range, wrappers) {
	  var content = prosemirrorModel.Fragment.empty;
	  for (var i = wrappers.length - 1; i >= 0; i--)
	    { content = prosemirrorModel.Fragment.from(wrappers[i].type.create(wrappers[i].attrs, content)); }
	
	  var start = range.start, end = range.end;
	  return this.step(new ReplaceAroundStep(start, end, start, end, new prosemirrorModel.Slice(content, 0, 0), wrappers.length, true))
	};
	
	// :: (number, ?number, NodeType, ?Object) → this
	// Set the type of all textblocks (partly) between `from` and `to` to
	// the given node type with the given attributes.
	Transform.prototype.setBlockType = function(from, to, type, attrs) {
	  var this$1 = this;
	  if ( to === void 0 ) to = from;
	
	  if (!type.isTextblock) { throw new RangeError("Type given to setBlockType should be a textblock") }
	  var mapFrom = this.steps.length;
	  this.doc.nodesBetween(from, to, function (node, pos) {
	    if (node.isTextblock && !node.hasMarkup(type, attrs) && canChangeType(this$1.doc, this$1.mapping.slice(mapFrom).map(pos), type)) {
	      // Ensure all markup that isn't allowed in the new node type is cleared
	      this$1.clearIncompatible(this$1.mapping.slice(mapFrom).map(pos, 1), type);
	      var mapping = this$1.mapping.slice(mapFrom);
	      var startM = mapping.map(pos, 1), endM = mapping.map(pos + node.nodeSize, 1);
	      this$1.step(new ReplaceAroundStep(startM, endM, startM + 1, endM - 1,
	                                      new prosemirrorModel.Slice(prosemirrorModel.Fragment.from(type.create(attrs, null, node.marks)), 0, 0), 1, true));
	      return false
	    }
	  });
	  return this
	};
	
	function canChangeType(doc, pos, type) {
	  var $pos = doc.resolve(pos), index = $pos.index();
	  return $pos.parent.canReplaceWith(index, index + 1, type)
	}
	
	// :: (number, ?NodeType, ?Object, ?[Mark]) → this
	// Change the type, attributes, and/or marks of the node at `pos`.
	// When `type` isn't given, the existing node type is preserved,
	Transform.prototype.setNodeMarkup = function(pos, type, attrs, marks) {
	  var node = this.doc.nodeAt(pos);
	  if (!node) { throw new RangeError("No node at given position") }
	  if (!type) { type = node.type; }
	  var newNode = type.create(attrs, null, marks || node.marks);
	  if (node.isLeaf)
	    { return this.replaceWith(pos, pos + node.nodeSize, newNode) }
	
	  if (!type.validContent(node.content))
	    { throw new RangeError("Invalid content for node type " + type.name) }
	
	  return this.step(new ReplaceAroundStep(pos, pos + node.nodeSize, pos + 1, pos + node.nodeSize - 1,
	                                         new prosemirrorModel.Slice(prosemirrorModel.Fragment.from(newNode), 0, 0), 1, true))
	};
	
	// :: (Node, number, number, ?[?{type: NodeType, attrs: ?Object}]) → bool
	// Check whether splitting at the given position is allowed.
	function canSplit(doc, pos, depth, typesAfter) {
	  if ( depth === void 0 ) depth = 1;
	
	  var $pos = doc.resolve(pos), base = $pos.depth - depth;
	  var innerType = (typesAfter && typesAfter[typesAfter.length - 1]) || $pos.parent;
	  if (base < 0 || $pos.parent.type.spec.isolating ||
	      !$pos.parent.canReplace($pos.index(), $pos.parent.childCount) ||
	      !innerType.type.validContent($pos.parent.content.cutByIndex($pos.index(), $pos.parent.childCount)))
	    { return false }
	  for (var d = $pos.depth - 1, i = depth - 2; d > base; d--, i--) {
	    var node = $pos.node(d), index$1 = $pos.index(d);
	    if (node.type.spec.isolating) { return false }
	    var rest = node.content.cutByIndex(index$1, node.childCount);
	    var after = (typesAfter && typesAfter[i]) || node;
	    if (after != node) { rest = rest.replaceChild(0, after.type.create(after.attrs)); }
	    if (!node.canReplace(index$1 + 1, node.childCount) || !after.type.validContent(rest))
	      { return false }
	  }
	  var index = $pos.indexAfter(base);
	  var baseType = typesAfter && typesAfter[0];
	  return $pos.node(base).canReplaceWith(index, index, baseType ? baseType.type : $pos.node(base + 1).type)
	}
	
	// :: (number, ?number, ?[?{type: NodeType, attrs: ?Object}]) → this
	// Split the node at the given position, and optionally, if `depth` is
	// greater than one, any number of nodes above that. By default, the
	// parts split off will inherit the node type of the original node.
	// This can be changed by passing an array of types and attributes to
	// use after the split.
	Transform.prototype.split = function(pos, depth, typesAfter) {
	  if ( depth === void 0 ) depth = 1;
	
	  var $pos = this.doc.resolve(pos), before = prosemirrorModel.Fragment.empty, after = prosemirrorModel.Fragment.empty;
	  for (var d = $pos.depth, e = $pos.depth - depth, i = depth - 1; d > e; d--, i--) {
	    before = prosemirrorModel.Fragment.from($pos.node(d).copy(before));
	    var typeAfter = typesAfter && typesAfter[i];
	    after = prosemirrorModel.Fragment.from(typeAfter ? typeAfter.type.create(typeAfter.attrs, after) : $pos.node(d).copy(after));
	  }
	  return this.step(new ReplaceStep(pos, pos, new prosemirrorModel.Slice(before.append(after), depth, depth), true))
	};
	
	// :: (Node, number) → bool
	// Test whether the blocks before and after a given position can be
	// joined.
	function canJoin(doc, pos) {
	  var $pos = doc.resolve(pos), index = $pos.index();
	  return joinable($pos.nodeBefore, $pos.nodeAfter) &&
	    $pos.parent.canReplace(index, index + 1)
	}
	
	function joinable(a, b) {
	  return a && b && !a.isLeaf && a.canAppend(b)
	}
	
	// :: (Node, number, ?number) → ?number
	// Find an ancestor of the given position that can be joined to the
	// block before (or after if `dir` is positive). Returns the joinable
	// point, if any.
	function joinPoint(doc, pos, dir) {
	  if ( dir === void 0 ) dir = -1;
	
	  var $pos = doc.resolve(pos);
	  for (var d = $pos.depth;; d--) {
	    var before = (void 0), after = (void 0), index = $pos.index(d);
	    if (d == $pos.depth) {
	      before = $pos.nodeBefore;
	      after = $pos.nodeAfter;
	    } else if (dir > 0) {
	      before = $pos.node(d + 1);
	      index++;
	      after = $pos.node(d).maybeChild(index);
	    } else {
	      before = $pos.node(d).maybeChild(index - 1);
	      after = $pos.node(d + 1);
	    }
	    if (before && !before.isTextblock && joinable(before, after) &&
	        $pos.node(d).canReplace(index, index + 1)) { return pos }
	    if (d == 0) { break }
	    pos = dir < 0 ? $pos.before(d) : $pos.after(d);
	  }
	}
	
	// :: (number, ?number) → this
	// Join the blocks around the given position. If depth is 2, their
	// last and first siblings are also joined, and so on.
	Transform.prototype.join = function(pos, depth) {
	  if ( depth === void 0 ) depth = 1;
	
	  var step = new ReplaceStep(pos - depth, pos + depth, prosemirrorModel.Slice.empty, true);
	  return this.step(step)
	};
	
	// :: (Node, number, NodeType) → ?number
	// Try to find a point where a node of the given type can be inserted
	// near `pos`, by searching up the node hierarchy when `pos` itself
	// isn't a valid place but is at the start or end of a node. Return
	// null if no position was found.
	function insertPoint(doc, pos, nodeType) {
	  var $pos = doc.resolve(pos);
	  if ($pos.parent.canReplaceWith($pos.index(), $pos.index(), nodeType)) { return pos }
	
	  if ($pos.parentOffset == 0)
	    { for (var d = $pos.depth - 1; d >= 0; d--) {
	      var index = $pos.index(d);
	      if ($pos.node(d).canReplaceWith(index, index, nodeType)) { return $pos.before(d + 1) }
	      if (index > 0) { return null }
	    } }
	  if ($pos.parentOffset == $pos.parent.content.size)
	    { for (var d$1 = $pos.depth - 1; d$1 >= 0; d$1--) {
	      var index$1 = $pos.indexAfter(d$1);
	      if ($pos.node(d$1).canReplaceWith(index$1, index$1, nodeType)) { return $pos.after(d$1 + 1) }
	      if (index$1 < $pos.node(d$1).childCount) { return null }
	    } }
	}
	
	// :: (Node, number, Slice) → ?number
	// Finds a position at or around the given position where the given
	// slice can be inserted. Will look at parent nodes' nearest boundary
	// and try there, even if the original position wasn't directly at the
	// start or end of that node. Returns null when no position was found.
	function dropPoint(doc, pos, slice) {
	  var $pos = doc.resolve(pos);
	  if (!slice.content.size) { return pos }
	  var content = slice.content;
	  for (var i = 0; i < slice.openStart; i++) { content = content.firstChild.content; }
	  for (var pass = 1; pass <= (slice.openStart == 0 && slice.size ? 2 : 1); pass++) {
	    for (var d = $pos.depth; d >= 0; d--) {
	      var bias = d == $pos.depth ? 0 : $pos.pos <= ($pos.start(d + 1) + $pos.end(d + 1)) / 2 ? -1 : 1;
	      var insertPos = $pos.index(d) + (bias > 0 ? 1 : 0);
	      if (pass == 1
	          ? $pos.node(d).canReplace(insertPos, insertPos, content)
	          : $pos.node(d).contentMatchAt(insertPos).findWrapping(content.firstChild.type))
	        { return bias == 0 ? $pos.pos : bias < 0 ? $pos.before(d + 1) : $pos.after(d + 1) }
	    }
	  }
	  return null
	}
	
	function mapFragment(fragment, f, parent) {
	  var mapped = [];
	  for (var i = 0; i < fragment.childCount; i++) {
	    var child = fragment.child(i);
	    if (child.content.size) { child = child.copy(mapFragment(child.content, f, child)); }
	    if (child.isInline) { child = f(child, parent, i); }
	    mapped.push(child);
	  }
	  return prosemirrorModel.Fragment.fromArray(mapped)
	}
	
	// ::- Add a mark to all inline content between two positions.
	var AddMarkStep = /*@__PURE__*/(function (Step) {
	  function AddMarkStep(from, to, mark) {
	    Step.call(this);
	    this.from = from;
	    this.to = to;
	    this.mark = mark;
	  }
	
	  if ( Step ) AddMarkStep.__proto__ = Step;
	  AddMarkStep.prototype = Object.create( Step && Step.prototype );
	  AddMarkStep.prototype.constructor = AddMarkStep;
	
	  AddMarkStep.prototype.apply = function apply (doc) {
	    var this$1 = this;
	
	    var oldSlice = doc.slice(this.from, this.to), $from = doc.resolve(this.from);
	    var parent = $from.node($from.sharedDepth(this.to));
	    var slice = new prosemirrorModel.Slice(mapFragment(oldSlice.content, function (node, parent) {
	      if (!parent.type.allowsMarkType(this$1.mark.type)) { return node }
	      return node.mark(this$1.mark.addToSet(node.marks))
	    }, parent), oldSlice.openStart, oldSlice.openEnd);
	    return StepResult.fromReplace(doc, this.from, this.to, slice)
	  };
	
	  AddMarkStep.prototype.invert = function invert () {
	    return new RemoveMarkStep(this.from, this.to, this.mark)
	  };
	
	  AddMarkStep.prototype.map = function map (mapping) {
	    var from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
	    if (from.deleted && to.deleted || from.pos >= to.pos) { return null }
	    return new AddMarkStep(from.pos, to.pos, this.mark)
	  };
	
	  AddMarkStep.prototype.merge = function merge (other) {
	    if (other instanceof AddMarkStep &&
	        other.mark.eq(this.mark) &&
	        this.from <= other.to && this.to >= other.from)
	      { return new AddMarkStep(Math.min(this.from, other.from),
	                             Math.max(this.to, other.to), this.mark) }
	  };
	
	  AddMarkStep.prototype.toJSON = function toJSON () {
	    return {stepType: "addMark", mark: this.mark.toJSON(),
	            from: this.from, to: this.to}
	  };
	
	  AddMarkStep.fromJSON = function fromJSON (schema, json) {
	    if (typeof json.from != "number" || typeof json.to != "number")
	      { throw new RangeError("Invalid input for AddMarkStep.fromJSON") }
	    return new AddMarkStep(json.from, json.to, schema.markFromJSON(json.mark))
	  };
	
	  return AddMarkStep;
	}(Step));
	
	Step.jsonID("addMark", AddMarkStep);
	
	// ::- Remove a mark from all inline content between two positions.
	var RemoveMarkStep = /*@__PURE__*/(function (Step) {
	  function RemoveMarkStep(from, to, mark) {
	    Step.call(this);
	    this.from = from;
	    this.to = to;
	    this.mark = mark;
	  }
	
	  if ( Step ) RemoveMarkStep.__proto__ = Step;
	  RemoveMarkStep.prototype = Object.create( Step && Step.prototype );
	  RemoveMarkStep.prototype.constructor = RemoveMarkStep;
	
	  RemoveMarkStep.prototype.apply = function apply (doc) {
	    var this$1 = this;
	
	    var oldSlice = doc.slice(this.from, this.to);
	    var slice = new prosemirrorModel.Slice(mapFragment(oldSlice.content, function (node) {
	      return node.mark(this$1.mark.removeFromSet(node.marks))
	    }), oldSlice.openStart, oldSlice.openEnd);
	    return StepResult.fromReplace(doc, this.from, this.to, slice)
	  };
	
	  RemoveMarkStep.prototype.invert = function invert () {
	    return new AddMarkStep(this.from, this.to, this.mark)
	  };
	
	  RemoveMarkStep.prototype.map = function map (mapping) {
	    var from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
	    if (from.deleted && to.deleted || from.pos >= to.pos) { return null }
	    return new RemoveMarkStep(from.pos, to.pos, this.mark)
	  };
	
	  RemoveMarkStep.prototype.merge = function merge (other) {
	    if (other instanceof RemoveMarkStep &&
	        other.mark.eq(this.mark) &&
	        this.from <= other.to && this.to >= other.from)
	      { return new RemoveMarkStep(Math.min(this.from, other.from),
	                                Math.max(this.to, other.to), this.mark) }
	  };
	
	  RemoveMarkStep.prototype.toJSON = function toJSON () {
	    return {stepType: "removeMark", mark: this.mark.toJSON(),
	            from: this.from, to: this.to}
	  };
	
	  RemoveMarkStep.fromJSON = function fromJSON (schema, json) {
	    if (typeof json.from != "number" || typeof json.to != "number")
	      { throw new RangeError("Invalid input for RemoveMarkStep.fromJSON") }
	    return new RemoveMarkStep(json.from, json.to, schema.markFromJSON(json.mark))
	  };
	
	  return RemoveMarkStep;
	}(Step));
	
	Step.jsonID("removeMark", RemoveMarkStep);
	
	// :: (number, number, Mark) → this
	// Add the given mark to the inline content between `from` and `to`.
	Transform.prototype.addMark = function(from, to, mark) {
	  var this$1 = this;
	
	  var removed = [], added = [], removing = null, adding = null;
	  this.doc.nodesBetween(from, to, function (node, pos, parent) {
	    if (!node.isInline) { return }
	    var marks = node.marks;
	    if (!mark.isInSet(marks) && parent.type.allowsMarkType(mark.type)) {
	      var start = Math.max(pos, from), end = Math.min(pos + node.nodeSize, to);
	      var newSet = mark.addToSet(marks);
	
	      for (var i = 0; i < marks.length; i++) {
	        if (!marks[i].isInSet(newSet)) {
	          if (removing && removing.to == start && removing.mark.eq(marks[i]))
	            { removing.to = end; }
	          else
	            { removed.push(removing = new RemoveMarkStep(start, end, marks[i])); }
	        }
	      }
	
	      if (adding && adding.to == start)
	        { adding.to = end; }
	      else
	        { added.push(adding = new AddMarkStep(start, end, mark)); }
	    }
	  });
	
	  removed.forEach(function (s) { return this$1.step(s); });
	  added.forEach(function (s) { return this$1.step(s); });
	  return this
	};
	
	// :: (number, number, ?union<Mark, MarkType>) → this
	// Remove marks from inline nodes between `from` and `to`. When `mark`
	// is a single mark, remove precisely that mark. When it is a mark type,
	// remove all marks of that type. When it is null, remove all marks of
	// any type.
	Transform.prototype.removeMark = function(from, to, mark) {
	  var this$1 = this;
	  if ( mark === void 0 ) mark = null;
	
	  var matched = [], step = 0;
	  this.doc.nodesBetween(from, to, function (node, pos) {
	    if (!node.isInline) { return }
	    step++;
	    var toRemove = null;
	    if (mark instanceof prosemirrorModel.MarkType) {
	      var found = mark.isInSet(node.marks);
	      if (found) { toRemove = [found]; }
	    } else if (mark) {
	      if (mark.isInSet(node.marks)) { toRemove = [mark]; }
	    } else {
	      toRemove = node.marks;
	    }
	    if (toRemove && toRemove.length) {
	      var end = Math.min(pos + node.nodeSize, to);
	      for (var i = 0; i < toRemove.length; i++) {
	        var style = toRemove[i], found$1 = (void 0);
	        for (var j = 0; j < matched.length; j++) {
	          var m = matched[j];
	          if (m.step == step - 1 && style.eq(matched[j].style)) { found$1 = m; }
	        }
	        if (found$1) {
	          found$1.to = end;
	          found$1.step = step;
	        } else {
	          matched.push({style: style, from: Math.max(pos, from), to: end, step: step});
	        }
	      }
	    }
	  });
	  matched.forEach(function (m) { return this$1.step(new RemoveMarkStep(m.from, m.to, m.style)); });
	  return this
	};
	
	// :: (number, NodeType, ?ContentMatch) → this
	// Removes all marks and nodes from the content of the node at `pos`
	// that don't match the given new parent node type. Accepts an
	// optional starting [content match](#model.ContentMatch) as third
	// argument.
	Transform.prototype.clearIncompatible = function(pos, parentType, match) {
	  if ( match === void 0 ) match = parentType.contentMatch;
	
	  var node = this.doc.nodeAt(pos);
	  var delSteps = [], cur = pos + 1;
	  for (var i = 0; i < node.childCount; i++) {
	    var child = node.child(i), end = cur + child.nodeSize;
	    var allowed = match.matchType(child.type, child.attrs);
	    if (!allowed) {
	      delSteps.push(new ReplaceStep(cur, end, prosemirrorModel.Slice.empty));
	    } else {
	      match = allowed;
	      for (var j = 0; j < child.marks.length; j++) { if (!parentType.allowsMarkType(child.marks[j].type))
	        { this.step(new RemoveMarkStep(cur, end, child.marks[j])); } }
	    }
	    cur = end;
	  }
	  if (!match.validEnd) {
	    var fill = match.fillBefore(prosemirrorModel.Fragment.empty, true);
	    this.replace(cur, cur, new prosemirrorModel.Slice(fill, 0, 0));
	  }
	  for (var i$1 = delSteps.length - 1; i$1 >= 0; i$1--) { this.step(delSteps[i$1]); }
	  return this
	};
	
	// :: (Node, number, ?number, ?Slice) → ?Step
	// ‘Fit’ a slice into a given position in the document, producing a
	// [step](#transform.Step) that inserts it. Will return null if
	// there's no meaningful way to insert the slice here, or inserting it
	// would be a no-op (an empty slice over an empty range).
	function replaceStep(doc, from, to, slice) {
	  if ( to === void 0 ) to = from;
	  if ( slice === void 0 ) slice = prosemirrorModel.Slice.empty;
	
	  if (from == to && !slice.size) { return null }
	
	  var $from = doc.resolve(from), $to = doc.resolve(to);
	  // Optimization -- avoid work if it's obvious that it's not needed.
	  if (fitsTrivially($from, $to, slice)) { return new ReplaceStep(from, to, slice) }
	  var placed = placeSlice($from, slice);
	
	  var fittedLeft = fitLeft($from, placed);
	  var fitted = fitRight($from, $to, fittedLeft);
	  if (!fitted) { return null }
	  if (fittedLeft.size != fitted.size && canMoveText($from, $to, fittedLeft)) {
	    var d = $to.depth, after = $to.after(d);
	    while (d > 1 && after == $to.end(--d)) { ++after; }
	    var fittedAfter = fitRight($from, doc.resolve(after), fittedLeft);
	    if (fittedAfter)
	      { return new ReplaceAroundStep(from, after, to, $to.end(), fittedAfter, fittedLeft.size) }
	  }
	  return fitted.size || from != to ? new ReplaceStep(from, to, fitted) : null
	}
	
	// :: (number, ?number, ?Slice) → this
	// Replace the part of the document between `from` and `to` with the
	// given `slice`.
	Transform.prototype.replace = function(from, to, slice) {
	  if ( to === void 0 ) to = from;
	  if ( slice === void 0 ) slice = prosemirrorModel.Slice.empty;
	
	  var step = replaceStep(this.doc, from, to, slice);
	  if (step) { this.step(step); }
	  return this
	};
	
	// :: (number, number, union<Fragment, Node, [Node]>) → this
	// Replace the given range with the given content, which may be a
	// fragment, node, or array of nodes.
	Transform.prototype.replaceWith = function(from, to, content) {
	  return this.replace(from, to, new prosemirrorModel.Slice(prosemirrorModel.Fragment.from(content), 0, 0))
	};
	
	// :: (number, number) → this
	// Delete the content between the given positions.
	Transform.prototype.delete = function(from, to) {
	  return this.replace(from, to, prosemirrorModel.Slice.empty)
	};
	
	// :: (number, union<Fragment, Node, [Node]>) → this
	// Insert the given content at the given position.
	Transform.prototype.insert = function(pos, content) {
	  return this.replaceWith(pos, pos, content)
	};
	
	
	
	function fitLeftInner($from, depth, placed, placedBelow) {
	  var content = prosemirrorModel.Fragment.empty, openEnd = 0, placedHere = placed[depth];
	  if ($from.depth > depth) {
	    var inner = fitLeftInner($from, depth + 1, placed, placedBelow || placedHere);
	    openEnd = inner.openEnd + 1;
	    content = prosemirrorModel.Fragment.from($from.node(depth + 1).copy(inner.content));
	  }
	
	  if (placedHere) {
	    content = content.append(placedHere.content);
	    openEnd = placedHere.openEnd;
	  }
	  if (placedBelow) {
	    content = content.append($from.node(depth).contentMatchAt($from.indexAfter(depth)).fillBefore(prosemirrorModel.Fragment.empty, true));
	    openEnd = 0;
	  }
	
	  return {content: content, openEnd: openEnd}
	}
	
	function fitLeft($from, placed) {
	  var ref = fitLeftInner($from, 0, placed, false);
	  var content = ref.content;
	  var openEnd = ref.openEnd;
	  return new prosemirrorModel.Slice(content, $from.depth, openEnd || 0)
	}
	
	function fitRightJoin(content, parent, $from, $to, depth, openStart, openEnd) {
	  var match, count = content.childCount, matchCount = count - (openEnd > 0 ? 1 : 0);
	  var parentNode = openStart < 0 ? parent : $from.node(depth);
	  if (openStart < 0)
	    { match = parentNode.contentMatchAt(matchCount); }
	  else if (count == 1 && openEnd > 0)
	    { match = parentNode.contentMatchAt(openStart ? $from.index(depth) : $from.indexAfter(depth)); }
	  else
	    { match = parentNode.contentMatchAt($from.indexAfter(depth))
	      .matchFragment(content, count > 0 && openStart ? 1 : 0, matchCount); }
	
	  var toNode = $to.node(depth);
	  if (openEnd > 0 && depth < $to.depth) {
	    var after = toNode.content.cutByIndex($to.indexAfter(depth)).addToStart(content.lastChild);
	    var joinable$1 = match.fillBefore(after, true);
	    // Can't insert content if there's a single node stretched across this gap
	    if (joinable$1 && joinable$1.size && openStart > 0 && count == 1) { joinable$1 = null; }
	
	    if (joinable$1) {
	      var inner = fitRightJoin(content.lastChild.content, content.lastChild, $from, $to,
	                               depth + 1, count == 1 ? openStart - 1 : -1, openEnd - 1);
	      if (inner) {
	        var last = content.lastChild.copy(inner);
	        if (joinable$1.size)
	          { return content.cutByIndex(0, count - 1).append(joinable$1).addToEnd(last) }
	        else
	          { return content.replaceChild(count - 1, last) }
	      }
	    }
	  }
	  if (openEnd > 0)
	    { match = match.matchType((count == 1 && openStart > 0 ? $from.node(depth + 1) : content.lastChild).type); }
	
	  // If we're here, the next level can't be joined, so we see what
	  // happens if we leave it open.
	  var toIndex = $to.index(depth);
	  if (toIndex == toNode.childCount && !toNode.type.compatibleContent(parent.type)) { return null }
	  var joinable = match.fillBefore(toNode.content, true, toIndex);
	  for (var i = toIndex; joinable && i < toNode.content.childCount; i++)
	    { if (!parentNode.type.allowsMarks(toNode.content.child(i).marks)) { joinable = null; } }
	  if (!joinable) { return null }
	
	  if (openEnd > 0) {
	    var closed = fitRightClosed(content.lastChild, openEnd - 1, $from, depth + 1,
	                                count == 1 ? openStart - 1 : -1);
	    content = content.replaceChild(count - 1, closed);
	  }
	  content = content.append(joinable);
	  if ($to.depth > depth)
	    { content = content.addToEnd(fitRightSeparate($to, depth + 1)); }
	  return content
	}
	
	function fitRightClosed(node, openEnd, $from, depth, openStart) {
	  var match, content = node.content, count = content.childCount;
	  if (openStart >= 0)
	    { match = $from.node(depth).contentMatchAt($from.indexAfter(depth))
	      .matchFragment(content, openStart > 0 ? 1 : 0, count); }
	  else
	    { match = node.contentMatchAt(count); }
	
	  if (openEnd > 0) {
	    var closed = fitRightClosed(content.lastChild, openEnd - 1, $from, depth + 1,
	                                count == 1 ? openStart - 1 : -1);
	    content = content.replaceChild(count - 1, closed);
	  }
	
	  return node.copy(content.append(match.fillBefore(prosemirrorModel.Fragment.empty, true)))
	}
	
	function fitRightSeparate($to, depth) {
	  var node = $to.node(depth);
	  var fill = node.contentMatchAt(0).fillBefore(node.content, true, $to.index(depth));
	  if ($to.depth > depth) { fill = fill.addToEnd(fitRightSeparate($to, depth + 1)); }
	  return node.copy(fill)
	}
	
	function normalizeSlice(content, openStart, openEnd) {
	  while (openStart > 0 && openEnd > 0 && content.childCount == 1) {
	    content = content.firstChild.content;
	    openStart--;
	    openEnd--;
	  }
	  return new prosemirrorModel.Slice(content, openStart, openEnd)
	}
	
	// : (ResolvedPos, ResolvedPos, number, Slice) → Slice
	function fitRight($from, $to, slice) {
	  var fitted = fitRightJoin(slice.content, $from.node(0), $from, $to, 0, slice.openStart, slice.openEnd);
	  if (!fitted) { return null }
	  return normalizeSlice(fitted, slice.openStart, $to.depth)
	}
	
	function fitsTrivially($from, $to, slice) {
	  return !slice.openStart && !slice.openEnd && $from.start() == $to.start() &&
	    $from.parent.canReplace($from.index(), $to.index(), slice.content)
	}
	
	function canMoveText($from, $to, slice) {
	  if (!$to.parent.isTextblock) { return false }
	
	  var parent = slice.openEnd ? nodeRight(slice.content, slice.openEnd)
	      : $from.node($from.depth - (slice.openStart - slice.openEnd));
	  if (!parent.isTextblock) { return false }
	  for (var i = $to.index(); i < $to.parent.childCount; i++)
	    { if (!parent.type.allowsMarks($to.parent.child(i).marks)) { return false } }
	  var match;
	  if (slice.openEnd) {
	    match = parent.contentMatchAt(parent.childCount);
	  } else {
	    match = parent.contentMatchAt(parent.childCount);
	    if (slice.size) { match = match.matchFragment(slice.content, slice.openStart ? 1 : 0); }
	  }
	  match = match.matchFragment($to.parent.content, $to.index());
	  return match && match.validEnd
	}
	
	function nodeRight(content, depth) {
	  for (var i = 1; i < depth; i++) { content = content.lastChild.content; }
	  return content.lastChild
	}
	
	// Algorithm for 'placing' the elements of a slice into a gap:
	//
	// We consider the content of each node that is open to the left to be
	// independently placeable. I.e. in <p("foo"), p("bar")>, when the
	// paragraph on the left is open, "foo" can be placed (somewhere on
	// the left side of the replacement gap) independently from p("bar").
	//
	// So placeSlice splits up a slice into a number of sub-slices,
	// along with information on where they can be placed on the given
	// left-side edge. It works by walking the open side of the slice,
	// from the inside out, and trying to find a landing spot for each
	// element, by simultaneously scanning over the gap side. When no
	// place is found for an open node's content, it is left in that node.
	
	// : (ResolvedPos, Slice) → [{content: Fragment, openEnd: number, depth: number}]
	function placeSlice($from, slice) {
	  var frontier = new Frontier($from);
	  for (var pass = 1; slice.size && pass <= 3; pass++) {
	    var value = frontier.placeSlice(slice.content, slice.openStart, slice.openEnd, pass);
	    if (pass == 3 && value != slice && value.size) { pass = 0; } // Restart if the 3rd pass made progress but left content
	    slice = value;
	  }
	  while (frontier.open.length) { frontier.closeNode(); }
	  return frontier.placed
	}
	
	// Helper class that models the open side of the insert position,
	// keeping track of the content match and already inserted content
	// at each depth.
	var Frontier = function Frontier($pos) {
	  // : [{parent: Node, match: ContentMatch, content: Fragment, wrapper: bool, openEnd: number, depth: number}]
	  this.open = [];
	  for (var d = 0; d <= $pos.depth; d++) {
	    var parent = $pos.node(d), match = parent.contentMatchAt($pos.indexAfter(d));
	    this.open.push({parent: parent, match: match, content: prosemirrorModel.Fragment.empty, wrapper: false, openEnd: 0, depth: d});
	  }
	  this.placed = [];
	};
	
	// : (Fragment, number, number, number, ?Node) → Slice
	// Tries to place the content of the given slice, and returns a
	// slice containing unplaced content.
	//
	// pass 1: try to fit directly
	// pass 2: allow wrapper nodes to be introduced
	// pass 3: allow unwrapping of nodes that aren't open
	Frontier.prototype.placeSlice = function placeSlice (fragment, openStart, openEnd, pass, parent) {
	  if (openStart > 0) {
	    var first = fragment.firstChild;
	    var inner = this.placeSlice(first.content, Math.max(0, openStart - 1),
	                                openEnd && fragment.childCount == 1 ? openEnd - 1 : 0,
	                                pass, first);
	    if (inner.content != first.content) {
	      if (inner.content.size) {
	        fragment = fragment.replaceChild(0, first.copy(inner.content));
	        openStart = inner.openStart + 1;
	      } else {
	        if (fragment.childCount == 1) { openEnd = 0; }
	        fragment = fragment.cutByIndex(1);
	        openStart = 0;
	      }
	    }
	  }
	  var result = this.placeContent(fragment, openStart, openEnd, pass, parent);
	  if (pass > 2 && result.size && openStart == 0) {
	    var child = result.content.firstChild, single = result.content.childCount == 1;
	    this.placeContent(child.content, 0, openEnd && single ? openEnd - 1 : 0, pass, child);
	    result = single ? prosemirrorModel.Fragment.empty : new prosemirrorModel.Slice(result.content.cutByIndex(1), 0, openEnd);
	  }
	  return result
	};
	
	Frontier.prototype.placeContent = function placeContent (fragment, openStart, openEnd, pass, parent) {
	  var i = 0;
	  // Go over the fragment's children
	  for (; i < fragment.childCount; i++) {
	    var child = fragment.child(i), placed = false, last = i == fragment.childCount - 1;
	    // Try each open node in turn, starting from the innermost
	    for (var d = this.open.length - 1; d >= 0; d--) {
	      var open = this.open[d], wrap = (void 0);
	
	      // If pass > 1, it is allowed to wrap the node to help find a
	      // fit, so if findWrapping returns something, we add open
	      // nodes to the frontier for that wrapping.
	      if (pass > 1 && (wrap = open.match.findWrapping(child.type)) &&
	          !(parent && wrap.length && wrap[wrap.length - 1] == parent.type)) {
	        while (this.open.length - 1 > d) { this.closeNode(); }
	        for (var w = 0; w < wrap.length; w++) {
	          open.match = open.match.matchType(wrap[w]);
	          d++;
	          open = {parent: wrap[w].create(),
	                  match: wrap[w].contentMatch,
	                  content: prosemirrorModel.Fragment.empty, wrapper: true, openEnd: 0, depth: d + w};
	          this.open.push(open);
	        }
	      }
	
	      // See if the child fits here
	      var match = open.match.matchType(child.type);
	      if (!match) {
	        var fill = open.match.fillBefore(prosemirrorModel.Fragment.from(child));
	        if (fill) {
	          for (var j = 0; j < fill.childCount; j++) {
	            var ch = fill.child(j);
	            this.addNode(open, ch, 0);
	            match = open.match.matchFragment(ch);
	          }
	        } else if (parent && open.match.matchType(parent.type)) {
	          // Don't continue looking further up if the parent node
	          // would fit here.
	          break
	        } else {
	          continue
	        }
	      }
	
	      // Close open nodes above this one, since we're starting to
	      // add to this.
	      while (this.open.length - 1 > d) { this.closeNode(); }
	      // Strip marks from the child or close its start when necessary
	      child = child.mark(open.parent.type.allowedMarks(child.marks));
	      if (openStart) {
	        child = closeNodeStart(child, openStart, last ? openEnd : 0);
	        openStart = 0;
	      }
	      // Add the child to this open node and adjust its metadata
	      this.addNode(open, child, last ? openEnd : 0);
	      open.match = match;
	      if (last) { openEnd = 0; }
	      placed = true;
	      break
	    }
	    // As soon as we've failed to place a node we stop looking at
	    // later nodes
	    if (!placed) { break }
	  }
	  // Close the current open node if it's not the the root and we
	  // either placed up to the end of the node or the the current
	  // slice depth's node type matches the open node's type
	  if (this.open.length > 1 &&
	      (i > 0 && i == fragment.childCount ||
	       parent && this.open[this.open.length - 1].parent.type == parent.type))
	    { this.closeNode(); }
	
	  return new prosemirrorModel.Slice(fragment.cutByIndex(i), openStart, openEnd)
	};
	
	Frontier.prototype.addNode = function addNode (open, node, openEnd) {
	  open.content = closeFragmentEnd(open.content, open.openEnd).addToEnd(node);
	  open.openEnd = openEnd;
	};
	
	Frontier.prototype.closeNode = function closeNode () {
	  var open = this.open.pop();
	  if (open.content.size == 0) ; else if (open.wrapper) {
	    this.addNode(this.open[this.open.length - 1], open.parent.copy(open.content), open.openEnd + 1);
	  } else {
	    this.placed[open.depth] = {depth: open.depth, content: open.content, openEnd: open.openEnd};
	  }
	};
	
	function closeNodeStart(node, openStart, openEnd) {
	  var content = node.content;
	  if (openStart > 1) {
	    var first = closeNodeStart(node.firstChild, openStart - 1, node.childCount == 1 ? openEnd - 1 : 0);
	    content = node.content.replaceChild(0, first);
	  }
	  var fill = node.type.contentMatch.fillBefore(content, openEnd == 0);
	  return node.copy(fill.append(content))
	}
	
	function closeNodeEnd(node, depth) {
	  var content = node.content;
	  if (depth > 1) {
	    var last = closeNodeEnd(node.lastChild, depth - 1);
	    content = node.content.replaceChild(node.childCount - 1, last);
	  }
	  var fill = node.contentMatchAt(node.childCount).fillBefore(prosemirrorModel.Fragment.empty, true);
	  return node.copy(content.append(fill))
	}
	
	function closeFragmentEnd(fragment, depth) {
	  return depth ? fragment.replaceChild(fragment.childCount - 1, closeNodeEnd(fragment.lastChild, depth)) : fragment
	}
	
	// :: (number, number, Slice) → this
	// Replace a range of the document with a given slice, using `from`,
	// `to`, and the slice's [`openStart`](#model.Slice.openStart) property
	// as hints, rather than fixed start and end points. This method may
	// grow the replaced area or close open nodes in the slice in order to
	// get a fit that is more in line with WYSIWYG expectations, by
	// dropping fully covered parent nodes of the replaced region when
	// they are marked [non-defining](#model.NodeSpec.defining), or
	// including an open parent node from the slice that _is_ marked as
	// [defining](#model.NodeSpec.defining).
	//
	// This is the method, for example, to handle paste. The similar
	// [`replace`](#transform.Transform.replace) method is a more
	// primitive tool which will _not_ move the start and end of its given
	// range, and is useful in situations where you need more precise
	// control over what happens.
	Transform.prototype.replaceRange = function(from, to, slice) {
	  if (!slice.size) { return this.deleteRange(from, to) }
	
	  var $from = this.doc.resolve(from), $to = this.doc.resolve(to);
	  if (fitsTrivially($from, $to, slice))
	    { return this.step(new ReplaceStep(from, to, slice)) }
	
	  var targetDepths = coveredDepths($from, this.doc.resolve(to));
	  // Can't replace the whole document, so remove 0 if it's present
	  if (targetDepths[targetDepths.length - 1] == 0) { targetDepths.pop(); }
	  // Negative numbers represent not expansion over the whole node at
	  // that depth, but replacing from $from.before(-D) to $to.pos.
	  var preferredTarget = -($from.depth + 1);
	  targetDepths.unshift(preferredTarget);
	  // This loop picks a preferred target depth, if one of the covering
	  // depths is not outside of a defining node, and adds negative
	  // depths for any depth that has $from at its start and does not
	  // cross a defining node.
	  for (var d = $from.depth, pos = $from.pos - 1; d > 0; d--, pos--) {
	    var spec = $from.node(d).type.spec;
	    if (spec.defining || spec.isolating) { break }
	    if (targetDepths.indexOf(d) > -1) { preferredTarget = d; }
	    else if ($from.before(d) == pos) { targetDepths.splice(1, 0, -d); }
	  }
	  // Try to fit each possible depth of the slice into each possible
	  // target depth, starting with the preferred depths.
	  var preferredTargetIndex = targetDepths.indexOf(preferredTarget);
	
	  var leftNodes = [], preferredDepth = slice.openStart;
	  for (var content = slice.content, i = 0;; i++) {
	    var node = content.firstChild;
	    leftNodes.push(node);
	    if (i == slice.openStart) { break }
	    content = node.content;
	  }
	  // Back up if the node directly above openStart, or the node above
	  // that separated only by a non-defining textblock node, is defining.
	  if (preferredDepth > 0 && leftNodes[preferredDepth - 1].type.spec.defining &&
	      $from.node(preferredTargetIndex).type != leftNodes[preferredDepth - 1].type)
	    { preferredDepth -= 1; }
	  else if (preferredDepth >= 2 && leftNodes[preferredDepth - 1].isTextblock && leftNodes[preferredDepth - 2].type.spec.defining &&
	           $from.node(preferredTargetIndex).type != leftNodes[preferredDepth - 2].type)
	    { preferredDepth -= 2; }
	
	  for (var j = slice.openStart; j >= 0; j--) {
	    var openDepth = (j + preferredDepth + 1) % (slice.openStart + 1);
	    var insert = leftNodes[openDepth];
	    if (!insert) { continue }
	    for (var i$1 = 0; i$1 < targetDepths.length; i$1++) {
	      // Loop over possible expansion levels, starting with the
	      // preferred one
	      var targetDepth = targetDepths[(i$1 + preferredTargetIndex) % targetDepths.length], expand = true;
	      if (targetDepth < 0) { expand = false; targetDepth = -targetDepth; }
	      var parent = $from.node(targetDepth - 1), index = $from.index(targetDepth - 1);
	      if (parent.canReplaceWith(index, index, insert.type, insert.marks))
	        { return this.replace($from.before(targetDepth), expand ? $to.after(targetDepth) : to,
	                            new prosemirrorModel.Slice(closeFragment(slice.content, 0, slice.openStart, openDepth),
	                                      openDepth, slice.openEnd)) }
	    }
	  }
	
	  var startSteps = this.steps.length;
	  for (var i$2 = targetDepths.length - 1; i$2 >= 0; i$2--) {
	    this.replace(from, to, slice);
	    if (this.steps.length > startSteps) { break }
	    var depth = targetDepths[i$2];
	    if (i$2 < 0) { continue }
	    from = $from.before(depth); to = $to.after(depth);
	  }
	  return this
	};
	
	function closeFragment(fragment, depth, oldOpen, newOpen, parent) {
	  if (depth < oldOpen) {
	    var first = fragment.firstChild;
	    fragment = fragment.replaceChild(0, first.copy(closeFragment(first.content, depth + 1, oldOpen, newOpen, first)));
	  }
	  if (depth > newOpen) {
	    var match = parent.contentMatchAt(0);
	    var start = match.fillBefore(fragment).append(fragment);
	    fragment = start.append(match.matchFragment(start).fillBefore(prosemirrorModel.Fragment.empty, true));
	  }
	  return fragment
	}
	
	// :: (number, number, Node) → this
	// Replace the given range with a node, but use `from` and `to` as
	// hints, rather than precise positions. When from and to are the same
	// and are at the start or end of a parent node in which the given
	// node doesn't fit, this method may _move_ them out towards a parent
	// that does allow the given node to be placed. When the given range
	// completely covers a parent node, this method may completely replace
	// that parent node.
	Transform.prototype.replaceRangeWith = function(from, to, node) {
	  if (!node.isInline && from == to && this.doc.resolve(from).parent.content.size) {
	    var point = insertPoint(this.doc, from, node.type);
	    if (point != null) { from = to = point; }
	  }
	  return this.replaceRange(from, to, new prosemirrorModel.Slice(prosemirrorModel.Fragment.from(node), 0, 0))
	};
	
	// :: (number, number) → this
	// Delete the given range, expanding it to cover fully covered
	// parent nodes until a valid replace is found.
	Transform.prototype.deleteRange = function(from, to) {
	  var $from = this.doc.resolve(from), $to = this.doc.resolve(to);
	  var covered = coveredDepths($from, $to);
	  for (var i = 0; i < covered.length; i++) {
	    var depth = covered[i], last = i == covered.length - 1;
	    if ((last && depth == 0) || $from.node(depth).type.contentMatch.validEnd)
	      { return this.delete($from.start(depth), $to.end(depth)) }
	    if (depth > 0 && (last || $from.node(depth - 1).canReplace($from.index(depth - 1), $to.indexAfter(depth - 1))))
	      { return this.delete($from.before(depth), $to.after(depth)) }
	  }
	  for (var d = 1; d <= $from.depth && d <= $to.depth; d++) {
	    if (from - $from.start(d) == $from.depth - d && to > $from.end(d) && $to.end(d) - to != $to.depth - d)
	      { return this.delete($from.before(d), to) }
	  }
	  return this.delete(from, to)
	};
	
	// : (ResolvedPos, ResolvedPos) → [number]
	// Returns an array of all depths for which $from - $to spans the
	// whole content of the nodes at that depth.
	function coveredDepths($from, $to) {
	  var result = [], minDepth = Math.min($from.depth, $to.depth);
	  for (var d = minDepth; d >= 0; d--) {
	    var start = $from.start(d);
	    if (start < $from.pos - ($from.depth - d) ||
	        $to.end(d) > $to.pos + ($to.depth - d) ||
	        $from.node(d).type.spec.isolating ||
	        $to.node(d).type.spec.isolating) { break }
	    if (start == $to.start(d)) { result.push(d); }
	  }
	  return result
	}
	
	exports.AddMarkStep = AddMarkStep;
	exports.MapResult = MapResult;
	exports.Mapping = Mapping;
	exports.RemoveMarkStep = RemoveMarkStep;
	exports.ReplaceAroundStep = ReplaceAroundStep;
	exports.ReplaceStep = ReplaceStep;
	exports.Step = Step;
	exports.StepMap = StepMap;
	exports.StepResult = StepResult;
	exports.Transform = Transform;
	exports.TransformError = TransformError;
	exports.canJoin = canJoin;
	exports.canSplit = canSplit;
	exports.dropPoint = dropPoint;
	exports.findWrapping = findWrapping;
	exports.insertPoint = insertPoint;
	exports.joinPoint = joinPoint;
	exports.liftTarget = liftTarget;
	exports.replaceStep = replaceStep;
	//# sourceMappingURL=index.js.map


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(319), __esModule: true };

/***/ }),
/* 27 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(140);
	var isBuffer = __webpack_require__(446);
	
	/*global toString:true*/
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return toString.call(val) === '[object Array]';
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(val) {
	  return (typeof FormData !== 'undefined') && (val instanceof FormData);
	}
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */
	function isFunction(val) {
	  return toString.call(val) === '[object Function]';
	}
	
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */
	function isStream(val) {
	  return isObject(val) && isFunction(val.pipe);
	}
	
	/**
	 * Determine if a value is a URLSearchParams object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	 */
	function isURLSearchParams(val) {
	  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
	}
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.replace(/^\s*/, '').replace(/\s*$/, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  navigator.product -> 'ReactNative'
	 */
	function isStandardBrowserEnv() {
	  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
	    return false;
	  }
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object' && !isArray(obj)) {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (typeof result[key] === 'object' && typeof val === 'object') {
	      result[key] = merge(result[key], val);
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	/**
	 * Extends object a by mutably adding to it the properties of object b.
	 *
	 * @param {Object} a The object to be extended
	 * @param {Object} b The object to copy properties from
	 * @param {Object} thisArg The object to bind function to
	 * @return {Object} The resulting value of object a
	 */
	function extend(a, b, thisArg) {
	  forEach(b, function assignValue(val, key) {
	    if (thisArg && typeof val === 'function') {
	      a[key] = bind(val, thisArg);
	    } else {
	      a[key] = val;
	    }
	  });
	  return a;
	}
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isBuffer: isBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction,
	  isStream: isStream,
	  isURLSearchParams: isURLSearchParams,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  extend: extend,
	  trim: trim
	};


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _getPrototypeOf = __webpack_require__(30);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(7);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(10);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(32);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(31);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _getOwnPropertyDescriptor = __webpack_require__(23);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getOwnPropertySymbols = __webpack_require__(16);
	
	var _getOwnPropertySymbols2 = _interopRequireDefault(_getOwnPropertySymbols);
	
	var _keys = __webpack_require__(13);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _defineProperty2 = __webpack_require__(15);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var prosemirrorState = __webpack_require__(6);
	var prosemirrorView = __webpack_require__(48);
	var index_js = __webpack_require__(34);
	var prosemirrorModel = __webpack_require__(12);
	
	function styleInject(css, ref) {
	  if (ref === void 0) ref = {};
	  var insertAt = ref.insertAt;
	
	  if (!css || typeof document === 'undefined') {
	    return;
	  }
	
	  var head = document.head || document.getElementsByTagName('head')[0];
	  var style = document.createElement('style');
	  style.type = 'text/css';
	
	  if (insertAt === 'top') {
	    if (head.firstChild) {
	      head.insertBefore(style, head.firstChild);
	    } else {
	      head.appendChild(style);
	    }
	  } else {
	    head.appendChild(style);
	  }
	
	  if (style.styleSheet) {
	    style.styleSheet.cssText = css;
	  } else {
	    style.appendChild(document.createTextNode(css));
	  }
	}
	
	var css = ".ProseMirror-dropcursor-bottom{position:relative}.ProseMirror-dropcursor-bottom:after{content:\"\";position:absolute;bottom:-4px;left:0;right:0;height:3px;background-color:#1c6cdc;z-index:10}.ProseMirror-dropcursor-top{position:relative}.ProseMirror-dropcursor-top:after{content:\"\";position:absolute;top:2px;left:0;right:0;height:2px;background-color:#1c6cdc;z-index:10}";
	styleInject(css);
	
	var gecko = typeof navigator !== 'undefined' && /gecko\/\d/i.test(navigator.userAgent);
	var linux = typeof navigator !== 'undefined' && /linux/i.test(navigator.platform);
	var pluginKey = new prosemirrorState.PluginKey('dropCursor');
	function dropCursor(options) {
	  var timeout = null;
	  var plugin = new prosemirrorState.Plugin({
	    key: pluginKey,
	    state: {
	      init: function init() {
	        return null;
	      },
	      apply: function apply(tr, prev, state) {
	        if (gecko && linux) return null;
	        var command = tr.getMeta(plugin);
	        if (!command) return prev;
	
	        if (command.type === 'set') {
	          return pluginStateFor(state, command.pos, options);
	        }
	
	        return null;
	      }
	    },
	    props: {
	      handleDOMEvents: {
	        dragover: function dragover(view, event) {
	          var active = plugin.getState(view.state);
	          var pos = view.posAtCoords({
	            left: event.clientX,
	            top: event.clientY
	          });
	
	          if (pos) {
	            var target = pos.pos;
	
	            if (view.dragging) {
	              target = dropPos(view.dragging.slice, view.state.doc.resolve(target));
	            }
	
	            if (!active || active.pos !== target) {
	              dispatch(view, {
	                type: 'set',
	                pos: target
	              });
	            }
	          }
	
	          scheduleRemoval(view);
	          return false;
	        },
	        dragend: function dragend(view) {
	          if (plugin.getState(view.state)) dispatch(view, {
	            type: 'remove'
	          });
	          return false;
	        },
	        drop: function drop(view) {
	          if (plugin.getState(view.state)) dispatch(view, {
	            type: 'remove'
	          });
	          return false;
	        },
	        dragleave: function dragleave(view, event) {
	          if (event.target === view.dom) dispatch(view, {
	            type: 'remove'
	          });
	          return false;
	        }
	      },
	
	      decorations: function decorations(state) {
	        var active = plugin.getState(state);
	        return active && active.deco;
	      }
	    }
	  });
	
	  function dispatch(view, data) {
	    view.dispatch(view.state.tr.setMeta(plugin, data));
	  }
	
	  function scheduleRemoval(view) {
	    clearTimeout(timeout);
	    timeout = setTimeout(function () {
	      if (plugin.getState(view.state)) dispatch(view, {
	        type: 'remove'
	      });
	    }, 1000);
	  }
	
	  return plugin;
	}
	
	function style(options, side) {
	  if (side === 'bottom' || side === 'top') {
	    return 'border-' + side + ': 2px solid #3789a9; margin-' + side + ': 2px';
	  }
	
	  var width = options && options.width || 1;
	  var color = options && options.color || 'black';
	  return 'border-' + side + ': ' + width + 'px solid ' + color + '; margin-' + side + ': -' + width + 'px';
	}
	
	function pluginStateFor(state, pos, options) {
	  window.__EDITOR_DROP_CURSOR__ = true;
	  var $pos = state.doc.resolve(pos),
	      deco = void 0;
	
	  if (!$pos.parent.inlineContent) {
	    var before = void 0,
	        after = void 0;
	
	    if (before = $pos.nodeBefore) {
	      if (before && (before.type.name === "table_row" || before.type.name === "table")) {
	        return null;
	      }
	
	      deco = prosemirrorView.Decoration.node(pos - before.nodeSize, pos, {
	        nodeName: 'div',
	        class: 'ProseMirror-dropcursor-bottom'
	      });
	    } else if (after = $pos.nodeAfter) {
	      if (after && after.type.name === "table_row") {
	        return null;
	      }
	
	      deco = prosemirrorView.Decoration.node(pos, pos + after.nodeSize, {
	        nodeName: 'div',
	        class: 'ProseMirror-dropcursor-top'
	      });
	    }
	  }
	
	  if (!deco) {
	    var node = document.createElement('span');
	    node.textContent = '\u200B';
	    node.style.cssText = style(options, 'left') + '; display: inline-block; pointer-events: none';
	    deco = prosemirrorView.Decoration.widget(pos, node);
	  }
	
	  deco = prosemirrorView.DecorationSet.create(state.doc, [deco]);
	  return {
	    pos: pos,
	    deco: deco
	  };
	}
	
	function dropPos(slice, $pos) {
	  if (!slice || !slice.content.size) return $pos.pos;
	  var content = slice.content;
	
	  for (var i = 0; i < slice.openStart; i++) {
	    content = content.firstChild.content;
	  }for (var d = $pos.depth; d >= 0; d--) {
	    var bias = d === $pos.depth ? 0 : $pos.pos <= ($pos.start(d + 1) + $pos.end(d + 1)) / 2 ? -1 : 1;
	    var insertPos = $pos.index(d) + (bias > 0 ? 1 : 0);
	
	    if ($pos.node(d).canReplace(insertPos, insertPos, content)) {
	      return bias === 0 ? $pos.pos : bias < 0 ? $pos.before(d + 1) : $pos.after(d + 1);
	    }
	  }
	
	  return $pos.pos;
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    (0, _defineProperty3.default)(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	var defineProperty = _defineProperty;
	
	function _objectSpread(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? arguments[i] : {};
	    var ownKeys = (0, _keys2.default)(source);
	
	    if (typeof _getOwnPropertySymbols2.default === 'function') {
	      ownKeys = ownKeys.concat((0, _getOwnPropertySymbols2.default)(source).filter(function (sym) {
	        return (0, _getOwnPropertyDescriptor2.default)(source, sym).enumerable;
	      }));
	    }
	
	    ownKeys.forEach(function (key) {
	      defineProperty(target, key, source[key]);
	    });
	  }
	
	  return target;
	}
	
	var objectSpread = _objectSpread;
	
	var GapCursor = function (_prosemirrorState$Sel) {
	  (0, _inherits3.default)(GapCursor, _prosemirrorState$Sel);
	
	  function GapCursor($pos, dom) {
	    (0, _classCallCheck3.default)(this, GapCursor);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (GapCursor.__proto__ || (0, _getPrototypeOf2.default)(GapCursor)).call(this, $pos, $pos));
	
	    _this.dom = dom;
	    return _this;
	  }
	
	  (0, _createClass3.default)(GapCursor, [{
	    key: 'map',
	    value: function map(doc, mapping) {
	      var $pos = doc.resolve(mapping.map(this.head));
	      return GapCursor.valid($pos) ? new GapCursor($pos) : prosemirrorState.Selection.near($pos);
	    }
	  }, {
	    key: 'content',
	    value: function content() {
	      return prosemirrorModel.Slice.empty;
	    }
	  }, {
	    key: 'eq',
	    value: function eq(other) {
	      return other instanceof GapCursor && other.head === this.head;
	    }
	  }, {
	    key: 'toJSON',
	    value: function toJSON() {
	      return {
	        type: 'gapcursor',
	        pos: this.head
	      };
	    }
	  }, {
	    key: 'getBookmark',
	    value: function getBookmark() {
	      return new GapBookmark(this.anchor);
	    }
	  }], [{
	    key: 'fromJSON',
	    value: function fromJSON(doc, json) {
	      return new GapCursor(doc.resolve(json.pos));
	    }
	  }, {
	    key: 'isValidNode',
	    value: function isValidNode(node) {
	      return !!(node && node.type.spec.allowGapCursor);
	    }
	  }, {
	    key: 'valid',
	    value: function valid($pos) {
	      var nodeBefore = this.getNodeBefore($pos);
	      var nodeAfter = this.getNodeAfter($pos);
	      return !!(nodeBefore || nodeAfter);
	    }
	  }, {
	    key: 'findFrom',
	    value: function findFrom($pos, dir) {
	      var isGreedy = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	      if (dir) {
	        var res = dir === 'before' ? this.getNodeBefore($pos) : this.getNodeAfter($pos);
	        return res ? {
	          node: res.node,
	          pos: res.pos,
	          dir: dir
	        } : null;
	      }
	
	      var before = this.getNodeBefore($pos, isGreedy);
	
	      if (before) {
	        return {
	          node: before.node,
	          pos: before.pos,
	          dir: 'before'
	        };
	      }
	
	      var after = this.getNodeAfter($pos, isGreedy);
	      return after ? {
	        node: after.node,
	        pos: after.pos,
	        dir: 'after'
	      } : null;
	    }
	  }, {
	    key: 'getNodeBefore',
	    value: function getNodeBefore($pos, isGreedy) {
	      var nodeBefore = $pos.nodeBefore;
	      var pos = $pos.pos;
	
	      var node = $pos.node();
	      var isNodeTable = node.type.name === 'table';
	
	      if (isNodeTable) {
	        nodeBefore = node;
	        pos += node.nodeSize + 1;
	      }
	
	      if (isGreedy && !nodeBefore && $pos.depth > 0) {
	        var index = $pos.index($pos.depth - 1);
	        var parent = $pos.node($pos.depth - 1);
	        nodeBefore = index > 0 ? parent.child(index - 1) : null;
	        pos -= index > 0 ? 1 : 0;
	      }
	
	      while (nodeBefore && ['list_item', 'task_item', 'paragraph'].includes(nodeBefore.type.name)) {
	        nodeBefore = nodeBefore.lastChild;
	        pos -= 1;
	      }
	
	      if (nodeBefore && nodeBefore.type.name === 'table') {
	        pos -= !isNodeTable && $pos.pos >= nodeBefore.nodeSize ? 0 : 2;
	      }
	
	      return this.isValidNode(nodeBefore) ? {
	        node: nodeBefore,
	        pos: pos
	      } : null;
	    }
	  }, {
	    key: 'getNodeAfter',
	    value: function getNodeAfter($pos, isGreedy) {
	      var nodeAfter = $pos.nodeAfter;
	      var pos = $pos.pos;
	
	      if (isGreedy && !nodeAfter && $pos.depth > 0) {
	        var index = $pos.index();
	        var parent = $pos.node($pos.depth - 1);
	        nodeAfter = parent.childCount > index + 1 ? parent.child(index + 1) : null;
	        pos += parent.childCount > index + 1 ? 1 : 0;
	      }
	
	      while (nodeAfter && ['list_item', 'task_item', 'paragraph'].includes(nodeAfter.type.name)) {
	        nodeAfter = nodeAfter.firstChild;
	        pos += 1;
	      }
	
	      return this.isValidNode(nodeAfter) ? {
	        node: nodeAfter,
	        pos: pos
	      } : null;
	    }
	  }]);
	  return GapCursor;
	}(prosemirrorState.Selection);
	
	GapCursor.prototype.visible = false;
	prosemirrorState.Selection.jsonID('gapcursor', GapCursor);
	
	var GapBookmark = function () {
	  function GapBookmark(pos) {
	    (0, _classCallCheck3.default)(this, GapBookmark);
	
	    this.pos = pos;
	  }
	
	  (0, _createClass3.default)(GapBookmark, [{
	    key: 'map',
	    value: function map(mapping) {
	      return new GapBookmark(mapping.map(this.pos));
	    }
	  }, {
	    key: 'resolve',
	    value: function resolve(doc) {
	      var $pos = doc.resolve(this.pos);
	      return GapCursor.valid($pos) ? new GapCursor($pos) : prosemirrorState.Selection.near($pos);
	    }
	  }]);
	  return GapBookmark;
	}();
	
	var css$1 = ".ProseMirror-gapcursor{display:none;position:absolute;pointer-events:none;z-index:2}.ProseMirror-gapcursor:after{content:\"\";display:inline-block;vertical-align:baseline;height:100%;border-left:1px solid #000;-webkit-animation:ProseMirror-cursor-blink 1.1s steps(2,start) infinite;animation:ProseMirror-cursor-blink 1.1s steps(2,start) infinite}.ProseMirror-focused .ProseMirror-gapcursor{display:block}@-webkit-keyframes ProseMirror-cursor-blink{to{visibility:hidden}}@keyframes ProseMirror-cursor-blink{to{visibility:hidden}}";
	styleInject(css$1);
	
	var skipUpdate = void 0;
	var findDir = void 0;
	var findGreedy = void 0;
	var lastAction = void 0;
	var lastCursor = void 0;
	
	function reset() {
	  skipUpdate = false;
	  findDir = "";
	  findGreedy = false;
	  lastAction = {
	    type: ""
	  };
	  lastCursor = {
	    id: 0,
	    type: "",
	    dir: "",
	    height: 0,
	    top: 0,
	    left: 0
	  };
	}
	
	var pluginKey$1 = new prosemirrorState.PluginKey("gapCursor");
	function gapCursor() {
	  reset();
	  return new prosemirrorState.Plugin({
	    key: pluginKey$1,
	    props: {
	      decorations: drawGapCursor,
	      handleClick: handleClick,
	      handleDoubleClick: handleDoubleClick,
	      handleTripleClick: handleDoubleClick,
	      handleKeyDown: handleKeyDown,
	      handleDOMEvents: {
	        keyup: handleKeyUp,
	        mousedown: handleMouseDown,
	        mouseup: handleMouseUp
	      }
	    },
	
	    view: function view() {
	      return {
	        update: updateCursor
	      };
	    }
	  });
	}
	function setLastAction(type) {
	  var attr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  lastAction = objectSpread({
	    type: type
	  }, attr);
	}
	function setFindDir(dir) {
	  findDir = dir;
	}
	function getGapCursor() {
	  return lastCursor;
	}
	
	function drawGapCursor(state) {
	  if (!(state.selection instanceof GapCursor)) {
	    return null;
	  }
	
	  var pos = state.selection.head;
	  var node = getCursorNode();
	  var key = 'gapCursor' + lastCursor.id;
	  return prosemirrorView.DecorationSet.create(state.doc, [prosemirrorView.Decoration.widget(pos, node, {
	    key: key
	  })]);
	}
	
	function getCursorNode() {
	  var node = document.createElement("div");
	  node.className = "ProseMirror-gapcursor";
	  node.style.height = lastCursor.height + 'px';
	  node.style.top = lastCursor.top + 'px';
	  node.style.left = lastCursor.left + 'px';
	  return node;
	}
	
	
	function updateCursor(view) {
	  var state = view.state,
	      dispatch = view.dispatch;
	  var selection = state.selection,
	      tr = state.tr,
	      doc = state.doc;
	  var $anchor = selection.$anchor,
	      $head = selection.$head,
	      anchor = selection.anchor,
	      head = selection.head;
	
	  var isNodeSelection = selection instanceof prosemirrorState.NodeSelection;
	  var isGapCursorSelection = selection instanceof GapCursor;
	  var $pos = $head;
	  var isHideCursor = false;
	
	  if (skipUpdate) {
	    skipUpdate = false;
	    return;
	  }
	
	  if (isGapCursorSelection && lastAction.type === "mouseDown") {
	    if (lastCursor.type === "table") {
	      isHideCursor = true;
	    } else {
	      return;
	    }
	  }
	
	  if (isNodeSelection && lastAction.type !== "keyDown") {
	    return;
	  }
	
	  if (!isNodeSelection && anchor !== head) {
	    return;
	  }
	
	  if (isNodeSelection && lastAction.type === "keyDown" && lastAction.dir === "right") {
	    $pos = $anchor;
	  }
	
	  if (isGapCursorSelection) {
	    setFindDir(lastCursor.dir);
	  }
	
	  var res = GapCursor.findFrom($pos, findDir, findGreedy);
	  setFindDir("");
	  findGreedy = false;
	
	  if (res) {
	    var dom = getResDom(view, res);
	    var isUpdate = updateCursorStyle(dom, res) || isHideCursor;
	
	    if (dom.offsetHeight === 0 && dom.classList.contains("ct-image")) {
	      setTimeout(function () {
	        updateCursor(view);
	      }, 100);
	      return;
	    }
	
	    if (isHideCursor) {
	      lastCursor.id += 1;
	      lastCursor.height = 0;
	    }
	
	    if (isUpdate) {
	      skipUpdate = true;
	      dispatch(tr.setSelection(new GapCursor(doc.resolve(res.pos), dom)));
	    }
	  } else {
	    lastCursor.height = 0;
	
	    if (selection instanceof GapCursor) {
	      skipUpdate = true;
	      dispatch(tr.setSelection(prosemirrorState.Selection.near($head)));
	    }
	  }
	}
	
	
	function updateCursorStyle(dom, res) {
	  if (!dom) {
	    return false;
	  }var dir = res.dir;
	
	  var _getDomOffset = getDomOffset(dom),
	      offsetTop = _getDomOffset.offsetTop,
	      offsetLeft = _getDomOffset.offsetLeft;
	
	  var height = dom.offsetHeight;
	  var top = offsetTop;
	  var left = (dir === "before" ? dom.offsetWidth : 0) + offsetLeft;
	
	  if (dir === "before" && getTagName(dom) === "table" && hasClass(dom.parentNode, "ct-table-wrapper")) {
	    if (dom.offsetWidth > dom.parentNode.offsetWidth) {
	      left = dom.parentNode.offsetWidth + dom.offsetLeft;
	    }
	  }
	
	  if (hasClass(dom, "ct-image") && dir === "after") {
	    left -= 1;
	  } else if (hasClass(dom, "ct-mention") || hasClass(dom, "ct-status")) {
	    left += dir === "after" ? -2 : 1;
	  }
	
	  if (getTagName(dom) === "hr") {
	    height = 16;
	    top -= 8;
	  }
	
	  if (hasClass(dom, "ct-mention") || hasClass(dom, "ct-status")) {
	    var tagName = getTagName(dom.parentNode);
	
	    if (tagName === "h1" || tagName === "h2") {
	      if (hasClass(dom, "ct-mention")) {
	        top -= tagName === "h1" ? 11 : 6;
	      } else {
	        top -= tagName === "h1" ? 7 : 2;
	      }
	    }
	
	    if (tagName === "p") {
	      tagName = getTagName(dom.parentNode.parentNode);
	    }
	
	    if (tagName === "td" || tagName === "th") {
	      top += 1;
	      left += 1;
	    }
	  }
	
	  if (lastCursor.height !== height || lastCursor.top !== top || lastCursor.left !== left) {
	    var id = lastCursor.id + 1;
	    var type = res.node.type.name;
	    lastCursor = {
	      id: id,
	      type: type,
	      dir: dir,
	      height: height,
	      top: top,
	      left: left
	    };
	    return true;
	  }
	
	  return false;
	}
	
	
	function getDomOffset(dom) {
	  var offsetTop = dom.offsetTop;
	  var offsetLeft = dom.offsetLeft;
	  var offsetParent = dom.offsetParent;
	
	  while (offsetParent && window.getComputedStyle(offsetParent, null).position === "static") {
	    offsetTop += offsetParent.offsetTop;
	    offsetLeft += offsetParent.offsetLeft;
	    offsetParent = offsetParent.offsetParent;
	  }
	
	  return {
	    offsetTop: offsetTop,
	    offsetLeft: offsetLeft
	  };
	}
	
	
	function getResDom(view, _res) {
	  if (!_res) {
	    return null;
	  }var pos = _res.pos,
	      dir = _res.dir;
	
	  var res = void 0;
	
	  try {
	    res = view.domAtPos(pos + (dir === "before" ? -1 : 0));
	  } catch (error) {
	    console.error(error);
	    return;
	  }
	
	  var dom = res.node.childNodes[res.offset];
	
	  if (hasClass(dom, "ProseMirror-gapcursor")) {
	    dom = res.node.childNodes[res.offset + (dir === "before" ? -1 : 2)];
	  }
	
	  if (hasClass(dom, "ct-table-wrapper")) {
	    dom = dom.firstChild;
	  }
	
	  var nodeCls = res.node.className;
	  var caseArr = ["ct-note-content", "ct-collapse-content", "ct-task-li", "ct-task-li-checked"];
	
	  if (nodeCls && /^ct-/.test(nodeCls) && !caseArr.includes(nodeCls)) {
	    dom = res.node;
	  }
	
	  if (getTagName(res.node) === "tbody") {
	    dom = res.node.parentNode;
	  }
	
	  if (getTagName(res.node) === "code") {
	    dom = res.node.parentNode && res.node.parentNode.parentNode;
	  }
	
	  if (getTagName(dom) === "div" && hasClass(dom.parentNode, "CodeMirror")) {
	    dom = dom.parentNode;
	  }
	
	  return dom;
	}
	
	function getTagName(dom) {
	  return (dom && dom.tagName || "").toLowerCase();
	}
	
	function hasClass(dom, cls) {
	  return dom && dom.className && dom.classList.contains(cls);
	}
	
	function handleKeyUp(view, event) {
	  if (event.keyCode === 229) {
	    var state = view.state,
	        dispatch = view.dispatch;
	    var tr = state.tr,
	        selection = state.selection;
	    var $from = selection.$from;
	
	
	    if (selection instanceof GapCursor && $from.nodeAfter && $from.nodeAfter.type.name === "image") {
	      var newSelection = prosemirrorState.TextSelection.create(tr.doc, $from.pos);
	      tr.setSelection(newSelection);
	      dispatch(tr);
	      view.focus();
	    }
	  }
	
	  return false;
	}
	
	function handleMouseDown() {
	  setLastAction("mouseDown");
	  return false;
	}
	
	function handleMouseUp() {
	  setLastAction("mouseUp");
	  return false;
	}
	
	
	function handleClick(view, _pos, event) {
	  setLastAction("click");
	  var state = view.state;
	  var posInfo = view.posAtCoords({
	    left: event.clientX,
	    top: event.clientY
	  });
	  var pos = _pos;
	  var $pos = state.doc.resolve(pos);
	
	  if ($pos.nodeAfter && $pos.nodeAfter.type.name === 'paragraph') {
	    view.dispatch(view.state.tr.setSelection(prosemirrorState.TextSelection.create(state.doc, pos + 1, pos + 1)));
	    return true;
	  }
	
	  var $from = view.state.selection.$from;
	  var parentNode = $from.node(-1);
	  var afterNode = $from.nodeAfter;
	
	  if (parentNode && afterNode && parentNode.type.name === "list_item" && afterNode.type.name === "text") {
	    return false;
	  }
	
	  var listNode = $from.node(-4);
	  var tableNode = $from.node(-3);
	  var tableStart = $from.start(-3);
	
	  if (listNode && tableNode && listNode.type.name === "list_item" && tableNode.type.name === "table" && pos < tableStart) {
	    updateCursorStyle(view.docView.domFromPos(tableStart), {
	      dir: "after",
	      node: tableNode
	    });
	    var _newSelection = new GapCursor(state.doc.resolve(tableStart - 1));
	    view.dispatch(state.tr.setSelection(_newSelection));
	    return true;
	  }
	
	  try {
	    var nodeSelection = prosemirrorState.NodeSelection.create(state.doc, pos);
	
	    if (nodeSelection) {
	      var selNode = nodeSelection.node;
	
	      if (selNode.type.name === "image" || selNode.type.name === "drawio") {
	        var domNode = view.docView.domFromPos(pos).node;
	        var imageDom = domNode.querySelector('[src="' + selNode.attrs.src + '"]');
	        var imageDomRect = imageDom.getBoundingClientRect();
	
	        if (event.x > imageDomRect.x && event.y < imageDomRect.y) {
	          var _newSelection2 = new prosemirrorState.TextSelection(state.doc.resolve(_pos));
	          view.dispatch(state.tr.setSelection(_newSelection2));
	          return false;
	        }
	      }
	    }
	  } catch (error) {}
	
	  var isNodeSelected = posInfo && posInfo.pos === posInfo.inside;
	
	  if (posInfo && posInfo.inside > -1 && posInfo.inside + 1 === posInfo.pos) {
	    if ($pos.nodeBefore && $pos.nodeBefore.nodeSize === 1) {
	      isNodeSelected = true;
	    }
	  }
	
	  if (isNodeSelected) {
	    return false;
	  }
	
	  var isStatus = $pos.node().type.name === "status";
	  var isStatusLeft = isStatus && posInfo.inside !== $pos.before() && pos === $pos.start();
	  var isStatusRight = isStatus && posInfo.inside !== $pos.before() && pos > $pos.start();
	
	  if (isStatusLeft) {
	    pos = $pos.before();
	    $pos = state.doc.resolve(pos);
	  } else if (isStatusRight) {
	    pos = $pos.after();
	    $pos = state.doc.resolve(pos);
	  }
	
	  var isAfter = pos === $pos.start() || getClickDir(event) === "left";
	  var isBefore = pos === $pos.end() || $pos.parent.type.name === "table" && pos === $pos.start();
	  var dir = (isBefore ? "before" : "") || (isAfter ? "after" : "");
	  var res = GapCursor.findFrom($pos, dir);
	
	  if (!res) {
	    return false;
	  }
	
	  var dom = getResDom(view, res);
	
	  if (dom && res.dir === "before") {
	    var rect = dom.getBoundingClientRect();
	
	    if (event.pageY > rect.top + rect.height) {
	      res = GapCursor.findFrom($pos, "after");
	      dom = getResDom(view, res);
	
	      if (!res || !dom) {
	        view.focus();
	        return false;
	      }
	    }
	  }
	
	  updateCursorStyle(dom, res);
	  var newSelection = new GapCursor(state.doc.resolve(res.pos), dom);
	  view.dispatch(state.tr.setSelection(newSelection));
	  return true;
	}
	
	function handleDoubleClick(view, _pos) {
	  var state = view.state;
	  var selection = state.selection;
	
	
	  if (selection instanceof GapCursor && selection.$from.pos === _pos) {
	    return true;
	  }
	}
	
	var handleKeyDown = index_js.keydownHandler({
	  ArrowLeft: arrow("left"),
	  ArrowRight: arrow("right"),
	  ArrowUp: arrow("up"),
	  ArrowDown: arrow("down"),
	  "Shift-ArrowLeft": arrow("left", true),
	  "Shift-ArrowRight": arrow("right", true)
	});
	
	
	function getEnterOffset(view, $pos, res, dir) {
	  var name = res.node.type.name;
	  var pos = res.node.nodeSize;
	
	  if (name === "table") {
	    pos = 3;
	  } else if (name === "code") {
	    pos = 2;
	  }
	
	  return (dir === "right" ? 1 : -1) * pos;
	}
	
	
	function getLeaveOffset(view, $pos, res, dir) {
	  var offset = 0;
	  var nextNode = dir === "right" ? $pos.nodeAfter : $pos.nodeBefore;
	  var isSamePos = !!(res.node.isBlock && nextNode && nextNode.type.spec.allowGapCursor);
	  var ratio = isSamePos ? 0 : 1;
	  offset = dir === "right" ? ratio : $pos.pos > 0 ? -1 * ratio : 0;
	
	  if (!isSamePos && view.endOfTextblock(dir)) {
	    var $next = view.state.doc.resolve($pos.pos + offset);
	
	    if ($next.node().type.name === "list_item") {
	      offset += dir === "right" ? 2 : -2;
	      $next = view.state.doc.resolve($pos.pos + offset);
	    }
	
	    var node = dir === "right" ? $next.nodeAfter : $next.nodeBefore;
	    var offsetMap = {
	      bullet_list: 2,
	      paragraph: 1
	    };
	
	    if (node && offsetMap[node.type.name]) {
	      offset += (dir === "right" ? 1 : -1) * offsetMap[node.type.name];
	    }
	  }
	
	  return offset;
	}
	
	
	function isFirstNode($pos, node) {
	  var target = node;
	
	  for (var d = $pos.depth; d >= 0; d--) {
	    if ($pos.node(d).firstChild !== target) {
	      return false;
	    }
	
	    target = $pos.node(d);
	  }
	
	  return true;
	}
	
	
	function isLastNode($pos, node) {
	  var target = node;
	
	  for (var d = $pos.depth; d >= 0; d--) {
	    if ($pos.node(d).lastChild !== target) {
	      return false;
	    }
	
	    target = $pos.node(d);
	  }
	
	  return true;
	}
	
	
	function arrow(dir, isShift) {
	  return function (state, dispatch, view) {
	    var tr = state.tr;
	    var _state$selection = state.selection,
	        $from = _state$selection.$from,
	        from = _state$selection.from;
	    var status = state.schema.nodes.status;
	
	    setLastAction("keyDown", {
	      dir: dir
	    });
	
	    if (dir === "left") {
	      var textPos = from - 3;
	
	      if (state.selection.$anchor.parentOffset === 0) {
	        textPos -= 1;
	      }
	
	      if (textPos < 0) {
	        return false;
	      }
	
	      if ($from.parentOffset === 0 && !$from.nodeBefore) {
	        var _$pos = tr.doc.resolve(from - 2);
	
	        if (_$pos.nodeBefore && _$pos.nodeBefore.type.name === "table_row") {
	          var _newSelection3 = prosemirrorState.TextSelection.create(tr.doc, from - 4);
	          dispatch(tr.setSelection(_newSelection3));
	          return true;
	        }
	      }
	
	      var textNode = tr.doc.nodeAt(textPos);
	
	      if (textNode && textNode.type.name === "text") {
	        var statusPos = textPos - textNode.nodeSize;
	
	        if (statusPos < 0) {
	          return false;
	        }
	
	        var statusNode = tr.doc.nodeAt(statusPos);
	
	        if (statusNode && statusNode.type.name === "status") {
	          var _newSelection4 = new GapCursor(tr.doc.resolve(textPos + 2));
	          dispatch(tr.setSelection(_newSelection4));
	          return true;
	        }
	      } else {
	        var parent = $from.parent,
	            nodeBefore = $from.nodeBefore;
	
	
	        if (parent && parent.type.name === status.name) {
	          if (nodeBefore && nodeBefore.text === '\u200B') {
	            var _newSelection5 = prosemirrorState.TextSelection.create(tr.doc, from - 2);
	            dispatch(tr.setSelection(_newSelection5));
	            return true;
	          }
	        }
	
	        if (nodeBefore && nodeBefore.type.name === status.name) {
	          var _newSelection6 = prosemirrorState.TextSelection.create(tr.doc, from - nodeBefore.nodeSize);
	          dispatch(tr.setSelection(_newSelection6));
	          return true;
	        }
	      }
	    }
	
	    if (dir === "right") {
	      if (state.selection.$cursor) {
	        var $cursor = state.selection.$cursor;
	
	        if (!$cursor.nodeAfter && $cursor.parent.type.name === status.name) {
	          dispatch(tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, from + 1)));
	          view.focus();
	          return true;
	        }
	      } else {
	        var nodeAfter = state.selection.$from.nodeAfter;
	
	        if (nodeAfter && nodeAfter.type.name === status.name) {
	          dispatch(tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, from + 1 + nodeAfter.nodeSize)));
	          view.focus();
	          return true;
	        }
	      }
	    }
	
	    if (!(state.selection instanceof GapCursor)) {
	      skipUpdate = dir === "up" || dir === "down";
	      return false;
	    }
	
	    var selection = state.selection,
	        doc = state.doc;
	
	    var pos = selection.head;
	    var $pos = doc.resolve(pos);
	
	    if (dir === "up" || dir === "down") {
	      var beforeNode = selection.$from.nodeBefore;
	      var afterNode = selection.$to.nodeAfter;
	
	      if (beforeNode && beforeNode.type.name === "status" || afterNode && afterNode.type.name === "status") {
	        var path = selection.$from.path;
	        var parentNode = path[path.length - 3];
	        var parent1Node = path[path.length - 6];
	        var parent2Node = path[path.length - 9];
	        var parent3Node = path[path.length - 12];
	
	        if (parent2Node && parent2Node.type.name === "table_row") {
	          var newPos = null;
	
	          if (dir === "up" && parent1Node.firstChild === parentNode && parent3Node.firstChild !== parent2Node) {
	            var rowIndex = parent3Node.content.content.indexOf(parent2Node);
	            var cellIndex = parent2Node.content.content.indexOf(parent1Node);
	            var tableContent = parent3Node.content.content;
	            var rowContent = parent3Node.content.content[rowIndex - 1].content.content;
	            newPos = path[path.length - 13] + 2;
	            tableContent.forEach(function (node, i) {
	              if (i < rowIndex - 1) {
	                newPos += node.nodeSize;
	              }
	            });
	            rowContent.forEach(function (node, i) {
	              if (i < cellIndex) {
	                newPos += node.nodeSize;
	              }
	            });
	          } else if (dir === "down" && parent1Node.lastChild === parentNode && parent3Node.lastChild !== parent2Node) {
	            var _rowIndex = parent3Node.content.content.indexOf(parent2Node);
	            var _cellIndex = parent2Node.content.content.indexOf(parent1Node);
	            var _tableContent = parent3Node.content.content;
	            var _rowContent = parent3Node.content.content[_rowIndex + 1].content.content;
	            newPos = path[path.length - 13] + 2;
	            _tableContent.forEach(function (node, i) {
	              if (i <= _rowIndex) {
	                newPos += node.nodeSize;
	              }
	            });
	            _rowContent.forEach(function (node, i) {
	              if (i < _cellIndex) {
	                newPos += node.nodeSize;
	              }
	            });
	          }
	
	          if (newPos) {
	            var _newSelection8 = prosemirrorState.TextSelection.create(doc, newPos);
	            dispatch(state.tr.setSelection(_newSelection8));
	            return false;
	          }
	        }
	      }
	
	      if ($pos.depth) {
	        pos = dir === "up" ? $pos.before() > 0 ? $pos.before() - 1 : 0 : $pos.after() + 1;
	      } else {
	        pos += dir === "up" ? pos > 0 ? -1 : 0 : 1;
	      }
	
	      if (dir === "down") {
	        var docSize = doc.resolve(0).node().nodeSize;
	
	        if (pos > docSize - 2) {
	          pos = docSize - 2;
	        }
	      }
	
	      var _newSelection7 = !isShift ? prosemirrorState.TextSelection.create(doc, pos) : prosemirrorState.TextSelection.create(doc, selection.anchor, pos);
	      dispatch(state.tr.setSelection(_newSelection7));
	      return true;
	    }
	
	    var curRes = GapCursor.findFrom($pos, lastCursor.dir);
	
	    if (!curRes) {
	      return false;
	    }
	
	    var isDocBegin = curRes.dir === "after" && isFirstNode($pos, curRes.node);
	    var isDocEnd = curRes.dir === "before" && isLastNode($pos, curRes.node);
	
	    if (isDocBegin && dir === "left" || isDocEnd && dir === "right") {
	      return true;
	    }
	
	    if (curRes.dir === "before" && dir === "right" || curRes.dir === "after" && dir === "left") {
	      pos += getLeaveOffset(view, $pos, curRes, dir);
	      setFindDir(dir === "right" ? "after" : "before");
	    } else {
	      pos += getEnterOffset(view, $pos, curRes, dir);
	      setFindDir(dir === "right" ? "before" : "after");
	    }
	
	    var newSelection = !isShift ? prosemirrorState.TextSelection.create(state.doc, pos) : prosemirrorState.TextSelection.create(doc, selection.anchor, pos);
	    dispatch(tr.setSelection(newSelection));
	    return true;
	  };
	}
	
	
	function getClickDir(event) {
	  var pmNode = document.querySelector(".ProseMirror");
	  var pmNodeStyle = window.getComputedStyle(pmNode, null);
	  var paddingLeft = parseInt(pmNodeStyle.paddingLeft, 10);
	  var paddingRight = parseInt(pmNodeStyle.paddingRight, 10);
	
	  var _pmNode$getBoundingCl = pmNode.getBoundingClientRect(),
	      left = _pmNode$getBoundingCl.left;
	
	  if (event.clientX <= left + paddingLeft) {
	    return "left";
	  }
	
	  return event.pageX >= pmNode.offsetWidth - paddingRight ? "right" : "inner";
	}
	
	var CursorModule = function CursorModule() {
	  (0, _classCallCheck3.default)(this, CursorModule);
	
	  this.name = 'cursor';
	  this.plugins = [dropCursor(), gapCursor()];
	};
	
	CursorModule.moduleName = 'cursor';
	
	exports.CursorModule = CursorModule;
	exports.GapCursor = GapCursor;
	exports.getGapCursor = getGapCursor;
	exports.setLastAction = setLastAction;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(325), __esModule: true };

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _setPrototypeOf = __webpack_require__(64);
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _create = __webpack_require__(57);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _typeof2 = __webpack_require__(8);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
	  }
	
	  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	};

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _typeof2 = __webpack_require__(8);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	};

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(50)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _create = __webpack_require__(57);
	
	var _create2 = _interopRequireDefault(_create);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var w3cKeyname = __webpack_require__(662);
	var prosemirrorState = __webpack_require__(6);
	
	var mac = typeof navigator !== 'undefined' ? /Mac/.test(navigator.platform) : false;
	
	function normalizeKeyName(name) {
	  var parts = name.split(/-(?!$)/);
	  var result = parts[parts.length - 1];
	  if (result === 'Space') result = ' ';
	  var alt = void 0,
	      ctrl = void 0,
	      shift = void 0,
	      meta = void 0;
	
	  for (var i = 0; i < parts.length - 1; i++) {
	    var mod = parts[i];
	    if (/^(cmd|meta|m)$/i.test(mod)) meta = true;else if (/^a(lt)?$/i.test(mod)) alt = true;else if (/^(c|ctrl|control)$/i.test(mod)) ctrl = true;else if (/^s(hift)?$/i.test(mod)) shift = true;else if (/^mod$/i.test(mod)) {
	      if (mac) meta = true;else ctrl = true;
	    } else throw new Error('Unrecognized modifier name: ' + mod);
	  }
	
	  if (alt) result = 'Alt-' + result;
	  if (ctrl) result = 'Ctrl-' + result;
	  if (meta) result = 'Meta-' + result;
	  if (shift) result = 'Shift-' + result;
	  return result;
	}
	
	function normalize(map) {
	  var copy = (0, _create2.default)(null);
	
	  for (var prop in map) {
	    copy[normalizeKeyName(prop)] = map[prop];
	  }return copy;
	}
	
	function modifiers(name, event, shift) {
	  if (event.altKey) name = 'Alt-' + name;
	  if (event.ctrlKey) name = 'Ctrl-' + name;
	  if (event.metaKey) name = 'Meta-' + name;
	  if (shift !== false && event.shiftKey) name = 'Shift-' + name;
	  return name;
	}
	
	function keymap(bindings) {
	  return new prosemirrorState.Plugin({
	    key: new prosemirrorState.PluginKey('keymap' + (Math.random() + '').slice(2)),
	    props: {
	      handleKeyDown: keydownHandler(bindings)
	    }
	  });
	}
	
	function keydownHandler(bindings) {
	  var map = normalize(bindings);
	  return function (view, event) {
	    var name = w3cKeyname.keyName(event);
	    var isChar = name.length === 1 && name !== ' ';
	    var baseName = void 0;
	
	    if (isChar && (event.shiftKey || event.altKey || event.metaKey) && (baseName = w3cKeyname.base[event.keyCode])) {
	      var _command = map[modifiers(baseName, event, true)];
	
	      if (_command && _command(view.state, view.dispatch, view, event)) {
	        event.preventDefault();
	        return true;
	      }
	    }
	
	    var mapKey = modifiers(name, event, !isChar);
	    var command = map[mapKey];
	
	    if (command && command(view.state, view.dispatch, view, event)) {
	      event.preventDefault();
	      return true;
	    }
	
	    return false;
	  };
	}
	
	exports.default = keymap;
	exports.keydownHandler = keydownHandler;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(328), __esModule: true };

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(27);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(36);
	var IE8_DOM_DEFINE = __webpack_require__(157);
	var toPrimitive = __webpack_require__(121);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(33) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.isEmpty = exports.isEqual = exports.arrayEquals = exports.looseEqual = exports.capitalize = exports.kebabCase = exports.autoprefixer = exports.isFirefox = exports.isEdge = exports.isIE = exports.coerceTruthyValueToArray = exports.arrayFind = exports.arrayFindIndex = exports.escapeRegexpString = exports.valueEquals = exports.generateId = exports.getValueByPath = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.noop = noop;
	exports.hasOwn = hasOwn;
	exports.toObject = toObject;
	exports.getPropByPath = getPropByPath;
	exports.rafThrottle = rafThrottle;
	exports.objToArray = objToArray;
	
	var _vue = __webpack_require__(20);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _types = __webpack_require__(181);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	function noop() {};
	
	function hasOwn(obj, key) {
	  return hasOwnProperty.call(obj, key);
	};
	
	function extend(to, _from) {
	  for (var key in _from) {
	    to[key] = _from[key];
	  }
	  return to;
	};
	
	function toObject(arr) {
	  var res = {};
	  for (var i = 0; i < arr.length; i++) {
	    if (arr[i]) {
	      extend(res, arr[i]);
	    }
	  }
	  return res;
	};
	
	var getValueByPath = exports.getValueByPath = function getValueByPath(object, prop) {
	  prop = prop || '';
	  var paths = prop.split('.');
	  var current = object;
	  var result = null;
	  for (var i = 0, j = paths.length; i < j; i++) {
	    var path = paths[i];
	    if (!current) break;
	
	    if (i === j - 1) {
	      result = current[path];
	      break;
	    }
	    current = current[path];
	  }
	  return result;
	};
	
	function getPropByPath(obj, path, strict) {
	  var tempObj = obj;
	  path = path.replace(/\[(\w+)\]/g, '.$1');
	  path = path.replace(/^\./, '');
	
	  var keyArr = path.split('.');
	  var i = 0;
	  for (var len = keyArr.length; i < len - 1; ++i) {
	    if (!tempObj && !strict) break;
	    var key = keyArr[i];
	    if (key in tempObj) {
	      tempObj = tempObj[key];
	    } else {
	      if (strict) {
	        throw new Error('please transfer a valid prop path to form item!');
	      }
	      break;
	    }
	  }
	  return {
	    o: tempObj,
	    k: keyArr[i],
	    v: tempObj ? tempObj[keyArr[i]] : null
	  };
	};
	
	var generateId = exports.generateId = function generateId() {
	  return Math.floor(Math.random() * 10000);
	};
	
	var valueEquals = exports.valueEquals = function valueEquals(a, b) {
	  // see: https://stackoverflow.com/questions/3115982/how-to-check-if-two-arrays-are-equal-with-javascript
	  if (a === b) return true;
	  if (!(a instanceof Array)) return false;
	  if (!(b instanceof Array)) return false;
	  if (a.length !== b.length) return false;
	  for (var i = 0; i !== a.length; ++i) {
	    if (a[i] !== b[i]) return false;
	  }
	  return true;
	};
	
	var escapeRegexpString = exports.escapeRegexpString = function escapeRegexpString() {
	  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	  return String(value).replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
	};
	
	// TODO: use native Array.find, Array.findIndex when IE support is dropped
	var arrayFindIndex = exports.arrayFindIndex = function arrayFindIndex(arr, pred) {
	  for (var i = 0; i !== arr.length; ++i) {
	    if (pred(arr[i])) {
	      return i;
	    }
	  }
	  return -1;
	};
	
	var arrayFind = exports.arrayFind = function arrayFind(arr, pred) {
	  var idx = arrayFindIndex(arr, pred);
	  return idx !== -1 ? arr[idx] : undefined;
	};
	
	// coerce truthy value to array
	var coerceTruthyValueToArray = exports.coerceTruthyValueToArray = function coerceTruthyValueToArray(val) {
	  if (Array.isArray(val)) {
	    return val;
	  } else if (val) {
	    return [val];
	  } else {
	    return [];
	  }
	};
	
	var isIE = exports.isIE = function isIE() {
	  return !_vue2.default.prototype.$isServer && !isNaN(Number(document.documentMode));
	};
	
	var isEdge = exports.isEdge = function isEdge() {
	  return !_vue2.default.prototype.$isServer && navigator.userAgent.indexOf('Edge') > -1;
	};
	
	var isFirefox = exports.isFirefox = function isFirefox() {
	  return !_vue2.default.prototype.$isServer && !!window.navigator.userAgent.match(/firefox/i);
	};
	
	var autoprefixer = exports.autoprefixer = function autoprefixer(style) {
	  if ((typeof style === 'undefined' ? 'undefined' : _typeof(style)) !== 'object') return style;
	  var rules = ['transform', 'transition', 'animation'];
	  var prefixes = ['ms-', 'webkit-'];
	  rules.forEach(function (rule) {
	    var value = style[rule];
	    if (rule && value) {
	      prefixes.forEach(function (prefix) {
	        style[prefix + rule] = value;
	      });
	    }
	  });
	  return style;
	};
	
	var kebabCase = exports.kebabCase = function kebabCase(str) {
	  var hyphenateRE = /([^-])([A-Z])/g;
	  return str.replace(hyphenateRE, '$1-$2').replace(hyphenateRE, '$1-$2').toLowerCase();
	};
	
	var capitalize = exports.capitalize = function capitalize(str) {
	  if (!(0, _types.isString)(str)) return str;
	  return str.charAt(0).toUpperCase() + str.slice(1);
	};
	
	var looseEqual = exports.looseEqual = function looseEqual(a, b) {
	  var isObjectA = (0, _types.isObject)(a);
	  var isObjectB = (0, _types.isObject)(b);
	  if (isObjectA && isObjectB) {
	    return JSON.stringify(a) === JSON.stringify(b);
	  } else if (!isObjectA && !isObjectB) {
	    return String(a) === String(b);
	  } else {
	    return false;
	  }
	};
	
	var arrayEquals = exports.arrayEquals = function arrayEquals(arrayA, arrayB) {
	  arrayA = arrayA || [];
	  arrayB = arrayB || [];
	
	  if (arrayA.length !== arrayB.length) {
	    return false;
	  }
	
	  for (var i = 0; i < arrayA.length; i++) {
	    if (!looseEqual(arrayA[i], arrayB[i])) {
	      return false;
	    }
	  }
	
	  return true;
	};
	
	var isEqual = exports.isEqual = function isEqual(value1, value2) {
	  if (Array.isArray(value1) && Array.isArray(value2)) {
	    return arrayEquals(value1, value2);
	  }
	  return looseEqual(value1, value2);
	};
	
	var isEmpty = exports.isEmpty = function isEmpty(val) {
	  // null or undefined
	  if (val == null) return true;
	
	  if (typeof val === 'boolean') return false;
	
	  if (typeof val === 'number') return !val;
	
	  if (val instanceof Error) return val.message === '';
	
	  switch (Object.prototype.toString.call(val)) {
	    // String or Array
	    case '[object String]':
	    case '[object Array]':
	      return !val.length;
	
	    // Map or Set or File
	    case '[object File]':
	    case '[object Map]':
	    case '[object Set]':
	      {
	        return !val.size;
	      }
	    // Plain Object
	    case '[object Object]':
	      {
	        return !Object.keys(val).length;
	      }
	  }
	
	  return false;
	};
	
	function rafThrottle(fn) {
	  var locked = false;
	  return function () {
	    var _this = this;
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    if (locked) return;
	    locked = true;
	    window.requestAnimationFrame(function (_) {
	      fn.apply(_this, args);
	      locked = false;
	    });
	  };
	}
	
	function objToArray(obj) {
	  if (Array.isArray(obj)) {
	    return obj;
	  }
	  return isEmpty(obj) ? [] : [obj];
	}

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _promise = __webpack_require__(35);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (fn) {
	  return function () {
	    var gen = fn.apply(this, arguments);
	    return new _promise2.default(function (resolve, reject) {
	      function step(key, arg) {
	        try {
	          var info = gen[key](arg);
	          var value = info.value;
	        } catch (error) {
	          reject(error);
	          return;
	        }
	
	        if (info.done) {
	          resolve(value);
	        } else {
	          return _promise2.default.resolve(value).then(function (value) {
	            step("next", value);
	          }, function (err) {
	            step("throw", err);
	          });
	        }
	      }
	
	      return step("next");
	    });
	  };
	};

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(279);


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(70);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.isInContainer = exports.getScrollContainer = exports.isScroll = exports.getStyle = exports.once = exports.off = exports.on = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /* istanbul ignore next */
	
	exports.hasClass = hasClass;
	exports.addClass = addClass;
	exports.removeClass = removeClass;
	exports.setStyle = setStyle;
	
	var _vue = __webpack_require__(20);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isServer = _vue2.default.prototype.$isServer;
	var SPECIAL_CHARS_REGEXP = /([\:\-\_]+(.))/g;
	var MOZ_HACK_REGEXP = /^moz([A-Z])/;
	var ieVersion = isServer ? 0 : Number(document.documentMode);
	
	/* istanbul ignore next */
	var trim = function trim(string) {
	  return (string || '').replace(/^[\s\uFEFF]+|[\s\uFEFF]+$/g, '');
	};
	/* istanbul ignore next */
	var camelCase = function camelCase(name) {
	  return name.replace(SPECIAL_CHARS_REGEXP, function (_, separator, letter, offset) {
	    return offset ? letter.toUpperCase() : letter;
	  }).replace(MOZ_HACK_REGEXP, 'Moz$1');
	};
	
	/* istanbul ignore next */
	var on = exports.on = function () {
	  if (!isServer && document.addEventListener) {
	    return function (element, event, handler) {
	      if (element && event && handler) {
	        element.addEventListener(event, handler, false);
	      }
	    };
	  } else {
	    return function (element, event, handler) {
	      if (element && event && handler) {
	        element.attachEvent('on' + event, handler);
	      }
	    };
	  }
	}();
	
	/* istanbul ignore next */
	var off = exports.off = function () {
	  if (!isServer && document.removeEventListener) {
	    return function (element, event, handler) {
	      if (element && event) {
	        element.removeEventListener(event, handler, false);
	      }
	    };
	  } else {
	    return function (element, event, handler) {
	      if (element && event) {
	        element.detachEvent('on' + event, handler);
	      }
	    };
	  }
	}();
	
	/* istanbul ignore next */
	var once = exports.once = function once(el, event, fn) {
	  var listener = function listener() {
	    if (fn) {
	      fn.apply(this, arguments);
	    }
	    off(el, event, listener);
	  };
	  on(el, event, listener);
	};
	
	/* istanbul ignore next */
	function hasClass(el, cls) {
	  if (!el || !cls) return false;
	  if (cls.indexOf(' ') !== -1) throw new Error('className should not contain space.');
	  if (el.classList) {
	    return el.classList.contains(cls);
	  } else {
	    return (' ' + el.className + ' ').indexOf(' ' + cls + ' ') > -1;
	  }
	};
	
	/* istanbul ignore next */
	function addClass(el, cls) {
	  if (!el) return;
	  var curClass = el.className;
	  var classes = (cls || '').split(' ');
	
	  for (var i = 0, j = classes.length; i < j; i++) {
	    var clsName = classes[i];
	    if (!clsName) continue;
	
	    if (el.classList) {
	      el.classList.add(clsName);
	    } else if (!hasClass(el, clsName)) {
	      curClass += ' ' + clsName;
	    }
	  }
	  if (!el.classList) {
	    el.className = curClass;
	  }
	};
	
	/* istanbul ignore next */
	function removeClass(el, cls) {
	  if (!el || !cls) return;
	  var classes = cls.split(' ');
	  var curClass = ' ' + el.className + ' ';
	
	  for (var i = 0, j = classes.length; i < j; i++) {
	    var clsName = classes[i];
	    if (!clsName) continue;
	
	    if (el.classList) {
	      el.classList.remove(clsName);
	    } else if (hasClass(el, clsName)) {
	      curClass = curClass.replace(' ' + clsName + ' ', ' ');
	    }
	  }
	  if (!el.classList) {
	    el.className = trim(curClass);
	  }
	};
	
	/* istanbul ignore next */
	var getStyle = exports.getStyle = ieVersion < 9 ? function (element, styleName) {
	  if (isServer) return;
	  if (!element || !styleName) return null;
	  styleName = camelCase(styleName);
	  if (styleName === 'float') {
	    styleName = 'styleFloat';
	  }
	  try {
	    switch (styleName) {
	      case 'opacity':
	        try {
	          return element.filters.item('alpha').opacity / 100;
	        } catch (e) {
	          return 1.0;
	        }
	      default:
	        return element.style[styleName] || element.currentStyle ? element.currentStyle[styleName] : null;
	    }
	  } catch (e) {
	    return element.style[styleName];
	  }
	} : function (element, styleName) {
	  if (isServer) return;
	  if (!element || !styleName) return null;
	  styleName = camelCase(styleName);
	  if (styleName === 'float') {
	    styleName = 'cssFloat';
	  }
	  try {
	    var computed = document.defaultView.getComputedStyle(element, '');
	    return element.style[styleName] || computed ? computed[styleName] : null;
	  } catch (e) {
	    return element.style[styleName];
	  }
	};
	
	/* istanbul ignore next */
	function setStyle(element, styleName, value) {
	  if (!element || !styleName) return;
	
	  if ((typeof styleName === 'undefined' ? 'undefined' : _typeof(styleName)) === 'object') {
	    for (var prop in styleName) {
	      if (styleName.hasOwnProperty(prop)) {
	        setStyle(element, prop, styleName[prop]);
	      }
	    }
	  } else {
	    styleName = camelCase(styleName);
	    if (styleName === 'opacity' && ieVersion < 9) {
	      element.style.filter = isNaN(value) ? '' : 'alpha(opacity=' + value * 100 + ')';
	    } else {
	      element.style[styleName] = value;
	    }
	  }
	};
	
	var isScroll = exports.isScroll = function isScroll(el, vertical) {
	  if (isServer) return;
	
	  var determinedDirection = vertical !== null || vertical !== undefined;
	  var overflow = determinedDirection ? vertical ? getStyle(el, 'overflow-y') : getStyle(el, 'overflow-x') : getStyle(el, 'overflow');
	
	  return overflow.match(/(scroll|auto)/);
	};
	
	var getScrollContainer = exports.getScrollContainer = function getScrollContainer(el, vertical) {
	  if (isServer) return;
	
	  var parent = el;
	  while (parent) {
	    if ([window, document, document.documentElement].includes(parent)) {
	      return window;
	    }
	    if (isScroll(parent, vertical)) {
	      return parent;
	    }
	    parent = parent.parentNode;
	  }
	
	  return parent;
	};
	
	var isInContainer = exports.isInContainer = function isInContainer(el, container) {
	  if (isServer || !el || !container) return false;
	
	  var elRect = el.getBoundingClientRect();
	  var containerRect = void 0;
	
	  if ([window, document, document.documentElement, null, undefined].includes(container)) {
	    containerRect = {
	      top: 0,
	      right: window.innerWidth,
	      bottom: window.innerHeight,
	      left: 0
	    };
	  } else {
	    containerRect = container.getBoundingClientRect();
	  }
	
	  return elRect.top < containerRect.bottom && elRect.bottom > containerRect.top && elRect.right > containerRect.left && elRect.left < containerRect.right;
	};

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(314), __esModule: true };

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(15);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (obj, key, value) {
	  if (key in obj) {
	    (0, _defineProperty2.default)(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};

/***/ }),
/* 45 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(37);
	var createDesc = __webpack_require__(75);
	module.exports = __webpack_require__(33) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(109);
	var defined = __webpack_require__(106);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var prosemirrorModel = __webpack_require__(12);
	var prosemirrorState = __webpack_require__(6);
	var prosemirrorTransform = __webpack_require__(25);
	
	var result = {};
	if (typeof navigator != "undefined" && typeof document != "undefined") {
	  var ie_edge = /Edge\/(\d+)/.exec(navigator.userAgent);
	  var ie_upto10 = /MSIE \d/.test(navigator.userAgent);
	  var ie_11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
	
	  result.mac = /Mac/.test(navigator.platform);
	  var ie = result.ie = !!(ie_upto10 || ie_11up || ie_edge);
	  result.ie_version = ie_upto10 ? document.documentMode || 6 : ie_11up ? +ie_11up[1] : ie_edge ? +ie_edge[1] : null;
	  result.gecko = !ie && /gecko\/(\d+)/i.test(navigator.userAgent);
	  result.gecko_version = result.gecko && +(/Firefox\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1];
	  var chrome = !ie && /Chrome\/(\d+)/.exec(navigator.userAgent);
	  result.chrome = !!chrome;
	  result.chrome_version = chrome && +chrome[1];
	  result.ios = !ie && /AppleWebKit/.test(navigator.userAgent) && /Mobile\/\w+/.test(navigator.userAgent);
	  result.android = /Android \d/.test(navigator.userAgent);
	  result.webkit = !ie && 'WebkitAppearance' in document.documentElement.style;
	  result.safari = /Apple Computer/.test(navigator.vendor);
	  result.webkit_version = result.webkit && +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1];
	}
	
	var domIndex = function(node) {
	  for (var index = 0;; index++) {
	    node = node.previousSibling;
	    if (!node) { return index }
	  }
	};
	
	var parentNode = function(node) {
	  var parent = node.parentNode;
	  return parent && parent.nodeType == 11 ? parent.host : parent
	};
	
	var textRange = function(node, from, to) {
	  var range = document.createRange();
	  range.setEnd(node, to == null ? node.nodeValue.length : to);
	  range.setStart(node, from || 0);
	  return range
	};
	
	// Scans forward and backward through DOM positions equivalent to the
	// given one to see if the two are in the same place (i.e. after a
	// text node vs at the end of that text node)
	var isEquivalentPosition = function(node, off, targetNode, targetOff) {
	  return targetNode && (scanFor(node, off, targetNode, targetOff, -1) ||
	                        scanFor(node, off, targetNode, targetOff, 1))
	};
	
	var atomElements = /^(img|br|input|textarea|hr)$/i;
	
	function scanFor(node, off, targetNode, targetOff, dir) {
	  for (;;) {
	    if (node == targetNode && off == targetOff) { return true }
	    if (off == (dir < 0 ? 0 : nodeSize(node)) || node.nodeType == 3 && node.nodeValue == "\ufeff") {
	      var parent = node.parentNode;
	      if (parent.nodeType != 1 || hasBlockDesc(node) || atomElements.test(node.nodeName) || node.contentEditable == "false")
	        { return false }
	      off = domIndex(node) + (dir < 0 ? 0 : 1);
	      node = parent;
	    } else if (node.nodeType == 1) {
	      node = node.childNodes[off + (dir < 0 ? -1 : 0)];
	      off = dir < 0 ? nodeSize(node) : 0;
	    } else {
	      return false
	    }
	  }
	}
	
	function nodeSize(node) {
	  return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length
	}
	
	function hasBlockDesc(dom) {
	  var desc = dom.pmViewDesc;
	  return desc && desc.node && desc.node.isBlock
	}
	
	// Work around Chrome issue https://bugs.chromium.org/p/chromium/issues/detail?id=447523
	// (isCollapsed inappropriately returns true in shadow dom)
	var selectionCollapsed = function(domSel) {
	  var collapsed = domSel.isCollapsed;
	  if (collapsed && result.chrome && domSel.rangeCount && !domSel.getRangeAt(0).collapsed)
	    { collapsed = false; }
	  return collapsed
	};
	
	function keyEvent(keyCode, key) {
	  var event = document.createEvent("Event");
	  event.initEvent("keydown", true, true);
	  event.keyCode = keyCode;
	  event.key = event.code = key;
	  return event
	}
	
	function windowRect(win) {
	  return {left: 0, right: win.innerWidth,
	          top: 0, bottom: win.innerHeight}
	}
	
	function getSide(value, side) {
	  return typeof value == "number" ? value : value[side]
	}
	
	function scrollRectIntoView(view, rect, startDOM) {
	  var scrollThreshold = view.someProp("scrollThreshold") || 0, scrollMargin = view.someProp("scrollMargin") || 5;
	  var doc = view.dom.ownerDocument, win = doc.defaultView;
	  for (var parent = startDOM || view.dom;; parent = parentNode(parent)) {
	    if (!parent) { break }
	    if (parent.nodeType != 1) { continue }
	    var atTop = parent == doc.body || parent.nodeType != 1;
	    var bounding = atTop ? windowRect(win) : parent.getBoundingClientRect();
	    var moveX = 0, moveY = 0;
	    if (rect.top < bounding.top + getSide(scrollThreshold, "top"))
	      { moveY = -(bounding.top - rect.top + getSide(scrollMargin, "top")); }
	    else if (rect.bottom > bounding.bottom - getSide(scrollThreshold, "bottom"))
	      { moveY = rect.bottom - bounding.bottom + getSide(scrollMargin, "bottom"); }
	    if (rect.left < bounding.left + getSide(scrollThreshold, "left"))
	      { moveX = -(bounding.left - rect.left + getSide(scrollMargin, "left")); }
	    else if (rect.right > bounding.right - getSide(scrollThreshold, "right"))
	      { moveX = rect.right - bounding.right + getSide(scrollMargin, "right"); }
	    if (moveX || moveY) {
	      if (atTop) {
	        win.scrollBy(moveX, moveY);
	      } else {
	        if (moveY) { parent.scrollTop += moveY; }
	        if (moveX) { parent.scrollLeft += moveX; }
	      }
	    }
	    if (atTop) { break }
	  }
	}
	
	// Store the scroll position of the editor's parent nodes, along with
	// the top position of an element near the top of the editor, which
	// will be used to make sure the visible viewport remains stable even
	// when the size of the content above changes.
	function storeScrollPos(view) {
	  var rect = view.dom.getBoundingClientRect(), startY = Math.max(0, rect.top);
	  var doc = view.dom.ownerDocument;
	  var refDOM, refTop;
	  for (var x = (rect.left + rect.right) / 2, y = startY + 1;
	       y < Math.min(innerHeight, rect.bottom); y += 5) {
	    var dom = view.root.elementFromPoint(x, y);
	    if (dom == view.dom || !view.dom.contains(dom)) { continue }
	    var localRect = dom.getBoundingClientRect();
	    if (localRect.top >= startY - 20) {
	      refDOM = dom;
	      refTop = localRect.top;
	      break
	    }
	  }
	  var stack = [];
	  for (var dom$1 = view.dom; dom$1; dom$1 = parentNode(dom$1)) {
	    stack.push({dom: dom$1, top: dom$1.scrollTop, left: dom$1.scrollLeft});
	    if (dom$1 == doc.body) { break }
	  }
	  return {refDOM: refDOM, refTop: refTop, stack: stack}
	}
	
	// Reset the scroll position of the editor's parent nodes to that what
	// it was before, when storeScrollPos was called.
	function resetScrollPos(ref) {
	  var refDOM = ref.refDOM;
	  var refTop = ref.refTop;
	  var stack = ref.stack;
	
	  var newRefTop = refDOM ? refDOM.getBoundingClientRect().top : 0;
	  var dTop = newRefTop == 0 ? 0 : newRefTop - refTop;
	  for (var i = 0; i < stack.length; i++) {
	    var ref$1 = stack[i];
	    var dom = ref$1.dom;
	    var top = ref$1.top;
	    var left = ref$1.left;
	    if (dom.scrollTop != top + dTop) { dom.scrollTop = top + dTop; }
	    if (dom.scrollLeft != left) { dom.scrollLeft = left; }
	  }
	}
	
	function findOffsetInNode(node, coords) {
	  var closest, dxClosest = 2e8, coordsClosest, offset = 0;
	  var rowBot = coords.top, rowTop = coords.top;
	  for (var child = node.firstChild, childIndex = 0; child; child = child.nextSibling, childIndex++) {
	    var rects = (void 0);
	    if (child.nodeType == 1) { rects = child.getClientRects(); }
	    else if (child.nodeType == 3) { rects = textRange(child).getClientRects(); }
	    else { continue }
	
	    for (var i = 0; i < rects.length; i++) {
	      var rect = rects[i];
	      if (rect.top <= rowBot && rect.bottom >= rowTop) {
	        rowBot = Math.max(rect.bottom, rowBot);
	        rowTop = Math.min(rect.top, rowTop);
	        var dx = rect.left > coords.left ? rect.left - coords.left
	            : rect.right < coords.left ? coords.left - rect.right : 0;
	        if (dx < dxClosest) {
	          closest = child;
	          dxClosest = dx;
	          coordsClosest = dx && closest.nodeType == 3 ? {left: rect.right < coords.left ? rect.right : rect.left, top: coords.top} : coords;
	          if (child.nodeType == 1 && dx)
	            { offset = childIndex + (coords.left >= (rect.left + rect.right) / 2 ? 1 : 0); }
	          continue
	        }
	      }
	      if (!closest && (coords.left >= rect.right && coords.top >= rect.top ||
	                       coords.left >= rect.left && coords.top >= rect.bottom))
	        { offset = childIndex + 1; }
	    }
	  }
	  if (closest && closest.nodeType == 3) { return findOffsetInText(closest, coordsClosest) }
	  if (!closest || (dxClosest && closest.nodeType == 1)) { return {node: node, offset: offset} }
	  return findOffsetInNode(closest, coordsClosest)
	}
	
	function findOffsetInText(node, coords) {
	  var len = node.nodeValue.length;
	  var range = document.createRange();
	  for (var i = 0; i < len; i++) {
	    range.setEnd(node, i + 1);
	    range.setStart(node, i);
	    var rect = singleRect(range, 1);
	    if (rect.top == rect.bottom) { continue }
	    if (inRect(coords, rect))
	      { return {node: node, offset: i + (coords.left >= (rect.left + rect.right) / 2 ? 1 : 0)} }
	  }
	  return {node: node, offset: 0}
	}
	
	function inRect(coords, rect) {
	  return coords.left >= rect.left - 1 && coords.left <= rect.right + 1&&
	    coords.top >= rect.top - 1 && coords.top <= rect.bottom + 1
	}
	
	function targetKludge(dom, coords) {
	  var parent = dom.parentNode;
	  if (parent && /^li$/i.test(parent.nodeName) && coords.left < dom.getBoundingClientRect().left)
	    { return parent }
	  return dom
	}
	
	function posFromElement(view, elt, coords) {
	  var ref = findOffsetInNode(elt, coords);
	  var node = ref.node;
	  var offset = ref.offset;
	  var bias = -1;
	  if (node.nodeType == 1 && !node.firstChild) {
	    var rect = node.getBoundingClientRect();
	    bias = rect.left != rect.right && coords.left > (rect.left + rect.right) / 2 ? 1 : -1;
	  }
	  return view.docView.posFromDOM(node, offset, bias)
	}
	
	function posFromCaret(view, node, offset, coords) {
	  // Browser (in caretPosition/RangeFromPoint) will agressively
	  // normalize towards nearby inline nodes. Since we are interested in
	  // positions between block nodes too, we first walk up the hierarchy
	  // of nodes to see if there are block nodes that the coordinates
	  // fall outside of. If so, we take the position before/after that
	  // block. If not, we call `posFromDOM` on the raw node/offset.
	  var outside = -1;
	  for (var cur = node;;) {
	    if (cur == view.dom) { break }
	    var desc = view.docView.nearestDesc(cur, true);
	    if (!desc) { return null }
	    if (desc.node.isBlock && desc.parent) {
	      var rect = desc.dom.getBoundingClientRect();
	      if (rect.left > coords.left || rect.top > coords.top) { outside = desc.posBefore; }
	      else if (rect.right < coords.left || rect.bottom < coords.top) { outside = desc.posAfter; }
	      else { break }
	    }
	    cur = desc.dom.parentNode;
	  }
	  return outside > -1 ? outside : view.docView.posFromDOM(node, offset)
	}
	
	function elementFromPoint(element, coords, box) {
	  var len = element.childNodes.length;
	  if (len && box.top < box.bottom) {
	    for (var startI = Math.max(0, Math.floor(len * (coords.top - box.top) / (box.bottom - box.top)) - 2), i = startI;;) {
	      var child = element.childNodes[i];
	      if (child.nodeType == 1) {
	        var rects = child.getClientRects();
	        for (var j = 0; j < rects.length; j++) {
	          var rect = rects[j];
	          if (inRect(coords, rect)) { return elementFromPoint(child, coords, rect) }
	        }
	      }
	      if ((i = (i + 1) % len) == startI) { break }
	    }
	  }
	  return element
	}
	
	// Given an x,y position on the editor, get the position in the document.
	function posAtCoords(view, coords) {
	  var root = view.root, node, offset;
	  if (root.caretPositionFromPoint) {
	    var pos$1 = root.caretPositionFromPoint(coords.left, coords.top);
	    if (pos$1) { var assign;
	      ((assign = pos$1, node = assign.offsetNode, offset = assign.offset)); }
	  }
	  if (!node && root.caretRangeFromPoint) {
	    var range = root.caretRangeFromPoint(coords.left, coords.top);
	    if (range) { var assign$1;
	      ((assign$1 = range, node = assign$1.startContainer, offset = assign$1.startOffset)); }
	  }
	
	  var elt = root.elementFromPoint(coords.left, coords.top + 1), pos;
	  if (!elt || !view.dom.contains(elt.nodeType != 1 ? elt.parentNode : elt)) {
	    var box = view.dom.getBoundingClientRect();
	    if (!inRect(coords, box)) { return null }
	    elt = elementFromPoint(view.dom, coords, box);
	    if (!elt) { return null }
	  }
	  elt = targetKludge(elt, coords);
	  if (node) {
	    // Suspiciously specific kludge to work around caret*FromPoint
	    // never returning a position at the end of the document
	    if (node == view.dom && offset == node.childNodes.length - 1 && node.lastChild.nodeType == 1 &&
	        coords.top > node.lastChild.getBoundingClientRect().bottom)
	      { pos = view.state.doc.content.size; }
	    // Ignore positions directly after a BR, since caret*FromPoint
	    // 'round up' positions that would be more accurately placed
	    // before the BR node.
	    else if (offset == 0 || node.nodeType != 1 || node.childNodes[offset - 1].nodeName != "BR")
	      { pos = posFromCaret(view, node, offset, coords); }
	  }
	  if (pos == null) { pos = posFromElement(view, elt, coords); }
	
	  var desc = view.docView.nearestDesc(elt, true);
	  return {pos: pos, inside: desc ? desc.posAtStart - desc.border : -1}
	}
	
	function singleRect(object, bias) {
	  var rects = object.getClientRects();
	  return !rects.length ? object.getBoundingClientRect() : rects[bias < 0 ? 0 : rects.length - 1]
	}
	
	// : (EditorView, number) → {left: number, top: number, right: number, bottom: number}
	// Given a position in the document model, get a bounding box of the
	// character at that position, relative to the window.
	function coordsAtPos(view, pos) {
	  var ref = view.docView.domFromPos(pos);
	  var node = ref.node;
	  var offset = ref.offset;
	
	  // These browsers support querying empty text ranges
	  if (node.nodeType == 3 && (result.chrome || result.gecko)) {
	    var rect = singleRect(textRange(node, offset, offset), 0);
	    // Firefox returns bad results (the position before the space)
	    // when querying a position directly after line-broken
	    // whitespace. Detect this situation and and kludge around it
	    if (result.gecko && offset && /\s/.test(node.nodeValue[offset - 1]) && offset < node.nodeValue.length) {
	      var rectBefore = singleRect(textRange(node, offset - 1, offset - 1), -1);
	      if (Math.abs(rectBefore.left - rect.left) < 1 && rectBefore.top == rect.top) {
	        var rectAfter = singleRect(textRange(node, offset, offset + 1), -1);
	        return flattenV(rectAfter, rectAfter.left < rectBefore.left)
	      }
	    }
	    return rect
	  }
	
	  if (node.nodeType == 1 && !view.state.doc.resolve(pos).parent.inlineContent) {
	    // Return a horizontal line in block context
	    var top = true, rect$1;
	    if (offset < node.childNodes.length) {
	      var after = node.childNodes[offset];
	      if (after.nodeType == 1) { rect$1 = after.getBoundingClientRect(); }
	    }
	    if (!rect$1 && offset) {
	      var before = node.childNodes[offset - 1];
	      if (before.nodeType == 1) { rect$1 = before.getBoundingClientRect(); top = false; }
	    }
	    return flattenH(rect$1 || parent.getBoundingClientRect(), top)
	  }
	
	  // Not Firefox/Chrome, or not in a text node, so we have to use
	  // actual element/character rectangles to get a solution (this part
	  // is not very bidi-safe)
	  //
	  // Try the left side first, fall back to the right one if that
	  // doesn't work.
	  for (var dir = -1; dir < 2; dir += 2) {
	    if (dir < 0 && offset) {
	      var prev = (void 0), target = node.nodeType == 3 ? textRange(node, offset - 1, offset)
	          : (prev = node.childNodes[offset - 1]).nodeType == 3 ? textRange(prev)
	          : prev.nodeType == 1 && prev.nodeName != "BR" ? prev : null; // BR nodes tend to only return the rectangle before them
	      if (target) {
	        var rect$2 = singleRect(target, 1);
	        if (rect$2.top < rect$2.bottom) { return flattenV(rect$2, false) }
	      }
	    } else if (dir > 0 && offset < nodeSize(node)) {
	      var next = (void 0), target$1 = node.nodeType == 3 ? textRange(node, offset, offset + 1)
	          : (next = node.childNodes[offset]).nodeType == 3 ? textRange(next)
	          : next.nodeType == 1 ? next : null;
	      if (target$1) {
	        var rect$3 = singleRect(target$1, -1);
	        if (rect$3.top < rect$3.bottom) { return flattenV(rect$3, true) }
	      }
	    }
	  }
	  // All else failed, just try to get a rectangle for the target node
	  return flattenV(singleRect(node.nodeType == 3 ? textRange(node) : node, 0), false)
	}
	
	function flattenV(rect, left) {
	  if (rect.width == 0) { return rect }
	  var x = left ? rect.left : rect.right;
	  return {top: rect.top, bottom: rect.bottom, left: x, right: x}
	}
	
	function flattenH(rect, top) {
	  if (rect.height == 0) { return rect }
	  var y = top ? rect.top : rect.bottom;
	  return {top: y, bottom: y, left: rect.left, right: rect.right}
	}
	
	function withFlushedState(view, state, f) {
	  var viewState = view.state, active = view.root.activeElement;
	  if (viewState != state || !view.inDOMChange) { view.updateState(state); }
	  if (active != view.dom) { view.focus(); }
	  try {
	    return f()
	  } finally {
	    if (viewState != state) { view.updateState(viewState); }
	    if (active != view.dom) { active.focus(); }
	  }
	}
	
	// : (EditorView, number, number)
	// Whether vertical position motion in a given direction
	// from a position would leave a text block.
	function endOfTextblockVertical(view, state, dir) {
	  var sel = state.selection;
	  var $pos = dir == "up" ? sel.$anchor.min(sel.$head) : sel.$anchor.max(sel.$head);
	  return withFlushedState(view, state, function () {
	    var ref = view.docView.domFromPos($pos.pos);
	    var dom = ref.node;
	    for (;;) {
	      var nearest = view.docView.nearestDesc(dom, true);
	      if (!nearest) { break }
	      if (nearest.node.isBlock) { dom = nearest.dom; break }
	      dom = nearest.dom.parentNode;
	    }
	    var coords = coordsAtPos(view, $pos.pos);
	    for (var child = dom.firstChild; child; child = child.nextSibling) {
	      var boxes = (void 0);
	      if (child.nodeType == 1) { boxes = child.getClientRects(); }
	      else if (child.nodeType == 3) { boxes = textRange(child, 0, child.nodeValue.length).getClientRects(); }
	      else { continue }
	      for (var i = 0; i < boxes.length; i++) {
	        var box = boxes[i];
	        if (box.bottom > box.top && (dir == "up" ? box.bottom < coords.top + 1 : box.top > coords.bottom - 1))
	          { return false }
	      }
	    }
	    return true
	  })
	}
	
	var maybeRTL = /[\u0590-\u08ac]/;
	
	function endOfTextblockHorizontal(view, state, dir) {
	  var ref = state.selection;
	  var $head = ref.$head;
	  if (!$head.parent.isTextblock) { return false }
	  var offset = $head.parentOffset, atStart = !offset, atEnd = offset == $head.parent.content.size;
	  var sel = getSelection();
	  // If the textblock is all LTR, or the browser doesn't support
	  // Selection.modify (Edge), fall back to a primitive approach
	  if (!maybeRTL.test($head.parent.textContent) || !sel.modify)
	    { return dir == "left" || dir == "backward" ? atStart : atEnd }
	
	  return withFlushedState(view, state, function () {
	    // This is a huge hack, but appears to be the best we can
	    // currently do: use `Selection.modify` to move the selection by
	    // one character, and see if that moves the cursor out of the
	    // textblock (or doesn't move it at all, when at the start/end of
	    // the document).
	    var oldRange = sel.getRangeAt(0), oldNode = sel.focusNode, oldOff = sel.focusOffset;
	    sel.modify("move", dir, "character");
	    var parentDOM = $head.depth ? view.docView.domAfterPos($head.before()) : view.dom;
	    var result$$1 = !parentDOM.contains(sel.focusNode.nodeType == 1 ? sel.focusNode : sel.focusNode.parentNode) ||
	        (oldNode == sel.focusNode && oldOff == sel.focusOffset);
	    // Restore the previous selection
	    sel.removeAllRanges();
	    sel.addRange(oldRange);
	    return result$$1
	  })
	}
	
	var cachedState = null;
	var cachedDir = null;
	var cachedResult = false;
	function endOfTextblock(view, state, dir) {
	  if (cachedState == state && cachedDir == dir) { return cachedResult }
	  cachedState = state; cachedDir = dir;
	  return cachedResult = dir == "up" || dir == "down"
	    ? endOfTextblockVertical(view, state, dir)
	    : endOfTextblockHorizontal(view, state, dir)
	}
	
	// NodeView:: interface
	//
	// By default, document nodes are rendered using the result of the
	// [`toDOM`](#model.NodeSpec.toDOM) method of their spec, and managed
	// entirely by the editor. For some use cases, such as embedded
	// node-specific editing interfaces, you want more control over
	// the behavior of a node's in-editor representation, and need to
	// [define](#view.EditorProps.nodeViews) a custom node view.
	//
	// Objects returned as node views must conform to this interface.
	//
	//   dom:: ?dom.Node
	//   The outer DOM node that represents the document node. When not
	//   given, the default strategy is used to create a DOM node.
	//
	//   contentDOM:: ?dom.Node
	//   The DOM node that should hold the node's content. Only meaningful
	//   if the node view also defines a `dom` property and if its node
	//   type is not a leaf node type. When this is present, ProseMirror
	//   will take care of rendering the node's children into it. When it
	//   is not present, the node view itself is responsible for rendering
	//   (or deciding not to render) its child nodes.
	//
	//   update:: ?(node: Node, decorations: [Decoration]) → bool
	//   When given, this will be called when the view is updating itself.
	//   It will be given a node (possibly of a different type), and an
	//   array of active decorations (which are automatically drawn, and
	//   the node view may ignore if it isn't interested in them), and
	//   should return true if it was able to update to that node, and
	//   false otherwise. If the node view has a `contentDOM` property (or
	//   no `dom` property), updating its child nodes will be handled by
	//   ProseMirror.
	//
	//   selectNode:: ?()
	//   Can be used to override the way the node's selected status (as a
	//   node selection) is displayed.
	//
	//   deselectNode:: ?()
	//   When defining a `selectNode` method, you should also provide a
	//   `deselectNode` method to remove the effect again.
	//
	//   setSelection:: ?(anchor: number, head: number, root: dom.Document)
	//   This will be called to handle setting the selection inside the
	//   node. The `anchor` and `head` positions are relative to the start
	//   of the node. By default, a DOM selection will be created between
	//   the DOM positions corresponding to those positions, but if you
	//   override it you can do something else.
	//
	//   stopEvent:: ?(event: dom.Event) → bool
	//   Can be used to prevent the editor view from trying to handle some
	//   or all DOM events that bubble up from the node view. Events for
	//   which this returns true are not handled by the editor.
	//
	//   ignoreMutation:: ?(dom.MutationRecord) → bool
	//   Called when a DOM
	//   [mutation](https://developer.mozilla.org/en-US/docs/Web/API/MutationObserver)
	//   happens within the view. Return false if the editor should
	//   re-parse the range around the mutation, true if it can safely be
	//   ignored.
	//
	//   destroy:: ?()
	//   Called when the node view is removed from the editor or the whole
	//   editor is destroyed.
	
	// View descriptions are data structures that describe the DOM that is
	// used to represent the editor's content. They are used for:
	//
	// - Incremental redrawing when the document changes
	//
	// - Figuring out what part of the document a given DOM position
	//   corresponds to
	//
	// - Wiring in custom implementations of the editing interface for a
	//   given node
	//
	// They form a doubly-linked mutable tree, starting at `view.docView`.
	
	var NOT_DIRTY = 0;
	var CHILD_DIRTY = 1;
	var CONTENT_DIRTY = 2;
	var NODE_DIRTY = 3;
	
	// Superclass for the various kinds of descriptions. Defines their
	// basic structure and shared methods.
	var ViewDesc = function ViewDesc(parent, children, dom, contentDOM) {
	  this.parent = parent;
	  this.children = children;
	  this.dom = dom;
	  // An expando property on the DOM node provides a link back to its
	  // description.
	  dom.pmViewDesc = this;
	  // This is the node that holds the child views. It may be null for
	  // descs that don't have children.
	  this.contentDOM = contentDOM;
	  this.dirty = NOT_DIRTY;
	};
	
	var prototypeAccessors$1 = { beforePosition: {},size: {},border: {},posBefore: {},posAtStart: {},posAfter: {},posAtEnd: {},contentLost: {} };
	
	// Used to check whether a given description corresponds to a
	// widget/mark/node.
	ViewDesc.prototype.matchesWidget = function matchesWidget () { return false };
	ViewDesc.prototype.matchesMark = function matchesMark () { return false };
	ViewDesc.prototype.matchesNode = function matchesNode () { return false };
	ViewDesc.prototype.matchesHack = function matchesHack () { return false };
	
	prototypeAccessors$1.beforePosition.get = function () { return false };
	
	// : () → ?ParseRule
	// When parsing in-editor content (in domchange.js), we allow
	// descriptions to determine the parse rules that should be used to
	// parse them.
	ViewDesc.prototype.parseRule = function parseRule () { return null };
	
	// : (dom.Event) → bool
	// Used by the editor's event handler to ignore events that come
	// from certain descs.
	ViewDesc.prototype.stopEvent = function stopEvent () { return false };
	
	// The size of the content represented by this desc.
	prototypeAccessors$1.size.get = function () {
	    var this$1 = this;
	
	  var size = 0;
	  for (var i = 0; i < this.children.length; i++) { size += this$1.children[i].size; }
	  return size
	};
	
	// For block nodes, this represents the space taken up by their
	// start/end tokens.
	prototypeAccessors$1.border.get = function () { return 0 };
	
	ViewDesc.prototype.destroy = function destroy () {
	    var this$1 = this;
	
	  this.parent = null;
	  if (this.dom.pmViewDesc == this) { this.dom.pmViewDesc = null; }
	  for (var i = 0; i < this.children.length; i++)
	    { this$1.children[i].destroy(); }
	};
	
	ViewDesc.prototype.posBeforeChild = function posBeforeChild (child) {
	    var this$1 = this;
	
	  for (var i = 0, pos = this.posAtStart; i < this.children.length; i++) {
	    var cur = this$1.children[i];
	    if (cur == child) { return pos }
	    pos += cur.size;
	  }
	};
	
	prototypeAccessors$1.posBefore.get = function () {
	  return this.parent.posBeforeChild(this)
	};
	
	prototypeAccessors$1.posAtStart.get = function () {
	  return this.parent ? this.parent.posBeforeChild(this) + this.border : 0
	};
	
	prototypeAccessors$1.posAfter.get = function () {
	  return this.posBefore + this.size
	};
	
	prototypeAccessors$1.posAtEnd.get = function () {
	  return this.posAtStart + this.size - 2 * this.border
	};
	
	// : (dom.Node, number, ?number) → number
	ViewDesc.prototype.localPosFromDOM = function localPosFromDOM (dom, offset, bias) {
	    var this$1 = this;
	
	  // If the DOM position is in the content, use the child desc after
	  // it to figure out a position.
	  if (this.contentDOM && this.contentDOM.contains(dom.nodeType == 1 ? dom : dom.parentNode)) {
	    if (bias < 0) {
	      var domBefore, desc;
	      if (dom == this.contentDOM) {
	        domBefore = dom.childNodes[offset - 1];
	      } else {
	        while (dom.parentNode != this.contentDOM) { dom = dom.parentNode; }
	        domBefore = dom.previousSibling;
	      }
	      while (domBefore && !((desc = domBefore.pmViewDesc) && desc.parent == this)) { domBefore = domBefore.previousSibling; }
	      return domBefore ? this.posBeforeChild(desc) + desc.size : this.posAtStart
	    } else {
	      var domAfter, desc$1;
	      if (dom == this.contentDOM) {
	        domAfter = dom.childNodes[offset];
	      } else {
	        while (dom.parentNode != this.contentDOM) { dom = dom.parentNode; }
	        domAfter = dom.nextSibling;
	      }
	      while (domAfter && !((desc$1 = domAfter.pmViewDesc) && desc$1.parent == this)) { domAfter = domAfter.nextSibling; }
	      return domAfter ? this.posBeforeChild(desc$1) : this.posAtEnd
	    }
	  }
	  // Otherwise, use various heuristics, falling back on the bias
	  // parameter, to determine whether to return the position at the
	  // start or at the end of this view desc.
	  var atEnd;
	  if (this.contentDOM && this.contentDOM != this.dom && this.dom.contains(this.contentDOM)) {
	    atEnd = dom.compareDocumentPosition(this.contentDOM) & 2;
	  } else if (this.dom.firstChild) {
	    if (offset == 0) { for (var search = dom;; search = search.parentNode) {
	      if (search == this$1.dom) { atEnd = false; break }
	      if (search.parentNode.firstChild != search) { break }
	    } }
	    if (atEnd == null && offset == dom.childNodes.length) { for (var search$1 = dom;; search$1 = search$1.parentNode) {
	      if (search$1 == this$1.dom) { atEnd = true; break }
	      if (search$1.parentNode.lastChild != search$1) { break }
	    } }
	  }
	  return (atEnd == null ? bias > 0 : atEnd) ? this.posAtEnd : this.posAtStart
	};
	
	// Scan up the dom finding the first desc that is a descendant of
	// this one.
	ViewDesc.prototype.nearestDesc = function nearestDesc (dom, onlyNodes) {
	    var this$1 = this;
	
	  for (var first = true, cur = dom; cur; cur = cur.parentNode) {
	    var desc = this$1.getDesc(cur);
	    if (desc && (!onlyNodes || desc.node)) {
	      // If dom is outside of this desc's nodeDOM, don't count it.
	      if (first && desc.nodeDOM && !(desc.nodeDOM.nodeType == 1 ? desc.nodeDOM.contains(dom) : desc.nodeDOM == dom)) { first = false; }
	      else { return desc }
	    }
	  }
	};
	
	ViewDesc.prototype.getDesc = function getDesc (dom) {
	    var this$1 = this;
	
	  var desc = dom.pmViewDesc;
	  for (var cur = desc; cur; cur = cur.parent) { if (cur == this$1) { return desc } }
	};
	
	ViewDesc.prototype.posFromDOM = function posFromDOM (dom, offset, bias) {
	    var this$1 = this;
	
	  for (var scan = dom;; scan = scan.parentNode) {
	    var desc = this$1.getDesc(scan);
	    if (desc) { return desc.localPosFromDOM(dom, offset, bias) }
	  }
	};
	
	// : (number) → ?NodeViewDesc
	// Find the desc for the node after the given pos, if any. (When a
	// parent node overrode rendering, there might not be one.)
	ViewDesc.prototype.descAt = function descAt (pos) {
	    var this$1 = this;
	
	  for (var i = 0, offset = 0; i < this.children.length; i++) {
	    var child = this$1.children[i], end = offset + child.size;
	    if (offset == pos && end != offset) {
	      while (!child.border && child.children.length) { child = child.children[0]; }
	      return child
	    }
	    if (pos < end) { return child.descAt(pos - offset - child.border) }
	    offset = end;
	  }
	};
	
	// : (number) → {node: dom.Node, offset: number}
	ViewDesc.prototype.domFromPos = function domFromPos (pos) {
	    var this$1 = this;
	
	  if (!this.contentDOM) { return {node: this.dom, offset: 0} }
	  for (var offset = 0, i = 0;; i++) {
	    if (offset == pos) {
	      while (i < this.children.length && this.children[i].beforePosition) { i++; }
	      return {node: this$1.contentDOM, offset: i}
	    }
	    if (i == this$1.children.length) { throw new Error("Invalid position " + pos) }
	    var child = this$1.children[i], end = offset + child.size;
	    if (pos < end) { return child.domFromPos(pos - offset - child.border) }
	    offset = end;
	  }
	};
	
	// Used to find a DOM range in a single parent for a given changed
	// range.
	ViewDesc.prototype.parseRange = function parseRange (from, to, base) {
	    var this$1 = this;
	    if ( base === void 0 ) base = 0;
	
	  if (this.children.length == 0)
	    { return {node: this.contentDOM, from: from, to: to, fromOffset: 0, toOffset: this.contentDOM.childNodes.length} }
	
	  var fromOffset = -1, toOffset = -1;
	  for (var offset = 0, i = 0;; i++) {
	    var child = this$1.children[i], end = offset + child.size;
	    if (fromOffset == -1 && from <= end) {
	      var childBase = offset + child.border;
	      // FIXME maybe descend mark views to parse a narrower range?
	      if (from >= childBase && to <= end - child.border && child.node &&
	          child.contentDOM && this$1.contentDOM.contains(child.contentDOM))
	        { return child.parseRange(from - childBase, to - childBase, base + childBase) }
	
	      from = base + offset;
	      for (var j = i; j > 0; j--) {
	        var prev = this$1.children[j - 1];
	        if (prev.size && prev.dom.parentNode == this$1.contentDOM && !prev.emptyChildAt(1)) {
	          fromOffset = domIndex(prev.dom) + 1;
	          break
	        }
	        from -= prev.size;
	      }
	      if (fromOffset == -1) { fromOffset = 0; }
	    }
	    if (fromOffset > -1 && to <= end) {
	      to = base + end;
	      for (var j$1 = i + 1; j$1 < this.children.length; j$1++) {
	        var next = this$1.children[j$1];
	        if (next.size && next.dom.parentNode == this$1.contentDOM && !next.emptyChildAt(-1)) {
	          toOffset = domIndex(next.dom);
	          break
	        }
	        to += next.size;
	      }
	      if (toOffset == -1) { toOffset = this$1.contentDOM.childNodes.length; }
	      break
	    }
	    offset = end;
	  }
	  return {node: this.contentDOM, from: from, to: to, fromOffset: fromOffset, toOffset: toOffset}
	};
	
	ViewDesc.prototype.emptyChildAt = function emptyChildAt (side) {
	  if (this.border || !this.contentDOM || !this.children.length) { return false }
	  var child = this.children[side < 0 ? 0 : this.children.length - 1];
	  return child.size == 0 || child.emptyChildAt(side)
	};
	
	// : (number) → dom.Node
	ViewDesc.prototype.domAfterPos = function domAfterPos (pos) {
	  var ref = this.domFromPos(pos);
	    var node = ref.node;
	    var offset = ref.offset;
	  if (node.nodeType != 1 || offset == node.childNodes.length)
	    { throw new RangeError("No node after pos " + pos) }
	  return node.childNodes[offset]
	};
	
	// : (number, number, dom.Document)
	// View descs are responsible for setting any selection that falls
	// entirely inside of them, so that custom implementations can do
	// custom things with the selection. Note that this falls apart when
	// a selection starts in such a node and ends in another, in which
	// case we just use whatever domFromPos produces as a best effort.
	ViewDesc.prototype.setSelection = function setSelection (anchor, head, root, force) {
	    var this$1 = this;
	
	  // If the selection falls entirely in a child, give it to that child
	  var from = Math.min(anchor, head), to = Math.max(anchor, head);
	  for (var i = 0, offset = 0; i < this.children.length; i++) {
	    var child = this$1.children[i], end = offset + child.size;
	    if (from > offset && to < end)
	      { return child.setSelection(anchor - offset - child.border, head - offset - child.border, root, force) }
	    offset = end;
	  }
	
	  var anchorDOM = this.domFromPos(anchor), headDOM = this.domFromPos(head);
	  var domSel = root.getSelection(), range = document.createRange();
	  if (!force &&
	      isEquivalentPosition(anchorDOM.node, anchorDOM.offset, domSel.anchorNode, domSel.anchorOffset) &&
	      isEquivalentPosition(headDOM.node, headDOM.offset, domSel.focusNode, domSel.focusOffset))
	    { return }
	
	  // Selection.extend can be used to create an 'inverted' selection
	  // (one where the focus is before the anchor), but not all
	  // browsers support it yet.
	  if (domSel.extend) {
	    range.setEnd(anchorDOM.node, anchorDOM.offset);
	    range.collapse(false);
	  } else {
	    if (anchor > head) { var tmp = anchorDOM; anchorDOM = headDOM; headDOM = tmp; }
	    range.setEnd(headDOM.node, headDOM.offset);
	    range.setStart(anchorDOM.node, anchorDOM.offset);
	  }
	  domSel.removeAllRanges();
	  domSel.addRange(range);
	  if (domSel.extend)
	    { domSel.extend(headDOM.node, headDOM.offset); }
	};
	
	// : (dom.MutationRecord) → bool
	ViewDesc.prototype.ignoreMutation = function ignoreMutation (_mutation) {
	  return !this.contentDOM
	};
	
	prototypeAccessors$1.contentLost.get = function () {
	  return this.contentDOM && this.contentDOM != this.dom && !this.dom.contains(this.contentDOM)
	};
	
	// Remove a subtree of the element tree that has been touched
	// by a DOM change, so that the next update will redraw it.
	ViewDesc.prototype.markDirty = function markDirty (from, to) {
	    var this$1 = this;
	
	  for (var offset = 0, i = 0; i < this.children.length; i++) {
	    var child = this$1.children[i], end = offset + child.size;
	    if (offset == end ? from <= end && to >= offset : from < end && to > offset) {
	      var startInside = offset + child.border, endInside = end - child.border;
	      if (from >= startInside && to <= endInside) {
	        this$1.dirty = from == offset || to == end ? CONTENT_DIRTY : CHILD_DIRTY;
	        if (from == startInside && to == endInside && child.contentLost) { child.dirty = NODE_DIRTY; }
	        else { child.markDirty(from - startInside, to - startInside); }
	        return
	      } else {
	        child.dirty = NODE_DIRTY;
	      }
	    }
	    offset = end;
	  }
	  this.dirty = CONTENT_DIRTY;
	};
	
	Object.defineProperties( ViewDesc.prototype, prototypeAccessors$1 );
	
	// Reused array to avoid allocating fresh arrays for things that will
	// stay empty anyway.
	var nothing = [];
	
	// A widget desc represents a widget decoration, which is a DOM node
	// drawn between the document nodes.
	var WidgetViewDesc = (function (ViewDesc) {
	  function WidgetViewDesc(parent, widget, view, pos) {
	    var self, dom = widget.type.toDOM;
	    if (typeof dom == "function") { dom = dom(view, function () {
	      if (!self) { return pos }
	      if (self.parent) { return self.parent.posBeforeChild(self) }
	    }); }
	    if (!widget.type.spec.raw) {
	      if (dom.nodeType != 1) {
	        var wrap = document.createElement("span");
	        wrap.appendChild(dom);
	        dom = wrap;
	      }
	      dom.contentEditable = false;
	      dom.classList.add("ProseMirror-widget");
	    }
	    ViewDesc.call(this, parent, nothing, dom, null);
	    this.widget = widget;
	    self = this;
	  }
	
	  if ( ViewDesc ) WidgetViewDesc.__proto__ = ViewDesc;
	  WidgetViewDesc.prototype = Object.create( ViewDesc && ViewDesc.prototype );
	  WidgetViewDesc.prototype.constructor = WidgetViewDesc;
	
	  var prototypeAccessors$1 = { beforePosition: {} };
	
	  prototypeAccessors$1.beforePosition.get = function () {
	    return this.widget.type.side < 0
	  };
	
	  WidgetViewDesc.prototype.matchesWidget = function matchesWidget (widget) {
	    return this.dirty == NOT_DIRTY && widget.type.eq(this.widget.type)
	  };
	
	  WidgetViewDesc.prototype.parseRule = function parseRule () { return {ignore: true} };
	
	  WidgetViewDesc.prototype.stopEvent = function stopEvent (event) {
	    var stop = this.widget.spec.stopEvent;
	    return stop ? stop(event) : false
	  };
	
	  Object.defineProperties( WidgetViewDesc.prototype, prototypeAccessors$1 );
	
	  return WidgetViewDesc;
	}(ViewDesc));
	
	// A cursor wrapper is used to put the cursor in when newly typed text
	// needs to be styled differently from its surrounding text (for
	// example through storedMarks), so that the style of the text doesn't
	// visually 'pop' between typing it and actually updating the view.
	var CursorWrapperDesc = (function (WidgetViewDesc) {
	  function CursorWrapperDesc () {
	    WidgetViewDesc.apply(this, arguments);
	  }
	
	  if ( WidgetViewDesc ) CursorWrapperDesc.__proto__ = WidgetViewDesc;
	  CursorWrapperDesc.prototype = Object.create( WidgetViewDesc && WidgetViewDesc.prototype );
	  CursorWrapperDesc.prototype.constructor = CursorWrapperDesc;
	
	  CursorWrapperDesc.prototype.parseRule = function parseRule () {
	    var content;
	    for (var child = this.dom.firstChild; child; child = child.nextSibling) {
	      var add = (void 0);
	      if (child.nodeType == 3) {
	        var text = child.nodeValue.replace(/\ufeff/g, "");
	        if (!text) { continue }
	        add = document.createTextNode(text);
	      } else if (child.textContent == "\ufeff") {
	        continue
	      } else {
	        add = child.cloneNode(true);
	      }
	      if (!content) { content = document.createDocumentFragment(); }
	      content.appendChild(add);
	    }
	    if (content) { return {skip: content} }
	    else { return WidgetViewDesc.prototype.parseRule.call(this) }
	  };
	
	  CursorWrapperDesc.prototype.ignoreMutation = function ignoreMutation () { return false };
	
	  return CursorWrapperDesc;
	}(WidgetViewDesc));
	
	// A mark desc represents a mark. May have multiple children,
	// depending on how the mark is split. Note that marks are drawn using
	// a fixed nesting order, for simplicity and predictability, so in
	// some cases they will be split more often than would appear
	// necessary.
	var MarkViewDesc = (function (ViewDesc) {
	  function MarkViewDesc(parent, mark, dom, contentDOM) {
	    ViewDesc.call(this, parent, [], dom, contentDOM);
	    this.mark = mark;
	  }
	
	  if ( ViewDesc ) MarkViewDesc.__proto__ = ViewDesc;
	  MarkViewDesc.prototype = Object.create( ViewDesc && ViewDesc.prototype );
	  MarkViewDesc.prototype.constructor = MarkViewDesc;
	
	  MarkViewDesc.create = function create (parent, mark, inline, view) {
	    var custom = view.nodeViews[mark.type.name];
	    var spec = custom && custom(mark, view, inline);
	    if (!spec || !spec.dom)
	      { spec = prosemirrorModel.DOMSerializer.renderSpec(document, mark.type.spec.toDOM(mark, inline)); }
	    return new MarkViewDesc(parent, mark, spec.dom, spec.contentDOM || spec.dom)
	  };
	
	  MarkViewDesc.prototype.parseRule = function parseRule () { return {mark: this.mark.type.name, attrs: this.mark.attrs, contentElement: this.contentDOM} };
	
	  MarkViewDesc.prototype.matchesMark = function matchesMark (mark) { return this.dirty != NODE_DIRTY && this.mark.eq(mark) };
	
	  MarkViewDesc.prototype.markDirty = function markDirty (from, to) {
	    ViewDesc.prototype.markDirty.call(this, from, to);
	    // Move dirty info to nearest node view
	    if (this.dirty != NOT_DIRTY) {
	      var parent = this.parent;
	      while (!parent.node) { parent = parent.parent; }
	      if (parent.dirty < this.dirty) { parent.dirty = this.dirty; }
	      this.dirty = NOT_DIRTY;
	    }
	  };
	
	  return MarkViewDesc;
	}(ViewDesc));
	
	// Node view descs are the main, most common type of view desc, and
	// correspond to an actual node in the document. Unlike mark descs,
	// they populate their child array themselves.
	var NodeViewDesc = (function (ViewDesc) {
	  function NodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, view, pos) {
	    ViewDesc.call(this, parent, node.isLeaf ? nothing : [], dom, contentDOM);
	    this.nodeDOM = nodeDOM;
	    this.node = node;
	    this.outerDeco = outerDeco;
	    this.innerDeco = innerDeco;
	    if (contentDOM) { this.updateChildren(view, pos); }
	  }
	
	  if ( ViewDesc ) NodeViewDesc.__proto__ = ViewDesc;
	  NodeViewDesc.prototype = Object.create( ViewDesc && ViewDesc.prototype );
	  NodeViewDesc.prototype.constructor = NodeViewDesc;
	
	  var prototypeAccessors$2 = { size: {},border: {} };
	
	  // By default, a node is rendered using the `toDOM` method from the
	  // node type spec. But client code can use the `nodeViews` spec to
	  // supply a custom node view, which can influence various aspects of
	  // the way the node works.
	  //
	  // (Using subclassing for this was intentionally decided against,
	  // since it'd require exposing a whole slew of finnicky
	  // implementation details to the user code that they probably will
	  // never need.)
	  NodeViewDesc.create = function create (parent, node, outerDeco, innerDeco, view, pos) {
	    var custom = view.nodeViews[node.type.name], descObj;
	    var spec = custom && custom(node, view, function () {
	      // (This is a function that allows the custom view to find its
	      // own position)
	      if (!descObj) { return pos }
	      if (descObj.parent) { return descObj.parent.posBeforeChild(descObj) }
	    }, outerDeco);
	
	    var dom = spec && spec.dom, contentDOM = spec && spec.contentDOM;
	    if (node.isText) {
	      if (!dom) { dom = document.createTextNode(node.text); }
	      else if (dom.nodeType != 3) { throw new RangeError("Text must be rendered as a DOM text node") }
	    } else if (!dom) {
	      var assign;
	      ((assign = prosemirrorModel.DOMSerializer.renderSpec(document, node.type.spec.toDOM(node)), dom = assign.dom, contentDOM = assign.contentDOM));
	    }
	    if (!contentDOM && !node.isText && dom.nodeName != "BR") { // Chrome gets confused by <br contenteditable=false>
	      if (!dom.hasAttribute("contenteditable")) { dom.contentEditable = false; }
	      if (node.type.spec.draggable) { dom.draggable = true; }
	    }
	
	    var nodeDOM = dom;
	    dom = applyOuterDeco(dom, outerDeco, node);
	
	    if (spec)
	      { return descObj = new CustomNodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM,
	                                              spec, view, pos + 1) }
	    else if (node.isText)
	      { return new TextViewDesc(parent, node, outerDeco, innerDeco, dom, nodeDOM, view) }
	    else
	      { return new NodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, view, pos + 1) }
	  };
	
	  NodeViewDesc.prototype.parseRule = function parseRule () {
	    var this$1 = this;
	
	    // Experimental kludge to allow opt-in re-parsing of nodes
	    if (this.node.type.spec.reparseInView) { return null }
	    // FIXME the assumption that this can always return the current
	    // attrs means that if the user somehow manages to change the
	    // attrs in the dom, that won't be picked up. Not entirely sure
	    // whether this is a problem
	    var rule = {node: this.node.type.name, attrs: this.node.attrs};
	    if (this.node.type.spec.code) { rule.preserveWhitespace = "full"; }
	    if (this.contentDOM && !this.contentLost) { rule.contentElement = this.contentDOM; }
	    else { rule.getContent = function () { return this$1.contentDOM ? prosemirrorModel.Fragment.empty : this$1.node.content; }; }
	    return rule
	  };
	
	  NodeViewDesc.prototype.matchesNode = function matchesNode (node, outerDeco, innerDeco) {
	    return this.dirty == NOT_DIRTY && node.eq(this.node) &&
	      sameOuterDeco(outerDeco, this.outerDeco) && innerDeco.eq(this.innerDeco)
	  };
	
	  prototypeAccessors$2.size.get = function () { return this.node.nodeSize };
	
	  prototypeAccessors$2.border.get = function () { return this.node.isLeaf ? 0 : 1 };
	
	  // Syncs `this.children` to match `this.node.content` and the local
	  // decorations, possibly introducing nesting for marks. Then, in a
	  // separate step, syncs the DOM inside `this.contentDOM` to
	  // `this.children`.
	  NodeViewDesc.prototype.updateChildren = function updateChildren (view, pos) {
	    var this$1 = this;
	
	    var updater = new ViewTreeUpdater(this), inline = this.node.inlineContent;
	    iterDeco(this.node, this.innerDeco, function (widget, i) {
	      if (widget.spec.marks)
	        { updater.syncToMarks(widget.spec.marks, inline, view); }
	      else if (widget.type.side >= 0)
	        { updater.syncToMarks(i == this$1.node.childCount ? prosemirrorModel.Mark.none : this$1.node.child(i).marks, inline, view); }
	      // If the next node is a desc matching this widget, reuse it,
	      // otherwise insert the widget as a new view desc.
	      updater.placeWidget(widget, view, pos);
	    }, function (child, outerDeco, innerDeco, i) {
	      // Make sure the wrapping mark descs match the node's marks.
	      updater.syncToMarks(child.marks, inline, view);
	      // Either find an existing desc that exactly matches this node,
	      // and drop the descs before it.
	      updater.findNodeMatch(child, outerDeco, innerDeco, i) ||
	        // Or try updating the next desc to reflect this node.
	        updater.updateNextNode(child, outerDeco, innerDeco, view, i) ||
	        // Or just add it as a new desc.
	        updater.addNode(child, outerDeco, innerDeco, view, pos);
	      pos += child.nodeSize;
	    });
	    // Drop all remaining descs after the current position.
	    updater.syncToMarks(nothing, inline, view);
	    if (this.node.isTextblock) { updater.addTextblockHacks(); }
	    updater.destroyRest();
	
	    // Sync the DOM if anything changed
	    if (updater.changed || this.dirty == CONTENT_DIRTY) { this.renderChildren(); }
	  };
	
	  NodeViewDesc.prototype.renderChildren = function renderChildren () {
	    renderDescs(this.contentDOM, this.children, NodeViewDesc.is);
	    if (result.ios) { iosHacks(this.dom); }
	  };
	
	  // : (Node, [Decoration], DecorationSet, EditorView) → bool
	  // If this desc be updated to match the given node decoration,
	  // do so and return true.
	  NodeViewDesc.prototype.update = function update (node, outerDeco, innerDeco, view) {
	    if (this.dirty == NODE_DIRTY ||
	        !node.sameMarkup(this.node)) { return false }
	    this.updateInner(node, outerDeco, innerDeco, view);
	    return true
	  };
	
	  NodeViewDesc.prototype.updateInner = function updateInner (node, outerDeco, innerDeco, view) {
	    this.updateOuterDeco(outerDeco);
	    this.node = node;
	    this.innerDeco = innerDeco;
	    if (this.contentDOM) { this.updateChildren(view, this.posAtStart); }
	    this.dirty = NOT_DIRTY;
	  };
	
	  NodeViewDesc.prototype.updateOuterDeco = function updateOuterDeco (outerDeco) {
	    if (sameOuterDeco(outerDeco, this.outerDeco)) { return }
	    var needsWrap = this.nodeDOM.nodeType != 1;
	    var oldDOM = this.dom;
	    this.dom = patchOuterDeco(this.dom, this.nodeDOM,
	                              computeOuterDeco(this.outerDeco, this.node, needsWrap),
	                              computeOuterDeco(outerDeco, this.node, needsWrap));
	    if (this.dom != oldDOM) {
	      oldDOM.pmViewDesc = null;
	      this.dom.pmViewDesc = this;
	    }
	    this.outerDeco = outerDeco;
	  };
	
	  // Mark this node as being the selected node.
	  NodeViewDesc.prototype.selectNode = function selectNode () {
	    this.nodeDOM.classList.add("ProseMirror-selectednode");
	    if (this.contentDOM || !this.node.type.spec.draggable) { this.dom.draggable = true; }
	  };
	
	  // Remove selected node marking from this node.
	  NodeViewDesc.prototype.deselectNode = function deselectNode () {
	    this.nodeDOM.classList.remove("ProseMirror-selectednode");
	    if (this.contentDOM || !this.node.type.spec.draggable) { this.dom.draggable = false; }
	  };
	
	  Object.defineProperties( NodeViewDesc.prototype, prototypeAccessors$2 );
	
	  return NodeViewDesc;
	}(ViewDesc));
	
	// Create a view desc for the top-level document node, to be exported
	// and used by the view class.
	function docViewDesc(doc, outerDeco, innerDeco, dom, view) {
	  applyOuterDeco(dom, outerDeco, doc);
	  return new NodeViewDesc(null, doc, outerDeco, innerDeco, dom, dom, dom, view, 0)
	}
	
	var TextViewDesc = (function (NodeViewDesc) {
	  function TextViewDesc(parent, node, outerDeco, innerDeco, dom, nodeDOM, view) {
	    NodeViewDesc.call(this, parent, node, outerDeco, innerDeco, dom, null, nodeDOM, view);
	  }
	
	  if ( NodeViewDesc ) TextViewDesc.__proto__ = NodeViewDesc;
	  TextViewDesc.prototype = Object.create( NodeViewDesc && NodeViewDesc.prototype );
	  TextViewDesc.prototype.constructor = TextViewDesc;
	
	  TextViewDesc.prototype.parseRule = function parseRule () {
	    var parent = this.nodeDOM.parentNode;
	    return parent ? {skip: parent} : {ignore: true}
	  };
	
	  TextViewDesc.prototype.update = function update (node, outerDeco) {
	    if (this.dirty == NODE_DIRTY || (this.dirty != NOT_DIRTY && !this.inParent()) ||
	        !node.sameMarkup(this.node)) { return false }
	    this.updateOuterDeco(outerDeco);
	    if ((this.dirty != NOT_DIRTY || node.text != this.node.text) && node.text != this.nodeDOM.nodeValue)
	      { this.nodeDOM.nodeValue = node.text; }
	    this.node = node;
	    this.dirty = NOT_DIRTY;
	    return true
	  };
	
	  TextViewDesc.prototype.inParent = function inParent () {
	    var parentDOM = this.parent.contentDOM;
	    for (var n = this.nodeDOM; n; n = n.parentNode) { if (n == parentDOM) { return true } }
	    return false
	  };
	
	  TextViewDesc.prototype.domFromPos = function domFromPos (pos) {
	    return {node: this.nodeDOM, offset: pos}
	  };
	
	  TextViewDesc.prototype.localPosFromDOM = function localPosFromDOM (dom, offset, bias) {
	    if (dom == this.nodeDOM) { return this.posAtStart + Math.min(offset, this.node.text.length) }
	    return NodeViewDesc.prototype.localPosFromDOM.call(this, dom, offset, bias)
	  };
	
	  TextViewDesc.prototype.ignoreMutation = function ignoreMutation (mutation) {
	    return mutation.type != "characterData"
	  };
	
	  return TextViewDesc;
	}(NodeViewDesc));
	
	// A dummy desc used to tag trailing BR or span nodes created to work
	// around contentEditable terribleness.
	var BRHackViewDesc = (function (ViewDesc) {
	  function BRHackViewDesc () {
	    ViewDesc.apply(this, arguments);
	  }
	
	  if ( ViewDesc ) BRHackViewDesc.__proto__ = ViewDesc;
	  BRHackViewDesc.prototype = Object.create( ViewDesc && ViewDesc.prototype );
	  BRHackViewDesc.prototype.constructor = BRHackViewDesc;
	
	  BRHackViewDesc.prototype.parseRule = function parseRule () { return {ignore: true} };
	  BRHackViewDesc.prototype.matchesHack = function matchesHack () { return this.dirty == NOT_DIRTY };
	
	  return BRHackViewDesc;
	}(ViewDesc));
	
	// A separate subclass is used for customized node views, so that the
	// extra checks only have to be made for nodes that are actually
	// customized.
	var CustomNodeViewDesc = (function (NodeViewDesc) {
	  function CustomNodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, spec, view, pos) {
	    NodeViewDesc.call(this, parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, view, pos);
	    this.spec = spec;
	  }
	
	  if ( NodeViewDesc ) CustomNodeViewDesc.__proto__ = NodeViewDesc;
	  CustomNodeViewDesc.prototype = Object.create( NodeViewDesc && NodeViewDesc.prototype );
	  CustomNodeViewDesc.prototype.constructor = CustomNodeViewDesc;
	
	  // A custom `update` method gets to decide whether the update goes
	  // through. If it does, and there's a `contentDOM` node, our logic
	  // updates the children.
	  CustomNodeViewDesc.prototype.update = function update (node, outerDeco, innerDeco, view) {
	    if (this.dirty == NODE_DIRTY) { return false }
	    if (this.spec.update) {
	      var result$$1 = this.spec.update(node, outerDeco);
	      if (result$$1) { this.updateInner(node, outerDeco, innerDeco, view); }
	      return result$$1
	    } else if (!this.contentDOM && !node.isLeaf) {
	      return false
	    } else {
	      return NodeViewDesc.prototype.update.call(this, node, outerDeco, innerDeco, view)
	    }
	  };
	
	  CustomNodeViewDesc.prototype.selectNode = function selectNode () {
	    this.spec.selectNode ? this.spec.selectNode() : NodeViewDesc.prototype.selectNode.call(this);
	  };
	
	  CustomNodeViewDesc.prototype.deselectNode = function deselectNode () {
	    this.spec.deselectNode ? this.spec.deselectNode() : NodeViewDesc.prototype.deselectNode.call(this);
	  };
	
	  CustomNodeViewDesc.prototype.setSelection = function setSelection (anchor, head, root, force) {
	    this.spec.setSelection ? this.spec.setSelection(anchor, head, root)
	      : NodeViewDesc.prototype.setSelection.call(this, anchor, head, root, force);
	  };
	
	  CustomNodeViewDesc.prototype.destroy = function destroy () {
	    if (this.spec.destroy) { this.spec.destroy(); }
	    NodeViewDesc.prototype.destroy.call(this);
	  };
	
	  CustomNodeViewDesc.prototype.stopEvent = function stopEvent (event) {
	    return this.spec.stopEvent ? this.spec.stopEvent(event) : false
	  };
	
	  CustomNodeViewDesc.prototype.ignoreMutation = function ignoreMutation (mutation) {
	    return this.spec.ignoreMutation ? this.spec.ignoreMutation(mutation) : NodeViewDesc.prototype.ignoreMutation.call(this, mutation)
	  };
	
	  return CustomNodeViewDesc;
	}(NodeViewDesc));
	
	// : (dom.Node, [ViewDesc])
	// Sync the content of the given DOM node with the nodes associated
	// with the given array of view descs, recursing into mark descs
	// because this should sync the subtree for a whole node at a time.
	function renderDescs(parentDOM, descs) {
	  var dom = parentDOM.firstChild;
	  for (var i = 0; i < descs.length; i++) {
	    var desc = descs[i], childDOM = desc.dom;
	    if (childDOM.parentNode == parentDOM) {
	      while (childDOM != dom) { dom = rm(dom); }
	      dom = dom.nextSibling;
	    } else {
	      parentDOM.insertBefore(childDOM, dom);
	    }
	    if (desc instanceof MarkViewDesc) {
	      var pos = dom ? dom.previousSibling : parentDOM.lastChild;
	      renderDescs(desc.contentDOM, desc.children);
	      dom = pos ? pos.nextSibling : parentDOM.firstChild;
	    }
	  }
	  while (dom) { dom = rm(dom); }
	}
	
	function OuterDecoLevel(nodeName) {
	  if (nodeName) { this.nodeName = nodeName; }
	}
	OuterDecoLevel.prototype = Object.create(null);
	
	var noDeco = [new OuterDecoLevel];
	
	function computeOuterDeco(outerDeco, node, needsWrap) {
	  if (outerDeco.length == 0) { return noDeco }
	
	  var top = needsWrap ? noDeco[0] : new OuterDecoLevel, result$$1 = [top];
	
	  for (var i = 0; i < outerDeco.length; i++) {
	    var attrs = outerDeco[i].type.attrs, cur = top;
	    if (!attrs) { continue }
	    if (attrs.nodeName)
	      { result$$1.push(cur = new OuterDecoLevel(attrs.nodeName)); }
	
	    for (var name in attrs) {
	      var val = attrs[name];
	      if (val == null) { continue }
	      if (needsWrap && result$$1.length == 1)
	        { result$$1.push(cur = top = new OuterDecoLevel(node.isInline ? "span" : "div")); }
	      if (name == "class") { cur.class = (cur.class ? cur.class + " " : "") + val; }
	      else if (name == "style") { cur.style = (cur.style ? cur.style + ";" : "") + val; }
	      else if (name != "nodeName") { cur[name] = val; }
	    }
	  }
	
	  return result$$1
	}
	
	function patchOuterDeco(outerDOM, nodeDOM, prevComputed, curComputed) {
	  // Shortcut for trivial case
	  if (prevComputed == noDeco && curComputed == noDeco) { return nodeDOM }
	
	  var curDOM = nodeDOM;
	  for (var i = 0; i < curComputed.length; i++) {
	    var deco = curComputed[i], prev = prevComputed[i];
	    if (i) {
	      var parent = (void 0);
	      if (prev && prev.nodeName == deco.nodeName && curDOM != outerDOM &&
	          (parent = nodeDOM.parentNode) && parent.tagName.toLowerCase() == deco.nodeName) {
	        curDOM = parent;
	      } else {
	        parent = document.createElement(deco.nodeName);
	        parent.appendChild(curDOM);
	        curDOM = parent;
	      }
	    }
	    patchAttributes(curDOM, prev || noDeco[0], deco);
	  }
	  return curDOM
	}
	
	function patchAttributes(dom, prev, cur) {
	  for (var name in prev)
	    { if (name != "class" && name != "style" && name != "nodeName" && !(name in cur))
	      { dom.removeAttribute(name); } }
	  for (var name$1 in cur)
	    { if (name$1 != "class" && name$1 != "style" && name$1 != "nodeName" && cur[name$1] != prev[name$1])
	      { dom.setAttribute(name$1, cur[name$1]); } }
	  if (prev.class != cur.class) {
	    var prevList = prev.class ? prev.class.split(" ") : nothing;
	    var curList = cur.class ? cur.class.split(" ") : nothing;
	    for (var i = 0; i < prevList.length; i++) { if (curList.indexOf(prevList[i]) == -1)
	      { dom.classList.remove(prevList[i]); } }
	    for (var i$1 = 0; i$1 < curList.length; i$1++) { if (prevList.indexOf(curList[i$1]) == -1)
	      { dom.classList.add(curList[i$1]); } }
	  }
	  if (prev.style != cur.style) {
	    if (prev.style) {
	      var prop = /\s*([\w\-\xa1-\uffff]+)\s*:(?:"(?:\\.|[^"])*"|'(?:\\.|[^'])*'|\(.*?\)|[^;])*/g, m;
	      while (m = prop.exec(prev.style))
	        { dom.style[m[1].toLowerCase()] = ""; }
	    }
	    if (cur.style)
	      { dom.style.cssText += cur.style; }
	  }
	}
	
	function applyOuterDeco(dom, deco, node) {
	  return patchOuterDeco(dom, dom, noDeco, computeOuterDeco(deco, node, dom.nodeType != 1))
	}
	
	// : ([Decoration], [Decoration]) → bool
	function sameOuterDeco(a, b) {
	  if (a.length != b.length) { return false }
	  for (var i = 0; i < a.length; i++) { if (!a[i].type.eq(b[i].type)) { return false } }
	  return true
	}
	
	// Remove a DOM node and return its next sibling.
	function rm(dom) {
	  var next = dom.nextSibling;
	  dom.parentNode.removeChild(dom);
	  return next
	}
	
	// Helper class for incrementally updating a tree of mark descs and
	// the widget and node descs inside of them.
	var ViewTreeUpdater = function ViewTreeUpdater(top) {
	  this.top = top;
	  // Index into `this.top`'s child array, represents the current
	  // update position.
	  this.index = 0;
	  // When entering a mark, the current top and index are pushed
	  // onto this.
	  this.stack = [];
	  // Tracks whether anything was changed
	  this.changed = false;
	
	  var pre = preMatch(top.node.content, top.children);
	  this.preMatched = pre.nodes;
	  this.preMatchOffset = pre.offset;
	};
	
	ViewTreeUpdater.prototype.getPreMatch = function getPreMatch (index) {
	  return index >= this.preMatchOffset ? this.preMatched[index - this.preMatchOffset] : null
	};
	
	// Destroy and remove the children between the given indices in
	// `this.top`.
	ViewTreeUpdater.prototype.destroyBetween = function destroyBetween (start, end) {
	    var this$1 = this;
	
	  if (start == end) { return }
	  for (var i = start; i < end; i++) { this$1.top.children[i].destroy(); }
	  this.top.children.splice(start, end - start);
	  this.changed = true;
	};
	
	// Destroy all remaining children in `this.top`.
	ViewTreeUpdater.prototype.destroyRest = function destroyRest () {
	  this.destroyBetween(this.index, this.top.children.length);
	};
	
	// : ([Mark], EditorView)
	// Sync the current stack of mark descs with the given array of
	// marks, reusing existing mark descs when possible.
	ViewTreeUpdater.prototype.syncToMarks = function syncToMarks (marks, inline, view) {
	    var this$1 = this;
	
	  var keep = 0, depth = this.stack.length >> 1;
	  var maxKeep = Math.min(depth, marks.length);
	  while (keep < maxKeep &&
	         (keep == depth - 1 ? this.top : this.stack[(keep + 1) << 1]).matchesMark(marks[keep]) && marks[keep].type.spec.spanning !== false)
	    { keep++; }
	
	  while (keep < depth) {
	    this$1.destroyRest();
	    this$1.top.dirty = NOT_DIRTY;
	    this$1.index = this$1.stack.pop();
	    this$1.top = this$1.stack.pop();
	    depth--;
	  }
	  while (depth < marks.length) {
	    this$1.stack.push(this$1.top, this$1.index + 1);
	    var found = -1;
	    for (var i = this.index; i < Math.min(this.index + 3, this.top.children.length); i++) {
	      if (this$1.top.children[i].matchesMark(marks[depth])) { found = i; break }
	    }
	    if (found > -1) {
	      if (found > this$1.index) {
	        this$1.changed = true;
	        this$1.top.children.splice(this$1.index, found - this$1.index);
	      }
	      this$1.top = this$1.top.children[this$1.index];
	    } else {
	      var markDesc = MarkViewDesc.create(this$1.top, marks[depth], inline, view);
	      this$1.top.children.splice(this$1.index, 0, markDesc);
	      this$1.top = markDesc;
	      this$1.changed = true;
	    }
	    this$1.index = 0;
	    depth++;
	  }
	};
	
	// : (Node, [Decoration], DecorationSet) → bool
	// Try to find a node desc matching the given data. Skip over it and
	// return true when successful.
	ViewTreeUpdater.prototype.findNodeMatch = function findNodeMatch (node, outerDeco, innerDeco, index) {
	    var this$1 = this;
	
	  var found = -1, preMatch = index < 0 ? undefined : this.getPreMatch(index), children = this.top.children;
	  if (preMatch && preMatch.matchesNode(node, outerDeco, innerDeco)) {
	    found = children.indexOf(preMatch);
	  } else {
	    for (var i = this.index, e = Math.min(children.length, i + 5); i < e; i++) {
	      var child = children[i];
	      if (child.matchesNode(node, outerDeco, innerDeco) && this$1.preMatched.indexOf(child) < 0) {
	        found = i;
	        break
	      }
	    }
	  }
	  if (found < 0) { return false }
	  this.destroyBetween(this.index, found);
	  this.index++;
	  return true
	};
	
	// : (Node, [Decoration], DecorationSet, EditorView, Fragment, number) → bool
	// Try to update the next node, if any, to the given data. Checks
	// pre-matches to avoid overwriting nodes that could still be used.
	ViewTreeUpdater.prototype.updateNextNode = function updateNextNode (node, outerDeco, innerDeco, view, index) {
	  if (this.index == this.top.children.length) { return false }
	  var next = this.top.children[this.index];
	  if (next instanceof NodeViewDesc) {
	    var preMatch = this.preMatched.indexOf(next);
	    if (preMatch > -1 && preMatch + this.preMatchOffset != index) { return false }
	    var nextDOM = next.dom;
	    if (next.update(node, outerDeco, innerDeco, view)) {
	      if (next.dom != nextDOM) { this.changed = true; }
	      this.index++;
	      return true
	    }
	  }
	  return false
	};
	
	// : (Node, [Decoration], DecorationSet, EditorView)
	// Insert the node as a newly created node desc.
	ViewTreeUpdater.prototype.addNode = function addNode (node, outerDeco, innerDeco, view, pos) {
	  this.top.children.splice(this.index++, 0, NodeViewDesc.create(this.top, node, outerDeco, innerDeco, view, pos));
	  this.changed = true;
	};
	
	ViewTreeUpdater.prototype.placeWidget = function placeWidget (widget, view, pos) {
	  if (this.index < this.top.children.length && this.top.children[this.index].matchesWidget(widget)) {
	    this.index++;
	  } else {
	    var desc = new (widget.spec.isCursorWrapper ? CursorWrapperDesc : WidgetViewDesc)(this.top, widget, view, pos);
	    this.top.children.splice(this.index++, 0, desc);
	    this.changed = true;
	  }
	};
	
	// Make sure a textblock looks and behaves correctly in
	// contentEditable.
	ViewTreeUpdater.prototype.addTextblockHacks = function addTextblockHacks () {
	  var lastChild = this.top.children[this.index - 1];
	  while (lastChild instanceof MarkViewDesc) { lastChild = lastChild.children[lastChild.children.length - 1]; }
	
	  if (!lastChild || // Empty textblock
	      !(lastChild instanceof TextViewDesc) ||
	      /\n$/.test(lastChild.node.text)) {
	    if (this.index < this.top.children.length && this.top.children[this.index].matchesHack()) {
	      this.index++;
	    } else {
	      var dom = document.createElement("br");
	      this.top.children.splice(this.index++, 0, new BRHackViewDesc(this.top, nothing, dom, null));
	      this.changed = true;
	    }
	  }
	};
	
	// : (Fragment, [ViewDesc]) → [ViewDesc]
	// Iterate from the end of the fragment and array of descs to find
	// directly matching ones, in order to avoid overeagerly reusing
	// those for other nodes. Returns an array whose positions correspond
	// to node positions in the fragment, and whose elements are either
	// descs matched to the child at that index, or empty.
	function preMatch(frag, descs) {
	  var result$$1 = [], end = frag.childCount;
	  for (var i = descs.length - 1; end > 0 && i >= 0; i--) {
	    var desc = descs[i], node = desc.node;
	    if (!node) { continue }
	    if (node != frag.child(end - 1)) { break }
	    result$$1.push(desc);
	    --end;
	  }
	  return {nodes: result$$1.reverse(), offset: end}
	}
	
	function compareSide(a, b) { return a.type.side - b.type.side }
	
	// : (ViewDesc, DecorationSet, (Decoration), (Node, [Decoration], DecorationSet, number))
	// This function abstracts iterating over the nodes and decorations in
	// a fragment. Calls `onNode` for each node, with its local and child
	// decorations. Splits text nodes when there is a decoration starting
	// or ending inside of them. Calls `onWidget` for each widget.
	function iterDeco(parent, deco, onWidget, onNode) {
	  var locals = deco.locals(parent), offset = 0;
	  // Simple, cheap variant for when there are no local decorations
	  if (locals.length == 0) {
	    for (var i = 0; i < parent.childCount; i++) {
	      var child = parent.child(i);
	      onNode(child, locals, deco.forChild(offset, child), i);
	      offset += child.nodeSize;
	    }
	    return
	  }
	
	  var decoIndex = 0, active = [], restNode = null;
	  for (var parentIndex = 0;;) {
	    if (decoIndex < locals.length && locals[decoIndex].to == offset) {
	      var widget = locals[decoIndex++], widgets = (void 0);
	      while (decoIndex < locals.length && locals[decoIndex].to == offset)
	        { (widgets || (widgets = [widget])).push(locals[decoIndex++]); }
	      if (widgets) {
	        widgets.sort(compareSide);
	        for (var i$1 = 0; i$1 < widgets.length; i$1++) { onWidget(widgets[i$1], parentIndex); }
	      } else {
	        onWidget(widget, parentIndex);
	      }
	    }
	
	    var child$1 = (void 0), index = (void 0);
	    if (restNode) {
	      index = -1;
	      child$1 = restNode;
	      restNode = null;
	    } else if (parentIndex < parent.childCount) {
	      index = parentIndex;
	      child$1 = parent.child(parentIndex++);
	    } else {
	      break
	    }
	
	    for (var i$2 = 0; i$2 < active.length; i$2++) { if (active[i$2].to <= offset) { active.splice(i$2--, 1); } }
	    while (decoIndex < locals.length && locals[decoIndex].from == offset) { active.push(locals[decoIndex++]); }
	
	    var end = offset + child$1.nodeSize;
	    if (child$1.isText) {
	      var cutAt = end;
	      if (decoIndex < locals.length && locals[decoIndex].from < cutAt) { cutAt = locals[decoIndex].from; }
	      for (var i$3 = 0; i$3 < active.length; i$3++) { if (active[i$3].to < cutAt) { cutAt = active[i$3].to; } }
	      if (cutAt < end) {
	        restNode = child$1.cut(cutAt - offset);
	        child$1 = child$1.cut(0, cutAt - offset);
	        end = cutAt;
	        index = -1;
	      }
	    }
	
	    onNode(child$1, active.length ? active.slice() : nothing, deco.forChild(offset, child$1), index);
	    offset = end;
	  }
	}
	
	// List markers in Mobile Safari will mysteriously disappear
	// sometimes. This works around that.
	function iosHacks(dom) {
	  if (dom.nodeName == "UL" || dom.nodeName == "OL") {
	    var oldCSS = dom.style.cssText;
	    dom.style.cssText = oldCSS + "; list-style: square !important";
	    window.getComputedStyle(dom).listStyle;
	    dom.style.cssText = oldCSS;
	  }
	}
	
	function moveSelectionBlock(state, dir) {
	  var ref = state.selection;
	  var $anchor = ref.$anchor;
	  var $head = ref.$head;
	  var $side = dir > 0 ? $anchor.max($head) : $anchor.min($head);
	  var $start = !$side.parent.inlineContent ? $side : $side.depth ? state.doc.resolve(dir > 0 ? $side.after() : $side.before()) : null;
	  return $start && prosemirrorState.Selection.findFrom($start, dir)
	}
	
	function apply(view, sel) {
	  view.dispatch(view.state.tr.setSelection(sel).scrollIntoView());
	  return true
	}
	
	function selectHorizontally(view, dir, mods) {
	  var sel = view.state.selection;
	  if (sel instanceof prosemirrorState.TextSelection) {
	    if (!sel.empty || mods.indexOf("s") > -1) {
	      return false
	    } else if (view.endOfTextblock(dir > 0 ? "right" : "left")) {
	      var next = moveSelectionBlock(view.state, dir);
	      if (next && (next instanceof prosemirrorState.NodeSelection)) { return apply(view, next) }
	      return false
	    } else {
	      var $head = sel.$head, node = $head.textOffset ? null : dir < 0 ? $head.nodeBefore : $head.nodeAfter, desc;
	      if (node && prosemirrorState.NodeSelection.isSelectable(node)) {
	        var nodePos = dir < 0 ? $head.pos - node.nodeSize : $head.pos;
	        if (node.isAtom || (desc = view.docView.descAt(nodePos)) && !desc.contentDOM)
	          { return apply(view, new prosemirrorState.NodeSelection(dir < 0 ? view.state.doc.resolve($head.pos - node.nodeSize) : $head)) }
	      }
	      return false
	    }
	  } else if (sel instanceof prosemirrorState.NodeSelection && sel.node.isInline) {
	    return apply(view, new prosemirrorState.TextSelection(dir > 0 ? sel.$to : sel.$from))
	  } else {
	    var next$1 = moveSelectionBlock(view.state, dir);
	    if (next$1) { return apply(view, next$1) }
	    return false
	  }
	}
	
	function nodeLen(node) {
	  return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length
	}
	
	function isIgnorable(dom) {
	  var desc = dom.pmViewDesc;
	  return desc && desc.size == 0 && (dom.nextSibling || dom.nodeName != "BR")
	}
	
	// Make sure the cursor isn't directly after one or more ignored
	// nodes, which will confuse the browser's cursor motion logic.
	function skipIgnoredNodesLeft(view) {
	  var sel = view.root.getSelection();
	  var node = sel.focusNode, offset = sel.focusOffset;
	  if (!node) { return }
	  var moveNode, moveOffset, force = false;
	  // Gecko will do odd things when the selection is directly in front
	  // of a non-editable node, so in that case, move it into the next
	  // node if possible. Issue prosemirror/prosemirror#832.
	  if (result.gecko && node.nodeType == 1 && offset < nodeLen(node) && isIgnorable(node.childNodes[offset])) { force = true; }
	  for (;;) {
	    if (offset > 0) {
	      if (node.nodeType != 1) {
	        if (node.nodeType == 3 && node.nodeValue.charAt(offset - 1) == "\ufeff") {
	          // IE11's cursor will still be stuck when placed at the
	          // beginning of the cursor wrapper text node (#807)
	          if (result.ie && result.ie_version <= 11) { force = true; }
	          moveNode = node;
	          moveOffset = --offset;
	        } else { break }
	      } else {
	        var before = node.childNodes[offset - 1];
	        if (isIgnorable(before)) {
	          moveNode = node;
	          moveOffset = --offset;
	        } else if (before.nodeType == 3) {
	          node = before;
	          offset = node.nodeValue.length;
	        } else { break }
	      }
	    } else if (isBlockNode(node)) {
	      break
	    } else {
	      var prev = node.previousSibling;
	      while (prev && isIgnorable(prev)) {
	        moveNode = node.parentNode;
	        moveOffset = domIndex(prev);
	        prev = prev.previousSibling;
	      }
	      if (!prev) {
	        node = node.parentNode;
	        if (node == view.dom) { break }
	        offset = 0;
	      } else {
	        node = prev;
	        offset = nodeLen(node);
	      }
	    }
	  }
	  if (force) { setSelFocus(view, sel, node, offset); }
	  else if (moveNode) { setSelFocus(view, sel, moveNode, moveOffset); }
	}
	
	// Make sure the cursor isn't directly before one or more ignored
	// nodes.
	function skipIgnoredNodesRight(view) {
	  var sel = view.root.getSelection();
	  var node = sel.focusNode, offset = sel.focusOffset;
	  if (!node) { return }
	  var len = nodeLen(node);
	  var moveNode, moveOffset;
	  for (;;) {
	    if (offset < len) {
	      if (node.nodeType != 1) { break }
	      var after = node.childNodes[offset];
	      if (isIgnorable(after)) {
	        moveNode = node;
	        moveOffset = ++offset;
	      }
	      else { break }
	    } else if (isBlockNode(node)) {
	      break
	    } else {
	      var next = node.nextSibling;
	      while (next && isIgnorable(next)) {
	        moveNode = next.parentNode;
	        moveOffset = domIndex(next) + 1;
	        next = next.nextSibling;
	      }
	      if (!next) {
	        node = node.parentNode;
	        if (node == view.dom) { break }
	        offset = len = 0;
	      } else {
	        node = next;
	        offset = 0;
	        len = nodeLen(node);
	      }
	    }
	  }
	  if (moveNode) { setSelFocus(view, sel, moveNode, moveOffset); }
	}
	
	function isBlockNode(dom) {
	  var desc = dom.pmViewDesc;
	  return desc && desc.node && desc.node.isBlock
	}
	
	function setSelFocus(view, sel, node, offset) {
	  if (selectionCollapsed(sel)) {
	    var range = document.createRange();
	    range.setEnd(node, offset);
	    range.setStart(node, offset);
	    sel.removeAllRanges();
	    sel.addRange(range);
	  } else if (sel.extend) {
	    sel.extend(node, offset);
	  }
	  view.selectionReader.storeDOMState(view.selection);
	}
	
	// : (EditorState, number)
	// Check whether vertical selection motion would involve node
	// selections. If so, apply it (if not, the result is left to the
	// browser)
	function selectVertically(view, dir, mods) {
	  var sel = view.state.selection;
	  if (sel instanceof prosemirrorState.TextSelection && !sel.empty || mods.indexOf("s") > -1) { return false }
	  var $from = sel.$from;
	  var $to = sel.$to;
	
	  if (!$from.parent.inlineContent || view.endOfTextblock(dir < 0 ? "up" : "down")) {
	    var next = moveSelectionBlock(view.state, dir);
	    if (next && (next instanceof prosemirrorState.NodeSelection))
	      { return apply(view, next) }
	  }
	  if (!$from.parent.inlineContent) {
	    var beyond = prosemirrorState.Selection.findFrom(dir < 0 ? $from : $to, dir);
	    return beyond ? apply(view, beyond) : true
	  }
	  return false
	}
	
	function stopNativeHorizontalDelete(view, dir) {
	  if (!(view.state.selection instanceof prosemirrorState.TextSelection)) { return true }
	  var ref = view.state.selection;
	  var $head = ref.$head;
	  var $anchor = ref.$anchor;
	  var empty = ref.empty;
	  if (!$head.sameParent($anchor)) { return true }
	  if (!empty) { return false }
	  if (view.endOfTextblock(dir > 0 ? "forward" : "backward")) { return true }
	  var nextNode = !$head.textOffset && (dir < 0 ? $head.nodeBefore : $head.nodeAfter);
	  if (nextNode && !nextNode.isText) {
	    var tr = view.state.tr;
	    if (dir < 0) { tr.delete($head.pos - nextNode.nodeSize, $head.pos); }
	    else { tr.delete($head.pos, $head.pos + nextNode.nodeSize); }
	    view.dispatch(tr);
	    return true
	  }
	  return false
	}
	
	function switchEditable(view, node, state) {
	  view.domObserver.stop();
	  node.contentEditable = state;
	  view.domObserver.start();
	}
	
	// Issue #867 / https://bugs.chromium.org/p/chromium/issues/detail?id=903821
	// In which Chrome does really wrong things when the down arrow is
	// pressed when the cursor is directly at the start of a textblock and
	// has an uneditable node after it
	function chromeDownArrowBug(view) {
	  if (!result.chrome || view.state.selection.$head.parentOffset > 0) { return }
	  var ref = view.root.getSelection();
	  var focusNode = ref.focusNode;
	  var focusOffset = ref.focusOffset;
	  if (focusNode && focusNode.nodeType == 1 && focusOffset == 0 &&
	      focusNode.firstChild && focusNode.firstChild.contentEditable == "false") {
	    var child = focusNode.firstChild;
	    switchEditable(view, child, true);
	    setTimeout(function () { return switchEditable(view, child, false); }, 20);
	  }
	}
	
	// A backdrop key mapping used to make sure we always suppress keys
	// that have a dangerous default effect, even if the commands they are
	// bound to return false, and to make sure that cursor-motion keys
	// find a cursor (as opposed to a node selection) when pressed. For
	// cursor-motion keys, the code in the handlers also takes care of
	// block selections.
	
	function getMods(event) {
	  var result$$1 = "";
	  if (event.ctrlKey) { result$$1 += "c"; }
	  if (event.metaKey) { result$$1 += "m"; }
	  if (event.altKey) { result$$1 += "a"; }
	  if (event.shiftKey) { result$$1 += "s"; }
	  return result$$1
	}
	
	function captureKeyDown(view, event) {
	  var code = event.keyCode, mods = getMods(event);
	  if (code == 8 || (result.mac && code == 72 && mods == "c")) { // Backspace, Ctrl-h on Mac
	    return stopNativeHorizontalDelete(view, -1) || skipIgnoredNodesLeft(view)
	  } else if (code == 46 || (result.mac && code == 68 && mods == "c")) { // Delete, Ctrl-d on Mac
	    return stopNativeHorizontalDelete(view, 1) || skipIgnoredNodesRight(view)
	  } else if (code == 13 || code == 27) { // Enter, Esc
	    return true
	  } else if (code == 37) { // Left arrow
	    return selectHorizontally(view, -1, mods) || skipIgnoredNodesLeft(view)
	  } else if (code == 39) { // Right arrow
	    return selectHorizontally(view, 1, mods) || skipIgnoredNodesRight(view)
	  } else if (code == 38) { // Up arrow
	    return selectVertically(view, -1, mods) || skipIgnoredNodesLeft(view)
	  } else if (code == 40) { // Down arrow
	    return chromeDownArrowBug(view) || selectVertically(view, 1, mods) || skipIgnoredNodesRight(view)
	  } else if (mods == (result.mac ? "m" : "c") &&
	             (code == 66 || code == 73 || code == 89 || code == 90)) { // Mod-[biyz]
	    return true
	  }
	  return false
	}
	
	var TrackedRecord = function TrackedRecord(prev, mapping, state) {
	  this.prev = prev;
	  this.mapping = mapping;
	  this.state = state;
	};
	
	var TrackMappings = function TrackMappings(state) {
	  this.seen = [new TrackedRecord(null, null, state)];
	  // Kludge to listen to state changes globally in order to be able
	  // to find mappings from a given state to another.
	  prosemirrorState.EditorState.addApplyListener(this.track = this.track.bind(this));
	};
	
	TrackMappings.prototype.destroy = function destroy () {
	  prosemirrorState.EditorState.removeApplyListener(this.track);
	};
	
	TrackMappings.prototype.find = function find (state) {
	    var this$1 = this;
	
	  for (var i = this.seen.length - 1; i >= 0; i--) {
	    var record = this$1.seen[i];
	    if (record.state == state) { return record }
	  }
	};
	
	TrackMappings.prototype.track = function track (old, tr, state) {
	  var found = this.seen.length < 200 ? this.find(old) : null;
	  if (found)
	    { this.seen.push(new TrackedRecord(found, tr.docChanged ? tr.mapping : null, state)); }
	};
	
	TrackMappings.prototype.getMapping = function getMapping (state, appendTo) {
	  var found = this.find(state);
	  if (!found) { return null }
	  var mappings = [];
	  for (var rec = found; rec; rec = rec.prev)
	    { if (rec.mapping) { mappings.push(rec.mapping); } }
	  var result = appendTo || new prosemirrorTransform.Mapping;
	  for (var i = mappings.length - 1; i >= 0; i--)
	    { result.appendMapping(mappings[i]); }
	  return result
	};
	
	// Track the state of the DOM selection, creating transactions to
	// update the selection state when necessary.
	var SelectionReader = function SelectionReader(view) {
	  var this$1 = this;
	
	  this.view = view;
	
	  // Track the state of the DOM selection.
	  this.lastAnchorNode = this.lastHeadNode = this.lastAnchorOffset = this.lastHeadOffset = null;
	  this.lastSelection = view.state.selection;
	  this.ignoreUpdates = false;
	  this.suppressUpdates = false;
	  this.poller = poller(this);
	
	  this.focusFunc = (function () { return this$1.poller.start(hasFocusAndSelection(this$1.view)); }).bind(this);
	  this.blurFunc = this.poller.stop;
	
	  view.dom.addEventListener("focus", this.focusFunc);
	  view.dom.addEventListener("blur", this.blurFunc);
	
	  if (!view.editable) { this.poller.start(false); }
	};
	
	SelectionReader.prototype.destroy = function destroy () {
	  this.view.dom.removeEventListener("focus", this.focusFunc);
	  this.view.dom.removeEventListener("blur", this.blurFunc);
	  this.poller.stop();
	};
	
	SelectionReader.prototype.poll = function poll (origin) { this.poller.poll(origin); };
	
	SelectionReader.prototype.editableChanged = function editableChanged () {
	  if (!this.view.editable) { this.poller.start(); }
	  else if (!hasFocusAndSelection(this.view)) { this.poller.stop(); }
	};
	
	// : () → bool
	// Whether the DOM selection has changed from the last known state.
	SelectionReader.prototype.domChanged = function domChanged () {
	  var sel = this.view.root.getSelection();
	  return sel.anchorNode != this.lastAnchorNode || sel.anchorOffset != this.lastAnchorOffset ||
	    sel.focusNode != this.lastHeadNode || sel.focusOffset != this.lastHeadOffset
	};
	
	// Store the current state of the DOM selection.
	SelectionReader.prototype.storeDOMState = function storeDOMState (selection) {
	  var sel = this.view.root.getSelection();
	  this.lastAnchorNode = sel.anchorNode; this.lastAnchorOffset = sel.anchorOffset;
	  this.lastHeadNode = sel.focusNode; this.lastHeadOffset = sel.focusOffset;
	  this.lastSelection = selection;
	};
	
	SelectionReader.prototype.clearDOMState = function clearDOMState () {
	  this.lastAnchorNode = this.lastSelection = null;
	};
	
	// : (?string)
	// When the DOM selection changes in a notable manner, modify the
	// current selection state to match.
	SelectionReader.prototype.readFromDOM = function readFromDOM (origin) {
	  if (this.ignoreUpdates || !this.domChanged() || !hasFocusAndSelection(this.view)) { return }
	  if (this.suppressUpdates) { return selectionToDOM(this.view) }
	  if (!this.view.inDOMChange) { this.view.domObserver.flush(); }
	  if (this.view.inDOMChange) { return }
	
	  var domSel = this.view.root.getSelection(), doc = this.view.state.doc;
	  var nearestDesc = this.view.docView.nearestDesc(domSel.focusNode), inWidget = nearestDesc && nearestDesc.size == 0;
	  var head = this.view.docView.posFromDOM(domSel.focusNode, domSel.focusOffset);
	  var $head = doc.resolve(head), $anchor, selection;
	  if (selectionCollapsed(domSel)) {
	    $anchor = $head;
	    while (nearestDesc && !nearestDesc.node) { nearestDesc = nearestDesc.parent; }
	    if (nearestDesc && nearestDesc.node.isAtom && prosemirrorState.NodeSelection.isSelectable(nearestDesc.node) && nearestDesc.parent) {
	      var pos = nearestDesc.posBefore;
	      selection = new prosemirrorState.NodeSelection(head == pos ? $head : doc.resolve(pos));
	    }
	  } else {
	    $anchor = doc.resolve(this.view.docView.posFromDOM(domSel.anchorNode, domSel.anchorOffset));
	  }
	
	  if (!selection) {
	    var bias = origin == "pointer" || (this.view.state.selection.head < $head.pos && !inWidget) ? 1 : -1;
	    selection = selectionBetween(this.view, $anchor, $head, bias);
	  }
	  if (!this.view.state.selection.eq(selection)) {
	    var tr = this.view.state.tr.setSelection(selection);
	    if (origin == "pointer") { tr.setMeta("pointer", true); }
	    else if (origin == "key") { tr.scrollIntoView(); }
	    this.view.dispatch(tr);
	  } else {
	    selectionToDOM(this.view);
	  }
	};
	
	// There's two polling models. On browsers that support the
	// selectionchange event (everything except Firefox < 52, basically), we
	// register a listener for that whenever the editor is focused.
	var SelectionChangePoller = function SelectionChangePoller(reader) {
	  var this$1 = this;
	
	  this.listening = false;
	  this.curOrigin = null;
	  this.originTime = 0;
	  this.reader = reader;
	
	  this.readFunc = function () { return reader.readFromDOM(this$1.originTime > Date.now() - 50 ? this$1.curOrigin : null); };
	};
	
	SelectionChangePoller.prototype.poll = function poll (origin) {
	  this.curOrigin = origin;
	  this.originTime = Date.now();
	};
	
	SelectionChangePoller.prototype.start = function start (andRead) {
	  if (!this.listening) {
	    var doc = this.reader.view.dom.ownerDocument;
	    doc.addEventListener("selectionchange", this.readFunc);
	    this.listening = true;
	    if (andRead) { this.readFunc(); }
	  }
	};
	
	SelectionChangePoller.prototype.stop = function stop () {
	  if (this.listening) {
	    var doc = this.reader.view.dom.ownerDocument;
	    doc.removeEventListener("selectionchange", this.readFunc);
	    this.listening = false;
	  }
	};
	
	// On Browsers that don't support the selectionchange event,
	// we use timeout-based polling.
	var TimeoutPoller = function TimeoutPoller(reader) {
	  // The timeout ID for the poller when active.
	  this.polling = null;
	  this.reader = reader;
	  this.pollFunc = this.doPoll.bind(this, null);
	};
	
	TimeoutPoller.prototype.doPoll = function doPoll (origin) {
	  var view = this.reader.view;
	  if (view.focused || !view.editable) {
	    this.reader.readFromDOM(origin);
	    this.polling = setTimeout(this.pollFunc, 100);
	  } else {
	    this.polling = null;
	  }
	};
	
	TimeoutPoller.prototype.poll = function poll (origin) {
	  clearTimeout(this.polling);
	  this.polling = setTimeout(origin ? this.doPoll.bind(this, origin) : this.pollFunc, 0);
	};
	
	TimeoutPoller.prototype.start = function start () {
	  if (this.polling == null) { this.poll(); }
	};
	
	TimeoutPoller.prototype.stop = function stop () {
	  clearTimeout(this.polling);
	  this.polling = null;
	};
	
	function poller(reader) {
	  return new ("onselectionchange" in document ? SelectionChangePoller : TimeoutPoller)(reader)
	}
	
	function selectionToDOM(view, takeFocus, force) {
	  var sel = view.state.selection;
	  syncNodeSelection(view, sel);
	
	  if (view.editable && !view.hasFocus()) {
	    if (!takeFocus) { return }
	    // See https://bugzilla.mozilla.org/show_bug.cgi?id=921444
	    if (result.gecko && result.gecko_version <= 55) {
	      view.selectionReader.ignoreUpdates = true;
	      view.dom.focus();
	      view.selectionReader.ignoreUpdates = false;
	    }
	  } else if (!view.editable && !hasSelection(view) && !takeFocus) {
	    return
	  }
	
	  var reader = view.selectionReader;
	  if (reader.lastSelection && reader.lastSelection.eq(sel) && !reader.domChanged()) { return }
	
	  reader.ignoreUpdates = true;
	
	  if (view.cursorWrapper) {
	    selectCursorWrapper(view);
	  } else {
	    var anchor = sel.anchor;
	    var head = sel.head;
	    var resetEditableFrom, resetEditableTo;
	    if (brokenSelectBetweenUneditable && !(sel instanceof prosemirrorState.TextSelection)) {
	      if (!sel.$from.parent.inlineContent)
	        { resetEditableFrom = temporarilyEditableNear(view, sel.from); }
	      if (!sel.empty && !sel.$from.parent.inlineContent)
	        { resetEditableTo = temporarilyEditableNear(view, sel.to); }
	    }
	    view.docView.setSelection(anchor, head, view.root, force);
	    if (brokenSelectBetweenUneditable) {
	      if (resetEditableFrom) { resetEditableFrom.contentEditable = "false"; }
	      if (resetEditableTo) { resetEditableTo.contentEditable = "false"; }
	    }
	    if (sel.visible) {
	      view.dom.classList.remove("ProseMirror-hideselection");
	    } else if (anchor != head) {
	      view.dom.classList.add("ProseMirror-hideselection");
	      if ("onselectionchange" in document) { removeClassOnSelectionChange(view); }
	    }
	  }
	
	  reader.storeDOMState(sel);
	  reader.ignoreUpdates = false;
	}
	
	// Kludge to work around Webkit not allowing a selection to start/end
	// between non-editable block nodes. We briefly make something
	// editable, set the selection, then set it uneditable again.
	
	var brokenSelectBetweenUneditable = result.safari || result.chrome && result.chrome_version < 63;
	
	function temporarilyEditableNear(view, pos) {
	  var ref = view.docView.domFromPos(pos);
	  var node = ref.node;
	  var offset = ref.offset;
	  var after = offset < node.childNodes.length ? node.childNodes[offset] : null;
	  var before = offset ? node.childNodes[offset - 1] : null;
	  if ((!after || after.contentEditable == "false") && (!before || before.contentEditable == "false")) {
	    if (after) {
	      after.contentEditable = "true";
	      return after
	    } else if (before) {
	      before.contentEditable = "true";
	      return before
	    }
	  }
	}
	
	function removeClassOnSelectionChange(view) {
	  var doc = view.dom.ownerDocument;
	  doc.removeEventListener("selectionchange", view.hideSelectionGuard);
	  var domSel = view.root.getSelection();
	  var node = domSel.anchorNode, offset = domSel.anchorOffset;
	  doc.addEventListener("selectionchange", view.hideSelectionGuard = function () {
	    if (domSel.anchorNode != node || domSel.anchorOffset != offset) {
	      doc.removeEventListener("selectionchange", view.hideSelectionGuard);
	      view.dom.classList.remove("ProseMirror-hideselection");
	    }
	  });
	}
	
	function selectCursorWrapper(view) {
	  var domSel = view.root.getSelection(), range = document.createRange();
	  var node = view.cursorWrapper.dom;
	  range.setEnd(node, node.childNodes.length);
	  range.collapse(false);
	  domSel.removeAllRanges();
	  domSel.addRange(range);
	  // Kludge to kill 'control selection' in IE11 when selecting an
	  // invisible cursor wrapper, since that would result in those weird
	  // resize handles and a selection that considers the absolutely
	  // positioned wrapper, rather than the root editable node, the
	  // focused element.
	  if (!view.state.selection.visible && result.ie && result.ie_version <= 11) {
	    node.disabled = true;
	    node.disabled = false;
	  }
	}
	
	function syncNodeSelection(view, sel) {
	  if (sel instanceof prosemirrorState.NodeSelection) {
	    var desc = view.docView.descAt(sel.from);
	    if (desc != view.lastSelectedViewDesc) {
	      clearNodeSelection(view);
	      if (desc) { desc.selectNode(); }
	      view.lastSelectedViewDesc = desc;
	    }
	  } else {
	    clearNodeSelection(view);
	  }
	}
	
	// Clear all DOM statefulness of the last node selection.
	function clearNodeSelection(view) {
	  if (view.lastSelectedViewDesc) {
	    if (view.lastSelectedViewDesc.parent)
	      { view.lastSelectedViewDesc.deselectNode(); }
	    view.lastSelectedViewDesc = null;
	  }
	}
	
	function selectionBetween(view, $anchor, $head, bias) {
	  return view.someProp("createSelectionBetween", function (f) { return f(view, $anchor, $head); })
	    || prosemirrorState.TextSelection.between($anchor, $head, bias)
	}
	
	function hasFocusAndSelection(view) {
	  if (view.editable && view.root.activeElement != view.dom) { return false }
	  return hasSelection(view)
	}
	
	function hasSelection(view) {
	  var sel = view.root.getSelection();
	  if (!sel.anchorNode) { return false }
	  try {
	    // Firefox will raise 'permission denied' errors when accessing
	    // properties of `sel.anchorNode` when it's in a generated CSS
	    // element.
	    return view.dom.contains(sel.anchorNode.nodeType == 3 ? sel.anchorNode.parentNode : sel.anchorNode) &&
	      (view.editable || view.dom.contains(sel.focusNode.nodeType == 3 ? sel.focusNode.parentNode : sel.focusNode))
	  } catch(_) {
	    return false
	  }
	}
	
	function nonInclusiveMark(mark) {
	  return mark.type.spec.inclusive === false
	}
	
	function needsCursorWrapper(state) {
	  var ref = state.selection;
	  var $head = ref.$head;
	  var $anchor = ref.$anchor;
	  var visible = ref.visible;
	  var $pos = $head.pos == $anchor.pos && (!visible || $head.parent.inlineContent) ? $head : null;
	  if ($pos && (!visible || state.storedMarks || $pos.parent.content.length == 0 ||
	               $pos.parentOffset && !$pos.textOffset && $pos.nodeBefore.marks.some(nonInclusiveMark)))
	    { return $pos }
	  else
	    { return null }
	}
	
	function anchorInRightPlace(view) {
	  var anchorDOM = view.docView.domFromPos(view.state.selection.anchor);
	  var domSel = view.root.getSelection();
	  return isEquivalentPosition(anchorDOM.node, anchorDOM.offset, domSel.anchorNode, domSel.anchorOffset)
	}
	
	var DOMChange = function DOMChange(view, composing) {
	  var this$1 = this;
	
	  this.view = view;
	  this.state = view.state;
	  this.composing = composing;
	  this.compositionEndedAt = null;
	  this.from = this.to = null;
	  this.typeOver = false;
	  this.timeout = composing ? null : setTimeout(function () { return this$1.finish(); }, DOMChange.commitTimeout);
	  this.trackMappings = new TrackMappings(view.state);
	
	  // If there have been changes since this DOM update started, we must
	  // map our start and end positions, as well as the new selection
	  // positions, through them. This tracks that mapping.
	  this.mapping = new prosemirrorTransform.Mapping;
	  this.mappingTo = view.state;
	};
	
	DOMChange.prototype.addRange = function addRange (from, to) {
	  if (this.from == null) {
	    this.from = from;
	    this.to = to;
	  } else {
	    this.from = Math.min(from, this.from);
	    this.to = Math.max(to, this.to);
	  }
	};
	
	DOMChange.prototype.changedRange = function changedRange () {
	  if (this.from == null) { return rangeAroundSelection(this.state.selection) }
	  var $from = this.state.doc.resolve(Math.min(this.from, this.state.selection.from)), $to = this.state.doc.resolve(this.to);
	  var shared = $from.sharedDepth(this.to);
	  return {from: $from.before(shared + 1), to: $to.after(shared + 1)}
	};
	
	DOMChange.prototype.markDirty = function markDirty (range) {
	  if (this.from == null) { this.view.docView.markDirty((range = range || this.changedRange()).from, range.to); }
	  else { this.view.docView.markDirty(this.from, this.to); }
	};
	
	DOMChange.prototype.stateUpdated = function stateUpdated (state) {
	  if (this.trackMappings.getMapping(state, this.mapping)) {
	    this.trackMappings.destroy();
	    this.trackMappings = new TrackMappings(state);
	    this.mappingTo = state;
	    return true
	  } else {
	    this.markDirty();
	    this.destroy();
	    return false
	  }
	};
	
	DOMChange.prototype.finish = function finish (force) {
	  clearTimeout(this.timeout);
	  if (this.composing && !force) { return }
	  this.view.domObserver.flush();
	  var range = this.changedRange();
	  this.markDirty(range);
	
	  this.destroy();
	  var sel = this.state.selection, allowTypeOver = this.typeOver && sel instanceof prosemirrorState.TextSelection &&
	      !sel.empty && sel.$head.sameParent(sel.$anchor);
	  readDOMChange(this.view, this.mapping, this.state, range, allowTypeOver);
	
	  // If the reading didn't result in a view update, force one by
	  // resetting the view to its current state.
	  if (this.view.docView.dirty) { this.view.updateState(this.view.state); }
	};
	
	DOMChange.prototype.destroy = function destroy () {
	  clearTimeout(this.timeout);
	  this.trackMappings.destroy();
	  this.view.inDOMChange = null;
	};
	
	DOMChange.prototype.compositionEnd = function compositionEnd (event) {
	    var this$1 = this;
	
	  if (this.composing) {
	    this.composing = false;
	    if (event) { this.compositionEndedAt = event.timeStamp; }
	    this.timeout = setTimeout(function () { return this$1.finish(); }, 50);
	  }
	};
	
	DOMChange.prototype.ignoreKeyDownOnCompositionEnd = function ignoreKeyDownOnCompositionEnd (event) {
	  // See https://www.stum.de/2016/06/24/handling-ime-events-in-javascript/.
	  // On Japanese input method editors (IMEs), the Enter key is used to confirm character
	  // selection. On Safari, when Enter is pressed, compositionend and keydown events are
	  // emitted. The keydown event triggers newline insertion, which we don't want.
	  // This method returns true if the keydown event should be ignored.
	  // We only ignore it once, as pressing Enter a second time *should* insert a newline.
	  // Furthermore, the keydown event timestamp must be close to the compositionEndedAt timestamp.
	  // This guards against the case where compositionend is triggered without the keyboard
	  // (e.g. character confirmation may be done with the mouse), and keydown is triggered
	  // afterwards- we wouldn't want to ignore the keydown event in this case.
	  if (result.safari && this.compositionEndedAt !== null && Math.abs(event.timeStamp - this.compositionEndedAt) < 500) {
	    this.compositionEndedAt = null;
	    return true
	  }
	  return false
	};
	
	DOMChange.start = function start (view, composing) {
	  if (view.inDOMChange) {
	    if (composing) {
	      clearTimeout(view.inDOMChange.timeout);
	      view.inDOMChange.composing = true;
	      view.inDOMChange.compositionEndedAt = null;
	    }
	  } else {
	    view.inDOMChange = new DOMChange(view, composing);
	  }
	  return view.inDOMChange
	};
	DOMChange.commitTimeout = 20;
	
	// Note that all referencing and parsing is done with the
	// start-of-operation selection and document, since that's the one
	// that the DOM represents. If any changes came in in the meantime,
	// the modification is mapped over those before it is applied, in
	// readDOMChange.
	
	function parseBetween(view, oldState, range) {
	  var ref = view.docView.parseRange(range.from, range.to);
	  var parent = ref.node;
	  var fromOffset = ref.fromOffset;
	  var toOffset = ref.toOffset;
	  var from = ref.from;
	  var to = ref.to;
	
	  var domSel = view.root.getSelection(), find = null, anchor = domSel.anchorNode;
	  if (anchor && view.dom.contains(anchor.nodeType == 1 ? anchor : anchor.parentNode)) {
	    find = [{node: anchor, offset: domSel.anchorOffset}];
	    if (!selectionCollapsed(domSel))
	      { find.push({node: domSel.focusNode, offset: domSel.focusOffset}); }
	  }
	  // Work around issue in Chrome where backspacing sometimes replaces
	  // the deleted content with a random BR node (issues #799, #831)
	  if (result.chrome && view.lastKeyCode === 8) {
	    for (var off = toOffset; off > fromOffset; off--) {
	      var node = parent.childNodes[off - 1], desc = node.pmViewDesc;
	      if (node.nodeType == "BR" && !desc) { toOffset = off; break }
	      if (!desc || desc.size) { break }
	    }
	  }
	  var startDoc = oldState.doc;
	  var parser = view.someProp("domParser") || prosemirrorModel.DOMParser.fromSchema(view.state.schema);
	  var $from = startDoc.resolve(from);
	  var sel = null, doc = parser.parse(parent, {
	    topNode: $from.parent,
	    topMatch: $from.parent.contentMatchAt($from.index()),
	    topOpen: true,
	    from: fromOffset,
	    to: toOffset,
	    preserveWhitespace: $from.parent.type.spec.code ? "full" : true,
	    editableContent: true,
	    findPositions: find,
	    ruleFromNode: ruleFromNode(parser, $from),
	    context: $from
	  });
	  if (find && find[0].pos != null) {
	    var anchor$1 = find[0].pos, head = find[1] && find[1].pos;
	    if (head == null) { head = anchor$1; }
	    sel = {anchor: anchor$1 + from, head: head + from};
	  }
	  return {doc: doc, sel: sel, from: from, to: to}
	}
	
	function ruleFromNode(parser, context) {
	  return function (dom) {
	    var desc = dom.pmViewDesc;
	    if (desc) {
	      return desc.parseRule()
	    } else if (dom.nodeName == "BR" && dom.parentNode) {
	      // Safari replaces the list item or table cell with a BR
	      // directly in the list node (?!) if you delete the last
	      // character in a list item or table cell (#708, #862)
	      if (result.safari && /^(ul|ol)$/i.test(dom.parentNode.nodeName))
	        { return parser.matchTag(document.createElement("li"), context) }
	      else if (dom.parentNode.lastChild == dom || result.safari && /^(tr|table)$/i.test(dom.parentNode.nodeName))
	        { return {ignore: true} }
	    }
	  }
	}
	
	function isAtEnd($pos, depth) {
	  for (var i = depth || 0; i < $pos.depth; i++)
	    { if ($pos.index(i) + 1 < $pos.node(i).childCount) { return false } }
	  return $pos.parentOffset == $pos.parent.content.size
	}
	function isAtStart($pos, depth) {
	  for (var i = depth || 0; i < $pos.depth; i++)
	    { if ($pos.index(0) > 0) { return false } }
	  return $pos.parentOffset == 0
	}
	
	function rangeAroundSelection(selection) {
	  // Intentionally uses $head/$anchor because those will correspond to the DOM selection
	  var $from = selection.$anchor.min(selection.$head), $to = selection.$anchor.max(selection.$head);
	
	  if ($from.sameParent($to) && $from.parent.inlineContent && $from.parentOffset && $to.parentOffset < $to.parent.content.size) {
	    var startOff = Math.max(0, $from.parentOffset);
	    var size = $from.parent.content.size;
	    var endOff = Math.min(size, $to.parentOffset);
	
	    if (startOff > 0)
	      { startOff = $from.parent.childBefore(startOff).offset; }
	    if (endOff < size) {
	      var after = $from.parent.childAfter(endOff);
	      endOff = after.offset + after.node.nodeSize;
	    }
	    var nodeStart = $from.start();
	    return {from: nodeStart + startOff, to: nodeStart + endOff}
	  } else {
	    for (var depth = 0;; depth++) {
	      var fromStart = isAtStart($from, depth + 1), toEnd = isAtEnd($to, depth + 1);
	      if (fromStart || toEnd || $from.index(depth) != $to.index(depth) || $to.node(depth).isTextblock) {
	        var from = $from.before(depth + 1), to = $to.after(depth + 1);
	        if (fromStart && $from.index(depth) > 0)
	          { from -= $from.node(depth).child($from.index(depth) - 1).nodeSize; }
	        if (toEnd && $to.index(depth) + 1 < $to.node(depth).childCount)
	          { to += $to.node(depth).child($to.index(depth) + 1).nodeSize; }
	        return {from: from, to: to}
	      }
	    }
	  }
	}
	
	function readDOMChange(view, mapping, oldState, range, allowTypeOver) {
	  var parse = parseBetween(view, oldState, range);
	
	  var doc = oldState.doc, compare = doc.slice(parse.from, parse.to);
	  var preferredPos, preferredSide;
	  // Prefer anchoring to end when Backspace is pressed
	  if (view.lastKeyCode === 8 && Date.now() - 100 < view.lastKeyCodeTime) {
	    preferredPos = oldState.selection.to;
	    preferredSide = "end";
	  } else {
	    preferredPos = oldState.selection.from;
	    preferredSide = "start";
	  }
	  view.lastKeyCode = null;
	
	  var change = findDiff(compare.content, parse.doc.content, parse.from, preferredPos, preferredSide);
	  if (!change) {
	    if (allowTypeOver) {
	      var state = view.state, sel = state.selection;
	      view.dispatch(state.tr.replaceSelectionWith(state.schema.text(state.doc.textBetween(sel.from, sel.to)), true).scrollIntoView());
	    } else if (parse.sel) {
	      var sel$1 = resolveSelection(view, view.state.doc, mapping, parse.sel);
	      if (sel$1 && !sel$1.eq(view.state.selection)) { view.dispatch(view.state.tr.setSelection(sel$1)); }
	    }
	    return
	  }
	  view.domChangeCount++;
	  // Handle the case where overwriting a selection by typing matches
	  // the start or end of the selected content, creating a change
	  // that's smaller than what was actually overwritten.
	  if (oldState.selection.from < oldState.selection.to &&
	      change.start == change.endB &&
	      oldState.selection instanceof prosemirrorState.TextSelection) {
	    if (change.start > oldState.selection.from && change.start <= oldState.selection.from + 2) {
	      change.start = oldState.selection.from;
	    } else if (change.endA < oldState.selection.to && change.endA >= oldState.selection.to - 2) {
	      change.endB += (oldState.selection.to - change.endA);
	      change.endA = oldState.selection.to;
	    }
	  }
	
	  var $from = parse.doc.resolveNoCache(change.start - parse.from);
	  var $to = parse.doc.resolveNoCache(change.endB - parse.from);
	  var nextSel;
	  // If this looks like the effect of pressing Enter, just dispatch an
	  // Enter key instead.
	  if (!$from.sameParent($to) && $from.pos < parse.doc.content.size &&
	      (nextSel = prosemirrorState.Selection.findFrom(parse.doc.resolve($from.pos + 1), 1, true)) &&
	      nextSel.head == $to.pos &&
	      view.someProp("handleKeyDown", function (f) { return f(view, keyEvent(13, "Enter")); }))
	    { return }
	  // Same for backspace
	  if (oldState.selection.anchor > change.start &&
	      looksLikeJoin(doc, change.start, change.endA, $from, $to) &&
	      view.someProp("handleKeyDown", function (f) { return f(view, keyEvent(8, "Backspace")); })) {
	    if (result.android && result.chrome) { // #820
	      view.selectionReader.suppressUpdates = true;
	      setTimeout(function () { return view.selectionReader.suppressUpdates = false; }, 50);
	    }
	    return
	  }
	
	  var from = mapping.map(change.start), to = Math.max(from, mapping.map(change.endA, -1));
	
	  var tr, storedMarks, markChange, $from1;
	  if ($from.sameParent($to) && $from.parent.inlineContent) {
	    if ($from.pos == $to.pos) { // Deletion
	      tr = view.state.tr.delete(from, to);
	      storedMarks = doc.resolve(change.start).marksAcross(doc.resolve(change.endA));
	    } else if ( // Adding or removing a mark
	      change.endA == change.endB && ($from1 = doc.resolve(change.start)) &&
	      (markChange = isMarkChange($from.parent.content.cut($from.parentOffset, $to.parentOffset),
	                                 $from1.parent.content.cut($from1.parentOffset, change.endA - $from1.start())))
	    ) {
	      tr = view.state.tr;
	      if (markChange.type == "add") { tr.addMark(from, to, markChange.mark); }
	      else { tr.removeMark(from, to, markChange.mark); }
	    } else if ($from.parent.child($from.index()).isText && $from.index() == $to.index() - ($to.textOffset ? 0 : 1)) {
	      // Both positions in the same text node -- simply insert text
	      var text = $from.parent.textBetween($from.parentOffset, $to.parentOffset);
	      if (view.someProp("handleTextInput", function (f) { return f(view, from, to, text); })) { return }
	      tr = view.state.tr.insertText(text, from, to);
	    }
	  }
	
	  if (!tr)
	    { tr = view.state.tr.replace(from, to, parse.doc.slice(change.start - parse.from, change.endB - parse.from)); }
	  if (parse.sel) {
	    var sel$2 = resolveSelection(view, tr.doc, mapping, parse.sel);
	    if (sel$2) { tr.setSelection(sel$2); }
	  }
	  if (storedMarks) { tr.ensureMarks(storedMarks); }
	  view.dispatch(tr.scrollIntoView());
	}
	
	function resolveSelection(view, doc, mapping, parsedSel) {
	  if (Math.max(parsedSel.anchor, parsedSel.head) > doc.content.size) { return null }
	  return selectionBetween(view, doc.resolve(mapping.map(parsedSel.anchor)),
	                          doc.resolve(mapping.map(parsedSel.head)))
	}
	
	// : (Fragment, Fragment) → ?{mark: Mark, type: string}
	// Given two same-length, non-empty fragments of inline content,
	// determine whether the first could be created from the second by
	// removing or adding a single mark type.
	function isMarkChange(cur, prev) {
	  var curMarks = cur.firstChild.marks, prevMarks = prev.firstChild.marks;
	  var added = curMarks, removed = prevMarks, type, mark, update;
	  for (var i = 0; i < prevMarks.length; i++) { added = prevMarks[i].removeFromSet(added); }
	  for (var i$1 = 0; i$1 < curMarks.length; i$1++) { removed = curMarks[i$1].removeFromSet(removed); }
	  if (added.length == 1 && removed.length == 0) {
	    mark = added[0];
	    type = "add";
	    update = function (node) { return node.mark(mark.addToSet(node.marks)); };
	  } else if (added.length == 0 && removed.length == 1) {
	    mark = removed[0];
	    type = "remove";
	    update = function (node) { return node.mark(mark.removeFromSet(node.marks)); };
	  } else {
	    return null
	  }
	  var updated = [];
	  for (var i$2 = 0; i$2 < prev.childCount; i$2++) { updated.push(update(prev.child(i$2))); }
	  if (prosemirrorModel.Fragment.from(updated).eq(cur)) { return {mark: mark, type: type} }
	}
	
	function looksLikeJoin(old, start, end, $newStart, $newEnd) {
	  if (!$newStart.parent.isTextblock ||
	      // The content must have shrunk
	      end - start <= $newEnd.pos - $newStart.pos ||
	      // newEnd must point directly at or after the end of the block that newStart points into
	      skipClosingAndOpening($newStart, true, false) < $newEnd.pos)
	    { return false }
	
	  var $start = old.resolve(start);
	  // Start must be at the end of a block
	  if ($start.parentOffset < $start.parent.content.size || !$start.parent.isTextblock)
	    { return false }
	  var $next = old.resolve(skipClosingAndOpening($start, true, true));
	  // The next textblock must start before end and end near it
	  if (!$next.parent.isTextblock || $next.pos > end ||
	      skipClosingAndOpening($next, true, false) < end)
	    { return false }
	
	  // The fragments after the join point must match
	  return $newStart.parent.content.cut($newStart.parentOffset).eq($next.parent.content)
	}
	
	function skipClosingAndOpening($pos, fromEnd, mayOpen) {
	  var depth = $pos.depth, end = fromEnd ? $pos.end() : $pos.pos;
	  while (depth > 0 && (fromEnd || $pos.indexAfter(depth) == $pos.node(depth).childCount)) {
	    depth--;
	    end++;
	    fromEnd = false;
	  }
	  if (mayOpen) {
	    var next = $pos.node(depth).maybeChild($pos.indexAfter(depth));
	    while (next && !next.isLeaf) {
	      next = next.firstChild;
	      end++;
	    }
	  }
	  return end
	}
	
	function findDiff(a, b, pos, preferredPos, preferredSide) {
	  var start = a.findDiffStart(b, pos);
	  if (start == null) { return null }
	  var ref = a.findDiffEnd(b, pos + a.size, pos + b.size);
	  var endA = ref.a;
	  var endB = ref.b;
	  if (preferredSide == "end") {
	    var adjust = Math.max(0, start - Math.min(endA, endB));
	    preferredPos -= endA + adjust - start;
	  }
	  if (endA < start && a.size < b.size) {
	    var move = preferredPos <= start && preferredPos >= endA ? start - preferredPos : 0;
	    start -= move;
	    endB = start + (endB - endA);
	    endA = start;
	  } else if (endB < start) {
	    var move$1 = preferredPos <= start && preferredPos >= endB ? start - preferredPos : 0;
	    start -= move$1;
	    endA = start + (endA - endB);
	    endB = start;
	  }
	  return {start: start, endA: endA, endB: endB}
	}
	
	function serializeForClipboard(view, slice) {
	  var context = [];
	  var content = slice.content;
	  var openStart = slice.openStart;
	  var openEnd = slice.openEnd;
	  while (openStart > 1 && openEnd > 1 && content.childCount == 1 && content.firstChild.childCount == 1) {
	    openStart--;
	    openEnd--;
	    var node = content.firstChild;
	    context.push(node.type.name, node.type.hasRequiredAttrs() ? node.attrs : null);
	    content = node.content;
	  }
	
	  var serializer = view.someProp("clipboardSerializer") || prosemirrorModel.DOMSerializer.fromSchema(view.state.schema);
	  var wrap = document.createElement("div");
	  wrap.appendChild(serializer.serializeFragment(content));
	
	  var firstChild = wrap.firstChild, needsWrap;
	  while (firstChild && firstChild.nodeType == 1 && (needsWrap = wrapMap[firstChild.nodeName.toLowerCase()])) {
	    for (var i = needsWrap.length - 1; i >= 0; i--) {
	      var wrapper = document.createElement(needsWrap[i]);
	      while (wrap.firstChild) { wrapper.appendChild(wrap.firstChild); }
	      wrap.appendChild(wrapper);
	    }
	    firstChild = wrap.firstChild;
	  }
	
	  if (firstChild && firstChild.nodeType == 1)
	    { firstChild.setAttribute("data-pm-slice", (openStart + " " + openEnd + " " + (JSON.stringify(context)))); }
	
	  var text = view.someProp("clipboardTextSerializer", function (f) { return f(slice); }) ||
	      slice.content.textBetween(0, slice.content.size, "\n\n");
	
	  return {dom: wrap, text: text}
	}
	
	// : (EditorView, string, string, ?bool, ResolvedPos) → ?Slice
	// Read a slice of content from the clipboard (or drop data).
	function parseFromClipboard(view, text, html, plainText, $context) {
	  var dom, inCode = $context.parent.type.spec.code, slice;
	  if (!html && !text) { return null }
	  var asText = text && (plainText || inCode || !html);
	  if (asText) {
	    view.someProp("transformPastedText", function (f) { text = f(text); });
	    if (inCode) { return new prosemirrorModel.Slice(prosemirrorModel.Fragment.from(view.state.schema.text(text)), 0, 0) }
	    var parsed = view.someProp("clipboardTextParser", function (f) { return f(text, $context); });
	    if (parsed) {
	      slice = parsed;
	    } else {
	      dom = document.createElement("div");
	      text.trim().split(/(?:\r\n?|\n)+/).forEach(function (block) {
	        dom.appendChild(document.createElement("p")).textContent = block;
	      });
	    }
	  } else {
	    view.someProp("transformPastedHTML", function (f) { html = f(html); });
	    dom = readHTML(html);
	  }
	
	  var contextNode = dom && dom.querySelector("[data-pm-slice]");
	  var sliceData = contextNode && /^(\d+) (\d+) (.*)/.exec(contextNode.getAttribute("data-pm-slice"));
	  if (!slice) {
	    var parser = view.someProp("clipboardParser") || view.someProp("domParser") || prosemirrorModel.DOMParser.fromSchema(view.state.schema);
	    slice = parser.parseSlice(dom, {preserveWhitespace: !!(asText || sliceData), context: $context});
	  }
	  if (sliceData)
	    { slice = addContext(new prosemirrorModel.Slice(slice.content, Math.min(slice.openStart, +sliceData[1]),
	                                 Math.min(slice.openEnd, +sliceData[2])), sliceData[3]); }
	  else // HTML wasn't created by ProseMirror. Make sure top-level siblings are coherent
	    { slice = prosemirrorModel.Slice.maxOpen(normalizeSiblings(slice.content, $context), false); }
	  view.someProp("transformPasted", function (f) { slice = f(slice); });
	  return slice
	}
	
	// Takes a slice parsed with parseSlice, which means there hasn't been
	// any content-expression checking done on the top nodes, tries to
	// find a parent node in the current context that might fit the nodes,
	// and if successful, rebuilds the slice so that it fits into that parent.
	//
	// This addresses the problem that Transform.replace expects a
	// coherent slice, and will fail to place a set of siblings that don't
	// fit anywhere in the schema.
	function normalizeSiblings(fragment, $context) {
	  if (fragment.childCount < 2) { return fragment }
	  var loop = function ( d ) {
	    var parent = $context.node(d);
	    var match = parent.contentMatchAt($context.index(d));
	    var lastWrap = (void 0), result = [];
	    fragment.forEach(function (node) {
	      if (!result) { return }
	      var wrap = match.findWrapping(node.type), inLast;
	      if (!wrap) { return result = null }
	      if (inLast = result.length && lastWrap.length && addToSibling(wrap, lastWrap, node, result[result.length - 1], 0)) {
	        result[result.length - 1] = inLast;
	      } else {
	        if (result.length) { result[result.length - 1] = closeRight(result[result.length - 1], lastWrap.length); }
	        var wrapped = withWrappers(node, wrap);
	        result.push(wrapped);
	        match = match.matchType(wrapped.type, wrapped.attrs);
	        lastWrap = wrap;
	      }
	    });
	    if (result) { return { v: prosemirrorModel.Fragment.from(result) } }
	  };
	
	  for (var d = $context.depth; d >= 0; d--) {
	    var returned = loop( d );
	
	    if ( returned ) return returned.v;
	  }
	  return fragment
	}
	
	function withWrappers(node, wrap, from) {
	  if ( from === void 0 ) from = 0;
	
	  for (var i = wrap.length - 1; i >= from; i--)
	    { node = wrap[i].create(null, prosemirrorModel.Fragment.from(node)); }
	  return node
	}
	
	// Used to group adjacent nodes wrapped in similar parents by
	// normalizeSiblings into the same parent node
	function addToSibling(wrap, lastWrap, node, sibling, depth) {
	  if (depth < wrap.length && depth < lastWrap.length && wrap[depth] == lastWrap[depth]) {
	    var inner = addToSibling(wrap, lastWrap, node, sibling.lastChild, depth + 1);
	    if (inner) { return sibling.copy(sibling.content.replaceChild(sibling.childCount - 1, inner)) }
	    var match = sibling.contentMatchAt(sibling.childCount);
	    if (match.matchType(depth == wrap.length - 1 ? node.type : wrap[depth + 1]))
	      { return sibling.copy(sibling.content.append(prosemirrorModel.Fragment.from(withWrappers(node, wrap, depth + 1)))) }
	  }
	}
	
	function closeRight(node, depth) {
	  if (depth == 0) { return node }
	  var fragment = node.content.replaceChild(node.childCount - 1, closeRight(node.lastChild, depth - 1));
	  var fill = node.contentMatchAt(node.childCount).fillBefore(prosemirrorModel.Fragment.empty, true);
	  return node.copy(fragment.append(fill))
	}
	
	// Trick from jQuery -- some elements must be wrapped in other
	// elements for innerHTML to work. I.e. if you do `div.innerHTML =
	// "<td>..</td>"` the table cells are ignored.
	var wrapMap = {thead: ["table"], colgroup: ["table"], col: ["table", "colgroup"],
	                 tr: ["table", "tbody"], td: ["table", "tbody", "tr"], th: ["table", "tbody", "tr"]};
	var detachedDoc = null;
	function readHTML(html) {
	  var metas = /(\s*<meta [^>]*>)*/.exec(html);
	  if (metas) { html = html.slice(metas[0].length); }
	  var doc = detachedDoc || (detachedDoc = document.implementation.createHTMLDocument("title"));
	  var elt = doc.createElement("div");
	  var firstTag = /(?:<meta [^>]*>)*<([a-z][^>\s]+)/i.exec(html), wrap, depth = 0;
	  if (wrap = firstTag && wrapMap[firstTag[1].toLowerCase()]) {
	    html = wrap.map(function (n) { return "<" + n + ">"; }).join("") + html + wrap.map(function (n) { return "</" + n + ">"; }).reverse().join("");
	    depth = wrap.length;
	  }
	  elt.innerHTML = html;
	  for (var i = 0; i < depth; i++) { elt = elt.firstChild; }
	  return elt
	}
	
	function addContext(slice, context) {
	  if (!slice.size) { return slice }
	  var schema = slice.content.firstChild.type.schema, array;
	  try { array = JSON.parse(context); }
	  catch(e) { return slice }
	  var content = slice.content;
	  var openStart = slice.openStart;
	  var openEnd = slice.openEnd;
	  for (var i = array.length - 2; i >= 0; i -= 2) {
	    var type = schema.nodes[array[i]];
	    if (!type || type.hasRequiredAttrs()) { break }
	    content = prosemirrorModel.Fragment.from(type.create(array[i + 1], content));
	    openStart++; openEnd++;
	  }
	  return new prosemirrorModel.Slice(content, openStart, openEnd)
	}
	
	var observeOptions = {childList: true, characterData: true, attributes: true, subtree: true, characterDataOldValue: true};
	// IE11 has very broken mutation observers, so we also listen to DOMCharacterDataModified
	var useCharData = result.ie && result.ie_version <= 11;
	
	var DOMObserver = function DOMObserver(view) {
	  var this$1 = this;
	
	  this.view = view;
	  this.observer = window.MutationObserver &&
	    new window.MutationObserver(function (mutations) { return this$1.registerMutations(mutations); });
	  if (useCharData)
	    { this.onCharData = function (e) { return this$1.registerMutation({target: e.target, type: "characterData", oldValue: e.prevValue}); }; }
	};
	
	DOMObserver.prototype.start = function start () {
	  if (this.observer)
	    { this.observer.observe(this.view.dom, observeOptions); }
	  if (useCharData)
	    { this.view.dom.addEventListener("DOMCharacterDataModified", this.onCharData); }
	};
	
	DOMObserver.prototype.stop = function stop () {
	  if (this.observer) {
	    this.flush();
	    this.observer.disconnect();
	  }
	  if (useCharData)
	    { this.view.dom.removeEventListener("DOMCharacterDataModified", this.onCharData); }
	};
	
	DOMObserver.prototype.flush = function flush () {
	  if (this.observer)
	    { this.registerMutations(this.observer.takeRecords()); }
	};
	
	DOMObserver.prototype.registerMutations = function registerMutations (mutations) {
	    var this$1 = this;
	
	  for (var i = 0; i < mutations.length; i++)
	    { this$1.registerMutation(mutations[i]); }
	};
	
	DOMObserver.prototype.registerMutation = function registerMutation (mut) {
	  if (!this.view.editable) { return }
	  var desc = this.view.docView.nearestDesc(mut.target);
	  if (mut.type == "attributes" &&
	      (desc == this.view.docView || mut.attributeName == "contenteditable")) { return }
	  if (!desc || desc.ignoreMutation(mut)) { return }
	
	  var from, to;
	  if (mut.type == "childList") {
	    var fromOffset = mut.previousSibling && mut.previousSibling.parentNode == mut.target
	        ? domIndex(mut.previousSibling) + 1 : 0;
	    if (fromOffset == -1) { return }
	    from = desc.localPosFromDOM(mut.target, fromOffset, -1);
	    var toOffset = mut.nextSibling && mut.nextSibling.parentNode == mut.target
	        ? domIndex(mut.nextSibling) : mut.target.childNodes.length;
	    if (toOffset == -1) { return }
	    to = desc.localPosFromDOM(mut.target, toOffset, 1);
	  } else if (mut.type == "attributes") {
	    from = desc.posAtStart - desc.border;
	    to = desc.posAtEnd + desc.border;
	  } else { // "characterData"
	    from = desc.posAtStart;
	    to = desc.posAtEnd;
	    // An event was generated for a text change that didn't change
	    // any text. Mark the dom change to fall back to assuming the
	    // selection was typed over with an identical value if it can't
	    // find another change.
	    if (mut.target.nodeValue == mut.oldValue) { DOMChange.start(this.view).typeOver = true; }
	  }
	
	  DOMChange.start(this.view).addRange(from, to);
	};
	
	// A collection of DOM events that occur within the editor, and callback functions
	// to invoke when the event fires.
	var handlers = {};
	var editHandlers = {};
	
	function initInput(view) {
	  view.shiftKey = false;
	  view.mouseDown = null;
	  view.inDOMChange = null;
	  view.lastKeyCode = null;
	  view.lastKeyCodeTime = 0;
	  view.lastClick = {time: 0, x: 0, y: 0, type: ""};
	  view.domObserver = new DOMObserver(view);
	  view.domObserver.start();
	  // Used by hacks like the beforeinput handler to check whether anything happened in the DOM
	  view.domChangeCount = 0;
	
	  view.eventHandlers = Object.create(null);
	  var loop = function ( event ) {
	    var handler = handlers[event];
	    view.dom.addEventListener(event, view.eventHandlers[event] = function (event) {
	      if (eventBelongsToView(view, event) && !runCustomHandler(view, event) &&
	          (view.editable || !(event.type in editHandlers)))
	        { handler(view, event); }
	    });
	  };
	
	  for (var event in handlers) loop( event );
	  ensureListeners(view);
	}
	
	function destroyInput(view) {
	  view.domObserver.stop();
	  if (view.inDOMChange) { view.inDOMChange.destroy(); }
	  for (var type in view.eventHandlers)
	    { view.dom.removeEventListener(type, view.eventHandlers[type]); }
	}
	
	function ensureListeners(view) {
	  view.someProp("handleDOMEvents", function (currentHandlers) {
	    for (var type in currentHandlers) { if (!view.eventHandlers[type])
	      { view.dom.addEventListener(type, view.eventHandlers[type] = function (event) { return runCustomHandler(view, event); }); } }
	  });
	}
	
	function runCustomHandler(view, event) {
	  return view.someProp("handleDOMEvents", function (handlers) {
	    var handler = handlers[event.type];
	    return handler ? handler(view, event) || event.defaultPrevented : false
	  })
	}
	
	function eventBelongsToView(view, event) {
	  if (!event.bubbles) { return true }
	  if (event.defaultPrevented) { return false }
	  for (var node = event.target; node != view.dom; node = node.parentNode)
	    { if (!node || node.nodeType == 11 ||
	        (node.pmViewDesc && node.pmViewDesc.stopEvent(event)))
	      { return false } }
	  return true
	}
	
	function dispatchEvent(view, event) {
	  if (!runCustomHandler(view, event) && handlers[event.type] &&
	      (view.editable || !(event.type in editHandlers)))
	    { handlers[event.type](view, event); }
	}
	
	editHandlers.keydown = function (view, event) {
	  view.shiftKey = event.keyCode == 16 || event.shiftKey;
	  if (view.inDOMChange) {
	    if (view.inDOMChange.composing) { return }
	    if (view.inDOMChange.ignoreKeyDownOnCompositionEnd(event)) { return }
	    view.inDOMChange.finish();
	  }
	  view.lastKeyCode = event.keyCode;
	  view.lastKeyCodeTime = Date.now();
	  if (view.someProp("handleKeyDown", function (f) { return f(view, event); }) || captureKeyDown(view, event))
	    { event.preventDefault(); }
	  else
	    { view.selectionReader.poll("key"); }
	};
	
	editHandlers.keyup = function (view, e) {
	  if (e.keyCode == 16) { view.shiftKey = false; }
	};
	
	editHandlers.keypress = function (view, event) {
	  if (view.inDOMChange || !event.charCode ||
	      event.ctrlKey && !event.altKey || result.mac && event.metaKey) { return }
	
	  if (view.someProp("handleKeyPress", function (f) { return f(view, event); })) {
	    event.preventDefault();
	    return
	  }
	
	  var sel = view.state.selection;
	  if (!(sel instanceof prosemirrorState.TextSelection) || !sel.$from.sameParent(sel.$to)) {
	    var text = String.fromCharCode(event.charCode);
	    if (!view.someProp("handleTextInput", function (f) { return f(view, sel.$from.pos, sel.$to.pos, text); }))
	      { view.dispatch(view.state.tr.insertText(text).scrollIntoView()); }
	    event.preventDefault();
	  }
	};
	
	function eventCoords(event) { return {left: event.clientX, top: event.clientY} }
	
	function isNear(event, click) {
	  var dx = click.x - event.clientX, dy = click.y - event.clientY;
	  return dx * dx + dy * dy < 100
	}
	
	function runHandlerOnContext(view, propName, pos, inside, event) {
	  if (inside == -1) { return false }
	  var $pos = view.state.doc.resolve(inside);
	  var loop = function ( i ) {
	    if (view.someProp(propName, function (f) { return i > $pos.depth ? f(view, pos, $pos.nodeAfter, $pos.before(i), event, true)
	                                                    : f(view, pos, $pos.node(i), $pos.before(i), event, false); }))
	      { return { v: true } }
	  };
	
	  for (var i = $pos.depth + 1; i > 0; i--) {
	    var returned = loop( i );
	
	    if ( returned ) return returned.v;
	  }
	  return false
	}
	
	function updateSelection(view, selection, origin) {
	  if (!view.focused) { view.focus(); }
	  var tr = view.state.tr.setSelection(selection);
	  if (origin == "pointer") { tr.setMeta("pointer", true); }
	  view.dispatch(tr);
	}
	
	function selectClickedLeaf(view, inside) {
	  if (inside == -1) { return false }
	  var $pos = view.state.doc.resolve(inside), node = $pos.nodeAfter;
	  if (node && node.isAtom && prosemirrorState.NodeSelection.isSelectable(node)) {
	    updateSelection(view, new prosemirrorState.NodeSelection($pos), "pointer");
	    return true
	  }
	  return false
	}
	
	function selectClickedNode(view, inside) {
	  if (inside == -1) { return false }
	  var sel = view.state.selection, selectedNode, selectAt;
	  if (sel instanceof prosemirrorState.NodeSelection) { selectedNode = sel.node; }
	
	  var $pos = view.state.doc.resolve(inside);
	  for (var i = $pos.depth + 1; i > 0; i--) {
	    var node = i > $pos.depth ? $pos.nodeAfter : $pos.node(i);
	    if (prosemirrorState.NodeSelection.isSelectable(node)) {
	      if (selectedNode && sel.$from.depth > 0 &&
	          i >= sel.$from.depth && $pos.before(sel.$from.depth + 1) == sel.$from.pos)
	        { selectAt = $pos.before(sel.$from.depth); }
	      else
	        { selectAt = $pos.before(i); }
	      break
	    }
	  }
	
	  if (selectAt != null) {
	    updateSelection(view, prosemirrorState.NodeSelection.create(view.state.doc, selectAt), "pointer");
	    return true
	  } else {
	    return false
	  }
	}
	
	function handleSingleClick(view, pos, inside, event, selectNode) {
	  return runHandlerOnContext(view, "handleClickOn", pos, inside, event) ||
	    view.someProp("handleClick", function (f) { return f(view, pos, event); }) ||
	    (selectNode ? selectClickedNode(view, inside) : selectClickedLeaf(view, inside))
	}
	
	function handleDoubleClick(view, pos, inside, event) {
	  return runHandlerOnContext(view, "handleDoubleClickOn", pos, inside, event) ||
	    view.someProp("handleDoubleClick", function (f) { return f(view, pos, event); })
	}
	
	function handleTripleClick(view, pos, inside, event) {
	  return runHandlerOnContext(view, "handleTripleClickOn", pos, inside, event) ||
	    view.someProp("handleTripleClick", function (f) { return f(view, pos, event); }) ||
	    defaultTripleClick(view, inside)
	}
	
	function defaultTripleClick(view, inside) {
	  var doc = view.state.doc;
	  if (inside == -1) {
	    if (doc.inlineContent) {
	      updateSelection(view, prosemirrorState.TextSelection.create(doc, 0, doc.content.size), "pointer");
	      return true
	    }
	    return false
	  }
	
	  var $pos = doc.resolve(inside);
	  for (var i = $pos.depth + 1; i > 0; i--) {
	    var node = i > $pos.depth ? $pos.nodeAfter : $pos.node(i);
	    var nodePos = $pos.before(i);
	    if (node.inlineContent)
	      { updateSelection(view, prosemirrorState.TextSelection.create(doc, nodePos + 1, nodePos + 1 + node.content.size), "pointer"); }
	    else if (prosemirrorState.NodeSelection.isSelectable(node))
	      { updateSelection(view, prosemirrorState.NodeSelection.create(doc, nodePos), "pointer"); }
	    else
	      { continue }
	    return true
	  }
	}
	
	function forceDOMFlush(view) {
	  if (!view.inDOMChange) { return false }
	  view.inDOMChange.finish(true);
	  return true
	}
	
	var selectNodeModifier = result.mac ? "metaKey" : "ctrlKey";
	
	handlers.mousedown = function (view, event) {
	  view.shiftKey = event.shiftKey;
	  var flushed = forceDOMFlush(view);
	  var now = Date.now(), type = "singleClick";
	  if (now - view.lastClick.time < 500 && isNear(event, view.lastClick) && !event[selectNodeModifier]) {
	    if (view.lastClick.type == "singleClick") { type = "doubleClick"; }
	    else if (view.lastClick.type == "doubleClick") { type = "tripleClick"; }
	  }
	  view.lastClick = {time: now, x: event.clientX, y: event.clientY, type: type};
	
	  var pos = view.posAtCoords(eventCoords(event));
	  if (!pos) { return }
	
	  if (type == "singleClick")
	    { view.mouseDown = new MouseDown(view, pos, event, flushed); }
	  else if ((type == "doubleClick" ? handleDoubleClick : handleTripleClick)(view, pos.pos, pos.inside, event))
	    { event.preventDefault(); }
	  else
	    { view.selectionReader.poll("pointer"); }
	};
	
	var MouseDown = function MouseDown(view, pos, event, flushed) {
	  var this$1 = this;
	
	  this.view = view;
	  this.pos = pos;
	  this.event = event;
	  this.flushed = flushed;
	  this.selectNode = event[selectNodeModifier];
	  this.allowDefault = event.shiftKey;
	
	  var targetNode, targetPos;
	  if (pos.inside > -1) {
	    targetNode = view.state.doc.nodeAt(pos.inside);
	    targetPos = pos.inside;
	  } else {
	    var $pos = view.state.doc.resolve(pos.pos);
	    targetNode = $pos.parent;
	    targetPos = $pos.depth ? $pos.before() : 0;
	  }
	
	  this.mightDrag = null;
	
	  var target = flushed ? null : event.target;
	  var targetDesc = target ? view.docView.nearestDesc(target, true) : null;
	  this.target = targetDesc ? targetDesc.dom : null;
	
	  if (targetNode.type.spec.draggable && targetNode.type.spec.selectable !== false ||
	      view.state.selection instanceof prosemirrorState.NodeSelection && targetPos == view.state.selection.from)
	    { this.mightDrag = {node: targetNode,
	                      pos: targetPos,
	                      addAttr: this.target && !this.target.draggable,
	                      setUneditable: this.target && result.gecko && !this.target.hasAttribute("contentEditable")}; }
	
	  if (this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable)) {
	    this.view.domObserver.stop();
	    if (this.mightDrag.addAttr) { this.target.draggable = true; }
	    if (this.mightDrag.setUneditable)
	      { setTimeout(function () { return this$1.target.setAttribute("contentEditable", "false"); }, 20); }
	    this.view.domObserver.start();
	  }
	
	  view.root.addEventListener("mouseup", this.up = this.up.bind(this));
	  view.root.addEventListener("mousemove", this.move = this.move.bind(this));
	  view.selectionReader.poll("pointer");
	};
	
	MouseDown.prototype.done = function done () {
	  this.view.root.removeEventListener("mouseup", this.up);
	  this.view.root.removeEventListener("mousemove", this.move);
	  if (this.mightDrag && this.target) {
	    this.view.domObserver.stop();
	    if (this.mightDrag.addAttr) { this.target.draggable = false; }
	    if (this.mightDrag.setUneditable) { this.target.removeAttribute("contentEditable"); }
	    this.view.domObserver.start();
	  }
	  this.view.mouseDown = null;
	};
	
	MouseDown.prototype.up = function up (event) {
	  this.done();
	
	  if (!this.view.dom.contains(event.target.nodeType == 3 ? event.target.parentNode : event.target))
	    { return }
	
	  if (this.allowDefault) {
	    // Force a cursor wrapper redraw if this was suppressed (to avoid an issue with IE drag-selection)
	    if (result.ie && needsCursorWrapper(this.view.state)) { this.view.updateState(this.view.state); }
	    this.view.selectionReader.poll("pointer");
	  } else if (handleSingleClick(this.view, this.pos.pos, this.pos.inside, event, this.selectNode)) {
	    event.preventDefault();
	  } else if (this.flushed ||
	             // Chrome will sometimes treat a node selection as a
	             // cursor, but still report that the node is selected
	             // when asked through getSelection. You'll then get a
	             // situation where clicking at the point where that
	             // (hidden) cursor is doesn't change the selection, and
	             // thus doesn't get a reaction from ProseMirror. This
	             // works around that.
	             (result.chrome && !(this.view.state.selection instanceof prosemirrorState.TextSelection) &&
	              (this.pos.pos == this.view.state.selection.from || this.pos.pos == this.view.state.selection.to))) {
	    updateSelection(this.view, prosemirrorState.Selection.near(this.view.state.doc.resolve(this.pos.pos)), "pointer");
	    event.preventDefault();
	  } else {
	    this.view.selectionReader.poll("pointer");
	  }
	};
	
	MouseDown.prototype.move = function move (event) {
	  if (!this.allowDefault && (Math.abs(this.event.x - event.clientX) > 4 ||
	                             Math.abs(this.event.y - event.clientY) > 4))
	    { this.allowDefault = true; }
	  this.view.selectionReader.poll("pointer");
	};
	
	handlers.touchdown = function (view) {
	  forceDOMFlush(view);
	  view.selectionReader.poll("pointer");
	};
	
	handlers.contextmenu = function (view) { return forceDOMFlush(view); };
	
	// Input compositions are hard. Mostly because the events fired by
	// browsers are A) very unpredictable and inconsistent, and B) not
	// cancelable.
	//
	// ProseMirror has the problem that it must not update the DOM during
	// a composition, or the browser will cancel it. What it does is keep
	// long-running operations (delayed DOM updates) when a composition is
	// active.
	//
	// We _do not_ trust the information in the composition events which,
	// apart from being very uninformative to begin with, is often just
	// plain wrong. Instead, when a composition ends, we parse the dom
	// around the original selection, and derive an update from that.
	
	editHandlers.compositionstart = editHandlers.compositionupdate = function (view) {
	  DOMChange.start(view, true);
	};
	
	editHandlers.compositionend = function (view, e) {
	  if (!view.inDOMChange) {
	    // We received a compositionend without having seen any previous
	    // events for the composition. If there's data in the event
	    // object, we assume that it's a real change, and start a
	    // composition. Otherwise, we just ignore it.
	    if (e.data) { DOMChange.start(view, true); }
	    else { return }
	  }
	
	  view.inDOMChange.compositionEnd(e);
	};
	
	editHandlers.input = function (view) {
	  var change = DOMChange.start(view);
	  if (!change.composing) { change.finish(); }
	};
	
	function captureCopy(view, dom) {
	  // The extra wrapper is somehow necessary on IE/Edge to prevent the
	  // content from being mangled when it is put onto the clipboard
	  var doc = dom.ownerDocument;
	  var wrap = doc.body.appendChild(doc.createElement("div"));
	  wrap.appendChild(dom);
	  wrap.style.cssText = "position: fixed; left: -10000px; top: 10px";
	  var sel = getSelection(), range = doc.createRange();
	  range.selectNodeContents(dom);
	  // Done because IE will fire a selectionchange moving the selection
	  // to its start when removeAllRanges is called and the editor still
	  // has focus (which will mess up the editor's selection state).
	  view.dom.blur();
	  sel.removeAllRanges();
	  sel.addRange(range);
	  setTimeout(function () {
	    doc.body.removeChild(wrap);
	    view.focus();
	  }, 50);
	}
	
	// This is very crude, but unfortunately both these browsers _pretend_
	// that they have a clipboard API—all the objects and methods are
	// there, they just don't work, and they are hard to test.
	var brokenClipboardAPI = (result.ie && result.ie_version < 15) ||
	      (result.ios && result.webkit_version < 604);
	
	handlers.copy = editHandlers.cut = function (view, e) {
	  var sel = view.state.selection, cut = e.type == "cut";
	  if (sel.empty) { return }
	
	  // IE and Edge's clipboard interface is completely broken
	  var data = brokenClipboardAPI ? null : e.clipboardData;
	  var slice = sel.content();
	  var ref = serializeForClipboard(view, slice);
	  var dom = ref.dom;
	  var text = ref.text;
	  if (data) {
	    e.preventDefault();
	    data.clearData();
	    data.setData("text/html", dom.innerHTML);
	    data.setData("text/plain", text);
	  } else {
	    captureCopy(view, dom);
	  }
	  if (cut) { view.dispatch(view.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut")); }
	};
	
	function sliceSingleNode(slice) {
	  return slice.openStart == 0 && slice.openEnd == 0 && slice.content.childCount == 1 ? slice.content.firstChild : null
	}
	
	function capturePaste(view, e) {
	  var doc = view.dom.ownerDocument;
	  var plainText = view.shiftKey || view.state.selection.$from.parent.type.spec.code;
	  var target = doc.body.appendChild(doc.createElement(plainText ? "textarea" : "div"));
	  if (!plainText) { target.contentEditable = "true"; }
	  target.style.cssText = "position: fixed; left: -10000px; top: 10px";
	  target.focus();
	  setTimeout(function () {
	    view.focus();
	    doc.body.removeChild(target);
	    if (plainText) { doPaste(view, target.value, null, e); }
	    else { doPaste(view, target.textContent, target.innerHTML, e); }
	  }, 50);
	}
	
	function doPaste(view, text, html, e) {
	  var slice = parseFromClipboard(view, text, html, view.shiftKey, view.state.selection.$from);
	  if (view.someProp("handlePaste", function (f) { return f(view, e, slice || prosemirrorModel.Slice.empty); }) || !slice) { return true }
	
	  var singleNode = sliceSingleNode(slice);
	  var tr = singleNode ? view.state.tr.replaceSelectionWith(singleNode, view.shiftKey) : view.state.tr.replaceSelection(slice);
	  view.dispatch(tr.scrollIntoView().setMeta("paste", true).setMeta("uiEvent", "paste"));
	  return true
	}
	
	editHandlers.paste = function (view, e) {
	  var data = brokenClipboardAPI ? null : e.clipboardData;
	  if (data && (doPaste(view, data.getData("text/plain"), data.getData("text/html"), e) || data.files.length > 0))
	    { e.preventDefault(); }
	  else
	    { capturePaste(view, e); }
	};
	
	var Dragging = function Dragging(slice, move) {
	  this.slice = slice;
	  this.move = move;
	};
	
	var dragCopyModifier = result.mac ? "altKey" : "ctrlKey";
	
	handlers.dragstart = function (view, e) {
	  var mouseDown = view.mouseDown;
	  if (mouseDown) { mouseDown.done(); }
	  if (!e.dataTransfer) { return }
	
	  var sel = view.state.selection;
	  var pos = sel.empty ? null : view.posAtCoords(eventCoords(e));
	  if (pos && pos.pos >= sel.from && pos.pos <= (sel instanceof prosemirrorState.NodeSelection ? sel.to - 1: sel.to)) {
	    // In selection
	  } else if (mouseDown && mouseDown.mightDrag) {
	    view.dispatch(view.state.tr.setSelection(prosemirrorState.NodeSelection.create(view.state.doc, mouseDown.mightDrag.pos)));
	  } else if (e.target && e.target.nodeType == 1) {
	    var desc = view.docView.nearestDesc(e.target, true);
	    if (!desc || !desc.node.type.spec.draggable || desc == view.docView) { return }
	    view.dispatch(view.state.tr.setSelection(prosemirrorState.NodeSelection.create(view.state.doc, desc.posBefore)));
	  }
	  var slice = view.state.selection.content();
	  var ref = serializeForClipboard(view, slice);
	  var dom = ref.dom;
	  var text = ref.text;
	  e.dataTransfer.clearData();
	  e.dataTransfer.setData(brokenClipboardAPI ? "Text" : "text/html", dom.innerHTML);
	  if (!brokenClipboardAPI) { e.dataTransfer.setData("text/plain", text); }
	  view.dragging = new Dragging(slice, !e[dragCopyModifier]);
	};
	
	handlers.dragend = function (view) {
	  window.setTimeout(function () { return view.dragging = null; }, 50);
	};
	
	editHandlers.dragover = editHandlers.dragenter = function (_, e) { return e.preventDefault(); };
	
	editHandlers.drop = function (view, e) {
	  var dragging = view.dragging;
	  view.dragging = null;
	
	  if (!e.dataTransfer) { return }
	
	  var eventPos = view.posAtCoords(eventCoords(e));
	  if (!eventPos) { return }
	  var $mouse = view.state.doc.resolve(eventPos.pos);
	  if (!$mouse) { return }
	  var slice = dragging && dragging.slice ||
	      parseFromClipboard(view, e.dataTransfer.getData(brokenClipboardAPI ? "Text" : "text/plain"),
	                         brokenClipboardAPI ? null : e.dataTransfer.getData("text/html"), false, $mouse);
	  if (!slice) { return }
	
	  e.preventDefault();
	  if (view.someProp("handleDrop", function (f) { return f(view, e, slice, dragging && dragging.move); })) { return }
	  var insertPos = slice ? prosemirrorTransform.dropPoint(view.state.doc, $mouse.pos, slice) : $mouse.pos;
	  if (insertPos == null) { insertPos = $mouse.pos; }
	
	  var tr = view.state.tr;
	  if (dragging && dragging.move) { tr.deleteSelection(); }
	
	  var pos = tr.mapping.map(insertPos);
	  var isNode = slice.openStart == 0 && slice.openEnd == 0 && slice.content.childCount == 1;
	  var beforeInsert = tr.doc;
	  if (isNode)
	    { tr.replaceRangeWith(pos, pos, slice.content.firstChild); }
	  else
	    { tr.replaceRange(pos, pos, slice); }
	  if (tr.doc.eq(beforeInsert)) { return }
	
	  var $pos = tr.doc.resolve(pos);
	  if (isNode && prosemirrorState.NodeSelection.isSelectable(slice.content.firstChild) &&
	      $pos.nodeAfter && $pos.nodeAfter.sameMarkup(slice.content.firstChild))
	    { tr.setSelection(new prosemirrorState.NodeSelection($pos)); }
	  else
	    { tr.setSelection(selectionBetween(view, $pos, tr.doc.resolve(tr.mapping.map(insertPos)))); }
	  view.focus();
	  view.dispatch(tr.setMeta("uiEvent", "drop"));
	};
	
	handlers.focus = function (view) {
	  if (!view.focused) {
	    view.dom.classList.add("ProseMirror-focused");
	    view.focused = true;
	  }
	};
	
	handlers.blur = function (view) {
	  if (view.focused) {
	    view.dom.classList.remove("ProseMirror-focused");
	    view.focused = false;
	  }
	};
	
	handlers.beforeinput = function (view, event) {
	  // We should probably do more with beforeinput events, but support
	  // is so spotty that I'm still waiting to see where they are going.
	
	  // Very specific hack to deal with backspace sometimes failing on
	  // Chrome Android when after an uneditable node.
	  if (result.chrome && result.android && event.inputType == "deleteContentBackward") {
	    var domChangeCount = view.domChangeCount;
	    setTimeout(function () {
	      if (view.domChangeCount != domChangeCount) { return } // Event already had some effect
	      // This bug tends to close the virtual keyboard, so we refocus
	      view.dom.blur();
	      view.focus();
	      if (view.someProp("handleKeyDown", function (f) { return f(view, keyEvent(8, "Backspace")); })) { return }
	      var ref = view.state.selection;
	      var $cursor = ref.$cursor;
	      // Crude approximation of backspace behavior when no command handled it
	      if ($cursor && $cursor.pos > 0) { view.dispatch(view.state.tr.delete($cursor.pos - 1, $cursor.pos).scrollIntoView()); }
	    }, 50);
	  }
	};
	
	// Make sure all handlers get registered
	for (var prop in editHandlers) { handlers[prop] = editHandlers[prop]; }
	
	function compareObjs(a, b) {
	  if (a == b) { return true }
	  for (var p in a) { if (a[p] !== b[p]) { return false } }
	  for (var p$1 in b) { if (!(p$1 in a)) { return false } }
	  return true
	}
	
	var WidgetType = function WidgetType(toDOM, spec) {
	  this.spec = spec || noSpec;
	  this.side = this.spec.side || 0;
	  this.toDOM = toDOM;
	};
	
	WidgetType.prototype.map = function map (mapping, span, offset, oldOffset) {
	  var ref = mapping.mapResult(span.from + oldOffset, this.side < 0 ? -1 : 1);
	    var pos = ref.pos;
	    var deleted = ref.deleted;
	  return deleted ? null : new Decoration(pos - offset, pos - offset, this)
	};
	
	WidgetType.prototype.valid = function valid () { return true };
	
	WidgetType.prototype.eq = function eq (other) {
	  return this == other ||
	    (other instanceof WidgetType &&
	     (this.spec.key && this.spec.key == other.spec.key ||
	      this.toDOM == other.toDOM && compareObjs(this.spec, other.spec)))
	};
	
	var InlineType = function InlineType(attrs, spec) {
	  this.spec = spec || noSpec;
	  this.attrs = attrs;
	};
	
	InlineType.prototype.map = function map (mapping, span, offset, oldOffset) {
	  var from = mapping.map(span.from + oldOffset, this.spec.inclusiveStart ? -1 : 1) - offset;
	  var to = mapping.map(span.to + oldOffset, this.spec.inclusiveEnd ? 1 : -1) - offset;
	  return from >= to ? null : new Decoration(from, to, this)
	};
	
	InlineType.prototype.valid = function valid (_, span) { return span.from < span.to };
	
	InlineType.prototype.eq = function eq (other) {
	  return this == other ||
	    (other instanceof InlineType && compareObjs(this.attrs, other.attrs) &&
	     compareObjs(this.spec, other.spec))
	};
	
	InlineType.is = function is (span) { return span.type instanceof InlineType };
	
	var NodeType = function NodeType(attrs, spec) {
	  this.spec = spec || noSpec;
	  this.attrs = attrs;
	};
	
	NodeType.prototype.map = function map (mapping, span, offset, oldOffset) {
	  var from = mapping.mapResult(span.from + oldOffset, 1);
	  if (from.deleted) { return null }
	  var to = mapping.mapResult(span.to + oldOffset, -1);
	  if (to.deleted || to.pos <= from.pos) { return null }
	  return new Decoration(from.pos - offset, to.pos - offset, this)
	};
	
	NodeType.prototype.valid = function valid (node, span) {
	  var ref = node.content.findIndex(span.from);
	    var index = ref.index;
	    var offset = ref.offset;
	  return offset == span.from && offset + node.child(index).nodeSize == span.to
	};
	
	NodeType.prototype.eq = function eq (other) {
	  return this == other ||
	    (other instanceof NodeType && compareObjs(this.attrs, other.attrs) &&
	     compareObjs(this.spec, other.spec))
	};
	
	// ::- Decoration objects can be provided to the view through the
	// [`decorations` prop](#view.EditorProps.decorations). They come in
	// several variants—see the static members of this class for details.
	var Decoration = function Decoration(from, to, type) {
	  // :: number
	  // The start position of the decoration.
	  this.from = from;
	  // :: number
	  // The end position. Will be the same as `from` for [widget
	  // decorations](#view.Decoration^widget).
	  this.to = to;
	  this.type = type;
	};
	
	var prototypeAccessors$2 = { spec: {} };
	
	Decoration.prototype.copy = function copy (from, to) {
	  return new Decoration(from, to, this.type)
	};
	
	Decoration.prototype.eq = function eq (other) {
	  return this.type.eq(other.type) && this.from == other.from && this.to == other.to
	};
	
	Decoration.prototype.map = function map (mapping, offset, oldOffset) {
	  return this.type.map(mapping, this, offset, oldOffset)
	};
	
	// :: (number, union<(view: EditorView, getPos: () → number) → dom.Node, dom.Node>, ?Object) → Decoration
	// Creates a widget decoration, which is a DOM node that's shown in
	// the document at the given position. It is recommended that you
	// delay rendering the widget by passing a function that will be
	// called when the widget is actually drawn in a view, but you can
	// also directly pass a DOM node. `getPos` can be used to find the
	// widget's current document position.
	//
	// spec::- These options are supported:
	//
	//   side:: ?number
	//   Controls which side of the document position this widget is
	//   associated with. When negative, it is drawn before a cursor
	//   at its position, and content inserted at that position ends
	//   up after the widget. When zero (the default) or positive, the
	//   widget is drawn after the cursor and content inserted there
	//   ends up before the widget.
	//
	//   When there are multiple widgets at a given position, their
	//   `side` values determine the order in which they appear. Those
	//   with lower values appear first. The ordering of widgets with
	//   the same `side` value is unspecified.
	//
	//   When `marks` is null, `side` also determines the marks that
	//   the widget is wrapped in—those of the node before when
	//   negative, those of the node after when positive.
	//
	//   marks:: ?[Mark]
	//   The precise set of marks to draw around the widget.
	//
	//   stopEvent:: ?(event: dom.Event) → bool
	//   Can be used to control which DOM events, when they bubble out
	//   of this widget, the editor view should ignore.
	//
	//   key:: ?string
	//   When comparing decorations of this type (in order to decide
	//   whether it needs to be redrawn), ProseMirror will by default
	//   compare the widget DOM node by identity. If you pass a key,
	//   that key will be compared instead, which can be useful when
	//   you generate decorations on the fly and don't want to store
	//   and reuse DOM nodes. Make sure that any widgets with the same
	//   key are interchangeable—if widgets differ in, for example,
	//   the behavior of some event handler, they should get
	//   different keys.
	Decoration.widget = function widget (pos, toDOM, spec) {
	  return new Decoration(pos, pos, new WidgetType(toDOM, spec))
	};
	
	// :: (number, number, DecorationAttrs, ?Object) → Decoration
	// Creates an inline decoration, which adds the given attributes to
	// each inline node between `from` and `to`.
	//
	// spec::- These options are recognized:
	//
	//   inclusiveStart:: ?bool
	//   Determines how the left side of the decoration is
	//   [mapped](#transform.Position_Mapping) when content is
	//   inserted directly at that position. By default, the decoration
	//   won't include the new content, but you can set this to `true`
	//   to make it inclusive.
	//
	//   inclusiveEnd:: ?bool
	//   Determines how the right side of the decoration is mapped.
	//   See
	//   [`inclusiveStart`](#view.Decoration^inline^spec.inclusiveStart).
	Decoration.inline = function inline (from, to, attrs, spec) {
	  return new Decoration(from, to, new InlineType(attrs, spec))
	};
	
	// :: (number, number, DecorationAttrs, ?Object) → Decoration
	// Creates a node decoration. `from` and `to` should point precisely
	// before and after a node in the document. That node, and only that
	// node, will receive the given attributes.
	Decoration.node = function node (from, to, attrs, spec) {
	  return new Decoration(from, to, new NodeType(attrs, spec))
	};
	
	// :: Object
	// The spec provided when creating this decoration. Can be useful
	// if you've stored extra information in that object.
	prototypeAccessors$2.spec.get = function () { return this.type.spec };
	
	Object.defineProperties( Decoration.prototype, prototypeAccessors$2 );
	
	// DecorationAttrs:: interface
	// A set of attributes to add to a decorated node. Most properties
	// simply directly correspond to DOM attributes of the same name,
	// which will be set to the property's value. These are exceptions:
	//
	//   class:: ?string
	//   A CSS class name or a space-separated set of class names to be
	//   _added_ to the classes that the node already had.
	//
	//   style:: ?string
	//   A string of CSS to be _added_ to the node's existing `style` property.
	//
	//   nodeName:: ?string
	//   When non-null, the target node is wrapped in a DOM element of
	//   this type (and the other attributes are applied to this element).
	
	var none = [];
	var noSpec = {};
	
	// ::- A collection of [decorations](#view.Decoration), organized in
	// such a way that the drawing algorithm can efficiently use and
	// compare them. This is a persistent data structure—it is not
	// modified, updates create a new value.
	var DecorationSet = function DecorationSet(local, children) {
	  this.local = local && local.length ? local : none;
	  this.children = children && children.length ? children : none;
	};
	
	// :: (Node, [Decoration]) → DecorationSet
	// Create a set of decorations, using the structure of the given
	// document.
	DecorationSet.create = function create (doc, decorations) {
	  return decorations.length ? buildTree(decorations, doc, 0, noSpec) : empty
	};
	
	// :: (?number, ?number, ?(spec: Object) → bool) → [Decoration]
	// Find all decorations in this set which touch the given range
	// (including decorations that start or end directly at the
	// boundaries) and match the given predicate on their spec. When
	// `start` and `end` are omitted, all decorations in the set are
	// considered. When `predicate` isn't given, all decorations are
	// asssumed to match.
	DecorationSet.prototype.find = function find (start, end, predicate) {
	  var result = [];
	  this.findInner(start == null ? 0 : start, end == null ? 1e9 : end, result, 0, predicate);
	  return result
	};
	
	DecorationSet.prototype.findInner = function findInner (start, end, result, offset, predicate) {
	    var this$1 = this;
	
	  for (var i = 0; i < this.local.length; i++) {
	    var span = this$1.local[i];
	    if (span.from <= end && span.to >= start && (!predicate || predicate(span.spec)))
	      { result.push(span.copy(span.from + offset, span.to + offset)); }
	  }
	  for (var i$1 = 0; i$1 < this.children.length; i$1 += 3) {
	    if (this$1.children[i$1] < end && this$1.children[i$1 + 1] > start) {
	      var childOff = this$1.children[i$1] + 1;
	      this$1.children[i$1 + 2].findInner(start - childOff, end - childOff, result, offset + childOff, predicate);
	    }
	  }
	};
	
	// :: (Mapping, Node, ?Object) → DecorationSet
	// Map the set of decorations in response to a change in the
	// document.
	//
	// options::- An optional set of options.
	//
	//   onRemove:: ?(decorationSpec: Object)
	//   When given, this function will be called for each decoration
	//   that gets dropped as a result of the mapping, passing the
	//   spec of that decoration.
	DecorationSet.prototype.map = function map (mapping, doc, options) {
	  if (this == empty || mapping.maps.length == 0) { return this }
	  return this.mapInner(mapping, doc, 0, 0, options || noSpec)
	};
	
	DecorationSet.prototype.mapInner = function mapInner (mapping, node, offset, oldOffset, options) {
	    var this$1 = this;
	
	  var newLocal;
	  for (var i = 0; i < this.local.length; i++) {
	    var mapped = this$1.local[i].map(mapping, offset, oldOffset);
	    if (mapped && mapped.type.valid(node, mapped)) { (newLocal || (newLocal = [])).push(mapped); }
	    else if (options.onRemove) { options.onRemove(this$1.local[i].spec); }
	  }
	
	  if (this.children.length)
	    { return mapChildren(this.children, newLocal, mapping, node, offset, oldOffset, options) }
	  else
	    { return newLocal ? new DecorationSet(newLocal.sort(byPos)) : empty }
	};
	
	// :: (Node, [Decoration]) → DecorationSet
	// Add the given array of decorations to the ones in the set,
	// producing a new set. Needs access to the current document to
	// create the appropriate tree structure.
	DecorationSet.prototype.add = function add (doc, decorations) {
	  if (!decorations.length) { return this }
	  if (this == empty) { return DecorationSet.create(doc, decorations) }
	  return this.addInner(doc, decorations, 0)
	};
	
	DecorationSet.prototype.addInner = function addInner (doc, decorations, offset) {
	    var this$1 = this;
	
	  var children, childIndex = 0;
	  doc.forEach(function (childNode, childOffset) {
	    var baseOffset = childOffset + offset, found;
	    if (!(found = takeSpansForNode(decorations, childNode, baseOffset))) { return }
	
	    if (!children) { children = this$1.children.slice(); }
	    while (childIndex < children.length && children[childIndex] < childOffset) { childIndex += 3; }
	    if (children[childIndex] == childOffset)
	      { children[childIndex + 2] = children[childIndex + 2].addInner(childNode, found, baseOffset + 1); }
	    else
	      { children.splice(childIndex, 0, childOffset, childOffset + childNode.nodeSize, buildTree(found, childNode, baseOffset + 1, noSpec)); }
	    childIndex += 3;
	  });
	
	  var local = moveSpans(childIndex ? withoutNulls(decorations) : decorations, -offset);
	  return new DecorationSet(local.length ? this.local.concat(local).sort(byPos) : this.local,
	                           children || this.children)
	};
	
	// :: ([Decoration]) → DecorationSet
	// Create a new set that contains the decorations in this set, minus
	// the ones in the given array.
	DecorationSet.prototype.remove = function remove (decorations) {
	  if (decorations.length == 0 || this == empty) { return this }
	  return this.removeInner(decorations, 0)
	};
	
	DecorationSet.prototype.removeInner = function removeInner (decorations, offset) {
	    var this$1 = this;
	
	  var children = this.children, local = this.local;
	  for (var i = 0; i < children.length; i += 3) {
	    var found = (void 0), from = children[i] + offset, to = children[i + 1] + offset;
	    for (var j = 0, span = (void 0); j < decorations.length; j++) { if (span = decorations[j]) {
	      if (span.from > from && span.to < to) {
	        decorations[j] = null
	        ;(found || (found = [])).push(span);
	      }
	    } }
	    if (!found) { continue }
	    if (children == this$1.children) { children = this$1.children.slice(); }
	    var removed = children[i + 2].removeInner(found, from + 1);
	    if (removed != empty) {
	      children[i + 2] = removed;
	    } else {
	      children.splice(i, 3);
	      i -= 3;
	    }
	  }
	  if (local.length) { for (var i$1 = 0, span$1 = (void 0); i$1 < decorations.length; i$1++) { if (span$1 = decorations[i$1]) {
	    for (var j$1 = 0; j$1 < local.length; j$1++) { if (local[j$1].type.eq(span$1.type)) {
	      if (local == this$1.local) { local = this$1.local.slice(); }
	      local.splice(j$1--, 1);
	    } }
	  } } }
	  if (children == this.children && local == this.local) { return this }
	  return local.length || children.length ? new DecorationSet(local, children) : empty
	};
	
	DecorationSet.prototype.forChild = function forChild (offset, node) {
	    var this$1 = this;
	
	  if (this == empty) { return this }
	  if (node.isLeaf) { return DecorationSet.empty }
	
	  var child, local;
	  for (var i = 0; i < this.children.length; i += 3) { if (this$1.children[i] >= offset) {
	    if (this$1.children[i] == offset) { child = this$1.children[i + 2]; }
	    break
	  } }
	  var start = offset + 1, end = start + node.content.size;
	  for (var i$1 = 0; i$1 < this.local.length; i$1++) {
	    var dec = this$1.local[i$1];
	    if (dec.from < end && dec.to > start && (dec.type instanceof InlineType)) {
	      var from = Math.max(start, dec.from) - start, to = Math.min(end, dec.to) - start;
	      if (from < to) { (local || (local = [])).push(dec.copy(from, to)); }
	    }
	  }
	  if (local) {
	    var localSet = new DecorationSet(local.sort(byPos));
	    return child ? new DecorationGroup([localSet, child]) : localSet
	  }
	  return child || empty
	};
	
	DecorationSet.prototype.eq = function eq (other) {
	    var this$1 = this;
	
	  if (this == other) { return true }
	  if (!(other instanceof DecorationSet) ||
	      this.local.length != other.local.length ||
	      this.children.length != other.children.length) { return false }
	  for (var i = 0; i < this.local.length; i++)
	    { if (!this$1.local[i].eq(other.local[i])) { return false } }
	  for (var i$1 = 0; i$1 < this.children.length; i$1 += 3)
	    { if (this$1.children[i$1] != other.children[i$1] ||
	        this$1.children[i$1 + 1] != other.children[i$1 + 1] ||
	        !this$1.children[i$1 + 2].eq(other.children[i$1 + 2])) { return false } }
	  return false
	};
	
	DecorationSet.prototype.locals = function locals (node) {
	  return removeOverlap(this.localsInner(node))
	};
	
	DecorationSet.prototype.localsInner = function localsInner (node) {
	    var this$1 = this;
	
	  if (this == empty) { return none }
	  if (node.inlineContent || !this.local.some(InlineType.is)) { return this.local }
	  var result = [];
	  for (var i = 0; i < this.local.length; i++) {
	    if (!(this$1.local[i].type instanceof InlineType))
	      { result.push(this$1.local[i]); }
	  }
	  return result
	};
	
	var empty = new DecorationSet();
	
	// :: DecorationSet
	// The empty set of decorations.
	DecorationSet.empty = empty;
	
	DecorationSet.removeOverlap = removeOverlap;
	
	// :- An abstraction that allows the code dealing with decorations to
	// treat multiple DecorationSet objects as if it were a single object
	// with (a subset of) the same interface.
	var DecorationGroup = function DecorationGroup(members) {
	  this.members = members;
	};
	
	DecorationGroup.prototype.forChild = function forChild (offset, child) {
	    var this$1 = this;
	
	  if (child.isLeaf) { return DecorationSet.empty }
	  var found = [];
	  for (var i = 0; i < this.members.length; i++) {
	    var result = this$1.members[i].forChild(offset, child);
	    if (result == empty) { continue }
	    if (result instanceof DecorationGroup) { found = found.concat(result.members); }
	    else { found.push(result); }
	  }
	  return DecorationGroup.from(found)
	};
	
	DecorationGroup.prototype.eq = function eq (other) {
	    var this$1 = this;
	
	  if (!(other instanceof DecorationGroup) ||
	      other.members.length != this.members.length) { return false }
	  for (var i = 0; i < this.members.length; i++)
	    { if (!this$1.members[i].eq(other.members[i])) { return false } }
	  return true
	};
	
	DecorationGroup.prototype.locals = function locals (node) {
	    var this$1 = this;
	
	  var result, sorted = true;
	  for (var i = 0; i < this.members.length; i++) {
	    var locals = this$1.members[i].localsInner(node);
	    if (!locals.length) { continue }
	    if (!result) {
	      result = locals;
	    } else {
	      if (sorted) {
	        result = result.slice();
	        sorted = false;
	      }
	      for (var j = 0; j < locals.length; j++) { result.push(locals[j]); }
	    }
	  }
	  return result ? removeOverlap(sorted ? result : result.sort(byPos)) : none
	};
	
	// : ([DecorationSet]) → union<DecorationSet, DecorationGroup>
	// Create a group for the given array of decoration sets, or return
	// a single set when possible.
	DecorationGroup.from = function from (members) {
	  switch (members.length) {
	    case 0: return empty
	    case 1: return members[0]
	    default: return new DecorationGroup(members)
	  }
	};
	
	function mapChildren(oldChildren, newLocal, mapping, node, offset, oldOffset, options) {
	  var children = oldChildren.slice();
	
	  // Mark the children that are directly touched by changes, and
	  // move those that are after the changes.
	  var shift = function (oldStart, oldEnd, newStart, newEnd) {
	    for (var i = 0; i < children.length; i += 3) {
	      var end = children[i + 1], dSize = (void 0);
	      if (end == -1 || oldStart > end + oldOffset) { continue }
	      if (oldEnd >= children[i] + oldOffset) {
	        children[i + 1] = -1;
	      } else if (dSize = (newEnd - newStart) - (oldEnd - oldStart) + (oldOffset - offset)) {
	        children[i] += dSize;
	        children[i + 1] += dSize;
	      }
	    }
	  };
	  for (var i = 0; i < mapping.maps.length; i++) { mapping.maps[i].forEach(shift); }
	
	  // Find the child nodes that still correspond to a single node,
	  // recursively call mapInner on them and update their positions.
	  var mustRebuild = false;
	  for (var i$1 = 0; i$1 < children.length; i$1 += 3) { if (children[i$1 + 1] == -1) { // Touched nodes
	    var from = mapping.map(children[i$1] + oldOffset), fromLocal = from - offset;
	    if (fromLocal < 0 || fromLocal >= node.content.size) {
	      mustRebuild = true;
	      continue
	    }
	    // Must read oldChildren because children was tagged with -1
	    var to = mapping.map(oldChildren[i$1 + 1] + oldOffset, -1), toLocal = to - offset;
	    var ref = node.content.findIndex(fromLocal);
	    var index = ref.index;
	    var childOffset = ref.offset;
	    var childNode = node.maybeChild(index);
	    if (childNode && childOffset == fromLocal && childOffset + childNode.nodeSize == toLocal) {
	      var mapped = children[i$1 + 2].mapInner(mapping, childNode, from + 1, children[i$1] + oldOffset + 1, options);
	      if (mapped != empty) {
	        children[i$1] = fromLocal;
	        children[i$1 + 1] = toLocal;
	        children[i$1 + 2] = mapped;
	      } else {
	        children[i$1 + 1] = -2;
	        mustRebuild = true;
	      }
	    } else {
	      mustRebuild = true;
	    }
	  } }
	
	  // Remaining children must be collected and rebuilt into the appropriate structure
	  if (mustRebuild) {
	    var decorations = mapAndGatherRemainingDecorations(children, oldChildren, newLocal || [], mapping,
	                                                       offset, oldOffset, options);
	    var built = buildTree(decorations, node, 0, options);
	    newLocal = built.local;
	    for (var i$2 = 0; i$2 < children.length; i$2 += 3) { if (children[i$2 + 1] < 0) {
	      children.splice(i$2, 3);
	      i$2 -= 3;
	    } }
	    for (var i$3 = 0, j = 0; i$3 < built.children.length; i$3 += 3) {
	      var from$1 = built.children[i$3];
	      while (j < children.length && children[j] < from$1) { j += 3; }
	      children.splice(j, 0, built.children[i$3], built.children[i$3 + 1], built.children[i$3 + 2]);
	    }
	  }
	
	  return new DecorationSet(newLocal && newLocal.sort(byPos), children)
	}
	
	function moveSpans(spans, offset) {
	  if (!offset || !spans.length) { return spans }
	  var result = [];
	  for (var i = 0; i < spans.length; i++) {
	    var span = spans[i];
	    result.push(new Decoration(span.from + offset, span.to + offset, span.type));
	  }
	  return result
	}
	
	function mapAndGatherRemainingDecorations(children, oldChildren, decorations, mapping, offset, oldOffset, options) {
	  // Gather all decorations from the remaining marked children
	  function gather(set, oldOffset) {
	    for (var i = 0; i < set.local.length; i++) {
	      var mapped = set.local[i].map(mapping, offset, oldOffset);
	      if (mapped) { decorations.push(mapped); }
	      else if (options.onRemove) { options.onRemove(set.local[i].spec); }
	    }
	    for (var i$1 = 0; i$1 < set.children.length; i$1 += 3)
	      { gather(set.children[i$1 + 2], set.children[i$1] + oldOffset + 1); }
	  }
	  for (var i = 0; i < children.length; i += 3) { if (children[i + 1] == -1)
	    { gather(children[i + 2], oldChildren[i] + oldOffset + 1); } }
	
	  return decorations
	}
	
	function takeSpansForNode(spans, node, offset) {
	  if (node.isLeaf) { return null }
	  var end = offset + node.nodeSize, found = null;
	  for (var i = 0, span = (void 0); i < spans.length; i++) {
	    if ((span = spans[i]) && span.from > offset && span.to < end) {
	      (found || (found = [])).push(span);
	      spans[i] = null;
	    }
	  }
	  return found
	}
	
	function withoutNulls(array) {
	  var result = [];
	  for (var i = 0; i < array.length; i++)
	    { if (array[i] != null) { result.push(array[i]); } }
	  return result
	}
	
	// : ([Decoration], Node, number) → DecorationSet
	// Build up a tree that corresponds to a set of decorations. `offset`
	// is a base offset that should be subtractet from the `from` and `to`
	// positions in the spans (so that we don't have to allocate new spans
	// for recursive calls).
	function buildTree(spans, node, offset, options) {
	  var children = [], hasNulls = false;
	  node.forEach(function (childNode, localStart) {
	    var found = takeSpansForNode(spans, childNode, localStart + offset);
	    if (found) {
	      hasNulls = true;
	      var subtree = buildTree(found, childNode, offset + localStart + 1, options);
	      if (subtree != empty)
	        { children.push(localStart, localStart + childNode.nodeSize, subtree); }
	    }
	  });
	  var locals = moveSpans(hasNulls ? withoutNulls(spans) : spans, -offset).sort(byPos);
	  for (var i = 0; i < locals.length; i++) { if (!locals[i].type.valid(node, locals[i])) {
	    if (options.onRemove) { options.onRemove(locals[i].spec); }
	    locals.splice(i--, 1);
	  } }
	  return locals.length || children.length ? new DecorationSet(locals, children) : empty
	}
	
	// : (Decoration, Decoration) → number
	// Used to sort decorations so that ones with a low start position
	// come first, and within a set with the same start position, those
	// with an smaller end position come first.
	function byPos(a, b) {
	  return a.from - b.from || a.to - b.to
	}
	
	// : ([Decoration]) → [Decoration]
	// Scan a sorted array of decorations for partially overlapping spans,
	// and split those so that only fully overlapping spans are left (to
	// make subsequent rendering easier). Will return the input array if
	// no partially overlapping spans are found (the common case).
	function removeOverlap(spans) {
	  var working = spans;
	  for (var i = 0; i < working.length - 1; i++) {
	    var span = working[i];
	    if (span.from != span.to) { for (var j = i + 1; j < working.length; j++) {
	      var next = working[j];
	      if (next.from == span.from) {
	        if (next.to != span.to) {
	          if (working == spans) { working = spans.slice(); }
	          // Followed by a partially overlapping larger span. Split that
	          // span.
	          working[j] = next.copy(next.from, span.to);
	          insertAhead(working, j + 1, next.copy(span.to, next.to));
	        }
	        continue
	      } else {
	        if (next.from < span.to) {
	          if (working == spans) { working = spans.slice(); }
	          // The end of this one overlaps with a subsequent span. Split
	          // this one.
	          working[i] = span.copy(span.from, next.from);
	          insertAhead(working, j, span.copy(next.from, span.to));
	        }
	        break
	      }
	    } }
	  }
	  return working
	}
	
	function insertAhead(array, i, deco) {
	  while (i < array.length && byPos(deco, array[i]) > 0) { i++; }
	  array.splice(i, 0, deco);
	}
	
	// : (EditorView) → union<DecorationSet, DecorationGroup>
	// Get the decorations associated with the current props of a view.
	function viewDecorations(view) {
	  var found = [];
	  view.someProp("decorations", function (f) {
	    var result = f(view.state);
	    if (result && result != empty) { found.push(result); }
	  });
	  if (view.cursorWrapper)
	    { found.push(DecorationSet.create(view.state.doc, [view.cursorWrapper.deco])); }
	  return DecorationGroup.from(found)
	}
	
	// ::- An editor view manages the DOM structure that represents an
	// editable document. Its state and behavior are determined by its
	// [props](#view.DirectEditorProps).
	var EditorView = function EditorView(place, props) {
	  this._props = props;
	  // :: EditorState
	  // The view's current [state](#state.EditorState).
	  this.state = props.state;
	
	  this.dispatch = this.dispatch.bind(this);
	
	  this._root = null;
	  this.focused = false;
	
	  // :: dom.Element
	  // An editable DOM node containing the document. (You probably
	  // should not directly interfere with its content.)
	  this.dom = (place && place.mount) || document.createElement("div");
	  if (place) {
	    if (place.appendChild) { place.appendChild(this.dom); }
	    else if (place.apply) { place(this.dom); }
	    else if (place.mount) { this.mounted = true; }
	  }
	
	  this.editable = getEditable(this);
	  this.cursorWrapper = null;
	  updateCursorWrapper(this);
	  this.nodeViews = buildNodeViews(this);
	  this.docView = docViewDesc(this.state.doc, computeDocDeco(this), viewDecorations(this), this.dom, this);
	
	  this.lastSelectedViewDesc = null;
	  // :: ?{slice: Slice, move: bool}
	  // When editor content is being dragged, this object contains
	  // information about the dragged slice and whether it is being
	  // copied or moved. At any other time, it is null.
	  this.dragging = null;
	  initInput(this); // Must be done before creating a SelectionReader
	
	  this.selectionReader = new SelectionReader(this);
	
	  this.pluginViews = [];
	  this.updatePluginViews();
	};
	
	var prototypeAccessors = { props: {},root: {} };
	
	// :: DirectEditorProps
	// The view's current [props](#view.EditorProps).
	prototypeAccessors.props.get = function () {
	    var this$1 = this;
	
	  if (this._props.state != this.state) {
	    var prev = this._props;
	    this._props = {};
	    for (var name in prev) { this$1._props[name] = prev[name]; }
	    this._props.state = this.state;
	  }
	  return this._props
	};
	
	// :: (DirectEditorProps)
	// Update the view's props. Will immediately cause an update to
	// the DOM.
	EditorView.prototype.update = function update (props) {
	  if (props.handleDOMEvents != this._props.handleDOMEvents) { ensureListeners(this); }
	  this._props = props;
	  this.updateStateInner(props.state, true);
	};
	
	// :: (DirectEditorProps)
	// Update the view by updating existing props object with the object
	// given as argument. Equivalent to `view.update(Object.assign({},
	// view.props, props))`.
	EditorView.prototype.setProps = function setProps (props) {
	    var this$1 = this;
	
	  var updated = {};
	  for (var name in this$1._props) { updated[name] = this$1._props[name]; }
	  updated.state = this.state;
	  for (var name$1 in props) { updated[name$1] = props[name$1]; }
	  this.update(updated);
	};
	
	// :: (EditorState)
	// Update the editor's `state` prop, without touching any of the
	// other props.
	EditorView.prototype.updateState = function updateState (state) {
	  this.updateStateInner(state, this.state.plugins != state.plugins);
	};
	
	EditorView.prototype.updateStateInner = function updateStateInner (state, reconfigured) {
	    var this$1 = this;
	
	  var prev = this.state, redraw = false;
	  this.state = state;
	  if (reconfigured) {
	    var nodeViews = buildNodeViews(this);
	    if (changedNodeViews(nodeViews, this.nodeViews)) {
	      this.nodeViews = nodeViews;
	      redraw = true;
	    }
	    ensureListeners(this);
	  }
	
	  this.domObserver.flush();
	  if (this.inDOMChange && this.inDOMChange.stateUpdated(state)) { return }
	
	  var prevEditable = this.editable;
	  this.editable = getEditable(this);
	  updateCursorWrapper(this);
	  var innerDeco = viewDecorations(this), outerDeco = computeDocDeco(this);
	
	  var scroll = reconfigured ? "reset"
	      : state.scrollToSelection > prev.scrollToSelection ? "to selection" : "preserve";
	  var updateDoc = redraw || !this.docView.matchesNode(state.doc, outerDeco, innerDeco);
	  var updateSel = updateDoc || !state.selection.eq(prev.selection) || this.selectionReader.domChanged();
	  var oldScrollPos = scroll == "preserve" && updateSel && storeScrollPos(this);
	
	  if (updateSel) {
	    this.domObserver.stop();
	    var forceSelUpdate = false;
	    if (updateDoc) {
	      // Work around an issue in Chrome where changing the DOM
	      // around the active selection puts it into a broken state
	      // where the thing the user sees differs from the selection
	      // reported by the Selection object (#710)
	      var startSelContext = result.chrome && selectionContext(this.root);
	      if (redraw || !this.docView.update(state.doc, outerDeco, innerDeco, this)) {
	        this.docView.destroy();
	        this.docView = docViewDesc(state.doc, outerDeco, innerDeco, this.dom, this);
	      }
	      this.selectionReader.clearDOMState();
	      if (startSelContext)
	        { forceSelUpdate = needChromeSelectionForce(startSelContext, this.root); }
	    }
	    // Work around for an issue where an update arriving right between
	    // a DOM selection change and the "selectionchange" event for it
	    // can cause a spurious DOM selection update, disrupting mouse
	    // drag selection.
	    if (forceSelUpdate ||
	        !(this.mouseDown && this.selectionReader.domChanged() && anchorInRightPlace(this))) {
	      selectionToDOM(this, false, forceSelUpdate);
	    } else {
	      syncNodeSelection(this, state.selection);
	      this.selectionReader.storeDOMState(state.selection);
	    }
	    this.domObserver.start();
	  }
	
	  if (prevEditable != this.editable) { this.selectionReader.editableChanged(); }
	  this.updatePluginViews(reconfigured ? null : prev);
	
	  if (scroll == "reset") {
	    this.dom.scrollTop = 0;
	  } else if (scroll == "to selection") {
	    var startDOM = this.root.getSelection().focusNode;
	    if (this.someProp("handleScrollToSelection", function (f) { return f(this$1); }))
	      {} // Handled
	    else if (state.selection instanceof prosemirrorState.NodeSelection)
	      { scrollRectIntoView(this, this.docView.domAfterPos(state.selection.from).getBoundingClientRect(), startDOM); }
	    else
	      { scrollRectIntoView(this, this.coordsAtPos(state.selection.head), startDOM); }
	  } else if (oldScrollPos) {
	    resetScrollPos(oldScrollPos);
	  }
	};
	
	EditorView.prototype.destroyPluginViews = function destroyPluginViews () {
	  var view;
	  while (view = this.pluginViews.pop()) { if (view.destroy) { view.destroy(); } }
	};
	
	EditorView.prototype.updatePluginViews = function updatePluginViews (prevState) {
	    var this$1 = this;
	
	  if (!prevState) {
	    this.destroyPluginViews();
	    for (var i = 0; i < this.state.plugins.length; i++) {
	      var plugin = this$1.state.plugins[i];
	      if (plugin.spec.view) { this$1.pluginViews.push(plugin.spec.view(this$1)); }
	    }
	  } else {
	    for (var i$1 = 0; i$1 < this.pluginViews.length; i$1++) {
	      var pluginView = this$1.pluginViews[i$1];
	      if (pluginView.update) { pluginView.update(this$1, prevState); }
	    }
	  }
	};
	
	// :: (string, ?(prop: *) → *) → *
	// Goes over the values of a prop, first those provided directly,
	// then those from plugins (in order), and calls `f` every time a
	// non-undefined value is found. When `f` returns a truthy value,
	// that is immediately returned. When `f` isn't provided, it is
	// treated as the identity function (the prop value is returned
	// directly).
	EditorView.prototype.someProp = function someProp (propName, f) {
	  var prop = this._props && this._props[propName], value;
	  if (prop != null && (value = f ? f(prop) : prop)) { return value }
	  var plugins = this.state.plugins;
	  if (plugins) { for (var i = 0; i < plugins.length; i++) {
	    var prop$1 = plugins[i].props[propName];
	    if (prop$1 != null && (value = f ? f(prop$1) : prop$1)) { return value }
	  } }
	};
	
	// :: () → bool
	// Query whether the view has focus.
	EditorView.prototype.hasFocus = function hasFocus () {
	  return this.root.activeElement == this.dom
	};
	
	// :: ()
	// Focus the editor.
	EditorView.prototype.focus = function focus () {
	  this.domObserver.stop();
	  selectionToDOM(this, true);
	  this.domObserver.start();
	  if (this.editable) { this.dom.focus(); }
	};
	
	// :: union<dom.Document, dom.DocumentFragment>
	// Get the document root in which the editor exists. This will
	// usually be the top-level `document`, but might be a [shadow
	// DOM](https://developer.mozilla.org/en-US/docs/Web/Web_Components/Shadow_DOM)
	// root if the editor is inside one.
	prototypeAccessors.root.get = function () {
	    var this$1 = this;
	
	  var cached = this._root;
	  if (cached == null) { for (var search = this.dom.parentNode; search; search = search.parentNode) {
	    if (search.nodeType == 9 || (search.nodeType == 11 && search.host))
	      { return this$1._root = search }
	  } }
	  return cached || document
	};
	
	// :: ({left: number, top: number}) → ?{pos: number, inside: number}
	// Given a pair of viewport coordinates, return the document
	// position that corresponds to them. May return null if the given
	// coordinates aren't inside of the editor. When an object is
	// returned, its `pos` property is the position nearest to the
	// coordinates, and its `inside` property holds the position of the
	// inner node that the position falls inside of, or -1 if it is at
	// the top level, not in any node.
	EditorView.prototype.posAtCoords = function posAtCoords$1 (coords) {
	  var pos = posAtCoords(this, coords);
	  if (this.inDOMChange && pos) {
	    pos.pos = this.inDOMChange.mapping.map(pos.pos);
	    if (pos.inside != -1) { pos.inside = this.inDOMChange.mapping.map(pos.inside); }
	  }
	  return pos
	};
	
	// :: (number) → {left: number, right: number, top: number, bottom: number}
	// Returns the viewport rectangle at a given document position. `left`
	// and `right` will be the same number, as this returns a flat
	// cursor-ish rectangle.
	EditorView.prototype.coordsAtPos = function coordsAtPos$1 (pos) {
	  if (this.inDOMChange)
	    { pos = this.inDOMChange.mapping.invert().map(pos); }
	  return coordsAtPos(this, pos)
	};
	
	// :: (number) → {node: dom.Node, offset: number}
	// Find the DOM position that corresponds to the given document
	// position. Note that you should **not** mutate the editor's
	// internal DOM, only inspect it (and even that is usually not
	// necessary).
	EditorView.prototype.domAtPos = function domAtPos (pos) {
	  if (this.inDOMChange)
	    { pos = this.inDOMChange.mapping.invert().map(pos); }
	  return this.docView.domFromPos(pos)
	};
	
	// :: (number) → ?dom.Node
	// Find the DOM node that represents the document node after the
	// given position. May return `null` when the position doesn't point
	// in front of a node or if the node is inside an opaque node view.
	//
	// This is intended to be able to call things like
	// `getBoundingClientRect` on that DOM node. Do **not** mutate the
	// editor DOM directly, or add styling this way, since that will be
	// immediately overriden by the editor as it redraws the node.
	EditorView.prototype.nodeDOM = function nodeDOM (pos) {
	  if (this.inDOMChange)
	    { pos = this.inDOMChange.mapping.invert().map(pos); }
	  var desc = this.docView.descAt(pos);
	  return desc ? desc.nodeDOM : null
	};
	
	// :: (dom.Node, number, ?number) → number
	// Find the document position that corresponds to a given DOM
	// position. (Whenever possible, it is preferable to inspect the
	// document structure directly, rather than poking around in the
	// DOM, but sometimes—for example when interpreting an event
	// target—you don't have a choice.)
	//
	// The `bias` parameter can be used to influence which side of a DOM
	// node to use when the position is inside a leaf node.
	EditorView.prototype.posAtDOM = function posAtDOM (node, offset, bias) {
	    if ( bias === void 0 ) bias = -1;
	
	  var pos = this.docView.posFromDOM(node, offset, bias);
	  if (pos == null) { throw new RangeError("DOM position not inside the editor") }
	  if (this.inDOMChange)
	    { pos = this.inDOMChange.mapping.map(pos); }
	  return pos
	};
	
	// :: (union<"up", "down", "left", "right", "forward", "backward">, ?EditorState) → bool
	// Find out whether the selection is at the end of a textblock when
	// moving in a given direction. When, for example, given `"left"`,
	// it will return true if moving left from the current cursor
	// position would leave that position's parent textblock. Will apply
	// to the view's current state by default, but it is possible to
	// pass a different state.
	EditorView.prototype.endOfTextblock = function endOfTextblock$1 (dir, state) {
	  return endOfTextblock(this, state || this.state, dir)
	};
	
	// :: ()
	// Removes the editor from the DOM and destroys all [node
	// views](#view.NodeView).
	EditorView.prototype.destroy = function destroy () {
	  if (!this.docView) { return }
	  destroyInput(this);
	  this.destroyPluginViews();
	  this.selectionReader.destroy();
	  if (this.mounted) {
	    this.docView.update(this.state.doc, [], viewDecorations(this), this);
	    this.dom.textContent = "";
	  } else if (this.dom.parentNode) {
	    this.dom.parentNode.removeChild(this.dom);
	  }
	  this.docView.destroy();
	  this.docView = null;
	};
	
	// Used for testing.
	EditorView.prototype.dispatchEvent = function dispatchEvent$1 (event) {
	  return dispatchEvent(this, event)
	};
	
	// :: (Transaction)
	// Dispatch a transaction. Will call
	// [`dispatchTransaction`](#view.DirectEditorProps.dispatchTransaction)
	// when given, and otherwise defaults to applying the transaction to
	// the current state and calling
	// [`updateState`](#view.EditorView.updateState) with the result.
	// This method is bound to the view instance, so that it can be
	// easily passed around.
	EditorView.prototype.dispatch = function dispatch (tr) {
	  var dispatchTransaction = this._props.dispatchTransaction;
	  if (dispatchTransaction) { dispatchTransaction.call(this, tr); }
	  else { this.updateState(this.state.apply(tr)); }
	};
	
	Object.defineProperties( EditorView.prototype, prototypeAccessors );
	
	function computeDocDeco(view) {
	  var attrs = Object.create(null);
	  attrs.class = "ProseMirror";
	  attrs.contenteditable = String(view.editable);
	
	  view.someProp("attributes", function (value) {
	    if (typeof value == "function") { value = value(view.state); }
	    if (value) { for (var attr in value) {
	      if (attr == "class")
	        { attrs.class += " " + value[attr]; }
	      else if (!attrs[attr] && attr != "contenteditable" && attr != "nodeName")
	        { attrs[attr] = String(value[attr]); }
	    } }
	  });
	
	  return [Decoration.node(0, view.state.doc.content.size, attrs)]
	}
	
	function cursorWrapperDOM(visible) {
	  var span = document.createElement("span");
	  span.textContent = "\ufeff"; // zero-width non-breaking space
	  if (!visible) {
	    span.style.position = "absolute";
	    span.style.left = "-100000px";
	  }
	  return span
	}
	
	function updateCursorWrapper(view) {
	  var $pos = needsCursorWrapper(view.state);
	  // On IE/Edge, moving the DOM selection will abort a mouse drag, so
	  // there we delay the creation of the wrapper when the mouse is down.
	  if ($pos && !(result.ie && view.mouseDown)) {
	    var visible = view.state.selection.visible;
	    // Needs a cursor wrapper
	    var marks = view.state.storedMarks || $pos.marks(), dom;
	    if (!view.cursorWrapper || !prosemirrorModel.Mark.sameSet(view.cursorWrapper.deco.spec.marks, marks) ||
	        view.cursorWrapper.dom.textContent != "\ufeff" ||
	        view.cursorWrapper.deco.spec.visible != visible)
	      { dom = cursorWrapperDOM(visible); }
	    else if (view.cursorWrapper.deco.pos != $pos.pos)
	      { dom = view.cursorWrapper.dom; }
	    if (dom)
	      { view.cursorWrapper = {dom: dom, deco: Decoration.widget($pos.pos, dom, {isCursorWrapper: true, marks: marks, raw: true, visible: visible})}; }
	  } else {
	    view.cursorWrapper = null;
	  }
	}
	
	function getEditable(view) {
	  return !view.someProp("editable", function (value) { return value(view.state) === false; })
	}
	
	function selectionContext(root) {
	  var ref = root.getSelection();
	  var offset = ref.focusOffset;
	  var node = ref.focusNode;
	  if (!node || node.nodeType == 3) { return null }
	  return [node, offset,
	          node.nodeType == 1 ? node.childNodes[offset - 1] : null,
	          node.nodeType == 1 ? node.childNodes[offset] : null]
	}
	
	function needChromeSelectionForce(context, root) {
	  var newContext = selectionContext(root);
	  if (!newContext || newContext[0].nodeType == 3) { return false }
	  for (var i = 0; i < context.length; i++) { if (newContext[i] != context[i]) { return true } }
	  return false
	}
	
	function buildNodeViews(view) {
	  var result$$1 = {};
	  view.someProp("nodeViews", function (obj) {
	    for (var prop in obj) { if (!Object.prototype.hasOwnProperty.call(result$$1, prop))
	      { result$$1[prop] = obj[prop]; } }
	  });
	  return result$$1
	}
	
	function changedNodeViews(a, b) {
	  var nA = 0, nB = 0;
	  for (var prop in a) {
	    if (a[prop] != b[prop]) { return true }
	    nA++;
	  }
	  for (var _ in b) { nB++; }
	  return nA != nB
	}
	
	// EditorProps:: interface
	//
	// Props are configuration values that can be passed to an editor view
	// or included in a plugin. This interface lists the supported props.
	//
	// The various event-handling functions may all return `true` to
	// indicate that they handled the given event. The view will then take
	// care to call `preventDefault` on the event, except with
	// `handleDOMEvents`, where the handler itself is responsible for that.
	//
	// How a prop is resolved depends on the prop. Handler functions are
	// called one at a time, starting with the base props and then
	// searching through the plugins (in order of appearance) until one of
	// them returns true. For some props, the first plugin that yields a
	// value gets precedence.
	//
	//   handleDOMEvents:: ?Object<(view: EditorView, event: dom.Event) → bool>
	//   Can be an object mapping DOM event type names to functions that
	//   handle them. Such functions will be called before any handling
	//   ProseMirror does of events fired on the editable DOM element.
	//   Contrary to the other event handling props, when returning true
	//   from such a function, you are responsible for calling
	//   `preventDefault` yourself (or not, if you want to allow the
	//   default behavior).
	//
	//   handleKeyDown:: ?(view: EditorView, event: dom.KeyboardEvent) → bool
	//   Called when the editor receives a `keydown` event.
	//
	//   handleKeyPress:: ?(view: EditorView, event: dom.KeyboardEvent) → bool
	//   Handler for `keypress` events.
	//
	//   handleTextInput:: ?(view: EditorView, from: number, to: number, text: string) → bool
	//   Whenever the user directly input text, this handler is called
	//   before the input is applied. If it returns `true`, the default
	//   behavior of actually inserting the text is suppressed.
	//
	//   handleClickOn:: ?(view: EditorView, pos: number, node: Node, nodePos: number, event: dom.MouseEvent, direct: bool) → bool
	//   Called for each node around a click, from the inside out. The
	//   `direct` flag will be true for the inner node.
	//
	//   handleClick:: ?(view: EditorView, pos: number, event: dom.MouseEvent) → bool
	//   Called when the editor is clicked, after `handleClickOn` handlers
	//   have been called.
	//
	//   handleDoubleClickOn:: ?(view: EditorView, pos: number, node: Node, nodePos: number, event: dom.MouseEvent, direct: bool) → bool
	//   Called for each node around a double click.
	//
	//   handleDoubleClick:: ?(view: EditorView, pos: number, event: dom.MouseEvent) → bool
	//   Called when the editor is double-clicked, after `handleDoubleClickOn`.
	//
	//   handleTripleClickOn:: ?(view: EditorView, pos: number, node: Node, nodePos: number, event: dom.MouseEvent, direct: bool) → bool
	//   Called for each node around a triple click.
	//
	//   handleTripleClick:: ?(view: EditorView, pos: number, event: dom.MouseEvent) → bool
	//   Called when the editor is triple-clicked, after `handleTripleClickOn`.
	//
	//   handlePaste:: ?(view: EditorView, event: dom.Event, slice: Slice) → bool
	//   Can be used to override the behavior of pasting. `slice` is the
	//   pasted content parsed by the editor, but you can directly access
	//   the event to get at the raw content.
	//
	//   handleDrop:: ?(view: EditorView, event: dom.Event, slice: Slice, moved: bool) → bool
	//   Called when something is dropped on the editor. `moved` will be
	//   true if this drop moves from the current selection (which should
	//   thus be deleted).
	//
	//   handleScrollToSelection:: ?(view: EditorView) → bool
	//   Called when the view, after updating its state, tries to scroll
	//   the selection into view. A handler function may return false to
	//   indicate that it did not handle the scrolling and further
	//   handlers or the default behavior should be tried.
	//
	//   createSelectionBetween:: ?(view: EditorView, anchor: ResolvedPos, head: ResolvedPos) → ?Selection
	//   Can be used to override the way a selection is created when
	//   reading a DOM selection between the given anchor and head.
	//
	//   domParser:: ?DOMParser
	//   The [parser](#model.DOMParser) to use when reading editor changes
	//   from the DOM. Defaults to calling
	//   [`DOMParser.fromSchema`](#model.DOMParser^fromSchema) on the
	//   editor's schema.
	//
	//   transformPastedHTML:: ?(html: string) → string
	//   Can be used to transform pasted HTML text, _before_ it is parsed,
	//   for example to clean it up.
	//
	//   clipboardParser:: ?DOMParser
	//   The [parser](#model.DOMParser) to use when reading content from
	//   the clipboard. When not given, the value of the
	//   [`domParser`](#view.EditorProps.domParser) prop is used.
	//
	//   transformPastedText:: ?(text: string) → string
	//   Transform pasted plain text.
	//
	//   clipboardTextParser:: ?(text: string, $context: ResolvedPos) → Slice
	//   A function to parse text from the clipboard into a document
	//   slice. Called after
	//   [`transformPastedText`](#view.EditorProps.transformPastedText).
	//   The default behavior is to split the text into lines, wrap them
	//   in `<p>` tags, and call
	//   [`clipboardParser`](#view.EditorProps.clipboardParser) on it.
	//
	//   transformPasted:: ?(Slice) → Slice
	//   Can be used to transform pasted content before it is applied to
	//   the document.
	//
	//   nodeViews:: ?Object<(node: Node, view: EditorView, getPos: () → number, decorations: [Decoration]) → NodeView>
	//   Allows you to pass custom rendering and behavior logic for nodes
	//   and marks. Should map node and mark names to constructor
	//   functions that produce a [`NodeView`](#view.NodeView) object
	//   implementing the node's display behavior. For nodes, the third
	//   argument `getPos` is a function that can be called to get the
	//   node's current position, which can be useful when creating
	//   transactions to update it. For marks, the third argument is a
	//   boolean that indicates whether the mark's content is inline.
	//
	//   `decorations` is an array of node or inline decorations that are
	//   active around the node. They are automatically drawn in the
	//   normal way, and you will usually just want to ignore this, but
	//   they can also be used as a way to provide context information to
	//   the node view without adding it to the document itself.
	//
	//   clipboardSerializer:: ?DOMSerializer
	//   The DOM serializer to use when putting content onto the
	//   clipboard. If not given, the result of
	//   [`DOMSerializer.fromSchema`](#model.DOMSerializer^fromSchema)
	//   will be used.
	//
	//   clipboardTextSerializer:: ?(Slice) → string
	//   A function that will be called to get the text for the current
	//   selection when copying text to the clipboard. By default, the
	//   editor will use [`textBetween`](#model.Node.textBetween) on the
	//   selected range.
	//
	//   decorations:: ?(state: EditorState) → ?DecorationSet
	//   A set of [document decorations](#view.Decoration) to show in the
	//   view.
	//
	//   editable:: ?(state: EditorState) → bool
	//   When this returns false, the content of the view is not directly
	//   editable.
	//
	//   attributes:: ?union<Object<string>, (EditorState) → ?Object<string>>
	//   Control the DOM attributes of the editable element. May be either
	//   an object or a function going from an editor state to an object.
	//   By default, the element will get a class `"ProseMirror"`, and
	//   will have its `contentEditable` attribute determined by the
	//   [`editable` prop](#view.EditorProps.editable). Additional classes
	//   provided here will be added to the class. For other attributes,
	//   the value provided first (as in
	//   [`someProp`](#view.EditorView.someProp)) will be used.
	//
	//   scrollThreshold:: ?union<number, {top: number, right: number, bottom: number, left: number}>
	//   Determines the distance (in pixels) between the cursor and the
	//   end of the visible viewport at which point, when scrolling the
	//   cursor into view, scrolling takes place. Defaults to 0.
	//
	//   scrollMargin:: ?union<number, {top: number, right: number, bottom: number, left: number}>
	//   Determines the extra space (in pixels) that is left above or
	//   below the cursor when it is scrolled into view. Defaults to 5.
	
	// DirectEditorProps:: interface extends EditorProps
	//
	// The props object given directly to the editor view supports two
	// fields that can't be used in plugins:
	//
	//   state:: EditorState
	//   The current state of the editor.
	//
	//   dispatchTransaction:: ?(tr: Transaction)
	//   The callback over which to send transactions (state updates)
	//   produced by the view. If you specify this, you probably want to
	//   make sure this ends up calling the view's
	//   [`updateState`](#view.EditorView.updateState) method with a new
	//   state that has the transaction
	//   [applied](#state.EditorState.apply). The callback will be bound to have
	//   the view instance as its `this` binding.
	
	exports.EditorView = EditorView;
	exports.Decoration = Decoration;
	exports.DecorationSet = DecorationSet;
	exports.__serializeForClipboard = serializeForClipboard;
	exports.__parseFromClipboard = parseFromClipboard;
	//# sourceMappingURL=index.js.map


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),
/* 50 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(106);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(348)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(110)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(354);
	var global = __webpack_require__(17);
	var hide = __webpack_require__(46);
	var Iterators = __webpack_require__(59);
	var TO_STRING_TAG = __webpack_require__(19)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ }),
/* 54 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	function _broadcast(componentName, eventName, params) {
	  this.$children.forEach(function (child) {
	    var name = child.$options.componentName;
	
	    if (name === componentName) {
	      child.$emit.apply(child, [eventName].concat(params));
	    } else {
	      _broadcast.apply(child, [componentName, eventName].concat([params]));
	    }
	  });
	}
	exports.default = {
	  methods: {
	    dispatch: function dispatch(componentName, eventName, params) {
	      var parent = this.$parent || this.$root;
	      var name = parent.$options.componentName;
	
	      while (parent && (!name || name !== componentName)) {
	        parent = parent.$parent;
	
	        if (parent) {
	          name = parent.$options.componentName;
	        }
	      }
	      if (parent) {
	        parent.$emit.apply(parent, [eventName].concat(params));
	      }
	    },
	    broadcast: function broadcast(componentName, eventName, params) {
	      _broadcast.call(this, componentName, eventName, params);
	    }
	  }
	};

/***/ }),
/* 55 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFgAAABICAYAAAByQzKvAAADvklEQVR4Ae2bO2gUURSGZ3d2kixiEwRBUoj4LLSILyy0UUS0l1UQGxsbwcbOSisbSaWFjVUWBcEilVqJBnyBj8IIglgoggSCiptdZ0Y4d84l3M3OzM6eM5uE32LOzn38c/bb3+ude6+VOI5jD3/UCFTVlCFMBABY2QgADMDKBJTl4WAAViagLA8HA7AyAWV5OBiAlQkoy8PBAKxMQFkeDgZgZQLK8nCwMuCasn5v+TCiuvD1HMXOy48Uoy/fTJ/5XybydXw9fapu3kQx2L+Tor93h2nhr0yvrMysDLI1ca2UvaMRJk5tN58QwOjH/EAgqxvHqf9I4yhFP3H2QKKCneFgQZjLSek7ONnx6zQf0/PbM7PL5SFWNnLqEGkFjWNGsyImXUgIDi6ELX8n9VlEWc7lr+z+DQnOJE7mBiVHOFgZuJqD7WxBecztxYedXN06QU2GNbuAg3v9QkLl8g5O3tB4niuUZ2EZzqM+ud1olPzGBwcX/unydRR3MK8tZL2hVTwzQa0l/8qHj15QxtHPhdTMa4f3mPo/LYr/3nxKbc95cF7+gV2p7aUr4WBpoo6euIN5Vcx5Ttdt7JlXvOrEBqoLrp6n2Lp2l6Lr5OD4PiofOXeC4uLUfYp5L5wXHJyX2CppJ+5gu56bE0B76h61HLvcMNFxsj+5jcrZua3bD+k+fGXWkekmx6XfvHJI5mqCMTgXpuKNxB3suTsRGbnF7ZBatG42KbKT69cvmJ7r6qaenfvsvSnv99pnXv3K92oPB/ciI1Qu7+CCibGTO+8+k8Lo7i0Uo4XfFOO5rwWVh9sNDlbmL+/gZPfX+97fXpud554167eLd2boqwcHzZvXmDO7cOfJmZw4r8yGsg3gYFmeXWriDuZzC2FOB1vnJm9odp6bzBbC528paZ5dFHUy59VFQLkADlYGLO5gPnETzn5ITd2upp00u8Cuc7kzzy54njx66TRV+UfMqlr04Ck3TY2cV2ojhUo4WAHqUkn5cxHJjsbfK7foObweu/ShZX7mkz/1GxfNY7GjUSZ+/WeJj8Fe4hA+K9bqc91W+itzHpyXtH6WHsbgLEID1suPwU5CnelyzqQ5j/XsGTWc7HHRrK17+THY4WNPOSblfOLGaSZ2a53LpyvFlIsJYQwuxi13L/Ux2M3EnlnDCXcXDe6LECjdwTZJ/C8jiwIfBiAwPAcPkPRq6opZhPKvBcAArExAWR4OBmBlAsrycDAAKxNQloeDAViZgLI8HAzAygSU5eFgAFYmoCwPBwOwMgFl+f8vzgRWd1o6RgAAAABJRU5ErkJggg=="

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _defineProperty2 = __webpack_require__(44);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(30);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(7);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(10);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(32);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(31);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _setPrototypeOf = __webpack_require__(64);
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _create = __webpack_require__(57);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _typeof2 = __webpack_require__(8);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault(ex) {
	  return ex && (typeof ex === 'undefined' ? 'undefined' : (0, _typeof3.default)(ex)) === 'object' && 'default' in ex ? ex['default'] : ex;
	}
	
	var preact = __webpack_require__(24);
	var preact__default = _interopDefault(preact);
	var classNames = _interopDefault(__webpack_require__(49));
	
	var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
	
	function createCommonjsModule(fn, module) {
	  return module = { exports: {} }, fn(module, module.exports), module.exports;
	}
	
	var preactPortal = createCommonjsModule(function (module, exports) {
	  (function (global, factory) {
	    module.exports = factory(preact__default);
	  })(commonjsGlobal, function (preact) {
	    var classCallCheck = function classCallCheck(instance, Constructor) {
	      if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	      }
	    };
	
	    var inherits = function inherits(subClass, superClass) {
	      if (typeof superClass !== "function" && superClass !== null) {
	        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : (0, _typeof3.default)(superClass)));
	      }
	
	      subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	        constructor: {
	          value: subClass,
	          enumerable: false,
	          writable: true,
	          configurable: true
	        }
	      });
	      if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	    };
	
	    var possibleConstructorReturn = function possibleConstructorReturn(self, call) {
	      if (!self) {
	        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	      }
	
	      return call && ((typeof call === 'undefined' ? 'undefined' : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	    };
	
	    var Portal = function (_Component) {
	      inherits(Portal, _Component);
	
	      function Portal() {
	        classCallCheck(this, Portal);
	        return possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      Portal.prototype.componentDidUpdate = function componentDidUpdate(props) {
	        for (var i in props) {
	          if (props[i] !== this.props[i]) {
	            return setTimeout(this.renderLayer);
	          }
	        }
	      };
	
	      Portal.prototype.componentDidMount = function componentDidMount() {
	        this.isMounted = true;
	        this.renderLayer = this.renderLayer.bind(this);
	        this.renderLayer();
	      };
	
	      Portal.prototype.componentWillUnmount = function componentWillUnmount() {
	        this.renderLayer(false);
	        this.isMounted = false;
	        if (this.remote) this.remote.parentNode.removeChild(this.remote);
	      };
	
	      Portal.prototype.findNode = function findNode(node) {
	        return typeof node === 'string' ? document.querySelector(node) : node;
	      };
	
	      Portal.prototype.renderLayer = function renderLayer() {
	        var show = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	        if (!this.isMounted) return;
	
	        if (this.props.into !== this.intoPointer) {
	          this.intoPointer = this.props.into;
	          if (this.into && this.remote) {
	            this.remote = preact.render(preact.h(PortalProxy, null), this.into, this.remote);
	          }
	          this.into = this.findNode(this.props.into);
	        }
	
	        this.remote = preact.render(preact.h(PortalProxy, { context: this.context }, show && this.props.children || null), this.into, this.remote);
	      };
	
	      Portal.prototype.render = function render() {
	        return null;
	      };
	
	      return Portal;
	    }(preact.Component);
	
	    var PortalProxy = function (_Component2) {
	      inherits(PortalProxy, _Component2);
	
	      function PortalProxy() {
	        classCallCheck(this, PortalProxy);
	        return possibleConstructorReturn(this, _Component2.apply(this, arguments));
	      }
	
	      PortalProxy.prototype.getChildContext = function getChildContext() {
	        return this.props.context;
	      };
	
	      PortalProxy.prototype.render = function render(_ref) {
	        var children = _ref.children;
	
	        return children && children[0] || null;
	      };
	
	      return PortalProxy;
	    }(preact.Component);
	
	    return Portal;
	  });
	});
	
	function styleInject(css, ref) {
	  if (ref === void 0) ref = {};
	  var insertAt = ref.insertAt;
	
	  if (!css || typeof document === 'undefined') {
	    return;
	  }
	
	  var head = document.head || document.getElementsByTagName('head')[0];
	  var style = document.createElement('style');
	  style.type = 'text/css';
	
	  if (insertAt === 'top') {
	    if (head.firstChild) {
	      head.insertBefore(style, head.firstChild);
	    } else {
	      head.appendChild(style);
	    }
	  } else {
	    head.appendChild(style);
	  }
	
	  if (style.styleSheet) {
	    style.styleSheet.cssText = css;
	  } else {
	    style.appendChild(document.createTextNode(css));
	  }
	}
	
	var css = ".cte-button{height:32px;border:1px solid rgba(0,0,0,.13);border-radius:4px;box-sizing:border-box;min-width:80px;font-size:14px;font-family:PingFangSC-Regular;color:rgba(0,0,0,.87);margin-left:12px;cursor:pointer;transition:all .3s}.cte-button:hover{border:1px solid #1c6cdc;color:#1c6cdc}.cte-button:active{color:#1253b5;border:1px solid #1253b5}.cte-button[disabled]{cursor:not-allowed;opacity:.45}.cte-button[disabled]:active,.cte-button[disabled]:hover{border:1px solid rgba(0,0,0,.13);color:rgba(0,0,0,.87)}.cte-button-primary.cte-button{border:1px solid #1c6cdc;background:#1c6cdc;color:#fff}.cte-button-primary.cte-button[disabled]{cursor:not-allowed;opacity:.45}.cte-button-primary.cte-button[disabled]:active,.cte-button-primary.cte-button[disabled]:hover{background:#1c6cdc;color:#fff}.cte-button-primary.cte-button:hover{border:1px solid #3d91f2;background:#3d91f2;color:#fff}.cte-button-primary.cte-button:active{border:1px solid #1253b5;background:#1253b5;color:#fff}.cte-button-danger{background:#ff5f57;color:#fff}.cte-button-disabled{opacity:.45;cursor:not-allowed}";
	styleInject(css);
	
	var Button = function (_preact$Component) {
	  (0, _inherits3.default)(Button, _preact$Component);
	
	  function Button() {
	    (0, _classCallCheck3.default)(this, Button);
	    return (0, _possibleConstructorReturn3.default)(this, (Button.__proto__ || (0, _getPrototypeOf2.default)(Button)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Button, [{
	    key: 'render',
	    value: function render() {
	      var _classNames;
	
	      var _props = this.props,
	          children = _props.children,
	          type = _props.type,
	          prefix = _props.prefix,
	          disabled = _props.disabled,
	          onClick = _props.onClick;
	
	      return preact.h("button", {
	        disabled: disabled,
	        className: classNames(prefix, (_classNames = {}, (0, _defineProperty3.default)(_classNames, prefix + '-danger', type === 'danger'), (0, _defineProperty3.default)(_classNames, prefix + '-primary', type === 'primary'), (0, _defineProperty3.default)(_classNames, prefix + '-disabled', disabled), _classNames)),
	        onClick: onClick
	      }, children);
	    }
	  }]);
	  return Button;
	}(preact.Component);
	
	Button.defaultProps = {
	  type: '',
	  prefix: 'cte-button',
	  disabled: false
	};
	
	var css$1 = ".cte-modal{position:fixed;background-color:rgba(0,0,0,.5);z-index:1002}.cte-modal,.cte-modal .mask{top:0;left:0;right:0;bottom:0}.cte-modal .mask{position:absolute}.cte-modal-header{height:58px;padding:16px 24px;border-radius:4px 4px 0 0;background-color:#fff;line-height:26px;color:rgba(0,0,0,.87)}.cte-modal-header-title{font-size:18px;font-family:PingFangSC-Medium}.cte-modal-header-close{position:absolute;width:28px;height:28px;top:15px;right:20px;background:#fff;transition:all .3s;display:flex;align-items:center;justify-content:center;border-radius:50%;cursor:pointer}.cte-modal-header-close:hover{background:rgba(0,0,0,.07)}.cte-modal-header-close-icon{cursor:pointer;width:16px;height:16px;border:none;outline:none;background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg class='icon' viewBox='0 0 1024 1024' xmlns='http://www.w3.org/2000/svg' width='20' height='20'%3E%3Cdefs%3E%3Cstyle/%3E%3C/defs%3E%3Cpath d='M557.248 512l279.083 279.061-45.27 45.27L512 557.227 232.939 836.33l-45.27-45.291L466.773 512 187.67 232.939l45.27-45.27L512 466.773 791.061 187.67l45.27 45.27z' fill-opacity='.6'/%3E%3C/svg%3E\") no-repeat 50%}.cte-modal-body{padding:0 24px}.cte-modal-content{position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);width:560px;border-radius:10px;overflow:hidden;background-color:#fff;box-shadow:0 1px 4px 0 rgba(111,130,166,.08),0 16px 30px 0 rgba(111,130,166,.14)}.cte-modal-footer{display:flex;justify-content:flex-end;height:64px;padding:16px 24px;border-radius:0 0 4px 4px}";
	styleInject(css$1);
	
	var defaultModalWidth = {
	  small: 400,
	  middle: 600,
	  large: 800,
	  super: 960
	};
	
	var Modal = function (_preact$Component2) {
	  (0, _inherits3.default)(Modal, _preact$Component2);
	
	  function Modal() {
	    var _ref2;
	
	    (0, _classCallCheck3.default)(this, Modal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this2 = (0, _possibleConstructorReturn3.default)(this, (_ref2 = Modal.__proto__ || (0, _getPrototypeOf2.default)(Modal)).call.apply(_ref2, [this].concat(args)));
	
	    _this2.onKeyDown = function (e) {
	      var _this2$props = _this2.props,
	          onOk = _this2$props.onOk,
	          canEnter = _this2$props.canEnter;
	
	
	      if (!e.isComposing && (e.which === 13 || e.keyCode === 13) && canEnter) {
	        onOk();
	        e.stopPropagation();
	        e.preventDefault();
	        return false;
	      }
	    };
	    return _this2;
	  }
	
	  (0, _createClass3.default)(Modal, [{
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          children = _props2.children,
	          className = _props2.className,
	          title = _props2.title,
	          contentClassName = _props2.contentClassName,
	          _props2$okText = _props2.okText,
	          okText = _props2$okText === undefined ? "确定" : _props2$okText,
	          _props2$cancelText = _props2.cancelText,
	          cancelText = _props2$cancelText === undefined ? "取消" : _props2$cancelText,
	          onOk = _props2.onOk,
	          disabled = _props2.disabled,
	          onCancel = _props2.onCancel,
	          _props2$showFooter = _props2.showFooter,
	          showFooter = _props2$showFooter === undefined ? true : _props2$showFooter,
	          wrapper = _props2.wrapper,
	          prefix = _props2.prefix,
	          type = _props2.type;
	
	      return preact.h(preactPortal, {
	        into: wrapper || "body"
	      }, preact.h("div", {
	        className: prefix + ' ' + (className || "")
	      }, preact.h("div", {
	        className: "mask"
	      }), preact.h("div", {
	        className: prefix + '-content ' + (contentClassName || ""),
	        style: {
	          width: defaultModalWidth[type]
	        },
	        onKeyDown: this.onKeyDown
	      }, preact.h("div", {
	        className: prefix + '-header'
	      }, preact.h("div", {
	        className: prefix + '-header-title'
	      }, title), preact.h("div", {
	        className: prefix + '-header-close',
	        onClick: onCancel
	      }, preact.h("button", {
	        className: prefix + '-header-close-icon'
	      }))), preact.h("div", {
	        className: prefix + '-body'
	      }, children), showFooter && preact.h("div", {
	        className: prefix + '-footer'
	      }, preact.h(Button, {
	        onClick: onCancel
	      }, cancelText), preact.h(Button, {
	        type: "primary",
	        className: "ok",
	        onClick: onOk,
	        disabled: disabled
	      }, okText)))));
	    }
	  }]);
	  return Modal;
	}(preact.Component);
	
	Modal.defaultProps = {
	  prefix: 'cte-modal',
	  type: 'middle',
	  canEnter: false
	};
	
	var css$2 = ".ct-menu-item{position:relative;width:34px;height:34px;cursor:pointer;background-repeat:no-repeat;background-position:50%}.ct-menu-item svg{margin:4px 0 0 4px}.ct-menu-item.edit{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M13 7a.5.5 0 1 1 0 1H8a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1v-5a.5.5 0 1 1 1 0v-2 7a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h7-2zm6.854-.854a.5.5 0 0 1 0 .708l-6.364 6.364a.5.5 0 1 1-.708-.708l6.364-6.364a.5.5 0 0 1 .708 0z' fill='%23666' fill-rule='evenodd'/%3E%3C/svg%3E\")}.ct-menu-item.link{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M7.884 13.85l4.124-4.125 2.133 2.134a3.017 3.017 0 0 1 0 4.266l-1.99 1.991a3.017 3.017 0 0 1-4.267-4.266zm4.835-3.414l-.15.15a2.011 2.011 0 0 0 0 2.844l.712.711-.711.711.355.356-1.066-1.067a3.017 3.017 0 0 1 0-4.266l.149-.15.711.711zm.562 5.128l-1.842 1.841a2.011 2.011 0 0 1-2.844-2.844l1.99-1.991-.71-.711 3.975-3.975a3.017 3.017 0 0 1 4.266 4.266l-4.124 4.125-.711-.711zm-.562-5.128l.711.712-.71.71.71.712a2.011 2.011 0 0 1 0 2.844l-.15.15-.355-.356 1.067 1.067 2.133-2.134-.71-.71 1.99-1.992a2.011 2.011 0 0 0-2.844-2.844l-1.842 1.841z' fill='%23666' fill-rule='evenodd'/%3E%3C/svg%3E\")}.ct-menu-item.visitLink{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M6.674 16h1.128a6.001 6.001 0 1 0 0-6H6.674a7 7 0 1 1 0 6zm7.472-1.232l1.268-1.268H6.621a.5.5 0 1 1 0-1h8.793l-1.268-1.268a.5.5 0 0 1 .708-.707l2.1 2.101a.5.5 0 0 1 .021.727l-2.121 2.122a.5.5 0 1 1-.708-.707z' fill='%23666'/%3E%3C/g%3E%3C/svg%3E\")}.ct-menu-item.cancelLink{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M7.884 13.85l4.124-4.125 2.133 2.134a3.017 3.017 0 0 1 0 4.266l-1.99 1.991a3.017 3.017 0 0 1-4.267-4.266zm4.835-3.414l-.15.15a2.011 2.011 0 0 0 0 2.844l.712.711-.711.711.355.356-1.066-1.067a3.017 3.017 0 0 1 0-4.266l.149-.15.711.711zm.562 5.128l-1.842 1.841a2.011 2.011 0 0 1-2.844-2.844l1.99-1.991-.71-.711 3.975-3.975a3.017 3.017 0 0 1 4.266 4.266l-4.124 4.125-.711-.711zm-.562-5.128l1.842-1.841a2.011 2.011 0 1 1 2.844 2.844l-1.99 1.991.71.711-2.133 2.134-1.067-1.067.356.356.15-.15a2.011 2.011 0 0 0 0-2.844l-.712-.711.711-.711-.71-.712zM7.354 7.354a.5.5 0 0 1 .707 0l1.414 1.414a.5.5 0 1 1-.707.707L7.354 8.06a.5.5 0 0 1 0-.707zm9 9a.5.5 0 0 1 .707 0l1.414 1.414a.5.5 0 1 1-.707.707l-1.414-1.414a.5.5 0 0 1 0-.707zM17 14.5a.5.5 0 0 1 .5-.5h2a.5.5 0 1 1 0 1h-2a.5.5 0 0 1-.5-.5zm-11-3a.5.5 0 0 1 .5-.5h2a.5.5 0 1 1 0 1h-2a.5.5 0 0 1-.5-.5zM11.5 6a.5.5 0 0 1 .5.5v2a.5.5 0 1 1-1 0v-2a.5.5 0 0 1 .5-.5zm3 11a.5.5 0 0 1 .5.5v2a.5.5 0 1 1-1 0v-2a.5.5 0 0 1 .5-.5z' fill='%23666' fill-rule='evenodd'/%3E%3C/svg%3E\")}";
	styleInject(css$2);
	
	var MenItem = function (_preact$Component3) {
	  (0, _inherits3.default)(MenItem, _preact$Component3);
	
	  function MenItem() {
	    var _ref3;
	
	    (0, _classCallCheck3.default)(this, MenItem);
	
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    var _this3 = (0, _possibleConstructorReturn3.default)(this, (_ref3 = MenItem.__proto__ || (0, _getPrototypeOf2.default)(MenItem)).call.apply(_ref3, [this].concat(args)));
	
	    _this3.state = {
	      hasTooltip: false
	    };
	    return _this3;
	  }
	
	  (0, _createClass3.default)(MenItem, [{
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props3 = this.props,
	          tip = _props3.tip,
	          onClick = _props3.onClick,
	          type = _props3.type;
	
	      return preact.h("div", {
	        className: 'ct-menu-item ' + type,
	        onMouseEnter: function onMouseEnter() {
	          return _this4.setState({
	            hasTooltip: true
	          });
	        },
	        onMouseLeave: function onMouseLeave() {
	          return _this4.setState({
	            hasTooltip: false
	          });
	        },
	        onClick: onClick
	      }, this.state.hasTooltip && preact.h("span", {
	        className: "ct-toolbar-tooltip"
	      }, tip));
	    }
	  }]);
	  return MenItem;
	}(preact.Component);
	
	var css$3 = ".ct-toolbox .checkbox{display:inline-block;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;position:relative;height:16px;margin-right:6px;vertical-align:-13%;cursor:pointer;align-items:center;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ct-toolbox .checkbox input{display:none}.ct-toolbox .checkbox .checkbox-bg{position:relative;display:inline-block;box-sizing:border-box;width:16px;height:16px;border:1px solid #ddd;border-radius:2px;vertical-align:top;margin-right:6px}.ct-toolbox .checkbox input:checked+.checkbox-bg{background-color:#1c6cdc;border-color:#1c6cdc}.ct-toolbox .checkbox input:checked+.checkbox-bg:after{content:\" \";display:table;position:absolute;left:4px;top:2px;width:5px;height:8px;border:2px solid #fff;border-top:0;border-left:0;-webkit-transform:rotate(45deg);transform:rotate(45deg)}";
	styleInject(css$3);
	
	var CheckBox = function (_preact$Component4) {
	  (0, _inherits3.default)(CheckBox, _preact$Component4);
	
	  function CheckBox() {
	    (0, _classCallCheck3.default)(this, CheckBox);
	    return (0, _possibleConstructorReturn3.default)(this, (CheckBox.__proto__ || (0, _getPrototypeOf2.default)(CheckBox)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CheckBox, [{
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props,
	          checked = _props4.checked,
	          onClick = _props4.onClick,
	          children = _props4.children;
	
	      return preact.h("div", {
	        className: "checkbox",
	        onClick: onClick
	      }, preact.h("input", {
	        type: "checkbox",
	        checked: checked
	      }), preact.h("span", {
	        className: "checkbox-bg"
	      }), preact.h("span", {
	        className: "checkbox-label"
	      }, children));
	    }
	  }]);
	  return CheckBox;
	}(preact.Component);
	
	exports.Modal = Modal;
	exports.IconItem = MenItem;
	exports.CheckBox = CheckBox;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(320), __esModule: true };

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(41);
	var call = __webpack_require__(160);
	var isArrayIter = __webpack_require__(158);
	var anObject = __webpack_require__(36);
	var toLength = __webpack_require__(88);
	var getIterFn = __webpack_require__(124);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ }),
/* 59 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(166);
	var enumBugKeys = __webpack_require__(108);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(27);
	module.exports = function (it, TYPE) {
	  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
	  return it;
	};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(315), __esModule: true };

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(322), __esModule: true };

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(327), __esModule: true };

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _isIterable2 = __webpack_require__(277);
	
	var _isIterable3 = _interopRequireDefault(_isIterable2);
	
	var _getIterator2 = __webpack_require__(62);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function sliceIterator(arr, i) {
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	    var _e = undefined;
	
	    try {
	      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);
	
	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"]) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }
	
	    return _arr;
	  }
	
	  return function (arr, i) {
	    if (Array.isArray(arr)) {
	      return arr;
	    } else if ((0, _isIterable3.default)(Object(arr))) {
	      return sliceIterator(arr, i);
	    } else {
	      throw new TypeError("Invalid attempt to destructure non-iterable instance");
	    }
	  };
	}();

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _from = __webpack_require__(43);
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }
	
	    return arr2;
	  } else {
	    return (0, _from2.default)(arr);
	  }
	};

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(1));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("css", function(config, parserConfig) {
	  var inline = parserConfig.inline
	  if (!parserConfig.propertyKeywords) parserConfig = CodeMirror.resolveMode("text/css");
	
	  var indentUnit = config.indentUnit,
	      tokenHooks = parserConfig.tokenHooks,
	      documentTypes = parserConfig.documentTypes || {},
	      mediaTypes = parserConfig.mediaTypes || {},
	      mediaFeatures = parserConfig.mediaFeatures || {},
	      mediaValueKeywords = parserConfig.mediaValueKeywords || {},
	      propertyKeywords = parserConfig.propertyKeywords || {},
	      nonStandardPropertyKeywords = parserConfig.nonStandardPropertyKeywords || {},
	      fontProperties = parserConfig.fontProperties || {},
	      counterDescriptors = parserConfig.counterDescriptors || {},
	      colorKeywords = parserConfig.colorKeywords || {},
	      valueKeywords = parserConfig.valueKeywords || {},
	      allowNested = parserConfig.allowNested,
	      lineComment = parserConfig.lineComment,
	      supportsAtComponent = parserConfig.supportsAtComponent === true;
	
	  var type, override;
	  function ret(style, tp) { type = tp; return style; }
	
	  // Tokenizers
	
	  function tokenBase(stream, state) {
	    var ch = stream.next();
	    if (tokenHooks[ch]) {
	      var result = tokenHooks[ch](stream, state);
	      if (result !== false) return result;
	    }
	    if (ch == "@") {
	      stream.eatWhile(/[\w\\\-]/);
	      return ret("def", stream.current());
	    } else if (ch == "=" || (ch == "~" || ch == "|") && stream.eat("=")) {
	      return ret(null, "compare");
	    } else if (ch == "\"" || ch == "'") {
	      state.tokenize = tokenString(ch);
	      return state.tokenize(stream, state);
	    } else if (ch == "#") {
	      stream.eatWhile(/[\w\\\-]/);
	      return ret("atom", "hash");
	    } else if (ch == "!") {
	      stream.match(/^\s*\w*/);
	      return ret("keyword", "important");
	    } else if (/\d/.test(ch) || ch == "." && stream.eat(/\d/)) {
	      stream.eatWhile(/[\w.%]/);
	      return ret("number", "unit");
	    } else if (ch === "-") {
	      if (/[\d.]/.test(stream.peek())) {
	        stream.eatWhile(/[\w.%]/);
	        return ret("number", "unit");
	      } else if (stream.match(/^-[\w\\\-]*/)) {
	        stream.eatWhile(/[\w\\\-]/);
	        if (stream.match(/^\s*:/, false))
	          return ret("variable-2", "variable-definition");
	        return ret("variable-2", "variable");
	      } else if (stream.match(/^\w+-/)) {
	        return ret("meta", "meta");
	      }
	    } else if (/[,+>*\/]/.test(ch)) {
	      return ret(null, "select-op");
	    } else if (ch == "." && stream.match(/^-?[_a-z][_a-z0-9-]*/i)) {
	      return ret("qualifier", "qualifier");
	    } else if (/[:;{}\[\]\(\)]/.test(ch)) {
	      return ret(null, ch);
	    } else if (stream.match(/[\w-.]+(?=\()/)) {
	      if (/^(url(-prefix)?|domain|regexp)$/.test(stream.current().toLowerCase())) {
	        state.tokenize = tokenParenthesized;
	      }
	      return ret("variable callee", "variable");
	    } else if (/[\w\\\-]/.test(ch)) {
	      stream.eatWhile(/[\w\\\-]/);
	      return ret("property", "word");
	    } else {
	      return ret(null, null);
	    }
	  }
	
	  function tokenString(quote) {
	    return function(stream, state) {
	      var escaped = false, ch;
	      while ((ch = stream.next()) != null) {
	        if (ch == quote && !escaped) {
	          if (quote == ")") stream.backUp(1);
	          break;
	        }
	        escaped = !escaped && ch == "\\";
	      }
	      if (ch == quote || !escaped && quote != ")") state.tokenize = null;
	      return ret("string", "string");
	    };
	  }
	
	  function tokenParenthesized(stream, state) {
	    stream.next(); // Must be '('
	    if (!stream.match(/\s*[\"\')]/, false))
	      state.tokenize = tokenString(")");
	    else
	      state.tokenize = null;
	    return ret(null, "(");
	  }
	
	  // Context management
	
	  function Context(type, indent, prev) {
	    this.type = type;
	    this.indent = indent;
	    this.prev = prev;
	  }
	
	  function pushContext(state, stream, type, indent) {
	    state.context = new Context(type, stream.indentation() + (indent === false ? 0 : indentUnit), state.context);
	    return type;
	  }
	
	  function popContext(state) {
	    if (state.context.prev)
	      state.context = state.context.prev;
	    return state.context.type;
	  }
	
	  function pass(type, stream, state) {
	    return states[state.context.type](type, stream, state);
	  }
	  function popAndPass(type, stream, state, n) {
	    for (var i = n || 1; i > 0; i--)
	      state.context = state.context.prev;
	    return pass(type, stream, state);
	  }
	
	  // Parser
	
	  function wordAsValue(stream) {
	    var word = stream.current().toLowerCase();
	    if (valueKeywords.hasOwnProperty(word))
	      override = "atom";
	    else if (colorKeywords.hasOwnProperty(word))
	      override = "keyword";
	    else
	      override = "variable";
	  }
	
	  var states = {};
	
	  states.top = function(type, stream, state) {
	    if (type == "{") {
	      return pushContext(state, stream, "block");
	    } else if (type == "}" && state.context.prev) {
	      return popContext(state);
	    } else if (supportsAtComponent && /@component/i.test(type)) {
	      return pushContext(state, stream, "atComponentBlock");
	    } else if (/^@(-moz-)?document$/i.test(type)) {
	      return pushContext(state, stream, "documentTypes");
	    } else if (/^@(media|supports|(-moz-)?document|import)$/i.test(type)) {
	      return pushContext(state, stream, "atBlock");
	    } else if (/^@(font-face|counter-style)/i.test(type)) {
	      state.stateArg = type;
	      return "restricted_atBlock_before";
	    } else if (/^@(-(moz|ms|o|webkit)-)?keyframes$/i.test(type)) {
	      return "keyframes";
	    } else if (type && type.charAt(0) == "@") {
	      return pushContext(state, stream, "at");
	    } else if (type == "hash") {
	      override = "builtin";
	    } else if (type == "word") {
	      override = "tag";
	    } else if (type == "variable-definition") {
	      return "maybeprop";
	    } else if (type == "interpolation") {
	      return pushContext(state, stream, "interpolation");
	    } else if (type == ":") {
	      return "pseudo";
	    } else if (allowNested && type == "(") {
	      return pushContext(state, stream, "parens");
	    }
	    return state.context.type;
	  };
	
	  states.block = function(type, stream, state) {
	    if (type == "word") {
	      var word = stream.current().toLowerCase();
	      if (propertyKeywords.hasOwnProperty(word)) {
	        override = "property";
	        return "maybeprop";
	      } else if (nonStandardPropertyKeywords.hasOwnProperty(word)) {
	        override = "string-2";
	        return "maybeprop";
	      } else if (allowNested) {
	        override = stream.match(/^\s*:(?:\s|$)/, false) ? "property" : "tag";
	        return "block";
	      } else {
	        override += " error";
	        return "maybeprop";
	      }
	    } else if (type == "meta") {
	      return "block";
	    } else if (!allowNested && (type == "hash" || type == "qualifier")) {
	      override = "error";
	      return "block";
	    } else {
	      return states.top(type, stream, state);
	    }
	  };
	
	  states.maybeprop = function(type, stream, state) {
	    if (type == ":") return pushContext(state, stream, "prop");
	    return pass(type, stream, state);
	  };
	
	  states.prop = function(type, stream, state) {
	    if (type == ";") return popContext(state);
	    if (type == "{" && allowNested) return pushContext(state, stream, "propBlock");
	    if (type == "}" || type == "{") return popAndPass(type, stream, state);
	    if (type == "(") return pushContext(state, stream, "parens");
	
	    if (type == "hash" && !/^#([0-9a-fA-f]{3,4}|[0-9a-fA-f]{6}|[0-9a-fA-f]{8})$/.test(stream.current())) {
	      override += " error";
	    } else if (type == "word") {
	      wordAsValue(stream);
	    } else if (type == "interpolation") {
	      return pushContext(state, stream, "interpolation");
	    }
	    return "prop";
	  };
	
	  states.propBlock = function(type, _stream, state) {
	    if (type == "}") return popContext(state);
	    if (type == "word") { override = "property"; return "maybeprop"; }
	    return state.context.type;
	  };
	
	  states.parens = function(type, stream, state) {
	    if (type == "{" || type == "}") return popAndPass(type, stream, state);
	    if (type == ")") return popContext(state);
	    if (type == "(") return pushContext(state, stream, "parens");
	    if (type == "interpolation") return pushContext(state, stream, "interpolation");
	    if (type == "word") wordAsValue(stream);
	    return "parens";
	  };
	
	  states.pseudo = function(type, stream, state) {
	    if (type == "meta") return "pseudo";
	
	    if (type == "word") {
	      override = "variable-3";
	      return state.context.type;
	    }
	    return pass(type, stream, state);
	  };
	
	  states.documentTypes = function(type, stream, state) {
	    if (type == "word" && documentTypes.hasOwnProperty(stream.current())) {
	      override = "tag";
	      return state.context.type;
	    } else {
	      return states.atBlock(type, stream, state);
	    }
	  };
	
	  states.atBlock = function(type, stream, state) {
	    if (type == "(") return pushContext(state, stream, "atBlock_parens");
	    if (type == "}" || type == ";") return popAndPass(type, stream, state);
	    if (type == "{") return popContext(state) && pushContext(state, stream, allowNested ? "block" : "top");
	
	    if (type == "interpolation") return pushContext(state, stream, "interpolation");
	
	    if (type == "word") {
	      var word = stream.current().toLowerCase();
	      if (word == "only" || word == "not" || word == "and" || word == "or")
	        override = "keyword";
	      else if (mediaTypes.hasOwnProperty(word))
	        override = "attribute";
	      else if (mediaFeatures.hasOwnProperty(word))
	        override = "property";
	      else if (mediaValueKeywords.hasOwnProperty(word))
	        override = "keyword";
	      else if (propertyKeywords.hasOwnProperty(word))
	        override = "property";
	      else if (nonStandardPropertyKeywords.hasOwnProperty(word))
	        override = "string-2";
	      else if (valueKeywords.hasOwnProperty(word))
	        override = "atom";
	      else if (colorKeywords.hasOwnProperty(word))
	        override = "keyword";
	      else
	        override = "error";
	    }
	    return state.context.type;
	  };
	
	  states.atComponentBlock = function(type, stream, state) {
	    if (type == "}")
	      return popAndPass(type, stream, state);
	    if (type == "{")
	      return popContext(state) && pushContext(state, stream, allowNested ? "block" : "top", false);
	    if (type == "word")
	      override = "error";
	    return state.context.type;
	  };
	
	  states.atBlock_parens = function(type, stream, state) {
	    if (type == ")") return popContext(state);
	    if (type == "{" || type == "}") return popAndPass(type, stream, state, 2);
	    return states.atBlock(type, stream, state);
	  };
	
	  states.restricted_atBlock_before = function(type, stream, state) {
	    if (type == "{")
	      return pushContext(state, stream, "restricted_atBlock");
	    if (type == "word" && state.stateArg == "@counter-style") {
	      override = "variable";
	      return "restricted_atBlock_before";
	    }
	    return pass(type, stream, state);
	  };
	
	  states.restricted_atBlock = function(type, stream, state) {
	    if (type == "}") {
	      state.stateArg = null;
	      return popContext(state);
	    }
	    if (type == "word") {
	      if ((state.stateArg == "@font-face" && !fontProperties.hasOwnProperty(stream.current().toLowerCase())) ||
	          (state.stateArg == "@counter-style" && !counterDescriptors.hasOwnProperty(stream.current().toLowerCase())))
	        override = "error";
	      else
	        override = "property";
	      return "maybeprop";
	    }
	    return "restricted_atBlock";
	  };
	
	  states.keyframes = function(type, stream, state) {
	    if (type == "word") { override = "variable"; return "keyframes"; }
	    if (type == "{") return pushContext(state, stream, "top");
	    return pass(type, stream, state);
	  };
	
	  states.at = function(type, stream, state) {
	    if (type == ";") return popContext(state);
	    if (type == "{" || type == "}") return popAndPass(type, stream, state);
	    if (type == "word") override = "tag";
	    else if (type == "hash") override = "builtin";
	    return "at";
	  };
	
	  states.interpolation = function(type, stream, state) {
	    if (type == "}") return popContext(state);
	    if (type == "{" || type == ";") return popAndPass(type, stream, state);
	    if (type == "word") override = "variable";
	    else if (type != "variable" && type != "(" && type != ")") override = "error";
	    return "interpolation";
	  };
	
	  return {
	    startState: function(base) {
	      return {tokenize: null,
	              state: inline ? "block" : "top",
	              stateArg: null,
	              context: new Context(inline ? "block" : "top", base || 0, null)};
	    },
	
	    token: function(stream, state) {
	      if (!state.tokenize && stream.eatSpace()) return null;
	      var style = (state.tokenize || tokenBase)(stream, state);
	      if (style && typeof style == "object") {
	        type = style[1];
	        style = style[0];
	      }
	      override = style;
	      if (type != "comment")
	        state.state = states[state.state](type, stream, state);
	      return override;
	    },
	
	    indent: function(state, textAfter) {
	      var cx = state.context, ch = textAfter && textAfter.charAt(0);
	      var indent = cx.indent;
	      if (cx.type == "prop" && (ch == "}" || ch == ")")) cx = cx.prev;
	      if (cx.prev) {
	        if (ch == "}" && (cx.type == "block" || cx.type == "top" ||
	                          cx.type == "interpolation" || cx.type == "restricted_atBlock")) {
	          // Resume indentation from parent context.
	          cx = cx.prev;
	          indent = cx.indent;
	        } else if (ch == ")" && (cx.type == "parens" || cx.type == "atBlock_parens") ||
	            ch == "{" && (cx.type == "at" || cx.type == "atBlock")) {
	          // Dedent relative to current context.
	          indent = Math.max(0, cx.indent - indentUnit);
	        }
	      }
	      return indent;
	    },
	
	    electricChars: "}",
	    blockCommentStart: "/*",
	    blockCommentEnd: "*/",
	    blockCommentContinue: " * ",
	    lineComment: lineComment,
	    fold: "brace"
	  };
	});
	
	  function keySet(array) {
	    var keys = {};
	    for (var i = 0; i < array.length; ++i) {
	      keys[array[i].toLowerCase()] = true;
	    }
	    return keys;
	  }
	
	  var documentTypes_ = [
	    "domain", "regexp", "url", "url-prefix"
	  ], documentTypes = keySet(documentTypes_);
	
	  var mediaTypes_ = [
	    "all", "aural", "braille", "handheld", "print", "projection", "screen",
	    "tty", "tv", "embossed"
	  ], mediaTypes = keySet(mediaTypes_);
	
	  var mediaFeatures_ = [
	    "width", "min-width", "max-width", "height", "min-height", "max-height",
	    "device-width", "min-device-width", "max-device-width", "device-height",
	    "min-device-height", "max-device-height", "aspect-ratio",
	    "min-aspect-ratio", "max-aspect-ratio", "device-aspect-ratio",
	    "min-device-aspect-ratio", "max-device-aspect-ratio", "color", "min-color",
	    "max-color", "color-index", "min-color-index", "max-color-index",
	    "monochrome", "min-monochrome", "max-monochrome", "resolution",
	    "min-resolution", "max-resolution", "scan", "grid", "orientation",
	    "device-pixel-ratio", "min-device-pixel-ratio", "max-device-pixel-ratio",
	    "pointer", "any-pointer", "hover", "any-hover"
	  ], mediaFeatures = keySet(mediaFeatures_);
	
	  var mediaValueKeywords_ = [
	    "landscape", "portrait", "none", "coarse", "fine", "on-demand", "hover",
	    "interlace", "progressive"
	  ], mediaValueKeywords = keySet(mediaValueKeywords_);
	
	  var propertyKeywords_ = [
	    "align-content", "align-items", "align-self", "alignment-adjust",
	    "alignment-baseline", "anchor-point", "animation", "animation-delay",
	    "animation-direction", "animation-duration", "animation-fill-mode",
	    "animation-iteration-count", "animation-name", "animation-play-state",
	    "animation-timing-function", "appearance", "azimuth", "backdrop-filter",
	    "backface-visibility", "background", "background-attachment",
	    "background-blend-mode", "background-clip", "background-color",
	    "background-image", "background-origin", "background-position",
	    "background-position-x", "background-position-y", "background-repeat",
	    "background-size", "baseline-shift", "binding", "bleed", "block-size",
	    "bookmark-label", "bookmark-level", "bookmark-state", "bookmark-target",
	    "border", "border-bottom", "border-bottom-color", "border-bottom-left-radius",
	    "border-bottom-right-radius", "border-bottom-style", "border-bottom-width",
	    "border-collapse", "border-color", "border-image", "border-image-outset",
	    "border-image-repeat", "border-image-slice", "border-image-source",
	    "border-image-width", "border-left", "border-left-color", "border-left-style",
	    "border-left-width", "border-radius", "border-right", "border-right-color",
	    "border-right-style", "border-right-width", "border-spacing", "border-style",
	    "border-top", "border-top-color", "border-top-left-radius",
	    "border-top-right-radius", "border-top-style", "border-top-width",
	    "border-width", "bottom", "box-decoration-break", "box-shadow", "box-sizing",
	    "break-after", "break-before", "break-inside", "caption-side", "caret-color",
	    "clear", "clip", "color", "color-profile", "column-count", "column-fill",
	    "column-gap", "column-rule", "column-rule-color", "column-rule-style",
	    "column-rule-width", "column-span", "column-width", "columns", "contain",
	    "content", "counter-increment", "counter-reset", "crop", "cue", "cue-after",
	    "cue-before", "cursor", "direction", "display", "dominant-baseline",
	    "drop-initial-after-adjust", "drop-initial-after-align",
	    "drop-initial-before-adjust", "drop-initial-before-align", "drop-initial-size",
	    "drop-initial-value", "elevation", "empty-cells", "fit", "fit-position",
	    "flex", "flex-basis", "flex-direction", "flex-flow", "flex-grow",
	    "flex-shrink", "flex-wrap", "float", "float-offset", "flow-from", "flow-into",
	    "font", "font-family", "font-feature-settings", "font-kerning",
	    "font-language-override", "font-optical-sizing", "font-size",
	    "font-size-adjust", "font-stretch", "font-style", "font-synthesis",
	    "font-variant", "font-variant-alternates", "font-variant-caps",
	    "font-variant-east-asian", "font-variant-ligatures", "font-variant-numeric",
	    "font-variant-position", "font-variation-settings", "font-weight", "gap",
	    "grid", "grid-area", "grid-auto-columns", "grid-auto-flow", "grid-auto-rows",
	    "grid-column", "grid-column-end", "grid-column-gap", "grid-column-start",
	    "grid-gap", "grid-row", "grid-row-end", "grid-row-gap", "grid-row-start",
	    "grid-template", "grid-template-areas", "grid-template-columns",
	    "grid-template-rows", "hanging-punctuation", "height", "hyphens", "icon",
	    "image-orientation", "image-rendering", "image-resolution", "inline-box-align",
	    "inset", "inset-block", "inset-block-end", "inset-block-start", "inset-inline",
	    "inset-inline-end", "inset-inline-start", "isolation", "justify-content",
	    "justify-items", "justify-self", "left", "letter-spacing", "line-break",
	    "line-height", "line-height-step", "line-stacking", "line-stacking-ruby",
	    "line-stacking-shift", "line-stacking-strategy", "list-style",
	    "list-style-image", "list-style-position", "list-style-type", "margin",
	    "margin-bottom", "margin-left", "margin-right", "margin-top", "marks",
	    "marquee-direction", "marquee-loop", "marquee-play-count", "marquee-speed",
	    "marquee-style", "max-block-size", "max-height", "max-inline-size",
	    "max-width", "min-block-size", "min-height", "min-inline-size", "min-width",
	    "mix-blend-mode", "move-to", "nav-down", "nav-index", "nav-left", "nav-right",
	    "nav-up", "object-fit", "object-position", "offset", "offset-anchor",
	    "offset-distance", "offset-path", "offset-position", "offset-rotate",
	    "opacity", "order", "orphans", "outline", "outline-color", "outline-offset",
	    "outline-style", "outline-width", "overflow", "overflow-style",
	    "overflow-wrap", "overflow-x", "overflow-y", "padding", "padding-bottom",
	    "padding-left", "padding-right", "padding-top", "page", "page-break-after",
	    "page-break-before", "page-break-inside", "page-policy", "pause",
	    "pause-after", "pause-before", "perspective", "perspective-origin", "pitch",
	    "pitch-range", "place-content", "place-items", "place-self", "play-during",
	    "position", "presentation-level", "punctuation-trim", "quotes",
	    "region-break-after", "region-break-before", "region-break-inside",
	    "region-fragment", "rendering-intent", "resize", "rest", "rest-after",
	    "rest-before", "richness", "right", "rotate", "rotation", "rotation-point",
	    "row-gap", "ruby-align", "ruby-overhang", "ruby-position", "ruby-span",
	    "scale", "scroll-behavior", "scroll-margin", "scroll-margin-block",
	    "scroll-margin-block-end", "scroll-margin-block-start", "scroll-margin-bottom",
	    "scroll-margin-inline", "scroll-margin-inline-end",
	    "scroll-margin-inline-start", "scroll-margin-left", "scroll-margin-right",
	    "scroll-margin-top", "scroll-padding", "scroll-padding-block",
	    "scroll-padding-block-end", "scroll-padding-block-start",
	    "scroll-padding-bottom", "scroll-padding-inline", "scroll-padding-inline-end",
	    "scroll-padding-inline-start", "scroll-padding-left", "scroll-padding-right",
	    "scroll-padding-top", "scroll-snap-align", "scroll-snap-type",
	    "shape-image-threshold", "shape-inside", "shape-margin", "shape-outside",
	    "size", "speak", "speak-as", "speak-header", "speak-numeral",
	    "speak-punctuation", "speech-rate", "stress", "string-set", "tab-size",
	    "table-layout", "target", "target-name", "target-new", "target-position",
	    "text-align", "text-align-last", "text-combine-upright", "text-decoration",
	    "text-decoration-color", "text-decoration-line", "text-decoration-skip",
	    "text-decoration-skip-ink", "text-decoration-style", "text-emphasis",
	    "text-emphasis-color", "text-emphasis-position", "text-emphasis-style",
	    "text-height", "text-indent", "text-justify", "text-orientation",
	    "text-outline", "text-overflow", "text-rendering", "text-shadow",
	    "text-size-adjust", "text-space-collapse", "text-transform",
	    "text-underline-position", "text-wrap", "top", "transform", "transform-origin",
	    "transform-style", "transition", "transition-delay", "transition-duration",
	    "transition-property", "transition-timing-function", "translate",
	    "unicode-bidi", "user-select", "vertical-align", "visibility", "voice-balance",
	    "voice-duration", "voice-family", "voice-pitch", "voice-range", "voice-rate",
	    "voice-stress", "voice-volume", "volume", "white-space", "widows", "width",
	    "will-change", "word-break", "word-spacing", "word-wrap", "writing-mode", "z-index",
	    // SVG-specific
	    "clip-path", "clip-rule", "mask", "enable-background", "filter", "flood-color",
	    "flood-opacity", "lighting-color", "stop-color", "stop-opacity", "pointer-events",
	    "color-interpolation", "color-interpolation-filters",
	    "color-rendering", "fill", "fill-opacity", "fill-rule", "image-rendering",
	    "marker", "marker-end", "marker-mid", "marker-start", "shape-rendering", "stroke",
	    "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin",
	    "stroke-miterlimit", "stroke-opacity", "stroke-width", "text-rendering",
	    "baseline-shift", "dominant-baseline", "glyph-orientation-horizontal",
	    "glyph-orientation-vertical", "text-anchor", "writing-mode"
	  ], propertyKeywords = keySet(propertyKeywords_);
	
	  var nonStandardPropertyKeywords_ = [
	    "border-block", "border-block-color", "border-block-end",
	    "border-block-end-color", "border-block-end-style", "border-block-end-width",
	    "border-block-start", "border-block-start-color", "border-block-start-style",
	    "border-block-start-width", "border-block-style", "border-block-width",
	    "border-inline", "border-inline-color", "border-inline-end",
	    "border-inline-end-color", "border-inline-end-style",
	    "border-inline-end-width", "border-inline-start", "border-inline-start-color",
	    "border-inline-start-style", "border-inline-start-width",
	    "border-inline-style", "border-inline-width", "margin-block",
	    "margin-block-end", "margin-block-start", "margin-inline", "margin-inline-end",
	    "margin-inline-start", "padding-block", "padding-block-end",
	    "padding-block-start", "padding-inline", "padding-inline-end",
	    "padding-inline-start", "scroll-snap-stop", "scrollbar-3d-light-color",
	    "scrollbar-arrow-color", "scrollbar-base-color", "scrollbar-dark-shadow-color",
	    "scrollbar-face-color", "scrollbar-highlight-color", "scrollbar-shadow-color",
	    "scrollbar-track-color", "searchfield-cancel-button", "searchfield-decoration",
	    "searchfield-results-button", "searchfield-results-decoration", "shape-inside", "zoom"
	  ], nonStandardPropertyKeywords = keySet(nonStandardPropertyKeywords_);
	
	  var fontProperties_ = [
	    "font-display", "font-family", "src", "unicode-range", "font-variant",
	     "font-feature-settings", "font-stretch", "font-weight", "font-style"
	  ], fontProperties = keySet(fontProperties_);
	
	  var counterDescriptors_ = [
	    "additive-symbols", "fallback", "negative", "pad", "prefix", "range",
	    "speak-as", "suffix", "symbols", "system"
	  ], counterDescriptors = keySet(counterDescriptors_);
	
	  var colorKeywords_ = [
	    "aliceblue", "antiquewhite", "aqua", "aquamarine", "azure", "beige",
	    "bisque", "black", "blanchedalmond", "blue", "blueviolet", "brown",
	    "burlywood", "cadetblue", "chartreuse", "chocolate", "coral", "cornflowerblue",
	    "cornsilk", "crimson", "cyan", "darkblue", "darkcyan", "darkgoldenrod",
	    "darkgray", "darkgreen", "darkkhaki", "darkmagenta", "darkolivegreen",
	    "darkorange", "darkorchid", "darkred", "darksalmon", "darkseagreen",
	    "darkslateblue", "darkslategray", "darkturquoise", "darkviolet",
	    "deeppink", "deepskyblue", "dimgray", "dodgerblue", "firebrick",
	    "floralwhite", "forestgreen", "fuchsia", "gainsboro", "ghostwhite",
	    "gold", "goldenrod", "gray", "grey", "green", "greenyellow", "honeydew",
	    "hotpink", "indianred", "indigo", "ivory", "khaki", "lavender",
	    "lavenderblush", "lawngreen", "lemonchiffon", "lightblue", "lightcoral",
	    "lightcyan", "lightgoldenrodyellow", "lightgray", "lightgreen", "lightpink",
	    "lightsalmon", "lightseagreen", "lightskyblue", "lightslategray",
	    "lightsteelblue", "lightyellow", "lime", "limegreen", "linen", "magenta",
	    "maroon", "mediumaquamarine", "mediumblue", "mediumorchid", "mediumpurple",
	    "mediumseagreen", "mediumslateblue", "mediumspringgreen", "mediumturquoise",
	    "mediumvioletred", "midnightblue", "mintcream", "mistyrose", "moccasin",
	    "navajowhite", "navy", "oldlace", "olive", "olivedrab", "orange", "orangered",
	    "orchid", "palegoldenrod", "palegreen", "paleturquoise", "palevioletred",
	    "papayawhip", "peachpuff", "peru", "pink", "plum", "powderblue",
	    "purple", "rebeccapurple", "red", "rosybrown", "royalblue", "saddlebrown",
	    "salmon", "sandybrown", "seagreen", "seashell", "sienna", "silver", "skyblue",
	    "slateblue", "slategray", "snow", "springgreen", "steelblue", "tan",
	    "teal", "thistle", "tomato", "turquoise", "violet", "wheat", "white",
	    "whitesmoke", "yellow", "yellowgreen"
	  ], colorKeywords = keySet(colorKeywords_);
	
	  var valueKeywords_ = [
	    "above", "absolute", "activeborder", "additive", "activecaption", "afar",
	    "after-white-space", "ahead", "alias", "all", "all-scroll", "alphabetic", "alternate",
	    "always", "amharic", "amharic-abegede", "antialiased", "appworkspace",
	    "arabic-indic", "armenian", "asterisks", "attr", "auto", "auto-flow", "avoid", "avoid-column", "avoid-page",
	    "avoid-region", "background", "backwards", "baseline", "below", "bidi-override", "binary",
	    "bengali", "blink", "block", "block-axis", "bold", "bolder", "border", "border-box",
	    "both", "bottom", "break", "break-all", "break-word", "bullets", "button", "button-bevel",
	    "buttonface", "buttonhighlight", "buttonshadow", "buttontext", "calc", "cambodian",
	    "capitalize", "caps-lock-indicator", "caption", "captiontext", "caret",
	    "cell", "center", "checkbox", "circle", "cjk-decimal", "cjk-earthly-branch",
	    "cjk-heavenly-stem", "cjk-ideographic", "clear", "clip", "close-quote",
	    "col-resize", "collapse", "color", "color-burn", "color-dodge", "column", "column-reverse",
	    "compact", "condensed", "contain", "content", "contents",
	    "content-box", "context-menu", "continuous", "copy", "counter", "counters", "cover", "crop",
	    "cross", "crosshair", "currentcolor", "cursive", "cyclic", "darken", "dashed", "decimal",
	    "decimal-leading-zero", "default", "default-button", "dense", "destination-atop",
	    "destination-in", "destination-out", "destination-over", "devanagari", "difference",
	    "disc", "discard", "disclosure-closed", "disclosure-open", "document",
	    "dot-dash", "dot-dot-dash",
	    "dotted", "double", "down", "e-resize", "ease", "ease-in", "ease-in-out", "ease-out",
	    "element", "ellipse", "ellipsis", "embed", "end", "ethiopic", "ethiopic-abegede",
	    "ethiopic-abegede-am-et", "ethiopic-abegede-gez", "ethiopic-abegede-ti-er",
	    "ethiopic-abegede-ti-et", "ethiopic-halehame-aa-er",
	    "ethiopic-halehame-aa-et", "ethiopic-halehame-am-et",
	    "ethiopic-halehame-gez", "ethiopic-halehame-om-et",
	    "ethiopic-halehame-sid-et", "ethiopic-halehame-so-et",
	    "ethiopic-halehame-ti-er", "ethiopic-halehame-ti-et", "ethiopic-halehame-tig",
	    "ethiopic-numeric", "ew-resize", "exclusion", "expanded", "extends", "extra-condensed",
	    "extra-expanded", "fantasy", "fast", "fill", "fixed", "flat", "flex", "flex-end", "flex-start", "footnotes",
	    "forwards", "from", "geometricPrecision", "georgian", "graytext", "grid", "groove",
	    "gujarati", "gurmukhi", "hand", "hangul", "hangul-consonant", "hard-light", "hebrew",
	    "help", "hidden", "hide", "higher", "highlight", "highlighttext",
	    "hiragana", "hiragana-iroha", "horizontal", "hsl", "hsla", "hue", "icon", "ignore",
	    "inactiveborder", "inactivecaption", "inactivecaptiontext", "infinite",
	    "infobackground", "infotext", "inherit", "initial", "inline", "inline-axis",
	    "inline-block", "inline-flex", "inline-grid", "inline-table", "inset", "inside", "intrinsic", "invert",
	    "italic", "japanese-formal", "japanese-informal", "justify", "kannada",
	    "katakana", "katakana-iroha", "keep-all", "khmer",
	    "korean-hangul-formal", "korean-hanja-formal", "korean-hanja-informal",
	    "landscape", "lao", "large", "larger", "left", "level", "lighter", "lighten",
	    "line-through", "linear", "linear-gradient", "lines", "list-item", "listbox", "listitem",
	    "local", "logical", "loud", "lower", "lower-alpha", "lower-armenian",
	    "lower-greek", "lower-hexadecimal", "lower-latin", "lower-norwegian",
	    "lower-roman", "lowercase", "ltr", "luminosity", "malayalam", "match", "matrix", "matrix3d",
	    "media-controls-background", "media-current-time-display",
	    "media-fullscreen-button", "media-mute-button", "media-play-button",
	    "media-return-to-realtime-button", "media-rewind-button",
	    "media-seek-back-button", "media-seek-forward-button", "media-slider",
	    "media-sliderthumb", "media-time-remaining-display", "media-volume-slider",
	    "media-volume-slider-container", "media-volume-sliderthumb", "medium",
	    "menu", "menulist", "menulist-button", "menulist-text",
	    "menulist-textfield", "menutext", "message-box", "middle", "min-intrinsic",
	    "mix", "mongolian", "monospace", "move", "multiple", "multiply", "myanmar", "n-resize",
	    "narrower", "ne-resize", "nesw-resize", "no-close-quote", "no-drop",
	    "no-open-quote", "no-repeat", "none", "normal", "not-allowed", "nowrap",
	    "ns-resize", "numbers", "numeric", "nw-resize", "nwse-resize", "oblique", "octal", "opacity", "open-quote",
	    "optimizeLegibility", "optimizeSpeed", "oriya", "oromo", "outset",
	    "outside", "outside-shape", "overlay", "overline", "padding", "padding-box",
	    "painted", "page", "paused", "persian", "perspective", "plus-darker", "plus-lighter",
	    "pointer", "polygon", "portrait", "pre", "pre-line", "pre-wrap", "preserve-3d",
	    "progress", "push-button", "radial-gradient", "radio", "read-only",
	    "read-write", "read-write-plaintext-only", "rectangle", "region",
	    "relative", "repeat", "repeating-linear-gradient",
	    "repeating-radial-gradient", "repeat-x", "repeat-y", "reset", "reverse",
	    "rgb", "rgba", "ridge", "right", "rotate", "rotate3d", "rotateX", "rotateY",
	    "rotateZ", "round", "row", "row-resize", "row-reverse", "rtl", "run-in", "running",
	    "s-resize", "sans-serif", "saturation", "scale", "scale3d", "scaleX", "scaleY", "scaleZ", "screen",
	    "scroll", "scrollbar", "scroll-position", "se-resize", "searchfield",
	    "searchfield-cancel-button", "searchfield-decoration",
	    "searchfield-results-button", "searchfield-results-decoration", "self-start", "self-end",
	    "semi-condensed", "semi-expanded", "separate", "serif", "show", "sidama",
	    "simp-chinese-formal", "simp-chinese-informal", "single",
	    "skew", "skewX", "skewY", "skip-white-space", "slide", "slider-horizontal",
	    "slider-vertical", "sliderthumb-horizontal", "sliderthumb-vertical", "slow",
	    "small", "small-caps", "small-caption", "smaller", "soft-light", "solid", "somali",
	    "source-atop", "source-in", "source-out", "source-over", "space", "space-around", "space-between", "space-evenly", "spell-out", "square",
	    "square-button", "start", "static", "status-bar", "stretch", "stroke", "sub",
	    "subpixel-antialiased", "super", "sw-resize", "symbolic", "symbols", "system-ui", "table",
	    "table-caption", "table-cell", "table-column", "table-column-group",
	    "table-footer-group", "table-header-group", "table-row", "table-row-group",
	    "tamil",
	    "telugu", "text", "text-bottom", "text-top", "textarea", "textfield", "thai",
	    "thick", "thin", "threeddarkshadow", "threedface", "threedhighlight",
	    "threedlightshadow", "threedshadow", "tibetan", "tigre", "tigrinya-er",
	    "tigrinya-er-abegede", "tigrinya-et", "tigrinya-et-abegede", "to", "top",
	    "trad-chinese-formal", "trad-chinese-informal", "transform",
	    "translate", "translate3d", "translateX", "translateY", "translateZ",
	    "transparent", "ultra-condensed", "ultra-expanded", "underline", "unset", "up",
	    "upper-alpha", "upper-armenian", "upper-greek", "upper-hexadecimal",
	    "upper-latin", "upper-norwegian", "upper-roman", "uppercase", "urdu", "url",
	    "var", "vertical", "vertical-text", "visible", "visibleFill", "visiblePainted",
	    "visibleStroke", "visual", "w-resize", "wait", "wave", "wider",
	    "window", "windowframe", "windowtext", "words", "wrap", "wrap-reverse", "x-large", "x-small", "xor",
	    "xx-large", "xx-small"
	  ], valueKeywords = keySet(valueKeywords_);
	
	  var allWords = documentTypes_.concat(mediaTypes_).concat(mediaFeatures_).concat(mediaValueKeywords_)
	    .concat(propertyKeywords_).concat(nonStandardPropertyKeywords_).concat(colorKeywords_)
	    .concat(valueKeywords_);
	  CodeMirror.registerHelper("hintWords", "css", allWords);
	
	  function tokenCComment(stream, state) {
	    var maybeEnd = false, ch;
	    while ((ch = stream.next()) != null) {
	      if (maybeEnd && ch == "/") {
	        state.tokenize = null;
	        break;
	      }
	      maybeEnd = (ch == "*");
	    }
	    return ["comment", "comment"];
	  }
	
	  CodeMirror.defineMIME("text/css", {
	    documentTypes: documentTypes,
	    mediaTypes: mediaTypes,
	    mediaFeatures: mediaFeatures,
	    mediaValueKeywords: mediaValueKeywords,
	    propertyKeywords: propertyKeywords,
	    nonStandardPropertyKeywords: nonStandardPropertyKeywords,
	    fontProperties: fontProperties,
	    counterDescriptors: counterDescriptors,
	    colorKeywords: colorKeywords,
	    valueKeywords: valueKeywords,
	    tokenHooks: {
	      "/": function(stream, state) {
	        if (!stream.eat("*")) return false;
	        state.tokenize = tokenCComment;
	        return tokenCComment(stream, state);
	      }
	    },
	    name: "css"
	  });
	
	  CodeMirror.defineMIME("text/x-scss", {
	    mediaTypes: mediaTypes,
	    mediaFeatures: mediaFeatures,
	    mediaValueKeywords: mediaValueKeywords,
	    propertyKeywords: propertyKeywords,
	    nonStandardPropertyKeywords: nonStandardPropertyKeywords,
	    colorKeywords: colorKeywords,
	    valueKeywords: valueKeywords,
	    fontProperties: fontProperties,
	    allowNested: true,
	    lineComment: "//",
	    tokenHooks: {
	      "/": function(stream, state) {
	        if (stream.eat("/")) {
	          stream.skipToEnd();
	          return ["comment", "comment"];
	        } else if (stream.eat("*")) {
	          state.tokenize = tokenCComment;
	          return tokenCComment(stream, state);
	        } else {
	          return ["operator", "operator"];
	        }
	      },
	      ":": function(stream) {
	        if (stream.match(/\s*\{/, false))
	          return [null, null]
	        return false;
	      },
	      "$": function(stream) {
	        stream.match(/^[\w-]+/);
	        if (stream.match(/^\s*:/, false))
	          return ["variable-2", "variable-definition"];
	        return ["variable-2", "variable"];
	      },
	      "#": function(stream) {
	        if (!stream.eat("{")) return false;
	        return [null, "interpolation"];
	      }
	    },
	    name: "css",
	    helperType: "scss"
	  });
	
	  CodeMirror.defineMIME("text/x-less", {
	    mediaTypes: mediaTypes,
	    mediaFeatures: mediaFeatures,
	    mediaValueKeywords: mediaValueKeywords,
	    propertyKeywords: propertyKeywords,
	    nonStandardPropertyKeywords: nonStandardPropertyKeywords,
	    colorKeywords: colorKeywords,
	    valueKeywords: valueKeywords,
	    fontProperties: fontProperties,
	    allowNested: true,
	    lineComment: "//",
	    tokenHooks: {
	      "/": function(stream, state) {
	        if (stream.eat("/")) {
	          stream.skipToEnd();
	          return ["comment", "comment"];
	        } else if (stream.eat("*")) {
	          state.tokenize = tokenCComment;
	          return tokenCComment(stream, state);
	        } else {
	          return ["operator", "operator"];
	        }
	      },
	      "@": function(stream) {
	        if (stream.eat("{")) return [null, "interpolation"];
	        if (stream.match(/^(charset|document|font-face|import|(-(moz|ms|o|webkit)-)?keyframes|media|namespace|page|supports)\b/i, false)) return false;
	        stream.eatWhile(/[\w\\\-]/);
	        if (stream.match(/^\s*:/, false))
	          return ["variable-2", "variable-definition"];
	        return ["variable-2", "variable"];
	      },
	      "&": function() {
	        return ["atom", "atom"];
	      }
	    },
	    name: "css",
	    helperType: "less"
	  });
	
	  CodeMirror.defineMIME("text/x-gss", {
	    documentTypes: documentTypes,
	    mediaTypes: mediaTypes,
	    mediaFeatures: mediaFeatures,
	    propertyKeywords: propertyKeywords,
	    nonStandardPropertyKeywords: nonStandardPropertyKeywords,
	    fontProperties: fontProperties,
	    counterDescriptors: counterDescriptors,
	    colorKeywords: colorKeywords,
	    valueKeywords: valueKeywords,
	    supportsAtComponent: true,
	    tokenHooks: {
	      "/": function(stream, state) {
	        if (!stream.eat("*")) return false;
	        state.tokenize = tokenCComment;
	        return tokenCComment(stream, state);
	      }
	    },
	    name: "css",
	    helperType: "gss"
	  });
	
	});


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(1));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("javascript", function(config, parserConfig) {
	  var indentUnit = config.indentUnit;
	  var statementIndent = parserConfig.statementIndent;
	  var jsonldMode = parserConfig.jsonld;
	  var jsonMode = parserConfig.json || jsonldMode;
	  var isTS = parserConfig.typescript;
	  var wordRE = parserConfig.wordCharacters || /[\w$\xa1-\uffff]/;
	
	  // Tokenizer
	
	  var keywords = function(){
	    function kw(type) {return {type: type, style: "keyword"};}
	    var A = kw("keyword a"), B = kw("keyword b"), C = kw("keyword c"), D = kw("keyword d");
	    var operator = kw("operator"), atom = {type: "atom", style: "atom"};
	
	    return {
	      "if": kw("if"), "while": A, "with": A, "else": B, "do": B, "try": B, "finally": B,
	      "return": D, "break": D, "continue": D, "new": kw("new"), "delete": C, "void": C, "throw": C,
	      "debugger": kw("debugger"), "var": kw("var"), "const": kw("var"), "let": kw("var"),
	      "function": kw("function"), "catch": kw("catch"),
	      "for": kw("for"), "switch": kw("switch"), "case": kw("case"), "default": kw("default"),
	      "in": operator, "typeof": operator, "instanceof": operator,
	      "true": atom, "false": atom, "null": atom, "undefined": atom, "NaN": atom, "Infinity": atom,
	      "this": kw("this"), "class": kw("class"), "super": kw("atom"),
	      "yield": C, "export": kw("export"), "import": kw("import"), "extends": C,
	      "await": C
	    };
	  }();
	
	  var isOperatorChar = /[+\-*&%=<>!?|~^@]/;
	  var isJsonldKeyword = /^@(context|id|value|language|type|container|list|set|reverse|index|base|vocab|graph)"/;
	
	  function readRegexp(stream) {
	    var escaped = false, next, inSet = false;
	    while ((next = stream.next()) != null) {
	      if (!escaped) {
	        if (next == "/" && !inSet) return;
	        if (next == "[") inSet = true;
	        else if (inSet && next == "]") inSet = false;
	      }
	      escaped = !escaped && next == "\\";
	    }
	  }
	
	  // Used as scratch variables to communicate multiple values without
	  // consing up tons of objects.
	  var type, content;
	  function ret(tp, style, cont) {
	    type = tp; content = cont;
	    return style;
	  }
	  function tokenBase(stream, state) {
	    var ch = stream.next();
	    if (ch == '"' || ch == "'") {
	      state.tokenize = tokenString(ch);
	      return state.tokenize(stream, state);
	    } else if (ch == "." && stream.match(/^\d[\d_]*(?:[eE][+\-]?[\d_]+)?/)) {
	      return ret("number", "number");
	    } else if (ch == "." && stream.match("..")) {
	      return ret("spread", "meta");
	    } else if (/[\[\]{}\(\),;\:\.]/.test(ch)) {
	      return ret(ch);
	    } else if (ch == "=" && stream.eat(">")) {
	      return ret("=>", "operator");
	    } else if (ch == "0" && stream.match(/^(?:x[\dA-Fa-f_]+|o[0-7_]+|b[01_]+)n?/)) {
	      return ret("number", "number");
	    } else if (/\d/.test(ch)) {
	      stream.match(/^[\d_]*(?:n|(?:\.[\d_]*)?(?:[eE][+\-]?[\d_]+)?)?/);
	      return ret("number", "number");
	    } else if (ch == "/") {
	      if (stream.eat("*")) {
	        state.tokenize = tokenComment;
	        return tokenComment(stream, state);
	      } else if (stream.eat("/")) {
	        stream.skipToEnd();
	        return ret("comment", "comment");
	      } else if (expressionAllowed(stream, state, 1)) {
	        readRegexp(stream);
	        stream.match(/^\b(([gimyus])(?![gimyus]*\2))+\b/);
	        return ret("regexp", "string-2");
	      } else {
	        stream.eat("=");
	        return ret("operator", "operator", stream.current());
	      }
	    } else if (ch == "`") {
	      state.tokenize = tokenQuasi;
	      return tokenQuasi(stream, state);
	    } else if (ch == "#") {
	      stream.skipToEnd();
	      return ret("error", "error");
	    } else if (ch == "<" && stream.match("!--") || ch == "-" && stream.match("->")) {
	      stream.skipToEnd()
	      return ret("comment", "comment")
	    } else if (isOperatorChar.test(ch)) {
	      if (ch != ">" || !state.lexical || state.lexical.type != ">") {
	        if (stream.eat("=")) {
	          if (ch == "!" || ch == "=") stream.eat("=")
	        } else if (/[<>*+\-]/.test(ch)) {
	          stream.eat(ch)
	          if (ch == ">") stream.eat(ch)
	        }
	      }
	      return ret("operator", "operator", stream.current());
	    } else if (wordRE.test(ch)) {
	      stream.eatWhile(wordRE);
	      var word = stream.current()
	      if (state.lastType != ".") {
	        if (keywords.propertyIsEnumerable(word)) {
	          var kw = keywords[word]
	          return ret(kw.type, kw.style, word)
	        }
	        if (word == "async" && stream.match(/^(\s|\/\*.*?\*\/)*[\[\(\w]/, false))
	          return ret("async", "keyword", word)
	      }
	      return ret("variable", "variable", word)
	    }
	  }
	
	  function tokenString(quote) {
	    return function(stream, state) {
	      var escaped = false, next;
	      if (jsonldMode && stream.peek() == "@" && stream.match(isJsonldKeyword)){
	        state.tokenize = tokenBase;
	        return ret("jsonld-keyword", "meta");
	      }
	      while ((next = stream.next()) != null) {
	        if (next == quote && !escaped) break;
	        escaped = !escaped && next == "\\";
	      }
	      if (!escaped) state.tokenize = tokenBase;
	      return ret("string", "string");
	    };
	  }
	
	  function tokenComment(stream, state) {
	    var maybeEnd = false, ch;
	    while (ch = stream.next()) {
	      if (ch == "/" && maybeEnd) {
	        state.tokenize = tokenBase;
	        break;
	      }
	      maybeEnd = (ch == "*");
	    }
	    return ret("comment", "comment");
	  }
	
	  function tokenQuasi(stream, state) {
	    var escaped = false, next;
	    while ((next = stream.next()) != null) {
	      if (!escaped && (next == "`" || next == "$" && stream.eat("{"))) {
	        state.tokenize = tokenBase;
	        break;
	      }
	      escaped = !escaped && next == "\\";
	    }
	    return ret("quasi", "string-2", stream.current());
	  }
	
	  var brackets = "([{}])";
	  // This is a crude lookahead trick to try and notice that we're
	  // parsing the argument patterns for a fat-arrow function before we
	  // actually hit the arrow token. It only works if the arrow is on
	  // the same line as the arguments and there's no strange noise
	  // (comments) in between. Fallback is to only notice when we hit the
	  // arrow, and not declare the arguments as locals for the arrow
	  // body.
	  function findFatArrow(stream, state) {
	    if (state.fatArrowAt) state.fatArrowAt = null;
	    var arrow = stream.string.indexOf("=>", stream.start);
	    if (arrow < 0) return;
	
	    if (isTS) { // Try to skip TypeScript return type declarations after the arguments
	      var m = /:\s*(?:\w+(?:<[^>]*>|\[\])?|\{[^}]*\})\s*$/.exec(stream.string.slice(stream.start, arrow))
	      if (m) arrow = m.index
	    }
	
	    var depth = 0, sawSomething = false;
	    for (var pos = arrow - 1; pos >= 0; --pos) {
	      var ch = stream.string.charAt(pos);
	      var bracket = brackets.indexOf(ch);
	      if (bracket >= 0 && bracket < 3) {
	        if (!depth) { ++pos; break; }
	        if (--depth == 0) { if (ch == "(") sawSomething = true; break; }
	      } else if (bracket >= 3 && bracket < 6) {
	        ++depth;
	      } else if (wordRE.test(ch)) {
	        sawSomething = true;
	      } else if (/["'\/`]/.test(ch)) {
	        for (;; --pos) {
	          if (pos == 0) return
	          var next = stream.string.charAt(pos - 1)
	          if (next == ch && stream.string.charAt(pos - 2) != "\\") { pos--; break }
	        }
	      } else if (sawSomething && !depth) {
	        ++pos;
	        break;
	      }
	    }
	    if (sawSomething && !depth) state.fatArrowAt = pos;
	  }
	
	  // Parser
	
	  var atomicTypes = {"atom": true, "number": true, "variable": true, "string": true, "regexp": true, "this": true, "jsonld-keyword": true};
	
	  function JSLexical(indented, column, type, align, prev, info) {
	    this.indented = indented;
	    this.column = column;
	    this.type = type;
	    this.prev = prev;
	    this.info = info;
	    if (align != null) this.align = align;
	  }
	
	  function inScope(state, varname) {
	    for (var v = state.localVars; v; v = v.next)
	      if (v.name == varname) return true;
	    for (var cx = state.context; cx; cx = cx.prev) {
	      for (var v = cx.vars; v; v = v.next)
	        if (v.name == varname) return true;
	    }
	  }
	
	  function parseJS(state, style, type, content, stream) {
	    var cc = state.cc;
	    // Communicate our context to the combinators.
	    // (Less wasteful than consing up a hundred closures on every call.)
	    cx.state = state; cx.stream = stream; cx.marked = null, cx.cc = cc; cx.style = style;
	
	    if (!state.lexical.hasOwnProperty("align"))
	      state.lexical.align = true;
	
	    while(true) {
	      var combinator = cc.length ? cc.pop() : jsonMode ? expression : statement;
	      if (combinator(type, content)) {
	        while(cc.length && cc[cc.length - 1].lex)
	          cc.pop()();
	        if (cx.marked) return cx.marked;
	        if (type == "variable" && inScope(state, content)) return "variable-2";
	        return style;
	      }
	    }
	  }
	
	  // Combinator utils
	
	  var cx = {state: null, column: null, marked: null, cc: null};
	  function pass() {
	    for (var i = arguments.length - 1; i >= 0; i--) cx.cc.push(arguments[i]);
	  }
	  function cont() {
	    pass.apply(null, arguments);
	    return true;
	  }
	  function inList(name, list) {
	    for (var v = list; v; v = v.next) if (v.name == name) return true
	    return false;
	  }
	  function register(varname) {
	    var state = cx.state;
	    cx.marked = "def";
	    if (state.context) {
	      if (state.lexical.info == "var" && state.context && state.context.block) {
	        // FIXME function decls are also not block scoped
	        var newContext = registerVarScoped(varname, state.context)
	        if (newContext != null) {
	          state.context = newContext
	          return
	        }
	      } else if (!inList(varname, state.localVars)) {
	        state.localVars = new Var(varname, state.localVars)
	        return
	      }
	    }
	    // Fall through means this is global
	    if (parserConfig.globalVars && !inList(varname, state.globalVars))
	      state.globalVars = new Var(varname, state.globalVars)
	  }
	  function registerVarScoped(varname, context) {
	    if (!context) {
	      return null
	    } else if (context.block) {
	      var inner = registerVarScoped(varname, context.prev)
	      if (!inner) return null
	      if (inner == context.prev) return context
	      return new Context(inner, context.vars, true)
	    } else if (inList(varname, context.vars)) {
	      return context
	    } else {
	      return new Context(context.prev, new Var(varname, context.vars), false)
	    }
	  }
	
	  function isModifier(name) {
	    return name == "public" || name == "private" || name == "protected" || name == "abstract" || name == "readonly"
	  }
	
	  // Combinators
	
	  function Context(prev, vars, block) { this.prev = prev; this.vars = vars; this.block = block }
	  function Var(name, next) { this.name = name; this.next = next }
	
	  var defaultVars = new Var("this", new Var("arguments", null))
	  function pushcontext() {
	    cx.state.context = new Context(cx.state.context, cx.state.localVars, false)
	    cx.state.localVars = defaultVars
	  }
	  function pushblockcontext() {
	    cx.state.context = new Context(cx.state.context, cx.state.localVars, true)
	    cx.state.localVars = null
	  }
	  function popcontext() {
	    cx.state.localVars = cx.state.context.vars
	    cx.state.context = cx.state.context.prev
	  }
	  popcontext.lex = true
	  function pushlex(type, info) {
	    var result = function() {
	      var state = cx.state, indent = state.indented;
	      if (state.lexical.type == "stat") indent = state.lexical.indented;
	      else for (var outer = state.lexical; outer && outer.type == ")" && outer.align; outer = outer.prev)
	        indent = outer.indented;
	      state.lexical = new JSLexical(indent, cx.stream.column(), type, null, state.lexical, info);
	    };
	    result.lex = true;
	    return result;
	  }
	  function poplex() {
	    var state = cx.state;
	    if (state.lexical.prev) {
	      if (state.lexical.type == ")")
	        state.indented = state.lexical.indented;
	      state.lexical = state.lexical.prev;
	    }
	  }
	  poplex.lex = true;
	
	  function expect(wanted) {
	    function exp(type) {
	      if (type == wanted) return cont();
	      else if (wanted == ";" || type == "}" || type == ")" || type == "]") return pass();
	      else return cont(exp);
	    };
	    return exp;
	  }
	
	  function statement(type, value) {
	    if (type == "var") return cont(pushlex("vardef", value), vardef, expect(";"), poplex);
	    if (type == "keyword a") return cont(pushlex("form"), parenExpr, statement, poplex);
	    if (type == "keyword b") return cont(pushlex("form"), statement, poplex);
	    if (type == "keyword d") return cx.stream.match(/^\s*$/, false) ? cont() : cont(pushlex("stat"), maybeexpression, expect(";"), poplex);
	    if (type == "debugger") return cont(expect(";"));
	    if (type == "{") return cont(pushlex("}"), pushblockcontext, block, poplex, popcontext);
	    if (type == ";") return cont();
	    if (type == "if") {
	      if (cx.state.lexical.info == "else" && cx.state.cc[cx.state.cc.length - 1] == poplex)
	        cx.state.cc.pop()();
	      return cont(pushlex("form"), parenExpr, statement, poplex, maybeelse);
	    }
	    if (type == "function") return cont(functiondef);
	    if (type == "for") return cont(pushlex("form"), forspec, statement, poplex);
	    if (type == "class" || (isTS && value == "interface")) {
	      cx.marked = "keyword"
	      return cont(pushlex("form", type == "class" ? type : value), className, poplex)
	    }
	    if (type == "variable") {
	      if (isTS && value == "declare") {
	        cx.marked = "keyword"
	        return cont(statement)
	      } else if (isTS && (value == "module" || value == "enum" || value == "type") && cx.stream.match(/^\s*\w/, false)) {
	        cx.marked = "keyword"
	        if (value == "enum") return cont(enumdef);
	        else if (value == "type") return cont(typename, expect("operator"), typeexpr, expect(";"));
	        else return cont(pushlex("form"), pattern, expect("{"), pushlex("}"), block, poplex, poplex)
	      } else if (isTS && value == "namespace") {
	        cx.marked = "keyword"
	        return cont(pushlex("form"), expression, statement, poplex)
	      } else if (isTS && value == "abstract") {
	        cx.marked = "keyword"
	        return cont(statement)
	      } else {
	        return cont(pushlex("stat"), maybelabel);
	      }
	    }
	    if (type == "switch") return cont(pushlex("form"), parenExpr, expect("{"), pushlex("}", "switch"), pushblockcontext,
	                                      block, poplex, poplex, popcontext);
	    if (type == "case") return cont(expression, expect(":"));
	    if (type == "default") return cont(expect(":"));
	    if (type == "catch") return cont(pushlex("form"), pushcontext, maybeCatchBinding, statement, poplex, popcontext);
	    if (type == "export") return cont(pushlex("stat"), afterExport, poplex);
	    if (type == "import") return cont(pushlex("stat"), afterImport, poplex);
	    if (type == "async") return cont(statement)
	    if (value == "@") return cont(expression, statement)
	    return pass(pushlex("stat"), expression, expect(";"), poplex);
	  }
	  function maybeCatchBinding(type) {
	    if (type == "(") return cont(funarg, expect(")"))
	  }
	  function expression(type, value) {
	    return expressionInner(type, value, false);
	  }
	  function expressionNoComma(type, value) {
	    return expressionInner(type, value, true);
	  }
	  function parenExpr(type) {
	    if (type != "(") return pass()
	    return cont(pushlex(")"), maybeexpression, expect(")"), poplex)
	  }
	  function expressionInner(type, value, noComma) {
	    if (cx.state.fatArrowAt == cx.stream.start) {
	      var body = noComma ? arrowBodyNoComma : arrowBody;
	      if (type == "(") return cont(pushcontext, pushlex(")"), commasep(funarg, ")"), poplex, expect("=>"), body, popcontext);
	      else if (type == "variable") return pass(pushcontext, pattern, expect("=>"), body, popcontext);
	    }
	
	    var maybeop = noComma ? maybeoperatorNoComma : maybeoperatorComma;
	    if (atomicTypes.hasOwnProperty(type)) return cont(maybeop);
	    if (type == "function") return cont(functiondef, maybeop);
	    if (type == "class" || (isTS && value == "interface")) { cx.marked = "keyword"; return cont(pushlex("form"), classExpression, poplex); }
	    if (type == "keyword c" || type == "async") return cont(noComma ? expressionNoComma : expression);
	    if (type == "(") return cont(pushlex(")"), maybeexpression, expect(")"), poplex, maybeop);
	    if (type == "operator" || type == "spread") return cont(noComma ? expressionNoComma : expression);
	    if (type == "[") return cont(pushlex("]"), arrayLiteral, poplex, maybeop);
	    if (type == "{") return contCommasep(objprop, "}", null, maybeop);
	    if (type == "quasi") return pass(quasi, maybeop);
	    if (type == "new") return cont(maybeTarget(noComma));
	    if (type == "import") return cont(expression);
	    return cont();
	  }
	  function maybeexpression(type) {
	    if (type.match(/[;\}\)\],]/)) return pass();
	    return pass(expression);
	  }
	
	  function maybeoperatorComma(type, value) {
	    if (type == ",") return cont(maybeexpression);
	    return maybeoperatorNoComma(type, value, false);
	  }
	  function maybeoperatorNoComma(type, value, noComma) {
	    var me = noComma == false ? maybeoperatorComma : maybeoperatorNoComma;
	    var expr = noComma == false ? expression : expressionNoComma;
	    if (type == "=>") return cont(pushcontext, noComma ? arrowBodyNoComma : arrowBody, popcontext);
	    if (type == "operator") {
	      if (/\+\+|--/.test(value) || isTS && value == "!") return cont(me);
	      if (isTS && value == "<" && cx.stream.match(/^([^>]|<.*?>)*>\s*\(/, false))
	        return cont(pushlex(">"), commasep(typeexpr, ">"), poplex, me);
	      if (value == "?") return cont(expression, expect(":"), expr);
	      return cont(expr);
	    }
	    if (type == "quasi") { return pass(quasi, me); }
	    if (type == ";") return;
	    if (type == "(") return contCommasep(expressionNoComma, ")", "call", me);
	    if (type == ".") return cont(property, me);
	    if (type == "[") return cont(pushlex("]"), maybeexpression, expect("]"), poplex, me);
	    if (isTS && value == "as") { cx.marked = "keyword"; return cont(typeexpr, me) }
	    if (type == "regexp") {
	      cx.state.lastType = cx.marked = "operator"
	      cx.stream.backUp(cx.stream.pos - cx.stream.start - 1)
	      return cont(expr)
	    }
	  }
	  function quasi(type, value) {
	    if (type != "quasi") return pass();
	    if (value.slice(value.length - 2) != "${") return cont(quasi);
	    return cont(expression, continueQuasi);
	  }
	  function continueQuasi(type) {
	    if (type == "}") {
	      cx.marked = "string-2";
	      cx.state.tokenize = tokenQuasi;
	      return cont(quasi);
	    }
	  }
	  function arrowBody(type) {
	    findFatArrow(cx.stream, cx.state);
	    return pass(type == "{" ? statement : expression);
	  }
	  function arrowBodyNoComma(type) {
	    findFatArrow(cx.stream, cx.state);
	    return pass(type == "{" ? statement : expressionNoComma);
	  }
	  function maybeTarget(noComma) {
	    return function(type) {
	      if (type == ".") return cont(noComma ? targetNoComma : target);
	      else if (type == "variable" && isTS) return cont(maybeTypeArgs, noComma ? maybeoperatorNoComma : maybeoperatorComma)
	      else return pass(noComma ? expressionNoComma : expression);
	    };
	  }
	  function target(_, value) {
	    if (value == "target") { cx.marked = "keyword"; return cont(maybeoperatorComma); }
	  }
	  function targetNoComma(_, value) {
	    if (value == "target") { cx.marked = "keyword"; return cont(maybeoperatorNoComma); }
	  }
	  function maybelabel(type) {
	    if (type == ":") return cont(poplex, statement);
	    return pass(maybeoperatorComma, expect(";"), poplex);
	  }
	  function property(type) {
	    if (type == "variable") {cx.marked = "property"; return cont();}
	  }
	  function objprop(type, value) {
	    if (type == "async") {
	      cx.marked = "property";
	      return cont(objprop);
	    } else if (type == "variable" || cx.style == "keyword") {
	      cx.marked = "property";
	      if (value == "get" || value == "set") return cont(getterSetter);
	      var m // Work around fat-arrow-detection complication for detecting typescript typed arrow params
	      if (isTS && cx.state.fatArrowAt == cx.stream.start && (m = cx.stream.match(/^\s*:\s*/, false)))
	        cx.state.fatArrowAt = cx.stream.pos + m[0].length
	      return cont(afterprop);
	    } else if (type == "number" || type == "string") {
	      cx.marked = jsonldMode ? "property" : (cx.style + " property");
	      return cont(afterprop);
	    } else if (type == "jsonld-keyword") {
	      return cont(afterprop);
	    } else if (isTS && isModifier(value)) {
	      cx.marked = "keyword"
	      return cont(objprop)
	    } else if (type == "[") {
	      return cont(expression, maybetype, expect("]"), afterprop);
	    } else if (type == "spread") {
	      return cont(expressionNoComma, afterprop);
	    } else if (value == "*") {
	      cx.marked = "keyword";
	      return cont(objprop);
	    } else if (type == ":") {
	      return pass(afterprop)
	    }
	  }
	  function getterSetter(type) {
	    if (type != "variable") return pass(afterprop);
	    cx.marked = "property";
	    return cont(functiondef);
	  }
	  function afterprop(type) {
	    if (type == ":") return cont(expressionNoComma);
	    if (type == "(") return pass(functiondef);
	  }
	  function commasep(what, end, sep) {
	    function proceed(type, value) {
	      if (sep ? sep.indexOf(type) > -1 : type == ",") {
	        var lex = cx.state.lexical;
	        if (lex.info == "call") lex.pos = (lex.pos || 0) + 1;
	        return cont(function(type, value) {
	          if (type == end || value == end) return pass()
	          return pass(what)
	        }, proceed);
	      }
	      if (type == end || value == end) return cont();
	      if (sep && sep.indexOf(";") > -1) return pass(what)
	      return cont(expect(end));
	    }
	    return function(type, value) {
	      if (type == end || value == end) return cont();
	      return pass(what, proceed);
	    };
	  }
	  function contCommasep(what, end, info) {
	    for (var i = 3; i < arguments.length; i++)
	      cx.cc.push(arguments[i]);
	    return cont(pushlex(end, info), commasep(what, end), poplex);
	  }
	  function block(type) {
	    if (type == "}") return cont();
	    return pass(statement, block);
	  }
	  function maybetype(type, value) {
	    if (isTS) {
	      if (type == ":") return cont(typeexpr);
	      if (value == "?") return cont(maybetype);
	    }
	  }
	  function maybetypeOrIn(type, value) {
	    if (isTS && (type == ":" || value == "in")) return cont(typeexpr)
	  }
	  function mayberettype(type) {
	    if (isTS && type == ":") {
	      if (cx.stream.match(/^\s*\w+\s+is\b/, false)) return cont(expression, isKW, typeexpr)
	      else return cont(typeexpr)
	    }
	  }
	  function isKW(_, value) {
	    if (value == "is") {
	      cx.marked = "keyword"
	      return cont()
	    }
	  }
	  function typeexpr(type, value) {
	    if (value == "keyof" || value == "typeof" || value == "infer") {
	      cx.marked = "keyword"
	      return cont(value == "typeof" ? expressionNoComma : typeexpr)
	    }
	    if (type == "variable" || value == "void") {
	      cx.marked = "type"
	      return cont(afterType)
	    }
	    if (value == "|" || value == "&") return cont(typeexpr)
	    if (type == "string" || type == "number" || type == "atom") return cont(afterType);
	    if (type == "[") return cont(pushlex("]"), commasep(typeexpr, "]", ","), poplex, afterType)
	    if (type == "{") return cont(pushlex("}"), commasep(typeprop, "}", ",;"), poplex, afterType)
	    if (type == "(") return cont(commasep(typearg, ")"), maybeReturnType, afterType)
	    if (type == "<") return cont(commasep(typeexpr, ">"), typeexpr)
	  }
	  function maybeReturnType(type) {
	    if (type == "=>") return cont(typeexpr)
	  }
	  function typeprop(type, value) {
	    if (type == "variable" || cx.style == "keyword") {
	      cx.marked = "property"
	      return cont(typeprop)
	    } else if (value == "?" || type == "number" || type == "string") {
	      return cont(typeprop)
	    } else if (type == ":") {
	      return cont(typeexpr)
	    } else if (type == "[") {
	      return cont(expect("variable"), maybetypeOrIn, expect("]"), typeprop)
	    } else if (type == "(") {
	      return pass(functiondecl, typeprop)
	    }
	  }
	  function typearg(type, value) {
	    if (type == "variable" && cx.stream.match(/^\s*[?:]/, false) || value == "?") return cont(typearg)
	    if (type == ":") return cont(typeexpr)
	    if (type == "spread") return cont(typearg)
	    return pass(typeexpr)
	  }
	  function afterType(type, value) {
	    if (value == "<") return cont(pushlex(">"), commasep(typeexpr, ">"), poplex, afterType)
	    if (value == "|" || type == "." || value == "&") return cont(typeexpr)
	    if (type == "[") return cont(typeexpr, expect("]"), afterType)
	    if (value == "extends" || value == "implements") { cx.marked = "keyword"; return cont(typeexpr) }
	    if (value == "?") return cont(typeexpr, expect(":"), typeexpr)
	  }
	  function maybeTypeArgs(_, value) {
	    if (value == "<") return cont(pushlex(">"), commasep(typeexpr, ">"), poplex, afterType)
	  }
	  function typeparam() {
	    return pass(typeexpr, maybeTypeDefault)
	  }
	  function maybeTypeDefault(_, value) {
	    if (value == "=") return cont(typeexpr)
	  }
	  function vardef(_, value) {
	    if (value == "enum") {cx.marked = "keyword"; return cont(enumdef)}
	    return pass(pattern, maybetype, maybeAssign, vardefCont);
	  }
	  function pattern(type, value) {
	    if (isTS && isModifier(value)) { cx.marked = "keyword"; return cont(pattern) }
	    if (type == "variable") { register(value); return cont(); }
	    if (type == "spread") return cont(pattern);
	    if (type == "[") return contCommasep(eltpattern, "]");
	    if (type == "{") return contCommasep(proppattern, "}");
	  }
	  function proppattern(type, value) {
	    if (type == "variable" && !cx.stream.match(/^\s*:/, false)) {
	      register(value);
	      return cont(maybeAssign);
	    }
	    if (type == "variable") cx.marked = "property";
	    if (type == "spread") return cont(pattern);
	    if (type == "}") return pass();
	    if (type == "[") return cont(expression, expect(']'), expect(':'), proppattern);
	    return cont(expect(":"), pattern, maybeAssign);
	  }
	  function eltpattern() {
	    return pass(pattern, maybeAssign)
	  }
	  function maybeAssign(_type, value) {
	    if (value == "=") return cont(expressionNoComma);
	  }
	  function vardefCont(type) {
	    if (type == ",") return cont(vardef);
	  }
	  function maybeelse(type, value) {
	    if (type == "keyword b" && value == "else") return cont(pushlex("form", "else"), statement, poplex);
	  }
	  function forspec(type, value) {
	    if (value == "await") return cont(forspec);
	    if (type == "(") return cont(pushlex(")"), forspec1, poplex);
	  }
	  function forspec1(type) {
	    if (type == "var") return cont(vardef, forspec2);
	    if (type == "variable") return cont(forspec2);
	    return pass(forspec2)
	  }
	  function forspec2(type, value) {
	    if (type == ")") return cont()
	    if (type == ";") return cont(forspec2)
	    if (value == "in" || value == "of") { cx.marked = "keyword"; return cont(expression, forspec2) }
	    return pass(expression, forspec2)
	  }
	  function functiondef(type, value) {
	    if (value == "*") {cx.marked = "keyword"; return cont(functiondef);}
	    if (type == "variable") {register(value); return cont(functiondef);}
	    if (type == "(") return cont(pushcontext, pushlex(")"), commasep(funarg, ")"), poplex, mayberettype, statement, popcontext);
	    if (isTS && value == "<") return cont(pushlex(">"), commasep(typeparam, ">"), poplex, functiondef)
	  }
	  function functiondecl(type, value) {
	    if (value == "*") {cx.marked = "keyword"; return cont(functiondecl);}
	    if (type == "variable") {register(value); return cont(functiondecl);}
	    if (type == "(") return cont(pushcontext, pushlex(")"), commasep(funarg, ")"), poplex, mayberettype, popcontext);
	    if (isTS && value == "<") return cont(pushlex(">"), commasep(typeparam, ">"), poplex, functiondecl)
	  }
	  function typename(type, value) {
	    if (type == "keyword" || type == "variable") {
	      cx.marked = "type"
	      return cont(typename)
	    } else if (value == "<") {
	      return cont(pushlex(">"), commasep(typeparam, ">"), poplex)
	    }
	  }
	  function funarg(type, value) {
	    if (value == "@") cont(expression, funarg)
	    if (type == "spread") return cont(funarg);
	    if (isTS && isModifier(value)) { cx.marked = "keyword"; return cont(funarg); }
	    if (isTS && type == "this") return cont(maybetype, maybeAssign)
	    return pass(pattern, maybetype, maybeAssign);
	  }
	  function classExpression(type, value) {
	    // Class expressions may have an optional name.
	    if (type == "variable") return className(type, value);
	    return classNameAfter(type, value);
	  }
	  function className(type, value) {
	    if (type == "variable") {register(value); return cont(classNameAfter);}
	  }
	  function classNameAfter(type, value) {
	    if (value == "<") return cont(pushlex(">"), commasep(typeparam, ">"), poplex, classNameAfter)
	    if (value == "extends" || value == "implements" || (isTS && type == ",")) {
	      if (value == "implements") cx.marked = "keyword";
	      return cont(isTS ? typeexpr : expression, classNameAfter);
	    }
	    if (type == "{") return cont(pushlex("}"), classBody, poplex);
	  }
	  function classBody(type, value) {
	    if (type == "async" ||
	        (type == "variable" &&
	         (value == "static" || value == "get" || value == "set" || (isTS && isModifier(value))) &&
	         cx.stream.match(/^\s+[\w$\xa1-\uffff]/, false))) {
	      cx.marked = "keyword";
	      return cont(classBody);
	    }
	    if (type == "variable" || cx.style == "keyword") {
	      cx.marked = "property";
	      return cont(isTS ? classfield : functiondef, classBody);
	    }
	    if (type == "number" || type == "string") return cont(isTS ? classfield : functiondef, classBody);
	    if (type == "[")
	      return cont(expression, maybetype, expect("]"), isTS ? classfield : functiondef, classBody)
	    if (value == "*") {
	      cx.marked = "keyword";
	      return cont(classBody);
	    }
	    if (isTS && type == "(") return pass(functiondecl, classBody)
	    if (type == ";" || type == ",") return cont(classBody);
	    if (type == "}") return cont();
	    if (value == "@") return cont(expression, classBody)
	  }
	  function classfield(type, value) {
	    if (value == "?") return cont(classfield)
	    if (type == ":") return cont(typeexpr, maybeAssign)
	    if (value == "=") return cont(expressionNoComma)
	    var context = cx.state.lexical.prev, isInterface = context && context.info == "interface"
	    return pass(isInterface ? functiondecl : functiondef)
	  }
	  function afterExport(type, value) {
	    if (value == "*") { cx.marked = "keyword"; return cont(maybeFrom, expect(";")); }
	    if (value == "default") { cx.marked = "keyword"; return cont(expression, expect(";")); }
	    if (type == "{") return cont(commasep(exportField, "}"), maybeFrom, expect(";"));
	    return pass(statement);
	  }
	  function exportField(type, value) {
	    if (value == "as") { cx.marked = "keyword"; return cont(expect("variable")); }
	    if (type == "variable") return pass(expressionNoComma, exportField);
	  }
	  function afterImport(type) {
	    if (type == "string") return cont();
	    if (type == "(") return pass(expression);
	    return pass(importSpec, maybeMoreImports, maybeFrom);
	  }
	  function importSpec(type, value) {
	    if (type == "{") return contCommasep(importSpec, "}");
	    if (type == "variable") register(value);
	    if (value == "*") cx.marked = "keyword";
	    return cont(maybeAs);
	  }
	  function maybeMoreImports(type) {
	    if (type == ",") return cont(importSpec, maybeMoreImports)
	  }
	  function maybeAs(_type, value) {
	    if (value == "as") { cx.marked = "keyword"; return cont(importSpec); }
	  }
	  function maybeFrom(_type, value) {
	    if (value == "from") { cx.marked = "keyword"; return cont(expression); }
	  }
	  function arrayLiteral(type) {
	    if (type == "]") return cont();
	    return pass(commasep(expressionNoComma, "]"));
	  }
	  function enumdef() {
	    return pass(pushlex("form"), pattern, expect("{"), pushlex("}"), commasep(enummember, "}"), poplex, poplex)
	  }
	  function enummember() {
	    return pass(pattern, maybeAssign);
	  }
	
	  function isContinuedStatement(state, textAfter) {
	    return state.lastType == "operator" || state.lastType == "," ||
	      isOperatorChar.test(textAfter.charAt(0)) ||
	      /[,.]/.test(textAfter.charAt(0));
	  }
	
	  function expressionAllowed(stream, state, backUp) {
	    return state.tokenize == tokenBase &&
	      /^(?:operator|sof|keyword [bcd]|case|new|export|default|spread|[\[{}\(,;:]|=>)$/.test(state.lastType) ||
	      (state.lastType == "quasi" && /\{\s*$/.test(stream.string.slice(0, stream.pos - (backUp || 0))))
	  }
	
	  // Interface
	
	  return {
	    startState: function(basecolumn) {
	      var state = {
	        tokenize: tokenBase,
	        lastType: "sof",
	        cc: [],
	        lexical: new JSLexical((basecolumn || 0) - indentUnit, 0, "block", false),
	        localVars: parserConfig.localVars,
	        context: parserConfig.localVars && new Context(null, null, false),
	        indented: basecolumn || 0
	      };
	      if (parserConfig.globalVars && typeof parserConfig.globalVars == "object")
	        state.globalVars = parserConfig.globalVars;
	      return state;
	    },
	
	    token: function(stream, state) {
	      if (stream.sol()) {
	        if (!state.lexical.hasOwnProperty("align"))
	          state.lexical.align = false;
	        state.indented = stream.indentation();
	        findFatArrow(stream, state);
	      }
	      if (state.tokenize != tokenComment && stream.eatSpace()) return null;
	      var style = state.tokenize(stream, state);
	      if (type == "comment") return style;
	      state.lastType = type == "operator" && (content == "++" || content == "--") ? "incdec" : type;
	      return parseJS(state, style, type, content, stream);
	    },
	
	    indent: function(state, textAfter) {
	      if (state.tokenize == tokenComment) return CodeMirror.Pass;
	      if (state.tokenize != tokenBase) return 0;
	      var firstChar = textAfter && textAfter.charAt(0), lexical = state.lexical, top
	      // Kludge to prevent 'maybelse' from blocking lexical scope pops
	      if (!/^\s*else\b/.test(textAfter)) for (var i = state.cc.length - 1; i >= 0; --i) {
	        var c = state.cc[i];
	        if (c == poplex) lexical = lexical.prev;
	        else if (c != maybeelse) break;
	      }
	      while ((lexical.type == "stat" || lexical.type == "form") &&
	             (firstChar == "}" || ((top = state.cc[state.cc.length - 1]) &&
	                                   (top == maybeoperatorComma || top == maybeoperatorNoComma) &&
	                                   !/^[,\.=+\-*:?[\(]/.test(textAfter))))
	        lexical = lexical.prev;
	      if (statementIndent && lexical.type == ")" && lexical.prev.type == "stat")
	        lexical = lexical.prev;
	      var type = lexical.type, closing = firstChar == type;
	
	      if (type == "vardef") return lexical.indented + (state.lastType == "operator" || state.lastType == "," ? lexical.info.length + 1 : 0);
	      else if (type == "form" && firstChar == "{") return lexical.indented;
	      else if (type == "form") return lexical.indented + indentUnit;
	      else if (type == "stat")
	        return lexical.indented + (isContinuedStatement(state, textAfter) ? statementIndent || indentUnit : 0);
	      else if (lexical.info == "switch" && !closing && parserConfig.doubleIndentSwitch != false)
	        return lexical.indented + (/^(?:case|default)\b/.test(textAfter) ? indentUnit : 2 * indentUnit);
	      else if (lexical.align) return lexical.column + (closing ? 0 : 1);
	      else return lexical.indented + (closing ? 0 : indentUnit);
	    },
	
	    electricInput: /^\s*(?:case .*?:|default:|\{|\})$/,
	    blockCommentStart: jsonMode ? null : "/*",
	    blockCommentEnd: jsonMode ? null : "*/",
	    blockCommentContinue: jsonMode ? null : " * ",
	    lineComment: jsonMode ? null : "//",
	    fold: "brace",
	    closeBrackets: "()[]{}''\"\"``",
	
	    helperType: jsonMode ? "json" : "javascript",
	    jsonldMode: jsonldMode,
	    jsonMode: jsonMode,
	
	    expressionAllowed: expressionAllowed,
	
	    skipExpression: function(state) {
	      var top = state.cc[state.cc.length - 1]
	      if (top == expression || top == expressionNoComma) state.cc.pop()
	    }
	  };
	});
	
	CodeMirror.registerHelper("wordChars", "javascript", /[\w$]/);
	
	CodeMirror.defineMIME("text/javascript", "javascript");
	CodeMirror.defineMIME("text/ecmascript", "javascript");
	CodeMirror.defineMIME("application/javascript", "javascript");
	CodeMirror.defineMIME("application/x-javascript", "javascript");
	CodeMirror.defineMIME("application/ecmascript", "javascript");
	CodeMirror.defineMIME("application/json", {name: "javascript", json: true});
	CodeMirror.defineMIME("application/x-json", {name: "javascript", json: true});
	CodeMirror.defineMIME("application/ld+json", {name: "javascript", jsonld: true});
	CodeMirror.defineMIME("text/typescript", { name: "javascript", typescript: true });
	CodeMirror.defineMIME("application/typescript", { name: "javascript", typescript: true });
	
	});


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(1));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	var htmlConfig = {
	  autoSelfClosers: {'area': true, 'base': true, 'br': true, 'col': true, 'command': true,
	                    'embed': true, 'frame': true, 'hr': true, 'img': true, 'input': true,
	                    'keygen': true, 'link': true, 'meta': true, 'param': true, 'source': true,
	                    'track': true, 'wbr': true, 'menuitem': true},
	  implicitlyClosed: {'dd': true, 'li': true, 'optgroup': true, 'option': true, 'p': true,
	                     'rp': true, 'rt': true, 'tbody': true, 'td': true, 'tfoot': true,
	                     'th': true, 'tr': true},
	  contextGrabbers: {
	    'dd': {'dd': true, 'dt': true},
	    'dt': {'dd': true, 'dt': true},
	    'li': {'li': true},
	    'option': {'option': true, 'optgroup': true},
	    'optgroup': {'optgroup': true},
	    'p': {'address': true, 'article': true, 'aside': true, 'blockquote': true, 'dir': true,
	          'div': true, 'dl': true, 'fieldset': true, 'footer': true, 'form': true,
	          'h1': true, 'h2': true, 'h3': true, 'h4': true, 'h5': true, 'h6': true,
	          'header': true, 'hgroup': true, 'hr': true, 'menu': true, 'nav': true, 'ol': true,
	          'p': true, 'pre': true, 'section': true, 'table': true, 'ul': true},
	    'rp': {'rp': true, 'rt': true},
	    'rt': {'rp': true, 'rt': true},
	    'tbody': {'tbody': true, 'tfoot': true},
	    'td': {'td': true, 'th': true},
	    'tfoot': {'tbody': true},
	    'th': {'td': true, 'th': true},
	    'thead': {'tbody': true, 'tfoot': true},
	    'tr': {'tr': true}
	  },
	  doNotIndent: {"pre": true},
	  allowUnquoted: true,
	  allowMissing: true,
	  caseFold: true
	}
	
	var xmlConfig = {
	  autoSelfClosers: {},
	  implicitlyClosed: {},
	  contextGrabbers: {},
	  doNotIndent: {},
	  allowUnquoted: false,
	  allowMissing: false,
	  allowMissingTagName: false,
	  caseFold: false
	}
	
	CodeMirror.defineMode("xml", function(editorConf, config_) {
	  var indentUnit = editorConf.indentUnit
	  var config = {}
	  var defaults = config_.htmlMode ? htmlConfig : xmlConfig
	  for (var prop in defaults) config[prop] = defaults[prop]
	  for (var prop in config_) config[prop] = config_[prop]
	
	  // Return variables for tokenizers
	  var type, setStyle;
	
	  function inText(stream, state) {
	    function chain(parser) {
	      state.tokenize = parser;
	      return parser(stream, state);
	    }
	
	    var ch = stream.next();
	    if (ch == "<") {
	      if (stream.eat("!")) {
	        if (stream.eat("[")) {
	          if (stream.match("CDATA[")) return chain(inBlock("atom", "]]>"));
	          else return null;
	        } else if (stream.match("--")) {
	          return chain(inBlock("comment", "-->"));
	        } else if (stream.match("DOCTYPE", true, true)) {
	          stream.eatWhile(/[\w\._\-]/);
	          return chain(doctype(1));
	        } else {
	          return null;
	        }
	      } else if (stream.eat("?")) {
	        stream.eatWhile(/[\w\._\-]/);
	        state.tokenize = inBlock("meta", "?>");
	        return "meta";
	      } else {
	        type = stream.eat("/") ? "closeTag" : "openTag";
	        state.tokenize = inTag;
	        return "tag bracket";
	      }
	    } else if (ch == "&") {
	      var ok;
	      if (stream.eat("#")) {
	        if (stream.eat("x")) {
	          ok = stream.eatWhile(/[a-fA-F\d]/) && stream.eat(";");
	        } else {
	          ok = stream.eatWhile(/[\d]/) && stream.eat(";");
	        }
	      } else {
	        ok = stream.eatWhile(/[\w\.\-:]/) && stream.eat(";");
	      }
	      return ok ? "atom" : "error";
	    } else {
	      stream.eatWhile(/[^&<]/);
	      return null;
	    }
	  }
	  inText.isInText = true;
	
	  function inTag(stream, state) {
	    var ch = stream.next();
	    if (ch == ">" || (ch == "/" && stream.eat(">"))) {
	      state.tokenize = inText;
	      type = ch == ">" ? "endTag" : "selfcloseTag";
	      return "tag bracket";
	    } else if (ch == "=") {
	      type = "equals";
	      return null;
	    } else if (ch == "<") {
	      state.tokenize = inText;
	      state.state = baseState;
	      state.tagName = state.tagStart = null;
	      var next = state.tokenize(stream, state);
	      return next ? next + " tag error" : "tag error";
	    } else if (/[\'\"]/.test(ch)) {
	      state.tokenize = inAttribute(ch);
	      state.stringStartCol = stream.column();
	      return state.tokenize(stream, state);
	    } else {
	      stream.match(/^[^\s\u00a0=<>\"\']*[^\s\u00a0=<>\"\'\/]/);
	      return "word";
	    }
	  }
	
	  function inAttribute(quote) {
	    var closure = function(stream, state) {
	      while (!stream.eol()) {
	        if (stream.next() == quote) {
	          state.tokenize = inTag;
	          break;
	        }
	      }
	      return "string";
	    };
	    closure.isInAttribute = true;
	    return closure;
	  }
	
	  function inBlock(style, terminator) {
	    return function(stream, state) {
	      while (!stream.eol()) {
	        if (stream.match(terminator)) {
	          state.tokenize = inText;
	          break;
	        }
	        stream.next();
	      }
	      return style;
	    }
	  }
	
	  function doctype(depth) {
	    return function(stream, state) {
	      var ch;
	      while ((ch = stream.next()) != null) {
	        if (ch == "<") {
	          state.tokenize = doctype(depth + 1);
	          return state.tokenize(stream, state);
	        } else if (ch == ">") {
	          if (depth == 1) {
	            state.tokenize = inText;
	            break;
	          } else {
	            state.tokenize = doctype(depth - 1);
	            return state.tokenize(stream, state);
	          }
	        }
	      }
	      return "meta";
	    };
	  }
	
	  function Context(state, tagName, startOfLine) {
	    this.prev = state.context;
	    this.tagName = tagName;
	    this.indent = state.indented;
	    this.startOfLine = startOfLine;
	    if (config.doNotIndent.hasOwnProperty(tagName) || (state.context && state.context.noIndent))
	      this.noIndent = true;
	  }
	  function popContext(state) {
	    if (state.context) state.context = state.context.prev;
	  }
	  function maybePopContext(state, nextTagName) {
	    var parentTagName;
	    while (true) {
	      if (!state.context) {
	        return;
	      }
	      parentTagName = state.context.tagName;
	      if (!config.contextGrabbers.hasOwnProperty(parentTagName) ||
	          !config.contextGrabbers[parentTagName].hasOwnProperty(nextTagName)) {
	        return;
	      }
	      popContext(state);
	    }
	  }
	
	  function baseState(type, stream, state) {
	    if (type == "openTag") {
	      state.tagStart = stream.column();
	      return tagNameState;
	    } else if (type == "closeTag") {
	      return closeTagNameState;
	    } else {
	      return baseState;
	    }
	  }
	  function tagNameState(type, stream, state) {
	    if (type == "word") {
	      state.tagName = stream.current();
	      setStyle = "tag";
	      return attrState;
	    } else if (config.allowMissingTagName && type == "endTag") {
	      setStyle = "tag bracket";
	      return attrState(type, stream, state);
	    } else {
	      setStyle = "error";
	      return tagNameState;
	    }
	  }
	  function closeTagNameState(type, stream, state) {
	    if (type == "word") {
	      var tagName = stream.current();
	      if (state.context && state.context.tagName != tagName &&
	          config.implicitlyClosed.hasOwnProperty(state.context.tagName))
	        popContext(state);
	      if ((state.context && state.context.tagName == tagName) || config.matchClosing === false) {
	        setStyle = "tag";
	        return closeState;
	      } else {
	        setStyle = "tag error";
	        return closeStateErr;
	      }
	    } else if (config.allowMissingTagName && type == "endTag") {
	      setStyle = "tag bracket";
	      return closeState(type, stream, state);
	    } else {
	      setStyle = "error";
	      return closeStateErr;
	    }
	  }
	
	  function closeState(type, _stream, state) {
	    if (type != "endTag") {
	      setStyle = "error";
	      return closeState;
	    }
	    popContext(state);
	    return baseState;
	  }
	  function closeStateErr(type, stream, state) {
	    setStyle = "error";
	    return closeState(type, stream, state);
	  }
	
	  function attrState(type, _stream, state) {
	    if (type == "word") {
	      setStyle = "attribute";
	      return attrEqState;
	    } else if (type == "endTag" || type == "selfcloseTag") {
	      var tagName = state.tagName, tagStart = state.tagStart;
	      state.tagName = state.tagStart = null;
	      if (type == "selfcloseTag" ||
	          config.autoSelfClosers.hasOwnProperty(tagName)) {
	        maybePopContext(state, tagName);
	      } else {
	        maybePopContext(state, tagName);
	        state.context = new Context(state, tagName, tagStart == state.indented);
	      }
	      return baseState;
	    }
	    setStyle = "error";
	    return attrState;
	  }
	  function attrEqState(type, stream, state) {
	    if (type == "equals") return attrValueState;
	    if (!config.allowMissing) setStyle = "error";
	    return attrState(type, stream, state);
	  }
	  function attrValueState(type, stream, state) {
	    if (type == "string") return attrContinuedState;
	    if (type == "word" && config.allowUnquoted) {setStyle = "string"; return attrState;}
	    setStyle = "error";
	    return attrState(type, stream, state);
	  }
	  function attrContinuedState(type, stream, state) {
	    if (type == "string") return attrContinuedState;
	    return attrState(type, stream, state);
	  }
	
	  return {
	    startState: function(baseIndent) {
	      var state = {tokenize: inText,
	                   state: baseState,
	                   indented: baseIndent || 0,
	                   tagName: null, tagStart: null,
	                   context: null}
	      if (baseIndent != null) state.baseIndent = baseIndent
	      return state
	    },
	
	    token: function(stream, state) {
	      if (!state.tagName && stream.sol())
	        state.indented = stream.indentation();
	
	      if (stream.eatSpace()) return null;
	      type = null;
	      var style = state.tokenize(stream, state);
	      if ((style || type) && style != "comment") {
	        setStyle = null;
	        state.state = state.state(type || style, stream, state);
	        if (setStyle)
	          style = setStyle == "error" ? style + " error" : setStyle;
	      }
	      return style;
	    },
	
	    indent: function(state, textAfter, fullLine) {
	      var context = state.context;
	      // Indent multi-line strings (e.g. css).
	      if (state.tokenize.isInAttribute) {
	        if (state.tagStart == state.indented)
	          return state.stringStartCol + 1;
	        else
	          return state.indented + indentUnit;
	      }
	      if (context && context.noIndent) return CodeMirror.Pass;
	      if (state.tokenize != inTag && state.tokenize != inText)
	        return fullLine ? fullLine.match(/^(\s*)/)[0].length : 0;
	      // Indent the starts of attribute names.
	      if (state.tagName) {
	        if (config.multilineTagIndentPastTag !== false)
	          return state.tagStart + state.tagName.length + 2;
	        else
	          return state.tagStart + indentUnit * (config.multilineTagIndentFactor || 1);
	      }
	      if (config.alignCDATA && /<!\[CDATA\[/.test(textAfter)) return 0;
	      var tagAfter = textAfter && /^<(\/)?([\w_:\.-]*)/.exec(textAfter);
	      if (tagAfter && tagAfter[1]) { // Closing tag spotted
	        while (context) {
	          if (context.tagName == tagAfter[2]) {
	            context = context.prev;
	            break;
	          } else if (config.implicitlyClosed.hasOwnProperty(context.tagName)) {
	            context = context.prev;
	          } else {
	            break;
	          }
	        }
	      } else if (tagAfter) { // Opening tag spotted
	        while (context) {
	          var grabbers = config.contextGrabbers[context.tagName];
	          if (grabbers && grabbers.hasOwnProperty(tagAfter[2]))
	            context = context.prev;
	          else
	            break;
	        }
	      }
	      while (context && context.prev && !context.startOfLine)
	        context = context.prev;
	      if (context) return context.indent + indentUnit;
	      else return state.baseIndent || 0;
	    },
	
	    electricInput: /<\/[\s\w:]+>$/,
	    blockCommentStart: "<!--",
	    blockCommentEnd: "-->",
	
	    configuration: config.htmlMode ? "html" : "xml",
	    helperType: config.htmlMode ? "html" : "xml",
	
	    skipAttribute: function(state) {
	      if (state.state == attrValueState)
	        state.state = attrState
	    },
	
	    xmlCurrentTag: function(state) {
	      return state.tagName ? {name: state.tagName, close: state.type == "closeTag"} : null
	    },
	
	    xmlCurrentContext: function(state) {
	      var context = []
	      for (var cx = state.context; cx; cx = cx.prev)
	        if (cx.tagName) context.push(cx.tagName)
	      return context.reverse()
	    }
	  };
	});
	
	CodeMirror.defineMIME("text/xml", "xml");
	CodeMirror.defineMIME("application/xml", "xml");
	if (!CodeMirror.mimeModes.hasOwnProperty("text/html"))
	  CodeMirror.defineMIME("text/html", {name: "xml", htmlMode: true});
	
	});


/***/ }),
/* 70 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 71 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 72 */
/***/ (function(module, exports) {

	module.exports = true;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	var META = __webpack_require__(89)('meta');
	var isObject = __webpack_require__(27);
	var has = __webpack_require__(45);
	var setDesc = __webpack_require__(37).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(50)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),
/* 74 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 75 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(37).f;
	var has = __webpack_require__(45);
	var TAG = __webpack_require__(19)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 77 */
/***/ (function(module, exports) {



/***/ }),
/* 78 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	/**
	 * Creates a throttled function that only invokes `func` at most once per
	 * every `wait` milliseconds. The throttled function comes with a `cancel`
	 * method to cancel delayed `func` invocations and a `flush` method to
	 * immediately invoke them. Provide `options` to indicate whether `func`
	 * should be invoked on the leading and/or trailing edge of the `wait`
	 * timeout. The `func` is invoked with the last arguments provided to the
	 * throttled function. Subsequent calls to the throttled function return the
	 * result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the throttled function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.throttle` and `_.debounce`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to throttle.
	 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=true]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new throttled function.
	 * @example
	 *
	 * // Avoid excessively updating the position while scrolling.
	 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	 *
	 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	 * jQuery(element).on('click', throttled);
	 *
	 * // Cancel the trailing throttled invocation.
	 * jQuery(window).on('popstate', throttled.cancel);
	 */
	function throttle(func, wait, options) {
	  var leading = true,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  if (isObject(options)) {
	    leading = 'leading' in options ? !!options.leading : leading;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  return debounce(func, wait, {
	    'leading': leading,
	    'maxWait': wait,
	    'trailing': trailing
	  });
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = throttle;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 79 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	
	exports.default = {
	    ORIGINAL_URL_LOST: 'originalUrl is lost',
	    SHOULD_NO_SCHEMA_IN_ORIGINAL_URL: 'originalUrl should not include schema like http or https etc...',
	    PROTOCOL_UNDEFINED: 'Protocol undefined, if current env is your local machine, ignore this. if not, please contact sso administrator',
	    CONFIG_USING_LOCAL_ACCESS_POINT: "Can't get accessPoint from remote config, using local config",
	    SYS_ERROR: 'system error, plz contact sso manager',
	    STATE_ERROR: 'state not found or a pair of states is not matched(the cause maybe is csrf attack)'
	};

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var __importDefault = undefined && undefined.__importDefault || function (mod) {
	    return mod && mod.__esModule ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	
	var minimatch_1 = __importDefault(__webpack_require__(450));
	var Logger = function () {
	    function Logger(name) {
	        this.moduleName = name;
	    }
	    Logger.prototype.log = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        console.log.apply(console, ["[LOG] " + this.moduleName + " - "].concat(args));
	    };
	    Logger.prototype.warn = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        console.warn.apply(console, ["[WARN] " + this.moduleName + " - "].concat(args));
	    };
	    Logger.prototype.error = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        console.error.apply(console, ["[ERROR] " + this.moduleName + " - "].concat(args));
	    };
	    return Logger;
	}();
	exports.Logger = Logger;
	var Url = function () {
	    function Url() {}
	    Url.prototype.getSearchString = function (name) {
	        var reg = new RegExp("(/?|&)" + name + "=([^&]*)(&|$)", 'i');
	        var url = location.href.split(location.host)[1];
	        var result = url.match(reg);
	        if (result != null) {
	            return decodeURIComponent(result[2]);
	        }
	        return null;
	    };
	    Url.prototype.getReqPath = function (href, origin, prefix) {
	        if (prefix === void 0) {
	            prefix = '';
	        }
	        return href.replace(origin, '').replace(prefix, '');
	    };
	    return Url;
	}();
	exports.urlObj = new Url();
	
	exports.whiteListAndBlackListCheck = function (url, whiteLists, includeUrlList) {
	    if (whiteLists === void 0) {
	        whiteLists = [];
	    }
	    if (includeUrlList === void 0) {
	        includeUrlList = [];
	    }
	
	    if (includeUrlList && includeUrlList.length > 0) return !includeUrlList.some(function (il) {
	        return minimatch_1.default(url, il);
	    });
	
	    if (!whiteLists) whiteLists = [];
	    return whiteLists.some(function (wl) {
	        return minimatch_1.default(url, wl);
	    });
	};
	
	exports.hasSchema = function (url) {
	    var schemaReg = /^(http|https|ftp):/;
	    var noSchemaReg = /^(\/|\\)(\/|\\)/;
	    return schemaReg.test(url) || noSchemaReg.test(url);
	};
	
	exports.getBrowserVersion = function (browser) {
	    var userAgent = navigator.userAgent.toLowerCase();
	    var returnObj = {};
	    if (userAgent.indexOf("chrome") > -1 && userAgent.indexOf("safari") > -1) {
	        returnObj['chrome'] = parseInt(userAgent.match(/chrome\/([\d.]+)/)[1], 10);
	    }
	    return browser ? returnObj[browser] : returnObj;
	};

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(330), __esModule: true };

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(331), __esModule: true };

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(26);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ }),
/* 84 */
/***/ (function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(71);
	var TAG = __webpack_require__(19)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(36);
	var dPs = __webpack_require__(344);
	var enumBugKeys = __webpack_require__(108);
	var IE_PROTO = __webpack_require__(118)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(107)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(156).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	var hide = __webpack_require__(46);
	module.exports = function (target, src, safe) {
	  for (var key in src) {
	    if (safe && target[key]) target[key] = src[key];
	    else hide(target, key, src[key]);
	  } return target;
	};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(120);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 89 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.i18n = exports.use = exports.t = undefined;
	
	var _zhCN = __webpack_require__(389);
	
	var _zhCN2 = _interopRequireDefault(_zhCN);
	
	var _vue = __webpack_require__(20);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _deepmerge = __webpack_require__(381);
	
	var _deepmerge2 = _interopRequireDefault(_deepmerge);
	
	var _format = __webpack_require__(388);
	
	var _format2 = _interopRequireDefault(_format);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var format = (0, _format2.default)(_vue2.default);
	var lang = _zhCN2.default;
	var merged = false;
	var i18nHandler = function i18nHandler() {
	  var vuei18n = Object.getPrototypeOf(this || _vue2.default).$t;
	  if (typeof vuei18n === 'function' && !!_vue2.default.locale) {
	    if (!merged) {
	      merged = true;
	      _vue2.default.locale(_vue2.default.config.lang, (0, _deepmerge2.default)(lang, _vue2.default.locale(_vue2.default.config.lang) || {}, { clone: true }));
	    }
	    return vuei18n.apply(this, arguments);
	  }
	};
	
	var t = exports.t = function t(path, options) {
	  var value = i18nHandler.apply(this, arguments);
	  if (value !== null && value !== undefined) return value;
	
	  var array = path.split('.');
	  var current = lang;
	
	  for (var i = 0, j = array.length; i < j; i++) {
	    var property = array[i];
	    value = current[property];
	    if (i === j - 1) return format(value, options);
	    if (!value) return '';
	    current = value;
	  }
	  return '';
	};
	
	var use = exports.use = function use(l) {
	  lang = l || lang;
	};
	
	var i18n = exports.i18n = function i18n(fn) {
	  i18nHandler = fn || i18nHandler;
	};
	
	exports.default = { use: use, t: t, i18n: i18n };

/***/ }),
/* 91 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (target) {
	  for (var i = 1, j = arguments.length; i < j; i++) {
	    var source = arguments[i] || {};
	    for (var prop in source) {
	      if (source.hasOwnProperty(prop)) {
	        var value = source[prop];
	        if (value !== undefined) {
	          target[prop] = value;
	        }
	      }
	    }
	  }
	
	  return target;
	};
	
	;

/***/ }),
/* 92 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.isDef = isDef;
	exports.isKorean = isKorean;
	function isDef(val) {
	  return val !== undefined && val !== null;
	}
	function isKorean(text) {
	  var reg = /([(\uAC00-\uD7AF)|(\u3130-\u318F)])+/gi;
	  return reg.test(text);
	}

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _vue = __webpack_require__(20);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _popup = __webpack_require__(180);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PopperJS = _vue2.default.prototype.$isServer ? function () {} : __webpack_require__(399);
	var stop = function stop(e) {
	  return e.stopPropagation();
	};
	
	/**
	 * @param {HTMLElement} [reference=$refs.reference] - The reference element used to position the popper.
	 * @param {HTMLElement} [popper=$refs.popper] - The HTML element used as popper, or a configuration used to generate the popper.
	 * @param {String} [placement=button] - Placement of the popper accepted values: top(-start, -end), right(-start, -end), bottom(-start, -end), left(-start, -end)
	 * @param {Number} [offset=0] - Amount of pixels the popper will be shifted (can be negative).
	 * @param {Boolean} [visible=false] Visibility of the popup element.
	 * @param {Boolean} [visible-arrow=false] Visibility of the arrow, no style.
	 */
	exports.default = {
	  props: {
	    transformOrigin: {
	      type: [Boolean, String],
	      default: true
	    },
	    placement: {
	      type: String,
	      default: 'bottom'
	    },
	    boundariesPadding: {
	      type: Number,
	      default: 5
	    },
	    reference: {},
	    popper: {},
	    offset: {
	      default: 0
	    },
	    value: Boolean,
	    visibleArrow: Boolean,
	    arrowOffset: {
	      type: Number,
	      default: 35
	    },
	    appendToBody: {
	      type: Boolean,
	      default: true
	    },
	    popperOptions: {
	      type: Object,
	      default: function _default() {
	        return {
	          gpuAcceleration: false
	        };
	      }
	    }
	  },
	
	  data: function data() {
	    return {
	      showPopper: false,
	      currentPlacement: ''
	    };
	  },
	
	
	  watch: {
	    value: {
	      immediate: true,
	      handler: function handler(val) {
	        this.showPopper = val;
	        this.$emit('input', val);
	      }
	    },
	
	    showPopper: function showPopper(val) {
	      if (this.disabled) return;
	      val ? this.updatePopper() : this.destroyPopper();
	      this.$emit('input', val);
	    }
	  },
	
	  methods: {
	    createPopper: function createPopper() {
	      var _this = this;
	
	      if (this.$isServer) return;
	      this.currentPlacement = this.currentPlacement || this.placement;
	      if (!/^(top|bottom|left|right)(-start|-end)?$/g.test(this.currentPlacement)) {
	        return;
	      }
	
	      var options = this.popperOptions;
	      var popper = this.popperElm = this.popperElm || this.popper || this.$refs.popper;
	      var reference = this.referenceElm = this.referenceElm || this.reference || this.$refs.reference;
	
	      if (!reference && this.$slots.reference && this.$slots.reference[0]) {
	        reference = this.referenceElm = this.$slots.reference[0].elm;
	      }
	
	      if (!popper || !reference) return;
	      if (this.visibleArrow) this.appendArrow(popper);
	      if (this.appendToBody) document.body.appendChild(this.popperElm);
	      if (this.popperJS && this.popperJS.destroy) {
	        this.popperJS.destroy();
	      }
	
	      options.placement = this.currentPlacement;
	      options.offset = this.offset;
	      options.arrowOffset = this.arrowOffset;
	      this.popperJS = new PopperJS(reference, popper, options);
	      this.popperJS.onCreate(function (_) {
	        _this.$emit('created', _this);
	        _this.resetTransformOrigin();
	        _this.$nextTick(_this.updatePopper);
	      });
	      if (typeof options.onUpdate === 'function') {
	        this.popperJS.onUpdate(options.onUpdate);
	      }
	      this.popperJS._popper.style.zIndex = _popup.PopupManager.nextZIndex();
	      this.popperElm.addEventListener('click', stop);
	    },
	    updatePopper: function updatePopper() {
	      var popperJS = this.popperJS;
	      if (popperJS) {
	        popperJS.update();
	        if (popperJS._popper) {
	          popperJS._popper.style.zIndex = _popup.PopupManager.nextZIndex();
	        }
	      } else {
	        this.createPopper();
	      }
	    },
	    doDestroy: function doDestroy(forceDestroy) {
	      /* istanbul ignore if */
	      if (!this.popperJS || this.showPopper && !forceDestroy) return;
	      this.popperJS.destroy();
	      this.popperJS = null;
	    },
	    destroyPopper: function destroyPopper() {
	      if (this.popperJS) {
	        this.resetTransformOrigin();
	      }
	    },
	    resetTransformOrigin: function resetTransformOrigin() {
	      if (!this.transformOrigin) return;
	      var placementMap = {
	        top: 'bottom',
	        bottom: 'top',
	        left: 'right',
	        right: 'left'
	      };
	      var placement = this.popperJS._popper.getAttribute('x-placement').split('-')[0];
	      var origin = placementMap[placement];
	      this.popperJS._popper.style.transformOrigin = typeof this.transformOrigin === 'string' ? this.transformOrigin : ['top', 'bottom'].indexOf(placement) > -1 ? 'center ' + origin : origin + ' center';
	    },
	    appendArrow: function appendArrow(element) {
	      var hash = void 0;
	      if (this.appended) {
	        return;
	      }
	
	      this.appended = true;
	
	      for (var item in element.attributes) {
	        if (/^_v-/.test(element.attributes[item].name)) {
	          hash = element.attributes[item].name;
	          break;
	        }
	      }
	
	      var arrow = document.createElement('div');
	
	      if (hash) {
	        arrow.setAttribute(hash, '');
	      }
	      arrow.setAttribute('x-arrow', '');
	      arrow.className = 'popper__arrow';
	      element.appendChild(arrow);
	    }
	  },
	
	  beforeDestroy: function beforeDestroy() {
	    this.doDestroy(true);
	    if (this.popperElm && this.popperElm.parentNode === document.body) {
	      this.popperElm.removeEventListener('click', stop);
	      document.body.removeChild(this.popperElm);
	    }
	  },
	
	
	  // call destroy in keep-alive mode
	  deactivated: function deactivated() {
	    this.$options.beforeDestroy[0].call(this);
	  }
	};

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint-disable no-undefined */
	
	var throttle = __webpack_require__(134);
	
	/**
	 * Debounce execution of a function. Debouncing, unlike throttling,
	 * guarantees that a function is only executed a single time, either at the
	 * very beginning of a series of calls, or at the very end.
	 *
	 * @param  {Number}   delay         A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
	 * @param  {Boolean}  [atBegin]     Optional, defaults to false. If atBegin is false or unspecified, callback will only be executed `delay` milliseconds
	 *                                  after the last debounced-function call. If atBegin is true, callback will be executed only at the first debounced-function call.
	 *                                  (After the throttled-function has not been called for `delay` milliseconds, the internal counter is reset).
	 * @param  {Function} callback      A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
	 *                                  to `callback` when the debounced-function is executed.
	 *
	 * @return {Function} A new, debounced function.
	 */
	module.exports = function ( delay, atBegin, callback ) {
		return callback === undefined ? throttle(delay, atBegin, false) : throttle(delay, callback, atBegin !== false);
	};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var utils = __webpack_require__(28);
	var normalizeHeaderName = __webpack_require__(221);
	
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	function setContentTypeIfUnset(headers, value) {
	  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}
	
	function getDefaultAdapter() {
	  var adapter;
	  if (typeof XMLHttpRequest !== 'undefined') {
	    // For browsers use XHR adapter
	    adapter = __webpack_require__(136);
	  } else if (typeof process !== 'undefined') {
	    // For node use HTTP adapter
	    adapter = __webpack_require__(136);
	  }
	  return adapter;
	}
	
	var defaults = {
	  adapter: getDefaultAdapter(),
	
	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName(headers, 'Content-Type');
	    if (utils.isFormData(data) ||
	      utils.isArrayBuffer(data) ||
	      utils.isBuffer(data) ||
	      utils.isStream(data) ||
	      utils.isFile(data) ||
	      utils.isBlob(data)
	    ) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isURLSearchParams(data)) {
	      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }
	    if (utils.isObject(data)) {
	      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
	      return JSON.stringify(data);
	    }
	    return data;
	  }],
	
	  transformResponse: [function transformResponse(data) {
	    /*eslint no-param-reassign:0*/
	    if (typeof data === 'string') {
	      try {
	        data = JSON.parse(data);
	      } catch (e) { /* Ignore */ }
	    }
	    return data;
	  }],
	
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	
	  maxContentLength: -1,
	
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  }
	};
	
	defaults.headers = {
	  common: {
	    'Accept': 'application/json, text/plain, */*'
	  }
	};
	
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  defaults.headers[method] = {};
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
	});
	
	module.exports = defaults;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(133)))

/***/ }),
/* 96 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var RESIZER_CLASS = "ct-resizer";
	var SHADOWDOM_CLASS = "ct-web-dangers-shadow-wrapper";
	
	var POPOVER_CLASS = "ct-toolbox-popover";
	var WEB_REG = /^https?:\/\/[^/]+/;
	var BORDER_CACHE_FIELD = "image-border-cache";
	var IMAGE_MIN_WIDTH = 20;
	
	var IMAGE_MAX_HEIGHT = 600;
	var IMAGE_INFO_DISPLAY_MIN_WIDTH_SIZE = 80;
	
	var IMAGE_INFO_DISPLAY_MIN_HEIGHT_SIZE = 35;
	
	var IMAGE_OFFSET = 4;
	
	var IMAGE_DEFAULT_WIDTH = 100;
	
	var IMAGE_DEFAULT_HEIGHT = 100;
	
	var CITADELREG = /^https?:\/\/([0-9a-zA-Z\-]+(-sl-))?km\.(it\.(dev|test|beta|st)\.)?sankuai\.com/;
	
	exports.RESIZER_CLASS = RESIZER_CLASS;
	exports.SHADOWDOM_CLASS = SHADOWDOM_CLASS;
	exports.POPOVER_CLASS = POPOVER_CLASS;
	exports.WEB_REG = WEB_REG;
	exports.BORDER_CACHE_FIELD = BORDER_CACHE_FIELD;
	exports.IMAGE_MIN_WIDTH = IMAGE_MIN_WIDTH;
	exports.IMAGE_MAX_HEIGHT = IMAGE_MAX_HEIGHT;
	exports.IMAGE_INFO_DISPLAY_MIN_WIDTH_SIZE = IMAGE_INFO_DISPLAY_MIN_WIDTH_SIZE;
	exports.IMAGE_INFO_DISPLAY_MIN_HEIGHT_SIZE = IMAGE_INFO_DISPLAY_MIN_HEIGHT_SIZE;
	exports.IMAGE_OFFSET = IMAGE_OFFSET;
	exports.IMAGE_DEFAULT_WIDTH = IMAGE_DEFAULT_WIDTH;
	exports.IMAGE_DEFAULT_HEIGHT = IMAGE_DEFAULT_HEIGHT;
	exports.CITADELREG = CITADELREG;

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _set = __webpack_require__(101);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _toConsumableArray2 = __webpack_require__(66);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _weakMap = __webpack_require__(278);
	
	var _weakMap2 = _interopRequireDefault(_weakMap);
	
	var _from = __webpack_require__(43);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _getPrototypeOf = __webpack_require__(30);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(7);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(10);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(32);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(31);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _getOwnPropertyDescriptor = __webpack_require__(23);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getOwnPropertySymbols = __webpack_require__(16);
	
	var _getOwnPropertySymbols2 = _interopRequireDefault(_getOwnPropertySymbols);
	
	var _keys = __webpack_require__(13);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _defineProperty2 = __webpack_require__(15);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _assign = __webpack_require__(26);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _typeof2 = __webpack_require__(8);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault(ex) {
	  return ex && (typeof ex === 'undefined' ? 'undefined' : (0, _typeof3.default)(ex)) === 'object' && 'default' in ex ? ex['default'] : ex;
	}
	
	var keymap = __webpack_require__(34);
	var keymap__default = _interopDefault(keymap);
	var preact = __webpack_require__(24);
	var throttle = _interopDefault(__webpack_require__(78));
	var index_js = __webpack_require__(22);
	var classNames = _interopDefault(__webpack_require__(49));
	var index_js$1 = __webpack_require__(56);
	var prosemirrorState = __webpack_require__(6);
	var prosemirrorView = __webpack_require__(48);
	var prosemirrorModel = __webpack_require__(12);
	var index_js$2 = __webpack_require__(29);
	var prosemirrorTransform = __webpack_require__(25);
	
	function createCommonjsModule(fn, module) {
	  return module = { exports: {} }, fn(module, module.exports), module.exports;
	}
	
	var _extends_1 = createCommonjsModule(function (module) {
	  function _extends() {
	    module.exports = _extends = _assign2.default || function (target) {
	      for (var i = 1; i < arguments.length; i++) {
	        var source = arguments[i];
	
	        for (var key in source) {
	          if (Object.prototype.hasOwnProperty.call(source, key)) {
	            target[key] = source[key];
	          }
	        }
	      }
	
	      return target;
	    };
	
	    return _extends.apply(this, arguments);
	  }
	
	  module.exports = _extends;
	});
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    (0, _defineProperty3.default)(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	var defineProperty = _defineProperty;
	
	function _objectSpread(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? arguments[i] : {};
	    var ownKeys = (0, _keys2.default)(source);
	
	    if (typeof _getOwnPropertySymbols2.default === 'function') {
	      ownKeys = ownKeys.concat((0, _getOwnPropertySymbols2.default)(source).filter(function (sym) {
	        return (0, _getOwnPropertyDescriptor2.default)(source, sym).enumerable;
	      }));
	    }
	
	    ownKeys.forEach(function (key) {
	      defineProperty(target, key, source[key]);
	    });
	  }
	
	  return target;
	}
	
	var objectSpread = _objectSpread;
	
	var TriangleIcon = function TriangleIcon(props) {
	  return preact.h("svg", {
	    class: "icon",
	    style: "",
	    viewBox: "0 0 1638 1024",
	    version: "1.1",
	    xmlns: "http://www.w3.org/2000/svg",
	    id: "mx_n_1513063069382",
	    width: "10.8",
	    height: "7.4"
	  }, preact.h("defs", null, preact.h("style", {
	    type: "text/css"
	  })), preact.h("path", {
	    d: "M1595.8016 262.7584a160.5632 160.5632 0 0 0 31.5392-167.936A145.2032 145.2032 0 0 0 1493.4016 0H144.9984a145.408 145.408 0 0 0-133.9392 95.0272A163.0208 163.0208 0 0 0 0 154.0096c0 39.936 14.7456 79.2576 42.3936 108.7488L716.8 978.944c27.2384 28.8768 64.1024 45.056 102.4 45.056 38.5024 0 75.3664-16.384 102.4-45.056l674.2016-716.1856z",
	    fill: "#3789A9"
	  }));
	};
	
	var DashedIcon = function DashedIcon(props) {
	  return preact.h("svg", {
	    width: "48px",
	    height: "42px",
	    viewBox: "0 0 48 42",
	    version: "1.1",
	    xmlns: "http://www.w3.org/2000/svg"
	  }, preact.h("title", null, '\u865A\u7EBF\u6846'), preact.h("desc", null, "Created with Sketch."), preact.h("defs", null), preact.h("g", {
	    id: "Page-1",
	    stroke: "none",
	    "stroke-width": "1",
	    fill: "none",
	    "fill-rule": "evenodd"
	  }, preact.h("g", {
	    id: '\u8868\u683C\u5C5E\u6027'
	  }, preact.h("path", {
	    d: "M45,16.5 L45,10.5 L48,10.5 L48,16.5 L45,16.5 Z M45,25.5 L48,25.5 L48,31.5 L45,31.5 L45,25.5 Z M45,34.5 L48,34.5 L48,36 C48,39.3137085 45.3137085,42 42,42 L37.4854431,42 L37.4854431,39 L42,39 C43.6568542,39 45,37.6568542 45,36 L45,34.5 Z M34.4854431,39 L34.4854431,42 L28.4854431,42 L28.4854431,39 L34.4854431,39 Z M19.4854431,39 L19.4854431,42 L13.4854431,42 L13.4854431,39 L19.4854431,39 Z M10.4854431,39 L10.4854431,42 L6,42 C2.6862915,42 0,39.3137085 0,36 L0,34.5 L3,34.5 L3,36 C3,37.6568542 4.34314575,39 6,39 L10.4854431,39 Z M3,31.5 L0,31.5 L0,25.5 L3,25.5 L3,31.5 Z M3,16.5 L0,16.5 L0,10.5 L3,10.5 L3,16.5 Z M3,7.5 L0,7.5 L0,6 C0,2.6862915 2.6862915,0 6,0 L10.4854431,0 L10.4854431,3 L6,3 C4.34314575,3 3,4.34314575 3,6 L3,7.5 Z M13.4854431,3 L13.4854431,0 L19.4854431,0 L19.4854431,3 L13.4854431,3 Z M28.4854431,3 L28.4854431,0 L34.4854431,0 L34.4854431,3 L28.4854431,3 Z M37.4854431,3 L37.4854431,0 L42,0 C45.3137085,0 48,2.6862915 48,6 L48,7.5 L45,7.5 L45,6 C45,4.34314575 43.6568542,3 42,3 L37.4854431,3 Z",
	    fill: "#6B6B6B",
	    "fill-rule": "nonzero"
	  }), preact.h("path", {
	    d: "M25.4854431,22.5 L25.4854431,31.538842 L22.4854431,31.538842 L22.4854431,22.5 L10.2857143,22.5 L10.2857143,19.5 L22.4854431,19.5 L22.4854431,10.461158 L25.4854431,10.461158 L25.4854431,19.5 L37.7142857,19.5 L37.7142857,22.5 L25.4854431,22.5 Z M-2.27373675e-13,22.5 L-2.27373675e-13,19.5 L6.85714286,19.5 L6.85714286,22.5 L-2.27373675e-13,22.5 Z M41.1428571,22.5 L41.1428571,19.5 L48,19.5 L48,22.5 L41.1428571,22.5 Z M22.4854431,1.42108547e-14 L25.4854431,1.42108547e-14 L25.4854431,6.97410534 L22.4854431,6.97410534 L22.4854431,1.42108547e-14 Z M22.4854431,35.0258947 L25.4854431,35.0258947 L25.4854431,42 L22.4854431,42 L22.4854431,35.0258947 Z",
	    id: "Combined-Shape",
	    fill: "#CCCCCC"
	  }))));
	};
	
	var SolidIcon = function SolidIcon(props) {
	  return preact.h("svg", {
	    width: "48px",
	    height: "42px",
	    viewBox: "0 0 48 42",
	    version: "1.1",
	    xmlns: "http://www.w3.org/2000/svg"
	  }, preact.h("title", null, '\u5B9E\u7EBF\u6846'), preact.h("desc", null, "Created with Sketch."), preact.h("defs", null), preact.h("g", {
	    id: "Page-1",
	    stroke: "none",
	    "stroke-width": "1",
	    fill: "none",
	    "fill-rule": "evenodd"
	  }, preact.h("g", {
	    id: "Group-9"
	  }, preact.h("path", {
	    d: "M25.4854431,22.5 L25.4854431,31.538842 L22.4854431,31.538842 L22.4854431,22.5 L17.1428571,22.5 L10.2857143,22.5 L10.2857143,19.5 L17.1428571,19.5 L22.4854431,19.5 L22.4854431,10.461158 L25.4854431,10.461158 L25.4854431,19.5 L33.7302246,19.5 L37.7142857,19.5 L37.7142857,22.5 L33.7302246,22.5 L25.4854431,22.5 Z M0,22.5 L0,19.5 L6.85714286,19.5 L6.85714286,22.5 L0,22.5 Z M41.1428571,22.5 L41.1428571,19.5 L48,19.5 L48,22.5 L41.1428571,22.5 Z M22.4854431,0 L25.4854431,0 L25.4854431,6.97410534 L22.4854431,6.97410534 L22.4854431,0 Z M22.4854431,35.0258947 L25.4854431,35.0258947 L25.4854431,42 L22.4854431,42 L22.4854431,35.0258947 Z",
	    id: "Combined-Shape",
	    fill: "#CCCCCC"
	  }), preact.h("path", {
	    d: "M6,3 C4.34314575,3 3,4.34314575 3,6 L3,36 C3,37.6568542 4.34314575,39 6,39 L42,39 C43.6568542,39 45,37.6568542 45,36 L45,6 C45,4.34314575 43.6568542,3 42,3 L6,3 Z M6,0 L42,0 C45.3137085,0 48,2.6862915 48,6 L48,36 C48,39.3137085 45.3137085,42 42,42 L6,42 C2.6862915,42 0,39.3137085 0,36 L0,6 C0,2.6862915 2.6862915,0 6,0 Z",
	    id: "Rectangle-15",
	    fill: "#6B6B6B",
	    "fill-rule": "nonzero"
	  }))));
	};
	
	function styleInject(css, ref) {
	  if (ref === void 0) ref = {};
	  var insertAt = ref.insertAt;
	
	  if (!css || typeof document === 'undefined') {
	    return;
	  }
	
	  var head = document.head || document.getElementsByTagName('head')[0];
	  var style = document.createElement('style');
	  style.type = 'text/css';
	
	  if (insertAt === 'top') {
	    if (head.firstChild) {
	      head.insertBefore(style, head.firstChild);
	    } else {
	      head.appendChild(style);
	    }
	  } else {
	    head.appendChild(style);
	  }
	
	  if (style.styleSheet) {
	    style.styleSheet.cssText = css;
	  } else {
	    style.appendChild(document.createTextNode(css));
	  }
	}
	
	var css = ".toolbar-color-popover-wrapper{display:flex;justify-content:center;align-items:center;position:relative;height:28px;width:40px;font-size:12px;cursor:pointer;transition:all .2s ease}.toolbar-color-popover-wrapper.disabled{cursor:not-allowed}.toolbar-color-popover-wrapper.disabled path{fill:#aaa}.toolbar-color-popover-wrapper .left{width:26px;height:100%}.toolbar-color-popover-wrapper .right{width:14px;height:100%;background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='7' height='4' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M.5.5h6l-3 3z' fill='%23AEAEAE' fill-rule='evenodd'/%3E%3C/svg%3E\") no-repeat 50%}.toolbar-color-popover-wrapper.font-color{position:relative}.toolbar-color-popover-wrapper.font-color .left{background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='10' height='10' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6.62 5.902L5.01 1.484 3.302 5.902H6.62zM4.26 0h1.624l3.844 10H8.156L7.08 7.005H2.89L1.743 10H.272L4.26 0z' fill='%23666' fill-rule='evenodd'/%3E%3C/svg%3E\") no-repeat 7px 7px}.toolbar-color-popover-wrapper.font-color .left .color{position:absolute;left:5px;bottom:7px;width:14px;height:2px;border:1px solid;margin:0 auto}.toolbar-color-popover-wrapper.bg-color .left{position:relative}.toolbar-color-popover-wrapper.bg-color .color{position:absolute;top:18px;left:5px;width:14px;height:2px}.toolbar-color-popover-wrapper.border-color{width:246px}.toolbar-color-popover{display:flex;justify-content:flex-start;align-items:flex-start;flex-wrap:wrap;position:absolute;width:258px;height:150px;bottom:-152px;left:0;padding:8px;border-radius:2px;background:#fff;border:1px solid #eee;box-shadow:0 1px 4px 0 rgba(111,130,166,.08),0 16px 30px 0 rgba(111,130,166,.14);z-index:2}.toolbar-color-popover .default{position:relative;width:calc(100% - 2px);margin:0 1px 8px;height:24px;border:1px solid #ddd;border-radius:2px;cursor:pointer}.toolbar-color-popover .color-grid{position:absolute;top:5px;left:10px;width:13px;height:13px;border:1px solid}.toolbar-color-popover .text{height:24px;line-height:24px;text-align:center;font-size:12px;color:#333}.toolbar-color-grid{margin:0 2px;width:16px;height:16px;cursor:pointer}.toolbar-color-grid:nth-child(2),.toolbar-color-grid:nth-child(12){border:1px solid #eee}.toolbar-color-grid.selected{z-index:2;border-radius:1px;border:1px solid #fff;box-shadow:0 0 0 2px #999}.toolbar-color-grid:hover{z-index:3;border-radius:1px;border:1px solid #fff}.toolbar-color-grid:hover:nth-child(3){box-shadow:0 0 0 2px #333}.toolbar-color-grid:hover:nth-child(4){box-shadow:0 0 0 2px #f5222d}.toolbar-color-grid:hover:nth-child(5){box-shadow:0 0 0 2px #fa541c}.toolbar-color-grid:hover:nth-child(6){box-shadow:0 0 0 2px #faad14}.toolbar-color-grid:hover:nth-child(7){box-shadow:0 0 0 2px #fadb14}.toolbar-color-grid:hover:nth-child(8){box-shadow:0 0 0 2px #52c41a}.toolbar-color-grid:hover:nth-child(9){box-shadow:0 0 0 2px #13c2c2}.toolbar-color-grid:hover:nth-child(10){box-shadow:0 0 0 2px #1890ff}.toolbar-color-grid:hover:nth-child(11){box-shadow:0 0 0 2px #2f54eb}.toolbar-color-grid:hover:nth-child(12){box-shadow:0 0 0 2px #722ed1}.toolbar-color-grid:hover:nth-child(13){box-shadow:0 0 0 2px #eb2f96}.toolbar-color-grid:hover:nth-child(14){box-shadow:0 0 0 2px #f6f6f6}.toolbar-color-grid:hover:nth-child(15){box-shadow:0 0 0 2px #989898}.toolbar-color-grid:hover:nth-child(16){box-shadow:0 0 0 2px #ffe8e7}.toolbar-color-grid:hover:nth-child(17){box-shadow:0 0 0 2px #ffece0}.toolbar-color-grid:hover:nth-child(18){box-shadow:0 0 0 2px #fff7cb}.toolbar-color-grid:hover:nth-child(19){box-shadow:0 0 0 2px #fcfcca}.toolbar-color-grid:hover:nth-child(20){box-shadow:0 0 0 2px #e5f7d3}.toolbar-color-grid:hover:nth-child(21){box-shadow:0 0 0 2px #cffff7}.toolbar-color-grid:hover:nth-child(22){box-shadow:0 0 0 2px #d4eefc}.toolbar-color-grid:hover:nth-child(23){box-shadow:0 0 0 2px #dfe8fc}.toolbar-color-grid:hover:nth-child(24){box-shadow:0 0 0 2px #efe1fa}.toolbar-color-grid:hover:nth-child(25){box-shadow:0 0 0 2px #fbe1eb}.toolbar-color-grid:hover:nth-child(26){box-shadow:0 0 0 2px #e9e9e9}.toolbar-color-grid:hover:nth-child(27){box-shadow:0 0 0 2px #666}.toolbar-color-grid:hover:nth-child(28){box-shadow:0 0 0 2px #ffa39e}.toolbar-color-grid:hover:nth-child(29){box-shadow:0 0 0 2px #ffbb96}.toolbar-color-grid:hover:nth-child(30){box-shadow:0 0 0 2px #ffe58f}.toolbar-color-grid:hover:nth-child(31){box-shadow:0 0 0 2px #fffb8f}.toolbar-color-grid:hover:nth-child(32){box-shadow:0 0 0 2px #b7eb8f}.toolbar-color-grid:hover:nth-child(33){box-shadow:0 0 0 2px #87e8de}.toolbar-color-grid:hover:nth-child(34){box-shadow:0 0 0 2px #91d5ff}.toolbar-color-grid:hover:nth-child(35){box-shadow:0 0 0 2px #adc6ff}.toolbar-color-grid:hover:nth-child(36){box-shadow:0 0 0 2px #d3adf7}.toolbar-color-grid:hover:nth-child(37){box-shadow:0 0 0 2px #ffadd2}.toolbar-color-grid:hover:nth-child(38){box-shadow:0 0 0 2px #ddd}.toolbar-color-grid:hover:nth-child(39){box-shadow:0 0 0 2px #4b4b4b}.toolbar-color-grid:hover:nth-child(40){box-shadow:0 0 0 2px #ff4d4f}.toolbar-color-grid:hover:nth-child(41){box-shadow:0 0 0 2px #ff7a45}.toolbar-color-grid:hover:nth-child(42){box-shadow:0 0 0 2px #ffc53d}.toolbar-color-grid:hover:nth-child(43){box-shadow:0 0 0 2px #ffec3d}.toolbar-color-grid:hover:nth-child(44){box-shadow:0 0 0 2px #73d13d}.toolbar-color-grid:hover:nth-child(45){box-shadow:0 0 0 2px #36cfc9}.toolbar-color-grid:hover:nth-child(46){box-shadow:0 0 0 2px #40a8ff}.toolbar-color-grid:hover:nth-child(47){box-shadow:0 0 0 2px #597ef7}.toolbar-color-grid:hover:nth-child(48){box-shadow:0 0 0 2px #9254de}.toolbar-color-grid:hover:nth-child(49){box-shadow:0 0 0 2px #f759ab}.toolbar-color-grid:hover:nth-child(50){box-shadow:0 0 0 2px #ccc}.toolbar-color-grid:hover:nth-child(51){box-shadow:0 0 0 2px #262626}.toolbar-color-grid:hover:nth-child(52){box-shadow:0 0 0 2px #cf1322}.toolbar-color-grid:hover:nth-child(53){box-shadow:0 0 0 2px #d4380d}.toolbar-color-grid:hover:nth-child(54){box-shadow:0 0 0 2px #d48806}.toolbar-color-grid:hover:nth-child(55){box-shadow:0 0 0 2px #d4b106}.toolbar-color-grid:hover:nth-child(56){box-shadow:0 0 0 2px #389e0d}.toolbar-color-grid:hover:nth-child(57){box-shadow:0 0 0 2px #08979c}.toolbar-color-grid:hover:nth-child(58){box-shadow:0 0 0 2px #096dd9}.toolbar-color-grid:hover:nth-child(59){box-shadow:0 0 0 2px #1d39c4}.toolbar-color-grid:hover:nth-child(60){box-shadow:0 0 0 2px #531dab}.toolbar-color-grid:hover:nth-child(61){box-shadow:0 0 0 2px #c41d7f}.toolbar-color-grid:hover:nth-child(62){box-shadow:0 0 0 2px #aaa}.toolbar-color-grid:hover:nth-child(63){box-shadow:0 0 0 2px #000}.toolbar-color-grid:hover:nth-child(64){box-shadow:0 0 0 2px #820014}.toolbar-color-grid:hover:nth-child(65){box-shadow:0 0 0 2px #871400}.toolbar-color-grid:hover:nth-child(66){box-shadow:0 0 0 2px #874d00}.toolbar-color-grid:hover:nth-child(67){box-shadow:0 0 0 2px #876800}.toolbar-color-grid:hover:nth-child(68){box-shadow:0 0 0 2px #135200}.toolbar-color-grid:hover:nth-child(69){box-shadow:0 0 0 2px #00474f}.toolbar-color-grid:hover:nth-child(70){box-shadow:0 0 0 2px #003a8c}.toolbar-color-grid:hover:nth-child(71){box-shadow:0 0 0 2px #061178}.toolbar-color-grid:hover:nth-child(72){box-shadow:0 0 0 2px #22075e}.toolbar-color-grid:hover:nth-child(73){box-shadow:0 0 0 2px #780650}.toolbar-color-grid:hover:nth-child(2),.toolbar-color-grid:hover:nth-child(14){box-shadow:0 0 0 2px #aaa}";
	styleInject(css);
	
	var colors = ["#fff", "#333", "#f5222d", "#fa541c", "#faad14", "#fadb14", "#52c41a", "#13c2c2", "#1890ff", "#2f54eb", "#722ed1", "#eb2f96", "#f6f6f6", "#989898", "#ffe8e7", "#ffece0", "#fff7cb", "#fcfcca", "#e5f7d3", "#cffff7", "#d4eefc", "#dfe8fc", "#efe1fa", "#fbe1eb", "#e9e9e9", "#666", "#ffa39e", "#ffbb96", "#ffe58f", "#fffb8f", "#b7eb8f", "#87e8de", "#91d5ff", "#adc6ff", "#d3adf7", "#ffadd2", "#ddd", "#4b4b4b", "#ff4d4f", "#ff7a45", "#ffc53d", "#ffec3d", "#73d13d", "#36cfc9", "#40a8ff", "#597ef7", "#9254de", "#f759ab", "#ccc", "#262626", "#cf1322", "#d4380d", "#d48806", "#d4b106", "#389e0d", "#08979c", "#096dd9", "#1d39c4", "#531dab", "#c41d7f", "#aaa", "#000", "#820014", "#871400", "#874d00", "#876800", "#135200", "#00474f", "#003a8c", "#061178", "#22075e", "#780650"];
	var colorTypes = [{
	  defaultBg: "#333",
	  defaultBorder: "#333",
	  tip: "文字颜色",
	  type: "font"
	}, {
	  defaultBg: "#fff",
	  defaultBorder: "#eee",
	  tip: "表格底色",
	  type: "bg"
	}, {
	  defaultBg: "#ccc",
	  defaultBorder: "#ccc",
	  tip: "边框颜色",
	  type: "border"
	}];
	
	var Popover = function (_preact$Component) {
	  (0, _inherits3.default)(Popover, _preact$Component);
	
	  function Popover() {
	    (0, _classCallCheck3.default)(this, Popover);
	    return (0, _possibleConstructorReturn3.default)(this, (Popover.__proto__ || (0, _getPrototypeOf2.default)(Popover)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Popover, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          typeInfo = _props.typeInfo,
	          select = _props.select,
	          selected = _props.selected,
	          displayPos = _props.displayPos;
	
	      var colorGrids = colors.map(function (color) {
	        return preact.h("div", {
	          key: color,
	          style: {
	            background: color
	          },
	          onClick: function onClick() {
	            return select(color);
	          },
	          className: classNames("toolbar-color-grid", {
	            selected: selected === color
	          })
	        });
	      });
	      return preact.h("div", {
	        "data-action": typeInfo.type + 'Color',
	        className: "toolbar-color-popover",
	        style: displayPos
	      }, preact.h("div", {
	        onClick: function onClick() {
	          return select(null);
	        },
	        className: "default"
	      }, preact.h("div", {
	        style: {
	          background: typeInfo.defaultBg,
	          borderColor: typeInfo.defaultBorder
	        },
	        className: "color-grid"
	      }), preact.h("div", {
	        className: "text"
	      }, '\u6062\u590D\u9ED8\u8BA4')), colorGrids);
	    }
	  }]);
	  return Popover;
	}(preact.Component);
	
	var ColorPopover = function (_preact$Component2) {
	  (0, _inherits3.default)(ColorPopover, _preact$Component2);
	
	  function ColorPopover(props) {
	    (0, _classCallCheck3.default)(this, ColorPopover);
	
	    var _this2 = (0, _possibleConstructorReturn3.default)(this, (ColorPopover.__proto__ || (0, _getPrototypeOf2.default)(ColorPopover)).call(this, props));
	
	    _this2.onSelect = function (color) {
	      var _this2$props = _this2.props,
	          type = _this2$props.type,
	          setSelected = _this2$props.setSelected,
	          setColor = _this2$props.setColor,
	          editorCore = _this2$props.editorCore;
	      var view = editorCore.view,
	          basicCommands = editorCore.basicCommands;
	
	
	      if (type === "font") {
	        if (color === null) {
	          basicCommands.setTextDefaultColor();
	        } else {
	          basicCommands.setTextColor(color);
	        }
	      }
	
	      if (setSelected) {
	        setSelected(color);
	      }
	
	      if (setColor) {
	        setColor(color);
	      }
	
	      view.focus();
	
	      window.requestAnimationFrame(function () {
	        _this2.setState({
	          hasTooltip: false,
	          isOpen: false,
	          selected: color
	        });
	      });
	    };
	
	    _this2.hidePopover = function (e) {
	      if (!e || e && e.target && !_this2.container.contains(e.target)) {
	        _this2.setState({
	          hasTooltip: false,
	          isOpen: false
	        });
	        window.removeEventListener("click", _this2.hidePopover);
	      }
	    };
	
	    _this2.setColor = function () {
	      var _this2$props2 = _this2.props,
	          type = _this2$props2.type,
	          editorCore = _this2$props2.editorCore,
	          setColor = _this2$props2.setColor;
	      var view = editorCore.view,
	          basicCommands = editorCore.basicCommands;
	
	
	      if (type === "font") {
	        basicCommands.setTextColor(_this2.state.selected);
	      }
	
	      if (setColor) {
	        setColor(_this2.state.selected);
	      }
	
	      view.focus();
	    };
	
	    _this2.handleClick = function (e) {
	      var _this2$props3 = _this2.props,
	          editorCore = _this2$props3.editorCore,
	          disabledHandler = _this2$props3.disabledHandler;
	      var view = editorCore.view;
	
	      var disabled = disabledHandler();
	
	      if (view) {
	        view.focus();
	      }
	
	      if (disabled) {
	        return;
	      }
	
	      var isOpen = _this2.state.isOpen;
	
	
	      if (!isOpen) {
	        _this2.setState({
	          hasTooltip: false,
	          isOpen: true
	        });
	        window.addEventListener("click", _this2.hidePopover);
	      } else {
	        _this2.hidePopover();
	      }
	    };
	
	    _this2.handleMouseEnter = function () {
	      if (_this2.state.isOpen) {
	        return;
	      }
	
	      _this2.setState({
	        hasTooltip: true
	      });
	    };
	
	    _this2.state = {
	      hasTooltip: false,
	      isOpen: false,
	      popoverPos: {},
	      selected: props.selected || null
	    };
	    return _this2;
	  }
	
	  (0, _createClass3.default)(ColorPopover, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var popoverPos = {
	        left: 0,
	        top: this.container.offsetHeight + 'px'
	      };
	      this.setState({
	        popoverPos: popoverPos
	      });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener("click", this.hidePopover);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          type = _props2.type,
	          disabledHandler = _props2.disabledHandler,
	          children = _props2.children;
	
	      var disabled = disabledHandler();
	      var _state = this.state,
	          hasTooltip = _state.hasTooltip,
	          isOpen = _state.isOpen,
	          selected = _state.selected,
	          popoverPos = _state.popoverPos;
	
	      var typeInfo = colorTypes.find(function (_) {
	        return _.type === type;
	      });
	
	      if (children && children.length) {
	        return preact.h("div", {
	          ref: function ref(container) {
	            return _this3.container = container;
	          },
	          onMouseEnter: function onMouseEnter() {
	            if (disabled) {
	              return;
	            }
	
	            _this3.handleMouseEnter();
	          },
	          onMouseLeave: function onMouseLeave() {
	            return _this3.setState({
	              hasTooltip: false
	            });
	          },
	          onClick: this.handleClick,
	          className: 'toolbar-color-popover-wrapper ' + type + '-color' + (disabled ? " disabled" : "")
	        }, children, isOpen && preact.h(Popover, {
	          typeInfo: typeInfo,
	          selected: selected,
	          select: this.onSelect,
	          displayPos: popoverPos
	        }), hasTooltip && preact.h("div", {
	          className: "ct-toolbar-tooltip"
	        }, typeInfo.tip));
	      }
	
	      return preact.h("div", {
	        ref: function ref(container) {
	          return _this3.container = container;
	        },
	        onMouseEnter: function onMouseEnter() {
	          if (disabled) {
	            return;
	          }
	
	          _this3.handleMouseEnter();
	        },
	        onMouseLeave: function onMouseLeave() {
	          return _this3.setState({
	            hasTooltip: false
	          });
	        },
	        className: 'toolbar-color-popover-wrapper ' + type + '-color' + (disabled ? " disabled" : "")
	      }, type === "bg" && preact.h("div", {
	        "data-action": "bgColor",
	        className: "left",
	        onClick: this.setColor
	      }, preact.h("div", {
	        className: "color",
	        style: {
	          background: selected || "#989898"
	        }
	      })), type === "font" && preact.h("div", {
	        "data-action": "fontColor",
	        className: "left",
	        onClick: this.setColor
	      }, preact.h("div", {
	        className: "color",
	        style: {
	          background: selected || "#333",
	          borderColor: selected ? selected === "#FFFFFF" ? "#eee" : selected : "#333"
	        }
	      })), type !== "border" && preact.h("div", {
	        className: "right",
	        onClick: this.handleClick
	      }), isOpen && preact.h(Popover, {
	        typeInfo: typeInfo,
	        selected: selected,
	        select: this.onSelect
	      }), hasTooltip && preact.h("div", {
	        className: "ct-toolbar-tooltip"
	      }, typeInfo.tip));
	    }
	  }]);
	  return ColorPopover;
	}(preact.Component);
	
	var css$1 = ".table-modal{text-align:left!important}.table-modal .table-modal-wrapper{width:630px}.table-modal .ct-modal-title{font-weight:500}.table-modal .ant-modal-footer{padding:0 24px 24px;border:none}.table-modal .ant-modal-footer .ant-btn{width:60px;height:32px;padding:0;margin-left:16px;border-radius:2px}.table-modal-content{display:flex;justify-content:flex-start;align-items:baseline;padding:24px}.table-modal-content .left{display:flex;flex-direction:column;justify-content:space-between;width:246px;height:176px;margin-right:30px}.table-modal-content .right{width:300px}.table-modal-content .title{margin-bottom:8px;font-size:14px;color:#333;line-height:22px}.table-modal-content .style-wrapper{display:flex;justify-content:flex-start;align-items:baseline}.table-modal-content .style-item{width:76px;height:70px;text-align:center}.table-modal-content .style-item svg{display:block;margin-top:14px;margin-left:14px}.table-modal-content .solid{margin-left:18px}.table-modal-content .selected{background-color:rgba(0,167,205,.1)}.table-modal-content .color-block{display:flex;justify-content:flex-start;align-items:baseline;width:246px;height:24px;padding:6px 8px;border:1px solid #ddd;border-radius:2px}.table-modal-content .color-block .inner{width:212px;height:10px}.table-modal-content .color-block svg{display:block;margin-left:8px}.table-modal-content .color-block svg path{fill:#b0b0b0}.table-modal-content .width-wrapper{display:flex;justify-content:space-around;align-items:center;flex-wrap:wrap;height:146px;border:1px solid #ddd;border-radius:2px;font-size:12px}.table-modal-content .width-wrapper .width-item{cursor:pointer;width:126px;height:19px;line-height:19px;border-radius:2px;text-align:center;display:flex;align-items:center;justify-content:center}.table-modal-content .width-wrapper .width-item .inner{display:inline-block;vertical-align:middle;width:110px;background:#1c6cdc}.table-modal-content .width-wrapper .width-item:nth-child(2) .inner{height:4px}.table-modal-content .width-wrapper .width-item:nth-child(3) .inner{height:1px}.table-modal-content .width-wrapper .width-item:nth-child(4) .inner{height:5px}.table-modal-content .width-wrapper .width-item:nth-child(5) .inner{height:2px}.table-modal-content .width-wrapper .width-item:nth-child(6) .inner{height:6px}.table-modal-content .width-wrapper .width-item:nth-child(7) .inner{height:3px}.table-modal-content .width-wrapper .width-item:nth-child(8) .inner{height:7px}.border-color .ct-color-pop-wrapper{display:block;width:auto;height:auto;border:none;background:none}";
	styleInject(css$1);
	
	var TableModal = function (_preact$Component3) {
	  (0, _inherits3.default)(TableModal, _preact$Component3);
	
	  function TableModal(props) {
	    (0, _classCallCheck3.default)(this, TableModal);
	
	    var _this4 = (0, _possibleConstructorReturn3.default)(this, (TableModal.__proto__ || (0, _getPrototypeOf2.default)(TableModal)).call(this, props));
	
	    _this4.handleOk = function () {
	      var _this4$props = _this4.props,
	          setTableAttrs = _this4$props.setTableAttrs,
	          hideModal = _this4$props.hideModal;
	
	      setTableAttrs(objectSpread({}, _this4.state));
	      hideModal();
	    };
	
	    _this4.handleCancel = function () {
	      var hideModal = _this4.props.hideModal;
	
	      hideModal();
	    };
	
	    var _this4$props2 = _this4.props,
	        borderStyle = _this4$props2.borderStyle,
	        borderColor = _this4$props2.borderColor,
	        borderWidth = _this4$props2.borderWidth,
	        store = _this4$props2.store;
	
	    _this4.state = {
	      borderStyle: borderStyle || 'solid',
	      borderColor: borderColor || '#cccccc',
	      borderWidth: borderWidth === null ? 1 : borderWidth
	    };
	    _this4.store = store;
	    return _this4;
	  }
	
	  (0, _createClass3.default)(TableModal, [{
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var _state2 = this.state,
	          borderStyle = _state2.borderStyle,
	          borderColor = _state2.borderColor,
	          borderWidth = _state2.borderWidth;
	
	      return preact.h(index_js$1.Modal, {
	        wrapClassName: "ct-modal table-modal",
	        contentClassName: "table-modal-wrapper",
	        width: "620px",
	        title: preact.h("div", {
	          className: "ct-modal-title"
	        }, '\u8868\u683C\u5C5E\u6027'),
	        visible: true,
	        okText: '\u786E\u5B9A',
	        onOk: this.handleOk,
	        onCancel: function onCancel() {
	          _this5.handleCancel();
	        }
	      }, preact.h("div", {
	        className: "table-modal-content"
	      }, preact.h("div", {
	        className: "left"
	      }, preact.h("div", {
	        className: "border-style"
	      }, preact.h("div", {
	        className: "title"
	      }, '\u8FB9\u6846\u6837\u5F0F\uFF1A'), preact.h("div", {
	        className: "style-wrapper"
	      }, preact.h("div", {
	        className: classNames('style-item dashed', {
	          selected: borderStyle === 'dashed'
	        }),
	        onClick: function onClick() {
	          return _this5.setState({
	            borderStyle: 'dashed'
	          });
	        }
	      }, preact.h(DashedIcon, null)), preact.h("div", {
	        className: classNames('style-item solid', {
	          selected: borderStyle === 'solid'
	        }),
	        onClick: function onClick() {
	          return _this5.setState({
	            borderStyle: 'solid'
	          });
	        }
	      }, preact.h(SolidIcon, null)))), preact.h("div", {
	        className: "border-color"
	      }, preact.h("div", {
	        className: "title"
	      }, '\u8FB9\u6846\u989C\u8272\uFF1A'), preact.h(ColorPopover, {
	        type: "border",
	        store: this.store,
	        setColor: function setColor(color) {
	          _this5.setState({
	            borderColor: color
	          });
	        },
	        setDefaultColor: function setDefaultColor() {
	          _this5.setState({
	            borderColor: '#cccccc'
	          });
	        },
	        disabledHandler: function disabledHandler() {
	          return false;
	        },
	        editorCore: this.store,
	        setSelected: function setSelected(borderColor) {
	          return _this5.setState({
	            borderColor: borderColor
	          });
	        }
	      }, preact.h("div", {
	        className: "color-block"
	      }, preact.h("div", {
	        className: "inner",
	        style: {
	          background: borderColor
	        }
	      }), preact.h(TriangleIcon, null))))), preact.h("div", {
	        className: "right"
	      }, preact.h("div", {
	        className: "border-width"
	      }, preact.h("div", {
	        className: "title"
	      }, '\u8FB9\u6846\u5BBD\u5EA6\uFF1A'), preact.h("div", {
	        className: "width-wrapper"
	      }, preact.h("div", {
	        className: classNames('width-item', {
	          selected: borderWidth === 0
	        }),
	        onClick: function onClick() {
	          return _this5.setState({
	            borderWidth: 0
	          });
	        }
	      }, '\u65E0'), [4, 1, 5, 2, 6, 3, 7].map(function (_) {
	        return preact.h("div", {
	          key: _,
	          className: classNames('width-item', {
	            selected: borderWidth === _
	          }),
	          onClick: function onClick() {
	            return _this5.setState({
	              borderWidth: _
	            });
	          }
	        }, preact.h("div", {
	          className: "inner",
	          style: {
	            backgroundColor: borderColor
	          }
	        }));
	      }))))));
	    }
	  }]);
	  return TableModal;
	}(preact.Component);
	
	var css$2 = ".table-headerbar .ct-table-wrapper{margin:0!important;overflow:hidden}.table-headerbar table{margin-top:0!important;overflow:hidden}.table-headerbar table .selectedCell:after{display:none}";
	styleInject(css$2);
	
	var HeaderBar = function (_preact$Component4) {
	  (0, _inherits3.default)(HeaderBar, _preact$Component4);
	
	  function HeaderBar() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, HeaderBar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this6 = (0, _possibleConstructorReturn3.default)(this, (_ref = HeaderBar.__proto__ || (0, _getPrototypeOf2.default)(HeaderBar)).call.apply(_ref, [this].concat(args)));
	
	    _this6.init = function () {
	      var _this6$props = _this6.props,
	          headerTableDOM = _this6$props.headerTableDOM,
	          tableHeader = _this6$props.tableHeader,
	          headerParentNode = _this6$props.headerParentNode,
	          headerPaddingLeft = _this6$props.headerPaddingLeft;
	
	      var headerBarTableDOM = headerTableDOM.cloneNode();
	      headerBarTableDOM.className = '';
	      headerBarTableDOM.style.width = headerTableDOM.clientWidth + 'px';
	      var headerColgroupDOM = headerTableDOM.firstElementChild.cloneNode(true);
	      var headerTbodyDOM = document.createElement('tbody');
	      var wrapperDOM = document.createElement('div');
	      var colDOMs = [];
	      var rowDOM = headerTableDOM.lastElementChild.children[0];
	
	      for (var i = 0; i < rowDOM.childElementCount; i++) {
	        var _cellDOM = rowDOM.children[i];
	        var _colspan = parseInt(_cellDOM.getAttribute('colspan'), 10) || 1;
	        var cellWidth = _cellDOM.getBoundingClientRect().width / _colspan;
	
	        for (var j = 0; j < _colspan; j++) {
	          colDOMs.push({
	            cellWidth: cellWidth
	          });
	        }
	      }
	
	      if (headerColgroupDOM.children.length === 0) {
	        colDOMs.forEach(function (col) {
	          var cellWidth = col.cellWidth || parseInt(col.style && col.style.width, 10);
	          headerColgroupDOM.appendChild(document.createElement('col')).style.width = cellWidth + 'px';
	        });
	      }
	
	      var firstCellNode = tableHeader.firstElementChild;
	      var colspan = firstCellNode.getAttribute('colspan');
	
	      if (colspan) {
	        var width = 0;
	        (0, _from2.default)(headerColgroupDOM.children).some(function (col, i) {
	          if (i === colspan) return true;
	          width += parseInt(col.style.width, 10);
	          return false;
	        });
	        firstCellNode.style.width = width + 'px';
	      }
	
	      wrapperDOM.className = 'ct-table-wrapper';
	      headerTbodyDOM.appendChild(tableHeader);
	      headerBarTableDOM.appendChild(headerColgroupDOM);
	      headerBarTableDOM.appendChild(headerTbodyDOM);
	      headerBarTableDOM.style.marginLeft = headerPaddingLeft + 'px';
	      wrapperDOM.appendChild(headerBarTableDOM);
	      _this6.headerBar.innerHTML = '';
	      _this6.headerBar.appendChild(wrapperDOM);
	      wrapperDOM.scrollLeft = headerParentNode.scrollLeft;
	    };
	
	    _this6.handleDoubleClick = function (e) {
	      var headerDOM = e.target.closest('th');
	
	      if (headerDOM) {
	        var _this6$props2 = _this6.props,
	            headerTableDOM = _this6$props2.headerTableDOM,
	            view = _this6$props2.view,
	            $scroll = _this6$props2.$scroll;
	        var state = view.state,
	            dispatch = view.dispatch;
	
	        var index = (0, _from2.default)(headerDOM.parentElement.children).indexOf(headerDOM);
	        var trueDOM = headerTableDOM.lastElementChild.firstElementChild.cells[index];
	        var pos = view.docView.posFromDOM(trueDOM);
	        $scroll.scrollTop -= 90 - trueDOM.getBoundingClientRect().top;
	        dispatch(state.tr.setSelection(prosemirrorState.TextSelection.create(state.tr.doc, pos - 1)));
	        view.focus();
	      }
	    };
	
	    _this6.handleMouseWheel = function (e) {
	      var isInCloneHeader = e.target.closest('.table-headerbar');
	      if (!isInCloneHeader) return;
	      var direct = 0;
	
	      if (e.wheelDelta) {
	        direct = e.wheelDelta > 0 ? 1 : -1;
	      } else if (e.detail) {
	        direct = e.detail > 0 ? 1 : -1;
	      }
	
	      if (direct !== 0) {
	        var $scroll = _this6.props.$scroll;
	
	
	        if (direct === 1) {
	          $scroll.scrollTop -= 7;
	        } else {
	          $scroll.scrollTop += 7;
	        }
	      }
	    };
	    return _this6;
	  }
	
	  (0, _createClass3.default)(HeaderBar, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var $scroll = this.props.$scroll;
	
	      $scroll.addEventListener('mousewheel', this.handleMouseWheel);
	      this.headerBar.addEventListener('dblclick', this.handleDoubleClick);
	      this.init();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.init();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var $scroll = this.props.$scroll;
	
	      $scroll.removeEventListener('mousewheel', this.handleMouseWheel);
	      this.headerBar.removeEventListener('dblclick', this.handleDoubleClick);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this7 = this;
	
	      var headerParentNode = this.props.headerParentNode;
	
	      return preact.h("div", {
	        className: "table-headerbar",
	        style: {
	          width: headerParentNode.clientWidth + 'px'
	        },
	        ref: function ref(refs) {
	          _this7.headerBar = refs;
	        }
	      });
	    }
	  }]);
	  return HeaderBar;
	}(preact.Component);
	
	var css$3 = ".ct-table-scrollbar{height:15px;overflow-x:auto;overflow-y:hidden}.ct-table-scrollbar .inner{border:1px solid transparent}";
	styleInject(css$3);
	
	var ScrollBar = function (_preact$Component5) {
	  (0, _inherits3.default)(ScrollBar, _preact$Component5);
	
	  function ScrollBar() {
	    var _ref2;
	
	    (0, _classCallCheck3.default)(this, ScrollBar);
	
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    var _this8 = (0, _possibleConstructorReturn3.default)(this, (_ref2 = ScrollBar.__proto__ || (0, _getPrototypeOf2.default)(ScrollBar)).call.apply(_ref2, [this].concat(args)));
	
	    _this8.handleScroll = function () {
	      var scrollParentNode = _this8.props.scrollParentNode;
	
	      var scrollLeft = _this8.scrollBar.scrollLeft;
	
	      if (scrollParentNode.scrollLeft !== scrollLeft) {
	        scrollParentNode.scrollLeft = scrollLeft;
	      }
	    };
	    return _this8;
	  }
	
	  (0, _createClass3.default)(ScrollBar, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var scrollParentNode = this.props.scrollParentNode;
	
	      this.scrollBar.scrollLeft = scrollParentNode.scrollLeft;
	      this.scrollBar.onscroll = this.handleScroll;
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.scrollBar.onscroll = null;
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      var scrollParentNode = this.props.scrollParentNode;
	
	      var scrollLeft = scrollParentNode.scrollLeft;
	
	      if (this.scrollBar.scrollLeft !== scrollLeft) {
	        this.scrollBar.scrollLeft = scrollLeft;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this9 = this;
	
	      var _props3 = this.props,
	          scrollContainerWidth = _props3.scrollContainerWidth,
	          scrollTableWidth = _props3.scrollTableWidth;
	
	      return preact.h("div", {
	        className: "ct-table-scrollbar",
	        style: {
	          width: scrollContainerWidth + 'px'
	        },
	        ref: function ref(refs) {
	          _this9.scrollBar = refs;
	        }
	      }, preact.h("div", {
	        className: "inner",
	        style: {
	          width: scrollTableWidth + 2 + 'px'
	        }
	      }));
	    }
	  }]);
	  return ScrollBar;
	}(preact.Component);
	
	var css$4 = ".ct-table-all-selectbar,.ct-table-row-selectbar{height:100%;width:100%}.ct-table-col-selectbar-wrapper{overflow-x:hidden}.ct-table-col-selectbar{height:26px}.visible-wrapper{width:100%;height:100%}.ct-table-col-selectbar{margin-top:20px;pointer-events:all}.ct-table-col-selectbar .ct-table-selectbar-item{float:left;height:100%}.ct-table-col-selectbar .ct-table-selectbar-item:first-child .visible-wrapper.left .visible{border-left:1px solid transparent;border-top-left-radius:2px;border-bottom-left-radius:2px}.ct-table-col-selectbar .ct-table-selectbar-item:last-child .visible-wrapper.right .visible{border-top-right-radius:2px;border-bottom-right-radius:2px}.ct-table-col-selectbar .visible-wrapper{padding-top:8px}.ct-table-col-selectbar .visible{height:10px}.ct-table-col-selectbar .visible-wrapper.left .visible{border-left:1px solid #ddd}.ct-table-row-selectbar .ct-table-selectbar-item:first-child .visible-wrapper.top .visible{border-top-left-radius:2px;border-top-right-radius:2px}.ct-table-row-selectbar .ct-table-selectbar-item:last-child .visible-wrapper.bottom .visible{border-bottom-left-radius:2px;border-bottom-right-radius:2px;border:none}.ct-table-row-selectbar .visible-wrapper{padding-left:8px}.ct-table-row-selectbar .visible{height:100%;width:10px}.ct-table-row-selectbar .visible-wrapper.bottom .visible{border-bottom:1px solid #ddd}.ct-table-all-selectbar .visible{width:10px;height:10px;border-radius:10px;background:#eee;cursor:-webkit-grab}.ct-table-all-selectbar .visible:hover{background:#ccc}.ct-table-all-selectbar .visible.selected{background:rgba(0,167,205,.2)}.ct-table-selectbar-item{cursor:pointer}.ct-table-selectbar-item .visible{background:#eee}.ct-table-selectbar-item:hover .visible{background:#ccc}.ct-table-selectbar-item.selected .visible{background:rgba(0,167,205,.2)}";
	styleInject(css$4);
	
	var _index_js$getSystemIn = index_js.getSystemInfo(),
	    os = _index_js$getSystemIn.os;
	
	var dragCopyModifier = /MAC/.test(os.toUpperCase()) ? "altKey" : "ctrlKey";
	
	var ColSelectBar = function (_preact$Component6) {
	  (0, _inherits3.default)(ColSelectBar, _preact$Component6);
	
	  function ColSelectBar() {
	    var _ref3;
	
	    (0, _classCallCheck3.default)(this, ColSelectBar);
	
	    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      args[_key3] = arguments[_key3];
	    }
	
	    var _this10 = (0, _possibleConstructorReturn3.default)(this, (_ref3 = ColSelectBar.__proto__ || (0, _getPrototypeOf2.default)(ColSelectBar)).call.apply(_ref3, [this].concat(args)));
	
	    _this10.handleClick = function () {
	      var _this10$props = _this10.props,
	          view = _this10$props.view,
	          tablePos = _this10$props.tablePos,
	          reShowPopover = _this10$props.reShowPopover;
	      var dispatch = view.dispatch,
	          state = view.state;
	      var tr = state.tr,
	          doc = state.doc;
	
	      var newSelection = prosemirrorState.NodeSelection.create(doc, tablePos);
	      dispatch(tr.setSelection(newSelection));
	      view.focus();
	      reShowPopover();
	    };
	
	    _this10.handleDragStart = function (e) {
	      var _this10$props2 = _this10.props,
	          view = _this10$props2.view,
	          tablePos = _this10$props2.tablePos,
	          tableDOM = _this10$props2.tableDOM;
	      var state = view.state;
	
	      tableDOM.style = 'opacity: 0.9;';
	      e.dataTransfer.setDragImage(tableDOM, 0, 0);
	      var mouseDown = view.mouseDown;
	      if (mouseDown) mouseDown.done();
	      var node = state.doc.nodeAt(tablePos);
	      var newSelection = prosemirrorState.TextSelection.create(state.doc, tablePos, tablePos + node.nodeSize);
	      var slice = newSelection.content();
	
	      if (slice && slice.content && slice.content.content) {
	        var _slice$content$conten = slice.content.content[0].type;
	        _slice$content$conten = _slice$content$conten === undefined ? {} : _slice$content$conten;
	        var name = _slice$content$conten.name;
	
	
	        if (name === 'blockquote') {
	          var nodeSelection = prosemirrorState.NodeSelection.create(state.doc, tablePos, tablePos + node.nodeSize);
	          slice = nodeSelection.content();
	        }
	      }
	
	      view.dragging = {
	        slice: slice,
	        move: !event[dragCopyModifier]
	      };
	      view.dispatch(state.tr.setSelection(newSelection));
	    };
	
	    _this10.isSelectedAll = function () {
	      var _this10$props3 = _this10.props,
	          tableDOM = _this10$props3.tableDOM,
	          colDOMs = _this10$props3.colDOMs,
	          selectedRowArr = _this10$props3.selectedRowArr,
	          selectedColArr = _this10$props3.selectedColArr;
	
	      if (!tableDOM) return false;
	      var tableRowDOMs = tableDOM.lastElementChild.children;
	      return selectedColArr.length === colDOMs.length && selectedRowArr.length === tableRowDOMs.length;
	    };
	    return _this10;
	  }
	
	  (0, _createClass3.default)(ColSelectBar, [{
	    key: 'render',
	    value: function render() {
	      var selected = this.isSelectedAll();
	      return preact.h("div", {
	        draggable: true,
	        className: "ct-table-all-selectbar",
	        onClick: this.handleClick,
	        onDragStart: this.handleDragStart
	      }, preact.h("div", {
	        className: 'visible' + (selected ? ' selected' : '')
	      }));
	    }
	  }]);
	  return ColSelectBar;
	}(preact.Component);
	
	var readFromCache = void 0,
	    addToCache = void 0;
	
	if (typeof _weakMap2.default !== 'undefined') {
	  var cache = new _weakMap2.default();
	
	  readFromCache = function readFromCache(key) {
	    return cache.get(key);
	  };
	
	  addToCache = function addToCache(key, value) {
	    cache.set(key, value);
	    return value;
	  };
	} else {
	  var _cache = [],
	      cacheSize = 10,
	      cachePos = 0;
	
	  readFromCache = function readFromCache(key) {
	    for (var i = 0; i < _cache.length; i += 2) {
	      if (_cache[i] == key) return _cache[i + 1];
	    }
	  };
	
	  addToCache = function addToCache(key, value) {
	    if (cachePos == cacheSize) cachePos = 0;
	    _cache[cachePos++] = key;
	    return _cache[cachePos++] = value;
	  };
	}
	
	var Rect = function Rect(left, top, right, bottom) {
	  (0, _classCallCheck3.default)(this, Rect);
	
	  this.left = left;
	  this.top = top;
	  this.right = right;
	  this.bottom = bottom;
	};
	
	var TableMap = function () {
	  function TableMap(width, height, map, problems) {
	    (0, _classCallCheck3.default)(this, TableMap);
	
	    this.width = width;
	
	    this.height = height;
	
	    this.map = map;
	
	    this.problems = problems;
	  }
	
	  (0, _createClass3.default)(TableMap, [{
	    key: 'findCell',
	    value: function findCell(pos) {
	      for (var i = 0; i < this.map.length; i++) {
	        var curPos = this.map[i];
	        if (curPos != pos) continue;
	        var left = i % this.width,
	            top = i / this.width | 0;
	        var right = left + 1,
	            bottom = top + 1;
	
	        for (var j = 1; right < this.width && this.map[i + j] == curPos; j++) {
	          right++;
	        }for (var _j = 1; bottom < this.height && this.map[i + this.width * _j] == curPos; _j++) {
	          bottom++;
	        }return new Rect(left, top, right, bottom);
	      }
	
	      throw new RangeError('No cell with offset ' + pos + ' found');
	    }
	  }, {
	    key: 'colCount',
	    value: function colCount(pos) {
	      for (var i = 0; i < this.map.length; i++) {
	        if (this.map[i] == pos) return i % this.width;
	      }
	
	      throw new RangeError('No cell with offset ' + pos + ' found');
	    }
	  }, {
	    key: 'nextCell',
	    value: function nextCell(pos, axis, dir) {
	      var _findCell = this.findCell(pos),
	          left = _findCell.left,
	          right = _findCell.right,
	          top = _findCell.top,
	          bottom = _findCell.bottom;
	
	      if (axis == 'horiz') {
	        if (dir < 0 ? left == 0 : right == this.width) return null;
	        return this.map[top * this.width + (dir < 0 ? left - 1 : right)];
	      }
	
	      if (dir < 0 ? top == 0 : bottom == this.height) return null;
	      return this.map[left + this.width * (dir < 0 ? top - 1 : bottom)];
	    }
	  }, {
	    key: 'rectBetween',
	    value: function rectBetween(a, b) {
	      var _findCell2 = this.findCell(a),
	          leftA = _findCell2.left,
	          rightA = _findCell2.right,
	          topA = _findCell2.top,
	          bottomA = _findCell2.bottom;
	
	      var _findCell3 = this.findCell(b),
	          leftB = _findCell3.left,
	          rightB = _findCell3.right,
	          topB = _findCell3.top,
	          bottomB = _findCell3.bottom;
	
	      return new Rect(Math.min(leftA, leftB), Math.min(topA, topB), Math.max(rightA, rightB), Math.max(bottomA, bottomB));
	    }
	  }, {
	    key: 'cellsInRect',
	    value: function cellsInRect(rect) {
	      var result = [],
	          seen = [];
	
	      for (var row = rect.top; row < rect.bottom; row++) {
	        for (var col = rect.left; col < rect.right; col++) {
	          var index = row * this.width + col,
	              pos = this.map[index];
	          if (seen.indexOf(pos) > -1) continue;
	          seen.push(pos);
	
	          if ((col != rect.left || !col || this.map[index - 1] != pos) && (row != rect.top || !row || this.map[index - this.width] != pos)) {
	            result.push(pos);
	          }
	        }
	      }
	
	      return result;
	    }
	  }, {
	    key: 'positionAt',
	    value: function positionAt(row, col, table) {
	      for (var i = 0, rowStart = 0;; i++) {
	        var rowEnd = rowStart + table.child(i).nodeSize;
	
	        if (i == row) {
	          var index = col + row * this.width,
	              rowEndIndex = (row + 1) * this.width;
	
	          while (index < rowEndIndex && this.map[index] < rowStart) {
	            index++;
	          }return index == rowEndIndex ? rowEnd - 1 : this.map[index];
	        }
	
	        rowStart = rowEnd;
	      }
	    }
	  }], [{
	    key: 'get',
	    value: function get(table) {
	      return readFromCache(table) || addToCache(table, computeMap(table));
	    }
	  }]);
	  return TableMap;
	}();
	
	function computeMap(table) {
	  if (table.type.spec.tableRole != 'table') throw new RangeError('Not a table node: ' + table.type.name);
	  var width = findWidth(table),
	      height = table.childCount;
	  var map = [],
	      mapPos = 0,
	      problems = null,
	      colWidths = [];
	
	  for (var i = 0, e = width * height; i < e; i++) {
	    map[i] = 0;
	  }for (var row = 0, pos = 0; row < height; row++) {
	    var rowNode = table.child(row);
	    pos++;
	
	    for (var _i = 0;; _i++) {
	      while (mapPos < map.length && map[mapPos] != 0) {
	        mapPos++;
	      }if (_i == rowNode.childCount) break;
	      var cellNode = rowNode.child(_i),
	          _cellNode$attrs = cellNode.attrs,
	          colspan = _cellNode$attrs.colspan,
	          rowspan = _cellNode$attrs.rowspan,
	          colwidth = _cellNode$attrs.colwidth;
	
	
	      for (var h = 0; h < rowspan; h++) {
	        if (h + row >= height) {
	          (problems || (problems = [])).push({
	            type: 'overlong_rowspan',
	            pos: pos,
	            n: rowspan - h
	          });
	          break;
	        }
	
	        var start = mapPos + h * width;
	
	        for (var w = 0; w < colspan; w++) {
	          if (map[start + w] == 0) {
	            map[start + w] = pos;
	          } else {
	            (problems || (problems = [])).push({
	              type: 'collision',
	              row: row,
	              pos: pos,
	              n: colspan - w
	            });
	          }
	
	          var colW = colwidth && colwidth[w];
	
	          if (colW) {
	            var widthIndex = (start + w) % width * 2,
	                prev = colWidths[widthIndex];
	
	            if (prev == null || prev != colW && colWidths[widthIndex + 1] == 1) {
	              colWidths[widthIndex] = colW;
	              colWidths[widthIndex + 1] = 1;
	            } else if (prev == colW) {
	              colWidths[widthIndex + 1]++;
	            }
	          }
	        }
	      }
	
	      mapPos += colspan;
	      pos += cellNode.nodeSize;
	    }
	
	    var expectedPos = (row + 1) * width,
	        missing = 0;
	
	    while (mapPos < expectedPos) {
	      if (map[mapPos++] == 0) missing++;
	    }if (missing) (problems || (problems = [])).push({
	      type: 'missing',
	      row: row,
	      n: missing
	    });
	    pos++;
	  }
	
	  var tableMap = new TableMap(width, height, map, problems),
	      badWidths = false;
	
	  for (var _i2 = 0; !badWidths && _i2 < colWidths.length; _i2 += 2) {
	    if (colWidths[_i2] != null && colWidths[_i2 + 1] < height) badWidths = true;
	  }
	
	  if (badWidths) findBadColWidths(tableMap, colWidths, table);
	  return tableMap;
	}
	
	function findWidth(table) {
	  var width = -1,
	      hasRowSpan = false;
	
	  for (var row = 0; row < table.childCount; row++) {
	    var rowNode = table.child(row),
	        rowWidth = 0;
	
	    if (hasRowSpan) {
	      for (var j = 0; j < row; j++) {
	        var prevRow = table.child(j);
	
	        for (var i = 0; i < prevRow.childCount; i++) {
	          var cell = prevRow.child(i);
	          if (j + cell.attrs.rowspan > row) rowWidth += cell.attrs.colspan;
	        }
	      }
	    }
	
	    for (var _i3 = 0; _i3 < rowNode.childCount; _i3++) {
	      var _cell = rowNode.child(_i3);
	      rowWidth += _cell.attrs.colspan;
	      if (_cell.attrs.rowspan > 1) hasRowSpan = true;
	    }
	
	    if (width == -1) {
	      width = rowWidth;
	    } else if (width != rowWidth) {
	      width = Math.max(width, rowWidth);
	    }
	  }
	
	  return width;
	}
	
	function findBadColWidths(map, colWidths, table) {
	  if (!map.problems) map.problems = [];
	
	  for (var i = 0, seen = []; i < map.map.length; i++) {
	    var pos = map.map[i];
	    if (seen.indexOf(pos) > -1) continue;
	    seen.push(pos);
	    var node = table.nodeAt(pos),
	        updated = null;
	
	    for (var j = 0; j < node.attrs.colspan; j++) {
	      var col = (i + j) % map.width,
	          colWidth = colWidths[col * 2];
	
	      if (colWidth != null && (!node.attrs.colwidth || node.attrs.colwidth[j] != colWidth)) {
	        (updated || (updated = freshColWidth(node.attrs)))[j] = colWidth;
	      }
	    }
	
	    if (updated) map.problems.unshift({
	      type: 'colwidth mismatch',
	      pos: pos,
	      colwidth: updated
	    });
	  }
	}
	
	function freshColWidth(attrs) {
	  if (attrs.colwidth) return attrs.colwidth.slice();
	  var result = [];
	
	  for (var i = 0; i < attrs.colspan; i++) {
	    result.push(0);
	  }return result;
	}
	
	var isResizing = false;
	var TableView = function () {
	  function TableView(_node, _getPos, store, cellMinWidth) {
	    var _this11 = this;
	
	    (0, _classCallCheck3.default)(this, TableView);
	
	    this.fixedErrorColumns = function (node, getPos) {
	      if (node.attrs.responsive) return;
	      var view = _this11.store.view;
	      var state = view.state,
	          dispatch = view.dispatch;
	      var tr = state.tr,
	          schema = state.schema;
	      var _schema$nodes = schema.nodes,
	          table_header = _schema$nodes.table_header,
	          table_cell = _schema$nodes.table_cell;
	
	      var cellTypes = [table_header, table_cell];
	      var docView = view.docView;
	      var pos = getPos();
	      tr.doc.nodesBetween(pos, pos + node.nodeSize, function (node, pos) {
	        if (cellTypes.includes(node.type)) {
	          var attrs = node.attrs;
	          var colwidth = attrs.colwidth;
	
	          if (colwidth.includes(0) || colwidth.includes(NaN) || colwidth.includes(Infinity)) {
	            var dom = docView.domFromPos(pos + 1).node;
	            var width = dom.clientWidth + 3;
	            var len = colwidth.length;
	            var newColwidth = new Array(len);
	            var divWidth = ~~(width / len);
	            newColwidth.fill(divWidth > 50 ? divWidth : 50);
	
	            try {
	              tr.setNodeMarkup(pos, null, objectSpread({}, attrs, {
	                colwidth: newColwidth
	              }));
	            } catch (error) {}
	          }
	        }
	      });
	      dispatch(tr.setMeta('addToHistory', false));
	    };
	
	    this.handleTableScroll = function () {
	      var _store = _this11.store,
	          parentNode = _store.parentNode,
	          reShowPopover = _store.reShowPopover,
	          handleTableScroll = _store.handleTableScroll;
	
	      if (parentNode !== _this11.dom) reShowPopover();
	      handleTableScroll();
	    };
	
	    isResizing = false;
	    this.store = store;
	    this.node = _node;
	    this.cellMinWidth = cellMinWidth;
	    var dataDiffId = _node.attrs.dataDiffId;
	
	    this.dom = document.createElement('div');
	    this.dom.className = 'ct-table-wrapper';
	
	    if (dataDiffId) {
	      this.dom.setAttribute('data-diff-id', dataDiffId);
	    }
	
	    this.table = this.dom.appendChild(document.createElement('table'));
	    this.colgroup = this.table.appendChild(document.createElement('colgroup'));
	    updateColumns(_node, this.colgroup, this.table, cellMinWidth);
	    this.contentDOM = this.table.appendChild(document.createElement('tbody'));
	    setTimeout(function () {
	      return _this11.fixedErrorColumns(_node, _getPos);
	    }, 100);
	    this.dom.addEventListener('scroll', this.handleTableScroll);
	  }
	
	  (0, _createClass3.default)(TableView, [{
	    key: 'update',
	    value: function update(node) {
	      if (node.type !== this.node.type) return false;
	      this.node = node;
	      updateColumns(node, this.colgroup, this.table, this.cellMinWidth);
	      return true;
	    }
	  }, {
	    key: 'ignoreMutation',
	    value: function ignoreMutation(record) {
	      return record.type === 'attributes' && (record.target === this.table || this.colgroup.contains(record.target));
	    }
	  }, {
	    key: 'destory',
	    value: function destory() {
	      this.dom.removeEventListener('scroll', this.handleTableScroll);
	    }
	  }]);
	  return TableView;
	}();
	
	function updateColumns(node, colgroup, table, cellMinWidth, isDragged, overrideCol, overrideValue, store) {
	  if (isDragged !== undefined) {
	    isResizing = isDragged;
	    if (!isDragged) return;
	  } else if (isResizing && !overrideCol) return false;
	
	  var _node$attrs = node.attrs,
	      indent = _node$attrs.indent,
	      responsive = _node$attrs.responsive,
	      borderStyle = _node$attrs.borderStyle,
	      borderWidth = _node$attrs.borderWidth,
	      borderColor = _node$attrs.borderColor;
	
	
	  if (!responsive) {
	    var totalWidth = 0;
	    var fixedWidth = true;
	    var colgroupFragment = document.createDocumentFragment();
	    var row = node.content.content[0];
	    var col = 0;
	
	    for (var i = 0; i < row.childCount; i++) {
	      var _row$child$attrs = row.child(i).attrs,
	          colspan = _row$child$attrs.colspan,
	          colwidth = _row$child$attrs.colwidth;
	
	      var hasWidth = overrideCol === col ? overrideValue : colwidth && colwidth.map(function (p) {
	        return parseInt(p);
	      }).reduce(function (prev, cur) {
	        return prev + cur;
	      });
	      totalWidth += hasWidth || cellMinWidth;
	
	      for (var j = 0; j < colspan; j++) {
	        var colWidthValue = overrideCol === col ? overrideValue : colwidth && colwidth[j];
	        if (!hasWidth) fixedWidth = false;
	        colgroupFragment.appendChild(document.createElement('col')).style.width = colWidthValue ? colWidthValue + 'px' : '';
	        col++;
	      }
	    }
	
	    colgroup.innerHTML = '';
	    colgroup.appendChild(colgroupFragment);
	
	    if (fixedWidth) {
	      table.style.width = totalWidth + 'px';
	      table.style.minWidth = '';
	    } else {
	      table.style.width = '';
	      table.style.minWidth = totalWidth + 'px';
	    }
	  } else {
	    colgroup.innerHTML = '';
	    table.style.width = '';
	    table.style.minWidth = '';
	  }
	
	  if (store && table === store.tableDOM) {
	    store.handleTableWidthChange();
	  }
	
	  if (indent >= 0) table.style.marginLeft = indent * 20 + 'px';
	  table.className = responsive ? 'responsive' : '';
	  table.setAttribute('data-borderstyle', borderStyle);
	  table.setAttribute('data-borderwidth', borderWidth);
	  table.setAttribute('data-bordercolor', borderColor);
	}
	
	var pluginKey = new prosemirrorState.PluginKey('tableColumnResizing');
	var preStartX = null;
	
	var columnResizingDOM = null;
	
	var cellDOM = null;
	
	var tableWrapperDOM = null;
	
	var handleWidth = 0;
	
	var hadMouseDown = false;
	
	function columnResizing() {
	  var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref4$cellMinWidth = _ref4.cellMinWidth,
	      cellMinWidth = _ref4$cellMinWidth === undefined ? 25 : _ref4$cellMinWidth;
	
	  var store = arguments[1];
	
	  var plugin = new prosemirrorState.Plugin({
	    key: pluginKey,
	    state: {
	      init: function init(_, state) {
	        this.spec.props.nodeViews.table = function (node, view, getPos) {
	          return new TableView(node, getPos, store, cellMinWidth);
	        };
	
	        return new ResizeState(-1, false);
	      },
	      apply: function apply(tr, prev) {
	        return prev.apply(tr);
	      }
	    },
	    props: {
	      attributes: function attributes(state) {
	        var pluginState = pluginKey.getState(state);
	        return pluginState.activeHandle > -1 ? {
	          class: 'resize-cursor'
	        } : null;
	      },
	
	
	      handleDOMEvents: {
	        mousemove: function mousemove(view, event) {
	          handleMouseMove(view, event, cellMinWidth, store);
	        },
	        mousedown: function mousedown(view, event) {
	          handleMouseDown(view, event, cellMinWidth);
	        }
	      },
	
	      decorations: function decorations(state) {
	        var pluginState = pluginKey.getState(state);
	
	        if (pluginState.activeHandle > -1) {
	          var res = null;
	
	          try {
	            res = handleDecorations(state, pluginState.activeHandle, store.view);
	          } catch (error) {
	            console.error(error);
	          }
	
	          return res;
	        }
	
	        columnResizingDOM = null;
	        updateColumns(0, 0, 0, 0, false);
	      },
	
	
	      nodeViews: {}
	    }
	  });
	  return plugin;
	}
	
	var ResizeState = function () {
	  function ResizeState(activeHandle, dragging) {
	    (0, _classCallCheck3.default)(this, ResizeState);
	
	    this.activeHandle = activeHandle;
	    this.dragging = dragging;
	    preStartX = dragging ? dragging.startX : null;
	  }
	
	  (0, _createClass3.default)(ResizeState, [{
	    key: 'apply',
	    value: function apply(tr) {
	      var state = this,
	          action = tr.getMeta(pluginKey);
	
	      if (action && action.setHandle) {
	        return new ResizeState(action.setHandle, null);
	      }
	
	      if (action && action.setDragging) {
	        return new ResizeState(state.activeHandle, action.setDragging);
	      }
	
	      if (state.activeHandle > -1 && tr.docChanged) {
	        var $handle = tr.doc.resolve(tr.mapping.map(state.activeHandle, -1));
	        if (!($handle.parent.type.spec.tableRole === 'row' && $handle.nodeAfter)) $handle = null;
	        state = new ResizeState($handle && $handle.pos, state.dragging);
	      }
	
	      return state;
	    }
	  }]);
	  return ResizeState;
	}();
	
	function handleMouseMove(view, event, cellMinWidth, store) {
	  var pluginState = pluginKey.getState(view.state);
	
	  if (pluginState.dragging && hadMouseDown) {
	    var offset = event.clientX - preStartX;
	    preStartX = event.clientX;
	    window.requestAnimationFrame(function () {
	      if (columnResizingDOM) {
	        var styleLeft = parseInt(columnResizingDOM.style.left, 10) + offset;
	        columnResizingDOM.style.left = styleLeft + 'px';
	      }
	    });
	    store.checkGlobalTabel();
	    displayColumnWidth(view, pluginState.activeHandle, draggedWidth(pluginState.dragging, event, cellMinWidth), cellMinWidth, store);
	  } else if (!window.ctImgResizing) {
	    var target = domCellAround(event.target);
	    var cell = -1;
	
	    if (target) {
	      var _target$getBoundingCl = target.getBoundingClientRect(),
	          left = _target$getBoundingCl.left,
	          right = _target$getBoundingCl.right;
	
	      var borderWidth = window.getComputedStyle(target, null)['border-left-width'];
	      handleWidth = parseInt(borderWidth || 1, 10) + 3;
	
	      if (Math.abs(event.clientX - left) <= handleWidth) {
	        cell = edgeCell(view, event, 'left');
	      } else if (Math.abs(right - event.clientX) <= handleWidth) {
	        cell = edgeCell(view, event, 'right');
	      }
	    }
	
	    if (cell !== pluginState.activeHandle) updateHandle(view, cell);
	  }
	}
	
	function handleMouseDown(view, event, cellMinWidth) {
	  hadMouseDown = false;
	
	  if (document.hidden) return false;
	  var pluginState = pluginKey.getState(view.state);
	  if (pluginState.activeHandle === -1 || pluginState.dragging) return false;
	  var cell = view.state.doc.nodeAt(pluginState.activeHandle);
	  var width = formatWidth(currentColWidth(view, pluginState.activeHandle, cell.attrs));
	  var docView = view.docView,
	      state = view.state;
	  var tr = state.tr,
	      schema = state.schema,
	      doc = state.doc;
	
	  var tableDOM = tableWrapperDOM.firstChild;
	
	  if (tableDOM.classList.contains('responsive')) {
	    var _schema$nodes2 = schema.nodes,
	        table_header = _schema$nodes2.table_header,
	        table_cell = _schema$nodes2.table_cell;
	
	    var cellTypes = [table_header, table_cell];
	    var tablePos = docView.posFromDOM(tableDOM) - 1;
	    var tableNode = doc.nodeAt(tablePos);
	    doc.nodesBetween(tablePos, tablePos + tableNode.nodeSize, function (node, pos) {
	      if (cellTypes.includes(node.type)) {
	        var attrs = node.attrs;
	        var cellDom = docView.domFromPos(pos + 1).node;
	        var colspan = parseInt(cellDom.getAttribute('colspan'), 10) || 1;
	        var cellWidth = cellDom.getBoundingClientRect().width / colspan;
	        var newColwidth = [];
	
	        for (var i = 0; i < colspan; i++) {
	          newColwidth.push(cellWidth);
	        }var newAttrs = objectSpread({}, attrs, {
	          colwidth: newColwidth
	        });
	
	        tr.setNodeMarkup(pos, null, newAttrs);
	        if (cell === node) width = formatWidth(currentColWidth(view, pluginState.activeHandle, newAttrs));
	      }
	    });
	    tr.setNodeMarkup(tablePos, null, objectSpread({}, tableNode.attrs, {
	      responsive: false
	    }));
	  }
	
	  view.dispatch(tr.setMeta(pluginKey, {
	    setDragging: {
	      startX: event.clientX,
	      startWidth: width
	    }
	  }));
	
	  function finish(e) {
	    hadMouseDown = false;
	    window.removeEventListener('mouseup', finish);
	    window.removeEventListener('mousemove', move);
	    var pluginState = pluginKey.getState(view.state);
	
	    if (pluginState.dragging) {
	      try {
	        updateColumnWidth(view, pluginState.activeHandle, draggedWidth(pluginState.dragging, e, cellMinWidth));
	        view.dispatch(view.state.tr.setMeta(pluginKey, {
	          setDragging: null
	        }));
	      } catch (error) {
	        console.warn(error);
	      }
	    }
	  }
	
	  function move(e) {
	    if (!e.which) finish(e);
	  }
	
	  window.addEventListener('mouseup', finish);
	  window.addEventListener('mousemove', move);
	  event.preventDefault();
	  hadMouseDown = true;
	  return true;
	}
	
	function currentColWidth(view, cellPos, _ref5) {
	  var colspan = _ref5.colspan,
	      colwidth = _ref5.colwidth;
	
	  var width = colwidth && colwidth[colwidth.length - 1];
	  if (width) return width;
	
	  var domWidth = view.domAtPos(cellPos + 1).node.offsetWidth,
	      parts = colspan;
	
	  if (colwidth) {
	    for (var i = 0; i < colspan; i++) {
	      if (colwidth[i]) {
	        domWidth -= colwidth[i];
	        parts--;
	      }
	    }
	  }
	
	  return domWidth / parts;
	}
	
	function domCellAround(target) {
	  while (target && target.nodeName !== 'TD' && target.nodeName !== 'TH') {
	    target = target.classList.contains('ProseMirror') ? null : target.parentNode;
	  }
	
	  return target;
	}
	
	function edgeCell(view, event, side) {
	  var left = side === 'left' ? event.clientX + 1 : event.clientX;
	  var posInfo = view.posAtCoords({
	    left: left,
	    top: event.clientY
	  });
	  if (!posInfo) return -1;
	  var pos = posInfo.pos;
	
	  var $cell = cellAround(view.state.doc.resolve(pos));
	  if (!$cell) return -1;
	  if (side === 'right') return $cell.pos;
	  var map = TableMap.get($cell.node(-1)),
	      start = $cell.start(-1);
	  var index = map.map.indexOf($cell.pos - start);
	  return index % map.width === 0 ? -1 : start + map.map[index - 1];
	}
	
	function draggedWidth(dragging, event, cellMinWidth) {
	  var offset = event.clientX - dragging.startX;
	  return Math.max(cellMinWidth, dragging.startWidth + offset);
	}
	
	function updateHandle(view, value) {
	  view.dispatch(view.state.tr.setMeta(pluginKey, {
	    setHandle: value
	  }));
	}
	
	function updateColumnWidth(view, cellPos, width) {
	  var $cell = view.state.doc.resolve(cellPos);
	  var table = $cell.node(-1),
	      map = TableMap.get(table),
	      start = $cell.start(-1);
	  var col = map.colCount($cell.pos - start) + $cell.nodeAfter.attrs.colspan - 1;
	  var tr = view.state.tr;
	
	  for (var row = 0; row < map.height; row++) {
	    var mapIndex = row * map.width + col;
	
	    if (row && map.map[mapIndex] === map.map[mapIndex - map.width]) continue;
	    var pos = map.map[mapIndex],
	        _table$nodeAt = table.nodeAt(pos),
	        attrs = _table$nodeAt.attrs;
	
	    var index = attrs.colspan === 1 ? 0 : col - map.colCount(pos);
	    if (attrs.colwidth && attrs.colwidth[index] === width) continue;
	    var colwidth = attrs.colwidth ? attrs.colwidth.slice() : zeroes(attrs.colspan);
	    colwidth[index] = width;
	    tr.setNodeMarkup(start + pos, null, setAttr(attrs, 'colwidth', colwidth));
	  }
	
	  if (tr.docChanged) view.dispatch(tr);
	}
	
	function displayColumnWidth(view, cell, width, cellMinWidth, store) {
	  var $cell = view.state.doc.resolve(cell);
	  var table = $cell.node(-1),
	      start = $cell.start(-1);
	  if (!table) return;
	  var col = TableMap.get(table).colCount($cell.pos - start) + $cell.nodeAfter.attrs.colspan - 1;
	  var dom = view.domAtPos($cell.start(-1)).node;
	
	  while (dom.nodeName !== 'TABLE') {
	    dom = dom.parentNode;
	  }updateColumns(table, dom.firstChild, dom, cellMinWidth, true, col, width, store);
	}
	
	function zeroes(n) {
	  var result = [];
	
	  for (var i = 0; i < n; i++) {
	    result.push(0);
	  }return result;
	}
	
	function handleDecorations(state, cell, view) {
	  var decorations = [];
	  var $cell = state.doc.resolve(cell);
	  var table = $cell.node(-1),
	      map = TableMap.get(table),
	      start = $cell.start(-1);
	  var col = map.colCount($cell.pos - start) + $cell.nodeAfter.attrs.colspan;
	
	  for (var row = 0; row < map.height; row++) {
	    var index = col + row * map.width - 1;
	
	    if ((col === map.width || map.map[index] !== map.map[index + 1]) && (row === 0 || map.map[index - 1] !== map.map[index - 1 - map.width])) {
	      var cellPos = map.map[index];
	      var pos = start + cellPos + table.nodeAt(cellPos).nodeSize - 1;
	      var dom = document.createElement('div');
	      cellDOM = view.domAtPos(pos).node;
	      var tableDOM = cellDOM.parentNode.parentNode.parentNode;
	      tableWrapperDOM = tableDOM.parentNode;
	      var tableParentOffsetLeft = index_js.getTargetLeft(tableWrapperDOM.parentNode) + parseInt(window.getComputedStyle(tableWrapperDOM.parentNode, null).paddingLeft, 10) + parseInt(window.getComputedStyle(tableDOM, null).marginLeft, 10);
	      dom.className = 'column-resize-handler';
	      var borderWidth = window.getComputedStyle(cellDOM, null)['border-left-width'];
	      handleWidth = parseInt(borderWidth || 1, 10) + 1;
	      var styleLeft = index_js.getTargetLeft(cellDOM) + cellDOM.offsetWidth + tableWrapperDOM.scrollLeft - tableParentOffsetLeft - Math.floor(handleWidth / 2) + 1;
	
	      if (!columnResizingDOM && window.navigator.platform === 'Win32') {
	        styleLeft -= 1;
	      }
	
	      dom.style.left = styleLeft - 2 + 'px';
	      dom.style.bottom = '-' + Math.floor(handleWidth / 2) + 'px';
	      columnResizingDOM = dom;
	      decorations.push(prosemirrorView.Decoration.widget(view.docView.posFromDOM(cellDOM.parentNode), dom));
	      break;
	    }
	  }
	
	  return prosemirrorView.DecorationSet.create(state.doc, decorations);
	}
	
	function insertTable(store) {
	  return function (rowCount, colCount, headerData) {
	    return function (state, dispatch, view, trigger) {
	      var schema = state.schema;
	      var _schema$nodes3 = schema.nodes,
	          table = _schema$nodes3.table,
	          table_row = _schema$nodes3.table_row,
	          table_cell = _schema$nodes3.table_cell,
	          table_header = _schema$nodes3.table_header;
	
	      var headers = [];
	
	      for (var i = 0; i < colCount; i++) {
	        var headerNode = headerData ? table_header.create({
	          colwidth: [68]
	        }, headerData[i]) : table_header.createAndFill({
	          colwidth: [68]
	        });
	        headers.push(headerNode);
	      }
	
	      var rowHeader = table_row.create(null, prosemirrorModel.Fragment.from(headers));
	      var rows = [rowHeader];
	
	      for (var _i4 = 0; _i4 < rowCount - 1; _i4++) {
	        var cells = [];
	
	        for (var j = 0; j < colCount; j++) {
	          var cellNode = table_cell.createAndFill({
	            colwidth: [68]
	          });
	          cells.push(cellNode);
	        }
	
	        var rowNode = table_row.create(null, prosemirrorModel.Fragment.from(cells));
	        rows.push(rowNode);
	      }
	
	      var tableNode = table.create(null, prosemirrorModel.Fragment.from(rows));
	
	      var _index_js$insertBlock = index_js.insertBlock(state, tableNode),
	          transaction = _index_js$insertBlock.transaction,
	          newPos = _index_js$insertBlock.newPos;
	
	      if (!transaction) return false;
	      dispatch(transaction.scrollIntoView());
	      var tableDOM = view.docView.domFromPos(newPos).node.parentNode.parentNode.parentNode;
	      if (tableDOM.tagName.toUpperCase() === 'TBODY') tableDOM = tableDOM.parentNode;
	      store.showPopover(tableDOM);
	      trigger && trigger('afterInsert', {
	        draggable: true
	      });
	      view.focus();
	      return true;
	    };
	  };
	}
	
	function columnIsHeader(map, table, col) {
	  var headerCell = table.type.schema.nodes.table_header;
	
	  for (var row = 0; row < map.height; row++) {
	    if (table.nodeAt(map.map[col + row * map.width]).type !== headerCell) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	function addColumn(tr, _ref6, col, numCell, hasRowHeader, defaultColWidth, dir) {
	  var map = _ref6.map,
	      tableStart = _ref6.tableStart,
	      table = _ref6.table,
	      tableCell = _ref6.tableCell;
	  var _table$type$schema$no = table.type.schema.nodes,
	      table_cell = _table$type$schema$no.table_cell,
	      table_header = _table$type$schema$no.table_header,
	      paragraph = _table$type$schema$no.paragraph;
	
	  if (hasRowHeader === undefined) hasRowHeader = getHasRowHeader(table.content.content, table_header);
	  var refColumn = col > 0 ? -1 : 0;
	
	  if (columnIsHeader(map, table, col + refColumn)) {
	    refColumn = col === 0 || col === map.width ? null : 0;
	  }
	
	  for (var row = 0; row < map.height; row++) {
	    var index = row * map.width + col;
	
	    if (col > 0 && col < map.width && map.map[index - 1] === map.map[index]) {
	      var pos = map.map[index];
	      var cell = table.nodeAt(pos);
	      tr.setNodeMarkup(tr.mapping.map(tableStart + pos), null, addColspan(cell.attrs, col - map.colCount(pos)));
	
	      row += cell.attrs.rowspan - 1;
	    } else {
	      var cellIndex = refColumn !== null ? map.map[index + refColumn + dir] : map.map[map.width - 1];
	      var _cell2 = table.nodeAt(cellIndex || map.map[map.width - 1]);
	      var type = row === 0 && hasRowHeader ? table_header : table_cell;
	      var _pos = map.positionAt(row, col, table);
	
	      var colwidth = defaultColWidth || _cell2.attrs.colwidth;
	
	      var firstChildAlign = _cell2.firstChild.attrs.align;
	      var defaultType = paragraph;
	      var attrs = !numCell || hasRowHeader && row === 0 ? {
	        colwidth: [].concat((0, _toConsumableArray3.default)(colwidth))
	      } : {
	        numCell: numCell,
	        colwidth: [].concat((0, _toConsumableArray3.default)(colwidth)) };
	
	      if (numCell) {
	        row += _cell2.attrs.rowspan - 1;
	        tr.insert(tr.mapping.map(tableStart + _pos), type.createAndFill(objectSpread({}, attrs, {
	          rowspan: _cell2.attrs.rowspan
	        }), defaultType.create({
	          align: firstChildAlign
	        })));
	      } else {
	        tr.insert(tr.mapping.map(tableStart + _pos), type.createAndFill(attrs, defaultType.create({
	          align: firstChildAlign
	        })));
	      }
	    }
	  }
	
	  return tr;
	}
	
	function _addColumnBefore(store) {
	  return function (state, dispatch, view) {
	    var schema = state.schema;
	    var _schema$nodes4 = schema.nodes,
	        table_header = _schema$nodes4.table_header,
	        table_cell = _schema$nodes4.table_cell;
	
	    var cellTypes = [table_header, table_cell];
	    var rect = selectedRect(state);
	    if (!rect) return false;
	    var tableContent = rect.table.content.content;
	
	    if (rect.left === 0 || rect.left === 1) {
	      var _getHasColHeader = getHasColHeader(tableContent, table_header),
	          hasColHeader = _getHasColHeader.hasColHeader,
	          headerCol = _getHasColHeader.headerCol;
	
	      if (hasColHeader && rect.left === headerCol) return false;
	      var hasNumCol = getHasNumCol(tableContent, table_header);
	      if (hasNumCol && rect.left === 0) return false;
	    }
	
	    if (dispatch) {
	      var hasRowHeader = getHasRowHeader(tableContent, table_header);
	
	      var originNode = index_js.findParentNode(state.tr.selection.$from.path, function (node) {
	        return cellTypes.includes(node.type);
	      });
	      var attrs = originNode.node.attrs;
	
	      var combinedColWidth = [attrs.colwidth.reduce(function (prev, cur) {
	        return prev + cur;
	      })];
	      var tr = addColumn(state.tr, rect, rect.left, false, hasRowHeader, combinedColWidth, rect.left === 0 ? 0 : 1);
	      var foundCellNode = index_js.findParentNode(tr.selection.$from.path, function (node) {
	        return cellTypes.includes(node.type);
	      });
	      var newPos = foundCellNode.pos - 2;
	      if (newPos >= 0) tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, newPos));
	      dispatch(tr);
	      store.handleTableWidthChange();
	      view.focus();
	    }
	
	    return true;
	  };
	}
	
	function _addColumnAfter(store) {
	  return function (state, dispatch, view) {
	    var schema = state.schema;
	    var _schema$nodes5 = schema.nodes,
	        table_header = _schema$nodes5.table_header,
	        table_cell = _schema$nodes5.table_cell;
	
	    var cellTypes = [table_header, table_cell];
	    var rect = selectedRect(state);
	    if (!rect) return false;
	    var tableContent = rect.table.content.content;
	
	    if (rect.left === 0 || rect.left === 1) {
	      var _getHasColHeader2 = getHasColHeader(tableContent, table_header),
	          hasColHeader = _getHasColHeader2.hasColHeader,
	          headerCol = _getHasColHeader2.headerCol;
	
	      if (hasColHeader && rect.left + 1 === headerCol) return false;
	    }
	
	    if (dispatch) {
	      var originNode = index_js.findParentNode(state.tr.selection.$from.path, function (node) {
	        return cellTypes.includes(node.type);
	      });
	      var attrs = originNode.node.attrs;
	
	      var hasRowHeader = getHasRowHeader(tableContent, table_header);
	      var combinedColWidth = [attrs.colwidth.reduce(function (prev, cur) {
	        return prev + cur;
	      })];
	      var tr = addColumn(state.tr, rect, rect.right, false, hasRowHeader, combinedColWidth, 0);
	
	      var foundCellNode = index_js.findParentNode(tr.selection.$from.path, function (node) {
	        return cellTypes.includes(node.type);
	      });
	      var newPos = foundCellNode.pos + foundCellNode.node.nodeSize + 2;
	      if (newPos >= 0) tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, newPos));
	      dispatch(tr);
	      store.handleTableWidthChange('right');
	      view.focus();
	    }
	
	    return true;
	  };
	}
	
	function rowIsHeader(map, table, row) {
	  var headerCell = table.type.schema.nodes.table_header;
	
	  for (var col = 0; col < map.width; col++) {
	    if (table.nodeAt(map.map[col + row * map.width]).type !== headerCell) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	function addRow(tr, _ref7, row) {
	  var map = _ref7.map,
	      tableStart = _ref7.tableStart,
	      table = _ref7.table;
	
	  var nodes = table.type.schema.nodes;
	  var table_cell = nodes.table_cell,
	      table_header = nodes.table_header,
	      paragraph = nodes.paragraph;
	
	  var tableContent = table.content.content;
	  var hasNumCol = getHasNumCol(tableContent, table_header);
	
	  var _getHasColHeader3 = getHasColHeader(tableContent, table_header),
	      headerCol = _getHasColHeader3.headerCol;
	
	  var rowPos = tableStart;
	
	  for (var i = 0; i < row; i++) {
	    rowPos += table.child(i).nodeSize;
	  }var cells = [];
	  var rowspanPos = new _set2.default();
	  var refRow = row > 0 ? -1 : 0;
	
	  if (rowIsHeader(map, table, row + refRow)) {
	    refRow = row === 0 || row === map.height ? null : 0;
	  }
	
	  for (var col = 0, index = map.width * row; col < map.width; col++, index++) {
	    if (row > 0 && row < map.height && map.map[index] === map.map[index - map.width]) {
	      var pos = map.map[index];
	      if (rowspanPos.has(pos)) continue;
	      rowspanPos.add(pos);
	      var cellNode = table.nodeAt(pos, index);
	      var attrs = cellNode.attrs;
	      tr.setNodeMarkup(tableStart + pos, null, setAttr(attrs, 'rowspan', attrs.rowspan + 1));
	      col += attrs.colspan - 1;
	    } else {
	      var type = col === headerCol ? table_header : table_cell;
	      var tableCell = void 0;
	      var colwidth = null;
	
	      if (refRow) {
	        tableCell = table.nodeAt(map.map[index + refRow * map.width]);
	        colwidth = tableCell.attrs.colwidth;
	      }
	
	      var _attrs = hasNumCol && col === 0 ? {
	        colwidth: colwidth,
	        numCell: true
	      } : {
	        colwidth: colwidth };
	
	      if (tableCell) {
	        var firstChildAlign = tableCell.firstChild.attrs.align;
	        var defaultType = paragraph;
	        cells.push(type.createAndFill(_attrs, defaultType.create({
	          align: firstChildAlign
	        })));
	      } else {
	        cells.push(type.createAndFill(_attrs));
	      }
	    }
	  }
	
	  tr.insert(rowPos, nodes.table_row.create(null, cells));
	  return tr;
	}
	
	function _addRowBefore(store) {
	  return function (state, dispatch, view) {
	    var selection = state.selection,
	        schema = state.schema;
	    var $from = selection.$from;
	    var _schema$nodes6 = schema.nodes,
	        table_row = _schema$nodes6.table_row,
	        table_header = _schema$nodes6.table_header;
	
	    var rect = selectedRect(state);
	    if (!rect) return false;
	    var tableContent = rect.table.content.content;
	    var hasRowHeader = getHasRowHeader(tableContent, table_header);
	    if (hasRowHeader && rect.top === 0) return false;
	
	    if (dispatch) {
	      var tr = addRow(state.tr, rect, rect.top);
	
	      var foundRowNode = index_js.findParentNode($from.path, function (node) {
	        return node.type === table_row;
	      });
	      var hasNumCol = getHasNumCol(tableContent, table_header);
	
	      var newPos = getAddRowBeforePos(rect, foundRowNode, hasNumCol);
	      if (newPos >= 0) tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, newPos));
	      dispatch(tr);
	      store.handleTableHeightChange();
	      view.focus();
	    }
	
	    return true;
	  };
	}
	
	function getAddRowBeforePos(rect, foundRowNode) {
	  var leftStart = rect.top * rect.map.width;
	  var leftEnd = leftStart + rect.left;
	  var leftPosArr = rect.map.map.slice(leftStart, leftEnd);
	  var leftDis = 0;
	  var lastMaxPos = rect.map.map[leftStart - 1];
	  leftPosArr.forEach(function (pos) {
	    if (pos >= lastMaxPos) {
	      leftDis++;
	      lastMaxPos = pos;
	    }
	  });
	  return foundRowNode.pos + 2 + leftDis * 4;
	}
	
	function _addRowAfter(store) {
	  return function (state, dispatch, view) {
	    if (dispatch) {
	      var selection = state.selection,
	          _schema = state.schema;
	      var $from = selection.$from;
	      var _schema$nodes7 = _schema.nodes,
	          table_row = _schema$nodes7.table_row,
	          table_header = _schema$nodes7.table_header;
	
	      var rect = selectedRect(state);
	      if (!rect) return false;
	      var tableContent = rect.table.content.content;
	      var tr = addRow(state.tr, rect, rect.bottom);
	
	      if (rect.tableCell.attrs.rowspan === 1) {
	        var foundRowNode = index_js.findParentNode($from.path, function (node) {
	          return node.type === table_row;
	        });
	        var hasNumCol = getHasNumCol(tableContent, table_header);
	
	        var newPos = getAddRowAfterPos(rect, foundRowNode, hasNumCol);
	        if (newPos >= 0) tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, newPos));
	      }
	
	      dispatch(tr.scrollIntoView());
	      store.$scroll.scrollTop += 30;
	      store.handleTableHeightChange();
	      view.focus();
	    }
	
	    return true;
	  };
	}
	
	function getAddRowAfterPos(rect, foundRowNode, hasNumCol) {
	  var nextRowPos = foundRowNode.pos + foundRowNode.node.nodeSize + 2;
	  var leftStart = (rect.top + 1) * rect.map.width;
	  var leftEnd = leftStart + rect.left;
	  var leftPosArr = rect.map.map.slice(leftStart, leftEnd);
	
	  if (leftPosArr.length === 0) {
	    return nextRowPos + 1 + rect.left * 4;
	  }
	
	  var leftDis = 0;
	  var lastMaxPos = rect.map.map[leftStart - 1];
	  leftPosArr.forEach(function (pos) {
	    if (pos >= lastMaxPos) {
	      leftDis++;
	      lastMaxPos = pos;
	    }
	  });
	  return nextRowPos + 1 + leftDis * 4;
	}
	
	function _mergeCells(state, dispatch) {
	  var selection = state.selection,
	      schema = state.schema;
	  var _schema$nodes8 = schema.nodes,
	      table_cell = _schema$nodes8.table_cell,
	      table_header = _schema$nodes8.table_header;
	
	  var cellTypes = [table_cell, table_header];
	
	  if (selection instanceof CellSelection) {
	    var hasNumCell = false;
	    var allNumCell = true;
	    selection.ranges.forEach(function (range) {
	      var foundCellNode = index_js.findParentNode(range.$from.path, function (node) {
	        return node && cellTypes.includes(node.type);
	      });
	
	      if (foundCellNode && foundCellNode.node.attrs.numCell) {
	        hasNumCell = true;
	      } else {
	        allNumCell = false;
	      }
	    });
	    if (hasNumCell && !allNumCell) return false;
	  }
	
	  var sel = state.selection;
	  if (!(sel instanceof CellSelection) || sel.$anchorCell.pos === sel.$headCell.pos) return false;
	  var rect = selectedRect(state);
	  var map = rect.map;
	
	  if (cellsOverlapRectangle(map, rect)) {
	    return false;
	  }
	
	  if (dispatch) {
	    var tr = state.tr;
	    var colwidth = [];
	    var content = prosemirrorModel.Fragment.empty;
	    var mergedPos = void 0;
	    var mergedCell = void 0;
	    var seen = [];
	
	    for (var row = rect.top; row < rect.bottom; row++) {
	      var posArr = [];
	
	      for (var col = rect.left; col < rect.right; col++) {
	        var cellPos = map.map[row * map.width + col];
	
	        if (posArr.includes(cellPos)) continue;
	        posArr.push(cellPos);
	        var cell = rect.table.nodeAt(cellPos);
	
	        if (row === rect.top) {
	          colwidth = colwidth.concat(cell.attrs.colwidth);
	        }
	
	        if (seen.indexOf(cellPos) > -1) continue;
	        seen.push(cellPos);
	
	        if (mergedPos == null) {
	          mergedPos = cellPos;
	          mergedCell = cell;
	        } else {
	          if (!isEmptyCell(cell)) {
	            content = content.append(cell.content);
	          }
	
	          var mapped = tr.mapping.map(cellPos + rect.tableStart);
	          tr.delete(mapped, mapped + cell.nodeSize);
	        }
	      }
	    }
	
	    var newAttrs = objectSpread({}, mergedCell.attrs, {
	      colspan: rect.right - rect.left,
	      rowspan: rect.bottom - rect.top,
	      colwidth: colwidth
	    });
	
	    tr.setNodeMarkup(mergedPos + rect.tableStart, null, newAttrs);
	
	    if (content.size) {
	      var end = mergedPos + 1 + mergedCell.content.size;
	      var start = isEmptyCell(mergedCell) ? mergedPos + 1 : end;
	      tr.replaceWith(start + rect.tableStart, end + rect.tableStart, content);
	    }
	
	    tr.setSelection(new CellSelection(tr.doc.resolve(mergedPos + rect.tableStart)));
	    dispatch(tr);
	  }
	
	  return true;
	}
	
	function _splitCell(state, dispatch) {
	  var schema = state.schema,
	      tr = state.tr;
	  var _schema$nodes9 = schema.nodes,
	      table_cell = _schema$nodes9.table_cell,
	      table_header = _schema$nodes9.table_header;
	
	  var selection = state.selection;
	
	  if (!(selection instanceof CellSelection)) {
	    var rowType = schema.nodes.table_row;
	    var pos = void 0;
	
	    var fromPath = [].concat((0, _toConsumableArray3.default)(selection.$from.path)).reverse();
	
	    for (var i = 0; i < fromPath.length; i++) {
	      var node = fromPath[i];
	
	      if (node.type === rowType) {
	        pos = fromPath[i - 2];
	        break;
	      }
	    }
	
	    if (!pos) return false;
	    selection = new CellSelection(tr.doc.resolve(pos));
	    tr.setSelection(selection);
	  }
	
	  if (selection.$anchorCell.pos !== selection.$headCell.pos) return false;
	  var cellNode = selection.$anchorCell.nodeAfter;
	  if (cellNode.attrs.colspan === 1 && cellNode.attrs.rowspan === 1) return false;
	
	  if (dispatch) {
	    var baseAttrs = cellNode.attrs;
	    var attrs = [];
	    var colwidth = baseAttrs.colwidth;
	    if (baseAttrs.rowspan > 1) baseAttrs = setAttr(baseAttrs, 'rowspan', 1);
	    if (baseAttrs.colspan > 1) baseAttrs = setAttr(baseAttrs, 'colspan', 1);
	    var rect = selectedRect(state);
	    if (!rect) return false;
	    var tableContent = rect.table.content.content;
	    var hasRowHeader = getHasRowHeader(tableContent, table_header);
	
	    var _getHasColHeader4 = getHasColHeader(tableContent, table_header, hasRowHeader),
	        hasColHeader = _getHasColHeader4.hasColHeader,
	        headerCol = _getHasColHeader4.headerCol;
	
	    var _tr = state.tr;
	
	    for (var _i5 = 0; _i5 < rect.right - rect.left; _i5++) {
	      attrs.push(colwidth ? setAttr(baseAttrs, 'colwidth', colwidth && colwidth[_i5] ? [colwidth[_i5]] : null) : baseAttrs);
	    }
	
	    var lastCell = void 0;
	
	    for (var row = 0; row < rect.bottom; row++) {
	      if (row >= rect.top) {
	        var _pos2 = rect.map.positionAt(row, rect.left, rect.table);
	        if (row === rect.top) _pos2 += cellNode.nodeSize;
	
	        for (var col = rect.left, _i6 = 0; col < rect.right; col++, _i6++) {
	          if (col === rect.left && row === rect.top) continue;
	          var cellType = table_cell;
	
	          if (row === 0 && hasRowHeader || col === headerCol && hasColHeader) {
	            cellType = table_header;
	          }
	
	          _tr.insert(lastCell = _tr.mapping.map(_pos2 + rect.tableStart, 1), cellType.createAndFill(attrs[_i6]));
	        }
	      }
	    }
	
	    _tr.setNodeMarkup(selection.$anchorCell.pos, null, attrs[0]);
	    _tr.setSelection(new CellSelection(_tr.doc.resolve(selection.$anchorCell.pos), lastCell && _tr.doc.resolve(lastCell)));
	    dispatch(_tr);
	  }
	
	  return true;
	}
	
	function deleteTableLib(state, dispatch) {
	  var $pos = state.selection.$anchor;
	
	  for (var d = $pos.depth; d > 0; d--) {
	    var node = $pos.node(d);
	
	    if (node.type.spec.tableRole === 'table') {
	      if (dispatch) dispatch(state.tr.delete($pos.before(d), $pos.after(d)).scrollIntoView());
	      return true;
	    }
	  }
	
	  return false;
	}
	
	function _deleteTable(store) {
	  return function (state, dispatch, view, trigger) {
	    if (deleteTableLib(state, dispatch)) {
	      store.hidePopover();
	      trigger && trigger('afterDelete', {
	        draggable: true
	      });
	      view.focus();
	      return true;
	    }
	
	    return false;
	  };
	}
	
	function deleteColumnLib(state, dispatch) {
	  if (dispatch) {
	    var rect = selectedRect(state);
	    var tr = state.tr;
	    if (rect.left === 0 && rect.right == rect.map.width) return false;
	
	    for (var i = rect.right - 1;; i--) {
	      removeColumn(tr, rect, i);
	      if (i == rect.left) break;
	      rect.table = rect.tableStart ? tr.doc.nodeAt(rect.tableStart - 1) : tr.doc;
	      rect.map = TableMap.get(rect.table);
	    }
	
	    dispatch(tr);
	  }
	
	  return true;
	}
	
	function _deleteColumn(store) {
	  return function (state, dispatch, view) {
	    var transaction = state.tr;
	    var rect = selectedRect(state);
	    if (!rect) return false;
	
	    var fakeDispatch = function fakeDispatch(tr) {
	      transaction = tr;
	    };
	
	    if (deleteColumnLib(state, fakeDispatch)) {
	      var selection = state.selection,
	          _schema2 = state.schema;
	      var table_row = _schema2.nodes.table_row;
	
	      var path = selection.$from.path;
	      var foundRowNode = index_js.findParentNode(path, function (node) {
	        return node.type === table_row;
	      });
	      var tableCellNode = rect.tableCell;
	
	      if (foundRowNode.node.lastChild === tableCellNode) {
	        transaction = transaction.setSelection(prosemirrorState.TextSelection.create(transaction.doc, transaction.selection.from - 6));
	      }
	
	      dispatch(transaction);
	      view.focus();
	      store.handleTableWidthChange();
	      return true;
	    }
	
	    return _deleteTable(store)(state, dispatch, view);
	  };
	}
	
	function removeRow(tr, ref, row) {
	  var map = ref.map;
	  var table = ref.table;
	  var tableStart = ref.tableStart;
	  var rowPos = 0;
	
	  for (var i = 0; i < row; i++) {
	    rowPos += table.child(i).nodeSize;
	  }
	
	  var nextRow = rowPos + table.child(row).nodeSize;
	  var mapFrom = tr.mapping.maps.length;
	  tr.delete(rowPos + tableStart, nextRow + tableStart);
	  var lastPos = null;
	
	  for (var col = 0, index = row * map.width; col < map.width; col++, index++) {
	    var pos = map.map[index];
	
	    if (pos !== lastPos) {
	      if (row > 0 && pos === map.map[index - map.width]) {
	        var attrs = table.nodeAt(pos).attrs;
	
	        tr.setNodeMarkup(tr.mapping.slice(mapFrom).map(pos + tableStart), null, setAttr(attrs, 'rowspan', attrs.rowspan - 1));
	        col += attrs.colspan - 1;
	      } else if (row < map.width && pos === map.map[index + map.width]) {
	        var cell = table.nodeAt(pos);
	        var copy = cell.type.create(setAttr(cell.attrs, 'rowspan', cell.attrs.rowspan - 1), cell.content);
	        var newPos = map.positionAt(row + 1, col, table);
	        tr.insert(tr.mapping.slice(mapFrom).map(tableStart + newPos), copy);
	        col += cell.attrs.colspan - 1;
	      }
	    }
	
	    lastPos = pos;
	  }
	}
	
	function _deleteRow(store) {
	  return function (state, dispatch, view) {
	    var tr = state.tr,
	        selection = state.selection,
	        schema = state.schema;
	    var table_row = schema.nodes.table_row;
	
	    var rect = selectedRect(state);
	
	    if (!rect || rect.top === 0 && rect.bottom === rect.map.height) {
	      return _deleteTable(store)(state, dispatch, view);
	    }
	
	    for (var i = rect.bottom - 1;; i--) {
	      removeRow(tr, rect, i);
	
	      if (i === rect.top) {
	        break;
	      }
	
	      rect.table = rect.tableStart ? tr.doc.nodeAt(rect.tableStart - 1) : tr.doc;
	      rect.map = TableMap.get(rect.table);
	    }
	
	    var newPos = getDeleteRowPos(rect, tr, selection, table_row);
	    if (newPos >= 0) tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, newPos));
	    dispatch(tr);
	    view.focus();
	    store.handleTableHeightChange();
	    return true;
	  };
	}
	
	function getDeleteRowPos(rect, tr, selection, table_row) {
	  var path = selection.$from.path;
	
	  if (selection instanceof CellSelection) {
	    var minFromPos = selection.from;
	    selection.ranges.forEach(function (sel) {
	      if (sel.$from.pos < minFromPos) {
	        path = sel.$from.path;
	        minFromPos = sel.from;
	      }
	    });
	    var _foundRowNode = index_js.findParentNode(path, function (node) {
	      return node.type === table_row;
	    });
	    return _foundRowNode.pos - 3;
	  }
	
	  var tableNode = rect.table;
	  var foundRowNode = index_js.findParentNode(path, function (node) {
	    return node.type === table_row;
	  });
	  var currentRowNode = foundRowNode.node;
	  var nowPos = tr.selection.from;
	  var tableNodeContent = tableNode.content.content;
	  var numCellPlus = rect.tableCell.attrs.numCell ? 4 : 0;
	
	  var height = rect.map.height - 1;
	  var lastNotEmptyRowNode = tableNodeContent[height];
	
	  while (lastNotEmptyRowNode.nodeSize === 2 && tableNode[--height]) {
	    lastNotEmptyRowNode = tableNode[--height];
	  }
	
	  var isLastRow = currentRowNode === lastNotEmptyRowNode || currentRowNode.nodeSize === lastNotEmptyRowNode.nodeSize && currentRowNode.textContent === lastNotEmptyRowNode.textContent;
	
	  if (isLastRow && tableNodeContent.length !== 1) {
	    var leftPlus = rect.map.map[rect.map.width * (rect.top - 1) + rect.left] || 0;
	    return rect.tableStart + leftPlus + 1 + numCellPlus;
	  }
	
	  var leftStart = (rect.top + 1) * rect.map.width;
	  var leftEnd = leftStart + rect.left;
	  var leftPosArr = rect.map.map.slice(leftStart, leftEnd);
	  var leftDis = 0;
	  var lastMaxPos = rect.map.map[leftStart - 1];
	  leftPosArr.forEach(function (pos) {
	    if (pos >= lastMaxPos) {
	      leftDis++;
	      lastMaxPos = pos;
	    }
	  });
	  if (!tableNodeContent[rect.top + 1]) return nowPos + numCellPlus;
	  var tableRowNodeContent = tableNodeContent[rect.top + 1].content.content;
	  var plus = 0;
	
	  for (var i = 0; i < leftDis; i++) {
	    plus += tableRowNodeContent[i] ? tableRowNodeContent[i].nodeSize : 0;
	  }
	
	  return nowPos + plus + numCellPlus;
	}
	
	function toggleRowHeader(store) {
	  return function (hasRowHeader, headerCol, hasNumCol, tableNode, startPos) {
	    return function (state, dispatch, view) {
	      if (dispatch) {
	        var tr = state.tr,
	            _schema3 = state.schema;
	
	        var cellType = _schema3.nodes.table_cell;
	        var headerType = _schema3.nodes.table_header;
	        var transaction = void 0;
	
	        if (hasRowHeader) {
	          tr.doc.nodesBetween(startPos, tableNode.nodeSize + startPos, function (node, pos, parent) {
	            if (node.type === headerType && parent === tableNode.firstChild) {
	              var newAttrs = node.attrs;
	
	              if (node === parent.firstChild) {
	                if (hasNumCol) newAttrs = objectSpread({}, newAttrs, {
	                  numCell: true
	                });
	                transaction = headerCol === 0 ? tr.setNodeMarkup(pos, null, newAttrs) : tr.setNodeMarkup(pos, cellType, newAttrs);
	              } else {
	                var index = parent.content.content.indexOf(node);
	
	                if (headerCol !== index) {
	                  transaction = tr.setNodeMarkup(pos, cellType, newAttrs);
	                }
	              }
	            }
	          });
	        } else {
	          tr.doc.nodesBetween(startPos, tableNode.nodeSize + startPos, function (node, pos, parent) {
	            if (parent === tableNode.firstChild) {
	              var attrs = node.attrs;
	              transaction = hasNumCol ? tr.setNodeMarkup(pos, headerType, objectSpread({}, attrs, {
	                numCell: false
	              })) : tr.setNodeMarkup(pos, headerType, attrs);
	            }
	          });
	        }
	
	        if (transaction) dispatch(transaction);
	      }
	
	      view.focus();
	      var tableDOM = view.docView.domFromPos(startPos + 1).node;
	      if (tableDOM.tagName.toUpperCase() !== 'TABLE') tableDOM = tableDOM.parentNode;
	      store.showPopover(tableDOM);
	      return true;
	    };
	  };
	}
	
	function toggleColHeader(hasColHeader, hasRowHeader, hasNumCol, tableNode, startPos) {
	  return function (state, dispatch, view) {
	    if (dispatch) {
	      var tr = state.tr,
	          _schema4 = state.schema;
	
	      var cellType = _schema4.nodes.table_cell;
	      var headerType = _schema4.nodes.table_header;
	      var tableContent = tableNode.content.content;
	      var transaction = void 0;
	
	      if (hasColHeader) {
	        tr.doc.nodesBetween(startPos, tableNode.nodeSize + startPos, function (node, pos, parent) {
	          if (node.type === headerType && tableContent.includes(parent) && !(hasRowHeader && parent === tableNode.firstChild)) {
	            transaction = tr.setNodeMarkup(pos, cellType, node.attrs);
	          }
	        });
	      } else {
	        var rowspan = 0;
	        tr.doc.nodesBetween(startPos, tableNode.nodeSize + startPos, function (node, pos, parent) {
	          if (node === parent.firstChild && tableContent.includes(parent)) {
	            if (!rowspan) {
	              if (node.attrs.rowspan > 1) rowspan = node.attrs.rowspan - 1;
	              if (node.type === cellType) transaction = tr.setNodeMarkup(pos, headerType, node.attrs);
	            } else {
	              rowspan--;
	            }
	          }
	        });
	      }
	
	      if (transaction) dispatch(transaction);
	    }
	
	    view.focus();
	    return true;
	  };
	}
	
	function removeColumn(tr, _ref8, col) {
	  var map = _ref8.map,
	      table = _ref8.table,
	      tableStart = _ref8.tableStart;
	
	  var mapStart = tr.mapping.maps.length;
	
	  for (var row = 0; row < map.height;) {
	    var index = row * map.width + col;
	    var pos = map.map[index];
	    var cell = table.nodeAt(pos);
	
	    if (col > 0 && map.map[index - 1] === pos || col < map.width - 1 && map.map[index + 1] === pos) {
	      tr.setNodeMarkup(tr.mapping.slice(mapStart).map(tableStart + pos), null, rmColSpan(cell.attrs, col - map.colCount(pos)));
	    } else {
	      var start = tr.mapping.slice(mapStart).map(tableStart + pos);
	      tr.delete(start, start + cell.nodeSize);
	    }
	
	    row += cell.attrs.rowspan;
	  }
	}
	
	function toggleNumCol(store) {
	  return function (hasNumCol, hasRowHeader) {
	    return function (state, dispatch, view) {
	      if (dispatch) {
	        var tr = state.tr;
	
	        var rect = selectedRect(state);
	        if (!rect) return false;
	        var transaction = tr;
	
	        if (hasNumCol) {
	          removeColumn(transaction, rect, 0);
	        } else {
	          transaction = addColumn(transaction, rect, 0, true, hasRowHeader, [50], 0);
	        }
	
	        dispatch(transaction);
	      }
	
	      store.handleTableWidthChange();
	      view.focus();
	      return true;
	    };
	  };
	}
	
	function setBgColor(color) {
	  return function (state, dispatch, view) {
	    var selection = state.selection,
	        tr = state.tr,
	        schema = state.schema;
	
	    var transaction = tr;
	
	    if (selection instanceof CellSelection) {
	      var ranges = selection.ranges;
	      ranges.forEach(function (sel) {
	        var $from = sel.$from;
	
	        transaction = transaction.setNodeMarkup($from.pos - 1, $from.parent.type, objectSpread({}, $from.parent.attrs, {
	          bgColor: color
	        }));
	      });
	    } else {
	      var cellType = schema.nodes.table_cell;
	      var headerType = schema.nodes.table_header;
	      var foundNode = index_js.findParentNode(selection.$from.path, function (node) {
	        return [cellType, headerType].includes(node.type);
	      });
	
	      transaction = transaction.setNodeMarkup(foundNode.pos, foundNode.node.type, objectSpread({}, foundNode.node.attrs, {
	        bgColor: color
	      }));
	    }
	
	    dispatch(transaction);
	    return true;
	  };
	}
	
	function _setResponsive(store) {
	  return function (state, dispatch, view) {
	    var selection = state.selection,
	        tr = state.tr,
	        schema = state.schema;
	
	    var tableType = schema.nodes.table;
	    var foundNode = index_js.findParentNode(selection.$from.path, function (node) {
	      return node.type === tableType;
	    });
	    if (!foundNode) return true;
	
	    if (!foundNode.node.attrs.responsive) {
	      if (dispatch) {
	        tr.setNodeMarkup(foundNode.pos, null, objectSpread({}, foundNode.node.attrs, {
	          responsive: true
	        }));
	        dispatch(tr);
	        view.focus();
	        var tableDOM = view.docView.domFromPos(foundNode.pos + 1).node;
	        if (tableDOM.tagName.toUpperCase() !== 'TABLE') tableDOM = tableDOM.parentNode;
	        store.showPopover(tableDOM);
	      }
	
	      return true;
	    }
	
	    return false;
	  };
	}
	
	function _setFixed(state, dispatch, view) {
	  var selection = state.selection,
	      tr = state.tr,
	      schema = state.schema,
	      doc = state.doc;
	
	  var tableType = schema.nodes.table;
	  var foundNode = index_js.findParentNode(selection.$from.path, function (node) {
	    return node.type === tableType;
	  });
	
	  if (foundNode && foundNode.node.attrs.responsive) {
	    if (dispatch) {
	      var docView = view.docView;
	      var _schema$nodes10 = schema.nodes,
	          table_header = _schema$nodes10.table_header,
	          table_cell = _schema$nodes10.table_cell;
	
	      var cellTypes = [table_header, table_cell];
	      var tablePos = foundNode.pos;
	      var tableNode = foundNode.node;
	      doc.nodesBetween(tablePos, tablePos + tableNode.nodeSize, function (node, pos) {
	        if (cellTypes.includes(node.type)) {
	          var attrs = node.attrs;
	          var cellDom = docView.domFromPos(pos + 1).node;
	          var colspan = parseInt(cellDom.getAttribute('colspan'), 10) || 1;
	          var cellWidth = cellDom.getBoundingClientRect().width / colspan;
	          var newColwidth = [];
	
	          for (var i = 0; i < colspan; i++) {
	            newColwidth.push(cellWidth);
	          }var newAttrs = objectSpread({}, attrs, {
	            colwidth: newColwidth
	          });
	
	          tr.setNodeMarkup(pos, null, newAttrs);
	        }
	      });
	      tr.setNodeMarkup(tablePos, null, objectSpread({}, tableNode.attrs, {
	        responsive: false
	      }));
	      dispatch(tr);
	      view.focus();
	    }
	
	    return true;
	  }
	
	  return false;
	}
	
	function setIndent(attrsGetter, type) {
	  return function (state, dispatch, view) {
	    var selection = state.selection,
	        tr = state.tr;
	    var $anchorCell = selection.$anchorCell,
	        $headCell = selection.$headCell,
	        $from = selection.$from,
	        dom = selection.dom;
	
	    var disableIndent = selection instanceof index_js$2.GapCursor && dom && dom.tagName.toUpperCase() === 'TABLE' || isAllCellSelection(selection);
	    if (disableIndent) return false;
	  };
	}
	
	function increaseIndent() {
	  return setIndent(function (attrs) {
	    return objectSpread({}, attrs, {
	      indent: attrs.indent + 1
	    });
	  }, 'more');
	}
	
	function reduceIndent() {
	  return setIndent(function (attrs) {
	    return objectSpread({}, attrs, {
	      indent: attrs.indent - 1
	    });
	  }, 'less');
	}
	
	function setPosition(position) {
	  var verticalAlign = ['top', 'middle', 'bottom'];
	  var textAlign = ['left', 'center', 'right'];
	  var style = {};
	
	  if (~verticalAlign.indexOf(position)) {
	    style = {
	      verticalAlign: position
	    };
	  }
	
	  if (~textAlign.indexOf(position)) {
	    style = {
	      textAlign: position
	    };
	  }
	
	  return function (state, dispatch, view) {
	    var selection = state.selection,
	        tr = state.tr,
	        schema = state.schema;
	
	    var transaction = tr;
	
	    if (selection instanceof CellSelection) {
	      var ranges = selection.ranges;
	      ranges.forEach(function (sel) {
	        var $from = sel.$from;
	
	        transaction = transaction.setNodeMarkup($from.pos - 1, $from.parent.type, objectSpread({}, $from.parent.attrs, style));
	      });
	    } else {
	      var cellType = schema.nodes.table_cell;
	      var headerType = schema.nodes.table_header;
	      var foundNode = index_js.findParentNode(selection.$from.path, function (node) {
	        return [cellType, headerType].includes(node.type);
	      });
	
	      transaction = transaction.setNodeMarkup(foundNode.pos, foundNode.node.type, objectSpread({}, foundNode.node.attrs, style));
	    }
	
	    dispatch(transaction);
	    return true;
	  };
	}
	
	function setTableAttrsCommand(attrs) {
	  return function (state, dispatch, view) {
	    var selection = state.selection,
	        tr = state.tr,
	        schema = state.schema;
	
	    var tableType = schema.nodes.table;
	    var foundNode = index_js.findParentNode(selection.$from.path, function (node) {
	      return node.type === tableType;
	    });
	    if (!foundNode) return true;
	
	    if (attrs) {
	      tr.setNodeMarkup(foundNode.pos, null, objectSpread({}, foundNode.node.attrs, attrs));
	      dispatch(tr);
	      return true;
	    }
	
	    return false;
	  };
	}
	
	var key = new prosemirrorState.PluginKey('selectingCells');
	
	function selectedRect(state, curSelection) {
	  var cellType = state.schema.nodes.table_cell;
	  var headerType = state.schema.nodes.table_header;
	  var sel = curSelection || state.selection;
	  var $pos = selectionCell(state, sel);
	  if (!$pos) return false;
	  var table = $pos.node(-1);
	  var tableStart = $pos.start(-1);
	  var map = TableMap.get(table);
	  var foundNode = index_js.findParentNode(sel.$from.path, function (node) {
	    return [cellType, headerType].includes(node.type);
	  });
	  var tableCell = void 0;
	
	  if (foundNode) {
	    tableCell = foundNode.node;
	  } else {
	    return false;
	  }
	
	  var rect = void 0;
	
	  if (sel instanceof CellSelection) {
	    rect = map.rectBetween(sel.$anchorCell.pos - tableStart, sel.$headCell.pos - tableStart);
	  } else {
	    rect = map.findCell($pos.pos - tableStart);
	  }
	
	  rect.tableStart = tableStart;
	  rect.map = map;
	  rect.table = table;
	  rect.tableCell = tableCell;
	  return rect;
	}
	function isInTable(state) {
	  var $head = state.selection.$head;
	
	  for (var d = $head.depth; d > 0; d--) {
	    if ($head.node(d).type.spec.tableRole === 'row') return true;
	  }
	
	  return false;
	}
	function cellAround($pos) {
	  for (var d = $pos.depth - 1; d > 0; d--) {
	    if ($pos.node(d).type.spec.tableRole === 'row') return $pos.node(0).resolve($pos.before(d + 1));
	  }
	
	  return null;
	}
	
	function cellNear($pos) {
	  for (var after = $pos.nodeAfter, pos = $pos.pos; after; after = after.firstChild, pos++) {
	    var role = after.type.spec.tableRole;
	    if (role === 'cell' || role === 'header_cell') return $pos.doc.resolve(pos);
	  }
	
	  for (var before = $pos.nodeBefore, _pos3 = $pos.pos; before; before = before.lastChild, _pos3--) {
	    var _role = before.type.spec.tableRole;
	    if (_role === 'cell' || _role === 'header_cell') return $pos.doc.resolve(_pos3 - before.nodeSize);
	  }
	}
	
	function setAttr(attrs, name, value) {
	  var result = {};
	
	  for (var prop in attrs) {
	    result[prop] = attrs[prop];
	  }result[name] = value;
	  return result;
	}
	function selectionCell(state, curSelection) {
	  var sel = curSelection || state.selection;
	
	  if (sel.$anchorCell) {
	    return sel.$anchorCell.pos > sel.$headCell.pos ? sel.$anchorCell : sel.$headCell;
	  }
	
	  return sel.$anchorCell || cellAround(sel.$head) || cellNear(sel.$head);
	}
	function rmColspan(attrs, pos) {
	  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
	
	  var result = setAttr(attrs, 'colspan', attrs.colspan - n);
	
	  if (result.colwidth) {
	    result.colwidth = result.colwidth.slice();
	    result.colwidth.splice(pos, n);
	    if (!result.colwidth.some(function (w) {
	      return w > 0;
	    })) result.colwidth = null;
	  }
	
	  return result;
	}
	function addColspan(attrs, pos) {
	  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
	
	  var result = setAttr(attrs, 'colspan', attrs.colspan + n);
	
	  if (result.colwidth) {
	    result.colwidth = result.colwidth.slice();
	
	    for (var i = 0; i < n; i++) {
	      result.colwidth.splice(pos, 0, 0);
	    }
	  }
	
	  return result;
	}
	
	function getHasRowHeader(tableContent, headerType) {
	  var hasRowHeader = false;
	  tableContent.forEach(function (tableRow) {
	    if (hasRowHeader) return;
	    var rowContent = tableRow.content.content;
	
	    hasRowHeader = rowContent.some(function (p) {
	      return p.type === headerType;
	    });
	  });
	  return hasRowHeader;
	}
	
	function getHasColHeader(tableContent, headerType, hasRowHeader) {
	  if (hasRowHeader === undefined) hasRowHeader = getHasRowHeader(tableContent, headerType);
	
	  if (hasRowHeader && tableContent.length === 1) {
	    return {
	      hasColHeader: false,
	      headerCol: null
	    };
	  }
	
	  var hasColHeader = false;
	  var headerCol = null;
	  var colLen = tableContent[0].childCount;
	  var rowLen = tableContent.length;
	  var preRowspanInfo = {};
	
	  for (var i = 0; i < colLen; i++) {
	    if (hasColHeader) break;
	    var has = true;
	    var rowspan = 0;
	
	    for (var j = 0; j < rowLen; j++) {
	      if (rowspan === rowLen - 1) has = false;
	
	      if (rowspan === 0) {
	        var node = tableContent[j].content.content[i - (preRowspanInfo[j] || 0)];
	        if (!node) has = false;
	
	        if (node && node.attrs.rowspan > 1) {
	          rowspan = node.attrs.rowspan - 1;
	        }
	
	        if (node && node.type !== headerType) has = false;
	      } else {
	        preRowspanInfo[j] = preRowspanInfo[j] ? 1 + preRowspanInfo[j] : 1;
	        rowspan--;
	      }
	    }
	
	    hasColHeader = has;
	    headerCol = i;
	  }
	
	  if (!hasColHeader) {
	    headerCol = null;
	  }
	
	  return {
	    hasColHeader: hasColHeader,
	    headerCol: headerCol
	  };
	}
	
	function getHasNumCol(tableContent, headerType, hasRowHeader) {
	  if (hasRowHeader === undefined) hasRowHeader = getHasRowHeader(tableContent, headerType);
	
	  if (hasRowHeader && tableContent.length === 1) {
	    return false;
	  }
	
	  var hasNumCol = true;
	  var rowspan = 0;
	
	  for (var i = 0; i < tableContent.length; i++) {
	    if (rowspan === 0) {
	      var node = tableContent[i].firstChild;
	
	      if (!node) continue;
	      var nodeRowspan = node.attrs.rowspan;
	      if (nodeRowspan > 1) rowspan = nodeRowspan - 1;
	
	      if (!node.attrs.numCell && (nodeRowspan === tableContent.length && node.type === headerType || !(node.type === headerType && i === 0))) {
	        hasNumCol = false;
	        break;
	      }
	    } else rowspan--;
	  }
	
	  return hasNumCol;
	}
	
	function hasTableHeader(state) {
	  var schema = state.schema,
	      selection = state.selection;
	  var $from = selection.$from;
	
	  var tableType = schema.nodes.table;
	  var headerType = schema.nodes.table_header;
	  var foundNode = index_js.findParentNode($from.path, function (node) {
	    return node.type === tableType;
	  });
	  if (!foundNode) return {
	    hasRowHeader: false,
	    hasColHeader: false
	  };
	  var tableNode = foundNode.node,
	      startPos = foundNode.pos;
	
	  if (!tableNode) return {
	    hasRowHeader: false,
	    hasColHeader: false,
	    hasNumCol: false,
	    tableNode: tableNode,
	    startPos: startPos
	  };
	  var tableContent = tableNode.content.content;
	  var hasRowHeader = getHasRowHeader(tableContent, headerType);
	
	  var _getHasColHeader5 = getHasColHeader(tableContent, headerType, hasRowHeader),
	      hasColHeader = _getHasColHeader5.hasColHeader,
	      headerCol = _getHasColHeader5.headerCol;
	
	  var hasNumCol = getHasNumCol(tableContent, headerType, hasRowHeader);
	  return {
	    hasRowHeader: hasRowHeader,
	    hasColHeader: hasColHeader,
	    headerCol: headerCol,
	    hasNumCol: hasNumCol,
	    tableNode: tableNode,
	    startPos: startPos
	  };
	}
	
	function canSplitCell(state) {
	  try {
	    var can = _splitCell(state);
	    return can;
	  } catch (error) {}
	
	  return false;
	}
	
	function isInNumCell(state) {
	  var selection = state.selection;
	  var $from = selection.$from;
	
	  return index_js.findParentNode($from.path, function (node) {
	    return node.attrs && node.attrs.numCell;
	  });
	}
	
	function afterInsert(store) {
	  return function (_ref9) {
	    var braceWidth = _ref9.braceWidth;
	
	    return function (state, dispatch, view) {
	      if (!braceWidth) return;
	      var selection = state.selection,
	          schema = state.schema;
	      var $from = selection.$from;
	      var _schema$nodes11 = schema.nodes,
	          table_cell = _schema$nodes11.table_cell,
	          table_header = _schema$nodes11.table_header;
	
	      var cellTypes = [table_cell, table_header];
	      var fromPath = $from.path;
	      var foundCellNode = index_js.findParentNode(fromPath, function (node) {
	        return cellTypes.includes(node.type);
	      });
	
	      if (foundCellNode) {
	        var attrs = foundCellNode.node.attrs;
	        var width = attrs.colwidth.reduce(function (a, b) {
	          return a + b;
	        });
	
	        if (width < braceWidth) {
	          updateColumnWidth(view, foundCellNode.pos, braceWidth);
	          store.reShowPopover();
	        }
	      }
	    };
	  };
	}
	
	function _stateChanged(store) {
	  return function (state, dispatch, view) {
	    var schema = state.schema,
	        selection = state.selection;
	    var $from = selection.$from;
	
	    var table = schema.nodes.table;
	    var foundNode = index_js.findParentNode($from.path, function (node) {
	      return node.type === table;
	    });
	
	    if (foundNode) {
	      var tableDOM = view.docView.domFromPos(foundNode.pos + 1).node;
	      if (tableDOM.tagName.toUpperCase() !== 'TABLE') tableDOM = tableDOM.parentNode;
	      store.showPopover(tableDOM);
	    } else if (store.isShowPopover) {
	      store.hidePopover();
	    }
	  };
	}
	
	var triggerTableCellToDOM = function triggerTableCellToDOM(view) {
	  var $pos = view.state.selection.$from;
	  var tr = view.state.tr;
	  var _view$state$schema$no = view.state.schema.nodes,
	      table_cell = _view$state$schema$no.table_cell,
	      table_header = _view$state$schema$no.table_header;
	
	  var cellTypes = [table_cell, table_header];
	  var foundCellNode = index_js.findParentNode($pos.path, function (node) {
	    return cellTypes.includes(node.type);
	  });
	
	  if (foundCellNode && !foundCellNode.node.isText) {
	    var attrs = foundCellNode.node.attrs;
	
	    var newAttrs = objectSpread({}, attrs, {
	      numCell: 0
	    });
	
	    if (attrs.numCell === true) return false;
	
	    try {
	      tr.setNodeMarkup(foundCellNode.pos, null, newAttrs);
	      view.dispatch(tr);
	    } catch (error) {
	      console.error(error);
	    }
	  }
	};
	
	function formatWidth(width) {
	  width = Math.round(width);
	  var remainder = width % 4;
	
	  switch (remainder) {
	    case 0:
	      return width;
	
	    case 1:
	      return width - 1;
	
	    case 2:
	      return width + 2;
	
	    default:
	      return width + 1;
	  }
	}
	
	function isEmptyCell(cell) {
	  var c = cell.content;
	  return c.childCount === 1 && c.firstChild.isTextblock && c.firstChild.childCount === 0;
	}
	function cellsOverlapRectangle(ref, rect) {
	  if (!ref) {
	    return false;
	  }
	
	  var width = ref.width;
	  var height = ref.height;
	  var map = ref.map;
	  var indexTop = rect.top * width + rect.left;
	  var indexLeft = indexTop;
	  var indexBottom = (rect.bottom - 1) * width + rect.left;
	  var indexRight = indexTop + (rect.right - rect.left - 1);
	
	  for (var i = rect.top; i < rect.bottom; i++) {
	    if (rect.left > 0 && map[indexLeft] === map[indexLeft - 1] || rect.right < width && map[indexRight] === map[indexRight + 1]) {
	      return true;
	    }
	
	    indexLeft += width;
	    indexRight += width;
	  }
	
	  for (var i$1 = rect.left; i$1 < rect.right; i$1++) {
	    if (rect.top > 0 && map[indexTop] === map[indexTop - width] || rect.bottom < height && map[indexBottom] === map[indexBottom + width]) {
	      return true;
	    }
	
	    indexTop++;
	    indexBottom++;
	  }
	
	  return false;
	}
	function pointsAtCell($pos) {
	  return $pos.parent.type.spec.tableRole === 'row' && $pos.nodeAfter;
	}
	function inSameTable($a, $b) {
	  return $a.depth === $b.depth && $a.pos >= $b.start(-1) && $a.pos <= $b.end(-1);
	}
	function rmColSpan(attrs, pos) {
	  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
	
	  var result = setAttr(attrs, 'colspan', attrs.colspan - n);
	
	  if (result.colwidth) {
	    result.colwidth = result.colwidth.slice();
	    result.colwidth.splice(pos, n);
	    if (!result.colwidth.some(function (w) {
	      return w > 0;
	    })) result.colwidth = null;
	  }
	
	  return result;
	}
	function nextCell($pos, axis, dir) {
	  var start = $pos.start(-1);
	  var map = TableMap.get($pos.node(-1));
	  var moved = map.nextCell($pos.pos - start, axis, dir);
	  return moved === null ? null : $pos.node(0).resolve(start + moved);
	}
	
	function findNextCell($cell, dir) {
	  if (dir < 0) {
	    var before = $cell.nodeBefore;
	    if (before) return $cell.pos - before.nodeSize;
	
	    for (var row = $cell.index(-1) - 1, rowEnd = $cell.before(); row >= 0; row--) {
	      var rowNode = $cell.node(-1).child(row);
	      if (rowNode.childCount) return rowEnd - 1 - rowNode.lastChild.nodeSize;
	      rowEnd -= rowNode.nodeSize;
	    }
	  } else {
	    if ($cell.index() < $cell.parent.childCount - 1) return $cell.pos + $cell.nodeAfter.nodeSize;
	    var table = $cell.node(-1);
	
	    for (var _row = $cell.indexAfter(-1), rowStart = $cell.after(); _row < table.childCount; _row++) {
	      var _rowNode = table.child(_row);
	      if (_rowNode.childCount) return rowStart + 1;
	      rowStart += _rowNode.nodeSize;
	    }
	  }
	}
	
	function moveCellForward($pos) {
	  return $pos.node(0).resolve($pos.pos + $pos.nodeAfter.nodeSize);
	}
	
	function goToNextCell(direction) {
	  return function (state, dispatch) {
	    if (!isInTable(state)) return false;
	    var cell = findNextCell(selectionCell(state), direction);
	    if (cell === null) return;
	
	    if (dispatch) {
	      var $cell = state.doc.resolve(cell);
	      dispatch(state.tr.setSelection(prosemirrorState.TextSelection.between($cell, moveCellForward($cell))).scrollIntoView());
	    }
	
	    return true;
	  };
	}
	var canAddColumnBefore = function canAddColumnBefore(store) {
	  return function (state) {
	    try {
	      return _addColumnBefore(store)(state);
	    } catch (error) {
	      console.error(error);
	      return false;
	    }
	  };
	};
	var canAddColumnAfter = function canAddColumnAfter(store) {
	  return function (state) {
	    try {
	      return _addColumnAfter(store)(state);
	    } catch (error) {
	      console.error(error);
	      return false;
	    }
	  };
	};
	var canAddRowBefore = function canAddRowBefore(store) {
	  return function (state) {
	    try {
	      return _addRowBefore(store)(state);
	    } catch (error) {
	      console.warn(error);
	      return false;
	    }
	  };
	};
	
	var isAllCellSelection = function isAllCellSelection(selection) {
	  if (selection instanceof CellSelection) {
	    var $from = selection.$from,
	        ranges = selection.ranges;
	
	    var foundNode = index_js.findParentNode($from.path, function (item) {
	      return item.type && item.type.name === 'table';
	    });
	    var tableRowContents = foundNode.node.content.content;
	    var tableCellCount = 0;
	
	    for (var i = 0; i < tableRowContents.length; i++) {
	      var row = tableRowContents[i];
	      tableCellCount += row.content.content.length;
	    }
	
	    return tableCellCount === ranges.length;
	  }
	
	  return false;
	};
	
	function canIndent(state, direction) {
	  return setIndent(function (_) {
	    return _;
	  }, direction)(state);
	}
	function getTableAttrs(state) {
	  var $from = state.selection.$from;
	  var foundNode = index_js.findParentNode($from.path, function (item) {
	    return item.type && item.type.name === 'table';
	  });
	
	  if (foundNode) {
	    return foundNode.node.attrs;
	  }
	}
	
	var CellSelection = function (_prosemirrorState$Sel) {
	  (0, _inherits3.default)(CellSelection, _prosemirrorState$Sel);
	
	  function CellSelection($anchorCell) {
	    var $headCell = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $anchorCell;
	    (0, _classCallCheck3.default)(this, CellSelection);
	
	    var table = $anchorCell.node(-1),
	        map = TableMap.get(table),
	        start = $anchorCell.start(-1);
	    var rect = map.rectBetween($anchorCell.pos - start, $headCell.pos - start);
	    var doc = $anchorCell.node(0);
	    var cells = map.cellsInRect(rect).filter(function (p) {
	      return p != $headCell.pos - start;
	    });
	
	    cells.unshift($headCell.pos - start);
	    var ranges = cells.map(function (pos) {
	      var cell = table.nodeAt(pos),
	          from = pos + start + 1;
	      return new prosemirrorState.SelectionRange(doc.resolve(from), doc.resolve(from + cell.content.size));
	    });
	
	    var _this12 = (0, _possibleConstructorReturn3.default)(this, (CellSelection.__proto__ || (0, _getPrototypeOf2.default)(CellSelection)).call(this, ranges[0].$from, ranges[0].$to, ranges));
	
	    _this12.$anchorCell = $anchorCell;
	
	    _this12.$headCell = $headCell;
	    return _this12;
	  }
	
	  (0, _createClass3.default)(CellSelection, [{
	    key: 'map',
	    value: function map(doc, mapping) {
	      var $anchorCell = doc.resolve(mapping.map(this.$anchorCell.pos));
	      var $headCell = doc.resolve(mapping.map(this.$headCell.pos));
	
	      if (pointsAtCell($anchorCell) && pointsAtCell($headCell) && inSameTable($anchorCell, $headCell)) {
	        var tableChanged = this.$anchorCell.node(-1) != $anchorCell.node(-1);
	
	        if (tableChanged && this.isRowSelection()) {
	          return CellSelection.colSelection($anchorCell, $headCell);
	        } else if (tableChanged && this.isColSelection()) {
	          return CellSelection.rowSelection($anchorCell, $headCell);
	        }
	
	        return new CellSelection($anchorCell, $headCell);
	      }
	
	      return prosemirrorState.TextSelection.between($anchorCell, $headCell);
	    }
	  }, {
	    key: 'content',
	    value: function content() {
	      var table = this.$anchorCell.node(-1),
	          map = TableMap.get(table),
	          start = this.$anchorCell.start(-1);
	      var rect = map.rectBetween(this.$anchorCell.pos - start, this.$headCell.pos - start);
	      var seen = [],
	          rows = [];
	
	      for (var row = rect.top; row < rect.bottom; row++) {
	        var rowContent = [];
	
	        for (var index = row * map.width + rect.left, col = rect.left; col < rect.right; col++, index++) {
	          var pos = map.map[index];
	
	          if (seen.indexOf(pos) == -1) {
	            seen.push(pos);
	            var cellRect = map.findCell(pos),
	                cell = table.nodeAt(pos);
	            var extraLeft = rect.left - cellRect.left,
	                extraRight = cellRect.right - rect.right;
	
	            if (extraLeft > 0 || extraRight > 0) {
	              var attrs = cell.attrs;
	              if (extraLeft > 0) attrs = rmColSpan(attrs, 0, extraLeft);
	              if (extraRight > 0) attrs = rmColSpan(attrs, attrs.colspan - extraRight, extraRight);
	              if (cellRect.left < rect.left) cell = cell.type.createAndFill(attrs);else cell = cell.type.create(attrs, cell.content);
	            }
	
	            if (cellRect.top < rect.top || cellRect.bottom > rect.bottom) {
	              var _attrs2 = setAttr(cell.attrs, 'rowspan', Math.min(cellRect.bottom, rect.bottom) - Math.max(cellRect.top, rect.top));
	              if (cellRect.top < rect.top) cell = cell.type.createAndFill(_attrs2);else cell = cell.type.create(_attrs2, cell.content);
	            }
	
	            rowContent.push(cell);
	          }
	        }
	
	        rows.push(table.child(row).copy(prosemirrorModel.Fragment.from(rowContent)));
	      }
	
	      return new prosemirrorModel.Slice(prosemirrorModel.Fragment.from(rows), 1, 1);
	    }
	  }, {
	    key: 'replace',
	    value: function replace(tr) {
	      var content = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : prosemirrorModel.Slice.empty;
	
	      var mapFrom = tr.steps.length,
	          ranges = this.ranges;
	
	      for (var i = 0; i < ranges.length; i++) {
	        var _ranges$i = ranges[i],
	            $from = _ranges$i.$from,
	            $to = _ranges$i.$to,
	            mapping = tr.mapping.slice(mapFrom);
	
	        tr.replace(mapping.map($from.pos), mapping.map($to.pos), i ? prosemirrorModel.Slice.empty : content);
	      }
	
	      var sel = prosemirrorState.Selection.findFrom(tr.doc.resolve(tr.mapping.slice(mapFrom).map(this.to)), -1);
	      if (sel) tr.setSelection(sel);
	    }
	  }, {
	    key: 'replaceWith',
	    value: function replaceWith(tr, node) {
	      this.replace(tr, new prosemirrorModel.Slice(prosemirrorModel.Fragment.from(node), 0, 0));
	    }
	  }, {
	    key: 'forEachCell',
	    value: function forEachCell(f) {
	      var table = this.$anchorCell.node(-1),
	          map = TableMap.get(table),
	          start = this.$anchorCell.start(-1);
	      var cells = map.cellsInRect(map.rectBetween(this.$anchorCell.pos - start, this.$headCell.pos - start));
	
	      for (var i = 0; i < cells.length; i++) {
	        f(table.nodeAt(cells[i]), start + cells[i]);
	      }
	    }
	  }, {
	    key: 'isColSelection',
	    value: function isColSelection() {
	      var anchorTop = this.$anchorCell.index(-1),
	          headTop = this.$headCell.index(-1);
	      if (Math.min(anchorTop, headTop) > 0) return false;
	      var anchorBot = anchorTop + this.$anchorCell.nodeAfter.attrs.rowspan,
	          headBot = headTop + this.$headCell.nodeAfter.attrs.rowspan;
	      return Math.max(anchorBot, headBot) == this.$headCell.node(-1).childCount;
	    }
	  }, {
	    key: 'isRowSelection',
	    value: function isRowSelection() {
	      var map = TableMap.get(this.$anchorCell.node(-1)),
	          start = this.$anchorCell.start(-1);
	      var anchorLeft = map.colCount(this.$anchorCell.pos - start),
	          headLeft = map.colCount(this.$headCell.pos - start);
	      if (Math.min(anchorLeft, headLeft) > 0) return false;
	      var anchorRight = anchorLeft + this.$anchorCell.nodeAfter.attrs.colspan,
	          headRight = headLeft + this.$headCell.nodeAfter.attrs.colspan;
	      return Math.max(anchorRight, headRight) == map.width;
	    }
	  }, {
	    key: 'eq',
	    value: function eq(other) {
	      return other instanceof CellSelection && other.$anchorCell.pos == this.$anchorCell.pos && other.$headCell.pos == this.$headCell.pos;
	    }
	  }, {
	    key: 'toJSON',
	    value: function toJSON() {
	      return {
	        type: 'cell',
	        anchor: this.$anchorCell.pos,
	        head: this.$headCell.pos
	      };
	    }
	  }, {
	    key: 'getBookmark',
	    value: function getBookmark() {
	      return new CellBookmark(this.$anchorCell.pos, this.$headCell.pos);
	    }
	  }], [{
	    key: 'rowSelection',
	    value: function rowSelection($anchorCell) {
	      var $headCell = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $anchorCell;
	
	      var map = TableMap.get($anchorCell.node(-1)),
	          start = $anchorCell.start(-1);
	      var anchorRect = map.findCell($anchorCell.pos - start),
	          headRect = map.findCell($headCell.pos - start);
	      var doc = $anchorCell.node(0);
	
	      if (anchorRect.top <= headRect.top) {
	        if (anchorRect.top > 0) {
	          $anchorCell = doc.resolve(start + map.map[anchorRect.left]);
	        }
	
	        if (headRect.bottom < map.height) {
	          $headCell = doc.resolve(start + map.map[map.width * (map.height - 1) + headRect.right - 1]);
	        }
	      } else {
	        if (headRect.top > 0) {
	          $headCell = doc.resolve(start + map.map[headRect.left]);
	        }
	
	        if (anchorRect.bottom < map.height) {
	          $anchorCell = doc.resolve(start + map.map[map.width * (map.height - 1) + anchorRect.right - 1]);
	        }
	      }
	
	      return new CellSelection($anchorCell, $headCell);
	    }
	  }, {
	    key: 'colSelection',
	    value: function colSelection($anchorCell) {
	      var $headCell = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $anchorCell;
	
	      var map = TableMap.get($anchorCell.node(-1)),
	          start = $anchorCell.start(-1);
	      var anchorRect = map.findCell($anchorCell.pos - start),
	          headRect = map.findCell($headCell.pos - start);
	      var doc = $anchorCell.node(0);
	
	      if (anchorRect.left <= headRect.left) {
	        if (anchorRect.left > 0) {
	          $anchorCell = doc.resolve(start + map.map[anchorRect.top * map.width]);
	        }
	
	        if (headRect.right < map.width) {
	          $headCell = doc.resolve(start + map.map[map.width * (headRect.top + 1) - 1]);
	        }
	      } else {
	        if (headRect.left > 0) {
	          $headCell = doc.resolve(start + map.map[headRect.top * map.width]);
	        }
	
	        if (anchorRect.right < map.width) {
	          $anchorCell = doc.resolve(start + map.map[map.width * (anchorRect.top + 1) - 1]);
	        }
	      }
	
	      return new CellSelection($anchorCell, $headCell);
	    }
	  }, {
	    key: 'fromJSON',
	    value: function fromJSON(doc, json) {
	      return new CellSelection(doc.resolve(json.anchor), doc.resolve(json.head));
	    }
	  }, {
	    key: 'create',
	    value: function create(doc, anchorCell) {
	      var headCell = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : anchorCell;
	
	      return new CellSelection(doc.resolve(anchorCell), doc.resolve(headCell));
	    }
	  }]);
	  return CellSelection;
	}(prosemirrorState.Selection);
	
	CellSelection.prototype.visible = false;
	prosemirrorState.Selection.jsonID('cell', CellSelection);
	
	var CellBookmark = function () {
	  function CellBookmark(anchor, head) {
	    (0, _classCallCheck3.default)(this, CellBookmark);
	
	    this.anchor = anchor;
	    this.head = head;
	  }
	
	  (0, _createClass3.default)(CellBookmark, [{
	    key: 'map',
	    value: function map(mapping) {
	      return new CellBookmark(mapping.map(this.anchor), mapping.map(this.head));
	    }
	  }, {
	    key: 'resolve',
	    value: function resolve(doc) {
	      var $anchorCell = doc.resolve(this.anchor),
	          $headCell = doc.resolve(this.head);
	
	      if ($anchorCell.parent.type.spec.tableRole == 'row' && $headCell.parent.type.spec.tableRole == 'row' && $anchorCell.index() < $anchorCell.parent.childCount && $headCell.index() < $headCell.parent.childCount && inSameTable($anchorCell, $headCell)) {
	        return new CellSelection($anchorCell, $headCell);
	      }
	
	      return prosemirrorState.Selection.near($headCell, 1);
	    }
	  }]);
	  return CellBookmark;
	}();
	
	function drawCellSelection(state) {
	  if (!(state.selection instanceof CellSelection)) return null;
	  var cells = [];
	  state.selection.forEachCell(function (node, pos) {
	    cells.push(prosemirrorView.Decoration.node(pos, pos + node.nodeSize, {
	      class: 'selectedCell'
	    }));
	  });
	  return prosemirrorView.DecorationSet.create(state.doc, cells);
	}
	
	function isCellBoundarySelection(_ref10) {
	  var $from = _ref10.$from,
	      $to = _ref10.$to;
	
	  if ($from.pos == $to.pos || $from.pos < $from.pos - 6) return false;
	
	  var afterFrom = $from.pos,
	      beforeTo = $to.pos,
	      depth = $from.depth;
	
	  for (; depth >= 0; depth--, afterFrom++) {
	    if ($from.after(depth + 1) < $from.end(depth)) break;
	  }
	
	  for (var d = $to.depth; d >= 0; d--, beforeTo--) {
	    if ($to.before(d + 1) > $to.start(d)) break;
	  }
	
	  return afterFrom == beforeTo && /row|table/.test($from.node(depth).type.spec.tableRole);
	}
	
	function normalizeSelection(state, tr) {
	  var sel = (tr || state).selection,
	      doc = (tr || state).doc,
	      normalize = void 0,
	      role = void 0;
	
	  if (sel instanceof prosemirrorState.NodeSelection && (role = sel.node.type.spec.tableRole)) {
	    if (role == 'cell' || role == 'header_cell') {
	      normalize = CellSelection.create(doc, sel.from);
	    } else if (role == 'row') {
	      var $cell = doc.resolve(sel.from + 1);
	      normalize = CellSelection.rowSelection($cell, $cell);
	    } else {
	      var map = TableMap.get(sel.node),
	          start = sel.from + 1;
	      var lastCell = start + map.map[map.width * map.height - 1];
	      normalize = CellSelection.create(doc, start + 1, lastCell);
	    }
	  } else if (sel instanceof prosemirrorState.TextSelection && isCellBoundarySelection(sel)) {
	    normalize = prosemirrorState.TextSelection.create(doc, sel.from);
	  }
	
	  if (normalize) {
	    (tr || (tr = state.tr)).setSelection(normalize);
	  }
	
	  return tr;
	}
	
	var css$5 = ".selectbar-addtip-wrapper.left,.selectbar-addtip-wrapper.right{float:left;width:50%;height:100%}.selectbar-addtip-wrapper.bottom,.selectbar-addtip-wrapper.top{width:100%;height:50%;position:relative}.selectbar-addtip{position:absolute;display:flex;justify-content:center;align-items:center;background:#111;border-radius:3px;line-height:26px;z-index:99;cursor:pointer}.selectbar-addtip svg path{fill:#fff}.selectbar-addtip.left{left:-12px}.selectbar-addtip.right{right:-12px}.selectbar-addtip.left,.selectbar-addtip.right{top:0;width:24px;height:24px;margin-bottom:4px}.selectbar-addtip.left:after,.selectbar-addtip.right:after{content:\"\";position:absolute;width:0;bottom:-4px;right:50%;-webkit-transform:translate(50%);transform:translate(50%);display:block;border-color:#111 transparent;border-style:solid;border-width:5px 5px 0;z-index:1}.selectbar-addtip.top{top:-12px}.selectbar-addtip.bottom{bottom:-12px}.selectbar-addtip.bottom,.selectbar-addtip.top{left:-20px;width:24px;height:24px;margin-right:4px}.selectbar-addtip.bottom:after,.selectbar-addtip.top:after{content:\"\";position:absolute;width:0;right:-9px;bottom:50%;-webkit-transform:translateY(50%);transform:translateY(50%);display:block;border:5px solid transparent;border-left-color:#111;z-index:1}";
	styleInject(css$5);
	
	var Addtip = function (_preact$Component7) {
	  (0, _inherits3.default)(Addtip, _preact$Component7);
	
	  function Addtip() {
	    var _ref11;
	
	    (0, _classCallCheck3.default)(this, Addtip);
	
	    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	      args[_key4] = arguments[_key4];
	    }
	
	    var _this13 = (0, _possibleConstructorReturn3.default)(this, (_ref11 = Addtip.__proto__ || (0, _getPrototypeOf2.default)(Addtip)).call.apply(_ref11, [this].concat(args)));
	
	    _this13.state = {
	      hasAddtip: false,
	      extraOffset: 0
	    };
	
	    _this13.handleMouseEnter = function (e) {
	      var dir = _this13.props.dir;
	
	      var _e$target$getBounding = e.target.getBoundingClientRect(),
	          left = _e$target$getBounding.left,
	          right = _e$target$getBounding.right;
	
	      var extraOffset = 0;
	
	      if (e.target.closest('.ct-table-col-selectbar-wrapper')) {
	        var wrapper = e.target.closest('.ct-table-col-selectbar-wrapper');
	
	        var _wrapper$getBoundingC = wrapper.getBoundingClientRect(),
	            wrapperLeft = _wrapper$getBoundingC.left,
	            wrapperRight = _wrapper$getBoundingC.right;
	
	        if (dir === 'left') {
	          extraOffset = left > wrapperLeft ? 0 : wrapperLeft - left;
	        }
	
	        if (dir === 'right') {
	          extraOffset = right > wrapperRight ? wrapperRight - right : 0;
	        }
	      }
	
	      _this13.setState({
	        hasAddtip: true,
	        extraOffset: extraOffset
	      });
	    };
	    return _this13;
	  }
	
	  (0, _createClass3.default)(Addtip, [{
	    key: 'render',
	    value: function render() {
	      var _this14 = this;
	
	      var _props4 = this.props,
	          children = _props4.children,
	          dir = _props4.dir,
	          onClick = _props4.onClick,
	          offset = _props4.offset;
	      var _state3 = this.state,
	          hasAddtip = _state3.hasAddtip,
	          extraOffset = _state3.extraOffset;
	
	      var style = {
	        left: offset + extraOffset
	      };
	      return preact.h("div", {
	        onMouseEnter: this.handleMouseEnter,
	        onMouseLeave: function onMouseLeave() {
	          return _this14.setState({
	            hasAddtip: false
	          });
	        },
	        className: 'selectbar-addtip-wrapper ' + dir,
	        ref: function ref(refs) {
	          _this14.wrapper = refs;
	        }
	      }, children, hasAddtip && preact.h("div", {
	        className: 'selectbar-addtip ' + dir,
	        style: style,
	        onClick: onClick
	      }, preact.h("svg", {
	        width: "16px",
	        height: "16px",
	        viewBox: "0 0 16 16"
	      }, preact.h("g", {
	        stroke: "none",
	        strokeWidth: "1",
	        fill: "none",
	        fillRule: "evenodd"
	      }, preact.h("g", {
	        transform: "translate(-273.000000, -427.000000)",
	        fill: "#BDC2C7"
	      }, preact.h("g", {
	        transform: "translate(276.000000, 430.000000)"
	      }, preact.h("path", {
	        d: "M5.66497803,4.33502197 L5.66497803,0.664978027 C5.66497803,0.297720804 5.36725722,0 5,0 C4.63274278,0 4.33502197,0.297720804 4.33502197,0.664978027 L4.33502197,4.33502197 L0.664978027,4.33502197 C0.297720804,4.33502197 0,4.63274278 0,5 C0,5.36725722 0.297720804,5.66497803 0.664978027,5.66497803 L4.33502197,5.66497803 L4.33502197,9.33502197 C4.33502197,9.7022792 4.63274278,10 5,10 C5.36725722,10 5.66497803,9.7022792 5.66497803,9.33502197 L5.66497803,5.66497803 L9.33502197,5.66497803 C9.7022792,5.66497803 10,5.36725722 10,5 C10,4.63274278 9.7022792,4.33502197 9.33502197,4.33502197 L5.66497803,4.33502197 Z",
	        id: "Combined-Shape"
	      })))))));
	    }
	  }]);
	  return Addtip;
	}(preact.Component);
	
	var preventShiftMouseDown = function preventShiftMouseDown(e) {
	  if (e.shiftKey) e.preventDefault();
	};
	
	var RowSelectBar = function (_preact$Component8) {
	  (0, _inherits3.default)(RowSelectBar, _preact$Component8);
	
	  function RowSelectBar() {
	    var _ref12;
	
	    (0, _classCallCheck3.default)(this, RowSelectBar);
	
	    for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	      args[_key5] = arguments[_key5];
	    }
	
	    var _this15 = (0, _possibleConstructorReturn3.default)(this, (_ref12 = RowSelectBar.__proto__ || (0, _getPrototypeOf2.default)(RowSelectBar)).call.apply(_ref12, [this].concat(args)));
	
	    _this15.anchorCellIdx = null;
	    _this15.headCellIdx = null;
	
	    _this15.handleItemClick = function (event, itemIdx) {
	      var _this15$props = _this15.props,
	          view = _this15$props.view,
	          tableDOM = _this15$props.tableDOM,
	          tableWidth = _this15$props.tableWidth,
	          reShowPopover = _this15$props.reShowPopover;
	      var dispatch = view.dispatch,
	          state = view.state;
	      var tr = state.tr,
	          doc = state.doc;
	
	      var tableBodyDOM = tableDOM.lastElementChild;
	      var anchorCellIdx = itemIdx;
	      var headCellIdx = itemIdx;
	
	      if (event.shiftKey) {
	        if (_this15.anchorCellIdx < itemIdx) {
	          anchorCellIdx = typeof _this15.anchorCellIdx === 'number' ? _this15.anchorCellIdx : itemIdx;
	          headCellIdx = itemIdx;
	        } else {
	          anchorCellIdx = itemIdx;
	          headCellIdx = typeof _this15.headCellIdx === 'number' ? _this15.headCellIdx : itemIdx;
	        }
	      }
	
	      var idxChanged = true;
	      var times = 0;
	
	      while (idxChanged && times < 50) {
	        times++;
	        idxChanged = false;
	        (0, _from2.default)(tableBodyDOM.children).forEach(function (tableRowDOM, idx) {
	          var cellDOMs = (0, _from2.default)(tableRowDOM.children);
	          if (idx > headCellIdx) return;
	          cellDOMs.forEach(function (cell) {
	            if (cell.rowSpan) {
	              var maxReach = idx + cell.rowSpan - 1;
	
	              if (idx < anchorCellIdx && maxReach >= anchorCellIdx) {
	                anchorCellIdx = idx;
	                idxChanged = true;
	              }
	
	              if (maxReach > headCellIdx) {
	                headCellIdx = maxReach;
	                idxChanged = true;
	              }
	            }
	          });
	        });
	      }
	
	      _this15.anchorCellIdx = anchorCellIdx;
	      _this15.headCellIdx = headCellIdx;
	
	      var anchorCellDOM = tableBodyDOM.children[anchorCellIdx].firstElementChild;
	      var borderWidth = parseInt(window.getComputedStyle(anchorCellDOM, null).borderWidth, 10);
	      var headCellDOM = void 0;
	      (0, _from2.default)(tableBodyDOM.children).forEach(function (tableRowDOM, idx) {
	        var cellDOM = tableRowDOM.lastElementChild;
	
	        if (!headCellDOM && cellDOM && idx >= anchorCellIdx && headCellIdx >= idx && (cellDOM.rowSpan && cellDOM.rowSpan - 1 + idx === headCellIdx || idx === headCellIdx)) {
	          var totalOffset = cellDOM.offsetLeft + cellDOM.offsetWidth;
	          var floorTableWidth = Math.floor(tableWidth);
	          var dis = totalOffset - floorTableWidth + borderWidth;
	
	          if (dis > -5 && dis < 5) {
	            headCellDOM = cellDOM;
	          }
	        }
	      });
	
	      var anchorPos = view.docView.posFromDOM(anchorCellDOM, undefined, -1) - 1;
	      var headPos = view.docView.posFromDOM(headCellDOM, undefined, -1) - 1;
	
	      var newSelection = new CellSelection(doc.resolve(anchorPos), doc.resolve(headPos));
	      dispatch(tr.setSelection(newSelection));
	      view.focus();
	      reShowPopover();
	    };
	
	    _this15.handleAddtipClick = function (event, idx, dir) {
	      var _this15$props2 = _this15.props,
	          store = _this15$props2.store,
	          view = _this15$props2.view,
	          tableDOM = _this15$props2.tableDOM;
	      var dispatch = view.dispatch,
	          state = view.state;
	      var tr = state.tr,
	          doc = state.doc;
	
	      var tableBodyDOM = tableDOM.lastElementChild;
	      event.stopPropagation();
	
	      var currentCellDOM = null;
	      var cellIdx = idx;
	
	      while (!currentCellDOM) {
	        currentCellDOM = tableBodyDOM.children[cellIdx].firstElementChild;
	        cellIdx--;
	      }
	
	      var currentPos = view.docView.posFromDOM(currentCellDOM, undefined, -1);
	      dispatch(tr.setSelection(prosemirrorState.TextSelection.create(doc, currentPos + (currentCellDOM.classList.contains('num-cell') ? 4 : 2))));
	
	      if (dir === 'top') {
	        return _addRowBefore(store)(view.state, view.dispatch, view);
	      }
	
	      return _addRowAfter(store)(view.state, view.dispatch, view);
	    };
	
	    _this15.renderItems = function () {
	      var _this15$props3 = _this15.props,
	          tableDOM = _this15$props3.tableDOM,
	          selectedRowArr = _this15$props3.selectedRowArr;
	
	      if (!tableDOM) return [];
	      var tableRowDOMs = (0, _from2.default)(tableDOM.lastElementChild.children);
	      var items = [];
	      _this15.anchorCellIdx = selectedRowArr.length ? Math.min.apply(Math, (0, _toConsumableArray3.default)(selectedRowArr)) : null;
	      _this15.headCellIdx = selectedRowArr.length ? Math.max.apply(Math, (0, _toConsumableArray3.default)(selectedRowArr)) : null;
	
	      if (tableRowDOMs[0] && tableRowDOMs[0].classList.contains('ProseMirror-widget')) {
	        tableRowDOMs = tableRowDOMs.slice(1);
	      }
	
	      tableRowDOMs.forEach(function (tr, idx) {
	        var trHeight = parseFloat(window.getComputedStyle(tr).height);
	        var selected = selectedRowArr.includes(idx);
	        items.push(preact.h("div", {
	          key: idx,
	          className: 'ct-table-selectbar-item' + (selected ? ' selected' : ''),
	          style: {
	            height: trHeight + (idx === 0 ? 1 : 0) + 'px'
	          },
	          onClick: function onClick(e) {
	            return _this15.handleItemClick(e, idx);
	          },
	          onMouseDown: preventShiftMouseDown
	        }, preact.h(Addtip, {
	          dir: "top",
	          onClick: function onClick(e) {
	            return _this15.handleAddtipClick(e, idx, 'top');
	          }
	        }, preact.h("div", {
	          className: "visible-wrapper top"
	        }, preact.h("div", {
	          className: "visible"
	        }))), preact.h(Addtip, {
	          dir: "bottom",
	          onClick: function onClick(e) {
	            return _this15.handleAddtipClick(e, idx, 'bottom');
	          }
	        }, preact.h("div", {
	          className: "visible-wrapper bottom"
	        }, preact.h("div", {
	          className: "visible"
	        })))));
	      });
	      return items;
	    };
	    return _this15;
	  }
	
	  (0, _createClass3.default)(RowSelectBar, [{
	    key: 'render',
	    value: function render() {
	      return preact.h("div", {
	        className: "ct-table-row-selectbar"
	      }, this.renderItems());
	    }
	  }]);
	  return RowSelectBar;
	}(preact.Component);
	
	var preventShiftMouseDown$1 = function preventShiftMouseDown$1(e) {
	  if (e.shiftKey) e.preventDefault();
	};
	
	var ColSelectBar$1 = function (_preact$Component9) {
	  (0, _inherits3.default)(ColSelectBar$1, _preact$Component9);
	
	  function ColSelectBar$1(props) {
	    (0, _classCallCheck3.default)(this, ColSelectBar$1);
	
	    var _this16 = (0, _possibleConstructorReturn3.default)(this, (ColSelectBar$1.__proto__ || (0, _getPrototypeOf2.default)(ColSelectBar$1)).call(this, props));
	
	    _this16.anchorCellIdx = null;
	    _this16.headCellIdx = null;
	    _this16.state = {
	      scrollLeft: 0
	    };
	
	    _this16.handleItemClick = function (event, itemIdx) {
	      var _this16$props = _this16.props,
	          view = _this16$props.view,
	          tableDOM = _this16$props.tableDOM,
	          reShowPopover = _this16$props.reShowPopover;
	      var dispatch = view.dispatch,
	          state = view.state;
	      var tr = state.tr,
	          doc = state.doc;
	
	      var tableBodyDOM = tableDOM.lastElementChild;
	      var anchorCellIdx = itemIdx;
	      var headCellIdx = itemIdx;
	
	      if (event.shiftKey) {
	        if (_this16.anchorCellIdx < itemIdx) {
	          anchorCellIdx = typeof _this16.anchorCellIdx === 'number' ? _this16.anchorCellIdx : itemIdx;
	          headCellIdx = itemIdx;
	        } else {
	          anchorCellIdx = itemIdx;
	          headCellIdx = typeof _this16.headCellIdx === 'number' ? _this16.headCellIdx : itemIdx;
	        }
	      }
	
	      var idxChanged = true;
	
	      while (idxChanged) {
	        idxChanged = false;
	        (0, _from2.default)(tableBodyDOM.children).forEach(function (tableRowDOM) {
	          var cellDOMs = (0, _from2.default)(tableRowDOM.children);
	          cellDOMs.forEach(function (cellDOM, idx) {
	            if (idx <= headCellIdx && cellDOM.colSpan) {
	              var maxReach = idx + cellDOM.colSpan - 1;
	
	              if (idx < anchorCellIdx && maxReach >= anchorCellIdx) {
	                anchorCellIdx = idx;
	                idxChanged = true;
	              }
	
	              if (maxReach > headCellIdx) {
	                headCellIdx = maxReach;
	                idxChanged = true;
	              }
	            }
	          });
	        });
	      }
	
	      _this16.anchorCellIdx = anchorCellIdx;
	      _this16.headCellIdx = headCellIdx;
	
	      var anchorCellDOM = void 0;
	      var headCellDOM = void 0;
	      var index = 0;
	      (0, _from2.default)(tableBodyDOM.firstElementChild.children).forEach(function (cellDOM) {
	        if (index === anchorCellIdx) anchorCellDOM = cellDOM;
	        index = (cellDOM.colSpan ? index + cellDOM.colSpan - 1 : index) + 1;
	      });
	      var preRowspanInfo = {};
	
	      var tableRows = tableBodyDOM.children;
	      var colLen = tableDOM.firstElementChild.children.length;
	      var rowLen = tableRows.length;
	
	      for (var i = 0; i < colLen && !headCellDOM; i++) {
	        var rowspan = 0;
	
	        for (var j = 0; j < rowLen && !headCellDOM; j++) {
	          var _cellDOM2 = void 0;
	
	          if (rowspan === 0) {
	            _cellDOM2 = tableRows[j].children[i - (preRowspanInfo[j] || 0)];
	
	            if (_cellDOM2 && _cellDOM2.rowSpan > 1) {
	              rowspan = _cellDOM2.rowSpan - 1;
	            }
	          } else {
	            _cellDOM2 = tableRows[j].children[i];
	            preRowspanInfo[j] = preRowspanInfo[j] ? 1 + preRowspanInfo[j] : 1;
	            rowspan--;
	          }
	
	          if (_cellDOM2 && (_cellDOM2.rowSpan ? _cellDOM2.rowSpan + j : j) === rowLen && ((_cellDOM2.colSpan ? i + _cellDOM2.colSpan - 1 : i) === headCellIdx || anchorCellDOM.offsetLeft === _cellDOM2.offsetLeft)) {
	            headCellDOM = _cellDOM2;
	          }
	        }
	      }
	
	      if (!headCellDOM || _this16.anchorCellIdx !== _this16.headCellIdx) {
	        var maybeHeadCellDOM = 0;
	        index = preRowspanInfo[rowLen - 1] || 0;
	        (0, _from2.default)(tableBodyDOM.lastElementChild.children).forEach(function (cellDOM) {
	          if (cellDOM && anchorCellDOM.offsetLeft === cellDOM.offsetLeft) maybeHeadCellDOM = cellDOM;
	          if ((cellDOM.colSpan ? index + cellDOM.colSpan - 1 : index) === headCellIdx) headCellDOM = cellDOM;
	          index = (cellDOM.colSpan ? index + cellDOM.colSpan - 1 : index) + 1;
	        });
	        if (!headCellDOM) headCellDOM = maybeHeadCellDOM;
	      }
	
	      var anchorPos = view.docView.posFromDOM(anchorCellDOM, undefined, -1) - 1;
	      var headPos = view.docView.posFromDOM(headCellDOM, undefined, -1) - 1;
	
	      var newSelection = new CellSelection(doc.resolve(anchorPos), doc.resolve(headPos));
	      dispatch(tr.setSelection(newSelection));
	      view.focus();
	      reShowPopover();
	    };
	
	    _this16.handleAddtipClick = function (event, idx, dir) {
	      var _this16$props2 = _this16.props,
	          store = _this16$props2.store,
	          view = _this16$props2.view,
	          tableDOM = _this16$props2.tableDOM;
	      var dispatch = view.dispatch,
	          state = view.state;
	      var tr = state.tr,
	          doc = state.doc;
	
	      var tableBodyDOM = tableDOM.lastElementChild;
	      event.stopPropagation();
	
	      var currentCellDOM = null;
	      var index = 0;
	      (0, _from2.default)(tableBodyDOM.firstElementChild.children).forEach(function (cellDOM) {
	        if (currentCellDOM) return;
	        var maxReach = index + cellDOM.colSpan - 1;
	        if (index <= idx && idx <= maxReach) currentCellDOM = cellDOM;
	        index = (cellDOM.colSpan ? maxReach : index) + 1;
	      });
	
	      var currentPos = view.docView.posFromDOM(currentCellDOM, undefined, -1);
	      dispatch(tr.setSelection(prosemirrorState.TextSelection.create(doc, currentPos + 1)));
	
	      if (dir === 'left') {
	        return _addColumnBefore(store)(view.state, view.dispatch, view);
	      }
	
	      return _addColumnAfter(store)(view.state, view.dispatch, view);
	    };
	
	    _this16.renderItems = function () {
	      var _this16$props3 = _this16.props,
	          store = _this16$props3.store,
	          tableDOM = _this16$props3.tableDOM,
	          selectedColArr = _this16$props3.selectedColArr;
	      var scrollLeft = _this16.state.scrollLeft;
	
	      if (!tableDOM) return [];
	      var colDOMs = (0, _from2.default)(tableDOM.firstElementChild.children);
	      var items = [];
	
	      if (colDOMs.length === 0) {
	        var tableRowDOMs = tableDOM.lastElementChild.children;
	        var rowDOM = tableRowDOMs[0];
	        colDOMs = [];
	
	        for (var i = 0; i < rowDOM.childElementCount; i++) {
	          var _cellDOM3 = rowDOM.children[i];
	          var colspan = parseInt(_cellDOM3.getAttribute('colspan'), 10) || 1;
	          var cellWidth = _cellDOM3.getBoundingClientRect().width / colspan;
	
	          for (var j = 0; j < colspan; j++) {
	            colDOMs.push({
	              cellWidth: cellWidth
	            });
	          }
	        }
	      }
	
	      store.colDOMs = colDOMs;
	      _this16.anchorCellIdx = selectedColArr.length ? Math.min.apply(Math, (0, _toConsumableArray3.default)(selectedColArr)) : null;
	      _this16.headCellIdx = selectedColArr.length ? Math.max.apply(Math, (0, _toConsumableArray3.default)(selectedColArr)) : null;
	
	      var totalWidth = 0;
	      colDOMs.forEach(function (col, idx) {
	        var colWidth = col.cellWidth || parseInt(col.style && col.style.width, 10);
	        totalWidth += colWidth;
	        var selected = selectedColArr.includes(idx);
	        items.push(preact.h("div", {
	          key: idx,
	          className: 'ct-table-selectbar-item' + (selected ? ' selected' : ''),
	          style: {
	            width: (idx === colDOMs.length - 1 ? colWidth + 1 : colWidth) + 'px'
	          },
	          onClick: function onClick(e) {
	            return _this16.handleItemClick(e, idx);
	          },
	          onMouseDown: preventShiftMouseDown$1
	        }, preact.h(Addtip, {
	          dir: "left",
	          offset: totalWidth - colWidth - 12 - scrollLeft,
	          onClick: function onClick(e) {
	            return _this16.handleAddtipClick(e, idx, 'left');
	          }
	        }, preact.h("div", {
	          className: "visible-wrapper left"
	        }, preact.h("div", {
	          className: "visible"
	        }))), preact.h(Addtip, {
	          dir: "right",
	          offset: totalWidth - 12 - scrollLeft,
	          onClick: function onClick(e) {
	            return _this16.handleAddtipClick(e, idx, 'right');
	          }
	        }, preact.h("div", {
	          className: "visible-wrapper right"
	        }, preact.h("div", {
	          className: "visible"
	        })))));
	      });
	      return {
	        items: items,
	        totalWidth: totalWidth
	      };
	    };
	
	    _this16.onScroll = function (e) {
	      _this16.setState({
	        scrollLeft: e.target.scrollLeft
	      });
	    };
	
	    _this16.handleScroll = throttle(_this16.onScroll, 300);
	    return _this16;
	  }
	
	  (0, _createClass3.default)(ColSelectBar$1, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var parentNode = this.props.parentNode;
	
	      this.scrollBar.scrollLeft = parentNode.scrollLeft;
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      var parentNode = this.props.parentNode;
	
	      var scrollLeft = parentNode.scrollLeft;
	
	      if (this.scrollBar.scrollLeft !== scrollLeft) {
	        this.scrollBar.scrollLeft = scrollLeft;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this17 = this;
	
	      var _props5 = this.props,
	          containerWidth = _props5.containerWidth,
	          tableMarginLeft = _props5.tableMarginLeft,
	          colPaddingLeft = _props5.colPaddingLeft;
	
	      var _renderItems = this.renderItems(),
	          items = _renderItems.items,
	          totalWidth = _renderItems.totalWidth;
	
	      return preact.h("div", {
	        style: {
	          position: 'relative'
	        }
	      }, preact.h("div", {
	        className: "ct-table-col-selectbar-wrapper",
	        style: {
	          width: containerWidth - tableMarginLeft + colPaddingLeft + 'px',
	          paddingLeft: colPaddingLeft + 'px'
	        },
	        ref: function ref(div) {
	          _this17.scrollBar = div;
	        },
	        onScroll: this.handleScroll
	      }, preact.h("div", {
	        className: "ct-table-col-selectbar",
	        style: {
	          width: totalWidth + 1 + 'px'
	        }
	      }, items)));
	    }
	  }]);
	  return ColSelectBar$1;
	}(preact.Component);
	
	var showPopoverUtil = function showPopoverUtil(popover, styleObj, Component, props) {
	  if (!popover) return;
	  popover.style.display = 'block';
	  (0, _keys2.default)(styleObj).forEach(function (key) {
	    popover.style[key] = styleObj[key];
	  });
	  preact.render(preact.h(Component, props), popover, popover.firstChild);
	};
	var hidePopoverUtil = function hidePopoverUtil(popover) {
	  if (!popover) return;
	  popover.style.display = 'none';
	  preact.render(null, popover, popover.firstChild);
	};
	var isLegalTableDOM = function isLegalTableDOM(tableDOM) {
	  return tableDOM && tableDOM.tagName.toUpperCase() === 'TABLE' && tableDOM.parentNode && tableDOM.parentNode.classList.contains('ct-table-wrapper') && !tableDOM.closest('.ct-collapse:not(.active)');
	};
	
	var TableStore = function () {
	  function TableStore(config) {
	    var _this18 = this;
	
	    (0, _classCallCheck3.default)(this, TableStore);
	
	    this.config = {};
	    this.core = null;
	    this.view = null;
	    this.modules = null;
	    this.$scroll = null;
	    this.popover = null;
	    this.isShowPopover = false;
	    this.isShowScrollBar = false;
	    this.isShowHeaderBar = false;
	    this.isShowSelectBar = false;
	    this.headerTableDOM = null;
	    this.headerParentNode = null;
	    this.headerPaddingLeft = 0;
	    this.scrollTableDOM = null;
	    this.tableDOM = null;
	    this.tableContent = "";
	    this.tablePos = null;
	    this.parentNode = null;
	    this.colDOMs = [];
	    this.tableMarginLeft = 0;
	    this.tableLeft = 0;
	    this.tableTop = 0;
	    this.tableBottom = 0;
	    this.tableHeight = 0;
	    this.tableWidth = 0;
	    this.containerWidth = 0;
	    this.colPaddingLeft = 0;
	    this.scrollContainerWidth = 0;
	    this.scrollTableWidth = 0;
	    this.tableHeightChanging = false;
	    this.cellSelection = null;
	    this.selectedRowArr = [];
	    this.selectedColArr = [];
	
	    this.emitTableError = function (msg) {
	      if (_this18.editor) {
	        _this18.editor.emit("tableError", msg);
	      }
	    };
	
	    this.checkGlobalTabel = function () {
	      var checkHeader = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      var tableDOMs = (0, _from2.default)(_this18.$scroll.querySelectorAll(".ct-table-wrapper > table")).filter(function (tableDOM) {
	        return !tableDOM.closest(".ct-collapse:not(.active)");
	      });
	      if (checkHeader) _this18.checkTableHeader(tableDOMs);
	      _this18.checkScrollBar(tableDOMs);
	    };
	
	    this.reShowPopover = function () {
	      var tableDOM = _this18.tableDOM || _this18.tablePos && _this18.view.docView.domFromPos(_this18.tablePos + 1).node.parentNode;
	      _this18.showPopover(tableDOM);
	    };
	
	    this.showPopover = function (tableDOM) {
	      if (!isLegalTableDOM(tableDOM)) return _this18.hidePopover();
	      _this18.isShowPopover = true;
	      _this18.tableDOM = tableDOM;
	      _this18.tableContent = tableDOM.innerHTML;
	      _this18.parentNode = tableDOM.parentNode;
	      setTimeout(function () {
	        if (!_this18.tableDOM) return _this18.hidePopover();
	
	        try {
	          _this18.tablePos = _this18.view.docView.posFromDOM(_this18.tableDOM) - 1;
	        } catch (error) {
	          return;
	        }
	
	        _this18.setTableRect();
	        _this18.showSelectBar();
	        _this18.handleCellSelected();
	        _this18.addEvents();
	        _this18.checkTableHeader([tableDOM, _this18.headerTableDOM].filter(function (_) {
	          return !!_;
	        }));
	      }, 0);
	    };
	
	    this.hidePopover = function () {
	      var tableDOM = _this18.tableDOM;
	      _this18.isShowPopover = false;
	      _this18.tableDOM = null;
	      _this18.tablePos = null;
	      _this18.cellSelection = null;
	      _this18.selectedRowArr = [];
	      _this18.selectedColArr = [];
	      _this18.hideSelectBar();
	      _this18.removeEvents();
	      _this18.checkTableHeader([tableDOM, _this18.headerTableDOM].filter(function (_) {
	        return !!_;
	      }));
	    };
	
	    this.checkScrollBar = function (tableDOMs) {
	      var res = tableDOMs.some(function (tableDOM) {
	        return _this18.toggleScrollBar(tableDOM);
	      });
	
	      if (!res) {
	        _this18.scrollTableDOM = null;
	        _this18.hideScrollBar();
	      }
	    };
	
	    this.toggleScrollBar = function (scrollTableDOM) {
	      var bottomBias = _this18.getBottomBias();
	      var scrollParentNode = scrollTableDOM.parentNode;
	      var isOutTable = scrollParentNode && !scrollParentNode.closest("table");
	      if (!isOutTable) return false;
	      var tableRect = scrollTableDOM.getBoundingClientRect();
	      var tableLeft = tableRect.left + scrollParentNode.scrollLeft;
	      var tableBottom = window.innerHeight - tableRect.bottom;
	      var containerWidth = scrollParentNode.clientWidth;
	      var tableWidth = tableRect.width;
	
	      if (containerWidth < tableWidth && tableRect.top + bottomBias + 10 < window.innerHeight && tableBottom < bottomBias + 10) {
	        _this18.scrollTableDOM = scrollTableDOM;
	        _this18.scrollParentNode = scrollParentNode;
	        _this18.scrollContainerWidth = containerWidth;
	        _this18.scrollTableWidth = tableWidth;
	        _this18.showScrollBar(tableLeft);
	        return true;
	      }
	
	      return false;
	    };
	
	    this.showScrollBar = function (tableLeft) {
	      var bottomBias = _this18.getBottomBias();
	      var styleObj = {
	        left: tableLeft + 'px',
	        bottom: bottomBias + 'px'
	      };
	      var props = {
	        scrollParentNode: _this18.scrollParentNode,
	        scrollContainerWidth: _this18.scrollContainerWidth,
	        scrollTableWidth: _this18.scrollTableWidth
	      };
	      showPopoverUtil(_this18.scrollBarPopover, styleObj, ScrollBar, props);
	      _this18.isShowScrollBar = true;
	    };
	
	    this.hideScrollBar = function () {
	      hidePopoverUtil(_this18.scrollBarPopover);
	      _this18.isShowScrollBar = false;
	    };
	
	    this.checkTableHeader = function (tableDOMs) {
	      var res = tableDOMs.some(function (tableDOM) {
	        return _this18.toggleHeaderBar(tableDOM);
	      });
	
	      if (!res) {
	        _this18.headerTableDOM = null;
	        _this18.hideHeaderBar();
	      }
	    };
	
	    this.toggleHeaderBar = function (headerTableDOM) {
	      try {
	        var topBias = _this18.getTopBias();
	        var tbody = headerTableDOM.querySelector('tbody');
	        var findFirstTr = tbody && tbody.querySelector("tr");
	
	        if (!findFirstTr) {
	          throw new Error('citadelError: cann\'t find tr in dom ' + tbody.innerHTML);
	        }
	
	        var _hasTableHeader = [].concat((0, _toConsumableArray3.default)(findFirstTr.cells)).every(function (cell) {
	          return cell.tagName === "TH";
	        });
	
	        var _headerTableDOM$getBo = headerTableDOM.getBoundingClientRect(),
	            top = _headerTableDOM$getBo.top,
	            bottom = _headerTableDOM$getBo.bottom,
	            left = _headerTableDOM$getBo.left;
	
	        if (_hasTableHeader && top < topBias && bottom > topBias + findFirstTr.clientHeight) {
	          _this18.headerTableDOM = headerTableDOM;
	          _this18.headerParentNode = headerTableDOM.parentNode;
	          _this18.tableHeader = _this18.cloneHeader(findFirstTr);
	          var scrollLeft = _this18.headerParentNode.scrollLeft;
	          _this18.showHeaderBar(topBias, left, scrollLeft);
	          return true;
	        }
	
	        return false;
	      } catch (err) {
	        throw err;
	      }
	    };
	
	    this.showHeaderBar = function (toolbarHeight, headerLeft, scrollLeft) {
	      var marginLeft = parseInt(_this18.headerTableDOM.style.marginLeft, 10) || 0;
	      var paddingLeft = 0;
	      var popoverLeft = scrollLeft + headerLeft;
	
	      if (marginLeft >= scrollLeft) {
	        popoverLeft -= scrollLeft;
	        paddingLeft = scrollLeft;
	      } else {
	        popoverLeft -= marginLeft;
	        paddingLeft = marginLeft;
	      }
	
	      _this18.headerPaddingLeft = paddingLeft;
	      var styleObj = {
	        left: popoverLeft + 'px',
	        top: toolbarHeight + 'px'
	      };
	      var props = {
	        view: _this18.view,
	        $scroll: _this18.$scroll,
	        headerTableDOM: _this18.headerTableDOM,
	        tableHeader: _this18.tableHeader,
	        headerParentNode: _this18.headerParentNode,
	        headerPaddingLeft: _this18.headerPaddingLeft
	      };
	      showPopoverUtil(_this18.headerBarPopover, styleObj, HeaderBar, props);
	      _this18.isShowHeaderBar = true;
	      _this18.headerParentNode.addEventListener("scroll", _this18.handleHeaderTableScroll);
	    };
	
	    this.hideHeaderBar = function () {
	      hidePopoverUtil(_this18.headerBarPopover);
	      _this18.isShowHeaderBar = false;
	      _this18.headerParentNode && _this18.headerParentNode.removeEventListener("scroll", _this18.handleHeaderTableScroll);
	    };
	
	    this.handleHeaderTableScroll = function () {
	      if (_this18.isShowHeaderBar && _this18.headerTableDOM) {
	        var popoverDOM = document.querySelector(".ct-table-headerbar-popover");
	        var wrapperDOM = popoverDOM.querySelector(".ct-table-wrapper");
	
	        if (wrapperDOM) {
	          var headerLeft = _this18.headerTableDOM.getBoundingClientRect().left;
	          var scrollLeft = _this18.headerParentNode.scrollLeft;
	          var marginLeft = parseInt(_this18.headerTableDOM.style.marginLeft, 10) || 0;
	          var paddingLeft = 0;
	          var popoverLeft = headerLeft + scrollLeft;
	
	          if (marginLeft >= scrollLeft) {
	            popoverLeft -= scrollLeft;
	            paddingLeft = scrollLeft;
	          } else {
	            popoverLeft -= marginLeft;
	            paddingLeft = marginLeft;
	          }
	
	          _this18.headerPaddingLeft = paddingLeft;
	          popoverDOM.style.left = popoverLeft + 'px';
	          wrapperDOM.scrollLeft = scrollLeft;
	        }
	      }
	    };
	
	    this.cloneHeader = function (header) {
	      var newHeader = header.cloneNode(true);
	      var ctFrames = header.querySelectorAll(".ct-frame");
	
	      (0, _from2.default)(newHeader.querySelectorAll(".ct-frame")).forEach(function (frame, i) {
	        frame.onload = function () {
	          frame.contentDocument.write('<!doctype html>' + ctFrames[i].contentDocument.documentElement.innerHTML);
	        };
	      });
	      return newHeader;
	    };
	
	    this.showSelectBar = function () {
	      var scrollLeft = _this18.parentNode.scrollLeft;
	      var tableLeft = _this18.tableLeft;
	      var paddingLeft = 0;
	
	      if (_this18.tableMarginLeft >= scrollLeft) {
	        tableLeft -= scrollLeft;
	        paddingLeft = scrollLeft;
	      } else {
	        tableLeft -= _this18.tableMarginLeft;
	        paddingLeft = _this18.tableMarginLeft;
	      }
	
	      _this18.colPaddingLeft = paddingLeft;
	      var allStyleObj = {
	        left: tableLeft - 18 + 'px',
	        top: _this18.tableTop - 18 + 'px'
	      };
	      var rowStyleObj = {
	        left: tableLeft - 26 + 'px',
	        top: _this18.tableTop + 'px',
	        height: _this18.tableHeight + 'px'
	      };
	      var colStyleObj = {
	        left: tableLeft + 'px',
	        top: _this18.tableTop - 46 + 'px',
	        width: _this18.containerWidth + 'px'
	      };
	      var allProps = {
	        view: _this18.view,
	        tablePos: _this18.tablePos,
	        tableDOM: _this18.tableDOM,
	        colDOMs: _this18.colDOMs,
	        selectedRowArr: _this18.selectedRowArr,
	        selectedColArr: _this18.selectedColArr,
	        reShowPopover: _this18.reShowPopover
	      };
	      var rowProps = {
	        store: _this18,
	        view: _this18.view,
	        tableDOM: _this18.tableDOM,
	        parentNode: _this18.parentNode,
	        tableWidth: _this18.tableWidth,
	        selectedRowArr: _this18.selectedRowArr,
	        reShowPopover: _this18.reShowPopover
	      };
	      var colProps = {
	        store: _this18,
	        view: _this18.view,
	        tableDOM: _this18.tableDOM,
	        parentNode: _this18.parentNode,
	        containerWidth: _this18.containerWidth,
	        tableMarginLeft: _this18.tableMarginLeft,
	        colPaddingLeft: _this18.colPaddingLeft,
	        selectedColArr: _this18.selectedColArr,
	        reShowPopover: _this18.reShowPopover
	      };
	      showPopoverUtil(_this18.allSelectBarPopover, allStyleObj, ColSelectBar, allProps);
	      showPopoverUtil(_this18.rowSelectBarPopover, rowStyleObj, RowSelectBar, rowProps);
	      showPopoverUtil(_this18.colSelectBarPopover, colStyleObj, ColSelectBar$1, colProps);
	      _this18.isShowSelectBar = true;
	    };
	
	    this.hideSelectBar = function () {
	      hidePopoverUtil(_this18.allSelectBarPopover);
	      hidePopoverUtil(_this18.rowSelectBarPopover);
	      hidePopoverUtil(_this18.colSelectBarPopover);
	      _this18.isShowSelectBar = false;
	    };
	
	    this.handleCellSelected = function (selection) {
	      if (!_this18.tableDOM || _this18.cellSelection === selection) return;
	      _this18.cellSelection = selection;
	      setTimeout(function () {
	        _this18.countSelected();
	
	        if (_this18.view.state.selection instanceof CellSelection) {
	          _this18.showSelectBar();
	        }
	      }, 0);
	    };
	
	    this.countSelected = function () {
	      if (!_this18.tableDOM) return;
	      var selectedCells = _this18.tableDOM.querySelectorAll(".selectedCell");
	      var tableRowDOMs = (0, _from2.default)(_this18.tableDOM.lastElementChild.children);
	      var selectedRowArr = [];
	      var selectedColArr = [];
	
	      var leftWidthSet = [];
	      var colSpanMap = {};
	
	      var offsetTopSet = new _set2.default();
	      var rowSpanMap = {};
	      selectedCells.forEach(function (selectedCell) {
	        var leftWidth = selectedCell.offsetLeft;
	        var colSpan = selectedCell.colSpan;
	        leftWidthSet.push(leftWidth);
	
	        if (!colSpanMap[leftWidth] || colSpanMap[leftWidth] < colSpan) {
	          colSpanMap[leftWidth] = colSpan;
	        }
	
	        var offsetTop = selectedCell.offsetTop;
	        var rowSpan = selectedCell.rowSpan;
	        offsetTopSet.add(offsetTop);
	
	        if (!rowSpanMap[offsetTop] || rowSpanMap[offsetTop] < rowSpan) {
	          rowSpanMap[offsetTop] = rowSpan;
	        }
	      });
	
	      if (_this18.colDOMs.length === 0 || !_this18.colDOMs[0].style) {
	        var rowDOM = tableRowDOMs[0];
	        _this18.colDOMs = [];
	
	        for (var i = 0; i < rowDOM.childElementCount; i++) {
	          var _cellDOM4 = rowDOM.children[i];
	          var colspan = parseInt(_cellDOM4.getAttribute("colspan"), 10) || 1;
	          var cellWidth = _cellDOM4.getBoundingClientRect().width / colspan;
	
	          for (var j = 0; j < colspan; j++) {
	            _this18.colDOMs.push({
	              cellWidth: cellWidth
	            });
	          }
	        }
	      }
	
	      var leftWidth = 0;
	      _this18.colDOMs.forEach(function (col, idx) {
	        var colWidth = col.cellWidth || parseInt(col.style && col.style.width, 10);
	        var selected = leftWidthSet.some(function (_) {
	          var dis = leftWidth - _;
	          return dis > -5 && dis < 5;
	        });
	        if (selected) selectedColArr.push(idx);
	
	        var colSpan = colSpanMap[leftWidth];
	        leftWidth += colWidth;
	
	        if (selected && colSpan > 1) {
	          leftWidthSet.push(leftWidth);
	          colSpanMap[leftWidth] = colSpan - 1;
	        }
	      });
	
	      var nextSelected = 0;
	      tableRowDOMs.forEach(function (tr, idx) {
	        var offsetTop = tr.offsetTop;
	        var selected = offsetTopSet.has(offsetTop) || nextSelected > 0;
	        if (selected) selectedRowArr.push(idx);
	
	        var rowSpan = rowSpanMap[offsetTop];
	
	        if (selected && rowSpan - 1 > nextSelected) {
	          nextSelected = rowSpan - 1;
	        } else {
	          nextSelected--;
	        }
	      });
	      _this18.selectedRowArr = selectedRowArr;
	      _this18.selectedColArr = selectedColArr;
	    };
	
	    this.addEvents = function () {
	      _this18.removeEvents();
	      _this18.$scroll.addEventListener("mousewheel", _this18.handleMouseWheel);
	      window.addEventListener("resize", _this18.handlePageResize);
	    };
	
	    this.removeEvents = function () {
	      _this18.$scroll.removeEventListener("mousewheel", _this18.handleMouseWheel);
	      window.removeEventListener("resize", _this18.handlePageResize);
	    };
	
	    this.handleMouseWheel = function (e) {
	      var isInSelectBar = e.target.classList.contains("visible");
	      if (!isInSelectBar) return;
	      var direct = 0;
	
	      if (e.wheelDelta) {
	        direct = e.wheelDelta > 0 ? 1 : -1;
	      } else if (e.detail) {
	        direct = e.detail > 0 ? 1 : -1;
	      }
	
	      if (direct !== 0) {
	        if (direct === 1) {
	          _this18.$scroll.scrollTop -= 8;
	        } else {
	          _this18.$scroll.scrollTop += 8;
	        }
	      }
	    };
	
	    this.handleTableScroll = function () {
	      if (_this18.isShowPopover) {
	        var onTableScroll = _this18.config.onTableScroll;
	
	        _this18.setTableRect();
	        _this18.showSelectBar();
	        _this18.checkGlobalTabel(false);
	        if (onTableScroll) onTableScroll(_this18.core);
	      }
	    };
	
	    this.handleTableWidthChange = function (dir) {
	      if (!_this18.tableDOM) return;
	      var preTableWith = _this18.tableWidth;
	
	      if (dir === "right") {
	        setTimeout(function () {
	          _this18.parentNode.scrollLeft += _this18.tableWidth - preTableWith;
	        }, 10);
	      }
	
	      _this18.setTableRect();
	      _this18.showSelectBar();
	    };
	
	    this.handleTableHeightChange = function () {
	      if (!_this18.tableDOM) return;
	      _this18.tableHeightChanging = true;
	      _this18.setTableRect();
	      _this18.showSelectBar();
	    };
	
	    this.handlePageScroll = function () {
	      _this18.checkGlobalTabel();
	
	      if (_this18.tableHeightChanging) {
	        _this18.tableHeightChanging = false;
	        return;
	      }
	
	      if (_this18.isShowPopover) {
	        _this18.setTableRect();
	        _this18.showSelectBar();
	      }
	    };
	
	    this.handlePageResize = function () {
	      _this18.showPopover(_this18.tableDOM);
	    };
	
	    this.setTableRect = function () {
	      if (!_this18.tableDOM) return _this18.hidePopover();
	      var tableRect = _this18.tableDOM.getBoundingClientRect();
	      _this18.tableMarginLeft = parseInt(_this18.tableDOM.style.marginLeft, 10) || 0;
	      _this18.tableLeft = tableRect.left + _this18.parentNode.scrollLeft;
	      _this18.tableTop = tableRect.top;
	      _this18.tableBottom = window.innerHeight - tableRect.bottom;
	      _this18.containerWidth = _this18.parentNode.clientWidth;
	      _this18.tableHeight = tableRect.height;
	      _this18.tableWidth = tableRect.width;
	    };
	
	    this.showModal = function () {
	      var state = _this18.view.state;
	      var selection = state.selection,
	          schema = state.schema;
	
	      var tableType = schema.nodes.table;
	      var foundNode = index_js.findParentNode(selection.$from.path, function (node) {
	        return node.type === tableType;
	      });
	      if (!foundNode) return;
	      var Component = preact.h(TableModal, _extends_1({
	        store: _this18.editor
	      }, foundNode.node.attrs, {
	        setTableAttrs: function setTableAttrs(attrs) {
	          return _this18.setTableAttrs(objectSpread({}, foundNode.node.attrs, attrs), foundNode.pos);
	        },
	        hideModal: _this18.hideModal
	      }));
	      preact.render(Component, _this18.modalPopover);
	    };
	
	    this.hideModal = function () {
	      preact.render(null, _this18.modalPopover, _this18.modalPopover.lastChild);
	    };
	
	    this.setTableAttrs = function (attrs, pos) {
	      var _view = _this18.view,
	          state = _view.state,
	          dispatch = _view.dispatch;
	      var tr = state.tr;
	
	      tr.setNodeMarkup(pos, null, objectSpread({}, attrs));
	      dispatch(tr);
	      _this18.view.focus();
	      _this18.showPopover(_this18.tableDOM);
	    };
	
	    this.config = config;
	    this.showPopover = throttle(this.showPopover, 200);
	  }
	
	  (0, _createClass3.default)(TableStore, [{
	    key: 'init',
	    value: function init(editor) {
	      this.editor = editor;
	      this.core = editor.core;
	      this.view = editor.view;
	      this.$scroll = editor.$scroll;
	      this.modules = editor.modules;
	      this.getTopBias = editor.getTopBias;
	      this.getBottomBias = editor.getBottomBias;
	
	      if (this.$scroll.tagName === "HTML") {
	        window.addEventListener("scroll", this.handlePageScroll);
	      } else {
	        this.$scroll.addEventListener("scroll", this.handlePageScroll);
	      }
	    }
	  }, {
	    key: 'onCreatePopover',
	    value: function onCreatePopover(scrollBarPopover, headerBarPopover, rowSelectBarPopover, colSelectBarPopover, allSelectBarPopover, modalPopover) {
	      this.scrollBarPopover = scrollBarPopover;
	      this.headerBarPopover = headerBarPopover;
	      this.rowSelectBarPopover = rowSelectBarPopover;
	      this.colSelectBarPopover = colSelectBarPopover;
	      this.allSelectBarPopover = allSelectBarPopover;
	      this.modalPopover = modalPopover;
	      setTimeout(this.checkGlobalTabel, 0);
	    }
	  }, {
	    key: 'onRemovePopover',
	    value: function onRemovePopover() {
	      this.hidePopover();
	      this.hideHeaderBar();
	      this.hideScrollBar();
	
	      if (this.$scroll.tagName === "HTML") {
	        window.removeEventListener("scroll", this.handlePageScroll);
	      } else {
	        this.$scroll.removeEventListener("scroll", this.handlePageScroll);
	      }
	    }
	  }]);
	  return TableStore;
	}();
	
	function uuid() {
	  var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
	  var id = [];
	
	  for (var i = 0; i < 8; i++) {
	    id.push(chars[parseInt(Math.random() * chars.length, 10)]);
	  }
	
	  return id.join('');
	}
	
	var getWidthNumber = function getWidthNumber(width, tableWidth) {
	  if (typeof width === 'string') {
	    if (width.indexOf('%') !== -1) {
	      return parseFloat(width) * 0.01 * tableWidth;
	    }
	
	    return parseInt(width, 10);
	  }
	
	  return width;
	};
	function getCellAttrs(dom) {
	  var pmDOM = document.querySelector('.ProseMirror');
	  var widthAttr = dom.getAttribute('data-colwidth');
	  var tableWidth = pmDOM ? pmDOM.clientWidth : 0;
	  var tableEl = dom.parentNode.parentNode.parentNode;
	  var colgroupEl = tableEl.children[0];
	  var index = (0, _from2.default)(dom.parentNode.children).findIndex(function (el) {
	    return el === dom;
	  });
	  var col = colgroupEl.children[index];
	  var colspan = parseFloat(dom.getAttribute('colspan') || 1);
	  var rowspan = parseFloat(dom.getAttribute('rowspan') || 1);
	
	  if (!widthAttr) {
	    widthAttr = dom.width || dom.style.width || col && (col.width || col.style.width);
	    tableWidth = getWidthNumber(tableEl.style.width, tableWidth);
	  }
	
	  var widths = void 0;
	
	  if (widthAttr && widthAttr.split(',').length > colspan) {
	    widths = [widthAttr.split(',').map(function (p) {
	      return parseInt(p);
	    }).reduce(function (prev, cur) {
	      return prev + cur;
	    })];
	  } else {
	    widths = widthAttr ? widthAttr.split(',').map(function (w) {
	      return getWidthNumber(w, tableWidth);
	    }) : [tableWidth / (colgroupEl.children[0] ? colgroupEl.children[0].children.length : 1)];
	    widths = widths.map(function (num) {
	      return num < 50 ? 50 : ~~num;
	    });
	  }
	
	  var widthsLen = widths.length;
	
	  if (widthsLen < colspan) {
	    var fillArr = new Array(colspan - widthsLen);
	    fillArr.fill(50);
	    widths = [].concat((0, _toConsumableArray3.default)(widths), fillArr);
	  }
	
	  if (window.devicePixelRatio === 1.25) {
	    widths = widths.map(formatWidth);
	  }
	
	  var dataCellDiffId = dom.getAttribute('data-cell-diff-id');
	  var result = {
	    dataCellDiffId: dataCellDiffId,
	    colspan: colspan,
	    rowspan: rowspan,
	    colwidth: widthsLen <= colspan ? widths : [50],
	    bgColor: dom.style.backgroundColor,
	    textAlign: dom.style.textAlign,
	    verticalAlign: dom.style.verticalAlign,
	    color: dom.style.color,
	    numCell: dom.classList.contains('num-cell')
	  };
	  return result;
	}
	function setCellAttrs(node) {
	  var attrs = {};
	  var nodeAttrs = node.attrs;
	
	  if (nodeAttrs.colspan !== 1) {
	    attrs.colspan = nodeAttrs.colspan;
	  }
	
	  if (nodeAttrs.rowspan !== 1) {
	    attrs.rowspan = nodeAttrs.rowspan;
	  }
	
	  if (nodeAttrs.colwidth) {
	    attrs['data-colwidth'] = nodeAttrs.colwidth.join(',');
	  } else {
	    attrs['data-colwidth'] = '68';
	  }
	
	  attrs.width = attrs['data-colwidth'];
	  var style = '';
	
	  var textBlockNames = ['paragraph', 'heading'];
	
	  if (node.content.content.some(function (child) {
	    var typeName = child.type.name;
	    if (child.type.spec.braceWidth) return true;
	    if (textBlockNames.includes(typeName)) return child.content.content.some(function (_) {
	      return _.type.spec.braceWidth;
	    });
	    return false;
	  })) {
	    attrs.class = 'overflow';
	  }
	
	  if (nodeAttrs.bgColor) style += 'background-color: ' + nodeAttrs.bgColor + ';';
	  if (nodeAttrs.color) style += 'color: ' + nodeAttrs.color + ';';
	  if (nodeAttrs.verticalAlign) style += 'vertical-align:' + nodeAttrs.verticalAlign + ';';
	  if (nodeAttrs.textAlign) style += 'text-align:' + nodeAttrs.textAlign + ';';
	  if (style) attrs.style = style;
	
	  if (nodeAttrs.numCell) {
	    attrs.contenteditable = true;
	    attrs.style = 'caret-color: transparent';
	    attrs.class = attrs.class ? attrs.class + ' num-cell' : 'num-cell';
	  }
	
	  attrs['data-cell-diff-id'] = nodeAttrs.dataCellDiffId || 'ct-cell-diff-id-' + uuid();
	  return attrs;
	}
	function getTableAttrs$1(dom) {
	  var marginLeft = parseInt(dom.style.marginLeft, 10) / 20 || 0;
	  var indent = marginLeft > 0 ? marginLeft : 0;
	  var responsive = dom.classList.contains('responsive');
	  var borderStyle = dom.getAttribute('data-borderstyle');
	  var borderWidth = dom.getAttribute('data-borderwidth');
	  var borderColor = dom.getAttribute('data-bordercolor');
	  var dataDiffId = dom.getAttribute('data-diff-id');
	  return {
	    indent: indent,
	    responsive: responsive,
	    borderStyle: borderStyle,
	    borderWidth: borderWidth,
	    borderColor: borderColor,
	    dataDiffId: dataDiffId
	  };
	}
	function setTableAttrs(node) {
	  var attrs = {};
	  var _node$attrs2 = node.attrs,
	      indent = _node$attrs2.indent,
	      responsive = _node$attrs2.responsive,
	      borderStyle = _node$attrs2.borderStyle,
	      borderWidth = _node$attrs2.borderWidth,
	      borderColor = _node$attrs2.borderColor,
	      dataDiffId = _node$attrs2.dataDiffId;
	
	  if (indent > 0) attrs.style = 'margin-left: ' + indent * 20 + 'px;';
	  if (responsive) attrs.class = 'responsive';
	  if (borderStyle !== 'solid') attrs['data-borderstyle'] = borderStyle;
	  if (borderWidth !== 1) attrs['data-borderwidth'] = borderWidth;
	  if (borderColor !== '#dddddd') attrs['data-bordercolor'] = borderColor;
	  attrs['data-diff-id'] = dataDiffId || 'ct-diff-id-' + uuid();
	  return attrs;
	}
	
	var cellAttrs = {
	  colspan: {
	    default: 1
	  },
	  rowspan: {
	    default: 1
	  },
	  colwidth: {
	    default: [68]
	  },
	  textAlign: {
	    default: null
	  },
	  verticalAlign: {
	    default: null
	  },
	  bgColor: {
	    default: null
	  },
	  color: {
	    default: null
	  },
	  numCell: {
	    default: null
	  },
	
	  dataCellDiffId: {
	    default: null
	  }
	};
	var schema = {
	  nodes: {
	    table: {
	      content: 'table_row+',
	      tableRole: 'table',
	      isolating: true,
	      allowGapCursor: true,
	      insertBlock: true,
	      group: 'block',
	      attrs: {
	        indent: {
	          default: 0
	        },
	        responsive: {
	          default: false
	        },
	        borderStyle: {
	          default: 'solid'
	        },
	        borderWidth: {
	          default: 1
	        },
	        borderColor: {
	          default: '#cccccc'
	        },
	        dataDiffId: {
	          default: null
	        }
	      },
	      parseDOM: [{
	        tag: 'table',
	        getAttrs: getTableAttrs$1
	      }],
	
	      toDOM: function toDOM(node) {
	        return ['table', setTableAttrs(node), ['tbody', 0]];
	      }
	    },
	    table_row: {
	      content: '(table_cell | table_header)*',
	      tableRole: 'row',
	      attrs: {
	        dataRowDiffId: {
	          default: null
	        }
	      },
	      parseDOM: [{
	        tag: 'tr',
	
	        getAttrs: function getAttrs(dom) {
	          var dataRowDiffId = dom.getAttribute('data-row-diff-id');
	          return {
	            dataRowDiffId: dataRowDiffId
	          };
	        }
	      }],
	
	      toDOM: function toDOM(dom) {
	        var attrs = {};
	        var dataRowDiffId = dom.attrs.dataRowDiffId;
	
	        attrs['data-row-diff-id'] = dataRowDiffId || 'ct-tr-diff-id-' + uuid();
	        return ['tr', attrs, 0];
	      }
	    },
	    table_cell: {
	      content: 'block+',
	      attrs: cellAttrs,
	      tableRole: 'cell',
	      isolating: true,
	      parseDOM: [{
	        tag: 'td',
	
	        getAttrs: function getAttrs(dom) {
	          return getCellAttrs(dom);
	        }
	      }],
	
	      toDOM: function toDOM(node) {
	        return ['td', setCellAttrs(node), 0];
	      }
	    },
	    table_header: {
	      content: 'block+',
	      attrs: cellAttrs,
	      tableRole: 'header_cell',
	      isolating: true,
	      parseDOM: [{
	        tag: 'th',
	
	        getAttrs: function getAttrs(dom) {
	          return getCellAttrs(dom);
	        }
	      }],
	
	      toDOM: function toDOM(node) {
	        return ['th', setCellAttrs(node), 0];
	      }
	    }
	  }
	};
	
	var dfsTable = function dfsTable(content, nodeTypes, depth) {
	  var table = nodeTypes.table;
	
	
	  for (var i = 0; i < content.length; i++) {
	    var node = content[i];
	
	    if (node.type === table) {
	      processTable(node, nodeTypes);
	    } else if (depth < 3) {
	      var nodeContent = node.content.content;
	
	      if (nodeContent.length > 0) {
	        dfsTable(nodeContent, nodeTypes, depth + 1);
	      }
	    }
	  }
	};
	
	var processCell = function processCell(sliceNode, tableNode, rowNode, cellNode, table_cell, table_header) {
	  var hasRowHeader = false;
	  var hasColHeader = false;
	  var rowNodes = tableNode.content.content;
	  var cellNodes = rowNode.content.content;
	  var rowIndex = rowNodes.indexOf(rowNode);
	  var colIndex = cellNodes.indexOf(cellNode);
	  var sliceContent = sliceNode.content.content;
	
	  if (cellNode.type === table_header) {
	    if (colIndex === cellNodes.length - 1) {
	      hasRowHeader = true;
	    } else {
	      var cell = cellNodes[colIndex + 1];
	      if (cell && cell.type === table_header) hasRowHeader = true;
	    }
	
	    if (rowIndex === rowNodes.length - 1) {
	      hasColHeader = true;
	    } else {
	      var _cell3 = rowNodes[rowIndex + 1].content.content[colIndex];
	      if (_cell3 && _cell3.type === table_header) hasColHeader = true;
	    }
	  }
	
	  var type = hasRowHeader ? table_header : table_cell;
	  var rowContent = sliceContent[0].content.content;
	
	  for (var j = 0; j < rowContent.length; j++) {
	    var _cell4 = rowContent[j];
	    var cellContent = _cell4.content.content;
	
	    if (_cell4.type !== type) {
	      rowContent[j] = type.create(_cell4.attrs, cellContent, _cell4.marks);
	    }
	  }
	
	  type = hasColHeader ? table_header : table_cell;
	
	  for (var i = 0; i < sliceContent.length; i++) {
	    var _rowContent = sliceContent[i].content.content;
	    var _cell5 = _rowContent[0];
	
	    if (_cell5 && _cell5.type !== type && !(type !== table_header && i === 0)) {
	      var _cellContent = _cell5.content.content;
	      _rowContent[0] = type.create(_cell5.attrs, _cellContent, _cell5.marks);
	    }
	  }
	};
	
	var processTable = function processTable(tableNode, nodeTypes) {
	  var table = nodeTypes.table,
	      table_cell = nodeTypes.table_cell,
	      table_header = nodeTypes.table_header,
	      paragraph = nodeTypes.paragraph;
	
	  var tableContent = tableNode.content.content;
	
	  var _getHasColHeader6 = getHasColHeader(tableContent, table_header),
	      headerCol = _getHasColHeader6.headerCol;
	
	  var firstRowContent = tableContent[0].content.content;
	
	  for (var j = 0; j < firstRowContent.length; j++) {
	    var cell = firstRowContent[j];
	    var cellContent = cell.content.content;
	    var isEmpty = cellContent.length <= 0;
	
	    if (!isEmpty) {
	      for (var k = 0; k < cellContent.length; k++) {
	        if (cellContent[k].type === table) {
	          processTable(cellContent[k], nodeTypes);
	        }
	      }
	    } else {
	      cellContent = paragraph.create();
	    }
	
	    firstRowContent[j] = cell.type.create(cell.attrs, cellContent, cell.marks);
	  }
	
	  for (var i = 0; i < tableContent.length; i++) {
	    var rowContent = tableContent[i].content.content;
	
	    for (var _j2 = 0; _j2 < rowContent.length; _j2++) {
	      var _cell6 = rowContent[_j2];
	      var _cellContent2 = _cell6.content.content;
	      var _isEmpty = _cellContent2.length <= 0;
	
	      if (!_isEmpty) {
	        for (var _k = 0; _k < _cellContent2.length; _k++) {
	          if (_cellContent2[_k].type === table) {
	            processTable(_cellContent2[_k], nodeTypes);
	          }
	        }
	      } else {
	        _cellContent2 = paragraph.create();
	      }
	
	      if (_cell6.type === table_header && i > 0 && _j2 !== headerCol || _isEmpty) {
	        rowContent[_j2] = table_cell.create(objectSpread({}, _cell6.attrs, {
	          bgColor: '#f6f6f6'
	        }), _cellContent2, _cell6.marks);
	      }
	    }
	  }
	};
	
	function pastedCells(slice) {
	  if (!slice.size) return null;
	  var content = slice.content,
	      openStart = slice.openStart,
	      openEnd = slice.openEnd;
	
	
	  while (content.childCount === 1 && (openStart > 0 && openEnd > 0 || content.firstChild.type.spec.tableRole === 'table')) {
	    openStart--;
	    openEnd--;
	    content = content.firstChild.content;
	  }
	
	  var first = content.firstChild,
	      role = first.type.spec.tableRole;
	  var schema = first.type.schema,
	      rows = [];
	  var table_row = schema.nodes.table_row;
	
	  if (role === 'row') {
	    for (var i = 0; i < content.childCount; i++) {
	      var cells = content.child(i).content;
	      var left = i ? 0 : Math.max(0, openStart - 1);
	      var right = i < content.childCount - 1 ? 0 : Math.max(0, openEnd - 1);
	      if (left || right) cells = fitSlice(table_row, new prosemirrorModel.Slice(cells, left, right)).content;
	      rows.push(cells);
	    }
	  } else if (role === 'cell' || role === 'header_cell') {
	    rows.push(openStart || openEnd ? fitSlice(table_row, new prosemirrorModel.Slice(content, openStart, openEnd)).content : content);
	  } else {
	    return null;
	  }
	
	  rows.forEach(function (row) {
	    var rowContent = row.content;
	    rowContent.forEach(function (cell, i) {
	      if (cell.attrs.numCell) rowContent[i] = cell.type.create(objectSpread({}, cell.attrs, {
	        numCell: false
	      }), cell.content);
	    });
	  });
	  return ensureRectangular(schema, rows);
	}
	
	function ensureRectangular(schema, rows) {
	  var table_cell = schema.nodes.table_cell;
	
	  var widths = [];
	
	  for (var i = 0; i < rows.length; i++) {
	    var row = rows[i];
	
	    for (var j = row.childCount - 1; j >= 0; j--) {
	      var _row$child$attrs2 = row.child(j).attrs,
	          rowspan = _row$child$attrs2.rowspan,
	          colspan = _row$child$attrs2.colspan;
	
	
	      for (var r = i; r < i + rowspan; r++) {
	        widths[r] = (widths[r] || 0) + colspan;
	      }
	    }
	  }
	
	  var width = 0;
	
	  for (var _r = 0; _r < widths.length; _r++) {
	    width = Math.max(width, widths[_r]);
	  }for (var _r2 = 0; _r2 < widths.length; _r2++) {
	    if (_r2 >= rows.length) rows.push(prosemirrorModel.Fragment.empty);
	
	    if (widths[_r2] < width) {
	      var empty = table_cell.createAndFill(),
	          cells = [];
	
	      for (var _i7 = widths[_r2]; _i7 < width; _i7++) {
	        cells.push(empty);
	      }rows[_r2] = rows[_r2].append(prosemirrorModel.Fragment.from(cells));
	    }
	  }
	
	  return {
	    height: rows.length,
	    width: width,
	    rows: rows
	  };
	}
	
	function fitSlice(nodeType, slice) {
	  var node = nodeType.createAndFill();
	  var tr = new prosemirrorTransform.Transform(node).replace(0, node.content.size, slice);
	  return tr.doc;
	}
	
	function clipCells(_ref13, newWidth, newHeight) {
	  var width = _ref13.width,
	      height = _ref13.height,
	      rows = _ref13.rows;
	
	  if (width != newWidth) {
	    var added = [],
	        newRows = [];
	
	    for (var row = 0; row < rows.length; row++) {
	      var frag = rows[row],
	          cells = [];
	
	      for (var col = added[row] || 0, i = 0; col < newWidth; i++) {
	        var cell = frag.child(i % frag.childCount);
	
	        if (col + cell.attrs.colspan > newWidth) {
	          cell = cell.type.create(rmColspan(cell.attrs, cell.attrs.colspan, col + cell.attrs.colspan - newWidth), cell.content);
	        }
	
	        cells.push(cell);
	        col += cell.attrs.colspan;
	
	        for (var j = 1; j < cell.attrs.rowspan; j++) {
	          added[row + j] = (added[row + j] || 0) + cell.attrs.colspan;
	        }
	      }
	
	      newRows.push(prosemirrorModel.Fragment.from(cells));
	    }
	
	    rows = newRows;
	    width = newWidth;
	  }
	
	  if (height != newHeight) {
	    var _newRows = [];
	
	    for (var _row2 = 0, _i8 = 0; _row2 < newHeight; _row2++, _i8++) {
	      var _cells = [],
	          source = rows[_i8 % height];
	
	      for (var _j3 = 0; _j3 < source.childCount; _j3++) {
	        var _cell7 = source.child(_j3);
	
	        if (_row2 + _cell7.attrs.rowspan > newHeight) {
	          _cell7 = _cell7.type.create(setAttr(_cell7.attrs, 'rowspan', newHeight - _cell7.attrs.rowspan), _cell7.content);
	        }
	
	        _cells.push(_cell7);
	      }
	
	      _newRows.push(prosemirrorModel.Fragment.from(_cells));
	    }
	
	    rows = _newRows;
	    height = newHeight;
	  }
	
	  return {
	    width: width,
	    height: height,
	    rows: rows
	  };
	}
	
	function growTable(tr, map, table, start, width, height, mapFrom) {
	  var schema = tr.doc.type.schema,
	      empty = void 0,
	      emptyHead = void 0;
	  var _schema$nodes12 = schema.nodes,
	      table_cell = _schema$nodes12.table_cell,
	      table_header = _schema$nodes12.table_header,
	      table_row = _schema$nodes12.table_row;
	
	
	  if (width > map.width) {
	    for (var row = 0, rowEnd = 0; row < map.height; row++) {
	      var rowNode = table.child(row);
	      rowEnd += rowNode.nodeSize;
	      var cells = [],
	          add = void 0;
	
	      if (rowNode.lastChild === null || rowNode.lastChild.type === table_cell) {
	        add = empty || (empty = table_cell.createAndFill());
	      } else {
	        add = emptyHead || (emptyHead = table_header.createAndFill());
	      }
	
	      for (var i = map.width; i < width; i++) {
	        cells.push(add);
	      }tr.insert(tr.mapping.slice(mapFrom).map(rowEnd - 1 + start), cells);
	    }
	  }
	
	  if (height > map.height) {
	    var _cells2 = [];
	
	    for (var _i9 = 0, _start = (map.height - 1) * map.width; _i9 < Math.max(map.width, width); _i9++) {
	      var cell = void 0;
	
	      if (_i9 >= map.width) {
	        cell = table_cell.createAndFill();
	      } else {
	        var mapCell = table.nodeAt(map.map[_start + _i9]);
	        var header = _i9 >= map.width ? false : mapCell.type === table_header;
	        cell = header ? table_header.createAndFill({
	          numCell: mapCell.attrs.numCell
	        }) : table_cell.createAndFill({
	          numCell: mapCell.attrs.numCell
	        });
	      }
	
	      _cells2.push(cell);
	    }
	
	    var emptyRow = table_row.create(null, prosemirrorModel.Fragment.from(_cells2)),
	        rows = [];
	
	    for (var _i10 = map.height; _i10 < height; _i10++) {
	      rows.push(emptyRow);
	    }tr.insert(tr.mapping.slice(mapFrom).map(start + table.nodeSize - 2), rows);
	    return true;
	  }
	
	  return !!(empty || emptyHead);
	}
	
	function isolateHorizontal(tr, map, table, start, left, right, top, mapFrom) {
	  if (top === 0 || top === map.height) return false;
	  var found = false;
	
	  for (var col = left; col < right; col++) {
	    var index = top * map.width + col,
	        pos = map.map[index];
	
	    if (map.map[index - map.width] === pos) {
	      found = true;
	      var cell = table.nodeAt(pos);
	
	      var _map$findCell = map.findCell(pos),
	          cellTop = _map$findCell.top,
	          cellLeft = _map$findCell.left;
	
	      tr.setNodeMarkup(tr.mapping.slice(mapFrom).map(pos + start), null, setAttr(cell.attrs, 'rowspan', top - cellTop));
	      tr.insert(tr.mapping.slice(mapFrom).map(map.positionAt(top, cellLeft, table)), cell.type.createAndFill(setAttr(cell.attrs, 'rowspan', cellTop + cell.attrs.rowspan - top)));
	      col += cell.attrs.colspan - 1;
	    }
	  }
	
	  return found;
	}
	
	function isolateVertical(tr, map, table, start, top, bottom, left, mapFrom) {
	  if (left === 0 || left === map.width) return false;
	  var found = false;
	
	  for (var row = top; row < bottom; row++) {
	    var index = row * map.width + left,
	        pos = map.map[index];
	
	    if (map.map[index - 1] === pos) {
	      found = true;
	      var cell = table.nodeAt(pos),
	          cellLeft = map.colCount(pos);
	      var updatePos = tr.mapping.slice(mapFrom).map(pos + start);
	      tr.setNodeMarkup(updatePos, null, rmColspan(cell.attrs, left - cellLeft, cell.attrs.colspan - (left - cellLeft)));
	      tr.insert(updatePos + cell.nodeSize, cell.type.createAndFill(rmColspan(cell.attrs, 0, left - cellLeft)));
	      row += cell.attrs.rowspan - 1;
	    }
	  }
	
	  return found;
	}
	
	function insertCells(state, dispatch, tableStart, rect, cells, store) {
	  var table = tableStart ? state.doc.nodeAt(tableStart - 1) : state.doc;
	  var map = TableMap.get(table);
	  var top = rect.top,
	      left = rect.left;
	
	  var right = left + cells.width;
	  var bottom = top + cells.height;
	  var tr = state.tr;
	  var mapFrom = 0;
	  var hasExtraWidth = false;
	  var initMap = map;
	
	  function recomp() {
	    table = tableStart ? tr.doc.nodeAt(tableStart - 1) : tr.doc;
	
	    if (!table) {
	      store.emitTableError('不能仅改变合并单元格的一部分');
	
	      return false;
	    }
	
	    map = TableMap.get(table);
	    mapFrom = tr.mapping.maps.length;
	    return true;
	  }
	
	  if (growTable(tr, map, table, tableStart, right, bottom, mapFrom)) {
	    if (!recomp()) {
	      return;
	    }
	  }
	
	  if (isolateHorizontal(tr, map, table, tableStart, left, right, top, mapFrom)) {
	    hasExtraWidth = true;
	
	    if (!recomp()) {
	      return;
	    }
	  }
	
	  if (isolateHorizontal(tr, map, table, tableStart, left, right, bottom, mapFrom)) {
	    hasExtraWidth = true;
	
	    if (!recomp()) {
	      return;
	    }
	  }
	
	  if (isolateVertical(tr, map, table, tableStart, top, bottom, left, mapFrom)) {
	    if (!recomp()) {
	      return;
	    }
	  }
	
	  if (isolateVertical(tr, map, table, tableStart, top, bottom, right, mapFrom)) {
	    if (!recomp()) {
	      return;
	    }
	  }
	
	  if (map.width - initMap.width > 0 && hasExtraWidth) {
	    store.emitTableError('不能仅改变合并单元格的一部分');
	    return;
	  }
	
	  var count = 0;
	
	  var _loop = function _loop(row) {
	    var from = map.positionAt(row, left, table);
	    var to = map.positionAt(row, right, table);
	    var slice = new prosemirrorModel.Slice(cells.rows[row - top], 1, 1);
	    var ids = [];
	    tr.doc.nodesBetween(from + tableStart + count, to + tableStart + count, function (node) {
	      if (['table_cell', 'table_header'].includes(node.type.name) && node.attrs.dataCellDiffId) {
	        ids.push(node.attrs.dataCellDiffId);
	      }
	    });
	    count += 4;
	
	    if (slice.size > 0) {
	      slice.content.content.forEach(function (p, index) {
	        p.attrs.dataCellDiffId = ids[index] || p.attrs.dataCellDiffId;
	      });
	      tr.replace(tr.mapping.slice(mapFrom).map(from + tableStart), tr.mapping.slice(mapFrom).map(to + tableStart), slice);
	    } else {
	      tr.delete(tr.mapping.slice(mapFrom).map(from + tableStart), tr.mapping.slice(mapFrom).map(to + tableStart));
	    }
	  };
	
	  for (var row = top; row < bottom; row++) {
	    _loop(row);
	  }
	
	  if (map.width - initMap.width === 0 && !hasExtraWidth) {
	    recomp();
	    var cellCount = 0;
	    cells.rows.forEach(function (f) {
	      return cellCount += f.childCount;
	    });
	
	    if (cellCount === 1) {
	      tr.setSelection(new CellSelection(tr.doc.resolve(tableStart + map.positionAt(top, left, table))));
	    } else {
	      tr.setSelection(new CellSelection(tr.doc.resolve(tableStart + map.positionAt(top, left, table)), tr.doc.resolve(tableStart + map.positionAt(bottom - 1, right - 1, table))));
	    }
	  }
	
	  var cellNode = tr.selection.$from.node(-1);
	
	  if (cellNode.attrs.numCell === true) {
	    tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, tr.selection.from - 6));
	  }
	
	  dispatch(tr);
	}
	
	var transformPasted = function transformPasted(store) {
	  return function (slice) {
	    var state = store.view.state;
	    var schema = state.schema,
	        selection = state.selection;
	    var _schema$nodes13 = schema.nodes,
	        table = _schema$nodes13.table,
	        table_row = _schema$nodes13.table_row,
	        table_cell = _schema$nodes13.table_cell,
	        table_header = _schema$nodes13.table_header;
	
	    var sliceContent = slice.content.content;
	    var sliceNode = sliceContent.length === 1 ? sliceContent[0] : null;
	
	    if (sliceNode) {
	      if (sliceNode.type !== table && selection instanceof CellSelection) {
	        var cellNode = table_cell.create({
	          colwidth: [68]
	        }, sliceNode);
	        var rowNode = table_row.create(null, prosemirrorModel.Fragment.from(cellNode));
	        sliceNode = table.create(null, prosemirrorModel.Fragment.from(rowNode));
	        sliceContent[0] = sliceNode;
	      }
	
	      if (sliceNode.type === table) {
	        var $from = selection.$from;
	
	
	        if (selection instanceof CellSelection) {
	          var minPos = Infinity;
	          selection.ranges.forEach(function (range) {
	            var pos = range.$from.pos;
	
	            if (pos < minPos) {
	              minPos = pos;
	              $from = range.$from;
	            }
	          });
	        }
	
	        var foundTable = index_js.findParentNode($from.path, function (node) {
	          return node.type === table;
	        });
	
	        if (foundTable) {
	          var tableNode = foundTable.node;
	          var _rowNode2 = index_js.findParentNode($from.path, function (node) {
	            return node.type === table_row;
	          }).node;
	          var _cellNode = index_js.findParentNode($from.path, function (node) {
	            return [table_cell, table_header].includes(node.type);
	          }).node;
	          processCell(sliceNode, tableNode, _rowNode2, _cellNode, table_cell, table_header);
	        } else {
	          slice.openStart = 0;
	          slice.openEnd = 0;
	        }
	      } else if (sliceNode.type.isAtom) {
	        slice.openStart = 0;
	        slice.openEnd = 0;
	      }
	    }
	
	    dfsTable(sliceContent, schema.nodes, 0);
	    return slice;
	  };
	};
	
	var css$6 = ".ct-editor-popover{display:none;position:fixed;top:auto;left:auto;right:auto;bottom:auto;z-index:19;background:#fff;box-shadow:0 4px 16px 0 rgba(106,93,73,.2),0 8px 20px 0 rgba(106,93,73,.1);border-radius:1px;opacity:1;transition:opacity .2s ease}div.ct-table-headerbar-popover{box-shadow:none;border-radius:none;background:transparent;z-index:99}div.ct-table-scrollbar-popover{z-index:19}div.ct-table-all-selectbar-popover,div.ct-table-col-selectbar-popover,div.ct-table-row-selectbar-popover{z-index:2;box-shadow:none;background:transparent}div.ct-table-all-selectbar-popover{z-index:3;width:18px;height:18px}div.ct-table-row-selectbar-popover{width:26px}div.ct-table-col-selectbar-popover{height:26px;pointer-events:none}";
	styleInject(css$6);
	
	var Popover$1 = function () {
	  function Popover$1(view, store) {
	    (0, _classCallCheck3.default)(this, Popover$1);
	
	    this.store = store;
	    var viewParentNode = view.dom.parentNode;
	    this.scrollBarPopover = document.createElement('div');
	    this.scrollBarPopover.className = 'ct-table-scrollbar-popover ct-editor-popover';
	    this.headerBarPopover = document.createElement('div');
	    this.headerBarPopover.className = 'ct-table-headerbar-popover ct-editor-popover';
	    this.rowSelectBarPopover = document.createElement('div');
	    this.rowSelectBarPopover.className = 'ct-table-row-selectbar-popover ct-editor-popover';
	    this.colSelectBarPopover = document.createElement('div');
	    this.colSelectBarPopover.className = 'ct-table-col-selectbar-popover ct-editor-popover';
	    this.allSelectBarPopover = document.createElement('div');
	    this.allSelectBarPopover.className = 'ct-table-all-selectbar-popover ct-editor-popover';
	    this.modalPopover = document.createElement('div');
	    this.modalPopover.className = 'ct-table-modal-popover ct-editor-popover';
	
	    if (viewParentNode) {
	      viewParentNode.appendChild(this.scrollBarPopover);
	      viewParentNode.appendChild(this.headerBarPopover);
	      viewParentNode.appendChild(this.rowSelectBarPopover);
	      viewParentNode.appendChild(this.colSelectBarPopover);
	      viewParentNode.appendChild(this.allSelectBarPopover);
	      viewParentNode.appendChild(this.modalPopover);
	      this.store.onCreatePopover(this.scrollBarPopover, this.headerBarPopover, this.rowSelectBarPopover, this.colSelectBarPopover, this.allSelectBarPopover, this.modalPopover);
	    }
	
	    if (this.store.editor) {
	      this.store.init(this.store.editor);
	    }
	  }
	
	  (0, _createClass3.default)(Popover$1, [{
	    key: 'destroy',
	    value: function destroy() {
	      this.allSelectBarPopover.remove();
	      this.scrollBarPopover.remove();
	      this.headerBarPopover.remove();
	      this.rowSelectBarPopover.remove();
	      this.colSelectBarPopover.remove();
	      this.modalPopover.remove();
	      this.store.onRemovePopover();
	    }
	  }, {
	    key: 'update',
	    value: function update(view) {
	      if (!this.store.isShowPopover) return;
	      var selection = view.state.selection;
	
	      if (isAllCellSelection(selection)) {
	        var foundNode = index_js.findParentNode(selection.$from.path, function (item) {
	          return item.type && item.type.name === 'table';
	        });
	        var tableDOM = view.docView.domFromPos(foundNode.pos + 1).node;
	        if (tableDOM.tagName.toUpperCase() !== 'TABLE') tableDOM = tableDOM.parentNode;
	        this.store.showPopover(tableDOM);
	      }
	    }
	  }]);
	  return Popover$1;
	}();
	
	var handleMouseEvent = function handleMouseEvent(store, view, e) {
	  var target = e.target;
	
	  var domAssert = function domAssert(dom) {
	    return dom.tagName.toUpperCase() === 'TABLE';
	  };
	
	  var dom = index_js.findParentDOM(target, domAssert);
	
	  if (dom) {
	    store.showPopover(dom);
	    setTimeout(function () {
	      store.countSelected();
	      store.showSelectBar();
	    }, 1);
	  } else if (store.isShowPopover) {
	    store.hidePopover();
	  }
	};
	
	var handleKeyEvent = function handleKeyEvent(store, view) {
	  var _view$state = view.state,
	      schema = _view$state.schema,
	      selection = _view$state.selection;
	  var $from = selection.$from;
	
	  var table = schema.nodes.table;
	  var foundNode = index_js.findParentNode($from.path, function (node) {
	    return node.type === table;
	  });
	
	  if (foundNode) {
	    var tableDOM = view.docView.domFromPos(foundNode.pos + 1).node;
	    if (tableDOM.tagName.toUpperCase() !== 'TABLE') tableDOM = tableDOM.parentNode;
	    store.showPopover(tableDOM);
	  } else if (store.isShowPopover) {
	    store.hidePopover();
	  }
	};
	
	function createPlugin(store) {
	  var pluginKey = new prosemirrorState.PluginKey('table');
	  return new prosemirrorState.Plugin({
	    key: pluginKey,
	    state: {
	      init: function init() {
	        return 0;
	      },
	      apply: function apply(tr, value, oldState, newState) {
	        var selection = newState.selection;
	
	
	        if (isAllCellSelection(selection)) {
	          store.isShowPopover = true;
	        }
	
	        store.checkGlobalTabel();
	      }
	    },
	    props: {
	      decorations: function decorations(state) {
	        var selection = state.selection;
	        var $from = selection.$from;
	
	
	        if (selection instanceof CellSelection) {
	          store.handleCellSelected(selection);
	
	          var rows = selection.content().content.content;
	          var rowsLen = rows.length;
	          var topBorderCells = rows[0].content.content;
	          var bottomBorderCells = [];
	          var leftBorderCells = [];
	          var rightBorderCells = [];
	          var ignoreLeftRow = [];
	          rows.forEach(function (row, i) {
	            var cells = row.content.content;
	            var cellsLen = cells.length;
	            cells.forEach(function (cell, j) {
	              if (i === rowsLen - 1 || i + cell.attrs.rowspan === rowsLen) {
	                bottomBorderCells.push(cell);
	              }
	
	              if (j === 0 && !ignoreLeftRow.includes(i)) {
	                leftBorderCells.push(cell);
	                var rowspan = cell.attrs.rowspan - 1;
	
	                while (rowspan > 0) {
	                  ignoreLeftRow.push(i + rowspan);
	                  rowspan--;
	                }
	              }
	
	              if (j === cellsLen - 1 && !rightBorderCells.some(function (borderCell) {
	                return borderCell.rowspan + borderCell.row > i;
	              })) {
	                rightBorderCells.push({
	                  cell: cell,
	                  row: i,
	                  rowspan: cell.attrs.rowspan
	                });
	              }
	            });
	          });
	          var borderCells = [];
	          selection.forEachCell(function (node, pos) {
	            var className = '';
	            if (topBorderCells.includes(node)) className += ' top';
	            if (bottomBorderCells.includes(node)) className += ' bottom';
	            if (leftBorderCells.includes(node)) className += ' left';
	            if (rightBorderCells.some(function (borderCell) {
	              return borderCell.cell === node;
	            })) className += ' right';
	            if (className !== '') borderCells.push(prosemirrorView.Decoration.node(pos, pos + node.nodeSize, {
	              class: className.trim()
	            }));
	          });
	          return prosemirrorView.DecorationSet.create(state.doc, borderCells);
	        }
	
	        var table = index_js.findParentNode($from.path, function (item) {
	          return item.type && item.type.name === "table";
	        });
	
	        if (table) {
	          var attrs = {
	            class: "ct-table-show"
	          };
	          var deco = prosemirrorView.Decoration.node(table.pos, table.pos + table.node.nodeSize, attrs);
	          return prosemirrorView.DecorationSet.create(state.doc, [deco]);
	        }
	
	        store.handleCellSelected(null);
	        return null;
	      },
	      handleClick: function handleClick(view, pos) {
	        var _view$state2 = view.state,
	            tr = _view$state2.tr,
	            schema = _view$state2.schema,
	            doc = _view$state2.doc,
	            selection = _view$state2.selection;
	
	
	        if (selection instanceof CellSelection) {
	          var _schema$nodes14 = schema.nodes,
	              table_header = _schema$nodes14.table_header,
	              table_cell = _schema$nodes14.table_cell;
	
	          var cellTypes = [table_header, table_cell];
	          var foundNode = index_js.findParentNode(selection.$from.path, function (node) {
	            return cellTypes.includes(node.type);
	          });
	          if (!foundNode) return false;
	          view.dispatch(tr.setSelection(prosemirrorState.TextSelection.create(doc, pos)));
	        }
	      },
	      handlePaste: function handlePaste(view) {
	        setTimeout(function () {
	          return triggerTableCellToDOM(view);
	        }, 0);
	      },
	      transformPasted: transformPasted(store),
	      afterPasted: triggerTableCellToDOM,
	      afterDrop: function afterDrop(view, pos) {
	        triggerTableCellToDOM(view);
	
	        if (pos === 0) store.$scroll.scrollTop = 0;
	        handleKeyEvent(store, view);
	      },
	      handleDOMEvents: {
	        drop: function drop(view) {
	          store.hidePopover();
	          setTimeout(function () {
	            return triggerTableCellToDOM(view);
	          }, 0);
	        },
	        mousedown: function mousedown(view, e) {
	          return handleMouseEvent(store, view, e);
	        },
	        contextmenu: function contextmenu(view, e) {
	          return handleMouseEvent(store, view, e);
	        },
	        keyup: function keyup(view) {
	          return handleKeyEvent(store, view);
	        },
	        keydown: function keydown() {
	          return store.reShowPopover();
	        },
	        cut: function cut(view) {
	          var selection = view.state.selection;
	
	
	          if (selection instanceof CellSelection) {
	            if (isAllCellSelection(selection)) {
	              var $anchorCell = selection.$anchorCell;
	
	              var tablePos = $anchorCell.before(-1);
	              store.hidePopover();
	              setTimeout(function () {
	                var dispatch = view.dispatch,
	                    _view$state3 = view.state,
	                    doc = _view$state3.doc,
	                    tr = _view$state3.tr;
	
	                var tableSize = doc.nodeAt(tablePos).nodeSize;
	                var selection = prosemirrorState.TextSelection.create(doc, tablePos, tablePos + tableSize);
	                dispatch(tr.setSelection(selection).deleteSelection());
	              }, 0);
	            }
	          }
	        }
	      }
	    },
	
	    view: function view(editorView) {
	      return new Popover$1(editorView, store);
	    }
	  });
	}
	
	function isInList(state) {
	  if (!state) return false;
	  var _state$selection = state.selection,
	      $from = _state$selection.$from,
	      $to = _state$selection.$to;
	
	  var range = $from.blockRange($to);
	  if (!range) return false;
	  var _state$schema$nodes = state.schema.nodes,
	      bullet_list = _state$schema$nodes.bullet_list,
	      ordered_list = _state$schema$nodes.ordered_list,
	      task_list = _state$schema$nodes.task_list;
	
	  var listTypes = [bullet_list, ordered_list, task_list];
	  var depth0Node = $from.node(range.depth);
	  var depth1Node = $from.node(range.depth - 1);
	  var depth1NodeType = depth1Node && depth1Node.type;
	  var depth0NodeType = depth0Node && depth0Node.type;
	  return listTypes.some(function (type) {
	    return type === depth1NodeType || type === depth0NodeType;
	  });
	}
	
	var goToNextCell1 = goToNextCell(1);
	var goToPreCell = goToNextCell(-1);
	
	function handleTab(store) {
	  return function (state, dispatch, view) {
	    var selection = state.selection,
	        schema = state.schema;
	
	    if (isInList(state)) return false;
	    if (increaseIndent()(state, dispatch, view)) return true;
	    if (!isInTable(state)) return false;
	    if (goToNextCell1(state, dispatch, view)) return true;
	    var _schema$nodes15 = schema.nodes,
	        table_cell = _schema$nodes15.table_cell,
	        table_header = _schema$nodes15.table_header;
	
	    var cellTypes = [table_cell, table_header];
	    var rect = selectedRect(state);
	    if (!rect) return false;
	    var transaction = addRow(state.tr, rect, rect.bottom);
	    var foundNode = index_js.findParentNode(selection.$from.path, function (node) {
	      return cellTypes.includes(node.type);
	    });
	    transaction = transaction.setSelection(prosemirrorState.TextSelection.create(transaction.doc, foundNode.pos + foundNode.node.nodeSize + 3));
	    dispatch(transaction);
	    return true;
	  };
	}
	
	function handleShiftTab(store) {
	  return function (state, dispatch, view) {
	    if (isInList(state)) return false;
	    if (reduceIndent()(state, dispatch, view)) return true;
	    if (!isInTable(state)) return false;
	    return goToPreCell(state, dispatch, view);
	  };
	}
	
	function handleBackspace(store) {
	  return function (state, dispatch, view) {
	    var tr = state.tr,
	        selection = state.selection,
	        schema = state.schema;
	    var _schema$nodes16 = schema.nodes,
	        table_cell = _schema$nodes16.table_cell,
	        table_header = _schema$nodes16.table_header;
	    var $from = selection.$from,
	        $to = selection.$to,
	        from = selection.from,
	        to = selection.to;
	
	    var cellTypes = [table_cell, table_header];
	
	    if (selection instanceof CellSelection) {
	      store.hidePopover();
	
	      if (deleteWholeTable(selection, tr, dispatch)) {
	        return true;
	      }
	
	      store.showPopover();
	    }
	
	    var foundNode = index_js.findParentNode($from.path, function (node) {
	      return cellTypes.includes(node.type);
	    });
	    if (!foundNode) return false;
	
	    if (selection instanceof index_js$2.GapCursor && $from.parentOffset === 0) {
	      if (from - foundNode.pos > 2) {
	        dispatch(tr.delete(from - 2, from));
	      }
	
	      return true;
	    }
	
	    if ($from.parent !== $to.parent && $to.parentOffset === 0) {
	      dispatch(tr.delete(from, to - 4));
	      return true;
	    }
	
	    return false;
	  };
	}
	
	function deleteWholeTable(selection, tr, dispatch) {
	  var $from = selection.$from,
	      $anchorCell = selection.$anchorCell,
	      $headCell = selection.$headCell;
	
	  var tableNode = index_js.findParentNode($from.path, function (item) {
	    return item.type && item.type.name === 'table';
	  }).node;
	
	  if (isAllCellSelection(selection)) {
	    var $firstCell = $anchorCell.pos < $headCell.pos ? $anchorCell : $headCell;
	    var pos = $firstCell.pos - 2;
	    tr.delete(pos, pos + tableNode.nodeSize);
	
	    if (tr.doc.nodeSize > pos + 2) {
	      tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, pos + 1));
	    } else {
	      tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, pos));
	    }
	
	    if (dispatch) {
	      dispatch(tr);
	      return true;
	    }
	
	    return tr;
	  }
	
	  return false;
	}
	
	var handleKeyDown = keymap.keydownHandler({
	  ArrowLeft: arrow('horiz', -1),
	  ArrowRight: arrow('horiz', 1),
	  ArrowUp: arrow('vert', -1),
	  ArrowDown: arrow('vert', 1),
	  'Shift-ArrowLeft': shiftArrow('horiz', -1),
	  'Shift-ArrowRight': shiftArrow('horiz', 1),
	  'Shift-ArrowUp': shiftArrow('vert', -1),
	  'Shift-ArrowDown': shiftArrow('vert', 1),
	  Backspace: deleteCellSelection,
	  'Mod-Backspace': deleteCellSelection,
	  Delete: deleteCellSelection,
	  'Mod-Delete': deleteCellSelection
	});
	
	function arrow(axis, dir) {
	  return function (state, dispatch, view) {
	    var table = state.schema.nodes.table;
	
	    var sel = state.selection;
	
	    if (sel instanceof CellSelection) {
	      dispatch(state.tr.setSelection(prosemirrorState.Selection.near(sel.$headCell, dir)));
	      return true;
	    }
	
	    var foundNode = index_js.findParentNode(sel.$from.path, function (node) {
	      return node.type === table;
	    });
	    if (!foundNode) return false;
	
	    if (axis === 'horiz') {
	      var newPos = sel.head + dir;
	
	      if (foundNode.pos + 4 > newPos) {
	        dispatch(state.tr.setSelection(new index_js$2.GapCursor(state.doc.resolve(foundNode.pos))));
	        return true;
	      }
	    }
	
	    if (axis != 'horiz' && !sel.empty) return false;
	    var end = atEndOfCell(view, axis, dir);
	    if (end == null) return false;
	
	    if (axis === 'horiz') {
	      dispatch(state.tr.setSelection(prosemirrorState.Selection.near(state.doc.resolve(sel.head + dir), dir)));
	      return true;
	    }
	
	    var $cell = state.doc.resolve(end),
	        $next = nextCell($cell, axis, dir),
	        newSel = void 0;
	    if ($next) newSel = prosemirrorState.Selection.near($next, 1);else if (dir < 0) newSel = prosemirrorState.Selection.near(state.doc.resolve($cell.before(-1)), -1);else newSel = prosemirrorState.Selection.near(state.doc.resolve($cell.after(-1)), 1);
	    dispatch(state.tr.setSelection(newSel));
	    return true;
	  };
	}
	
	function shiftArrow(axis, dir) {
	  return function (state, dispatch, view) {
	    var sel = state.selection;
	
	    if (!(sel instanceof CellSelection)) {
	      var end = atEndOfCell(view, axis, dir);
	      if (end == null) return false;
	      sel = new CellSelection(state.doc.resolve(end));
	    }
	
	    var $head = nextCell(sel.$headCell, axis, dir);
	    if (!$head) return false;
	    if (dispatch) dispatch(state.tr.setSelection(new CellSelection(sel.$anchorCell, $head)));
	    return true;
	  };
	}
	
	function deleteCellSelection(state, dispatch) {
	  var sel = state.selection;
	  if (!(sel instanceof CellSelection)) return false;
	
	  if (dispatch) {
	    var tr = state.tr,
	        baseContent = state.schema.nodes.table_cell.createAndFill().content;
	    sel.forEachCell(function (cell, pos) {
	      if (!cell.content.eq(baseContent)) {
	        tr.replace(tr.mapping.map(pos + 1), tr.mapping.map(pos + cell.nodeSize - 1), new prosemirrorModel.Slice(baseContent, 0, 0));
	      }
	    });
	    if (tr.docChanged) dispatch(tr);
	  }
	
	  return true;
	}
	
	function handleTripleClick(view, pos) {
	  var doc = view.state.doc,
	      $cell = cellAround(doc.resolve(pos));
	  if (!$cell) return false;
	  view.dispatch(view.state.tr.setSelection(new CellSelection($cell)));
	  return true;
	}
	function _handlePaste(view, _, slice, store) {
	  if (!isInTable(view.state)) return false;
	  var cells = pastedCells(slice),
	      sel = view.state.selection;
	
	  if (sel instanceof CellSelection) {
	    if (!cells) cells = {
	      width: 1,
	      height: 1,
	      rows: [prosemirrorModel.Fragment.from(fitSlice(view.state.schema.nodes.table_cell, slice))]
	    };
	    var table = sel.$anchorCell.node(-1),
	        start = sel.$anchorCell.start(-1);
	    var rect = TableMap.get(table).rectBetween(sel.$anchorCell.pos - start, sel.$headCell.pos - start);
	    cells = clipCells(cells, rect.right - rect.left, rect.bottom - rect.top);
	    insertCells(view.state, view.dispatch, start, rect, cells, store);
	    return true;
	  } else if (cells) {
	    var $cell = selectionCell(view.state),
	        _start2 = $cell.start(-1);
	    insertCells(view.state, view.dispatch, _start2, TableMap.get($cell.node(-1)).findCell($cell.pos - _start2), cells, store);
	    return true;
	  }
	
	  return false;
	}
	function handleMouseDown$1(view, startEvent) {
	  if (startEvent.ctrlKey || startEvent.metaKey) return;
	  var startDOMCell = domInCell(view, startEvent.target),
	      $anchor = void 0;
	
	  if (startEvent.shiftKey && view.state.selection instanceof CellSelection) {
	    setCellSelection(view.state.selection.$anchorCell, startEvent);
	    startEvent.preventDefault();
	  } else if (startEvent.shiftKey && startDOMCell && ($anchor = cellAround(view.state.selection.$anchor)) != null && cellUnderMouse(view, startEvent).pos != $anchor.pos) {
	    setCellSelection($anchor, startEvent);
	    startEvent.preventDefault();
	  } else if (!startDOMCell) {
	    return;
	  }
	
	  function setCellSelection($anchor, event) {
	    var $head = cellUnderMouse(view, event);
	    var starting = key.getState(view.state) == null;
	
	    if (!$head || !inSameTable($anchor, $head)) {
	      if (starting) $head = $anchor;else return;
	    }
	
	    var selection = new CellSelection($anchor, $head);
	
	    if (starting || !view.state.selection.eq(selection)) {
	      var tr = view.state.tr.setSelection(selection);
	      if (starting) tr.setMeta(key, $anchor.pos);
	      view.dispatch(tr);
	    }
	  }
	
	  function stop() {
	    view.root.removeEventListener('mouseup', stop);
	    view.root.removeEventListener('dragstart', stop);
	    view.root.removeEventListener('mousemove', move);
	    if (key.getState(view.state) != null) view.dispatch(view.state.tr.setMeta(key, -1));
	  }
	
	  function move(event) {
	    var anchor = key.getState(view.state),
	        $anchor = void 0;
	
	    if (anchor != null) {
	      $anchor = view.state.doc.resolve(anchor);
	    } else if (domInCell(view, event.target) != startDOMCell) {
	      $anchor = cellUnderMouse(view, startEvent);
	      if (!$anchor) return stop();
	    }
	
	    if ($anchor) setCellSelection($anchor, event);
	  }
	
	  view.root.addEventListener('mouseup', stop);
	  view.root.addEventListener('dragstart', stop);
	  view.root.addEventListener('mousemove', move);
	}
	
	function atEndOfCell(view, axis, dir) {
	  if (!(view.state.selection instanceof prosemirrorState.TextSelection)) return null;
	  var $head = view.state.selection.$head;
	
	
	  for (var d = $head.depth - 1; d >= 0; d--) {
	    var parent = $head.node(d),
	        index = dir < 0 ? $head.index(d) : $head.indexAfter(d);
	    if (index != (dir < 0 ? 0 : parent.childCount)) return null;
	
	    if (parent.type.spec.tableRole == 'cell' || parent.type.spec.tableRole == 'header_cell') {
	      var cellPos = $head.before(d);
	      var dirStr = axis == 'vert' ? dir > 0 ? 'down' : 'up' : dir > 0 ? 'right' : 'left';
	      return view.endOfTextblock(dirStr) ? cellPos : null;
	    }
	  }
	
	  return null;
	}
	
	function domInCell(view, dom) {
	  for (; dom && dom != view.dom; dom = dom.parentNode) {
	    if (dom.nodeName == 'TD' || dom.nodeName == 'TH') return dom;
	  }
	}
	
	function cellUnderMouse(view, event) {
	  var mousePos = view.posAtCoords({
	    left: event.clientX,
	    top: event.clientY
	  });
	  if (!mousePos) return null;
	  return mousePos ? cellAround(view.state.doc.resolve(mousePos.pos)) : null;
	}
	
	function changedDescendants(old, cur, offset, f) {
	  var oldSize = old.childCount,
	      curSize = cur.childCount;
	
	  outer: for (var i = 0, j = 0; i < curSize; i++) {
	    var child = cur.child(i);
	
	    for (var scan = j, e = Math.min(oldSize, i + 3); scan < e; scan++) {
	      if (old.child(scan) == child) {
	        j = scan + 1;
	        offset += child.nodeSize;
	        continue outer;
	      }
	    }
	
	    f(child, offset);
	
	    if (j < oldSize && old.child(j).sameMarkup(child)) {
	      changedDescendants(old.child(j), child, offset + 1, f);
	    } else {
	      child.nodesBetween(0, child.content.size, f, offset + 1);
	    }
	
	    offset += child.nodeSize;
	  }
	}
	
	function fixTables(state, oldState) {
	  var tr = void 0,
	      check = function check(node, pos) {
	    if (node.type.spec.tableRole == 'table') tr = fixTable(state, node, pos, tr);
	  };
	
	  if (!oldState) state.doc.descendants(check);else if (oldState.doc != state.doc) changedDescendants(oldState.doc, state.doc, 0, check);
	  return tr;
	}
	
	function fixTable(state, table, tablePos, tr) {
	  var map = TableMap.get(table);
	  if (!map.problems) return tr;
	  if (!tr) tr = state.tr;
	
	  var mustAdd = [];
	
	  for (var i = 0; i < map.height; i++) {
	    mustAdd.push(0);
	  }for (var _i11 = 0; _i11 < map.problems.length; _i11++) {
	    var prob = map.problems[_i11];
	
	    if (prob.type == 'collision') {
	      var cell = table.nodeAt(prob.pos);
	
	      for (var j = 0; j < cell.attrs.rowspan; j++) {
	        mustAdd[prob.row + j] += prob.n;
	      }tr.setNodeMarkup(tr.mapping.map(tablePos + 1 + prob.pos), null, rmColSpan(cell.attrs, cell.attrs.colspan - prob.n, prob.n));
	    } else if (prob.type == 'missing') {
	      mustAdd[prob.row] += prob.n;
	    } else if (prob.type == 'overlong_rowspan') {
	      var _cell8 = table.nodeAt(prob.pos);
	      tr.setNodeMarkup(tr.mapping.map(tablePos + 1 + prob.pos), null, setAttr(_cell8.attrs, 'rowspan', _cell8.attrs.rowspan - prob.n));
	    } else if (prob.type == 'colwidth mismatch') {
	      var _cell9 = table.nodeAt(prob.pos);
	      tr.setNodeMarkup(tr.mapping.map(tablePos + 1 + prob.pos), null, setAttr(_cell9.attrs, 'colwidth', prob.colwidth));
	    }
	  }
	
	  var first = void 0,
	      last = void 0;
	
	  for (var _i12 = 0; _i12 < mustAdd.length; _i12++) {
	    if (mustAdd[_i12]) {
	      if (first == null) first = _i12;
	      last = _i12;
	    }
	  }
	
	  for (var _i13 = 0, pos = tablePos + 1; _i13 < map.height; _i13++) {
	    var end = pos + table.child(_i13).nodeSize;
	    var add = mustAdd[_i13];
	
	    if (add > 0) {
	      var nodes = [];
	
	      for (var _j4 = 0; _j4 < add; _j4++) {
	        nodes.push(state.schema.nodes.table_cell.createAndFill());
	      }
	
	      var side = (_i13 == 0 || first == _i13 - 1) && last == _i13 ? pos + 1 : end - 1;
	      tr.insert(tr.mapping.map(side), nodes);
	    }
	
	    pos = end;
	  }
	
	  return tr;
	}
	
	function tableEditing(store) {
	  return new prosemirrorState.Plugin({
	    key: key,
	
	    state: {
	      init: function init() {
	        return null;
	      },
	      apply: function apply(tr, cur) {
	        var set = tr.getMeta(key);
	        if (set != null) return set === -1 ? null : set;
	        if (cur == null || !tr.docChanged) return cur;
	
	        var _tr$mapping$mapResult = tr.mapping.mapResult(cur),
	            deleted = _tr$mapping$mapResult.deleted,
	            pos = _tr$mapping$mapResult.pos;
	
	        return deleted ? null : pos;
	      }
	    },
	    props: {
	      decorations: drawCellSelection,
	      handleDOMEvents: {
	        mousedown: handleMouseDown$1,
	        input: function input(view, e) {
	          var selection = view.state.selection;
	          var $from = selection.$from;
	
	          var isNumCell = index_js.findParentNode($from.path, function (node) {
	            return node.attrs && node.attrs.numCell;
	          });
	
	          if (isNumCell) {
	            e.preventDefault();
	          }
	        }
	      },
	
	      createSelectionBetween: function createSelectionBetween(view) {
	        if (key.getState(view.state) != null) return view.state.selection;
	      },
	
	
	      handleTripleClick: handleTripleClick,
	      handleKeyDown: handleKeyDown,
	      handlePaste: function handlePaste() {
	        for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
	          args[_key6] = arguments[_key6];
	        }
	
	        return _handlePaste.apply(undefined, args.concat([store]));
	      }
	    },
	
	    appendTransaction: function appendTransaction(_, oldState, state) {
	      return normalizeSelection(state, fixTables(state, oldState));
	    }
	  });
	}
	
	var css$7 = ".ct-table-wrapper{width:100%;overflow-x:auto;overflow-y:hidden;margin:8px 0;padding-bottom:1px;padding-right:1px;counter-reset:cellnumber}.ct-table-wrapper table,.ct-table-wrapper tbody,.ct-table-wrapper td,.ct-table-wrapper th{background-clip:padding-box!important}.ct-table-wrapper table{width:auto;border-collapse:collapse;table-layout:fixed;word-break:break-all;position:relative;overflow:auto;margin-top:15px}.ct-table-wrapper td,.ct-table-wrapper th{box-sizing:border-box;width:auto;min-width:-webkit-fit-content;min-width:-moz-fit-content;min-width:fit-content;padding:1px 8px;border:1px solid #ddd;vertical-align:top;background-color:#fff}.ct-table-wrapper td.overflow,.ct-table-wrapper th.overflow{overflow:hidden;position:relative}.ct-table-wrapper td>ol,.ct-table-wrapper td>ul,.ct-table-wrapper th>ol,.ct-table-wrapper th>ul{overflow:hidden}.ct-table-wrapper th{text-align:left;background-color:#f6f6f6}.ct-table-wrapper td{overflow:hidden}.ct-table-wrapper .num-cell{counter-increment:cellnumber;vertical-align:top;text-align:center;color:#000;padding:8px 0;font-size:12px;-webkit-user-select:none!important;-moz-user-select:none!important;-ms-user-select:none!important;user-select:none!important}.ct-table-wrapper .num-cell:before{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;pointer-events:none;content:counter(cellnumber)}.ct-table-wrapper .num-cell p{display:none}.ct-table-wrapper h1,.ct-table-wrapper h2,.ct-table-wrapper h3,.ct-table-wrapper h4,.ct-table-wrapper h5,.ct-table-wrapper h6,.ct-table-wrapper p{min-width:0;margin-top:8px}.ct-table-wrapper ol,.ct-table-wrapper ul{padding-left:34px}.ct-table-wrapper .ct-image{font-size:1;min-width:32px;max-width:calc(100% - 6px)}.ProseMirror.resize-cursor{cursor:col-resize}.ProseMirror .column-resize-handler{position:absolute;top:0;bottom:-1px;width:2px;right:0;z-index:15;background-color:#adf;pointer-events:none}.column-resize-handler.ProseMirror-widget{background:#3d91f2}table .selectedCell{position:relative}table .selectedCell:after{z-index:2;position:absolute;content:\"\";left:0;right:0;top:0;bottom:0;background-color:rgba(65,194,245,.2);pointer-events:none}table .selectedCell.top:after{border-top:2px solid #1c6cdc}table .selectedCell.bottom:after{border-bottom:2px solid #1c6cdc}table .selectedCell.left:after{border-left:2px solid #1c6cdc}table .selectedCell.right:after{border-right:2px solid #1c6cdc}table[data-borderstyle=dashed]>tbody>tr>td,table[data-borderstyle=dashed]>tbody>tr>th{border-style:dashed}table[data-borderwidth=\"0\"]>tbody>tr>td,table[data-borderwidth=\"0\"]>tbody>tr>th{border:none}table[data-borderwidth=\"1\"] tr:first-child:after{content:\"\"}table[data-borderwidth=\"1\"]>tbody>tr>td,table[data-borderwidth=\"1\"]>tbody>tr>th{border-width:1px}table[data-borderwidth=\"1\"]>tbody>tr .column-resize-handler{width:2px}table[data-borderwidth=\"1\"]>tbody>tr .selectedCell:after{left:0;right:0;top:0;bottom:0;border-width:2px}table[data-borderwidth=\"2\"]>tbody>tr>td,table[data-borderwidth=\"2\"]>tbody>tr>th{border-width:2px}table[data-borderwidth=\"2\"]>tbody>tr .column-resize-handler{width:3px}table[data-borderwidth=\"2\"]>tbody>tr .selectedCell:after{left:1px;right:1px;top:1px;bottom:1px;border-width:3px}table[data-borderwidth=\"3\"]>tbody>tr>td,table[data-borderwidth=\"3\"]>tbody>tr>th{border-width:3px}table[data-borderwidth=\"3\"]>tbody>tr .column-resize-handler{width:4px}table[data-borderwidth=\"3\"]>tbody>tr .selectedCell:after{left:2px;right:2px;top:2px;bottom:2px;border-width:4px}table[data-borderwidth=\"4\"]>tbody>tr>td,table[data-borderwidth=\"4\"]>tbody>tr>th{border-width:4px}table[data-borderwidth=\"4\"]>tbody>tr .column-resize-handler{width:5px}table[data-borderwidth=\"4\"]>tbody>tr .selectedCell:after{left:3px;right:3px;top:3px;bottom:3px;border-width:5px}table[data-borderwidth=\"5\"]>tbody>tr>td,table[data-borderwidth=\"5\"]>tbody>tr>th{border-width:5px}table[data-borderwidth=\"5\"]>tbody>tr .column-resize-handler{width:6px}table[data-borderwidth=\"5\"]>tbody>tr .selectedCell:after{left:4px;right:4px;top:4px;bottom:4px;border-width:6px}table[data-borderwidth=\"6\"]>tbody>tr>td,table[data-borderwidth=\"6\"]>tbody>tr>th{border-width:6px}table[data-borderwidth=\"6\"]>tbody>tr .column-resize-handler{width:7px}table[data-borderwidth=\"6\"]>tbody>tr .selectedCell:after{left:5px;right:5px;top:5px;bottom:5px;border-width:7px}table[data-borderwidth=\"7\"]>tbody>tr>td,table[data-borderwidth=\"7\"]>tbody>tr>th{border-width:7px}table[data-borderwidth=\"7\"]>tbody>tr .column-resize-handler{width:8px}table[data-borderwidth=\"7\"]>tbody>tr .selectedCell:after{left:6px;right:6px;top:6px;bottom:6px;border-width:8px}table[data-bordercolor=\"#fff\"]>tbody>tr>td,table[data-bordercolor=\"#fff\"]>tbody>tr>th{border-color:#fff}table[data-bordercolor=\"#333\"]>tbody>tr>td,table[data-bordercolor=\"#333\"]>tbody>tr>th{border-color:#333}table[data-bordercolor=\"#f5222d\"]>tbody>tr>td,table[data-bordercolor=\"#f5222d\"]>tbody>tr>th{border-color:#f5222d}table[data-bordercolor=\"#fa541c\"]>tbody>tr>td,table[data-bordercolor=\"#fa541c\"]>tbody>tr>th{border-color:#fa541c}table[data-bordercolor=\"#faad14\"]>tbody>tr>td,table[data-bordercolor=\"#faad14\"]>tbody>tr>th{border-color:#faad14}table[data-bordercolor=\"#fadb14\"]>tbody>tr>td,table[data-bordercolor=\"#fadb14\"]>tbody>tr>th{border-color:#fadb14}table[data-bordercolor=\"#52c41a\"]>tbody>tr>td,table[data-bordercolor=\"#52c41a\"]>tbody>tr>th{border-color:#52c41a}table[data-bordercolor=\"#13c2c2\"]>tbody>tr>td,table[data-bordercolor=\"#13c2c2\"]>tbody>tr>th{border-color:#13c2c2}table[data-bordercolor=\"#1890ff\"]>tbody>tr>td,table[data-bordercolor=\"#1890ff\"]>tbody>tr>th{border-color:#1890ff}table[data-bordercolor=\"#2f54eb\"]>tbody>tr>td,table[data-bordercolor=\"#2f54eb\"]>tbody>tr>th{border-color:#2f54eb}table[data-bordercolor=\"#722ed1\"]>tbody>tr>td,table[data-bordercolor=\"#722ed1\"]>tbody>tr>th{border-color:#722ed1}table[data-bordercolor=\"#eb2f96\"]>tbody>tr>td,table[data-bordercolor=\"#eb2f96\"]>tbody>tr>th{border-color:#eb2f96}table[data-bordercolor=\"#f6f6f6\"]>tbody>tr>td,table[data-bordercolor=\"#f6f6f6\"]>tbody>tr>th{border-color:#f6f6f6}table[data-bordercolor=\"#989898\"]>tbody>tr>td,table[data-bordercolor=\"#989898\"]>tbody>tr>th{border-color:#989898}table[data-bordercolor=\"#ffe8e7\"]>tbody>tr>td,table[data-bordercolor=\"#ffe8e7\"]>tbody>tr>th{border-color:#ffe8e7}table[data-bordercolor=\"#ffece0\"]>tbody>tr>td,table[data-bordercolor=\"#ffece0\"]>tbody>tr>th{border-color:#ffece0}table[data-bordercolor=\"#fff7cb\"]>tbody>tr>td,table[data-bordercolor=\"#fff7cb\"]>tbody>tr>th{border-color:#fff7cb}table[data-bordercolor=\"#fcfcca\"]>tbody>tr>td,table[data-bordercolor=\"#fcfcca\"]>tbody>tr>th{border-color:#fcfcca}table[data-bordercolor=\"#e5f7d3\"]>tbody>tr>td,table[data-bordercolor=\"#e5f7d3\"]>tbody>tr>th{border-color:#e5f7d3}table[data-bordercolor=\"#cffff7\"]>tbody>tr>td,table[data-bordercolor=\"#cffff7\"]>tbody>tr>th{border-color:#cffff7}table[data-bordercolor=\"#d4eefc\"]>tbody>tr>td,table[data-bordercolor=\"#d4eefc\"]>tbody>tr>th{border-color:#d4eefc}table[data-bordercolor=\"#dfe8fc\"]>tbody>tr>td,table[data-bordercolor=\"#dfe8fc\"]>tbody>tr>th{border-color:#dfe8fc}table[data-bordercolor=\"#efe1fa\"]>tbody>tr>td,table[data-bordercolor=\"#efe1fa\"]>tbody>tr>th{border-color:#efe1fa}table[data-bordercolor=\"#fbe1eb\"]>tbody>tr>td,table[data-bordercolor=\"#fbe1eb\"]>tbody>tr>th{border-color:#fbe1eb}table[data-bordercolor=\"#e9e9e9\"]>tbody>tr>td,table[data-bordercolor=\"#e9e9e9\"]>tbody>tr>th{border-color:#e9e9e9}table[data-bordercolor=\"#666\"]>tbody>tr>td,table[data-bordercolor=\"#666\"]>tbody>tr>th{border-color:#666}table[data-bordercolor=\"#ffa39e\"]>tbody>tr>td,table[data-bordercolor=\"#ffa39e\"]>tbody>tr>th{border-color:#ffa39e}table[data-bordercolor=\"#ffbb96\"]>tbody>tr>td,table[data-bordercolor=\"#ffbb96\"]>tbody>tr>th{border-color:#ffbb96}table[data-bordercolor=\"#ffe58f\"]>tbody>tr>td,table[data-bordercolor=\"#ffe58f\"]>tbody>tr>th{border-color:#ffe58f}table[data-bordercolor=\"#fffb8f\"]>tbody>tr>td,table[data-bordercolor=\"#fffb8f\"]>tbody>tr>th{border-color:#fffb8f}table[data-bordercolor=\"#b7eb8f\"]>tbody>tr>td,table[data-bordercolor=\"#b7eb8f\"]>tbody>tr>th{border-color:#b7eb8f}table[data-bordercolor=\"#87e8de\"]>tbody>tr>td,table[data-bordercolor=\"#87e8de\"]>tbody>tr>th{border-color:#87e8de}table[data-bordercolor=\"#91d5ff\"]>tbody>tr>td,table[data-bordercolor=\"#91d5ff\"]>tbody>tr>th{border-color:#91d5ff}table[data-bordercolor=\"#adc6ff\"]>tbody>tr>td,table[data-bordercolor=\"#adc6ff\"]>tbody>tr>th{border-color:#adc6ff}table[data-bordercolor=\"#d3adf7\"]>tbody>tr>td,table[data-bordercolor=\"#d3adf7\"]>tbody>tr>th{border-color:#d3adf7}table[data-bordercolor=\"#ffadd2\"]>tbody>tr>td,table[data-bordercolor=\"#ffadd2\"]>tbody>tr>th{border-color:#ffadd2}table[data-bordercolor=\"#ddd\"]>tbody>tr>td,table[data-bordercolor=\"#ddd\"]>tbody>tr>th{border-color:#ddd}table[data-bordercolor=\"#4b4b4b\"]>tbody>tr>td,table[data-bordercolor=\"#4b4b4b\"]>tbody>tr>th{border-color:#4b4b4b}table[data-bordercolor=\"#ff4d4f\"]>tbody>tr>td,table[data-bordercolor=\"#ff4d4f\"]>tbody>tr>th{border-color:#ff4d4f}table[data-bordercolor=\"#ff7a45\"]>tbody>tr>td,table[data-bordercolor=\"#ff7a45\"]>tbody>tr>th{border-color:#ff7a45}table[data-bordercolor=\"#ffc53d\"]>tbody>tr>td,table[data-bordercolor=\"#ffc53d\"]>tbody>tr>th{border-color:#ffc53d}table[data-bordercolor=\"#ffec3d\"]>tbody>tr>td,table[data-bordercolor=\"#ffec3d\"]>tbody>tr>th{border-color:#ffec3d}table[data-bordercolor=\"#73d13d\"]>tbody>tr>td,table[data-bordercolor=\"#73d13d\"]>tbody>tr>th{border-color:#73d13d}table[data-bordercolor=\"#36cfc9\"]>tbody>tr>td,table[data-bordercolor=\"#36cfc9\"]>tbody>tr>th{border-color:#36cfc9}table[data-bordercolor=\"#40a8ff\"]>tbody>tr>td,table[data-bordercolor=\"#40a8ff\"]>tbody>tr>th{border-color:#40a8ff}table[data-bordercolor=\"#597ef7\"]>tbody>tr>td,table[data-bordercolor=\"#597ef7\"]>tbody>tr>th{border-color:#597ef7}table[data-bordercolor=\"#9254de\"]>tbody>tr>td,table[data-bordercolor=\"#9254de\"]>tbody>tr>th{border-color:#9254de}table[data-bordercolor=\"#f759ab\"]>tbody>tr>td,table[data-bordercolor=\"#f759ab\"]>tbody>tr>th{border-color:#f759ab}table[data-bordercolor=\"#ccc\"]>tbody>tr>td,table[data-bordercolor=\"#ccc\"]>tbody>tr>th{border-color:#ccc}table[data-bordercolor=\"#262626\"]>tbody>tr>td,table[data-bordercolor=\"#262626\"]>tbody>tr>th{border-color:#262626}table[data-bordercolor=\"#cf1322\"]>tbody>tr>td,table[data-bordercolor=\"#cf1322\"]>tbody>tr>th{border-color:#cf1322}table[data-bordercolor=\"#d4380d\"]>tbody>tr>td,table[data-bordercolor=\"#d4380d\"]>tbody>tr>th{border-color:#d4380d}table[data-bordercolor=\"#d48806\"]>tbody>tr>td,table[data-bordercolor=\"#d48806\"]>tbody>tr>th{border-color:#d48806}table[data-bordercolor=\"#d4b106\"]>tbody>tr>td,table[data-bordercolor=\"#d4b106\"]>tbody>tr>th{border-color:#d4b106}table[data-bordercolor=\"#389e0d\"]>tbody>tr>td,table[data-bordercolor=\"#389e0d\"]>tbody>tr>th{border-color:#389e0d}table[data-bordercolor=\"#08979c\"]>tbody>tr>td,table[data-bordercolor=\"#08979c\"]>tbody>tr>th{border-color:#08979c}table[data-bordercolor=\"#096dd9\"]>tbody>tr>td,table[data-bordercolor=\"#096dd9\"]>tbody>tr>th{border-color:#096dd9}table[data-bordercolor=\"#1d39c4\"]>tbody>tr>td,table[data-bordercolor=\"#1d39c4\"]>tbody>tr>th{border-color:#1d39c4}table[data-bordercolor=\"#531dab\"]>tbody>tr>td,table[data-bordercolor=\"#531dab\"]>tbody>tr>th{border-color:#531dab}table[data-bordercolor=\"#c41d7f\"]>tbody>tr>td,table[data-bordercolor=\"#c41d7f\"]>tbody>tr>th{border-color:#c41d7f}table[data-bordercolor=\"#aaa\"]>tbody>tr>td,table[data-bordercolor=\"#aaa\"]>tbody>tr>th{border-color:#aaa}table[data-bordercolor=\"#000\"]>tbody>tr>td,table[data-bordercolor=\"#000\"]>tbody>tr>th{border-color:#000}table[data-bordercolor=\"#820014\"]>tbody>tr>td,table[data-bordercolor=\"#820014\"]>tbody>tr>th{border-color:#820014}table[data-bordercolor=\"#871400\"]>tbody>tr>td,table[data-bordercolor=\"#871400\"]>tbody>tr>th{border-color:#871400}table[data-bordercolor=\"#874d00\"]>tbody>tr>td,table[data-bordercolor=\"#874d00\"]>tbody>tr>th{border-color:#874d00}table[data-bordercolor=\"#876800\"]>tbody>tr>td,table[data-bordercolor=\"#876800\"]>tbody>tr>th{border-color:#876800}table[data-bordercolor=\"#135200\"]>tbody>tr>td,table[data-bordercolor=\"#135200\"]>tbody>tr>th{border-color:#135200}table[data-bordercolor=\"#00474f\"]>tbody>tr>td,table[data-bordercolor=\"#00474f\"]>tbody>tr>th{border-color:#00474f}table[data-bordercolor=\"#003a8c\"]>tbody>tr>td,table[data-bordercolor=\"#003a8c\"]>tbody>tr>th{border-color:#003a8c}table[data-bordercolor=\"#061178\"]>tbody>tr>td,table[data-bordercolor=\"#061178\"]>tbody>tr>th{border-color:#061178}table[data-bordercolor=\"#22075e\"]>tbody>tr>td,table[data-bordercolor=\"#22075e\"]>tbody>tr>th{border-color:#22075e}table[data-bordercolor=\"#780650\"]>tbody>tr>td,table[data-bordercolor=\"#780650\"]>tbody>tr>th{border-color:#780650}table.responsive{table-layout:auto}table.responsive>tbody>tr>td,table.responsive>tbody>tr>th{width:auto!important;min-width:52px}table.responsive>tbody>tr>td h1,table.responsive>tbody>tr>td h2,table.responsive>tbody>tr>td h3,table.responsive>tbody>tr>td h4,table.responsive>tbody>tr>td h5,table.responsive>tbody>tr>td h6,table.responsive>tbody>tr>td p,table.responsive>tbody>tr>th h1,table.responsive>tbody>tr>th h2,table.responsive>tbody>tr>th h3,table.responsive>tbody>tr>th h4,table.responsive>tbody>tr>th h5,table.responsive>tbody>tr>th h6,table.responsive>tbody>tr>th p{min-width:0;margin-top:8px;word-break:keep-all}.pm-body-wrapper .ct-table-wrapper{overflow-x:auto}.pm-body-wrapper .ct-table-wrapper table{position:static}.pm-body-wrapper .ct-table-wrapper .num-cell-view:before{content:\"\"}.pm-body-wrapper .ct-table-wrapper .cloneHeader{display:none}.pm-body-wrapper .ct-table-wrapper .cloneHeader>th,.pm-body-wrapper .ct-table-wrapper .originHeader>th{position:relative}.pm-body-wrapper .ct-table-wrapper .cloneHeader>th:after,.pm-body-wrapper .ct-table-wrapper .originHeader>th:after{content:\"\";width:12px;height:12px;visibility:hidden;position:absolute;right:4px;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg class='icon' viewBox='0 0 1024 1024' xmlns='http://www.w3.org/2000/svg' width='12' height='12'%3E%3Cdefs%3E%3Cstyle/%3E%3C/defs%3E%3Cpath d='M228.437 251.904L475.563 15.36a51.2 51.2 0 0 1 72.874 0l247.126 236.544a52.907 52.907 0 0 1 11.178 57.173 51.627 51.627 0 0 1-47.616 32.256h-494.25a51.541 51.541 0 0 1-47.616-32.426 52.907 52.907 0 0 1 11.178-57.003zm567.126 520.192L548.437 1008.64a51.2 51.2 0 0 1-72.874 0L228.437 772.096a52.907 52.907 0 0 1-11.178-57.173 51.627 51.627 0 0 1 47.616-32.256h494.25c20.822 0 39.595 12.8 47.616 32.426a52.907 52.907 0 0 1-11.178 57.003z' fill='%23B0B0B0'/%3E%3C/svg%3E\");background-color:inherit;background-repeat:no-repeat;background-position:50%;cursor:pointer}.pm-body-wrapper .ct-table-wrapper .cloneHeader:hover>th:after,.pm-body-wrapper .ct-table-wrapper .originHeader:hover>th:after{visibility:visible}.pm-body-wrapper .ct-table-wrapper .cloneHeader>th[data-reverse=\"-1\"]:after,.pm-body-wrapper .ct-table-wrapper .originHeader>th[data-reverse=\"-1\"]:after{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='12' height='12' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M2.677 2.952L5.573.18a.6.6 0 0 1 .854 0l2.896 2.772a.62.62 0 0 1 .131.67.605.605 0 0 1-.558.378H3.104a.604.604 0 0 1-.558-.38.62.62 0 0 1 .131-.668zm6.646 6.096L6.427 11.82a.6.6 0 0 1-.854 0L2.677 9.048a.62.62 0 0 1-.131-.67A.605.605 0 0 1 3.104 8h5.792c.244 0 .464.15.558.38a.62.62 0 0 1-.131.668z' fill='%23B0B0B0'/%3E%3Cpath d='M2.677 2.952L5.573.18a.6.6 0 0 1 .854 0l2.896 2.772a.62.62 0 0 1 .131.67.605.605 0 0 1-.558.378H3.104a.604.604 0 0 1-.558-.38.62.62 0 0 1 .131-.668z' fill='%236B6B6B'/%3E%3Cpath d='M9.323 9.048L6.427 11.82a.6.6 0 0 1-.854 0L2.677 9.048a.62.62 0 0 1-.131-.67A.605.605 0 0 1 3.104 8h5.792c.244 0 .464.15.558.38a.62.62 0 0 1-.131.668z' fill='%23AAA'/%3E%3C/g%3E%3C/svg%3E\")}.pm-body-wrapper .ct-table-wrapper .cloneHeader>th[data-reverse=\"1\"]:after,.pm-body-wrapper .ct-table-wrapper .originHeader>th[data-reverse=\"1\"]:after{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='12' height='12' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M2.677 2.952L5.573.18a.6.6 0 0 1 .854 0l2.896 2.772a.62.62 0 0 1 .131.67.605.605 0 0 1-.558.378H3.104a.604.604 0 0 1-.558-.38.62.62 0 0 1 .131-.668zm6.646 6.096L6.427 11.82a.6.6 0 0 1-.854 0L2.677 9.048a.62.62 0 0 1-.131-.67A.605.605 0 0 1 3.104 8h5.792c.244 0 .464.15.558.38a.62.62 0 0 1-.131.668z' fill='%23B0B0B0'/%3E%3Cpath d='M2.677 2.952L5.573.18a.6.6 0 0 1 .854 0l2.896 2.772a.62.62 0 0 1 .131.67.605.605 0 0 1-.558.378H3.104a.604.604 0 0 1-.558-.38.62.62 0 0 1 .131-.668z' fill='%23AAA'/%3E%3Cpath d='M9.323 9.048L6.427 11.82a.6.6 0 0 1-.854 0L2.677 9.048a.62.62 0 0 1-.131-.67A.605.605 0 0 1 3.104 8h5.792c.244 0 .464.15.558.38a.62.62 0 0 1-.131.668z' fill='%236B6B6B'/%3E%3C/g%3E%3C/svg%3E\")}.pm-body-wrapper .ct-table-wrapper .tableHeadFixed{display:table-row;position:absolute;top:0;z-index:99;overflow:hidden}.pm-body-wrapper .ct-table-wrapper .tableHeadFixed td,.pm-body-wrapper .ct-table-wrapper .tableHeadFixed th{overflow:hidden}.pm-body-wrapper .ct-table-wrapper .float-scrollbar{display:none;height:17px;position:absolute;bottom:0;width:100%}.pm-body-wrapper .ct-table-wrapper .float-scroll-filling{border:1px solid #fff;opacity:.01}.pm-body-wrapper .ct-table-wrapper .float-scroll-container{overflow-x:auto;overflow-y:hidden;height:17px}";
	styleInject(css$7);
	
	function getScrollbarWidth() {
	  var tags = document.createElement('p');
	  var styles = {
	    width: '100px',
	    height: '100px',
	    overflowY: 'scroll'
	  };
	
	  for (var i in styles) {
	    tags.style[i] = styles[i];
	  }
	
	  document.body.appendChild(tags);
	  var scrollbarWidth = tags.offsetWidth - tags.clientWidth;
	  tags.remove();
	  return scrollbarWidth;
	}
	
	function getColWidth(attr) {
	  if (!attr) return;
	  return attr.split(',').reduce(function (p, c) {
	    return +p + +c;
	  }, 0);
	}
	
	function isContainsByTags(node, tags, bodyWrapper) {
	  var parentNode = node.parentNode;
	
	  while (parentNode && parentNode !== bodyWrapper) {
	    if (tags.includes((parentNode.tagName || '').toLowerCase())) {
	      return parentNode;
	    }
	
	    parentNode = parentNode.parentNode;
	  }
	
	  return false;
	}
	
	function formatWidth$1(width) {
	  width = Math.round(width);
	  var remainder = width % 4;
	
	  switch (remainder) {
	    case 0:
	      return width;
	
	    case 1:
	      return width - 1;
	
	    case 2:
	      return width + 2;
	
	    case 3:
	      return width + 1;
	
	    default:
	  }
	}
	
	function isHasHead(thead) {
	  var hasThead = true;
	  thead.childNodes.forEach(function (th) {
	    if ((th.tagName || '').toLowerCase() !== 'th') {
	      hasThead = false;
	    }
	  });
	  return hasThead;
	}
	
	function translateWidthForScaleWindow(td, originTds, index) {
	  td.forEach(function (i, ind) {
	    var width = getColWidth(i.getAttribute('data-colwidth'));
	    width = formatWidth$1(width);
	    var originTd = originTds && originTds[ind];
	
	    if (width) {
	      if (index === 0) i.style.cssText = i.style.cssText + ' min-width: ' + width + 'px; max-width: ' + width + 'px;';
	      i.setAttribute('width', width + 'px');
	      return;
	    }
	
	    var clientWidth = originTds && originTd ? originTd.clientWidth : i.clientWidth;
	    clientWidth += 18;
	    clientWidth = formatWidth$1(clientWidth);
	    if (clientWidth < 52) clientWidth = 52;
	
	    if (index === 0) {
	      i.setAttribute('width', clientWidth + 'px');
	      i.style.cssText = i.style.cssText + ' min-width: ' + clientWidth + 'px; max-width: ' + clientWidth + 'px;';
	    } else {
	      i.setAttribute('width', clientWidth + 'px');
	    }
	  });
	}
	
	
	function calculateTableWidth(tr) {
	  var tableWidth = 0;
	  var allHasWidth = true;
	  (0, _from2.default)(tr).forEach(function (td) {
	    if (!td.getAttribute('data-colwidth') || td.getAttribute('data-colwidth') === '0') allHasWidth = false;else {
	      var width = getColWidth(td.getAttribute('data-colwidth'));
	
	      var colspan = td.getAttribute('colspan');
	      var dataWidth = td.getAttribute('data-colwidth');
	      var dataLen = (dataWidth || '').split(',').length;
	
	      if (dataLen === 1 && colspan && +colspan > 1) {
	        width = +colspan * dataWidth;
	      }
	
	      if (window.devicePixelRatio === 1.25) {
	        width = formatWidth$1(width);
	      }
	
	      tableWidth += width;
	    }
	  });
	  return {
	    tableWidth: tableWidth,
	    allHasWidth: allHasWidth
	  };
	}
	
	function addColGroup(table) {
	  if ((0, _from2.default)(table.children).some(function (ele) {
	    return (ele.tagName || '').toLowerCase() === 'colgroup';
	  })) {
	    return;
	  }
	
	  var tbodyChild = table.getElementsByTagName('tbody')[0];
	
	  if (!tbodyChild) {
	    return;
	  }
	
	  var firstTr = tbodyChild.childNodes[0];
	  if (!firstTr) return;
	  var colgroup = document.createElement('colgroup');
	  (0, _from2.default)(firstTr.childNodes).forEach(function (td) {
	    var colspan = td.getAttribute('colspan');
	    var colwidth = td.getAttribute('data-colwidth');
	    var widthArr = colwidth && colwidth.split(',') || [];
	
	    if (colspan) {
	      for (var i = 0; i < +colspan; i++) {
	        var col = document.createElement('col');
	        var width = widthArr && widthArr[i];
	        width = +width;
	
	        if (width) {
	          if (window.devicePixelRatio === 1.25) {
	            width = formatWidth$1(width);
	          }
	
	          col.setAttribute('style', 'width: ' + width + 'px;');
	        }
	
	        colgroup.appendChild(col);
	      }
	    } else {
	      var _col = document.createElement('col');
	
	      if (+colwidth) {
	        if (window.devicePixelRatio === 1.25) {
	          colwidth = formatWidth$1(colwidth);
	        }
	
	        _col.setAttribute('style', 'width: ' + colwidth + 'px;');
	      }
	
	      colgroup.appendChild(_col);
	    }
	  });
	  table.insertBefore(colgroup, table.childNodes[0]);
	}
	
	function translateWidth(table, originTable) {
	  var tableInCollapse = originTable && originTable.closest('.ct-collapse-content');
	  var tableLayout = table.getAttribute('data-table-layout');
	
	  if (tableInCollapse && tableLayout && tableLayout === 'auto') {
	    tableInCollapse.style.display = 'block';
	  }
	
	  var cellCount = 1;
	  (0, _from2.default)(table.querySelectorAll('tr')).forEach(function (tr, index) {
	    var tds = tr.querySelectorAll('th, td');
	    if (!tds) return;
	    var originTrs = originTable && originTable.querySelectorAll('tr');
	    var originTds = originTrs && originTrs[index] && originTrs[index].querySelectorAll('th, td');
	
	    if (window.devicePixelRatio === 1.25) {
	      translateWidthForScaleWindow(tds, originTds, index);
	      return;
	    }
	
	    (0, _from2.default)(tds).forEach(function (td, ind) {
	      var width = getColWidth(td.getAttribute('data-colwidth'));
	
	      var isNumCell = td.classList.contains('num-cell');
	
	      var _index_js$getSystemIn2 = index_js.getSystemInfo(),
	          isMobile = _index_js$getSystemIn2.isMobile;
	
	      if (isNumCell && !isMobile) {
	        td.classList.add('num-cell-view');
	        td.innerHTML = cellCount;
	        cellCount++;
	      }
	
	      var needOverFlow = td.querySelector('a[class="ct-attachment"]') || td.querySelector('.ct-status');
	      var originTd = originTds && originTds[ind];
	
	      if (width) {
	        if (index === 0) td.style.cssText = td.style.cssText + ' min-width: ' + width + 'px; max-width: ' + width + 'px;';
	        td.setAttribute('width', width + 'px');
	        if (needOverFlow) td.style.overflow = 'hidden';
	        return;
	      }
	
	      var clientWidth = originTds && originTd ? originTd.clientWidth : td.clientWidth;
	      clientWidth += 18;
	
	      if (clientWidth < 50) clientWidth = 50;
	      td.setAttribute('width', clientWidth + 'px');
	      if (needOverFlow) td.style.overflow = 'hidden';
	      td.style.cssText = td.style.cssText + ' min-width: ' + clientWidth + 'px; max-width: ' + clientWidth + 'px;';
	    });
	  });
	
	  if (tableInCollapse && tableLayout && tableLayout === 'auto') {
	    tableInCollapse.style.display = 'none';
	  }
	}
	
	function cloneFixedHeader(table, bodyWrapper) {
	  if (isContainsByTags(table, 'table', bodyWrapper)) return;
	
	  var tr = table.querySelectorAll('tr');
	  if (tr && tr.length === 1) return;
	  var originHeader = table.querySelector('.originHeader');
	  if (originHeader) return;
	  originHeader = table.querySelector('tr:first-child');
	  originHeader.classList.add('originHeader');
	
	  var hasThead = isHasHead(originHeader);
	  if (!hasThead) return;
	
	  var cloneHeader = table.querySelector('.cloneHeader');
	  if (cloneHeader) return;
	  var insertCloneHeader = originHeader.cloneNode(true);
	
	  var titleInTable = insertCloneHeader.querySelectorAll('h1, h2, h3, h4, h5, h6');
	  titleInTable.forEach(function (h) {
	    h.removeAttribute('id');
	  });
	  insertCloneHeader.classList.remove('originHeader');
	  insertCloneHeader.classList.add('cloneHeader');
	  var tbody = document.createElement('tbody');
	  tbody.classList.add('cloneHeaderBody');
	  tbody.appendChild(insertCloneHeader);
	  table.insertBefore(tbody, table.childNodes[0]);
	}
	
	function addTableFloatScrollBar(tableWrapper, floatScrollBar, tableWrapperScrollWidth, containerPadding, containerPaddingLeft, scrollbarWidth) {
	  var html = '<div\n      class="float-scroll-container"\n      style="margin-left: ' + (containerPaddingLeft + scrollbarWidth) + 'px;"\n    >\n      <div class="float-scroll-filling" style="width: ' + tableWrapperScrollWidth + 'px;"></div>\n    </div>';
	
	  var marginLeftData = tableWrapper.style.marginLeft;
	  var marginLeft = +(marginLeftData && marginLeftData.replace('px', ''));
	  floatScrollBar.innerHTML = html;
	  floatScrollBar.className = 'float-scrollbar';
	  floatScrollBar.style.right = containerPadding + scrollbarWidth - marginLeft + 'px';
	  tableWrapper.appendChild(floatScrollBar);
	}
	
	function tableFloatScrollBar(table, navBarHeight, containerPadding, containerPaddingLeft, scrollbarWidth) {
	  var tableAbsoluteTop = table.getBoundingClientRect().top;
	  var tableAbsoluteBottom = tableAbsoluteTop + table.clientHeight;
	  var tableWrapper = table.parentNode;
	  var floatScrollBar = tableWrapper && tableWrapper.querySelector('.float-scrollbar');
	  var screenHeight = document.body.clientHeight;
	  var tableWrapperWidth = tableWrapper.clientWidth,
	      tableWrapperScrollWidth = tableWrapper.scrollWidth;
	
	
	  if (tableWrapperWidth < tableWrapperScrollWidth && tableAbsoluteTop < screenHeight && !floatScrollBar) {
	    floatScrollBar = document.createElement('div');
	    addTableFloatScrollBar(tableWrapper, floatScrollBar, tableWrapperScrollWidth, containerPadding, containerPaddingLeft, scrollbarWidth);
	  }
	
	  if (!floatScrollBar) return;
	
	  if (tableAbsoluteTop - navBarHeight <= screenHeight && tableAbsoluteBottom >= screenHeight) {
	    floatScrollBar.style.display = 'block';
	    floatScrollBar.childNodes[0].scrollLeft = tableWrapper.scrollLeft;
	  } else {
	    floatScrollBar.style.display = 'none';
	  }
	}
	
	function addTableBorder(table) {
	  var _table$dataset = table.dataset,
	      bordercolor = _table$dataset.bordercolor,
	      borderwidth = _table$dataset.borderwidth,
	      borderstyle = _table$dataset.borderstyle;
	
	  if (borderwidth === '0') return;
	  var borderCSS = (borderwidth || 1) + 'px ' + (borderstyle || 'solid') + ' ' + (bordercolor || '#cccccc');
	  table.style.borderTop = borderCSS;
	
	  if (borderwidth) {
	    table.style.borderLeft = borderCSS;
	  }
	}
	
	var scrollbarWidth = getScrollbarWidth();
	
	function alignPercentTable(header, originHeader) {
	  header.childNodes.forEach(function (th, index) {
	    var orgth = originHeader.childNodes && originHeader.childNodes[index];
	
	    if (orgth.clientWidth) {
	      th.style.minWidth = orgth.clientWidth + 1 + 'px';
	      th.style.maxWidth = orgth.clientWidth + 1 + 'px';
	    }
	  });
	}
	
	function tableHorizonScroll(e) {
	  var target = e.target;
	  var scrollLeft = target.scrollLeft;
	  var offsetLeft = target.offsetLeft;
	
	  if (target.className === 'ct-table-wrapper' && target.querySelector('.tableHeadFixed')) {
	    var tableHead = target.querySelector('tr:first-child');
	
	    if (tableHead) {
	      var paddingLeft = offsetLeft;
	      tableHead.style.left = -scrollLeft + paddingLeft + 'px';
	    }
	  }
	
	  if (target.className === 'ct-table-wrapper' && target.querySelector('.float-scrollbar')) {
	    target.querySelector('.float-scroll-container').scrollLeft = scrollLeft;
	  }
	
	  if (target.className === 'float-scroll-container') {
	    var currentTableWrapper = target.closest('.ct-table-wrapper');
	    currentTableWrapper && (currentTableWrapper.scrollLeft = scrollLeft);
	  }
	}
	
	function tableHeadFixed(_ref14) {
	  var bodyWrapper = _ref14.bodyWrapper,
	      navBarHeight = _ref14.navBarHeight,
	      containerPadding = _ref14.containerPadding,
	      containerPaddingLeft = _ref14.containerPaddingLeft,
	      _ref14$isFloatScroll = _ref14.isFloatScroll,
	      isFloatScroll = _ref14$isFloatScroll === undefined ? false : _ref14$isFloatScroll;
	
	  if (!bodyWrapper) return;
	  bodyWrapper.querySelectorAll('table').forEach(function (table) {
	    if (isFloatScroll) tableFloatScrollBar(table, navBarHeight, containerPadding, containerPaddingLeft, scrollbarWidth);
	
	    var isInCollapse = table.closest('.ct-collapse:not(.active)');
	    if (isInCollapse) return;
	    var tableAbsoluteTop = table.getBoundingClientRect().top;
	    var tableRect = table.getBoundingClientRect();
	    var tableAbsoluteBottom = tableAbsoluteTop + tableRect.height;
	
	    var insertedHeader = table.querySelector('.cloneHeader');
	    var originHeader = table.querySelector('.originHeader');
	    if (!insertedHeader || !originHeader) return;
	
	    var tableLayout = table.getAttribute('data-table-layout');
	    var isResponsive = table.classList.contains('responsive');
	
	    if (tableLayout && tableLayout === 'auto' || isResponsive) {
	      alignPercentTable(insertedHeader, originHeader);
	    }
	
	    var hasRight = insertedHeader.style.right;
	
	    if (!hasRight) {
	      var marginLeftData = table.parentNode.style.marginLeft;
	      var marginLeft = +(marginLeftData && marginLeftData.replace('px', ''));
	      insertedHeader.style.right = containerPadding + scrollbarWidth - marginLeft + 'px';
	    }
	
	    var isFixed = insertedHeader.classList.contains('tableHeadFixed');
	    var shouldFixed = tableAbsoluteTop - navBarHeight <= 0 && tableAbsoluteBottom - originHeader.clientHeight - navBarHeight >= 0;
	
	    if (shouldFixed && !isFixed) {
	      insertedHeader.classList.add('tableHeadFixed');
	      var paddingLeft = table.offsetLeft;
	      insertedHeader.style.left = -table.parentNode.scrollLeft + paddingLeft + 'px';
	      return;
	    }
	
	    if (!shouldFixed && isFixed) {
	      insertedHeader.classList.remove('tableHeadFixed');
	    }
	  });
	}
	var tableToView = function tableToView(_ref15) {
	  var cloneWrapper = _ref15.cloneWrapper,
	      bodyWrapper = _ref15.bodyWrapper,
	      onDestroy = _ref15.onDestroy;
	
	  var _ref16 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
	    headerFixed: false
	  },
	      scrollWrapper = _ref16.scrollWrapper,
	      _ref16$headerFixed = _ref16.headerFixed,
	      headerFixed = _ref16$headerFixed === undefined ? false : _ref16$headerFixed,
	      navBarHeight = _ref16.navBarHeight,
	      containerPadding = _ref16.containerPadding,
	      navBarHeightFn = _ref16.navBarHeightFn;
	
	  var unmountFns = [];
	  var pmBodyWrapper = cloneWrapper || bodyWrapper;
	  var tables = pmBodyWrapper.querySelectorAll('table');
	  var originTables = bodyWrapper && bodyWrapper.querySelectorAll('table');
	  (0, _from2.default)(tables).forEach(function (table, index) {
	    if (!table.querySelector('tr')) return;
	    if (table.parentNode.classList.contains('ct-table-wrapper')) return;
	
	    var newNode = document.createElement('div');
	    newNode.setAttribute('class', 'ct-table-wrapper');
	    var parentNode = table.parentNode;
	    parentNode.insertBefore(newNode, table);
	    newNode.appendChild(table);
	    var hasMargin = table.style.marginLeft;
	
	    if (hasMargin) {
	      table.parentNode.style.marginLeft = hasMargin;
	      table.parentNode.style.marginRight = '1px';
	
	      table.parentNode.style.width = 'calc(100% - ' + (parseInt(hasMargin, 10) + 1) + 'px)';
	      table.style.marginLeft = 0;
	    }
	
	    var isResponsive = table.classList.contains('responsive');
	    var tr = table.querySelectorAll('tr');
	    var trLen = tr && tr.length === 1;
	    var tableLayout = table.getAttribute('data-table-layout');
	
	    if (!isResponsive) {
	      var tablechild = table.querySelector('tr:first-child').childNodes;
	
	      var _calculateTableWidth = calculateTableWidth(tablechild),
	          tableWidth = _calculateTableWidth.tableWidth,
	          allHasWidth = _calculateTableWidth.allHasWidth;
	
	      if (allHasWidth && !table.hasAttribute('width')) {
	        table.style.width = tableWidth + 'px';
	      }
	
	      if (!allHasWidth && !table.hasAttribute('min-width') && tableWidth) {
	        table.style.minWidth = tableWidth + 'px';
	      }
	
	      addColGroup(table);
	
	      if (trLen && tableLayout === 'auto') return;
	
	      if (bodyWrapper) {
	        var originTable = originTables[index];
	        translateWidth(table, originTable);
	      } else {
	        translateWidth(table);
	      }
	    }
	
	    addTableBorder(table);
	
	    if (headerFixed && !trLen) {
	      cloneFixedHeader(table, bodyWrapper);
	      newNode.addEventListener("scroll", tableHorizonScroll);
	      unmountFns.push(function () {
	        newNode.removeEventListener("scroll", tableHorizonScroll);
	      });
	    }
	  });
	
	  if (headerFixed) {
	    var handleScroll = function handleScroll() {
	      if (navBarHeightFn) {
	        navBarHeight = navBarHeightFn();
	      }
	
	      tableHeadFixed({
	        bodyWrapper: bodyWrapper,
	        navBarHeight: navBarHeight,
	        containerPadding: containerPadding
	      });
	    };
	
	    scrollWrapper.addEventListener('scroll', handleScroll);
	    onDestroy(function () {
	      scrollWrapper.removeEventListener('scroll', handleScroll);
	      unmountFns.forEach(function (unmount) {
	        return unmount();
	      });
	    });
	  }
	};
	
	var TableModule = function () {
	  function TableModule() {
	    var _this19 = this;
	
	    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
	      cellMinWidth: 50
	    };
	    (0, _classCallCheck3.default)(this, TableModule);
	
	    this.name = 'table';
	    this.store = new TableStore(config);
	    this.schema = schema;
	    this.commands = {
	      insertTable: insertTable(this.store),
	      addColumnAfter: function addColumnAfter() {
	        return _addColumnAfter(_this19.store);
	      },
	      addColumnBefore: function addColumnBefore() {
	        return _addColumnBefore(_this19.store);
	      },
	      deleteColumn: function deleteColumn() {
	        return _deleteColumn(_this19.store);
	      },
	      addRowAfter: function addRowAfter() {
	        return _addRowAfter(_this19.store);
	      },
	      addRowBefore: function addRowBefore() {
	        return _addRowBefore(_this19.store);
	      },
	      deleteRow: function deleteRow() {
	        return _deleteRow(_this19.store);
	      },
	      mergeCells: function mergeCells() {
	        return _mergeCells;
	      },
	      splitCell: function splitCell() {
	        return _splitCell;
	      },
	      deleteTable: function deleteTable() {
	        return _deleteTable(_this19.store);
	      },
	      toggleRowHeader: toggleRowHeader(this.store),
	      toggleColHeader: toggleColHeader,
	      toggleNumCol: toggleNumCol(this.store),
	      setBgColor: setBgColor,
	      setBgDefaultColor: function setBgDefaultColor() {
	        return setBgColor('');
	      },
	      setResponsive: function setResponsive() {
	        return _setResponsive(_this19.store);
	      },
	      setFixed: function setFixed() {
	        return _setFixed;
	      },
	      increaseIndent: increaseIndent,
	      reduceIndent: reduceIndent,
	      setPosition: setPosition,
	      setTableAttrsCommand: setTableAttrsCommand
	    };
	    this.utils = {
	      isInTable: isInTable,
	      isInNumCell: isInNumCell,
	      isAllCellSelection: isAllCellSelection,
	      isResponsive: function isResponsive(state) {
	        return _setResponsive()(state);
	      },
	      hasTableHeader: hasTableHeader,
	      canMergeCells: function canMergeCells(state) {
	        return _mergeCells(state);
	      },
	      canSplitCell: canSplitCell,
	      canAddRowBefore: canAddRowBefore(this.store),
	      canAddColumnBefore: canAddColumnBefore(this.store),
	      canAddColumnAfter: canAddColumnAfter(this.store),
	      canIndent: canIndent,
	      getTableAttrs: getTableAttrs
	    };
	    this.plugins = [createPlugin(this.store), keymap__default({
	      Backspace: handleBackspace(this.store),
	      'Mod-Backspace': handleBackspace(this.store),
	      Delete: handleBackspace(this.store),
	      'Mod-Delete': handleBackspace(this.store),
	      Tab: handleTab(this.store),
	      'Shift-Tab': handleShiftTab(this.store),
	      'Alt-ArrowUp': _addRowBefore(this.store),
	      'Alt-ArrowDown': _addRowAfter(this.store),
	      'Alt-ArrowLeft': _addColumnBefore(this.store),
	      'Alt-ArrowRight': _addColumnAfter(this.store),
	      'Mod-Shift-h': setPosition('top'),
	      'Mod-Shift-H': setPosition('top'),
	      'Mod-Shift-m': setPosition('middle'),
	      'Mod-Shift-M': setPosition('middle'),
	      'Mod-Shift-d': setPosition('bottom'),
	      'Mod-Shift-D': setPosition('bottom')
	    }), columnResizing({
	      cellMinWidth: config.cellMinWidth
	    }, this.store), tableEditing(this.store)];
	    this.pluginPriority = 'high';
	    this.events = {
	      afterInsert: afterInsert(this.store),
	      stateChanged: function stateChanged() {
	        return _stateChanged(_this19.store);
	      }
	    };
	  }
	
	  (0, _createClass3.default)(TableModule, [{
	    key: 'init',
	    value: function init(moduleManager) {
	      this.store.init(moduleManager);
	    }
	  }]);
	  return TableModule;
	}();
	
	TableModule.moduleName = 'table';
	
	exports.TableModule = TableModule;
	exports.CellSelection = CellSelection;
	exports.tableHorizonScroll = tableHorizonScroll;
	exports.tableHeadFixed = tableHeadFixed;
	exports.tableToView = tableToView;

/***/ }),
/* 98 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.CONFIG_API_URL = {
	    ppe: {
	        SSO_CONFIG_URL: '//ssoconfigs.it.beta.sankuai.com'
	    },
	    test: {
	        SSO_CONFIG_URL: '//ssoconfigs.it.test.sankuai.com'
	    },
	    dev: {
	        SSO_CONFIG_URL: '//ssoconfigs.it.dev.sankuai.com'
	    },
	    product: {
	        SSO_CONFIG_URL: 'https://ssosv.sankuai.com/configs'
	    },
	    staging: {
	        SSO_CONFIG_URL: 'https://ssosv.sankuai.com/configs'
	    }
	};
	exports.SSO_SPECIAL_ROUTE = {
	    callbackUrl: '/sso/callback',
	    logoutUrl: '/sso/logout',
	    robotUrl: '/sso/robot'
	};
	exports.DEFAULT_SSO_ACCESS_CONFIG = {
	    dev: {
	        accessEnv: 'dev',
	        http: {
	            openApiHost: '//ssosv.it.test.sankuai.info/open',
	            ssoSvHost: '//ssosv.it.test.sankuai.info/sson'
	        },
	        id: 'dev_master',
	        loginUrl: '//ssosv.it.test.sankuai.info/sson/login',
	        thrift: {
	            openApiThrift: {
	                remoteAppkey: 'com.sankuai.it.iam.ssoopenapi',
	                remoteServerPort: 9002
	            },
	            ssoSvThrift: {
	                remoteAppkey: 'com.sankuai.it.iam.ssoservice',
	                remoteServerPort: 9002
	            }
	        }
	    },
	    test: {
	        accessEnv: 'test',
	        http: {
	            openApiHost: '//ssosv.it.test.sankuai.com/open',
	            ssoSvHost: '//ssosv.it.test.sankuai.com/sson'
	        },
	        id: 'test_master',
	        loginUrl: '//ssosv.it.test.sankuai.com/sson/login',
	        thrift: {
	            openApiThrift: {
	                remoteAppkey: 'com.sankuai.it.iam.ssoopenapi',
	                remoteServerPort: 9002
	            },
	            ssoSvThrift: {
	                remoteAppkey: 'com.sankuai.it.iam.ssoservice',
	                remoteServerPort: 9002
	            }
	        }
	    },
	    staging: {
	        accessEnv: 'staging',
	        http: {
	            openApiHost: '//ssosv.it.st.sankuai.com/open',
	            ssoSvHost: '//ssosv.it.st.sankuai.com/sson'
	        },
	        id: 'staging_master',
	        loginUrl: '//ssosv.it.st.sankuai.com/sson/login',
	        thrift: {
	            openApiThrift: {
	                remoteAppkey: 'com.sankuai.it.iam.ssoopenapi',
	                remoteServerPort: 9002
	            },
	            ssoSvThrift: {
	                remoteAppkey: 'com.sankuai.it.iam.ssoservice',
	                remoteServerPort: 9002
	            }
	        }
	    },
	    ppe: {
	        accessEnv: 'ppe',
	        http: {
	            openApiHost: '//ssosv.it.beta.sankuai.com/open',
	            ssoSvHost: '//ssosv.it.beta.sankuai.com/sson'
	        },
	        id: 'ppe_master',
	        loginUrl: '//ssosv.it.beta.sankuai.com/sson/login',
	        thrift: {
	            openApiThrift: {
	                remoteAppkey: 'com.sankuai.it.iam.ssoopenapi',
	                remoteServerPort: 9002
	            },
	            ssoSvThrift: {
	                remoteAppkey: 'com.sankuai.it.iam.ssoservice',
	                remoteServerPort: 9002
	            }
	        }
	    },
	    product: {
	        accessEnv: 'product',
	        http: {
	            openApiHost: 'https://ssosv.sankuai.com/open',
	            ssoSvHost: 'https://ssosv.sankuai.com/sson'
	        },
	        id: 'product_master',
	        loginUrl: 'https://ssosv.sankuai.com/sson/login',
	        thrift: {
	            openApiThrift: {
	                remoteAppkey: 'com.sankuai.it.iam.ssoopenapi',
	                remoteServerPort: 9002
	            },
	            ssoSvThrift: {
	                remoteAppkey: 'com.sankuai.it.iam.ssoservice',
	                remoteServerPort: 9002
	            }
	        }
	    }
	};
	exports.configMappingModel = {
	    loginUrl: {
	        layer: 'accessPoint'
	    },
	    accessEnv: {
	        layer: 'accessPoint'
	    },
	    openApiHost: {
	        layer: 'accessPoint.http'
	    },
	    ssoSvHost: {
	        layer: 'accessPoint.http'
	    }
	};
	exports.HARD_CODE_METHOD = 'SHA256';
	exports.WEB_DEFAULT_IP = '0.0.0.0';

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.sso = exports.ssoWeb = undefined;
	
	var _jsCookie = __webpack_require__(447);
	
	var _jsCookie2 = _interopRequireDefault(_jsCookie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SSOWeb = __webpack_require__(240).default;
	var isProduction = window.location.host === 'agent-repair-prompt.sankuai.com';
	
	var VUE_APP_CLIENT_ID_PROD = '2c4ad23224';
	var VUE_APP_CLIENT_ID_DEV = 'ab54c8213f';
	
	var ssoWeb = exports.ssoWeb = new SSOWeb({
	    clientId: isProduction ? VUE_APP_CLIENT_ID_PROD : VUE_APP_CLIENT_ID_DEV,
	    accessEnv: isProduction ? 'product' : 'test',
	    callbackUrl: '/#/callback' });
	
	var sso = exports.sso = {
	    clientId: isProduction ? VUE_APP_CLIENT_ID_PROD : VUE_APP_CLIENT_ID_DEV,
	    redirectLogin: function redirectLogin() {
	        ssoWeb.login();
	    },
	    redirectLoginNew: function redirectLoginNew() {
	        window.location.href = ssoWeb.getLoginUrl();
	    },
	    logout: function logout() {
	        var _this = this;
	
	        ssoWeb.logout().then(function () {
	            _this.removeSsoid();
	            _this.setCurrentURL();
	            _this.redirectLoginNew();
	        });
	    },
	    removeSsoid: function removeSsoid() {
	        _jsCookie2.default.remove('ssoid');
	    },
	    setSsoid: function setSsoid(ssoid) {
	        _jsCookie2.default.set('ssoid', ssoid, { expires: 7 });
	    },
	    getSsoid: function getSsoid() {
	        return _jsCookie2.default.get('ssoid');
	    },
	    setCurrentURL: function setCurrentURL() {
	        var currentURL = window.location.href;
	        if (!currentURL.includes('/callback')) {
	            _jsCookie2.default.set('currentURL', currentURL);
	        }
	    },
	    getCurrentURL: function getCurrentURL() {
	        return _jsCookie2.default.get('currentURL') || '/';
	    }
	};

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(317), __esModule: true };

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(329), __esModule: true };

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(1));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	function Context(indented, column, type, info, align, prev) {
	  this.indented = indented;
	  this.column = column;
	  this.type = type;
	  this.info = info;
	  this.align = align;
	  this.prev = prev;
	}
	function pushContext(state, col, type, info) {
	  var indent = state.indented;
	  if (state.context && state.context.type == "statement" && type != "statement")
	    indent = state.context.indented;
	  return state.context = new Context(indent, col, type, info, null, state.context);
	}
	function popContext(state) {
	  var t = state.context.type;
	  if (t == ")" || t == "]" || t == "}")
	    state.indented = state.context.indented;
	  return state.context = state.context.prev;
	}
	
	function typeBefore(stream, state, pos) {
	  if (state.prevToken == "variable" || state.prevToken == "type") return true;
	  if (/\S(?:[^- ]>|[*\]])\s*$|\*$/.test(stream.string.slice(0, pos))) return true;
	  if (state.typeAtEndOfLine && stream.column() == stream.indentation()) return true;
	}
	
	function isTopScope(context) {
	  for (;;) {
	    if (!context || context.type == "top") return true;
	    if (context.type == "}" && context.prev.info != "namespace") return false;
	    context = context.prev;
	  }
	}
	
	CodeMirror.defineMode("clike", function(config, parserConfig) {
	  var indentUnit = config.indentUnit,
	      statementIndentUnit = parserConfig.statementIndentUnit || indentUnit,
	      dontAlignCalls = parserConfig.dontAlignCalls,
	      keywords = parserConfig.keywords || {},
	      types = parserConfig.types || {},
	      builtin = parserConfig.builtin || {},
	      blockKeywords = parserConfig.blockKeywords || {},
	      defKeywords = parserConfig.defKeywords || {},
	      atoms = parserConfig.atoms || {},
	      hooks = parserConfig.hooks || {},
	      multiLineStrings = parserConfig.multiLineStrings,
	      indentStatements = parserConfig.indentStatements !== false,
	      indentSwitch = parserConfig.indentSwitch !== false,
	      namespaceSeparator = parserConfig.namespaceSeparator,
	      isPunctuationChar = parserConfig.isPunctuationChar || /[\[\]{}\(\),;\:\.]/,
	      numberStart = parserConfig.numberStart || /[\d\.]/,
	      number = parserConfig.number || /^(?:0x[a-f\d]+|0b[01]+|(?:\d+\.?\d*|\.\d+)(?:e[-+]?\d+)?)(u|ll?|l|f)?/i,
	      isOperatorChar = parserConfig.isOperatorChar || /[+\-*&%=<>!?|\/]/,
	      isIdentifierChar = parserConfig.isIdentifierChar || /[\w\$_\xa1-\uffff]/,
	      // An optional function that takes a {string} token and returns true if it
	      // should be treated as a builtin.
	      isReservedIdentifier = parserConfig.isReservedIdentifier || false;
	
	  var curPunc, isDefKeyword;
	
	  function tokenBase(stream, state) {
	    var ch = stream.next();
	    if (hooks[ch]) {
	      var result = hooks[ch](stream, state);
	      if (result !== false) return result;
	    }
	    if (ch == '"' || ch == "'") {
	      state.tokenize = tokenString(ch);
	      return state.tokenize(stream, state);
	    }
	    if (isPunctuationChar.test(ch)) {
	      curPunc = ch;
	      return null;
	    }
	    if (numberStart.test(ch)) {
	      stream.backUp(1)
	      if (stream.match(number)) return "number"
	      stream.next()
	    }
	    if (ch == "/") {
	      if (stream.eat("*")) {
	        state.tokenize = tokenComment;
	        return tokenComment(stream, state);
	      }
	      if (stream.eat("/")) {
	        stream.skipToEnd();
	        return "comment";
	      }
	    }
	    if (isOperatorChar.test(ch)) {
	      while (!stream.match(/^\/[\/*]/, false) && stream.eat(isOperatorChar)) {}
	      return "operator";
	    }
	    stream.eatWhile(isIdentifierChar);
	    if (namespaceSeparator) while (stream.match(namespaceSeparator))
	      stream.eatWhile(isIdentifierChar);
	
	    var cur = stream.current();
	    if (contains(keywords, cur)) {
	      if (contains(blockKeywords, cur)) curPunc = "newstatement";
	      if (contains(defKeywords, cur)) isDefKeyword = true;
	      return "keyword";
	    }
	    if (contains(types, cur)) return "type";
	    if (contains(builtin, cur)
	        || (isReservedIdentifier && isReservedIdentifier(cur))) {
	      if (contains(blockKeywords, cur)) curPunc = "newstatement";
	      return "builtin";
	    }
	    if (contains(atoms, cur)) return "atom";
	    return "variable";
	  }
	
	  function tokenString(quote) {
	    return function(stream, state) {
	      var escaped = false, next, end = false;
	      while ((next = stream.next()) != null) {
	        if (next == quote && !escaped) {end = true; break;}
	        escaped = !escaped && next == "\\";
	      }
	      if (end || !(escaped || multiLineStrings))
	        state.tokenize = null;
	      return "string";
	    };
	  }
	
	  function tokenComment(stream, state) {
	    var maybeEnd = false, ch;
	    while (ch = stream.next()) {
	      if (ch == "/" && maybeEnd) {
	        state.tokenize = null;
	        break;
	      }
	      maybeEnd = (ch == "*");
	    }
	    return "comment";
	  }
	
	  function maybeEOL(stream, state) {
	    if (parserConfig.typeFirstDefinitions && stream.eol() && isTopScope(state.context))
	      state.typeAtEndOfLine = typeBefore(stream, state, stream.pos)
	  }
	
	  // Interface
	
	  return {
	    startState: function(basecolumn) {
	      return {
	        tokenize: null,
	        context: new Context((basecolumn || 0) - indentUnit, 0, "top", null, false),
	        indented: 0,
	        startOfLine: true,
	        prevToken: null
	      };
	    },
	
	    token: function(stream, state) {
	      var ctx = state.context;
	      if (stream.sol()) {
	        if (ctx.align == null) ctx.align = false;
	        state.indented = stream.indentation();
	        state.startOfLine = true;
	      }
	      if (stream.eatSpace()) { maybeEOL(stream, state); return null; }
	      curPunc = isDefKeyword = null;
	      var style = (state.tokenize || tokenBase)(stream, state);
	      if (style == "comment" || style == "meta") return style;
	      if (ctx.align == null) ctx.align = true;
	
	      if (curPunc == ";" || curPunc == ":" || (curPunc == "," && stream.match(/^\s*(?:\/\/.*)?$/, false)))
	        while (state.context.type == "statement") popContext(state);
	      else if (curPunc == "{") pushContext(state, stream.column(), "}");
	      else if (curPunc == "[") pushContext(state, stream.column(), "]");
	      else if (curPunc == "(") pushContext(state, stream.column(), ")");
	      else if (curPunc == "}") {
	        while (ctx.type == "statement") ctx = popContext(state);
	        if (ctx.type == "}") ctx = popContext(state);
	        while (ctx.type == "statement") ctx = popContext(state);
	      }
	      else if (curPunc == ctx.type) popContext(state);
	      else if (indentStatements &&
	               (((ctx.type == "}" || ctx.type == "top") && curPunc != ";") ||
	                (ctx.type == "statement" && curPunc == "newstatement"))) {
	        pushContext(state, stream.column(), "statement", stream.current());
	      }
	
	      if (style == "variable" &&
	          ((state.prevToken == "def" ||
	            (parserConfig.typeFirstDefinitions && typeBefore(stream, state, stream.start) &&
	             isTopScope(state.context) && stream.match(/^\s*\(/, false)))))
	        style = "def";
	
	      if (hooks.token) {
	        var result = hooks.token(stream, state, style);
	        if (result !== undefined) style = result;
	      }
	
	      if (style == "def" && parserConfig.styleDefs === false) style = "variable";
	
	      state.startOfLine = false;
	      state.prevToken = isDefKeyword ? "def" : style || curPunc;
	      maybeEOL(stream, state);
	      return style;
	    },
	
	    indent: function(state, textAfter) {
	      if (state.tokenize != tokenBase && state.tokenize != null || state.typeAtEndOfLine) return CodeMirror.Pass;
	      var ctx = state.context, firstChar = textAfter && textAfter.charAt(0);
	      var closing = firstChar == ctx.type;
	      if (ctx.type == "statement" && firstChar == "}") ctx = ctx.prev;
	      if (parserConfig.dontIndentStatements)
	        while (ctx.type == "statement" && parserConfig.dontIndentStatements.test(ctx.info))
	          ctx = ctx.prev
	      if (hooks.indent) {
	        var hook = hooks.indent(state, ctx, textAfter, indentUnit);
	        if (typeof hook == "number") return hook
	      }
	      var switchBlock = ctx.prev && ctx.prev.info == "switch";
	      if (parserConfig.allmanIndentation && /[{(]/.test(firstChar)) {
	        while (ctx.type != "top" && ctx.type != "}") ctx = ctx.prev
	        return ctx.indented
	      }
	      if (ctx.type == "statement")
	        return ctx.indented + (firstChar == "{" ? 0 : statementIndentUnit);
	      if (ctx.align && (!dontAlignCalls || ctx.type != ")"))
	        return ctx.column + (closing ? 0 : 1);
	      if (ctx.type == ")" && !closing)
	        return ctx.indented + statementIndentUnit;
	
	      return ctx.indented + (closing ? 0 : indentUnit) +
	        (!closing && switchBlock && !/^(?:case|default)\b/.test(textAfter) ? indentUnit : 0);
	    },
	
	    electricInput: indentSwitch ? /^\s*(?:case .*?:|default:|\{\}?|\})$/ : /^\s*[{}]$/,
	    blockCommentStart: "/*",
	    blockCommentEnd: "*/",
	    blockCommentContinue: " * ",
	    lineComment: "//",
	    fold: "brace"
	  };
	});
	
	  function words(str) {
	    var obj = {}, words = str.split(" ");
	    for (var i = 0; i < words.length; ++i) obj[words[i]] = true;
	    return obj;
	  }
	  function contains(words, word) {
	    if (typeof words === "function") {
	      return words(word);
	    } else {
	      return words.propertyIsEnumerable(word);
	    }
	  }
	  var cKeywords = "auto if break case register continue return default do sizeof " +
	    "static else struct switch extern typedef union for goto while enum const " +
	    "volatile inline restrict asm fortran";
	
	  // Keywords from https://en.cppreference.com/w/cpp/keyword includes C++20.
	  var cppKeywords = "alignas alignof and and_eq audit axiom bitand bitor catch " +
	  "class compl concept constexpr const_cast decltype delete dynamic_cast " +
	  "explicit export final friend import module mutable namespace new noexcept " +
	  "not not_eq operator or or_eq override private protected public " +
	  "reinterpret_cast requires static_assert static_cast template this " +
	  "thread_local throw try typeid typename using virtual xor xor_eq";
	
	  var objCKeywords = "bycopy byref in inout oneway out self super atomic nonatomic retain copy " +
	  "readwrite readonly strong weak assign typeof nullable nonnull null_resettable _cmd " +
	  "@interface @implementation @end @protocol @encode @property @synthesize @dynamic @class " +
	  "@public @package @private @protected @required @optional @try @catch @finally @import " +
	  "@selector @encode @defs @synchronized @autoreleasepool @compatibility_alias @available";
	
	  var objCBuiltins = "FOUNDATION_EXPORT FOUNDATION_EXTERN NS_INLINE NS_FORMAT_FUNCTION " +
	  " NS_RETURNS_RETAINEDNS_ERROR_ENUM NS_RETURNS_NOT_RETAINED NS_RETURNS_INNER_POINTER " +
	  "NS_DESIGNATED_INITIALIZER NS_ENUM NS_OPTIONS NS_REQUIRES_NIL_TERMINATION " +
	  "NS_ASSUME_NONNULL_BEGIN NS_ASSUME_NONNULL_END NS_SWIFT_NAME NS_REFINED_FOR_SWIFT"
	
	  // Do not use this. Use the cTypes function below. This is global just to avoid
	  // excessive calls when cTypes is being called multiple times during a parse.
	  var basicCTypes = words("int long char short double float unsigned signed " +
	    "void bool");
	
	  // Do not use this. Use the objCTypes function below. This is global just to avoid
	  // excessive calls when objCTypes is being called multiple times during a parse.
	  var basicObjCTypes = words("SEL instancetype id Class Protocol BOOL");
	
	  // Returns true if identifier is a "C" type.
	  // C type is defined as those that are reserved by the compiler (basicTypes),
	  // and those that end in _t (Reserved by POSIX for types)
	  // http://www.gnu.org/software/libc/manual/html_node/Reserved-Names.html
	  function cTypes(identifier) {
	    return contains(basicCTypes, identifier) || /.+_t$/.test(identifier);
	  }
	
	  // Returns true if identifier is a "Objective C" type.
	  function objCTypes(identifier) {
	    return cTypes(identifier) || contains(basicObjCTypes, identifier);
	  }
	
	  var cBlockKeywords = "case do else for if switch while struct enum union";
	  var cDefKeywords = "struct enum union";
	
	  function cppHook(stream, state) {
	    if (!state.startOfLine) return false
	    for (var ch, next = null; ch = stream.peek();) {
	      if (ch == "\\" && stream.match(/^.$/)) {
	        next = cppHook
	        break
	      } else if (ch == "/" && stream.match(/^\/[\/\*]/, false)) {
	        break
	      }
	      stream.next()
	    }
	    state.tokenize = next
	    return "meta"
	  }
	
	  function pointerHook(_stream, state) {
	    if (state.prevToken == "type") return "type";
	    return false;
	  }
	
	  // For C and C++ (and ObjC): identifiers starting with __
	  // or _ followed by a capital letter are reserved for the compiler.
	  function cIsReservedIdentifier(token) {
	    if (!token || token.length < 2) return false;
	    if (token[0] != '_') return false;
	    return (token[1] == '_') || (token[1] !== token[1].toLowerCase());
	  }
	
	  function cpp14Literal(stream) {
	    stream.eatWhile(/[\w\.']/);
	    return "number";
	  }
	
	  function cpp11StringHook(stream, state) {
	    stream.backUp(1);
	    // Raw strings.
	    if (stream.match(/(R|u8R|uR|UR|LR)/)) {
	      var match = stream.match(/"([^\s\\()]{0,16})\(/);
	      if (!match) {
	        return false;
	      }
	      state.cpp11RawStringDelim = match[1];
	      state.tokenize = tokenRawString;
	      return tokenRawString(stream, state);
	    }
	    // Unicode strings/chars.
	    if (stream.match(/(u8|u|U|L)/)) {
	      if (stream.match(/["']/, /* eat */ false)) {
	        return "string";
	      }
	      return false;
	    }
	    // Ignore this hook.
	    stream.next();
	    return false;
	  }
	
	  function cppLooksLikeConstructor(word) {
	    var lastTwo = /(\w+)::~?(\w+)$/.exec(word);
	    return lastTwo && lastTwo[1] == lastTwo[2];
	  }
	
	  // C#-style strings where "" escapes a quote.
	  function tokenAtString(stream, state) {
	    var next;
	    while ((next = stream.next()) != null) {
	      if (next == '"' && !stream.eat('"')) {
	        state.tokenize = null;
	        break;
	      }
	    }
	    return "string";
	  }
	
	  // C++11 raw string literal is <prefix>"<delim>( anything )<delim>", where
	  // <delim> can be a string up to 16 characters long.
	  function tokenRawString(stream, state) {
	    // Escape characters that have special regex meanings.
	    var delim = state.cpp11RawStringDelim.replace(/[^\w\s]/g, '\\$&');
	    var match = stream.match(new RegExp(".*?\\)" + delim + '"'));
	    if (match)
	      state.tokenize = null;
	    else
	      stream.skipToEnd();
	    return "string";
	  }
	
	  function def(mimes, mode) {
	    if (typeof mimes == "string") mimes = [mimes];
	    var words = [];
	    function add(obj) {
	      if (obj) for (var prop in obj) if (obj.hasOwnProperty(prop))
	        words.push(prop);
	    }
	    add(mode.keywords);
	    add(mode.types);
	    add(mode.builtin);
	    add(mode.atoms);
	    if (words.length) {
	      mode.helperType = mimes[0];
	      CodeMirror.registerHelper("hintWords", mimes[0], words);
	    }
	
	    for (var i = 0; i < mimes.length; ++i)
	      CodeMirror.defineMIME(mimes[i], mode);
	  }
	
	  def(["text/x-csrc", "text/x-c", "text/x-chdr"], {
	    name: "clike",
	    keywords: words(cKeywords),
	    types: cTypes,
	    blockKeywords: words(cBlockKeywords),
	    defKeywords: words(cDefKeywords),
	    typeFirstDefinitions: true,
	    atoms: words("NULL true false"),
	    isReservedIdentifier: cIsReservedIdentifier,
	    hooks: {
	      "#": cppHook,
	      "*": pointerHook,
	    },
	    modeProps: {fold: ["brace", "include"]}
	  });
	
	  def(["text/x-c++src", "text/x-c++hdr"], {
	    name: "clike",
	    keywords: words(cKeywords + " " + cppKeywords),
	    types: cTypes,
	    blockKeywords: words(cBlockKeywords + " class try catch"),
	    defKeywords: words(cDefKeywords + " class namespace"),
	    typeFirstDefinitions: true,
	    atoms: words("true false NULL nullptr"),
	    dontIndentStatements: /^template$/,
	    isIdentifierChar: /[\w\$_~\xa1-\uffff]/,
	    isReservedIdentifier: cIsReservedIdentifier,
	    hooks: {
	      "#": cppHook,
	      "*": pointerHook,
	      "u": cpp11StringHook,
	      "U": cpp11StringHook,
	      "L": cpp11StringHook,
	      "R": cpp11StringHook,
	      "0": cpp14Literal,
	      "1": cpp14Literal,
	      "2": cpp14Literal,
	      "3": cpp14Literal,
	      "4": cpp14Literal,
	      "5": cpp14Literal,
	      "6": cpp14Literal,
	      "7": cpp14Literal,
	      "8": cpp14Literal,
	      "9": cpp14Literal,
	      token: function(stream, state, style) {
	        if (style == "variable" && stream.peek() == "(" &&
	            (state.prevToken == ";" || state.prevToken == null ||
	             state.prevToken == "}") &&
	            cppLooksLikeConstructor(stream.current()))
	          return "def";
	      }
	    },
	    namespaceSeparator: "::",
	    modeProps: {fold: ["brace", "include"]}
	  });
	
	  def("text/x-java", {
	    name: "clike",
	    keywords: words("abstract assert break case catch class const continue default " +
	                    "do else enum extends final finally for goto if implements import " +
	                    "instanceof interface native new package private protected public " +
	                    "return static strictfp super switch synchronized this throw throws transient " +
	                    "try volatile while @interface"),
	    types: words("byte short int long float double boolean char void Boolean Byte Character Double Float " +
	                 "Integer Long Number Object Short String StringBuffer StringBuilder Void"),
	    blockKeywords: words("catch class do else finally for if switch try while"),
	    defKeywords: words("class interface enum @interface"),
	    typeFirstDefinitions: true,
	    atoms: words("true false null"),
	    number: /^(?:0x[a-f\d_]+|0b[01_]+|(?:[\d_]+\.?\d*|\.\d+)(?:e[-+]?[\d_]+)?)(u|ll?|l|f)?/i,
	    hooks: {
	      "@": function(stream) {
	        // Don't match the @interface keyword.
	        if (stream.match('interface', false)) return false;
	
	        stream.eatWhile(/[\w\$_]/);
	        return "meta";
	      }
	    },
	    modeProps: {fold: ["brace", "import"]}
	  });
	
	  def("text/x-csharp", {
	    name: "clike",
	    keywords: words("abstract as async await base break case catch checked class const continue" +
	                    " default delegate do else enum event explicit extern finally fixed for" +
	                    " foreach goto if implicit in interface internal is lock namespace new" +
	                    " operator out override params private protected public readonly ref return sealed" +
	                    " sizeof stackalloc static struct switch this throw try typeof unchecked" +
	                    " unsafe using virtual void volatile while add alias ascending descending dynamic from get" +
	                    " global group into join let orderby partial remove select set value var yield"),
	    types: words("Action Boolean Byte Char DateTime DateTimeOffset Decimal Double Func" +
	                 " Guid Int16 Int32 Int64 Object SByte Single String Task TimeSpan UInt16 UInt32" +
	                 " UInt64 bool byte char decimal double short int long object"  +
	                 " sbyte float string ushort uint ulong"),
	    blockKeywords: words("catch class do else finally for foreach if struct switch try while"),
	    defKeywords: words("class interface namespace struct var"),
	    typeFirstDefinitions: true,
	    atoms: words("true false null"),
	    hooks: {
	      "@": function(stream, state) {
	        if (stream.eat('"')) {
	          state.tokenize = tokenAtString;
	          return tokenAtString(stream, state);
	        }
	        stream.eatWhile(/[\w\$_]/);
	        return "meta";
	      }
	    }
	  });
	
	  function tokenTripleString(stream, state) {
	    var escaped = false;
	    while (!stream.eol()) {
	      if (!escaped && stream.match('"""')) {
	        state.tokenize = null;
	        break;
	      }
	      escaped = stream.next() == "\\" && !escaped;
	    }
	    return "string";
	  }
	
	  function tokenNestedComment(depth) {
	    return function (stream, state) {
	      var ch
	      while (ch = stream.next()) {
	        if (ch == "*" && stream.eat("/")) {
	          if (depth == 1) {
	            state.tokenize = null
	            break
	          } else {
	            state.tokenize = tokenNestedComment(depth - 1)
	            return state.tokenize(stream, state)
	          }
	        } else if (ch == "/" && stream.eat("*")) {
	          state.tokenize = tokenNestedComment(depth + 1)
	          return state.tokenize(stream, state)
	        }
	      }
	      return "comment"
	    }
	  }
	
	  def("text/x-scala", {
	    name: "clike",
	    keywords: words(
	      /* scala */
	      "abstract case catch class def do else extends final finally for forSome if " +
	      "implicit import lazy match new null object override package private protected return " +
	      "sealed super this throw trait try type val var while with yield _ " +
	
	      /* package scala */
	      "assert assume require print println printf readLine readBoolean readByte readShort " +
	      "readChar readInt readLong readFloat readDouble"
	    ),
	    types: words(
	      "AnyVal App Application Array BufferedIterator BigDecimal BigInt Char Console Either " +
	      "Enumeration Equiv Error Exception Fractional Function IndexedSeq Int Integral Iterable " +
	      "Iterator List Map Numeric Nil NotNull Option Ordered Ordering PartialFunction PartialOrdering " +
	      "Product Proxy Range Responder Seq Serializable Set Specializable Stream StringBuilder " +
	      "StringContext Symbol Throwable Traversable TraversableOnce Tuple Unit Vector " +
	
	      /* package java.lang */
	      "Boolean Byte Character CharSequence Class ClassLoader Cloneable Comparable " +
	      "Compiler Double Exception Float Integer Long Math Number Object Package Pair Process " +
	      "Runtime Runnable SecurityManager Short StackTraceElement StrictMath String " +
	      "StringBuffer System Thread ThreadGroup ThreadLocal Throwable Triple Void"
	    ),
	    multiLineStrings: true,
	    blockKeywords: words("catch class enum do else finally for forSome if match switch try while"),
	    defKeywords: words("class enum def object package trait type val var"),
	    atoms: words("true false null"),
	    indentStatements: false,
	    indentSwitch: false,
	    isOperatorChar: /[+\-*&%=<>!?|\/#:@]/,
	    hooks: {
	      "@": function(stream) {
	        stream.eatWhile(/[\w\$_]/);
	        return "meta";
	      },
	      '"': function(stream, state) {
	        if (!stream.match('""')) return false;
	        state.tokenize = tokenTripleString;
	        return state.tokenize(stream, state);
	      },
	      "'": function(stream) {
	        stream.eatWhile(/[\w\$_\xa1-\uffff]/);
	        return "atom";
	      },
	      "=": function(stream, state) {
	        var cx = state.context
	        if (cx.type == "}" && cx.align && stream.eat(">")) {
	          state.context = new Context(cx.indented, cx.column, cx.type, cx.info, null, cx.prev)
	          return "operator"
	        } else {
	          return false
	        }
	      },
	
	      "/": function(stream, state) {
	        if (!stream.eat("*")) return false
	        state.tokenize = tokenNestedComment(1)
	        return state.tokenize(stream, state)
	      }
	    },
	    modeProps: {closeBrackets: {pairs: '()[]{}""', triples: '"'}}
	  });
	
	  function tokenKotlinString(tripleString){
	    return function (stream, state) {
	      var escaped = false, next, end = false;
	      while (!stream.eol()) {
	        if (!tripleString && !escaped && stream.match('"') ) {end = true; break;}
	        if (tripleString && stream.match('"""')) {end = true; break;}
	        next = stream.next();
	        if(!escaped && next == "$" && stream.match('{'))
	          stream.skipTo("}");
	        escaped = !escaped && next == "\\" && !tripleString;
	      }
	      if (end || !tripleString)
	        state.tokenize = null;
	      return "string";
	    }
	  }
	
	  def("text/x-kotlin", {
	    name: "clike",
	    keywords: words(
	      /*keywords*/
	      "package as typealias class interface this super val operator " +
	      "var fun for is in This throw return annotation " +
	      "break continue object if else while do try when !in !is as? " +
	
	      /*soft keywords*/
	      "file import where by get set abstract enum open inner override private public internal " +
	      "protected catch finally out final vararg reified dynamic companion constructor init " +
	      "sealed field property receiver param sparam lateinit data inline noinline tailrec " +
	      "external annotation crossinline const operator infix suspend actual expect setparam"
	    ),
	    types: words(
	      /* package java.lang */
	      "Boolean Byte Character CharSequence Class ClassLoader Cloneable Comparable " +
	      "Compiler Double Exception Float Integer Long Math Number Object Package Pair Process " +
	      "Runtime Runnable SecurityManager Short StackTraceElement StrictMath String " +
	      "StringBuffer System Thread ThreadGroup ThreadLocal Throwable Triple Void Annotation Any BooleanArray " +
	      "ByteArray Char CharArray DeprecationLevel DoubleArray Enum FloatArray Function Int IntArray Lazy " +
	      "LazyThreadSafetyMode LongArray Nothing ShortArray Unit"
	    ),
	    intendSwitch: false,
	    indentStatements: false,
	    multiLineStrings: true,
	    number: /^(?:0x[a-f\d_]+|0b[01_]+|(?:[\d_]+(\.\d+)?|\.\d+)(?:e[-+]?[\d_]+)?)(u|ll?|l|f)?/i,
	    blockKeywords: words("catch class do else finally for if where try while enum"),
	    defKeywords: words("class val var object interface fun"),
	    atoms: words("true false null this"),
	    hooks: {
	      "@": function(stream) {
	        stream.eatWhile(/[\w\$_]/);
	        return "meta";
	      },
	      '*': function(_stream, state) {
	        return state.prevToken == '.' ? 'variable' : 'operator';
	      },
	      '"': function(stream, state) {
	        state.tokenize = tokenKotlinString(stream.match('""'));
	        return state.tokenize(stream, state);
	      },
	      "/": function(stream, state) {
	        if (!stream.eat("*")) return false;
	        state.tokenize = tokenNestedComment(1);
	        return state.tokenize(stream, state)
	      },
	      indent: function(state, ctx, textAfter, indentUnit) {
	        var firstChar = textAfter && textAfter.charAt(0);
	        if ((state.prevToken == "}" || state.prevToken == ")") && textAfter == "")
	          return state.indented;
	        if ((state.prevToken == "operator" && textAfter != "}" && state.context.type != "}") ||
	          state.prevToken == "variable" && firstChar == "." ||
	          (state.prevToken == "}" || state.prevToken == ")") && firstChar == ".")
	          return indentUnit * 2 + ctx.indented;
	        if (ctx.align && ctx.type == "}")
	          return ctx.indented + (state.context.type == (textAfter || "").charAt(0) ? 0 : indentUnit);
	      }
	    },
	    modeProps: {closeBrackets: {triples: '"'}}
	  });
	
	  def(["x-shader/x-vertex", "x-shader/x-fragment"], {
	    name: "clike",
	    keywords: words("sampler1D sampler2D sampler3D samplerCube " +
	                    "sampler1DShadow sampler2DShadow " +
	                    "const attribute uniform varying " +
	                    "break continue discard return " +
	                    "for while do if else struct " +
	                    "in out inout"),
	    types: words("float int bool void " +
	                 "vec2 vec3 vec4 ivec2 ivec3 ivec4 bvec2 bvec3 bvec4 " +
	                 "mat2 mat3 mat4"),
	    blockKeywords: words("for while do if else struct"),
	    builtin: words("radians degrees sin cos tan asin acos atan " +
	                    "pow exp log exp2 sqrt inversesqrt " +
	                    "abs sign floor ceil fract mod min max clamp mix step smoothstep " +
	                    "length distance dot cross normalize ftransform faceforward " +
	                    "reflect refract matrixCompMult " +
	                    "lessThan lessThanEqual greaterThan greaterThanEqual " +
	                    "equal notEqual any all not " +
	                    "texture1D texture1DProj texture1DLod texture1DProjLod " +
	                    "texture2D texture2DProj texture2DLod texture2DProjLod " +
	                    "texture3D texture3DProj texture3DLod texture3DProjLod " +
	                    "textureCube textureCubeLod " +
	                    "shadow1D shadow2D shadow1DProj shadow2DProj " +
	                    "shadow1DLod shadow2DLod shadow1DProjLod shadow2DProjLod " +
	                    "dFdx dFdy fwidth " +
	                    "noise1 noise2 noise3 noise4"),
	    atoms: words("true false " +
	                "gl_FragColor gl_SecondaryColor gl_Normal gl_Vertex " +
	                "gl_MultiTexCoord0 gl_MultiTexCoord1 gl_MultiTexCoord2 gl_MultiTexCoord3 " +
	                "gl_MultiTexCoord4 gl_MultiTexCoord5 gl_MultiTexCoord6 gl_MultiTexCoord7 " +
	                "gl_FogCoord gl_PointCoord " +
	                "gl_Position gl_PointSize gl_ClipVertex " +
	                "gl_FrontColor gl_BackColor gl_FrontSecondaryColor gl_BackSecondaryColor " +
	                "gl_TexCoord gl_FogFragCoord " +
	                "gl_FragCoord gl_FrontFacing " +
	                "gl_FragData gl_FragDepth " +
	                "gl_ModelViewMatrix gl_ProjectionMatrix gl_ModelViewProjectionMatrix " +
	                "gl_TextureMatrix gl_NormalMatrix gl_ModelViewMatrixInverse " +
	                "gl_ProjectionMatrixInverse gl_ModelViewProjectionMatrixInverse " +
	                "gl_TexureMatrixTranspose gl_ModelViewMatrixInverseTranspose " +
	                "gl_ProjectionMatrixInverseTranspose " +
	                "gl_ModelViewProjectionMatrixInverseTranspose " +
	                "gl_TextureMatrixInverseTranspose " +
	                "gl_NormalScale gl_DepthRange gl_ClipPlane " +
	                "gl_Point gl_FrontMaterial gl_BackMaterial gl_LightSource gl_LightModel " +
	                "gl_FrontLightModelProduct gl_BackLightModelProduct " +
	                "gl_TextureColor gl_EyePlaneS gl_EyePlaneT gl_EyePlaneR gl_EyePlaneQ " +
	                "gl_FogParameters " +
	                "gl_MaxLights gl_MaxClipPlanes gl_MaxTextureUnits gl_MaxTextureCoords " +
	                "gl_MaxVertexAttribs gl_MaxVertexUniformComponents gl_MaxVaryingFloats " +
	                "gl_MaxVertexTextureImageUnits gl_MaxTextureImageUnits " +
	                "gl_MaxFragmentUniformComponents gl_MaxCombineTextureImageUnits " +
	                "gl_MaxDrawBuffers"),
	    indentSwitch: false,
	    hooks: {"#": cppHook},
	    modeProps: {fold: ["brace", "include"]}
	  });
	
	  def("text/x-nesc", {
	    name: "clike",
	    keywords: words(cKeywords + " as atomic async call command component components configuration event generic " +
	                    "implementation includes interface module new norace nx_struct nx_union post provides " +
	                    "signal task uses abstract extends"),
	    types: cTypes,
	    blockKeywords: words(cBlockKeywords),
	    atoms: words("null true false"),
	    hooks: {"#": cppHook},
	    modeProps: {fold: ["brace", "include"]}
	  });
	
	  def("text/x-objectivec", {
	    name: "clike",
	    keywords: words(cKeywords + " " + objCKeywords),
	    types: objCTypes,
	    builtin: words(objCBuiltins),
	    blockKeywords: words(cBlockKeywords + " @synthesize @try @catch @finally @autoreleasepool @synchronized"),
	    defKeywords: words(cDefKeywords + " @interface @implementation @protocol @class"),
	    dontIndentStatements: /^@.*$/,
	    typeFirstDefinitions: true,
	    atoms: words("YES NO NULL Nil nil true false nullptr"),
	    isReservedIdentifier: cIsReservedIdentifier,
	    hooks: {
	      "#": cppHook,
	      "*": pointerHook,
	    },
	    modeProps: {fold: ["brace", "include"]}
	  });
	
	  def("text/x-objectivec++", {
	    name: "clike",
	    keywords: words(cKeywords + " " + objCKeywords + " " + cppKeywords),
	    types: objCTypes,
	    builtin: words(objCBuiltins),
	    blockKeywords: words(cBlockKeywords + " @synthesize @try @catch @finally @autoreleasepool @synchronized class try catch"),
	    defKeywords: words(cDefKeywords + " @interface @implementation @protocol @class class namespace"),
	    dontIndentStatements: /^@.*$|^template$/,
	    typeFirstDefinitions: true,
	    atoms: words("YES NO NULL Nil nil true false nullptr"),
	    isReservedIdentifier: cIsReservedIdentifier,
	    hooks: {
	      "#": cppHook,
	      "*": pointerHook,
	      "u": cpp11StringHook,
	      "U": cpp11StringHook,
	      "L": cpp11StringHook,
	      "R": cpp11StringHook,
	      "0": cpp14Literal,
	      "1": cpp14Literal,
	      "2": cpp14Literal,
	      "3": cpp14Literal,
	      "4": cpp14Literal,
	      "5": cpp14Literal,
	      "6": cpp14Literal,
	      "7": cpp14Literal,
	      "8": cpp14Literal,
	      "9": cpp14Literal,
	      token: function(stream, state, style) {
	        if (style == "variable" && stream.peek() == "(" &&
	            (state.prevToken == ";" || state.prevToken == null ||
	             state.prevToken == "}") &&
	            cppLooksLikeConstructor(stream.current()))
	          return "def";
	      }
	    },
	    namespaceSeparator: "::",
	    modeProps: {fold: ["brace", "include"]}
	  });
	
	  def("text/x-squirrel", {
	    name: "clike",
	    keywords: words("base break clone continue const default delete enum extends function in class" +
	                    " foreach local resume return this throw typeof yield constructor instanceof static"),
	    types: cTypes,
	    blockKeywords: words("case catch class else for foreach if switch try while"),
	    defKeywords: words("function local class"),
	    typeFirstDefinitions: true,
	    atoms: words("true false null"),
	    hooks: {"#": cppHook},
	    modeProps: {fold: ["brace", "include"]}
	  });
	
	  // Ceylon Strings need to deal with interpolation
	  var stringTokenizer = null;
	  function tokenCeylonString(type) {
	    return function(stream, state) {
	      var escaped = false, next, end = false;
	      while (!stream.eol()) {
	        if (!escaped && stream.match('"') &&
	              (type == "single" || stream.match('""'))) {
	          end = true;
	          break;
	        }
	        if (!escaped && stream.match('``')) {
	          stringTokenizer = tokenCeylonString(type);
	          end = true;
	          break;
	        }
	        next = stream.next();
	        escaped = type == "single" && !escaped && next == "\\";
	      }
	      if (end)
	          state.tokenize = null;
	      return "string";
	    }
	  }
	
	  def("text/x-ceylon", {
	    name: "clike",
	    keywords: words("abstracts alias assembly assert assign break case catch class continue dynamic else" +
	                    " exists extends finally for function given if import in interface is let module new" +
	                    " nonempty object of out outer package return satisfies super switch then this throw" +
	                    " try value void while"),
	    types: function(word) {
	        // In Ceylon all identifiers that start with an uppercase are types
	        var first = word.charAt(0);
	        return (first === first.toUpperCase() && first !== first.toLowerCase());
	    },
	    blockKeywords: words("case catch class dynamic else finally for function if interface module new object switch try while"),
	    defKeywords: words("class dynamic function interface module object package value"),
	    builtin: words("abstract actual aliased annotation by default deprecated doc final formal late license" +
	                   " native optional sealed see serializable shared suppressWarnings tagged throws variable"),
	    isPunctuationChar: /[\[\]{}\(\),;\:\.`]/,
	    isOperatorChar: /[+\-*&%=<>!?|^~:\/]/,
	    numberStart: /[\d#$]/,
	    number: /^(?:#[\da-fA-F_]+|\$[01_]+|[\d_]+[kMGTPmunpf]?|[\d_]+\.[\d_]+(?:[eE][-+]?\d+|[kMGTPmunpf]|)|)/i,
	    multiLineStrings: true,
	    typeFirstDefinitions: true,
	    atoms: words("true false null larger smaller equal empty finished"),
	    indentSwitch: false,
	    styleDefs: false,
	    hooks: {
	      "@": function(stream) {
	        stream.eatWhile(/[\w\$_]/);
	        return "meta";
	      },
	      '"': function(stream, state) {
	          state.tokenize = tokenCeylonString(stream.match('""') ? "triple" : "single");
	          return state.tokenize(stream, state);
	        },
	      '`': function(stream, state) {
	          if (!stringTokenizer || !stream.match('`')) return false;
	          state.tokenize = stringTokenizer;
	          stringTokenizer = null;
	          return state.tokenize(stream, state);
	        },
	      "'": function(stream) {
	        stream.eatWhile(/[\w\$_\xa1-\uffff]/);
	        return "atom";
	      },
	      token: function(_stream, state, style) {
	          if ((style == "variable" || style == "type") &&
	              state.prevToken == ".") {
	            return "variable-2";
	          }
	        }
	    },
	    modeProps: {
	        fold: ["brace", "import"],
	        closeBrackets: {triples: '"'}
	    }
	  });
	
	});


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(1), __webpack_require__(69), __webpack_require__(68), __webpack_require__(67));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror", "../xml/xml", "../javascript/javascript", "../css/css"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  "use strict";
	
	  var defaultTags = {
	    script: [
	      ["lang", /(javascript|babel)/i, "javascript"],
	      ["type", /^(?:text|application)\/(?:x-)?(?:java|ecma)script$|^module$|^$/i, "javascript"],
	      ["type", /./, "text/plain"],
	      [null, null, "javascript"]
	    ],
	    style:  [
	      ["lang", /^css$/i, "css"],
	      ["type", /^(text\/)?(x-)?(stylesheet|css)$/i, "css"],
	      ["type", /./, "text/plain"],
	      [null, null, "css"]
	    ]
	  };
	
	  function maybeBackup(stream, pat, style) {
	    var cur = stream.current(), close = cur.search(pat);
	    if (close > -1) {
	      stream.backUp(cur.length - close);
	    } else if (cur.match(/<\/?$/)) {
	      stream.backUp(cur.length);
	      if (!stream.match(pat, false)) stream.match(cur);
	    }
	    return style;
	  }
	
	  var attrRegexpCache = {};
	  function getAttrRegexp(attr) {
	    var regexp = attrRegexpCache[attr];
	    if (regexp) return regexp;
	    return attrRegexpCache[attr] = new RegExp("\\s+" + attr + "\\s*=\\s*('|\")?([^'\"]+)('|\")?\\s*");
	  }
	
	  function getAttrValue(text, attr) {
	    var match = text.match(getAttrRegexp(attr))
	    return match ? /^\s*(.*?)\s*$/.exec(match[2])[1] : ""
	  }
	
	  function getTagRegexp(tagName, anchored) {
	    return new RegExp((anchored ? "^" : "") + "<\/\s*" + tagName + "\s*>", "i");
	  }
	
	  function addTags(from, to) {
	    for (var tag in from) {
	      var dest = to[tag] || (to[tag] = []);
	      var source = from[tag];
	      for (var i = source.length - 1; i >= 0; i--)
	        dest.unshift(source[i])
	    }
	  }
	
	  function findMatchingMode(tagInfo, tagText) {
	    for (var i = 0; i < tagInfo.length; i++) {
	      var spec = tagInfo[i];
	      if (!spec[0] || spec[1].test(getAttrValue(tagText, spec[0]))) return spec[2];
	    }
	  }
	
	  CodeMirror.defineMode("htmlmixed", function (config, parserConfig) {
	    var htmlMode = CodeMirror.getMode(config, {
	      name: "xml",
	      htmlMode: true,
	      multilineTagIndentFactor: parserConfig.multilineTagIndentFactor,
	      multilineTagIndentPastTag: parserConfig.multilineTagIndentPastTag
	    });
	
	    var tags = {};
	    var configTags = parserConfig && parserConfig.tags, configScript = parserConfig && parserConfig.scriptTypes;
	    addTags(defaultTags, tags);
	    if (configTags) addTags(configTags, tags);
	    if (configScript) for (var i = configScript.length - 1; i >= 0; i--)
	      tags.script.unshift(["type", configScript[i].matches, configScript[i].mode])
	
	    function html(stream, state) {
	      var style = htmlMode.token(stream, state.htmlState), tag = /\btag\b/.test(style), tagName
	      if (tag && !/[<>\s\/]/.test(stream.current()) &&
	          (tagName = state.htmlState.tagName && state.htmlState.tagName.toLowerCase()) &&
	          tags.hasOwnProperty(tagName)) {
	        state.inTag = tagName + " "
	      } else if (state.inTag && tag && />$/.test(stream.current())) {
	        var inTag = /^([\S]+) (.*)/.exec(state.inTag)
	        state.inTag = null
	        var modeSpec = stream.current() == ">" && findMatchingMode(tags[inTag[1]], inTag[2])
	        var mode = CodeMirror.getMode(config, modeSpec)
	        var endTagA = getTagRegexp(inTag[1], true), endTag = getTagRegexp(inTag[1], false);
	        state.token = function (stream, state) {
	          if (stream.match(endTagA, false)) {
	            state.token = html;
	            state.localState = state.localMode = null;
	            return null;
	          }
	          return maybeBackup(stream, endTag, state.localMode.token(stream, state.localState));
	        };
	        state.localMode = mode;
	        state.localState = CodeMirror.startState(mode, htmlMode.indent(state.htmlState, "", ""));
	      } else if (state.inTag) {
	        state.inTag += stream.current()
	        if (stream.eol()) state.inTag += " "
	      }
	      return style;
	    };
	
	    return {
	      startState: function () {
	        var state = CodeMirror.startState(htmlMode);
	        return {token: html, inTag: null, localMode: null, localState: null, htmlState: state};
	      },
	
	      copyState: function (state) {
	        var local;
	        if (state.localState) {
	          local = CodeMirror.copyState(state.localMode, state.localState);
	        }
	        return {token: state.token, inTag: state.inTag,
	                localMode: state.localMode, localState: local,
	                htmlState: CodeMirror.copyState(htmlMode, state.htmlState)};
	      },
	
	      token: function (stream, state) {
	        return state.token(stream, state);
	      },
	
	      indent: function (state, textAfter, line) {
	        if (!state.localMode || /^\s*<\//.test(textAfter))
	          return htmlMode.indent(state.htmlState, textAfter, line);
	        else if (state.localMode.indent)
	          return state.localMode.indent(state.localState, textAfter, line);
	        else
	          return CodeMirror.Pass;
	      },
	
	      innerMode: function (state) {
	        return {state: state.localState || state.htmlState, mode: state.localMode || htmlMode};
	      }
	    };
	  }, "xml", "javascript", "css");
	
	  CodeMirror.defineMIME("text/html", "htmlmixed");
	});


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx = __webpack_require__(41);
	var IObject = __webpack_require__(109);
	var toObject = __webpack_require__(51);
	var toLength = __webpack_require__(88);
	var asc = __webpack_require__(337);
	module.exports = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || asc;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IObject(O);
	    var f = ctx(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      val = self[index];
	      res = f(val, index, O);
	      if (TYPE) {
	        if (IS_MAP) result[index] = res;   // map
	        else if (res) switch (TYPE) {
	          case 3: return true;             // some
	          case 5: return val;              // find
	          case 6: return index;            // findIndex
	          case 2: result.push(val);        // filter
	        } else if (IS_EVERY) return false; // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(17);
	var $export = __webpack_require__(14);
	var meta = __webpack_require__(73);
	var fails = __webpack_require__(50);
	var hide = __webpack_require__(46);
	var redefineAll = __webpack_require__(87);
	var forOf = __webpack_require__(58);
	var anInstance = __webpack_require__(84);
	var isObject = __webpack_require__(27);
	var setToStringTag = __webpack_require__(76);
	var dP = __webpack_require__(37).f;
	var each = __webpack_require__(104)(0);
	var DESCRIPTORS = __webpack_require__(33);
	
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  if (!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    C = wrapper(function (target, iterable) {
	      anInstance(target, C, NAME, '_c');
	      target._c = new Base();
	      if (iterable != undefined) forOf(iterable, IS_MAP, target[ADDER], target);
	    });
	    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
	      var IS_ADDER = KEY == 'add' || KEY == 'set';
	      if (KEY in proto && !(IS_WEAK && KEY == 'clear')) hide(C.prototype, KEY, function (a, b) {
	        anInstance(this, C, KEY);
	        if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
	        var result = this._c[KEY](a === 0 ? 0 : a, b);
	        return IS_ADDER ? this : result;
	      });
	    });
	    IS_WEAK || dP(C.prototype, 'size', {
	      get: function () {
	        return this._c.size;
	      }
	    });
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F, O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};


/***/ }),
/* 106 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(27);
	var document = __webpack_require__(17).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 108 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(71);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(72);
	var $export = __webpack_require__(14);
	var redefine = __webpack_require__(115);
	var hide = __webpack_require__(46);
	var Iterators = __webpack_require__(59);
	var $iterCreate = __webpack_require__(342);
	var setToStringTag = __webpack_require__(76);
	var getPrototypeOf = __webpack_require__(165);
	var ITERATOR = __webpack_require__(19)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(70);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(74);
	var createDesc = __webpack_require__(75);
	var toIObject = __webpack_require__(47);
	var toPrimitive = __webpack_require__(121);
	var has = __webpack_require__(45);
	var IE8_DOM_DEFINE = __webpack_require__(157);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(33) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),
/* 113 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(14);
	var core = __webpack_require__(4);
	var fails = __webpack_require__(50);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(46);


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(14);
	var aFunction = __webpack_require__(70);
	var ctx = __webpack_require__(41);
	var forOf = __webpack_require__(58);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
	    var mapFn = arguments[1];
	    var mapping, A, n, cb;
	    aFunction(this);
	    mapping = mapFn !== undefined;
	    if (mapping) aFunction(mapFn);
	    if (source == undefined) return new this();
	    A = [];
	    if (mapping) {
	      n = 0;
	      cb = ctx(mapFn, arguments[2], 2);
	      forOf(source, false, function (nextItem) {
	        A.push(cb(nextItem, n++));
	      });
	    } else {
	      forOf(source, false, A.push, A);
	    }
	    return new this(A);
	  } });
	};


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(14);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { of: function of() {
	    var length = arguments.length;
	    var A = new Array(length);
	    while (length--) A[length] = arguments[length];
	    return new this(A);
	  } });
	};


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(119)('keys');
	var uid = __webpack_require__(89);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(4);
	var global = __webpack_require__(17);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(72) ? 'pure' : 'global',
	  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
	});


/***/ }),
/* 120 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(27);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(17);
	var core = __webpack_require__(4);
	var LIBRARY = __webpack_require__(72);
	var wksExt = __webpack_require__(123);
	var defineProperty = __webpack_require__(37).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(19);


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(85);
	var ITERATOR = __webpack_require__(19)('iterator');
	var Iterators = __webpack_require__(59);
	module.exports = __webpack_require__(4).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 76);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
	/* globals __VUE_SSR_CONTEXT__ */
	
	// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
	// This module is a runtime utility for cleaner component module output and will
	// be included in the final webpack user bundle.
	
	function normalizeComponent (
	  scriptExports,
	  render,
	  staticRenderFns,
	  functionalTemplate,
	  injectStyles,
	  scopeId,
	  moduleIdentifier, /* server only */
	  shadowMode /* vue-cli only */
	) {
	  // Vue.extend constructor export interop
	  var options = typeof scriptExports === 'function'
	    ? scriptExports.options
	    : scriptExports
	
	  // render functions
	  if (render) {
	    options.render = render
	    options.staticRenderFns = staticRenderFns
	    options._compiled = true
	  }
	
	  // functional template
	  if (functionalTemplate) {
	    options.functional = true
	  }
	
	  // scopedId
	  if (scopeId) {
	    options._scopeId = 'data-v-' + scopeId
	  }
	
	  var hook
	  if (moduleIdentifier) { // server build
	    hook = function (context) {
	      // 2.3 injection
	      context =
	        context || // cached call
	        (this.$vnode && this.$vnode.ssrContext) || // stateful
	        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
	      // 2.2 with runInNewContext: true
	      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
	        context = __VUE_SSR_CONTEXT__
	      }
	      // inject component styles
	      if (injectStyles) {
	        injectStyles.call(this, context)
	      }
	      // register component module identifier for async chunk inferrence
	      if (context && context._registeredComponents) {
	        context._registeredComponents.add(moduleIdentifier)
	      }
	    }
	    // used by ssr in case component is cached and beforeCreate
	    // never gets called
	    options._ssrRegister = hook
	  } else if (injectStyles) {
	    hook = shadowMode
	      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
	      : injectStyles
	  }
	
	  if (hook) {
	    if (options.functional) {
	      // for template-only hot-reload because in that case the render fn doesn't
	      // go through the normalizer
	      options._injectStyles = hook
	      // register for functioal component in vue file
	      var originalRender = options.render
	      options.render = function renderWithStyleInjection (h, context) {
	        hook.call(context)
	        return originalRender(h, context)
	      }
	    } else {
	      // inject component registration as beforeCreate hook
	      var existing = options.beforeCreate
	      options.beforeCreate = existing
	        ? [].concat(existing, hook)
	        : [hook]
	    }
	  }
	
	  return {
	    exports: scriptExports,
	    options: options
	  }
	}
	
	
	/***/ }),
	
	/***/ 11:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(175);
	
	/***/ }),
	
	/***/ 21:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(92);
	
	/***/ }),
	
	/***/ 4:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(54);
	
	/***/ }),
	
	/***/ 76:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/input/src/input.vue?vue&type=template&id=343dd774&
	var render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      class: [
	        _vm.type === "textarea" ? "el-textarea" : "el-input",
	        _vm.inputSize ? "el-input--" + _vm.inputSize : "",
	        {
	          "is-disabled": _vm.inputDisabled,
	          "is-exceed": _vm.inputExceed,
	          "el-input-group": _vm.$slots.prepend || _vm.$slots.append,
	          "el-input-group--append": _vm.$slots.append,
	          "el-input-group--prepend": _vm.$slots.prepend,
	          "el-input--prefix": _vm.$slots.prefix || _vm.prefixIcon,
	          "el-input--suffix":
	            _vm.$slots.suffix ||
	            _vm.suffixIcon ||
	            _vm.clearable ||
	            _vm.showPassword
	        }
	      ],
	      on: {
	        mouseenter: function($event) {
	          _vm.hovering = true
	        },
	        mouseleave: function($event) {
	          _vm.hovering = false
	        }
	      }
	    },
	    [
	      _vm.type !== "textarea"
	        ? [
	            _vm.$slots.prepend
	              ? _c(
	                  "div",
	                  { staticClass: "el-input-group__prepend" },
	                  [_vm._t("prepend")],
	                  2
	                )
	              : _vm._e(),
	            _vm.type !== "textarea"
	              ? _c(
	                  "input",
	                  _vm._b(
	                    {
	                      ref: "input",
	                      staticClass: "el-input__inner",
	                      attrs: {
	                        tabindex: _vm.tabindex,
	                        type: _vm.showPassword
	                          ? _vm.passwordVisible
	                            ? "text"
	                            : "password"
	                          : _vm.type,
	                        disabled: _vm.inputDisabled,
	                        readonly: _vm.readonly,
	                        autocomplete: _vm.autoComplete || _vm.autocomplete,
	                        "aria-label": _vm.label
	                      },
	                      on: {
	                        compositionstart: _vm.handleCompositionStart,
	                        compositionupdate: _vm.handleCompositionUpdate,
	                        compositionend: _vm.handleCompositionEnd,
	                        input: _vm.handleInput,
	                        focus: _vm.handleFocus,
	                        blur: _vm.handleBlur,
	                        change: _vm.handleChange
	                      }
	                    },
	                    "input",
	                    _vm.$attrs,
	                    false
	                  )
	                )
	              : _vm._e(),
	            _vm.$slots.prefix || _vm.prefixIcon
	              ? _c(
	                  "span",
	                  { staticClass: "el-input__prefix" },
	                  [
	                    _vm._t("prefix"),
	                    _vm.prefixIcon
	                      ? _c("i", {
	                          staticClass: "el-input__icon",
	                          class: _vm.prefixIcon
	                        })
	                      : _vm._e()
	                  ],
	                  2
	                )
	              : _vm._e(),
	            _vm.getSuffixVisible()
	              ? _c("span", { staticClass: "el-input__suffix" }, [
	                  _c(
	                    "span",
	                    { staticClass: "el-input__suffix-inner" },
	                    [
	                      !_vm.showClear ||
	                      !_vm.showPwdVisible ||
	                      !_vm.isWordLimitVisible
	                        ? [
	                            _vm._t("suffix"),
	                            _vm.suffixIcon
	                              ? _c("i", {
	                                  staticClass: "el-input__icon",
	                                  class: _vm.suffixIcon
	                                })
	                              : _vm._e()
	                          ]
	                        : _vm._e(),
	                      _vm.showClear
	                        ? _c("i", {
	                            staticClass:
	                              "el-input__icon el-icon-circle-close el-input__clear",
	                            on: {
	                              mousedown: function($event) {
	                                $event.preventDefault()
	                              },
	                              click: _vm.clear
	                            }
	                          })
	                        : _vm._e(),
	                      _vm.showPwdVisible
	                        ? _c("i", {
	                            staticClass:
	                              "el-input__icon el-icon-view el-input__clear",
	                            on: { click: _vm.handlePasswordVisible }
	                          })
	                        : _vm._e(),
	                      _vm.isWordLimitVisible
	                        ? _c("span", { staticClass: "el-input__count" }, [
	                            _c(
	                              "span",
	                              { staticClass: "el-input__count-inner" },
	                              [
	                                _vm._v(
	                                  "\n            " +
	                                    _vm._s(_vm.textLength) +
	                                    "/" +
	                                    _vm._s(_vm.upperLimit) +
	                                    "\n          "
	                                )
	                              ]
	                            )
	                          ])
	                        : _vm._e()
	                    ],
	                    2
	                  ),
	                  _vm.validateState
	                    ? _c("i", {
	                        staticClass: "el-input__icon",
	                        class: ["el-input__validateIcon", _vm.validateIcon]
	                      })
	                    : _vm._e()
	                ])
	              : _vm._e(),
	            _vm.$slots.append
	              ? _c(
	                  "div",
	                  { staticClass: "el-input-group__append" },
	                  [_vm._t("append")],
	                  2
	                )
	              : _vm._e()
	          ]
	        : _c(
	            "textarea",
	            _vm._b(
	              {
	                ref: "textarea",
	                staticClass: "el-textarea__inner",
	                style: _vm.textareaStyle,
	                attrs: {
	                  tabindex: _vm.tabindex,
	                  disabled: _vm.inputDisabled,
	                  readonly: _vm.readonly,
	                  autocomplete: _vm.autoComplete || _vm.autocomplete,
	                  "aria-label": _vm.label
	                },
	                on: {
	                  compositionstart: _vm.handleCompositionStart,
	                  compositionupdate: _vm.handleCompositionUpdate,
	                  compositionend: _vm.handleCompositionEnd,
	                  input: _vm.handleInput,
	                  focus: _vm.handleFocus,
	                  blur: _vm.handleBlur,
	                  change: _vm.handleChange
	                }
	              },
	              "textarea",
	              _vm.$attrs,
	              false
	            )
	          ),
	      _vm.isWordLimitVisible && _vm.type === "textarea"
	        ? _c("span", { staticClass: "el-input__count" }, [
	            _vm._v(_vm._s(_vm.textLength) + "/" + _vm._s(_vm.upperLimit))
	          ])
	        : _vm._e()
	    ],
	    2
	  )
	}
	var staticRenderFns = []
	render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/input/src/input.vue?vue&type=template&id=343dd774&
	
	// EXTERNAL MODULE: external "element-ui/lib/mixins/emitter"
	var emitter_ = __webpack_require__(4);
	var emitter_default = /*#__PURE__*/__webpack_require__.n(emitter_);
	
	// EXTERNAL MODULE: external "element-ui/lib/mixins/migrating"
	var migrating_ = __webpack_require__(11);
	var migrating_default = /*#__PURE__*/__webpack_require__.n(migrating_);
	
	// CONCATENATED MODULE: ./packages/input/src/calcTextareaHeight.js
	var hiddenTextarea = void 0;
	
	var HIDDEN_STYLE = '\n  height:0 !important;\n  visibility:hidden !important;\n  overflow:hidden !important;\n  position:absolute !important;\n  z-index:-1000 !important;\n  top:0 !important;\n  right:0 !important\n';
	
	var CONTEXT_STYLE = ['letter-spacing', 'line-height', 'padding-top', 'padding-bottom', 'font-family', 'font-weight', 'font-size', 'text-rendering', 'text-transform', 'width', 'text-indent', 'padding-left', 'padding-right', 'border-width', 'box-sizing'];
	
	function calculateNodeStyling(targetElement) {
	  var style = window.getComputedStyle(targetElement);
	
	  var boxSizing = style.getPropertyValue('box-sizing');
	
	  var paddingSize = parseFloat(style.getPropertyValue('padding-bottom')) + parseFloat(style.getPropertyValue('padding-top'));
	
	  var borderSize = parseFloat(style.getPropertyValue('border-bottom-width')) + parseFloat(style.getPropertyValue('border-top-width'));
	
	  var contextStyle = CONTEXT_STYLE.map(function (name) {
	    return name + ':' + style.getPropertyValue(name);
	  }).join(';');
	
	  return { contextStyle: contextStyle, paddingSize: paddingSize, borderSize: borderSize, boxSizing: boxSizing };
	}
	
	function calcTextareaHeight(targetElement) {
	  var minRows = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	  var maxRows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	  if (!hiddenTextarea) {
	    hiddenTextarea = document.createElement('textarea');
	    document.body.appendChild(hiddenTextarea);
	  }
	
	  var _calculateNodeStyling = calculateNodeStyling(targetElement),
	      paddingSize = _calculateNodeStyling.paddingSize,
	      borderSize = _calculateNodeStyling.borderSize,
	      boxSizing = _calculateNodeStyling.boxSizing,
	      contextStyle = _calculateNodeStyling.contextStyle;
	
	  hiddenTextarea.setAttribute('style', contextStyle + ';' + HIDDEN_STYLE);
	  hiddenTextarea.value = targetElement.value || targetElement.placeholder || '';
	
	  var height = hiddenTextarea.scrollHeight;
	  var result = {};
	
	  if (boxSizing === 'border-box') {
	    height = height + borderSize;
	  } else if (boxSizing === 'content-box') {
	    height = height - paddingSize;
	  }
	
	  hiddenTextarea.value = '';
	  var singleRowHeight = hiddenTextarea.scrollHeight - paddingSize;
	
	  if (minRows !== null) {
	    var minHeight = singleRowHeight * minRows;
	    if (boxSizing === 'border-box') {
	      minHeight = minHeight + paddingSize + borderSize;
	    }
	    height = Math.max(minHeight, height);
	    result.minHeight = minHeight + 'px';
	  }
	  if (maxRows !== null) {
	    var maxHeight = singleRowHeight * maxRows;
	    if (boxSizing === 'border-box') {
	      maxHeight = maxHeight + paddingSize + borderSize;
	    }
	    height = Math.min(maxHeight, height);
	  }
	  result.height = height + 'px';
	  hiddenTextarea.parentNode && hiddenTextarea.parentNode.removeChild(hiddenTextarea);
	  hiddenTextarea = null;
	  return result;
	};
	// EXTERNAL MODULE: external "element-ui/lib/utils/merge"
	var merge_ = __webpack_require__(9);
	var merge_default = /*#__PURE__*/__webpack_require__.n(merge_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/shared"
	var shared_ = __webpack_require__(21);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/input/src/input.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	/* harmony default export */ var inputvue_type_script_lang_js_ = ({
	  name: 'ElInput',
	
	  componentName: 'ElInput',
	
	  mixins: [emitter_default.a, migrating_default.a],
	
	  inheritAttrs: false,
	
	  inject: {
	    elForm: {
	      default: ''
	    },
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  data: function data() {
	    return {
	      textareaCalcStyle: {},
	      hovering: false,
	      focused: false,
	      isComposing: false,
	      passwordVisible: false
	    };
	  },
	
	
	  props: {
	    value: [String, Number],
	    size: String,
	    resize: String,
	    form: String,
	    disabled: Boolean,
	    readonly: Boolean,
	    type: {
	      type: String,
	      default: 'text'
	    },
	    autosize: {
	      type: [Boolean, Object],
	      default: false
	    },
	    autocomplete: {
	      type: String,
	      default: 'off'
	    },
	    /** @Deprecated in next major version */
	    autoComplete: {
	      type: String,
	      validator: function validator(val) {
	         false && false;
	        return true;
	      }
	    },
	    validateEvent: {
	      type: Boolean,
	      default: true
	    },
	    suffixIcon: String,
	    prefixIcon: String,
	    label: String,
	    clearable: {
	      type: Boolean,
	      default: false
	    },
	    showPassword: {
	      type: Boolean,
	      default: false
	    },
	    showWordLimit: {
	      type: Boolean,
	      default: false
	    },
	    tabindex: String
	  },
	
	  computed: {
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    validateState: function validateState() {
	      return this.elFormItem ? this.elFormItem.validateState : '';
	    },
	    needStatusIcon: function needStatusIcon() {
	      return this.elForm ? this.elForm.statusIcon : false;
	    },
	    validateIcon: function validateIcon() {
	      return {
	        validating: 'el-icon-loading',
	        success: 'el-icon-circle-check',
	        error: 'el-icon-circle-close'
	      }[this.validateState];
	    },
	    textareaStyle: function textareaStyle() {
	      return merge_default()({}, this.textareaCalcStyle, { resize: this.resize });
	    },
	    inputSize: function inputSize() {
	      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
	    },
	    inputDisabled: function inputDisabled() {
	      return this.disabled || (this.elForm || {}).disabled;
	    },
	    nativeInputValue: function nativeInputValue() {
	      return this.value === null || this.value === undefined ? '' : String(this.value);
	    },
	    showClear: function showClear() {
	      return this.clearable && !this.inputDisabled && !this.readonly && this.nativeInputValue && (this.focused || this.hovering);
	    },
	    showPwdVisible: function showPwdVisible() {
	      return this.showPassword && !this.inputDisabled && !this.readonly && (!!this.nativeInputValue || this.focused);
	    },
	    isWordLimitVisible: function isWordLimitVisible() {
	      return this.showWordLimit && this.$attrs.maxlength && (this.type === 'text' || this.type === 'textarea') && !this.inputDisabled && !this.readonly && !this.showPassword;
	    },
	    upperLimit: function upperLimit() {
	      return this.$attrs.maxlength;
	    },
	    textLength: function textLength() {
	      if (typeof this.value === 'number') {
	        return String(this.value).length;
	      }
	
	      return (this.value || '').length;
	    },
	    inputExceed: function inputExceed() {
	      // show exceed style if length of initial value greater then maxlength
	      return this.isWordLimitVisible && this.textLength > this.upperLimit;
	    }
	  },
	
	  watch: {
	    value: function value(val) {
	      this.$nextTick(this.resizeTextarea);
	      if (this.validateEvent) {
	        this.dispatch('ElFormItem', 'el.form.change', [val]);
	      }
	    },
	
	    // native input value is set explicitly
	    // do not use v-model / :value in template
	    // see: https://github.com/ElemeFE/element/issues/14521
	    nativeInputValue: function nativeInputValue() {
	      this.setNativeInputValue();
	    },
	
	    // when change between <input> and <textarea>,
	    // update DOM dependent value and styles
	    // https://github.com/ElemeFE/element/issues/14857
	    type: function type() {
	      var _this = this;
	
	      this.$nextTick(function () {
	        _this.setNativeInputValue();
	        _this.resizeTextarea();
	        _this.updateIconOffset();
	      });
	    }
	  },
	
	  methods: {
	    focus: function focus() {
	      this.getInput().focus();
	    },
	    blur: function blur() {
	      this.getInput().blur();
	    },
	    getMigratingConfig: function getMigratingConfig() {
	      return {
	        props: {
	          'icon': 'icon is removed, use suffix-icon / prefix-icon instead.',
	          'on-icon-click': 'on-icon-click is removed.'
	        },
	        events: {
	          'click': 'click is removed.'
	        }
	      };
	    },
	    handleBlur: function handleBlur(event) {
	      this.focused = false;
	      this.$emit('blur', event);
	      if (this.validateEvent) {
	        this.dispatch('ElFormItem', 'el.form.blur', [this.value]);
	      }
	    },
	    select: function select() {
	      this.getInput().select();
	    },
	    resizeTextarea: function resizeTextarea() {
	      if (this.$isServer) return;
	      var autosize = this.autosize,
	          type = this.type;
	
	      if (type !== 'textarea') return;
	      if (!autosize) {
	        this.textareaCalcStyle = {
	          minHeight: calcTextareaHeight(this.$refs.textarea).minHeight
	        };
	        return;
	      }
	      var minRows = autosize.minRows;
	      var maxRows = autosize.maxRows;
	
	      this.textareaCalcStyle = calcTextareaHeight(this.$refs.textarea, minRows, maxRows);
	    },
	    setNativeInputValue: function setNativeInputValue() {
	      var input = this.getInput();
	      if (!input) return;
	      if (input.value === this.nativeInputValue) return;
	      input.value = this.nativeInputValue;
	    },
	    handleFocus: function handleFocus(event) {
	      this.focused = true;
	      this.$emit('focus', event);
	    },
	    handleCompositionStart: function handleCompositionStart() {
	      this.isComposing = true;
	    },
	    handleCompositionUpdate: function handleCompositionUpdate(event) {
	      var text = event.target.value;
	      var lastCharacter = text[text.length - 1] || '';
	      this.isComposing = !Object(shared_["isKorean"])(lastCharacter);
	    },
	    handleCompositionEnd: function handleCompositionEnd(event) {
	      if (this.isComposing) {
	        this.isComposing = false;
	        this.handleInput(event);
	      }
	    },
	    handleInput: function handleInput(event) {
	      // should not emit input during composition
	      // see: https://github.com/ElemeFE/element/issues/10516
	      if (this.isComposing) return;
	
	      // hack for https://github.com/ElemeFE/element/issues/8548
	      // should remove the following line when we don't support IE
	      if (event.target.value === this.nativeInputValue) return;
	
	      this.$emit('input', event.target.value);
	
	      // ensure native input value is controlled
	      // see: https://github.com/ElemeFE/element/issues/12850
	      this.$nextTick(this.setNativeInputValue);
	    },
	    handleChange: function handleChange(event) {
	      this.$emit('change', event.target.value);
	    },
	    calcIconOffset: function calcIconOffset(place) {
	      var elList = [].slice.call(this.$el.querySelectorAll('.el-input__' + place) || []);
	      if (!elList.length) return;
	      var el = null;
	      for (var i = 0; i < elList.length; i++) {
	        if (elList[i].parentNode === this.$el) {
	          el = elList[i];
	          break;
	        }
	      }
	      if (!el) return;
	      var pendantMap = {
	        suffix: 'append',
	        prefix: 'prepend'
	      };
	
	      var pendant = pendantMap[place];
	      if (this.$slots[pendant]) {
	        el.style.transform = 'translateX(' + (place === 'suffix' ? '-' : '') + this.$el.querySelector('.el-input-group__' + pendant).offsetWidth + 'px)';
	      } else {
	        el.removeAttribute('style');
	      }
	    },
	    updateIconOffset: function updateIconOffset() {
	      this.calcIconOffset('prefix');
	      this.calcIconOffset('suffix');
	    },
	    clear: function clear() {
	      this.$emit('input', '');
	      this.$emit('change', '');
	      this.$emit('clear');
	    },
	    handlePasswordVisible: function handlePasswordVisible() {
	      this.passwordVisible = !this.passwordVisible;
	      this.focus();
	    },
	    getInput: function getInput() {
	      return this.$refs.input || this.$refs.textarea;
	    },
	    getSuffixVisible: function getSuffixVisible() {
	      return this.$slots.suffix || this.suffixIcon || this.showClear || this.showPassword || this.isWordLimitVisible || this.validateState && this.needStatusIcon;
	    }
	  },
	
	  created: function created() {
	    this.$on('inputSelect', this.select);
	  },
	  mounted: function mounted() {
	    this.setNativeInputValue();
	    this.resizeTextarea();
	    this.updateIconOffset();
	  },
	  updated: function updated() {
	    this.$nextTick(this.updateIconOffset);
	  }
	});
	// CONCATENATED MODULE: ./packages/input/src/input.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_inputvue_type_script_lang_js_ = (inputvue_type_script_lang_js_); 
	// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
	var componentNormalizer = __webpack_require__(0);
	
	// CONCATENATED MODULE: ./packages/input/src/input.vue
	
	
	
	
	
	/* normalize component */
	
	var component = Object(componentNormalizer["a" /* default */])(
	  src_inputvue_type_script_lang_js_,
	  render,
	  staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var api; }
	component.options.__file = "packages/input/src/input.vue"
	/* harmony default export */ var input = (component.exports);
	// CONCATENATED MODULE: ./packages/input/index.js
	
	
	/* istanbul ignore next */
	input.install = function (Vue) {
	  Vue.component(input.name, input);
	};
	
	/* harmony default export */ var packages_input = __webpack_exports__["default"] = (input);
	
	/***/ }),
	
	/***/ 9:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(91);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 126 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (ref) {
	  return {
	    methods: {
	      focus: function focus() {
	        this.$refs[ref].focus();
	      }
	    }
	  };
	};
	
	;

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _locale = __webpack_require__(90);
	
	exports.default = {
	  methods: {
	    t: function t() {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _locale.t.apply(this, args);
	    }
	  }
	};

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 127);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 127:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/resize-event"
	var resize_event_ = __webpack_require__(16);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/scrollbar-width"
	var scrollbar_width_ = __webpack_require__(39);
	var scrollbar_width_default = /*#__PURE__*/__webpack_require__.n(scrollbar_width_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/util"
	var util_ = __webpack_require__(3);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/dom"
	var dom_ = __webpack_require__(2);
	
	// CONCATENATED MODULE: ./packages/scrollbar/src/util.js
	var BAR_MAP = {
	  vertical: {
	    offset: 'offsetHeight',
	    scroll: 'scrollTop',
	    scrollSize: 'scrollHeight',
	    size: 'height',
	    key: 'vertical',
	    axis: 'Y',
	    client: 'clientY',
	    direction: 'top'
	  },
	  horizontal: {
	    offset: 'offsetWidth',
	    scroll: 'scrollLeft',
	    scrollSize: 'scrollWidth',
	    size: 'width',
	    key: 'horizontal',
	    axis: 'X',
	    client: 'clientX',
	    direction: 'left'
	  }
	};
	
	function renderThumbStyle(_ref) {
	  var move = _ref.move,
	      size = _ref.size,
	      bar = _ref.bar;
	
	  var style = {};
	  var translate = 'translate' + bar.axis + '(' + move + '%)';
	
	  style[bar.size] = size;
	  style.transform = translate;
	  style.msTransform = translate;
	  style.webkitTransform = translate;
	
	  return style;
	};
	// CONCATENATED MODULE: ./packages/scrollbar/src/bar.js
	
	
	
	/* istanbul ignore next */
	/* harmony default export */ var src_bar = ({
	  name: 'Bar',
	
	  props: {
	    vertical: Boolean,
	    size: String,
	    move: Number
	  },
	
	  computed: {
	    bar: function bar() {
	      return BAR_MAP[this.vertical ? 'vertical' : 'horizontal'];
	    },
	    wrap: function wrap() {
	      return this.$parent.wrap;
	    }
	  },
	
	  render: function render(h) {
	    var size = this.size,
	        move = this.move,
	        bar = this.bar;
	
	
	    return h(
	      'div',
	      {
	        'class': ['el-scrollbar__bar', 'is-' + bar.key],
	        on: {
	          'mousedown': this.clickTrackHandler
	        }
	      },
	      [h('div', {
	        ref: 'thumb',
	        'class': 'el-scrollbar__thumb',
	        on: {
	          'mousedown': this.clickThumbHandler
	        },
	
	        style: renderThumbStyle({ size: size, move: move, bar: bar }) })]
	    );
	  },
	
	
	  methods: {
	    clickThumbHandler: function clickThumbHandler(e) {
	      // prevent click event of right button
	      if (e.ctrlKey || e.button === 2) {
	        return;
	      }
	      this.startDrag(e);
	      this[this.bar.axis] = e.currentTarget[this.bar.offset] - (e[this.bar.client] - e.currentTarget.getBoundingClientRect()[this.bar.direction]);
	    },
	    clickTrackHandler: function clickTrackHandler(e) {
	      var offset = Math.abs(e.target.getBoundingClientRect()[this.bar.direction] - e[this.bar.client]);
	      var thumbHalf = this.$refs.thumb[this.bar.offset] / 2;
	      var thumbPositionPercentage = (offset - thumbHalf) * 100 / this.$el[this.bar.offset];
	
	      this.wrap[this.bar.scroll] = thumbPositionPercentage * this.wrap[this.bar.scrollSize] / 100;
	    },
	    startDrag: function startDrag(e) {
	      e.stopImmediatePropagation();
	      this.cursorDown = true;
	
	      Object(dom_["on"])(document, 'mousemove', this.mouseMoveDocumentHandler);
	      Object(dom_["on"])(document, 'mouseup', this.mouseUpDocumentHandler);
	      document.onselectstart = function () {
	        return false;
	      };
	    },
	    mouseMoveDocumentHandler: function mouseMoveDocumentHandler(e) {
	      if (this.cursorDown === false) return;
	      var prevPage = this[this.bar.axis];
	
	      if (!prevPage) return;
	
	      var offset = (this.$el.getBoundingClientRect()[this.bar.direction] - e[this.bar.client]) * -1;
	      var thumbClickPosition = this.$refs.thumb[this.bar.offset] - prevPage;
	      var thumbPositionPercentage = (offset - thumbClickPosition) * 100 / this.$el[this.bar.offset];
	
	      this.wrap[this.bar.scroll] = thumbPositionPercentage * this.wrap[this.bar.scrollSize] / 100;
	    },
	    mouseUpDocumentHandler: function mouseUpDocumentHandler(e) {
	      this.cursorDown = false;
	      this[this.bar.axis] = 0;
	      Object(dom_["off"])(document, 'mousemove', this.mouseMoveDocumentHandler);
	      document.onselectstart = null;
	    }
	  },
	
	  destroyed: function destroyed() {
	    Object(dom_["off"])(document, 'mouseup', this.mouseUpDocumentHandler);
	  }
	});
	// CONCATENATED MODULE: ./packages/scrollbar/src/main.js
	// reference https://github.com/noeldelgado/gemini-scrollbar/blob/master/index.js
	
	
	
	
	
	
	/* istanbul ignore next */
	/* harmony default export */ var main = ({
	  name: 'ElScrollbar',
	
	  components: { Bar: src_bar },
	
	  props: {
	    native: Boolean,
	    wrapStyle: {},
	    wrapClass: {},
	    viewClass: {},
	    viewStyle: {},
	    noresize: Boolean, // 如果 container 尺寸不会发生变化，最好设置它可以优化性能
	    tag: {
	      type: String,
	      default: 'div'
	    }
	  },
	
	  data: function data() {
	    return {
	      sizeWidth: '0',
	      sizeHeight: '0',
	      moveX: 0,
	      moveY: 0
	    };
	  },
	
	
	  computed: {
	    wrap: function wrap() {
	      return this.$refs.wrap;
	    }
	  },
	
	  render: function render(h) {
	    var gutter = scrollbar_width_default()();
	    var style = this.wrapStyle;
	
	    if (gutter) {
	      var gutterWith = '-' + gutter + 'px';
	      var gutterStyle = 'margin-bottom: ' + gutterWith + '; margin-right: ' + gutterWith + ';';
	
	      if (Array.isArray(this.wrapStyle)) {
	        style = Object(util_["toObject"])(this.wrapStyle);
	        style.marginRight = style.marginBottom = gutterWith;
	      } else if (typeof this.wrapStyle === 'string') {
	        style += gutterStyle;
	      } else {
	        style = gutterStyle;
	      }
	    }
	    var view = h(this.tag, {
	      class: ['el-scrollbar__view', this.viewClass],
	      style: this.viewStyle,
	      ref: 'resize'
	    }, this.$slots.default);
	    var wrap = h(
	      'div',
	      {
	        ref: 'wrap',
	        style: style,
	        on: {
	          'scroll': this.handleScroll
	        },
	
	        'class': [this.wrapClass, 'el-scrollbar__wrap', gutter ? '' : 'el-scrollbar__wrap--hidden-default'] },
	      [[view]]
	    );
	    var nodes = void 0;
	
	    if (!this.native) {
	      nodes = [wrap, h(src_bar, {
	        attrs: {
	          move: this.moveX,
	          size: this.sizeWidth }
	      }), h(src_bar, {
	        attrs: {
	          vertical: true,
	          move: this.moveY,
	          size: this.sizeHeight }
	      })];
	    } else {
	      nodes = [h(
	        'div',
	        {
	          ref: 'wrap',
	          'class': [this.wrapClass, 'el-scrollbar__wrap'],
	          style: style },
	        [[view]]
	      )];
	    }
	    return h('div', { class: 'el-scrollbar' }, nodes);
	  },
	
	
	  methods: {
	    handleScroll: function handleScroll() {
	      var wrap = this.wrap;
	
	      this.moveY = wrap.scrollTop * 100 / wrap.clientHeight;
	      this.moveX = wrap.scrollLeft * 100 / wrap.clientWidth;
	    },
	    update: function update() {
	      var heightPercentage = void 0,
	          widthPercentage = void 0;
	      var wrap = this.wrap;
	      if (!wrap) return;
	
	      heightPercentage = wrap.clientHeight * 100 / wrap.scrollHeight;
	      widthPercentage = wrap.clientWidth * 100 / wrap.scrollWidth;
	
	      this.sizeHeight = heightPercentage < 100 ? heightPercentage + '%' : '';
	      this.sizeWidth = widthPercentage < 100 ? widthPercentage + '%' : '';
	    }
	  },
	
	  mounted: function mounted() {
	    if (this.native) return;
	    this.$nextTick(this.update);
	    !this.noresize && Object(resize_event_["addResizeListener"])(this.$refs.resize, this.update);
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this.native) return;
	    !this.noresize && Object(resize_event_["removeResizeListener"])(this.$refs.resize, this.update);
	  }
	});
	// CONCATENATED MODULE: ./packages/scrollbar/index.js
	
	
	/* istanbul ignore next */
	main.install = function (Vue) {
	  Vue.component(main.name, main);
	};
	
	/* harmony default export */ var scrollbar = __webpack_exports__["default"] = (main);
	
	/***/ }),
	
	/***/ 16:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(130);
	
	/***/ }),
	
	/***/ 2:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(42);
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(38);
	
	/***/ }),
	
	/***/ 39:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(132);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 129 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var aria = aria || {};
	
	aria.Utils = aria.Utils || {};
	
	/**
	 * @desc Set focus on descendant nodes until the first focusable element is
	 *       found.
	 * @param element
	 *          DOM node for which to find the first focusable descendant.
	 * @returns
	 *  true if a focusable element is found and focus is set.
	 */
	aria.Utils.focusFirstDescendant = function (element) {
	  for (var i = 0; i < element.childNodes.length; i++) {
	    var child = element.childNodes[i];
	    if (aria.Utils.attemptFocus(child) || aria.Utils.focusFirstDescendant(child)) {
	      return true;
	    }
	  }
	  return false;
	};
	
	/**
	 * @desc Find the last descendant node that is focusable.
	 * @param element
	 *          DOM node for which to find the last focusable descendant.
	 * @returns
	 *  true if a focusable element is found and focus is set.
	 */
	
	aria.Utils.focusLastDescendant = function (element) {
	  for (var i = element.childNodes.length - 1; i >= 0; i--) {
	    var child = element.childNodes[i];
	    if (aria.Utils.attemptFocus(child) || aria.Utils.focusLastDescendant(child)) {
	      return true;
	    }
	  }
	  return false;
	};
	
	/**
	 * @desc Set Attempt to set focus on the current node.
	 * @param element
	 *          The node to attempt to focus on.
	 * @returns
	 *  true if element is focused.
	 */
	aria.Utils.attemptFocus = function (element) {
	  if (!aria.Utils.isFocusable(element)) {
	    return false;
	  }
	  aria.Utils.IgnoreUtilFocusChanges = true;
	  try {
	    element.focus();
	  } catch (e) {}
	  aria.Utils.IgnoreUtilFocusChanges = false;
	  return document.activeElement === element;
	};
	
	aria.Utils.isFocusable = function (element) {
	  if (element.tabIndex > 0 || element.tabIndex === 0 && element.getAttribute('tabIndex') !== null) {
	    return true;
	  }
	
	  if (element.disabled) {
	    return false;
	  }
	
	  switch (element.nodeName) {
	    case 'A':
	      return !!element.href && element.rel !== 'ignore';
	    case 'INPUT':
	      return element.type !== 'hidden' && element.type !== 'file';
	    case 'BUTTON':
	    case 'SELECT':
	    case 'TEXTAREA':
	      return true;
	    default:
	      return false;
	  }
	};
	
	/**
	 * 触发一个事件
	 * mouseenter, mouseleave, mouseover, keyup, change, click 等
	 * @param  {Element} elm
	 * @param  {String} name
	 * @param  {*} opts
	 */
	aria.Utils.triggerEvent = function (elm, name) {
	  var eventName = void 0;
	
	  if (/^mouse|click/.test(name)) {
	    eventName = 'MouseEvents';
	  } else if (/^key/.test(name)) {
	    eventName = 'KeyboardEvent';
	  } else {
	    eventName = 'HTMLEvents';
	  }
	  var evt = document.createEvent(eventName);
	
	  for (var _len = arguments.length, opts = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    opts[_key - 2] = arguments[_key];
	  }
	
	  evt.initEvent.apply(evt, [name].concat(opts));
	  elm.dispatchEvent ? elm.dispatchEvent(evt) : elm.fireEvent('on' + name, evt);
	
	  return elm;
	};
	
	aria.Utils.keys = {
	  tab: 9,
	  enter: 13,
	  space: 32,
	  left: 37,
	  up: 38,
	  right: 39,
	  down: 40,
	  esc: 27
	};
	
	exports.default = aria.Utils;

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.removeResizeListener = exports.addResizeListener = undefined;
	
	var _resizeObserverPolyfill = __webpack_require__(461);
	
	var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isServer = typeof window === 'undefined';
	
	/* istanbul ignore next */
	var resizeHandler = function resizeHandler(entries) {
	  for (var _iterator = entries, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	    var _ref;
	
	    if (_isArray) {
	      if (_i >= _iterator.length) break;
	      _ref = _iterator[_i++];
	    } else {
	      _i = _iterator.next();
	      if (_i.done) break;
	      _ref = _i.value;
	    }
	
	    var entry = _ref;
	
	    var listeners = entry.target.__resizeListeners__ || [];
	    if (listeners.length) {
	      listeners.forEach(function (fn) {
	        fn();
	      });
	    }
	  }
	};
	
	/* istanbul ignore next */
	var addResizeListener = exports.addResizeListener = function addResizeListener(element, fn) {
	  if (isServer) return;
	  if (!element.__resizeListeners__) {
	    element.__resizeListeners__ = [];
	    element.__ro__ = new _resizeObserverPolyfill2.default(resizeHandler);
	    element.__ro__.observe(element);
	  }
	  element.__resizeListeners__.push(fn);
	};
	
	/* istanbul ignore next */
	var removeResizeListener = exports.removeResizeListener = function removeResizeListener(element, fn) {
	  if (!element || !element.__resizeListeners__) return;
	  element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
	  if (!element.__resizeListeners__.length) {
	    element.__ro__.disconnect();
	  }
	};

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = scrollIntoView;
	
	var _vue = __webpack_require__(20);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function scrollIntoView(container, selected) {
	  if (_vue2.default.prototype.$isServer) return;
	
	  if (!selected) {
	    container.scrollTop = 0;
	    return;
	  }
	
	  var offsetParents = [];
	  var pointer = selected.offsetParent;
	  while (pointer && container !== pointer && container.contains(pointer)) {
	    offsetParents.push(pointer);
	    pointer = pointer.offsetParent;
	  }
	  var top = selected.offsetTop + offsetParents.reduce(function (prev, curr) {
	    return prev + curr.offsetTop;
	  }, 0);
	  var bottom = top + selected.offsetHeight;
	  var viewRectTop = container.scrollTop;
	  var viewRectBottom = viewRectTop + container.clientHeight;
	
	  if (top < viewRectTop) {
	    container.scrollTop = top;
	  } else if (bottom > viewRectBottom) {
	    container.scrollTop = bottom - container.clientHeight;
	  }
	}

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function () {
	  if (_vue2.default.prototype.$isServer) return 0;
	  if (scrollBarWidth !== undefined) return scrollBarWidth;
	
	  var outer = document.createElement('div');
	  outer.className = 'el-scrollbar__wrap';
	  outer.style.visibility = 'hidden';
	  outer.style.width = '100px';
	  outer.style.position = 'absolute';
	  outer.style.top = '-9999px';
	  document.body.appendChild(outer);
	
	  var widthNoScroll = outer.offsetWidth;
	  outer.style.overflow = 'scroll';
	
	  var inner = document.createElement('div');
	  inner.style.width = '100%';
	  outer.appendChild(inner);
	
	  var widthWithScroll = inner.offsetWidth;
	  outer.parentNode.removeChild(outer);
	  scrollBarWidth = widthNoScroll - widthWithScroll;
	
	  return scrollBarWidth;
	};
	
	var _vue = __webpack_require__(20);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var scrollBarWidth = void 0;
	
	;

/***/ }),
/* 133 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 134 */
/***/ (function(module, exports) {

	/* eslint-disable no-undefined,no-param-reassign,no-shadow */
	
	/**
	 * Throttle execution of a function. Especially useful for rate limiting
	 * execution of handlers on events like resize and scroll.
	 *
	 * @param  {Number}    delay          A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
	 * @param  {Boolean}   [noTrailing]   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds while the
	 *                                    throttled-function is being called. If noTrailing is false or unspecified, callback will be executed one final time
	 *                                    after the last throttled-function call. (After the throttled-function has not been called for `delay` milliseconds,
	 *                                    the internal counter is reset)
	 * @param  {Function}  callback       A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
	 *                                    to `callback` when the throttled-function is executed.
	 * @param  {Boolean}   [debounceMode] If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is false (at end),
	 *                                    schedule `callback` to execute after `delay` ms.
	 *
	 * @return {Function}  A new, throttled, function.
	 */
	module.exports = function ( delay, noTrailing, callback, debounceMode ) {
	
		// After wrapper has stopped being called, this timeout ensures that
		// `callback` is executed at the proper times in `throttle` and `end`
		// debounce modes.
		var timeoutID;
	
		// Keep track of the last time `callback` was executed.
		var lastExec = 0;
	
		// `noTrailing` defaults to falsy.
		if ( typeof noTrailing !== 'boolean' ) {
			debounceMode = callback;
			callback = noTrailing;
			noTrailing = undefined;
		}
	
		// The `wrapper` function encapsulates all of the throttling / debouncing
		// functionality and when executed will limit the rate at which `callback`
		// is executed.
		function wrapper () {
	
			var self = this;
			var elapsed = Number(new Date()) - lastExec;
			var args = arguments;
	
			// Execute `callback` and update the `lastExec` timestamp.
			function exec () {
				lastExec = Number(new Date());
				callback.apply(self, args);
			}
	
			// If `debounceMode` is true (at begin) this is used to clear the flag
			// to allow future `callback` executions.
			function clear () {
				timeoutID = undefined;
			}
	
			if ( debounceMode && !timeoutID ) {
				// Since `wrapper` is being called for the first time and
				// `debounceMode` is true (at begin), execute `callback`.
				exec();
			}
	
			// Clear any existing timeout.
			if ( timeoutID ) {
				clearTimeout(timeoutID);
			}
	
			if ( debounceMode === undefined && elapsed > delay ) {
				// In throttle mode, if `delay` time has been exceeded, execute
				// `callback`.
				exec();
	
			} else if ( noTrailing !== true ) {
				// In trailing throttle mode, since `delay` time has not been
				// exceeded, schedule `callback` to execute `delay` ms after most
				// recent execution.
				//
				// If `debounceMode` is true (at begin), schedule `clear` to execute
				// after `delay` ms.
				//
				// If `debounceMode` is false (at end), schedule `callback` to
				// execute after `delay` ms.
				timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
			}
	
		}
	
		// Return the wrapper function.
		return wrapper;
	
	};


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _util = __webpack_require__(9);
	
	var util = _interopRequireWildcard(_util);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	/**
	 *  Rule for validating required fields.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param source The source object being validated.
	 *  @param errors An array of errors that this rule may add
	 *  validation errors to.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function required(rule, value, source, errors, options, type) {
	  if (rule.required && (!source.hasOwnProperty(rule.field) || util.isEmptyValue(value, type || rule.type))) {
	    errors.push(util.format(options.messages.required, rule.fullField));
	  }
	}
	
	exports['default'] = required;
	module.exports = exports['default'];

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(28);
	var settle = __webpack_require__(213);
	var buildURL = __webpack_require__(216);
	var parseHeaders = __webpack_require__(222);
	var isURLSameOrigin = __webpack_require__(220);
	var createError = __webpack_require__(139);
	var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(215);
	
	module.exports = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	
	    if (utils.isFormData(requestData)) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }
	
	    var request = new XMLHttpRequest();
	    var loadEvent = 'onreadystatechange';
	    var xDomain = false;
	
	    // For IE 8/9 CORS support
	    // Only supports POST and GET calls and doesn't returns the response headers.
	    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
	    if (("production") !== 'test' &&
	        typeof window !== 'undefined' &&
	        window.XDomainRequest && !('withCredentials' in request) &&
	        !isURLSameOrigin(config.url)) {
	      request = new window.XDomainRequest();
	      loadEvent = 'onload';
	      xDomain = true;
	      request.onprogress = function handleProgress() {};
	      request.ontimeout = function handleTimeout() {};
	    }
	
	    // HTTP basic authentication
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password || '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }
	
	    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);
	
	    // Set the request timeout in MS
	    request.timeout = config.timeout;
	
	    // Listen for ready state
	    request[loadEvent] = function handleLoad() {
	      if (!request || (request.readyState !== 4 && !xDomain)) {
	        return;
	      }
	
	      // The request errored out and we didn't get a response, this will be
	      // handled by onerror instead
	      // With one exception: request that using file: protocol, most browsers
	      // will return status as 0 even though it's a successful request
	      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	        return;
	      }
	
	      // Prepare the response
	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
	      var response = {
	        data: responseData,
	        // IE sends 1223 instead of 204 (https://github.com/mzabriskie/axios/issues/201)
	        status: request.status === 1223 ? 204 : request.status,
	        statusText: request.status === 1223 ? 'No Content' : request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };
	
	      settle(resolve, reject, response);
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle low level network errors
	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(createError('Network Error', config, null, request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle timeout
	    request.ontimeout = function handleTimeout() {
	      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
	        request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.
	    if (utils.isStandardBrowserEnv()) {
	      var cookies = __webpack_require__(218);
	
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
	          cookies.read(config.xsrfCookieName) :
	          undefined;
	
	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    }
	
	    // Add headers to the request
	    if ('setRequestHeader' in request) {
	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    }
	
	    // Add withCredentials to request if needed
	    if (config.withCredentials) {
	      request.withCredentials = true;
	    }
	
	    // Add responseType to request if needed
	    if (config.responseType) {
	      try {
	        request.responseType = config.responseType;
	      } catch (e) {
	        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
	        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
	        if (config.responseType !== 'json') {
	          throw e;
	        }
	      }
	    }
	
	    // Handle progress if needed
	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    }
	
	    // Not all browsers support upload events
	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }
	
	    if (config.cancelToken) {
	      // Handle cancellation
	      config.cancelToken.promise.then(function onCanceled(cancel) {
	        if (!request) {
	          return;
	        }
	
	        request.abort();
	        reject(cancel);
	        // Clean up request
	        request = null;
	      });
	    }
	
	    if (requestData === undefined) {
	      requestData = null;
	    }
	
	    // Send the request
	    request.send(requestData);
	  });
	};


/***/ }),
/* 137 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * A `Cancel` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */
	function Cancel(message) {
	  this.message = message;
	}
	
	Cancel.prototype.toString = function toString() {
	  return 'Cancel' + (this.message ? ': ' + this.message : '');
	};
	
	Cancel.prototype.__CANCEL__ = true;
	
	module.exports = Cancel;


/***/ }),
/* 138 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var enhanceError = __webpack_require__(212);
	
	/**
	 * Create an Error with the specified message, config, error code, request and response.
	 *
	 * @param {string} message The error message.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */
	module.exports = function createError(message, config, code, request, response) {
	  var error = new Error(message);
	  return enhanceError(error, config, code, request, response);
	};


/***/ }),
/* 140 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};


/***/ }),
/* 141 */
/***/ (function(module, exports) {

	var nestRE = /^(attrs|props|on|nativeOn|class|style|hook)$/
	
	module.exports = function mergeJSXProps (objs) {
	  return objs.reduce(function (a, b) {
	    var aa, bb, key, nestedKey, temp
	    for (key in b) {
	      aa = a[key]
	      bb = b[key]
	      if (aa && nestRE.test(key)) {
	        // normalize class
	        if (key === 'class') {
	          if (typeof aa === 'string') {
	            temp = aa
	            a[key] = aa = {}
	            aa[temp] = true
	          }
	          if (typeof bb === 'string') {
	            temp = bb
	            b[key] = bb = {}
	            bb[temp] = true
	          }
	        }
	        if (key === 'on' || key === 'nativeOn' || key === 'hook') {
	          // merge functions
	          for (nestedKey in bb) {
	            aa[nestedKey] = mergeFn(aa[nestedKey], bb[nestedKey])
	          }
	        } else if (Array.isArray(aa)) {
	          a[key] = aa.concat(bb)
	        } else if (Array.isArray(bb)) {
	          a[key] = [aa].concat(bb)
	        } else {
	          for (nestedKey in bb) {
	            aa[nestedKey] = bb[nestedKey]
	          }
	        }
	      } else {
	        a[key] = b[key]
	      }
	    }
	    return a
	  }, {})
	}
	
	function mergeFn (a, b) {
	  return function () {
	    a && a.apply(this, arguments)
	    b && b.apply(this, arguments)
	  }
	}


/***/ }),
/* 142 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var RESIZER_CLASS = "ct-resizer";
	var SHADOWDOM_CLASS = "ct-web-dangers-shadow-wrapper";
	
	var POPOVER_CLASS = "ct-toolbox-popover";
	var WEB_REG = /^https?:\/\/[^/]+/;
	var BORDER_CACHE_FIELD = "image-border-cache";
	var IMAGE_MIN_WIDTH = 20;
	
	var IMAGE_MAX_HEIGHT = 600;
	var IMAGE_INFO_DISPLAY_MIN_WIDTH_SIZE = 80;
	
	var IMAGE_INFO_DISPLAY_MIN_HEIGHT_SIZE = 35;
	
	var IMAGE_OFFSET = 4;
	
	var IMAGE_DEFAULT_WIDTH = 100;
	
	var IMAGE_DEFAULT_HEIGHT = 100;
	
	var CITADELREG = /^https?:\/\/([0-9a-zA-Z\-]+(-sl-))?km\.(it\.(dev|test|beta|st)\.)?sankuai\.com/;
	
	exports.RESIZER_CLASS = RESIZER_CLASS;
	exports.SHADOWDOM_CLASS = SHADOWDOM_CLASS;
	exports.POPOVER_CLASS = POPOVER_CLASS;
	exports.WEB_REG = WEB_REG;
	exports.BORDER_CACHE_FIELD = BORDER_CACHE_FIELD;
	exports.IMAGE_MIN_WIDTH = IMAGE_MIN_WIDTH;
	exports.IMAGE_MAX_HEIGHT = IMAGE_MAX_HEIGHT;
	exports.IMAGE_INFO_DISPLAY_MIN_WIDTH_SIZE = IMAGE_INFO_DISPLAY_MIN_WIDTH_SIZE;
	exports.IMAGE_INFO_DISPLAY_MIN_HEIGHT_SIZE = IMAGE_INFO_DISPLAY_MIN_HEIGHT_SIZE;
	exports.IMAGE_OFFSET = IMAGE_OFFSET;
	exports.IMAGE_DEFAULT_WIDTH = IMAGE_DEFAULT_WIDTH;
	exports.IMAGE_DEFAULT_HEIGHT = IMAGE_DEFAULT_HEIGHT;
	exports.CITADELREG = CITADELREG;

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _keys = __webpack_require__(13);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _toConsumableArray2 = __webpack_require__(66);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _defineProperty2 = __webpack_require__(44);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _setPrototypeOf = __webpack_require__(64);
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _create = __webpack_require__(57);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _getIterator2 = __webpack_require__(62);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _entries = __webpack_require__(63);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _slicedToArray2 = __webpack_require__(65);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _assign = __webpack_require__(26);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _map = __webpack_require__(151);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _classCallCheck2 = __webpack_require__(7);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(10);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _typeof2 = __webpack_require__(8);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault(ex) {
	  return ex && (typeof ex === 'undefined' ? 'undefined' : (0, _typeof3.default)(ex)) === 'object' && 'default' in ex ? ex['default'] : ex;
	}
	
	var index_ts = __webpack_require__(234);
	var index_js = __webpack_require__(227);
	var index_js$1 = __webpack_require__(228);
	var index_js$2 = __webpack_require__(229);
	var index_ts$1 = __webpack_require__(230);
	var index_ts$2 = __webpack_require__(231);
	var index_js$3 = __webpack_require__(232);
	var index_ts$3 = __webpack_require__(233);
	var index_js$4 = __webpack_require__(235);
	var index_js$5 = __webpack_require__(236);
	var index_js$6 = __webpack_require__(237);
	var index_js$7 = __webpack_require__(238);
	var index_ts$4 = __webpack_require__(239);
	var index_js$8 = __webpack_require__(97);
	var index_js$9 = __webpack_require__(29);
	var prosemirrorModel = __webpack_require__(12);
	var prosemirrorState = __webpack_require__(6);
	var prosemirrorView = __webpack_require__(48);
	var preact = __webpack_require__(24);
	var preact__default = _interopDefault(preact);
	__webpack_require__(49);
	__webpack_require__(56);
	__webpack_require__(22);
	__webpack_require__(78);
	__webpack_require__(25);
	
	var ROOT_CLASS_NAME = "ct-editor";
	
	var defaultModules = [index_ts$1.CoreModule, index_js$5.ListModule, index_js$8.TableModule, index_ts$4.StatusModule, index_js.BasicModule, index_js$1.CodeModule, index_js$2.CollapseModule, index_js$3.HistoryModule, index_ts$3.ImageModule, index_js$4.LinkModule, index_js$6.NoteModule, index_js$7.QuoteModule, index_ts$2.DragButtonModule, index_ts.KeymapGroupModule];
	
	var EventBus = function () {
	  function EventBus() {
	    (0, _classCallCheck3.default)(this, EventBus);
	
	    this.events = new _map2.default();
	  }
	
	  (0, _createClass3.default)(EventBus, [{
	    key: 'emit',
	    value: function emit(type, data) {
	      var handlers = this.events.get(type);
	
	      if (handlers) {
	        handlers.forEach(function (handler) {
	          return handler(data);
	        });
	      }
	    }
	  }, {
	    key: 'on',
	    value: function on(type, handler) {
	      if (this.events.has(type)) {
	        this.events.get(type).push(handler);
	      } else {
	        this.events.set(type, [handler]);
	      }
	    }
	  }, {
	    key: 'off',
	    value: function off(type, handler) {
	      if (this.events.has(type)) {
	        var handlers = this.events.get(type);
	        var index = handlers.findIndex(function (h) {
	          return h === handler;
	        });
	
	        if (index !== -1) {
	          handlers.splice(index, 1);
	          return true;
	        }
	      }
	
	      return false;
	    }
	  }]);
	  return EventBus;
	}();
	
	var collectSchemas = function collectSchemas(schemas) {
	  return schemas.reduce(function (prev, curr) {
	    (0, _assign2.default)(prev.nodes, curr.nodes);
	    (0, _assign2.default)(prev.marks, curr.marks);
	    return prev;
	  }, {
	    nodes: {},
	    marks: {}
	  });
	};
	
	var createDoc = function createDoc(schema, plugins, value) {
	  var $container = document.createElement("div");
	  $container.innerHTML = value.replace(/\u200B/g, "").replace(/(class="ct-status"[^>]*>)/g, '$1\u200B');
	  return prosemirrorModel.DOMParser.fromSchema(schema).parse($container);
	};
	var getModules = function getModules(modules, config) {
	  var exclude = config.excludeModules ? config.excludeModules : [];
	  var append = config.appendModules ? config.appendModules : [];
	  var result = modules.filter(function (m) {
	    return exclude.every(function (n) {
	      return m.moduleName !== n;
	    });
	  }).map(function (Module) {
	    return new Module();
	  }).concat(append).concat([new index_js$9.CursorModule()]);
	
	  if (config.reactModule) {
	    result.splice(1, 0, config.reactModule);
	  }
	
	  return result;
	};
	var _applyModuleConfig = function _applyModuleConfig(moduleConfigs, editor) {
	  if (!moduleConfigs) {
	    return;
	  }
	
	  var _loop = function _loop(key, value) {
	    if (!value) {
	      return 'continue';
	    }
	
	    (0, _entries2.default)(value).forEach(function (_ref4) {
	      var _ref5 = (0, _slicedToArray3.default)(_ref4, 2),
	          k = _ref5[0],
	          v = _ref5[1];
	
	      if (editor[key + 'Config']) {
	        editor[key + 'Config'][k] = v;
	      }
	    });
	  };
	
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = (0, _getIterator3.default)((0, _entries2.default)(moduleConfigs)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var _ref2 = _step.value;
	
	      var _ref3 = (0, _slicedToArray3.default)(_ref2, 2);
	
	      var key = _ref3[0];
	      var value = _ref3[1];
	
	      var _ret = _loop(key, value);
	
	      if (_ret === 'continue') continue;
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	};
	
	var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
	
	function createCommonjsModule(fn, module) {
	  return module = { exports: {} }, fn(module, module.exports), module.exports;
	}
	
	var _extends_1 = createCommonjsModule(function (module) {
	  function _extends() {
	    module.exports = _extends = _assign2.default || function (target) {
	      for (var i = 1; i < arguments.length; i++) {
	        var source = arguments[i];
	
	        for (var key in source) {
	          if (Object.prototype.hasOwnProperty.call(source, key)) {
	            target[key] = source[key];
	          }
	        }
	      }
	
	      return target;
	    };
	
	    return _extends.apply(this, arguments);
	  }
	
	  module.exports = _extends;
	});
	
	function styleInject(css, ref) {
	  if (ref === void 0) ref = {};
	  var insertAt = ref.insertAt;
	
	  if (!css || typeof document === 'undefined') {
	    return;
	  }
	
	  var head = document.head || document.getElementsByTagName('head')[0];
	  var style = document.createElement('style');
	  style.type = 'text/css';
	
	  if (insertAt === 'top') {
	    if (head.firstChild) {
	      head.insertBefore(style, head.firstChild);
	    } else {
	      head.appendChild(style);
	    }
	  } else {
	    head.appendChild(style);
	  }
	
	  if (style.styleSheet) {
	    style.styleSheet.cssText = css;
	  } else {
	    style.appendChild(document.createTextNode(css));
	  }
	}
	
	var css = ".toolbar-color-popover-wrapper{display:flex;justify-content:center;align-items:center;position:relative;height:28px;width:40px;font-size:12px;cursor:pointer;transition:all .2s ease}.toolbar-color-popover-wrapper.disabled{cursor:not-allowed}.toolbar-color-popover-wrapper.disabled path{fill:#aaa}.toolbar-color-popover-wrapper .left{width:26px;height:100%}.toolbar-color-popover-wrapper .right{width:14px;height:100%;background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='7' height='4' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M.5.5h6l-3 3z' fill='%23AEAEAE' fill-rule='evenodd'/%3E%3C/svg%3E\") no-repeat 50%}.toolbar-color-popover-wrapper.font-color{position:relative}.toolbar-color-popover-wrapper.font-color .left{background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='10' height='10' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6.62 5.902L5.01 1.484 3.302 5.902H6.62zM4.26 0h1.624l3.844 10H8.156L7.08 7.005H2.89L1.743 10H.272L4.26 0z' fill='%23666' fill-rule='evenodd'/%3E%3C/svg%3E\") no-repeat 7px 7px}.toolbar-color-popover-wrapper.font-color .left .color{position:absolute;left:5px;bottom:7px;width:14px;height:2px;border:1px solid;margin:0 auto}.toolbar-color-popover-wrapper.bg-color .left{position:relative}.toolbar-color-popover-wrapper.bg-color .color{position:absolute;top:18px;left:5px;width:14px;height:2px}.toolbar-color-popover-wrapper.border-color{width:246px}.toolbar-color-popover{display:flex;justify-content:flex-start;align-items:flex-start;flex-wrap:wrap;position:absolute;width:258px;height:150px;bottom:-152px;left:0;padding:8px;border-radius:2px;background:#fff;border:1px solid #eee;box-shadow:0 1px 4px 0 rgba(111,130,166,.08),0 16px 30px 0 rgba(111,130,166,.14);z-index:2}.toolbar-color-popover .default{position:relative;width:calc(100% - 2px);margin:0 1px 8px;height:24px;border:1px solid #ddd;border-radius:2px;cursor:pointer}.toolbar-color-popover .color-grid{position:absolute;top:5px;left:10px;width:13px;height:13px;border:1px solid}.toolbar-color-popover .text{height:24px;line-height:24px;text-align:center;font-size:12px;color:#333}.toolbar-color-grid{margin:0 2px;width:16px;height:16px;cursor:pointer}.toolbar-color-grid:nth-child(2),.toolbar-color-grid:nth-child(12){border:1px solid #eee}.toolbar-color-grid.selected{z-index:2;border-radius:1px;border:1px solid #fff;box-shadow:0 0 0 2px #999}.toolbar-color-grid:hover{z-index:3;border-radius:1px;border:1px solid #fff}.toolbar-color-grid:hover:nth-child(3){box-shadow:0 0 0 2px #333}.toolbar-color-grid:hover:nth-child(4){box-shadow:0 0 0 2px #f5222d}.toolbar-color-grid:hover:nth-child(5){box-shadow:0 0 0 2px #fa541c}.toolbar-color-grid:hover:nth-child(6){box-shadow:0 0 0 2px #faad14}.toolbar-color-grid:hover:nth-child(7){box-shadow:0 0 0 2px #fadb14}.toolbar-color-grid:hover:nth-child(8){box-shadow:0 0 0 2px #52c41a}.toolbar-color-grid:hover:nth-child(9){box-shadow:0 0 0 2px #13c2c2}.toolbar-color-grid:hover:nth-child(10){box-shadow:0 0 0 2px #1890ff}.toolbar-color-grid:hover:nth-child(11){box-shadow:0 0 0 2px #2f54eb}.toolbar-color-grid:hover:nth-child(12){box-shadow:0 0 0 2px #722ed1}.toolbar-color-grid:hover:nth-child(13){box-shadow:0 0 0 2px #eb2f96}.toolbar-color-grid:hover:nth-child(14){box-shadow:0 0 0 2px #f6f6f6}.toolbar-color-grid:hover:nth-child(15){box-shadow:0 0 0 2px #989898}.toolbar-color-grid:hover:nth-child(16){box-shadow:0 0 0 2px #ffe8e7}.toolbar-color-grid:hover:nth-child(17){box-shadow:0 0 0 2px #ffece0}.toolbar-color-grid:hover:nth-child(18){box-shadow:0 0 0 2px #fff7cb}.toolbar-color-grid:hover:nth-child(19){box-shadow:0 0 0 2px #fcfcca}.toolbar-color-grid:hover:nth-child(20){box-shadow:0 0 0 2px #e5f7d3}.toolbar-color-grid:hover:nth-child(21){box-shadow:0 0 0 2px #cffff7}.toolbar-color-grid:hover:nth-child(22){box-shadow:0 0 0 2px #d4eefc}.toolbar-color-grid:hover:nth-child(23){box-shadow:0 0 0 2px #dfe8fc}.toolbar-color-grid:hover:nth-child(24){box-shadow:0 0 0 2px #efe1fa}.toolbar-color-grid:hover:nth-child(25){box-shadow:0 0 0 2px #fbe1eb}.toolbar-color-grid:hover:nth-child(26){box-shadow:0 0 0 2px #e9e9e9}.toolbar-color-grid:hover:nth-child(27){box-shadow:0 0 0 2px #666}.toolbar-color-grid:hover:nth-child(28){box-shadow:0 0 0 2px #ffa39e}.toolbar-color-grid:hover:nth-child(29){box-shadow:0 0 0 2px #ffbb96}.toolbar-color-grid:hover:nth-child(30){box-shadow:0 0 0 2px #ffe58f}.toolbar-color-grid:hover:nth-child(31){box-shadow:0 0 0 2px #fffb8f}.toolbar-color-grid:hover:nth-child(32){box-shadow:0 0 0 2px #b7eb8f}.toolbar-color-grid:hover:nth-child(33){box-shadow:0 0 0 2px #87e8de}.toolbar-color-grid:hover:nth-child(34){box-shadow:0 0 0 2px #91d5ff}.toolbar-color-grid:hover:nth-child(35){box-shadow:0 0 0 2px #adc6ff}.toolbar-color-grid:hover:nth-child(36){box-shadow:0 0 0 2px #d3adf7}.toolbar-color-grid:hover:nth-child(37){box-shadow:0 0 0 2px #ffadd2}.toolbar-color-grid:hover:nth-child(38){box-shadow:0 0 0 2px #ddd}.toolbar-color-grid:hover:nth-child(39){box-shadow:0 0 0 2px #4b4b4b}.toolbar-color-grid:hover:nth-child(40){box-shadow:0 0 0 2px #ff4d4f}.toolbar-color-grid:hover:nth-child(41){box-shadow:0 0 0 2px #ff7a45}.toolbar-color-grid:hover:nth-child(42){box-shadow:0 0 0 2px #ffc53d}.toolbar-color-grid:hover:nth-child(43){box-shadow:0 0 0 2px #ffec3d}.toolbar-color-grid:hover:nth-child(44){box-shadow:0 0 0 2px #73d13d}.toolbar-color-grid:hover:nth-child(45){box-shadow:0 0 0 2px #36cfc9}.toolbar-color-grid:hover:nth-child(46){box-shadow:0 0 0 2px #40a8ff}.toolbar-color-grid:hover:nth-child(47){box-shadow:0 0 0 2px #597ef7}.toolbar-color-grid:hover:nth-child(48){box-shadow:0 0 0 2px #9254de}.toolbar-color-grid:hover:nth-child(49){box-shadow:0 0 0 2px #f759ab}.toolbar-color-grid:hover:nth-child(50){box-shadow:0 0 0 2px #ccc}.toolbar-color-grid:hover:nth-child(51){box-shadow:0 0 0 2px #262626}.toolbar-color-grid:hover:nth-child(52){box-shadow:0 0 0 2px #cf1322}.toolbar-color-grid:hover:nth-child(53){box-shadow:0 0 0 2px #d4380d}.toolbar-color-grid:hover:nth-child(54){box-shadow:0 0 0 2px #d48806}.toolbar-color-grid:hover:nth-child(55){box-shadow:0 0 0 2px #d4b106}.toolbar-color-grid:hover:nth-child(56){box-shadow:0 0 0 2px #389e0d}.toolbar-color-grid:hover:nth-child(57){box-shadow:0 0 0 2px #08979c}.toolbar-color-grid:hover:nth-child(58){box-shadow:0 0 0 2px #096dd9}.toolbar-color-grid:hover:nth-child(59){box-shadow:0 0 0 2px #1d39c4}.toolbar-color-grid:hover:nth-child(60){box-shadow:0 0 0 2px #531dab}.toolbar-color-grid:hover:nth-child(61){box-shadow:0 0 0 2px #c41d7f}.toolbar-color-grid:hover:nth-child(62){box-shadow:0 0 0 2px #aaa}.toolbar-color-grid:hover:nth-child(63){box-shadow:0 0 0 2px #000}.toolbar-color-grid:hover:nth-child(64){box-shadow:0 0 0 2px #820014}.toolbar-color-grid:hover:nth-child(65){box-shadow:0 0 0 2px #871400}.toolbar-color-grid:hover:nth-child(66){box-shadow:0 0 0 2px #874d00}.toolbar-color-grid:hover:nth-child(67){box-shadow:0 0 0 2px #876800}.toolbar-color-grid:hover:nth-child(68){box-shadow:0 0 0 2px #135200}.toolbar-color-grid:hover:nth-child(69){box-shadow:0 0 0 2px #00474f}.toolbar-color-grid:hover:nth-child(70){box-shadow:0 0 0 2px #003a8c}.toolbar-color-grid:hover:nth-child(71){box-shadow:0 0 0 2px #061178}.toolbar-color-grid:hover:nth-child(72){box-shadow:0 0 0 2px #22075e}.toolbar-color-grid:hover:nth-child(73){box-shadow:0 0 0 2px #780650}.toolbar-color-grid:hover:nth-child(2),.toolbar-color-grid:hover:nth-child(14){box-shadow:0 0 0 2px #aaa}";
	styleInject(css);
	
	var css$1 = ".ct-table-model-pop-wrapper .ct-extra-popover{width:80px;left:-2px;padding:8px 0;position:absolute;top:26px;border-radius:2px;background:#fff;border:1px solid #eee;box-shadow:0 1px 4px 0 rgba(111,130,166,.08),0 16px 30px 0 rgba(111,130,166,.14);z-index:2}.ct-table-model-pop-wrapper .ct-extra-popover-item{padding-left:16px;height:30px;color:#333}.ct-p-pop-wrapper,.ct-table-model-pop-wrapper .ct-extra-popover-item{display:flex;justify-content:space-between;align-items:center;font-size:12px;transition:all .2s ease}.ct-p-pop-wrapper{position:relative;padding-left:10px;padding-right:5px;height:28px;width:80px;border-radius:2px;cursor:pointer;border:1px solid transparent;background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='7' height='4' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M.5.5h6l-3 3z' fill='%23AEAEAE' fill-rule='evenodd'/%3E%3C/svg%3E\") no-repeat 95% 56%}.ct-p-pop-wrapper:hover{border:1px solid #ccc}";
	styleInject(css$1);
	
	var css$2 = ".citadel-editor-toolbar{display:flex;justify-content:flex-start;align-items:center;flex-wrap:wrap;width:100%;min-height:50px;border-bottom:1px solid #eee;color:#555;padding:5px 10px 0}.citadel-editor-toolbar .toolbar-split{width:1px;height:15px;margin:auto 10px;background:#ddd}.citadel-editor-toolbar .toolbar-tooltip{position:absolute;left:50%;-webkit-transform:translate(-50%);transform:translate(-50%);bottom:-35px;height:25px;padding:0 10px;line-height:25px;white-space:nowrap;vertical-align:middle;color:#fff;font-size:12px;background:rgba(0,0,0,.7);border-radius:4px;z-index:1}.citadel-editor-toolbar .toolbar-tooltip:after{position:absolute;width:0;top:-5px;right:50%;-webkit-transform:translate(50%);transform:translate(50%);display:block;border-color:rgba(0,0,0,.7) transparent;border-style:solid;border-width:0 5px 5px;content:\"\";z-index:1}.citadel-editor-toolbar .menu-item-wrapper{display:flex;flex-direction:row;margin-bottom:5px}.citadel-editor-toolbar .menu-item{position:relative;display:flex}.citadel-editor-toolbar .menu-item .disabled{pointer-events:none}.citadel-editor-toolbar .menu-item .toolbar-icon-wrapper{position:relative;width:28px;height:28px;margin:auto 5px;border-radius:2px;cursor:pointer;transition:all .2s ease;border:1px solid transparent;background-clip:content-box}.citadel-editor-toolbar .menu-item .toolbar-icon-wrapper[data-action=extra],.citadel-editor-toolbar .menu-item .toolbar-icon-wrapper[data-action=table]{width:45px}.citadel-editor-toolbar .menu-item:hover>.toolbar-icon-wrapper{border:1px solid #ccc}.citadel-editor-toolbar .menu-item.disabled>.toolbar-icon-wrapper{background-color:#fff;opacity:.3;cursor:not-allowed}.citadel-editor-toolbar .menu-item.active>.toolbar-icon-wrapper{border:1px solid #ccc;background-color:#eee}.citadel-editor-toolbar .toolbar-secondary{display:flex;justify-content:center;align-items:center;flex-wrap:wrap;height:40px;margin-top:1px;padding-bottom:15px}.citadel-editor-toolbar .toolbar-secondary .toolbar-icon-wrapper:first-child{margin-left:0}.citadel-editor-toolbar .toolbar-secondary .toolbar-numcol{font-size:12px;color:#333;line-height:16px;display:flex;align-items:center}.citadel-editor-toolbar .toolbar-secondary .toolbar-color-popover-wrapper.bg-color .left{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg transform='rotate(45 1.207 14.864)'%3E%3Crect stroke='%23666' fill-rule='nonzero' x='1.5' y='.5' width='7.5' height='7.5' rx='1'/%3E%3Cpath fill='%23666' d='M8.874.337l.191 7.658L1.52 7.69zM0 2h4v1H0z'/%3E%3C/g%3E%3Cpath d='M17.5 16a1.5 1.5 0 0 0 1.5-1.5c0-.552-.5-1.386-1.5-2.5-1 1.114-1.5 1.948-1.5 2.5a1.5 1.5 0 0 0 1.5 1.5z' fill='%23666'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-popover-wrapper{width:100px;padding:8px 0;position:absolute;border-radius:2px;background:#fff;border:1px solid #eee;box-shadow:0 1px 4px 0 rgba(111,130,166,.08),0 16px 30px 0 rgba(111,130,166,.14);z-index:2}.toolbar-popover-wrapper .menu-item-wrapper.more>.menu-item{width:100px}.toolbar-popover-wrapper .menu-item-wrapper.more>.menu-item:after{content:\"\";position:absolute;width:9px;height:5px;right:8px;display:inline-block;-webkit-transform:rotate(-90deg);transform:rotate(-90deg);background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='7' height='4' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M.5.5h6l-3 3z' fill='%23AEAEAE' fill-rule='evenodd'/%3E%3C/svg%3E\") no-repeat;background-size:cover}.toolbar-popover-wrapper.fit{width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}.toolbar-popover-wrapper.fit .menu-item{padding:0 16px}.toolbar-popover-wrapper .menu-item{display:flex;align-items:center;width:100%;height:30px;padding-left:10px;font-size:12px;color:#333;cursor:pointer;transition:all .2s ease}.toolbar-popover-wrapper .menu-item:hover{background-color:#f6f6f6}.toolbar-popover-wrapper .menu-item:hover .toolbar-icon-wrapper{background-color:unset}.toolbar-popover-wrapper .menu-item>span{display:inline-block}.toolbar-popover-wrapper .menu-item .toolbar-icon-wrapper{width:16px;height:16px;margin-right:8px;margin-left:0}.toolbar-popover-wrapper .menu-item .toolbar-icon-wrapper:hover{background-color:unset}.toolbar-icon-wrapper{display:inline-block;background-repeat:no-repeat;background-size:cover}.toolbar-icon-wrapper[data-action=extra]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='40' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M14.5 12.5h3a.5.5 0 1 1 0 1h-3v3a.5.5 0 1 1-1 0v-3h-3a.5.5 0 1 1 0-1h3v-3a.5.5 0 1 1 1 0v3zM9 6h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2zm0 1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H9z' fill='%23666'/%3E%3Cpath fill='%23AEAEAE' d='M27 12h6l-3 3z'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=catalog]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg class='icon' viewBox='0 0 1228 1024' xmlns='http://www.w3.org/2000/svg' width='19.188' height='16'%3E%3Cdefs%3E%3Cstyle/%3E%3C/defs%3E%3Cpath d='M368 192h480a48 48 0 1 1 0 96H368a48 48 0 0 1 0-96zm128 181.312h352a48 48 0 1 1 0 96H496a48 48 0 1 1 0-96zM368 554.688h480a48 48 0 1 1 0 96H368a48 48 0 0 1 0-96zM176 288a48 48 0 1 1 0-96 48 48 0 0 1 0 96zm0 362.688a48 48 0 1 1 0-96 48 48 0 0 1 0 96zm128-181.376a48 48 0 1 1 0-96 48 48 0 0 1 0 96zM496 736h352a48 48 0 1 1 0 96H496a48 48 0 1 1 0-96zm-192 96a48 48 0 1 1 0-96 48 48 0 0 1 0 96z' fill='%23666'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=attachment]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg class='icon' viewBox='0 0 1024 1024' xmlns='http://www.w3.org/2000/svg' width='16' height='16'%3E%3Cdefs%3E%3Cstyle/%3E%3C/defs%3E%3Cpath d='M148.864 415.808l288-279.04a31.552 31.552 0 0 1 43.648 0 30.272 30.272 0 0 1 0 42.88l-289.92 280.96c-85.376 85.888-85.376 224.448 3.968 308.352a233.152 233.152 0 0 0 321.728 0l339.584-327.808c57.6-54.656 57.6-144.384 0-199.04-57.6-54.592-148.928-54.592-204.544 0l-353.472 341.44h-1.984a60.48 60.48 0 0 0 0 85.888 63.104 63.104 0 0 0 87.36 0l1.984-1.92 295.872-284.928a31.552 31.552 0 0 1 43.712 0 30.272 30.272 0 0 1 0 42.944L428.928 712.32l-1.984 1.984a126.272 126.272 0 0 1-174.784 0 118.656 118.656 0 0 1 0-169.728l1.984-1.92 351.488-341.504 5.952-5.824c1.984-1.92 3.968-1.92 5.952-3.904 83.456-68.288 204.544-66.368 282.048 9.728 77.44 74.176 79.36 193.152 11.904 271.232-1.984 1.92-1.984 3.84-3.968 5.824l-7.936 7.808L560 813.824l-1.984 1.92c-113.28 107.328-295.936 107.328-409.152-1.92-113.152-111.232-113.152-288.768 0-398.08z' fill='%23666'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=drawio]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg class='icon' viewBox='0 0 1024 1024' xmlns='http://www.w3.org/2000/svg' width='16' height='16'%3E%3Cdefs%3E%3Cstyle/%3E%3C/defs%3E%3Cpath d='M800 704h57.6a38.4 38.4 0 0 1 38.4 38.4v115.2a38.4 38.4 0 0 1-38.4 38.4H678.4a38.4 38.4 0 0 1-38.4-38.4V742.4a38.4 38.4 0 0 1 38.4-38.4h55.104V576a32 32 0 0 0-32-32h-384a32 32 0 0 0-32 32v128H345.6a38.4 38.4 0 0 1 38.4 38.4v115.2a38.4 38.4 0 0 1-38.4 38.4H166.4a38.4 38.4 0 0 1-38.4-38.4V742.4a38.4 38.4 0 0 1 38.4-38.4H224V544a64 64 0 0 1 64-64h192V320h-57.6a38.4 38.4 0 0 1-38.4-38.4V166.4a38.4 38.4 0 0 1 38.4-38.4h179.2a38.4 38.4 0 0 1 38.4 38.4v115.2a38.4 38.4 0 0 1-38.4 38.4H544v160h192a64 64 0 0 1 64 64v160z' fill='%23666'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=status]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg class='icon' viewBox='0 0 1024 1024' xmlns='http://www.w3.org/2000/svg' width='16' height='16'%3E%3Cdefs%3E%3Cstyle/%3E%3C/defs%3E%3Cpath d='M192 704v64h640v-64H192zm-38.4-64h716.8c14.08 0 25.6 11.52 25.6 25.6v140.8a25.6 25.6 0 0 1-25.6 25.6H153.6a25.6 25.6 0 0 1-25.6-25.6V665.6c0-14.08 11.52-25.6 25.6-25.6zm0-448h716.8c14.08 0 25.6 11.52 25.6 25.6v140.8a25.6 25.6 0 0 1-25.6 25.6H153.6a25.6 25.6 0 0 1-25.6-25.6V217.6c0-14.08 11.52-25.6 25.6-25.6z' fill='%23666'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=quote]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='16' height='16' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.578 4v1.143c-.394.195-.69.548-.887 1.058-.197.51-.296 1.181-.296 2.015v.355H13V12H9.25V9.436c0-1.554.276-2.785.828-3.69.552-.907 1.385-1.489 2.5-1.746zm-6.25 0v1.143c-.394.195-.69.548-.887 1.058-.197.51-.296 1.181-.296 2.015v.355H6.75V12H3V9.436c0-1.554.276-2.785.828-3.69.552-.907 1.385-1.489 2.5-1.746z' fill='%23666' fill-rule='evenodd'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=collapse]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='16' height='16' xmlns='http://www.w3.org/2000/svg'%3E%3Cg transform='translate(1 1)' fill-rule='nonzero' fill='none'%3E%3Cpath d='M11.934.5H4A1.5 1.5 0 0 0 2.5 2v11.5H10a1.5 1.5 0 0 0 1.5-1.5V4l.004-.062.43-3.438z' stroke='%23666' fill='%23FFF'/%3E%3Cpath d='M11.5 4.5h2v-3a1 1 0 0 0-2 0v3zM.5 10.5V12A1.5 1.5 0 0 0 2 13.5h7.5v-3h-9z' stroke='%23666' fill='%23FFF'/%3E%3Crect fill='%23666' x='4' y='3' width='6' height='1' rx='.5'/%3E%3Crect stroke='%23666' fill='%23FFF' x='8.5' y='8.5' width='3' height='5' rx='1.5'/%3E%3Cpath fill='%23FFF' d='M7 6h4v4H7z'/%3E%3Crect fill='%23666' x='4' y='6' width='6' height='1' rx='.5'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=latex]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='16' height='16' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill-rule='nonzero' fill='none'%3E%3Cpath d='M9 1.5c-1.307-.053-2.227.088-2.76.42C5.708 2.253 5.294 2.946 5 4L2.5 15' stroke='%236B6B6B'/%3E%3Cpath fill='%236B6B6B' d='M1 6h8v1H1z'/%3E%3Cpath d='M8 8l6 7M14 8l-6 7' stroke='%236B6B6B'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=html]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='16' height='16' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23666' fill-rule='evenodd'%3E%3Cpath d='M15 5h-1V3H2v2H1V3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v2zm0 7v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-2h1v2h12v-2h1zM6 7v4H5V7H4V6h3v1H6zm4.012.442L11 6.007V6h1v5h-1V7.75l-.709 1.013-.287.421L10 9.178l-.004.006-.438-.636L9 7.75V11H8V6h1v.007l1.012 1.435zM14 10h2v1h-3V6h1v4zM2 9H1v2H0V6h1v2h1V6h1v5H2V9z'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=hr]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg class='icon' viewBox='0 0 1024 1024' xmlns='http://www.w3.org/2000/svg' width='16' height='16'%3E%3Cdefs%3E%3Cstyle/%3E%3C/defs%3E%3Cpath d='M162.88 416h698.24c19.2 0 34.88 14.336 34.88 32s-15.616 32-34.88 32H162.88c-19.2 0-34.88-14.336-34.88-32s15.616-32 34.88-32zm0 128h698.24c19.2 0 34.88 14.336 34.88 32s-15.616 32-34.88 32H162.88c-19.2 0-34.88-14.336-34.88-32s15.616-32 34.88-32z' fill='%23666'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=mention]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg class='icon' viewBox='0 0 1024 1024' xmlns='http://www.w3.org/2000/svg' width='16' height='16'%3E%3Cdefs%3E%3Cstyle/%3E%3C/defs%3E%3Cpath d='M553.792 658.88a222.72 222.72 0 0 1-59.008 48.128c-21.76 12.096-43.584 18.176-65.536 18.176a133.12 133.12 0 0 1-70.144-20.8c-22.656-13.824-41.152-35.136-55.296-63.872a210.688 210.688 0 0 1-21.312-94.592c0-42.304 11.008-84.672 33.024-127.104 22.08-42.496 49.408-74.304 82.112-95.616 32.704-21.312 64.512-32 95.36-32 23.488 0 45.888 6.144 67.264 18.24 21.376 12.096 39.68 30.528 55.168 55.296l13.76-61.888h72.576l-58.368 267.84c-8.128 37.248-12.16 57.856-12.16 61.888 0 7.168 2.752 13.376 8.32 18.56a28.288 28.288 0 0 0 20.032 7.744c14.336 0 33.152-8.128 56.32-24.32a224 224 0 0 0 73.28-85.632c17.92-35.84 26.88-72.704 26.88-110.72 0-44.48-11.52-86.016-34.56-124.608-23.168-38.592-57.6-69.44-103.424-92.608-45.824-23.168-96.448-34.688-151.872-34.688-63.296 0-121.024 14.528-173.376 43.712a301.376 301.376 0 0 0-121.6 125.312 368.768 368.768 0 0 0-43.2 175.04c0 65.216 14.4 121.344 43.136 168.448 28.8 47.104 70.4 81.92 124.928 104.32 54.464 22.528 114.816 33.792 181.056 33.792 70.784 0 130.176-11.712 177.984-35.136 47.872-23.424 83.712-51.84 107.52-85.44H896c-24.96 37.632-48.64 66.112-70.976 85.44a380.16 380.16 0 0 1-119.616 68.864C659.2 887.552 603.52 896 538.368 896a577.088 577.088 0 0 1-166.08-22.784c-50.688-15.168-93.824-37.952-129.536-68.48a303.488 303.488 0 0 1-80.64-105.152A391.104 391.104 0 0 1 128 536.768c0-64.96 13.504-126.848 40.576-185.6 32.96-72.128 79.808-127.36 140.48-165.696C369.728 147.2 443.328 128 529.856 128c67.008 0 127.232 13.504 180.608 40.512A299.52 299.52 0 0 1 836.8 289.28c26.24 46.08 39.36 96 39.36 150.08 0 77.184-27.584 145.664-82.752 205.568-49.216 53.76-103.04 80.64-161.408 80.64-18.624 0-33.728-2.816-45.184-8.384a54.336 54.336 0 0 1-25.344-23.936c-3.52-6.656-6.08-18.112-7.68-34.368zM357.504 550.72c0 36.48 8.768 64.768 26.368 84.992 17.536 20.224 37.76 30.336 60.416 30.336 15.104 0 31.104-4.48 47.872-13.312 16.704-8.96 32.768-22.208 48-39.744 15.296-17.536 27.776-39.872 37.504-66.88 9.728-27.008 14.592-54.08 14.592-81.216 0-36.16-9.088-64.256-27.328-84.224a87.04 87.04 0 0 0-66.688-29.952c-17.28 0-33.6 4.352-48.896 12.992s-30.08 22.528-44.416 41.728c-14.336 19.2-25.792 42.432-34.432 69.824a252.352 252.352 0 0 0-12.992 75.456z' fill='%23666'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=undo]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M19.5 18.5a11.621 11.621 0 0 0-7.996-5v3L6.5 12.1l5.004-4.6v3a9.198 9.198 0 0 1 7.996 8z' fill='%23666'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=redo]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M6.5 18.5a11.621 11.621 0 0 1 7.996-5v3l5.004-4.4-5.004-4.6v3a9.198 9.198 0 0 0-7.996 8z' fill='%23666'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=clearFormat]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M15.037 6.245l4.613 3.928c.424.362.47.992.1 1.408l-5.68 6.402L8.656 18 6.35 16.036a.984.984 0 0 1-.1-1.408l7.35-8.285a1.033 1.033 0 0 1 1.437-.098zm-4.009 4.519l4.612 3.928-2.004 2.26-4.626.026-1.607-1.368a.492.492 0 0 1-.05-.704l3.675-4.142zM6 19h14v1H6v-1z' fill='%23666'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=bold]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M9.255 16.718c.097 1.08-.655 1.595-2.255 1.546V19h7.2c3.006-.098 4.606-1.276 4.8-3.533-.097-1.668-1.09-2.723-2.982-3.164v-.074c1.552-.294 2.327-1.03 2.327-2.208 0-.589-.242-1.153-.727-1.693-.824-.932-2.521-1.373-5.09-1.324-.583 0-1.6.049-3.055.147-.388 0-.921.024-1.6.073-.388.05-.63.074-.728.074v.736h.437c.727 0 1.188.098 1.382.294.194.148.29.59.29 1.325v7.065zm2.545-3.9c.194-.05.655-.074 1.382-.074 1.842.05 2.812.982 2.909 2.797 0 1.717-.873 2.576-2.618 2.576-1.164.098-1.721-.466-1.673-1.693v-3.606zm0-5.005c.29-.049.606-.073.945-.073 1.843 0 2.788.76 2.837 2.281-.049 1.325-.824 1.987-2.327 1.987H11.8V7.813z' fill='%23666'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=italic]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M12.568 9.189l-2.176 7.698c-.202.905-.846 1.358-1.934 1.358h-.245L8 19h6.608l.213-.755h-.326c-1.157.05-1.565-.427-1.226-1.434l2.154-7.622c.27-.956.95-1.434 2.037-1.434h.327L18 7h-6.608l-.213.755h.245c1.102-.05 1.483.427 1.144 1.434z' fill='%23666'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=strikethrough]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='27' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M17.436 14H20v1.6h-1.964l1.464 3.9h-1.995l-1.364-3.894h-5.318L9.367 19.5H7.5l1.519-3.9H7V14h2.642l2.92-7.5h2.06l2.814 7.5zm-6.026 0h4.084l-1.98-5.57L11.41 14z' fill='%23666' fill-rule='nonzero'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=underline]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M7 17.9h12v1.6H7v-1.6zm7.82-10.488h-.405V6.5H18.2v.912h-.31c-.708-.03-1 .236-.972.874v5.041c-.036 2.329-1.358 3.537-3.895 3.573-2.629-.035-4.007-1.099-4.044-3.167V8.07c.028-.492-.179-.687-.723-.658H7.8V6.5h4.503v.912h-.406c-.507 0-.723.203-.723.67v5.646c.032 1.287.728 1.922 2.155 1.954 1.571-.032 2.337-.75 2.368-2.205V8.534c.03-.813-.243-1.151-.876-1.122z' fill='%23666' fill-rule='evenodd'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=alignLeft]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M7 7.5h12v1H7v-1zm0 2h8v1H7v-1zm0 2h12v1H7v-1zm0 2h8v1H7v-1zm0 2h12v1H7v-1zm0 2h8v1H7v-1z' fill='%23666'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=alignCenter]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M7 7.5h12v1H7v-1zm2 2h8v1H9v-1zm-2 2h12v1H7v-1zm2 2h8v1H9v-1zm-2 2h12v1H7v-1zm2 2h8v1H9v-1z' fill='%23666'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=alignRight]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M7 7.5h12v1H7v-1zm4 2h8v1h-8v-1zm-4 2h12v1H7v-1zm4 2h8v1h-8v-1zm-4 2h12v1H7v-1zm4 2h8v1h-8v-1z' fill='%23666'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=orderList]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M11 8h9v1h-9V8zm0 5h9v1h-9v-1zm0 5h9v1h-9v-1zM7.14 9.65V7.04H6v-.35c.145 0 .29-.01.434-.03.131-.02.26-.056.381-.11a.819.819 0 0 0 .288-.21.729.729 0 0 0 .161-.34h.4v3.65h-.527.003zm-.951 2.27c.06-.154.152-.294.27-.41.134-.117.288-.209.455-.27.2-.063.41-.093.619-.09.181-.003.362.02.536.07.157.037.306.105.437.2a.9.9 0 0 1 .402.78.941.941 0 0 1-.089.42 1.03 1.03 0 0 1-.239.33 1.878 1.878 0 0 1-.341.27c-.128.08-.26.15-.4.23a7.692 7.692 0 0 0-.784.41 1.728 1.728 0 0 0-.291.25.582.582 0 0 0-.158.3h2.255v.38H6c.015-.19.062-.376.14-.55.07-.146.164-.281.275-.4a2.31 2.31 0 0 1 .378-.3c.14-.08.287-.16.44-.24.186-.09.349-.18.489-.26.124-.072.242-.156.35-.25a.891.891 0 0 0 .21-.26.766.766 0 0 0 .072-.34.541.541 0 0 0-.068-.27.73.73 0 0 0-.452-.34 1.179 1.179 0 0 0-.329-.05.935.935 0 0 0-.393.08.823.823 0 0 0-.269.21.808.808 0 0 0-.152.29 1.037 1.037 0 0 0-.04.33h-.527a1.263 1.263 0 0 1 .065-.52zm1.035 5.94h.174c.107.002.215-.011.319-.04a.747.747 0 0 0 .266-.11.546.546 0 0 0 .183-.19.479.479 0 0 0 .068-.26.5.5 0 0 0-.223-.44 1.059 1.059 0 0 0-.557-.14 1.034 1.034 0 0 0-.37.06.717.717 0 0 0-.26.17.758.758 0 0 0-.151.26.866.866 0 0 0-.05.3h-.526c.004-.165.038-.327.1-.48.058-.14.145-.267.257-.37.122-.106.264-.188.418-.24.186-.063.383-.093.58-.09a2.22 2.22 0 0 1 .529.06c.15.035.294.096.425.18.25.16.397.443.384.74a.65.65 0 0 1-.174.44 1.1 1.1 0 0 1-.433.28V18c.232.03.445.144.6.32.13.161.199.363.195.57a.941.941 0 0 1-.121.48 1.115 1.115 0 0 1-.325.35c-.148.095-.31.166-.48.21a2.732 2.732 0 0 1-.585.07c-.205 0-.41-.026-.607-.08a1.311 1.311 0 0 1-.464-.23 1.064 1.064 0 0 1-.295-.37 1.162 1.162 0 0 1-.1-.51h.527a.8.8 0 0 0 .248.58c.191.16.438.24.687.22.122.002.245-.011.365-.04.105-.033.206-.08.3-.14a.769.769 0 0 0 .207-.22.589.589 0 0 0 .078-.3.607.607 0 0 0-.075-.3.653.653 0 0 0-.2-.22.872.872 0 0 0-.294-.14 1.442 1.442 0 0 0-.368-.04 3.093 3.093 0 0 0-.316.02v-.38a.115.115 0 0 0 .055.01h.009z' fill='%23666'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=bulletList]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M11 7.5h9v1h-9v-1zm-3.5-1a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm3.5 6h9v1h-9v-1zm-3.5-1a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm3.5 6h9v1h-9v-1zm-3.5-1a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z' fill='%23666'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=taskList]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M12.367 15.5a.567.567 0 0 1-.427-.16l-2.776-2.707a.537.537 0 0 1 0-.773.571.571 0 0 1 .793 0l2.453 2.392 3.695-3.602c.205-.2.537-.2.741 0 .205.2.205.523 0 .723l-4.079 3.977a.53.53 0 0 1-.4.15zM8 6h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2zm0 1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H8z' fill='%23666'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=indentLess]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M7 8h12v1H7V8zm4 2h8v1h-8v-1zm0 2h8v1h-8v-1zm0 2h8v1h-8v-1zm0 2h8v1h-8v-1zm-4 2h12v1H7v-1zm2-7v4l-2-2 2-2z' fill='%23666'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=indentMore]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M7 8h12v1H7V8zm0 2h8v1H7v-1zm0 2h8v1H7v-1zm0 2h8v1H7v-1zm0 2h8v1H7v-1zm0 2h12v1H7v-1zm10-7l2 2-2 2v-4z' fill='%23666'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=table]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='40' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M12 11v8h-1v-8H8v-1h12v1h-8zM9 6h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2zm0 1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H9zm3 7v-1h8v1h-8zm0 3v-1h8v1h-8z' fill='%23666'/%3E%3Cpath fill='%23AEAEAE' d='M27 12h6l-3 3z'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=link]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M7.884 13.85l4.124-4.125 2.133 2.134a3.017 3.017 0 0 1 0 4.266l-1.99 1.991a3.017 3.017 0 0 1-4.267-4.266zm4.835-3.414l-.15.15a2.011 2.011 0 0 0 0 2.844l.712.711-.711.711.355.356-1.066-1.067a3.017 3.017 0 0 1 0-4.266l.149-.15.711.711zm.562 5.128l-1.842 1.841a2.011 2.011 0 0 1-2.844-2.844l1.99-1.991-.71-.711 3.975-3.975a3.017 3.017 0 0 1 4.266 4.266l-4.124 4.125-.711-.711zm-.562-5.128l.711.712-.71.71.71.712a2.011 2.011 0 0 1 0 2.844l-.15.15-.355-.356 1.067 1.067 2.133-2.134-.71-.71 1.99-1.992a2.011 2.011 0 0 0-2.844-2.844l-1.842 1.841z' fill='%23666'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=code]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M14.035 9.02c.267.073.432.331.368.575l-1.84 7.076c-.064.245-.332.383-.598.31-.267-.074-.432-.332-.368-.576l1.84-7.076c.064-.245.332-.383.598-.31zM7.207 13l2.475 2.475a.5.5 0 0 1-.707.707l-2.829-2.828a.498.498 0 0 1 0-.708l2.829-2.828a.5.5 0 0 1 .707.707L7.207 13zm11.586 0l-2.475-2.475a.5.5 0 1 1 .707-.707l2.829 2.828a.498.498 0 0 1 0 .708l-2.829 2.828a.5.5 0 1 1-.707-.707L18.793 13z' fill='%23666' fill-rule='evenodd'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=note]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='16' height='16' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M8 1c3.826 0 7 3.173 7 7s-3.174 7-7 7c-3.827 0-7-3.173-7-7s3.173-7 7-7zm0 13c3.323 0 6-2.676 6-6s-2.677-6-6-6-6 2.676-6 6 2.677 6 6 6zm0-8.247a.877.877 0 1 1 0-1.754.877.877 0 0 1 0 1.754zM8 7a.75.75 0 0 1 .75.75v3.5a.75.75 0 1 1-1.5 0v-3.5A.75.75 0 0 1 8 7z' fill='%23666' fill-rule='nonzero'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=image]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M18 11.945V8.4a.4.4 0 0 0-.4-.4H8.4a.4.4 0 0 0-.4.4v5.566c1.677 1.356 3.343 1.367 5 .034s3.323-2.018 5-2.055zm0 .978c-.658-.016-1.214.052-1.667.203-1 .333-2.055.994-3.057 1.779-1.152.9-2.557 1.234-3.888.836-.355-.106-.818-.363-1.388-.77V17.6c0 .22.18.4.4.4h9.2a.4.4 0 0 0 .4-.4v-4.677zM17.745 7c.454 0 .777.127.968.38.191.253.287.584.287.993v9.574a.924.924 0 0 1-.087.38 1.074 1.074 0 0 1-.24.34c-.102.097-.22.177-.354.24a1.03 1.03 0 0 1-.44.093H8.04c-.276 0-.518-.111-.727-.333a1.126 1.126 0 0 1-.314-.8v-9.76c0-.32.089-.585.267-.794A.883.883 0 0 1 7.974 7h9.771zm-7.368 1.947a1.263 1.263 0 0 1 .888.367c.111.11.2.242.267.393.066.15.1.31.1.48 0 .346-.123.64-.367.88-.245.24-.54.36-.888.36-.169 0-.33-.031-.48-.094a1.144 1.144 0 0 1-.394-.266 1.398 1.398 0 0 1-.267-.394 1.161 1.161 0 0 1-.1-.486c0-.17.033-.33.1-.48.067-.151.156-.283.267-.394.111-.11.242-.2.394-.266.15-.067.311-.1.48-.1z' fill='%23666'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=markdown]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg class='icon' viewBox='0 0 1024 1024' xmlns='http://www.w3.org/2000/svg' width='16' height='16'%3E%3Cdefs%3E%3Cstyle/%3E%3C/defs%3E%3Cpath d='M832 224v576a32 32 0 1 1-64 0V313.28L534.208 598.4a32 32 0 0 1-45.632-.192L256 313.472V800a32 32 0 1 1-64 0V224a32 32 0 0 1 32.64-32 32.32 32.32 0 0 1 26.048 14.336l260.864 319.36 265.792-324.352A32 32 0 0 1 832 224z' fill='%23666'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=experiment]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='16' height='16' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M7 1.5a.5.5 0 0 0-.5.5v4.202l-5.041 7.52a.5.5 0 0 0 .415.778h12.253a.5.5 0 0 0 .416-.778L9.5 6.188V2a.5.5 0 0 0-.5-.5H7z' stroke='%236B6B6B'/%3E%3Cpath fill='%236B6B6B' d='M5 1h6v1H5zM3.5 10h9v1h-9zM2.55 12H9v1H2z'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=textExtra]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='40' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23666'%3E%3Cpath d='M11.07 20H9l8.262-12.744h1.602L21.456 20h-1.854l-.612-3.132h-5.976L11.07 20zm2.862-4.698h4.806l-1.08-6.048-3.726 6.048zM8.991 9.9h-.027c-.108.193-.282.35-.523.474-.24.123-.513.185-.82.185-.174 0-.355-.023-.544-.068a1.622 1.622 0 0 1-.523-.225 1.31 1.31 0 0 1-.396-.415A1.193 1.193 0 0 1 6 9.216c0-.324.092-.582.275-.775.183-.192.419-.339.707-.441.288-.102.608-.17.96-.203.35-.033.695-.05 1.031-.05V7.64c0-.27-.098-.47-.293-.6a1.236 1.236 0 0 0-.698-.193c-.228 0-.447.048-.658.144a1.77 1.77 0 0 0-.522.351l-.559-.657c.246-.229.53-.4.852-.514.32-.114.647-.171.977-.171.384 0 .701.054.95.162.25.108.446.25.59.424.145.174.245.369.302.585.057.216.086.433.086.649v2.63H8.991V9.9zm-.018-1.423H8.73c-.174 0-.358.008-.55.023-.192.015-.37.048-.531.1a1.135 1.135 0 0 0-.406.215.479.479 0 0 0-.162.383.46.46 0 0 0 .243.424.784.784 0 0 0 .244.09c.09.018.18.027.27.027.372 0 .654-.1.847-.298.192-.198.288-.468.288-.81v-.154z'/%3E%3C/g%3E%3Cpath fill='%23AEAEAE' d='M30 11.5h6l-3 3z'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=minder]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='16' height='16' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M5 8.5V9a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v.5h1.03A4 4 0 0 1 10 4v-.5a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1V5a3 3 0 0 0 0 6v-.5a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1V12a4 4 0 0 1-3.97-3.5H5zm-1 0V7H2v2h2v-.5zm7-5v2h3v-2h-3zm0 7v2h3v-2h-3z' fill='%23666'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=sub]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg class='icon' viewBox='0 0 1024 1024' xmlns='http://www.w3.org/2000/svg' width='16' height='16'%3E%3Cdefs%3E%3Cstyle/%3E%3C/defs%3E%3Cpath d='M79.104 192h118.208L352 423.232 506.688 192h118.208L409.792 501.248 640 832H521.792L352 578.304 182.208 832H64l228.48-330.752L79.04 192zm877.888 590.08V832H747.264l1.024-13.76a119.04 119.04 0 0 1 10.24-39.808c5.12-10.56 11.776-20.224 20.16-29.184 8-7.872 16.768-14.848 26.752-21.12 9.152-5.248 18.688-10.432 28.992-15.808 10.048-4.864 19.456-9.92 30.4-16.192a131.84 131.84 0 0 0 20.544-14.72 43.84 43.84 0 0 0 10.112-12.288 36.8 36.8 0 0 0 3.456-16.512 21.632 21.632 0 0 0-2.624-10.688 33.664 33.664 0 0 0-21.568-15.872 62.784 62.784 0 0 0-17.536-2.688 46.72 46.72 0 0 0-19.392 3.84 39.68 39.68 0 0 0-12.928 10.048 38.976 38.976 0 0 0-7.296 14.016 53.568 53.568 0 0 0-2.112 17.024l.576 13.312h-58.88l-.96-11.712a93.632 93.632 0 0 1 4.864-38.528c4.608-12.032 11.52-22.528 20.928-31.68 9.728-8.576 20.992-15.232 33.728-19.84 14.08-4.48 28.8-6.656 43.2-6.4 12.864-.192 25.664 1.472 37.504 4.8 11.712 2.816 22.72 7.872 32 14.592A70.528 70.528 0 0 1 960 653.184a77.888 77.888 0 0 1-24.704 57.344c-7.36 7.232-15.424 13.632-24.128 19.072-3.84 2.368-7.808 4.672-13.056 7.68l-14.208 7.872c-7.04 3.136-13.44 6.272-25.472 12.48a359.808 359.808 0 0 0-22.656 12.608 98.048 98.048 0 0 0-14.208 11.84h135.424z' fill='%23666'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=sup]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg class='icon' viewBox='0 0 1024 1024' xmlns='http://www.w3.org/2000/svg' width='16' height='16'%3E%3Cdefs%3E%3Cstyle/%3E%3C/defs%3E%3Cpath d='M79.104 192h118.208L352 423.232 506.688 192h118.208L409.792 501.248 640 832H521.792L352 578.304 182.208 832H64l228.48-330.752L79.04 192zm877.888 208.64v49.92H747.264l1.024-13.76a119.04 119.04 0 0 1 10.24-39.808c5.12-10.56 11.776-20.224 20.16-29.184 8-7.808 16.768-14.848 26.752-21.12 9.152-5.248 18.688-10.432 28.992-15.808 10.048-4.864 19.456-9.92 30.4-16.192a131.84 131.84 0 0 0 20.544-14.72 43.84 43.84 0 0 0 10.112-12.288 36.8 36.8 0 0 0 3.456-16.448 21.632 21.632 0 0 0-2.624-10.752 33.664 33.664 0 0 0-21.568-15.872 62.784 62.784 0 0 0-17.536-2.688 46.72 46.72 0 0 0-19.392 3.84 39.68 39.68 0 0 0-12.928 10.048 38.976 38.976 0 0 0-7.296 14.016 53.568 53.568 0 0 0-2.112 17.024l.576 13.312h-58.88l-.96-11.712a93.632 93.632 0 0 1 4.864-38.528c4.608-12.032 11.52-22.528 20.928-31.68 9.728-8.576 20.992-15.232 33.728-19.84 14.08-4.48 28.8-6.592 43.2-6.4 12.864-.192 25.664 1.472 37.504 4.864 11.712 2.752 22.72 7.808 32 14.528A70.528 70.528 0 0 1 960 271.744a77.888 77.888 0 0 1-24.704 57.344c-7.36 7.232-15.424 13.696-24.128 19.072-3.84 2.368-7.808 4.672-13.056 7.68l-14.208 7.872c-7.04 3.136-13.44 6.272-25.472 12.48a359.808 359.808 0 0 0-22.656 12.608 98.048 98.048 0 0 0-14.208 11.84h135.424z' fill='%23666'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=addRowBefore]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M8 8.5V10L6 8l2-2v1.5h3v1H8zm8.5 3.2V11h1v9H6v-1h10.5v-2.8H6v-1h10.5v-2.5H6v-1h10.5zM12 6.5h8v3h-8v-3z' fill='%23666' fill-rule='evenodd'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=addRowAfter]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M8 17.5h3v1H8V20l-2-2 2-2v1.5zm8.5-3.2H6v-1h10.5v-2.5H6v-1h10.5V7H6V6h11.5v9h-1v-.7zM12 19.5h8v-3h-8v3z' fill='%23666' fill-rule='evenodd'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=deleteRow]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M18.214 13L20 14.786l-.714.714-1.786-1.786-1.786 1.786-.714-.714L16.786 13 15 11.214l.714-.714 1.786 1.786 1.786-1.786.714.714L18.214 13zM12 6h.5v4h-1V7H6V6h6zm-.5 13v-3h1v4H6v-1h5.5zm2.5-6.5h1v1h-1v1H6v-3h8v1z' fill='%23666' fill-rule='evenodd'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=addColumnBefore]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M8.5 8H10L8 6 6 8h1.5v3h1V8zm3.2 8.5H11v1h9V6h-1v10.5h-2.8V6h-1v10.5h-2.5V6h-1v10.5zM6.5 12v8h3v-8h-3z' fill='%23666' fill-rule='evenodd'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=addColumnAfter]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M17.5 8H16l2-2 2 2h-1.5v3h-1V8zm-3.2 8.5h.7v1H6V6h1v10.5h2.8V6h1v10.5h2.5V6h1v10.5zm5.2-4.5v8h-3v-8h3z' fill='%23666' fill-rule='evenodd'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=deleteColumn]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M13 18.214L11.214 20l-.714-.714 1.786-1.786-1.786-1.786.714-.714L13 16.786 14.786 15l.714.714-1.786 1.786 1.786 1.786-.714.714L13 18.214zm7-5.714V6h-1v5.5h-3v1h4zm-13-1V6H6v6.5h4v-1H7zm6.5 2.5v1h-1v-1h-1V6h3v8h-1z' fill='%23666' fill-rule='evenodd'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=mergeCells]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10 15.5H6v-1h4V11H6v-1h4V7h1v3h4V7h1v3h4v1h-9v8h-1v-3.5zM7 6h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2zm0 1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H7z' fill='%23666' fill-rule='evenodd'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=splitCell]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M19.197 14.5H20.5v1h-1.303v-1zm-8.697 0h1.303v1H10.5v-1zm4.348 0h1.304v1h-1.304v-1zm2.175 0h1.303v1h-1.303v-1zm-4.349 0h1.303v1h-1.303v-1zm3.352 3.697V19.5h-1v-1.303h1zm0-7.697v1.303h-1V10.5h1zm0 5.773v1.303h-1v-1.303h1zm0-3.849v1.303h-1v-1.303h1z' fill='%23999'/%3E%3Cpath d='M10 15.5H6v-1h4V11H6v-1h4V7h1v3h4V7h1v3h4v1h-9v8h-1v-3.5zM7 6h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2zm0 1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H7z' fill='%23666'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=tableRow]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M16 10v4h4v1h-4v4h-1v-4h-4v4h-1v-4H6v-1h4v-4H6V8v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8v2h-4zm-1 0h-4v4h4v-4zM7 6h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2z' fill='%23666' fill-rule='evenodd'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=tableCol]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10 14.5h5V11h-5v3.5zm0 1V19H7h12a1 1 0 0 0 1-1v-2.5h-4V19h-1v-3.5h-5zm10-1V8a1 1 0 0 0-1-1H7h3v3h5V7h1v3h4v1h-4v3.5h4zM7 6h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2z' fill='%23666' fill-rule='evenodd'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=tableAttrs]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M13.495 13.5v3.013h-1V13.5H8.43v-1h4.066V9.487h1V12.5H17.571v1H13.495zm6.505-2v-2h1v2h-1zm0 3h1v2h-1v-2zm0 3h1v.5a2 2 0 0 1-2 2h-1.505v-1H19a1 1 0 0 0 1-1v-.5zM16.495 19v1h-2v-1h2zm-5 0v1h-2v-1h2zm-3 0v1H7a2 2 0 0 1-2-2v-.5h1v.5a1 1 0 0 0 1 1h1.495zM6 16.5H5v-2h1v2zm0-5H5v-2h1v2zm0-3H5V8a2 2 0 0 1 2-2h1.495v1H7a1 1 0 0 0-1 1v.5zM9.495 7V6h2v1h-2zm5 0V6h2v1h-2zm3 0V6H19a2 2 0 0 1 2 2v.5h-1V8a1 1 0 0 0-1-1h-1.505zM5 13.5v-1h2.286v1H5zm13.714 0v-1H21v1h-2.286zM12.495 6h1v2.325h-1V6zm0 11.675h1V20h-1v-2.325z' fill='%23333' fill-rule='nonzero'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=deleteTable]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M16.497 8.5H19.5a.5.5 0 0 1 0 .999h-13a.5.5 0 1 1 0-.999h3.003V8c0-1.105.854-2 1.908-2h3.178c1.054 0 1.908.895 1.908 2v.5zm-5.995 0h4.996V8c0-.552-.373-1-.833-1h-3.33c-.46 0-.833.448-.833 1v.5zm7.993 3.25v-.404 6.962c0 .934-.895 1.692-1.998 1.692H9.503c-1.103 0-1.998-.758-1.998-1.692v-6.962.403-.25a.5.5 0 1 1 1 0v6.671c0 .451.402.817.899.817h7.192c.497 0 .9-.366.9-.817V11.5a.5.5 0 1 1 .999 0v.25zm-7.493-.755a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.999 0v-6a.5.5 0 0 1 .499-.5zm3.996.004a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0v-6a.5.5 0 0 1 .5-.5z' fill='%23666' fill-rule='evenodd'/%3E%3C/svg%3E\")}";
	styleInject(css$2);
	
	var css$3 = ".toolbar-add-table-modal{position:fixed;padding:8px 8px 1px;background-color:#fff;border:1px solid #eee;box-shadow:0 1px 4px 0 rgba(111,130,166,.08),0 16px 30px 0 rgba(111,130,166,.14);font-size:12px;border-radius:2px;z-index:99}.toolbar-add-table-modal .container{border:1px solid #ddd;cursor:pointer}.toolbar-add-table-modal .row{height:18px;border-bottom:1px solid #ddd}.toolbar-add-table-modal .row:first-child{background-color:#f6f6f6}.toolbar-add-table-modal .row:last-child{height:17px;border-bottom:none}.toolbar-add-table-modal .block{display:inline-block;width:25px;height:100%;border-right:1px solid #ddd}.toolbar-add-table-modal .block:last-child{width:23px;border-right:none}.toolbar-add-table-modal .count{text-align:center}";
	styleInject(css$3);
	
	var css$4 = ".toolbar-textExtra-popover-wrapper{display:flex;justify-content:center;align-items:center;position:relative;height:28px;width:45px;font-size:12px;cursor:pointer;transition:all .2s ease;background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='40' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23666'%3E%3Cpath d='M11.07 20H9l8.262-12.744h1.602L21.456 20h-1.854l-.612-3.132h-5.976L11.07 20zm2.862-4.698h4.806l-1.08-6.048-3.726 6.048zM8.991 9.9h-.027c-.108.193-.282.35-.523.474-.24.123-.513.185-.82.185-.174 0-.355-.023-.544-.068a1.622 1.622 0 0 1-.523-.225 1.31 1.31 0 0 1-.396-.415A1.193 1.193 0 0 1 6 9.216c0-.324.092-.582.275-.775.183-.192.419-.339.707-.441.288-.102.608-.17.96-.203.35-.033.695-.05 1.031-.05V7.64c0-.27-.098-.47-.293-.6a1.236 1.236 0 0 0-.698-.193c-.228 0-.447.048-.658.144a1.77 1.77 0 0 0-.522.351l-.559-.657c.246-.229.53-.4.852-.514.32-.114.647-.171.977-.171.384 0 .701.054.95.162.25.108.446.25.59.424.145.174.245.369.302.585.057.216.086.433.086.649v2.63H8.991V9.9zm-.018-1.423H8.73c-.174 0-.358.008-.55.023-.192.015-.37.048-.531.1a1.135 1.135 0 0 0-.406.215.479.479 0 0 0-.162.383.46.46 0 0 0 .243.424.784.784 0 0 0 .244.09c.09.018.18.027.27.027.372 0 .654-.1.847-.298.192-.198.288-.468.288-.81v-.154z'/%3E%3C/g%3E%3Cpath fill='%23AEAEAE' d='M30 11.5h6l-3 3z'/%3E%3C/g%3E%3C/svg%3E\") no-repeat 50%}.toolbar-textExtra-popover-wrapper:hover{background-color:#ddd}.toolbar-textExtra-popover-wrapper.disabled{cursor:not-allowed}.toolbar-textExtra-popover-wrapper.disabled path{fill:#aaa}.toolbar-more-popover{width:80px!important;padding:8px 0}";
	styleInject(css$4);
	
	var preactPortal = createCommonjsModule(function (module, exports) {
	  (function (global, factory) {
	    module.exports = factory(preact__default);
	  })(commonjsGlobal, function (preact) {
	    var classCallCheck = function classCallCheck(instance, Constructor) {
	      if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	      }
	    };
	
	    var inherits = function inherits(subClass, superClass) {
	      if (typeof superClass !== "function" && superClass !== null) {
	        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : (0, _typeof3.default)(superClass)));
	      }
	
	      subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	        constructor: {
	          value: subClass,
	          enumerable: false,
	          writable: true,
	          configurable: true
	        }
	      });
	      if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	    };
	
	    var possibleConstructorReturn = function possibleConstructorReturn(self, call) {
	      if (!self) {
	        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	      }
	
	      return call && ((typeof call === 'undefined' ? 'undefined' : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	    };
	
	    var Portal = function (_Component) {
	      inherits(Portal, _Component);
	
	      function Portal() {
	        classCallCheck(this, Portal);
	        return possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      Portal.prototype.componentDidUpdate = function componentDidUpdate(props) {
	        for (var i in props) {
	          if (props[i] !== this.props[i]) {
	            return setTimeout(this.renderLayer);
	          }
	        }
	      };
	
	      Portal.prototype.componentDidMount = function componentDidMount() {
	        this.isMounted = true;
	        this.renderLayer = this.renderLayer.bind(this);
	        this.renderLayer();
	      };
	
	      Portal.prototype.componentWillUnmount = function componentWillUnmount() {
	        this.renderLayer(false);
	        this.isMounted = false;
	        if (this.remote) this.remote.parentNode.removeChild(this.remote);
	      };
	
	      Portal.prototype.findNode = function findNode(node) {
	        return typeof node === 'string' ? document.querySelector(node) : node;
	      };
	
	      Portal.prototype.renderLayer = function renderLayer() {
	        var show = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	        if (!this.isMounted) return;
	
	        if (this.props.into !== this.intoPointer) {
	          this.intoPointer = this.props.into;
	          if (this.into && this.remote) {
	            this.remote = preact.render(preact.h(PortalProxy, null), this.into, this.remote);
	          }
	          this.into = this.findNode(this.props.into);
	        }
	
	        this.remote = preact.render(preact.h(PortalProxy, { context: this.context }, show && this.props.children || null), this.into, this.remote);
	      };
	
	      Portal.prototype.render = function render() {
	        return null;
	      };
	
	      return Portal;
	    }(preact.Component);
	
	    var PortalProxy = function (_Component2) {
	      inherits(PortalProxy, _Component2);
	
	      function PortalProxy() {
	        classCallCheck(this, PortalProxy);
	        return possibleConstructorReturn(this, _Component2.apply(this, arguments));
	      }
	
	      PortalProxy.prototype.getChildContext = function getChildContext() {
	        return this.props.context;
	      };
	
	      PortalProxy.prototype.render = function render(_ref) {
	        var children = _ref.children;
	
	        return children && children[0] || null;
	      };
	
	      return PortalProxy;
	    }(preact.Component);
	
	    return Portal;
	  });
	});
	
	var css$5 = ".ct-editor-dropdown-content{position:absolute;border-radius:2px;background:#fff;border:1px solid #eee;box-shadow:0 1px 4px 0 rgba(111,130,166,.08),0 16px 30px 0 rgba(111,130,166,.14);cursor:pointer;z-index:9999}.ct-editor-dropdown-container{position:relative;padding-left:10px;padding-right:5px;height:28px;font-size:12px;cursor:pointer;transition:all .2s ease}.ct-editor-dropdown-container,.ct-editor-dropdown-container .ct-dropdown-selected{display:flex;justify-content:space-between;align-items:center}.ct-editor-dropdown-container .ct-dropdown-selected svg{margin-left:20px;margin-right:5px}.ct-editor-dropdown-container .ct-toolbar-tooltip{display:none}.ct-editor-dropdown-container:hover{background-color:#ddd}.ct-editor-dropdown-container:hover .ct-toolbar-tooltip{display:block}.ct-editor-dropdown-container.disabled{cursor:not-allowed;color:#aaa}.ct-editor-dropdown-container.disabled .ct-dropdown-selected{cursor:not-allowed}";
	styleInject(css$5);
	
	var css$6 = ".toolbar-p-popover-item{margin:8px auto;padding-left:16px;padding-right:10px;color:#333;transition:all .2s ease}.toolbar-p-popover-item:hover{background:#f6f6f6}.toolbar-p-popover-item:not(:first-child){font-weight:700}.toolbar-p-popover-item:first-child{font-size:14px;line-height:24px}.toolbar-p-popover-item:nth-child(2){font-size:28px;line-height:42px}.toolbar-p-popover-item:nth-child(3){font-size:24px;line-height:36px}.toolbar-p-popover-item:nth-child(4){font-size:20px;line-height:30px}.toolbar-p-popover-item:nth-child(5){font-size:16px;line-height:24px}.toolbar-p-popover-item:nth-child(6){font-size:14px;line-height:21px}.toolbar-p-popover-item:nth-child(7){font-size:12px;line-height:18px}";
	styleInject(css$6);
	
	var css$7 = ".citadel-editor-toolbar .fs-dp-item{margin:5px auto;padding:3px 16px;color:#333;transition:all .2s ease;font-weight:700;font-size:14px;line-height:16px}.citadel-editor-toolbar .fs-dp-item:hover{background:#f6f6f6}";
	styleInject(css$7);
	
	var Editor = function () {
	  function Editor(dom) {
	    var _this = this;
	
	    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    (0, _classCallCheck3.default)(this, Editor);
	
	    this.dom = void 0;
	    this.modules = void 0;
	    this.config = void 0;
	    this.$scroll = void 0;
	    this.view = void 0;
	    this.schema = void 0;
	    this.events = [];
	    this.dValue = "<p/>";
	    this.eventBus = new EventBus();
	    this.excludeModules = [];
	    this.editorKey = Math.random().toFixed(9).toString().split('.')[1];
	
	    this.trigger = function (type, params) {
	      var events = _this.events[type];
	
	      if (events) {
	        events.forEach(function (handler) {
	          return handler(params);
	        });
	      }
	    };
	
	    this.getTopBias = function () {
	      var _$scroll$getBoundingC = _this.$scroll.getBoundingClientRect(),
	          top = _$scroll$getBoundingC.top;
	
	      return _this.tableStore.isShowPopover ? top + 30 : top;
	    };
	
	    this.getBottomBias = function () {
	      return 3;
	    };
	
	    this.dom = dom;
	    this.dom.classList.add(ROOT_CLASS_NAME);
	    this.$scroll = dom.parentNode;
	    this.config = this.applyConfig(config);
	    this.modules = getModules(Editor.modules, config);
	    this.create(config.defaultValue || "");
	
	    if (window.__CITADELEDITOR_INSTANCE) {
	      window.__CITADELEDITOR_INSTANCE[this.editorKey] = this;
	    } else {
	      window.__CITADELEDITOR_INSTANCE = (0, _defineProperty3.default)({}, this.editorKey, this);
	    }
	  }
	
	  (0, _createClass3.default)(Editor, [{
	    key: 'destroy',
	    value: function destroy() {
	      delete window.__CITADELEDITOR_INSTANCE[this.editorKey];
	      this.modules.forEach(function (module) {
	        if (typeof module.destroy === "function") {
	          module.destroy();
	        }
	      });
	      var $modal = document.querySelector(".ct-editor-modal");
	
	      if ($modal) {
	        var $textarea = $modal.querySelector("textarea");
	
	        if ($textarea) {
	          $textarea.value = "";
	        }
	
	        $modal.remove();
	      }
	    }
	  }, {
	    key: 'defaultValue',
	    value: function defaultValue(value) {
	      this.dValue = value;
	      this.value(value);
	      return this;
	    }
	  }, {
	    key: 'value',
	    value: function value(_value) {
	      if (!this.view) {
	        return;
	      }
	
	      var _view$state = this.view.state,
	          doc = _view$state.doc,
	          schema = _view$state.schema,
	          plugins = _view$state.plugins;
	
	
	      if (arguments.length === 0 || typeof _value !== "string") {
	        var $container = document.createElement("div");
	        var fragment = prosemirrorModel.DOMSerializer.fromSchema(schema).serializeFragment(doc.content);
	        $container.appendChild(fragment);
	        return $container.innerHTML;
	      }
	
	      var newDoc = createDoc(schema, plugins, _value);
	      var newState = prosemirrorState.EditorState.create({
	        doc: newDoc,
	        schema: schema,
	        plugins: plugins
	      });
	      this.view.updateState(newState);
	    }
	  }, {
	    key: 'status',
	    value: function status() {
	      return this.modules.map(function (module) {
	        return module.getStatus();
	      });
	    }
	  }, {
	    key: 'hasFocus',
	    value: function hasFocus() {
	      if (!this.view) {
	        return;
	      }
	
	      return this.view.hasFocus();
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      if (!this.view) {
	        return;
	      }
	
	      this.view.focus();
	    }
	  }, {
	    key: 'on',
	    value: function on(type, handler) {
	      this.eventBus.on(type, handler);
	    }
	  }, {
	    key: 'off',
	    value: function off(type, handler) {
	      this.eventBus.off(type, handler);
	    }
	  }, {
	    key: 'emit',
	    value: function emit(type, data) {
	      this.eventBus.emit(type, data);
	    }
	  }, {
	    key: 'applyModuleConfig',
	    value: function applyModuleConfig(config, target) {
	      _applyModuleConfig(config, target);
	    }
	  }, {
	    key: 'applyConfig',
	    value: function applyConfig(config) {
	      if (config.scroll) {
	        this.$scroll = config.scroll;
	      }
	
	      if (config.getTopBias) {
	        this.getTopBias = config.getTopBias;
	      }
	
	      if (config.getBottomBias) {
	        this.getBottomBias = config.getBottomBias;
	      }
	
	      if (config.excludeModules) {
	        this.excludeModules = config.excludeModules;
	      }
	
	      return config;
	    }
	  }, {
	    key: 'create',
	    value: function create(dValue) {
	      var _this2 = this;
	
	      var schemas = [];
	      var plugins = [];
	      this.modules.forEach(function (_ref6) {
	        var name = _ref6.name,
	            schema = _ref6.schema,
	            pls = _ref6.plugins,
	            commands = _ref6.commands,
	            events = _ref6.events,
	            _ref6$config = _ref6.config,
	            config = _ref6$config === undefined ? {} : _ref6$config,
	            store = _ref6.store,
	            utils = _ref6.utils;
	
	        if (_this2.excludeModules.includes(name)) {
	          return;
	        }
	
	        if (pls) {
	          plugins.push.apply(plugins, (0, _toConsumableArray3.default)(pls));
	        }
	
	        if (schema) {
	          if (name === "basic") {
	            schemas.unshift(schema);
	          } else {
	            schemas.push(schema);
	          }
	        }
	
	        (0, _keys2.default)(commands || []).forEach(function (key) {
	          var trueCommand = commands[key];
	
	          commands[key] = function () {
	            if (!_this2.view) {
	              return function () {
	                return null;
	              };
	            }
	
	            var _view = _this2.view,
	                state = _view.state,
	                dispatch = _view.dispatch;
	
	            var command = trueCommand.apply(undefined, arguments);
	            return command(state, dispatch, _this2.view, _this2.trigger);
	          };
	        });
	
	        (0, _keys2.default)(events || []).forEach(function (key) {
	          var handler = function handler(params) {
	            if (!_this2.view) {
	              return;
	            }
	
	            var _view2 = _this2.view,
	                state = _view2.state,
	                dispatch = _view2.dispatch;
	
	            events[key](params)(state, dispatch, _this2.view);
	          };
	
	          if (Array.isArray(_this2.events[key])) {
	            _this2.events[key].push(handler);
	          } else {
	            _this2.events[key] = [handler];
	          }
	        });
	        _this2[name + 'Commands'] = commands;
	        _this2[name + 'Utils'] = utils;
	        _this2[name + 'Store'] = store;
	        _this2[name + 'Config'] = config;
	      });
	      var editorSchema = new prosemirrorModel.Schema(collectSchemas(schemas));
	      var editorState = prosemirrorState.EditorState.create({
	        doc: createDoc(editorSchema, plugins, this.dValue),
	        schema: editorSchema,
	        plugins: plugins
	      });
	      this.plugins = plugins;
	      this.view = new prosemirrorView.EditorView(this.dom, {
	        state: editorState
	      });
	      this.schema = this.view.state.schema;
	      this.applyModuleConfig(this.config.moduleConfigs, this);
	      this.modules.forEach(function (module) {
	        return module.init && module.init(_this2);
	      });
	      this.value(dValue);
	    }
	  }]);
	  return Editor;
	}();
	
	Editor.modules = defaultModules;
	
	exports.Editor = Editor;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _getIterator2 = __webpack_require__(62);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _setPrototypeOf = __webpack_require__(64);
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _create = __webpack_require__(57);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _getOwnPropertyDescriptor = __webpack_require__(23);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _defineProperty2 = __webpack_require__(15);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(30);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(7);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(10);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(32);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(31);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _getOwnPropertySymbols = __webpack_require__(16);
	
	var _getOwnPropertySymbols2 = _interopRequireDefault(_getOwnPropertySymbols);
	
	var _keys = __webpack_require__(13);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _assign = __webpack_require__(26);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _typeof2 = __webpack_require__(8);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault(ex) {
	  return ex && (typeof ex === 'undefined' ? 'undefined' : (0, _typeof3.default)(ex)) === 'object' && 'default' in ex ? ex['default'] : ex;
	}
	
	var preact = __webpack_require__(24);
	var preact__default = _interopDefault(preact);
	var classNames = _interopDefault(__webpack_require__(49));
	var index_js = __webpack_require__(56);
	var index_js$1 = __webpack_require__(22);
	var throttle = _interopDefault(__webpack_require__(78));
	__webpack_require__(29);
	__webpack_require__(25);
	__webpack_require__(12);
	__webpack_require__(6);
	var index_js$3 = __webpack_require__(97);
	
	var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
	
	function createCommonjsModule(fn, module) {
	  return module = { exports: {} }, fn(module, module.exports), module.exports;
	}
	
	var _extends_1 = createCommonjsModule(function (module) {
	  function _extends() {
	    module.exports = _extends = _assign2.default || function (target) {
	      for (var i = 1; i < arguments.length; i++) {
	        var source = arguments[i];
	
	        for (var key in source) {
	          if (Object.prototype.hasOwnProperty.call(source, key)) {
	            target[key] = source[key];
	          }
	        }
	      }
	
	      return target;
	    };
	
	    return _extends.apply(this, arguments);
	  }
	
	  module.exports = _extends;
	});
	
	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = (0, _keys2.default)(source);
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  return target;
	}
	
	var objectWithoutPropertiesLoose = _objectWithoutPropertiesLoose;
	
	function _objectWithoutProperties(source, excluded) {
	  if (source == null) return {};
	  var target = objectWithoutPropertiesLoose(source, excluded);
	  var key, i;
	
	  if (_getOwnPropertySymbols2.default) {
	    var sourceSymbolKeys = (0, _getOwnPropertySymbols2.default)(source);
	
	    for (i = 0; i < sourceSymbolKeys.length; i++) {
	      key = sourceSymbolKeys[i];
	      if (excluded.indexOf(key) >= 0) continue;
	      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
	      target[key] = source[key];
	    }
	  }
	
	  return target;
	}
	
	var objectWithoutProperties = _objectWithoutProperties;
	
	var MenuItemWrapper = function (_preact$Component) {
	  (0, _inherits3.default)(MenuItemWrapper, _preact$Component);
	
	  function MenuItemWrapper() {
	    var _ref2;
	
	    (0, _classCallCheck3.default)(this, MenuItemWrapper);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = MenuItemWrapper.__proto__ || (0, _getPrototypeOf2.default)(MenuItemWrapper)).call.apply(_ref2, [this].concat(args)));
	
	    _this.container = void 0;
	    return _this;
	  }
	
	  (0, _createClass3.default)(MenuItemWrapper, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var getRef = this.props.getRef;
	
	
	      if (getRef) {
	        getRef(this.container);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          children = _props.children,
	          isMore = _props.isMore;
	
	      return preact.h("div", {
	        className: 'menu-item-wrapper' + (isMore ? " more" : ""),
	        ref: function ref(container) {
	          _this2.container = container;
	        }
	      }, children);
	    }
	  }]);
	  return MenuItemWrapper;
	}(preact.Component);
	
	var MenuItem = function (_preact$Component2) {
	  (0, _inherits3.default)(MenuItem, _preact$Component2);
	
	  function MenuItem() {
	    (0, _classCallCheck3.default)(this, MenuItem);
	    return (0, _possibleConstructorReturn3.default)(this, (MenuItem.__proto__ || (0, _getPrototypeOf2.default)(MenuItem)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(MenuItem, [{
	    key: 'render',
	    value: function render() {
	      var _this$props = this.props,
	          type = _this$props.type,
	          restProps = objectWithoutProperties(_this$props, ["type"]);
	
	
	      if (type === "extra") {
	        return preact.h(ExtraItem, restProps);
	      }
	
	      return preact.h(HeaderMenuItem, restProps);
	    }
	  }]);
	  return MenuItem;
	}(preact.Component);
	
	var HeaderMenuItem = function (_preact$Component3) {
	  (0, _inherits3.default)(HeaderMenuItem, _preact$Component3);
	
	  function HeaderMenuItem() {
	    var _ref3;
	
	    (0, _classCallCheck3.default)(this, HeaderMenuItem);
	
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    var _this4 = (0, _possibleConstructorReturn3.default)(this, (_ref3 = HeaderMenuItem.__proto__ || (0, _getPrototypeOf2.default)(HeaderMenuItem)).call.apply(_ref3, [this].concat(args)));
	
	    _this4.state = {
	      hasTooltip: false
	    };
	
	    _this4.handleClick = function (e) {
	      var _this4$props = _this4.props,
	          disabledHandler = _this4$props.disabledHandler,
	          onClick = _this4$props.onClick;
	
	      var disabled = disabledHandler && disabledHandler();
	
	      if (disabled) {
	        return;
	      }
	
	      if (onClick) {
	        onClick(e);
	      }
	    };
	    return _this4;
	  }
	
	  (0, _createClass3.default)(HeaderMenuItem, [{
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var _props2 = this.props,
	          action = _props2.action,
	          tooltip = _props2.tooltip,
	          activeHandler = _props2.activeHandler,
	          disabledHandler = _props2.disabledHandler,
	          children = _props2.children;
	
	      var disabled = disabledHandler && disabledHandler();
	      var iconClassNames = classNames({
	        "active": activeHandler && activeHandler(),
	        disabled: disabled,
	        "menu-item": true
	      });
	      return preact.h("div", {
	        className: iconClassNames,
	        onMouseEnter: function onMouseEnter() {
	          if (disabled) {
	            return;
	          }
	
	          _this5.setState({
	            hasTooltip: true
	          });
	        },
	        onMouseLeave: function onMouseLeave() {
	          return _this5.setState({
	            hasTooltip: false
	          });
	        },
	        onClick: this.handleClick
	      }, preact.h("span", {
	        className: "toolbar-icon-wrapper",
	        "data-action": action
	      }), children, this.state.hasTooltip && tooltip && preact.h("div", {
	        className: "toolbar-tooltip"
	      }, tooltip));
	    }
	  }]);
	  return HeaderMenuItem;
	}(preact.Component);
	
	var ExtraItem = function (_preact$Component4) {
	  (0, _inherits3.default)(ExtraItem, _preact$Component4);
	
	  function ExtraItem() {
	    (0, _classCallCheck3.default)(this, ExtraItem);
	    return (0, _possibleConstructorReturn3.default)(this, (ExtraItem.__proto__ || (0, _getPrototypeOf2.default)(ExtraItem)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ExtraItem, [{
	    key: 'render',
	    value: function render() {
	      var _this$props2 = this.props,
	          action = _this$props2.action,
	          tooltip = _this$props2.tooltip,
	          restProps = objectWithoutProperties(_this$props2, ["action", "tooltip"]);
	
	
	      return preact.h("div", _extends_1({
	        className: "menu-item"
	      }, restProps), action ? preact.h("span", {
	        "data-action": action,
	        className: "toolbar-icon-wrapper"
	      }) : "", preact.h("span", null, tooltip));
	    }
	  }]);
	  return ExtraItem;
	}(preact.Component);
	
	var handleListClick = function handleListClick(listType, editorCore) {
	  var listCommands = editorCore.listCommands,
	      listUtils = editorCore.listUtils,
	      view = editorCore.view;
	
	
	  if (listUtils.judgeListType(view.state, listType)) {
	    listCommands.unwrapList();
	  } else if (!listUtils.isInList(view.state)) {
	    listCommands.wrapInList(listType);
	  } else {
	    listCommands.transformList(listType);
	  }
	
	  view.focus();
	};
	var caculatePopoverPos = function caculatePopoverPos(mountNode, popover) {
	  var top = mountNode.offsetTop;
	  var left = mountNode.offsetWidth;
	  var rect = mountNode.getBoundingClientRect();
	  var innerWidth = window.innerWidth;
	
	  if (innerWidth - rect.right < 100 && popover) {
	    left = -popover.offsetWidth;
	  }
	
	  return {
	    left: left + 'px',
	    top: top - 10 + 'px'
	  };
	};
	
	function styleInject(css, ref) {
	  if (ref === void 0) ref = {};
	  var insertAt = ref.insertAt;
	
	  if (!css || typeof document === 'undefined') {
	    return;
	  }
	
	  var head = document.head || document.getElementsByTagName('head')[0];
	  var style = document.createElement('style');
	  style.type = 'text/css';
	
	  if (insertAt === 'top') {
	    if (head.firstChild) {
	      head.insertBefore(style, head.firstChild);
	    } else {
	      head.appendChild(style);
	    }
	  } else {
	    head.appendChild(style);
	  }
	
	  if (style.styleSheet) {
	    style.styleSheet.cssText = css;
	  } else {
	    style.appendChild(document.createTextNode(css));
	  }
	}
	
	var css = ".toolbar-color-popover-wrapper{display:flex;justify-content:center;align-items:center;position:relative;height:28px;width:40px;font-size:12px;cursor:pointer;transition:all .2s ease}.toolbar-color-popover-wrapper.disabled{cursor:not-allowed}.toolbar-color-popover-wrapper.disabled path{fill:#aaa}.toolbar-color-popover-wrapper .left{width:26px;height:100%}.toolbar-color-popover-wrapper .right{width:14px;height:100%;background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='7' height='4' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M.5.5h6l-3 3z' fill='%23AEAEAE' fill-rule='evenodd'/%3E%3C/svg%3E\") no-repeat 50%}.toolbar-color-popover-wrapper.font-color{position:relative}.toolbar-color-popover-wrapper.font-color .left{background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='10' height='10' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6.62 5.902L5.01 1.484 3.302 5.902H6.62zM4.26 0h1.624l3.844 10H8.156L7.08 7.005H2.89L1.743 10H.272L4.26 0z' fill='%23666' fill-rule='evenodd'/%3E%3C/svg%3E\") no-repeat 7px 7px}.toolbar-color-popover-wrapper.font-color .left .color{position:absolute;left:5px;bottom:7px;width:14px;height:2px;border:1px solid;margin:0 auto}.toolbar-color-popover-wrapper.bg-color .left{position:relative}.toolbar-color-popover-wrapper.bg-color .color{position:absolute;top:18px;left:5px;width:14px;height:2px}.toolbar-color-popover-wrapper.border-color{width:246px}.toolbar-color-popover{display:flex;justify-content:flex-start;align-items:flex-start;flex-wrap:wrap;position:absolute;width:258px;height:150px;bottom:-152px;left:0;padding:8px;border-radius:2px;background:#fff;border:1px solid #eee;box-shadow:0 1px 4px 0 rgba(111,130,166,.08),0 16px 30px 0 rgba(111,130,166,.14);z-index:2}.toolbar-color-popover .default{position:relative;width:calc(100% - 2px);margin:0 1px 8px;height:24px;border:1px solid #ddd;border-radius:2px;cursor:pointer}.toolbar-color-popover .color-grid{position:absolute;top:5px;left:10px;width:13px;height:13px;border:1px solid}.toolbar-color-popover .text{height:24px;line-height:24px;text-align:center;font-size:12px;color:#333}.toolbar-color-grid{margin:0 2px;width:16px;height:16px;cursor:pointer}.toolbar-color-grid:nth-child(2),.toolbar-color-grid:nth-child(12){border:1px solid #eee}.toolbar-color-grid.selected{z-index:2;border-radius:1px;border:1px solid #fff;box-shadow:0 0 0 2px #999}.toolbar-color-grid:hover{z-index:3;border-radius:1px;border:1px solid #fff}.toolbar-color-grid:hover:nth-child(3){box-shadow:0 0 0 2px #333}.toolbar-color-grid:hover:nth-child(4){box-shadow:0 0 0 2px #f5222d}.toolbar-color-grid:hover:nth-child(5){box-shadow:0 0 0 2px #fa541c}.toolbar-color-grid:hover:nth-child(6){box-shadow:0 0 0 2px #faad14}.toolbar-color-grid:hover:nth-child(7){box-shadow:0 0 0 2px #fadb14}.toolbar-color-grid:hover:nth-child(8){box-shadow:0 0 0 2px #52c41a}.toolbar-color-grid:hover:nth-child(9){box-shadow:0 0 0 2px #13c2c2}.toolbar-color-grid:hover:nth-child(10){box-shadow:0 0 0 2px #1890ff}.toolbar-color-grid:hover:nth-child(11){box-shadow:0 0 0 2px #2f54eb}.toolbar-color-grid:hover:nth-child(12){box-shadow:0 0 0 2px #722ed1}.toolbar-color-grid:hover:nth-child(13){box-shadow:0 0 0 2px #eb2f96}.toolbar-color-grid:hover:nth-child(14){box-shadow:0 0 0 2px #f6f6f6}.toolbar-color-grid:hover:nth-child(15){box-shadow:0 0 0 2px #989898}.toolbar-color-grid:hover:nth-child(16){box-shadow:0 0 0 2px #ffe8e7}.toolbar-color-grid:hover:nth-child(17){box-shadow:0 0 0 2px #ffece0}.toolbar-color-grid:hover:nth-child(18){box-shadow:0 0 0 2px #fff7cb}.toolbar-color-grid:hover:nth-child(19){box-shadow:0 0 0 2px #fcfcca}.toolbar-color-grid:hover:nth-child(20){box-shadow:0 0 0 2px #e5f7d3}.toolbar-color-grid:hover:nth-child(21){box-shadow:0 0 0 2px #cffff7}.toolbar-color-grid:hover:nth-child(22){box-shadow:0 0 0 2px #d4eefc}.toolbar-color-grid:hover:nth-child(23){box-shadow:0 0 0 2px #dfe8fc}.toolbar-color-grid:hover:nth-child(24){box-shadow:0 0 0 2px #efe1fa}.toolbar-color-grid:hover:nth-child(25){box-shadow:0 0 0 2px #fbe1eb}.toolbar-color-grid:hover:nth-child(26){box-shadow:0 0 0 2px #e9e9e9}.toolbar-color-grid:hover:nth-child(27){box-shadow:0 0 0 2px #666}.toolbar-color-grid:hover:nth-child(28){box-shadow:0 0 0 2px #ffa39e}.toolbar-color-grid:hover:nth-child(29){box-shadow:0 0 0 2px #ffbb96}.toolbar-color-grid:hover:nth-child(30){box-shadow:0 0 0 2px #ffe58f}.toolbar-color-grid:hover:nth-child(31){box-shadow:0 0 0 2px #fffb8f}.toolbar-color-grid:hover:nth-child(32){box-shadow:0 0 0 2px #b7eb8f}.toolbar-color-grid:hover:nth-child(33){box-shadow:0 0 0 2px #87e8de}.toolbar-color-grid:hover:nth-child(34){box-shadow:0 0 0 2px #91d5ff}.toolbar-color-grid:hover:nth-child(35){box-shadow:0 0 0 2px #adc6ff}.toolbar-color-grid:hover:nth-child(36){box-shadow:0 0 0 2px #d3adf7}.toolbar-color-grid:hover:nth-child(37){box-shadow:0 0 0 2px #ffadd2}.toolbar-color-grid:hover:nth-child(38){box-shadow:0 0 0 2px #ddd}.toolbar-color-grid:hover:nth-child(39){box-shadow:0 0 0 2px #4b4b4b}.toolbar-color-grid:hover:nth-child(40){box-shadow:0 0 0 2px #ff4d4f}.toolbar-color-grid:hover:nth-child(41){box-shadow:0 0 0 2px #ff7a45}.toolbar-color-grid:hover:nth-child(42){box-shadow:0 0 0 2px #ffc53d}.toolbar-color-grid:hover:nth-child(43){box-shadow:0 0 0 2px #ffec3d}.toolbar-color-grid:hover:nth-child(44){box-shadow:0 0 0 2px #73d13d}.toolbar-color-grid:hover:nth-child(45){box-shadow:0 0 0 2px #36cfc9}.toolbar-color-grid:hover:nth-child(46){box-shadow:0 0 0 2px #40a8ff}.toolbar-color-grid:hover:nth-child(47){box-shadow:0 0 0 2px #597ef7}.toolbar-color-grid:hover:nth-child(48){box-shadow:0 0 0 2px #9254de}.toolbar-color-grid:hover:nth-child(49){box-shadow:0 0 0 2px #f759ab}.toolbar-color-grid:hover:nth-child(50){box-shadow:0 0 0 2px #ccc}.toolbar-color-grid:hover:nth-child(51){box-shadow:0 0 0 2px #262626}.toolbar-color-grid:hover:nth-child(52){box-shadow:0 0 0 2px #cf1322}.toolbar-color-grid:hover:nth-child(53){box-shadow:0 0 0 2px #d4380d}.toolbar-color-grid:hover:nth-child(54){box-shadow:0 0 0 2px #d48806}.toolbar-color-grid:hover:nth-child(55){box-shadow:0 0 0 2px #d4b106}.toolbar-color-grid:hover:nth-child(56){box-shadow:0 0 0 2px #389e0d}.toolbar-color-grid:hover:nth-child(57){box-shadow:0 0 0 2px #08979c}.toolbar-color-grid:hover:nth-child(58){box-shadow:0 0 0 2px #096dd9}.toolbar-color-grid:hover:nth-child(59){box-shadow:0 0 0 2px #1d39c4}.toolbar-color-grid:hover:nth-child(60){box-shadow:0 0 0 2px #531dab}.toolbar-color-grid:hover:nth-child(61){box-shadow:0 0 0 2px #c41d7f}.toolbar-color-grid:hover:nth-child(62){box-shadow:0 0 0 2px #aaa}.toolbar-color-grid:hover:nth-child(63){box-shadow:0 0 0 2px #000}.toolbar-color-grid:hover:nth-child(64){box-shadow:0 0 0 2px #820014}.toolbar-color-grid:hover:nth-child(65){box-shadow:0 0 0 2px #871400}.toolbar-color-grid:hover:nth-child(66){box-shadow:0 0 0 2px #874d00}.toolbar-color-grid:hover:nth-child(67){box-shadow:0 0 0 2px #876800}.toolbar-color-grid:hover:nth-child(68){box-shadow:0 0 0 2px #135200}.toolbar-color-grid:hover:nth-child(69){box-shadow:0 0 0 2px #00474f}.toolbar-color-grid:hover:nth-child(70){box-shadow:0 0 0 2px #003a8c}.toolbar-color-grid:hover:nth-child(71){box-shadow:0 0 0 2px #061178}.toolbar-color-grid:hover:nth-child(72){box-shadow:0 0 0 2px #22075e}.toolbar-color-grid:hover:nth-child(73){box-shadow:0 0 0 2px #780650}.toolbar-color-grid:hover:nth-child(2),.toolbar-color-grid:hover:nth-child(14){box-shadow:0 0 0 2px #aaa}";
	styleInject(css);
	
	var colors = ["#fff", "#333", "#f5222d", "#fa541c", "#faad14", "#fadb14", "#52c41a", "#13c2c2", "#1890ff", "#2f54eb", "#722ed1", "#eb2f96", "#f6f6f6", "#989898", "#ffe8e7", "#ffece0", "#fff7cb", "#fcfcca", "#e5f7d3", "#cffff7", "#d4eefc", "#dfe8fc", "#efe1fa", "#fbe1eb", "#e9e9e9", "#666", "#ffa39e", "#ffbb96", "#ffe58f", "#fffb8f", "#b7eb8f", "#87e8de", "#91d5ff", "#adc6ff", "#d3adf7", "#ffadd2", "#ddd", "#4b4b4b", "#ff4d4f", "#ff7a45", "#ffc53d", "#ffec3d", "#73d13d", "#36cfc9", "#40a8ff", "#597ef7", "#9254de", "#f759ab", "#ccc", "#262626", "#cf1322", "#d4380d", "#d48806", "#d4b106", "#389e0d", "#08979c", "#096dd9", "#1d39c4", "#531dab", "#c41d7f", "#aaa", "#000", "#820014", "#871400", "#874d00", "#876800", "#135200", "#00474f", "#003a8c", "#061178", "#22075e", "#780650"];
	var colorTypes = [{
	  defaultBg: "#333",
	  defaultBorder: "#333",
	  tip: "文字颜色",
	  type: "font"
	}, {
	  defaultBg: "#fff",
	  defaultBorder: "#eee",
	  tip: "表格底色",
	  type: "bg"
	}, {
	  defaultBg: "#ccc",
	  defaultBorder: "#ccc",
	  tip: "边框颜色",
	  type: "border"
	}];
	
	var Popover = function (_preact$Component5) {
	  (0, _inherits3.default)(Popover, _preact$Component5);
	
	  function Popover() {
	    (0, _classCallCheck3.default)(this, Popover);
	    return (0, _possibleConstructorReturn3.default)(this, (Popover.__proto__ || (0, _getPrototypeOf2.default)(Popover)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Popover, [{
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          typeInfo = _props3.typeInfo,
	          select = _props3.select,
	          selected = _props3.selected,
	          displayPos = _props3.displayPos;
	
	      var colorGrids = colors.map(function (color) {
	        return preact.h("div", {
	          key: color,
	          style: {
	            background: color
	          },
	          onClick: function onClick() {
	            return select(color);
	          },
	          className: classNames("toolbar-color-grid", {
	            selected: selected === color
	          })
	        });
	      });
	      return preact.h("div", {
	        "data-action": typeInfo.type + 'Color',
	        className: "toolbar-color-popover",
	        style: displayPos
	      }, preact.h("div", {
	        onClick: function onClick() {
	          return select(null);
	        },
	        className: "default"
	      }, preact.h("div", {
	        style: {
	          background: typeInfo.defaultBg,
	          borderColor: typeInfo.defaultBorder
	        },
	        className: "color-grid"
	      }), preact.h("div", {
	        className: "text"
	      }, '\u6062\u590D\u9ED8\u8BA4')), colorGrids);
	    }
	  }]);
	  return Popover;
	}(preact.Component);
	
	var ColorPopover = function (_preact$Component6) {
	  (0, _inherits3.default)(ColorPopover, _preact$Component6);
	
	  function ColorPopover(props) {
	    (0, _classCallCheck3.default)(this, ColorPopover);
	
	    var _this8 = (0, _possibleConstructorReturn3.default)(this, (ColorPopover.__proto__ || (0, _getPrototypeOf2.default)(ColorPopover)).call(this, props));
	
	    _this8.onSelect = function (color) {
	      var _this8$props = _this8.props,
	          type = _this8$props.type,
	          setSelected = _this8$props.setSelected,
	          setColor = _this8$props.setColor,
	          editorCore = _this8$props.editorCore;
	      var view = editorCore.view,
	          basicCommands = editorCore.basicCommands;
	
	
	      if (type === "font") {
	        if (color === null) {
	          basicCommands.setTextDefaultColor();
	        } else {
	          basicCommands.setTextColor(color);
	        }
	      }
	
	      if (setSelected) {
	        setSelected(color);
	      }
	
	      if (setColor) {
	        setColor(color);
	      }
	
	      view.focus();
	
	      window.requestAnimationFrame(function () {
	        _this8.setState({
	          hasTooltip: false,
	          isOpen: false,
	          selected: color
	        });
	      });
	    };
	
	    _this8.hidePopover = function (e) {
	      if (!e || e && e.target && !_this8.container.contains(e.target)) {
	        _this8.setState({
	          hasTooltip: false,
	          isOpen: false
	        });
	        window.removeEventListener("click", _this8.hidePopover);
	      }
	    };
	
	    _this8.setColor = function () {
	      var _this8$props2 = _this8.props,
	          type = _this8$props2.type,
	          editorCore = _this8$props2.editorCore,
	          setColor = _this8$props2.setColor;
	      var view = editorCore.view,
	          basicCommands = editorCore.basicCommands;
	
	
	      if (type === "font") {
	        basicCommands.setTextColor(_this8.state.selected);
	      }
	
	      if (setColor) {
	        setColor(_this8.state.selected);
	      }
	
	      view.focus();
	    };
	
	    _this8.handleClick = function (e) {
	      var _this8$props3 = _this8.props,
	          editorCore = _this8$props3.editorCore,
	          disabledHandler = _this8$props3.disabledHandler;
	      var view = editorCore.view;
	
	      var disabled = disabledHandler();
	
	      if (view) {
	        view.focus();
	      }
	
	      if (disabled) {
	        return;
	      }
	
	      var isOpen = _this8.state.isOpen;
	
	
	      if (!isOpen) {
	        _this8.setState({
	          hasTooltip: false,
	          isOpen: true
	        });
	        window.addEventListener("click", _this8.hidePopover);
	      } else {
	        _this8.hidePopover();
	      }
	    };
	
	    _this8.handleMouseEnter = function () {
	      if (_this8.state.isOpen) {
	        return;
	      }
	
	      _this8.setState({
	        hasTooltip: true
	      });
	    };
	
	    _this8.state = {
	      hasTooltip: false,
	      isOpen: false,
	      popoverPos: {},
	      selected: props.selected || null
	    };
	    return _this8;
	  }
	
	  (0, _createClass3.default)(ColorPopover, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var popoverPos = {
	        left: 0,
	        top: this.container.offsetHeight + 'px'
	      };
	      this.setState({
	        popoverPos: popoverPos
	      });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener("click", this.hidePopover);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this9 = this;
	
	      var _props4 = this.props,
	          type = _props4.type,
	          disabledHandler = _props4.disabledHandler,
	          children = _props4.children;
	
	      var disabled = disabledHandler();
	      var _state = this.state,
	          hasTooltip = _state.hasTooltip,
	          isOpen = _state.isOpen,
	          selected = _state.selected,
	          popoverPos = _state.popoverPos;
	
	      var typeInfo = colorTypes.find(function (_) {
	        return _.type === type;
	      });
	
	      if (children && children.length) {
	        return preact.h("div", {
	          ref: function ref(container) {
	            return _this9.container = container;
	          },
	          onMouseEnter: function onMouseEnter() {
	            if (disabled) {
	              return;
	            }
	
	            _this9.handleMouseEnter();
	          },
	          onMouseLeave: function onMouseLeave() {
	            return _this9.setState({
	              hasTooltip: false
	            });
	          },
	          onClick: this.handleClick,
	          className: 'toolbar-color-popover-wrapper ' + type + '-color' + (disabled ? " disabled" : "")
	        }, children, isOpen && preact.h(Popover, {
	          typeInfo: typeInfo,
	          selected: selected,
	          select: this.onSelect,
	          displayPos: popoverPos
	        }), hasTooltip && preact.h("div", {
	          className: "ct-toolbar-tooltip"
	        }, typeInfo.tip));
	      }
	
	      return preact.h("div", {
	        ref: function ref(container) {
	          return _this9.container = container;
	        },
	        onMouseEnter: function onMouseEnter() {
	          if (disabled) {
	            return;
	          }
	
	          _this9.handleMouseEnter();
	        },
	        onMouseLeave: function onMouseLeave() {
	          return _this9.setState({
	            hasTooltip: false
	          });
	        },
	        className: 'toolbar-color-popover-wrapper ' + type + '-color' + (disabled ? " disabled" : "")
	      }, type === "bg" && preact.h("div", {
	        "data-action": "bgColor",
	        className: "left",
	        onClick: this.setColor
	      }, preact.h("div", {
	        className: "color",
	        style: {
	          background: selected || "#989898"
	        }
	      })), type === "font" && preact.h("div", {
	        "data-action": "fontColor",
	        className: "left",
	        onClick: this.setColor
	      }, preact.h("div", {
	        className: "color",
	        style: {
	          background: selected || "#333",
	          borderColor: selected ? selected === "#FFFFFF" ? "#eee" : selected : "#333"
	        }
	      })), type !== "border" && preact.h("div", {
	        className: "right",
	        onClick: this.handleClick
	      }), isOpen && preact.h(Popover, {
	        typeInfo: typeInfo,
	        selected: selected,
	        select: this.onSelect
	      }), hasTooltip && preact.h("div", {
	        className: "ct-toolbar-tooltip"
	      }, typeInfo.tip));
	    }
	  }]);
	  return ColorPopover;
	}(preact.Component);
	
	var css$1 = ".ct-table-model-pop-wrapper .ct-extra-popover{width:80px;left:-2px;padding:8px 0;position:absolute;top:26px;border-radius:2px;background:#fff;border:1px solid #eee;box-shadow:0 1px 4px 0 rgba(111,130,166,.08),0 16px 30px 0 rgba(111,130,166,.14);z-index:2}.ct-table-model-pop-wrapper .ct-extra-popover-item{padding-left:16px;height:30px;color:#333}.ct-p-pop-wrapper,.ct-table-model-pop-wrapper .ct-extra-popover-item{display:flex;justify-content:space-between;align-items:center;font-size:12px;transition:all .2s ease}.ct-p-pop-wrapper{position:relative;padding-left:10px;padding-right:5px;height:28px;width:80px;border-radius:2px;cursor:pointer;border:1px solid transparent;background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='7' height='4' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M.5.5h6l-3 3z' fill='%23AEAEAE' fill-rule='evenodd'/%3E%3C/svg%3E\") no-repeat 95% 56%}.ct-p-pop-wrapper:hover{border:1px solid #ccc}";
	styleInject(css$1);
	
	var Popover$1 = function (_preact$Component7) {
	  (0, _inherits3.default)(Popover$1, _preact$Component7);
	
	  function Popover$1() {
	    (0, _classCallCheck3.default)(this, Popover$1);
	    return (0, _possibleConstructorReturn3.default)(this, (Popover$1.__proto__ || (0, _getPrototypeOf2.default)(Popover$1)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Popover$1, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.addEventListener('click', this.props.onGlobalClick);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener('click', this.props.onGlobalClick);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props5 = this.props,
	          setResponsive = _props5.setResponsive,
	          setFixed = _props5.setFixed;
	
	      return preact.h("div", {
	        className: "ct-extra-popover"
	      }, preact.h("div", {
	        "data-action": "tableFixed",
	        className: "ct-extra-popover-item",
	        onClick: setFixed
	      }, preact.h("span", null, '\u56FA\u5B9A\u5BBD\u5EA6')), preact.h("div", {
	        "data-action": "tableResponsive",
	        className: "ct-extra-popover-item",
	        onClick: setResponsive
	      }, preact.h("span", null, '\u81EA\u9002\u5E94')));
	    }
	  }]);
	  return Popover$1;
	}(preact.Component);
	
	var ExtraPopover = function (_preact$Component8) {
	  (0, _inherits3.default)(ExtraPopover, _preact$Component8);
	
	  function ExtraPopover() {
	    var _ref4;
	
	    (0, _classCallCheck3.default)(this, ExtraPopover);
	
	    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      args[_key3] = arguments[_key3];
	    }
	
	    var _this11 = (0, _possibleConstructorReturn3.default)(this, (_ref4 = ExtraPopover.__proto__ || (0, _getPrototypeOf2.default)(ExtraPopover)).call.apply(_ref4, [this].concat(args)));
	
	    _this11.state = {
	      isOpen: false
	    };
	
	    _this11.onGlobalClick = function () {
	      _this11.setState({
	        isOpen: false
	      });
	    };
	
	    _this11.handleClick = function (e) {
	      var view = _this11.props.editor.view;
	
	      view.focus();
	      _this11.setState({
	        isOpen: !_this11.state.isOpen
	      });
	      e.stopPropagation();
	    };
	    return _this11;
	  }
	
	  (0, _createClass3.default)(ExtraPopover, [{
	    key: 'render',
	    value: function render() {
	      var _props6 = this.props,
	          isResponsive = _props6.isResponsive,
	          setResponsive = _props6.setResponsive,
	          setFixed = _props6.setFixed;
	
	      return preact.h("div", {
	        onClick: this.handleClick,
	        className: 'ct-p-pop-wrapper ct-table-model-pop-wrapper'
	      }, isResponsive() ? '自适应' : '固定宽度', this.state.isOpen && preact.h(Popover$1, {
	        setResponsive: setResponsive,
	        setFixed: setFixed,
	        onGlobalClick: this.onGlobalClick
	      }));
	    }
	  }]);
	  return ExtraPopover;
	}(preact.Component);
	
	var TableMenu = function (_preact$Component9) {
	  (0, _inherits3.default)(TableMenu, _preact$Component9);
	
	  function TableMenu() {
	    (0, _classCallCheck3.default)(this, TableMenu);
	    return (0, _possibleConstructorReturn3.default)(this, (TableMenu.__proto__ || (0, _getPrototypeOf2.default)(TableMenu)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(TableMenu, [{
	    key: 'render',
	    value: function render() {
	      var editor = this.props.getEditorCore();
	      var state = editor.view.state;
	      var tableStore = editor.tableStore,
	          tableCommands = editor.tableCommands,
	          tableUtils = editor.tableUtils;
	
	      var _ref5 = tableUtils ? tableUtils.hasTableHeader(state) : {},
	          hasRowHeader = _ref5.hasRowHeader,
	          hasColHeader = _ref5.hasColHeader,
	          headerCol = _ref5.headerCol,
	          hasNumCol = _ref5.hasNumCol,
	          tableNode = _ref5.tableNode,
	          startPos = _ref5.startPos;
	
	      return !tableStore || !tableStore.isShowPopover ? null : preact.h("div", {
	        className: "toolbar-secondary"
	      }, preact.h(MenuItem, {
	        action: "addRowBefore",
	        tooltip: '\u4E0A\u65B9\u63D2\u5165\u884C',
	        onClick: function onClick() {
	          return tableCommands.addRowBefore();
	        },
	        disabledHandler: function disabledHandler() {
	          return tableUtils && !tableUtils.canAddRowBefore(state);
	        }
	      }), preact.h(MenuItem, {
	        action: "addRowAfter",
	        tooltip: '\u4E0B\u65B9\u63D2\u5165\u884C',
	        onClick: function onClick() {
	          return tableCommands.addRowAfter();
	        }
	      }), preact.h(MenuItem, {
	        action: "deleteRow",
	        tooltip: '\u5220\u9664\u884C',
	        onClick: function onClick() {
	          return tableCommands.deleteRow();
	        }
	      }), preact.h("div", {
	        className: "toolbar-split"
	      }), preact.h(MenuItem, {
	        action: "addColumnBefore",
	        tooltip: '\u5DE6\u4FA7\u63D2\u5165\u5217',
	        onClick: function onClick() {
	          return tableCommands.addColumnBefore();
	        },
	        disabledHandler: function disabledHandler() {
	          return tableUtils && !tableUtils.canAddColumnBefore(state);
	        }
	      }), preact.h(MenuItem, {
	        action: "addColumnAfter",
	        tooltip: '\u53F3\u4FA7\u63D2\u5165\u5217',
	        onClick: function onClick() {
	          return tableCommands.addColumnAfter();
	        },
	        disabledHandler: function disabledHandler() {
	          return tableUtils && !tableUtils.canAddColumnAfter(state);
	        }
	      }), preact.h(MenuItem, {
	        action: "deleteColumn",
	        tooltip: '\u5220\u9664\u5217',
	        onClick: function onClick() {
	          return tableCommands.deleteColumn();
	        }
	      }), preact.h("div", {
	        className: "toolbar-split"
	      }), preact.h(MenuItem, {
	        action: "mergeCells",
	        tooltip: '\u5408\u5E76\u5355\u5143\u683C',
	        onClick: function onClick() {
	          return tableCommands.mergeCells();
	        },
	        disabledHandler: function disabledHandler() {
	          return tableUtils && !tableUtils.canMergeCells(state);
	        }
	      }), preact.h(MenuItem, {
	        action: "splitCell",
	        tooltip: '\u62C6\u5206\u5355\u5143\u683C',
	        onClick: function onClick() {
	          return tableCommands.splitCell();
	        },
	        disabledHandler: function disabledHandler() {
	          return tableUtils && !tableUtils.canSplitCell(state);
	        }
	      }), preact.h("div", {
	        className: "toolbar-split"
	      }), preact.h(MenuItem, {
	        action: "tableRow",
	        tooltip: hasRowHeader ? "取消表头行" : "设置表头行",
	        onClick: function onClick() {
	          return tableCommands.toggleRowHeader(hasRowHeader, headerCol, hasNumCol, tableNode, startPos);
	        }
	      }), preact.h(MenuItem, {
	        action: "tableCol",
	        tooltip: hasColHeader ? "取消表头列" : "设置表头列",
	        onClick: function onClick() {
	          return tableCommands.toggleColHeader(hasColHeader, hasRowHeader, hasNumCol, tableNode, startPos);
	        },
	        disabledHandler: function disabledHandler() {
	          return hasRowHeader && tableNode.content.content.length === 1;
	        }
	      }), preact.h("div", {
	        className: "toolbar-split"
	      }), preact.h(ColorPopover, {
	        editorCore: editor,
	        disabledHandler: function disabledHandler() {
	          return false;
	        },
	        selected: tableStore && tableStore.selected,
	        setSelected: function setSelected(s) {
	          tableStore.selected = s;
	        },
	        type: "bg",
	        setColor: function setColor(c) {
	          return tableCommands.setBgColor(c);
	        },
	        setDefaultColor: function setDefaultColor() {
	          return tableCommands.setBgDefaultColor();
	        }
	      }), preact.h("div", {
	        className: "toolbar-split"
	      }), preact.h(MenuItem, {
	        action: "tableAttrs",
	        tooltip: '\u8868\u683C\u5C5E\u6027',
	        onClick: function onClick() {
	          return tableStore.showModal();
	        }
	      }), preact.h(MenuItem, {
	        action: "deleteTable",
	        tooltip: '\u5220\u9664\u8868\u683C',
	        onClick: function onClick() {
	          return tableCommands.deleteTable();
	        }
	      }), preact.h("div", {
	        className: "toolbar-split"
	      }), preact.h(ExtraPopover, {
	        editor: editor,
	        isResponsive: function isResponsive() {
	          return tableUtils && !tableUtils.isResponsive(state);
	        },
	        setResponsive: function setResponsive() {
	          return tableCommands.setResponsive();
	        },
	        setFixed: function setFixed() {
	          return tableCommands.setFixed();
	        }
	      }), preact.h("div", {
	        className: "toolbar-split"
	      }), preact.h("div", {
	        className: "toolbar-numcol",
	        onClick: function onClick() {
	          return tableCommands.toggleNumCol(hasNumCol, hasRowHeader, tableNode, startPos);
	        }
	      }, preact.h(index_js.CheckBox, {
	        checked: hasNumCol
	      }), hasNumCol ? "取消行号列" : "设置行号列"));
	    }
	  }]);
	  return TableMenu;
	}(preact.Component);
	
	var css$2 = ".citadel-editor-toolbar{display:flex;justify-content:flex-start;align-items:center;flex-wrap:wrap;width:100%;min-height:50px;border-bottom:1px solid #eee;color:#555;padding:5px 10px 0}.citadel-editor-toolbar .toolbar-split{width:1px;height:15px;margin:auto 10px;background:#ddd}.citadel-editor-toolbar .toolbar-tooltip{position:absolute;left:50%;-webkit-transform:translate(-50%);transform:translate(-50%);bottom:-35px;height:25px;padding:0 10px;line-height:25px;white-space:nowrap;vertical-align:middle;color:#fff;font-size:12px;background:rgba(0,0,0,.7);border-radius:4px;z-index:1}.citadel-editor-toolbar .toolbar-tooltip:after{position:absolute;width:0;top:-5px;right:50%;-webkit-transform:translate(50%);transform:translate(50%);display:block;border-color:rgba(0,0,0,.7) transparent;border-style:solid;border-width:0 5px 5px;content:\"\";z-index:1}.citadel-editor-toolbar .menu-item-wrapper{display:flex;flex-direction:row;margin-bottom:5px}.citadel-editor-toolbar .menu-item{position:relative;display:flex}.citadel-editor-toolbar .menu-item .disabled{pointer-events:none}.citadel-editor-toolbar .menu-item .toolbar-icon-wrapper{position:relative;width:28px;height:28px;margin:auto 5px;border-radius:2px;cursor:pointer;transition:all .2s ease;border:1px solid transparent;background-clip:content-box}.citadel-editor-toolbar .menu-item .toolbar-icon-wrapper[data-action=extra],.citadel-editor-toolbar .menu-item .toolbar-icon-wrapper[data-action=table]{width:45px}.citadel-editor-toolbar .menu-item:hover>.toolbar-icon-wrapper{border:1px solid #ccc}.citadel-editor-toolbar .menu-item.disabled>.toolbar-icon-wrapper{background-color:#fff;opacity:.3;cursor:not-allowed}.citadel-editor-toolbar .menu-item.active>.toolbar-icon-wrapper{border:1px solid #ccc;background-color:#eee}.citadel-editor-toolbar .toolbar-secondary{display:flex;justify-content:center;align-items:center;flex-wrap:wrap;height:40px;margin-top:1px;padding-bottom:15px}.citadel-editor-toolbar .toolbar-secondary .toolbar-icon-wrapper:first-child{margin-left:0}.citadel-editor-toolbar .toolbar-secondary .toolbar-numcol{font-size:12px;color:#333;line-height:16px;display:flex;align-items:center}.citadel-editor-toolbar .toolbar-secondary .toolbar-color-popover-wrapper.bg-color .left{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg transform='rotate(45 1.207 14.864)'%3E%3Crect stroke='%23666' fill-rule='nonzero' x='1.5' y='.5' width='7.5' height='7.5' rx='1'/%3E%3Cpath fill='%23666' d='M8.874.337l.191 7.658L1.52 7.69zM0 2h4v1H0z'/%3E%3C/g%3E%3Cpath d='M17.5 16a1.5 1.5 0 0 0 1.5-1.5c0-.552-.5-1.386-1.5-2.5-1 1.114-1.5 1.948-1.5 2.5a1.5 1.5 0 0 0 1.5 1.5z' fill='%23666'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-popover-wrapper{width:100px;padding:8px 0;position:absolute;border-radius:2px;background:#fff;border:1px solid #eee;box-shadow:0 1px 4px 0 rgba(111,130,166,.08),0 16px 30px 0 rgba(111,130,166,.14);z-index:2}.toolbar-popover-wrapper .menu-item-wrapper.more>.menu-item{width:100px}.toolbar-popover-wrapper .menu-item-wrapper.more>.menu-item:after{content:\"\";position:absolute;width:9px;height:5px;right:8px;display:inline-block;-webkit-transform:rotate(-90deg);transform:rotate(-90deg);background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='7' height='4' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M.5.5h6l-3 3z' fill='%23AEAEAE' fill-rule='evenodd'/%3E%3C/svg%3E\") no-repeat;background-size:cover}.toolbar-popover-wrapper.fit{width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}.toolbar-popover-wrapper.fit .menu-item{padding:0 16px}.toolbar-popover-wrapper .menu-item{display:flex;align-items:center;width:100%;height:30px;padding-left:10px;font-size:12px;color:#333;cursor:pointer;transition:all .2s ease}.toolbar-popover-wrapper .menu-item:hover{background-color:#f6f6f6}.toolbar-popover-wrapper .menu-item:hover .toolbar-icon-wrapper{background-color:unset}.toolbar-popover-wrapper .menu-item>span{display:inline-block}.toolbar-popover-wrapper .menu-item .toolbar-icon-wrapper{width:16px;height:16px;margin-right:8px;margin-left:0}.toolbar-popover-wrapper .menu-item .toolbar-icon-wrapper:hover{background-color:unset}.toolbar-icon-wrapper{display:inline-block;background-repeat:no-repeat;background-size:cover}.toolbar-icon-wrapper[data-action=extra]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='40' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M14.5 12.5h3a.5.5 0 1 1 0 1h-3v3a.5.5 0 1 1-1 0v-3h-3a.5.5 0 1 1 0-1h3v-3a.5.5 0 1 1 1 0v3zM9 6h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2zm0 1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H9z' fill='%23666'/%3E%3Cpath fill='%23AEAEAE' d='M27 12h6l-3 3z'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=catalog]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg class='icon' viewBox='0 0 1228 1024' xmlns='http://www.w3.org/2000/svg' width='19.188' height='16'%3E%3Cdefs%3E%3Cstyle/%3E%3C/defs%3E%3Cpath d='M368 192h480a48 48 0 1 1 0 96H368a48 48 0 0 1 0-96zm128 181.312h352a48 48 0 1 1 0 96H496a48 48 0 1 1 0-96zM368 554.688h480a48 48 0 1 1 0 96H368a48 48 0 0 1 0-96zM176 288a48 48 0 1 1 0-96 48 48 0 0 1 0 96zm0 362.688a48 48 0 1 1 0-96 48 48 0 0 1 0 96zm128-181.376a48 48 0 1 1 0-96 48 48 0 0 1 0 96zM496 736h352a48 48 0 1 1 0 96H496a48 48 0 1 1 0-96zm-192 96a48 48 0 1 1 0-96 48 48 0 0 1 0 96z' fill='%23666'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=attachment]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg class='icon' viewBox='0 0 1024 1024' xmlns='http://www.w3.org/2000/svg' width='16' height='16'%3E%3Cdefs%3E%3Cstyle/%3E%3C/defs%3E%3Cpath d='M148.864 415.808l288-279.04a31.552 31.552 0 0 1 43.648 0 30.272 30.272 0 0 1 0 42.88l-289.92 280.96c-85.376 85.888-85.376 224.448 3.968 308.352a233.152 233.152 0 0 0 321.728 0l339.584-327.808c57.6-54.656 57.6-144.384 0-199.04-57.6-54.592-148.928-54.592-204.544 0l-353.472 341.44h-1.984a60.48 60.48 0 0 0 0 85.888 63.104 63.104 0 0 0 87.36 0l1.984-1.92 295.872-284.928a31.552 31.552 0 0 1 43.712 0 30.272 30.272 0 0 1 0 42.944L428.928 712.32l-1.984 1.984a126.272 126.272 0 0 1-174.784 0 118.656 118.656 0 0 1 0-169.728l1.984-1.92 351.488-341.504 5.952-5.824c1.984-1.92 3.968-1.92 5.952-3.904 83.456-68.288 204.544-66.368 282.048 9.728 77.44 74.176 79.36 193.152 11.904 271.232-1.984 1.92-1.984 3.84-3.968 5.824l-7.936 7.808L560 813.824l-1.984 1.92c-113.28 107.328-295.936 107.328-409.152-1.92-113.152-111.232-113.152-288.768 0-398.08z' fill='%23666'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=drawio]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg class='icon' viewBox='0 0 1024 1024' xmlns='http://www.w3.org/2000/svg' width='16' height='16'%3E%3Cdefs%3E%3Cstyle/%3E%3C/defs%3E%3Cpath d='M800 704h57.6a38.4 38.4 0 0 1 38.4 38.4v115.2a38.4 38.4 0 0 1-38.4 38.4H678.4a38.4 38.4 0 0 1-38.4-38.4V742.4a38.4 38.4 0 0 1 38.4-38.4h55.104V576a32 32 0 0 0-32-32h-384a32 32 0 0 0-32 32v128H345.6a38.4 38.4 0 0 1 38.4 38.4v115.2a38.4 38.4 0 0 1-38.4 38.4H166.4a38.4 38.4 0 0 1-38.4-38.4V742.4a38.4 38.4 0 0 1 38.4-38.4H224V544a64 64 0 0 1 64-64h192V320h-57.6a38.4 38.4 0 0 1-38.4-38.4V166.4a38.4 38.4 0 0 1 38.4-38.4h179.2a38.4 38.4 0 0 1 38.4 38.4v115.2a38.4 38.4 0 0 1-38.4 38.4H544v160h192a64 64 0 0 1 64 64v160z' fill='%23666'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=status]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg class='icon' viewBox='0 0 1024 1024' xmlns='http://www.w3.org/2000/svg' width='16' height='16'%3E%3Cdefs%3E%3Cstyle/%3E%3C/defs%3E%3Cpath d='M192 704v64h640v-64H192zm-38.4-64h716.8c14.08 0 25.6 11.52 25.6 25.6v140.8a25.6 25.6 0 0 1-25.6 25.6H153.6a25.6 25.6 0 0 1-25.6-25.6V665.6c0-14.08 11.52-25.6 25.6-25.6zm0-448h716.8c14.08 0 25.6 11.52 25.6 25.6v140.8a25.6 25.6 0 0 1-25.6 25.6H153.6a25.6 25.6 0 0 1-25.6-25.6V217.6c0-14.08 11.52-25.6 25.6-25.6z' fill='%23666'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=quote]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='16' height='16' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.578 4v1.143c-.394.195-.69.548-.887 1.058-.197.51-.296 1.181-.296 2.015v.355H13V12H9.25V9.436c0-1.554.276-2.785.828-3.69.552-.907 1.385-1.489 2.5-1.746zm-6.25 0v1.143c-.394.195-.69.548-.887 1.058-.197.51-.296 1.181-.296 2.015v.355H6.75V12H3V9.436c0-1.554.276-2.785.828-3.69.552-.907 1.385-1.489 2.5-1.746z' fill='%23666' fill-rule='evenodd'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=collapse]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='16' height='16' xmlns='http://www.w3.org/2000/svg'%3E%3Cg transform='translate(1 1)' fill-rule='nonzero' fill='none'%3E%3Cpath d='M11.934.5H4A1.5 1.5 0 0 0 2.5 2v11.5H10a1.5 1.5 0 0 0 1.5-1.5V4l.004-.062.43-3.438z' stroke='%23666' fill='%23FFF'/%3E%3Cpath d='M11.5 4.5h2v-3a1 1 0 0 0-2 0v3zM.5 10.5V12A1.5 1.5 0 0 0 2 13.5h7.5v-3h-9z' stroke='%23666' fill='%23FFF'/%3E%3Crect fill='%23666' x='4' y='3' width='6' height='1' rx='.5'/%3E%3Crect stroke='%23666' fill='%23FFF' x='8.5' y='8.5' width='3' height='5' rx='1.5'/%3E%3Cpath fill='%23FFF' d='M7 6h4v4H7z'/%3E%3Crect fill='%23666' x='4' y='6' width='6' height='1' rx='.5'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=latex]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='16' height='16' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill-rule='nonzero' fill='none'%3E%3Cpath d='M9 1.5c-1.307-.053-2.227.088-2.76.42C5.708 2.253 5.294 2.946 5 4L2.5 15' stroke='%236B6B6B'/%3E%3Cpath fill='%236B6B6B' d='M1 6h8v1H1z'/%3E%3Cpath d='M8 8l6 7M14 8l-6 7' stroke='%236B6B6B'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=html]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='16' height='16' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23666' fill-rule='evenodd'%3E%3Cpath d='M15 5h-1V3H2v2H1V3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v2zm0 7v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-2h1v2h12v-2h1zM6 7v4H5V7H4V6h3v1H6zm4.012.442L11 6.007V6h1v5h-1V7.75l-.709 1.013-.287.421L10 9.178l-.004.006-.438-.636L9 7.75V11H8V6h1v.007l1.012 1.435zM14 10h2v1h-3V6h1v4zM2 9H1v2H0V6h1v2h1V6h1v5H2V9z'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=hr]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg class='icon' viewBox='0 0 1024 1024' xmlns='http://www.w3.org/2000/svg' width='16' height='16'%3E%3Cdefs%3E%3Cstyle/%3E%3C/defs%3E%3Cpath d='M162.88 416h698.24c19.2 0 34.88 14.336 34.88 32s-15.616 32-34.88 32H162.88c-19.2 0-34.88-14.336-34.88-32s15.616-32 34.88-32zm0 128h698.24c19.2 0 34.88 14.336 34.88 32s-15.616 32-34.88 32H162.88c-19.2 0-34.88-14.336-34.88-32s15.616-32 34.88-32z' fill='%23666'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=mention]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg class='icon' viewBox='0 0 1024 1024' xmlns='http://www.w3.org/2000/svg' width='16' height='16'%3E%3Cdefs%3E%3Cstyle/%3E%3C/defs%3E%3Cpath d='M553.792 658.88a222.72 222.72 0 0 1-59.008 48.128c-21.76 12.096-43.584 18.176-65.536 18.176a133.12 133.12 0 0 1-70.144-20.8c-22.656-13.824-41.152-35.136-55.296-63.872a210.688 210.688 0 0 1-21.312-94.592c0-42.304 11.008-84.672 33.024-127.104 22.08-42.496 49.408-74.304 82.112-95.616 32.704-21.312 64.512-32 95.36-32 23.488 0 45.888 6.144 67.264 18.24 21.376 12.096 39.68 30.528 55.168 55.296l13.76-61.888h72.576l-58.368 267.84c-8.128 37.248-12.16 57.856-12.16 61.888 0 7.168 2.752 13.376 8.32 18.56a28.288 28.288 0 0 0 20.032 7.744c14.336 0 33.152-8.128 56.32-24.32a224 224 0 0 0 73.28-85.632c17.92-35.84 26.88-72.704 26.88-110.72 0-44.48-11.52-86.016-34.56-124.608-23.168-38.592-57.6-69.44-103.424-92.608-45.824-23.168-96.448-34.688-151.872-34.688-63.296 0-121.024 14.528-173.376 43.712a301.376 301.376 0 0 0-121.6 125.312 368.768 368.768 0 0 0-43.2 175.04c0 65.216 14.4 121.344 43.136 168.448 28.8 47.104 70.4 81.92 124.928 104.32 54.464 22.528 114.816 33.792 181.056 33.792 70.784 0 130.176-11.712 177.984-35.136 47.872-23.424 83.712-51.84 107.52-85.44H896c-24.96 37.632-48.64 66.112-70.976 85.44a380.16 380.16 0 0 1-119.616 68.864C659.2 887.552 603.52 896 538.368 896a577.088 577.088 0 0 1-166.08-22.784c-50.688-15.168-93.824-37.952-129.536-68.48a303.488 303.488 0 0 1-80.64-105.152A391.104 391.104 0 0 1 128 536.768c0-64.96 13.504-126.848 40.576-185.6 32.96-72.128 79.808-127.36 140.48-165.696C369.728 147.2 443.328 128 529.856 128c67.008 0 127.232 13.504 180.608 40.512A299.52 299.52 0 0 1 836.8 289.28c26.24 46.08 39.36 96 39.36 150.08 0 77.184-27.584 145.664-82.752 205.568-49.216 53.76-103.04 80.64-161.408 80.64-18.624 0-33.728-2.816-45.184-8.384a54.336 54.336 0 0 1-25.344-23.936c-3.52-6.656-6.08-18.112-7.68-34.368zM357.504 550.72c0 36.48 8.768 64.768 26.368 84.992 17.536 20.224 37.76 30.336 60.416 30.336 15.104 0 31.104-4.48 47.872-13.312 16.704-8.96 32.768-22.208 48-39.744 15.296-17.536 27.776-39.872 37.504-66.88 9.728-27.008 14.592-54.08 14.592-81.216 0-36.16-9.088-64.256-27.328-84.224a87.04 87.04 0 0 0-66.688-29.952c-17.28 0-33.6 4.352-48.896 12.992s-30.08 22.528-44.416 41.728c-14.336 19.2-25.792 42.432-34.432 69.824a252.352 252.352 0 0 0-12.992 75.456z' fill='%23666'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=undo]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M19.5 18.5a11.621 11.621 0 0 0-7.996-5v3L6.5 12.1l5.004-4.6v3a9.198 9.198 0 0 1 7.996 8z' fill='%23666'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=redo]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M6.5 18.5a11.621 11.621 0 0 1 7.996-5v3l5.004-4.4-5.004-4.6v3a9.198 9.198 0 0 0-7.996 8z' fill='%23666'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=clearFormat]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M15.037 6.245l4.613 3.928c.424.362.47.992.1 1.408l-5.68 6.402L8.656 18 6.35 16.036a.984.984 0 0 1-.1-1.408l7.35-8.285a1.033 1.033 0 0 1 1.437-.098zm-4.009 4.519l4.612 3.928-2.004 2.26-4.626.026-1.607-1.368a.492.492 0 0 1-.05-.704l3.675-4.142zM6 19h14v1H6v-1z' fill='%23666'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=bold]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M9.255 16.718c.097 1.08-.655 1.595-2.255 1.546V19h7.2c3.006-.098 4.606-1.276 4.8-3.533-.097-1.668-1.09-2.723-2.982-3.164v-.074c1.552-.294 2.327-1.03 2.327-2.208 0-.589-.242-1.153-.727-1.693-.824-.932-2.521-1.373-5.09-1.324-.583 0-1.6.049-3.055.147-.388 0-.921.024-1.6.073-.388.05-.63.074-.728.074v.736h.437c.727 0 1.188.098 1.382.294.194.148.29.59.29 1.325v7.065zm2.545-3.9c.194-.05.655-.074 1.382-.074 1.842.05 2.812.982 2.909 2.797 0 1.717-.873 2.576-2.618 2.576-1.164.098-1.721-.466-1.673-1.693v-3.606zm0-5.005c.29-.049.606-.073.945-.073 1.843 0 2.788.76 2.837 2.281-.049 1.325-.824 1.987-2.327 1.987H11.8V7.813z' fill='%23666'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=italic]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M12.568 9.189l-2.176 7.698c-.202.905-.846 1.358-1.934 1.358h-.245L8 19h6.608l.213-.755h-.326c-1.157.05-1.565-.427-1.226-1.434l2.154-7.622c.27-.956.95-1.434 2.037-1.434h.327L18 7h-6.608l-.213.755h.245c1.102-.05 1.483.427 1.144 1.434z' fill='%23666'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=strikethrough]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='27' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M17.436 14H20v1.6h-1.964l1.464 3.9h-1.995l-1.364-3.894h-5.318L9.367 19.5H7.5l1.519-3.9H7V14h2.642l2.92-7.5h2.06l2.814 7.5zm-6.026 0h4.084l-1.98-5.57L11.41 14z' fill='%23666' fill-rule='nonzero'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=underline]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M7 17.9h12v1.6H7v-1.6zm7.82-10.488h-.405V6.5H18.2v.912h-.31c-.708-.03-1 .236-.972.874v5.041c-.036 2.329-1.358 3.537-3.895 3.573-2.629-.035-4.007-1.099-4.044-3.167V8.07c.028-.492-.179-.687-.723-.658H7.8V6.5h4.503v.912h-.406c-.507 0-.723.203-.723.67v5.646c.032 1.287.728 1.922 2.155 1.954 1.571-.032 2.337-.75 2.368-2.205V8.534c.03-.813-.243-1.151-.876-1.122z' fill='%23666' fill-rule='evenodd'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=alignLeft]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M7 7.5h12v1H7v-1zm0 2h8v1H7v-1zm0 2h12v1H7v-1zm0 2h8v1H7v-1zm0 2h12v1H7v-1zm0 2h8v1H7v-1z' fill='%23666'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=alignCenter]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M7 7.5h12v1H7v-1zm2 2h8v1H9v-1zm-2 2h12v1H7v-1zm2 2h8v1H9v-1zm-2 2h12v1H7v-1zm2 2h8v1H9v-1z' fill='%23666'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=alignRight]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M7 7.5h12v1H7v-1zm4 2h8v1h-8v-1zm-4 2h12v1H7v-1zm4 2h8v1h-8v-1zm-4 2h12v1H7v-1zm4 2h8v1h-8v-1z' fill='%23666'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=orderList]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M11 8h9v1h-9V8zm0 5h9v1h-9v-1zm0 5h9v1h-9v-1zM7.14 9.65V7.04H6v-.35c.145 0 .29-.01.434-.03.131-.02.26-.056.381-.11a.819.819 0 0 0 .288-.21.729.729 0 0 0 .161-.34h.4v3.65h-.527.003zm-.951 2.27c.06-.154.152-.294.27-.41.134-.117.288-.209.455-.27.2-.063.41-.093.619-.09.181-.003.362.02.536.07.157.037.306.105.437.2a.9.9 0 0 1 .402.78.941.941 0 0 1-.089.42 1.03 1.03 0 0 1-.239.33 1.878 1.878 0 0 1-.341.27c-.128.08-.26.15-.4.23a7.692 7.692 0 0 0-.784.41 1.728 1.728 0 0 0-.291.25.582.582 0 0 0-.158.3h2.255v.38H6c.015-.19.062-.376.14-.55.07-.146.164-.281.275-.4a2.31 2.31 0 0 1 .378-.3c.14-.08.287-.16.44-.24.186-.09.349-.18.489-.26.124-.072.242-.156.35-.25a.891.891 0 0 0 .21-.26.766.766 0 0 0 .072-.34.541.541 0 0 0-.068-.27.73.73 0 0 0-.452-.34 1.179 1.179 0 0 0-.329-.05.935.935 0 0 0-.393.08.823.823 0 0 0-.269.21.808.808 0 0 0-.152.29 1.037 1.037 0 0 0-.04.33h-.527a1.263 1.263 0 0 1 .065-.52zm1.035 5.94h.174c.107.002.215-.011.319-.04a.747.747 0 0 0 .266-.11.546.546 0 0 0 .183-.19.479.479 0 0 0 .068-.26.5.5 0 0 0-.223-.44 1.059 1.059 0 0 0-.557-.14 1.034 1.034 0 0 0-.37.06.717.717 0 0 0-.26.17.758.758 0 0 0-.151.26.866.866 0 0 0-.05.3h-.526c.004-.165.038-.327.1-.48.058-.14.145-.267.257-.37.122-.106.264-.188.418-.24.186-.063.383-.093.58-.09a2.22 2.22 0 0 1 .529.06c.15.035.294.096.425.18.25.16.397.443.384.74a.65.65 0 0 1-.174.44 1.1 1.1 0 0 1-.433.28V18c.232.03.445.144.6.32.13.161.199.363.195.57a.941.941 0 0 1-.121.48 1.115 1.115 0 0 1-.325.35c-.148.095-.31.166-.48.21a2.732 2.732 0 0 1-.585.07c-.205 0-.41-.026-.607-.08a1.311 1.311 0 0 1-.464-.23 1.064 1.064 0 0 1-.295-.37 1.162 1.162 0 0 1-.1-.51h.527a.8.8 0 0 0 .248.58c.191.16.438.24.687.22.122.002.245-.011.365-.04.105-.033.206-.08.3-.14a.769.769 0 0 0 .207-.22.589.589 0 0 0 .078-.3.607.607 0 0 0-.075-.3.653.653 0 0 0-.2-.22.872.872 0 0 0-.294-.14 1.442 1.442 0 0 0-.368-.04 3.093 3.093 0 0 0-.316.02v-.38a.115.115 0 0 0 .055.01h.009z' fill='%23666'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=bulletList]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M11 7.5h9v1h-9v-1zm-3.5-1a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm3.5 6h9v1h-9v-1zm-3.5-1a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm3.5 6h9v1h-9v-1zm-3.5-1a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z' fill='%23666'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=taskList]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M12.367 15.5a.567.567 0 0 1-.427-.16l-2.776-2.707a.537.537 0 0 1 0-.773.571.571 0 0 1 .793 0l2.453 2.392 3.695-3.602c.205-.2.537-.2.741 0 .205.2.205.523 0 .723l-4.079 3.977a.53.53 0 0 1-.4.15zM8 6h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2zm0 1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H8z' fill='%23666'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=indentLess]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M7 8h12v1H7V8zm4 2h8v1h-8v-1zm0 2h8v1h-8v-1zm0 2h8v1h-8v-1zm0 2h8v1h-8v-1zm-4 2h12v1H7v-1zm2-7v4l-2-2 2-2z' fill='%23666'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=indentMore]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M7 8h12v1H7V8zm0 2h8v1H7v-1zm0 2h8v1H7v-1zm0 2h8v1H7v-1zm0 2h8v1H7v-1zm0 2h12v1H7v-1zm10-7l2 2-2 2v-4z' fill='%23666'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=table]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='40' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M12 11v8h-1v-8H8v-1h12v1h-8zM9 6h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2zm0 1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H9zm3 7v-1h8v1h-8zm0 3v-1h8v1h-8z' fill='%23666'/%3E%3Cpath fill='%23AEAEAE' d='M27 12h6l-3 3z'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=link]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M7.884 13.85l4.124-4.125 2.133 2.134a3.017 3.017 0 0 1 0 4.266l-1.99 1.991a3.017 3.017 0 0 1-4.267-4.266zm4.835-3.414l-.15.15a2.011 2.011 0 0 0 0 2.844l.712.711-.711.711.355.356-1.066-1.067a3.017 3.017 0 0 1 0-4.266l.149-.15.711.711zm.562 5.128l-1.842 1.841a2.011 2.011 0 0 1-2.844-2.844l1.99-1.991-.71-.711 3.975-3.975a3.017 3.017 0 0 1 4.266 4.266l-4.124 4.125-.711-.711zm-.562-5.128l.711.712-.71.71.71.712a2.011 2.011 0 0 1 0 2.844l-.15.15-.355-.356 1.067 1.067 2.133-2.134-.71-.71 1.99-1.992a2.011 2.011 0 0 0-2.844-2.844l-1.842 1.841z' fill='%23666'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=code]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M14.035 9.02c.267.073.432.331.368.575l-1.84 7.076c-.064.245-.332.383-.598.31-.267-.074-.432-.332-.368-.576l1.84-7.076c.064-.245.332-.383.598-.31zM7.207 13l2.475 2.475a.5.5 0 0 1-.707.707l-2.829-2.828a.498.498 0 0 1 0-.708l2.829-2.828a.5.5 0 0 1 .707.707L7.207 13zm11.586 0l-2.475-2.475a.5.5 0 1 1 .707-.707l2.829 2.828a.498.498 0 0 1 0 .708l-2.829 2.828a.5.5 0 1 1-.707-.707L18.793 13z' fill='%23666' fill-rule='evenodd'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=note]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='16' height='16' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M8 1c3.826 0 7 3.173 7 7s-3.174 7-7 7c-3.827 0-7-3.173-7-7s3.173-7 7-7zm0 13c3.323 0 6-2.676 6-6s-2.677-6-6-6-6 2.676-6 6 2.677 6 6 6zm0-8.247a.877.877 0 1 1 0-1.754.877.877 0 0 1 0 1.754zM8 7a.75.75 0 0 1 .75.75v3.5a.75.75 0 1 1-1.5 0v-3.5A.75.75 0 0 1 8 7z' fill='%23666' fill-rule='nonzero'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=image]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M18 11.945V8.4a.4.4 0 0 0-.4-.4H8.4a.4.4 0 0 0-.4.4v5.566c1.677 1.356 3.343 1.367 5 .034s3.323-2.018 5-2.055zm0 .978c-.658-.016-1.214.052-1.667.203-1 .333-2.055.994-3.057 1.779-1.152.9-2.557 1.234-3.888.836-.355-.106-.818-.363-1.388-.77V17.6c0 .22.18.4.4.4h9.2a.4.4 0 0 0 .4-.4v-4.677zM17.745 7c.454 0 .777.127.968.38.191.253.287.584.287.993v9.574a.924.924 0 0 1-.087.38 1.074 1.074 0 0 1-.24.34c-.102.097-.22.177-.354.24a1.03 1.03 0 0 1-.44.093H8.04c-.276 0-.518-.111-.727-.333a1.126 1.126 0 0 1-.314-.8v-9.76c0-.32.089-.585.267-.794A.883.883 0 0 1 7.974 7h9.771zm-7.368 1.947a1.263 1.263 0 0 1 .888.367c.111.11.2.242.267.393.066.15.1.31.1.48 0 .346-.123.64-.367.88-.245.24-.54.36-.888.36-.169 0-.33-.031-.48-.094a1.144 1.144 0 0 1-.394-.266 1.398 1.398 0 0 1-.267-.394 1.161 1.161 0 0 1-.1-.486c0-.17.033-.33.1-.48.067-.151.156-.283.267-.394.111-.11.242-.2.394-.266.15-.067.311-.1.48-.1z' fill='%23666'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=markdown]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg class='icon' viewBox='0 0 1024 1024' xmlns='http://www.w3.org/2000/svg' width='16' height='16'%3E%3Cdefs%3E%3Cstyle/%3E%3C/defs%3E%3Cpath d='M832 224v576a32 32 0 1 1-64 0V313.28L534.208 598.4a32 32 0 0 1-45.632-.192L256 313.472V800a32 32 0 1 1-64 0V224a32 32 0 0 1 32.64-32 32.32 32.32 0 0 1 26.048 14.336l260.864 319.36 265.792-324.352A32 32 0 0 1 832 224z' fill='%23666'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=experiment]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='16' height='16' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M7 1.5a.5.5 0 0 0-.5.5v4.202l-5.041 7.52a.5.5 0 0 0 .415.778h12.253a.5.5 0 0 0 .416-.778L9.5 6.188V2a.5.5 0 0 0-.5-.5H7z' stroke='%236B6B6B'/%3E%3Cpath fill='%236B6B6B' d='M5 1h6v1H5zM3.5 10h9v1h-9zM2.55 12H9v1H2z'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=textExtra]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='40' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23666'%3E%3Cpath d='M11.07 20H9l8.262-12.744h1.602L21.456 20h-1.854l-.612-3.132h-5.976L11.07 20zm2.862-4.698h4.806l-1.08-6.048-3.726 6.048zM8.991 9.9h-.027c-.108.193-.282.35-.523.474-.24.123-.513.185-.82.185-.174 0-.355-.023-.544-.068a1.622 1.622 0 0 1-.523-.225 1.31 1.31 0 0 1-.396-.415A1.193 1.193 0 0 1 6 9.216c0-.324.092-.582.275-.775.183-.192.419-.339.707-.441.288-.102.608-.17.96-.203.35-.033.695-.05 1.031-.05V7.64c0-.27-.098-.47-.293-.6a1.236 1.236 0 0 0-.698-.193c-.228 0-.447.048-.658.144a1.77 1.77 0 0 0-.522.351l-.559-.657c.246-.229.53-.4.852-.514.32-.114.647-.171.977-.171.384 0 .701.054.95.162.25.108.446.25.59.424.145.174.245.369.302.585.057.216.086.433.086.649v2.63H8.991V9.9zm-.018-1.423H8.73c-.174 0-.358.008-.55.023-.192.015-.37.048-.531.1a1.135 1.135 0 0 0-.406.215.479.479 0 0 0-.162.383.46.46 0 0 0 .243.424.784.784 0 0 0 .244.09c.09.018.18.027.27.027.372 0 .654-.1.847-.298.192-.198.288-.468.288-.81v-.154z'/%3E%3C/g%3E%3Cpath fill='%23AEAEAE' d='M30 11.5h6l-3 3z'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=minder]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='16' height='16' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M5 8.5V9a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v.5h1.03A4 4 0 0 1 10 4v-.5a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1V5a3 3 0 0 0 0 6v-.5a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1V12a4 4 0 0 1-3.97-3.5H5zm-1 0V7H2v2h2v-.5zm7-5v2h3v-2h-3zm0 7v2h3v-2h-3z' fill='%23666'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=sub]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg class='icon' viewBox='0 0 1024 1024' xmlns='http://www.w3.org/2000/svg' width='16' height='16'%3E%3Cdefs%3E%3Cstyle/%3E%3C/defs%3E%3Cpath d='M79.104 192h118.208L352 423.232 506.688 192h118.208L409.792 501.248 640 832H521.792L352 578.304 182.208 832H64l228.48-330.752L79.04 192zm877.888 590.08V832H747.264l1.024-13.76a119.04 119.04 0 0 1 10.24-39.808c5.12-10.56 11.776-20.224 20.16-29.184 8-7.872 16.768-14.848 26.752-21.12 9.152-5.248 18.688-10.432 28.992-15.808 10.048-4.864 19.456-9.92 30.4-16.192a131.84 131.84 0 0 0 20.544-14.72 43.84 43.84 0 0 0 10.112-12.288 36.8 36.8 0 0 0 3.456-16.512 21.632 21.632 0 0 0-2.624-10.688 33.664 33.664 0 0 0-21.568-15.872 62.784 62.784 0 0 0-17.536-2.688 46.72 46.72 0 0 0-19.392 3.84 39.68 39.68 0 0 0-12.928 10.048 38.976 38.976 0 0 0-7.296 14.016 53.568 53.568 0 0 0-2.112 17.024l.576 13.312h-58.88l-.96-11.712a93.632 93.632 0 0 1 4.864-38.528c4.608-12.032 11.52-22.528 20.928-31.68 9.728-8.576 20.992-15.232 33.728-19.84 14.08-4.48 28.8-6.656 43.2-6.4 12.864-.192 25.664 1.472 37.504 4.8 11.712 2.816 22.72 7.872 32 14.592A70.528 70.528 0 0 1 960 653.184a77.888 77.888 0 0 1-24.704 57.344c-7.36 7.232-15.424 13.632-24.128 19.072-3.84 2.368-7.808 4.672-13.056 7.68l-14.208 7.872c-7.04 3.136-13.44 6.272-25.472 12.48a359.808 359.808 0 0 0-22.656 12.608 98.048 98.048 0 0 0-14.208 11.84h135.424z' fill='%23666'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=sup]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg class='icon' viewBox='0 0 1024 1024' xmlns='http://www.w3.org/2000/svg' width='16' height='16'%3E%3Cdefs%3E%3Cstyle/%3E%3C/defs%3E%3Cpath d='M79.104 192h118.208L352 423.232 506.688 192h118.208L409.792 501.248 640 832H521.792L352 578.304 182.208 832H64l228.48-330.752L79.04 192zm877.888 208.64v49.92H747.264l1.024-13.76a119.04 119.04 0 0 1 10.24-39.808c5.12-10.56 11.776-20.224 20.16-29.184 8-7.808 16.768-14.848 26.752-21.12 9.152-5.248 18.688-10.432 28.992-15.808 10.048-4.864 19.456-9.92 30.4-16.192a131.84 131.84 0 0 0 20.544-14.72 43.84 43.84 0 0 0 10.112-12.288 36.8 36.8 0 0 0 3.456-16.448 21.632 21.632 0 0 0-2.624-10.752 33.664 33.664 0 0 0-21.568-15.872 62.784 62.784 0 0 0-17.536-2.688 46.72 46.72 0 0 0-19.392 3.84 39.68 39.68 0 0 0-12.928 10.048 38.976 38.976 0 0 0-7.296 14.016 53.568 53.568 0 0 0-2.112 17.024l.576 13.312h-58.88l-.96-11.712a93.632 93.632 0 0 1 4.864-38.528c4.608-12.032 11.52-22.528 20.928-31.68 9.728-8.576 20.992-15.232 33.728-19.84 14.08-4.48 28.8-6.592 43.2-6.4 12.864-.192 25.664 1.472 37.504 4.864 11.712 2.752 22.72 7.808 32 14.528A70.528 70.528 0 0 1 960 271.744a77.888 77.888 0 0 1-24.704 57.344c-7.36 7.232-15.424 13.696-24.128 19.072-3.84 2.368-7.808 4.672-13.056 7.68l-14.208 7.872c-7.04 3.136-13.44 6.272-25.472 12.48a359.808 359.808 0 0 0-22.656 12.608 98.048 98.048 0 0 0-14.208 11.84h135.424z' fill='%23666'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=addRowBefore]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M8 8.5V10L6 8l2-2v1.5h3v1H8zm8.5 3.2V11h1v9H6v-1h10.5v-2.8H6v-1h10.5v-2.5H6v-1h10.5zM12 6.5h8v3h-8v-3z' fill='%23666' fill-rule='evenodd'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=addRowAfter]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M8 17.5h3v1H8V20l-2-2 2-2v1.5zm8.5-3.2H6v-1h10.5v-2.5H6v-1h10.5V7H6V6h11.5v9h-1v-.7zM12 19.5h8v-3h-8v3z' fill='%23666' fill-rule='evenodd'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=deleteRow]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M18.214 13L20 14.786l-.714.714-1.786-1.786-1.786 1.786-.714-.714L16.786 13 15 11.214l.714-.714 1.786 1.786 1.786-1.786.714.714L18.214 13zM12 6h.5v4h-1V7H6V6h6zm-.5 13v-3h1v4H6v-1h5.5zm2.5-6.5h1v1h-1v1H6v-3h8v1z' fill='%23666' fill-rule='evenodd'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=addColumnBefore]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M8.5 8H10L8 6 6 8h1.5v3h1V8zm3.2 8.5H11v1h9V6h-1v10.5h-2.8V6h-1v10.5h-2.5V6h-1v10.5zM6.5 12v8h3v-8h-3z' fill='%23666' fill-rule='evenodd'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=addColumnAfter]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M17.5 8H16l2-2 2 2h-1.5v3h-1V8zm-3.2 8.5h.7v1H6V6h1v10.5h2.8V6h1v10.5h2.5V6h1v10.5zm5.2-4.5v8h-3v-8h3z' fill='%23666' fill-rule='evenodd'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=deleteColumn]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M13 18.214L11.214 20l-.714-.714 1.786-1.786-1.786-1.786.714-.714L13 16.786 14.786 15l.714.714-1.786 1.786 1.786 1.786-.714.714L13 18.214zm7-5.714V6h-1v5.5h-3v1h4zm-13-1V6H6v6.5h4v-1H7zm6.5 2.5v1h-1v-1h-1V6h3v8h-1z' fill='%23666' fill-rule='evenodd'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=mergeCells]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10 15.5H6v-1h4V11H6v-1h4V7h1v3h4V7h1v3h4v1h-9v8h-1v-3.5zM7 6h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2zm0 1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H7z' fill='%23666' fill-rule='evenodd'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=splitCell]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M19.197 14.5H20.5v1h-1.303v-1zm-8.697 0h1.303v1H10.5v-1zm4.348 0h1.304v1h-1.304v-1zm2.175 0h1.303v1h-1.303v-1zm-4.349 0h1.303v1h-1.303v-1zm3.352 3.697V19.5h-1v-1.303h1zm0-7.697v1.303h-1V10.5h1zm0 5.773v1.303h-1v-1.303h1zm0-3.849v1.303h-1v-1.303h1z' fill='%23999'/%3E%3Cpath d='M10 15.5H6v-1h4V11H6v-1h4V7h1v3h4V7h1v3h4v1h-9v8h-1v-3.5zM7 6h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2zm0 1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H7z' fill='%23666'/%3E%3C/g%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=tableRow]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M16 10v4h4v1h-4v4h-1v-4h-4v4h-1v-4H6v-1h4v-4H6V8v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8v2h-4zm-1 0h-4v4h4v-4zM7 6h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2z' fill='%23666' fill-rule='evenodd'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=tableCol]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10 14.5h5V11h-5v3.5zm0 1V19H7h12a1 1 0 0 0 1-1v-2.5h-4V19h-1v-3.5h-5zm10-1V8a1 1 0 0 0-1-1H7h3v3h5V7h1v3h4v1h-4v3.5h4zM7 6h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2z' fill='%23666' fill-rule='evenodd'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=tableAttrs]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M13.495 13.5v3.013h-1V13.5H8.43v-1h4.066V9.487h1V12.5H17.571v1H13.495zm6.505-2v-2h1v2h-1zm0 3h1v2h-1v-2zm0 3h1v.5a2 2 0 0 1-2 2h-1.505v-1H19a1 1 0 0 0 1-1v-.5zM16.495 19v1h-2v-1h2zm-5 0v1h-2v-1h2zm-3 0v1H7a2 2 0 0 1-2-2v-.5h1v.5a1 1 0 0 0 1 1h1.495zM6 16.5H5v-2h1v2zm0-5H5v-2h1v2zm0-3H5V8a2 2 0 0 1 2-2h1.495v1H7a1 1 0 0 0-1 1v.5zM9.495 7V6h2v1h-2zm5 0V6h2v1h-2zm3 0V6H19a2 2 0 0 1 2 2v.5h-1V8a1 1 0 0 0-1-1h-1.505zM5 13.5v-1h2.286v1H5zm13.714 0v-1H21v1h-2.286zM12.495 6h1v2.325h-1V6zm0 11.675h1V20h-1v-2.325z' fill='%23333' fill-rule='nonzero'/%3E%3C/svg%3E\")}.toolbar-icon-wrapper[data-action=deleteTable]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M16.497 8.5H19.5a.5.5 0 0 1 0 .999h-13a.5.5 0 1 1 0-.999h3.003V8c0-1.105.854-2 1.908-2h3.178c1.054 0 1.908.895 1.908 2v.5zm-5.995 0h4.996V8c0-.552-.373-1-.833-1h-3.33c-.46 0-.833.448-.833 1v.5zm7.993 3.25v-.404 6.962c0 .934-.895 1.692-1.998 1.692H9.503c-1.103 0-1.998-.758-1.998-1.692v-6.962.403-.25a.5.5 0 1 1 1 0v6.671c0 .451.402.817.899.817h7.192c.497 0 .9-.366.9-.817V11.5a.5.5 0 1 1 .999 0v.25zm-7.493-.755a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.999 0v-6a.5.5 0 0 1 .499-.5zm3.996.004a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0v-6a.5.5 0 0 1 .5-.5z' fill='%23666' fill-rule='evenodd'/%3E%3C/svg%3E\")}";
	styleInject(css$2);
	
	var AlignMenuItem = function (_preact$Component10) {
	  (0, _inherits3.default)(AlignMenuItem, _preact$Component10);
	
	  function AlignMenuItem() {
	    (0, _classCallCheck3.default)(this, AlignMenuItem);
	    return (0, _possibleConstructorReturn3.default)(this, (AlignMenuItem.__proto__ || (0, _getPrototypeOf2.default)(AlignMenuItem)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(AlignMenuItem, [{
	    key: 'render',
	    value: function render() {
	      var editorCore = this.props.editorCore;
	      var basicCommands = editorCore.basicCommands,
	          basicUtils = editorCore.basicUtils,
	          view = editorCore.view;
	
	
	      if (!basicCommands || !basicUtils) {
	        return "";
	      }
	
	      return preact.h(MenuItemWrapper, null, preact.h(MenuItem, {
	        action: "alignLeft",
	        tooltip: '\u5DE6\u5BF9\u9F50',
	        activeHandler: function activeHandler() {
	          return basicUtils && basicUtils.isAlignedBlock(view.state, view, "left");
	        },
	        disabledHandler: function disabledHandler() {
	          return !basicCommands || !basicUtils.canAlign(view.state, view);
	        },
	        onClick: function onClick() {
	          return basicCommands.setAlign("left");
	        }
	      }), preact.h(MenuItem, {
	        action: "alignCenter",
	        tooltip: '\u5C45\u4E2D\u5BF9\u9F50',
	        activeHandler: function activeHandler() {
	          return basicUtils && basicUtils.isAlignedBlock(view.state, view, "center");
	        },
	        disabledHandler: function disabledHandler() {
	          return !basicCommands || !basicUtils.canAlign(view.state, view);
	        },
	        onClick: function onClick() {
	          return basicCommands.setAlign("center");
	        }
	      }), preact.h(MenuItem, {
	        action: "alignRight",
	        tooltip: '\u53F3\u5BF9\u9F50',
	        activeHandler: function activeHandler() {
	          return basicUtils && basicUtils.isAlignedBlock(view.state, view, "right");
	        },
	        disabledHandler: function disabledHandler() {
	          return !basicCommands || !basicUtils.canAlign(view.state, view);
	        },
	        onClick: function onClick() {
	          return basicCommands.setAlign("right");
	        }
	      }));
	    }
	  }]);
	  return AlignMenuItem;
	}(preact.Component);
	
	var AttachmentMenuItem = function (_preact$Component11) {
	  (0, _inherits3.default)(AttachmentMenuItem, _preact$Component11);
	
	  function AttachmentMenuItem() {
	    var _ref6;
	
	    (0, _classCallCheck3.default)(this, AttachmentMenuItem);
	
	    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	      args[_key4] = arguments[_key4];
	    }
	
	    var _this14 = (0, _possibleConstructorReturn3.default)(this, (_ref6 = AttachmentMenuItem.__proto__ || (0, _getPrototypeOf2.default)(AttachmentMenuItem)).call.apply(_ref6, [this].concat(args)));
	
	    _this14.uploadAttachment = function () {
	      var attachmentStore = _this14.props.editorCore.attachmentStore;
	
	
	      if (!attachmentStore) {
	        return;
	      }
	
	      var input = document.createElement("input");
	      input.setAttribute("type", "file");
	      input.setAttribute("multiple", "true");
	
	      input.onchange = function (e) {
	        if (e.target && e.target.files) {
	          attachmentStore.insertFiles(e.target.files);
	          input.remove();
	        }
	      };
	
	      input.click();
	    };
	    return _this14;
	  }
	
	  (0, _createClass3.default)(AttachmentMenuItem, [{
	    key: 'render',
	    value: function render() {
	      var _props7 = this.props,
	          type = _props7.type,
	          editorCore = _props7.editorCore;
	      var attachmentStore = editorCore.attachmentStore,
	          view = editorCore.view;
	
	
	      if (!attachmentStore) {
	        return "";
	      }
	
	      var isDisable = view.state && !index_js$1.canInsertTypes(view.state);
	      return preact.h(MenuItemWrapper, null, preact.h(MenuItem, {
	        action: "attachment",
	        tooltip: '\u9644\u4EF6',
	        disabledHandler: function disabledHandler() {
	          return isDisable;
	        },
	        onClick: this.uploadAttachment,
	        type: type
	      }));
	    }
	  }]);
	  return AttachmentMenuItem;
	}(preact.Component);
	
	var BoldMenuItem = function (_preact$Component12) {
	  (0, _inherits3.default)(BoldMenuItem, _preact$Component12);
	
	  function BoldMenuItem() {
	    (0, _classCallCheck3.default)(this, BoldMenuItem);
	    return (0, _possibleConstructorReturn3.default)(this, (BoldMenuItem.__proto__ || (0, _getPrototypeOf2.default)(BoldMenuItem)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(BoldMenuItem, [{
	    key: 'render',
	    value: function render() {
	      var _props8 = this.props,
	          editorCore = _props8.editorCore,
	          type = _props8.type;
	      var view = editorCore.view,
	          codeUtils = editorCore.codeUtils,
	          basicCommands = editorCore.basicCommands,
	          basicUtils = editorCore.basicUtils,
	          schema = editorCore.view.state.schema;
	
	
	      if (!basicCommands || !basicUtils) {
	        return "";
	      }
	
	      var isInCode = codeUtils && codeUtils.isInCode(view.state);
	      var isInHeading = basicUtils && basicUtils.isInHeading(view.state);
	      return preact.h(MenuItemWrapper, null, preact.h(MenuItem, {
	        action: "bold",
	        tooltip: '\u7C97\u4F53',
	        type: type,
	        activeHandler: function activeHandler() {
	          return basicUtils && (basicUtils.hasMark(view.state, schema.marks.strong) || basicUtils.isInHeading(view.state));
	        },
	        disabledHandler: function disabledHandler() {
	          return isInCode || isInHeading;
	        },
	        onClick: function onClick() {
	          return basicCommands.toggleMark(schema.marks.strong);
	        }
	      }));
	    }
	  }]);
	  return BoldMenuItem;
	}(preact.Component);
	
	var BulletListMenuItem = function (_preact$Component13) {
	  (0, _inherits3.default)(BulletListMenuItem, _preact$Component13);
	
	  function BulletListMenuItem() {
	    (0, _classCallCheck3.default)(this, BulletListMenuItem);
	    return (0, _possibleConstructorReturn3.default)(this, (BulletListMenuItem.__proto__ || (0, _getPrototypeOf2.default)(BulletListMenuItem)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(BulletListMenuItem, [{
	    key: 'render',
	    value: function render() {
	      var _props9 = this.props,
	          editorCore = _props9.editorCore,
	          type = _props9.type;
	      var listUtils = editorCore.listUtils,
	          view = editorCore.view;
	
	
	      if (!listUtils) {
	        return "";
	      }
	
	      var schema = view.state.schema;
	
	      return preact.h(MenuItemWrapper, null, preact.h(MenuItem, {
	        action: "bulletList",
	        tooltip: '\u65E0\u5E8F\u5217\u8868',
	        type: type,
	        disabledHandler: function disabledHandler() {
	          return view.state && !index_js$1.canInsertTypes(view.state);
	        },
	        activeHandler: function activeHandler() {
	          return listUtils && listUtils.judgeListType(view.state, schema.nodes.bullet_list);
	        },
	        onClick: function onClick() {
	          handleListClick(schema.nodes.bullet_list, editorCore);
	        }
	      }));
	    }
	  }]);
	  return BulletListMenuItem;
	}(preact.Component);
	
	var CatalogMenuItem = function (_preact$Component14) {
	  (0, _inherits3.default)(CatalogMenuItem, _preact$Component14);
	
	  function CatalogMenuItem() {
	    (0, _classCallCheck3.default)(this, CatalogMenuItem);
	    return (0, _possibleConstructorReturn3.default)(this, (CatalogMenuItem.__proto__ || (0, _getPrototypeOf2.default)(CatalogMenuItem)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CatalogMenuItem, [{
	    key: 'render',
	    value: function render() {
	      var _props10 = this.props,
	          editorCore = _props10.editorCore,
	          type = _props10.type;
	      var catalogCommands = editorCore.catalogCommands;
	
	
	      if (!catalogCommands) {
	        return "";
	      }
	
	      return preact.h(MenuItemWrapper, null, preact.h(MenuItem, {
	        action: "catalog",
	        tooltip: '\u76EE\u5F55',
	        onClick: catalogCommands.insert,
	        type: type
	      }));
	      return "";
	    }
	  }]);
	  return CatalogMenuItem;
	}(preact.Component);
	
	var ClearFormatMenuItem = function (_preact$Component15) {
	  (0, _inherits3.default)(ClearFormatMenuItem, _preact$Component15);
	
	  function ClearFormatMenuItem() {
	    (0, _classCallCheck3.default)(this, ClearFormatMenuItem);
	    return (0, _possibleConstructorReturn3.default)(this, (ClearFormatMenuItem.__proto__ || (0, _getPrototypeOf2.default)(ClearFormatMenuItem)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ClearFormatMenuItem, [{
	    key: 'render',
	    value: function render() {
	      var _props11 = this.props,
	          editorCore = _props11.editorCore,
	          type = _props11.type;
	      var codeUtils = editorCore.codeUtils,
	          basicCommands = editorCore.basicCommands,
	          basicUtils = editorCore.basicUtils,
	          view = editorCore.view;
	
	
	      if (!basicCommands || !basicUtils) {
	        return "";
	      }
	
	      var isInCode = codeUtils && codeUtils.isInCode(view.state);
	      return preact.h(MenuItemWrapper, null, preact.h(MenuItem, {
	        action: "clearFormat",
	        tooltip: '\u6E05\u9664\u683C\u5F0F',
	        type: type,
	        disabledHandler: function disabledHandler() {
	          return isInCode || basicCommands && !basicUtils.isTextBlock(view.state);
	        },
	        onClick: function onClick() {
	          return basicCommands.clearFormat();
	        }
	      }));
	    }
	  }]);
	  return ClearFormatMenuItem;
	}(preact.Component);
	
	var CodeMenuItem = function (_preact$Component16) {
	  (0, _inherits3.default)(CodeMenuItem, _preact$Component16);
	
	  function CodeMenuItem() {
	    (0, _classCallCheck3.default)(this, CodeMenuItem);
	    return (0, _possibleConstructorReturn3.default)(this, (CodeMenuItem.__proto__ || (0, _getPrototypeOf2.default)(CodeMenuItem)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CodeMenuItem, [{
	    key: 'render',
	    value: function render() {
	      var _props12 = this.props,
	          editorCore = _props12.editorCore,
	          type = _props12.type;
	      var codeCommands = editorCore.codeCommands;
	
	
	      if (!codeCommands) {
	        return "";
	      }
	
	      var view = editorCore.view;
	
	      return preact.h(MenuItemWrapper, null, preact.h(MenuItem, {
	        action: "code",
	        tooltip: '\u4EE3\u7801\u5757',
	        type: type,
	        disabledHandler: function disabledHandler() {
	          return view.state && !index_js$1.canInsertTypes(view.state);
	        },
	        onClick: function onClick() {
	          return codeCommands.insert();
	        }
	      }));
	    }
	  }]);
	  return CodeMenuItem;
	}(preact.Component);
	
	var CollapseMenuItem = function (_preact$Component17) {
	  (0, _inherits3.default)(CollapseMenuItem, _preact$Component17);
	
	  function CollapseMenuItem() {
	    (0, _classCallCheck3.default)(this, CollapseMenuItem);
	    return (0, _possibleConstructorReturn3.default)(this, (CollapseMenuItem.__proto__ || (0, _getPrototypeOf2.default)(CollapseMenuItem)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CollapseMenuItem, [{
	    key: 'render',
	    value: function render() {
	      var _props13 = this.props,
	          editorCore = _props13.editorCore,
	          type = _props13.type;
	      var collapseCommands = editorCore.collapseCommands;
	
	
	      if (!collapseCommands) {
	        return "";
	      }
	
	      return preact.h(MenuItemWrapper, null, preact.h(MenuItem, {
	        action: "collapse",
	        tooltip: '\u5C55\u5F00',
	        type: type,
	        onClick: collapseCommands.insert
	      }));
	    }
	  }]);
	  return CollapseMenuItem;
	}(preact.Component);
	
	var ColorMenuItem = function (_preact$Component18) {
	  (0, _inherits3.default)(ColorMenuItem, _preact$Component18);
	
	  function ColorMenuItem() {
	    (0, _classCallCheck3.default)(this, ColorMenuItem);
	    return (0, _possibleConstructorReturn3.default)(this, (ColorMenuItem.__proto__ || (0, _getPrototypeOf2.default)(ColorMenuItem)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ColorMenuItem, [{
	    key: 'render',
	    value: function render() {
	      var editorCore = this.props.editorCore;
	      var codeUtils = editorCore.codeUtils,
	          view = editorCore.view;
	
	
	      if (!editorCore) {
	        return "";
	      }
	
	      var isInCode = codeUtils && codeUtils.isInCode(view.state);
	      return preact.h(ColorPopover, {
	        type: "font",
	        editorCore: editorCore,
	        disabledHandler: function disabledHandler() {
	          return isInCode;
	        }
	      });
	    }
	  }]);
	  return ColorMenuItem;
	}(preact.Component);
	
	var DrawIOMenuItem = function (_preact$Component19) {
	  (0, _inherits3.default)(DrawIOMenuItem, _preact$Component19);
	
	  function DrawIOMenuItem() {
	    (0, _classCallCheck3.default)(this, DrawIOMenuItem);
	    return (0, _possibleConstructorReturn3.default)(this, (DrawIOMenuItem.__proto__ || (0, _getPrototypeOf2.default)(DrawIOMenuItem)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(DrawIOMenuItem, [{
	    key: 'render',
	    value: function render() {
	      var _props14 = this.props,
	          editorCore = _props14.editorCore,
	          type = _props14.type;
	      var drawioStore = editorCore.drawioStore;
	
	
	      if (!drawioStore) {
	        return "";
	      }
	
	      return preact.h(MenuItemWrapper, null, preact.h(MenuItem, {
	        action: "drawio",
	        tooltip: '\u6D41\u7A0B\u56FE',
	        type: type,
	        onClick: function onClick() {
	          return drawioStore.create();
	        }
	      }));
	    }
	  }]);
	  return DrawIOMenuItem;
	}(preact.Component);
	
	var ExtraMenuItem = function (_preact$Component20) {
	  (0, _inherits3.default)(ExtraMenuItem, _preact$Component20);
	
	  function ExtraMenuItem() {
	    var _ref7;
	
	    (0, _classCallCheck3.default)(this, ExtraMenuItem);
	
	    for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	      args[_key5] = arguments[_key5];
	    }
	
	    var _this23 = (0, _possibleConstructorReturn3.default)(this, (_ref7 = ExtraMenuItem.__proto__ || (0, _getPrototypeOf2.default)(ExtraMenuItem)).call.apply(_ref7, [this].concat(args)));
	
	    _this23.popover = void 0;
	    _this23.container = void 0;
	    _this23.state = {
	      displayPos: {},
	      isShowDropDown: false
	    };
	
	    _this23.showDropDown = function (e) {
	      var isShowDropDown = _this23.state.isShowDropDown;
	
	
	      if (!isShowDropDown) {
	        var target = e.target;
	        var displayPos = {
	          left: target.offsetLeft + 'px',
	          top: target.offsetTop + target.offsetHeight + 'px'
	        };
	        _this23.setState({
	          isShowDropDown: true,
	          displayPos: displayPos
	        });
	        window.addEventListener("click", _this23.hideDropDown);
	      } else {
	        _this23.hideDropDown();
	      }
	    };
	
	    _this23.hideDropDown = function (e) {
	      if (!e || e.target && !_this23.container.base.contains(e.target)) {
	        _this23.setState({
	          displayPos: {},
	          isShowDropDown: false
	        });
	        window.removeEventListener("click", _this23.hideDropDown);
	      }
	    };
	    return _this23;
	  }
	
	  (0, _createClass3.default)(ExtraMenuItem, [{
	    key: 'render',
	    value: function render() {
	      var _this24 = this;
	
	      var _state2 = this.state,
	          isShowDropDown = _state2.isShowDropDown,
	          displayPos = _state2.displayPos;
	      var _props15 = this.props,
	          editorCore = _props15.editorCore,
	          content = _props15.content,
	          type = _props15.type;
	      var view = editorCore.view,
	          codeUtils = editorCore.codeUtils;
	
	      var isInCode = codeUtils && codeUtils.isInCode(view.state);
	      return preact.h(MenuItemWrapper, {
	        ref: function ref(container) {
	          _this24.container = container;
	        }
	      }, preact.h(MenuItem, {
	        action: "extra",
	        onClick: this.showDropDown,
	        disabledHandler: function disabledHandler() {
	          return isInCode;
	        },
	        type: type
	      }, isShowDropDown && preact.h("div", {
	        style: displayPos,
	        className: "toolbar-popover-wrapper",
	        ref: function ref(popover) {
	          _this24.popover = popover;
	        },
	        onClick: this.hideDropDown
	      }, content)));
	    }
	  }]);
	  return ExtraMenuItem;
	}(preact.Component);
	
	var ExtraMoreMenuItem = function (_preact$Component21) {
	  (0, _inherits3.default)(ExtraMoreMenuItem, _preact$Component21);
	
	  function ExtraMoreMenuItem(props) {
	    (0, _classCallCheck3.default)(this, ExtraMoreMenuItem);
	
	    var _this25 = (0, _possibleConstructorReturn3.default)(this, (ExtraMoreMenuItem.__proto__ || (0, _getPrototypeOf2.default)(ExtraMoreMenuItem)).call(this, props));
	
	    _this25.container = void 0;
	    _this25.popover = void 0;
	    _this25.state = void 0;
	
	    _this25.showMore = function () {
	      var isShowMore = _this25.state.isShowMore;
	
	
	      if (!isShowMore) {
	        _this25.setState({
	          isShowMore: true
	        }, function () {
	          var displayPos = caculatePopoverPos(_this25.container, _this25.popover);
	          _this25.setState({
	            displayPos: displayPos
	          });
	        });
	        setTimeout(function () {
	          window.addEventListener("mousemove", _this25.hideMore);
	        }, 200);
	      }
	    };
	
	    _this25.hideMore = function (e) {
	      if (!e || !e.target || !_this25.container.contains(e.target)) {
	        _this25.setState({
	          isShowMore: false,
	          displayPos: {}
	        });
	        window.removeEventListener("mousemove", _this25.hideMore);
	      }
	    };
	
	    _this25.renderExtraMore = function () {
	      var item = _this25.props.item;
	      var _this25$state = _this25.state,
	          isShowMore = _this25$state.isShowMore,
	          displayPos = _this25$state.displayPos;
	
	
	      if (!isShowMore || !item) {
	        return;
	      }
	
	      return preact.h("div", {
	        className: "toolbar-popover-wrapper fit",
	        style: displayPos,
	        ref: function ref(popover) {
	          _this25.popover = popover;
	        }
	      }, renderExtraList(item.content, _this25.props.editorCore));
	    };
	
	    _this25.state = {
	      displayPos: {},
	      isShowMore: false
	    };
	    _this25.hideMore = throttle(_this25.hideMore, 100);
	    return _this25;
	  }
	
	  (0, _createClass3.default)(ExtraMoreMenuItem, [{
	    key: 'render',
	    value: function render() {
	      var _this26 = this;
	
	      var item = this.props.item;
	
	
	      if (!item) {
	        return "";
	      }
	
	      return preact.h(MenuItemWrapper, {
	        getRef: function getRef(container) {
	          _this26.container = container;
	        },
	        isMore: true
	      }, preact.h(MenuItem, {
	        action: item.action,
	        tooltip: item.title,
	        onMouseEnter: this.showMore,
	        type: "extra"
	      }), this.renderExtraMore());
	    }
	  }]);
	  return ExtraMoreMenuItem;
	}(preact.Component);
	
	var HistoryMenuItem = function (_preact$Component22) {
	  (0, _inherits3.default)(HistoryMenuItem, _preact$Component22);
	
	  function HistoryMenuItem() {
	    (0, _classCallCheck3.default)(this, HistoryMenuItem);
	    return (0, _possibleConstructorReturn3.default)(this, (HistoryMenuItem.__proto__ || (0, _getPrototypeOf2.default)(HistoryMenuItem)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(HistoryMenuItem, [{
	    key: 'render',
	    value: function render() {
	      var _props16 = this.props,
	          editorCore = _props16.editorCore,
	          type = _props16.type;
	      var historyCommands = editorCore.historyCommands,
	          historyUtils = editorCore.historyUtils,
	          view = editorCore.view;
	
	
	      if (!historyCommands || !historyUtils) {
	        return "";
	      }
	
	      return preact.h(MenuItemWrapper, null, preact.h(MenuItem, {
	        action: "undo",
	        tooltip: '\u64A4\u9500',
	        type: type,
	        onClick: function onClick() {
	          return historyCommands.undo();
	        },
	        disabledHandler: function disabledHandler() {
	          return !historyUtils || historyUtils.undoDepth(view.state) === 0;
	        }
	      }), preact.h(MenuItem, {
	        action: "redo",
	        tooltip: '\u91CD\u505A',
	        type: type,
	        onClick: function onClick() {
	          return historyCommands.redo();
	        },
	        disabledHandler: function disabledHandler() {
	          return !historyUtils || historyUtils.redoDepth(view.state) === 0;
	        }
	      }));
	    }
	  }]);
	  return HistoryMenuItem;
	}(preact.Component);
	
	var HrMenuItem = function (_preact$Component23) {
	  (0, _inherits3.default)(HrMenuItem, _preact$Component23);
	
	  function HrMenuItem() {
	    (0, _classCallCheck3.default)(this, HrMenuItem);
	    return (0, _possibleConstructorReturn3.default)(this, (HrMenuItem.__proto__ || (0, _getPrototypeOf2.default)(HrMenuItem)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(HrMenuItem, [{
	    key: 'render',
	    value: function render() {
	      var _props17 = this.props,
	          editorCore = _props17.editorCore,
	          type = _props17.type;
	      var basicCommands = editorCore.basicCommands;
	
	
	      if (!basicCommands) {
	        return "";
	      }
	
	      return preact.h(MenuItemWrapper, null, preact.h(MenuItem, {
	        action: "hr",
	        tooltip: '\u6C34\u5E73\u7EBF',
	        onClick: basicCommands.insertHr,
	        type: type
	      }));
	    }
	  }]);
	  return HrMenuItem;
	}(preact.Component);
	
	var ImageMenuItem = function (_preact$Component24) {
	  (0, _inherits3.default)(ImageMenuItem, _preact$Component24);
	
	  function ImageMenuItem() {
	    var _ref8;
	
	    (0, _classCallCheck3.default)(this, ImageMenuItem);
	
	    for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
	      args[_key6] = arguments[_key6];
	    }
	
	    var _this29 = (0, _possibleConstructorReturn3.default)(this, (_ref8 = ImageMenuItem.__proto__ || (0, _getPrototypeOf2.default)(ImageMenuItem)).call.apply(_ref8, [this].concat(args)));
	
	    _this29.uploadImage = function () {
	      var imageStore = _this29.props.editorCore.imageStore;
	
	
	      if (!imageStore) {
	        return;
	      }
	
	      var input = document.createElement("input");
	      input.setAttribute("type", "file");
	      input.setAttribute("multiple", "true");
	      input.setAttribute("accept", "image/*");
	
	      input.onchange = function (e) {
	        imageStore.insertFiles(e.target.files);
	        input.remove();
	      };
	
	      input.click();
	    };
	    return _this29;
	  }
	
	  (0, _createClass3.default)(ImageMenuItem, [{
	    key: 'render',
	    value: function render() {
	      var _props18 = this.props,
	          type = _props18.type,
	          editorCore = _props18.editorCore;
	      var imageStore = editorCore.imageStore,
	          view = editorCore.view;
	
	
	      if (!imageStore) {
	        return "";
	      }
	
	      var isDisable = view.state && !index_js$1.canInsertTypes(view.state);
	      return preact.h(MenuItemWrapper, null, preact.h(MenuItem, {
	        action: "image",
	        tooltip: '\u56FE\u7247',
	        type: type,
	        disabledHandler: function disabledHandler() {
	          return isDisable;
	        },
	        onClick: this.uploadImage
	      }));
	    }
	  }]);
	  return ImageMenuItem;
	}(preact.Component);
	
	var IndentMenuItem = function (_preact$Component25) {
	  (0, _inherits3.default)(IndentMenuItem, _preact$Component25);
	
	  function IndentMenuItem() {
	    (0, _classCallCheck3.default)(this, IndentMenuItem);
	    return (0, _possibleConstructorReturn3.default)(this, (IndentMenuItem.__proto__ || (0, _getPrototypeOf2.default)(IndentMenuItem)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(IndentMenuItem, [{
	    key: 'render',
	    value: function render() {
	      var _props19 = this.props,
	          editorCore = _props19.editorCore,
	          type = _props19.type;
	      var basicCommands = editorCore.basicCommands,
	          basicUtils = editorCore.basicUtils,
	          listCommands = editorCore.listCommands,
	          listUtils = editorCore.listUtils,
	          tableCommands = editorCore.tableCommands,
	          tableUtils = editorCore.tableUtils;
	
	
	      if (!basicCommands || !listCommands || !tableCommands) {
	        return "";
	      }
	
	      var view = editorCore.view;
	
	      return preact.h(MenuItemWrapper, null, preact.h(MenuItem, {
	        action: "indentLess",
	        tooltip: '\u51CF\u5C11\u7F29\u8FDB',
	        type: type,
	        disabledHandler: function disabledHandler() {
	          if (!basicUtils) {
	            return true;
	          }
	
	          if (listUtils.isInList(view.state)) {
	            return false;
	          }
	
	          if (tableUtils.canIndent(view.state, "less")) {
	            return false;
	          }
	
	          return !basicUtils.canIndent(view.state, "less");
	        },
	        onClick: function onClick() {
	          if (!listCommands.liftListItem()) {
	            if (!tableCommands.reduceIndent()) {
	              basicCommands.setIndent("less");
	            }
	          }
	
	          view.focus();
	        }
	      }), preact.h(MenuItem, {
	        action: "indentMore",
	        tooltip: '\u589E\u52A0\u7F29\u8FDB',
	        type: type,
	        disabledHandler: function disabledHandler() {
	          if (!basicUtils) {
	            return true;
	          }
	
	          if (listUtils.isInList(view.state)) {
	            return false;
	          }
	
	          if (tableUtils.canIndent(view.state, "more")) {
	            return false;
	          }
	
	          return !basicUtils.canIndent(view.state, "more");
	        },
	        onClick: function onClick() {
	          if (!listCommands.sinkListItem()) {
	            if (!tableCommands.increaseIndent()) {
	              basicCommands.setIndent("more");
	            }
	          }
	
	          view.focus();
	        }
	      }));
	    }
	  }]);
	  return IndentMenuItem;
	}(preact.Component);
	
	var ItalicMenuItem = function (_preact$Component26) {
	  (0, _inherits3.default)(ItalicMenuItem, _preact$Component26);
	
	  function ItalicMenuItem() {
	    (0, _classCallCheck3.default)(this, ItalicMenuItem);
	    return (0, _possibleConstructorReturn3.default)(this, (ItalicMenuItem.__proto__ || (0, _getPrototypeOf2.default)(ItalicMenuItem)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ItalicMenuItem, [{
	    key: 'render',
	    value: function render() {
	      var _props20 = this.props,
	          editorCore = _props20.editorCore,
	          type = _props20.type;
	      var codeUtils = editorCore.codeUtils,
	          basicCommands = editorCore.basicCommands,
	          basicUtils = editorCore.basicUtils,
	          view = editorCore.view;
	      var schema = view.state.schema;
	
	
	      if (!basicCommands || !basicUtils) {
	        return "";
	      }
	
	      var isInCode = codeUtils && codeUtils.isInCode(view.state);
	      return preact.h(MenuItemWrapper, null, preact.h(MenuItem, {
	        action: "italic",
	        tooltip: '\u659C\u4F53',
	        type: type,
	        activeHandler: function activeHandler() {
	          return basicUtils && basicUtils.hasMark(view.state, schema.marks.em);
	        },
	        disabledHandler: function disabledHandler() {
	          return isInCode;
	        },
	        onClick: function onClick() {
	          return basicCommands.toggleMark(schema.marks.em);
	        }
	      }));
	    }
	  }]);
	  return ItalicMenuItem;
	}(preact.Component);
	
	var LatexMenuItem = function (_preact$Component27) {
	  (0, _inherits3.default)(LatexMenuItem, _preact$Component27);
	
	  function LatexMenuItem() {
	    (0, _classCallCheck3.default)(this, LatexMenuItem);
	    return (0, _possibleConstructorReturn3.default)(this, (LatexMenuItem.__proto__ || (0, _getPrototypeOf2.default)(LatexMenuItem)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(LatexMenuItem, [{
	    key: 'render',
	    value: function render() {
	      var _props21 = this.props,
	          editorCore = _props21.editorCore,
	          type = _props21.type;
	      var htmlStore = editorCore.htmlStore,
	          schema = editorCore.view.state.schema;
	
	
	      if (!htmlStore) {
	        return "";
	      }
	
	      if (type === "extra") {
	        return preact.h(MenuItemWrapper, null, preact.h(MenuItem, {
	          action: "latex",
	          tooltip: '\u516C\u5F0F',
	          type: type,
	          onClick: function onClick() {
	            return htmlStore.create(schema.nodes.markdown, "latex");
	          }
	        }));
	      }
	
	      return "";
	    }
	  }]);
	  return LatexMenuItem;
	}(preact.Component);
	
	var LinkMenuItem = function (_preact$Component28) {
	  (0, _inherits3.default)(LinkMenuItem, _preact$Component28);
	
	  function LinkMenuItem() {
	    var _ref9;
	
	    (0, _classCallCheck3.default)(this, LinkMenuItem);
	
	    for (var _len7 = arguments.length, args = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
	      args[_key7] = arguments[_key7];
	    }
	
	    var _this33 = (0, _possibleConstructorReturn3.default)(this, (_ref9 = LinkMenuItem.__proto__ || (0, _getPrototypeOf2.default)(LinkMenuItem)).call.apply(_ref9, [this].concat(args)));
	
	    _this33.addLink = function () {
	      var editorCore = _this33.props.editorCore;
	      var linkStore = editorCore.linkStore,
	          linkUtils = editorCore.linkUtils,
	          view = editorCore.view;
	
	      var attrs = linkUtils.getLinkAttrs(view.state, view.dispatch);
	
	      if (attrs) {
	        linkStore.openModal(attrs, 0);
	      }
	    };
	    return _this33;
	  }
	
	  (0, _createClass3.default)(LinkMenuItem, [{
	    key: 'render',
	    value: function render() {
	      var _props22 = this.props,
	          editorCore = _props22.editorCore,
	          type = _props22.type;
	      var linkStore = editorCore.linkStore,
	          linkUtils = editorCore.linkUtils;
	
	
	      if (!linkStore || !linkUtils) {
	        return "";
	      }
	
	      var view = editorCore.view;
	
	      return preact.h(MenuItemWrapper, null, preact.h(MenuItem, {
	        action: "link",
	        tooltip: '\u94FE\u63A5',
	        type: type,
	        activeHandler: function activeHandler() {
	          return linkUtils && linkUtils.hasLink(view.state);
	        },
	        disabledHandler: function disabledHandler() {
	          return view.state && !index_js$1.canInsertTypes(view.state);
	        },
	        onClick: this.addLink
	      }));
	    }
	  }]);
	  return LinkMenuItem;
	}(preact.Component);
	
	var MarkdownMenuItem = function (_preact$Component29) {
	  (0, _inherits3.default)(MarkdownMenuItem, _preact$Component29);
	
	  function MarkdownMenuItem() {
	    (0, _classCallCheck3.default)(this, MarkdownMenuItem);
	    return (0, _possibleConstructorReturn3.default)(this, (MarkdownMenuItem.__proto__ || (0, _getPrototypeOf2.default)(MarkdownMenuItem)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(MarkdownMenuItem, [{
	    key: 'render',
	    value: function render() {
	      var _props23 = this.props,
	          editorCore = _props23.editorCore,
	          type = _props23.type;
	      var htmlStore = editorCore.htmlStore,
	          schema = editorCore.view.state.schema;
	
	
	      if (!htmlStore) {
	        return "";
	      }
	
	      return preact.h(MenuItemWrapper, null, preact.h(MenuItem, {
	        type: type,
	        tooltip: "Markdown",
	        onClick: function onClick() {
	          return htmlStore.create(schema.nodes.markdown, "markdown");
	        }
	      }));
	    }
	  }]);
	  return MarkdownMenuItem;
	}(preact.Component);
	
	var HTMLMenuItem = function (_preact$Component30) {
	  (0, _inherits3.default)(HTMLMenuItem, _preact$Component30);
	
	  function HTMLMenuItem() {
	    (0, _classCallCheck3.default)(this, HTMLMenuItem);
	    return (0, _possibleConstructorReturn3.default)(this, (HTMLMenuItem.__proto__ || (0, _getPrototypeOf2.default)(HTMLMenuItem)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(HTMLMenuItem, [{
	    key: 'render',
	    value: function render() {
	      var _props24 = this.props,
	          editorCore = _props24.editorCore,
	          type = _props24.type;
	      var htmlStore = editorCore.htmlStore,
	          schema = editorCore.view.state.schema;
	
	
	      if (!htmlStore) {
	        return "";
	      }
	
	      return preact.h(MenuItemWrapper, null, preact.h(MenuItem, {
	        type: type,
	        tooltip: "HTML",
	        onClick: function onClick() {
	          return htmlStore.create(schema.nodes.html, "html");
	        }
	      }));
	    }
	  }]);
	  return HTMLMenuItem;
	}(preact.Component);
	
	var MentionMenuItem = function (_preact$Component31) {
	  (0, _inherits3.default)(MentionMenuItem, _preact$Component31);
	
	  function MentionMenuItem() {
	    (0, _classCallCheck3.default)(this, MentionMenuItem);
	    return (0, _possibleConstructorReturn3.default)(this, (MentionMenuItem.__proto__ || (0, _getPrototypeOf2.default)(MentionMenuItem)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(MentionMenuItem, [{
	    key: 'render',
	    value: function render() {
	      var _props25 = this.props,
	          editorCore = _props25.editorCore,
	          type = _props25.type;
	      var mentionStore = editorCore.mentionStore;
	
	
	      if (!mentionStore) {
	        return "";
	      }
	
	      return preact.h(MenuItemWrapper, null, preact.h(MenuItem, {
	        type: type,
	        action: "mention",
	        tooltip: '\u7528\u6237\u63D0\u53CA',
	        onClick: function onClick() {
	          return mentionStore.insertMention();
	        }
	      }));
	    }
	  }]);
	  return MentionMenuItem;
	}(preact.Component);
	
	var MinderMenuItem = function (_preact$Component32) {
	  (0, _inherits3.default)(MinderMenuItem, _preact$Component32);
	
	  function MinderMenuItem() {
	    (0, _classCallCheck3.default)(this, MinderMenuItem);
	    return (0, _possibleConstructorReturn3.default)(this, (MinderMenuItem.__proto__ || (0, _getPrototypeOf2.default)(MinderMenuItem)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(MinderMenuItem, [{
	    key: 'render',
	    value: function render() {
	      var _props26 = this.props,
	          editorCore = _props26.editorCore,
	          type = _props26.type;
	      var minderStore = editorCore.minderStore;
	
	
	      if (!minderStore) {
	        return "";
	      }
	
	      return preact.h(MenuItemWrapper, null, preact.h(MenuItem, {
	        type: type,
	        action: "minder",
	        tooltip: '\u601D\u7EF4\u5BFC\u56FE',
	        onClick: function onClick() {
	          return minderStore.create();
	        }
	      }));
	    }
	  }]);
	  return MinderMenuItem;
	}(preact.Component);
	
	var noteSelectItem = [{
	  title: "信息",
	  type: "info"
	}, {
	  title: "警示",
	  type: "note"
	}, {
	  title: "注意",
	  type: "warning"
	}, {
	  title: "提示",
	  type: "tip"
	}];
	
	var NoteMenuItem = function (_preact$Component33) {
	  (0, _inherits3.default)(NoteMenuItem, _preact$Component33);
	
	  function NoteMenuItem() {
	    var _ref10;
	
	    (0, _classCallCheck3.default)(this, NoteMenuItem);
	
	    for (var _len8 = arguments.length, args = Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
	      args[_key8] = arguments[_key8];
	    }
	
	    var _this38 = (0, _possibleConstructorReturn3.default)(this, (_ref10 = NoteMenuItem.__proto__ || (0, _getPrototypeOf2.default)(NoteMenuItem)).call.apply(_ref10, [this].concat(args)));
	
	    _this38.container = void 0;
	    _this38.popover = void 0;
	    _this38.state = {
	      displayPos: {},
	      showSelect: false
	    };
	
	    _this38.showSelect = function () {
	      var showSelect = _this38.state.showSelect;
	
	
	      if (!showSelect) {
	        _this38.setState({
	          showSelect: true
	        }, function () {
	          var displayPos = caculatePopoverPos(_this38.container, _this38.popover);
	          _this38.setState({
	            displayPos: displayPos
	          });
	        });
	        setTimeout(function () {
	          window.addEventListener("mousemove", _this38.hideSelect);
	        });
	      }
	    };
	
	    _this38.hideSelect = function (e) {
	      if (!e || !e.target || !_this38.container.contains(e.target)) {
	        _this38.setState({
	          showSelect: false
	        });
	        window.removeEventListener("mousemove", _this38.hideSelect);
	      }
	    };
	
	    _this38.renderSelect = function () {
	      var _this38$state = _this38.state,
	          showSelect = _this38$state.showSelect,
	          displayPos = _this38$state.displayPos;
	
	
	      if (!showSelect) {
	        return;
	      }
	
	      return preact.h("div", {
	        className: "toolbar-popover-wrapper fit",
	        style: displayPos,
	        ref: function ref(popover) {
	          _this38.popover = popover;
	        }
	      }, _this38.renderNoteSelectItem());
	    };
	
	    _this38.renderNoteSelectItem = function () {
	      var noteCommands = _this38.props.editorCore.noteCommands;
	
	      return noteSelectItem.map(function (_ref11) {
	        var title = _ref11.title,
	            type = _ref11.type;
	
	        var onClick = function onClick() {
	          return noteCommands.insert(type);
	        };
	
	        return preact.h("div", {
	          className: "menu-item",
	          onClick: onClick
	        }, title);
	      });
	    };
	    return _this38;
	  }
	
	  (0, _createClass3.default)(NoteMenuItem, [{
	    key: 'render',
	    value: function render() {
	      var _this39 = this;
	
	      var _props27 = this.props,
	          editorCore = _props27.editorCore,
	          type = _props27.type;
	      var noteCommands = editorCore.noteCommands;
	
	
	      if (!noteCommands) {
	        return "";
	      }
	
	      return preact.h(MenuItemWrapper, {
	        getRef: function getRef(container) {
	          _this39.container = container;
	        },
	        isMore: true
	      }, preact.h(MenuItem, {
	        type: type,
	        action: "note",
	        tooltip: '\u6837\u5F0F',
	        onMouseEnter: this.showSelect
	      }), this.renderSelect());
	    }
	  }]);
	  return NoteMenuItem;
	}(preact.Component);
	
	var OrderListMenuItem = function (_preact$Component34) {
	  (0, _inherits3.default)(OrderListMenuItem, _preact$Component34);
	
	  function OrderListMenuItem() {
	    (0, _classCallCheck3.default)(this, OrderListMenuItem);
	    return (0, _possibleConstructorReturn3.default)(this, (OrderListMenuItem.__proto__ || (0, _getPrototypeOf2.default)(OrderListMenuItem)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(OrderListMenuItem, [{
	    key: 'render',
	    value: function render() {
	      var _props28 = this.props,
	          editorCore = _props28.editorCore,
	          type = _props28.type;
	      var listUtils = editorCore.listUtils,
	          view = editorCore.view;
	
	
	      if (!listUtils) {
	        return "";
	      }
	
	      var schema = view.state.schema;
	
	      return preact.h(MenuItemWrapper, null, preact.h(MenuItem, {
	        action: "orderList",
	        tooltip: '\u6709\u5E8F\u5217\u8868',
	        type: type,
	        disabledHandler: function disabledHandler() {
	          return view.state && !index_js$1.canInsertTypes(view.state);
	        },
	        activeHandler: function activeHandler() {
	          return listUtils && listUtils.judgeListType(view.state, schema.nodes.ordered_list);
	        },
	        onClick: function onClick() {
	          handleListClick(schema.nodes.ordered_list, editorCore);
	        }
	      }));
	    }
	  }]);
	  return OrderListMenuItem;
	}(preact.Component);
	
	var QuoteMenuItem = function (_preact$Component35) {
	  (0, _inherits3.default)(QuoteMenuItem, _preact$Component35);
	
	  function QuoteMenuItem() {
	    (0, _classCallCheck3.default)(this, QuoteMenuItem);
	    return (0, _possibleConstructorReturn3.default)(this, (QuoteMenuItem.__proto__ || (0, _getPrototypeOf2.default)(QuoteMenuItem)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(QuoteMenuItem, [{
	    key: 'render',
	    value: function render() {
	      var _props29 = this.props,
	          editorCore = _props29.editorCore,
	          type = _props29.type;
	      var quoteCommands = editorCore.quoteCommands,
	          view = editorCore.view;
	
	
	      if (!quoteCommands) {
	        return "";
	      }
	
	      return preact.h(MenuItemWrapper, null, preact.h(MenuItem, {
	        type: type,
	        action: "quote",
	        tooltip: '\u5F15\u7528',
	        onClick: function onClick() {
	          return quoteCommands.toggle(view.state);
	        }
	      }));
	    }
	  }]);
	  return QuoteMenuItem;
	}(preact.Component);
	
	var StatusMenuItem = function (_preact$Component36) {
	  (0, _inherits3.default)(StatusMenuItem, _preact$Component36);
	
	  function StatusMenuItem() {
	    (0, _classCallCheck3.default)(this, StatusMenuItem);
	    return (0, _possibleConstructorReturn3.default)(this, (StatusMenuItem.__proto__ || (0, _getPrototypeOf2.default)(StatusMenuItem)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(StatusMenuItem, [{
	    key: 'render',
	    value: function render() {
	      var _props30 = this.props,
	          editorCore = _props30.editorCore,
	          type = _props30.type;
	      var statusCommands = editorCore.statusCommands;
	
	
	      if (!statusCommands) {
	        return "";
	      }
	
	      return preact.h(MenuItemWrapper, null, preact.h(MenuItem, {
	        action: "status",
	        tooltip: '\u72B6\u6001',
	        type: type,
	        onClick: statusCommands.insert
	      }));
	    }
	  }]);
	  return StatusMenuItem;
	}(preact.Component);
	
	var StrikethroughMenuItem = function (_preact$Component37) {
	  (0, _inherits3.default)(StrikethroughMenuItem, _preact$Component37);
	
	  function StrikethroughMenuItem() {
	    (0, _classCallCheck3.default)(this, StrikethroughMenuItem);
	    return (0, _possibleConstructorReturn3.default)(this, (StrikethroughMenuItem.__proto__ || (0, _getPrototypeOf2.default)(StrikethroughMenuItem)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(StrikethroughMenuItem, [{
	    key: 'render',
	    value: function render() {
	      var _props31 = this.props,
	          editorCore = _props31.editorCore,
	          type = _props31.type;
	      var codeUtils = editorCore.codeUtils,
	          basicCommands = editorCore.basicCommands,
	          basicUtils = editorCore.basicUtils,
	          view = editorCore.view;
	      var schema = view.state.schema;
	
	
	      if (!basicCommands || !basicUtils) {
	        return "";
	      }
	
	      var isInCode = codeUtils && codeUtils.isInCode(view.state);
	      return preact.h(MenuItemWrapper, null, preact.h(MenuItem, {
	        action: "strikethrough",
	        tooltip: '\u4E2D\u5212\u7EBF',
	        type: type,
	        activeHandler: function activeHandler() {
	          return basicUtils && basicUtils.hasMark(view.state, schema.marks.strikethrough);
	        },
	        disabledHandler: function disabledHandler() {
	          return isInCode;
	        },
	        onClick: function onClick() {
	          return basicCommands.toggleMark(schema.marks.strikethrough);
	        }
	      }));
	    }
	  }]);
	  return StrikethroughMenuItem;
	}(preact.Component);
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    (0, _defineProperty3.default)(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	var defineProperty = _defineProperty;
	
	function _objectSpread(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? arguments[i] : {};
	    var ownKeys = (0, _keys2.default)(source);
	
	    if (typeof _getOwnPropertySymbols2.default === 'function') {
	      ownKeys = ownKeys.concat((0, _getOwnPropertySymbols2.default)(source).filter(function (sym) {
	        return (0, _getOwnPropertyDescriptor2.default)(source, sym).enumerable;
	      }));
	    }
	
	    ownKeys.forEach(function (key) {
	      defineProperty(target, key, source[key]);
	    });
	  }
	
	  return target;
	}
	
	var objectSpread = _objectSpread;
	
	var css$3 = ".toolbar-add-table-modal{position:fixed;padding:8px 8px 1px;background-color:#fff;border:1px solid #eee;box-shadow:0 1px 4px 0 rgba(111,130,166,.08),0 16px 30px 0 rgba(111,130,166,.14);font-size:12px;border-radius:2px;z-index:99}.toolbar-add-table-modal .container{border:1px solid #ddd;cursor:pointer}.toolbar-add-table-modal .row{height:18px;border-bottom:1px solid #ddd}.toolbar-add-table-modal .row:first-child{background-color:#f6f6f6}.toolbar-add-table-modal .row:last-child{height:17px;border-bottom:none}.toolbar-add-table-modal .block{display:inline-block;width:25px;height:100%;border-right:1px solid #ddd}.toolbar-add-table-modal .block:last-child{width:23px;border-right:none}.toolbar-add-table-modal .count{text-align:center}";
	styleInject(css$3);
	
	var Popover$2 = function (_preact$Component38) {
	  (0, _inherits3.default)(Popover$2, _preact$Component38);
	
	  function Popover$2() {
	    var _ref12;
	
	    (0, _classCallCheck3.default)(this, Popover$2);
	
	    for (var _len9 = arguments.length, args = Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
	      args[_key9] = arguments[_key9];
	    }
	
	    var _this44 = (0, _possibleConstructorReturn3.default)(this, (_ref12 = Popover$2.__proto__ || (0, _getPrototypeOf2.default)(Popover$2)).call.apply(_ref12, [this].concat(args)));
	
	    _this44.state = {
	      bound: {
	        rowCount: 4,
	        colCount: 4
	      },
	      highlight: {
	        rowNum: 0,
	        colNum: 0
	      }
	    };
	
	    _this44.onMouseMove = function (e) {
	      var target = e.target;
	      var row = target.getAttribute("data-row");
	      var col = target.getAttribute("data-col");
	      var _this44$state = _this44.state,
	          _this44$state$bound = _this44$state.bound,
	          rowCount = _this44$state$bound.rowCount,
	          colCount = _this44$state$bound.colCount,
	          _this44$state$highlig = _this44$state.highlight,
	          rowNum = _this44$state$highlig.rowNum,
	          colNum = _this44$state$highlig.colNum;
	
	      var newRowCount = rowCount;
	      var newColCount = colCount;
	
	      if (row !== null) {
	        if (row > 3) {
	          newRowCount = +row + 1;
	        } else {
	          newRowCount = 4;
	        }
	
	        if (col > 3) {
	          newColCount = +col + 1;
	        } else {
	          newColCount = 4;
	        }
	
	        _this44.setState({
	          bound: {
	            rowCount: newRowCount,
	            colCount: newColCount
	          },
	          highlight: {
	            rowNum: +row,
	            colNum: +col
	          }
	        });
	      } else {
	        var limit = _this44.props.limit;
	        var xDis = _this44.modal.offsetLeft + _this44.modal.offsetWidth - 8;
	        var yDis = _this44.modal.offsetTop + _this44.modal.offsetHeight - 20;
	        var newRowNum = rowNum;
	        var newColNum = colNum;
	
	        if (e.clientX > xDis) {
	          if (colCount < limit.col) {
	            newColCount = colCount + 1;
	          }
	
	          if (newColNum < newColCount - 1) {
	            newColNum = newColCount - 1;
	          }
	        } else {
	          newColNum = colCount - ~~((xDis - e.clientX) / 25 + 1);
	
	          if (newColNum < 0) {
	            newColNum = 0;
	          }
	        }
	
	        if (e.clientY > yDis) {
	          if (rowCount < limit.row) {
	            newRowCount = rowCount + 1;
	          }
	
	          if (newRowNum < newRowCount - 1) {
	            newRowNum = newRowCount - 1;
	          }
	        } else {
	          newRowNum = rowCount - ~~((yDis - e.clientY) / 17 + 1);
	
	          if (newRowNum < 0) {
	            newRowNum = 0;
	          }
	        }
	
	        _this44.setState({
	          bound: {
	            rowCount: newRowCount,
	            colCount: newColCount
	          },
	          highlight: {
	            rowNum: newRowNum,
	            colNum: newColNum
	          }
	        });
	      }
	    };
	
	    _this44.handleClick = function () {
	      var _this44$state$highlig2 = _this44.state.highlight,
	          rowNum = _this44$state$highlig2.rowNum,
	          colNum = _this44$state$highlig2.colNum;
	
	      _this44.props.insertTable(rowNum + 1, colNum + 1);
	    };
	    return _this44;
	  }
	
	  (0, _createClass3.default)(Popover$2, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.addEventListener("mousemove", this.onMouseMove);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener("mousemove", this.onMouseMove);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this45 = this;
	
	      var _state3 = this.state,
	          _state3$highlight = _state3.highlight,
	          rowNum = _state3$highlight.rowNum,
	          colNum = _state3$highlight.colNum,
	          _state3$bound = _state3.bound,
	          rowCount = _state3$bound.rowCount,
	          colCount = _state3$bound.colCount;
	
	      var rows = [];
	
	      for (var i = 0; i < rowCount; i++) {
	        var blocks = [];
	
	        for (var j = 0; j < colCount; j++) {
	          if (rowNum >= i && colNum >= j) {
	            blocks.push(preact.h("div", {
	              key: j,
	              "data-row": i,
	              "data-col": j,
	              className: "block",
	              style: {
	                backgroundColor: "rgba(240, 251, 255, 0.5)"
	              }
	            }));
	          } else {
	            blocks.push(preact.h("div", {
	              key: j,
	              "data-row": i,
	              "data-col": j,
	              className: "block"
	            }));
	          }
	        }
	
	        rows.push(preact.h("div", {
	          className: "row",
	          key: i
	        }, blocks));
	      }
	
	      var width = 118 + (colCount - 4) * 25 + 'px';
	      return preact.h("div", {
	        className: "toolbar-add-table-modal",
	        style: objectSpread({}, this.props.style, {
	          width: width
	        }),
	        onClick: this.handleClick,
	        ref: function ref(div) {
	          _this45.modal = div;
	        }
	      }, preact.h("div", {
	        className: "container"
	      }, rows), preact.h("div", {
	        className: "count"
	      }, rowNum + 1 + ' X ' + (colNum + 1)));
	    }
	  }]);
	  return Popover$2;
	}(preact.Component);
	
	var TablePopover = function (_preact$Component39) {
	  (0, _inherits3.default)(TablePopover, _preact$Component39);
	
	  function TablePopover() {
	    var _ref13;
	
	    (0, _classCallCheck3.default)(this, TablePopover);
	
	    for (var _len10 = arguments.length, args = Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
	      args[_key10] = arguments[_key10];
	    }
	
	    var _this46 = (0, _possibleConstructorReturn3.default)(this, (_ref13 = TablePopover.__proto__ || (0, _getPrototypeOf2.default)(TablePopover)).call.apply(_ref13, [this].concat(args)));
	
	    _this46.tableRef = null;
	    _this46.state = {
	      tablePopover: {
	        style: {},
	        visible: false
	      }
	    };
	
	    _this46.closeTablePopover = function (e) {
	      if (e.target && _this46.props.wrapper && !_this46.props.wrapper.base.contains(e.target) && _this46.state.tablePopover.visible && _this46.tableRef) {
	        document.removeEventListener("click", _this46.closeTablePopover);
	        _this46.setState({
	          tablePopover: {
	            visible: false
	          }
	        });
	      }
	    };
	
	    _this46.toggle = function (e) {
	      var visible = _this46.state.tablePopover.visible;
	
	      if (visible) {
	        document.removeEventListener("click", _this46.closeTablePopover);
	        _this46.setState({
	          tablePopover: {
	            visible: false
	          }
	        });
	      } else {
	        document.addEventListener("click", _this46.closeTablePopover);
	        _this46.setState({
	          tablePopover: {
	            style: {
	              left: e.clientX - 20 + 'px',
	              top: e.clientY + 15 + 'px'
	            },
	            visible: true
	          }
	        });
	      }
	    };
	
	    _this46.handleClick = function (row, col) {
	      var _this46$props$editorC = _this46.props.editorCore,
	          view = _this46$props$editorC.view,
	          tableCommands = _this46$props$editorC.tableCommands;
	
	      _this46.toggle();
	      tableCommands.insertTable(row, col);
	      view.focus();
	    };
	    return _this46;
	  }
	
	  (0, _createClass3.default)(TablePopover, [{
	    key: 'render',
	    value: function render() {
	      var _this47 = this;
	
	      var tablePopover = this.state.tablePopover;
	
	
	      if (!tablePopover.visible) {
	        return null;
	      }
	
	      return preact.h(Popover$2, {
	        ref: function ref(target) {
	          _this47.tableRef = target;
	        },
	        style: tablePopover.style,
	        limit: {
	          row: 15,
	          col: 15
	        },
	        insertTable: this.handleClick
	      });
	    }
	  }]);
	  return TablePopover;
	}(preact.Component);
	
	var TableMenuItem = function (_preact$Component40) {
	  (0, _inherits3.default)(TableMenuItem, _preact$Component40);
	
	  function TableMenuItem() {
	    var _ref14;
	
	    (0, _classCallCheck3.default)(this, TableMenuItem);
	
	    for (var _len11 = arguments.length, args = Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
	      args[_key11] = arguments[_key11];
	    }
	
	    var _this48 = (0, _possibleConstructorReturn3.default)(this, (_ref14 = TableMenuItem.__proto__ || (0, _getPrototypeOf2.default)(TableMenuItem)).call.apply(_ref14, [this].concat(args)));
	
	    _this48.tablePopover = void 0;
	    _this48.wrapper = void 0;
	    return _this48;
	  }
	
	  (0, _createClass3.default)(TableMenuItem, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.forceUpdate();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this49 = this;
	
	      var _props32 = this.props,
	          editorCore = _props32.editorCore,
	          type = _props32.type;
	      var view = editorCore.view;
	      var tableCommands = editorCore.tableCommands;
	
	
	      if (!tableCommands) {
	        return null;
	      }
	
	      return preact.h(MenuItemWrapper, {
	        ref: function ref(wrapper) {
	          _this49.wrapper = wrapper;
	        }
	      }, preact.h(MenuItem, {
	        action: "table",
	        tooltip: '\u8868\u683C',
	        type: type,
	        disabledHandler: function disabledHandler() {
	          return view.state && !index_js$1.canInsertTypes(view.state);
	        },
	        onClick: function onClick(e) {
	          _this49.tablePopover.toggle(e);
	          view.focus();
	        }
	      }), preact.h(TablePopover, {
	        editorCore: editorCore,
	        wrapper: this.wrapper,
	        ref: function ref(popover) {
	          _this49.tablePopover = popover;
	        }
	      }));
	    }
	  }]);
	  return TableMenuItem;
	}(preact.Component);
	
	var TaskListMenuItem = function (_preact$Component41) {
	  (0, _inherits3.default)(TaskListMenuItem, _preact$Component41);
	
	  function TaskListMenuItem() {
	    (0, _classCallCheck3.default)(this, TaskListMenuItem);
	    return (0, _possibleConstructorReturn3.default)(this, (TaskListMenuItem.__proto__ || (0, _getPrototypeOf2.default)(TaskListMenuItem)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(TaskListMenuItem, [{
	    key: 'render',
	    value: function render() {
	      var _props33 = this.props,
	          editorCore = _props33.editorCore,
	          type = _props33.type;
	      var listUtils = editorCore.listUtils,
	          view = editorCore.view;
	
	
	      if (!listUtils) {
	        return "";
	      }
	
	      var schema = view.state.schema;
	
	      return preact.h(MenuItemWrapper, null, preact.h(MenuItem, {
	        type: type,
	        action: "taskList",
	        tooltip: '\u4EFB\u52A1\u5217\u8868',
	        disabledHandler: function disabledHandler() {
	          return view.state && !index_js$1.canInsertTypes(view.state);
	        },
	        activeHandler: function activeHandler() {
	          return listUtils && listUtils.judgeListType(view.state, schema.nodes.task_list);
	        },
	        onClick: function onClick() {
	          handleListClick(schema.nodes.task_list, editorCore);
	        }
	      }));
	    }
	  }]);
	  return TaskListMenuItem;
	}(preact.Component);
	
	var css$4 = ".toolbar-textExtra-popover-wrapper{display:flex;justify-content:center;align-items:center;position:relative;height:28px;width:45px;font-size:12px;cursor:pointer;transition:all .2s ease;background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='40' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23666'%3E%3Cpath d='M11.07 20H9l8.262-12.744h1.602L21.456 20h-1.854l-.612-3.132h-5.976L11.07 20zm2.862-4.698h4.806l-1.08-6.048-3.726 6.048zM8.991 9.9h-.027c-.108.193-.282.35-.523.474-.24.123-.513.185-.82.185-.174 0-.355-.023-.544-.068a1.622 1.622 0 0 1-.523-.225 1.31 1.31 0 0 1-.396-.415A1.193 1.193 0 0 1 6 9.216c0-.324.092-.582.275-.775.183-.192.419-.339.707-.441.288-.102.608-.17.96-.203.35-.033.695-.05 1.031-.05V7.64c0-.27-.098-.47-.293-.6a1.236 1.236 0 0 0-.698-.193c-.228 0-.447.048-.658.144a1.77 1.77 0 0 0-.522.351l-.559-.657c.246-.229.53-.4.852-.514.32-.114.647-.171.977-.171.384 0 .701.054.95.162.25.108.446.25.59.424.145.174.245.369.302.585.057.216.086.433.086.649v2.63H8.991V9.9zm-.018-1.423H8.73c-.174 0-.358.008-.55.023-.192.015-.37.048-.531.1a1.135 1.135 0 0 0-.406.215.479.479 0 0 0-.162.383.46.46 0 0 0 .243.424.784.784 0 0 0 .244.09c.09.018.18.027.27.027.372 0 .654-.1.847-.298.192-.198.288-.468.288-.81v-.154z'/%3E%3C/g%3E%3Cpath fill='%23AEAEAE' d='M30 11.5h6l-3 3z'/%3E%3C/g%3E%3C/svg%3E\") no-repeat 50%}.toolbar-textExtra-popover-wrapper:hover{background-color:#ddd}.toolbar-textExtra-popover-wrapper.disabled{cursor:not-allowed}.toolbar-textExtra-popover-wrapper.disabled path{fill:#aaa}.toolbar-more-popover{width:80px!important;padding:8px 0}";
	styleInject(css$4);
	
	var Popover$3 = function (_preact$Component42) {
	  (0, _inherits3.default)(Popover$3, _preact$Component42);
	
	  function Popover$3() {
	    (0, _classCallCheck3.default)(this, Popover$3);
	    return (0, _possibleConstructorReturn3.default)(this, (Popover$3.__proto__ || (0, _getPrototypeOf2.default)(Popover$3)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Popover$3, [{
	    key: 'render',
	    value: function render() {
	      var _this52 = this;
	
	      var _props$displayPos = this.props.displayPos,
	          displayPos = _props$displayPos === undefined ? {} : _props$displayPos;
	
	      return preact.h("div", {
	        className: "toolbar-popover-wrapper toolbar-more-popover",
	        style: displayPos
	      }, preact.h("div", {
	        "data-action": "sup",
	        className: "menu-item toolbar-more-popover-item",
	        onClick: function onClick(e) {
	          return _this52.props.select("sup");
	        }
	      }, preact.h("span", {
	        className: "toolbar-icon-wrapper",
	        "data-action": "sup"
	      }), preact.h("span", null, '\u4E0A\u6807')), preact.h("div", {
	        "data-action": "sub",
	        className: "menu-item toolbar-more-popover-item",
	        onClick: function onClick(e) {
	          return _this52.props.select("sub");
	        }
	      }, preact.h("span", {
	        className: "toolbar-icon-wrapper",
	        "data-action": "sub"
	      }), preact.h("span", null, '\u4E0B\u6807')));
	    }
	  }]);
	  return Popover$3;
	}(preact.Component);
	
	var MorePopover = function (_preact$Component43) {
	  (0, _inherits3.default)(MorePopover, _preact$Component43);
	
	  function MorePopover() {
	    var _ref15;
	
	    (0, _classCallCheck3.default)(this, MorePopover);
	
	    for (var _len12 = arguments.length, args = Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
	      args[_key12] = arguments[_key12];
	    }
	
	    var _this53 = (0, _possibleConstructorReturn3.default)(this, (_ref15 = MorePopover.__proto__ || (0, _getPrototypeOf2.default)(MorePopover)).call.apply(_ref15, [this].concat(args)));
	
	    _this53.state = {
	      hasTooltip: false,
	      isOpen: false
	    };
	
	    _this53.onSelect = function (ops) {
	      var _this53$props$handler = _this53.props.handler,
	          handler = _this53$props$handler === undefined ? {} : _this53$props$handler;
	
	
	      if (typeof handler[ops] === "function") {
	        return handler[ops]();
	      }
	    };
	
	    _this53.hidePopover = function (e) {
	      if (!e || e && e.target && !_this53.container.contains(e.target)) {
	        _this53.setState({
	          hasTooltip: false,
	          isOpen: false
	        });
	        window.removeEventListener("click", _this53.hidePopover);
	      }
	    };
	
	    _this53.componentDidMount = function () {
	      var popoverPos = {
	        left: 0,
	        top: _this53.container.offsetHeight + 'px'
	      };
	      _this53.setState({
	        popoverPos: popoverPos
	      });
	    };
	
	    _this53.handleClick = function (e) {
	      var view = _this53.props.editorCore.view;
	
	      view.focus();
	      var isOpen = _this53.state.isOpen;
	
	
	      if (!isOpen) {
	        _this53.setState({
	          hasTooltip: false,
	          isOpen: true
	        });
	        window.addEventListener("click", _this53.hidePopover);
	      } else {
	        _this53.hidePopover();
	      }
	    };
	
	    _this53.handleMouseEnter = function () {
	      if (_this53.state.isOpen) {
	        return;
	      }
	
	      _this53.setState({
	        hasTooltip: true
	      });
	    };
	    return _this53;
	  }
	
	  (0, _createClass3.default)(MorePopover, [{
	    key: 'render',
	    value: function render() {
	      var _this54 = this;
	
	      var disabledHandler = this.props.disabledHandler;
	
	      var disabled = disabledHandler && disabledHandler();
	      var popoverPos = this.state.popoverPos;
	
	      return preact.h("div", {
	        onClick: !disabled ? this.handleClick : null,
	        onMouseEnter: !disabled ? this.handleMouseEnter : null,
	        onMouseLeave: function onMouseLeave() {
	          return _this54.setState({
	            hasTooltip: false
	          });
	        },
	        className: 'toolbar-textExtra-popover-wrapper' + (disabled ? " disabled" : ""),
	        ref: function ref(container) {
	          _this54.container = container;
	        }
	      }, this.state.isOpen && preact.h(Popover$3, {
	        select: this.onSelect,
	        displayPos: popoverPos
	      }), this.state.hasTooltip && preact.h("div", {
	        className: "toolbar-tooltip",
	        style: {
	          width: "70px"
	        }
	      }, '\u6587\u5B57\u5176\u4ED6'));
	    }
	  }]);
	  return MorePopover;
	}(preact.Component);
	
	var TextExtraMenuItem = function (_preact$Component44) {
	  (0, _inherits3.default)(TextExtraMenuItem, _preact$Component44);
	
	  function TextExtraMenuItem() {
	    (0, _classCallCheck3.default)(this, TextExtraMenuItem);
	    return (0, _possibleConstructorReturn3.default)(this, (TextExtraMenuItem.__proto__ || (0, _getPrototypeOf2.default)(TextExtraMenuItem)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(TextExtraMenuItem, [{
	    key: 'render',
	    value: function render() {
	      var _props34 = this.props,
	          editorCore = _props34.editorCore,
	          type = _props34.type;
	      var codeUtils = editorCore.codeUtils,
	          basicCommands = editorCore.basicCommands,
	          view = editorCore.view;
	      var schema = view.state.schema;
	
	
	      if (!basicCommands) {
	        return "";
	      }
	
	      var isInCode = codeUtils && codeUtils.isInCode(view.state);
	      return preact.h(MorePopover, {
	        type: type,
	        editorCore: editorCore,
	        disabledHandler: function disabledHandler() {
	          return isInCode;
	        },
	        handler: {
	          sub: function sub() {
	            return basicCommands.toggleSuMark(schema.marks.sub);
	          },
	          sup: function sup() {
	            return basicCommands.toggleSuMark(schema.marks.sup);
	          }
	        }
	      });
	    }
	  }]);
	  return TextExtraMenuItem;
	}(preact.Component);
	
	var preactPortal = createCommonjsModule(function (module, exports) {
	  (function (global, factory) {
	    module.exports = factory(preact__default);
	  })(commonjsGlobal, function (preact) {
	    var classCallCheck = function classCallCheck(instance, Constructor) {
	      if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	      }
	    };
	
	    var inherits = function inherits(subClass, superClass) {
	      if (typeof superClass !== "function" && superClass !== null) {
	        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : (0, _typeof3.default)(superClass)));
	      }
	
	      subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	        constructor: {
	          value: subClass,
	          enumerable: false,
	          writable: true,
	          configurable: true
	        }
	      });
	      if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	    };
	
	    var possibleConstructorReturn = function possibleConstructorReturn(self, call) {
	      if (!self) {
	        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	      }
	
	      return call && ((typeof call === 'undefined' ? 'undefined' : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	    };
	
	    var Portal = function (_Component) {
	      inherits(Portal, _Component);
	
	      function Portal() {
	        classCallCheck(this, Portal);
	        return possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      Portal.prototype.componentDidUpdate = function componentDidUpdate(props) {
	        for (var i in props) {
	          if (props[i] !== this.props[i]) {
	            return setTimeout(this.renderLayer);
	          }
	        }
	      };
	
	      Portal.prototype.componentDidMount = function componentDidMount() {
	        this.isMounted = true;
	        this.renderLayer = this.renderLayer.bind(this);
	        this.renderLayer();
	      };
	
	      Portal.prototype.componentWillUnmount = function componentWillUnmount() {
	        this.renderLayer(false);
	        this.isMounted = false;
	        if (this.remote) this.remote.parentNode.removeChild(this.remote);
	      };
	
	      Portal.prototype.findNode = function findNode(node) {
	        return typeof node === 'string' ? document.querySelector(node) : node;
	      };
	
	      Portal.prototype.renderLayer = function renderLayer() {
	        var show = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	        if (!this.isMounted) return;
	
	        if (this.props.into !== this.intoPointer) {
	          this.intoPointer = this.props.into;
	          if (this.into && this.remote) {
	            this.remote = preact.render(preact.h(PortalProxy, null), this.into, this.remote);
	          }
	          this.into = this.findNode(this.props.into);
	        }
	
	        this.remote = preact.render(preact.h(PortalProxy, { context: this.context }, show && this.props.children || null), this.into, this.remote);
	      };
	
	      Portal.prototype.render = function render() {
	        return null;
	      };
	
	      return Portal;
	    }(preact.Component);
	
	    var PortalProxy = function (_Component2) {
	      inherits(PortalProxy, _Component2);
	
	      function PortalProxy() {
	        classCallCheck(this, PortalProxy);
	        return possibleConstructorReturn(this, _Component2.apply(this, arguments));
	      }
	
	      PortalProxy.prototype.getChildContext = function getChildContext() {
	        return this.props.context;
	      };
	
	      PortalProxy.prototype.render = function render(_ref) {
	        var children = _ref.children;
	
	        return children && children[0] || null;
	      };
	
	      return PortalProxy;
	    }(preact.Component);
	
	    return Portal;
	  });
	});
	
	var DownIcon = function DownIcon(props) {
	  return preact.h("svg", {
	    width: "7px",
	    height: "4px",
	    viewBox: "0 0 7 4",
	    version: "1.1",
	    xmlns: "http://www.w3.org/2000/svg"
	  }, preact.h("desc", null, "Created with Sketch."), preact.h("defs", null), preact.h("g", {
	    id: "Page-1",
	    stroke: "none",
	    "stroke-width": "1",
	    fill: "none",
	    "fill-rule": "evenodd"
	  }, preact.h("g", {
	    id: '20\u3001\u5BCC\u6587\u672C\u7F16\u8F91',
	    transform: "translate(-521.000000, -82.000000)",
	    fill: "#AEAEAE"
	  }, preact.h("g", {
	    id: "Group",
	    transform: "translate(0.000000, 56.000000)"
	  }, preact.h("g", {
	    id: "Group-8",
	    transform: "translate(258.500000, 15.000000)"
	  }, preact.h("g", {
	    id: '\u5B57\u53F7',
	    transform: "translate(223.000000, 0.000000)"
	  }, preact.h("polygon", {
	    id: '\u5F62\u72B6_32',
	    points: "40 11.5 46 11.5 43 14.5"
	  })))))));
	};
	
	var css$5 = ".ct-editor-dropdown-content{position:absolute;border-radius:2px;background:#fff;border:1px solid #eee;box-shadow:0 1px 4px 0 rgba(111,130,166,.08),0 16px 30px 0 rgba(111,130,166,.14);cursor:pointer;z-index:9999}.ct-editor-dropdown-container{position:relative;padding-left:10px;padding-right:5px;height:28px;font-size:12px;cursor:pointer;transition:all .2s ease}.ct-editor-dropdown-container,.ct-editor-dropdown-container .ct-dropdown-selected{display:flex;justify-content:space-between;align-items:center}.ct-editor-dropdown-container .ct-dropdown-selected svg{margin-left:20px;margin-right:5px}.ct-editor-dropdown-container .ct-toolbar-tooltip{display:none}.ct-editor-dropdown-container:hover{background-color:#ddd}.ct-editor-dropdown-container:hover .ct-toolbar-tooltip{display:block}.ct-editor-dropdown-container.disabled{cursor:not-allowed;color:#aaa}.ct-editor-dropdown-container.disabled .ct-dropdown-selected{cursor:not-allowed}";
	styleInject(css$5);
	
	var Dropdown = function (_preact$Component45) {
	  (0, _inherits3.default)(Dropdown, _preact$Component45);
	
	  function Dropdown(props) {
	    (0, _classCallCheck3.default)(this, Dropdown);
	
	    var _this56 = (0, _possibleConstructorReturn3.default)(this, (Dropdown.__proto__ || (0, _getPrototypeOf2.default)(Dropdown)).call(this, props));
	
	    _this56.ref = void 0;
	    _this56.btn = void 0;
	    _this56.state = {
	      active: false
	    };
	
	    _this56.clickOutSide = function (e) {
	      if (e.target === _this56.btn || _this56.btn.contains(e.target)) return;
	
	      if (_this56.ref && !_this56.ref.contains(e.target)) {
	        _this56.setState({
	          active: false
	        });
	      }
	    };
	
	    _this56.onClick = function () {
	      if (!_this56.props.disabled) _this56.setState({
	        active: !_this56.state.active
	      });
	    };
	    return _this56;
	  }
	
	  (0, _createClass3.default)(Dropdown, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.addEventListener('mousedown', this.clickOutSide);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener('mousedown', this.clickOutSide);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this57 = this;
	
	      var _props35 = this.props,
	          disabled = _props35.disabled,
	          tooltip = _props35.tooltip,
	          menuWidth = _props35.width;
	      var active = this.state.active;
	
	      var _ref16 = this.btn ? this.btn.getBoundingClientRect() : {
	        top: 0,
	        left: 0,
	        width: 0,
	        height: 0
	      },
	          top = _ref16.top,
	          left = _ref16.left,
	          width = _ref16.width,
	          height = _ref16.height;
	
	      var style = {
	        top: top + height + 'px',
	        left: left + 'px',
	        maxWidth: width + 100 + 'px'
	      };
	      var selectBtnStyl = {};
	      if (menuWidth) selectBtnStyl.width = menuWidth + 'px';
	      return preact.h("div", null, preact.h("div", {
	        className: 'ct-editor-dropdown-container ' + (disabled ? 'disabled' : ''),
	        ref: function ref(_ref17) {
	          return _this57.btn = _ref17;
	        },
	        onClick: this.onClick
	      }, preact.h("span", {
	        className: 'ct-dropdown-selected ',
	        style: selectBtnStyl
	      }, this.props.selected, preact.h(DownIcon, null)), preact.h("div", {
	        className: "ct-toolbar-tooltip",
	        style: {
	          width: "70px"
	        }
	      }, tooltip), preact.h(preactPortal, {
	        into: "body"
	      }, active ? preact.h("div", {
	        onClick: function onClick() {
	          return _this57.setState({
	            active: false
	          });
	        },
	        className: "ct-editor-dropdown-content",
	        style: style,
	        ref: function ref(_ref18) {
	          return _this57.ref = _ref18;
	        }
	      }, this.props.children) : null)));
	    }
	  }]);
	  return Dropdown;
	}(preact.Component);
	
	var css$6 = ".toolbar-p-popover-item{margin:8px auto;padding-left:16px;padding-right:10px;color:#333;transition:all .2s ease}.toolbar-p-popover-item:hover{background:#f6f6f6}.toolbar-p-popover-item:not(:first-child){font-weight:700}.toolbar-p-popover-item:first-child{font-size:14px;line-height:24px}.toolbar-p-popover-item:nth-child(2){font-size:28px;line-height:42px}.toolbar-p-popover-item:nth-child(3){font-size:24px;line-height:36px}.toolbar-p-popover-item:nth-child(4){font-size:20px;line-height:30px}.toolbar-p-popover-item:nth-child(5){font-size:16px;line-height:24px}.toolbar-p-popover-item:nth-child(6){font-size:14px;line-height:21px}.toolbar-p-popover-item:nth-child(7){font-size:12px;line-height:18px}";
	styleInject(css$6);
	
	function uuid() {
	  var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
	  var id = [];
	
	  for (var i = 0; i < 8; i++) {
	    id.push(chars[parseInt(Math.random() * chars.length, 10)]);
	  }
	
	  return id.join('');
	}
	
	var textBlocks = [{
	  type: "paragraph",
	  text: "正文",
	  keymap: "0"
	}, {
	  type: "heading_1",
	  text: "一级标题",
	  keymap: "1"
	}, {
	  type: "heading_2",
	  text: "二级标题",
	  keymap: "2"
	}, {
	  type: "heading_3",
	  text: "三级标题",
	  keymap: "3"
	}, {
	  type: "heading_4",
	  text: "四级标题",
	  keymap: "4"
	}, {
	  type: "heading_5",
	  text: "五级标题",
	  keymap: "5"
	}, {
	  type: "heading_6",
	  text: "六级标题",
	  keymap: "6"
	}];
	
	var BlockPopover = function (_preact$Component46) {
	  (0, _inherits3.default)(BlockPopover, _preact$Component46);
	
	  function BlockPopover() {
	    var _ref19;
	
	    (0, _classCallCheck3.default)(this, BlockPopover);
	
	    for (var _len13 = arguments.length, args = Array(_len13), _key13 = 0; _key13 < _len13; _key13++) {
	      args[_key13] = arguments[_key13];
	    }
	
	    var _this58 = (0, _possibleConstructorReturn3.default)(this, (_ref19 = BlockPopover.__proto__ || (0, _getPrototypeOf2.default)(BlockPopover)).call.apply(_ref19, [this].concat(args)));
	
	    _this58.state = {
	      hasTooltip: false,
	      isOpen: false
	    };
	
	    _this58.onSelect = function (type) {
	      var _this58$props$editorC = _this58.props.editorCore,
	          view = _this58$props$editorC.view,
	          basicUtils = _this58$props$editorC.basicUtils,
	          basicCommands = _this58$props$editorC.basicCommands;
	      var schema = view.state.schema;
	
	      var currAttr = basicUtils.getAttrs(view.state);
	
	      if (/heading_+/.test(type)) {
	        var level = parseInt(type[8], 10);
	        basicCommands.setTextBlockType(schema.nodes.heading, objectSpread({}, currAttr, {
	          level: level,
	          id: uuid()
	        }));
	      } else {
	        basicCommands.setTextBlockType(schema.nodes.paragraph);
	      }
	
	      view.focus();
	    };
	
	    _this58.handleMouseEnter = function () {
	      if (_this58.state.isOpen) {
	        return;
	      }
	
	      _this58.setState({
	        hasTooltip: true
	      });
	    };
	    return _this58;
	  }
	
	  (0, _createClass3.default)(BlockPopover, [{
	    key: 'render',
	    value: function render() {
	      var _this59 = this;
	
	      var _props$editorCore = this.props.editorCore,
	          view = _props$editorCore.view,
	          basicUtils = _props$editorCore.basicUtils;
	
	      var label = basicUtils ? basicUtils.getTextBlockType(view.state) : null;
	      var disabled = !label;
	      return preact.h(Dropdown, {
	        disabled: disabled,
	        selected: label || "无效段落",
	        tooltip: '\u6BB5\u843D\u683C\u5F0F',
	        width: 80
	      }, preact.h("div", null, textBlocks.map(function (b, index) {
	        return preact.h("div", {
	          "data-action": "paragraph",
	          key: b.type + '-' + index,
	          className: "toolbar-p-popover-item",
	          onClick: function onClick() {
	            return _this59.onSelect(b.type);
	          }
	        }, b.text);
	      })));
	    }
	  }]);
	  return BlockPopover;
	}(preact.Component);
	
	var TitleMenuItem = function (_preact$Component47) {
	  (0, _inherits3.default)(TitleMenuItem, _preact$Component47);
	
	  function TitleMenuItem() {
	    (0, _classCallCheck3.default)(this, TitleMenuItem);
	    return (0, _possibleConstructorReturn3.default)(this, (TitleMenuItem.__proto__ || (0, _getPrototypeOf2.default)(TitleMenuItem)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(TitleMenuItem, [{
	    key: 'render',
	    value: function render() {
	      var editorCore = this.props.editorCore;
	
	
	      if (!editorCore) {
	        return "";
	      }
	
	      return preact.h(BlockPopover, {
	        editorCore: editorCore
	      });
	    }
	  }]);
	  return TitleMenuItem;
	}(preact.Component);
	
	var UndelineMenuItem = function (_preact$Component48) {
	  (0, _inherits3.default)(UndelineMenuItem, _preact$Component48);
	
	  function UndelineMenuItem() {
	    (0, _classCallCheck3.default)(this, UndelineMenuItem);
	    return (0, _possibleConstructorReturn3.default)(this, (UndelineMenuItem.__proto__ || (0, _getPrototypeOf2.default)(UndelineMenuItem)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(UndelineMenuItem, [{
	    key: 'render',
	    value: function render() {
	      var _props36 = this.props,
	          editorCore = _props36.editorCore,
	          type = _props36.type;
	      var codeUtils = editorCore.codeUtils,
	          basicCommands = editorCore.basicCommands,
	          basicUtils = editorCore.basicUtils,
	          view = editorCore.view;
	      var schema = view.state.schema;
	
	
	      if (!basicCommands || !basicUtils) {
	        return "";
	      }
	
	      var isInCode = codeUtils && codeUtils.isInCode(view.state);
	      return preact.h(MenuItemWrapper, null, preact.h(MenuItem, {
	        type: type,
	        action: "underline",
	        tooltip: '\u4E0B\u5212\u7EBF',
	        activeHandler: function activeHandler() {
	          return basicUtils && basicUtils.hasMark(view.state, schema.marks.underline);
	        },
	        disabledHandler: function disabledHandler() {
	          return isInCode;
	        },
	        onClick: function onClick() {
	          return basicCommands.toggleMark(schema.marks.underline);
	        }
	      }));
	    }
	  }]);
	  return UndelineMenuItem;
	}(preact.Component);
	
	var css$7 = ".citadel-editor-toolbar .fs-dp-item{margin:5px auto;padding:3px 16px;color:#333;transition:all .2s ease;font-weight:700;font-size:14px;line-height:16px}.citadel-editor-toolbar .fs-dp-item:hover{background:#f6f6f6}";
	styleInject(css$7);
	
	var textBlocks$1 = [{
	  type: "12",
	  text: "9",
	  keymap: "0"
	}, {
	  type: "13",
	  text: "10",
	  keymap: "1"
	}, {
	  type: "14",
	  text: "11",
	  keymap: "2"
	}, {
	  type: "16",
	  text: "12",
	  keymap: "3"
	}, {
	  type: "19",
	  text: "14",
	  keymap: "4"
	}, {
	  type: "22",
	  text: "16",
	  keymap: "5"
	}, {
	  type: "24",
	  text: "18",
	  keymap: "6"
	}, {
	  type: "29",
	  text: "22",
	  keymap: "7"
	}, {
	  type: "32",
	  text: "24",
	  keymap: "8"
	}, {
	  type: "40",
	  text: "30",
	  keymap: "9"
	}, {
	  type: "48",
	  text: "36",
	  keymap: "10"
	}];
	
	
	var generateFontsize = function generateFontsize(type) {
	  if (type === null) return {
	    text: '11'
	  };
	  if (type === ' - ') return {
	    text: ' - '
	  };
	  if (type === 28) return {
	    text: 21
	  };
	  if (type === 20) return {
	    text: 15
	  };
	  return textBlocks$1.filter(function (b) {
	    return b.type === type.toString();
	  })[0];
	};
	
	var FontsizePopover = function (_preact$Component49) {
	  (0, _inherits3.default)(FontsizePopover, _preact$Component49);
	
	  function FontsizePopover() {
	    var _ref20;
	
	    (0, _classCallCheck3.default)(this, FontsizePopover);
	
	    for (var _len14 = arguments.length, args = Array(_len14), _key14 = 0; _key14 < _len14; _key14++) {
	      args[_key14] = arguments[_key14];
	    }
	
	    var _this62 = (0, _possibleConstructorReturn3.default)(this, (_ref20 = FontsizePopover.__proto__ || (0, _getPrototypeOf2.default)(FontsizePopover)).call.apply(_ref20, [this].concat(args)));
	
	    _this62.onSelect = function (size) {
	      var _this62$props$editorC = _this62.props.editorCore,
	          view = _this62$props$editorC.view,
	          basicCommands = _this62$props$editorC.basicCommands;
	      var _view$state = view.state,
	          selection = _view$state.selection,
	          doc = _view$state.doc;
	
	      basicCommands.setFontsize(size);
	
	
	      if (selection instanceof index_js$3.CellSelection) {
	        var detectCell = selection.$headCell;
	        var node = doc.nodeAt(detectCell.pos);
	
	        if (node.attrs.numCell) {
	          return;
	        }
	      }
	
	      view.focus();
	    };
	    return _this62;
	  }
	
	  (0, _createClass3.default)(FontsizePopover, [{
	    key: 'render',
	    value: function render() {
	      var _this63 = this;
	
	      var _props$editorCore2 = this.props.editorCore,
	          view = _props$editorCore2.view,
	          basicUtils = _props$editorCore2.basicUtils;
	
	      var fontSize = basicUtils ? basicUtils.getTextFontsize(view.state) : null;
	      var label = generateFontsize(fontSize);
	      var disabled = !basicUtils.canSetFontsize(view.state) || !label;
	      return preact.h("div", null, preact.h(Dropdown, {
	        selected: label.text,
	        disabled: disabled,
	        tooltip: '\u5B57\u4F53\u5927\u5C0F'
	      }, textBlocks$1.map(function (block, index) {
	        return preact.h("div", {
	          key: block.text + '-' + index,
	          className: "fs-dp-item",
	          onClick: function onClick() {
	            return _this63.onSelect(block.type);
	          }
	        }, block.text);
	      })));
	    }
	  }]);
	  return FontsizePopover;
	}(preact.Component);
	
	var FontSizeMenuItem = function (_preact$Component50) {
	  (0, _inherits3.default)(FontSizeMenuItem, _preact$Component50);
	
	  function FontSizeMenuItem() {
	    (0, _classCallCheck3.default)(this, FontSizeMenuItem);
	    return (0, _possibleConstructorReturn3.default)(this, (FontSizeMenuItem.__proto__ || (0, _getPrototypeOf2.default)(FontSizeMenuItem)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(FontSizeMenuItem, [{
	    key: 'render',
	    value: function render() {
	      var editorCore = this.props.editorCore;
	
	
	      if (!editorCore) {
	        return "";
	      }
	
	      return preact.h(FontsizePopover, {
	        editorCore: editorCore
	      });
	    }
	  }]);
	  return FontSizeMenuItem;
	}(preact.Component);
	
	var getMenuItem = function getMenuItem(name, props) {
	  switch (name) {
	    case "align":
	      return preact.h(AlignMenuItem, props);
	
	    case "attachment":
	      return preact.h(AttachmentMenuItem, props);
	
	    case "bold":
	      return preact.h(BoldMenuItem, props);
	
	    case "bulletList":
	      return preact.h(BulletListMenuItem, props);
	
	    case "catalog":
	      return preact.h(CatalogMenuItem, props);
	
	    case "clearFormat":
	      return preact.h(ClearFormatMenuItem, props);
	
	    case "code":
	      return preact.h(CodeMenuItem, props);
	
	    case "collapse":
	      return preact.h(CollapseMenuItem, props);
	
	    case "color":
	      return preact.h(ColorMenuItem, props);
	
	    case "drawio":
	      return preact.h(DrawIOMenuItem, props);
	
	    case "extra":
	      return preact.h(ExtraMenuItem, props);
	
	    case "extra_more":
	      return preact.h(ExtraMoreMenuItem, props);
	
	    case "history":
	      return preact.h(HistoryMenuItem, props);
	
	    case "hr":
	      return preact.h(HrMenuItem, props);
	
	    case "image":
	      return preact.h(ImageMenuItem, props);
	
	    case "indent":
	      return preact.h(IndentMenuItem, props);
	
	    case "italic":
	      return preact.h(ItalicMenuItem, props);
	
	    case "latex":
	      return preact.h(LatexMenuItem, props);
	
	    case "link":
	      return preact.h(LinkMenuItem, props);
	
	    case "markdown":
	      return preact.h(MarkdownMenuItem, props);
	
	    case "html":
	      return preact.h(HTMLMenuItem, props);
	
	    case "mention":
	      return preact.h(MentionMenuItem, props);
	
	    case "minder":
	      return preact.h(MinderMenuItem, props);
	
	    case "note":
	      return preact.h(NoteMenuItem, props);
	
	    case "orderList":
	      return preact.h(OrderListMenuItem, props);
	
	    case "quote":
	      return preact.h(QuoteMenuItem, props);
	
	    case "status":
	      return preact.h(StatusMenuItem, props);
	
	    case "strikethrough":
	      return preact.h(StrikethroughMenuItem, props);
	
	    case "table":
	      return preact.h(TableMenuItem, props);
	
	    case "taskList":
	      return preact.h(TaskListMenuItem, props);
	
	    case "textExtra":
	      return preact.h(TextExtraMenuItem, props);
	
	    case "title":
	      return preact.h(TitleMenuItem, props);
	
	    case "underline":
	      return preact.h(UndelineMenuItem, props);
	
	    case "fontSize":
	      return preact.h(FontSizeMenuItem, props);
	  }
	};
	
	var renderMenuBar = function renderMenuBar(menuBarConfig, editorCore) {
	  return menuBarConfig.map(function (item, idx) {
	    return renderItem(item, editorCore, idx === menuBarConfig.length - 1);
	  });
	};
	var renderItem = function renderItem(itemList, editorCore) {
	  var isLast = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var menu = itemList.map(function (item) {
	    if (typeof item === "string") {
	      return getMenuItem(item, {
	        editorCore: editorCore
	      });
	    } else if (item.type === "extra") {
	      return renderExtraMenu(item.content, editorCore);
	    } else if (item.type === "custom") {
	      return renderCustom(item);
	    }
	  });
	
	  if (!isLast) {
	    menu.push(preact.h("div", {
	      className: "toolbar-split"
	    }));
	  }
	
	  return menu;
	};
	var renderExtraMenu = function renderExtraMenu(itemList, editorCore) {
	  var extraList = renderExtraList(itemList, editorCore);
	  return getMenuItem("extra", {
	    editorCore: editorCore,
	    content: extraList
	  });
	};
	var renderExtraList = function renderExtraList(itemList, editorCore) {
	  return itemList.map(function (item) {
	    if (typeof item === "string") {
	      return getMenuItem(item, {
	        editorCore: editorCore,
	        type: "extra"
	      });
	    } else if (item.type === "more") {
	      return getMenuItem("extra_more", {
	        editorCore: editorCore,
	        item: item
	      });
	    } else if (item.type === "custom") {
	      return renderCustom(item);
	    }
	  });
	};
	var renderCustom = function renderCustom(item) {
	  if (typeof item.render !== "function") {
	    throw new Error("custom menu should have render menthod");
	  }
	
	  var container = document.createElement("div");
	  return item.render(container);
	};
	var hasTable = function hasTable(config) {
	  var queue = [config];
	
	  while (queue.length !== 0) {
	    var list = queue.shift();
	
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = (0, _getIterator3.default)(list), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var item = _step.value;
	
	        if (typeof item !== "string") {
	          if (item.content) {
	            queue.push(item.content);
	          } else {
	            queue.push(item);
	          }
	        } else {
	          if (item === "table") {
	            return true;
	          }
	        }
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	  }
	
	  return false;
	};
	
	var ToolBar = function (_preact$Component51) {
	  (0, _inherits3.default)(ToolBar, _preact$Component51);
	
	  function ToolBar() {
	    (0, _classCallCheck3.default)(this, ToolBar);
	    return (0, _possibleConstructorReturn3.default)(this, (ToolBar.__proto__ || (0, _getPrototypeOf2.default)(ToolBar)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ToolBar, [{
	    key: 'getMenuBar',
	    value: function getMenuBar() {
	      var _props37 = this.props,
	          getToolbarConfig = _props37.getToolbarConfig,
	          getEditorCore = _props37.getEditorCore;
	
	      var editorCore = getEditorCore();
	      var toolbarConfig = getToolbarConfig(editorCore);
	      return renderMenuBar(toolbarConfig, editorCore);
	    }
	  }, {
	    key: 'getTableMenu',
	    value: function getTableMenu() {
	      var _props38 = this.props,
	          getToolbarConfig = _props38.getToolbarConfig,
	          getEditorCore = _props38.getEditorCore;
	
	      var toolbarConfig = getToolbarConfig(getEditorCore());
	      var props = {
	        getEditorCore: getEditorCore
	      };
	      return hasTable(toolbarConfig) ? preact.h(TableMenu, props) : null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return preact.h("div", {
	        className: "citadel-editor-toolbar"
	      }, this.getMenuBar(), this.getTableMenu());
	    }
	  }]);
	  return ToolBar;
	}(preact.Component);
	
	var defaultGetToolbarConfig = function defaultGetToolbarConfig(editorCore) {
	  if (!editorCore) {
	    return [];
	  }
	
	  return [["history"], ["title", "fontSize", "clearFormat", "bold", "italic", "strikethrough", "underline", "color", "textExtra"], ["align"], ["bulletList", "orderList", "taskList", "indent"], ["table", "image", "link", "code", {
	    content: ["catalog", "attachment", "drawio", "minder", "status", "quote", "collapse", "note", "latex", "html", "hr", "mention"],
	    type: "extra"
	  }]];
	};
	
	var buildToolbar = function buildToolbar(_ref21) {
	  var $toolbarWrapper = _ref21.$toolbarWrapper,
	      getEditorCore = _ref21.getEditorCore,
	      getToolbarConfig = _ref21.getToolbarConfig;
	
	  var count = 0;
	  var toolbar = void 0;
	
	  var renderComponent = function renderComponent() {
	    if (!$toolbarWrapper) {
	      return;
	    }
	
	    toolbar = preact.render(preact.h(ToolBar, {
	      key: count,
	      getEditorCore: getEditorCore,
	      getToolbarConfig: getToolbarConfig || defaultGetToolbarConfig
	    }), $toolbarWrapper, $toolbarWrapper.firstChild);
	  };
	
	  var changeHandler = function changeHandler() {
	    count++;
	    setTimeout(renderComponent);
	  };
	
	  renderComponent();
	  var editor = getEditorCore();
	  editor.on("update", changeHandler);
	  editor.on("change", changeHandler);
	  return function () {
	    editor.off("update", changeHandler);
	    editor.off("change", changeHandler);
	    preact.render(null, $toolbarWrapper, toolbar);
	  };
	};
	
	exports.buildToolbar = buildToolbar;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _stringify = __webpack_require__(100);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _assign = __webpack_require__(26);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getOwnPropertySymbols = __webpack_require__(16);
	
	var _getOwnPropertySymbols2 = _interopRequireDefault(_getOwnPropertySymbols);
	
	var _iterator = __webpack_require__(82);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(81);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _promise = __webpack_require__(35);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = _promise2.default))(function (resolve, reject) {
	        function fulfilled(value) {
	            try {
	                step(generator.next(value));
	            } catch (e) {
	                reject(e);
	            }
	        }
	        function rejected(value) {
	            try {
	                step(generator["throw"](value));
	            } catch (e) {
	                reject(e);
	            }
	        }
	        function step(result) {
	            result.done ? resolve(result.value) : new P(function (resolve) {
	                resolve(result.value);
	            }).then(fulfilled, rejected);
	        }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	var __generator = undefined && undefined.__generator || function (thisArg, body) {
	    var _ = { label: 0, sent: function sent() {
	            if (t[0] & 1) throw t[1];return t[1];
	        }, trys: [], ops: [] },
	        f,
	        y,
	        t,
	        g;
	    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof _symbol2.default === "function" && (g[_iterator2.default] = function () {
	        return this;
	    }), g;
	    function verb(n) {
	        return function (v) {
	            return step([n, v]);
	        };
	    }
	    function step(op) {
	        if (f) throw new TypeError("Generator is already executing.");
	        while (_) {
	            try {
	                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	                if (y = 0, t) op = [op[0] & 2, t.value];
	                switch (op[0]) {
	                    case 0:case 1:
	                        t = op;break;
	                    case 4:
	                        _.label++;return { value: op[1], done: false };
	                    case 5:
	                        _.label++;y = op[1];op = [0];continue;
	                    case 7:
	                        op = _.ops.pop();_.trys.pop();continue;
	                    default:
	                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
	                            _ = 0;continue;
	                        }
	                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
	                            _.label = op[1];break;
	                        }
	                        if (op[0] === 6 && _.label < t[1]) {
	                            _.label = t[1];t = op;break;
	                        }
	                        if (t && _.label < t[2]) {
	                            _.label = t[2];_.ops.push(op);break;
	                        }
	                        if (t[2]) _.ops.pop();
	                        _.trys.pop();continue;
	                }
	                op = body.call(thisArg, _);
	            } catch (e) {
	                op = [6, e];y = 0;
	            } finally {
	                f = t = 0;
	            }
	        }if (op[0] & 5) throw op[1];return { value: op[0] ? op[1] : void 0, done: true };
	    }
	};
	var __rest = undefined && undefined.__rest || function (s, e) {
	    var t = {};
	    for (var p in s) {
	        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	    }if (s != null && typeof _getOwnPropertySymbols2.default === "function") for (var i = 0, p = (0, _getOwnPropertySymbols2.default)(s); i < p.length; i++) {
	        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	    }
	    return t;
	};
	var __importDefault = undefined && undefined.__importDefault || function (mod) {
	    return mod && mod.__esModule ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	
	var const_1 = __webpack_require__(98);
	var common_util_1 = __webpack_require__(80);
	var request_1 = __webpack_require__(147);
	var config_util_1 = __webpack_require__(148);
	
	var en_GB_1 = __importDefault(__webpack_require__(79));
	var CONFIG_USING_LOCAL_ACCESS_POINT = en_GB_1.default.CONFIG_USING_LOCAL_ACCESS_POINT;
	var pkgVersion;
	var ConfigClient = function () {
	    function ConfigClient(configArgs) {
	        var clientId = configArgs.clientId,
	            userCfgs = __rest(configArgs, ["clientId"]);
	        this.clientId = clientId;
	        this.env = userCfgs.accessEnv;
	        this.userCfgs = userCfgs;
	        this.configUrl = const_1.CONFIG_API_URL[this.localEnvMatchedEnv(this.env)].SSO_CONFIG_URL;
	        this.logger = new common_util_1.Logger('ConfigClient(线下环境请忽略)');
	    }
	    ConfigClient.prototype.init = function () {
	        return __awaiter(this, void 0, void 0, function () {
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        return [4, this.startRequest()];
	                    case 1:
	                        _a.sent();
	                        return [2];
	                }
	            });
	        });
	    };
	    ConfigClient.prototype.getConfig = function () {
	        return this.availableCfgs;
	    };
	    ConfigClient.prototype.startRequest = function () {
	        return __awaiter(this, void 0, void 0, function () {
	            var _a, userCfgs, clientId, env;
	            return __generator(this, function (_b) {
	                _a = this, userCfgs = _a.userCfgs, clientId = _a.clientId, env = _a.env;
	                this.reportConfig();
	                this.availableCfgs = (0, _assign2.default)(config_util_1.configModelTranslator({ accessPoint: const_1.DEFAULT_SSO_ACCESS_CONFIG[this.localEnvMatchedEnv(env)] }), userCfgs, { clientId: clientId });
	                return [2];
	            });
	        });
	    };
	    ConfigClient.prototype.getConfigInfo = function (params, clientId) {
	        return __awaiter(this, void 0, void 0, function () {
	            var url, opts, data;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        url = this.configUrl + "/exchange";
	                        opts = {
	                            headers: {
	                                clientId: clientId
	                            },
	                            method: 'POST',
	                            body: (0, _stringify2.default)(params)
	                        };
	                        return [4, request_1.fetchRequest(url, opts)];
	                    case 1:
	                        data = _a.sent();
	
	                        if (data !== null && data.msg) {
	                            this.logger.warn('getConfigInfo:', data.msg);
	                            return [2, data.msg];
	                        }
	                        return [2, data];
	                }
	            });
	        });
	    };
	    ConfigClient.prototype.reportConfig = function () {
	        return __awaiter(this, void 0, void 0, function () {
	            var cacheOjb, clientId, err_1;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        cacheOjb = {
	                            digest: ''
	                        };
	                        clientId = this.clientId;
	                        _a.label = 1;
	                    case 1:
	                        _a.trys.push([1, 3,, 4]);
	                        return [4, this.getConfigInfo(this.getExchangeReqParams(cacheOjb, true), clientId)];
	                    case 2:
	                        _a.sent();
	                        return [3, 4];
	                    case 3:
	                        err_1 = _a.sent();
	                        this.logger.warn('reportConfig:', err_1);
	                        return [3, 4];
	                    case 4:
	                        return [2];
	                }
	            });
	        });
	    };
	    ConfigClient.prototype.localEnvMatchedEnv = function (env) {
	        return env;
	    };
	    ConfigClient.prototype.getExchangeReqParams = function (cacheObj, isReport) {
	        var version = '1.0';
	        var cmd = 'REPORT_CONFIGS';
	        var sdkVersion = "web-" + (pkgVersion || '0.0.0');
	        var _a = this,
	            env = _a.env,
	            clientId = _a.clientId,
	            userCfgs = _a.userCfgs;
	        var _b = cacheObj.digest,
	            digest = _b === void 0 ? '' : _b;
	        var params = {
	            ssoConfigs: {
	                digest: digest,
	                configs: userCfgs
	            },
	            clientInfo: {
	                sdkVersion: sdkVersion,
	                env: env,
	                clientId: clientId,
	                ip: const_1.WEB_DEFAULT_IP
	            }
	        };
	
	        if (!isReport) {
	            cmd = 'REQUEST_CONFIGS';
	            return {
	                version: version,
	                cmd: cmd,
	                params: {
	                    accessEnv: this.env
	                }
	            };
	        }
	        return {
	            version: version,
	            cmd: cmd,
	            params: params
	        };
	    };
	    return ConfigClient;
	}();
	exports.ConfigClient = ConfigClient;
	exports.setPkgVersion = function (version) {
	    pkgVersion = version;
	};

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	function __export(m) {
	  for (var p in m) {
	    if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	  }
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	
	__export(__webpack_require__(242));
	var config_client_1 = __webpack_require__(145);
	exports.setPkgVersion = config_client_1.setPkgVersion;

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _assign = __webpack_require__(26);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _promise = __webpack_require__(35);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var __importDefault = undefined && undefined.__importDefault || function (mod) {
	    return mod && mod.__esModule ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	
	var en_GB_1 = __importDefault(__webpack_require__(79));
	var SYS_ERROR = en_GB_1.default.SYS_ERROR;
	function advancedFetch(originalFetch, timeout) {
	    var abortFunc;
	    var abortPromise = new _promise2.default(function (res, rej) {
	        abortFunc = function abortFunc() {
	            rej('timeout, and abort promise');
	        };
	    });
	    var highOrderFetch = _promise2.default.race([originalFetch, abortPromise]);
	    setTimeout(function () {
	        abortFunc();
	    }, timeout || 10 * 1000);
	    return highOrderFetch;
	}
	var resStatusMW = function resStatusMW(res) {
	    var reject = _promise2.default.reject;
	    reject = reject.bind(_promise2.default);
	    return res.status === 200 ? res.json() : reject({ code: res.status });
	};
	var resCatchError = function resCatchError(err) {
	    var ssoError = err;
	    if (ssoError.data && ssoError.data.msg) {
	        return { msg: ssoError.data.msg };
	    }
	
	    if (err.stack || typeof err === 'string') {
	        console.error(err.stack || err);
	    }
	    return { msg: SYS_ERROR };
	};
	function fetchRequest(url, opts) {
	    var options = {
	        method: 'POST'
	    };
	    var resolve = _promise2.default.resolve,
	        reject = _promise2.default.reject;
	    resolve = resolve.bind(_promise2.default);
	    reject = reject.bind(_promise2.default);
	    var fetchOptions = (0, _assign2.default)({}, options, opts);
	    return advancedFetch(fetch(url, fetchOptions)).then(resStatusMW).then(function (res) {
	        if (res.code === 200) {
	            return resolve(res.data);
	        }
	        return reject(res);
	    }).catch(resCatchError);
	}
	exports.fetchRequest = fetchRequest;

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _assign = __webpack_require__(26);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _keys = __webpack_require__(13);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var const_1 = __webpack_require__(98);
	
	function configModelTranslator(data) {
	    var keys = (0, _keys2.default)(const_1.configMappingModel);
	    return keys.reduce(function (result, key) {
	        var _a, _b;
	        var layerArr = const_1.configMappingModel[key].layer.split('.');
	
	        if (layerArr[0] === '') return (0, _assign2.default)(result, (_a = {}, _a[key] = data[key], _a));
	        var value = layerArr.reduce(function (original, layer) {
	            return original[layer];
	        }, data)[key];
	        return (0, _assign2.default)(result, (_b = {}, _b[key] = value, _b));
	    }, {});
	}
	exports.configModelTranslator = configModelTranslator;

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var __importDefault = undefined && undefined.__importDefault || function (mod) {
	    return mod && mod.__esModule ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	
	var sha256_1 = __importDefault(__webpack_require__(380));
	var enc_base64_1 = __importDefault(__webpack_require__(379));
	var CHARSET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
	function bufferToString(buffer) {
	    var state = [];
	    for (var i = 0; i < buffer.byteLength; i += 1) {
	        var index = buffer[i] % CHARSET.length | 0;
	        state.push(CHARSET[index]);
	    }
	    return state.join('');
	}
	exports.bufferToString = bufferToString;
	var DEFAULT_SIZE = 64;
	var HAS_CRYPTO = typeof window !== 'undefined' && !!window.crypto;
	exports.cryptoGenerateRandom = function (sizeInBytes) {
	    if (sizeInBytes === void 0) {
	        sizeInBytes = DEFAULT_SIZE;
	    }
	    var buffer = new Uint8Array(sizeInBytes);
	    if (HAS_CRYPTO) {
	        window.crypto.getRandomValues(buffer);
	    } else {
	        for (var i = 0; i < sizeInBytes; i += 1) {
	            buffer[i] = +Math.random().toString().slice(2);
	        }
	    }
	    return bufferToString(buffer);
	};
	function sha256Crypto(randomBytes) {
	    return enc_base64_1.default.stringify(sha256_1.default(randomBytes));
	}
	exports.sha256Crypto = sha256Crypto;

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _keys = __webpack_require__(13);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getOwnPropertySymbols = __webpack_require__(16);
	
	var _getOwnPropertySymbols2 = _interopRequireDefault(_getOwnPropertySymbols);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var __rest = undefined && undefined.__rest || function (s, e) {
	    var t = {};
	    for (var p in s) {
	        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	    }if (s != null && typeof _getOwnPropertySymbols2.default === "function") for (var i = 0, p = (0, _getOwnPropertySymbols2.default)(s); i < p.length; i++) {
	        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	    }
	    return t;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	function parseCookie(tokenArgs) {
	    var tokenStr = '';
	    var name = tokenArgs.name,
	        value = tokenArgs.value,
	        optionalArgs = __rest(tokenArgs, ["name", "value"]);
	    tokenStr = name + "=" + value + ";";
	    (0, _keys2.default)(optionalArgs).forEach(function (key) {
	        tokenStr += " " + key + "=" + optionalArgs[key] + ";";
	    });
	    return tokenStr;
	}
	exports.parseCookie = parseCookie;
	function generateState() {
	    return Math.random().toString(32).slice(2);
	}
	exports.generateState = generateState;

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(318), __esModule: true };

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(1), __webpack_require__(67));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror", "../css/css"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("sass", function(config) {
	  var cssMode = CodeMirror.mimeModes["text/css"];
	  var propertyKeywords = cssMode.propertyKeywords || {},
	      colorKeywords = cssMode.colorKeywords || {},
	      valueKeywords = cssMode.valueKeywords || {},
	      fontProperties = cssMode.fontProperties || {};
	
	  function tokenRegexp(words) {
	    return new RegExp("^" + words.join("|"));
	  }
	
	  var keywords = ["true", "false", "null", "auto"];
	  var keywordsRegexp = new RegExp("^" + keywords.join("|"));
	
	  var operators = ["\\(", "\\)", "=", ">", "<", "==", ">=", "<=", "\\+", "-",
	                   "\\!=", "/", "\\*", "%", "and", "or", "not", ";","\\{","\\}",":"];
	  var opRegexp = tokenRegexp(operators);
	
	  var pseudoElementsRegexp = /^::?[a-zA-Z_][\w\-]*/;
	
	  var word;
	
	  function isEndLine(stream) {
	    return !stream.peek() || stream.match(/\s+$/, false);
	  }
	
	  function urlTokens(stream, state) {
	    var ch = stream.peek();
	
	    if (ch === ")") {
	      stream.next();
	      state.tokenizer = tokenBase;
	      return "operator";
	    } else if (ch === "(") {
	      stream.next();
	      stream.eatSpace();
	
	      return "operator";
	    } else if (ch === "'" || ch === '"') {
	      state.tokenizer = buildStringTokenizer(stream.next());
	      return "string";
	    } else {
	      state.tokenizer = buildStringTokenizer(")", false);
	      return "string";
	    }
	  }
	  function comment(indentation, multiLine) {
	    return function(stream, state) {
	      if (stream.sol() && stream.indentation() <= indentation) {
	        state.tokenizer = tokenBase;
	        return tokenBase(stream, state);
	      }
	
	      if (multiLine && stream.skipTo("*/")) {
	        stream.next();
	        stream.next();
	        state.tokenizer = tokenBase;
	      } else {
	        stream.skipToEnd();
	      }
	
	      return "comment";
	    };
	  }
	
	  function buildStringTokenizer(quote, greedy) {
	    if (greedy == null) { greedy = true; }
	
	    function stringTokenizer(stream, state) {
	      var nextChar = stream.next();
	      var peekChar = stream.peek();
	      var previousChar = stream.string.charAt(stream.pos-2);
	
	      var endingString = ((nextChar !== "\\" && peekChar === quote) || (nextChar === quote && previousChar !== "\\"));
	
	      if (endingString) {
	        if (nextChar !== quote && greedy) { stream.next(); }
	        if (isEndLine(stream)) {
	          state.cursorHalf = 0;
	        }
	        state.tokenizer = tokenBase;
	        return "string";
	      } else if (nextChar === "#" && peekChar === "{") {
	        state.tokenizer = buildInterpolationTokenizer(stringTokenizer);
	        stream.next();
	        return "operator";
	      } else {
	        return "string";
	      }
	    }
	
	    return stringTokenizer;
	  }
	
	  function buildInterpolationTokenizer(currentTokenizer) {
	    return function(stream, state) {
	      if (stream.peek() === "}") {
	        stream.next();
	        state.tokenizer = currentTokenizer;
	        return "operator";
	      } else {
	        return tokenBase(stream, state);
	      }
	    };
	  }
	
	  function indent(state) {
	    if (state.indentCount == 0) {
	      state.indentCount++;
	      var lastScopeOffset = state.scopes[0].offset;
	      var currentOffset = lastScopeOffset + config.indentUnit;
	      state.scopes.unshift({ offset:currentOffset });
	    }
	  }
	
	  function dedent(state) {
	    if (state.scopes.length == 1) return;
	
	    state.scopes.shift();
	  }
	
	  function tokenBase(stream, state) {
	    var ch = stream.peek();
	
	    // Comment
	    if (stream.match("/*")) {
	      state.tokenizer = comment(stream.indentation(), true);
	      return state.tokenizer(stream, state);
	    }
	    if (stream.match("//")) {
	      state.tokenizer = comment(stream.indentation(), false);
	      return state.tokenizer(stream, state);
	    }
	
	    // Interpolation
	    if (stream.match("#{")) {
	      state.tokenizer = buildInterpolationTokenizer(tokenBase);
	      return "operator";
	    }
	
	    // Strings
	    if (ch === '"' || ch === "'") {
	      stream.next();
	      state.tokenizer = buildStringTokenizer(ch);
	      return "string";
	    }
	
	    if(!state.cursorHalf){// state.cursorHalf === 0
	    // first half i.e. before : for key-value pairs
	    // including selectors
	
	      if (ch === "-") {
	        if (stream.match(/^-\w+-/)) {
	          return "meta";
	        }
	      }
	
	      if (ch === ".") {
	        stream.next();
	        if (stream.match(/^[\w-]+/)) {
	          indent(state);
	          return "qualifier";
	        } else if (stream.peek() === "#") {
	          indent(state);
	          return "tag";
	        }
	      }
	
	      if (ch === "#") {
	        stream.next();
	        // ID selectors
	        if (stream.match(/^[\w-]+/)) {
	          indent(state);
	          return "builtin";
	        }
	        if (stream.peek() === "#") {
	          indent(state);
	          return "tag";
	        }
	      }
	
	      // Variables
	      if (ch === "$") {
	        stream.next();
	        stream.eatWhile(/[\w-]/);
	        return "variable-2";
	      }
	
	      // Numbers
	      if (stream.match(/^-?[0-9\.]+/))
	        return "number";
	
	      // Units
	      if (stream.match(/^(px|em|in)\b/))
	        return "unit";
	
	      if (stream.match(keywordsRegexp))
	        return "keyword";
	
	      if (stream.match(/^url/) && stream.peek() === "(") {
	        state.tokenizer = urlTokens;
	        return "atom";
	      }
	
	      if (ch === "=") {
	        // Match shortcut mixin definition
	        if (stream.match(/^=[\w-]+/)) {
	          indent(state);
	          return "meta";
	        }
	      }
	
	      if (ch === "+") {
	        // Match shortcut mixin definition
	        if (stream.match(/^\+[\w-]+/)){
	          return "variable-3";
	        }
	      }
	
	      if(ch === "@"){
	        if(stream.match(/@extend/)){
	          if(!stream.match(/\s*[\w]/))
	            dedent(state);
	        }
	      }
	
	
	      // Indent Directives
	      if (stream.match(/^@(else if|if|media|else|for|each|while|mixin|function)/)) {
	        indent(state);
	        return "def";
	      }
	
	      // Other Directives
	      if (ch === "@") {
	        stream.next();
	        stream.eatWhile(/[\w-]/);
	        return "def";
	      }
	
	      if (stream.eatWhile(/[\w-]/)){
	        if(stream.match(/ *: *[\w-\+\$#!\("']/,false)){
	          word = stream.current().toLowerCase();
	          var prop = state.prevProp + "-" + word;
	          if (propertyKeywords.hasOwnProperty(prop)) {
	            return "property";
	          } else if (propertyKeywords.hasOwnProperty(word)) {
	            state.prevProp = word;
	            return "property";
	          } else if (fontProperties.hasOwnProperty(word)) {
	            return "property";
	          }
	          return "tag";
	        }
	        else if(stream.match(/ *:/,false)){
	          indent(state);
	          state.cursorHalf = 1;
	          state.prevProp = stream.current().toLowerCase();
	          return "property";
	        }
	        else if(stream.match(/ *,/,false)){
	          return "tag";
	        }
	        else{
	          indent(state);
	          return "tag";
	        }
	      }
	
	      if(ch === ":"){
	        if (stream.match(pseudoElementsRegexp)){ // could be a pseudo-element
	          return "variable-3";
	        }
	        stream.next();
	        state.cursorHalf=1;
	        return "operator";
	      }
	
	    } // cursorHalf===0 ends here
	    else{
	
	      if (ch === "#") {
	        stream.next();
	        // Hex numbers
	        if (stream.match(/[0-9a-fA-F]{6}|[0-9a-fA-F]{3}/)){
	          if (isEndLine(stream)) {
	            state.cursorHalf = 0;
	          }
	          return "number";
	        }
	      }
	
	      // Numbers
	      if (stream.match(/^-?[0-9\.]+/)){
	        if (isEndLine(stream)) {
	          state.cursorHalf = 0;
	        }
	        return "number";
	      }
	
	      // Units
	      if (stream.match(/^(px|em|in)\b/)){
	        if (isEndLine(stream)) {
	          state.cursorHalf = 0;
	        }
	        return "unit";
	      }
	
	      if (stream.match(keywordsRegexp)){
	        if (isEndLine(stream)) {
	          state.cursorHalf = 0;
	        }
	        return "keyword";
	      }
	
	      if (stream.match(/^url/) && stream.peek() === "(") {
	        state.tokenizer = urlTokens;
	        if (isEndLine(stream)) {
	          state.cursorHalf = 0;
	        }
	        return "atom";
	      }
	
	      // Variables
	      if (ch === "$") {
	        stream.next();
	        stream.eatWhile(/[\w-]/);
	        if (isEndLine(stream)) {
	          state.cursorHalf = 0;
	        }
	        return "variable-2";
	      }
	
	      // bang character for !important, !default, etc.
	      if (ch === "!") {
	        stream.next();
	        state.cursorHalf = 0;
	        return stream.match(/^[\w]+/) ? "keyword": "operator";
	      }
	
	      if (stream.match(opRegexp)){
	        if (isEndLine(stream)) {
	          state.cursorHalf = 0;
	        }
	        return "operator";
	      }
	
	      // attributes
	      if (stream.eatWhile(/[\w-]/)) {
	        if (isEndLine(stream)) {
	          state.cursorHalf = 0;
	        }
	        word = stream.current().toLowerCase();
	        if (valueKeywords.hasOwnProperty(word)) {
	          return "atom";
	        } else if (colorKeywords.hasOwnProperty(word)) {
	          return "keyword";
	        } else if (propertyKeywords.hasOwnProperty(word)) {
	          state.prevProp = stream.current().toLowerCase();
	          return "property";
	        } else {
	          return "tag";
	        }
	      }
	
	      //stream.eatSpace();
	      if (isEndLine(stream)) {
	        state.cursorHalf = 0;
	        return null;
	      }
	
	    } // else ends here
	
	    if (stream.match(opRegexp))
	      return "operator";
	
	    // If we haven't returned by now, we move 1 character
	    // and return an error
	    stream.next();
	    return null;
	  }
	
	  function tokenLexer(stream, state) {
	    if (stream.sol()) state.indentCount = 0;
	    var style = state.tokenizer(stream, state);
	    var current = stream.current();
	
	    if (current === "@return" || current === "}"){
	      dedent(state);
	    }
	
	    if (style !== null) {
	      var startOfToken = stream.pos - current.length;
	
	      var withCurrentIndent = startOfToken + (config.indentUnit * state.indentCount);
	
	      var newScopes = [];
	
	      for (var i = 0; i < state.scopes.length; i++) {
	        var scope = state.scopes[i];
	
	        if (scope.offset <= withCurrentIndent)
	          newScopes.push(scope);
	      }
	
	      state.scopes = newScopes;
	    }
	
	
	    return style;
	  }
	
	  return {
	    startState: function() {
	      return {
	        tokenizer: tokenBase,
	        scopes: [{offset: 0, type: "sass"}],
	        indentCount: 0,
	        cursorHalf: 0,  // cursor half tells us if cursor lies after (1)
	                        // or before (0) colon (well... more or less)
	        definedVars: [],
	        definedMixins: []
	      };
	    },
	    token: function(stream, state) {
	      var style = tokenLexer(stream, state);
	
	      state.lastToken = { style: style, content: stream.current() };
	
	      return style;
	    },
	
	    indent: function(state) {
	      return state.scopes[0].offset;
	    }
	  };
	}, "css");
	
	CodeMirror.defineMIME("text/x-sass", "sass");
	
	});


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/LICENSE
	
	// Stylus mode created by Dmitry Kiselyov http://git.io/AaRB
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(1));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  "use strict";
	
	  CodeMirror.defineMode("stylus", function(config) {
	    var indentUnit = config.indentUnit,
	        indentUnitString = '',
	        tagKeywords = keySet(tagKeywords_),
	        tagVariablesRegexp = /^(a|b|i|s|col|em)$/i,
	        propertyKeywords = keySet(propertyKeywords_),
	        nonStandardPropertyKeywords = keySet(nonStandardPropertyKeywords_),
	        valueKeywords = keySet(valueKeywords_),
	        colorKeywords = keySet(colorKeywords_),
	        documentTypes = keySet(documentTypes_),
	        documentTypesRegexp = wordRegexp(documentTypes_),
	        mediaFeatures = keySet(mediaFeatures_),
	        mediaTypes = keySet(mediaTypes_),
	        fontProperties = keySet(fontProperties_),
	        operatorsRegexp = /^\s*([.]{2,3}|&&|\|\||\*\*|[?!=:]?=|[-+*\/%<>]=?|\?:|\~)/,
	        wordOperatorKeywordsRegexp = wordRegexp(wordOperatorKeywords_),
	        blockKeywords = keySet(blockKeywords_),
	        vendorPrefixesRegexp = new RegExp(/^\-(moz|ms|o|webkit)-/i),
	        commonAtoms = keySet(commonAtoms_),
	        firstWordMatch = "",
	        states = {},
	        ch,
	        style,
	        type,
	        override;
	
	    while (indentUnitString.length < indentUnit) indentUnitString += ' ';
	
	    /**
	     * Tokenizers
	     */
	    function tokenBase(stream, state) {
	      firstWordMatch = stream.string.match(/(^[\w-]+\s*=\s*$)|(^\s*[\w-]+\s*=\s*[\w-])|(^\s*(\.|#|@|\$|\&|\[|\d|\+|::?|\{|\>|~|\/)?\s*[\w-]*([a-z0-9-]|\*|\/\*)(\(|,)?)/);
	      state.context.line.firstWord = firstWordMatch ? firstWordMatch[0].replace(/^\s*/, "") : "";
	      state.context.line.indent = stream.indentation();
	      ch = stream.peek();
	
	      // Line comment
	      if (stream.match("//")) {
	        stream.skipToEnd();
	        return ["comment", "comment"];
	      }
	      // Block comment
	      if (stream.match("/*")) {
	        state.tokenize = tokenCComment;
	        return tokenCComment(stream, state);
	      }
	      // String
	      if (ch == "\"" || ch == "'") {
	        stream.next();
	        state.tokenize = tokenString(ch);
	        return state.tokenize(stream, state);
	      }
	      // Def
	      if (ch == "@") {
	        stream.next();
	        stream.eatWhile(/[\w\\-]/);
	        return ["def", stream.current()];
	      }
	      // ID selector or Hex color
	      if (ch == "#") {
	        stream.next();
	        // Hex color
	        if (stream.match(/^[0-9a-f]{3}([0-9a-f]([0-9a-f]{2}){0,2})?\b(?!-)/i)) {
	          return ["atom", "atom"];
	        }
	        // ID selector
	        if (stream.match(/^[a-z][\w-]*/i)) {
	          return ["builtin", "hash"];
	        }
	      }
	      // Vendor prefixes
	      if (stream.match(vendorPrefixesRegexp)) {
	        return ["meta", "vendor-prefixes"];
	      }
	      // Numbers
	      if (stream.match(/^-?[0-9]?\.?[0-9]/)) {
	        stream.eatWhile(/[a-z%]/i);
	        return ["number", "unit"];
	      }
	      // !important|optional
	      if (ch == "!") {
	        stream.next();
	        return [stream.match(/^(important|optional)/i) ? "keyword": "operator", "important"];
	      }
	      // Class
	      if (ch == "." && stream.match(/^\.[a-z][\w-]*/i)) {
	        return ["qualifier", "qualifier"];
	      }
	      // url url-prefix domain regexp
	      if (stream.match(documentTypesRegexp)) {
	        if (stream.peek() == "(") state.tokenize = tokenParenthesized;
	        return ["property", "word"];
	      }
	      // Mixins / Functions
	      if (stream.match(/^[a-z][\w-]*\(/i)) {
	        stream.backUp(1);
	        return ["keyword", "mixin"];
	      }
	      // Block mixins
	      if (stream.match(/^(\+|-)[a-z][\w-]*\(/i)) {
	        stream.backUp(1);
	        return ["keyword", "block-mixin"];
	      }
	      // Parent Reference BEM naming
	      if (stream.string.match(/^\s*&/) && stream.match(/^[-_]+[a-z][\w-]*/)) {
	        return ["qualifier", "qualifier"];
	      }
	      // / Root Reference & Parent Reference
	      if (stream.match(/^(\/|&)(-|_|:|\.|#|[a-z])/)) {
	        stream.backUp(1);
	        return ["variable-3", "reference"];
	      }
	      if (stream.match(/^&{1}\s*$/)) {
	        return ["variable-3", "reference"];
	      }
	      // Word operator
	      if (stream.match(wordOperatorKeywordsRegexp)) {
	        return ["operator", "operator"];
	      }
	      // Word
	      if (stream.match(/^\$?[-_]*[a-z0-9]+[\w-]*/i)) {
	        // Variable
	        if (stream.match(/^(\.|\[)[\w-\'\"\]]+/i, false)) {
	          if (!wordIsTag(stream.current())) {
	            stream.match(/\./);
	            return ["variable-2", "variable-name"];
	          }
	        }
	        return ["variable-2", "word"];
	      }
	      // Operators
	      if (stream.match(operatorsRegexp)) {
	        return ["operator", stream.current()];
	      }
	      // Delimiters
	      if (/[:;,{}\[\]\(\)]/.test(ch)) {
	        stream.next();
	        return [null, ch];
	      }
	      // Non-detected items
	      stream.next();
	      return [null, null];
	    }
	
	    /**
	     * Token comment
	     */
	    function tokenCComment(stream, state) {
	      var maybeEnd = false, ch;
	      while ((ch = stream.next()) != null) {
	        if (maybeEnd && ch == "/") {
	          state.tokenize = null;
	          break;
	        }
	        maybeEnd = (ch == "*");
	      }
	      return ["comment", "comment"];
	    }
	
	    /**
	     * Token string
	     */
	    function tokenString(quote) {
	      return function(stream, state) {
	        var escaped = false, ch;
	        while ((ch = stream.next()) != null) {
	          if (ch == quote && !escaped) {
	            if (quote == ")") stream.backUp(1);
	            break;
	          }
	          escaped = !escaped && ch == "\\";
	        }
	        if (ch == quote || !escaped && quote != ")") state.tokenize = null;
	        return ["string", "string"];
	      };
	    }
	
	    /**
	     * Token parenthesized
	     */
	    function tokenParenthesized(stream, state) {
	      stream.next(); // Must be "("
	      if (!stream.match(/\s*[\"\')]/, false))
	        state.tokenize = tokenString(")");
	      else
	        state.tokenize = null;
	      return [null, "("];
	    }
	
	    /**
	     * Context management
	     */
	    function Context(type, indent, prev, line) {
	      this.type = type;
	      this.indent = indent;
	      this.prev = prev;
	      this.line = line || {firstWord: "", indent: 0};
	    }
	
	    function pushContext(state, stream, type, indent) {
	      indent = indent >= 0 ? indent : indentUnit;
	      state.context = new Context(type, stream.indentation() + indent, state.context);
	      return type;
	    }
	
	    function popContext(state, currentIndent) {
	      var contextIndent = state.context.indent - indentUnit;
	      currentIndent = currentIndent || false;
	      state.context = state.context.prev;
	      if (currentIndent) state.context.indent = contextIndent;
	      return state.context.type;
	    }
	
	    function pass(type, stream, state) {
	      return states[state.context.type](type, stream, state);
	    }
	
	    function popAndPass(type, stream, state, n) {
	      for (var i = n || 1; i > 0; i--)
	        state.context = state.context.prev;
	      return pass(type, stream, state);
	    }
	
	
	    /**
	     * Parser
	     */
	    function wordIsTag(word) {
	      return word.toLowerCase() in tagKeywords;
	    }
	
	    function wordIsProperty(word) {
	      word = word.toLowerCase();
	      return word in propertyKeywords || word in fontProperties;
	    }
	
	    function wordIsBlock(word) {
	      return word.toLowerCase() in blockKeywords;
	    }
	
	    function wordIsVendorPrefix(word) {
	      return word.toLowerCase().match(vendorPrefixesRegexp);
	    }
	
	    function wordAsValue(word) {
	      var wordLC = word.toLowerCase();
	      var override = "variable-2";
	      if (wordIsTag(word)) override = "tag";
	      else if (wordIsBlock(word)) override = "block-keyword";
	      else if (wordIsProperty(word)) override = "property";
	      else if (wordLC in valueKeywords || wordLC in commonAtoms) override = "atom";
	      else if (wordLC == "return" || wordLC in colorKeywords) override = "keyword";
	
	      // Font family
	      else if (word.match(/^[A-Z]/)) override = "string";
	      return override;
	    }
	
	    function typeIsBlock(type, stream) {
	      return ((endOfLine(stream) && (type == "{" || type == "]" || type == "hash" || type == "qualifier")) || type == "block-mixin");
	    }
	
	    function typeIsInterpolation(type, stream) {
	      return type == "{" && stream.match(/^\s*\$?[\w-]+/i, false);
	    }
	
	    function typeIsPseudo(type, stream) {
	      return type == ":" && stream.match(/^[a-z-]+/, false);
	    }
	
	    function startOfLine(stream) {
	      return stream.sol() || stream.string.match(new RegExp("^\\s*" + escapeRegExp(stream.current())));
	    }
	
	    function endOfLine(stream) {
	      return stream.eol() || stream.match(/^\s*$/, false);
	    }
	
	    function firstWordOfLine(line) {
	      var re = /^\s*[-_]*[a-z0-9]+[\w-]*/i;
	      var result = typeof line == "string" ? line.match(re) : line.string.match(re);
	      return result ? result[0].replace(/^\s*/, "") : "";
	    }
	
	
	    /**
	     * Block
	     */
	    states.block = function(type, stream, state) {
	      if ((type == "comment" && startOfLine(stream)) ||
	          (type == "," && endOfLine(stream)) ||
	          type == "mixin") {
	        return pushContext(state, stream, "block", 0);
	      }
	      if (typeIsInterpolation(type, stream)) {
	        return pushContext(state, stream, "interpolation");
	      }
	      if (endOfLine(stream) && type == "]") {
	        if (!/^\s*(\.|#|:|\[|\*|&)/.test(stream.string) && !wordIsTag(firstWordOfLine(stream))) {
	          return pushContext(state, stream, "block", 0);
	        }
	      }
	      if (typeIsBlock(type, stream)) {
	        return pushContext(state, stream, "block");
	      }
	      if (type == "}" && endOfLine(stream)) {
	        return pushContext(state, stream, "block", 0);
	      }
	      if (type == "variable-name") {
	        if (stream.string.match(/^\s?\$[\w-\.\[\]\'\"]+$/) || wordIsBlock(firstWordOfLine(stream))) {
	          return pushContext(state, stream, "variableName");
	        }
	        else {
	          return pushContext(state, stream, "variableName", 0);
	        }
	      }
	      if (type == "=") {
	        if (!endOfLine(stream) && !wordIsBlock(firstWordOfLine(stream))) {
	          return pushContext(state, stream, "block", 0);
	        }
	        return pushContext(state, stream, "block");
	      }
	      if (type == "*") {
	        if (endOfLine(stream) || stream.match(/\s*(,|\.|#|\[|:|{)/,false)) {
	          override = "tag";
	          return pushContext(state, stream, "block");
	        }
	      }
	      if (typeIsPseudo(type, stream)) {
	        return pushContext(state, stream, "pseudo");
	      }
	      if (/@(font-face|media|supports|(-moz-)?document)/.test(type)) {
	        return pushContext(state, stream, endOfLine(stream) ? "block" : "atBlock");
	      }
	      if (/@(-(moz|ms|o|webkit)-)?keyframes$/.test(type)) {
	        return pushContext(state, stream, "keyframes");
	      }
	      if (/@extends?/.test(type)) {
	        return pushContext(state, stream, "extend", 0);
	      }
	      if (type && type.charAt(0) == "@") {
	
	        // Property Lookup
	        if (stream.indentation() > 0 && wordIsProperty(stream.current().slice(1))) {
	          override = "variable-2";
	          return "block";
	        }
	        if (/(@import|@require|@charset)/.test(type)) {
	          return pushContext(state, stream, "block", 0);
	        }
	        return pushContext(state, stream, "block");
	      }
	      if (type == "reference" && endOfLine(stream)) {
	        return pushContext(state, stream, "block");
	      }
	      if (type == "(") {
	        return pushContext(state, stream, "parens");
	      }
	
	      if (type == "vendor-prefixes") {
	        return pushContext(state, stream, "vendorPrefixes");
	      }
	      if (type == "word") {
	        var word = stream.current();
	        override = wordAsValue(word);
	
	        if (override == "property") {
	          if (startOfLine(stream)) {
	            return pushContext(state, stream, "block", 0);
	          } else {
	            override = "atom";
	            return "block";
	          }
	        }
	
	        if (override == "tag") {
	
	          // tag is a css value
	          if (/embed|menu|pre|progress|sub|table/.test(word)) {
	            if (wordIsProperty(firstWordOfLine(stream))) {
	              override = "atom";
	              return "block";
	            }
	          }
	
	          // tag is an attribute
	          if (stream.string.match(new RegExp("\\[\\s*" + word + "|" + word +"\\s*\\]"))) {
	            override = "atom";
	            return "block";
	          }
	
	          // tag is a variable
	          if (tagVariablesRegexp.test(word)) {
	            if ((startOfLine(stream) && stream.string.match(/=/)) ||
	                (!startOfLine(stream) &&
	                 !stream.string.match(/^(\s*\.|#|\&|\[|\/|>|\*)/) &&
	                 !wordIsTag(firstWordOfLine(stream)))) {
	              override = "variable-2";
	              if (wordIsBlock(firstWordOfLine(stream)))  return "block";
	              return pushContext(state, stream, "block", 0);
	            }
	          }
	
	          if (endOfLine(stream)) return pushContext(state, stream, "block");
	        }
	        if (override == "block-keyword") {
	          override = "keyword";
	
	          // Postfix conditionals
	          if (stream.current(/(if|unless)/) && !startOfLine(stream)) {
	            return "block";
	          }
	          return pushContext(state, stream, "block");
	        }
	        if (word == "return") return pushContext(state, stream, "block", 0);
	
	        // Placeholder selector
	        if (override == "variable-2" && stream.string.match(/^\s?\$[\w-\.\[\]\'\"]+$/)) {
	          return pushContext(state, stream, "block");
	        }
	      }
	      return state.context.type;
	    };
	
	
	    /**
	     * Parens
	     */
	    states.parens = function(type, stream, state) {
	      if (type == "(") return pushContext(state, stream, "parens");
	      if (type == ")") {
	        if (state.context.prev.type == "parens") {
	          return popContext(state);
	        }
	        if ((stream.string.match(/^[a-z][\w-]*\(/i) && endOfLine(stream)) ||
	            wordIsBlock(firstWordOfLine(stream)) ||
	            /(\.|#|:|\[|\*|&|>|~|\+|\/)/.test(firstWordOfLine(stream)) ||
	            (!stream.string.match(/^-?[a-z][\w-\.\[\]\'\"]*\s*=/) &&
	             wordIsTag(firstWordOfLine(stream)))) {
	          return pushContext(state, stream, "block");
	        }
	        if (stream.string.match(/^[\$-]?[a-z][\w-\.\[\]\'\"]*\s*=/) ||
	            stream.string.match(/^\s*(\(|\)|[0-9])/) ||
	            stream.string.match(/^\s+[a-z][\w-]*\(/i) ||
	            stream.string.match(/^\s+[\$-]?[a-z]/i)) {
	          return pushContext(state, stream, "block", 0);
	        }
	        if (endOfLine(stream)) return pushContext(state, stream, "block");
	        else return pushContext(state, stream, "block", 0);
	      }
	      if (type && type.charAt(0) == "@" && wordIsProperty(stream.current().slice(1))) {
	        override = "variable-2";
	      }
	      if (type == "word") {
	        var word = stream.current();
	        override = wordAsValue(word);
	        if (override == "tag" && tagVariablesRegexp.test(word)) {
	          override = "variable-2";
	        }
	        if (override == "property" || word == "to") override = "atom";
	      }
	      if (type == "variable-name") {
	        return pushContext(state, stream, "variableName");
	      }
	      if (typeIsPseudo(type, stream)) {
	        return pushContext(state, stream, "pseudo");
	      }
	      return state.context.type;
	    };
	
	
	    /**
	     * Vendor prefixes
	     */
	    states.vendorPrefixes = function(type, stream, state) {
	      if (type == "word") {
	        override = "property";
	        return pushContext(state, stream, "block", 0);
	      }
	      return popContext(state);
	    };
	
	
	    /**
	     * Pseudo
	     */
	    states.pseudo = function(type, stream, state) {
	      if (!wordIsProperty(firstWordOfLine(stream.string))) {
	        stream.match(/^[a-z-]+/);
	        override = "variable-3";
	        if (endOfLine(stream)) return pushContext(state, stream, "block");
	        return popContext(state);
	      }
	      return popAndPass(type, stream, state);
	    };
	
	
	    /**
	     * atBlock
	     */
	    states.atBlock = function(type, stream, state) {
	      if (type == "(") return pushContext(state, stream, "atBlock_parens");
	      if (typeIsBlock(type, stream)) {
	        return pushContext(state, stream, "block");
	      }
	      if (typeIsInterpolation(type, stream)) {
	        return pushContext(state, stream, "interpolation");
	      }
	      if (type == "word") {
	        var word = stream.current().toLowerCase();
	        if (/^(only|not|and|or)$/.test(word))
	          override = "keyword";
	        else if (documentTypes.hasOwnProperty(word))
	          override = "tag";
	        else if (mediaTypes.hasOwnProperty(word))
	          override = "attribute";
	        else if (mediaFeatures.hasOwnProperty(word))
	          override = "property";
	        else if (nonStandardPropertyKeywords.hasOwnProperty(word))
	          override = "string-2";
	        else override = wordAsValue(stream.current());
	        if (override == "tag" && endOfLine(stream)) {
	          return pushContext(state, stream, "block");
	        }
	      }
	      if (type == "operator" && /^(not|and|or)$/.test(stream.current())) {
	        override = "keyword";
	      }
	      return state.context.type;
	    };
	
	    states.atBlock_parens = function(type, stream, state) {
	      if (type == "{" || type == "}") return state.context.type;
	      if (type == ")") {
	        if (endOfLine(stream)) return pushContext(state, stream, "block");
	        else return pushContext(state, stream, "atBlock");
	      }
	      if (type == "word") {
	        var word = stream.current().toLowerCase();
	        override = wordAsValue(word);
	        if (/^(max|min)/.test(word)) override = "property";
	        if (override == "tag") {
	          tagVariablesRegexp.test(word) ? override = "variable-2" : override = "atom";
	        }
	        return state.context.type;
	      }
	      return states.atBlock(type, stream, state);
	    };
	
	
	    /**
	     * Keyframes
	     */
	    states.keyframes = function(type, stream, state) {
	      if (stream.indentation() == "0" && ((type == "}" && startOfLine(stream)) || type == "]" || type == "hash"
	                                          || type == "qualifier" || wordIsTag(stream.current()))) {
	        return popAndPass(type, stream, state);
	      }
	      if (type == "{") return pushContext(state, stream, "keyframes");
	      if (type == "}") {
	        if (startOfLine(stream)) return popContext(state, true);
	        else return pushContext(state, stream, "keyframes");
	      }
	      if (type == "unit" && /^[0-9]+\%$/.test(stream.current())) {
	        return pushContext(state, stream, "keyframes");
	      }
	      if (type == "word") {
	        override = wordAsValue(stream.current());
	        if (override == "block-keyword") {
	          override = "keyword";
	          return pushContext(state, stream, "keyframes");
	        }
	      }
	      if (/@(font-face|media|supports|(-moz-)?document)/.test(type)) {
	        return pushContext(state, stream, endOfLine(stream) ? "block" : "atBlock");
	      }
	      if (type == "mixin") {
	        return pushContext(state, stream, "block", 0);
	      }
	      return state.context.type;
	    };
	
	
	    /**
	     * Interpolation
	     */
	    states.interpolation = function(type, stream, state) {
	      if (type == "{") popContext(state) && pushContext(state, stream, "block");
	      if (type == "}") {
	        if (stream.string.match(/^\s*(\.|#|:|\[|\*|&|>|~|\+|\/)/i) ||
	            (stream.string.match(/^\s*[a-z]/i) && wordIsTag(firstWordOfLine(stream)))) {
	          return pushContext(state, stream, "block");
	        }
	        if (!stream.string.match(/^(\{|\s*\&)/) ||
	            stream.match(/\s*[\w-]/,false)) {
	          return pushContext(state, stream, "block", 0);
	        }
	        return pushContext(state, stream, "block");
	      }
	      if (type == "variable-name") {
	        return pushContext(state, stream, "variableName", 0);
	      }
	      if (type == "word") {
	        override = wordAsValue(stream.current());
	        if (override == "tag") override = "atom";
	      }
	      return state.context.type;
	    };
	
	
	    /**
	     * Extend/s
	     */
	    states.extend = function(type, stream, state) {
	      if (type == "[" || type == "=") return "extend";
	      if (type == "]") return popContext(state);
	      if (type == "word") {
	        override = wordAsValue(stream.current());
	        return "extend";
	      }
	      return popContext(state);
	    };
	
	
	    /**
	     * Variable name
	     */
	    states.variableName = function(type, stream, state) {
	      if (type == "string" || type == "[" || type == "]" || stream.current().match(/^(\.|\$)/)) {
	        if (stream.current().match(/^\.[\w-]+/i)) override = "variable-2";
	        return "variableName";
	      }
	      return popAndPass(type, stream, state);
	    };
	
	
	    return {
	      startState: function(base) {
	        return {
	          tokenize: null,
	          state: "block",
	          context: new Context("block", base || 0, null)
	        };
	      },
	      token: function(stream, state) {
	        if (!state.tokenize && stream.eatSpace()) return null;
	        style = (state.tokenize || tokenBase)(stream, state);
	        if (style && typeof style == "object") {
	          type = style[1];
	          style = style[0];
	        }
	        override = style;
	        state.state = states[state.state](type, stream, state);
	        return override;
	      },
	      indent: function(state, textAfter, line) {
	
	        var cx = state.context,
	            ch = textAfter && textAfter.charAt(0),
	            indent = cx.indent,
	            lineFirstWord = firstWordOfLine(textAfter),
	            lineIndent = line.match(/^\s*/)[0].replace(/\t/g, indentUnitString).length,
	            prevLineFirstWord = state.context.prev ? state.context.prev.line.firstWord : "",
	            prevLineIndent = state.context.prev ? state.context.prev.line.indent : lineIndent;
	
	        if (cx.prev &&
	            (ch == "}" && (cx.type == "block" || cx.type == "atBlock" || cx.type == "keyframes") ||
	             ch == ")" && (cx.type == "parens" || cx.type == "atBlock_parens") ||
	             ch == "{" && (cx.type == "at"))) {
	          indent = cx.indent - indentUnit;
	        } else if (!(/(\})/.test(ch))) {
	          if (/@|\$|\d/.test(ch) ||
	              /^\{/.test(textAfter) ||
	/^\s*\/(\/|\*)/.test(textAfter) ||
	              /^\s*\/\*/.test(prevLineFirstWord) ||
	              /^\s*[\w-\.\[\]\'\"]+\s*(\?|:|\+)?=/i.test(textAfter) ||
	/^(\+|-)?[a-z][\w-]*\(/i.test(textAfter) ||
	/^return/.test(textAfter) ||
	              wordIsBlock(lineFirstWord)) {
	            indent = lineIndent;
	          } else if (/(\.|#|:|\[|\*|&|>|~|\+|\/)/.test(ch) || wordIsTag(lineFirstWord)) {
	            if (/\,\s*$/.test(prevLineFirstWord)) {
	              indent = prevLineIndent;
	            } else if (/^\s+/.test(line) && (/(\.|#|:|\[|\*|&|>|~|\+|\/)/.test(prevLineFirstWord) || wordIsTag(prevLineFirstWord))) {
	              indent = lineIndent <= prevLineIndent ? prevLineIndent : prevLineIndent + indentUnit;
	            } else {
	              indent = lineIndent;
	            }
	          } else if (!/,\s*$/.test(line) && (wordIsVendorPrefix(lineFirstWord) || wordIsProperty(lineFirstWord))) {
	            if (wordIsBlock(prevLineFirstWord)) {
	              indent = lineIndent <= prevLineIndent ? prevLineIndent : prevLineIndent + indentUnit;
	            } else if (/^\{/.test(prevLineFirstWord)) {
	              indent = lineIndent <= prevLineIndent ? lineIndent : prevLineIndent + indentUnit;
	            } else if (wordIsVendorPrefix(prevLineFirstWord) || wordIsProperty(prevLineFirstWord)) {
	              indent = lineIndent >= prevLineIndent ? prevLineIndent : lineIndent;
	            } else if (/^(\.|#|:|\[|\*|&|@|\+|\-|>|~|\/)/.test(prevLineFirstWord) ||
	                      /=\s*$/.test(prevLineFirstWord) ||
	                      wordIsTag(prevLineFirstWord) ||
	                      /^\$[\w-\.\[\]\'\"]/.test(prevLineFirstWord)) {
	              indent = prevLineIndent + indentUnit;
	            } else {
	              indent = lineIndent;
	            }
	          }
	        }
	        return indent;
	      },
	      electricChars: "}",
	      lineComment: "//",
	      fold: "indent"
	    };
	  });
	
	  // developer.mozilla.org/en-US/docs/Web/HTML/Element
	  var tagKeywords_ = ["a","abbr","address","area","article","aside","audio", "b", "base","bdi", "bdo","bgsound","blockquote","body","br","button","canvas","caption","cite", "code","col","colgroup","data","datalist","dd","del","details","dfn","div", "dl","dt","em","embed","fieldset","figcaption","figure","footer","form","h1", "h2","h3","h4","h5","h6","head","header","hgroup","hr","html","i","iframe", "img","input","ins","kbd","keygen","label","legend","li","link","main","map", "mark","marquee","menu","menuitem","meta","meter","nav","nobr","noframes", "noscript","object","ol","optgroup","option","output","p","param","pre", "progress","q","rp","rt","ruby","s","samp","script","section","select", "small","source","span","strong","style","sub","summary","sup","table","tbody","td","textarea","tfoot","th","thead","time","tr","track", "u","ul","var","video"];
	
	  // github.com/codemirror/CodeMirror/blob/master/mode/css/css.js
	  var documentTypes_ = ["domain", "regexp", "url", "url-prefix"];
	  var mediaTypes_ = ["all","aural","braille","handheld","print","projection","screen","tty","tv","embossed"];
	  var mediaFeatures_ = ["width","min-width","max-width","height","min-height","max-height","device-width","min-device-width","max-device-width","device-height","min-device-height","max-device-height","aspect-ratio","min-aspect-ratio","max-aspect-ratio","device-aspect-ratio","min-device-aspect-ratio","max-device-aspect-ratio","color","min-color","max-color","color-index","min-color-index","max-color-index","monochrome","min-monochrome","max-monochrome","resolution","min-resolution","max-resolution","scan","grid"];
	  var propertyKeywords_ = ["align-content","align-items","align-self","alignment-adjust","alignment-baseline","anchor-point","animation","animation-delay","animation-direction","animation-duration","animation-fill-mode","animation-iteration-count","animation-name","animation-play-state","animation-timing-function","appearance","azimuth","backface-visibility","background","background-attachment","background-clip","background-color","background-image","background-origin","background-position","background-repeat","background-size","baseline-shift","binding","bleed","bookmark-label","bookmark-level","bookmark-state","bookmark-target","border","border-bottom","border-bottom-color","border-bottom-left-radius","border-bottom-right-radius","border-bottom-style","border-bottom-width","border-collapse","border-color","border-image","border-image-outset","border-image-repeat","border-image-slice","border-image-source","border-image-width","border-left","border-left-color","border-left-style","border-left-width","border-radius","border-right","border-right-color","border-right-style","border-right-width","border-spacing","border-style","border-top","border-top-color","border-top-left-radius","border-top-right-radius","border-top-style","border-top-width","border-width","bottom","box-decoration-break","box-shadow","box-sizing","break-after","break-before","break-inside","caption-side","clear","clip","color","color-profile","column-count","column-fill","column-gap","column-rule","column-rule-color","column-rule-style","column-rule-width","column-span","column-width","columns","content","counter-increment","counter-reset","crop","cue","cue-after","cue-before","cursor","direction","display","dominant-baseline","drop-initial-after-adjust","drop-initial-after-align","drop-initial-before-adjust","drop-initial-before-align","drop-initial-size","drop-initial-value","elevation","empty-cells","fit","fit-position","flex","flex-basis","flex-direction","flex-flow","flex-grow","flex-shrink","flex-wrap","float","float-offset","flow-from","flow-into","font","font-feature-settings","font-family","font-kerning","font-language-override","font-size","font-size-adjust","font-stretch","font-style","font-synthesis","font-variant","font-variant-alternates","font-variant-caps","font-variant-east-asian","font-variant-ligatures","font-variant-numeric","font-variant-position","font-weight","grid","grid-area","grid-auto-columns","grid-auto-flow","grid-auto-position","grid-auto-rows","grid-column","grid-column-end","grid-column-start","grid-row","grid-row-end","grid-row-start","grid-template","grid-template-areas","grid-template-columns","grid-template-rows","hanging-punctuation","height","hyphens","icon","image-orientation","image-rendering","image-resolution","inline-box-align","justify-content","left","letter-spacing","line-break","line-height","line-stacking","line-stacking-ruby","line-stacking-shift","line-stacking-strategy","list-style","list-style-image","list-style-position","list-style-type","margin","margin-bottom","margin-left","margin-right","margin-top","marker-offset","marks","marquee-direction","marquee-loop","marquee-play-count","marquee-speed","marquee-style","max-height","max-width","min-height","min-width","move-to","nav-down","nav-index","nav-left","nav-right","nav-up","object-fit","object-position","opacity","order","orphans","outline","outline-color","outline-offset","outline-style","outline-width","overflow","overflow-style","overflow-wrap","overflow-x","overflow-y","padding","padding-bottom","padding-left","padding-right","padding-top","page","page-break-after","page-break-before","page-break-inside","page-policy","pause","pause-after","pause-before","perspective","perspective-origin","pitch","pitch-range","play-during","position","presentation-level","punctuation-trim","quotes","region-break-after","region-break-before","region-break-inside","region-fragment","rendering-intent","resize","rest","rest-after","rest-before","richness","right","rotation","rotation-point","ruby-align","ruby-overhang","ruby-position","ruby-span","shape-image-threshold","shape-inside","shape-margin","shape-outside","size","speak","speak-as","speak-header","speak-numeral","speak-punctuation","speech-rate","stress","string-set","tab-size","table-layout","target","target-name","target-new","target-position","text-align","text-align-last","text-decoration","text-decoration-color","text-decoration-line","text-decoration-skip","text-decoration-style","text-emphasis","text-emphasis-color","text-emphasis-position","text-emphasis-style","text-height","text-indent","text-justify","text-outline","text-overflow","text-shadow","text-size-adjust","text-space-collapse","text-transform","text-underline-position","text-wrap","top","transform","transform-origin","transform-style","transition","transition-delay","transition-duration","transition-property","transition-timing-function","unicode-bidi","vertical-align","visibility","voice-balance","voice-duration","voice-family","voice-pitch","voice-range","voice-rate","voice-stress","voice-volume","volume","white-space","widows","width","will-change","word-break","word-spacing","word-wrap","z-index","clip-path","clip-rule","mask","enable-background","filter","flood-color","flood-opacity","lighting-color","stop-color","stop-opacity","pointer-events","color-interpolation","color-interpolation-filters","color-rendering","fill","fill-opacity","fill-rule","image-rendering","marker","marker-end","marker-mid","marker-start","shape-rendering","stroke","stroke-dasharray","stroke-dashoffset","stroke-linecap","stroke-linejoin","stroke-miterlimit","stroke-opacity","stroke-width","text-rendering","baseline-shift","dominant-baseline","glyph-orientation-horizontal","glyph-orientation-vertical","text-anchor","writing-mode","font-smoothing","osx-font-smoothing"];
	  var nonStandardPropertyKeywords_ = ["scrollbar-arrow-color","scrollbar-base-color","scrollbar-dark-shadow-color","scrollbar-face-color","scrollbar-highlight-color","scrollbar-shadow-color","scrollbar-3d-light-color","scrollbar-track-color","shape-inside","searchfield-cancel-button","searchfield-decoration","searchfield-results-button","searchfield-results-decoration","zoom"];
	  var fontProperties_ = ["font-family","src","unicode-range","font-variant","font-feature-settings","font-stretch","font-weight","font-style"];
	  var colorKeywords_ = ["aliceblue","antiquewhite","aqua","aquamarine","azure","beige","bisque","black","blanchedalmond","blue","blueviolet","brown","burlywood","cadetblue","chartreuse","chocolate","coral","cornflowerblue","cornsilk","crimson","cyan","darkblue","darkcyan","darkgoldenrod","darkgray","darkgreen","darkkhaki","darkmagenta","darkolivegreen","darkorange","darkorchid","darkred","darksalmon","darkseagreen","darkslateblue","darkslategray","darkturquoise","darkviolet","deeppink","deepskyblue","dimgray","dodgerblue","firebrick","floralwhite","forestgreen","fuchsia","gainsboro","ghostwhite","gold","goldenrod","gray","grey","green","greenyellow","honeydew","hotpink","indianred","indigo","ivory","khaki","lavender","lavenderblush","lawngreen","lemonchiffon","lightblue","lightcoral","lightcyan","lightgoldenrodyellow","lightgray","lightgreen","lightpink","lightsalmon","lightseagreen","lightskyblue","lightslategray","lightsteelblue","lightyellow","lime","limegreen","linen","magenta","maroon","mediumaquamarine","mediumblue","mediumorchid","mediumpurple","mediumseagreen","mediumslateblue","mediumspringgreen","mediumturquoise","mediumvioletred","midnightblue","mintcream","mistyrose","moccasin","navajowhite","navy","oldlace","olive","olivedrab","orange","orangered","orchid","palegoldenrod","palegreen","paleturquoise","palevioletred","papayawhip","peachpuff","peru","pink","plum","powderblue","purple","rebeccapurple","red","rosybrown","royalblue","saddlebrown","salmon","sandybrown","seagreen","seashell","sienna","silver","skyblue","slateblue","slategray","snow","springgreen","steelblue","tan","teal","thistle","tomato","turquoise","violet","wheat","white","whitesmoke","yellow","yellowgreen"];
	  var valueKeywords_ = ["above","absolute","activeborder","additive","activecaption","afar","after-white-space","ahead","alias","all","all-scroll","alphabetic","alternate","always","amharic","amharic-abegede","antialiased","appworkspace","arabic-indic","armenian","asterisks","attr","auto","avoid","avoid-column","avoid-page","avoid-region","background","backwards","baseline","below","bidi-override","binary","bengali","blink","block","block-axis","bold","bolder","border","border-box","both","bottom","break","break-all","break-word","bullets","button","button-bevel","buttonface","buttonhighlight","buttonshadow","buttontext","calc","cambodian","capitalize","caps-lock-indicator","caption","captiontext","caret","cell","center","checkbox","circle","cjk-decimal","cjk-earthly-branch","cjk-heavenly-stem","cjk-ideographic","clear","clip","close-quote","col-resize","collapse","column","compact","condensed","contain","content","contents","content-box","context-menu","continuous","copy","counter","counters","cover","crop","cross","crosshair","currentcolor","cursive","cyclic","dashed","decimal","decimal-leading-zero","default","default-button","destination-atop","destination-in","destination-out","destination-over","devanagari","disc","discard","disclosure-closed","disclosure-open","document","dot-dash","dot-dot-dash","dotted","double","down","e-resize","ease","ease-in","ease-in-out","ease-out","element","ellipse","ellipsis","embed","end","ethiopic","ethiopic-abegede","ethiopic-abegede-am-et","ethiopic-abegede-gez","ethiopic-abegede-ti-er","ethiopic-abegede-ti-et","ethiopic-halehame-aa-er","ethiopic-halehame-aa-et","ethiopic-halehame-am-et","ethiopic-halehame-gez","ethiopic-halehame-om-et","ethiopic-halehame-sid-et","ethiopic-halehame-so-et","ethiopic-halehame-ti-er","ethiopic-halehame-ti-et","ethiopic-halehame-tig","ethiopic-numeric","ew-resize","expanded","extends","extra-condensed","extra-expanded","fantasy","fast","fill","fixed","flat","flex","footnotes","forwards","from","geometricPrecision","georgian","graytext","groove","gujarati","gurmukhi","hand","hangul","hangul-consonant","hebrew","help","hidden","hide","higher","highlight","highlighttext","hiragana","hiragana-iroha","horizontal","hsl","hsla","icon","ignore","inactiveborder","inactivecaption","inactivecaptiontext","infinite","infobackground","infotext","inherit","initial","inline","inline-axis","inline-block","inline-flex","inline-table","inset","inside","intrinsic","invert","italic","japanese-formal","japanese-informal","justify","kannada","katakana","katakana-iroha","keep-all","khmer","korean-hangul-formal","korean-hanja-formal","korean-hanja-informal","landscape","lao","large","larger","left","level","lighter","line-through","linear","linear-gradient","lines","list-item","listbox","listitem","local","logical","loud","lower","lower-alpha","lower-armenian","lower-greek","lower-hexadecimal","lower-latin","lower-norwegian","lower-roman","lowercase","ltr","malayalam","match","matrix","matrix3d","media-controls-background","media-current-time-display","media-fullscreen-button","media-mute-button","media-play-button","media-return-to-realtime-button","media-rewind-button","media-seek-back-button","media-seek-forward-button","media-slider","media-sliderthumb","media-time-remaining-display","media-volume-slider","media-volume-slider-container","media-volume-sliderthumb","medium","menu","menulist","menulist-button","menulist-text","menulist-textfield","menutext","message-box","middle","min-intrinsic","mix","mongolian","monospace","move","multiple","myanmar","n-resize","narrower","ne-resize","nesw-resize","no-close-quote","no-drop","no-open-quote","no-repeat","none","normal","not-allowed","nowrap","ns-resize","numbers","numeric","nw-resize","nwse-resize","oblique","octal","open-quote","optimizeLegibility","optimizeSpeed","oriya","oromo","outset","outside","outside-shape","overlay","overline","padding","padding-box","painted","page","paused","persian","perspective","plus-darker","plus-lighter","pointer","polygon","portrait","pre","pre-line","pre-wrap","preserve-3d","progress","push-button","radial-gradient","radio","read-only","read-write","read-write-plaintext-only","rectangle","region","relative","repeat","repeating-linear-gradient","repeating-radial-gradient","repeat-x","repeat-y","reset","reverse","rgb","rgba","ridge","right","rotate","rotate3d","rotateX","rotateY","rotateZ","round","row-resize","rtl","run-in","running","s-resize","sans-serif","scale","scale3d","scaleX","scaleY","scaleZ","scroll","scrollbar","scroll-position","se-resize","searchfield","searchfield-cancel-button","searchfield-decoration","searchfield-results-button","searchfield-results-decoration","semi-condensed","semi-expanded","separate","serif","show","sidama","simp-chinese-formal","simp-chinese-informal","single","skew","skewX","skewY","skip-white-space","slide","slider-horizontal","slider-vertical","sliderthumb-horizontal","sliderthumb-vertical","slow","small","small-caps","small-caption","smaller","solid","somali","source-atop","source-in","source-out","source-over","space","spell-out","square","square-button","start","static","status-bar","stretch","stroke","sub","subpixel-antialiased","super","sw-resize","symbolic","symbols","table","table-caption","table-cell","table-column","table-column-group","table-footer-group","table-header-group","table-row","table-row-group","tamil","telugu","text","text-bottom","text-top","textarea","textfield","thai","thick","thin","threeddarkshadow","threedface","threedhighlight","threedlightshadow","threedshadow","tibetan","tigre","tigrinya-er","tigrinya-er-abegede","tigrinya-et","tigrinya-et-abegede","to","top","trad-chinese-formal","trad-chinese-informal","translate","translate3d","translateX","translateY","translateZ","transparent","ultra-condensed","ultra-expanded","underline","up","upper-alpha","upper-armenian","upper-greek","upper-hexadecimal","upper-latin","upper-norwegian","upper-roman","uppercase","urdu","url","var","vertical","vertical-text","visible","visibleFill","visiblePainted","visibleStroke","visual","w-resize","wait","wave","wider","window","windowframe","windowtext","words","x-large","x-small","xor","xx-large","xx-small","bicubic","optimizespeed","grayscale","row","row-reverse","wrap","wrap-reverse","column-reverse","flex-start","flex-end","space-between","space-around", "unset"];
	
	  var wordOperatorKeywords_ = ["in","and","or","not","is not","is a","is","isnt","defined","if unless"],
	      blockKeywords_ = ["for","if","else","unless", "from", "to"],
	      commonAtoms_ = ["null","true","false","href","title","type","not-allowed","readonly","disabled"],
	      commonDef_ = ["@font-face", "@keyframes", "@media", "@viewport", "@page", "@host", "@supports", "@block", "@css"];
	
	  var hintWords = tagKeywords_.concat(documentTypes_,mediaTypes_,mediaFeatures_,
	                                      propertyKeywords_,nonStandardPropertyKeywords_,
	                                      colorKeywords_,valueKeywords_,fontProperties_,
	                                      wordOperatorKeywords_,blockKeywords_,
	                                      commonAtoms_,commonDef_);
	
	  function wordRegexp(words) {
	    words = words.sort(function(a,b){return b > a;});
	    return new RegExp("^((" + words.join(")|(") + "))\\b");
	  }
	
	  function keySet(array) {
	    var keys = {};
	    for (var i = 0; i < array.length; ++i) keys[array[i]] = true;
	    return keys;
	  }
	
	  function escapeRegExp(text) {
	    return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
	  }
	
	  CodeMirror.registerHelper("hintWords", "stylus", hintWords);
	  CodeMirror.defineMIME("text/x-styl", "stylus");
	});


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var dP = __webpack_require__(37).f;
	var create = __webpack_require__(86);
	var redefineAll = __webpack_require__(87);
	var ctx = __webpack_require__(41);
	var anInstance = __webpack_require__(84);
	var forOf = __webpack_require__(58);
	var $iterDefine = __webpack_require__(110);
	var step = __webpack_require__(162);
	var setSpecies = __webpack_require__(169);
	var DESCRIPTORS = __webpack_require__(33);
	var fastKey = __webpack_require__(73).fastKey;
	var validate = __webpack_require__(61);
	var SIZE = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function (that, key) {
	  // fast case
	  var index = fastKey(key);
	  var entry;
	  if (index !== 'F') return that._i[index];
	  // frozen object case
	  for (entry = that._f; entry; entry = entry.n) {
	    if (entry.k == key) return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;         // collection type
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear() {
	        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
	          entry.r = true;
	          if (entry.p) entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function (key) {
	        var that = validate(this, NAME);
	        var entry = getEntry(that, key);
	        if (entry) {
	          var next = entry.n;
	          var prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if (prev) prev.n = next;
	          if (next) next.p = prev;
	          if (that._f == entry) that._f = next;
	          if (that._l == entry) that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /* , that = undefined */) {
	        validate(this, NAME);
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	        var entry;
	        while (entry = entry ? entry.n : this._f) {
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while (entry && entry.r) entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key) {
	        return !!getEntry(validate(this, NAME), key);
	      }
	    });
	    if (DESCRIPTORS) dP(C.prototype, 'size', {
	      get: function () {
	        return validate(this, NAME)[SIZE];
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var entry = getEntry(that, key);
	    var prev, index;
	    // change existing entry
	    if (entry) {
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if (!that._f) that._f = entry;
	      if (prev) prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if (index !== 'F') that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function (C, NAME, IS_MAP) {
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function (iterated, kind) {
	      this._t = validate(iterated, NAME); // target
	      this._k = kind;                     // kind
	      this._l = undefined;                // previous
	    }, function () {
	      var that = this;
	      var kind = that._k;
	      var entry = that._l;
	      // revert to the last existing entry
	      while (entry && entry.r) entry = entry.p;
	      // get next entry
	      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if (kind == 'keys') return step(0, entry.k);
	      if (kind == 'values') return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(85);
	var from = __webpack_require__(334);
	module.exports = function (NAME) {
	  return function toJSON() {
	    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(17).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(33) && !__webpack_require__(50)(function () {
	  return Object.defineProperty(__webpack_require__(107)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(59);
	var ITERATOR = __webpack_require__(19)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(71);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(36);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(19)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 162 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = __webpack_require__(33);
	var getKeys = __webpack_require__(60);
	var gOPS = __webpack_require__(113);
	var pIE = __webpack_require__(74);
	var toObject = __webpack_require__(51);
	var IObject = __webpack_require__(109);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(50)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(166);
	var hiddenKeys = __webpack_require__(108).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(45);
	var toObject = __webpack_require__(51);
	var IE_PROTO = __webpack_require__(118)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(45);
	var toIObject = __webpack_require__(47);
	var arrayIndexOf = __webpack_require__(335)(false);
	var IE_PROTO = __webpack_require__(118)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 167 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(36);
	var isObject = __webpack_require__(27);
	var newPromiseCapability = __webpack_require__(111);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(17);
	var core = __webpack_require__(4);
	var dP = __webpack_require__(37);
	var DESCRIPTORS = __webpack_require__(33);
	var SPECIES = __webpack_require__(19)('species');
	
	module.exports = function (KEY) {
	  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(36);
	var aFunction = __webpack_require__(70);
	var SPECIES = __webpack_require__(19)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(41);
	var invoke = __webpack_require__(341);
	var html = __webpack_require__(156);
	var cel = __webpack_require__(107);
	var global = __webpack_require__(17);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(71)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(17);
	var has = __webpack_require__(45);
	var DESCRIPTORS = __webpack_require__(33);
	var $export = __webpack_require__(14);
	var redefine = __webpack_require__(115);
	var META = __webpack_require__(73).KEY;
	var $fails = __webpack_require__(50);
	var shared = __webpack_require__(119);
	var setToStringTag = __webpack_require__(76);
	var uid = __webpack_require__(89);
	var wks = __webpack_require__(19);
	var wksExt = __webpack_require__(123);
	var wksDefine = __webpack_require__(122);
	var enumKeys = __webpack_require__(340);
	var isArray = __webpack_require__(159);
	var anObject = __webpack_require__(36);
	var isObject = __webpack_require__(27);
	var toObject = __webpack_require__(51);
	var toIObject = __webpack_require__(47);
	var toPrimitive = __webpack_require__(121);
	var createDesc = __webpack_require__(75);
	var _create = __webpack_require__(86);
	var gOPNExt = __webpack_require__(345);
	var $GOPD = __webpack_require__(112);
	var $GOPS = __webpack_require__(113);
	var $DP = __webpack_require__(37);
	var $keys = __webpack_require__(60);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(164).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(74).f = $propertyIsEnumerable;
	  $GOPS.f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(72)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });
	
	$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    return $GOPS.f(toObject(it));
	  }
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(46)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory();
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define([], factory);
		}
		else {
			// Global (browser)
			root.CryptoJS = factory();
		}
	}(this, function () {
	
		/**
		 * CryptoJS core components.
		 */
		var CryptoJS = CryptoJS || (function (Math, undefined) {
		    /*
		     * Local polyfil of Object.create
		     */
		    var create = Object.create || (function () {
		        function F() {};
	
		        return function (obj) {
		            var subtype;
	
		            F.prototype = obj;
	
		            subtype = new F();
	
		            F.prototype = null;
	
		            return subtype;
		        };
		    }())
	
		    /**
		     * CryptoJS namespace.
		     */
		    var C = {};
	
		    /**
		     * Library namespace.
		     */
		    var C_lib = C.lib = {};
	
		    /**
		     * Base object for prototypal inheritance.
		     */
		    var Base = C_lib.Base = (function () {
	
	
		        return {
		            /**
		             * Creates a new object that inherits from this object.
		             *
		             * @param {Object} overrides Properties to copy into the new object.
		             *
		             * @return {Object} The new object.
		             *
		             * @static
		             *
		             * @example
		             *
		             *     var MyType = CryptoJS.lib.Base.extend({
		             *         field: 'value',
		             *
		             *         method: function () {
		             *         }
		             *     });
		             */
		            extend: function (overrides) {
		                // Spawn
		                var subtype = create(this);
	
		                // Augment
		                if (overrides) {
		                    subtype.mixIn(overrides);
		                }
	
		                // Create default initializer
		                if (!subtype.hasOwnProperty('init') || this.init === subtype.init) {
		                    subtype.init = function () {
		                        subtype.$super.init.apply(this, arguments);
		                    };
		                }
	
		                // Initializer's prototype is the subtype object
		                subtype.init.prototype = subtype;
	
		                // Reference supertype
		                subtype.$super = this;
	
		                return subtype;
		            },
	
		            /**
		             * Extends this object and runs the init method.
		             * Arguments to create() will be passed to init().
		             *
		             * @return {Object} The new object.
		             *
		             * @static
		             *
		             * @example
		             *
		             *     var instance = MyType.create();
		             */
		            create: function () {
		                var instance = this.extend();
		                instance.init.apply(instance, arguments);
	
		                return instance;
		            },
	
		            /**
		             * Initializes a newly created object.
		             * Override this method to add some logic when your objects are created.
		             *
		             * @example
		             *
		             *     var MyType = CryptoJS.lib.Base.extend({
		             *         init: function () {
		             *             // ...
		             *         }
		             *     });
		             */
		            init: function () {
		            },
	
		            /**
		             * Copies properties into this object.
		             *
		             * @param {Object} properties The properties to mix in.
		             *
		             * @example
		             *
		             *     MyType.mixIn({
		             *         field: 'value'
		             *     });
		             */
		            mixIn: function (properties) {
		                for (var propertyName in properties) {
		                    if (properties.hasOwnProperty(propertyName)) {
		                        this[propertyName] = properties[propertyName];
		                    }
		                }
	
		                // IE won't copy toString using the loop above
		                if (properties.hasOwnProperty('toString')) {
		                    this.toString = properties.toString;
		                }
		            },
	
		            /**
		             * Creates a copy of this object.
		             *
		             * @return {Object} The clone.
		             *
		             * @example
		             *
		             *     var clone = instance.clone();
		             */
		            clone: function () {
		                return this.init.prototype.extend(this);
		            }
		        };
		    }());
	
		    /**
		     * An array of 32-bit words.
		     *
		     * @property {Array} words The array of 32-bit words.
		     * @property {number} sigBytes The number of significant bytes in this word array.
		     */
		    var WordArray = C_lib.WordArray = Base.extend({
		        /**
		         * Initializes a newly created word array.
		         *
		         * @param {Array} words (Optional) An array of 32-bit words.
		         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.lib.WordArray.create();
		         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
		         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
		         */
		        init: function (words, sigBytes) {
		            words = this.words = words || [];
	
		            if (sigBytes != undefined) {
		                this.sigBytes = sigBytes;
		            } else {
		                this.sigBytes = words.length * 4;
		            }
		        },
	
		        /**
		         * Converts this word array to a string.
		         *
		         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
		         *
		         * @return {string} The stringified word array.
		         *
		         * @example
		         *
		         *     var string = wordArray + '';
		         *     var string = wordArray.toString();
		         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
		         */
		        toString: function (encoder) {
		            return (encoder || Hex).stringify(this);
		        },
	
		        /**
		         * Concatenates a word array to this word array.
		         *
		         * @param {WordArray} wordArray The word array to append.
		         *
		         * @return {WordArray} This word array.
		         *
		         * @example
		         *
		         *     wordArray1.concat(wordArray2);
		         */
		        concat: function (wordArray) {
		            // Shortcuts
		            var thisWords = this.words;
		            var thatWords = wordArray.words;
		            var thisSigBytes = this.sigBytes;
		            var thatSigBytes = wordArray.sigBytes;
	
		            // Clamp excess bits
		            this.clamp();
	
		            // Concat
		            if (thisSigBytes % 4) {
		                // Copy one byte at a time
		                for (var i = 0; i < thatSigBytes; i++) {
		                    var thatByte = (thatWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
		                    thisWords[(thisSigBytes + i) >>> 2] |= thatByte << (24 - ((thisSigBytes + i) % 4) * 8);
		                }
		            } else {
		                // Copy one word at a time
		                for (var i = 0; i < thatSigBytes; i += 4) {
		                    thisWords[(thisSigBytes + i) >>> 2] = thatWords[i >>> 2];
		                }
		            }
		            this.sigBytes += thatSigBytes;
	
		            // Chainable
		            return this;
		        },
	
		        /**
		         * Removes insignificant bits.
		         *
		         * @example
		         *
		         *     wordArray.clamp();
		         */
		        clamp: function () {
		            // Shortcuts
		            var words = this.words;
		            var sigBytes = this.sigBytes;
	
		            // Clamp
		            words[sigBytes >>> 2] &= 0xffffffff << (32 - (sigBytes % 4) * 8);
		            words.length = Math.ceil(sigBytes / 4);
		        },
	
		        /**
		         * Creates a copy of this word array.
		         *
		         * @return {WordArray} The clone.
		         *
		         * @example
		         *
		         *     var clone = wordArray.clone();
		         */
		        clone: function () {
		            var clone = Base.clone.call(this);
		            clone.words = this.words.slice(0);
	
		            return clone;
		        },
	
		        /**
		         * Creates a word array filled with random bytes.
		         *
		         * @param {number} nBytes The number of random bytes to generate.
		         *
		         * @return {WordArray} The random word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.lib.WordArray.random(16);
		         */
		        random: function (nBytes) {
		            var words = [];
	
		            var r = (function (m_w) {
		                var m_w = m_w;
		                var m_z = 0x3ade68b1;
		                var mask = 0xffffffff;
	
		                return function () {
		                    m_z = (0x9069 * (m_z & 0xFFFF) + (m_z >> 0x10)) & mask;
		                    m_w = (0x4650 * (m_w & 0xFFFF) + (m_w >> 0x10)) & mask;
		                    var result = ((m_z << 0x10) + m_w) & mask;
		                    result /= 0x100000000;
		                    result += 0.5;
		                    return result * (Math.random() > .5 ? 1 : -1);
		                }
		            });
	
		            for (var i = 0, rcache; i < nBytes; i += 4) {
		                var _r = r((rcache || Math.random()) * 0x100000000);
	
		                rcache = _r() * 0x3ade67b7;
		                words.push((_r() * 0x100000000) | 0);
		            }
	
		            return new WordArray.init(words, nBytes);
		        }
		    });
	
		    /**
		     * Encoder namespace.
		     */
		    var C_enc = C.enc = {};
	
		    /**
		     * Hex encoding strategy.
		     */
		    var Hex = C_enc.Hex = {
		        /**
		         * Converts a word array to a hex string.
		         *
		         * @param {WordArray} wordArray The word array.
		         *
		         * @return {string} The hex string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
		         */
		        stringify: function (wordArray) {
		            // Shortcuts
		            var words = wordArray.words;
		            var sigBytes = wordArray.sigBytes;
	
		            // Convert
		            var hexChars = [];
		            for (var i = 0; i < sigBytes; i++) {
		                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
		                hexChars.push((bite >>> 4).toString(16));
		                hexChars.push((bite & 0x0f).toString(16));
		            }
	
		            return hexChars.join('');
		        },
	
		        /**
		         * Converts a hex string to a word array.
		         *
		         * @param {string} hexStr The hex string.
		         *
		         * @return {WordArray} The word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
		         */
		        parse: function (hexStr) {
		            // Shortcut
		            var hexStrLength = hexStr.length;
	
		            // Convert
		            var words = [];
		            for (var i = 0; i < hexStrLength; i += 2) {
		                words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << (24 - (i % 8) * 4);
		            }
	
		            return new WordArray.init(words, hexStrLength / 2);
		        }
		    };
	
		    /**
		     * Latin1 encoding strategy.
		     */
		    var Latin1 = C_enc.Latin1 = {
		        /**
		         * Converts a word array to a Latin1 string.
		         *
		         * @param {WordArray} wordArray The word array.
		         *
		         * @return {string} The Latin1 string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
		         */
		        stringify: function (wordArray) {
		            // Shortcuts
		            var words = wordArray.words;
		            var sigBytes = wordArray.sigBytes;
	
		            // Convert
		            var latin1Chars = [];
		            for (var i = 0; i < sigBytes; i++) {
		                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
		                latin1Chars.push(String.fromCharCode(bite));
		            }
	
		            return latin1Chars.join('');
		        },
	
		        /**
		         * Converts a Latin1 string to a word array.
		         *
		         * @param {string} latin1Str The Latin1 string.
		         *
		         * @return {WordArray} The word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
		         */
		        parse: function (latin1Str) {
		            // Shortcut
		            var latin1StrLength = latin1Str.length;
	
		            // Convert
		            var words = [];
		            for (var i = 0; i < latin1StrLength; i++) {
		                words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << (24 - (i % 4) * 8);
		            }
	
		            return new WordArray.init(words, latin1StrLength);
		        }
		    };
	
		    /**
		     * UTF-8 encoding strategy.
		     */
		    var Utf8 = C_enc.Utf8 = {
		        /**
		         * Converts a word array to a UTF-8 string.
		         *
		         * @param {WordArray} wordArray The word array.
		         *
		         * @return {string} The UTF-8 string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
		         */
		        stringify: function (wordArray) {
		            try {
		                return decodeURIComponent(escape(Latin1.stringify(wordArray)));
		            } catch (e) {
		                throw new Error('Malformed UTF-8 data');
		            }
		        },
	
		        /**
		         * Converts a UTF-8 string to a word array.
		         *
		         * @param {string} utf8Str The UTF-8 string.
		         *
		         * @return {WordArray} The word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
		         */
		        parse: function (utf8Str) {
		            return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
		        }
		    };
	
		    /**
		     * Abstract buffered block algorithm template.
		     *
		     * The property blockSize must be implemented in a concrete subtype.
		     *
		     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
		     */
		    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
		        /**
		         * Resets this block algorithm's data buffer to its initial state.
		         *
		         * @example
		         *
		         *     bufferedBlockAlgorithm.reset();
		         */
		        reset: function () {
		            // Initial values
		            this._data = new WordArray.init();
		            this._nDataBytes = 0;
		        },
	
		        /**
		         * Adds new data to this block algorithm's buffer.
		         *
		         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
		         *
		         * @example
		         *
		         *     bufferedBlockAlgorithm._append('data');
		         *     bufferedBlockAlgorithm._append(wordArray);
		         */
		        _append: function (data) {
		            // Convert string to WordArray, else assume WordArray already
		            if (typeof data == 'string') {
		                data = Utf8.parse(data);
		            }
	
		            // Append
		            this._data.concat(data);
		            this._nDataBytes += data.sigBytes;
		        },
	
		        /**
		         * Processes available data blocks.
		         *
		         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
		         *
		         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
		         *
		         * @return {WordArray} The processed data.
		         *
		         * @example
		         *
		         *     var processedData = bufferedBlockAlgorithm._process();
		         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
		         */
		        _process: function (doFlush) {
		            // Shortcuts
		            var data = this._data;
		            var dataWords = data.words;
		            var dataSigBytes = data.sigBytes;
		            var blockSize = this.blockSize;
		            var blockSizeBytes = blockSize * 4;
	
		            // Count blocks ready
		            var nBlocksReady = dataSigBytes / blockSizeBytes;
		            if (doFlush) {
		                // Round up to include partial blocks
		                nBlocksReady = Math.ceil(nBlocksReady);
		            } else {
		                // Round down to include only full blocks,
		                // less the number of blocks that must remain in the buffer
		                nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
		            }
	
		            // Count words ready
		            var nWordsReady = nBlocksReady * blockSize;
	
		            // Count bytes ready
		            var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes);
	
		            // Process blocks
		            if (nWordsReady) {
		                for (var offset = 0; offset < nWordsReady; offset += blockSize) {
		                    // Perform concrete-algorithm logic
		                    this._doProcessBlock(dataWords, offset);
		                }
	
		                // Remove processed words
		                var processedWords = dataWords.splice(0, nWordsReady);
		                data.sigBytes -= nBytesReady;
		            }
	
		            // Return processed words
		            return new WordArray.init(processedWords, nBytesReady);
		        },
	
		        /**
		         * Creates a copy of this object.
		         *
		         * @return {Object} The clone.
		         *
		         * @example
		         *
		         *     var clone = bufferedBlockAlgorithm.clone();
		         */
		        clone: function () {
		            var clone = Base.clone.call(this);
		            clone._data = this._data.clone();
	
		            return clone;
		        },
	
		        _minBufferSize: 0
		    });
	
		    /**
		     * Abstract hasher template.
		     *
		     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
		     */
		    var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
		        /**
		         * Configuration options.
		         */
		        cfg: Base.extend(),
	
		        /**
		         * Initializes a newly created hasher.
		         *
		         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
		         *
		         * @example
		         *
		         *     var hasher = CryptoJS.algo.SHA256.create();
		         */
		        init: function (cfg) {
		            // Apply config defaults
		            this.cfg = this.cfg.extend(cfg);
	
		            // Set initial values
		            this.reset();
		        },
	
		        /**
		         * Resets this hasher to its initial state.
		         *
		         * @example
		         *
		         *     hasher.reset();
		         */
		        reset: function () {
		            // Reset data buffer
		            BufferedBlockAlgorithm.reset.call(this);
	
		            // Perform concrete-hasher logic
		            this._doReset();
		        },
	
		        /**
		         * Updates this hasher with a message.
		         *
		         * @param {WordArray|string} messageUpdate The message to append.
		         *
		         * @return {Hasher} This hasher.
		         *
		         * @example
		         *
		         *     hasher.update('message');
		         *     hasher.update(wordArray);
		         */
		        update: function (messageUpdate) {
		            // Append
		            this._append(messageUpdate);
	
		            // Update the hash
		            this._process();
	
		            // Chainable
		            return this;
		        },
	
		        /**
		         * Finalizes the hash computation.
		         * Note that the finalize operation is effectively a destructive, read-once operation.
		         *
		         * @param {WordArray|string} messageUpdate (Optional) A final message update.
		         *
		         * @return {WordArray} The hash.
		         *
		         * @example
		         *
		         *     var hash = hasher.finalize();
		         *     var hash = hasher.finalize('message');
		         *     var hash = hasher.finalize(wordArray);
		         */
		        finalize: function (messageUpdate) {
		            // Final message update
		            if (messageUpdate) {
		                this._append(messageUpdate);
		            }
	
		            // Perform concrete-hasher logic
		            var hash = this._doFinalize();
	
		            return hash;
		        },
	
		        blockSize: 512/32,
	
		        /**
		         * Creates a shortcut function to a hasher's object interface.
		         *
		         * @param {Hasher} hasher The hasher to create a helper for.
		         *
		         * @return {Function} The shortcut function.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
		         */
		        _createHelper: function (hasher) {
		            return function (message, cfg) {
		                return new hasher.init(cfg).finalize(message);
		            };
		        },
	
		        /**
		         * Creates a shortcut function to the HMAC's object interface.
		         *
		         * @param {Hasher} hasher The hasher to use in this HMAC helper.
		         *
		         * @return {Function} The shortcut function.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
		         */
		        _createHmacHelper: function (hasher) {
		            return function (message, key) {
		                return new C_algo.HMAC.init(hasher, key).finalize(message);
		            };
		        }
		    });
	
		    /**
		     * Algorithm namespace.
		     */
		    var C_algo = C.algo = {};
	
		    return C;
		}(Math));
	
	
		return CryptoJS;
	
	}));

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 83);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
	/* globals __VUE_SSR_CONTEXT__ */
	
	// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
	// This module is a runtime utility for cleaner component module output and will
	// be included in the final webpack user bundle.
	
	function normalizeComponent (
	  scriptExports,
	  render,
	  staticRenderFns,
	  functionalTemplate,
	  injectStyles,
	  scopeId,
	  moduleIdentifier, /* server only */
	  shadowMode /* vue-cli only */
	) {
	  // Vue.extend constructor export interop
	  var options = typeof scriptExports === 'function'
	    ? scriptExports.options
	    : scriptExports
	
	  // render functions
	  if (render) {
	    options.render = render
	    options.staticRenderFns = staticRenderFns
	    options._compiled = true
	  }
	
	  // functional template
	  if (functionalTemplate) {
	    options.functional = true
	  }
	
	  // scopedId
	  if (scopeId) {
	    options._scopeId = 'data-v-' + scopeId
	  }
	
	  var hook
	  if (moduleIdentifier) { // server build
	    hook = function (context) {
	      // 2.3 injection
	      context =
	        context || // cached call
	        (this.$vnode && this.$vnode.ssrContext) || // stateful
	        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
	      // 2.2 with runInNewContext: true
	      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
	        context = __VUE_SSR_CONTEXT__
	      }
	      // inject component styles
	      if (injectStyles) {
	        injectStyles.call(this, context)
	      }
	      // register component module identifier for async chunk inferrence
	      if (context && context._registeredComponents) {
	        context._registeredComponents.add(moduleIdentifier)
	      }
	    }
	    // used by ssr in case component is cached and beforeCreate
	    // never gets called
	    options._ssrRegister = hook
	  } else if (injectStyles) {
	    hook = shadowMode
	      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
	      : injectStyles
	  }
	
	  if (hook) {
	    if (options.functional) {
	      // for template-only hot-reload because in that case the render fn doesn't
	      // go through the normalizer
	      options._injectStyles = hook
	      // register for functioal component in vue file
	      var originalRender = options.render
	      options.render = function renderWithStyleInjection (h, context) {
	        hook.call(context)
	        return originalRender(h, context)
	      }
	    } else {
	      // inject component registration as beforeCreate hook
	      var existing = options.beforeCreate
	      options.beforeCreate = existing
	        ? [].concat(existing, hook)
	        : [hook]
	    }
	  }
	
	  return {
	    exports: scriptExports,
	    options: options
	  }
	}
	
	
	/***/ }),
	
	/***/ 4:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(54);
	
	/***/ }),
	
	/***/ 83:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox.vue?vue&type=template&id=d0387074&
	var render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "label",
	    {
	      staticClass: "el-checkbox",
	      class: [
	        _vm.border && _vm.checkboxSize
	          ? "el-checkbox--" + _vm.checkboxSize
	          : "",
	        { "is-disabled": _vm.isDisabled },
	        { "is-bordered": _vm.border },
	        { "is-checked": _vm.isChecked }
	      ],
	      attrs: { id: _vm.id }
	    },
	    [
	      _c(
	        "span",
	        {
	          staticClass: "el-checkbox__input",
	          class: {
	            "is-disabled": _vm.isDisabled,
	            "is-checked": _vm.isChecked,
	            "is-indeterminate": _vm.indeterminate,
	            "is-focus": _vm.focus
	          },
	          attrs: {
	            tabindex: _vm.indeterminate ? 0 : false,
	            role: _vm.indeterminate ? "checkbox" : false,
	            "aria-checked": _vm.indeterminate ? "mixed" : false
	          }
	        },
	        [
	          _c("span", { staticClass: "el-checkbox__inner" }),
	          _vm.trueLabel || _vm.falseLabel
	            ? _c("input", {
	                directives: [
	                  {
	                    name: "model",
	                    rawName: "v-model",
	                    value: _vm.model,
	                    expression: "model"
	                  }
	                ],
	                staticClass: "el-checkbox__original",
	                attrs: {
	                  type: "checkbox",
	                  "aria-hidden": _vm.indeterminate ? "true" : "false",
	                  name: _vm.name,
	                  disabled: _vm.isDisabled,
	                  "true-value": _vm.trueLabel,
	                  "false-value": _vm.falseLabel
	                },
	                domProps: {
	                  checked: Array.isArray(_vm.model)
	                    ? _vm._i(_vm.model, null) > -1
	                    : _vm._q(_vm.model, _vm.trueLabel)
	                },
	                on: {
	                  change: [
	                    function($event) {
	                      var $$a = _vm.model,
	                        $$el = $event.target,
	                        $$c = $$el.checked ? _vm.trueLabel : _vm.falseLabel
	                      if (Array.isArray($$a)) {
	                        var $$v = null,
	                          $$i = _vm._i($$a, $$v)
	                        if ($$el.checked) {
	                          $$i < 0 && (_vm.model = $$a.concat([$$v]))
	                        } else {
	                          $$i > -1 &&
	                            (_vm.model = $$a
	                              .slice(0, $$i)
	                              .concat($$a.slice($$i + 1)))
	                        }
	                      } else {
	                        _vm.model = $$c
	                      }
	                    },
	                    _vm.handleChange
	                  ],
	                  focus: function($event) {
	                    _vm.focus = true
	                  },
	                  blur: function($event) {
	                    _vm.focus = false
	                  }
	                }
	              })
	            : _c("input", {
	                directives: [
	                  {
	                    name: "model",
	                    rawName: "v-model",
	                    value: _vm.model,
	                    expression: "model"
	                  }
	                ],
	                staticClass: "el-checkbox__original",
	                attrs: {
	                  type: "checkbox",
	                  "aria-hidden": _vm.indeterminate ? "true" : "false",
	                  disabled: _vm.isDisabled,
	                  name: _vm.name
	                },
	                domProps: {
	                  value: _vm.label,
	                  checked: Array.isArray(_vm.model)
	                    ? _vm._i(_vm.model, _vm.label) > -1
	                    : _vm.model
	                },
	                on: {
	                  change: [
	                    function($event) {
	                      var $$a = _vm.model,
	                        $$el = $event.target,
	                        $$c = $$el.checked ? true : false
	                      if (Array.isArray($$a)) {
	                        var $$v = _vm.label,
	                          $$i = _vm._i($$a, $$v)
	                        if ($$el.checked) {
	                          $$i < 0 && (_vm.model = $$a.concat([$$v]))
	                        } else {
	                          $$i > -1 &&
	                            (_vm.model = $$a
	                              .slice(0, $$i)
	                              .concat($$a.slice($$i + 1)))
	                        }
	                      } else {
	                        _vm.model = $$c
	                      }
	                    },
	                    _vm.handleChange
	                  ],
	                  focus: function($event) {
	                    _vm.focus = true
	                  },
	                  blur: function($event) {
	                    _vm.focus = false
	                  }
	                }
	              })
	        ]
	      ),
	      _vm.$slots.default || _vm.label
	        ? _c(
	            "span",
	            { staticClass: "el-checkbox__label" },
	            [
	              _vm._t("default"),
	              !_vm.$slots.default ? [_vm._v(_vm._s(_vm.label))] : _vm._e()
	            ],
	            2
	          )
	        : _vm._e()
	    ]
	  )
	}
	var staticRenderFns = []
	render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/checkbox/src/checkbox.vue?vue&type=template&id=d0387074&
	
	// EXTERNAL MODULE: external "element-ui/lib/mixins/emitter"
	var emitter_ = __webpack_require__(4);
	var emitter_default = /*#__PURE__*/__webpack_require__.n(emitter_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var checkboxvue_type_script_lang_js_ = ({
	  name: 'ElCheckbox',
	
	  mixins: [emitter_default.a],
	
	  inject: {
	    elForm: {
	      default: ''
	    },
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  componentName: 'ElCheckbox',
	
	  data: function data() {
	    return {
	      selfModel: false,
	      focus: false,
	      isLimitExceeded: false
	    };
	  },
	
	
	  computed: {
	    model: {
	      get: function get() {
	        return this.isGroup ? this.store : this.value !== undefined ? this.value : this.selfModel;
	      },
	      set: function set(val) {
	        if (this.isGroup) {
	          this.isLimitExceeded = false;
	          this._checkboxGroup.min !== undefined && val.length < this._checkboxGroup.min && (this.isLimitExceeded = true);
	
	          this._checkboxGroup.max !== undefined && val.length > this._checkboxGroup.max && (this.isLimitExceeded = true);
	
	          this.isLimitExceeded === false && this.dispatch('ElCheckboxGroup', 'input', [val]);
	        } else {
	          this.$emit('input', val);
	          this.selfModel = val;
	        }
	      }
	    },
	
	    isChecked: function isChecked() {
	      if ({}.toString.call(this.model) === '[object Boolean]') {
	        return this.model;
	      } else if (Array.isArray(this.model)) {
	        return this.model.indexOf(this.label) > -1;
	      } else if (this.model !== null && this.model !== undefined) {
	        return this.model === this.trueLabel;
	      }
	    },
	    isGroup: function isGroup() {
	      var parent = this.$parent;
	      while (parent) {
	        if (parent.$options.componentName !== 'ElCheckboxGroup') {
	          parent = parent.$parent;
	        } else {
	          this._checkboxGroup = parent;
	          return true;
	        }
	      }
	      return false;
	    },
	    store: function store() {
	      return this._checkboxGroup ? this._checkboxGroup.value : this.value;
	    },
	
	
	    /* used to make the isDisabled judgment under max/min props */
	    isLimitDisabled: function isLimitDisabled() {
	      var _checkboxGroup = this._checkboxGroup,
	          max = _checkboxGroup.max,
	          min = _checkboxGroup.min;
	
	      return !!(max || min) && this.model.length >= max && !this.isChecked || this.model.length <= min && this.isChecked;
	    },
	    isDisabled: function isDisabled() {
	      return this.isGroup ? this._checkboxGroup.disabled || this.disabled || (this.elForm || {}).disabled || this.isLimitDisabled : this.disabled || (this.elForm || {}).disabled;
	    },
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    checkboxSize: function checkboxSize() {
	      var temCheckboxSize = this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
	      return this.isGroup ? this._checkboxGroup.checkboxGroupSize || temCheckboxSize : temCheckboxSize;
	    }
	  },
	
	  props: {
	    value: {},
	    label: {},
	    indeterminate: Boolean,
	    disabled: Boolean,
	    checked: Boolean,
	    name: String,
	    trueLabel: [String, Number],
	    falseLabel: [String, Number],
	    id: String, /* 当indeterminate为真时，为controls提供相关连的checkbox的id，表明元素间的控制关系*/
	    controls: String, /* 当indeterminate为真时，为controls提供相关连的checkbox的id，表明元素间的控制关系*/
	    border: Boolean,
	    size: String
	  },
	
	  methods: {
	    addToStore: function addToStore() {
	      if (Array.isArray(this.model) && this.model.indexOf(this.label) === -1) {
	        this.model.push(this.label);
	      } else {
	        this.model = this.trueLabel || true;
	      }
	    },
	    handleChange: function handleChange(ev) {
	      var _this = this;
	
	      if (this.isLimitExceeded) return;
	      var value = void 0;
	      if (ev.target.checked) {
	        value = this.trueLabel === undefined ? true : this.trueLabel;
	      } else {
	        value = this.falseLabel === undefined ? false : this.falseLabel;
	      }
	      this.$emit('change', value, ev);
	      this.$nextTick(function () {
	        if (_this.isGroup) {
	          _this.dispatch('ElCheckboxGroup', 'change', [_this._checkboxGroup.value]);
	        }
	      });
	    }
	  },
	
	  created: function created() {
	    this.checked && this.addToStore();
	  },
	  mounted: function mounted() {
	    // 为indeterminate元素 添加aria-controls 属性
	    if (this.indeterminate) {
	      this.$el.setAttribute('aria-controls', this.controls);
	    }
	  },
	
	
	  watch: {
	    value: function value(_value) {
	      this.dispatch('ElFormItem', 'el.form.change', _value);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/checkbox/src/checkbox.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_checkboxvue_type_script_lang_js_ = (checkboxvue_type_script_lang_js_); 
	// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
	var componentNormalizer = __webpack_require__(0);
	
	// CONCATENATED MODULE: ./packages/checkbox/src/checkbox.vue
	
	
	
	
	
	/* normalize component */
	
	var component = Object(componentNormalizer["a" /* default */])(
	  src_checkboxvue_type_script_lang_js_,
	  render,
	  staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var api; }
	component.options.__file = "packages/checkbox/src/checkbox.vue"
	/* harmony default export */ var src_checkbox = (component.exports);
	// CONCATENATED MODULE: ./packages/checkbox/index.js
	
	
	/* istanbul ignore next */
	src_checkbox.install = function (Vue) {
	  Vue.component(src_checkbox.name, src_checkbox);
	};
	
	/* harmony default export */ var packages_checkbox = __webpack_exports__["default"] = (src_checkbox);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _util = __webpack_require__(38);
	
	/**
	 * Show migrating guide in browser console.
	 *
	 * Usage:
	 * import Migrating from 'element-ui/src/mixins/migrating';
	 *
	 * mixins: [Migrating]
	 *
	 * add getMigratingConfig method for your component.
	 *  getMigratingConfig() {
	 *    return {
	 *      props: {
	 *        'allow-no-selection': 'allow-no-selection is removed.',
	 *        'selection-mode': 'selection-mode is removed.'
	 *      },
	 *      events: {
	 *        selectionchange: 'selectionchange is renamed to selection-change.'
	 *      }
	 *    };
	 *  },
	 */
	exports.default = {
	  mounted: function mounted() {
	    if (true) return;
	    if (!this.$vnode) return;
	
	    var _getMigratingConfig = this.getMigratingConfig(),
	        _getMigratingConfig$p = _getMigratingConfig.props,
	        props = _getMigratingConfig$p === undefined ? {} : _getMigratingConfig$p,
	        _getMigratingConfig$e = _getMigratingConfig.events,
	        events = _getMigratingConfig$e === undefined ? {} : _getMigratingConfig$e;
	
	    var _$vnode = this.$vnode,
	        data = _$vnode.data,
	        componentOptions = _$vnode.componentOptions;
	
	    var definedProps = data.attrs || {};
	    var definedEvents = componentOptions.listeners || {};
	
	    for (var propName in definedProps) {
	      propName = (0, _util.kebabCase)(propName); // compatible with camel case
	      if (props[propName]) {
	        console.warn('[Element Migrating][' + this.$options.name + '][Attribute]: ' + props[propName]);
	      }
	    }
	
	    for (var eventName in definedEvents) {
	      eventName = (0, _util.kebabCase)(eventName); // compatible with camel case
	      if (events[eventName]) {
	        console.warn('[Element Migrating][' + this.$options.name + '][Event]: ' + events[eventName]);
	      }
	    }
	  },
	
	  methods: {
	    getMigratingConfig: function getMigratingConfig() {
	      return {
	        props: {},
	        events: {}
	      };
	    }
	  }
	};

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 116);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
	/* globals __VUE_SSR_CONTEXT__ */
	
	// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
	// This module is a runtime utility for cleaner component module output and will
	// be included in the final webpack user bundle.
	
	function normalizeComponent (
	  scriptExports,
	  render,
	  staticRenderFns,
	  functionalTemplate,
	  injectStyles,
	  scopeId,
	  moduleIdentifier, /* server only */
	  shadowMode /* vue-cli only */
	) {
	  // Vue.extend constructor export interop
	  var options = typeof scriptExports === 'function'
	    ? scriptExports.options
	    : scriptExports
	
	  // render functions
	  if (render) {
	    options.render = render
	    options.staticRenderFns = staticRenderFns
	    options._compiled = true
	  }
	
	  // functional template
	  if (functionalTemplate) {
	    options.functional = true
	  }
	
	  // scopedId
	  if (scopeId) {
	    options._scopeId = 'data-v-' + scopeId
	  }
	
	  var hook
	  if (moduleIdentifier) { // server build
	    hook = function (context) {
	      // 2.3 injection
	      context =
	        context || // cached call
	        (this.$vnode && this.$vnode.ssrContext) || // stateful
	        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
	      // 2.2 with runInNewContext: true
	      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
	        context = __VUE_SSR_CONTEXT__
	      }
	      // inject component styles
	      if (injectStyles) {
	        injectStyles.call(this, context)
	      }
	      // register component module identifier for async chunk inferrence
	      if (context && context._registeredComponents) {
	        context._registeredComponents.add(moduleIdentifier)
	      }
	    }
	    // used by ssr in case component is cached and beforeCreate
	    // never gets called
	    options._ssrRegister = hook
	  } else if (injectStyles) {
	    hook = shadowMode
	      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
	      : injectStyles
	  }
	
	  if (hook) {
	    if (options.functional) {
	      // for template-only hot-reload because in that case the render fn doesn't
	      // go through the normalizer
	      options._injectStyles = hook
	      // register for functioal component in vue file
	      var originalRender = options.render
	      options.render = function renderWithStyleInjection (h, context) {
	        hook.call(context)
	        return originalRender(h, context)
	      }
	    } else {
	      // inject component registration as beforeCreate hook
	      var existing = options.beforeCreate
	      options.beforeCreate = existing
	        ? [].concat(existing, hook)
	        : [hook]
	    }
	  }
	
	  return {
	    exports: scriptExports,
	    options: options
	  }
	}
	
	
	/***/ }),
	
	/***/ 116:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/radio/src/radio.vue?vue&type=template&id=69cd6268&
	var render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "label",
	    {
	      staticClass: "el-radio",
	      class: [
	        _vm.border && _vm.radioSize ? "el-radio--" + _vm.radioSize : "",
	        { "is-disabled": _vm.isDisabled },
	        { "is-focus": _vm.focus },
	        { "is-bordered": _vm.border },
	        { "is-checked": _vm.model === _vm.label }
	      ],
	      attrs: {
	        role: "radio",
	        "aria-checked": _vm.model === _vm.label,
	        "aria-disabled": _vm.isDisabled,
	        tabindex: _vm.tabIndex
	      },
	      on: {
	        keydown: function($event) {
	          if (
	            !("button" in $event) &&
	            _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])
	          ) {
	            return null
	          }
	          $event.stopPropagation()
	          $event.preventDefault()
	          _vm.model = _vm.isDisabled ? _vm.model : _vm.label
	        }
	      }
	    },
	    [
	      _c(
	        "span",
	        {
	          staticClass: "el-radio__input",
	          class: {
	            "is-disabled": _vm.isDisabled,
	            "is-checked": _vm.model === _vm.label
	          }
	        },
	        [
	          _c("span", { staticClass: "el-radio__inner" }),
	          _c("input", {
	            directives: [
	              {
	                name: "model",
	                rawName: "v-model",
	                value: _vm.model,
	                expression: "model"
	              }
	            ],
	            ref: "radio",
	            staticClass: "el-radio__original",
	            attrs: {
	              type: "radio",
	              "aria-hidden": "true",
	              name: _vm.name,
	              disabled: _vm.isDisabled,
	              tabindex: "-1"
	            },
	            domProps: {
	              value: _vm.label,
	              checked: _vm._q(_vm.model, _vm.label)
	            },
	            on: {
	              focus: function($event) {
	                _vm.focus = true
	              },
	              blur: function($event) {
	                _vm.focus = false
	              },
	              change: [
	                function($event) {
	                  _vm.model = _vm.label
	                },
	                _vm.handleChange
	              ]
	            }
	          })
	        ]
	      ),
	      _c(
	        "span",
	        {
	          staticClass: "el-radio__label",
	          on: {
	            keydown: function($event) {
	              $event.stopPropagation()
	            }
	          }
	        },
	        [
	          _vm._t("default"),
	          !_vm.$slots.default ? [_vm._v(_vm._s(_vm.label))] : _vm._e()
	        ],
	        2
	      )
	    ]
	  )
	}
	var staticRenderFns = []
	render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/radio/src/radio.vue?vue&type=template&id=69cd6268&
	
	// EXTERNAL MODULE: external "element-ui/lib/mixins/emitter"
	var emitter_ = __webpack_require__(4);
	var emitter_default = /*#__PURE__*/__webpack_require__.n(emitter_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/radio/src/radio.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var radiovue_type_script_lang_js_ = ({
	  name: 'ElRadio',
	
	  mixins: [emitter_default.a],
	
	  inject: {
	    elForm: {
	      default: ''
	    },
	
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  componentName: 'ElRadio',
	
	  props: {
	    value: {},
	    label: {},
	    disabled: Boolean,
	    name: String,
	    border: Boolean,
	    size: String
	  },
	
	  data: function data() {
	    return {
	      focus: false
	    };
	  },
	
	  computed: {
	    isGroup: function isGroup() {
	      var parent = this.$parent;
	      while (parent) {
	        if (parent.$options.componentName !== 'ElRadioGroup') {
	          parent = parent.$parent;
	        } else {
	          this._radioGroup = parent;
	          return true;
	        }
	      }
	      return false;
	    },
	
	    model: {
	      get: function get() {
	        return this.isGroup ? this._radioGroup.value : this.value;
	      },
	      set: function set(val) {
	        if (this.isGroup) {
	          this.dispatch('ElRadioGroup', 'input', [val]);
	        } else {
	          this.$emit('input', val);
	        }
	        this.$refs.radio && (this.$refs.radio.checked = this.model === this.label);
	      }
	    },
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    radioSize: function radioSize() {
	      var temRadioSize = this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
	      return this.isGroup ? this._radioGroup.radioGroupSize || temRadioSize : temRadioSize;
	    },
	    isDisabled: function isDisabled() {
	      return this.isGroup ? this._radioGroup.disabled || this.disabled || (this.elForm || {}).disabled : this.disabled || (this.elForm || {}).disabled;
	    },
	    tabIndex: function tabIndex() {
	      return this.isDisabled || this.isGroup && this.model !== this.label ? -1 : 0;
	    }
	  },
	
	  methods: {
	    handleChange: function handleChange() {
	      var _this = this;
	
	      this.$nextTick(function () {
	        _this.$emit('change', _this.model);
	        _this.isGroup && _this.dispatch('ElRadioGroup', 'handleChange', _this.model);
	      });
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/radio/src/radio.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_radiovue_type_script_lang_js_ = (radiovue_type_script_lang_js_); 
	// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
	var componentNormalizer = __webpack_require__(0);
	
	// CONCATENATED MODULE: ./packages/radio/src/radio.vue
	
	
	
	
	
	/* normalize component */
	
	var component = Object(componentNormalizer["a" /* default */])(
	  src_radiovue_type_script_lang_js_,
	  render,
	  staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var api; }
	component.options.__file = "packages/radio/src/radio.vue"
	/* harmony default export */ var src_radio = (component.exports);
	// CONCATENATED MODULE: ./packages/radio/index.js
	
	
	/* istanbul ignore next */
	src_radio.install = function (Vue) {
	  Vue.component(src_radio.name, src_radio);
	};
	
	/* harmony default export */ var packages_radio = __webpack_exports__["default"] = (src_radio);
	
	/***/ }),
	
	/***/ 4:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(54);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 177 */
/***/ (function(module, exports) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 124);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
	/* globals __VUE_SSR_CONTEXT__ */
	
	// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
	// This module is a runtime utility for cleaner component module output and will
	// be included in the final webpack user bundle.
	
	function normalizeComponent (
	  scriptExports,
	  render,
	  staticRenderFns,
	  functionalTemplate,
	  injectStyles,
	  scopeId,
	  moduleIdentifier, /* server only */
	  shadowMode /* vue-cli only */
	) {
	  // Vue.extend constructor export interop
	  var options = typeof scriptExports === 'function'
	    ? scriptExports.options
	    : scriptExports
	
	  // render functions
	  if (render) {
	    options.render = render
	    options.staticRenderFns = staticRenderFns
	    options._compiled = true
	  }
	
	  // functional template
	  if (functionalTemplate) {
	    options.functional = true
	  }
	
	  // scopedId
	  if (scopeId) {
	    options._scopeId = 'data-v-' + scopeId
	  }
	
	  var hook
	  if (moduleIdentifier) { // server build
	    hook = function (context) {
	      // 2.3 injection
	      context =
	        context || // cached call
	        (this.$vnode && this.$vnode.ssrContext) || // stateful
	        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
	      // 2.2 with runInNewContext: true
	      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
	        context = __VUE_SSR_CONTEXT__
	      }
	      // inject component styles
	      if (injectStyles) {
	        injectStyles.call(this, context)
	      }
	      // register component module identifier for async chunk inferrence
	      if (context && context._registeredComponents) {
	        context._registeredComponents.add(moduleIdentifier)
	      }
	    }
	    // used by ssr in case component is cached and beforeCreate
	    // never gets called
	    options._ssrRegister = hook
	  } else if (injectStyles) {
	    hook = shadowMode
	      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
	      : injectStyles
	  }
	
	  if (hook) {
	    if (options.functional) {
	      // for template-only hot-reload because in that case the render fn doesn't
	      // go through the normalizer
	      options._injectStyles = hook
	      // register for functioal component in vue file
	      var originalRender = options.render
	      options.render = function renderWithStyleInjection (h, context) {
	        hook.call(context)
	        return originalRender(h, context)
	      }
	    } else {
	      // inject component registration as beforeCreate hook
	      var existing = options.beforeCreate
	      options.beforeCreate = existing
	        ? [].concat(existing, hook)
	        : [hook]
	    }
	  }
	
	  return {
	    exports: scriptExports,
	    options: options
	  }
	}
	
	
	/***/ }),
	
	/***/ 124:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/tag/src/tag.vue?vue&type=script&lang=js&
	
	/* harmony default export */ var tagvue_type_script_lang_js_ = ({
	  name: 'ElTag',
	  props: {
	    text: String,
	    closable: Boolean,
	    type: String,
	    hit: Boolean,
	    disableTransitions: Boolean,
	    color: String,
	    size: String,
	    effect: {
	      type: String,
	      default: 'light',
	      validator: function validator(val) {
	        return ['dark', 'light', 'plain'].indexOf(val) !== -1;
	      }
	    }
	  },
	  methods: {
	    handleClose: function handleClose(event) {
	      event.stopPropagation();
	      this.$emit('close', event);
	    },
	    handleClick: function handleClick(event) {
	      this.$emit('click', event);
	    }
	  },
	  computed: {
	    tagSize: function tagSize() {
	      return this.size || (this.$ELEMENT || {}).size;
	    }
	  },
	  render: function render(h) {
	    var type = this.type,
	        tagSize = this.tagSize,
	        hit = this.hit,
	        effect = this.effect;
	
	    var classes = ['el-tag', type ? 'el-tag--' + type : '', tagSize ? 'el-tag--' + tagSize : '', effect ? 'el-tag--' + effect : '', hit && 'is-hit'];
	    var tagEl = h(
	      'span',
	      {
	        'class': classes,
	        style: { backgroundColor: this.color },
	        on: {
	          'click': this.handleClick
	        }
	      },
	      [this.$slots.default, this.closable && h('i', { 'class': 'el-tag__close el-icon-close', on: {
	          'click': this.handleClose
	        }
	      })]
	    );
	
	    return this.disableTransitions ? tagEl : h(
	      'transition',
	      {
	        attrs: { name: 'el-zoom-in-center' }
	      },
	      [tagEl]
	    );
	  }
	});
	// CONCATENATED MODULE: ./packages/tag/src/tag.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_tagvue_type_script_lang_js_ = (tagvue_type_script_lang_js_); 
	// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
	var componentNormalizer = __webpack_require__(0);
	
	// CONCATENATED MODULE: ./packages/tag/src/tag.vue
	var render, staticRenderFns
	
	
	
	
	/* normalize component */
	
	var component = Object(componentNormalizer["a" /* default */])(
	  src_tagvue_type_script_lang_js_,
	  render,
	  staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var api; }
	component.options.__file = "packages/tag/src/tag.vue"
	/* harmony default export */ var tag = (component.exports);
	// CONCATENATED MODULE: ./packages/tag/index.js
	
	
	/* istanbul ignore next */
	tag.install = function (Vue) {
	  Vue.component(tag.name, tag);
	};
	
	/* harmony default export */ var packages_tag = __webpack_exports__["default"] = (tag);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _vue = __webpack_require__(20);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _dom = __webpack_require__(42);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var nodeList = [];
	var ctx = '@@clickoutsideContext';
	
	var startClick = void 0;
	var seed = 0;
	
	!_vue2.default.prototype.$isServer && (0, _dom.on)(document, 'mousedown', function (e) {
	  return startClick = e;
	});
	
	!_vue2.default.prototype.$isServer && (0, _dom.on)(document, 'mouseup', function (e) {
	  nodeList.forEach(function (node) {
	    return node[ctx].documentHandler(e, startClick);
	  });
	});
	
	function createDocumentHandler(el, binding, vnode) {
	  return function () {
	    var mouseup = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var mousedown = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    if (!vnode || !vnode.context || !mouseup.target || !mousedown.target || el.contains(mouseup.target) || el.contains(mousedown.target) || el === mouseup.target || vnode.context.popperElm && (vnode.context.popperElm.contains(mouseup.target) || vnode.context.popperElm.contains(mousedown.target))) return;
	
	    if (binding.expression && el[ctx].methodName && vnode.context[el[ctx].methodName]) {
	      vnode.context[el[ctx].methodName]();
	    } else {
	      el[ctx].bindingFn && el[ctx].bindingFn();
	    }
	  };
	}
	
	/**
	 * v-clickoutside
	 * @desc 点击元素外面才会触发的事件
	 * @example
	 * ```vue
	 * <div v-element-clickoutside="handleClose">
	 * ```
	 */
	exports.default = {
	  bind: function bind(el, binding, vnode) {
	    nodeList.push(el);
	    var id = seed++;
	    el[ctx] = {
	      id: id,
	      documentHandler: createDocumentHandler(el, binding, vnode),
	      methodName: binding.expression,
	      bindingFn: binding.value
	    };
	  },
	  update: function update(el, binding, vnode) {
	    el[ctx].documentHandler = createDocumentHandler(el, binding, vnode);
	    el[ctx].methodName = binding.expression;
	    el[ctx].bindingFn = binding.value;
	  },
	  unbind: function unbind(el) {
	    var len = nodeList.length;
	
	    for (var i = 0; i < len; i++) {
	      if (nodeList[i][ctx].id === el[ctx].id) {
	        nodeList.splice(i, 1);
	        break;
	      }
	    }
	    delete el[ctx];
	  }
	};

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/* Modified from https://github.com/taylorhakes/fecha
	 *
	 * The MIT License (MIT)
	 *
	 * Copyright (c) 2015 Taylor Hakes
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 *     The above copyright notice and this permission notice shall be included in all
	 * copies or substantial portions of the Software.
	 *
	 *     THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 *     FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 *     OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	 * SOFTWARE.
	 */
	
	/*eslint-disable*/
	// 把 YYYY-MM-DD 改成了 yyyy-MM-dd
	(function (main) {
	  'use strict';
	
	  /**
	   * Parse or format dates
	   * @class fecha
	   */
	
	  var fecha = {};
	  var token = /d{1,4}|M{1,4}|yy(?:yy)?|S{1,3}|Do|ZZ|([HhMsDm])\1?|[aA]|"[^"]*"|'[^']*'/g;
	  var twoDigits = '\\d\\d?';
	  var threeDigits = '\\d{3}';
	  var fourDigits = '\\d{4}';
	  var word = '[^\\s]+';
	  var literal = /\[([^]*?)\]/gm;
	  var noop = function noop() {};
	
	  function regexEscape(str) {
	    return str.replace(/[|\\{()[^$+*?.-]/g, '\\$&');
	  }
	
	  function shorten(arr, sLen) {
	    var newArr = [];
	    for (var i = 0, len = arr.length; i < len; i++) {
	      newArr.push(arr[i].substr(0, sLen));
	    }
	    return newArr;
	  }
	
	  function monthUpdate(arrName) {
	    return function (d, v, i18n) {
	      var index = i18n[arrName].indexOf(v.charAt(0).toUpperCase() + v.substr(1).toLowerCase());
	      if (~index) {
	        d.month = index;
	      }
	    };
	  }
	
	  function pad(val, len) {
	    val = String(val);
	    len = len || 2;
	    while (val.length < len) {
	      val = '0' + val;
	    }
	    return val;
	  }
	
	  var dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
	  var monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
	  var monthNamesShort = shorten(monthNames, 3);
	  var dayNamesShort = shorten(dayNames, 3);
	  fecha.i18n = {
	    dayNamesShort: dayNamesShort,
	    dayNames: dayNames,
	    monthNamesShort: monthNamesShort,
	    monthNames: monthNames,
	    amPm: ['am', 'pm'],
	    DoFn: function DoFn(D) {
	      return D + ['th', 'st', 'nd', 'rd'][D % 10 > 3 ? 0 : (D - D % 10 !== 10) * D % 10];
	    }
	  };
	
	  var formatFlags = {
	    D: function D(dateObj) {
	      return dateObj.getDay();
	    },
	    DD: function DD(dateObj) {
	      return pad(dateObj.getDay());
	    },
	    Do: function Do(dateObj, i18n) {
	      return i18n.DoFn(dateObj.getDate());
	    },
	    d: function d(dateObj) {
	      return dateObj.getDate();
	    },
	    dd: function dd(dateObj) {
	      return pad(dateObj.getDate());
	    },
	    ddd: function ddd(dateObj, i18n) {
	      return i18n.dayNamesShort[dateObj.getDay()];
	    },
	    dddd: function dddd(dateObj, i18n) {
	      return i18n.dayNames[dateObj.getDay()];
	    },
	    M: function M(dateObj) {
	      return dateObj.getMonth() + 1;
	    },
	    MM: function MM(dateObj) {
	      return pad(dateObj.getMonth() + 1);
	    },
	    MMM: function MMM(dateObj, i18n) {
	      return i18n.monthNamesShort[dateObj.getMonth()];
	    },
	    MMMM: function MMMM(dateObj, i18n) {
	      return i18n.monthNames[dateObj.getMonth()];
	    },
	    yy: function yy(dateObj) {
	      return pad(String(dateObj.getFullYear()), 4).substr(2);
	    },
	    yyyy: function yyyy(dateObj) {
	      return pad(dateObj.getFullYear(), 4);
	    },
	    h: function h(dateObj) {
	      return dateObj.getHours() % 12 || 12;
	    },
	    hh: function hh(dateObj) {
	      return pad(dateObj.getHours() % 12 || 12);
	    },
	    H: function H(dateObj) {
	      return dateObj.getHours();
	    },
	    HH: function HH(dateObj) {
	      return pad(dateObj.getHours());
	    },
	    m: function m(dateObj) {
	      return dateObj.getMinutes();
	    },
	    mm: function mm(dateObj) {
	      return pad(dateObj.getMinutes());
	    },
	    s: function s(dateObj) {
	      return dateObj.getSeconds();
	    },
	    ss: function ss(dateObj) {
	      return pad(dateObj.getSeconds());
	    },
	    S: function S(dateObj) {
	      return Math.round(dateObj.getMilliseconds() / 100);
	    },
	    SS: function SS(dateObj) {
	      return pad(Math.round(dateObj.getMilliseconds() / 10), 2);
	    },
	    SSS: function SSS(dateObj) {
	      return pad(dateObj.getMilliseconds(), 3);
	    },
	    a: function a(dateObj, i18n) {
	      return dateObj.getHours() < 12 ? i18n.amPm[0] : i18n.amPm[1];
	    },
	    A: function A(dateObj, i18n) {
	      return dateObj.getHours() < 12 ? i18n.amPm[0].toUpperCase() : i18n.amPm[1].toUpperCase();
	    },
	    ZZ: function ZZ(dateObj) {
	      var o = dateObj.getTimezoneOffset();
	      return (o > 0 ? '-' : '+') + pad(Math.floor(Math.abs(o) / 60) * 100 + Math.abs(o) % 60, 4);
	    }
	  };
	
	  var parseFlags = {
	    d: [twoDigits, function (d, v) {
	      d.day = v;
	    }],
	    Do: [twoDigits + word, function (d, v) {
	      d.day = parseInt(v, 10);
	    }],
	    M: [twoDigits, function (d, v) {
	      d.month = v - 1;
	    }],
	    yy: [twoDigits, function (d, v) {
	      var da = new Date(),
	          cent = +('' + da.getFullYear()).substr(0, 2);
	      d.year = '' + (v > 68 ? cent - 1 : cent) + v;
	    }],
	    h: [twoDigits, function (d, v) {
	      d.hour = v;
	    }],
	    m: [twoDigits, function (d, v) {
	      d.minute = v;
	    }],
	    s: [twoDigits, function (d, v) {
	      d.second = v;
	    }],
	    yyyy: [fourDigits, function (d, v) {
	      d.year = v;
	    }],
	    S: ['\\d', function (d, v) {
	      d.millisecond = v * 100;
	    }],
	    SS: ['\\d{2}', function (d, v) {
	      d.millisecond = v * 10;
	    }],
	    SSS: [threeDigits, function (d, v) {
	      d.millisecond = v;
	    }],
	    D: [twoDigits, noop],
	    ddd: [word, noop],
	    MMM: [word, monthUpdate('monthNamesShort')],
	    MMMM: [word, monthUpdate('monthNames')],
	    a: [word, function (d, v, i18n) {
	      var val = v.toLowerCase();
	      if (val === i18n.amPm[0]) {
	        d.isPm = false;
	      } else if (val === i18n.amPm[1]) {
	        d.isPm = true;
	      }
	    }],
	    ZZ: ['[^\\s]*?[\\+\\-]\\d\\d:?\\d\\d|[^\\s]*?Z', function (d, v) {
	      var parts = (v + '').match(/([+-]|\d\d)/gi),
	          minutes;
	
	      if (parts) {
	        minutes = +(parts[1] * 60) + parseInt(parts[2], 10);
	        d.timezoneOffset = parts[0] === '+' ? minutes : -minutes;
	      }
	    }]
	  };
	  parseFlags.dd = parseFlags.d;
	  parseFlags.dddd = parseFlags.ddd;
	  parseFlags.DD = parseFlags.D;
	  parseFlags.mm = parseFlags.m;
	  parseFlags.hh = parseFlags.H = parseFlags.HH = parseFlags.h;
	  parseFlags.MM = parseFlags.M;
	  parseFlags.ss = parseFlags.s;
	  parseFlags.A = parseFlags.a;
	
	  // Some common format strings
	  fecha.masks = {
	    default: 'ddd MMM dd yyyy HH:mm:ss',
	    shortDate: 'M/D/yy',
	    mediumDate: 'MMM d, yyyy',
	    longDate: 'MMMM d, yyyy',
	    fullDate: 'dddd, MMMM d, yyyy',
	    shortTime: 'HH:mm',
	    mediumTime: 'HH:mm:ss',
	    longTime: 'HH:mm:ss.SSS'
	  };
	
	  /***
	   * Format a date
	   * @method format
	   * @param {Date|number} dateObj
	   * @param {string} mask Format of the date, i.e. 'mm-dd-yy' or 'shortDate'
	   */
	  fecha.format = function (dateObj, mask, i18nSettings) {
	    var i18n = i18nSettings || fecha.i18n;
	
	    if (typeof dateObj === 'number') {
	      dateObj = new Date(dateObj);
	    }
	
	    if (Object.prototype.toString.call(dateObj) !== '[object Date]' || isNaN(dateObj.getTime())) {
	      throw new Error('Invalid Date in fecha.format');
	    }
	
	    mask = fecha.masks[mask] || mask || fecha.masks['default'];
	
	    var literals = [];
	
	    // Make literals inactive by replacing them with ??
	    mask = mask.replace(literal, function ($0, $1) {
	      literals.push($1);
	      return '@@@';
	    });
	    // Apply formatting rules
	    mask = mask.replace(token, function ($0) {
	      return $0 in formatFlags ? formatFlags[$0](dateObj, i18n) : $0.slice(1, $0.length - 1);
	    });
	    // Inline literal values back into the formatted value
	    return mask.replace(/@@@/g, function () {
	      return literals.shift();
	    });
	  };
	
	  /**
	   * Parse a date string into an object, changes - into /
	   * @method parse
	   * @param {string} dateStr Date string
	   * @param {string} format Date parse format
	   * @returns {Date|boolean}
	   */
	  fecha.parse = function (dateStr, format, i18nSettings) {
	    var i18n = i18nSettings || fecha.i18n;
	
	    if (typeof format !== 'string') {
	      throw new Error('Invalid format in fecha.parse');
	    }
	
	    format = fecha.masks[format] || format;
	
	    // Avoid regular expression denial of service, fail early for really long strings
	    // https://www.owasp.org/index.php/Regular_expression_Denial_of_Service_-_ReDoS
	    if (dateStr.length > 1000) {
	      return null;
	    }
	
	    var dateInfo = {};
	    var parseInfo = [];
	    var literals = [];
	    format = format.replace(literal, function ($0, $1) {
	      literals.push($1);
	      return '@@@';
	    });
	    var newFormat = regexEscape(format).replace(token, function ($0) {
	      if (parseFlags[$0]) {
	        var info = parseFlags[$0];
	        parseInfo.push(info[1]);
	        return '(' + info[0] + ')';
	      }
	
	      return $0;
	    });
	    newFormat = newFormat.replace(/@@@/g, function () {
	      return literals.shift();
	    });
	    var matches = dateStr.match(new RegExp(newFormat, 'i'));
	    if (!matches) {
	      return null;
	    }
	
	    for (var i = 1; i < matches.length; i++) {
	      parseInfo[i - 1](dateInfo, matches[i], i18n);
	    }
	
	    var today = new Date();
	    if (dateInfo.isPm === true && dateInfo.hour != null && +dateInfo.hour !== 12) {
	      dateInfo.hour = +dateInfo.hour + 12;
	    } else if (dateInfo.isPm === false && +dateInfo.hour === 12) {
	      dateInfo.hour = 0;
	    }
	
	    var date;
	    if (dateInfo.timezoneOffset != null) {
	      dateInfo.minute = +(dateInfo.minute || 0) - +dateInfo.timezoneOffset;
	      date = new Date(Date.UTC(dateInfo.year || today.getFullYear(), dateInfo.month || 0, dateInfo.day || 1, dateInfo.hour || 0, dateInfo.minute || 0, dateInfo.second || 0, dateInfo.millisecond || 0));
	    } else {
	      date = new Date(dateInfo.year || today.getFullYear(), dateInfo.month || 0, dateInfo.day || 1, dateInfo.hour || 0, dateInfo.minute || 0, dateInfo.second || 0, dateInfo.millisecond || 0);
	    }
	    return date;
	  };
	
	  /* istanbul ignore next */
	  if (typeof module !== 'undefined' && module.exports) {
	    module.exports = fecha;
	  } else if (true) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return fecha;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else {
	    main.fecha = fecha;
	  }
	})(undefined);

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.PopupManager = undefined;
	
	var _vue = __webpack_require__(20);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _merge = __webpack_require__(91);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _popupManager = __webpack_require__(400);
	
	var _popupManager2 = _interopRequireDefault(_popupManager);
	
	var _scrollbarWidth = __webpack_require__(132);
	
	var _scrollbarWidth2 = _interopRequireDefault(_scrollbarWidth);
	
	var _dom = __webpack_require__(42);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var idSeed = 1;
	
	var scrollBarWidth = void 0;
	
	exports.default = {
	  props: {
	    visible: {
	      type: Boolean,
	      default: false
	    },
	    openDelay: {},
	    closeDelay: {},
	    zIndex: {},
	    modal: {
	      type: Boolean,
	      default: false
	    },
	    modalFade: {
	      type: Boolean,
	      default: true
	    },
	    modalClass: {},
	    modalAppendToBody: {
	      type: Boolean,
	      default: false
	    },
	    lockScroll: {
	      type: Boolean,
	      default: true
	    },
	    closeOnPressEscape: {
	      type: Boolean,
	      default: false
	    },
	    closeOnClickModal: {
	      type: Boolean,
	      default: false
	    }
	  },
	
	  beforeMount: function beforeMount() {
	    this._popupId = 'popup-' + idSeed++;
	    _popupManager2.default.register(this._popupId, this);
	  },
	  beforeDestroy: function beforeDestroy() {
	    _popupManager2.default.deregister(this._popupId);
	    _popupManager2.default.closeModal(this._popupId);
	
	    this.restoreBodyStyle();
	  },
	  data: function data() {
	    return {
	      opened: false,
	      bodyPaddingRight: null,
	      computedBodyPaddingRight: 0,
	      withoutHiddenClass: true,
	      rendered: false
	    };
	  },
	
	
	  watch: {
	    visible: function visible(val) {
	      var _this = this;
	
	      if (val) {
	        if (this._opening) return;
	        if (!this.rendered) {
	          this.rendered = true;
	          _vue2.default.nextTick(function () {
	            _this.open();
	          });
	        } else {
	          this.open();
	        }
	      } else {
	        this.close();
	      }
	    }
	  },
	
	  methods: {
	    open: function open(options) {
	      var _this2 = this;
	
	      if (!this.rendered) {
	        this.rendered = true;
	      }
	
	      var props = (0, _merge2.default)({}, this.$props || this, options);
	
	      if (this._closeTimer) {
	        clearTimeout(this._closeTimer);
	        this._closeTimer = null;
	      }
	      clearTimeout(this._openTimer);
	
	      var openDelay = Number(props.openDelay);
	      if (openDelay > 0) {
	        this._openTimer = setTimeout(function () {
	          _this2._openTimer = null;
	          _this2.doOpen(props);
	        }, openDelay);
	      } else {
	        this.doOpen(props);
	      }
	    },
	    doOpen: function doOpen(props) {
	      if (this.$isServer) return;
	      if (this.willOpen && !this.willOpen()) return;
	      if (this.opened) return;
	
	      this._opening = true;
	
	      var dom = this.$el;
	
	      var modal = props.modal;
	
	      var zIndex = props.zIndex;
	      if (zIndex) {
	        _popupManager2.default.zIndex = zIndex;
	      }
	
	      if (modal) {
	        if (this._closing) {
	          _popupManager2.default.closeModal(this._popupId);
	          this._closing = false;
	        }
	        _popupManager2.default.openModal(this._popupId, _popupManager2.default.nextZIndex(), this.modalAppendToBody ? undefined : dom, props.modalClass, props.modalFade);
	        if (props.lockScroll) {
	          this.withoutHiddenClass = !(0, _dom.hasClass)(document.body, 'el-popup-parent--hidden');
	          if (this.withoutHiddenClass) {
	            this.bodyPaddingRight = document.body.style.paddingRight;
	            this.computedBodyPaddingRight = parseInt((0, _dom.getStyle)(document.body, 'paddingRight'), 10);
	          }
	          scrollBarWidth = (0, _scrollbarWidth2.default)();
	          var bodyHasOverflow = document.documentElement.clientHeight < document.body.scrollHeight;
	          var bodyOverflowY = (0, _dom.getStyle)(document.body, 'overflowY');
	          if (scrollBarWidth > 0 && (bodyHasOverflow || bodyOverflowY === 'scroll') && this.withoutHiddenClass) {
	            document.body.style.paddingRight = this.computedBodyPaddingRight + scrollBarWidth + 'px';
	          }
	          (0, _dom.addClass)(document.body, 'el-popup-parent--hidden');
	        }
	      }
	
	      if (getComputedStyle(dom).position === 'static') {
	        dom.style.position = 'absolute';
	      }
	
	      dom.style.zIndex = _popupManager2.default.nextZIndex();
	      this.opened = true;
	
	      this.onOpen && this.onOpen();
	
	      this.doAfterOpen();
	    },
	    doAfterOpen: function doAfterOpen() {
	      this._opening = false;
	    },
	    close: function close() {
	      var _this3 = this;
	
	      if (this.willClose && !this.willClose()) return;
	
	      if (this._openTimer !== null) {
	        clearTimeout(this._openTimer);
	        this._openTimer = null;
	      }
	      clearTimeout(this._closeTimer);
	
	      var closeDelay = Number(this.closeDelay);
	
	      if (closeDelay > 0) {
	        this._closeTimer = setTimeout(function () {
	          _this3._closeTimer = null;
	          _this3.doClose();
	        }, closeDelay);
	      } else {
	        this.doClose();
	      }
	    },
	    doClose: function doClose() {
	      this._closing = true;
	
	      this.onClose && this.onClose();
	
	      if (this.lockScroll) {
	        setTimeout(this.restoreBodyStyle, 200);
	      }
	
	      this.opened = false;
	
	      this.doAfterClose();
	    },
	    doAfterClose: function doAfterClose() {
	      _popupManager2.default.closeModal(this._popupId);
	      this._closing = false;
	    },
	    restoreBodyStyle: function restoreBodyStyle() {
	      if (this.modal && this.withoutHiddenClass) {
	        document.body.style.paddingRight = this.bodyPaddingRight;
	        (0, _dom.removeClass)(document.body, 'el-popup-parent--hidden');
	      }
	      this.withoutHiddenClass = true;
	    }
	  }
	};
	exports.PopupManager = _popupManager2.default;

/***/ }),
/* 181 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.isString = isString;
	exports.isObject = isObject;
	exports.isHtmlElement = isHtmlElement;
	function isString(obj) {
	  return Object.prototype.toString.call(obj) === '[object String]';
	}
	
	function isObject(obj) {
	  return Object.prototype.toString.call(obj) === '[object Object]';
	}
	
	function isHtmlElement(node) {
	  return node && node.nodeType === Node.ELEMENT_NODE;
	}
	
	var isFunction = exports.isFunction = function isFunction(functionToCheck) {
	  var getType = {};
	  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
	};
	
	var isUndefined = exports.isUndefined = function isUndefined(val) {
	  return val === void 0;
	};
	
	var isDefined = exports.isDefined = function isDefined(val) {
	  return val !== undefined && val !== null;
	};

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var prosemirrorTransform = __webpack_require__(25);
	var prosemirrorModel = __webpack_require__(12);
	var prosemirrorState = __webpack_require__(6);
	
	// :: (EditorState, ?(tr: Transaction)) → bool
	// Delete the selection, if there is one.
	function deleteSelection(state, dispatch) {
	  if (state.selection.empty) { return false }
	  if (dispatch) { dispatch(state.tr.deleteSelection().scrollIntoView()); }
	  return true
	}
	
	// :: (EditorState, ?(tr: Transaction), ?EditorView) → bool
	// If the selection is empty and at the start of a textblock, try to
	// reduce the distance between that block and the one before it—if
	// there's a block directly before it that can be joined, join them.
	// If not, try to move the selected block closer to the next one in
	// the document structure by lifting it out of its parent or moving it
	// into a parent of the previous block. Will use the view for accurate
	// (bidi-aware) start-of-textblock detection if given.
	function joinBackward(state, dispatch, view) {
	  var ref = state.selection;
	  var $cursor = ref.$cursor;
	  if (!$cursor || (view ? !view.endOfTextblock("backward", state)
	                        : $cursor.parentOffset > 0))
	    { return false }
	
	  var $cut = findCutBefore($cursor);
	
	  // If there is no node before this, try to lift
	  if (!$cut) {
	    var range = $cursor.blockRange(), target = range && prosemirrorTransform.liftTarget(range);
	    if (target == null) { return false }
	    if (dispatch) { dispatch(state.tr.lift(range, target).scrollIntoView()); }
	    return true
	  }
	
	  var before = $cut.nodeBefore;
	  // Apply the joining algorithm
	  if (!before.type.spec.isolating && deleteBarrier(state, $cut, dispatch))
	    { return true }
	
	  // If the node below has no content and the node above is
	  // selectable, delete the node below and select the one above.
	  if ($cursor.parent.content.size == 0 &&
	      (textblockAt(before, "end") || prosemirrorState.NodeSelection.isSelectable(before))) {
	    if (dispatch) {
	      var tr = state.tr.deleteRange($cursor.before(), $cursor.after());
	      tr.setSelection(textblockAt(before, "end") ? prosemirrorState.Selection.findFrom(tr.doc.resolve(tr.mapping.map($cut.pos, -1)), -1)
	                      : prosemirrorState.NodeSelection.create(tr.doc, $cut.pos - before.nodeSize));
	      dispatch(tr.scrollIntoView());
	    }
	    return true
	  }
	
	  // If the node before is an atom, delete it
	  if (before.isAtom && $cut.depth == $cursor.depth - 1) {
	    if (dispatch) { dispatch(state.tr.delete($cut.pos - before.nodeSize, $cut.pos).scrollIntoView()); }
	    return true
	  }
	
	  return false
	}
	
	function textblockAt(node, side) {
	  for (; node; node = (side == "start" ? node.firstChild : node.lastChild))
	    { if (node.isTextblock) { return true } }
	  return false
	}
	
	// :: (EditorState, ?(tr: Transaction), ?EditorView) → bool
	// When the selection is empty and at the start of a textblock, select
	// the node before that textblock, if possible. This is intended to be
	// bound to keys like backspace, after
	// [`joinBackward`](#commands.joinBackward) or other deleting
	// commands, as a fall-back behavior when the schema doesn't allow
	// deletion at the selected point.
	function selectNodeBackward(state, dispatch, view) {
	  var ref = state.selection;
	  var $cursor = ref.$cursor;
	  if (!$cursor || (view ? !view.endOfTextblock("backward", state)
	                        : $cursor.parentOffset > 0))
	    { return false }
	
	  var $cut = findCutBefore($cursor), node = $cut && $cut.nodeBefore;
	  if (!node || !prosemirrorState.NodeSelection.isSelectable(node)) { return false }
	  if (dispatch)
	    { dispatch(state.tr.setSelection(prosemirrorState.NodeSelection.create(state.doc, $cut.pos - node.nodeSize)).scrollIntoView()); }
	  return true
	}
	
	function findCutBefore($pos) {
	  if (!$pos.parent.type.spec.isolating) { for (var i = $pos.depth - 1; i >= 0; i--) {
	    if ($pos.index(i) > 0) { return $pos.doc.resolve($pos.before(i + 1)) }
	    if ($pos.node(i).type.spec.isolating) { break }
	  } }
	  return null
	}
	
	// :: (EditorState, ?(tr: Transaction), ?EditorView) → bool
	// If the selection is empty and the cursor is at the end of a
	// textblock, try to reduce or remove the boundary between that block
	// and the one after it, either by joining them or by moving the other
	// block closer to this one in the tree structure. Will use the view
	// for accurate start-of-textblock detection if given.
	function joinForward(state, dispatch, view) {
	  var ref = state.selection;
	  var $cursor = ref.$cursor;
	  if (!$cursor || (view ? !view.endOfTextblock("forward", state)
	                        : $cursor.parentOffset < $cursor.parent.content.size))
	    { return false }
	
	  var $cut = findCutAfter($cursor);
	
	  // If there is no node after this, there's nothing to do
	  if (!$cut) { return false }
	
	  var after = $cut.nodeAfter;
	  // Try the joining algorithm
	  if (deleteBarrier(state, $cut, dispatch)) { return true }
	
	  // If the node above has no content and the node below is
	  // selectable, delete the node above and select the one below.
	  if ($cursor.parent.content.size == 0 &&
	      (textblockAt(after, "start") || prosemirrorState.NodeSelection.isSelectable(after))) {
	    if (dispatch) {
	      var tr = state.tr.deleteRange($cursor.before(), $cursor.after());
	      tr.setSelection(textblockAt(after, "start") ? prosemirrorState.Selection.findFrom(tr.doc.resolve(tr.mapping.map($cut.pos)), 1)
	                      : prosemirrorState.NodeSelection.create(tr.doc, tr.mapping.map($cut.pos)));
	      dispatch(tr.scrollIntoView());
	    }
	    return true
	  }
	
	  // If the next node is an atom, delete it
	  if (after.isAtom && $cut.depth == $cursor.depth - 1) {
	    if (dispatch) { dispatch(state.tr.delete($cut.pos, $cut.pos + after.nodeSize).scrollIntoView()); }
	    return true
	  }
	
	  return false
	}
	
	// :: (EditorState, ?(tr: Transaction), ?EditorView) → bool
	// When the selection is empty and at the end of a textblock, select
	// the node coming after that textblock, if possible. This is intended
	// to be bound to keys like delete, after
	// [`joinForward`](#commands.joinForward) and similar deleting
	// commands, to provide a fall-back behavior when the schema doesn't
	// allow deletion at the selected point.
	function selectNodeForward(state, dispatch, view) {
	  var ref = state.selection;
	  var $cursor = ref.$cursor;
	  if (!$cursor || (view ? !view.endOfTextblock("forward", state)
	                        : $cursor.parentOffset < $cursor.parent.content.size))
	    { return false }
	
	  var $cut = findCutAfter($cursor), node = $cut && $cut.nodeAfter;
	  if (!node || !prosemirrorState.NodeSelection.isSelectable(node)) { return false }
	  if (dispatch)
	    { dispatch(state.tr.setSelection(prosemirrorState.NodeSelection.create(state.doc, $cut.pos)).scrollIntoView()); }
	  return true
	}
	
	function findCutAfter($pos) {
	  if (!$pos.parent.type.spec.isolating) { for (var i = $pos.depth - 1; i >= 0; i--) {
	    var parent = $pos.node(i);
	    if ($pos.index(i) + 1 < parent.childCount) { return $pos.doc.resolve($pos.after(i + 1)) }
	    if (parent.type.spec.isolating) { break }
	  } }
	  return null
	}
	
	// :: (EditorState, ?(tr: Transaction)) → bool
	// Join the selected block or, if there is a text selection, the
	// closest ancestor block of the selection that can be joined, with
	// the sibling above it.
	function joinUp(state, dispatch) {
	  var sel = state.selection, nodeSel = sel instanceof prosemirrorState.NodeSelection, point;
	  if (nodeSel) {
	    if (sel.node.isTextblock || !prosemirrorTransform.canJoin(state.doc, sel.from)) { return false }
	    point = sel.from;
	  } else {
	    point = prosemirrorTransform.joinPoint(state.doc, sel.from, -1);
	    if (point == null) { return false }
	  }
	  if (dispatch) {
	    var tr = state.tr.join(point);
	    if (nodeSel) { tr.setSelection(prosemirrorState.NodeSelection.create(tr.doc, point - state.doc.resolve(point).nodeBefore.nodeSize)); }
	    dispatch(tr.scrollIntoView());
	  }
	  return true
	}
	
	// :: (EditorState, ?(tr: Transaction)) → bool
	// Join the selected block, or the closest ancestor of the selection
	// that can be joined, with the sibling after it.
	function joinDown(state, dispatch) {
	  var sel = state.selection, point;
	  if (sel instanceof prosemirrorState.NodeSelection) {
	    if (sel.node.isTextblock || !prosemirrorTransform.canJoin(state.doc, sel.to)) { return false }
	    point = sel.to;
	  } else {
	    point = prosemirrorTransform.joinPoint(state.doc, sel.to, 1);
	    if (point == null) { return false }
	  }
	  if (dispatch)
	    { dispatch(state.tr.join(point).scrollIntoView()); }
	  return true
	}
	
	// :: (EditorState, ?(tr: Transaction)) → bool
	// Lift the selected block, or the closest ancestor block of the
	// selection that can be lifted, out of its parent node.
	function lift(state, dispatch) {
	  var ref = state.selection;
	  var $from = ref.$from;
	  var $to = ref.$to;
	  var range = $from.blockRange($to), target = range && prosemirrorTransform.liftTarget(range);
	  if (target == null) { return false }
	  if (dispatch) { dispatch(state.tr.lift(range, target).scrollIntoView()); }
	  return true
	}
	
	// :: (EditorState, ?(tr: Transaction)) → bool
	// If the selection is in a node whose type has a truthy
	// [`code`](#model.NodeSpec.code) property in its spec, replace the
	// selection with a newline character.
	function newlineInCode(state, dispatch) {
	  var ref = state.selection;
	  var $head = ref.$head;
	  var $anchor = ref.$anchor;
	  if (!$head.parent.type.spec.code || !$head.sameParent($anchor)) { return false }
	  if (dispatch) { dispatch(state.tr.insertText("\n").scrollIntoView()); }
	  return true
	}
	
	function defaultBlockAt(match) {
	  for (var i = 0; i < match.edgeCount; i++) {
	    var ref = match.edge(i);
	    var type = ref.type;
	    if (type.isTextblock && !type.hasRequiredAttrs()) { return type }
	  }
	  return null
	}
	
	// :: (EditorState, ?(tr: Transaction)) → bool
	// When the selection is in a node with a truthy
	// [`code`](#model.NodeSpec.code) property in its spec, create a
	// default block after the code block, and move the cursor there.
	function exitCode(state, dispatch) {
	  var ref = state.selection;
	  var $head = ref.$head;
	  var $anchor = ref.$anchor;
	  if (!$head.parent.type.spec.code || !$head.sameParent($anchor)) { return false }
	  var above = $head.node(-1), after = $head.indexAfter(-1), type = defaultBlockAt(above.contentMatchAt(after));
	  if (!above.canReplaceWith(after, after, type)) { return false }
	  if (dispatch) {
	    var pos = $head.after(), tr = state.tr.replaceWith(pos, pos, type.createAndFill());
	    tr.setSelection(prosemirrorState.Selection.near(tr.doc.resolve(pos), 1));
	    dispatch(tr.scrollIntoView());
	  }
	  return true
	}
	
	// :: (EditorState, ?(tr: Transaction)) → bool
	// If a block node is selected, create an empty paragraph before (if
	// it is its parent's first child) or after it.
	function createParagraphNear(state, dispatch) {
	  var ref = state.selection;
	  var $from = ref.$from;
	  var $to = ref.$to;
	  if ($from.parent.inlineContent || $to.parent.inlineContent) { return false }
	  var type = defaultBlockAt($from.parent.contentMatchAt($to.indexAfter()));
	  if (!type || !type.isTextblock) { return false }
	  if (dispatch) {
	    var side = (!$from.parentOffset && $to.index() < $to.parent.childCount ? $from : $to).pos;
	    var tr = state.tr.insert(side, type.createAndFill());
	    tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, side + 1));
	    dispatch(tr.scrollIntoView());
	  }
	  return true
	}
	
	// :: (EditorState, ?(tr: Transaction)) → bool
	// If the cursor is in an empty textblock that can be lifted, lift the
	// block.
	function liftEmptyBlock(state, dispatch) {
	  var ref = state.selection;
	  var $cursor = ref.$cursor;
	  if (!$cursor || $cursor.parent.content.size) { return false }
	  if ($cursor.depth > 1 && $cursor.after() != $cursor.end(-1)) {
	    var before = $cursor.before();
	    if (prosemirrorTransform.canSplit(state.doc, before)) {
	      if (dispatch) { dispatch(state.tr.split(before).scrollIntoView()); }
	      return true
	    }
	  }
	  var range = $cursor.blockRange(), target = range && prosemirrorTransform.liftTarget(range);
	  if (target == null) { return false }
	  if (dispatch) { dispatch(state.tr.lift(range, target).scrollIntoView()); }
	  return true
	}
	
	// :: (EditorState, ?(tr: Transaction)) → bool
	// Split the parent block of the selection. If the selection is a text
	// selection, also delete its content.
	function splitBlock(state, dispatch) {
	  var ref = state.selection;
	  var $from = ref.$from;
	  var $to = ref.$to;
	  if (state.selection instanceof prosemirrorState.NodeSelection && state.selection.node.isBlock) {
	    if (!$from.parentOffset || !prosemirrorTransform.canSplit(state.doc, $from.pos)) { return false }
	    if (dispatch) { dispatch(state.tr.split($from.pos).scrollIntoView()); }
	    return true
	  }
	
	  if (!$from.parent.isBlock) { return false }
	
	  if (dispatch) {
	    var atEnd = $to.parentOffset == $to.parent.content.size;
	    var tr = state.tr;
	    if (state.selection instanceof prosemirrorState.TextSelection) { tr.deleteSelection(); }
	    var deflt = $from.depth == 0 ? null : defaultBlockAt($from.node(-1).contentMatchAt($from.indexAfter(-1)));
	    var types = atEnd && deflt ? [{type: deflt}] : null;
	    var can = prosemirrorTransform.canSplit(tr.doc, tr.mapping.map($from.pos), 1, types);
	    if (!types && !can && prosemirrorTransform.canSplit(tr.doc, tr.mapping.map($from.pos), 1, deflt && [{type: deflt}])) {
	      types = [{type: deflt}];
	      can = true;
	    }
	    if (can) {
	      tr.split(tr.mapping.map($from.pos), 1, types);
	      if (!atEnd && !$from.parentOffset && $from.parent.type != deflt &&
	          $from.node(-1).canReplace($from.index(-1), $from.indexAfter(-1), prosemirrorModel.Fragment.from(deflt.create(), $from.parent)))
	        { tr.setNodeMarkup(tr.mapping.map($from.before()), deflt); }
	    }
	    dispatch(tr.scrollIntoView());
	  }
	  return true
	}
	
	// :: (EditorState, ?(tr: Transaction)) → bool
	// Acts like [`splitBlock`](#commands.splitBlock), but without
	// resetting the set of active marks at the cursor.
	function splitBlockKeepMarks(state, dispatch) {
	  return splitBlock(state, dispatch && (function (tr) {
	    var marks = state.storedMarks || (state.selection.$to.parentOffset && state.selection.$from.marks());
	    if (marks) { tr.ensureMarks(marks); }
	    dispatch(tr);
	  }))
	}
	
	// :: (EditorState, ?(tr: Transaction)) → bool
	// Move the selection to the node wrapping the current selection, if
	// any. (Will not select the document node.)
	function selectParentNode(state, dispatch) {
	  var ref = state.selection;
	  var $from = ref.$from;
	  var to = ref.to;
	  var pos;
	  var same = $from.sharedDepth(to);
	  if (same == 0) { return false }
	  pos = $from.before(same);
	  if (dispatch) { dispatch(state.tr.setSelection(prosemirrorState.NodeSelection.create(state.doc, pos))); }
	  return true
	}
	
	// :: (EditorState, ?(tr: Transaction)) → bool
	// Select the whole document.
	function selectAll(state, dispatch) {
	  if (dispatch) { dispatch(state.tr.setSelection(new prosemirrorState.AllSelection(state.doc))); }
	  return true
	}
	
	function joinMaybeClear(state, $pos, dispatch) {
	  var before = $pos.nodeBefore, after = $pos.nodeAfter, index = $pos.index();
	  if (!before || !after || !before.type.compatibleContent(after.type)) { return false }
	  if (!before.content.size && $pos.parent.canReplace(index - 1, index)) {
	    if (dispatch) { dispatch(state.tr.delete($pos.pos - before.nodeSize, $pos.pos).scrollIntoView()); }
	    return true
	  }
	  if (!$pos.parent.canReplace(index, index + 1) || !(after.isTextblock || prosemirrorTransform.canJoin(state.doc, $pos.pos)))
	    { return false }
	  if (dispatch)
	    { dispatch(state.tr
	             .clearIncompatible($pos.pos, before.type, before.contentMatchAt(before.childCount))
	             .join($pos.pos)
	             .scrollIntoView()); }
	  return true
	}
	
	function deleteBarrier(state, $cut, dispatch) {
	  var before = $cut.nodeBefore, after = $cut.nodeAfter, conn, match;
	  if (before.type.spec.isolating || after.type.spec.isolating) { return false }
	  if (joinMaybeClear(state, $cut, dispatch)) { return true }
	
	  if ($cut.parent.canReplace($cut.index(), $cut.index() + 1) &&
	      (conn = (match = before.contentMatchAt(before.childCount)).findWrapping(after.type)) &&
	      match.matchType(conn[0] || after.type).validEnd) {
	    if (dispatch) {
	      var end = $cut.pos + after.nodeSize, wrap = prosemirrorModel.Fragment.empty;
	      for (var i = conn.length - 1; i >= 0; i--)
	        { wrap = prosemirrorModel.Fragment.from(conn[i].create(null, wrap)); }
	      wrap = prosemirrorModel.Fragment.from(before.copy(wrap));
	      var tr = state.tr.step(new prosemirrorTransform.ReplaceAroundStep($cut.pos - 1, end, $cut.pos, end, new prosemirrorModel.Slice(wrap, 1, 0), conn.length, true));
	      var joinAt = end + 2 * conn.length;
	      if (prosemirrorTransform.canJoin(tr.doc, joinAt)) { tr.join(joinAt); }
	      dispatch(tr.scrollIntoView());
	    }
	    return true
	  }
	
	  var selAfter = prosemirrorState.Selection.findFrom($cut, 1);
	  var range = selAfter && selAfter.$from.blockRange(selAfter.$to), target = range && prosemirrorTransform.liftTarget(range);
	  if (target != null && target >= $cut.depth) {
	    if (dispatch) { dispatch(state.tr.lift(range, target).scrollIntoView()); }
	    return true
	  }
	
	  return false
	}
	
	// Parameterized commands
	
	// :: (NodeType, ?Object) → (state: EditorState, dispatch: ?(tr: Transaction)) → bool
	// Wrap the selection in a node of the given type with the given
	// attributes.
	function wrapIn(nodeType, attrs) {
	  return function(state, dispatch) {
	    var ref = state.selection;
	    var $from = ref.$from;
	    var $to = ref.$to;
	    var range = $from.blockRange($to), wrapping = range && prosemirrorTransform.findWrapping(range, nodeType, attrs);
	    if (!wrapping) { return false }
	    if (dispatch) { dispatch(state.tr.wrap(range, wrapping).scrollIntoView()); }
	    return true
	  }
	}
	
	// :: (NodeType, ?Object) → (state: EditorState, dispatch: ?(tr: Transaction)) → bool
	// Returns a command that tries to set the selected textblocks to the
	// given node type with the given attributes.
	function setBlockType(nodeType, attrs) {
	  return function(state, dispatch) {
	    var ref = state.selection;
	    var from = ref.from;
	    var to = ref.to;
	    var applicable = false;
	    state.doc.nodesBetween(from, to, function (node, pos) {
	      if (applicable) { return false }
	      if (!node.isTextblock || node.hasMarkup(nodeType, attrs)) { return }
	      if (node.type == nodeType) {
	        applicable = true;
	      } else {
	        var $pos = state.doc.resolve(pos), index = $pos.index();
	        applicable = $pos.parent.canReplaceWith(index, index + 1, nodeType);
	      }
	    });
	    if (!applicable) { return false }
	    if (dispatch) { dispatch(state.tr.setBlockType(from, to, nodeType, attrs).scrollIntoView()); }
	    return true
	  }
	}
	
	function markApplies(doc, ranges, type) {
	  var loop = function ( i ) {
	    var ref = ranges[i];
	    var $from = ref.$from;
	    var $to = ref.$to;
	    var can = $from.depth == 0 ? doc.type.allowsMarkType(type) : false;
	    doc.nodesBetween($from.pos, $to.pos, function (node) {
	      if (can) { return false }
	      can = node.inlineContent && node.type.allowsMarkType(type);
	    });
	    if (can) { return { v: true } }
	  };
	
	  for (var i = 0; i < ranges.length; i++) {
	    var returned = loop( i );
	
	    if ( returned ) return returned.v;
	  }
	  return false
	}
	
	// :: (MarkType, ?Object) → (state: EditorState, dispatch: ?(tr: Transaction)) → bool
	// Create a command function that toggles the given mark with the
	// given attributes. Will return `false` when the current selection
	// doesn't support that mark. This will remove the mark if any marks
	// of that type exist in the selection, or add it otherwise. If the
	// selection is empty, this applies to the [stored
	// marks](#state.EditorState.storedMarks) instead of a range of the
	// document.
	function toggleMark(markType, attrs) {
	  return function(state, dispatch) {
	    var ref = state.selection;
	    var empty = ref.empty;
	    var $cursor = ref.$cursor;
	    var ranges = ref.ranges;
	    if ((empty && !$cursor) || !markApplies(state.doc, ranges, markType)) { return false }
	    if (dispatch) {
	      if ($cursor) {
	        if (markType.isInSet(state.storedMarks || $cursor.marks()))
	          { dispatch(state.tr.removeStoredMark(markType)); }
	        else
	          { dispatch(state.tr.addStoredMark(markType.create(attrs))); }
	      } else {
	        var has = false, tr = state.tr;
	        for (var i = 0; !has && i < ranges.length; i++) {
	          var ref$1 = ranges[i];
	          var $from = ref$1.$from;
	          var $to = ref$1.$to;
	          has = state.doc.rangeHasMark($from.pos, $to.pos, markType);
	        }
	        for (var i$1 = 0; i$1 < ranges.length; i$1++) {
	          var ref$2 = ranges[i$1];
	          var $from$1 = ref$2.$from;
	          var $to$1 = ref$2.$to;
	          if (has) { tr.removeMark($from$1.pos, $to$1.pos, markType); }
	          else { tr.addMark($from$1.pos, $to$1.pos, markType.create(attrs)); }
	        }
	        dispatch(tr.scrollIntoView());
	      }
	    }
	    return true
	  }
	}
	
	function wrapDispatchForJoin(dispatch, isJoinable) {
	  return function (tr) {
	    if (!tr.isGeneric) { return dispatch(tr) }
	
	    var ranges = [];
	    for (var i = 0; i < tr.mapping.maps.length; i++) {
	      var map = tr.mapping.maps[i];
	      for (var j = 0; j < ranges.length; j++)
	        { ranges[j] = map.map(ranges[j]); }
	      map.forEach(function (_s, _e, from, to) { return ranges.push(from, to); });
	    }
	
	    // Figure out which joinable points exist inside those ranges,
	    // by checking all node boundaries in their parent nodes.
	    var joinable = [];
	    for (var i$1 = 0; i$1 < ranges.length; i$1 += 2) {
	      var from = ranges[i$1], to = ranges[i$1 + 1];
	      var $from = tr.doc.resolve(from), depth = $from.sharedDepth(to), parent = $from.node(depth);
	      for (var index = $from.indexAfter(depth), pos = $from.after(depth + 1); pos <= to; ++index) {
	        var after = parent.maybeChild(index);
	        if (!after) { break }
	        if (index && joinable.indexOf(pos) == -1) {
	          var before = parent.child(index - 1);
	          if (before.type == after.type && isJoinable(before, after))
	            { joinable.push(pos); }
	        }
	        pos += after.nodeSize;
	      }
	    }
	    // Join the joinable points
	    joinable.sort(function (a, b) { return a - b; });
	    for (var i$2 = joinable.length - 1; i$2 >= 0; i$2--) {
	      if (prosemirrorTransform.canJoin(tr.doc, joinable[i$2])) { tr.join(joinable[i$2]); }
	    }
	    dispatch(tr);
	  }
	}
	
	// :: ((state: EditorState, ?(tr: Transaction)) → bool, union<(before: Node, after: Node) → bool, [string]>) → (state: EditorState, ?(tr: Transaction)) → bool
	// Wrap a command so that, when it produces a transform that causes
	// two joinable nodes to end up next to each other, those are joined.
	// Nodes are considered joinable when they are of the same type and
	// when the `isJoinable` predicate returns true for them or, if an
	// array of strings was passed, if their node type name is in that
	// array.
	function autoJoin(command, isJoinable) {
	  if (Array.isArray(isJoinable)) {
	    var types = isJoinable;
	    isJoinable = function (node) { return types.indexOf(node.type.name) > -1; };
	  }
	  return function (state, dispatch) { return command(state, dispatch && wrapDispatchForJoin(dispatch, isJoinable)); }
	}
	
	// :: (...[(EditorState, ?(tr: Transaction), ?EditorView) → bool]) → (EditorState, ?(tr: Transaction), ?EditorView) → bool
	// Combine a number of command functions into a single function (which
	// calls them one by one until one returns true).
	function chainCommands() {
	  var commands = [], len = arguments.length;
	  while ( len-- ) commands[ len ] = arguments[ len ];
	
	  return function(state, dispatch, view) {
	    for (var i = 0; i < commands.length; i++)
	      { if (commands[i](state, dispatch, view)) { return true } }
	    return false
	  }
	}
	
	var backspace = chainCommands(deleteSelection, joinBackward, selectNodeBackward);
	var del = chainCommands(deleteSelection, joinForward, selectNodeForward);
	
	// :: Object
	// A basic keymap containing bindings not specific to any schema.
	// Binds the following keys (when multiple commands are listed, they
	// are chained with [`chainCommands`](#commands.chainCommands)):
	//
	// * **Enter** to `newlineInCode`, `createParagraphNear`, `liftEmptyBlock`, `splitBlock`
	// * **Mod-Enter** to `exitCode`
	// * **Backspace** and **Mod-Backspace** to `deleteSelection`, `joinBackward`, `selectNodeBackward`
	// * **Delete** and **Mod-Delete** to `deleteSelection`, `joinForward`, `selectNodeForward`
	// * **Mod-Delete** to `deleteSelection`, `joinForward`, `selectNodeForward`
	// * **Mod-a** to `selectAll`
	var pcBaseKeymap = {
	  "Enter": chainCommands(newlineInCode, createParagraphNear, liftEmptyBlock, splitBlock),
	  "Mod-Enter": exitCode,
	  "Backspace": backspace,
	  "Mod-Backspace": backspace,
	  "Delete": del,
	  "Mod-Delete": del,
	  "Mod-a": selectAll
	};
	
	// :: Object
	// A copy of `pcBaseKeymap` that also binds **Ctrl-h** like Backspace,
	// **Ctrl-d** like Delete, **Alt-Backspace** like Ctrl-Backspace, and
	// **Ctrl-Alt-Backspace**, **Alt-Delete**, and **Alt-d** like
	// Ctrl-Delete.
	var macBaseKeymap = {
	  "Ctrl-h": pcBaseKeymap["Backspace"],
	  "Alt-Backspace": pcBaseKeymap["Mod-Backspace"],
	  "Ctrl-d": pcBaseKeymap["Delete"],
	  "Ctrl-Alt-Backspace": pcBaseKeymap["Mod-Delete"],
	  "Alt-Delete": pcBaseKeymap["Mod-Delete"],
	  "Alt-d": pcBaseKeymap["Mod-Delete"]
	};
	for (var key in pcBaseKeymap) { macBaseKeymap[key] = pcBaseKeymap[key]; }
	
	// declare global: os, navigator
	var mac = typeof navigator != "undefined" ? /Mac/.test(navigator.platform)
	          : typeof os != "undefined" ? os.platform() == "darwin" : false;
	
	// :: Object
	// Depending on the detected platform, this will hold
	// [`pcBasekeymap`](#commands.pcBaseKeymap) or
	// [`macBaseKeymap`](#commands.macBaseKeymap).
	var baseKeymap = mac ? macBaseKeymap : pcBaseKeymap;
	
	exports.autoJoin = autoJoin;
	exports.baseKeymap = baseKeymap;
	exports.chainCommands = chainCommands;
	exports.createParagraphNear = createParagraphNear;
	exports.deleteSelection = deleteSelection;
	exports.exitCode = exitCode;
	exports.joinBackward = joinBackward;
	exports.joinDown = joinDown;
	exports.joinForward = joinForward;
	exports.joinUp = joinUp;
	exports.lift = lift;
	exports.liftEmptyBlock = liftEmptyBlock;
	exports.macBaseKeymap = macBaseKeymap;
	exports.newlineInCode = newlineInCode;
	exports.pcBaseKeymap = pcBaseKeymap;
	exports.selectAll = selectAll;
	exports.selectNodeBackward = selectNodeBackward;
	exports.selectNodeForward = selectNodeForward;
	exports.selectParentNode = selectParentNode;
	exports.setBlockType = setBlockType;
	exports.splitBlock = splitBlock;
	exports.splitBlockKeepMarks = splitBlockKeepMarks;
	exports.toggleMark = toggleMark;
	exports.wrapIn = wrapIn;
	//# sourceMappingURL=index.js.map


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var RopeSequence = _interopDefault(__webpack_require__(462));
	var prosemirrorTransform = __webpack_require__(25);
	var prosemirrorState = __webpack_require__(6);
	
	// ProseMirror's history isn't simply a way to roll back to a previous
	// state, because ProseMirror supports applying changes without adding
	// them to the history (for example during collaboration).
	//
	// To this end, each 'Branch' (one for the undo history and one for
	// the redo history) keeps an array of 'Items', which can optionally
	// hold a step (an actual undoable change), and always hold a position
	// map (which is needed to move changes below them to apply to the
	// current document).
	//
	// An item that has both a step and a selection bookmark is the start
	// of an 'event' — a group of changes that will be undone or redone at
	// once. (It stores only the bookmark, since that way we don't have to
	// provide a document until the selection is actually applied, which
	// is useful when compressing.)
	
	// Used to schedule history compression
	var max_empty_items = 500;
	
	var Branch = function Branch(items, eventCount) {
	  this.items = items;
	  this.eventCount = eventCount;
	};
	
	// : (EditorState, bool) → ?{transform: Transform, selection: ?SelectionBookmark, remaining: Branch}
	// Pop the latest event off the branch's history and apply it
	// to a document transform.
	Branch.prototype.popEvent = function popEvent (state, preserveItems) {
	    var this$1 = this;
	
	  if (this.eventCount == 0) { return null }
	
	  var end = this.items.length;
	  for (;; end--) {
	    var next = this.items.get(end - 1);
	    if (next.selection) { --end; break }
	  }
	
	  var remap, mapFrom;
	  if (preserveItems) {
	    remap = this.remapping(end, this.items.length);
	    mapFrom = remap.maps.length;
	  }
	  var transform = state.tr;
	  var selection, remaining;
	  var addAfter = [], addBefore = [];
	
	  this.items.forEach(function (item, i) {
	    if (!item.step) {
	      if (!remap) {
	        remap = this$1.remapping(end, i + 1);
	        mapFrom = remap.maps.length;
	      }
	      mapFrom--;
	      addBefore.push(item);
	      return
	    }
	
	    if (remap) {
	      addBefore.push(new Item(item.map));
	      var step = item.step.map(remap.slice(mapFrom)), map;
	
	      if (step && transform.maybeStep(step).doc) {
	        map = transform.mapping.maps[transform.mapping.maps.length - 1];
	        addAfter.push(new Item(map, null, null, addAfter.length + addBefore.length));
	      }
	      mapFrom--;
	      if (map) { remap.appendMap(map, mapFrom); }
	    } else {
	      transform.maybeStep(item.step);
	    }
	
	    if (item.selection) {
	      selection = remap ? item.selection.map(remap.slice(mapFrom)) : item.selection;
	      remaining = new Branch(this$1.items.slice(0, end).append(addBefore.reverse().concat(addAfter)), this$1.eventCount - 1);
	      return false
	    }
	  }, this.items.length, 0);
	
	  return {remaining: remaining, transform: transform, selection: selection}
	};
	
	// : (Transform, ?SelectionBookmark, Object) → Branch
	// Create a new branch with the given transform added.
	Branch.prototype.addTransform = function addTransform (transform, selection, histOptions, preserveItems) {
	  var newItems = [], eventCount = this.eventCount;
	  var oldItems = this.items, lastItem = !preserveItems && oldItems.length ? oldItems.get(oldItems.length - 1) : null;
	
	  for (var i = 0; i < transform.steps.length; i++) {
	    var step = transform.steps[i].invert(transform.docs[i]);
	    var item = new Item(transform.mapping.maps[i], step, selection), merged = (void 0);
	    if (merged = lastItem && lastItem.merge(item)) {
	      item = merged;
	      if (i) { newItems.pop(); }
	      else { oldItems = oldItems.slice(0, oldItems.length - 1); }
	    }
	    newItems.push(item);
	    if (selection) {
	      eventCount++;
	      selection = null;
	    }
	    if (!preserveItems) { lastItem = item; }
	  }
	  var overflow = eventCount - histOptions.depth;
	  if (overflow > DEPTH_OVERFLOW) {
	    oldItems = cutOffEvents(oldItems, overflow);
	    eventCount -= overflow;
	  }
	  return new Branch(oldItems.append(newItems), eventCount)
	};
	
	Branch.prototype.remapping = function remapping (from, to) {
	  var maps = new prosemirrorTransform.Mapping;
	  this.items.forEach(function (item, i) {
	    var mirrorPos = item.mirrorOffset != null && i - item.mirrorOffset >= from
	        ? maps.maps.length - item.mirrorOffset : null;
	    maps.appendMap(item.map, mirrorPos);
	  }, from, to);
	  return maps
	};
	
	Branch.prototype.addMaps = function addMaps (array) {
	  if (this.eventCount == 0) { return this }
	  return new Branch(this.items.append(array.map(function (map) { return new Item(map); })), this.eventCount)
	};
	
	// : (Transform, number)
	// When the collab module receives remote changes, the history has
	// to know about those, so that it can adjust the steps that were
	// rebased on top of the remote changes, and include the position
	// maps for the remote changes in its array of items.
	Branch.prototype.rebased = function rebased (rebasedTransform, rebasedCount) {
	  if (!this.eventCount) { return this }
	
	  var rebasedItems = [], start = Math.max(0, this.items.length - rebasedCount);
	
	  var mapping = rebasedTransform.mapping;
	  var newUntil = rebasedTransform.steps.length;
	  var eventCount = this.eventCount;
	  this.items.forEach(function (item) { if (item.selection) { eventCount--; } }, start);
	
	  var iRebased = rebasedCount;
	  this.items.forEach(function (item) {
	    var pos = mapping.getMirror(--iRebased);
	    if (pos == null) { return }
	    newUntil = Math.min(newUntil, pos);
	    var map = mapping.maps[pos];
	    if (item.step) {
	      var step = rebasedTransform.steps[pos].invert(rebasedTransform.docs[pos]);
	      var selection = item.selection && item.selection.map(mapping.slice(iRebased + 1, pos));
	      if (selection) { eventCount++; }
	      rebasedItems.push(new Item(map, step, selection));
	    } else {
	      rebasedItems.push(new Item(map));
	    }
	  }, start);
	
	  var newMaps = [];
	  for (var i = rebasedCount; i < newUntil; i++)
	    { newMaps.push(new Item(mapping.maps[i])); }
	  var items = this.items.slice(0, start).append(newMaps).append(rebasedItems);
	  var branch = new Branch(items, eventCount);
	
	  if (branch.emptyItemCount() > max_empty_items)
	    { branch = branch.compress(this.items.length - rebasedItems.length); }
	  return branch
	};
	
	Branch.prototype.emptyItemCount = function emptyItemCount () {
	  var count = 0;
	  this.items.forEach(function (item) { if (!item.step) { count++; } });
	  return count
	};
	
	// Compressing a branch means rewriting it to push the air (map-only
	// items) out. During collaboration, these naturally accumulate
	// because each remote change adds one. The `upto` argument is used
	// to ensure that only the items below a given level are compressed,
	// because `rebased` relies on a clean, untouched set of items in
	// order to associate old items with rebased steps.
	Branch.prototype.compress = function compress (upto) {
	    if ( upto === void 0 ) upto = this.items.length;
	
	  var remap = this.remapping(0, upto), mapFrom = remap.maps.length;
	  var items = [], events = 0;
	  this.items.forEach(function (item, i) {
	    if (i >= upto) {
	      items.push(item);
	      if (item.selection) { events++; }
	    } else if (item.step) {
	      var step = item.step.map(remap.slice(mapFrom)), map = step && step.getMap();
	      mapFrom--;
	      if (map) { remap.appendMap(map, mapFrom); }
	      if (step) {
	        var selection = item.selection && item.selection.map(remap.slice(mapFrom));
	        if (selection) { events++; }
	        var newItem = new Item(map.invert(), step, selection), merged, last = items.length - 1;
	        if (merged = items.length && items[last].merge(newItem))
	          { items[last] = merged; }
	        else
	          { items.push(newItem); }
	      }
	    } else if (item.map) {
	      mapFrom--;
	    }
	  }, this.items.length, 0);
	  return new Branch(RopeSequence.from(items.reverse()), events)
	};
	
	Branch.empty = new Branch(RopeSequence.empty, 0);
	
	function cutOffEvents(items, n) {
	  var cutPoint;
	  items.forEach(function (item, i) {
	    if (item.selection && (n-- == 0)) {
	      cutPoint = i;
	      return false
	    }
	  });
	  return items.slice(cutPoint)
	}
	
	var Item = function Item(map, step, selection, mirrorOffset) {
	  // The (forward) step map for this item.
	  this.map = map;
	  // The inverted step
	  this.step = step;
	  // If this is non-null, this item is the start of a group, and
	  // this selection is the starting selection for the group (the one
	  // that was active before the first step was applied)
	  this.selection = selection;
	  // If this item is the inverse of a previous mapping on the stack,
	  // this points at the inverse's offset
	  this.mirrorOffset = mirrorOffset;
	};
	
	Item.prototype.merge = function merge (other) {
	  if (this.step && other.step && !other.selection) {
	    var step = other.step.merge(this.step);
	    if (step) { return new Item(step.getMap().invert(), step, this.selection) }
	  }
	};
	
	// The value of the state field that tracks undo/redo history for that
	// state. Will be stored in the plugin state when the history plugin
	// is active.
	var HistoryState = function HistoryState(done, undone, prevRanges, prevTime) {
	  this.done = done;
	  this.undone = undone;
	  this.prevRanges = prevRanges;
	  this.prevTime = prevTime;
	};
	
	var DEPTH_OVERFLOW = 20;
	
	// : (HistoryState, EditorState, Transaction, Object)
	// Record a transformation in undo history.
	function applyTransaction(history, state, tr, options) {
	  var historyTr = tr.getMeta(historyKey), rebased;
	  if (historyTr) { return historyTr.historyState }
	
	  if (tr.getMeta(closeHistoryKey)) { history = new HistoryState(history.done, history.undone, null, 0); }
	
	  var appended = tr.getMeta("appendedTransaction");
	
	  if (tr.steps.length == 0) {
	    return history
	  } else if (appended && appended.getMeta(historyKey)) {
	    if (appended.getMeta(historyKey).redo)
	      { return new HistoryState(history.done.addTransform(tr, null, options, mustPreserveItems(state)),
	                              history.undone, rangesFor(tr.mapping.maps[tr.steps.length - 1]), history.prevTime) }
	    else
	      { return new HistoryState(history.done, history.undone.addTransform(tr, null, options, mustPreserveItems(state)),
	                              null, history.prevTime) }
	  } else if (tr.getMeta("addToHistory") !== false && !(appended && appended.getMeta("addToHistory") === false)) {
	    // Group transforms that occur in quick succession into one event.
	    var newGroup = history.prevTime == 0 || !appended && (history.prevTime < (tr.time || 0) - options.newGroupDelay ||
	                                                          !isAdjacentTo(tr, history.prevRanges));
	    var prevRanges = appended ? mapRanges(history.prevRanges, tr.mapping) : rangesFor(tr.mapping.maps[tr.steps.length - 1]);
	    return new HistoryState(history.done.addTransform(tr, newGroup ? state.selection.getBookmark() : null,
	                                                      options, mustPreserveItems(state)),
	                            Branch.empty, prevRanges, tr.time)
	  } else if (rebased = tr.getMeta("rebased")) {
	    // Used by the collab module to tell the history that some of its
	    // content has been rebased.
	    return new HistoryState(history.done.rebased(tr, rebased),
	                            history.undone.rebased(tr, rebased),
	                            mapRanges(history.prevRanges, tr.mapping), history.prevTime)
	  } else {
	    return new HistoryState(history.done.addMaps(tr.mapping.maps),
	                            history.undone.addMaps(tr.mapping.maps),
	                            mapRanges(history.prevRanges, tr.mapping), history.prevTime)
	  }
	}
	
	function isAdjacentTo(transform, prevRanges) {
	  if (!prevRanges) { return false }
	  if (!transform.docChanged) { return true }
	  var adjacent = false;
	  transform.mapping.maps[0].forEach(function (start, end) {
	    for (var i = 0; i < prevRanges.length; i += 2)
	      { if (start <= prevRanges[i + 1] && end >= prevRanges[i])
	        { adjacent = true; } }
	  });
	  return adjacent
	}
	
	function rangesFor(map) {
	  var result = [];
	  map.forEach(function (_from, _to, from, to) { return result.push(from, to); });
	  return result
	}
	
	function mapRanges(ranges, mapping) {
	  if (!ranges) { return null }
	  var result = [];
	  for (var i = 0; i < ranges.length; i += 2) {
	    var from = mapping.map(ranges[i], 1), to = mapping.map(ranges[i + 1], -1);
	    if (from <= to) { result.push(from, to); }
	  }
	  return result
	}
	
	// : (HistoryState, EditorState, (tr: Transaction), bool)
	// Apply the latest event from one branch to the document and shift the event
	// onto the other branch.
	function histTransaction(history, state, dispatch, redo) {
	  var preserveItems = mustPreserveItems(state), histOptions = historyKey.get(state).spec.config;
	  var pop = (redo ? history.undone : history.done).popEvent(state, preserveItems);
	  if (!pop) { return }
	
	  var selection = pop.selection.resolve(pop.transform.doc);
	  var added = (redo ? history.done : history.undone).addTransform(pop.transform, state.selection.getBookmark(),
	                                                                  histOptions, preserveItems);
	
	  var newHist = new HistoryState(redo ? added : pop.remaining, redo ? pop.remaining : added, null, 0);
	  dispatch(pop.transform.setSelection(selection).setMeta(historyKey, {redo: redo, historyState: newHist}).scrollIntoView());
	}
	
	var cachedPreserveItems = false, cachedPreserveItemsPlugins = null;
	// Check whether any plugin in the given state has a
	// `historyPreserveItems` property in its spec, in which case we must
	// preserve steps exactly as they came in, so that they can be
	// rebased.
	function mustPreserveItems(state) {
	  var plugins = state.plugins;
	  if (cachedPreserveItemsPlugins != plugins) {
	    cachedPreserveItems = false;
	    cachedPreserveItemsPlugins = plugins;
	    for (var i = 0; i < plugins.length; i++) { if (plugins[i].spec.historyPreserveItems) {
	      cachedPreserveItems = true;
	      break
	    } }
	  }
	  return cachedPreserveItems
	}
	
	// :: (Transaction) → Transaction
	// Set a flag on the given transaction that will prevent further steps
	// from being appended to an existing history event (so that they
	// require a separate undo command to undo).
	function closeHistory(tr) {
	  return tr.setMeta(closeHistoryKey, true)
	}
	
	var historyKey = new prosemirrorState.PluginKey("history");
	var closeHistoryKey = new prosemirrorState.PluginKey("closeHistory");
	
	// :: (?Object) → Plugin
	// Returns a plugin that enables the undo history for an editor. The
	// plugin will track undo and redo stacks, which can be used with the
	// [`undo`](#history.undo) and [`redo`](#history.redo) commands.
	//
	// You can set an `"addToHistory"` [metadata
	// property](#state.Transaction.setMeta) of `false` on a transaction
	// to prevent it from being rolled back by undo.
	//
	//   config::-
	//   Supports the following configuration options:
	//
	//     depth:: ?number
	//     The amount of history events that are collected before the
	//     oldest events are discarded. Defaults to 100.
	//
	//     newGroupDelay:: ?number
	//     The delay between changes after which a new group should be
	//     started. Defaults to 500 (milliseconds). Note that when changes
	//     aren't adjacent, a new group is always started.
	function history(config) {
	  config = {depth: config && config.depth || 100,
	            newGroupDelay: config && config.newGroupDelay || 500};
	  return new prosemirrorState.Plugin({
	    key: historyKey,
	
	    state: {
	      init: function init() {
	        return new HistoryState(Branch.empty, Branch.empty, null, 0)
	      },
	      apply: function apply(tr, hist, state) {
	        return applyTransaction(hist, state, tr, config)
	      }
	    },
	
	    config: config
	  })
	}
	
	// :: (EditorState, ?(tr: Transaction)) → bool
	// A command function that undoes the last change, if any.
	function undo(state, dispatch) {
	  var hist = historyKey.getState(state);
	  if (!hist || hist.done.eventCount == 0) { return false }
	  if (dispatch) { histTransaction(hist, state, dispatch, false); }
	  return true
	}
	
	// :: (EditorState, ?(tr: Transaction)) → bool
	// A command function that redoes the last undone change, if any.
	function redo(state, dispatch) {
	  var hist = historyKey.getState(state);
	  if (!hist || hist.undone.eventCount == 0) { return false }
	  if (dispatch) { histTransaction(hist, state, dispatch, true); }
	  return true
	}
	
	// :: (EditorState) → number
	// The amount of undoable events available in a given state.
	function undoDepth(state) {
	  var hist = historyKey.getState(state);
	  return hist ? hist.done.eventCount : 0
	}
	
	// :: (EditorState) → number
	// The amount of redoable events available in a given editor state.
	function redoDepth(state) {
	  var hist = historyKey.getState(state);
	  return hist ? hist.undone.eventCount : 0
	}
	
	exports.HistoryState = HistoryState;
	exports.closeHistory = closeHistory;
	exports.history = history;
	exports.redo = redo;
	exports.redoDepth = redoDepth;
	exports.undo = undo;
	exports.undoDepth = undoDepth;
	//# sourceMappingURL=index.js.map


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(413)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(250),
	  /* template */
	  __webpack_require__(637),
	  /* scopeId */
	  "data-v-33358d44",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(83);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _typeof2 = __webpack_require__(8);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _util = __webpack_require__(9);
	
	var _validator = __webpack_require__(197);
	
	var _validator2 = _interopRequireDefault(_validator);
	
	var _messages2 = __webpack_require__(186);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 *  Encapsulates a validation schema.
	 *
	 *  @param descriptor An object declaring validation rules
	 *  for this schema.
	 */
	function Schema(descriptor) {
	  this.rules = null;
	  this._messages = _messages2.messages;
	  this.define(descriptor);
	}
	
	Schema.prototype = {
	  messages: function messages(_messages) {
	    if (_messages) {
	      this._messages = (0, _util.deepMerge)((0, _messages2.newMessages)(), _messages);
	    }
	    return this._messages;
	  },
	  define: function define(rules) {
	    if (!rules) {
	      throw new Error('Cannot configure a schema with no rules');
	    }
	    if ((typeof rules === 'undefined' ? 'undefined' : (0, _typeof3['default'])(rules)) !== 'object' || Array.isArray(rules)) {
	      throw new Error('Rules must be an object');
	    }
	    this.rules = {};
	    var z = void 0;
	    var item = void 0;
	    for (z in rules) {
	      if (rules.hasOwnProperty(z)) {
	        item = rules[z];
	        this.rules[z] = Array.isArray(item) ? item : [item];
	      }
	    }
	  },
	  validate: function validate(source_) {
	    var _this = this;
	
	    var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var oc = arguments[2];
	
	    var source = source_;
	    var options = o;
	    var callback = oc;
	    if (typeof options === 'function') {
	      callback = options;
	      options = {};
	    }
	    if (!this.rules || Object.keys(this.rules).length === 0) {
	      if (callback) {
	        callback();
	      }
	      return;
	    }
	    function complete(results) {
	      var i = void 0;
	      var field = void 0;
	      var errors = [];
	      var fields = {};
	
	      function add(e) {
	        if (Array.isArray(e)) {
	          errors = errors.concat.apply(errors, e);
	        } else {
	          errors.push(e);
	        }
	      }
	
	      for (i = 0; i < results.length; i++) {
	        add(results[i]);
	      }
	      if (!errors.length) {
	        errors = null;
	        fields = null;
	      } else {
	        for (i = 0; i < errors.length; i++) {
	          field = errors[i].field;
	          fields[field] = fields[field] || [];
	          fields[field].push(errors[i]);
	        }
	      }
	      callback(errors, fields);
	    }
	
	    if (options.messages) {
	      var messages = this.messages();
	      if (messages === _messages2.messages) {
	        messages = (0, _messages2.newMessages)();
	      }
	      (0, _util.deepMerge)(messages, options.messages);
	      options.messages = messages;
	    } else {
	      options.messages = this.messages();
	    }
	    var arr = void 0;
	    var value = void 0;
	    var series = {};
	    var keys = options.keys || Object.keys(this.rules);
	    keys.forEach(function (z) {
	      arr = _this.rules[z];
	      value = source[z];
	      arr.forEach(function (r) {
	        var rule = r;
	        if (typeof rule.transform === 'function') {
	          if (source === source_) {
	            source = (0, _extends3['default'])({}, source);
	          }
	          value = source[z] = rule.transform(value);
	        }
	        if (typeof rule === 'function') {
	          rule = {
	            validator: rule
	          };
	        } else {
	          rule = (0, _extends3['default'])({}, rule);
	        }
	        rule.validator = _this.getValidationMethod(rule);
	        rule.field = z;
	        rule.fullField = rule.fullField || z;
	        rule.type = _this.getType(rule);
	        if (!rule.validator) {
	          return;
	        }
	        series[z] = series[z] || [];
	        series[z].push({
	          rule: rule,
	          value: value,
	          source: source,
	          field: z
	        });
	      });
	    });
	    var errorFields = {};
	    (0, _util.asyncMap)(series, options, function (data, doIt) {
	      var rule = data.rule;
	      var deep = (rule.type === 'object' || rule.type === 'array') && ((0, _typeof3['default'])(rule.fields) === 'object' || (0, _typeof3['default'])(rule.defaultField) === 'object');
	      deep = deep && (rule.required || !rule.required && data.value);
	      rule.field = data.field;
	      function addFullfield(key, schema) {
	        return (0, _extends3['default'])({}, schema, {
	          fullField: rule.fullField + '.' + key
	        });
	      }
	
	      function cb() {
	        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	        var errors = e;
	        if (!Array.isArray(errors)) {
	          errors = [errors];
	        }
	        if (errors.length) {
	          (0, _util.warning)('async-validator:', errors);
	        }
	        if (errors.length && rule.message) {
	          errors = [].concat(rule.message);
	        }
	
	        errors = errors.map((0, _util.complementError)(rule));
	
	        if (options.first && errors.length) {
	          errorFields[rule.field] = 1;
	          return doIt(errors);
	        }
	        if (!deep) {
	          doIt(errors);
	        } else {
	          // if rule is required but the target object
	          // does not exist fail at the rule level and don't
	          // go deeper
	          if (rule.required && !data.value) {
	            if (rule.message) {
	              errors = [].concat(rule.message).map((0, _util.complementError)(rule));
	            } else if (options.error) {
	              errors = [options.error(rule, (0, _util.format)(options.messages.required, rule.field))];
	            } else {
	              errors = [];
	            }
	            return doIt(errors);
	          }
	
	          var fieldsSchema = {};
	          if (rule.defaultField) {
	            for (var k in data.value) {
	              if (data.value.hasOwnProperty(k)) {
	                fieldsSchema[k] = rule.defaultField;
	              }
	            }
	          }
	          fieldsSchema = (0, _extends3['default'])({}, fieldsSchema, data.rule.fields);
	          for (var f in fieldsSchema) {
	            if (fieldsSchema.hasOwnProperty(f)) {
	              var fieldSchema = Array.isArray(fieldsSchema[f]) ? fieldsSchema[f] : [fieldsSchema[f]];
	              fieldsSchema[f] = fieldSchema.map(addFullfield.bind(null, f));
	            }
	          }
	          var schema = new Schema(fieldsSchema);
	          schema.messages(options.messages);
	          if (data.rule.options) {
	            data.rule.options.messages = options.messages;
	            data.rule.options.error = options.error;
	          }
	          schema.validate(data.value, data.rule.options || options, function (errs) {
	            doIt(errs && errs.length ? errors.concat(errs) : errs);
	          });
	        }
	      }
	
	      var res = rule.validator(rule, data.value, cb, data.source, options);
	      if (res && res.then) {
	        res.then(function () {
	          return cb();
	        }, function (e) {
	          return cb(e);
	        });
	      }
	    }, function (results) {
	      complete(results);
	    });
	  },
	  getType: function getType(rule) {
	    if (rule.type === undefined && rule.pattern instanceof RegExp) {
	      rule.type = 'pattern';
	    }
	    if (typeof rule.validator !== 'function' && rule.type && !_validator2['default'].hasOwnProperty(rule.type)) {
	      throw new Error((0, _util.format)('Unknown rule type %s', rule.type));
	    }
	    return rule.type || 'string';
	  },
	  getValidationMethod: function getValidationMethod(rule) {
	    if (typeof rule.validator === 'function') {
	      return rule.validator;
	    }
	    var keys = Object.keys(rule);
	    var messageIndex = keys.indexOf('message');
	    if (messageIndex !== -1) {
	      keys.splice(messageIndex, 1);
	    }
	    if (keys.length === 1 && keys[0] === 'required') {
	      return _validator2['default'].required;
	    }
	    return _validator2['default'][this.getType(rule)] || false;
	  }
	};
	
	Schema.register = function register(type, validator) {
	  if (typeof validator !== 'function') {
	    throw new Error('Cannot register a validator by type, validator is not a function');
	  }
	  _validator2['default'][type] = validator;
	};
	
	Schema.messages = _messages2.messages;
	
	exports['default'] = Schema;
	module.exports = exports['default'];

/***/ }),
/* 186 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.newMessages = newMessages;
	function newMessages() {
	  return {
	    'default': 'Validation error on field %s',
	    required: '%s is required',
	    'enum': '%s must be one of %s',
	    whitespace: '%s cannot be empty',
	    date: {
	      format: '%s date %s is invalid for format %s',
	      parse: '%s date could not be parsed, %s is invalid ',
	      invalid: '%s date %s is invalid'
	    },
	    types: {
	      string: '%s is not a %s',
	      method: '%s is not a %s (function)',
	      array: '%s is not an %s',
	      object: '%s is not an %s',
	      number: '%s is not a %s',
	      date: '%s is not a %s',
	      boolean: '%s is not a %s',
	      integer: '%s is not an %s',
	      float: '%s is not a %s',
	      regexp: '%s is not a valid %s',
	      email: '%s is not a valid %s',
	      url: '%s is not a valid %s',
	      hex: '%s is not a valid %s'
	    },
	    string: {
	      len: '%s must be exactly %s characters',
	      min: '%s must be at least %s characters',
	      max: '%s cannot be longer than %s characters',
	      range: '%s must be between %s and %s characters'
	    },
	    number: {
	      len: '%s must equal %s',
	      min: '%s cannot be less than %s',
	      max: '%s cannot be greater than %s',
	      range: '%s must be between %s and %s'
	    },
	    array: {
	      len: '%s must be exactly %s in length',
	      min: '%s cannot be less than %s in length',
	      max: '%s cannot be greater than %s in length',
	      range: '%s must be between %s and %s in length'
	    },
	    pattern: {
	      mismatch: '%s value %s does not match pattern %s'
	    },
	    clone: function clone() {
	      var cloned = JSON.parse(JSON.stringify(this));
	      cloned.clone = this.clone;
	      return cloned;
	    }
	  };
	}
	
	var messages = exports.messages = newMessages();

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _util = __webpack_require__(9);
	
	var util = _interopRequireWildcard(_util);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var ENUM = 'enum';
	
	/**
	 *  Rule for validating a value exists in an enumerable list.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param source The source object being validated.
	 *  @param errors An array of errors that this rule may add
	 *  validation errors to.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function enumerable(rule, value, source, errors, options) {
	  rule[ENUM] = Array.isArray(rule[ENUM]) ? rule[ENUM] : [];
	  if (rule[ENUM].indexOf(value) === -1) {
	    errors.push(util.format(options.messages[ENUM], rule.fullField, rule[ENUM].join(', ')));
	  }
	}
	
	exports['default'] = enumerable;
	module.exports = exports['default'];

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _util = __webpack_require__(9);
	
	var util = _interopRequireWildcard(_util);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	/**
	 *  Rule for validating a regular expression pattern.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param source The source object being validated.
	 *  @param errors An array of errors that this rule may add
	 *  validation errors to.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function pattern(rule, value, source, errors, options) {
	  if (rule.pattern) {
	    if (rule.pattern instanceof RegExp) {
	      // if a RegExp instance is passed, reset `lastIndex` in case its `global`
	      // flag is accidentally set to `true`, which in a validation scenario
	      // is not necessary and the result might be misleading
	      rule.pattern.lastIndex = 0;
	      if (!rule.pattern.test(value)) {
	        errors.push(util.format(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
	      }
	    } else if (typeof rule.pattern === 'string') {
	      var _pattern = new RegExp(rule.pattern);
	      if (!_pattern.test(value)) {
	        errors.push(util.format(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
	      }
	    }
	  }
	}
	
	exports['default'] = pattern;
	module.exports = exports['default'];

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _util = __webpack_require__(9);
	
	var util = _interopRequireWildcard(_util);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	/**
	 *  Rule for validating minimum and maximum allowed values.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param source The source object being validated.
	 *  @param errors An array of errors that this rule may add
	 *  validation errors to.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function range(rule, value, source, errors, options) {
	  var len = typeof rule.len === 'number';
	  var min = typeof rule.min === 'number';
	  var max = typeof rule.max === 'number';
	  // 正则匹配码点范围从U+010000一直到U+10FFFF的文字（补充平面Supplementary Plane）
	  var spRegexp = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
	  var val = value;
	  var key = null;
	  var num = typeof value === 'number';
	  var str = typeof value === 'string';
	  var arr = Array.isArray(value);
	  if (num) {
	    key = 'number';
	  } else if (str) {
	    key = 'string';
	  } else if (arr) {
	    key = 'array';
	  }
	  // if the value is not of a supported type for range validation
	  // the validation rule rule should use the
	  // type property to also test for a particular type
	  if (!key) {
	    return false;
	  }
	  if (arr) {
	    val = value.length;
	  }
	  if (str) {
	    // 处理码点大于U+010000的文字length属性不准确的bug，如"𠮷𠮷𠮷".lenght !== 3
	    val = value.replace(spRegexp, '_').length;
	  }
	  if (len) {
	    if (val !== rule.len) {
	      errors.push(util.format(options.messages[key].len, rule.fullField, rule.len));
	    }
	  } else if (min && !max && val < rule.min) {
	    errors.push(util.format(options.messages[key].min, rule.fullField, rule.min));
	  } else if (max && !min && val > rule.max) {
	    errors.push(util.format(options.messages[key].max, rule.fullField, rule.max));
	  } else if (min && max && (val < rule.min || val > rule.max)) {
	    errors.push(util.format(options.messages[key].range, rule.fullField, rule.min, rule.max));
	  }
	}
	
	exports['default'] = range;
	module.exports = exports['default'];

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(8);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _util = __webpack_require__(9);
	
	var util = _interopRequireWildcard(_util);
	
	var _required = __webpack_require__(135);
	
	var _required2 = _interopRequireDefault(_required);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/* eslint max-len:0 */
	
	var pattern = {
	  // http://emailregex.com/
	  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
	  url: new RegExp('^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$', 'i'),
	  hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
	};
	
	var types = {
	  integer: function integer(value) {
	    return types.number(value) && parseInt(value, 10) === value;
	  },
	  float: function float(value) {
	    return types.number(value) && !types.integer(value);
	  },
	  array: function array(value) {
	    return Array.isArray(value);
	  },
	  regexp: function regexp(value) {
	    if (value instanceof RegExp) {
	      return true;
	    }
	    try {
	      return !!new RegExp(value);
	    } catch (e) {
	      return false;
	    }
	  },
	  date: function date(value) {
	    return typeof value.getTime === 'function' && typeof value.getMonth === 'function' && typeof value.getYear === 'function';
	  },
	  number: function number(value) {
	    if (isNaN(value)) {
	      return false;
	    }
	    return typeof value === 'number';
	  },
	  object: function object(value) {
	    return (typeof value === 'undefined' ? 'undefined' : (0, _typeof3['default'])(value)) === 'object' && !types.array(value);
	  },
	  method: function method(value) {
	    return typeof value === 'function';
	  },
	  email: function email(value) {
	    return typeof value === 'string' && !!value.match(pattern.email) && value.length < 255;
	  },
	  url: function url(value) {
	    return typeof value === 'string' && !!value.match(pattern.url);
	  },
	  hex: function hex(value) {
	    return typeof value === 'string' && !!value.match(pattern.hex);
	  }
	};
	
	/**
	 *  Rule for validating the type of a value.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param source The source object being validated.
	 *  @param errors An array of errors that this rule may add
	 *  validation errors to.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function type(rule, value, source, errors, options) {
	  if (rule.required && value === undefined) {
	    (0, _required2['default'])(rule, value, source, errors, options);
	    return;
	  }
	  var custom = ['integer', 'float', 'array', 'regexp', 'object', 'method', 'email', 'number', 'date', 'url', 'hex'];
	  var ruleType = rule.type;
	  if (custom.indexOf(ruleType) > -1) {
	    if (!types[ruleType](value)) {
	      errors.push(util.format(options.messages.types[ruleType], rule.fullField, rule.type));
	    }
	    // straight typeof check
	  } else if (ruleType && (typeof value === 'undefined' ? 'undefined' : (0, _typeof3['default'])(value)) !== rule.type) {
	    errors.push(util.format(options.messages.types[ruleType], rule.fullField, rule.type));
	  }
	}
	
	exports['default'] = type;
	module.exports = exports['default'];

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _util = __webpack_require__(9);
	
	var util = _interopRequireWildcard(_util);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	/**
	 *  Rule for validating whitespace.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param source The source object being validated.
	 *  @param errors An array of errors that this rule may add
	 *  validation errors to.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function whitespace(rule, value, source, errors, options) {
	  if (/^\s+$/.test(value) || value === '') {
	    errors.push(util.format(options.messages.whitespace, rule.fullField));
	  }
	}
	
	exports['default'] = whitespace;
	module.exports = exports['default'];

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(21);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 *  Validates an array.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function array(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value, 'array') && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options, 'array');
	    if (!(0, _util.isEmptyValue)(value, 'array')) {
	      _rule2['default'].type(rule, value, source, errors, options);
	      _rule2['default'].range(rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = array;
	module.exports = exports['default'];

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _util = __webpack_require__(9);
	
	var _rule = __webpack_require__(21);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 *  Validates a boolean.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function boolean(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value) && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options);
	    if (value !== undefined) {
	      _rule2['default'].type(rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = boolean;
	module.exports = exports['default'];

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(21);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function date(rule, value, callback, source, options) {
	  // console.log('integer rule called %j', rule);
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  // console.log('validate on %s value', value);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value) && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options);
	    if (!(0, _util.isEmptyValue)(value)) {
	      var dateObject = void 0;
	
	      if (typeof value === 'number') {
	        dateObject = new Date(value);
	      } else {
	        dateObject = value;
	      }
	
	      _rule2['default'].type(rule, dateObject, source, errors, options);
	      if (dateObject) {
	        _rule2['default'].range(rule, dateObject.getTime(), source, errors, options);
	      }
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = date;
	module.exports = exports['default'];

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(21);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ENUM = 'enum';
	
	/**
	 *  Validates an enumerable list.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function enumerable(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value) && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options);
	    if (value) {
	      _rule2['default'][ENUM](rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = enumerable;
	module.exports = exports['default'];

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(21);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 *  Validates a number is a floating point number.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function floatFn(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value) && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options);
	    if (value !== undefined) {
	      _rule2['default'].type(rule, value, source, errors, options);
	      _rule2['default'].range(rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = floatFn;
	module.exports = exports['default'];

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _string = __webpack_require__(205);
	
	var _string2 = _interopRequireDefault(_string);
	
	var _method = __webpack_require__(199);
	
	var _method2 = _interopRequireDefault(_method);
	
	var _number = __webpack_require__(200);
	
	var _number2 = _interopRequireDefault(_number);
	
	var _boolean = __webpack_require__(193);
	
	var _boolean2 = _interopRequireDefault(_boolean);
	
	var _regexp = __webpack_require__(203);
	
	var _regexp2 = _interopRequireDefault(_regexp);
	
	var _integer = __webpack_require__(198);
	
	var _integer2 = _interopRequireDefault(_integer);
	
	var _float = __webpack_require__(196);
	
	var _float2 = _interopRequireDefault(_float);
	
	var _array = __webpack_require__(192);
	
	var _array2 = _interopRequireDefault(_array);
	
	var _object = __webpack_require__(201);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _enum = __webpack_require__(195);
	
	var _enum2 = _interopRequireDefault(_enum);
	
	var _pattern = __webpack_require__(202);
	
	var _pattern2 = _interopRequireDefault(_pattern);
	
	var _date = __webpack_require__(194);
	
	var _date2 = _interopRequireDefault(_date);
	
	var _required = __webpack_require__(204);
	
	var _required2 = _interopRequireDefault(_required);
	
	var _type = __webpack_require__(206);
	
	var _type2 = _interopRequireDefault(_type);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = {
	  string: _string2['default'],
	  method: _method2['default'],
	  number: _number2['default'],
	  boolean: _boolean2['default'],
	  regexp: _regexp2['default'],
	  integer: _integer2['default'],
	  float: _float2['default'],
	  array: _array2['default'],
	  object: _object2['default'],
	  'enum': _enum2['default'],
	  pattern: _pattern2['default'],
	  date: _date2['default'],
	  url: _type2['default'],
	  hex: _type2['default'],
	  email: _type2['default'],
	  required: _required2['default']
	};
	module.exports = exports['default'];

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(21);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 *  Validates a number is an integer.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function integer(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value) && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options);
	    if (value !== undefined) {
	      _rule2['default'].type(rule, value, source, errors, options);
	      _rule2['default'].range(rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = integer;
	module.exports = exports['default'];

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(21);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 *  Validates a function.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function method(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value) && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options);
	    if (value !== undefined) {
	      _rule2['default'].type(rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = method;
	module.exports = exports['default'];

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(21);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 *  Validates a number.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function number(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value) && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options);
	    if (value !== undefined) {
	      _rule2['default'].type(rule, value, source, errors, options);
	      _rule2['default'].range(rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = number;
	module.exports = exports['default'];

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(21);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 *  Validates an object.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function object(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value) && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options);
	    if (value !== undefined) {
	      _rule2['default'].type(rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = object;
	module.exports = exports['default'];

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(21);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 *  Validates a regular expression pattern.
	 *
	 *  Performs validation when a rule only contains
	 *  a pattern property but is not declared as a string type.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function pattern(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value, 'string') && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options);
	    if (!(0, _util.isEmptyValue)(value, 'string')) {
	      _rule2['default'].pattern(rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = pattern;
	module.exports = exports['default'];

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(21);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 *  Validates the regular expression type.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function regexp(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value) && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options);
	    if (!(0, _util.isEmptyValue)(value)) {
	      _rule2['default'].type(rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = regexp;
	module.exports = exports['default'];

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(8);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _rule = __webpack_require__(21);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function required(rule, value, callback, source, options) {
	  var errors = [];
	  var type = Array.isArray(value) ? 'array' : typeof value === 'undefined' ? 'undefined' : (0, _typeof3['default'])(value);
	  _rule2['default'].required(rule, value, source, errors, options, type);
	  callback(errors);
	}
	
	exports['default'] = required;
	module.exports = exports['default'];

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(21);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 *  Performs validation for string types.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function string(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value, 'string') && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options, 'string');
	    if (!(0, _util.isEmptyValue)(value, 'string')) {
	      _rule2['default'].type(rule, value, source, errors, options);
	      _rule2['default'].range(rule, value, source, errors, options);
	      _rule2['default'].pattern(rule, value, source, errors, options);
	      if (rule.whitespace === true) {
	        _rule2['default'].whitespace(rule, value, source, errors, options);
	      }
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = string;
	module.exports = exports['default'];

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(21);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function type(rule, value, callback, source, options) {
	  var ruleType = rule.type;
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value, ruleType) && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options, ruleType);
	    if (!(0, _util.isEmptyValue)(value, ruleType)) {
	      _rule2['default'].type(rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = type;
	module.exports = exports['default'];

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(28);
	var bind = __webpack_require__(140);
	var Axios = __webpack_require__(209);
	var defaults = __webpack_require__(95);
	
	/**
	 * Create an instance of Axios
	 *
	 * @param {Object} defaultConfig The default config for the instance
	 * @return {Axios} A new instance of Axios
	 */
	function createInstance(defaultConfig) {
	  var context = new Axios(defaultConfig);
	  var instance = bind(Axios.prototype.request, context);
	
	  // Copy axios.prototype to instance
	  utils.extend(instance, Axios.prototype, context);
	
	  // Copy context to instance
	  utils.extend(instance, context);
	
	  return instance;
	}
	
	// Create the default instance to be exported
	var axios = createInstance(defaults);
	
	// Expose Axios class to allow class inheritance
	axios.Axios = Axios;
	
	// Factory for creating new instances
	axios.create = function create(instanceConfig) {
	  return createInstance(utils.merge(defaults, instanceConfig));
	};
	
	// Expose Cancel & CancelToken
	axios.Cancel = __webpack_require__(137);
	axios.CancelToken = __webpack_require__(208);
	axios.isCancel = __webpack_require__(138);
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(223);
	
	module.exports = axios;
	
	// Allow use of default import syntax in TypeScript
	module.exports.default = axios;


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Cancel = __webpack_require__(137);
	
	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */
	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }
	
	  var resolvePromise;
	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });
	
	  var token = this;
	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }
	
	    token.reason = new Cancel(message);
	    resolvePromise(token.reason);
	  });
	}
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};
	
	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */
	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};
	
	module.exports = CancelToken;


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(95);
	var utils = __webpack_require__(28);
	var InterceptorManager = __webpack_require__(210);
	var dispatchRequest = __webpack_require__(211);
	var isAbsoluteURL = __webpack_require__(219);
	var combineURLs = __webpack_require__(217);
	
	/**
	 * Create a new instance of Axios
	 *
	 * @param {Object} instanceConfig The default config for the instance
	 */
	function Axios(instanceConfig) {
	  this.defaults = instanceConfig;
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	/**
	 * Dispatch a request
	 *
	 * @param {Object} config The config specific for this request (merged with this.defaults)
	 */
	Axios.prototype.request = function request(config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = utils.merge({
	      url: arguments[0]
	    }, arguments[1]);
	  }
	
	  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
	  config.method = config.method.toLowerCase();
	
	  // Support baseURL config
	  if (config.baseURL && !isAbsoluteURL(config.url)) {
	    config.url = combineURLs(config.baseURL, config.url);
	  }
	
	  // Hook up interceptors middleware
	  var chain = [dispatchRequest, undefined];
	  var promise = Promise.resolve(config);
	
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    chain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    chain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  while (chain.length) {
	    promise = promise.then(chain.shift(), chain.shift());
	  }
	
	  return promise;
	};
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url
	    }));
	  };
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, data, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	});
	
	module.exports = Axios;


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(28);
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(28);
	var transformData = __webpack_require__(214);
	var isCancel = __webpack_require__(138);
	var defaults = __webpack_require__(95);
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	function throwIfCancellationRequested(config) {
	  if (config.cancelToken) {
	    config.cancelToken.throwIfRequested();
	  }
	}
	
	/**
	 * Dispatch a request to the server using the configured adapter.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  throwIfCancellationRequested(config);
	
	  // Ensure headers exist
	  config.headers = config.headers || {};
	
	  // Transform request data
	  config.data = transformData(
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers || {}
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  var adapter = config.adapter || defaults.adapter;
	
	  return adapter(config).then(function onAdapterResolution(response) {
	    throwIfCancellationRequested(config);
	
	    // Transform response data
	    response.data = transformData(
	      response.data,
	      response.headers,
	      config.transformResponse
	    );
	
	    return response;
	  }, function onAdapterRejection(reason) {
	    if (!isCancel(reason)) {
	      throwIfCancellationRequested(config);
	
	      // Transform response data
	      if (reason && reason.response) {
	        reason.response.data = transformData(
	          reason.response.data,
	          reason.response.headers,
	          config.transformResponse
	        );
	      }
	    }
	
	    return Promise.reject(reason);
	  });
	};


/***/ }),
/* 212 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Update an Error with the specified config, error code, and response.
	 *
	 * @param {Error} error The error to update.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The error.
	 */
	module.exports = function enhanceError(error, config, code, request, response) {
	  error.config = config;
	  if (code) {
	    error.code = code;
	  }
	  error.request = request;
	  error.response = response;
	  return error;
	};


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var createError = __webpack_require__(139);
	
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	module.exports = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  // Note: status is not exposed by XDomainRequest
	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(createError(
	      'Request failed with status code ' + response.status,
	      response.config,
	      null,
	      response.request,
	      response
	    ));
	  }
	};


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(28);
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn(data, headers);
	  });
	
	  return data;
	};


/***/ }),
/* 215 */
/***/ (function(module, exports) {

	'use strict';
	
	// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js
	
	var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	
	function E() {
	  this.message = 'String contains an invalid character';
	}
	E.prototype = new Error;
	E.prototype.code = 5;
	E.prototype.name = 'InvalidCharacterError';
	
	function btoa(input) {
	  var str = String(input);
	  var output = '';
	  for (
	    // initialize result and counter
	    var block, charCode, idx = 0, map = chars;
	    // if the next str index does not exist:
	    //   change the mapping table to "="
	    //   check if d has no fractional digits
	    str.charAt(idx | 0) || (map = '=', idx % 1);
	    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
	    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
	  ) {
	    charCode = str.charCodeAt(idx += 3 / 4);
	    if (charCode > 0xFF) {
	      throw new E();
	    }
	    block = block << 8 | charCode;
	  }
	  return output;
	}
	
	module.exports = btoa;


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(28);
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%40/gi, '@').
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else if (utils.isURLSearchParams(params)) {
	    serializedParams = params.toString();
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      }
	
	      if (!utils.isArray(val)) {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};


/***/ }),
/* 217 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return relativeURL
	    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
	    : baseURL;
	};


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(28);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	  (function standardBrowserEnv() {
	    return {
	      write: function write(name, value, expires, path, domain, secure) {
	        var cookie = [];
	        cookie.push(name + '=' + encodeURIComponent(value));
	
	        if (utils.isNumber(expires)) {
	          cookie.push('expires=' + new Date(expires).toGMTString());
	        }
	
	        if (utils.isString(path)) {
	          cookie.push('path=' + path);
	        }
	
	        if (utils.isString(domain)) {
	          cookie.push('domain=' + domain);
	        }
	
	        if (secure === true) {
	          cookie.push('secure');
	        }
	
	        document.cookie = cookie.join('; ');
	      },
	
	      read: function read(name) {
	        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	        return (match ? decodeURIComponent(match[3]) : null);
	      },
	
	      remove: function remove(name) {
	        this.write(name, '', Date.now() - 86400000);
	      }
	    };
	  })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return {
	      write: function write() {},
	      read: function read() { return null; },
	      remove: function remove() {}
	    };
	  })()
	);


/***/ }),
/* 219 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(28);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	  (function standardBrowserEnv() {
	    var msie = /(msie|trident)/i.test(navigator.userAgent);
	    var urlParsingNode = document.createElement('a');
	    var originURL;
	
	    /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	    function resolveURL(url) {
	      var href = url;
	
	      if (msie) {
	        // IE needs attribute set twice to normalize properties
	        urlParsingNode.setAttribute('href', href);
	        href = urlParsingNode.href;
	      }
	
	      urlParsingNode.setAttribute('href', href);
	
	      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	      return {
	        href: urlParsingNode.href,
	        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	        host: urlParsingNode.host,
	        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	        hostname: urlParsingNode.hostname,
	        port: urlParsingNode.port,
	        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	                  urlParsingNode.pathname :
	                  '/' + urlParsingNode.pathname
	      };
	    }
	
	    originURL = resolveURL(window.location.href);
	
	    /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	    return function isURLSameOrigin(requestURL) {
	      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	      return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	    };
	  })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return function isURLSameOrigin() {
	      return true;
	    };
	  })()
	);


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(28);
	
	module.exports = function normalizeHeaderName(headers, normalizedName) {
	  utils.forEach(headers, function processHeader(value, name) {
	    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	      headers[normalizedName] = value;
	      delete headers[name];
	    }
	  });
	};


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(28);
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	    }
	  });
	
	  return parsed;
	};


/***/ }),
/* 223 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CheckBox = exports.IconItem = exports.Modal = undefined;
	
	var _defineProperty2 = __webpack_require__(44);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(30);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(7);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(10);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(32);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(31);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _setPrototypeOf = __webpack_require__(64);
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _create = __webpack_require__(57);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _typeof2 = __webpack_require__(8);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _preact = __webpack_require__(24);
	
	var _preact2 = _interopRequireDefault(_preact);
	
	var _classnames = __webpack_require__(49);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
	
	function createCommonjsModule(fn, module) {
	  return module = { exports: {} }, fn(module, module.exports), module.exports;
	}
	
	var preactPortal = createCommonjsModule(function (module, exports) {
	  (function (global, factory) {
	    module.exports = factory(_preact2.default);
	  })(commonjsGlobal, function (preact) {
	    var classCallCheck = function classCallCheck(instance, Constructor) {
	      if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	      }
	    };
	
	    var inherits = function inherits(subClass, superClass) {
	      if (typeof superClass !== "function" && superClass !== null) {
	        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : (0, _typeof3.default)(superClass)));
	      }
	
	      subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	        constructor: {
	          value: subClass,
	          enumerable: false,
	          writable: true,
	          configurable: true
	        }
	      });
	      if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	    };
	
	    var possibleConstructorReturn = function possibleConstructorReturn(self, call) {
	      if (!self) {
	        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	      }
	
	      return call && ((typeof call === 'undefined' ? 'undefined' : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	    };
	
	    var Portal = function (_Component) {
	      inherits(Portal, _Component);
	
	      function Portal() {
	        classCallCheck(this, Portal);
	        return possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      Portal.prototype.componentDidUpdate = function componentDidUpdate(props) {
	        for (var i in props) {
	          if (props[i] !== this.props[i]) {
	            return setTimeout(this.renderLayer);
	          }
	        }
	      };
	
	      Portal.prototype.componentDidMount = function componentDidMount() {
	        this.isMounted = true;
	        this.renderLayer = this.renderLayer.bind(this);
	        this.renderLayer();
	      };
	
	      Portal.prototype.componentWillUnmount = function componentWillUnmount() {
	        this.renderLayer(false);
	        this.isMounted = false;
	        if (this.remote) this.remote.parentNode.removeChild(this.remote);
	      };
	
	      Portal.prototype.findNode = function findNode(node) {
	        return typeof node === 'string' ? document.querySelector(node) : node;
	      };
	
	      Portal.prototype.renderLayer = function renderLayer() {
	        var show = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	        if (!this.isMounted) return;
	
	        if (this.props.into !== this.intoPointer) {
	          this.intoPointer = this.props.into;
	          if (this.into && this.remote) {
	            this.remote = preact.render(preact.h(PortalProxy, null), this.into, this.remote);
	          }
	          this.into = this.findNode(this.props.into);
	        }
	
	        this.remote = preact.render(preact.h(PortalProxy, { context: this.context }, show && this.props.children || null), this.into, this.remote);
	      };
	
	      Portal.prototype.render = function render() {
	        return null;
	      };
	
	      return Portal;
	    }(preact.Component);
	
	    var PortalProxy = function (_Component2) {
	      inherits(PortalProxy, _Component2);
	
	      function PortalProxy() {
	        classCallCheck(this, PortalProxy);
	        return possibleConstructorReturn(this, _Component2.apply(this, arguments));
	      }
	
	      PortalProxy.prototype.getChildContext = function getChildContext() {
	        return this.props.context;
	      };
	
	      PortalProxy.prototype.render = function render(_ref) {
	        var children = _ref.children;
	
	        return children && children[0] || null;
	      };
	
	      return PortalProxy;
	    }(preact.Component);
	
	    return Portal;
	  });
	});
	
	function styleInject(css, ref) {
	  if (ref === void 0) ref = {};
	  var insertAt = ref.insertAt;
	
	  if (!css || typeof document === 'undefined') {
	    return;
	  }
	
	  var head = document.head || document.getElementsByTagName('head')[0];
	  var style = document.createElement('style');
	  style.type = 'text/css';
	
	  if (insertAt === 'top') {
	    if (head.firstChild) {
	      head.insertBefore(style, head.firstChild);
	    } else {
	      head.appendChild(style);
	    }
	  } else {
	    head.appendChild(style);
	  }
	
	  if (style.styleSheet) {
	    style.styleSheet.cssText = css;
	  } else {
	    style.appendChild(document.createTextNode(css));
	  }
	}
	
	var css = ".cte-button{height:32px;border:1px solid rgba(0,0,0,.13);border-radius:4px;box-sizing:border-box;min-width:80px;font-size:14px;font-family:PingFangSC-Regular;color:rgba(0,0,0,.87);margin-left:12px;cursor:pointer;transition:all .3s}.cte-button:hover{border:1px solid #1c6cdc;color:#1c6cdc}.cte-button:active{color:#1253b5;border:1px solid #1253b5}.cte-button[disabled]{cursor:not-allowed;opacity:.45}.cte-button[disabled]:active,.cte-button[disabled]:hover{border:1px solid rgba(0,0,0,.13);color:rgba(0,0,0,.87)}.cte-button-primary.cte-button{border:1px solid #1c6cdc;background:#1c6cdc;color:#fff}.cte-button-primary.cte-button[disabled]{cursor:not-allowed;opacity:.45}.cte-button-primary.cte-button[disabled]:active,.cte-button-primary.cte-button[disabled]:hover{background:#1c6cdc;color:#fff}.cte-button-primary.cte-button:hover{border:1px solid #3d91f2;background:#3d91f2;color:#fff}.cte-button-primary.cte-button:active{border:1px solid #1253b5;background:#1253b5;color:#fff}.cte-button-danger{background:#ff5f57;color:#fff}.cte-button-disabled{opacity:.45;cursor:not-allowed}";
	styleInject(css);
	
	var Button = function (_Component3) {
	  (0, _inherits3.default)(Button, _Component3);
	
	  function Button() {
	    (0, _classCallCheck3.default)(this, Button);
	    return (0, _possibleConstructorReturn3.default)(this, (Button.__proto__ || (0, _getPrototypeOf2.default)(Button)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Button, [{
	    key: 'render',
	    value: function render() {
	      var _classNames;
	
	      var _props = this.props,
	          children = _props.children,
	          type = _props.type,
	          prefix = _props.prefix,
	          disabled = _props.disabled,
	          onClick = _props.onClick;
	
	      return (0, _preact.h)("button", {
	        disabled: disabled,
	        className: (0, _classnames2.default)(prefix, (_classNames = {}, (0, _defineProperty3.default)(_classNames, prefix + '-danger', type === 'danger'), (0, _defineProperty3.default)(_classNames, prefix + '-primary', type === 'primary'), (0, _defineProperty3.default)(_classNames, prefix + '-disabled', disabled), _classNames)),
	        onClick: onClick
	      }, children);
	    }
	  }]);
	  return Button;
	}(_preact.Component);
	
	Button.defaultProps = {
	  type: '',
	  prefix: 'cte-button',
	  disabled: false
	};
	
	var css$1 = ".cte-modal{position:fixed;background-color:rgba(0,0,0,.5);z-index:1002}.cte-modal,.cte-modal .mask{top:0;left:0;right:0;bottom:0}.cte-modal .mask{position:absolute}.cte-modal-header{height:58px;padding:16px 24px;border-radius:4px 4px 0 0;background-color:#fff;line-height:26px;color:rgba(0,0,0,.87)}.cte-modal-header-title{font-size:18px;font-family:PingFangSC-Medium}.cte-modal-header-close{position:absolute;width:28px;height:28px;top:15px;right:20px;background:#fff;transition:all .3s;display:flex;align-items:center;justify-content:center;border-radius:50%;cursor:pointer}.cte-modal-header-close:hover{background:rgba(0,0,0,.07)}.cte-modal-header-close-icon{cursor:pointer;width:16px;height:16px;border:none;outline:none;background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg class='icon' viewBox='0 0 1024 1024' xmlns='http://www.w3.org/2000/svg' width='20' height='20'%3E%3Cdefs%3E%3Cstyle/%3E%3C/defs%3E%3Cpath d='M557.248 512l279.083 279.061-45.27 45.27L512 557.227 232.939 836.33l-45.27-45.291L466.773 512 187.67 232.939l45.27-45.27L512 466.773 791.061 187.67l45.27 45.27z' fill-opacity='.6'/%3E%3C/svg%3E\") no-repeat 50%}.cte-modal-body{padding:0 24px}.cte-modal-content{position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);width:560px;border-radius:10px;overflow:hidden;background-color:#fff;box-shadow:0 1px 4px 0 rgba(111,130,166,.08),0 16px 30px 0 rgba(111,130,166,.14)}.cte-modal-footer{display:flex;justify-content:flex-end;height:64px;padding:16px 24px;border-radius:0 0 4px 4px}";
	styleInject(css$1);
	
	var defaultModalWidth = {
	  small: 400,
	  middle: 600,
	  large: 800,
	  super: 960
	};
	
	var Modal = function (_Component4) {
	  (0, _inherits3.default)(Modal, _Component4);
	
	  function Modal() {
	    var _ref2;
	
	    (0, _classCallCheck3.default)(this, Modal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this2 = (0, _possibleConstructorReturn3.default)(this, (_ref2 = Modal.__proto__ || (0, _getPrototypeOf2.default)(Modal)).call.apply(_ref2, [this].concat(args)));
	
	    _this2.onKeyDown = function (e) {
	      var _this2$props = _this2.props,
	          onOk = _this2$props.onOk,
	          canEnter = _this2$props.canEnter;
	
	
	      if (!e.isComposing && (e.which === 13 || e.keyCode === 13) && canEnter) {
	        onOk();
	        e.stopPropagation();
	        e.preventDefault();
	        return false;
	      }
	    };
	    return _this2;
	  }
	
	  (0, _createClass3.default)(Modal, [{
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          children = _props2.children,
	          className = _props2.className,
	          title = _props2.title,
	          contentClassName = _props2.contentClassName,
	          _props2$okText = _props2.okText,
	          okText = _props2$okText === undefined ? "确定" : _props2$okText,
	          _props2$cancelText = _props2.cancelText,
	          cancelText = _props2$cancelText === undefined ? "取消" : _props2$cancelText,
	          onOk = _props2.onOk,
	          disabled = _props2.disabled,
	          onCancel = _props2.onCancel,
	          _props2$showFooter = _props2.showFooter,
	          showFooter = _props2$showFooter === undefined ? true : _props2$showFooter,
	          wrapper = _props2.wrapper,
	          prefix = _props2.prefix,
	          type = _props2.type;
	
	      return (0, _preact.h)(preactPortal, {
	        into: wrapper || "body"
	      }, (0, _preact.h)("div", {
	        className: prefix + ' ' + (className || "")
	      }, (0, _preact.h)("div", {
	        className: "mask"
	      }), (0, _preact.h)("div", {
	        className: prefix + '-content ' + (contentClassName || ""),
	        style: {
	          width: defaultModalWidth[type]
	        },
	        onKeyDown: this.onKeyDown
	      }, (0, _preact.h)("div", {
	        className: prefix + '-header'
	      }, (0, _preact.h)("div", {
	        className: prefix + '-header-title'
	      }, title), (0, _preact.h)("div", {
	        className: prefix + '-header-close',
	        onClick: onCancel
	      }, (0, _preact.h)("button", {
	        className: prefix + '-header-close-icon'
	      }))), (0, _preact.h)("div", {
	        className: prefix + '-body'
	      }, children), showFooter && (0, _preact.h)("div", {
	        className: prefix + '-footer'
	      }, (0, _preact.h)(Button, {
	        onClick: onCancel
	      }, cancelText), (0, _preact.h)(Button, {
	        type: "primary",
	        className: "ok",
	        onClick: onOk,
	        disabled: disabled
	      }, okText)))));
	    }
	  }]);
	  return Modal;
	}(_preact.Component);
	
	Modal.defaultProps = {
	  prefix: 'cte-modal',
	  type: 'middle',
	  canEnter: false
	};
	
	var css$2 = ".ct-menu-item{position:relative;width:34px;height:34px;cursor:pointer;background-repeat:no-repeat;background-position:50%}.ct-menu-item svg{margin:4px 0 0 4px}.ct-menu-item.edit{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M13 7a.5.5 0 1 1 0 1H8a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1v-5a.5.5 0 1 1 1 0v-2 7a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h7-2zm6.854-.854a.5.5 0 0 1 0 .708l-6.364 6.364a.5.5 0 1 1-.708-.708l6.364-6.364a.5.5 0 0 1 .708 0z' fill='%23666' fill-rule='evenodd'/%3E%3C/svg%3E\")}.ct-menu-item.link{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M7.884 13.85l4.124-4.125 2.133 2.134a3.017 3.017 0 0 1 0 4.266l-1.99 1.991a3.017 3.017 0 0 1-4.267-4.266zm4.835-3.414l-.15.15a2.011 2.011 0 0 0 0 2.844l.712.711-.711.711.355.356-1.066-1.067a3.017 3.017 0 0 1 0-4.266l.149-.15.711.711zm.562 5.128l-1.842 1.841a2.011 2.011 0 0 1-2.844-2.844l1.99-1.991-.71-.711 3.975-3.975a3.017 3.017 0 0 1 4.266 4.266l-4.124 4.125-.711-.711zm-.562-5.128l.711.712-.71.71.71.712a2.011 2.011 0 0 1 0 2.844l-.15.15-.355-.356 1.067 1.067 2.133-2.134-.71-.71 1.99-1.992a2.011 2.011 0 0 0-2.844-2.844l-1.842 1.841z' fill='%23666' fill-rule='evenodd'/%3E%3C/svg%3E\")}.ct-menu-item.visitLink{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M6.674 16h1.128a6.001 6.001 0 1 0 0-6H6.674a7 7 0 1 1 0 6zm7.472-1.232l1.268-1.268H6.621a.5.5 0 1 1 0-1h8.793l-1.268-1.268a.5.5 0 0 1 .708-.707l2.1 2.101a.5.5 0 0 1 .021.727l-2.121 2.122a.5.5 0 1 1-.708-.707z' fill='%23666'/%3E%3C/g%3E%3C/svg%3E\")}.ct-menu-item.cancelLink{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='26' height='26' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M7.884 13.85l4.124-4.125 2.133 2.134a3.017 3.017 0 0 1 0 4.266l-1.99 1.991a3.017 3.017 0 0 1-4.267-4.266zm4.835-3.414l-.15.15a2.011 2.011 0 0 0 0 2.844l.712.711-.711.711.355.356-1.066-1.067a3.017 3.017 0 0 1 0-4.266l.149-.15.711.711zm.562 5.128l-1.842 1.841a2.011 2.011 0 0 1-2.844-2.844l1.99-1.991-.71-.711 3.975-3.975a3.017 3.017 0 0 1 4.266 4.266l-4.124 4.125-.711-.711zm-.562-5.128l1.842-1.841a2.011 2.011 0 1 1 2.844 2.844l-1.99 1.991.71.711-2.133 2.134-1.067-1.067.356.356.15-.15a2.011 2.011 0 0 0 0-2.844l-.712-.711.711-.711-.71-.712zM7.354 7.354a.5.5 0 0 1 .707 0l1.414 1.414a.5.5 0 1 1-.707.707L7.354 8.06a.5.5 0 0 1 0-.707zm9 9a.5.5 0 0 1 .707 0l1.414 1.414a.5.5 0 1 1-.707.707l-1.414-1.414a.5.5 0 0 1 0-.707zM17 14.5a.5.5 0 0 1 .5-.5h2a.5.5 0 1 1 0 1h-2a.5.5 0 0 1-.5-.5zm-11-3a.5.5 0 0 1 .5-.5h2a.5.5 0 1 1 0 1h-2a.5.5 0 0 1-.5-.5zM11.5 6a.5.5 0 0 1 .5.5v2a.5.5 0 1 1-1 0v-2a.5.5 0 0 1 .5-.5zm3 11a.5.5 0 0 1 .5.5v2a.5.5 0 1 1-1 0v-2a.5.5 0 0 1 .5-.5z' fill='%23666' fill-rule='evenodd'/%3E%3C/svg%3E\")}";
	styleInject(css$2);
	
	var MenItem = function (_Component5) {
	  (0, _inherits3.default)(MenItem, _Component5);
	
	  function MenItem() {
	    var _ref3;
	
	    (0, _classCallCheck3.default)(this, MenItem);
	
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    var _this3 = (0, _possibleConstructorReturn3.default)(this, (_ref3 = MenItem.__proto__ || (0, _getPrototypeOf2.default)(MenItem)).call.apply(_ref3, [this].concat(args)));
	
	    _this3.state = {
	      hasTooltip: false
	    };
	    return _this3;
	  }
	
	  (0, _createClass3.default)(MenItem, [{
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props3 = this.props,
	          tip = _props3.tip,
	          onClick = _props3.onClick,
	          type = _props3.type;
	
	      return (0, _preact.h)("div", {
	        className: 'ct-menu-item ' + type,
	        onMouseEnter: function onMouseEnter() {
	          return _this4.setState({
	            hasTooltip: true
	          });
	        },
	        onMouseLeave: function onMouseLeave() {
	          return _this4.setState({
	            hasTooltip: false
	          });
	        },
	        onClick: onClick
	      }, this.state.hasTooltip && (0, _preact.h)("span", {
	        className: "ct-toolbar-tooltip"
	      }, tip));
	    }
	  }]);
	  return MenItem;
	}(_preact.Component);
	
	var css$3 = ".ct-toolbox .checkbox{display:inline-block;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;position:relative;height:16px;margin-right:6px;vertical-align:-13%;cursor:pointer;align-items:center;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ct-toolbox .checkbox input{display:none}.ct-toolbox .checkbox .checkbox-bg{position:relative;display:inline-block;box-sizing:border-box;width:16px;height:16px;border:1px solid #ddd;border-radius:2px;vertical-align:top;margin-right:6px}.ct-toolbox .checkbox input:checked+.checkbox-bg{background-color:#1c6cdc;border-color:#1c6cdc}.ct-toolbox .checkbox input:checked+.checkbox-bg:after{content:\" \";display:table;position:absolute;left:4px;top:2px;width:5px;height:8px;border:2px solid #fff;border-top:0;border-left:0;-webkit-transform:rotate(45deg);transform:rotate(45deg)}";
	styleInject(css$3);
	
	var CheckBox = function (_Component6) {
	  (0, _inherits3.default)(CheckBox, _Component6);
	
	  function CheckBox() {
	    (0, _classCallCheck3.default)(this, CheckBox);
	    return (0, _possibleConstructorReturn3.default)(this, (CheckBox.__proto__ || (0, _getPrototypeOf2.default)(CheckBox)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CheckBox, [{
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props,
	          checked = _props4.checked,
	          onClick = _props4.onClick,
	          children = _props4.children;
	
	      return (0, _preact.h)("div", {
	        className: "checkbox",
	        onClick: onClick
	      }, (0, _preact.h)("input", {
	        type: "checkbox",
	        checked: checked
	      }), (0, _preact.h)("span", {
	        className: "checkbox-bg"
	      }), (0, _preact.h)("span", {
	        className: "checkbox-label"
	      }, children));
	    }
	  }]);
	  return CheckBox;
	}(_preact.Component);
	
	exports.Modal = Modal;
	exports.IconItem = MenItem;
	exports.CheckBox = CheckBox;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.imageToView = exports.ImageModule = undefined;
	
	var _toConsumableArray2 = __webpack_require__(66);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _from = __webpack_require__(43);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _regenerator = __webpack_require__(40);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(39);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _promise = __webpack_require__(35);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _getPrototypeOf = __webpack_require__(30);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _createClass2 = __webpack_require__(10);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(32);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(31);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _getOwnPropertyDescriptor = __webpack_require__(23);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getOwnPropertySymbols = __webpack_require__(16);
	
	var _getOwnPropertySymbols2 = _interopRequireDefault(_getOwnPropertySymbols);
	
	var _keys = __webpack_require__(13);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _defineProperty2 = __webpack_require__(15);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(7);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _slicedToArray2 = __webpack_require__(65);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _entries = __webpack_require__(63);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _prosemirrorState = __webpack_require__(6);
	
	var _prosemirrorView = __webpack_require__(48);
	
	var _index = __webpack_require__(142);
	
	var _index2 = __webpack_require__(226);
	
	var _preact = __webpack_require__(24);
	
	var _index3 = __webpack_require__(224);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var setAttributes = function setAttributes($dom, attrs) {
	  (0, _entries2.default)(attrs).forEach(function (_ref) {
	    var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
	        k = _ref2[0],
	        v = _ref2[1];
	
	    $dom.setAttribute(k, v);
	  });
	};
	function getImageAttrs(name, data, originWidth, originHeight, containerWidth, containerNode) {
	  var small = data.small,
	      middle = data.middle,
	      origin = data.origin;
	
	  var attrs = {
	    border: +localStorage.getItem(_index.BORDER_CACHE_FIELD) === 1,
	    mss: "",
	    name: name,
	    origin: origin,
	    small: small,
	    src: middle
	  };
	
	  if (originWidth && originHeight) {
	    var _calculateSize = (0, _index2.calculateSize)(originWidth, originHeight, containerWidth, _index.IMAGE_MAX_HEIGHT),
	        width = _calculateSize.width,
	        height = _calculateSize.height,
	        newOriginWidth = _calculateSize.newOriginWidth,
	        newOriginHeight = _calculateSize.newOriginHeight;
	
	    var isInTable = containerNode.tagName === "TD" || containerNode.tagName === "TH" || containerNode.tagName === "TR";
	    attrs.width = isInTable ? newOriginWidth : width;
	    attrs.height = isInTable ? newOriginHeight : height;
	  }
	
	  return attrs;
	}
	
	var ImageView = function ImageView(node, view, getPos, store) {
	  var _this = this;
	
	  (0, _classCallCheck3.default)(this, ImageView);
	
	  this.dom = document.createElement("span");
	  this.image = document.createElement("img");
	
	  this.onload = function () {
	    _this.dom.style.height = "auto";
	
	    try {
	      if (!_this.imageWidth) {
	        var _image = _this.image,
	            naturalWidth = _image.naturalWidth,
	            naturalHeight = _image.naturalHeight;
	
	        var containerNode = _this.dom.parentElement;
	        var containerWidth = containerNode.offsetWidth;
	
	        var _calculateSize2 = (0, _index2.calculateSize)(naturalWidth, naturalHeight, containerWidth),
	            width = _calculateSize2.width,
	            height = _calculateSize2.height,
	            newOriginWidth = _calculateSize2.newOriginWidth,
	            newOriginHeight = _calculateSize2.newOriginHeight;
	
	        var containerParent = containerNode.parentElement;
	        var isInTable = containerParent.tagName === "TD" || containerParent.tagName === "TH" || containerParent.tagName === "TR";
	        var showWidth = isInTable ? newOriginWidth : width;
	        var showHeight = isInTable ? newOriginHeight : height;
	        _this.imageWidth = width;
	        _this.store.updateAttrs({
	          width: showWidth,
	          height: showHeight
	        }, false, _this.getPos());
	      }
	
	      _this.dom.removeChild(_index2.$CtLoading);
	    } catch (err) {}
	
	    _this.dom.appendChild(_this.image);
	  };
	
	  this.onerror = function () {
	    var onError = _this.store.config.onError;
	
	
	    if (onError && onError(_this.dom)) {
	      return;
	    }
	
	    if (parseInt(_this.dom.style.width) < 50) {
	      _this.dom.style.width = "";
	    }
	
	    _this.image.classList.add("ct-img-failed");
	    _this.dom.classList.add("failed");
	  };
	
	  var _node$attrs = node.attrs,
	      name = _node$attrs.name,
	      border = _node$attrs.border,
	      link = _node$attrs.link,
	      _width = _node$attrs.width,
	      small = _node$attrs.small,
	      origin = _node$attrs.origin,
	      _height = _node$attrs.height;
	
	  var domAttrs = {
	    "class": 'ct-image' + (border ? " ct-image-border" : ""),
	    "data-link": link
	  };
	  var _store$config = store.config,
	      config = _store$config === undefined ? {} : _store$config;
	  var customFixDisplayUrl = config.customFixDisplayUrl;
	
	  var src = node.attrs.src;
	
	  if (!src) {
	    src = '';
	    console.error('img src is empty (throw error)');
	  }
	
	  if (customFixDisplayUrl) {
	    src = customFixDisplayUrl(src);
	  }
	
	  var imgAttrs = {
	    "data-small": small,
	    "data-origin": origin,
	    alt: name.length > 100 ? name.substr(0, 100) + '...' : name,
	    src: src,
	    width: '' + (_width || _index.IMAGE_DEFAULT_WIDTH)
	  };
	  this.dom.style.width = (_width || _index.IMAGE_DEFAULT_WIDTH) + 'px';
	  this.dom.style.height = (_height || _index.IMAGE_DEFAULT_HEIGHT) + 'px';
	  setAttributes(this.dom, domAttrs);
	  setAttributes(this.image, imgAttrs);
	  this.store = store;
	  this.getPos = getPos;
	  this.imageWidth = _width;
	  this.image.onerror = this.onerror;
	  this.image.onload = this.onload;
	  this.dom.appendChild(_index2.$CtLoading);
	};
	
	var pluginKey = new _prosemirrorState.PluginKey("image");
	function createPlugins(store) {
	  var plugin = new _prosemirrorState.Plugin({
	    key: pluginKey,
	    state: {
	      init: function init() {
	        return _prosemirrorView.DecorationSet.empty;
	      },
	      apply: function apply(tr, set) {
	        set = set.map(tr.mapping, tr.doc);
	
	        var action = tr.getMeta(this);
	
	        if (action && action.add) {
	          var _action$add = action.add,
	              pos = _action$add.pos,
	              key = _action$add.key;
	
	          var widget = (0, _index2.createUploadMask)();
	          var deco = _prosemirrorView.Decoration.widget(pos, widget, {
	            key: key,
	            size: -1
	          });
	          set = set.add(tr.doc, [deco]);
	        } else if (action && action.remove) {
	          set = set.remove(set.find(null, null, function (spec) {
	            return spec.key === action.remove.key;
	          }));
	        }
	
	        return set;
	      }
	    },
	    props: {
	      decorations: function decorations(state) {
	        return this.getState(state);
	      },
	
	
	      nodeViews: {
	        image: function image(node, view, getPos) {
	          return new ImageView(node, view, getPos, store);
	        }
	      },
	
	      handleClick: function handleClick(view, pos, e) {
	        if (store.node && (store.node.pos === pos || store.node.pos + 1 === pos)) {
	          return false;
	        }
	
	        var preSelected = document.querySelector('[data-type="ct-progress"].selected');
	
	        if (preSelected) {
	          preSelected.classList.remove("selected");
	        }
	
	        var selected = e.target.closest('[data-type="ct-progress"]');
	
	        if (selected) {
	          var state = view.state,
	              dispatch = view.dispatch;
	
	
	          if (selected.tagName.toUpperCase() === "DIV") {
	            var selection = _prosemirrorState.TextSelection.create(state.doc, pos, pos + 1);
	            dispatch(state.tr.setSelection(selection));
	          } else {
	            var _selection = _prosemirrorState.TextSelection.create(state.doc, pos, pos + 1);
	            dispatch(state.tr.setSelection(_selection));
	          }
	
	          selected.classList.add("selected");
	          return true;
	        }
	      } },
	    view: function view(_view) {
	      return new _index2.Popover({
	        view: _view,
	        store: store,
	        className: "ct-image-editor-popover"
	      });
	    }
	  });
	  return [plugin];
	}
	
	var imageSchema = {
	  nodes: {
	    image: {
	      atom: true,
	      group: "inline",
	      inline: true,
	      draggable: true,
	      allowGapCursor: true,
	      braceWidth: 82,
	      attrs: {
	        src: {
	          default: ""
	        },
	
	        small: {
	          default: ""
	        },
	
	        origin: {
	          default: ""
	        },
	
	        mss: {
	          default: ""
	        },
	        name: {
	          default: ""
	        },
	        width: {
	          default: 0
	        },
	        height: {
	          default: 0
	        },
	        link: {
	          default: null
	        },
	        border: {
	          default: false
	        }
	      },
	      parseDOM: [{
	        tag: 'span[class~="ct-image"]',
	
	        getAttrs: function getAttrs(dom) {
	          var img = dom.querySelector("img");
	          var src = img.getAttribute("data-src");
	          return {
	            src: src,
	            small: img.getAttribute("data-small") || src,
	            origin: img.getAttribute("data-origin") || src,
	            mss: img.getAttribute("data-mss") || "",
	            name: img.getAttribute("alt") || "",
	            width: img.getAttribute("data-width") || 0,
	            height: img.getAttribute("data-height") || 0,
	            link: img.getAttribute("data-link") || null,
	            border: dom.classList.contains("ct-image-border")
	          };
	        }
	      }, {
	        tag: "img",
	
	        getAttrs: function getAttrs(dom) {
	          var src = dom.getAttribute("src");
	          return {
	            name: dom.getAttribute("alt") || "",
	            origin: src,
	            small: src,
	            src: src,
	            width: dom.getAttribute("data-width") || dom.getAttribute("width") || 0,
	            height: dom.getAttribute("data-height") || dom.getAttribute("height") || 0
	          };
	        }
	      }],
	
	      toDOM: function toDOM(node) {
	        var _node$attrs2 = node.attrs,
	            mss = _node$attrs2.mss,
	            name = _node$attrs2.name,
	            width = _node$attrs2.width,
	            height = _node$attrs2.height,
	            link = _node$attrs2.link,
	            border = _node$attrs2.border;
	        var _node$attrs3 = node.attrs,
	            small = _node$attrs3.small,
	            src = _node$attrs3.src,
	            origin = _node$attrs3.origin;
	
	        var attrs = {
	          class: 'ct-image' + (border ? " ct-image-border" : "")
	        };
	        var imgAttrs = {
	          "alt": name.length > 100 ? name.substr(0, 100) + '...' : name,
	          "data-origin": origin,
	          "data-small": small,
	          "data-src": src
	        };
	
	        if (width && width !== "0") {
	          attrs.style = 'width: ' + width + 'px';
	          imgAttrs["data-width"] = width;
	          imgAttrs["data-height"] = height;
	        }
	
	        if (mss) {
	          imgAttrs["data-mss"] = mss;
	        }
	
	        if (link) {
	          imgAttrs["data-link"] = link;
	        }
	
	        return ["span", attrs, ["img", imgAttrs]];
	      }
	    }
	  }
	};
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    (0, _defineProperty3.default)(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	var defineProperty = _defineProperty;
	
	function _objectSpread(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? arguments[i] : {};
	    var ownKeys = (0, _keys2.default)(source);
	
	    if (typeof _getOwnPropertySymbols2.default === 'function') {
	      ownKeys = ownKeys.concat((0, _getOwnPropertySymbols2.default)(source).filter(function (sym) {
	        return (0, _getOwnPropertyDescriptor2.default)(source, sym).enumerable;
	      }));
	    }
	
	    ownKeys.forEach(function (key) {
	      defineProperty(target, key, source[key]);
	    });
	  }
	
	  return target;
	}
	
	var objectSpread = _objectSpread;
	
	function styleInject(css, ref) {
	  if (ref === void 0) ref = {};
	  var insertAt = ref.insertAt;
	
	  if (!css || typeof document === 'undefined') {
	    return;
	  }
	
	  var head = document.head || document.getElementsByTagName('head')[0];
	  var style = document.createElement('style');
	  style.type = 'text/css';
	
	  if (insertAt === 'top') {
	    if (head.firstChild) {
	      head.insertBefore(style, head.firstChild);
	    } else {
	      head.appendChild(style);
	    }
	  } else {
	    head.appendChild(style);
	  }
	
	  if (style.styleSheet) {
	    style.styleSheet.cssText = css;
	  } else {
	    style.appendChild(document.createTextNode(css));
	  }
	}
	
	var css = ".ct-image-link-modal .content{height:206px!important}.ct-image-link-modal .ant-modal-footer{padding:0 24px 32px;border:none}.ct-image-link-modal .ant-modal-footer .ant-btn{width:60px!important;height:32px;padding:0;margin-left:16px;border-radius:2px}.ct-image-link-modal .input-error{position:absolute;top:55px;left:65px;font-size:12px;color:#f05e50}.image-link-content{padding:14px 0;position:relative;font-size:12px;color:rgba(0,0,0,.65)}.image-link-content .cte-image-link-modal-item{color:rgba(0,0,0,.6);line-heigt:22px}.image-link-content .cte-image-link-modal-item>label{display:flex;align-items:center}.image-link-content .cte-image-link-modal-item>label span{color:rgba(0,0,0,.6);width:60px}.image-link-content .cte-image-link-modal-item input[type=text]{width:100%;height:32px;padding:6px 8px;margin-left:12px;border-radius:4px;border:1px solid rgba(0,0,0,.13);outline:none;color:rgba(0,0,0,.87);transition:all .218s ease}.image-link-content .cte-image-link-modal-item input[type=text]:focus{border:1px solid #1c6cdc}.image-link-content .cte-image-link-modal-item input[type=text]::-webkit-input-placeholder{color:rgba(0,0,0,.24)}.image-link-content .cte-image-link-modal-item input[type=text]::-moz-placeholder{color:rgba(0,0,0,.24)}.image-link-content .cte-image-link-modal-item input[type=text]::-ms-input-placeholder{color:rgba(0,0,0,.24)}.image-link-content .cte-image-link-modal-item input[type=text]:-ms-input-placeholder{color:rgba(0,0,0,.24)}.image-link-content .cte-image-link-modal-item input[type=text]::placeholder{color:rgba(0,0,0,.24)}";
	styleInject(css);
	
	var formatLink = function formatLink(href) {
	  var regex1 = /^(https?:\/\/)?(\w+\.?)+(\/.+)?$/i;
	  var regex2 = /^((https?:\/\/|\w+(\.\w+)+)(:\w+)?).+$/;
	  var newHref = href.replace(regex1, function (match, capture) {
	    return capture ? match : 'http://' + match;
	  });
	
	  return regex2.test(newHref) ? newHref : false;
	};
	
	var LinkModal = function (_Component) {
	  (0, _inherits3.default)(LinkModal, _Component);
	
	  function LinkModal(props) {
	    (0, _classCallCheck3.default)(this, LinkModal);
	
	    var _this2 = (0, _possibleConstructorReturn3.default)(this, (LinkModal.__proto__ || (0, _getPrototypeOf2.default)(LinkModal)).call(this));
	
	    _this2.link = '';
	    _this2.state = {
	      error: null
	    };
	
	    _this2.handleKeydown = function (e) {
	      if (e.which === 13 || e.keyCode === 13) {
	        _this2.handleOk();
	        e.stopPropagation();
	        e.preventDefault();
	        return false;
	      }
	    };
	
	    _this2.handleInputHref = function (e) {
	      if (_this2.state.error) {
	        _this2.setState({
	          error: null
	        });
	      }
	
	      _this2.link = e.target.value.replace(/(^[\u200B\s])|([\u200B\s]$)/g, '');
	    };
	
	    _this2.handleOk = function () {
	      var link = formatLink(_this2.link);
	      if (!link) return _this2.setState({
	        error: '请输入正确的地址'
	      });
	      _this2.handleCancel();
	      _this2.props.addImageLink(link);
	    };
	
	    _this2.handleCancel = function () {
	      if (_this2.state.error) _this2.setState({
	        error: null
	      });
	      _this2.props.closeModal();
	    };
	
	    _this2.link = props.link || '';
	    return _this2;
	  }
	
	  (0, _createClass3.default)(LinkModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.addEventListener('keydown', this.handleKeydown);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener('keydown', this.handleKeydown);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props$link = this.props.link,
	          link = _props$link === undefined ? '' : _props$link;
	      var error = this.state.error;
	
	      return (0, _preact.h)(_index3.Modal, {
	        visible: true,
	        className: "ct-image-link-modal",
	        title: '\u56FE\u7247\u94FE\u63A5',
	        okText: '\u63D2\u5165',
	        onOk: this.handleOk,
	        onCancel: this.handleCancel,
	        canEnter: true
	      }, (0, _preact.h)("div", {
	        className: "image-link-content"
	      }, (0, _preact.h)("div", {
	        className: "cte-image-link-modal-item"
	      }, (0, _preact.h)("label", null, (0, _preact.h)("span", null, '\u94FE\u63A5\u5730\u5740'), (0, _preact.h)("input", {
	        id: "imagelink",
	        type: "text",
	        className: "ct-input input-link-href",
	        placeholder: '\u8BF7\u8F93\u5165\u94FE\u63A5\u5730\u5740',
	        autoComplete: "off",
	        defaultValue: link,
	        onInput: this.handleInputHref
	      }))), error && (0, _preact.h)("div", {
	        className: "input-error"
	      }, error)));
	    }
	  }]);
	  return LinkModal;
	}(_preact.Component);
	
	var css$1 = ".ct-image-toolbar{display:flex;height:34px;padding:0 10px;opacity:1;transition:opacity .2s ease}.ct-image-toolbar .split{width:1px;height:14px;margin-top:0;background:#d8d8d8}.ct-image-toolbar .pm-image-width-label{height:18px;padding-left:8px;margin-top:0;color:#333;font-size:12px;line-height:20px}.ct-image-toolbar .pm-image-width-input{border-radius:2px;border:1px solid #ddd;box-sizing:border-box;width:66px;height:24px;padding:5px 8px 3px;margin:0 0 0 8px;font-size:12px;color:#333;-moz-appearance:textfield}.ct-image-toolbar .pm-image-width-input::-webkit-inner-spin-button,.ct-image-toolbar .pm-image-width-input::-webkit-outer-spin-button{-webkit-appearance:none!important;margin:0}.ct-toolbar-tooltip{position:absolute;left:50%;-webkit-transform:translate(-50%);transform:translate(-50%);bottom:-35px;height:25px;padding:0 10px;line-height:25px;white-space:nowrap;vertical-align:middle;color:#fff;font-size:12px;background:rgba(0,0,0,.7);border-radius:4px;z-index:1}.ct-toolbar-tooltip:after{position:absolute;width:0;top:-5px;right:50%;-webkit-transform:translate(50%);transform:translate(50%);display:block;border-color:rgba(0,0,0,.7) transparent;border-style:solid;border-width:0 5px 5px;content:\"\";z-index:1}";
	styleInject(css$1);
	
	var Toolbar = function (_Component2) {
	  (0, _inherits3.default)(Toolbar, _Component2);
	
	  function Toolbar(props) {
	    (0, _classCallCheck3.default)(this, Toolbar);
	
	    var _this3 = (0, _possibleConstructorReturn3.default)(this, (Toolbar.__proto__ || (0, _getPrototypeOf2.default)(Toolbar)).call(this, props));
	
	    _this3.container = null;
	    _this3.input = null;
	
	    _this3.handleCheckboxChange = function () {
	      var newHasBorder = !_this3.state.hasBorder;
	      _this3.setState({
	        hasBorder: newHasBorder
	      });
	      _this3.props.toggleBorder(newHasBorder);
	    };
	
	    _this3.addLink = function () {
	      _this3.setState({
	        visible: true
	      });
	    };
	
	    _this3.editLink = function () {
	      _this3.setState({
	        visible: true
	      });
	    };
	
	    _this3.cancelLink = function () {
	      _this3.props.cancelImageLink();
	    };
	
	    _this3.closeModal = function () {
	      _this3.setState({
	        visible: false
	      });
	    };
	
	    _this3.handleInputChange = function (e) {
	      var width = e.target.value;
	      _this3.setState({
	        width: width
	      });
	    };
	
	    _this3.setWidth = function () {
	      var _this3$props = _this3.props,
	          maxWidth = _this3$props.maxWidth,
	          naturalWidth = _this3$props.naturalWidth;
	
	      var width = _this3.input.value;
	
	      if (width < _index.IMAGE_MIN_WIDTH) {
	        if (naturalWidth < 5 || naturalWidth > _index.IMAGE_MIN_WIDTH) {
	          width = _index.IMAGE_MIN_WIDTH;
	        } else if (width < naturalWidth) {
	          width = naturalWidth;
	        }
	      } else if (width > maxWidth) {
	        width = maxWidth;
	      }
	
	      _this3.props.setWidth(width);
	
	      if (width !== _this3.state.width) {
	        _this3.setState({
	          width: width
	        });
	      }
	    };
	
	    _this3.state = {
	      hasBorder: props.hasBorder,
	      hasLink: !!props.link,
	      visible: false,
	      width: props.width
	    };
	    return _this3;
	  }
	
	  (0, _createClass3.default)(Toolbar, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        hasLink: !!nextProps.link
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _state = this.state,
	          hasBorder = _state.hasBorder,
	          hasLink = _state.hasLink,
	          visible = _state.visible,
	          width = _state.width;
	
	      return (0, _preact.h)("div", {
	        ref: function ref(r) {
	          return _this4.container = r;
	        },
	        className: "ct-image-toolbar"
	      }, (0, _preact.h)(_index3.CheckBox, {
	        checked: hasBorder,
	        onClick: this.handleCheckboxChange
	      }, '\u8FB9\u6846'), (0, _preact.h)("div", {
	        className: "split"
	      }), hasLink ? [(0, _preact.h)(_index3.IconItem, {
	        type: "cancelLink",
	        onClick: this.cancelLink,
	        tip: '\u53D6\u6D88\u94FE\u63A5'
	      }), (0, _preact.h)(_index3.IconItem, {
	        type: "edit",
	        onClick: this.editLink,
	        tip: '\u7F16\u8F91\u94FE\u63A5'
	      })] : (0, _preact.h)(_index3.IconItem, {
	        type: "link",
	        onClick: this.addLink,
	        tip: '\u94FE\u63A5'
	      }), (0, _preact.h)("div", {
	        className: "split"
	      }), (0, _preact.h)("label", {
	        id: "pm-image-width-label",
	        className: "pm-image-width-label",
	        htmlFor: "pm-image-width-input"
	      }, '\u5BBD\u5EA6'), (0, _preact.h)("input", {
	        id: "pm-image-width-input",
	        ref: function ref(i) {
	          return _this4.input = i;
	        },
	        className: "ct-input pm-image-width-input",
	        type: "number",
	        autoComplete: "off",
	        value: parseInt(width, 10),
	        onChange: this.handleInputChange,
	        onBlur: this.setWidth,
	        onKeyDown: function onKeyDown(e) {
	          if (e.keyCode === 13) {
	            e.target.blur();
	          }
	        }
	      }), visible && (0, _preact.h)(LinkModal, {
	        link: this.props.link,
	        addImageLink: this.props.addImageLink,
	        closeModal: this.closeModal
	      }));
	    }
	  }]);
	  return Toolbar;
	}(_preact.Component);
	
	var getToolBar = function getToolBar(node, update) {
	  var dom = node.dom,
	      attrs = node.attrs;
	
	  var _dom$getBoundingClien = dom.getBoundingClientRect(),
	      width = _dom$getBoundingClien.width;
	
	  var blockNode = (0, _index2.findParentBlockNode)(node.dom);
	
	  if (!blockNode) {
	    return;
	  }
	
	  var parentTagName = blockNode.parentNode.tagName.toLowerCase();
	  var maxWidth = blockNode.clientWidth - _index.IMAGE_OFFSET;
	
	  if ((parentTagName === "td" || parentTagName === "th") && blockNode.closest("table").classList.contains("responsive")) {
	    maxWidth = 1920;
	  }
	
	  return (0, _preact.h)(Toolbar, {
	    dom: dom,
	    type: "image",
	    link: attrs.link,
	    width: attrs.width || width,
	    maxWidth: maxWidth,
	    naturalWidth: dom.firstChild.naturalWidth,
	    hasBorder: dom.classList.contains("ct-image-border"),
	    toggleBorder: function toggleBorder(data) {
	      return _toggleBorder(data, update);
	    },
	    addImageLink: function addImageLink(data) {
	      return _addImageLink(data, update);
	    },
	    cancelImageLink: function cancelImageLink() {
	      return _cancelImageLink(update);
	    },
	    setWidth: function setWidth(width) {
	      return _setWidth(node, width, update);
	    }
	  });
	};
	
	var _addImageLink = function _addImageLink(link, update) {
	  update({
	    link: link
	  });
	};
	
	var _cancelImageLink = function _cancelImageLink(update) {
	  update({
	    link: null
	  });
	};
	
	var _toggleBorder = function _toggleBorder(hasBorder, update) {
	  localStorage.setItem(_index.BORDER_CACHE_FIELD, hasBorder ? "1" : "0");
	  update({
	    border: hasBorder
	  });
	};
	
	var _setWidth = function _setWidth(node, width, update) {
	  var dom = node.dom;
	  var $img = dom.querySelector("img");
	  var height = width / $img.clientWidth * $img.clientHeight;
	  dom.style.width = width + 'px';
	  update({
	    width: width,
	    height: height
	  });
	};
	
	var preloadImage = function preloadImage(src) {
	  return new _promise2.default(function (resolve, reject) {
	    var image = new Image();
	
	    setTimeout(function () {
	      setTimeout(function () {
	        image.src = src;
	      }, 0);
	    }, 0);
	
	    image.onload = function () {
	      return resolve(image);
	    };
	
	    image.onerror = function () {
	      return reject('\u56FE\u7247\u4E0B\u8F7D\u5931\u8D25: ' + src);
	    };
	  });
	};
	
	var _class, _temp;
	var ImageStore = (0, _index2.uploader)(_class = (0, _index2.resizer)(_class = (_temp = function () {
	  function ImageStore() {
	    (0, _classCallCheck3.default)(this, ImageStore);
	
	    this.pluginName = "image$";
	    this.view = void 0;
	    this.trigger = void 0;
	    this.config = void 0;
	    this.node = void 0;
	    this.ctPopover = void 0;
	    this.editor = void 0;
	  }
	
	  (0, _createClass3.default)(ImageStore, [{
	    key: 'init',
	    value: function init(editor) {
	      var trigger = editor.trigger,
	          view = editor.view,
	          _editor$imageConfig = editor.imageConfig,
	          imageConfig = _editor$imageConfig === undefined ? {} : _editor$imageConfig;
	
	      this.trigger = trigger;
	      this.view = view;
	      this.config = imageConfig;
	      this.editor = editor;
	    }
	  }, {
	    key: 'insertToDoc',
	    value: function insertToDoc(key, filename, failedHandle) {
	      var _this5 = this;
	
	      return function () {
	        var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(_ref3) {
	          var _ref3$name = _ref3.name,
	              name = _ref3$name === undefined ? filename : _ref3$name,
	              src = _ref3.src,
	              w = _ref3.width,
	              small = _ref3.small,
	              origin = _ref3.origin;
	
	          var customFixDisplayUrl, _ref5, naturalWidth, naturalHeight, dispatch, placeHolderInfo, node, pos, $container, containerWidth, attrs;
	
	          return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	              switch (_context.prev = _context.next) {
	                case 0:
	                  _context.prev = 0;
	
	                  if (src) {
	                    _context.next = 3;
	                    break;
	                  }
	
	                  throw new Error("图片上传失败");
	
	                case 3:
	                  customFixDisplayUrl = _this5.config.customFixDisplayUrl;
	
	
	                  if (customFixDisplayUrl) {
	                    src = customFixDisplayUrl(src);
	                  }
	
	                  _context.next = 7;
	                  return preloadImage(src);
	
	                case 7:
	                  _ref5 = _context.sent;
	                  naturalWidth = _ref5.naturalWidth;
	                  naturalHeight = _ref5.naturalHeight;
	                  dispatch = _this5.view.dispatch;
	                  placeHolderInfo = (0, _index2.findPlaceholder)(_this5.view, _this5.pluginName, key);
	
	                  if (placeHolderInfo) {
	                    _context.next = 14;
	                    break;
	                  }
	
	                  return _context.abrupt('return');
	
	                case 14:
	                  node = placeHolderInfo.node, pos = placeHolderInfo.pos;
	                  $container = (0, _index2.findParentBlockNode)(node);
	                  containerWidth = ($container && $container.clientWidth !== 0 ? $container.clientWidth : 68) - _index.IMAGE_OFFSET;
	                  attrs = getImageAttrs(name, {
	                    small: small,
	                    middle: src,
	                    origin: origin
	                  }, naturalWidth, naturalHeight, containerWidth, $container && $container.parentNode);
	
	
	                  if (w) {
	                    attrs.height = w * naturalHeight / naturalWidth;
	
	                    attrs.width = w;
	                  }
	
	                  dispatch(_this5.view.state.tr.replaceWith(pos, pos, _this5.view.state.schema.nodes.image.create(attrs)));
	                  (0, _index2.deletePlaceholder)(_this5.view, _this5.pluginName, key);
	                  _context.next = 27;
	                  break;
	
	                case 23:
	                  _context.prev = 23;
	                  _context.t0 = _context['catch'](0);
	
	                  console.error(_context.t0);
	                  failedHandle("图片上传失败");
	
	                case 27:
	                case 'end':
	                  return _context.stop();
	              }
	            }
	          }, _callee, _this5, [[0, 23]]);
	        }));
	
	        return function (_x) {
	          return _ref4.apply(this, arguments);
	        };
	      }();
	    }
	  }, {
	    key: 'updateAttrs',
	    value: function updateAttrs(data) {
	      var shouldSelect = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	      var pos = arguments[2];
	      var _view2 = this.view,
	          state = _view2.state,
	          dispatch = _view2.dispatch;
	      var tr = state.tr,
	          doc = state.doc,
	          schema = state.schema;
	
	
	      if (pos === undefined) {
	        pos = this.node.pos;
	      }
	
	      var ctrlNode = tr.doc.nodeAt(pos);
	
	      if (!ctrlNode) {
	        return;
	      }
	
	      var attrs = objectSpread({}, ctrlNode.attrs, data);
	
	      tr.setNodeMarkup(pos, schema.nodes.image, attrs);
	
	      if (shouldSelect) {
	        var newSelection = _prosemirrorState.NodeSelection.create(doc, pos);
	        tr.setSelection(newSelection);
	      }
	
	      dispatch(tr);
	
	      if (shouldSelect) {
	        var dom = this.view.nodeDOM(pos);
	
	        if (dom) {
	          this.showPopover({
	            dom: dom,
	            attrs: attrs,
	            pos: pos
	          });
	        }
	      }
	    }
	  }, {
	    key: 'showPopover',
	    value: function showPopover(node) {
	      this.hidePopover();
	      this.node = node;
	      this.ctShowResizer();
	      this.ctPopover.show({
	        dom: node.dom,
	        content: getToolBar(node, this.updateAttrs.bind(this))
	      });
	    }
	  }, {
	    key: 'hidePopover',
	    value: function hidePopover() {
	      this.ctHideResizer();
	      this.ctPopover.hide();
	    }
	  }]);
	  return ImageStore;
	}(), _temp)) || _class) || _class;
	
	var readeAsBase64 = function readeAsBase64(file, onprogress) {
	  return new _promise2.default(function (resolve, reject) {
	    var reader = new FileReader();
	
	    reader.onload = function () {
	      return resolve(reader.result);
	    };
	
	    reader.onerror = function () {
	      return reject("oops");
	    };
	
	    reader.onprogress = onprogress;
	    reader.readAsDataURL(file);
	  });
	};
	
	var customUpload = function () {
	  var _ref7 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(_ref6) {
	    var file = _ref6.file,
	        onprogress = _ref6.onprogress,
	        insert = _ref6.insert,
	        failedHandle = _ref6.failedHandle;
	    var result;
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            _context3.prev = 0;
	            _context3.next = 3;
	            return new _promise2.default(function (res) {
	              setTimeout((0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	                var rest;
	                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                  while (1) {
	                    switch (_context2.prev = _context2.next) {
	                      case 0:
	                        _context2.next = 2;
	                        return readeAsBase64(file, onprogress);
	
	                      case 2:
	                        rest = _context2.sent;
	
	                        res(rest);
	
	                      case 4:
	                      case 'end':
	                        return _context2.stop();
	                    }
	                  }
	                }, _callee2, undefined);
	              })), 2000);
	            });
	
	          case 3:
	            result = _context3.sent;
	            _context3.next = 6;
	            return insert({
	              src: result
	            });
	
	          case 6:
	            _context3.next = 11;
	            break;
	
	          case 8:
	            _context3.prev = 8;
	            _context3.t0 = _context3['catch'](0);
	
	            failedHandle('some errors: ' + _context3.t0);
	
	          case 11:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, undefined, [[0, 8]]);
	  }));
	
	  return function customUpload(_x3) {
	    return _ref7.apply(this, arguments);
	  };
	}();
	
	var config = {
	  customUpload: customUpload
	};
	
	var css$2 = ".ct-image{display:inline-block;position:relative;max-width:100%;margin:0 3px;line-height:1;font-size:0;box-sizing:content-box;background-color:#fff;vertical-align:bottom}.ct-image.ProseMirror-selectednode{outline:2px solid #00a7cd}.ct-image img{width:100%;max-width:100%;vertical-align:bottom}.ct-image .ct-img-failed{min-width:50px;min-height:50px}.ct-image .ct-img-failed,.ct-image .ct-img-loading,.ct-image .ct-img-mask{display:inline-block}.ct-image .ct-img-failed:before,.ct-image .ct-img-loading:before,.ct-image .ct-img-mask:before{content:\"\";position:absolute;left:0;top:0;display:block;width:100%;height:100%;background:#f6f6f6;z-index:1}.ct-image .ct-img-failed:after,.ct-image .ct-img-loading:after,.ct-image .ct-img-mask:after{content:\"\";position:absolute;left:12px;top:12px;display:block;width:28px;height:20px;z-index:2}.ct-image .ct-img-noperm{position:absolute;left:12px;top:40px;display:block;z-index:9;font-size:14px;color:#777}.ct-image .ct-img-failed:after{background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg class='icon' viewBox='0 0 1380 1024' xmlns='http://www.w3.org/2000/svg' width='26.953' height='20'%3E%3Cdefs%3E%3Cstyle/%3E%3C/defs%3E%3Cpath d='M526.889 315.732l165.016 171.024a66.785 66.785 0 0 1 18.724 46.371V737.77l135.664-202.254-123.399-162.635a66.78 66.78 0 0 1-8.027-67.029L830.58 40.121C841.19 15.756 865.235.001 891.809.001h338.475c82.394 0 149.89 65.742 149.89 147.731V876.27c0 81.989-67.496 147.731-149.89 147.731H149.89C67.496 1024.001 0 958.259 0 876.27V147.732C0 65.743 67.496.001 149.89.001h393.258c45.99 0 78.216 45.4 63.044 88.815L526.89 315.733z' fill='%237F9496'/%3E%3Cpath d='M543.148 66.783l-83.824 239.855a44.52 44.52 0 0 0 9.99 45.602l174.532 180.887v277.792a44.52 44.52 0 0 0 19.721 36.974c20.42 13.697 48.078 8.247 61.775-12.173l185.264-276.199c10.592-15.791 9.987-36.565-1.506-51.712L776.096 332.515 891.809 66.784h338.475c45.899 0 83.107 36.242 83.107 80.949v728.538c0 44.707-37.208 80.949-83.107 80.949H149.89c-45.899 0-83.107-36.242-83.107-80.949V147.733c0-44.707 37.208-80.949 83.107-80.949h393.258z' fill='%23FFF'/%3E%3Cpath d='M496.955 289.391l252.816 398.046 196.047-178.035 300.791 358.771H133.566z' fill='%23DDD'/%3E%3Cpath d='M526.889 315.732l165.016 171.024a66.785 66.785 0 0 1 18.724 46.371V737.77l135.664-202.254-123.399-162.635a66.78 66.78 0 0 1-8.027-67.029L830.58 40.121C841.19 15.756 865.235.001 891.809.001h338.475c82.394 0 149.89 65.742 149.89 147.731V876.27c0 81.989-67.496 147.731-149.89 147.731H149.89C67.496 1024.001 0 958.259 0 876.27V147.732C0 65.743 67.496.001 149.89.001h393.258c45.99 0 78.216 45.4 63.044 88.815L526.89 315.733zm16.259-248.949H149.89c-45.899 0-83.107 36.242-83.107 80.949V876.27c0 44.707 37.208 80.949 83.107 80.949h1080.394c45.899 0 83.107-36.242 83.107-80.949V147.732c0-44.707-37.208-80.949-83.107-80.949H891.809L776.096 332.514 909.1 507.808c11.493 15.147 12.098 35.922 1.506 51.712L725.342 835.719c-13.697 20.42-41.355 25.871-61.775 12.173a44.522 44.522 0 0 1-19.721-36.974V533.126L469.314 352.239a44.523 44.523 0 0 1-9.99-45.602l83.824-239.855z' fill='%237F9496'/%3E%3Cpath d='M1230.284 309.628c0 67.06-55.813 121.423-124.661 121.423s-124.661-54.363-124.661-121.423 55.813-121.423 124.661-121.423 124.661 54.363 124.661 121.423z' fill='%23EEE'/%3E%3C/svg%3E\") no-repeat 0 0}.ct-image .ct-img-mask:after{background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg class='icon' viewBox='0 0 1380 1024' xmlns='http://www.w3.org/2000/svg' width='26.953' height='20'%3E%3Cdefs%3E%3Cstyle/%3E%3C/defs%3E%3Cpath d='M155.826 0h1068.522c86.06 0 155.826 69.766 155.826 155.826v712.348c0 86.06-69.766 155.826-155.826 155.826H155.826C69.766 1024 0 954.234 0 868.174V155.826C0 69.766 69.766 0 155.826 0z' fill='%237F9496'/%3E%3Cpath d='M155.826 66.783c-49.177 0-89.043 39.866-89.043 89.043v712.348c0 49.177 39.866 89.043 89.043 89.043h1068.522c49.177 0 89.043-39.866 89.043-89.043V155.826c0-49.177-39.866-89.043-89.043-89.043H155.826z' fill='%23FFF'/%3E%3Cpath d='M496.955 289.391l252.816 398.046 196.047-178.035 300.791 358.771H133.566z' fill='%23D6D2ED'/%3E%3Cpath d='M1230.284 309.628c0 67.06-55.813 121.423-124.661 121.423s-124.661-54.363-124.661-121.423 55.813-121.423 124.661-121.423 124.661 54.363 124.661 121.423z' fill='%23E8E4FB'/%3E%3C/svg%3E\") no-repeat 0 0}.ct-image .ct-img-loading-bounce{position:absolute;display:block;z-index:9}.ct-image .ct-img-loading-bounce>i{display:none;vertical-align:middle}.ct-image .ct-img-loading-bounce>:nth-child(-n+3){display:inline-block;width:12px;height:12px;background:$brand;border-radius:50%;-webkit-animation:bounce-delay 1.4s ease-in-out infinite both;animation:bounce-delay 1.4s ease-in-out infinite both}.ct-image .ct-img-loading-bounce>:nth-child(-n+3):not(:last-child){margin-right:5px}.ct-image .ct-img-loading-bounce>:first-child{-webkit-animation-delay:-.32s;animation-delay:-.32s}.ct-image .ct-img-loading-bounce>:nth-child(2){-webkit-animation-delay:-.16s;animation-delay:-.16s}.ct-image.ProseMirror-selectednode{outline:2px solid $brand!important}.ct-image-border{display:inline-block;outline:2px solid #ddd!important}.ct-edit-img>img{display:block;max-width:100%;border:1px solid transparent}.ct-edit-img.active>img{border:1px solid #118bfb}span[data-type=ct-progress]{min-width:62px;min-height:62px}span[data-type=ct-progress].selected{outline:2px solid #118bfb}span[data-type=ct-progress] ::-moz-selection{background:transparent!important;color:unset!important}span[data-type=ct-progress] ::selection{background:transparent!important;color:unset!important}span[data-type=ct-progress] img{width:auto;max-width:100%;max-height:600px}.ct-image-editor{display:block;position:absolute;left:0;right:0;top:0;bottom:0;z-index:11;outline:1px dashed #aaa;pointer-events:none}.ct-image-editor .resizer{position:absolute;width:24px;height:24px;pointer-events:auto}.ct-image-editor .resizer:after{box-sizing:border-box;content:\" \";position:absolute;display:block;top:5px;left:5px;width:14px;height:14px;border-radius:7px;border:2px solid #fff;box-shadow:0 1px 2px 0;background-color:#333}.ct-image-editor .info{position:absolute;padding:5px;font-size:12px;color:#fff;background:rgba(0,0,0,.7)}.ct-image-editor .info-lt{left:8px;top:8px}.ct-image-editor .info-lb{left:8px;bottom:8px}.ct-image-editor .info-rt{right:8px;top:8px}.ct-image-editor .info-rb{right:8px;bottom:8px}.ct-image-editor .resizer-lt{left:-12px;top:-12px;cursor:nwse-resize}.ct-image-editor .resizer-lb{left:-12px;bottom:-12px;cursor:nesw-resize}.ct-image-editor .resizer-rt{right:-12px;top:-12px;cursor:nesw-resize}.ct-image-editor .resizer-rb{right:-12px;bottom:-12px;cursor:nwse-resize}.ct-image-resizer{display:none;position:absolute;height:24px;width:24px;z-index:11}.ct-image-mask.image{position:absolute;top:-1px;left:-1px;bottom:-1px;right:-1px;min-width:360px;min-height:100px;font-size:14px;overflow:hidden;background:rgba(0,0,0,.7);color:#fff}.ct-image-mask.image .ct-image-loading{position:absolute;top:10px;left:10px;width:15px;height:15px;border-radius:50%;border:2px solid #d5d5d5;border-bottom-color:transparent;vertical-align:-8%;-webkit-animation:image-loading .8s linear infinite;animation:image-loading .8s linear infinite}.ct-image-mask.image .ct-image-progress{position:absolute;top:30px;left:10px;text-decoration:none!important}.ct-image-mask.image .ct-image-load-failed{top:7px;line-height:20px;overflow:hidden;color:#fff}.ct-image-mask.image .ct-image-load-failed,.ct-image-mask.image .ct-image-reupload{display:none;position:absolute;left:7px;font-size:12px;text-decoration:none!important}.ct-image-mask.image .ct-image-reupload{top:70px;padding:2px;border-radius:2px;color:#000;background:#fff;outline:none;cursor:pointer}@-webkit-keyframes image-loading{0%{-webkit-transform:rotate(0);transform:rotate(0)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes image-loading{0%{-webkit-transform:rotate(0);transform:rotate(0)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}";
	styleInject(css$2);
	
	function isContainsByTags(node, tags) {
	  var parentNode = node.parentNode;
	
	  while (parentNode && parentNode.id !== 'pm-body-wrapper') {
	    if (tags.includes((parentNode.tagName || '').toLowerCase())) {
	      return parentNode;
	    }
	
	    parentNode = parentNode.parentNode;
	  }
	
	  return false;
	}
	
	function handleAddImgSpace(imgs, maxWidth) {
	  (0, _from2.default)(imgs).forEach(function (img) {
	    var imgSource = img.getAttribute('data-src');
	    if (!imgSource || img.getAttribute('src')) return;
	    var dataWidth = img.getAttribute('data-width');
	    var dataHeight = img.getAttribute('data-height');
	
	    if (!dataWidth || !dataHeight) {
	      img.src = imgSource;
	      img.style.maxWidth = '100%';
	      img.parentNode.style.cssText = 'max-width: 100%';
	      return;
	    }
	
	    img.className = 'ct-img-mask';
	    var parentNodeWithTable = isContainsByTags(img, ['td', 'th']);
	
	    if (parentNodeWithTable) {
	      img.parentNode.style.cssText = 'max-width: 100%; width: ' + dataWidth + 'px';
	      img.height = dataHeight;
	      return;
	    }
	
	    if (dataWidth < maxWidth) {
	      img.width = dataWidth;
	      img.height = dataHeight;
	      img.parentNode.style.cssText = 'width: ' + dataWidth + 'px';
	    } else {
	      img.width = '100%';
	      img.height = dataHeight * (maxWidth / dataWidth);
	      img.parentNode.style.cssText = 'width: 100%';
	    }
	  });
	}
	
	function setImgsSrc(imgs, maxWidth, onError) {
	  (0, _from2.default)(imgs).forEach(function (img) {
	    if (!img.hasAttribute('data-src')) return;
	    var dataWidth = img.getAttribute('data-width');
	    var parentNodeWithTable = isContainsByTags(img, ['td', 'th']);
	
	    if (parentNodeWithTable || !dataWidth) {
	      img.parentNode.style.cssText = 'max-width: ' + dataWidth + 'px';
	    }
	
	    if (dataWidth < maxWidth) {
	      img.width = dataWidth;
	      img.parentNode.style.cssText = 'width: ' + dataWidth + 'px';
	    } else {
	      img.width = '100%';
	      img.parentNode.style.cssText = 'width: 100%;';
	    }
	
	    img.src = img.getAttribute('data-src');
	
	    img.onerror = function (e) {
	      if (onError(e)) {
	        e.target.classList.add('ct-img-failed');
	      }
	    };
	  });
	}
	
	var handleImageLink = function handleImageLink($body) {
	  var handler = function handler(_ref9) {
	    var target = _ref9.target;
	
	    var $span = target.closest('.ct-image');
	
	    if ($span && target.getAttribute('data-link')) {
	      window.open(target.getAttribute('data-link'));
	    }
	  };
	
	  $body.addEventListener('click', handler);
	  return function () {
	    return $body.removeEventListener('click', handler);
	  };
	};
	
	var imageToView = function imageToView(_ref10) {
	  var bodyWrapper = _ref10.bodyWrapper,
	      onDestroy = _ref10.onDestroy;
	
	  var _ref11 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref11$maxWidth = _ref11.maxWidth,
	      maxWidth = _ref11$maxWidth === undefined ? 1000 : _ref11$maxWidth,
	      _ref11$lazyload = _ref11.lazyload,
	      lazyload = _ref11$lazyload === undefined ? false : _ref11$lazyload,
	      _ref11$imageLink = _ref11.imageLink,
	      imageLink = _ref11$imageLink === undefined ? true : _ref11$imageLink,
	      _ref11$onError = _ref11.onError,
	      onError = _ref11$onError === undefined ? function () {
	    return true;
	  } : _ref11$onError;
	
	  var imgs = bodyWrapper.querySelectorAll('.ct-image > img');
	  if (!imgs.length) return;
	  if (imageLink) onDestroy(handleImageLink(bodyWrapper));
	
	  if (!lazyload) {
	    setImgsSrc(imgs, maxWidth, onError);
	  } else {
	    handleAddImgSpace(imgs, maxWidth);
	  }
	};
	
	var ImageModule = function () {
	  function ImageModule() {
	    (0, _classCallCheck3.default)(this, ImageModule);
	
	    this.name = "image";
	    this.schema = void 0;
	    this.plugins = void 0;
	    this.config = void 0;
	    this.store = void 0;
	    this.editor = void 0;
	    this.store = new ImageStore();
	    this.schema = imageSchema;
	    this.plugins = [].concat((0, _toConsumableArray3.default)(createPlugins(this.store)));
	    this.config = config;
	  }
	
	  (0, _createClass3.default)(ImageModule, [{
	    key: 'init',
	    value: function init(editor) {
	      this.editor = editor;
	      this.store.init(editor);
	    }
	  }]);
	  return ImageModule;
	}();
	
	ImageModule.moduleName = "image";
	
	exports.ImageModule = ImageModule;
	exports.imageToView = imageToView;

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.config = exports.download = exports.$CtLoading = exports.computeSliceMinWidth = exports.createUploadMask = exports.calculateSize = exports.uploader = exports.Popover = exports.calculateWidth = exports.resizer = exports.send = exports.getElementFromDOM = exports.createShadowDOM = exports.deletePlaceholder = exports.findPlaceholder = exports.createPlaceholder = exports.PopoverStore = exports.uploadHelper = exports.handleEnterCreator = exports.handleTabCreator = exports.handleDeleteCreator = exports.handleBackspaceCreator = exports.mobileCopyToClipboard = exports.copyToClipboard = exports.getDynamicSrc = exports.getSvgSizeAfterEdit = exports.getSizeFromSvg = exports.fixSvgRatio = exports.uuid = exports.checkConfig = exports.getTargetLeft = exports.compute = exports.isPrintableKey = exports.getSystemInfo = exports.isChild = exports.getBlockNode = exports.canInsertTypes = exports.insertBlock = exports.getInsertBlockSlice = exports.setBetweenAttrs = exports.findParentBlockNode = exports.findParentDOM = exports.findParentNode = exports.getContentWidth = undefined;
	
	var _typeof2 = __webpack_require__(8);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _regenerator = __webpack_require__(40);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(39);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _entries = __webpack_require__(63);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _from = __webpack_require__(43);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _promise = __webpack_require__(35);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _assign = __webpack_require__(26);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getIterator2 = __webpack_require__(62);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _getOwnPropertyDescriptor = __webpack_require__(23);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getOwnPropertySymbols = __webpack_require__(16);
	
	var _getOwnPropertySymbols2 = _interopRequireDefault(_getOwnPropertySymbols);
	
	var _keys = __webpack_require__(13);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _defineProperty3 = __webpack_require__(15);
	
	var _defineProperty4 = _interopRequireDefault(_defineProperty3);
	
	var _slicedToArray2 = __webpack_require__(65);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _classCallCheck2 = __webpack_require__(7);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(10);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _defineProperty5 = __webpack_require__(44);
	
	var _defineProperty6 = _interopRequireDefault(_defineProperty5);
	
	var _prosemirrorState = __webpack_require__(6);
	
	var _prosemirrorModel = __webpack_require__(12);
	
	var _preact = __webpack_require__(24);
	
	var _classnames = __webpack_require__(49);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _index = __webpack_require__(142);
	
	var _lodash = __webpack_require__(78);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getContentWidth($elem) {
	  var computedStyle = window.getComputedStyle($elem);
	  var width = +computedStyle.width.replace('px', '');
	  var paddingLeft = +computedStyle.paddingLeft.replace('px', '');
	  var paddingRight = +computedStyle.paddingRight.replace('px', '');
	  return width - paddingLeft - paddingRight;
	}
	
	function findParentNode(path, assert) {
	  for (var i = path.length - 1; i >= 0; i--) {
	    if (assert(path[i])) {
	      return {
	        node: path[i],
	        pos: path[i - 1]
	      };
	    }
	  }
	
	  return null;
	}
	
	var findParentDOM = function findParentDOM(targetDOM, assert) {
	  var dom = targetDOM;
	
	  while (true) {
	    if (!dom || dom.classList && dom.classList.contains('ProseMirror')) return false;
	    if (assert(dom)) return dom;
	    dom = dom.parentNode;
	  }
	};
	
	var findParentBlockNode = function findParentBlockNode(targetDOM) {
	  var dom = targetDOM.parentNode;
	  var flag = 0;
	
	  while (flag < 40) {
	    if (!dom || dom.classList && dom.classList.contains('ProseMirror')) return false;
	    if (['block', 'flex'].includes(getComputedStyle(dom).display)) return dom;
	    dom = dom.parentNode;
	    flag++;
	  }
	};
	
	function setBetweenAttrs(from, to, tr, assert, attrsGetter) {
	  tr.doc.nodesBetween(from, to, function (node, pos, parent) {
	    if (assert(node, pos, parent)) {
	      var newAttrs = attrsGetter(node.attrs);
	
	      try {
	        tr.setNodeMarkup(pos, null, newAttrs);
	      } catch (error) {
	        console.error(error);
	      }
	    }
	  });
	}
	function getInsertBlockSlice(state, node) {
	  var schema = state.schema,
	      selection = state.selection,
	      doc = state.doc;
	  var paragraph = schema.nodes.paragraph;
	  var $from = selection.$from,
	      $to = selection.$to,
	      to = selection.to;
	
	  var beforeNode = $from.nodeBefore;
	  var afterNode = $to.nodeAfter;
	  var fromNodeGrandParent = $from.node(-1);
	  var fromNodeParent = $from.node();
	
	  if ((!beforeNode || !beforeNode.isText && !beforeNode.isTextblock && !beforeNode.isInline) && (!afterNode || !afterNode.isText && !afterNode.isTextblock && !afterNode.isInline)) {
	    var nodes = [node, paragraph.create()];
	
	    var isInTail = to === doc.content.size - 1 || (fromNodeGrandParent && fromNodeGrandParent.lastChild) === fromNodeParent;
	    if (isInTail) return new _prosemirrorModel.Slice(_prosemirrorModel.Fragment.from(nodes), 0, 0);
	
	    var nextBlockNode = to < doc.content.size ? doc.nodeAt(to + 1) : null;
	
	    if (nextBlockNode && !nextBlockNode.isTextblock && !nextBlockNode.isText) {
	      return new _prosemirrorModel.Slice(_prosemirrorModel.Fragment.from(nodes), 0, 0);
	    }
	  }
	
	  return new _prosemirrorModel.Slice(_prosemirrorModel.Fragment.from([node]), 0, 0);
	}
	
	function insertBlock(state, node, headNoSpace) {
	  var tr = state.tr,
	      schema = state.schema,
	      selection = state.selection;
	  var _schema$nodes = schema.nodes,
	      table = _schema$nodes.table,
	      code_block = _schema$nodes.code_block,
	      status = _schema$nodes.status,
	      note = _schema$nodes.note,
	      note_title = _schema$nodes.note_title,
	      collapse_title = _schema$nodes.collapse_title;
	  var to = selection.to,
	      $from = selection.$from;
	
	  var nodeBefore = $from.nodeBefore;
	
	  var parentNode = $from.parent;
	  var textBlocks = [code_block, status, note_title, collapse_title];
	
	  if (textBlocks.includes(parentNode.type)) return false;
	  var transaction = tr.setStoredMarks([]);
	
	  var slice = getInsertBlockSlice(state, node, headNoSpace);
	  transaction = transaction.replaceSelection(slice);
	
	  var newPos = nodeBefore ? 2 : 0;
	  newPos = selection.constructor.name === 'GapCursor' ? to : to + newPos;
	
	  if (node.type.isLeaf) {
	    newPos += 1;
	  } else if (node.type === note) {
	    newPos += 4;
	  } else if (node.type === table) {
	    newPos += 3;
	  }
	
	  transaction = transaction.setSelection(_prosemirrorState.TextSelection.create(transaction.doc, newPos));
	  return {
	    transaction: transaction,
	    newPos: newPos
	  };
	}
	
	function canInsertTypes(state) {
	  var schema = state.schema,
	      selection = state.selection;
	  var $from = selection.$from;
	  var _schema$nodes2 = schema.nodes,
	      status = _schema$nodes2.status,
	      code_block = _schema$nodes2.code_block,
	      note_title = _schema$nodes2.note_title,
	      collapse_title = _schema$nodes2.collapse_title;
	
	  var parentNode = $from.parent;
	  var texBlocks = [status, code_block, note_title, collapse_title];
	
	  return !texBlocks.includes(parentNode.type);
	}
	
	var isChild = function isChild(child, parent) {
	  var is = false;
	
	  var dfs = function dfs(node) {
	    if (is) return;
	    var content = node.content.content;
	
	    for (var i = 0; i < content.length; i++) {
	      var n = content[i];
	
	      if (n === child) {
	        is = true;
	        break;
	      }
	
	      dfs(n);
	    }
	  };
	
	  dfs(parent);
	  return is;
	};
	
	var getBlockNode = function getBlockNode(state, from, to) {
	  var tr = state.tr,
	      selection = state.selection;
	
	  var fromParentNode = selection.$from.node(-1);
	  var newFrom = from < 0 ? 0 : from;
	  var newTo = to > tr.doc.content.size ? tr.doc.content.size : to;
	  var is = null;
	  tr.doc.nodesBetween(newFrom, newTo, function (node) {
	    var nodeType = node.type;
	    if (nodeType && nodeType.spec.insertBlock && !isChild(fromParentNode, node)) is = node;
	    return !is;
	  });
	  return is;
	};
	
	function styleInject(css, ref) {
	  if (ref === void 0) ref = {};
	  var insertAt = ref.insertAt;
	
	  if (!css || typeof document === 'undefined') {
	    return;
	  }
	
	  var head = document.head || document.getElementsByTagName('head')[0];
	  var style = document.createElement('style');
	  style.type = 'text/css';
	
	  if (insertAt === 'top') {
	    if (head.firstChild) {
	      head.insertBefore(style, head.firstChild);
	    } else {
	      head.appendChild(style);
	    }
	  } else {
	    head.appendChild(style);
	  }
	
	  if (style.styleSheet) {
	    style.styleSheet.cssText = css;
	  } else {
	    style.appendChild(document.createTextNode(css));
	  }
	}
	
	var css = ".ct-toastr{position:relative;display:flex;flex-direction:row;flex-wrap:wrap;background:#fff;border-radius:4px;box-shadow:0 4px 12px rgba(0,0,0,.15);padding:10px;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;left:50%;top:55px;-webkit-transform:translateX(-50%);transform:translateX(-50%);z-index:9000}.ct-toastr .ct-toastr-success{margin-right:10px;width:16px;height:16px;background:url(\"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTYuOTQgOC44NjVMNC44MDEgNi43MjhhMS4yMDMgMS4yMDMgMCAwIDAtMS42OTQuMDAzIDEuMTk1IDEuMTk1IDAgMCAwLS4wMDMgMS42OTRMNi4wOCAxMS40Yy4yMzUuMjM1LjU0OC4zNTEuODYxLjM0Ny4zMTIuMDA0LjYyNC0uMTEzLjg2MS0uMzVMMTIuODk4IDYuM2ExLjIwMyAxLjIwMyAwIDAgMC0uMDAyLTEuNjk0IDEuMTk1IDEuMTk1IDAgMCAwLTEuNjk1LS4wMDNMNi45NCA4Ljg2NXpNMTYgOGMwIDEuNDUxLS4zNTggMi43OS0xLjA3MyA0LjAxNmE3Ljk2NCA3Ljk2NCAwIDAgMS0yLjkxMSAyLjkxMUE3LjgyNiA3LjgyNiAwIDAgMSA4IDE2YTcuODI2IDcuODI2IDAgMCAxLTQuMDE2LTEuMDczIDcuOTY0IDcuOTY0IDAgMCAxLTIuOTExLTIuOTExQTcuODI2IDcuODI2IDAgMCAxIDAgOGMwLTEuNDUxLjM1OC0yLjc5IDEuMDczLTQuMDE2YTcuOTY0IDcuOTY0IDAgMCAxIDIuOTExLTIuOTExQTcuODI2IDcuODI2IDAgMCAxIDggMGMxLjQ1MSAwIDIuNzkuMzU4IDQuMDE2IDEuMDczYTcuOTY0IDcuOTY0IDAgMCAxIDIuOTExIDIuOTExQTcuODI2IDcuODI2IDAgMCAxIDE2IDh6IiBmaWxsPSIjNzBCMTIzIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=\") no-repeat 0}.ct-toastr .ct-toastr-error{margin-right:10px;width:16px;height:16px;background:url(\"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTggMGE4IDggMCAxIDEgMCAxNkE4IDggMCAwIDEgOCAwek0zLjIgOGMwIC42NjcuNTM2IDEuMiAxLjE5NiAxLjJoNy4yMDhjLjY1MiAwIDEuMTk2LS41MzcgMS4xOTYtMS4yIDAtLjY2Ny0uNTM2LTEuMi0xLjE5Ni0xLjJINC4zOTZDMy43NDQgNi44IDMuMiA3LjMzNyAzLjIgOHoiIGZpbGw9IiNGMDVFNTAiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==\") no-repeat 0}";
	styleInject(css);
	
	var uuid = function uuid() {
	  var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".split("");
	  var id = [];
	
	  for (var i = 0; i < 8; i++) {
	    id.push(chars[parseInt('' + Math.random() * chars.length, 10)]);
	  }
	
	  return id.join("");
	};
	
	var createContainer = function createContainer() {
	  var dom = document.createElement('div');
	  dom.setAttribute('class', 'ct-toast-container');
	  dom.setAttribute('style', 'position:absolute;top:0;left:0;width:100%');
	  document.body.appendChild(dom);
	  return dom;
	};
	
	var clearToast = function clearToast(id, container, delay) {
	  setTimeout(function () {
	    var dom = document.querySelector('#' + id);
	    if (!dom) return;
	    (0, _preact.render)(null, container, dom);
	  }, delay * 1000);
	};
	
	var ToastrContent = function ToastrContent(props) {
	  return (0, _preact.h)("div", {
	    className: "ct-toastr",
	    id: props.id
	  }, (0, _preact.h)("div", {
	    className: (0, _classnames2.default)((0, _defineProperty6.default)({}, 'ct-toastr-' + props.type, true))
	  }), (0, _preact.h)("span", null, props.text));
	};
	
	var Toastr = function () {
	  function Toastr() {
	    (0, _classCallCheck3.default)(this, Toastr);
	  }
	
	  (0, _createClass3.default)(Toastr, null, [{
	    key: 'success',
	    value: function success(str) {
	      var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1.5;
	
	      var dom = document.querySelector('.ct-toast-container');
	      if (!dom) dom = createContainer();
	      var id = uuid();
	      (0, _preact.render)((0, _preact.h)(ToastrContent, {
	        id: id,
	        type: "success",
	        text: str
	      }), dom);
	      clearToast(id, dom, delay);
	    }
	  }, {
	    key: 'error',
	    value: function error(str) {
	      var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1.5;
	
	      var dom = document.querySelector('.ct-toast-container');
	      if (!dom) dom = createContainer();
	      var id = uuid();
	      (0, _preact.render)((0, _preact.h)(ToastrContent, {
	        id: id,
	        type: "error",
	        text: str
	      }), dom);
	      clearToast(id, dom, delay);
	    }
	  }]);
	  return Toastr;
	}();
	
	var config = window.__CLIENT_CONFIG__ || {};
	
	function getSystemInfo() {
	  var nVer = navigator.appVersion;
	  var nAgt = navigator.userAgent;
	  var browser = navigator.appName;
	  var version = '' + parseFloat(navigator.appVersion);
	  var nameOffset = void 0,
	      verOffset = void 0,
	      ix = void 0;
	  var isMobile = nAgt.toLowerCase().indexOf("mobile") !== -1;
	
	  if ((verOffset = nAgt.indexOf("Opera")) !== -1) {
	    browser = "Opera";
	    version = nAgt.substring(verOffset + 6);
	
	    if ((verOffset = nAgt.indexOf("Version")) !== -1) {
	      version = nAgt.substring(verOffset + 8);
	    }
	  }
	
	  if ((verOffset = nAgt.indexOf("OPR")) !== -1) {
	    browser = "Opera";
	    version = nAgt.substring(verOffset + 4);
	  } else if ((verOffset = nAgt.indexOf("Edge")) !== -1) {
	    browser = "Microsoft Edge";
	    version = nAgt.substring(verOffset + 5);
	  } else if ((verOffset = nAgt.indexOf("MSIE")) !== -1) {
	    browser = "Microsoft Internet Explorer";
	    version = nAgt.substring(verOffset + 5);
	  } else if ((verOffset = nAgt.indexOf("Chrome")) !== -1) {
	    browser = "Chrome";
	    version = nAgt.substring(verOffset + 7);
	  } else if ((verOffset = nAgt.indexOf("Safari")) !== -1) {
	    browser = "Safari";
	    version = nAgt.substring(verOffset + 7);
	
	    if ((verOffset = nAgt.indexOf("Version")) !== -1) {
	      version = nAgt.substring(verOffset + 8);
	    }
	  } else if ((verOffset = nAgt.indexOf("Firefox")) !== -1) {
	    browser = "Firefox";
	    version = nAgt.substring(verOffset + 8);
	  } else if (nAgt.indexOf("Trident/") !== -1) {
	    browser = "Microsoft Internet Explorer";
	    version = nAgt.substring(nAgt.indexOf("rv:") + 3);
	  } else if ((nameOffset = nAgt.lastIndexOf(" ") + 1) < (verOffset = nAgt.lastIndexOf("/"))) {
	    browser = nAgt.substring(nameOffset, verOffset);
	    version = nAgt.substring(verOffset + 1);
	
	    if (browser.toLowerCase() === browser.toUpperCase()) {
	      browser = navigator.appName;
	    }
	  }
	
	  if ((ix = version.indexOf(";")) !== -1) {
	    version = version.substring(0, ix);
	  }
	
	  if ((ix = version.indexOf(" ")) !== -1) {
	    version = version.substring(0, ix);
	  }
	
	  if ((ix = version.indexOf(")")) !== -1) {
	    version = version.substring(0, ix);
	  }
	
	  var os = "unknown";
	  var clientStrings = [{
	    s: "Windows 10",
	    r: /(Windows 10.0|Windows NT 10.0)/
	  }, {
	    s: "Windows 8.1",
	    r: /(Windows 8.1|Windows NT 6.3)/
	  }, {
	    s: "Windows 8",
	    r: /(Windows 8|Windows NT 6.2)/
	  }, {
	    s: "Windows 7",
	    r: /(Windows 7|Windows NT 6.1)/
	  }, {
	    s: "Windows Vista",
	    r: /Windows NT 6.0/
	  }, {
	    s: "Windows Server 2003",
	    r: /Windows NT 5.2/
	  }, {
	    s: "Windows XP",
	    r: /(Windows NT 5.1|Windows XP)/
	  }, {
	    s: "Windows 2000",
	    r: /(Windows NT 5.0|Windows 2000)/
	  }, {
	    s: "Windows ME",
	    r: /(Win 9x 4.90|Windows ME)/
	  }, {
	    s: "Windows 98",
	    r: /(Windows 98|Win98)/
	  }, {
	    s: "Windows 95",
	    r: /(Windows 95|Win95|Windows_95)/
	  }, {
	    s: "Windows NT 4.0",
	    r: /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/
	  }, {
	    s: "Windows CE",
	    r: /Windows CE/
	  }, {
	    s: "Windows 3.11",
	    r: /Win16/
	  }, {
	    s: "Android",
	    r: /Android/
	  }, {
	    s: "Open BSD",
	    r: /OpenBSD/
	  }, {
	    s: "Sun OS",
	    r: /SunOS/
	  }, {
	    s: "Linux",
	    r: /(Linux|X11)/
	  }, {
	    s: "iOS",
	    r: /(iPhone|iPad|iPod)/
	  }, {
	    s: "Mac OS X",
	    r: /Mac OS X/
	  }, {
	    s: "Mac OS",
	    r: /(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/
	  }, {
	    s: "QNX",
	    r: /QNX/
	  }, {
	    s: "UNIX",
	    r: /UNIX/
	  }, {
	    s: "BeOS",
	    r: /BeOS/
	  }, {
	    s: "OS/2",
	    r: /OS\/2/
	  }, {
	    s: "Search Bot",
	    r: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/
	  }];
	
	  for (var id in clientStrings) {
	    var cs = clientStrings[id];
	
	    if (cs.r.test(nAgt)) {
	      os = cs.s;
	      break;
	    }
	  }
	
	  var osVersion = "unknown";
	
	  if (/Windows/.test(os)) {
	    osVersion = /Windows (.*)/.exec(os)[1];
	    os = "Windows";
	  }
	
	  switch (os) {
	    case "Mac OS X":
	      osVersion = /Mac OS X (10[._\d]+)/.exec(nAgt)[1];
	      break;
	
	    case "Android":
	      osVersion = /Android ([._\d]+)/.exec(nAgt)[1];
	      break;
	
	    case "iOS":
	      osVersion = /OS (\d+)_(\d+)_?(\d+)?/.exec(nVer);
	      osVersion = osVersion[1] + '.' + osVersion[2] + '.' + (osVersion[3] | 0);
	      break;
	
	    default:
	      break;
	  }
	
	  return {
	    browser: browser || "unknown",
	    browserVersion: version || "unknown",
	    os: os || "unknown",
	    osVersion: osVersion || "unknown",
	    isMobile: isMobile
	  };
	}
	
	function isPrintableKey(evt) {
	  var key = evt.which || evt.keyCode;
	  return !(evt.altKey || evt.ctrlKey || evt.metaKey || evt.shiftKey) && (key === 32 || key >= 48 && key <= 57 || key >= 65 && key <= 90 || key >= 96 && key <= 105 || key === 106 || key >= 186 && key <= 192 || key >= 219 || key <= 222);
	}
	
	function compute(origin) {
	  if (origin >= 1024 * 1024) {
	    return (origin / (1024 * 1024)).toFixed(2) + 'MB';
	  } else if (origin >= 1024) {
	    return (origin / 1024).toFixed(2) + 'KB';
	  }
	
	  return (origin || 0) + 'B';
	}
	
	var getTargetLeft = function getTargetLeft(target) {
	  var left = 0;
	  var dom = target;
	
	  while (dom != null) {
	    var offsetParent = dom.offsetParent;
	    var parent = dom.parentNode;
	    left += dom.offsetLeft - dom.scrollLeft;
	
	    while (parent && parent !== offsetParent) {
	      var pOffsetLeft = parent.scrollLeft;
	
	      if (pOffsetLeft) {
	        left -= pOffsetLeft;
	      }
	
	      parent = parent.parentNode;
	    }
	
	    dom = offsetParent;
	  }
	
	  return left;
	};
	
	var checkConfig = function checkConfig(config, rule) {
	  for (var key in rule) {
	    var value = config[key];
	    var type = rule[key];
	
	    if (!value) {
	      throw new TypeError('Missing configuration item ' + key);
	    }
	
	    if (typeof type === "string") {
	      if (Object.prototype.toString.call(value).slice(8, -1) !== rule[key]) {
	        throw new TypeError('Configuration item ' + key + ' type must be ' + rule[key]);
	      }
	    } else if (!(value instanceof type)) {
	      throw new TypeError('Configuration item ' + key + ' type must be ' + rule[key]);
	    }
	  }
	};
	
	function uuid$1() {
	  var chars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".split("");
	  var id = [];
	
	  for (var i = 0; i < 8; i++) {
	    id.push(chars[parseInt('' + Math.random() * chars.length, 10)]);
	  }
	
	  return id.join("");
	}
	var getSizeFromSvg = function getSizeFromSvg(svgStr) {
	  var width = 0;
	  var height = 0;
	  var widthRes = svgStr.match(/width="([^"]+)"/);
	  var heightRes = svgStr.match(/height="([^"]+)"/);
	
	  if (widthRes && heightRes) {
	    width = parseInt(widthRes[1], 10);
	    height = parseInt(heightRes[1], 10);
	  }
	
	  if (!width || !height) {
	    var viewBox = svgStr.match(/viewBox="([^'"]*)"/);
	    var sizeStr = viewBox ? viewBox[1] : "0, 0";
	    var sizes = sizeStr.match(/\d+/g);
	    height = +sizes.pop();
	    width = +sizes.pop();
	  }
	
	  return {
	    width: width,
	    height: height
	  };
	};
	
	var fixSvgScale = function fixSvgScale(svgStr) {
	  return svgStr.replace(/width="[^'"]+"/, 'width="100%"').replace(/height="[^"']+"/, "");
	};
	
	function fixSvgRatio(_ref) {
	  var svgStr = _ref.svgStr,
	      width = _ref.width,
	      height = _ref.height;
	
	  svgStr = svgStr.slice(4);
	  var prefix = "<svg ";
	
	  if (!width || !height) {
	    var sizeInfo = getSizeFromSvg(svgStr);
	    width = sizeInfo.width;
	    height = sizeInfo.height;
	  }
	
	  if (!svgStr.includes("xMidYMid slice")) {
	    prefix += 'preserveAspectRatio="xMidYMid slice" ';
	  }
	
	  if (!svgStr.includes("viewBox")) {
	    prefix += 'viewBox="0, 0, ' + width + ', ' + height + '"';
	  } else {
	    svgStr = svgStr.replace(/viewBox="[^"]+"/, 'viewBox="0, 0, ' + width + ', ' + height + '"');
	  }
	
	  return prefix + fixSvgScale(svgStr);
	}
	
	
	function getSvgSizeAfterEdit(_ref2) {
	  var displayWidth = _ref2.displayWidth,
	      newSvgStr = _ref2.newSvgStr,
	      hadResize = _ref2.hadResize,
	      _ref2$formatted = _ref2.formatted,
	      formatted = _ref2$formatted === undefined ? false : _ref2$formatted;
	
	  var _getSizeFromSvg = getSizeFromSvg(newSvgStr),
	      newWidth = _getSizeFromSvg.width,
	      newHeight = _getSizeFromSvg.height;
	
	  if (!hadResize) {
	    return undefined;
	  }
	
	  var scale = displayWidth / newWidth;
	  var width = displayWidth;
	  var height = newHeight * scale;
	
	  if (formatted) {
	    width = width + 'px';
	    height = height + 'px';
	  }
	
	  return {
	    width: width,
	    height: height
	  };
	}
	
	function getDynamicSrc(url) {
	  var href = window.location.href;
	  var isNewContent = ['production'].includes(config.env) ? href.includes('create') : config.env;
	
	  if (url.includes('api/file/cdn')) {
	    url += '&isNewContent=' + isNewContent;
	    if (href.includes('template') && !href.includes('create') && !url.includes('template')) url += '&template=1';
	    return url;
	  }
	
	  var urlReg = /^https:\/\/km.*\.meituan\.net.*contentId=(\d+)&attachmentId=(\d+).*&contentType=(\d)/i;
	
	  var _urlReg$exec = urlReg.exec(url),
	      _urlReg$exec2 = (0, _slicedToArray3.default)(_urlReg$exec, 4),
	      _ = _urlReg$exec2[0],
	      contentId = _urlReg$exec2[1],
	      attachmentId = _urlReg$exec2[2],
	      contentType = _urlReg$exec2[3];
	
	  return window.location.origin + '/api/file/cdn/' + contentId + '/' + attachmentId + '?contentType=' + contentType + '&isNewContent=' + isNewContent;
	}
	
	var mobileCopyToClipboard = function mobileCopyToClipboard(content, successStr, event) {
	  var clip = new ClipBoard('.btn', {
	    text: function text() {
	      return content;
	    }
	  });
	  clip.on('success', function (e) {
	    Toast.info(successStr || '复制成功');
	    e.clearSelection();
	  });
	  clip.on('error', function (err) {
	    Toast.info('当前浏览器不支持快捷复制,请手动复制');
	    console.error(err);
	  });
	  clip.onClick(event);
	  clip.destroy();
	};
	
	var copyToClipboard = function copyToClipboard(content, successStr) {
	  var inputEle = document.createElement('input');
	  inputEle.value = content;
	  document.body.appendChild(inputEle);
	  inputEle.select();
	
	  try {
	    document.execCommand('Copy');
	    Toastr.success(successStr || '复制成功');
	  } catch (err) {
	    Toastr.success('当前浏览器不支持快捷复制,请手动复制');
	    console.error(err);
	  }
	
	  document.body.removeChild(inputEle);
	};
	
	function handleBackspaceCreator(nodeTypeName, titleNodeTypeName, contentNodeTypeName) {
	  return function handleBackspace(state, dispatch) {
	    var tr = state.tr,
	        schema = state.schema,
	        selection = state.selection;
	    var paragraph = schema.nodes.paragraph;
	
	    var note = schema.nodes[nodeTypeName];
	    var note_title = schema.nodes[titleNodeTypeName];
	    var note_content = schema.nodes[contentNodeTypeName];
	    var $cursor = selection.$cursor,
	        $from = selection.$from,
	        $to = selection.$to,
	        from = selection.from,
	        to = selection.to;
	
	
	    var assert1 = function assert1(node) {
	      return node.type === note;
	    };
	
	    var assert2 = function assert2(node) {
	      return node.type === note_title;
	    };
	
	    var assert3 = function assert3(node) {
	      return node.type === note_content;
	    };
	
	    if ($cursor) {
	      var parentType = $cursor.parent.type;
	      var plus = parentType.isInline ? 2 : 1;
	      var contentNode = $cursor.node(-plus);
	
	      if (!$cursor.nodeBefore && (parentType === note_title || parentType === note_content || contentNode && contentNode.type === note_content && contentNode.firstChild === $cursor.node(-plus + 1))) {
	        return true;
	      }
	    } else {
	      var fromNoteNode = findParentNode($from.path, assert1);
	      var toNoteNode = findParentNode($to.path, assert1);
	
	      if (fromNoteNode && toNoteNode && fromNoteNode.pos !== toNoteNode.pos || !fromNoteNode && toNoteNode || fromNoteNode && !toNoteNode) {
	        var newFrom = from;
	        var newTo = to;
	        if (fromNoteNode) newFrom = fromNoteNode.pos;
	        if (toNoteNode) newTo = toNoteNode.pos + toNoteNode.node.nodeSize;
	        dispatch(tr.delete(newFrom, newTo));
	        return true;
	      } else if (fromNoteNode) {
	        var noteNode = fromNoteNode.node;
	        var fromNoteTitleNode = findParentNode($from.path, assert2);
	        var toNoteContentNode = findParentNode($to.path, assert3);
	
	        if (fromNoteTitleNode && toNoteContentNode && noteNode.firstChild === fromNoteTitleNode.node && noteNode.lastChild === toNoteContentNode.node) {
	          var end = fromNoteTitleNode.pos + fromNoteTitleNode.node.nodeSize - 1;
	          var dis = end - from;
	          tr.delete(from, end);
	          tr.delete(toNoteContentNode.pos - dis, to - dis);
	          tr.setSelection(_prosemirrorState.TextSelection.create(tr.doc, from));
	          dispatch(tr);
	          return true;
	        }
	
	        if (toNoteContentNode && from - toNoteContentNode.pos < 3 && toNoteContentNode.pos + toNoteContentNode.node.nodeSize - to < 3) {
	          var start = toNoteContentNode.pos + 1;
	          var _end = toNoteContentNode.pos + toNoteContentNode.node.nodeSize - 1;
	          tr.replaceWith(start, _end, paragraph.create());
	          tr.setSelection(_prosemirrorState.TextSelection.create(tr.doc, from));
	          dispatch(tr);
	          return true;
	        }
	      }
	    }
	
	    return false;
	  };
	}
	function handleDeleteCreator(nodeTypeName, titleNodeTypeName, contentNodeTypeName) {
	  return function handleDelete(state, dispatch) {
	    var tr = state.tr,
	        schema = state.schema,
	        selection = state.selection;
	
	    var note = schema.nodes[nodeTypeName];
	    var note_title = schema.nodes[titleNodeTypeName];
	    var note_content = schema.nodes[contentNodeTypeName];
	    var $cursor = selection.$cursor,
	        $from = selection.$from,
	        $to = selection.$to,
	        from = selection.from,
	        to = selection.to;
	
	
	    var assert1 = function assert1(node) {
	      return node.type === note;
	    };
	
	    var assert2 = function assert2(node) {
	      return node.type === note_title;
	    };
	
	    var assert3 = function assert3(node) {
	      return node.type === note_content;
	    };
	
	    if ($cursor) {
	      var parentType = $cursor.parent.type;
	      var plus = parentType.isInline ? 2 : 1;
	
	      if (!$cursor.nodeAfter && ($cursor.parent.type === note_title || $cursor.node(-plus).type === note_content)) {
	        return true;
	      }
	    } else {
	      var fromNoteNode = findParentNode($from.path, assert1);
	      var toNoteNode = findParentNode($to.path, assert1);
	
	      if (fromNoteNode && toNoteNode && fromNoteNode.pos !== toNoteNode.pos || !fromNoteNode && toNoteNode || fromNoteNode && !toNoteNode) {
	        var newFrom = from;
	        var newTo = to;
	        if (fromNoteNode) newFrom = fromNoteNode.pos;
	        if (toNoteNode) newTo = toNoteNode.pos + toNoteNode.node.nodeSize;
	        dispatch(tr.delete(newFrom, newTo));
	        return true;
	      }
	
	      var fromNoteTitleNode = findParentNode($from.path, assert2);
	      var toNoteContentNode = findParentNode($to.path, assert3);
	
	      if (fromNoteTitleNode && toNoteContentNode) {
	        var end = fromNoteTitleNode.pos + fromNoteTitleNode.node.nodeSize - 1;
	        var dis = end - from;
	        tr.delete(from, end);
	        tr.delete(toNoteContentNode.pos - dis, to - dis);
	        tr.setSelection(_prosemirrorState.TextSelection.create(tr.doc, from));
	        dispatch(tr);
	        return true;
	      }
	
	      if (toNoteContentNode && toNoteContentNode.pos + 1 === from && toNoteContentNode.pos + toNoteContentNode.node.nodeSize - 1 === to) {
	        tr.delete(from + 1, to - 1);
	        tr.setSelection(_prosemirrorState.TextSelection.create(tr.doc, from));
	        dispatch(tr);
	        return true;
	      }
	    }
	
	    return false;
	  };
	}
	function handleTabCreator(nodeTypeName, titleNodeTypeName, contentNodeTypeName) {
	  return function handleTab(state, dispatch) {
	    var tr = state.tr,
	        schema = state.schema,
	        selection = state.selection;
	
	    var note_title = schema.nodes[titleNodeTypeName];
	    var $from = selection.$from;
	
	
	    var assert = function assert(node) {
	      return node.type === note_title;
	    };
	
	    var foundNode = findParentNode($from.path, assert);
	
	    if (foundNode) {
	      tr.setSelection(_prosemirrorState.TextSelection.create(tr.doc, foundNode.pos + foundNode.node.nodeSize + 2));
	      dispatch(tr);
	      return true;
	    }
	
	    return false;
	  };
	}
	function handleEnterCreator(nodeTypeName, titleNodeTypeName, contentNodeTypeName) {
	  return function handleEnter(state, dispatch, view) {
	    var tr = state.tr,
	        schema = state.schema,
	        selection = state.selection;
	    var $from = selection.$from;
	
	    var note_title = schema.nodes[titleNodeTypeName];
	    var foundNode = findParentNode($from.path, function (node) {
	      return node.type === note_title;
	    });
	
	    if (foundNode) {
	      var node = foundNode.node,
	          pos = foundNode.pos;
	
	      var newSelection = _prosemirrorState.TextSelection.create(tr.doc, pos + node.nodeSize + 1);
	      dispatch(tr.setSelection(newSelection));
	      view.focus();
	      return true;
	    }
	
	    return false;
	  };
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    (0, _defineProperty4.default)(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	var defineProperty = _defineProperty;
	
	function _objectSpread(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? arguments[i] : {};
	    var ownKeys = (0, _keys2.default)(source);
	
	    if (typeof _getOwnPropertySymbols2.default === 'function') {
	      ownKeys = ownKeys.concat((0, _getOwnPropertySymbols2.default)(source).filter(function (sym) {
	        return (0, _getOwnPropertyDescriptor2.default)(source, sym).enumerable;
	      }));
	    }
	
	    ownKeys.forEach(function (key) {
	      defineProperty(target, key, source[key]);
	    });
	  }
	
	  return target;
	}
	
	var objectSpread = _objectSpread;
	
	var uploadHelper = function uploadHelper(config) {
	  var preUpload = function preUpload() {
	    return '';
	  };
	
	  var onProgress = function onProgress() {
	    return null;
	  };
	
	  var finishUpload = function finishUpload() {};
	
	  var suffixes = config.suffixes,
	      limitSize = config.limitSize,
	      onSuffixError = config.onSuffixError,
	      onSizeError = config.onSizeError;
	
	
	  var setter = function setter(files) {
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = (0, _getIterator3.default)(files), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var file = _step.value;
	
	        if (suffixes && !checkSuffix(file.name, suffixes)) {
	          if (onSuffixError) onSuffixError(file.name);
	          continue;
	        }
	
	        if (limitSize && file.size / (1024 * 1024) > limitSize) {
	          if (onSizeError) onSizeError(file.size);
	          continue;
	        }
	
	        doUpload(file, config, {
	          preUpload: preUpload,
	          onProgress: onProgress,
	          finishUpload: finishUpload
	        });
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	  };
	
	  var getter = function getter(pre, on, finish) {
	    preUpload = pre;
	    onProgress = on;
	    finishUpload = finish;
	    return setter;
	  };
	
	  return [getter, setter];
	};
	
	var checkSuffix = function checkSuffix(name, suffixes) {
	  var temp = /\.[^.]+$/.exec(name);
	
	  if (temp) {
	    var suffix = temp[0].slice(1).toLowerCase();
	    return suffixes.findIndex(function (s) {
	      return suffix === s;
	    }) > -1;
	  }
	
	  return false;
	};
	
	var doUpload = function doUpload(file, config, hooks) {
	  var uploadUrl = config.uploadUrl,
	      onUploadError = config.onUploadError;
	  var preUpload = hooks.preUpload,
	      _onProgress = hooks.onProgress,
	      finishUpload = hooks.finishUpload;
	
	  var isImage = file.type.indexOf('image') > -1;
	  var key = preUpload({
	    file: file,
	    isImage: isImage
	  });
	  upload({
	    uploadUrl: uploadUrl,
	    onProgress: function onProgress(e) {
	      return _onProgress({
	        file: file,
	        isImage: isImage,
	        key: key
	      }, e);
	    },
	    addition: {}
	  }, file).then(function (res) {
	    finishUpload(objectSpread({
	      key: key,
	      res: res,
	      file: file,
	      isImage: isImage,
	      size: file.size
	    }, config));
	  }).catch(function (err) {
	    return onUploadError && onUploadError(err, key);
	  });
	};
	
	function upload() {
	  var conf = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var file = arguments[1];
	
	  var config = (0, _assign2.default)({}, defaultConf, conf);
	  var uploadUrl = config.uploadUrl,
	      addition = config.addition,
	      onProgress = config.onProgress;
	
	  var formData = fileFormBuilder(addition, file);
	  return uploadFile(uploadUrl, {
	    body: formData
	  }, onProgress);
	}
	
	var defaultConf = {
	  uploadUrl: '',
	  onProgress: function onProgress() {}
	};
	
	function fileFormBuilder() {
	  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var file = arguments[1];
	
	  var formData = new FormData();
	  var name = data.name || 'file';
	
	  if (data.filename) {
	    formData.append(name, file, data.filename);
	  } else {
	    formData.append(name, file);
	  }
	
	  (0, _keys2.default)(data).forEach(function (key) {
	    if (key !== 'name' && key !== 'filename') {
	      formData.append(key, data[key]);
	    }
	  });
	  return formData;
	}
	
	function uploadFile(url) {
	  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var onProgress = arguments[2];
	
	  return new _promise2.default(function (resolve, reject) {
	    var xhr = new XMLHttpRequest();
	    xhr.open('post', url);
	    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	
	    for (var k in opts.headers || {}) {
	      xhr.setRequestHeader(k, opts.headers[k]);
	    }
	
	    xhr.onload = function () {
	      if (xhr.status === 401 || xhr.message === 'auth failed') {
	        reject(xhr);
	      } else {
	        try {
	          resolve(JSON.parse(xhr.responseText));
	        } catch (error) {
	          resolve(xhr.responseText);
	        }
	      }
	    };
	
	    xhr.onerror = function () {
	      reject(xhr);
	    };
	
	    xhr.ontimeout = function () {
	      reject(xhr);
	    };
	
	    if (xhr.upload && onProgress) {
	      xhr.upload.onprogress = onProgress;
	    }
	
	    xhr.send(opts.body);
	  });
	}
	
	var PopoverStore = function () {
	  function PopoverStore() {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, PopoverStore);
	
	    this.view = null;
	    this.modules = null;
	    this.$scroll = null;
	    this.popover = null;
	    this.domNode = null;
	    this.isShow = false;
	    this.scrollTop = 0;
	
	    this.handleScroll = function () {
	      if (!_this.isShow) return;
	      var scrollTop = _this.$scroll.scrollTop;
	      _this.popover.style.top = parseFloat(_this.popover.style.top) + _this.scrollTop - scrollTop + 'px';
	      _this.scrollTop = scrollTop;
	    };
	  }
	
	  (0, _createClass3.default)(PopoverStore, [{
	    key: 'init',
	    value: function init(moduleManager) {
	      this.view = moduleManager.view;
	      this.$scroll = moduleManager.$scroll;
	      this.modules = moduleManager.modules;
	
	      if (this.$scroll.tagName === 'HTML') {
	        window.addEventListener('scroll', this.handleScroll);
	      } else {
	        this.$scroll.addEventListener('scroll', this.handleScroll);
	      }
	    }
	  }, {
	    key: 'onCreatePopover',
	    value: function onCreatePopover(popover) {
	      this.popover = popover;
	    }
	  }, {
	    key: 'onRemovePopover',
	    value: function onRemovePopover() {
	      this.hidePopover();
	
	      if (this.$scroll.tagName === 'HTML') {
	        window.removeEventListener('scroll', this.handleScroll);
	      } else {
	        this.$scroll.removeEventListener('scroll', this.handleScroll);
	      }
	    }
	  }, {
	    key: 'reShowPopover',
	    value: function reShowPopover() {
	      if (this.domNode) this.showPopover(this.domNode);
	    }
	  }, {
	    key: 'showPopover',
	    value: function showPopover(domNode) {
	      if (this.popover) {
	        this.popover.style.display = 'block';
	        this.domNode = domNode;
	        this.isShow = true;
	        this.scrollTop = this.$scroll.$scrollTop;
	      }
	    }
	  }, {
	    key: 'hidePopover',
	    value: function hidePopover() {
	      if (this.popover) {
	        this.popover.style.display = 'none';
	        this.isShow = false;
	      }
	    }
	  }]);
	  return PopoverStore;
	}();
	
	var createPlaceholder = function createPlaceholder(view, plugin, key, pos) {
	  var state = view.state,
	      dispatch = view.dispatch;
	
	  var placeholderPlugin = state.config.pluginsByKey[plugin];
	  dispatch(state.tr.setMeta(placeholderPlugin, {
	    add: {
	      key: key,
	      pos: pos
	    }
	  }).insertText('\u200B', pos).scrollIntoView());
	  view.focus();
	};
	var deletePlaceholder = function deletePlaceholder(view, plugin, key) {
	  var state = view.state,
	      dispatch = view.dispatch;
	
	  var placeholderPlugin = state.config.pluginsByKey[plugin];
	
	  try {
	    var transaction = state.tr.setMeta(placeholderPlugin, {
	      remove: {
	        key: key
	      }
	    });
	    dispatch(transaction);
	    view.focus();
	  } catch (err) {
	    console.error("placeholder maybe deleted", err);
	  }
	};
	var findPlaceholder = function findPlaceholder(view, plugin, key) {
	  var state = view.state;
	
	  var placeholderPlugin = state.config.pluginsByKey[plugin];
	  var found = placeholderPlugin.getState(state).find(null, null, function (spec) {
	    return spec.key === key;
	  });
	
	  if (found.length) {
	    return {
	      pos: found[0].from,
	      node: found[0].type.toDOM
	    };
	  }
	
	  return null;
	};
	
	var createShadowDOM = function createShadowDOM(_ref3) {
	  var dom = _ref3.dom,
	      content = _ref3.content;
	
	  if (!document.body.attachShadow) {
	    dom.innerHTML = content;
	    return;
	  }
	
	  var shadowWrapper = document.createElement("div");
	  shadowWrapper.setAttribute("class", _index.SHADOWDOM_CLASS);
	  var shadowRoot = shadowWrapper.attachShadow({
	    mode: "open"
	  });
	  shadowRoot.innerHTML = "<style>svg { width: 100%; height: 100%; } svg * { user-select: none }</style>";
	  shadowRoot.innerHTML += content;
	  dom.appendChild(shadowWrapper);
	};
	var getElementFromDOM = function getElementFromDOM(_ref4) {
	  var selector = _ref4.selector,
	      dom = _ref4.dom;
	
	  var shawdowWrapper = dom.querySelector('.' + _index.SHADOWDOM_CLASS);
	
	  if (shawdowWrapper && shawdowWrapper.shadowRoot) {
	    return shawdowWrapper.shadowRoot.querySelector(selector);
	  }
	
	  if (selector === "div") {
	    return dom;
	  }
	
	  return dom.querySelector(selector);
	};
	
	var DEFAULT_OPTIONS = {
	  method: "GET",
	  credentials: "include",
	  headers: {
	    "Cache-Control": "no-cache",
	    "X-Requested-With": "XMLHttpRequest"
	  }
	};
	var DEFAULT_TIMEOUT = 1e4;
	function advancedFetch(fetchPromise, timeout) {
	  var abortFn = function abortFn() {};
	
	  var abortPromise = new _promise2.default(function (resolve, reject) {
	    abortFn = function abortFn() {
	      reject(new Error("abort promise"));
	    };
	  });
	  var abortablePromise = _promise2.default.race([fetchPromise, abortPromise]);
	  var timer = setTimeout(function () {
	    abortFn();
	  }, timeout || DEFAULT_TIMEOUT);
	  return abortablePromise.then(function (data) {
	    clearTimeout(timer);
	    return data;
	  });
	}
	
	var text2JSON = function text2JSON(resText) {
	  var resJson = void 0;
	
	  try {
	    resJson = JSON.parse(resText);
	
	    if (resJson.status !== 0) {
	      var _resJson$data = resJson.data,
	          errorCode = _resJson$data.errorCode,
	          message = _resJson$data.message;
	
	      return _promise2.default.reject(console.error(errorCode, message));
	    }
	  } catch (err) {
	    return _promise2.default.resolve(resText);
	  }
	
	  if (resJson.data !== undefined) {
	    return _promise2.default.resolve(resJson.data);
	  }
	
	  return _promise2.default.resolve(resJson);
	};
	
	function transform(query) {
	  return (0, _keys2.default)(query).map(function (key) {
	    return key + '=' + query[key];
	  });
	}
	
	var send = function send(url, options) {
	  var isRedirect = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	  var timeout = arguments[3];
	
	  var fetchUrl = url;
	
	  if (options && options.query) {
	    fetchUrl += '?' + transform(options.query).join('&');
	  }
	
	  var fetchOptions = (0, _assign2.default)({}, DEFAULT_OPTIONS, options);
	  return advancedFetch(fetch(fetchUrl, fetchOptions), timeout).then(function (response) {
	    if (response.ok) {
	      return response.text();
	    }
	
	    return response.text().then(text2JSON).then(function (resJson) {
	      return _promise2.default.reject(new Error('status: ' + response.status + ', message: ' + resJson.message + ' }'));
	    });
	  }).then(text2JSON).catch(function (error) {
	    if (error.message === "auth failed") {
	      if (isRedirect) {
	        location.reload();
	      }
	    }
	
	    return _promise2.default.reject(error);
	  });
	};
	
	function createToolbar(onMouseDown) {
	  var $imgEditor = document.createElement("span");
	  $imgEditor.className = _index.RESIZER_CLASS;
	  $imgEditor.innerHTML = '\n      <span class="info info-rb"></span>\n      <span class="resizer resizer-lt"></span>\n      <span class="resizer resizer-lb"></span>\n      <span class="resizer resizer-rt"></span>\n      <span class="resizer resizer-rb"></span>\n    ';
	  $imgEditor.addEventListener("mousedown", onMouseDown, false);
	  return $imgEditor;
	}
	
	function calculateWidth(width, diff, isAdd, max, min) {
	  var result = isAdd ? width + diff : width - diff;
	
	  if (result <= min) {
	    return min;
	  } else if (result >= max) {
	    return max;
	  }
	
	  return result;
	}
	function calculateHeight(height, diffY, isAddY, max, min) {
	  var result = isAddY ? height + diffY : height - diffY;
	
	  if (result <= min) {
	    return min;
	  } else if (result >= max) {
	    return max;
	  }
	
	  return result;
	}
	function getContentDisplaySize(_ref5) {
	  var type = _ref5.type,
	      dom = _ref5.dom,
	      resizer = _ref5.resizer,
	      clientX = _ref5.clientX,
	      clientY = _ref5.clientY;
	
	  var imgNode = getElementFromDOM({
	    dom: dom,
	    selector: type
	  });
	  var isAdd = resizer.isAdd,
	      isAddY = resizer.isAddY,
	      startX = resizer.startX,
	      startY = resizer.startY,
	      originalWidth = resizer.originalWidth,
	      originalHeight = resizer.originalHeight,
	      maxWidth = resizer.maxWidth;
	
	  var diff = clientX - startX;
	  var diffY = clientY - startY;
	  var naturalHeight = 0;
	  var naturalWidth = 0;
	  var width = 0;
	  var height = 0;
	
	  switch (type) {
	    case "img":
	      naturalWidth = imgNode.naturalWidth;
	      naturalHeight = imgNode.naturalHeight;
	      break;
	
	    case "svg":
	      {
	        naturalWidth = imgNode.viewBox.baseVal.width;
	        naturalHeight = imgNode.viewBox.baseVal.height;
	        break;
	      }
	
	    case "div":
	      {
	        naturalWidth = imgNode.offsetWidth;
	        naturalHeight = imgNode.offsetHeight;
	        break;
	      }
	  }
	
	  var minWidth = naturalWidth;
	
	  if (naturalWidth < 5 || naturalWidth > 20) {
	    minWidth = _index.IMAGE_MIN_WIDTH;
	  }
	
	  width = calculateWidth(originalWidth, diff, isAdd, maxWidth, minWidth);
	
	  if (type !== "div") {
	    if (naturalHeight) {
	      height = width / naturalWidth * naturalHeight;
	    }
	  } else {
	    if (naturalHeight) {
	      height = calculateHeight(originalHeight, diffY, isAddY, 600, 150);
	      width = width < 320 ? 320 : width;
	    }
	  }
	
	  return {
	    width: width,
	    height: height,
	    imgNode: imgNode
	  };
	}
	
	var css$1 = ".ct-resizer{display:block;position:absolute;left:0;right:0;top:0;bottom:0;z-index:11;outline:1px dashed #aaa;pointer-events:none}.ct-resizer .resizer{position:absolute;width:24px;height:24px;pointer-events:auto}.ct-resizer .resizer:after{box-sizing:border-box;content:\" \";position:absolute;display:block;top:5px;left:5px;width:14px;height:14px;border-radius:7px;border:2px solid #fff;box-shadow:0 1px 2px 0;background-color:#333}.ct-resizer .info{position:absolute;padding:5px;font-size:12px;color:#fff;background:rgba(0,0,0,.7)}.ct-resizer .info-lt{left:8px;top:8px}.ct-resizer .info-lb{left:8px;bottom:8px}.ct-resizer .info-rt{right:8px;top:8px}.ct-resizer .info-rb{right:8px;bottom:8px}.ct-resizer .resizer-lt{left:-12px;top:-12px;cursor:nwse-resize}.ct-resizer .resizer-lb{left:-12px;bottom:-12px;cursor:nesw-resize}.ct-resizer .resizer-rt{right:-12px;top:-12px;cursor:nesw-resize}.ct-resizer .resizer-rb{right:-12px;bottom:-12px;cursor:nwse-resize}";
	styleInject(css$1);
	
	var RESIZING = "resizing";
	function resizer(constructor) {
	  constructor.prototype.ctShowResizer = showResizer;
	  constructor.prototype.ctHideResizer = hideResizer;
	  constructor.prototype.ctToggleDisplayOfImageInfo = toggleDisplayOfImageInfo;
	  constructor.prototype.ctResizeType = "img";
	  constructor.prototype.resizer = null;
	  constructor.prototype.node = null;
	  constructor.prototype.$imageInfo = null;
	  constructor.prototype.$resizer = null;
	  constructor.prototype.startMoveCallback = null;
	  constructor.prototype.endMoveCallback = null;
	
	  constructor.prototype.setStartMoveCallback = function (cb) {
	    this.startMoveCallback = cb;
	  };
	
	  constructor.prototype.setEndMoveCallback = function (cb) {
	    this.endMoveCallback = cb;
	  };
	
	  return constructor;
	}
	var onMouseDown = void 0;
	var onMouseMove = void 0;
	var onMouseUp = void 0;
	
	function resizerOnMouseDown(e) {
	  if (!e.target) {
	    return;
	  }
	
	  var classList = e.target.classList;
	
	  if (!classList.contains("resizer")) {
	    return;
	  }
	
	  if (!this.$imageInfo) {
	    return;
	  }
	
	  e.preventDefault();
	  var isLeftTop = classList.contains("resizer-lt");
	  var isLeftBottom = classList.contains("resizer-lb");
	  var isRightTop = classList.contains("resizer-rt");
	  var isRightBottom = classList.contains("resizer-rb");
	  var isAdd = isRightTop || isRightBottom;
	  var isAddY = isLeftBottom || isRightBottom;
	
	  if (isLeftTop) {
	    this.$imageInfo.className = "info info-lt";
	  } else if (isLeftBottom) {
	    this.$imageInfo.className = "info info-lb";
	  } else if (isRightTop) {
	    this.$imageInfo.className = "info info-rt";
	  } else if (isRightBottom) {
	    this.$imageInfo.className = "info info-rb";
	  }
	
	  var blockNode = findParentBlockNode(this.node.dom);
	
	  if (!blockNode) {
	    return;
	  }
	
	  var parentTagName = blockNode.parentNode.tagName.toLowerCase();
	  var maxWidth = blockNode.clientWidth - _index.IMAGE_OFFSET;
	
	  if ((parentTagName === "td" || parentTagName === "th") && blockNode.closest("table").classList.contains("responsive")) {
	    maxWidth = 1920;
	  }
	
	  this.resizer = {
	    maxWidth: maxWidth,
	    isAdd: isAdd,
	    isAddY: isAddY,
	    isResizing: false,
	    startX: e.clientX,
	    startY: e.clientY,
	    originalWidth: this.node.dom.clientWidth,
	    originalHeight: this.node.dom.clientHeight
	  };
	  setResizerState();
	  window.addEventListener("mousemove", onMouseMove);
	  window.addEventListener("mouseup", onMouseUp);
	}
	
	var resizerOnMouseMove = function resizerOnMouseMove(e) {
	  if (!this.resizer) {
	    return;
	  }
	
	  if (this.node.dom.querySelector(".ct-editor-loading")) {
	    return;
	  }
	
	  var _getContentDisplaySiz = getContentDisplaySize({
	    type: this.ctResizeType,
	    dom: this.node.dom,
	    resizer: this.resizer,
	    clientX: e.clientX,
	    clientY: e.clientY
	  }),
	      width = _getContentDisplaySiz.width,
	      height = _getContentDisplaySiz.height;
	
	  this.resizer.width = width;
	
	  if (height) {
	    this.resizer.height = height;
	  }
	
	  this.node.dom.style.width = this.resizer.width + 'px';
	
	  if (height) {
	    this.node.dom.style.height = this.resizer.height + 'px';
	  }
	
	  if (this.startMoveCallback) {
	    this.startMoveCallback(height, width);
	  }
	
	  this.ctToggleDisplayOfImageInfo();
	  this.resizer.isResizing = true;
	};
	
	resizerOnMouseMove = (0, _lodash2.default)(resizerOnMouseMove, 16);
	
	function resizerOnMouseUp() {
	  if (!this.resizer) {
	    return;
	  }
	
	  if (!this.resizer.isResizing) {
	    this.resizer = null;
	    return;
	  }
	
	  var _resizer = this.resizer,
	      isResizing = _resizer.isResizing,
	      width = _resizer.width;
	
	
	  if (!isResizing || !width) {
	    return;
	  }
	
	  this.resizer.isResizing = false;
	  var imgNode = getElementFromDOM({
	    dom: this.node.dom,
	    selector: this.ctResizeType
	  });
	
	  if (imgNode) {
	    try {
	      this.updateAttrs({
	        width: imgNode.clientWidth,
	        height: imgNode.clientHeight,
	        hadResize: true
	      });
	    } catch (err) {
	      console.error(err);
	    }
	  }
	
	  dropResizerState();
	
	  if (this.endMoveCallback) {
	    this.endMoveCallback();
	  }
	
	  window.removeEventListener("mousemove", onMouseMove);
	  window.removeEventListener("mouseup", onMouseUp);
	}
	
	function toggleDisplayOfImageInfo() {
	  var spanDOM = this.node.dom;
	  var styleWidth = parseInt(spanDOM.style.width, 10);
	  var width = spanDOM.clientWidth;
	  var height = spanDOM.clientHeight;
	
	  if (styleWidth && width !== styleWidth) {
	    height = parseInt('' + styleWidth / width * height, 10);
	    width = styleWidth;
	  }
	
	  var textContent = width + ' \xD7 ' + height;
	
	  if (spanDOM.clientWidth < textContent.length * 8 + 10 || spanDOM.clientHeight < _index.IMAGE_INFO_DISPLAY_MIN_HEIGHT_SIZE) {
	    this.$imageInfo.style.display = "none";
	  } else {
	    this.$imageInfo.style.display = "block";
	    this.$imageInfo.textContent = textContent;
	  }
	}
	
	function hideResizer() {
	  if (this.$resizer) {
	    this.$resizer.remove();
	    this.$resizer = null;
	    this.$imageInfo = null;
	    this.resizer = null;
	  }
	}
	
	function showResizer(config) {
	  if (config) {
	    if (config.node) {
	      this.node = config.node;
	    }
	
	    this.ctResizeType = config.type;
	  }
	
	  onMouseDown = resizerOnMouseDown.bind(this);
	  onMouseMove = resizerOnMouseMove.bind(this);
	  onMouseUp = resizerOnMouseUp.bind(this);
	  this.$resizer = createToolbar(onMouseDown);
	  this.$imageInfo = this.$resizer.firstElementChild;
	  this.node.dom.appendChild(this.$resizer);
	  this.ctToggleDisplayOfImageInfo();
	}
	
	function setResizerState() {
	  var popovers = document.getElementsByClassName(_index.POPOVER_CLASS);
	  window.ctImgResizing = true;
	
	  (0, _from2.default)(popovers).forEach(function (node) {
	    if (node.childNodes.length > 0) {
	      node.classList.add(RESIZING);
	    }
	  });
	}
	
	function dropResizerState() {
	  var popovers = document.getElementsByClassName(_index.POPOVER_CLASS);
	  window.ctImgResizing = false;
	
	  (0, _from2.default)(popovers).forEach(function (node) {
	    if (node.classList.contains(RESIZING)) {
	      node.classList.remove(RESIZING);
	    }
	  });
	}
	
	var css$2 = ".ct-toolbox-popover{display:none;position:absolute;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;height:-webkit-fit-content;height:-moz-fit-content;height:fit-content;pointer-events:none;background:transparent;z-index:98;transition:opacity .2s ease}.ct-toolbox-popover.resizing{height:-webkit-fit-content!important;height:-moz-fit-content!important;height:fit-content!important}.ct-toolbox-popover .ct-toolbox{position:-webkit-sticky;position:sticky;display:flex;top:0;flex-direction:row;align-items:center;background:#fff;font-size:12px;box-shadow:0 4px 16px 0 rgba(106,93,73,.2),0 8px 20px 0 rgba(106,93,73,.1);border-radius:1px;pointer-events:all}.ct-toolbox-popover .ct-toolbox.in-table{top:30px}.ct-toolbox-popover .ct-toolbox.nosticky{position:relative}.ct-toolbox-popover .ct-toolbox.nosticky.in-table{top:0}";
	styleInject(css$2);
	
	var getDOMOffset = function getDOMOffset(_ref6) {
	  var offsetParent = _ref6.offsetParent,
	      dom = _ref6.dom,
	      toolboxHeight = _ref6.toolboxHeight,
	      _ref6$bottomFirst = _ref6.bottomFirst,
	      bottomFirst = _ref6$bottomFirst === undefined ? false : _ref6$bottomFirst,
	      popoverWidth = _ref6.popoverWidth;
	
	  var top = 0;
	  var left = 0;
	  var right = "auto";
	
	  var _dom$getBoundingClien = dom.getBoundingClientRect(),
	      domLeft = _dom$getBoundingClien.left,
	      domTop = _dom$getBoundingClien.top,
	      domBottom = _dom$getBoundingClien.bottom;
	
	  var _offsetParent$getBoun = offsetParent.getBoundingClientRect(),
	      parentLeft = _offsetParent$getBoun.left,
	      parentTop = _offsetParent$getBoun.top,
	      parentRight = _offsetParent$getBoun.right;
	
	  var avHeight = window.innerHeight;
	  top = domTop - parentTop;
	
	  left = domLeft - parentLeft;
	
	  if (bottomFirst && avHeight - domBottom - 50 > toolboxHeight) {
	    top = domBottom - parentTop + 2;
	  } else {
	    top = top - toolboxHeight - 2;
	  }
	
	  var rightWidth = parentRight - domLeft;
	
	  if (rightWidth < popoverWidth) {
	    left = "auto";
	    right = 0;
	  }
	
	  if (left < 0) {
	    left = 0;
	    right = "auto";
	  }
	
	  return {
	    left: left,
	    top: top,
	    right: right
	  };
	};
	var setPopoverStyle = function setPopoverStyle(_ref7) {
	  var $popover = _ref7.$popover,
	      dom = _ref7.dom,
	      customStyle = _ref7.customStyle,
	      offsetParent = _ref7.offsetParent,
	      toolboxHeight = _ref7.toolboxHeight,
	      bottomFirst = _ref7.bottomFirst,
	      popoverWidth = _ref7.popoverWidth;
	
	  $popover.style.display = "block";
	
	  if (dom) {
	    var height = dom.offsetHeight + toolboxHeight;
	
	    if (!offsetParent || !$popover) {
	      return;
	    }
	
	    var style = getDOMOffset({
	      offsetParent: offsetParent,
	      dom: dom,
	      toolboxHeight: toolboxHeight,
	      bottomFirst: bottomFirst,
	      popoverWidth: popoverWidth
	    });
	    (0, _entries2.default)(style).forEach(function (_ref8) {
	      var _ref9 = (0, _slicedToArray3.default)(_ref8, 2),
	          key = _ref9[0],
	          value = _ref9[1];
	
	      if (/[0-9]+/.test(value)) {
	        $popover.style[key] = value + 'px';
	      } else {
	        $popover.style[key] = '' + value;
	      }
	    });
	    $popover.style.height = height + 'px';
	  } else if (customStyle) {
	    (0, _keys2.default)(customStyle).forEach(function (key) {
	      $popover.style[key] = customStyle[key];
	    });
	  }
	};
	var emptyDOM = function emptyDOM(renderDOM) {
	  if (renderDOM.firstElementChild) {
	    (0, _preact.render)(null, renderDOM, renderDOM.firstElementChild);
	  }
	};
	
	var SHOW = "show";
	var HIDE = "hide";
	var TOOLBOX_HEIGHT = 34;
	
	var Popover = function () {
	  function Popover(_ref10) {
	    var _this2 = this;
	
	    var view = _ref10.view,
	        store = _ref10.store,
	        className = _ref10.className,
	        height = _ref10.height,
	        _ref10$autoControl = _ref10.autoControl,
	        autoControl = _ref10$autoControl === undefined ? true : _ref10$autoControl,
	        _ref10$bottomFirst = _ref10.bottomFirst,
	        bottomFirst = _ref10$bottomFirst === undefined ? false : _ref10$bottomFirst,
	        _ref10$sticky = _ref10.sticky,
	        sticky = _ref10$sticky === undefined ? true : _ref10$sticky,
	        getToolboxHeightFn = _ref10.getToolboxHeightFn;
	    (0, _classCallCheck3.default)(this, Popover);
	
	    this.toolboxHeight = void 0;
	    this.getToolboxHeightFn = void 0;
	    this.offsetParent = void 0;
	    this.offsetParentRect = void 0;
	    this.$popover = void 0;
	    this.store = void 0;
	    this.view = void 0;
	    this.pluginName = void 0;
	    this.isAutoControl = void 0;
	    this.isBottomFirst = void 0;
	    this.isSticky = void 0;
	    this.tableWrapper = void 0;
	    this.popoverWidth = void 0;
	    this.tableOffset = void 0;
	    this.popoverState = HIDE;
	
	    this.setPopoverState = function (state) {
	      _this2.popoverState = state;
	    };
	
	    this.checkTable = function (dom) {
	      if (!dom) {
	        return;
	      }
	
	      _this2.tableWrapper = dom.closest(".ct-table-wrapper");
	    };
	
	    this.fixTableScroll = function () {
	      if (!_this2.isAutoControl) {
	        return;
	      }
	
	      if (_this2.$popover.firstElementChild) {
	        if (_this2.tableWrapper) {
	          _this2.$popover.firstElementChild.classList.add("in-table");
	          _this2.tableWrapper.addEventListener("scroll", _this2.updatePopover);
	        } else {
	          _this2.tableOffset = null;
	          _this2.$popover.firstElementChild.classList.remove("in-table");
	        }
	      }
	    };
	
	    this.updatePopover = function () {
	      var node = objectSpread({}, _this2.store.node);
	
	      _this2.store.hidePopover();
	      _this2.store.showPopover(node);
	    };
	
	    this.toolboxHeight = height || TOOLBOX_HEIGHT;
	    this.getToolboxHeightFn = getToolboxHeightFn;
	    this.isAutoControl = autoControl;
	    this.isBottomFirst = bottomFirst;
	    this.isSticky = sticky;
	    this.updatePopover = (0, _lodash2.default)(this.updatePopover, 16);
	    this.tableOffset = null;
	    this.store = store;
	    this.view = view;
	    this.$popover = document.createElement("div");
	    this.$popover.className = 'ct-toolbox-popover ' + (className || "");
	    this.store.ctPopover = this;
	
	    if (view.dom.parentElement) {
	      view.dom.parentElement.appendChild(this.$popover);
	    }
	  }
	
	  (0, _createClass3.default)(Popover, [{
	    key: 'show',
	    value: function show(_ref11) {
	      var dom = _ref11.dom,
	          content = _ref11.content,
	          customStyle = _ref11.customStyle,
	          _ref11$forceUpdate = _ref11.forceUpdate,
	          forceUpdate = _ref11$forceUpdate === undefined ? false : _ref11$forceUpdate;
	
	      if (this.popoverState === SHOW && !forceUpdate) {
	        return;
	      }
	
	      if (this.popoverState === HIDE) {
	        var offsetParent = this.view.dom.parentElement;
	        this.checkTable(dom);
	        var toolboxHeight = this.toolboxHeight;
	
	        if (this.getToolboxHeightFn) {
	          toolboxHeight = this.getToolboxHeightFn();
	        }
	
	        setPopoverStyle({
	          $popover: this.$popover,
	          dom: dom,
	          customStyle: customStyle,
	          offsetParent: offsetParent,
	          toolboxHeight: toolboxHeight,
	          bottomFirst: this.isBottomFirst,
	          popoverWidth: this.popoverWidth
	        });
	      }
	
	      if (forceUpdate) {
	        emptyDOM(this.$popover);
	      }
	
	      (0, _preact.render)(content, this.$popover);
	
	      if (this.$popover.firstElementChild) {
	        var $child = this.$popover.firstElementChild;
	        $child.classList.add("ct-toolbox");
	
	        if (!this.isSticky) {
	          $child.classList.add("nosticky");
	        }
	
	        this.fixTableScroll();
	        this.setPopoverState(SHOW);
	      }
	
	      if (!this.popoverWidth) {
	        this.updatePopover();
	      }
	    }
	  }, {
	    key: 'hide',
	    value: function hide() {
	      if (this.popoverState === HIDE) {
	        return;
	      }
	
	      this.popoverWidth = this.$popover.offsetWidth;
	      emptyDOM(this.$popover);
	
	      if (this.isAutoControl && this.tableWrapper) {
	        this.tableWrapper.removeEventListener("scroll", this.updatePopover);
	      }
	
	      this.$popover.setAttribute("style", "");
	      this.$popover.style.display = "none";
	      this.setPopoverState(HIDE);
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      this.$popover.remove();
	    }
	  }, {
	    key: 'update',
	    value: function update(view) {
	      var selection = view.state.selection;
	
	      var selNode = selection.node;
	
	      if (this.store.handleViewUpdate) {
	        this.store.handleViewUpdate({
	          view: view,
	          selNode: selNode,
	          selection: selection
	        });
	      } else if (this.isAutoControl && this.store.pluginName) {
	        try {
	          var pluginName = this.store.pluginName.match(/([a-z|A-Z]+)/)[0].toLowerCase();
	          var pos = null;
	          var attrs = {};
	          var dom = null;
	
	          if (selection.node && selection.node.type.name.toLowerCase() === pluginName) {
	            var $from = selection.$from;
	
	            pos = $from.pos;
	            var nodeAfter = $from.nodeAfter;
	
	            attrs = nodeAfter.attrs;
	          }
	
	          if (pos === null) {
	            var findResult = findParentNode(selection.$anchor.path, function (item) {
	              return item.type && item.type.name === pluginName;
	            });
	
	            if (findResult) {
	              pos = findResult.pos;
	              attrs = findResult.node.attrs;
	            }
	          }
	
	          dom = view.nodeDOM(pos);
	
	          if (dom && dom.classList && !dom.classList.contains("failed")) {
	            var _attrs = attrs,
	                content = _attrs.content;
	
	            this.store.hidePopover();
	            this.store.showPopover({
	              dom: dom,
	              pos: pos,
	              data: content,
	              attrs: attrs,
	              view: view
	            });
	          } else if (this.store.hidePopover) {
	            this.store.hidePopover();
	          }
	        } catch (err) {
	          console.error("showPopover failed", err);
	        }
	      }
	    }
	  }]);
	  return Popover;
	}();
	
	function calculateSize(originWidth, originHeight, containerWidth) {
	  var imageMaxHeight = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _index.IMAGE_MAX_HEIGHT;
	
	  var result = {
	    newOriginHeight: 0,
	    newOriginWidth: 0,
	    height: 0,
	    width: 0
	  };
	
	  if (originHeight < imageMaxHeight) {
	    result.newOriginWidth = originWidth;
	    result.newOriginHeight = originHeight;
	
	    if (originWidth > containerWidth) {
	      result.width = containerWidth;
	      result.height = +(originHeight * containerWidth / originWidth).toFixed(2);
	    } else {
	      result.width = originWidth;
	      result.height = originHeight;
	    }
	  } else {
	    result.width = +(originWidth * imageMaxHeight / originHeight).toFixed(2);
	    result.height = imageMaxHeight;
	    result.newOriginWidth = result.width;
	    result.newOriginHeight = imageMaxHeight;
	
	    if (result.width > containerWidth) {
	      result.width = containerWidth;
	
	      result.height = +(containerWidth / originWidth * originHeight).toFixed(2);
	    }
	  }
	
	  return result;
	}
	
	function calculatePercent(total, loaded) {
	  var percent = "0";
	
	  if (total) {
	    if (loaded === total) {
	      percent = "99";
	    } else {
	      percent = (loaded / total * 100).toFixed(2);
	    }
	  }
	
	  return percent + '%';
	}
	function createUploadMask() {
	  var widget = document.createElement("span");
	  widget.setAttribute("class", "ct-image");
	  widget.setAttribute("data-type", "ct-progress");
	  widget.innerHTML = '\n    <img src="" />\n    <div class="ct-image-mask image">\n      <span class="ct-image-loading"></span>\n      <span class="ct-image-progress">0%</span>\n      <span class="ct-image-load-failed">\u62B1\u6B49\uFF0C\u56FE\u7247\u4E0A\u4F20\u5931\u8D25\uFF01<br style="line-height:0">\u5982\u679C\u662F\u4ECE\u5916\u90E8\u62D6\u52A8\u3001\u7C98\u8D34\u8FC7\u6765\u7684\u56FE\u7247\uFF0C\u8BF7\u4E0B\u8F7D\u539F\u56FE\u5E76\u91CD\u65B0\u4E0A\u4F20\u3002<br style="line-height:0">\u5426\u5219\uFF0C\u8BF7\u70B9\u51FB\u4E0B\u65B9\u6309\u94AE\u8FDB\u884C\u91CD\u8BD5\u3002\n      </span>\n      <button class="ct-image-reupload">\u91CD\u8BD5</button>\n    </div>\n  ';
	  return widget;
	}
	
	function uploader(constructor) {
	  constructor.prototype.insertFiles = insertFiles;
	  constructor.prototype.prepare = prepare;
	  constructor.prototype.onprogress = onprogress;
	  constructor.prototype.failed = failed;
	  return constructor;
	}
	
	function insertFiles(files, style) {
	  var _this3 = this;
	
	  var customUpload = this.config.customUpload;
	  var uploadCheck = this.config.customUploadCheck;
	  return _promise2.default.all((0, _from2.default)(files).map(function () {
	    var _ref12 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(file) {
	      var key, failedHandle;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.t0 = !uploadCheck;
	
	              if (_context.t0) {
	                _context.next = 5;
	                break;
	              }
	
	              _context.next = 4;
	              return uploadCheck(file);
	
	            case 4:
	              _context.t0 = _context.sent;
	
	            case 5:
	              if (!_context.t0) {
	                _context.next = 10;
	                break;
	              }
	
	              key = uuid$1();
	
	              _this3.prepare({
	                key: key,
	                file: file,
	                style: style
	              });
	              failedHandle = _this3.failed(key, file);
	              return _context.abrupt('return', customUpload({
	                file: file,
	                onprogress: _this3.onprogress(key),
	                insert: _this3.insertToDoc(key, file.name, failedHandle),
	                failedHandle: failedHandle
	              }));
	
	            case 10:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this3);
	    }));
	
	    return function (_x8) {
	      return _ref12.apply(this, arguments);
	    };
	  }()));
	}
	
	function prepare(_ref13) {
	  var key = _ref13.key,
	      file = _ref13.file,
	      url = _ref13.url,
	      position = _ref13.position,
	      style = _ref13.style;
	  var _view = this.view,
	      tr = _view.state.tr,
	      dispatch = _view.dispatch;
	
	  var pos = typeof position === "number" ? position : tr.selection.from;
	  var src = url || URL.createObjectURL(file);
	
	  if (!tr.selection.empty) {
	    tr.deleteSelection();
	    dispatch(tr);
	  }
	
	  createPlaceholder(this.view, this.pluginName, key, pos);
	  var placeholderInfo = findPlaceholder(this.view, this.pluginName, key);
	
	  if (!placeholderInfo) {
	    return;
	  }
	
	  if (this.uploadingDisplay) {
	    this.uploadingDisplay({
	      key: key,
	      file: file,
	      placeholderInfo: placeholderInfo
	    });
	  } else {
	    var node = placeholderInfo.node;
	
	    var $img = node.querySelector("img");
	    $img.src = src;
	
	    if (style) {
	      (0, _entries2.default)(style).forEach(function (_ref14) {
	        var _ref15 = (0, _slicedToArray3.default)(_ref14, 2),
	            name = _ref15[0],
	            rule = _ref15[1];
	
	        $img.style[name] = rule;
	      });
	    }
	  }
	
	  return key;
	}
	
	function onprogress(key) {
	  var _this4 = this;
	
	  return function (_ref16) {
	    var total = _ref16.total,
	        loaded = _ref16.loaded;
	
	    var placeholder = findPlaceholder(_this4.view, _this4.pluginName, key);
	
	    if (!placeholder) {
	      return;
	    }
	
	    placeholder.node.querySelector(".ct-image-progress").innerText = calculatePercent(total, loaded);
	  };
	}
	
	function failed(key, file, customReupload) {
	  var _this5 = this;
	
	  return function (msg) {
	    var placeholder = findPlaceholder(_this5.view, _this5.pluginName, key);
	
	    if (!placeholder) {
	      return;
	    }
	
	    var node = placeholder.node;
	
	    var $progress = node.querySelector(".ct-image-progress");
	    var $loading = node.querySelector(".ct-image-loading");
	    var $loadFailed = node.querySelector(".ct-image-load-failed");
	    var $btnUpload = node.querySelector(".ct-image-reupload");
	    $loading.style.display = "none";
	    $progress.style.display = "none";
	    $loadFailed.style.display = "block";
	    $btnUpload.style.display = "block";
	    $btnUpload.addEventListener("click", function () {
	      deletePlaceholder(_this5.view, _this5.pluginName, key);
	
	      if (customReupload) {
	        customReupload();
	      } else {
	        _this5.insertFiles([file]);
	      }
	    });
	  };
	}
	
	var computeSliceMinWidth = function computeSliceMinWidth(slice) {
	  var result = 0;
	  slice.content.forEach(function (node) {
	    var name = node.type.name;
	    var braceWidth = node.type.schema.nodes[name].spec.braceWidth;
	    var width = parseInt(node.attrs.width, 10) || braceWidth || 0;
	
	    if (width > result) {
	      result = width;
	    }
	  });
	  return result;
	};
	
	var $CtLoading = function () {
	  var div = document.createElement("div");
	  div.classList.add("ct-editor-loading");
	  div.innerHTML = '<div class="loading-wrapper"><i></i><i></i><i></i></div>';
	  return div;
	}();
	
	function download(src, otherAttributes, useOpen) {
	  var url = '' + src + (src.indexOf('?') > -1 ? '&' : '?') + 'download=true';
	
	  if (useOpen) {
	    window.open(url);
	    return;
	  }
	
	  var aEl = document.createElement('a');
	  aEl.setAttribute('href', url);
	
	  if (typeof otherAttributes === 'string') {
	    aEl.setAttribute('download', otherAttributes);
	    aEl.download = otherAttributes;
	  }
	
	  if ((typeof otherAttributes === 'undefined' ? 'undefined' : (0, _typeof3.default)(otherAttributes)) === 'object') {
	    (0, _keys2.default)(otherAttributes).forEach(function (attrKey) {
	      return aEl.setAttribute(attrKey, otherAttributes[attrKey]);
	    });
	  }
	
	  aEl.click();
	}
	
	var css$3 = ".ct-toolbar-tooltip{position:absolute;left:50%;-webkit-transform:translate(-50%);transform:translate(-50%);bottom:-35px;height:25px;padding:0 10px;line-height:25px;white-space:nowrap;vertical-align:middle;color:#fff;font-size:12px;background:rgba(0,0,0,.7);border-radius:4px;z-index:1}.ct-toolbar-tooltip:after{position:absolute;width:0;top:-5px;right:50%;-webkit-transform:translate(50%);transform:translate(50%);display:block;border-color:rgba(0,0,0,.7) transparent;border-style:solid;border-width:0 5px 5px;content:\"\";z-index:1}.ct-input{border:1px solid #ddd;border-radius:2px}.ct-web-dangers-shadow-wrapper{width:100%;height:100%}.ct-image.ProseMirror-widget{vertical-align:bottom}.ct-img-failed{display:inline-block;width:100%;height:100%}:.ct-img-failed:before{content:\"\";position:absolute;left:0;top:0;display:block;width:100%;height:100%;background:#f6f6f6;z-index:1}.ct-img-failed:after{content:\"\";position:absolute;left:12px;top:12px;display:block;width:28px;height:20px;z-index:2;background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg class='icon' viewBox='0 0 1380 1024' xmlns='http://www.w3.org/2000/svg' width='26.953' height='20'%3E%3Cdefs%3E%3Cstyle/%3E%3C/defs%3E%3Cpath d='M526.889 315.732l165.016 171.024a66.785 66.785 0 0 1 18.724 46.371V737.77l135.664-202.254-123.399-162.635a66.78 66.78 0 0 1-8.027-67.029L830.58 40.121C841.19 15.756 865.235.001 891.809.001h338.475c82.394 0 149.89 65.742 149.89 147.731V876.27c0 81.989-67.496 147.731-149.89 147.731H149.89C67.496 1024.001 0 958.259 0 876.27V147.732C0 65.743 67.496.001 149.89.001h393.258c45.99 0 78.216 45.4 63.044 88.815L526.89 315.733z' fill='%237F9496'/%3E%3Cpath d='M543.148 66.783l-83.824 239.855a44.52 44.52 0 0 0 9.99 45.602l174.532 180.887v277.792a44.52 44.52 0 0 0 19.721 36.974c20.42 13.697 48.078 8.247 61.775-12.173l185.264-276.199c10.592-15.791 9.987-36.565-1.506-51.712L776.096 332.515 891.809 66.784h338.475c45.899 0 83.107 36.242 83.107 80.949v728.538c0 44.707-37.208 80.949-83.107 80.949H149.89c-45.899 0-83.107-36.242-83.107-80.949V147.733c0-44.707 37.208-80.949 83.107-80.949h393.258z' fill='%23FFF'/%3E%3Cpath d='M496.955 289.391l252.816 398.046 196.047-178.035 300.791 358.771H133.566z' fill='%23DDD'/%3E%3Cpath d='M526.889 315.732l165.016 171.024a66.785 66.785 0 0 1 18.724 46.371V737.77l135.664-202.254-123.399-162.635a66.78 66.78 0 0 1-8.027-67.029L830.58 40.121C841.19 15.756 865.235.001 891.809.001h338.475c82.394 0 149.89 65.742 149.89 147.731V876.27c0 81.989-67.496 147.731-149.89 147.731H149.89C67.496 1024.001 0 958.259 0 876.27V147.732C0 65.743 67.496.001 149.89.001h393.258c45.99 0 78.216 45.4 63.044 88.815L526.89 315.733zm16.259-248.949H149.89c-45.899 0-83.107 36.242-83.107 80.949V876.27c0 44.707 37.208 80.949 83.107 80.949h1080.394c45.899 0 83.107-36.242 83.107-80.949V147.732c0-44.707-37.208-80.949-83.107-80.949H891.809L776.096 332.514 909.1 507.808c11.493 15.147 12.098 35.922 1.506 51.712L725.342 835.719c-13.697 20.42-41.355 25.871-61.775 12.173a44.522 44.522 0 0 1-19.721-36.974V533.126L469.314 352.239a44.523 44.523 0 0 1-9.99-45.602l83.824-239.855z' fill='%237F9496'/%3E%3Cpath d='M1230.284 309.628c0 67.06-55.813 121.423-124.661 121.423s-124.661-54.363-124.661-121.423 55.813-121.423 124.661-121.423 124.661 54.363 124.661 121.423z' fill='%23EEE'/%3E%3C/svg%3E\") no-repeat 0 0}.ct-editor-loading{display:inline-block;font-size:12px;position:absolute;bottom:0;left:0;right:0;top:0;z-index:9;text-align:center;white-space:nowrap;background:#f6f6f6}.ct-editor-loading .loading-wrapper{position:absolute;left:0;right:0;top:50%;height:-webkit-fit-content;height:-moz-fit-content;height:fit-content;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.ct-editor-loading .loading-wrapper>i{display:none;vertical-align:middle}.ct-editor-loading .loading-wrapper>i:after,.ct-editor-loading .loading-wrapper>i:before{content:\" \";display:inline-block;height:100%;margin-left:-.25em;vertical-align:middle}.ct-editor-loading .loading-wrapper i:nth-child(-n+3){display:inline-block;width:1em;height:1em;background:#00a7cd;border-radius:50%;-webkit-animation:bounce-delay 1.4s ease-in-out infinite both;animation:bounce-delay 1.4s ease-in-out infinite both}.ct-editor-loading .loading-wrapper i:not(:last-child){margin-right:.4em}.ct-editor-loading .loading-wrapper i:first-child{-webkit-animation-delay:-.32s;animation-delay:-.32s}.ct-editor-loading .loading-wrapper i:nth-child(2){-webkit-animation-delay:-.16s;animation-delay:-.16s}@-webkit-keyframes bounce-delay{0%,80%,to{-webkit-transform:scale(0);transform:scale(0)}40%{-webkit-transform:scale(1);transform:scale(1)}}@keyframes bounce-delay{0%,80%,to{-webkit-transform:scale(0);transform:scale(0)}40%{-webkit-transform:scale(1);transform:scale(1)}}";
	styleInject(css$3);
	
	exports.getContentWidth = getContentWidth;
	exports.findParentNode = findParentNode;
	exports.findParentDOM = findParentDOM;
	exports.findParentBlockNode = findParentBlockNode;
	exports.setBetweenAttrs = setBetweenAttrs;
	exports.getInsertBlockSlice = getInsertBlockSlice;
	exports.insertBlock = insertBlock;
	exports.canInsertTypes = canInsertTypes;
	exports.getBlockNode = getBlockNode;
	exports.isChild = isChild;
	exports.getSystemInfo = getSystemInfo;
	exports.isPrintableKey = isPrintableKey;
	exports.compute = compute;
	exports.getTargetLeft = getTargetLeft;
	exports.checkConfig = checkConfig;
	exports.uuid = uuid$1;
	exports.fixSvgRatio = fixSvgRatio;
	exports.getSizeFromSvg = getSizeFromSvg;
	exports.getSvgSizeAfterEdit = getSvgSizeAfterEdit;
	exports.getDynamicSrc = getDynamicSrc;
	exports.copyToClipboard = copyToClipboard;
	exports.mobileCopyToClipboard = mobileCopyToClipboard;
	exports.handleBackspaceCreator = handleBackspaceCreator;
	exports.handleDeleteCreator = handleDeleteCreator;
	exports.handleTabCreator = handleTabCreator;
	exports.handleEnterCreator = handleEnterCreator;
	exports.uploadHelper = uploadHelper;
	exports.PopoverStore = PopoverStore;
	exports.createPlaceholder = createPlaceholder;
	exports.findPlaceholder = findPlaceholder;
	exports.deletePlaceholder = deletePlaceholder;
	exports.createShadowDOM = createShadowDOM;
	exports.getElementFromDOM = getElementFromDOM;
	exports.send = send;
	exports.resizer = resizer;
	exports.calculateWidth = calculateWidth;
	exports.Popover = Popover;
	exports.uploader = uploader;
	exports.calculateSize = calculateSize;
	exports.createUploadMask = createUploadMask;
	exports.computeSliceMinWidth = computeSliceMinWidth;
	exports.$CtLoading = $CtLoading;
	exports.download = download;
	exports.config = config;

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass2 = __webpack_require__(10);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _classCallCheck2 = __webpack_require__(7);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _set = __webpack_require__(101);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _getOwnPropertyDescriptor = __webpack_require__(23);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getOwnPropertySymbols = __webpack_require__(16);
	
	var _getOwnPropertySymbols2 = _interopRequireDefault(_getOwnPropertySymbols);
	
	var _keys = __webpack_require__(13);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _defineProperty2 = __webpack_require__(15);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _typeof2 = __webpack_require__(8);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault(ex) {
	  return ex && (typeof ex === 'undefined' ? 'undefined' : (0, _typeof3.default)(ex)) === 'object' && 'default' in ex ? ex['default'] : ex;
	}
	
	var prosemirrorCommands = __webpack_require__(182);
	var keymap = _interopDefault(__webpack_require__(34));
	var index_js = __webpack_require__(22);
	var index_js$1 = __webpack_require__(29);
	var prosemirrorTransform = __webpack_require__(25);
	var prosemirrorModel = __webpack_require__(12);
	var prosemirrorState = __webpack_require__(6);
	var index_ts = __webpack_require__(96);
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    (0, _defineProperty3.default)(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	var defineProperty = _defineProperty;
	
	function _objectSpread(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? arguments[i] : {};
	    var ownKeys = (0, _keys2.default)(source);
	
	    if (typeof _getOwnPropertySymbols2.default === 'function') {
	      ownKeys = ownKeys.concat((0, _getOwnPropertySymbols2.default)(source).filter(function (sym) {
	        return (0, _getOwnPropertyDescriptor2.default)(source, sym).enumerable;
	      }));
	    }
	
	    ownKeys.forEach(function (key) {
	      defineProperty(target, key, source[key]);
	    });
	  }
	
	  return target;
	}
	
	var objectSpread = _objectSpread;
	
	function markApplies(doc, ranges, type) {
	  var _loop = function _loop(i) {
	    var _ranges$i = ranges[i],
	        $from = _ranges$i.$from,
	        $to = _ranges$i.$to;
	
	    var can = $from.depth === 0 ? doc.type.allowsMarkType(type) : false;
	    doc.nodesBetween($from.pos, $to.pos, function (node) {
	      if (node.inlineContent && node.type.allowsMarkType(type)) can = true;
	      return !can;
	    });
	    if (can) return {
	        v: true
	      };
	  };
	
	  for (var i = 0; i < ranges.length; i++) {
	    var _ret = _loop(i);
	
	    if ((typeof _ret === 'undefined' ? 'undefined' : (0, _typeof3.default)(_ret)) === "object") return _ret.v;
	  }
	
	  return false;
	}
	
	function setTextBlockType(nodeType, attrs) {
	  return function (state, dispatch, view) {
	    var tr = state.tr,
	        selection = state.selection,
	        schema = state.schema;
	    var _schema$nodes = schema.nodes,
	        paragraph = _schema$nodes.paragraph,
	        heading = _schema$nodes.heading,
	        list_item = _schema$nodes.list_item,
	        task_item = _schema$nodes.task_item,
	        text = _schema$nodes.text;
	    var font = schema.marks.font;
	
	    var transaction = void 0;
	
	    selection.ranges.forEach(function (range) {
	      var from = range.$from.pos;
	      var to = range.$to.pos;
	      tr.doc.nodesBetween(from, to, function (node, pos, parent) {
	        if (node.type === text) {
	          tr.removeMark(pos, pos + node.text.length, font);
	        }
	
	        if (node.type === paragraph || node.type === heading) {
	          transaction = tr.setNodeMarkup(pos, nodeType, objectSpread({}, node.attrs, attrs));
	
	          if ((parent.type === list_item || parent.type === task_item) && tr.doc.nodeAt(pos - 1)) {
	            transaction = tr.setNodeMarkup(pos - 1, null, objectSpread({}, parent.attrs, {
	              level: attrs && attrs.level
	            }));
	          }
	        }
	      });
	    });
	    if (!transaction) return false;
	    dispatch(transaction.scrollIntoView());
	    view.focus();
	    return true;
	  };
	}
	function setIndent(type) {
	  return function (state, dispatch, view) {
	    var attrsGetter = function attrsGetter(attrs) {
	      return objectSpread({}, attrs, {
	        indent: attrs.indent + (type === 'more' ? 1 : -1)
	      });
	    };
	
	    try {
	      var selection = state.selection,
	          tr = state.tr,
	          schema = state.schema;
	      var _schema$nodes2 = schema.nodes,
	          table = _schema$nodes2.table,
	          list_item = _schema$nodes2.list_item,
	          task_item = _schema$nodes2.task_item;
	
	      var itemTypes = [list_item, task_item];
	      var transaction = void 0;
	
	      selection.ranges.forEach(function (range) {
	        var from = range.$from.pos;
	        var to = range.$to.pos;
	        var blockStart = 0;
	        var blockEnd = 0;
	        tr.doc.nodesBetween(from, to, function (node, pos) {
	          if (pos > blockStart && pos < blockEnd) return;
	
	          if (itemTypes.includes(node.type)) {
	            if (pos < from || pos > to) return;
	            blockStart = pos;
	            blockEnd = pos + node.nodeSize;
	          }
	
	          if (node.type === table) {
	            return false;
	          }
	
	          var attrs = node.attrs;
	
	          if (attrs.indent !== undefined && (type !== 'less' || attrs.indent > 0)) {
	            var newAttrs = attrsGetter(attrs);
	            transaction = tr.setNodeMarkup(pos, null, newAttrs);
	          }
	        });
	      });
	      if (!transaction) return false;
	
	      if (dispatch) {
	        dispatch(transaction);
	        view.focus();
	      }
	
	      return true;
	    } catch (error) {
	      console.error(error);
	      return false;
	    }
	  };
	}
	
	function setAlign(align) {
	  return function (state, dispatch, view) {
	    var selection = state.selection,
	        tr = state.tr;
	
	    var transaction = void 0;
	
	    selection.ranges.forEach(function (range) {
	      var from = range.$from.pos;
	      var to = range.$to.pos;
	      tr.doc.nodesBetween(from, to, function (node, pos) {
	        if (!node.type.spec.alignBlock) return;
	
	        var newAttrs = objectSpread({}, node.attrs, {
	          align: align
	        });
	
	        try {
	          transaction = tr.setNodeMarkup(pos, null, newAttrs);
	        } catch (e) {}
	      });
	    });
	
	    if (selection instanceof index_js$1.GapCursor) {
	      var $from = selection.$from,
	          dom = selection.dom;
	      var nodeBefore = $from.nodeBefore,
	          nodeAfter = $from.nodeAfter,
	          pos = $from.pos;
	
	      if (!dom) return false;
	      var domPos = void 0;
	
	      try {
	        domPos = view.docView.posFromDOM(dom);
	      } catch (error) {
	        return false;
	      }
	
	      if (nodeAfter && nodeAfter.type.spec.alignBlock && nodeAfter.type.isAtom && domPos === pos) {
	        var newAttrs = objectSpread({}, nodeAfter.attrs, {
	          align: align
	        });
	
	        transaction = tr.setNodeMarkup(pos, null, newAttrs);
	      }
	
	      if (nodeBefore && nodeBefore.type.spec.alignBlock && nodeBefore.type.isAtom && domPos < pos) {
	        var _newAttrs = objectSpread({}, nodeBefore.attrs, {
	          align: align
	        });
	
	        transaction = tr.setNodeMarkup(pos - 1, null, _newAttrs);
	      }
	    }
	
	    if (!transaction) return false;
	
	    if (dispatch) {
	      dispatch(transaction);
	      view.focus();
	    }
	
	    return true;
	  };
	}
	
	function toggleMark(markType, attrs) {
	  return function (state, dispatch, view) {
	    var tr = state.tr,
	        selection = state.selection,
	        schema = state.schema;
	    var empty = selection.empty,
	        $cursor = selection.$cursor,
	        ranges = selection.ranges;
	
	
	    if (empty && !$cursor || !markApplies(state.doc, ranges, markType)) {
	      view.focus();
	      return false;
	    }
	
	    if (selection instanceof prosemirrorState.NodeSelection) {
	      return false;
	    }
	
	    if (dispatch) {
	      if ($cursor) {
	        if (markType.isInSet(state.storedMarks || $cursor.marks())) {
	          dispatch(state.tr.removeStoredMark(markType));
	        } else {
	          dispatch(tr.addStoredMark(markType.create(attrs)));
	        }
	      } else {
	        var has = false;
	
	        for (var i = 0; !has && i < ranges.length; i++) {
	          var _ranges$i2 = ranges[i],
	              $from = _ranges$i2.$from,
	              $to = _ranges$i2.$to;
	
	          has = state.doc.rangeHasMark($from.pos, $to.pos, markType);
	        }
	
	        var isCellSelection = selection.constructor.name === 'CellSelection';
	        var prePos = null;
	        var insertTextCount = 0;
	
	        for (var _i = 0; _i < ranges.length; _i++) {
	          var _ranges$_i = ranges[_i],
	              _$from = _ranges$_i.$from,
	              _$to = _ranges$_i.$to;
	
	          var from = _$from.pos;
	          var to = _$to.pos;
	
	          if (has) {
	            tr.removeMark(from, to, markType);
	          } else if (isCellSelection && _$from.parent.nodeSize === 4) {
	            if (from > prePos && prePos !== null) insertTextCount++;
	            prePos = from;
	            tr.insert(from + insertTextCount + 1, schema.text('\u200B', [markType.create(attrs)]));
	          } else {
	            tr.addMark(from + insertTextCount, to + insertTextCount, markType.create(attrs));
	          }
	        }
	
	        dispatch(tr);
	      }
	    }
	
	    view.focus();
	    return true;
	  };
	}
	
	function toggleSuMark(markType) {
	  return function (state, dispatch, view) {
	    var tr = state.tr,
	        selection = state.selection,
	        schema = state.schema;
	    var empty = selection.empty,
	        $cursor = selection.$cursor,
	        ranges = selection.ranges;
	    var _schema$marks = schema.marks,
	        sub = _schema$marks.sub,
	        sup = _schema$marks.sup;
	
	    if (empty && !$cursor || !markApplies(state.doc, ranges, markType)) return false;
	
	    if (dispatch) {
	      if ($cursor) {
	        if (markType.isInSet(state.storedMarks || $cursor.marks())) {
	          dispatch(tr.removeStoredMark(markType));
	        } else {
	          var transaction = tr;
	
	          if (sub.isInSet(state.storedMarks || $cursor.marks())) {
	            transaction = transaction.removeStoredMark(sub);
	          }
	
	          if (sup.isInSet(state.storedMarks || $cursor.marks())) {
	            transaction = transaction.removeStoredMark(sup);
	          }
	
	          dispatch(transaction.addStoredMark(markType.create()));
	        }
	      } else {
	        var _transaction = tr;
	
	        var removeSubMark = function removeSubMark(subType) {
	          var has = false;
	
	          for (var i = 0; !has && i < ranges.length; i++) {
	            var _ranges$i3 = ranges[i],
	                $from = _ranges$i3.$from,
	                $to = _ranges$i3.$to;
	
	            has = state.doc.rangeHasMark($from.pos, $to.pos, subType);
	          }
	
	          for (var _i2 = 0; _i2 < ranges.length; _i2++) {
	            var _ranges$_i2 = ranges[_i2],
	                _$from2 = _ranges$_i2.$from,
	                _$to2 = _ranges$_i2.$to;
	
	
	            if (has) {
	              _transaction = _transaction.removeMark(_$from2.pos, _$to2.pos, subType);
	            }
	          }
	
	          return has;
	        };
	
	        var hasSub = removeSubMark(sub);
	        var hasSup = removeSubMark(sup);
	
	        if (!(markType === sub && hasSub || markType === sup && hasSup)) {
	          for (var i = 0; i < ranges.length; i++) {
	            var _ranges$i4 = ranges[i],
	                $from = _ranges$i4.$from,
	                $to = _ranges$i4.$to;
	
	            _transaction = _transaction.addMark($from.pos, $to.pos, markType.create());
	          }
	        }
	
	        dispatch(_transaction);
	        view.focus();
	      }
	    }
	
	    return true;
	  };
	}
	function insertHr() {
	  return function (state, dispatch, view) {
	    var node = state.schema.nodes.horizontal_rule.create();
	
	    var _index_js$insertBlock = index_js.insertBlock(state, node),
	        transaction = _index_js$insertBlock.transaction;
	
	    if (!transaction) return false;
	    dispatch(transaction.scrollIntoView());
	    view.focus();
	    return true;
	  };
	}
	
	function clearFormat() {
	  return function clearCommand(state, dispatch, view) {
	    var selection = state.selection,
	        schema = state.schema,
	        tr = state.tr;
	    var $cursor = selection.$cursor;
	    var _schema$nodes3 = schema.nodes,
	        paragraph = _schema$nodes3.paragraph,
	        heading = _schema$nodes3.heading,
	        list_item = _schema$nodes3.list_item,
	        task_item = _schema$nodes3.task_item;
	
	
	    if ($cursor) {
	      var cursor = $cursor.pos;
	      var beforeNode = $cursor.nodeBefore;
	      var afterNode = $cursor.nodeAfter;
	
	      if (beforeNode) {
	        (0, _keys2.default)(schema.marks).forEach(function (mark) {
	          tr.removeMark(cursor - beforeNode.nodeSize, cursor, mark.type);
	        });
	      }
	
	      if (afterNode) {
	        (0, _keys2.default)(schema.marks).forEach(function (mark) {
	          tr.removeMark(cursor, cursor + afterNode.nodeSize, mark.type);
	        });
	      }
	    }
	
	    selection.ranges.forEach(function (range) {
	      var from = range.$from.pos;
	      var to = range.$to.pos;
	      tr.doc.nodesBetween(from, to, function (node, pos, parent) {
	        if (node.type === heading) {
	          tr.setNodeMarkup(pos, paragraph, node.attrs);
	
	          if ((parent.type === list_item || parent.type === task_item) && tr.doc.nodeAt(pos - 1)) {
	            tr.setNodeMarkup(pos - 1, null, objectSpread({}, parent.attrs, {
	              level: null
	            }));
	          }
	        }
	      });
	      tr.setBlockType(from, to, schema.nodes.paragraph);
	      (0, _keys2.default)(schema.marks).forEach(function (mark) {
	        tr.removeMark(from, to, mark.type);
	      });
	    });
	    dispatch(tr);
	    view.focus();
	    return true;
	  };
	}
	
	function setTextColor(color) {
	  return function (state, dispatch, view) {
	    var colorType = state.schema.marks.color;
	    var attrs = {
	      color: color
	    };
	    var _state$selection = state.selection,
	        empty = _state$selection.empty,
	        $cursor = _state$selection.$cursor,
	        ranges = _state$selection.ranges;
	
	
	    if (empty && !$cursor || !markApplies(state.doc, ranges, colorType)) {
	      return false;
	    }
	
	    if ($cursor) {
	      dispatch(state.tr.addStoredMark(colorType.create(attrs)));
	    } else {
	      var has = false;
	      var tr = state.tr;
	
	
	      for (var i = 0; !has && i < ranges.length; i++) {
	        var _ranges$i5 = ranges[i],
	            $from = _ranges$i5.$from,
	            $to = _ranges$i5.$to;
	
	        has = state.doc.rangeHasMark($from.pos, $to.pos, colorType);
	      }
	
	      for (var _i3 = 0; _i3 < ranges.length; _i3++) {
	        var _ranges$_i3 = ranges[_i3],
	            _$from3 = _ranges$_i3.$from,
	            _$to3 = _ranges$_i3.$to;
	
	
	        if (has) tr.removeMark(_$from3.pos, _$to3.pos, colorType);
	        tr.addMark(_$from3.pos, _$to3.pos, colorType.create(attrs));
	      }
	
	      dispatch(tr);
	      view.focus();
	    }
	
	    return true;
	  };
	}
	
	function setFontsize(size) {
	  return function (state, dispatch, view) {
	    var fontType = state.schema.marks.font;
	    var attrs = {
	      dataSize: size
	    };
	    var _state$selection2 = state.selection,
	        empty = _state$selection2.empty,
	        $cursor = _state$selection2.$cursor,
	        ranges = _state$selection2.ranges;
	
	
	    if (empty && !$cursor || !markApplies(state.doc, ranges, fontType)) {
	      return false;
	    }
	
	    if ($cursor) {
	      dispatch(state.tr.addStoredMark(fontType.create(attrs)));
	    } else {
	      var has = false;
	      var tr = state.tr;
	
	
	      for (var i = 0; !has && i < ranges.length; i++) {
	        var _ranges$i6 = ranges[i],
	            $from = _ranges$i6.$from,
	            $to = _ranges$i6.$to;
	
	        has = state.doc.rangeHasMark($from.pos, $to.pos, fontType);
	      }
	
	      for (var _i4 = 0; _i4 < ranges.length; _i4++) {
	        var _ranges$_i4 = ranges[_i4],
	            _$from4 = _ranges$_i4.$from,
	            _$to4 = _ranges$_i4.$to;
	
	
	        if (has) tr.removeMark(_$from4.pos, _$to4.pos, fontType);
	        tr.addMark(_$from4.pos, _$to4.pos, fontType.create(attrs));
	      }
	
	      dispatch(tr);
	    }
	
	    return true;
	  };
	}
	
	function setTextDefaultColor() {
	  return function (state, dispatch, view) {
	    var colorType = state.schema.marks.color;
	    var _state$selection3 = state.selection,
	        empty = _state$selection3.empty,
	        $cursor = _state$selection3.$cursor,
	        ranges = _state$selection3.ranges;
	
	
	    if (empty && !$cursor || !markApplies(state.doc, ranges, colorType)) {
	      return false;
	    }
	
	    if ($cursor) {
	      dispatch(state.tr.removeStoredMark(colorType));
	    } else {
	      var tr = state.tr;
	
	
	      for (var i = 0; i < ranges.length; i++) {
	        var _ranges$i7 = ranges[i],
	            $from = _ranges$i7.$from,
	            $to = _ranges$i7.$to;
	
	        tr.removeMark($from.pos, $to.pos, colorType);
	      }
	
	      dispatch(tr.scrollIntoView());
	    }
	
	    view.focus();
	    return true;
	  };
	}
	
	function splitBlock(state, dispatch) {
	  var selection = state.selection,
	      schema = state.schema;
	  var $from = selection.$from,
	      $to = selection.$to,
	      from = selection.from;
	
	
	  if (selection instanceof prosemirrorState.NodeSelection && selection.node.isBlock) {
	    if (!$from.parentOffset || !prosemirrorTransform.canSplit(state.doc, $from.pos)) return false;
	    if (dispatch) dispatch(state.tr.split($from.pos).scrollIntoView());
	    return true;
	  }
	
	  if (dispatch) {
	    var atStart = $to.parentOffset === 0;
	    var atEnd = $to.parentOffset === $to.parent.content.size;
	    var tr = state.tr;
	    if (selection instanceof prosemirrorState.TextSelection) tr.deleteSelection();
	    var parentNode = $from.node(-1);
	    var deflt = $from.depth === 0 ? null : parentNode.defaultContentType($from.indexAfter(-1));
	    var splitDepth = 1;
	
	    if (atStart && ['blockquote', 'note_content', 'collapse_content', 'doc', 'table_cell', 'table_header'].includes(parentNode.type.name)) {
	      var nodeType = parentNode.type;
	
	      if (['table_cell', 'table_header', 'blockquote'].includes(parentNode.type.name)) {
	        nodeType = schema.nodes.doc;
	      }
	
	      tr.insert(from, nodeType.createAndFill());
	      tr.deleteRange(from, from + 2);
	      dispatch(tr.scrollIntoView());
	      return true;
	    }
	
	    if (atEnd && ['blockquote', 'note_content', 'collapse_content', 'doc', 'table_cell', 'table_header'].includes(parentNode.type.name)) {
	      var _nodeType = parentNode.type;
	
	      if (['table_cell', 'table_header', 'blockquote'].includes(parentNode.type.name)) {
	        _nodeType = schema.nodes.doc;
	      }
	
	      tr.insert(from, _nodeType.createAndFill());
	      tr.deleteRange(from + 4, from + 5);
	      tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, from + 2));
	      dispatch(tr.scrollIntoView());
	      return true;
	    }
	
	    if (deflt === schema.nodes.text) {
	      if (!$from.nodeBefore || !$to.nodeAfter) {
	        tr.insert(from, parentNode.type.createAndFill());
	        tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, from + 2));
	        tr.delete(from + 2, from + 4);
	        dispatch(tr.scrollIntoView());
	        return true;
	      }
	
	      splitDepth = 2;
	    }
	
	    var types = atEnd ? [{
	      type: deflt,
	      attrs: getAttrs(state)
	    }] : null;
	    var _can = prosemirrorTransform.canSplit(tr.doc, $from.pos, 1, types);
	
	    if (!types && !_can && prosemirrorTransform.canSplit(tr.doc, tr.mapping.map($from.pos), splitDepth, deflt && [{
	      type: deflt
	    }])) {
	      types = [{
	        type: deflt
	      }];
	      _can = true;
	    }
	
	    if (_can) {
	      tr.split(tr.mapping.map($from.pos), splitDepth, types || [{
	        type: deflt,
	        attrs: {
	          dataDiffId: 'ct-diff-id-' + uuid()
	        }
	      }]);
	
	      if (!atEnd && !$from.parentOffset && $from.parent.type !== deflt && $from.node(-1).canReplace($from.index(-1), $from.indexAfter(-1), prosemirrorModel.Fragment.from(deflt.create(), $from.parent))) {
	        tr.setNodeMarkup(tr.mapping.map($from.before()), deflt);
	      }
	    }
	
	    dispatch(tr.scrollIntoView());
	  }
	
	  return true;
	}
	
	function splitBlockKeepMarks(state, dispatch) {
	  return splitBlock(state, dispatch && function (tr) {
	    var marks = state.storedMarks || state.selection.$to.parentOffset && state.selection.$from.marks();
	    if (marks) tr.ensureMarks(marks);
	    dispatch(tr);
	  });
	}
	
	function createParagraphNear(state, dispatch) {
	  var selection = state.selection;
	  var $from = selection.$from,
	      $to = selection.$to;
	
	
	  if ($from.parent.inlineContent || $to.parent.inlineContent) {
	    return false;
	  }
	
	  var type = $from.parent.defaultContentType($to.indexAfter());
	
	  if (!type || !type.isTextblock) {
	    return false;
	  }
	
	  if (dispatch) {
	    var isGapCursor = selection instanceof index_js$1.GapCursor;
	    var gapCursor = isGapCursor ? index_js$1.getGapCursor() : {};
	    var side = (!$from.parentOffset && $to.index() < $to.parent.childCount ? $from : $to).pos;
	    var tr = state.tr.insert(side, type.createAndFill());
	    var pos = side + (isGapCursor && gapCursor.dir === 'after' ? 2 : 1);
	    tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, pos));
	    dispatch(tr);
	  }
	
	  return true;
	}
	
	var setTitleFontSize = function setTitleFontSize(level) {
	  var type = void 0;
	
	  switch (level) {
	    case 1:
	      type = 28;
	      break;
	
	    case 2:
	      type = 24;
	      break;
	
	    case 3:
	      type = 20;
	      break;
	
	    case 4:
	      type = 16;
	      break;
	
	    case 5:
	      type = 14;
	      break;
	
	    case 6:
	      type = 12;
	      break;
	
	    default:
	      type = 14;
	  }
	
	  return type;
	};
	
	function isTextBlock(state) {
	  var selection = state.selection,
	      tr = state.tr;
	
	  var is = true;
	
	  selection.ranges.forEach(function (range) {
	    var from = range.$from.pos;
	    var to = range.$to.pos;
	    tr.doc.nodesBetween(from, to, function (node) {
	      var type = node.type;
	      if (type.isLeaf && type.name !== 'hard_break' && type.name !== 'text' && type.name !== 'image' && type.name !== 'drawio' && !type.isTextblock) is = false;
	      return is;
	    });
	  });
	  return is;
	}
	function isWeirdBlock(state) {
	  var selection = state.selection,
	      tr = state.tr;
	
	  var is = false;
	
	  selection.ranges.forEach(function (range) {
	    var from = range.$from.pos;
	    var to = range.$to.pos;
	    tr.doc.nodesBetween(from, to, function (node) {
	      if (node.attrs.weird) is = true;
	      return !is;
	    });
	  });
	  return is;
	}
	
	function getAttrs(state) {
	  if (!state.selection.empty) return {};
	  var _state$selection4 = state.selection,
	      from = _state$selection4.from,
	      to = _state$selection4.to;
	
	  var result = {};
	  state.tr.doc.nodesBetween(from, to, function (node) {
	    result = node.attrs;
	  });
	  delete result.dataDiffId;
	  return result;
	}
	
	function getTextBlockType(state) {
	  var selection = state.selection,
	      tr = state.tr,
	      schema = state.schema;
	  var _schema$nodes4 = schema.nodes,
	      paragraph = _schema$nodes4.paragraph,
	      heading = _schema$nodes4.heading,
	      status = _schema$nodes4.status,
	      font = _schema$nodes4.font;
	
	  var type = null;
	
	  if (status) {
	    var isInStatus = selection.node && selection.node.type === status || index_js.findParentNode(selection.$from.path, function (node) {
	      return node.type === status;
	    });
	    if (isInStatus) return type;
	  }
	
	  selection.ranges.forEach(function (range) {
	    var from = range.$from.pos;
	    var to = range.$to.pos;
	    tr.doc.nodesBetween(from, to, function (node) {
	      if (type !== null) return false;
	      if (node.type === paragraph) type = '正文';else if (node.type === heading) {
	        var level = node.attrs.level;
	
	        type = ['😜', '一', '二', '三', '四', '五', '六'][level] + '\u7EA7\u6807\u9898';
	      }
	    });
	  });
	  return type;
	}
	function getTextFontsize(state) {
	  var selection = state.selection,
	      tr = state.tr,
	      schema = state.schema;
	  var _schema$nodes5 = schema.nodes,
	      paragraph = _schema$nodes5.paragraph,
	      heading = _schema$nodes5.heading,
	      collapse = _schema$nodes5.collapse,
	      table = _schema$nodes5.table,
	      text = _schema$nodes5.text,
	      collapse_content = _schema$nodes5.collapse_content,
	      table_row = _schema$nodes5.table_row,
	      table_header = _schema$nodes5.table_header,
	      table_cell = _schema$nodes5.table_cell,
	      hard_break = _schema$nodes5.hard_break;
	  var font = schema.marks.font;
	
	  var type = ' - ';
	  var availableType = [paragraph, heading, collapse, collapse_content, table, table_header, table_cell, table_row, text, hard_break];
	  var nodeList = [];
	
	  var findFontMark = function findFontMark(m) {
	    return m.type === font && m.attrs.dataSize;
	  };
	
	  selection.ranges.forEach(function (range) {
	    var from = range.$from.pos;
	    var to = range.$to.pos;
	
	    if (from !== to) {
	      tr.doc.nodesBetween(from, to, function (node, pos, parent) {
	        if (availableType.indexOf(node.type) === -1) return false;
	        if (node.type === text || node.type === heading) nodeList.push(node);
	        if (node.type === heading) return false;
	      });
	    } else {
	      type = 14;
	
	      if (range.$to.nodeAfter !== null && range.$to.nodeBefore !== null) {
	        if (range.$to.parent && range.$to.parent.type === heading) {
	          type = setTitleFontSize(range.$to.parent.attrs.level);
	        } else {
	          var fontMark = range.$to.nodeBefore.marks.filter(findFontMark);
	          if (fontMark.length > 0) type = fontMark[0].attrs.dataSize;
	        }
	      } else {
	        if (range.$to.nodeAfter === null && range.$to.nodeBefore === null) {
	          var hasFont = hasMark(state, font);
	
	          if (hasFont) {
	            type = hasFont.attrs.dataSize;
	            return;
	          }
	        }
	
	        var nodePosition = 'nodeBefore';
	        if (range.$to.nodeBefore === null) nodePosition = 'nodeAfter';
	
	        if (range.$to.parent && range.$to.parent.type === heading) {
	          type = setTitleFontSize(range.$to.parent.attrs.level);
	        } else {
	          var calculateNode = range.$to[nodePosition];
	          if (!calculateNode) return;
	          var _fontMark = calculateNode.marks.filter(findFontMark);
	          if (_fontMark.length > 0) type = _fontMark[0].attrs.dataSize;
	        }
	      }
	
	      if (range.$to.nodeAfter === null && range.$to.nodeBefore && range.$to.nodeBefore.type === text) {
	        var fm = range.$to.nodeBefore.marks.filter(findFontMark);
	        if (fm.length > 0) type = fm[0].attrs.dataSize;
	      }
	    }
	  });
	
	
	  if (nodeList.length === 1) {
	    if (nodeList[0].type === heading) {
	      var level = nodeList[0].attrs.level;
	
	      type = setTitleFontSize(level);
	    } else {
	      var fontMark = nodeList[0].marks.filter(findFontMark);
	
	      if (fontMark.length > 0) {
	        type = fontMark[0].attrs.dataSize;
	      } else {
	        type = 14;
	      }
	    }
	  } else if (nodeList.length !== 0) {
	    var hasDiffType = false;
	    nodeList.reduce(function (acc, current) {
	      if (acc.type !== current.type) hasDiffType = true;
	      return current;
	    });
	
	    if (!hasDiffType) {
	      if (nodeList[0].type === heading) {
	        var uniqueLevels = new _set2.default();
	        nodeList.forEach(function (n) {
	          return uniqueLevels.add(n.attrs.level);
	        });
	
	        if (uniqueLevels.length === 1) {
	          type = setTitleFontSize(uniqueLevels[0]);
	        }
	      } else {
	        var fontMarks = [];
	        nodeList.forEach(function (n) {
	          var fm = n.marks.filter(findFontMark);
	          if (fm.length > 0) fontMarks.push(fm[0]);
	        });
	
	        if (fontMarks.length === 0) {
	          type = 14;
	        } else if (fontMarks.length === nodeList.length) {
	          var size = new _set2.default();
	          fontMarks.forEach(function (fm) {
	            return size.add(fm.attrs.dataSize);
	          });
	          if (size.size === 1) type = size.values().next().value;
	        }
	      }
	    }
	  }
	
	  return type;
	}
	function canSetFontsize(state) {
	  var selection = state.selection,
	      tr = state.tr,
	      schema = state.schema;
	  var _schema$nodes6 = schema.nodes,
	      paragraph = _schema$nodes6.paragraph,
	      table = _schema$nodes6.table,
	      table_cell = _schema$nodes6.table_cell,
	      table_header = _schema$nodes6.table_header,
	      table_row = _schema$nodes6.table_row,
	      collapse = _schema$nodes6.collapse,
	      collapse_content = _schema$nodes6.collapse_content,
	      text = _schema$nodes6.text,
	      hard_break = _schema$nodes6.hard_break;
	
	  var bool = true;
	
	  selection.ranges.forEach(function (range) {
	    var from = range.$from.pos;
	    var to = range.$to.pos;
	    tr.doc.nodesBetween(from, to, function (node) {
	      if (node.type !== paragraph && node.type !== table && node.type !== table_cell && node.type !== table_header && node.type !== table_row && node.type !== collapse && node.type !== collapse_content && node.type !== hard_break && node.type !== text) bool = false;
	    });
	  });
	  return bool;
	}
	function isInParagraph(state) {
	  var selection = state.selection,
	      tr = state.tr,
	      schema = state.schema;
	  var paragraph = schema.nodes.paragraph;
	
	  var bool = false;
	
	  selection.ranges.forEach(function (range) {
	    var from = range.$from.pos;
	    var to = range.$to.pos;
	
	    if (from === to) {
	      tr.doc.nodesBetween(from, to, function (node) {
	        if (node.type !== paragraph) bool = true;
	      });
	    }
	  });
	  return bool;
	}
	function isInHeading(state) {
	  var selection = state.selection,
	      tr = state.tr,
	      schema = state.schema;
	  var heading = schema.nodes.heading;
	
	  var topLevelNodeList = [];
	  selection.ranges.forEach(function (range) {
	    var from = range.$from.pos;
	    var to = range.$to.pos;
	    tr.doc.nodesBetween(from, to, function (node) {
	      topLevelNodeList.push(node);
	      return false;
	    });
	  });
	  var $from = selection.$from;
	
	  var isHeading = index_js.findParentNode($from.path, function (item) {
	    return item.type && item.type.name === "heading";
	  });
	  return !!isHeading || topLevelNodeList.some(function (p) {
	    return p.type === heading;
	  });
	}
	
	function hasMark(state, type) {
	  var selection = state.selection,
	      doc = state.doc,
	      schema = state.schema;
	  var from = selection.from,
	      to = selection.to,
	      $from = selection.$from,
	      empty = selection.empty,
	      $cursor = selection.$cursor;
	
	
	  if ($cursor && schema.marks.strong === type && schema.nodes.table_header) {
	    var path = $cursor.path;
	    var headerType = schema.nodes.table_header;
	    var isInTableHeader = path.some(function (p) {
	      return p.type === headerType;
	    });
	    if (isInTableHeader) return true;
	  }
	
	  if (empty) {
	    return type.isInSet(state.storedMarks || $from.marks());
	  }
	
	  if (selection.constructor.name === 'CellSelection') {
	    var ranges = selection.ranges;
	    return ranges.every(function (range) {
	      var $to = range.$to;
	
	      return doc.rangeHasMark($from.pos, $to.pos, type);
	    });
	  }
	
	  return doc.rangeHasMark(from, to, type);
	}
	
	function isAlignedBlock(state, view, align) {
	  var selection = state.selection;
	  var ranges = selection.ranges,
	      $anchor = selection.$anchor,
	      node = selection.node;
	
	
	  if (selection.constructor.name === 'CellSelection') {
	    return ranges.every(function (range) {
	      var $from = range.$from;
	
	      var node = $from.node().firstChild;
	      if (!node) return false;
	      var attrs = node.attrs;
	      if (attrs.align === '' && align === 'left') return true;
	      if (!attrs.align) return false;
	      return attrs.align === align;
	    });
	  }
	
	  if (selection instanceof index_js$1.GapCursor) {
	    var $from = selection.$from,
	        dom = selection.dom;
	    var nodeBefore = $from.nodeBefore,
	        nodeAfter = $from.nodeAfter,
	        pos = $from.pos;
	
	    if (!dom) return false;
	    var domPos = void 0;
	
	    try {
	      domPos = view.docView.posFromDOM(dom);
	    } catch (error) {
	      return false;
	    }
	
	    if (nodeBefore && nodeBefore.type.spec.alignBlock && nodeBefore.type.isAtom && domPos < pos) {
	      var _attrs = nodeBefore.attrs;
	      if (_attrs.align === '' && align === 'left') return true;
	      if (!_attrs.align) return false;
	      return _attrs.align === align;
	    }
	
	    if (nodeAfter && nodeAfter.type.spec.alignBlock && nodeAfter.type.isAtom && domPos === pos) {
	      var _attrs2 = nodeAfter.attrs;
	      if (_attrs2.align === '' && align === 'left') return true;
	      if (!_attrs2.align) return false;
	      return _attrs2.align === align;
	    }
	  }
	
	  var alignNode = node || $anchor.parent;
	  var attrs = alignNode.attrs;
	  if (attrs.align === '' && align === 'left') return true;
	  if (!attrs.align) return false;
	  return attrs.align === align;
	}
	function canAlign(state, view) {
	  return setAlign('left')(state, undefined, view);
	}
	
	function canIndent(state, direction) {
	  return setIndent(direction)(state);
	}
	
	function getHeadingAttrs(node) {
	  var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	  var align = node.style.textAlign;
	  var indent = parseInt(node.style.marginLeft, 10) / 20 || 0;
	  var dataDiffId = node.getAttribute('data-diff-id');
	  var attrs = {
	    id: uuid(),
	
	    indent: indent,
	
	    align: align === 'justify' ? 'left' : align,
	    dataDiffId: dataDiffId || 'ct-diff-id-' + uuid() };
	  return level === null ? attrs : objectSpread({
	    level: level
	  }, attrs);
	}
	
	function uuid() {
	  var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
	  var id = [];
	
	  for (var i = 0; i < 8; i++) {
	    id.push(chars[parseInt(Math.random() * chars.length, 10)]);
	  }
	
	  return id.join('');
	}
	
	var nodes = {
	  doc: {
	    content: 'block+'
	  },
	
	  text: {
	    group: 'inline'
	  },
	
	  paragraph: {
	    attrs: {
	      indent: {
	        default: 0
	      },
	      align: {
	        default: 'left'
	      },
	      dataDiffId: {
	        default: null
	      }
	    },
	    content: 'inline*',
	    group: 'block',
	    textContentBlock: true,
	    alignBlock: true,
	    parseDOM: [{
	      tag: 'p',
	      preserveWhitespace: 'full',
	      getAttrs: function getAttrs(dom) {
	        return getHeadingAttrs(dom);
	      }
	    }],
	
	    toDOM: function toDOM(node) {
	      var _node$attrs = node.attrs,
	          align = _node$attrs.align,
	          indent = _node$attrs.indent,
	          dataDiffId = _node$attrs.dataDiffId;
	
	      var attrs = {};
	      var style = '';
	
	      if (align && align !== 'left') {
	        style += 'text-align: ' + align + ';';
	      }
	
	      if (indent) {
	        style += 'margin-left: ' + Math.max(indent, 0) * 20 + 'px;';
	      }
	
	      if (style) {
	        attrs.style = style;
	      }
	
	      attrs['data-diff-id'] = dataDiffId || 'ct-diff-id-' + uuid();
	      return ['p', attrs, 0];
	    }
	  },
	
	  heading: {
	    attrs: {
	      id: {
	        default: ''
	      },
	      level: {
	        default: 1
	      },
	      indent: {
	        default: 0
	      },
	      align: {
	        default: 'left'
	      },
	      dataDiffId: {
	        default: null
	      }
	    },
	    content: 'inline*',
	    textContentBlock: true,
	    group: 'block',
	    defining: true,
	    alignBlock: true,
	    parseDOM: [1, 2, 3, 4, 5, 6].map(function (level) {
	      return {
	        tag: 'h' + level,
	        preserveWhitespace: 'full',
	        getAttrs: function getAttrs(dom) {
	          return getHeadingAttrs(dom, level);
	        }
	      };
	    }),
	
	    toDOM: function toDOM(node) {
	      var _node$attrs2 = node.attrs,
	          level = _node$attrs2.level,
	          align = _node$attrs2.align,
	          indent = _node$attrs2.indent,
	          id = _node$attrs2.id,
	          dataDiffId = _node$attrs2.dataDiffId;
	
	      var attrs = {
	        id: id ? id : uuid()
	      };
	      var style = '';
	
	      if (align && align !== 'left') {
	        style += 'text-align: ' + align + ';';
	      }
	
	      if (indent) {
	        style += 'margin-left: ' + Math.max(indent, 0) * 20 + 'px;';
	      }
	
	      if (style) {
	        attrs.style = style;
	      }
	
	      attrs.class = 'ct-heading';
	      attrs['data-diff-id'] = dataDiffId || 'ct-diff-id-' + uuid();
	      return ['h' + level, attrs, 0];
	    }
	  },
	
	  hard_break: {
	    inline: true,
	    group: 'inline',
	    selectable: false,
	    parseDOM: [{
	      tag: 'br'
	    }],
	
	    toDOM: function toDOM() {
	      return ['br'];
	    }
	  },
	
	  horizontal_rule: {
	    group: 'block',
	    allowGapCursor: true,
	    insertBlock: true,
	    attrs: {
	      dataDiffId: {
	        default: null
	      }
	    },
	    parseDOM: [{
	      tag: 'hr',
	      getAttrs: function getAttrs(dom) {
	        var dataDiffId = dom.getAttribute('data-diff-id');
	        return {
	          dataDiffId: dataDiffId
	        };
	      }
	    }],
	
	    toDOM: function toDOM(dom) {
	      var dataDiffId = dom.attrs.dataDiffId;
	
	      var attrs = {
	        'data-diff-id': dataDiffId || 'ct-diff-id-' + uuid()
	      };
	      return ['hr', attrs];
	    }
	  }
	};
	
	var calculateheigth = function calculateheigth(fontSize) {
	  var lineHeight = void 0;
	
	  switch (fontSize) {
	    case 12:
	    case 13:
	    case 14:
	    case 16:
	      lineHeight = 24;
	      break;
	
	    default:
	      lineHeight = parseInt(fontSize) + 8;
	      break;
	  }
	
	  return lineHeight;
	};
	
	var marks = {
	  em: {
	    parseDOM: [{
	      tag: 'i'
	    }, {
	      tag: 'em'
	    }, {
	      style: 'font-style=italic'
	    }],
	
	    toDOM: function toDOM() {
	      return ['em'];
	    }
	  },
	
	  strong: {
	    parseDOM: [{
	      tag: 'strong'
	    }, {
	      tag: 'b',
	      getAttrs: function getAttrs(node) {
	        return node.style.fontWeight !== 'normal' && null;
	      }
	    }, {
	      style: 'font-weight',
	      getAttrs: function getAttrs(value) {
	        return (/^(bold(er)?|[5-9]\d{2,})$/.test(value) && null
	        );
	      }
	    }],
	
	    toDOM: function toDOM() {
	      return ['strong'];
	    }
	  },
	  underline: {
	    parseDOM: [{
	      tag: 'u'
	    }, {
	      style: 'text-decoration=underline'
	    }],
	
	    toDOM: function toDOM() {
	      return ['u'];
	    }
	  },
	  strikethrough: {
	    parseDOM: [{
	      tag: 'del'
	    }, {
	      style: 'text-decoration=line-through'
	    }],
	
	    toDOM: function toDOM() {
	      return ['del'];
	    }
	  },
	  color: {
	    attrs: {
	      color: {
	        default: '#333'
	      }
	    },
	    parseDOM: [{
	      priority: 20,
	      tag: 'span[style*=color]',
	      getAttrs: function getAttrs(node) {
	        return {
	          color: node.style.color
	        };
	      }
	    }],
	
	    toDOM: function toDOM(node) {
	      return ['span', {
	        style: 'color: ' + node.attrs.color
	      }];
	    }
	  },
	  sup: {
	    parseDOM: [{
	      tag: 'sup'
	    }],
	
	    toDOM: function toDOM() {
	      return ['sup'];
	    }
	  },
	  sub: {
	    parseDOM: [{
	      tag: 'sub'
	    }],
	
	    toDOM: function toDOM() {
	      return ['sub'];
	    }
	  },
	  font: {
	    attrs: {
	      dataSize: {
	        default: 14
	      }
	    },
	    parseDOM: [{
	      tag: 'font',
	      getAttrs: function getAttrs(dom) {
	        var size = dom.getAttribute('data-size') || 14;
	        return {
	          dataSize: size
	        };
	      }
	    }],
	
	    toDOM: function toDOM(node) {
	      var lineHeight = calculateheigth(node.attrs.dataSize);
	      var style = {
	        style: 'font-size:' + node.attrs.dataSize + 'px;line-height:' + lineHeight + 'px',
	        'data-size': node.attrs.dataSize
	      };
	      return ['font', style];
	    }
	  }
	};
	
	function handleBackspace(state, dispatch, view) {
	  var tr = state.tr,
	      selection = state.selection,
	      schema = state.schema,
	      doc = state.doc;
	  var $from = selection.$from,
	      from = selection.from,
	      to = selection.to;
	  var $to = selection.$to,
	      $cursor = selection.$cursor;
	  var _schema$nodes7 = schema.nodes,
	      paragraph = _schema$nodes7.paragraph,
	      horizontal_rule = _schema$nodes7.horizontal_rule,
	      link = _schema$nodes7.link,
	      ordered_list = _schema$nodes7.ordered_list,
	      bullet_list = _schema$nodes7.bullet_list,
	      task_list = _schema$nodes7.task_list,
	      list_item = _schema$nodes7.list_item,
	      task_item = _schema$nodes7.task_item;
	
	  var listTypes = [ordered_list, bullet_list, task_list];
	  var itemTypes = [list_item, task_item];
	  var fromNode = $from.node();
	  var toNode = $to.node();
	
	  if (selection instanceof prosemirrorState.NodeSelection) {
	    dispatch(tr.deleteSelection().setSelection(prosemirrorState.TextSelection.create(tr.doc, from)));
	    view.focus();
	    return true;
	  }
	
	  var isGapCursor = false;
	
	  if (selection instanceof index_js$1.GapCursor) {
	    var res = index_js$1.GapCursor.findFrom($from);
	
	    if (res && res.dir === 'before') {
	      index_js$1.setLastAction('delete');
	
	      if (res.node.type.name === 'code_block') {
	        var newSelection = prosemirrorState.TextSelection.create(tr.doc, res.pos - res.node.nodeSize, res.pos);
	        dispatch(tr.setSelection(newSelection));
	      } else {
	        var _newSelection = prosemirrorState.NodeSelection.create(tr.doc, res.pos - res.node.nodeSize);
	        dispatch(tr.setSelection(_newSelection));
	      }
	
	      return true;
	    }
	
	    isGapCursor = true;
	    from = res.pos;
	    to = res.pos;
	    $from = doc.resolve(res.pos);
	    fromNode = res.node;
	  }
	
	  if ($from.parentOffset === 0 || isGapCursor) {
	    if ($cursor || isGapCursor) {
	      var fromNodeParent = isGapCursor ? $from.node() : $from.node(-1);
	      if (!fromNodeParent) return false;
	      var isDocHead = from === 1;
	
	      var preBlockNode = isDocHead ? false : index_js.getBlockNode(state, from - 3, from - 1);
	
	      if (preBlockNode && index_js.isChild(fromNode, preBlockNode)) preBlockNode = false;
	
	      if (preBlockNode) {
	        var _newSelection2 = prosemirrorState.TextSelection.create(tr.doc, from - 1);
	
	        if (fromNode.childCount === 0) {
	          tr.delete(from - 1, to + 1);
	        }
	
	        dispatch(tr.setSelection(_newSelection2));
	        return true;
	      }
	
	      if (fromNode.type === paragraph && fromNode.attrs.indent > 0) {
	        setIndent('less')(state, dispatch, view);
	        return true;
	      }
	
	      var parentContent = fromNodeParent.content.content;
	
	      if (fromNode.content.size === 0 && !itemTypes.includes(fromNodeParent.type) && parentContent[0] === $from.parent) {
	        var secondNode = parentContent[1];
	
	        if (secondNode && listTypes.includes(secondNode.type)) {
	          tr.replaceWith(from - 1, to + secondNode.nodeSize + 1, secondNode);
	          dispatch(tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, from + 1)));
	          return true;
	        }
	
	        if (parentContent.length !== 1 && parentContent[0] === fromNode) {
	          if (parentContent[0].type.name === "collapse_title" && parentContent[0].type.name === "note_title" && parentContent[0].attrs.align) {
	            return false;
	          }
	
	          tr.delete(from - 1, to + 1);
	          dispatch(tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, from - 1)));
	          return true;
	        }
	      }
	
	      if (isGapCursor && from > 1) {
	        if ($from.parentOffset !== 0) {
	          tr.delete(from - 1, to);
	          dispatch(tr.setSelection(prosemirrorState.TextSelection.create(doc, from - 1)));
	          return true;
	        } else {
	          tr.delete(from - 2, to);
	          dispatch(tr);
	          return true;
	        }
	      }
	    } else {
	      if ($from.nodeAfter && $from.nodeAfter.type === horizontal_rule) {
	        dispatch(tr.replaceWith(from + 1, to, paragraph.create()));
	      }
	
	      if (fromNode.type === link && fromNode === toNode && to - from === fromNode.content.size) {
	        dispatch(tr.delete(from, to + 1));
	      }
	    }
	  }
	
	  return false;
	}
	
	function handleDelete(state, dispatch) {
	  var tr = state.tr,
	      selection = state.selection,
	      doc = state.doc;
	  var $cursor = selection.$cursor,
	      $from = selection.$from,
	      to = selection.to;
	
	  var fromNode = $from.node();
	  var fromSize = fromNode.content.size;
	
	  if (selection instanceof index_js$1.GapCursor) {
	    index_js$1.setLastAction('delete');
	    var res = index_js$1.GapCursor.findFrom($from);
	    var resAfter = index_js$1.GapCursor.findFrom($from, 'after');
	
	    if (res && res.dir === 'after' || resAfter && resAfter.dir === 'after') {
	      if (res.node.type.name === 'code_block') {
	        var newSelection = prosemirrorState.TextSelection.create(tr.doc, res.pos, res.pos + res.node.nodeSize);
	        dispatch(tr.setSelection(newSelection));
	      } else {
	        dispatch(tr.setSelection(prosemirrorState.NodeSelection.create(doc, res.pos)));
	      }
	
	      return true;
	    }
	
	    var pos = res.pos;
	    var nodeAfter = doc.resolve(res.pos).nodeAfter;
	
	    if (pos < doc.content.size) {
	      if (!nodeAfter && pos < doc.content.size - 1) {
	        tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, pos + 2));
	      } else if (res.node.isBlock) {
	        tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, pos + 1));
	      } else if (nodeAfter) {
	        tr.delete(pos, pos + 1);
	      }
	    }
	
	    dispatch(tr);
	    return true;
	  }
	
	  if ($cursor && $from.parentOffset === fromSize) {
	    var fromNodeParent = $from.node(-1);
	    if (!fromNodeParent) return false;
	
	    var isDocTail = to === doc.content.size - 1;
	
	    var nextBlockNode = isDocTail ? false : index_js.getBlockNode(state, to + 1, to + 3);
	
	    if (nextBlockNode) {
	      var plus = fromNode.isBlock ? 1 : 2;
	
	      if (nextBlockNode.nodeSize === 1) {
	        dispatch(tr.delete(to + plus, to + plus + 1));
	      } else {
	        dispatch(tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, to + plus, to + plus + nextBlockNode.nodeSize + 1)));
	      }
	
	      return true;
	    }
	  }
	
	  return false;
	}
	
	function handleEnter(state, dispatch, view) {
	  var tr = state.tr,
	      selection = state.selection;
	
	
	  if (selection instanceof prosemirrorState.AllSelection) {
	    tr.deleteSelection();
	    dispatch(tr);
	    return true;
	  }
	
	  return prosemirrorCommands.chainCommands(prosemirrorCommands.newlineInCode, createParagraphNear, prosemirrorCommands.liftEmptyBlock, splitBlockKeepMarks)(state, dispatch, view);
	}
	
	function handleShiftEnter(state, dispatch, view) {
	  var tr = state.tr,
	      selection = state.selection,
	      schema = state.schema;
	  var $cursor = selection.$cursor,
	      $from = selection.$from;
	  var hard_break = schema.nodes.hard_break;
	
	  var $c = selection instanceof index_js$1.GapCursor ? $from : $cursor;
	
	  if ($c && $c.parent.type.spec.textContentBlock) {
	    tr.insert($c.pos, hard_break.createAndFill());
	    dispatch(tr);
	    return true;
	  }
	
	  return handleEnter(state, dispatch, view);
	}
	
	function outsideTableCommands(state, dispatch, view, store, isList, isShift, isText, isTextStart) {
	  if (isText && isTextStart) {
	    var command = isShift ? setIndent('less') : setIndent('more');
	    command(state, dispatch, view);
	    return true;
	  } else if (isText && !isTextStart) {
	      if (!isShift) {
	        var tr = state.tr;
	
	        dispatch(tr.insertText('    '));
	        return true;
	      }
	
	      var _command = setIndent('less');
	      _command(state, dispatch, view);
	      return true;
	    } else if (isList) {
	        var _store$listCommands = store.listCommands,
	            sinkListItem = _store$listCommands.sinkListItem,
	            liftListItem = _store$listCommands.liftListItem;
	
	        var _command2 = isShift ? liftListItem : sinkListItem;
	        _command2(state, dispatch);
	        return true;
	      }
	
	  return false;
	}
	
	function TabKeymap(isShift, store) {
	  return function tabCommand(state, dispatch, view) {
	    var isText = isTextBlock(state);
	    var isInList = store.editor.listUtils && store.editor.listUtils.isInList(state);
	    var isInTable = store.editor.tableUtils && store.editor.tableUtils.isInTable(state);
	    var isTextStart = state.selection.$from.parentOffset === 0;
	
	    if (isInList) {
	      var _store$editor$listCom = store.editor.listCommands,
	          sinkListItem = _store$editor$listCom.sinkListItem,
	          liftListItem = _store$editor$listCom.liftListItem;
	
	      var command = isShift ? liftListItem : sinkListItem;
	      command(state, dispatch, view);
	      return true;
	    }
	
	    if (!isInTable) {
	      return outsideTableCommands(state, dispatch, view, store, isInList, isShift, isText, isTextStart);
	    }
	
	    return false;
	  };
	}
	
	var tableTestReg = /<table[^>]*?data-pm-slice="/;
	var tablePMDataTestReg = /data-pm-slice="[^>]*?\[\]"/;
	var codeTestReg = /class="ct-code"[^>]*?data-pm-slice="/;
	var noteTestReg = /class="ct-note-[^>]*?data-pm-slice="/;
	var noteExecReg = /class="ct-note-[^>]*>([\s\S]*?)<\/div>/;
	var collapseTestReg = /class="ct-collapse-[^>]*?data-pm-slice="/;
	var collapseExecReg = /class="ct-collapse-[^>]*>([\s\S]*?)<\/div>/;
	var basicTestReg = /class="ct-basic"[^>]*?data-pm-slice="1 1/;
	var basicExecReg = /class="ct-basic"[^>]*>([\s\S]*?)<\/span>/;
	var confluenceTableTestReg = /confluenceTable/;
	
	var HTMLTransformer = function HTMLTransformer(htmlStr) {
	  var _this = this;
	
	  (0, _classCallCheck3.default)(this, HTMLTransformer);
	
	  this.parsePMSlice = function () {
	    _this.htmlString;
	    var removePMSlice = true;
	
	    if (_this.htmlString.includes('data-pm-slice="')) {
	      if (!_this.htmlString.includes('data-pm-slice="none"')) {
	        if (tableTestReg.test(_this.htmlString)) {
	          if (!tablePMDataTestReg.test(_this.htmlString)) {
	            _this.htmlString = _this.htmlString.replace(/<table.*?<td.*?>/g, '').replace(/<\/td><\/tr><\/tbody><\/table>/g, '');
	          }
	        } else if (codeTestReg.test(_this.htmlString)) {
	          removePMSlice = false;
	        } else if (basicTestReg.test(_this.htmlString)) {
	          _this.htmlString = basicExecReg.exec(_this.htmlString)[1];
	        } else if (noteTestReg.test(_this.htmlString)) {
	          _this.htmlString = noteExecReg.exec(_this.htmlString)[1];
	        } else if (collapseTestReg.test(_this.htmlString)) {
	          _this.htmlString = collapseExecReg.exec(_this.htmlString)[1];
	        }
	      }
	
	      if (removePMSlice) _this.htmlString = _this.htmlString.replace(/ data-pm-slice="[^>]*?"/g, '');
	    }
	
	    return _this;
	  };
	
	  this.parseExcel = function () {
	    if (_this.htmlString.includes('xmlns:o="urn:schemas-microsoft-com:office:office"') && _this.htmlString.includes('xmlns:x="urn:schemas-microsoft-com:office:excel"')) {
	      _this.htmlString = _this.htmlString.replace(/(<\/html>)[\s\S]*$/, '$1').replace(/<br>\s*/g, '<br>\u200B');
	    }
	
	    return _this;
	  };
	
	  this.parseWikiTable = function () {
	    if (confluenceTableTestReg.test(_this.htmlString)) {
	      _this.htmlString = _this.htmlString.replace(/<tbody><tr><tr>/g, '<tbody><tr>').replace(/background-color: rgb\(224, 224, 224\) !important;/g, 'background-color: #F6F6F6;').replace(/\sbackground-color: rgb\(237, 245, 255\) !important;/g, '').replace(/<thead[^>]*?tableFloatingHeader[^O].*?<\/thead>/g, '');
	    }
	
	    return _this;
	  };
	
	  this.parseWikiTable = function () {
	    if (confluenceTableTestReg.test(_this.htmlString)) {
	      _this.htmlString = _this.htmlString.replace(/<tbody><tr><tr>/g, '<tbody><tr>').replace(/background-color: rgb\(224, 224, 224\) !important;/g, 'background-color: #F6F6F6;').replace(/\sbackground-color: rgb\(237, 245, 255\) !important;/g, '').replace(/<thead[^>]*?tableFloatingHeader[^O].*?<\/thead>/g, '');
	    }
	
	    return _this;
	  };
	
	  this.pareseCode = function () {
	    if (_this.htmlString.includes('xmlns:m="http://schemas.microsoft.com/office/2004/12/omml"')) {
	      return _this;
	    }
	
	    if (!_this.htmlString.includes('ct-code') && !_this.htmlString.includes('ct-html')) {
	      _this.htmlString = _this.htmlString.replace(/<body>([\s\S]*)<\/body>/g, function (word) {
	        return word.replace(/\n</g, '<').replace(/>\s*\n/g, '>').replace(/\n/g, '<br />');
	      });
	    }
	
	    if (_this.htmlString.includes('ct-code')) {
	      _this.htmlString = _this.htmlString.replace(/<div class="title[^>]*?>([^<].*?)<\/div>/g, '<div class="title" data-title="$1"></div>').replace(/<div class="language[^>]*?>([^<].*?)<\/div>/g, '<div class="language" data-language="$1"></div>').replace(/<span[^>]*?cm-text.*?<\/span>/g, '').replace(/(<pre[^>]*?CodeMirror-line.*?)(<\/pre>)/g, '$1\n$2');
	    }
	
	    return _this;
	  };
	
	  this.otherFilter = function () {
	    _this.htmlString = _this.htmlString.replace(/(<a[^>]*?[^-])color:[^>]*?;([^<]*?<\/a>)/g, '$1$2').replace(/color: rgb\(51, 51, 51\);/g, '').replace(/(<td[^>]*?)background-color: rgb\(255, 255, 255\);([^<]*?<\/td>)/g, '$1$2').replace(/(<td[^<]*?>)(\s*?)(<\/td>)/g, '$1<p></p>$3').replace(/(<li[^<]*?>)(\s*?)(<\/li>)/g, '$1<p></p>$3').replace(/<tr[^>]*?cloneHeader.*?<\/tr>/g, '').replace(/<tr[^>]*?>[^<]*?(<tr)/g, '$1').replace(/<col[^>]*?style="width: 0px;"[^<]*?>/g, '<col>').replace(/<img[^>]*? src="file:\/\/\/[^<]*?>/g, '').replace(/<img[^>]*? src="https:\/\/file\.sankuai\.com\/pan\/[^<]*?>/g, '<span>\u200B</span>').replace(/ct-selected/g, '').replace(/(<div class="ct-gantt.*?>).*?(<\/div>)/g, '$1$2').replace(/(<td[^>]*?>[^<]*?)(<!--EndFragment-->)/g, '$1<p></p></td></tr></tbody></table></div>$2').replace(/&amp;token=.*?&amp;isNewContent=\w*/g, '').replace(/&amp;isNewContent=\w*/g, '');
	
	    return _this;
	  };
	
	  this.filterShadowDom = function (html) {
	    if (!~_this.htmlString.indexOf(index_ts.SHADOWDOM_CLASS)) {
	      return _this;
	    }
	
	    var createSpan = document.createElement('span');
	    createSpan.innerHTML = _this.htmlString;
	    createSpan.querySelectorAll('.' + index_ts.SHADOWDOM_CLASS).forEach(function (el) {
	      return el.remove();
	    });
	    _this.htmlString = createSpan.innerHTML;
	    return _this;
	  };
	
	  this.washHeadingAttr_ID = function () {
	    if (!~_this.htmlString.indexOf('ct-heading')) return _this;
	    var createDom = document.createElement('div');
	    createDom.innerHTML = _this.htmlString;
	    var heading = createDom.querySelectorAll('.ct-heading');
	    heading.forEach(function (h) {
	      if (h.getAttribute('id')) h.setAttribute('id', uuid());
	    });
	    _this.htmlString = createDom.innerHTML;
	    return _this;
	  };
	
	  this.washDiffIds = function () {
	    var createDom = document.createElement('div');
	    createDom.innerHTML = _this.htmlString;
	    var list = createDom.querySelectorAll('[data-diff-id]');
	    list.forEach(function (h) {
	      h.setAttribute('data-diff-id', 'ct-diff-id-' + uuid());
	    });
	    _this.htmlString = createDom.innerHTML;
	    return _this;
	  };
	
	  this.value = function () {
	    return _this.htmlString;
	  };
	
	  this.htmlString = htmlStr;
	};
	
	var transformPastedHTML = function transformPastedHTML(html) {
	  var transformer = new HTMLTransformer(html);
	  var res = transformer.parsePMSlice().parseExcel().parseWikiTable().pareseCode().otherFilter().filterShadowDom().washHeadingAttr_ID().washDiffIds().value();
	  return res;
	};
	var _transformPasted = function _transformPasted(store, slice) {
	  var trigger = store.editor.trigger;
	  var _store$view$state = store.view.state,
	      schema = _store$view$state.schema,
	      selection = _store$view$state.selection;
	  var $from = selection.$from;
	  var _schema$nodes8 = schema.nodes,
	      paragraph = _schema$nodes8.paragraph,
	      heading = _schema$nodes8.heading,
	      table = _schema$nodes8.table,
	      table_row = _schema$nodes8.table_row,
	      latex_inline = _schema$nodes8.latex_inline;
	
	  var sliceContent = slice.content.content;
	
	  if (slice.openStart === slice.openEnd && sliceContent.some(function (node) {
	    return node.isBlock && node.type !== heading && node.type !== paragraph;
	  })) {
	    slice.openStart = 0;
	    slice.openEnd = 0;
	  } else if (slice.openStart > 1 && slice.openEnd > 1) {
	    slice.openStart = 1;
	    slice.openEnd = 1;
	  }
	
	  if (sliceContent.length !== 1) {
	    var sliceMinWidth = index_js.computeSliceMinWidth(slice);
	    if (sliceMinWidth) trigger('afterInsert', {
	      braceWidth: sliceMinWidth
	    });
	    return slice;
	  }
	
	  var newSlice = slice;
	  var sliceNode = sliceContent[0];
	  var sliceNodeType = sliceNode.type;
	  var foundTableRow = index_js.findParentNode($from.path, function (node) {
	    return node.type === table_row;
	  });
	
	  if (!(sliceNodeType === table && foundTableRow) && sliceNodeType.spec.insertBlock) {
	    newSlice = index_js.getInsertBlockSlice(store.view.state, sliceNode);
	    if (newSlice === sliceNode) newSlice = slice;
	  }
	
	  if (sliceNodeType === latex_inline) {
	    newSlice.openend = 0;
	    newSlice.openStart = 0;
	  }
	
	  var braceWidth = sliceNodeType.spec.braceWidth;
	  if (braceWidth) trigger('afterInsert', {
	    braceWidth: braceWidth
	  });
	  return newSlice;
	};
	
	var specialChar = String.fromCharCode(10);
	
	function createPlugin(store) {
	  var pluginKey = new prosemirrorState.PluginKey('basic');
	  return new prosemirrorState.Plugin({
	    key: pluginKey,
	    props: {
	      transformPastedHTML: transformPastedHTML,
	      transformPastedText: function transformPastedText(text) {
	        return text.replace(new RegExp(specialChar, 'g'), '\n');
	      },
	
	      clipboardTextParser: function clipboardTextParser(text) {
	        var schema = store.view.state.schema;
	        var paragraph = schema.nodes.paragraph;
	
	        var contents = [];
	        var len = text.length;
	        var cursor = 0;
	
	        while (cursor < len) {
	          var breakIndex = text.indexOf('\n', cursor);
	
	          if (breakIndex !== -1) {
	            var textContent = text.slice(cursor, breakIndex);
	            if (textContent) contents.push(paragraph.create(null, schema.text(textContent)));
	            cursor = breakIndex + 1;
	          } else {
	            contents.push(paragraph.create(null, schema.text(text.slice(cursor, len))));
	            cursor = len + 1;
	          }
	        }
	
	        var fragment = prosemirrorModel.Fragment.from(contents);
	        var slice = new prosemirrorModel.Slice(fragment, 1, 1);
	        return slice;
	      },
	      transformPasted: function transformPasted(slice) {
	        return _transformPasted(store, slice);
	      },
	      transformDroped: function transformDroped(slice) {
	        return _transformPasted(store, slice);
	      }
	    }
	  });
	}
	
	var BasicStore = function () {
	  function BasicStore() {
	    (0, _classCallCheck3.default)(this, BasicStore);
	
	    this.view = null;
	    this.editor = null;
	  }
	
	  (0, _createClass3.default)(BasicStore, [{
	    key: 'init',
	    value: function init(editor) {
	      this.view = editor.view;
	      this.editor = editor;
	    }
	  }]);
	  return BasicStore;
	}();
	
	function styleInject(css, ref) {
	  if (ref === void 0) ref = {};
	  var insertAt = ref.insertAt;
	
	  if (!css || typeof document === 'undefined') {
	    return;
	  }
	
	  var head = document.head || document.getElementsByTagName('head')[0];
	  var style = document.createElement('style');
	  style.type = 'text/css';
	
	  if (insertAt === 'top') {
	    if (head.firstChild) {
	      head.insertBefore(style, head.firstChild);
	    } else {
	      head.appendChild(style);
	    }
	  } else {
	    head.appendChild(style);
	  }
	
	  if (style.styleSheet) {
	    style.styleSheet.cssText = css;
	  } else {
	    style.appendChild(document.createTextNode(css));
	  }
	}
	
	var css = ".ProseMirror{position:relative;outline:none;word-wrap:break-word;white-space:pre-wrap;-webkit-font-variant-ligatures:none;font-variant-ligatures:none}.ProseMirror *{box-sizing:border-box}.ProseMirror-hideselection ::selection{color:#666}.ProseMirror-hideselection ::-moz-selection{color:#666}.ProseMirror [draggable]{-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;user-select:text}.ProseMirror pre{white-space:pre-wrap}.ProseMirror-hideselection ::selection{background:transparent}.ProseMirror-hideselection ::-moz-selection{background:transparent}.ProseMirror-hideselection{caret-color:transparent}.ProseMirror-selectednode{outline:none}.ProseMirror-hideselection ::-moz-selection{color:inherit!important}.ProseMirror-hideselection ::selection{color:inherit!important}.ct-editor h1,.ct-editor h2,.ct-editor h3,.ct-editor h4,.ct-editor h5,.ct-editor h6,.ct-editor p,.ct-editor pre,.pm-body-wrapper h1,.pm-body-wrapper h2,.pm-body-wrapper h3,.pm-body-wrapper h4,.pm-body-wrapper h5,.pm-body-wrapper h6,.pm-body-wrapper p,.pm-body-wrapper pre,.ProseMirror h1,.ProseMirror h2,.ProseMirror h3,.ProseMirror h4,.ProseMirror h5,.ProseMirror h6,.ProseMirror p,.ProseMirror pre{margin:8px 0;color:#333;word-break:break-word;clear:both}.ct-editor p,.ct-editor pre,.pm-body-wrapper p,.pm-body-wrapper pre,.ProseMirror p,.ProseMirror pre{font-size:14px;line-height:22px;min-height:24px}.ct-editor h1,.ct-editor h2,.ct-editor h3,.ct-editor h4,.pm-body-wrapper h1,.pm-body-wrapper h2,.pm-body-wrapper h3,.pm-body-wrapper h4,.ProseMirror h1,.ProseMirror h2,.ProseMirror h3,.ProseMirror h4{padding:8px 0}.ct-editor h5,.ct-editor h6,.pm-body-wrapper h5,.pm-body-wrapper h6,.ProseMirror h5,.ProseMirror h6{padding:4px 0}.ct-editor h1,.pm-body-wrapper h1,.ProseMirror h1{font-size:28px;font-weight:700;line-height:36px;min-height:36px}.ct-editor h2,.pm-body-wrapper h2,.ProseMirror h2{font-size:24px;font-weight:700;line-height:32px;min-height:32px}.ct-editor h3,.pm-body-wrapper h3,.ProseMirror h3{font-size:20px;font-weight:700;line-height:28px;min-height:28px}.ct-editor h4,.pm-body-wrapper h4,.ProseMirror h4{font-size:16px;font-weight:700;line-height:24px;min-height:24px}.ct-editor h5,.pm-body-wrapper h5,.ProseMirror h5{font-size:14px;font-weight:700;line-height:22px;min-height:22px}.ct-editor h6,.pm-body-wrapper h6,.ProseMirror h6{font-size:12px;font-weight:700;line-height:20px;min-height:20px}.ct-editor hr,.pm-body-wrapper hr,.ProseMirror hr{display:block;height:1px;width:100%;border:0;background:#ccc}.ct-editor hr.ProseMirror-selectednode,.pm-body-wrapper hr.ProseMirror-selectednode,.ProseMirror hr.ProseMirror-selectednode{background:#00a7cd}";
	styleInject(css);
	
	var BasicModule = function () {
	  function BasicModule() {
	    (0, _classCallCheck3.default)(this, BasicModule);
	
	    this.name = 'basic';
	    this.store = new BasicStore();
	    this.schema = {
	      nodes: nodes,
	      marks: marks
	    };
	    this.commands = {
	      clearFormat: clearFormat,
	      insertHr: insertHr,
	      setIndent: setIndent,
	      setTextBlockType: setTextBlockType,
	      setAlign: setAlign,
	      setTextColor: setTextColor,
	      setTextDefaultColor: setTextDefaultColor,
	      toggleMark: toggleMark,
	      toggleSuMark: toggleSuMark,
	      setFontsize: setFontsize
	    };
	    this.utils = {
	      canAlign: canAlign,
	      canIndent: canIndent,
	      getAttrs: getAttrs,
	      getTextBlockType: getTextBlockType,
	      hasMark: hasMark,
	      isTextBlock: isTextBlock,
	      isWeirdBlock: isWeirdBlock,
	      isAlignedBlock: isAlignedBlock,
	      getTextFontsize: getTextFontsize,
	      canSetFontsize: canSetFontsize,
	      isInParagraph: isInParagraph,
	      isInHeading: isInHeading
	    };
	    this.plugins = [keymap({
	      Enter: handleEnter,
	      'Shift-Enter': handleShiftEnter,
	      Backspace: handleBackspace,
	      'Mod-Backspace': handleBackspace,
	      Delete: handleDelete,
	      'Mod-Delete': handleDelete
	    }), keymap(prosemirrorCommands.baseKeymap), keymap({
	      Tab: TabKeymap(false, this.store),
	      'Shift-Tab': TabKeymap(true, this.store)
	    }), createPlugin(this.store)];
	  }
	
	  (0, _createClass3.default)(BasicModule, [{
	    key: 'init',
	    value: function init(editor) {
	      this.store.init(editor);
	    }
	  }]);
	  return BasicModule;
	}();
	
	BasicModule.moduleName = 'basic';
	
	exports.BasicModule = BasicModule;

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _defineProperty2 = __webpack_require__(44);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _assign = __webpack_require__(26);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _set = __webpack_require__(101);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _getPrototypeOf = __webpack_require__(30);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(7);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(10);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(32);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(31);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _typeof2 = __webpack_require__(8);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault(ex) {
	  return ex && (typeof ex === 'undefined' ? 'undefined' : (0, _typeof3.default)(ex)) === 'object' && 'default' in ex ? ex['default'] : ex;
	}
	
	var index_js = __webpack_require__(22);
	__webpack_require__(29);
	__webpack_require__(25);
	__webpack_require__(12);
	var prosemirrorState = __webpack_require__(6);
	var prosemirrorView = __webpack_require__(48);
	var preact = __webpack_require__(24);
	var prosemirrorCommands = __webpack_require__(182);
	var prosemirrorHistory = __webpack_require__(183);
	var CodeMirror = _interopDefault(__webpack_require__(1));
	__webpack_require__(287);
	__webpack_require__(283);
	__webpack_require__(402);
	__webpack_require__(102);
	__webpack_require__(67);
	__webpack_require__(289);
	__webpack_require__(290);
	__webpack_require__(291);
	__webpack_require__(292);
	__webpack_require__(103);
	__webpack_require__(294);
	__webpack_require__(68);
	__webpack_require__(295);
	__webpack_require__(309);
	__webpack_require__(296);
	__webpack_require__(297);
	__webpack_require__(299);
	__webpack_require__(300);
	__webpack_require__(301);
	__webpack_require__(302);
	__webpack_require__(304);
	__webpack_require__(305);
	__webpack_require__(306);
	__webpack_require__(152);
	__webpack_require__(307);
	__webpack_require__(308);
	__webpack_require__(153);
	__webpack_require__(310);
	__webpack_require__(311);
	__webpack_require__(69);
	__webpack_require__(312);
	var keymap = _interopDefault(__webpack_require__(34));
	var plantumlEncoder = _interopDefault(__webpack_require__(458));
	
	var DEFAULT_LANGUAGE = 'Plain Text';
	var DEFAULT_THEME = 'xq-light';
	var DEFAULT_TITLE = '代码块';
	
	function uuid() {
	  var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
	  var id = [];
	
	  for (var i = 0; i < 8; i++) {
	    id.push(chars[parseInt(Math.random() * chars.length, 10)]);
	  }
	
	  return id.join('');
	}
	
	var schema = {
	  nodes: {
	    code_block: {
	      group: 'block',
	      content: 'text*',
	      allowGapCursor: true,
	      insertBlock: true,
	      dragBlock: true,
	      marks: '',
	      attrs: {
	        language: {
	          default: DEFAULT_LANGUAGE
	        },
	
	        theme: {
	          default: DEFAULT_THEME
	        },
	
	        title: {
	          default: DEFAULT_TITLE
	        },
	
	        isExpand: {
	          default: true
	        },
	
	        isCreate: {
	          default: false
	        },
	
	        dataDiffId: {
	          default: null
	        }
	      },
	      parseDOM: [{
	        tag: 'div[class="ct-code"]',
	        preserveWhitespace: 'full',
	
	        getAttrs: function getAttrs(dom) {
	          var titleDOM = dom.querySelector('.title');
	          var languageDOM = dom.querySelector('.language');
	          var dataDiffId = dom.getAttribute('data-diff-id');
	          var _dom$dataset = dom.dataset,
	              _dom$dataset$language = _dom$dataset.language,
	              language = _dom$dataset$language === undefined ? languageDOM ? languageDOM.getAttribute('data-language') || DEFAULT_LANGUAGE : DEFAULT_LANGUAGE : _dom$dataset$language,
	              _dom$dataset$theme = _dom$dataset.theme,
	              theme = _dom$dataset$theme === undefined ? DEFAULT_THEME : _dom$dataset$theme,
	              _dom$dataset$title = _dom$dataset.title,
	              title = _dom$dataset$title === undefined ? titleDOM ? titleDOM.getAttribute('data-title') || DEFAULT_TITLE : DEFAULT_TITLE : _dom$dataset$title;
	
	          var isExpand = void 0;
	
	          if (dom.querySelector('.isNotExpand')) {
	            isExpand = false;
	          } else {
	            isExpand = dom.getAttribute('data-expand') !== 'false';
	          }
	
	          return {
	            language: language,
	            theme: theme,
	            title: title,
	            isExpand: isExpand,
	            dataDiffId: dataDiffId
	          };
	        }
	      }],
	
	      toDOM: function toDOM(node) {
	        var _node$attrs = node.attrs,
	            language = _node$attrs.language,
	            theme = _node$attrs.theme,
	            title = _node$attrs.title,
	            isExpand = _node$attrs.isExpand,
	            dataDiffId = _node$attrs.dataDiffId;
	
	        var attrs = {
	          class: 'ct-code',
	          spellcheck: false,
	          'data-language': language,
	          'data-theme': theme,
	          'data-title': title,
	          'data-expand': isExpand,
	          'data-diff-id': dataDiffId || 'ct-diff-id-' + uuid()
	        };
	        return ['div', attrs, ['pre', {}, ['code', 0]]];
	      }
	    }
	  }
	};
	
	function insert() {
	  return function (state, dispatch, view, trigger) {
	    var schema = state.schema;
	
	    var node = schema.nodes.code_block.create({
	      isCreate: true,
	      language: localStorage.getItem('cmLanguage') || ''
	    });
	
	    var _index_js$insertBlock = index_js.insertBlock(state, node),
	        transaction = _index_js$insertBlock.transaction;
	
	    if (!transaction) return false;
	    dispatch(transaction.scrollIntoView());
	    if (typeof trigger === 'function') trigger('afterInsert', {
	      draggable: true,
	      braceWidth: 250
	    });
	    return true;
	  };
	}
	function update(attrs, pos) {
	  return function (state, dispatch) {
	    var tr = state.tr,
	        schema = state.schema;
	
	    dispatch(tr.setNodeMarkup(pos, schema.nodes.code_block, attrs).scrollIntoView());
	  };
	}
	function isInCode(state) {
	  if (!state) return false;
	  var $from = state.selection.$from;
	
	  var foundNode = index_js.findParentNode($from.path, function (node) {
	    return node.type && node.type.spec.code;
	  });
	  return !!foundNode;
	}
	
	function styleInject(css, ref) {
	  if (ref === void 0) ref = {};
	  var insertAt = ref.insertAt;
	
	  if (!css || typeof document === 'undefined') {
	    return;
	  }
	
	  var head = document.head || document.getElementsByTagName('head')[0];
	  var style = document.createElement('style');
	  style.type = 'text/css';
	
	  if (insertAt === 'top') {
	    if (head.firstChild) {
	      head.insertBefore(style, head.firstChild);
	    } else {
	      head.appendChild(style);
	    }
	  } else {
	    head.appendChild(style);
	  }
	
	  if (style.styleSheet) {
	    style.styleSheet.cssText = css;
	  } else {
	    style.appendChild(document.createTextNode(css));
	  }
	}
	
	var css = ".ct-code-toolbar{display:flex;position:relative;width:100%;height:30px;padding-left:10px;align-items:center;background:#f2f2f2;box-sizing:border-box}.ct-code-toolbar .padding{height:100%;width:10px;cursor:pointer}.ct-code-toolbar .expand{width:24px;height:100%;background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg class='icon' viewBox='0 0 1024 1024' xmlns='http://www.w3.org/2000/svg' width='8' height='8'%3E%3Cdefs%3E%3Cstyle/%3E%3C/defs%3E%3Cpath d='M375.967 310.026L28.207 642.81a89.34 89.34 0 0 0 0 130.17 99.323 99.323 0 0 0 136.058 0l347.76-332.657 347.759 332.785a99.323 99.323 0 0 0 136.057 0 89.34 89.34 0 0 0 0-130.17l-347.76-332.784-65.916-59.39a105.723 105.723 0 0 0-140.281 0l-65.917 59.39z' fill='%23747272'/%3E%3C/svg%3E\") no-repeat 50%;cursor:pointer;transition:-webkit-transform .2s;transition:transform .2s;transition:transform .2s,-webkit-transform .2s}.ct-code-toolbar .collapse{-webkit-transform:rotate(-180deg);transform:rotate(-180deg)}.ct-code-toolbar .title{flex:1;line-height:30px;height:30px;font-size:12px;font-weight:700;color:#333;cursor:text;outline:none;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ct-code-toolbar .ct-code-lang-select-list{position:fixed;width:140px;max-height:360px;margin:0;padding:8px 0;background:#fff;box-shadow:0 4px 16px 0 rgba(106,93,73,.2),0 8px 20px 0 rgba(106,93,73,.1);border-radius:4px;overflow-y:auto;list-style:none;z-index:11}.ct-code-toolbar .ct-code-lang-select-list::-webkit-scrollbar{background-color:#f5f5f5;width:6px;height:8px}.ct-code-toolbar .ct-code-lang-select-list::-webkit-scrollbar-thumb{border-radius:3px;background-color:#ddd}.ct-code-toolbar .list-item{height:24px;line-height:24px;padding-left:16px;font-size:12px;color:#333;cursor:pointer}.ct-code-toolbar .active,.ct-code-toolbar .list-item:hover{background:#f6f6f6}.ct-code-lang-select{width:140px;overflow:hidden;height:30px;line-height:30px}.ct-code-lang-select .lang{height:30px;padding-right:32px;font-family:Tahoma;font-size:12px;color:#999;text-align:right;cursor:pointer;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ct-code-lang-select .lang:after{content:\"\";position:absolute;width:8px;height:8px;top:12px;margin:0 8px;background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg class='icon' viewBox='0 0 1638 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' id='mx_n_1513063069382' width='10.8' height='7.4'%3E%3Cdefs%3E%3Cstyle/%3E%3C/defs%3E%3Cpath d='M1595.802 262.758a160.563 160.563 0 0 0 31.539-167.936A145.203 145.203 0 0 0 1493.4 0H144.999A145.408 145.408 0 0 0 11.06 95.027 163.02 163.02 0 0 0 0 154.01c0 39.936 14.746 79.257 42.394 108.748L716.8 978.944c27.238 28.877 64.102 45.056 102.4 45.056 38.502 0 75.366-16.384 102.4-45.056l674.202-716.186z' fill='%23B0B0B0'/%3E%3C/svg%3E\") no-repeat 0 0;background-size:8px 8px;transition:-webkit-transform .2s;transition:transform .2s;transition:transform .2s,-webkit-transform .2s}.ct-code-lang-select .select-expand:after{-webkit-transform:rotate(180deg);transform:rotate(180deg)}";
	styleInject(css);
	
	var Toolbar = function (_preact$Component) {
	  (0, _inherits3.default)(Toolbar, _preact$Component);
	
	  function Toolbar(props) {
	    (0, _classCallCheck3.default)(this, Toolbar);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Toolbar.__proto__ || (0, _getPrototypeOf2.default)(Toolbar)).call(this, props));
	
	    _this.toggleDisplay = function () {
	      var isExpand = !_this.state.isExpand;
	      _this.setState({
	        isExpand: isExpand
	      });
	      _this.props.toggleDisplay(isExpand);
	    };
	
	    _this.updateTitle = function () {
	      var title = _this.title.textContent;
	      _this.setState({
	        title: title
	      });
	      _this.props.updateTitle(title);
	    };
	
	    _this.handleClick = function (e) {
	      e.preventDefault();
	      e.stopPropagation();
	      var lang = e.target.textContent;
	
	      if (lang === _this.state.lang) {
	        return;
	      }
	
	      _this.props.changeLanguage(lang);
	      _this.setState({
	        isShow: false,
	        lang: lang
	      });
	    };
	
	    _this.hideSelect = function (e) {
	      var selectNode = e.target.closest('.ct-code-lang-select-list');
	
	      if (_this.state.isShow && !selectNode) {
	        _this.setState({
	          isShow: false
	        });
	      }
	    };
	
	    _this.toggleShow = function (e) {
	      e.preventDefault();
	      e.stopPropagation();
	      if (_this.toolbar.offsetWidth < 100) return;
	
	      var _e$target$getBounding = e.target.getBoundingClientRect(),
	          left = _e$target$getBounding.left,
	          top = _e$target$getBounding.top;
	
	      var ulTop = top + e.target.offsetHeight;
	      _this.setState({
	        isShow: !_this.state.isShow,
	        left: left,
	        top: ulTop
	      });
	    };
	
	    _this.state = {
	      title: props.attrs.title || DEFAULT_TITLE,
	      lang: props.attrs.language,
	      isExpand: props.attrs.isExpand,
	      isShow: false,
	      left: 0,
	      top: 0
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(Toolbar, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var pageWrapper = document.querySelector('body');
	      pageWrapper.addEventListener('mousedown', this.hideSelect);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var pageWrapper = document.querySelector('body');
	      pageWrapper.removeEventListener('mousedown', this.hideSelect);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          setSelection = _props.setSelection,
	          languages = _props.languages;
	      var _state = this.state,
	          lang = _state.lang,
	          isExpand = _state.isExpand,
	          isShow = _state.isShow,
	          title = _state.title,
	          left = _state.left,
	          top = _state.top;
	
	      return preact.h("div", {
	        className: "ct-code-toolbar",
	        ref: function ref(refs) {
	          _this2.toolbar = refs;
	        }
	      }, preact.h("div", {
	        className: 'expand ' + (isExpand ? '' : 'collapse'),
	        onClick: this.toggleDisplay
	      }), preact.h("div", {
	        className: "title",
	        contentEditable: true,
	        dangerouslySetInnerHTML: {
	          __html: title
	        },
	        ref: function ref(refs) {
	          _this2.title = refs;
	        },
	        onFocus: setSelection,
	        onBlur: this.updateTitle
	      }), preact.h("div", {
	        className: "ct-code-lang-select"
	      }, preact.h("div", {
	        className: 'lang ' + (isShow ? 'select-expand' : ''),
	        onClick: this.toggleShow
	      }, lang)), isShow && preact.h("ul", {
	        className: "ct-code-lang-select-list",
	        ref: function ref(refs) {
	          _this2.list = refs;
	        },
	        style: {
	          left: left + 'px',
	          top: top + 'px'
	        }
	      }, languages.map(function (_ref) {
	        var name = _ref.name;
	        return preact.h("li", {
	          className: 'list-item ' + (lang === name ? 'active' : ''),
	          key: name,
	          onClick: _this2.handleClick
	        }, name);
	      })));
	    }
	  }]);
	  return Toolbar;
	}(preact.Component);
	
	var languages = [{
	  name: 'Plain Text',
	  mime: 'text/plain',
	  mode: 'null',
	  ext: ['txt', 'text', 'conf', 'def', 'list', 'log']
	}, {
	  name: 'C',
	  mime: 'text/x-csrc',
	  mode: 'clike',
	  ext: ['c', 'h', 'ino']
	}, {
	  name: 'C++',
	  mime: 'text/x-c++src',
	  mode: 'clike',
	  ext: ['cpp', 'c++', 'cc', 'cxx', 'hpp', 'h++', 'hh', 'hxx'],
	  alias: ['cpp']
	}, {
	  name: 'C#',
	  mime: 'text/x-csharp',
	  mode: 'clike',
	  ext: ['cs'],
	  alias: ['csharp']
	}, {
	  name: 'CSS',
	  mime: 'text/css',
	  mode: 'css',
	  ext: ['css']
	}, {
	  name: 'Dart',
	  mimes: ['application/dart', 'text/x-dart'],
	  mode: 'dart',
	  ext: ['dart']
	}, {
	  name: 'Elm',
	  mime: 'text/x-elm',
	  mode: 'elm',
	  ext: ['elm']
	}, {
	  name: 'Go',
	  mime: 'text/x-go',
	  mode: 'go',
	  ext: ['go']
	}, {
	  name: 'Groovy',
	  mime: 'text/x-groovy',
	  mode: 'groovy',
	  ext: ['groovy', 'gradle'],
	  file: /^Jenkinsfile$/
	}, {
	  name: 'HTML',
	  mime: 'text/html',
	  mode: 'htmlmixed',
	  ext: ['html', 'htm', 'handlebars', 'hbs'],
	  alias: ['xhtml']
	}, {
	  name: 'HTTP',
	  mime: 'message/http',
	  mode: 'http'
	}, {
	  name: 'Java',
	  mime: 'text/x-java',
	  mode: 'clike',
	  ext: ['java']
	}, {
	  name: 'JavaScript',
	  mimes: ['text/javascript', 'text/ecmascript', 'application/javascript', 'application/x-javascript', 'application/ecmascript'],
	  mode: 'javascript',
	  ext: ['js'],
	  alias: ['ecmascript', 'js', 'node']
	}, {
	  name: 'JSON',
	  mimes: ['application/json', 'application/x-json'],
	  mode: 'javascript',
	  ext: ['json', 'map'],
	  alias: ['json5']
	}, {
	  name: 'JSX',
	  mime: 'text/jsx',
	  mode: 'jsx',
	  ext: ['jsx']
	}, {
	  name: 'Kotlin',
	  mime: 'text/x-kotlin',
	  mode: 'clike',
	  ext: ['kt']
	}, {
	  name: 'LaTeX',
	  mime: 'text/x-latex',
	  mode: 'stex',
	  ext: ['text', 'ltx', 'tex'],
	  alias: ['tex']
	}, {
	  name: 'Lua',
	  mime: 'text/x-lua',
	  mode: 'lua',
	  ext: ['lua']
	}, {
	  name: 'Markdown',
	  mime: 'text/x-markdown',
	  mode: 'markdown',
	  ext: ['markdown', 'md', 'mkd']
	}, {
	  name: 'Nginx',
	  mime: 'text/x-nginx-conf',
	  mode: 'nginx',
	  file: /nginx.*\.conf$/i
	}, {
	  name: 'Objective-C',
	  mime: 'text/x-objectivec',
	  mode: 'clike',
	  ext: ['m', 'mm'],
	  alias: ['objective-c', 'objc']
	}, {
	  name: 'Perl',
	  mime: 'text/x-perl',
	  mode: 'perl',
	  ext: ['pl', 'pm']
	}, {
	  name: 'PHP',
	  mimes: ['text/x-php', 'application/x-httpd-php', 'application/x-httpd-php-open'],
	  mode: 'php',
	  ext: ['php', 'php3', 'php4', 'php5', 'php7', 'phtml']
	}, {
	  name: 'PowerShell',
	  mime: 'application/x-powershell',
	  mode: 'powershell',
	  ext: ['ps1', 'psd1', 'psm1']
	}, {
	  name: 'Python',
	  mime: 'text/x-python',
	  mode: 'python',
	  ext: ['BUILD', 'bzl', 'py', 'pyw'],
	  file: /^(BUCK|BUILD)$/
	}, {
	  name: 'R',
	  mime: 'text/x-rsrc',
	  mode: 'r',
	  ext: ['r', 'R'],
	  alias: ['rscript']
	}, {
	  name: 'Ruby',
	  mime: 'text/x-ruby',
	  mode: 'ruby',
	  ext: ['rb'],
	  alias: ['jruby', 'macruby', 'rake', 'rb', 'rbx']
	}, {
	  name: 'Sass',
	  mime: 'text/x-sass',
	  mode: 'sass',
	  ext: ['sass']
	}, {
	  name: 'Scala',
	  mime: 'text/x-scala',
	  mode: 'clike',
	  ext: ['scala']
	}, {
	  name: 'Shell',
	  mimes: ['text/x-sh', 'application/x-sh'],
	  mode: 'shell',
	  ext: ['sh', 'ksh', 'bash'],
	  alias: ['bash', 'sh', 'zsh'],
	  file: /^PKGBUILD$/
	}, {
	  name: 'SQL',
	  mime: 'text/x-sql',
	  mode: 'sql',
	  ext: ['sql']
	}, {
	  name: 'Stylus',
	  mime: 'text/x-styl',
	  mode: 'stylus',
	  ext: ['styl']
	}, {
	  name: 'Swift',
	  mime: 'text/x-swift',
	  mode: 'swift',
	  ext: ['swift']
	}, {
	  name: 'Vue.js Component',
	  mimes: ['script/x-vue', 'text/x-vue'],
	  mode: 'vue',
	  ext: ['vue']
	}, {
	  name: 'XML',
	  mimes: ['application/xml', 'text/xml'],
	  mode: 'xml',
	  ext: ['xml', 'xsl', 'xsd', 'svg'],
	  alias: ['rss', 'wsdl', 'xsd']
	}, {
	  name: 'YAML',
	  mimes: ['text/x-yaml', 'text/yaml'],
	  mode: 'yaml',
	  ext: ['yaml', 'yml'],
	  alias: ['yml']
	}, {
	  name: 'PlantUML',
	  mode: 'plantuml'
	}];
	var modeMap = {};
	languages.forEach(function (_ref2) {
	  var name = _ref2.name,
	      mime = _ref2.mime,
	      mode = _ref2.mode;
	
	  if (mode === 'clike' || mode === 'sql') {
	    modeMap[name.toLowerCase()] = Array.isArray(mime) ? mime[0] : mime;
	  } else {
	    modeMap[name.toLowerCase()] = mode;
	  }
	});
	function getMode(language) {
	  return modeMap[(language || '').toLowerCase()] || 'null';
	}
	
	var css$1 = ".cm-s-xq-light span.cm-keyword{line-height:1em;font-weight:700;color:#5a5cad}.cm-s-xq-light span.cm-atom{color:#6c8cd5}.cm-s-xq-light span.cm-number{color:#164}.cm-s-xq-light span.cm-def{text-decoration:underline}.cm-s-xq-light span.cm-type,.cm-s-xq-light span.cm-variable,.cm-s-xq-light span.cm-variable-2,.cm-s-xq-light span.cm-variable-3{color:#000}.cm-s-xq-light span.cm-comment{color:#0080ff;font-style:italic}.cm-s-xq-light span.cm-string{color:red}.cm-s-xq-light span.cm-meta{color:#ff0}.cm-s-xq-light span.cm-qualifier{color:grey}.cm-s-xq-light span.cm-builtin{color:#7ea656}.cm-s-xq-light span.cm-bracket{color:#cc7}.cm-s-xq-light span.cm-tag{color:#3f7f7f}.cm-s-xq-light span.cm-attribute{color:#7f007f}.cm-s-xq-light span.cm-error{color:red}.cm-s-xq-light .CodeMirror-activeline-background{background:#e8f2ff}.cm-s-xq-light .CodeMirror-matchingbracket{outline:1px solid grey;color:#000!important;background:#ff0}.CodeMirror{height:auto;background:#fcfcfc}.CodeMirror div{box-sizing:content-box}.CodeMirror pre{white-space:pre!important;padding:0 10px}.CodeMirror pre span{font-family:monospace}.CodeMirror .CodeMirror-sizer{margin-left:46px!important}.CodeMirror .CodeMirror-lines{padding:10px 0}.CodeMirror .CodeMirror-line{counter-increment:linenumber;margin:0}.CodeMirror .CodeMirror-line:before{content:counter(linenumber);position:absolute;display:block;left:-46px;width:32px;line-height:24px;text-align:right;font-size:12px;color:#9b9b9b}.cm-s-xq-light span.cm-def{text-decoration:none}.cm-s-xq-light span.cm-meta{color:red}.cm-s-xq-light span.cm-type{color:green}.CodeMirror-cursor{width:2px!important}";
	styleInject(css$1);
	
	var modeSet = new _set2.default();
	languages.forEach(function (_ref3) {
	  var mode = _ref3.mode;
	
	  if (!modeSet.has(mode) && mode !== 'null' && mode !== 'plantuml') {
	    modeSet.add(mode);
	  }
	});
	
	var css$2 = ".ct-code-selected{margin:5px 0;border:1px solid #0082a6;opacity:.7;border-radius:3px}.ct-code-selected .CodeMirror,.ct-code-selected .ct-code{margin:0}";
	styleInject(css$2);
	
	function computeChange(oldVal, newVal) {
	  if (oldVal === newVal) return null;
	  var start = 0;
	  var oldEnd = oldVal.length;
	  var newEnd = newVal.length;
	
	  while (start < oldEnd && oldVal.charCodeAt(start) === newVal.charCodeAt(start)) {
	    ++start;
	  }while (oldEnd > start && newEnd > start && oldVal.charCodeAt(oldEnd - 1) === newVal.charCodeAt(newEnd - 1)) {
	    oldEnd--;
	    newEnd--;
	  }
	
	  return {
	    from: start,
	    to: oldEnd,
	    text: newVal.slice(start, newEnd)
	  };
	}
	
	var CodeBlockView = function () {
	  function CodeBlockView(node, view, getPos, store) {
	    var _this3 = this;
	
	    (0, _classCallCheck3.default)(this, CodeBlockView);
	
	    this.updateAttrs = function (attrs) {
	      var _view = _this3.view,
	          state = _view.state,
	          dispatch = _view.dispatch;
	
	      var newAttrs = (0, _assign2.default)({}, _this3.node.attrs, attrs);
	      var command = update(newAttrs, _this3.getPos());
	      command(state, dispatch);
	    };
	
	    this.toggleDisplay = function (isExpand) {
	      var $cm = _this3.cm.getWrapperElement();
	      _this3.cm.focus();
	
	      if (isExpand) {
	        $cm.style.cssText = 'height:auto !important';
	        _this3.cm.refresh();
	      } else {
	        $cm.style.cssText = 'height:0 !important';
	      }
	
	      _this3.updateAttrs({
	        isExpand: isExpand
	      });
	    };
	
	    this.updateTitle = function (title) {
	      _this3.updateAttrs({
	        title: title
	      });
	    };
	
	    this.changeLanguage = function (language) {
	      _this3.cm.setOption('mode', getMode(language));
	      _this3.updateAttrs({
	        language: language
	      });
	      _this3.cm.focus();
	      localStorage.setItem('cmLanguage', language);
	    };
	
	    this.setTextSelection = function () {
	      var _view2 = _this3.view,
	          state = _view2.state,
	          dispatch = _view2.dispatch;
	      var doc = state.doc,
	          tr = state.tr;
	
	      var pos = _this3.getPos() + 1;
	      var selection = prosemirrorState.TextSelection.create(doc, pos, pos);
	      dispatch(tr.setSelection(selection));
	    };
	
	    this.node = node;
	    this.view = view;
	    this.getPos = getPos;
	    this.store = store;
	    var _node$attrs2 = this.node.attrs,
	        _language = _node$attrs2.language,
	        theme = _node$attrs2.theme,
	        isCreate = _node$attrs2.isCreate,
	        dataDiffId = _node$attrs2.dataDiffId;
	
	    var value = this.node.textContent;
	
	    this.cm = new CodeMirror(null, {
	      value: value,
	
	      matchBrackets: true,
	
	      tabSize: 2,
	      mode: getMode(_language),
	      theme: theme,
	
	      extraKeys: this.codeMirrorKeymap()
	    });
	    this.dom = this.createDom();
	
	    setTimeout(function () {
	      _this3.cm.refresh();
	    }, 20);
	
	    this.updating = false;
	
	    this.cm.on('changes', function () {
	      if (!_this3.updating) _this3.valueChanged();
	    });
	    this.cm.on('focus', function () {
	      _this3.forwardSelection();
	    });
	
	    this.cm.on('drop', function (c, e) {
	      var htmlData = e.dataTransfer.getData('text/html');
	
	      if (htmlData && htmlData[1] !== 'p' && htmlData[1] !== 'h') {
	        e.stopPropagation();
	        e.preventDefault();
	        return false;
	      }
	    });
	  }
	
	  (0, _createClass3.default)(CodeBlockView, [{
	    key: 'createDom',
	    value: function createDom() {
	      var _node = this.node,
	          attrs = _node.attrs,
	          dataDiffId = _node.attrs.dataDiffId;
	
	      var $cm = this.cm.getWrapperElement();
	
	      if (!attrs.isExpand) {
	        $cm.style.cssText = 'height:0 !important';
	      }
	
	      var $toolbar = document.createElement('div');
	      preact.render(preact.h(Toolbar, {
	        attrs: attrs,
	        languages: languages,
	        setSelection: this.setTextSelection,
	        toggleDisplay: this.toggleDisplay,
	        updateTitle: this.updateTitle,
	        changeLanguage: this.changeLanguage
	      }), $toolbar);
	      var $code = document.createElement('div');
	      $code.className = 'ct-code';
	
	      if (dataDiffId) {
	        $code.setAttribute('data-diff-id', dataDiffId);
	      }
	
	      $code.appendChild($toolbar);
	      $code.appendChild($cm);
	      return $code;
	    }
	  }, {
	    key: 'forwardSelection',
	    value: function forwardSelection() {
	      if (!this.cm.hasFocus()) return;
	      var state = this.view.state;
	      var selection = this.asProseMirrorSelection(state.doc);
	
	      if (!selection.eq(state.selection)) {
	        this.view.dispatch(state.tr.setSelection(selection));
	      }
	    }
	  }, {
	    key: 'asProseMirrorSelection',
	    value: function asProseMirrorSelection(doc) {
	      var offset = this.getPos() + 1;
	      var anchor = this.cm.indexFromPos(this.cm.getCursor('anchor')) + offset;
	      var head = this.cm.indexFromPos(this.cm.getCursor('head')) + offset;
	      return prosemirrorState.TextSelection.create(doc, anchor, head);
	    }
	  }, {
	    key: 'setSelection',
	    value: function setSelection(anchor, head) {
	      this.cm.focus();
	      this.updating = true;
	      this.cm.setSelection(this.cm.posFromIndex(anchor), this.cm.posFromIndex(head));
	      this.updating = false;
	    }
	  }, {
	    key: 'valueChanged',
	    value: function valueChanged() {
	      var change = computeChange(this.node.textContent, this.cm.getValue());
	
	      if (change) {
	        var _view$state = this.view.state,
	            tr = _view$state.tr,
	            _schema = _view$state.schema;
	
	        var start = this.getPos() + 1;
	        var from = start + change.from;
	        var to = start + change.to;
	        var content = change.text ? _schema.text(change.text) : null;
	        this.view.dispatch(tr.replaceWith(from, to, content));
	      }
	    }
	  }, {
	    key: 'codeMirrorKeymap',
	    value: function codeMirrorKeymap() {
	      var _this4 = this,
	          _CodeMirror$normalize;
	
	      var view = this.view;
	      var mod = /Mac/.test(navigator.platform) ? 'Cmd' : 'Ctrl';
	      return CodeMirror.normalizeKeyMap((_CodeMirror$normalize = {
	        Up: function Up() {
	          return _this4.maybeEscape('line', -1);
	        },
	        Left: function Left() {
	          return _this4.maybeEscape('char', -1);
	        },
	        Down: function Down() {
	          return _this4.maybeEscape('line', 1);
	        },
	        Right: function Right() {
	          return _this4.maybeEscape('char', 1);
	        }
	      }, (0, _defineProperty3.default)(_CodeMirror$normalize, mod + '-Z', function undefined() {
	        prosemirrorHistory.undo(view.state, view.dispatch);
	        _this4.store.trigger('afterInsert', {
	          draggable: true
	        });
	      }), (0, _defineProperty3.default)(_CodeMirror$normalize, mod + '-A', function undefined() {
	        return _this4.selectAll();
	      }), (0, _defineProperty3.default)(_CodeMirror$normalize, 'Shift-' + mod + '-Z', function undefined() {
	        prosemirrorHistory.redo(view.state, view.dispatch);
	        _this4.store.trigger('afterInsert', {
	          draggable: true
	        });
	      }), (0, _defineProperty3.default)(_CodeMirror$normalize, 'Shift-' + mod + '-A', function undefined() {
	        return _this4.selectAllContent();
	      }), (0, _defineProperty3.default)(_CodeMirror$normalize, 'Shift-Enter', function ShiftEnter() {
	        _this4.cm.execCommand('newlineAndIndent');
	      }), (0, _defineProperty3.default)(_CodeMirror$normalize, mod + '-Y', function undefined() {
	        prosemirrorHistory.redo(view.state, view.dispatch);
	        _this4.store.trigger('afterInsert', {
	          draggable: true
	        });
	      }), (0, _defineProperty3.default)(_CodeMirror$normalize, 'Ctrl-Enter', function CtrlEnter() {
	        if (prosemirrorCommands.exitCode(view.state, view.dispatch)) view.focus();
	      }), _CodeMirror$normalize));
	    }
	  }, {
	    key: 'maybeEscape',
	    value: function maybeEscape(unit, dir) {
	      var pos = this.cm.getCursor();
	
	      if (this.cm.somethingSelected() || pos.line !== (dir < 0 ? this.cm.firstLine() : this.cm.lastLine()) || unit === 'char' && pos.ch !== (dir < 0 ? 0 : this.cm.getLine(pos.line).length)) {
	        return CodeMirror.Pass;
	      }
	
	      this.view.focus();
	      var targetPos = this.getPos() + (dir < 0 ? 0 : this.node.nodeSize);
	      var selection = prosemirrorState.Selection.near(this.view.state.doc.resolve(targetPos), dir);
	      this.view.dispatch(this.view.state.tr.setSelection(selection).scrollIntoView());
	      this.view.focus();
	    }
	  }, {
	    key: 'selectAllContent',
	    value: function selectAllContent() {
	      this.cm.focus();
	      this.cm.execCommand('selectAll');
	    }
	  }, {
	    key: 'selectAll',
	    value: function selectAll() {
	      var _view3 = this.view,
	          state = _view3.state,
	          dispatch = _view3.dispatch;
	
	      var allSelection = new prosemirrorState.AllSelection(state.doc);
	      this.view.focus();
	      dispatch(state.tr.setSelection(allSelection));
	    }
	  }, {
	    key: 'update',
	    value: function update(node) {
	      if (node.type !== this.node.type) return false;
	      this.node = node;
	      var change = computeChange(this.cm.getValue(), node.textContent);
	
	      if (change) {
	        this.updating = true;
	        this.cm.replaceRange(change.text, this.cm.posFromIndex(change.from), this.cm.posFromIndex(change.to));
	        this.updating = false;
	      }
	
	      return true;
	    }
	  }, {
	    key: 'selectNode',
	    value: function selectNode() {
	      this.cm.focus();
	    }
	  }, {
	    key: 'stopEvent',
	    value: function stopEvent() {
	      return true;
	    }
	  }]);
	  return CodeBlockView;
	}();
	
	var createPlugin = function createPlugin(store) {
	  return new prosemirrorState.Plugin({
	    props: {
	      decorations: function decorations(state) {
	        var selection = state.selection,
	            schema = state.schema,
	            doc = state.doc;
	        var from = selection.from,
	            to = selection.to,
	            $from = selection.$from;
	        var code_block = schema.nodes.code_block;
	
	        var node = doc.nodeAt(from);
	        var code = index_js.findParentNode($from.path, function (item) {
	          return item.type && item.type.name === "code_block";
	        });
	
	        if (code) {
	          var attrs = {
	            class: "ct-code-show"
	          };
	          var deco = prosemirrorView.Decoration.node(code.pos, code.pos + code.node.nodeSize, attrs);
	          return prosemirrorView.DecorationSet.create(state.doc, [deco]);
	        }
	
	        if (node && node.type === code_block && from + node.nodeSize === to) {
	          var _deco = prosemirrorView.Decoration.node(from, to, {
	            nodeName: "div",
	            class: "ct-code-selected"
	          });
	          return prosemirrorView.DecorationSet.create(doc, [_deco]);
	        }
	
	        return prosemirrorView.DecorationSet.empty;
	      },
	      nodeViews: {
	        code_block: function code_block(node, view, getPos) {
	          return new CodeBlockView(node, view, getPos, store);
	        }
	      }
	    }
	  });
	};
	
	function arrowHandler(dir) {
	  return function (state, dispatch, view) {
	    if (state.selection.empty && view.endOfTextblock(dir)) {
	      var side = dir === 'left' || dir === 'up' ? -1 : 1;
	      var $head = state.selection.$head;
	      var nextPos = prosemirrorState.Selection.near(state.doc.resolve(side > 0 ? $head.after() : $head.before()), side);
	
	      if (nextPos.$head && nextPos.$head.parent.type.name === 'code_block') {
	        dispatch(state.tr.setSelection(nextPos));
	        return true;
	      }
	    }
	
	    return false;
	  };
	}
	
	function createKeymap() {
	  return keymap({
	    ArrowLeft: arrowHandler('left'),
	    ArrowRight: arrowHandler('right'),
	    ArrowUp: arrowHandler('up'),
	    ArrowDown: arrowHandler('down')
	  });
	}
	
	var CodeStore = function () {
	  function CodeStore() {
	    (0, _classCallCheck3.default)(this, CodeStore);
	  }
	
	  (0, _createClass3.default)(CodeStore, [{
	    key: 'init',
	    value: function init(editor) {
	      this.trigger = editor.trigger;
	    }
	  }]);
	  return CodeStore;
	}();
	
	var css$3 = ".ct-code{min-width:233px;margin:5px 0;font-size:14px;border:1px solid #ddd;border-radius:2px 2px;background:#fcfcfc;font-family:monospace;line-height:21px}.ct-code .header{display:flex;position:relative;width:100%;height:30px;padding:0 10px;background:#f2f2f2;box-sizing:border-box}.ct-code .header .title{flex:1;padding-left:22px;line-height:30px;font-size:12px;font-weight:700;color:#333;cursor:pointer;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ct-code .header .title:before{content:\"\";position:absolute;left:14px;top:11px;width:8px;height:8px;background:url(\"data:image/svg+xml;base64,PHN2ZyBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iOCIgaGVpZ2h0PSI4Ij48ZGVmcz48c3R5bGUvPjwvZGVmcz48cGF0aCBkPSJNMzc1Ljk2NyAzMTAuMDI2TDI4LjIwNyA2NDIuODFhODkuMzQgODkuMzQgMCAwIDAgMCAxMzAuMTcgOTkuMzIzIDk5LjMyMyAwIDAgMCAxMzYuMDU4IDBsMzQ3Ljc2LTMzMi42NTcgMzQ3Ljc1OSAzMzIuNzg1YTk5LjMyMyA5OS4zMjMgMCAwIDAgMTM2LjA1NyAwIDg5LjM0IDg5LjM0IDAgMCAwIDAtMTMwLjE3bC0zNDcuNzYtMzMyLjc4NC02NS45MTYtNTkuMzlhMTA1LjcyMyAxMDUuNzIzIDAgMCAwLTE0MC4yODEgMGwtNjUuOTE3IDU5LjM5eiIgZmlsbD0iIzc0NzI3MiIvPjwvc3ZnPg==\") no-repeat 0 0;transition:-webkit-transform .2s;transition:transform .2s;transition:transform .2s,-webkit-transform .2s}.ct-code .header .collapse:before{-webkit-transform:rotate(-180deg);transform:rotate(-180deg)}.ct-code .header .icon-loading:before{border-radius:50%;border:1px solid #d5d5d5;border-bottom-color:transparent;background:none;transition:none;-webkit-animation:loading .8s linear infinite;animation:loading .8s linear infinite}.ct-code .header .language{width:120px;height:30px;line-height:30px;text-align:right;font-size:12px;color:#999}@-webkit-keyframes loading{0%{-webkit-transform:rotate(0);transform:rotate(0)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes loading{0%{-webkit-transform:rotate(0);transform:rotate(0)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}.ct-code[data-language=plantuml]:before{content:\"plantUML宏\";display:block;padding:10px 20px 0;font-size:12px;background:#fafafa}.ct-code[data-language=plantuml]>*{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;pointer-events:none}@media print{.CodeMirror .CodeMirror-sizer{min-width:100%!important;max-width:100%!important}.CodeMirror .CodeMirror-sizer .CodeMirror-line{white-space:pre-wrap!important}}";
	styleInject(css$3);
	
	var CodeViewer = function (_preact$Component2) {
	  (0, _inherits3.default)(CodeViewer, _preact$Component2);
	
	  function CodeViewer(props) {
	    (0, _classCallCheck3.default)(this, CodeViewer);
	
	    var _this5 = (0, _possibleConstructorReturn3.default)(this, (CodeViewer.__proto__ || (0, _getPrototypeOf2.default)(CodeViewer)).call(this));
	
	    _this5.container = null;
	    _this5.cm = null;
	
	    _this5.initCodeViewer = function () {
	      var _this5$props$data = _this5.props.data,
	          _this5$props$data$val = _this5$props$data.value,
	          value = _this5$props$data$val === undefined ? '' : _this5$props$data$val,
	          language = _this5$props$data.language,
	          theme = _this5$props$data.theme;
	
	      var _index_js$getSystemIn = index_js.getSystemInfo(),
	          isMobile = _index_js$getSystemIn.isMobile;
	
	      var inputStyle = isMobile ? 'textarea' : 'contenteditable';
	      var readOnly = isMobile ? true : 'nocursor';
	      var cm = new CodeMirror(_this5.container, {
	        value: value,
	        tabSize: 2,
	
	        cursorBlinkRate: -1,
	        inputStyle: inputStyle,
	        readOnly: readOnly,
	        theme: theme,
	
	        matchBrackets: true,
	
	        mode: getMode(language)
	      });
	      _this5.cm = cm;
	
	      cm.on('cut', function (c, e) {
	        e.preventDefault();
	      });
	
	      _this5.$cm = cm.getWrapperElement();
	
	      if (isMobile) {
	        _this5.$cm.querySelector('textarea').setAttribute('disabled', 'true');
	      }
	
	      _this5.$cm.style.cssText = !_this5.state.isExpand ? 'height:0.1px !important' : 'height:auto !important';
	      _this5.setState({
	        isInit: true
	      });
	    };
	
	    _this5.handleClick = function () {
	      if (!_this5.$cm) {
	        _this5.setState({
	          isInit: false
	        }, function () {
	          setTimeout(function () {
	            _this5.initCodeViewer();
	          }, 20);
	        });
	      } else {
	        _this5.$cm.style.cssText = _this5.state.isExpand ? 'height:0.1px !important' : 'height:auto !important';
	        _this5.setState({
	          isExpand: !_this5.state.isExpand
	        }, function () {
	          if (_this5.cm) {
	            _this5.cm.refresh();
	          }
	        });
	      }
	    };
	
	    _this5.state = {
	      isExpand: props.data.isExpand,
	      isInit: null
	    };
	    return _this5;
	  }
	
	  (0, _createClass3.default)(CodeViewer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var zoomCallback = this.props.zoomCallback;
	
	      this.initCodeViewer();
	      zoomCallback(this.$cm);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      var _state2 = this.state,
	          isInit = _state2.isInit,
	          isExpand = _state2.isExpand;
	      var _props$data = this.props.data,
	          title = _props$data.title,
	          language = _props$data.language;
	
	      var iconClass = isInit === false ? 'icon-loading' : isExpand ? '' : 'collapse';
	      return preact.h("div", null, preact.h("div", {
	        key: "header",
	        className: "header"
	      }, preact.h("div", {
	        className: 'title ' + iconClass,
	        onClick: this.handleClick
	      }, title), preact.h("div", {
	        className: "language"
	      }, language), !isExpand && preact.h("div", {
	        className: "isNotExpand"
	      })), preact.h("div", {
	        key: "viewer",
	        ref: function ref(refs) {
	          _this6.container = refs;
	        }
	      }));
	    }
	  }]);
	  return CodeViewer;
	}(preact.Component);
	
	function handler(node, zoomCallback) {
	  var codeNode = node.querySelector('code');
	  if (!codeNode) return;
	  var _node$dataset = node.dataset,
	      _node$dataset$languag = _node$dataset.language,
	      language = _node$dataset$languag === undefined ? DEFAULT_LANGUAGE : _node$dataset$languag,
	      _node$dataset$theme = _node$dataset.theme,
	      theme = _node$dataset$theme === undefined ? DEFAULT_THEME : _node$dataset$theme,
	      _node$dataset$title = _node$dataset.title,
	      title = _node$dataset$title === undefined ? DEFAULT_TITLE : _node$dataset$title;
	
	  var isExpand = node.getAttribute('data-expand') !== 'false';
	  var data = {
	    language: language,
	    theme: theme,
	    title: title,
	    isExpand: isExpand,
	    value: codeNode.textContent
	  };
	  node.innerHTML = '';
	  preact.render(preact.h(CodeViewer, {
	    data: data,
	    zoomCallback: zoomCallback
	  }), node);
	
	  var attrs = ['data-language', 'data-theme', 'data-title', 'data-expand', 'spellcheck'];
	  attrs.forEach(function (attr) {
	    node.removeAttribute(attr);
	  });
	}
	
	
	function renderPlantUML() {
	  var plantUmlUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'https://km.sankuai.com/plantuml/svg/';
	  var node = arguments[1];
	
	  var codeNode = node.querySelector('code');
	
	  if (!codeNode) {
	    return;
	  }
	
	  var content = codeNode.innerText;
	  var encoded = plantumlEncoder.encode(content);
	  var umlUrl = '' + plantUmlUrl + encoded;
	  var newNode = document.createElement('span');
	  newNode.setAttribute('class', 'ct-image');
	  var imageNode = new Image();
	  imageNode.setAttribute('src', umlUrl);
	  imageNode.setAttribute('data-src', umlUrl);
	  newNode.appendChild(imageNode);
	  node.parentNode.replaceChild(newNode, node);
	}
	
	var codeToView = function codeToView(_ref4) {
	  var bodyWrapper = _ref4.bodyWrapper,
	      zoomCallback = _ref4.zoomCallback;
	
	  var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
	    plantUmlUrl: 'http://www.plantuml.com/plantuml/svg/'
	  },
	      plantUmlUrl = _ref5.plantUmlUrl;
	
	  var codeBlockNodes = bodyWrapper.querySelectorAll('.ct-code');
	  codeBlockNodes.forEach(function (node) {
	    if (node.getAttribute('data-diff-ignore')) {
	      return;
	    }
	
	    var language = node.getAttribute('data-language') || '';
	
	    if (language.toLowerCase() === 'plantuml') {
	      renderPlantUML(plantUmlUrl, node);
	    } else {
	      handler(node, zoomCallback);
	    }
	  });
	};
	
	var CodeModule = function () {
	  function CodeModule() {
	    (0, _classCallCheck3.default)(this, CodeModule);
	
	    this.name = "code";
	    this.schema = schema;
	    this.store = new CodeStore();
	    this.commands = {
	      insert: insert
	    };
	    this.plugins = [createKeymap(), createPlugin(this.store)];
	    this.utils = {
	      isInCode: isInCode
	    };
	  }
	
	  (0, _createClass3.default)(CodeModule, [{
	    key: 'init',
	    value: function init(editor) {
	      this.store.init(editor);
	    }
	  }]);
	  return CodeModule;
	}();
	
	CodeModule.moduleName = "code";
	
	exports.CodeModule = CodeModule;
	exports.codeToView = codeToView;

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classCallCheck2 = __webpack_require__(7);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _getOwnPropertyDescriptor = __webpack_require__(23);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getOwnPropertySymbols = __webpack_require__(16);
	
	var _getOwnPropertySymbols2 = _interopRequireDefault(_getOwnPropertySymbols);
	
	var _keys = __webpack_require__(13);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _defineProperty2 = __webpack_require__(15);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _typeof2 = __webpack_require__(8);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault(ex) {
	  return ex && (typeof ex === 'undefined' ? 'undefined' : (0, _typeof3.default)(ex)) === 'object' && 'default' in ex ? ex['default'] : ex;
	}
	
	var keymap = _interopDefault(__webpack_require__(34));
	var index_js = __webpack_require__(22);
	__webpack_require__(29);
	__webpack_require__(25);
	var prosemirrorModel = __webpack_require__(12);
	var prosemirrorState = __webpack_require__(6);
	var prosemirrorView = __webpack_require__(48);
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    (0, _defineProperty3.default)(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	var defineProperty = _defineProperty;
	
	function _objectSpread(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? arguments[i] : {};
	    var ownKeys = (0, _keys2.default)(source);
	
	    if (typeof _getOwnPropertySymbols2.default === 'function') {
	      ownKeys = ownKeys.concat((0, _getOwnPropertySymbols2.default)(source).filter(function (sym) {
	        return (0, _getOwnPropertyDescriptor2.default)(source, sym).enumerable;
	      }));
	    }
	
	    ownKeys.forEach(function (key) {
	      defineProperty(target, key, source[key]);
	    });
	  }
	
	  return target;
	}
	
	var objectSpread = _objectSpread;
	
	function uuid() {
	  var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
	  var id = [];
	
	  for (var i = 0; i < 8; i++) {
	    id.push(chars[parseInt(Math.random() * chars.length, 10)]);
	  }
	
	  return id.join('');
	}
	
	var collapseSchema = {
	  nodes: {
	    collapse: {
	      group: 'block',
	      content: 'collapse_title collapse_content',
	      isolating: true,
	      allowGapCursor: true,
	      dragBlock: true,
	      insertBlock: true,
	      braceWidth: 300,
	      attrs: {
	        active: {
	          default: true
	        },
	        dataDiffId: {
	          default: null
	        }
	      },
	      parseDOM: [{
	        tag: 'div[class~="ct-collapse"]',
	
	        getAttrs: function getAttrs(dom) {
	          var dataDiffId = dom.getAttribute('data-diff-id');
	          return {
	            active: dom.classList.contains('active'),
	            dataDiffId: dataDiffId
	          };
	        }
	      }],
	
	      toDOM: function toDOM(node) {
	        var _node$attrs = node.attrs,
	            active = _node$attrs.active,
	            dataDiffId = _node$attrs.dataDiffId;
	
	        var nodeAttrs = {
	          class: 'ct-collapse' + (active ? ' active' : ''),
	          'data-diff-id': dataDiffId || 'ct-diff-id-' + uuid()
	        };
	        return ['div', nodeAttrs, 0];
	      }
	    },
	    collapse_title: {
	      content: 'text*',
	      draggable: false,
	      isolating: true,
	      alignBlock: true,
	      attrs: {
	        align: {
	          default: 'left'
	        }
	      },
	      parseDOM: [{
	        tag: 'div[class~="ct-collapse-title"]',
	        getAttrs: function getAttrs(dom) {
	          return {
	            align: dom.style.textAlign
	          };
	        }
	      }],
	
	      toDOM: function toDOM(node) {
	        var align = node.attrs.align;
	
	        var attrs = {
	          class: 'ct-collapse-title'
	        };
	
	        if (align && align !== 'left') {
	          attrs.style = 'text-align: ' + align + ';';
	        }
	
	        return ['div', attrs, ['span', {
	          class: 'ct-collapse-title-text',
	          spellCheck: false
	        }, 0]];
	      }
	    },
	    collapse_content: {
	      content: 'block+',
	      isolating: true,
	      attrs: {},
	      parseDOM: [{
	        tag: 'div[class~="ct-collapse-content"]'
	      }],
	
	      toDOM: function toDOM() {
	        var nodeAttrs = {
	          class: 'ct-collapse-content'
	        };
	        return ['div', nodeAttrs, 0];
	      }
	    }
	  }
	};
	
	function getTitleSelection(tr) {
	  var titlePos = void 0;
	  var addNum = 1;
	  var titleSelection = void 0;
	
	  var getTitle = function getTitle() {
	    titlePos = tr.selection.$from.pos + addNum++;
	    titleSelection = prosemirrorState.TextSelection.create(tr.doc, titlePos);
	
	    if (titleSelection.$from.nodeBefore && titleSelection.$from.nodeBefore.type.name === "collapse_title") {
	      titleSelection = prosemirrorState.TextSelection.create(tr.doc, titlePos - 1);
	      return titleSelection;
	    }
	
	    var collapseTitle = index_js.findParentNode(titleSelection.$from.path, function (item) {
	      return item.type && item.type.name === "collapse_title";
	    });
	
	    if (!collapseTitle && addNum < 4) {
	      return getTitle();
	    }
	
	    return titleSelection;
	  };
	
	  return getTitle();
	}
	
	function insert() {
	  return function (state, dispatch, view, trigger) {
	    var schema = state.schema;
	    var _schema$nodes = schema.nodes,
	        collapse = _schema$nodes.collapse,
	        collapse_title = _schema$nodes.collapse_title,
	        collapse_content = _schema$nodes.collapse_content;
	
	    var titleNode = collapse_title.createAndFill();
	    var contentNode = collapse_content.createAndFill();
	    var collapseNode = collapse.create(null, prosemirrorModel.Fragment.from([titleNode, contentNode]));
	
	    var _index_js$insertBlock = index_js.insertBlock(state, collapseNode),
	        transaction = _index_js$insertBlock.transaction;
	
	    if (!transaction) {
	      return false;
	    }
	
	    var newSelection = getTitleSelection(transaction);
	    transaction.setSelection(newSelection);
	    transaction.insertText("点击展开内容", newSelection.from);
	    dispatch(transaction.scrollIntoView());
	    view.focus();
	
	    if (typeof trigger === "function") {
	      trigger("afterInsert", {
	        draggable: true,
	        braceWidth: 300
	      });
	    }
	
	    return true;
	  };
	}
	
	var handleClick = function handleClick(view, pos, e) {
	  var isTitle = e.target.classList.contains('ct-collapse-title-text');
	  var dis = e.clientX - e.target.getBoundingClientRect().left;
	
	  if (isTitle && dis > 2 && dis < 20) {
	    var state = view.state,
	        dispatch = view.dispatch;
	    var selection = state.selection,
	        tr = state.tr;
	    var $from = selection.$from;
	
	    var collapse = index_js.findParentNode($from.path, function (item) {
	      return item.type && item.type.name === 'collapse';
	    });
	
	    if (collapse) {
	      var attrs = collapse.node.attrs;
	      dispatch(tr.setNodeMarkup(collapse.pos, null, objectSpread({}, attrs, {
	        active: !attrs.active
	      })).scrollIntoView());
	    }
	  }
	
	  return false;
	};
	
	var pluginKey = new prosemirrorState.PluginKey('collapse');
	function createPlugin() {
	  return new prosemirrorState.Plugin({
	    key: pluginKey,
	    props: {
	      handleClick: handleClick,
	      decorations: function decorations(state) {
	        var selection = state.selection;
	        var $from = selection.$from;
	
	        var collapse = index_js.findParentNode($from.path, function (item) {
	          return item.type && item.type.name === 'collapse';
	        });
	
	        if (collapse) {
	          var attrs = {
	            nodeName: 'div',
	            class: 'ct-collapse-show'
	          };
	          var deco = prosemirrorView.Decoration.node(collapse.pos, collapse.pos + collapse.node.nodeSize, attrs);
	          return prosemirrorView.DecorationSet.create(state.doc, [deco]);
	        }
	      },
	      handleDrop: function handleDrop(view, event, slice, moved) {
	        try {
	          var status = view.state.schema.nodes.status;
	
	
	          if (event.target.classList.contains("ct-collapse")) {
	            return true;
	          }
	
	          if (event.target.closest(".ct-collapse-title")) {
	            var content = slice.content.content;
	
	            if (content.length > 1) {
	              return true;
	            }
	
	            if (content[0].isTextblock && content[0].content.content.length === 1) {
	              return false;
	            }
	
	            if (content[0].isBlock || content[0].type === status) {
	              return true;
	            }
	          }
	        } catch (err) {}
	      }
	    }
	  });
	}
	
	var handleBackspace = index_js.handleBackspaceCreator('collapse', 'collapse_title', 'collapse_content');
	var handleDelete = index_js.handleDeleteCreator('collapse', 'collapse_title', 'collapse_content');
	var handleTab = index_js.handleTabCreator('collapse', 'collapse_title', 'collapse_content');
	var handleEnter = index_js.handleEnterCreator('collapse', 'collapse_title', 'collapse_content');
	
	function handleClick$1(e) {
	  var $target = e.target;
	  if (!$target.closest('.ct-collapse-title')) return;
	  var ctCollapse = $target.closest('.ct-collapse');
	
	  var cls = ctCollapse.classList;
	
	  if (ctCollapse.getAttribute('data-diff-ignore')) {
	    return;
	  }
	
	  if (!cls.contains('ct-collapse')) {
	    return;
	  }
	
	  if (cls.contains('active')) {
	    cls.remove('active');
	  } else {
	    cls.add('active');
	  }
	
	  e.stopPropagation();
	  e.preventDefault();
	}
	
	function compatiOldData(node) {
	  var title = node.querySelector('.ct-collapse-title');
	  var titleText = node.querySelector('.ct-collapse-title .ct-collapse-title-text');
	
	  if (!titleText && title) {
	    var newText = document.createElement('span');
	    newText.className = 'ct-collapse-title-text';
	    newText.innerHTML = title.innerHTML;
	    var childNode = title.childNodes[0];
	    childNode && title.removeChild(childNode);
	    title.appendChild(newText);
	  }
	}
	
	function toView(_ref) {
	  var bodyWrapper = _ref.bodyWrapper;
	
	  var nodeList = bodyWrapper.querySelectorAll('.ct-collapse');
	
	  if (nodeList.length) {
	    nodeList.forEach(function (node) {
	      node.addEventListener('click', handleClick$1, false);
	      compatiOldData(node);
	    });
	  }
	}
	
	function styleInject(css, ref) {
	  if (ref === void 0) ref = {};
	  var insertAt = ref.insertAt;
	
	  if (!css || typeof document === 'undefined') {
	    return;
	  }
	
	  var head = document.head || document.getElementsByTagName('head')[0];
	  var style = document.createElement('style');
	  style.type = 'text/css';
	
	  if (insertAt === 'top') {
	    if (head.firstChild) {
	      head.insertBefore(style, head.firstChild);
	    } else {
	      head.appendChild(style);
	    }
	  } else {
	    head.appendChild(style);
	  }
	
	  if (style.styleSheet) {
	    style.styleSheet.cssText = css;
	  } else {
	    style.appendChild(document.createTextNode(css));
	  }
	}
	
	var css = ".ct-collapse{min-width:267px;margin:8px 0;padding:8px;border-radius:2px}.ct-collapse .ct-collapse-title{line-height:16px}.ct-collapse .ct-collapse-title>.ct-collapse-title-text{position:relative;padding-left:24px;color:#333;font-family:PingFangSC-Medium;font-size:13px;vertical-align:top}.ct-collapse .ct-collapse-title>.ct-collapse-title-text:before{position:absolute;top:2px;left:3px;content:\"\";width:16px;height:16px;background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg class='icon' viewBox='0 0 1024 1024' xmlns='http://www.w3.org/2000/svg' width='8' height='8'%3E%3Cdefs%3E%3Cstyle/%3E%3C/defs%3E%3Cpath d='M375.967 310.026L28.207 642.81a89.34 89.34 0 0 0 0 130.17 99.323 99.323 0 0 0 136.058 0l347.76-332.657 347.759 332.785a99.323 99.323 0 0 0 136.057 0 89.34 89.34 0 0 0 0-130.17l-347.76-332.784-65.916-59.39a105.723 105.723 0 0 0-140.281 0l-65.917 59.39z' fill='%23747272'/%3E%3C/svg%3E\") no-repeat 50%;-webkit-transform:rotate(-180deg);transform:rotate(-180deg);transition:-webkit-transform .2s;transition:transform .2s;transition:transform .2s,-webkit-transform .2s;cursor:pointer}.ct-collapse.active>.ct-collapse-title{padding-bottom:8px}.ct-collapse.active>.ct-collapse-title .ct-collapse-title-text:before{-webkit-transform:rotate(0deg);transform:rotate(0deg)}.ct-collapse.active>.ct-collapse-content{display:block;height:auto;padding:8px 24px;border-radius:2px}.ct-collapse>.ct-collapse-content{height:.1px;padding:0;background:transparent;overflow:hidden}.ProseMirror .ct-collapse{overflow:hidden}.ProseMirror .ct-collapse.active>.ct-collapse-content{display:block;height:auto;border-radius:2px}.ProseMirror .ct-collapse>.ct-collapse-content{display:none;overflow:unset}.ProseMirror .ct-collapse:hover{background-color:#f6f6f6}.ProseMirror .ct-collapse:hover>.ct-collapse-content{background-color:#fff}.ProseMirror .ct-collapse-show>.ct-collapse{background-color:#f6f6f6;border:1px solid #ddd}.ProseMirror .ct-collapse-show>.ct-collapse>.ct-collapse-content{background-color:#f6f6f6}.ProseMirror .ct-collapse-show>.active>.ct-collapse-content{background-color:#fff;border:1px solid #ddd}.ProseMirror-selectednode.ct-collapse{border:1px solid #1c6cdc}.pm-body-wrapper .ct-collapse-title-text{cursor:pointer}";
	styleInject(css);
	
	var CollapseModule = function CollapseModule() {
	  (0, _classCallCheck3.default)(this, CollapseModule);
	
	  this.name = 'collapse';
	  this.schema = collapseSchema;
	  this.commands = {
	    insert: insert
	  };
	  this.plugins = [createPlugin(), keymap({
	    Backspace: handleBackspace,
	    'Mod-Backspace': handleBackspace,
	    Delete: handleDelete,
	    'Mod-Delete': handleDelete,
	    Tab: handleTab,
	    Enter: handleEnter
	  })];
	};
	
	CollapseModule.moduleName = 'collapse';
	
	exports.CollapseModule = CollapseModule;
	exports.collapseToView = toView;

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classCallCheck2 = __webpack_require__(7);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(10);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var prosemirrorState = __webpack_require__(6);
	
	var createPlugins = function createPlugins(module) {
	  var eventHandler = function eventHandler(data, type) {
	    var editor = module.editor;
	
	    if (editor) {
	      editor.emit(type, data);
	    }
	
	    return false;
	  };
	
	  var plugin = new prosemirrorState.Plugin({
	    key: new prosemirrorState.PluginKey("core"),
	    state: {
	      init: function init() {
	        return 0;
	      },
	      apply: function apply(tr) {
	        eventHandler(tr, "update");
	
	        if (tr.docChanged) {
	          eventHandler(tr, "change");
	        }
	
	        return 0;
	      }
	    },
	    props: {
	      handleClick: function handleClick(v, p, e) {
	        return eventHandler(e, "click");
	      },
	      handleDoubleClick: function handleDoubleClick(v, p, e) {
	        return eventHandler(e, "doubleClick");
	      },
	      handleTripleClick: function handleTripleClick(v, p, e) {
	        return eventHandler(e, "tripleClick");
	      },
	      handleKeyDown: function handleKeyDown(v, e) {
	        return eventHandler(e, "keydown");
	      },
	      handleKeyPress: function handleKeyPress(v, e) {
	        return eventHandler(e, "keypress");
	      },
	      handleTextInput: function handleTextInput(v, f, t, text) {
	        return eventHandler(text, "textinput");
	      },
	      handleScrollToSelection: function handleScrollToSelection() {
	        return eventHandler(null, "scrolltoslelection");
	      },
	      handlePaste: function handlePaste(v, e, slice) {
	        return eventHandler({
	          event: e,
	          slice: slice
	        }, "paste");
	      },
	      handleDrop: function handleDrop(v, e, slice) {
	        return eventHandler({
	          event: e,
	          slice: slice
	        }, "drop");
	      }
	    },
	    view: function view() {
	      return {
	        destroy: function destroy() {
	          return eventHandler(null, "destroy");
	        }
	      };
	    }
	  });
	  return [plugin];
	};
	
	var CoreModule = function () {
	  function CoreModule() {
	    (0, _classCallCheck3.default)(this, CoreModule);
	
	    this.name = "core";
	    this.plugins = [];
	    this.editor = null;
	    this.plugins = createPlugins(this);
	  }
	
	  (0, _createClass3.default)(CoreModule, [{
	    key: 'init',
	    value: function init(editor) {
	      this.editor = editor;
	    }
	  }]);
	  return CoreModule;
	}();
	
	CoreModule.moduleName = "core";
	
	exports.CoreModule = CoreModule;

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _getPrototypeOf = __webpack_require__(30);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(7);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(10);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(32);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(31);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var preact = __webpack_require__(24);
	var prosemirrorState = __webpack_require__(6);
	var index_js = __webpack_require__(22);
	
	var TABLE_SELECTOR = ".ct-table-wrapper";
	var findAllTables = function findAllTables(dom) {
	  var result = [];
	  var closestTable = dom.closest(TABLE_SELECTOR);
	  var count = 0;
	
	  while (closestTable && count < 10) {
	    result.push(closestTable);
	    closestTable = closestTable.parentNode.closest(TABLE_SELECTOR);
	    count += 1;
	  }
	
	  return result;
	};
	
	function styleInject(css, ref) {
	  if (ref === void 0) ref = {};
	  var insertAt = ref.insertAt;
	
	  if (!css || typeof document === 'undefined') {
	    return;
	  }
	
	  var head = document.head || document.getElementsByTagName('head')[0];
	  var style = document.createElement('style');
	  style.type = 'text/css';
	
	  if (insertAt === 'top') {
	    if (head.firstChild) {
	      head.insertBefore(style, head.firstChild);
	    } else {
	      head.appendChild(style);
	    }
	  } else {
	    head.appendChild(style);
	  }
	
	  if (style.styleSheet) {
	    style.styleSheet.cssText = css;
	  } else {
	    style.appendChild(document.createTextNode(css));
	  }
	}
	
	var css = ".ct-drag-button{z-index:50;position:absolute;text-align:center;line-height:28px;cursor:-webkit-grab;width:30px;height:30px;background:url(\"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSIxNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNi41IDBhMS41IDEuNSAwIDEgMSAwIDMgMS41IDEuNSAwIDAgMSAwLTN6bTAgNi41YTEuNSAxLjUgMCAxIDEgMCAzIDEuNSAxLjUgMCAwIDEgMC0zem0tMS41IDhhMS41IDEuNSAwIDEgMSAzIDAgMS41IDEuNSAwIDAgMS0zIDB6TTEuNSAwYTEuNSAxLjUgMCAxIDEgMCAzIDEuNSAxLjUgMCAwIDEgMC0zem0wIDYuNWExLjUgMS41IDAgMSAxIDAgMyAxLjUgMS41IDAgMCAxIDAtM3ptMCA2LjVzLS44MjggMCAwIDBhMS41IDEuNSAwIDEgMSAwIDMgMS41IDEuNSAwIDAgMSAwLTN6IiBmaWxsPSIjQjBCMEIwIiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48L3N2Zz4=\") no-repeat 50%}";
	styleInject(css);
	
	var BUTTON_WIDTH = 30;
	
	var Button = function (_preact$Component) {
	  (0, _inherits3.default)(Button, _preact$Component);
	
	  function Button(props) {
	    (0, _classCallCheck3.default)(this, Button);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Button.__proto__ || (0, _getPrototypeOf2.default)(Button)).call(this, props));
	
	    _this.tables = [];
	
	    _this.handleScroll = function (e) {
	      _this.setState(_this.props.getPosition());
	    };
	
	    _this.state = _this.props.getPosition();
	    return _this;
	  }
	
	  (0, _createClass3.default)(Button, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var dom = this.props.dom;
	
	      this.tables = findAllTables(dom);
	      this.tables.forEach(function (table) {
	        table.addEventListener("scroll", _this2.handleScroll);
	      });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var _this3 = this;
	
	      this.tables.forEach(function (table) {
	        table.removeEventListener("scroll", _this3.handleScroll);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          getPosition = _props.getPosition,
	          onDragStart = _props.onDragStart,
	          onClick = _props.onClick;
	
	      var _getPosition = getPosition(),
	          left = _getPosition.left,
	          top = _getPosition.top;
	
	      return preact.h("div", {
	        className: "ct-drag-button",
	        draggable: true,
	        style: {
	          left: left - BUTTON_WIDTH,
	          top: top
	        },
	        onDragStart: onDragStart,
	        onClick: onClick
	      });
	    }
	  }]);
	  return Button;
	}(preact.Component);
	
	var DRAG_BUTTON_SCHEMA_PROPS_NAME = "dragBlock";
	
	var hasButton = function hasButton(node) {
	  return node.type.schema.nodes[node.type.name].spec[DRAG_BUTTON_SCHEMA_PROPS_NAME];
	};
	var getSelection = function getSelection(doc, from, to) {
	  var node = doc.nodeAt(from);
	
	  if (node.type.name === "code_block") {
	    return prosemirrorState.TextSelection.create(doc, from, to);
	  }
	
	  return prosemirrorState.NodeSelection.create(doc, from);
	};
	
	var _index_js$getSystemIn = index_js.getSystemInfo(),
	    os = _index_js$getSystemIn.os;
	
	var dragCopyModifier = /MAC/.test(os.toUpperCase()) ? "altKey" : "ctrlKey";
	
	var View = function () {
	  function View(_editorView) {
	    var _this4 = this;
	
	    (0, _classCallCheck3.default)(this, View);
	
	    this.$popover = document.createElement("div");
	    this.$editor = void 0;
	
	    this.destroy = function () {
	      _this4.$popover.remove();
	    };
	
	    this.update = function (editorView) {
	      var selection = editorView.state.selection;
	
	
	      if (selection instanceof prosemirrorState.NodeSelection) {
	        if (hasButton(selection.node)) {
	          _this4.showButton(editorView, selection);
	          return;
	        }
	      }
	
	      if (selection instanceof prosemirrorState.TextSelection) {
	        var resolvedPos = selection.$from;
	        var nodeMaybe = resolvedPos.doc.nodeAt(selection.from);
	
	        if (nodeMaybe && hasButton(nodeMaybe)) {
	          var container = prosemirrorState.NodeSelection.create(resolvedPos.doc, selection.from);
	          _this4.showButton(editorView, container);
	          return;
	        }
	
	        for (var d = resolvedPos.depth; d >= 0; d--) {
	          if (hasButton(resolvedPos.node(d))) {
	            var _container = prosemirrorState.NodeSelection.create(resolvedPos.doc, resolvedPos.before(d));
	            _this4.showButton(editorView, _container);
	            return;
	          }
	        }
	      }
	
	      _this4.hideButton();
	    };
	
	    this.handleDragStart = function (editorView, from, to) {
	      return function (event) {
	        var dispatch = editorView.dispatch,
	            state = editorView.state;
	
	        var dragDOM = editorView.nodeDOM(from);
	        var selection = getSelection(state.doc, from, to);
	        var slice = selection.content();
	        event.dataTransfer.setDragImage(dragDOM, 0, 0);
	        editorView.dragging = {
	          slice: slice,
	          move: !event[dragCopyModifier]
	        };
	        dispatch(state.tr.setSelection(selection));
	      };
	    };
	
	    this.handleClick = function (editorView, from, to) {
	      return function () {
	        var dispatch = editorView.dispatch,
	            state = editorView.state;
	
	        var selection = getSelection(state.doc, from, to);
	        dispatch(state.tr.setSelection(selection));
	        editorView.focus();
	      };
	    };
	
	    this.$popover.classList.add("ct-drag-button-popover");
	    this.$editor = _editorView.dom.parentElement;
	    this.$editor.appendChild(this.$popover);
	  }
	
	  (0, _createClass3.default)(View, [{
	    key: 'hideButton',
	    value: function hideButton() {
	      preact.render(null, this.$popover, this.$popover.lastElementChild || undefined);
	    }
	  }, {
	    key: 'showButton',
	    value: function showButton(editorView, selection) {
	      var _this5 = this;
	
	      var from = selection.from,
	          to = selection.to;
	
	      var dom = editorView.nodeDOM(from);
	      var buttonProps = {
	        onDragStart: this.handleDragStart(editorView, from, to),
	        onClick: this.handleClick(editorView, from, to),
	        dom: dom,
	        getPosition: function getPosition() {
	          var nodeDOM = editorView.nodeDOM(from);
	
	          var _$editor$getBoundingC = _this5.$editor.getBoundingClientRect(),
	              pl = _$editor$getBoundingC.left,
	              pt = _$editor$getBoundingC.top;
	
	          if (!nodeDOM) {
	            return {
	              left: pl,
	              top: pt
	            };
	          }
	
	          var _nodeDOM$getBoundingC = nodeDOM.getBoundingClientRect(),
	              cl = _nodeDOM$getBoundingC.left,
	              ct = _nodeDOM$getBoundingC.top;
	
	          return {
	            left: cl - pl,
	            top: ct - pt
	          };
	        }
	      };
	      preact.render(preact.h(Button, buttonProps), this.$popover, this.$popover.lastElementChild || undefined);
	    }
	  }]);
	  return View;
	}();
	
	var pluginKey = new prosemirrorState.PluginKey("dragButton");
	var createPlugin = function createPlugin() {
	  return new prosemirrorState.Plugin({
	    key: pluginKey,
	    view: function view(editorView) {
	      return new View(editorView);
	    }
	  });
	};
	
	var DragButtonModule = function DragButtonModule() {
	  (0, _classCallCheck3.default)(this, DragButtonModule);
	
	  this.name = "dragButton";
	  this.plugins = [createPlugin()];
	};
	
	DragButtonModule.pluginName = "dragButton";
	
	exports.DragButtonModule = DragButtonModule;

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classCallCheck2 = __webpack_require__(7);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _typeof2 = __webpack_require__(8);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault(ex) {
	  return ex && (typeof ex === 'undefined' ? 'undefined' : (0, _typeof3.default)(ex)) === 'object' && 'default' in ex ? ex['default'] : ex;
	}
	
	var prosemirrorHistory = __webpack_require__(183);
	var keymap = _interopDefault(__webpack_require__(34));
	
	function undoDepth(state) {
	  return prosemirrorHistory.undoDepth(state);
	}
	
	function redoDepth(state) {
	  return prosemirrorHistory.redoDepth(state);
	}
	function _redo(state, dispatch, view, trigger) {
	  var res = prosemirrorHistory.redo(state, dispatch, view);
	  if (typeof trigger === 'function') trigger('stateChanged');
	  return res;
	}
	function _undo(state, dispatch, view, trigger) {
	  var res = prosemirrorHistory.undo(state, dispatch, view);
	  if (typeof trigger === 'function') trigger('stateChanged');
	  return res;
	}
	
	var HistoryModule = function HistoryModule() {
	  (0, _classCallCheck3.default)(this, HistoryModule);
	
	  this.name = 'history';
	  this.commands = {
	    undo: function undo() {
	      return _undo;
	    },
	    redo: function redo() {
	      return _redo;
	    }
	  };
	  this.utils = {
	    undoDepth: undoDepth,
	    redoDepth: redoDepth
	  };
	  this.plugins = [keymap({
	    'Mod-z': _undo,
	    'Mod-y': _redo,
	    'Shift-Mod-z': _redo,
	    'Mod-Z': _undo,
	    'Mod-Y': _redo,
	    'Shift-Mod-Z': _redo
	  }), prosemirrorHistory.history()];
	};
	
	HistoryModule.moduleName = 'history';
	
	exports.HistoryModule = HistoryModule;

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _toConsumableArray2 = __webpack_require__(66);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _from = __webpack_require__(43);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _regenerator = __webpack_require__(40);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(39);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _promise = __webpack_require__(35);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _getPrototypeOf = __webpack_require__(30);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _createClass2 = __webpack_require__(10);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(32);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(31);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _getOwnPropertyDescriptor = __webpack_require__(23);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getOwnPropertySymbols = __webpack_require__(16);
	
	var _getOwnPropertySymbols2 = _interopRequireDefault(_getOwnPropertySymbols);
	
	var _keys = __webpack_require__(13);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _defineProperty2 = __webpack_require__(15);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(7);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _slicedToArray2 = __webpack_require__(65);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _entries = __webpack_require__(63);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var prosemirrorState = __webpack_require__(6);
	var prosemirrorView = __webpack_require__(48);
	var index_ts = __webpack_require__(96);
	var index_js = __webpack_require__(22);
	var preact = __webpack_require__(24);
	var index_js$1 = __webpack_require__(56);
	
	var setAttributes = function setAttributes($dom, attrs) {
	  (0, _entries2.default)(attrs).forEach(function (_ref) {
	    var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
	        k = _ref2[0],
	        v = _ref2[1];
	
	    $dom.setAttribute(k, v);
	  });
	};
	function getImageAttrs(name, data, originWidth, originHeight, containerWidth, containerNode) {
	  var small = data.small,
	      middle = data.middle,
	      origin = data.origin;
	
	  var attrs = {
	    border: +localStorage.getItem(index_ts.BORDER_CACHE_FIELD) === 1,
	    mss: "",
	    name: name,
	    origin: origin,
	    small: small,
	    src: middle
	  };
	
	  if (originWidth && originHeight) {
	    var _index_js$calculateSi = index_js.calculateSize(originWidth, originHeight, containerWidth, index_ts.IMAGE_MAX_HEIGHT),
	        width = _index_js$calculateSi.width,
	        height = _index_js$calculateSi.height,
	        newOriginWidth = _index_js$calculateSi.newOriginWidth,
	        newOriginHeight = _index_js$calculateSi.newOriginHeight;
	
	    var isInTable = containerNode.tagName === "TD" || containerNode.tagName === "TH" || containerNode.tagName === "TR";
	    attrs.width = isInTable ? newOriginWidth : width;
	    attrs.height = isInTable ? newOriginHeight : height;
	  }
	
	  return attrs;
	}
	
	var ImageView = function ImageView(node, view, getPos, store) {
	  var _this = this;
	
	  (0, _classCallCheck3.default)(this, ImageView);
	
	  this.dom = document.createElement("span");
	  this.image = document.createElement("img");
	
	  this.onload = function () {
	    _this.dom.style.height = "auto";
	
	    try {
	      if (!_this.imageWidth) {
	        var _image = _this.image,
	            naturalWidth = _image.naturalWidth,
	            naturalHeight = _image.naturalHeight;
	
	        var containerNode = _this.dom.parentElement;
	        var containerWidth = containerNode.offsetWidth;
	
	        var _index_js$calculateSi2 = index_js.calculateSize(naturalWidth, naturalHeight, containerWidth),
	            width = _index_js$calculateSi2.width,
	            height = _index_js$calculateSi2.height,
	            newOriginWidth = _index_js$calculateSi2.newOriginWidth,
	            newOriginHeight = _index_js$calculateSi2.newOriginHeight;
	
	        var containerParent = containerNode.parentElement;
	        var isInTable = containerParent.tagName === "TD" || containerParent.tagName === "TH" || containerParent.tagName === "TR";
	        var showWidth = isInTable ? newOriginWidth : width;
	        var showHeight = isInTable ? newOriginHeight : height;
	        _this.imageWidth = width;
	        _this.store.updateAttrs({
	          width: showWidth,
	          height: showHeight
	        }, false, _this.getPos());
	      }
	
	      _this.dom.removeChild(index_js.$CtLoading);
	    } catch (err) {}
	
	    _this.dom.appendChild(_this.image);
	  };
	
	  this.onerror = function () {
	    var onError = _this.store.config.onError;
	
	
	    if (onError && onError(_this.dom)) {
	      return;
	    }
	
	    if (parseInt(_this.dom.style.width) < 50) {
	      _this.dom.style.width = "";
	    }
	
	    _this.image.classList.add("ct-img-failed");
	    _this.dom.classList.add("failed");
	  };
	
	  var _node$attrs = node.attrs,
	      name = _node$attrs.name,
	      border = _node$attrs.border,
	      link = _node$attrs.link,
	      _width = _node$attrs.width,
	      small = _node$attrs.small,
	      origin = _node$attrs.origin,
	      _height = _node$attrs.height;
	
	  var domAttrs = {
	    "class": 'ct-image' + (border ? " ct-image-border" : ""),
	    "data-link": link
	  };
	  var _store$config = store.config,
	      config = _store$config === undefined ? {} : _store$config;
	  var customFixDisplayUrl = config.customFixDisplayUrl;
	
	  var src = node.attrs.src;
	
	  if (!src) {
	    src = '';
	    console.error('img src is empty (throw error)');
	  }
	
	  if (customFixDisplayUrl) {
	    src = customFixDisplayUrl(src);
	  }
	
	  var imgAttrs = {
	    "data-small": small,
	    "data-origin": origin,
	    alt: name.length > 100 ? name.substr(0, 100) + '...' : name,
	    src: src,
	    width: '' + (_width || index_ts.IMAGE_DEFAULT_WIDTH)
	  };
	  this.dom.style.width = (_width || index_ts.IMAGE_DEFAULT_WIDTH) + 'px';
	  this.dom.style.height = (_height || index_ts.IMAGE_DEFAULT_HEIGHT) + 'px';
	  setAttributes(this.dom, domAttrs);
	  setAttributes(this.image, imgAttrs);
	  this.store = store;
	  this.getPos = getPos;
	  this.imageWidth = _width;
	  this.image.onerror = this.onerror;
	  this.image.onload = this.onload;
	  this.dom.appendChild(index_js.$CtLoading);
	};
	
	var pluginKey = new prosemirrorState.PluginKey("image");
	function createPlugins(store) {
	  var plugin = new prosemirrorState.Plugin({
	    key: pluginKey,
	    state: {
	      init: function init() {
	        return prosemirrorView.DecorationSet.empty;
	      },
	      apply: function apply(tr, set) {
	        set = set.map(tr.mapping, tr.doc);
	
	        var action = tr.getMeta(this);
	
	        if (action && action.add) {
	          var _action$add = action.add,
	              pos = _action$add.pos,
	              key = _action$add.key;
	
	          var widget = index_js.createUploadMask();
	          var deco = prosemirrorView.Decoration.widget(pos, widget, {
	            key: key,
	            size: -1
	          });
	          set = set.add(tr.doc, [deco]);
	        } else if (action && action.remove) {
	          set = set.remove(set.find(null, null, function (spec) {
	            return spec.key === action.remove.key;
	          }));
	        }
	
	        return set;
	      }
	    },
	    props: {
	      decorations: function decorations(state) {
	        return this.getState(state);
	      },
	
	
	      nodeViews: {
	        image: function image(node, view, getPos) {
	          return new ImageView(node, view, getPos, store);
	        }
	      },
	
	      handleClick: function handleClick(view, pos, e) {
	        if (store.node && (store.node.pos === pos || store.node.pos + 1 === pos)) {
	          return false;
	        }
	
	        var preSelected = document.querySelector('[data-type="ct-progress"].selected');
	
	        if (preSelected) {
	          preSelected.classList.remove("selected");
	        }
	
	        var selected = e.target.closest('[data-type="ct-progress"]');
	
	        if (selected) {
	          var state = view.state,
	              dispatch = view.dispatch;
	
	
	          if (selected.tagName.toUpperCase() === "DIV") {
	            var selection = prosemirrorState.TextSelection.create(state.doc, pos, pos + 1);
	            dispatch(state.tr.setSelection(selection));
	          } else {
	            var _selection = prosemirrorState.TextSelection.create(state.doc, pos, pos + 1);
	            dispatch(state.tr.setSelection(_selection));
	          }
	
	          selected.classList.add("selected");
	          return true;
	        }
	      } },
	    view: function view(_view) {
	      return new index_js.Popover({
	        view: _view,
	        store: store,
	        className: "ct-image-editor-popover"
	      });
	    }
	  });
	  return [plugin];
	}
	
	var imageSchema = {
	  nodes: {
	    image: {
	      atom: true,
	      group: "inline",
	      inline: true,
	      draggable: true,
	      allowGapCursor: true,
	      braceWidth: 82,
	      attrs: {
	        src: {
	          default: ""
	        },
	
	        small: {
	          default: ""
	        },
	
	        origin: {
	          default: ""
	        },
	
	        mss: {
	          default: ""
	        },
	        name: {
	          default: ""
	        },
	        width: {
	          default: 0
	        },
	        height: {
	          default: 0
	        },
	        link: {
	          default: null
	        },
	        border: {
	          default: false
	        }
	      },
	      parseDOM: [{
	        tag: 'span[class~="ct-image"]',
	
	        getAttrs: function getAttrs(dom) {
	          var img = dom.querySelector("img");
	          var src = img.getAttribute("data-src");
	          return {
	            src: src,
	            small: img.getAttribute("data-small") || src,
	            origin: img.getAttribute("data-origin") || src,
	            mss: img.getAttribute("data-mss") || "",
	            name: img.getAttribute("alt") || "",
	            width: img.getAttribute("data-width") || 0,
	            height: img.getAttribute("data-height") || 0,
	            link: img.getAttribute("data-link") || null,
	            border: dom.classList.contains("ct-image-border")
	          };
	        }
	      }, {
	        tag: "img",
	
	        getAttrs: function getAttrs(dom) {
	          var src = dom.getAttribute("src");
	          return {
	            name: dom.getAttribute("alt") || "",
	            origin: src,
	            small: src,
	            src: src,
	            width: dom.getAttribute("data-width") || dom.getAttribute("width") || 0,
	            height: dom.getAttribute("data-height") || dom.getAttribute("height") || 0
	          };
	        }
	      }],
	
	      toDOM: function toDOM(node) {
	        var _node$attrs2 = node.attrs,
	            mss = _node$attrs2.mss,
	            name = _node$attrs2.name,
	            width = _node$attrs2.width,
	            height = _node$attrs2.height,
	            link = _node$attrs2.link,
	            border = _node$attrs2.border;
	        var _node$attrs3 = node.attrs,
	            small = _node$attrs3.small,
	            src = _node$attrs3.src,
	            origin = _node$attrs3.origin;
	
	        var attrs = {
	          class: 'ct-image' + (border ? " ct-image-border" : "")
	        };
	        var imgAttrs = {
	          "alt": name.length > 100 ? name.substr(0, 100) + '...' : name,
	          "data-origin": origin,
	          "data-small": small,
	          "data-src": src
	        };
	
	        if (width && width !== "0") {
	          attrs.style = 'width: ' + width + 'px';
	          imgAttrs["data-width"] = width;
	          imgAttrs["data-height"] = height;
	        }
	
	        if (mss) {
	          imgAttrs["data-mss"] = mss;
	        }
	
	        if (link) {
	          imgAttrs["data-link"] = link;
	        }
	
	        return ["span", attrs, ["img", imgAttrs]];
	      }
	    }
	  }
	};
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    (0, _defineProperty3.default)(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	var defineProperty = _defineProperty;
	
	function _objectSpread(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? arguments[i] : {};
	    var ownKeys = (0, _keys2.default)(source);
	
	    if (typeof _getOwnPropertySymbols2.default === 'function') {
	      ownKeys = ownKeys.concat((0, _getOwnPropertySymbols2.default)(source).filter(function (sym) {
	        return (0, _getOwnPropertyDescriptor2.default)(source, sym).enumerable;
	      }));
	    }
	
	    ownKeys.forEach(function (key) {
	      defineProperty(target, key, source[key]);
	    });
	  }
	
	  return target;
	}
	
	var objectSpread = _objectSpread;
	
	function styleInject(css, ref) {
	  if (ref === void 0) ref = {};
	  var insertAt = ref.insertAt;
	
	  if (!css || typeof document === 'undefined') {
	    return;
	  }
	
	  var head = document.head || document.getElementsByTagName('head')[0];
	  var style = document.createElement('style');
	  style.type = 'text/css';
	
	  if (insertAt === 'top') {
	    if (head.firstChild) {
	      head.insertBefore(style, head.firstChild);
	    } else {
	      head.appendChild(style);
	    }
	  } else {
	    head.appendChild(style);
	  }
	
	  if (style.styleSheet) {
	    style.styleSheet.cssText = css;
	  } else {
	    style.appendChild(document.createTextNode(css));
	  }
	}
	
	var css = ".ct-image-link-modal .content{height:206px!important}.ct-image-link-modal .ant-modal-footer{padding:0 24px 32px;border:none}.ct-image-link-modal .ant-modal-footer .ant-btn{width:60px!important;height:32px;padding:0;margin-left:16px;border-radius:2px}.ct-image-link-modal .input-error{position:absolute;top:55px;left:65px;font-size:12px;color:#f05e50}.image-link-content{padding:14px 0;position:relative;font-size:12px;color:rgba(0,0,0,.65)}.image-link-content .cte-image-link-modal-item{color:rgba(0,0,0,.6);line-heigt:22px}.image-link-content .cte-image-link-modal-item>label{display:flex;align-items:center}.image-link-content .cte-image-link-modal-item>label span{color:rgba(0,0,0,.6);width:60px}.image-link-content .cte-image-link-modal-item input[type=text]{width:100%;height:32px;padding:6px 8px;margin-left:12px;border-radius:4px;border:1px solid rgba(0,0,0,.13);outline:none;color:rgba(0,0,0,.87);transition:all .218s ease}.image-link-content .cte-image-link-modal-item input[type=text]:focus{border:1px solid #1c6cdc}.image-link-content .cte-image-link-modal-item input[type=text]::-webkit-input-placeholder{color:rgba(0,0,0,.24)}.image-link-content .cte-image-link-modal-item input[type=text]::-moz-placeholder{color:rgba(0,0,0,.24)}.image-link-content .cte-image-link-modal-item input[type=text]::-ms-input-placeholder{color:rgba(0,0,0,.24)}.image-link-content .cte-image-link-modal-item input[type=text]:-ms-input-placeholder{color:rgba(0,0,0,.24)}.image-link-content .cte-image-link-modal-item input[type=text]::placeholder{color:rgba(0,0,0,.24)}";
	styleInject(css);
	
	var formatLink = function formatLink(href) {
	  var regex1 = /^(https?:\/\/)?(\w+\.?)+(\/.+)?$/i;
	  var regex2 = /^((https?:\/\/|\w+(\.\w+)+)(:\w+)?).+$/;
	  var newHref = href.replace(regex1, function (match, capture) {
	    return capture ? match : 'http://' + match;
	  });
	
	  return regex2.test(newHref) ? newHref : false;
	};
	
	var LinkModal = function (_preact$Component) {
	  (0, _inherits3.default)(LinkModal, _preact$Component);
	
	  function LinkModal(props) {
	    (0, _classCallCheck3.default)(this, LinkModal);
	
	    var _this2 = (0, _possibleConstructorReturn3.default)(this, (LinkModal.__proto__ || (0, _getPrototypeOf2.default)(LinkModal)).call(this));
	
	    _this2.link = '';
	    _this2.state = {
	      error: null
	    };
	
	    _this2.handleKeydown = function (e) {
	      if (e.which === 13 || e.keyCode === 13) {
	        _this2.handleOk();
	        e.stopPropagation();
	        e.preventDefault();
	        return false;
	      }
	    };
	
	    _this2.handleInputHref = function (e) {
	      if (_this2.state.error) {
	        _this2.setState({
	          error: null
	        });
	      }
	
	      _this2.link = e.target.value.replace(/(^[\u200B\s])|([\u200B\s]$)/g, '');
	    };
	
	    _this2.handleOk = function () {
	      var link = formatLink(_this2.link);
	      if (!link) return _this2.setState({
	        error: '请输入正确的地址'
	      });
	      _this2.handleCancel();
	      _this2.props.addImageLink(link);
	    };
	
	    _this2.handleCancel = function () {
	      if (_this2.state.error) _this2.setState({
	        error: null
	      });
	      _this2.props.closeModal();
	    };
	
	    _this2.link = props.link || '';
	    return _this2;
	  }
	
	  (0, _createClass3.default)(LinkModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.addEventListener('keydown', this.handleKeydown);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener('keydown', this.handleKeydown);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props$link = this.props.link,
	          link = _props$link === undefined ? '' : _props$link;
	      var error = this.state.error;
	
	      return preact.h(index_js$1.Modal, {
	        visible: true,
	        className: "ct-image-link-modal",
	        title: '\u56FE\u7247\u94FE\u63A5',
	        okText: '\u63D2\u5165',
	        onOk: this.handleOk,
	        onCancel: this.handleCancel,
	        canEnter: true
	      }, preact.h("div", {
	        className: "image-link-content"
	      }, preact.h("div", {
	        className: "cte-image-link-modal-item"
	      }, preact.h("label", null, preact.h("span", null, '\u94FE\u63A5\u5730\u5740'), preact.h("input", {
	        id: "imagelink",
	        type: "text",
	        className: "ct-input input-link-href",
	        placeholder: '\u8BF7\u8F93\u5165\u94FE\u63A5\u5730\u5740',
	        autoComplete: "off",
	        defaultValue: link,
	        onInput: this.handleInputHref
	      }))), error && preact.h("div", {
	        className: "input-error"
	      }, error)));
	    }
	  }]);
	  return LinkModal;
	}(preact.Component);
	
	var css$1 = ".ct-image-toolbar{display:flex;height:34px;padding:0 10px;opacity:1;transition:opacity .2s ease}.ct-image-toolbar .split{width:1px;height:14px;margin-top:0;background:#d8d8d8}.ct-image-toolbar .pm-image-width-label{height:18px;padding-left:8px;margin-top:0;color:#333;font-size:12px;line-height:20px}.ct-image-toolbar .pm-image-width-input{border-radius:2px;border:1px solid #ddd;box-sizing:border-box;width:66px;height:24px;padding:5px 8px 3px;margin:0 0 0 8px;font-size:12px;color:#333;-moz-appearance:textfield}.ct-image-toolbar .pm-image-width-input::-webkit-inner-spin-button,.ct-image-toolbar .pm-image-width-input::-webkit-outer-spin-button{-webkit-appearance:none!important;margin:0}.ct-toolbar-tooltip{position:absolute;left:50%;-webkit-transform:translate(-50%);transform:translate(-50%);bottom:-35px;height:25px;padding:0 10px;line-height:25px;white-space:nowrap;vertical-align:middle;color:#fff;font-size:12px;background:rgba(0,0,0,.7);border-radius:4px;z-index:1}.ct-toolbar-tooltip:after{position:absolute;width:0;top:-5px;right:50%;-webkit-transform:translate(50%);transform:translate(50%);display:block;border-color:rgba(0,0,0,.7) transparent;border-style:solid;border-width:0 5px 5px;content:\"\";z-index:1}";
	styleInject(css$1);
	
	var Toolbar = function (_preact$Component2) {
	  (0, _inherits3.default)(Toolbar, _preact$Component2);
	
	  function Toolbar(props) {
	    (0, _classCallCheck3.default)(this, Toolbar);
	
	    var _this3 = (0, _possibleConstructorReturn3.default)(this, (Toolbar.__proto__ || (0, _getPrototypeOf2.default)(Toolbar)).call(this, props));
	
	    _this3.container = null;
	    _this3.input = null;
	
	    _this3.handleCheckboxChange = function () {
	      var newHasBorder = !_this3.state.hasBorder;
	      _this3.setState({
	        hasBorder: newHasBorder
	      });
	      _this3.props.toggleBorder(newHasBorder);
	    };
	
	    _this3.addLink = function () {
	      _this3.setState({
	        visible: true
	      });
	    };
	
	    _this3.editLink = function () {
	      _this3.setState({
	        visible: true
	      });
	    };
	
	    _this3.cancelLink = function () {
	      _this3.props.cancelImageLink();
	    };
	
	    _this3.closeModal = function () {
	      _this3.setState({
	        visible: false
	      });
	    };
	
	    _this3.handleInputChange = function (e) {
	      var width = e.target.value;
	      _this3.setState({
	        width: width
	      });
	    };
	
	    _this3.setWidth = function () {
	      var _this3$props = _this3.props,
	          maxWidth = _this3$props.maxWidth,
	          naturalWidth = _this3$props.naturalWidth;
	
	      var width = _this3.input.value;
	
	      if (width < index_ts.IMAGE_MIN_WIDTH) {
	        if (naturalWidth < 5 || naturalWidth > index_ts.IMAGE_MIN_WIDTH) {
	          width = index_ts.IMAGE_MIN_WIDTH;
	        } else if (width < naturalWidth) {
	          width = naturalWidth;
	        }
	      } else if (width > maxWidth) {
	        width = maxWidth;
	      }
	
	      _this3.props.setWidth(width);
	
	      if (width !== _this3.state.width) {
	        _this3.setState({
	          width: width
	        });
	      }
	    };
	
	    _this3.state = {
	      hasBorder: props.hasBorder,
	      hasLink: !!props.link,
	      visible: false,
	      width: props.width
	    };
	    return _this3;
	  }
	
	  (0, _createClass3.default)(Toolbar, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        hasLink: !!nextProps.link
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _state = this.state,
	          hasBorder = _state.hasBorder,
	          hasLink = _state.hasLink,
	          visible = _state.visible,
	          width = _state.width;
	
	      return preact.h("div", {
	        ref: function ref(r) {
	          return _this4.container = r;
	        },
	        className: "ct-image-toolbar"
	      }, preact.h(index_js$1.CheckBox, {
	        checked: hasBorder,
	        onClick: this.handleCheckboxChange
	      }, '\u8FB9\u6846'), preact.h("div", {
	        className: "split"
	      }), hasLink ? [preact.h(index_js$1.IconItem, {
	        type: "cancelLink",
	        onClick: this.cancelLink,
	        tip: '\u53D6\u6D88\u94FE\u63A5'
	      }), preact.h(index_js$1.IconItem, {
	        type: "edit",
	        onClick: this.editLink,
	        tip: '\u7F16\u8F91\u94FE\u63A5'
	      })] : preact.h(index_js$1.IconItem, {
	        type: "link",
	        onClick: this.addLink,
	        tip: '\u94FE\u63A5'
	      }), preact.h("div", {
	        className: "split"
	      }), preact.h("label", {
	        id: "pm-image-width-label",
	        className: "pm-image-width-label",
	        htmlFor: "pm-image-width-input"
	      }, '\u5BBD\u5EA6'), preact.h("input", {
	        id: "pm-image-width-input",
	        ref: function ref(i) {
	          return _this4.input = i;
	        },
	        className: "ct-input pm-image-width-input",
	        type: "number",
	        autoComplete: "off",
	        value: parseInt(width, 10),
	        onChange: this.handleInputChange,
	        onBlur: this.setWidth,
	        onKeyDown: function onKeyDown(e) {
	          if (e.keyCode === 13) {
	            e.target.blur();
	          }
	        }
	      }), visible && preact.h(LinkModal, {
	        link: this.props.link,
	        addImageLink: this.props.addImageLink,
	        closeModal: this.closeModal
	      }));
	    }
	  }]);
	  return Toolbar;
	}(preact.Component);
	
	var getToolBar = function getToolBar(node, update) {
	  var dom = node.dom,
	      attrs = node.attrs;
	
	  var _dom$getBoundingClien = dom.getBoundingClientRect(),
	      width = _dom$getBoundingClien.width;
	
	  var blockNode = index_js.findParentBlockNode(node.dom);
	
	  if (!blockNode) {
	    return;
	  }
	
	  var parentTagName = blockNode.parentNode.tagName.toLowerCase();
	  var maxWidth = blockNode.clientWidth - index_ts.IMAGE_OFFSET;
	
	  if ((parentTagName === "td" || parentTagName === "th") && blockNode.closest("table").classList.contains("responsive")) {
	    maxWidth = 1920;
	  }
	
	  return preact.h(Toolbar, {
	    dom: dom,
	    type: "image",
	    link: attrs.link,
	    width: attrs.width || width,
	    maxWidth: maxWidth,
	    naturalWidth: dom.firstChild.naturalWidth,
	    hasBorder: dom.classList.contains("ct-image-border"),
	    toggleBorder: function toggleBorder(data) {
	      return _toggleBorder(data, update);
	    },
	    addImageLink: function addImageLink(data) {
	      return _addImageLink(data, update);
	    },
	    cancelImageLink: function cancelImageLink() {
	      return _cancelImageLink(update);
	    },
	    setWidth: function setWidth(width) {
	      return _setWidth(node, width, update);
	    }
	  });
	};
	
	var _addImageLink = function _addImageLink(link, update) {
	  update({
	    link: link
	  });
	};
	
	var _cancelImageLink = function _cancelImageLink(update) {
	  update({
	    link: null
	  });
	};
	
	var _toggleBorder = function _toggleBorder(hasBorder, update) {
	  localStorage.setItem(index_ts.BORDER_CACHE_FIELD, hasBorder ? "1" : "0");
	  update({
	    border: hasBorder
	  });
	};
	
	var _setWidth = function _setWidth(node, width, update) {
	  var dom = node.dom;
	  var $img = dom.querySelector("img");
	  var height = width / $img.clientWidth * $img.clientHeight;
	  dom.style.width = width + 'px';
	  update({
	    width: width,
	    height: height
	  });
	};
	
	var preloadImage = function preloadImage(src) {
	  return new _promise2.default(function (resolve, reject) {
	    var image = new Image();
	
	    setTimeout(function () {
	      setTimeout(function () {
	        image.src = src;
	      }, 0);
	    }, 0);
	
	    image.onload = function () {
	      return resolve(image);
	    };
	
	    image.onerror = function () {
	      return reject('\u56FE\u7247\u4E0B\u8F7D\u5931\u8D25: ' + src);
	    };
	  });
	};
	
	var _class, _temp;
	var ImageStore = index_js.uploader(_class = index_js.resizer(_class = (_temp = function () {
	  function ImageStore() {
	    (0, _classCallCheck3.default)(this, ImageStore);
	
	    this.pluginName = "image$";
	    this.view = void 0;
	    this.trigger = void 0;
	    this.config = void 0;
	    this.node = void 0;
	    this.ctPopover = void 0;
	    this.editor = void 0;
	  }
	
	  (0, _createClass3.default)(ImageStore, [{
	    key: 'init',
	    value: function init(editor) {
	      var trigger = editor.trigger,
	          view = editor.view,
	          _editor$imageConfig = editor.imageConfig,
	          imageConfig = _editor$imageConfig === undefined ? {} : _editor$imageConfig;
	
	      this.trigger = trigger;
	      this.view = view;
	      this.config = imageConfig;
	      this.editor = editor;
	    }
	  }, {
	    key: 'insertToDoc',
	    value: function insertToDoc(key, filename, failedHandle) {
	      var _this5 = this;
	
	      return function () {
	        var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(_ref3) {
	          var _ref3$name = _ref3.name,
	              name = _ref3$name === undefined ? filename : _ref3$name,
	              src = _ref3.src,
	              w = _ref3.width,
	              small = _ref3.small,
	              origin = _ref3.origin;
	
	          var customFixDisplayUrl, _ref5, naturalWidth, naturalHeight, dispatch, placeHolderInfo, node, pos, $container, containerWidth, attrs;
	
	          return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	              switch (_context.prev = _context.next) {
	                case 0:
	                  _context.prev = 0;
	
	                  if (src) {
	                    _context.next = 3;
	                    break;
	                  }
	
	                  throw new Error("图片上传失败");
	
	                case 3:
	                  customFixDisplayUrl = _this5.config.customFixDisplayUrl;
	
	
	                  if (customFixDisplayUrl) {
	                    src = customFixDisplayUrl(src);
	                  }
	
	                  _context.next = 7;
	                  return preloadImage(src);
	
	                case 7:
	                  _ref5 = _context.sent;
	                  naturalWidth = _ref5.naturalWidth;
	                  naturalHeight = _ref5.naturalHeight;
	                  dispatch = _this5.view.dispatch;
	                  placeHolderInfo = index_js.findPlaceholder(_this5.view, _this5.pluginName, key);
	
	                  if (placeHolderInfo) {
	                    _context.next = 14;
	                    break;
	                  }
	
	                  return _context.abrupt('return');
	
	                case 14:
	                  node = placeHolderInfo.node, pos = placeHolderInfo.pos;
	                  $container = index_js.findParentBlockNode(node);
	                  containerWidth = ($container && $container.clientWidth !== 0 ? $container.clientWidth : 68) - index_ts.IMAGE_OFFSET;
	                  attrs = getImageAttrs(name, {
	                    small: small,
	                    middle: src,
	                    origin: origin
	                  }, naturalWidth, naturalHeight, containerWidth, $container && $container.parentNode);
	
	
	                  if (w) {
	                    attrs.height = w * naturalHeight / naturalWidth;
	
	                    attrs.width = w;
	                  }
	
	                  dispatch(_this5.view.state.tr.replaceWith(pos, pos, _this5.view.state.schema.nodes.image.create(attrs)));
	                  index_js.deletePlaceholder(_this5.view, _this5.pluginName, key);
	                  _context.next = 27;
	                  break;
	
	                case 23:
	                  _context.prev = 23;
	                  _context.t0 = _context['catch'](0);
	
	                  console.error(_context.t0);
	                  failedHandle("图片上传失败");
	
	                case 27:
	                case 'end':
	                  return _context.stop();
	              }
	            }
	          }, _callee, _this5, [[0, 23]]);
	        }));
	
	        return function (_x) {
	          return _ref4.apply(this, arguments);
	        };
	      }();
	    }
	  }, {
	    key: 'updateAttrs',
	    value: function updateAttrs(data) {
	      var shouldSelect = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	      var pos = arguments[2];
	      var _view2 = this.view,
	          state = _view2.state,
	          dispatch = _view2.dispatch;
	      var tr = state.tr,
	          doc = state.doc,
	          schema = state.schema;
	
	
	      if (pos === undefined) {
	        pos = this.node.pos;
	      }
	
	      var ctrlNode = tr.doc.nodeAt(pos);
	
	      if (!ctrlNode) {
	        return;
	      }
	
	      var attrs = objectSpread({}, ctrlNode.attrs, data);
	
	      tr.setNodeMarkup(pos, schema.nodes.image, attrs);
	
	      if (shouldSelect) {
	        var newSelection = prosemirrorState.NodeSelection.create(doc, pos);
	        tr.setSelection(newSelection);
	      }
	
	      dispatch(tr);
	
	      if (shouldSelect) {
	        var dom = this.view.nodeDOM(pos);
	
	        if (dom) {
	          this.showPopover({
	            dom: dom,
	            attrs: attrs,
	            pos: pos
	          });
	        }
	      }
	    }
	  }, {
	    key: 'showPopover',
	    value: function showPopover(node) {
	      this.hidePopover();
	      this.node = node;
	      this.ctShowResizer();
	      this.ctPopover.show({
	        dom: node.dom,
	        content: getToolBar(node, this.updateAttrs.bind(this))
	      });
	    }
	  }, {
	    key: 'hidePopover',
	    value: function hidePopover() {
	      this.ctHideResizer();
	      this.ctPopover.hide();
	    }
	  }]);
	  return ImageStore;
	}(), _temp)) || _class) || _class;
	
	var readeAsBase64 = function readeAsBase64(file, onprogress) {
	  return new _promise2.default(function (resolve, reject) {
	    var reader = new FileReader();
	
	    reader.onload = function () {
	      return resolve(reader.result);
	    };
	
	    reader.onerror = function () {
	      return reject("oops");
	    };
	
	    reader.onprogress = onprogress;
	    reader.readAsDataURL(file);
	  });
	};
	
	var customUpload = function () {
	  var _ref7 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(_ref6) {
	    var file = _ref6.file,
	        onprogress = _ref6.onprogress,
	        insert = _ref6.insert,
	        failedHandle = _ref6.failedHandle;
	    var result;
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            _context3.prev = 0;
	            _context3.next = 3;
	            return new _promise2.default(function (res) {
	              setTimeout((0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	                var rest;
	                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                  while (1) {
	                    switch (_context2.prev = _context2.next) {
	                      case 0:
	                        _context2.next = 2;
	                        return readeAsBase64(file, onprogress);
	
	                      case 2:
	                        rest = _context2.sent;
	
	                        res(rest);
	
	                      case 4:
	                      case 'end':
	                        return _context2.stop();
	                    }
	                  }
	                }, _callee2, undefined);
	              })), 2000);
	            });
	
	          case 3:
	            result = _context3.sent;
	            _context3.next = 6;
	            return insert({
	              src: result
	            });
	
	          case 6:
	            _context3.next = 11;
	            break;
	
	          case 8:
	            _context3.prev = 8;
	            _context3.t0 = _context3['catch'](0);
	
	            failedHandle('some errors: ' + _context3.t0);
	
	          case 11:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, undefined, [[0, 8]]);
	  }));
	
	  return function customUpload(_x3) {
	    return _ref7.apply(this, arguments);
	  };
	}();
	
	var config = {
	  customUpload: customUpload
	};
	
	var css$2 = ".ct-image{display:inline-block;position:relative;max-width:100%;margin:0 3px;line-height:1;font-size:0;box-sizing:content-box;background-color:#fff;vertical-align:bottom}.ct-image.ProseMirror-selectednode{outline:2px solid #00a7cd}.ct-image img{width:100%;max-width:100%;vertical-align:bottom}.ct-image .ct-img-failed{min-width:50px;min-height:50px}.ct-image .ct-img-failed,.ct-image .ct-img-loading,.ct-image .ct-img-mask{display:inline-block}.ct-image .ct-img-failed:before,.ct-image .ct-img-loading:before,.ct-image .ct-img-mask:before{content:\"\";position:absolute;left:0;top:0;display:block;width:100%;height:100%;background:#f6f6f6;z-index:1}.ct-image .ct-img-failed:after,.ct-image .ct-img-loading:after,.ct-image .ct-img-mask:after{content:\"\";position:absolute;left:12px;top:12px;display:block;width:28px;height:20px;z-index:2}.ct-image .ct-img-noperm{position:absolute;left:12px;top:40px;display:block;z-index:9;font-size:14px;color:#777}.ct-image .ct-img-failed:after{background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg class='icon' viewBox='0 0 1380 1024' xmlns='http://www.w3.org/2000/svg' width='26.953' height='20'%3E%3Cdefs%3E%3Cstyle/%3E%3C/defs%3E%3Cpath d='M526.889 315.732l165.016 171.024a66.785 66.785 0 0 1 18.724 46.371V737.77l135.664-202.254-123.399-162.635a66.78 66.78 0 0 1-8.027-67.029L830.58 40.121C841.19 15.756 865.235.001 891.809.001h338.475c82.394 0 149.89 65.742 149.89 147.731V876.27c0 81.989-67.496 147.731-149.89 147.731H149.89C67.496 1024.001 0 958.259 0 876.27V147.732C0 65.743 67.496.001 149.89.001h393.258c45.99 0 78.216 45.4 63.044 88.815L526.89 315.733z' fill='%237F9496'/%3E%3Cpath d='M543.148 66.783l-83.824 239.855a44.52 44.52 0 0 0 9.99 45.602l174.532 180.887v277.792a44.52 44.52 0 0 0 19.721 36.974c20.42 13.697 48.078 8.247 61.775-12.173l185.264-276.199c10.592-15.791 9.987-36.565-1.506-51.712L776.096 332.515 891.809 66.784h338.475c45.899 0 83.107 36.242 83.107 80.949v728.538c0 44.707-37.208 80.949-83.107 80.949H149.89c-45.899 0-83.107-36.242-83.107-80.949V147.733c0-44.707 37.208-80.949 83.107-80.949h393.258z' fill='%23FFF'/%3E%3Cpath d='M496.955 289.391l252.816 398.046 196.047-178.035 300.791 358.771H133.566z' fill='%23DDD'/%3E%3Cpath d='M526.889 315.732l165.016 171.024a66.785 66.785 0 0 1 18.724 46.371V737.77l135.664-202.254-123.399-162.635a66.78 66.78 0 0 1-8.027-67.029L830.58 40.121C841.19 15.756 865.235.001 891.809.001h338.475c82.394 0 149.89 65.742 149.89 147.731V876.27c0 81.989-67.496 147.731-149.89 147.731H149.89C67.496 1024.001 0 958.259 0 876.27V147.732C0 65.743 67.496.001 149.89.001h393.258c45.99 0 78.216 45.4 63.044 88.815L526.89 315.733zm16.259-248.949H149.89c-45.899 0-83.107 36.242-83.107 80.949V876.27c0 44.707 37.208 80.949 83.107 80.949h1080.394c45.899 0 83.107-36.242 83.107-80.949V147.732c0-44.707-37.208-80.949-83.107-80.949H891.809L776.096 332.514 909.1 507.808c11.493 15.147 12.098 35.922 1.506 51.712L725.342 835.719c-13.697 20.42-41.355 25.871-61.775 12.173a44.522 44.522 0 0 1-19.721-36.974V533.126L469.314 352.239a44.523 44.523 0 0 1-9.99-45.602l83.824-239.855z' fill='%237F9496'/%3E%3Cpath d='M1230.284 309.628c0 67.06-55.813 121.423-124.661 121.423s-124.661-54.363-124.661-121.423 55.813-121.423 124.661-121.423 124.661 54.363 124.661 121.423z' fill='%23EEE'/%3E%3C/svg%3E\") no-repeat 0 0}.ct-image .ct-img-mask:after{background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg class='icon' viewBox='0 0 1380 1024' xmlns='http://www.w3.org/2000/svg' width='26.953' height='20'%3E%3Cdefs%3E%3Cstyle/%3E%3C/defs%3E%3Cpath d='M155.826 0h1068.522c86.06 0 155.826 69.766 155.826 155.826v712.348c0 86.06-69.766 155.826-155.826 155.826H155.826C69.766 1024 0 954.234 0 868.174V155.826C0 69.766 69.766 0 155.826 0z' fill='%237F9496'/%3E%3Cpath d='M155.826 66.783c-49.177 0-89.043 39.866-89.043 89.043v712.348c0 49.177 39.866 89.043 89.043 89.043h1068.522c49.177 0 89.043-39.866 89.043-89.043V155.826c0-49.177-39.866-89.043-89.043-89.043H155.826z' fill='%23FFF'/%3E%3Cpath d='M496.955 289.391l252.816 398.046 196.047-178.035 300.791 358.771H133.566z' fill='%23D6D2ED'/%3E%3Cpath d='M1230.284 309.628c0 67.06-55.813 121.423-124.661 121.423s-124.661-54.363-124.661-121.423 55.813-121.423 124.661-121.423 124.661 54.363 124.661 121.423z' fill='%23E8E4FB'/%3E%3C/svg%3E\") no-repeat 0 0}.ct-image .ct-img-loading-bounce{position:absolute;display:block;z-index:9}.ct-image .ct-img-loading-bounce>i{display:none;vertical-align:middle}.ct-image .ct-img-loading-bounce>:nth-child(-n+3){display:inline-block;width:12px;height:12px;background:$brand;border-radius:50%;-webkit-animation:bounce-delay 1.4s ease-in-out infinite both;animation:bounce-delay 1.4s ease-in-out infinite both}.ct-image .ct-img-loading-bounce>:nth-child(-n+3):not(:last-child){margin-right:5px}.ct-image .ct-img-loading-bounce>:first-child{-webkit-animation-delay:-.32s;animation-delay:-.32s}.ct-image .ct-img-loading-bounce>:nth-child(2){-webkit-animation-delay:-.16s;animation-delay:-.16s}.ct-image.ProseMirror-selectednode{outline:2px solid $brand!important}.ct-image-border{display:inline-block;outline:2px solid #ddd!important}.ct-edit-img>img{display:block;max-width:100%;border:1px solid transparent}.ct-edit-img.active>img{border:1px solid #118bfb}span[data-type=ct-progress]{min-width:62px;min-height:62px}span[data-type=ct-progress].selected{outline:2px solid #118bfb}span[data-type=ct-progress] ::-moz-selection{background:transparent!important;color:unset!important}span[data-type=ct-progress] ::selection{background:transparent!important;color:unset!important}span[data-type=ct-progress] img{width:auto;max-width:100%;max-height:600px}.ct-image-editor{display:block;position:absolute;left:0;right:0;top:0;bottom:0;z-index:11;outline:1px dashed #aaa;pointer-events:none}.ct-image-editor .resizer{position:absolute;width:24px;height:24px;pointer-events:auto}.ct-image-editor .resizer:after{box-sizing:border-box;content:\" \";position:absolute;display:block;top:5px;left:5px;width:14px;height:14px;border-radius:7px;border:2px solid #fff;box-shadow:0 1px 2px 0;background-color:#333}.ct-image-editor .info{position:absolute;padding:5px;font-size:12px;color:#fff;background:rgba(0,0,0,.7)}.ct-image-editor .info-lt{left:8px;top:8px}.ct-image-editor .info-lb{left:8px;bottom:8px}.ct-image-editor .info-rt{right:8px;top:8px}.ct-image-editor .info-rb{right:8px;bottom:8px}.ct-image-editor .resizer-lt{left:-12px;top:-12px;cursor:nwse-resize}.ct-image-editor .resizer-lb{left:-12px;bottom:-12px;cursor:nesw-resize}.ct-image-editor .resizer-rt{right:-12px;top:-12px;cursor:nesw-resize}.ct-image-editor .resizer-rb{right:-12px;bottom:-12px;cursor:nwse-resize}.ct-image-resizer{display:none;position:absolute;height:24px;width:24px;z-index:11}.ct-image-mask.image{position:absolute;top:-1px;left:-1px;bottom:-1px;right:-1px;min-width:360px;min-height:100px;font-size:14px;overflow:hidden;background:rgba(0,0,0,.7);color:#fff}.ct-image-mask.image .ct-image-loading{position:absolute;top:10px;left:10px;width:15px;height:15px;border-radius:50%;border:2px solid #d5d5d5;border-bottom-color:transparent;vertical-align:-8%;-webkit-animation:image-loading .8s linear infinite;animation:image-loading .8s linear infinite}.ct-image-mask.image .ct-image-progress{position:absolute;top:30px;left:10px;text-decoration:none!important}.ct-image-mask.image .ct-image-load-failed{top:7px;line-height:20px;overflow:hidden;color:#fff}.ct-image-mask.image .ct-image-load-failed,.ct-image-mask.image .ct-image-reupload{display:none;position:absolute;left:7px;font-size:12px;text-decoration:none!important}.ct-image-mask.image .ct-image-reupload{top:70px;padding:2px;border-radius:2px;color:#000;background:#fff;outline:none;cursor:pointer}@-webkit-keyframes image-loading{0%{-webkit-transform:rotate(0);transform:rotate(0)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes image-loading{0%{-webkit-transform:rotate(0);transform:rotate(0)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}";
	styleInject(css$2);
	
	function isContainsByTags(node, tags) {
	  var parentNode = node.parentNode;
	
	  while (parentNode && parentNode.id !== 'pm-body-wrapper') {
	    if (tags.includes((parentNode.tagName || '').toLowerCase())) {
	      return parentNode;
	    }
	
	    parentNode = parentNode.parentNode;
	  }
	
	  return false;
	}
	
	function handleAddImgSpace(imgs, maxWidth) {
	  (0, _from2.default)(imgs).forEach(function (img) {
	    var imgSource = img.getAttribute('data-src');
	    if (!imgSource || img.getAttribute('src')) return;
	    var dataWidth = img.getAttribute('data-width');
	    var dataHeight = img.getAttribute('data-height');
	
	    if (!dataWidth || !dataHeight) {
	      img.src = imgSource;
	      img.style.maxWidth = '100%';
	      img.parentNode.style.cssText = 'max-width: 100%';
	      return;
	    }
	
	    img.className = 'ct-img-mask';
	    var parentNodeWithTable = isContainsByTags(img, ['td', 'th']);
	
	    if (parentNodeWithTable) {
	      img.parentNode.style.cssText = 'max-width: 100%; width: ' + dataWidth + 'px';
	      img.height = dataHeight;
	      return;
	    }
	
	    if (dataWidth < maxWidth) {
	      img.width = dataWidth;
	      img.height = dataHeight;
	      img.parentNode.style.cssText = 'width: ' + dataWidth + 'px';
	    } else {
	      img.width = '100%';
	      img.height = dataHeight * (maxWidth / dataWidth);
	      img.parentNode.style.cssText = 'width: 100%';
	    }
	  });
	}
	
	function setImgsSrc(imgs, maxWidth, onError) {
	  (0, _from2.default)(imgs).forEach(function (img) {
	    if (!img.hasAttribute('data-src')) return;
	    var dataWidth = img.getAttribute('data-width');
	    var parentNodeWithTable = isContainsByTags(img, ['td', 'th']);
	
	    if (parentNodeWithTable || !dataWidth) {
	      img.parentNode.style.cssText = 'max-width: ' + dataWidth + 'px';
	    }
	
	    if (dataWidth < maxWidth) {
	      img.width = dataWidth;
	      img.parentNode.style.cssText = 'width: ' + dataWidth + 'px';
	    } else {
	      img.width = '100%';
	      img.parentNode.style.cssText = 'width: 100%;';
	    }
	
	    img.src = img.getAttribute('data-src');
	
	    img.onerror = function (e) {
	      if (onError(e)) {
	        e.target.classList.add('ct-img-failed');
	      }
	    };
	  });
	}
	
	var handleImageLink = function handleImageLink($body) {
	  var handler = function handler(_ref9) {
	    var target = _ref9.target;
	
	    var $span = target.closest('.ct-image');
	
	    if ($span && target.getAttribute('data-link')) {
	      window.open(target.getAttribute('data-link'));
	    }
	  };
	
	  $body.addEventListener('click', handler);
	  return function () {
	    return $body.removeEventListener('click', handler);
	  };
	};
	
	var imageToView = function imageToView(_ref10) {
	  var bodyWrapper = _ref10.bodyWrapper,
	      onDestroy = _ref10.onDestroy;
	
	  var _ref11 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref11$maxWidth = _ref11.maxWidth,
	      maxWidth = _ref11$maxWidth === undefined ? 1000 : _ref11$maxWidth,
	      _ref11$lazyload = _ref11.lazyload,
	      lazyload = _ref11$lazyload === undefined ? false : _ref11$lazyload,
	      _ref11$imageLink = _ref11.imageLink,
	      imageLink = _ref11$imageLink === undefined ? true : _ref11$imageLink,
	      _ref11$onError = _ref11.onError,
	      onError = _ref11$onError === undefined ? function () {
	    return true;
	  } : _ref11$onError;
	
	  var imgs = bodyWrapper.querySelectorAll('.ct-image > img');
	  if (!imgs.length) return;
	  if (imageLink) onDestroy(handleImageLink(bodyWrapper));
	
	  if (!lazyload) {
	    setImgsSrc(imgs, maxWidth, onError);
	  } else {
	    handleAddImgSpace(imgs, maxWidth);
	  }
	};
	
	var ImageModule = function () {
	  function ImageModule() {
	    (0, _classCallCheck3.default)(this, ImageModule);
	
	    this.name = "image";
	    this.schema = void 0;
	    this.plugins = void 0;
	    this.config = void 0;
	    this.store = void 0;
	    this.editor = void 0;
	    this.store = new ImageStore();
	    this.schema = imageSchema;
	    this.plugins = [].concat((0, _toConsumableArray3.default)(createPlugins(this.store)));
	    this.config = config;
	  }
	
	  (0, _createClass3.default)(ImageModule, [{
	    key: 'init',
	    value: function init(editor) {
	      this.editor = editor;
	      this.store.init(editor);
	    }
	  }]);
	  return ImageModule;
	}();
	
	ImageModule.moduleName = "image";
	
	exports.ImageModule = ImageModule;
	exports.imageToView = imageToView;

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classCallCheck2 = __webpack_require__(7);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(10);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _getOwnPropertyDescriptor = __webpack_require__(23);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getOwnPropertySymbols = __webpack_require__(16);
	
	var _getOwnPropertySymbols2 = _interopRequireDefault(_getOwnPropertySymbols);
	
	var _keys = __webpack_require__(13);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _defineProperty2 = __webpack_require__(15);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _typeof2 = __webpack_require__(8);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault(ex) {
	  return ex && (typeof ex === 'undefined' ? 'undefined' : (0, _typeof3.default)(ex)) === 'object' && 'default' in ex ? ex['default'] : ex;
	}
	
	var keymap = _interopDefault(__webpack_require__(34));
	__webpack_require__(25);
	__webpack_require__(12);
	var prosemirrorState = __webpack_require__(6);
	var index_js = __webpack_require__(22);
	var index_js$1 = __webpack_require__(29);
	var index_js$2 = __webpack_require__(97);
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    (0, _defineProperty3.default)(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	var defineProperty = _defineProperty;
	
	function _objectSpread(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? arguments[i] : {};
	    var ownKeys = (0, _keys2.default)(source);
	
	    if (typeof _getOwnPropertySymbols2.default === 'function') {
	      ownKeys = ownKeys.concat((0, _getOwnPropertySymbols2.default)(source).filter(function (sym) {
	        return (0, _getOwnPropertyDescriptor2.default)(source, sym).enumerable;
	      }));
	    }
	
	    ownKeys.forEach(function (key) {
	      defineProperty(target, key, source[key]);
	    });
	  }
	
	  return target;
	}
	
	var objectSpread = _objectSpread;
	
	function setAlign(align) {
	  return function (state, dispatch, view) {
	    var selection = state.selection,
	        tr = state.tr;
	
	    var transaction = void 0;
	
	    selection.ranges.forEach(function (range) {
	      var from = range.$from.pos;
	      var to = range.$to.pos;
	      tr.doc.nodesBetween(from, to, function (node, pos) {
	        if (!node.type.spec.alignBlock) return;
	
	        var newAttrs = objectSpread({}, node.attrs, {
	          align: align
	        });
	
	        try {
	          transaction = tr.setNodeMarkup(pos, null, newAttrs);
	        } catch (e) {}
	      });
	    });
	
	    if (selection instanceof index_js$1.GapCursor) {
	      var $from = selection.$from,
	          dom = selection.dom;
	      var nodeBefore = $from.nodeBefore,
	          nodeAfter = $from.nodeAfter,
	          pos = $from.pos;
	
	      if (!dom) return false;
	      var domPos = void 0;
	
	      try {
	        domPos = view.docView.posFromDOM(dom);
	      } catch (error) {
	        return false;
	      }
	
	      if (nodeAfter && nodeAfter.type.spec.alignBlock && nodeAfter.type.isAtom && domPos === pos) {
	        var newAttrs = objectSpread({}, nodeAfter.attrs, {
	          align: align
	        });
	
	        transaction = tr.setNodeMarkup(pos, null, newAttrs);
	      }
	
	      if (nodeBefore && nodeBefore.type.spec.alignBlock && nodeBefore.type.isAtom && domPos < pos) {
	        var _newAttrs = objectSpread({}, nodeBefore.attrs, {
	          align: align
	        });
	
	        transaction = tr.setNodeMarkup(pos - 1, null, _newAttrs);
	      }
	    }
	
	    if (!transaction) return false;
	
	    if (dispatch) {
	      dispatch(transaction);
	      view.focus();
	    }
	
	    return true;
	  };
	}
	
	var handleListClick = function handleListClick(listType) {
	  return function (state, dispatch, view, editor) {
	    var listCommands = editor.listCommands,
	        listUtils = editor.listUtils;
	
	
	    if (!listCommands) {
	      return;
	    }
	
	    if (listUtils.judgeListType(state, listType)) {
	      listCommands.unwrapList();
	    } else if (!listUtils.isInList(state)) {
	      listCommands.wrapInList(listType);
	    } else {
	      listCommands.transformList(listType);
	    }
	
	    view.focus();
	  };
	};
	var setOL = function setOL(editor, state, dispatch, view) {
	  var ordered_list = state.schema.nodes.ordered_list;
	
	  var command = handleListClick(ordered_list);
	  command(state, dispatch, view, editor);
	  return true;
	};
	var setUL = function setUL(editor, state, dispatch, view) {
	  var bullet_list = state.schema.nodes.bullet_list;
	
	  var command = handleListClick(bullet_list);
	  command(state, dispatch, view, editor);
	  return true;
	};
	var setLink = function setLink(editor, state, dispatch) {
	  var attrs = editor.linkUtils.getLinkAttrs(state, dispatch);
	
	  if (attrs) {
	    editor.linkStore.openModal(attrs);
	  }
	
	  return true;
	};
	
	function quickSelect(state, dispatch, view) {
	  var tr = state.tr,
	      selection = state.selection,
	      schema = state.schema,
	      doc = state.doc;
	  var $from = selection.$from;
	  var _schema$nodes = schema.nodes,
	      note_content = _schema$nodes.note_content,
	      note_title = _schema$nodes.note_title,
	      collapse_title = _schema$nodes.collapse_title,
	      collapse_content = _schema$nodes.collapse_content,
	      status = _schema$nodes.status,
	      table = _schema$nodes.table;
	
	  var contentBlocks = [note_content, note_title, collapse_title, collapse_content, status, table];
	  var foundNode = index_js.findParentNode($from.path, function (node) {
	    return contentBlocks.includes(node.type);
	  });
	
	  if (foundNode) {
	    var newSelection = void 0;
	    var pos = foundNode.pos;
	    var node = foundNode.node;
	
	    switch (foundNode.node.type) {
	      case collapse_title:
	      case collapse_content:
	      case note_title:
	      case note_content:
	      case status:
	        newSelection = prosemirrorState.TextSelection.create(doc, pos + 1, pos + node.nodeSize - 1);
	        break;
	
	      case table:
	        var lastCell = node.lastChild.lastChild;
	        newSelection = new index_js$2.CellSelection(doc.resolve(pos + 2), doc.resolve(pos + node.nodeSize - lastCell.nodeSize - 2));
	        break;
	    }
	
	    dispatch(tr.setSelection(newSelection));
	    view.focus();
	  } else if (selection instanceof prosemirrorState.NodeSelection && contentBlocks.includes(selection.node.type)) {
	    var from = selection.from,
	        to = selection.to;
	
	    var _newSelection = prosemirrorState.TextSelection.create(doc, from + 1, to - 1);
	    dispatch(tr.setSelection(_newSelection));
	    view.focus();
	  }
	}
	
	function copyWithStyle() {
	  window.__EDITOR_COPY_WITH_STYLE__ = true;
	  document.execCommand("Copy");
	  return true;
	}
	
	var IS_MAC = navigator.platform.toUpperCase().indexOf("MAC") >= 0;
	function buildKeymap(getEditor) {
	  var keys = {};
	
	  var bind = function bind(key, cmd) {
	    return keys[key] = cmd;
	  };
	
	  var _loop = function _loop(i) {
	    bind('Mod-' + i, function () {
	      var editor = getEditor();
	      editor.basicCommands.setTextBlockType(editor.view.state.schema.nodes.heading, {
	        level: i
	      });
	      return true;
	    });
	  };
	
	  for (var i = 1; i <= 6; i++) {
	    _loop(i);
	  }
	
	  return keys;
	}
	function createPlugins(module) {
	  var getEditor = function getEditor() {
	    return module.editor;
	  };
	
	  var plugins = [keymap({
	    "Shift-Mod-o": function ShiftModO() {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return setOL.apply(undefined, [getEditor()].concat(args));
	    },
	    "Shift-Mod-O": function ShiftModO() {
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return setOL.apply(undefined, [getEditor()].concat(args));
	    },
	
	    "Shift-Mod-u": function ShiftModU() {
	      for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	        args[_key3] = arguments[_key3];
	      }
	
	      return setUL.apply(undefined, [getEditor()].concat(args));
	    },
	    "Shift-Mod-U": function ShiftModU() {
	      for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	        args[_key4] = arguments[_key4];
	      }
	
	      return setUL.apply(undefined, [getEditor()].concat(args));
	    },
	
	    "Shift-Mod-s": function ShiftModS() {
	      getEditor().basicCommands.toggleMark(getEditor().view.state.schema.marks.strikethrough);
	      return true;
	    },
	    "Shift-Mod-S": function ShiftModS() {
	      getEditor().basicCommands.toggleMark(getEditor().view.state.schema.marks.strikethrough);
	      return true;
	    },
	
	    "Mod-k": function ModK(state, dispatch) {
	      return setLink(getEditor(), state, dispatch);
	    },
	    "Mod-K": function ModK(state, dispatch) {
	      return setLink(getEditor(), state, dispatch);
	    },
	
	    "Shift-Mod-l": setAlign("left"),
	    "Shift-Mod-I": setAlign("left"),
	
	    "Shift-Mod-c": setAlign("center"),
	    "Shift-Mod-C": setAlign("center"),
	
	    "Shift-Mod-r": setAlign("right"),
	    "Shift-Mod-R": setAlign("right"),
	
	    "Mod-0": function Mod0() {
	      return getEditor().basicCommands.setTextBlockType(getEditor().view.state.schema.nodes.paragraph);
	    },
	
	    "Mod-b": function ModB() {
	      return getEditor().basicCommands.toggleMark(getEditor().view.state.schema.marks.strong);
	    },
	    "Mod-B": function ModB() {
	      return getEditor().basicCommands.toggleMark(getEditor().view.state.schema.marks.strong);
	    },
	
	    "Mod-i": function ModI() {
	      return getEditor().basicCommands.toggleMark(getEditor().view.state.schema.marks.em);
	    },
	    "Mod-I": function ModI() {
	      return getEditor().basicCommands.toggleMark(getEditor().view.state.schema.marks.em);
	    },
	
	    "Mod-u": function ModU() {
	      return getEditor().basicCommands.toggleMark(getEditor().view.state.schema.marks.underline);
	    },
	    "Mod-U": function ModU() {
	      return getEditor().basicCommands.toggleMark(getEditor().view.state.schema.marks.underline);
	    },
	
	    "Mod-Alt-t": function ModAltT() {
	      return getEditor().timeStore.insertTime();
	    },
	    "Mod-Alt-T": function ModAltT() {
	      return getEditor().timeStore.insertTime();
	    },
	
	    "Mod-Alt-c": function ModAltC() {
	      return getEditor().codeCommands.insert();
	    },
	    "Mod-Alt-C": function ModAltC() {
	      return getEditor().codeCommands.insert();
	    },
	
	    "Mod-Shift-a": quickSelect,
	    "Mod-Shift-A": quickSelect,
	
	    "Mod-8": function Mod8(state) {
	      return getEditor().quoteCommands.toggle(state);
	    }
	  }), keymap(buildKeymap(getEditor))];
	
	  if (IS_MAC) {
	    plugins.push(keymap({
	      "Mod-Ctrl-c": copyWithStyle,
	      "Mod-Ctrl-C": copyWithStyle
	    }));
	  } else {
	    plugins.push(keymap({
	      "Mod-Alt-c": copyWithStyle,
	      "Mod-Alt-C": copyWithStyle
	    }));
	  }
	
	  return plugins;
	}
	
	var KeymapGroupModule = function () {
	  function KeymapGroupModule() {
	    (0, _classCallCheck3.default)(this, KeymapGroupModule);
	
	    this.name = "keymapGroup";
	    this.editor = void 0;
	    this.plugins = void 0;
	    this.plugins = createPlugins(this);
	  }
	
	  (0, _createClass3.default)(KeymapGroupModule, [{
	    key: 'init',
	    value: function init(editor) {
	      this.editor = editor;
	    }
	  }]);
	  return KeymapGroupModule;
	}();
	
	KeymapGroupModule.moduleName = "keymapGroup";
	
	exports.KeymapGroupModule = KeymapGroupModule;

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _promise = __webpack_require__(35);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _map = __webpack_require__(151);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _getPrototypeOf = __webpack_require__(30);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _createClass2 = __webpack_require__(10);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(32);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(31);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _assign = __webpack_require__(26);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _regenerator = __webpack_require__(40);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(39);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _classCallCheck2 = __webpack_require__(7);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _getOwnPropertyDescriptor = __webpack_require__(23);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getOwnPropertySymbols = __webpack_require__(16);
	
	var _getOwnPropertySymbols2 = _interopRequireDefault(_getOwnPropertySymbols);
	
	var _keys = __webpack_require__(13);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _defineProperty2 = __webpack_require__(15);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var index_js = __webpack_require__(22);
	var prosemirrorState = __webpack_require__(6);
	var index_js$1 = __webpack_require__(29);
	var prosemirrorModel = __webpack_require__(12);
	var preact = __webpack_require__(24);
	var index_js$2 = __webpack_require__(56);
	
	var schema = {
	  nodes: {
	    link: {
	      inline: true,
	      attrs: {
	        id: {
	          default: ""
	        },
	        href: {
	          default: ""
	        },
	        title: {
	          default: ""
	        },
	        pageId: {
	          default: ""
	        },
	        autoUpdate: {
	          default: ""
	        },
	        isNew: {
	          default: false
	        }
	      },
	      group: "inline",
	      content: "text*",
	      defining: true,
	      parseDOM: [{
	        tag: "a[href]",
	
	        getAttrs: function getAttrs(dom) {
	          return {
	            id: index_js.uuid(),
	            href: dom.getAttribute("href"),
	            title: dom.innerText,
	            pageId: dom.getAttribute("data-pageid"),
	            autoUpdate: dom.getAttribute("data-auto_update") === "1",
	            isNew: false
	          };
	        }
	      }],
	
	      toDOM: function toDOM(node) {
	        var _node$attrs = node.attrs,
	            href = _node$attrs.href,
	            pageId = _node$attrs.pageId,
	            autoUpdate = _node$attrs.autoUpdate;
	
	        var attrs = {
	          class: "ct-link",
	          href: href,
	          "data-pageid": pageId,
	          "data-auto_update": autoUpdate ? "1" : "0"
	        };
	        return ["a", attrs, 0];
	      }
	    }
	  }
	};
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    (0, _defineProperty3.default)(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	var defineProperty = _defineProperty;
	
	function _objectSpread(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? arguments[i] : {};
	    var ownKeys = (0, _keys2.default)(source);
	
	    if (typeof _getOwnPropertySymbols2.default === 'function') {
	      ownKeys = ownKeys.concat((0, _getOwnPropertySymbols2.default)(source).filter(function (sym) {
	        return (0, _getOwnPropertyDescriptor2.default)(source, sym).enumerable;
	      }));
	    }
	
	    ownKeys.forEach(function (key) {
	      defineProperty(target, key, source[key]);
	    });
	  }
	
	  return target;
	}
	
	var objectSpread = _objectSpread;
	
	function addLink(attrs, outSelection) {
	  return function (state, dispatch) {
	    var tr = state.tr,
	        schema = state.schema;
	
	    var nodeType = schema.nodes.link;
	    var selection = outSelection || state.selection;
	    var $cursor = selection.$cursor,
	        $from = selection.$from,
	        $to = selection.$to,
	        from = selection.from,
	        to = selection.to;
	
	
	    if (selection instanceof index_js$1.GapCursor) {
	      $cursor = $from;
	    }
	
	    var text = attrs.title || attrs.href;
	
	    if ($cursor && !outSelection) {
	      var node = $cursor.nodeBefore || $cursor.nodeAfter || {
	        marks: []
	      };
	      var marks = node.marks;
	      var plus = 1;
	
	      if (selection instanceof index_js$1.GapCursor) {
	        plus = 2;
	      }
	
	      tr.insert($cursor.pos, nodeType.create(attrs, schema.text(text), marks));
	
	      if (!attrs.autoUpdate) {
	        tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, $cursor.pos + text.length + plus));
	      }
	
	      dispatch(tr.scrollIntoView());
	    } else {
	      var _node = $from.nodeAfter || $to.nodeBefore || $from.nodeBefore || $to.nodeAfter || {
	        marks: []
	      };
	      var _marks = _node.marks;
	      var _plus = 1;
	
	      tr.replaceWith(from - ($from.nodeBefore ? 0 : 1), to, nodeType.create(attrs, schema.text(text), _marks));
	
	      if (!attrs.autoUpdate) {
	        tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, from + text.length + _plus));
	      }
	
	      dispatch(tr.scrollIntoView());
	    }
	  };
	}
	
	function cancelLink() {
	  return function (state, dispatch, view) {
	    var tr = state.tr,
	        schema = state.schema,
	        selection = state.selection;
	    var $from = selection.$from;
	
	    var node = selection instanceof prosemirrorState.NodeSelection ? selection.node : $from.parent;
	
	    if (node.type.name !== "link") {
	      return false;
	    }
	
	    var from = $from.start($from.depth);
	    var to = from + node.nodeSize - 1;
	    var text = node.textContent;
	
	    if (selection instanceof prosemirrorState.NodeSelection) {
	      var dom = view.nodeDOM(from);
	      text = dom.textContent;
	    }
	
	    if (selection instanceof prosemirrorState.NodeSelection) {
	      dispatch(tr.replaceSelectionWith(schema.text(text)));
	    } else {
	      dispatch(tr.replaceWith(from - 1, to, schema.text(text)));
	    }
	  };
	}
	
	function hasLink(state) {
	  if (!state) {
	    return false;
	  }
	
	  var tr = state.tr,
	      schema = state.schema;
	
	  var nodeType = schema.nodes.link;
	  var selection = state.selection;
	  var from = selection.from,
	      to = selection.to;
	
	  var has = false;
	  tr.doc.nodesBetween(from, to, function (node) {
	    if (nodeType === node.type) {
	      has = true;
	    }
	
	    return !has;
	  });
	  return has;
	}
	
	function getLinkAttrs(state, dispatch, outSelection) {
	  if (!state) {
	    return null;
	  }
	
	  var attrs = {};
	  var tr = state.tr,
	      doc = state.doc,
	      schema = state.schema;
	
	  var nodeType = schema.nodes.link;
	  var selection = outSelection || state.selection;
	  var $from = selection.$from,
	      from = selection.from,
	      to = selection.to;
	
	  var linkNode = null;
	  var linkNodeFrom = null;
	  tr.doc.nodesBetween(from, to, function (node, pos) {
	    if (nodeType === node.type) {
	      linkNode = node;
	      linkNodeFrom = pos;
	      attrs = objectSpread({}, node.attrs, {
	        title: linkNode.textContent
	      });
	      tr.setNodeMarkup(pos, null, attrs);
	    }
	  });
	
	  if (linkNode) {
	    if (dispatch) {
	      dispatch(tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, linkNodeFrom, linkNodeFrom + linkNode.nodeSize)));
	    }
	  } else if (attrs.href) {
	    var textNode = $from.node();
	
	    if (dispatch) {
	      dispatch(tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, from, from + textNode.nodeSize)));
	    }
	
	    attrs.title = textNode.textContent;
	  } else {
	    attrs.title = doc.textBetween(from, to);
	  }
	
	  return attrs;
	}
	
	var CLASS_NAME = "ct-link";
	var AUTO_UPDATE_CLASS_NAME = CLASS_NAME + ' ' + CLASS_NAME + '-auto-update';
	var regex1 = /^(https?:\/\/)?(\w+\.?)+(\/.+)?$/i;
	var regex2 = /^((https?:\/\/|\w+(\.\w+)+)(:\w+)?).+$/;
	var regex3 = /^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
	
	var LinkView = function LinkView(node, view, getPos, store) {
	  var _this = this;
	
	  (0, _classCallCheck3.default)(this, LinkView);
	
	  this.dom = void 0;
	  this.contentDOM = void 0;
	  this.node = void 0;
	  this.view = void 0;
	  this.getPos = void 0;
	  this.store = void 0;
	
	  this.destroy = function () {
	    _this.dom.removeEventListener("click", _this.handleClick);
	  };
	
	  this.handleClick = function (e) {
	    e.preventDefault();
	
	    if (_this.node.attrs.autoUpdate) {
	      var _view = _this.view,
	          dispatch = _view.dispatch,
	          _view$state = _view.state,
	          doc = _view$state.doc,
	          tr = _view$state.tr;
	
	      var newSelection = prosemirrorState.NodeSelection.create(doc, _this.getPos());
	      dispatch(tr.setSelection(newSelection));
	    }
	  };
	
	  this.setTitle = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	    var _node$attrs2, pageId, cacheKey, autoUpdate, href, docId, data, res;
	
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            _node$attrs2 = _this.node.attrs, pageId = _node$attrs2.pageId, cacheKey = _node$attrs2.id, autoUpdate = _node$attrs2.autoUpdate, href = _node$attrs2.href;
	            docId = pageId;
	            _context.prev = 2;
	
	            if (!(!docId && autoUpdate)) {
	              _context.next = 8;
	              break;
	            }
	
	            _context.next = 6;
	            return _this.store.checkPageTitle(href);
	
	          case 6:
	            data = _context.sent;
	
	            docId = data ? data.pageId : "";
	
	          case 8:
	            if (docId) {
	              _context.next = 11;
	              break;
	            }
	
	            _this.dom.innerText = href;
	            return _context.abrupt('return');
	
	          case 11:
	            _context.next = 13;
	            return _this.store.getTitleByPageId(docId, cacheKey);
	
	          case 13:
	            res = _context.sent;
	
	
	            if (res && res.length && res[0]) {
	              _this.dom.innerText = res[0];
	            } else {
	              _this.dom.innerText = _this.node.attrs.title;
	            }
	            _context.next = 20;
	            break;
	
	          case 17:
	            _context.prev = 17;
	            _context.t0 = _context['catch'](2);
	
	            _this.dom.innerText = _this.node.attrs.title;
	
	          case 20:
	
	            if (_this.store.editor.catalogStore && _this.store.editor.catalogStore.update) {
	              _this.store.editor.catalogStore.update();
	            }
	
	          case 21:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, _this, [[2, 17]]);
	  }));
	
	  this.initPageIdAndAutoUpdate = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	    var _node$attrs3, href, id, attrs, res, _view2, dispatch, tr;
	
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            _node$attrs3 = _this.node.attrs, href = _node$attrs3.href, id = _node$attrs3.id;
	            attrs = objectSpread({}, _this.node.attrs, {
	              isNew: false
	            });
	            _context2.next = 4;
	            return _this.store.checkPageTitle(href);
	
	          case 4:
	            res = _context2.sent;
	
	            (0, _assign2.default)(attrs, {
	              pageId: res ? res.pageId : "",
	              autoUpdate: !!res,
	              id: id || index_js.uuid()
	            });
	            _view2 = _this.view, dispatch = _view2.dispatch, tr = _view2.state.tr;
	
	
	            try {
	              dispatch(tr.setNodeMarkup(_this.getPos(), undefined, attrs));
	            } catch (e) {
	              console.error(e);
	            }
	
	          case 8:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, _this);
	  }));
	
	  var _node$attrs4 = node.attrs,
	      _href = _node$attrs4.href,
	      title = _node$attrs4.title,
	      _autoUpdate = _node$attrs4.autoUpdate,
	      isNew = _node$attrs4.isNew;
	
	  var _attrs = {
	    href: _href,
	    target: "_blank",
	    rel: "noopener",
	    innerText: title,
	    className: _autoUpdate ? AUTO_UPDATE_CLASS_NAME : CLASS_NAME
	  };
	  this.node = node;
	  this.view = view;
	  this.getPos = getPos;
	  this.store = store;
	  this.dom = document.createElement("a");
	  this.dom.addEventListener("click", this.handleClick);
	  (0, _assign2.default)(this.dom, _attrs);
	
	  if (isNew) {
	    this.initPageIdAndAutoUpdate();
	  } else {
	    if (!_autoUpdate) {
	      this.contentDOM = this.dom;
	    } else {
	      this.setTitle();
	    }
	  }
	};
	
	var pluginKey = new prosemirrorState.PluginKey("link");
	
	var createPlugin = function createPlugin(store) {
	  return new prosemirrorState.Plugin({
	    key: pluginKey,
	    props: {
	      handleDOMEvents: {
	        keydown: function keydown(view, event) {
	          if (event.key !== 'Enter') {
	            return false;
	          }
	
	          var state = view.state;
	          var dispatch = view.dispatch;
	          var tr = state.tr,
	              schema = state.schema,
	              selection = state.selection;
	          var $from = selection.$from;
	
	          var link = schema.nodes.link;
	          var foundNode = index_js.findParentNode($from.path, function (node) {
	            return node.type === link;
	          });
	
	          if (foundNode) {
	            var node = foundNode.node,
	                pos = foundNode.pos;
	
	            var newSelection = prosemirrorState.TextSelection.create(tr.doc, pos + node.nodeSize);
	            dispatch(tr.setSelection(newSelection));
	            view.focus();
	            return true;
	          }
	
	          return false;
	        }
	      },
	      handleClick: function handleClick(view, pos1, e) {
	        if (e.button !== 0) {
	          return false;
	        }
	
	        var _view$state2 = view.state,
	            tr = _view$state2.tr,
	            selection = _view$state2.selection,
	            schema = _view$state2.schema;
	        var link = schema.nodes.link;
	        var $cursor = selection.$cursor;
	
	
	        var assert = function assert(node) {
	          return node.type === link;
	        };
	
	        var foundNode = $cursor && index_js.findParentNode($cursor.path, assert);
	
	        if (foundNode) {
	          var pos = foundNode.pos;
	          var linkDOM = view.docView.domFromPos(pos + 1).node;
	          store.showPopover({
	            dom: linkDOM,
	            selection: tr.selection
	          });
	        }
	
	        return false;
	      },
	      handleDoubleClick: function handleDoubleClick(view) {
	        var state = view.state,
	            dispatch = view.dispatch;
	        var tr = state.tr,
	            selection = state.selection,
	            schema = state.schema;
	        var link = schema.nodes.link;
	        var $cursor = selection.$cursor;
	
	
	        var assert = function assert(node) {
	          return node.type === link;
	        };
	
	        var foundNode = $cursor && index_js.findParentNode($cursor.path, assert);
	
	        if (foundNode) {
	          var pos = foundNode.pos;
	          var linkDOM = view.docView.domFromPos(pos + 1).node;
	          dispatch(tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, pos + 1, pos + foundNode.node.nodeSize)));
	          store.openModal({
	            href: linkDOM.href,
	            title: linkDOM.innerText
	          }, 1);
	          return true;
	        }
	
	        return false;
	      },
	      handleKeyDown: function handleKeyDown() {
	        if (store.hasPopover) {
	          store.hidePopover();
	        }
	      },
	      transformPasted: function transformPasted(slice) {
	        var view = store.view;
	        var state = view.state;
	        var schema = state.schema;
	        var _schema$nodes = schema.nodes,
	            link = _schema$nodes.link,
	            paragraph = _schema$nodes.paragraph,
	            text = _schema$nodes.text;
	
	        var allTransformCount = 0;
	
	        var transferNode = function transferNode(node) {
	          var textContent = node.textContent;
	          var urlReg = /((https?:\/\/|www\.)[-A-Za-z0-9+&@#/%=~_|.:*[\]=?,]+)/g;
	          var mailReg = /([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+/g;
	          var attrs = null;
	
	          if (urlReg.test(textContent)) {
	            attrs = {
	              href: textContent,
	              title: textContent,
	              autoUpdate: true,
	              isNew: true
	            };
	          }
	
	          if (mailReg.test(textContent)) {
	            attrs = {
	              href: 'mailto:' + textContent,
	              title: textContent,
	              autoUpdate: true,
	              isNew: true
	            };
	          }
	
	          if (attrs) {
	            node.type === text ? allTransformCount += 2 : void 0;
	
	            return link.create(attrs, schema.text(textContent), node.marks);
	          }
	
	          return node;
	        };
	
	        slice.content.content = slice.content.content.map(function (node) {
	          if (node.type === link || node.type === text) {
	            return transferNode(node);
	          }
	
	          if (node.type === paragraph) {
	            var transformCount = 0;
	            var newNodeList = [];
	            node.content.content.map(function (textNode, index) {
	              var newReg = /((?:https?:\/\/|www\.)[-A-Za-z0-9+&@#/%=~_|.:*[\]=?,]+)/g;
	              var newMailReg = /((?:[a-zA-Z0-9_.-])+@(?:(?:[a-zA-Z0-9-])+\.)+(?:[a-zA-Z0-9]{2,4}))+/g;
	              var textContent = textNode.textContent;
	              var needTransferUrl = textNode.type === text && newReg.test(textContent);
	              var needTransferMail = textNode.type === text && newMailReg.test(textContent);
	
	              if (needTransferUrl || needTransferMail) {
	                var splitReg = needTransferUrl ? newReg : newMailReg;
	                var textArr = textContent.split(splitReg).filter(function (item) {
	                  return item !== '';
	                });
	                var nodeArr = textArr.map(function (innerText) {
	                  var newLinkNode = transferNode(schema.text(innerText));
	                  if (newLinkNode.type !== text) transformCount += 2;
	                  return newLinkNode;
	                });
	                newNodeList = newNodeList.concat(nodeArr);
	              } else {
	                newNodeList.push(textNode);
	              }
	            });
	            node.content.size += transformCount;
	
	            return node.copy(prosemirrorModel.Fragment.from(newNodeList));
	          }
	
	          return node;
	        });
	        slice.content.size += allTransformCount;
	        return slice;
	      },
	      nodeViews: {
	        link: function link(node, view, getPos) {
	          return new LinkView(node, view, getPos, store);
	        }
	      }
	    },
	    view: function view(_view3) {
	      return new index_js.Popover({
	        view: _view3,
	        store: store,
	        className: "ct-link-popover",
	        sticky: false
	      });
	    }
	  });
	};
	
	function styleInject(css, ref) {
	  if (ref === void 0) ref = {};
	  var insertAt = ref.insertAt;
	
	  if (!css || typeof document === 'undefined') {
	    return;
	  }
	
	  var head = document.head || document.getElementsByTagName('head')[0];
	  var style = document.createElement('style');
	  style.type = 'text/css';
	
	  if (insertAt === 'top') {
	    if (head.firstChild) {
	      head.insertBefore(style, head.firstChild);
	    } else {
	      head.appendChild(style);
	    }
	  } else {
	    head.appendChild(style);
	  }
	
	  if (style.styleSheet) {
	    style.styleSheet.cssText = css;
	  } else {
	    style.appendChild(document.createTextNode(css));
	  }
	}
	
	var css = ".ct-link-editor .menu-item{position:relative;display:inline-block;width:36px;height:38px}.ct-link-editor .menu-item:hover{background-color:#f6f6f6!important}.ct-link-editor .menu-item.cancel{background:url(../assets/cancelLink.svg) no-repeat 50%}.ct-link-editor .menu-item.edit{background:url(../assets/editLink.svg) no-repeat 50%}.ct-link-editor .menu-item.visit{background:url(../assets/visitLink.svg) no-repeat 50%}";
	styleInject(css);
	
	var LinkEditor = function (_preact$Component) {
	  (0, _inherits3.default)(LinkEditor, _preact$Component);
	
	  function LinkEditor() {
	    var _ref3;
	
	    (0, _classCallCheck3.default)(this, LinkEditor);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this2 = (0, _possibleConstructorReturn3.default)(this, (_ref3 = LinkEditor.__proto__ || (0, _getPrototypeOf2.default)(LinkEditor)).call.apply(_ref3, [this].concat(args)));
	
	    _this2.onGlobalClick = function (e) {
	      var hidePopover = _this2.props.hidePopover;
	
	      var targetDOM = e.target;
	
	      if (!targetDOM.closest(".ct-link")) {
	        hidePopover();
	      }
	    };
	    return _this2;
	  }
	
	  (0, _createClass3.default)(LinkEditor, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.addEventListener("click", this.onGlobalClick);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener("click", this.onGlobalClick);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          cancelLink = _props.cancelLink,
	          visitLink = _props.visitLink,
	          editLink = _props.editLink;
	
	      return preact.h("div", {
	        className: "ct-link-editor"
	      }, preact.h(index_js$2.IconItem, {
	        tip: '\u53D6\u6D88\u94FE\u63A5',
	        onClick: cancelLink,
	        type: "cancelLink"
	      }), preact.h(index_js$2.IconItem, {
	        tip: '\u8BBF\u95EE\u94FE\u63A5',
	        onClick: visitLink,
	        type: "visitLink"
	      }), preact.h(index_js$2.IconItem, {
	        tip: '\u7F16\u8F91\u94FE\u63A5',
	        onClick: editLink,
	        type: "edit"
	      }));
	    }
	  }]);
	  return LinkEditor;
	}(preact.Component);
	
	var formatLink = function formatLink(href) {
	  var newHref = href.split("mailto:").reverse()[0].replace(regex1, function (match, capture) {
	    return capture ? match : 'http://' + match;
	  });
	
	  if (regex2.test(newHref) || newHref.indexOf("http") === 0) {
	    return newHref;
	  }
	
	  if (regex3.test(newHref)) {
	    return 'mailto:' + newHref;
	  }
	
	  return false;
	};
	
	var css$1 = ".ct-link-modal{padding:24px;font-size:12px}.ct-link-modal .cte-link-modal-item{color:rgba(0,0,0,.6);line-heigt:22px}.ct-link-modal .cte-link-modal-item>label{display:flex;align-items:center}.ct-link-modal .cte-link-modal-item>label span{width:60px}.ct-link-modal .cte-link-modal-item:not(:last-child){margin-bottom:16px}.ct-link-modal .cte-link-modal-item input[type=text]{width:100%;height:32px;padding:6px 8px;margin-left:12px;border-radius:4px;border:1px solid rgba(0,0,0,.13);outline:none;color:rgba(0,0,0,.87);transition:all .218s ease}.ct-link-modal .cte-link-modal-item input[type=text]:focus{border:1px solid #1c6cdc}.ct-link-modal .cte-link-modal-item input[type=text]::-webkit-input-placeholder{color:rgba(0,0,0,.24)}.ct-link-modal .cte-link-modal-item input[type=text]::-moz-placeholder{color:rgba(0,0,0,.24)}.ct-link-modal .cte-link-modal-item input[type=text]::-ms-input-placeholder{color:rgba(0,0,0,.24)}.ct-link-modal .cte-link-modal-item input[type=text]:-ms-input-placeholder{color:rgba(0,0,0,.24)}.ct-link-modal .cte-link-modal-item input[type=text]::placeholder{color:rgba(0,0,0,.24)}.ct-link-modal .input-link-href{margin-bottom:24px}.ct-link-modal .error-notice{position:absolute;top:145px;left:88px;font-size:12px;color:#f05e50}.ct-link-modal .input-link-checkbox{display:flex;margin:12px 0 0 64px;cursor:pointer}";
	styleInject(css$1);
	
	var LinkModal = function (_preact$Component2) {
	  (0, _inherits3.default)(LinkModal, _preact$Component2);
	
	  function LinkModal(props) {
	    var _this4 = this;
	
	    (0, _classCallCheck3.default)(this, LinkModal);
	
	    var _this3 = (0, _possibleConstructorReturn3.default)(this, (LinkModal.__proto__ || (0, _getPrototypeOf2.default)(LinkModal)).call(this, props));
	
	    _this3.first = true;
	    _this3.timer = null;
	    _this3.needCheckPageTitle = false;
	    _this3.cancelAutoUpdate = void 0;
	    _this3.hrefInputRef = void 0;
	    _this3.titleInputRef = void 0;
	
	    _this3.handleInputHref = function (e) {
	      var href = e.target.value.replace(/(^[\u200B\s])|([\u200B\s]$)/g, "");
	      _this3.setState({
	        href: href,
	        pageId: null,
	        error: null
	      });
	      _this3.needCheckPageTitle = true;
	
	      if (_this3.state.autoUpdate) {
	        _this3.setState({
	          disabledOk: true
	        });
	      }
	
	      if (_this3.timer !== null) {
	        clearTimeout(_this3.timer);
	      }
	
	      _this3.timer = setTimeout(function () {
	        _this3.checkPageTitle(href);
	      }, _this3.first ? 0 : 300);
	      _this3.first = false;
	    };
	
	    _this3.handleInputHrefBlur = function () {
	      if (!_this3.needCheckPageTitle) {
	        return;
	      }
	
	      if (_this3.timer !== null) {
	        clearTimeout(_this3.timer);
	      }
	
	      var href = _this3.state.href;
	
	      _this3.first = true;
	      _this3.checkPageTitle(href);
	    };
	
	    _this3.handleInputText = function (e) {
	      if (_this3.timer !== null) {
	        clearTimeout(_this3.timer);
	      }
	
	      var title = e.target.value;
	      _this3.setState({
	        title: title,
	        hadEdit: true,
	        autoUpdate: false
	      });
	    };
	
	    _this3.handleInputAutoUpdate = function () {
	      if (_this3.timer !== null) {
	        clearTimeout(_this3.timer);
	      }
	
	      var autoUpdate = !_this3.state.autoUpdate;
	      _this3.setState({
	        autoUpdate: autoUpdate
	      });
	      _this3.cancelAutoUpdate = !autoUpdate;
	
	      if (autoUpdate) {
	        _this3.setState({
	          hadEdit: false,
	          disabledOk: true
	        });
	        _this3.checkPageTitle(_this3.state.href);
	      }
	    };
	
	    _this3.checkPageTitle = function () {
	      var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(href) {
	        var checkPageTitle, hadEdit, res, title, pageId;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                checkPageTitle = _this3.props.checkPageTitle;
	                hadEdit = _this3.state.hadEdit;
	                _context3.next = 4;
	                return checkPageTitle(href);
	
	              case 4:
	                res = _context3.sent;
	
	                _this3.setState({
	                  showAutoUpdate: !!res,
	                  disabledOk: false
	                });
	                _this3.needCheckPageTitle = false;
	
	                if (!(hadEdit || _this3.cancelAutoUpdate)) {
	                  _context3.next = 9;
	                  break;
	                }
	
	                return _context3.abrupt('return');
	
	              case 9:
	
	                if (res) {
	                  title = res.title, pageId = res.pageId;
	
	
	                  if (Array.isArray(title)) {
	                    _this3.setState({
	                      title: title[0],
	                      pageId: pageId,
	                      autoUpdate: true
	                    });
	                  }
	                } else {
	                  _this3.setState({
	                    autoUpdate: false
	                  });
	                }
	
	              case 10:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this4);
	      }));
	
	      return function (_x) {
	        return _ref4.apply(this, arguments);
	      };
	    }();
	
	    _this3.handleOk = function () {
	      var addLink = _this3.props.addLink;
	      var _this3$state = _this3.state,
	          href = _this3$state.href,
	          title = _this3$state.title,
	          pageId = _this3$state.pageId,
	          hadEdit = _this3$state.hadEdit,
	          autoUpdate = _this3$state.autoUpdate;
	
	      var newHref = formatLink(href);
	
	      if (!newHref) {
	        return _this3.setState({
	          error: "请输入正确的地址"
	        });
	      }
	
	      addLink({
	        href: newHref,
	        title: title || href,
	        pageId: pageId,
	        hadEdit: hadEdit,
	        autoUpdate: autoUpdate
	      });
	      _this3.handleCancel();
	    };
	
	    _this3.handleCancel = function () {
	      var closeModal = _this3.props.closeModal;
	
	      closeModal();
	    };
	
	    var type = props.type,
	        _props$href = props.href,
	        _href = _props$href === undefined ? "" : _props$href,
	        _title = props.title,
	        _props$autoUpdate = props.autoUpdate,
	        _autoUpdate = _props$autoUpdate === undefined ? false : _props$autoUpdate;
	
	    _this3.state = {
	      href: _href,
	      title: _title,
	      autoUpdate: _autoUpdate,
	      showAutoUpdate: _autoUpdate || false,
	      error: null,
	      pageId: null,
	      hadEdit: _autoUpdate ? false : type !== 0 || !!_title,
	      disabledOk: false
	    };
	    _this3.cancelAutoUpdate = type === 0 ? false : !_autoUpdate;
	    return _this3;
	  }
	
	  (0, _createClass3.default)(LinkModal, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref5 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
	        var _state, title, href;
	
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                _state = this.state, title = _state.title, href = _state.href;
	                _context4.next = 3;
	                return this.checkPageTitle(href);
	
	              case 3:
	
	                if (title === "") {
	                  this.titleInputRef.focus();
	                } else {
	                  this.hrefInputRef.focus();
	                }
	
	              case 4:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, this);
	      }));
	
	      function componentDidMount() {
	        return _ref5.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var type = this.props.type;
	      var _state2 = this.state,
	          error = _state2.error,
	          href = _state2.href,
	          title = _state2.title,
	          autoUpdate = _state2.autoUpdate,
	          showAutoUpdate = _state2.showAutoUpdate,
	          disabledOk = _state2.disabledOk;
	
	      var autoUpdateComponent = preact.h("div", {
	        className: "input-link-checkbox ct-toolbox"
	      }, preact.h(index_js$2.CheckBox, {
	        checked: autoUpdate,
	        onClick: this.handleInputAutoUpdate
	      }, '\u94FE\u63A5\u6587\u5B57\u8DDF\u968F\u6587\u6863\u6807\u9898\u53D8\u66F4'));
	      return preact.h(index_js$2.Modal, {
	        into: "body",
	        className: "ct-link-modal",
	        title: '\u94FE\u63A5',
	        okText: type === 0 ? "插 入" : "保 存",
	        cancelText: '\u53D6 \u6D88',
	        onOk: this.handleOk,
	        onCancel: this.handleCancel,
	        canEnter: true,
	        disabled: !href.length
	      }, preact.h("div", {
	        className: "cte-link-modal-item"
	      }, preact.h("label", null, preact.h("span", null, '\u94FE\u63A5\u6587\u5B57:'), preact.h("input", {
	        ref: function ref(_ref6) {
	          return _this5.titleInputRef = _ref6;
	        },
	        type: "text",
	        placeholder: '\u8BF7\u8F93\u5165\u94FE\u63A5\u6587\u5B57',
	        value: title,
	        onInput: this.handleInputText
	      }))), preact.h("div", {
	        className: "cte-link-modal-item"
	      }, preact.h("label", null, preact.h("span", null, '\u94FE\u63A5\u5730\u5740:'), preact.h("input", {
	        ref: function ref(_ref7) {
	          return _this5.hrefInputRef = _ref7;
	        },
	        type: "text",
	        id: "ct-link-modal-href-input",
	        placeholder: '\u8BF7\u8F93\u5165\u94FE\u63A5\u5730\u5740',
	        value: href,
	        onInput: this.handleInputHref,
	        onBlur: this.handleInputHrefBlur,
	        autocomplete: "off"
	      }))), showAutoUpdate && autoUpdateComponent, error && preact.h("div", {
	        className: "error-notice"
	      }, error));
	    }
	  }]);
	  return LinkModal;
	}(preact.Component);
	
	var LinkStore = function () {
	  function LinkStore() {
	    var _this6 = this;
	
	    (0, _classCallCheck3.default)(this, LinkStore);
	
	    this.selection = null;
	    this.node = null;
	    this.modal = null;
	    this.pluginName = "link";
	    this.titleCache = new _map2.default();
	
	    this.showPopover = function (node) {
	      if (!node) {
	        return;
	      }
	
	      var dom = node.dom,
	          selection = node.selection,
	          view = node.view;
	
	      _this6.node = node;
	      _this6.ctPopover.hide();
	
	      if (view) {
	        _this6.selection = view.state.tr.selection;
	      } else {
	        _this6.selection = selection;
	      }
	
	      _this6.ctPopover.show({
	        dom: dom,
	        content: _this6.getToolbar()
	      });
	    };
	
	    this.hidePopover = function () {
	      _this6.ctPopover.hide();
	      _this6.node = null;
	    };
	
	    this.getToolbar = function () {
	      return preact.h(LinkEditor, {
	        hidePopover: _this6.hidePopover,
	        cancelLink: _this6.cancelLink,
	        visitLink: _this6.visitLink,
	        editLink: _this6.editLink
	      });
	    };
	
	    this.checkPageTitle = function () {
	      var _ref8 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5(href) {
	        var _config, customGetTitles, customGetUniqueId, pageId, title;
	
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                _config = _this6.config, customGetTitles = _config.customGetTitles, customGetUniqueId = _config.customGetUniqueId;
	
	                if (!(!customGetTitles || !customGetUniqueId)) {
	                  _context5.next = 3;
	                  break;
	                }
	
	                return _context5.abrupt('return', null);
	
	              case 3:
	                pageId = customGetUniqueId(href);
	
	                if (!(pageId === null)) {
	                  _context5.next = 6;
	                  break;
	                }
	
	                return _context5.abrupt('return', null);
	
	              case 6:
	                _context5.next = 8;
	                return customGetTitles([pageId]);
	
	              case 8:
	                title = _context5.sent;
	
	                if (!(title === null)) {
	                  _context5.next = 11;
	                  break;
	                }
	
	                return _context5.abrupt('return', null);
	
	              case 11:
	                return _context5.abrupt('return', {
	                  title: title,
	                  pageId: pageId
	                });
	
	              case 12:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, _this6);
	      }));
	
	      return function (_x2) {
	        return _ref8.apply(this, arguments);
	      };
	    }();
	
	    this.openModal = function (_ref9, type, selection) {
	      var href = _ref9.href,
	          title = _ref9.title,
	          autoUpdate = _ref9.autoUpdate;
	
	      if (!selection) {
	        _this6.selection = null;
	      }
	
	      _this6.modal = preact.render(preact.h(LinkModal, {
	        type: type,
	        href: href || "",
	        title: title || "",
	        closeModal: _this6.closeModal,
	        checkPageTitle: _this6.checkPageTitle,
	        addLink: _this6.addLink,
	        autoUpdate: autoUpdate
	      }), document.body);
	    };
	
	    this.closeModal = function () {
	      preact.render(null, document.body, _this6.modal);
	      _this6.view.focus();
	    };
	
	    this.addLink = function (newAttrs) {
	      var _view4 = _this6.view,
	          state = _view4.state,
	          dispatch = _view4.dispatch;
	
	      addLink(newAttrs)(state, dispatch);
	    };
	
	    this.cancelLink = function () {
	      var _view5 = _this6.view,
	          state = _view5.state,
	          dispatch = _view5.dispatch;
	
	      cancelLink(_this6.selection)(state, dispatch, _this6.view);
	      _this6.view.focus();
	    };
	
	    this.visitLink = function () {
	      var attrs = getLinkAttrs(_this6.view.state, _this6.view.dispatch, _this6.selection);
	      var otherWindow = window.open(attrs.href);
	      otherWindow.opener = null;
	    };
	
	    this.editLink = function () {
	      var attrs = getLinkAttrs(_this6.view.state, _this6.view.dispatch, _this6.selection);
	      _this6.openModal(attrs, 1, true);
	    };
	
	    this.getTitleByPageId = function () {
	      var _ref10 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6(pageId, cacheKey) {
	        var title;
	        return _regenerator2.default.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                if (!(pageId === "" || cacheKey === "")) {
	                  _context6.next = 2;
	                  break;
	                }
	
	                return _context6.abrupt('return', []);
	
	              case 2:
	                if (!_this6.titleCache.has(cacheKey)) {
	                  _context6.next = 4;
	                  break;
	                }
	
	                return _context6.abrupt('return', _this6.titleCache.get(cacheKey));
	
	              case 4:
	                _context6.next = 6;
	                return _this6.config.customGetTitles([pageId]);
	
	              case 6:
	                title = _context6.sent;
	
	
	                if (title && title.length && title[0]) {
	                  _this6.titleCache.set(cacheKey, title);
	                }
	
	                return _context6.abrupt('return', title);
	
	              case 9:
	              case 'end':
	                return _context6.stop();
	            }
	          }
	        }, _callee6, _this6);
	      }));
	
	      return function (_x3, _x4) {
	        return _ref10.apply(this, arguments);
	      };
	    }();
	  }
	
	  (0, _createClass3.default)(LinkStore, [{
	    key: 'init',
	    value: function init(editor) {
	      this.editor = editor;
	      this.view = editor.view;
	      this.config = editor.linkConfig;
	    }
	  }]);
	  return LinkStore;
	}();
	
	function getTitles(ids) {
	  if (!Array.isArray(ids)) {
	    ids = [ids];
	  }
	
	  return _promise2.default.resolve(ids.map(function (id) {
	    return '\u6807\u9898' + id;
	  }));
	}
	function getUniqueId(content) {
	  if (!/^https?:\/\/km\.(it\.(dev|test|beta|st)\.)?sankuai\.com\/page\/\d+/.test(content) || !content.includes(location.host) && !location.host.includes('localhost')) return null;
	  var match = content.match(/\d+/);
	  if (!match || !match[0]) return null;
	  return match[0];
	}
	var config = {
	  customGetTitles: getTitles,
	  customGetUniqueId: getUniqueId
	};
	
	var css$2 = ".ct-link{color:#1890ff;background:transparent;text-decoration:none;outline:none}.ct-link:hover{text-decoration:underline}";
	styleInject(css$2);
	
	var LinkModule = function () {
	  function LinkModule() {
	    (0, _classCallCheck3.default)(this, LinkModule);
	
	    this.name = "link";
	    this.store = new LinkStore();
	    this.schema = schema;
	    this.config = config;
	    this.commands = {
	      addLink: addLink,
	      cancelLink: cancelLink
	    };
	    this.utils = {
	      getLinkAttrs: getLinkAttrs,
	      hasLink: hasLink
	    };
	    this.plugins = [createPlugin(this.store)];
	  }
	
	  (0, _createClass3.default)(LinkModule, [{
	    key: 'init',
	    value: function init(moduleManager) {
	      this.store.init(moduleManager);
	    }
	  }]);
	  return LinkModule;
	}();
	
	LinkModule.moduleName = "link";
	
	exports.LinkModule = LinkModule;

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classCallCheck2 = __webpack_require__(7);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(10);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _getOwnPropertyDescriptor = __webpack_require__(23);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getOwnPropertySymbols = __webpack_require__(16);
	
	var _getOwnPropertySymbols2 = _interopRequireDefault(_getOwnPropertySymbols);
	
	var _keys = __webpack_require__(13);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _defineProperty2 = __webpack_require__(15);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _typeof2 = __webpack_require__(8);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault(ex) {
	  return ex && (typeof ex === 'undefined' ? 'undefined' : (0, _typeof3.default)(ex)) === 'object' && 'default' in ex ? ex['default'] : ex;
	}
	
	var keymap = _interopDefault(__webpack_require__(34));
	var index_js = __webpack_require__(22);
	var index_js$1 = __webpack_require__(29);
	var prosemirrorTransform = __webpack_require__(25);
	var prosemirrorModel = __webpack_require__(12);
	var prosemirrorState = __webpack_require__(6);
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    (0, _defineProperty3.default)(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	var defineProperty = _defineProperty;
	
	function _objectSpread(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? arguments[i] : {};
	    var ownKeys = (0, _keys2.default)(source);
	
	    if (typeof _getOwnPropertySymbols2.default === 'function') {
	      ownKeys = ownKeys.concat((0, _getOwnPropertySymbols2.default)(source).filter(function (sym) {
	        return (0, _getOwnPropertyDescriptor2.default)(source, sym).enumerable;
	      }));
	    }
	
	    ownKeys.forEach(function (key) {
	      defineProperty(target, key, source[key]);
	    });
	  }
	
	  return target;
	}
	
	var objectSpread = _objectSpread;
	
	function uuid() {
	  var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
	  var id = [];
	
	  for (var i = 0; i < 8; i++) {
	    id.push(chars[parseInt(Math.random() * chars.length, 10)]);
	  }
	
	  return id.join('');
	}
	
	var listAttrs = {
	  indent: {
	    default: 0
	  },
	  dataDiffId: {
	    default: null
	  }
	};
	
	var getListNodeAttrs = function getListNodeAttrs(node, extraAttrs) {
	  var _node$attrs = node.attrs,
	      indent = _node$attrs.indent,
	      dataDiffId = _node$attrs.dataDiffId;
	
	  var attrs = {
	    'data-diff-id': dataDiffId || 'ct-diff-id-' + uuid()
	  };
	  var style = '';
	  if (indent) style += 'margin-left: ' + indent * 20 + 'px;';
	  if (style) attrs.style = style;
	
	  if (extraAttrs) {
	    return objectSpread({}, attrs, extraAttrs);
	  }
	
	  return attrs;
	};
	
	var getItemNodeAttrs = function getItemNodeAttrs(node, extraAttrs) {
	  var dataListItemDiffId = node.attrs.dataListItemDiffId;
	
	  var attrs = {};
	  attrs['data-list-item-diff-id'] = dataListItemDiffId || 'ct-list-item-diff-id-' + uuid();
	  var firstChild = node.firstChild;
	
	  if (firstChild && firstChild.type.name === 'heading') {
	    if (extraAttrs.class) {
	      extraAttrs.class += ' ct-item-level-' + firstChild.attrs.level;
	    } else {
	      attrs.class = 'ct-item-level-' + firstChild.attrs.level;
	    }
	  }
	
	  if (extraAttrs) {
	    return objectSpread({}, attrs, extraAttrs);
	  }
	
	  return attrs;
	};
	
	var schema = {
	  nodes: {
	    task_list: {
	      attrs: listAttrs,
	      content: '(task_item | list_item)+',
	      group: 'block',
	      defining: true,
	      listRole: true,
	      parseDOM: [{
	        tag: 'ul[class="ct-task-list"]',
	        getAttrs: function getAttrs(dom) {
	          var dataDiffId = dom.getAttribute('data-diff-id');
	          var indent = parseInt(dom.style.marginLeft, 10) / 20 || 0;
	          return {
	            indent: indent,
	            dataDiffId: dataDiffId
	          };
	        }
	      }],
	
	      toDOM: function toDOM(node) {
	        var attrs = getListNodeAttrs(node, {
	          class: 'ct-task-list'
	        });
	        return ['ul', attrs, 0];
	      }
	    },
	
	    task_item: {
	      attrs: {
	        checked: {
	          default: false
	        },
	        level: {
	          default: 0
	        },
	        dataListItemDiffId: {
	          default: null
	        }
	      },
	      content: '(paragraph | block)+',
	      defining: true,
	      parseDOM: [{
	        tag: 'li[data-type="task_item"]',
	
	        getAttrs: function getAttrs(dom) {
	          var dataListItemDiffId = dom.getAttribute('data-list-item-diff-id');
	          return {
	            checked: dom.classList.contains('ct-task-li-checked'),
	            dataListItemDiffId: dataListItemDiffId
	          };
	        }
	      }],
	
	      toDOM: function toDOM(node) {
	        var attrs = getItemNodeAttrs(node, {
	          'data-type': 'task_item',
	          class: node.attrs.checked ? 'ct-task-li-checked' : 'ct-task-li'
	        });
	        return ['li', attrs, 0];
	      }
	    },
	
	    ordered_list: {
	      attrs: listAttrs,
	      content: '(list_item | task_item)+',
	      group: 'block',
	      defining: true,
	      listRole: true,
	      parseDOM: [{
	        tag: 'ol',
	        getAttrs: function getAttrs(dom) {
	          var indent = parseInt(dom.style.marginLeft, 10) / 20 || 0;
	          var dataDiffId = dom.getAttribute('data-diff-id');
	          return {
	            indent: indent,
	            dataDiffId: dataDiffId
	          };
	        }
	      }],
	
	      toDOM: function toDOM(node) {
	        var attrs = getListNodeAttrs(node);
	        return ['ol', attrs, 0];
	      }
	    },
	
	    bullet_list: {
	      attrs: listAttrs,
	      content: '(list_item | task_item)+',
	      group: 'block',
	      defining: true,
	      listRole: true,
	      parseDOM: [{
	        tag: 'ul',
	        getAttrs: function getAttrs(dom) {
	          var indent = parseInt(dom.style.marginLeft, 10) / 20 || 0;
	          var dataDiffId = dom.getAttribute('data-diff-id');
	          return {
	            indent: indent,
	            dataDiffId: dataDiffId
	          };
	        }
	      }],
	
	      toDOM: function toDOM(node) {
	        var attrs = getListNodeAttrs(node);
	        return ['ul', attrs, 0];
	      }
	    },
	
	    list_item: {
	      attrs: {
	        level: {
	          default: 0
	        },
	        hidden: {
	          default: false
	        },
	        dataListItemDiffId: {
	          default: null
	        }
	      },
	      content: '(paragraph | block)+',
	      defining: true,
	      parseDOM: [{
	        tag: 'li',
	
	        getAttrs: function getAttrs(dom) {
	          var dataListItemDiffId = dom.getAttribute('data-list-item-diff-id');
	          var hidden = dom.classList.contains('ct-hidden-item');
	          return {
	            hidden: hidden,
	            dataListItemDiffId: dataListItemDiffId
	          };
	        }
	      }],
	
	      toDOM: function toDOM(node) {
	        var attrs = getItemNodeAttrs(node, node.attrs.hidden ? {
	          class: 'ct-hidden-item'
	        } : {});
	        return ['li', attrs, 0];
	      }
	    }
	  }
	};
	
	function judgeListType(state, listType) {
	  if (!state) return false;
	  var selection = state.selection,
	      tr = state.tr;
	
	
	  if (selection.constructor.name === 'CellSelection') {
	    var has = false;
	    var firstRange = selection.ranges[0];
	    var from = firstRange.$from.pos;
	    var to = firstRange.$to.pos;
	    tr.doc.nodesBetween(from, to, function (node, pos, parent) {
	      if (has) return;
	      if (node.type === listType) has = true;
	    });
	    return has;
	  }
	
	  return !!index_js.findParentNode(selection.$from.path, function (node) {
	    return node.type === listType;
	  });
	}
	function isInList(state) {
	  if (!state) return false;
	  var _state$selection = state.selection,
	      $from = _state$selection.$from,
	      $to = _state$selection.$to;
	
	  var range = $from.blockRange($to);
	  if (!range) return false;
	  var _state$schema$nodes = state.schema.nodes,
	      bullet_list = _state$schema$nodes.bullet_list,
	      ordered_list = _state$schema$nodes.ordered_list,
	      task_list = _state$schema$nodes.task_list;
	
	  var listTypes = [bullet_list, ordered_list, task_list];
	  var depth0Node = $from.node(range.depth);
	  var depth1Node = $from.node(range.depth - 1);
	  var depth1NodeType = depth1Node && depth1Node.type;
	  var depth0NodeType = depth0Node && depth0Node.type;
	  return listTypes.some(function (type) {
	    return type === depth1NodeType || type === depth0NodeType;
	  });
	}
	
	function wrapInList(listType, attrs) {
	  return function (state, dispatch) {
	    var doc = state.doc,
	        tr = state.tr;
	
	    var transaction = tr;
	    var selection = state.selection;
	
	    if (selection.$from.depth === 0 && selection.$from.pos === 0) {
	      selection = prosemirrorState.TextSelection.create(tr.doc, 1);
	      transaction.setSelection(selection);
	    }
	
	    selection.ranges.forEach(function (selRange, i) {
	      var _transaction$selectio = transaction.selection.ranges[i],
	          $from = _transaction$selectio.$from,
	          $to = _transaction$selectio.$to;
	
	      var range = $from.blockRange($to);
	      var doJoin = false;
	      var outerRange = range;
	      if (!range) return false;
	      var fromParent = $from.parent;
	      var toParent = $to.parent;
	      var isSelectRange = fromParent !== toParent || fromParent.type.name === 'doc' && toParent.type.name === 'doc';
	
	      if (range.depth >= 2 && $from.node(range.depth - 1).type.compatibleContent(listType) && range.startIndex === 0) {
	        if ($from.index(range.depth - 1) === 0) return false;
	        var $insert = doc.resolve(range.start - 2);
	        outerRange = new prosemirrorModel.NodeRange($insert, $insert, range.depth);
	
	        if (range.endIndex < range.parent.childCount) {
	          range = new prosemirrorModel.NodeRange($from, doc.resolve($to.end(range.depth)), range.depth);
	        }
	
	        doJoin = true;
	      }
	
	      var wrappers = prosemirrorTransform.findWrapping(outerRange, listType, attrs, range);
	
	      if (!wrappers) {
	        var parentBlockNode = index_js.findParentNode($from.path, function (node) {
	          return node.type && node.type.isBlock;
	        });
	        var newSelection = prosemirrorState.NodeSelection.create(tr.doc, parentBlockNode.pos);
	        $from = newSelection.$from;
	        $to = newSelection.$to;
	        range = $from.blockRange($to);
	        doJoin = false;
	        outerRange = range;
	        if (!range) return false;
	
	        if (range.depth >= 2 && $from.node(range.depth - 1).type.compatibleContent(listType) && range.startIndex === 0) {
	          if ($from.index(range.depth - 1) === 0) return false;
	          var _$insert = doc.resolve(range.start - 2);
	          outerRange = new prosemirrorModel.NodeRange(_$insert, _$insert, range.depth);
	
	          if (range.endIndex < range.parent.childCount) {
	            range = new prosemirrorModel.NodeRange($from, doc.resolve($to.end(range.depth)), range.depth);
	          }
	
	          doJoin = true;
	        }
	
	        wrappers = prosemirrorTransform.findWrapping(outerRange, listType, attrs, range);
	        if (!wrappers) return false;
	      }
	
	      transaction = doWrapInList(transaction, range, wrappers, doJoin, listType, isSelectRange);
	    });
	    if (dispatch) dispatch(transaction);
	    return true;
	  };
	}
	
	function doWrapInList(tr, range, wrappers, joinBefore, listType, isSelectRange) {
	  var start = range.start,
	      end = range.end;
	
	  var content = prosemirrorModel.Fragment.empty;
	
	  for (var i = wrappers.length - 1; i >= 0; i--) {
	    var attrs = null;
	
	    if (!isSelectRange && wrappers[i].type === listType) {
	      attrs = {
	        indent: range.$from.parent.attrs.indent
	      };
	    }
	
	    content = prosemirrorModel.Fragment.from(wrappers[i].type.create(attrs || wrappers[i].attrs, content));
	  }
	
	  tr.step(new prosemirrorTransform.ReplaceAroundStep(start - (joinBefore ? 2 : 0), end, start, end, new prosemirrorModel.Slice(content, 0, 0), wrappers.length, true));
	  var found = 0;
	
	  for (var _i = 0; _i < wrappers.length; _i++) {
	    if (wrappers[_i].type === listType) {
	      found = _i + 1;
	    }
	  }
	
	  var splitDepth = wrappers.length - found;
	  var splitPos = start + wrappers.length - (joinBefore ? 2 : 0),
	      parent = range.parent;
	  var childNodes = [];
	
	  for (var _i2 = range.startIndex, e = range.endIndex, first = true; _i2 < e; _i2++, first = false) {
	    var childNode = parent.child(_i2);
	    childNodes.push(childNode);
	    if (!first && prosemirrorTransform.canSplit(tr.doc, splitPos, splitDepth)) tr.split(splitPos, splitDepth);
	    splitPos += childNode.nodeSize + (first ? 0 : 2 * splitDepth);
	  }
	
	  tr.doc.nodesBetween(start, end + childNodes.length * 2 + 2, function (node, pos) {
	    if (childNodes.includes(node)) {
	      tr.setNodeMarkup(pos, null, objectSpread({}, node.attrs, {
	        indent: 0
	      }));
	    }
	  });
	  return tr;
	}
	
	function _unwrapList(state, dispatch) {
	  var tr = state.tr,
	      selection = state.selection;
	  var _state$schema$nodes2 = state.schema.nodes,
	      list_item = _state$schema$nodes2.list_item,
	      task_item = _state$schema$nodes2.task_item;
	
	  var isCellSelection = selection.constructor.name === 'CellSelection';
	  var transaction = tr;
	  selection.ranges.forEach(function (selRange, i) {
	    var _transaction$selectio2 = transaction.selection.ranges[i],
	        $from = _transaction$selectio2.$from,
	        $to = _transaction$selectio2.$to;
	
	
	    if (isCellSelection) {
	      var trueSelection = prosemirrorState.TextSelection.create(transaction.doc, $from.pos + 2, $to.pos - 2);
	      $from = trueSelection.$from;
	      $to = trueSelection.$to;
	    }
	
	    var range = $from.blockRange($to, function (node) {
	      return node.childCount && (node.firstChild.type === list_item || node.firstChild.type === task_item);
	    });
	    if (!range) return false;
	    var outTransaction = liftOutOfList(transaction, range);
	    if (outTransaction) transaction = outTransaction;
	  });
	  if (dispatch) dispatch(transaction);
	  return true;
	}
	
	function _sinkListItem(state, dispatch) {
	  var tr = state.tr,
	      selection = state.selection,
	      schema = state.schema;
	  var _schema$nodes = schema.nodes,
	      list_item = _schema$nodes.list_item,
	      task_item = _schema$nodes.task_item;
	  var $from = selection.$from,
	      $to = selection.$to;
	
	  var range = $from.blockRange($to, function (node) {
	    return node.childCount && (node.firstChild.type === list_item || node.firstChild.type === task_item);
	  });
	  if (!range) return false;
	  var startIndex = range.startIndex;
	
	  if (startIndex === 0) {
	    var _parentNode = range.parent;
	    var indent = _parentNode.attrs.indent + 1;
	    var rangeFrom = range.$from.pos;
	    var rangeTo = range.$to.pos;
	    tr.doc.nodesBetween(rangeFrom, rangeTo, function (node, pos) {
	      if (node === _parentNode) dispatch(tr.setNodeMarkup(pos, node.type, objectSpread({}, node.attrs, {
	        indent: indent
	      })));
	    });
	    return true;
	  }
	
	  var parentNode = range.parent,
	      nodeBefore = parentNode.child(startIndex - 1);
	  if (nodeBefore.type !== list_item && nodeBefore.type !== task_item) return true;
	
	  if (dispatch) {
	    var nestedBefore = nodeBefore.lastChild && nodeBefore.lastChild.type === parentNode.type;
	    var inner = prosemirrorModel.Fragment.from(nestedBefore ? nodeBefore.type.create() : null);
	    var slice = new prosemirrorModel.Slice(prosemirrorModel.Fragment.from(nodeBefore.type.create(null, prosemirrorModel.Fragment.from(parentNode.type.create(null, inner)))), nestedBefore ? 3 : 1, 0);
	    var before = range.start,
	        after = range.end;
	    dispatch(tr.step(new prosemirrorTransform.ReplaceAroundStep(before - (nestedBefore ? 3 : 1), after, before, after, slice, 1, true)));
	  }
	
	  return true;
	}
	
	function _liftListItem(state, dispatch) {
	  var tr = state.tr,
	      selection = state.selection,
	      schema = state.schema;
	  var _schema$nodes2 = schema.nodes,
	      list_item = _schema$nodes2.list_item,
	      task_item = _schema$nodes2.task_item;
	
	  var itemTypes = [list_item, task_item];
	  var $from = selection.$from,
	      $to = selection.$to;
	
	  var range = $from.blockRange($to, function (node) {
	    return node.childCount && itemTypes.includes(node.firstChild.type);
	  });
	  if (!range) return false;
	  var rangeParent = range.parent;
	
	  if (range.startIndex === 0 && rangeParent.attrs.indent !== 0) {
	    var indent = rangeParent.attrs.indent - 1;
	    var rangeFrom = range.$from.pos;
	    var rangeTo = range.$to.pos;
	    tr.doc.nodesBetween(rangeFrom, rangeTo, function (node, pos) {
	      if (node === rangeParent) {
	        dispatch(tr.setNodeMarkup(pos, node.type, objectSpread({}, node.attrs, {
	          indent: indent
	        })));
	      }
	    });
	    return true;
	  }
	
	  var itemType = $from.node(range.depth - 1).type;
	
	  if (itemTypes.includes(itemType)) {
	    return liftToOuterList(state, dispatch, itemType, range);
	  }
	
	  var transaction = liftOutOfList(tr, range);
	  return transaction && dispatch(transaction);
	}
	
	function liftToOuterList(state, dispatch, itemType, range) {
	  var tr = state.tr,
	      end = range.end,
	      endOfList = range.$to.end(range.depth);
	
	  if (end < endOfList) {
	    tr.step(new prosemirrorTransform.ReplaceAroundStep(end - 1, endOfList, end, endOfList, new prosemirrorModel.Slice(prosemirrorModel.Fragment.from(itemType.create(null, range.parent.copy())), 1, 0), 1, true));
	    range = new prosemirrorModel.NodeRange(tr.doc.resolveNoCache(range.$from.pos), tr.doc.resolveNoCache(endOfList), range.depth);
	  }
	
	  var rangeParent = range.parent;
	  var rangeFrom = range.$from.pos;
	  var rangeTo = range.$to.pos;
	  var transaction = tr;
	  tr.doc.nodesBetween(rangeFrom, rangeTo, function (node, pos, parent) {
	    if (parent === rangeParent) {
	      transaction = transaction.setNodeMarkup(pos, itemType, node.attrs);
	    }
	  });
	  dispatch(transaction.lift(range, prosemirrorTransform.liftTarget(range)));
	  return true;
	}
	
	function liftOutOfList(tr, range) {
	  var transaction = tr;
	  var list = range.parent;
	
	  for (var pos = range.end, i = range.endIndex - 1, e = range.startIndex; i > e; i--) {
	    pos -= list.child(i).nodeSize;
	    transaction.delete(pos - 1, pos + 1);
	  }
	
	  var $start = transaction.doc.resolve(range.start),
	      item = $start.nodeAfter;
	  var atStart = range.startIndex == 0,
	      atEnd = range.endIndex == list.childCount;
	  var parent = $start.node(-1),
	      indexBefore = $start.index(-1);
	
	  if (!parent.canReplace(indexBefore + (atStart ? 0 : 1), indexBefore + 1, item.content.append(atEnd ? prosemirrorModel.Fragment.empty : prosemirrorModel.Fragment.from(list)))) {
	    return false;
	  }
	
	  var start = $start.pos,
	      end = start + item.nodeSize;
	  var slice = new prosemirrorModel.Slice((atStart ? prosemirrorModel.Fragment.empty : prosemirrorModel.Fragment.from(list.copy(prosemirrorModel.Fragment.empty))).append(atEnd ? prosemirrorModel.Fragment.empty : prosemirrorModel.Fragment.from(list.copy(prosemirrorModel.Fragment.empty))), atStart ? 0 : 1, atEnd ? 0 : 1);
	  transaction.step(new prosemirrorTransform.ReplaceAroundStep(start - (atStart ? 1 : 0), end + (atEnd ? 1 : 0), start + 1, end - 1, slice, atStart ? 0 : 1));
	  return transaction;
	}
	
	function liftOutFirstOfList(state, dispatch, range) {
	  var tr = state.tr,
	      schema = state.schema;
	  var _schema$nodes3 = schema.nodes,
	      list_item = _schema$nodes3.list_item,
	      task_list = _schema$nodes3.task_list,
	      ordered_list = _schema$nodes3.ordered_list,
	      bullet_list = _schema$nodes3.bullet_list;
	
	  var listTypes = [task_list, ordered_list, bullet_list];
	  var list = range.parent;
	
	  for (var pos = range.end, i = range.endIndex - 1, e = range.startIndex; i > e; i--) {
	    pos -= list.child(i).nodeSize;
	    tr.delete(pos - 1, pos + 1);
	  }
	
	  var $start = tr.doc.resolve(range.start);
	  var item = $start.nodeAfter;
	  var itemContent = item.content.content;
	  var listContent = list.content.content;
	  var newListContent = [];
	  var outNodes = [];
	  itemContent.forEach(function (node) {
	    if (listTypes.includes(node.type)) {
	      newListContent.push(list_item.create({
	        hidden: true
	      }, prosemirrorModel.Fragment.from(node)));
	    } else {
	      outNodes.push(node);
	    }
	  });
	  newListContent = newListContent.concat(listContent.slice(1));
	  var newList = list.copy(prosemirrorModel.Fragment.from(newListContent));
	  var newNodes = [].concat(outNodes, [newList]);
	  var start = range.start;
	  var end = start + list.nodeSize;
	  tr.replaceWith(start - 1, end - 1, prosemirrorModel.Fragment.from(newNodes));
	  dispatch(tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, start)));
	  return true;
	}
	
	var getTypes = function getTypes(listType, schema) {
	  var _schema$nodes4 = schema.nodes,
	      bullet_list = _schema$nodes4.bullet_list,
	      ordered_list = _schema$nodes4.ordered_list,
	      task_list = _schema$nodes4.task_list,
	      list_item = _schema$nodes4.list_item,
	      task_item = _schema$nodes4.task_item;
	
	  var otherListTypes = [];
	  var itemType = list_item;
	  var otherItemTypes = [task_item];
	
	  if (listType === bullet_list) {
	    otherListTypes = [ordered_list, task_list];
	  } else if (listType === ordered_list) {
	    otherListTypes = [bullet_list, task_list];
	  } else {
	    itemType = task_item;
	    otherItemTypes = [list_item];
	    otherListTypes = [ordered_list, bullet_list];
	  }
	
	  return {
	    itemType: itemType,
	    otherListTypes: otherListTypes,
	    otherItemTypes: otherItemTypes
	  };
	};
	
	function transformList(listType) {
	  return function (state, dispatch) {
	    var tr = state.tr,
	        selection = state.selection,
	        schema = state.schema;
	
	    var _getTypes = getTypes(listType, schema),
	        itemType = _getTypes.itemType,
	        otherListTypes = _getTypes.otherListTypes,
	        otherItemTypes = _getTypes.otherItemTypes;
	
	    var isCellSelection = selection.constructor.name === 'CellSelection';
	    var transaction = tr;
	    selection.ranges.forEach(function (selRange, i) {
	      var _transaction$selectio3 = transaction.selection.ranges[i],
	          $from = _transaction$selectio3.$from,
	          $to = _transaction$selectio3.$to;
	
	
	      if (isCellSelection) {
	        var trueSelection = prosemirrorState.TextSelection.create(transaction.doc, $from.pos + 2, $to.pos - 2);
	        $from = trueSelection.$from;
	        $to = trueSelection.$to;
	      }
	
	      var node = index_js.findParentNode($from.path, function (node) {
	        return otherListTypes.includes(node.type);
	      });
	      if (!node) return;
	      var from = node.pos;
	      var to = node.node.nodeSize + from;
	      var lastItemPos = null;
	      var lastItemNode = null;
	      transaction.doc.nodesBetween(from, to, function (node, pos) {
	        if (otherListTypes.includes(node.type)) {
	          if (pos + 4 > from) {
	            transaction = transaction.setNodeMarkup(pos, listType, node.attrs);
	          }
	        } else if (otherItemTypes.includes(node.type)) {
	          if (pos - 2 > from) {
	            transaction = transaction.setNodeMarkup(pos, itemType, node.attrs);
	          } else {
	            lastItemPos = pos;
	            lastItemNode = node;
	          }
	        }
	      });
	      if (lastItemPos) transaction = transaction.setNodeMarkup(lastItemPos, itemType, lastItemNode.attrs);
	    });
	    dispatch(transaction);
	    return true;
	  };
	}
	
	function handleBackspace(state, dispatch, view) {
	  var tr = state.tr,
	      selection = state.selection,
	      schema = state.schema;
	  var _schema$nodes5 = schema.nodes,
	      list_item = _schema$nodes5.list_item,
	      task_item = _schema$nodes5.task_item;
	
	  var itemTypes = [list_item, task_item];
	  var $cursor = selection.$cursor,
	      $from = selection.$from,
	      from = selection.from,
	      $to = selection.$to,
	      to = selection.to;
	
	
	  if (selection instanceof index_js$1.GapCursor) {
	    try {
	      $cursor = tr.doc.resolve(from);
	    } catch (error) {
	      console.error(error);
	    }
	  }
	
	  if ($cursor && $cursor.parent.type.name === 'doc' && $cursor.nodeBefore && $cursor.nodeBefore.type.name.includes('list') && $cursor.nodeAfter && $cursor.nodeAfter.type.isBlock) {
	    var newPos = from - 3;
	    dispatch(tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, newPos)));
	    return true;
	  }
	
	  if ($from.parentOffset === 0) {
	    var fromNodeParent = $from.node(-1);
	    var toNodeParent = $to.node(-1);
	    if (!fromNodeParent) return false;
	
	    if ($cursor) {
	      var isBeforeTable = $cursor.nodeAfter && $cursor.nodeAfter.type.name === 'table';
	      var parentTypeIsInline = $cursor.parent.type.isInline;
	      var plus = parentTypeIsInline ? 2 : 1;
	      var cursorNodeParent = isBeforeTable ? $cursor.node() : $cursor.node(-plus);
	      var cursorNode = parentTypeIsInline ? $cursor.node(-1) : $cursor.node();
	      var cursor = from - plus + 1;
	      var nodeAfter = $to.nodeAfter;
	
	      var isDocHead = cursor === plus;
	
	      var isLastChild = cursorNodeParent.lastChild === cursorNode;
	      var nodePreRow = isDocHead ? null : view.domAtPos(cursor - 2).node;
	
	      var nodePreRowName = nodePreRow && nodePreRow.nodeName.toUpperCase();
	
	      if (nodePreRowName === 'UL' || nodePreRowName === 'OL') {
	        if (!itemTypes.includes(cursorNodeParent.type)) {
	          var indent = 3 + plus;
	          var parent = nodePreRow;
	          var nodeName = void 0;
	
	          while (true) {
	            var lastChild = parent.lastElementChild.lastElementChild;
	            nodeName = lastChild.nodeName.toUpperCase();
	
	            if (nodeName !== 'UL' && nodeName !== 'OL') {
	              break;
	            }
	
	            parent = lastChild;
	            indent += 2;
	          }
	
	          if (nodeName !== 'P' && nodeName[0] !== 'h') {
	            indent -= 1;
	          }
	
	          var _newPos = cursor - indent;
	
	          if (!nodeAfter) {
	            tr.delete(cursor - 1, to + 1);
	            tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, _newPos));
	          } else {
	            var cursorNodeSize = cursorNode.nodeSize;
	
	            if (isLastChild) {
	              tr.delete(cursor, cursor + cursorNodeSize - 1);
	            } else {
	              tr.delete(cursor, cursor + cursorNodeSize);
	            }
	
	            if (cursorNode.content.childCount) {
	              tr.insert(_newPos, cursorNode.content);
	              tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, _newPos));
	            } else {
	              tr.insert(_newPos, cursorNode);
	              tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, _newPos + 1));
	            }
	          }
	
	          dispatch(tr);
	          return true;
	        } else if (cursorNode === cursorNodeParent.content.content[0]) {
	          var range = $cursor.blockRange($cursor, function (node) {
	            return node.childCount && node.firstChild.type === cursorNodeParent.type;
	          });
	          if (!range) return false;
	          var rangeParent = range.parent;
	          var content = rangeParent.content.content;
	
	          if (content[0] !== cursorNodeParent) {
	            var newList = rangeParent.copy(prosemirrorModel.Fragment.from(content.filter(function (n) {
	              return n !== cursorNodeParent;
	            })));
	            var start = $cursor.path[$cursor.path.length - (parentTypeIsInline ? 13 : 10)];
	            var end = start + rangeParent.nodeSize;
	            tr.replaceWith(start, end, newList);
	            tr.insert(cursor - 3, prosemirrorModel.Fragment.from(cursorNodeParent.content));
	            dispatch(tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, cursor - 2)));
	            return true;
	          }
	
	          if (content.length === 1) {
	            var transaction = liftOutOfList(tr, range);
	            return transaction && dispatch(transaction);
	          }
	
	          return liftOutFirstOfList(state, dispatch, range);
	        }
	      } else if (nodePreRowName === 'LI' && isBeforeTable) {
	        var _range = $cursor.blockRange($cursor, function (node) {
	          return node.childCount && node.firstChild.type === cursorNodeParent.type;
	        });
	        if (!_range) return false;
	        var _rangeParent = _range.parent;
	        var _content = _rangeParent.content.content;
	
	        if (_content[0] !== cursorNodeParent) {
	          var _newList = _rangeParent.copy(prosemirrorModel.Fragment.from(_content.filter(function (n) {
	            return n !== cursorNodeParent;
	          })));
	          var _start = $cursor.path[$cursor.path.length - 2];
	          var _end = _start + _rangeParent.nodeSize;
	          tr.replaceWith(_start, _end, _newList);
	          tr.insert(cursor - 3, prosemirrorModel.Fragment.from(cursorNodeParent.content));
	          dispatch(tr.setSelection(new index_js$1.GapCursor(tr.doc.resolve(cursor - 2))));
	          return true;
	        }
	      }
	
	      return false;
	    } else if ($to.parentOffset === $to.node().content.size && fromNodeParent !== toNodeParent && fromNodeParent && itemTypes.includes(fromNodeParent.type) && toNodeParent && itemTypes.includes(toNodeParent.type)) {
	      tr.delete(from, to);
	      dispatch(tr);
	      return true;
	    }
	  }
	
	  var foundFromNode = index_js.findParentNode($from.path, function (n) {
	    return n.type && n.type.spec.listRole;
	  });
	  var foundToNode = index_js.findParentNode($to.path, function (n) {
	    return n.type && n.type.spec.listRole;
	  });
	
	  if (foundToNode && (!foundFromNode || foundFromNode.node !== foundToNode.node) && to === foundToNode.pos + foundToNode.node.nodeSize - 3) {
	    tr.delete(from, to + 3);
	    dispatch(tr);
	    return true;
	  }
	
	  return false;
	}
	
	function handleDelete(state, dispatch) {
	  var tr = state.tr,
	      selection = state.selection,
	      schema = state.schema;
	  var $cursor = selection.$cursor,
	      $from = selection.$from,
	      from = selection.from,
	      $to = selection.$to,
	      to = selection.to;
	  var _schema$nodes6 = schema.nodes,
	      list_item = _schema$nodes6.list_item,
	      task_item = _schema$nodes6.task_item;
	
	  var itemTypes = [list_item, task_item];
	  var toNode = $to.node();
	
	  if ($from.parentOffset === 0) {
	    var fromNodeParent = $from.node(-1);
	    var toNodeParent = $to.node(-1);
	    if (!fromNodeParent) return false;
	
	    if (!$cursor && $to.parentOffset === toNode.content.size && fromNodeParent !== toNodeParent && fromNodeParent && itemTypes.includes(fromNodeParent.type) && toNodeParent && itemTypes.includes(toNodeParent.type)) {
	      tr.delete(from, to);
	      dispatch(tr);
	      return true;
	    }
	  }
	
	  return false;
	}
	function handleEnter(state, dispatch) {
	  var _state$schema$nodes3 = state.schema.nodes,
	      paragraph = _state$schema$nodes3.paragraph,
	      heading = _state$schema$nodes3.heading,
	      list_item = _state$schema$nodes3.list_item,
	      task_item = _state$schema$nodes3.task_item;
	
	  var itemTypes = [list_item, task_item];
	  var tr = state.tr;
	  var selection = state.selection;
	
	  var $anchor = selection.$anchor;
	
	  if (!$anchor.parent.type.isBlock && !$anchor.nodeAfter) {
	    var _node = index_js.findParentNode($anchor.path, function (n) {
	      return [paragraph, heading].includes(n.type);
	    });
	    if (!_node) return false;
	    var pos = _node.pos + _node.node.nodeSize - 1;
	    selection = prosemirrorState.TextSelection.create(state.doc, pos);
	    tr.setSelection(selection);
	  }
	
	  var _selection = selection,
	      $from = _selection.$from,
	      $to = _selection.$to,
	      node = _selection.node,
	      from = _selection.from;
	
	  var fromNode = $from.node();
	  if (!index_js.canInsertTypes(state)) return false;
	  if (node && node.isBlock || $from.depth < 2 || !$from.sameParent($to)) return false;
	  var grandParent = $from.node(-1);
	  if (!itemTypes.includes(grandParent.type) && !itemTypes.includes(fromNode.type)) return false;
	
	  if ($from.parent === grandParent.content.content[0] && $from.parent.content.size === 0) {
	    var range = $from.blockRange($to, function (n) {
	      return n.childCount && n.firstChild.type === grandParent.type;
	    });
	    if (!range) return false;
	
	    if (dispatch) {
	      var itemType = $from.node(range.depth - 1).type;
	
	      if (itemTypes.includes(itemType)) {
	        return liftToOuterList(state, dispatch, itemType, range);
	      }
	
	      var transaction = liftOutOfList(tr, range);
	      transaction && dispatch(transaction);
	      return !!transaction;
	    }
	
	    return true;
	  }
	
	  var nextType = $to.pos === $from.end() ? grandParent.defaultContentType(0) : null;
	  tr.delete($from.pos, $to.pos);
	  var types = nextType && [null, {
	    type: nextType,
	    attrs: objectSpread({}, $from.node().attrs)
	  }];
	  if (!prosemirrorTransform.canSplit(tr.doc, $from.pos, 2, types)) return false;
	  var marks = state.storedMarks || $to.parentOffset && $from.marks() || [];
	
	  if (dispatch) {
	    var atStart = $to.parentOffset === 0;
	
	    if (atStart) {
	      tr.insert(from, grandParent.type.createAndFill({
	        dataListItemDiffId: 'ct-list-item-diff-id-' + uuid()
	      }));
	      tr.deleteRange(from, from + 2);
	      dispatch(tr.scrollIntoView());
	      return true;
	    }
	
	    if (grandParent.type === task_item) {
	      var _pos = index_js.findParentNode($from.path, function (n) {
	        return n.type === task_item;
	      }).pos;
	      tr.setNodeMarkup(_pos, null, objectSpread({}, grandParent.attrs, {
	        checked: false,
	        dataListItemDiffId: 'ct-list-item-diff-id-' + uuid()
	      }));
	      tr.split($from.pos, 2, types);
	      tr.setNodeMarkup(_pos, null, objectSpread({}, grandParent.attrs));
	    } else {
	      tr.split(tr.mapping.map($from.pos), 2, [{
	        type: list_item,
	        attrs: {
	          dataDiffId: 'ct-list-item-diff-id-' + uuid()
	        }
	      }, {
	        type: paragraph,
	        attrs: {
	          dataDiffId: 'ct-diff-id-' + uuid()
	        }
	      }]);
	    }
	
	    dispatch(tr.ensureMarks(marks).scrollIntoView());
	  }
	
	  return true;
	}
	
	var handleClick = function handleClick(view, pos, e) {
	  if (e.target.getAttribute('data-type') !== 'task_item') return false;
	  var state = view.state,
	      dispatch = view.dispatch;
	  var tr = state.tr,
	      schema = state.schema;
	
	  var selection = void 0;
	
	  try {
	    selection = prosemirrorState.NodeSelection.create(state.doc, pos);
	  } catch (e) {
	    return false;
	  }
	
	  var node = selection.node;
	
	  if (node.type === schema.nodes.task_item) {
	    var attrs = node.attrs;
	    dispatch(tr.setNodeMarkup(pos, null, objectSpread({}, attrs, {
	      checked: !attrs.checked
	    })));
	  }
	
	  return false;
	};
	
	var pluginKey = new prosemirrorState.PluginKey('list');
	function createPlugin(store) {
	  return new prosemirrorState.Plugin({
	    key: pluginKey,
	    props: {
	      handleClick: handleClick,
	      handleDoubleClick: handleClick,
	      transformPasted: function transformPasted(slice) {
	        var state = store.view.state;
	        var schema = state.schema,
	            selection = state.selection;
	        var _schema$nodes7 = schema.nodes,
	            ordered_list = _schema$nodes7.ordered_list,
	            bullet_list = _schema$nodes7.bullet_list,
	            task_list = _schema$nodes7.task_list,
	            list_item = _schema$nodes7.list_item,
	            task_item = _schema$nodes7.task_item;
	
	        var listTypes = [ordered_list, bullet_list, task_list];
	        var $cursor = selection.$cursor;
	
	        var sliceContent = slice.content.content;
	
	        if ($cursor && sliceContent.length === 1) {
	          var sliceNode = sliceContent[0];
	          var nodeBefore = $cursor.nodeBefore,
	              nodeAfter = $cursor.nodeAfter,
	              path = $cursor.path;
	
	          var listNode = path[path.length - 9];
	
	          if (!nodeBefore && !nodeAfter && listTypes.includes(sliceNode.type) && listNode && listTypes.includes(listNode.type) && sliceNode.type !== listNode.type) {
	            sliceContent[0] = listNode.type.create(sliceNode.attrs, sliceNode.content);
	          }
	        }
	
	        sliceContent.forEach(function (node) {
	          if (node.type === ordered_list || node.type === bullet_list) {
	            var items = node.content.content;
	            items.forEach(function (item, i) {
	              if (item.type === task_item) {
	                items[i] = list_item.create(item.attrs, item.content);
	              }
	            });
	          } else if (node.type === task_list) {
	            var _items = node.content.content;
	            _items.forEach(function (item, i) {
	              if (item.type === list_item) {
	                _items[i] = task_item.create(item.attrs, item.content);
	              }
	            });
	          }
	        });
	        return slice;
	      }
	    }
	  });
	}
	
	var ListStore = function () {
	  function ListStore() {
	    (0, _classCallCheck3.default)(this, ListStore);
	
	    this.view = null;
	    this.modules = {};
	  }
	
	  (0, _createClass3.default)(ListStore, [{
	    key: 'init',
	    value: function init(moduleManager) {
	      this.view = moduleManager.view;
	      this.modules = moduleManager.modules;
	    }
	  }]);
	  return ListStore;
	}();
	
	function styleInject(css, ref) {
	  if (ref === void 0) ref = {};
	  var insertAt = ref.insertAt;
	
	  if (!css || typeof document === 'undefined') {
	    return;
	  }
	
	  var head = document.head || document.getElementsByTagName('head')[0];
	  var style = document.createElement('style');
	  style.type = 'text/css';
	
	  if (insertAt === 'top') {
	    if (head.firstChild) {
	      head.insertBefore(style, head.firstChild);
	    } else {
	      head.appendChild(style);
	    }
	  } else {
	    head.appendChild(style);
	  }
	
	  if (style.styleSheet) {
	    style.styleSheet.cssText = css;
	  } else {
	    style.appendChild(document.createTextNode(css));
	  }
	}
	
	var css = ".pm-body-wrapper ol,.pm-body-wrapper ul,.ProseMirror ol,.ProseMirror ul{margin:8px 0;padding-left:24px}.pm-body-wrapper ol li,.pm-body-wrapper ul li,.ProseMirror ol li,.ProseMirror ul li{min-height:24px;font-size:14px}.pm-body-wrapper ol>h1,.pm-body-wrapper ol>h2,.pm-body-wrapper ol>h3,.pm-body-wrapper ol>h4,.pm-body-wrapper ol>h5,.pm-body-wrapper ol>h6,.pm-body-wrapper ol>p,.pm-body-wrapper ul>h1,.pm-body-wrapper ul>h2,.pm-body-wrapper ul>h3,.pm-body-wrapper ul>h4,.pm-body-wrapper ul>h5,.pm-body-wrapper ul>h6,.pm-body-wrapper ul>p,.ProseMirror ol>h1,.ProseMirror ol>h2,.ProseMirror ol>h3,.ProseMirror ol>h4,.ProseMirror ol>h5,.ProseMirror ol>h6,.ProseMirror ol>p,.ProseMirror ul>h1,.ProseMirror ul>h2,.ProseMirror ul>h3,.ProseMirror ul>h4,.ProseMirror ul>h5,.ProseMirror ul>h6,.ProseMirror ul>p{margin:0}.pm-body-wrapper ol .ct-image,.pm-body-wrapper ul .ct-image,.ProseMirror ol .ct-image,.ProseMirror ul .ct-image{vertical-align:top}.pm-body-wrapper ol hr,.pm-body-wrapper ul hr,.ProseMirror ol hr,.ProseMirror ul hr{display:inline-block}.pm-body-wrapper .ct-item-level-1,.ProseMirror .ct-item-level-1{font-size:28px}.pm-body-wrapper .ct-item-level-2,.ProseMirror .ct-item-level-2{font-size:24px}.pm-body-wrapper .ct-item-level-3,.ProseMirror .ct-item-level-3{font-size:20px}.pm-body-wrapper .ct-item-level-4,.ProseMirror .ct-item-level-4{font-size:16px}.pm-body-wrapper .ct-item-level-5,.ProseMirror .ct-item-level-5{font-size:14px}.pm-body-wrapper .ct-item-level-6,.ProseMirror .ct-item-level-6{font-size:12px}ol .ct-item-level-1{margin-left:12px}ol .ct-item-level-2{margin-left:8px}ol .ct-item-level-3{margin-left:5px}ol .ct-item-level-4{margin-left:1px}ol .ct-item-level-6{margin-left:-2px}ul .ct-item-level-1{margin-left:7px}ul .ct-item-level-2{margin-left:6px}ul .ct-item-level-3{margin-left:3px}ul .ct-item-level-4{margin-left:2px}ul .ct-item-level-6{margin-left:-1px}.ct-task-list{list-style-type:none!important}.ct-task-list li{margin-left:0}.ct-task-list .ct-task-li{position:relative;list-style-type:none!important}.ct-task-list .ct-task-li:before{content:\"\";position:absolute;top:3px;left:-21px;height:17px;width:17px;border-radius:1px;background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='16' height='16' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 0h16v16H0V0zm1 1v14h14V1H1z' fill='%236E6B6B' fill-rule='evenodd'/%3E%3C/svg%3E\") no-repeat 50%}.ct-task-list .ct-task-li-checked{position:relative;list-style-type:none!important}.ct-task-list .ct-task-li-checked:before{content:\"\";position:absolute;top:3px;left:-21px;height:17px;width:17px;border-radius:1px;background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='16' height='16' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12 0v1H1v14h14V7h1v9H0V0h12zM6.908 9.728l7.385-7.385a1 1 0 0 1 1.414 1.414l-8.071 8.071c-.2.201-.465.299-.728.293a.997.997 0 0 1-.728-.293L2.938 8.586a1 1 0 0 1 1.414-1.414l2.556 2.556z' fill='%23AAA' fill-rule='evenodd'/%3E%3C/svg%3E\") no-repeat 50%}.ct-task-li-checked:after,.ct-task-li-checked:before,.ct-task-li:before{cursor:pointer}.ct-task-list .ct-item-level-1:before{top:15px}.ct-task-list .ct-item-level-2:before{top:12px}.ct-task-list .ct-item-level-3:before{top:8px}.ct-task-list .ct-item-level-4:before{top:5px}.ct-task-list .ct-item-level-6:before{top:1px}li.ProseMirror-selectednode,li.ProseMirror-selectednode:after{display:none}.ct-task-list .ct-task-li-checked audio,.ct-task-list .ct-task-li-checked div,.ct-task-list .ct-task-li-checked h1,.ct-task-list .ct-task-li-checked h2,.ct-task-list .ct-task-li-checked h3,.ct-task-list .ct-task-li-checked h4,.ct-task-list .ct-task-li-checked h5,.ct-task-list .ct-task-li-checked h6,.ct-task-list .ct-task-li-checked p,.ct-task-list .ct-task-li-checked span,.ct-task-list .ct-task-li-checked video{opacity:.7}.ct-task-list .ct-task-li-checked .ct-task-li audio,.ct-task-list .ct-task-li-checked .ct-task-li div,.ct-task-list .ct-task-li-checked .ct-task-li h1,.ct-task-list .ct-task-li-checked .ct-task-li h2,.ct-task-list .ct-task-li-checked .ct-task-li h3,.ct-task-list .ct-task-li-checked .ct-task-li h4,.ct-task-list .ct-task-li-checked .ct-task-li h5,.ct-task-list .ct-task-li-checked .ct-task-li h6,.ct-task-list .ct-task-li-checked .ct-task-li p,.ct-task-list .ct-task-li-checked .ct-task-li span,.ct-task-list .ct-task-li-checked .ct-task-li video{opacity:unset}.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked audio,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked div,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked h1,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked h2,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked h3,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked h4,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked h5,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked h6,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked p,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked span,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked video{opacity:.7}.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li audio,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li div,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li h1,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li h2,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li h3,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li h4,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li h5,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li h6,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li p,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li span,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li video{opacity:unset}.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked audio,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked div,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked h1,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked h2,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked h3,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked h4,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked h5,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked h6,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked p,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked span,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked video{opacity:.7}.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li audio,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li div,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li h1,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li h2,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li h3,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li h4,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li h5,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li h6,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li p,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li span,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li video{opacity:unset}ol{list-style-type:decimal}ol ol{list-style-type:lower-alpha}ol ol ol{list-style-type:lower-roman}ol ol ol ol{list-style-type:decimal}ol ol ol ol ol{list-style-type:lower-alpha}ol ol ol ol ol ol{list-style-type:lower-roman}ol ol ol ol ol ol ol{list-style-type:decimal}ol ol ol ol ol ol ol ol{list-style-type:lower-alpha}ol ol ol ol ol ol ol ol ol{list-style-type:lower-roman}ul{list-style-type:disc}ul ul{list-style-type:square}ul ul ul{list-style-type:circle}ul ul ul ul{list-style-type:disc}ul ul ul ul ul{list-style-type:square}ul ul ul ul ul ul{list-style-type:circle}ul ul ul ul ul ul ul{list-style-type:disc}ul ul ul ul ul ul ul ul{list-style-type:square}ul ul ul ul ul ul ul ul ul{list-style-type:circle}.ct-hidden-item{list-style:none}";
	styleInject(css);
	
	var ListModule = function () {
	  function ListModule() {
	    (0, _classCallCheck3.default)(this, ListModule);
	
	    this.name = 'list';
	    this.store = new ListStore();
	    this.schema = schema;
	    this.commands = {
	      wrapInList: wrapInList,
	      unwrapList: function unwrapList() {
	        return _unwrapList;
	      },
	      transformList: transformList,
	      liftListItem: function liftListItem() {
	        return _liftListItem;
	      },
	      sinkListItem: function sinkListItem() {
	        return _sinkListItem;
	      }
	    };
	    this.utils = {
	      judgeListType: judgeListType,
	      isInList: isInList
	    };
	    this.plugins = [keymap({
	      Backspace: handleBackspace,
	      'Mod-Backspace': handleBackspace,
	      Delete: handleDelete,
	      'Mod-Delete': handleDelete,
	      Enter: handleEnter
	    }), createPlugin(this.store)];
	    this.pluginPriority = 'high';
	  }
	
	  (0, _createClass3.default)(ListModule, [{
	    key: 'init',
	    value: function init(moduleManager) {
	      this.store.init(moduleManager);
	    }
	  }]);
	  return ListModule;
	}();
	
	ListModule.moduleName = 'list';
	
	exports.ListModule = ListModule;

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _from = __webpack_require__(43);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _getPrototypeOf = __webpack_require__(30);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(7);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(10);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(32);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(31);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _getOwnPropertyDescriptor = __webpack_require__(23);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getOwnPropertySymbols = __webpack_require__(16);
	
	var _getOwnPropertySymbols2 = _interopRequireDefault(_getOwnPropertySymbols);
	
	var _keys = __webpack_require__(13);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _defineProperty2 = __webpack_require__(15);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _typeof2 = __webpack_require__(8);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault(ex) {
	  return ex && (typeof ex === 'undefined' ? 'undefined' : (0, _typeof3.default)(ex)) === 'object' && 'default' in ex ? ex['default'] : ex;
	}
	
	var keymap = _interopDefault(__webpack_require__(34));
	var index_js = __webpack_require__(22);
	__webpack_require__(29);
	__webpack_require__(25);
	var prosemirrorModel = __webpack_require__(12);
	var prosemirrorState = __webpack_require__(6);
	var prosemirrorView = __webpack_require__(48);
	var preact = __webpack_require__(24);
	var index_js$2 = __webpack_require__(56);
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    (0, _defineProperty3.default)(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	var defineProperty = _defineProperty;
	
	function _objectSpread(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? arguments[i] : {};
	    var ownKeys = (0, _keys2.default)(source);
	
	    if (typeof _getOwnPropertySymbols2.default === 'function') {
	      ownKeys = ownKeys.concat((0, _getOwnPropertySymbols2.default)(source).filter(function (sym) {
	        return (0, _getOwnPropertyDescriptor2.default)(source, sym).enumerable;
	      }));
	    }
	
	    ownKeys.forEach(function (key) {
	      defineProperty(target, key, source[key]);
	    });
	  }
	
	  return target;
	}
	
	var objectSpread = _objectSpread;
	
	function uuid() {
	  var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
	  var id = [];
	
	  for (var i = 0; i < 8; i++) {
	    id.push(chars[parseInt(Math.random() * chars.length, 10)]);
	  }
	
	  return id.join('');
	}
	
	var noteSchema = {
	  nodes: {
	    note: {
	      group: 'block',
	      content: 'note_title note_content',
	      isolating: true,
	      allowGapCursor: true,
	      insertBlock: true,
	      dragBlock: true,
	      braceWidth: 300,
	      attrs: {
	        type: {
	          default: 'note'
	        },
	        hiddenTitle: {
	          default: true
	        },
	        dataDiffId: {
	          default: null
	        }
	      },
	      parseDOM: [{
	        tag: 'div[class~="ct-note"]',
	        getAttrs: function getAttrs(dom) {
	          return {
	            type: dom.getAttribute('data-type'),
	            hiddenTitle: dom.classList.contains('hidden-title'),
	            dataDiffId: dom.getAttribute('data-diff-id')
	          };
	        }
	      }],
	
	      toDOM: function toDOM(node) {
	        var _node$attrs = node.attrs,
	            type = _node$attrs.type,
	            hiddenTitle = _node$attrs.hiddenTitle,
	            dataDiffId = _node$attrs.dataDiffId;
	
	        var nodeAttrs = {
	          class: 'ct-note' + (hiddenTitle ? ' hidden-title' : ''),
	          'data-type': type,
	          'data-diff-id': dataDiffId || 'ct-diff-id-' + uuid()
	        };
	        return ['div', nodeAttrs, 0];
	      }
	    },
	    note_title: {
	      content: 'text*',
	      alignBlock: true,
	      attrs: {
	        align: {
	          default: 'left'
	        }
	      },
	      parseDOM: [{
	        tag: 'div[class~="ct-note-title"]',
	        getAttrs: function getAttrs(dom) {
	          return {
	            align: dom.style.textAlign
	          };
	        }
	      }],
	
	      toDOM: function toDOM(node) {
	        var align = node.attrs.align;
	
	        var attrs = {
	          class: 'ct-note-title'
	        };
	
	        if (align && align !== 'left') {
	          attrs.style = 'text-align: ' + align + ';';
	        }
	
	        return ['div', attrs, ['span', {
	          class: 'ct-note-title-text'
	        }, 0]];
	      }
	    },
	    note_content: {
	      content: 'block+',
	      attrs: {},
	      parseDOM: [{
	        tag: 'div[class~="ct-note-content"]'
	      }],
	
	      toDOM: function toDOM() {
	        var nodeAttrs = {
	          class: 'ct-note-content'
	        };
	        return ['div', nodeAttrs, 0];
	      }
	    }
	  }
	};
	
	function insert(store) {
	  return function (type) {
	    return function (state, dispatch, view, trigger) {
	      var schema = state.schema,
	          tr = state.tr,
	          selection = state.selection;
	      var from = selection.from;
	      var _schema$nodes = schema.nodes,
	          note = _schema$nodes.note,
	          note_title = _schema$nodes.note_title,
	          note_content = _schema$nodes.note_content;
	
	      var titleNode = note_title.createAndFill();
	      var contentNode = note_content.createAndFill();
	      var noteNode = note.create({
	        type: type
	      }, prosemirrorModel.Fragment.from([titleNode, contentNode]));
	
	      var _index_js$insertBlock = index_js.insertBlock(state, noteNode),
	          transaction = _index_js$insertBlock.transaction;
	
	      if (!transaction) {
	        return false;
	      }
	
	      tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, from + 1));
	      dispatch(transaction.scrollIntoView());
	      view.focus();
	      return true;
	    };
	  };
	}
	function _setAttrs(attrs) {
	  return function (state, dispatch) {
	    var tr = state.tr,
	        selection = state.selection,
	        schema = state.schema;
	    var $from = selection.$from;
	    var note = schema.nodes.note;
	
	
	    var assert = function assert(node) {
	      return node.type === note;
	    };
	
	    var foundNode = index_js.findParentNode($from.path, assert);
	
	    if (!foundNode) {
	      return false;
	    }
	
	    var oldAttrs = foundNode.node.attrs;
	    dispatch(tr.setNodeMarkup(foundNode.pos, null, objectSpread({}, oldAttrs, attrs)));
	    return true;
	  };
	}
	
	function createPlugin(store) {
	  var pluginKey = new prosemirrorState.PluginKey("note");
	  var plugin = new prosemirrorState.Plugin({
	    key: pluginKey,
	    props: {
	      decorations: function decorations(state) {
	        var selection = state.selection,
	            schema = state.schema,
	            doc = state.doc;
	        var $from = selection.$from;
	        var note = schema.nodes.note;
	
	        var foundNode = index_js.findParentNode($from.path, function (node) {
	          return node.type === note;
	        });
	
	        if (foundNode) {
	          var deco = prosemirrorView.Decoration.node(foundNode.pos, foundNode.node.nodeSize + foundNode.pos, {
	            nodeName: "div",
	            class: "ct-note-selected"
	          });
	          return prosemirrorView.DecorationSet.create(doc, [deco]);
	        }
	      },
	      handleDrop: function handleDrop(view, event, slice, moved) {
	        try {
	          var status = view.state.schema.nodes.status;
	
	
	          if (event.target.classList.contains("ct-note")) {
	            return true;
	          }
	
	          if (event.target.closest(".ct-note-title")) {
	            var content = slice.content.content;
	
	            if (content.length > 1) {
	              return true;
	            }
	
	            if (content[0].isTextblock && content[0].content.content.length === 1) {
	              return false;
	            }
	
	            if (content[0].isBlock || content[0].type === status) {
	              return true;
	            }
	          }
	        } catch (err) {}
	      },
	
	      handleDOMEvents: {}
	    },
	    view: function view(_view) {
	      return new index_js.Popover({
	        view: _view,
	        store: store,
	        className: "ct-note-popover"
	      });
	    }
	  });
	  return plugin;
	}
	
	var handleBackspace = index_js.handleBackspaceCreator('note', 'note_title', 'note_content');
	var handleDelete = index_js.handleDeleteCreator('note', 'note_title', 'note_content');
	var handleTab = index_js.handleTabCreator('note', 'note_title', 'note_content');
	var handleEnter = index_js.handleEnterCreator('note', 'note_title', 'note_content');
	
	function styleInject(css, ref) {
	  if (ref === void 0) ref = {};
	  var insertAt = ref.insertAt;
	
	  if (!css || typeof document === 'undefined') {
	    return;
	  }
	
	  var head = document.head || document.getElementsByTagName('head')[0];
	  var style = document.createElement('style');
	  style.type = 'text/css';
	
	  if (insertAt === 'top') {
	    if (head.firstChild) {
	      head.insertBefore(style, head.firstChild);
	    } else {
	      head.appendChild(style);
	    }
	  } else {
	    head.appendChild(style);
	  }
	
	  if (style.styleSheet) {
	    style.styleSheet.cssText = css;
	  } else {
	    style.appendChild(document.createTextNode(css));
	  }
	}
	
	var css = ".ct-note-popover{z-index:9}.ct-note-popover .ct-note-editor{width:72px;height:34px;line-height:17px;padding:2px 8px;font-size:13px;color:#333;cursor:pointer}";
	styleInject(css);
	
	var NoteEditor = function (_preact$Component) {
	  (0, _inherits3.default)(NoteEditor, _preact$Component);
	
	  function NoteEditor() {
	    var _ref;
	
	    (0, _classCallCheck3.default)(this, NoteEditor);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = NoteEditor.__proto__ || (0, _getPrototypeOf2.default)(NoteEditor)).call.apply(_ref, [this].concat(args)));
	
	    _this.handleClick = function () {
	      _this.props.toggleTitle();
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(NoteEditor, [{
	    key: 'render',
	    value: function render() {
	      var hiddenTitle = this.props.hiddenTitle;
	
	      return preact.h("div", {
	        className: "ct-note-editor"
	      }, preact.h(index_js$2.CheckBox, {
	        checked: !hiddenTitle,
	        onClick: this.handleClick
	      }, '\u6807\u9898'));
	    }
	  }]);
	  return NoteEditor;
	}(preact.Component);
	
	var NoteStore = function () {
	  function NoteStore() {
	    var _this2 = this;
	
	    (0, _classCallCheck3.default)(this, NoteStore);
	
	    this.pluginName = "note";
	
	    this.showPopover = function (node) {
	      _this2.hidePopover();
	
	      if (node) {
	        _this2.node = node;
	        var dom = node.dom,
	            attrs = node.attrs;
	
	        _this2.ctPopover.show({
	          dom: dom,
	          content: _this2.getToolbar(attrs.hiddenTitle)
	        });
	      }
	    };
	
	    this.updateAttrs = function (data) {
	      if (!_this2.node) {
	        return;
	      }
	
	      var _editor$view = _this2.editor.view,
	          state = _editor$view.state,
	          dispatch = _editor$view.dispatch;
	      var tr = state.tr,
	          schema = state.schema;
	
	      var nodeType = schema.nodes.note;
	
	      var attrs = objectSpread({}, _this2.node.attrs, data);
	
	      var pos = _this2.node.pos;
	
	      dispatch(tr.setNodeMarkup(pos, nodeType, attrs));
	      var dom = _this2.editor.view.nodeDOM(pos);
	      return {
	        dom: dom,
	        pos: pos,
	        attrs: attrs
	      };
	    };
	
	    this.hidePopover = function () {
	      _this2.ctPopover.hide();
	    };
	
	    this.toggleTitle = function () {
	      if (!_this2.node) {
	        return;
	      }
	
	      var node = _this2.updateAttrs({
	        hiddenTitle: !_this2.node.attrs.hiddenTitle
	      });
	
	      _this2.showPopover(node);
	    };
	
	    this.getToolbar = function (hiddenTitle) {
	      return preact.h(NoteEditor, {
	        hiddenTitle: hiddenTitle,
	        toggleTitle: _this2.toggleTitle
	      });
	    };
	  }
	
	  (0, _createClass3.default)(NoteStore, [{
	    key: 'init',
	    value: function init(editor) {
	      this.editor = editor;
	      this.view = editor.view;
	    }
	  }]);
	  return NoteStore;
	}();
	
	var noteToView = function noteToView(_ref2) {
	  var bodyWrapper = _ref2.bodyWrapper;
	
	  var noteNodes = bodyWrapper.querySelectorAll('.ct-note');
	  noteNodes.forEach(function (node) {
	    (0, _from2.default)(node.children).forEach(function (child) {
	      if (child.innerHTML.trim() === '') {
	        node.removeChild(child);
	      }
	    });
	  });
	};
	
	var css$1 = ".ct-note-selected .ct-note{border-color:#fdc446}.ct-note-selected .ct-note[data-type=info]{border-color:#23bdd9}.ct-note-selected .ct-note[data-type=tip]{border-color:#53752d}.ct-note-selected .ct-note[data-type=warning]{border-color:#e75252}.ct-note{min-width:265px;min-height:42px;margin:8px 0;border:1px solid transparent;border-radius:4px;background-color:#fffbe6}.ct-note.ProseMirror-selectednode{border-color:#fdc446}.ct-note[data-type=info]{background-color:#e6ffff}.ct-note[data-type=info].ProseMirror-selectednode{border-color:#23bdd9}.ct-note[data-type=tip]{background-color:#f6ffed}.ct-note[data-type=tip].ProseMirror-selectednode{border-color:#53752d}.ct-note[data-type=warning]{background-color:#fff1f0}.ct-note[data-type=warning].ProseMirror-selectednode{border-color:#e75252}.ct-note.ProseMirror-selectednode{position:relative}.ct-note.ProseMirror-selectednode:after{z-index:2;position:absolute;content:\"\";left:-1px;right:-1px;top:-1px;bottom:-1px;background-color:#23bdd9;opacity:.2;pointer-events:none}.hidden-title{background:#fffbe6 url(\"data:image/svg+xml;charset=utf-8,%3Csvg class='icon' viewBox='0 0 1024 1024' xmlns='http://www.w3.org/2000/svg' width='18' height='18'%3E%3Cdefs%3E%3Cstyle/%3E%3C/defs%3E%3Cpath d='M64 512a448 448 0 1 1 896 0 448 448 0 0 1-896 0zm448-296.832c-37.376 0-67.2 30.08-67.2 67.008v270.848c0 36.544 30.08 67.008 67.2 67.008 37.376 0 67.2-30.016 67.2-67.008V282.24c0-36.48-30.08-67.008-67.2-67.008zm0 593.6a67.2 67.2 0 1 0 0-134.4 67.2 67.2 0 0 0 0 134.4z' fill='%23FDC446'/%3E%3C/svg%3E\") no-repeat 10px 10px}.hidden-title>.ct-note-title{display:none}.hidden-title[data-type=info]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg class='icon' viewBox='0 0 1024 1024' xmlns='http://www.w3.org/2000/svg' width='18' height='18'%3E%3Cdefs%3E%3Cstyle/%3E%3C/defs%3E%3Cpath d='M64 512a448 448 0 1 1 896 0 448 448 0 0 1-896 0zm576 255.808c0-41.6-66.752-57.088-66.56-83.84V454.592C573.44 416.064 545.92 384 512 384c-45.44 0-97.024 25.344-97.024 48.576s35.584 11.968 35.584 46.528v204.8c0 26.24-66.56 41.6-66.56 83.904 0 .448 256.768 0 256 0zM512 192a64 64 0 1 0 0 128 64 64 0 0 0 0-128z' fill='%233d91f2'/%3E%3C/svg%3E\")}.hidden-title[data-type=tip]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg class='icon' viewBox='0 0 1024 1024' xmlns='http://www.w3.org/2000/svg' width='18' height='18'%3E%3Cdefs%3E%3Cstyle/%3E%3C/defs%3E%3Cpath d='M550.4 573.76v27.84a38.4 38.4 0 0 1-76.8 0v-27.84c-45.952-13.312-72.192-52.16-72.96-109.248a38.4 38.4 0 0 1 76.8-.96c.448 30.4 8.128 38.528 34.56 38.528 26.432 0 34.112-8.128 34.56-38.528a38.4 38.4 0 1 1 76.8.96c-.768 57.088-27.008 95.936-72.96 109.248zM512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896zm112 594.048A223.296 223.296 0 0 0 736 464a224 224 0 1 0-336 194.048V720a64 64 0 0 0 64 64h96a64 64 0 0 0 64-64v-61.952z' fill='%2370B123'/%3E%3C/svg%3E\")}.hidden-title[data-type=warning]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg class='icon' viewBox='0 0 1024 1024' xmlns='http://www.w3.org/2000/svg' width='18' height='18'%3E%3Cdefs%3E%3Cstyle/%3E%3C/defs%3E%3Cpath d='M64 512a448 448 0 1 1 896 0 448 448 0 0 1-896 0zm448-296.832c-37.376 0-67.2 30.08-67.2 67.008v270.848c0 36.544 30.08 67.008 67.2 67.008 37.376 0 67.2-30.016 67.2-67.008V282.24c0-36.48-30.08-67.008-67.2-67.008zm0 593.6a67.2 67.2 0 1 0 0-134.4 67.2 67.2 0 0 0 0 134.4z' fill='%23F05E50'/%3E%3C/svg%3E\")}.ct-note-title{min-height:24px;padding:8px 0;font-size:14px;font-weight:700;color:#333;line-height:24px}.ct-note-title>.ct-note-title-text{position:relative;display:inline-block;min-height:24px;padding-left:36px;color:#333;line-height:24px;font-family:PingFangSC-Medium;font-size:13px;background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg class='icon' viewBox='0 0 1024 1024' xmlns='http://www.w3.org/2000/svg' width='18' height='18'%3E%3Cdefs%3E%3Cstyle/%3E%3C/defs%3E%3Cpath d='M64 512a448 448 0 1 1 896 0 448 448 0 0 1-896 0zm448-296.832c-37.376 0-67.2 30.08-67.2 67.008v270.848c0 36.544 30.08 67.008 67.2 67.008 37.376 0 67.2-30.016 67.2-67.008V282.24c0-36.48-30.08-67.008-67.2-67.008zm0 593.6a67.2 67.2 0 1 0 0-134.4 67.2 67.2 0 0 0 0 134.4z' fill='%23FDC446'/%3E%3C/svg%3E\") no-repeat;background-position:10px 3px}[data-type=info]>.ct-note-title>.ct-note-title-text{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg class='icon' viewBox='0 0 1024 1024' xmlns='http://www.w3.org/2000/svg' width='18' height='18'%3E%3Cdefs%3E%3Cstyle/%3E%3C/defs%3E%3Cpath d='M64 512a448 448 0 1 1 896 0 448 448 0 0 1-896 0zm576 255.808c0-41.6-66.752-57.088-66.56-83.84V454.592C573.44 416.064 545.92 384 512 384c-45.44 0-97.024 25.344-97.024 48.576s35.584 11.968 35.584 46.528v204.8c0 26.24-66.56 41.6-66.56 83.904 0 .448 256.768 0 256 0zM512 192a64 64 0 1 0 0 128 64 64 0 0 0 0-128z' fill='%233d91f2'/%3E%3C/svg%3E\")}[data-type=tip]>.ct-note-title>.ct-note-title-text{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg class='icon' viewBox='0 0 1024 1024' xmlns='http://www.w3.org/2000/svg' width='18' height='18'%3E%3Cdefs%3E%3Cstyle/%3E%3C/defs%3E%3Cpath d='M550.4 573.76v27.84a38.4 38.4 0 0 1-76.8 0v-27.84c-45.952-13.312-72.192-52.16-72.96-109.248a38.4 38.4 0 0 1 76.8-.96c.448 30.4 8.128 38.528 34.56 38.528 26.432 0 34.112-8.128 34.56-38.528a38.4 38.4 0 1 1 76.8.96c-.768 57.088-27.008 95.936-72.96 109.248zM512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896zm112 594.048A223.296 223.296 0 0 0 736 464a224 224 0 1 0-336 194.048V720a64 64 0 0 0 64 64h96a64 64 0 0 0 64-64v-61.952z' fill='%2370B123'/%3E%3C/svg%3E\")}[data-type=warning]>.ct-note-title>.ct-note-title-text{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg class='icon' viewBox='0 0 1024 1024' xmlns='http://www.w3.org/2000/svg' width='18' height='18'%3E%3Cdefs%3E%3Cstyle/%3E%3C/defs%3E%3Cpath d='M64 512a448 448 0 1 1 896 0 448 448 0 0 1-896 0zm448-296.832c-37.376 0-67.2 30.08-67.2 67.008v270.848c0 36.544 30.08 67.008 67.2 67.008 37.376 0 67.2-30.016 67.2-67.008V282.24c0-36.48-30.08-67.008-67.2-67.008zm0 593.6a67.2 67.2 0 1 0 0-134.4 67.2 67.2 0 0 0 0 134.4z' fill='%23F05E50'/%3E%3C/svg%3E\")}.ct-note-content{padding:0 8px 0 36px;overflow:hidden}";
	styleInject(css$1);
	
	var NoteModule = function () {
	  function NoteModule() {
	    (0, _classCallCheck3.default)(this, NoteModule);
	
	    this.name = 'note';
	    this.store = new NoteStore();
	    this.schema = noteSchema;
	    this.commands = {
	      insert: insert(this.store),
	      setAttrs: function setAttrs(attrs) {
	        return _setAttrs(attrs);
	      }
	    };
	    this.plugins = [createPlugin(this.store), keymap({
	      Backspace: handleBackspace,
	      'Mod-Backspace': handleBackspace,
	      Delete: handleDelete,
	      'Mod-Delete': handleDelete,
	      Tab: handleTab,
	      Enter: handleEnter
	    })];
	  }
	
	  (0, _createClass3.default)(NoteModule, [{
	    key: 'init',
	    value: function init(moduleManager) {
	      this.store.init(moduleManager);
	    }
	  }]);
	  return NoteModule;
	}();
	
	NoteModule.moduleName = 'note';
	
	exports.NoteModule = NoteModule;
	exports.noteToView = noteToView;

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classCallCheck2 = __webpack_require__(7);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _typeof2 = __webpack_require__(8);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault(ex) {
	  return ex && (typeof ex === 'undefined' ? 'undefined' : (0, _typeof3.default)(ex)) === 'object' && 'default' in ex ? ex['default'] : ex;
	}
	
	var keymap = _interopDefault(__webpack_require__(34));
	var index_js = __webpack_require__(22);
	var index_js$1 = __webpack_require__(29);
	var prosemirrorTransform = __webpack_require__(25);
	__webpack_require__(12);
	var prosemirrorState = __webpack_require__(6);
	
	function uuid() {
	  var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
	  var id = [];
	
	  for (var i = 0; i < 8; i++) {
	    id.push(chars[parseInt(Math.random() * chars.length, 10)]);
	  }
	
	  return id.join('');
	}
	
	var schema = {
	  nodes: {
	    blockquote: {
	      content: 'block+',
	      group: 'block',
	      defining: true,
	      allowGapCursor: true,
	      attrs: {
	        dataDiffId: {
	          default: null
	        }
	      },
	      parseDOM: [{
	        tag: 'blockquote',
	
	        getAttrs: function getAttrs(dom) {
	          var dataDiffId = dom.getAttribute('data-diff-id');
	          return {
	            dataDiffId: dataDiffId
	          };
	        }
	      }],
	
	      toDOM: function toDOM(dom) {
	        var dataDiffId = dom.attrs.dataDiffId;
	
	        return ['blockquote', {
	          class: 'ct-blockquote',
	          'data-diff-id': dataDiffId || 'ct-diff-id-' + uuid()
	        }, 0];
	      }
	    }
	  }
	};
	
	function isInQuote(state) {
	  var selection = state.selection,
	      schema = state.schema;
	
	  var node = index_js.findParentNode(selection.$anchor.path, function (node) {
	    return node.type === schema.nodes.blockquote;
	  });
	  return !!node;
	}
	
	function wrapInQuote(attrs) {
	  return function (state, dispatch, view) {
	    var _state$schema$nodes = state.schema.nodes,
	        paragraph = _state$schema$nodes.paragraph,
	        heading = _state$schema$nodes.heading,
	        ordered_list = _state$schema$nodes.ordered_list,
	        bullet_list = _state$schema$nodes.bullet_list,
	        task_list = _state$schema$nodes.task_list,
	        blockquote = _state$schema$nodes.blockquote;
	
	    var listTypes = [ordered_list, bullet_list, task_list];
	    var selection = state.selection;
	
	    if (!selection.$anchor.parent.type.isBlock) {
	      var node = index_js.findParentNode(selection.$anchor.path, function (n) {
	        return [paragraph, heading].includes(n.type);
	      });
	      if (!node) return false;
	      selection = prosemirrorState.TextSelection.create(state.doc, node.pos + 1);
	    }
	
	    if (selection instanceof index_js$1.GapCursor) {
	      var _selection = selection,
	          _$from = _selection.$from,
	          from = _selection.from,
	          dom = _selection.dom;
	
	      var nodeAfter = _$from.nodeAfter;
	      var nodeBefore = _$from.nodeBefore;
	
	      if (dom) {
	        var tagName = dom.tagName,
	            className = dom.className;
	
	        var nodeAfterName = nodeAfter && nodeAfter.type.name.split('_')[0];
	        var nodeBeforeName = nodeBefore && nodeBefore.type.name.split('_')[0];
	
	        if (nodeAfterName && (tagName.toLowerCase() === nodeAfterName || className.includes(nodeAfterName))) {
	          selection = prosemirrorState.TextSelection.create(state.doc, from, from + nodeAfter.nodeSize);
	        } else if (nodeBeforeName && (tagName.toLowerCase() === nodeBeforeName || className.includes(nodeBeforeName))) {
	          selection = prosemirrorState.TextSelection.create(state.doc, from - nodeBefore.nodeSize, from);
	        }
	      }
	    }
	
	    var _selection2 = selection,
	        $from = _selection2.$from,
	        $to = _selection2.$to;
	
	    var range = $from.blockRange($to);
	
	    var listNode = index_js.findParentNode($from.path, function (node) {
	      return listTypes.includes(node.type);
	    });
	
	    if (listNode) {
	      var start = listNode.pos;
	      var end = listNode.pos + listNode.node.nodeSize - 1;
	      selection = prosemirrorState.TextSelection.create(state.doc, start, end);
	      range = selection.$from.blockRange(selection.$to);
	    }
	
	    var wrapping = range && prosemirrorTransform.findWrapping(range, blockquote, attrs);
	
	    if (!wrapping) {
	      return false;
	    }
	
	    dispatch(state.tr.wrap(range, wrapping));
	    return true;
	  };
	}
	
	function unwrapInQuote(state, dispatch) {
	  var _state$schema$nodes2 = state.schema.nodes,
	      paragraph = _state$schema$nodes2.paragraph,
	      heading = _state$schema$nodes2.heading,
	      ordered_list = _state$schema$nodes2.ordered_list,
	      bullet_list = _state$schema$nodes2.bullet_list,
	      task_list = _state$schema$nodes2.task_list;
	
	  var listTypes = [ordered_list, bullet_list, task_list];
	  var selection = state.selection;
	
	  if (!selection.$anchor.parent.type.isBlock) {
	    var node = index_js.findParentNode(selection.$anchor.path, function (node) {
	      return [paragraph, heading].includes(node.type);
	    });
	    if (!node) return false;
	    selection = prosemirrorState.TextSelection.create(state.doc, node.pos + 1);
	  }
	
	  var $from = selection.$from;
	  var $to = selection.$to;
	  var range = $from.blockRange($to);
	
	  var listNode = index_js.findParentNode($from.path, function (node) {
	    return listTypes.includes(node.type);
	  });
	
	  if (listNode) {
	    var start = listNode.pos;
	    var end = listNode.pos + listNode.node.nodeSize - 1;
	    selection = prosemirrorState.TextSelection.create(state.doc, start, end);
	    range = selection.$from.blockRange(selection.$to);
	  }
	
	  var target = range && prosemirrorTransform.liftTarget(range);
	  if (target == null) return false;
	  dispatch(state.tr.lift(range, target).scrollIntoView());
	  return true;
	}
	function toggle(state) {
	  if (isInQuote(state)) {
	    return unwrapInQuote;
	  }
	
	  return wrapInQuote();
	}
	
	function handleBackspace(state, dispatch, view) {
	  var tr = state.tr,
	      selection = state.selection,
	      schema = state.schema;
	  var $cursor = selection.$cursor,
	      from = selection.from,
	      to = selection.to;
	  var blockquote = schema.nodes.blockquote;
	
	
	  if ($cursor && $cursor.parentOffset === 0) {
	    var parentType = $cursor.parent.type;
	    var plus = parentType.isInline ? 2 : 1;
	    var cursorNodeParent = $cursor.node(-plus);
	    var cursorNode = parentType.isInline ? $cursor.node(-1) : $cursor.node();
	    if (!cursorNodeParent) return false;
	    var nodeAfter = $cursor.nodeAfter;
	
	    var nodeBefore = $cursor.nodeBefore;
	
	    var isDocHead = from === plus;
	
	    var isLastChild = cursorNodeParent.lastChild === cursorNode;
	    var nodePreRow = isDocHead ? null : view.domAtPos(from - plus - 1).node;
	
	    var nodePreRowName = nodePreRow && nodePreRow.nodeName.toUpperCase();
	
	    if (cursorNodeParent.type === blockquote && !nodeBefore && cursorNodeParent.firstChild === cursorNode) {
	      unwrapInQuote(state, dispatch);
	      return true;
	    }
	
	    if (nodePreRowName === 'BLOCKQUOTE') {
	      var newPos = from - 3;
	
	      if (!nodeAfter) {
	        tr.delete(from - 1, to + 1);
	        tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, newPos));
	      } else {
	        var cursorNodeSize = cursorNode.nodeSize;
	
	        if (isLastChild) {
	          tr.delete(from, from + cursorNodeSize - 1);
	        } else {
	          tr.delete(from, from + cursorNodeSize);
	        }
	
	        if (cursorNode.textContent) {
	          tr.insertText(cursorNode.textContent, newPos);
	          tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, newPos));
	        } else {
	          tr.insert(newPos, cursorNode);
	          tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, newPos + 1));
	        }
	      }
	
	      dispatch(tr);
	      return true;
	    }
	  }
	
	  return false;
	}
	function handleEnter(state, dispatch) {
	  var selection = state.selection,
	      schema = state.schema;
	  var $cursor = selection.$cursor;
	
	  if (!$cursor || !isInQuote(state)) return false;
	  var link = schema.nodes.link;
	  var nodeBefore = $cursor.nodeBefore;
	  var nodeAfter = $cursor.nodeAfter;
	
	  if ((!nodeBefore || nodeBefore.type === link && nodeBefore.nodeSize === 2) && (!nodeAfter || nodeAfter.type === link && nodeAfter.nodeSize === 2)) {
	    return unwrapInQuote(state, dispatch);
	  }
	
	  return false;
	}
	
	function styleInject(css, ref) {
	  if (ref === void 0) ref = {};
	  var insertAt = ref.insertAt;
	
	  if (!css || typeof document === 'undefined') {
	    return;
	  }
	
	  var head = document.head || document.getElementsByTagName('head')[0];
	  var style = document.createElement('style');
	  style.type = 'text/css';
	
	  if (insertAt === 'top') {
	    if (head.firstChild) {
	      head.insertBefore(style, head.firstChild);
	    } else {
	      head.appendChild(style);
	    }
	  } else {
	    head.appendChild(style);
	  }
	
	  if (style.styleSheet) {
	    style.styleSheet.cssText = css;
	  } else {
	    style.appendChild(document.createTextNode(css));
	  }
	}
	
	var css = ".ct-blockquote{padding-left:16px;border-left:2px solid #ddd;margin-left:8px;margin-right:0;color:#999}.ct-blockquote h1,.ct-blockquote h2,.ct-blockquote h3,.ct-blockquote h4,.ct-blockquote h5,.ct-blockquote h6,.ct-blockquote p,.ct-blockquote span{color:#999}";
	styleInject(css);
	
	var QuoteModule = function QuoteModule() {
	  (0, _classCallCheck3.default)(this, QuoteModule);
	
	  this.name = 'quote';
	  this.schema = schema;
	  this.commands = {
	    toggle: toggle
	  };
	  this.utils = {
	    isInQuote: isInQuote
	  };
	  this.plugins = [keymap({
	    Backspace: handleBackspace,
	    'Mod-Backspace': handleBackspace,
	    Enter: handleEnter
	  })];
	};
	
	QuoteModule.moduleName = 'quote';
	
	exports.QuoteModule = QuoteModule;

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _from = __webpack_require__(43);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _getPrototypeOf = __webpack_require__(30);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(7);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(10);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(32);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(31);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _toConsumableArray2 = __webpack_require__(66);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _getOwnPropertyDescriptor = __webpack_require__(23);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getOwnPropertySymbols = __webpack_require__(16);
	
	var _getOwnPropertySymbols2 = _interopRequireDefault(_getOwnPropertySymbols);
	
	var _keys = __webpack_require__(13);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _defineProperty2 = __webpack_require__(15);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _typeof2 = __webpack_require__(8);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault(ex) {
	  return ex && (typeof ex === 'undefined' ? 'undefined' : (0, _typeof3.default)(ex)) === 'object' && 'default' in ex ? ex['default'] : ex;
	}
	
	var prosemirrorState = __webpack_require__(6);
	var index_js = __webpack_require__(22);
	var index_js$1 = __webpack_require__(29);
	var keymap = _interopDefault(__webpack_require__(34));
	var preact = __webpack_require__(24);
	
	var FONT_COLOR_DARK = "#333";
	var FONT_COLOR_LIGHT = "#fff";
	var colorsMore = ["#fff", "#333", "#f5222d", "#fa541c", "#faad14", "#fadb14", "#52c41a", "#13c2c2", "#1890ff", "#2f54eb", "#722ed1", "#eb2f96", "#f6f6f6", "#989898", "#ffe8e7", "#ffece0", "#fff7cb", "#fcfcca", "#e5f7d3", "#cffff7", "#d4eefc", "#dfe8fc", "#efe1fa", "#fbe1eb", "#e9e9e9", "#666", "#ffa39e", "#ffbb96", "#ffe58f", "#fffb8f", "#b7eb8f", "#87e8de", "#91d5ff", "#adc6ff", "#d3adf7", "#ffadd2", "#ddd", "#4b4b4b", "#ff4d4f", "#ff7a45", "#ffc53d", "#ffec3d", "#73d13d", "#36cfc9", "#40a8ff", "#597ef7", "#9254de", "#f759ab", "#ccc", "#262626", "#cf1322", "#d4380d", "#d48806", "#d4b106", "#389e0d", "#08979c", "#096dd9", "#1d39c4", "#531dab", "#c41d7f", "#aaa", "#000", "#820014", "#871400", "#874d00", "#876800", "#135200", "#00474f", "#003a8c", "#061178", "#22075e", "#780650"];
	var colors = ["#ccc", "#f5222d", "#fadb14", "#52c41a", "#1890ff"];
	var patterns = [{
	  type: "fill",
	  text: "填充"
	}, {
	  type: "outline",
	  text: "线框"
	}];
	var colorsMap = {
	  gray: "#ccc",
	  red: "#f5222d",
	  yellow: "#fadb14",
	  green: "#52c41a",
	  blue: "#1890ff"
	};
	
	var formatOldValue = function formatOldValue() {
	  var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
	
	  if (colorsMap[color]) {
	    return colorsMap[color];
	  }
	
	  return color;
	};
	
	var computeFontColor = function computeFontColor(color) {
	  var index = colorsMore.findIndex(function (c) {
	    return c === color;
	  });
	
	  if (index === -1) {
	    return FONT_COLOR_DARK;
	  }
	
	  if (index % 12 < 1) {
	    return FONT_COLOR_DARK;
	  }
	
	  if (index % 12 < 2) {
	    return FONT_COLOR_LIGHT;
	  }
	
	  if (index > 11 && index < 36) {
	    return FONT_COLOR_DARK;
	  }
	
	  return FONT_COLOR_LIGHT;
	};
	
	var computeStyle = function computeStyle(color, pattern) {
	  return '\n    background: ' + (pattern === "fill" ? color : "#fff") + ';\n    border-color: ' + color + ';\n    color: ' + (pattern === "fill" ? computeFontColor(color) : "") + ';\n  ';
	};
	var createNodeView = function createNodeView(node) {
	  var dom = document.createElement("span");
	  var _node$attrs = node.attrs,
	      color = _node$attrs.color,
	      pattern = _node$attrs.pattern;
	
	  dom.setAttribute("class", "ct-status");
	  dom.setAttribute("style", computeStyle(color, pattern));
	  dom.setAttribute("spellcheck", "false");
	  return {
	    dom: dom,
	    contentDOM: dom
	  };
	};
	
	var schema = {
	  nodes: {
	    status: {
	      group: "inline",
	      content: "text*",
	      inline: true,
	      defining: true,
	      allowGapCursor: true,
	      braceWidth: 90,
	      attrs: {
	        pattern: {
	          default: "fill"
	        },
	        color: {
	          default: "#ccc"
	        },
	        expand: {
	          default: false
	        },
	        input: {
	          default: false
	        },
	        selectedkey: {
	          default: null
	        }
	      },
	      parseDOM: [{
	        tag: 'span[class~="ct-status"]',
	        getAttrs: function getAttrs(dom) {
	          var color = formatOldValue(dom.getAttribute("data-color"));
	          return {
	            color: color,
	            pattern: dom.getAttribute("data-pattern"),
	            expand: !colors.includes(color)
	          };
	        }
	      }],
	
	      toDOM: function toDOM(node) {
	        var _node$attrs2 = node.attrs,
	            pattern = _node$attrs2.pattern,
	            color = _node$attrs2.color;
	
	        var nodeAttrs = {
	          "class": "ct-status",
	          "data-pattern": pattern,
	          "data-color": color
	        };
	        return ["span", nodeAttrs, 0];
	      }
	    }
	  }
	};
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    (0, _defineProperty3.default)(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	var defineProperty = _defineProperty;
	
	function _objectSpread(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? arguments[i] : {};
	    var ownKeys = (0, _keys2.default)(source);
	
	    if (typeof _getOwnPropertySymbols2.default === 'function') {
	      ownKeys = ownKeys.concat((0, _getOwnPropertySymbols2.default)(source).filter(function (sym) {
	        return (0, _getOwnPropertyDescriptor2.default)(source, sym).enumerable;
	      }));
	    }
	
	    ownKeys.forEach(function (key) {
	      defineProperty(target, key, source[key]);
	    });
	  }
	
	  return target;
	}
	
	var objectSpread = _objectSpread;
	
	function _insert() {
	  return function (state, dispatch, view, trigger) {
	    var tr = state.tr,
	        schema = state.schema,
	        selection = state.selection;
	    var $from = selection.$from,
	        from = selection.from;
	    var status = schema.nodes.status;
	
	
	    if (!index_js.canInsertTypes(state)) {
	      return false;
	    }
	
	    var selectedkey = index_js.uuid();
	    var node = status.create({
	      input: true,
	      selectedkey: selectedkey
	    }, schema.text('\u200B'));
	    var plus = $from.parent.type.name === "link" ? 3 : 2;
	    tr.replaceWith(from, from, node);
	    var newSelection = prosemirrorState.TextSelection.create(tr.doc, from + plus);
	    tr.setSelection(newSelection);
	    dispatch(tr.scrollIntoView());
	
	    if (typeof trigger === "function") {
	      trigger("afterInsert", {
	        braceWidth: 90
	      });
	    }
	
	    view.focus();
	    return true;
	  };
	}
	
	function setAttrs(attrs, outSelection) {
	  return function (state, dispatch, view) {
	    var tr = state.tr,
	        schema = state.schema;
	    var from = outSelection.from,
	        to = outSelection.to;
	
	    var status = schema.nodes.status;
	    index_js.setBetweenAttrs(from, to, tr, function (node) {
	      return node.type === status;
	    }, function (oldAttrs) {
	      return objectSpread({}, oldAttrs, attrs);
	    });
	    tr.setSelection(outSelection);
	    dispatch(tr);
	    view.focus();
	    return true;
	  };
	}
	
	var lastSelectStatus = null;
	
	var nodeAssert = function nodeAssert(status) {
	  return function (node) {
	    return node.type === status;
	  };
	};
	
	var domAssert = function domAssert(dom) {
	  return dom && dom.classList && dom.classList.contains("ct-status");
	};
	
	var pluginKey = new prosemirrorState.PluginKey("status");
	function createPlugin(store) {
	  return new prosemirrorState.Plugin({
	    key: pluginKey,
	    props: {
	      handleClick: function handleClick() {
	        store.hidePopover();
	      },
	      handleClickOn: function handleClickOn(view, pos, node, nodePos) {
	        var dispatch = view.dispatch,
	            state = view.state;
	        var schema = state.schema,
	            tr = state.tr,
	            selection = state.selection;
	        var status = schema.nodes.status;
	
	
	        try {
	          if (selection && node.type.name === status.name) {
	            if (!lastSelectStatus) {
	              var newSelection = prosemirrorState.NodeSelection.create(tr.doc, nodePos);
	              tr.setSelection(newSelection);
	              dispatch(tr);
	            } else if (lastSelectStatus.selectedkey === node.attrs.selectedkey) {
	              var newPos = pos;
	              var nodeBefore = selection.$from.nodeBefore;
	
	              if (!nodeBefore) {
	                newPos += 1;
	              }
	
	              tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, newPos));
	
	              if (tr.selection.node || tr.selection.$from.parent.type.name !== status.name) {
	                tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, newPos - 1));
	              }
	
	              view.dispatch(tr);
	              view.focus();
	            }
	
	            return true;
	          }
	        } catch (err) {
	          console.error(err);
	        }
	      },
	      transformPastedHTML: function transformPastedHTML(html) {
	        return html.replace(/(class="ct-status"[^>]*>(?!\u200B))/g, '$1\u200B');
	      },
	
	      handleDoubleClick: function handleDoubleClick(view, _pos, e) {
	        var state = view.state,
	            dispatch = view.dispatch;
	        var tr = state.tr,
	            doc = state.doc,
	            schema = state.schema,
	            selection = state.selection;
	        var status = schema.nodes.status;
	
	        var foundNode = index_js.findParentNode(state.selection.$from.path, nodeAssert(status));
	        var statusDOM = index_js.findParentDOM(e.target, domAssert);
	        var pos = null;
	
	        if (foundNode && statusDOM) {
	          pos = foundNode.pos;
	        } else if (statusDOM) {
	          pos = view.docView.posFromDOM(statusDOM) - 1 - statusDOM.textContent.length;
	        }
	
	        var node = selection.node;
	
	
	        if (pos && node) {
	          tr.setSelection(prosemirrorState.TextSelection.create(doc, pos + node.nodeSize - 1));
	          dispatch(tr);
	          return true;
	        }
	
	        return false;
	      },
	      handleDOMEvents: {
	        cut: function cut(view, event) {
	          var _view$state = view.state,
	              selection = _view$state.selection,
	              schema = _view$state.schema,
	              tr = _view$state.tr;
	          var status = schema.nodes.status;
	          var $from = selection.$from,
	              $to = selection.$to,
	              from = selection.from,
	              to = selection.to;
	
	          var selectStatusFrom = $from.parent && $from.parent.type === status && $from.parent;
	          var selectStatusTo = $to.parent && $to.parent.type === status && $to.parent;
	          var statusNode = selectStatusFrom || selectStatusTo;
	          var rangeSize = Math.abs(to - from) + 3;
	
	          if ((selectStatusFrom || selectStatusTo) && rangeSize >= statusNode.nodeSize) {
	            try {
	              var _prosemirrorState$Tex;
	
	              var pos = [];
	
	              if (rangeSize === statusNode.nodeSize) {
	                pos = [from - 2, to + 1];
	              } else if (selectStatusFrom) {
	                pos = [from - 2, to];
	              } else if (selectStatusTo) {
	                pos = [from, to + 1];
	              }
	
	              var newSelection = (_prosemirrorState$Tex = prosemirrorState.TextSelection).create.apply(_prosemirrorState$Tex, [tr.doc].concat((0, _toConsumableArray3.default)(pos)));
	              view.dispatch(tr.setSelection(newSelection));
	            } catch (err) {
	              console.error(err);
	            }
	          }
	        },
	        drop: function drop() {
	          store.hidePopover(false);
	        },
	        keydown: function keydown(view, e) {
	          var state = view.state,
	              dispatch = view.dispatch;
	          var tr = state.tr,
	              schema = state.schema,
	              selection = state.selection;
	          var from = selection.from,
	              $from = selection.$from,
	              to = selection.to;
	
	          var status = schema.nodes.status;
	          var node = selection.node;
	          var keyCode = e.keyCode || e.which;
	
	          if (keyCode === 8) {
	            return false;
	          }
	
	          if (node && node.type === status) {
	            tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, from + 2, from + node.nodeSize - 1));
	            dispatch(tr);
	          } else if ($from.parent && $from.parent.type === status && !$from.nodeBefore) {
	            tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, from + 1, to));
	            dispatch(tr);
	          }
	        },
	        mousedown: function mousedown(view) {
	          var _view$state2 = view.state,
	              selection = _view$state2.selection,
	              schema = _view$state2.schema;
	          var status = schema.nodes.status;
	
	          var selectedNode = selection && selection.$from.parent;
	
	          if (selectedNode && selectedNode.type.name !== status.name || selection.node) {
	            selectedNode = selection.node;
	          }
	
	          if (selectedNode && selectedNode.type.name === status.name) {
	            if (lastSelectStatus && lastSelectStatus.selectedkey !== selectedNode.attrs.selectedkey) {
	              lastSelectStatus = null;
	            } else {
	              lastSelectStatus = {
	                selectedkey: selectedNode.attrs.selectedkey
	              };
	            }
	          } else {
	            lastSelectStatus = null;
	          }
	
	          return false;
	        }
	      },
	      nodeViews: {
	        status: function status(node) {
	          return createNodeView(node);
	        }
	      }
	    },
	    view: function view(_view) {
	      return new index_js.Popover({
	        view: _view,
	        store: store,
	        height: 76,
	        className: "ct-status-popover",
	        bottomFirst: true,
	        sticky: false,
	        getToolboxHeightFn: function getToolboxHeightFn() {
	          if (store.node && store.node.attrs.expand) {
	            return 170;
	          }
	
	          return 76;
	        }
	      });
	    }
	  });
	}
	
	function checkZero(text) {
	  return text === '\u200B';
	}
	
	function isSelectStatus() {
	  var selection = window.getSelection();
	  return selection.focusNode && selection.focusNode.classList && selection.focusNode.classList.contains("ct-status");
	}
	
	function handleBackspace(state, dispatch, view) {
	  var tr = state.tr,
	      schema = state.schema,
	      selection = state.selection;
	
	  var status = schema.nodes.status;
	  var $cursor = selection.$cursor,
	      $from = selection.$from,
	      from = selection.from,
	      to = selection.to;
	
	  var statusInfo = index_js.findParentNode($from.path, function (node) {
	    return node.type === status;
	  });
	
	  if (statusInfo) {
	    if ($cursor) {
	      var cursorNodeBefore = $cursor.nodeBefore;
	      var isZeroBefore = cursorNodeBefore && checkZero(cursorNodeBefore.text);
	
	      if (isZeroBefore || !cursorNodeBefore) {
	        return true;
	      }
	    } else {
	      var isFocusStatus = isSelectStatus();
	      var nodeBefore = $from.nodeBefore;
	
	      var trueFrom = from;
	
	      if (!isFocusStatus) {
	        if (!nodeBefore) {
	          trueFrom += 1;
	        }
	
	        tr.delete(trueFrom, to);
	        tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, trueFrom));
	        dispatch(tr);
	        view.focus();
	        return true;
	      } else if (!nodeBefore) {
	        dispatch(tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, trueFrom + 1, to)));
	        return false;
	      }
	    }
	  }
	
	  if ($cursor) {
	    var textPos = from - 3;
	
	    if (textPos < 0) {
	      return false;
	    }
	
	    var textNode = tr.doc.nodeAt(textPos);
	
	    if (textNode && textNode.type.name === "text") {
	      var statusPos = textPos - textNode.nodeSize;
	
	      if (statusPos < 0) {
	        return false;
	      }
	
	      var statusNode = tr.doc.nodeAt(statusPos);
	
	      if (statusNode && statusNode.type === status) {
	        tr.delete(from - 1, from);
	        var newSelection = new index_js$1.GapCursor(tr.doc.resolve(from - 1));
	        dispatch(tr.setSelection(newSelection));
	        return true;
	      }
	    }
	  }
	
	  return false;
	}
	var handleEnter = function handleEnter(state, dispatch, view) {
	  var tr = state.tr,
	      schema = state.schema,
	      selection = state.selection;
	  var $from = selection.$from;
	
	  var status = schema.nodes.status;
	  var foundNode = index_js.findParentNode($from.path, function (node) {
	    return node.type === status;
	  });
	
	  if (foundNode) {
	    var node = foundNode.node,
	        pos = foundNode.pos;
	
	    var newSelection = prosemirrorState.TextSelection.create(tr.doc, pos + node.nodeSize + 1);
	    dispatch(tr.setSelection(newSelection));
	    view.focus();
	    return true;
	  }
	
	  return false;
	};
	
	var ColorPicker = function ColorPicker(_ref) {
	  var _ref$className = _ref.className,
	      className = _ref$className === undefined ? "" : _ref$className,
	      colors = _ref.colors,
	      selected = _ref.selected,
	      onChange = _ref.onChange;
	  return preact.h("div", {
	    className: 'color-group ' + className
	  }, colors.map(function (color) {
	    return preact.h("div", {
	      key: color,
	      className: 'item' + (color === selected ? " selected" : ""),
	      onClick: function onClick() {
	        return onChange(color);
	      }
	    }, preact.h("div", {
	      style: {
	        backgroundColor: color
	      }
	    }));
	  }));
	};
	
	function styleInject(css, ref) {
	  if (ref === void 0) ref = {};
	  var insertAt = ref.insertAt;
	
	  if (!css || typeof document === 'undefined') {
	    return;
	  }
	
	  var head = document.head || document.getElementsByTagName('head')[0];
	  var style = document.createElement('style');
	  style.type = 'text/css';
	
	  if (insertAt === 'top') {
	    if (head.firstChild) {
	      head.insertBefore(style, head.firstChild);
	    } else {
	      head.appendChild(style);
	    }
	  } else {
	    head.appendChild(style);
	  }
	
	  if (style.styleSheet) {
	    style.styleSheet.cssText = css;
	  } else {
	    style.appendChild(document.createTextNode(css));
	  }
	}
	
	var css = ".ct-status-expand{display:flex;align-items:center}.ct-status-expand-btn{display:flex;width:26px;height:26px;background:url(\"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTExIDIxYTMgMyAwIDEgMSAwIDYgMyAzIDAgMCAxIDAtNnptMTMgMGEzIDMgMCAxIDEgMCA2IDMgMyAwIDAgMSAwLTZ6bTEzIDBhMyAzIDAgMSAxIDAgNiAzIDMgMCAwIDEgMC02eiIgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJub256ZXJvIi8+PC9zdmc+\") 50% no-repeat;background-size:16px 16px;cursor:pointer;margin:0 1px 0 -5px}";
	styleInject(css);
	
	var Expand = function (_preact$Component) {
	  (0, _inherits3.default)(Expand, _preact$Component);
	
	  function Expand(props) {
	    (0, _classCallCheck3.default)(this, Expand);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Expand.__proto__ || (0, _getPrototypeOf2.default)(Expand)).call(this, props));
	
	    _this.handleClick = function () {
	      var _this$props$onExpand = _this.props.onExpand,
	          onExpand = _this$props$onExpand === undefined ? function () {
	        return null;
	      } : _this$props$onExpand;
	
	      _this.setState({
	        expand: true
	      });
	      onExpand();
	    };
	
	    _this.state = {
	      expand: !!props.expand
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(Expand, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          _props$className = _props.className,
	          className = _props$className === undefined ? "" : _props$className,
	          child = _props.child,
	          children = _props.children;
	      var expand = this.state.expand;
	
	      return preact.h("div", {
	        className: 'ct-status-expand ' + className
	      }, expand ? child : children, expand ? null : preact.h("div", {
	        className: "ct-status-expand-btn",
	        onClick: function onClick() {
	          return _this2.handleClick();
	        }
	      }));
	    }
	  }]);
	  return Expand;
	}(preact.Component);
	
	var PatternPicker = function PatternPicker(_ref2) {
	  var _ref2$className = _ref2.className,
	      className = _ref2$className === undefined ? "" : _ref2$className,
	      patterns = _ref2.patterns,
	      selected = _ref2.selected,
	      onChange = _ref2.onChange;
	  return preact.h("div", {
	    className: 'pattern-group ' + className
	  }, patterns.map(function (p) {
	    return preact.h("label", {
	      className: "radio",
	      key: p.type,
	      onClick: function onClick() {
	        return onChange(p.type);
	      }
	    }, preact.h("span", {
	      className: "radio-bg"
	    }), preact.h("input", {
	      type: "radio",
	      checked: selected === p.type
	    }), " ", p.text, preact.h("span", {
	      className: "radio-on"
	    }));
	  }));
	};
	
	var css$1 = ".ct-toolbox.ct-status-editor{flex-direction:column;align-items:flex-start}.ct-toolbox.ct-status-editor .ct-status-editor-expand{display:flex;flex-direction:row}.ct-toolbox.ct-status-editor .color-group{height:38px;display:flex;justify-content:center;align-items:center}.ct-toolbox.ct-status-editor .color-group .item{width:26px;height:26px;margin:0 2px;display:flex;justify-content:center;align-items:center;cursor:pointer}.ct-toolbox.ct-status-editor .color-group .item.selected,.ct-toolbox.ct-status-editor .color-group .item:hover{border:1px solid #ccc;border-radius:2px}.ct-toolbox.ct-status-editor .color-group .item:first-child{margin:0 2px 0 4px}.ct-toolbox.ct-status-editor .color-group .item div{width:14px;height:14px}.ct-toolbox.ct-status-editor .color-group-large{width:244px;height:106px;flex-wrap:wrap;margin:9px 6px}.ct-toolbox.ct-status-editor .color-group-large .item{width:16px;height:16px;border:1px solid #eee;margin:1px 2px 0}.ct-toolbox.ct-status-editor .color-group-large .item.selected,.ct-toolbox.ct-status-editor .color-group-large .item:hover{z-index:2;border-radius:1px;border:1px solid #fff;box-shadow:0 0 0 2px #999}.ct-toolbox.ct-status-editor .color-group-large .item:hover{z-index:3}.ct-toolbox.ct-status-editor .color-group-large .item:first-child{margin:1px 2px 0}.ct-toolbox.ct-status-editor .pattern-group{height:38px;display:flex;justify-content:center;align-items:center;margin-left:12px}.ct-toolbox.ct-status-editor .pattern-group.large{margin-bottom:8px}.ct-toolbox.ct-status-editor .pattern-group .radio{display:inline-block;position:relative;font-size:14px;line-height:16px;margin-right:12px;cursor:pointer}.ct-toolbox.ct-status-editor .pattern-group .radio input{display:none}.ct-toolbox.ct-status-editor .pattern-group .radio .radio-bg{display:inline-block;height:16px;width:16px;margin-right:5px;padding:0;border-radius:100%;border:1px solid #00a7cd;vertical-align:top;cursor:pointer;transition:all .2s ease}.ct-toolbox.ct-status-editor .pattern-group .radio .radio-on{display:none}.ct-toolbox.ct-status-editor .pattern-group .radio input:checked+span.radio-on{width:8px;height:8px;position:absolute;border-radius:100%;background:#00a7cd;top:4px;left:4px;transition:all .2s ease;-webkit-transform:scale(1);transform:scale(1);display:inline-block}";
	styleInject(css$1);
	
	var StatusEditor = function (_preact$Component2) {
	  (0, _inherits3.default)(StatusEditor, _preact$Component2);
	
	  function StatusEditor(props) {
	    (0, _classCallCheck3.default)(this, StatusEditor);
	
	    var _this3 = (0, _possibleConstructorReturn3.default)(this, (StatusEditor.__proto__ || (0, _getPrototypeOf2.default)(StatusEditor)).call(this, props));
	
	    _this3.handleClick = function (e) {
	      e.stopImmediatePropagation();
	      e.stopPropagation();
	    };
	
	    _this3.handleExpand = function () {
	      _this3.setState({
	        expand: true
	      });
	      _this3.props.handleExpand();
	    };
	
	    _this3.state = {
	      expand: props.expand
	    };
	    return _this3;
	  }
	
	  (0, _createClass3.default)(StatusEditor, [{
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props2 = this.props,
	          color = _props2.color,
	          pattern = _props2.pattern,
	          handleColorSelect = _props2.handleColorSelect,
	          handlePatternSelect = _props2.handlePatternSelect;
	      var expand = this.state.expand;
	
	      return preact.h("div", {
	        className: "ct-status-editor",
	        onClick: this.handleClick
	      }, preact.h(Expand, {
	        className: "ct-status-editor-expand",
	        expand: expand,
	        onExpand: function onExpand() {
	          return _this4.handleExpand();
	        },
	        child: preact.h(ColorPicker, {
	          className: "color-group-large",
	          colors: colorsMore,
	          selected: color,
	          onChange: function onChange(c) {
	            return handleColorSelect(c, expand);
	          }
	        })
	      }, preact.h(ColorPicker, {
	        colors: colors,
	        selected: color,
	        onChange: function onChange(c) {
	          return handleColorSelect(c, expand);
	        }
	      })), preact.h(PatternPicker, {
	        className: expand ? "large" : "",
	        patterns: patterns,
	        selected: pattern,
	        onChange: function onChange(p) {
	          return handlePatternSelect(p, expand);
	        }
	      }));
	    }
	  }]);
	  return StatusEditor;
	}(preact.Component);
	
	var StatusStore = function () {
	  function StatusStore() {
	    var _this5 = this;
	
	    (0, _classCallCheck3.default)(this, StatusStore);
	
	    this.color = "gray";
	    this.pattern = "fill";
	    this.pluginName = "status";
	    this.node = null;
	
	    this.showPopover = function (node) {
	      _this5.node = node;
	      _this5.ctPopover.show({
	        dom: _this5.node.dom,
	        content: _this5.getToolbar(node.attrs)
	      });
	    };
	
	    this.hidePopover = function () {
	      _this5.ctPopover.hide();
	    };
	
	    this.handleColorSelect = function (color, exp) {
	      var expand = exp || !colors.includes(color);
	      var dom = _this5.setAttrs({
	        color: color,
	        expand: expand
	      });
	      _this5.color = color;
	      _this5.node.dom = dom;
	      var node = {
	        dom: dom,
	        pos: _this5.node.pos,
	        attrs: _this5.node.attrs
	      };
	      _this5.hidePopover();
	      _this5.showPopover(node);
	    };
	
	    this.handlePatternSelect = function (pattern, expand) {
	      var dom = _this5.setAttrs({
	        pattern: pattern,
	        expand: expand
	      });
	      _this5.pattern = pattern;
	      _this5.node.dom = dom;
	      var node = {
	        dom: dom,
	        pos: _this5.node.pos,
	        attrs: _this5.node.attrs
	      };
	      _this5.hidePopover();
	      _this5.showPopover(node);
	    };
	
	    this.handleExpand = function () {
	      var dom = _this5.setAttrs({
	        expand: true
	      });
	      _this5.node.dom = dom;
	      var node = {
	        dom: dom,
	        pos: _this5.node.pos,
	        attrs: _this5.node.attrs
	      };
	      _this5.hidePopover();
	      _this5.showPopover(node);
	    };
	
	    this.setAttrs = function (newAttrs) {
	      if (!_this5.node) {
	        return;
	      }
	
	      var _editor$view = _this5.editor.view,
	          state = _editor$view.state,
	          dispatch = _editor$view.dispatch;
	      var tr = state.tr;
	      var pos = _this5.node.pos;
	
	
	      try {
	        var attrs = objectSpread({}, _this5.node.attrs, newAttrs);
	
	        _this5.node.attrs = attrs;
	        tr.setNodeMarkup(pos, null, attrs);
	      } catch (error) {
	        console.error(error);
	      }
	
	      dispatch(tr);
	      return _this5.view.nodeDOM(pos);
	    };
	
	    this.getToolbar = function (_ref3) {
	      var color = _ref3.color,
	          pattern = _ref3.pattern,
	          expand = _ref3.expand;
	
	      return preact.h(StatusEditor, {
	        color: color,
	        pattern: pattern,
	        expand: expand,
	        handleColorSelect: _this5.handleColorSelect,
	        handlePatternSelect: _this5.handlePatternSelect,
	        handleExpand: _this5.handleExpand,
	        hidePopover: _this5.hidePopover
	      });
	    };
	  }
	
	  (0, _createClass3.default)(StatusStore, [{
	    key: 'init',
	    value: function init(editor) {
	      this.editor = editor;
	      this.view = editor.view;
	    }
	  }]);
	  return StatusStore;
	}();
	
	function wash(body) {
	  return body.replace(/(<span class="ct-status"[^>]+>)/g, '$1\u200B');
	}
	
	var css$2 = ".ct-status{display:inline-block;word-break:break-all;min-height:22px;min-width:68px;padding:0 8px;margin:0 2px;vertical-align:bottom;font-size:12px;font-weight:700;line-height:18px;text-align:center;color:#000;background-color:#ccc;border:2px solid #ccc;border-radius:2px;cursor:text}.ct-status[data-color=red]{background-color:#f5222d;border-color:#f5222d}.ct-status[data-color=red][data-pattern=fill]{color:#fff}.ct-status[data-color=yellow]{background-color:#fadb14;border-color:#fadb14}.ct-status[data-color=yellow][data-pattern=fill]{color:#876800}.ct-status[data-color=green]{background-color:#52c41a;border-color:#52c41a}.ct-status[data-color=green][data-pattern=fill]{color:#fff}.ct-status[data-color=blue]{background-color:#1890ff;border-color:#1890ff}.ct-status[data-color=blue][data-pattern=fill]{color:#fff}.ct-status[data-pattern=outline]{background-color:#f7f7f7}.ct-status.ProseMirror-selectednode{outline:unset}.ct-status.ct-selected,.ct-status.ProseMirror-selectednode,.ct-status:hover{position:relative}.ct-status.ct-selected:after,.ct-status.ProseMirror-selectednode:after,.ct-status:hover:after{z-index:2;position:absolute;content:\"\";left:-3px;right:-3px;top:-3px;bottom:-3px;border:2px solid #23bdd9;border-radius:3px;pointer-events:none}.ct-status[data-selectedkey]{cursor:default}";
	styleInject(css$2);
	
	var toView = function toView(_ref4) {
	  var bodyWrapper = _ref4.bodyWrapper;
	
	  var nodes = bodyWrapper.querySelectorAll(".ct-status");
	  (0, _from2.default)(nodes).forEach(function (node) {
	    var _node$dataset = node.dataset,
	        _node$dataset$color = _node$dataset.color,
	        color = _node$dataset$color === undefined ? "#ccc" : _node$dataset$color,
	        _node$dataset$pattern = _node$dataset.pattern,
	        pattern = _node$dataset$pattern === undefined ? "fill" : _node$dataset$pattern;
	
	    var formattedColor = formatOldValue(color);
	    node.setAttribute("style", computeStyle(formattedColor, pattern));
	  });
	};
	
	var StatusModule = function () {
	  function StatusModule() {
	    (0, _classCallCheck3.default)(this, StatusModule);
	
	    this.name = "status";
	    this.store = void 0;
	    this.schema = void 0;
	    this.commands = void 0;
	    this.plugins = void 0;
	    this.wash = void 0;
	    this.store = new StatusStore();
	    this.schema = schema;
	    this.commands = {
	      insert: function insert() {
	        return _insert();
	      },
	      setAttrs: setAttrs
	    };
	    this.plugins = [createPlugin(this.store), keymap({
	      "Backspace": handleBackspace,
	      "Mod-Backspace": handleBackspace,
	      "Delete": handleBackspace,
	      "Mod-Delete": handleBackspace,
	      "Enter": handleEnter,
	      "Tab": handleEnter
	    })];
	    this.wash = wash;
	  }
	
	  (0, _createClass3.default)(StatusModule, [{
	    key: 'init',
	    value: function init(editor) {
	      this.store.init(editor);
	    }
	  }]);
	  return StatusModule;
	}();
	
	StatusModule.moduleName = "status";
	
	exports.StatusModule = StatusModule;
	exports.toView = toView;

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var packageInfo = __webpack_require__(448);
	
	__webpack_require__(146).setPkgVersion(packageInfo.version);
	
	module.exports = __webpack_require__(146);

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _stringify = __webpack_require__(100);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _iterator = __webpack_require__(82);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(81);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _promise = __webpack_require__(35);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = _promise2.default))(function (resolve, reject) {
	        function fulfilled(value) {
	            try {
	                step(generator.next(value));
	            } catch (e) {
	                reject(e);
	            }
	        }
	        function rejected(value) {
	            try {
	                step(generator["throw"](value));
	            } catch (e) {
	                reject(e);
	            }
	        }
	        function step(result) {
	            result.done ? resolve(result.value) : new P(function (resolve) {
	                resolve(result.value);
	            }).then(fulfilled, rejected);
	        }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	var __generator = undefined && undefined.__generator || function (thisArg, body) {
	    var _ = { label: 0, sent: function sent() {
	            if (t[0] & 1) throw t[1];return t[1];
	        }, trys: [], ops: [] },
	        f,
	        y,
	        t,
	        g;
	    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof _symbol2.default === "function" && (g[_iterator2.default] = function () {
	        return this;
	    }), g;
	    function verb(n) {
	        return function (v) {
	            return step([n, v]);
	        };
	    }
	    function step(op) {
	        if (f) throw new TypeError("Generator is already executing.");
	        while (_) {
	            try {
	                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	                if (y = 0, t) op = [op[0] & 2, t.value];
	                switch (op[0]) {
	                    case 0:case 1:
	                        t = op;break;
	                    case 4:
	                        _.label++;return { value: op[1], done: false };
	                    case 5:
	                        _.label++;y = op[1];op = [0];continue;
	                    case 7:
	                        op = _.ops.pop();_.trys.pop();continue;
	                    default:
	                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
	                            _ = 0;continue;
	                        }
	                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
	                            _.label = op[1];break;
	                        }
	                        if (op[0] === 6 && _.label < t[1]) {
	                            _.label = t[1];t = op;break;
	                        }
	                        if (t && _.label < t[2]) {
	                            _.label = t[2];_.ops.push(op);break;
	                        }
	                        if (t[2]) _.ops.pop();
	                        _.trys.pop();continue;
	                }
	                op = body.call(thisArg, _);
	            } catch (e) {
	                op = [6, e];y = 0;
	            } finally {
	                f = t = 0;
	            }
	        }if (op[0] & 5) throw op[1];return { value: op[0] ? op[1] : void 0, done: true };
	    }
	};
	var __importDefault = undefined && undefined.__importDefault || function (mod) {
	    return mod && mod.__esModule ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	
	var request_1 = __webpack_require__(147);
	var common_util_1 = __webpack_require__(80);
	var en_GB_1 = __importDefault(__webpack_require__(79));
	var SYS_ERROR = en_GB_1.default.SYS_ERROR;
	var RestClient = function () {
	    function RestClient(args) {
	        this.apiUrlLogin = args.apiUrlLogin;
	        this.apiUrlOpen = args.apiUrlOpen;
	        this.logger = new common_util_1.Logger('RestClient');
	    }
	    RestClient.prototype.getToken = function (code, codeVerifier, clientId) {
	        return __awaiter(this, void 0, void 0, function () {
	            var url, opts, data, err_1;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        url = this.apiUrlLogin + "/oauth2.0/pkce/access-token?code=" + code + "&code_verifier=" + codeVerifier + "&client_id=" + clientId;
	                        opts = {
	                            headers: {
	                                "Content-Type": 'application/json'
	                            },
	                            method: 'GET'
	                        };
	                        _a.label = 1;
	                    case 1:
	                        _a.trys.push([1, 3,, 4]);
	                        return [4, request_1.fetchRequest(url, opts)];
	                    case 2:
	                        data = _a.sent();
	                        return [3, 4];
	                    case 3:
	                        err_1 = _a.sent();
	                        data = {};
	                        data.msg = err_1.stack || SYS_ERROR;
	                        this.logger.error('getToken', err_1);
	                        return [3, 4];
	                    case 4:
	                        if (data.msg) {
	                            return [2, data.msg];
	                        }
	                        return [2, data];
	                }
	            });
	        });
	    };
	    RestClient.prototype.logout = function (accessToken, clientId) {
	        return __awaiter(this, void 0, void 0, function () {
	            var url, opts, data, err_2;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        url = this.apiUrlLogin + "/oauth2.0/pkce/logout";
	                        opts = {
	                            headers: {
	                                "Content-Type": 'application/json'
	                            },
	                            method: 'POST',
	                            body: (0, _stringify2.default)({
	                                accessToken: accessToken,
	                                clientId: clientId
	                            })
	                        };
	                        _a.label = 1;
	                    case 1:
	                        _a.trys.push([1, 3,, 4]);
	                        return [4, request_1.fetchRequest(url, opts)];
	                    case 2:
	                        data = _a.sent();
	                        return [3, 4];
	                    case 3:
	                        err_2 = _a.sent();
	                        data = {};
	                        data.msg = err_2.stack || SYS_ERROR;
	                        this.logger.error('logout', err_2);
	                        return [3, 4];
	                    case 4:
	                        if (data !== null && data.msg) {
	                            return [2, data.msg];
	                        }
	                        return [2, data];
	                }
	            });
	        });
	    };
	    return RestClient;
	}();
	exports.RestClient = RestClient;

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _iterator = __webpack_require__(82);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(81);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _promise = __webpack_require__(35);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = _promise2.default))(function (resolve, reject) {
	        function fulfilled(value) {
	            try {
	                step(generator.next(value));
	            } catch (e) {
	                reject(e);
	            }
	        }
	        function rejected(value) {
	            try {
	                step(generator["throw"](value));
	            } catch (e) {
	                reject(e);
	            }
	        }
	        function step(result) {
	            result.done ? resolve(result.value) : new P(function (resolve) {
	                resolve(result.value);
	            }).then(fulfilled, rejected);
	        }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	var __generator = undefined && undefined.__generator || function (thisArg, body) {
	    var _ = { label: 0, sent: function sent() {
	            if (t[0] & 1) throw t[1];return t[1];
	        }, trys: [], ops: [] },
	        f,
	        y,
	        t,
	        g;
	    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof _symbol2.default === "function" && (g[_iterator2.default] = function () {
	        return this;
	    }), g;
	    function verb(n) {
	        return function (v) {
	            return step([n, v]);
	        };
	    }
	    function step(op) {
	        if (f) throw new TypeError("Generator is already executing.");
	        while (_) {
	            try {
	                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	                if (y = 0, t) op = [op[0] & 2, t.value];
	                switch (op[0]) {
	                    case 0:case 1:
	                        t = op;break;
	                    case 4:
	                        _.label++;return { value: op[1], done: false };
	                    case 5:
	                        _.label++;y = op[1];op = [0];continue;
	                    case 7:
	                        op = _.ops.pop();_.trys.pop();continue;
	                    default:
	                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
	                            _ = 0;continue;
	                        }
	                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
	                            _.label = op[1];break;
	                        }
	                        if (op[0] === 6 && _.label < t[1]) {
	                            _.label = t[1];t = op;break;
	                        }
	                        if (t && _.label < t[2]) {
	                            _.label = t[2];_.ops.push(op);break;
	                        }
	                        if (t[2]) _.ops.pop();
	                        _.trys.pop();continue;
	                }
	                op = body.call(thisArg, _);
	            } catch (e) {
	                op = [6, e];y = 0;
	            } finally {
	                f = t = 0;
	            }
	        }if (op[0] & 5) throw op[1];return { value: op[0] ? op[1] : void 0, done: true };
	    }
	};
	var __importDefault = undefined && undefined.__importDefault || function (mod) {
	    return mod && mod.__esModule ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	
	__webpack_require__(663);
	var const_1 = __webpack_require__(98);
	var config_client_1 = __webpack_require__(145);
	var common_util_1 = __webpack_require__(80);
	var en_GB_1 = __importDefault(__webpack_require__(79));
	var rest_client_1 = __webpack_require__(241);
	var storage_1 = __webpack_require__(243);
	var store_util_1 = __webpack_require__(150);
	var crypto_util_1 = __webpack_require__(149);
	var SHOULD_NO_SCHEMA_IN_ORIGINAL_URL = en_GB_1.default.SHOULD_NO_SCHEMA_IN_ORIGINAL_URL,
	    ORIGINAL_URL_LOST = en_GB_1.default.ORIGINAL_URL_LOST,
	    PROTOCOL_UNDEFINED = en_GB_1.default.PROTOCOL_UNDEFINED,
	    STATE_ERROR = en_GB_1.default.STATE_ERROR;
	var SSOWeb = function () {
	    function SSOWeb(configs) {
	        var clientId = configs.clientId,
	            accessEnv = configs.accessEnv;
	        this.clientId = clientId;
	        this.accessEnv = accessEnv;
	        this.configClient = new config_client_1.ConfigClient(configs);
	        this.isInitial = false;
	    }
	    SSOWeb.prototype.init = function () {
	        return __awaiter(this, void 0, void 0, function () {
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        return [4, this.configClient.init()];
	                    case 1:
	                        _a.sent();
	                        return [4, this.initConfig(this.configClient.getConfig())];
	                    case 2:
	                        _a.sent();
	
	                        this.logger = new common_util_1.Logger('SSOClient');
	                        return [2];
	                }
	            });
	        });
	    };
	    SSOWeb.prototype.initConfig = function (_a) {
	        var clientId = _a.clientId,
	            logoutUri = _a.logoutUri,
	            loginUrl = _a.loginUrl,
	            rewriteLocation = _a.rewriteLocation,
	            schema = _a.schema,
	            sameSite = _a.sameSite,
	            isDebug = _a.isDebug,
	            excludedUriList = _a.excludedUriList,
	            includedUriList = _a.includedUriList,
	            openApiHost = _a.openApiHost,
	            ssoSvHost = _a.ssoSvHost,
	            callbackUrl = _a.callbackUrl;
	        return __awaiter(this, void 0, void 0, function () {
	            return __generator(this, function (_b) {
	                this.logoutUrl = logoutUri || const_1.SSO_SPECIAL_ROUTE.logoutUrl;
	                this.callbackUrl = callbackUrl || const_1.SSO_SPECIAL_ROUTE.callbackUrl;
	                this.loginUrl = loginUrl;
	                this.SSO_URL = {
	                    SSO_API_URL: openApiHost,
	                    SSO_LOGIN_URL: ssoSvHost
	                };
	                this.isInitial = true;
	
	                this.rewriteLocation = rewriteLocation ? '/' + rewriteLocation.replace(/^\/+/, '').replace(/\/+$/, '') : '';
	                this.schema = schema && schema.slice(-1) !== ':' ? schema + ":" : schema;
	                this.sameSite = sameSite !== false;
	                this.isDebug = isDebug === true;
	                this.excludedUriList = excludedUriList && excludedUriList.length > 0 ? excludedUriList.split(',') : excludedUriList;
	                this.includedUriList = includedUriList && includedUriList.length > 0 ? includedUriList.split(',') : includedUriList;
	                this.client = new rest_client_1.RestClient({
	                    apiUrlLogin: this.SSO_URL.SSO_LOGIN_URL,
	                    apiUrlOpen: this.SSO_URL.SSO_API_URL
	                });
	                this.store = new storage_1.Storage({
	                    clientId: clientId,
	                    method: const_1.HARD_CODE_METHOD
	                });
	                return [2];
	            });
	        });
	    };
	    SSOWeb.prototype.login = function () {
	        return __awaiter(this, void 0, void 0, function () {
	            var _a, logoutUrl, callbackUrl, rewriteLocation, includedUriList, excludedUriList, _b, stateStore, verifier, tokenStore, code, originalUrl, token, href, origin, reqPath, defaultCallbackUrl, defaultLogoutUrl, defaultRobotUrl, defaultCheckPath, state, stateInBrowser, codeVerifier, result, accessToken, redirectUrlObj, loginUrl_1;
	            return __generator(this, function (_c) {
	                switch (_c.label) {
	                    case 0:
	                        if (!!this.isInitial) return [3, 2];
	                        return [4, this.init()];
	                    case 1:
	                        _c.sent();
	                        _c.label = 2;
	                    case 2:
	                        _a = this, logoutUrl = _a.logoutUrl, callbackUrl = _a.callbackUrl, rewriteLocation = _a.rewriteLocation, includedUriList = _a.includedUriList, excludedUriList = _a.excludedUriList;
	                        _b = this.store, stateStore = _b.stateStore, verifier = _b.verifier, tokenStore = _b.tokenStore;
	                        code = common_util_1.urlObj.getSearchString('code');
	                        originalUrl = common_util_1.urlObj.getSearchString('original-url');
	                        token = tokenStore.getToken();
	                        href = location.href;
	                        origin = location.origin;
	                        reqPath = decodeURIComponent(common_util_1.urlObj.getReqPath(href, origin, rewriteLocation));
	                        if (this.isDebug) {
	                            console.log("================== ssoweb debug =================");
	                            console.log("logoutUrl: ", this.logoutUrl);
	                            console.log("callbackUrl: ", this.callbackUrl);
	                            console.log("href: ", decodeURIComponent(href));
	                            console.log("origin: ", origin);
	                            console.log("rewriteLocation: ", rewriteLocation);
	                            console.log("reqPath: ", reqPath);
	                            console.log("originalUrl: ", originalUrl);
	                            console.log("code: ", code);
	                            console.log("token: ", token);
	                            console.log("=================================================");
	                        }
	                        defaultCallbackUrl = const_1.SSO_SPECIAL_ROUTE.callbackUrl, defaultLogoutUrl = const_1.SSO_SPECIAL_ROUTE.logoutUrl, defaultRobotUrl = const_1.SSO_SPECIAL_ROUTE.robotUrl;
	                        defaultCheckPath = [defaultCallbackUrl, defaultLogoutUrl, defaultRobotUrl, logoutUrl, callbackUrl];
	                        if (!defaultCheckPath.includes(reqPath) && common_util_1.whiteListAndBlackListCheck(reqPath, excludedUriList, includedUriList)) {
	                            return [2, { type: 'info', message: 'no need to check' }];
	                        }
	                        if (!(code && this.isCallbackPath(reqPath))) return [3, 4];
	                        state = common_util_1.urlObj.getSearchString('state');
	                        stateInBrowser = stateStore.getState();
	                        if (common_util_1.hasSchema(originalUrl)) {
	                            this.logger.error('error', new Error(SHOULD_NO_SCHEMA_IN_ORIGINAL_URL));
	                            return [2, { type: 'error', message: SHOULD_NO_SCHEMA_IN_ORIGINAL_URL }];
	                        }
	                        if (!state || state !== stateInBrowser) {
	                            this.logger.error('error', new Error(STATE_ERROR));
	                            return [2, { type: 'error', message: STATE_ERROR }];
	                        }
	                        codeVerifier = verifier.getCodeVerifier();
	                        return [4, this.getToken(code, codeVerifier)];
	                    case 3:
	                        result = _c.sent();
	                        if (typeof result === 'string') {
	                            this.logger.error(result);
	                            return [2, { type: 'error', message: result }];
	                        }
	                        accessToken = result.accessToken;
	                        if (!originalUrl) {
	                            this.logger.error('error', new Error(ORIGINAL_URL_LOST));
	                            originalUrl = rewriteLocation + "/";
	                        }
	                        tokenStore.setToken(accessToken, this.sameSite);
	                        token = accessToken;
	
	                        setTimeout(function () {
	                            location.href = originalUrl;
	                        }, 1);
	                        return [3, 7];
	                    case 4:
	                        if (!(this.isLogoutPath(reqPath) || !token)) return [3, 7];
	                        redirectUrlObj = this.createRedirectUrl("" + rewriteLocation + reqPath);
	                        if (!this.isLogoutPath(reqPath)) return [3, 6];
	                        return [4, this.logout(token)];
	                    case 5:
	                        _c.sent();
	                        redirectUrlObj = this.createRedirectUrl(rewriteLocation + "/");
	                        _c.label = 6;
	                    case 6:
	                        loginUrl_1 = this.getLoginUrl(redirectUrlObj);
	
	                        setTimeout(function () {
	                            location.href = loginUrl_1;
	                        }, 1);
	                        return [2, { type: 'info', message: "redirect to " + loginUrl_1 }];
	                    case 7:
	                        return [2, token];
	                }
	            });
	        });
	    };
	    SSOWeb.prototype.logout = function (token) {
	        return __awaiter(this, void 0, void 0, function () {
	            var clientId, tokenStore;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        if (!this.isInitial) throw Error('should init first');
	                        if (!token) {
	                            token = this.store.tokenStore.getToken();
	                        }
	                        clientId = this.clientId;
	                        tokenStore = this.store.tokenStore;
	                        return [4, this.client.logout(token, clientId)];
	                    case 1:
	                        _a.sent();
	                        tokenStore.clearToken();
	                        return [2];
	                }
	            });
	        });
	    };
	
	    SSOWeb.prototype.getLoginUrl = function (redirectUrlObj) {
	        if (!this.isInitial) throw Error('should init first');
	        var rewriteLocation = this.rewriteLocation;
	        if (!redirectUrlObj) {
	            var reqPath = decodeURIComponent(common_util_1.urlObj.getReqPath(location.href, location.origin, rewriteLocation));
	            redirectUrlObj = this.createRedirectUrl("" + rewriteLocation + reqPath);
	        }
	        var loginUrlObj = new URL(this.loginUrl, location.origin);
	        var _a = this.store,
	            verifier = _a.verifier,
	            stateStore = _a.stateStore;
	        var state = store_util_1.generateState();
	        var codeVerifier = crypto_util_1.cryptoGenerateRandom();
	        stateStore.clearState();
	        stateStore.setState(state);
	        verifier.clearCodeVerifier();
	        verifier.setCodeVerifier(codeVerifier);
	        var codeChallengeMethod = verifier.getCodeChallengeMethod();
	        var codeChallenge = verifier.isSha256() ? crypto_util_1.sha256Crypto(codeVerifier) : codeVerifier;
	
	        var redirectUrl = "" + redirectUrlObj.origin + decodeURIComponent(redirectUrlObj.pathname) + redirectUrlObj.search;
	        loginUrlObj.search = "client_id=" + this.clientId + "&redirect_uri=" + encodeURIComponent(redirectUrl) + "&state=" + state + "&code_challenge=" + encodeURIComponent(codeChallenge) + "&code_challenge_method=" + codeChallengeMethod;
	        if (this.isDebug) {
	            console.log("================== ssoweb debug =================");
	            console.log("redirect_uri origin: ", redirectUrlObj.origin);
	            console.log("redirect_uri pathname: ", redirectUrlObj.pathname);
	            console.log("redirect_uri search: ", decodeURIComponent(redirectUrlObj.search));
	            console.log("redirect_uri: ", decodeURIComponent(redirectUrl));
	            console.log("=================================================");
	        }
	        return loginUrlObj.href;
	    };
	
	    SSOWeb.prototype.createRedirectUrl = function (originalUrl) {
	        var redirectUrlObj = new URL(location.origin);
	        var defaultCallbackUrl = const_1.SSO_SPECIAL_ROUTE.callbackUrl;
	        var _a = this,
	            schema = _a.schema,
	            rewriteLocation = _a.rewriteLocation,
	            callbackUrl = _a.callbackUrl;
	        if (schema) redirectUrlObj.protocol = schema;
	        if (!redirectUrlObj.protocol) {
	            console.warn(PROTOCOL_UNDEFINED);
	
	            redirectUrlObj.protocol = 'http:';
	        }
	        redirectUrlObj.pathname = "" + rewriteLocation + (callbackUrl || defaultCallbackUrl);
	        redirectUrlObj.search = "original-url=" + encodeURIComponent(originalUrl);
	        return redirectUrlObj;
	    };
	    SSOWeb.prototype.isLogoutPath = function (reqPath) {
	        var logoutUrl = this.logoutUrl;
	        var defaultLogoutUrl = const_1.SSO_SPECIAL_ROUTE.logoutUrl;
	        return reqPath.startsWith(logoutUrl) || reqPath.startsWith(defaultLogoutUrl);
	    };
	    SSOWeb.prototype.isCallbackPath = function (reqPath) {
	        var callbackUrl = this.callbackUrl;
	        var defaultCallbackUrl = const_1.SSO_SPECIAL_ROUTE.callbackUrl;
	        return reqPath.startsWith(callbackUrl) || reqPath.startsWith(defaultCallbackUrl);
	    };
	    SSOWeb.prototype.getToken = function (code, verifier) {
	        var clientId = this.clientId;
	        return this.client.getToken(code, verifier, clientId);
	    };
	    return SSOWeb;
	}();
	var ssoInstance;
	
	function singletonWrapper(configs) {
	    if (configs.accessEnv === 'ppe') {
	        console.error('sso beta环境即将下线，请切换至test环境，详情参考 https://km.sankuai.com/page/173996827');
	    }
	    if (!ssoInstance) {
	        ssoInstance = new SSOWeb(configs);
	    }
	    return ssoInstance;
	}
	exports.default = singletonWrapper;
	
	exports._dispose = function () {
	    ssoInstance = null;
	};

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var __importStar = undefined && undefined.__importStar || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) {
	        if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
	    }result["default"] = mod;
	    return result;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	
	var State = __importStar(__webpack_require__(244));
	var Token = __importStar(__webpack_require__(245));
	var Verifier = __importStar(__webpack_require__(246));
	var Storage = function () {
	    function Storage(storageArgs) {
	        this.stateStore = new State.StateStorage({
	            clientId: storageArgs.clientId
	        });
	        this.tokenStore = new Token.TokenStorage({
	            clientId: storageArgs.clientId
	        });
	        this.verifier = new Verifier.VerifierStorage({
	            method: storageArgs.method
	        });
	    }
	    return Storage;
	}();
	exports.Storage = Storage;

/***/ }),
/* 244 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var StateStorage = function () {
	    function StateStorage(stateArgs) {
	        this.STATE_POSTFIX_NAME = 'state';
	        this.STATE_NAME = stateArgs.clientId + "_" + this.STATE_POSTFIX_NAME;
	    }
	    StateStorage.prototype.setState = function (state) {
	        sessionStorage.setItem(this.STATE_NAME, state);
	    };
	    StateStorage.prototype.getState = function () {
	        return sessionStorage.getItem(this.STATE_NAME);
	    };
	    StateStorage.prototype.clearState = function () {
	        sessionStorage.removeItem(this.STATE_NAME);
	    };
	    return StateStorage;
	}();
	exports.StateStorage = StateStorage;

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _assign = __webpack_require__(26);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var __importStar = undefined && undefined.__importStar || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) {
	        if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
	    }result["default"] = mod;
	    return result;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	
	var util = __importStar(__webpack_require__(247));
	var DEFAULT_TOKEN_CFG = {
	    name: 'ssoid',
	    path: '/',
	    domain: ''
	};
	var TokenStorage = function () {
	    function TokenStorage(tokenArgs) {
	        this.clientId = tokenArgs.clientId;
	    }
	    TokenStorage.prototype.setToken = function (ssoid, sameSite) {
	        if (!ssoid) return void 0;
	        var options = {
	            value: ssoid,
	            name: this.clientId + "_" + DEFAULT_TOKEN_CFG.name,
	            path: DEFAULT_TOKEN_CFG.path,
	            domain: DEFAULT_TOKEN_CFG.domain,
	            expires: new Date(Date.now() + 1000 * 60 * 60 * 24 * 30).toString()
	        };
	        if (!sameSite && util.getBrowserVersion('chrome') >= 80) {
	            (0, _assign2.default)(options, {
	                SameSite: 'None',
	                Secure: true
	            });
	        }
	        document.cookie = util.parseCookie(options);
	    };
	    TokenStorage.prototype.getToken = function () {
	        var value = "; " + document.cookie;
	        var parts = value.split("; " + this.clientId + "_" + DEFAULT_TOKEN_CFG.name + "=");
	        if (parts.length == 2) return parts.pop().split(';').shift();
	        return '';
	    };
	    TokenStorage.prototype.clearToken = function () {
	        document.cookie = util.parseCookie({
	            value: '',
	            name: this.clientId + "_" + DEFAULT_TOKEN_CFG.name,
	            path: DEFAULT_TOKEN_CFG.path,
	            domain: DEFAULT_TOKEN_CFG.domain,
	            expires: 'expires=Thu, 01 Jan 1970 00:00:01 GMT'
	        });
	    };
	    return TokenStorage;
	}();
	exports.TokenStorage = TokenStorage;

/***/ }),
/* 246 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var VerifierStorage = function () {
	    function VerifierStorage(args) {
	        this.CODE_VERIFIER_NAME = 'code_verifier';
	        this.CODE_CHALLENGE_METHOD = 'SHA256';
	        this.CODE_CHALLENGE_METHOD = args.method || this.CODE_CHALLENGE_METHOD;
	    }
	    VerifierStorage.prototype.setCodeVerifier = function (verifier) {
	        sessionStorage.setItem(this.CODE_VERIFIER_NAME, verifier);
	    };
	    VerifierStorage.prototype.getCodeVerifier = function () {
	        return sessionStorage.getItem(this.CODE_VERIFIER_NAME);
	    };
	    VerifierStorage.prototype.clearCodeVerifier = function () {
	        sessionStorage.removeItem(this.CODE_VERIFIER_NAME);
	    };
	    VerifierStorage.prototype.getCodeChallengeMethod = function () {
	        return this.CODE_CHALLENGE_METHOD;
	    };
	    VerifierStorage.prototype.isSha256 = function () {
	        return !!~this.CODE_CHALLENGE_METHOD.toLowerCase().indexOf('sha256');
	    };
	    return VerifierStorage;
	}();
	exports.VerifierStorage = VerifierStorage;

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	function __export(m) {
	  for (var p in m) {
	    if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	  }
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	
	__export(__webpack_require__(149));
	__export(__webpack_require__(150));
	__export(__webpack_require__(80));
	__export(__webpack_require__(148));

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(100);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _assign = __webpack_require__(26);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _home = __webpack_require__(184);
	
	var _home2 = _interopRequireDefault(_home);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'app',
	    data: function data() {
	        return {};
	    },
	
	    components: {
	        menus: _home2.default
	    },
	    ready: function ready() {},
	    beforeDestroy: function beforeDestroy() {},
	
	    methods: {},
	    created: function created() {
	        var _this = this;
	
	        if (sessionStorage.getItem("store")) {
	            this.$store.replaceState((0, _assign2.default)({}, this.$store.state, JSON.parse(sessionStorage.getItem("store"))));
	        }
	
	        window.addEventListener("beforeunload", function () {
	            sessionStorage.setItem("store", (0, _stringify2.default)(_this.$store.state));
	        });
	    }
	};

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'menus',
	    mounted: function mounted() {},
	    computed: (0, _vuex.mapState)({
	        tokenAPI: function tokenAPI(state) {
	            return state.tokenAPI;
	        },
	        token: function token(state) {
	            return state.token;
	        },
	        getuserAPI: function getuserAPI(state) {
	            return state.getuserAPI;
	        }
	    }),
	    methods: {
	        getCookie: function getCookie(name) {
	            var arr,
	                reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
	            if (arr = document.cookie.match(reg)) return unescape(arr[2]);else return null;
	        },
	        getuser: function getuser(token) {
	            var vm = this;
	            _axios2.default.get(vm.getuserAPI, {
	                withCredentials: true,
	                headers: { 'x-requested-with': 'XMLHttpRequest', 'access-token': token }
	            }).then(function (response) {
	                if (response.data.code !== 0) {
	                    return;
	                }
	                vm.user = response.data.data;
	                if (vm.user != null) {
	                    document.cookie = "username=" + vm.user.login;
	                }
	            }).catch(function (error) {
	                vm.requesterrorinfo(error);
	            });
	        },
	        requesterrorinfo: function requesterrorinfo(error) {
	            var vm = this;
	
	            if (error.response) {
	                var code = error.response.status;
	                if (code == 401) {
	                    vm.$message('您未登录,请刷新');
	                    var count = vm.getCookie("access-count");
	                    if (count == null || count == 0) {
	                        document.cookie = "access-count=1";
	                        document.cookie = vm.cookieName + vm.$route.fullPath;
	                        window.location = vm.loginRediret;
	                    } else {
	                        vm.$message("未登录请刷新页面");
	                    }
	                } else {
	                    if (code == 404) {
	                        vm.$notify({
	                            title: '提示',
	                            message: '404:Not found!',
	                            type: 'error'
	                        });
	                    } else {
	                        vm.$notify({
	                            title: '提示',
	                            message: '501:服务端未响应!',
	                            type: 'error'
	                        });
	                    }
	                }
	            } else {
	                vm.$notify({
	                    title: '提示',
	                    message: '502:服务端未响应!',
	                    type: 'error'
	                });
	            }
	        }
	    },
	    data: function data() {
	        return {
	            user: ""
	        };
	    }
	};

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _store = __webpack_require__(11);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _vuex = __webpack_require__(3);
	
	var _SSOUtil = __webpack_require__(99);
	
	var _ErrorCode = __webpack_require__(276);
	
	var _ErrorCode2 = _interopRequireDefault(_ErrorCode);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    mounted: function mounted() {
	        var vm = this;
	        if (vm.token === "") {
	            var token = vm.getCookie("access-token");
	            if (token != null) {
	                vm.$store.commit('UPDATETOKEN', token);
	                vm.token = token;
	            }
	        }
	        this.$nextTick(function () {
	            vm.getUser();
	        });
	        this.$nextTick(function () {
	            vm.buildMenuList();
	        });
	    },
	    computed: (0, _vuex.mapState)({
	        selectItemList: function selectItemList(state) {
	            return state.selectItemList;
	        },
	        selectDocument: function selectDocument(state) {
	            return state.selectDocument;
	        },
	        activeItem: function activeItem(state) {
	            return state.activeItem;
	        },
	        openItems: function openItems(state) {
	            return state.openItems;
	        },
	        cookieName: function cookieName(state) {
	            return state.cookieName;
	        },
	        token: function token(state) {
	            return state.token;
	        },
	        getDocumentItem: function getDocumentItem(state) {
	            return state.documentItem;
	        },
	        getuserAPI: function getuserAPI(state) {
	            return state.getuserAPI;
	        },
	        logoutRediret: function logoutRediret(state) {
	            return state.logoutRediret;
	        },
	        selectDirItems: function selectDirItems(state) {
	            return state.selectDirItems;
	        },
	        currentLang: function currentLang(state) {
	            return state.currentLang;
	        },
	        currentLangLabel: function currentLangLabel() {
	            var _this = this;
	
	            var lang = this.languages.find(function (l) {
	                return l.value === _this.currentLang;
	            });
	            return lang && lang.label || '';
	        }
	    }),
	    methods: {
	        buildMenuList: function buildMenuList() {
	            var vm = this;
	            if (vm.documentItems) {
	                return;
	            }
	            _axios2.default.get(vm.selectItemList, {
	                withCredentials: true
	            }).then(function (response) {
	                var responseData = response.data;
	                (0, _ErrorCode2.default)(responseData);
	                var itemList = response.data.data;
	                if (!itemList || itemList.length === 0) {
	                    return;
	                }
	                itemList[0].disabled = true;
	                vm.documentItems = itemList;
	            }).catch(function () {
	                vm.documentItems = null;
	            });
	            setTimeout(function () {
	                vm.buildMenuList();
	            }, 100000);
	        },
	        whitelist_apply: function whitelist_apply() {
	            this.$router.push({ path: '/whiteApply' });
	        },
	        usercert_apply: function usercert_apply() {
	            this.$router.push({ path: '/userCertApply' });
	        },
	        handleSelect: function handleSelect(key, keyPath) {
	            this.$router.push({ path: '/templateHtml', query: { index: key } });
	        },
	        getCookie: function getCookie(name) {
	            var arr,
	                reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
	            if (arr = document.cookie.match(reg)) return unescape(arr[2]);else return null;
	        },
	        handleMenuSelect: function handleMenuSelect(command) {
	            if (this.$store.state.is_manager) {
	                this.$router.push({ path: '/' + command });
	            } else {
	                this.$notify({
	                    title: '没有权限',
	                    message: '你没有操作当前菜单的权限',
	                    type: 'error'
	                });
	            }
	        },
	        handleCommand: function handleCommand(command) {
	            if (command === "2-0") {
	                _SSOUtil.sso.logout();
	            }
	        },
	        getUser: function getUser() {
	            var _this2 = this;
	
	            var vm = this;
	            if (vm.user && vm.user !== '') {
	                return;
	            }
	            if (vm.user == null || vm.user === "") {
	                vm.user = vm.getCookie("username");
	                document.cookie = "ssoid=" + vm.getCookie("access-token");
	                _axios2.default.get(vm.getuserAPI, {
	                    withCredentials: true
	                }).then(function (response) {
	                    var responseData = response.data;
	                    (0, _ErrorCode2.default)(responseData);
	                    if (response.data.code !== 0) {
	                        return;
	                    }
	                    var user = response.data.data;
	                    vm.user = user;
	                    vm.userName = user.name;
	                    vm.mis_id = user.login;
	                    vm.is_manager = response.data.isManager;
	                    vm.$store.commit('managerAuthority', vm.is_manager);
	                    var loginName = user.login;
	                    vm.userMis = loginName;
	                    var avatarUrl = response.data.avatarUrl;
	                    if (typeof loginName !== 'undefined') {
	                        _this2.imgUrl = avatarUrl;
	                        _this2.$refs["home_main"].style.display = "block";
	                    }
	                }).catch(function (error) {
	                    vm.requesterrorinfo(error);
	                });
	                setTimeout(function () {
	                    vm.getUser();
	                }, 100000);
	            }
	        },
	        requesterrorinfo: function requesterrorinfo(error) {
	            var vm = this;
	            if (error.response) {
	                var code = error.response.status;
	                if (code == 401) {
	                    window.location = vm.loginRediret;
	                } else {
	                    if (code == 404) {
	                        vm.$notify({
	                            title: '提示',
	                            message: '404:Not found!',
	                            type: 'error'
	                        });
	                    } else {
	                        vm.$notify({
	                            title: '提示',
	                            message: '501:服务端未响应!',
	                            type: 'error'
	                        });
	                    }
	                }
	            } else {
	                vm.$notify({
	                    title: '提示',
	                    message: '502:服务端未响应!',
	                    type: 'error'
	                });
	            }
	        },
	        handleLanguageChange: function handleLanguageChange(lang) {
	            this.$store.commit('UPDATE_LANGUAGE', lang);
	        }
	    },
	    data: function data() {
	        return {
	            user: '',
	            userName: '',
	            mis_id: '',
	            imgUrl: '',
	            documentItems: null,
	            is_manager: false,
	            dropdown_item: {
	                disabled: true,
	                divided: true
	            },
	            languages: [{ value: 'zh', label: '中文' }, { value: 'en', label: 'English' }]
	        };
	    }
	};

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: "addItem",
	    mounted: function mounted() {
	        var vm = this;
	        if (!vm.$store.state.is_manager) {
	            this.$notify({
	                title: '没有权限',
	                message: '你没有操作当前菜单的权限',
	                type: 'error'
	            });
	            return;
	        }
	        if (vm.token == "") {
	            var token = vm.getCookie("access-token");
	            if (token != null) {
	                vm.$store.commit('UPDATETOKEN', token);
	                vm.token = token;
	            }
	        }
	        this.$nextTick(function () {
	            _axios2.default.get(vm.selectItemList, {
	                withCredentials: true
	            }).then(function (response) {
	                if (response.data && response.data.status === 401) {
	                    window.location = vm.loginRediret;
	                    return;
	                }
	                var itemList = response.data.data;
	                if (!itemList || itemList.length === 0) {
	                    return;
	                }
	                vm.$set(vm.form, 'options', itemList);
	            }).catch(function (error) {
	                vm.requesterrorinfo(error);
	            });
	        });
	    },
	    computed: (0, _vuex.mapState)({
	        addItem: function addItem(state) {
	            return state.addItem;
	        },
	        selectItemList: function selectItemList(state) {
	            return state.selectItemList;
	        }
	
	    }),
	    data: function data() {
	        return {
	            form: {
	                title: '',
	                type: '目录',
	                options: new Array(),
	                language: 'zh'
	            },
	            token: '',
	            selectedItemList: []
	        };
	    },
	
	    methods: {
	        getCookie: function getCookie(name) {
	            var arr,
	                reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
	            if (arr = document.cookie.match(reg)) return unescape(arr[2]);else return null;
	        },
	        requesterrorinfo: function requesterrorinfo(error) {
	            var vm = this;
	            if (error.response) {
	                var code = error.response.status;
	                if (code == 401) {
	                    document.cookie = "currentURL=addItem";
	                    window.location = vm.loginRediret;
	                } else {
	                    if (code == 404) {
	                        vm.$notify({
	                            title: '提示',
	                            message: '404:Not found!',
	                            type: 'error'
	                        });
	                    } else {
	                        vm.$notify({
	                            title: '提示',
	                            message: '501:服务端未响应!',
	                            type: 'error'
	                        });
	                    }
	                }
	            } else {
	                vm.$notify({
	                    title: '提示',
	                    message: '502:服务端未响应!',
	                    type: 'error'
	                });
	            }
	        },
	        onSubmit: function onSubmit() {
	            var _this = this;
	
	            var vm = this;
	            var fatherDirId = '0';
	            var index = '';
	            var item = null;
	            if (vm.form.title == null || vm.form.title.trim() == '') {
	                this.$message.error('文档标题不得为空，请输入后重新提交！');
	                return;
	            }
	
	            var length = this.selectedItemList.length;
	            if (length == 0) {
	                var lt = vm.form.options.length;
	                if (lt === 0) {
	                    index = '1';
	                } else {
	                    index = parseInt(vm.form.options[lt - 1].value) + 1 + '';
	                }
	                if (vm.form.type === '文本') {
	                    this.$message.error('根目录只能创建目录项，无法创建文本！');
	                    return;
	                } else {
	                    item = { value: index, label: vm.form.title, fatherIndex: '0', children: [], isDir: 1, language: vm.form.language };
	                }
	                vm.form.options.push(item);
	            } else {
	                var values = this.selectedItemList;
	                fatherDirId = this.selectedItemList[values.length - 1];
	                var strings = fatherDirId.split('-');
	                if (strings.length == 1) {
	                    var children = null;
	                    var options = vm.form.options;
	                    for (var i = 0; i < options.length; i++) {
	                        if (options[i].value == fatherDirId) {
	                            children = options[i].children;
	                            if (children == null) {
	                                this.$message.error('文本下无法创建！');
	                                return;
	                            }
	                            var childrenLength = children.length;
	                            if (childrenLength == 0) {
	                                index = fatherDirId + '-' + 1;
	                            } else {
	                                var lastIndex = parseInt(children[childrenLength - 1].value.split('-')[1]) + 1;
	                                index = fatherDirId + '-' + lastIndex;
	                            }
	                            if (vm.form.type == '文本') {
	                                item = { value: index, label: vm.form.title, fatherIndex: fatherDirId, isDir: 0, language: vm.form.language };
	                            } else {
	                                item = {
	                                    value: index,
	                                    label: vm.form.title,
	                                    fatherIndex: fatherDirId,
	                                    children: [],
	                                    isDir: 1,
	                                    language: vm.form.language
	                                };
	                            }
	                            options[i].children.push(item);
	                        }
	                    }
	                    vm.form.options = options;
	                } else if (strings.length == 2) {
	                    var children = null;
	                    var options = vm.form.options;
	                    for (var i = 0; i < options.length; i++) {
	                        if (options[i].children != null) {
	                            for (var j = 0; j < options[i].children.length; j++) {
	                                if (options[i].children[j].value == fatherDirId) {
	                                    children = options[i].children[j].children;
	                                    if (children == null) {
	                                        this.$message.error('文本下无法创建！');
	                                        return;
	                                    }
	                                    var childrenLength = children.length;
	                                    if (childrenLength == 0) {
	                                        index = fatherDirId + '-' + 1;
	                                    } else {
	                                        var lastIndex = parseInt(children[childrenLength - 1].value.split('-')[2]) + 1;
	                                        index = fatherDirId + '-' + lastIndex;
	                                    }
	                                    if (vm.form.type == '文本') {
	                                        item = {
	                                            value: index,
	                                            label: vm.form.title,
	                                            fatherIndex: fatherDirId,
	                                            isDir: 0,
	                                            language: vm.form.language
	                                        };
	                                    } else {
	                                        item = {
	                                            value: index,
	                                            label: vm.form.title,
	                                            fatherIndex: fatherDirId,
	                                            children: [],
	                                            isDir: 1,
	                                            language: vm.form.language
	                                        };
	                                    }
	                                    options[i].children[j].children.push(item);
	                                }
	                            }
	                        }
	                    }
	                    vm.form.options = options;
	                } else if (strings.length == 3) {
	                    var children = null;
	                    var options = vm.form.options;
	                    for (var i = 0; i < options.length; i++) {
	                        if (options[i].children != null) {
	                            for (var j = 0; j < options[i].children.length; j++) {
	                                if (options[i].children[j].children != null) {
	                                    for (var k = 0; k < options[i].children[j].children.length; k++) {
	                                        if (options[i].children[j].children[k].value == fatherDirId) {
	                                            children = options[i].children[j].children[k].children;
	                                            if (children == null) {
	                                                this.$message.error('文本下无法创建！');
	                                                return;
	                                            }
	                                            var childrenLength = children.length;
	                                            if (childrenLength == 0) {
	                                                index = fatherDirId + '-' + 1;
	                                            } else {
	                                                var lastIndex = parseInt(children[childrenLength - 1].value.split('-')[3]) + 1;
	                                                index = fatherDirId + '-' + lastIndex;
	                                            }
	                                            if (vm.form.type == '文本') {
	                                                item = {
	                                                    value: index,
	                                                    label: vm.form.title,
	                                                    fatherIndex: fatherDirId,
	                                                    isDir: 0,
	                                                    language: vm.form.language
	                                                };
	                                            } else {
	                                                item = {
	                                                    value: index,
	                                                    label: vm.form.title,
	                                                    fatherIndex: fatherDirId,
	                                                    children: [],
	                                                    isDir: 1,
	                                                    language: vm.form.language
	                                                };
	                                            }
	                                            options[i].children[j].children[k].children.push(item);
	                                        }
	                                    }
	                                }
	                            }
	                        }
	                    }
	                    vm.form.options = options;
	                }
	            }
	            if (item.isDir == 1) {
	                _axios2.default.post(vm.addItem, item, {
	                    withCredentials: true
	                }).then(function (response) {
	                    vm.$notify({
	                        title: '提示',
	                        message: '添加目录成功！',
	                        type: 'success'
	                    });
	                    _this.selectedItemList = [];
	                    vm.form.title = '';
	                    vm.form.type = '目录';
	                }).catch(function (error) {
	                    vm.requesterrorinfo(error);
	                });
	            } else {
	                vm.$router.push({ path: '/editorItem', query: { index: index, title: vm.form.title, item: item } });
	            }
	        }
	    }
	};

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(40);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(39);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "addLangIndex",
	  mounted: function mounted() {
	    var vm = this;
	    if (!vm.$store.state.is_manager) {
	      this.$notify({
	        title: '没有权限',
	        message: '你没有操作当前菜单的权限',
	        type: 'error'
	      });
	      return;
	    }
	    if (vm.token == "") {
	      var token = vm.getCookie("access-token");
	      if (token != null) {
	        vm.$store.commit('UPDATETOKEN', token);
	        vm.token = token;
	      }
	    }
	    this.$nextTick(function () {
	      _axios2.default.get(vm.selectItemList, {
	        withCredentials: true
	      }).then(function (response) {
	        if (response.data && response.data.status === 401) {
	          window.location = vm.loginRediret;
	          return;
	        }
	        var itemList = response.data.data;
	        if (!itemList || itemList.length === 0) {
	          return;
	        }
	        vm.$set(vm.form, 'options', itemList);
	      }).catch(function (error) {
	        vm.requesterrorinfo(error);
	      });
	    });
	  },
	  computed: (0, _vuex.mapState)({
	    selectItemList: function selectItemList(state) {
	      return state.selectItemList;
	    },
	    addLangRelation: function addLangRelation(state) {
	      return state.addLangRelation;
	    },
	    checkLangRelation: function checkLangRelation(state) {
	      return state.checkLangRelation;
	    }
	  }),
	  data: function data() {
	    return {
	      form: {
	        options: []
	      },
	      value: '',
	      token: '',
	      basePage: [],
	      relaPage: []
	    };
	  },
	
	  methods: {
	    getCookie: function getCookie(name) {
	      var arr,
	          reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
	      if (arr = document.cookie.match(reg)) return unescape(arr[2]);else return null;
	    },
	    checkSubmit: function () {
	      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        var _this = this;
	
	        var vm, baseLength, relaLength, index, relaIndex;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                vm = this;
	                baseLength = vm.basePage.length;
	                relaLength = vm.relaPage.length;
	
	                if (!(baseLength == 0 || relaLength == 0)) {
	                  _context.next = 8;
	                  break;
	                }
	
	                this.$message.error('请选择要关联的文档!');
	                return _context.abrupt("return");
	
	              case 8:
	                index = vm.basePage[vm.basePage.length - 1];
	                relaIndex = vm.relaPage[vm.relaPage.length - 1];
	                _context.next = 12;
	                return _axios2.default.post(vm.checkLangRelation, { index: index, relaIndex: relaIndex }, {
	                  withCredentials: true
	                }).then(function (response) {
	                  if (response.data.code == 0) {
	                    _this.$confirm('此操作会覆盖已有映射关系，是否继续?', '提示', {
	                      confirmButtonText: '确定',
	                      cancelButtonText: '取消',
	                      type: 'warning'
	                    }).then(function () {
	                      _this.onSubmit();
	                    }).catch(function () {
	                      _this.$message({
	                        type: 'info',
	                        message: '已取消删除'
	                      });
	                    });
	                  } else if (response.data.code == 1) {
	                    _this.onSubmit();
	                  } else {
	                    _this.$message.error(response.data.message);
	                  }
	                }).catch(function (error) {
	                  this.requesterrorinfo(error);
	                });
	
	              case 12:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function checkSubmit() {
	        return _ref.apply(this, arguments);
	      }
	
	      return checkSubmit;
	    }(),
	    onSubmit: function () {
	      var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        var _this2 = this;
	
	        var vm, baseLength, relaLength, index, relaIndex;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                vm = this;
	                baseLength = vm.basePage.length;
	                relaLength = vm.relaPage.length;
	
	                if (!(baseLength == 0 || relaLength == 0)) {
	                  _context2.next = 8;
	                  break;
	                }
	
	                this.$message.error('请选择要关联的文档!');
	                return _context2.abrupt("return");
	
	              case 8:
	                index = vm.basePage[vm.basePage.length - 1];
	                relaIndex = vm.relaPage[vm.relaPage.length - 1];
	                _context2.next = 12;
	                return _axios2.default.post(vm.addLangRelation, { index: index, relaIndex: relaIndex }, {
	                  withCredentials: true
	                }).then(function (response) {
	                  if (response.data.code == 0) {
	                    _this2.$message.success('映射信息更新成功');
	                    return;
	                  } else {
	                    _this2.$message.error(response.data.message);
	                    return;
	                  }
	                }).catch(function (error) {
	                  this.requesterrorinfo(error);
	                });
	
	              case 12:
	              case "end":
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function onSubmit() {
	        return _ref2.apply(this, arguments);
	      }
	
	      return onSubmit;
	    }()
	  }
	};

/***/ }),
/* 253 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: "ai",
	  mounted: function mounted() {
	    var _this = this;
	
	    window.location.href = 'moaaiapp://safeAccessFromBrowser';
	    setTimeout(function () {
	      var toIndex = _this.$route.query.toIndex || '2-1';
	      _this.$router.push({ path: '/templateHtml', query: { index: toIndex } });
	    }, 2000);
	  }
	};

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(11);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _vuex = __webpack_require__(3);
	
	var _commonUtil = __webpack_require__(18);
	
	var _commonUtil2 = _interopRequireDefault(_commonUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  store: _store2.default,
	  mounted: function mounted() {
	    var vm = this;
	    if (vm.token == "") {
	      var token = this.getCookie("access-token");
	      if (token != null) {
	        vm.$store.commit('UPDATETOKEN', token);
	        vm.token = token;
	      }
	    }
	    vm.getUser();
	  },
	  computed: (0, _vuex.mapState)({
	    loginRediret: function loginRediret(state) {
	      return state.loginRediret;
	    },
	    cookieName: function cookieName(state) {
	      return state.cookieName;
	    },
	    getuserAPI: function getuserAPI(state) {
	      return state.getuserAPI;
	    }
	  }),
	  filters: {
	    idcExplain: function idcExplain(val) {
	      return _commonUtil2.default.idcExplain(val);
	    },
	    timeFormat: function timeFormat(val) {
	      return _commonUtil2.default.timeFormat(val);
	    },
	    switchColor: function switchColor(val) {
	      return _commonUtil2.default.switchColor(val);
	    },
	    statusExplain: function statusExplain(val) {
	      return _commonUtil2.default.statusExplain(val);
	    }
	  },
	  methods: {
	    reset: function reset() {
	      var vm = this;
	      vm.name = '';
	      vm.rasp = '';
	      vm.proc = '';
	      vm.ws = '';
	      vm.query_arg = 'hostname';
	      vm.query_value = '';
	    },
	    masterStatusColor: function masterStatusColor(status) {
	      if (status == 1) {
	        return "#A1D6E4";
	      }
	      if (status == 0) {
	        return "#878D99";
	      }
	      if (status == 4) {
	        return "#878D99";
	      }
	      if (status == 6) {
	        return "#F5A9A9";
	      }
	      if (status == 5) {
	        return "#FFC78E";
	      }
	    },
	    kmUrl: function kmUrl(URL) {
	      window.open(URL);
	    },
	    routerUrl: function routerUrl(URL) {
	      this.$router.push(URL);
	    },
	    handleSelectionChange: function handleSelectionChange(val) {
	      this.multipleSelection = val;
	    },
	    getCookie: function getCookie(name) {
	      var arr,
	          reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
	      if (arr = document.cookie.match(reg)) return unescape(arr[2]);else return null;
	    },
	    getUser: function getUser() {
	      var vm = this;
	      if (vm.user == null || vm.user == "") {
	        vm.user = vm.getCookie("username");
	        document.cookie = "ssoid=" + vm.getCookie("access-token");
	        _axios2.default.get(vm.getuserAPI, {
	          withCredentials: true
	        }).then(function (response) {
	          if (response.data.status == 401) {
	            document.cookie = vm.cookieName + vm.$route.fullPath;
	            window.location = vm.loginRediret;
	          }
	        }).catch(function (error) {
	          vm.requesterrorinfo(error);
	        });
	      }
	    },
	    requesterrorinfo: function requesterrorinfo(error) {
	      var vm = this;
	      if (error.response) {
	        var code = error.response.status;
	        if (code == 401) {
	          vm.$message.error("401:您未登录");
	          var count = vm.getCookie("access-count");
	          window.location = vm.loginRediret;
	          if (count == null || count == 0) {
	            document.cookie = "access-count=1";
	            vm.$message('您未登录,请刷新');
	            document.cookie = vm.cookieName + vm.$route.fullPath;
	            window.location = vm.loginRediret;
	          } else {
	            vm.$message('您未登录,请刷新');
	          }
	        } else {
	          if (code == 404) {
	            vm.$notify({
	              title: '提示',
	              message: '404:Not found!',
	              type: 'error'
	            });
	          } else {
	            vm.$notify({
	              title: '提示',
	              message: '501:服务端未响应!',
	              type: 'error'
	            });
	          }
	        }
	      } else {
	        vm.$notify({
	          title: '提示',
	          message: '502:服务端未响应!',
	          type: 'error'
	
	        });
	      }
	    }
	  },
	  data: function data() {
	    return {
	      hostname: '',
	      token: ''
	    };
	  }
	};

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(11);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _vuex = __webpack_require__(3);
	
	var _commonUtil = __webpack_require__(18);
	
	var _commonUtil2 = _interopRequireDefault(_commonUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  store: _store2.default,
	  mounted: function mounted() {
	    var vm = this;
	    if (vm.token == "") {
	      var token = this.getCookie("access-token");
	      if (token != null) {
	        vm.$store.commit('UPDATETOKEN', token);
	        vm.token = token;
	      }
	    }
	    vm.getUser();
	  },
	  computed: (0, _vuex.mapState)({
	    loginRediret: function loginRediret(state) {
	      return state.loginRediret;
	    },
	    cookieName: function cookieName(state) {
	      return state.cookieName;
	    },
	    getuserAPI: function getuserAPI(state) {
	      return state.getuserAPI;
	    }
	  }),
	  filters: {
	    idcExplain: function idcExplain(val) {
	      return _commonUtil2.default.idcExplain(val);
	    },
	    timeFormat: function timeFormat(val) {
	      return _commonUtil2.default.timeFormat(val);
	    },
	    switchColor: function switchColor(val) {
	      return _commonUtil2.default.switchColor(val);
	    },
	    statusExplain: function statusExplain(val) {
	      return _commonUtil2.default.statusExplain(val);
	    }
	  },
	  methods: {
	    reset: function reset() {
	      var vm = this;
	      vm.name = '';
	      vm.rasp = '';
	      vm.proc = '';
	      vm.ws = '';
	      vm.query_arg = 'hostname';
	      vm.query_value = '';
	    },
	    masterStatusColor: function masterStatusColor(status) {
	      if (status == 1) {
	        return "#A1D6E4";
	      }
	      if (status == 0) {
	        return "#878D99";
	      }
	      if (status == 4) {
	        return "#878D99";
	      }
	      if (status == 6) {
	        return "#F5A9A9";
	      }
	      if (status == 5) {
	        return "#FFC78E";
	      }
	    },
	    kmUrl: function kmUrl(URL) {
	      window.open(URL);
	    },
	    handleSelectionChange: function handleSelectionChange(val) {
	      this.multipleSelection = val;
	    },
	    getCookie: function getCookie(name) {
	      var arr,
	          reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
	      if (arr = document.cookie.match(reg)) return unescape(arr[2]);else return null;
	    },
	    getUser: function getUser() {
	      var vm = this;
	      if (vm.user == null || vm.user == "") {
	        vm.user = vm.getCookie("username");
	        document.cookie = "ssoid=" + vm.getCookie("access-token");
	        _axios2.default.get(vm.getuserAPI, {
	          withCredentials: true
	        }).then(function (response) {
	          if (response.data.status == 401) {
	            document.cookie = vm.cookieName + vm.$route.fullPath;
	            window.location = vm.loginRediret;
	          }
	        }).catch(function (error) {
	          vm.requesterrorinfo(error);
	        });
	      }
	    },
	    requesterrorinfo: function requesterrorinfo(error) {
	      var vm = this;
	      if (error.response) {
	        var code = error.response.status;
	        if (code == 401) {
	          vm.$message.error("401:您未登录");
	          var count = vm.getCookie("access-count");
	          window.location = vm.loginRediret;
	          if (count == null || count == 0) {
	            document.cookie = "access-count=1";
	            vm.$message('您未登录,请刷新');
	            document.cookie = vm.cookieName + vm.$route.fullPath;
	            window.location = vm.loginRediret;
	          } else {
	            vm.$message('您未登录,请刷新');
	          }
	        } else {
	          if (code == 404) {
	            vm.$notify({
	              title: '提示',
	              message: '404:Not found!',
	              type: 'error'
	            });
	          } else {
	            vm.$notify({
	              title: '提示',
	              message: '501:服务端未响应!',
	              type: 'error'
	            });
	          }
	        }
	      } else {
	        vm.$notify({
	          title: '提示',
	          message: '502:服务端未响应!',
	          type: 'error'
	
	        });
	      }
	    }
	  },
	  data: function data() {
	    return {
	      hostname: '',
	      token: ''
	    };
	  }
	};

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(11);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _vuex = __webpack_require__(3);
	
	var _commonUtil = __webpack_require__(18);
	
	var _commonUtil2 = _interopRequireDefault(_commonUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  store: _store2.default,
	  mounted: function mounted() {
	    var vm = this;
	    if (vm.token == "") {
	      var token = this.getCookie("access-token");
	      if (token != null) {
	        vm.$store.commit('UPDATETOKEN', token);
	        vm.token = token;
	      }
	    }
	    vm.getUser();
	  },
	  computed: (0, _vuex.mapState)({
	    loginRediret: function loginRediret(state) {
	      return state.loginRediret;
	    },
	    cookieName: function cookieName(state) {
	      return state.cookieName;
	    },
	    getuserAPI: function getuserAPI(state) {
	      return state.getuserAPI;
	    }
	  }),
	  filters: {
	    idcExplain: function idcExplain(val) {
	      return _commonUtil2.default.idcExplain(val);
	    },
	    timeFormat: function timeFormat(val) {
	      return _commonUtil2.default.timeFormat(val);
	    },
	    switchColor: function switchColor(val) {
	      return _commonUtil2.default.switchColor(val);
	    },
	    statusExplain: function statusExplain(val) {
	      return _commonUtil2.default.statusExplain(val);
	    }
	  },
	  methods: {
	    reset: function reset() {
	      var vm = this;
	      vm.name = '';
	      vm.rasp = '';
	      vm.proc = '';
	      vm.ws = '';
	      vm.query_arg = 'hostname';
	      vm.query_value = '';
	    },
	    masterStatusColor: function masterStatusColor(status) {
	      if (status == 1) {
	        return "#A1D6E4";
	      }
	      if (status == 0) {
	        return "#878D99";
	      }
	      if (status == 4) {
	        return "#878D99";
	      }
	      if (status == 6) {
	        return "#F5A9A9";
	      }
	      if (status == 5) {
	        return "#FFC78E";
	      }
	    },
	    kmUrl: function kmUrl(URL) {
	      window.open(URL);
	    },
	    handleSelectionChange: function handleSelectionChange(val) {
	      this.multipleSelection = val;
	    },
	    getCookie: function getCookie(name) {
	      var arr,
	          reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
	      if (arr = document.cookie.match(reg)) return unescape(arr[2]);else return null;
	    },
	    getUser: function getUser() {
	      var vm = this;
	      if (vm.user == null || vm.user == "") {
	        vm.user = vm.getCookie("username");
	        document.cookie = "ssoid=" + vm.getCookie("access-token");
	        _axios2.default.get(vm.getuserAPI, {
	          withCredentials: true
	        }).then(function (response) {
	          if (response.data.status == 401) {
	            document.cookie = vm.cookieName + vm.$route.fullPath;
	            window.location = vm.loginRediret;
	          }
	        }).catch(function (error) {
	          vm.requesterrorinfo(error);
	        });
	      }
	    },
	    requesterrorinfo: function requesterrorinfo(error) {
	      var vm = this;
	      if (error.response) {
	        var code = error.response.status;
	        if (code == 401) {
	          vm.$message.error("401:您未登录");
	          var count = vm.getCookie("access-count");
	          window.location = vm.loginRediret;
	          if (count == null || count == 0) {
	            document.cookie = "access-count=1";
	            vm.$message('您未登录,请刷新');
	            document.cookie = vm.cookieName + vm.$route.fullPath;
	            window.location = vm.loginRediret;
	          } else {
	            vm.$message('您未登录,请刷新');
	          }
	        } else {
	          if (code == 404) {
	            vm.$notify({
	              title: '提示',
	              message: '404:Not found!',
	              type: 'error'
	            });
	          } else {
	            vm.$notify({
	              title: '提示',
	              message: '501:服务端未响应!',
	              type: 'error'
	            });
	          }
	        }
	      } else {
	        vm.$notify({
	          title: '提示',
	          message: '502:服务端未响应!',
	          type: 'error'
	
	        });
	      }
	    }
	  },
	  data: function data() {
	    return {
	      hostname: '',
	      token: ''
	    };
	  }
	};

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(44);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: "deleteItem",
	    mounted: function mounted() {
	        var vm = this;
	        if (!vm.$store.state.is_manager) {
	            this.$notify({
	                title: '没有权限',
	                message: '你没有操作当前菜单的权限',
	                type: 'error'
	            });
	            return;
	        }
	        if (vm.token == "") {
	            var token = vm.getCookie("access-token");
	            if (token != null) {
	                vm.$store.commit('UPDATETOKEN', token);
	                vm.token = token;
	            }
	        }
	        this.$nextTick(function () {
	            _axios2.default.get(vm.selectItemList, {
	                withCredentials: true
	            }).then(function (response) {
	                if (response.data && response.data.status === 401) {
	                    window.location = vm.loginRediret;
	                    return;
	                }
	                var itemList = response.data.data;
	                if (!itemList || itemList.length === 0) {
	                    return;
	                }
	                vm.$set(vm.form, 'options', itemList);
	            }).catch(function (error) {
	                vm.requesterrorinfo(error);
	            });
	        });
	    },
	    computed: (0, _vuex.mapState)({
	        deleteDocument: function deleteDocument(state) {
	            return state.deleteDocument;
	        },
	        selectItemList: function selectItemList(state) {
	            return state.selectItemList;
	        }
	    }),
	    data: function data() {
	        return {
	            form: {
	                options: []
	            },
	            value: '',
	            token: '',
	            selectedItemList: []
	        };
	    },
	
	    methods: (0, _defineProperty3.default)({
	        getCookie: function getCookie(name) {
	            var arr,
	                reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
	            if (arr = document.cookie.match(reg)) return unescape(arr[2]);else return null;
	        },
	        open: function open() {
	            var _this = this;
	
	            this.$confirm('此操作将永久删除该项, 是否继续?', '提示', {
	                confirmButtonText: '确定',
	                cancelButtonText: '取消',
	                type: 'warning'
	            }).then(function () {
	                _this.onSubmit();
	            }).catch(function () {
	                _this.$message({
	                    type: 'info',
	                    message: '已取消删除'
	                });
	            });
	        },
	        onSubmit: function onSubmit() {
	            var _this2 = this;
	
	            var vm = this;
	            var length = vm.selectedItemList.length;
	            if (length == 0) {
	                this.$message.error('请选择要删除的文档或目录!');
	                return;
	            } else {
	                var values = vm.selectedItemList;
	                var itemIndex = values[values.length - 1];
	                _axios2.default.post(vm.deleteDocument, { documentIndex: itemIndex }, {
	                    withCredentials: true
	                }).then(function (response) {
	                    if (response.data.code == 4) {
	                        _this2.$message.error('要删除的文档不可包含子项!');
	                        return;
	                    } else if (response.data.code == 2) {
	                        vm.deleteItem(itemIndex);
	                        vm.selectedItemList = [];
	                        _this2.$message.success('删除成功!');
	                        return;
	                    } else {
	                        _this2.$message.error('删除失败!');
	                        return;
	                    }
	                }).catch(function (error) {
	                    this.requesterrorinfo(error);
	                });
	            }
	        },
	        deleteItem: function deleteItem(itemIndex) {
	            var vm = this;
	            var strings = itemIndex.split('-');
	            if (strings.length == 1) {
	                var options = vm.form.options;
	                for (var i = 0; i < options.length; i++) {
	                    if (options[i].value == itemIndex) {
	                        vm.form.options.splice(i, 1);
	                    }
	                }
	            } else if (strings.length == 2) {
	                var options = vm.form.options;
	                for (var i = 0; i < options.length; i++) {
	                    if (options[i].children != null) {
	                        for (var j = 0; j < options[i].children.length; j++) {
	                            if (options[i].children[j].value == itemIndex) {
	                                vm.form.options[i].children.splice(j, 1);
	                            }
	                        }
	                    }
	                }
	            } else if (strings.length == 3) {
	                var options = vm.form.options;
	                for (var i = 0; i < options.length; i++) {
	                    if (options[i].children != null) {
	                        for (var j = 0; j < options[i].children.length; j++) {
	                            if (options[i].children[j].children != null) {
	                                for (var k = 0; k < options[i].children[j].children.length; k++) {
	                                    if (options[i].children[j].children[k].value == itemIndex) {
	                                        vm.form.options[i].children[j].children.splice(k, 1);
	                                    }
	                                }
	                            }
	                        }
	                    }
	                }
	            } else if (strings.length == 4) {
	                var options = vm.form.options;
	                for (var i = 0; i < options.length; i++) {
	                    if (options[i].children != null) {
	                        for (var j = 0; j < options[i].children.length; j++) {
	                            if (options[i].children[j].children != null) {
	                                for (var k = 0; k < options[i].children[j].children.length; k++) {
	                                    if (options[i].children[j].children[k] != null) {
	                                        for (var l = 0; l < options[i].children[j].children[k].children.length; l++) {
	                                            if (options[i].children[j].children[k].children[l].value == itemIndex) {
	                                                vm.form.options[i].children[j].children[k].children.splice(l, 1);
	                                            }
	                                        }
	                                    }
	                                }
	                            }
	                        }
	                    }
	                }
	            }
	        },
	        requesterrorinfo: function requesterrorinfo(error) {
	            var vm = this;
	            if (error.response) {
	                var code = error.response.status;
	                if (code == 401) {
	                    document.cookie = "currentURL=deleteItem";
	                    window.location = vm.loginRediret;
	                } else {
	                    if (code == 404) {
	                        vm.$notify({
	                            title: '提示',
	                            message: '404:Not found!',
	                            type: 'error'
	                        });
	                    } else {
	                        vm.$notify({
	                            title: '提示',
	                            message: '501:服务端未响应!',
	                            type: 'error'
	                        });
	                    }
	                }
	            } else {
	                vm.$notify({
	                    title: '提示',
	                    message: '502:服务端未响应!',
	                    type: 'error'
	                });
	            }
	        }
	    }, "getCookie", function getCookie(name) {
	        var arr,
	            reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
	        if (arr = document.cookie.match(reg)) return unescape(arr[2]);else return null;
	    })
	};

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(40);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(39);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _citadelEditor = __webpack_require__(143);
	
	var _toolbar = __webpack_require__(144);
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: "editorItem",
	    mounted: function mounted() {
	        window.addEventListener('scroll', this.handleScroll);
	        var vm = this;
	        if (!vm.$store.state.is_manager) {
	            this.$notify({
	                title: '没有权限',
	                message: '你没有操作当前菜单的权限',
	                type: 'error'
	            });
	            return;
	        }
	        if (vm.token === "") {
	            var token = this.getCookie("access-token");
	            if (token != null) {
	                vm.$store.commit('UPDATETOKEN', token);
	                vm.token = token;
	            }
	        }
	        vm.currentIndex = vm.$route.query.index;
	        vm.currentTitle = vm.$route.query.title;
	        vm.item = vm.$route.query.item;
	        var $editor = document.querySelector("#editor");
	        var $toolbarWrapper = document.querySelector("#toolbar");
	        var editor = new _citadelEditor.Editor($editor, {
	            defaultValue: '<h1>在此编辑内容</h1><p></p><p></p><p></p><p></p><p></p><p></p>'
	        });
	        (0, _toolbar.buildToolbar)({
	            $toolbarWrapper: $toolbarWrapper,
	            getEditorCore: function getEditorCore() {
	                return editor;
	            }
	        });
	        vm.editor = editor;
	        vm.buildScrollData();
	    },
	    computed: (0, _vuex.mapState)({
	        loginRediret: function loginRediret(state) {
	            return state.loginRediret;
	        },
	        addItem: function addItem(state) {
	            return state.addItem;
	        },
	        addDocument: function addDocument(state) {
	            return state.addDocument;
	        },
	        selectDocument: function selectDocument(state) {
	            return state.selectDocument;
	        },
	        selectItemList: function selectItemList(state) {
	            return state.selectItemList;
	        },
	        getuserAPI: function getuserAPI(state) {
	            return state.getuserAPI;
	        },
	        cookieName: function cookieName(state) {
	            return state.cookieName;
	        }
	    }),
	    methods: {
	        buildScrollData: function buildScrollData() {
	            var vm = this;
	
	            this.$nextTick(function () {
	                var header = document.getElementById("toolbar");
	
	                vm.scroll.offsetTop = header.offsetTop;
	                vm.scroll.offsetHeight = header.offsetHeight;
	            });
	        },
	        handleScroll: function handleScroll() {
	            var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
	
	            this.scroll.headerFixed = scrollTop > this.scroll.offsetTop - this.scroll.offsetHeight;
	        },
	        getCookie: function getCookie(name) {
	            var arr,
	                reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
	            if (arr = document.cookie.match(reg)) return unescape(arr[2]);else return null;
	        },
	        addContent: function () {
	            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	                var vm, title, htmlInfo, document;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                vm = this;
	                                title = vm.currentTitle;
	                                htmlInfo = vm.editor.value();
	                                document = { documentIndex: vm.currentIndex, documentTitle: title, documentContent: htmlInfo };
	                                _context.next = 6;
	                                return _axios2.default.post(vm.addItem, vm.item, {
	                                    withCredentials: true
	                                }).then(function (response) {}).catch(function (error) {
	                                    vm.requesterrorinfo(error);
	                                });
	
	                            case 6:
	                                if (!(vm.item.isDir == 0)) {
	                                    _context.next = 9;
	                                    break;
	                                }
	
	                                _context.next = 9;
	                                return _axios2.default.post(vm.addDocument, document, {
	                                    withCredentials: true
	                                }).then(function (response) {
	                                    if (response.data.code == 2) {
	                                        vm.$notify({
	                                            title: '提示',
	                                            message: '添加文档成功！',
	                                            type: 'success'
	                                        });
	                                    }
	                                }).catch(function (error) {
	                                    vm.requesterrorinfo(error);
	                                });
	
	                            case 9:
	                                this.$router.push({ path: '/templateHtml', query: { index: vm.currentIndex } });
	
	                            case 10:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function addContent() {
	                return _ref.apply(this, arguments);
	            }
	
	            return addContent;
	        }()
	    },
	    data: function data() {
	        return {
	            token: '',
	            currentIndex: '',
	            currentTitle: '',
	            item: {},
	            editor: null,
	            scroll: {
	                offsetTop: 0,
	                offsetHeight: 0,
	                headerFixed: false
	            }
	        };
	    }
	};

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(11);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _vuex = __webpack_require__(3);
	
	var _commonUtil = __webpack_require__(18);
	
	var _commonUtil2 = _interopRequireDefault(_commonUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  store: _store2.default,
	  mounted: function mounted() {
	    var vm = this;
	    if (vm.token == "") {
	      var token = this.getCookie("access-token");
	      if (token != null) {
	        vm.$store.commit('UPDATETOKEN', token);
	        vm.token = token;
	      }
	    }
	    vm.getUser();
	  },
	  computed: (0, _vuex.mapState)({
	    loginRediret: function loginRediret(state) {
	      return state.loginRediret;
	    },
	    cookieName: function cookieName(state) {
	      return state.cookieName;
	    },
	    getuserAPI: function getuserAPI(state) {
	      return state.getuserAPI;
	    }
	  }),
	  filters: {
	    idcExplain: function idcExplain(val) {
	      return _commonUtil2.default.idcExplain(val);
	    },
	    timeFormat: function timeFormat(val) {
	      return _commonUtil2.default.timeFormat(val);
	    },
	    switchColor: function switchColor(val) {
	      return _commonUtil2.default.switchColor(val);
	    },
	    statusExplain: function statusExplain(val) {
	      return _commonUtil2.default.statusExplain(val);
	    }
	  },
	  methods: {
	    reset: function reset() {},
	    kmUrl: function kmUrl(URL) {
	      window.open(URL);
	    },
	    routerUrl: function routerUrl(URL) {
	      this.$router.push(URL);
	    },
	    handleSelectionChange: function handleSelectionChange(val) {
	      this.multipleSelection = val;
	    },
	    getCookie: function getCookie(name) {
	      var arr,
	          reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
	      if (arr = document.cookie.match(reg)) return unescape(arr[2]);else return null;
	    },
	    getUser: function getUser() {
	      var vm = this;
	      if (vm.user == null || vm.user == "") {
	        vm.user = vm.getCookie("username");
	        document.cookie = "ssoid=" + vm.getCookie("access-token");
	        _axios2.default.get(vm.getuserAPI, {
	          withCredentials: true
	        }).then(function (response) {
	          if (response.data.status == 401) {
	            document.cookie = vm.cookieName + vm.$route.fullPath;
	            window.location = vm.loginRediret;
	          }
	        }).catch(function (error) {
	          vm.requesterrorinfo(error);
	        });
	      }
	    },
	    requesterrorinfo: function requesterrorinfo(error) {
	      var vm = this;
	      if (error.response) {
	        var code = error.response.status;
	        if (code == 401) {
	          vm.$message.error("401:您未登录");
	          var count = vm.getCookie("access-count");
	          window.location = vm.loginRediret;
	          if (count == null || count == 0) {
	            document.cookie = "access-count=1";
	            vm.$message('您未登录,请刷新');
	            document.cookie = vm.cookieName + vm.$route.fullPath;
	            window.location = vm.loginRediret;
	          } else {
	            vm.$message('您未登录,请刷新');
	          }
	        } else {
	          if (code == 404) {
	            vm.$notify({
	              title: '提示',
	              message: '404:Not found!',
	              type: 'error'
	            });
	          } else {
	            vm.$notify({
	              title: '提示',
	              message: '501:服务端未响应!',
	              type: 'error'
	            });
	          }
	        }
	      } else {
	        vm.$notify({
	          title: '提示',
	          message: '502:服务端未响应!',
	          type: 'error'
	
	        });
	      }
	    }
	  },
	  data: function data() {
	    return {
	      hostname: '',
	      token: ''
	    };
	  }
	};

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(11);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _vuex = __webpack_require__(3);
	
	var _commonUtil = __webpack_require__(18);
	
	var _commonUtil2 = _interopRequireDefault(_commonUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  store: _store2.default,
	  mounted: function mounted() {
	    var vm = this;
	    if (vm.token == "") {
	      var token = this.getCookie("access-token");
	      if (token != null) {
	        vm.$store.commit('UPDATETOKEN', token);
	        vm.token = token;
	      }
	    }
	    vm.getUser();
	  },
	  computed: (0, _vuex.mapState)({
	    loginRediret: function loginRediret(state) {
	      return state.loginRediret;
	    },
	    cookieName: function cookieName(state) {
	      return state.cookieName;
	    },
	    getuserAPI: function getuserAPI(state) {
	      return state.getuserAPI;
	    }
	  }),
	  filters: {
	    idcExplain: function idcExplain(val) {
	      return _commonUtil2.default.idcExplain(val);
	    },
	    timeFormat: function timeFormat(val) {
	      return _commonUtil2.default.timeFormat(val);
	    },
	    switchColor: function switchColor(val) {
	      return _commonUtil2.default.switchColor(val);
	    },
	    statusExplain: function statusExplain(val) {
	      return _commonUtil2.default.statusExplain(val);
	    }
	  },
	  methods: {
	    reset: function reset() {},
	    kmUrl: function kmUrl(URL) {
	      window.open(URL);
	    },
	    handleSelectionChange: function handleSelectionChange(val) {
	      this.multipleSelection = val;
	    },
	    getCookie: function getCookie(name) {
	      var arr,
	          reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
	      if (arr = document.cookie.match(reg)) return unescape(arr[2]);else return null;
	    },
	    getUser: function getUser() {
	      var vm = this;
	      if (vm.user == null || vm.user == "") {
	        vm.user = vm.getCookie("username");
	        document.cookie = "ssoid=" + vm.getCookie("access-token");
	        _axios2.default.get(vm.getuserAPI, {
	          withCredentials: true
	        }).then(function (response) {
	          if (response.data.status == 401) {
	            document.cookie = vm.cookieName + vm.$route.fullPath;
	            window.location = vm.loginRediret;
	          }
	        }).catch(function (error) {
	          vm.requesterrorinfo(error);
	        });
	      }
	    },
	    requesterrorinfo: function requesterrorinfo(error) {
	      var vm = this;
	      if (error.response) {
	        var code = error.response.status;
	        if (code == 401) {
	          vm.$message.error("401:您未登录");
	          var count = vm.getCookie("access-count");
	          window.location = vm.loginRediret;
	          if (count == null || count == 0) {
	            document.cookie = "access-count=1";
	            vm.$message('您未登录,请刷新');
	            document.cookie = vm.cookieName + vm.$route.fullPath;
	            window.location = vm.loginRediret;
	          } else {
	            vm.$message('您未登录,请刷新');
	          }
	        } else {
	          if (code == 404) {
	            vm.$notify({
	              title: '提示',
	              message: '404:Not found!',
	              type: 'error'
	            });
	          } else {
	            vm.$notify({
	              title: '提示',
	              message: '501:服务端未响应!',
	              type: 'error'
	            });
	          }
	        }
	      } else {
	        vm.$notify({
	          title: '提示',
	          message: '502:服务端未响应!',
	          type: 'error'
	
	        });
	      }
	    }
	  },
	  data: function data() {
	    return {
	      hostname: '',
	      token: ''
	    };
	  }
	};

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(11);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _vuex = __webpack_require__(3);
	
	var _commonUtil = __webpack_require__(18);
	
	var _commonUtil2 = _interopRequireDefault(_commonUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  store: _store2.default,
	  mounted: function mounted() {
	    var vm = this;
	    if (vm.token == "") {
	      var token = this.getCookie("access-token");
	      if (token != null) {
	        vm.$store.commit('UPDATETOKEN', token);
	        vm.token = token;
	      }
	    }
	    vm.getUser();
	  },
	  computed: (0, _vuex.mapState)({
	    loginRediret: function loginRediret(state) {
	      return state.loginRediret;
	    },
	    cookieName: function cookieName(state) {
	      return state.cookieName;
	    },
	    getuserAPI: function getuserAPI(state) {
	      return state.getuserAPI;
	    }
	  }),
	  filters: {
	    idcExplain: function idcExplain(val) {
	      return _commonUtil2.default.idcExplain(val);
	    },
	    timeFormat: function timeFormat(val) {
	      return _commonUtil2.default.timeFormat(val);
	    },
	    switchColor: function switchColor(val) {
	      return _commonUtil2.default.switchColor(val);
	    },
	    statusExplain: function statusExplain(val) {
	      return _commonUtil2.default.statusExplain(val);
	    }
	  },
	  methods: {
	    reset: function reset() {},
	    kmUrl: function kmUrl(URL) {
	      window.open(URL);
	    },
	    handleSelectionChange: function handleSelectionChange(val) {
	      this.multipleSelection = val;
	    },
	    getCookie: function getCookie(name) {
	      var arr,
	          reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
	      if (arr = document.cookie.match(reg)) return unescape(arr[2]);else return null;
	    },
	    getUser: function getUser() {
	      var vm = this;
	      if (vm.user == null || vm.user == "") {
	        vm.user = vm.getCookie("username");
	        document.cookie = "ssoid=" + vm.getCookie("access-token");
	        _axios2.default.get(vm.getuserAPI, {
	          withCredentials: true
	        }).then(function (response) {
	          if (response.data.status == 401) {
	            document.cookie = vm.cookieName + vm.$route.fullPath;
	            window.location = vm.loginRediret;
	          }
	        }).catch(function (error) {
	          vm.requesterrorinfo(error);
	        });
	      }
	    },
	    requesterrorinfo: function requesterrorinfo(error) {
	      var vm = this;
	      if (error.response) {
	        var code = error.response.status;
	        if (code == 401) {
	          vm.$message.error("401:您未登录");
	          var count = vm.getCookie("access-count");
	          window.location = vm.loginRediret;
	          if (count == null || count == 0) {
	            document.cookie = "access-count=1";
	            vm.$message('您未登录,请刷新');
	            document.cookie = vm.cookieName + vm.$route.fullPath;
	            window.location = vm.loginRediret;
	          } else {
	            vm.$message('您未登录,请刷新');
	          }
	        } else {
	          if (code == 404) {
	            vm.$notify({
	              title: '提示',
	              message: '404:Not found!',
	              type: 'error'
	            });
	          } else {
	            vm.$notify({
	              title: '提示',
	              message: '501:服务端未响应!',
	              type: 'error'
	            });
	          }
	        }
	      } else {
	        vm.$notify({
	          title: '提示',
	          message: '502:服务端未响应!',
	          type: 'error'
	
	        });
	      }
	    }
	  },
	  data: function data() {
	    return {
	      hostname: '',
	      token: ''
	    };
	  }
	};

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(11);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _vuex = __webpack_require__(3);
	
	var _commonUtil = __webpack_require__(18);
	
	var _commonUtil2 = _interopRequireDefault(_commonUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  store: _store2.default,
	  mounted: function mounted() {
	    var vm = this;
	    if (vm.token == "") {
	      var token = this.getCookie("access-token");
	      if (token != null) {
	        vm.$store.commit('UPDATETOKEN', token);
	        vm.token = token;
	      }
	    }
	    vm.getUser();
	  },
	  computed: (0, _vuex.mapState)({
	    loginRediret: function loginRediret(state) {
	      return state.loginRediret;
	    },
	    cookieName: function cookieName(state) {
	      return state.cookieName;
	    },
	    getuserAPI: function getuserAPI(state) {
	      return state.getuserAPI;
	    }
	  }),
	  filters: {
	    idcExplain: function idcExplain(val) {
	      return _commonUtil2.default.idcExplain(val);
	    },
	    timeFormat: function timeFormat(val) {
	      return _commonUtil2.default.timeFormat(val);
	    },
	    switchColor: function switchColor(val) {
	      return _commonUtil2.default.switchColor(val);
	    },
	    statusExplain: function statusExplain(val) {
	      return _commonUtil2.default.statusExplain(val);
	    }
	  },
	  methods: {
	    reset: function reset() {},
	    kmUrl: function kmUrl(URL) {
	      window.open(URL);
	    },
	    routerUrl: function routerUrl(URL) {
	      this.$router.push(URL);
	    },
	    handleSelectionChange: function handleSelectionChange(val) {
	      this.multipleSelection = val;
	    },
	    getCookie: function getCookie(name) {
	      var arr,
	          reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
	      if (arr = document.cookie.match(reg)) return unescape(arr[2]);else return null;
	    },
	    getUser: function getUser() {
	      var vm = this;
	      if (vm.user == null || vm.user == "") {
	        vm.user = vm.getCookie("username");
	        document.cookie = "ssoid=" + vm.getCookie("access-token");
	        _axios2.default.get(vm.getuserAPI, {
	          withCredentials: true
	        }).then(function (response) {
	          if (response.data.status == 401) {
	            document.cookie = vm.cookieName + vm.$route.fullPath;
	            window.location = vm.loginRediret;
	          }
	        }).catch(function (error) {
	          vm.requesterrorinfo(error);
	        });
	      }
	    },
	    requesterrorinfo: function requesterrorinfo(error) {
	      var vm = this;
	      if (error.response) {
	        var code = error.response.status;
	        if (code == 401) {
	          vm.$message.error("401:您未登录");
	          var count = vm.getCookie("access-count");
	          window.location = vm.loginRediret;
	          if (count == null || count == 0) {
	            document.cookie = "access-count=1";
	            vm.$message('您未登录,请刷新');
	            document.cookie = vm.cookieName + vm.$route.fullPath;
	            window.location = vm.loginRediret;
	          } else {
	            vm.$message('您未登录,请刷新');
	          }
	        } else {
	          if (code == 404) {
	            vm.$notify({
	              title: '提示',
	              message: '404:Not found!',
	              type: 'error'
	            });
	          } else {
	            vm.$notify({
	              title: '提示',
	              message: '501:服务端未响应!',
	              type: 'error'
	            });
	          }
	        }
	      } else {
	        vm.$notify({
	          title: '提示',
	          message: '502:服务端未响应!',
	          type: 'error'
	
	        });
	      }
	    }
	  },
	  data: function data() {
	    return {
	      hostname: '',
	      token: ''
	    };
	  }
	};

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(11);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _vuex = __webpack_require__(3);
	
	var _commonUtil = __webpack_require__(18);
	
	var _commonUtil2 = _interopRequireDefault(_commonUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  store: _store2.default,
	  mounted: function mounted() {
	    var vm = this;
	    if (vm.token == "") {
	      var token = this.getCookie("access-token");
	      if (token != null) {
	        vm.$store.commit('UPDATETOKEN', token);
	        vm.token = token;
	      }
	    }
	    vm.getUser();
	  },
	  computed: (0, _vuex.mapState)({
	    loginRediret: function loginRediret(state) {
	      return state.loginRediret;
	    },
	    cookieName: function cookieName(state) {
	      return state.cookieName;
	    },
	    getuserAPI: function getuserAPI(state) {
	      return state.getuserAPI;
	    }
	  }),
	  filters: {
	    idcExplain: function idcExplain(val) {
	      return _commonUtil2.default.idcExplain(val);
	    },
	    timeFormat: function timeFormat(val) {
	      return _commonUtil2.default.timeFormat(val);
	    },
	    switchColor: function switchColor(val) {
	      return _commonUtil2.default.switchColor(val);
	    },
	    statusExplain: function statusExplain(val) {
	      return _commonUtil2.default.statusExplain(val);
	    }
	  },
	  methods: {
	    reset: function reset() {},
	    kmUrl: function kmUrl(URL) {
	      window.open(URL);
	    },
	    routerUrl: function routerUrl(URL) {
	      this.$router.push(URL);
	    },
	    handleSelectionChange: function handleSelectionChange(val) {
	      this.multipleSelection = val;
	    },
	    getCookie: function getCookie(name) {
	      var arr,
	          reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
	      if (arr = document.cookie.match(reg)) return unescape(arr[2]);else return null;
	    },
	    getUser: function getUser() {
	      var vm = this;
	      if (vm.user == null || vm.user == "") {
	        vm.user = vm.getCookie("username");
	        document.cookie = "ssoid=" + vm.getCookie("access-token");
	        _axios2.default.get(vm.getuserAPI, {
	          withCredentials: true
	        }).then(function (response) {
	          if (response.data.status == 401) {
	            document.cookie = vm.cookieName + vm.$route.fullPath;
	            window.location = vm.loginRediret;
	          }
	        }).catch(function (error) {
	          vm.requesterrorinfo(error);
	        });
	      }
	    },
	    requesterrorinfo: function requesterrorinfo(error) {
	      var vm = this;
	      if (error.response) {
	        var code = error.response.status;
	        if (code == 401) {
	          vm.$message.error("401:您未登录");
	          var count = vm.getCookie("access-count");
	          window.location = vm.loginRediret;
	          if (count == null || count == 0) {
	            document.cookie = "access-count=1";
	            vm.$message('您未登录,请刷新');
	            document.cookie = vm.cookieName + vm.$route.fullPath;
	            window.location = vm.loginRediret;
	          } else {
	            vm.$message('您未登录,请刷新');
	          }
	        } else {
	          if (code == 404) {
	            vm.$notify({
	              title: '提示',
	              message: '404:Not found!',
	              type: 'error'
	            });
	          } else {
	            vm.$notify({
	              title: '提示',
	              message: '501:服务端未响应!',
	              type: 'error'
	            });
	          }
	        }
	      } else {
	        vm.$notify({
	          title: '提示',
	          message: '502:服务端未响应!',
	          type: 'error'
	
	        });
	      }
	    }
	  },
	  data: function data() {
	    return {
	      hostname: '',
	      token: ''
	    };
	  }
	};

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(11);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _vuex = __webpack_require__(3);
	
	var _commonUtil = __webpack_require__(18);
	
	var _commonUtil2 = _interopRequireDefault(_commonUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  store: _store2.default,
	  mounted: function mounted() {
	    var vm = this;
	    if (vm.token == "") {
	      var token = this.getCookie("access-token");
	      if (token != null) {
	        vm.$store.commit('UPDATETOKEN', token);
	        vm.token = token;
	      }
	    }
	    vm.getUser();
	  },
	  computed: (0, _vuex.mapState)({
	    loginRediret: function loginRediret(state) {
	      return state.loginRediret;
	    },
	    cookieName: function cookieName(state) {
	      return state.cookieName;
	    },
	    getuserAPI: function getuserAPI(state) {
	      return state.getuserAPI;
	    }
	  }),
	  filters: {
	    idcExplain: function idcExplain(val) {
	      return _commonUtil2.default.idcExplain(val);
	    },
	    timeFormat: function timeFormat(val) {
	      return _commonUtil2.default.timeFormat(val);
	    },
	    switchColor: function switchColor(val) {
	      return _commonUtil2.default.switchColor(val);
	    },
	    statusExplain: function statusExplain(val) {
	      return _commonUtil2.default.statusExplain(val);
	    }
	  },
	  methods: {
	    reset: function reset() {},
	    kmUrl: function kmUrl(URL) {
	      window.open(URL);
	    },
	    routerUrl: function routerUrl(URL) {
	      this.$router.push(URL);
	    },
	    handleSelectionChange: function handleSelectionChange(val) {
	      this.multipleSelection = val;
	    },
	    getCookie: function getCookie(name) {
	      var arr,
	          reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
	      if (arr = document.cookie.match(reg)) return unescape(arr[2]);else return null;
	    },
	    getUser: function getUser() {
	      var vm = this;
	      if (vm.user == null || vm.user == "") {
	        vm.user = vm.getCookie("username");
	        document.cookie = "ssoid=" + vm.getCookie("access-token");
	        _axios2.default.get(vm.getuserAPI, {
	          withCredentials: true
	        }).then(function (response) {
	          if (response.data.status == 401) {
	            document.cookie = vm.cookieName + vm.$route.fullPath;
	            window.location = vm.loginRediret;
	          }
	        }).catch(function (error) {
	          vm.requesterrorinfo(error);
	        });
	      }
	    },
	    requesterrorinfo: function requesterrorinfo(error) {
	      var vm = this;
	      if (error.response) {
	        var code = error.response.status;
	        if (code == 401) {
	          vm.$message.error("401:您未登录");
	          var count = vm.getCookie("access-count");
	          window.location = vm.loginRediret;
	          if (count == null || count == 0) {
	            document.cookie = "access-count=1";
	            vm.$message('您未登录,请刷新');
	            document.cookie = vm.cookieName + vm.$route.fullPath;
	            window.location = vm.loginRediret;
	          } else {
	            vm.$message('您未登录,请刷新');
	          }
	        } else {
	          if (code == 404) {
	            vm.$notify({
	              title: '提示',
	              message: '404:Not found!',
	              type: 'error'
	            });
	          } else {
	            vm.$notify({
	              title: '提示',
	              message: '501:服务端未响应!',
	              type: 'error'
	            });
	          }
	        }
	      } else {
	        vm.$notify({
	          title: '提示',
	          message: '502:服务端未响应!',
	          type: 'error'
	
	        });
	      }
	    }
	  },
	  data: function data() {
	    return {
	      hostname: '',
	      token: ''
	    };
	  }
	};

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(11);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _vuex = __webpack_require__(3);
	
	var _commonUtil = __webpack_require__(18);
	
	var _commonUtil2 = _interopRequireDefault(_commonUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  store: _store2.default,
	  mounted: function mounted() {
	    var vm = this;
	    if (vm.token == "") {
	      var token = this.getCookie("access-token");
	      if (token != null) {
	        vm.$store.commit('UPDATETOKEN', token);
	        vm.token = token;
	      }
	    }
	    vm.getUser();
	  },
	  computed: (0, _vuex.mapState)({
	    loginRediret: function loginRediret(state) {
	      return state.loginRediret;
	    },
	    cookieName: function cookieName(state) {
	      return state.cookieName;
	    },
	    getuserAPI: function getuserAPI(state) {
	      return state.getuserAPI;
	    }
	  }),
	  filters: {
	    idcExplain: function idcExplain(val) {
	      return _commonUtil2.default.idcExplain(val);
	    },
	    timeFormat: function timeFormat(val) {
	      return _commonUtil2.default.timeFormat(val);
	    },
	    switchColor: function switchColor(val) {
	      return _commonUtil2.default.switchColor(val);
	    },
	    statusExplain: function statusExplain(val) {
	      return _commonUtil2.default.statusExplain(val);
	    }
	  },
	  methods: {
	    reset: function reset() {},
	    kmUrl: function kmUrl(URL) {
	      window.open(URL);
	    },
	    routerUrl: function routerUrl(URL) {
	      this.$router.push(URL);
	    },
	    handleSelectionChange: function handleSelectionChange(val) {
	      this.multipleSelection = val;
	    },
	    getCookie: function getCookie(name) {
	      var arr,
	          reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
	      if (arr = document.cookie.match(reg)) return unescape(arr[2]);else return null;
	    },
	    getUser: function getUser() {
	      var vm = this;
	      if (vm.user == null || vm.user == "") {
	        vm.user = vm.getCookie("username");
	        document.cookie = "ssoid=" + vm.getCookie("access-token");
	        _axios2.default.get(vm.getuserAPI, {
	          withCredentials: true
	        }).then(function (response) {
	          if (response.data.status == 401) {
	            document.cookie = vm.cookieName + vm.$route.fullPath;
	            window.location = vm.loginRediret;
	          }
	        }).catch(function (error) {
	          vm.requesterrorinfo(error);
	        });
	      }
	    },
	    requesterrorinfo: function requesterrorinfo(error) {
	      var vm = this;
	      if (error.response) {
	        var code = error.response.status;
	        if (code == 401) {
	          vm.$message.error("401:您未登录");
	          var count = vm.getCookie("access-count");
	          window.location = vm.loginRediret;
	          if (count == null || count == 0) {
	            document.cookie = "access-count=1";
	            vm.$message('您未登录,请刷新');
	            document.cookie = vm.cookieName + vm.$route.fullPath;
	            window.location = vm.loginRediret;
	          } else {
	            vm.$message('您未登录,请刷新');
	          }
	        } else {
	          if (code == 404) {
	            vm.$notify({
	              title: '提示',
	              message: '404:Not found!',
	              type: 'error'
	            });
	          } else {
	            vm.$notify({
	              title: '提示',
	              message: '501:服务端未响应!',
	              type: 'error'
	            });
	          }
	        }
	      } else {
	        vm.$notify({
	          title: '提示',
	          message: '502:服务端未响应!',
	          type: 'error'
	
	        });
	      }
	    }
	  },
	  data: function data() {
	    return {
	      hostname: '',
	      token: ''
	    };
	  }
	};

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _store = __webpack_require__(11);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _vuex = __webpack_require__(3);
	
	var _commonUtil = __webpack_require__(18);
	
	var _commonUtil2 = _interopRequireDefault(_commonUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    store: _store2.default,
	    mounted: function mounted() {
	        var vm = this;
	        if (vm.token == "") {
	            var token = this.getCookie("access-token");
	            if (token != null) {
	                vm.$store.commit('UPDATETOKEN', token);
	                vm.token = token;
	            }
	        }
	        vm.getUser();
	    },
	    computed: (0, _vuex.mapState)({
	        loginRediret: function loginRediret(state) {
	            return state.loginRediret;
	        },
	        cookieName: function cookieName(state) {
	            return state.cookieName;
	        },
	        getuserAPI: function getuserAPI(state) {
	            return state.getuserAPI;
	        }
	    }),
	    filters: {
	        idcExplain: function idcExplain(val) {
	            return _commonUtil2.default.idcExplain(val);
	        },
	        timeFormat: function timeFormat(val) {
	            return _commonUtil2.default.timeFormat(val);
	        },
	        switchColor: function switchColor(val) {
	            return _commonUtil2.default.switchColor(val);
	        },
	        statusExplain: function statusExplain(val) {
	            return _commonUtil2.default.statusExplain(val);
	        }
	    },
	    methods: {
	        reset: function reset() {},
	        kmUrl: function kmUrl(URL) {
	            window.open(URL);
	        },
	        handleSelectionChange: function handleSelectionChange(val) {
	            this.multipleSelection = val;
	        },
	        getCookie: function getCookie(name) {
	            var arr,
	                reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
	            if (arr = document.cookie.match(reg)) return unescape(arr[2]);else return null;
	        },
	        getUser: function getUser() {
	            var vm = this;
	            if (vm.user == null || vm.user == "") {
	                vm.user = vm.getCookie("username");
	                document.cookie = "ssoid=" + vm.getCookie("access-token");
	                _axios2.default.get(vm.getuserAPI, {
	                    withCredentials: true
	                }).then(function (response) {
	                    if (response.data.status == 401) {
	                        document.cookie = vm.cookieName + vm.$route.fullPath;
	                        window.location = vm.loginRediret;
	                    }
	                }).catch(function (error) {
	                    vm.requesterrorinfo(error);
	                });
	            }
	        },
	        requesterrorinfo: function requesterrorinfo(error) {
	            var vm = this;
	            if (error.response) {
	                var code = error.response.status;
	                if (code == 401) {
	                    vm.$message.error("401:您未登录");
	                    var count = vm.getCookie("access-count");
	                    window.location = vm.loginRediret;
	                    if (count == null || count == 0) {
	                        document.cookie = "access-count=1";
	                        vm.$message('您未登录,请刷新');
	                        document.cookie = vm.cookieName + vm.$route.fullPath;
	                        window.location = vm.loginRediret;
	                    } else {
	                        vm.$message('您未登录,请刷新');
	                    }
	                } else {
	                    if (code == 404) {
	                        vm.$notify({
	                            title: '提示',
	                            message: '404:Not found!',
	                            type: 'error'
	                        });
	                    } else {
	                        vm.$notify({
	                            title: '提示',
	                            message: '501:服务端未响应!',
	                            type: 'error'
	                        });
	                    }
	                }
	            } else {
	                vm.$notify({
	                    title: '提示',
	                    message: '502:服务端未响应!',
	                    type: 'error'
	
	                });
	            }
	        }
	    },
	    data: function data() {
	        return {
	            hostname: '',
	            token: ''
	        };
	    }
	};

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(11);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _vuex = __webpack_require__(3);
	
	var _commonUtil = __webpack_require__(18);
	
	var _commonUtil2 = _interopRequireDefault(_commonUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  store: _store2.default,
	  mounted: function mounted() {
	    var vm = this;
	    if (vm.token == "") {
	      var token = this.getCookie("access-token");
	      if (token != null) {
	        vm.$store.commit('UPDATETOKEN', token);
	        vm.token = token;
	      }
	    }
	    vm.getUser();
	  },
	  computed: (0, _vuex.mapState)({
	    loginRediret: function loginRediret(state) {
	      return state.loginRediret;
	    },
	    cookieName: function cookieName(state) {
	      return state.cookieName;
	    },
	    getuserAPI: function getuserAPI(state) {
	      return state.getuserAPI;
	    }
	  }),
	  filters: {
	    idcExplain: function idcExplain(val) {
	      return _commonUtil2.default.idcExplain(val);
	    },
	    timeFormat: function timeFormat(val) {
	      return _commonUtil2.default.timeFormat(val);
	    },
	    switchColor: function switchColor(val) {
	      return _commonUtil2.default.switchColor(val);
	    },
	    statusExplain: function statusExplain(val) {
	      return _commonUtil2.default.statusExplain(val);
	    }
	  },
	  methods: {
	    reset: function reset() {},
	    kmUrl: function kmUrl(URL) {
	      window.open(URL);
	    },
	    handleSelectionChange: function handleSelectionChange(val) {
	      this.multipleSelection = val;
	    },
	    getCookie: function getCookie(name) {
	      var arr,
	          reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
	      if (arr = document.cookie.match(reg)) return unescape(arr[2]);else return null;
	    },
	    getUser: function getUser() {
	      var vm = this;
	      if (vm.user == null || vm.user == "") {
	        vm.user = vm.getCookie("username");
	        document.cookie = "ssoid=" + vm.getCookie("access-token");
	        _axios2.default.get(vm.getuserAPI, {
	          withCredentials: true
	        }).then(function (response) {
	          if (response.data.status == 401) {
	            document.cookie = vm.cookieName + vm.$route.fullPath;
	            window.location = vm.loginRediret;
	          }
	        }).catch(function (error) {
	          vm.requesterrorinfo(error);
	        });
	      }
	    },
	    requesterrorinfo: function requesterrorinfo(error) {
	      var vm = this;
	      if (error.response) {
	        var code = error.response.status;
	        if (code == 401) {
	          vm.$message.error("401:您未登录");
	          var count = vm.getCookie("access-count");
	          window.location = vm.loginRediret;
	          if (count == null || count == 0) {
	            document.cookie = "access-count=1";
	            vm.$message('您未登录,请刷新');
	            document.cookie = vm.cookieName + vm.$route.fullPath;
	            window.location = vm.loginRediret;
	          } else {
	            vm.$message('您未登录,请刷新');
	          }
	        } else {
	          if (code == 404) {
	            vm.$notify({
	              title: '提示',
	              message: '404:Not found!',
	              type: 'error'
	            });
	          } else {
	            vm.$notify({
	              title: '提示',
	              message: '501:服务端未响应!',
	              type: 'error'
	            });
	          }
	        }
	      } else {
	        vm.$notify({
	          title: '提示',
	          message: '502:服务端未响应!',
	          type: 'error'
	
	        });
	      }
	    }
	  },
	  data: function data() {
	    return {
	      hostname: '',
	      token: ''
	    };
	  }
	};

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(83);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _vuex = __webpack_require__(3);
	
	var _image = __webpack_require__(225);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: "templateHtml",
	    beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
	        this.currentIndex = to.query.index;
	        window.scrollTo(0, 0);
	        next();
	    },
	
	    mounted: function mounted() {
	        var _this = this;
	
	        var vm = this;
	        vm.currentIndex = vm.$route.query.index;
	        if (vm.token == "") {
	            var token = this.getCookie("access-token");
	            if (token != null) {
	                vm.$store.commit('UPDATETOKEN', token);
	                vm.token = token;
	            }
	        }
	        vm.$store.commit('changeActiveItem', vm.currentIndex);
	        _axios2.default.get(vm.selectDocument, {
	            withCredentials: true,
	            params: { "documentIndex": vm.currentIndex, "language": "" }
	        }).then(function (response) {
	            if (response.data && response.data.status === 401) {
	                document.cookie = "currentURL=templateHtml?index=" + vm.currentIndex;
	                window.location = vm.loginRediret;
	                return;
	            }
	            if (response.data.code === 2) {
	                if (response.data.message !== '查询成功') {
	                    vm.$notify({
	                        title: '提示(Notice)',
	                        message: "无对应语言页面，显示当前页面～(No corresponding language page available, displaying the current page~)",
	                        type: 'warning',
	                        customClass: 'notify-warning'
	                    });
	                }
	                vm.documentContent = response.data.data.documentContent;
	                vm.$refs.contentWrapper.innerHTML = vm.documentContent;
	                vm.title = response.data.data.documentTitle;
	                console.log(response.data.data.language);
	                _this.$store.commit('UPDATE_LANGUAGE', response.data.data.language);
	                (0, _image.imageToView)({
	                    bodyWrapper: vm.$refs.contentWrapper
	                }, {
	                    imageLink: false
	                });
	            } else {
	                vm.$notify({
	                    title: '提示',
	                    message: '显示文档失败！',
	                    type: 'error'
	                });
	            }
	        }).catch(function (error) {
	            vm.requesterrorinfo(error);
	        });
	    },
	
	    computed: (0, _vuex.mapState)((0, _extends3.default)({
	        loginRediret: function loginRediret(state) {
	            return state.loginRediret;
	        },
	        selectDocument: function selectDocument(state) {
	            return state.selectDocument;
	        },
	        selectItemList: function selectItemList(state) {
	            return state.selectItemList;
	        },
	        cookieName: function cookieName(state) {
	            return state.cookieName;
	        }
	    }, (0, _vuex.mapState)({
	        currentLang: function currentLang(state) {
	            return state.currentLang;
	        }
	    }))),
	    methods: {
	        closeDialogFun: function closeDialogFun() {
	            this.centerDialogVisible = false;
	            window.location.reload();
	        },
	        getCookie: function getCookie(name) {
	            var arr,
	                reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
	            if (arr = document.cookie.match(reg)) return unescape(arr[2]);else return null;
	        },
	        editorDocument: function editorDocument() {
	            if (!this.$store.state.is_manager) {
	                this.$notify({
	                    title: '没有权限',
	                    message: '你没有操作当前菜单的权限',
	                    type: 'error'
	                });
	                return;
	            }
	            this.$router.push({
	                path: '/updateDocument',
	                query: { index: this.currentIndex }
	            });
	        },
	        refreshHtmlWhenLangChange: function refreshHtmlWhenLangChange(index) {
	            var _this2 = this;
	
	            var vm = this;
	            _axios2.default.get(vm.selectDocument, {
	                withCredentials: true,
	                params: { "documentIndex": index.query.index, "language": vm.currentLang }
	            }).then(function (response) {
	                if (response.data && response.data.status === 401) {
	                    document.cookie = "currentURL=templateHtml?index=" + vm.currentIndex;
	                    window.location = vm.loginRediret;
	                    return;
	                }
	                if (response.data.code === 2) {
	                    if (response.data.message !== '查询成功') {
	                        vm.$notify({
	                            title: '提示(Notice)',
	                            message: "无对应语言页面，显示当前页面～(No corresponding language page available, displaying the current page~)",
	                            type: 'warning',
	                            customClass: 'notify-warning'
	                        });
	                        _this2.$store.commit('UPDATE_LANGUAGE', response.data.data.language);
	                    }
	                    vm.documentContent = response.data.data.documentContent;
	                    vm.$refs.contentWrapper.innerHTML = vm.documentContent;
	                    vm.title = response.data.data.documentTitle;
	                    (0, _image.imageToView)({
	                        bodyWrapper: vm.$refs.contentWrapper
	                    }, {
	                        imageLink: false
	                    });
	                } else {
	                    var message = '显示文档失败！';
	                    if (response.data && response.data.message) {
	                        message = response.data.message + '!';
	                    }
	                    vm.$notify({
	                        title: '提示',
	                        message: message,
	                        type: 'error'
	                    });
	                }
	            }).catch(function (error) {
	                vm.requesterrorinfo(error);
	            });
	        },
	        refreshHtml: function refreshHtml(index) {
	            var _this3 = this;
	
	            var vm = this;
	            _axios2.default.get(vm.selectDocument, {
	                withCredentials: true,
	                params: { "documentIndex": index.query.index, "language": "" }
	            }).then(function (response) {
	                if (response.data && response.data.status === 401) {
	                    document.cookie = "currentURL=templateHtml?index=" + vm.currentIndex;
	                    window.location = vm.loginRediret;
	                    return;
	                }
	                if (response.data.code === 2) {
	                    if (response.data.message !== '查询成功') {
	                        vm.$notify({
	                            title: '提示(Notice)',
	                            message: "无对应语言页面，显示当前页面～(No corresponding language page available, displaying the current page~)",
	                            type: 'warning',
	                            customClass: 'notify-warning'
	                        });
	                    }
	                    vm.documentContent = response.data.data.documentContent;
	                    vm.$refs.contentWrapper.innerHTML = vm.documentContent;
	                    vm.title = response.data.data.documentTitle;
	                    console.log(response.data.data.language);
	                    _this3.$store.commit('UPDATE_LANGUAGE', response.data.data.language);
	
	                    (0, _image.imageToView)({
	                        bodyWrapper: vm.$refs.contentWrapper
	                    }, {
	                        imageLink: false
	                    });
	                } else {
	                    var message = '显示文档失败！';
	                    if (response.data && response.data.message) {
	                        message = response.data.message + '!';
	                    }
	                    vm.$notify({
	                        title: '提示',
	                        message: message,
	                        type: 'error'
	                    });
	                }
	            }).catch(function (error) {
	                vm.requesterrorinfo(error);
	            });
	        },
	        requesterrorinfo: function requesterrorinfo(error) {
	            var vm = this;
	            if (error.response) {
	                var code = error.response.status;
	                if (code == 401) {
	                    document.cookie = "currentURL=templateHtml?index=" + vm.currentIndex;
	                    window.location = vm.loginRediret;
	                } else {
	                    if (code == 404) {
	                        vm.$notify({
	                            title: '提示',
	                            message: '404:Not found!',
	                            type: 'error'
	                        });
	                    } else {
	                        vm.$notify({
	                            title: '提示',
	                            message: '501:服务端未响应!',
	                            type: 'error'
	                        });
	                    }
	                }
	            } else {
	                vm.$notify({
	                    title: '提示',
	                    message: '502:服务端未响应!',
	                    type: 'error'
	                });
	            }
	        },
	        updateComponentLanguage: function updateComponentLanguage(lang) {
	            var index = {
	                query: {
	                    index: this.currentIndex
	                }
	            };
	            this.refreshHtmlWhenLangChange(index);
	        }
	    },
	    watch: {
	        $route: "refreshHtml",
	        currentLang: function currentLang(newLang) {
	            this.updateComponentLanguage(newLang);
	        }
	    },
	    data: function data() {
	        return {
	            token: '',
	            currentIndex: '',
	            documentContent: '',
	            title: '',
	            centerDialogVisible: false
	        };
	    }
	};

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _store = __webpack_require__(11);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _vuex = __webpack_require__(3);
	
	var _commonUtil = __webpack_require__(18);
	
	var _commonUtil2 = _interopRequireDefault(_commonUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    store: _store2.default,
	    mounted: function mounted() {},
	    computed: (0, _vuex.mapState)({
	        loginRediret: function loginRediret(state) {
	            return state.loginRediret;
	        },
	        cookieName: function cookieName(state) {
	            return state.cookieName;
	        },
	        getuserAPI: function getuserAPI(state) {
	            return state.getuserAPI;
	        }
	    }),
	    filters: {
	        idcExplain: function idcExplain(val) {
	            return _commonUtil2.default.idcExplain(val);
	        },
	        timeFormat: function timeFormat(val) {
	            return _commonUtil2.default.timeFormat(val);
	        },
	        switchColor: function switchColor(val) {
	            return _commonUtil2.default.switchColor(val);
	        },
	        statusExplain: function statusExplain(val) {
	            return _commonUtil2.default.statusExplain(val);
	        }
	    },
	    methods: {
	        reset: function reset() {},
	        kmUrl: function kmUrl(URL) {
	            window.open(URL);
	        },
	        routerUrl: function routerUrl(URL) {
	            this.$router.push(URL);
	        },
	        handleSelectionChange: function handleSelectionChange(val) {
	            this.multipleSelection = val;
	        },
	        getCookie: function getCookie(name) {
	            var arr,
	                reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
	            if (arr = document.cookie.match(reg)) return unescape(arr[2]);else return null;
	        },
	        requesterrorinfo: function requesterrorinfo(error) {
	            var vm = this;
	            if (error.response) {
	                var code = error.response.status;
	                if (code == 401) {
	                    vm.$message.error("401:您未登录");
	                    var count = vm.getCookie("access-count");
	                    window.location = vm.loginRediret;
	                    if (count == null || count == 0) {
	                        document.cookie = "access-count=1";
	                        vm.$message('您未登录,请刷新');
	                        document.cookie = vm.cookieName + vm.$route.fullPath;
	                        window.location = vm.loginRediret;
	                    } else {
	                        vm.$message('您未登录,请刷新');
	                    }
	                } else {
	                    if (code == 404) {
	                        vm.$notify({
	                            title: '提示',
	                            message: '404:Not found!',
	                            type: 'error'
	                        });
	                    } else {
	                        vm.$notify({
	                            title: '提示',
	                            message: '501:服务端未响应!',
	                            type: 'error'
	                        });
	                    }
	                }
	            } else {
	                vm.$notify({
	                    title: '提示',
	                    message: '502:服务端未响应!',
	                    type: 'error'
	
	                });
	            }
	        }
	    }
	};

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(40);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _promise = __webpack_require__(35);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _asyncToGenerator2 = __webpack_require__(39);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _citadelEditor = __webpack_require__(143);
	
	var _toolbar = __webpack_require__(144);
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: "updateDocument",
	    mounted: function mounted() {
	        window.addEventListener('scroll', this.handleScroll);
	        var vm = this;
	        if (!vm.$store.state.is_manager) {
	            this.$notify({
	                title: '没有权限',
	                message: '你没有操作当前菜单的权限',
	                type: 'error'
	            });
	            return;
	        }
	        if (vm.token === "") {
	            var token = this.getCookie("access-token");
	            if (token != null) {
	                vm.$store.commit('UPDATETOKEN', token);
	                vm.token = token;
	            }
	        }
	
	        vm.currentIndex = this.$route.query.index;
	        _axios2.default.get(vm.selectDocument, {
	            withCredentials: true,
	            params: { "documentIndex": vm.currentIndex, "language": "" }
	        }).then(function (response) {
	            if (response.data && response.data.status === 401) {
	                document.cookie = "currentURL=updateDocument?index=" + vm.currentIndex;
	                window.location = vm.loginRediret;
	                return;
	            }
	            if (response.data.code === 2) {
	                if (response.data.message !== '查询成功') {
	                    vm.$notify({
	                        title: '提示(Notice)',
	                        message: "无对应语言页面，显示当前页面～(No corresponding language page available, displaying the current page~)",
	                        type: 'warning',
	                        customClass: 'notify-warning'
	                    });
	                }
	                vm.documentContent = response.data.data.documentContent;
	                vm.title = response.data.data.documentTitle;
	                var $editor = document.querySelector("#editor");
	                var $toolbarWrapper = document.querySelector("#toolbar");
	                var editor = new _citadelEditor.Editor($editor, {
	                    defaultValue: vm.documentContent,
	                    moduleConfigs: {
	                        image: {
	                            customUpload: function () {
	                                var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(_ref) {
	                                    var _this = this;
	
	                                    var file = _ref.file,
	                                        onprogress = _ref.onprogress,
	                                        insert = _ref.insert,
	                                        failedHandle = _ref.failedHandle;
	                                    var result;
	                                    return _regenerator2.default.wrap(function _callee2$(_context2) {
	                                        while (1) {
	                                            switch (_context2.prev = _context2.next) {
	                                                case 0:
	                                                    _context2.prev = 0;
	                                                    _context2.next = 3;
	                                                    return new _promise2.default(function (res) {
	                                                        setTimeout((0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	                                                            var rest;
	                                                            return _regenerator2.default.wrap(function _callee$(_context) {
	                                                                while (1) {
	                                                                    switch (_context.prev = _context.next) {
	                                                                        case 0:
	                                                                            _context.next = 2;
	                                                                            return vm.uploadFileToS3(file, onprogress);
	
	                                                                        case 2:
	                                                                            rest = _context.sent;
	
	                                                                            res(rest);
	
	                                                                        case 4:
	                                                                        case "end":
	                                                                            return _context.stop();
	                                                                    }
	                                                                }
	                                                            }, _callee, _this);
	                                                        })), 2000);
	                                                    });
	
	                                                case 3:
	                                                    result = _context2.sent;
	                                                    _context2.next = 6;
	                                                    return insert({
	                                                        src: result
	                                                    });
	
	                                                case 6:
	                                                    _context2.next = 11;
	                                                    break;
	
	                                                case 8:
	                                                    _context2.prev = 8;
	                                                    _context2.t0 = _context2["catch"](0);
	
	                                                    failedHandle("some errors: " + _context2.t0);
	
	                                                case 11:
	                                                case "end":
	                                                    return _context2.stop();
	                                            }
	                                        }
	                                    }, _callee2, this, [[0, 8]]);
	                                }));
	
	                                function customUpload(_x) {
	                                    return _ref2.apply(this, arguments);
	                                }
	
	                                return customUpload;
	                            }()
	                        }
	                    }
	                });
	                (0, _toolbar.buildToolbar)({
	                    $toolbarWrapper: $toolbarWrapper,
	                    getEditorCore: function getEditorCore() {
	                        return editor;
	                    }
	                });
	                vm.editor = editor;
	            } else {
	                vm.$notify({
	                    title: '提示',
	                    message: '显示文档失败！',
	                    type: 'error'
	                });
	            }
	        }).catch(function (error) {
	            vm.requesterrorinfo(error);
	        });
	        vm.buildScrollData();
	    },
	    computed: (0, _vuex.mapState)({
	        updateDocument: function updateDocument(state) {
	            return state.updateDocument;
	        },
	        selectDocument: function selectDocument(state) {
	            return state.selectDocument;
	        },
	        uploadImage: function uploadImage(state) {
	            return state.uploadImage;
	        }
	    }),
	    methods: {
	        buildScrollData: function buildScrollData() {
	            var vm = this;
	
	            this.$nextTick(function () {
	                var header = document.getElementById("toolbar");
	
	                vm.scroll.offsetTop = header.offsetTop;
	                vm.scroll.offsetHeight = header.offsetHeight;
	            });
	        },
	        handleScroll: function handleScroll() {
	            var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
	
	            this.scroll.headerFixed = scrollTop > this.scroll.offsetTop - this.scroll.offsetHeight;
	        },
	        getCookie: function getCookie(name) {
	            var arr,
	                reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
	            if (arr = document.cookie.match(reg)) return unescape(arr[2]);else return null;
	        },
	        updateContent: function updateContent() {
	            var _this2 = this;
	
	            var vm = this;
	            var htmlInfo = vm.editor.value();
	            var document = { documentIndex: vm.currentIndex, documentContent: htmlInfo, documentTitle: vm.title };
	            _axios2.default.post(vm.updateDocument, document, {
	                withCredentials: true
	            }).then(function (response) {
	                if (response.data.code === 2) {
	                    vm.$notify({
	                        title: '提示',
	                        message: '修改成功！',
	                        type: 'success'
	                    });
	                    _this2.$router.push({ path: '/templateHtml', query: { index: vm.currentIndex } });
	                } else {
	                    var message = '修改失败！';
	                    if (response.data && response.data.message) {
	                        message = response.data.message + '!';
	                    }
	                    vm.$notify({
	                        title: '提示',
	                        message: message,
	                        type: 'error'
	                    });
	                }
	            }).catch(function (error) {
	                vm.requesterrorinfo(error);
	            });
	        },
	        goBack: function goBack() {
	            this.$router.go(-1);
	        },
	        requesterrorinfo: function requesterrorinfo(error) {
	            var vm = this;
	            if (error.response) {
	                var code = error.response.status;
	                if (code === 401) {
	                    document.cookie = "currentURL=updateDocument?index=" + vm.currentIndex;
	                    window.location = vm.loginRediret;
	                } else {
	                    if (code === 404) {
	                        vm.$notify({
	                            title: '提示',
	                            message: '404:Not found!',
	                            type: 'error'
	                        });
	                    } else {
	                        vm.$notify({
	                            title: '提示',
	                            message: '501:服务端未响应!',
	                            type: 'error'
	                        });
	                    }
	                }
	            } else {
	                vm.$notify({
	                    title: '提示',
	                    message: '502:服务端未响应!',
	                    type: 'error'
	                });
	            }
	        },
	        uploadFileToS3: function () {
	            var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(file, onprogress) {
	                var vm, formData, response;
	                return _regenerator2.default.wrap(function _callee3$(_context3) {
	                    while (1) {
	                        switch (_context3.prev = _context3.next) {
	                            case 0:
	                                vm = this;
	                                formData = new FormData();
	
	                                formData.append('file', file);
	                                _context3.next = 5;
	                                return _axios2.default.post(vm.uploadImage, formData, {
	                                    withCredentials: true,
	                                    headers: { 'Content-Type': 'multipart/form-data' }
	                                });
	
	                            case 5:
	                                response = _context3.sent;
	
	                                if (!(response.data.code === 0)) {
	                                    _context3.next = 10;
	                                    break;
	                                }
	
	                                return _context3.abrupt("return", response.data.data);
	
	                            case 10:
	                                vm.$message.error(response.data.message);
	                                return _context3.abrupt("return", null);
	
	                            case 12:
	                            case "end":
	                                return _context3.stop();
	                        }
	                    }
	                }, _callee3, this);
	            }));
	
	            function uploadFileToS3(_x2, _x3) {
	                return _ref4.apply(this, arguments);
	            }
	
	            return uploadFileToS3;
	        }()
	    },
	    data: function data() {
	        return {
	            token: '',
	            title: '标题',
	            documentContent: '',
	            currentIndex: '',
	            editor: null,
	            scroll: {
	                offsetTop: 0,
	                offsetHeight: 0,
	                headerFixed: false
	            }
	        };
	    },
	    destroyed: function destroyed() {
	        window.removeEventListener('scroll', this.handleScroll);
	    }
	};

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _vuex = __webpack_require__(3);
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: "updateItem",
	    data: function data() {
	        return {
	            form: {
	                title: '',
	                options: []
	            },
	            token: '',
	            value: ''
	        };
	    },
	
	    mounted: function mounted() {
	        var vm = this;
	        if (!vm.$store.state.is_manager) {
	            this.$notify({
	                title: '没有权限',
	                message: '你没有操作当前菜单的权限',
	                type: 'error'
	            });
	            return;
	        }
	        if (vm.token == "") {
	            var token = this.getCookie("access-token");
	            if (token != null) {
	                vm.$store.commit('UPDATETOKEN', token);
	                vm.token = token;
	            }
	        }
	        this.$nextTick(function () {
	            _axios2.default.get(vm.selectDirItems, {
	                withCredentials: true
	            }).then(function (response) {
	                if (response.data && response.data.status === 401) {
	                    window.location = vm.loginRediret;
	                    return;
	                }
	                var dirItem = response.data.data;
	                if (!dirItem || dirItem.length === 0) {
	                    return;
	                }
	                vm.$set(vm.form, 'options', dirItem);
	            }).catch(function (error) {
	                vm.requesterrorinfo(error);
	            });
	        });
	    },
	    computed: (0, _vuex.mapState)({
	        updateItem: function updateItem(state) {
	            return state.updateItem;
	        },
	        selectDirItems: function selectDirItems(state) {
	            return state.selectDirItems;
	        }
	    }),
	    methods: {
	        getCookie: function getCookie(name) {
	            var arr,
	                reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
	            if (arr = document.cookie.match(reg)) return unescape(arr[2]);else return null;
	        },
	        onSubmit: function onSubmit() {
	            var vm = this;
	            if (vm.value == '' || vm.form.title == '') {
	                vm.$message.error('信息不完整，请完善！');
	                return;
	            }
	            _axios2.default.post(vm.updateItem, { documentIndex: vm.value, documentTitle: vm.form.title }, {
	                withCredentials: true
	            }).then(function (response) {
	                vm.$notify({
	                    title: '提示',
	                    message: '修改成功',
	                    type: 'success'
	                });
	            }).catch(function (error) {
	                vm.requesterrorinfo(error);
	            });
	        },
	        requesterrorinfo: function requesterrorinfo(error) {
	            var vm = this;
	            if (error.response) {
	                var code = error.response.status;
	                if (code === 401) {
	                    document.cookie = "currentURL=updateItem";
	                    window.location = vm.loginRediret;
	                } else {
	                    if (code === 404) {
	                        vm.$notify({
	                            title: '提示',
	                            message: '404:Not found!',
	                            type: 'error'
	                        });
	                    } else {
	                        vm.$notify({
	                            title: '提示',
	                            message: '501:服务端未响应!',
	                            type: 'error'
	                        });
	                    }
	                }
	            } else {
	                vm.$notify({
	                    title: '提示',
	                    message: '502:服务端未响应!',
	                    type: 'error'
	                });
	            }
	        }
	    }
	};

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(44);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _regenerator = __webpack_require__(40);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(39);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _methods;
	
	var _store = __webpack_require__(11);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _vuex = __webpack_require__(3);
	
	var _commonUtil = __webpack_require__(18);
	
	var _commonUtil2 = _interopRequireDefault(_commonUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    store: _store2.default,
	    mounted: function mounted() {
	        var vm = this;
	        if (vm.token == "") {
	            var token = this.getCookie("access-token");
	            if (token != null) {
	                vm.$store.commit('UPDATETOKEN', token);
	                vm.token = token;
	            }
	        }
	        vm.getUser();
	    },
	    computed: (0, _vuex.mapState)({
	        loginRediret: function loginRediret(state) {
	            return state.loginRediret;
	        },
	        cookieName: function cookieName(state) {
	            return state.cookieName;
	        },
	        temporaryWhiteAPI: function temporaryWhiteAPI(state) {
	            return state.temporaryWhiteAPI;
	        },
	        getuserAPI: function getuserAPI(state) {
	            return state.getuserAPI;
	        },
	        userCertGetUrl: function userCertGetUrl(state) {
	            return state.userCertGetUrl;
	        },
	        userCertAddOne: function userCertAddOne(state) {
	            return state.userCertAddOne;
	        }
	    }),
	    filters: {
	        idcExplain: function idcExplain(val) {
	            return _commonUtil2.default.idcExplain(val);
	        },
	        timeFormat: function timeFormat(val) {
	            return _commonUtil2.default.timeFormat(val);
	        },
	        switchColor: function switchColor(val) {
	            return _commonUtil2.default.switchColor(val);
	        },
	        statusExplain: function statusExplain(val) {
	            return _commonUtil2.default.statusExplain(val);
	        }
	    },
	    methods: (_methods = {
	        reset: function reset() {
	            var vm = this;
	            vm.name = '';
	            vm.rasp = '';
	            vm.proc = '';
	            vm.ws = '';
	            vm.query_arg = 'hostname';
	            vm.query_value = '';
	        },
	        getCookie: function getCookie(name) {
	            var arr,
	                reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
	            if (arr = document.cookie.match(reg)) return unescape(arr[2]);else return null;
	        },
	        kmUrl: function kmUrl(URL) {
	            window.open(URL);
	        },
	        handleSelectionChange: function handleSelectionChange(val) {
	            this.multipleSelection = val;
	        },
	        commitMisApply: function () {
	            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(doc) {
	                var vm, regex, result, url_result;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                vm = this;
	
	                                if (doc.mis_id) {
	                                    _context.next = 4;
	                                    break;
	                                }
	
	                                vm.$message.error("Mis账号不能为空");
	                                return _context.abrupt('return');
	
	                            case 4:
	                                if (doc.device_id) {
	                                    _context.next = 7;
	                                    break;
	                                }
	
	                                vm.$message.error("MAC地址不能为空");
	                                return _context.abrupt('return');
	
	                            case 7:
	                                regex = /^([0-9a-fA-F]{2})(([/\s:][0-9a-fA-F]{2}){5})$/;
	
	                                if (regex.test(doc.device_id)) {
	                                    _context.next = 11;
	                                    break;
	                                }
	
	                                vm.$message.error("MAC地址格式错误");
	                                return _context.abrupt('return');
	
	                            case 11:
	                                _context.next = 13;
	                                return vm.submitUserCert(doc);
	
	                            case 13:
	                                result = _context.sent;
	
	                                if (!(result['code'] !== 0)) {
	                                    _context.next = 17;
	                                    break;
	                                }
	
	                                alert(result['message']);
	                                return _context.abrupt('return');
	
	                            case 17:
	                                _context.next = 19;
	                                return vm.getS3Url(doc);
	
	                            case 19:
	                                url_result = _context.sent;
	
	                                if (!(url_result['code'] !== 0)) {
	                                    _context.next = 23;
	                                    break;
	                                }
	
	                                alert(url_result['message']);
	                                return _context.abrupt('return');
	
	                            case 23:
	                                window.location.href = url_result['data'];
	
	                            case 24:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function commitMisApply(_x) {
	                return _ref.apply(this, arguments);
	            }
	
	            return commitMisApply;
	        }()
	    }, (0, _defineProperty3.default)(_methods, 'getCookie', function getCookie(name) {
	        var arr,
	            reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
	        if (arr = document.cookie.match(reg)) return unescape(arr[2]);else return null;
	    }), (0, _defineProperty3.default)(_methods, 'getUser', function getUser() {
	        var vm = this;
	        if (vm.user == null || vm.user == "") {
	            vm.user = vm.getCookie("username");
	            document.cookie = "ssoid=" + vm.getCookie("access-token");
	            _axios2.default.get(vm.getuserAPI, {
	                withCredentials: true
	            }).then(function (response) {
	                if (response.data.status == 401) {
	                    document.cookie = vm.cookieName + vm.$route.fullPath;
	                    window.location = vm.loginRediret;
	                } else {
	                    vm.userCertApply.mis_id = response.data.data.login;
	                    if (vm.userCertApply.mis_id == null) {
	                        vm.userCertApply.mis_id = vm.getCookie("username");
	                    }
	                    if (vm.userCertApply.mis_id == null) {
	                        vm.userCertApply.mis_id = vm.getCookie("user").login;
	                    }
	                }
	            }).catch(function (error) {
	                vm.requesterrorinfo(error);
	            });
	        }
	    }), (0, _defineProperty3.default)(_methods, 'submitUserCert', function () {
	        var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(doc) {
	            var vm, response;
	            return _regenerator2.default.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            vm = this;
	                            _context2.next = 3;
	                            return _axios2.default.get(vm.userCertAddOne, {
	                                withCredentials: true,
	                                params: { "misId": doc.mis_id, "deviceId": doc.device_id }
	                            });
	
	                        case 3:
	                            response = _context2.sent;
	                            return _context2.abrupt('return', response.data);
	
	                        case 5:
	                        case 'end':
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, this);
	        }));
	
	        function submitUserCert(_x2) {
	            return _ref2.apply(this, arguments);
	        }
	
	        return submitUserCert;
	    }()), (0, _defineProperty3.default)(_methods, 'getS3Url', function () {
	        var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(doc) {
	            var vm, response;
	            return _regenerator2.default.wrap(function _callee3$(_context3) {
	                while (1) {
	                    switch (_context3.prev = _context3.next) {
	                        case 0:
	                            vm = this;
	                            _context3.next = 3;
	                            return _axios2.default.get(vm.userCertGetUrl, {
	                                withCredentials: true,
	                                params: { "misId": doc.mis_id, "deviceId": doc.device_id }
	                            });
	
	                        case 3:
	                            response = _context3.sent;
	                            return _context3.abrupt('return', response.data);
	
	                        case 5:
	                        case 'end':
	                            return _context3.stop();
	                    }
	                }
	            }, _callee3, this);
	        }));
	
	        function getS3Url(_x3) {
	            return _ref3.apply(this, arguments);
	        }
	
	        return getS3Url;
	    }()), (0, _defineProperty3.default)(_methods, 'requesterrorinfo', function requesterrorinfo(error) {
	        var vm = this;
	        if (error.response) {
	            var code = error.response.status;
	            if (code == 401) {
	                vm.$message.error("401:您未登录");
	                var count = vm.getCookie("access-count");
	                window.location = vm.loginRediret;
	                if (count == null || count == 0) {
	                    document.cookie = "access-count=1";
	                    vm.$message('您未登录,请刷新');
	                    document.cookie = vm.cookieName + vm.$route.fullPath;
	                    window.location = vm.loginRediret;
	                } else {
	                    vm.$message('您未登录,请刷新');
	                }
	            } else {
	                if (code == 404) {
	                    vm.$notify({
	                        title: '提示',
	                        message: '404:Not found!',
	                        type: 'error'
	                    });
	                } else {
	                    vm.$notify({
	                        title: '提示',
	                        message: '501:服务端未响应!',
	                        type: 'error'
	                    });
	                }
	            }
	        } else {
	            vm.$notify({
	                title: '提示',
	                message: '502:服务端未响应!',
	                type: 'error'
	
	            });
	        }
	    }), _methods),
	    data: function data() {
	        return {
	            userCertApply: {
	                mis_id: '',
	                device_id: ''
	            },
	            checkNull: {
	                mis_id: [{ required: true, message: 'MIS账号不能为空', trigger: 'blur' }, {
	                    min: 1,
	                    max: 50,
	                    message: '长度在 50 个字以内',
	                    trigger: 'blur'
	                }],
	                device_id: [{ required: true, message: '申请原因不能为空', trigger: 'blur' }, {
	                    min: 1,
	                    max: 1000,
	                    message: '长度在 200 个字以内',
	                    trigger: 'blur'
	                }]
	            }
	        };
	    }
	};

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(83);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _store = __webpack_require__(11);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  store: _store2.default,
	  mounted: function mounted() {
	    var vm = this;
	    if (vm.token == "") {
	      var token = this.getCookie("access-token");
	      if (token != null) {
	        vm.$store.commit('UPDATETOKEN', token);
	        vm.token = token;
	      }
	    }
	    vm.getUser();
	  },
	  computed: (0, _vuex.mapState)({
	    loginRediret: function loginRediret(state) {
	      return state.loginRediret;
	    },
	    cookieName: function cookieName(state) {
	      return state.cookieName;
	    },
	    addWhiteListAPI: function addWhiteListAPI(state) {
	      return state.addWhiteListAPI;
	    },
	    getuserAPI: function getuserAPI(state) {
	      return state.getuserAPI;
	    }
	  }),
	  methods: {
	    getCookie: function getCookie(name) {
	      var arr,
	          reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
	      if (arr = document.cookie.match(reg)) return unescape(arr[2]);else return null;
	    },
	    commitMisApply: function commitMisApply(doc) {
	      var vm = this;
	      if (doc.misId == null || doc.misId == "") {
	        alert("Mis账号不能为空 ( Mis cannot be empty )");
	        return;
	      }
	      if (doc.scene == 2 && doc.dateLine == null) {
	        alert("加白到期时间不能为空 ( The expiration date for the whitelist cannot be empty )");
	        return;
	      }
	      if (doc.deviceOsList.length == 0) {
	        alert("操作系统不能为空 ( The system cannot be empty )");
	        return;
	      }
	      if (doc.items.length == 0) {
	        alert("加白项目不能为空 ( The whitelist program cannot be empty )");
	        return;
	      }
	      if (doc.reason == null || doc.reason.trim() == "") {
	        alert("原因不能为空 ( The reason cannot be empty )");
	        return;
	      }
	      var param = (0, _extends3.default)({}, doc, {
	        deviceOsList: doc.deviceOsList.join(';'),
	        items: doc.items.join(';')
	      });
	      _axios2.default.post(vm.addWhiteListAPI, param, {
	        withCredentials: true
	      }).then(function (response) {
	        var status = response.data.code;
	        var message = response.data.message;
	
	        if (status === 0) {
	          var link = message;
	          var successMessage = '\n            <div style="text-align: left; line-height: 1.8; font-size: 14px;">\n              <div style="margin-bottom: 10px; font-weight: 600;"> \u63D0\u4EA4\u6210\u529F / Submitted successfully </div>\n              <div style="margin-bottom: 10px;"> \u5BA1\u6279\u8BE6\u60C5 / Approval details\uFF1A</div>\n              <div style="margin-bottom: 10px;"><a href="' + link + '" target="_blank" style="color: #409EFF; text-decoration: underline; cursor: pointer;">' + link + '</a></div>\n              <div> \u82E5\u65E0\u6CD5\u8BBF\u95EE\uFF0C\u8BF7\u5728\u624B\u673A\u5927\u8C61\u67E5\u770B / If inaccessible, check in DaXiang app. </div>\n            </div>\n          ';
	          vm.$alert(successMessage, '提示', {
	            dangerouslyUseHTMLString: true,
	            confirmButtonText: '确定',
	            callback: function callback() {
	              vm.moaAccessWhiteApply.scene = 1;
	              vm.moaAccessWhiteApply.dateLine = null;
	              vm.moaAccessWhiteApply.deviceOsList = [];
	              vm.moaAccessWhiteApply.items = [];
	              vm.moaAccessWhiteApply.reason = '';
	            }
	          });
	        } else {
	          var urlRegex = /(https?:\/\/[^\s<>]+)/g;
	          var displayMessage = message.replace(/\n/g, '<br/>').replace(urlRegex, function (url) {
	            return '<a href="' + url + '" target="_blank" style="color: #409EFF; text-decoration: underline; cursor: pointer;">' + url + '</a>';
	          });
	          var errorMessage = '<div style="text-align: left; line-height: 1.8; font-size: 14px;">' + displayMessage + '</div>';
	          vm.$alert(errorMessage, '提示', {
	            dangerouslyUseHTMLString: true,
	            confirmButtonText: '确定',
	            callback: function callback() {
	              vm.moaAccessWhiteApply.scene = 1;
	              vm.moaAccessWhiteApply.dateLine = null;
	              vm.moaAccessWhiteApply.deviceOsList = [];
	              vm.moaAccessWhiteApply.items = [];
	              vm.moaAccessWhiteApply.reason = '';
	            }
	          });
	        }
	      }).catch(function (error) {
	        vm.requesterrorinfo(error);
	      });
	    },
	    getUser: function getUser() {
	      var vm = this;
	      if (vm.user == null || vm.user == "") {
	        vm.user = vm.getCookie("username");
	        document.cookie = "ssoid=" + vm.getCookie("access-token");
	        _axios2.default.get(vm.getuserAPI, {
	          withCredentials: true
	        }).then(function (response) {
	          if (response.data.status == 401) {
	            document.cookie = vm.cookieName + vm.$route.fullPath;
	            window.location = vm.loginRediret;
	          } else {
	            vm.moaAccessWhiteApply.misId = response.data.data.login;
	            if (vm.moaAccessWhiteApply.misId == null) {
	              vm.moaAccessWhiteApply.misId = vm.getCookie("username");
	            }
	            if (vm.moaAccessWhiteApply.misId == null) {
	              vm.moaAccessWhiteApply.misId = vm.getCookie("user").login;
	            }
	          }
	        }).catch(function (error) {
	          vm.requesterrorinfo(error);
	        });
	      }
	    },
	    requesterrorinfo: function requesterrorinfo(error) {
	      var vm = this;
	      if (error.response) {
	        var code = error.response.status;
	        if (code == 401) {
	          vm.$message.error("401:您未登录");
	          var count = vm.getCookie("access-count");
	          window.location = vm.loginRediret;
	          if (count == null || count == 0) {
	            document.cookie = "access-count=1";
	            vm.$message('您未登录,请刷新');
	            document.cookie = vm.cookieName + vm.$route.fullPath;
	            window.location = vm.loginRediret;
	          } else {
	            vm.$message('您未登录,请刷新');
	          }
	        } else {
	          if (code == 404) {
	            vm.$notify({
	              title: '提示',
	              message: '404:Not found!',
	              type: 'error'
	            });
	          } else {
	            vm.$notify({
	              title: '提示',
	              message: '501:服务端未响应!',
	              type: 'error'
	            });
	          }
	        }
	      } else {
	        vm.$notify({
	          title: '提示',
	          message: '502:服务端未响应!',
	          type: 'error'
	
	        });
	      }
	    }
	  },
	  data: function data() {
	    return {
	      token: '',
	      dateLineOptions: {
	        disabledDate: function disabledDate(date) {
	          var today = new Date();
	          today.setHours(0, 0, 0, 0);
	          return date && date.getTime() < today.getTime();
	        }
	      },
	      moaAccessWhiteApply: {
	        misId: '',
	        dateLine: null,
	        scene: 1,
	        deviceOsList: [],
	        items: [],
	        reason: ''
	      },
	      checkNull: {
	        misId: [{ required: true, message: 'MIS账号不能为空', trigger: 'blur' }, {
	          min: 1,
	          max: 50,
	          message: '长度在 50 个字以内',
	          trigger: 'blur'
	        }],
	
	        reason: [{ required: true, message: '申请原因不能为空', trigger: 'blur' }, {
	          min: 1,
	          max: 1000,
	          message: '长度在 200 个字以内',
	          trigger: 'blur'
	        }]
	      }
	    };
	  }
	};

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(11);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _axios = __webpack_require__(5);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _vuex = __webpack_require__(3);
	
	var _commonUtil = __webpack_require__(18);
	
	var _commonUtil2 = _interopRequireDefault(_commonUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  store: _store2.default,
	  mounted: function mounted() {
	    var vm = this;
	    if (vm.token == "") {
	      var token = this.getCookie("access-token");
	      if (token != null) {
	        vm.$store.commit('UPDATETOKEN', token);
	        vm.token = token;
	      }
	    }
	    vm.getUser();
	  },
	  computed: (0, _vuex.mapState)({
	    loginRediret: function loginRediret(state) {
	      return state.loginRediret;
	    },
	    cookieName: function cookieName(state) {
	      return state.cookieName;
	    },
	    getuserAPI: function getuserAPI(state) {
	      return state.getuserAPI;
	    }
	  }),
	  filters: {
	    idcExplain: function idcExplain(val) {
	      return _commonUtil2.default.idcExplain(val);
	    },
	    timeFormat: function timeFormat(val) {
	      return _commonUtil2.default.timeFormat(val);
	    },
	    switchColor: function switchColor(val) {
	      return _commonUtil2.default.switchColor(val);
	    },
	    statusExplain: function statusExplain(val) {
	      return _commonUtil2.default.statusExplain(val);
	    }
	  },
	  methods: {
	    reset: function reset() {},
	    kmUrl: function kmUrl(URL) {
	      window.open(URL);
	    },
	    routerUrl: function routerUrl(URL) {
	      this.$router.push(URL);
	    },
	    handleSelectionChange: function handleSelectionChange(val) {
	      this.multipleSelection = val;
	    },
	    getCookie: function getCookie(name) {
	      var arr,
	          reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
	      if (arr = document.cookie.match(reg)) return unescape(arr[2]);else return null;
	    },
	    getUser: function getUser() {
	      var vm = this;
	      if (vm.user == null || vm.user == "") {
	        vm.user = vm.getCookie("username");
	        document.cookie = "ssoid=" + vm.getCookie("access-token");
	        _axios2.default.get(vm.getuserAPI, {
	          withCredentials: true
	        }).then(function (response) {
	          if (response.data.status == 401) {
	            document.cookie = vm.cookieName + vm.$route.fullPath;
	            window.location = vm.loginRediret;
	          }
	        }).catch(function (error) {
	          vm.requesterrorinfo(error);
	        });
	      }
	    },
	    requesterrorinfo: function requesterrorinfo(error) {
	      var vm = this;
	      if (error.response) {
	        var code = error.response.status;
	        if (code == 401) {
	          vm.$message.error("401:您未登录");
	          var count = vm.getCookie("access-count");
	          window.location = vm.loginRediret;
	          if (count == null || count == 0) {
	            document.cookie = "access-count=1";
	            vm.$message('您未登录,请刷新');
	            document.cookie = vm.cookieName + vm.$route.fullPath;
	            window.location = vm.loginRediret;
	          } else {
	            vm.$message('您未登录,请刷新');
	          }
	        } else {
	          if (code == 404) {
	            vm.$notify({
	              title: '提示',
	              message: '404:Not found!',
	              type: 'error'
	            });
	          } else {
	            vm.$notify({
	              title: '提示',
	              message: '501:服务端未响应!',
	              type: 'error'
	            });
	          }
	        }
	      } else {
	        vm.$notify({
	          title: '提示',
	          message: '502:服务端未响应!',
	          type: 'error'
	
	        });
	      }
	    }
	  },
	  data: function data() {
	    return {
	      hostname: '',
	      token: ''
	    };
	  }
	};

/***/ }),
/* 275 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = {
	    serverHost: "https://agentrepair-itsec.meituan.com",
	    agentServerHost: "https://securityagent.sankuai.com",
	
	    loginRedirect: "https://ssosv.sankuai.com/sson/login?redirect_uri=https%3A%2F%2Fagent-repair-prompt.sankuai.com%2F%23%2Fcallback&client_id=2c4ad23224",
	    logoutRedirect: "https://ssosv.sankuai.com/sson/logout?redirect_uri=https%3A%2F%2Fagent-repair-prompt.sankuai.com&client_id=2c4ad23224"
	};

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _SSOUtil = __webpack_require__(99);
	
	module.exports = function (result) {
	    if (result['status'] === 401) {
	        _SSOUtil.sso.logout();
	    }
	};

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(316), __esModule: true };

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(332), __esModule: true };

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	// This method of obtaining a reference to the global object needs to be
	// kept identical to the way it is obtained in runtime.js
	var g = (function() { return this })() || Function("return this")();
	
	// Use `getOwnPropertyNames` because not all browsers support calling
	// `hasOwnProperty` on the global `self` object in a worker. See #183.
	var hadRuntime = g.regeneratorRuntime &&
	  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;
	
	// Save the old regeneratorRuntime in case it needs to be restored later.
	var oldRuntime = hadRuntime && g.regeneratorRuntime;
	
	// Force reevalutation of runtime.js.
	g.regeneratorRuntime = undefined;
	
	module.exports = __webpack_require__(280);
	
	if (hadRuntime) {
	  // Restore the original runtime.
	  g.regeneratorRuntime = oldRuntime;
	} else {
	  // Remove the global property added by runtime.js.
	  try {
	    delete g.regeneratorRuntime;
	  } catch(e) {
	    g.regeneratorRuntime = undefined;
	  }
	}


/***/ }),
/* 280 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // In sloppy mode, unbound `this` refers to the global object, fallback to
	  // Function constructor if we're in global strict mode. That is sadly a form
	  // of indirect eval which violates Content Security Policy.
	  (function() { return this })() || Function("return this")()
	);


/***/ }),
/* 281 */
/***/ (function(module, exports) {

	'use strict';
	module.exports = balanced;
	function balanced(a, b, str) {
	  if (a instanceof RegExp) a = maybeMatch(a, str);
	  if (b instanceof RegExp) b = maybeMatch(b, str);
	
	  var r = range(a, b, str);
	
	  return r && {
	    start: r[0],
	    end: r[1],
	    pre: str.slice(0, r[0]),
	    body: str.slice(r[0] + a.length, r[1]),
	    post: str.slice(r[1] + b.length)
	  };
	}
	
	function maybeMatch(reg, str) {
	  var m = str.match(reg);
	  return m ? m[0] : null;
	}
	
	balanced.range = range;
	function range(a, b, str) {
	  var begs, beg, left, right, result;
	  var ai = str.indexOf(a);
	  var bi = str.indexOf(b, ai + 1);
	  var i = ai;
	
	  if (ai >= 0 && bi > 0) {
	    begs = [];
	    left = str.length;
	
	    while (i >= 0 && !result) {
	      if (i == ai) {
	        begs.push(i);
	        ai = str.indexOf(a, i + 1);
	      } else if (begs.length == 1) {
	        result = [ begs.pop(), bi ];
	      } else {
	        beg = begs.pop();
	        if (beg < left) {
	          left = beg;
	          right = bi;
	        }
	
	        bi = str.indexOf(b, i + 1);
	      }
	
	      i = ai < bi && ai >= 0 ? ai : bi;
	    }
	
	    if (begs.length) {
	      result = [ left, right ];
	    }
	  }
	
	  return result;
	}


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	var concatMap = __webpack_require__(313);
	var balanced = __webpack_require__(281);
	
	module.exports = expandTop;
	
	var escSlash = '\0SLASH'+Math.random()+'\0';
	var escOpen = '\0OPEN'+Math.random()+'\0';
	var escClose = '\0CLOSE'+Math.random()+'\0';
	var escComma = '\0COMMA'+Math.random()+'\0';
	var escPeriod = '\0PERIOD'+Math.random()+'\0';
	
	function numeric(str) {
	  return parseInt(str, 10) == str
	    ? parseInt(str, 10)
	    : str.charCodeAt(0);
	}
	
	function escapeBraces(str) {
	  return str.split('\\\\').join(escSlash)
	            .split('\\{').join(escOpen)
	            .split('\\}').join(escClose)
	            .split('\\,').join(escComma)
	            .split('\\.').join(escPeriod);
	}
	
	function unescapeBraces(str) {
	  return str.split(escSlash).join('\\')
	            .split(escOpen).join('{')
	            .split(escClose).join('}')
	            .split(escComma).join(',')
	            .split(escPeriod).join('.');
	}
	
	
	// Basically just str.split(","), but handling cases
	// where we have nested braced sections, which should be
	// treated as individual members, like {a,{b,c},d}
	function parseCommaParts(str) {
	  if (!str)
	    return [''];
	
	  var parts = [];
	  var m = balanced('{', '}', str);
	
	  if (!m)
	    return str.split(',');
	
	  var pre = m.pre;
	  var body = m.body;
	  var post = m.post;
	  var p = pre.split(',');
	
	  p[p.length-1] += '{' + body + '}';
	  var postParts = parseCommaParts(post);
	  if (post.length) {
	    p[p.length-1] += postParts.shift();
	    p.push.apply(p, postParts);
	  }
	
	  parts.push.apply(parts, p);
	
	  return parts;
	}
	
	function expandTop(str) {
	  if (!str)
	    return [];
	
	  // I don't know why Bash 4.3 does this, but it does.
	  // Anything starting with {} will have the first two bytes preserved
	  // but *only* at the top level, so {},a}b will not expand to anything,
	  // but a{},b}c will be expanded to [a}c,abc].
	  // One could argue that this is a bug in Bash, but since the goal of
	  // this module is to match Bash's rules, we escape a leading {}
	  if (str.substr(0, 2) === '{}') {
	    str = '\\{\\}' + str.substr(2);
	  }
	
	  return expand(escapeBraces(str), true).map(unescapeBraces);
	}
	
	function identity(e) {
	  return e;
	}
	
	function embrace(str) {
	  return '{' + str + '}';
	}
	function isPadded(el) {
	  return /^-?0\d/.test(el);
	}
	
	function lte(i, y) {
	  return i <= y;
	}
	function gte(i, y) {
	  return i >= y;
	}
	
	function expand(str, isTop) {
	  var expansions = [];
	
	  var m = balanced('{', '}', str);
	  if (!m || /\$$/.test(m.pre)) return [str];
	
	  var isNumericSequence = /^-?\d+\.\.-?\d+(?:\.\.-?\d+)?$/.test(m.body);
	  var isAlphaSequence = /^[a-zA-Z]\.\.[a-zA-Z](?:\.\.-?\d+)?$/.test(m.body);
	  var isSequence = isNumericSequence || isAlphaSequence;
	  var isOptions = m.body.indexOf(',') >= 0;
	  if (!isSequence && !isOptions) {
	    // {a},b}
	    if (m.post.match(/,.*\}/)) {
	      str = m.pre + '{' + m.body + escClose + m.post;
	      return expand(str);
	    }
	    return [str];
	  }
	
	  var n;
	  if (isSequence) {
	    n = m.body.split(/\.\./);
	  } else {
	    n = parseCommaParts(m.body);
	    if (n.length === 1) {
	      // x{{a,b}}y ==> x{a}y x{b}y
	      n = expand(n[0], false).map(embrace);
	      if (n.length === 1) {
	        var post = m.post.length
	          ? expand(m.post, false)
	          : [''];
	        return post.map(function(p) {
	          return m.pre + n[0] + p;
	        });
	      }
	    }
	  }
	
	  // at this point, n is the parts, and we know it's not a comma set
	  // with a single entry.
	
	  // no need to expand pre, since it is guaranteed to be free of brace-sets
	  var pre = m.pre;
	  var post = m.post.length
	    ? expand(m.post, false)
	    : [''];
	
	  var N;
	
	  if (isSequence) {
	    var x = numeric(n[0]);
	    var y = numeric(n[1]);
	    var width = Math.max(n[0].length, n[1].length)
	    var incr = n.length == 3
	      ? Math.abs(numeric(n[2]))
	      : 1;
	    var test = lte;
	    var reverse = y < x;
	    if (reverse) {
	      incr *= -1;
	      test = gte;
	    }
	    var pad = n.some(isPadded);
	
	    N = [];
	
	    for (var i = x; test(i, y); i += incr) {
	      var c;
	      if (isAlphaSequence) {
	        c = String.fromCharCode(i);
	        if (c === '\\')
	          c = '';
	      } else {
	        c = String(i);
	        if (pad) {
	          var need = width - c.length;
	          if (need > 0) {
	            var z = new Array(need + 1).join('0');
	            if (i < 0)
	              c = '-' + z + c.slice(1);
	            else
	              c = z + c;
	          }
	        }
	      }
	      N.push(c);
	    }
	  } else {
	    N = concatMap(n, function(el) { return expand(el, false) });
	  }
	
	  for (var j = 0; j < N.length; j++) {
	    for (var k = 0; k < post.length; k++) {
	      var expansion = pre + N[j] + post[k];
	      if (!isTop || isSequence || expansion)
	        expansions.push(expansion);
	    }
	  }
	
	  return expansions;
	}
	


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(1));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  var ie_lt8 = /MSIE \d/.test(navigator.userAgent) &&
	    (document.documentMode == null || document.documentMode < 8);
	
	  var Pos = CodeMirror.Pos;
	
	  var matching = {"(": ")>", ")": "(<", "[": "]>", "]": "[<", "{": "}>", "}": "{<", "<": ">>", ">": "<<"};
	
	  function bracketRegex(config) {
	    return config && config.bracketRegex || /[(){}[\]]/
	  }
	
	  function findMatchingBracket(cm, where, config) {
	    var line = cm.getLineHandle(where.line), pos = where.ch - 1;
	    var afterCursor = config && config.afterCursor
	    if (afterCursor == null)
	      afterCursor = /(^| )cm-fat-cursor($| )/.test(cm.getWrapperElement().className)
	    var re = bracketRegex(config)
	
	    // A cursor is defined as between two characters, but in in vim command mode
	    // (i.e. not insert mode), the cursor is visually represented as a
	    // highlighted box on top of the 2nd character. Otherwise, we allow matches
	    // from before or after the cursor.
	    var match = (!afterCursor && pos >= 0 && re.test(line.text.charAt(pos)) && matching[line.text.charAt(pos)]) ||
	        re.test(line.text.charAt(pos + 1)) && matching[line.text.charAt(++pos)];
	    if (!match) return null;
	    var dir = match.charAt(1) == ">" ? 1 : -1;
	    if (config && config.strict && (dir > 0) != (pos == where.ch)) return null;
	    var style = cm.getTokenTypeAt(Pos(where.line, pos + 1));
	
	    var found = scanForBracket(cm, Pos(where.line, pos + (dir > 0 ? 1 : 0)), dir, style || null, config);
	    if (found == null) return null;
	    return {from: Pos(where.line, pos), to: found && found.pos,
	            match: found && found.ch == match.charAt(0), forward: dir > 0};
	  }
	
	  // bracketRegex is used to specify which type of bracket to scan
	  // should be a regexp, e.g. /[[\]]/
	  //
	  // Note: If "where" is on an open bracket, then this bracket is ignored.
	  //
	  // Returns false when no bracket was found, null when it reached
	  // maxScanLines and gave up
	  function scanForBracket(cm, where, dir, style, config) {
	    var maxScanLen = (config && config.maxScanLineLength) || 10000;
	    var maxScanLines = (config && config.maxScanLines) || 1000;
	
	    var stack = [];
	    var re = bracketRegex(config)
	    var lineEnd = dir > 0 ? Math.min(where.line + maxScanLines, cm.lastLine() + 1)
	                          : Math.max(cm.firstLine() - 1, where.line - maxScanLines);
	    for (var lineNo = where.line; lineNo != lineEnd; lineNo += dir) {
	      var line = cm.getLine(lineNo);
	      if (!line) continue;
	      var pos = dir > 0 ? 0 : line.length - 1, end = dir > 0 ? line.length : -1;
	      if (line.length > maxScanLen) continue;
	      if (lineNo == where.line) pos = where.ch - (dir < 0 ? 1 : 0);
	      for (; pos != end; pos += dir) {
	        var ch = line.charAt(pos);
	        if (re.test(ch) && (style === undefined || cm.getTokenTypeAt(Pos(lineNo, pos + 1)) == style)) {
	          var match = matching[ch];
	          if (match && (match.charAt(1) == ">") == (dir > 0)) stack.push(ch);
	          else if (!stack.length) return {pos: Pos(lineNo, pos), ch: ch};
	          else stack.pop();
	        }
	      }
	    }
	    return lineNo - dir == (dir > 0 ? cm.lastLine() : cm.firstLine()) ? false : null;
	  }
	
	  function matchBrackets(cm, autoclear, config) {
	    // Disable brace matching in long lines, since it'll cause hugely slow updates
	    var maxHighlightLen = cm.state.matchBrackets.maxHighlightLineLength || 1000;
	    var marks = [], ranges = cm.listSelections();
	    for (var i = 0; i < ranges.length; i++) {
	      var match = ranges[i].empty() && findMatchingBracket(cm, ranges[i].head, config);
	      if (match && cm.getLine(match.from.line).length <= maxHighlightLen) {
	        var style = match.match ? "CodeMirror-matchingbracket" : "CodeMirror-nonmatchingbracket";
	        marks.push(cm.markText(match.from, Pos(match.from.line, match.from.ch + 1), {className: style}));
	        if (match.to && cm.getLine(match.to.line).length <= maxHighlightLen)
	          marks.push(cm.markText(match.to, Pos(match.to.line, match.to.ch + 1), {className: style}));
	      }
	    }
	
	    if (marks.length) {
	      // Kludge to work around the IE bug from issue #1193, where text
	      // input stops going to the textare whever this fires.
	      if (ie_lt8 && cm.state.focused) cm.focus();
	
	      var clear = function() {
	        cm.operation(function() {
	          for (var i = 0; i < marks.length; i++) marks[i].clear();
	        });
	      };
	      if (autoclear) setTimeout(clear, 800);
	      else return clear;
	    }
	  }
	
	  function doMatchBrackets(cm) {
	    cm.operation(function() {
	      if (cm.state.matchBrackets.currentlyHighlighted) {
	        cm.state.matchBrackets.currentlyHighlighted();
	        cm.state.matchBrackets.currentlyHighlighted = null;
	      }
	      cm.state.matchBrackets.currentlyHighlighted = matchBrackets(cm, false, cm.state.matchBrackets);
	    });
	  }
	
	  CodeMirror.defineOption("matchBrackets", false, function(cm, val, old) {
	    if (old && old != CodeMirror.Init) {
	      cm.off("cursorActivity", doMatchBrackets);
	      if (cm.state.matchBrackets && cm.state.matchBrackets.currentlyHighlighted) {
	        cm.state.matchBrackets.currentlyHighlighted();
	        cm.state.matchBrackets.currentlyHighlighted = null;
	      }
	    }
	    if (val) {
	      cm.state.matchBrackets = typeof val == "object" ? val : {};
	      cm.on("cursorActivity", doMatchBrackets);
	    }
	  });
	
	  CodeMirror.defineExtension("matchBrackets", function() {matchBrackets(this, true);});
	  CodeMirror.defineExtension("findMatchingBracket", function(pos, config, oldConfig){
	    // Backwards-compatibility kludge
	    if (oldConfig || typeof config == "boolean") {
	      if (!oldConfig) {
	        config = config ? {strict: true} : null
	      } else {
	        oldConfig.strict = config
	        config = oldConfig
	      }
	    }
	    return findMatchingBracket(this, pos, config)
	  });
	  CodeMirror.defineExtension("scanForBracket", function(pos, dir, style, config){
	    return scanForBracket(this, pos, dir, style, config);
	  });
	});


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(1));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.multiplexingMode = function(outer /*, others */) {
	  // Others should be {open, close, mode [, delimStyle] [, innerStyle]} objects
	  var others = Array.prototype.slice.call(arguments, 1);
	
	  function indexOf(string, pattern, from, returnEnd) {
	    if (typeof pattern == "string") {
	      var found = string.indexOf(pattern, from);
	      return returnEnd && found > -1 ? found + pattern.length : found;
	    }
	    var m = pattern.exec(from ? string.slice(from) : string);
	    return m ? m.index + from + (returnEnd ? m[0].length : 0) : -1;
	  }
	
	  return {
	    startState: function() {
	      return {
	        outer: CodeMirror.startState(outer),
	        innerActive: null,
	        inner: null
	      };
	    },
	
	    copyState: function(state) {
	      return {
	        outer: CodeMirror.copyState(outer, state.outer),
	        innerActive: state.innerActive,
	        inner: state.innerActive && CodeMirror.copyState(state.innerActive.mode, state.inner)
	      };
	    },
	
	    token: function(stream, state) {
	      if (!state.innerActive) {
	        var cutOff = Infinity, oldContent = stream.string;
	        for (var i = 0; i < others.length; ++i) {
	          var other = others[i];
	          var found = indexOf(oldContent, other.open, stream.pos);
	          if (found == stream.pos) {
	            if (!other.parseDelimiters) stream.match(other.open);
	            state.innerActive = other;
	
	            // Get the outer indent, making sure to handle CodeMirror.Pass
	            var outerIndent = 0;
	            if (outer.indent) {
	              var possibleOuterIndent = outer.indent(state.outer, "", "");
	              if (possibleOuterIndent !== CodeMirror.Pass) outerIndent = possibleOuterIndent;
	            }
	
	            state.inner = CodeMirror.startState(other.mode, outerIndent);
	            return other.delimStyle && (other.delimStyle + " " + other.delimStyle + "-open");
	          } else if (found != -1 && found < cutOff) {
	            cutOff = found;
	          }
	        }
	        if (cutOff != Infinity) stream.string = oldContent.slice(0, cutOff);
	        var outerToken = outer.token(stream, state.outer);
	        if (cutOff != Infinity) stream.string = oldContent;
	        return outerToken;
	      } else {
	        var curInner = state.innerActive, oldContent = stream.string;
	        if (!curInner.close && stream.sol()) {
	          state.innerActive = state.inner = null;
	          return this.token(stream, state);
	        }
	        var found = curInner.close ? indexOf(oldContent, curInner.close, stream.pos, curInner.parseDelimiters) : -1;
	        if (found == stream.pos && !curInner.parseDelimiters) {
	          stream.match(curInner.close);
	          state.innerActive = state.inner = null;
	          return curInner.delimStyle && (curInner.delimStyle + " " + curInner.delimStyle + "-close");
	        }
	        if (found > -1) stream.string = oldContent.slice(0, found);
	        var innerToken = curInner.mode.token(stream, state.inner);
	        if (found > -1) stream.string = oldContent;
	
	        if (found == stream.pos && curInner.parseDelimiters)
	          state.innerActive = state.inner = null;
	
	        if (curInner.innerStyle) {
	          if (innerToken) innerToken = innerToken + " " + curInner.innerStyle;
	          else innerToken = curInner.innerStyle;
	        }
	
	        return innerToken;
	      }
	    },
	
	    indent: function(state, textAfter, line) {
	      var mode = state.innerActive ? state.innerActive.mode : outer;
	      if (!mode.indent) return CodeMirror.Pass;
	      return mode.indent(state.innerActive ? state.inner : state.outer, textAfter, line);
	    },
	
	    blankLine: function(state) {
	      var mode = state.innerActive ? state.innerActive.mode : outer;
	      if (mode.blankLine) {
	        mode.blankLine(state.innerActive ? state.inner : state.outer);
	      }
	      if (!state.innerActive) {
	        for (var i = 0; i < others.length; ++i) {
	          var other = others[i];
	          if (other.open === "\n") {
	            state.innerActive = other;
	            state.inner = CodeMirror.startState(other.mode, mode.indent ? mode.indent(state.outer, "", "") : 0);
	          }
	        }
	      } else if (state.innerActive.close === "\n") {
	        state.innerActive = state.inner = null;
	      }
	    },
	
	    electricChars: outer.electricChars,
	
	    innerMode: function(state) {
	      return state.inner ? {state: state.inner, mode: state.innerActive.mode} : {state: state.outer, mode: outer};
	    }
	  };
	};
	
	});


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/LICENSE
	
	// Utility function that allows modes to be combined. The mode given
	// as the base argument takes care of most of the normal mode
	// functionality, but a second (typically simple) mode is used, which
	// can override the style of text. Both modes get to parse all of the
	// text, but when both assign a non-null style to a piece of code, the
	// overlay wins, unless the combine argument was true and not overridden,
	// or state.overlay.combineTokens was true, in which case the styles are
	// combined.
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(1));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.overlayMode = function(base, overlay, combine) {
	  return {
	    startState: function() {
	      return {
	        base: CodeMirror.startState(base),
	        overlay: CodeMirror.startState(overlay),
	        basePos: 0, baseCur: null,
	        overlayPos: 0, overlayCur: null,
	        streamSeen: null
	      };
	    },
	    copyState: function(state) {
	      return {
	        base: CodeMirror.copyState(base, state.base),
	        overlay: CodeMirror.copyState(overlay, state.overlay),
	        basePos: state.basePos, baseCur: null,
	        overlayPos: state.overlayPos, overlayCur: null
	      };
	    },
	
	    token: function(stream, state) {
	      if (stream != state.streamSeen ||
	          Math.min(state.basePos, state.overlayPos) < stream.start) {
	        state.streamSeen = stream;
	        state.basePos = state.overlayPos = stream.start;
	      }
	
	      if (stream.start == state.basePos) {
	        state.baseCur = base.token(stream, state.base);
	        state.basePos = stream.pos;
	      }
	      if (stream.start == state.overlayPos) {
	        stream.pos = stream.start;
	        state.overlayCur = overlay.token(stream, state.overlay);
	        state.overlayPos = stream.pos;
	      }
	      stream.pos = Math.min(state.basePos, state.overlayPos);
	
	      // state.overlay.combineTokens always takes precedence over combine,
	      // unless set to null
	      if (state.overlayCur == null) return state.baseCur;
	      else if (state.baseCur != null &&
	               state.overlay.combineTokens ||
	               combine && state.overlay.combineTokens == null)
	        return state.baseCur + " " + state.overlayCur;
	      else return state.overlayCur;
	    },
	
	    indent: base.indent && function(state, textAfter, line) {
	      return base.indent(state.base, textAfter, line);
	    },
	    electricChars: base.electricChars,
	
	    innerMode: function(state) { return {state: state.base, mode: base}; },
	
	    blankLine: function(state) {
	      var baseToken, overlayToken;
	      if (base.blankLine) baseToken = base.blankLine(state.base);
	      if (overlay.blankLine) overlayToken = overlay.blankLine(state.overlay);
	
	      return overlayToken == null ?
	        baseToken :
	        (combine && baseToken != null ? baseToken + " " + overlayToken : overlayToken);
	    }
	  };
	};
	
	});


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(1));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  "use strict";
	
	  CodeMirror.defineSimpleMode = function(name, states) {
	    CodeMirror.defineMode(name, function(config) {
	      return CodeMirror.simpleMode(config, states);
	    });
	  };
	
	  CodeMirror.simpleMode = function(config, states) {
	    ensureState(states, "start");
	    var states_ = {}, meta = states.meta || {}, hasIndentation = false;
	    for (var state in states) if (state != meta && states.hasOwnProperty(state)) {
	      var list = states_[state] = [], orig = states[state];
	      for (var i = 0; i < orig.length; i++) {
	        var data = orig[i];
	        list.push(new Rule(data, states));
	        if (data.indent || data.dedent) hasIndentation = true;
	      }
	    }
	    var mode = {
	      startState: function() {
	        return {state: "start", pending: null,
	                local: null, localState: null,
	                indent: hasIndentation ? [] : null};
	      },
	      copyState: function(state) {
	        var s = {state: state.state, pending: state.pending,
	                 local: state.local, localState: null,
	                 indent: state.indent && state.indent.slice(0)};
	        if (state.localState)
	          s.localState = CodeMirror.copyState(state.local.mode, state.localState);
	        if (state.stack)
	          s.stack = state.stack.slice(0);
	        for (var pers = state.persistentStates; pers; pers = pers.next)
	          s.persistentStates = {mode: pers.mode,
	                                spec: pers.spec,
	                                state: pers.state == state.localState ? s.localState : CodeMirror.copyState(pers.mode, pers.state),
	                                next: s.persistentStates};
	        return s;
	      },
	      token: tokenFunction(states_, config),
	      innerMode: function(state) { return state.local && {mode: state.local.mode, state: state.localState}; },
	      indent: indentFunction(states_, meta)
	    };
	    if (meta) for (var prop in meta) if (meta.hasOwnProperty(prop))
	      mode[prop] = meta[prop];
	    return mode;
	  };
	
	  function ensureState(states, name) {
	    if (!states.hasOwnProperty(name))
	      throw new Error("Undefined state " + name + " in simple mode");
	  }
	
	  function toRegex(val, caret) {
	    if (!val) return /(?:)/;
	    var flags = "";
	    if (val instanceof RegExp) {
	      if (val.ignoreCase) flags = "i";
	      val = val.source;
	    } else {
	      val = String(val);
	    }
	    return new RegExp((caret === false ? "" : "^") + "(?:" + val + ")", flags);
	  }
	
	  function asToken(val) {
	    if (!val) return null;
	    if (val.apply) return val
	    if (typeof val == "string") return val.replace(/\./g, " ");
	    var result = [];
	    for (var i = 0; i < val.length; i++)
	      result.push(val[i] && val[i].replace(/\./g, " "));
	    return result;
	  }
	
	  function Rule(data, states) {
	    if (data.next || data.push) ensureState(states, data.next || data.push);
	    this.regex = toRegex(data.regex);
	    this.token = asToken(data.token);
	    this.data = data;
	  }
	
	  function tokenFunction(states, config) {
	    return function(stream, state) {
	      if (state.pending) {
	        var pend = state.pending.shift();
	        if (state.pending.length == 0) state.pending = null;
	        stream.pos += pend.text.length;
	        return pend.token;
	      }
	
	      if (state.local) {
	        if (state.local.end && stream.match(state.local.end)) {
	          var tok = state.local.endToken || null;
	          state.local = state.localState = null;
	          return tok;
	        } else {
	          var tok = state.local.mode.token(stream, state.localState), m;
	          if (state.local.endScan && (m = state.local.endScan.exec(stream.current())))
	            stream.pos = stream.start + m.index;
	          return tok;
	        }
	      }
	
	      var curState = states[state.state];
	      for (var i = 0; i < curState.length; i++) {
	        var rule = curState[i];
	        var matches = (!rule.data.sol || stream.sol()) && stream.match(rule.regex);
	        if (matches) {
	          if (rule.data.next) {
	            state.state = rule.data.next;
	          } else if (rule.data.push) {
	            (state.stack || (state.stack = [])).push(state.state);
	            state.state = rule.data.push;
	          } else if (rule.data.pop && state.stack && state.stack.length) {
	            state.state = state.stack.pop();
	          }
	
	          if (rule.data.mode)
	            enterLocalMode(config, state, rule.data.mode, rule.token);
	          if (rule.data.indent)
	            state.indent.push(stream.indentation() + config.indentUnit);
	          if (rule.data.dedent)
	            state.indent.pop();
	          var token = rule.token
	          if (token && token.apply) token = token(matches)
	          if (matches.length > 2 && rule.token && typeof rule.token != "string") {
	            state.pending = [];
	            for (var j = 2; j < matches.length; j++)
	              if (matches[j])
	                state.pending.push({text: matches[j], token: rule.token[j - 1]});
	            stream.backUp(matches[0].length - (matches[1] ? matches[1].length : 0));
	            return token[0];
	          } else if (token && token.join) {
	            return token[0];
	          } else {
	            return token;
	          }
	        }
	      }
	      stream.next();
	      return null;
	    };
	  }
	
	  function cmp(a, b) {
	    if (a === b) return true;
	    if (!a || typeof a != "object" || !b || typeof b != "object") return false;
	    var props = 0;
	    for (var prop in a) if (a.hasOwnProperty(prop)) {
	      if (!b.hasOwnProperty(prop) || !cmp(a[prop], b[prop])) return false;
	      props++;
	    }
	    for (var prop in b) if (b.hasOwnProperty(prop)) props--;
	    return props == 0;
	  }
	
	  function enterLocalMode(config, state, spec, token) {
	    var pers;
	    if (spec.persistent) for (var p = state.persistentStates; p && !pers; p = p.next)
	      if (spec.spec ? cmp(spec.spec, p.spec) : spec.mode == p.mode) pers = p;
	    var mode = pers ? pers.mode : spec.mode || CodeMirror.getMode(config, spec.spec);
	    var lState = pers ? pers.state : CodeMirror.startState(mode);
	    if (spec.persistent && !pers)
	      state.persistentStates = {mode: mode, spec: spec.spec, state: lState, next: state.persistentStates};
	
	    state.localState = lState;
	    state.local = {mode: mode,
	                   end: spec.end && toRegex(spec.end),
	                   endScan: spec.end && spec.forceEnd !== false && toRegex(spec.end, false),
	                   endToken: token && token.join ? token[token.length - 1] : token};
	  }
	
	  function indexOf(val, arr) {
	    for (var i = 0; i < arr.length; i++) if (arr[i] === val) return true;
	  }
	
	  function indentFunction(states, meta) {
	    return function(state, textAfter, line) {
	      if (state.local && state.local.mode.indent)
	        return state.local.mode.indent(state.localState, textAfter, line);
	      if (state.indent == null || state.local || meta.dontIndentStates && indexOf(state.state, meta.dontIndentStates) > -1)
	        return CodeMirror.Pass;
	
	      var pos = state.indent.length - 1, rules = states[state.state];
	      scan: for (;;) {
	        for (var i = 0; i < rules.length; i++) {
	          var rule = rules[i];
	          if (rule.data.dedent && rule.data.dedentIfLineStart !== false) {
	            var m = rule.regex.exec(textAfter);
	            if (m && m[0]) {
	              pos--;
	              if (rule.next || rule.push) rules = states[rule.next || rule.push];
	              textAfter = textAfter.slice(m[0].length);
	              continue scan;
	            }
	          }
	        }
	        break;
	      }
	      return pos < 0 ? 0 : state.indent[pos];
	    };
	  }
	});


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(1));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  "use strict";
	  var WRAP_CLASS = "CodeMirror-activeline";
	  var BACK_CLASS = "CodeMirror-activeline-background";
	  var GUTT_CLASS = "CodeMirror-activeline-gutter";
	
	  CodeMirror.defineOption("styleActiveLine", false, function(cm, val, old) {
	    var prev = old == CodeMirror.Init ? false : old;
	    if (val == prev) return
	    if (prev) {
	      cm.off("beforeSelectionChange", selectionChange);
	      clearActiveLines(cm);
	      delete cm.state.activeLines;
	    }
	    if (val) {
	      cm.state.activeLines = [];
	      updateActiveLines(cm, cm.listSelections());
	      cm.on("beforeSelectionChange", selectionChange);
	    }
	  });
	
	  function clearActiveLines(cm) {
	    for (var i = 0; i < cm.state.activeLines.length; i++) {
	      cm.removeLineClass(cm.state.activeLines[i], "wrap", WRAP_CLASS);
	      cm.removeLineClass(cm.state.activeLines[i], "background", BACK_CLASS);
	      cm.removeLineClass(cm.state.activeLines[i], "gutter", GUTT_CLASS);
	    }
	  }
	
	  function sameArray(a, b) {
	    if (a.length != b.length) return false;
	    for (var i = 0; i < a.length; i++)
	      if (a[i] != b[i]) return false;
	    return true;
	  }
	
	  function updateActiveLines(cm, ranges) {
	    var active = [];
	    for (var i = 0; i < ranges.length; i++) {
	      var range = ranges[i];
	      var option = cm.getOption("styleActiveLine");
	      if (typeof option == "object" && option.nonEmpty ? range.anchor.line != range.head.line : !range.empty())
	        continue
	      var line = cm.getLineHandleVisualStart(range.head.line);
	      if (active[active.length - 1] != line) active.push(line);
	    }
	    if (sameArray(cm.state.activeLines, active)) return;
	    cm.operation(function() {
	      clearActiveLines(cm);
	      for (var i = 0; i < active.length; i++) {
	        cm.addLineClass(active[i], "wrap", WRAP_CLASS);
	        cm.addLineClass(active[i], "background", BACK_CLASS);
	        cm.addLineClass(active[i], "gutter", GUTT_CLASS);
	      }
	      cm.state.activeLines = active;
	    });
	  }
	
	  function selectionChange(cm, sel) {
	    updateActiveLines(cm, sel.ranges);
	  }
	});


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/LICENSE
	
	/**
	 * Link to the project's GitHub page:
	 * https://github.com/pickhardt/coffeescript-codemirror-mode
	 */
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(1));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("coffeescript", function(conf, parserConf) {
	  var ERRORCLASS = "error";
	
	  function wordRegexp(words) {
	    return new RegExp("^((" + words.join(")|(") + "))\\b");
	  }
	
	  var operators = /^(?:->|=>|\+[+=]?|-[\-=]?|\*[\*=]?|\/[\/=]?|[=!]=|<[><]?=?|>>?=?|%=?|&=?|\|=?|\^=?|\~|!|\?|(or|and|\|\||&&|\?)=)/;
	  var delimiters = /^(?:[()\[\]{},:`=;]|\.\.?\.?)/;
	  var identifiers = /^[_A-Za-z$][_A-Za-z$0-9]*/;
	  var atProp = /^@[_A-Za-z$][_A-Za-z$0-9]*/;
	
	  var wordOperators = wordRegexp(["and", "or", "not",
	                                  "is", "isnt", "in",
	                                  "instanceof", "typeof"]);
	  var indentKeywords = ["for", "while", "loop", "if", "unless", "else",
	                        "switch", "try", "catch", "finally", "class"];
	  var commonKeywords = ["break", "by", "continue", "debugger", "delete",
	                        "do", "in", "of", "new", "return", "then",
	                        "this", "@", "throw", "when", "until", "extends"];
	
	  var keywords = wordRegexp(indentKeywords.concat(commonKeywords));
	
	  indentKeywords = wordRegexp(indentKeywords);
	
	
	  var stringPrefixes = /^('{3}|\"{3}|['\"])/;
	  var regexPrefixes = /^(\/{3}|\/)/;
	  var commonConstants = ["Infinity", "NaN", "undefined", "null", "true", "false", "on", "off", "yes", "no"];
	  var constants = wordRegexp(commonConstants);
	
	  // Tokenizers
	  function tokenBase(stream, state) {
	    // Handle scope changes
	    if (stream.sol()) {
	      if (state.scope.align === null) state.scope.align = false;
	      var scopeOffset = state.scope.offset;
	      if (stream.eatSpace()) {
	        var lineOffset = stream.indentation();
	        if (lineOffset > scopeOffset && state.scope.type == "coffee") {
	          return "indent";
	        } else if (lineOffset < scopeOffset) {
	          return "dedent";
	        }
	        return null;
	      } else {
	        if (scopeOffset > 0) {
	          dedent(stream, state);
	        }
	      }
	    }
	    if (stream.eatSpace()) {
	      return null;
	    }
	
	    var ch = stream.peek();
	
	    // Handle docco title comment (single line)
	    if (stream.match("####")) {
	      stream.skipToEnd();
	      return "comment";
	    }
	
	    // Handle multi line comments
	    if (stream.match("###")) {
	      state.tokenize = longComment;
	      return state.tokenize(stream, state);
	    }
	
	    // Single line comment
	    if (ch === "#") {
	      stream.skipToEnd();
	      return "comment";
	    }
	
	    // Handle number literals
	    if (stream.match(/^-?[0-9\.]/, false)) {
	      var floatLiteral = false;
	      // Floats
	      if (stream.match(/^-?\d*\.\d+(e[\+\-]?\d+)?/i)) {
	        floatLiteral = true;
	      }
	      if (stream.match(/^-?\d+\.\d*/)) {
	        floatLiteral = true;
	      }
	      if (stream.match(/^-?\.\d+/)) {
	        floatLiteral = true;
	      }
	
	      if (floatLiteral) {
	        // prevent from getting extra . on 1..
	        if (stream.peek() == "."){
	          stream.backUp(1);
	        }
	        return "number";
	      }
	      // Integers
	      var intLiteral = false;
	      // Hex
	      if (stream.match(/^-?0x[0-9a-f]+/i)) {
	        intLiteral = true;
	      }
	      // Decimal
	      if (stream.match(/^-?[1-9]\d*(e[\+\-]?\d+)?/)) {
	        intLiteral = true;
	      }
	      // Zero by itself with no other piece of number.
	      if (stream.match(/^-?0(?![\dx])/i)) {
	        intLiteral = true;
	      }
	      if (intLiteral) {
	        return "number";
	      }
	    }
	
	    // Handle strings
	    if (stream.match(stringPrefixes)) {
	      state.tokenize = tokenFactory(stream.current(), false, "string");
	      return state.tokenize(stream, state);
	    }
	    // Handle regex literals
	    if (stream.match(regexPrefixes)) {
	      if (stream.current() != "/" || stream.match(/^.*\//, false)) { // prevent highlight of division
	        state.tokenize = tokenFactory(stream.current(), true, "string-2");
	        return state.tokenize(stream, state);
	      } else {
	        stream.backUp(1);
	      }
	    }
	
	
	
	    // Handle operators and delimiters
	    if (stream.match(operators) || stream.match(wordOperators)) {
	      return "operator";
	    }
	    if (stream.match(delimiters)) {
	      return "punctuation";
	    }
	
	    if (stream.match(constants)) {
	      return "atom";
	    }
	
	    if (stream.match(atProp) || state.prop && stream.match(identifiers)) {
	      return "property";
	    }
	
	    if (stream.match(keywords)) {
	      return "keyword";
	    }
	
	    if (stream.match(identifiers)) {
	      return "variable";
	    }
	
	    // Handle non-detected items
	    stream.next();
	    return ERRORCLASS;
	  }
	
	  function tokenFactory(delimiter, singleline, outclass) {
	    return function(stream, state) {
	      while (!stream.eol()) {
	        stream.eatWhile(/[^'"\/\\]/);
	        if (stream.eat("\\")) {
	          stream.next();
	          if (singleline && stream.eol()) {
	            return outclass;
	          }
	        } else if (stream.match(delimiter)) {
	          state.tokenize = tokenBase;
	          return outclass;
	        } else {
	          stream.eat(/['"\/]/);
	        }
	      }
	      if (singleline) {
	        if (parserConf.singleLineStringErrors) {
	          outclass = ERRORCLASS;
	        } else {
	          state.tokenize = tokenBase;
	        }
	      }
	      return outclass;
	    };
	  }
	
	  function longComment(stream, state) {
	    while (!stream.eol()) {
	      stream.eatWhile(/[^#]/);
	      if (stream.match("###")) {
	        state.tokenize = tokenBase;
	        break;
	      }
	      stream.eatWhile("#");
	    }
	    return "comment";
	  }
	
	  function indent(stream, state, type) {
	    type = type || "coffee";
	    var offset = 0, align = false, alignOffset = null;
	    for (var scope = state.scope; scope; scope = scope.prev) {
	      if (scope.type === "coffee" || scope.type == "}") {
	        offset = scope.offset + conf.indentUnit;
	        break;
	      }
	    }
	    if (type !== "coffee") {
	      align = null;
	      alignOffset = stream.column() + stream.current().length;
	    } else if (state.scope.align) {
	      state.scope.align = false;
	    }
	    state.scope = {
	      offset: offset,
	      type: type,
	      prev: state.scope,
	      align: align,
	      alignOffset: alignOffset
	    };
	  }
	
	  function dedent(stream, state) {
	    if (!state.scope.prev) return;
	    if (state.scope.type === "coffee") {
	      var _indent = stream.indentation();
	      var matched = false;
	      for (var scope = state.scope; scope; scope = scope.prev) {
	        if (_indent === scope.offset) {
	          matched = true;
	          break;
	        }
	      }
	      if (!matched) {
	        return true;
	      }
	      while (state.scope.prev && state.scope.offset !== _indent) {
	        state.scope = state.scope.prev;
	      }
	      return false;
	    } else {
	      state.scope = state.scope.prev;
	      return false;
	    }
	  }
	
	  function tokenLexer(stream, state) {
	    var style = state.tokenize(stream, state);
	    var current = stream.current();
	
	    // Handle scope changes.
	    if (current === "return") {
	      state.dedent = true;
	    }
	    if (((current === "->" || current === "=>") && stream.eol())
	        || style === "indent") {
	      indent(stream, state);
	    }
	    var delimiter_index = "[({".indexOf(current);
	    if (delimiter_index !== -1) {
	      indent(stream, state, "])}".slice(delimiter_index, delimiter_index+1));
	    }
	    if (indentKeywords.exec(current)){
	      indent(stream, state);
	    }
	    if (current == "then"){
	      dedent(stream, state);
	    }
	
	
	    if (style === "dedent") {
	      if (dedent(stream, state)) {
	        return ERRORCLASS;
	      }
	    }
	    delimiter_index = "])}".indexOf(current);
	    if (delimiter_index !== -1) {
	      while (state.scope.type == "coffee" && state.scope.prev)
	        state.scope = state.scope.prev;
	      if (state.scope.type == current)
	        state.scope = state.scope.prev;
	    }
	    if (state.dedent && stream.eol()) {
	      if (state.scope.type == "coffee" && state.scope.prev)
	        state.scope = state.scope.prev;
	      state.dedent = false;
	    }
	
	    return style;
	  }
	
	  var external = {
	    startState: function(basecolumn) {
	      return {
	        tokenize: tokenBase,
	        scope: {offset:basecolumn || 0, type:"coffee", prev: null, align: false},
	        prop: false,
	        dedent: 0
	      };
	    },
	
	    token: function(stream, state) {
	      var fillAlign = state.scope.align === null && state.scope;
	      if (fillAlign && stream.sol()) fillAlign.align = false;
	
	      var style = tokenLexer(stream, state);
	      if (style && style != "comment") {
	        if (fillAlign) fillAlign.align = true;
	        state.prop = style == "punctuation" && stream.current() == "."
	      }
	
	      return style;
	    },
	
	    indent: function(state, text) {
	      if (state.tokenize != tokenBase) return 0;
	      var scope = state.scope;
	      var closer = text && "])}".indexOf(text.charAt(0)) > -1;
	      if (closer) while (scope.type == "coffee" && scope.prev) scope = scope.prev;
	      var closes = closer && scope.type === text.charAt(0);
	      if (scope.align)
	        return scope.alignOffset - (closes ? 1 : 0);
	      else
	        return (closes ? scope.prev : scope).offset;
	    },
	
	    lineComment: "#",
	    fold: "indent"
	  };
	  return external;
	});
	
	// IANA registered media type
	// https://www.iana.org/assignments/media-types/
	CodeMirror.defineMIME("application/vnd.coffeescript", "coffeescript");
	
	CodeMirror.defineMIME("text/x-coffeescript", "coffeescript");
	CodeMirror.defineMIME("text/coffeescript", "coffeescript");
	
	});


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(1), __webpack_require__(102));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror", "../clike/clike"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  "use strict";
	
	  var keywords = ("this super static final const abstract class extends external factory " +
	    "implements mixin get native set typedef with enum throw rethrow " +
	    "assert break case continue default in return new deferred async await covariant " +
	    "try catch finally do else for if switch while import library export " +
	    "part of show hide is as extension on yield").split(" ");
	  var blockKeywords = "try catch finally do else for if switch while".split(" ");
	  var atoms = "true false null".split(" ");
	  var builtins = "void bool num int double dynamic var String".split(" ");
	
	  function set(words) {
	    var obj = {};
	    for (var i = 0; i < words.length; ++i) obj[words[i]] = true;
	    return obj;
	  }
	
	  function pushInterpolationStack(state) {
	    (state.interpolationStack || (state.interpolationStack = [])).push(state.tokenize);
	  }
	
	  function popInterpolationStack(state) {
	    return (state.interpolationStack || (state.interpolationStack = [])).pop();
	  }
	
	  function sizeInterpolationStack(state) {
	    return state.interpolationStack ? state.interpolationStack.length : 0;
	  }
	
	  CodeMirror.defineMIME("application/dart", {
	    name: "clike",
	    keywords: set(keywords),
	    blockKeywords: set(blockKeywords),
	    builtin: set(builtins),
	    atoms: set(atoms),
	    hooks: {
	      "@": function(stream) {
	        stream.eatWhile(/[\w\$_\.]/);
	        return "meta";
	      },
	
	      // custom string handling to deal with triple-quoted strings and string interpolation
	      "'": function(stream, state) {
	        return tokenString("'", stream, state, false);
	      },
	      "\"": function(stream, state) {
	        return tokenString("\"", stream, state, false);
	      },
	      "r": function(stream, state) {
	        var peek = stream.peek();
	        if (peek == "'" || peek == "\"") {
	          return tokenString(stream.next(), stream, state, true);
	        }
	        return false;
	      },
	
	      "}": function(_stream, state) {
	        // "}" is end of interpolation, if interpolation stack is non-empty
	        if (sizeInterpolationStack(state) > 0) {
	          state.tokenize = popInterpolationStack(state);
	          return null;
	        }
	        return false;
	      },
	
	      "/": function(stream, state) {
	        if (!stream.eat("*")) return false
	        state.tokenize = tokenNestedComment(1)
	        return state.tokenize(stream, state)
	      },
	      token: function(stream, _, style) {
	        if (style == "variable") {
	          // Assume uppercase symbols are classes using variable-2
	          var isUpper = RegExp('^[_$]*[A-Z][a-zA-Z0-9_$]*$','g');
	          if (isUpper.test(stream.current())) {
	            return 'variable-2';
	          }
	        }
	      }
	    }
	  });
	
	  function tokenString(quote, stream, state, raw) {
	    var tripleQuoted = false;
	    if (stream.eat(quote)) {
	      if (stream.eat(quote)) tripleQuoted = true;
	      else return "string"; //empty string
	    }
	    function tokenStringHelper(stream, state) {
	      var escaped = false;
	      while (!stream.eol()) {
	        if (!raw && !escaped && stream.peek() == "$") {
	          pushInterpolationStack(state);
	          state.tokenize = tokenInterpolation;
	          return "string";
	        }
	        var next = stream.next();
	        if (next == quote && !escaped && (!tripleQuoted || stream.match(quote + quote))) {
	          state.tokenize = null;
	          break;
	        }
	        escaped = !raw && !escaped && next == "\\";
	      }
	      return "string";
	    }
	    state.tokenize = tokenStringHelper;
	    return tokenStringHelper(stream, state);
	  }
	
	  function tokenInterpolation(stream, state) {
	    stream.eat("$");
	    if (stream.eat("{")) {
	      // let clike handle the content of ${...},
	      // we take over again when "}" appears (see hooks).
	      state.tokenize = null;
	    } else {
	      state.tokenize = tokenInterpolationIdentifier;
	    }
	    return null;
	  }
	
	  function tokenInterpolationIdentifier(stream, state) {
	    stream.eatWhile(/[\w_]/);
	    state.tokenize = popInterpolationStack(state);
	    return "variable";
	  }
	
	  function tokenNestedComment(depth) {
	    return function (stream, state) {
	      var ch
	      while (ch = stream.next()) {
	        if (ch == "*" && stream.eat("/")) {
	          if (depth == 1) {
	            state.tokenize = null
	            break
	          } else {
	            state.tokenize = tokenNestedComment(depth - 1)
	            return state.tokenize(stream, state)
	          }
	        } else if (ch == "/" && stream.eat("*")) {
	          state.tokenize = tokenNestedComment(depth + 1)
	          return state.tokenize(stream, state)
	        }
	      }
	      return "comment"
	    }
	  }
	
	  CodeMirror.registerHelper("hintWords", "application/dart", keywords.concat(atoms).concat(builtins));
	
	  // This is needed to make loading through meta.js work.
	  CodeMirror.defineMode("dart", function(conf) {
	    return CodeMirror.getMode(conf, "application/dart");
	  }, "clike");
	});


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: http://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(1));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  "use strict";
	
	  CodeMirror.defineMode("elm", function() {
	
	    function switchState(source, setState, f)
	    {
	      setState(f);
	      return f(source, setState);
	    }
	
	    var lowerRE = /[a-z]/;
	    var upperRE = /[A-Z]/;
	    var innerRE = /[a-zA-Z0-9_]/;
	
	    var digitRE = /[0-9]/;
	    var hexRE = /[0-9A-Fa-f]/;
	    var symbolRE = /[-&*+.\\/<>=?^|:]/;
	    var specialRE = /[(),[\]{}]/;
	    var spacesRE = /[ \v\f]/; // newlines are handled in tokenizer
	
	    function normal()
	    {
	      return function(source, setState)
	      {
	        if (source.eatWhile(spacesRE))
	        {
	          return null;
	        }
	
	        var char = source.next();
	
	        if (specialRE.test(char))
	        {
	          return (char === '{' && source.eat('-'))
	            ? switchState(source, setState, chompMultiComment(1))
	            : (char === '[' && source.match('glsl|'))
	                ? switchState(source, setState, chompGlsl)
	                : 'builtin';
	        }
	
	        if (char === '\'')
	        {
	          return switchState(source, setState, chompChar);
	        }
	
	        if (char === '"')
	        {
	          return source.eat('"')
	            ? source.eat('"')
	                ? switchState(source, setState, chompMultiString)
	                : 'string'
	            : switchState(source, setState, chompSingleString);
	        }
	
	        if (upperRE.test(char))
	        {
	          source.eatWhile(innerRE);
	          return 'variable-2';
	        }
	
	        if (lowerRE.test(char))
	        {
	          var isDef = source.pos === 1;
	          source.eatWhile(innerRE);
	          return isDef ? "def" : "variable";
	        }
	
	        if (digitRE.test(char))
	        {
	          if (char === '0')
	          {
	            if (source.eat(/[xX]/))
	            {
	              source.eatWhile(hexRE); // should require at least 1
	              return "number";
	            }
	          }
	          else
	          {
	            source.eatWhile(digitRE);
	          }
	          if (source.eat('.'))
	          {
	            source.eatWhile(digitRE); // should require at least 1
	          }
	          if (source.eat(/[eE]/))
	          {
	            source.eat(/[-+]/);
	            source.eatWhile(digitRE); // should require at least 1
	          }
	          return "number";
	        }
	
	        if (symbolRE.test(char))
	        {
	          if (char === '-' && source.eat('-'))
	          {
	            source.skipToEnd();
	            return "comment";
	          }
	          source.eatWhile(symbolRE);
	          return "keyword";
	        }
	
	        if (char === '_')
	        {
	          return "keyword";
	        }
	
	        return "error";
	      }
	    }
	
	    function chompMultiComment(nest)
	    {
	      if (nest == 0)
	      {
	        return normal();
	      }
	      return function(source, setState)
	      {
	        while (!source.eol())
	        {
	          var char = source.next();
	          if (char == '{' && source.eat('-'))
	          {
	            ++nest;
	          }
	          else if (char == '-' && source.eat('}'))
	          {
	            --nest;
	            if (nest === 0)
	            {
	              setState(normal());
	              return 'comment';
	            }
	          }
	        }
	        setState(chompMultiComment(nest));
	        return 'comment';
	      }
	    }
	
	    function chompMultiString(source, setState)
	    {
	      while (!source.eol())
	      {
	        var char = source.next();
	        if (char === '"' && source.eat('"') && source.eat('"'))
	        {
	          setState(normal());
	          return 'string';
	        }
	      }
	      return 'string';
	    }
	
	    function chompSingleString(source, setState)
	    {
	      while (source.skipTo('\\"')) { source.next(); source.next(); }
	      if (source.skipTo('"'))
	      {
	        source.next();
	        setState(normal());
	        return 'string';
	      }
	      source.skipToEnd();
	      setState(normal());
	      return 'error';
	    }
	
	    function chompChar(source, setState)
	    {
	      while (source.skipTo("\\'")) { source.next(); source.next(); }
	      if (source.skipTo("'"))
	      {
	        source.next();
	        setState(normal());
	        return 'string';
	      }
	      source.skipToEnd();
	      setState(normal());
	      return 'error';
	    }
	
	    function chompGlsl(source, setState)
	    {
	      while (!source.eol())
	      {
	        var char = source.next();
	        if (char === '|' && source.eat(']'))
	        {
	          setState(normal());
	          return 'string';
	        }
	      }
	      return 'string';
	    }
	
	    var wellKnownWords = {
	      case: 1,
	      of: 1,
	      as: 1,
	      if: 1,
	      then: 1,
	      else: 1,
	      let: 1,
	      in: 1,
	      type: 1,
	      alias: 1,
	      module: 1,
	      where: 1,
	      import: 1,
	      exposing: 1,
	      port: 1
	    };
	
	    return {
	      startState: function ()  { return { f: normal() }; },
	      copyState:  function (s) { return { f: s.f }; },
	
	      token: function(stream, state) {
	        var type = state.f(stream, function(s) { state.f = s; });
	        var word = stream.current();
	        return (wellKnownWords.hasOwnProperty(word)) ? 'keyword' : type;
	      }
	    };
	
	  });
	
	  CodeMirror.defineMIME("text/x-elm", "elm");
	});


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(1));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("go", function(config) {
	  var indentUnit = config.indentUnit;
	
	  var keywords = {
	    "break":true, "case":true, "chan":true, "const":true, "continue":true,
	    "default":true, "defer":true, "else":true, "fallthrough":true, "for":true,
	    "func":true, "go":true, "goto":true, "if":true, "import":true,
	    "interface":true, "map":true, "package":true, "range":true, "return":true,
	    "select":true, "struct":true, "switch":true, "type":true, "var":true,
	    "bool":true, "byte":true, "complex64":true, "complex128":true,
	    "float32":true, "float64":true, "int8":true, "int16":true, "int32":true,
	    "int64":true, "string":true, "uint8":true, "uint16":true, "uint32":true,
	    "uint64":true, "int":true, "uint":true, "uintptr":true, "error": true,
	    "rune":true
	  };
	
	  var atoms = {
	    "true":true, "false":true, "iota":true, "nil":true, "append":true,
	    "cap":true, "close":true, "complex":true, "copy":true, "delete":true, "imag":true,
	    "len":true, "make":true, "new":true, "panic":true, "print":true,
	    "println":true, "real":true, "recover":true
	  };
	
	  var isOperatorChar = /[+\-*&^%:=<>!|\/]/;
	
	  var curPunc;
	
	  function tokenBase(stream, state) {
	    var ch = stream.next();
	    if (ch == '"' || ch == "'" || ch == "`") {
	      state.tokenize = tokenString(ch);
	      return state.tokenize(stream, state);
	    }
	    if (/[\d\.]/.test(ch)) {
	      if (ch == ".") {
	        stream.match(/^[0-9]+([eE][\-+]?[0-9]+)?/);
	      } else if (ch == "0") {
	        stream.match(/^[xX][0-9a-fA-F]+/) || stream.match(/^0[0-7]+/);
	      } else {
	        stream.match(/^[0-9]*\.?[0-9]*([eE][\-+]?[0-9]+)?/);
	      }
	      return "number";
	    }
	    if (/[\[\]{}\(\),;\:\.]/.test(ch)) {
	      curPunc = ch;
	      return null;
	    }
	    if (ch == "/") {
	      if (stream.eat("*")) {
	        state.tokenize = tokenComment;
	        return tokenComment(stream, state);
	      }
	      if (stream.eat("/")) {
	        stream.skipToEnd();
	        return "comment";
	      }
	    }
	    if (isOperatorChar.test(ch)) {
	      stream.eatWhile(isOperatorChar);
	      return "operator";
	    }
	    stream.eatWhile(/[\w\$_\xa1-\uffff]/);
	    var cur = stream.current();
	    if (keywords.propertyIsEnumerable(cur)) {
	      if (cur == "case" || cur == "default") curPunc = "case";
	      return "keyword";
	    }
	    if (atoms.propertyIsEnumerable(cur)) return "atom";
	    return "variable";
	  }
	
	  function tokenString(quote) {
	    return function(stream, state) {
	      var escaped = false, next, end = false;
	      while ((next = stream.next()) != null) {
	        if (next == quote && !escaped) {end = true; break;}
	        escaped = !escaped && quote != "`" && next == "\\";
	      }
	      if (end || !(escaped || quote == "`"))
	        state.tokenize = tokenBase;
	      return "string";
	    };
	  }
	
	  function tokenComment(stream, state) {
	    var maybeEnd = false, ch;
	    while (ch = stream.next()) {
	      if (ch == "/" && maybeEnd) {
	        state.tokenize = tokenBase;
	        break;
	      }
	      maybeEnd = (ch == "*");
	    }
	    return "comment";
	  }
	
	  function Context(indented, column, type, align, prev) {
	    this.indented = indented;
	    this.column = column;
	    this.type = type;
	    this.align = align;
	    this.prev = prev;
	  }
	  function pushContext(state, col, type) {
	    return state.context = new Context(state.indented, col, type, null, state.context);
	  }
	  function popContext(state) {
	    if (!state.context.prev) return;
	    var t = state.context.type;
	    if (t == ")" || t == "]" || t == "}")
	      state.indented = state.context.indented;
	    return state.context = state.context.prev;
	  }
	
	  // Interface
	
	  return {
	    startState: function(basecolumn) {
	      return {
	        tokenize: null,
	        context: new Context((basecolumn || 0) - indentUnit, 0, "top", false),
	        indented: 0,
	        startOfLine: true
	      };
	    },
	
	    token: function(stream, state) {
	      var ctx = state.context;
	      if (stream.sol()) {
	        if (ctx.align == null) ctx.align = false;
	        state.indented = stream.indentation();
	        state.startOfLine = true;
	        if (ctx.type == "case") ctx.type = "}";
	      }
	      if (stream.eatSpace()) return null;
	      curPunc = null;
	      var style = (state.tokenize || tokenBase)(stream, state);
	      if (style == "comment") return style;
	      if (ctx.align == null) ctx.align = true;
	
	      if (curPunc == "{") pushContext(state, stream.column(), "}");
	      else if (curPunc == "[") pushContext(state, stream.column(), "]");
	      else if (curPunc == "(") pushContext(state, stream.column(), ")");
	      else if (curPunc == "case") ctx.type = "case";
	      else if (curPunc == "}" && ctx.type == "}") popContext(state);
	      else if (curPunc == ctx.type) popContext(state);
	      state.startOfLine = false;
	      return style;
	    },
	
	    indent: function(state, textAfter) {
	      if (state.tokenize != tokenBase && state.tokenize != null) return CodeMirror.Pass;
	      var ctx = state.context, firstChar = textAfter && textAfter.charAt(0);
	      if (ctx.type == "case" && /^(?:case|default)\b/.test(textAfter)) {
	        state.context.type = "}";
	        return ctx.indented;
	      }
	      var closing = firstChar == ctx.type;
	      if (ctx.align) return ctx.column + (closing ? 0 : 1);
	      else return ctx.indented + (closing ? 0 : indentUnit);
	    },
	
	    electricChars: "{}):",
	    closeBrackets: "()[]{}''\"\"``",
	    fold: "brace",
	    blockCommentStart: "/*",
	    blockCommentEnd: "*/",
	    lineComment: "//"
	  };
	});
	
	CodeMirror.defineMIME("text/x-go", "go");
	
	});


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(1));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("groovy", function(config) {
	  function words(str) {
	    var obj = {}, words = str.split(" ");
	    for (var i = 0; i < words.length; ++i) obj[words[i]] = true;
	    return obj;
	  }
	  var keywords = words(
	    "abstract as assert boolean break byte case catch char class const continue def default " +
	    "do double else enum extends final finally float for goto if implements import in " +
	    "instanceof int interface long native new package private protected public return " +
	    "short static strictfp super switch synchronized threadsafe throw throws trait transient " +
	    "try void volatile while");
	  var blockKeywords = words("catch class def do else enum finally for if interface switch trait try while");
	  var standaloneKeywords = words("return break continue");
	  var atoms = words("null true false this");
	
	  var curPunc;
	  function tokenBase(stream, state) {
	    var ch = stream.next();
	    if (ch == '"' || ch == "'") {
	      return startString(ch, stream, state);
	    }
	    if (/[\[\]{}\(\),;\:\.]/.test(ch)) {
	      curPunc = ch;
	      return null;
	    }
	    if (/\d/.test(ch)) {
	      stream.eatWhile(/[\w\.]/);
	      if (stream.eat(/eE/)) { stream.eat(/\+\-/); stream.eatWhile(/\d/); }
	      return "number";
	    }
	    if (ch == "/") {
	      if (stream.eat("*")) {
	        state.tokenize.push(tokenComment);
	        return tokenComment(stream, state);
	      }
	      if (stream.eat("/")) {
	        stream.skipToEnd();
	        return "comment";
	      }
	      if (expectExpression(state.lastToken, false)) {
	        return startString(ch, stream, state);
	      }
	    }
	    if (ch == "-" && stream.eat(">")) {
	      curPunc = "->";
	      return null;
	    }
	    if (/[+\-*&%=<>!?|\/~]/.test(ch)) {
	      stream.eatWhile(/[+\-*&%=<>|~]/);
	      return "operator";
	    }
	    stream.eatWhile(/[\w\$_]/);
	    if (ch == "@") { stream.eatWhile(/[\w\$_\.]/); return "meta"; }
	    if (state.lastToken == ".") return "property";
	    if (stream.eat(":")) { curPunc = "proplabel"; return "property"; }
	    var cur = stream.current();
	    if (atoms.propertyIsEnumerable(cur)) { return "atom"; }
	    if (keywords.propertyIsEnumerable(cur)) {
	      if (blockKeywords.propertyIsEnumerable(cur)) curPunc = "newstatement";
	      else if (standaloneKeywords.propertyIsEnumerable(cur)) curPunc = "standalone";
	      return "keyword";
	    }
	    return "variable";
	  }
	  tokenBase.isBase = true;
	
	  function startString(quote, stream, state) {
	    var tripleQuoted = false;
	    if (quote != "/" && stream.eat(quote)) {
	      if (stream.eat(quote)) tripleQuoted = true;
	      else return "string";
	    }
	    function t(stream, state) {
	      var escaped = false, next, end = !tripleQuoted;
	      while ((next = stream.next()) != null) {
	        if (next == quote && !escaped) {
	          if (!tripleQuoted) { break; }
	          if (stream.match(quote + quote)) { end = true; break; }
	        }
	        if (quote == '"' && next == "$" && !escaped && stream.eat("{")) {
	          state.tokenize.push(tokenBaseUntilBrace());
	          return "string";
	        }
	        escaped = !escaped && next == "\\";
	      }
	      if (end) state.tokenize.pop();
	      return "string";
	    }
	    state.tokenize.push(t);
	    return t(stream, state);
	  }
	
	  function tokenBaseUntilBrace() {
	    var depth = 1;
	    function t(stream, state) {
	      if (stream.peek() == "}") {
	        depth--;
	        if (depth == 0) {
	          state.tokenize.pop();
	          return state.tokenize[state.tokenize.length-1](stream, state);
	        }
	      } else if (stream.peek() == "{") {
	        depth++;
	      }
	      return tokenBase(stream, state);
	    }
	    t.isBase = true;
	    return t;
	  }
	
	  function tokenComment(stream, state) {
	    var maybeEnd = false, ch;
	    while (ch = stream.next()) {
	      if (ch == "/" && maybeEnd) {
	        state.tokenize.pop();
	        break;
	      }
	      maybeEnd = (ch == "*");
	    }
	    return "comment";
	  }
	
	  function expectExpression(last, newline) {
	    return !last || last == "operator" || last == "->" || /[\.\[\{\(,;:]/.test(last) ||
	      last == "newstatement" || last == "keyword" || last == "proplabel" ||
	      (last == "standalone" && !newline);
	  }
	
	  function Context(indented, column, type, align, prev) {
	    this.indented = indented;
	    this.column = column;
	    this.type = type;
	    this.align = align;
	    this.prev = prev;
	  }
	  function pushContext(state, col, type) {
	    return state.context = new Context(state.indented, col, type, null, state.context);
	  }
	  function popContext(state) {
	    var t = state.context.type;
	    if (t == ")" || t == "]" || t == "}")
	      state.indented = state.context.indented;
	    return state.context = state.context.prev;
	  }
	
	  // Interface
	
	  return {
	    startState: function(basecolumn) {
	      return {
	        tokenize: [tokenBase],
	        context: new Context((basecolumn || 0) - config.indentUnit, 0, "top", false),
	        indented: 0,
	        startOfLine: true,
	        lastToken: null
	      };
	    },
	
	    token: function(stream, state) {
	      var ctx = state.context;
	      if (stream.sol()) {
	        if (ctx.align == null) ctx.align = false;
	        state.indented = stream.indentation();
	        state.startOfLine = true;
	        // Automatic semicolon insertion
	        if (ctx.type == "statement" && !expectExpression(state.lastToken, true)) {
	          popContext(state); ctx = state.context;
	        }
	      }
	      if (stream.eatSpace()) return null;
	      curPunc = null;
	      var style = state.tokenize[state.tokenize.length-1](stream, state);
	      if (style == "comment") return style;
	      if (ctx.align == null) ctx.align = true;
	
	      if ((curPunc == ";" || curPunc == ":") && ctx.type == "statement") popContext(state);
	      // Handle indentation for {x -> \n ... }
	      else if (curPunc == "->" && ctx.type == "statement" && ctx.prev.type == "}") {
	        popContext(state);
	        state.context.align = false;
	      }
	      else if (curPunc == "{") pushContext(state, stream.column(), "}");
	      else if (curPunc == "[") pushContext(state, stream.column(), "]");
	      else if (curPunc == "(") pushContext(state, stream.column(), ")");
	      else if (curPunc == "}") {
	        while (ctx.type == "statement") ctx = popContext(state);
	        if (ctx.type == "}") ctx = popContext(state);
	        while (ctx.type == "statement") ctx = popContext(state);
	      }
	      else if (curPunc == ctx.type) popContext(state);
	      else if (ctx.type == "}" || ctx.type == "top" || (ctx.type == "statement" && curPunc == "newstatement"))
	        pushContext(state, stream.column(), "statement");
	      state.startOfLine = false;
	      state.lastToken = curPunc || style;
	      return style;
	    },
	
	    indent: function(state, textAfter) {
	      if (!state.tokenize[state.tokenize.length-1].isBase) return CodeMirror.Pass;
	      var firstChar = textAfter && textAfter.charAt(0), ctx = state.context;
	      if (ctx.type == "statement" && !expectExpression(state.lastToken, true)) ctx = ctx.prev;
	      var closing = firstChar == ctx.type;
	      if (ctx.type == "statement") return ctx.indented + (firstChar == "{" ? 0 : config.indentUnit);
	      else if (ctx.align) return ctx.column + (closing ? 0 : 1);
	      else return ctx.indented + (closing ? 0 : config.indentUnit);
	    },
	
	    electricChars: "{}",
	    closeBrackets: {triples: "'\""},
	    fold: "brace",
	    blockCommentStart: "/*",
	    blockCommentEnd: "*/",
	    lineComment: "//"
	  };
	});
	
	CodeMirror.defineMIME("text/x-groovy", "groovy");
	
	});


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(1), __webpack_require__(286), __webpack_require__(284));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror", "../../addon/mode/simple", "../../addon/mode/multiplex"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  "use strict";
	
	  CodeMirror.defineSimpleMode("handlebars-tags", {
	    start: [
	      { regex: /\{\{\{/, push: "handlebars_raw", token: "tag" },
	      { regex: /\{\{!--/, push: "dash_comment", token: "comment" },
	      { regex: /\{\{!/,   push: "comment", token: "comment" },
	      { regex: /\{\{/,    push: "handlebars", token: "tag" }
	    ],
	    handlebars_raw: [
	      { regex: /\}\}\}/, pop: true, token: "tag" },
	    ],
	    handlebars: [
	      { regex: /\}\}/, pop: true, token: "tag" },
	
	      // Double and single quotes
	      { regex: /"(?:[^\\"]|\\.)*"?/, token: "string" },
	      { regex: /'(?:[^\\']|\\.)*'?/, token: "string" },
	
	      // Handlebars keywords
	      { regex: />|[#\/]([A-Za-z_]\w*)/, token: "keyword" },
	      { regex: /(?:else|this)\b/, token: "keyword" },
	
	      // Numeral
	      { regex: /\d+/i, token: "number" },
	
	      // Atoms like = and .
	      { regex: /=|~|@|true|false/, token: "atom" },
	
	      // Paths
	      { regex: /(?:\.\.\/)*(?:[A-Za-z_][\w\.]*)+/, token: "variable-2" }
	    ],
	    dash_comment: [
	      { regex: /--\}\}/, pop: true, token: "comment" },
	
	      // Commented code
	      { regex: /./, token: "comment"}
	    ],
	    comment: [
	      { regex: /\}\}/, pop: true, token: "comment" },
	      { regex: /./, token: "comment" }
	    ],
	    meta: {
	      blockCommentStart: "{{--",
	      blockCommentEnd: "--}}"
	    }
	  });
	
	  CodeMirror.defineMode("handlebars", function(config, parserConfig) {
	    var handlebars = CodeMirror.getMode(config, "handlebars-tags");
	    if (!parserConfig || !parserConfig.base) return handlebars;
	    return CodeMirror.multiplexingMode(
	      CodeMirror.getMode(config, parserConfig.base),
	      {open: "{{", close: /\}\}\}?/, mode: handlebars, parseDelimiters: true}
	    );
	  });
	
	  CodeMirror.defineMIME("text/x-handlebars-template", "handlebars");
	});


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(1));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("http", function() {
	  function failFirstLine(stream, state) {
	    stream.skipToEnd();
	    state.cur = header;
	    return "error";
	  }
	
	  function start(stream, state) {
	    if (stream.match(/^HTTP\/\d\.\d/)) {
	      state.cur = responseStatusCode;
	      return "keyword";
	    } else if (stream.match(/^[A-Z]+/) && /[ \t]/.test(stream.peek())) {
	      state.cur = requestPath;
	      return "keyword";
	    } else {
	      return failFirstLine(stream, state);
	    }
	  }
	
	  function responseStatusCode(stream, state) {
	    var code = stream.match(/^\d+/);
	    if (!code) return failFirstLine(stream, state);
	
	    state.cur = responseStatusText;
	    var status = Number(code[0]);
	    if (status >= 100 && status < 200) {
	      return "positive informational";
	    } else if (status >= 200 && status < 300) {
	      return "positive success";
	    } else if (status >= 300 && status < 400) {
	      return "positive redirect";
	    } else if (status >= 400 && status < 500) {
	      return "negative client-error";
	    } else if (status >= 500 && status < 600) {
	      return "negative server-error";
	    } else {
	      return "error";
	    }
	  }
	
	  function responseStatusText(stream, state) {
	    stream.skipToEnd();
	    state.cur = header;
	    return null;
	  }
	
	  function requestPath(stream, state) {
	    stream.eatWhile(/\S/);
	    state.cur = requestProtocol;
	    return "string-2";
	  }
	
	  function requestProtocol(stream, state) {
	    if (stream.match(/^HTTP\/\d\.\d$/)) {
	      state.cur = header;
	      return "keyword";
	    } else {
	      return failFirstLine(stream, state);
	    }
	  }
	
	  function header(stream) {
	    if (stream.sol() && !stream.eat(/[ \t]/)) {
	      if (stream.match(/^.*?:/)) {
	        return "atom";
	      } else {
	        stream.skipToEnd();
	        return "error";
	      }
	    } else {
	      stream.skipToEnd();
	      return "string";
	    }
	  }
	
	  function body(stream) {
	    stream.skipToEnd();
	    return null;
	  }
	
	  return {
	    token: function(stream, state) {
	      var cur = state.cur;
	      if (cur != header && cur != body && stream.eatSpace()) return null;
	      return cur(stream, state);
	    },
	
	    blankLine: function(state) {
	      state.cur = body;
	    },
	
	    startState: function() {
	      return {cur: start};
	    }
	  };
	});
	
	CodeMirror.defineMIME("message/http", "http");
	
	});


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(1), __webpack_require__(69), __webpack_require__(68))
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror", "../xml/xml", "../javascript/javascript"], mod)
	  else // Plain browser env
	    mod(CodeMirror)
	})(function(CodeMirror) {
	  "use strict"
	
	  // Depth means the amount of open braces in JS context, in XML
	  // context 0 means not in tag, 1 means in tag, and 2 means in tag
	  // and js block comment.
	  function Context(state, mode, depth, prev) {
	    this.state = state; this.mode = mode; this.depth = depth; this.prev = prev
	  }
	
	  function copyContext(context) {
	    return new Context(CodeMirror.copyState(context.mode, context.state),
	                       context.mode,
	                       context.depth,
	                       context.prev && copyContext(context.prev))
	  }
	
	  CodeMirror.defineMode("jsx", function(config, modeConfig) {
	    var xmlMode = CodeMirror.getMode(config, {name: "xml", allowMissing: true, multilineTagIndentPastTag: false, allowMissingTagName: true})
	    var jsMode = CodeMirror.getMode(config, modeConfig && modeConfig.base || "javascript")
	
	    function flatXMLIndent(state) {
	      var tagName = state.tagName
	      state.tagName = null
	      var result = xmlMode.indent(state, "", "")
	      state.tagName = tagName
	      return result
	    }
	
	    function token(stream, state) {
	      if (state.context.mode == xmlMode)
	        return xmlToken(stream, state, state.context)
	      else
	        return jsToken(stream, state, state.context)
	    }
	
	    function xmlToken(stream, state, cx) {
	      if (cx.depth == 2) { // Inside a JS /* */ comment
	        if (stream.match(/^.*?\*\//)) cx.depth = 1
	        else stream.skipToEnd()
	        return "comment"
	      }
	
	      if (stream.peek() == "{") {
	        xmlMode.skipAttribute(cx.state)
	
	        var indent = flatXMLIndent(cx.state), xmlContext = cx.state.context
	        // If JS starts on same line as tag
	        if (xmlContext && stream.match(/^[^>]*>\s*$/, false)) {
	          while (xmlContext.prev && !xmlContext.startOfLine)
	            xmlContext = xmlContext.prev
	          // If tag starts the line, use XML indentation level
	          if (xmlContext.startOfLine) indent -= config.indentUnit
	          // Else use JS indentation level
	          else if (cx.prev.state.lexical) indent = cx.prev.state.lexical.indented
	        // Else if inside of tag
	        } else if (cx.depth == 1) {
	          indent += config.indentUnit
	        }
	
	        state.context = new Context(CodeMirror.startState(jsMode, indent),
	                                    jsMode, 0, state.context)
	        return null
	      }
	
	      if (cx.depth == 1) { // Inside of tag
	        if (stream.peek() == "<") { // Tag inside of tag
	          xmlMode.skipAttribute(cx.state)
	          state.context = new Context(CodeMirror.startState(xmlMode, flatXMLIndent(cx.state)),
	                                      xmlMode, 0, state.context)
	          return null
	        } else if (stream.match("//")) {
	          stream.skipToEnd()
	          return "comment"
	        } else if (stream.match("/*")) {
	          cx.depth = 2
	          return token(stream, state)
	        }
	      }
	
	      var style = xmlMode.token(stream, cx.state), cur = stream.current(), stop
	      if (/\btag\b/.test(style)) {
	        if (/>$/.test(cur)) {
	          if (cx.state.context) cx.depth = 0
	          else state.context = state.context.prev
	        } else if (/^</.test(cur)) {
	          cx.depth = 1
	        }
	      } else if (!style && (stop = cur.indexOf("{")) > -1) {
	        stream.backUp(cur.length - stop)
	      }
	      return style
	    }
	
	    function jsToken(stream, state, cx) {
	      if (stream.peek() == "<" && jsMode.expressionAllowed(stream, cx.state)) {
	        jsMode.skipExpression(cx.state)
	        state.context = new Context(CodeMirror.startState(xmlMode, jsMode.indent(cx.state, "", "")),
	                                    xmlMode, 0, state.context)
	        return null
	      }
	
	      var style = jsMode.token(stream, cx.state)
	      if (!style && cx.depth != null) {
	        var cur = stream.current()
	        if (cur == "{") {
	          cx.depth++
	        } else if (cur == "}") {
	          if (--cx.depth == 0) state.context = state.context.prev
	        }
	      }
	      return style
	    }
	
	    return {
	      startState: function() {
	        return {context: new Context(CodeMirror.startState(jsMode), jsMode)}
	      },
	
	      copyState: function(state) {
	        return {context: copyContext(state.context)}
	      },
	
	      token: token,
	
	      indent: function(state, textAfter, fullLine) {
	        return state.context.mode.indent(state.context.state, textAfter, fullLine)
	      },
	
	      innerMode: function(state) {
	        return state.context
	      }
	    }
	  }, "xml", "javascript")
	
	  CodeMirror.defineMIME("text/jsx", "jsx")
	  CodeMirror.defineMIME("text/typescript-jsx", {name: "jsx", base: {name: "javascript", typescript: true}})
	});


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/LICENSE
	
	// LUA mode. Ported to CodeMirror 2 from Franciszek Wawrzak's
	// CodeMirror 1 mode.
	// highlights keywords, strings, comments (no leveling supported! ("[==[")), tokens, basic indenting
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(1));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("lua", function(config, parserConfig) {
	  var indentUnit = config.indentUnit;
	
	  function prefixRE(words) {
	    return new RegExp("^(?:" + words.join("|") + ")", "i");
	  }
	  function wordRE(words) {
	    return new RegExp("^(?:" + words.join("|") + ")$", "i");
	  }
	  var specials = wordRE(parserConfig.specials || []);
	
	  // long list of standard functions from lua manual
	  var builtins = wordRE([
	    "_G","_VERSION","assert","collectgarbage","dofile","error","getfenv","getmetatable","ipairs","load",
	    "loadfile","loadstring","module","next","pairs","pcall","print","rawequal","rawget","rawset","require",
	    "select","setfenv","setmetatable","tonumber","tostring","type","unpack","xpcall",
	
	    "coroutine.create","coroutine.resume","coroutine.running","coroutine.status","coroutine.wrap","coroutine.yield",
	
	    "debug.debug","debug.getfenv","debug.gethook","debug.getinfo","debug.getlocal","debug.getmetatable",
	    "debug.getregistry","debug.getupvalue","debug.setfenv","debug.sethook","debug.setlocal","debug.setmetatable",
	    "debug.setupvalue","debug.traceback",
	
	    "close","flush","lines","read","seek","setvbuf","write",
	
	    "io.close","io.flush","io.input","io.lines","io.open","io.output","io.popen","io.read","io.stderr","io.stdin",
	    "io.stdout","io.tmpfile","io.type","io.write",
	
	    "math.abs","math.acos","math.asin","math.atan","math.atan2","math.ceil","math.cos","math.cosh","math.deg",
	    "math.exp","math.floor","math.fmod","math.frexp","math.huge","math.ldexp","math.log","math.log10","math.max",
	    "math.min","math.modf","math.pi","math.pow","math.rad","math.random","math.randomseed","math.sin","math.sinh",
	    "math.sqrt","math.tan","math.tanh",
	
	    "os.clock","os.date","os.difftime","os.execute","os.exit","os.getenv","os.remove","os.rename","os.setlocale",
	    "os.time","os.tmpname",
	
	    "package.cpath","package.loaded","package.loaders","package.loadlib","package.path","package.preload",
	    "package.seeall",
	
	    "string.byte","string.char","string.dump","string.find","string.format","string.gmatch","string.gsub",
	    "string.len","string.lower","string.match","string.rep","string.reverse","string.sub","string.upper",
	
	    "table.concat","table.insert","table.maxn","table.remove","table.sort"
	  ]);
	  var keywords = wordRE(["and","break","elseif","false","nil","not","or","return",
	                         "true","function", "end", "if", "then", "else", "do",
	                         "while", "repeat", "until", "for", "in", "local" ]);
	
	  var indentTokens = wordRE(["function", "if","repeat","do", "\\(", "{"]);
	  var dedentTokens = wordRE(["end", "until", "\\)", "}"]);
	  var dedentPartial = prefixRE(["end", "until", "\\)", "}", "else", "elseif"]);
	
	  function readBracket(stream) {
	    var level = 0;
	    while (stream.eat("=")) ++level;
	    stream.eat("[");
	    return level;
	  }
	
	  function normal(stream, state) {
	    var ch = stream.next();
	    if (ch == "-" && stream.eat("-")) {
	      if (stream.eat("[") && stream.eat("["))
	        return (state.cur = bracketed(readBracket(stream), "comment"))(stream, state);
	      stream.skipToEnd();
	      return "comment";
	    }
	    if (ch == "\"" || ch == "'")
	      return (state.cur = string(ch))(stream, state);
	    if (ch == "[" && /[\[=]/.test(stream.peek()))
	      return (state.cur = bracketed(readBracket(stream), "string"))(stream, state);
	    if (/\d/.test(ch)) {
	      stream.eatWhile(/[\w.%]/);
	      return "number";
	    }
	    if (/[\w_]/.test(ch)) {
	      stream.eatWhile(/[\w\\\-_.]/);
	      return "variable";
	    }
	    return null;
	  }
	
	  function bracketed(level, style) {
	    return function(stream, state) {
	      var curlev = null, ch;
	      while ((ch = stream.next()) != null) {
	        if (curlev == null) {if (ch == "]") curlev = 0;}
	        else if (ch == "=") ++curlev;
	        else if (ch == "]" && curlev == level) { state.cur = normal; break; }
	        else curlev = null;
	      }
	      return style;
	    };
	  }
	
	  function string(quote) {
	    return function(stream, state) {
	      var escaped = false, ch;
	      while ((ch = stream.next()) != null) {
	        if (ch == quote && !escaped) break;
	        escaped = !escaped && ch == "\\";
	      }
	      if (!escaped) state.cur = normal;
	      return "string";
	    };
	  }
	
	  return {
	    startState: function(basecol) {
	      return {basecol: basecol || 0, indentDepth: 0, cur: normal};
	    },
	
	    token: function(stream, state) {
	      if (stream.eatSpace()) return null;
	      var style = state.cur(stream, state);
	      var word = stream.current();
	      if (style == "variable") {
	        if (keywords.test(word)) style = "keyword";
	        else if (builtins.test(word)) style = "builtin";
	        else if (specials.test(word)) style = "variable-2";
	      }
	      if ((style != "comment") && (style != "string")){
	        if (indentTokens.test(word)) ++state.indentDepth;
	        else if (dedentTokens.test(word)) --state.indentDepth;
	      }
	      return style;
	    },
	
	    indent: function(state, textAfter) {
	      var closing = dedentPartial.test(textAfter);
	      return state.basecol + indentUnit * (state.indentDepth - (closing ? 1 : 0));
	    },
	
	    lineComment: "--",
	    blockCommentStart: "--[[",
	    blockCommentEnd: "]]"
	  };
	});
	
	CodeMirror.defineMIME("text/x-lua", "lua");
	
	});


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(1), __webpack_require__(69), __webpack_require__(298));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror", "../xml/xml", "../meta"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("markdown", function(cmCfg, modeCfg) {
	
	  var htmlMode = CodeMirror.getMode(cmCfg, "text/html");
	  var htmlModeMissing = htmlMode.name == "null"
	
	  function getMode(name) {
	    if (CodeMirror.findModeByName) {
	      var found = CodeMirror.findModeByName(name);
	      if (found) name = found.mime || found.mimes[0];
	    }
	    var mode = CodeMirror.getMode(cmCfg, name);
	    return mode.name == "null" ? null : mode;
	  }
	
	  // Should characters that affect highlighting be highlighted separate?
	  // Does not include characters that will be output (such as `1.` and `-` for lists)
	  if (modeCfg.highlightFormatting === undefined)
	    modeCfg.highlightFormatting = false;
	
	  // Maximum number of nested blockquotes. Set to 0 for infinite nesting.
	  // Excess `>` will emit `error` token.
	  if (modeCfg.maxBlockquoteDepth === undefined)
	    modeCfg.maxBlockquoteDepth = 0;
	
	  // Turn on task lists? ("- [ ] " and "- [x] ")
	  if (modeCfg.taskLists === undefined) modeCfg.taskLists = false;
	
	  // Turn on strikethrough syntax
	  if (modeCfg.strikethrough === undefined)
	    modeCfg.strikethrough = false;
	
	  if (modeCfg.emoji === undefined)
	    modeCfg.emoji = false;
	
	  if (modeCfg.fencedCodeBlockHighlighting === undefined)
	    modeCfg.fencedCodeBlockHighlighting = true;
	
	  if (modeCfg.xml === undefined)
	    modeCfg.xml = true;
	
	  // Allow token types to be overridden by user-provided token types.
	  if (modeCfg.tokenTypeOverrides === undefined)
	    modeCfg.tokenTypeOverrides = {};
	
	  var tokenTypes = {
	    header: "header",
	    code: "comment",
	    quote: "quote",
	    list1: "variable-2",
	    list2: "variable-3",
	    list3: "keyword",
	    hr: "hr",
	    image: "image",
	    imageAltText: "image-alt-text",
	    imageMarker: "image-marker",
	    formatting: "formatting",
	    linkInline: "link",
	    linkEmail: "link",
	    linkText: "link",
	    linkHref: "string",
	    em: "em",
	    strong: "strong",
	    strikethrough: "strikethrough",
	    emoji: "builtin"
	  };
	
	  for (var tokenType in tokenTypes) {
	    if (tokenTypes.hasOwnProperty(tokenType) && modeCfg.tokenTypeOverrides[tokenType]) {
	      tokenTypes[tokenType] = modeCfg.tokenTypeOverrides[tokenType];
	    }
	  }
	
	  var hrRE = /^([*\-_])(?:\s*\1){2,}\s*$/
	  ,   listRE = /^(?:[*\-+]|^[0-9]+([.)]))\s+/
	  ,   taskListRE = /^\[(x| )\](?=\s)/i // Must follow listRE
	  ,   atxHeaderRE = modeCfg.allowAtxHeaderWithoutSpace ? /^(#+)/ : /^(#+)(?: |$)/
	  ,   setextHeaderRE = /^ {0,3}(?:\={1,}|-{2,})\s*$/
	  ,   textRE = /^[^#!\[\]*_\\<>` "'(~:]+/
	  ,   fencedCodeRE = /^(~~~+|```+)[ \t]*([\w+#-]*)[^\n`]*$/
	  ,   linkDefRE = /^\s*\[[^\]]+?\]:.*$/ // naive link-definition
	  ,   punctuation = /[!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E42\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC9\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDF3C-\uDF3E]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]/
	  ,   expandedTab = "    " // CommonMark specifies tab as 4 spaces
	
	  function switchInline(stream, state, f) {
	    state.f = state.inline = f;
	    return f(stream, state);
	  }
	
	  function switchBlock(stream, state, f) {
	    state.f = state.block = f;
	    return f(stream, state);
	  }
	
	  function lineIsEmpty(line) {
	    return !line || !/\S/.test(line.string)
	  }
	
	  // Blocks
	
	  function blankLine(state) {
	    // Reset linkTitle state
	    state.linkTitle = false;
	    state.linkHref = false;
	    state.linkText = false;
	    // Reset EM state
	    state.em = false;
	    // Reset STRONG state
	    state.strong = false;
	    // Reset strikethrough state
	    state.strikethrough = false;
	    // Reset state.quote
	    state.quote = 0;
	    // Reset state.indentedCode
	    state.indentedCode = false;
	    if (state.f == htmlBlock) {
	      var exit = htmlModeMissing
	      if (!exit) {
	        var inner = CodeMirror.innerMode(htmlMode, state.htmlState)
	        exit = inner.mode.name == "xml" && inner.state.tagStart === null &&
	          (!inner.state.context && inner.state.tokenize.isInText)
	      }
	      if (exit) {
	        state.f = inlineNormal;
	        state.block = blockNormal;
	        state.htmlState = null;
	      }
	    }
	    // Reset state.trailingSpace
	    state.trailingSpace = 0;
	    state.trailingSpaceNewLine = false;
	    // Mark this line as blank
	    state.prevLine = state.thisLine
	    state.thisLine = {stream: null}
	    return null;
	  }
	
	  function blockNormal(stream, state) {
	    var firstTokenOnLine = stream.column() === state.indentation;
	    var prevLineLineIsEmpty = lineIsEmpty(state.prevLine.stream);
	    var prevLineIsIndentedCode = state.indentedCode;
	    var prevLineIsHr = state.prevLine.hr;
	    var prevLineIsList = state.list !== false;
	    var maxNonCodeIndentation = (state.listStack[state.listStack.length - 1] || 0) + 3;
	
	    state.indentedCode = false;
	
	    var lineIndentation = state.indentation;
	    // compute once per line (on first token)
	    if (state.indentationDiff === null) {
	      state.indentationDiff = state.indentation;
	      if (prevLineIsList) {
	        state.list = null;
	        // While this list item's marker's indentation is less than the deepest
	        //  list item's content's indentation,pop the deepest list item
	        //  indentation off the stack, and update block indentation state
	        while (lineIndentation < state.listStack[state.listStack.length - 1]) {
	          state.listStack.pop();
	          if (state.listStack.length) {
	            state.indentation = state.listStack[state.listStack.length - 1];
	          // less than the first list's indent -> the line is no longer a list
	          } else {
	            state.list = false;
	          }
	        }
	        if (state.list !== false) {
	          state.indentationDiff = lineIndentation - state.listStack[state.listStack.length - 1]
	        }
	      }
	    }
	
	    // not comprehensive (currently only for setext detection purposes)
	    var allowsInlineContinuation = (
	        !prevLineLineIsEmpty && !prevLineIsHr && !state.prevLine.header &&
	        (!prevLineIsList || !prevLineIsIndentedCode) &&
	        !state.prevLine.fencedCodeEnd
	    );
	
	    var isHr = (state.list === false || prevLineIsHr || prevLineLineIsEmpty) &&
	      state.indentation <= maxNonCodeIndentation && stream.match(hrRE);
	
	    var match = null;
	    if (state.indentationDiff >= 4 && (prevLineIsIndentedCode || state.prevLine.fencedCodeEnd ||
	         state.prevLine.header || prevLineLineIsEmpty)) {
	      stream.skipToEnd();
	      state.indentedCode = true;
	      return tokenTypes.code;
	    } else if (stream.eatSpace()) {
	      return null;
	    } else if (firstTokenOnLine && state.indentation <= maxNonCodeIndentation && (match = stream.match(atxHeaderRE)) && match[1].length <= 6) {
	      state.quote = 0;
	      state.header = match[1].length;
	      state.thisLine.header = true;
	      if (modeCfg.highlightFormatting) state.formatting = "header";
	      state.f = state.inline;
	      return getType(state);
	    } else if (state.indentation <= maxNonCodeIndentation && stream.eat('>')) {
	      state.quote = firstTokenOnLine ? 1 : state.quote + 1;
	      if (modeCfg.highlightFormatting) state.formatting = "quote";
	      stream.eatSpace();
	      return getType(state);
	    } else if (!isHr && !state.setext && firstTokenOnLine && state.indentation <= maxNonCodeIndentation && (match = stream.match(listRE))) {
	      var listType = match[1] ? "ol" : "ul";
	
	      state.indentation = lineIndentation + stream.current().length;
	      state.list = true;
	      state.quote = 0;
	
	      // Add this list item's content's indentation to the stack
	      state.listStack.push(state.indentation);
	      // Reset inline styles which shouldn't propagate aross list items
	      state.em = false;
	      state.strong = false;
	      state.code = false;
	      state.strikethrough = false;
	
	      if (modeCfg.taskLists && stream.match(taskListRE, false)) {
	        state.taskList = true;
	      }
	      state.f = state.inline;
	      if (modeCfg.highlightFormatting) state.formatting = ["list", "list-" + listType];
	      return getType(state);
	    } else if (firstTokenOnLine && state.indentation <= maxNonCodeIndentation && (match = stream.match(fencedCodeRE, true))) {
	      state.quote = 0;
	      state.fencedEndRE = new RegExp(match[1] + "+ *$");
	      // try switching mode
	      state.localMode = modeCfg.fencedCodeBlockHighlighting && getMode(match[2]);
	      if (state.localMode) state.localState = CodeMirror.startState(state.localMode);
	      state.f = state.block = local;
	      if (modeCfg.highlightFormatting) state.formatting = "code-block";
	      state.code = -1
	      return getType(state);
	    // SETEXT has lowest block-scope precedence after HR, so check it after
	    //  the others (code, blockquote, list...)
	    } else if (
	      // if setext set, indicates line after ---/===
	      state.setext || (
	        // line before ---/===
	        (!allowsInlineContinuation || !prevLineIsList) && !state.quote && state.list === false &&
	        !state.code && !isHr && !linkDefRE.test(stream.string) &&
	        (match = stream.lookAhead(1)) && (match = match.match(setextHeaderRE))
	      )
	    ) {
	      if ( !state.setext ) {
	        state.header = match[0].charAt(0) == '=' ? 1 : 2;
	        state.setext = state.header;
	      } else {
	        state.header = state.setext;
	        // has no effect on type so we can reset it now
	        state.setext = 0;
	        stream.skipToEnd();
	        if (modeCfg.highlightFormatting) state.formatting = "header";
	      }
	      state.thisLine.header = true;
	      state.f = state.inline;
	      return getType(state);
	    } else if (isHr) {
	      stream.skipToEnd();
	      state.hr = true;
	      state.thisLine.hr = true;
	      return tokenTypes.hr;
	    } else if (stream.peek() === '[') {
	      return switchInline(stream, state, footnoteLink);
	    }
	
	    return switchInline(stream, state, state.inline);
	  }
	
	  function htmlBlock(stream, state) {
	    var style = htmlMode.token(stream, state.htmlState);
	    if (!htmlModeMissing) {
	      var inner = CodeMirror.innerMode(htmlMode, state.htmlState)
	      if ((inner.mode.name == "xml" && inner.state.tagStart === null &&
	           (!inner.state.context && inner.state.tokenize.isInText)) ||
	          (state.md_inside && stream.current().indexOf(">") > -1)) {
	        state.f = inlineNormal;
	        state.block = blockNormal;
	        state.htmlState = null;
	      }
	    }
	    return style;
	  }
	
	  function local(stream, state) {
	    var currListInd = state.listStack[state.listStack.length - 1] || 0;
	    var hasExitedList = state.indentation < currListInd;
	    var maxFencedEndInd = currListInd + 3;
	    if (state.fencedEndRE && state.indentation <= maxFencedEndInd && (hasExitedList || stream.match(state.fencedEndRE))) {
	      if (modeCfg.highlightFormatting) state.formatting = "code-block";
	      var returnType;
	      if (!hasExitedList) returnType = getType(state)
	      state.localMode = state.localState = null;
	      state.block = blockNormal;
	      state.f = inlineNormal;
	      state.fencedEndRE = null;
	      state.code = 0
	      state.thisLine.fencedCodeEnd = true;
	      if (hasExitedList) return switchBlock(stream, state, state.block);
	      return returnType;
	    } else if (state.localMode) {
	      return state.localMode.token(stream, state.localState);
	    } else {
	      stream.skipToEnd();
	      return tokenTypes.code;
	    }
	  }
	
	  // Inline
	  function getType(state) {
	    var styles = [];
	
	    if (state.formatting) {
	      styles.push(tokenTypes.formatting);
	
	      if (typeof state.formatting === "string") state.formatting = [state.formatting];
	
	      for (var i = 0; i < state.formatting.length; i++) {
	        styles.push(tokenTypes.formatting + "-" + state.formatting[i]);
	
	        if (state.formatting[i] === "header") {
	          styles.push(tokenTypes.formatting + "-" + state.formatting[i] + "-" + state.header);
	        }
	
	        // Add `formatting-quote` and `formatting-quote-#` for blockquotes
	        // Add `error` instead if the maximum blockquote nesting depth is passed
	        if (state.formatting[i] === "quote") {
	          if (!modeCfg.maxBlockquoteDepth || modeCfg.maxBlockquoteDepth >= state.quote) {
	            styles.push(tokenTypes.formatting + "-" + state.formatting[i] + "-" + state.quote);
	          } else {
	            styles.push("error");
	          }
	        }
	      }
	    }
	
	    if (state.taskOpen) {
	      styles.push("meta");
	      return styles.length ? styles.join(' ') : null;
	    }
	    if (state.taskClosed) {
	      styles.push("property");
	      return styles.length ? styles.join(' ') : null;
	    }
	
	    if (state.linkHref) {
	      styles.push(tokenTypes.linkHref, "url");
	    } else { // Only apply inline styles to non-url text
	      if (state.strong) { styles.push(tokenTypes.strong); }
	      if (state.em) { styles.push(tokenTypes.em); }
	      if (state.strikethrough) { styles.push(tokenTypes.strikethrough); }
	      if (state.emoji) { styles.push(tokenTypes.emoji); }
	      if (state.linkText) { styles.push(tokenTypes.linkText); }
	      if (state.code) { styles.push(tokenTypes.code); }
	      if (state.image) { styles.push(tokenTypes.image); }
	      if (state.imageAltText) { styles.push(tokenTypes.imageAltText, "link"); }
	      if (state.imageMarker) { styles.push(tokenTypes.imageMarker); }
	    }
	
	    if (state.header) { styles.push(tokenTypes.header, tokenTypes.header + "-" + state.header); }
	
	    if (state.quote) {
	      styles.push(tokenTypes.quote);
	
	      // Add `quote-#` where the maximum for `#` is modeCfg.maxBlockquoteDepth
	      if (!modeCfg.maxBlockquoteDepth || modeCfg.maxBlockquoteDepth >= state.quote) {
	        styles.push(tokenTypes.quote + "-" + state.quote);
	      } else {
	        styles.push(tokenTypes.quote + "-" + modeCfg.maxBlockquoteDepth);
	      }
	    }
	
	    if (state.list !== false) {
	      var listMod = (state.listStack.length - 1) % 3;
	      if (!listMod) {
	        styles.push(tokenTypes.list1);
	      } else if (listMod === 1) {
	        styles.push(tokenTypes.list2);
	      } else {
	        styles.push(tokenTypes.list3);
	      }
	    }
	
	    if (state.trailingSpaceNewLine) {
	      styles.push("trailing-space-new-line");
	    } else if (state.trailingSpace) {
	      styles.push("trailing-space-" + (state.trailingSpace % 2 ? "a" : "b"));
	    }
	
	    return styles.length ? styles.join(' ') : null;
	  }
	
	  function handleText(stream, state) {
	    if (stream.match(textRE, true)) {
	      return getType(state);
	    }
	    return undefined;
	  }
	
	  function inlineNormal(stream, state) {
	    var style = state.text(stream, state);
	    if (typeof style !== 'undefined')
	      return style;
	
	    if (state.list) { // List marker (*, +, -, 1., etc)
	      state.list = null;
	      return getType(state);
	    }
	
	    if (state.taskList) {
	      var taskOpen = stream.match(taskListRE, true)[1] === " ";
	      if (taskOpen) state.taskOpen = true;
	      else state.taskClosed = true;
	      if (modeCfg.highlightFormatting) state.formatting = "task";
	      state.taskList = false;
	      return getType(state);
	    }
	
	    state.taskOpen = false;
	    state.taskClosed = false;
	
	    if (state.header && stream.match(/^#+$/, true)) {
	      if (modeCfg.highlightFormatting) state.formatting = "header";
	      return getType(state);
	    }
	
	    var ch = stream.next();
	
	    // Matches link titles present on next line
	    if (state.linkTitle) {
	      state.linkTitle = false;
	      var matchCh = ch;
	      if (ch === '(') {
	        matchCh = ')';
	      }
	      matchCh = (matchCh+'').replace(/([.?*+^\[\]\\(){}|-])/g, "\\$1");
	      var regex = '^\\s*(?:[^' + matchCh + '\\\\]+|\\\\\\\\|\\\\.)' + matchCh;
	      if (stream.match(new RegExp(regex), true)) {
	        return tokenTypes.linkHref;
	      }
	    }
	
	    // If this block is changed, it may need to be updated in GFM mode
	    if (ch === '`') {
	      var previousFormatting = state.formatting;
	      if (modeCfg.highlightFormatting) state.formatting = "code";
	      stream.eatWhile('`');
	      var count = stream.current().length
	      if (state.code == 0 && (!state.quote || count == 1)) {
	        state.code = count
	        return getType(state)
	      } else if (count == state.code) { // Must be exact
	        var t = getType(state)
	        state.code = 0
	        return t
	      } else {
	        state.formatting = previousFormatting
	        return getType(state)
	      }
	    } else if (state.code) {
	      return getType(state);
	    }
	
	    if (ch === '\\') {
	      stream.next();
	      if (modeCfg.highlightFormatting) {
	        var type = getType(state);
	        var formattingEscape = tokenTypes.formatting + "-escape";
	        return type ? type + " " + formattingEscape : formattingEscape;
	      }
	    }
	
	    if (ch === '!' && stream.match(/\[[^\]]*\] ?(?:\(|\[)/, false)) {
	      state.imageMarker = true;
	      state.image = true;
	      if (modeCfg.highlightFormatting) state.formatting = "image";
	      return getType(state);
	    }
	
	    if (ch === '[' && state.imageMarker && stream.match(/[^\]]*\](\(.*?\)| ?\[.*?\])/, false)) {
	      state.imageMarker = false;
	      state.imageAltText = true
	      if (modeCfg.highlightFormatting) state.formatting = "image";
	      return getType(state);
	    }
	
	    if (ch === ']' && state.imageAltText) {
	      if (modeCfg.highlightFormatting) state.formatting = "image";
	      var type = getType(state);
	      state.imageAltText = false;
	      state.image = false;
	      state.inline = state.f = linkHref;
	      return type;
	    }
	
	    if (ch === '[' && !state.image) {
	      if (state.linkText && stream.match(/^.*?\]/)) return getType(state)
	      state.linkText = true;
	      if (modeCfg.highlightFormatting) state.formatting = "link";
	      return getType(state);
	    }
	
	    if (ch === ']' && state.linkText) {
	      if (modeCfg.highlightFormatting) state.formatting = "link";
	      var type = getType(state);
	      state.linkText = false;
	      state.inline = state.f = stream.match(/\(.*?\)| ?\[.*?\]/, false) ? linkHref : inlineNormal
	      return type;
	    }
	
	    if (ch === '<' && stream.match(/^(https?|ftps?):\/\/(?:[^\\>]|\\.)+>/, false)) {
	      state.f = state.inline = linkInline;
	      if (modeCfg.highlightFormatting) state.formatting = "link";
	      var type = getType(state);
	      if (type){
	        type += " ";
	      } else {
	        type = "";
	      }
	      return type + tokenTypes.linkInline;
	    }
	
	    if (ch === '<' && stream.match(/^[^> \\]+@(?:[^\\>]|\\.)+>/, false)) {
	      state.f = state.inline = linkInline;
	      if (modeCfg.highlightFormatting) state.formatting = "link";
	      var type = getType(state);
	      if (type){
	        type += " ";
	      } else {
	        type = "";
	      }
	      return type + tokenTypes.linkEmail;
	    }
	
	    if (modeCfg.xml && ch === '<' && stream.match(/^(!--|\?|!\[CDATA\[|[a-z][a-z0-9-]*(?:\s+[a-z_:.\-]+(?:\s*=\s*[^>]+)?)*\s*(?:>|$))/i, false)) {
	      var end = stream.string.indexOf(">", stream.pos);
	      if (end != -1) {
	        var atts = stream.string.substring(stream.start, end);
	        if (/markdown\s*=\s*('|"){0,1}1('|"){0,1}/.test(atts)) state.md_inside = true;
	      }
	      stream.backUp(1);
	      state.htmlState = CodeMirror.startState(htmlMode);
	      return switchBlock(stream, state, htmlBlock);
	    }
	
	    if (modeCfg.xml && ch === '<' && stream.match(/^\/\w*?>/)) {
	      state.md_inside = false;
	      return "tag";
	    } else if (ch === "*" || ch === "_") {
	      var len = 1, before = stream.pos == 1 ? " " : stream.string.charAt(stream.pos - 2)
	      while (len < 3 && stream.eat(ch)) len++
	      var after = stream.peek() || " "
	      // See http://spec.commonmark.org/0.27/#emphasis-and-strong-emphasis
	      var leftFlanking = !/\s/.test(after) && (!punctuation.test(after) || /\s/.test(before) || punctuation.test(before))
	      var rightFlanking = !/\s/.test(before) && (!punctuation.test(before) || /\s/.test(after) || punctuation.test(after))
	      var setEm = null, setStrong = null
	      if (len % 2) { // Em
	        if (!state.em && leftFlanking && (ch === "*" || !rightFlanking || punctuation.test(before)))
	          setEm = true
	        else if (state.em == ch && rightFlanking && (ch === "*" || !leftFlanking || punctuation.test(after)))
	          setEm = false
	      }
	      if (len > 1) { // Strong
	        if (!state.strong && leftFlanking && (ch === "*" || !rightFlanking || punctuation.test(before)))
	          setStrong = true
	        else if (state.strong == ch && rightFlanking && (ch === "*" || !leftFlanking || punctuation.test(after)))
	          setStrong = false
	      }
	      if (setStrong != null || setEm != null) {
	        if (modeCfg.highlightFormatting) state.formatting = setEm == null ? "strong" : setStrong == null ? "em" : "strong em"
	        if (setEm === true) state.em = ch
	        if (setStrong === true) state.strong = ch
	        var t = getType(state)
	        if (setEm === false) state.em = false
	        if (setStrong === false) state.strong = false
	        return t
	      }
	    } else if (ch === ' ') {
	      if (stream.eat('*') || stream.eat('_')) { // Probably surrounded by spaces
	        if (stream.peek() === ' ') { // Surrounded by spaces, ignore
	          return getType(state);
	        } else { // Not surrounded by spaces, back up pointer
	          stream.backUp(1);
	        }
	      }
	    }
	
	    if (modeCfg.strikethrough) {
	      if (ch === '~' && stream.eatWhile(ch)) {
	        if (state.strikethrough) {// Remove strikethrough
	          if (modeCfg.highlightFormatting) state.formatting = "strikethrough";
	          var t = getType(state);
	          state.strikethrough = false;
	          return t;
	        } else if (stream.match(/^[^\s]/, false)) {// Add strikethrough
	          state.strikethrough = true;
	          if (modeCfg.highlightFormatting) state.formatting = "strikethrough";
	          return getType(state);
	        }
	      } else if (ch === ' ') {
	        if (stream.match(/^~~/, true)) { // Probably surrounded by space
	          if (stream.peek() === ' ') { // Surrounded by spaces, ignore
	            return getType(state);
	          } else { // Not surrounded by spaces, back up pointer
	            stream.backUp(2);
	          }
	        }
	      }
	    }
	
	    if (modeCfg.emoji && ch === ":" && stream.match(/^(?:[a-z_\d+][a-z_\d+-]*|\-[a-z_\d+][a-z_\d+-]*):/)) {
	      state.emoji = true;
	      if (modeCfg.highlightFormatting) state.formatting = "emoji";
	      var retType = getType(state);
	      state.emoji = false;
	      return retType;
	    }
	
	    if (ch === ' ') {
	      if (stream.match(/^ +$/, false)) {
	        state.trailingSpace++;
	      } else if (state.trailingSpace) {
	        state.trailingSpaceNewLine = true;
	      }
	    }
	
	    return getType(state);
	  }
	
	  function linkInline(stream, state) {
	    var ch = stream.next();
	
	    if (ch === ">") {
	      state.f = state.inline = inlineNormal;
	      if (modeCfg.highlightFormatting) state.formatting = "link";
	      var type = getType(state);
	      if (type){
	        type += " ";
	      } else {
	        type = "";
	      }
	      return type + tokenTypes.linkInline;
	    }
	
	    stream.match(/^[^>]+/, true);
	
	    return tokenTypes.linkInline;
	  }
	
	  function linkHref(stream, state) {
	    // Check if space, and return NULL if so (to avoid marking the space)
	    if(stream.eatSpace()){
	      return null;
	    }
	    var ch = stream.next();
	    if (ch === '(' || ch === '[') {
	      state.f = state.inline = getLinkHrefInside(ch === "(" ? ")" : "]");
	      if (modeCfg.highlightFormatting) state.formatting = "link-string";
	      state.linkHref = true;
	      return getType(state);
	    }
	    return 'error';
	  }
	
	  var linkRE = {
	    ")": /^(?:[^\\\(\)]|\\.|\((?:[^\\\(\)]|\\.)*\))*?(?=\))/,
	    "]": /^(?:[^\\\[\]]|\\.|\[(?:[^\\\[\]]|\\.)*\])*?(?=\])/
	  }
	
	  function getLinkHrefInside(endChar) {
	    return function(stream, state) {
	      var ch = stream.next();
	
	      if (ch === endChar) {
	        state.f = state.inline = inlineNormal;
	        if (modeCfg.highlightFormatting) state.formatting = "link-string";
	        var returnState = getType(state);
	        state.linkHref = false;
	        return returnState;
	      }
	
	      stream.match(linkRE[endChar])
	      state.linkHref = true;
	      return getType(state);
	    };
	  }
	
	  function footnoteLink(stream, state) {
	    if (stream.match(/^([^\]\\]|\\.)*\]:/, false)) {
	      state.f = footnoteLinkInside;
	      stream.next(); // Consume [
	      if (modeCfg.highlightFormatting) state.formatting = "link";
	      state.linkText = true;
	      return getType(state);
	    }
	    return switchInline(stream, state, inlineNormal);
	  }
	
	  function footnoteLinkInside(stream, state) {
	    if (stream.match(/^\]:/, true)) {
	      state.f = state.inline = footnoteUrl;
	      if (modeCfg.highlightFormatting) state.formatting = "link";
	      var returnType = getType(state);
	      state.linkText = false;
	      return returnType;
	    }
	
	    stream.match(/^([^\]\\]|\\.)+/, true);
	
	    return tokenTypes.linkText;
	  }
	
	  function footnoteUrl(stream, state) {
	    // Check if space, and return NULL if so (to avoid marking the space)
	    if(stream.eatSpace()){
	      return null;
	    }
	    // Match URL
	    stream.match(/^[^\s]+/, true);
	    // Check for link title
	    if (stream.peek() === undefined) { // End of line, set flag to check next line
	      state.linkTitle = true;
	    } else { // More content on line, check if link title
	      stream.match(/^(?:\s+(?:"(?:[^"\\]|\\\\|\\.)+"|'(?:[^'\\]|\\\\|\\.)+'|\((?:[^)\\]|\\\\|\\.)+\)))?/, true);
	    }
	    state.f = state.inline = inlineNormal;
	    return tokenTypes.linkHref + " url";
	  }
	
	  var mode = {
	    startState: function() {
	      return {
	        f: blockNormal,
	
	        prevLine: {stream: null},
	        thisLine: {stream: null},
	
	        block: blockNormal,
	        htmlState: null,
	        indentation: 0,
	
	        inline: inlineNormal,
	        text: handleText,
	
	        formatting: false,
	        linkText: false,
	        linkHref: false,
	        linkTitle: false,
	        code: 0,
	        em: false,
	        strong: false,
	        header: 0,
	        setext: 0,
	        hr: false,
	        taskList: false,
	        list: false,
	        listStack: [],
	        quote: 0,
	        trailingSpace: 0,
	        trailingSpaceNewLine: false,
	        strikethrough: false,
	        emoji: false,
	        fencedEndRE: null
	      };
	    },
	
	    copyState: function(s) {
	      return {
	        f: s.f,
	
	        prevLine: s.prevLine,
	        thisLine: s.thisLine,
	
	        block: s.block,
	        htmlState: s.htmlState && CodeMirror.copyState(htmlMode, s.htmlState),
	        indentation: s.indentation,
	
	        localMode: s.localMode,
	        localState: s.localMode ? CodeMirror.copyState(s.localMode, s.localState) : null,
	
	        inline: s.inline,
	        text: s.text,
	        formatting: false,
	        linkText: s.linkText,
	        linkTitle: s.linkTitle,
	        linkHref: s.linkHref,
	        code: s.code,
	        em: s.em,
	        strong: s.strong,
	        strikethrough: s.strikethrough,
	        emoji: s.emoji,
	        header: s.header,
	        setext: s.setext,
	        hr: s.hr,
	        taskList: s.taskList,
	        list: s.list,
	        listStack: s.listStack.slice(0),
	        quote: s.quote,
	        indentedCode: s.indentedCode,
	        trailingSpace: s.trailingSpace,
	        trailingSpaceNewLine: s.trailingSpaceNewLine,
	        md_inside: s.md_inside,
	        fencedEndRE: s.fencedEndRE
	      };
	    },
	
	    token: function(stream, state) {
	
	      // Reset state.formatting
	      state.formatting = false;
	
	      if (stream != state.thisLine.stream) {
	        state.header = 0;
	        state.hr = false;
	
	        if (stream.match(/^\s*$/, true)) {
	          blankLine(state);
	          return null;
	        }
	
	        state.prevLine = state.thisLine
	        state.thisLine = {stream: stream}
	
	        // Reset state.taskList
	        state.taskList = false;
	
	        // Reset state.trailingSpace
	        state.trailingSpace = 0;
	        state.trailingSpaceNewLine = false;
	
	        if (!state.localState) {
	          state.f = state.block;
	          if (state.f != htmlBlock) {
	            var indentation = stream.match(/^\s*/, true)[0].replace(/\t/g, expandedTab).length;
	            state.indentation = indentation;
	            state.indentationDiff = null;
	            if (indentation > 0) return null;
	          }
	        }
	      }
	      return state.f(stream, state);
	    },
	
	    innerMode: function(state) {
	      if (state.block == htmlBlock) return {state: state.htmlState, mode: htmlMode};
	      if (state.localState) return {state: state.localState, mode: state.localMode};
	      return {state: state, mode: mode};
	    },
	
	    indent: function(state, textAfter, line) {
	      if (state.block == htmlBlock && htmlMode.indent) return htmlMode.indent(state.htmlState, textAfter, line)
	      if (state.localState && state.localMode.indent) return state.localMode.indent(state.localState, textAfter, line)
	      return CodeMirror.Pass
	    },
	
	    blankLine: blankLine,
	
	    getType: getType,
	
	    blockCommentStart: "<!--",
	    blockCommentEnd: "-->",
	    closeBrackets: "()[]{}''\"\"``",
	    fold: "markdown"
	  };
	  return mode;
	}, "xml");
	
	CodeMirror.defineMIME("text/markdown", "markdown");
	
	CodeMirror.defineMIME("text/x-markdown", "markdown");
	
	});


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(1));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  "use strict";
	
	  CodeMirror.modeInfo = [
	    {name: "APL", mime: "text/apl", mode: "apl", ext: ["dyalog", "apl"]},
	    {name: "PGP", mimes: ["application/pgp", "application/pgp-encrypted", "application/pgp-keys", "application/pgp-signature"], mode: "asciiarmor", ext: ["asc", "pgp", "sig"]},
	    {name: "ASN.1", mime: "text/x-ttcn-asn", mode: "asn.1", ext: ["asn", "asn1"]},
	    {name: "Asterisk", mime: "text/x-asterisk", mode: "asterisk", file: /^extensions\.conf$/i},
	    {name: "Brainfuck", mime: "text/x-brainfuck", mode: "brainfuck", ext: ["b", "bf"]},
	    {name: "C", mime: "text/x-csrc", mode: "clike", ext: ["c", "h", "ino"]},
	    {name: "C++", mime: "text/x-c++src", mode: "clike", ext: ["cpp", "c++", "cc", "cxx", "hpp", "h++", "hh", "hxx"], alias: ["cpp"]},
	    {name: "Cobol", mime: "text/x-cobol", mode: "cobol", ext: ["cob", "cpy"]},
	    {name: "C#", mime: "text/x-csharp", mode: "clike", ext: ["cs"], alias: ["csharp", "cs"]},
	    {name: "Clojure", mime: "text/x-clojure", mode: "clojure", ext: ["clj", "cljc", "cljx"]},
	    {name: "ClojureScript", mime: "text/x-clojurescript", mode: "clojure", ext: ["cljs"]},
	    {name: "Closure Stylesheets (GSS)", mime: "text/x-gss", mode: "css", ext: ["gss"]},
	    {name: "CMake", mime: "text/x-cmake", mode: "cmake", ext: ["cmake", "cmake.in"], file: /^CMakeLists.txt$/},
	    {name: "CoffeeScript", mimes: ["application/vnd.coffeescript", "text/coffeescript", "text/x-coffeescript"], mode: "coffeescript", ext: ["coffee"], alias: ["coffee", "coffee-script"]},
	    {name: "Common Lisp", mime: "text/x-common-lisp", mode: "commonlisp", ext: ["cl", "lisp", "el"], alias: ["lisp"]},
	    {name: "Cypher", mime: "application/x-cypher-query", mode: "cypher", ext: ["cyp", "cypher"]},
	    {name: "Cython", mime: "text/x-cython", mode: "python", ext: ["pyx", "pxd", "pxi"]},
	    {name: "Crystal", mime: "text/x-crystal", mode: "crystal", ext: ["cr"]},
	    {name: "CSS", mime: "text/css", mode: "css", ext: ["css"]},
	    {name: "CQL", mime: "text/x-cassandra", mode: "sql", ext: ["cql"]},
	    {name: "D", mime: "text/x-d", mode: "d", ext: ["d"]},
	    {name: "Dart", mimes: ["application/dart", "text/x-dart"], mode: "dart", ext: ["dart"]},
	    {name: "diff", mime: "text/x-diff", mode: "diff", ext: ["diff", "patch"]},
	    {name: "Django", mime: "text/x-django", mode: "django"},
	    {name: "Dockerfile", mime: "text/x-dockerfile", mode: "dockerfile", file: /^Dockerfile$/},
	    {name: "DTD", mime: "application/xml-dtd", mode: "dtd", ext: ["dtd"]},
	    {name: "Dylan", mime: "text/x-dylan", mode: "dylan", ext: ["dylan", "dyl", "intr"]},
	    {name: "EBNF", mime: "text/x-ebnf", mode: "ebnf"},
	    {name: "ECL", mime: "text/x-ecl", mode: "ecl", ext: ["ecl"]},
	    {name: "edn", mime: "application/edn", mode: "clojure", ext: ["edn"]},
	    {name: "Eiffel", mime: "text/x-eiffel", mode: "eiffel", ext: ["e"]},
	    {name: "Elm", mime: "text/x-elm", mode: "elm", ext: ["elm"]},
	    {name: "Embedded Javascript", mime: "application/x-ejs", mode: "htmlembedded", ext: ["ejs"]},
	    {name: "Embedded Ruby", mime: "application/x-erb", mode: "htmlembedded", ext: ["erb"]},
	    {name: "Erlang", mime: "text/x-erlang", mode: "erlang", ext: ["erl"]},
	    {name: "Esper", mime: "text/x-esper", mode: "sql"},
	    {name: "Factor", mime: "text/x-factor", mode: "factor", ext: ["factor"]},
	    {name: "FCL", mime: "text/x-fcl", mode: "fcl"},
	    {name: "Forth", mime: "text/x-forth", mode: "forth", ext: ["forth", "fth", "4th"]},
	    {name: "Fortran", mime: "text/x-fortran", mode: "fortran", ext: ["f", "for", "f77", "f90", "f95"]},
	    {name: "F#", mime: "text/x-fsharp", mode: "mllike", ext: ["fs"], alias: ["fsharp"]},
	    {name: "Gas", mime: "text/x-gas", mode: "gas", ext: ["s"]},
	    {name: "Gherkin", mime: "text/x-feature", mode: "gherkin", ext: ["feature"]},
	    {name: "GitHub Flavored Markdown", mime: "text/x-gfm", mode: "gfm", file: /^(readme|contributing|history).md$/i},
	    {name: "Go", mime: "text/x-go", mode: "go", ext: ["go"]},
	    {name: "Groovy", mime: "text/x-groovy", mode: "groovy", ext: ["groovy", "gradle"], file: /^Jenkinsfile$/},
	    {name: "HAML", mime: "text/x-haml", mode: "haml", ext: ["haml"]},
	    {name: "Haskell", mime: "text/x-haskell", mode: "haskell", ext: ["hs"]},
	    {name: "Haskell (Literate)", mime: "text/x-literate-haskell", mode: "haskell-literate", ext: ["lhs"]},
	    {name: "Haxe", mime: "text/x-haxe", mode: "haxe", ext: ["hx"]},
	    {name: "HXML", mime: "text/x-hxml", mode: "haxe", ext: ["hxml"]},
	    {name: "ASP.NET", mime: "application/x-aspx", mode: "htmlembedded", ext: ["aspx"], alias: ["asp", "aspx"]},
	    {name: "HTML", mime: "text/html", mode: "htmlmixed", ext: ["html", "htm", "handlebars", "hbs"], alias: ["xhtml"]},
	    {name: "HTTP", mime: "message/http", mode: "http"},
	    {name: "IDL", mime: "text/x-idl", mode: "idl", ext: ["pro"]},
	    {name: "Pug", mime: "text/x-pug", mode: "pug", ext: ["jade", "pug"], alias: ["jade"]},
	    {name: "Java", mime: "text/x-java", mode: "clike", ext: ["java"]},
	    {name: "Java Server Pages", mime: "application/x-jsp", mode: "htmlembedded", ext: ["jsp"], alias: ["jsp"]},
	    {name: "JavaScript", mimes: ["text/javascript", "text/ecmascript", "application/javascript", "application/x-javascript", "application/ecmascript"],
	     mode: "javascript", ext: ["js"], alias: ["ecmascript", "js", "node"]},
	    {name: "JSON", mimes: ["application/json", "application/x-json"], mode: "javascript", ext: ["json", "map"], alias: ["json5"]},
	    {name: "JSON-LD", mime: "application/ld+json", mode: "javascript", ext: ["jsonld"], alias: ["jsonld"]},
	    {name: "JSX", mime: "text/jsx", mode: "jsx", ext: ["jsx"]},
	    {name: "Jinja2", mime: "text/jinja2", mode: "jinja2", ext: ["j2", "jinja", "jinja2"]},
	    {name: "Julia", mime: "text/x-julia", mode: "julia", ext: ["jl"]},
	    {name: "Kotlin", mime: "text/x-kotlin", mode: "clike", ext: ["kt"]},
	    {name: "LESS", mime: "text/x-less", mode: "css", ext: ["less"]},
	    {name: "LiveScript", mime: "text/x-livescript", mode: "livescript", ext: ["ls"], alias: ["ls"]},
	    {name: "Lua", mime: "text/x-lua", mode: "lua", ext: ["lua"]},
	    {name: "Markdown", mime: "text/x-markdown", mode: "markdown", ext: ["markdown", "md", "mkd"]},
	    {name: "mIRC", mime: "text/mirc", mode: "mirc"},
	    {name: "MariaDB SQL", mime: "text/x-mariadb", mode: "sql"},
	    {name: "Mathematica", mime: "text/x-mathematica", mode: "mathematica", ext: ["m", "nb", "wl", "wls"]},
	    {name: "Modelica", mime: "text/x-modelica", mode: "modelica", ext: ["mo"]},
	    {name: "MUMPS", mime: "text/x-mumps", mode: "mumps", ext: ["mps"]},
	    {name: "MS SQL", mime: "text/x-mssql", mode: "sql"},
	    {name: "mbox", mime: "application/mbox", mode: "mbox", ext: ["mbox"]},
	    {name: "MySQL", mime: "text/x-mysql", mode: "sql"},
	    {name: "Nginx", mime: "text/x-nginx-conf", mode: "nginx", file: /nginx.*\.conf$/i},
	    {name: "NSIS", mime: "text/x-nsis", mode: "nsis", ext: ["nsh", "nsi"]},
	    {name: "NTriples", mimes: ["application/n-triples", "application/n-quads", "text/n-triples"],
	     mode: "ntriples", ext: ["nt", "nq"]},
	    {name: "Objective-C", mime: "text/x-objectivec", mode: "clike", ext: ["m"], alias: ["objective-c", "objc"]},
	    {name: "Objective-C++", mime: "text/x-objectivec++", mode: "clike", ext: ["mm"], alias: ["objective-c++", "objc++"]},
	    {name: "OCaml", mime: "text/x-ocaml", mode: "mllike", ext: ["ml", "mli", "mll", "mly"]},
	    {name: "Octave", mime: "text/x-octave", mode: "octave", ext: ["m"]},
	    {name: "Oz", mime: "text/x-oz", mode: "oz", ext: ["oz"]},
	    {name: "Pascal", mime: "text/x-pascal", mode: "pascal", ext: ["p", "pas"]},
	    {name: "PEG.js", mime: "null", mode: "pegjs", ext: ["jsonld"]},
	    {name: "Perl", mime: "text/x-perl", mode: "perl", ext: ["pl", "pm"]},
	    {name: "PHP", mimes: ["text/x-php", "application/x-httpd-php", "application/x-httpd-php-open"], mode: "php", ext: ["php", "php3", "php4", "php5", "php7", "phtml"]},
	    {name: "Pig", mime: "text/x-pig", mode: "pig", ext: ["pig"]},
	    {name: "Plain Text", mime: "text/plain", mode: "null", ext: ["txt", "text", "conf", "def", "list", "log"]},
	    {name: "PLSQL", mime: "text/x-plsql", mode: "sql", ext: ["pls"]},
	    {name: "PostgreSQL", mime: "text/x-pgsql", mode: "sql"},
	    {name: "PowerShell", mime: "application/x-powershell", mode: "powershell", ext: ["ps1", "psd1", "psm1"]},
	    {name: "Properties files", mime: "text/x-properties", mode: "properties", ext: ["properties", "ini", "in"], alias: ["ini", "properties"]},
	    {name: "ProtoBuf", mime: "text/x-protobuf", mode: "protobuf", ext: ["proto"]},
	    {name: "Python", mime: "text/x-python", mode: "python", ext: ["BUILD", "bzl", "py", "pyw"], file: /^(BUCK|BUILD)$/},
	    {name: "Puppet", mime: "text/x-puppet", mode: "puppet", ext: ["pp"]},
	    {name: "Q", mime: "text/x-q", mode: "q", ext: ["q"]},
	    {name: "R", mime: "text/x-rsrc", mode: "r", ext: ["r", "R"], alias: ["rscript"]},
	    {name: "reStructuredText", mime: "text/x-rst", mode: "rst", ext: ["rst"], alias: ["rst"]},
	    {name: "RPM Changes", mime: "text/x-rpm-changes", mode: "rpm"},
	    {name: "RPM Spec", mime: "text/x-rpm-spec", mode: "rpm", ext: ["spec"]},
	    {name: "Ruby", mime: "text/x-ruby", mode: "ruby", ext: ["rb"], alias: ["jruby", "macruby", "rake", "rb", "rbx"]},
	    {name: "Rust", mime: "text/x-rustsrc", mode: "rust", ext: ["rs"]},
	    {name: "SAS", mime: "text/x-sas", mode: "sas", ext: ["sas"]},
	    {name: "Sass", mime: "text/x-sass", mode: "sass", ext: ["sass"]},
	    {name: "Scala", mime: "text/x-scala", mode: "clike", ext: ["scala"]},
	    {name: "Scheme", mime: "text/x-scheme", mode: "scheme", ext: ["scm", "ss"]},
	    {name: "SCSS", mime: "text/x-scss", mode: "css", ext: ["scss"]},
	    {name: "Shell", mimes: ["text/x-sh", "application/x-sh"], mode: "shell", ext: ["sh", "ksh", "bash"], alias: ["bash", "sh", "zsh"], file: /^PKGBUILD$/},
	    {name: "Sieve", mime: "application/sieve", mode: "sieve", ext: ["siv", "sieve"]},
	    {name: "Slim", mimes: ["text/x-slim", "application/x-slim"], mode: "slim", ext: ["slim"]},
	    {name: "Smalltalk", mime: "text/x-stsrc", mode: "smalltalk", ext: ["st"]},
	    {name: "Smarty", mime: "text/x-smarty", mode: "smarty", ext: ["tpl"]},
	    {name: "Solr", mime: "text/x-solr", mode: "solr"},
	    {name: "SML", mime: "text/x-sml", mode: "mllike", ext: ["sml", "sig", "fun", "smackspec"]},
	    {name: "Soy", mime: "text/x-soy", mode: "soy", ext: ["soy"], alias: ["closure template"]},
	    {name: "SPARQL", mime: "application/sparql-query", mode: "sparql", ext: ["rq", "sparql"], alias: ["sparul"]},
	    {name: "Spreadsheet", mime: "text/x-spreadsheet", mode: "spreadsheet", alias: ["excel", "formula"]},
	    {name: "SQL", mime: "text/x-sql", mode: "sql", ext: ["sql"]},
	    {name: "SQLite", mime: "text/x-sqlite", mode: "sql"},
	    {name: "Squirrel", mime: "text/x-squirrel", mode: "clike", ext: ["nut"]},
	    {name: "Stylus", mime: "text/x-styl", mode: "stylus", ext: ["styl"]},
	    {name: "Swift", mime: "text/x-swift", mode: "swift", ext: ["swift"]},
	    {name: "sTeX", mime: "text/x-stex", mode: "stex"},
	    {name: "LaTeX", mime: "text/x-latex", mode: "stex", ext: ["text", "ltx", "tex"], alias: ["tex"]},
	    {name: "SystemVerilog", mime: "text/x-systemverilog", mode: "verilog", ext: ["v", "sv", "svh"]},
	    {name: "Tcl", mime: "text/x-tcl", mode: "tcl", ext: ["tcl"]},
	    {name: "Textile", mime: "text/x-textile", mode: "textile", ext: ["textile"]},
	    {name: "TiddlyWiki ", mime: "text/x-tiddlywiki", mode: "tiddlywiki"},
	    {name: "Tiki wiki", mime: "text/tiki", mode: "tiki"},
	    {name: "TOML", mime: "text/x-toml", mode: "toml", ext: ["toml"]},
	    {name: "Tornado", mime: "text/x-tornado", mode: "tornado"},
	    {name: "troff", mime: "text/troff", mode: "troff", ext: ["1", "2", "3", "4", "5", "6", "7", "8", "9"]},
	    {name: "TTCN", mime: "text/x-ttcn", mode: "ttcn", ext: ["ttcn", "ttcn3", "ttcnpp"]},
	    {name: "TTCN_CFG", mime: "text/x-ttcn-cfg", mode: "ttcn-cfg", ext: ["cfg"]},
	    {name: "Turtle", mime: "text/turtle", mode: "turtle", ext: ["ttl"]},
	    {name: "TypeScript", mime: "application/typescript", mode: "javascript", ext: ["ts"], alias: ["ts"]},
	    {name: "TypeScript-JSX", mime: "text/typescript-jsx", mode: "jsx", ext: ["tsx"], alias: ["tsx"]},
	    {name: "Twig", mime: "text/x-twig", mode: "twig"},
	    {name: "Web IDL", mime: "text/x-webidl", mode: "webidl", ext: ["webidl"]},
	    {name: "VB.NET", mime: "text/x-vb", mode: "vb", ext: ["vb"]},
	    {name: "VBScript", mime: "text/vbscript", mode: "vbscript", ext: ["vbs"]},
	    {name: "Velocity", mime: "text/velocity", mode: "velocity", ext: ["vtl"]},
	    {name: "Verilog", mime: "text/x-verilog", mode: "verilog", ext: ["v"]},
	    {name: "VHDL", mime: "text/x-vhdl", mode: "vhdl", ext: ["vhd", "vhdl"]},
	    {name: "Vue.js Component", mimes: ["script/x-vue", "text/x-vue"], mode: "vue", ext: ["vue"]},
	    {name: "XML", mimes: ["application/xml", "text/xml"], mode: "xml", ext: ["xml", "xsl", "xsd", "svg"], alias: ["rss", "wsdl", "xsd"]},
	    {name: "XQuery", mime: "application/xquery", mode: "xquery", ext: ["xy", "xquery"]},
	    {name: "Yacas", mime: "text/x-yacas", mode: "yacas", ext: ["ys"]},
	    {name: "YAML", mimes: ["text/x-yaml", "text/yaml"], mode: "yaml", ext: ["yaml", "yml"], alias: ["yml"]},
	    {name: "Z80", mime: "text/x-z80", mode: "z80", ext: ["z80"]},
	    {name: "mscgen", mime: "text/x-mscgen", mode: "mscgen", ext: ["mscgen", "mscin", "msc"]},
	    {name: "xu", mime: "text/x-xu", mode: "mscgen", ext: ["xu"]},
	    {name: "msgenny", mime: "text/x-msgenny", mode: "mscgen", ext: ["msgenny"]}
	  ];
	  // Ensure all modes have a mime property for backwards compatibility
	  for (var i = 0; i < CodeMirror.modeInfo.length; i++) {
	    var info = CodeMirror.modeInfo[i];
	    if (info.mimes) info.mime = info.mimes[0];
	  }
	
	  CodeMirror.findModeByMIME = function(mime) {
	    mime = mime.toLowerCase();
	    for (var i = 0; i < CodeMirror.modeInfo.length; i++) {
	      var info = CodeMirror.modeInfo[i];
	      if (info.mime == mime) return info;
	      if (info.mimes) for (var j = 0; j < info.mimes.length; j++)
	        if (info.mimes[j] == mime) return info;
	    }
	    if (/\+xml$/.test(mime)) return CodeMirror.findModeByMIME("application/xml")
	    if (/\+json$/.test(mime)) return CodeMirror.findModeByMIME("application/json")
	  };
	
	  CodeMirror.findModeByExtension = function(ext) {
	    ext = ext.toLowerCase();
	    for (var i = 0; i < CodeMirror.modeInfo.length; i++) {
	      var info = CodeMirror.modeInfo[i];
	      if (info.ext) for (var j = 0; j < info.ext.length; j++)
	        if (info.ext[j] == ext) return info;
	    }
	  };
	
	  CodeMirror.findModeByFileName = function(filename) {
	    for (var i = 0; i < CodeMirror.modeInfo.length; i++) {
	      var info = CodeMirror.modeInfo[i];
	      if (info.file && info.file.test(filename)) return info;
	    }
	    var dot = filename.lastIndexOf(".");
	    var ext = dot > -1 && filename.substring(dot + 1, filename.length);
	    if (ext) return CodeMirror.findModeByExtension(ext);
	  };
	
	  CodeMirror.findModeByName = function(name) {
	    name = name.toLowerCase();
	    for (var i = 0; i < CodeMirror.modeInfo.length; i++) {
	      var info = CodeMirror.modeInfo[i];
	      if (info.name.toLowerCase() == name) return info;
	      if (info.alias) for (var j = 0; j < info.alias.length; j++)
	        if (info.alias[j].toLowerCase() == name) return info;
	    }
	  };
	});


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(1));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("nginx", function(config) {
	
	  function words(str) {
	    var obj = {}, words = str.split(" ");
	    for (var i = 0; i < words.length; ++i) obj[words[i]] = true;
	    return obj;
	  }
	
	  var keywords = words(
	    /* ngxDirectiveControl */ "break return rewrite set" +
	    /* ngxDirective */ " accept_mutex accept_mutex_delay access_log add_after_body add_before_body add_header addition_types aio alias allow ancient_browser ancient_browser_value auth_basic auth_basic_user_file auth_http auth_http_header auth_http_timeout autoindex autoindex_exact_size autoindex_localtime charset charset_types client_body_buffer_size client_body_in_file_only client_body_in_single_buffer client_body_temp_path client_body_timeout client_header_buffer_size client_header_timeout client_max_body_size connection_pool_size create_full_put_path daemon dav_access dav_methods debug_connection debug_points default_type degradation degrade deny devpoll_changes devpoll_events directio directio_alignment empty_gif env epoll_events error_log eventport_events expires fastcgi_bind fastcgi_buffer_size fastcgi_buffers fastcgi_busy_buffers_size fastcgi_cache fastcgi_cache_key fastcgi_cache_methods fastcgi_cache_min_uses fastcgi_cache_path fastcgi_cache_use_stale fastcgi_cache_valid fastcgi_catch_stderr fastcgi_connect_timeout fastcgi_hide_header fastcgi_ignore_client_abort fastcgi_ignore_headers fastcgi_index fastcgi_intercept_errors fastcgi_max_temp_file_size fastcgi_next_upstream fastcgi_param fastcgi_pass_header fastcgi_pass_request_body fastcgi_pass_request_headers fastcgi_read_timeout fastcgi_send_lowat fastcgi_send_timeout fastcgi_split_path_info fastcgi_store fastcgi_store_access fastcgi_temp_file_write_size fastcgi_temp_path fastcgi_upstream_fail_timeout fastcgi_upstream_max_fails flv geoip_city geoip_country google_perftools_profiles gzip gzip_buffers gzip_comp_level gzip_disable gzip_hash gzip_http_version gzip_min_length gzip_no_buffer gzip_proxied gzip_static gzip_types gzip_vary gzip_window if_modified_since ignore_invalid_headers image_filter image_filter_buffer image_filter_jpeg_quality image_filter_transparency imap_auth imap_capabilities imap_client_buffer index ip_hash keepalive_requests keepalive_timeout kqueue_changes kqueue_events large_client_header_buffers limit_conn limit_conn_log_level limit_rate limit_rate_after limit_req limit_req_log_level limit_req_zone limit_zone lingering_time lingering_timeout lock_file log_format log_not_found log_subrequest map_hash_bucket_size map_hash_max_size master_process memcached_bind memcached_buffer_size memcached_connect_timeout memcached_next_upstream memcached_read_timeout memcached_send_timeout memcached_upstream_fail_timeout memcached_upstream_max_fails merge_slashes min_delete_depth modern_browser modern_browser_value msie_padding msie_refresh multi_accept open_file_cache open_file_cache_errors open_file_cache_events open_file_cache_min_uses open_file_cache_valid open_log_file_cache output_buffers override_charset perl perl_modules perl_require perl_set pid pop3_auth pop3_capabilities port_in_redirect postpone_gzipping postpone_output protocol proxy proxy_bind proxy_buffer proxy_buffer_size proxy_buffering proxy_buffers proxy_busy_buffers_size proxy_cache proxy_cache_key proxy_cache_methods proxy_cache_min_uses proxy_cache_path proxy_cache_use_stale proxy_cache_valid proxy_connect_timeout proxy_headers_hash_bucket_size proxy_headers_hash_max_size proxy_hide_header proxy_ignore_client_abort proxy_ignore_headers proxy_intercept_errors proxy_max_temp_file_size proxy_method proxy_next_upstream proxy_pass_error_message proxy_pass_header proxy_pass_request_body proxy_pass_request_headers proxy_read_timeout proxy_redirect proxy_send_lowat proxy_send_timeout proxy_set_body proxy_set_header proxy_ssl_session_reuse proxy_store proxy_store_access proxy_temp_file_write_size proxy_temp_path proxy_timeout proxy_upstream_fail_timeout proxy_upstream_max_fails random_index read_ahead real_ip_header recursive_error_pages request_pool_size reset_timedout_connection resolver resolver_timeout rewrite_log rtsig_overflow_events rtsig_overflow_test rtsig_overflow_threshold rtsig_signo satisfy secure_link_secret send_lowat send_timeout sendfile sendfile_max_chunk server_name_in_redirect server_names_hash_bucket_size server_names_hash_max_size server_tokens set_real_ip_from smtp_auth smtp_capabilities smtp_client_buffer smtp_greeting_delay so_keepalive source_charset ssi ssi_ignore_recycled_buffers ssi_min_file_chunk ssi_silent_errors ssi_types ssi_value_length ssl ssl_certificate ssl_certificate_key ssl_ciphers ssl_client_certificate ssl_crl ssl_dhparam ssl_engine ssl_prefer_server_ciphers ssl_protocols ssl_session_cache ssl_session_timeout ssl_verify_client ssl_verify_depth starttls stub_status sub_filter sub_filter_once sub_filter_types tcp_nodelay tcp_nopush thread_stack_size timeout timer_resolution types_hash_bucket_size types_hash_max_size underscores_in_headers uninitialized_variable_warn use user userid userid_domain userid_expires userid_mark userid_name userid_p3p userid_path userid_service valid_referers variables_hash_bucket_size variables_hash_max_size worker_connections worker_cpu_affinity worker_priority worker_processes worker_rlimit_core worker_rlimit_nofile worker_rlimit_sigpending worker_threads working_directory xclient xml_entities xslt_stylesheet xslt_typesdrew@li229-23"
	    );
	
	  var keywords_block = words(
	    /* ngxDirectiveBlock */ "http mail events server types location upstream charset_map limit_except if geo map"
	    );
	
	  var keywords_important = words(
	    /* ngxDirectiveImportant */ "include root server server_name listen internal proxy_pass memcached_pass fastcgi_pass try_files"
	    );
	
	  var indentUnit = config.indentUnit, type;
	  function ret(style, tp) {type = tp; return style;}
	
	  function tokenBase(stream, state) {
	
	
	    stream.eatWhile(/[\w\$_]/);
	
	    var cur = stream.current();
	
	
	    if (keywords.propertyIsEnumerable(cur)) {
	      return "keyword";
	    }
	    else if (keywords_block.propertyIsEnumerable(cur)) {
	      return "variable-2";
	    }
	    else if (keywords_important.propertyIsEnumerable(cur)) {
	      return "string-2";
	    }
	    /**/
	
	    var ch = stream.next();
	    if (ch == "@") {stream.eatWhile(/[\w\\\-]/); return ret("meta", stream.current());}
	    else if (ch == "/" && stream.eat("*")) {
	      state.tokenize = tokenCComment;
	      return tokenCComment(stream, state);
	    }
	    else if (ch == "<" && stream.eat("!")) {
	      state.tokenize = tokenSGMLComment;
	      return tokenSGMLComment(stream, state);
	    }
	    else if (ch == "=") ret(null, "compare");
	    else if ((ch == "~" || ch == "|") && stream.eat("=")) return ret(null, "compare");
	    else if (ch == "\"" || ch == "'") {
	      state.tokenize = tokenString(ch);
	      return state.tokenize(stream, state);
	    }
	    else if (ch == "#") {
	      stream.skipToEnd();
	      return ret("comment", "comment");
	    }
	    else if (ch == "!") {
	      stream.match(/^\s*\w*/);
	      return ret("keyword", "important");
	    }
	    else if (/\d/.test(ch)) {
	      stream.eatWhile(/[\w.%]/);
	      return ret("number", "unit");
	    }
	    else if (/[,.+>*\/]/.test(ch)) {
	      return ret(null, "select-op");
	    }
	    else if (/[;{}:\[\]]/.test(ch)) {
	      return ret(null, ch);
	    }
	    else {
	      stream.eatWhile(/[\w\\\-]/);
	      return ret("variable", "variable");
	    }
	  }
	
	  function tokenCComment(stream, state) {
	    var maybeEnd = false, ch;
	    while ((ch = stream.next()) != null) {
	      if (maybeEnd && ch == "/") {
	        state.tokenize = tokenBase;
	        break;
	      }
	      maybeEnd = (ch == "*");
	    }
	    return ret("comment", "comment");
	  }
	
	  function tokenSGMLComment(stream, state) {
	    var dashes = 0, ch;
	    while ((ch = stream.next()) != null) {
	      if (dashes >= 2 && ch == ">") {
	        state.tokenize = tokenBase;
	        break;
	      }
	      dashes = (ch == "-") ? dashes + 1 : 0;
	    }
	    return ret("comment", "comment");
	  }
	
	  function tokenString(quote) {
	    return function(stream, state) {
	      var escaped = false, ch;
	      while ((ch = stream.next()) != null) {
	        if (ch == quote && !escaped)
	          break;
	        escaped = !escaped && ch == "\\";
	      }
	      if (!escaped) state.tokenize = tokenBase;
	      return ret("string", "string");
	    };
	  }
	
	  return {
	    startState: function(base) {
	      return {tokenize: tokenBase,
	              baseIndent: base || 0,
	              stack: []};
	    },
	
	    token: function(stream, state) {
	      if (stream.eatSpace()) return null;
	      type = null;
	      var style = state.tokenize(stream, state);
	
	      var context = state.stack[state.stack.length-1];
	      if (type == "hash" && context == "rule") style = "atom";
	      else if (style == "variable") {
	        if (context == "rule") style = "number";
	        else if (!context || context == "@media{") style = "tag";
	      }
	
	      if (context == "rule" && /^[\{\};]$/.test(type))
	        state.stack.pop();
	      if (type == "{") {
	        if (context == "@media") state.stack[state.stack.length-1] = "@media{";
	        else state.stack.push("{");
	      }
	      else if (type == "}") state.stack.pop();
	      else if (type == "@media") state.stack.push("@media");
	      else if (context == "{" && type != "comment") state.stack.push("rule");
	      return style;
	    },
	
	    indent: function(state, textAfter) {
	      var n = state.stack.length;
	      if (/^\}/.test(textAfter))
	        n -= state.stack[state.stack.length-1] == "rule" ? 2 : 1;
	      return state.baseIndent + n * indentUnit;
	    },
	
	    electricChars: "}"
	  };
	});
	
	CodeMirror.defineMIME("text/x-nginx-conf", "nginx");
	
	});


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/LICENSE
	
	// CodeMirror2 mode/perl/perl.js (text/x-perl) beta 0.10 (2011-11-08)
	// This is a part of CodeMirror from https://github.com/sabaca/CodeMirror_mode_perl (mail@sabaca.com)
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(1));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("perl",function(){
	        // http://perldoc.perl.org
	        var PERL={                                      //   null - magic touch
	                                                        //   1 - keyword
	                                                        //   2 - def
	                                                        //   3 - atom
	                                                        //   4 - operator
	                                                        //   5 - variable-2 (predefined)
	                                                        //   [x,y] - x=1,2,3; y=must be defined if x{...}
	                                                //      PERL operators
	                '->'                            :   4,
	                '++'                            :   4,
	                '--'                            :   4,
	                '**'                            :   4,
	                                                        //   ! ~ \ and unary + and -
	                '=~'                            :   4,
	                '!~'                            :   4,
	                '*'                             :   4,
	                '/'                             :   4,
	                '%'                             :   4,
	                'x'                             :   4,
	                '+'                             :   4,
	                '-'                             :   4,
	                '.'                             :   4,
	                '<<'                            :   4,
	                '>>'                            :   4,
	                                                        //   named unary operators
	                '<'                             :   4,
	                '>'                             :   4,
	                '<='                            :   4,
	                '>='                            :   4,
	                'lt'                            :   4,
	                'gt'                            :   4,
	                'le'                            :   4,
	                'ge'                            :   4,
	                '=='                            :   4,
	                '!='                            :   4,
	                '<=>'                           :   4,
	                'eq'                            :   4,
	                'ne'                            :   4,
	                'cmp'                           :   4,
	                '~~'                            :   4,
	                '&'                             :   4,
	                '|'                             :   4,
	                '^'                             :   4,
	                '&&'                            :   4,
	                '||'                            :   4,
	                '//'                            :   4,
	                '..'                            :   4,
	                '...'                           :   4,
	                '?'                             :   4,
	                ':'                             :   4,
	                '='                             :   4,
	                '+='                            :   4,
	                '-='                            :   4,
	                '*='                            :   4,  //   etc. ???
	                ','                             :   4,
	                '=>'                            :   4,
	                '::'                            :   4,
	                                                        //   list operators (rightward)
	                'not'                           :   4,
	                'and'                           :   4,
	                'or'                            :   4,
	                'xor'                           :   4,
	                                                //      PERL predefined variables (I know, what this is a paranoid idea, but may be needed for people, who learn PERL, and for me as well, ...and may be for you?;)
	                'BEGIN'                         :   [5,1],
	                'END'                           :   [5,1],
	                'PRINT'                         :   [5,1],
	                'PRINTF'                        :   [5,1],
	                'GETC'                          :   [5,1],
	                'READ'                          :   [5,1],
	                'READLINE'                      :   [5,1],
	                'DESTROY'                       :   [5,1],
	                'TIE'                           :   [5,1],
	                'TIEHANDLE'                     :   [5,1],
	                'UNTIE'                         :   [5,1],
	                'STDIN'                         :    5,
	                'STDIN_TOP'                     :    5,
	                'STDOUT'                        :    5,
	                'STDOUT_TOP'                    :    5,
	                'STDERR'                        :    5,
	                'STDERR_TOP'                    :    5,
	                '$ARG'                          :    5,
	                '$_'                            :    5,
	                '@ARG'                          :    5,
	                '@_'                            :    5,
	                '$LIST_SEPARATOR'               :    5,
	                '$"'                            :    5,
	                '$PROCESS_ID'                   :    5,
	                '$PID'                          :    5,
	                '$$'                            :    5,
	                '$REAL_GROUP_ID'                :    5,
	                '$GID'                          :    5,
	                '$('                            :    5,
	                '$EFFECTIVE_GROUP_ID'           :    5,
	                '$EGID'                         :    5,
	                '$)'                            :    5,
	                '$PROGRAM_NAME'                 :    5,
	                '$0'                            :    5,
	                '$SUBSCRIPT_SEPARATOR'          :    5,
	                '$SUBSEP'                       :    5,
	                '$;'                            :    5,
	                '$REAL_USER_ID'                 :    5,
	                '$UID'                          :    5,
	                '$<'                            :    5,
	                '$EFFECTIVE_USER_ID'            :    5,
	                '$EUID'                         :    5,
	                '$>'                            :    5,
	                '$a'                            :    5,
	                '$b'                            :    5,
	                '$COMPILING'                    :    5,
	                '$^C'                           :    5,
	                '$DEBUGGING'                    :    5,
	                '$^D'                           :    5,
	                '${^ENCODING}'                  :    5,
	                '$ENV'                          :    5,
	                '%ENV'                          :    5,
	                '$SYSTEM_FD_MAX'                :    5,
	                '$^F'                           :    5,
	                '@F'                            :    5,
	                '${^GLOBAL_PHASE}'              :    5,
	                '$^H'                           :    5,
	                '%^H'                           :    5,
	                '@INC'                          :    5,
	                '%INC'                          :    5,
	                '$INPLACE_EDIT'                 :    5,
	                '$^I'                           :    5,
	                '$^M'                           :    5,
	                '$OSNAME'                       :    5,
	                '$^O'                           :    5,
	                '${^OPEN}'                      :    5,
	                '$PERLDB'                       :    5,
	                '$^P'                           :    5,
	                '$SIG'                          :    5,
	                '%SIG'                          :    5,
	                '$BASETIME'                     :    5,
	                '$^T'                           :    5,
	                '${^TAINT}'                     :    5,
	                '${^UNICODE}'                   :    5,
	                '${^UTF8CACHE}'                 :    5,
	                '${^UTF8LOCALE}'                :    5,
	                '$PERL_VERSION'                 :    5,
	                '$^V'                           :    5,
	                '${^WIN32_SLOPPY_STAT}'         :    5,
	                '$EXECUTABLE_NAME'              :    5,
	                '$^X'                           :    5,
	                '$1'                            :    5, // - regexp $1, $2...
	                '$MATCH'                        :    5,
	                '$&'                            :    5,
	                '${^MATCH}'                     :    5,
	                '$PREMATCH'                     :    5,
	                '$`'                            :    5,
	                '${^PREMATCH}'                  :    5,
	                '$POSTMATCH'                    :    5,
	                "$'"                            :    5,
	                '${^POSTMATCH}'                 :    5,
	                '$LAST_PAREN_MATCH'             :    5,
	                '$+'                            :    5,
	                '$LAST_SUBMATCH_RESULT'         :    5,
	                '$^N'                           :    5,
	                '@LAST_MATCH_END'               :    5,
	                '@+'                            :    5,
	                '%LAST_PAREN_MATCH'             :    5,
	                '%+'                            :    5,
	                '@LAST_MATCH_START'             :    5,
	                '@-'                            :    5,
	                '%LAST_MATCH_START'             :    5,
	                '%-'                            :    5,
	                '$LAST_REGEXP_CODE_RESULT'      :    5,
	                '$^R'                           :    5,
	                '${^RE_DEBUG_FLAGS}'            :    5,
	                '${^RE_TRIE_MAXBUF}'            :    5,
	                '$ARGV'                         :    5,
	                '@ARGV'                         :    5,
	                'ARGV'                          :    5,
	                'ARGVOUT'                       :    5,
	                '$OUTPUT_FIELD_SEPARATOR'       :    5,
	                '$OFS'                          :    5,
	                '$,'                            :    5,
	                '$INPUT_LINE_NUMBER'            :    5,
	                '$NR'                           :    5,
	                '$.'                            :    5,
	                '$INPUT_RECORD_SEPARATOR'       :    5,
	                '$RS'                           :    5,
	                '$/'                            :    5,
	                '$OUTPUT_RECORD_SEPARATOR'      :    5,
	                '$ORS'                          :    5,
	                '$\\'                           :    5,
	                '$OUTPUT_AUTOFLUSH'             :    5,
	                '$|'                            :    5,
	                '$ACCUMULATOR'                  :    5,
	                '$^A'                           :    5,
	                '$FORMAT_FORMFEED'              :    5,
	                '$^L'                           :    5,
	                '$FORMAT_PAGE_NUMBER'           :    5,
	                '$%'                            :    5,
	                '$FORMAT_LINES_LEFT'            :    5,
	                '$-'                            :    5,
	                '$FORMAT_LINE_BREAK_CHARACTERS' :    5,
	                '$:'                            :    5,
	                '$FORMAT_LINES_PER_PAGE'        :    5,
	                '$='                            :    5,
	                '$FORMAT_TOP_NAME'              :    5,
	                '$^'                            :    5,
	                '$FORMAT_NAME'                  :    5,
	                '$~'                            :    5,
	                '${^CHILD_ERROR_NATIVE}'        :    5,
	                '$EXTENDED_OS_ERROR'            :    5,
	                '$^E'                           :    5,
	                '$EXCEPTIONS_BEING_CAUGHT'      :    5,
	                '$^S'                           :    5,
	                '$WARNING'                      :    5,
	                '$^W'                           :    5,
	                '${^WARNING_BITS}'              :    5,
	                '$OS_ERROR'                     :    5,
	                '$ERRNO'                        :    5,
	                '$!'                            :    5,
	                '%OS_ERROR'                     :    5,
	                '%ERRNO'                        :    5,
	                '%!'                            :    5,
	                '$CHILD_ERROR'                  :    5,
	                '$?'                            :    5,
	                '$EVAL_ERROR'                   :    5,
	                '$@'                            :    5,
	                '$OFMT'                         :    5,
	                '$#'                            :    5,
	                '$*'                            :    5,
	                '$ARRAY_BASE'                   :    5,
	                '$['                            :    5,
	                '$OLD_PERL_VERSION'             :    5,
	                '$]'                            :    5,
	                                                //      PERL blocks
	                'if'                            :[1,1],
	                elsif                           :[1,1],
	                'else'                          :[1,1],
	                'while'                         :[1,1],
	                unless                          :[1,1],
	                'for'                           :[1,1],
	                foreach                         :[1,1],
	                                                //      PERL functions
	                'abs'                           :1,     // - absolute value function
	                accept                          :1,     // - accept an incoming socket connect
	                alarm                           :1,     // - schedule a SIGALRM
	                'atan2'                         :1,     // - arctangent of Y/X in the range -PI to PI
	                bind                            :1,     // - binds an address to a socket
	                binmode                         :1,     // - prepare binary files for I/O
	                bless                           :1,     // - create an object
	                bootstrap                       :1,     //
	                'break'                         :1,     // - break out of a "given" block
	                caller                          :1,     // - get context of the current subroutine call
	                chdir                           :1,     // - change your current working directory
	                chmod                           :1,     // - changes the permissions on a list of files
	                chomp                           :1,     // - remove a trailing record separator from a string
	                chop                            :1,     // - remove the last character from a string
	                chown                           :1,     // - change the ownership on a list of files
	                chr                             :1,     // - get character this number represents
	                chroot                          :1,     // - make directory new root for path lookups
	                close                           :1,     // - close file (or pipe or socket) handle
	                closedir                        :1,     // - close directory handle
	                connect                         :1,     // - connect to a remote socket
	                'continue'                      :[1,1], // - optional trailing block in a while or foreach
	                'cos'                           :1,     // - cosine function
	                crypt                           :1,     // - one-way passwd-style encryption
	                dbmclose                        :1,     // - breaks binding on a tied dbm file
	                dbmopen                         :1,     // - create binding on a tied dbm file
	                'default'                       :1,     //
	                defined                         :1,     // - test whether a value, variable, or function is defined
	                'delete'                        :1,     // - deletes a value from a hash
	                die                             :1,     // - raise an exception or bail out
	                'do'                            :1,     // - turn a BLOCK into a TERM
	                dump                            :1,     // - create an immediate core dump
	                each                            :1,     // - retrieve the next key/value pair from a hash
	                endgrent                        :1,     // - be done using group file
	                endhostent                      :1,     // - be done using hosts file
	                endnetent                       :1,     // - be done using networks file
	                endprotoent                     :1,     // - be done using protocols file
	                endpwent                        :1,     // - be done using passwd file
	                endservent                      :1,     // - be done using services file
	                eof                             :1,     // - test a filehandle for its end
	                'eval'                          :1,     // - catch exceptions or compile and run code
	                'exec'                          :1,     // - abandon this program to run another
	                exists                          :1,     // - test whether a hash key is present
	                exit                            :1,     // - terminate this program
	                'exp'                           :1,     // - raise I to a power
	                fcntl                           :1,     // - file control system call
	                fileno                          :1,     // - return file descriptor from filehandle
	                flock                           :1,     // - lock an entire file with an advisory lock
	                fork                            :1,     // - create a new process just like this one
	                format                          :1,     // - declare a picture format with use by the write() function
	                formline                        :1,     // - internal function used for formats
	                getc                            :1,     // - get the next character from the filehandle
	                getgrent                        :1,     // - get next group record
	                getgrgid                        :1,     // - get group record given group user ID
	                getgrnam                        :1,     // - get group record given group name
	                gethostbyaddr                   :1,     // - get host record given its address
	                gethostbyname                   :1,     // - get host record given name
	                gethostent                      :1,     // - get next hosts record
	                getlogin                        :1,     // - return who logged in at this tty
	                getnetbyaddr                    :1,     // - get network record given its address
	                getnetbyname                    :1,     // - get networks record given name
	                getnetent                       :1,     // - get next networks record
	                getpeername                     :1,     // - find the other end of a socket connection
	                getpgrp                         :1,     // - get process group
	                getppid                         :1,     // - get parent process ID
	                getpriority                     :1,     // - get current nice value
	                getprotobyname                  :1,     // - get protocol record given name
	                getprotobynumber                :1,     // - get protocol record numeric protocol
	                getprotoent                     :1,     // - get next protocols record
	                getpwent                        :1,     // - get next passwd record
	                getpwnam                        :1,     // - get passwd record given user login name
	                getpwuid                        :1,     // - get passwd record given user ID
	                getservbyname                   :1,     // - get services record given its name
	                getservbyport                   :1,     // - get services record given numeric port
	                getservent                      :1,     // - get next services record
	                getsockname                     :1,     // - retrieve the sockaddr for a given socket
	                getsockopt                      :1,     // - get socket options on a given socket
	                given                           :1,     //
	                glob                            :1,     // - expand filenames using wildcards
	                gmtime                          :1,     // - convert UNIX time into record or string using Greenwich time
	                'goto'                          :1,     // - create spaghetti code
	                grep                            :1,     // - locate elements in a list test true against a given criterion
	                hex                             :1,     // - convert a string to a hexadecimal number
	                'import'                        :1,     // - patch a module's namespace into your own
	                index                           :1,     // - find a substring within a string
	                'int'                           :1,     // - get the integer portion of a number
	                ioctl                           :1,     // - system-dependent device control system call
	                'join'                          :1,     // - join a list into a string using a separator
	                keys                            :1,     // - retrieve list of indices from a hash
	                kill                            :1,     // - send a signal to a process or process group
	                last                            :1,     // - exit a block prematurely
	                lc                              :1,     // - return lower-case version of a string
	                lcfirst                         :1,     // - return a string with just the next letter in lower case
	                length                          :1,     // - return the number of bytes in a string
	                'link'                          :1,     // - create a hard link in the filesytem
	                listen                          :1,     // - register your socket as a server
	                local                           : 2,    // - create a temporary value for a global variable (dynamic scoping)
	                localtime                       :1,     // - convert UNIX time into record or string using local time
	                lock                            :1,     // - get a thread lock on a variable, subroutine, or method
	                'log'                           :1,     // - retrieve the natural logarithm for a number
	                lstat                           :1,     // - stat a symbolic link
	                m                               :null,  // - match a string with a regular expression pattern
	                map                             :1,     // - apply a change to a list to get back a new list with the changes
	                mkdir                           :1,     // - create a directory
	                msgctl                          :1,     // - SysV IPC message control operations
	                msgget                          :1,     // - get SysV IPC message queue
	                msgrcv                          :1,     // - receive a SysV IPC message from a message queue
	                msgsnd                          :1,     // - send a SysV IPC message to a message queue
	                my                              : 2,    // - declare and assign a local variable (lexical scoping)
	                'new'                           :1,     //
	                next                            :1,     // - iterate a block prematurely
	                no                              :1,     // - unimport some module symbols or semantics at compile time
	                oct                             :1,     // - convert a string to an octal number
	                open                            :1,     // - open a file, pipe, or descriptor
	                opendir                         :1,     // - open a directory
	                ord                             :1,     // - find a character's numeric representation
	                our                             : 2,    // - declare and assign a package variable (lexical scoping)
	                pack                            :1,     // - convert a list into a binary representation
	                'package'                       :1,     // - declare a separate global namespace
	                pipe                            :1,     // - open a pair of connected filehandles
	                pop                             :1,     // - remove the last element from an array and return it
	                pos                             :1,     // - find or set the offset for the last/next m//g search
	                print                           :1,     // - output a list to a filehandle
	                printf                          :1,     // - output a formatted list to a filehandle
	                prototype                       :1,     // - get the prototype (if any) of a subroutine
	                push                            :1,     // - append one or more elements to an array
	                q                               :null,  // - singly quote a string
	                qq                              :null,  // - doubly quote a string
	                qr                              :null,  // - Compile pattern
	                quotemeta                       :null,  // - quote regular expression magic characters
	                qw                              :null,  // - quote a list of words
	                qx                              :null,  // - backquote quote a string
	                rand                            :1,     // - retrieve the next pseudorandom number
	                read                            :1,     // - fixed-length buffered input from a filehandle
	                readdir                         :1,     // - get a directory from a directory handle
	                readline                        :1,     // - fetch a record from a file
	                readlink                        :1,     // - determine where a symbolic link is pointing
	                readpipe                        :1,     // - execute a system command and collect standard output
	                recv                            :1,     // - receive a message over a Socket
	                redo                            :1,     // - start this loop iteration over again
	                ref                             :1,     // - find out the type of thing being referenced
	                rename                          :1,     // - change a filename
	                require                         :1,     // - load in external functions from a library at runtime
	                reset                           :1,     // - clear all variables of a given name
	                'return'                        :1,     // - get out of a function early
	                reverse                         :1,     // - flip a string or a list
	                rewinddir                       :1,     // - reset directory handle
	                rindex                          :1,     // - right-to-left substring search
	                rmdir                           :1,     // - remove a directory
	                s                               :null,  // - replace a pattern with a string
	                say                             :1,     // - print with newline
	                scalar                          :1,     // - force a scalar context
	                seek                            :1,     // - reposition file pointer for random-access I/O
	                seekdir                         :1,     // - reposition directory pointer
	                select                          :1,     // - reset default output or do I/O multiplexing
	                semctl                          :1,     // - SysV semaphore control operations
	                semget                          :1,     // - get set of SysV semaphores
	                semop                           :1,     // - SysV semaphore operations
	                send                            :1,     // - send a message over a socket
	                setgrent                        :1,     // - prepare group file for use
	                sethostent                      :1,     // - prepare hosts file for use
	                setnetent                       :1,     // - prepare networks file for use
	                setpgrp                         :1,     // - set the process group of a process
	                setpriority                     :1,     // - set a process's nice value
	                setprotoent                     :1,     // - prepare protocols file for use
	                setpwent                        :1,     // - prepare passwd file for use
	                setservent                      :1,     // - prepare services file for use
	                setsockopt                      :1,     // - set some socket options
	                shift                           :1,     // - remove the first element of an array, and return it
	                shmctl                          :1,     // - SysV shared memory operations
	                shmget                          :1,     // - get SysV shared memory segment identifier
	                shmread                         :1,     // - read SysV shared memory
	                shmwrite                        :1,     // - write SysV shared memory
	                shutdown                        :1,     // - close down just half of a socket connection
	                'sin'                           :1,     // - return the sine of a number
	                sleep                           :1,     // - block for some number of seconds
	                socket                          :1,     // - create a socket
	                socketpair                      :1,     // - create a pair of sockets
	                'sort'                          :1,     // - sort a list of values
	                splice                          :1,     // - add or remove elements anywhere in an array
	                'split'                         :1,     // - split up a string using a regexp delimiter
	                sprintf                         :1,     // - formatted print into a string
	                'sqrt'                          :1,     // - square root function
	                srand                           :1,     // - seed the random number generator
	                stat                            :1,     // - get a file's status information
	                state                           :1,     // - declare and assign a state variable (persistent lexical scoping)
	                study                           :1,     // - optimize input data for repeated searches
	                'sub'                           :1,     // - declare a subroutine, possibly anonymously
	                'substr'                        :1,     // - get or alter a portion of a stirng
	                symlink                         :1,     // - create a symbolic link to a file
	                syscall                         :1,     // - execute an arbitrary system call
	                sysopen                         :1,     // - open a file, pipe, or descriptor
	                sysread                         :1,     // - fixed-length unbuffered input from a filehandle
	                sysseek                         :1,     // - position I/O pointer on handle used with sysread and syswrite
	                system                          :1,     // - run a separate program
	                syswrite                        :1,     // - fixed-length unbuffered output to a filehandle
	                tell                            :1,     // - get current seekpointer on a filehandle
	                telldir                         :1,     // - get current seekpointer on a directory handle
	                tie                             :1,     // - bind a variable to an object class
	                tied                            :1,     // - get a reference to the object underlying a tied variable
	                time                            :1,     // - return number of seconds since 1970
	                times                           :1,     // - return elapsed time for self and child processes
	                tr                              :null,  // - transliterate a string
	                truncate                        :1,     // - shorten a file
	                uc                              :1,     // - return upper-case version of a string
	                ucfirst                         :1,     // - return a string with just the next letter in upper case
	                umask                           :1,     // - set file creation mode mask
	                undef                           :1,     // - remove a variable or function definition
	                unlink                          :1,     // - remove one link to a file
	                unpack                          :1,     // - convert binary structure into normal perl variables
	                unshift                         :1,     // - prepend more elements to the beginning of a list
	                untie                           :1,     // - break a tie binding to a variable
	                use                             :1,     // - load in a module at compile time
	                utime                           :1,     // - set a file's last access and modify times
	                values                          :1,     // - return a list of the values in a hash
	                vec                             :1,     // - test or set particular bits in a string
	                wait                            :1,     // - wait for any child process to die
	                waitpid                         :1,     // - wait for a particular child process to die
	                wantarray                       :1,     // - get void vs scalar vs list context of current subroutine call
	                warn                            :1,     // - print debugging info
	                when                            :1,     //
	                write                           :1,     // - print a picture record
	                y                               :null}; // - transliterate a string
	
	        var RXstyle="string-2";
	        var RXmodifiers=/[goseximacplud]/;              // NOTE: "m", "s", "y" and "tr" need to correct real modifiers for each regexp type
	
	        function tokenChain(stream,state,chain,style,tail){     // NOTE: chain.length > 2 is not working now (it's for s[...][...]geos;)
	                state.chain=null;                               //                                                          12   3tail
	                state.style=null;
	                state.tail=null;
	                state.tokenize=function(stream,state){
	                        var e=false,c,i=0;
	                        while(c=stream.next()){
	                                if(c===chain[i]&&!e){
	                                        if(chain[++i]!==undefined){
	                                                state.chain=chain[i];
	                                                state.style=style;
	                                                state.tail=tail;}
	                                        else if(tail)
	                                                stream.eatWhile(tail);
	                                        state.tokenize=tokenPerl;
	                                        return style;}
	                                e=!e&&c=="\\";}
	                        return style;};
	                return state.tokenize(stream,state);}
	
	        function tokenSOMETHING(stream,state,string){
	                state.tokenize=function(stream,state){
	                        if(stream.string==string)
	                                state.tokenize=tokenPerl;
	                        stream.skipToEnd();
	                        return "string";};
	                return state.tokenize(stream,state);}
	
	        function tokenPerl(stream,state){
	                if(stream.eatSpace())
	                        return null;
	                if(state.chain)
	                        return tokenChain(stream,state,state.chain,state.style,state.tail);
	                if(stream.match(/^\-?[\d\.]/,false))
	                        if(stream.match(/^(\-?(\d*\.\d+(e[+-]?\d+)?|\d+\.\d*)|0x[\da-fA-F]+|0b[01]+|\d+(e[+-]?\d+)?)/))
	                                return 'number';
	                if(stream.match(/^<<(?=\w)/)){                  // NOTE: <<SOMETHING\n...\nSOMETHING\n
	                        stream.eatWhile(/\w/);
	                        return tokenSOMETHING(stream,state,stream.current().substr(2));}
	                if(stream.sol()&&stream.match(/^\=item(?!\w)/)){// NOTE: \n=item...\n=cut\n
	                        return tokenSOMETHING(stream,state,'=cut');}
	                var ch=stream.next();
	                if(ch=='"'||ch=="'"){                           // NOTE: ' or " or <<'SOMETHING'\n...\nSOMETHING\n or <<"SOMETHING"\n...\nSOMETHING\n
	                        if(prefix(stream, 3)=="<<"+ch){
	                                var p=stream.pos;
	                                stream.eatWhile(/\w/);
	                                var n=stream.current().substr(1);
	                                if(n&&stream.eat(ch))
	                                        return tokenSOMETHING(stream,state,n);
	                                stream.pos=p;}
	                        return tokenChain(stream,state,[ch],"string");}
	                if(ch=="q"){
	                        var c=look(stream, -2);
	                        if(!(c&&/\w/.test(c))){
	                                c=look(stream, 0);
	                                if(c=="x"){
	                                        c=look(stream, 1);
	                                        if(c=="("){
	                                                eatSuffix(stream, 2);
	                                                return tokenChain(stream,state,[")"],RXstyle,RXmodifiers);}
	                                        if(c=="["){
	                                                eatSuffix(stream, 2);
	                                                return tokenChain(stream,state,["]"],RXstyle,RXmodifiers);}
	                                        if(c=="{"){
	                                                eatSuffix(stream, 2);
	                                                return tokenChain(stream,state,["}"],RXstyle,RXmodifiers);}
	                                        if(c=="<"){
	                                                eatSuffix(stream, 2);
	                                                return tokenChain(stream,state,[">"],RXstyle,RXmodifiers);}
	                                        if(/[\^'"!~\/]/.test(c)){
	                                                eatSuffix(stream, 1);
	                                                return tokenChain(stream,state,[stream.eat(c)],RXstyle,RXmodifiers);}}
	                                else if(c=="q"){
	                                        c=look(stream, 1);
	                                        if(c=="("){
	                                                eatSuffix(stream, 2);
	                                                return tokenChain(stream,state,[")"],"string");}
	                                        if(c=="["){
	                                                eatSuffix(stream, 2);
	                                                return tokenChain(stream,state,["]"],"string");}
	                                        if(c=="{"){
	                                                eatSuffix(stream, 2);
	                                                return tokenChain(stream,state,["}"],"string");}
	                                        if(c=="<"){
	                                                eatSuffix(stream, 2);
	                                                return tokenChain(stream,state,[">"],"string");}
	                                        if(/[\^'"!~\/]/.test(c)){
	                                                eatSuffix(stream, 1);
	                                                return tokenChain(stream,state,[stream.eat(c)],"string");}}
	                                else if(c=="w"){
	                                        c=look(stream, 1);
	                                        if(c=="("){
	                                                eatSuffix(stream, 2);
	                                                return tokenChain(stream,state,[")"],"bracket");}
	                                        if(c=="["){
	                                                eatSuffix(stream, 2);
	                                                return tokenChain(stream,state,["]"],"bracket");}
	                                        if(c=="{"){
	                                                eatSuffix(stream, 2);
	                                                return tokenChain(stream,state,["}"],"bracket");}
	                                        if(c=="<"){
	                                                eatSuffix(stream, 2);
	                                                return tokenChain(stream,state,[">"],"bracket");}
	                                        if(/[\^'"!~\/]/.test(c)){
	                                                eatSuffix(stream, 1);
	                                                return tokenChain(stream,state,[stream.eat(c)],"bracket");}}
	                                else if(c=="r"){
	                                        c=look(stream, 1);
	                                        if(c=="("){
	                                                eatSuffix(stream, 2);
	                                                return tokenChain(stream,state,[")"],RXstyle,RXmodifiers);}
	                                        if(c=="["){
	                                                eatSuffix(stream, 2);
	                                                return tokenChain(stream,state,["]"],RXstyle,RXmodifiers);}
	                                        if(c=="{"){
	                                                eatSuffix(stream, 2);
	                                                return tokenChain(stream,state,["}"],RXstyle,RXmodifiers);}
	                                        if(c=="<"){
	                                                eatSuffix(stream, 2);
	                                                return tokenChain(stream,state,[">"],RXstyle,RXmodifiers);}
	                                        if(/[\^'"!~\/]/.test(c)){
	                                                eatSuffix(stream, 1);
	                                                return tokenChain(stream,state,[stream.eat(c)],RXstyle,RXmodifiers);}}
	                                else if(/[\^'"!~\/(\[{<]/.test(c)){
	                                        if(c=="("){
	                                                eatSuffix(stream, 1);
	                                                return tokenChain(stream,state,[")"],"string");}
	                                        if(c=="["){
	                                                eatSuffix(stream, 1);
	                                                return tokenChain(stream,state,["]"],"string");}
	                                        if(c=="{"){
	                                                eatSuffix(stream, 1);
	                                                return tokenChain(stream,state,["}"],"string");}
	                                        if(c=="<"){
	                                                eatSuffix(stream, 1);
	                                                return tokenChain(stream,state,[">"],"string");}
	                                        if(/[\^'"!~\/]/.test(c)){
	                                                return tokenChain(stream,state,[stream.eat(c)],"string");}}}}
	                if(ch=="m"){
	                        var c=look(stream, -2);
	                        if(!(c&&/\w/.test(c))){
	                                c=stream.eat(/[(\[{<\^'"!~\/]/);
	                                if(c){
	                                        if(/[\^'"!~\/]/.test(c)){
	                                                return tokenChain(stream,state,[c],RXstyle,RXmodifiers);}
	                                        if(c=="("){
	                                                return tokenChain(stream,state,[")"],RXstyle,RXmodifiers);}
	                                        if(c=="["){
	                                                return tokenChain(stream,state,["]"],RXstyle,RXmodifiers);}
	                                        if(c=="{"){
	                                                return tokenChain(stream,state,["}"],RXstyle,RXmodifiers);}
	                                        if(c=="<"){
	                                                return tokenChain(stream,state,[">"],RXstyle,RXmodifiers);}}}}
	                if(ch=="s"){
	                        var c=/[\/>\]})\w]/.test(look(stream, -2));
	                        if(!c){
	                                c=stream.eat(/[(\[{<\^'"!~\/]/);
	                                if(c){
	                                        if(c=="[")
	                                                return tokenChain(stream,state,["]","]"],RXstyle,RXmodifiers);
	                                        if(c=="{")
	                                                return tokenChain(stream,state,["}","}"],RXstyle,RXmodifiers);
	                                        if(c=="<")
	                                                return tokenChain(stream,state,[">",">"],RXstyle,RXmodifiers);
	                                        if(c=="(")
	                                                return tokenChain(stream,state,[")",")"],RXstyle,RXmodifiers);
	                                        return tokenChain(stream,state,[c,c],RXstyle,RXmodifiers);}}}
	                if(ch=="y"){
	                        var c=/[\/>\]})\w]/.test(look(stream, -2));
	                        if(!c){
	                                c=stream.eat(/[(\[{<\^'"!~\/]/);
	                                if(c){
	                                        if(c=="[")
	                                                return tokenChain(stream,state,["]","]"],RXstyle,RXmodifiers);
	                                        if(c=="{")
	                                                return tokenChain(stream,state,["}","}"],RXstyle,RXmodifiers);
	                                        if(c=="<")
	                                                return tokenChain(stream,state,[">",">"],RXstyle,RXmodifiers);
	                                        if(c=="(")
	                                                return tokenChain(stream,state,[")",")"],RXstyle,RXmodifiers);
	                                        return tokenChain(stream,state,[c,c],RXstyle,RXmodifiers);}}}
	                if(ch=="t"){
	                        var c=/[\/>\]})\w]/.test(look(stream, -2));
	                        if(!c){
	                                c=stream.eat("r");if(c){
	                                c=stream.eat(/[(\[{<\^'"!~\/]/);
	                                if(c){
	                                        if(c=="[")
	                                                return tokenChain(stream,state,["]","]"],RXstyle,RXmodifiers);
	                                        if(c=="{")
	                                                return tokenChain(stream,state,["}","}"],RXstyle,RXmodifiers);
	                                        if(c=="<")
	                                                return tokenChain(stream,state,[">",">"],RXstyle,RXmodifiers);
	                                        if(c=="(")
	                                                return tokenChain(stream,state,[")",")"],RXstyle,RXmodifiers);
	                                        return tokenChain(stream,state,[c,c],RXstyle,RXmodifiers);}}}}
	                if(ch=="`"){
	                        return tokenChain(stream,state,[ch],"variable-2");}
	                if(ch=="/"){
	                        if(!/~\s*$/.test(prefix(stream)))
	                                return "operator";
	                        else
	                                return tokenChain(stream,state,[ch],RXstyle,RXmodifiers);}
	                if(ch=="$"){
	                        var p=stream.pos;
	                        if(stream.eatWhile(/\d/)||stream.eat("{")&&stream.eatWhile(/\d/)&&stream.eat("}"))
	                                return "variable-2";
	                        else
	                                stream.pos=p;}
	                if(/[$@%]/.test(ch)){
	                        var p=stream.pos;
	                        if(stream.eat("^")&&stream.eat(/[A-Z]/)||!/[@$%&]/.test(look(stream, -2))&&stream.eat(/[=|\\\-#?@;:&`~\^!\[\]*'"$+.,\/<>()]/)){
	                                var c=stream.current();
	                                if(PERL[c])
	                                        return "variable-2";}
	                        stream.pos=p;}
	                if(/[$@%&]/.test(ch)){
	                        if(stream.eatWhile(/[\w$\[\]]/)||stream.eat("{")&&stream.eatWhile(/[\w$\[\]]/)&&stream.eat("}")){
	                                var c=stream.current();
	                                if(PERL[c])
	                                        return "variable-2";
	                                else
	                                        return "variable";}}
	                if(ch=="#"){
	                        if(look(stream, -2)!="$"){
	                                stream.skipToEnd();
	                                return "comment";}}
	                if(/[:+\-\^*$&%@=<>!?|\/~\.]/.test(ch)){
	                        var p=stream.pos;
	                        stream.eatWhile(/[:+\-\^*$&%@=<>!?|\/~\.]/);
	                        if(PERL[stream.current()])
	                                return "operator";
	                        else
	                                stream.pos=p;}
	                if(ch=="_"){
	                        if(stream.pos==1){
	                                if(suffix(stream, 6)=="_END__"){
	                                        return tokenChain(stream,state,['\0'],"comment");}
	                                else if(suffix(stream, 7)=="_DATA__"){
	                                        return tokenChain(stream,state,['\0'],"variable-2");}
	                                else if(suffix(stream, 7)=="_C__"){
	                                        return tokenChain(stream,state,['\0'],"string");}}}
	                if(/\w/.test(ch)){
	                        var p=stream.pos;
	                        if(look(stream, -2)=="{"&&(look(stream, 0)=="}"||stream.eatWhile(/\w/)&&look(stream, 0)=="}"))
	                                return "string";
	                        else
	                                stream.pos=p;}
	                if(/[A-Z]/.test(ch)){
	                        var l=look(stream, -2);
	                        var p=stream.pos;
	                        stream.eatWhile(/[A-Z_]/);
	                        if(/[\da-z]/.test(look(stream, 0))){
	                                stream.pos=p;}
	                        else{
	                                var c=PERL[stream.current()];
	                                if(!c)
	                                        return "meta";
	                                if(c[1])
	                                        c=c[0];
	                                if(l!=":"){
	                                        if(c==1)
	                                                return "keyword";
	                                        else if(c==2)
	                                                return "def";
	                                        else if(c==3)
	                                                return "atom";
	                                        else if(c==4)
	                                                return "operator";
	                                        else if(c==5)
	                                                return "variable-2";
	                                        else
	                                                return "meta";}
	                                else
	                                        return "meta";}}
	                if(/[a-zA-Z_]/.test(ch)){
	                        var l=look(stream, -2);
	                        stream.eatWhile(/\w/);
	                        var c=PERL[stream.current()];
	                        if(!c)
	                                return "meta";
	                        if(c[1])
	                                c=c[0];
	                        if(l!=":"){
	                                if(c==1)
	                                        return "keyword";
	                                else if(c==2)
	                                        return "def";
	                                else if(c==3)
	                                        return "atom";
	                                else if(c==4)
	                                        return "operator";
	                                else if(c==5)
	                                        return "variable-2";
	                                else
	                                        return "meta";}
	                        else
	                                return "meta";}
	                return null;}
	
	        return {
	            startState: function() {
	                return {
	                    tokenize: tokenPerl,
	                    chain: null,
	                    style: null,
	                    tail: null
	                };
	            },
	            token: function(stream, state) {
	                return (state.tokenize || tokenPerl)(stream, state);
	            },
	            lineComment: '#'
	        };
	});
	
	CodeMirror.registerHelper("wordChars", "perl", /[\w$]/);
	
	CodeMirror.defineMIME("text/x-perl", "perl");
	
	// it's like "peek", but need for look-ahead or look-behind if index < 0
	function look(stream, c){
	  return stream.string.charAt(stream.pos+(c||0));
	}
	
	// return a part of prefix of current stream from current position
	function prefix(stream, c){
	  if(c){
	    var x=stream.pos-c;
	    return stream.string.substr((x>=0?x:0),c);}
	  else{
	    return stream.string.substr(0,stream.pos-1);
	  }
	}
	
	// return a part of suffix of current stream from current position
	function suffix(stream, c){
	  var y=stream.string.length;
	  var x=y-stream.pos+1;
	  return stream.string.substr(stream.pos,(c&&c<y?c:x));
	}
	
	// eating and vomiting a part of stream from current position
	function eatSuffix(stream, c){
	  var x=stream.pos+c;
	  var y;
	  if(x<=0)
	    stream.pos=0;
	  else if(x>=(y=stream.string.length-1))
	    stream.pos=y;
	  else
	    stream.pos=x;
	}
	
	});


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(1), __webpack_require__(103), __webpack_require__(102));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror", "../htmlmixed/htmlmixed", "../clike/clike"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  "use strict";
	
	  function keywords(str) {
	    var obj = {}, words = str.split(" ");
	    for (var i = 0; i < words.length; ++i) obj[words[i]] = true;
	    return obj;
	  }
	
	  // Helper for phpString
	  function matchSequence(list, end, escapes) {
	    if (list.length == 0) return phpString(end);
	    return function (stream, state) {
	      var patterns = list[0];
	      for (var i = 0; i < patterns.length; i++) if (stream.match(patterns[i][0])) {
	        state.tokenize = matchSequence(list.slice(1), end);
	        return patterns[i][1];
	      }
	      state.tokenize = phpString(end, escapes);
	      return "string";
	    };
	  }
	  function phpString(closing, escapes) {
	    return function(stream, state) { return phpString_(stream, state, closing, escapes); };
	  }
	  function phpString_(stream, state, closing, escapes) {
	    // "Complex" syntax
	    if (escapes !== false && stream.match("${", false) || stream.match("{$", false)) {
	      state.tokenize = null;
	      return "string";
	    }
	
	    // Simple syntax
	    if (escapes !== false && stream.match(/^\$[a-zA-Z_][a-zA-Z0-9_]*/)) {
	      // After the variable name there may appear array or object operator.
	      if (stream.match("[", false)) {
	        // Match array operator
	        state.tokenize = matchSequence([
	          [["[", null]],
	          [[/\d[\w\.]*/, "number"],
	           [/\$[a-zA-Z_][a-zA-Z0-9_]*/, "variable-2"],
	           [/[\w\$]+/, "variable"]],
	          [["]", null]]
	        ], closing, escapes);
	      }
	      if (stream.match(/\-\>\w/, false)) {
	        // Match object operator
	        state.tokenize = matchSequence([
	          [["->", null]],
	          [[/[\w]+/, "variable"]]
	        ], closing, escapes);
	      }
	      return "variable-2";
	    }
	
	    var escaped = false;
	    // Normal string
	    while (!stream.eol() &&
	           (escaped || escapes === false ||
	            (!stream.match("{$", false) &&
	             !stream.match(/^(\$[a-zA-Z_][a-zA-Z0-9_]*|\$\{)/, false)))) {
	      if (!escaped && stream.match(closing)) {
	        state.tokenize = null;
	        state.tokStack.pop(); state.tokStack.pop();
	        break;
	      }
	      escaped = stream.next() == "\\" && !escaped;
	    }
	    return "string";
	  }
	
	  var phpKeywords = "abstract and array as break case catch class clone const continue declare default " +
	    "do else elseif enddeclare endfor endforeach endif endswitch endwhile extends final " +
	    "for foreach function global goto if implements interface instanceof namespace " +
	    "new or private protected public static switch throw trait try use var while xor " +
	    "die echo empty exit eval include include_once isset list require require_once return " +
	    "print unset __halt_compiler self static parent yield insteadof finally";
	  var phpAtoms = "true false null TRUE FALSE NULL __CLASS__ __DIR__ __FILE__ __LINE__ __METHOD__ __FUNCTION__ __NAMESPACE__ __TRAIT__";
	  var phpBuiltin = "func_num_args func_get_arg func_get_args strlen strcmp strncmp strcasecmp strncasecmp each error_reporting define defined trigger_error user_error set_error_handler restore_error_handler get_declared_classes get_loaded_extensions extension_loaded get_extension_funcs debug_backtrace constant bin2hex hex2bin sleep usleep time mktime gmmktime strftime gmstrftime strtotime date gmdate getdate localtime checkdate flush wordwrap htmlspecialchars htmlentities html_entity_decode md5 md5_file crc32 getimagesize image_type_to_mime_type phpinfo phpversion phpcredits strnatcmp strnatcasecmp substr_count strspn strcspn strtok strtoupper strtolower strpos strrpos strrev hebrev hebrevc nl2br basename dirname pathinfo stripslashes stripcslashes strstr stristr strrchr str_shuffle str_word_count strcoll substr substr_replace quotemeta ucfirst ucwords strtr addslashes addcslashes rtrim str_replace str_repeat count_chars chunk_split trim ltrim strip_tags similar_text explode implode setlocale localeconv parse_str str_pad chop strchr sprintf printf vprintf vsprintf sscanf fscanf parse_url urlencode urldecode rawurlencode rawurldecode readlink linkinfo link unlink exec system escapeshellcmd escapeshellarg passthru shell_exec proc_open proc_close rand srand getrandmax mt_rand mt_srand mt_getrandmax base64_decode base64_encode abs ceil floor round is_finite is_nan is_infinite bindec hexdec octdec decbin decoct dechex base_convert number_format fmod ip2long long2ip getenv putenv getopt microtime gettimeofday getrusage uniqid quoted_printable_decode set_time_limit get_cfg_var magic_quotes_runtime set_magic_quotes_runtime get_magic_quotes_gpc get_magic_quotes_runtime import_request_variables error_log serialize unserialize memory_get_usage var_dump var_export debug_zval_dump print_r highlight_file show_source highlight_string ini_get ini_get_all ini_set ini_alter ini_restore get_include_path set_include_path restore_include_path setcookie header headers_sent connection_aborted connection_status ignore_user_abort parse_ini_file is_uploaded_file move_uploaded_file intval floatval doubleval strval gettype settype is_null is_resource is_bool is_long is_float is_int is_integer is_double is_real is_numeric is_string is_array is_object is_scalar ereg ereg_replace eregi eregi_replace split spliti join sql_regcase dl pclose popen readfile rewind rmdir umask fclose feof fgetc fgets fgetss fread fopen fpassthru ftruncate fstat fseek ftell fflush fwrite fputs mkdir rename copy tempnam tmpfile file file_get_contents file_put_contents stream_select stream_context_create stream_context_set_params stream_context_set_option stream_context_get_options stream_filter_prepend stream_filter_append fgetcsv flock get_meta_tags stream_set_write_buffer set_file_buffer set_socket_blocking stream_set_blocking socket_set_blocking stream_get_meta_data stream_register_wrapper stream_wrapper_register stream_set_timeout socket_set_timeout socket_get_status realpath fnmatch fsockopen pfsockopen pack unpack get_browser crypt opendir closedir chdir getcwd rewinddir readdir dir glob fileatime filectime filegroup fileinode filemtime fileowner fileperms filesize filetype file_exists is_writable is_writeable is_readable is_executable is_file is_dir is_link stat lstat chown touch clearstatcache mail ob_start ob_flush ob_clean ob_end_flush ob_end_clean ob_get_flush ob_get_clean ob_get_length ob_get_level ob_get_status ob_get_contents ob_implicit_flush ob_list_handlers ksort krsort natsort natcasesort asort arsort sort rsort usort uasort uksort shuffle array_walk count end prev next reset current key min max in_array array_search extract compact array_fill range array_multisort array_push array_pop array_shift array_unshift array_splice array_slice array_merge array_merge_recursive array_keys array_values array_count_values array_reverse array_reduce array_pad array_flip array_change_key_case array_rand array_unique array_intersect array_intersect_assoc array_diff array_diff_assoc array_sum array_filter array_map array_chunk array_key_exists array_intersect_key array_combine array_column pos sizeof key_exists assert assert_options version_compare ftok str_rot13 aggregate session_name session_module_name session_save_path session_id session_regenerate_id session_decode session_register session_unregister session_is_registered session_encode session_start session_destroy session_unset session_set_save_handler session_cache_limiter session_cache_expire session_set_cookie_params session_get_cookie_params session_write_close preg_match preg_match_all preg_replace preg_replace_callback preg_split preg_quote preg_grep overload ctype_alnum ctype_alpha ctype_cntrl ctype_digit ctype_lower ctype_graph ctype_print ctype_punct ctype_space ctype_upper ctype_xdigit virtual apache_request_headers apache_note apache_lookup_uri apache_child_terminate apache_setenv apache_response_headers apache_get_version getallheaders mysql_connect mysql_pconnect mysql_close mysql_select_db mysql_create_db mysql_drop_db mysql_query mysql_unbuffered_query mysql_db_query mysql_list_dbs mysql_list_tables mysql_list_fields mysql_list_processes mysql_error mysql_errno mysql_affected_rows mysql_insert_id mysql_result mysql_num_rows mysql_num_fields mysql_fetch_row mysql_fetch_array mysql_fetch_assoc mysql_fetch_object mysql_data_seek mysql_fetch_lengths mysql_fetch_field mysql_field_seek mysql_free_result mysql_field_name mysql_field_table mysql_field_len mysql_field_type mysql_field_flags mysql_escape_string mysql_real_escape_string mysql_stat mysql_thread_id mysql_client_encoding mysql_get_client_info mysql_get_host_info mysql_get_proto_info mysql_get_server_info mysql_info mysql mysql_fieldname mysql_fieldtable mysql_fieldlen mysql_fieldtype mysql_fieldflags mysql_selectdb mysql_createdb mysql_dropdb mysql_freeresult mysql_numfields mysql_numrows mysql_listdbs mysql_listtables mysql_listfields mysql_db_name mysql_dbname mysql_tablename mysql_table_name pg_connect pg_pconnect pg_close pg_connection_status pg_connection_busy pg_connection_reset pg_host pg_dbname pg_port pg_tty pg_options pg_ping pg_query pg_send_query pg_cancel_query pg_fetch_result pg_fetch_row pg_fetch_assoc pg_fetch_array pg_fetch_object pg_fetch_all pg_affected_rows pg_get_result pg_result_seek pg_result_status pg_free_result pg_last_oid pg_num_rows pg_num_fields pg_field_name pg_field_num pg_field_size pg_field_type pg_field_prtlen pg_field_is_null pg_get_notify pg_get_pid pg_result_error pg_last_error pg_last_notice pg_put_line pg_end_copy pg_copy_to pg_copy_from pg_trace pg_untrace pg_lo_create pg_lo_unlink pg_lo_open pg_lo_close pg_lo_read pg_lo_write pg_lo_read_all pg_lo_import pg_lo_export pg_lo_seek pg_lo_tell pg_escape_string pg_escape_bytea pg_unescape_bytea pg_client_encoding pg_set_client_encoding pg_meta_data pg_convert pg_insert pg_update pg_delete pg_select pg_exec pg_getlastoid pg_cmdtuples pg_errormessage pg_numrows pg_numfields pg_fieldname pg_fieldsize pg_fieldtype pg_fieldnum pg_fieldprtlen pg_fieldisnull pg_freeresult pg_result pg_loreadall pg_locreate pg_lounlink pg_loopen pg_loclose pg_loread pg_lowrite pg_loimport pg_loexport http_response_code get_declared_traits getimagesizefromstring socket_import_stream stream_set_chunk_size trait_exists header_register_callback class_uses session_status session_register_shutdown echo print global static exit array empty eval isset unset die include require include_once require_once json_decode json_encode json_last_error json_last_error_msg curl_close curl_copy_handle curl_errno curl_error curl_escape curl_exec curl_file_create curl_getinfo curl_init curl_multi_add_handle curl_multi_close curl_multi_exec curl_multi_getcontent curl_multi_info_read curl_multi_init curl_multi_remove_handle curl_multi_select curl_multi_setopt curl_multi_strerror curl_pause curl_reset curl_setopt_array curl_setopt curl_share_close curl_share_init curl_share_setopt curl_strerror curl_unescape curl_version mysqli_affected_rows mysqli_autocommit mysqli_change_user mysqli_character_set_name mysqli_close mysqli_commit mysqli_connect_errno mysqli_connect_error mysqli_connect mysqli_data_seek mysqli_debug mysqli_dump_debug_info mysqli_errno mysqli_error_list mysqli_error mysqli_fetch_all mysqli_fetch_array mysqli_fetch_assoc mysqli_fetch_field_direct mysqli_fetch_field mysqli_fetch_fields mysqli_fetch_lengths mysqli_fetch_object mysqli_fetch_row mysqli_field_count mysqli_field_seek mysqli_field_tell mysqli_free_result mysqli_get_charset mysqli_get_client_info mysqli_get_client_stats mysqli_get_client_version mysqli_get_connection_stats mysqli_get_host_info mysqli_get_proto_info mysqli_get_server_info mysqli_get_server_version mysqli_info mysqli_init mysqli_insert_id mysqli_kill mysqli_more_results mysqli_multi_query mysqli_next_result mysqli_num_fields mysqli_num_rows mysqli_options mysqli_ping mysqli_prepare mysqli_query mysqli_real_connect mysqli_real_escape_string mysqli_real_query mysqli_reap_async_query mysqli_refresh mysqli_rollback mysqli_select_db mysqli_set_charset mysqli_set_local_infile_default mysqli_set_local_infile_handler mysqli_sqlstate mysqli_ssl_set mysqli_stat mysqli_stmt_init mysqli_store_result mysqli_thread_id mysqli_thread_safe mysqli_use_result mysqli_warning_count";
	  CodeMirror.registerHelper("hintWords", "php", [phpKeywords, phpAtoms, phpBuiltin].join(" ").split(" "));
	  CodeMirror.registerHelper("wordChars", "php", /[\w$]/);
	
	  var phpConfig = {
	    name: "clike",
	    helperType: "php",
	    keywords: keywords(phpKeywords),
	    blockKeywords: keywords("catch do else elseif for foreach if switch try while finally"),
	    defKeywords: keywords("class function interface namespace trait"),
	    atoms: keywords(phpAtoms),
	    builtin: keywords(phpBuiltin),
	    multiLineStrings: true,
	    hooks: {
	      "$": function(stream) {
	        stream.eatWhile(/[\w\$_]/);
	        return "variable-2";
	      },
	      "<": function(stream, state) {
	        var before;
	        if (before = stream.match(/<<\s*/)) {
	          var quoted = stream.eat(/['"]/);
	          stream.eatWhile(/[\w\.]/);
	          var delim = stream.current().slice(before[0].length + (quoted ? 2 : 1));
	          if (quoted) stream.eat(quoted);
	          if (delim) {
	            (state.tokStack || (state.tokStack = [])).push(delim, 0);
	            state.tokenize = phpString(delim, quoted != "'");
	            return "string";
	          }
	        }
	        return false;
	      },
	      "#": function(stream) {
	        while (!stream.eol() && !stream.match("?>", false)) stream.next();
	        return "comment";
	      },
	      "/": function(stream) {
	        if (stream.eat("/")) {
	          while (!stream.eol() && !stream.match("?>", false)) stream.next();
	          return "comment";
	        }
	        return false;
	      },
	      '"': function(_stream, state) {
	        (state.tokStack || (state.tokStack = [])).push('"', 0);
	        state.tokenize = phpString('"');
	        return "string";
	      },
	      "{": function(_stream, state) {
	        if (state.tokStack && state.tokStack.length)
	          state.tokStack[state.tokStack.length - 1]++;
	        return false;
	      },
	      "}": function(_stream, state) {
	        if (state.tokStack && state.tokStack.length > 0 &&
	            !--state.tokStack[state.tokStack.length - 1]) {
	          state.tokenize = phpString(state.tokStack[state.tokStack.length - 2]);
	        }
	        return false;
	      }
	    }
	  };
	
	  CodeMirror.defineMode("php", function(config, parserConfig) {
	    var htmlMode = CodeMirror.getMode(config, (parserConfig && parserConfig.htmlMode) || "text/html");
	    var phpMode = CodeMirror.getMode(config, phpConfig);
	
	    function dispatch(stream, state) {
	      var isPHP = state.curMode == phpMode;
	      if (stream.sol() && state.pending && state.pending != '"' && state.pending != "'") state.pending = null;
	      if (!isPHP) {
	        if (stream.match(/^<\?\w*/)) {
	          state.curMode = phpMode;
	          if (!state.php) state.php = CodeMirror.startState(phpMode, htmlMode.indent(state.html, "", ""))
	          state.curState = state.php;
	          return "meta";
	        }
	        if (state.pending == '"' || state.pending == "'") {
	          while (!stream.eol() && stream.next() != state.pending) {}
	          var style = "string";
	        } else if (state.pending && stream.pos < state.pending.end) {
	          stream.pos = state.pending.end;
	          var style = state.pending.style;
	        } else {
	          var style = htmlMode.token(stream, state.curState);
	        }
	        if (state.pending) state.pending = null;
	        var cur = stream.current(), openPHP = cur.search(/<\?/), m;
	        if (openPHP != -1) {
	          if (style == "string" && (m = cur.match(/[\'\"]$/)) && !/\?>/.test(cur)) state.pending = m[0];
	          else state.pending = {end: stream.pos, style: style};
	          stream.backUp(cur.length - openPHP);
	        }
	        return style;
	      } else if (isPHP && state.php.tokenize == null && stream.match("?>")) {
	        state.curMode = htmlMode;
	        state.curState = state.html;
	        if (!state.php.context.prev) state.php = null;
	        return "meta";
	      } else {
	        return phpMode.token(stream, state.curState);
	      }
	    }
	
	    return {
	      startState: function() {
	        var html = CodeMirror.startState(htmlMode)
	        var php = parserConfig.startOpen ? CodeMirror.startState(phpMode) : null
	        return {html: html,
	                php: php,
	                curMode: parserConfig.startOpen ? phpMode : htmlMode,
	                curState: parserConfig.startOpen ? php : html,
	                pending: null};
	      },
	
	      copyState: function(state) {
	        var html = state.html, htmlNew = CodeMirror.copyState(htmlMode, html),
	            php = state.php, phpNew = php && CodeMirror.copyState(phpMode, php), cur;
	        if (state.curMode == htmlMode) cur = htmlNew;
	        else cur = phpNew;
	        return {html: htmlNew, php: phpNew, curMode: state.curMode, curState: cur,
	                pending: state.pending};
	      },
	
	      token: dispatch,
	
	      indent: function(state, textAfter, line) {
	        if ((state.curMode != phpMode && /^\s*<\//.test(textAfter)) ||
	            (state.curMode == phpMode && /^\?>/.test(textAfter)))
	          return htmlMode.indent(state.html, textAfter, line);
	        return state.curMode.indent(state.curState, textAfter, line);
	      },
	
	      blockCommentStart: "/*",
	      blockCommentEnd: "*/",
	      lineComment: "//",
	
	      innerMode: function(state) { return {state: state.curState, mode: state.curMode}; }
	    };
	  }, "htmlmixed", "clike");
	
	  CodeMirror.defineMIME("application/x-httpd-php", "php");
	  CodeMirror.defineMIME("application/x-httpd-php-open", {name: "php", startOpen: true});
	  CodeMirror.defineMIME("text/x-php", phpConfig);
	});


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/LICENSE
	
	(function(mod) {
	  'use strict';
	  if (true) // CommonJS
	    mod(__webpack_require__(1));
	  else if (typeof define == 'function' && define.amd) // AMD
	    define(['../../lib/codemirror'], mod);
	  else // Plain browser env
	    mod(window.CodeMirror);
	})(function(CodeMirror) {
	'use strict';
	
	CodeMirror.defineMode('powershell', function() {
	  function buildRegexp(patterns, options) {
	    options = options || {};
	    var prefix = options.prefix !== undefined ? options.prefix : '^';
	    var suffix = options.suffix !== undefined ? options.suffix : '\\b';
	
	    for (var i = 0; i < patterns.length; i++) {
	      if (patterns[i] instanceof RegExp) {
	        patterns[i] = patterns[i].source;
	      }
	      else {
	        patterns[i] = patterns[i].replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	      }
	    }
	
	    return new RegExp(prefix + '(' + patterns.join('|') + ')' + suffix, 'i');
	  }
	
	  var notCharacterOrDash = '(?=[^A-Za-z\\d\\-_]|$)';
	  var varNames = /[\w\-:]/
	  var keywords = buildRegexp([
	    /begin|break|catch|continue|data|default|do|dynamicparam/,
	    /else|elseif|end|exit|filter|finally|for|foreach|from|function|if|in/,
	    /param|process|return|switch|throw|trap|try|until|where|while/
	  ], { suffix: notCharacterOrDash });
	
	  var punctuation = /[\[\]{},;`\.]|@[({]/;
	  var wordOperators = buildRegexp([
	    'f',
	    /b?not/,
	    /[ic]?split/, 'join',
	    /is(not)?/, 'as',
	    /[ic]?(eq|ne|[gl][te])/,
	    /[ic]?(not)?(like|match|contains)/,
	    /[ic]?replace/,
	    /b?(and|or|xor)/
	  ], { prefix: '-' });
	  var symbolOperators = /[+\-*\/%]=|\+\+|--|\.\.|[+\-*&^%:=!|\/]|<(?!#)|(?!#)>/;
	  var operators = buildRegexp([wordOperators, symbolOperators], { suffix: '' });
	
	  var numbers = /^((0x[\da-f]+)|((\d+\.\d+|\d\.|\.\d+|\d+)(e[\+\-]?\d+)?))[ld]?([kmgtp]b)?/i;
	
	  var identifiers = /^[A-Za-z\_][A-Za-z\-\_\d]*\b/;
	
	  var symbolBuiltins = /[A-Z]:|%|\?/i;
	  var namedBuiltins = buildRegexp([
	    /Add-(Computer|Content|History|Member|PSSnapin|Type)/,
	    /Checkpoint-Computer/,
	    /Clear-(Content|EventLog|History|Host|Item(Property)?|Variable)/,
	    /Compare-Object/,
	    /Complete-Transaction/,
	    /Connect-PSSession/,
	    /ConvertFrom-(Csv|Json|SecureString|StringData)/,
	    /Convert-Path/,
	    /ConvertTo-(Csv|Html|Json|SecureString|Xml)/,
	    /Copy-Item(Property)?/,
	    /Debug-Process/,
	    /Disable-(ComputerRestore|PSBreakpoint|PSRemoting|PSSessionConfiguration)/,
	    /Disconnect-PSSession/,
	    /Enable-(ComputerRestore|PSBreakpoint|PSRemoting|PSSessionConfiguration)/,
	    /(Enter|Exit)-PSSession/,
	    /Export-(Alias|Clixml|Console|Counter|Csv|FormatData|ModuleMember|PSSession)/,
	    /ForEach-Object/,
	    /Format-(Custom|List|Table|Wide)/,
	    new RegExp('Get-(Acl|Alias|AuthenticodeSignature|ChildItem|Command|ComputerRestorePoint|Content|ControlPanelItem|Counter|Credential'
	      + '|Culture|Date|Event|EventLog|EventSubscriber|ExecutionPolicy|FormatData|Help|History|Host|HotFix|Item|ItemProperty|Job'
	      + '|Location|Member|Module|PfxCertificate|Process|PSBreakpoint|PSCallStack|PSDrive|PSProvider|PSSession|PSSessionConfiguration'
	      + '|PSSnapin|Random|Service|TraceSource|Transaction|TypeData|UICulture|Unique|Variable|Verb|WinEvent|WmiObject)'),
	    /Group-Object/,
	    /Import-(Alias|Clixml|Counter|Csv|LocalizedData|Module|PSSession)/,
	    /ImportSystemModules/,
	    /Invoke-(Command|Expression|History|Item|RestMethod|WebRequest|WmiMethod)/,
	    /Join-Path/,
	    /Limit-EventLog/,
	    /Measure-(Command|Object)/,
	    /Move-Item(Property)?/,
	    new RegExp('New-(Alias|Event|EventLog|Item(Property)?|Module|ModuleManifest|Object|PSDrive|PSSession|PSSessionConfigurationFile'
	      + '|PSSessionOption|PSTransportOption|Service|TimeSpan|Variable|WebServiceProxy|WinEvent)'),
	    /Out-(Default|File|GridView|Host|Null|Printer|String)/,
	    /Pause/,
	    /(Pop|Push)-Location/,
	    /Read-Host/,
	    /Receive-(Job|PSSession)/,
	    /Register-(EngineEvent|ObjectEvent|PSSessionConfiguration|WmiEvent)/,
	    /Remove-(Computer|Event|EventLog|Item(Property)?|Job|Module|PSBreakpoint|PSDrive|PSSession|PSSnapin|TypeData|Variable|WmiObject)/,
	    /Rename-(Computer|Item(Property)?)/,
	    /Reset-ComputerMachinePassword/,
	    /Resolve-Path/,
	    /Restart-(Computer|Service)/,
	    /Restore-Computer/,
	    /Resume-(Job|Service)/,
	    /Save-Help/,
	    /Select-(Object|String|Xml)/,
	    /Send-MailMessage/,
	    new RegExp('Set-(Acl|Alias|AuthenticodeSignature|Content|Date|ExecutionPolicy|Item(Property)?|Location|PSBreakpoint|PSDebug' +
	               '|PSSessionConfiguration|Service|StrictMode|TraceSource|Variable|WmiInstance)'),
	    /Show-(Command|ControlPanelItem|EventLog)/,
	    /Sort-Object/,
	    /Split-Path/,
	    /Start-(Job|Process|Service|Sleep|Transaction|Transcript)/,
	    /Stop-(Computer|Job|Process|Service|Transcript)/,
	    /Suspend-(Job|Service)/,
	    /TabExpansion2/,
	    /Tee-Object/,
	    /Test-(ComputerSecureChannel|Connection|ModuleManifest|Path|PSSessionConfigurationFile)/,
	    /Trace-Command/,
	    /Unblock-File/,
	    /Undo-Transaction/,
	    /Unregister-(Event|PSSessionConfiguration)/,
	    /Update-(FormatData|Help|List|TypeData)/,
	    /Use-Transaction/,
	    /Wait-(Event|Job|Process)/,
	    /Where-Object/,
	    /Write-(Debug|Error|EventLog|Host|Output|Progress|Verbose|Warning)/,
	    /cd|help|mkdir|more|oss|prompt/,
	    /ac|asnp|cat|cd|chdir|clc|clear|clhy|cli|clp|cls|clv|cnsn|compare|copy|cp|cpi|cpp|cvpa|dbp|del|diff|dir|dnsn|ebp/,
	    /echo|epal|epcsv|epsn|erase|etsn|exsn|fc|fl|foreach|ft|fw|gal|gbp|gc|gci|gcm|gcs|gdr|ghy|gi|gjb|gl|gm|gmo|gp|gps/,
	    /group|gsn|gsnp|gsv|gu|gv|gwmi|h|history|icm|iex|ihy|ii|ipal|ipcsv|ipmo|ipsn|irm|ise|iwmi|iwr|kill|lp|ls|man|md/,
	    /measure|mi|mount|move|mp|mv|nal|ndr|ni|nmo|npssc|nsn|nv|ogv|oh|popd|ps|pushd|pwd|r|rbp|rcjb|rcsn|rd|rdr|ren|ri/,
	    /rjb|rm|rmdir|rmo|rni|rnp|rp|rsn|rsnp|rujb|rv|rvpa|rwmi|sajb|sal|saps|sasv|sbp|sc|select|set|shcm|si|sl|sleep|sls/,
	    /sort|sp|spjb|spps|spsv|start|sujb|sv|swmi|tee|trcm|type|where|wjb|write/
	  ], { prefix: '', suffix: '' });
	  var variableBuiltins = buildRegexp([
	    /[$?^_]|Args|ConfirmPreference|ConsoleFileName|DebugPreference|Error|ErrorActionPreference|ErrorView|ExecutionContext/,
	    /FormatEnumerationLimit|Home|Host|Input|MaximumAliasCount|MaximumDriveCount|MaximumErrorCount|MaximumFunctionCount/,
	    /MaximumHistoryCount|MaximumVariableCount|MyInvocation|NestedPromptLevel|OutputEncoding|Pid|Profile|ProgressPreference/,
	    /PSBoundParameters|PSCommandPath|PSCulture|PSDefaultParameterValues|PSEmailServer|PSHome|PSScriptRoot|PSSessionApplicationName/,
	    /PSSessionConfigurationName|PSSessionOption|PSUICulture|PSVersionTable|Pwd|ShellId|StackTrace|VerbosePreference/,
	    /WarningPreference|WhatIfPreference/,
	
	    /Event|EventArgs|EventSubscriber|Sender/,
	    /Matches|Ofs|ForEach|LastExitCode|PSCmdlet|PSItem|PSSenderInfo|This/,
	    /true|false|null/
	  ], { prefix: '\\$', suffix: '' });
	
	  var builtins = buildRegexp([symbolBuiltins, namedBuiltins, variableBuiltins], { suffix: notCharacterOrDash });
	
	  var grammar = {
	    keyword: keywords,
	    number: numbers,
	    operator: operators,
	    builtin: builtins,
	    punctuation: punctuation,
	    identifier: identifiers
	  };
	
	  // tokenizers
	  function tokenBase(stream, state) {
	    // Handle Comments
	    //var ch = stream.peek();
	
	    var parent = state.returnStack[state.returnStack.length - 1];
	    if (parent && parent.shouldReturnFrom(state)) {
	      state.tokenize = parent.tokenize;
	      state.returnStack.pop();
	      return state.tokenize(stream, state);
	    }
	
	    if (stream.eatSpace()) {
	      return null;
	    }
	
	    if (stream.eat('(')) {
	      state.bracketNesting += 1;
	      return 'punctuation';
	    }
	
	    if (stream.eat(')')) {
	      state.bracketNesting -= 1;
	      return 'punctuation';
	    }
	
	    for (var key in grammar) {
	      if (stream.match(grammar[key])) {
	        return key;
	      }
	    }
	
	    var ch = stream.next();
	
	    // single-quote string
	    if (ch === "'") {
	      return tokenSingleQuoteString(stream, state);
	    }
	
	    if (ch === '$') {
	      return tokenVariable(stream, state);
	    }
	
	    // double-quote string
	    if (ch === '"') {
	      return tokenDoubleQuoteString(stream, state);
	    }
	
	    if (ch === '<' && stream.eat('#')) {
	      state.tokenize = tokenComment;
	      return tokenComment(stream, state);
	    }
	
	    if (ch === '#') {
	      stream.skipToEnd();
	      return 'comment';
	    }
	
	    if (ch === '@') {
	      var quoteMatch = stream.eat(/["']/);
	      if (quoteMatch && stream.eol()) {
	        state.tokenize = tokenMultiString;
	        state.startQuote = quoteMatch[0];
	        return tokenMultiString(stream, state);
	      } else if (stream.eol()) {
	        return 'error';
	      } else if (stream.peek().match(/[({]/)) {
	        return 'punctuation';
	      } else if (stream.peek().match(varNames)) {
	        // splatted variable
	        return tokenVariable(stream, state);
	      }
	    }
	    return 'error';
	  }
	
	  function tokenSingleQuoteString(stream, state) {
	    var ch;
	    while ((ch = stream.peek()) != null) {
	      stream.next();
	
	      if (ch === "'" && !stream.eat("'")) {
	        state.tokenize = tokenBase;
	        return 'string';
	      }
	    }
	
	    return 'error';
	  }
	
	  function tokenDoubleQuoteString(stream, state) {
	    var ch;
	    while ((ch = stream.peek()) != null) {
	      if (ch === '$') {
	        state.tokenize = tokenStringInterpolation;
	        return 'string';
	      }
	
	      stream.next();
	      if (ch === '`') {
	        stream.next();
	        continue;
	      }
	
	      if (ch === '"' && !stream.eat('"')) {
	        state.tokenize = tokenBase;
	        return 'string';
	      }
	    }
	
	    return 'error';
	  }
	
	  function tokenStringInterpolation(stream, state) {
	    return tokenInterpolation(stream, state, tokenDoubleQuoteString);
	  }
	
	  function tokenMultiStringReturn(stream, state) {
	    state.tokenize = tokenMultiString;
	    state.startQuote = '"'
	    return tokenMultiString(stream, state);
	  }
	
	  function tokenHereStringInterpolation(stream, state) {
	    return tokenInterpolation(stream, state, tokenMultiStringReturn);
	  }
	
	  function tokenInterpolation(stream, state, parentTokenize) {
	    if (stream.match('$(')) {
	      var savedBracketNesting = state.bracketNesting;
	      state.returnStack.push({
	        /*jshint loopfunc:true */
	        shouldReturnFrom: function(state) {
	          return state.bracketNesting === savedBracketNesting;
	        },
	        tokenize: parentTokenize
	      });
	      state.tokenize = tokenBase;
	      state.bracketNesting += 1;
	      return 'punctuation';
	    } else {
	      stream.next();
	      state.returnStack.push({
	        shouldReturnFrom: function() { return true; },
	        tokenize: parentTokenize
	      });
	      state.tokenize = tokenVariable;
	      return state.tokenize(stream, state);
	    }
	  }
	
	  function tokenComment(stream, state) {
	    var maybeEnd = false, ch;
	    while ((ch = stream.next()) != null) {
	      if (maybeEnd && ch == '>') {
	          state.tokenize = tokenBase;
	          break;
	      }
	      maybeEnd = (ch === '#');
	    }
	    return 'comment';
	  }
	
	  function tokenVariable(stream, state) {
	    var ch = stream.peek();
	    if (stream.eat('{')) {
	      state.tokenize = tokenVariableWithBraces;
	      return tokenVariableWithBraces(stream, state);
	    } else if (ch != undefined && ch.match(varNames)) {
	      stream.eatWhile(varNames);
	      state.tokenize = tokenBase;
	      return 'variable-2';
	    } else {
	      state.tokenize = tokenBase;
	      return 'error';
	    }
	  }
	
	  function tokenVariableWithBraces(stream, state) {
	    var ch;
	    while ((ch = stream.next()) != null) {
	      if (ch === '}') {
	        state.tokenize = tokenBase;
	        break;
	      }
	    }
	    return 'variable-2';
	  }
	
	  function tokenMultiString(stream, state) {
	    var quote = state.startQuote;
	    if (stream.sol() && stream.match(new RegExp(quote + '@'))) {
	      state.tokenize = tokenBase;
	    }
	    else if (quote === '"') {
	      while (!stream.eol()) {
	        var ch = stream.peek();
	        if (ch === '$') {
	          state.tokenize = tokenHereStringInterpolation;
	          return 'string';
	        }
	
	        stream.next();
	        if (ch === '`') {
	          stream.next();
	        }
	      }
	    }
	    else {
	      stream.skipToEnd();
	    }
	
	    return 'string';
	  }
	
	  var external = {
	    startState: function() {
	      return {
	        returnStack: [],
	        bracketNesting: 0,
	        tokenize: tokenBase
	      };
	    },
	
	    token: function(stream, state) {
	      return state.tokenize(stream, state);
	    },
	
	    blockCommentStart: '<#',
	    blockCommentEnd: '#>',
	    lineComment: '#',
	    fold: 'brace'
	  };
	  return external;
	});
	
	CodeMirror.defineMIME('application/x-powershell', 'powershell');
	});


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(1), __webpack_require__(68), __webpack_require__(67), __webpack_require__(103));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror", "../javascript/javascript", "../css/css", "../htmlmixed/htmlmixed"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("pug", function (config) {
	  // token types
	  var KEYWORD = 'keyword';
	  var DOCTYPE = 'meta';
	  var ID = 'builtin';
	  var CLASS = 'qualifier';
	
	  var ATTRS_NEST = {
	    '{': '}',
	    '(': ')',
	    '[': ']'
	  };
	
	  var jsMode = CodeMirror.getMode(config, 'javascript');
	
	  function State() {
	    this.javaScriptLine = false;
	    this.javaScriptLineExcludesColon = false;
	
	    this.javaScriptArguments = false;
	    this.javaScriptArgumentsDepth = 0;
	
	    this.isInterpolating = false;
	    this.interpolationNesting = 0;
	
	    this.jsState = CodeMirror.startState(jsMode);
	
	    this.restOfLine = '';
	
	    this.isIncludeFiltered = false;
	    this.isEach = false;
	
	    this.lastTag = '';
	    this.scriptType = '';
	
	    // Attributes Mode
	    this.isAttrs = false;
	    this.attrsNest = [];
	    this.inAttributeName = true;
	    this.attributeIsType = false;
	    this.attrValue = '';
	
	    // Indented Mode
	    this.indentOf = Infinity;
	    this.indentToken = '';
	
	    this.innerMode = null;
	    this.innerState = null;
	
	    this.innerModeForLine = false;
	  }
	  /**
	   * Safely copy a state
	   *
	   * @return {State}
	   */
	  State.prototype.copy = function () {
	    var res = new State();
	    res.javaScriptLine = this.javaScriptLine;
	    res.javaScriptLineExcludesColon = this.javaScriptLineExcludesColon;
	    res.javaScriptArguments = this.javaScriptArguments;
	    res.javaScriptArgumentsDepth = this.javaScriptArgumentsDepth;
	    res.isInterpolating = this.isInterpolating;
	    res.interpolationNesting = this.interpolationNesting;
	
	    res.jsState = CodeMirror.copyState(jsMode, this.jsState);
	
	    res.innerMode = this.innerMode;
	    if (this.innerMode && this.innerState) {
	      res.innerState = CodeMirror.copyState(this.innerMode, this.innerState);
	    }
	
	    res.restOfLine = this.restOfLine;
	
	    res.isIncludeFiltered = this.isIncludeFiltered;
	    res.isEach = this.isEach;
	    res.lastTag = this.lastTag;
	    res.scriptType = this.scriptType;
	    res.isAttrs = this.isAttrs;
	    res.attrsNest = this.attrsNest.slice();
	    res.inAttributeName = this.inAttributeName;
	    res.attributeIsType = this.attributeIsType;
	    res.attrValue = this.attrValue;
	    res.indentOf = this.indentOf;
	    res.indentToken = this.indentToken;
	
	    res.innerModeForLine = this.innerModeForLine;
	
	    return res;
	  };
	
	  function javaScript(stream, state) {
	    if (stream.sol()) {
	      // if javaScriptLine was set at end of line, ignore it
	      state.javaScriptLine = false;
	      state.javaScriptLineExcludesColon = false;
	    }
	    if (state.javaScriptLine) {
	      if (state.javaScriptLineExcludesColon && stream.peek() === ':') {
	        state.javaScriptLine = false;
	        state.javaScriptLineExcludesColon = false;
	        return;
	      }
	      var tok = jsMode.token(stream, state.jsState);
	      if (stream.eol()) state.javaScriptLine = false;
	      return tok || true;
	    }
	  }
	  function javaScriptArguments(stream, state) {
	    if (state.javaScriptArguments) {
	      if (state.javaScriptArgumentsDepth === 0 && stream.peek() !== '(') {
	        state.javaScriptArguments = false;
	        return;
	      }
	      if (stream.peek() === '(') {
	        state.javaScriptArgumentsDepth++;
	      } else if (stream.peek() === ')') {
	        state.javaScriptArgumentsDepth--;
	      }
	      if (state.javaScriptArgumentsDepth === 0) {
	        state.javaScriptArguments = false;
	        return;
	      }
	
	      var tok = jsMode.token(stream, state.jsState);
	      return tok || true;
	    }
	  }
	
	  function yieldStatement(stream) {
	    if (stream.match(/^yield\b/)) {
	        return 'keyword';
	    }
	  }
	
	  function doctype(stream) {
	    if (stream.match(/^(?:doctype) *([^\n]+)?/)) {
	        return DOCTYPE;
	    }
	  }
	
	  function interpolation(stream, state) {
	    if (stream.match('#{')) {
	      state.isInterpolating = true;
	      state.interpolationNesting = 0;
	      return 'punctuation';
	    }
	  }
	
	  function interpolationContinued(stream, state) {
	    if (state.isInterpolating) {
	      if (stream.peek() === '}') {
	        state.interpolationNesting--;
	        if (state.interpolationNesting < 0) {
	          stream.next();
	          state.isInterpolating = false;
	          return 'punctuation';
	        }
	      } else if (stream.peek() === '{') {
	        state.interpolationNesting++;
	      }
	      return jsMode.token(stream, state.jsState) || true;
	    }
	  }
	
	  function caseStatement(stream, state) {
	    if (stream.match(/^case\b/)) {
	      state.javaScriptLine = true;
	      return KEYWORD;
	    }
	  }
	
	  function when(stream, state) {
	    if (stream.match(/^when\b/)) {
	      state.javaScriptLine = true;
	      state.javaScriptLineExcludesColon = true;
	      return KEYWORD;
	    }
	  }
	
	  function defaultStatement(stream) {
	    if (stream.match(/^default\b/)) {
	      return KEYWORD;
	    }
	  }
	
	  function extendsStatement(stream, state) {
	    if (stream.match(/^extends?\b/)) {
	      state.restOfLine = 'string';
	      return KEYWORD;
	    }
	  }
	
	  function append(stream, state) {
	    if (stream.match(/^append\b/)) {
	      state.restOfLine = 'variable';
	      return KEYWORD;
	    }
	  }
	  function prepend(stream, state) {
	    if (stream.match(/^prepend\b/)) {
	      state.restOfLine = 'variable';
	      return KEYWORD;
	    }
	  }
	  function block(stream, state) {
	    if (stream.match(/^block\b *(?:(prepend|append)\b)?/)) {
	      state.restOfLine = 'variable';
	      return KEYWORD;
	    }
	  }
	
	  function include(stream, state) {
	    if (stream.match(/^include\b/)) {
	      state.restOfLine = 'string';
	      return KEYWORD;
	    }
	  }
	
	  function includeFiltered(stream, state) {
	    if (stream.match(/^include:([a-zA-Z0-9\-]+)/, false) && stream.match('include')) {
	      state.isIncludeFiltered = true;
	      return KEYWORD;
	    }
	  }
	
	  function includeFilteredContinued(stream, state) {
	    if (state.isIncludeFiltered) {
	      var tok = filter(stream, state);
	      state.isIncludeFiltered = false;
	      state.restOfLine = 'string';
	      return tok;
	    }
	  }
	
	  function mixin(stream, state) {
	    if (stream.match(/^mixin\b/)) {
	      state.javaScriptLine = true;
	      return KEYWORD;
	    }
	  }
	
	  function call(stream, state) {
	    if (stream.match(/^\+([-\w]+)/)) {
	      if (!stream.match(/^\( *[-\w]+ *=/, false)) {
	        state.javaScriptArguments = true;
	        state.javaScriptArgumentsDepth = 0;
	      }
	      return 'variable';
	    }
	    if (stream.match(/^\+#{/, false)) {
	      stream.next();
	      state.mixinCallAfter = true;
	      return interpolation(stream, state);
	    }
	  }
	  function callArguments(stream, state) {
	    if (state.mixinCallAfter) {
	      state.mixinCallAfter = false;
	      if (!stream.match(/^\( *[-\w]+ *=/, false)) {
	        state.javaScriptArguments = true;
	        state.javaScriptArgumentsDepth = 0;
	      }
	      return true;
	    }
	  }
	
	  function conditional(stream, state) {
	    if (stream.match(/^(if|unless|else if|else)\b/)) {
	      state.javaScriptLine = true;
	      return KEYWORD;
	    }
	  }
	
	  function each(stream, state) {
	    if (stream.match(/^(- *)?(each|for)\b/)) {
	      state.isEach = true;
	      return KEYWORD;
	    }
	  }
	  function eachContinued(stream, state) {
	    if (state.isEach) {
	      if (stream.match(/^ in\b/)) {
	        state.javaScriptLine = true;
	        state.isEach = false;
	        return KEYWORD;
	      } else if (stream.sol() || stream.eol()) {
	        state.isEach = false;
	      } else if (stream.next()) {
	        while (!stream.match(/^ in\b/, false) && stream.next());
	        return 'variable';
	      }
	    }
	  }
	
	  function whileStatement(stream, state) {
	    if (stream.match(/^while\b/)) {
	      state.javaScriptLine = true;
	      return KEYWORD;
	    }
	  }
	
	  function tag(stream, state) {
	    var captures;
	    if (captures = stream.match(/^(\w(?:[-:\w]*\w)?)\/?/)) {
	      state.lastTag = captures[1].toLowerCase();
	      if (state.lastTag === 'script') {
	        state.scriptType = 'application/javascript';
	      }
	      return 'tag';
	    }
	  }
	
	  function filter(stream, state) {
	    if (stream.match(/^:([\w\-]+)/)) {
	      var innerMode;
	      if (config && config.innerModes) {
	        innerMode = config.innerModes(stream.current().substring(1));
	      }
	      if (!innerMode) {
	        innerMode = stream.current().substring(1);
	      }
	      if (typeof innerMode === 'string') {
	        innerMode = CodeMirror.getMode(config, innerMode);
	      }
	      setInnerMode(stream, state, innerMode);
	      return 'atom';
	    }
	  }
	
	  function code(stream, state) {
	    if (stream.match(/^(!?=|-)/)) {
	      state.javaScriptLine = true;
	      return 'punctuation';
	    }
	  }
	
	  function id(stream) {
	    if (stream.match(/^#([\w-]+)/)) {
	      return ID;
	    }
	  }
	
	  function className(stream) {
	    if (stream.match(/^\.([\w-]+)/)) {
	      return CLASS;
	    }
	  }
	
	  function attrs(stream, state) {
	    if (stream.peek() == '(') {
	      stream.next();
	      state.isAttrs = true;
	      state.attrsNest = [];
	      state.inAttributeName = true;
	      state.attrValue = '';
	      state.attributeIsType = false;
	      return 'punctuation';
	    }
	  }
	
	  function attrsContinued(stream, state) {
	    if (state.isAttrs) {
	      if (ATTRS_NEST[stream.peek()]) {
	        state.attrsNest.push(ATTRS_NEST[stream.peek()]);
	      }
	      if (state.attrsNest[state.attrsNest.length - 1] === stream.peek()) {
	        state.attrsNest.pop();
	      } else  if (stream.eat(')')) {
	        state.isAttrs = false;
	        return 'punctuation';
	      }
	      if (state.inAttributeName && stream.match(/^[^=,\)!]+/)) {
	        if (stream.peek() === '=' || stream.peek() === '!') {
	          state.inAttributeName = false;
	          state.jsState = CodeMirror.startState(jsMode);
	          if (state.lastTag === 'script' && stream.current().trim().toLowerCase() === 'type') {
	            state.attributeIsType = true;
	          } else {
	            state.attributeIsType = false;
	          }
	        }
	        return 'attribute';
	      }
	
	      var tok = jsMode.token(stream, state.jsState);
	      if (state.attributeIsType && tok === 'string') {
	        state.scriptType = stream.current().toString();
	      }
	      if (state.attrsNest.length === 0 && (tok === 'string' || tok === 'variable' || tok === 'keyword')) {
	        try {
	          Function('', 'var x ' + state.attrValue.replace(/,\s*$/, '').replace(/^!/, ''));
	          state.inAttributeName = true;
	          state.attrValue = '';
	          stream.backUp(stream.current().length);
	          return attrsContinued(stream, state);
	        } catch (ex) {
	          //not the end of an attribute
	        }
	      }
	      state.attrValue += stream.current();
	      return tok || true;
	    }
	  }
	
	  function attributesBlock(stream, state) {
	    if (stream.match(/^&attributes\b/)) {
	      state.javaScriptArguments = true;
	      state.javaScriptArgumentsDepth = 0;
	      return 'keyword';
	    }
	  }
	
	  function indent(stream) {
	    if (stream.sol() && stream.eatSpace()) {
	      return 'indent';
	    }
	  }
	
	  function comment(stream, state) {
	    if (stream.match(/^ *\/\/(-)?([^\n]*)/)) {
	      state.indentOf = stream.indentation();
	      state.indentToken = 'comment';
	      return 'comment';
	    }
	  }
	
	  function colon(stream) {
	    if (stream.match(/^: */)) {
	      return 'colon';
	    }
	  }
	
	  function text(stream, state) {
	    if (stream.match(/^(?:\| ?| )([^\n]+)/)) {
	      return 'string';
	    }
	    if (stream.match(/^(<[^\n]*)/, false)) {
	      // html string
	      setInnerMode(stream, state, 'htmlmixed');
	      state.innerModeForLine = true;
	      return innerMode(stream, state, true);
	    }
	  }
	
	  function dot(stream, state) {
	    if (stream.eat('.')) {
	      var innerMode = null;
	      if (state.lastTag === 'script' && state.scriptType.toLowerCase().indexOf('javascript') != -1) {
	        innerMode = state.scriptType.toLowerCase().replace(/"|'/g, '');
	      } else if (state.lastTag === 'style') {
	        innerMode = 'css';
	      }
	      setInnerMode(stream, state, innerMode);
	      return 'dot';
	    }
	  }
	
	  function fail(stream) {
	    stream.next();
	    return null;
	  }
	
	
	  function setInnerMode(stream, state, mode) {
	    mode = CodeMirror.mimeModes[mode] || mode;
	    mode = config.innerModes ? config.innerModes(mode) || mode : mode;
	    mode = CodeMirror.mimeModes[mode] || mode;
	    mode = CodeMirror.getMode(config, mode);
	    state.indentOf = stream.indentation();
	
	    if (mode && mode.name !== 'null') {
	      state.innerMode = mode;
	    } else {
	      state.indentToken = 'string';
	    }
	  }
	  function innerMode(stream, state, force) {
	    if (stream.indentation() > state.indentOf || (state.innerModeForLine && !stream.sol()) || force) {
	      if (state.innerMode) {
	        if (!state.innerState) {
	          state.innerState = state.innerMode.startState ? CodeMirror.startState(state.innerMode, stream.indentation()) : {};
	        }
	        return stream.hideFirstChars(state.indentOf + 2, function () {
	          return state.innerMode.token(stream, state.innerState) || true;
	        });
	      } else {
	        stream.skipToEnd();
	        return state.indentToken;
	      }
	    } else if (stream.sol()) {
	      state.indentOf = Infinity;
	      state.indentToken = null;
	      state.innerMode = null;
	      state.innerState = null;
	    }
	  }
	  function restOfLine(stream, state) {
	    if (stream.sol()) {
	      // if restOfLine was set at end of line, ignore it
	      state.restOfLine = '';
	    }
	    if (state.restOfLine) {
	      stream.skipToEnd();
	      var tok = state.restOfLine;
	      state.restOfLine = '';
	      return tok;
	    }
	  }
	
	
	  function startState() {
	    return new State();
	  }
	  function copyState(state) {
	    return state.copy();
	  }
	  /**
	   * Get the next token in the stream
	   *
	   * @param {Stream} stream
	   * @param {State} state
	   */
	  function nextToken(stream, state) {
	    var tok = innerMode(stream, state)
	      || restOfLine(stream, state)
	      || interpolationContinued(stream, state)
	      || includeFilteredContinued(stream, state)
	      || eachContinued(stream, state)
	      || attrsContinued(stream, state)
	      || javaScript(stream, state)
	      || javaScriptArguments(stream, state)
	      || callArguments(stream, state)
	
	      || yieldStatement(stream)
	      || doctype(stream)
	      || interpolation(stream, state)
	      || caseStatement(stream, state)
	      || when(stream, state)
	      || defaultStatement(stream)
	      || extendsStatement(stream, state)
	      || append(stream, state)
	      || prepend(stream, state)
	      || block(stream, state)
	      || include(stream, state)
	      || includeFiltered(stream, state)
	      || mixin(stream, state)
	      || call(stream, state)
	      || conditional(stream, state)
	      || each(stream, state)
	      || whileStatement(stream, state)
	      || tag(stream, state)
	      || filter(stream, state)
	      || code(stream, state)
	      || id(stream)
	      || className(stream)
	      || attrs(stream, state)
	      || attributesBlock(stream, state)
	      || indent(stream)
	      || text(stream, state)
	      || comment(stream, state)
	      || colon(stream)
	      || dot(stream, state)
	      || fail(stream);
	
	    return tok === true ? null : tok;
	  }
	  return {
	    startState: startState,
	    copyState: copyState,
	    token: nextToken
	  };
	}, 'javascript', 'css', 'htmlmixed');
	
	CodeMirror.defineMIME('text/x-pug', 'pug');
	CodeMirror.defineMIME('text/x-jade', 'pug');
	
	});


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(1));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  "use strict";
	
	  function wordRegexp(words) {
	    return new RegExp("^((" + words.join(")|(") + "))\\b");
	  }
	
	  var wordOperators = wordRegexp(["and", "or", "not", "is"]);
	  var commonKeywords = ["as", "assert", "break", "class", "continue",
	                        "def", "del", "elif", "else", "except", "finally",
	                        "for", "from", "global", "if", "import",
	                        "lambda", "pass", "raise", "return",
	                        "try", "while", "with", "yield", "in"];
	  var commonBuiltins = ["abs", "all", "any", "bin", "bool", "bytearray", "callable", "chr",
	                        "classmethod", "compile", "complex", "delattr", "dict", "dir", "divmod",
	                        "enumerate", "eval", "filter", "float", "format", "frozenset",
	                        "getattr", "globals", "hasattr", "hash", "help", "hex", "id",
	                        "input", "int", "isinstance", "issubclass", "iter", "len",
	                        "list", "locals", "map", "max", "memoryview", "min", "next",
	                        "object", "oct", "open", "ord", "pow", "property", "range",
	                        "repr", "reversed", "round", "set", "setattr", "slice",
	                        "sorted", "staticmethod", "str", "sum", "super", "tuple",
	                        "type", "vars", "zip", "__import__", "NotImplemented",
	                        "Ellipsis", "__debug__"];
	  CodeMirror.registerHelper("hintWords", "python", commonKeywords.concat(commonBuiltins));
	
	  function top(state) {
	    return state.scopes[state.scopes.length - 1];
	  }
	
	  CodeMirror.defineMode("python", function(conf, parserConf) {
	    var ERRORCLASS = "error";
	
	    var delimiters = parserConf.delimiters || parserConf.singleDelimiters || /^[\(\)\[\]\{\}@,:`=;\.\\]/;
	    //               (Backwards-compatiblity with old, cumbersome config system)
	    var operators = [parserConf.singleOperators, parserConf.doubleOperators, parserConf.doubleDelimiters, parserConf.tripleDelimiters,
	                     parserConf.operators || /^([-+*/%\/&|^]=?|[<>=]+|\/\/=?|\*\*=?|!=|[~!@]|\.\.\.)/]
	    for (var i = 0; i < operators.length; i++) if (!operators[i]) operators.splice(i--, 1)
	
	    var hangingIndent = parserConf.hangingIndent || conf.indentUnit;
	
	    var myKeywords = commonKeywords, myBuiltins = commonBuiltins;
	    if (parserConf.extra_keywords != undefined)
	      myKeywords = myKeywords.concat(parserConf.extra_keywords);
	
	    if (parserConf.extra_builtins != undefined)
	      myBuiltins = myBuiltins.concat(parserConf.extra_builtins);
	
	    var py3 = !(parserConf.version && Number(parserConf.version) < 3)
	    if (py3) {
	      // since http://legacy.python.org/dev/peps/pep-0465/ @ is also an operator
	      var identifiers = parserConf.identifiers|| /^[_A-Za-z\u00A1-\uFFFF][_A-Za-z0-9\u00A1-\uFFFF]*/;
	      myKeywords = myKeywords.concat(["nonlocal", "False", "True", "None", "async", "await"]);
	      myBuiltins = myBuiltins.concat(["ascii", "bytes", "exec", "print"]);
	      var stringPrefixes = new RegExp("^(([rbuf]|(br)|(fr))?('{3}|\"{3}|['\"]))", "i");
	    } else {
	      var identifiers = parserConf.identifiers|| /^[_A-Za-z][_A-Za-z0-9]*/;
	      myKeywords = myKeywords.concat(["exec", "print"]);
	      myBuiltins = myBuiltins.concat(["apply", "basestring", "buffer", "cmp", "coerce", "execfile",
	                                      "file", "intern", "long", "raw_input", "reduce", "reload",
	                                      "unichr", "unicode", "xrange", "False", "True", "None"]);
	      var stringPrefixes = new RegExp("^(([rubf]|(ur)|(br))?('{3}|\"{3}|['\"]))", "i");
	    }
	    var keywords = wordRegexp(myKeywords);
	    var builtins = wordRegexp(myBuiltins);
	
	    // tokenizers
	    function tokenBase(stream, state) {
	      var sol = stream.sol() && state.lastToken != "\\"
	      if (sol) state.indent = stream.indentation()
	      // Handle scope changes
	      if (sol && top(state).type == "py") {
	        var scopeOffset = top(state).offset;
	        if (stream.eatSpace()) {
	          var lineOffset = stream.indentation();
	          if (lineOffset > scopeOffset)
	            pushPyScope(state);
	          else if (lineOffset < scopeOffset && dedent(stream, state) && stream.peek() != "#")
	            state.errorToken = true;
	          return null;
	        } else {
	          var style = tokenBaseInner(stream, state);
	          if (scopeOffset > 0 && dedent(stream, state))
	            style += " " + ERRORCLASS;
	          return style;
	        }
	      }
	      return tokenBaseInner(stream, state);
	    }
	
	    function tokenBaseInner(stream, state) {
	      if (stream.eatSpace()) return null;
	
	      // Handle Comments
	      if (stream.match(/^#.*/)) return "comment";
	
	      // Handle Number Literals
	      if (stream.match(/^[0-9\.]/, false)) {
	        var floatLiteral = false;
	        // Floats
	        if (stream.match(/^[\d_]*\.\d+(e[\+\-]?\d+)?/i)) { floatLiteral = true; }
	        if (stream.match(/^[\d_]+\.\d*/)) { floatLiteral = true; }
	        if (stream.match(/^\.\d+/)) { floatLiteral = true; }
	        if (floatLiteral) {
	          // Float literals may be "imaginary"
	          stream.eat(/J/i);
	          return "number";
	        }
	        // Integers
	        var intLiteral = false;
	        // Hex
	        if (stream.match(/^0x[0-9a-f_]+/i)) intLiteral = true;
	        // Binary
	        if (stream.match(/^0b[01_]+/i)) intLiteral = true;
	        // Octal
	        if (stream.match(/^0o[0-7_]+/i)) intLiteral = true;
	        // Decimal
	        if (stream.match(/^[1-9][\d_]*(e[\+\-]?[\d_]+)?/)) {
	          // Decimal literals may be "imaginary"
	          stream.eat(/J/i);
	          // TODO - Can you have imaginary longs?
	          intLiteral = true;
	        }
	        // Zero by itself with no other piece of number.
	        if (stream.match(/^0(?![\dx])/i)) intLiteral = true;
	        if (intLiteral) {
	          // Integer literals may be "long"
	          stream.eat(/L/i);
	          return "number";
	        }
	      }
	
	      // Handle Strings
	      if (stream.match(stringPrefixes)) {
	        var isFmtString = stream.current().toLowerCase().indexOf('f') !== -1;
	        if (!isFmtString) {
	          state.tokenize = tokenStringFactory(stream.current(), state.tokenize);
	          return state.tokenize(stream, state);
	        } else {
	          state.tokenize = formatStringFactory(stream.current(), state.tokenize);
	          return state.tokenize(stream, state);
	        }
	      }
	
	      for (var i = 0; i < operators.length; i++)
	        if (stream.match(operators[i])) return "operator"
	
	      if (stream.match(delimiters)) return "punctuation";
	
	      if (state.lastToken == "." && stream.match(identifiers))
	        return "property";
	
	      if (stream.match(keywords) || stream.match(wordOperators))
	        return "keyword";
	
	      if (stream.match(builtins))
	        return "builtin";
	
	      if (stream.match(/^(self|cls)\b/))
	        return "variable-2";
	
	      if (stream.match(identifiers)) {
	        if (state.lastToken == "def" || state.lastToken == "class")
	          return "def";
	        return "variable";
	      }
	
	      // Handle non-detected items
	      stream.next();
	      return ERRORCLASS;
	    }
	
	    function formatStringFactory(delimiter, tokenOuter) {
	      while ("rubf".indexOf(delimiter.charAt(0).toLowerCase()) >= 0)
	        delimiter = delimiter.substr(1);
	
	      var singleline = delimiter.length == 1;
	      var OUTCLASS = "string";
	
	      function tokenNestedExpr(depth) {
	        return function(stream, state) {
	          var inner = tokenBaseInner(stream, state)
	          if (inner == "punctuation") {
	            if (stream.current() == "{") {
	              state.tokenize = tokenNestedExpr(depth + 1)
	            } else if (stream.current() == "}") {
	              if (depth > 1) state.tokenize = tokenNestedExpr(depth - 1)
	              else state.tokenize = tokenString
	            }
	          }
	          return inner
	        }
	      }
	
	      function tokenString(stream, state) {
	        while (!stream.eol()) {
	          stream.eatWhile(/[^'"\{\}\\]/);
	          if (stream.eat("\\")) {
	            stream.next();
	            if (singleline && stream.eol())
	              return OUTCLASS;
	          } else if (stream.match(delimiter)) {
	            state.tokenize = tokenOuter;
	            return OUTCLASS;
	          } else if (stream.match('{{')) {
	            // ignore {{ in f-str
	            return OUTCLASS;
	          } else if (stream.match('{', false)) {
	            // switch to nested mode
	            state.tokenize = tokenNestedExpr(0)
	            if (stream.current()) return OUTCLASS;
	            else return state.tokenize(stream, state)
	          } else if (stream.match('}}')) {
	            return OUTCLASS;
	          } else if (stream.match('}')) {
	            // single } in f-string is an error
	            return ERRORCLASS;
	          } else {
	            stream.eat(/['"]/);
	          }
	        }
	        if (singleline) {
	          if (parserConf.singleLineStringErrors)
	            return ERRORCLASS;
	          else
	            state.tokenize = tokenOuter;
	        }
	        return OUTCLASS;
	      }
	      tokenString.isString = true;
	      return tokenString;
	    }
	
	    function tokenStringFactory(delimiter, tokenOuter) {
	      while ("rubf".indexOf(delimiter.charAt(0).toLowerCase()) >= 0)
	        delimiter = delimiter.substr(1);
	
	      var singleline = delimiter.length == 1;
	      var OUTCLASS = "string";
	
	      function tokenString(stream, state) {
	        while (!stream.eol()) {
	          stream.eatWhile(/[^'"\\]/);
	          if (stream.eat("\\")) {
	            stream.next();
	            if (singleline && stream.eol())
	              return OUTCLASS;
	          } else if (stream.match(delimiter)) {
	            state.tokenize = tokenOuter;
	            return OUTCLASS;
	          } else {
	            stream.eat(/['"]/);
	          }
	        }
	        if (singleline) {
	          if (parserConf.singleLineStringErrors)
	            return ERRORCLASS;
	          else
	            state.tokenize = tokenOuter;
	        }
	        return OUTCLASS;
	      }
	      tokenString.isString = true;
	      return tokenString;
	    }
	
	    function pushPyScope(state) {
	      while (top(state).type != "py") state.scopes.pop()
	      state.scopes.push({offset: top(state).offset + conf.indentUnit,
	                         type: "py",
	                         align: null})
	    }
	
	    function pushBracketScope(stream, state, type) {
	      var align = stream.match(/^([\s\[\{\(]|#.*)*$/, false) ? null : stream.column() + 1
	      state.scopes.push({offset: state.indent + hangingIndent,
	                         type: type,
	                         align: align})
	    }
	
	    function dedent(stream, state) {
	      var indented = stream.indentation();
	      while (state.scopes.length > 1 && top(state).offset > indented) {
	        if (top(state).type != "py") return true;
	        state.scopes.pop();
	      }
	      return top(state).offset != indented;
	    }
	
	    function tokenLexer(stream, state) {
	      if (stream.sol()) state.beginningOfLine = true;
	
	      var style = state.tokenize(stream, state);
	      var current = stream.current();
	
	      // Handle decorators
	      if (state.beginningOfLine && current == "@")
	        return stream.match(identifiers, false) ? "meta" : py3 ? "operator" : ERRORCLASS;
	
	      if (/\S/.test(current)) state.beginningOfLine = false;
	
	      if ((style == "variable" || style == "builtin")
	          && state.lastToken == "meta")
	        style = "meta";
	
	      // Handle scope changes.
	      if (current == "pass" || current == "return")
	        state.dedent += 1;
	
	      if (current == "lambda") state.lambda = true;
	      if (current == ":" && !state.lambda && top(state).type == "py")
	        pushPyScope(state);
	
	      if (current.length == 1 && !/string|comment/.test(style)) {
	        var delimiter_index = "[({".indexOf(current);
	        if (delimiter_index != -1)
	          pushBracketScope(stream, state, "])}".slice(delimiter_index, delimiter_index+1));
	
	        delimiter_index = "])}".indexOf(current);
	        if (delimiter_index != -1) {
	          if (top(state).type == current) state.indent = state.scopes.pop().offset - hangingIndent
	          else return ERRORCLASS;
	        }
	      }
	      if (state.dedent > 0 && stream.eol() && top(state).type == "py") {
	        if (state.scopes.length > 1) state.scopes.pop();
	        state.dedent -= 1;
	      }
	
	      return style;
	    }
	
	    var external = {
	      startState: function(basecolumn) {
	        return {
	          tokenize: tokenBase,
	          scopes: [{offset: basecolumn || 0, type: "py", align: null}],
	          indent: basecolumn || 0,
	          lastToken: null,
	          lambda: false,
	          dedent: 0
	        };
	      },
	
	      token: function(stream, state) {
	        var addErr = state.errorToken;
	        if (addErr) state.errorToken = false;
	        var style = tokenLexer(stream, state);
	
	        if (style && style != "comment")
	          state.lastToken = (style == "keyword" || style == "punctuation") ? stream.current() : style;
	        if (style == "punctuation") style = null;
	
	        if (stream.eol() && state.lambda)
	          state.lambda = false;
	        return addErr ? style + " " + ERRORCLASS : style;
	      },
	
	      indent: function(state, textAfter) {
	        if (state.tokenize != tokenBase)
	          return state.tokenize.isString ? CodeMirror.Pass : 0;
	
	        var scope = top(state), closing = scope.type == textAfter.charAt(0)
	        if (scope.align != null)
	          return scope.align - (closing ? 1 : 0)
	        else
	          return scope.offset - (closing ? hangingIndent : 0)
	      },
	
	      electricInput: /^\s*[\}\]\)]$/,
	      closeBrackets: {triples: "'\""},
	      lineComment: "#",
	      fold: "indent"
	    };
	    return external;
	  });
	
	  CodeMirror.defineMIME("text/x-python", "python");
	
	  var words = function(str) { return str.split(" "); };
	
	  CodeMirror.defineMIME("text/x-cython", {
	    name: "python",
	    extra_keywords: words("by cdef cimport cpdef ctypedef enum except "+
	                          "extern gil include nogil property public "+
	                          "readonly struct union DEF IF ELIF ELSE")
	  });
	
	});


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(1));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.registerHelper("wordChars", "r", /[\w.]/);
	
	CodeMirror.defineMode("r", function(config) {
	  function wordObj(words) {
	    var res = {};
	    for (var i = 0; i < words.length; ++i) res[words[i]] = true;
	    return res;
	  }
	  var commonAtoms = ["NULL", "NA", "Inf", "NaN", "NA_integer_", "NA_real_", "NA_complex_", "NA_character_", "TRUE", "FALSE"];
	  var commonBuiltins = ["list", "quote", "bquote", "eval", "return", "call", "parse", "deparse"];
	  var commonKeywords = ["if", "else", "repeat", "while", "function", "for", "in", "next", "break"];
	  var commonBlockKeywords = ["if", "else", "repeat", "while", "function", "for"];
	
	  CodeMirror.registerHelper("hintWords", "r", commonAtoms.concat(commonBuiltins, commonKeywords));
	
	  var atoms = wordObj(commonAtoms);
	  var builtins = wordObj(commonBuiltins);
	  var keywords = wordObj(commonKeywords);
	  var blockkeywords = wordObj(commonBlockKeywords);
	  var opChars = /[+\-*\/^<>=!&|~$:]/;
	  var curPunc;
	
	  function tokenBase(stream, state) {
	    curPunc = null;
	    var ch = stream.next();
	    if (ch == "#") {
	      stream.skipToEnd();
	      return "comment";
	    } else if (ch == "0" && stream.eat("x")) {
	      stream.eatWhile(/[\da-f]/i);
	      return "number";
	    } else if (ch == "." && stream.eat(/\d/)) {
	      stream.match(/\d*(?:e[+\-]?\d+)?/);
	      return "number";
	    } else if (/\d/.test(ch)) {
	      stream.match(/\d*(?:\.\d+)?(?:e[+\-]\d+)?L?/);
	      return "number";
	    } else if (ch == "'" || ch == '"') {
	      state.tokenize = tokenString(ch);
	      return "string";
	    } else if (ch == "`") {
	      stream.match(/[^`]+`/);
	      return "variable-3";
	    } else if (ch == "." && stream.match(/.[.\d]+/)) {
	      return "keyword";
	    } else if (/[\w\.]/.test(ch) && ch != "_") {
	      stream.eatWhile(/[\w\.]/);
	      var word = stream.current();
	      if (atoms.propertyIsEnumerable(word)) return "atom";
	      if (keywords.propertyIsEnumerable(word)) {
	        // Block keywords start new blocks, except 'else if', which only starts
	        // one new block for the 'if', no block for the 'else'.
	        if (blockkeywords.propertyIsEnumerable(word) &&
	            !stream.match(/\s*if(\s+|$)/, false))
	          curPunc = "block";
	        return "keyword";
	      }
	      if (builtins.propertyIsEnumerable(word)) return "builtin";
	      return "variable";
	    } else if (ch == "%") {
	      if (stream.skipTo("%")) stream.next();
	      return "operator variable-2";
	    } else if (
	        (ch == "<" && stream.eat("-")) ||
	        (ch == "<" && stream.match("<-")) ||
	        (ch == "-" && stream.match(/>>?/))
	      ) {
	      return "operator arrow";
	    } else if (ch == "=" && state.ctx.argList) {
	      return "arg-is";
	    } else if (opChars.test(ch)) {
	      if (ch == "$") return "operator dollar";
	      stream.eatWhile(opChars);
	      return "operator";
	    } else if (/[\(\){}\[\];]/.test(ch)) {
	      curPunc = ch;
	      if (ch == ";") return "semi";
	      return null;
	    } else {
	      return null;
	    }
	  }
	
	  function tokenString(quote) {
	    return function(stream, state) {
	      if (stream.eat("\\")) {
	        var ch = stream.next();
	        if (ch == "x") stream.match(/^[a-f0-9]{2}/i);
	        else if ((ch == "u" || ch == "U") && stream.eat("{") && stream.skipTo("}")) stream.next();
	        else if (ch == "u") stream.match(/^[a-f0-9]{4}/i);
	        else if (ch == "U") stream.match(/^[a-f0-9]{8}/i);
	        else if (/[0-7]/.test(ch)) stream.match(/^[0-7]{1,2}/);
	        return "string-2";
	      } else {
	        var next;
	        while ((next = stream.next()) != null) {
	          if (next == quote) { state.tokenize = tokenBase; break; }
	          if (next == "\\") { stream.backUp(1); break; }
	        }
	        return "string";
	      }
	    };
	  }
	
	  var ALIGN_YES = 1, ALIGN_NO = 2, BRACELESS = 4
	
	  function push(state, type, stream) {
	    state.ctx = {type: type,
	                 indent: state.indent,
	                 flags: 0,
	                 column: stream.column(),
	                 prev: state.ctx};
	  }
	  function setFlag(state, flag) {
	    var ctx = state.ctx
	    state.ctx = {type: ctx.type,
	                 indent: ctx.indent,
	                 flags: ctx.flags | flag,
	                 column: ctx.column,
	                 prev: ctx.prev}
	  }
	  function pop(state) {
	    state.indent = state.ctx.indent;
	    state.ctx = state.ctx.prev;
	  }
	
	  return {
	    startState: function() {
	      return {tokenize: tokenBase,
	              ctx: {type: "top",
	                    indent: -config.indentUnit,
	                    flags: ALIGN_NO},
	              indent: 0,
	              afterIdent: false};
	    },
	
	    token: function(stream, state) {
	      if (stream.sol()) {
	        if ((state.ctx.flags & 3) == 0) state.ctx.flags |= ALIGN_NO
	        if (state.ctx.flags & BRACELESS) pop(state)
	        state.indent = stream.indentation();
	      }
	      if (stream.eatSpace()) return null;
	      var style = state.tokenize(stream, state);
	      if (style != "comment" && (state.ctx.flags & ALIGN_NO) == 0) setFlag(state, ALIGN_YES)
	
	      if ((curPunc == ";" || curPunc == "{" || curPunc == "}") && state.ctx.type == "block") pop(state);
	      if (curPunc == "{") push(state, "}", stream);
	      else if (curPunc == "(") {
	        push(state, ")", stream);
	        if (state.afterIdent) state.ctx.argList = true;
	      }
	      else if (curPunc == "[") push(state, "]", stream);
	      else if (curPunc == "block") push(state, "block", stream);
	      else if (curPunc == state.ctx.type) pop(state);
	      else if (state.ctx.type == "block" && style != "comment") setFlag(state, BRACELESS)
	      state.afterIdent = style == "variable" || style == "keyword";
	      return style;
	    },
	
	    indent: function(state, textAfter) {
	      if (state.tokenize != tokenBase) return 0;
	      var firstChar = textAfter && textAfter.charAt(0), ctx = state.ctx,
	          closing = firstChar == ctx.type;
	      if (ctx.flags & BRACELESS) ctx = ctx.prev
	      if (ctx.type == "block") return ctx.indent + (firstChar == "{" ? 0 : config.indentUnit);
	      else if (ctx.flags & ALIGN_YES) return ctx.column + (closing ? 0 : 1);
	      else return ctx.indent + (closing ? 0 : config.indentUnit);
	    },
	
	    lineComment: "#"
	  };
	});
	
	CodeMirror.defineMIME("text/x-rsrc", "r");
	
	});


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(1));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("ruby", function(config) {
	  function wordObj(words) {
	    var o = {};
	    for (var i = 0, e = words.length; i < e; ++i) o[words[i]] = true;
	    return o;
	  }
	  var keywords = wordObj([
	    "alias", "and", "BEGIN", "begin", "break", "case", "class", "def", "defined?", "do", "else",
	    "elsif", "END", "end", "ensure", "false", "for", "if", "in", "module", "next", "not", "or",
	    "redo", "rescue", "retry", "return", "self", "super", "then", "true", "undef", "unless",
	    "until", "when", "while", "yield", "nil", "raise", "throw", "catch", "fail", "loop", "callcc",
	    "caller", "lambda", "proc", "public", "protected", "private", "require", "load",
	    "require_relative", "extend", "autoload", "__END__", "__FILE__", "__LINE__", "__dir__"
	  ]);
	  var indentWords = wordObj(["def", "class", "case", "for", "while", "until", "module", "then",
	                             "catch", "loop", "proc", "begin"]);
	  var dedentWords = wordObj(["end", "until"]);
	  var opening = {"[": "]", "{": "}", "(": ")"};
	  var closing = {"]": "[", "}": "{", ")": "("};
	  var curPunc;
	
	  function chain(newtok, stream, state) {
	    state.tokenize.push(newtok);
	    return newtok(stream, state);
	  }
	
	  function tokenBase(stream, state) {
	    if (stream.sol() && stream.match("=begin") && stream.eol()) {
	      state.tokenize.push(readBlockComment);
	      return "comment";
	    }
	    if (stream.eatSpace()) return null;
	    var ch = stream.next(), m;
	    if (ch == "`" || ch == "'" || ch == '"') {
	      return chain(readQuoted(ch, "string", ch == '"' || ch == "`"), stream, state);
	    } else if (ch == "/") {
	      if (regexpAhead(stream))
	        return chain(readQuoted(ch, "string-2", true), stream, state);
	      else
	        return "operator";
	    } else if (ch == "%") {
	      var style = "string", embed = true;
	      if (stream.eat("s")) style = "atom";
	      else if (stream.eat(/[WQ]/)) style = "string";
	      else if (stream.eat(/[r]/)) style = "string-2";
	      else if (stream.eat(/[wxq]/)) { style = "string"; embed = false; }
	      var delim = stream.eat(/[^\w\s=]/);
	      if (!delim) return "operator";
	      if (opening.propertyIsEnumerable(delim)) delim = opening[delim];
	      return chain(readQuoted(delim, style, embed, true), stream, state);
	    } else if (ch == "#") {
	      stream.skipToEnd();
	      return "comment";
	    } else if (ch == "<" && (m = stream.match(/^<([-~])[\`\"\']?([a-zA-Z_?]\w*)[\`\"\']?(?:;|$)/))) {
	      return chain(readHereDoc(m[2], m[1]), stream, state);
	    } else if (ch == "0") {
	      if (stream.eat("x")) stream.eatWhile(/[\da-fA-F]/);
	      else if (stream.eat("b")) stream.eatWhile(/[01]/);
	      else stream.eatWhile(/[0-7]/);
	      return "number";
	    } else if (/\d/.test(ch)) {
	      stream.match(/^[\d_]*(?:\.[\d_]+)?(?:[eE][+\-]?[\d_]+)?/);
	      return "number";
	    } else if (ch == "?") {
	      while (stream.match(/^\\[CM]-/)) {}
	      if (stream.eat("\\")) stream.eatWhile(/\w/);
	      else stream.next();
	      return "string";
	    } else if (ch == ":") {
	      if (stream.eat("'")) return chain(readQuoted("'", "atom", false), stream, state);
	      if (stream.eat('"')) return chain(readQuoted('"', "atom", true), stream, state);
	
	      // :> :>> :< :<< are valid symbols
	      if (stream.eat(/[\<\>]/)) {
	        stream.eat(/[\<\>]/);
	        return "atom";
	      }
	
	      // :+ :- :/ :* :| :& :! are valid symbols
	      if (stream.eat(/[\+\-\*\/\&\|\:\!]/)) {
	        return "atom";
	      }
	
	      // Symbols can't start by a digit
	      if (stream.eat(/[a-zA-Z$@_\xa1-\uffff]/)) {
	        stream.eatWhile(/[\w$\xa1-\uffff]/);
	        // Only one ? ! = is allowed and only as the last character
	        stream.eat(/[\?\!\=]/);
	        return "atom";
	      }
	      return "operator";
	    } else if (ch == "@" && stream.match(/^@?[a-zA-Z_\xa1-\uffff]/)) {
	      stream.eat("@");
	      stream.eatWhile(/[\w\xa1-\uffff]/);
	      return "variable-2";
	    } else if (ch == "$") {
	      if (stream.eat(/[a-zA-Z_]/)) {
	        stream.eatWhile(/[\w]/);
	      } else if (stream.eat(/\d/)) {
	        stream.eat(/\d/);
	      } else {
	        stream.next(); // Must be a special global like $: or $!
	      }
	      return "variable-3";
	    } else if (/[a-zA-Z_\xa1-\uffff]/.test(ch)) {
	      stream.eatWhile(/[\w\xa1-\uffff]/);
	      stream.eat(/[\?\!]/);
	      if (stream.eat(":")) return "atom";
	      return "ident";
	    } else if (ch == "|" && (state.varList || state.lastTok == "{" || state.lastTok == "do")) {
	      curPunc = "|";
	      return null;
	    } else if (/[\(\)\[\]{}\\;]/.test(ch)) {
	      curPunc = ch;
	      return null;
	    } else if (ch == "-" && stream.eat(">")) {
	      return "arrow";
	    } else if (/[=+\-\/*:\.^%<>~|]/.test(ch)) {
	      var more = stream.eatWhile(/[=+\-\/*:\.^%<>~|]/);
	      if (ch == "." && !more) curPunc = ".";
	      return "operator";
	    } else {
	      return null;
	    }
	  }
	
	  function regexpAhead(stream) {
	    var start = stream.pos, depth = 0, next, found = false, escaped = false
	    while ((next = stream.next()) != null) {
	      if (!escaped) {
	        if ("[{(".indexOf(next) > -1) {
	          depth++
	        } else if ("]})".indexOf(next) > -1) {
	          depth--
	          if (depth < 0) break
	        } else if (next == "/" && depth == 0) {
	          found = true
	          break
	        }
	        escaped = next == "\\"
	      } else {
	        escaped = false
	      }
	    }
	    stream.backUp(stream.pos - start)
	    return found
	  }
	
	  function tokenBaseUntilBrace(depth) {
	    if (!depth) depth = 1;
	    return function(stream, state) {
	      if (stream.peek() == "}") {
	        if (depth == 1) {
	          state.tokenize.pop();
	          return state.tokenize[state.tokenize.length-1](stream, state);
	        } else {
	          state.tokenize[state.tokenize.length - 1] = tokenBaseUntilBrace(depth - 1);
	        }
	      } else if (stream.peek() == "{") {
	        state.tokenize[state.tokenize.length - 1] = tokenBaseUntilBrace(depth + 1);
	      }
	      return tokenBase(stream, state);
	    };
	  }
	  function tokenBaseOnce() {
	    var alreadyCalled = false;
	    return function(stream, state) {
	      if (alreadyCalled) {
	        state.tokenize.pop();
	        return state.tokenize[state.tokenize.length-1](stream, state);
	      }
	      alreadyCalled = true;
	      return tokenBase(stream, state);
	    };
	  }
	  function readQuoted(quote, style, embed, unescaped) {
	    return function(stream, state) {
	      var escaped = false, ch;
	
	      if (state.context.type === 'read-quoted-paused') {
	        state.context = state.context.prev;
	        stream.eat("}");
	      }
	
	      while ((ch = stream.next()) != null) {
	        if (ch == quote && (unescaped || !escaped)) {
	          state.tokenize.pop();
	          break;
	        }
	        if (embed && ch == "#" && !escaped) {
	          if (stream.eat("{")) {
	            if (quote == "}") {
	              state.context = {prev: state.context, type: 'read-quoted-paused'};
	            }
	            state.tokenize.push(tokenBaseUntilBrace());
	            break;
	          } else if (/[@\$]/.test(stream.peek())) {
	            state.tokenize.push(tokenBaseOnce());
	            break;
	          }
	        }
	        escaped = !escaped && ch == "\\";
	      }
	      return style;
	    };
	  }
	  function readHereDoc(phrase, mayIndent) {
	    return function(stream, state) {
	      if (mayIndent) stream.eatSpace()
	      if (stream.match(phrase)) state.tokenize.pop();
	      else stream.skipToEnd();
	      return "string";
	    };
	  }
	  function readBlockComment(stream, state) {
	    if (stream.sol() && stream.match("=end") && stream.eol())
	      state.tokenize.pop();
	    stream.skipToEnd();
	    return "comment";
	  }
	
	  return {
	    startState: function() {
	      return {tokenize: [tokenBase],
	              indented: 0,
	              context: {type: "top", indented: -config.indentUnit},
	              continuedLine: false,
	              lastTok: null,
	              varList: false};
	    },
	
	    token: function(stream, state) {
	      curPunc = null;
	      if (stream.sol()) state.indented = stream.indentation();
	      var style = state.tokenize[state.tokenize.length-1](stream, state), kwtype;
	      var thisTok = curPunc;
	      if (style == "ident") {
	        var word = stream.current();
	        style = state.lastTok == "." ? "property"
	          : keywords.propertyIsEnumerable(stream.current()) ? "keyword"
	          : /^[A-Z]/.test(word) ? "tag"
	          : (state.lastTok == "def" || state.lastTok == "class" || state.varList) ? "def"
	          : "variable";
	        if (style == "keyword") {
	          thisTok = word;
	          if (indentWords.propertyIsEnumerable(word)) kwtype = "indent";
	          else if (dedentWords.propertyIsEnumerable(word)) kwtype = "dedent";
	          else if ((word == "if" || word == "unless") && stream.column() == stream.indentation())
	            kwtype = "indent";
	          else if (word == "do" && state.context.indented < state.indented)
	            kwtype = "indent";
	        }
	      }
	      if (curPunc || (style && style != "comment")) state.lastTok = thisTok;
	      if (curPunc == "|") state.varList = !state.varList;
	
	      if (kwtype == "indent" || /[\(\[\{]/.test(curPunc))
	        state.context = {prev: state.context, type: curPunc || style, indented: state.indented};
	      else if ((kwtype == "dedent" || /[\)\]\}]/.test(curPunc)) && state.context.prev)
	        state.context = state.context.prev;
	
	      if (stream.eol())
	        state.continuedLine = (curPunc == "\\" || style == "operator");
	      return style;
	    },
	
	    indent: function(state, textAfter) {
	      if (state.tokenize[state.tokenize.length-1] != tokenBase) return CodeMirror.Pass;
	      var firstChar = textAfter && textAfter.charAt(0);
	      var ct = state.context;
	      var closed = ct.type == closing[firstChar] ||
	        ct.type == "keyword" && /^(?:end|until|else|elsif|when|rescue)\b/.test(textAfter);
	      return ct.indented + (closed ? 0 : config.indentUnit) +
	        (state.continuedLine ? config.indentUnit : 0);
	    },
	
	    electricInput: /^\s*(?:end|rescue|elsif|else|\})$/,
	    lineComment: "#",
	    fold: "indent"
	  };
	});
	
	CodeMirror.defineMIME("text/x-ruby", "ruby");
	
	});


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(1));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode('shell', function() {
	
	  var words = {};
	  function define(style, dict) {
	    for(var i = 0; i < dict.length; i++) {
	      words[dict[i]] = style;
	    }
	  };
	
	  var commonAtoms = ["true", "false"];
	  var commonKeywords = ["if", "then", "do", "else", "elif", "while", "until", "for", "in", "esac", "fi",
	    "fin", "fil", "done", "exit", "set", "unset", "export", "function"];
	  var commonCommands = ["ab", "awk", "bash", "beep", "cat", "cc", "cd", "chown", "chmod", "chroot", "clear",
	    "cp", "curl", "cut", "diff", "echo", "find", "gawk", "gcc", "get", "git", "grep", "hg", "kill", "killall",
	    "ln", "ls", "make", "mkdir", "openssl", "mv", "nc", "nl", "node", "npm", "ping", "ps", "restart", "rm",
	    "rmdir", "sed", "service", "sh", "shopt", "shred", "source", "sort", "sleep", "ssh", "start", "stop",
	    "su", "sudo", "svn", "tee", "telnet", "top", "touch", "vi", "vim", "wall", "wc", "wget", "who", "write",
	    "yes", "zsh"];
	
	  CodeMirror.registerHelper("hintWords", "shell", commonAtoms.concat(commonKeywords, commonCommands));
	
	  define('atom', commonAtoms);
	  define('keyword', commonKeywords);
	  define('builtin', commonCommands);
	
	  function tokenBase(stream, state) {
	    if (stream.eatSpace()) return null;
	
	    var sol = stream.sol();
	    var ch = stream.next();
	
	    if (ch === '\\') {
	      stream.next();
	      return null;
	    }
	    if (ch === '\'' || ch === '"' || ch === '`') {
	      state.tokens.unshift(tokenString(ch, ch === "`" ? "quote" : "string"));
	      return tokenize(stream, state);
	    }
	    if (ch === '#') {
	      if (sol && stream.eat('!')) {
	        stream.skipToEnd();
	        return 'meta'; // 'comment'?
	      }
	      stream.skipToEnd();
	      return 'comment';
	    }
	    if (ch === '$') {
	      state.tokens.unshift(tokenDollar);
	      return tokenize(stream, state);
	    }
	    if (ch === '+' || ch === '=') {
	      return 'operator';
	    }
	    if (ch === '-') {
	      stream.eat('-');
	      stream.eatWhile(/\w/);
	      return 'attribute';
	    }
	    if (/\d/.test(ch)) {
	      stream.eatWhile(/\d/);
	      if(stream.eol() || !/\w/.test(stream.peek())) {
	        return 'number';
	      }
	    }
	    stream.eatWhile(/[\w-]/);
	    var cur = stream.current();
	    if (stream.peek() === '=' && /\w+/.test(cur)) return 'def';
	    return words.hasOwnProperty(cur) ? words[cur] : null;
	  }
	
	  function tokenString(quote, style) {
	    var close = quote == "(" ? ")" : quote == "{" ? "}" : quote
	    return function(stream, state) {
	      var next, escaped = false;
	      while ((next = stream.next()) != null) {
	        if (next === close && !escaped) {
	          state.tokens.shift();
	          break;
	        } else if (next === '$' && !escaped && quote !== "'" && stream.peek() != close) {
	          escaped = true;
	          stream.backUp(1);
	          state.tokens.unshift(tokenDollar);
	          break;
	        } else if (!escaped && quote !== close && next === quote) {
	          state.tokens.unshift(tokenString(quote, style))
	          return tokenize(stream, state)
	        } else if (!escaped && /['"]/.test(next) && !/['"]/.test(quote)) {
	          state.tokens.unshift(tokenStringStart(next, "string"));
	          stream.backUp(1);
	          break;
	        }
	        escaped = !escaped && next === '\\';
	      }
	      return style;
	    };
	  };
	
	  function tokenStringStart(quote, style) {
	    return function(stream, state) {
	      state.tokens[0] = tokenString(quote, style)
	      stream.next()
	      return tokenize(stream, state)
	    }
	  }
	
	  var tokenDollar = function(stream, state) {
	    if (state.tokens.length > 1) stream.eat('$');
	    var ch = stream.next()
	    if (/['"({]/.test(ch)) {
	      state.tokens[0] = tokenString(ch, ch == "(" ? "quote" : ch == "{" ? "def" : "string");
	      return tokenize(stream, state);
	    }
	    if (!/\d/.test(ch)) stream.eatWhile(/\w/);
	    state.tokens.shift();
	    return 'def';
	  };
	
	  function tokenize(stream, state) {
	    return (state.tokens[0] || tokenBase) (stream, state);
	  };
	
	  return {
	    startState: function() {return {tokens:[]};},
	    token: function(stream, state) {
	      return tokenize(stream, state);
	    },
	    closeBrackets: "()[]{}''\"\"``",
	    lineComment: '#',
	    fold: "brace"
	  };
	});
	
	CodeMirror.defineMIME('text/x-sh', 'shell');
	// Apache uses a slightly different Media Type for Shell scripts
	// http://svn.apache.org/repos/asf/httpd/httpd/trunk/docs/conf/mime.types
	CodeMirror.defineMIME('application/x-sh', 'shell');
	
	});


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(1));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("sql", function(config, parserConfig) {
	  var client         = parserConfig.client || {},
	      atoms          = parserConfig.atoms || {"false": true, "true": true, "null": true},
	      builtin        = parserConfig.builtin || set(defaultBuiltin),
	      keywords       = parserConfig.keywords || set(sqlKeywords),
	      operatorChars  = parserConfig.operatorChars || /^[*+\-%<>!=&|~^\/]/,
	      support        = parserConfig.support || {},
	      hooks          = parserConfig.hooks || {},
	      dateSQL        = parserConfig.dateSQL || {"date" : true, "time" : true, "timestamp" : true},
	      backslashStringEscapes = parserConfig.backslashStringEscapes !== false,
	      brackets       = parserConfig.brackets || /^[\{}\(\)\[\]]/,
	      punctuation    = parserConfig.punctuation || /^[;.,:]/
	
	  function tokenBase(stream, state) {
	    var ch = stream.next();
	
	    // call hooks from the mime type
	    if (hooks[ch]) {
	      var result = hooks[ch](stream, state);
	      if (result !== false) return result;
	    }
	
	    if (support.hexNumber &&
	      ((ch == "0" && stream.match(/^[xX][0-9a-fA-F]+/))
	      || (ch == "x" || ch == "X") && stream.match(/^'[0-9a-fA-F]+'/))) {
	      // hex
	      // ref: http://dev.mysql.com/doc/refman/5.5/en/hexadecimal-literals.html
	      return "number";
	    } else if (support.binaryNumber &&
	      (((ch == "b" || ch == "B") && stream.match(/^'[01]+'/))
	      || (ch == "0" && stream.match(/^b[01]+/)))) {
	      // bitstring
	      // ref: http://dev.mysql.com/doc/refman/5.5/en/bit-field-literals.html
	      return "number";
	    } else if (ch.charCodeAt(0) > 47 && ch.charCodeAt(0) < 58) {
	      // numbers
	      // ref: http://dev.mysql.com/doc/refman/5.5/en/number-literals.html
	      stream.match(/^[0-9]*(\.[0-9]+)?([eE][-+]?[0-9]+)?/);
	      support.decimallessFloat && stream.match(/^\.(?!\.)/);
	      return "number";
	    } else if (ch == "?" && (stream.eatSpace() || stream.eol() || stream.eat(";"))) {
	      // placeholders
	      return "variable-3";
	    } else if (ch == "'" || (ch == '"' && support.doubleQuote)) {
	      // strings
	      // ref: http://dev.mysql.com/doc/refman/5.5/en/string-literals.html
	      state.tokenize = tokenLiteral(ch);
	      return state.tokenize(stream, state);
	    } else if ((((support.nCharCast && (ch == "n" || ch == "N"))
	        || (support.charsetCast && ch == "_" && stream.match(/[a-z][a-z0-9]*/i)))
	        && (stream.peek() == "'" || stream.peek() == '"'))) {
	      // charset casting: _utf8'str', N'str', n'str'
	      // ref: http://dev.mysql.com/doc/refman/5.5/en/string-literals.html
	      return "keyword";
	    } else if (support.escapeConstant && (ch == "e" || ch == "E")
	        && (stream.peek() == "'" || (stream.peek() == '"' && support.doubleQuote))) {
	      // escape constant: E'str', e'str'
	      // ref: https://www.postgresql.org/docs/current/sql-syntax-lexical.html#SQL-SYNTAX-STRINGS-ESCAPE
	      state.tokenize = function(stream, state) {
	        return (state.tokenize = tokenLiteral(stream.next(), true))(stream, state);
	      }
	      return "keyword";
	    } else if (support.commentSlashSlash && ch == "/" && stream.eat("/")) {
	      // 1-line comment
	      stream.skipToEnd();
	      return "comment";
	    } else if ((support.commentHash && ch == "#")
	        || (ch == "-" && stream.eat("-") && (!support.commentSpaceRequired || stream.eat(" ")))) {
	      // 1-line comments
	      // ref: https://kb.askmonty.org/en/comment-syntax/
	      stream.skipToEnd();
	      return "comment";
	    } else if (ch == "/" && stream.eat("*")) {
	      // multi-line comments
	      // ref: https://kb.askmonty.org/en/comment-syntax/
	      state.tokenize = tokenComment(1);
	      return state.tokenize(stream, state);
	    } else if (ch == ".") {
	      // .1 for 0.1
	      if (support.zerolessFloat && stream.match(/^(?:\d+(?:e[+-]?\d+)?)/i))
	        return "number";
	      if (stream.match(/^\.+/))
	        return null
	      // .table_name (ODBC)
	      // // ref: http://dev.mysql.com/doc/refman/5.6/en/identifier-qualifiers.html
	      if (support.ODBCdotTable && stream.match(/^[\w\d_]+/))
	        return "variable-2";
	    } else if (operatorChars.test(ch)) {
	      // operators
	      stream.eatWhile(operatorChars);
	      return "operator";
	    } else if (brackets.test(ch)) {
	      // brackets
	      return "bracket";
	    } else if (punctuation.test(ch)) {
	      // punctuation
	      stream.eatWhile(punctuation);
	      return "punctuation";
	    } else if (ch == '{' &&
	        (stream.match(/^( )*(d|D|t|T|ts|TS)( )*'[^']*'( )*}/) || stream.match(/^( )*(d|D|t|T|ts|TS)( )*"[^"]*"( )*}/))) {
	      // dates (weird ODBC syntax)
	      // ref: http://dev.mysql.com/doc/refman/5.5/en/date-and-time-literals.html
	      return "number";
	    } else {
	      stream.eatWhile(/^[_\w\d]/);
	      var word = stream.current().toLowerCase();
	      // dates (standard SQL syntax)
	      // ref: http://dev.mysql.com/doc/refman/5.5/en/date-and-time-literals.html
	      if (dateSQL.hasOwnProperty(word) && (stream.match(/^( )+'[^']*'/) || stream.match(/^( )+"[^"]*"/)))
	        return "number";
	      if (atoms.hasOwnProperty(word)) return "atom";
	      if (builtin.hasOwnProperty(word)) return "builtin";
	      if (keywords.hasOwnProperty(word)) return "keyword";
	      if (client.hasOwnProperty(word)) return "string-2";
	      return null;
	    }
	  }
	
	  // 'string', with char specified in quote escaped by '\'
	  function tokenLiteral(quote, backslashEscapes) {
	    return function(stream, state) {
	      var escaped = false, ch;
	      while ((ch = stream.next()) != null) {
	        if (ch == quote && !escaped) {
	          state.tokenize = tokenBase;
	          break;
	        }
	        escaped = (backslashStringEscapes || backslashEscapes) && !escaped && ch == "\\";
	      }
	      return "string";
	    };
	  }
	  function tokenComment(depth) {
	    return function(stream, state) {
	      var m = stream.match(/^.*?(\/\*|\*\/)/)
	      if (!m) stream.skipToEnd()
	      else if (m[1] == "/*") state.tokenize = tokenComment(depth + 1)
	      else if (depth > 1) state.tokenize = tokenComment(depth - 1)
	      else state.tokenize = tokenBase
	      return "comment"
	    }
	  }
	
	  function pushContext(stream, state, type) {
	    state.context = {
	      prev: state.context,
	      indent: stream.indentation(),
	      col: stream.column(),
	      type: type
	    };
	  }
	
	  function popContext(state) {
	    state.indent = state.context.indent;
	    state.context = state.context.prev;
	  }
	
	  return {
	    startState: function() {
	      return {tokenize: tokenBase, context: null};
	    },
	
	    token: function(stream, state) {
	      if (stream.sol()) {
	        if (state.context && state.context.align == null)
	          state.context.align = false;
	      }
	      if (state.tokenize == tokenBase && stream.eatSpace()) return null;
	
	      var style = state.tokenize(stream, state);
	      if (style == "comment") return style;
	
	      if (state.context && state.context.align == null)
	        state.context.align = true;
	
	      var tok = stream.current();
	      if (tok == "(")
	        pushContext(stream, state, ")");
	      else if (tok == "[")
	        pushContext(stream, state, "]");
	      else if (state.context && state.context.type == tok)
	        popContext(state);
	      return style;
	    },
	
	    indent: function(state, textAfter) {
	      var cx = state.context;
	      if (!cx) return CodeMirror.Pass;
	      var closing = textAfter.charAt(0) == cx.type;
	      if (cx.align) return cx.col + (closing ? 0 : 1);
	      else return cx.indent + (closing ? 0 : config.indentUnit);
	    },
	
	    blockCommentStart: "/*",
	    blockCommentEnd: "*/",
	    lineComment: support.commentSlashSlash ? "//" : support.commentHash ? "#" : "--",
	    closeBrackets: "()[]{}''\"\"``"
	  };
	});
	
	  // `identifier`
	  function hookIdentifier(stream) {
	    // MySQL/MariaDB identifiers
	    // ref: http://dev.mysql.com/doc/refman/5.6/en/identifier-qualifiers.html
	    var ch;
	    while ((ch = stream.next()) != null) {
	      if (ch == "`" && !stream.eat("`")) return "variable-2";
	    }
	    stream.backUp(stream.current().length - 1);
	    return stream.eatWhile(/\w/) ? "variable-2" : null;
	  }
	
	  // "identifier"
	  function hookIdentifierDoublequote(stream) {
	    // Standard SQL /SQLite identifiers
	    // ref: http://web.archive.org/web/20160813185132/http://savage.net.au/SQL/sql-99.bnf.html#delimited%20identifier
	    // ref: http://sqlite.org/lang_keywords.html
	    var ch;
	    while ((ch = stream.next()) != null) {
	      if (ch == "\"" && !stream.eat("\"")) return "variable-2";
	    }
	    stream.backUp(stream.current().length - 1);
	    return stream.eatWhile(/\w/) ? "variable-2" : null;
	  }
	
	  // variable token
	  function hookVar(stream) {
	    // variables
	    // @@prefix.varName @varName
	    // varName can be quoted with ` or ' or "
	    // ref: http://dev.mysql.com/doc/refman/5.5/en/user-variables.html
	    if (stream.eat("@")) {
	      stream.match(/^session\./);
	      stream.match(/^local\./);
	      stream.match(/^global\./);
	    }
	
	    if (stream.eat("'")) {
	      stream.match(/^.*'/);
	      return "variable-2";
	    } else if (stream.eat('"')) {
	      stream.match(/^.*"/);
	      return "variable-2";
	    } else if (stream.eat("`")) {
	      stream.match(/^.*`/);
	      return "variable-2";
	    } else if (stream.match(/^[0-9a-zA-Z$\.\_]+/)) {
	      return "variable-2";
	    }
	    return null;
	  };
	
	  // short client keyword token
	  function hookClient(stream) {
	    // \N means NULL
	    // ref: http://dev.mysql.com/doc/refman/5.5/en/null-values.html
	    if (stream.eat("N")) {
	        return "atom";
	    }
	    // \g, etc
	    // ref: http://dev.mysql.com/doc/refman/5.5/en/mysql-commands.html
	    return stream.match(/^[a-zA-Z.#!?]/) ? "variable-2" : null;
	  }
	
	  // these keywords are used by all SQL dialects (however, a mode can still overwrite it)
	  var sqlKeywords = "alter and as asc between by count create delete desc distinct drop from group having in insert into is join like not on or order select set table union update values where limit ";
	
	  // turn a space-separated list into an array
	  function set(str) {
	    var obj = {}, words = str.split(" ");
	    for (var i = 0; i < words.length; ++i) obj[words[i]] = true;
	    return obj;
	  }
	
	  var defaultBuiltin = "bool boolean bit blob enum long longblob longtext medium mediumblob mediumint mediumtext time timestamp tinyblob tinyint tinytext text bigint int int1 int2 int3 int4 int8 integer float float4 float8 double char varbinary varchar varcharacter precision real date datetime year unsigned signed decimal numeric"
	
	  // A generic SQL Mode. It's not a standard, it just try to support what is generally supported
	  CodeMirror.defineMIME("text/x-sql", {
	    name: "sql",
	    keywords: set(sqlKeywords + "begin"),
	    builtin: set(defaultBuiltin),
	    atoms: set("false true null unknown"),
	    dateSQL: set("date time timestamp"),
	    support: set("ODBCdotTable doubleQuote binaryNumber hexNumber")
	  });
	
	  CodeMirror.defineMIME("text/x-mssql", {
	    name: "sql",
	    client: set("$partition binary_checksum checksum connectionproperty context_info current_request_id error_line error_message error_number error_procedure error_severity error_state formatmessage get_filestream_transaction_context getansinull host_id host_name isnull isnumeric min_active_rowversion newid newsequentialid rowcount_big xact_state object_id"),
	    keywords: set(sqlKeywords + "begin trigger proc view index for add constraint key primary foreign collate clustered nonclustered declare exec go if use index holdlock nolock nowait paglock readcommitted readcommittedlock readpast readuncommitted repeatableread rowlock serializable snapshot tablock tablockx updlock with"),
	    builtin: set("bigint numeric bit smallint decimal smallmoney int tinyint money float real char varchar text nchar nvarchar ntext binary varbinary image cursor timestamp hierarchyid uniqueidentifier sql_variant xml table "),
	    atoms: set("is not null like and or in left right between inner outer join all any some cross unpivot pivot exists"),
	    operatorChars: /^[*+\-%<>!=^\&|\/]/,
	    brackets: /^[\{}\(\)]/,
	    punctuation: /^[;.,:/]/,
	    backslashStringEscapes: false,
	    dateSQL: set("date datetimeoffset datetime2 smalldatetime datetime time"),
	    hooks: {
	      "@":   hookVar
	    }
	  });
	
	  CodeMirror.defineMIME("text/x-mysql", {
	    name: "sql",
	    client: set("charset clear connect edit ego exit go help nopager notee nowarning pager print prompt quit rehash source status system tee"),
	    keywords: set(sqlKeywords + "accessible action add after algorithm all analyze asensitive at authors auto_increment autocommit avg avg_row_length before binary binlog both btree cache call cascade cascaded case catalog_name chain change changed character check checkpoint checksum class_origin client_statistics close coalesce code collate collation collations column columns comment commit committed completion concurrent condition connection consistent constraint contains continue contributors convert cross current current_date current_time current_timestamp current_user cursor data database databases day_hour day_microsecond day_minute day_second deallocate dec declare default delay_key_write delayed delimiter des_key_file describe deterministic dev_pop dev_samp deviance diagnostics directory disable discard distinctrow div dual dumpfile each elseif enable enclosed end ends engine engines enum errors escape escaped even event events every execute exists exit explain extended fast fetch field fields first flush for force foreign found_rows full fulltext function general get global grant grants group group_concat handler hash help high_priority hosts hour_microsecond hour_minute hour_second if ignore ignore_server_ids import index index_statistics infile inner innodb inout insensitive insert_method install interval invoker isolation iterate key keys kill language last leading leave left level limit linear lines list load local localtime localtimestamp lock logs low_priority master master_heartbeat_period master_ssl_verify_server_cert masters match max max_rows maxvalue message_text middleint migrate min min_rows minute_microsecond minute_second mod mode modifies modify mutex mysql_errno natural next no no_write_to_binlog offline offset one online open optimize option optionally out outer outfile pack_keys parser partition partitions password phase plugin plugins prepare preserve prev primary privileges procedure processlist profile profiles purge query quick range read read_write reads real rebuild recover references regexp relaylog release remove rename reorganize repair repeatable replace require resignal restrict resume return returns revoke right rlike rollback rollup row row_format rtree savepoint schedule schema schema_name schemas second_microsecond security sensitive separator serializable server session share show signal slave slow smallint snapshot soname spatial specific sql sql_big_result sql_buffer_result sql_cache sql_calc_found_rows sql_no_cache sql_small_result sqlexception sqlstate sqlwarning ssl start starting starts status std stddev stddev_pop stddev_samp storage straight_join subclass_origin sum suspend table_name table_statistics tables tablespace temporary terminated to trailing transaction trigger triggers truncate uncommitted undo uninstall unique unlock upgrade usage use use_frm user user_resources user_statistics using utc_date utc_time utc_timestamp value variables varying view views warnings when while with work write xa xor year_month zerofill begin do then else loop repeat"),
	    builtin: set("bool boolean bit blob decimal double float long longblob longtext medium mediumblob mediumint mediumtext time timestamp tinyblob tinyint tinytext text bigint int int1 int2 int3 int4 int8 integer float float4 float8 double char varbinary varchar varcharacter precision date datetime year unsigned signed numeric"),
	    atoms: set("false true null unknown"),
	    operatorChars: /^[*+\-%<>!=&|^]/,
	    dateSQL: set("date time timestamp"),
	    support: set("ODBCdotTable decimallessFloat zerolessFloat binaryNumber hexNumber doubleQuote nCharCast charsetCast commentHash commentSpaceRequired"),
	    hooks: {
	      "@":   hookVar,
	      "`":   hookIdentifier,
	      "\\":  hookClient
	    }
	  });
	
	  CodeMirror.defineMIME("text/x-mariadb", {
	    name: "sql",
	    client: set("charset clear connect edit ego exit go help nopager notee nowarning pager print prompt quit rehash source status system tee"),
	    keywords: set(sqlKeywords + "accessible action add after algorithm all always analyze asensitive at authors auto_increment autocommit avg avg_row_length before binary binlog both btree cache call cascade cascaded case catalog_name chain change changed character check checkpoint checksum class_origin client_statistics close coalesce code collate collation collations column columns comment commit committed completion concurrent condition connection consistent constraint contains continue contributors convert cross current current_date current_time current_timestamp current_user cursor data database databases day_hour day_microsecond day_minute day_second deallocate dec declare default delay_key_write delayed delimiter des_key_file describe deterministic dev_pop dev_samp deviance diagnostics directory disable discard distinctrow div dual dumpfile each elseif enable enclosed end ends engine engines enum errors escape escaped even event events every execute exists exit explain extended fast fetch field fields first flush for force foreign found_rows full fulltext function general generated get global grant grants group groupby_concat handler hard hash help high_priority hosts hour_microsecond hour_minute hour_second if ignore ignore_server_ids import index index_statistics infile inner innodb inout insensitive insert_method install interval invoker isolation iterate key keys kill language last leading leave left level limit linear lines list load local localtime localtimestamp lock logs low_priority master master_heartbeat_period master_ssl_verify_server_cert masters match max max_rows maxvalue message_text middleint migrate min min_rows minute_microsecond minute_second mod mode modifies modify mutex mysql_errno natural next no no_write_to_binlog offline offset one online open optimize option optionally out outer outfile pack_keys parser partition partitions password persistent phase plugin plugins prepare preserve prev primary privileges procedure processlist profile profiles purge query quick range read read_write reads real rebuild recover references regexp relaylog release remove rename reorganize repair repeatable replace require resignal restrict resume return returns revoke right rlike rollback rollup row row_format rtree savepoint schedule schema schema_name schemas second_microsecond security sensitive separator serializable server session share show shutdown signal slave slow smallint snapshot soft soname spatial specific sql sql_big_result sql_buffer_result sql_cache sql_calc_found_rows sql_no_cache sql_small_result sqlexception sqlstate sqlwarning ssl start starting starts status std stddev stddev_pop stddev_samp storage straight_join subclass_origin sum suspend table_name table_statistics tables tablespace temporary terminated to trailing transaction trigger triggers truncate uncommitted undo uninstall unique unlock upgrade usage use use_frm user user_resources user_statistics using utc_date utc_time utc_timestamp value variables varying view views virtual warnings when while with work write xa xor year_month zerofill begin do then else loop repeat"),
	    builtin: set("bool boolean bit blob decimal double float long longblob longtext medium mediumblob mediumint mediumtext time timestamp tinyblob tinyint tinytext text bigint int int1 int2 int3 int4 int8 integer float float4 float8 double char varbinary varchar varcharacter precision date datetime year unsigned signed numeric"),
	    atoms: set("false true null unknown"),
	    operatorChars: /^[*+\-%<>!=&|^]/,
	    dateSQL: set("date time timestamp"),
	    support: set("ODBCdotTable decimallessFloat zerolessFloat binaryNumber hexNumber doubleQuote nCharCast charsetCast commentHash commentSpaceRequired"),
	    hooks: {
	      "@":   hookVar,
	      "`":   hookIdentifier,
	      "\\":  hookClient
	    }
	  });
	
	  // provided by the phpLiteAdmin project - phpliteadmin.org
	  CodeMirror.defineMIME("text/x-sqlite", {
	    name: "sql",
	    // commands of the official SQLite client, ref: https://www.sqlite.org/cli.html#dotcmd
	    client: set("auth backup bail binary changes check clone databases dbinfo dump echo eqp exit explain fullschema headers help import imposter indexes iotrace limit lint load log mode nullvalue once open output print prompt quit read restore save scanstats schema separator session shell show stats system tables testcase timeout timer trace vfsinfo vfslist vfsname width"),
	    // ref: http://sqlite.org/lang_keywords.html
	    keywords: set(sqlKeywords + "abort action add after all analyze attach autoincrement before begin cascade case cast check collate column commit conflict constraint cross current_date current_time current_timestamp database default deferrable deferred detach each else end escape except exclusive exists explain fail for foreign full glob if ignore immediate index indexed initially inner instead intersect isnull key left limit match natural no notnull null of offset outer plan pragma primary query raise recursive references regexp reindex release rename replace restrict right rollback row savepoint temp temporary then to transaction trigger unique using vacuum view virtual when with without"),
	    // SQLite is weakly typed, ref: http://sqlite.org/datatype3.html. This is just a list of some common types.
	    builtin: set("bool boolean bit blob decimal double float long longblob longtext medium mediumblob mediumint mediumtext time timestamp tinyblob tinyint tinytext text clob bigint int int2 int8 integer float double char varchar date datetime year unsigned signed numeric real"),
	    // ref: http://sqlite.org/syntax/literal-value.html
	    atoms: set("null current_date current_time current_timestamp"),
	    // ref: http://sqlite.org/lang_expr.html#binaryops
	    operatorChars: /^[*+\-%<>!=&|/~]/,
	    // SQLite is weakly typed, ref: http://sqlite.org/datatype3.html. This is just a list of some common types.
	    dateSQL: set("date time timestamp datetime"),
	    support: set("decimallessFloat zerolessFloat"),
	    identifierQuote: "\"",  //ref: http://sqlite.org/lang_keywords.html
	    hooks: {
	      // bind-parameters ref:http://sqlite.org/lang_expr.html#varparam
	      "@":   hookVar,
	      ":":   hookVar,
	      "?":   hookVar,
	      "$":   hookVar,
	      // The preferred way to escape Identifiers is using double quotes, ref: http://sqlite.org/lang_keywords.html
	      "\"":   hookIdentifierDoublequote,
	      // there is also support for backtics, ref: http://sqlite.org/lang_keywords.html
	      "`":   hookIdentifier
	    }
	  });
	
	  // the query language used by Apache Cassandra is called CQL, but this mime type
	  // is called Cassandra to avoid confusion with Contextual Query Language
	  CodeMirror.defineMIME("text/x-cassandra", {
	    name: "sql",
	    client: { },
	    keywords: set("add all allow alter and any apply as asc authorize batch begin by clustering columnfamily compact consistency count create custom delete desc distinct drop each_quorum exists filtering from grant if in index insert into key keyspace keyspaces level limit local_one local_quorum modify nan norecursive nosuperuser not of on one order password permission permissions primary quorum rename revoke schema select set storage superuser table three to token truncate ttl two type unlogged update use user users using values where with writetime"),
	    builtin: set("ascii bigint blob boolean counter decimal double float frozen inet int list map static text timestamp timeuuid tuple uuid varchar varint"),
	    atoms: set("false true infinity NaN"),
	    operatorChars: /^[<>=]/,
	    dateSQL: { },
	    support: set("commentSlashSlash decimallessFloat"),
	    hooks: { }
	  });
	
	  // this is based on Peter Raganitsch's 'plsql' mode
	  CodeMirror.defineMIME("text/x-plsql", {
	    name:       "sql",
	    client:     set("appinfo arraysize autocommit autoprint autorecovery autotrace blockterminator break btitle cmdsep colsep compatibility compute concat copycommit copytypecheck define describe echo editfile embedded escape exec execute feedback flagger flush heading headsep instance linesize lno loboffset logsource long longchunksize markup native newpage numformat numwidth pagesize pause pno recsep recsepchar release repfooter repheader serveroutput shiftinout show showmode size spool sqlblanklines sqlcase sqlcode sqlcontinue sqlnumber sqlpluscompatibility sqlprefix sqlprompt sqlterminator suffix tab term termout time timing trimout trimspool ttitle underline verify version wrap"),
	    keywords:   set("abort accept access add all alter and any array arraylen as asc assert assign at attributes audit authorization avg base_table begin between binary_integer body boolean by case cast char char_base check close cluster clusters colauth column comment commit compress connect connected constant constraint crash create current currval cursor data_base database date dba deallocate debugoff debugon decimal declare default definition delay delete desc digits dispose distinct do drop else elseif elsif enable end entry escape exception exception_init exchange exclusive exists exit external fast fetch file for force form from function generic goto grant group having identified if immediate in increment index indexes indicator initial initrans insert interface intersect into is key level library like limited local lock log logging long loop master maxextents maxtrans member minextents minus mislabel mode modify multiset new next no noaudit nocompress nologging noparallel not nowait number_base object of off offline on online only open option or order out package parallel partition pctfree pctincrease pctused pls_integer positive positiven pragma primary prior private privileges procedure public raise range raw read rebuild record ref references refresh release rename replace resource restrict return returning returns reverse revoke rollback row rowid rowlabel rownum rows run savepoint schema segment select separate session set share snapshot some space split sql start statement storage subtype successful synonym tabauth table tables tablespace task terminate then to trigger truncate type union unique unlimited unrecoverable unusable update use using validate value values variable view views when whenever where while with work"),
	    builtin:    set("abs acos add_months ascii asin atan atan2 average bfile bfilename bigserial bit blob ceil character chartorowid chr clob concat convert cos cosh count dec decode deref dual dump dup_val_on_index empty error exp false float floor found glb greatest hextoraw initcap instr instrb int integer isopen last_day least length lengthb ln lower lpad ltrim lub make_ref max min mlslabel mod months_between natural naturaln nchar nclob new_time next_day nextval nls_charset_decl_len nls_charset_id nls_charset_name nls_initcap nls_lower nls_sort nls_upper nlssort no_data_found notfound null number numeric nvarchar2 nvl others power rawtohex real reftohex round rowcount rowidtochar rowtype rpad rtrim serial sign signtype sin sinh smallint soundex sqlcode sqlerrm sqrt stddev string substr substrb sum sysdate tan tanh to_char text to_date to_label to_multi_byte to_number to_single_byte translate true trunc uid unlogged upper user userenv varchar varchar2 variance varying vsize xml"),
	    operatorChars: /^[*\/+\-%<>!=~]/,
	    dateSQL:    set("date time timestamp"),
	    support:    set("doubleQuote nCharCast zerolessFloat binaryNumber hexNumber")
	  });
	
	  // Created to support specific hive keywords
	  CodeMirror.defineMIME("text/x-hive", {
	    name: "sql",
	    keywords: set("select alter $elem$ $key$ $value$ add after all analyze and archive as asc before between binary both bucket buckets by cascade case cast change cluster clustered clusterstatus collection column columns comment compute concatenate continue create cross cursor data database databases dbproperties deferred delete delimited desc describe directory disable distinct distribute drop else enable end escaped exclusive exists explain export extended external fetch fields fileformat first format formatted from full function functions grant group having hold_ddltime idxproperties if import in index indexes inpath inputdriver inputformat insert intersect into is items join keys lateral left like limit lines load local location lock locks mapjoin materialized minus msck no_drop nocompress not of offline on option or order out outer outputdriver outputformat overwrite partition partitioned partitions percent plus preserve procedure purge range rcfile read readonly reads rebuild recordreader recordwriter recover reduce regexp rename repair replace restrict revoke right rlike row schema schemas semi sequencefile serde serdeproperties set shared show show_database sort sorted ssl statistics stored streamtable table tables tablesample tblproperties temporary terminated textfile then tmp to touch transform trigger unarchive undo union uniquejoin unlock update use using utc utc_tmestamp view when where while with admin authorization char compact compactions conf cube current current_date current_timestamp day decimal defined dependency directories elem_type exchange file following for grouping hour ignore inner interval jar less logical macro minute month more none noscan over owner partialscan preceding pretty principals protection reload rewrite role roles rollup rows second server sets skewed transactions truncate unbounded unset uri user values window year"),
	    builtin: set("bool boolean long timestamp tinyint smallint bigint int float double date datetime unsigned string array struct map uniontype key_type utctimestamp value_type varchar"),
	    atoms: set("false true null unknown"),
	    operatorChars: /^[*+\-%<>!=]/,
	    dateSQL: set("date timestamp"),
	    support: set("ODBCdotTable doubleQuote binaryNumber hexNumber")
	  });
	
	  CodeMirror.defineMIME("text/x-pgsql", {
	    name: "sql",
	    client: set("source"),
	    // For PostgreSQL - https://www.postgresql.org/docs/11/sql-keywords-appendix.html
	    // For pl/pgsql lang - https://github.com/postgres/postgres/blob/REL_11_2/src/pl/plpgsql/src/pl_scanner.c
	    keywords: set(sqlKeywords + "a abort abs absent absolute access according action ada add admin after aggregate alias all allocate also alter always analyse analyze and any are array array_agg array_max_cardinality as asc asensitive assert assertion assignment asymmetric at atomic attach attribute attributes authorization avg backward base64 before begin begin_frame begin_partition bernoulli between bigint binary bit bit_length blob blocked bom boolean both breadth by c cache call called cardinality cascade cascaded case cast catalog catalog_name ceil ceiling chain char char_length character character_length character_set_catalog character_set_name character_set_schema characteristics characters check checkpoint class class_origin clob close cluster coalesce cobol collate collation collation_catalog collation_name collation_schema collect column column_name columns command_function command_function_code comment comments commit committed concurrently condition condition_number configuration conflict connect connection connection_name constant constraint constraint_catalog constraint_name constraint_schema constraints constructor contains content continue control conversion convert copy corr corresponding cost count covar_pop covar_samp create cross csv cube cume_dist current current_catalog current_date current_default_transform_group current_path current_role current_row current_schema current_time current_timestamp current_transform_group_for_type current_user cursor cursor_name cycle data database datalink datatype date datetime_interval_code datetime_interval_precision day db deallocate debug dec decimal declare default defaults deferrable deferred defined definer degree delete delimiter delimiters dense_rank depends depth deref derived desc describe descriptor detach detail deterministic diagnostics dictionary disable discard disconnect dispatch distinct dlnewcopy dlpreviouscopy dlurlcomplete dlurlcompleteonly dlurlcompletewrite dlurlpath dlurlpathonly dlurlpathwrite dlurlscheme dlurlserver dlvalue do document domain double drop dump dynamic dynamic_function dynamic_function_code each element else elseif elsif empty enable encoding encrypted end end_frame end_partition endexec enforced enum equals errcode error escape event every except exception exclude excluding exclusive exec execute exists exit exp explain expression extension external extract false family fetch file filter final first first_value flag float floor following for force foreach foreign fortran forward found frame_row free freeze from fs full function functions fusion g general generated get global go goto grant granted greatest group grouping groups handler having header hex hierarchy hint hold hour id identity if ignore ilike immediate immediately immutable implementation implicit import in include including increment indent index indexes indicator info inherit inherits initially inline inner inout input insensitive insert instance instantiable instead int integer integrity intersect intersection interval into invoker is isnull isolation join k key key_member key_type label lag language large last last_value lateral lead leading leakproof least left length level library like like_regex limit link listen ln load local localtime localtimestamp location locator lock locked log logged loop lower m map mapping match matched materialized max max_cardinality maxvalue member merge message message_length message_octet_length message_text method min minute minvalue mod mode modifies module month more move multiset mumps name names namespace national natural nchar nclob nesting new next nfc nfd nfkc nfkd nil no none normalize normalized not nothing notice notify notnull nowait nth_value ntile null nullable nullif nulls number numeric object occurrences_regex octet_length octets of off offset oids old on only open operator option options or order ordering ordinality others out outer output over overlaps overlay overriding owned owner p pad parallel parameter parameter_mode parameter_name parameter_ordinal_position parameter_specific_catalog parameter_specific_name parameter_specific_schema parser partial partition pascal passing passthrough password path percent percent_rank percentile_cont percentile_disc perform period permission pg_context pg_datatype_name pg_exception_context pg_exception_detail pg_exception_hint placing plans pli policy portion position position_regex power precedes preceding precision prepare prepared preserve primary print_strict_params prior privileges procedural procedure procedures program public publication query quote raise range rank read reads real reassign recheck recovery recursive ref references referencing refresh regr_avgx regr_avgy regr_count regr_intercept regr_r2 regr_slope regr_sxx regr_sxy regr_syy reindex relative release rename repeatable replace replica requiring reset respect restart restore restrict result result_oid return returned_cardinality returned_length returned_octet_length returned_sqlstate returning returns reverse revoke right role rollback rollup routine routine_catalog routine_name routine_schema routines row row_count row_number rows rowtype rule savepoint scale schema schema_name schemas scope scope_catalog scope_name scope_schema scroll search second section security select selective self sensitive sequence sequences serializable server server_name session session_user set setof sets share show similar simple size skip slice smallint snapshot some source space specific specific_name specifictype sql sqlcode sqlerror sqlexception sqlstate sqlwarning sqrt stable stacked standalone start state statement static statistics stddev_pop stddev_samp stdin stdout storage strict strip structure style subclass_origin submultiset subscription substring substring_regex succeeds sum symmetric sysid system system_time system_user t table table_name tables tablesample tablespace temp template temporary text then ties time timestamp timezone_hour timezone_minute to token top_level_count trailing transaction transaction_active transactions_committed transactions_rolled_back transform transforms translate translate_regex translation treat trigger trigger_catalog trigger_name trigger_schema trim trim_array true truncate trusted type types uescape unbounded uncommitted under unencrypted union unique unknown unlink unlisten unlogged unnamed unnest until untyped update upper uri usage use_column use_variable user user_defined_type_catalog user_defined_type_code user_defined_type_name user_defined_type_schema using vacuum valid validate validator value value_of values var_pop var_samp varbinary varchar variable_conflict variadic varying verbose version versioning view views volatile warning when whenever where while whitespace width_bucket window with within without work wrapper write xml xmlagg xmlattributes xmlbinary xmlcast xmlcomment xmlconcat xmldeclaration xmldocument xmlelement xmlexists xmlforest xmliterate xmlnamespaces xmlparse xmlpi xmlquery xmlroot xmlschema xmlserialize xmltable xmltext xmlvalidate year yes zone"),
	    // https://www.postgresql.org/docs/11/datatype.html
	    builtin: set("bigint int8 bigserial serial8 bit varying varbit boolean bool box bytea character char varchar cidr circle date double precision float8 inet integer int int4 interval json jsonb line lseg macaddr macaddr8 money numeric decimal path pg_lsn point polygon real float4 smallint int2 smallserial serial2 serial serial4 text time without zone with timetz timestamp timestamptz tsquery tsvector txid_snapshot uuid xml"),
	    atoms: set("false true null unknown"),
	    operatorChars: /^[*\/+\-%<>!=&|^\/#@?~]/,
	    backslashStringEscapes: false,
	    dateSQL: set("date time timestamp"),
	    support: set("ODBCdotTable decimallessFloat zerolessFloat binaryNumber hexNumber nCharCast charsetCast escapeConstant")
	  });
	
	  // Google's SQL-like query language, GQL
	  CodeMirror.defineMIME("text/x-gql", {
	    name: "sql",
	    keywords: set("ancestor and asc by contains desc descendant distinct from group has in is limit offset on order select superset where"),
	    atoms: set("false true"),
	    builtin: set("blob datetime first key __key__ string integer double boolean null"),
	    operatorChars: /^[*+\-%<>!=]/
	  });
	
	  // Greenplum
	  CodeMirror.defineMIME("text/x-gpsql", {
	    name: "sql",
	    client: set("source"),
	    //https://github.com/greenplum-db/gpdb/blob/master/src/include/parser/kwlist.h
	    keywords: set("abort absolute access action active add admin after aggregate all also alter always analyse analyze and any array as asc assertion assignment asymmetric at authorization backward before begin between bigint binary bit boolean both by cache called cascade cascaded case cast chain char character characteristics check checkpoint class close cluster coalesce codegen collate column comment commit committed concurrency concurrently configuration connection constraint constraints contains content continue conversion copy cost cpu_rate_limit create createdb createexttable createrole createuser cross csv cube current current_catalog current_date current_role current_schema current_time current_timestamp current_user cursor cycle data database day deallocate dec decimal declare decode default defaults deferrable deferred definer delete delimiter delimiters deny desc dictionary disable discard distinct distributed do document domain double drop dxl each else enable encoding encrypted end enum errors escape every except exchange exclude excluding exclusive execute exists explain extension external extract false family fetch fields filespace fill filter first float following for force foreign format forward freeze from full function global grant granted greatest group group_id grouping handler hash having header hold host hour identity if ignore ilike immediate immutable implicit in including inclusive increment index indexes inherit inherits initially inline inner inout input insensitive insert instead int integer intersect interval into invoker is isnull isolation join key language large last leading least left level like limit list listen load local localtime localtimestamp location lock log login mapping master match maxvalue median merge minute minvalue missing mode modifies modify month move name names national natural nchar new newline next no nocreatedb nocreateexttable nocreaterole nocreateuser noinherit nologin none noovercommit nosuperuser not nothing notify notnull nowait null nullif nulls numeric object of off offset oids old on only operator option options or order ordered others out outer over overcommit overlaps overlay owned owner parser partial partition partitions passing password percent percentile_cont percentile_disc placing plans position preceding precision prepare prepared preserve primary prior privileges procedural procedure protocol queue quote randomly range read readable reads real reassign recheck recursive ref references reindex reject relative release rename repeatable replace replica reset resource restart restrict returning returns revoke right role rollback rollup rootpartition row rows rule savepoint scatter schema scroll search second security segment select sequence serializable session session_user set setof sets share show similar simple smallint some split sql stable standalone start statement statistics stdin stdout storage strict strip subpartition subpartitions substring superuser symmetric sysid system table tablespace temp template temporary text then threshold ties time timestamp to trailing transaction treat trigger trim true truncate trusted type unbounded uncommitted unencrypted union unique unknown unlisten until update user using vacuum valid validation validator value values varchar variadic varying verbose version view volatile web when where whitespace window with within without work writable write xml xmlattributes xmlconcat xmlelement xmlexists xmlforest xmlparse xmlpi xmlroot xmlserialize year yes zone"),
	    builtin: set("bigint int8 bigserial serial8 bit varying varbit boolean bool box bytea character char varchar cidr circle date double precision float float8 inet integer int int4 interval json jsonb line lseg macaddr macaddr8 money numeric decimal path pg_lsn point polygon real float4 smallint int2 smallserial serial2 serial serial4 text time without zone with timetz timestamp timestamptz tsquery tsvector txid_snapshot uuid xml"),
	    atoms: set("false true null unknown"),
	    operatorChars: /^[*+\-%<>!=&|^\/#@?~]/,
	    dateSQL: set("date time timestamp"),
	    support: set("ODBCdotTable decimallessFloat zerolessFloat binaryNumber hexNumber nCharCast charsetCast")
	  });
	
	  // Spark SQL
	  CodeMirror.defineMIME("text/x-sparksql", {
	    name: "sql",
	    keywords: set("add after all alter analyze and anti archive array as asc at between bucket buckets by cache cascade case cast change clear cluster clustered codegen collection column columns comment commit compact compactions compute concatenate cost create cross cube current current_date current_timestamp database databases datata dbproperties defined delete delimited deny desc describe dfs directories distinct distribute drop else end escaped except exchange exists explain export extended external false fields fileformat first following for format formatted from full function functions global grant group grouping having if ignore import in index indexes inner inpath inputformat insert intersect interval into is items join keys last lateral lazy left like limit lines list load local location lock locks logical macro map minus msck natural no not null nulls of on optimize option options or order out outer outputformat over overwrite partition partitioned partitions percent preceding principals purge range recordreader recordwriter recover reduce refresh regexp rename repair replace reset restrict revoke right rlike role roles rollback rollup row rows schema schemas select semi separated serde serdeproperties set sets show skewed sort sorted start statistics stored stratify struct table tables tablesample tblproperties temp temporary terminated then to touch transaction transactions transform true truncate unarchive unbounded uncache union unlock unset use using values view when where window with"),
	    builtin: set("tinyint smallint int bigint boolean float double string binary timestamp decimal array map struct uniontype delimited serde sequencefile textfile rcfile inputformat outputformat"),
	    atoms: set("false true null"),
	    operatorChars: /^[*\/+\-%<>!=~&|^]/,
	    dateSQL: set("date time timestamp"),
	    support: set("ODBCdotTable doubleQuote zerolessFloat")
	  });
	
	  // Esper
	  CodeMirror.defineMIME("text/x-esper", {
	    name: "sql",
	    client: set("source"),
	    // http://www.espertech.com/esper/release-5.5.0/esper-reference/html/appendix_keywords.html
	    keywords: set("alter and as asc between by count create delete desc distinct drop from group having in insert into is join like not on or order select set table union update values where limit after all and as at asc avedev avg between by case cast coalesce count create current_timestamp day days delete define desc distinct else end escape events every exists false first from full group having hour hours in inner insert instanceof into irstream is istream join last lastweekday left limit like max match_recognize matches median measures metadatasql min minute minutes msec millisecond milliseconds not null offset on or order outer output partition pattern prev prior regexp retain-union retain-intersection right rstream sec second seconds select set some snapshot sql stddev sum then true unidirectional until update variable weekday when where window"),
	    builtin: {},
	    atoms: set("false true null"),
	    operatorChars: /^[*+\-%<>!=&|^\/#@?~]/,
	    dateSQL: set("time"),
	    support: set("decimallessFloat zerolessFloat binaryNumber hexNumber")
	  });
	});
	
	/*
	  How Properties of Mime Types are used by SQL Mode
	  =================================================
	
	  keywords:
	    A list of keywords you want to be highlighted.
	  builtin:
	    A list of builtin types you want to be highlighted (if you want types to be of class "builtin" instead of "keyword").
	  operatorChars:
	    All characters that must be handled as operators.
	  client:
	    Commands parsed and executed by the client (not the server).
	  support:
	    A list of supported syntaxes which are not common, but are supported by more than 1 DBMS.
	    * ODBCdotTable: .tableName
	    * zerolessFloat: .1
	    * doubleQuote
	    * nCharCast: N'string'
	    * charsetCast: _utf8'string'
	    * commentHash: use # char for comments
	    * commentSlashSlash: use // for comments
	    * commentSpaceRequired: require a space after -- for comments
	  atoms:
	    Keywords that must be highlighted as atoms,. Some DBMS's support more atoms than others:
	    UNKNOWN, INFINITY, UNDERFLOW, NaN...
	  dateSQL:
	    Used for date/time SQL standard syntax, because not all DBMS's support same temporal types.
	*/


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/LICENSE
	
	/*
	 * Author: Constantin Jucovschi (c.jucovschi@jacobs-university.de)
	 * Licence: MIT
	 */
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(1));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	  "use strict";
	
	  CodeMirror.defineMode("stex", function(_config, parserConfig) {
	    "use strict";
	
	    function pushCommand(state, command) {
	      state.cmdState.push(command);
	    }
	
	    function peekCommand(state) {
	      if (state.cmdState.length > 0) {
	        return state.cmdState[state.cmdState.length - 1];
	      } else {
	        return null;
	      }
	    }
	
	    function popCommand(state) {
	      var plug = state.cmdState.pop();
	      if (plug) {
	        plug.closeBracket();
	      }
	    }
	
	    // returns the non-default plugin closest to the end of the list
	    function getMostPowerful(state) {
	      var context = state.cmdState;
	      for (var i = context.length - 1; i >= 0; i--) {
	        var plug = context[i];
	        if (plug.name == "DEFAULT") {
	          continue;
	        }
	        return plug;
	      }
	      return { styleIdentifier: function() { return null; } };
	    }
	
	    function addPluginPattern(pluginName, cmdStyle, styles) {
	      return function () {
	        this.name = pluginName;
	        this.bracketNo = 0;
	        this.style = cmdStyle;
	        this.styles = styles;
	        this.argument = null;   // \begin and \end have arguments that follow. These are stored in the plugin
	
	        this.styleIdentifier = function() {
	          return this.styles[this.bracketNo - 1] || null;
	        };
	        this.openBracket = function() {
	          this.bracketNo++;
	          return "bracket";
	        };
	        this.closeBracket = function() {};
	      };
	    }
	
	    var plugins = {};
	
	    plugins["importmodule"] = addPluginPattern("importmodule", "tag", ["string", "builtin"]);
	    plugins["documentclass"] = addPluginPattern("documentclass", "tag", ["", "atom"]);
	    plugins["usepackage"] = addPluginPattern("usepackage", "tag", ["atom"]);
	    plugins["begin"] = addPluginPattern("begin", "tag", ["atom"]);
	    plugins["end"] = addPluginPattern("end", "tag", ["atom"]);
	
	    plugins["label"    ] = addPluginPattern("label"    , "tag", ["atom"]);
	    plugins["ref"      ] = addPluginPattern("ref"      , "tag", ["atom"]);
	    plugins["eqref"    ] = addPluginPattern("eqref"    , "tag", ["atom"]);
	    plugins["cite"     ] = addPluginPattern("cite"     , "tag", ["atom"]);
	    plugins["bibitem"  ] = addPluginPattern("bibitem"  , "tag", ["atom"]);
	    plugins["Bibitem"  ] = addPluginPattern("Bibitem"  , "tag", ["atom"]);
	    plugins["RBibitem" ] = addPluginPattern("RBibitem" , "tag", ["atom"]);
	
	    plugins["DEFAULT"] = function () {
	      this.name = "DEFAULT";
	      this.style = "tag";
	
	      this.styleIdentifier = this.openBracket = this.closeBracket = function() {};
	    };
	
	    function setState(state, f) {
	      state.f = f;
	    }
	
	    // called when in a normal (no environment) context
	    function normal(source, state) {
	      var plug;
	      // Do we look like '\command' ?  If so, attempt to apply the plugin 'command'
	      if (source.match(/^\\[a-zA-Z@]+/)) {
	        var cmdName = source.current().slice(1);
	        plug = plugins.hasOwnProperty(cmdName) ? plugins[cmdName] : plugins["DEFAULT"];
	        plug = new plug();
	        pushCommand(state, plug);
	        setState(state, beginParams);
	        return plug.style;
	      }
	
	      // escape characters
	      if (source.match(/^\\[$&%#{}_]/)) {
	        return "tag";
	      }
	
	      // white space control characters
	      if (source.match(/^\\[,;!\/\\]/)) {
	        return "tag";
	      }
	
	      // find if we're starting various math modes
	      if (source.match("\\[")) {
	        setState(state, function(source, state){ return inMathMode(source, state, "\\]"); });
	        return "keyword";
	      }
	      if (source.match("\\(")) {
	        setState(state, function(source, state){ return inMathMode(source, state, "\\)"); });
	        return "keyword";
	      }
	      if (source.match("$$")) {
	        setState(state, function(source, state){ return inMathMode(source, state, "$$"); });
	        return "keyword";
	      }
	      if (source.match("$")) {
	        setState(state, function(source, state){ return inMathMode(source, state, "$"); });
	        return "keyword";
	      }
	
	      var ch = source.next();
	      if (ch == "%") {
	        source.skipToEnd();
	        return "comment";
	      } else if (ch == '}' || ch == ']') {
	        plug = peekCommand(state);
	        if (plug) {
	          plug.closeBracket(ch);
	          setState(state, beginParams);
	        } else {
	          return "error";
	        }
	        return "bracket";
	      } else if (ch == '{' || ch == '[') {
	        plug = plugins["DEFAULT"];
	        plug = new plug();
	        pushCommand(state, plug);
	        return "bracket";
	      } else if (/\d/.test(ch)) {
	        source.eatWhile(/[\w.%]/);
	        return "atom";
	      } else {
	        source.eatWhile(/[\w\-_]/);
	        plug = getMostPowerful(state);
	        if (plug.name == 'begin') {
	          plug.argument = source.current();
	        }
	        return plug.styleIdentifier();
	      }
	    }
	
	    function inMathMode(source, state, endModeSeq) {
	      if (source.eatSpace()) {
	        return null;
	      }
	      if (endModeSeq && source.match(endModeSeq)) {
	        setState(state, normal);
	        return "keyword";
	      }
	      if (source.match(/^\\[a-zA-Z@]+/)) {
	        return "tag";
	      }
	      if (source.match(/^[a-zA-Z]+/)) {
	        return "variable-2";
	      }
	      // escape characters
	      if (source.match(/^\\[$&%#{}_]/)) {
	        return "tag";
	      }
	      // white space control characters
	      if (source.match(/^\\[,;!\/]/)) {
	        return "tag";
	      }
	      // special math-mode characters
	      if (source.match(/^[\^_&]/)) {
	        return "tag";
	      }
	      // non-special characters
	      if (source.match(/^[+\-<>|=,\/@!*:;'"`~#?]/)) {
	        return null;
	      }
	      if (source.match(/^(\d+\.\d*|\d*\.\d+|\d+)/)) {
	        return "number";
	      }
	      var ch = source.next();
	      if (ch == "{" || ch == "}" || ch == "[" || ch == "]" || ch == "(" || ch == ")") {
	        return "bracket";
	      }
	
	      if (ch == "%") {
	        source.skipToEnd();
	        return "comment";
	      }
	      return "error";
	    }
	
	    function beginParams(source, state) {
	      var ch = source.peek(), lastPlug;
	      if (ch == '{' || ch == '[') {
	        lastPlug = peekCommand(state);
	        lastPlug.openBracket(ch);
	        source.eat(ch);
	        setState(state, normal);
	        return "bracket";
	      }
	      if (/[ \t\r]/.test(ch)) {
	        source.eat(ch);
	        return null;
	      }
	      setState(state, normal);
	      popCommand(state);
	
	      return normal(source, state);
	    }
	
	    return {
	      startState: function() {
	        var f = parserConfig.inMathMode ? function(source, state){ return inMathMode(source, state); } : normal;
	        return {
	          cmdState: [],
	          f: f
	        };
	      },
	      copyState: function(s) {
	        return {
	          cmdState: s.cmdState.slice(),
	          f: s.f
	        };
	      },
	      token: function(stream, state) {
	        return state.f(stream, state);
	      },
	      blankLine: function(state) {
	        state.f = normal;
	        state.cmdState.length = 0;
	      },
	      lineComment: "%"
	    };
	  });
	
	  CodeMirror.defineMIME("text/x-stex", "stex");
	  CodeMirror.defineMIME("text/x-latex", "stex");
	
	});


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/LICENSE
	
	// Swift mode created by Michael Kaminsky https://github.com/mkaminsky11
	
	(function(mod) {
	  if (true)
	    mod(__webpack_require__(1))
	  else if (typeof define == "function" && define.amd)
	    define(["../../lib/codemirror"], mod)
	  else
	    mod(CodeMirror)
	})(function(CodeMirror) {
	  "use strict"
	
	  function wordSet(words) {
	    var set = {}
	    for (var i = 0; i < words.length; i++) set[words[i]] = true
	    return set
	  }
	
	  var keywords = wordSet(["_","var","let","class","enum","extension","import","protocol","struct","func","typealias","associatedtype",
	                          "open","public","internal","fileprivate","private","deinit","init","new","override","self","subscript","super",
	                          "convenience","dynamic","final","indirect","lazy","required","static","unowned","unowned(safe)","unowned(unsafe)","weak","as","is",
	                          "break","case","continue","default","else","fallthrough","for","guard","if","in","repeat","switch","where","while",
	                          "defer","return","inout","mutating","nonmutating","catch","do","rethrows","throw","throws","try","didSet","get","set","willSet",
	                          "assignment","associativity","infix","left","none","operator","postfix","precedence","precedencegroup","prefix","right",
	                          "Any","AnyObject","Type","dynamicType","Self","Protocol","__COLUMN__","__FILE__","__FUNCTION__","__LINE__"])
	  var definingKeywords = wordSet(["var","let","class","enum","extension","import","protocol","struct","func","typealias","associatedtype","for"])
	  var atoms = wordSet(["true","false","nil","self","super","_"])
	  var types = wordSet(["Array","Bool","Character","Dictionary","Double","Float","Int","Int8","Int16","Int32","Int64","Never","Optional","Set","String",
	                       "UInt8","UInt16","UInt32","UInt64","Void"])
	  var operators = "+-/*%=|&<>~^?!"
	  var punc = ":;,.(){}[]"
	  var binary = /^\-?0b[01][01_]*/
	  var octal = /^\-?0o[0-7][0-7_]*/
	  var hexadecimal = /^\-?0x[\dA-Fa-f][\dA-Fa-f_]*(?:(?:\.[\dA-Fa-f][\dA-Fa-f_]*)?[Pp]\-?\d[\d_]*)?/
	  var decimal = /^\-?\d[\d_]*(?:\.\d[\d_]*)?(?:[Ee]\-?\d[\d_]*)?/
	  var identifier = /^\$\d+|(`?)[_A-Za-z][_A-Za-z$0-9]*\1/
	  var property = /^\.(?:\$\d+|(`?)[_A-Za-z][_A-Za-z$0-9]*\1)/
	  var instruction = /^\#[A-Za-z]+/
	  var attribute = /^@(?:\$\d+|(`?)[_A-Za-z][_A-Za-z$0-9]*\1)/
	  //var regexp = /^\/(?!\s)(?:\/\/)?(?:\\.|[^\/])+\//
	
	  function tokenBase(stream, state, prev) {
	    if (stream.sol()) state.indented = stream.indentation()
	    if (stream.eatSpace()) return null
	
	    var ch = stream.peek()
	    if (ch == "/") {
	      if (stream.match("//")) {
	        stream.skipToEnd()
	        return "comment"
	      }
	      if (stream.match("/*")) {
	        state.tokenize.push(tokenComment)
	        return tokenComment(stream, state)
	      }
	    }
	    if (stream.match(instruction)) return "builtin"
	    if (stream.match(attribute)) return "attribute"
	    if (stream.match(binary)) return "number"
	    if (stream.match(octal)) return "number"
	    if (stream.match(hexadecimal)) return "number"
	    if (stream.match(decimal)) return "number"
	    if (stream.match(property)) return "property"
	    if (operators.indexOf(ch) > -1) {
	      stream.next()
	      return "operator"
	    }
	    if (punc.indexOf(ch) > -1) {
	      stream.next()
	      stream.match("..")
	      return "punctuation"
	    }
	    var stringMatch
	    if (stringMatch = stream.match(/("""|"|')/)) {
	      var tokenize = tokenString.bind(null, stringMatch[0])
	      state.tokenize.push(tokenize)
	      return tokenize(stream, state)
	    }
	
	    if (stream.match(identifier)) {
	      var ident = stream.current()
	      if (types.hasOwnProperty(ident)) return "variable-2"
	      if (atoms.hasOwnProperty(ident)) return "atom"
	      if (keywords.hasOwnProperty(ident)) {
	        if (definingKeywords.hasOwnProperty(ident))
	          state.prev = "define"
	        return "keyword"
	      }
	      if (prev == "define") return "def"
	      return "variable"
	    }
	
	    stream.next()
	    return null
	  }
	
	  function tokenUntilClosingParen() {
	    var depth = 0
	    return function(stream, state, prev) {
	      var inner = tokenBase(stream, state, prev)
	      if (inner == "punctuation") {
	        if (stream.current() == "(") ++depth
	        else if (stream.current() == ")") {
	          if (depth == 0) {
	            stream.backUp(1)
	            state.tokenize.pop()
	            return state.tokenize[state.tokenize.length - 1](stream, state)
	          }
	          else --depth
	        }
	      }
	      return inner
	    }
	  }
	
	  function tokenString(openQuote, stream, state) {
	    var singleLine = openQuote.length == 1
	    var ch, escaped = false
	    while (ch = stream.peek()) {
	      if (escaped) {
	        stream.next()
	        if (ch == "(") {
	          state.tokenize.push(tokenUntilClosingParen())
	          return "string"
	        }
	        escaped = false
	      } else if (stream.match(openQuote)) {
	        state.tokenize.pop()
	        return "string"
	      } else {
	        stream.next()
	        escaped = ch == "\\"
	      }
	    }
	    if (singleLine) {
	      state.tokenize.pop()
	    }
	    return "string"
	  }
	
	  function tokenComment(stream, state) {
	    var ch
	    while (true) {
	      stream.match(/^[^/*]+/, true)
	      ch = stream.next()
	      if (!ch) break
	      if (ch === "/" && stream.eat("*")) {
	        state.tokenize.push(tokenComment)
	      } else if (ch === "*" && stream.eat("/")) {
	        state.tokenize.pop()
	      }
	    }
	    return "comment"
	  }
	
	  function Context(prev, align, indented) {
	    this.prev = prev
	    this.align = align
	    this.indented = indented
	  }
	
	  function pushContext(state, stream) {
	    var align = stream.match(/^\s*($|\/[\/\*])/, false) ? null : stream.column() + 1
	    state.context = new Context(state.context, align, state.indented)
	  }
	
	  function popContext(state) {
	    if (state.context) {
	      state.indented = state.context.indented
	      state.context = state.context.prev
	    }
	  }
	
	  CodeMirror.defineMode("swift", function(config) {
	    return {
	      startState: function() {
	        return {
	          prev: null,
	          context: null,
	          indented: 0,
	          tokenize: []
	        }
	      },
	
	      token: function(stream, state) {
	        var prev = state.prev
	        state.prev = null
	        var tokenize = state.tokenize[state.tokenize.length - 1] || tokenBase
	        var style = tokenize(stream, state, prev)
	        if (!style || style == "comment") state.prev = prev
	        else if (!state.prev) state.prev = style
	
	        if (style == "punctuation") {
	          var bracket = /[\(\[\{]|([\]\)\}])/.exec(stream.current())
	          if (bracket) (bracket[1] ? popContext : pushContext)(state, stream)
	        }
	
	        return style
	      },
	
	      indent: function(state, textAfter) {
	        var cx = state.context
	        if (!cx) return 0
	        var closing = /^[\]\}\)]/.test(textAfter)
	        if (cx.align != null) return cx.align - (closing ? 1 : 0)
	        return cx.indented + (closing ? 0 : config.indentUnit)
	      },
	
	      electricInput: /^\s*[\)\}\]]$/,
	
	      lineComment: "//",
	      blockCommentStart: "/*",
	      blockCommentEnd: "*/",
	      fold: "brace",
	      closeBrackets: "()[]{}''\"\"``"
	    }
	  })
	
	  CodeMirror.defineMIME("text/x-swift","swift")
	});


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/LICENSE
	
	(function (mod) {
	  "use strict";
	  if (true) {// CommonJS
	    mod(__webpack_require__(1),
	        __webpack_require__(285),
	        __webpack_require__(69),
	        __webpack_require__(68),
	        __webpack_require__(288),
	        __webpack_require__(67),
	        __webpack_require__(152),
	        __webpack_require__(153),
	        __webpack_require__(303),
	        __webpack_require__(293));
	  } else if (typeof define === "function" && define.amd) { // AMD
	    define(["../../lib/codemirror",
	            "../../addon/mode/overlay",
	            "../xml/xml",
	            "../javascript/javascript",
	            "../coffeescript/coffeescript",
	            "../css/css",
	            "../sass/sass",
	            "../stylus/stylus",
	            "../pug/pug",
	            "../handlebars/handlebars"], mod);
	  } else { // Plain browser env
	    mod(CodeMirror);
	  }
	})(function (CodeMirror) {
	  var tagLanguages = {
	    script: [
	      ["lang", /coffee(script)?/, "coffeescript"],
	      ["type", /^(?:text|application)\/(?:x-)?coffee(?:script)?$/, "coffeescript"],
	      ["lang", /^babel$/, "javascript"],
	      ["type", /^text\/babel$/, "javascript"],
	      ["type", /^text\/ecmascript-\d+$/, "javascript"]
	    ],
	    style: [
	      ["lang", /^stylus$/i, "stylus"],
	      ["lang", /^sass$/i, "sass"],
	      ["lang", /^less$/i, "text/x-less"],
	      ["lang", /^scss$/i, "text/x-scss"],
	      ["type", /^(text\/)?(x-)?styl(us)?$/i, "stylus"],
	      ["type", /^text\/sass/i, "sass"],
	      ["type", /^(text\/)?(x-)?scss$/i, "text/x-scss"],
	      ["type", /^(text\/)?(x-)?less$/i, "text/x-less"]
	    ],
	    template: [
	      ["lang", /^vue-template$/i, "vue"],
	      ["lang", /^pug$/i, "pug"],
	      ["lang", /^handlebars$/i, "handlebars"],
	      ["type", /^(text\/)?(x-)?pug$/i, "pug"],
	      ["type", /^text\/x-handlebars-template$/i, "handlebars"],
	      [null, null, "vue-template"]
	    ]
	  };
	
	  CodeMirror.defineMode("vue-template", function (config, parserConfig) {
	    var mustacheOverlay = {
	      token: function (stream) {
	        if (stream.match(/^\{\{.*?\}\}/)) return "meta mustache";
	        while (stream.next() && !stream.match("{{", false)) {}
	        return null;
	      }
	    };
	    return CodeMirror.overlayMode(CodeMirror.getMode(config, parserConfig.backdrop || "text/html"), mustacheOverlay);
	  });
	
	  CodeMirror.defineMode("vue", function (config) {
	    return CodeMirror.getMode(config, {name: "htmlmixed", tags: tagLanguages});
	  }, "htmlmixed", "xml", "javascript", "coffeescript", "css", "sass", "stylus", "pug", "handlebars");
	
	  CodeMirror.defineMIME("script/x-vue", "vue");
	  CodeMirror.defineMIME("text/x-vue", "vue");
	});


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	// CodeMirror, copyright (c) by Marijn Haverbeke and others
	// Distributed under an MIT license: https://codemirror.net/LICENSE
	
	(function(mod) {
	  if (true) // CommonJS
	    mod(__webpack_require__(1));
	  else if (typeof define == "function" && define.amd) // AMD
	    define(["../../lib/codemirror"], mod);
	  else // Plain browser env
	    mod(CodeMirror);
	})(function(CodeMirror) {
	"use strict";
	
	CodeMirror.defineMode("yaml", function() {
	
	  var cons = ['true', 'false', 'on', 'off', 'yes', 'no'];
	  var keywordRegex = new RegExp("\\b(("+cons.join(")|(")+"))$", 'i');
	
	  return {
	    token: function(stream, state) {
	      var ch = stream.peek();
	      var esc = state.escaped;
	      state.escaped = false;
	      /* comments */
	      if (ch == "#" && (stream.pos == 0 || /\s/.test(stream.string.charAt(stream.pos - 1)))) {
	        stream.skipToEnd();
	        return "comment";
	      }
	
	      if (stream.match(/^('([^']|\\.)*'?|"([^"]|\\.)*"?)/))
	        return "string";
	
	      if (state.literal && stream.indentation() > state.keyCol) {
	        stream.skipToEnd(); return "string";
	      } else if (state.literal) { state.literal = false; }
	      if (stream.sol()) {
	        state.keyCol = 0;
	        state.pair = false;
	        state.pairStart = false;
	        /* document start */
	        if(stream.match(/---/)) { return "def"; }
	        /* document end */
	        if (stream.match(/\.\.\./)) { return "def"; }
	        /* array list item */
	        if (stream.match(/\s*-\s+/)) { return 'meta'; }
	      }
	      /* inline pairs/lists */
	      if (stream.match(/^(\{|\}|\[|\])/)) {
	        if (ch == '{')
	          state.inlinePairs++;
	        else if (ch == '}')
	          state.inlinePairs--;
	        else if (ch == '[')
	          state.inlineList++;
	        else
	          state.inlineList--;
	        return 'meta';
	      }
	
	      /* list seperator */
	      if (state.inlineList > 0 && !esc && ch == ',') {
	        stream.next();
	        return 'meta';
	      }
	      /* pairs seperator */
	      if (state.inlinePairs > 0 && !esc && ch == ',') {
	        state.keyCol = 0;
	        state.pair = false;
	        state.pairStart = false;
	        stream.next();
	        return 'meta';
	      }
	
	      /* start of value of a pair */
	      if (state.pairStart) {
	        /* block literals */
	        if (stream.match(/^\s*(\||\>)\s*/)) { state.literal = true; return 'meta'; };
	        /* references */
	        if (stream.match(/^\s*(\&|\*)[a-z0-9\._-]+\b/i)) { return 'variable-2'; }
	        /* numbers */
	        if (state.inlinePairs == 0 && stream.match(/^\s*-?[0-9\.\,]+\s?$/)) { return 'number'; }
	        if (state.inlinePairs > 0 && stream.match(/^\s*-?[0-9\.\,]+\s?(?=(,|}))/)) { return 'number'; }
	        /* keywords */
	        if (stream.match(keywordRegex)) { return 'keyword'; }
	      }
	
	      /* pairs (associative arrays) -> key */
	      if (!state.pair && stream.match(/^\s*(?:[,\[\]{}&*!|>'"%@`][^\s'":]|[^,\[\]{}#&*!|>'"%@`])[^#]*?(?=\s*:($|\s))/)) {
	        state.pair = true;
	        state.keyCol = stream.indentation();
	        return "atom";
	      }
	      if (state.pair && stream.match(/^:\s*/)) { state.pairStart = true; return 'meta'; }
	
	      /* nothing found, continue */
	      state.pairStart = false;
	      state.escaped = (ch == '\\');
	      stream.next();
	      return null;
	    },
	    startState: function() {
	      return {
	        pair: false,
	        pairStart: false,
	        keyCol: 0,
	        inlinePairs: 0,
	        inlineList: 0,
	        literal: false,
	        escaped: false
	      };
	    },
	    lineComment: "#",
	    fold: "indent"
	  };
	});
	
	CodeMirror.defineMIME("text/x-yaml", "yaml");
	CodeMirror.defineMIME("text/yaml", "yaml");
	
	});


/***/ }),
/* 313 */
/***/ (function(module, exports) {

	module.exports = function (xs, fn) {
	    var res = [];
	    for (var i = 0; i < xs.length; i++) {
	        var x = fn(xs[i], i);
	        if (isArray(x)) res.push.apply(res, x);
	        else res.push(x);
	    }
	    return res;
	};
	
	var isArray = Array.isArray || function (xs) {
	    return Object.prototype.toString.call(xs) === '[object Array]';
	};


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(52);
	__webpack_require__(353);
	module.exports = __webpack_require__(4).Array.from;


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(53);
	__webpack_require__(52);
	module.exports = __webpack_require__(351);


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(53);
	__webpack_require__(52);
	module.exports = __webpack_require__(352);


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(4);
	var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
	module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
	  return $JSON.stringify.apply($JSON, arguments);
	};


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(77);
	__webpack_require__(52);
	__webpack_require__(53);
	__webpack_require__(355);
	__webpack_require__(368);
	__webpack_require__(367);
	__webpack_require__(366);
	module.exports = __webpack_require__(4).Map;


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(356);
	module.exports = __webpack_require__(4).Object.assign;


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(357);
	var $Object = __webpack_require__(4).Object;
	module.exports = function create(P, D) {
	  return $Object.create(P, D);
	};


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(358);
	var $Object = __webpack_require__(4).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(369);
	module.exports = __webpack_require__(4).Object.entries;


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(359);
	var $Object = __webpack_require__(4).Object;
	module.exports = function getOwnPropertyDescriptor(it, key) {
	  return $Object.getOwnPropertyDescriptor(it, key);
	};


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(172);
	module.exports = __webpack_require__(4).Object.getOwnPropertySymbols;


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(360);
	module.exports = __webpack_require__(4).Object.getPrototypeOf;


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(361);
	module.exports = __webpack_require__(4).Object.keys;


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(362);
	module.exports = __webpack_require__(4).Object.setPrototypeOf;


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(77);
	__webpack_require__(52);
	__webpack_require__(53);
	__webpack_require__(363);
	__webpack_require__(370);
	__webpack_require__(371);
	module.exports = __webpack_require__(4).Promise;


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(77);
	__webpack_require__(52);
	__webpack_require__(53);
	__webpack_require__(364);
	__webpack_require__(374);
	__webpack_require__(373);
	__webpack_require__(372);
	module.exports = __webpack_require__(4).Set;


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(172);
	__webpack_require__(77);
	__webpack_require__(375);
	__webpack_require__(376);
	module.exports = __webpack_require__(4).Symbol;


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(52);
	__webpack_require__(53);
	module.exports = __webpack_require__(123).f('iterator');


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(77);
	__webpack_require__(53);
	__webpack_require__(365);
	__webpack_require__(378);
	__webpack_require__(377);
	module.exports = __webpack_require__(4).WeakMap;


/***/ }),
/* 333 */
/***/ (function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__(58);
	
	module.exports = function (iter, ITERATOR) {
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(47);
	var toLength = __webpack_require__(88);
	var toAbsoluteIndex = __webpack_require__(349);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(27);
	var isArray = __webpack_require__(159);
	var SPECIES = __webpack_require__(19)('species');
	
	module.exports = function (original) {
	  var C;
	  if (isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(336);
	
	module.exports = function (original, length) {
	  return new (speciesConstructor(original))(length);
	};


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var redefineAll = __webpack_require__(87);
	var getWeak = __webpack_require__(73).getWeak;
	var anObject = __webpack_require__(36);
	var isObject = __webpack_require__(27);
	var anInstance = __webpack_require__(84);
	var forOf = __webpack_require__(58);
	var createArrayMethod = __webpack_require__(104);
	var $has = __webpack_require__(45);
	var validate = __webpack_require__(61);
	var arrayFind = createArrayMethod(5);
	var arrayFindIndex = createArrayMethod(6);
	var id = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function (that) {
	  return that._l || (that._l = new UncaughtFrozenStore());
	};
	var UncaughtFrozenStore = function () {
	  this.a = [];
	};
	var findUncaughtFrozen = function (store, key) {
	  return arrayFind(store.a, function (it) {
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function (key) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) return entry[1];
	  },
	  has: function (key) {
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function (key, value) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function (key) {
	    var index = arrayFindIndex(this.a, function (it) {
	      return it[0] === key;
	    });
	    if (~index) this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;      // collection type
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function (key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var data = getWeak(anObject(key), true);
	    if (data === true) uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(37);
	var createDesc = __webpack_require__(75);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(60);
	var gOPS = __webpack_require__(113);
	var pIE = __webpack_require__(74);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ }),
/* 341 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(86);
	var descriptor = __webpack_require__(75);
	var setToStringTag = __webpack_require__(76);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(46)(IteratorPrototype, __webpack_require__(19)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(17);
	var macrotask = __webpack_require__(171).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(71)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    var promise = Promise.resolve(undefined);
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(37);
	var anObject = __webpack_require__(36);
	var getKeys = __webpack_require__(60);
	
	module.exports = __webpack_require__(33) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(47);
	var gOPN = __webpack_require__(164).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	var DESCRIPTORS = __webpack_require__(33);
	var getKeys = __webpack_require__(60);
	var toIObject = __webpack_require__(47);
	var isEnum = __webpack_require__(74).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) {
	      key = keys[i++];
	      if (!DESCRIPTORS || isEnum.call(O, key)) {
	        result.push(isEntries ? [key, O[key]] : O[key]);
	      }
	    }
	    return result;
	  };
	};


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(27);
	var anObject = __webpack_require__(36);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(41)(Function.call, __webpack_require__(112).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(120);
	var defined = __webpack_require__(106);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(120);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(17);
	var navigator = global.navigator;
	
	module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(36);
	var get = __webpack_require__(124);
	module.exports = __webpack_require__(4).getIterator = function (it) {
	  var iterFn = get(it);
	  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
	  return anObject(iterFn.call(it));
	};


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(85);
	var ITERATOR = __webpack_require__(19)('iterator');
	var Iterators = __webpack_require__(59);
	module.exports = __webpack_require__(4).isIterable = function (it) {
	  var O = Object(it);
	  return O[ITERATOR] !== undefined
	    || '@@iterator' in O
	    // eslint-disable-next-line no-prototype-builtins
	    || Iterators.hasOwnProperty(classof(O));
	};


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(41);
	var $export = __webpack_require__(14);
	var toObject = __webpack_require__(51);
	var call = __webpack_require__(160);
	var isArrayIter = __webpack_require__(158);
	var toLength = __webpack_require__(88);
	var createProperty = __webpack_require__(339);
	var getIterFn = __webpack_require__(124);
	
	$export($export.S + $export.F * !__webpack_require__(161)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(333);
	var step = __webpack_require__(162);
	var Iterators = __webpack_require__(59);
	var toIObject = __webpack_require__(47);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(110)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(154);
	var validate = __webpack_require__(61);
	var MAP = 'Map';
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(105)(MAP, function (get) {
	  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key) {
	    var entry = strong.getEntry(validate(this, MAP), key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value) {
	    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
	  }
	}, strong, true);


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(14);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(163) });


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(14);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(86) });


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(14);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(33), 'Object', { defineProperty: __webpack_require__(37).f });


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(47);
	var $getOwnPropertyDescriptor = __webpack_require__(112).f;
	
	__webpack_require__(114)('getOwnPropertyDescriptor', function () {
	  return function getOwnPropertyDescriptor(it, key) {
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(51);
	var $getPrototypeOf = __webpack_require__(165);
	
	__webpack_require__(114)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(51);
	var $keys = __webpack_require__(60);
	
	__webpack_require__(114)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(14);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(347).set });


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(72);
	var global = __webpack_require__(17);
	var ctx = __webpack_require__(41);
	var classof = __webpack_require__(85);
	var $export = __webpack_require__(14);
	var isObject = __webpack_require__(27);
	var aFunction = __webpack_require__(70);
	var anInstance = __webpack_require__(84);
	var forOf = __webpack_require__(58);
	var speciesConstructor = __webpack_require__(170);
	var task = __webpack_require__(171).set;
	var microtask = __webpack_require__(343)();
	var newPromiseCapabilityModule = __webpack_require__(111);
	var perform = __webpack_require__(167);
	var userAgent = __webpack_require__(350);
	var promiseResolve = __webpack_require__(168);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8 || '';
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(19)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function')
	      && promise.then(empty) instanceof FakePromise
	      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	      // we can't detect it synchronously, so just check versions
	      && v8.indexOf('6.6') !== 0
	      && userAgent.indexOf('Chrome/66') === -1;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(87)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(76)($Promise, PROMISE);
	__webpack_require__(169)(PROMISE);
	Wrapper = __webpack_require__(4)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(161)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(154);
	var validate = __webpack_require__(61);
	var SET = 'Set';
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(105)(SET, function (get) {
	  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value) {
	    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
	  }
	}, strong);


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(17);
	var each = __webpack_require__(104)(0);
	var redefine = __webpack_require__(115);
	var meta = __webpack_require__(73);
	var assign = __webpack_require__(163);
	var weak = __webpack_require__(338);
	var isObject = __webpack_require__(27);
	var validate = __webpack_require__(61);
	var NATIVE_WEAK_MAP = __webpack_require__(61);
	var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
	var WEAK_MAP = 'WeakMap';
	var getWeak = meta.getWeak;
	var isExtensible = Object.isExtensible;
	var uncaughtFrozenStore = weak.ufstore;
	var InternalMap;
	
	var wrapper = function (get) {
	  return function WeakMap() {
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key) {
	    if (isObject(key)) {
	      var data = getWeak(key);
	      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value) {
	    return weak.def(validate(this, WEAK_MAP), key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(105)(WEAK_MAP, wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if (NATIVE_WEAK_MAP && IS_IE11) {
	  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function (key) {
	    var proto = $WeakMap.prototype;
	    var method = proto[key];
	    redefine(proto, key, function (a, b) {
	      // store frozen objects on internal weakmap shim
	      if (isObject(a) && !isExtensible(a)) {
	        if (!this._f) this._f = new InternalMap();
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
	__webpack_require__(116)('Map');


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
	__webpack_require__(117)('Map');


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(14);
	
	$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(155)('Map') });


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(14);
	var $entries = __webpack_require__(346)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it) {
	    return $entries(it);
	  }
	});


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(14);
	var core = __webpack_require__(4);
	var global = __webpack_require__(17);
	var speciesConstructor = __webpack_require__(170);
	var promiseResolve = __webpack_require__(168);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(14);
	var newPromiseCapability = __webpack_require__(111);
	var perform = __webpack_require__(167);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
	__webpack_require__(116)('Set');


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
	__webpack_require__(117)('Set');


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(14);
	
	$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(155)('Set') });


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(122)('asyncIterator');


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(122)('observable');


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
	__webpack_require__(116)('WeakMap');


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
	__webpack_require__(117)('WeakMap');


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(173));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
		    var C_enc = C.enc;
	
		    /**
		     * Base64 encoding strategy.
		     */
		    var Base64 = C_enc.Base64 = {
		        /**
		         * Converts a word array to a Base64 string.
		         *
		         * @param {WordArray} wordArray The word array.
		         *
		         * @return {string} The Base64 string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
		         */
		        stringify: function (wordArray) {
		            // Shortcuts
		            var words = wordArray.words;
		            var sigBytes = wordArray.sigBytes;
		            var map = this._map;
	
		            // Clamp excess bits
		            wordArray.clamp();
	
		            // Convert
		            var base64Chars = [];
		            for (var i = 0; i < sigBytes; i += 3) {
		                var byte1 = (words[i >>> 2]       >>> (24 - (i % 4) * 8))       & 0xff;
		                var byte2 = (words[(i + 1) >>> 2] >>> (24 - ((i + 1) % 4) * 8)) & 0xff;
		                var byte3 = (words[(i + 2) >>> 2] >>> (24 - ((i + 2) % 4) * 8)) & 0xff;
	
		                var triplet = (byte1 << 16) | (byte2 << 8) | byte3;
	
		                for (var j = 0; (j < 4) && (i + j * 0.75 < sigBytes); j++) {
		                    base64Chars.push(map.charAt((triplet >>> (6 * (3 - j))) & 0x3f));
		                }
		            }
	
		            // Add padding
		            var paddingChar = map.charAt(64);
		            if (paddingChar) {
		                while (base64Chars.length % 4) {
		                    base64Chars.push(paddingChar);
		                }
		            }
	
		            return base64Chars.join('');
		        },
	
		        /**
		         * Converts a Base64 string to a word array.
		         *
		         * @param {string} base64Str The Base64 string.
		         *
		         * @return {WordArray} The word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
		         */
		        parse: function (base64Str) {
		            // Shortcuts
		            var base64StrLength = base64Str.length;
		            var map = this._map;
		            var reverseMap = this._reverseMap;
	
		            if (!reverseMap) {
		                    reverseMap = this._reverseMap = [];
		                    for (var j = 0; j < map.length; j++) {
		                        reverseMap[map.charCodeAt(j)] = j;
		                    }
		            }
	
		            // Ignore padding
		            var paddingChar = map.charAt(64);
		            if (paddingChar) {
		                var paddingIndex = base64Str.indexOf(paddingChar);
		                if (paddingIndex !== -1) {
		                    base64StrLength = paddingIndex;
		                }
		            }
	
		            // Convert
		            return parseLoop(base64Str, base64StrLength, reverseMap);
	
		        },
	
		        _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
		    };
	
		    function parseLoop(base64Str, base64StrLength, reverseMap) {
		      var words = [];
		      var nBytes = 0;
		      for (var i = 0; i < base64StrLength; i++) {
		          if (i % 4) {
		              var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << ((i % 4) * 2);
		              var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> (6 - (i % 4) * 2);
		              words[nBytes >>> 2] |= (bits1 | bits2) << (24 - (nBytes % 4) * 8);
		              nBytes++;
		          }
		      }
		      return WordArray.create(words, nBytes);
		    }
		}());
	
	
		return CryptoJS.enc.Base64;
	
	}));

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(173));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function (Math) {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
		    var Hasher = C_lib.Hasher;
		    var C_algo = C.algo;
	
		    // Initialization and round constants tables
		    var H = [];
		    var K = [];
	
		    // Compute constants
		    (function () {
		        function isPrime(n) {
		            var sqrtN = Math.sqrt(n);
		            for (var factor = 2; factor <= sqrtN; factor++) {
		                if (!(n % factor)) {
		                    return false;
		                }
		            }
	
		            return true;
		        }
	
		        function getFractionalBits(n) {
		            return ((n - (n | 0)) * 0x100000000) | 0;
		        }
	
		        var n = 2;
		        var nPrime = 0;
		        while (nPrime < 64) {
		            if (isPrime(n)) {
		                if (nPrime < 8) {
		                    H[nPrime] = getFractionalBits(Math.pow(n, 1 / 2));
		                }
		                K[nPrime] = getFractionalBits(Math.pow(n, 1 / 3));
	
		                nPrime++;
		            }
	
		            n++;
		        }
		    }());
	
		    // Reusable object
		    var W = [];
	
		    /**
		     * SHA-256 hash algorithm.
		     */
		    var SHA256 = C_algo.SHA256 = Hasher.extend({
		        _doReset: function () {
		            this._hash = new WordArray.init(H.slice(0));
		        },
	
		        _doProcessBlock: function (M, offset) {
		            // Shortcut
		            var H = this._hash.words;
	
		            // Working variables
		            var a = H[0];
		            var b = H[1];
		            var c = H[2];
		            var d = H[3];
		            var e = H[4];
		            var f = H[5];
		            var g = H[6];
		            var h = H[7];
	
		            // Computation
		            for (var i = 0; i < 64; i++) {
		                if (i < 16) {
		                    W[i] = M[offset + i] | 0;
		                } else {
		                    var gamma0x = W[i - 15];
		                    var gamma0  = ((gamma0x << 25) | (gamma0x >>> 7))  ^
		                                  ((gamma0x << 14) | (gamma0x >>> 18)) ^
		                                   (gamma0x >>> 3);
	
		                    var gamma1x = W[i - 2];
		                    var gamma1  = ((gamma1x << 15) | (gamma1x >>> 17)) ^
		                                  ((gamma1x << 13) | (gamma1x >>> 19)) ^
		                                   (gamma1x >>> 10);
	
		                    W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
		                }
	
		                var ch  = (e & f) ^ (~e & g);
		                var maj = (a & b) ^ (a & c) ^ (b & c);
	
		                var sigma0 = ((a << 30) | (a >>> 2)) ^ ((a << 19) | (a >>> 13)) ^ ((a << 10) | (a >>> 22));
		                var sigma1 = ((e << 26) | (e >>> 6)) ^ ((e << 21) | (e >>> 11)) ^ ((e << 7)  | (e >>> 25));
	
		                var t1 = h + sigma1 + ch + K[i] + W[i];
		                var t2 = sigma0 + maj;
	
		                h = g;
		                g = f;
		                f = e;
		                e = (d + t1) | 0;
		                d = c;
		                c = b;
		                b = a;
		                a = (t1 + t2) | 0;
		            }
	
		            // Intermediate hash value
		            H[0] = (H[0] + a) | 0;
		            H[1] = (H[1] + b) | 0;
		            H[2] = (H[2] + c) | 0;
		            H[3] = (H[3] + d) | 0;
		            H[4] = (H[4] + e) | 0;
		            H[5] = (H[5] + f) | 0;
		            H[6] = (H[6] + g) | 0;
		            H[7] = (H[7] + h) | 0;
		        },
	
		        _doFinalize: function () {
		            // Shortcuts
		            var data = this._data;
		            var dataWords = data.words;
	
		            var nBitsTotal = this._nDataBytes * 8;
		            var nBitsLeft = data.sigBytes * 8;
	
		            // Add padding
		            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
		            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
		            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
		            data.sigBytes = dataWords.length * 4;
	
		            // Hash final blocks
		            this._process();
	
		            // Return final computed hash
		            return this._hash;
		        },
	
		        clone: function () {
		            var clone = Hasher.clone.call(this);
		            clone._hash = this._hash.clone();
	
		            return clone;
		        }
		    });
	
		    /**
		     * Shortcut function to the hasher's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     *
		     * @return {WordArray} The hash.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hash = CryptoJS.SHA256('message');
		     *     var hash = CryptoJS.SHA256(wordArray);
		     */
		    C.SHA256 = Hasher._createHelper(SHA256);
	
		    /**
		     * Shortcut function to the HMAC's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     * @param {WordArray|string} key The secret key.
		     *
		     * @return {WordArray} The HMAC.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hmac = CryptoJS.HmacSHA256(message, key);
		     */
		    C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
		}(Math));
	
	
		return CryptoJS.SHA256;
	
	}));

/***/ }),
/* 381 */
/***/ (function(module, exports) {

	'use strict';
	
	var isMergeableObject = function isMergeableObject(value) {
		return isNonNullObject(value)
			&& !isSpecial(value)
	};
	
	function isNonNullObject(value) {
		return !!value && typeof value === 'object'
	}
	
	function isSpecial(value) {
		var stringValue = Object.prototype.toString.call(value);
	
		return stringValue === '[object RegExp]'
			|| stringValue === '[object Date]'
			|| isReactElement(value)
	}
	
	// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
	var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
	var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;
	
	function isReactElement(value) {
		return value.$$typeof === REACT_ELEMENT_TYPE
	}
	
	function emptyTarget(val) {
	    return Array.isArray(val) ? [] : {}
	}
	
	function cloneIfNecessary(value, optionsArgument) {
	    var clone = optionsArgument && optionsArgument.clone === true;
	    return (clone && isMergeableObject(value)) ? deepmerge(emptyTarget(value), value, optionsArgument) : value
	}
	
	function defaultArrayMerge(target, source, optionsArgument) {
	    var destination = target.slice();
	    source.forEach(function(e, i) {
	        if (typeof destination[i] === 'undefined') {
	            destination[i] = cloneIfNecessary(e, optionsArgument);
	        } else if (isMergeableObject(e)) {
	            destination[i] = deepmerge(target[i], e, optionsArgument);
	        } else if (target.indexOf(e) === -1) {
	            destination.push(cloneIfNecessary(e, optionsArgument));
	        }
	    });
	    return destination
	}
	
	function mergeObject(target, source, optionsArgument) {
	    var destination = {};
	    if (isMergeableObject(target)) {
	        Object.keys(target).forEach(function(key) {
	            destination[key] = cloneIfNecessary(target[key], optionsArgument);
	        });
	    }
	    Object.keys(source).forEach(function(key) {
	        if (!isMergeableObject(source[key]) || !target[key]) {
	            destination[key] = cloneIfNecessary(source[key], optionsArgument);
	        } else {
	            destination[key] = deepmerge(target[key], source[key], optionsArgument);
	        }
	    });
	    return destination
	}
	
	function deepmerge(target, source, optionsArgument) {
	    var sourceIsArray = Array.isArray(source);
	    var targetIsArray = Array.isArray(target);
	    var options = optionsArgument || { arrayMerge: defaultArrayMerge };
	    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
	
	    if (!sourceAndTargetTypesMatch) {
	        return cloneIfNecessary(source, optionsArgument)
	    } else if (sourceIsArray) {
	        var arrayMerge = options.arrayMerge || defaultArrayMerge;
	        return arrayMerge(target, source, optionsArgument)
	    } else {
	        return mergeObject(target, source, optionsArgument)
	    }
	}
	
	deepmerge.all = function deepmergeAll(array, optionsArgument) {
	    if (!Array.isArray(array) || array.length < 2) {
	        throw new Error('first argument should be an array with at least two elements')
	    }
	
	    // we are sure there are at least 2 values, so it is safe to have no initial value
	    return array.reduce(function(prev, next) {
	        return deepmerge(prev, next, optionsArgument)
	    })
	};
	
	var deepmerge_1 = deepmerge;
	
	module.exports = deepmerge_1;


/***/ }),
/* 382 */
/***/ (function(module, exports) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 99);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
	/* globals __VUE_SSR_CONTEXT__ */
	
	// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
	// This module is a runtime utility for cleaner component module output and will
	// be included in the final webpack user bundle.
	
	function normalizeComponent (
	  scriptExports,
	  render,
	  staticRenderFns,
	  functionalTemplate,
	  injectStyles,
	  scopeId,
	  moduleIdentifier, /* server only */
	  shadowMode /* vue-cli only */
	) {
	  // Vue.extend constructor export interop
	  var options = typeof scriptExports === 'function'
	    ? scriptExports.options
	    : scriptExports
	
	  // render functions
	  if (render) {
	    options.render = render
	    options.staticRenderFns = staticRenderFns
	    options._compiled = true
	  }
	
	  // functional template
	  if (functionalTemplate) {
	    options.functional = true
	  }
	
	  // scopedId
	  if (scopeId) {
	    options._scopeId = 'data-v-' + scopeId
	  }
	
	  var hook
	  if (moduleIdentifier) { // server build
	    hook = function (context) {
	      // 2.3 injection
	      context =
	        context || // cached call
	        (this.$vnode && this.$vnode.ssrContext) || // stateful
	        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
	      // 2.2 with runInNewContext: true
	      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
	        context = __VUE_SSR_CONTEXT__
	      }
	      // inject component styles
	      if (injectStyles) {
	        injectStyles.call(this, context)
	      }
	      // register component module identifier for async chunk inferrence
	      if (context && context._registeredComponents) {
	        context._registeredComponents.add(moduleIdentifier)
	      }
	    }
	    // used by ssr in case component is cached and beforeCreate
	    // never gets called
	    options._ssrRegister = hook
	  } else if (injectStyles) {
	    hook = shadowMode
	      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
	      : injectStyles
	  }
	
	  if (hook) {
	    if (options.functional) {
	      // for template-only hot-reload because in that case the render fn doesn't
	      // go through the normalizer
	      options._injectStyles = hook
	      // register for functioal component in vue file
	      var originalRender = options.render
	      options.render = function renderWithStyleInjection (h, context) {
	        hook.call(context)
	        return originalRender(h, context)
	      }
	    } else {
	      // inject component registration as beforeCreate hook
	      var existing = options.beforeCreate
	      options.beforeCreate = existing
	        ? [].concat(existing, hook)
	        : [hook]
	    }
	  }
	
	  return {
	    exports: scriptExports,
	    options: options
	  }
	}
	
	
	/***/ }),
	
	/***/ 99:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/button/src/button-group.vue?vue&type=template&id=3d8661d0&
	var render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("div", { staticClass: "el-button-group" }, [_vm._t("default")], 2)
	}
	var staticRenderFns = []
	render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/button/src/button-group.vue?vue&type=template&id=3d8661d0&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/button/src/button-group.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	
	/* harmony default export */ var button_groupvue_type_script_lang_js_ = ({
	  name: 'ElButtonGroup'
	});
	// CONCATENATED MODULE: ./packages/button/src/button-group.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_button_groupvue_type_script_lang_js_ = (button_groupvue_type_script_lang_js_); 
	// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
	var componentNormalizer = __webpack_require__(0);
	
	// CONCATENATED MODULE: ./packages/button/src/button-group.vue
	
	
	
	
	
	/* normalize component */
	
	var component = Object(componentNormalizer["a" /* default */])(
	  src_button_groupvue_type_script_lang_js_,
	  render,
	  staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var api; }
	component.options.__file = "packages/button/src/button-group.vue"
	/* harmony default export */ var button_group = (component.exports);
	// CONCATENATED MODULE: ./packages/button-group/index.js
	
	
	/* istanbul ignore next */
	button_group.install = function (Vue) {
	  Vue.component(button_group.name, button_group);
	};
	
	/* harmony default export */ var packages_button_group = __webpack_exports__["default"] = (button_group);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 383 */
/***/ (function(module, exports) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 97);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
	/* globals __VUE_SSR_CONTEXT__ */
	
	// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
	// This module is a runtime utility for cleaner component module output and will
	// be included in the final webpack user bundle.
	
	function normalizeComponent (
	  scriptExports,
	  render,
	  staticRenderFns,
	  functionalTemplate,
	  injectStyles,
	  scopeId,
	  moduleIdentifier, /* server only */
	  shadowMode /* vue-cli only */
	) {
	  // Vue.extend constructor export interop
	  var options = typeof scriptExports === 'function'
	    ? scriptExports.options
	    : scriptExports
	
	  // render functions
	  if (render) {
	    options.render = render
	    options.staticRenderFns = staticRenderFns
	    options._compiled = true
	  }
	
	  // functional template
	  if (functionalTemplate) {
	    options.functional = true
	  }
	
	  // scopedId
	  if (scopeId) {
	    options._scopeId = 'data-v-' + scopeId
	  }
	
	  var hook
	  if (moduleIdentifier) { // server build
	    hook = function (context) {
	      // 2.3 injection
	      context =
	        context || // cached call
	        (this.$vnode && this.$vnode.ssrContext) || // stateful
	        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
	      // 2.2 with runInNewContext: true
	      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
	        context = __VUE_SSR_CONTEXT__
	      }
	      // inject component styles
	      if (injectStyles) {
	        injectStyles.call(this, context)
	      }
	      // register component module identifier for async chunk inferrence
	      if (context && context._registeredComponents) {
	        context._registeredComponents.add(moduleIdentifier)
	      }
	    }
	    // used by ssr in case component is cached and beforeCreate
	    // never gets called
	    options._ssrRegister = hook
	  } else if (injectStyles) {
	    hook = shadowMode
	      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
	      : injectStyles
	  }
	
	  if (hook) {
	    if (options.functional) {
	      // for template-only hot-reload because in that case the render fn doesn't
	      // go through the normalizer
	      options._injectStyles = hook
	      // register for functioal component in vue file
	      var originalRender = options.render
	      options.render = function renderWithStyleInjection (h, context) {
	        hook.call(context)
	        return originalRender(h, context)
	      }
	    } else {
	      // inject component registration as beforeCreate hook
	      var existing = options.beforeCreate
	      options.beforeCreate = existing
	        ? [].concat(existing, hook)
	        : [hook]
	    }
	  }
	
	  return {
	    exports: scriptExports,
	    options: options
	  }
	}
	
	
	/***/ }),
	
	/***/ 97:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/button/src/button.vue?vue&type=template&id=ca859fb4&
	var render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "button",
	    {
	      staticClass: "el-button",
	      class: [
	        _vm.type ? "el-button--" + _vm.type : "",
	        _vm.buttonSize ? "el-button--" + _vm.buttonSize : "",
	        {
	          "is-disabled": _vm.buttonDisabled,
	          "is-loading": _vm.loading,
	          "is-plain": _vm.plain,
	          "is-round": _vm.round,
	          "is-circle": _vm.circle
	        }
	      ],
	      attrs: {
	        disabled: _vm.buttonDisabled || _vm.loading,
	        autofocus: _vm.autofocus,
	        type: _vm.nativeType
	      },
	      on: { click: _vm.handleClick }
	    },
	    [
	      _vm.loading ? _c("i", { staticClass: "el-icon-loading" }) : _vm._e(),
	      _vm.icon && !_vm.loading ? _c("i", { class: _vm.icon }) : _vm._e(),
	      _vm.$slots.default ? _c("span", [_vm._t("default")], 2) : _vm._e()
	    ]
	  )
	}
	var staticRenderFns = []
	render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/button/src/button.vue?vue&type=template&id=ca859fb4&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/button/src/button.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var buttonvue_type_script_lang_js_ = ({
	  name: 'ElButton',
	
	  inject: {
	    elForm: {
	      default: ''
	    },
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  props: {
	    type: {
	      type: String,
	      default: 'default'
	    },
	    size: String,
	    icon: {
	      type: String,
	      default: ''
	    },
	    nativeType: {
	      type: String,
	      default: 'button'
	    },
	    loading: Boolean,
	    disabled: Boolean,
	    plain: Boolean,
	    autofocus: Boolean,
	    round: Boolean,
	    circle: Boolean
	  },
	
	  computed: {
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    buttonSize: function buttonSize() {
	      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
	    },
	    buttonDisabled: function buttonDisabled() {
	      return this.disabled || (this.elForm || {}).disabled;
	    }
	  },
	
	  methods: {
	    handleClick: function handleClick(evt) {
	      this.$emit('click', evt);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/button/src/button.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_buttonvue_type_script_lang_js_ = (buttonvue_type_script_lang_js_); 
	// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
	var componentNormalizer = __webpack_require__(0);
	
	// CONCATENATED MODULE: ./packages/button/src/button.vue
	
	
	
	
	
	/* normalize component */
	
	var component = Object(componentNormalizer["a" /* default */])(
	  src_buttonvue_type_script_lang_js_,
	  render,
	  staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var api; }
	component.options.__file = "packages/button/src/button.vue"
	/* harmony default export */ var src_button = (component.exports);
	// CONCATENATED MODULE: ./packages/button/index.js
	
	
	/* istanbul ignore next */
	src_button.install = function (Vue) {
	  Vue.component(src_button.name, src_button);
	};
	
	/* harmony default export */ var packages_button = __webpack_exports__["default"] = (src_button);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 59);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
	/* globals __VUE_SSR_CONTEXT__ */
	
	// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
	// This module is a runtime utility for cleaner component module output and will
	// be included in the final webpack user bundle.
	
	function normalizeComponent (
	  scriptExports,
	  render,
	  staticRenderFns,
	  functionalTemplate,
	  injectStyles,
	  scopeId,
	  moduleIdentifier, /* server only */
	  shadowMode /* vue-cli only */
	) {
	  // Vue.extend constructor export interop
	  var options = typeof scriptExports === 'function'
	    ? scriptExports.options
	    : scriptExports
	
	  // render functions
	  if (render) {
	    options.render = render
	    options.staticRenderFns = staticRenderFns
	    options._compiled = true
	  }
	
	  // functional template
	  if (functionalTemplate) {
	    options.functional = true
	  }
	
	  // scopedId
	  if (scopeId) {
	    options._scopeId = 'data-v-' + scopeId
	  }
	
	  var hook
	  if (moduleIdentifier) { // server build
	    hook = function (context) {
	      // 2.3 injection
	      context =
	        context || // cached call
	        (this.$vnode && this.$vnode.ssrContext) || // stateful
	        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
	      // 2.2 with runInNewContext: true
	      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
	        context = __VUE_SSR_CONTEXT__
	      }
	      // inject component styles
	      if (injectStyles) {
	        injectStyles.call(this, context)
	      }
	      // register component module identifier for async chunk inferrence
	      if (context && context._registeredComponents) {
	        context._registeredComponents.add(moduleIdentifier)
	      }
	    }
	    // used by ssr in case component is cached and beforeCreate
	    // never gets called
	    options._ssrRegister = hook
	  } else if (injectStyles) {
	    hook = shadowMode
	      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
	      : injectStyles
	  }
	
	  if (hook) {
	    if (options.functional) {
	      // for template-only hot-reload because in that case the render fn doesn't
	      // go through the normalizer
	      options._injectStyles = hook
	      // register for functioal component in vue file
	      var originalRender = options.render
	      options.render = function renderWithStyleInjection (h, context) {
	        hook.call(context)
	        return originalRender(h, context)
	      }
	    } else {
	      // inject component registration as beforeCreate hook
	      var existing = options.beforeCreate
	      options.beforeCreate = existing
	        ? [].concat(existing, hook)
	        : [hook]
	    }
	  }
	
	  return {
	    exports: scriptExports,
	    options: options
	  }
	}
	
	
	/***/ }),
	
	/***/ 14:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(128);
	
	/***/ }),
	
	/***/ 18:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(174);
	
	/***/ }),
	
	/***/ 21:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(92);
	
	/***/ }),
	
	/***/ 26:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(141);
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(38);
	
	/***/ }),
	
	/***/ 31:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(131);
	
	/***/ }),
	
	/***/ 32:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(129);
	
	/***/ }),
	
	/***/ 51:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(176);
	
	/***/ }),
	
	/***/ 59:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader-panel/src/cascader-panel.vue?vue&type=template&id=34932346&
	var cascader_panelvue_type_template_id_34932346_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      class: ["el-cascader-panel", _vm.border && "is-bordered"],
	      on: { keydown: _vm.handleKeyDown }
	    },
	    _vm._l(_vm.menus, function(menu, index) {
	      return _c("cascader-menu", {
	        key: index,
	        ref: "menu",
	        refInFor: true,
	        attrs: { index: index, nodes: menu }
	      })
	    }),
	    1
	  )
	}
	var staticRenderFns = []
	cascader_panelvue_type_template_id_34932346_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-panel.vue?vue&type=template&id=34932346&
	
	// EXTERNAL MODULE: external "babel-helper-vue-jsx-merge-props"
	var external_babel_helper_vue_jsx_merge_props_ = __webpack_require__(26);
	var external_babel_helper_vue_jsx_merge_props_default = /*#__PURE__*/__webpack_require__.n(external_babel_helper_vue_jsx_merge_props_);
	
	// EXTERNAL MODULE: external "element-ui/lib/scrollbar"
	var scrollbar_ = __webpack_require__(14);
	var scrollbar_default = /*#__PURE__*/__webpack_require__.n(scrollbar_);
	
	// EXTERNAL MODULE: external "element-ui/lib/checkbox"
	var checkbox_ = __webpack_require__(18);
	var checkbox_default = /*#__PURE__*/__webpack_require__.n(checkbox_);
	
	// EXTERNAL MODULE: external "element-ui/lib/radio"
	var radio_ = __webpack_require__(51);
	var radio_default = /*#__PURE__*/__webpack_require__.n(radio_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/util"
	var util_ = __webpack_require__(3);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader-panel/src/cascader-node.vue?vue&type=script&lang=js&
	
	
	
	
	
	
	var stopPropagation = function stopPropagation(e) {
	  return e.stopPropagation();
	};
	
	/* harmony default export */ var cascader_nodevue_type_script_lang_js_ = ({
	  inject: ['panel'],
	
	  components: {
	    ElCheckbox: checkbox_default.a,
	    ElRadio: radio_default.a
	  },
	
	  props: {
	    node: {
	      required: true
	    },
	    nodeId: String
	  },
	
	  computed: {
	    config: function config() {
	      return this.panel.config;
	    },
	    isLeaf: function isLeaf() {
	      return this.node.isLeaf;
	    },
	    isDisabled: function isDisabled() {
	      return this.node.isDisabled;
	    },
	    checkedValue: function checkedValue() {
	      return this.panel.checkedValue;
	    },
	    isChecked: function isChecked() {
	      return this.node.isSameNode(this.checkedValue);
	    },
	    inActivePath: function inActivePath() {
	      return this.isInPath(this.panel.activePath);
	    },
	    inCheckedPath: function inCheckedPath() {
	      var _this = this;
	
	      if (!this.config.checkStrictly) return false;
	
	      return this.panel.checkedNodePaths.some(function (checkedPath) {
	        return _this.isInPath(checkedPath);
	      });
	    },
	    value: function value() {
	      return this.node.getValueByOption();
	    }
	  },
	
	  methods: {
	    handleExpand: function handleExpand() {
	      var _this2 = this;
	
	      var panel = this.panel,
	          node = this.node,
	          isDisabled = this.isDisabled,
	          config = this.config;
	      var multiple = config.multiple,
	          checkStrictly = config.checkStrictly;
	
	
	      if (!checkStrictly && isDisabled || node.loading) return;
	
	      if (config.lazy && !node.loaded) {
	        panel.lazyLoad(node, function () {
	          // do not use cached leaf value here, invoke this.isLeaf to get new value.
	          var isLeaf = _this2.isLeaf;
	
	
	          if (!isLeaf) _this2.handleExpand();
	          if (multiple) {
	            // if leaf sync checked state, else clear checked state
	            var checked = isLeaf ? node.checked : false;
	            _this2.handleMultiCheckChange(checked);
	          }
	        });
	      } else {
	        panel.handleExpand(node);
	      }
	    },
	    handleCheckChange: function handleCheckChange() {
	      var panel = this.panel,
	          value = this.value,
	          node = this.node;
	
	      panel.handleCheckChange(value);
	      panel.handleExpand(node);
	    },
	    handleMultiCheckChange: function handleMultiCheckChange(checked) {
	      this.node.doCheck(checked);
	      this.panel.calculateMultiCheckedValue();
	    },
	    isInPath: function isInPath(pathNodes) {
	      var node = this.node;
	
	      var selectedPathNode = pathNodes[node.level - 1] || {};
	      return selectedPathNode.uid === node.uid;
	    },
	    renderPrefix: function renderPrefix(h) {
	      var isLeaf = this.isLeaf,
	          isChecked = this.isChecked,
	          config = this.config;
	      var checkStrictly = config.checkStrictly,
	          multiple = config.multiple;
	
	
	      if (multiple) {
	        return this.renderCheckbox(h);
	      } else if (checkStrictly) {
	        return this.renderRadio(h);
	      } else if (isLeaf && isChecked) {
	        return this.renderCheckIcon(h);
	      }
	
	      return null;
	    },
	    renderPostfix: function renderPostfix(h) {
	      var node = this.node,
	          isLeaf = this.isLeaf;
	
	
	      if (node.loading) {
	        return this.renderLoadingIcon(h);
	      } else if (!isLeaf) {
	        return this.renderExpandIcon(h);
	      }
	
	      return null;
	    },
	    renderCheckbox: function renderCheckbox(h) {
	      var node = this.node,
	          config = this.config,
	          isDisabled = this.isDisabled;
	
	      var events = {
	        on: { change: this.handleMultiCheckChange },
	        nativeOn: {}
	      };
	
	      if (config.checkStrictly) {
	        // when every node is selectable, click event should not trigger expand event.
	        events.nativeOn.click = stopPropagation;
	      }
	
	      return h('el-checkbox', external_babel_helper_vue_jsx_merge_props_default()([{
	        attrs: {
	          value: node.checked,
	          indeterminate: node.indeterminate,
	          disabled: isDisabled
	        }
	      }, events]));
	    },
	    renderRadio: function renderRadio(h) {
	      var checkedValue = this.checkedValue,
	          value = this.value,
	          isDisabled = this.isDisabled;
	
	      // to keep same reference if value cause radio's checked state is calculated by reference comparision;
	
	      if (Object(util_["isEqual"])(value, checkedValue)) {
	        value = checkedValue;
	      }
	
	      return h(
	        'el-radio',
	        {
	          attrs: {
	            value: checkedValue,
	            label: value,
	            disabled: isDisabled
	          },
	          on: {
	            'change': this.handleCheckChange
	          },
	          nativeOn: {
	            'click': stopPropagation
	          }
	        },
	        [h('span')]
	      );
	    },
	    renderCheckIcon: function renderCheckIcon(h) {
	      return h('i', { 'class': 'el-icon-check el-cascader-node__prefix' });
	    },
	    renderLoadingIcon: function renderLoadingIcon(h) {
	      return h('i', { 'class': 'el-icon-loading el-cascader-node__postfix' });
	    },
	    renderExpandIcon: function renderExpandIcon(h) {
	      return h('i', { 'class': 'el-icon-arrow-right el-cascader-node__postfix' });
	    },
	    renderContent: function renderContent(h) {
	      var panel = this.panel,
	          node = this.node;
	
	      var render = panel.renderLabelFn;
	      var vnode = render ? render({ node: node, data: node.data }) : null;
	
	      return h(
	        'span',
	        { 'class': 'el-cascader-node__label' },
	        [vnode || node.label]
	      );
	    }
	  },
	
	  render: function render(h) {
	    var _this3 = this;
	
	    var inActivePath = this.inActivePath,
	        inCheckedPath = this.inCheckedPath,
	        isChecked = this.isChecked,
	        isLeaf = this.isLeaf,
	        isDisabled = this.isDisabled,
	        config = this.config,
	        nodeId = this.nodeId;
	    var expandTrigger = config.expandTrigger,
	        checkStrictly = config.checkStrictly,
	        multiple = config.multiple;
	
	    var disabled = !checkStrictly && isDisabled;
	    var events = { on: {} };
	
	    if (expandTrigger === 'click') {
	      events.on.click = this.handleExpand;
	    } else {
	      events.on.mouseenter = function (e) {
	        _this3.handleExpand();
	        _this3.$emit('expand', e);
	      };
	      events.on.focus = function (e) {
	        _this3.handleExpand();
	        _this3.$emit('expand', e);
	      };
	    }
	    if (isLeaf && !isDisabled && !checkStrictly && !multiple) {
	      events.on.click = this.handleCheckChange;
	    }
	
	    return h(
	      'li',
	      external_babel_helper_vue_jsx_merge_props_default()([{
	        attrs: {
	          role: 'menuitem',
	          id: nodeId,
	          'aria-expanded': inActivePath,
	          tabindex: disabled ? null : -1
	        },
	        'class': {
	          'el-cascader-node': true,
	          'is-selectable': checkStrictly,
	          'in-active-path': inActivePath,
	          'in-checked-path': inCheckedPath,
	          'is-active': isChecked,
	          'is-disabled': disabled
	        }
	      }, events]),
	      [this.renderPrefix(h), this.renderContent(h), this.renderPostfix(h)]
	    );
	  }
	});
	// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-node.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_cascader_nodevue_type_script_lang_js_ = (cascader_nodevue_type_script_lang_js_); 
	// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
	var componentNormalizer = __webpack_require__(0);
	
	// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-node.vue
	var cascader_node_render, cascader_node_staticRenderFns
	
	
	
	
	/* normalize component */
	
	var component = Object(componentNormalizer["a" /* default */])(
	  src_cascader_nodevue_type_script_lang_js_,
	  cascader_node_render,
	  cascader_node_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var api; }
	component.options.__file = "packages/cascader-panel/src/cascader-node.vue"
	/* harmony default export */ var cascader_node = (component.exports);
	// EXTERNAL MODULE: external "element-ui/lib/mixins/locale"
	var locale_ = __webpack_require__(6);
	var locale_default = /*#__PURE__*/__webpack_require__.n(locale_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader-panel/src/cascader-menu.vue?vue&type=script&lang=js&
	
	
	
	
	
	
	
	/* harmony default export */ var cascader_menuvue_type_script_lang_js_ = ({
	  name: 'ElCascaderMenu',
	
	  mixins: [locale_default.a],
	
	  inject: ['panel'],
	
	  components: {
	    ElScrollbar: scrollbar_default.a,
	    CascaderNode: cascader_node
	  },
	
	  props: {
	    nodes: {
	      type: Array,
	      required: true
	    },
	    index: Number
	  },
	
	  data: function data() {
	    return {
	      activeNode: null,
	      hoverTimer: null,
	      id: Object(util_["generateId"])()
	    };
	  },
	
	
	  computed: {
	    isEmpty: function isEmpty() {
	      return !this.nodes.length;
	    },
	    menuId: function menuId() {
	      return 'cascader-menu-' + this.id + '-' + this.index;
	    }
	  },
	
	  methods: {
	    handleExpand: function handleExpand(e) {
	      this.activeNode = e.target;
	    },
	    handleMouseMove: function handleMouseMove(e) {
	      var activeNode = this.activeNode,
	          hoverTimer = this.hoverTimer;
	      var hoverZone = this.$refs.hoverZone;
	
	
	      if (!activeNode || !hoverZone) return;
	
	      if (activeNode.contains(e.target)) {
	        clearTimeout(hoverTimer);
	
	        var _$el$getBoundingClien = this.$el.getBoundingClientRect(),
	            left = _$el$getBoundingClien.left;
	
	        var startX = e.clientX - left;
	        var _$el = this.$el,
	            offsetWidth = _$el.offsetWidth,
	            offsetHeight = _$el.offsetHeight;
	
	        var top = activeNode.offsetTop;
	        var bottom = top + activeNode.offsetHeight;
	
	        hoverZone.innerHTML = '\n          <path style="pointer-events: auto;" fill="transparent" d="M' + startX + ' ' + top + ' L' + offsetWidth + ' 0 V' + top + ' Z" />\n          <path style="pointer-events: auto;" fill="transparent" d="M' + startX + ' ' + bottom + ' L' + offsetWidth + ' ' + offsetHeight + ' V' + bottom + ' Z" />\n        ';
	      } else if (!hoverTimer) {
	        this.hoverTimer = setTimeout(this.clearHoverZone, this.panel.config.hoverThreshold);
	      }
	    },
	    clearHoverZone: function clearHoverZone() {
	      var hoverZone = this.$refs.hoverZone;
	
	      if (!hoverZone) return;
	      hoverZone.innerHTML = '';
	    },
	    renderEmptyText: function renderEmptyText(h) {
	      return h(
	        'div',
	        { 'class': 'el-cascader-menu__empty-text' },
	        [this.t('el.cascader.noData')]
	      );
	    },
	    renderNodeList: function renderNodeList(h) {
	      var menuId = this.menuId;
	      var isHoverMenu = this.panel.isHoverMenu;
	
	      var events = { on: {} };
	
	      if (isHoverMenu) {
	        events.on.expand = this.handleExpand;
	      }
	
	      var nodes = this.nodes.map(function (node, index) {
	        var hasChildren = node.hasChildren;
	
	        return h('cascader-node', external_babel_helper_vue_jsx_merge_props_default()([{
	          key: node.uid,
	          attrs: { node: node,
	            'node-id': menuId + '-' + index,
	            'aria-haspopup': hasChildren,
	            'aria-owns': hasChildren ? menuId : null
	          }
	        }, events]));
	      });
	
	      return [].concat(nodes, [isHoverMenu ? h('svg', { ref: 'hoverZone', 'class': 'el-cascader-menu__hover-zone' }) : null]);
	    }
	  },
	
	  render: function render(h) {
	    var isEmpty = this.isEmpty,
	        menuId = this.menuId;
	
	    var events = { nativeOn: {} };
	
	    // optimize hover to expand experience (#8010)
	    if (this.panel.isHoverMenu) {
	      events.nativeOn.mousemove = this.handleMouseMove;
	      // events.nativeOn.mouseleave = this.clearHoverZone;
	    }
	
	    return h(
	      'el-scrollbar',
	      external_babel_helper_vue_jsx_merge_props_default()([{
	        attrs: {
	          tag: 'ul',
	          role: 'menu',
	          id: menuId,
	
	          'wrap-class': 'el-cascader-menu__wrap',
	          'view-class': {
	            'el-cascader-menu__list': true,
	            'is-empty': isEmpty
	          }
	        },
	        'class': 'el-cascader-menu' }, events]),
	      [isEmpty ? this.renderEmptyText(h) : this.renderNodeList(h)]
	    );
	  }
	});
	// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-menu.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_cascader_menuvue_type_script_lang_js_ = (cascader_menuvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-menu.vue
	var cascader_menu_render, cascader_menu_staticRenderFns
	
	
	
	
	/* normalize component */
	
	var cascader_menu_component = Object(componentNormalizer["a" /* default */])(
	  src_cascader_menuvue_type_script_lang_js_,
	  cascader_menu_render,
	  cascader_menu_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var cascader_menu_api; }
	cascader_menu_component.options.__file = "packages/cascader-panel/src/cascader-menu.vue"
	/* harmony default export */ var cascader_menu = (cascader_menu_component.exports);
	// EXTERNAL MODULE: external "element-ui/lib/utils/shared"
	var shared_ = __webpack_require__(21);
	
	// CONCATENATED MODULE: ./packages/cascader-panel/src/node.js
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	
	
	
	var uid = 0;
	
	var node_Node = function () {
	  function Node(data, config, parentNode) {
	    _classCallCheck(this, Node);
	
	    this.data = data;
	    this.config = config;
	    this.parent = parentNode || null;
	    this.level = !this.parent ? 1 : this.parent.level + 1;
	    this.uid = uid++;
	
	    this.initState();
	    this.initChildren();
	  }
	
	  Node.prototype.initState = function initState() {
	    var _config = this.config,
	        valueKey = _config.value,
	        labelKey = _config.label;
	
	
	    this.value = this.data[valueKey];
	    this.label = this.data[labelKey];
	    this.pathNodes = this.calculatePathNodes();
	    this.path = this.pathNodes.map(function (node) {
	      return node.value;
	    });
	    this.pathLabels = this.pathNodes.map(function (node) {
	      return node.label;
	    });
	
	    // lazy load
	    this.loading = false;
	    this.loaded = false;
	  };
	
	  Node.prototype.initChildren = function initChildren() {
	    var _this = this;
	
	    var config = this.config;
	
	    var childrenKey = config.children;
	    var childrenData = this.data[childrenKey];
	    this.hasChildren = Array.isArray(childrenData);
	    this.children = (childrenData || []).map(function (child) {
	      return new Node(child, config, _this);
	    });
	  };
	
	  Node.prototype.calculatePathNodes = function calculatePathNodes() {
	    var nodes = [this];
	    var parent = this.parent;
	
	    while (parent) {
	      nodes.unshift(parent);
	      parent = parent.parent;
	    }
	
	    return nodes;
	  };
	
	  Node.prototype.getPath = function getPath() {
	    return this.path;
	  };
	
	  Node.prototype.getValue = function getValue() {
	    return this.value;
	  };
	
	  Node.prototype.getValueByOption = function getValueByOption() {
	    return this.config.emitPath ? this.getPath() : this.getValue();
	  };
	
	  Node.prototype.getText = function getText(allLevels, separator) {
	    return allLevels ? this.pathLabels.join(separator) : this.label;
	  };
	
	  Node.prototype.isSameNode = function isSameNode(checkedValue) {
	    var value = this.getValueByOption();
	    return this.config.multiple && Array.isArray(checkedValue) ? checkedValue.some(function (val) {
	      return Object(util_["isEqual"])(val, value);
	    }) : Object(util_["isEqual"])(checkedValue, value);
	  };
	
	  Node.prototype.broadcast = function broadcast(event) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var handlerName = 'onParent' + Object(util_["capitalize"])(event);
	
	    this.children.forEach(function (child) {
	      if (child) {
	        // bottom up
	        child.broadcast.apply(child, [event].concat(args));
	        child[handlerName] && child[handlerName].apply(child, args);
	      }
	    });
	  };
	
	  Node.prototype.emit = function emit(event) {
	    var parent = this.parent;
	
	    var handlerName = 'onChild' + Object(util_["capitalize"])(event);
	    if (parent) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	        args[_key2 - 1] = arguments[_key2];
	      }
	
	      parent[handlerName] && parent[handlerName].apply(parent, args);
	      parent.emit.apply(parent, [event].concat(args));
	    }
	  };
	
	  Node.prototype.onParentCheck = function onParentCheck(checked) {
	    if (!this.isDisabled) {
	      this.setCheckState(checked);
	    }
	  };
	
	  Node.prototype.onChildCheck = function onChildCheck() {
	    var children = this.children;
	
	    var validChildren = children.filter(function (child) {
	      return !child.isDisabled;
	    });
	    var checked = validChildren.length ? validChildren.every(function (child) {
	      return child.checked;
	    }) : false;
	
	    this.setCheckState(checked);
	  };
	
	  Node.prototype.setCheckState = function setCheckState(checked) {
	    var totalNum = this.children.length;
	    var checkedNum = this.children.reduce(function (c, p) {
	      var num = p.checked ? 1 : p.indeterminate ? 0.5 : 0;
	      return c + num;
	    }, 0);
	
	    this.checked = checked;
	    this.indeterminate = checkedNum !== totalNum && checkedNum > 0;
	  };
	
	  Node.prototype.syncCheckState = function syncCheckState(checkedValue) {
	    var value = this.getValueByOption();
	    var checked = this.isSameNode(checkedValue, value);
	
	    this.doCheck(checked);
	  };
	
	  Node.prototype.doCheck = function doCheck(checked) {
	    if (this.checked !== checked) {
	      if (this.config.checkStrictly) {
	        this.checked = checked;
	      } else {
	        // bottom up to unify the calculation of the indeterminate state
	        this.broadcast('check', checked);
	        this.setCheckState(checked);
	        this.emit('check');
	      }
	    }
	  };
	
	  _createClass(Node, [{
	    key: 'isDisabled',
	    get: function get() {
	      var data = this.data,
	          parent = this.parent,
	          config = this.config;
	
	      var disabledKey = config.disabled;
	      var checkStrictly = config.checkStrictly;
	
	      return data[disabledKey] || !checkStrictly && parent && parent.isDisabled;
	    }
	  }, {
	    key: 'isLeaf',
	    get: function get() {
	      var data = this.data,
	          loaded = this.loaded,
	          hasChildren = this.hasChildren,
	          children = this.children;
	      var _config2 = this.config,
	          lazy = _config2.lazy,
	          leafKey = _config2.leaf;
	
	      if (lazy) {
	        var isLeaf = Object(shared_["isDef"])(data[leafKey]) ? data[leafKey] : loaded ? !children.length : false;
	        this.hasChildren = !isLeaf;
	        return isLeaf;
	      }
	      return !hasChildren;
	    }
	  }]);
	
	  return Node;
	}();
	
	/* harmony default export */ var src_node = (node_Node);
	// CONCATENATED MODULE: ./packages/cascader-panel/src/store.js
	function store_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	
	
	
	var flatNodes = function flatNodes(data, leafOnly) {
	  return data.reduce(function (res, node) {
	    if (node.isLeaf) {
	      res.push(node);
	    } else {
	      !leafOnly && res.push(node);
	      res = res.concat(flatNodes(node.children, leafOnly));
	    }
	    return res;
	  }, []);
	};
	
	var store_Store = function () {
	  function Store(data, config) {
	    store_classCallCheck(this, Store);
	
	    this.config = config;
	    this.initNodes(data);
	  }
	
	  Store.prototype.initNodes = function initNodes(data) {
	    var _this = this;
	
	    data = Object(util_["coerceTruthyValueToArray"])(data);
	    this.nodes = data.map(function (nodeData) {
	      return new src_node(nodeData, _this.config);
	    });
	    this.flattedNodes = this.getFlattedNodes(false, false);
	    this.leafNodes = this.getFlattedNodes(true, false);
	  };
	
	  Store.prototype.appendNode = function appendNode(nodeData, parentNode) {
	    var node = new src_node(nodeData, this.config, parentNode);
	    var children = parentNode ? parentNode.children : this.nodes;
	
	    children.push(node);
	  };
	
	  Store.prototype.appendNodes = function appendNodes(nodeDataList, parentNode) {
	    var _this2 = this;
	
	    nodeDataList = Object(util_["coerceTruthyValueToArray"])(nodeDataList);
	    nodeDataList.forEach(function (nodeData) {
	      return _this2.appendNode(nodeData, parentNode);
	    });
	  };
	
	  Store.prototype.getNodes = function getNodes() {
	    return this.nodes;
	  };
	
	  Store.prototype.getFlattedNodes = function getFlattedNodes(leafOnly) {
	    var cached = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    var cachedNodes = leafOnly ? this.leafNodes : this.flattedNodes;
	    return cached ? cachedNodes : flatNodes(this.nodes, leafOnly);
	  };
	
	  Store.prototype.getNodeByValue = function getNodeByValue(value) {
	    if (value) {
	      var nodes = this.getFlattedNodes(false, !this.config.lazy).filter(function (node) {
	        return Object(util_["valueEquals"])(node.path, value) || node.value === value;
	      });
	      return nodes && nodes.length ? nodes[0] : null;
	    }
	    return null;
	  };
	
	  return Store;
	}();
	
	/* harmony default export */ var src_store = (store_Store);
	// EXTERNAL MODULE: external "element-ui/lib/utils/merge"
	var merge_ = __webpack_require__(9);
	var merge_default = /*#__PURE__*/__webpack_require__.n(merge_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/aria-utils"
	var aria_utils_ = __webpack_require__(32);
	var aria_utils_default = /*#__PURE__*/__webpack_require__.n(aria_utils_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/scroll-into-view"
	var scroll_into_view_ = __webpack_require__(31);
	var scroll_into_view_default = /*#__PURE__*/__webpack_require__.n(scroll_into_view_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader-panel/src/cascader-panel.vue?vue&type=script&lang=js&
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	
	var KeyCode = aria_utils_default.a.keys;
	
	var DefaultProps = {
	  expandTrigger: 'click', // or hover
	  multiple: false,
	  checkStrictly: false, // whether all nodes can be selected
	  emitPath: true, // wether to emit an array of all levels value in which node is located
	  lazy: false,
	  lazyLoad: util_["noop"],
	  value: 'value',
	  label: 'label',
	  children: 'children',
	  leaf: 'leaf',
	  disabled: 'disabled',
	  hoverThreshold: 500
	};
	
	var cascader_panelvue_type_script_lang_js_isLeaf = function isLeaf(el) {
	  return !el.getAttribute('aria-owns');
	};
	
	var getSibling = function getSibling(el, distance) {
	  var parentNode = el.parentNode;
	
	  if (parentNode) {
	    var siblings = parentNode.querySelectorAll('.el-cascader-node[tabindex="-1"]');
	    var index = Array.prototype.indexOf.call(siblings, el);
	    return siblings[index + distance] || null;
	  }
	  return null;
	};
	
	var getMenuIndex = function getMenuIndex(el, distance) {
	  if (!el) return;
	  var pieces = el.id.split('-');
	  return Number(pieces[pieces.length - 2]);
	};
	
	var focusNode = function focusNode(el) {
	  if (!el) return;
	  el.focus();
	  !cascader_panelvue_type_script_lang_js_isLeaf(el) && el.click();
	};
	
	var checkNode = function checkNode(el) {
	  if (!el) return;
	
	  var input = el.querySelector('input');
	  if (input) {
	    input.click();
	  } else if (cascader_panelvue_type_script_lang_js_isLeaf(el)) {
	    el.click();
	  }
	};
	
	/* harmony default export */ var cascader_panelvue_type_script_lang_js_ = ({
	  name: 'ElCascaderPanel',
	
	  components: {
	    CascaderMenu: cascader_menu
	  },
	
	  props: {
	    value: {},
	    options: Array,
	    props: Object,
	    border: {
	      type: Boolean,
	      default: true
	    },
	    renderLabel: Function
	  },
	
	  provide: function provide() {
	    return {
	      panel: this
	    };
	  },
	  data: function data() {
	    return {
	      checkedValue: null,
	      checkedNodePaths: [],
	      store: [],
	      menus: [],
	      activePath: [],
	      loadCount: 0
	    };
	  },
	
	
	  computed: {
	    config: function config() {
	      return merge_default()(_extends({}, DefaultProps), this.props || {});
	    },
	    multiple: function multiple() {
	      return this.config.multiple;
	    },
	    checkStrictly: function checkStrictly() {
	      return this.config.checkStrictly;
	    },
	    leafOnly: function leafOnly() {
	      return !this.checkStrictly;
	    },
	    isHoverMenu: function isHoverMenu() {
	      return this.config.expandTrigger === 'hover';
	    },
	    renderLabelFn: function renderLabelFn() {
	      return this.renderLabel || this.$scopedSlots.default;
	    }
	  },
	
	  watch: {
	    options: {
	      handler: function handler() {
	        this.initStore();
	      },
	      immediate: true,
	      deep: true
	    },
	    value: function value() {
	      this.syncCheckedValue();
	      this.checkStrictly && this.calculateCheckedNodePaths();
	    },
	    checkedValue: function checkedValue(val) {
	      if (!Object(util_["isEqual"])(val, this.value)) {
	        this.checkStrictly && this.calculateCheckedNodePaths();
	        this.$emit('input', val);
	        this.$emit('change', val);
	      }
	    }
	  },
	
	  mounted: function mounted() {
	    if (!Object(util_["isEmpty"])(this.value)) {
	      this.syncCheckedValue();
	    }
	  },
	
	
	  methods: {
	    initStore: function initStore() {
	      var config = this.config,
	          options = this.options;
	
	      if (config.lazy && Object(util_["isEmpty"])(options)) {
	        this.lazyLoad();
	      } else {
	        this.store = new src_store(options, config);
	        this.menus = [this.store.getNodes()];
	        this.syncMenuState();
	      }
	    },
	    syncCheckedValue: function syncCheckedValue() {
	      var value = this.value,
	          checkedValue = this.checkedValue;
	
	      if (!Object(util_["isEqual"])(value, checkedValue)) {
	        this.checkedValue = value;
	        this.syncMenuState();
	      }
	    },
	    syncMenuState: function syncMenuState() {
	      var multiple = this.multiple,
	          checkStrictly = this.checkStrictly;
	
	      this.syncActivePath();
	      multiple && this.syncMultiCheckState();
	      checkStrictly && this.calculateCheckedNodePaths();
	      this.$nextTick(this.scrollIntoView);
	    },
	    syncMultiCheckState: function syncMultiCheckState() {
	      var _this = this;
	
	      var nodes = this.getFlattedNodes(this.leafOnly);
	
	      nodes.forEach(function (node) {
	        node.syncCheckState(_this.checkedValue);
	      });
	    },
	    syncActivePath: function syncActivePath() {
	      var _this2 = this;
	
	      var store = this.store,
	          multiple = this.multiple,
	          activePath = this.activePath,
	          checkedValue = this.checkedValue;
	
	
	      if (!Object(util_["isEmpty"])(activePath)) {
	        var nodes = activePath.map(function (node) {
	          return _this2.getNodeByValue(node.getValue());
	        });
	        this.expandNodes(nodes);
	      } else if (!Object(util_["isEmpty"])(checkedValue)) {
	        var value = multiple ? checkedValue[0] : checkedValue;
	        var checkedNode = this.getNodeByValue(value) || {};
	        var _nodes = (checkedNode.pathNodes || []).slice(0, -1);
	        this.expandNodes(_nodes);
	      } else {
	        this.activePath = [];
	        this.menus = [store.getNodes()];
	      }
	    },
	    expandNodes: function expandNodes(nodes) {
	      var _this3 = this;
	
	      nodes.forEach(function (node) {
	        return _this3.handleExpand(node, true /* silent */);
	      });
	    },
	    calculateCheckedNodePaths: function calculateCheckedNodePaths() {
	      var _this4 = this;
	
	      var checkedValue = this.checkedValue,
	          multiple = this.multiple;
	
	      var checkedValues = multiple ? Object(util_["coerceTruthyValueToArray"])(checkedValue) : [checkedValue];
	      this.checkedNodePaths = checkedValues.map(function (v) {
	        var checkedNode = _this4.getNodeByValue(v);
	        return checkedNode ? checkedNode.pathNodes : [];
	      });
	    },
	    handleKeyDown: function handleKeyDown(e) {
	      var target = e.target,
	          keyCode = e.keyCode;
	
	
	      switch (keyCode) {
	        case KeyCode.up:
	          var prev = getSibling(target, -1);
	          focusNode(prev);
	          break;
	        case KeyCode.down:
	          var next = getSibling(target, 1);
	          focusNode(next);
	          break;
	        case KeyCode.left:
	          var preMenu = this.$refs.menu[getMenuIndex(target) - 1];
	          if (preMenu) {
	            var expandedNode = preMenu.$el.querySelector('.el-cascader-node[aria-expanded="true"]');
	            focusNode(expandedNode);
	          }
	          break;
	        case KeyCode.right:
	          var nextMenu = this.$refs.menu[getMenuIndex(target) + 1];
	          if (nextMenu) {
	            var firstNode = nextMenu.$el.querySelector('.el-cascader-node[tabindex="-1"]');
	            focusNode(firstNode);
	          }
	          break;
	        case KeyCode.enter:
	          checkNode(target);
	          break;
	        case KeyCode.esc:
	        case KeyCode.tab:
	          this.$emit('close');
	          break;
	        default:
	          return;
	      }
	    },
	    handleExpand: function handleExpand(node, silent) {
	      var activePath = this.activePath;
	      var level = node.level;
	
	      var path = activePath.slice(0, level - 1);
	      var menus = this.menus.slice(0, level);
	
	      if (!node.isLeaf) {
	        path.push(node);
	        menus.push(node.children);
	      }
	
	      this.activePath = path;
	      this.menus = menus;
	
	      if (!silent) {
	        var pathValues = path.map(function (node) {
	          return node.getValue();
	        });
	        var activePathValues = activePath.map(function (node) {
	          return node.getValue();
	        });
	        if (!Object(util_["valueEquals"])(pathValues, activePathValues)) {
	          this.$emit('active-item-change', pathValues); // Deprecated
	          this.$emit('expand-change', pathValues);
	        }
	      }
	    },
	    handleCheckChange: function handleCheckChange(value) {
	      this.checkedValue = value;
	    },
	    lazyLoad: function lazyLoad(node, onFullfiled) {
	      var _this5 = this;
	
	      var config = this.config;
	
	      if (!node) {
	        node = node || { root: true, level: 0 };
	        this.store = new src_store([], config);
	        this.menus = [this.store.getNodes()];
	      }
	      node.loading = true;
	      var resolve = function resolve(dataList) {
	        var parent = node.root ? null : node;
	        dataList && dataList.length && _this5.store.appendNodes(dataList, parent);
	        node.loading = false;
	        node.loaded = true;
	
	        // dispose default value on lazy load mode
	        if (Array.isArray(_this5.checkedValue)) {
	          var nodeValue = _this5.checkedValue[_this5.loadCount++];
	          var valueKey = _this5.config.value;
	          var leafKey = _this5.config.leaf;
	
	          if (Array.isArray(dataList) && dataList.filter(function (item) {
	            return item[valueKey] === nodeValue;
	          }).length > 0) {
	            var checkedNode = _this5.store.getNodeByValue(nodeValue);
	
	            if (!checkedNode.data[leafKey]) {
	              _this5.lazyLoad(checkedNode, function () {
	                _this5.handleExpand(checkedNode);
	              });
	            }
	
	            if (_this5.loadCount === _this5.checkedValue.length) {
	              _this5.$parent.computePresentText();
	            }
	          }
	        }
	
	        onFullfiled && onFullfiled(dataList);
	      };
	      config.lazyLoad(node, resolve);
	    },
	
	
	    /**
	     * public methods
	    */
	    calculateMultiCheckedValue: function calculateMultiCheckedValue() {
	      this.checkedValue = this.getCheckedNodes(this.leafOnly).map(function (node) {
	        return node.getValueByOption();
	      });
	    },
	    scrollIntoView: function scrollIntoView() {
	      if (this.$isServer) return;
	
	      var menus = this.$refs.menu || [];
	      menus.forEach(function (menu) {
	        var menuElement = menu.$el;
	        if (menuElement) {
	          var container = menuElement.querySelector('.el-scrollbar__wrap');
	          var activeNode = menuElement.querySelector('.el-cascader-node.is-active') || menuElement.querySelector('.el-cascader-node.in-active-path');
	          scroll_into_view_default()(container, activeNode);
	        }
	      });
	    },
	    getNodeByValue: function getNodeByValue(val) {
	      return this.store.getNodeByValue(val);
	    },
	    getFlattedNodes: function getFlattedNodes(leafOnly) {
	      var cached = !this.config.lazy;
	      return this.store.getFlattedNodes(leafOnly, cached);
	    },
	    getCheckedNodes: function getCheckedNodes(leafOnly) {
	      var checkedValue = this.checkedValue,
	          multiple = this.multiple;
	
	      if (multiple) {
	        var nodes = this.getFlattedNodes(leafOnly);
	        return nodes.filter(function (node) {
	          return node.checked;
	        });
	      } else {
	        return Object(util_["isEmpty"])(checkedValue) ? [] : [this.getNodeByValue(checkedValue)];
	      }
	    },
	    clearCheckedNodes: function clearCheckedNodes() {
	      var config = this.config,
	          leafOnly = this.leafOnly;
	      var multiple = config.multiple,
	          emitPath = config.emitPath;
	
	      if (multiple) {
	        this.getCheckedNodes(leafOnly).filter(function (node) {
	          return !node.isDisabled;
	        }).forEach(function (node) {
	          return node.doCheck(false);
	        });
	        this.calculateMultiCheckedValue();
	      } else {
	        this.checkedValue = emitPath ? [] : null;
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-panel.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_cascader_panelvue_type_script_lang_js_ = (cascader_panelvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-panel.vue
	
	
	
	
	
	/* normalize component */
	
	var cascader_panel_component = Object(componentNormalizer["a" /* default */])(
	  src_cascader_panelvue_type_script_lang_js_,
	  cascader_panelvue_type_template_id_34932346_render,
	  staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var cascader_panel_api; }
	cascader_panel_component.options.__file = "packages/cascader-panel/src/cascader-panel.vue"
	/* harmony default export */ var cascader_panel = (cascader_panel_component.exports);
	// CONCATENATED MODULE: ./packages/cascader-panel/index.js
	
	
	/* istanbul ignore next */
	cascader_panel.install = function (Vue) {
	  Vue.component(cascader_panel.name, cascader_panel);
	};
	
	/* harmony default export */ var packages_cascader_panel = __webpack_exports__["default"] = (cascader_panel);
	
	/***/ }),
	
	/***/ 6:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(127);
	
	/***/ }),
	
	/***/ 9:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(91);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 86);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
	/* globals __VUE_SSR_CONTEXT__ */
	
	// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
	// This module is a runtime utility for cleaner component module output and will
	// be included in the final webpack user bundle.
	
	function normalizeComponent (
	  scriptExports,
	  render,
	  staticRenderFns,
	  functionalTemplate,
	  injectStyles,
	  scopeId,
	  moduleIdentifier, /* server only */
	  shadowMode /* vue-cli only */
	) {
	  // Vue.extend constructor export interop
	  var options = typeof scriptExports === 'function'
	    ? scriptExports.options
	    : scriptExports
	
	  // render functions
	  if (render) {
	    options.render = render
	    options.staticRenderFns = staticRenderFns
	    options._compiled = true
	  }
	
	  // functional template
	  if (functionalTemplate) {
	    options.functional = true
	  }
	
	  // scopedId
	  if (scopeId) {
	    options._scopeId = 'data-v-' + scopeId
	  }
	
	  var hook
	  if (moduleIdentifier) { // server build
	    hook = function (context) {
	      // 2.3 injection
	      context =
	        context || // cached call
	        (this.$vnode && this.$vnode.ssrContext) || // stateful
	        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
	      // 2.2 with runInNewContext: true
	      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
	        context = __VUE_SSR_CONTEXT__
	      }
	      // inject component styles
	      if (injectStyles) {
	        injectStyles.call(this, context)
	      }
	      // register component module identifier for async chunk inferrence
	      if (context && context._registeredComponents) {
	        context._registeredComponents.add(moduleIdentifier)
	      }
	    }
	    // used by ssr in case component is cached and beforeCreate
	    // never gets called
	    options._ssrRegister = hook
	  } else if (injectStyles) {
	    hook = shadowMode
	      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
	      : injectStyles
	  }
	
	  if (hook) {
	    if (options.functional) {
	      // for template-only hot-reload because in that case the render fn doesn't
	      // go through the normalizer
	      options._injectStyles = hook
	      // register for functioal component in vue file
	      var originalRender = options.render
	      options.render = function renderWithStyleInjection (h, context) {
	        hook.call(context)
	        return originalRender(h, context)
	      }
	    } else {
	      // inject component registration as beforeCreate hook
	      var existing = options.beforeCreate
	      options.beforeCreate = existing
	        ? [].concat(existing, hook)
	        : [hook]
	    }
	  }
	
	  return {
	    exports: scriptExports,
	    options: options
	  }
	}
	
	
	/***/ }),
	
	/***/ 4:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(54);
	
	/***/ }),
	
	/***/ 86:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox-group.vue?vue&type=template&id=7289a290&
	var render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-checkbox-group",
	      attrs: { role: "group", "aria-label": "checkbox-group" }
	    },
	    [_vm._t("default")],
	    2
	  )
	}
	var staticRenderFns = []
	render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/checkbox/src/checkbox-group.vue?vue&type=template&id=7289a290&
	
	// EXTERNAL MODULE: external "element-ui/lib/mixins/emitter"
	var emitter_ = __webpack_require__(4);
	var emitter_default = /*#__PURE__*/__webpack_require__.n(emitter_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox-group.vue?vue&type=script&lang=js&
	
	
	
	/* harmony default export */ var checkbox_groupvue_type_script_lang_js_ = ({
	  name: 'ElCheckboxGroup',
	
	  componentName: 'ElCheckboxGroup',
	
	  mixins: [emitter_default.a],
	
	  inject: {
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  props: {
	    value: {},
	    disabled: Boolean,
	    min: Number,
	    max: Number,
	    size: String,
	    fill: String,
	    textColor: String
	  },
	
	  computed: {
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    checkboxGroupSize: function checkboxGroupSize() {
	      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
	    }
	  },
	
	  watch: {
	    value: function value(_value) {
	      this.dispatch('ElFormItem', 'el.form.change', [_value]);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/checkbox/src/checkbox-group.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_checkbox_groupvue_type_script_lang_js_ = (checkbox_groupvue_type_script_lang_js_); 
	// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
	var componentNormalizer = __webpack_require__(0);
	
	// CONCATENATED MODULE: ./packages/checkbox/src/checkbox-group.vue
	
	
	
	
	
	/* normalize component */
	
	var component = Object(componentNormalizer["a" /* default */])(
	  src_checkbox_groupvue_type_script_lang_js_,
	  render,
	  staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var api; }
	component.options.__file = "packages/checkbox/src/checkbox-group.vue"
	/* harmony default export */ var checkbox_group = (component.exports);
	// CONCATENATED MODULE: ./packages/checkbox-group/index.js
	
	
	/* istanbul ignore next */
	checkbox_group.install = function (Vue) {
	  Vue.component(checkbox_group.name, checkbox_group);
	};
	
	/* harmony default export */ var packages_checkbox_group = __webpack_exports__["default"] = (checkbox_group);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 45);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(398);
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(42);
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(38);
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(54);
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(127);
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(93);
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(20);
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(91);
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(125);
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(175);
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(178);
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(90);
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(383);
	
	/***/ }),
	/* 13 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(130);
	
	/***/ }),
	/* 14 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(180);
	
	/***/ }),
	/* 15 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(94);
	
	/***/ }),
	/* 16 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(174);
	
	/***/ }),
	/* 17 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(128);
	
	/***/ }),
	/* 18 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(181);
	
	/***/ }),
	/* 19 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(92);
	
	/***/ }),
	/* 20 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(179);
	
	/***/ }),
	/* 21 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(395);
	
	/***/ }),
	/* 22 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(126);
	
	/***/ }),
	/* 23 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(401);
	
	/***/ }),
	/* 24 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(141);
	
	/***/ }),
	/* 25 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(134);
	
	/***/ }),
	/* 26 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(394);
	
	/***/ }),
	/* 27 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(131);
	
	/***/ }),
	/* 28 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(129);
	
	/***/ }),
	/* 29 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(382);
	
	/***/ }),
	/* 30 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(177);
	
	/***/ }),
	/* 31 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(132);
	
	/***/ }),
	/* 32 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(385);
	
	/***/ }),
	/* 33 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(396);
	
	/***/ }),
	/* 34 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(392);
	
	/***/ }),
	/* 35 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(464);
	
	/***/ }),
	/* 36 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(393);
	
	/***/ }),
	/* 37 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(390);
	
	/***/ }),
	/* 38 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(451);
	
	/***/ }),
	/* 39 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(397);
	
	/***/ }),
	/* 40 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(185);
	
	/***/ }),
	/* 41 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(387);
	
	/***/ }),
	/* 42 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(384);
	
	/***/ }),
	/* 43 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(176);
	
	/***/ }),
	/* 44 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(391);
	
	/***/ }),
	/* 45 */
	/***/ (function(module, exports, __webpack_require__) {
	
	module.exports = __webpack_require__(46);
	
	
	/***/ }),
	/* 46 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/pagination/src/pager.vue?vue&type=template&id=7274f267&
	var pagervue_type_template_id_7274f267_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "ul",
	    { staticClass: "el-pager", on: { click: _vm.onPagerClick } },
	    [
	      _vm.pageCount > 0
	        ? _c(
	            "li",
	            {
	              staticClass: "number",
	              class: { active: _vm.currentPage === 1, disabled: _vm.disabled }
	            },
	            [_vm._v("1")]
	          )
	        : _vm._e(),
	      _vm.showPrevMore
	        ? _c("li", {
	            staticClass: "el-icon more btn-quickprev",
	            class: [_vm.quickprevIconClass, { disabled: _vm.disabled }],
	            on: {
	              mouseenter: function($event) {
	                _vm.onMouseenter("left")
	              },
	              mouseleave: function($event) {
	                _vm.quickprevIconClass = "el-icon-more"
	              }
	            }
	          })
	        : _vm._e(),
	      _vm._l(_vm.pagers, function(pager) {
	        return _c(
	          "li",
	          {
	            key: pager,
	            staticClass: "number",
	            class: { active: _vm.currentPage === pager, disabled: _vm.disabled }
	          },
	          [_vm._v(_vm._s(pager))]
	        )
	      }),
	      _vm.showNextMore
	        ? _c("li", {
	            staticClass: "el-icon more btn-quicknext",
	            class: [_vm.quicknextIconClass, { disabled: _vm.disabled }],
	            on: {
	              mouseenter: function($event) {
	                _vm.onMouseenter("right")
	              },
	              mouseleave: function($event) {
	                _vm.quicknextIconClass = "el-icon-more"
	              }
	            }
	          })
	        : _vm._e(),
	      _vm.pageCount > 1
	        ? _c(
	            "li",
	            {
	              staticClass: "number",
	              class: {
	                active: _vm.currentPage === _vm.pageCount,
	                disabled: _vm.disabled
	              }
	            },
	            [_vm._v(_vm._s(_vm.pageCount))]
	          )
	        : _vm._e()
	    ],
	    2
	  )
	}
	var staticRenderFns = []
	pagervue_type_template_id_7274f267_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/pagination/src/pager.vue?vue&type=template&id=7274f267&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/pagination/src/pager.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var pagervue_type_script_lang_js_ = ({
	  name: 'ElPager',
	
	  props: {
	    currentPage: Number,
	
	    pageCount: Number,
	
	    pagerCount: Number,
	
	    disabled: Boolean
	  },
	
	  watch: {
	    showPrevMore: function showPrevMore(val) {
	      if (!val) this.quickprevIconClass = 'el-icon-more';
	    },
	    showNextMore: function showNextMore(val) {
	      if (!val) this.quicknextIconClass = 'el-icon-more';
	    }
	  },
	
	  methods: {
	    onPagerClick: function onPagerClick(event) {
	      var target = event.target;
	      if (target.tagName === 'UL' || this.disabled) {
	        return;
	      }
	
	      var newPage = Number(event.target.textContent);
	      var pageCount = this.pageCount;
	      var currentPage = this.currentPage;
	      var pagerCountOffset = this.pagerCount - 2;
	
	      if (target.className.indexOf('more') !== -1) {
	        if (target.className.indexOf('quickprev') !== -1) {
	          newPage = currentPage - pagerCountOffset;
	        } else if (target.className.indexOf('quicknext') !== -1) {
	          newPage = currentPage + pagerCountOffset;
	        }
	      }
	
	      /* istanbul ignore if */
	      if (!isNaN(newPage)) {
	        if (newPage < 1) {
	          newPage = 1;
	        }
	
	        if (newPage > pageCount) {
	          newPage = pageCount;
	        }
	      }
	
	      if (newPage !== currentPage) {
	        this.$emit('change', newPage);
	      }
	    },
	    onMouseenter: function onMouseenter(direction) {
	      if (this.disabled) return;
	      if (direction === 'left') {
	        this.quickprevIconClass = 'el-icon-d-arrow-left';
	      } else {
	        this.quicknextIconClass = 'el-icon-d-arrow-right';
	      }
	    }
	  },
	
	  computed: {
	    pagers: function pagers() {
	      var pagerCount = this.pagerCount;
	      var halfPagerCount = (pagerCount - 1) / 2;
	
	      var currentPage = Number(this.currentPage);
	      var pageCount = Number(this.pageCount);
	
	      var showPrevMore = false;
	      var showNextMore = false;
	
	      if (pageCount > pagerCount) {
	        if (currentPage > pagerCount - halfPagerCount) {
	          showPrevMore = true;
	        }
	
	        if (currentPage < pageCount - halfPagerCount) {
	          showNextMore = true;
	        }
	      }
	
	      var array = [];
	
	      if (showPrevMore && !showNextMore) {
	        var startPage = pageCount - (pagerCount - 2);
	        for (var i = startPage; i < pageCount; i++) {
	          array.push(i);
	        }
	      } else if (!showPrevMore && showNextMore) {
	        for (var _i = 2; _i < pagerCount; _i++) {
	          array.push(_i);
	        }
	      } else if (showPrevMore && showNextMore) {
	        var offset = Math.floor(pagerCount / 2) - 1;
	        for (var _i2 = currentPage - offset; _i2 <= currentPage + offset; _i2++) {
	          array.push(_i2);
	        }
	      } else {
	        for (var _i3 = 2; _i3 < pageCount; _i3++) {
	          array.push(_i3);
	        }
	      }
	
	      this.showPrevMore = showPrevMore;
	      this.showNextMore = showNextMore;
	
	      return array;
	    }
	  },
	
	  data: function data() {
	    return {
	      current: null,
	      showPrevMore: false,
	      showNextMore: false,
	      quicknextIconClass: 'el-icon-more',
	      quickprevIconClass: 'el-icon-more'
	    };
	  }
	});
	// CONCATENATED MODULE: ./packages/pagination/src/pager.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_pagervue_type_script_lang_js_ = (pagervue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
	/* globals __VUE_SSR_CONTEXT__ */
	
	// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
	// This module is a runtime utility for cleaner component module output and will
	// be included in the final webpack user bundle.
	
	function normalizeComponent (
	  scriptExports,
	  render,
	  staticRenderFns,
	  functionalTemplate,
	  injectStyles,
	  scopeId,
	  moduleIdentifier, /* server only */
	  shadowMode /* vue-cli only */
	) {
	  // Vue.extend constructor export interop
	  var options = typeof scriptExports === 'function'
	    ? scriptExports.options
	    : scriptExports
	
	  // render functions
	  if (render) {
	    options.render = render
	    options.staticRenderFns = staticRenderFns
	    options._compiled = true
	  }
	
	  // functional template
	  if (functionalTemplate) {
	    options.functional = true
	  }
	
	  // scopedId
	  if (scopeId) {
	    options._scopeId = 'data-v-' + scopeId
	  }
	
	  var hook
	  if (moduleIdentifier) { // server build
	    hook = function (context) {
	      // 2.3 injection
	      context =
	        context || // cached call
	        (this.$vnode && this.$vnode.ssrContext) || // stateful
	        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
	      // 2.2 with runInNewContext: true
	      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
	        context = __VUE_SSR_CONTEXT__
	      }
	      // inject component styles
	      if (injectStyles) {
	        injectStyles.call(this, context)
	      }
	      // register component module identifier for async chunk inferrence
	      if (context && context._registeredComponents) {
	        context._registeredComponents.add(moduleIdentifier)
	      }
	    }
	    // used by ssr in case component is cached and beforeCreate
	    // never gets called
	    options._ssrRegister = hook
	  } else if (injectStyles) {
	    hook = shadowMode
	      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
	      : injectStyles
	  }
	
	  if (hook) {
	    if (options.functional) {
	      // for template-only hot-reload because in that case the render fn doesn't
	      // go through the normalizer
	      options._injectStyles = hook
	      // register for functioal component in vue file
	      var originalRender = options.render
	      options.render = function renderWithStyleInjection (h, context) {
	        hook.call(context)
	        return originalRender(h, context)
	      }
	    } else {
	      // inject component registration as beforeCreate hook
	      var existing = options.beforeCreate
	      options.beforeCreate = existing
	        ? [].concat(existing, hook)
	        : [hook]
	    }
	  }
	
	  return {
	    exports: scriptExports,
	    options: options
	  }
	}
	
	// CONCATENATED MODULE: ./packages/pagination/src/pager.vue
	
	
	
	
	
	/* normalize component */
	
	var component = normalizeComponent(
	  src_pagervue_type_script_lang_js_,
	  pagervue_type_template_id_7274f267_render,
	  staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var api; }
	component.options.__file = "packages/pagination/src/pager.vue"
	/* harmony default export */ var pager = (component.exports);
	// EXTERNAL MODULE: external "element-ui/lib/select"
	var select_ = __webpack_require__(36);
	var select_default = /*#__PURE__*/__webpack_require__.n(select_);
	
	// EXTERNAL MODULE: external "element-ui/lib/option"
	var option_ = __webpack_require__(37);
	var option_default = /*#__PURE__*/__webpack_require__.n(option_);
	
	// EXTERNAL MODULE: external "element-ui/lib/input"
	var input_ = __webpack_require__(8);
	var input_default = /*#__PURE__*/__webpack_require__.n(input_);
	
	// EXTERNAL MODULE: external "element-ui/lib/mixins/locale"
	var locale_ = __webpack_require__(4);
	var locale_default = /*#__PURE__*/__webpack_require__.n(locale_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/util"
	var util_ = __webpack_require__(2);
	
	// CONCATENATED MODULE: ./packages/pagination/src/pagination.js
	
	
	
	
	
	
	
	/* harmony default export */ var pagination = ({
	  name: 'ElPagination',
	
	  props: {
	    pageSize: {
	      type: Number,
	      default: 10
	    },
	
	    small: Boolean,
	
	    total: Number,
	
	    pageCount: Number,
	
	    pagerCount: {
	      type: Number,
	      validator: function validator(value) {
	        return (value | 0) === value && value > 4 && value < 22 && value % 2 === 1;
	      },
	
	      default: 7
	    },
	
	    currentPage: {
	      type: Number,
	      default: 1
	    },
	
	    layout: {
	      default: 'prev, pager, next, jumper, ->, total'
	    },
	
	    pageSizes: {
	      type: Array,
	      default: function _default() {
	        return [10, 20, 30, 40, 50, 100];
	      }
	    },
	
	    popperClass: String,
	
	    prevText: String,
	
	    nextText: String,
	
	    background: Boolean,
	
	    disabled: Boolean,
	
	    hideOnSinglePage: Boolean
	  },
	
	  data: function data() {
	    return {
	      internalCurrentPage: 1,
	      internalPageSize: 0,
	      lastEmittedPage: -1,
	      userChangePageSize: false
	    };
	  },
	  render: function render(h) {
	    var layout = this.layout;
	    if (!layout) return null;
	    if (this.hideOnSinglePage && (!this.internalPageCount || this.internalPageCount === 1)) return null;
	
	    var template = h('div', { 'class': ['el-pagination', {
	        'is-background': this.background,
	        'el-pagination--small': this.small
	      }] });
	    var TEMPLATE_MAP = {
	      prev: h('prev'),
	      jumper: h('jumper'),
	      pager: h('pager', {
	        attrs: { currentPage: this.internalCurrentPage, pageCount: this.internalPageCount, pagerCount: this.pagerCount, disabled: this.disabled },
	        on: {
	          'change': this.handleCurrentChange
	        }
	      }),
	      next: h('next'),
	      sizes: h('sizes', {
	        attrs: { pageSizes: this.pageSizes }
	      }),
	      slot: h('slot', [this.$slots.default ? this.$slots.default : '']),
	      total: h('total')
	    };
	    var components = layout.split(',').map(function (item) {
	      return item.trim();
	    });
	    var rightWrapper = h('div', { 'class': 'el-pagination__rightwrapper' });
	    var haveRightWrapper = false;
	
	    template.children = template.children || [];
	    rightWrapper.children = rightWrapper.children || [];
	    components.forEach(function (compo) {
	      if (compo === '->') {
	        haveRightWrapper = true;
	        return;
	      }
	
	      if (!haveRightWrapper) {
	        template.children.push(TEMPLATE_MAP[compo]);
	      } else {
	        rightWrapper.children.push(TEMPLATE_MAP[compo]);
	      }
	    });
	
	    if (haveRightWrapper) {
	      template.children.unshift(rightWrapper);
	    }
	
	    return template;
	  },
	
	
	  components: {
	    Prev: {
	      render: function render(h) {
	        return h(
	          'button',
	          {
	            attrs: {
	              type: 'button',
	
	              disabled: this.$parent.disabled || this.$parent.internalCurrentPage <= 1
	            },
	            'class': 'btn-prev', on: {
	              'click': this.$parent.prev
	            }
	          },
	          [this.$parent.prevText ? h('span', [this.$parent.prevText]) : h('i', { 'class': 'el-icon el-icon-arrow-left' })]
	        );
	      }
	    },
	
	    Next: {
	      render: function render(h) {
	        return h(
	          'button',
	          {
	            attrs: {
	              type: 'button',
	
	              disabled: this.$parent.disabled || this.$parent.internalCurrentPage === this.$parent.internalPageCount || this.$parent.internalPageCount === 0
	            },
	            'class': 'btn-next', on: {
	              'click': this.$parent.next
	            }
	          },
	          [this.$parent.nextText ? h('span', [this.$parent.nextText]) : h('i', { 'class': 'el-icon el-icon-arrow-right' })]
	        );
	      }
	    },
	
	    Sizes: {
	      mixins: [locale_default.a],
	
	      props: {
	        pageSizes: Array
	      },
	
	      watch: {
	        pageSizes: {
	          immediate: true,
	          handler: function handler(newVal, oldVal) {
	            if (Object(util_["valueEquals"])(newVal, oldVal)) return;
	            if (Array.isArray(newVal)) {
	              this.$parent.internalPageSize = newVal.indexOf(this.$parent.pageSize) > -1 ? this.$parent.pageSize : this.pageSizes[0];
	            }
	          }
	        }
	      },
	
	      render: function render(h) {
	        var _this = this;
	
	        return h(
	          'span',
	          { 'class': 'el-pagination__sizes' },
	          [h(
	            'el-select',
	            {
	              attrs: {
	                value: this.$parent.internalPageSize,
	                popperClass: this.$parent.popperClass || '',
	                size: 'mini',
	
	                disabled: this.$parent.disabled },
	              on: {
	                'input': this.handleChange
	              }
	            },
	            [this.pageSizes.map(function (item) {
	              return h('el-option', {
	                attrs: {
	                  value: item,
	                  label: item + _this.t('el.pagination.pagesize') }
	              });
	            })]
	          )]
	        );
	      },
	
	
	      components: {
	        ElSelect: select_default.a,
	        ElOption: option_default.a
	      },
	
	      methods: {
	        handleChange: function handleChange(val) {
	          if (val !== this.$parent.internalPageSize) {
	            this.$parent.internalPageSize = val = parseInt(val, 10);
	            this.$parent.userChangePageSize = true;
	            this.$parent.$emit('update:pageSize', val);
	            this.$parent.$emit('size-change', val);
	          }
	        }
	      }
	    },
	
	    Jumper: {
	      mixins: [locale_default.a],
	
	      components: { ElInput: input_default.a },
	
	      data: function data() {
	        return {
	          userInput: null
	        };
	      },
	
	
	      watch: {
	        '$parent.internalCurrentPage': function $parentInternalCurrentPage() {
	          this.userInput = null;
	        }
	      },
	
	      methods: {
	        handleKeyup: function handleKeyup(_ref) {
	          var keyCode = _ref.keyCode,
	              target = _ref.target;
	
	          // Chrome, Safari, Firefox triggers change event on Enter
	          // Hack for IE: https://github.com/ElemeFE/element/issues/11710
	          // Drop this method when we no longer supports IE
	          if (keyCode === 13) {
	            this.handleChange(target.value);
	          }
	        },
	        handleInput: function handleInput(value) {
	          this.userInput = value;
	        },
	        handleChange: function handleChange(value) {
	          this.$parent.internalCurrentPage = this.$parent.getValidCurrentPage(value);
	          this.$parent.emitChange();
	          this.userInput = null;
	        }
	      },
	
	      render: function render(h) {
	        return h(
	          'span',
	          { 'class': 'el-pagination__jump' },
	          [this.t('el.pagination.goto'), h('el-input', {
	            'class': 'el-pagination__editor is-in-pagination',
	            attrs: { min: 1,
	              max: this.$parent.internalPageCount,
	              value: this.userInput !== null ? this.userInput : this.$parent.internalCurrentPage,
	              type: 'number',
	              disabled: this.$parent.disabled
	            },
	            nativeOn: {
	              'keyup': this.handleKeyup
	            },
	            on: {
	              'input': this.handleInput,
	              'change': this.handleChange
	            }
	          }), this.t('el.pagination.pageClassifier')]
	        );
	      }
	    },
	
	    Total: {
	      mixins: [locale_default.a],
	
	      render: function render(h) {
	        return typeof this.$parent.total === 'number' ? h(
	          'span',
	          { 'class': 'el-pagination__total' },
	          [this.t('el.pagination.total', { total: this.$parent.total })]
	        ) : '';
	      }
	    },
	
	    Pager: pager
	  },
	
	  methods: {
	    handleCurrentChange: function handleCurrentChange(val) {
	      this.internalCurrentPage = this.getValidCurrentPage(val);
	      this.userChangePageSize = true;
	      this.emitChange();
	    },
	    prev: function prev() {
	      if (this.disabled) return;
	      var newVal = this.internalCurrentPage - 1;
	      this.internalCurrentPage = this.getValidCurrentPage(newVal);
	      this.$emit('prev-click', this.internalCurrentPage);
	      this.emitChange();
	    },
	    next: function next() {
	      if (this.disabled) return;
	      var newVal = this.internalCurrentPage + 1;
	      this.internalCurrentPage = this.getValidCurrentPage(newVal);
	      this.$emit('next-click', this.internalCurrentPage);
	      this.emitChange();
	    },
	    getValidCurrentPage: function getValidCurrentPage(value) {
	      value = parseInt(value, 10);
	
	      var havePageCount = typeof this.internalPageCount === 'number';
	
	      var resetValue = void 0;
	      if (!havePageCount) {
	        if (isNaN(value) || value < 1) resetValue = 1;
	      } else {
	        if (value < 1) {
	          resetValue = 1;
	        } else if (value > this.internalPageCount) {
	          resetValue = this.internalPageCount;
	        }
	      }
	
	      if (resetValue === undefined && isNaN(value)) {
	        resetValue = 1;
	      } else if (resetValue === 0) {
	        resetValue = 1;
	      }
	
	      return resetValue === undefined ? value : resetValue;
	    },
	    emitChange: function emitChange() {
	      var _this2 = this;
	
	      this.$nextTick(function () {
	        if (_this2.internalCurrentPage !== _this2.lastEmittedPage || _this2.userChangePageSize) {
	          _this2.$emit('current-change', _this2.internalCurrentPage);
	          _this2.lastEmittedPage = _this2.internalCurrentPage;
	          _this2.userChangePageSize = false;
	        }
	      });
	    }
	  },
	
	  computed: {
	    internalPageCount: function internalPageCount() {
	      if (typeof this.total === 'number') {
	        return Math.max(1, Math.ceil(this.total / this.internalPageSize));
	      } else if (typeof this.pageCount === 'number') {
	        return Math.max(1, this.pageCount);
	      }
	      return null;
	    }
	  },
	
	  watch: {
	    currentPage: {
	      immediate: true,
	      handler: function handler(val) {
	        this.internalCurrentPage = this.getValidCurrentPage(val);
	      }
	    },
	
	    pageSize: {
	      immediate: true,
	      handler: function handler(val) {
	        this.internalPageSize = isNaN(val) ? 10 : val;
	      }
	    },
	
	    internalCurrentPage: {
	      immediate: true,
	      handler: function handler(newVal) {
	        this.$emit('update:currentPage', newVal);
	        this.lastEmittedPage = -1;
	      }
	    },
	
	    internalPageCount: function internalPageCount(newVal) {
	      /* istanbul ignore if */
	      var oldPage = this.internalCurrentPage;
	      if (newVal > 0 && oldPage === 0) {
	        this.internalCurrentPage = 1;
	      } else if (oldPage > newVal) {
	        this.internalCurrentPage = newVal === 0 ? 1 : newVal;
	        this.userChangePageSize && this.emitChange();
	      }
	      this.userChangePageSize = false;
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/pagination/index.js
	
	
	/* istanbul ignore next */
	pagination.install = function (Vue) {
	  Vue.component(pagination.name, pagination);
	};
	
	/* harmony default export */ var packages_pagination = (pagination);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/dialog/src/component.vue?vue&type=template&id=60140e62&
	var componentvue_type_template_id_60140e62_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "transition",
	    {
	      attrs: { name: "dialog-fade" },
	      on: { "after-enter": _vm.afterEnter, "after-leave": _vm.afterLeave }
	    },
	    [
	      _c(
	        "div",
	        {
	          directives: [
	            {
	              name: "show",
	              rawName: "v-show",
	              value: _vm.visible,
	              expression: "visible"
	            }
	          ],
	          staticClass: "el-dialog__wrapper",
	          on: {
	            click: function($event) {
	              if ($event.target !== $event.currentTarget) {
	                return null
	              }
	              return _vm.handleWrapperClick($event)
	            }
	          }
	        },
	        [
	          _c(
	            "div",
	            {
	              key: _vm.key,
	              ref: "dialog",
	              class: [
	                "el-dialog",
	                {
	                  "is-fullscreen": _vm.fullscreen,
	                  "el-dialog--center": _vm.center
	                },
	                _vm.customClass
	              ],
	              style: _vm.style,
	              attrs: {
	                role: "dialog",
	                "aria-modal": "true",
	                "aria-label": _vm.title || "dialog"
	              }
	            },
	            [
	              _c(
	                "div",
	                { staticClass: "el-dialog__header" },
	                [
	                  _vm._t("title", [
	                    _c("span", { staticClass: "el-dialog__title" }, [
	                      _vm._v(_vm._s(_vm.title))
	                    ])
	                  ]),
	                  _vm.showClose
	                    ? _c(
	                        "button",
	                        {
	                          staticClass: "el-dialog__headerbtn",
	                          attrs: { type: "button", "aria-label": "Close" },
	                          on: { click: _vm.handleClose }
	                        },
	                        [
	                          _c("i", {
	                            staticClass:
	                              "el-dialog__close el-icon el-icon-close"
	                          })
	                        ]
	                      )
	                    : _vm._e()
	                ],
	                2
	              ),
	              _vm.rendered
	                ? _c(
	                    "div",
	                    { staticClass: "el-dialog__body" },
	                    [_vm._t("default")],
	                    2
	                  )
	                : _vm._e(),
	              _vm.$slots.footer
	                ? _c(
	                    "div",
	                    { staticClass: "el-dialog__footer" },
	                    [_vm._t("footer")],
	                    2
	                  )
	                : _vm._e()
	            ]
	          )
	        ]
	      )
	    ]
	  )
	}
	var componentvue_type_template_id_60140e62_staticRenderFns = []
	componentvue_type_template_id_60140e62_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/dialog/src/component.vue?vue&type=template&id=60140e62&
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/popup"
	var popup_ = __webpack_require__(14);
	var popup_default = /*#__PURE__*/__webpack_require__.n(popup_);
	
	// EXTERNAL MODULE: external "element-ui/lib/mixins/migrating"
	var migrating_ = __webpack_require__(9);
	var migrating_default = /*#__PURE__*/__webpack_require__.n(migrating_);
	
	// EXTERNAL MODULE: external "element-ui/lib/mixins/emitter"
	var emitter_ = __webpack_require__(3);
	var emitter_default = /*#__PURE__*/__webpack_require__.n(emitter_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/dialog/src/component.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	/* harmony default export */ var componentvue_type_script_lang_js_ = ({
	  name: 'ElDialog',
	
	  mixins: [popup_default.a, emitter_default.a, migrating_default.a],
	
	  props: {
	    title: {
	      type: String,
	      default: ''
	    },
	
	    modal: {
	      type: Boolean,
	      default: true
	    },
	
	    modalAppendToBody: {
	      type: Boolean,
	      default: true
	    },
	
	    appendToBody: {
	      type: Boolean,
	      default: false
	    },
	
	    lockScroll: {
	      type: Boolean,
	      default: true
	    },
	
	    closeOnClickModal: {
	      type: Boolean,
	      default: true
	    },
	
	    closeOnPressEscape: {
	      type: Boolean,
	      default: true
	    },
	
	    showClose: {
	      type: Boolean,
	      default: true
	    },
	
	    width: String,
	
	    fullscreen: Boolean,
	
	    customClass: {
	      type: String,
	      default: ''
	    },
	
	    top: {
	      type: String,
	      default: '15vh'
	    },
	    beforeClose: Function,
	    center: {
	      type: Boolean,
	      default: false
	    },
	
	    destroyOnClose: Boolean
	  },
	
	  data: function data() {
	    return {
	      closed: false,
	      key: 0
	    };
	  },
	
	
	  watch: {
	    visible: function visible(val) {
	      var _this = this;
	
	      if (val) {
	        this.closed = false;
	        this.$emit('open');
	        this.$el.addEventListener('scroll', this.updatePopper);
	        this.$nextTick(function () {
	          _this.$refs.dialog.scrollTop = 0;
	        });
	        if (this.appendToBody) {
	          document.body.appendChild(this.$el);
	        }
	      } else {
	        this.$el.removeEventListener('scroll', this.updatePopper);
	        if (!this.closed) this.$emit('close');
	        if (this.destroyOnClose) {
	          this.$nextTick(function () {
	            _this.key++;
	          });
	        }
	      }
	    }
	  },
	
	  computed: {
	    style: function style() {
	      var style = {};
	      if (!this.fullscreen) {
	        style.marginTop = this.top;
	        if (this.width) {
	          style.width = this.width;
	        }
	      }
	      return style;
	    }
	  },
	
	  methods: {
	    getMigratingConfig: function getMigratingConfig() {
	      return {
	        props: {
	          'size': 'size is removed.'
	        }
	      };
	    },
	    handleWrapperClick: function handleWrapperClick() {
	      if (!this.closeOnClickModal) return;
	      this.handleClose();
	    },
	    handleClose: function handleClose() {
	      if (typeof this.beforeClose === 'function') {
	        this.beforeClose(this.hide);
	      } else {
	        this.hide();
	      }
	    },
	    hide: function hide(cancel) {
	      if (cancel !== false) {
	        this.$emit('update:visible', false);
	        this.$emit('close');
	        this.closed = true;
	      }
	    },
	    updatePopper: function updatePopper() {
	      this.broadcast('ElSelectDropdown', 'updatePopper');
	      this.broadcast('ElDropdownMenu', 'updatePopper');
	    },
	    afterEnter: function afterEnter() {
	      this.$emit('opened');
	    },
	    afterLeave: function afterLeave() {
	      this.$emit('closed');
	    }
	  },
	
	  mounted: function mounted() {
	    if (this.visible) {
	      this.rendered = true;
	      this.open();
	      if (this.appendToBody) {
	        document.body.appendChild(this.$el);
	      }
	    }
	  },
	  destroyed: function destroyed() {
	    // if appendToBody is true, remove DOM node after destroy
	    if (this.appendToBody && this.$el && this.$el.parentNode) {
	      this.$el.parentNode.removeChild(this.$el);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/dialog/src/component.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_componentvue_type_script_lang_js_ = (componentvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/dialog/src/component.vue
	
	
	
	
	
	/* normalize component */
	
	var component_component = normalizeComponent(
	  src_componentvue_type_script_lang_js_,
	  componentvue_type_template_id_60140e62_render,
	  componentvue_type_template_id_60140e62_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var component_api; }
	component_component.options.__file = "packages/dialog/src/component.vue"
	/* harmony default export */ var src_component = (component_component.exports);
	// CONCATENATED MODULE: ./packages/dialog/index.js
	
	
	/* istanbul ignore next */
	src_component.install = function (Vue) {
	  Vue.component(src_component.name, src_component);
	};
	
	/* harmony default export */ var dialog = (src_component);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/autocomplete/src/autocomplete.vue?vue&type=template&id=152f2ee6&
	var autocompletevue_type_template_id_152f2ee6_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      directives: [
	        {
	          name: "clickoutside",
	          rawName: "v-clickoutside",
	          value: _vm.close,
	          expression: "close"
	        }
	      ],
	      staticClass: "el-autocomplete",
	      attrs: {
	        "aria-haspopup": "listbox",
	        role: "combobox",
	        "aria-expanded": _vm.suggestionVisible,
	        "aria-owns": _vm.id
	      }
	    },
	    [
	      _c(
	        "el-input",
	        _vm._b(
	          {
	            ref: "input",
	            on: {
	              input: _vm.handleChange,
	              focus: _vm.handleFocus,
	              blur: _vm.handleBlur,
	              clear: _vm.handleClear
	            },
	            nativeOn: {
	              keydown: [
	                function($event) {
	                  if (
	                    !("button" in $event) &&
	                    _vm._k($event.keyCode, "up", 38, $event.key, [
	                      "Up",
	                      "ArrowUp"
	                    ])
	                  ) {
	                    return null
	                  }
	                  $event.preventDefault()
	                  _vm.highlight(_vm.highlightedIndex - 1)
	                },
	                function($event) {
	                  if (
	                    !("button" in $event) &&
	                    _vm._k($event.keyCode, "down", 40, $event.key, [
	                      "Down",
	                      "ArrowDown"
	                    ])
	                  ) {
	                    return null
	                  }
	                  $event.preventDefault()
	                  _vm.highlight(_vm.highlightedIndex + 1)
	                },
	                function($event) {
	                  if (
	                    !("button" in $event) &&
	                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
	                  ) {
	                    return null
	                  }
	                  return _vm.handleKeyEnter($event)
	                },
	                function($event) {
	                  if (
	                    !("button" in $event) &&
	                    _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
	                  ) {
	                    return null
	                  }
	                  return _vm.close($event)
	                }
	              ]
	            }
	          },
	          "el-input",
	          [_vm.$props, _vm.$attrs],
	          false
	        ),
	        [
	          _vm.$slots.prepend
	            ? _c("template", { slot: "prepend" }, [_vm._t("prepend")], 2)
	            : _vm._e(),
	          _vm.$slots.append
	            ? _c("template", { slot: "append" }, [_vm._t("append")], 2)
	            : _vm._e(),
	          _vm.$slots.prefix
	            ? _c("template", { slot: "prefix" }, [_vm._t("prefix")], 2)
	            : _vm._e(),
	          _vm.$slots.suffix
	            ? _c("template", { slot: "suffix" }, [_vm._t("suffix")], 2)
	            : _vm._e()
	        ],
	        2
	      ),
	      _c(
	        "el-autocomplete-suggestions",
	        {
	          ref: "suggestions",
	          class: [_vm.popperClass ? _vm.popperClass : ""],
	          attrs: {
	            "visible-arrow": "",
	            "popper-options": _vm.popperOptions,
	            "append-to-body": _vm.popperAppendToBody,
	            placement: _vm.placement,
	            id: _vm.id
	          }
	        },
	        _vm._l(_vm.suggestions, function(item, index) {
	          return _c(
	            "li",
	            {
	              key: index,
	              class: { highlighted: _vm.highlightedIndex === index },
	              attrs: {
	                id: _vm.id + "-item-" + index,
	                role: "option",
	                "aria-selected": _vm.highlightedIndex === index
	              },
	              on: {
	                click: function($event) {
	                  _vm.select(item)
	                }
	              }
	            },
	            [
	              _vm._t(
	                "default",
	                [
	                  _vm._v("\n        " + _vm._s(item[_vm.valueKey]) + "\n      ")
	                ],
	                { item: item }
	              )
	            ],
	            2
	          )
	        }),
	        0
	      )
	    ],
	    1
	  )
	}
	var autocompletevue_type_template_id_152f2ee6_staticRenderFns = []
	autocompletevue_type_template_id_152f2ee6_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/autocomplete/src/autocomplete.vue?vue&type=template&id=152f2ee6&
	
	// EXTERNAL MODULE: external "throttle-debounce/debounce"
	var debounce_ = __webpack_require__(15);
	var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/clickoutside"
	var clickoutside_ = __webpack_require__(10);
	var clickoutside_default = /*#__PURE__*/__webpack_require__.n(clickoutside_);
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/autocomplete/src/autocomplete-suggestions.vue?vue&type=template&id=cd10dcf0&
	var autocomplete_suggestionsvue_type_template_id_cd10dcf0_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "transition",
	    { attrs: { name: "el-zoom-in-top" }, on: { "after-leave": _vm.doDestroy } },
	    [
	      _c(
	        "div",
	        {
	          directives: [
	            {
	              name: "show",
	              rawName: "v-show",
	              value: _vm.showPopper,
	              expression: "showPopper"
	            }
	          ],
	          staticClass: "el-autocomplete-suggestion el-popper",
	          class: {
	            "is-loading": !_vm.parent.hideLoading && _vm.parent.loading
	          },
	          style: { width: _vm.dropdownWidth },
	          attrs: { role: "region" }
	        },
	        [
	          _c(
	            "el-scrollbar",
	            {
	              attrs: {
	                tag: "ul",
	                "wrap-class": "el-autocomplete-suggestion__wrap",
	                "view-class": "el-autocomplete-suggestion__list"
	              }
	            },
	            [
	              !_vm.parent.hideLoading && _vm.parent.loading
	                ? _c("li", [_c("i", { staticClass: "el-icon-loading" })])
	                : _vm._t("default")
	            ],
	            2
	          )
	        ],
	        1
	      )
	    ]
	  )
	}
	var autocomplete_suggestionsvue_type_template_id_cd10dcf0_staticRenderFns = []
	autocomplete_suggestionsvue_type_template_id_cd10dcf0_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/autocomplete/src/autocomplete-suggestions.vue?vue&type=template&id=cd10dcf0&
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/vue-popper"
	var vue_popper_ = __webpack_require__(5);
	var vue_popper_default = /*#__PURE__*/__webpack_require__.n(vue_popper_);
	
	// EXTERNAL MODULE: external "element-ui/lib/scrollbar"
	var scrollbar_ = __webpack_require__(17);
	var scrollbar_default = /*#__PURE__*/__webpack_require__.n(scrollbar_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/autocomplete/src/autocomplete-suggestions.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	/* harmony default export */ var autocomplete_suggestionsvue_type_script_lang_js_ = ({
	  components: { ElScrollbar: scrollbar_default.a },
	  mixins: [vue_popper_default.a, emitter_default.a],
	
	  componentName: 'ElAutocompleteSuggestions',
	
	  data: function data() {
	    return {
	      parent: this.$parent,
	      dropdownWidth: ''
	    };
	  },
	
	
	  props: {
	    options: {
	      default: function _default() {
	        return {
	          gpuAcceleration: false
	        };
	      }
	    },
	    id: String
	  },
	
	  methods: {
	    select: function select(item) {
	      this.dispatch('ElAutocomplete', 'item-click', item);
	    }
	  },
	
	  updated: function updated() {
	    var _this = this;
	
	    this.$nextTick(function (_) {
	      _this.popperJS && _this.updatePopper();
	    });
	  },
	  mounted: function mounted() {
	    this.$parent.popperElm = this.popperElm = this.$el;
	    this.referenceElm = this.$parent.$refs.input.$refs.input;
	    this.referenceList = this.$el.querySelector('.el-autocomplete-suggestion__list');
	    this.referenceList.setAttribute('role', 'listbox');
	    this.referenceList.setAttribute('id', this.id);
	  },
	  created: function created() {
	    var _this2 = this;
	
	    this.$on('visible', function (val, inputWidth) {
	      _this2.dropdownWidth = inputWidth + 'px';
	      _this2.showPopper = val;
	    });
	  }
	});
	// CONCATENATED MODULE: ./packages/autocomplete/src/autocomplete-suggestions.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_autocomplete_suggestionsvue_type_script_lang_js_ = (autocomplete_suggestionsvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/autocomplete/src/autocomplete-suggestions.vue
	
	
	
	
	
	/* normalize component */
	
	var autocomplete_suggestions_component = normalizeComponent(
	  src_autocomplete_suggestionsvue_type_script_lang_js_,
	  autocomplete_suggestionsvue_type_template_id_cd10dcf0_render,
	  autocomplete_suggestionsvue_type_template_id_cd10dcf0_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var autocomplete_suggestions_api; }
	autocomplete_suggestions_component.options.__file = "packages/autocomplete/src/autocomplete-suggestions.vue"
	/* harmony default export */ var autocomplete_suggestions = (autocomplete_suggestions_component.exports);
	// EXTERNAL MODULE: external "element-ui/lib/mixins/focus"
	var focus_ = __webpack_require__(22);
	var focus_default = /*#__PURE__*/__webpack_require__.n(focus_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/autocomplete/src/autocomplete.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	
	
	
	/* harmony default export */ var autocompletevue_type_script_lang_js_ = ({
	  name: 'ElAutocomplete',
	
	  mixins: [emitter_default.a, focus_default()('input'), migrating_default.a],
	
	  inheritAttrs: false,
	
	  componentName: 'ElAutocomplete',
	
	  components: {
	    ElInput: input_default.a,
	    ElAutocompleteSuggestions: autocomplete_suggestions
	  },
	
	  directives: { Clickoutside: clickoutside_default.a },
	
	  props: {
	    valueKey: {
	      type: String,
	      default: 'value'
	    },
	    popperClass: String,
	    popperOptions: Object,
	    placeholder: String,
	    clearable: {
	      type: Boolean,
	      default: false
	    },
	    disabled: Boolean,
	    name: String,
	    size: String,
	    value: String,
	    maxlength: Number,
	    minlength: Number,
	    autofocus: Boolean,
	    fetchSuggestions: Function,
	    triggerOnFocus: {
	      type: Boolean,
	      default: true
	    },
	    customItem: String,
	    selectWhenUnmatched: {
	      type: Boolean,
	      default: false
	    },
	    prefixIcon: String,
	    suffixIcon: String,
	    label: String,
	    debounce: {
	      type: Number,
	      default: 300
	    },
	    placement: {
	      type: String,
	      default: 'bottom-start'
	    },
	    hideLoading: Boolean,
	    popperAppendToBody: {
	      type: Boolean,
	      default: true
	    },
	    highlightFirstItem: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      activated: false,
	      suggestions: [],
	      loading: false,
	      highlightedIndex: -1,
	      suggestionDisabled: false
	    };
	  },
	
	  computed: {
	    suggestionVisible: function suggestionVisible() {
	      var suggestions = this.suggestions;
	      var isValidData = Array.isArray(suggestions) && suggestions.length > 0;
	      return (isValidData || this.loading) && this.activated;
	    },
	    id: function id() {
	      return 'el-autocomplete-' + Object(util_["generateId"])();
	    }
	  },
	  watch: {
	    suggestionVisible: function suggestionVisible(val) {
	      var $input = this.getInput();
	      if ($input) {
	        this.broadcast('ElAutocompleteSuggestions', 'visible', [val, $input.offsetWidth]);
	      }
	    }
	  },
	  methods: {
	    getMigratingConfig: function getMigratingConfig() {
	      return {
	        props: {
	          'custom-item': 'custom-item is removed, use scoped slot instead.',
	          'props': 'props is removed, use value-key instead.'
	        }
	      };
	    },
	    getData: function getData(queryString) {
	      var _this = this;
	
	      if (this.suggestionDisabled) {
	        return;
	      }
	      this.loading = true;
	      this.fetchSuggestions(queryString, function (suggestions) {
	        _this.loading = false;
	        if (_this.suggestionDisabled) {
	          return;
	        }
	        if (Array.isArray(suggestions)) {
	          _this.suggestions = suggestions;
	          _this.highlightedIndex = _this.highlightFirstItem ? 0 : -1;
	        } else {
	          console.error('[Element Error][Autocomplete]autocomplete suggestions must be an array');
	        }
	      });
	    },
	    handleChange: function handleChange(value) {
	      this.$emit('input', value);
	      this.suggestionDisabled = false;
	      if (!this.triggerOnFocus && !value) {
	        this.suggestionDisabled = true;
	        this.suggestions = [];
	        return;
	      }
	      this.debouncedGetData(value);
	    },
	    handleFocus: function handleFocus(event) {
	      this.activated = true;
	      this.$emit('focus', event);
	      if (this.triggerOnFocus) {
	        this.debouncedGetData(this.value);
	      }
	    },
	    handleBlur: function handleBlur(event) {
	      this.$emit('blur', event);
	    },
	    handleClear: function handleClear() {
	      this.activated = false;
	      this.$emit('clear');
	    },
	    close: function close(e) {
	      this.activated = false;
	    },
	    handleKeyEnter: function handleKeyEnter(e) {
	      var _this2 = this;
	
	      if (this.suggestionVisible && this.highlightedIndex >= 0 && this.highlightedIndex < this.suggestions.length) {
	        e.preventDefault();
	        this.select(this.suggestions[this.highlightedIndex]);
	      } else if (this.selectWhenUnmatched) {
	        this.$emit('select', { value: this.value });
	        this.$nextTick(function (_) {
	          _this2.suggestions = [];
	          _this2.highlightedIndex = -1;
	        });
	      }
	    },
	    select: function select(item) {
	      var _this3 = this;
	
	      this.$emit('input', item[this.valueKey]);
	      this.$emit('select', item);
	      this.$nextTick(function (_) {
	        _this3.suggestions = [];
	        _this3.highlightedIndex = -1;
	      });
	    },
	    highlight: function highlight(index) {
	      if (!this.suggestionVisible || this.loading) {
	        return;
	      }
	      if (index < 0) {
	        this.highlightedIndex = -1;
	        return;
	      }
	      if (index >= this.suggestions.length) {
	        index = this.suggestions.length - 1;
	      }
	      var suggestion = this.$refs.suggestions.$el.querySelector('.el-autocomplete-suggestion__wrap');
	      var suggestionList = suggestion.querySelectorAll('.el-autocomplete-suggestion__list li');
	
	      var highlightItem = suggestionList[index];
	      var scrollTop = suggestion.scrollTop;
	      var offsetTop = highlightItem.offsetTop;
	
	      if (offsetTop + highlightItem.scrollHeight > scrollTop + suggestion.clientHeight) {
	        suggestion.scrollTop += highlightItem.scrollHeight;
	      }
	      if (offsetTop < scrollTop) {
	        suggestion.scrollTop -= highlightItem.scrollHeight;
	      }
	      this.highlightedIndex = index;
	      var $input = this.getInput();
	      $input.setAttribute('aria-activedescendant', this.id + '-item-' + this.highlightedIndex);
	    },
	    getInput: function getInput() {
	      return this.$refs.input.getInput();
	    }
	  },
	  mounted: function mounted() {
	    var _this4 = this;
	
	    this.debouncedGetData = debounce_default()(this.debounce, this.getData);
	    this.$on('item-click', function (item) {
	      _this4.select(item);
	    });
	    var $input = this.getInput();
	    $input.setAttribute('role', 'textbox');
	    $input.setAttribute('aria-autocomplete', 'list');
	    $input.setAttribute('aria-controls', 'id');
	    $input.setAttribute('aria-activedescendant', this.id + '-item-' + this.highlightedIndex);
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.$refs.suggestions.$destroy();
	  }
	});
	// CONCATENATED MODULE: ./packages/autocomplete/src/autocomplete.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_autocompletevue_type_script_lang_js_ = (autocompletevue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/autocomplete/src/autocomplete.vue
	
	
	
	
	
	/* normalize component */
	
	var autocomplete_component = normalizeComponent(
	  src_autocompletevue_type_script_lang_js_,
	  autocompletevue_type_template_id_152f2ee6_render,
	  autocompletevue_type_template_id_152f2ee6_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var autocomplete_api; }
	autocomplete_component.options.__file = "packages/autocomplete/src/autocomplete.vue"
	/* harmony default export */ var autocomplete = (autocomplete_component.exports);
	// CONCATENATED MODULE: ./packages/autocomplete/index.js
	
	
	/* istanbul ignore next */
	autocomplete.install = function (Vue) {
	  Vue.component(autocomplete.name, autocomplete);
	};
	
	/* harmony default export */ var packages_autocomplete = (autocomplete);
	// EXTERNAL MODULE: external "element-ui/lib/button"
	var button_ = __webpack_require__(12);
	var button_default = /*#__PURE__*/__webpack_require__.n(button_);
	
	// EXTERNAL MODULE: external "element-ui/lib/button-group"
	var button_group_ = __webpack_require__(29);
	var button_group_default = /*#__PURE__*/__webpack_require__.n(button_group_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/dropdown/src/dropdown.vue?vue&type=script&lang=js&
	
	
	
	
	
	
	
	
	/* harmony default export */ var dropdownvue_type_script_lang_js_ = ({
	  name: 'ElDropdown',
	
	  componentName: 'ElDropdown',
	
	  mixins: [emitter_default.a, migrating_default.a],
	
	  directives: { Clickoutside: clickoutside_default.a },
	
	  components: {
	    ElButton: button_default.a,
	    ElButtonGroup: button_group_default.a
	  },
	
	  provide: function provide() {
	    return {
	      dropdown: this
	    };
	  },
	
	
	  props: {
	    trigger: {
	      type: String,
	      default: 'hover'
	    },
	    type: String,
	    size: {
	      type: String,
	      default: ''
	    },
	    splitButton: Boolean,
	    hideOnClick: {
	      type: Boolean,
	      default: true
	    },
	    placement: {
	      type: String,
	      default: 'bottom-end'
	    },
	    visibleArrow: {
	      default: true
	    },
	    showTimeout: {
	      type: Number,
	      default: 250
	    },
	    hideTimeout: {
	      type: Number,
	      default: 150
	    },
	    tabindex: {
	      type: Number,
	      default: 0
	    }
	  },
	
	  data: function data() {
	    return {
	      timeout: null,
	      visible: false,
	      triggerElm: null,
	      menuItems: null,
	      menuItemsArray: null,
	      dropdownElm: null,
	      focusing: false,
	      listId: 'dropdown-menu-' + Object(util_["generateId"])()
	    };
	  },
	
	
	  computed: {
	    dropdownSize: function dropdownSize() {
	      return this.size || (this.$ELEMENT || {}).size;
	    }
	  },
	
	  mounted: function mounted() {
	    this.$on('menu-item-click', this.handleMenuItemClick);
	  },
	
	
	  watch: {
	    visible: function visible(val) {
	      this.broadcast('ElDropdownMenu', 'visible', val);
	      this.$emit('visible-change', val);
	    },
	    focusing: function focusing(val) {
	      var selfDefine = this.$el.querySelector('.el-dropdown-selfdefine');
	      if (selfDefine) {
	        // 自定义
	        if (val) {
	          selfDefine.className += ' focusing';
	        } else {
	          selfDefine.className = selfDefine.className.replace('focusing', '');
	        }
	      }
	    }
	  },
	
	  methods: {
	    getMigratingConfig: function getMigratingConfig() {
	      return {
	        props: {
	          'menu-align': 'menu-align is renamed to placement.'
	        }
	      };
	    },
	    show: function show() {
	      var _this = this;
	
	      if (this.triggerElm.disabled) return;
	      clearTimeout(this.timeout);
	      this.timeout = setTimeout(function () {
	        _this.visible = true;
	      }, this.trigger === 'click' ? 0 : this.showTimeout);
	    },
	    hide: function hide() {
	      var _this2 = this;
	
	      if (this.triggerElm.disabled) return;
	      this.removeTabindex();
	      if (this.tabindex >= 0) {
	        this.resetTabindex(this.triggerElm);
	      }
	      clearTimeout(this.timeout);
	      this.timeout = setTimeout(function () {
	        _this2.visible = false;
	      }, this.trigger === 'click' ? 0 : this.hideTimeout);
	    },
	    handleClick: function handleClick() {
	      if (this.triggerElm.disabled) return;
	      if (this.visible) {
	        this.hide();
	      } else {
	        this.show();
	      }
	    },
	    handleTriggerKeyDown: function handleTriggerKeyDown(ev) {
	      var keyCode = ev.keyCode;
	      if ([38, 40].indexOf(keyCode) > -1) {
	        // up/down
	        this.removeTabindex();
	        this.resetTabindex(this.menuItems[0]);
	        this.menuItems[0].focus();
	        ev.preventDefault();
	        ev.stopPropagation();
	      } else if (keyCode === 13) {
	        // space enter选中
	        this.handleClick();
	      } else if ([9, 27].indexOf(keyCode) > -1) {
	        // tab || esc
	        this.hide();
	      }
	    },
	    handleItemKeyDown: function handleItemKeyDown(ev) {
	      var keyCode = ev.keyCode;
	      var target = ev.target;
	      var currentIndex = this.menuItemsArray.indexOf(target);
	      var max = this.menuItemsArray.length - 1;
	      var nextIndex = void 0;
	      if ([38, 40].indexOf(keyCode) > -1) {
	        // up/down
	        if (keyCode === 38) {
	          // up
	          nextIndex = currentIndex !== 0 ? currentIndex - 1 : 0;
	        } else {
	          // down
	          nextIndex = currentIndex < max ? currentIndex + 1 : max;
	        }
	        this.removeTabindex();
	        this.resetTabindex(this.menuItems[nextIndex]);
	        this.menuItems[nextIndex].focus();
	        ev.preventDefault();
	        ev.stopPropagation();
	      } else if (keyCode === 13) {
	        // enter选中
	        this.triggerElmFocus();
	        target.click();
	        if (this.hideOnClick) {
	          // click关闭
	          this.visible = false;
	        }
	      } else if ([9, 27].indexOf(keyCode) > -1) {
	        // tab // esc
	        this.hide();
	        this.triggerElmFocus();
	      }
	    },
	    resetTabindex: function resetTabindex(ele) {
	      // 下次tab时组件聚焦元素
	      this.removeTabindex();
	      ele.setAttribute('tabindex', '0'); // 下次期望的聚焦元素
	    },
	    removeTabindex: function removeTabindex() {
	      this.triggerElm.setAttribute('tabindex', '-1');
	      this.menuItemsArray.forEach(function (item) {
	        item.setAttribute('tabindex', '-1');
	      });
	    },
	    initAria: function initAria() {
	      this.dropdownElm.setAttribute('id', this.listId);
	      this.triggerElm.setAttribute('aria-haspopup', 'list');
	      this.triggerElm.setAttribute('aria-controls', this.listId);
	
	      if (!this.splitButton) {
	        // 自定义
	        this.triggerElm.setAttribute('role', 'button');
	        this.triggerElm.setAttribute('tabindex', this.tabindex);
	        this.triggerElm.setAttribute('class', (this.triggerElm.getAttribute('class') || '') + ' el-dropdown-selfdefine'); // 控制
	      }
	    },
	    initEvent: function initEvent() {
	      var _this3 = this;
	
	      var trigger = this.trigger,
	          show = this.show,
	          hide = this.hide,
	          handleClick = this.handleClick,
	          splitButton = this.splitButton,
	          handleTriggerKeyDown = this.handleTriggerKeyDown,
	          handleItemKeyDown = this.handleItemKeyDown;
	
	      this.triggerElm = splitButton ? this.$refs.trigger.$el : this.$slots.default[0].elm;
	
	      var dropdownElm = this.dropdownElm;
	
	      this.triggerElm.addEventListener('keydown', handleTriggerKeyDown); // triggerElm keydown
	      dropdownElm.addEventListener('keydown', handleItemKeyDown, true); // item keydown
	      // 控制自定义元素的样式
	      if (!splitButton) {
	        this.triggerElm.addEventListener('focus', function () {
	          _this3.focusing = true;
	        });
	        this.triggerElm.addEventListener('blur', function () {
	          _this3.focusing = false;
	        });
	        this.triggerElm.addEventListener('click', function () {
	          _this3.focusing = false;
	        });
	      }
	      if (trigger === 'hover') {
	        this.triggerElm.addEventListener('mouseenter', show);
	        this.triggerElm.addEventListener('mouseleave', hide);
	        dropdownElm.addEventListener('mouseenter', show);
	        dropdownElm.addEventListener('mouseleave', hide);
	      } else if (trigger === 'click') {
	        this.triggerElm.addEventListener('click', handleClick);
	      }
	    },
	    handleMenuItemClick: function handleMenuItemClick(command, instance) {
	      if (this.hideOnClick) {
	        this.visible = false;
	      }
	      this.$emit('command', command, instance);
	    },
	    triggerElmFocus: function triggerElmFocus() {
	      this.triggerElm.focus && this.triggerElm.focus();
	    },
	    initDomOperation: function initDomOperation() {
	      this.dropdownElm = this.popperElm;
	      this.menuItems = this.dropdownElm.querySelectorAll("[tabindex='-1']");
	      this.menuItemsArray = [].slice.call(this.menuItems);
	
	      this.initEvent();
	      this.initAria();
	    }
	  },
	
	  render: function render(h) {
	    var _this4 = this;
	
	    var hide = this.hide,
	        splitButton = this.splitButton,
	        type = this.type,
	        dropdownSize = this.dropdownSize;
	
	
	    var handleMainButtonClick = function handleMainButtonClick(event) {
	      _this4.$emit('click', event);
	      hide();
	    };
	
	    var triggerElm = !splitButton ? this.$slots.default : h('el-button-group', [h(
	      'el-button',
	      {
	        attrs: { type: type, size: dropdownSize },
	        nativeOn: {
	          'click': handleMainButtonClick
	        }
	      },
	      [this.$slots.default]
	    ), h(
	      'el-button',
	      { ref: 'trigger', attrs: { type: type, size: dropdownSize },
	        'class': 'el-dropdown__caret-button' },
	      [h('i', { 'class': 'el-dropdown__icon el-icon-arrow-down' })]
	    )]);
	
	    return h(
	      'div',
	      { 'class': 'el-dropdown', directives: [{
	          name: 'clickoutside',
	          value: hide
	        }]
	      },
	      [triggerElm, this.$slots.dropdown]
	    );
	  }
	});
	// CONCATENATED MODULE: ./packages/dropdown/src/dropdown.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_dropdownvue_type_script_lang_js_ = (dropdownvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/dropdown/src/dropdown.vue
	var dropdown_render, dropdown_staticRenderFns
	
	
	
	
	/* normalize component */
	
	var dropdown_component = normalizeComponent(
	  src_dropdownvue_type_script_lang_js_,
	  dropdown_render,
	  dropdown_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var dropdown_api; }
	dropdown_component.options.__file = "packages/dropdown/src/dropdown.vue"
	/* harmony default export */ var dropdown = (dropdown_component.exports);
	// CONCATENATED MODULE: ./packages/dropdown/index.js
	
	
	/* istanbul ignore next */
	dropdown.install = function (Vue) {
	  Vue.component(dropdown.name, dropdown);
	};
	
	/* harmony default export */ var packages_dropdown = (dropdown);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/dropdown/src/dropdown-menu.vue?vue&type=template&id=0da6b714&
	var dropdown_menuvue_type_template_id_0da6b714_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "transition",
	    { attrs: { name: "el-zoom-in-top" }, on: { "after-leave": _vm.doDestroy } },
	    [
	      _c(
	        "ul",
	        {
	          directives: [
	            {
	              name: "show",
	              rawName: "v-show",
	              value: _vm.showPopper,
	              expression: "showPopper"
	            }
	          ],
	          staticClass: "el-dropdown-menu el-popper",
	          class: [_vm.size && "el-dropdown-menu--" + _vm.size]
	        },
	        [_vm._t("default")],
	        2
	      )
	    ]
	  )
	}
	var dropdown_menuvue_type_template_id_0da6b714_staticRenderFns = []
	dropdown_menuvue_type_template_id_0da6b714_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/dropdown/src/dropdown-menu.vue?vue&type=template&id=0da6b714&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/dropdown/src/dropdown-menu.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var dropdown_menuvue_type_script_lang_js_ = ({
	  name: 'ElDropdownMenu',
	
	  componentName: 'ElDropdownMenu',
	
	  mixins: [vue_popper_default.a],
	
	  props: {
	    visibleArrow: {
	      type: Boolean,
	      default: true
	    },
	    arrowOffset: {
	      type: Number,
	      default: 0
	    }
	  },
	
	  data: function data() {
	    return {
	      size: this.dropdown.dropdownSize
	    };
	  },
	
	
	  inject: ['dropdown'],
	
	  created: function created() {
	    var _this = this;
	
	    this.$on('updatePopper', function () {
	      if (_this.showPopper) _this.updatePopper();
	    });
	    this.$on('visible', function (val) {
	      _this.showPopper = val;
	    });
	  },
	  mounted: function mounted() {
	    this.dropdown.popperElm = this.popperElm = this.$el;
	    this.referenceElm = this.dropdown.$el;
	    // compatible with 2.6 new v-slot syntax
	    // issue link https://github.com/ElemeFE/element/issues/14345
	    this.dropdown.initDomOperation();
	  },
	
	
	  watch: {
	    'dropdown.placement': {
	      immediate: true,
	      handler: function handler(val) {
	        this.currentPlacement = val;
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/dropdown/src/dropdown-menu.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_dropdown_menuvue_type_script_lang_js_ = (dropdown_menuvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/dropdown/src/dropdown-menu.vue
	
	
	
	
	
	/* normalize component */
	
	var dropdown_menu_component = normalizeComponent(
	  src_dropdown_menuvue_type_script_lang_js_,
	  dropdown_menuvue_type_template_id_0da6b714_render,
	  dropdown_menuvue_type_template_id_0da6b714_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var dropdown_menu_api; }
	dropdown_menu_component.options.__file = "packages/dropdown/src/dropdown-menu.vue"
	/* harmony default export */ var dropdown_menu = (dropdown_menu_component.exports);
	// CONCATENATED MODULE: ./packages/dropdown-menu/index.js
	
	
	/* istanbul ignore next */
	dropdown_menu.install = function (Vue) {
	  Vue.component(dropdown_menu.name, dropdown_menu);
	};
	
	/* harmony default export */ var packages_dropdown_menu = (dropdown_menu);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/dropdown/src/dropdown-item.vue?vue&type=template&id=6359102a&
	var dropdown_itemvue_type_template_id_6359102a_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "li",
	    {
	      staticClass: "el-dropdown-menu__item",
	      class: {
	        "is-disabled": _vm.disabled,
	        "el-dropdown-menu__item--divided": _vm.divided
	      },
	      attrs: {
	        "aria-disabled": _vm.disabled,
	        tabindex: _vm.disabled ? null : -1
	      },
	      on: { click: _vm.handleClick }
	    },
	    [_vm.icon ? _c("i", { class: _vm.icon }) : _vm._e(), _vm._t("default")],
	    2
	  )
	}
	var dropdown_itemvue_type_template_id_6359102a_staticRenderFns = []
	dropdown_itemvue_type_template_id_6359102a_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/dropdown/src/dropdown-item.vue?vue&type=template&id=6359102a&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/dropdown/src/dropdown-item.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var dropdown_itemvue_type_script_lang_js_ = ({
	  name: 'ElDropdownItem',
	
	  mixins: [emitter_default.a],
	
	  props: {
	    command: {},
	    disabled: Boolean,
	    divided: Boolean,
	    icon: String
	  },
	
	  methods: {
	    handleClick: function handleClick(e) {
	      this.dispatch('ElDropdown', 'menu-item-click', [this.command, this]);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/dropdown/src/dropdown-item.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_dropdown_itemvue_type_script_lang_js_ = (dropdown_itemvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/dropdown/src/dropdown-item.vue
	
	
	
	
	
	/* normalize component */
	
	var dropdown_item_component = normalizeComponent(
	  src_dropdown_itemvue_type_script_lang_js_,
	  dropdown_itemvue_type_template_id_6359102a_render,
	  dropdown_itemvue_type_template_id_6359102a_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var dropdown_item_api; }
	dropdown_item_component.options.__file = "packages/dropdown/src/dropdown-item.vue"
	/* harmony default export */ var dropdown_item = (dropdown_item_component.exports);
	// CONCATENATED MODULE: ./packages/dropdown-item/index.js
	
	
	/* istanbul ignore next */
	dropdown_item.install = function (Vue) {
	  Vue.component(dropdown_item.name, dropdown_item);
	};
	
	/* harmony default export */ var packages_dropdown_item = (dropdown_item);
	// CONCATENATED MODULE: ./src/utils/aria-utils.js
	var aria = aria || {};
	
	aria.Utils = aria.Utils || {};
	
	/**
	 * @desc Set focus on descendant nodes until the first focusable element is
	 *       found.
	 * @param element
	 *          DOM node for which to find the first focusable descendant.
	 * @returns
	 *  true if a focusable element is found and focus is set.
	 */
	aria.Utils.focusFirstDescendant = function (element) {
	  for (var i = 0; i < element.childNodes.length; i++) {
	    var child = element.childNodes[i];
	    if (aria.Utils.attemptFocus(child) || aria.Utils.focusFirstDescendant(child)) {
	      return true;
	    }
	  }
	  return false;
	};
	
	/**
	 * @desc Find the last descendant node that is focusable.
	 * @param element
	 *          DOM node for which to find the last focusable descendant.
	 * @returns
	 *  true if a focusable element is found and focus is set.
	 */
	
	aria.Utils.focusLastDescendant = function (element) {
	  for (var i = element.childNodes.length - 1; i >= 0; i--) {
	    var child = element.childNodes[i];
	    if (aria.Utils.attemptFocus(child) || aria.Utils.focusLastDescendant(child)) {
	      return true;
	    }
	  }
	  return false;
	};
	
	/**
	 * @desc Set Attempt to set focus on the current node.
	 * @param element
	 *          The node to attempt to focus on.
	 * @returns
	 *  true if element is focused.
	 */
	aria.Utils.attemptFocus = function (element) {
	  if (!aria.Utils.isFocusable(element)) {
	    return false;
	  }
	  aria.Utils.IgnoreUtilFocusChanges = true;
	  try {
	    element.focus();
	  } catch (e) {}
	  aria.Utils.IgnoreUtilFocusChanges = false;
	  return document.activeElement === element;
	};
	
	aria.Utils.isFocusable = function (element) {
	  if (element.tabIndex > 0 || element.tabIndex === 0 && element.getAttribute('tabIndex') !== null) {
	    return true;
	  }
	
	  if (element.disabled) {
	    return false;
	  }
	
	  switch (element.nodeName) {
	    case 'A':
	      return !!element.href && element.rel !== 'ignore';
	    case 'INPUT':
	      return element.type !== 'hidden' && element.type !== 'file';
	    case 'BUTTON':
	    case 'SELECT':
	    case 'TEXTAREA':
	      return true;
	    default:
	      return false;
	  }
	};
	
	/**
	 * 触发一个事件
	 * mouseenter, mouseleave, mouseover, keyup, change, click 等
	 * @param  {Element} elm
	 * @param  {String} name
	 * @param  {*} opts
	 */
	aria.Utils.triggerEvent = function (elm, name) {
	  var eventName = void 0;
	
	  if (/^mouse|click/.test(name)) {
	    eventName = 'MouseEvents';
	  } else if (/^key/.test(name)) {
	    eventName = 'KeyboardEvent';
	  } else {
	    eventName = 'HTMLEvents';
	  }
	  var evt = document.createEvent(eventName);
	
	  for (var _len = arguments.length, opts = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    opts[_key - 2] = arguments[_key];
	  }
	
	  evt.initEvent.apply(evt, [name].concat(opts));
	  elm.dispatchEvent ? elm.dispatchEvent(evt) : elm.fireEvent('on' + name, evt);
	
	  return elm;
	};
	
	aria.Utils.keys = {
	  tab: 9,
	  enter: 13,
	  space: 32,
	  left: 37,
	  up: 38,
	  right: 39,
	  down: 40,
	  esc: 27
	};
	
	/* harmony default export */ var aria_utils = (aria.Utils);
	// CONCATENATED MODULE: ./src/utils/menu/aria-submenu.js
	
	
	var SubMenu = function SubMenu(parent, domNode) {
	  this.domNode = domNode;
	  this.parent = parent;
	  this.subMenuItems = [];
	  this.subIndex = 0;
	  this.init();
	};
	
	SubMenu.prototype.init = function () {
	  this.subMenuItems = this.domNode.querySelectorAll('li');
	  this.addListeners();
	};
	
	SubMenu.prototype.gotoSubIndex = function (idx) {
	  if (idx === this.subMenuItems.length) {
	    idx = 0;
	  } else if (idx < 0) {
	    idx = this.subMenuItems.length - 1;
	  }
	  this.subMenuItems[idx].focus();
	  this.subIndex = idx;
	};
	
	SubMenu.prototype.addListeners = function () {
	  var _this = this;
	
	  var keys = aria_utils.keys;
	  var parentNode = this.parent.domNode;
	  Array.prototype.forEach.call(this.subMenuItems, function (el) {
	    el.addEventListener('keydown', function (event) {
	      var prevDef = false;
	      switch (event.keyCode) {
	        case keys.down:
	          _this.gotoSubIndex(_this.subIndex + 1);
	          prevDef = true;
	          break;
	        case keys.up:
	          _this.gotoSubIndex(_this.subIndex - 1);
	          prevDef = true;
	          break;
	        case keys.tab:
	          aria_utils.triggerEvent(parentNode, 'mouseleave');
	          break;
	        case keys.enter:
	        case keys.space:
	          prevDef = true;
	          event.currentTarget.click();
	          break;
	      }
	      if (prevDef) {
	        event.preventDefault();
	        event.stopPropagation();
	      }
	      return false;
	    });
	  });
	};
	
	/* harmony default export */ var aria_submenu = (SubMenu);
	// CONCATENATED MODULE: ./src/utils/menu/aria-menuitem.js
	
	
	
	var MenuItem = function MenuItem(domNode) {
	  this.domNode = domNode;
	  this.submenu = null;
	  this.init();
	};
	
	MenuItem.prototype.init = function () {
	  this.domNode.setAttribute('tabindex', '0');
	  var menuChild = this.domNode.querySelector('.el-menu');
	  if (menuChild) {
	    this.submenu = new aria_submenu(this, menuChild);
	  }
	  this.addListeners();
	};
	
	MenuItem.prototype.addListeners = function () {
	  var _this = this;
	
	  var keys = aria_utils.keys;
	  this.domNode.addEventListener('keydown', function (event) {
	    var prevDef = false;
	    switch (event.keyCode) {
	      case keys.down:
	        aria_utils.triggerEvent(event.currentTarget, 'mouseenter');
	        _this.submenu && _this.submenu.gotoSubIndex(0);
	        prevDef = true;
	        break;
	      case keys.up:
	        aria_utils.triggerEvent(event.currentTarget, 'mouseenter');
	        _this.submenu && _this.submenu.gotoSubIndex(_this.submenu.subMenuItems.length - 1);
	        prevDef = true;
	        break;
	      case keys.tab:
	        aria_utils.triggerEvent(event.currentTarget, 'mouseleave');
	        break;
	      case keys.enter:
	      case keys.space:
	        prevDef = true;
	        event.currentTarget.click();
	        break;
	    }
	    if (prevDef) {
	      event.preventDefault();
	    }
	  });
	};
	
	/* harmony default export */ var aria_menuitem = (MenuItem);
	// CONCATENATED MODULE: ./src/utils/menu/aria-menubar.js
	
	
	var Menu = function Menu(domNode) {
	  this.domNode = domNode;
	  this.init();
	};
	
	Menu.prototype.init = function () {
	  var menuChildren = this.domNode.childNodes;
	  [].filter.call(menuChildren, function (child) {
	    return child.nodeType === 1;
	  }).forEach(function (child) {
	    new aria_menuitem(child); // eslint-disable-line
	  });
	};
	/* harmony default export */ var aria_menubar = (Menu);
	// EXTERNAL MODULE: external "element-ui/lib/utils/dom"
	var dom_ = __webpack_require__(1);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/menu/src/menu.vue?vue&type=script&lang=js&
	
	
	
	
	
	
	/* harmony default export */ var menuvue_type_script_lang_js_ = ({
	  name: 'ElMenu',
	
	  render: function render(h) {
	    var component = h(
	      'ul',
	      {
	        attrs: {
	          role: 'menubar'
	        },
	        key: +this.collapse,
	        style: { backgroundColor: this.backgroundColor || '' },
	        'class': {
	          'el-menu--horizontal': this.mode === 'horizontal',
	          'el-menu--collapse': this.collapse,
	          "el-menu": true
	        }
	      },
	      [this.$slots.default]
	    );
	
	    if (this.collapseTransition) {
	      return h('el-menu-collapse-transition', [component]);
	    } else {
	      return component;
	    }
	  },
	
	
	  componentName: 'ElMenu',
	
	  mixins: [emitter_default.a, migrating_default.a],
	
	  provide: function provide() {
	    return {
	      rootMenu: this
	    };
	  },
	
	
	  components: {
	    'el-menu-collapse-transition': {
	      functional: true,
	      render: function render(createElement, context) {
	        var data = {
	          props: {
	            mode: 'out-in'
	          },
	          on: {
	            beforeEnter: function beforeEnter(el) {
	              el.style.opacity = 0.2;
	            },
	            enter: function enter(el) {
	              Object(dom_["addClass"])(el, 'el-opacity-transition');
	              el.style.opacity = 1;
	            },
	            afterEnter: function afterEnter(el) {
	              Object(dom_["removeClass"])(el, 'el-opacity-transition');
	              el.style.opacity = '';
	            },
	            beforeLeave: function beforeLeave(el) {
	              if (!el.dataset) el.dataset = {};
	
	              if (Object(dom_["hasClass"])(el, 'el-menu--collapse')) {
	                Object(dom_["removeClass"])(el, 'el-menu--collapse');
	                el.dataset.oldOverflow = el.style.overflow;
	                el.dataset.scrollWidth = el.clientWidth;
	                Object(dom_["addClass"])(el, 'el-menu--collapse');
	              } else {
	                Object(dom_["addClass"])(el, 'el-menu--collapse');
	                el.dataset.oldOverflow = el.style.overflow;
	                el.dataset.scrollWidth = el.clientWidth;
	                Object(dom_["removeClass"])(el, 'el-menu--collapse');
	              }
	
	              el.style.width = el.scrollWidth + 'px';
	              el.style.overflow = 'hidden';
	            },
	            leave: function leave(el) {
	              Object(dom_["addClass"])(el, 'horizontal-collapse-transition');
	              el.style.width = el.dataset.scrollWidth + 'px';
	            }
	          }
	        };
	        return createElement('transition', data, context.children);
	      }
	    }
	  },
	
	  props: {
	    mode: {
	      type: String,
	      default: 'vertical'
	    },
	    defaultActive: {
	      type: String,
	      default: ''
	    },
	    defaultOpeneds: Array,
	    uniqueOpened: Boolean,
	    router: Boolean,
	    menuTrigger: {
	      type: String,
	      default: 'hover'
	    },
	    collapse: Boolean,
	    backgroundColor: String,
	    textColor: String,
	    activeTextColor: String,
	    collapseTransition: {
	      type: Boolean,
	      default: true
	    }
	  },
	  data: function data() {
	    return {
	      activeIndex: this.defaultActive,
	      openedMenus: this.defaultOpeneds && !this.collapse ? this.defaultOpeneds.slice(0) : [],
	      items: {},
	      submenus: {}
	    };
	  },
	
	  computed: {
	    hoverBackground: function hoverBackground() {
	      return this.backgroundColor ? this.mixColor(this.backgroundColor, 0.2) : '';
	    },
	    isMenuPopup: function isMenuPopup() {
	      return this.mode === 'horizontal' || this.mode === 'vertical' && this.collapse;
	    }
	  },
	  watch: {
	    defaultActive: function defaultActive(value) {
	      if (!this.items[value]) {
	        this.activeIndex = null;
	      }
	      this.updateActiveIndex(value);
	    },
	    defaultOpeneds: function defaultOpeneds(value) {
	      if (!this.collapse) {
	        this.openedMenus = value;
	      }
	    },
	    collapse: function collapse(value) {
	      if (value) this.openedMenus = [];
	      this.broadcast('ElSubmenu', 'toggle-collapse', value);
	    }
	  },
	  methods: {
	    updateActiveIndex: function updateActiveIndex(val) {
	      var item = this.items[val] || this.items[this.activeIndex] || this.items[this.defaultActive];
	      if (item) {
	        this.activeIndex = item.index;
	        this.initOpenedMenu();
	      } else {
	        this.activeIndex = null;
	      }
	    },
	    getMigratingConfig: function getMigratingConfig() {
	      return {
	        props: {
	          'theme': 'theme is removed.'
	        }
	      };
	    },
	    getColorChannels: function getColorChannels(color) {
	      color = color.replace('#', '');
	      if (/^[0-9a-fA-F]{3}$/.test(color)) {
	        color = color.split('');
	        for (var i = 2; i >= 0; i--) {
	          color.splice(i, 0, color[i]);
	        }
	        color = color.join('');
	      }
	      if (/^[0-9a-fA-F]{6}$/.test(color)) {
	        return {
	          red: parseInt(color.slice(0, 2), 16),
	          green: parseInt(color.slice(2, 4), 16),
	          blue: parseInt(color.slice(4, 6), 16)
	        };
	      } else {
	        return {
	          red: 255,
	          green: 255,
	          blue: 255
	        };
	      }
	    },
	    mixColor: function mixColor(color, percent) {
	      var _getColorChannels = this.getColorChannels(color),
	          red = _getColorChannels.red,
	          green = _getColorChannels.green,
	          blue = _getColorChannels.blue;
	
	      if (percent > 0) {
	        // shade given color
	        red *= 1 - percent;
	        green *= 1 - percent;
	        blue *= 1 - percent;
	      } else {
	        // tint given color
	        red += (255 - red) * percent;
	        green += (255 - green) * percent;
	        blue += (255 - blue) * percent;
	      }
	      return 'rgb(' + Math.round(red) + ', ' + Math.round(green) + ', ' + Math.round(blue) + ')';
	    },
	    addItem: function addItem(item) {
	      this.$set(this.items, item.index, item);
	    },
	    removeItem: function removeItem(item) {
	      delete this.items[item.index];
	    },
	    addSubmenu: function addSubmenu(item) {
	      this.$set(this.submenus, item.index, item);
	    },
	    removeSubmenu: function removeSubmenu(item) {
	      delete this.submenus[item.index];
	    },
	    openMenu: function openMenu(index, indexPath) {
	      var openedMenus = this.openedMenus;
	      if (openedMenus.indexOf(index) !== -1) return;
	      // 将不在该菜单路径下的其余菜单收起
	      // collapse all menu that are not under current menu item
	      if (this.uniqueOpened) {
	        this.openedMenus = openedMenus.filter(function (index) {
	          return indexPath.indexOf(index) !== -1;
	        });
	      }
	      this.openedMenus.push(index);
	    },
	    closeMenu: function closeMenu(index) {
	      var i = this.openedMenus.indexOf(index);
	      if (i !== -1) {
	        this.openedMenus.splice(i, 1);
	      }
	    },
	    handleSubmenuClick: function handleSubmenuClick(submenu) {
	      var index = submenu.index,
	          indexPath = submenu.indexPath;
	
	      var isOpened = this.openedMenus.indexOf(index) !== -1;
	
	      if (isOpened) {
	        this.closeMenu(index);
	        this.$emit('close', index, indexPath);
	      } else {
	        this.openMenu(index, indexPath);
	        this.$emit('open', index, indexPath);
	      }
	    },
	    handleItemClick: function handleItemClick(item) {
	      var _this = this;
	
	      var index = item.index,
	          indexPath = item.indexPath;
	
	      var oldActiveIndex = this.activeIndex;
	      var hasIndex = item.index !== null;
	
	      if (hasIndex) {
	        this.activeIndex = item.index;
	      }
	
	      this.$emit('select', index, indexPath, item);
	
	      if (this.mode === 'horizontal' || this.collapse) {
	        this.openedMenus = [];
	      }
	
	      if (this.router && hasIndex) {
	        this.routeToItem(item, function (error) {
	          _this.activeIndex = oldActiveIndex;
	          if (error) {
	            // vue-router 3.1.0+ push/replace cause NavigationDuplicated error 
	            // https://github.com/ElemeFE/element/issues/17044
	            if (error.name === 'NavigationDuplicated') return;
	            console.error(error);
	          }
	        });
	      }
	    },
	
	    // 初始化展开菜单
	    // initialize opened menu
	    initOpenedMenu: function initOpenedMenu() {
	      var _this2 = this;
	
	      var index = this.activeIndex;
	      var activeItem = this.items[index];
	      if (!activeItem || this.mode === 'horizontal' || this.collapse) return;
	
	      var indexPath = activeItem.indexPath;
	
	      // 展开该菜单项的路径上所有子菜单
	      // expand all submenus of the menu item
	      indexPath.forEach(function (index) {
	        var submenu = _this2.submenus[index];
	        submenu && _this2.openMenu(index, submenu.indexPath);
	      });
	    },
	    routeToItem: function routeToItem(item, onError) {
	      var route = item.route || item.index;
	      try {
	        this.$router.push(route, function () {}, onError);
	      } catch (e) {
	        console.error(e);
	      }
	    },
	    open: function open(index) {
	      var _this3 = this;
	
	      var indexPath = this.submenus[index.toString()].indexPath;
	
	      indexPath.forEach(function (i) {
	        return _this3.openMenu(i, indexPath);
	      });
	    },
	    close: function close(index) {
	      this.closeMenu(index);
	    }
	  },
	  mounted: function mounted() {
	    this.initOpenedMenu();
	    this.$on('item-click', this.handleItemClick);
	    this.$on('submenu-click', this.handleSubmenuClick);
	    if (this.mode === 'horizontal') {
	      new aria_menubar(this.$el); // eslint-disable-line
	    }
	    this.$watch('items', this.updateActiveIndex);
	  }
	});
	// CONCATENATED MODULE: ./packages/menu/src/menu.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_menuvue_type_script_lang_js_ = (menuvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/menu/src/menu.vue
	var menu_render, menu_staticRenderFns
	
	
	
	
	/* normalize component */
	
	var menu_component = normalizeComponent(
	  src_menuvue_type_script_lang_js_,
	  menu_render,
	  menu_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var menu_api; }
	menu_component.options.__file = "packages/menu/src/menu.vue"
	/* harmony default export */ var src_menu = (menu_component.exports);
	// CONCATENATED MODULE: ./packages/menu/index.js
	
	
	/* istanbul ignore next */
	src_menu.install = function (Vue) {
	  Vue.component(src_menu.name, src_menu);
	};
	
	/* harmony default export */ var packages_menu = (src_menu);
	// EXTERNAL MODULE: external "element-ui/lib/transitions/collapse-transition"
	var collapse_transition_ = __webpack_require__(21);
	var collapse_transition_default = /*#__PURE__*/__webpack_require__.n(collapse_transition_);
	
	// CONCATENATED MODULE: ./packages/menu/src/menu-mixin.js
	/* harmony default export */ var menu_mixin = ({
	  inject: ['rootMenu'],
	  computed: {
	    indexPath: function indexPath() {
	      var path = [this.index];
	      var parent = this.$parent;
	      while (parent.$options.componentName !== 'ElMenu') {
	        if (parent.index) {
	          path.unshift(parent.index);
	        }
	        parent = parent.$parent;
	      }
	      return path;
	    },
	    parentMenu: function parentMenu() {
	      var parent = this.$parent;
	      while (parent && ['ElMenu', 'ElSubmenu'].indexOf(parent.$options.componentName) === -1) {
	        parent = parent.$parent;
	      }
	      return parent;
	    },
	    paddingStyle: function paddingStyle() {
	      if (this.rootMenu.mode !== 'vertical') return {};
	
	      var padding = 20;
	      var parent = this.$parent;
	
	      if (this.rootMenu.collapse) {
	        padding = 20;
	      } else {
	        while (parent && parent.$options.componentName !== 'ElMenu') {
	          if (parent.$options.componentName === 'ElSubmenu') {
	            padding += 20;
	          }
	          parent = parent.$parent;
	        }
	      }
	      return { paddingLeft: padding + 'px' };
	    }
	  }
	});
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/menu/src/submenu.vue?vue&type=script&lang=js&
	
	
	
	
	
	
	var poperMixins = {
	  props: {
	    transformOrigin: {
	      type: [Boolean, String],
	      default: false
	    },
	    offset: vue_popper_default.a.props.offset,
	    boundariesPadding: vue_popper_default.a.props.boundariesPadding,
	    popperOptions: vue_popper_default.a.props.popperOptions
	  },
	  data: vue_popper_default.a.data,
	  methods: vue_popper_default.a.methods,
	  beforeDestroy: vue_popper_default.a.beforeDestroy,
	  deactivated: vue_popper_default.a.deactivated
	};
	
	/* harmony default export */ var submenuvue_type_script_lang_js_ = ({
	  name: 'ElSubmenu',
	
	  componentName: 'ElSubmenu',
	
	  mixins: [menu_mixin, emitter_default.a, poperMixins],
	
	  components: { ElCollapseTransition: collapse_transition_default.a },
	
	  props: {
	    index: {
	      type: String,
	      required: true
	    },
	    showTimeout: {
	      type: Number,
	      default: 300
	    },
	    hideTimeout: {
	      type: Number,
	      default: 300
	    },
	    popperClass: String,
	    disabled: Boolean,
	    popperAppendToBody: {
	      type: Boolean,
	      default: undefined
	    }
	  },
	
	  data: function data() {
	    return {
	      popperJS: null,
	      timeout: null,
	      items: {},
	      submenus: {},
	      mouseInChild: false
	    };
	  },
	
	  watch: {
	    opened: function opened(val) {
	      var _this = this;
	
	      if (this.isMenuPopup) {
	        this.$nextTick(function (_) {
	          _this.updatePopper();
	        });
	      }
	    }
	  },
	  computed: {
	    // popper option
	    appendToBody: function appendToBody() {
	      return this.popperAppendToBody === undefined ? this.isFirstLevel : this.popperAppendToBody;
	    },
	    menuTransitionName: function menuTransitionName() {
	      return this.rootMenu.collapse ? 'el-zoom-in-left' : 'el-zoom-in-top';
	    },
	    opened: function opened() {
	      return this.rootMenu.openedMenus.indexOf(this.index) > -1;
	    },
	    active: function active() {
	      var isActive = false;
	      var submenus = this.submenus;
	      var items = this.items;
	
	      Object.keys(items).forEach(function (index) {
	        if (items[index].active) {
	          isActive = true;
	        }
	      });
	
	      Object.keys(submenus).forEach(function (index) {
	        if (submenus[index].active) {
	          isActive = true;
	        }
	      });
	
	      return isActive;
	    },
	    hoverBackground: function hoverBackground() {
	      return this.rootMenu.hoverBackground;
	    },
	    backgroundColor: function backgroundColor() {
	      return this.rootMenu.backgroundColor || '';
	    },
	    activeTextColor: function activeTextColor() {
	      return this.rootMenu.activeTextColor || '';
	    },
	    textColor: function textColor() {
	      return this.rootMenu.textColor || '';
	    },
	    mode: function mode() {
	      return this.rootMenu.mode;
	    },
	    isMenuPopup: function isMenuPopup() {
	      return this.rootMenu.isMenuPopup;
	    },
	    titleStyle: function titleStyle() {
	      if (this.mode !== 'horizontal') {
	        return {
	          color: this.textColor
	        };
	      }
	      return {
	        borderBottomColor: this.active ? this.rootMenu.activeTextColor ? this.activeTextColor : '' : 'transparent',
	        color: this.active ? this.activeTextColor : this.textColor
	      };
	    },
	    isFirstLevel: function isFirstLevel() {
	      var isFirstLevel = true;
	      var parent = this.$parent;
	      while (parent && parent !== this.rootMenu) {
	        if (['ElSubmenu', 'ElMenuItemGroup'].indexOf(parent.$options.componentName) > -1) {
	          isFirstLevel = false;
	          break;
	        } else {
	          parent = parent.$parent;
	        }
	      }
	      return isFirstLevel;
	    }
	  },
	  methods: {
	    handleCollapseToggle: function handleCollapseToggle(value) {
	      if (value) {
	        this.initPopper();
	      } else {
	        this.doDestroy();
	      }
	    },
	    addItem: function addItem(item) {
	      this.$set(this.items, item.index, item);
	    },
	    removeItem: function removeItem(item) {
	      delete this.items[item.index];
	    },
	    addSubmenu: function addSubmenu(item) {
	      this.$set(this.submenus, item.index, item);
	    },
	    removeSubmenu: function removeSubmenu(item) {
	      delete this.submenus[item.index];
	    },
	    handleClick: function handleClick() {
	      var rootMenu = this.rootMenu,
	          disabled = this.disabled;
	
	      if (rootMenu.menuTrigger === 'hover' && rootMenu.mode === 'horizontal' || rootMenu.collapse && rootMenu.mode === 'vertical' || disabled) {
	        return;
	      }
	      this.dispatch('ElMenu', 'submenu-click', this);
	    },
	    handleMouseenter: function handleMouseenter(event) {
	      var _this2 = this;
	
	      var showTimeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.showTimeout;
	
	
	      if (!('ActiveXObject' in window) && event.type === 'focus' && !event.relatedTarget) {
	        return;
	      }
	      var rootMenu = this.rootMenu,
	          disabled = this.disabled;
	
	      if (rootMenu.menuTrigger === 'click' && rootMenu.mode === 'horizontal' || !rootMenu.collapse && rootMenu.mode === 'vertical' || disabled) {
	        return;
	      }
	      this.dispatch('ElSubmenu', 'mouse-enter-child');
	      clearTimeout(this.timeout);
	      this.timeout = setTimeout(function () {
	        _this2.rootMenu.openMenu(_this2.index, _this2.indexPath);
	      }, showTimeout);
	
	      if (this.appendToBody) {
	        this.$parent.$el.dispatchEvent(new MouseEvent('mouseenter'));
	      }
	    },
	    handleMouseleave: function handleMouseleave() {
	      var _this3 = this;
	
	      var deepDispatch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	      var rootMenu = this.rootMenu;
	
	      if (rootMenu.menuTrigger === 'click' && rootMenu.mode === 'horizontal' || !rootMenu.collapse && rootMenu.mode === 'vertical') {
	        return;
	      }
	      this.dispatch('ElSubmenu', 'mouse-leave-child');
	      clearTimeout(this.timeout);
	      this.timeout = setTimeout(function () {
	        !_this3.mouseInChild && _this3.rootMenu.closeMenu(_this3.index);
	      }, this.hideTimeout);
	
	      if (this.appendToBody && deepDispatch) {
	        if (this.$parent.$options.name === 'ElSubmenu') {
	          this.$parent.handleMouseleave(true);
	        }
	      }
	    },
	    handleTitleMouseenter: function handleTitleMouseenter() {
	      if (this.mode === 'horizontal' && !this.rootMenu.backgroundColor) return;
	      var title = this.$refs['submenu-title'];
	      title && (title.style.backgroundColor = this.rootMenu.hoverBackground);
	    },
	    handleTitleMouseleave: function handleTitleMouseleave() {
	      if (this.mode === 'horizontal' && !this.rootMenu.backgroundColor) return;
	      var title = this.$refs['submenu-title'];
	      title && (title.style.backgroundColor = this.rootMenu.backgroundColor || '');
	    },
	    updatePlacement: function updatePlacement() {
	      this.currentPlacement = this.mode === 'horizontal' && this.isFirstLevel ? 'bottom-start' : 'right-start';
	    },
	    initPopper: function initPopper() {
	      this.referenceElm = this.$el;
	      this.popperElm = this.$refs.menu;
	      this.updatePlacement();
	    }
	  },
	  created: function created() {
	    var _this4 = this;
	
	    this.$on('toggle-collapse', this.handleCollapseToggle);
	    this.$on('mouse-enter-child', function () {
	      _this4.mouseInChild = true;
	      clearTimeout(_this4.timeout);
	    });
	    this.$on('mouse-leave-child', function () {
	      _this4.mouseInChild = false;
	      clearTimeout(_this4.timeout);
	    });
	  },
	  mounted: function mounted() {
	    this.parentMenu.addSubmenu(this);
	    this.rootMenu.addSubmenu(this);
	    this.initPopper();
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.parentMenu.removeSubmenu(this);
	    this.rootMenu.removeSubmenu(this);
	  },
	  render: function render(h) {
	    var _this5 = this;
	
	    var active = this.active,
	        opened = this.opened,
	        paddingStyle = this.paddingStyle,
	        titleStyle = this.titleStyle,
	        backgroundColor = this.backgroundColor,
	        rootMenu = this.rootMenu,
	        currentPlacement = this.currentPlacement,
	        menuTransitionName = this.menuTransitionName,
	        mode = this.mode,
	        disabled = this.disabled,
	        popperClass = this.popperClass,
	        $slots = this.$slots,
	        isFirstLevel = this.isFirstLevel;
	
	
	    var popupMenu = h(
	      'transition',
	      {
	        attrs: { name: menuTransitionName }
	      },
	      [h(
	        'div',
	        {
	          ref: 'menu',
	          directives: [{
	            name: 'show',
	            value: opened
	          }],
	
	          'class': ['el-menu--' + mode, popperClass],
	          on: {
	            'mouseenter': function mouseenter($event) {
	              return _this5.handleMouseenter($event, 100);
	            },
	            'mouseleave': function mouseleave() {
	              return _this5.handleMouseleave(true);
	            },
	            'focus': function focus($event) {
	              return _this5.handleMouseenter($event, 100);
	            }
	          }
	        },
	        [h(
	          'ul',
	          {
	            attrs: {
	              role: 'menu'
	            },
	            'class': ['el-menu el-menu--popup', 'el-menu--popup-' + currentPlacement],
	            style: { backgroundColor: rootMenu.backgroundColor || '' } },
	          [$slots.default]
	        )]
	      )]
	    );
	
	    var inlineMenu = h('el-collapse-transition', [h(
	      'ul',
	      {
	        attrs: {
	          role: 'menu'
	        },
	        'class': 'el-menu el-menu--inline',
	        directives: [{
	          name: 'show',
	          value: opened
	        }],
	
	        style: { backgroundColor: rootMenu.backgroundColor || '' } },
	      [$slots.default]
	    )]);
	
	    var submenuTitleIcon = rootMenu.mode === 'horizontal' && isFirstLevel || rootMenu.mode === 'vertical' && !rootMenu.collapse ? 'el-icon-arrow-down' : 'el-icon-arrow-right';
	
	    return h(
	      'li',
	      {
	        'class': {
	          'el-submenu': true,
	          'is-active': active,
	          'is-opened': opened,
	          'is-disabled': disabled
	        },
	        attrs: { role: 'menuitem',
	          'aria-haspopup': 'true',
	          'aria-expanded': opened
	        },
	        on: {
	          'mouseenter': this.handleMouseenter,
	          'mouseleave': function mouseleave() {
	            return _this5.handleMouseleave(false);
	          },
	          'focus': this.handleMouseenter
	        }
	      },
	      [h(
	        'div',
	        {
	          'class': 'el-submenu__title',
	          ref: 'submenu-title',
	          on: {
	            'click': this.handleClick,
	            'mouseenter': this.handleTitleMouseenter,
	            'mouseleave': this.handleTitleMouseleave
	          },
	
	          style: [paddingStyle, titleStyle, { backgroundColor: backgroundColor }]
	        },
	        [$slots.title, h('i', { 'class': ['el-submenu__icon-arrow', submenuTitleIcon] })]
	      ), this.isMenuPopup ? popupMenu : inlineMenu]
	    );
	  }
	});
	// CONCATENATED MODULE: ./packages/menu/src/submenu.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_submenuvue_type_script_lang_js_ = (submenuvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/menu/src/submenu.vue
	var submenu_render, submenu_staticRenderFns
	
	
	
	
	/* normalize component */
	
	var submenu_component = normalizeComponent(
	  src_submenuvue_type_script_lang_js_,
	  submenu_render,
	  submenu_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var submenu_api; }
	submenu_component.options.__file = "packages/menu/src/submenu.vue"
	/* harmony default export */ var submenu = (submenu_component.exports);
	// CONCATENATED MODULE: ./packages/submenu/index.js
	
	
	/* istanbul ignore next */
	submenu.install = function (Vue) {
	  Vue.component(submenu.name, submenu);
	};
	
	/* harmony default export */ var packages_submenu = (submenu);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/menu/src/menu-item.vue?vue&type=template&id=2a5dbfea&
	var menu_itemvue_type_template_id_2a5dbfea_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "li",
	    {
	      staticClass: "el-menu-item",
	      class: {
	        "is-active": _vm.active,
	        "is-disabled": _vm.disabled
	      },
	      style: [
	        _vm.paddingStyle,
	        _vm.itemStyle,
	        { backgroundColor: _vm.backgroundColor }
	      ],
	      attrs: { role: "menuitem", tabindex: "-1" },
	      on: {
	        click: _vm.handleClick,
	        mouseenter: _vm.onMouseEnter,
	        focus: _vm.onMouseEnter,
	        blur: _vm.onMouseLeave,
	        mouseleave: _vm.onMouseLeave
	      }
	    },
	    [
	      _vm.parentMenu.$options.componentName === "ElMenu" &&
	      _vm.rootMenu.collapse &&
	      _vm.$slots.title
	        ? _c("el-tooltip", { attrs: { effect: "dark", placement: "right" } }, [
	            _c(
	              "div",
	              { attrs: { slot: "content" }, slot: "content" },
	              [_vm._t("title")],
	              2
	            ),
	            _c(
	              "div",
	              {
	                staticStyle: {
	                  position: "absolute",
	                  left: "0",
	                  top: "0",
	                  height: "100%",
	                  width: "100%",
	                  display: "inline-block",
	                  "box-sizing": "border-box",
	                  padding: "0 20px"
	                }
	              },
	              [_vm._t("default")],
	              2
	            )
	          ])
	        : [_vm._t("default"), _vm._t("title")]
	    ],
	    2
	  )
	}
	var menu_itemvue_type_template_id_2a5dbfea_staticRenderFns = []
	menu_itemvue_type_template_id_2a5dbfea_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/menu/src/menu-item.vue?vue&type=template&id=2a5dbfea&
	
	// EXTERNAL MODULE: external "element-ui/lib/tooltip"
	var tooltip_ = __webpack_require__(26);
	var tooltip_default = /*#__PURE__*/__webpack_require__.n(tooltip_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/menu/src/menu-item.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	/* harmony default export */ var menu_itemvue_type_script_lang_js_ = ({
	  name: 'ElMenuItem',
	
	  componentName: 'ElMenuItem',
	
	  mixins: [menu_mixin, emitter_default.a],
	
	  components: { ElTooltip: tooltip_default.a },
	
	  props: {
	    index: {
	      default: null,
	      validator: function validator(val) {
	        return typeof val === 'string' || val === null;
	      }
	    },
	    route: [String, Object],
	    disabled: Boolean
	  },
	  computed: {
	    active: function active() {
	      return this.index === this.rootMenu.activeIndex;
	    },
	    hoverBackground: function hoverBackground() {
	      return this.rootMenu.hoverBackground;
	    },
	    backgroundColor: function backgroundColor() {
	      return this.rootMenu.backgroundColor || '';
	    },
	    activeTextColor: function activeTextColor() {
	      return this.rootMenu.activeTextColor || '';
	    },
	    textColor: function textColor() {
	      return this.rootMenu.textColor || '';
	    },
	    mode: function mode() {
	      return this.rootMenu.mode;
	    },
	    itemStyle: function itemStyle() {
	      var style = {
	        color: this.active ? this.activeTextColor : this.textColor
	      };
	      if (this.mode === 'horizontal' && !this.isNested) {
	        style.borderBottomColor = this.active ? this.rootMenu.activeTextColor ? this.activeTextColor : '' : 'transparent';
	      }
	      return style;
	    },
	    isNested: function isNested() {
	      return this.parentMenu !== this.rootMenu;
	    }
	  },
	  methods: {
	    onMouseEnter: function onMouseEnter() {
	      if (this.mode === 'horizontal' && !this.rootMenu.backgroundColor) return;
	      this.$el.style.backgroundColor = this.hoverBackground;
	    },
	    onMouseLeave: function onMouseLeave() {
	      if (this.mode === 'horizontal' && !this.rootMenu.backgroundColor) return;
	      this.$el.style.backgroundColor = this.backgroundColor;
	    },
	    handleClick: function handleClick() {
	      if (!this.disabled) {
	        this.dispatch('ElMenu', 'item-click', this);
	        this.$emit('click', this);
	      }
	    }
	  },
	  mounted: function mounted() {
	    this.parentMenu.addItem(this);
	    this.rootMenu.addItem(this);
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.parentMenu.removeItem(this);
	    this.rootMenu.removeItem(this);
	  }
	});
	// CONCATENATED MODULE: ./packages/menu/src/menu-item.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_menu_itemvue_type_script_lang_js_ = (menu_itemvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/menu/src/menu-item.vue
	
	
	
	
	
	/* normalize component */
	
	var menu_item_component = normalizeComponent(
	  src_menu_itemvue_type_script_lang_js_,
	  menu_itemvue_type_template_id_2a5dbfea_render,
	  menu_itemvue_type_template_id_2a5dbfea_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var menu_item_api; }
	menu_item_component.options.__file = "packages/menu/src/menu-item.vue"
	/* harmony default export */ var menu_item = (menu_item_component.exports);
	// CONCATENATED MODULE: ./packages/menu-item/index.js
	
	
	/* istanbul ignore next */
	menu_item.install = function (Vue) {
	  Vue.component(menu_item.name, menu_item);
	};
	
	/* harmony default export */ var packages_menu_item = (menu_item);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/menu/src/menu-item-group.vue?vue&type=template&id=543b7bdc&
	var menu_item_groupvue_type_template_id_543b7bdc_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("li", { staticClass: "el-menu-item-group" }, [
	    _c(
	      "div",
	      {
	        staticClass: "el-menu-item-group__title",
	        style: { paddingLeft: _vm.levelPadding + "px" }
	      },
	      [!_vm.$slots.title ? [_vm._v(_vm._s(_vm.title))] : _vm._t("title")],
	      2
	    ),
	    _c("ul", [_vm._t("default")], 2)
	  ])
	}
	var menu_item_groupvue_type_template_id_543b7bdc_staticRenderFns = []
	menu_item_groupvue_type_template_id_543b7bdc_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/menu/src/menu-item-group.vue?vue&type=template&id=543b7bdc&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/menu/src/menu-item-group.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var menu_item_groupvue_type_script_lang_js_ = ({
	  name: 'ElMenuItemGroup',
	
	  componentName: 'ElMenuItemGroup',
	
	  inject: ['rootMenu'],
	  props: {
	    title: {
	      type: String
	    }
	  },
	  data: function data() {
	    return {
	      paddingLeft: 20
	    };
	  },
	
	  computed: {
	    levelPadding: function levelPadding() {
	      var padding = 20;
	      var parent = this.$parent;
	      if (this.rootMenu.collapse) return 20;
	      while (parent && parent.$options.componentName !== 'ElMenu') {
	        if (parent.$options.componentName === 'ElSubmenu') {
	          padding += 20;
	        }
	        parent = parent.$parent;
	      }
	      return padding;
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/menu/src/menu-item-group.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_menu_item_groupvue_type_script_lang_js_ = (menu_item_groupvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/menu/src/menu-item-group.vue
	
	
	
	
	
	/* normalize component */
	
	var menu_item_group_component = normalizeComponent(
	  src_menu_item_groupvue_type_script_lang_js_,
	  menu_item_groupvue_type_template_id_543b7bdc_render,
	  menu_item_groupvue_type_template_id_543b7bdc_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var menu_item_group_api; }
	menu_item_group_component.options.__file = "packages/menu/src/menu-item-group.vue"
	/* harmony default export */ var menu_item_group = (menu_item_group_component.exports);
	// CONCATENATED MODULE: ./packages/menu-item-group/index.js
	
	
	/* istanbul ignore next */
	menu_item_group.install = function (Vue) {
	  Vue.component(menu_item_group.name, menu_item_group);
	};
	
	/* harmony default export */ var packages_menu_item_group = (menu_item_group);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/input/src/input.vue?vue&type=template&id=343dd774&
	var inputvue_type_template_id_343dd774_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      class: [
	        _vm.type === "textarea" ? "el-textarea" : "el-input",
	        _vm.inputSize ? "el-input--" + _vm.inputSize : "",
	        {
	          "is-disabled": _vm.inputDisabled,
	          "is-exceed": _vm.inputExceed,
	          "el-input-group": _vm.$slots.prepend || _vm.$slots.append,
	          "el-input-group--append": _vm.$slots.append,
	          "el-input-group--prepend": _vm.$slots.prepend,
	          "el-input--prefix": _vm.$slots.prefix || _vm.prefixIcon,
	          "el-input--suffix":
	            _vm.$slots.suffix ||
	            _vm.suffixIcon ||
	            _vm.clearable ||
	            _vm.showPassword
	        }
	      ],
	      on: {
	        mouseenter: function($event) {
	          _vm.hovering = true
	        },
	        mouseleave: function($event) {
	          _vm.hovering = false
	        }
	      }
	    },
	    [
	      _vm.type !== "textarea"
	        ? [
	            _vm.$slots.prepend
	              ? _c(
	                  "div",
	                  { staticClass: "el-input-group__prepend" },
	                  [_vm._t("prepend")],
	                  2
	                )
	              : _vm._e(),
	            _vm.type !== "textarea"
	              ? _c(
	                  "input",
	                  _vm._b(
	                    {
	                      ref: "input",
	                      staticClass: "el-input__inner",
	                      attrs: {
	                        tabindex: _vm.tabindex,
	                        type: _vm.showPassword
	                          ? _vm.passwordVisible
	                            ? "text"
	                            : "password"
	                          : _vm.type,
	                        disabled: _vm.inputDisabled,
	                        readonly: _vm.readonly,
	                        autocomplete: _vm.autoComplete || _vm.autocomplete,
	                        "aria-label": _vm.label
	                      },
	                      on: {
	                        compositionstart: _vm.handleCompositionStart,
	                        compositionupdate: _vm.handleCompositionUpdate,
	                        compositionend: _vm.handleCompositionEnd,
	                        input: _vm.handleInput,
	                        focus: _vm.handleFocus,
	                        blur: _vm.handleBlur,
	                        change: _vm.handleChange
	                      }
	                    },
	                    "input",
	                    _vm.$attrs,
	                    false
	                  )
	                )
	              : _vm._e(),
	            _vm.$slots.prefix || _vm.prefixIcon
	              ? _c(
	                  "span",
	                  { staticClass: "el-input__prefix" },
	                  [
	                    _vm._t("prefix"),
	                    _vm.prefixIcon
	                      ? _c("i", {
	                          staticClass: "el-input__icon",
	                          class: _vm.prefixIcon
	                        })
	                      : _vm._e()
	                  ],
	                  2
	                )
	              : _vm._e(),
	            _vm.getSuffixVisible()
	              ? _c("span", { staticClass: "el-input__suffix" }, [
	                  _c(
	                    "span",
	                    { staticClass: "el-input__suffix-inner" },
	                    [
	                      !_vm.showClear ||
	                      !_vm.showPwdVisible ||
	                      !_vm.isWordLimitVisible
	                        ? [
	                            _vm._t("suffix"),
	                            _vm.suffixIcon
	                              ? _c("i", {
	                                  staticClass: "el-input__icon",
	                                  class: _vm.suffixIcon
	                                })
	                              : _vm._e()
	                          ]
	                        : _vm._e(),
	                      _vm.showClear
	                        ? _c("i", {
	                            staticClass:
	                              "el-input__icon el-icon-circle-close el-input__clear",
	                            on: {
	                              mousedown: function($event) {
	                                $event.preventDefault()
	                              },
	                              click: _vm.clear
	                            }
	                          })
	                        : _vm._e(),
	                      _vm.showPwdVisible
	                        ? _c("i", {
	                            staticClass:
	                              "el-input__icon el-icon-view el-input__clear",
	                            on: { click: _vm.handlePasswordVisible }
	                          })
	                        : _vm._e(),
	                      _vm.isWordLimitVisible
	                        ? _c("span", { staticClass: "el-input__count" }, [
	                            _c(
	                              "span",
	                              { staticClass: "el-input__count-inner" },
	                              [
	                                _vm._v(
	                                  "\n            " +
	                                    _vm._s(_vm.textLength) +
	                                    "/" +
	                                    _vm._s(_vm.upperLimit) +
	                                    "\n          "
	                                )
	                              ]
	                            )
	                          ])
	                        : _vm._e()
	                    ],
	                    2
	                  ),
	                  _vm.validateState
	                    ? _c("i", {
	                        staticClass: "el-input__icon",
	                        class: ["el-input__validateIcon", _vm.validateIcon]
	                      })
	                    : _vm._e()
	                ])
	              : _vm._e(),
	            _vm.$slots.append
	              ? _c(
	                  "div",
	                  { staticClass: "el-input-group__append" },
	                  [_vm._t("append")],
	                  2
	                )
	              : _vm._e()
	          ]
	        : _c(
	            "textarea",
	            _vm._b(
	              {
	                ref: "textarea",
	                staticClass: "el-textarea__inner",
	                style: _vm.textareaStyle,
	                attrs: {
	                  tabindex: _vm.tabindex,
	                  disabled: _vm.inputDisabled,
	                  readonly: _vm.readonly,
	                  autocomplete: _vm.autoComplete || _vm.autocomplete,
	                  "aria-label": _vm.label
	                },
	                on: {
	                  compositionstart: _vm.handleCompositionStart,
	                  compositionupdate: _vm.handleCompositionUpdate,
	                  compositionend: _vm.handleCompositionEnd,
	                  input: _vm.handleInput,
	                  focus: _vm.handleFocus,
	                  blur: _vm.handleBlur,
	                  change: _vm.handleChange
	                }
	              },
	              "textarea",
	              _vm.$attrs,
	              false
	            )
	          ),
	      _vm.isWordLimitVisible && _vm.type === "textarea"
	        ? _c("span", { staticClass: "el-input__count" }, [
	            _vm._v(_vm._s(_vm.textLength) + "/" + _vm._s(_vm.upperLimit))
	          ])
	        : _vm._e()
	    ],
	    2
	  )
	}
	var inputvue_type_template_id_343dd774_staticRenderFns = []
	inputvue_type_template_id_343dd774_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/input/src/input.vue?vue&type=template&id=343dd774&
	
	// CONCATENATED MODULE: ./packages/input/src/calcTextareaHeight.js
	var hiddenTextarea = void 0;
	
	var HIDDEN_STYLE = '\n  height:0 !important;\n  visibility:hidden !important;\n  overflow:hidden !important;\n  position:absolute !important;\n  z-index:-1000 !important;\n  top:0 !important;\n  right:0 !important\n';
	
	var CONTEXT_STYLE = ['letter-spacing', 'line-height', 'padding-top', 'padding-bottom', 'font-family', 'font-weight', 'font-size', 'text-rendering', 'text-transform', 'width', 'text-indent', 'padding-left', 'padding-right', 'border-width', 'box-sizing'];
	
	function calculateNodeStyling(targetElement) {
	  var style = window.getComputedStyle(targetElement);
	
	  var boxSizing = style.getPropertyValue('box-sizing');
	
	  var paddingSize = parseFloat(style.getPropertyValue('padding-bottom')) + parseFloat(style.getPropertyValue('padding-top'));
	
	  var borderSize = parseFloat(style.getPropertyValue('border-bottom-width')) + parseFloat(style.getPropertyValue('border-top-width'));
	
	  var contextStyle = CONTEXT_STYLE.map(function (name) {
	    return name + ':' + style.getPropertyValue(name);
	  }).join(';');
	
	  return { contextStyle: contextStyle, paddingSize: paddingSize, borderSize: borderSize, boxSizing: boxSizing };
	}
	
	function calcTextareaHeight(targetElement) {
	  var minRows = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	  var maxRows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	  if (!hiddenTextarea) {
	    hiddenTextarea = document.createElement('textarea');
	    document.body.appendChild(hiddenTextarea);
	  }
	
	  var _calculateNodeStyling = calculateNodeStyling(targetElement),
	      paddingSize = _calculateNodeStyling.paddingSize,
	      borderSize = _calculateNodeStyling.borderSize,
	      boxSizing = _calculateNodeStyling.boxSizing,
	      contextStyle = _calculateNodeStyling.contextStyle;
	
	  hiddenTextarea.setAttribute('style', contextStyle + ';' + HIDDEN_STYLE);
	  hiddenTextarea.value = targetElement.value || targetElement.placeholder || '';
	
	  var height = hiddenTextarea.scrollHeight;
	  var result = {};
	
	  if (boxSizing === 'border-box') {
	    height = height + borderSize;
	  } else if (boxSizing === 'content-box') {
	    height = height - paddingSize;
	  }
	
	  hiddenTextarea.value = '';
	  var singleRowHeight = hiddenTextarea.scrollHeight - paddingSize;
	
	  if (minRows !== null) {
	    var minHeight = singleRowHeight * minRows;
	    if (boxSizing === 'border-box') {
	      minHeight = minHeight + paddingSize + borderSize;
	    }
	    height = Math.max(minHeight, height);
	    result.minHeight = minHeight + 'px';
	  }
	  if (maxRows !== null) {
	    var maxHeight = singleRowHeight * maxRows;
	    if (boxSizing === 'border-box') {
	      maxHeight = maxHeight + paddingSize + borderSize;
	    }
	    height = Math.min(maxHeight, height);
	  }
	  result.height = height + 'px';
	  hiddenTextarea.parentNode && hiddenTextarea.parentNode.removeChild(hiddenTextarea);
	  hiddenTextarea = null;
	  return result;
	};
	// EXTERNAL MODULE: external "element-ui/lib/utils/merge"
	var merge_ = __webpack_require__(7);
	var merge_default = /*#__PURE__*/__webpack_require__.n(merge_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/shared"
	var shared_ = __webpack_require__(19);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/input/src/input.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	/* harmony default export */ var inputvue_type_script_lang_js_ = ({
	  name: 'ElInput',
	
	  componentName: 'ElInput',
	
	  mixins: [emitter_default.a, migrating_default.a],
	
	  inheritAttrs: false,
	
	  inject: {
	    elForm: {
	      default: ''
	    },
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  data: function data() {
	    return {
	      textareaCalcStyle: {},
	      hovering: false,
	      focused: false,
	      isComposing: false,
	      passwordVisible: false
	    };
	  },
	
	
	  props: {
	    value: [String, Number],
	    size: String,
	    resize: String,
	    form: String,
	    disabled: Boolean,
	    readonly: Boolean,
	    type: {
	      type: String,
	      default: 'text'
	    },
	    autosize: {
	      type: [Boolean, Object],
	      default: false
	    },
	    autocomplete: {
	      type: String,
	      default: 'off'
	    },
	    /** @Deprecated in next major version */
	    autoComplete: {
	      type: String,
	      validator: function validator(val) {
	         false && false;
	        return true;
	      }
	    },
	    validateEvent: {
	      type: Boolean,
	      default: true
	    },
	    suffixIcon: String,
	    prefixIcon: String,
	    label: String,
	    clearable: {
	      type: Boolean,
	      default: false
	    },
	    showPassword: {
	      type: Boolean,
	      default: false
	    },
	    showWordLimit: {
	      type: Boolean,
	      default: false
	    },
	    tabindex: String
	  },
	
	  computed: {
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    validateState: function validateState() {
	      return this.elFormItem ? this.elFormItem.validateState : '';
	    },
	    needStatusIcon: function needStatusIcon() {
	      return this.elForm ? this.elForm.statusIcon : false;
	    },
	    validateIcon: function validateIcon() {
	      return {
	        validating: 'el-icon-loading',
	        success: 'el-icon-circle-check',
	        error: 'el-icon-circle-close'
	      }[this.validateState];
	    },
	    textareaStyle: function textareaStyle() {
	      return merge_default()({}, this.textareaCalcStyle, { resize: this.resize });
	    },
	    inputSize: function inputSize() {
	      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
	    },
	    inputDisabled: function inputDisabled() {
	      return this.disabled || (this.elForm || {}).disabled;
	    },
	    nativeInputValue: function nativeInputValue() {
	      return this.value === null || this.value === undefined ? '' : String(this.value);
	    },
	    showClear: function showClear() {
	      return this.clearable && !this.inputDisabled && !this.readonly && this.nativeInputValue && (this.focused || this.hovering);
	    },
	    showPwdVisible: function showPwdVisible() {
	      return this.showPassword && !this.inputDisabled && !this.readonly && (!!this.nativeInputValue || this.focused);
	    },
	    isWordLimitVisible: function isWordLimitVisible() {
	      return this.showWordLimit && this.$attrs.maxlength && (this.type === 'text' || this.type === 'textarea') && !this.inputDisabled && !this.readonly && !this.showPassword;
	    },
	    upperLimit: function upperLimit() {
	      return this.$attrs.maxlength;
	    },
	    textLength: function textLength() {
	      if (typeof this.value === 'number') {
	        return String(this.value).length;
	      }
	
	      return (this.value || '').length;
	    },
	    inputExceed: function inputExceed() {
	      // show exceed style if length of initial value greater then maxlength
	      return this.isWordLimitVisible && this.textLength > this.upperLimit;
	    }
	  },
	
	  watch: {
	    value: function value(val) {
	      this.$nextTick(this.resizeTextarea);
	      if (this.validateEvent) {
	        this.dispatch('ElFormItem', 'el.form.change', [val]);
	      }
	    },
	
	    // native input value is set explicitly
	    // do not use v-model / :value in template
	    // see: https://github.com/ElemeFE/element/issues/14521
	    nativeInputValue: function nativeInputValue() {
	      this.setNativeInputValue();
	    },
	
	    // when change between <input> and <textarea>,
	    // update DOM dependent value and styles
	    // https://github.com/ElemeFE/element/issues/14857
	    type: function type() {
	      var _this = this;
	
	      this.$nextTick(function () {
	        _this.setNativeInputValue();
	        _this.resizeTextarea();
	        _this.updateIconOffset();
	      });
	    }
	  },
	
	  methods: {
	    focus: function focus() {
	      this.getInput().focus();
	    },
	    blur: function blur() {
	      this.getInput().blur();
	    },
	    getMigratingConfig: function getMigratingConfig() {
	      return {
	        props: {
	          'icon': 'icon is removed, use suffix-icon / prefix-icon instead.',
	          'on-icon-click': 'on-icon-click is removed.'
	        },
	        events: {
	          'click': 'click is removed.'
	        }
	      };
	    },
	    handleBlur: function handleBlur(event) {
	      this.focused = false;
	      this.$emit('blur', event);
	      if (this.validateEvent) {
	        this.dispatch('ElFormItem', 'el.form.blur', [this.value]);
	      }
	    },
	    select: function select() {
	      this.getInput().select();
	    },
	    resizeTextarea: function resizeTextarea() {
	      if (this.$isServer) return;
	      var autosize = this.autosize,
	          type = this.type;
	
	      if (type !== 'textarea') return;
	      if (!autosize) {
	        this.textareaCalcStyle = {
	          minHeight: calcTextareaHeight(this.$refs.textarea).minHeight
	        };
	        return;
	      }
	      var minRows = autosize.minRows;
	      var maxRows = autosize.maxRows;
	
	      this.textareaCalcStyle = calcTextareaHeight(this.$refs.textarea, minRows, maxRows);
	    },
	    setNativeInputValue: function setNativeInputValue() {
	      var input = this.getInput();
	      if (!input) return;
	      if (input.value === this.nativeInputValue) return;
	      input.value = this.nativeInputValue;
	    },
	    handleFocus: function handleFocus(event) {
	      this.focused = true;
	      this.$emit('focus', event);
	    },
	    handleCompositionStart: function handleCompositionStart() {
	      this.isComposing = true;
	    },
	    handleCompositionUpdate: function handleCompositionUpdate(event) {
	      var text = event.target.value;
	      var lastCharacter = text[text.length - 1] || '';
	      this.isComposing = !Object(shared_["isKorean"])(lastCharacter);
	    },
	    handleCompositionEnd: function handleCompositionEnd(event) {
	      if (this.isComposing) {
	        this.isComposing = false;
	        this.handleInput(event);
	      }
	    },
	    handleInput: function handleInput(event) {
	      // should not emit input during composition
	      // see: https://github.com/ElemeFE/element/issues/10516
	      if (this.isComposing) return;
	
	      // hack for https://github.com/ElemeFE/element/issues/8548
	      // should remove the following line when we don't support IE
	      if (event.target.value === this.nativeInputValue) return;
	
	      this.$emit('input', event.target.value);
	
	      // ensure native input value is controlled
	      // see: https://github.com/ElemeFE/element/issues/12850
	      this.$nextTick(this.setNativeInputValue);
	    },
	    handleChange: function handleChange(event) {
	      this.$emit('change', event.target.value);
	    },
	    calcIconOffset: function calcIconOffset(place) {
	      var elList = [].slice.call(this.$el.querySelectorAll('.el-input__' + place) || []);
	      if (!elList.length) return;
	      var el = null;
	      for (var i = 0; i < elList.length; i++) {
	        if (elList[i].parentNode === this.$el) {
	          el = elList[i];
	          break;
	        }
	      }
	      if (!el) return;
	      var pendantMap = {
	        suffix: 'append',
	        prefix: 'prepend'
	      };
	
	      var pendant = pendantMap[place];
	      if (this.$slots[pendant]) {
	        el.style.transform = 'translateX(' + (place === 'suffix' ? '-' : '') + this.$el.querySelector('.el-input-group__' + pendant).offsetWidth + 'px)';
	      } else {
	        el.removeAttribute('style');
	      }
	    },
	    updateIconOffset: function updateIconOffset() {
	      this.calcIconOffset('prefix');
	      this.calcIconOffset('suffix');
	    },
	    clear: function clear() {
	      this.$emit('input', '');
	      this.$emit('change', '');
	      this.$emit('clear');
	    },
	    handlePasswordVisible: function handlePasswordVisible() {
	      this.passwordVisible = !this.passwordVisible;
	      this.focus();
	    },
	    getInput: function getInput() {
	      return this.$refs.input || this.$refs.textarea;
	    },
	    getSuffixVisible: function getSuffixVisible() {
	      return this.$slots.suffix || this.suffixIcon || this.showClear || this.showPassword || this.isWordLimitVisible || this.validateState && this.needStatusIcon;
	    }
	  },
	
	  created: function created() {
	    this.$on('inputSelect', this.select);
	  },
	  mounted: function mounted() {
	    this.setNativeInputValue();
	    this.resizeTextarea();
	    this.updateIconOffset();
	  },
	  updated: function updated() {
	    this.$nextTick(this.updateIconOffset);
	  }
	});
	// CONCATENATED MODULE: ./packages/input/src/input.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_inputvue_type_script_lang_js_ = (inputvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/input/src/input.vue
	
	
	
	
	
	/* normalize component */
	
	var input_component = normalizeComponent(
	  src_inputvue_type_script_lang_js_,
	  inputvue_type_template_id_343dd774_render,
	  inputvue_type_template_id_343dd774_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var input_api; }
	input_component.options.__file = "packages/input/src/input.vue"
	/* harmony default export */ var src_input = (input_component.exports);
	// CONCATENATED MODULE: ./packages/input/index.js
	
	
	/* istanbul ignore next */
	src_input.install = function (Vue) {
	  Vue.component(src_input.name, src_input);
	};
	
	/* harmony default export */ var packages_input = (src_input);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/input-number/src/input-number.vue?vue&type=template&id=42f8cf66&
	var input_numbervue_type_template_id_42f8cf66_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      class: [
	        "el-input-number",
	        _vm.inputNumberSize ? "el-input-number--" + _vm.inputNumberSize : "",
	        { "is-disabled": _vm.inputNumberDisabled },
	        { "is-without-controls": !_vm.controls },
	        { "is-controls-right": _vm.controlsAtRight }
	      ],
	      on: {
	        dragstart: function($event) {
	          $event.preventDefault()
	        }
	      }
	    },
	    [
	      _vm.controls
	        ? _c(
	            "span",
	            {
	              directives: [
	                {
	                  name: "repeat-click",
	                  rawName: "v-repeat-click",
	                  value: _vm.decrease,
	                  expression: "decrease"
	                }
	              ],
	              staticClass: "el-input-number__decrease",
	              class: { "is-disabled": _vm.minDisabled },
	              attrs: { role: "button" },
	              on: {
	                keydown: function($event) {
	                  if (
	                    !("button" in $event) &&
	                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
	                  ) {
	                    return null
	                  }
	                  return _vm.decrease($event)
	                }
	              }
	            },
	            [
	              _c("i", {
	                class:
	                  "el-icon-" + (_vm.controlsAtRight ? "arrow-down" : "minus")
	              })
	            ]
	          )
	        : _vm._e(),
	      _vm.controls
	        ? _c(
	            "span",
	            {
	              directives: [
	                {
	                  name: "repeat-click",
	                  rawName: "v-repeat-click",
	                  value: _vm.increase,
	                  expression: "increase"
	                }
	              ],
	              staticClass: "el-input-number__increase",
	              class: { "is-disabled": _vm.maxDisabled },
	              attrs: { role: "button" },
	              on: {
	                keydown: function($event) {
	                  if (
	                    !("button" in $event) &&
	                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
	                  ) {
	                    return null
	                  }
	                  return _vm.increase($event)
	                }
	              }
	            },
	            [
	              _c("i", {
	                class: "el-icon-" + (_vm.controlsAtRight ? "arrow-up" : "plus")
	              })
	            ]
	          )
	        : _vm._e(),
	      _c("el-input", {
	        ref: "input",
	        attrs: {
	          value: _vm.displayValue,
	          placeholder: _vm.placeholder,
	          disabled: _vm.inputNumberDisabled,
	          size: _vm.inputNumberSize,
	          max: _vm.max,
	          min: _vm.min,
	          name: _vm.name,
	          label: _vm.label
	        },
	        on: {
	          blur: _vm.handleBlur,
	          focus: _vm.handleFocus,
	          input: _vm.handleInput,
	          change: _vm.handleInputChange
	        },
	        nativeOn: {
	          keydown: [
	            function($event) {
	              if (
	                !("button" in $event) &&
	                _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])
	              ) {
	                return null
	              }
	              $event.preventDefault()
	              return _vm.increase($event)
	            },
	            function($event) {
	              if (
	                !("button" in $event) &&
	                _vm._k($event.keyCode, "down", 40, $event.key, [
	                  "Down",
	                  "ArrowDown"
	                ])
	              ) {
	                return null
	              }
	              $event.preventDefault()
	              return _vm.decrease($event)
	            }
	          ]
	        }
	      })
	    ],
	    1
	  )
	}
	var input_numbervue_type_template_id_42f8cf66_staticRenderFns = []
	input_numbervue_type_template_id_42f8cf66_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/input-number/src/input-number.vue?vue&type=template&id=42f8cf66&
	
	// CONCATENATED MODULE: ./src/directives/repeat-click.js
	
	
	/* harmony default export */ var repeat_click = ({
	  bind: function bind(el, binding, vnode) {
	    var interval = null;
	    var startTime = void 0;
	    var handler = function handler() {
	      return vnode.context[binding.expression].apply();
	    };
	    var clear = function clear() {
	      if (Date.now() - startTime < 100) {
	        handler();
	      }
	      clearInterval(interval);
	      interval = null;
	    };
	
	    Object(dom_["on"])(el, 'mousedown', function (e) {
	      if (e.button !== 0) return;
	      startTime = Date.now();
	      Object(dom_["once"])(document, 'mouseup', clear);
	      clearInterval(interval);
	      interval = setInterval(handler, 100);
	    });
	  }
	});
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/input-number/src/input-number.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	/* harmony default export */ var input_numbervue_type_script_lang_js_ = ({
	  name: 'ElInputNumber',
	  mixins: [focus_default()('input')],
	  inject: {
	    elForm: {
	      default: ''
	    },
	    elFormItem: {
	      default: ''
	    }
	  },
	  directives: {
	    repeatClick: repeat_click
	  },
	  components: {
	    ElInput: input_default.a
	  },
	  props: {
	    step: {
	      type: Number,
	      default: 1
	    },
	    stepStrictly: {
	      type: Boolean,
	      default: false
	    },
	    max: {
	      type: Number,
	      default: Infinity
	    },
	    min: {
	      type: Number,
	      default: -Infinity
	    },
	    value: {},
	    disabled: Boolean,
	    size: String,
	    controls: {
	      type: Boolean,
	      default: true
	    },
	    controlsPosition: {
	      type: String,
	      default: ''
	    },
	    name: String,
	    label: String,
	    placeholder: String,
	    precision: {
	      type: Number,
	      validator: function validator(val) {
	        return val >= 0 && val === parseInt(val, 10);
	      }
	    }
	  },
	  data: function data() {
	    return {
	      currentValue: 0,
	      userInput: null
	    };
	  },
	
	  watch: {
	    value: {
	      immediate: true,
	      handler: function handler(value) {
	        var newVal = value === undefined ? value : Number(value);
	        if (newVal !== undefined) {
	          if (isNaN(newVal)) {
	            return;
	          }
	
	          if (this.stepStrictly) {
	            var stepPrecision = this.getPrecision(this.step);
	            var precisionFactor = Math.pow(10, stepPrecision);
	            newVal = Math.round(newVal / this.step) * precisionFactor * this.step / precisionFactor;
	          }
	
	          if (this.precision !== undefined) {
	            newVal = this.toPrecision(newVal, this.precision);
	          }
	        }
	        if (newVal >= this.max) newVal = this.max;
	        if (newVal <= this.min) newVal = this.min;
	        this.currentValue = newVal;
	        this.userInput = null;
	        this.$emit('input', newVal);
	      }
	    }
	  },
	  computed: {
	    minDisabled: function minDisabled() {
	      return this._decrease(this.value, this.step) < this.min;
	    },
	    maxDisabled: function maxDisabled() {
	      return this._increase(this.value, this.step) > this.max;
	    },
	    numPrecision: function numPrecision() {
	      var value = this.value,
	          step = this.step,
	          getPrecision = this.getPrecision,
	          precision = this.precision;
	
	      var stepPrecision = getPrecision(step);
	      if (precision !== undefined) {
	        if (stepPrecision > precision) {
	          console.warn('[Element Warn][InputNumber]precision should not be less than the decimal places of step');
	        }
	        return precision;
	      } else {
	        return Math.max(getPrecision(value), stepPrecision);
	      }
	    },
	    controlsAtRight: function controlsAtRight() {
	      return this.controls && this.controlsPosition === 'right';
	    },
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    inputNumberSize: function inputNumberSize() {
	      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
	    },
	    inputNumberDisabled: function inputNumberDisabled() {
	      return this.disabled || (this.elForm || {}).disabled;
	    },
	    displayValue: function displayValue() {
	      if (this.userInput !== null) {
	        return this.userInput;
	      }
	
	      var currentValue = this.currentValue;
	
	      if (typeof currentValue === 'number') {
	        if (this.stepStrictly) {
	          var stepPrecision = this.getPrecision(this.step);
	          var precisionFactor = Math.pow(10, stepPrecision);
	          currentValue = Math.round(currentValue / this.step) * precisionFactor * this.step / precisionFactor;
	        }
	
	        if (this.precision !== undefined) {
	          currentValue = currentValue.toFixed(this.precision);
	        }
	      }
	
	      return currentValue;
	    }
	  },
	  methods: {
	    toPrecision: function toPrecision(num, precision) {
	      if (precision === undefined) precision = this.numPrecision;
	      return parseFloat(Math.round(num * Math.pow(10, precision)) / Math.pow(10, precision));
	    },
	    getPrecision: function getPrecision(value) {
	      if (value === undefined) return 0;
	      var valueString = value.toString();
	      var dotPosition = valueString.indexOf('.');
	      var precision = 0;
	      if (dotPosition !== -1) {
	        precision = valueString.length - dotPosition - 1;
	      }
	      return precision;
	    },
	    _increase: function _increase(val, step) {
	      if (typeof val !== 'number' && val !== undefined) return this.currentValue;
	
	      var precisionFactor = Math.pow(10, this.numPrecision);
	      // Solve the accuracy problem of JS decimal calculation by converting the value to integer.
	      return this.toPrecision((precisionFactor * val + precisionFactor * step) / precisionFactor);
	    },
	    _decrease: function _decrease(val, step) {
	      if (typeof val !== 'number' && val !== undefined) return this.currentValue;
	
	      var precisionFactor = Math.pow(10, this.numPrecision);
	
	      return this.toPrecision((precisionFactor * val - precisionFactor * step) / precisionFactor);
	    },
	    increase: function increase() {
	      if (this.inputNumberDisabled || this.maxDisabled) return;
	      var value = this.value || 0;
	      var newVal = this._increase(value, this.step);
	      this.setCurrentValue(newVal);
	    },
	    decrease: function decrease() {
	      if (this.inputNumberDisabled || this.minDisabled) return;
	      var value = this.value || 0;
	      var newVal = this._decrease(value, this.step);
	      this.setCurrentValue(newVal);
	    },
	    handleBlur: function handleBlur(event) {
	      this.$emit('blur', event);
	    },
	    handleFocus: function handleFocus(event) {
	      this.$emit('focus', event);
	    },
	    setCurrentValue: function setCurrentValue(newVal) {
	      var oldVal = this.currentValue;
	      if (typeof newVal === 'number' && this.precision !== undefined) {
	        newVal = this.toPrecision(newVal, this.precision);
	      }
	      if (newVal >= this.max) newVal = this.max;
	      if (newVal <= this.min) newVal = this.min;
	      if (oldVal === newVal) return;
	      this.userInput = null;
	      this.$emit('input', newVal);
	      this.$emit('change', newVal, oldVal);
	      this.currentValue = newVal;
	    },
	    handleInput: function handleInput(value) {
	      this.userInput = value;
	    },
	    handleInputChange: function handleInputChange(value) {
	      var newVal = value === '' ? undefined : Number(value);
	      if (!isNaN(newVal) || value === '') {
	        this.setCurrentValue(newVal);
	      }
	      this.userInput = null;
	    },
	    select: function select() {
	      this.$refs.input.select();
	    }
	  },
	  mounted: function mounted() {
	    var innerInput = this.$refs.input.$refs.input;
	    innerInput.setAttribute('role', 'spinbutton');
	    innerInput.setAttribute('aria-valuemax', this.max);
	    innerInput.setAttribute('aria-valuemin', this.min);
	    innerInput.setAttribute('aria-valuenow', this.currentValue);
	    innerInput.setAttribute('aria-disabled', this.inputNumberDisabled);
	  },
	  updated: function updated() {
	    if (!this.$refs || !this.$refs.input) return;
	    var innerInput = this.$refs.input.$refs.input;
	    innerInput.setAttribute('aria-valuenow', this.currentValue);
	  }
	});
	// CONCATENATED MODULE: ./packages/input-number/src/input-number.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_input_numbervue_type_script_lang_js_ = (input_numbervue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/input-number/src/input-number.vue
	
	
	
	
	
	/* normalize component */
	
	var input_number_component = normalizeComponent(
	  src_input_numbervue_type_script_lang_js_,
	  input_numbervue_type_template_id_42f8cf66_render,
	  input_numbervue_type_template_id_42f8cf66_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var input_number_api; }
	input_number_component.options.__file = "packages/input-number/src/input-number.vue"
	/* harmony default export */ var input_number = (input_number_component.exports);
	// CONCATENATED MODULE: ./packages/input-number/index.js
	
	
	/* istanbul ignore next */
	input_number.install = function (Vue) {
	  Vue.component(input_number.name, input_number);
	};
	
	/* harmony default export */ var packages_input_number = (input_number);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/radio/src/radio.vue?vue&type=template&id=69cd6268&
	var radiovue_type_template_id_69cd6268_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "label",
	    {
	      staticClass: "el-radio",
	      class: [
	        _vm.border && _vm.radioSize ? "el-radio--" + _vm.radioSize : "",
	        { "is-disabled": _vm.isDisabled },
	        { "is-focus": _vm.focus },
	        { "is-bordered": _vm.border },
	        { "is-checked": _vm.model === _vm.label }
	      ],
	      attrs: {
	        role: "radio",
	        "aria-checked": _vm.model === _vm.label,
	        "aria-disabled": _vm.isDisabled,
	        tabindex: _vm.tabIndex
	      },
	      on: {
	        keydown: function($event) {
	          if (
	            !("button" in $event) &&
	            _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])
	          ) {
	            return null
	          }
	          $event.stopPropagation()
	          $event.preventDefault()
	          _vm.model = _vm.isDisabled ? _vm.model : _vm.label
	        }
	      }
	    },
	    [
	      _c(
	        "span",
	        {
	          staticClass: "el-radio__input",
	          class: {
	            "is-disabled": _vm.isDisabled,
	            "is-checked": _vm.model === _vm.label
	          }
	        },
	        [
	          _c("span", { staticClass: "el-radio__inner" }),
	          _c("input", {
	            directives: [
	              {
	                name: "model",
	                rawName: "v-model",
	                value: _vm.model,
	                expression: "model"
	              }
	            ],
	            ref: "radio",
	            staticClass: "el-radio__original",
	            attrs: {
	              type: "radio",
	              "aria-hidden": "true",
	              name: _vm.name,
	              disabled: _vm.isDisabled,
	              tabindex: "-1"
	            },
	            domProps: {
	              value: _vm.label,
	              checked: _vm._q(_vm.model, _vm.label)
	            },
	            on: {
	              focus: function($event) {
	                _vm.focus = true
	              },
	              blur: function($event) {
	                _vm.focus = false
	              },
	              change: [
	                function($event) {
	                  _vm.model = _vm.label
	                },
	                _vm.handleChange
	              ]
	            }
	          })
	        ]
	      ),
	      _c(
	        "span",
	        {
	          staticClass: "el-radio__label",
	          on: {
	            keydown: function($event) {
	              $event.stopPropagation()
	            }
	          }
	        },
	        [
	          _vm._t("default"),
	          !_vm.$slots.default ? [_vm._v(_vm._s(_vm.label))] : _vm._e()
	        ],
	        2
	      )
	    ]
	  )
	}
	var radiovue_type_template_id_69cd6268_staticRenderFns = []
	radiovue_type_template_id_69cd6268_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/radio/src/radio.vue?vue&type=template&id=69cd6268&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/radio/src/radio.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var radiovue_type_script_lang_js_ = ({
	  name: 'ElRadio',
	
	  mixins: [emitter_default.a],
	
	  inject: {
	    elForm: {
	      default: ''
	    },
	
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  componentName: 'ElRadio',
	
	  props: {
	    value: {},
	    label: {},
	    disabled: Boolean,
	    name: String,
	    border: Boolean,
	    size: String
	  },
	
	  data: function data() {
	    return {
	      focus: false
	    };
	  },
	
	  computed: {
	    isGroup: function isGroup() {
	      var parent = this.$parent;
	      while (parent) {
	        if (parent.$options.componentName !== 'ElRadioGroup') {
	          parent = parent.$parent;
	        } else {
	          this._radioGroup = parent;
	          return true;
	        }
	      }
	      return false;
	    },
	
	    model: {
	      get: function get() {
	        return this.isGroup ? this._radioGroup.value : this.value;
	      },
	      set: function set(val) {
	        if (this.isGroup) {
	          this.dispatch('ElRadioGroup', 'input', [val]);
	        } else {
	          this.$emit('input', val);
	        }
	        this.$refs.radio && (this.$refs.radio.checked = this.model === this.label);
	      }
	    },
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    radioSize: function radioSize() {
	      var temRadioSize = this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
	      return this.isGroup ? this._radioGroup.radioGroupSize || temRadioSize : temRadioSize;
	    },
	    isDisabled: function isDisabled() {
	      return this.isGroup ? this._radioGroup.disabled || this.disabled || (this.elForm || {}).disabled : this.disabled || (this.elForm || {}).disabled;
	    },
	    tabIndex: function tabIndex() {
	      return this.isDisabled || this.isGroup && this.model !== this.label ? -1 : 0;
	    }
	  },
	
	  methods: {
	    handleChange: function handleChange() {
	      var _this = this;
	
	      this.$nextTick(function () {
	        _this.$emit('change', _this.model);
	        _this.isGroup && _this.dispatch('ElRadioGroup', 'handleChange', _this.model);
	      });
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/radio/src/radio.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_radiovue_type_script_lang_js_ = (radiovue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/radio/src/radio.vue
	
	
	
	
	
	/* normalize component */
	
	var radio_component = normalizeComponent(
	  src_radiovue_type_script_lang_js_,
	  radiovue_type_template_id_69cd6268_render,
	  radiovue_type_template_id_69cd6268_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var radio_api; }
	radio_component.options.__file = "packages/radio/src/radio.vue"
	/* harmony default export */ var src_radio = (radio_component.exports);
	// CONCATENATED MODULE: ./packages/radio/index.js
	
	
	/* istanbul ignore next */
	src_radio.install = function (Vue) {
	  Vue.component(src_radio.name, src_radio);
	};
	
	/* harmony default export */ var packages_radio = (src_radio);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/radio/src/radio-group.vue?vue&type=template&id=818a704c&
	var radio_groupvue_type_template_id_818a704c_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    _vm._elTag,
	    {
	      tag: "component",
	      staticClass: "el-radio-group",
	      attrs: { role: "radiogroup" },
	      on: { keydown: _vm.handleKeydown }
	    },
	    [_vm._t("default")],
	    2
	  )
	}
	var radio_groupvue_type_template_id_818a704c_staticRenderFns = []
	radio_groupvue_type_template_id_818a704c_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/radio/src/radio-group.vue?vue&type=template&id=818a704c&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/radio/src/radio-group.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	var keyCode = Object.freeze({
	  LEFT: 37,
	  UP: 38,
	  RIGHT: 39,
	  DOWN: 40
	});
	/* harmony default export */ var radio_groupvue_type_script_lang_js_ = ({
	  name: 'ElRadioGroup',
	
	  componentName: 'ElRadioGroup',
	
	  inject: {
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  mixins: [emitter_default.a],
	
	  props: {
	    value: {},
	    size: String,
	    fill: String,
	    textColor: String,
	    disabled: Boolean
	  },
	
	  computed: {
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    _elTag: function _elTag() {
	      return (this.$vnode.data || {}).tag || 'div';
	    },
	    radioGroupSize: function radioGroupSize() {
	      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
	    }
	  },
	
	  created: function created() {
	    var _this = this;
	
	    this.$on('handleChange', function (value) {
	      _this.$emit('change', value);
	    });
	  },
	  mounted: function mounted() {
	    // 当radioGroup没有默认选项时，第一个可以选中Tab导航
	    var radios = this.$el.querySelectorAll('[type=radio]');
	    var firstLabel = this.$el.querySelectorAll('[role=radio]')[0];
	    if (![].some.call(radios, function (radio) {
	      return radio.checked;
	    }) && firstLabel) {
	      firstLabel.tabIndex = 0;
	    }
	  },
	
	  methods: {
	    handleKeydown: function handleKeydown(e) {
	      // 左右上下按键 可以在radio组内切换不同选项
	      var target = e.target;
	      var className = target.nodeName === 'INPUT' ? '[type=radio]' : '[role=radio]';
	      var radios = this.$el.querySelectorAll(className);
	      var length = radios.length;
	      var index = [].indexOf.call(radios, target);
	      var roleRadios = this.$el.querySelectorAll('[role=radio]');
	      switch (e.keyCode) {
	        case keyCode.LEFT:
	        case keyCode.UP:
	          e.stopPropagation();
	          e.preventDefault();
	          if (index === 0) {
	            roleRadios[length - 1].click();
	            roleRadios[length - 1].focus();
	          } else {
	            roleRadios[index - 1].click();
	            roleRadios[index - 1].focus();
	          }
	          break;
	        case keyCode.RIGHT:
	        case keyCode.DOWN:
	          if (index === length - 1) {
	            e.stopPropagation();
	            e.preventDefault();
	            roleRadios[0].click();
	            roleRadios[0].focus();
	          } else {
	            roleRadios[index + 1].click();
	            roleRadios[index + 1].focus();
	          }
	          break;
	        default:
	          break;
	      }
	    }
	  },
	  watch: {
	    value: function value(_value) {
	      this.dispatch('ElFormItem', 'el.form.change', [this.value]);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/radio/src/radio-group.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_radio_groupvue_type_script_lang_js_ = (radio_groupvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/radio/src/radio-group.vue
	
	
	
	
	
	/* normalize component */
	
	var radio_group_component = normalizeComponent(
	  src_radio_groupvue_type_script_lang_js_,
	  radio_groupvue_type_template_id_818a704c_render,
	  radio_groupvue_type_template_id_818a704c_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var radio_group_api; }
	radio_group_component.options.__file = "packages/radio/src/radio-group.vue"
	/* harmony default export */ var radio_group = (radio_group_component.exports);
	// CONCATENATED MODULE: ./packages/radio-group/index.js
	
	
	/* istanbul ignore next */
	radio_group.install = function (Vue) {
	  Vue.component(radio_group.name, radio_group);
	};
	
	/* harmony default export */ var packages_radio_group = (radio_group);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/radio/src/radio-button.vue?vue&type=template&id=18a77a32&
	var radio_buttonvue_type_template_id_18a77a32_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "label",
	    {
	      staticClass: "el-radio-button",
	      class: [
	        _vm.size ? "el-radio-button--" + _vm.size : "",
	        { "is-active": _vm.value === _vm.label },
	        { "is-disabled": _vm.isDisabled },
	        { "is-focus": _vm.focus }
	      ],
	      attrs: {
	        role: "radio",
	        "aria-checked": _vm.value === _vm.label,
	        "aria-disabled": _vm.isDisabled,
	        tabindex: _vm.tabIndex
	      },
	      on: {
	        keydown: function($event) {
	          if (
	            !("button" in $event) &&
	            _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])
	          ) {
	            return null
	          }
	          $event.stopPropagation()
	          $event.preventDefault()
	          _vm.value = _vm.isDisabled ? _vm.value : _vm.label
	        }
	      }
	    },
	    [
	      _c("input", {
	        directives: [
	          {
	            name: "model",
	            rawName: "v-model",
	            value: _vm.value,
	            expression: "value"
	          }
	        ],
	        staticClass: "el-radio-button__orig-radio",
	        attrs: {
	          type: "radio",
	          name: _vm.name,
	          disabled: _vm.isDisabled,
	          tabindex: "-1"
	        },
	        domProps: { value: _vm.label, checked: _vm._q(_vm.value, _vm.label) },
	        on: {
	          change: [
	            function($event) {
	              _vm.value = _vm.label
	            },
	            _vm.handleChange
	          ],
	          focus: function($event) {
	            _vm.focus = true
	          },
	          blur: function($event) {
	            _vm.focus = false
	          }
	        }
	      }),
	      _c(
	        "span",
	        {
	          staticClass: "el-radio-button__inner",
	          style: _vm.value === _vm.label ? _vm.activeStyle : null,
	          on: {
	            keydown: function($event) {
	              $event.stopPropagation()
	            }
	          }
	        },
	        [
	          _vm._t("default"),
	          !_vm.$slots.default ? [_vm._v(_vm._s(_vm.label))] : _vm._e()
	        ],
	        2
	      )
	    ]
	  )
	}
	var radio_buttonvue_type_template_id_18a77a32_staticRenderFns = []
	radio_buttonvue_type_template_id_18a77a32_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/radio/src/radio-button.vue?vue&type=template&id=18a77a32&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/radio/src/radio-button.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var radio_buttonvue_type_script_lang_js_ = ({
	  name: 'ElRadioButton',
	
	  mixins: [emitter_default.a],
	
	  inject: {
	    elForm: {
	      default: ''
	    },
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  props: {
	    label: {},
	    disabled: Boolean,
	    name: String
	  },
	  data: function data() {
	    return {
	      focus: false
	    };
	  },
	
	  computed: {
	    value: {
	      get: function get() {
	        return this._radioGroup.value;
	      },
	      set: function set(value) {
	        this._radioGroup.$emit('input', value);
	      }
	    },
	    _radioGroup: function _radioGroup() {
	      var parent = this.$parent;
	      while (parent) {
	        if (parent.$options.componentName !== 'ElRadioGroup') {
	          parent = parent.$parent;
	        } else {
	          return parent;
	        }
	      }
	      return false;
	    },
	    activeStyle: function activeStyle() {
	      return {
	        backgroundColor: this._radioGroup.fill || '',
	        borderColor: this._radioGroup.fill || '',
	        boxShadow: this._radioGroup.fill ? '-1px 0 0 0 ' + this._radioGroup.fill : '',
	        color: this._radioGroup.textColor || ''
	      };
	    },
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    size: function size() {
	      return this._radioGroup.radioGroupSize || this._elFormItemSize || (this.$ELEMENT || {}).size;
	    },
	    isDisabled: function isDisabled() {
	      return this.disabled || this._radioGroup.disabled || (this.elForm || {}).disabled;
	    },
	    tabIndex: function tabIndex() {
	      return this.isDisabled || this._radioGroup && this.value !== this.label ? -1 : 0;
	    }
	  },
	
	  methods: {
	    handleChange: function handleChange() {
	      var _this = this;
	
	      this.$nextTick(function () {
	        _this.dispatch('ElRadioGroup', 'handleChange', _this.value);
	      });
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/radio/src/radio-button.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_radio_buttonvue_type_script_lang_js_ = (radio_buttonvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/radio/src/radio-button.vue
	
	
	
	
	
	/* normalize component */
	
	var radio_button_component = normalizeComponent(
	  src_radio_buttonvue_type_script_lang_js_,
	  radio_buttonvue_type_template_id_18a77a32_render,
	  radio_buttonvue_type_template_id_18a77a32_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var radio_button_api; }
	radio_button_component.options.__file = "packages/radio/src/radio-button.vue"
	/* harmony default export */ var radio_button = (radio_button_component.exports);
	// CONCATENATED MODULE: ./packages/radio-button/index.js
	
	
	/* istanbul ignore next */
	radio_button.install = function (Vue) {
	  Vue.component(radio_button.name, radio_button);
	};
	
	/* harmony default export */ var packages_radio_button = (radio_button);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox.vue?vue&type=template&id=d0387074&
	var checkboxvue_type_template_id_d0387074_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "label",
	    {
	      staticClass: "el-checkbox",
	      class: [
	        _vm.border && _vm.checkboxSize
	          ? "el-checkbox--" + _vm.checkboxSize
	          : "",
	        { "is-disabled": _vm.isDisabled },
	        { "is-bordered": _vm.border },
	        { "is-checked": _vm.isChecked }
	      ],
	      attrs: { id: _vm.id }
	    },
	    [
	      _c(
	        "span",
	        {
	          staticClass: "el-checkbox__input",
	          class: {
	            "is-disabled": _vm.isDisabled,
	            "is-checked": _vm.isChecked,
	            "is-indeterminate": _vm.indeterminate,
	            "is-focus": _vm.focus
	          },
	          attrs: {
	            tabindex: _vm.indeterminate ? 0 : false,
	            role: _vm.indeterminate ? "checkbox" : false,
	            "aria-checked": _vm.indeterminate ? "mixed" : false
	          }
	        },
	        [
	          _c("span", { staticClass: "el-checkbox__inner" }),
	          _vm.trueLabel || _vm.falseLabel
	            ? _c("input", {
	                directives: [
	                  {
	                    name: "model",
	                    rawName: "v-model",
	                    value: _vm.model,
	                    expression: "model"
	                  }
	                ],
	                staticClass: "el-checkbox__original",
	                attrs: {
	                  type: "checkbox",
	                  "aria-hidden": _vm.indeterminate ? "true" : "false",
	                  name: _vm.name,
	                  disabled: _vm.isDisabled,
	                  "true-value": _vm.trueLabel,
	                  "false-value": _vm.falseLabel
	                },
	                domProps: {
	                  checked: Array.isArray(_vm.model)
	                    ? _vm._i(_vm.model, null) > -1
	                    : _vm._q(_vm.model, _vm.trueLabel)
	                },
	                on: {
	                  change: [
	                    function($event) {
	                      var $$a = _vm.model,
	                        $$el = $event.target,
	                        $$c = $$el.checked ? _vm.trueLabel : _vm.falseLabel
	                      if (Array.isArray($$a)) {
	                        var $$v = null,
	                          $$i = _vm._i($$a, $$v)
	                        if ($$el.checked) {
	                          $$i < 0 && (_vm.model = $$a.concat([$$v]))
	                        } else {
	                          $$i > -1 &&
	                            (_vm.model = $$a
	                              .slice(0, $$i)
	                              .concat($$a.slice($$i + 1)))
	                        }
	                      } else {
	                        _vm.model = $$c
	                      }
	                    },
	                    _vm.handleChange
	                  ],
	                  focus: function($event) {
	                    _vm.focus = true
	                  },
	                  blur: function($event) {
	                    _vm.focus = false
	                  }
	                }
	              })
	            : _c("input", {
	                directives: [
	                  {
	                    name: "model",
	                    rawName: "v-model",
	                    value: _vm.model,
	                    expression: "model"
	                  }
	                ],
	                staticClass: "el-checkbox__original",
	                attrs: {
	                  type: "checkbox",
	                  "aria-hidden": _vm.indeterminate ? "true" : "false",
	                  disabled: _vm.isDisabled,
	                  name: _vm.name
	                },
	                domProps: {
	                  value: _vm.label,
	                  checked: Array.isArray(_vm.model)
	                    ? _vm._i(_vm.model, _vm.label) > -1
	                    : _vm.model
	                },
	                on: {
	                  change: [
	                    function($event) {
	                      var $$a = _vm.model,
	                        $$el = $event.target,
	                        $$c = $$el.checked ? true : false
	                      if (Array.isArray($$a)) {
	                        var $$v = _vm.label,
	                          $$i = _vm._i($$a, $$v)
	                        if ($$el.checked) {
	                          $$i < 0 && (_vm.model = $$a.concat([$$v]))
	                        } else {
	                          $$i > -1 &&
	                            (_vm.model = $$a
	                              .slice(0, $$i)
	                              .concat($$a.slice($$i + 1)))
	                        }
	                      } else {
	                        _vm.model = $$c
	                      }
	                    },
	                    _vm.handleChange
	                  ],
	                  focus: function($event) {
	                    _vm.focus = true
	                  },
	                  blur: function($event) {
	                    _vm.focus = false
	                  }
	                }
	              })
	        ]
	      ),
	      _vm.$slots.default || _vm.label
	        ? _c(
	            "span",
	            { staticClass: "el-checkbox__label" },
	            [
	              _vm._t("default"),
	              !_vm.$slots.default ? [_vm._v(_vm._s(_vm.label))] : _vm._e()
	            ],
	            2
	          )
	        : _vm._e()
	    ]
	  )
	}
	var checkboxvue_type_template_id_d0387074_staticRenderFns = []
	checkboxvue_type_template_id_d0387074_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/checkbox/src/checkbox.vue?vue&type=template&id=d0387074&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var checkboxvue_type_script_lang_js_ = ({
	  name: 'ElCheckbox',
	
	  mixins: [emitter_default.a],
	
	  inject: {
	    elForm: {
	      default: ''
	    },
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  componentName: 'ElCheckbox',
	
	  data: function data() {
	    return {
	      selfModel: false,
	      focus: false,
	      isLimitExceeded: false
	    };
	  },
	
	
	  computed: {
	    model: {
	      get: function get() {
	        return this.isGroup ? this.store : this.value !== undefined ? this.value : this.selfModel;
	      },
	      set: function set(val) {
	        if (this.isGroup) {
	          this.isLimitExceeded = false;
	          this._checkboxGroup.min !== undefined && val.length < this._checkboxGroup.min && (this.isLimitExceeded = true);
	
	          this._checkboxGroup.max !== undefined && val.length > this._checkboxGroup.max && (this.isLimitExceeded = true);
	
	          this.isLimitExceeded === false && this.dispatch('ElCheckboxGroup', 'input', [val]);
	        } else {
	          this.$emit('input', val);
	          this.selfModel = val;
	        }
	      }
	    },
	
	    isChecked: function isChecked() {
	      if ({}.toString.call(this.model) === '[object Boolean]') {
	        return this.model;
	      } else if (Array.isArray(this.model)) {
	        return this.model.indexOf(this.label) > -1;
	      } else if (this.model !== null && this.model !== undefined) {
	        return this.model === this.trueLabel;
	      }
	    },
	    isGroup: function isGroup() {
	      var parent = this.$parent;
	      while (parent) {
	        if (parent.$options.componentName !== 'ElCheckboxGroup') {
	          parent = parent.$parent;
	        } else {
	          this._checkboxGroup = parent;
	          return true;
	        }
	      }
	      return false;
	    },
	    store: function store() {
	      return this._checkboxGroup ? this._checkboxGroup.value : this.value;
	    },
	
	
	    /* used to make the isDisabled judgment under max/min props */
	    isLimitDisabled: function isLimitDisabled() {
	      var _checkboxGroup = this._checkboxGroup,
	          max = _checkboxGroup.max,
	          min = _checkboxGroup.min;
	
	      return !!(max || min) && this.model.length >= max && !this.isChecked || this.model.length <= min && this.isChecked;
	    },
	    isDisabled: function isDisabled() {
	      return this.isGroup ? this._checkboxGroup.disabled || this.disabled || (this.elForm || {}).disabled || this.isLimitDisabled : this.disabled || (this.elForm || {}).disabled;
	    },
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    checkboxSize: function checkboxSize() {
	      var temCheckboxSize = this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
	      return this.isGroup ? this._checkboxGroup.checkboxGroupSize || temCheckboxSize : temCheckboxSize;
	    }
	  },
	
	  props: {
	    value: {},
	    label: {},
	    indeterminate: Boolean,
	    disabled: Boolean,
	    checked: Boolean,
	    name: String,
	    trueLabel: [String, Number],
	    falseLabel: [String, Number],
	    id: String, /* 当indeterminate为真时，为controls提供相关连的checkbox的id，表明元素间的控制关系*/
	    controls: String, /* 当indeterminate为真时，为controls提供相关连的checkbox的id，表明元素间的控制关系*/
	    border: Boolean,
	    size: String
	  },
	
	  methods: {
	    addToStore: function addToStore() {
	      if (Array.isArray(this.model) && this.model.indexOf(this.label) === -1) {
	        this.model.push(this.label);
	      } else {
	        this.model = this.trueLabel || true;
	      }
	    },
	    handleChange: function handleChange(ev) {
	      var _this = this;
	
	      if (this.isLimitExceeded) return;
	      var value = void 0;
	      if (ev.target.checked) {
	        value = this.trueLabel === undefined ? true : this.trueLabel;
	      } else {
	        value = this.falseLabel === undefined ? false : this.falseLabel;
	      }
	      this.$emit('change', value, ev);
	      this.$nextTick(function () {
	        if (_this.isGroup) {
	          _this.dispatch('ElCheckboxGroup', 'change', [_this._checkboxGroup.value]);
	        }
	      });
	    }
	  },
	
	  created: function created() {
	    this.checked && this.addToStore();
	  },
	  mounted: function mounted() {
	    // 为indeterminate元素 添加aria-controls 属性
	    if (this.indeterminate) {
	      this.$el.setAttribute('aria-controls', this.controls);
	    }
	  },
	
	
	  watch: {
	    value: function value(_value) {
	      this.dispatch('ElFormItem', 'el.form.change', _value);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/checkbox/src/checkbox.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_checkboxvue_type_script_lang_js_ = (checkboxvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/checkbox/src/checkbox.vue
	
	
	
	
	
	/* normalize component */
	
	var checkbox_component = normalizeComponent(
	  src_checkboxvue_type_script_lang_js_,
	  checkboxvue_type_template_id_d0387074_render,
	  checkboxvue_type_template_id_d0387074_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var checkbox_api; }
	checkbox_component.options.__file = "packages/checkbox/src/checkbox.vue"
	/* harmony default export */ var src_checkbox = (checkbox_component.exports);
	// CONCATENATED MODULE: ./packages/checkbox/index.js
	
	
	/* istanbul ignore next */
	src_checkbox.install = function (Vue) {
	  Vue.component(src_checkbox.name, src_checkbox);
	};
	
	/* harmony default export */ var packages_checkbox = (src_checkbox);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox-button.vue?vue&type=template&id=478e906e&
	var checkbox_buttonvue_type_template_id_478e906e_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "label",
	    {
	      staticClass: "el-checkbox-button",
	      class: [
	        _vm.size ? "el-checkbox-button--" + _vm.size : "",
	        { "is-disabled": _vm.isDisabled },
	        { "is-checked": _vm.isChecked },
	        { "is-focus": _vm.focus }
	      ],
	      attrs: {
	        role: "checkbox",
	        "aria-checked": _vm.isChecked,
	        "aria-disabled": _vm.isDisabled
	      }
	    },
	    [
	      _vm.trueLabel || _vm.falseLabel
	        ? _c("input", {
	            directives: [
	              {
	                name: "model",
	                rawName: "v-model",
	                value: _vm.model,
	                expression: "model"
	              }
	            ],
	            staticClass: "el-checkbox-button__original",
	            attrs: {
	              type: "checkbox",
	              name: _vm.name,
	              disabled: _vm.isDisabled,
	              "true-value": _vm.trueLabel,
	              "false-value": _vm.falseLabel
	            },
	            domProps: {
	              checked: Array.isArray(_vm.model)
	                ? _vm._i(_vm.model, null) > -1
	                : _vm._q(_vm.model, _vm.trueLabel)
	            },
	            on: {
	              change: [
	                function($event) {
	                  var $$a = _vm.model,
	                    $$el = $event.target,
	                    $$c = $$el.checked ? _vm.trueLabel : _vm.falseLabel
	                  if (Array.isArray($$a)) {
	                    var $$v = null,
	                      $$i = _vm._i($$a, $$v)
	                    if ($$el.checked) {
	                      $$i < 0 && (_vm.model = $$a.concat([$$v]))
	                    } else {
	                      $$i > -1 &&
	                        (_vm.model = $$a
	                          .slice(0, $$i)
	                          .concat($$a.slice($$i + 1)))
	                    }
	                  } else {
	                    _vm.model = $$c
	                  }
	                },
	                _vm.handleChange
	              ],
	              focus: function($event) {
	                _vm.focus = true
	              },
	              blur: function($event) {
	                _vm.focus = false
	              }
	            }
	          })
	        : _c("input", {
	            directives: [
	              {
	                name: "model",
	                rawName: "v-model",
	                value: _vm.model,
	                expression: "model"
	              }
	            ],
	            staticClass: "el-checkbox-button__original",
	            attrs: {
	              type: "checkbox",
	              name: _vm.name,
	              disabled: _vm.isDisabled
	            },
	            domProps: {
	              value: _vm.label,
	              checked: Array.isArray(_vm.model)
	                ? _vm._i(_vm.model, _vm.label) > -1
	                : _vm.model
	            },
	            on: {
	              change: [
	                function($event) {
	                  var $$a = _vm.model,
	                    $$el = $event.target,
	                    $$c = $$el.checked ? true : false
	                  if (Array.isArray($$a)) {
	                    var $$v = _vm.label,
	                      $$i = _vm._i($$a, $$v)
	                    if ($$el.checked) {
	                      $$i < 0 && (_vm.model = $$a.concat([$$v]))
	                    } else {
	                      $$i > -1 &&
	                        (_vm.model = $$a
	                          .slice(0, $$i)
	                          .concat($$a.slice($$i + 1)))
	                    }
	                  } else {
	                    _vm.model = $$c
	                  }
	                },
	                _vm.handleChange
	              ],
	              focus: function($event) {
	                _vm.focus = true
	              },
	              blur: function($event) {
	                _vm.focus = false
	              }
	            }
	          }),
	      _vm.$slots.default || _vm.label
	        ? _c(
	            "span",
	            {
	              staticClass: "el-checkbox-button__inner",
	              style: _vm.isChecked ? _vm.activeStyle : null
	            },
	            [_vm._t("default", [_vm._v(_vm._s(_vm.label))])],
	            2
	          )
	        : _vm._e()
	    ]
	  )
	}
	var checkbox_buttonvue_type_template_id_478e906e_staticRenderFns = []
	checkbox_buttonvue_type_template_id_478e906e_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/checkbox/src/checkbox-button.vue?vue&type=template&id=478e906e&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox-button.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var checkbox_buttonvue_type_script_lang_js_ = ({
	  name: 'ElCheckboxButton',
	
	  mixins: [emitter_default.a],
	
	  inject: {
	    elForm: {
	      default: ''
	    },
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  data: function data() {
	    return {
	      selfModel: false,
	      focus: false,
	      isLimitExceeded: false
	    };
	  },
	
	
	  props: {
	    value: {},
	    label: {},
	    disabled: Boolean,
	    checked: Boolean,
	    name: String,
	    trueLabel: [String, Number],
	    falseLabel: [String, Number]
	  },
	  computed: {
	    model: {
	      get: function get() {
	        return this._checkboxGroup ? this.store : this.value !== undefined ? this.value : this.selfModel;
	      },
	      set: function set(val) {
	        if (this._checkboxGroup) {
	          this.isLimitExceeded = false;
	          this._checkboxGroup.min !== undefined && val.length < this._checkboxGroup.min && (this.isLimitExceeded = true);
	
	          this._checkboxGroup.max !== undefined && val.length > this._checkboxGroup.max && (this.isLimitExceeded = true);
	
	          this.isLimitExceeded === false && this.dispatch('ElCheckboxGroup', 'input', [val]);
	        } else if (this.value !== undefined) {
	          this.$emit('input', val);
	        } else {
	          this.selfModel = val;
	        }
	      }
	    },
	
	    isChecked: function isChecked() {
	      if ({}.toString.call(this.model) === '[object Boolean]') {
	        return this.model;
	      } else if (Array.isArray(this.model)) {
	        return this.model.indexOf(this.label) > -1;
	      } else if (this.model !== null && this.model !== undefined) {
	        return this.model === this.trueLabel;
	      }
	    },
	    _checkboxGroup: function _checkboxGroup() {
	      var parent = this.$parent;
	      while (parent) {
	        if (parent.$options.componentName !== 'ElCheckboxGroup') {
	          parent = parent.$parent;
	        } else {
	          return parent;
	        }
	      }
	      return false;
	    },
	    store: function store() {
	      return this._checkboxGroup ? this._checkboxGroup.value : this.value;
	    },
	    activeStyle: function activeStyle() {
	      return {
	        backgroundColor: this._checkboxGroup.fill || '',
	        borderColor: this._checkboxGroup.fill || '',
	        color: this._checkboxGroup.textColor || '',
	        'box-shadow': '-1px 0 0 0 ' + this._checkboxGroup.fill
	
	      };
	    },
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    size: function size() {
	      return this._checkboxGroup.checkboxGroupSize || this._elFormItemSize || (this.$ELEMENT || {}).size;
	    },
	
	
	    /* used to make the isDisabled judgment under max/min props */
	    isLimitDisabled: function isLimitDisabled() {
	      var _checkboxGroup2 = this._checkboxGroup,
	          max = _checkboxGroup2.max,
	          min = _checkboxGroup2.min;
	
	      return !!(max || min) && this.model.length >= max && !this.isChecked || this.model.length <= min && this.isChecked;
	    },
	    isDisabled: function isDisabled() {
	      return this._checkboxGroup ? this._checkboxGroup.disabled || this.disabled || (this.elForm || {}).disabled || this.isLimitDisabled : this.disabled || (this.elForm || {}).disabled;
	    }
	  },
	  methods: {
	    addToStore: function addToStore() {
	      if (Array.isArray(this.model) && this.model.indexOf(this.label) === -1) {
	        this.model.push(this.label);
	      } else {
	        this.model = this.trueLabel || true;
	      }
	    },
	    handleChange: function handleChange(ev) {
	      var _this = this;
	
	      if (this.isLimitExceeded) return;
	      var value = void 0;
	      if (ev.target.checked) {
	        value = this.trueLabel === undefined ? true : this.trueLabel;
	      } else {
	        value = this.falseLabel === undefined ? false : this.falseLabel;
	      }
	      this.$emit('change', value, ev);
	      this.$nextTick(function () {
	        if (_this._checkboxGroup) {
	          _this.dispatch('ElCheckboxGroup', 'change', [_this._checkboxGroup.value]);
	        }
	      });
	    }
	  },
	
	  created: function created() {
	    this.checked && this.addToStore();
	  }
	});
	// CONCATENATED MODULE: ./packages/checkbox/src/checkbox-button.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_checkbox_buttonvue_type_script_lang_js_ = (checkbox_buttonvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/checkbox/src/checkbox-button.vue
	
	
	
	
	
	/* normalize component */
	
	var checkbox_button_component = normalizeComponent(
	  src_checkbox_buttonvue_type_script_lang_js_,
	  checkbox_buttonvue_type_template_id_478e906e_render,
	  checkbox_buttonvue_type_template_id_478e906e_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var checkbox_button_api; }
	checkbox_button_component.options.__file = "packages/checkbox/src/checkbox-button.vue"
	/* harmony default export */ var checkbox_button = (checkbox_button_component.exports);
	// CONCATENATED MODULE: ./packages/checkbox-button/index.js
	
	
	/* istanbul ignore next */
	checkbox_button.install = function (Vue) {
	  Vue.component(checkbox_button.name, checkbox_button);
	};
	
	/* harmony default export */ var packages_checkbox_button = (checkbox_button);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox-group.vue?vue&type=template&id=7289a290&
	var checkbox_groupvue_type_template_id_7289a290_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-checkbox-group",
	      attrs: { role: "group", "aria-label": "checkbox-group" }
	    },
	    [_vm._t("default")],
	    2
	  )
	}
	var checkbox_groupvue_type_template_id_7289a290_staticRenderFns = []
	checkbox_groupvue_type_template_id_7289a290_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/checkbox/src/checkbox-group.vue?vue&type=template&id=7289a290&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox-group.vue?vue&type=script&lang=js&
	
	
	
	/* harmony default export */ var checkbox_groupvue_type_script_lang_js_ = ({
	  name: 'ElCheckboxGroup',
	
	  componentName: 'ElCheckboxGroup',
	
	  mixins: [emitter_default.a],
	
	  inject: {
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  props: {
	    value: {},
	    disabled: Boolean,
	    min: Number,
	    max: Number,
	    size: String,
	    fill: String,
	    textColor: String
	  },
	
	  computed: {
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    checkboxGroupSize: function checkboxGroupSize() {
	      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
	    }
	  },
	
	  watch: {
	    value: function value(_value) {
	      this.dispatch('ElFormItem', 'el.form.change', [_value]);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/checkbox/src/checkbox-group.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_checkbox_groupvue_type_script_lang_js_ = (checkbox_groupvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/checkbox/src/checkbox-group.vue
	
	
	
	
	
	/* normalize component */
	
	var checkbox_group_component = normalizeComponent(
	  src_checkbox_groupvue_type_script_lang_js_,
	  checkbox_groupvue_type_template_id_7289a290_render,
	  checkbox_groupvue_type_template_id_7289a290_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var checkbox_group_api; }
	checkbox_group_component.options.__file = "packages/checkbox/src/checkbox-group.vue"
	/* harmony default export */ var checkbox_group = (checkbox_group_component.exports);
	// CONCATENATED MODULE: ./packages/checkbox-group/index.js
	
	
	/* istanbul ignore next */
	checkbox_group.install = function (Vue) {
	  Vue.component(checkbox_group.name, checkbox_group);
	};
	
	/* harmony default export */ var packages_checkbox_group = (checkbox_group);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/switch/src/component.vue?vue&type=template&id=2dcd8fbb&
	var componentvue_type_template_id_2dcd8fbb_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-switch",
	      class: { "is-disabled": _vm.switchDisabled, "is-checked": _vm.checked },
	      attrs: {
	        role: "switch",
	        "aria-checked": _vm.checked,
	        "aria-disabled": _vm.switchDisabled
	      },
	      on: {
	        click: function($event) {
	          $event.preventDefault()
	          return _vm.switchValue($event)
	        }
	      }
	    },
	    [
	      _c("input", {
	        ref: "input",
	        staticClass: "el-switch__input",
	        attrs: {
	          type: "checkbox",
	          id: _vm.id,
	          name: _vm.name,
	          "true-value": _vm.activeValue,
	          "false-value": _vm.inactiveValue,
	          disabled: _vm.switchDisabled
	        },
	        on: {
	          change: _vm.handleChange,
	          keydown: function($event) {
	            if (
	              !("button" in $event) &&
	              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
	            ) {
	              return null
	            }
	            return _vm.switchValue($event)
	          }
	        }
	      }),
	      _vm.inactiveIconClass || _vm.inactiveText
	        ? _c(
	            "span",
	            {
	              class: [
	                "el-switch__label",
	                "el-switch__label--left",
	                !_vm.checked ? "is-active" : ""
	              ]
	            },
	            [
	              _vm.inactiveIconClass
	                ? _c("i", { class: [_vm.inactiveIconClass] })
	                : _vm._e(),
	              !_vm.inactiveIconClass && _vm.inactiveText
	                ? _c("span", { attrs: { "aria-hidden": _vm.checked } }, [
	                    _vm._v(_vm._s(_vm.inactiveText))
	                  ])
	                : _vm._e()
	            ]
	          )
	        : _vm._e(),
	      _c("span", {
	        ref: "core",
	        staticClass: "el-switch__core",
	        style: { width: _vm.coreWidth + "px" }
	      }),
	      _vm.activeIconClass || _vm.activeText
	        ? _c(
	            "span",
	            {
	              class: [
	                "el-switch__label",
	                "el-switch__label--right",
	                _vm.checked ? "is-active" : ""
	              ]
	            },
	            [
	              _vm.activeIconClass
	                ? _c("i", { class: [_vm.activeIconClass] })
	                : _vm._e(),
	              !_vm.activeIconClass && _vm.activeText
	                ? _c("span", { attrs: { "aria-hidden": !_vm.checked } }, [
	                    _vm._v(_vm._s(_vm.activeText))
	                  ])
	                : _vm._e()
	            ]
	          )
	        : _vm._e()
	    ]
	  )
	}
	var componentvue_type_template_id_2dcd8fbb_staticRenderFns = []
	componentvue_type_template_id_2dcd8fbb_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/switch/src/component.vue?vue&type=template&id=2dcd8fbb&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/switch/src/component.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	/* harmony default export */ var switch_src_componentvue_type_script_lang_js_ = ({
	  name: 'ElSwitch',
	  mixins: [focus_default()('input'), migrating_default.a, emitter_default.a],
	  inject: {
	    elForm: {
	      default: ''
	    }
	  },
	  props: {
	    value: {
	      type: [Boolean, String, Number],
	      default: false
	    },
	    disabled: {
	      type: Boolean,
	      default: false
	    },
	    width: {
	      type: Number,
	      default: 40
	    },
	    activeIconClass: {
	      type: String,
	      default: ''
	    },
	    inactiveIconClass: {
	      type: String,
	      default: ''
	    },
	    activeText: String,
	    inactiveText: String,
	    activeColor: {
	      type: String,
	      default: ''
	    },
	    inactiveColor: {
	      type: String,
	      default: ''
	    },
	    activeValue: {
	      type: [Boolean, String, Number],
	      default: true
	    },
	    inactiveValue: {
	      type: [Boolean, String, Number],
	      default: false
	    },
	    name: {
	      type: String,
	      default: ''
	    },
	    validateEvent: {
	      type: Boolean,
	      default: true
	    },
	    id: String
	  },
	  data: function data() {
	    return {
	      coreWidth: this.width
	    };
	  },
	  created: function created() {
	    if (!~[this.activeValue, this.inactiveValue].indexOf(this.value)) {
	      this.$emit('input', this.inactiveValue);
	    }
	  },
	
	  computed: {
	    checked: function checked() {
	      return this.value === this.activeValue;
	    },
	    switchDisabled: function switchDisabled() {
	      return this.disabled || (this.elForm || {}).disabled;
	    }
	  },
	  watch: {
	    checked: function checked() {
	      this.$refs.input.checked = this.checked;
	      if (this.activeColor || this.inactiveColor) {
	        this.setBackgroundColor();
	      }
	      if (this.validateEvent) {
	        this.dispatch('ElFormItem', 'el.form.change', [this.value]);
	      }
	    }
	  },
	  methods: {
	    handleChange: function handleChange(event) {
	      var _this = this;
	
	      var val = this.checked ? this.inactiveValue : this.activeValue;
	      this.$emit('input', val);
	      this.$emit('change', val);
	      this.$nextTick(function () {
	        // set input's checked property
	        // in case parent refuses to change component's value
	        _this.$refs.input.checked = _this.checked;
	      });
	    },
	    setBackgroundColor: function setBackgroundColor() {
	      var newColor = this.checked ? this.activeColor : this.inactiveColor;
	      this.$refs.core.style.borderColor = newColor;
	      this.$refs.core.style.backgroundColor = newColor;
	    },
	    switchValue: function switchValue() {
	      !this.switchDisabled && this.handleChange();
	    },
	    getMigratingConfig: function getMigratingConfig() {
	      return {
	        props: {
	          'on-color': 'on-color is renamed to active-color.',
	          'off-color': 'off-color is renamed to inactive-color.',
	          'on-text': 'on-text is renamed to active-text.',
	          'off-text': 'off-text is renamed to inactive-text.',
	          'on-value': 'on-value is renamed to active-value.',
	          'off-value': 'off-value is renamed to inactive-value.',
	          'on-icon-class': 'on-icon-class is renamed to active-icon-class.',
	          'off-icon-class': 'off-icon-class is renamed to inactive-icon-class.'
	        }
	      };
	    }
	  },
	  mounted: function mounted() {
	    /* istanbul ignore if */
	    this.coreWidth = this.width || 40;
	    if (this.activeColor || this.inactiveColor) {
	      this.setBackgroundColor();
	    }
	    this.$refs.input.checked = this.checked;
	  }
	});
	// CONCATENATED MODULE: ./packages/switch/src/component.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_switch_src_componentvue_type_script_lang_js_ = (switch_src_componentvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/switch/src/component.vue
	
	
	
	
	
	/* normalize component */
	
	var src_component_component = normalizeComponent(
	  packages_switch_src_componentvue_type_script_lang_js_,
	  componentvue_type_template_id_2dcd8fbb_render,
	  componentvue_type_template_id_2dcd8fbb_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var src_component_api; }
	src_component_component.options.__file = "packages/switch/src/component.vue"
	/* harmony default export */ var switch_src_component = (src_component_component.exports);
	// CONCATENATED MODULE: ./packages/switch/index.js
	
	
	/* istanbul ignore next */
	switch_src_component.install = function (Vue) {
	  Vue.component(switch_src_component.name, switch_src_component);
	};
	
	/* harmony default export */ var packages_switch = (switch_src_component);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/select.vue?vue&type=template&id=0e4aade6&
	var selectvue_type_template_id_0e4aade6_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      directives: [
	        {
	          name: "clickoutside",
	          rawName: "v-clickoutside",
	          value: _vm.handleClose,
	          expression: "handleClose"
	        }
	      ],
	      staticClass: "el-select",
	      class: [_vm.selectSize ? "el-select--" + _vm.selectSize : ""],
	      on: {
	        click: function($event) {
	          $event.stopPropagation()
	          return _vm.toggleMenu($event)
	        }
	      }
	    },
	    [
	      _vm.multiple
	        ? _c(
	            "div",
	            {
	              ref: "tags",
	              staticClass: "el-select__tags",
	              style: { "max-width": _vm.inputWidth - 32 + "px", width: "100%" }
	            },
	            [
	              _vm.collapseTags && _vm.selected.length
	                ? _c(
	                    "span",
	                    [
	                      _c(
	                        "el-tag",
	                        {
	                          attrs: {
	                            closable: !_vm.selectDisabled,
	                            size: _vm.collapseTagSize,
	                            hit: _vm.selected[0].hitState,
	                            type: "info",
	                            "disable-transitions": ""
	                          },
	                          on: {
	                            close: function($event) {
	                              _vm.deleteTag($event, _vm.selected[0])
	                            }
	                          }
	                        },
	                        [
	                          _c("span", { staticClass: "el-select__tags-text" }, [
	                            _vm._v(_vm._s(_vm.selected[0].currentLabel))
	                          ])
	                        ]
	                      ),
	                      _vm.selected.length > 1
	                        ? _c(
	                            "el-tag",
	                            {
	                              attrs: {
	                                closable: false,
	                                size: _vm.collapseTagSize,
	                                type: "info",
	                                "disable-transitions": ""
	                              }
	                            },
	                            [
	                              _c(
	                                "span",
	                                { staticClass: "el-select__tags-text" },
	                                [_vm._v("+ " + _vm._s(_vm.selected.length - 1))]
	                              )
	                            ]
	                          )
	                        : _vm._e()
	                    ],
	                    1
	                  )
	                : _vm._e(),
	              !_vm.collapseTags
	                ? _c(
	                    "transition-group",
	                    { on: { "after-leave": _vm.resetInputHeight } },
	                    _vm._l(_vm.selected, function(item) {
	                      return _c(
	                        "el-tag",
	                        {
	                          key: _vm.getValueKey(item),
	                          attrs: {
	                            closable: !_vm.selectDisabled,
	                            size: _vm.collapseTagSize,
	                            hit: item.hitState,
	                            type: "info",
	                            "disable-transitions": ""
	                          },
	                          on: {
	                            close: function($event) {
	                              _vm.deleteTag($event, item)
	                            }
	                          }
	                        },
	                        [
	                          _c("span", { staticClass: "el-select__tags-text" }, [
	                            _vm._v(_vm._s(item.currentLabel))
	                          ])
	                        ]
	                      )
	                    }),
	                    1
	                  )
	                : _vm._e(),
	              _vm.filterable
	                ? _c("input", {
	                    directives: [
	                      {
	                        name: "model",
	                        rawName: "v-model",
	                        value: _vm.query,
	                        expression: "query"
	                      }
	                    ],
	                    ref: "input",
	                    staticClass: "el-select__input",
	                    class: [_vm.selectSize ? "is-" + _vm.selectSize : ""],
	                    style: {
	                      "flex-grow": "1",
	                      width: _vm.inputLength / (_vm.inputWidth - 32) + "%",
	                      "max-width": _vm.inputWidth - 42 + "px"
	                    },
	                    attrs: {
	                      type: "text",
	                      disabled: _vm.selectDisabled,
	                      autocomplete: _vm.autoComplete || _vm.autocomplete
	                    },
	                    domProps: { value: _vm.query },
	                    on: {
	                      focus: _vm.handleFocus,
	                      blur: function($event) {
	                        _vm.softFocus = false
	                      },
	                      keyup: _vm.managePlaceholder,
	                      keydown: [
	                        _vm.resetInputState,
	                        function($event) {
	                          if (
	                            !("button" in $event) &&
	                            _vm._k($event.keyCode, "down", 40, $event.key, [
	                              "Down",
	                              "ArrowDown"
	                            ])
	                          ) {
	                            return null
	                          }
	                          $event.preventDefault()
	                          _vm.navigateOptions("next")
	                        },
	                        function($event) {
	                          if (
	                            !("button" in $event) &&
	                            _vm._k($event.keyCode, "up", 38, $event.key, [
	                              "Up",
	                              "ArrowUp"
	                            ])
	                          ) {
	                            return null
	                          }
	                          $event.preventDefault()
	                          _vm.navigateOptions("prev")
	                        },
	                        function($event) {
	                          if (
	                            !("button" in $event) &&
	                            _vm._k(
	                              $event.keyCode,
	                              "enter",
	                              13,
	                              $event.key,
	                              "Enter"
	                            )
	                          ) {
	                            return null
	                          }
	                          $event.preventDefault()
	                          return _vm.selectOption($event)
	                        },
	                        function($event) {
	                          if (
	                            !("button" in $event) &&
	                            _vm._k($event.keyCode, "esc", 27, $event.key, [
	                              "Esc",
	                              "Escape"
	                            ])
	                          ) {
	                            return null
	                          }
	                          $event.stopPropagation()
	                          $event.preventDefault()
	                          _vm.visible = false
	                        },
	                        function($event) {
	                          if (
	                            !("button" in $event) &&
	                            _vm._k(
	                              $event.keyCode,
	                              "delete",
	                              [8, 46],
	                              $event.key,
	                              ["Backspace", "Delete", "Del"]
	                            )
	                          ) {
	                            return null
	                          }
	                          return _vm.deletePrevTag($event)
	                        },
	                        function($event) {
	                          if (
	                            !("button" in $event) &&
	                            _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
	                          ) {
	                            return null
	                          }
	                          _vm.visible = false
	                        }
	                      ],
	                      compositionstart: _vm.handleComposition,
	                      compositionupdate: _vm.handleComposition,
	                      compositionend: _vm.handleComposition,
	                      input: [
	                        function($event) {
	                          if ($event.target.composing) {
	                            return
	                          }
	                          _vm.query = $event.target.value
	                        },
	                        _vm.debouncedQueryChange
	                      ]
	                    }
	                  })
	                : _vm._e()
	            ],
	            1
	          )
	        : _vm._e(),
	      _c(
	        "el-input",
	        {
	          ref: "reference",
	          class: { "is-focus": _vm.visible },
	          attrs: {
	            type: "text",
	            placeholder: _vm.currentPlaceholder,
	            name: _vm.name,
	            id: _vm.id,
	            autocomplete: _vm.autoComplete || _vm.autocomplete,
	            size: _vm.selectSize,
	            disabled: _vm.selectDisabled,
	            readonly: _vm.readonly,
	            "validate-event": false,
	            tabindex: _vm.multiple && _vm.filterable ? "-1" : null
	          },
	          on: { focus: _vm.handleFocus, blur: _vm.handleBlur },
	          nativeOn: {
	            keyup: function($event) {
	              return _vm.debouncedOnInputChange($event)
	            },
	            keydown: [
	              function($event) {
	                if (
	                  !("button" in $event) &&
	                  _vm._k($event.keyCode, "down", 40, $event.key, [
	                    "Down",
	                    "ArrowDown"
	                  ])
	                ) {
	                  return null
	                }
	                $event.stopPropagation()
	                $event.preventDefault()
	                _vm.navigateOptions("next")
	              },
	              function($event) {
	                if (
	                  !("button" in $event) &&
	                  _vm._k($event.keyCode, "up", 38, $event.key, [
	                    "Up",
	                    "ArrowUp"
	                  ])
	                ) {
	                  return null
	                }
	                $event.stopPropagation()
	                $event.preventDefault()
	                _vm.navigateOptions("prev")
	              },
	              function($event) {
	                if (
	                  !("button" in $event) &&
	                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
	                ) {
	                  return null
	                }
	                $event.preventDefault()
	                return _vm.selectOption($event)
	              },
	              function($event) {
	                if (
	                  !("button" in $event) &&
	                  _vm._k($event.keyCode, "esc", 27, $event.key, [
	                    "Esc",
	                    "Escape"
	                  ])
	                ) {
	                  return null
	                }
	                $event.stopPropagation()
	                $event.preventDefault()
	                _vm.visible = false
	              },
	              function($event) {
	                if (
	                  !("button" in $event) &&
	                  _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
	                ) {
	                  return null
	                }
	                _vm.visible = false
	              }
	            ],
	            paste: function($event) {
	              return _vm.debouncedOnInputChange($event)
	            },
	            mouseenter: function($event) {
	              _vm.inputHovering = true
	            },
	            mouseleave: function($event) {
	              _vm.inputHovering = false
	            }
	          },
	          model: {
	            value: _vm.selectedLabel,
	            callback: function($$v) {
	              _vm.selectedLabel = $$v
	            },
	            expression: "selectedLabel"
	          }
	        },
	        [
	          _vm.$slots.prefix
	            ? _c("template", { slot: "prefix" }, [_vm._t("prefix")], 2)
	            : _vm._e(),
	          _c("template", { slot: "suffix" }, [
	            _c("i", {
	              directives: [
	                {
	                  name: "show",
	                  rawName: "v-show",
	                  value: !_vm.showClose,
	                  expression: "!showClose"
	                }
	              ],
	              class: [
	                "el-select__caret",
	                "el-input__icon",
	                "el-icon-" + _vm.iconClass
	              ]
	            }),
	            _vm.showClose
	              ? _c("i", {
	                  staticClass:
	                    "el-select__caret el-input__icon el-icon-circle-close",
	                  on: { click: _vm.handleClearClick }
	                })
	              : _vm._e()
	          ])
	        ],
	        2
	      ),
	      _c(
	        "transition",
	        {
	          attrs: { name: "el-zoom-in-top" },
	          on: {
	            "before-enter": _vm.handleMenuEnter,
	            "after-leave": _vm.doDestroy
	          }
	        },
	        [
	          _c(
	            "el-select-menu",
	            {
	              directives: [
	                {
	                  name: "show",
	                  rawName: "v-show",
	                  value: _vm.visible && _vm.emptyText !== false,
	                  expression: "visible && emptyText !== false"
	                }
	              ],
	              ref: "popper",
	              attrs: { "append-to-body": _vm.popperAppendToBody }
	            },
	            [
	              _c(
	                "el-scrollbar",
	                {
	                  directives: [
	                    {
	                      name: "show",
	                      rawName: "v-show",
	                      value: _vm.options.length > 0 && !_vm.loading,
	                      expression: "options.length > 0 && !loading"
	                    }
	                  ],
	                  ref: "scrollbar",
	                  class: {
	                    "is-empty":
	                      !_vm.allowCreate &&
	                      _vm.query &&
	                      _vm.filteredOptionsCount === 0
	                  },
	                  attrs: {
	                    tag: "ul",
	                    "wrap-class": "el-select-dropdown__wrap",
	                    "view-class": "el-select-dropdown__list"
	                  }
	                },
	                [
	                  _vm.showNewOption
	                    ? _c("el-option", {
	                        attrs: { value: _vm.query, created: "" }
	                      })
	                    : _vm._e(),
	                  _vm._t("default")
	                ],
	                2
	              ),
	              _vm.emptyText &&
	              (!_vm.allowCreate ||
	                _vm.loading ||
	                (_vm.allowCreate && _vm.options.length === 0))
	                ? [
	                    _vm.$slots.empty
	                      ? _vm._t("empty")
	                      : _c("p", { staticClass: "el-select-dropdown__empty" }, [
	                          _vm._v(
	                            "\n          " +
	                              _vm._s(_vm.emptyText) +
	                              "\n        "
	                          )
	                        ])
	                  ]
	                : _vm._e()
	            ],
	            2
	          )
	        ],
	        1
	      )
	    ],
	    1
	  )
	}
	var selectvue_type_template_id_0e4aade6_staticRenderFns = []
	selectvue_type_template_id_0e4aade6_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/select/src/select.vue?vue&type=template&id=0e4aade6&
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/select-dropdown.vue?vue&type=template&id=06828748&
	var select_dropdownvue_type_template_id_06828748_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-select-dropdown el-popper",
	      class: [{ "is-multiple": _vm.$parent.multiple }, _vm.popperClass],
	      style: { minWidth: _vm.minWidth }
	    },
	    [_vm._t("default")],
	    2
	  )
	}
	var select_dropdownvue_type_template_id_06828748_staticRenderFns = []
	select_dropdownvue_type_template_id_06828748_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/select/src/select-dropdown.vue?vue&type=template&id=06828748&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/select-dropdown.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var select_dropdownvue_type_script_lang_js_ = ({
	  name: 'ElSelectDropdown',
	
	  componentName: 'ElSelectDropdown',
	
	  mixins: [vue_popper_default.a],
	
	  props: {
	    placement: {
	      default: 'bottom-start'
	    },
	
	    boundariesPadding: {
	      default: 0
	    },
	
	    popperOptions: {
	      default: function _default() {
	        return {
	          gpuAcceleration: false
	        };
	      }
	    },
	
	    visibleArrow: {
	      default: true
	    },
	
	    appendToBody: {
	      type: Boolean,
	      default: true
	    }
	  },
	
	  data: function data() {
	    return {
	      minWidth: ''
	    };
	  },
	
	
	  computed: {
	    popperClass: function popperClass() {
	      return this.$parent.popperClass;
	    }
	  },
	
	  watch: {
	    '$parent.inputWidth': function $parentInputWidth() {
	      this.minWidth = this.$parent.$el.getBoundingClientRect().width + 'px';
	    }
	  },
	
	  mounted: function mounted() {
	    var _this = this;
	
	    this.referenceElm = this.$parent.$refs.reference.$el;
	    this.$parent.popperElm = this.popperElm = this.$el;
	    this.$on('updatePopper', function () {
	      if (_this.$parent.visible) _this.updatePopper();
	    });
	    this.$on('destroyPopper', this.destroyPopper);
	  }
	});
	// CONCATENATED MODULE: ./packages/select/src/select-dropdown.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_select_dropdownvue_type_script_lang_js_ = (select_dropdownvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/select/src/select-dropdown.vue
	
	
	
	
	
	/* normalize component */
	
	var select_dropdown_component = normalizeComponent(
	  src_select_dropdownvue_type_script_lang_js_,
	  select_dropdownvue_type_template_id_06828748_render,
	  select_dropdownvue_type_template_id_06828748_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var select_dropdown_api; }
	select_dropdown_component.options.__file = "packages/select/src/select-dropdown.vue"
	/* harmony default export */ var select_dropdown = (select_dropdown_component.exports);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/option.vue?vue&type=template&id=7a44c642&
	var optionvue_type_template_id_7a44c642_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "li",
	    {
	      directives: [
	        {
	          name: "show",
	          rawName: "v-show",
	          value: _vm.visible,
	          expression: "visible"
	        }
	      ],
	      staticClass: "el-select-dropdown__item",
	      class: {
	        selected: _vm.itemSelected,
	        "is-disabled": _vm.disabled || _vm.groupDisabled || _vm.limitReached,
	        hover: _vm.hover
	      },
	      on: {
	        mouseenter: _vm.hoverItem,
	        click: function($event) {
	          $event.stopPropagation()
	          return _vm.selectOptionClick($event)
	        }
	      }
	    },
	    [_vm._t("default", [_c("span", [_vm._v(_vm._s(_vm.currentLabel))])])],
	    2
	  )
	}
	var optionvue_type_template_id_7a44c642_staticRenderFns = []
	optionvue_type_template_id_7a44c642_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/select/src/option.vue?vue&type=template&id=7a44c642&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/option.vue?vue&type=script&lang=js&
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	/* harmony default export */ var optionvue_type_script_lang_js_ = ({
	  mixins: [emitter_default.a],
	
	  name: 'ElOption',
	
	  componentName: 'ElOption',
	
	  inject: ['select'],
	
	  props: {
	    value: {
	      required: true
	    },
	    label: [String, Number],
	    created: Boolean,
	    disabled: {
	      type: Boolean,
	      default: false
	    }
	  },
	
	  data: function data() {
	    return {
	      index: -1,
	      groupDisabled: false,
	      visible: true,
	      hitState: false,
	      hover: false
	    };
	  },
	
	
	  computed: {
	    isObject: function isObject() {
	      return Object.prototype.toString.call(this.value).toLowerCase() === '[object object]';
	    },
	    currentLabel: function currentLabel() {
	      return this.label || (this.isObject ? '' : this.value);
	    },
	    currentValue: function currentValue() {
	      return this.value || this.label || '';
	    },
	    itemSelected: function itemSelected() {
	      if (!this.select.multiple) {
	        return this.isEqual(this.value, this.select.value);
	      } else {
	        return this.contains(this.select.value, this.value);
	      }
	    },
	    limitReached: function limitReached() {
	      if (this.select.multiple) {
	        return !this.itemSelected && (this.select.value || []).length >= this.select.multipleLimit && this.select.multipleLimit > 0;
	      } else {
	        return false;
	      }
	    }
	  },
	
	  watch: {
	    currentLabel: function currentLabel() {
	      if (!this.created && !this.select.remote) this.dispatch('ElSelect', 'setSelected');
	    },
	    value: function value(val, oldVal) {
	      var _select = this.select,
	          remote = _select.remote,
	          valueKey = _select.valueKey;
	
	      if (!this.created && !remote) {
	        if (valueKey && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object' && (typeof oldVal === 'undefined' ? 'undefined' : _typeof(oldVal)) === 'object' && val[valueKey] === oldVal[valueKey]) {
	          return;
	        }
	        this.dispatch('ElSelect', 'setSelected');
	      }
	    }
	  },
	
	  methods: {
	    isEqual: function isEqual(a, b) {
	      if (!this.isObject) {
	        return a === b;
	      } else {
	        var valueKey = this.select.valueKey;
	        return Object(util_["getValueByPath"])(a, valueKey) === Object(util_["getValueByPath"])(b, valueKey);
	      }
	    },
	    contains: function contains() {
	      var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	      var target = arguments[1];
	
	      if (!this.isObject) {
	        return arr && arr.indexOf(target) > -1;
	      } else {
	        var valueKey = this.select.valueKey;
	        return arr && arr.some(function (item) {
	          return Object(util_["getValueByPath"])(item, valueKey) === Object(util_["getValueByPath"])(target, valueKey);
	        });
	      }
	    },
	    handleGroupDisabled: function handleGroupDisabled(val) {
	      this.groupDisabled = val;
	    },
	    hoverItem: function hoverItem() {
	      if (!this.disabled && !this.groupDisabled) {
	        this.select.hoverIndex = this.select.options.indexOf(this);
	      }
	    },
	    selectOptionClick: function selectOptionClick() {
	      if (this.disabled !== true && this.groupDisabled !== true) {
	        this.dispatch('ElSelect', 'handleOptionClick', [this, true]);
	      }
	    },
	    queryChange: function queryChange(query) {
	      this.visible = new RegExp(Object(util_["escapeRegexpString"])(query), 'i').test(this.currentLabel) || this.created;
	      if (!this.visible) {
	        this.select.filteredOptionsCount--;
	      }
	    }
	  },
	
	  created: function created() {
	    this.select.options.push(this);
	    this.select.cachedOptions.push(this);
	    this.select.optionsCount++;
	    this.select.filteredOptionsCount++;
	
	    this.$on('queryChange', this.queryChange);
	    this.$on('handleGroupDisabled', this.handleGroupDisabled);
	  },
	  beforeDestroy: function beforeDestroy() {
	    var _select2 = this.select,
	        selected = _select2.selected,
	        multiple = _select2.multiple;
	
	    var selectedOptions = multiple ? selected : [selected];
	    var index = this.select.cachedOptions.indexOf(this);
	    var selectedIndex = selectedOptions.indexOf(this);
	
	    // if option is not selected, remove it from cache
	    if (index > -1 && selectedIndex < 0) {
	      this.select.cachedOptions.splice(index, 1);
	    }
	    this.select.onOptionDestroy(this.select.options.indexOf(this));
	  }
	});
	// CONCATENATED MODULE: ./packages/select/src/option.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_optionvue_type_script_lang_js_ = (optionvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/select/src/option.vue
	
	
	
	
	
	/* normalize component */
	
	var option_component = normalizeComponent(
	  src_optionvue_type_script_lang_js_,
	  optionvue_type_template_id_7a44c642_render,
	  optionvue_type_template_id_7a44c642_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var option_api; }
	option_component.options.__file = "packages/select/src/option.vue"
	/* harmony default export */ var src_option = (option_component.exports);
	// EXTERNAL MODULE: external "element-ui/lib/tag"
	var tag_ = __webpack_require__(30);
	var tag_default = /*#__PURE__*/__webpack_require__.n(tag_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/resize-event"
	var resize_event_ = __webpack_require__(13);
	
	// EXTERNAL MODULE: external "element-ui/lib/locale"
	var lib_locale_ = __webpack_require__(11);
	var lib_locale_default = /*#__PURE__*/__webpack_require__.n(lib_locale_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/scroll-into-view"
	var scroll_into_view_ = __webpack_require__(27);
	var scroll_into_view_default = /*#__PURE__*/__webpack_require__.n(scroll_into_view_);
	
	// CONCATENATED MODULE: ./packages/select/src/navigation-mixin.js
	/* harmony default export */ var navigation_mixin = ({
	  data: function data() {
	    return {
	      hoverOption: -1
	    };
	  },
	
	
	  computed: {
	    optionsAllDisabled: function optionsAllDisabled() {
	      return this.options.filter(function (option) {
	        return option.visible;
	      }).every(function (option) {
	        return option.disabled;
	      });
	    }
	  },
	
	  watch: {
	    hoverIndex: function hoverIndex(val) {
	      var _this = this;
	
	      if (typeof val === 'number' && val > -1) {
	        this.hoverOption = this.options[val] || {};
	      }
	      this.options.forEach(function (option) {
	        option.hover = _this.hoverOption === option;
	      });
	    }
	  },
	
	  methods: {
	    navigateOptions: function navigateOptions(direction) {
	      var _this2 = this;
	
	      if (!this.visible) {
	        this.visible = true;
	        return;
	      }
	      if (this.options.length === 0 || this.filteredOptionsCount === 0) return;
	      if (!this.optionsAllDisabled) {
	        if (direction === 'next') {
	          this.hoverIndex++;
	          if (this.hoverIndex === this.options.length) {
	            this.hoverIndex = 0;
	          }
	        } else if (direction === 'prev') {
	          this.hoverIndex--;
	          if (this.hoverIndex < 0) {
	            this.hoverIndex = this.options.length - 1;
	          }
	        }
	        var option = this.options[this.hoverIndex];
	        if (option.disabled === true || option.groupDisabled === true || !option.visible) {
	          this.navigateOptions(direction);
	        }
	        this.$nextTick(function () {
	          return _this2.scrollToOption(_this2.hoverOption);
	        });
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/select.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	/* harmony default export */ var selectvue_type_script_lang_js_ = ({
	  mixins: [emitter_default.a, locale_default.a, focus_default()('reference'), navigation_mixin],
	
	  name: 'ElSelect',
	
	  componentName: 'ElSelect',
	
	  inject: {
	    elForm: {
	      default: ''
	    },
	
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  provide: function provide() {
	    return {
	      'select': this
	    };
	  },
	
	
	  computed: {
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    readonly: function readonly() {
	      return !this.filterable || this.multiple || !Object(util_["isIE"])() && !Object(util_["isEdge"])() && !this.visible;
	    },
	    showClose: function showClose() {
	      var hasValue = this.multiple ? Array.isArray(this.value) && this.value.length > 0 : this.value !== undefined && this.value !== null && this.value !== '';
	      var criteria = this.clearable && !this.selectDisabled && this.inputHovering && hasValue;
	      return criteria;
	    },
	    iconClass: function iconClass() {
	      return this.remote && this.filterable ? '' : this.visible ? 'arrow-up is-reverse' : 'arrow-up';
	    },
	    debounce: function debounce() {
	      return this.remote ? 300 : 0;
	    },
	    emptyText: function emptyText() {
	      if (this.loading) {
	        return this.loadingText || this.t('el.select.loading');
	      } else {
	        if (this.remote && this.query === '' && this.options.length === 0) return false;
	        if (this.filterable && this.query && this.options.length > 0 && this.filteredOptionsCount === 0) {
	          return this.noMatchText || this.t('el.select.noMatch');
	        }
	        if (this.options.length === 0) {
	          return this.noDataText || this.t('el.select.noData');
	        }
	      }
	      return null;
	    },
	    showNewOption: function showNewOption() {
	      var _this = this;
	
	      var hasExistingOption = this.options.filter(function (option) {
	        return !option.created;
	      }).some(function (option) {
	        return option.currentLabel === _this.query;
	      });
	      return this.filterable && this.allowCreate && this.query !== '' && !hasExistingOption;
	    },
	    selectSize: function selectSize() {
	      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
	    },
	    selectDisabled: function selectDisabled() {
	      return this.disabled || (this.elForm || {}).disabled;
	    },
	    collapseTagSize: function collapseTagSize() {
	      return ['small', 'mini'].indexOf(this.selectSize) > -1 ? 'mini' : 'small';
	    }
	  },
	
	  components: {
	    ElInput: input_default.a,
	    ElSelectMenu: select_dropdown,
	    ElOption: src_option,
	    ElTag: tag_default.a,
	    ElScrollbar: scrollbar_default.a
	  },
	
	  directives: { Clickoutside: clickoutside_default.a },
	
	  props: {
	    name: String,
	    id: String,
	    value: {
	      required: true
	    },
	    autocomplete: {
	      type: String,
	      default: 'off'
	    },
	    /** @Deprecated in next major version */
	    autoComplete: {
	      type: String,
	      validator: function validator(val) {
	         false && false;
	        return true;
	      }
	    },
	    automaticDropdown: Boolean,
	    size: String,
	    disabled: Boolean,
	    clearable: Boolean,
	    filterable: Boolean,
	    allowCreate: Boolean,
	    loading: Boolean,
	    popperClass: String,
	    remote: Boolean,
	    loadingText: String,
	    noMatchText: String,
	    noDataText: String,
	    remoteMethod: Function,
	    filterMethod: Function,
	    multiple: Boolean,
	    multipleLimit: {
	      type: Number,
	      default: 0
	    },
	    placeholder: {
	      type: String,
	      default: function _default() {
	        return Object(lib_locale_["t"])('el.select.placeholder');
	      }
	    },
	    defaultFirstOption: Boolean,
	    reserveKeyword: Boolean,
	    valueKey: {
	      type: String,
	      default: 'value'
	    },
	    collapseTags: Boolean,
	    popperAppendToBody: {
	      type: Boolean,
	      default: true
	    }
	  },
	
	  data: function data() {
	    return {
	      options: [],
	      cachedOptions: [],
	      createdLabel: null,
	      createdSelected: false,
	      selected: this.multiple ? [] : {},
	      inputLength: 20,
	      inputWidth: 0,
	      initialInputHeight: 0,
	      cachedPlaceHolder: '',
	      optionsCount: 0,
	      filteredOptionsCount: 0,
	      visible: false,
	      softFocus: false,
	      selectedLabel: '',
	      hoverIndex: -1,
	      query: '',
	      previousQuery: null,
	      inputHovering: false,
	      currentPlaceholder: '',
	      menuVisibleOnFocus: false,
	      isOnComposition: false,
	      isSilentBlur: false
	    };
	  },
	
	
	  watch: {
	    selectDisabled: function selectDisabled() {
	      var _this2 = this;
	
	      this.$nextTick(function () {
	        _this2.resetInputHeight();
	      });
	    },
	    placeholder: function placeholder(val) {
	      this.cachedPlaceHolder = this.currentPlaceholder = val;
	    },
	    value: function value(val, oldVal) {
	      if (this.multiple) {
	        this.resetInputHeight();
	        if (val && val.length > 0 || this.$refs.input && this.query !== '') {
	          this.currentPlaceholder = '';
	        } else {
	          this.currentPlaceholder = this.cachedPlaceHolder;
	        }
	        if (this.filterable && !this.reserveKeyword) {
	          this.query = '';
	          this.handleQueryChange(this.query);
	        }
	      }
	      this.setSelected();
	      if (this.filterable && !this.multiple) {
	        this.inputLength = 20;
	      }
	      if (!Object(util_["valueEquals"])(val, oldVal)) {
	        this.dispatch('ElFormItem', 'el.form.change', val);
	      }
	    },
	    visible: function visible(val) {
	      var _this3 = this;
	
	      if (!val) {
	        this.broadcast('ElSelectDropdown', 'destroyPopper');
	        if (this.$refs.input) {
	          this.$refs.input.blur();
	        }
	        this.query = '';
	        this.previousQuery = null;
	        this.selectedLabel = '';
	        this.inputLength = 20;
	        this.menuVisibleOnFocus = false;
	        this.resetHoverIndex();
	        this.$nextTick(function () {
	          if (_this3.$refs.input && _this3.$refs.input.value === '' && _this3.selected.length === 0) {
	            _this3.currentPlaceholder = _this3.cachedPlaceHolder;
	          }
	        });
	        if (!this.multiple) {
	          if (this.selected) {
	            if (this.filterable && this.allowCreate && this.createdSelected && this.createdLabel) {
	              this.selectedLabel = this.createdLabel;
	            } else {
	              this.selectedLabel = this.selected.currentLabel;
	            }
	            if (this.filterable) this.query = this.selectedLabel;
	          }
	
	          if (this.filterable) {
	            this.currentPlaceholder = this.cachedPlaceHolder;
	          }
	        }
	      } else {
	        this.broadcast('ElSelectDropdown', 'updatePopper');
	        if (this.filterable) {
	          this.query = this.remote ? '' : this.selectedLabel;
	          this.handleQueryChange(this.query);
	          if (this.multiple) {
	            this.$refs.input.focus();
	          } else {
	            if (!this.remote) {
	              this.broadcast('ElOption', 'queryChange', '');
	              this.broadcast('ElOptionGroup', 'queryChange');
	            }
	
	            if (this.selectedLabel) {
	              this.currentPlaceholder = this.selectedLabel;
	              this.selectedLabel = '';
	            }
	          }
	        }
	      }
	      this.$emit('visible-change', val);
	    },
	    options: function options() {
	      var _this4 = this;
	
	      if (this.$isServer) return;
	      this.$nextTick(function () {
	        _this4.broadcast('ElSelectDropdown', 'updatePopper');
	      });
	      if (this.multiple) {
	        this.resetInputHeight();
	      }
	      var inputs = this.$el.querySelectorAll('input');
	      if ([].indexOf.call(inputs, document.activeElement) === -1) {
	        this.setSelected();
	      }
	      if (this.defaultFirstOption && (this.filterable || this.remote) && this.filteredOptionsCount) {
	        this.checkDefaultFirstOption();
	      }
	    }
	  },
	
	  methods: {
	    handleComposition: function handleComposition(event) {
	      var _this5 = this;
	
	      var text = event.target.value;
	      if (event.type === 'compositionend') {
	        this.isOnComposition = false;
	        this.$nextTick(function (_) {
	          return _this5.handleQueryChange(text);
	        });
	      } else {
	        var lastCharacter = text[text.length - 1] || '';
	        this.isOnComposition = !Object(shared_["isKorean"])(lastCharacter);
	      }
	    },
	    handleQueryChange: function handleQueryChange(val) {
	      var _this6 = this;
	
	      if (this.previousQuery === val || this.isOnComposition) return;
	      if (this.previousQuery === null && (typeof this.filterMethod === 'function' || typeof this.remoteMethod === 'function')) {
	        this.previousQuery = val;
	        return;
	      }
	      this.previousQuery = val;
	      this.$nextTick(function () {
	        if (_this6.visible) _this6.broadcast('ElSelectDropdown', 'updatePopper');
	      });
	      this.hoverIndex = -1;
	      if (this.multiple && this.filterable) {
	        this.$nextTick(function () {
	          var length = _this6.$refs.input.value.length * 15 + 20;
	          _this6.inputLength = _this6.collapseTags ? Math.min(50, length) : length;
	          _this6.managePlaceholder();
	          _this6.resetInputHeight();
	        });
	      }
	      if (this.remote && typeof this.remoteMethod === 'function') {
	        this.hoverIndex = -1;
	        this.remoteMethod(val);
	      } else if (typeof this.filterMethod === 'function') {
	        this.filterMethod(val);
	        this.broadcast('ElOptionGroup', 'queryChange');
	      } else {
	        this.filteredOptionsCount = this.optionsCount;
	        this.broadcast('ElOption', 'queryChange', val);
	        this.broadcast('ElOptionGroup', 'queryChange');
	      }
	      if (this.defaultFirstOption && (this.filterable || this.remote) && this.filteredOptionsCount) {
	        this.checkDefaultFirstOption();
	      }
	    },
	    scrollToOption: function scrollToOption(option) {
	      var target = Array.isArray(option) && option[0] ? option[0].$el : option.$el;
	      if (this.$refs.popper && target) {
	        var menu = this.$refs.popper.$el.querySelector('.el-select-dropdown__wrap');
	        scroll_into_view_default()(menu, target);
	      }
	      this.$refs.scrollbar && this.$refs.scrollbar.handleScroll();
	    },
	    handleMenuEnter: function handleMenuEnter() {
	      var _this7 = this;
	
	      this.$nextTick(function () {
	        return _this7.scrollToOption(_this7.selected);
	      });
	    },
	    emitChange: function emitChange(val) {
	      if (!Object(util_["valueEquals"])(this.value, val)) {
	        this.$emit('change', val);
	      }
	    },
	    getOption: function getOption(value) {
	      var option = void 0;
	      var isObject = Object.prototype.toString.call(value).toLowerCase() === '[object object]';
	      var isNull = Object.prototype.toString.call(value).toLowerCase() === '[object null]';
	      var isUndefined = Object.prototype.toString.call(value).toLowerCase() === '[object undefined]';
	
	      for (var i = this.cachedOptions.length - 1; i >= 0; i--) {
	        var cachedOption = this.cachedOptions[i];
	        var isEqual = isObject ? Object(util_["getValueByPath"])(cachedOption.value, this.valueKey) === Object(util_["getValueByPath"])(value, this.valueKey) : cachedOption.value === value;
	        if (isEqual) {
	          option = cachedOption;
	          break;
	        }
	      }
	      if (option) return option;
	      var label = !isObject && !isNull && !isUndefined ? value : '';
	      var newOption = {
	        value: value,
	        currentLabel: label
	      };
	      if (this.multiple) {
	        newOption.hitState = false;
	      }
	      return newOption;
	    },
	    setSelected: function setSelected() {
	      var _this8 = this;
	
	      if (!this.multiple) {
	        var option = this.getOption(this.value);
	        if (option.created) {
	          this.createdLabel = option.currentLabel;
	          this.createdSelected = true;
	        } else {
	          this.createdSelected = false;
	        }
	        this.selectedLabel = option.currentLabel;
	        this.selected = option;
	        if (this.filterable) this.query = this.selectedLabel;
	        return;
	      }
	      var result = [];
	      if (Array.isArray(this.value)) {
	        this.value.forEach(function (value) {
	          result.push(_this8.getOption(value));
	        });
	      }
	      this.selected = result;
	      this.$nextTick(function () {
	        _this8.resetInputHeight();
	      });
	    },
	    handleFocus: function handleFocus(event) {
	      if (!this.softFocus) {
	        if (this.automaticDropdown || this.filterable) {
	          this.visible = true;
	          if (this.filterable) {
	            this.menuVisibleOnFocus = true;
	          }
	        }
	        this.$emit('focus', event);
	      } else {
	        this.softFocus = false;
	      }
	    },
	    blur: function blur() {
	      this.visible = false;
	      this.$refs.reference.blur();
	    },
	    handleBlur: function handleBlur(event) {
	      var _this9 = this;
	
	      setTimeout(function () {
	        if (_this9.isSilentBlur) {
	          _this9.isSilentBlur = false;
	        } else {
	          _this9.$emit('blur', event);
	        }
	      }, 50);
	      this.softFocus = false;
	    },
	    handleClearClick: function handleClearClick(event) {
	      this.deleteSelected(event);
	    },
	    doDestroy: function doDestroy() {
	      this.$refs.popper && this.$refs.popper.doDestroy();
	    },
	    handleClose: function handleClose() {
	      this.visible = false;
	    },
	    toggleLastOptionHitState: function toggleLastOptionHitState(hit) {
	      if (!Array.isArray(this.selected)) return;
	      var option = this.selected[this.selected.length - 1];
	      if (!option) return;
	
	      if (hit === true || hit === false) {
	        option.hitState = hit;
	        return hit;
	      }
	
	      option.hitState = !option.hitState;
	      return option.hitState;
	    },
	    deletePrevTag: function deletePrevTag(e) {
	      if (e.target.value.length <= 0 && !this.toggleLastOptionHitState()) {
	        var value = this.value.slice();
	        value.pop();
	        this.$emit('input', value);
	        this.emitChange(value);
	      }
	    },
	    managePlaceholder: function managePlaceholder() {
	      if (this.currentPlaceholder !== '') {
	        this.currentPlaceholder = this.$refs.input.value ? '' : this.cachedPlaceHolder;
	      }
	    },
	    resetInputState: function resetInputState(e) {
	      if (e.keyCode !== 8) this.toggleLastOptionHitState(false);
	      this.inputLength = this.$refs.input.value.length * 15 + 20;
	      this.resetInputHeight();
	    },
	    resetInputHeight: function resetInputHeight() {
	      var _this10 = this;
	
	      if (this.collapseTags && !this.filterable) return;
	      this.$nextTick(function () {
	        if (!_this10.$refs.reference) return;
	        var inputChildNodes = _this10.$refs.reference.$el.childNodes;
	        var input = [].filter.call(inputChildNodes, function (item) {
	          return item.tagName === 'INPUT';
	        })[0];
	        var tags = _this10.$refs.tags;
	        var sizeInMap = _this10.initialInputHeight || 40;
	        input.style.height = _this10.selected.length === 0 ? sizeInMap + 'px' : Math.max(tags ? tags.clientHeight + (tags.clientHeight > sizeInMap ? 6 : 0) : 0, sizeInMap) + 'px';
	        if (_this10.visible && _this10.emptyText !== false) {
	          _this10.broadcast('ElSelectDropdown', 'updatePopper');
	        }
	      });
	    },
	    resetHoverIndex: function resetHoverIndex() {
	      var _this11 = this;
	
	      setTimeout(function () {
	        if (!_this11.multiple) {
	          _this11.hoverIndex = _this11.options.indexOf(_this11.selected);
	        } else {
	          if (_this11.selected.length > 0) {
	            _this11.hoverIndex = Math.min.apply(null, _this11.selected.map(function (item) {
	              return _this11.options.indexOf(item);
	            }));
	          } else {
	            _this11.hoverIndex = -1;
	          }
	        }
	      }, 300);
	    },
	    handleOptionSelect: function handleOptionSelect(option, byClick) {
	      var _this12 = this;
	
	      if (this.multiple) {
	        var value = (this.value || []).slice();
	        var optionIndex = this.getValueIndex(value, option.value);
	        if (optionIndex > -1) {
	          value.splice(optionIndex, 1);
	        } else if (this.multipleLimit <= 0 || value.length < this.multipleLimit) {
	          value.push(option.value);
	        }
	        this.$emit('input', value);
	        this.emitChange(value);
	        if (option.created) {
	          this.query = '';
	          this.handleQueryChange('');
	          this.inputLength = 20;
	        }
	        if (this.filterable) this.$refs.input.focus();
	      } else {
	        this.$emit('input', option.value);
	        this.emitChange(option.value);
	        this.visible = false;
	      }
	      this.isSilentBlur = byClick;
	      this.setSoftFocus();
	      if (this.visible) return;
	      this.$nextTick(function () {
	        _this12.scrollToOption(option);
	      });
	    },
	    setSoftFocus: function setSoftFocus() {
	      this.softFocus = true;
	      var input = this.$refs.input || this.$refs.reference;
	      if (input) {
	        input.focus();
	      }
	    },
	    getValueIndex: function getValueIndex() {
	      var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	      var value = arguments[1];
	
	      var isObject = Object.prototype.toString.call(value).toLowerCase() === '[object object]';
	      if (!isObject) {
	        return arr.indexOf(value);
	      } else {
	        var valueKey = this.valueKey;
	        var index = -1;
	        arr.some(function (item, i) {
	          if (Object(util_["getValueByPath"])(item, valueKey) === Object(util_["getValueByPath"])(value, valueKey)) {
	            index = i;
	            return true;
	          }
	          return false;
	        });
	        return index;
	      }
	    },
	    toggleMenu: function toggleMenu() {
	      if (!this.selectDisabled) {
	        if (this.menuVisibleOnFocus) {
	          this.menuVisibleOnFocus = false;
	        } else {
	          this.visible = !this.visible;
	        }
	        if (this.visible) {
	          (this.$refs.input || this.$refs.reference).focus();
	        }
	      }
	    },
	    selectOption: function selectOption() {
	      if (!this.visible) {
	        this.toggleMenu();
	      } else {
	        if (this.options[this.hoverIndex]) {
	          this.handleOptionSelect(this.options[this.hoverIndex]);
	        }
	      }
	    },
	    deleteSelected: function deleteSelected(event) {
	      event.stopPropagation();
	      var value = this.multiple ? [] : '';
	      this.$emit('input', value);
	      this.emitChange(value);
	      this.visible = false;
	      this.$emit('clear');
	    },
	    deleteTag: function deleteTag(event, tag) {
	      var index = this.selected.indexOf(tag);
	      if (index > -1 && !this.selectDisabled) {
	        var value = this.value.slice();
	        value.splice(index, 1);
	        this.$emit('input', value);
	        this.emitChange(value);
	        this.$emit('remove-tag', tag.value);
	      }
	      event.stopPropagation();
	    },
	    onInputChange: function onInputChange() {
	      if (this.filterable && this.query !== this.selectedLabel) {
	        this.query = this.selectedLabel;
	        this.handleQueryChange(this.query);
	      }
	    },
	    onOptionDestroy: function onOptionDestroy(index) {
	      if (index > -1) {
	        this.optionsCount--;
	        this.filteredOptionsCount--;
	        this.options.splice(index, 1);
	      }
	    },
	    resetInputWidth: function resetInputWidth() {
	      this.inputWidth = this.$refs.reference.$el.getBoundingClientRect().width;
	    },
	    handleResize: function handleResize() {
	      this.resetInputWidth();
	      if (this.multiple) this.resetInputHeight();
	    },
	    checkDefaultFirstOption: function checkDefaultFirstOption() {
	      this.hoverIndex = -1;
	      // highlight the created option
	      var hasCreated = false;
	      for (var i = this.options.length - 1; i >= 0; i--) {
	        if (this.options[i].created) {
	          hasCreated = true;
	          this.hoverIndex = i;
	          break;
	        }
	      }
	      if (hasCreated) return;
	      for (var _i = 0; _i !== this.options.length; ++_i) {
	        var option = this.options[_i];
	        if (this.query) {
	          // highlight first options that passes the filter
	          if (!option.disabled && !option.groupDisabled && option.visible) {
	            this.hoverIndex = _i;
	            break;
	          }
	        } else {
	          // highlight currently selected option
	          if (option.itemSelected) {
	            this.hoverIndex = _i;
	            break;
	          }
	        }
	      }
	    },
	    getValueKey: function getValueKey(item) {
	      if (Object.prototype.toString.call(item.value).toLowerCase() !== '[object object]') {
	        return item.value;
	      } else {
	        return Object(util_["getValueByPath"])(item.value, this.valueKey);
	      }
	    }
	  },
	
	  created: function created() {
	    var _this13 = this;
	
	    this.cachedPlaceHolder = this.currentPlaceholder = this.placeholder;
	    if (this.multiple && !Array.isArray(this.value)) {
	      this.$emit('input', []);
	    }
	    if (!this.multiple && Array.isArray(this.value)) {
	      this.$emit('input', '');
	    }
	
	    this.debouncedOnInputChange = debounce_default()(this.debounce, function () {
	      _this13.onInputChange();
	    });
	
	    this.debouncedQueryChange = debounce_default()(this.debounce, function (e) {
	      _this13.handleQueryChange(e.target.value);
	    });
	
	    this.$on('handleOptionClick', this.handleOptionSelect);
	    this.$on('setSelected', this.setSelected);
	  },
	  mounted: function mounted() {
	    var _this14 = this;
	
	    if (this.multiple && Array.isArray(this.value) && this.value.length > 0) {
	      this.currentPlaceholder = '';
	    }
	    Object(resize_event_["addResizeListener"])(this.$el, this.handleResize);
	
	    var reference = this.$refs.reference;
	    if (reference && reference.$el) {
	      var sizeMap = {
	        medium: 36,
	        small: 32,
	        mini: 28
	      };
	      var input = reference.$el.querySelector('input');
	      this.initialInputHeight = input.getBoundingClientRect().height || sizeMap[this.selectSize];
	    }
	    if (this.remote && this.multiple) {
	      this.resetInputHeight();
	    }
	    this.$nextTick(function () {
	      if (reference && reference.$el) {
	        _this14.inputWidth = reference.$el.getBoundingClientRect().width;
	      }
	    });
	    this.setSelected();
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this.$el && this.handleResize) Object(resize_event_["removeResizeListener"])(this.$el, this.handleResize);
	  }
	});
	// CONCATENATED MODULE: ./packages/select/src/select.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_selectvue_type_script_lang_js_ = (selectvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/select/src/select.vue
	
	
	
	
	
	/* normalize component */
	
	var select_component = normalizeComponent(
	  src_selectvue_type_script_lang_js_,
	  selectvue_type_template_id_0e4aade6_render,
	  selectvue_type_template_id_0e4aade6_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var select_api; }
	select_component.options.__file = "packages/select/src/select.vue"
	/* harmony default export */ var src_select = (select_component.exports);
	// CONCATENATED MODULE: ./packages/select/index.js
	
	
	/* istanbul ignore next */
	src_select.install = function (Vue) {
	  Vue.component(src_select.name, src_select);
	};
	
	/* harmony default export */ var packages_select = (src_select);
	// CONCATENATED MODULE: ./packages/option/index.js
	
	
	/* istanbul ignore next */
	src_option.install = function (Vue) {
	  Vue.component(src_option.name, src_option);
	};
	
	/* harmony default export */ var packages_option = (src_option);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/option-group.vue?vue&type=template&id=6685e5de&
	var option_groupvue_type_template_id_6685e5de_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "ul",
	    {
	      directives: [
	        {
	          name: "show",
	          rawName: "v-show",
	          value: _vm.visible,
	          expression: "visible"
	        }
	      ],
	      staticClass: "el-select-group__wrap"
	    },
	    [
	      _c("li", { staticClass: "el-select-group__title" }, [
	        _vm._v(_vm._s(_vm.label))
	      ]),
	      _c("li", [
	        _c("ul", { staticClass: "el-select-group" }, [_vm._t("default")], 2)
	      ])
	    ]
	  )
	}
	var option_groupvue_type_template_id_6685e5de_staticRenderFns = []
	option_groupvue_type_template_id_6685e5de_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/select/src/option-group.vue?vue&type=template&id=6685e5de&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/option-group.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var option_groupvue_type_script_lang_js_ = ({
	  mixins: [emitter_default.a],
	
	  name: 'ElOptionGroup',
	
	  componentName: 'ElOptionGroup',
	
	  props: {
	    label: String,
	    disabled: {
	      type: Boolean,
	      default: false
	    }
	  },
	
	  data: function data() {
	    return {
	      visible: true
	    };
	  },
	
	
	  watch: {
	    disabled: function disabled(val) {
	      this.broadcast('ElOption', 'handleGroupDisabled', val);
	    }
	  },
	
	  methods: {
	    queryChange: function queryChange() {
	      this.visible = this.$children && Array.isArray(this.$children) && this.$children.some(function (option) {
	        return option.visible === true;
	      });
	    }
	  },
	
	  created: function created() {
	    this.$on('queryChange', this.queryChange);
	  },
	  mounted: function mounted() {
	    if (this.disabled) {
	      this.broadcast('ElOption', 'handleGroupDisabled', this.disabled);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/select/src/option-group.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_option_groupvue_type_script_lang_js_ = (option_groupvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/select/src/option-group.vue
	
	
	
	
	
	/* normalize component */
	
	var option_group_component = normalizeComponent(
	  src_option_groupvue_type_script_lang_js_,
	  option_groupvue_type_template_id_6685e5de_render,
	  option_groupvue_type_template_id_6685e5de_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var option_group_api; }
	option_group_component.options.__file = "packages/select/src/option-group.vue"
	/* harmony default export */ var option_group = (option_group_component.exports);
	// CONCATENATED MODULE: ./packages/option-group/index.js
	
	
	/* istanbul ignore next */
	option_group.install = function (Vue) {
	  Vue.component(option_group.name, option_group);
	};
	
	/* harmony default export */ var packages_option_group = (option_group);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/button/src/button.vue?vue&type=template&id=ca859fb4&
	var buttonvue_type_template_id_ca859fb4_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "button",
	    {
	      staticClass: "el-button",
	      class: [
	        _vm.type ? "el-button--" + _vm.type : "",
	        _vm.buttonSize ? "el-button--" + _vm.buttonSize : "",
	        {
	          "is-disabled": _vm.buttonDisabled,
	          "is-loading": _vm.loading,
	          "is-plain": _vm.plain,
	          "is-round": _vm.round,
	          "is-circle": _vm.circle
	        }
	      ],
	      attrs: {
	        disabled: _vm.buttonDisabled || _vm.loading,
	        autofocus: _vm.autofocus,
	        type: _vm.nativeType
	      },
	      on: { click: _vm.handleClick }
	    },
	    [
	      _vm.loading ? _c("i", { staticClass: "el-icon-loading" }) : _vm._e(),
	      _vm.icon && !_vm.loading ? _c("i", { class: _vm.icon }) : _vm._e(),
	      _vm.$slots.default ? _c("span", [_vm._t("default")], 2) : _vm._e()
	    ]
	  )
	}
	var buttonvue_type_template_id_ca859fb4_staticRenderFns = []
	buttonvue_type_template_id_ca859fb4_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/button/src/button.vue?vue&type=template&id=ca859fb4&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/button/src/button.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var buttonvue_type_script_lang_js_ = ({
	  name: 'ElButton',
	
	  inject: {
	    elForm: {
	      default: ''
	    },
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  props: {
	    type: {
	      type: String,
	      default: 'default'
	    },
	    size: String,
	    icon: {
	      type: String,
	      default: ''
	    },
	    nativeType: {
	      type: String,
	      default: 'button'
	    },
	    loading: Boolean,
	    disabled: Boolean,
	    plain: Boolean,
	    autofocus: Boolean,
	    round: Boolean,
	    circle: Boolean
	  },
	
	  computed: {
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    buttonSize: function buttonSize() {
	      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
	    },
	    buttonDisabled: function buttonDisabled() {
	      return this.disabled || (this.elForm || {}).disabled;
	    }
	  },
	
	  methods: {
	    handleClick: function handleClick(evt) {
	      this.$emit('click', evt);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/button/src/button.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_buttonvue_type_script_lang_js_ = (buttonvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/button/src/button.vue
	
	
	
	
	
	/* normalize component */
	
	var button_component = normalizeComponent(
	  src_buttonvue_type_script_lang_js_,
	  buttonvue_type_template_id_ca859fb4_render,
	  buttonvue_type_template_id_ca859fb4_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var button_api; }
	button_component.options.__file = "packages/button/src/button.vue"
	/* harmony default export */ var src_button = (button_component.exports);
	// CONCATENATED MODULE: ./packages/button/index.js
	
	
	/* istanbul ignore next */
	src_button.install = function (Vue) {
	  Vue.component(src_button.name, src_button);
	};
	
	/* harmony default export */ var packages_button = (src_button);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/button/src/button-group.vue?vue&type=template&id=3d8661d0&
	var button_groupvue_type_template_id_3d8661d0_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("div", { staticClass: "el-button-group" }, [_vm._t("default")], 2)
	}
	var button_groupvue_type_template_id_3d8661d0_staticRenderFns = []
	button_groupvue_type_template_id_3d8661d0_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/button/src/button-group.vue?vue&type=template&id=3d8661d0&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/button/src/button-group.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	
	/* harmony default export */ var button_groupvue_type_script_lang_js_ = ({
	  name: 'ElButtonGroup'
	});
	// CONCATENATED MODULE: ./packages/button/src/button-group.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_button_groupvue_type_script_lang_js_ = (button_groupvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/button/src/button-group.vue
	
	
	
	
	
	/* normalize component */
	
	var button_group_component = normalizeComponent(
	  src_button_groupvue_type_script_lang_js_,
	  button_groupvue_type_template_id_3d8661d0_render,
	  button_groupvue_type_template_id_3d8661d0_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var button_group_api; }
	button_group_component.options.__file = "packages/button/src/button-group.vue"
	/* harmony default export */ var button_group = (button_group_component.exports);
	// CONCATENATED MODULE: ./packages/button-group/index.js
	
	
	/* istanbul ignore next */
	button_group.install = function (Vue) {
	  Vue.component(button_group.name, button_group);
	};
	
	/* harmony default export */ var packages_button_group = (button_group);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/table/src/table.vue?vue&type=template&id=493fe34e&
	var tablevue_type_template_id_493fe34e_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-table",
	      class: [
	        {
	          "el-table--fit": _vm.fit,
	          "el-table--striped": _vm.stripe,
	          "el-table--border": _vm.border || _vm.isGroup,
	          "el-table--hidden": _vm.isHidden,
	          "el-table--group": _vm.isGroup,
	          "el-table--fluid-height": _vm.maxHeight,
	          "el-table--scrollable-x": _vm.layout.scrollX,
	          "el-table--scrollable-y": _vm.layout.scrollY,
	          "el-table--enable-row-hover": !_vm.store.states.isComplex,
	          "el-table--enable-row-transition":
	            (_vm.store.states.data || []).length !== 0 &&
	            (_vm.store.states.data || []).length < 100
	        },
	        _vm.tableSize ? "el-table--" + _vm.tableSize : ""
	      ],
	      on: {
	        mouseleave: function($event) {
	          _vm.handleMouseLeave($event)
	        }
	      }
	    },
	    [
	      _c(
	        "div",
	        { ref: "hiddenColumns", staticClass: "hidden-columns" },
	        [_vm._t("default")],
	        2
	      ),
	      _vm.showHeader
	        ? _c(
	            "div",
	            {
	              directives: [
	                {
	                  name: "mousewheel",
	                  rawName: "v-mousewheel",
	                  value: _vm.handleHeaderFooterMousewheel,
	                  expression: "handleHeaderFooterMousewheel"
	                }
	              ],
	              ref: "headerWrapper",
	              staticClass: "el-table__header-wrapper"
	            },
	            [
	              _c("table-header", {
	                ref: "tableHeader",
	                style: {
	                  width: _vm.layout.bodyWidth ? _vm.layout.bodyWidth + "px" : ""
	                },
	                attrs: {
	                  store: _vm.store,
	                  border: _vm.border,
	                  "default-sort": _vm.defaultSort
	                }
	              })
	            ],
	            1
	          )
	        : _vm._e(),
	      _c(
	        "div",
	        {
	          ref: "bodyWrapper",
	          staticClass: "el-table__body-wrapper",
	          class: [
	            _vm.layout.scrollX
	              ? "is-scrolling-" + _vm.scrollPosition
	              : "is-scrolling-none"
	          ],
	          style: [_vm.bodyHeight]
	        },
	        [
	          _c("table-body", {
	            style: {
	              width: _vm.bodyWidth
	            },
	            attrs: {
	              context: _vm.context,
	              store: _vm.store,
	              stripe: _vm.stripe,
	              "row-class-name": _vm.rowClassName,
	              "row-style": _vm.rowStyle,
	              highlight: _vm.highlightCurrentRow
	            }
	          }),
	          !_vm.data || _vm.data.length === 0
	            ? _c(
	                "div",
	                {
	                  ref: "emptyBlock",
	                  staticClass: "el-table__empty-block",
	                  style: _vm.emptyBlockStyle
	                },
	                [
	                  _c(
	                    "span",
	                    { staticClass: "el-table__empty-text" },
	                    [
	                      _vm._t("empty", [
	                        _vm._v(
	                          _vm._s(_vm.emptyText || _vm.t("el.table.emptyText"))
	                        )
	                      ])
	                    ],
	                    2
	                  )
	                ]
	              )
	            : _vm._e(),
	          _vm.$slots.append
	            ? _c(
	                "div",
	                {
	                  ref: "appendWrapper",
	                  staticClass: "el-table__append-wrapper"
	                },
	                [_vm._t("append")],
	                2
	              )
	            : _vm._e()
	        ],
	        1
	      ),
	      _vm.showSummary
	        ? _c(
	            "div",
	            {
	              directives: [
	                {
	                  name: "show",
	                  rawName: "v-show",
	                  value: _vm.data && _vm.data.length > 0,
	                  expression: "data && data.length > 0"
	                },
	                {
	                  name: "mousewheel",
	                  rawName: "v-mousewheel",
	                  value: _vm.handleHeaderFooterMousewheel,
	                  expression: "handleHeaderFooterMousewheel"
	                }
	              ],
	              ref: "footerWrapper",
	              staticClass: "el-table__footer-wrapper"
	            },
	            [
	              _c("table-footer", {
	                style: {
	                  width: _vm.layout.bodyWidth ? _vm.layout.bodyWidth + "px" : ""
	                },
	                attrs: {
	                  store: _vm.store,
	                  border: _vm.border,
	                  "sum-text": _vm.sumText || _vm.t("el.table.sumText"),
	                  "summary-method": _vm.summaryMethod,
	                  "default-sort": _vm.defaultSort
	                }
	              })
	            ],
	            1
	          )
	        : _vm._e(),
	      _vm.fixedColumns.length > 0
	        ? _c(
	            "div",
	            {
	              directives: [
	                {
	                  name: "mousewheel",
	                  rawName: "v-mousewheel",
	                  value: _vm.handleFixedMousewheel,
	                  expression: "handleFixedMousewheel"
	                }
	              ],
	              ref: "fixedWrapper",
	              staticClass: "el-table__fixed",
	              style: [
	                {
	                  width: _vm.layout.fixedWidth
	                    ? _vm.layout.fixedWidth + "px"
	                    : ""
	                },
	                _vm.fixedHeight
	              ]
	            },
	            [
	              _vm.showHeader
	                ? _c(
	                    "div",
	                    {
	                      ref: "fixedHeaderWrapper",
	                      staticClass: "el-table__fixed-header-wrapper"
	                    },
	                    [
	                      _c("table-header", {
	                        ref: "fixedTableHeader",
	                        style: {
	                          width: _vm.bodyWidth
	                        },
	                        attrs: {
	                          fixed: "left",
	                          border: _vm.border,
	                          store: _vm.store
	                        }
	                      })
	                    ],
	                    1
	                  )
	                : _vm._e(),
	              _c(
	                "div",
	                {
	                  ref: "fixedBodyWrapper",
	                  staticClass: "el-table__fixed-body-wrapper",
	                  style: [
	                    {
	                      top: _vm.layout.headerHeight + "px"
	                    },
	                    _vm.fixedBodyHeight
	                  ]
	                },
	                [
	                  _c("table-body", {
	                    style: {
	                      width: _vm.bodyWidth
	                    },
	                    attrs: {
	                      fixed: "left",
	                      store: _vm.store,
	                      stripe: _vm.stripe,
	                      highlight: _vm.highlightCurrentRow,
	                      "row-class-name": _vm.rowClassName,
	                      "row-style": _vm.rowStyle
	                    }
	                  }),
	                  _vm.$slots.append
	                    ? _c("div", {
	                        staticClass: "el-table__append-gutter",
	                        style: { height: _vm.layout.appendHeight + "px" }
	                      })
	                    : _vm._e()
	                ],
	                1
	              ),
	              _vm.showSummary
	                ? _c(
	                    "div",
	                    {
	                      directives: [
	                        {
	                          name: "show",
	                          rawName: "v-show",
	                          value: _vm.data && _vm.data.length > 0,
	                          expression: "data && data.length > 0"
	                        }
	                      ],
	                      ref: "fixedFooterWrapper",
	                      staticClass: "el-table__fixed-footer-wrapper"
	                    },
	                    [
	                      _c("table-footer", {
	                        style: {
	                          width: _vm.bodyWidth
	                        },
	                        attrs: {
	                          fixed: "left",
	                          border: _vm.border,
	                          "sum-text": _vm.sumText || _vm.t("el.table.sumText"),
	                          "summary-method": _vm.summaryMethod,
	                          store: _vm.store
	                        }
	                      })
	                    ],
	                    1
	                  )
	                : _vm._e()
	            ]
	          )
	        : _vm._e(),
	      _vm.rightFixedColumns.length > 0
	        ? _c(
	            "div",
	            {
	              directives: [
	                {
	                  name: "mousewheel",
	                  rawName: "v-mousewheel",
	                  value: _vm.handleFixedMousewheel,
	                  expression: "handleFixedMousewheel"
	                }
	              ],
	              ref: "rightFixedWrapper",
	              staticClass: "el-table__fixed-right",
	              style: [
	                {
	                  width: _vm.layout.rightFixedWidth
	                    ? _vm.layout.rightFixedWidth + "px"
	                    : "",
	                  right: _vm.layout.scrollY
	                    ? (_vm.border
	                        ? _vm.layout.gutterWidth
	                        : _vm.layout.gutterWidth || 0) + "px"
	                    : ""
	                },
	                _vm.fixedHeight
	              ]
	            },
	            [
	              _vm.showHeader
	                ? _c(
	                    "div",
	                    {
	                      ref: "rightFixedHeaderWrapper",
	                      staticClass: "el-table__fixed-header-wrapper"
	                    },
	                    [
	                      _c("table-header", {
	                        ref: "rightFixedTableHeader",
	                        style: {
	                          width: _vm.bodyWidth
	                        },
	                        attrs: {
	                          fixed: "right",
	                          border: _vm.border,
	                          store: _vm.store
	                        }
	                      })
	                    ],
	                    1
	                  )
	                : _vm._e(),
	              _c(
	                "div",
	                {
	                  ref: "rightFixedBodyWrapper",
	                  staticClass: "el-table__fixed-body-wrapper",
	                  style: [
	                    {
	                      top: _vm.layout.headerHeight + "px"
	                    },
	                    _vm.fixedBodyHeight
	                  ]
	                },
	                [
	                  _c("table-body", {
	                    style: {
	                      width: _vm.bodyWidth
	                    },
	                    attrs: {
	                      fixed: "right",
	                      store: _vm.store,
	                      stripe: _vm.stripe,
	                      "row-class-name": _vm.rowClassName,
	                      "row-style": _vm.rowStyle,
	                      highlight: _vm.highlightCurrentRow
	                    }
	                  }),
	                  _vm.$slots.append
	                    ? _c("div", {
	                        staticClass: "el-table__append-gutter",
	                        style: { height: _vm.layout.appendHeight + "px" }
	                      })
	                    : _vm._e()
	                ],
	                1
	              ),
	              _vm.showSummary
	                ? _c(
	                    "div",
	                    {
	                      directives: [
	                        {
	                          name: "show",
	                          rawName: "v-show",
	                          value: _vm.data && _vm.data.length > 0,
	                          expression: "data && data.length > 0"
	                        }
	                      ],
	                      ref: "rightFixedFooterWrapper",
	                      staticClass: "el-table__fixed-footer-wrapper"
	                    },
	                    [
	                      _c("table-footer", {
	                        style: {
	                          width: _vm.bodyWidth
	                        },
	                        attrs: {
	                          fixed: "right",
	                          border: _vm.border,
	                          "sum-text": _vm.sumText || _vm.t("el.table.sumText"),
	                          "summary-method": _vm.summaryMethod,
	                          store: _vm.store
	                        }
	                      })
	                    ],
	                    1
	                  )
	                : _vm._e()
	            ]
	          )
	        : _vm._e(),
	      _vm.rightFixedColumns.length > 0
	        ? _c("div", {
	            ref: "rightFixedPatch",
	            staticClass: "el-table__fixed-right-patch",
	            style: {
	              width: _vm.layout.scrollY ? _vm.layout.gutterWidth + "px" : "0",
	              height: _vm.layout.headerHeight + "px"
	            }
	          })
	        : _vm._e(),
	      _c("div", {
	        directives: [
	          {
	            name: "show",
	            rawName: "v-show",
	            value: _vm.resizeProxyVisible,
	            expression: "resizeProxyVisible"
	          }
	        ],
	        ref: "resizeProxy",
	        staticClass: "el-table__column-resize-proxy"
	      })
	    ]
	  )
	}
	var tablevue_type_template_id_493fe34e_staticRenderFns = []
	tablevue_type_template_id_493fe34e_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/table/src/table.vue?vue&type=template&id=493fe34e&
	
	// EXTERNAL MODULE: external "element-ui/lib/checkbox"
	var checkbox_ = __webpack_require__(16);
	var checkbox_default = /*#__PURE__*/__webpack_require__.n(checkbox_);
	
	// EXTERNAL MODULE: external "throttle-debounce"
	var external_throttle_debounce_ = __webpack_require__(35);
	
	// EXTERNAL MODULE: external "normalize-wheel"
	var external_normalize_wheel_ = __webpack_require__(38);
	var external_normalize_wheel_default = /*#__PURE__*/__webpack_require__.n(external_normalize_wheel_);
	
	// CONCATENATED MODULE: ./src/directives/mousewheel.js
	
	
	var isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
	
	var mousewheel_mousewheel = function mousewheel(element, callback) {
	  if (element && element.addEventListener) {
	    element.addEventListener(isFirefox ? 'DOMMouseScroll' : 'mousewheel', function (event) {
	      var normalized = external_normalize_wheel_default()(event);
	      callback && callback.apply(this, [event, normalized]);
	    });
	  }
	};
	
	/* harmony default export */ var directives_mousewheel = ({
	  bind: function bind(el, binding) {
	    mousewheel_mousewheel(el, binding.value);
	  }
	});
	// EXTERNAL MODULE: external "vue"
	var external_vue_ = __webpack_require__(6);
	var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);
	
	// CONCATENATED MODULE: ./packages/table/src/util.js
	var util_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	
	
	var getCell = function getCell(event) {
	  var cell = event.target;
	
	  while (cell && cell.tagName.toUpperCase() !== 'HTML') {
	    if (cell.tagName.toUpperCase() === 'TD') {
	      return cell;
	    }
	    cell = cell.parentNode;
	  }
	
	  return null;
	};
	
	var util_isObject = function isObject(obj) {
	  return obj !== null && (typeof obj === 'undefined' ? 'undefined' : util_typeof(obj)) === 'object';
	};
	
	var util_orderBy = function orderBy(array, sortKey, reverse, sortMethod, sortBy) {
	  if (!sortKey && !sortMethod && (!sortBy || Array.isArray(sortBy) && !sortBy.length)) {
	    return array;
	  }
	  if (typeof reverse === 'string') {
	    reverse = reverse === 'descending' ? -1 : 1;
	  } else {
	    reverse = reverse && reverse < 0 ? -1 : 1;
	  }
	  var getKey = sortMethod ? null : function (value, index) {
	    if (sortBy) {
	      if (!Array.isArray(sortBy)) {
	        sortBy = [sortBy];
	      }
	      return sortBy.map(function (by) {
	        if (typeof by === 'string') {
	          return Object(util_["getValueByPath"])(value, by);
	        } else {
	          return by(value, index, array);
	        }
	      });
	    }
	    if (sortKey !== '$key') {
	      if (util_isObject(value) && '$value' in value) value = value.$value;
	    }
	    return [util_isObject(value) ? Object(util_["getValueByPath"])(value, sortKey) : value];
	  };
	  var compare = function compare(a, b) {
	    if (sortMethod) {
	      return sortMethod(a.value, b.value);
	    }
	    for (var i = 0, len = a.key.length; i < len; i++) {
	      if (a.key[i] < b.key[i]) {
	        return -1;
	      }
	      if (a.key[i] > b.key[i]) {
	        return 1;
	      }
	    }
	    return 0;
	  };
	  return array.map(function (value, index) {
	    return {
	      value: value,
	      index: index,
	      key: getKey ? getKey(value, index) : null
	    };
	  }).sort(function (a, b) {
	    var order = compare(a, b);
	    if (!order) {
	      // make stable https://en.wikipedia.org/wiki/Sorting_algorithm#Stability
	      order = a.index - b.index;
	    }
	    return order * reverse;
	  }).map(function (item) {
	    return item.value;
	  });
	};
	
	var getColumnById = function getColumnById(table, columnId) {
	  var column = null;
	  table.columns.forEach(function (item) {
	    if (item.id === columnId) {
	      column = item;
	    }
	  });
	  return column;
	};
	
	var getColumnByKey = function getColumnByKey(table, columnKey) {
	  var column = null;
	  for (var i = 0; i < table.columns.length; i++) {
	    var item = table.columns[i];
	    if (item.columnKey === columnKey) {
	      column = item;
	      break;
	    }
	  }
	  return column;
	};
	
	var getColumnByCell = function getColumnByCell(table, cell) {
	  var matches = (cell.className || '').match(/el-table_[^\s]+/gm);
	  if (matches) {
	    return getColumnById(table, matches[0]);
	  }
	  return null;
	};
	
	var getRowIdentity = function getRowIdentity(row, rowKey) {
	  if (!row) throw new Error('row is required when get row identity');
	  if (typeof rowKey === 'string') {
	    if (rowKey.indexOf('.') < 0) {
	      return row[rowKey];
	    }
	    var key = rowKey.split('.');
	    var current = row;
	    for (var i = 0; i < key.length; i++) {
	      current = current[key[i]];
	    }
	    return current;
	  } else if (typeof rowKey === 'function') {
	    return rowKey.call(null, row);
	  }
	};
	
	var getKeysMap = function getKeysMap(array, rowKey) {
	  var arrayMap = {};
	  (array || []).forEach(function (row, index) {
	    arrayMap[getRowIdentity(row, rowKey)] = { row: row, index: index };
	  });
	  return arrayMap;
	};
	
	function hasOwn(obj, key) {
	  return Object.prototype.hasOwnProperty.call(obj, key);
	}
	
	function mergeOptions(defaults, config) {
	  var options = {};
	  var key = void 0;
	  for (key in defaults) {
	    options[key] = defaults[key];
	  }
	  for (key in config) {
	    if (hasOwn(config, key)) {
	      var value = config[key];
	      if (typeof value !== 'undefined') {
	        options[key] = value;
	      }
	    }
	  }
	  return options;
	}
	
	function parseWidth(width) {
	  if (width !== undefined) {
	    width = parseInt(width, 10);
	    if (isNaN(width)) {
	      width = null;
	    }
	  }
	  return width;
	}
	
	function parseMinWidth(minWidth) {
	  if (typeof minWidth !== 'undefined') {
	    minWidth = parseWidth(minWidth);
	    if (isNaN(minWidth)) {
	      minWidth = 80;
	    }
	  }
	  return minWidth;
	};
	
	function parseHeight(height) {
	  if (typeof height === 'number') {
	    return height;
	  }
	  if (typeof height === 'string') {
	    if (/^\d+(?:px)?$/.test(height)) {
	      return parseInt(height, 10);
	    } else {
	      return height;
	    }
	  }
	  return null;
	}
	
	// https://github.com/reduxjs/redux/blob/master/src/compose.js
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}
	
	function toggleRowStatus(statusArr, row, newVal) {
	  var changed = false;
	  var index = statusArr.indexOf(row);
	  var included = index !== -1;
	
	  var addRow = function addRow() {
	    statusArr.push(row);
	    changed = true;
	  };
	  var removeRow = function removeRow() {
	    statusArr.splice(index, 1);
	    changed = true;
	  };
	
	  if (typeof newVal === 'boolean') {
	    if (newVal && !included) {
	      addRow();
	    } else if (!newVal && included) {
	      removeRow();
	    }
	  } else {
	    if (included) {
	      removeRow();
	    } else {
	      addRow();
	    }
	  }
	  return changed;
	}
	
	function walkTreeNode(root, cb) {
	  var childrenKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'children';
	  var lazyKey = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'hasChildren';
	
	  var isNil = function isNil(array) {
	    return !(Array.isArray(array) && array.length);
	  };
	
	  function _walker(parent, children, level) {
	    cb(parent, children, level);
	    children.forEach(function (item) {
	      if (item[lazyKey]) {
	        cb(item, null, level + 1);
	        return;
	      }
	      var children = item[childrenKey];
	      if (!isNil(children)) {
	        _walker(item, children, level + 1);
	      }
	    });
	  }
	
	  root.forEach(function (item) {
	    if (item[lazyKey]) {
	      cb(item, null, 0);
	      return;
	    }
	    var children = item[childrenKey];
	    if (!isNil(children)) {
	      _walker(item, children, 0);
	    }
	  });
	}
	// CONCATENATED MODULE: ./packages/table/src/store/expand.js
	
	
	/* harmony default export */ var expand = ({
	  data: function data() {
	    return {
	      states: {
	        defaultExpandAll: false,
	        expandRows: []
	      }
	    };
	  },
	
	
	  methods: {
	    updateExpandRows: function updateExpandRows() {
	      var _states = this.states,
	          _states$data = _states.data,
	          data = _states$data === undefined ? [] : _states$data,
	          rowKey = _states.rowKey,
	          defaultExpandAll = _states.defaultExpandAll,
	          expandRows = _states.expandRows;
	
	      if (defaultExpandAll) {
	        this.states.expandRows = data.slice();
	      } else if (rowKey) {
	        // TODO：这里的代码可以优化
	        var expandRowsMap = getKeysMap(expandRows, rowKey);
	        this.states.expandRows = data.reduce(function (prev, row) {
	          var rowId = getRowIdentity(row, rowKey);
	          var rowInfo = expandRowsMap[rowId];
	          if (rowInfo) {
	            prev.push(row);
	          }
	          return prev;
	        }, []);
	      } else {
	        this.states.expandRows = [];
	      }
	    },
	    toggleRowExpansion: function toggleRowExpansion(row, expanded) {
	      var changed = toggleRowStatus(this.states.expandRows, row, expanded);
	      if (changed) {
	        this.table.$emit('expand-change', row, this.states.expandRows.slice());
	        this.scheduleLayout();
	      }
	    },
	    setExpandRowKeys: function setExpandRowKeys(rowKeys) {
	      this.assertRowKey();
	      // TODO：这里的代码可以优化
	      var _states2 = this.states,
	          data = _states2.data,
	          rowKey = _states2.rowKey;
	
	      var keysMap = getKeysMap(data, rowKey);
	      this.states.expandRows = rowKeys.reduce(function (prev, cur) {
	        var info = keysMap[cur];
	        if (info) {
	          prev.push(info.row);
	        }
	        return prev;
	      }, []);
	    },
	    isRowExpanded: function isRowExpanded(row) {
	      var _states3 = this.states,
	          _states3$expandRows = _states3.expandRows,
	          expandRows = _states3$expandRows === undefined ? [] : _states3$expandRows,
	          rowKey = _states3.rowKey;
	
	      if (rowKey) {
	        var expandMap = getKeysMap(expandRows, rowKey);
	        return !!expandMap[getRowIdentity(row, rowKey)];
	      }
	      return expandRows.indexOf(row) !== -1;
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/table/src/store/current.js
	
	
	
	/* harmony default export */ var current = ({
	  data: function data() {
	    return {
	      states: {
	        // 不可响应的，设置 currentRowKey 时，data 不一定存在，也许无法算出正确的 currentRow
	        // 把该值缓存一下，当用户点击修改 currentRow 时，把该值重置为 null
	        _currentRowKey: null,
	        currentRow: null
	      }
	    };
	  },
	
	
	  methods: {
	    setCurrentRowKey: function setCurrentRowKey(key) {
	      this.assertRowKey();
	      this.states._currentRowKey = key;
	      this.setCurrentRowByKey(key);
	    },
	    restoreCurrentRowKey: function restoreCurrentRowKey() {
	      this.states._currentRowKey = null;
	    },
	    setCurrentRowByKey: function setCurrentRowByKey(key) {
	      var states = this.states;
	      var _states$data = states.data,
	          data = _states$data === undefined ? [] : _states$data,
	          rowKey = states.rowKey;
	
	      var currentRow = null;
	      if (rowKey) {
	        currentRow = Object(util_["arrayFind"])(data, function (item) {
	          return getRowIdentity(item, rowKey) === key;
	        });
	      }
	      states.currentRow = currentRow;
	    },
	    updateCurrentRow: function updateCurrentRow(currentRow) {
	      var states = this.states,
	          table = this.table;
	
	      var oldCurrentRow = states.currentRow;
	      if (currentRow && currentRow !== oldCurrentRow) {
	        states.currentRow = currentRow;
	        table.$emit('current-change', currentRow, oldCurrentRow);
	        return;
	      }
	      if (!currentRow && oldCurrentRow) {
	        states.currentRow = null;
	        table.$emit('current-change', null, oldCurrentRow);
	      }
	    },
	    updateCurrentRowData: function updateCurrentRowData() {
	      var states = this.states,
	          table = this.table;
	      var rowKey = states.rowKey,
	          _currentRowKey = states._currentRowKey;
	      // data 为 null 时，解构时的默认值会被忽略
	
	      var data = states.data || [];
	      var oldCurrentRow = states.currentRow;
	
	      // 当 currentRow 不在 data 中时尝试更新数据
	      if (data.indexOf(oldCurrentRow) === -1 && oldCurrentRow) {
	        if (rowKey) {
	          var currentRowKey = getRowIdentity(oldCurrentRow, rowKey);
	          this.setCurrentRowByKey(currentRowKey);
	        } else {
	          states.currentRow = null;
	        }
	        if (states.currentRow === null) {
	          table.$emit('current-change', null, oldCurrentRow);
	        }
	      } else if (_currentRowKey) {
	        // 把初始时下设置的 rowKey 转化成 rowData
	        this.setCurrentRowByKey(_currentRowKey);
	        this.restoreCurrentRowKey();
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/table/src/store/tree.js
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	
	
	/* harmony default export */ var tree = ({
	  data: function data() {
	    return {
	      states: {
	        // defaultExpandAll 存在于 expand.js 中，这里不重复添加
	        // 在展开行中，expandRowKeys 会被转化成 expandRows，expandRowKeys 这个属性只是记录了 TreeTable 行的展开
	        // TODO: 拆分为独立的 TreeTable，统一用法
	        expandRowKeys: [],
	        treeData: {},
	        indent: 16,
	        lazy: false,
	        lazyTreeNodeMap: {},
	        lazyColumnIdentifier: 'hasChildren',
	        childrenColumnName: 'children'
	      }
	    };
	  },
	
	
	  computed: {
	    // 嵌入型的数据，watch 无法是检测到变化 https://github.com/ElemeFE/element/issues/14998
	    // TODO: 使用 computed 解决该问题，是否会造成性能问题？
	    // @return { id: { level, children } }
	    normalizedData: function normalizedData() {
	      if (!this.states.rowKey) return {};
	      var data = this.states.data || [];
	      return this.normalize(data);
	    },
	
	    // @return { id: { children } }
	    // 针对懒加载的情形，不处理嵌套数据
	    normalizedLazyNode: function normalizedLazyNode() {
	      var _states = this.states,
	          rowKey = _states.rowKey,
	          lazyTreeNodeMap = _states.lazyTreeNodeMap,
	          lazyColumnIdentifier = _states.lazyColumnIdentifier;
	
	      var keys = Object.keys(lazyTreeNodeMap);
	      var res = {};
	      if (!keys.length) return res;
	      keys.forEach(function (key) {
	        if (lazyTreeNodeMap[key].length) {
	          var item = { children: [] };
	          lazyTreeNodeMap[key].forEach(function (row) {
	            var currentRowKey = getRowIdentity(row, rowKey);
	            item.children.push(currentRowKey);
	            if (row[lazyColumnIdentifier] && !res[currentRowKey]) {
	              res[currentRowKey] = { children: [] };
	            }
	          });
	          res[key] = item;
	        }
	      });
	      return res;
	    }
	  },
	
	  watch: {
	    normalizedData: 'updateTreeData',
	    normalizedLazyNode: 'updateTreeData'
	  },
	
	  methods: {
	    normalize: function normalize(data) {
	      var _states2 = this.states,
	          childrenColumnName = _states2.childrenColumnName,
	          lazyColumnIdentifier = _states2.lazyColumnIdentifier,
	          rowKey = _states2.rowKey,
	          lazy = _states2.lazy;
	
	      var res = {};
	      walkTreeNode(data, function (parent, children, level) {
	        var parentId = getRowIdentity(parent, rowKey);
	        if (Array.isArray(children)) {
	          res[parentId] = {
	            children: children.map(function (row) {
	              return getRowIdentity(row, rowKey);
	            }),
	            level: level
	          };
	        } else if (lazy) {
	          // 当 children 不存在且 lazy 为 true，该节点即为懒加载的节点
	          res[parentId] = {
	            children: [],
	            lazy: true,
	            level: level
	          };
	        }
	      }, childrenColumnName, lazyColumnIdentifier);
	      return res;
	    },
	    updateTreeData: function updateTreeData() {
	      var nested = this.normalizedData;
	      var normalizedLazyNode = this.normalizedLazyNode;
	      var keys = Object.keys(nested);
	      var newTreeData = {};
	      if (keys.length) {
	        var _states3 = this.states,
	            oldTreeData = _states3.treeData,
	            defaultExpandAll = _states3.defaultExpandAll,
	            expandRowKeys = _states3.expandRowKeys,
	            lazy = _states3.lazy;
	
	        var rootLazyRowKeys = [];
	        var getExpanded = function getExpanded(oldValue, key) {
	          var included = defaultExpandAll || expandRowKeys && expandRowKeys.indexOf(key) !== -1;
	          return !!(oldValue && oldValue.expanded || included);
	        };
	        // 合并 expanded 与 display，确保数据刷新后，状态不变
	        keys.forEach(function (key) {
	          var oldValue = oldTreeData[key];
	          var newValue = _extends({}, nested[key]);
	          newValue.expanded = getExpanded(oldValue, key);
	          if (newValue.lazy) {
	            var _ref = oldValue || {},
	                _ref$loaded = _ref.loaded,
	                loaded = _ref$loaded === undefined ? false : _ref$loaded,
	                _ref$loading = _ref.loading,
	                loading = _ref$loading === undefined ? false : _ref$loading;
	
	            newValue.loaded = !!loaded;
	            newValue.loading = !!loading;
	            rootLazyRowKeys.push(key);
	          }
	          newTreeData[key] = newValue;
	        });
	        // 根据懒加载数据更新 treeData
	        var lazyKeys = Object.keys(normalizedLazyNode);
	        if (lazy && lazyKeys.length && rootLazyRowKeys.length) {
	          lazyKeys.forEach(function (key) {
	            var oldValue = oldTreeData[key];
	            var lazyNodeChildren = normalizedLazyNode[key].children;
	            if (rootLazyRowKeys.indexOf(key) !== -1) {
	              // 懒加载的 root 节点，更新一下原有的数据，原来的 children 一定是空数组
	              if (newTreeData[key].children.length !== 0) {
	                throw new Error('[ElTable]children must be an empty array.');
	              }
	              newTreeData[key].children = lazyNodeChildren;
	            } else {
	              var _ref2 = oldValue || {},
	                  _ref2$loaded = _ref2.loaded,
	                  loaded = _ref2$loaded === undefined ? false : _ref2$loaded,
	                  _ref2$loading = _ref2.loading,
	                  loading = _ref2$loading === undefined ? false : _ref2$loading;
	
	              newTreeData[key] = {
	                lazy: true,
	                loaded: !!loaded,
	                loading: !!loading,
	                expanded: getExpanded(oldValue, key),
	                children: lazyNodeChildren,
	                level: ''
	              };
	            }
	          });
	        }
	      }
	      this.states.treeData = newTreeData;
	      this.updateTableScrollY();
	    },
	    updateTreeExpandKeys: function updateTreeExpandKeys(value) {
	      this.states.expandRowKeys = value;
	      this.updateTreeData();
	    },
	    toggleTreeExpansion: function toggleTreeExpansion(row, expanded) {
	      this.assertRowKey();
	
	      var _states4 = this.states,
	          rowKey = _states4.rowKey,
	          treeData = _states4.treeData;
	
	      var id = getRowIdentity(row, rowKey);
	      var data = id && treeData[id];
	      if (id && data && 'expanded' in data) {
	        var oldExpanded = data.expanded;
	        expanded = typeof expanded === 'undefined' ? !data.expanded : expanded;
	        treeData[id].expanded = expanded;
	        if (oldExpanded !== expanded) {
	          this.table.$emit('expand-change', row, expanded);
	        }
	        this.updateTableScrollY();
	      }
	    },
	    loadOrToggle: function loadOrToggle(row) {
	      this.assertRowKey();
	      var _states5 = this.states,
	          lazy = _states5.lazy,
	          treeData = _states5.treeData,
	          rowKey = _states5.rowKey;
	
	      var id = getRowIdentity(row, rowKey);
	      var data = treeData[id];
	      if (lazy && data && 'loaded' in data && !data.loaded) {
	        this.loadData(row, id, data);
	      } else {
	        this.toggleTreeExpansion(row);
	      }
	    },
	    loadData: function loadData(row, key, treeNode) {
	      var _this = this;
	
	      var load = this.table.load;
	      var _states6 = this.states,
	          lazyTreeNodeMap = _states6.lazyTreeNodeMap,
	          treeData = _states6.treeData;
	
	      if (load && !treeData[key].loaded) {
	        treeData[key].loading = true;
	        load(row, treeNode, function (data) {
	          if (!Array.isArray(data)) {
	            throw new Error('[ElTable] data must be an array');
	          }
	          treeData[key].loading = false;
	          treeData[key].loaded = true;
	          treeData[key].expanded = true;
	          if (data.length) {
	            _this.$set(lazyTreeNodeMap, key, data);
	          }
	          _this.table.$emit('expand-change', row, true);
	        });
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/table/src/store/watcher.js
	
	
	
	
	
	
	
	var watcher_sortData = function sortData(data, states) {
	  var sortingColumn = states.sortingColumn;
	  if (!sortingColumn || typeof sortingColumn.sortable === 'string') {
	    return data;
	  }
	  return util_orderBy(data, states.sortProp, states.sortOrder, sortingColumn.sortMethod, sortingColumn.sortBy);
	};
	
	var doFlattenColumns = function doFlattenColumns(columns) {
	  var result = [];
	  columns.forEach(function (column) {
	    if (column.children) {
	      result.push.apply(result, doFlattenColumns(column.children));
	    } else {
	      result.push(column);
	    }
	  });
	  return result;
	};
	
	/* harmony default export */ var watcher = (external_vue_default.a.extend({
	  data: function data() {
	    return {
	      states: {
	        // 3.0 版本后要求必须设置该属性
	        rowKey: null,
	
	        // 渲染的数据来源，是对 table 中的 data 过滤排序后的结果
	        data: [],
	
	        // 是否包含固定列
	        isComplex: false,
	
	        // 列
	        _columns: [], // 不可响应的
	        originColumns: [],
	        columns: [],
	        fixedColumns: [],
	        rightFixedColumns: [],
	        leafColumns: [],
	        fixedLeafColumns: [],
	        rightFixedLeafColumns: [],
	        leafColumnsLength: 0,
	        fixedLeafColumnsLength: 0,
	        rightFixedLeafColumnsLength: 0,
	
	        // 选择
	        isAllSelected: false,
	        selection: [],
	        reserveSelection: false,
	        selectOnIndeterminate: false,
	        selectable: null,
	
	        // 过滤
	        filters: {}, // 不可响应的
	        filteredData: null,
	
	        // 排序
	        sortingColumn: null,
	        sortProp: null,
	        sortOrder: null,
	
	        hoverRow: null
	      }
	    };
	  },
	
	
	  mixins: [expand, current, tree],
	
	  methods: {
	    // 检查 rowKey 是否存在
	    assertRowKey: function assertRowKey() {
	      var rowKey = this.states.rowKey;
	      if (!rowKey) throw new Error('[ElTable] prop row-key is required');
	    },
	
	
	    // 更新列
	    updateColumns: function updateColumns() {
	      var states = this.states;
	      var _columns = states._columns || [];
	      states.fixedColumns = _columns.filter(function (column) {
	        return column.fixed === true || column.fixed === 'left';
	      });
	      states.rightFixedColumns = _columns.filter(function (column) {
	        return column.fixed === 'right';
	      });
	
	      if (states.fixedColumns.length > 0 && _columns[0] && _columns[0].type === 'selection' && !_columns[0].fixed) {
	        _columns[0].fixed = true;
	        states.fixedColumns.unshift(_columns[0]);
	      }
	
	      var notFixedColumns = _columns.filter(function (column) {
	        return !column.fixed;
	      });
	      states.originColumns = [].concat(states.fixedColumns).concat(notFixedColumns).concat(states.rightFixedColumns);
	
	      var leafColumns = doFlattenColumns(notFixedColumns);
	      var fixedLeafColumns = doFlattenColumns(states.fixedColumns);
	      var rightFixedLeafColumns = doFlattenColumns(states.rightFixedColumns);
	
	      states.leafColumnsLength = leafColumns.length;
	      states.fixedLeafColumnsLength = fixedLeafColumns.length;
	      states.rightFixedLeafColumnsLength = rightFixedLeafColumns.length;
	
	      states.columns = [].concat(fixedLeafColumns).concat(leafColumns).concat(rightFixedLeafColumns);
	      states.isComplex = states.fixedColumns.length > 0 || states.rightFixedColumns.length > 0;
	    },
	
	
	    // 更新 DOM
	    scheduleLayout: function scheduleLayout(needUpdateColumns) {
	      if (needUpdateColumns) {
	        this.updateColumns();
	      }
	      this.table.debouncedUpdateLayout();
	    },
	
	
	    // 选择
	    isSelected: function isSelected(row) {
	      var _states$selection = this.states.selection,
	          selection = _states$selection === undefined ? [] : _states$selection;
	
	      return selection.indexOf(row) > -1;
	    },
	    clearSelection: function clearSelection() {
	      var states = this.states;
	      states.isAllSelected = false;
	      var oldSelection = states.selection;
	      if (oldSelection.length) {
	        states.selection = [];
	        this.table.$emit('selection-change', []);
	      }
	    },
	    cleanSelection: function cleanSelection() {
	      var states = this.states;
	      var data = states.data,
	          rowKey = states.rowKey,
	          selection = states.selection;
	
	      var deleted = void 0;
	      if (rowKey) {
	        deleted = [];
	        var selectedMap = getKeysMap(selection, rowKey);
	        var dataMap = getKeysMap(data, rowKey);
	        for (var key in selectedMap) {
	          if (selectedMap.hasOwnProperty(key) && !dataMap[key]) {
	            deleted.push(selectedMap[key].row);
	          }
	        }
	      } else {
	        deleted = selection.filter(function (item) {
	          return data.indexOf(item) === -1;
	        });
	      }
	      if (deleted.length) {
	        var newSelection = selection.filter(function (item) {
	          return deleted.indexOf(item) === -1;
	        });
	        states.selection = newSelection;
	        this.table.$emit('selection-change', newSelection.slice());
	      }
	    },
	    toggleRowSelection: function toggleRowSelection(row, selected) {
	      var emitChange = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	      var changed = toggleRowStatus(this.states.selection, row, selected);
	      if (changed) {
	        var newSelection = (this.states.selection || []).slice();
	        // 调用 API 修改选中值，不触发 select 事件
	        if (emitChange) {
	          this.table.$emit('select', newSelection, row);
	        }
	        this.table.$emit('selection-change', newSelection);
	      }
	    },
	    _toggleAllSelection: function _toggleAllSelection() {
	      var states = this.states;
	      var _states$data = states.data,
	          data = _states$data === undefined ? [] : _states$data,
	          selection = states.selection;
	      // when only some rows are selected (but not all), select or deselect all of them
	      // depending on the value of selectOnIndeterminate
	
	      var value = states.selectOnIndeterminate ? !states.isAllSelected : !(states.isAllSelected || selection.length);
	      states.isAllSelected = value;
	
	      var selectionChanged = false;
	      data.forEach(function (row, index) {
	        if (states.selectable) {
	          if (states.selectable.call(null, row, index) && toggleRowStatus(selection, row, value)) {
	            selectionChanged = true;
	          }
	        } else {
	          if (toggleRowStatus(selection, row, value)) {
	            selectionChanged = true;
	          }
	        }
	      });
	
	      if (selectionChanged) {
	        this.table.$emit('selection-change', selection ? selection.slice() : []);
	      }
	      this.table.$emit('select-all', selection);
	    },
	    updateSelectionByRowKey: function updateSelectionByRowKey() {
	      var states = this.states;
	      var selection = states.selection,
	          rowKey = states.rowKey,
	          data = states.data;
	
	      var selectedMap = getKeysMap(selection, rowKey);
	      data.forEach(function (row) {
	        var rowId = getRowIdentity(row, rowKey);
	        var rowInfo = selectedMap[rowId];
	        if (rowInfo) {
	          selection[rowInfo.index] = row;
	        }
	      });
	    },
	    updateAllSelected: function updateAllSelected() {
	      var states = this.states;
	      var selection = states.selection,
	          rowKey = states.rowKey,
	          selectable = states.selectable;
	      // data 为 null 时，解构时的默认值会被忽略
	
	      var data = states.data || [];
	      if (data.length === 0) {
	        states.isAllSelected = false;
	        return;
	      }
	
	      var selectedMap = void 0;
	      if (rowKey) {
	        selectedMap = getKeysMap(selection, rowKey);
	      }
	      var isSelected = function isSelected(row) {
	        if (selectedMap) {
	          return !!selectedMap[getRowIdentity(row, rowKey)];
	        } else {
	          return selection.indexOf(row) !== -1;
	        }
	      };
	      var isAllSelected = true;
	      var selectedCount = 0;
	      for (var i = 0, j = data.length; i < j; i++) {
	        var item = data[i];
	        var isRowSelectable = selectable && selectable.call(null, item, i);
	        if (!isSelected(item)) {
	          if (!selectable || isRowSelectable) {
	            isAllSelected = false;
	            break;
	          }
	        } else {
	          selectedCount++;
	        }
	      }
	
	      if (selectedCount === 0) isAllSelected = false;
	      states.isAllSelected = isAllSelected;
	    },
	
	
	    // 过滤与排序
	    updateFilters: function updateFilters(columns, values) {
	      if (!Array.isArray(columns)) {
	        columns = [columns];
	      }
	      var states = this.states;
	      var filters = {};
	      columns.forEach(function (col) {
	        states.filters[col.id] = values;
	        filters[col.columnKey || col.id] = values;
	      });
	
	      return filters;
	    },
	    updateSort: function updateSort(column, prop, order) {
	      if (this.states.sortingColumn && this.states.sortingColumn !== column) {
	        this.states.sortingColumn.order = null;
	      }
	      this.states.sortingColumn = column;
	      this.states.sortProp = prop;
	      this.states.sortOrder = order;
	    },
	    execFilter: function execFilter() {
	      var _this = this;
	
	      var states = this.states;
	      var _data = states._data,
	          filters = states.filters;
	
	      var data = _data;
	
	      Object.keys(filters).forEach(function (columnId) {
	        var values = states.filters[columnId];
	        if (!values || values.length === 0) return;
	        var column = getColumnById(_this.states, columnId);
	        if (column && column.filterMethod) {
	          data = data.filter(function (row) {
	            return values.some(function (value) {
	              return column.filterMethod.call(null, value, row, column);
	            });
	          });
	        }
	      });
	
	      states.filteredData = data;
	    },
	    execSort: function execSort() {
	      var states = this.states;
	      states.data = watcher_sortData(states.filteredData, states);
	    },
	
	
	    // 根据 filters 与 sort 去过滤 data
	    execQuery: function execQuery(ignore) {
	      if (!(ignore && ignore.filter)) {
	        this.execFilter();
	      }
	      this.execSort();
	    },
	    clearFilter: function clearFilter(columnKeys) {
	      var states = this.states;
	      var _table$$refs = this.table.$refs,
	          tableHeader = _table$$refs.tableHeader,
	          fixedTableHeader = _table$$refs.fixedTableHeader,
	          rightFixedTableHeader = _table$$refs.rightFixedTableHeader;
	
	
	      var panels = {};
	      if (tableHeader) panels = merge_default()(panels, tableHeader.filterPanels);
	      if (fixedTableHeader) panels = merge_default()(panels, fixedTableHeader.filterPanels);
	      if (rightFixedTableHeader) panels = merge_default()(panels, rightFixedTableHeader.filterPanels);
	
	      var keys = Object.keys(panels);
	      if (!keys.length) return;
	
	      if (typeof columnKeys === 'string') {
	        columnKeys = [columnKeys];
	      }
	
	      if (Array.isArray(columnKeys)) {
	        var columns = columnKeys.map(function (key) {
	          return getColumnByKey(states, key);
	        });
	        keys.forEach(function (key) {
	          var column = columns.find(function (col) {
	            return col.id === key;
	          });
	          if (column) {
	            // TODO: 优化这里的代码
	            panels[key].filteredValue = [];
	          }
	        });
	        this.commit('filterChange', {
	          column: columns,
	          values: [],
	          silent: true,
	          multi: true
	        });
	      } else {
	        keys.forEach(function (key) {
	          // TODO: 优化这里的代码
	          panels[key].filteredValue = [];
	        });
	
	        states.filters = {};
	        this.commit('filterChange', {
	          column: {},
	          values: [],
	          silent: true
	        });
	      }
	    },
	    clearSort: function clearSort() {
	      var states = this.states;
	      if (!states.sortingColumn) return;
	
	      this.updateSort(null, null, null);
	      this.commit('changeSortCondition', {
	        silent: true
	      });
	    },
	
	
	    // 适配层，expand-row-keys 在 Expand 与 TreeTable 中都有使用
	    setExpandRowKeysAdapter: function setExpandRowKeysAdapter(val) {
	      // 这里会触发额外的计算，但为了兼容性，暂时这么做
	      this.setExpandRowKeys(val);
	      this.updateTreeExpandKeys(val);
	    },
	
	
	    // 展开行与 TreeTable 都要使用
	    toggleRowExpansionAdapter: function toggleRowExpansionAdapter(row, expanded) {
	      var hasExpandColumn = this.states.columns.some(function (_ref) {
	        var type = _ref.type;
	        return type === 'expand';
	      });
	      if (hasExpandColumn) {
	        this.toggleRowExpansion(row, expanded);
	      } else {
	        this.toggleTreeExpansion(row, expanded);
	      }
	    }
	  }
	}));
	// CONCATENATED MODULE: ./packages/table/src/store/index.js
	
	
	
	
	watcher.prototype.mutations = {
	  setData: function setData(states, data) {
	    var dataInstanceChanged = states._data !== data;
	    states._data = data;
	
	    this.execQuery();
	    // 数据变化，更新部分数据。
	    // 没有使用 computed，而是手动更新部分数据 https://github.com/vuejs/vue/issues/6660#issuecomment-331417140
	    this.updateCurrentRowData();
	    this.updateExpandRows();
	    if (states.reserveSelection) {
	      this.assertRowKey();
	      this.updateSelectionByRowKey();
	    } else {
	      if (dataInstanceChanged) {
	        this.clearSelection();
	      } else {
	        this.cleanSelection();
	      }
	    }
	    this.updateAllSelected();
	
	    this.updateTableScrollY();
	  },
	  insertColumn: function insertColumn(states, column, index, parent) {
	    var array = states._columns;
	    if (parent) {
	      array = parent.children;
	      if (!array) array = parent.children = [];
	    }
	
	    if (typeof index !== 'undefined') {
	      array.splice(index, 0, column);
	    } else {
	      array.push(column);
	    }
	
	    if (column.type === 'selection') {
	      states.selectable = column.selectable;
	      states.reserveSelection = column.reserveSelection;
	    }
	
	    if (this.table.$ready) {
	      this.updateColumns(); // hack for dynamics insert column
	      this.scheduleLayout();
	    }
	  },
	  removeColumn: function removeColumn(states, column, parent) {
	    var array = states._columns;
	    if (parent) {
	      array = parent.children;
	      if (!array) array = parent.children = [];
	    }
	    if (array) {
	      array.splice(array.indexOf(column), 1);
	    }
	
	    if (this.table.$ready) {
	      this.updateColumns(); // hack for dynamics remove column
	      this.scheduleLayout();
	    }
	  },
	  sort: function sort(states, options) {
	    var prop = options.prop,
	        order = options.order,
	        init = options.init;
	
	    if (prop) {
	      var column = Object(util_["arrayFind"])(states.columns, function (column) {
	        return column.property === prop;
	      });
	      if (column) {
	        column.order = order;
	        this.updateSort(column, prop, order);
	        this.commit('changeSortCondition', { init: init });
	      }
	    }
	  },
	  changeSortCondition: function changeSortCondition(states, options) {
	    // 修复 pr https://github.com/ElemeFE/element/pull/15012 导致的 bug
	    var column = states.sortingColumn,
	        prop = states.sortProp,
	        order = states.sortOrder;
	
	    if (order === null) {
	      states.sortingColumn = null;
	      states.sortProp = null;
	    }
	    var ingore = { filter: true };
	    this.execQuery(ingore);
	
	    if (!options || !(options.silent || options.init)) {
	      this.table.$emit('sort-change', {
	        column: column,
	        prop: prop,
	        order: order
	      });
	    }
	
	    this.updateTableScrollY();
	  },
	  filterChange: function filterChange(states, options) {
	    var column = options.column,
	        values = options.values,
	        silent = options.silent;
	
	    var newFilters = this.updateFilters(column, values);
	
	    this.execQuery();
	
	    if (!silent) {
	      this.table.$emit('filter-change', newFilters);
	    }
	
	    this.updateTableScrollY();
	  },
	  toggleAllSelection: function toggleAllSelection() {
	    this.toggleAllSelection();
	  },
	  rowSelectedChanged: function rowSelectedChanged(states, row) {
	    this.toggleRowSelection(row);
	    this.updateAllSelected();
	  },
	  setHoverRow: function setHoverRow(states, row) {
	    states.hoverRow = row;
	  },
	  setCurrentRow: function setCurrentRow(states, row) {
	    this.updateCurrentRow(row);
	  }
	};
	
	watcher.prototype.commit = function (name) {
	  var mutations = this.mutations;
	  if (mutations[name]) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    mutations[name].apply(this, [this.states].concat(args));
	  } else {
	    throw new Error('Action not found: ' + name);
	  }
	};
	
	watcher.prototype.updateTableScrollY = function () {
	  external_vue_default.a.nextTick(this.table.updateScrollY);
	};
	
	/* harmony default export */ var src_store = (watcher);
	// CONCATENATED MODULE: ./packages/table/src/store/helper.js
	
	
	
	function createStore(table) {
	  var initialState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (!table) {
	    throw new Error('Table is required.');
	  }
	
	  var store = new src_store();
	  store.table = table;
	  // fix https://github.com/ElemeFE/element/issues/14075
	  // related pr https://github.com/ElemeFE/element/pull/14146
	  store.toggleAllSelection = debounce_default()(10, store._toggleAllSelection);
	  Object.keys(initialState).forEach(function (key) {
	    store.states[key] = initialState[key];
	  });
	  return store;
	}
	
	function mapStates(mapper) {
	  var res = {};
	  Object.keys(mapper).forEach(function (key) {
	    var value = mapper[key];
	    var fn = void 0;
	    if (typeof value === 'string') {
	      fn = function fn() {
	        return this.store.states[value];
	      };
	    } else if (typeof value === 'function') {
	      fn = function fn() {
	        return value.call(this, this.store.states);
	      };
	    } else {
	      console.error('invalid value type');
	    }
	    if (fn) {
	      res[key] = fn;
	    }
	  });
	  return res;
	};
	// EXTERNAL MODULE: external "element-ui/lib/utils/scrollbar-width"
	var scrollbar_width_ = __webpack_require__(31);
	var scrollbar_width_default = /*#__PURE__*/__webpack_require__.n(scrollbar_width_);
	
	// CONCATENATED MODULE: ./packages/table/src/table-layout.js
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	
	
	
	
	var table_layout_TableLayout = function () {
	  function TableLayout(options) {
	    _classCallCheck(this, TableLayout);
	
	    this.observers = [];
	    this.table = null;
	    this.store = null;
	    this.columns = null;
	    this.fit = true;
	    this.showHeader = true;
	
	    this.height = null;
	    this.scrollX = false;
	    this.scrollY = false;
	    this.bodyWidth = null;
	    this.fixedWidth = null;
	    this.rightFixedWidth = null;
	    this.tableHeight = null;
	    this.headerHeight = 44; // Table Header Height
	    this.appendHeight = 0; // Append Slot Height
	    this.footerHeight = 44; // Table Footer Height
	    this.viewportHeight = null; // Table Height - Scroll Bar Height
	    this.bodyHeight = null; // Table Height - Table Header Height
	    this.fixedBodyHeight = null; // Table Height - Table Header Height - Scroll Bar Height
	    this.gutterWidth = scrollbar_width_default()();
	
	    for (var name in options) {
	      if (options.hasOwnProperty(name)) {
	        this[name] = options[name];
	      }
	    }
	
	    if (!this.table) {
	      throw new Error('table is required for Table Layout');
	    }
	    if (!this.store) {
	      throw new Error('store is required for Table Layout');
	    }
	  }
	
	  TableLayout.prototype.updateScrollY = function updateScrollY() {
	    var height = this.height;
	    if (height === null) return false;
	    var bodyWrapper = this.table.bodyWrapper;
	    if (this.table.$el && bodyWrapper) {
	      var body = bodyWrapper.querySelector('.el-table__body');
	      var prevScrollY = this.scrollY;
	      var scrollY = body.offsetHeight > this.bodyHeight;
	      this.scrollY = scrollY;
	      return prevScrollY !== scrollY;
	    }
	    return false;
	  };
	
	  TableLayout.prototype.setHeight = function setHeight(value) {
	    var _this = this;
	
	    var prop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'height';
	
	    if (external_vue_default.a.prototype.$isServer) return;
	    var el = this.table.$el;
	    value = parseHeight(value);
	    this.height = value;
	
	    if (!el && (value || value === 0)) return external_vue_default.a.nextTick(function () {
	      return _this.setHeight(value, prop);
	    });
	
	    if (typeof value === 'number') {
	      el.style[prop] = value + 'px';
	      this.updateElsHeight();
	    } else if (typeof value === 'string') {
	      el.style[prop] = value;
	      this.updateElsHeight();
	    }
	  };
	
	  TableLayout.prototype.setMaxHeight = function setMaxHeight(value) {
	    this.setHeight(value, 'max-height');
	  };
	
	  TableLayout.prototype.getFlattenColumns = function getFlattenColumns() {
	    var flattenColumns = [];
	    var columns = this.table.columns;
	    columns.forEach(function (column) {
	      if (column.isColumnGroup) {
	        flattenColumns.push.apply(flattenColumns, column.columns);
	      } else {
	        flattenColumns.push(column);
	      }
	    });
	
	    return flattenColumns;
	  };
	
	  TableLayout.prototype.updateElsHeight = function updateElsHeight() {
	    var _this2 = this;
	
	    if (!this.table.$ready) return external_vue_default.a.nextTick(function () {
	      return _this2.updateElsHeight();
	    });
	    var _table$$refs = this.table.$refs,
	        headerWrapper = _table$$refs.headerWrapper,
	        appendWrapper = _table$$refs.appendWrapper,
	        footerWrapper = _table$$refs.footerWrapper;
	
	    this.appendHeight = appendWrapper ? appendWrapper.offsetHeight : 0;
	
	    if (this.showHeader && !headerWrapper) return;
	
	    // fix issue (https://github.com/ElemeFE/element/pull/16956)
	    var headerTrElm = headerWrapper ? headerWrapper.querySelector('.el-table__header tr') : null;
	    var noneHeader = this.headerDisplayNone(headerTrElm);
	
	    var headerHeight = this.headerHeight = !this.showHeader ? 0 : headerWrapper.offsetHeight;
	    if (this.showHeader && !noneHeader && headerWrapper.offsetWidth > 0 && (this.table.columns || []).length > 0 && headerHeight < 2) {
	      return external_vue_default.a.nextTick(function () {
	        return _this2.updateElsHeight();
	      });
	    }
	    var tableHeight = this.tableHeight = this.table.$el.clientHeight;
	    var footerHeight = this.footerHeight = footerWrapper ? footerWrapper.offsetHeight : 0;
	    if (this.height !== null) {
	      this.bodyHeight = tableHeight - headerHeight - footerHeight + (footerWrapper ? 1 : 0);
	    }
	    this.fixedBodyHeight = this.scrollX ? this.bodyHeight - this.gutterWidth : this.bodyHeight;
	
	    var noData = !(this.store.states.data && this.store.states.data.length);
	    this.viewportHeight = this.scrollX ? tableHeight - (noData ? 0 : this.gutterWidth) : tableHeight;
	
	    this.updateScrollY();
	    this.notifyObservers('scrollable');
	  };
	
	  TableLayout.prototype.headerDisplayNone = function headerDisplayNone(elm) {
	    if (!elm) return true;
	    var headerChild = elm;
	    while (headerChild.tagName !== 'DIV') {
	      if (getComputedStyle(headerChild).display === 'none') {
	        return true;
	      }
	      headerChild = headerChild.parentElement;
	    }
	    return false;
	  };
	
	  TableLayout.prototype.updateColumnsWidth = function updateColumnsWidth() {
	    if (external_vue_default.a.prototype.$isServer) return;
	    var fit = this.fit;
	    var bodyWidth = this.table.$el.clientWidth;
	    var bodyMinWidth = 0;
	
	    var flattenColumns = this.getFlattenColumns();
	    var flexColumns = flattenColumns.filter(function (column) {
	      return typeof column.width !== 'number';
	    });
	
	    flattenColumns.forEach(function (column) {
	      // Clean those columns whose width changed from flex to unflex
	      if (typeof column.width === 'number' && column.realWidth) column.realWidth = null;
	    });
	
	    if (flexColumns.length > 0 && fit) {
	      flattenColumns.forEach(function (column) {
	        bodyMinWidth += column.width || column.minWidth || 80;
	      });
	
	      var scrollYWidth = this.scrollY ? this.gutterWidth : 0;
	
	      if (bodyMinWidth <= bodyWidth - scrollYWidth) {
	        // DON'T HAVE SCROLL BAR
	        this.scrollX = false;
	
	        var totalFlexWidth = bodyWidth - scrollYWidth - bodyMinWidth;
	
	        if (flexColumns.length === 1) {
	          flexColumns[0].realWidth = (flexColumns[0].minWidth || 80) + totalFlexWidth;
	        } else {
	          var allColumnsWidth = flexColumns.reduce(function (prev, column) {
	            return prev + (column.minWidth || 80);
	          }, 0);
	          var flexWidthPerPixel = totalFlexWidth / allColumnsWidth;
	          var noneFirstWidth = 0;
	
	          flexColumns.forEach(function (column, index) {
	            if (index === 0) return;
	            var flexWidth = Math.floor((column.minWidth || 80) * flexWidthPerPixel);
	            noneFirstWidth += flexWidth;
	            column.realWidth = (column.minWidth || 80) + flexWidth;
	          });
	
	          flexColumns[0].realWidth = (flexColumns[0].minWidth || 80) + totalFlexWidth - noneFirstWidth;
	        }
	      } else {
	        // HAVE HORIZONTAL SCROLL BAR
	        this.scrollX = true;
	        flexColumns.forEach(function (column) {
	          column.realWidth = column.minWidth;
	        });
	      }
	
	      this.bodyWidth = Math.max(bodyMinWidth, bodyWidth);
	      this.table.resizeState.width = this.bodyWidth;
	    } else {
	      flattenColumns.forEach(function (column) {
	        if (!column.width && !column.minWidth) {
	          column.realWidth = 80;
	        } else {
	          column.realWidth = column.width || column.minWidth;
	        }
	
	        bodyMinWidth += column.realWidth;
	      });
	      this.scrollX = bodyMinWidth > bodyWidth;
	
	      this.bodyWidth = bodyMinWidth;
	    }
	
	    var fixedColumns = this.store.states.fixedColumns;
	
	    if (fixedColumns.length > 0) {
	      var fixedWidth = 0;
	      fixedColumns.forEach(function (column) {
	        fixedWidth += column.realWidth || column.width;
	      });
	
	      this.fixedWidth = fixedWidth;
	    }
	
	    var rightFixedColumns = this.store.states.rightFixedColumns;
	    if (rightFixedColumns.length > 0) {
	      var rightFixedWidth = 0;
	      rightFixedColumns.forEach(function (column) {
	        rightFixedWidth += column.realWidth || column.width;
	      });
	
	      this.rightFixedWidth = rightFixedWidth;
	    }
	
	    this.notifyObservers('columns');
	  };
	
	  TableLayout.prototype.addObserver = function addObserver(observer) {
	    this.observers.push(observer);
	  };
	
	  TableLayout.prototype.removeObserver = function removeObserver(observer) {
	    var index = this.observers.indexOf(observer);
	    if (index !== -1) {
	      this.observers.splice(index, 1);
	    }
	  };
	
	  TableLayout.prototype.notifyObservers = function notifyObservers(event) {
	    var _this3 = this;
	
	    var observers = this.observers;
	    observers.forEach(function (observer) {
	      switch (event) {
	        case 'columns':
	          observer.onColumnsChange(_this3);
	          break;
	        case 'scrollable':
	          observer.onScrollableChange(_this3);
	          break;
	        default:
	          throw new Error('Table Layout don\'t have event ' + event + '.');
	      }
	    });
	  };
	
	  return TableLayout;
	}();
	
	/* harmony default export */ var table_layout = (table_layout_TableLayout);
	// CONCATENATED MODULE: ./packages/table/src/layout-observer.js
	/* harmony default export */ var layout_observer = ({
	  created: function created() {
	    this.tableLayout.addObserver(this);
	  },
	  destroyed: function destroyed() {
	    this.tableLayout.removeObserver(this);
	  },
	
	
	  computed: {
	    tableLayout: function tableLayout() {
	      var layout = this.layout;
	      if (!layout && this.table) {
	        layout = this.table.layout;
	      }
	      if (!layout) {
	        throw new Error('Can not find table layout.');
	      }
	      return layout;
	    }
	  },
	
	  mounted: function mounted() {
	    this.onColumnsChange(this.tableLayout);
	    this.onScrollableChange(this.tableLayout);
	  },
	  updated: function updated() {
	    if (this.__updated__) return;
	    this.onColumnsChange(this.tableLayout);
	    this.onScrollableChange(this.tableLayout);
	    this.__updated__ = true;
	  },
	
	
	  methods: {
	    onColumnsChange: function onColumnsChange(layout) {
	      var cols = this.$el.querySelectorAll('colgroup > col');
	      if (!cols.length) return;
	      var flattenColumns = layout.getFlattenColumns();
	      var columnsMap = {};
	      flattenColumns.forEach(function (column) {
	        columnsMap[column.id] = column;
	      });
	      for (var i = 0, j = cols.length; i < j; i++) {
	        var col = cols[i];
	        var name = col.getAttribute('name');
	        var column = columnsMap[name];
	        if (column) {
	          col.setAttribute('width', column.realWidth || column.width);
	        }
	      }
	    },
	    onScrollableChange: function onScrollableChange(layout) {
	      var cols = this.$el.querySelectorAll('colgroup > col[name=gutter]');
	      for (var i = 0, j = cols.length; i < j; i++) {
	        var col = cols[i];
	        col.setAttribute('width', layout.scrollY ? layout.gutterWidth : '0');
	      }
	      var ths = this.$el.querySelectorAll('th.gutter');
	      for (var _i = 0, _j = ths.length; _i < _j; _i++) {
	        var th = ths[_i];
	        th.style.width = layout.scrollY ? layout.gutterWidth + 'px' : '0';
	        th.style.display = layout.scrollY ? '' : 'none';
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/table/src/table-body.js
	var table_body_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var table_body_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	
	
	
	
	
	
	
	
	
	/* harmony default export */ var table_body = ({
	  name: 'ElTableBody',
	
	  mixins: [layout_observer],
	
	  components: {
	    ElCheckbox: checkbox_default.a,
	    ElTooltip: tooltip_default.a
	  },
	
	  props: {
	    store: {
	      required: true
	    },
	    stripe: Boolean,
	    context: {},
	    rowClassName: [String, Function],
	    rowStyle: [Object, Function],
	    fixed: String,
	    highlight: Boolean
	  },
	
	  render: function render(h) {
	    var _this = this;
	
	    var data = this.data || [];
	    return h(
	      'table',
	      {
	        'class': 'el-table__body',
	        attrs: { cellspacing: '0',
	          cellpadding: '0',
	          border: '0' }
	      },
	      [h('colgroup', [this.columns.map(function (column) {
	        return h('col', {
	          attrs: { name: column.id },
	          key: column.id });
	      })]), h('tbody', [data.reduce(function (acc, row) {
	        return acc.concat(_this.wrappedRowRender(row, acc.length));
	      }, []), h('el-tooltip', {
	        attrs: { effect: this.table.tooltipEffect, placement: 'top', content: this.tooltipContent },
	        ref: 'tooltip' })])]
	    );
	  },
	
	
	  computed: table_body_extends({
	    table: function table() {
	      return this.$parent;
	    }
	  }, mapStates({
	    data: 'data',
	    columns: 'columns',
	    treeIndent: 'indent',
	    leftFixedLeafCount: 'fixedLeafColumnsLength',
	    rightFixedLeafCount: 'rightFixedLeafColumnsLength',
	    columnsCount: function columnsCount(states) {
	      return states.columns.length;
	    },
	    leftFixedCount: function leftFixedCount(states) {
	      return states.fixedColumns.length;
	    },
	    rightFixedCount: function rightFixedCount(states) {
	      return states.rightFixedColumns.length;
	    },
	    hasExpandColumn: function hasExpandColumn(states) {
	      return states.columns.some(function (_ref) {
	        var type = _ref.type;
	        return type === 'expand';
	      });
	    }
	  }), {
	    firstDefaultColumnIndex: function firstDefaultColumnIndex() {
	      return Object(util_["arrayFindIndex"])(this.columns, function (_ref2) {
	        var type = _ref2.type;
	        return type === 'default';
	      });
	    }
	  }),
	
	  watch: {
	    // don't trigger getter of currentRow in getCellClass. see https://jsfiddle.net/oe2b4hqt/
	    // update DOM manually. see https://github.com/ElemeFE/element/pull/13954/files#diff-9b450c00d0a9dec0ffad5a3176972e40
	    'store.states.hoverRow': function storeStatesHoverRow(newVal, oldVal) {
	      var _this2 = this;
	
	      if (!this.store.states.isComplex || this.$isServer) return;
	      var raf = window.requestAnimationFrame;
	      if (!raf) {
	        raf = function raf(fn) {
	          return setTimeout(fn, 16);
	        };
	      }
	      raf(function () {
	        var rows = _this2.$el.querySelectorAll('.el-table__row');
	        var oldRow = rows[oldVal];
	        var newRow = rows[newVal];
	        if (oldRow) {
	          Object(dom_["removeClass"])(oldRow, 'hover-row');
	        }
	        if (newRow) {
	          Object(dom_["addClass"])(newRow, 'hover-row');
	        }
	      });
	    }
	  },
	
	  data: function data() {
	    return {
	      tooltipContent: ''
	    };
	  },
	  created: function created() {
	    this.activateTooltip = debounce_default()(50, function (tooltip) {
	      return tooltip.handleShowPopper();
	    });
	  },
	
	
	  methods: {
	    getKeyOfRow: function getKeyOfRow(row, index) {
	      var rowKey = this.table.rowKey;
	      if (rowKey) {
	        return getRowIdentity(row, rowKey);
	      }
	      return index;
	    },
	    isColumnHidden: function isColumnHidden(index) {
	      if (this.fixed === true || this.fixed === 'left') {
	        return index >= this.leftFixedLeafCount;
	      } else if (this.fixed === 'right') {
	        return index < this.columnsCount - this.rightFixedLeafCount;
	      } else {
	        return index < this.leftFixedLeafCount || index >= this.columnsCount - this.rightFixedLeafCount;
	      }
	    },
	    getSpan: function getSpan(row, column, rowIndex, columnIndex) {
	      var rowspan = 1;
	      var colspan = 1;
	      var fn = this.table.spanMethod;
	      if (typeof fn === 'function') {
	        var result = fn({
	          row: row,
	          column: column,
	          rowIndex: rowIndex,
	          columnIndex: columnIndex
	        });
	        if (Array.isArray(result)) {
	          rowspan = result[0];
	          colspan = result[1];
	        } else if ((typeof result === 'undefined' ? 'undefined' : table_body_typeof(result)) === 'object') {
	          rowspan = result.rowspan;
	          colspan = result.colspan;
	        }
	      }
	      return { rowspan: rowspan, colspan: colspan };
	    },
	    getRowStyle: function getRowStyle(row, rowIndex) {
	      var rowStyle = this.table.rowStyle;
	      if (typeof rowStyle === 'function') {
	        return rowStyle.call(null, {
	          row: row,
	          rowIndex: rowIndex
	        });
	      }
	      return rowStyle || null;
	    },
	    getRowClass: function getRowClass(row, rowIndex) {
	      var classes = ['el-table__row'];
	      if (this.table.highlightCurrentRow && row === this.store.states.currentRow) {
	        classes.push('current-row');
	      }
	
	      if (this.stripe && rowIndex % 2 === 1) {
	        classes.push('el-table__row--striped');
	      }
	      var rowClassName = this.table.rowClassName;
	      if (typeof rowClassName === 'string') {
	        classes.push(rowClassName);
	      } else if (typeof rowClassName === 'function') {
	        classes.push(rowClassName.call(null, {
	          row: row,
	          rowIndex: rowIndex
	        }));
	      }
	
	      if (this.store.states.expandRows.indexOf(row) > -1) {
	        classes.push('expanded');
	      }
	
	      return classes;
	    },
	    getCellStyle: function getCellStyle(rowIndex, columnIndex, row, column) {
	      var cellStyle = this.table.cellStyle;
	      if (typeof cellStyle === 'function') {
	        return cellStyle.call(null, {
	          rowIndex: rowIndex,
	          columnIndex: columnIndex,
	          row: row,
	          column: column
	        });
	      }
	      return cellStyle;
	    },
	    getCellClass: function getCellClass(rowIndex, columnIndex, row, column) {
	      var classes = [column.id, column.align, column.className];
	
	      if (this.isColumnHidden(columnIndex)) {
	        classes.push('is-hidden');
	      }
	
	      var cellClassName = this.table.cellClassName;
	      if (typeof cellClassName === 'string') {
	        classes.push(cellClassName);
	      } else if (typeof cellClassName === 'function') {
	        classes.push(cellClassName.call(null, {
	          rowIndex: rowIndex,
	          columnIndex: columnIndex,
	          row: row,
	          column: column
	        }));
	      }
	
	      return classes.join(' ');
	    },
	    getColspanRealWidth: function getColspanRealWidth(columns, colspan, index) {
	      if (colspan < 1) {
	        return columns[index].realWidth;
	      }
	      var widthArr = columns.map(function (_ref3) {
	        var realWidth = _ref3.realWidth;
	        return realWidth;
	      }).slice(index, index + colspan);
	      return widthArr.reduce(function (acc, width) {
	        return acc + width;
	      }, -1);
	    },
	    handleCellMouseEnter: function handleCellMouseEnter(event, row) {
	      var table = this.table;
	      var cell = getCell(event);
	
	      if (cell) {
	        var column = getColumnByCell(table, cell);
	        var hoverState = table.hoverState = { cell: cell, column: column, row: row };
	        table.$emit('cell-mouse-enter', hoverState.row, hoverState.column, hoverState.cell, event);
	      }
	
	      // 判断是否text-overflow, 如果是就显示tooltip
	      var cellChild = event.target.querySelector('.cell');
	      if (!(Object(dom_["hasClass"])(cellChild, 'el-tooltip') && cellChild.childNodes.length)) {
	        return;
	      }
	      // use range width instead of scrollWidth to determine whether the text is overflowing
	      // to address a potential FireFox bug: https://bugzilla.mozilla.org/show_bug.cgi?id=1074543#c3
	      var range = document.createRange();
	      range.setStart(cellChild, 0);
	      range.setEnd(cellChild, cellChild.childNodes.length);
	      var rangeWidth = range.getBoundingClientRect().width;
	      var padding = (parseInt(Object(dom_["getStyle"])(cellChild, 'paddingLeft'), 10) || 0) + (parseInt(Object(dom_["getStyle"])(cellChild, 'paddingRight'), 10) || 0);
	      if ((rangeWidth + padding > cellChild.offsetWidth || cellChild.scrollWidth > cellChild.offsetWidth) && this.$refs.tooltip) {
	        var tooltip = this.$refs.tooltip;
	        // TODO 会引起整个 Table 的重新渲染，需要优化
	        this.tooltipContent = cell.innerText || cell.textContent;
	        tooltip.referenceElm = cell;
	        tooltip.$refs.popper && (tooltip.$refs.popper.style.display = 'none');
	        tooltip.doDestroy();
	        tooltip.setExpectedState(true);
	        this.activateTooltip(tooltip);
	      }
	    },
	    handleCellMouseLeave: function handleCellMouseLeave(event) {
	      var tooltip = this.$refs.tooltip;
	      if (tooltip) {
	        tooltip.setExpectedState(false);
	        tooltip.handleClosePopper();
	      }
	      var cell = getCell(event);
	      if (!cell) return;
	
	      var oldHoverState = this.table.hoverState || {};
	      this.table.$emit('cell-mouse-leave', oldHoverState.row, oldHoverState.column, oldHoverState.cell, event);
	    },
	
	
	    handleMouseEnter: debounce_default()(30, function (index) {
	      this.store.commit('setHoverRow', index);
	    }),
	
	    handleMouseLeave: debounce_default()(30, function () {
	      this.store.commit('setHoverRow', null);
	    }),
	
	    handleContextMenu: function handleContextMenu(event, row) {
	      this.handleEvent(event, row, 'contextmenu');
	    },
	    handleDoubleClick: function handleDoubleClick(event, row) {
	      this.handleEvent(event, row, 'dblclick');
	    },
	    handleClick: function handleClick(event, row) {
	      this.store.commit('setCurrentRow', row);
	      this.handleEvent(event, row, 'click');
	    },
	    handleEvent: function handleEvent(event, row, name) {
	      var table = this.table;
	      var cell = getCell(event);
	      var column = void 0;
	      if (cell) {
	        column = getColumnByCell(table, cell);
	        if (column) {
	          table.$emit('cell-' + name, row, column, cell, event);
	        }
	      }
	      table.$emit('row-' + name, row, column, event);
	    },
	    rowRender: function rowRender(row, $index, treeRowData) {
	      var _this3 = this;
	
	      var h = this.$createElement;
	      var treeIndent = this.treeIndent,
	          columns = this.columns,
	          firstDefaultColumnIndex = this.firstDefaultColumnIndex;
	
	      var columnsHidden = columns.map(function (column, index) {
	        return _this3.isColumnHidden(index);
	      });
	      var rowClasses = this.getRowClass(row, $index);
	      var display = true;
	      if (treeRowData) {
	        rowClasses.push('el-table__row--level-' + treeRowData.level);
	        display = treeRowData.display;
	      }
	      // 指令 v-show 会覆盖 row-style 中 display
	      // 使用 :style 代替 v-show https://github.com/ElemeFE/element/issues/16995
	      var displayStyle = display ? null : {
	        display: 'none'
	      };
	      return h(
	        'tr',
	        {
	          style: [displayStyle, this.getRowStyle(row, $index)],
	          'class': rowClasses,
	          key: this.getKeyOfRow(row, $index),
	          on: {
	            'dblclick': function dblclick($event) {
	              return _this3.handleDoubleClick($event, row);
	            },
	            'click': function click($event) {
	              return _this3.handleClick($event, row);
	            },
	            'contextmenu': function contextmenu($event) {
	              return _this3.handleContextMenu($event, row);
	            },
	            'mouseenter': function mouseenter(_) {
	              return _this3.handleMouseEnter($index);
	            },
	            'mouseleave': this.handleMouseLeave
	          }
	        },
	        [columns.map(function (column, cellIndex) {
	          var _getSpan = _this3.getSpan(row, column, $index, cellIndex),
	              rowspan = _getSpan.rowspan,
	              colspan = _getSpan.colspan;
	
	          if (!rowspan || !colspan) {
	            return null;
	          }
	          var columnData = table_body_extends({}, column);
	          columnData.realWidth = _this3.getColspanRealWidth(columns, colspan, cellIndex);
	          var data = {
	            store: _this3.store,
	            _self: _this3.context || _this3.table.$vnode.context,
	            column: columnData,
	            row: row,
	            $index: $index
	          };
	          if (cellIndex === firstDefaultColumnIndex && treeRowData) {
	            data.treeNode = {
	              indent: treeRowData.level * treeIndent,
	              level: treeRowData.level
	            };
	            if (typeof treeRowData.expanded === 'boolean') {
	              data.treeNode.expanded = treeRowData.expanded;
	              // 表明是懒加载
	              if ('loading' in treeRowData) {
	                data.treeNode.loading = treeRowData.loading;
	              }
	              if ('noLazyChildren' in treeRowData) {
	                data.treeNode.noLazyChildren = treeRowData.noLazyChildren;
	              }
	            }
	          }
	          return h(
	            'td',
	            {
	              style: _this3.getCellStyle($index, cellIndex, row, column),
	              'class': _this3.getCellClass($index, cellIndex, row, column),
	              attrs: { rowspan: rowspan,
	                colspan: colspan
	              },
	              on: {
	                'mouseenter': function mouseenter($event) {
	                  return _this3.handleCellMouseEnter($event, row);
	                },
	                'mouseleave': _this3.handleCellMouseLeave
	              }
	            },
	            [column.renderCell.call(_this3._renderProxy, _this3.$createElement, data, columnsHidden[cellIndex])]
	          );
	        })]
	      );
	    },
	    wrappedRowRender: function wrappedRowRender(row, $index) {
	      var _this4 = this;
	
	      var h = this.$createElement;
	
	      var store = this.store;
	      var isRowExpanded = store.isRowExpanded,
	          assertRowKey = store.assertRowKey;
	      var _store$states = store.states,
	          treeData = _store$states.treeData,
	          lazyTreeNodeMap = _store$states.lazyTreeNodeMap,
	          childrenColumnName = _store$states.childrenColumnName,
	          rowKey = _store$states.rowKey;
	
	      if (this.hasExpandColumn && isRowExpanded(row)) {
	        var renderExpanded = this.table.renderExpanded;
	        var tr = this.rowRender(row, $index);
	        if (!renderExpanded) {
	          console.error('[Element Error]renderExpanded is required.');
	          return tr;
	        }
	        // 使用二维数组，避免修改 $index
	        return [[tr, h(
	          'tr',
	          { key: 'expanded-row__' + tr.key },
	          [h(
	            'td',
	            {
	              attrs: { colspan: this.columnsCount },
	              'class': 'el-table__expanded-cell' },
	            [renderExpanded(this.$createElement, { row: row, $index: $index, store: this.store })]
	          )]
	        )]];
	      } else if (Object.keys(treeData).length) {
	        assertRowKey();
	        // TreeTable 时，rowKey 必须由用户设定，不使用 getKeyOfRow 计算
	        // 在调用 rowRender 函数时，仍然会计算 rowKey，不太好的操作
	        var key = getRowIdentity(row, rowKey);
	        var cur = treeData[key];
	        var treeRowData = null;
	        if (cur) {
	          treeRowData = {
	            expanded: cur.expanded,
	            level: cur.level,
	            display: true
	          };
	          if (typeof cur.lazy === 'boolean') {
	            if (typeof cur.loaded === 'boolean' && cur.loaded) {
	              treeRowData.noLazyChildren = !(cur.children && cur.children.length);
	            }
	            treeRowData.loading = cur.loading;
	          }
	        }
	        var tmp = [this.rowRender(row, $index, treeRowData)];
	        // 渲染嵌套数据
	        if (cur) {
	          // currentRow 记录的是 index，所以还需主动增加 TreeTable 的 index
	          var i = 0;
	          var traverse = function traverse(children, parent) {
	            if (!(children && children.length && parent)) return;
	            children.forEach(function (node) {
	              // 父节点的 display 状态影响子节点的显示状态
	              var innerTreeRowData = {
	                display: parent.display && parent.expanded,
	                level: parent.level + 1
	              };
	              var childKey = getRowIdentity(node, rowKey);
	              if (childKey === undefined || childKey === null) {
	                throw new Error('for nested data item, row-key is required.');
	              }
	              cur = table_body_extends({}, treeData[childKey]);
	              // 对于当前节点，分成有无子节点两种情况。
	              // 如果包含子节点的，设置 expanded 属性。
	              // 对于它子节点的 display 属性由它本身的 expanded 与 display 共同决定。
	              if (cur) {
	                innerTreeRowData.expanded = cur.expanded;
	                // 懒加载的某些节点，level 未知
	                cur.level = cur.level || innerTreeRowData.level;
	                cur.display = !!(cur.expanded && innerTreeRowData.display);
	                if (typeof cur.lazy === 'boolean') {
	                  if (typeof cur.loaded === 'boolean' && cur.loaded) {
	                    innerTreeRowData.noLazyChildren = !(cur.children && cur.children.length);
	                  }
	                  innerTreeRowData.loading = cur.loading;
	                }
	              }
	              i++;
	              tmp.push(_this4.rowRender(node, $index + i, innerTreeRowData));
	              if (cur) {
	                var _nodes = lazyTreeNodeMap[childKey] || node[childrenColumnName];
	                traverse(_nodes, cur);
	              }
	            });
	          };
	          // 对于 root 节点，display 一定为 true
	          cur.display = true;
	          var nodes = lazyTreeNodeMap[key] || row[childrenColumnName];
	          traverse(nodes, cur);
	        }
	        return tmp;
	      } else {
	        return this.rowRender(row, $index);
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/table/src/filter-panel.vue?vue&type=template&id=7f2c919f&
	var filter_panelvue_type_template_id_7f2c919f_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("transition", { attrs: { name: "el-zoom-in-top" } }, [
	    _vm.multiple
	      ? _c(
	          "div",
	          {
	            directives: [
	              {
	                name: "clickoutside",
	                rawName: "v-clickoutside",
	                value: _vm.handleOutsideClick,
	                expression: "handleOutsideClick"
	              },
	              {
	                name: "show",
	                rawName: "v-show",
	                value: _vm.showPopper,
	                expression: "showPopper"
	              }
	            ],
	            staticClass: "el-table-filter"
	          },
	          [
	            _c(
	              "div",
	              { staticClass: "el-table-filter__content" },
	              [
	                _c(
	                  "el-scrollbar",
	                  { attrs: { "wrap-class": "el-table-filter__wrap" } },
	                  [
	                    _c(
	                      "el-checkbox-group",
	                      {
	                        staticClass: "el-table-filter__checkbox-group",
	                        model: {
	                          value: _vm.filteredValue,
	                          callback: function($$v) {
	                            _vm.filteredValue = $$v
	                          },
	                          expression: "filteredValue"
	                        }
	                      },
	                      _vm._l(_vm.filters, function(filter) {
	                        return _c(
	                          "el-checkbox",
	                          { key: filter.value, attrs: { label: filter.value } },
	                          [_vm._v(_vm._s(filter.text))]
	                        )
	                      }),
	                      1
	                    )
	                  ],
	                  1
	                )
	              ],
	              1
	            ),
	            _c("div", { staticClass: "el-table-filter__bottom" }, [
	              _c(
	                "button",
	                {
	                  class: { "is-disabled": _vm.filteredValue.length === 0 },
	                  attrs: { disabled: _vm.filteredValue.length === 0 },
	                  on: { click: _vm.handleConfirm }
	                },
	                [_vm._v(_vm._s(_vm.t("el.table.confirmFilter")))]
	              ),
	              _c("button", { on: { click: _vm.handleReset } }, [
	                _vm._v(_vm._s(_vm.t("el.table.resetFilter")))
	              ])
	            ])
	          ]
	        )
	      : _c(
	          "div",
	          {
	            directives: [
	              {
	                name: "clickoutside",
	                rawName: "v-clickoutside",
	                value: _vm.handleOutsideClick,
	                expression: "handleOutsideClick"
	              },
	              {
	                name: "show",
	                rawName: "v-show",
	                value: _vm.showPopper,
	                expression: "showPopper"
	              }
	            ],
	            staticClass: "el-table-filter"
	          },
	          [
	            _c(
	              "ul",
	              { staticClass: "el-table-filter__list" },
	              [
	                _c(
	                  "li",
	                  {
	                    staticClass: "el-table-filter__list-item",
	                    class: {
	                      "is-active":
	                        _vm.filterValue === undefined ||
	                        _vm.filterValue === null
	                    },
	                    on: {
	                      click: function($event) {
	                        _vm.handleSelect(null)
	                      }
	                    }
	                  },
	                  [_vm._v(_vm._s(_vm.t("el.table.clearFilter")))]
	                ),
	                _vm._l(_vm.filters, function(filter) {
	                  return _c(
	                    "li",
	                    {
	                      key: filter.value,
	                      staticClass: "el-table-filter__list-item",
	                      class: { "is-active": _vm.isActive(filter) },
	                      attrs: { label: filter.value },
	                      on: {
	                        click: function($event) {
	                          _vm.handleSelect(filter.value)
	                        }
	                      }
	                    },
	                    [_vm._v(_vm._s(filter.text))]
	                  )
	                })
	              ],
	              2
	            )
	          ]
	        )
	  ])
	}
	var filter_panelvue_type_template_id_7f2c919f_staticRenderFns = []
	filter_panelvue_type_template_id_7f2c919f_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/table/src/filter-panel.vue?vue&type=template&id=7f2c919f&
	
	// CONCATENATED MODULE: ./packages/table/src/dropdown.js
	
	var dropdowns = [];
	
	!external_vue_default.a.prototype.$isServer && document.addEventListener('click', function (event) {
	  dropdowns.forEach(function (dropdown) {
	    var target = event.target;
	    if (!dropdown || !dropdown.$el) return;
	    if (target === dropdown.$el || dropdown.$el.contains(target)) {
	      return;
	    }
	    dropdown.handleOutsideClick && dropdown.handleOutsideClick(event);
	  });
	});
	
	/* harmony default export */ var src_dropdown = ({
	  open: function open(instance) {
	    if (instance) {
	      dropdowns.push(instance);
	    }
	  },
	  close: function close(instance) {
	    var index = dropdowns.indexOf(instance);
	    if (index !== -1) {
	      dropdowns.splice(instance, 1);
	    }
	  }
	});
	// EXTERNAL MODULE: external "element-ui/lib/checkbox-group"
	var checkbox_group_ = __webpack_require__(32);
	var checkbox_group_default = /*#__PURE__*/__webpack_require__.n(checkbox_group_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/table/src/filter-panel.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	
	
	
	/* harmony default export */ var filter_panelvue_type_script_lang_js_ = ({
	  name: 'ElTableFilterPanel',
	
	  mixins: [vue_popper_default.a, locale_default.a],
	
	  directives: {
	    Clickoutside: clickoutside_default.a
	  },
	
	  components: {
	    ElCheckbox: checkbox_default.a,
	    ElCheckboxGroup: checkbox_group_default.a,
	    ElScrollbar: scrollbar_default.a
	  },
	
	  props: {
	    placement: {
	      type: String,
	      default: 'bottom-end'
	    }
	  },
	
	  methods: {
	    isActive: function isActive(filter) {
	      return filter.value === this.filterValue;
	    },
	    handleOutsideClick: function handleOutsideClick() {
	      var _this = this;
	
	      setTimeout(function () {
	        _this.showPopper = false;
	      }, 16);
	    },
	    handleConfirm: function handleConfirm() {
	      this.confirmFilter(this.filteredValue);
	      this.handleOutsideClick();
	    },
	    handleReset: function handleReset() {
	      this.filteredValue = [];
	      this.confirmFilter(this.filteredValue);
	      this.handleOutsideClick();
	    },
	    handleSelect: function handleSelect(filterValue) {
	      this.filterValue = filterValue;
	
	      if (typeof filterValue !== 'undefined' && filterValue !== null) {
	        this.confirmFilter(this.filteredValue);
	      } else {
	        this.confirmFilter([]);
	      }
	
	      this.handleOutsideClick();
	    },
	    confirmFilter: function confirmFilter(filteredValue) {
	      this.table.store.commit('filterChange', {
	        column: this.column,
	        values: filteredValue
	      });
	      this.table.store.updateAllSelected();
	    }
	  },
	
	  data: function data() {
	    return {
	      table: null,
	      cell: null,
	      column: null
	    };
	  },
	
	
	  computed: {
	    filters: function filters() {
	      return this.column && this.column.filters;
	    },
	
	
	    filterValue: {
	      get: function get() {
	        return (this.column.filteredValue || [])[0];
	      },
	      set: function set(value) {
	        if (this.filteredValue) {
	          if (typeof value !== 'undefined' && value !== null) {
	            this.filteredValue.splice(0, 1, value);
	          } else {
	            this.filteredValue.splice(0, 1);
	          }
	        }
	      }
	    },
	
	    filteredValue: {
	      get: function get() {
	        if (this.column) {
	          return this.column.filteredValue || [];
	        }
	        return [];
	      },
	      set: function set(value) {
	        if (this.column) {
	          this.column.filteredValue = value;
	        }
	      }
	    },
	
	    multiple: function multiple() {
	      if (this.column) {
	        return this.column.filterMultiple;
	      }
	      return true;
	    }
	  },
	
	  mounted: function mounted() {
	    var _this2 = this;
	
	    this.popperElm = this.$el;
	    this.referenceElm = this.cell;
	    this.table.bodyWrapper.addEventListener('scroll', function () {
	      _this2.updatePopper();
	    });
	
	    this.$watch('showPopper', function (value) {
	      if (_this2.column) _this2.column.filterOpened = value;
	      if (value) {
	        src_dropdown.open(_this2);
	      } else {
	        src_dropdown.close(_this2);
	      }
	    });
	  },
	
	  watch: {
	    showPopper: function showPopper(val) {
	      if (val === true && parseInt(this.popperJS._popper.style.zIndex, 10) < popup_["PopupManager"].zIndex) {
	        this.popperJS._popper.style.zIndex = popup_["PopupManager"].nextZIndex();
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/table/src/filter-panel.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_filter_panelvue_type_script_lang_js_ = (filter_panelvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/table/src/filter-panel.vue
	
	
	
	
	
	/* normalize component */
	
	var filter_panel_component = normalizeComponent(
	  src_filter_panelvue_type_script_lang_js_,
	  filter_panelvue_type_template_id_7f2c919f_render,
	  filter_panelvue_type_template_id_7f2c919f_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var filter_panel_api; }
	filter_panel_component.options.__file = "packages/table/src/filter-panel.vue"
	/* harmony default export */ var filter_panel = (filter_panel_component.exports);
	// CONCATENATED MODULE: ./packages/table/src/table-header.js
	var table_header_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	
	
	
	
	
	
	
	var getAllColumns = function getAllColumns(columns) {
	  var result = [];
	  columns.forEach(function (column) {
	    if (column.children) {
	      result.push(column);
	      result.push.apply(result, getAllColumns(column.children));
	    } else {
	      result.push(column);
	    }
	  });
	  return result;
	};
	
	var convertToRows = function convertToRows(originColumns) {
	  var maxLevel = 1;
	  var traverse = function traverse(column, parent) {
	    if (parent) {
	      column.level = parent.level + 1;
	      if (maxLevel < column.level) {
	        maxLevel = column.level;
	      }
	    }
	    if (column.children) {
	      var colSpan = 0;
	      column.children.forEach(function (subColumn) {
	        traverse(subColumn, column);
	        colSpan += subColumn.colSpan;
	      });
	      column.colSpan = colSpan;
	    } else {
	      column.colSpan = 1;
	    }
	  };
	
	  originColumns.forEach(function (column) {
	    column.level = 1;
	    traverse(column);
	  });
	
	  var rows = [];
	  for (var i = 0; i < maxLevel; i++) {
	    rows.push([]);
	  }
	
	  var allColumns = getAllColumns(originColumns);
	
	  allColumns.forEach(function (column) {
	    if (!column.children) {
	      column.rowSpan = maxLevel - column.level + 1;
	    } else {
	      column.rowSpan = 1;
	    }
	    rows[column.level - 1].push(column);
	  });
	
	  return rows;
	};
	
	/* harmony default export */ var table_header = ({
	  name: 'ElTableHeader',
	
	  mixins: [layout_observer],
	
	  render: function render(h) {
	    var _this = this;
	
	    var originColumns = this.store.states.originColumns;
	    var columnRows = convertToRows(originColumns, this.columns);
	    // 是否拥有多级表头
	    var isGroup = columnRows.length > 1;
	    if (isGroup) this.$parent.isGroup = true;
	    return h(
	      'table',
	      {
	        'class': 'el-table__header',
	        attrs: { cellspacing: '0',
	          cellpadding: '0',
	          border: '0' }
	      },
	      [h('colgroup', [this.columns.map(function (column) {
	        return h('col', {
	          attrs: { name: column.id },
	          key: column.id });
	      }), this.hasGutter ? h('col', {
	        attrs: { name: 'gutter' }
	      }) : '']), h(
	        'thead',
	        { 'class': [{ 'is-group': isGroup, 'has-gutter': this.hasGutter }] },
	        [this._l(columnRows, function (columns, rowIndex) {
	          return h(
	            'tr',
	            {
	              style: _this.getHeaderRowStyle(rowIndex),
	              'class': _this.getHeaderRowClass(rowIndex)
	            },
	            [columns.map(function (column, cellIndex) {
	              return h(
	                'th',
	                {
	                  attrs: {
	                    colspan: column.colSpan,
	                    rowspan: column.rowSpan
	                  },
	                  on: {
	                    'mousemove': function mousemove($event) {
	                      return _this.handleMouseMove($event, column);
	                    },
	                    'mouseout': _this.handleMouseOut,
	                    'mousedown': function mousedown($event) {
	                      return _this.handleMouseDown($event, column);
	                    },
	                    'click': function click($event) {
	                      return _this.handleHeaderClick($event, column);
	                    },
	                    'contextmenu': function contextmenu($event) {
	                      return _this.handleHeaderContextMenu($event, column);
	                    }
	                  },
	
	                  style: _this.getHeaderCellStyle(rowIndex, cellIndex, columns, column),
	                  'class': _this.getHeaderCellClass(rowIndex, cellIndex, columns, column),
	                  key: column.id },
	                [h(
	                  'div',
	                  { 'class': ['cell', column.filteredValue && column.filteredValue.length > 0 ? 'highlight' : '', column.labelClassName] },
	                  [column.renderHeader ? column.renderHeader.call(_this._renderProxy, h, { column: column, $index: cellIndex, store: _this.store, _self: _this.$parent.$vnode.context }) : column.label, column.sortable ? h(
	                    'span',
	                    {
	                      'class': 'caret-wrapper',
	                      on: {
	                        'click': function click($event) {
	                          return _this.handleSortClick($event, column);
	                        }
	                      }
	                    },
	                    [h('i', { 'class': 'sort-caret ascending',
	                      on: {
	                        'click': function click($event) {
	                          return _this.handleSortClick($event, column, 'ascending');
	                        }
	                      }
	                    }), h('i', { 'class': 'sort-caret descending',
	                      on: {
	                        'click': function click($event) {
	                          return _this.handleSortClick($event, column, 'descending');
	                        }
	                      }
	                    })]
	                  ) : '', column.filterable ? h(
	                    'span',
	                    {
	                      'class': 'el-table__column-filter-trigger',
	                      on: {
	                        'click': function click($event) {
	                          return _this.handleFilterClick($event, column);
	                        }
	                      }
	                    },
	                    [h('i', { 'class': ['el-icon-arrow-down', column.filterOpened ? 'el-icon-arrow-up' : ''] })]
	                  ) : '']
	                )]
	              );
	            }), _this.hasGutter ? h('th', { 'class': 'gutter' }) : '']
	          );
	        })]
	      )]
	    );
	  },
	
	
	  props: {
	    fixed: String,
	    store: {
	      required: true
	    },
	    border: Boolean,
	    defaultSort: {
	      type: Object,
	      default: function _default() {
	        return {
	          prop: '',
	          order: ''
	        };
	      }
	    }
	  },
	
	  components: {
	    ElCheckbox: checkbox_default.a
	  },
	
	  computed: table_header_extends({
	    table: function table() {
	      return this.$parent;
	    },
	    hasGutter: function hasGutter() {
	      return !this.fixed && this.tableLayout.gutterWidth;
	    }
	  }, mapStates({
	    columns: 'columns',
	    isAllSelected: 'isAllSelected',
	    leftFixedLeafCount: 'fixedLeafColumnsLength',
	    rightFixedLeafCount: 'rightFixedLeafColumnsLength',
	    columnsCount: function columnsCount(states) {
	      return states.columns.length;
	    },
	    leftFixedCount: function leftFixedCount(states) {
	      return states.fixedColumns.length;
	    },
	    rightFixedCount: function rightFixedCount(states) {
	      return states.rightFixedColumns.length;
	    }
	  })),
	
	  created: function created() {
	    this.filterPanels = {};
	  },
	  mounted: function mounted() {
	    var _this2 = this;
	
	    // nextTick 是有必要的 https://github.com/ElemeFE/element/pull/11311
	    this.$nextTick(function () {
	      var _defaultSort = _this2.defaultSort,
	          prop = _defaultSort.prop,
	          order = _defaultSort.order;
	
	      var init = true;
	      _this2.store.commit('sort', { prop: prop, order: order, init: init });
	    });
	  },
	  beforeDestroy: function beforeDestroy() {
	    var panels = this.filterPanels;
	    for (var prop in panels) {
	      if (panels.hasOwnProperty(prop) && panels[prop]) {
	        panels[prop].$destroy(true);
	      }
	    }
	  },
	
	
	  methods: {
	    isCellHidden: function isCellHidden(index, columns) {
	      var start = 0;
	      for (var i = 0; i < index; i++) {
	        start += columns[i].colSpan;
	      }
	      var after = start + columns[index].colSpan - 1;
	      if (this.fixed === true || this.fixed === 'left') {
	        return after >= this.leftFixedLeafCount;
	      } else if (this.fixed === 'right') {
	        return start < this.columnsCount - this.rightFixedLeafCount;
	      } else {
	        return after < this.leftFixedLeafCount || start >= this.columnsCount - this.rightFixedLeafCount;
	      }
	    },
	    getHeaderRowStyle: function getHeaderRowStyle(rowIndex) {
	      var headerRowStyle = this.table.headerRowStyle;
	      if (typeof headerRowStyle === 'function') {
	        return headerRowStyle.call(null, { rowIndex: rowIndex });
	      }
	      return headerRowStyle;
	    },
	    getHeaderRowClass: function getHeaderRowClass(rowIndex) {
	      var classes = [];
	
	      var headerRowClassName = this.table.headerRowClassName;
	      if (typeof headerRowClassName === 'string') {
	        classes.push(headerRowClassName);
	      } else if (typeof headerRowClassName === 'function') {
	        classes.push(headerRowClassName.call(null, { rowIndex: rowIndex }));
	      }
	
	      return classes.join(' ');
	    },
	    getHeaderCellStyle: function getHeaderCellStyle(rowIndex, columnIndex, row, column) {
	      var headerCellStyle = this.table.headerCellStyle;
	      if (typeof headerCellStyle === 'function') {
	        return headerCellStyle.call(null, {
	          rowIndex: rowIndex,
	          columnIndex: columnIndex,
	          row: row,
	          column: column
	        });
	      }
	      return headerCellStyle;
	    },
	    getHeaderCellClass: function getHeaderCellClass(rowIndex, columnIndex, row, column) {
	      var classes = [column.id, column.order, column.headerAlign, column.className, column.labelClassName];
	
	      if (rowIndex === 0 && this.isCellHidden(columnIndex, row)) {
	        classes.push('is-hidden');
	      }
	
	      if (!column.children) {
	        classes.push('is-leaf');
	      }
	
	      if (column.sortable) {
	        classes.push('is-sortable');
	      }
	
	      var headerCellClassName = this.table.headerCellClassName;
	      if (typeof headerCellClassName === 'string') {
	        classes.push(headerCellClassName);
	      } else if (typeof headerCellClassName === 'function') {
	        classes.push(headerCellClassName.call(null, {
	          rowIndex: rowIndex,
	          columnIndex: columnIndex,
	          row: row,
	          column: column
	        }));
	      }
	
	      return classes.join(' ');
	    },
	    toggleAllSelection: function toggleAllSelection(event) {
	      event.stopPropagation();
	      this.store.commit('toggleAllSelection');
	    },
	    handleFilterClick: function handleFilterClick(event, column) {
	      event.stopPropagation();
	      var target = event.target;
	      var cell = target.tagName === 'TH' ? target : target.parentNode;
	      if (Object(dom_["hasClass"])(cell, 'noclick')) return;
	      cell = cell.querySelector('.el-table__column-filter-trigger') || cell;
	      var table = this.$parent;
	
	      var filterPanel = this.filterPanels[column.id];
	
	      if (filterPanel && column.filterOpened) {
	        filterPanel.showPopper = false;
	        return;
	      }
	
	      if (!filterPanel) {
	        filterPanel = new external_vue_default.a(filter_panel);
	        this.filterPanels[column.id] = filterPanel;
	        if (column.filterPlacement) {
	          filterPanel.placement = column.filterPlacement;
	        }
	        filterPanel.table = table;
	        filterPanel.cell = cell;
	        filterPanel.column = column;
	        !this.$isServer && filterPanel.$mount(document.createElement('div'));
	      }
	
	      setTimeout(function () {
	        filterPanel.showPopper = true;
	      }, 16);
	    },
	    handleHeaderClick: function handleHeaderClick(event, column) {
	      if (!column.filters && column.sortable) {
	        this.handleSortClick(event, column);
	      } else if (column.filterable && !column.sortable) {
	        this.handleFilterClick(event, column);
	      }
	
	      this.$parent.$emit('header-click', column, event);
	    },
	    handleHeaderContextMenu: function handleHeaderContextMenu(event, column) {
	      this.$parent.$emit('header-contextmenu', column, event);
	    },
	    handleMouseDown: function handleMouseDown(event, column) {
	      var _this3 = this;
	
	      if (this.$isServer) return;
	      if (column.children && column.children.length > 0) return;
	      /* istanbul ignore if */
	      if (this.draggingColumn && this.border) {
	        this.dragging = true;
	
	        this.$parent.resizeProxyVisible = true;
	
	        var table = this.$parent;
	        var tableEl = table.$el;
	        var tableLeft = tableEl.getBoundingClientRect().left;
	        var columnEl = this.$el.querySelector('th.' + column.id);
	        var columnRect = columnEl.getBoundingClientRect();
	        var minLeft = columnRect.left - tableLeft + 30;
	
	        Object(dom_["addClass"])(columnEl, 'noclick');
	
	        this.dragState = {
	          startMouseLeft: event.clientX,
	          startLeft: columnRect.right - tableLeft,
	          startColumnLeft: columnRect.left - tableLeft,
	          tableLeft: tableLeft
	        };
	
	        var resizeProxy = table.$refs.resizeProxy;
	        resizeProxy.style.left = this.dragState.startLeft + 'px';
	
	        document.onselectstart = function () {
	          return false;
	        };
	        document.ondragstart = function () {
	          return false;
	        };
	
	        var handleMouseMove = function handleMouseMove(event) {
	          var deltaLeft = event.clientX - _this3.dragState.startMouseLeft;
	          var proxyLeft = _this3.dragState.startLeft + deltaLeft;
	
	          resizeProxy.style.left = Math.max(minLeft, proxyLeft) + 'px';
	        };
	
	        var handleMouseUp = function handleMouseUp() {
	          if (_this3.dragging) {
	            var _dragState = _this3.dragState,
	                startColumnLeft = _dragState.startColumnLeft,
	                startLeft = _dragState.startLeft;
	
	            var finalLeft = parseInt(resizeProxy.style.left, 10);
	            var columnWidth = finalLeft - startColumnLeft;
	            column.width = column.realWidth = columnWidth;
	            table.$emit('header-dragend', column.width, startLeft - startColumnLeft, column, event);
	
	            _this3.store.scheduleLayout();
	
	            document.body.style.cursor = '';
	            _this3.dragging = false;
	            _this3.draggingColumn = null;
	            _this3.dragState = {};
	
	            table.resizeProxyVisible = false;
	          }
	
	          document.removeEventListener('mousemove', handleMouseMove);
	          document.removeEventListener('mouseup', handleMouseUp);
	          document.onselectstart = null;
	          document.ondragstart = null;
	
	          setTimeout(function () {
	            Object(dom_["removeClass"])(columnEl, 'noclick');
	          }, 0);
	        };
	
	        document.addEventListener('mousemove', handleMouseMove);
	        document.addEventListener('mouseup', handleMouseUp);
	      }
	    },
	    handleMouseMove: function handleMouseMove(event, column) {
	      if (column.children && column.children.length > 0) return;
	      var target = event.target;
	      while (target && target.tagName !== 'TH') {
	        target = target.parentNode;
	      }
	
	      if (!column || !column.resizable) return;
	
	      if (!this.dragging && this.border) {
	        var rect = target.getBoundingClientRect();
	
	        var bodyStyle = document.body.style;
	        if (rect.width > 12 && rect.right - event.pageX < 8) {
	          bodyStyle.cursor = 'col-resize';
	          if (Object(dom_["hasClass"])(target, 'is-sortable')) {
	            target.style.cursor = 'col-resize';
	          }
	          this.draggingColumn = column;
	        } else if (!this.dragging) {
	          bodyStyle.cursor = '';
	          if (Object(dom_["hasClass"])(target, 'is-sortable')) {
	            target.style.cursor = 'pointer';
	          }
	          this.draggingColumn = null;
	        }
	      }
	    },
	    handleMouseOut: function handleMouseOut() {
	      if (this.$isServer) return;
	      document.body.style.cursor = '';
	    },
	    toggleOrder: function toggleOrder(_ref) {
	      var order = _ref.order,
	          sortOrders = _ref.sortOrders;
	
	      if (order === '') return sortOrders[0];
	      var index = sortOrders.indexOf(order || null);
	      return sortOrders[index > sortOrders.length - 2 ? 0 : index + 1];
	    },
	    handleSortClick: function handleSortClick(event, column, givenOrder) {
	      event.stopPropagation();
	      var order = column.order === givenOrder ? null : givenOrder || this.toggleOrder(column);
	
	      var target = event.target;
	      while (target && target.tagName !== 'TH') {
	        target = target.parentNode;
	      }
	
	      if (target && target.tagName === 'TH') {
	        if (Object(dom_["hasClass"])(target, 'noclick')) {
	          Object(dom_["removeClass"])(target, 'noclick');
	          return;
	        }
	      }
	
	      if (!column.sortable) return;
	
	      var states = this.store.states;
	      var sortProp = states.sortProp;
	      var sortOrder = void 0;
	      var sortingColumn = states.sortingColumn;
	
	      if (sortingColumn !== column || sortingColumn === column && sortingColumn.order === null) {
	        if (sortingColumn) {
	          sortingColumn.order = null;
	        }
	        states.sortingColumn = column;
	        sortProp = column.property;
	      }
	
	      if (!order) {
	        sortOrder = column.order = null;
	      } else {
	        sortOrder = column.order = order;
	      }
	
	      states.sortProp = sortProp;
	      states.sortOrder = sortOrder;
	
	      this.store.commit('changeSortCondition');
	    }
	  },
	
	  data: function data() {
	    return {
	      draggingColumn: null,
	      dragging: false,
	      dragState: {}
	    };
	  }
	});
	// CONCATENATED MODULE: ./packages/table/src/table-footer.js
	var table_footer_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	
	
	
	/* harmony default export */ var table_footer = ({
	  name: 'ElTableFooter',
	
	  mixins: [layout_observer],
	
	  render: function render(h) {
	    var _this = this;
	
	    var sums = [];
	    if (this.summaryMethod) {
	      sums = this.summaryMethod({ columns: this.columns, data: this.store.states.data });
	    } else {
	      this.columns.forEach(function (column, index) {
	        if (index === 0) {
	          sums[index] = _this.sumText;
	          return;
	        }
	        var values = _this.store.states.data.map(function (item) {
	          return Number(item[column.property]);
	        });
	        var precisions = [];
	        var notNumber = true;
	        values.forEach(function (value) {
	          if (!isNaN(value)) {
	            notNumber = false;
	            var decimal = ('' + value).split('.')[1];
	            precisions.push(decimal ? decimal.length : 0);
	          }
	        });
	        var precision = Math.max.apply(null, precisions);
	        if (!notNumber) {
	          sums[index] = values.reduce(function (prev, curr) {
	            var value = Number(curr);
	            if (!isNaN(value)) {
	              return parseFloat((prev + curr).toFixed(Math.min(precision, 20)));
	            } else {
	              return prev;
	            }
	          }, 0);
	        } else {
	          sums[index] = '';
	        }
	      });
	    }
	
	    return h(
	      'table',
	      {
	        'class': 'el-table__footer',
	        attrs: { cellspacing: '0',
	          cellpadding: '0',
	          border: '0' }
	      },
	      [h('colgroup', [this.columns.map(function (column) {
	        return h('col', {
	          attrs: { name: column.id },
	          key: column.id });
	      }), this.hasGutter ? h('col', {
	        attrs: { name: 'gutter' }
	      }) : '']), h(
	        'tbody',
	        { 'class': [{ 'has-gutter': this.hasGutter }] },
	        [h('tr', [this.columns.map(function (column, cellIndex) {
	          return h(
	            'td',
	            {
	              key: cellIndex,
	              attrs: { colspan: column.colSpan,
	                rowspan: column.rowSpan
	              },
	              'class': _this.getRowClasses(column, cellIndex) },
	            [h(
	              'div',
	              { 'class': ['cell', column.labelClassName] },
	              [sums[cellIndex]]
	            )]
	          );
	        }), this.hasGutter ? h('th', { 'class': 'gutter' }) : ''])]
	      )]
	    );
	  },
	
	
	  props: {
	    fixed: String,
	    store: {
	      required: true
	    },
	    summaryMethod: Function,
	    sumText: String,
	    border: Boolean,
	    defaultSort: {
	      type: Object,
	      default: function _default() {
	        return {
	          prop: '',
	          order: ''
	        };
	      }
	    }
	  },
	
	  computed: table_footer_extends({
	    table: function table() {
	      return this.$parent;
	    },
	    hasGutter: function hasGutter() {
	      return !this.fixed && this.tableLayout.gutterWidth;
	    }
	  }, mapStates({
	    columns: 'columns',
	    isAllSelected: 'isAllSelected',
	    leftFixedLeafCount: 'fixedLeafColumnsLength',
	    rightFixedLeafCount: 'rightFixedLeafColumnsLength',
	    columnsCount: function columnsCount(states) {
	      return states.columns.length;
	    },
	    leftFixedCount: function leftFixedCount(states) {
	      return states.fixedColumns.length;
	    },
	    rightFixedCount: function rightFixedCount(states) {
	      return states.rightFixedColumns.length;
	    }
	  })),
	
	  methods: {
	    isCellHidden: function isCellHidden(index, columns, column) {
	      if (this.fixed === true || this.fixed === 'left') {
	        return index >= this.leftFixedLeafCount;
	      } else if (this.fixed === 'right') {
	        var before = 0;
	        for (var i = 0; i < index; i++) {
	          before += columns[i].colSpan;
	        }
	        return before < this.columnsCount - this.rightFixedLeafCount;
	      } else if (!this.fixed && column.fixed) {
	        // hide cell when footer instance is not fixed and column is fixed
	        return true;
	      } else {
	        return index < this.leftFixedCount || index >= this.columnsCount - this.rightFixedCount;
	      }
	    },
	    getRowClasses: function getRowClasses(column, cellIndex) {
	      var classes = [column.id, column.align, column.labelClassName];
	      if (column.className) {
	        classes.push(column.className);
	      }
	      if (this.isCellHidden(cellIndex, this.columns, column)) {
	        classes.push('is-hidden');
	      }
	      if (!column.children) {
	        classes.push('is-leaf');
	      }
	      return classes;
	    }
	  }
	});
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/table/src/table.vue?vue&type=script&lang=js&
	var tablevue_type_script_lang_js_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var tableIdSeed = 1;
	
	/* harmony default export */ var tablevue_type_script_lang_js_ = ({
	  name: 'ElTable',
	
	  mixins: [locale_default.a, migrating_default.a],
	
	  directives: {
	    Mousewheel: directives_mousewheel
	  },
	
	  props: {
	    data: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	
	    size: String,
	
	    width: [String, Number],
	
	    height: [String, Number],
	
	    maxHeight: [String, Number],
	
	    fit: {
	      type: Boolean,
	      default: true
	    },
	
	    stripe: Boolean,
	
	    border: Boolean,
	
	    rowKey: [String, Function],
	
	    context: {},
	
	    showHeader: {
	      type: Boolean,
	      default: true
	    },
	
	    showSummary: Boolean,
	
	    sumText: String,
	
	    summaryMethod: Function,
	
	    rowClassName: [String, Function],
	
	    rowStyle: [Object, Function],
	
	    cellClassName: [String, Function],
	
	    cellStyle: [Object, Function],
	
	    headerRowClassName: [String, Function],
	
	    headerRowStyle: [Object, Function],
	
	    headerCellClassName: [String, Function],
	
	    headerCellStyle: [Object, Function],
	
	    highlightCurrentRow: Boolean,
	
	    currentRowKey: [String, Number],
	
	    emptyText: String,
	
	    expandRowKeys: Array,
	
	    defaultExpandAll: Boolean,
	
	    defaultSort: Object,
	
	    tooltipEffect: String,
	
	    spanMethod: Function,
	
	    selectOnIndeterminate: {
	      type: Boolean,
	      default: true
	    },
	
	    indent: {
	      type: Number,
	      default: 16
	    },
	
	    treeProps: {
	      type: Object,
	      default: function _default() {
	        return {
	          hasChildren: 'hasChildren',
	          children: 'children'
	        };
	      }
	    },
	
	    lazy: Boolean,
	
	    load: Function
	  },
	
	  components: {
	    TableHeader: table_header,
	    TableFooter: table_footer,
	    TableBody: table_body,
	    ElCheckbox: checkbox_default.a
	  },
	
	  methods: {
	    getMigratingConfig: function getMigratingConfig() {
	      return {
	        events: {
	          expand: 'expand is renamed to expand-change'
	        }
	      };
	    },
	    setCurrentRow: function setCurrentRow(row) {
	      this.store.commit('setCurrentRow', row);
	    },
	    toggleRowSelection: function toggleRowSelection(row, selected) {
	      this.store.toggleRowSelection(row, selected, false);
	      this.store.updateAllSelected();
	    },
	    toggleRowExpansion: function toggleRowExpansion(row, expanded) {
	      this.store.toggleRowExpansionAdapter(row, expanded);
	    },
	    clearSelection: function clearSelection() {
	      this.store.clearSelection();
	    },
	    clearFilter: function clearFilter(columnKeys) {
	      this.store.clearFilter(columnKeys);
	    },
	    clearSort: function clearSort() {
	      this.store.clearSort();
	    },
	    handleMouseLeave: function handleMouseLeave() {
	      this.store.commit('setHoverRow', null);
	      if (this.hoverState) this.hoverState = null;
	    },
	    updateScrollY: function updateScrollY() {
	      var changed = this.layout.updateScrollY();
	      if (changed) {
	        this.layout.notifyObservers('scrollable');
	        this.layout.updateColumnsWidth();
	      }
	    },
	    handleFixedMousewheel: function handleFixedMousewheel(event, data) {
	      var bodyWrapper = this.bodyWrapper;
	      if (Math.abs(data.spinY) > 0) {
	        var currentScrollTop = bodyWrapper.scrollTop;
	        if (data.pixelY < 0 && currentScrollTop !== 0) {
	          event.preventDefault();
	        }
	        if (data.pixelY > 0 && bodyWrapper.scrollHeight - bodyWrapper.clientHeight > currentScrollTop) {
	          event.preventDefault();
	        }
	        bodyWrapper.scrollTop += Math.ceil(data.pixelY / 5);
	      } else {
	        bodyWrapper.scrollLeft += Math.ceil(data.pixelX / 5);
	      }
	    },
	    handleHeaderFooterMousewheel: function handleHeaderFooterMousewheel(event, data) {
	      var pixelX = data.pixelX,
	          pixelY = data.pixelY;
	
	      if (Math.abs(pixelX) >= Math.abs(pixelY)) {
	        this.bodyWrapper.scrollLeft += data.pixelX / 5;
	      }
	    },
	
	
	    // TODO 使用 CSS transform
	    syncPostion: Object(external_throttle_debounce_["throttle"])(20, function () {
	      var _bodyWrapper = this.bodyWrapper,
	          scrollLeft = _bodyWrapper.scrollLeft,
	          scrollTop = _bodyWrapper.scrollTop,
	          offsetWidth = _bodyWrapper.offsetWidth,
	          scrollWidth = _bodyWrapper.scrollWidth;
	      var _$refs = this.$refs,
	          headerWrapper = _$refs.headerWrapper,
	          footerWrapper = _$refs.footerWrapper,
	          fixedBodyWrapper = _$refs.fixedBodyWrapper,
	          rightFixedBodyWrapper = _$refs.rightFixedBodyWrapper;
	
	      if (headerWrapper) headerWrapper.scrollLeft = scrollLeft;
	      if (footerWrapper) footerWrapper.scrollLeft = scrollLeft;
	      if (fixedBodyWrapper) fixedBodyWrapper.scrollTop = scrollTop;
	      if (rightFixedBodyWrapper) rightFixedBodyWrapper.scrollTop = scrollTop;
	      var maxScrollLeftPosition = scrollWidth - offsetWidth - 1;
	      if (scrollLeft >= maxScrollLeftPosition) {
	        this.scrollPosition = 'right';
	      } else if (scrollLeft === 0) {
	        this.scrollPosition = 'left';
	      } else {
	        this.scrollPosition = 'middle';
	      }
	    }),
	
	    bindEvents: function bindEvents() {
	      this.bodyWrapper.addEventListener('scroll', this.syncPostion, { passive: true });
	      if (this.fit) {
	        Object(resize_event_["addResizeListener"])(this.$el, this.resizeListener);
	      }
	    },
	    unbindEvents: function unbindEvents() {
	      this.bodyWrapper.removeEventListener('scroll', this.syncPostion, { passive: true });
	      if (this.fit) {
	        Object(resize_event_["removeResizeListener"])(this.$el, this.resizeListener);
	      }
	    },
	    resizeListener: function resizeListener() {
	      if (!this.$ready) return;
	      var shouldUpdateLayout = false;
	      var el = this.$el;
	      var _resizeState = this.resizeState,
	          oldWidth = _resizeState.width,
	          oldHeight = _resizeState.height;
	
	
	      var width = el.offsetWidth;
	      if (oldWidth !== width) {
	        shouldUpdateLayout = true;
	      }
	
	      var height = el.offsetHeight;
	      if ((this.height || this.shouldUpdateHeight) && oldHeight !== height) {
	        shouldUpdateLayout = true;
	      }
	
	      if (shouldUpdateLayout) {
	        this.resizeState.width = width;
	        this.resizeState.height = height;
	        this.doLayout();
	      }
	    },
	    doLayout: function doLayout() {
	      if (this.shouldUpdateHeight) {
	        this.layout.updateElsHeight();
	      }
	      this.layout.updateColumnsWidth();
	    },
	    sort: function sort(prop, order) {
	      this.store.commit('sort', { prop: prop, order: order });
	    },
	    toggleAllSelection: function toggleAllSelection() {
	      this.store.commit('toggleAllSelection');
	    }
	  },
	
	  computed: tablevue_type_script_lang_js_extends({
	    tableSize: function tableSize() {
	      return this.size || (this.$ELEMENT || {}).size;
	    },
	    bodyWrapper: function bodyWrapper() {
	      return this.$refs.bodyWrapper;
	    },
	    shouldUpdateHeight: function shouldUpdateHeight() {
	      return this.height || this.maxHeight || this.fixedColumns.length > 0 || this.rightFixedColumns.length > 0;
	    },
	    bodyWidth: function bodyWidth() {
	      var _layout = this.layout,
	          bodyWidth = _layout.bodyWidth,
	          scrollY = _layout.scrollY,
	          gutterWidth = _layout.gutterWidth;
	
	      return bodyWidth ? bodyWidth - (scrollY ? gutterWidth : 0) + 'px' : '';
	    },
	    bodyHeight: function bodyHeight() {
	      var _layout2 = this.layout,
	          _layout2$headerHeight = _layout2.headerHeight,
	          headerHeight = _layout2$headerHeight === undefined ? 0 : _layout2$headerHeight,
	          bodyHeight = _layout2.bodyHeight,
	          _layout2$footerHeight = _layout2.footerHeight,
	          footerHeight = _layout2$footerHeight === undefined ? 0 : _layout2$footerHeight;
	
	      if (this.height) {
	        return {
	          height: bodyHeight ? bodyHeight + 'px' : ''
	        };
	      } else if (this.maxHeight) {
	        var maxHeight = parseHeight(this.maxHeight);
	        if (typeof maxHeight === 'number') {
	          return {
	            'max-height': maxHeight - footerHeight - (this.showHeader ? headerHeight : 0) + 'px'
	          };
	        }
	      }
	      return {};
	    },
	    fixedBodyHeight: function fixedBodyHeight() {
	      if (this.height) {
	        return {
	          height: this.layout.fixedBodyHeight ? this.layout.fixedBodyHeight + 'px' : ''
	        };
	      } else if (this.maxHeight) {
	        var maxHeight = parseHeight(this.maxHeight);
	        if (typeof maxHeight === 'number') {
	          maxHeight = this.layout.scrollX ? maxHeight - this.layout.gutterWidth : maxHeight;
	          if (this.showHeader) {
	            maxHeight -= this.layout.headerHeight;
	          }
	          maxHeight -= this.layout.footerHeight;
	          return {
	            'max-height': maxHeight + 'px'
	          };
	        }
	      }
	      return {};
	    },
	    fixedHeight: function fixedHeight() {
	      if (this.maxHeight) {
	        if (this.showSummary) {
	          return {
	            bottom: 0
	          };
	        }
	        return {
	          bottom: this.layout.scrollX && this.data.length ? this.layout.gutterWidth + 'px' : ''
	        };
	      } else {
	        if (this.showSummary) {
	          return {
	            height: this.layout.tableHeight ? this.layout.tableHeight + 'px' : ''
	          };
	        }
	        return {
	          height: this.layout.viewportHeight ? this.layout.viewportHeight + 'px' : ''
	        };
	      }
	    },
	    emptyBlockStyle: function emptyBlockStyle() {
	      if (this.data && this.data.length) return null;
	      var height = '100%';
	      if (this.layout.appendHeight) {
	        height = 'calc(100% - ' + this.layout.appendHeight + 'px)';
	      }
	      return {
	        width: this.bodyWidth,
	        height: height
	      };
	    }
	  }, mapStates({
	    selection: 'selection',
	    columns: 'columns',
	    tableData: 'data',
	    fixedColumns: 'fixedColumns',
	    rightFixedColumns: 'rightFixedColumns'
	  })),
	
	  watch: {
	    height: {
	      immediate: true,
	      handler: function handler(value) {
	        this.layout.setHeight(value);
	      }
	    },
	
	    maxHeight: {
	      immediate: true,
	      handler: function handler(value) {
	        this.layout.setMaxHeight(value);
	      }
	    },
	
	    currentRowKey: {
	      immediate: true,
	      handler: function handler(value) {
	        if (!this.rowKey) return;
	        this.store.setCurrentRowKey(value);
	      }
	    },
	
	    data: {
	      immediate: true,
	      handler: function handler(value) {
	        this.store.commit('setData', value);
	      }
	    },
	
	    expandRowKeys: {
	      immediate: true,
	      handler: function handler(newVal) {
	        if (newVal) {
	          this.store.setExpandRowKeysAdapter(newVal);
	        }
	      }
	    }
	  },
	
	  created: function created() {
	    var _this = this;
	
	    this.tableId = 'el-table_' + tableIdSeed++;
	    this.debouncedUpdateLayout = Object(external_throttle_debounce_["debounce"])(50, function () {
	      return _this.doLayout();
	    });
	  },
	  mounted: function mounted() {
	    var _this2 = this;
	
	    this.bindEvents();
	    this.store.updateColumns();
	    this.doLayout();
	
	    this.resizeState = {
	      width: this.$el.offsetWidth,
	      height: this.$el.offsetHeight
	    };
	
	    // init filters
	    this.store.states.columns.forEach(function (column) {
	      if (column.filteredValue && column.filteredValue.length) {
	        _this2.store.commit('filterChange', {
	          column: column,
	          values: column.filteredValue,
	          silent: true
	        });
	      }
	    });
	
	    this.$ready = true;
	  },
	  destroyed: function destroyed() {
	    this.unbindEvents();
	  },
	  data: function data() {
	    var _treeProps = this.treeProps,
	        _treeProps$hasChildre = _treeProps.hasChildren,
	        hasChildren = _treeProps$hasChildre === undefined ? 'hasChildren' : _treeProps$hasChildre,
	        _treeProps$children = _treeProps.children,
	        children = _treeProps$children === undefined ? 'children' : _treeProps$children;
	
	    this.store = createStore(this, {
	      rowKey: this.rowKey,
	      defaultExpandAll: this.defaultExpandAll,
	      selectOnIndeterminate: this.selectOnIndeterminate,
	      // TreeTable 的相关配置
	      indent: this.indent,
	      lazy: this.lazy,
	      lazyColumnIdentifier: hasChildren,
	      childrenColumnName: children
	    });
	    var layout = new table_layout({
	      store: this.store,
	      table: this,
	      fit: this.fit,
	      showHeader: this.showHeader
	    });
	    return {
	      layout: layout,
	      isHidden: false,
	      renderExpanded: null,
	      resizeProxyVisible: false,
	      resizeState: {
	        width: null,
	        height: null
	      },
	      // 是否拥有多级表头
	      isGroup: false,
	      scrollPosition: 'left'
	    };
	  }
	});
	// CONCATENATED MODULE: ./packages/table/src/table.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_tablevue_type_script_lang_js_ = (tablevue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/table/src/table.vue
	
	
	
	
	
	/* normalize component */
	
	var table_component = normalizeComponent(
	  src_tablevue_type_script_lang_js_,
	  tablevue_type_template_id_493fe34e_render,
	  tablevue_type_template_id_493fe34e_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var table_api; }
	table_component.options.__file = "packages/table/src/table.vue"
	/* harmony default export */ var src_table = (table_component.exports);
	// CONCATENATED MODULE: ./packages/table/index.js
	
	
	/* istanbul ignore next */
	src_table.install = function (Vue) {
	  Vue.component(src_table.name, src_table);
	};
	
	/* harmony default export */ var packages_table = (src_table);
	// CONCATENATED MODULE: ./packages/table/src/config.js
	
	
	var cellStarts = {
	  default: {
	    order: ''
	  },
	  selection: {
	    width: 48,
	    minWidth: 48,
	    realWidth: 48,
	    order: '',
	    className: 'el-table-column--selection'
	  },
	  expand: {
	    width: 48,
	    minWidth: 48,
	    realWidth: 48,
	    order: ''
	  },
	  index: {
	    width: 48,
	    minWidth: 48,
	    realWidth: 48,
	    order: ''
	  }
	};
	
	// 这些选项不应该被覆盖
	var cellForced = {
	  selection: {
	    renderHeader: function renderHeader(h, _ref) {
	      var store = _ref.store;
	
	      return h('el-checkbox', {
	        attrs: {
	          disabled: store.states.data && store.states.data.length === 0,
	          indeterminate: store.states.selection.length > 0 && !this.isAllSelected,
	
	          value: this.isAllSelected },
	        nativeOn: {
	          'click': this.toggleAllSelection
	        }
	      });
	    },
	    renderCell: function renderCell(h, _ref2) {
	      var row = _ref2.row,
	          column = _ref2.column,
	          store = _ref2.store,
	          $index = _ref2.$index;
	
	      return h('el-checkbox', {
	        nativeOn: {
	          'click': function click(event) {
	            return event.stopPropagation();
	          }
	        },
	        attrs: {
	          value: store.isSelected(row),
	          disabled: column.selectable ? !column.selectable.call(null, row, $index) : false
	        },
	        on: {
	          'input': function input() {
	            store.commit('rowSelectedChanged', row);
	          }
	        }
	      });
	    },
	    sortable: false,
	    resizable: false
	  },
	  index: {
	    renderHeader: function renderHeader(h, _ref3) {
	      var column = _ref3.column;
	
	      return column.label || '#';
	    },
	    renderCell: function renderCell(h, _ref4) {
	      var $index = _ref4.$index,
	          column = _ref4.column;
	
	      var i = $index + 1;
	      var index = column.index;
	
	      if (typeof index === 'number') {
	        i = $index + index;
	      } else if (typeof index === 'function') {
	        i = index($index);
	      }
	
	      return h('div', [i]);
	    },
	    sortable: false
	  },
	  expand: {
	    renderHeader: function renderHeader(h, _ref5) {
	      var column = _ref5.column;
	
	      return column.label || '';
	    },
	    renderCell: function renderCell(h, _ref6) {
	      var row = _ref6.row,
	          store = _ref6.store;
	
	      var classes = ['el-table__expand-icon'];
	      if (store.states.expandRows.indexOf(row) > -1) {
	        classes.push('el-table__expand-icon--expanded');
	      }
	      var callback = function callback(e) {
	        e.stopPropagation();
	        store.toggleRowExpansion(row);
	      };
	      return h(
	        'div',
	        { 'class': classes,
	          on: {
	            'click': callback
	          }
	        },
	        [h('i', { 'class': 'el-icon el-icon-arrow-right' })]
	      );
	    },
	    sortable: false,
	    resizable: false,
	    className: 'el-table__expand-column'
	  }
	};
	
	function defaultRenderCell(h, _ref7) {
	  var row = _ref7.row,
	      column = _ref7.column,
	      $index = _ref7.$index;
	
	  var property = column.property;
	  var value = property && Object(util_["getPropByPath"])(row, property).v;
	  if (column && column.formatter) {
	    return column.formatter(row, column, value, $index);
	  }
	  return value;
	}
	
	function treeCellPrefix(h, _ref8) {
	  var row = _ref8.row,
	      treeNode = _ref8.treeNode,
	      store = _ref8.store;
	
	  if (!treeNode) return null;
	  var ele = [];
	  var callback = function callback(e) {
	    e.stopPropagation();
	    store.loadOrToggle(row);
	  };
	  if (treeNode.indent) {
	    ele.push(h('span', { 'class': 'el-table__indent', style: { 'padding-left': treeNode.indent + 'px' } }));
	  }
	  if (typeof treeNode.expanded === 'boolean' && !treeNode.noLazyChildren) {
	    var expandClasses = ['el-table__expand-icon', treeNode.expanded ? 'el-table__expand-icon--expanded' : ''];
	    var iconClasses = ['el-icon-arrow-right'];
	    if (treeNode.loading) {
	      iconClasses = ['el-icon-loading'];
	    }
	    ele.push(h(
	      'div',
	      { 'class': expandClasses,
	        on: {
	          'click': callback
	        }
	      },
	      [h('i', { 'class': iconClasses })]
	    ));
	  } else {
	    ele.push(h('span', { 'class': 'el-table__placeholder' }));
	  }
	  return ele;
	}
	// CONCATENATED MODULE: ./packages/table/src/table-column.js
	var table_column_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	
	
	
	
	var columnIdSeed = 1;
	
	/* harmony default export */ var table_column = ({
	  name: 'ElTableColumn',
	
	  props: {
	    type: {
	      type: String,
	      default: 'default'
	    },
	    label: String,
	    className: String,
	    labelClassName: String,
	    property: String,
	    prop: String,
	    width: {},
	    minWidth: {},
	    renderHeader: Function,
	    sortable: {
	      type: [Boolean, String],
	      default: false
	    },
	    sortMethod: Function,
	    sortBy: [String, Function, Array],
	    resizable: {
	      type: Boolean,
	      default: true
	    },
	    columnKey: String,
	    align: String,
	    headerAlign: String,
	    showTooltipWhenOverflow: Boolean,
	    showOverflowTooltip: Boolean,
	    fixed: [Boolean, String],
	    formatter: Function,
	    selectable: Function,
	    reserveSelection: Boolean,
	    filterMethod: Function,
	    filteredValue: Array,
	    filters: Array,
	    filterPlacement: String,
	    filterMultiple: {
	      type: Boolean,
	      default: true
	    },
	    index: [Number, Function],
	    sortOrders: {
	      type: Array,
	      default: function _default() {
	        return ['ascending', 'descending', null];
	      },
	      validator: function validator(val) {
	        return val.every(function (order) {
	          return ['ascending', 'descending', null].indexOf(order) > -1;
	        });
	      }
	    }
	  },
	
	  data: function data() {
	    return {
	      isSubColumn: false,
	      columns: []
	    };
	  },
	
	
	  computed: {
	    owner: function owner() {
	      var parent = this.$parent;
	      while (parent && !parent.tableId) {
	        parent = parent.$parent;
	      }
	      return parent;
	    },
	    columnOrTableParent: function columnOrTableParent() {
	      var parent = this.$parent;
	      while (parent && !parent.tableId && !parent.columnId) {
	        parent = parent.$parent;
	      }
	      return parent;
	    },
	    realWidth: function realWidth() {
	      return parseWidth(this.width);
	    },
	    realMinWidth: function realMinWidth() {
	      return parseMinWidth(this.minWidth);
	    },
	    realAlign: function realAlign() {
	      return this.align ? 'is-' + this.align : null;
	    },
	    realHeaderAlign: function realHeaderAlign() {
	      return this.headerAlign ? 'is-' + this.headerAlign : this.realAlign;
	    }
	  },
	
	  methods: {
	    getPropsData: function getPropsData() {
	      var _this = this;
	
	      for (var _len = arguments.length, props = Array(_len), _key = 0; _key < _len; _key++) {
	        props[_key] = arguments[_key];
	      }
	
	      return props.reduce(function (prev, cur) {
	        if (Array.isArray(cur)) {
	          cur.forEach(function (key) {
	            prev[key] = _this[key];
	          });
	        }
	        return prev;
	      }, {});
	    },
	    getColumnElIndex: function getColumnElIndex(children, child) {
	      return [].indexOf.call(children, child);
	    },
	    setColumnWidth: function setColumnWidth(column) {
	      if (this.realWidth) {
	        column.width = this.realWidth;
	      }
	      if (this.realMinWidth) {
	        column.minWidth = this.realMinWidth;
	      }
	      if (!column.minWidth) {
	        column.minWidth = 80;
	      }
	      column.realWidth = column.width === undefined ? column.minWidth : column.width;
	      return column;
	    },
	    setColumnForcedProps: function setColumnForcedProps(column) {
	      // 对于特定类型的 column，某些属性不允许设置
	      var type = column.type;
	      var source = cellForced[type] || {};
	      Object.keys(source).forEach(function (prop) {
	        var value = source[prop];
	        if (value !== undefined) {
	          column[prop] = prop === 'className' ? column[prop] + ' ' + value : value;
	        }
	      });
	      return column;
	    },
	    setColumnRenders: function setColumnRenders(column) {
	      var _this2 = this;
	
	      var h = this.$createElement;
	
	      // renderHeader 属性不推荐使用。
	      if (this.renderHeader) {
	        console.warn('[Element Warn][TableColumn]Comparing to render-header, scoped-slot header is easier to use. We recommend users to use scoped-slot header.');
	      } else if (column.type !== 'selection') {
	        column.renderHeader = function (h, scope) {
	          var renderHeader = _this2.$scopedSlots.header;
	          return renderHeader ? renderHeader(scope) : column.label;
	        };
	      }
	
	      var originRenderCell = column.renderCell;
	      // TODO: 这里的实现调整
	      if (column.type === 'expand') {
	        // 对于展开行，renderCell 不允许配置的。在上一步中已经设置过，这里需要简单封装一下。
	        column.renderCell = function (h, data) {
	          return h(
	            'div',
	            { 'class': 'cell' },
	            [originRenderCell(h, data)]
	          );
	        };
	        this.owner.renderExpanded = function (h, data) {
	          return _this2.$scopedSlots.default ? _this2.$scopedSlots.default(data) : _this2.$slots.default;
	        };
	      } else {
	        originRenderCell = originRenderCell || defaultRenderCell;
	        // 对 renderCell 进行包装
	        column.renderCell = function (h, data) {
	          var children = null;
	          if (_this2.$scopedSlots.default) {
	            children = _this2.$scopedSlots.default(data);
	          } else {
	            children = originRenderCell(h, data);
	          }
	          var prefix = treeCellPrefix(h, data);
	          var props = {
	            class: 'cell',
	            style: {}
	          };
	          if (column.showOverflowTooltip) {
	            props.class += ' el-tooltip';
	            props.style = { width: (data.column.realWidth || data.column.width) - 1 + 'px' };
	          }
	          return h(
	            'div',
	            props,
	            [prefix, children]
	          );
	        };
	      }
	      return column;
	    },
	    registerNormalWatchers: function registerNormalWatchers() {
	      var _this3 = this;
	
	      var props = ['label', 'property', 'filters', 'filterMultiple', 'sortable', 'index', 'formatter', 'className', 'labelClassName', 'showOverflowTooltip'];
	      // 一些属性具有别名
	      var aliases = {
	        prop: 'property',
	        realAlign: 'align',
	        realHeaderAlign: 'headerAlign',
	        realWidth: 'width'
	      };
	      var allAliases = props.reduce(function (prev, cur) {
	        prev[cur] = cur;
	        return prev;
	      }, aliases);
	
	      Object.keys(allAliases).forEach(function (key) {
	        var columnKey = aliases[key];
	
	        _this3.$watch(key, function (newVal) {
	          _this3.columnConfig[columnKey] = newVal;
	        });
	      });
	    },
	    registerComplexWatchers: function registerComplexWatchers() {
	      var _this4 = this;
	
	      var props = ['fixed'];
	      var aliases = {
	        realWidth: 'width',
	        realMinWidth: 'minWidth'
	      };
	      var allAliases = props.reduce(function (prev, cur) {
	        prev[cur] = cur;
	        return prev;
	      }, aliases);
	
	      Object.keys(allAliases).forEach(function (key) {
	        var columnKey = aliases[key];
	
	        _this4.$watch(key, function (newVal) {
	          _this4.columnConfig[columnKey] = newVal;
	          var updateColumns = columnKey === 'fixed';
	          _this4.owner.store.scheduleLayout(updateColumns);
	        });
	      });
	    }
	  },
	
	  components: {
	    ElCheckbox: checkbox_default.a
	  },
	
	  beforeCreate: function beforeCreate() {
	    this.row = {};
	    this.column = {};
	    this.$index = 0;
	    this.columnId = '';
	  },
	  created: function created() {
	    var parent = this.columnOrTableParent;
	    this.isSubColumn = this.owner !== parent;
	    this.columnId = (parent.tableId || parent.columnId) + '_column_' + columnIdSeed++;
	
	    var type = this.type || 'default';
	    var sortable = this.sortable === '' ? true : this.sortable;
	    var defaults = table_column_extends({}, cellStarts[type], {
	      id: this.columnId,
	      type: type,
	      property: this.prop || this.property,
	      align: this.realAlign,
	      headerAlign: this.realHeaderAlign,
	      showOverflowTooltip: this.showOverflowTooltip || this.showTooltipWhenOverflow,
	      // filter 相关属性
	      filterable: this.filters || this.filterMethod,
	      filteredValue: [],
	      filterPlacement: '',
	      isColumnGroup: false,
	      filterOpened: false,
	      // sort 相关属性
	      sortable: sortable,
	      // index 列
	      index: this.index
	    });
	
	    var basicProps = ['columnKey', 'label', 'className', 'labelClassName', 'type', 'renderHeader', 'formatter', 'fixed', 'resizable'];
	    var sortProps = ['sortMethod', 'sortBy', 'sortOrders'];
	    var selectProps = ['selectable', 'reserveSelection'];
	    var filterProps = ['filterMethod', 'filters', 'filterMultiple', 'filterOpened', 'filteredValue', 'filterPlacement'];
	
	    var column = this.getPropsData(basicProps, sortProps, selectProps, filterProps);
	    column = mergeOptions(defaults, column);
	
	    // 注意 compose 中函数执行的顺序是从右到左
	    var chains = compose(this.setColumnRenders, this.setColumnWidth, this.setColumnForcedProps);
	    column = chains(column);
	
	    this.columnConfig = column;
	
	    // 注册 watcher
	    this.registerNormalWatchers();
	    this.registerComplexWatchers();
	  },
	  mounted: function mounted() {
	    var owner = this.owner;
	    var parent = this.columnOrTableParent;
	    var children = this.isSubColumn ? parent.$el.children : parent.$refs.hiddenColumns.children;
	    var columnIndex = this.getColumnElIndex(children, this.$el);
	
	    owner.store.commit('insertColumn', this.columnConfig, columnIndex, this.isSubColumn ? parent.columnConfig : null);
	  },
	  destroyed: function destroyed() {
	    if (!this.$parent) return;
	    var parent = this.$parent;
	    this.owner.store.commit('removeColumn', this.columnConfig, this.isSubColumn ? parent.columnConfig : null);
	  },
	  render: function render(h) {
	    // slots 也要渲染，需要计算合并表头
	    return h('div', this.$slots.default);
	  }
	});
	// CONCATENATED MODULE: ./packages/table-column/index.js
	
	
	/* istanbul ignore next */
	table_column.install = function (Vue) {
	  Vue.component(table_column.name, table_column);
	};
	
	/* harmony default export */ var packages_table_column = (table_column);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/picker.vue?vue&type=template&id=79ae069f&
	var pickervue_type_template_id_79ae069f_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return !_vm.ranged
	    ? _c(
	        "el-input",
	        _vm._b(
	          {
	            directives: [
	              {
	                name: "clickoutside",
	                rawName: "v-clickoutside",
	                value: _vm.handleClose,
	                expression: "handleClose"
	              }
	            ],
	            ref: "reference",
	            staticClass: "el-date-editor",
	            class: "el-date-editor--" + _vm.type,
	            attrs: {
	              readonly:
	                !_vm.editable ||
	                _vm.readonly ||
	                _vm.type === "dates" ||
	                _vm.type === "week",
	              disabled: _vm.pickerDisabled,
	              size: _vm.pickerSize,
	              name: _vm.name,
	              placeholder: _vm.placeholder,
	              value: _vm.displayValue,
	              validateEvent: false
	            },
	            on: {
	              focus: _vm.handleFocus,
	              input: function(value) {
	                return (_vm.userInput = value)
	              },
	              change: _vm.handleChange
	            },
	            nativeOn: {
	              keydown: function($event) {
	                return _vm.handleKeydown($event)
	              },
	              mouseenter: function($event) {
	                return _vm.handleMouseEnter($event)
	              },
	              mouseleave: function($event) {
	                _vm.showClose = false
	              }
	            }
	          },
	          "el-input",
	          _vm.firstInputId,
	          false
	        ),
	        [
	          _c("i", {
	            staticClass: "el-input__icon",
	            class: _vm.triggerClass,
	            attrs: { slot: "prefix" },
	            on: { click: _vm.handleFocus },
	            slot: "prefix"
	          }),
	          _vm.haveTrigger
	            ? _c("i", {
	                staticClass: "el-input__icon",
	                class: [_vm.showClose ? "" + _vm.clearIcon : ""],
	                attrs: { slot: "suffix" },
	                on: { click: _vm.handleClickIcon },
	                slot: "suffix"
	              })
	            : _vm._e()
	        ]
	      )
	    : _c(
	        "div",
	        {
	          directives: [
	            {
	              name: "clickoutside",
	              rawName: "v-clickoutside",
	              value: _vm.handleClose,
	              expression: "handleClose"
	            }
	          ],
	          ref: "reference",
	          staticClass: "el-date-editor el-range-editor el-input__inner",
	          class: [
	            "el-date-editor--" + _vm.type,
	            _vm.pickerSize ? "el-range-editor--" + _vm.pickerSize : "",
	            _vm.pickerDisabled ? "is-disabled" : "",
	            _vm.pickerVisible ? "is-active" : ""
	          ],
	          on: {
	            click: _vm.handleRangeClick,
	            mouseenter: _vm.handleMouseEnter,
	            mouseleave: function($event) {
	              _vm.showClose = false
	            },
	            keydown: _vm.handleKeydown
	          }
	        },
	        [
	          _c("i", {
	            class: ["el-input__icon", "el-range__icon", _vm.triggerClass]
	          }),
	          _c(
	            "input",
	            _vm._b(
	              {
	                staticClass: "el-range-input",
	                attrs: {
	                  autocomplete: "off",
	                  placeholder: _vm.startPlaceholder,
	                  disabled: _vm.pickerDisabled,
	                  readonly: !_vm.editable || _vm.readonly,
	                  name: _vm.name && _vm.name[0]
	                },
	                domProps: { value: _vm.displayValue && _vm.displayValue[0] },
	                on: {
	                  input: _vm.handleStartInput,
	                  change: _vm.handleStartChange,
	                  focus: _vm.handleFocus
	                }
	              },
	              "input",
	              _vm.firstInputId,
	              false
	            )
	          ),
	          _vm._t("range-separator", [
	            _c("span", { staticClass: "el-range-separator" }, [
	              _vm._v(_vm._s(_vm.rangeSeparator))
	            ])
	          ]),
	          _c(
	            "input",
	            _vm._b(
	              {
	                staticClass: "el-range-input",
	                attrs: {
	                  autocomplete: "off",
	                  placeholder: _vm.endPlaceholder,
	                  disabled: _vm.pickerDisabled,
	                  readonly: !_vm.editable || _vm.readonly,
	                  name: _vm.name && _vm.name[1]
	                },
	                domProps: { value: _vm.displayValue && _vm.displayValue[1] },
	                on: {
	                  input: _vm.handleEndInput,
	                  change: _vm.handleEndChange,
	                  focus: _vm.handleFocus
	                }
	              },
	              "input",
	              _vm.secondInputId,
	              false
	            )
	          ),
	          _vm.haveTrigger
	            ? _c("i", {
	                staticClass: "el-input__icon el-range__close-icon",
	                class: [_vm.showClose ? "" + _vm.clearIcon : ""],
	                on: { click: _vm.handleClickIcon }
	              })
	            : _vm._e()
	        ],
	        2
	      )
	}
	var pickervue_type_template_id_79ae069f_staticRenderFns = []
	pickervue_type_template_id_79ae069f_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/date-picker/src/picker.vue?vue&type=template&id=79ae069f&
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/date-util"
	var date_util_ = __webpack_require__(0);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/picker.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	
	
	var NewPopper = {
	  props: {
	    appendToBody: vue_popper_default.a.props.appendToBody,
	    offset: vue_popper_default.a.props.offset,
	    boundariesPadding: vue_popper_default.a.props.boundariesPadding,
	    arrowOffset: vue_popper_default.a.props.arrowOffset
	  },
	  methods: vue_popper_default.a.methods,
	  data: function data() {
	    return merge_default()({ visibleArrow: true }, vue_popper_default.a.data);
	  },
	
	  beforeDestroy: vue_popper_default.a.beforeDestroy
	};
	
	var DEFAULT_FORMATS = {
	  date: 'yyyy-MM-dd',
	  month: 'yyyy-MM',
	  datetime: 'yyyy-MM-dd HH:mm:ss',
	  time: 'HH:mm:ss',
	  week: 'yyyywWW',
	  timerange: 'HH:mm:ss',
	  daterange: 'yyyy-MM-dd',
	  monthrange: 'yyyy-MM',
	  datetimerange: 'yyyy-MM-dd HH:mm:ss',
	  year: 'yyyy'
	};
	var HAVE_TRIGGER_TYPES = ['date', 'datetime', 'time', 'time-select', 'week', 'month', 'year', 'daterange', 'monthrange', 'timerange', 'datetimerange', 'dates'];
	var pickervue_type_script_lang_js_DATE_FORMATTER = function DATE_FORMATTER(value, format) {
	  if (format === 'timestamp') return value.getTime();
	  return Object(date_util_["formatDate"])(value, format);
	};
	var pickervue_type_script_lang_js_DATE_PARSER = function DATE_PARSER(text, format) {
	  if (format === 'timestamp') return new Date(Number(text));
	  return Object(date_util_["parseDate"])(text, format);
	};
	var RANGE_FORMATTER = function RANGE_FORMATTER(value, format) {
	  if (Array.isArray(value) && value.length === 2) {
	    var start = value[0];
	    var end = value[1];
	
	    if (start && end) {
	      return [pickervue_type_script_lang_js_DATE_FORMATTER(start, format), pickervue_type_script_lang_js_DATE_FORMATTER(end, format)];
	    }
	  }
	  return '';
	};
	var RANGE_PARSER = function RANGE_PARSER(array, format, separator) {
	  if (!Array.isArray(array)) {
	    array = array.split(separator);
	  }
	  if (array.length === 2) {
	    var range1 = array[0];
	    var range2 = array[1];
	
	    return [pickervue_type_script_lang_js_DATE_PARSER(range1, format), pickervue_type_script_lang_js_DATE_PARSER(range2, format)];
	  }
	  return [];
	};
	var TYPE_VALUE_RESOLVER_MAP = {
	  default: {
	    formatter: function formatter(value) {
	      if (!value) return '';
	      return '' + value;
	    },
	    parser: function parser(text) {
	      if (text === undefined || text === '') return null;
	      return text;
	    }
	  },
	  week: {
	    formatter: function formatter(value, format) {
	      var week = Object(date_util_["getWeekNumber"])(value);
	      var month = value.getMonth();
	      var trueDate = new Date(value);
	      if (week === 1 && month === 11) {
	        trueDate.setHours(0, 0, 0, 0);
	        trueDate.setDate(trueDate.getDate() + 3 - (trueDate.getDay() + 6) % 7);
	      }
	      var date = Object(date_util_["formatDate"])(trueDate, format);
	
	      date = /WW/.test(date) ? date.replace(/WW/, week < 10 ? '0' + week : week) : date.replace(/W/, week);
	      return date;
	    },
	    parser: function parser(text, format) {
	      // parse as if a normal date
	      return TYPE_VALUE_RESOLVER_MAP.date.parser(text, format);
	    }
	  },
	  date: {
	    formatter: pickervue_type_script_lang_js_DATE_FORMATTER,
	    parser: pickervue_type_script_lang_js_DATE_PARSER
	  },
	  datetime: {
	    formatter: pickervue_type_script_lang_js_DATE_FORMATTER,
	    parser: pickervue_type_script_lang_js_DATE_PARSER
	  },
	  daterange: {
	    formatter: RANGE_FORMATTER,
	    parser: RANGE_PARSER
	  },
	  monthrange: {
	    formatter: RANGE_FORMATTER,
	    parser: RANGE_PARSER
	  },
	  datetimerange: {
	    formatter: RANGE_FORMATTER,
	    parser: RANGE_PARSER
	  },
	  timerange: {
	    formatter: RANGE_FORMATTER,
	    parser: RANGE_PARSER
	  },
	  time: {
	    formatter: pickervue_type_script_lang_js_DATE_FORMATTER,
	    parser: pickervue_type_script_lang_js_DATE_PARSER
	  },
	  month: {
	    formatter: pickervue_type_script_lang_js_DATE_FORMATTER,
	    parser: pickervue_type_script_lang_js_DATE_PARSER
	  },
	  year: {
	    formatter: pickervue_type_script_lang_js_DATE_FORMATTER,
	    parser: pickervue_type_script_lang_js_DATE_PARSER
	  },
	  number: {
	    formatter: function formatter(value) {
	      if (!value) return '';
	      return '' + value;
	    },
	    parser: function parser(text) {
	      var result = Number(text);
	
	      if (!isNaN(text)) {
	        return result;
	      } else {
	        return null;
	      }
	    }
	  },
	  dates: {
	    formatter: function formatter(value, format) {
	      return value.map(function (date) {
	        return pickervue_type_script_lang_js_DATE_FORMATTER(date, format);
	      });
	    },
	    parser: function parser(value, format) {
	      return (typeof value === 'string' ? value.split(', ') : value).map(function (date) {
	        return date instanceof Date ? date : pickervue_type_script_lang_js_DATE_PARSER(date, format);
	      });
	    }
	  }
	};
	var PLACEMENT_MAP = {
	  left: 'bottom-start',
	  center: 'bottom',
	  right: 'bottom-end'
	};
	
	var parseAsFormatAndType = function parseAsFormatAndType(value, customFormat, type) {
	  var rangeSeparator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '-';
	
	  if (!value) return null;
	  var parser = (TYPE_VALUE_RESOLVER_MAP[type] || TYPE_VALUE_RESOLVER_MAP['default']).parser;
	  var format = customFormat || DEFAULT_FORMATS[type];
	  return parser(value, format, rangeSeparator);
	};
	
	var formatAsFormatAndType = function formatAsFormatAndType(value, customFormat, type) {
	  if (!value) return null;
	  var formatter = (TYPE_VALUE_RESOLVER_MAP[type] || TYPE_VALUE_RESOLVER_MAP['default']).formatter;
	  var format = customFormat || DEFAULT_FORMATS[type];
	  return formatter(value, format);
	};
	
	/*
	 * Considers:
	 *   1. Date object
	 *   2. date string
	 *   3. array of 1 or 2
	 */
	var valueEquals = function valueEquals(a, b) {
	  // considers Date object and string
	  var dateEquals = function dateEquals(a, b) {
	    var aIsDate = a instanceof Date;
	    var bIsDate = b instanceof Date;
	    if (aIsDate && bIsDate) {
	      return a.getTime() === b.getTime();
	    }
	    if (!aIsDate && !bIsDate) {
	      return a === b;
	    }
	    return false;
	  };
	
	  var aIsArray = a instanceof Array;
	  var bIsArray = b instanceof Array;
	  if (aIsArray && bIsArray) {
	    if (a.length !== b.length) {
	      return false;
	    }
	    return a.every(function (item, index) {
	      return dateEquals(item, b[index]);
	    });
	  }
	  if (!aIsArray && !bIsArray) {
	    return dateEquals(a, b);
	  }
	  return false;
	};
	
	var isString = function isString(val) {
	  return typeof val === 'string' || val instanceof String;
	};
	
	var pickervue_type_script_lang_js_validator = function validator(val) {
	  // either: String, Array of String, null / undefined
	  return val === null || val === undefined || isString(val) || Array.isArray(val) && val.length === 2 && val.every(isString);
	};
	
	/* harmony default export */ var pickervue_type_script_lang_js_ = ({
	  mixins: [emitter_default.a, NewPopper],
	
	  inject: {
	    elForm: {
	      default: ''
	    },
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  props: {
	    size: String,
	    format: String,
	    valueFormat: String,
	    readonly: Boolean,
	    placeholder: String,
	    startPlaceholder: String,
	    endPlaceholder: String,
	    prefixIcon: String,
	    clearIcon: {
	      type: String,
	      default: 'el-icon-circle-close'
	    },
	    name: {
	      default: '',
	      validator: pickervue_type_script_lang_js_validator
	    },
	    disabled: Boolean,
	    clearable: {
	      type: Boolean,
	      default: true
	    },
	    id: {
	      default: '',
	      validator: pickervue_type_script_lang_js_validator
	    },
	    popperClass: String,
	    editable: {
	      type: Boolean,
	      default: true
	    },
	    align: {
	      type: String,
	      default: 'left'
	    },
	    value: {},
	    defaultValue: {},
	    defaultTime: {},
	    rangeSeparator: {
	      default: '-'
	    },
	    pickerOptions: {},
	    unlinkPanels: Boolean,
	    validateEvent: {
	      type: Boolean,
	      default: true
	    }
	  },
	
	  components: { ElInput: input_default.a },
	
	  directives: { Clickoutside: clickoutside_default.a },
	
	  data: function data() {
	    return {
	      pickerVisible: false,
	      showClose: false,
	      userInput: null,
	      valueOnOpen: null, // value when picker opens, used to determine whether to emit change
	      unwatchPickerOptions: null
	    };
	  },
	
	
	  watch: {
	    pickerVisible: function pickerVisible(val) {
	      if (this.readonly || this.pickerDisabled) return;
	      if (val) {
	        this.showPicker();
	        this.valueOnOpen = Array.isArray(this.value) ? [].concat(this.value) : this.value;
	      } else {
	        this.hidePicker();
	        this.emitChange(this.value);
	        this.userInput = null;
	        if (this.validateEvent) {
	          this.dispatch('ElFormItem', 'el.form.blur');
	        }
	        this.$emit('blur', this);
	        this.blur();
	      }
	    },
	
	    parsedValue: {
	      immediate: true,
	      handler: function handler(val) {
	        if (this.picker) {
	          this.picker.value = val;
	        }
	      }
	    },
	    defaultValue: function defaultValue(val) {
	      // NOTE: should eventually move to jsx style picker + panel ?
	      if (this.picker) {
	        this.picker.defaultValue = val;
	      }
	    },
	    value: function value(val, oldVal) {
	      if (!valueEquals(val, oldVal) && !this.pickerVisible && this.validateEvent) {
	        this.dispatch('ElFormItem', 'el.form.change', val);
	      }
	    }
	  },
	
	  computed: {
	    ranged: function ranged() {
	      return this.type.indexOf('range') > -1;
	    },
	    reference: function reference() {
	      var reference = this.$refs.reference;
	      return reference.$el || reference;
	    },
	    refInput: function refInput() {
	      if (this.reference) {
	        return [].slice.call(this.reference.querySelectorAll('input'));
	      }
	      return [];
	    },
	    valueIsEmpty: function valueIsEmpty() {
	      var val = this.value;
	      if (Array.isArray(val)) {
	        for (var i = 0, len = val.length; i < len; i++) {
	          if (val[i]) {
	            return false;
	          }
	        }
	      } else {
	        if (val) {
	          return false;
	        }
	      }
	      return true;
	    },
	    triggerClass: function triggerClass() {
	      return this.prefixIcon || (this.type.indexOf('time') !== -1 ? 'el-icon-time' : 'el-icon-date');
	    },
	    selectionMode: function selectionMode() {
	      if (this.type === 'week') {
	        return 'week';
	      } else if (this.type === 'month') {
	        return 'month';
	      } else if (this.type === 'year') {
	        return 'year';
	      } else if (this.type === 'dates') {
	        return 'dates';
	      }
	
	      return 'day';
	    },
	    haveTrigger: function haveTrigger() {
	      if (typeof this.showTrigger !== 'undefined') {
	        return this.showTrigger;
	      }
	      return HAVE_TRIGGER_TYPES.indexOf(this.type) !== -1;
	    },
	    displayValue: function displayValue() {
	      var formattedValue = formatAsFormatAndType(this.parsedValue, this.format, this.type, this.rangeSeparator);
	      if (Array.isArray(this.userInput)) {
	        return [this.userInput[0] || formattedValue && formattedValue[0] || '', this.userInput[1] || formattedValue && formattedValue[1] || ''];
	      } else if (this.userInput !== null) {
	        return this.userInput;
	      } else if (formattedValue) {
	        return this.type === 'dates' ? formattedValue.join(', ') : formattedValue;
	      } else {
	        return '';
	      }
	    },
	    parsedValue: function parsedValue() {
	      if (!this.value) return this.value; // component value is not set
	      if (this.type === 'time-select') return this.value; // time-select does not require parsing, this might change in next major version
	
	      var valueIsDateObject = Object(date_util_["isDateObject"])(this.value) || Array.isArray(this.value) && this.value.every(date_util_["isDateObject"]);
	      if (valueIsDateObject) {
	        return this.value;
	      }
	
	      if (this.valueFormat) {
	        return parseAsFormatAndType(this.value, this.valueFormat, this.type, this.rangeSeparator) || this.value;
	      }
	
	      // NOTE: deal with common but incorrect usage, should remove in next major version
	      // user might provide string / timestamp without value-format, coerce them into date (or array of date)
	      return Array.isArray(this.value) ? this.value.map(function (val) {
	        return new Date(val);
	      }) : new Date(this.value);
	    },
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    pickerSize: function pickerSize() {
	      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
	    },
	    pickerDisabled: function pickerDisabled() {
	      return this.disabled || (this.elForm || {}).disabled;
	    },
	    firstInputId: function firstInputId() {
	      var obj = {};
	      var id = void 0;
	      if (this.ranged) {
	        id = this.id && this.id[0];
	      } else {
	        id = this.id;
	      }
	      if (id) obj.id = id;
	      return obj;
	    },
	    secondInputId: function secondInputId() {
	      var obj = {};
	      var id = void 0;
	      if (this.ranged) {
	        id = this.id && this.id[1];
	      }
	      if (id) obj.id = id;
	      return obj;
	    }
	  },
	
	  created: function created() {
	    // vue-popper
	    this.popperOptions = {
	      boundariesPadding: 0,
	      gpuAcceleration: false
	    };
	    this.placement = PLACEMENT_MAP[this.align] || PLACEMENT_MAP.left;
	
	    this.$on('fieldReset', this.handleFieldReset);
	  },
	
	
	  methods: {
	    focus: function focus() {
	      if (!this.ranged) {
	        this.$refs.reference.focus();
	      } else {
	        this.handleFocus();
	      }
	    },
	    blur: function blur() {
	      this.refInput.forEach(function (input) {
	        return input.blur();
	      });
	    },
	
	
	    // {parse, formatTo} Value deals maps component value with internal Date
	    parseValue: function parseValue(value) {
	      var isParsed = Object(date_util_["isDateObject"])(value) || Array.isArray(value) && value.every(date_util_["isDateObject"]);
	      if (this.valueFormat && !isParsed) {
	        return parseAsFormatAndType(value, this.valueFormat, this.type, this.rangeSeparator) || value;
	      } else {
	        return value;
	      }
	    },
	    formatToValue: function formatToValue(date) {
	      var isFormattable = Object(date_util_["isDateObject"])(date) || Array.isArray(date) && date.every(date_util_["isDateObject"]);
	      if (this.valueFormat && isFormattable) {
	        return formatAsFormatAndType(date, this.valueFormat, this.type, this.rangeSeparator);
	      } else {
	        return date;
	      }
	    },
	
	
	    // {parse, formatTo} String deals with user input
	    parseString: function parseString(value) {
	      var type = Array.isArray(value) ? this.type : this.type.replace('range', '');
	      return parseAsFormatAndType(value, this.format, type);
	    },
	    formatToString: function formatToString(value) {
	      var type = Array.isArray(value) ? this.type : this.type.replace('range', '');
	      return formatAsFormatAndType(value, this.format, type);
	    },
	    handleMouseEnter: function handleMouseEnter() {
	      if (this.readonly || this.pickerDisabled) return;
	      if (!this.valueIsEmpty && this.clearable) {
	        this.showClose = true;
	      }
	    },
	    handleChange: function handleChange() {
	      if (this.userInput) {
	        var value = this.parseString(this.displayValue);
	        if (value) {
	          this.picker.value = value;
	          if (this.isValidValue(value)) {
	            this.emitInput(value);
	            this.userInput = null;
	          }
	        }
	      }
	      if (this.userInput === '') {
	        this.emitInput(null);
	        this.emitChange(null);
	        this.userInput = null;
	      }
	    },
	    handleStartInput: function handleStartInput(event) {
	      if (this.userInput) {
	        this.userInput = [event.target.value, this.userInput[1]];
	      } else {
	        this.userInput = [event.target.value, null];
	      }
	    },
	    handleEndInput: function handleEndInput(event) {
	      if (this.userInput) {
	        this.userInput = [this.userInput[0], event.target.value];
	      } else {
	        this.userInput = [null, event.target.value];
	      }
	    },
	    handleStartChange: function handleStartChange(event) {
	      var value = this.parseString(this.userInput && this.userInput[0]);
	      if (value) {
	        this.userInput = [this.formatToString(value), this.displayValue[1]];
	        var newValue = [value, this.picker.value && this.picker.value[1]];
	        this.picker.value = newValue;
	        if (this.isValidValue(newValue)) {
	          this.emitInput(newValue);
	          this.userInput = null;
	        }
	      }
	    },
	    handleEndChange: function handleEndChange(event) {
	      var value = this.parseString(this.userInput && this.userInput[1]);
	      if (value) {
	        this.userInput = [this.displayValue[0], this.formatToString(value)];
	        var newValue = [this.picker.value && this.picker.value[0], value];
	        this.picker.value = newValue;
	        if (this.isValidValue(newValue)) {
	          this.emitInput(newValue);
	          this.userInput = null;
	        }
	      }
	    },
	    handleClickIcon: function handleClickIcon(event) {
	      if (this.readonly || this.pickerDisabled) return;
	      if (this.showClose) {
	        this.valueOnOpen = this.value;
	        event.stopPropagation();
	        this.emitInput(null);
	        this.emitChange(null);
	        this.showClose = false;
	        if (this.picker && typeof this.picker.handleClear === 'function') {
	          this.picker.handleClear();
	        }
	      } else {
	        this.pickerVisible = !this.pickerVisible;
	      }
	    },
	    handleClose: function handleClose() {
	      if (!this.pickerVisible) return;
	      this.pickerVisible = false;
	
	      if (this.type === 'dates') {
	        // restore to former value
	        var oldValue = parseAsFormatAndType(this.valueOnOpen, this.valueFormat, this.type, this.rangeSeparator) || this.valueOnOpen;
	        this.emitInput(oldValue);
	      }
	    },
	    handleFieldReset: function handleFieldReset(initialValue) {
	      this.userInput = initialValue === '' ? null : initialValue;
	    },
	    handleFocus: function handleFocus() {
	      var type = this.type;
	
	      if (HAVE_TRIGGER_TYPES.indexOf(type) !== -1 && !this.pickerVisible) {
	        this.pickerVisible = true;
	      }
	      this.$emit('focus', this);
	    },
	    handleKeydown: function handleKeydown(event) {
	      var _this = this;
	
	      var keyCode = event.keyCode;
	
	      // ESC
	      if (keyCode === 27) {
	        this.pickerVisible = false;
	        event.stopPropagation();
	        return;
	      }
	
	      // Tab
	      if (keyCode === 9) {
	        if (!this.ranged) {
	          this.handleChange();
	          this.pickerVisible = this.picker.visible = false;
	          this.blur();
	          event.stopPropagation();
	        } else {
	          // user may change focus between two input
	          setTimeout(function () {
	            if (_this.refInput.indexOf(document.activeElement) === -1) {
	              _this.pickerVisible = false;
	              _this.blur();
	              event.stopPropagation();
	            }
	          }, 0);
	        }
	        return;
	      }
	
	      // Enter
	      if (keyCode === 13) {
	        if (this.userInput === '' || this.isValidValue(this.parseString(this.displayValue))) {
	          this.handleChange();
	          this.pickerVisible = this.picker.visible = false;
	          this.blur();
	        }
	        event.stopPropagation();
	        return;
	      }
	
	      // if user is typing, do not let picker handle key input
	      if (this.userInput) {
	        event.stopPropagation();
	        return;
	      }
	
	      // delegate other keys to panel
	      if (this.picker && this.picker.handleKeydown) {
	        this.picker.handleKeydown(event);
	      }
	    },
	    handleRangeClick: function handleRangeClick() {
	      var type = this.type;
	
	      if (HAVE_TRIGGER_TYPES.indexOf(type) !== -1 && !this.pickerVisible) {
	        this.pickerVisible = true;
	      }
	      this.$emit('focus', this);
	    },
	    hidePicker: function hidePicker() {
	      if (this.picker) {
	        this.picker.resetView && this.picker.resetView();
	        this.pickerVisible = this.picker.visible = false;
	        this.destroyPopper();
	      }
	    },
	    showPicker: function showPicker() {
	      var _this2 = this;
	
	      if (this.$isServer) return;
	      if (!this.picker) {
	        this.mountPicker();
	      }
	      this.pickerVisible = this.picker.visible = true;
	
	      this.updatePopper();
	
	      this.picker.value = this.parsedValue;
	      this.picker.resetView && this.picker.resetView();
	
	      this.$nextTick(function () {
	        _this2.picker.adjustSpinners && _this2.picker.adjustSpinners();
	      });
	    },
	    mountPicker: function mountPicker() {
	      var _this3 = this;
	
	      this.picker = new external_vue_default.a(this.panel).$mount();
	      this.picker.defaultValue = this.defaultValue;
	      this.picker.defaultTime = this.defaultTime;
	      this.picker.popperClass = this.popperClass;
	      this.popperElm = this.picker.$el;
	      this.picker.width = this.reference.getBoundingClientRect().width;
	      this.picker.showTime = this.type === 'datetime' || this.type === 'datetimerange';
	      this.picker.selectionMode = this.selectionMode;
	      this.picker.unlinkPanels = this.unlinkPanels;
	      this.picker.arrowControl = this.arrowControl || this.timeArrowControl || false;
	      this.$watch('format', function (format) {
	        _this3.picker.format = format;
	      });
	
	      var updateOptions = function updateOptions() {
	        var options = _this3.pickerOptions;
	
	        if (options && options.selectableRange) {
	          var ranges = options.selectableRange;
	          var parser = TYPE_VALUE_RESOLVER_MAP.datetimerange.parser;
	          var format = DEFAULT_FORMATS.timerange;
	
	          ranges = Array.isArray(ranges) ? ranges : [ranges];
	          _this3.picker.selectableRange = ranges.map(function (range) {
	            return parser(range, format, _this3.rangeSeparator);
	          });
	        }
	
	        for (var option in options) {
	          if (options.hasOwnProperty(option) &&
	          // 忽略 time-picker 的该配置项
	          option !== 'selectableRange') {
	            _this3.picker[option] = options[option];
	          }
	        }
	
	        // main format must prevail over undocumented pickerOptions.format
	        if (_this3.format) {
	          _this3.picker.format = _this3.format;
	        }
	      };
	      updateOptions();
	      this.unwatchPickerOptions = this.$watch('pickerOptions', function () {
	        return updateOptions();
	      }, { deep: true });
	      this.$el.appendChild(this.picker.$el);
	      this.picker.resetView && this.picker.resetView();
	
	      this.picker.$on('dodestroy', this.doDestroy);
	      this.picker.$on('pick', function () {
	        var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	        var visible = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	        _this3.userInput = null;
	        _this3.pickerVisible = _this3.picker.visible = visible;
	        _this3.emitInput(date);
	        _this3.picker.resetView && _this3.picker.resetView();
	      });
	
	      this.picker.$on('select-range', function (start, end, pos) {
	        if (_this3.refInput.length === 0) return;
	        if (!pos || pos === 'min') {
	          _this3.refInput[0].setSelectionRange(start, end);
	          _this3.refInput[0].focus();
	        } else if (pos === 'max') {
	          _this3.refInput[1].setSelectionRange(start, end);
	          _this3.refInput[1].focus();
	        }
	      });
	    },
	    unmountPicker: function unmountPicker() {
	      if (this.picker) {
	        this.picker.$destroy();
	        this.picker.$off();
	        if (typeof this.unwatchPickerOptions === 'function') {
	          this.unwatchPickerOptions();
	        }
	        this.picker.$el.parentNode.removeChild(this.picker.$el);
	      }
	    },
	    emitChange: function emitChange(val) {
	      // determine user real change only
	      if (!valueEquals(val, this.valueOnOpen)) {
	        this.$emit('change', val);
	        this.valueOnOpen = val;
	        if (this.validateEvent) {
	          this.dispatch('ElFormItem', 'el.form.change', val);
	        }
	      }
	    },
	    emitInput: function emitInput(val) {
	      var formatted = this.formatToValue(val);
	      if (!valueEquals(this.value, formatted)) {
	        this.$emit('input', formatted);
	      }
	    },
	    isValidValue: function isValidValue(value) {
	      if (!this.picker) {
	        this.mountPicker();
	      }
	      if (this.picker.isValidValue) {
	        return value && this.picker.isValidValue(value);
	      } else {
	        return true;
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/date-picker/src/picker.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_pickervue_type_script_lang_js_ = (pickervue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/date-picker/src/picker.vue
	
	
	
	
	
	/* normalize component */
	
	var picker_component = normalizeComponent(
	  src_pickervue_type_script_lang_js_,
	  pickervue_type_template_id_79ae069f_render,
	  pickervue_type_template_id_79ae069f_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var picker_api; }
	picker_component.options.__file = "packages/date-picker/src/picker.vue"
	/* harmony default export */ var picker = (picker_component.exports);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/date.vue?vue&type=template&id=2440d4ea&
	var datevue_type_template_id_2440d4ea_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "transition",
	    {
	      attrs: { name: "el-zoom-in-top" },
	      on: { "after-enter": _vm.handleEnter, "after-leave": _vm.handleLeave }
	    },
	    [
	      _c(
	        "div",
	        {
	          directives: [
	            {
	              name: "show",
	              rawName: "v-show",
	              value: _vm.visible,
	              expression: "visible"
	            }
	          ],
	          staticClass: "el-picker-panel el-date-picker el-popper",
	          class: [
	            {
	              "has-sidebar": _vm.$slots.sidebar || _vm.shortcuts,
	              "has-time": _vm.showTime
	            },
	            _vm.popperClass
	          ]
	        },
	        [
	          _c(
	            "div",
	            { staticClass: "el-picker-panel__body-wrapper" },
	            [
	              _vm._t("sidebar"),
	              _vm.shortcuts
	                ? _c(
	                    "div",
	                    { staticClass: "el-picker-panel__sidebar" },
	                    _vm._l(_vm.shortcuts, function(shortcut, key) {
	                      return _c(
	                        "button",
	                        {
	                          key: key,
	                          staticClass: "el-picker-panel__shortcut",
	                          attrs: { type: "button" },
	                          on: {
	                            click: function($event) {
	                              _vm.handleShortcutClick(shortcut)
	                            }
	                          }
	                        },
	                        [_vm._v(_vm._s(shortcut.text))]
	                      )
	                    }),
	                    0
	                  )
	                : _vm._e(),
	              _c("div", { staticClass: "el-picker-panel__body" }, [
	                _vm.showTime
	                  ? _c("div", { staticClass: "el-date-picker__time-header" }, [
	                      _c(
	                        "span",
	                        { staticClass: "el-date-picker__editor-wrap" },
	                        [
	                          _c("el-input", {
	                            attrs: {
	                              placeholder: _vm.t("el.datepicker.selectDate"),
	                              value: _vm.visibleDate,
	                              size: "small"
	                            },
	                            on: {
	                              input: function(val) {
	                                return (_vm.userInputDate = val)
	                              },
	                              change: _vm.handleVisibleDateChange
	                            }
	                          })
	                        ],
	                        1
	                      ),
	                      _c(
	                        "span",
	                        {
	                          directives: [
	                            {
	                              name: "clickoutside",
	                              rawName: "v-clickoutside",
	                              value: _vm.handleTimePickClose,
	                              expression: "handleTimePickClose"
	                            }
	                          ],
	                          staticClass: "el-date-picker__editor-wrap"
	                        },
	                        [
	                          _c("el-input", {
	                            ref: "input",
	                            attrs: {
	                              placeholder: _vm.t("el.datepicker.selectTime"),
	                              value: _vm.visibleTime,
	                              size: "small"
	                            },
	                            on: {
	                              focus: function($event) {
	                                _vm.timePickerVisible = true
	                              },
	                              input: function(val) {
	                                return (_vm.userInputTime = val)
	                              },
	                              change: _vm.handleVisibleTimeChange
	                            }
	                          }),
	                          _c("time-picker", {
	                            ref: "timepicker",
	                            attrs: {
	                              "time-arrow-control": _vm.arrowControl,
	                              visible: _vm.timePickerVisible
	                            },
	                            on: {
	                              pick: _vm.handleTimePick,
	                              mounted: _vm.proxyTimePickerDataProperties
	                            }
	                          })
	                        ],
	                        1
	                      )
	                    ])
	                  : _vm._e(),
	                _c(
	                  "div",
	                  {
	                    directives: [
	                      {
	                        name: "show",
	                        rawName: "v-show",
	                        value: _vm.currentView !== "time",
	                        expression: "currentView !== 'time'"
	                      }
	                    ],
	                    staticClass: "el-date-picker__header",
	                    class: {
	                      "el-date-picker__header--bordered":
	                        _vm.currentView === "year" ||
	                        _vm.currentView === "month"
	                    }
	                  },
	                  [
	                    _c("button", {
	                      staticClass:
	                        "el-picker-panel__icon-btn el-date-picker__prev-btn el-icon-d-arrow-left",
	                      attrs: {
	                        type: "button",
	                        "aria-label": _vm.t("el.datepicker.prevYear")
	                      },
	                      on: { click: _vm.prevYear }
	                    }),
	                    _c("button", {
	                      directives: [
	                        {
	                          name: "show",
	                          rawName: "v-show",
	                          value: _vm.currentView === "date",
	                          expression: "currentView === 'date'"
	                        }
	                      ],
	                      staticClass:
	                        "el-picker-panel__icon-btn el-date-picker__prev-btn el-icon-arrow-left",
	                      attrs: {
	                        type: "button",
	                        "aria-label": _vm.t("el.datepicker.prevMonth")
	                      },
	                      on: { click: _vm.prevMonth }
	                    }),
	                    _c(
	                      "span",
	                      {
	                        staticClass: "el-date-picker__header-label",
	                        attrs: { role: "button" },
	                        on: { click: _vm.showYearPicker }
	                      },
	                      [_vm._v(_vm._s(_vm.yearLabel))]
	                    ),
	                    _c(
	                      "span",
	                      {
	                        directives: [
	                          {
	                            name: "show",
	                            rawName: "v-show",
	                            value: _vm.currentView === "date",
	                            expression: "currentView === 'date'"
	                          }
	                        ],
	                        staticClass: "el-date-picker__header-label",
	                        class: { active: _vm.currentView === "month" },
	                        attrs: { role: "button" },
	                        on: { click: _vm.showMonthPicker }
	                      },
	                      [
	                        _vm._v(
	                          _vm._s(_vm.t("el.datepicker.month" + (_vm.month + 1)))
	                        )
	                      ]
	                    ),
	                    _c("button", {
	                      staticClass:
	                        "el-picker-panel__icon-btn el-date-picker__next-btn el-icon-d-arrow-right",
	                      attrs: {
	                        type: "button",
	                        "aria-label": _vm.t("el.datepicker.nextYear")
	                      },
	                      on: { click: _vm.nextYear }
	                    }),
	                    _c("button", {
	                      directives: [
	                        {
	                          name: "show",
	                          rawName: "v-show",
	                          value: _vm.currentView === "date",
	                          expression: "currentView === 'date'"
	                        }
	                      ],
	                      staticClass:
	                        "el-picker-panel__icon-btn el-date-picker__next-btn el-icon-arrow-right",
	                      attrs: {
	                        type: "button",
	                        "aria-label": _vm.t("el.datepicker.nextMonth")
	                      },
	                      on: { click: _vm.nextMonth }
	                    })
	                  ]
	                ),
	                _c(
	                  "div",
	                  { staticClass: "el-picker-panel__content" },
	                  [
	                    _c("date-table", {
	                      directives: [
	                        {
	                          name: "show",
	                          rawName: "v-show",
	                          value: _vm.currentView === "date",
	                          expression: "currentView === 'date'"
	                        }
	                      ],
	                      attrs: {
	                        "selection-mode": _vm.selectionMode,
	                        "first-day-of-week": _vm.firstDayOfWeek,
	                        value: _vm.value,
	                        "default-value": _vm.defaultValue
	                          ? new Date(_vm.defaultValue)
	                          : null,
	                        date: _vm.date,
	                        "cell-class-name": _vm.cellClassName,
	                        "disabled-date": _vm.disabledDate
	                      },
	                      on: { pick: _vm.handleDatePick }
	                    }),
	                    _c("year-table", {
	                      directives: [
	                        {
	                          name: "show",
	                          rawName: "v-show",
	                          value: _vm.currentView === "year",
	                          expression: "currentView === 'year'"
	                        }
	                      ],
	                      attrs: {
	                        value: _vm.value,
	                        "default-value": _vm.defaultValue
	                          ? new Date(_vm.defaultValue)
	                          : null,
	                        date: _vm.date,
	                        "disabled-date": _vm.disabledDate
	                      },
	                      on: { pick: _vm.handleYearPick }
	                    }),
	                    _c("month-table", {
	                      directives: [
	                        {
	                          name: "show",
	                          rawName: "v-show",
	                          value: _vm.currentView === "month",
	                          expression: "currentView === 'month'"
	                        }
	                      ],
	                      attrs: {
	                        value: _vm.value,
	                        "default-value": _vm.defaultValue
	                          ? new Date(_vm.defaultValue)
	                          : null,
	                        date: _vm.date,
	                        "disabled-date": _vm.disabledDate
	                      },
	                      on: { pick: _vm.handleMonthPick }
	                    })
	                  ],
	                  1
	                )
	              ])
	            ],
	            2
	          ),
	          _c(
	            "div",
	            {
	              directives: [
	                {
	                  name: "show",
	                  rawName: "v-show",
	                  value: _vm.footerVisible && _vm.currentView === "date",
	                  expression: "footerVisible && currentView === 'date'"
	                }
	              ],
	              staticClass: "el-picker-panel__footer"
	            },
	            [
	              _c(
	                "el-button",
	                {
	                  directives: [
	                    {
	                      name: "show",
	                      rawName: "v-show",
	                      value: _vm.selectionMode !== "dates",
	                      expression: "selectionMode !== 'dates'"
	                    }
	                  ],
	                  staticClass: "el-picker-panel__link-btn",
	                  attrs: { size: "mini", type: "text" },
	                  on: { click: _vm.changeToNow }
	                },
	                [
	                  _vm._v(
	                    "\n        " +
	                      _vm._s(_vm.t("el.datepicker.now")) +
	                      "\n      "
	                  )
	                ]
	              ),
	              _c(
	                "el-button",
	                {
	                  staticClass: "el-picker-panel__link-btn",
	                  attrs: { plain: "", size: "mini" },
	                  on: { click: _vm.confirm }
	                },
	                [
	                  _vm._v(
	                    "\n        " +
	                      _vm._s(_vm.t("el.datepicker.confirm")) +
	                      "\n      "
	                  )
	                ]
	              )
	            ],
	            1
	          )
	        ]
	      )
	    ]
	  )
	}
	var datevue_type_template_id_2440d4ea_staticRenderFns = []
	datevue_type_template_id_2440d4ea_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/date.vue?vue&type=template&id=2440d4ea&
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/time.vue?vue&type=template&id=3d939089&
	var timevue_type_template_id_3d939089_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "transition",
	    {
	      attrs: { name: "el-zoom-in-top" },
	      on: {
	        "after-leave": function($event) {
	          _vm.$emit("dodestroy")
	        }
	      }
	    },
	    [
	      _c(
	        "div",
	        {
	          directives: [
	            {
	              name: "show",
	              rawName: "v-show",
	              value: _vm.visible,
	              expression: "visible"
	            }
	          ],
	          staticClass: "el-time-panel el-popper",
	          class: _vm.popperClass
	        },
	        [
	          _c(
	            "div",
	            {
	              staticClass: "el-time-panel__content",
	              class: { "has-seconds": _vm.showSeconds }
	            },
	            [
	              _c("time-spinner", {
	                ref: "spinner",
	                attrs: {
	                  "arrow-control": _vm.useArrow,
	                  "show-seconds": _vm.showSeconds,
	                  "am-pm-mode": _vm.amPmMode,
	                  date: _vm.date
	                },
	                on: {
	                  change: _vm.handleChange,
	                  "select-range": _vm.setSelectionRange
	                }
	              })
	            ],
	            1
	          ),
	          _c("div", { staticClass: "el-time-panel__footer" }, [
	            _c(
	              "button",
	              {
	                staticClass: "el-time-panel__btn cancel",
	                attrs: { type: "button" },
	                on: { click: _vm.handleCancel }
	              },
	              [_vm._v(_vm._s(_vm.t("el.datepicker.cancel")))]
	            ),
	            _c(
	              "button",
	              {
	                staticClass: "el-time-panel__btn",
	                class: { confirm: !_vm.disabled },
	                attrs: { type: "button" },
	                on: {
	                  click: function($event) {
	                    _vm.handleConfirm()
	                  }
	                }
	              },
	              [_vm._v(_vm._s(_vm.t("el.datepicker.confirm")))]
	            )
	          ])
	        ]
	      )
	    ]
	  )
	}
	var timevue_type_template_id_3d939089_staticRenderFns = []
	timevue_type_template_id_3d939089_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/time.vue?vue&type=template&id=3d939089&
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/basic/time-spinner.vue?vue&type=template&id=1facadeb&
	var time_spinnervue_type_template_id_1facadeb_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-time-spinner",
	      class: { "has-seconds": _vm.showSeconds }
	    },
	    [
	      !_vm.arrowControl
	        ? [
	            _c(
	              "el-scrollbar",
	              {
	                ref: "hours",
	                staticClass: "el-time-spinner__wrapper",
	                attrs: {
	                  "wrap-style": "max-height: inherit;",
	                  "view-class": "el-time-spinner__list",
	                  noresize: "",
	                  tag: "ul"
	                },
	                nativeOn: {
	                  mouseenter: function($event) {
	                    _vm.emitSelectRange("hours")
	                  },
	                  mousemove: function($event) {
	                    _vm.adjustCurrentSpinner("hours")
	                  }
	                }
	              },
	              _vm._l(_vm.hoursList, function(disabled, hour) {
	                return _c(
	                  "li",
	                  {
	                    key: hour,
	                    staticClass: "el-time-spinner__item",
	                    class: { active: hour === _vm.hours, disabled: disabled },
	                    on: {
	                      click: function($event) {
	                        _vm.handleClick("hours", {
	                          value: hour,
	                          disabled: disabled
	                        })
	                      }
	                    }
	                  },
	                  [
	                    _vm._v(
	                      _vm._s(
	                        ("0" + (_vm.amPmMode ? hour % 12 || 12 : hour)).slice(
	                          -2
	                        )
	                      ) + _vm._s(_vm.amPm(hour))
	                    )
	                  ]
	                )
	              }),
	              0
	            ),
	            _c(
	              "el-scrollbar",
	              {
	                ref: "minutes",
	                staticClass: "el-time-spinner__wrapper",
	                attrs: {
	                  "wrap-style": "max-height: inherit;",
	                  "view-class": "el-time-spinner__list",
	                  noresize: "",
	                  tag: "ul"
	                },
	                nativeOn: {
	                  mouseenter: function($event) {
	                    _vm.emitSelectRange("minutes")
	                  },
	                  mousemove: function($event) {
	                    _vm.adjustCurrentSpinner("minutes")
	                  }
	                }
	              },
	              _vm._l(_vm.minutesList, function(enabled, key) {
	                return _c(
	                  "li",
	                  {
	                    key: key,
	                    staticClass: "el-time-spinner__item",
	                    class: { active: key === _vm.minutes, disabled: !enabled },
	                    on: {
	                      click: function($event) {
	                        _vm.handleClick("minutes", {
	                          value: key,
	                          disabled: false
	                        })
	                      }
	                    }
	                  },
	                  [_vm._v(_vm._s(("0" + key).slice(-2)))]
	                )
	              }),
	              0
	            ),
	            _c(
	              "el-scrollbar",
	              {
	                directives: [
	                  {
	                    name: "show",
	                    rawName: "v-show",
	                    value: _vm.showSeconds,
	                    expression: "showSeconds"
	                  }
	                ],
	                ref: "seconds",
	                staticClass: "el-time-spinner__wrapper",
	                attrs: {
	                  "wrap-style": "max-height: inherit;",
	                  "view-class": "el-time-spinner__list",
	                  noresize: "",
	                  tag: "ul"
	                },
	                nativeOn: {
	                  mouseenter: function($event) {
	                    _vm.emitSelectRange("seconds")
	                  },
	                  mousemove: function($event) {
	                    _vm.adjustCurrentSpinner("seconds")
	                  }
	                }
	              },
	              _vm._l(60, function(second, key) {
	                return _c(
	                  "li",
	                  {
	                    key: key,
	                    staticClass: "el-time-spinner__item",
	                    class: { active: key === _vm.seconds },
	                    on: {
	                      click: function($event) {
	                        _vm.handleClick("seconds", {
	                          value: key,
	                          disabled: false
	                        })
	                      }
	                    }
	                  },
	                  [_vm._v(_vm._s(("0" + key).slice(-2)))]
	                )
	              }),
	              0
	            )
	          ]
	        : _vm._e(),
	      _vm.arrowControl
	        ? [
	            _c(
	              "div",
	              {
	                staticClass: "el-time-spinner__wrapper is-arrow",
	                on: {
	                  mouseenter: function($event) {
	                    _vm.emitSelectRange("hours")
	                  }
	                }
	              },
	              [
	                _c("i", {
	                  directives: [
	                    {
	                      name: "repeat-click",
	                      rawName: "v-repeat-click",
	                      value: _vm.decrease,
	                      expression: "decrease"
	                    }
	                  ],
	                  staticClass: "el-time-spinner__arrow el-icon-arrow-up"
	                }),
	                _c("i", {
	                  directives: [
	                    {
	                      name: "repeat-click",
	                      rawName: "v-repeat-click",
	                      value: _vm.increase,
	                      expression: "increase"
	                    }
	                  ],
	                  staticClass: "el-time-spinner__arrow el-icon-arrow-down"
	                }),
	                _c(
	                  "ul",
	                  { ref: "hours", staticClass: "el-time-spinner__list" },
	                  _vm._l(_vm.arrowHourList, function(hour, key) {
	                    return _c(
	                      "li",
	                      {
	                        key: key,
	                        staticClass: "el-time-spinner__item",
	                        class: {
	                          active: hour === _vm.hours,
	                          disabled: _vm.hoursList[hour]
	                        }
	                      },
	                      [
	                        _vm._v(
	                          _vm._s(
	                            hour === undefined
	                              ? ""
	                              : (
	                                  "0" + (_vm.amPmMode ? hour % 12 || 12 : hour)
	                                ).slice(-2) + _vm.amPm(hour)
	                          )
	                        )
	                      ]
	                    )
	                  }),
	                  0
	                )
	              ]
	            ),
	            _c(
	              "div",
	              {
	                staticClass: "el-time-spinner__wrapper is-arrow",
	                on: {
	                  mouseenter: function($event) {
	                    _vm.emitSelectRange("minutes")
	                  }
	                }
	              },
	              [
	                _c("i", {
	                  directives: [
	                    {
	                      name: "repeat-click",
	                      rawName: "v-repeat-click",
	                      value: _vm.decrease,
	                      expression: "decrease"
	                    }
	                  ],
	                  staticClass: "el-time-spinner__arrow el-icon-arrow-up"
	                }),
	                _c("i", {
	                  directives: [
	                    {
	                      name: "repeat-click",
	                      rawName: "v-repeat-click",
	                      value: _vm.increase,
	                      expression: "increase"
	                    }
	                  ],
	                  staticClass: "el-time-spinner__arrow el-icon-arrow-down"
	                }),
	                _c(
	                  "ul",
	                  { ref: "minutes", staticClass: "el-time-spinner__list" },
	                  _vm._l(_vm.arrowMinuteList, function(minute, key) {
	                    return _c(
	                      "li",
	                      {
	                        key: key,
	                        staticClass: "el-time-spinner__item",
	                        class: { active: minute === _vm.minutes }
	                      },
	                      [
	                        _vm._v(
	                          "\n          " +
	                            _vm._s(
	                              minute === undefined
	                                ? ""
	                                : ("0" + minute).slice(-2)
	                            ) +
	                            "\n        "
	                        )
	                      ]
	                    )
	                  }),
	                  0
	                )
	              ]
	            ),
	            _vm.showSeconds
	              ? _c(
	                  "div",
	                  {
	                    staticClass: "el-time-spinner__wrapper is-arrow",
	                    on: {
	                      mouseenter: function($event) {
	                        _vm.emitSelectRange("seconds")
	                      }
	                    }
	                  },
	                  [
	                    _c("i", {
	                      directives: [
	                        {
	                          name: "repeat-click",
	                          rawName: "v-repeat-click",
	                          value: _vm.decrease,
	                          expression: "decrease"
	                        }
	                      ],
	                      staticClass: "el-time-spinner__arrow el-icon-arrow-up"
	                    }),
	                    _c("i", {
	                      directives: [
	                        {
	                          name: "repeat-click",
	                          rawName: "v-repeat-click",
	                          value: _vm.increase,
	                          expression: "increase"
	                        }
	                      ],
	                      staticClass: "el-time-spinner__arrow el-icon-arrow-down"
	                    }),
	                    _c(
	                      "ul",
	                      { ref: "seconds", staticClass: "el-time-spinner__list" },
	                      _vm._l(_vm.arrowSecondList, function(second, key) {
	                        return _c(
	                          "li",
	                          {
	                            key: key,
	                            staticClass: "el-time-spinner__item",
	                            class: { active: second === _vm.seconds }
	                          },
	                          [
	                            _vm._v(
	                              "\n          " +
	                                _vm._s(
	                                  second === undefined
	                                    ? ""
	                                    : ("0" + second).slice(-2)
	                                ) +
	                                "\n        "
	                            )
	                          ]
	                        )
	                      }),
	                      0
	                    )
	                  ]
	                )
	              : _vm._e()
	          ]
	        : _vm._e()
	    ],
	    2
	  )
	}
	var time_spinnervue_type_template_id_1facadeb_staticRenderFns = []
	time_spinnervue_type_template_id_1facadeb_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/date-picker/src/basic/time-spinner.vue?vue&type=template&id=1facadeb&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/basic/time-spinner.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	/* harmony default export */ var time_spinnervue_type_script_lang_js_ = ({
	  components: { ElScrollbar: scrollbar_default.a },
	
	  directives: {
	    repeatClick: repeat_click
	  },
	
	  props: {
	    date: {},
	    defaultValue: {}, // reserved for future use
	    showSeconds: {
	      type: Boolean,
	      default: true
	    },
	    arrowControl: Boolean,
	    amPmMode: {
	      type: String,
	      default: '' // 'a': am/pm; 'A': AM/PM
	    }
	  },
	
	  computed: {
	    hours: function hours() {
	      return this.date.getHours();
	    },
	    minutes: function minutes() {
	      return this.date.getMinutes();
	    },
	    seconds: function seconds() {
	      return this.date.getSeconds();
	    },
	    hoursList: function hoursList() {
	      return Object(date_util_["getRangeHours"])(this.selectableRange);
	    },
	    minutesList: function minutesList() {
	      return Object(date_util_["getRangeMinutes"])(this.selectableRange, this.hours);
	    },
	    arrowHourList: function arrowHourList() {
	      var hours = this.hours;
	      return [hours > 0 ? hours - 1 : undefined, hours, hours < 23 ? hours + 1 : undefined];
	    },
	    arrowMinuteList: function arrowMinuteList() {
	      var minutes = this.minutes;
	      return [minutes > 0 ? minutes - 1 : undefined, minutes, minutes < 59 ? minutes + 1 : undefined];
	    },
	    arrowSecondList: function arrowSecondList() {
	      var seconds = this.seconds;
	      return [seconds > 0 ? seconds - 1 : undefined, seconds, seconds < 59 ? seconds + 1 : undefined];
	    }
	  },
	
	  data: function data() {
	    return {
	      selectableRange: [],
	      currentScrollbar: null
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    this.$nextTick(function () {
	      !_this.arrowControl && _this.bindScrollEvent();
	    });
	  },
	
	
	  methods: {
	    increase: function increase() {
	      this.scrollDown(1);
	    },
	    decrease: function decrease() {
	      this.scrollDown(-1);
	    },
	    modifyDateField: function modifyDateField(type, value) {
	      switch (type) {
	        case 'hours':
	          this.$emit('change', Object(date_util_["modifyTime"])(this.date, value, this.minutes, this.seconds));break;
	        case 'minutes':
	          this.$emit('change', Object(date_util_["modifyTime"])(this.date, this.hours, value, this.seconds));break;
	        case 'seconds':
	          this.$emit('change', Object(date_util_["modifyTime"])(this.date, this.hours, this.minutes, value));break;
	      }
	    },
	    handleClick: function handleClick(type, _ref) {
	      var value = _ref.value,
	          disabled = _ref.disabled;
	
	      if (!disabled) {
	        this.modifyDateField(type, value);
	        this.emitSelectRange(type);
	        this.adjustSpinner(type, value);
	      }
	    },
	    emitSelectRange: function emitSelectRange(type) {
	      if (type === 'hours') {
	        this.$emit('select-range', 0, 2);
	      } else if (type === 'minutes') {
	        this.$emit('select-range', 3, 5);
	      } else if (type === 'seconds') {
	        this.$emit('select-range', 6, 8);
	      }
	      this.currentScrollbar = type;
	    },
	    bindScrollEvent: function bindScrollEvent() {
	      var _this2 = this;
	
	      var bindFuntion = function bindFuntion(type) {
	        _this2.$refs[type].wrap.onscroll = function (e) {
	          // TODO: scroll is emitted when set scrollTop programatically
	          // should find better solutions in the future!
	          _this2.handleScroll(type, e);
	        };
	      };
	      bindFuntion('hours');
	      bindFuntion('minutes');
	      bindFuntion('seconds');
	    },
	    handleScroll: function handleScroll(type) {
	      var value = Math.min(Math.round((this.$refs[type].wrap.scrollTop - (this.scrollBarHeight(type) * 0.5 - 10) / this.typeItemHeight(type) + 3) / this.typeItemHeight(type)), type === 'hours' ? 23 : 59);
	      this.modifyDateField(type, value);
	    },
	
	
	    // NOTE: used by datetime / date-range panel
	    //       renamed from adjustScrollTop
	    //       should try to refactory it
	    adjustSpinners: function adjustSpinners() {
	      this.adjustSpinner('hours', this.hours);
	      this.adjustSpinner('minutes', this.minutes);
	      this.adjustSpinner('seconds', this.seconds);
	    },
	    adjustCurrentSpinner: function adjustCurrentSpinner(type) {
	      this.adjustSpinner(type, this[type]);
	    },
	    adjustSpinner: function adjustSpinner(type, value) {
	      if (this.arrowControl) return;
	      var el = this.$refs[type].wrap;
	      if (el) {
	        el.scrollTop = Math.max(0, value * this.typeItemHeight(type));
	      }
	    },
	    scrollDown: function scrollDown(step) {
	      var _this3 = this;
	
	      if (!this.currentScrollbar) {
	        this.emitSelectRange('hours');
	      }
	
	      var label = this.currentScrollbar;
	      var hoursList = this.hoursList;
	      var now = this[label];
	
	      if (this.currentScrollbar === 'hours') {
	        var total = Math.abs(step);
	        step = step > 0 ? 1 : -1;
	        var length = hoursList.length;
	        while (length-- && total) {
	          now = (now + step + hoursList.length) % hoursList.length;
	          if (hoursList[now]) {
	            continue;
	          }
	          total--;
	        }
	        if (hoursList[now]) return;
	      } else {
	        now = (now + step + 60) % 60;
	      }
	
	      this.modifyDateField(label, now);
	      this.adjustSpinner(label, now);
	      this.$nextTick(function () {
	        return _this3.emitSelectRange(_this3.currentScrollbar);
	      });
	    },
	    amPm: function amPm(hour) {
	      var shouldShowAmPm = this.amPmMode.toLowerCase() === 'a';
	      if (!shouldShowAmPm) return '';
	      var isCapital = this.amPmMode === 'A';
	      var content = hour < 12 ? ' am' : ' pm';
	      if (isCapital) content = content.toUpperCase();
	      return content;
	    },
	    typeItemHeight: function typeItemHeight(type) {
	      return this.$refs[type].$el.querySelector('li').offsetHeight;
	    },
	    scrollBarHeight: function scrollBarHeight(type) {
	      return this.$refs[type].$el.offsetHeight;
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/date-picker/src/basic/time-spinner.vue?vue&type=script&lang=js&
	 /* harmony default export */ var basic_time_spinnervue_type_script_lang_js_ = (time_spinnervue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/date-picker/src/basic/time-spinner.vue
	
	
	
	
	
	/* normalize component */
	
	var time_spinner_component = normalizeComponent(
	  basic_time_spinnervue_type_script_lang_js_,
	  time_spinnervue_type_template_id_1facadeb_render,
	  time_spinnervue_type_template_id_1facadeb_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var time_spinner_api; }
	time_spinner_component.options.__file = "packages/date-picker/src/basic/time-spinner.vue"
	/* harmony default export */ var time_spinner = (time_spinner_component.exports);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/time.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	/* harmony default export */ var timevue_type_script_lang_js_ = ({
	  mixins: [locale_default.a],
	
	  components: {
	    TimeSpinner: time_spinner
	  },
	
	  props: {
	    visible: Boolean,
	    timeArrowControl: Boolean
	  },
	
	  watch: {
	    visible: function visible(val) {
	      var _this = this;
	
	      if (val) {
	        this.oldValue = this.value;
	        this.$nextTick(function () {
	          return _this.$refs.spinner.emitSelectRange('hours');
	        });
	      } else {
	        this.needInitAdjust = true;
	      }
	    },
	    value: function value(newVal) {
	      var _this2 = this;
	
	      var date = void 0;
	      if (newVal instanceof Date) {
	        date = Object(date_util_["limitTimeRange"])(newVal, this.selectableRange, this.format);
	      } else if (!newVal) {
	        date = this.defaultValue ? new Date(this.defaultValue) : new Date();
	      }
	
	      this.date = date;
	      if (this.visible && this.needInitAdjust) {
	        this.$nextTick(function (_) {
	          return _this2.adjustSpinners();
	        });
	        this.needInitAdjust = false;
	      }
	    },
	    selectableRange: function selectableRange(val) {
	      this.$refs.spinner.selectableRange = val;
	    },
	    defaultValue: function defaultValue(val) {
	      if (!Object(date_util_["isDate"])(this.value)) {
	        this.date = val ? new Date(val) : new Date();
	      }
	    }
	  },
	
	  data: function data() {
	    return {
	      popperClass: '',
	      format: 'HH:mm:ss',
	      value: '',
	      defaultValue: null,
	      date: new Date(),
	      oldValue: new Date(),
	      selectableRange: [],
	      selectionRange: [0, 2],
	      disabled: false,
	      arrowControl: false,
	      needInitAdjust: true
	    };
	  },
	
	
	  computed: {
	    showSeconds: function showSeconds() {
	      return (this.format || '').indexOf('ss') !== -1;
	    },
	    useArrow: function useArrow() {
	      return this.arrowControl || this.timeArrowControl || false;
	    },
	    amPmMode: function amPmMode() {
	      if ((this.format || '').indexOf('A') !== -1) return 'A';
	      if ((this.format || '').indexOf('a') !== -1) return 'a';
	      return '';
	    }
	  },
	
	  methods: {
	    handleCancel: function handleCancel() {
	      this.$emit('pick', this.oldValue, false);
	    },
	    handleChange: function handleChange(date) {
	      // this.visible avoids edge cases, when use scrolls during panel closing animation
	      if (this.visible) {
	        this.date = Object(date_util_["clearMilliseconds"])(date);
	        // if date is out of range, do not emit
	        if (this.isValidValue(this.date)) {
	          this.$emit('pick', this.date, true);
	        }
	      }
	    },
	    setSelectionRange: function setSelectionRange(start, end) {
	      this.$emit('select-range', start, end);
	      this.selectionRange = [start, end];
	    },
	    handleConfirm: function handleConfirm() {
	      var visible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	      var first = arguments[1];
	
	      if (first) return;
	      var date = Object(date_util_["clearMilliseconds"])(Object(date_util_["limitTimeRange"])(this.date, this.selectableRange, this.format));
	      this.$emit('pick', date, visible, first);
	    },
	    handleKeydown: function handleKeydown(event) {
	      var keyCode = event.keyCode;
	      var mapping = { 38: -1, 40: 1, 37: -1, 39: 1 };
	
	      // Left or Right
	      if (keyCode === 37 || keyCode === 39) {
	        var step = mapping[keyCode];
	        this.changeSelectionRange(step);
	        event.preventDefault();
	        return;
	      }
	
	      // Up or Down
	      if (keyCode === 38 || keyCode === 40) {
	        var _step = mapping[keyCode];
	        this.$refs.spinner.scrollDown(_step);
	        event.preventDefault();
	        return;
	      }
	    },
	    isValidValue: function isValidValue(date) {
	      return Object(date_util_["timeWithinRange"])(date, this.selectableRange, this.format);
	    },
	    adjustSpinners: function adjustSpinners() {
	      return this.$refs.spinner.adjustSpinners();
	    },
	    changeSelectionRange: function changeSelectionRange(step) {
	      var list = [0, 3].concat(this.showSeconds ? [6] : []);
	      var mapping = ['hours', 'minutes'].concat(this.showSeconds ? ['seconds'] : []);
	      var index = list.indexOf(this.selectionRange[0]);
	      var next = (index + step + list.length) % list.length;
	      this.$refs.spinner.emitSelectRange(mapping[next]);
	    }
	  },
	
	  mounted: function mounted() {
	    var _this3 = this;
	
	    this.$nextTick(function () {
	      return _this3.handleConfirm(true, true);
	    });
	    this.$emit('mounted');
	  }
	});
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/time.vue?vue&type=script&lang=js&
	 /* harmony default export */ var panel_timevue_type_script_lang_js_ = (timevue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/time.vue
	
	
	
	
	
	/* normalize component */
	
	var time_component = normalizeComponent(
	  panel_timevue_type_script_lang_js_,
	  timevue_type_template_id_3d939089_render,
	  timevue_type_template_id_3d939089_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var time_api; }
	time_component.options.__file = "packages/date-picker/src/panel/time.vue"
	/* harmony default export */ var panel_time = (time_component.exports);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/basic/year-table.vue?vue&type=template&id=c86ab5e0&
	var year_tablevue_type_template_id_c86ab5e0_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "table",
	    { staticClass: "el-year-table", on: { click: _vm.handleYearTableClick } },
	    [
	      _c("tbody", [
	        _c("tr", [
	          _c(
	            "td",
	            {
	              staticClass: "available",
	              class: _vm.getCellStyle(_vm.startYear + 0)
	            },
	            [_c("a", { staticClass: "cell" }, [_vm._v(_vm._s(_vm.startYear))])]
	          ),
	          _c(
	            "td",
	            {
	              staticClass: "available",
	              class: _vm.getCellStyle(_vm.startYear + 1)
	            },
	            [
	              _c("a", { staticClass: "cell" }, [
	                _vm._v(_vm._s(_vm.startYear + 1))
	              ])
	            ]
	          ),
	          _c(
	            "td",
	            {
	              staticClass: "available",
	              class: _vm.getCellStyle(_vm.startYear + 2)
	            },
	            [
	              _c("a", { staticClass: "cell" }, [
	                _vm._v(_vm._s(_vm.startYear + 2))
	              ])
	            ]
	          ),
	          _c(
	            "td",
	            {
	              staticClass: "available",
	              class: _vm.getCellStyle(_vm.startYear + 3)
	            },
	            [
	              _c("a", { staticClass: "cell" }, [
	                _vm._v(_vm._s(_vm.startYear + 3))
	              ])
	            ]
	          )
	        ]),
	        _c("tr", [
	          _c(
	            "td",
	            {
	              staticClass: "available",
	              class: _vm.getCellStyle(_vm.startYear + 4)
	            },
	            [
	              _c("a", { staticClass: "cell" }, [
	                _vm._v(_vm._s(_vm.startYear + 4))
	              ])
	            ]
	          ),
	          _c(
	            "td",
	            {
	              staticClass: "available",
	              class: _vm.getCellStyle(_vm.startYear + 5)
	            },
	            [
	              _c("a", { staticClass: "cell" }, [
	                _vm._v(_vm._s(_vm.startYear + 5))
	              ])
	            ]
	          ),
	          _c(
	            "td",
	            {
	              staticClass: "available",
	              class: _vm.getCellStyle(_vm.startYear + 6)
	            },
	            [
	              _c("a", { staticClass: "cell" }, [
	                _vm._v(_vm._s(_vm.startYear + 6))
	              ])
	            ]
	          ),
	          _c(
	            "td",
	            {
	              staticClass: "available",
	              class: _vm.getCellStyle(_vm.startYear + 7)
	            },
	            [
	              _c("a", { staticClass: "cell" }, [
	                _vm._v(_vm._s(_vm.startYear + 7))
	              ])
	            ]
	          )
	        ]),
	        _c("tr", [
	          _c(
	            "td",
	            {
	              staticClass: "available",
	              class: _vm.getCellStyle(_vm.startYear + 8)
	            },
	            [
	              _c("a", { staticClass: "cell" }, [
	                _vm._v(_vm._s(_vm.startYear + 8))
	              ])
	            ]
	          ),
	          _c(
	            "td",
	            {
	              staticClass: "available",
	              class: _vm.getCellStyle(_vm.startYear + 9)
	            },
	            [
	              _c("a", { staticClass: "cell" }, [
	                _vm._v(_vm._s(_vm.startYear + 9))
	              ])
	            ]
	          ),
	          _c("td"),
	          _c("td")
	        ])
	      ])
	    ]
	  )
	}
	var year_tablevue_type_template_id_c86ab5e0_staticRenderFns = []
	year_tablevue_type_template_id_c86ab5e0_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/date-picker/src/basic/year-table.vue?vue&type=template&id=c86ab5e0&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/basic/year-table.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	var year_tablevue_type_script_lang_js_datesInYear = function datesInYear(year) {
	  var numOfDays = Object(date_util_["getDayCountOfYear"])(year);
	  var firstDay = new Date(year, 0, 1);
	  return Object(date_util_["range"])(numOfDays).map(function (n) {
	    return Object(date_util_["nextDate"])(firstDay, n);
	  });
	};
	
	/* harmony default export */ var year_tablevue_type_script_lang_js_ = ({
	  props: {
	    disabledDate: {},
	    value: {},
	    defaultValue: {
	      validator: function validator(val) {
	        // null or valid Date Object
	        return val === null || val instanceof Date && Object(date_util_["isDate"])(val);
	      }
	    },
	    date: {}
	  },
	
	  computed: {
	    startYear: function startYear() {
	      return Math.floor(this.date.getFullYear() / 10) * 10;
	    }
	  },
	
	  methods: {
	    getCellStyle: function getCellStyle(year) {
	      var style = {};
	      var today = new Date();
	
	      style.disabled = typeof this.disabledDate === 'function' ? year_tablevue_type_script_lang_js_datesInYear(year).every(this.disabledDate) : false;
	      style.current = Object(util_["arrayFindIndex"])(Object(util_["coerceTruthyValueToArray"])(this.value), function (date) {
	        return date.getFullYear() === year;
	      }) >= 0;
	      style.today = today.getFullYear() === year;
	      style.default = this.defaultValue && this.defaultValue.getFullYear() === year;
	
	      return style;
	    },
	    handleYearTableClick: function handleYearTableClick(event) {
	      var target = event.target;
	      if (target.tagName === 'A') {
	        if (Object(dom_["hasClass"])(target.parentNode, 'disabled')) return;
	        var year = target.textContent || target.innerText;
	        this.$emit('pick', Number(year));
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/date-picker/src/basic/year-table.vue?vue&type=script&lang=js&
	 /* harmony default export */ var basic_year_tablevue_type_script_lang_js_ = (year_tablevue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/date-picker/src/basic/year-table.vue
	
	
	
	
	
	/* normalize component */
	
	var year_table_component = normalizeComponent(
	  basic_year_tablevue_type_script_lang_js_,
	  year_tablevue_type_template_id_c86ab5e0_render,
	  year_tablevue_type_template_id_c86ab5e0_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var year_table_api; }
	year_table_component.options.__file = "packages/date-picker/src/basic/year-table.vue"
	/* harmony default export */ var year_table = (year_table_component.exports);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/basic/month-table.vue?vue&type=template&id=654d4f42&
	var month_tablevue_type_template_id_654d4f42_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "table",
	    {
	      staticClass: "el-month-table",
	      on: { click: _vm.handleMonthTableClick, mousemove: _vm.handleMouseMove }
	    },
	    [
	      _c(
	        "tbody",
	        _vm._l(_vm.rows, function(row, key) {
	          return _c(
	            "tr",
	            { key: key },
	            _vm._l(row, function(cell, key) {
	              return _c("td", { key: key, class: _vm.getCellStyle(cell) }, [
	                _c("div", [
	                  _c("a", { staticClass: "cell" }, [
	                    _vm._v(
	                      _vm._s(
	                        _vm.t("el.datepicker.months." + _vm.months[cell.text])
	                      )
	                    )
	                  ])
	                ])
	              ])
	            }),
	            0
	          )
	        }),
	        0
	      )
	    ]
	  )
	}
	var month_tablevue_type_template_id_654d4f42_staticRenderFns = []
	month_tablevue_type_template_id_654d4f42_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/date-picker/src/basic/month-table.vue?vue&type=template&id=654d4f42&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/basic/month-table.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	var month_tablevue_type_script_lang_js_datesInMonth = function datesInMonth(year, month) {
	  var numOfDays = Object(date_util_["getDayCountOfMonth"])(year, month);
	  var firstDay = new Date(year, month, 1);
	  return Object(date_util_["range"])(numOfDays).map(function (n) {
	    return Object(date_util_["nextDate"])(firstDay, n);
	  });
	};
	
	var clearDate = function clearDate(date) {
	  return new Date(date.getFullYear(), date.getMonth());
	};
	
	var getMonthTimestamp = function getMonthTimestamp(time) {
	  if (typeof time === 'number' || typeof time === 'string') {
	    return clearDate(new Date(time)).getTime();
	  } else if (time instanceof Date) {
	    return clearDate(time).getTime();
	  } else {
	    return NaN;
	  }
	};
	/* harmony default export */ var month_tablevue_type_script_lang_js_ = ({
	  props: {
	    disabledDate: {},
	    value: {},
	    selectionMode: {
	      default: 'month'
	    },
	    minDate: {},
	
	    maxDate: {},
	    defaultValue: {
	      validator: function validator(val) {
	        // null or valid Date Object
	        return val === null || Object(date_util_["isDate"])(val) || Array.isArray(val) && val.every(date_util_["isDate"]);
	      }
	    },
	    date: {},
	    rangeState: {
	      default: function _default() {
	        return {
	          endDate: null,
	          selecting: false
	        };
	      }
	    }
	  },
	
	  mixins: [locale_default.a],
	
	  watch: {
	    'rangeState.endDate': function rangeStateEndDate(newVal) {
	      this.markRange(this.minDate, newVal);
	    },
	    minDate: function minDate(newVal, oldVal) {
	      if (getMonthTimestamp(newVal) !== getMonthTimestamp(oldVal)) {
	        this.markRange(this.minDate, this.maxDate);
	      }
	    },
	    maxDate: function maxDate(newVal, oldVal) {
	      if (getMonthTimestamp(newVal) !== getMonthTimestamp(oldVal)) {
	        this.markRange(this.minDate, this.maxDate);
	      }
	    }
	  },
	
	  data: function data() {
	    return {
	      months: ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'],
	      tableRows: [[], [], []],
	      lastRow: null,
	      lastColumn: null
	    };
	  },
	
	
	  methods: {
	    cellMatchesDate: function cellMatchesDate(cell, date) {
	      var value = new Date(date);
	      return this.date.getFullYear() === value.getFullYear() && Number(cell.text) === value.getMonth();
	    },
	    getCellStyle: function getCellStyle(cell) {
	      var _this = this;
	
	      var style = {};
	      var year = this.date.getFullYear();
	      var today = new Date();
	      var month = cell.text;
	      var defaultValue = this.defaultValue ? Array.isArray(this.defaultValue) ? this.defaultValue : [this.defaultValue] : [];
	      style.disabled = typeof this.disabledDate === 'function' ? month_tablevue_type_script_lang_js_datesInMonth(year, month).every(this.disabledDate) : false;
	      style.current = Object(util_["arrayFindIndex"])(Object(util_["coerceTruthyValueToArray"])(this.value), function (date) {
	        return date.getFullYear() === year && date.getMonth() === month;
	      }) >= 0;
	      style.today = today.getFullYear() === year && today.getMonth() === month;
	      style.default = defaultValue.some(function (date) {
	        return _this.cellMatchesDate(cell, date);
	      });
	
	      if (cell.inRange) {
	        style['in-range'] = true;
	
	        if (cell.start) {
	          style['start-date'] = true;
	        }
	
	        if (cell.end) {
	          style['end-date'] = true;
	        }
	      }
	      return style;
	    },
	    getMonthOfCell: function getMonthOfCell(month) {
	      var year = this.date.getFullYear();
	      return new Date(year, month, 1);
	    },
	    markRange: function markRange(minDate, maxDate) {
	      minDate = getMonthTimestamp(minDate);
	      maxDate = getMonthTimestamp(maxDate) || minDate;
	      var _ref = [Math.min(minDate, maxDate), Math.max(minDate, maxDate)];
	      minDate = _ref[0];
	      maxDate = _ref[1];
	
	      var rows = this.rows;
	      for (var i = 0, k = rows.length; i < k; i++) {
	        var row = rows[i];
	        for (var j = 0, l = row.length; j < l; j++) {
	
	          var cell = row[j];
	          var index = i * 4 + j;
	          var time = new Date(this.date.getFullYear(), index).getTime();
	
	          cell.inRange = minDate && time >= minDate && time <= maxDate;
	          cell.start = minDate && time === minDate;
	          cell.end = maxDate && time === maxDate;
	        }
	      }
	    },
	    handleMouseMove: function handleMouseMove(event) {
	      if (!this.rangeState.selecting) return;
	
	      var target = event.target;
	      if (target.tagName === 'A') {
	        target = target.parentNode.parentNode;
	      }
	      if (target.tagName === 'DIV') {
	        target = target.parentNode;
	      }
	      if (target.tagName !== 'TD') return;
	
	      var row = target.parentNode.rowIndex;
	      var column = target.cellIndex;
	      // can not select disabled date
	      if (this.rows[row][column].disabled) return;
	
	      // only update rangeState when mouse moves to a new cell
	      // this avoids frequent Date object creation and improves performance
	      if (row !== this.lastRow || column !== this.lastColumn) {
	        this.lastRow = row;
	        this.lastColumn = column;
	        this.$emit('changerange', {
	          minDate: this.minDate,
	          maxDate: this.maxDate,
	          rangeState: {
	            selecting: true,
	            endDate: this.getMonthOfCell(row * 4 + column)
	          }
	        });
	      }
	    },
	    handleMonthTableClick: function handleMonthTableClick(event) {
	      var target = event.target;
	      if (target.tagName === 'A') {
	        target = target.parentNode.parentNode;
	      }
	      if (target.tagName === 'DIV') {
	        target = target.parentNode;
	      }
	      if (target.tagName !== 'TD') return;
	      if (Object(dom_["hasClass"])(target, 'disabled')) return;
	      var column = target.cellIndex;
	      var row = target.parentNode.rowIndex;
	      var month = row * 4 + column;
	      var newDate = this.getMonthOfCell(month);
	      if (this.selectionMode === 'range') {
	        if (!this.rangeState.selecting) {
	          this.$emit('pick', { minDate: newDate, maxDate: null });
	          this.rangeState.selecting = true;
	        } else {
	          if (newDate >= this.minDate) {
	            this.$emit('pick', { minDate: this.minDate, maxDate: newDate });
	          } else {
	            this.$emit('pick', { minDate: newDate, maxDate: this.minDate });
	          }
	          this.rangeState.selecting = false;
	        }
	      } else {
	        this.$emit('pick', month);
	      }
	    }
	  },
	
	  computed: {
	    rows: function rows() {
	      var _this2 = this;
	
	      // TODO: refactory rows / getCellClasses
	      var rows = this.tableRows;
	      var disabledDate = this.disabledDate;
	      var selectedDate = [];
	      var now = getMonthTimestamp(new Date());
	
	      for (var i = 0; i < 3; i++) {
	        var row = rows[i];
	
	        var _loop = function _loop(j) {
	          var cell = row[j];
	          if (!cell) {
	            cell = { row: i, column: j, type: 'normal', inRange: false, start: false, end: false };
	          }
	
	          cell.type = 'normal';
	
	          var index = i * 4 + j;
	          var time = new Date(_this2.date.getFullYear(), index).getTime();
	          cell.inRange = time >= getMonthTimestamp(_this2.minDate) && time <= getMonthTimestamp(_this2.maxDate);
	          cell.start = _this2.minDate && time === getMonthTimestamp(_this2.minDate);
	          cell.end = _this2.maxDate && time === getMonthTimestamp(_this2.maxDate);
	          var isToday = time === now;
	
	          if (isToday) {
	            cell.type = 'today';
	          }
	          cell.text = index;
	          var cellDate = new Date(time);
	          cell.disabled = typeof disabledDate === 'function' && disabledDate(cellDate);
	          cell.selected = Object(util_["arrayFind"])(selectedDate, function (date) {
	            return date.getTime() === cellDate.getTime();
	          });
	
	          _this2.$set(row, j, cell);
	        };
	
	        for (var j = 0; j < 4; j++) {
	          _loop(j);
	        }
	      }
	      return rows;
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/date-picker/src/basic/month-table.vue?vue&type=script&lang=js&
	 /* harmony default export */ var basic_month_tablevue_type_script_lang_js_ = (month_tablevue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/date-picker/src/basic/month-table.vue
	
	
	
	
	
	/* normalize component */
	
	var month_table_component = normalizeComponent(
	  basic_month_tablevue_type_script_lang_js_,
	  month_tablevue_type_template_id_654d4f42_render,
	  month_tablevue_type_template_id_654d4f42_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var month_table_api; }
	month_table_component.options.__file = "packages/date-picker/src/basic/month-table.vue"
	/* harmony default export */ var month_table = (month_table_component.exports);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/basic/date-table.vue?vue&type=template&id=5d1f3341&
	var date_tablevue_type_template_id_5d1f3341_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "table",
	    {
	      staticClass: "el-date-table",
	      class: { "is-week-mode": _vm.selectionMode === "week" },
	      attrs: { cellspacing: "0", cellpadding: "0" },
	      on: { click: _vm.handleClick, mousemove: _vm.handleMouseMove }
	    },
	    [
	      _c(
	        "tbody",
	        [
	          _c(
	            "tr",
	            [
	              _vm.showWeekNumber
	                ? _c("th", [_vm._v(_vm._s(_vm.t("el.datepicker.week")))])
	                : _vm._e(),
	              _vm._l(_vm.WEEKS, function(week, key) {
	                return _c("th", { key: key }, [
	                  _vm._v(_vm._s(_vm.t("el.datepicker.weeks." + week)))
	                ])
	              })
	            ],
	            2
	          ),
	          _vm._l(_vm.rows, function(row, key) {
	            return _c(
	              "tr",
	              {
	                key: key,
	                staticClass: "el-date-table__row",
	                class: { current: _vm.isWeekActive(row[1]) }
	              },
	              _vm._l(row, function(cell, key) {
	                return _c("td", { key: key, class: _vm.getCellClasses(cell) }, [
	                  _c("div", [
	                    _c("span", [
	                      _vm._v("\n          " + _vm._s(cell.text) + "\n        ")
	                    ])
	                  ])
	                ])
	              }),
	              0
	            )
	          })
	        ],
	        2
	      )
	    ]
	  )
	}
	var date_tablevue_type_template_id_5d1f3341_staticRenderFns = []
	date_tablevue_type_template_id_5d1f3341_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/date-picker/src/basic/date-table.vue?vue&type=template&id=5d1f3341&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/basic/date-table.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	var _WEEKS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
	var date_tablevue_type_script_lang_js_getDateTimestamp = function getDateTimestamp(time) {
	  if (typeof time === 'number' || typeof time === 'string') {
	    return Object(date_util_["clearTime"])(new Date(time)).getTime();
	  } else if (time instanceof Date) {
	    return Object(date_util_["clearTime"])(time).getTime();
	  } else {
	    return NaN;
	  }
	};
	
	// remove the first element that satisfies `pred` from arr
	// return a new array if modification occurs
	// return the original array otherwise
	var date_tablevue_type_script_lang_js_removeFromArray = function removeFromArray(arr, pred) {
	  var idx = typeof pred === 'function' ? Object(util_["arrayFindIndex"])(arr, pred) : arr.indexOf(pred);
	  return idx >= 0 ? [].concat(arr.slice(0, idx), arr.slice(idx + 1)) : arr;
	};
	
	/* harmony default export */ var date_tablevue_type_script_lang_js_ = ({
	  mixins: [locale_default.a],
	
	  props: {
	    firstDayOfWeek: {
	      default: 7,
	      type: Number,
	      validator: function validator(val) {
	        return val >= 1 && val <= 7;
	      }
	    },
	
	    value: {},
	
	    defaultValue: {
	      validator: function validator(val) {
	        // either: null, valid Date object, Array of valid Date objects
	        return val === null || Object(date_util_["isDate"])(val) || Array.isArray(val) && val.every(date_util_["isDate"]);
	      }
	    },
	
	    date: {},
	
	    selectionMode: {
	      default: 'day'
	    },
	
	    showWeekNumber: {
	      type: Boolean,
	      default: false
	    },
	
	    disabledDate: {},
	
	    cellClassName: {},
	
	    minDate: {},
	
	    maxDate: {},
	
	    rangeState: {
	      default: function _default() {
	        return {
	          endDate: null,
	          selecting: false
	        };
	      }
	    }
	  },
	
	  computed: {
	    offsetDay: function offsetDay() {
	      var week = this.firstDayOfWeek;
	      // 周日为界限，左右偏移的天数，3217654 例如周一就是 -1，目的是调整前两行日期的位置
	      return week > 3 ? 7 - week : -week;
	    },
	    WEEKS: function WEEKS() {
	      var week = this.firstDayOfWeek;
	      return _WEEKS.concat(_WEEKS).slice(week, week + 7);
	    },
	    year: function year() {
	      return this.date.getFullYear();
	    },
	    month: function month() {
	      return this.date.getMonth();
	    },
	    startDate: function startDate() {
	      return Object(date_util_["getStartDateOfMonth"])(this.year, this.month);
	    },
	    rows: function rows() {
	      var _this = this;
	
	      // TODO: refactory rows / getCellClasses
	      var date = new Date(this.year, this.month, 1);
	      var day = Object(date_util_["getFirstDayOfMonth"])(date); // day of first day
	      var dateCountOfMonth = Object(date_util_["getDayCountOfMonth"])(date.getFullYear(), date.getMonth());
	      var dateCountOfLastMonth = Object(date_util_["getDayCountOfMonth"])(date.getFullYear(), date.getMonth() === 0 ? 11 : date.getMonth() - 1);
	
	      day = day === 0 ? 7 : day;
	
	      var offset = this.offsetDay;
	      var rows = this.tableRows;
	      var count = 1;
	
	      var startDate = this.startDate;
	      var disabledDate = this.disabledDate;
	      var cellClassName = this.cellClassName;
	      var selectedDate = this.selectionMode === 'dates' ? Object(util_["coerceTruthyValueToArray"])(this.value) : [];
	      var now = date_tablevue_type_script_lang_js_getDateTimestamp(new Date());
	
	      for (var i = 0; i < 6; i++) {
	        var row = rows[i];
	
	        if (this.showWeekNumber) {
	          if (!row[0]) {
	            row[0] = { type: 'week', text: Object(date_util_["getWeekNumber"])(Object(date_util_["nextDate"])(startDate, i * 7 + 1)) };
	          }
	        }
	
	        var _loop = function _loop(j) {
	          var cell = row[_this.showWeekNumber ? j + 1 : j];
	          if (!cell) {
	            cell = { row: i, column: j, type: 'normal', inRange: false, start: false, end: false };
	          }
	
	          cell.type = 'normal';
	
	          var index = i * 7 + j;
	          var time = Object(date_util_["nextDate"])(startDate, index - offset).getTime();
	          cell.inRange = time >= date_tablevue_type_script_lang_js_getDateTimestamp(_this.minDate) && time <= date_tablevue_type_script_lang_js_getDateTimestamp(_this.maxDate);
	          cell.start = _this.minDate && time === date_tablevue_type_script_lang_js_getDateTimestamp(_this.minDate);
	          cell.end = _this.maxDate && time === date_tablevue_type_script_lang_js_getDateTimestamp(_this.maxDate);
	          var isToday = time === now;
	
	          if (isToday) {
	            cell.type = 'today';
	          }
	
	          if (i >= 0 && i <= 1) {
	            var numberOfDaysFromPreviousMonth = day + offset < 0 ? 7 + day + offset : day + offset;
	
	            if (j + i * 7 >= numberOfDaysFromPreviousMonth) {
	              cell.text = count++;
	            } else {
	              cell.text = dateCountOfLastMonth - (numberOfDaysFromPreviousMonth - j % 7) + 1 + i * 7;
	              cell.type = 'prev-month';
	            }
	          } else {
	            if (count <= dateCountOfMonth) {
	              cell.text = count++;
	            } else {
	              cell.text = count++ - dateCountOfMonth;
	              cell.type = 'next-month';
	            }
	          }
	
	          var cellDate = new Date(time);
	          cell.disabled = typeof disabledDate === 'function' && disabledDate(cellDate);
	          cell.selected = Object(util_["arrayFind"])(selectedDate, function (date) {
	            return date.getTime() === cellDate.getTime();
	          });
	          cell.customClass = typeof cellClassName === 'function' && cellClassName(cellDate);
	          _this.$set(row, _this.showWeekNumber ? j + 1 : j, cell);
	        };
	
	        for (var j = 0; j < 7; j++) {
	          _loop(j);
	        }
	
	        if (this.selectionMode === 'week') {
	          var start = this.showWeekNumber ? 1 : 0;
	          var end = this.showWeekNumber ? 7 : 6;
	          var isWeekActive = this.isWeekActive(row[start + 1]);
	
	          row[start].inRange = isWeekActive;
	          row[start].start = isWeekActive;
	          row[end].inRange = isWeekActive;
	          row[end].end = isWeekActive;
	        }
	      }
	
	      return rows;
	    }
	  },
	
	  watch: {
	    'rangeState.endDate': function rangeStateEndDate(newVal) {
	      this.markRange(this.minDate, newVal);
	    },
	    minDate: function minDate(newVal, oldVal) {
	      if (date_tablevue_type_script_lang_js_getDateTimestamp(newVal) !== date_tablevue_type_script_lang_js_getDateTimestamp(oldVal)) {
	        this.markRange(this.minDate, this.maxDate);
	      }
	    },
	    maxDate: function maxDate(newVal, oldVal) {
	      if (date_tablevue_type_script_lang_js_getDateTimestamp(newVal) !== date_tablevue_type_script_lang_js_getDateTimestamp(oldVal)) {
	        this.markRange(this.minDate, this.maxDate);
	      }
	    }
	  },
	
	  data: function data() {
	    return {
	      tableRows: [[], [], [], [], [], []],
	      lastRow: null,
	      lastColumn: null
	    };
	  },
	
	
	  methods: {
	    cellMatchesDate: function cellMatchesDate(cell, date) {
	      var value = new Date(date);
	      return this.year === value.getFullYear() && this.month === value.getMonth() && Number(cell.text) === value.getDate();
	    },
	    getCellClasses: function getCellClasses(cell) {
	      var _this2 = this;
	
	      var selectionMode = this.selectionMode;
	      var defaultValue = this.defaultValue ? Array.isArray(this.defaultValue) ? this.defaultValue : [this.defaultValue] : [];
	
	      var classes = [];
	      if ((cell.type === 'normal' || cell.type === 'today') && !cell.disabled) {
	        classes.push('available');
	        if (cell.type === 'today') {
	          classes.push('today');
	        }
	      } else {
	        classes.push(cell.type);
	      }
	
	      if (cell.type === 'normal' && defaultValue.some(function (date) {
	        return _this2.cellMatchesDate(cell, date);
	      })) {
	        classes.push('default');
	      }
	
	      if (selectionMode === 'day' && (cell.type === 'normal' || cell.type === 'today') && this.cellMatchesDate(cell, this.value)) {
	        classes.push('current');
	      }
	
	      if (cell.inRange && (cell.type === 'normal' || cell.type === 'today' || this.selectionMode === 'week')) {
	        classes.push('in-range');
	
	        if (cell.start) {
	          classes.push('start-date');
	        }
	
	        if (cell.end) {
	          classes.push('end-date');
	        }
	      }
	
	      if (cell.disabled) {
	        classes.push('disabled');
	      }
	
	      if (cell.selected) {
	        classes.push('selected');
	      }
	
	      if (cell.customClass) {
	        classes.push(cell.customClass);
	      }
	
	      return classes.join(' ');
	    },
	    getDateOfCell: function getDateOfCell(row, column) {
	      var offsetFromStart = row * 7 + (column - (this.showWeekNumber ? 1 : 0)) - this.offsetDay;
	      return Object(date_util_["nextDate"])(this.startDate, offsetFromStart);
	    },
	    isWeekActive: function isWeekActive(cell) {
	      if (this.selectionMode !== 'week') return false;
	      var newDate = new Date(this.year, this.month, 1);
	      var year = newDate.getFullYear();
	      var month = newDate.getMonth();
	
	      if (cell.type === 'prev-month') {
	        newDate.setMonth(month === 0 ? 11 : month - 1);
	        newDate.setFullYear(month === 0 ? year - 1 : year);
	      }
	
	      if (cell.type === 'next-month') {
	        newDate.setMonth(month === 11 ? 0 : month + 1);
	        newDate.setFullYear(month === 11 ? year + 1 : year);
	      }
	
	      newDate.setDate(parseInt(cell.text, 10));
	
	      if (Object(date_util_["isDate"])(this.value)) {
	        var dayOffset = (this.value.getDay() - this.firstDayOfWeek + 7) % 7 - 1;
	        var weekDate = Object(date_util_["prevDate"])(this.value, dayOffset);
	        return weekDate.getTime() === newDate.getTime();
	      }
	      return false;
	    },
	    markRange: function markRange(minDate, maxDate) {
	      minDate = date_tablevue_type_script_lang_js_getDateTimestamp(minDate);
	      maxDate = date_tablevue_type_script_lang_js_getDateTimestamp(maxDate) || minDate;
	      var _ref = [Math.min(minDate, maxDate), Math.max(minDate, maxDate)];
	      minDate = _ref[0];
	      maxDate = _ref[1];
	
	
	      var startDate = this.startDate;
	      var rows = this.rows;
	      for (var i = 0, k = rows.length; i < k; i++) {
	        var row = rows[i];
	        for (var j = 0, l = row.length; j < l; j++) {
	          if (this.showWeekNumber && j === 0) continue;
	
	          var _cell = row[j];
	          var index = i * 7 + j + (this.showWeekNumber ? -1 : 0);
	          var time = Object(date_util_["nextDate"])(startDate, index - this.offsetDay).getTime();
	
	          _cell.inRange = minDate && time >= minDate && time <= maxDate;
	          _cell.start = minDate && time === minDate;
	          _cell.end = maxDate && time === maxDate;
	        }
	      }
	    },
	    handleMouseMove: function handleMouseMove(event) {
	      if (!this.rangeState.selecting) return;
	
	      var target = event.target;
	      if (target.tagName === 'SPAN') {
	        target = target.parentNode.parentNode;
	      }
	      if (target.tagName === 'DIV') {
	        target = target.parentNode;
	      }
	      if (target.tagName !== 'TD') return;
	
	      var row = target.parentNode.rowIndex - 1;
	      var column = target.cellIndex;
	
	      // can not select disabled date
	      if (this.rows[row][column].disabled) return;
	
	      // only update rangeState when mouse moves to a new cell
	      // this avoids frequent Date object creation and improves performance
	      if (row !== this.lastRow || column !== this.lastColumn) {
	        this.lastRow = row;
	        this.lastColumn = column;
	        this.$emit('changerange', {
	          minDate: this.minDate,
	          maxDate: this.maxDate,
	          rangeState: {
	            selecting: true,
	            endDate: this.getDateOfCell(row, column)
	          }
	        });
	      }
	    },
	    handleClick: function handleClick(event) {
	      var target = event.target;
	      if (target.tagName === 'SPAN') {
	        target = target.parentNode.parentNode;
	      }
	      if (target.tagName === 'DIV') {
	        target = target.parentNode;
	      }
	
	      if (target.tagName !== 'TD') return;
	
	      var row = target.parentNode.rowIndex - 1;
	      var column = this.selectionMode === 'week' ? 1 : target.cellIndex;
	      var cell = this.rows[row][column];
	
	      if (cell.disabled || cell.type === 'week') return;
	
	      var newDate = this.getDateOfCell(row, column);
	
	      if (this.selectionMode === 'range') {
	        if (!this.rangeState.selecting) {
	          this.$emit('pick', { minDate: newDate, maxDate: null });
	          this.rangeState.selecting = true;
	        } else {
	          if (newDate >= this.minDate) {
	            this.$emit('pick', { minDate: this.minDate, maxDate: newDate });
	          } else {
	            this.$emit('pick', { minDate: newDate, maxDate: this.minDate });
	          }
	          this.rangeState.selecting = false;
	        }
	      } else if (this.selectionMode === 'day') {
	        this.$emit('pick', newDate);
	      } else if (this.selectionMode === 'week') {
	        var weekNumber = Object(date_util_["getWeekNumber"])(newDate);
	        var value = newDate.getFullYear() + 'w' + weekNumber;
	        this.$emit('pick', {
	          year: newDate.getFullYear(),
	          week: weekNumber,
	          value: value,
	          date: newDate
	        });
	      } else if (this.selectionMode === 'dates') {
	        var _value = this.value || [];
	        var newValue = cell.selected ? date_tablevue_type_script_lang_js_removeFromArray(_value, function (date) {
	          return date.getTime() === newDate.getTime();
	        }) : [].concat(_value, [newDate]);
	        this.$emit('pick', newValue);
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/date-picker/src/basic/date-table.vue?vue&type=script&lang=js&
	 /* harmony default export */ var basic_date_tablevue_type_script_lang_js_ = (date_tablevue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/date-picker/src/basic/date-table.vue
	
	
	
	
	
	/* normalize component */
	
	var date_table_component = normalizeComponent(
	  basic_date_tablevue_type_script_lang_js_,
	  date_tablevue_type_template_id_5d1f3341_render,
	  date_tablevue_type_template_id_5d1f3341_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var date_table_api; }
	date_table_component.options.__file = "packages/date-picker/src/basic/date-table.vue"
	/* harmony default export */ var date_table = (date_table_component.exports);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/date.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	
	
	
	
	/* harmony default export */ var datevue_type_script_lang_js_ = ({
	  mixins: [locale_default.a],
	
	  directives: { Clickoutside: clickoutside_default.a },
	
	  watch: {
	    showTime: function showTime(val) {
	      var _this = this;
	
	      /* istanbul ignore if */
	      if (!val) return;
	      this.$nextTick(function (_) {
	        var inputElm = _this.$refs.input.$el;
	        if (inputElm) {
	          _this.pickerWidth = inputElm.getBoundingClientRect().width + 10;
	        }
	      });
	    },
	    value: function value(val) {
	      if (this.selectionMode === 'dates' && this.value) return;
	      if (Object(date_util_["isDate"])(val)) {
	        this.date = new Date(val);
	      } else {
	        this.date = this.getDefaultValue();
	      }
	    },
	    defaultValue: function defaultValue(val) {
	      if (!Object(date_util_["isDate"])(this.value)) {
	        this.date = val ? new Date(val) : new Date();
	      }
	    },
	    timePickerVisible: function timePickerVisible(val) {
	      var _this2 = this;
	
	      if (val) this.$nextTick(function () {
	        return _this2.$refs.timepicker.adjustSpinners();
	      });
	    },
	    selectionMode: function selectionMode(newVal) {
	      if (newVal === 'month') {
	        /* istanbul ignore next */
	        if (this.currentView !== 'year' || this.currentView !== 'month') {
	          this.currentView = 'month';
	        }
	      } else if (newVal === 'dates') {
	        this.currentView = 'date';
	      }
	    }
	  },
	
	  methods: {
	    proxyTimePickerDataProperties: function proxyTimePickerDataProperties() {
	      var _this3 = this;
	
	      var format = function format(timeFormat) {
	        _this3.$refs.timepicker.format = timeFormat;
	      };
	      var value = function value(_value) {
	        _this3.$refs.timepicker.value = _value;
	      };
	      var date = function date(_date) {
	        _this3.$refs.timepicker.date = _date;
	      };
	      var selectableRange = function selectableRange(_selectableRange) {
	        _this3.$refs.timepicker.selectableRange = _selectableRange;
	      };
	
	      this.$watch('value', value);
	      this.$watch('date', date);
	      this.$watch('selectableRange', selectableRange);
	
	      format(this.timeFormat);
	      value(this.value);
	      date(this.date);
	      selectableRange(this.selectableRange);
	    },
	    handleClear: function handleClear() {
	      this.date = this.getDefaultValue();
	      this.$emit('pick', null);
	    },
	    emit: function emit(value) {
	      var _this4 = this;
	
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      if (!value) {
	        this.$emit.apply(this, ['pick', value].concat(args));
	      } else if (Array.isArray(value)) {
	        var dates = value.map(function (date) {
	          return _this4.showTime ? Object(date_util_["clearMilliseconds"])(date) : Object(date_util_["clearTime"])(date);
	        });
	        this.$emit.apply(this, ['pick', dates].concat(args));
	      } else {
	        this.$emit.apply(this, ['pick', this.showTime ? Object(date_util_["clearMilliseconds"])(value) : Object(date_util_["clearTime"])(value)].concat(args));
	      }
	      this.userInputDate = null;
	      this.userInputTime = null;
	    },
	
	
	    // resetDate() {
	    //   this.date = new Date(this.date);
	    // },
	
	    showMonthPicker: function showMonthPicker() {
	      this.currentView = 'month';
	    },
	    showYearPicker: function showYearPicker() {
	      this.currentView = 'year';
	    },
	
	
	    // XXX: 没用到
	    // handleLabelClick() {
	    //   if (this.currentView === 'date') {
	    //     this.showMonthPicker();
	    //   } else if (this.currentView === 'month') {
	    //     this.showYearPicker();
	    //   }
	    // },
	
	    prevMonth: function prevMonth() {
	      this.date = Object(date_util_["prevMonth"])(this.date);
	    },
	    nextMonth: function nextMonth() {
	      this.date = Object(date_util_["nextMonth"])(this.date);
	    },
	    prevYear: function prevYear() {
	      if (this.currentView === 'year') {
	        this.date = Object(date_util_["prevYear"])(this.date, 10);
	      } else {
	        this.date = Object(date_util_["prevYear"])(this.date);
	      }
	    },
	    nextYear: function nextYear() {
	      if (this.currentView === 'year') {
	        this.date = Object(date_util_["nextYear"])(this.date, 10);
	      } else {
	        this.date = Object(date_util_["nextYear"])(this.date);
	      }
	    },
	    handleShortcutClick: function handleShortcutClick(shortcut) {
	      if (shortcut.onClick) {
	        shortcut.onClick(this);
	      }
	    },
	    handleTimePick: function handleTimePick(value, visible, first) {
	      if (Object(date_util_["isDate"])(value)) {
	        var newDate = this.value ? Object(date_util_["modifyTime"])(this.value, value.getHours(), value.getMinutes(), value.getSeconds()) : Object(date_util_["modifyWithTimeString"])(this.getDefaultValue(), this.defaultTime);
	        this.date = newDate;
	        this.emit(this.date, true);
	      } else {
	        this.emit(value, true);
	      }
	      if (!first) {
	        this.timePickerVisible = visible;
	      }
	    },
	    handleTimePickClose: function handleTimePickClose() {
	      this.timePickerVisible = false;
	    },
	    handleMonthPick: function handleMonthPick(month) {
	      if (this.selectionMode === 'month') {
	        this.date = Object(date_util_["modifyDate"])(this.date, this.year, month, 1);
	        this.emit(this.date);
	      } else {
	        this.date = Object(date_util_["changeYearMonthAndClampDate"])(this.date, this.year, month);
	        // TODO: should emit intermediate value ??
	        // this.emit(this.date);
	        this.currentView = 'date';
	      }
	    },
	    handleDatePick: function handleDatePick(value) {
	      if (this.selectionMode === 'day') {
	        var newDate = this.value ? Object(date_util_["modifyDate"])(this.value, value.getFullYear(), value.getMonth(), value.getDate()) : Object(date_util_["modifyWithTimeString"])(value, this.defaultTime);
	        // change default time while out of selectableRange
	        if (!this.checkDateWithinRange(newDate)) {
	          newDate = Object(date_util_["modifyDate"])(this.selectableRange[0][0], value.getFullYear(), value.getMonth(), value.getDate());
	        }
	        this.date = newDate;
	        this.emit(this.date, this.showTime);
	      } else if (this.selectionMode === 'week') {
	        this.emit(value.date);
	      } else if (this.selectionMode === 'dates') {
	        this.emit(value, true); // set false to keep panel open
	      }
	    },
	    handleYearPick: function handleYearPick(year) {
	      if (this.selectionMode === 'year') {
	        this.date = Object(date_util_["modifyDate"])(this.date, year, 0, 1);
	        this.emit(this.date);
	      } else {
	        this.date = Object(date_util_["changeYearMonthAndClampDate"])(this.date, year, this.month);
	        // TODO: should emit intermediate value ??
	        // this.emit(this.date, true);
	        this.currentView = 'month';
	      }
	    },
	    changeToNow: function changeToNow() {
	      // NOTE: not a permanent solution
	      //       consider disable "now" button in the future
	      if ((!this.disabledDate || !this.disabledDate(new Date())) && this.checkDateWithinRange(new Date())) {
	        this.date = new Date();
	        this.emit(this.date);
	      }
	    },
	    confirm: function confirm() {
	      if (this.selectionMode === 'dates') {
	        this.emit(this.value);
	      } else {
	        // value were emitted in handle{Date,Time}Pick, nothing to update here
	        // deal with the scenario where: user opens the picker, then confirm without doing anything
	        var value = this.value ? this.value : Object(date_util_["modifyWithTimeString"])(this.getDefaultValue(), this.defaultTime);
	        this.date = new Date(value); // refresh date
	        this.emit(value);
	      }
	    },
	    resetView: function resetView() {
	      if (this.selectionMode === 'month') {
	        this.currentView = 'month';
	      } else if (this.selectionMode === 'year') {
	        this.currentView = 'year';
	      } else {
	        this.currentView = 'date';
	      }
	    },
	    handleEnter: function handleEnter() {
	      document.body.addEventListener('keydown', this.handleKeydown);
	    },
	    handleLeave: function handleLeave() {
	      this.$emit('dodestroy');
	      document.body.removeEventListener('keydown', this.handleKeydown);
	    },
	    handleKeydown: function handleKeydown(event) {
	      var keyCode = event.keyCode;
	      var list = [38, 40, 37, 39];
	      if (this.visible && !this.timePickerVisible) {
	        if (list.indexOf(keyCode) !== -1) {
	          this.handleKeyControl(keyCode);
	          event.stopPropagation();
	          event.preventDefault();
	        }
	        if (keyCode === 13 && this.userInputDate === null && this.userInputTime === null) {
	          // Enter
	          this.emit(this.date, false);
	        }
	      }
	    },
	    handleKeyControl: function handleKeyControl(keyCode) {
	      var mapping = {
	        'year': {
	          38: -4, 40: 4, 37: -1, 39: 1, offset: function offset(date, step) {
	            return date.setFullYear(date.getFullYear() + step);
	          }
	        },
	        'month': {
	          38: -4, 40: 4, 37: -1, 39: 1, offset: function offset(date, step) {
	            return date.setMonth(date.getMonth() + step);
	          }
	        },
	        'week': {
	          38: -1, 40: 1, 37: -1, 39: 1, offset: function offset(date, step) {
	            return date.setDate(date.getDate() + step * 7);
	          }
	        },
	        'day': {
	          38: -7, 40: 7, 37: -1, 39: 1, offset: function offset(date, step) {
	            return date.setDate(date.getDate() + step);
	          }
	        }
	      };
	      var mode = this.selectionMode;
	      var year = 3.1536e10;
	      var now = this.date.getTime();
	      var newDate = new Date(this.date.getTime());
	      while (Math.abs(now - newDate.getTime()) <= year) {
	        var map = mapping[mode];
	        map.offset(newDate, map[keyCode]);
	        if (typeof this.disabledDate === 'function' && this.disabledDate(newDate)) {
	          continue;
	        }
	        this.date = newDate;
	        this.$emit('pick', newDate, true);
	        break;
	      }
	    },
	    handleVisibleTimeChange: function handleVisibleTimeChange(value) {
	      var time = Object(date_util_["parseDate"])(value, this.timeFormat);
	      if (time && this.checkDateWithinRange(time)) {
	        this.date = Object(date_util_["modifyDate"])(time, this.year, this.month, this.monthDate);
	        this.userInputTime = null;
	        this.$refs.timepicker.value = this.date;
	        this.timePickerVisible = false;
	        this.emit(this.date, true);
	      }
	    },
	    handleVisibleDateChange: function handleVisibleDateChange(value) {
	      var date = Object(date_util_["parseDate"])(value, this.dateFormat);
	      if (date) {
	        if (typeof this.disabledDate === 'function' && this.disabledDate(date)) {
	          return;
	        }
	        this.date = Object(date_util_["modifyTime"])(date, this.date.getHours(), this.date.getMinutes(), this.date.getSeconds());
	        this.userInputDate = null;
	        this.resetView();
	        this.emit(this.date, true);
	      }
	    },
	    isValidValue: function isValidValue(value) {
	      return value && !isNaN(value) && (typeof this.disabledDate === 'function' ? !this.disabledDate(value) : true) && this.checkDateWithinRange(value);
	    },
	    getDefaultValue: function getDefaultValue() {
	      // if default-value is set, return it
	      // otherwise, return now (the moment this method gets called)
	      return this.defaultValue ? new Date(this.defaultValue) : new Date();
	    },
	    checkDateWithinRange: function checkDateWithinRange(date) {
	      return this.selectableRange.length > 0 ? Object(date_util_["timeWithinRange"])(date, this.selectableRange, this.format || 'HH:mm:ss') : true;
	    }
	  },
	
	  components: {
	    TimePicker: panel_time, YearTable: year_table, MonthTable: month_table, DateTable: date_table, ElInput: input_default.a, ElButton: button_default.a
	  },
	
	  data: function data() {
	    return {
	      popperClass: '',
	      date: new Date(),
	      value: '',
	      defaultValue: null, // use getDefaultValue() for time computation
	      defaultTime: null,
	      showTime: false,
	      selectionMode: 'day',
	      shortcuts: '',
	      visible: false,
	      currentView: 'date',
	      disabledDate: '',
	      cellClassName: '',
	      selectableRange: [],
	      firstDayOfWeek: 7,
	      showWeekNumber: false,
	      timePickerVisible: false,
	      format: '',
	      arrowControl: false,
	      userInputDate: null,
	      userInputTime: null
	    };
	  },
	
	
	  computed: {
	    year: function year() {
	      return this.date.getFullYear();
	    },
	    month: function month() {
	      return this.date.getMonth();
	    },
	    week: function week() {
	      return Object(date_util_["getWeekNumber"])(this.date);
	    },
	    monthDate: function monthDate() {
	      return this.date.getDate();
	    },
	    footerVisible: function footerVisible() {
	      return this.showTime || this.selectionMode === 'dates';
	    },
	    visibleTime: function visibleTime() {
	      if (this.userInputTime !== null) {
	        return this.userInputTime;
	      } else {
	        return Object(date_util_["formatDate"])(this.value || this.defaultValue, this.timeFormat);
	      }
	    },
	    visibleDate: function visibleDate() {
	      if (this.userInputDate !== null) {
	        return this.userInputDate;
	      } else {
	        return Object(date_util_["formatDate"])(this.value || this.defaultValue, this.dateFormat);
	      }
	    },
	    yearLabel: function yearLabel() {
	      var yearTranslation = this.t('el.datepicker.year');
	      if (this.currentView === 'year') {
	        var startYear = Math.floor(this.year / 10) * 10;
	        if (yearTranslation) {
	          return startYear + ' ' + yearTranslation + ' - ' + (startYear + 9) + ' ' + yearTranslation;
	        }
	        return startYear + ' - ' + (startYear + 9);
	      }
	      return this.year + ' ' + yearTranslation;
	    },
	    timeFormat: function timeFormat() {
	      if (this.format) {
	        return Object(date_util_["extractTimeFormat"])(this.format);
	      } else {
	        return 'HH:mm:ss';
	      }
	    },
	    dateFormat: function dateFormat() {
	      if (this.format) {
	        return Object(date_util_["extractDateFormat"])(this.format);
	      } else {
	        return 'yyyy-MM-dd';
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/date.vue?vue&type=script&lang=js&
	 /* harmony default export */ var panel_datevue_type_script_lang_js_ = (datevue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/date.vue
	
	
	
	
	
	/* normalize component */
	
	var date_component = normalizeComponent(
	  panel_datevue_type_script_lang_js_,
	  datevue_type_template_id_2440d4ea_render,
	  datevue_type_template_id_2440d4ea_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var date_api; }
	date_component.options.__file = "packages/date-picker/src/panel/date.vue"
	/* harmony default export */ var panel_date = (date_component.exports);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/date-range.vue?vue&type=template&id=2652849a&
	var date_rangevue_type_template_id_2652849a_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "transition",
	    {
	      attrs: { name: "el-zoom-in-top" },
	      on: {
	        "after-leave": function($event) {
	          _vm.$emit("dodestroy")
	        }
	      }
	    },
	    [
	      _c(
	        "div",
	        {
	          directives: [
	            {
	              name: "show",
	              rawName: "v-show",
	              value: _vm.visible,
	              expression: "visible"
	            }
	          ],
	          staticClass: "el-picker-panel el-date-range-picker el-popper",
	          class: [
	            {
	              "has-sidebar": _vm.$slots.sidebar || _vm.shortcuts,
	              "has-time": _vm.showTime
	            },
	            _vm.popperClass
	          ]
	        },
	        [
	          _c(
	            "div",
	            { staticClass: "el-picker-panel__body-wrapper" },
	            [
	              _vm._t("sidebar"),
	              _vm.shortcuts
	                ? _c(
	                    "div",
	                    { staticClass: "el-picker-panel__sidebar" },
	                    _vm._l(_vm.shortcuts, function(shortcut, key) {
	                      return _c(
	                        "button",
	                        {
	                          key: key,
	                          staticClass: "el-picker-panel__shortcut",
	                          attrs: { type: "button" },
	                          on: {
	                            click: function($event) {
	                              _vm.handleShortcutClick(shortcut)
	                            }
	                          }
	                        },
	                        [_vm._v(_vm._s(shortcut.text))]
	                      )
	                    }),
	                    0
	                  )
	                : _vm._e(),
	              _c("div", { staticClass: "el-picker-panel__body" }, [
	                _vm.showTime
	                  ? _c(
	                      "div",
	                      { staticClass: "el-date-range-picker__time-header" },
	                      [
	                        _c(
	                          "span",
	                          { staticClass: "el-date-range-picker__editors-wrap" },
	                          [
	                            _c(
	                              "span",
	                              {
	                                staticClass:
	                                  "el-date-range-picker__time-picker-wrap"
	                              },
	                              [
	                                _c("el-input", {
	                                  ref: "minInput",
	                                  staticClass: "el-date-range-picker__editor",
	                                  attrs: {
	                                    size: "small",
	                                    disabled: _vm.rangeState.selecting,
	                                    placeholder: _vm.t(
	                                      "el.datepicker.startDate"
	                                    ),
	                                    value: _vm.minVisibleDate
	                                  },
	                                  on: {
	                                    input: function(val) {
	                                      return _vm.handleDateInput(val, "min")
	                                    },
	                                    change: function(val) {
	                                      return _vm.handleDateChange(val, "min")
	                                    }
	                                  }
	                                })
	                              ],
	                              1
	                            ),
	                            _c(
	                              "span",
	                              {
	                                directives: [
	                                  {
	                                    name: "clickoutside",
	                                    rawName: "v-clickoutside",
	                                    value: _vm.handleMinTimeClose,
	                                    expression: "handleMinTimeClose"
	                                  }
	                                ],
	                                staticClass:
	                                  "el-date-range-picker__time-picker-wrap"
	                              },
	                              [
	                                _c("el-input", {
	                                  staticClass: "el-date-range-picker__editor",
	                                  attrs: {
	                                    size: "small",
	                                    disabled: _vm.rangeState.selecting,
	                                    placeholder: _vm.t(
	                                      "el.datepicker.startTime"
	                                    ),
	                                    value: _vm.minVisibleTime
	                                  },
	                                  on: {
	                                    focus: function($event) {
	                                      _vm.minTimePickerVisible = true
	                                    },
	                                    input: function(val) {
	                                      return _vm.handleTimeInput(val, "min")
	                                    },
	                                    change: function(val) {
	                                      return _vm.handleTimeChange(val, "min")
	                                    }
	                                  }
	                                }),
	                                _c("time-picker", {
	                                  ref: "minTimePicker",
	                                  attrs: {
	                                    "time-arrow-control": _vm.arrowControl,
	                                    visible: _vm.minTimePickerVisible
	                                  },
	                                  on: {
	                                    pick: _vm.handleMinTimePick,
	                                    mounted: function($event) {
	                                      _vm.$refs.minTimePicker.format =
	                                        _vm.timeFormat
	                                    }
	                                  }
	                                })
	                              ],
	                              1
	                            )
	                          ]
	                        ),
	                        _c("span", { staticClass: "el-icon-arrow-right" }),
	                        _c(
	                          "span",
	                          {
	                            staticClass:
	                              "el-date-range-picker__editors-wrap is-right"
	                          },
	                          [
	                            _c(
	                              "span",
	                              {
	                                staticClass:
	                                  "el-date-range-picker__time-picker-wrap"
	                              },
	                              [
	                                _c("el-input", {
	                                  staticClass: "el-date-range-picker__editor",
	                                  attrs: {
	                                    size: "small",
	                                    disabled: _vm.rangeState.selecting,
	                                    placeholder: _vm.t("el.datepicker.endDate"),
	                                    value: _vm.maxVisibleDate,
	                                    readonly: !_vm.minDate
	                                  },
	                                  on: {
	                                    input: function(val) {
	                                      return _vm.handleDateInput(val, "max")
	                                    },
	                                    change: function(val) {
	                                      return _vm.handleDateChange(val, "max")
	                                    }
	                                  }
	                                })
	                              ],
	                              1
	                            ),
	                            _c(
	                              "span",
	                              {
	                                directives: [
	                                  {
	                                    name: "clickoutside",
	                                    rawName: "v-clickoutside",
	                                    value: _vm.handleMaxTimeClose,
	                                    expression: "handleMaxTimeClose"
	                                  }
	                                ],
	                                staticClass:
	                                  "el-date-range-picker__time-picker-wrap"
	                              },
	                              [
	                                _c("el-input", {
	                                  staticClass: "el-date-range-picker__editor",
	                                  attrs: {
	                                    size: "small",
	                                    disabled: _vm.rangeState.selecting,
	                                    placeholder: _vm.t("el.datepicker.endTime"),
	                                    value: _vm.maxVisibleTime,
	                                    readonly: !_vm.minDate
	                                  },
	                                  on: {
	                                    focus: function($event) {
	                                      _vm.minDate &&
	                                        (_vm.maxTimePickerVisible = true)
	                                    },
	                                    input: function(val) {
	                                      return _vm.handleTimeInput(val, "max")
	                                    },
	                                    change: function(val) {
	                                      return _vm.handleTimeChange(val, "max")
	                                    }
	                                  }
	                                }),
	                                _c("time-picker", {
	                                  ref: "maxTimePicker",
	                                  attrs: {
	                                    "time-arrow-control": _vm.arrowControl,
	                                    visible: _vm.maxTimePickerVisible
	                                  },
	                                  on: {
	                                    pick: _vm.handleMaxTimePick,
	                                    mounted: function($event) {
	                                      _vm.$refs.maxTimePicker.format =
	                                        _vm.timeFormat
	                                    }
	                                  }
	                                })
	                              ],
	                              1
	                            )
	                          ]
	                        )
	                      ]
	                    )
	                  : _vm._e(),
	                _c(
	                  "div",
	                  {
	                    staticClass:
	                      "el-picker-panel__content el-date-range-picker__content is-left"
	                  },
	                  [
	                    _c("div", { staticClass: "el-date-range-picker__header" }, [
	                      _c("button", {
	                        staticClass:
	                          "el-picker-panel__icon-btn el-icon-d-arrow-left",
	                        attrs: { type: "button" },
	                        on: { click: _vm.leftPrevYear }
	                      }),
	                      _c("button", {
	                        staticClass:
	                          "el-picker-panel__icon-btn el-icon-arrow-left",
	                        attrs: { type: "button" },
	                        on: { click: _vm.leftPrevMonth }
	                      }),
	                      _vm.unlinkPanels
	                        ? _c("button", {
	                            staticClass:
	                              "el-picker-panel__icon-btn el-icon-d-arrow-right",
	                            class: { "is-disabled": !_vm.enableYearArrow },
	                            attrs: {
	                              type: "button",
	                              disabled: !_vm.enableYearArrow
	                            },
	                            on: { click: _vm.leftNextYear }
	                          })
	                        : _vm._e(),
	                      _vm.unlinkPanels
	                        ? _c("button", {
	                            staticClass:
	                              "el-picker-panel__icon-btn el-icon-arrow-right",
	                            class: { "is-disabled": !_vm.enableMonthArrow },
	                            attrs: {
	                              type: "button",
	                              disabled: !_vm.enableMonthArrow
	                            },
	                            on: { click: _vm.leftNextMonth }
	                          })
	                        : _vm._e(),
	                      _c("div", [_vm._v(_vm._s(_vm.leftLabel))])
	                    ]),
	                    _c("date-table", {
	                      attrs: {
	                        "selection-mode": "range",
	                        date: _vm.leftDate,
	                        "default-value": _vm.defaultValue,
	                        "min-date": _vm.minDate,
	                        "max-date": _vm.maxDate,
	                        "range-state": _vm.rangeState,
	                        "disabled-date": _vm.disabledDate,
	                        "cell-class-name": _vm.cellClassName,
	                        "first-day-of-week": _vm.firstDayOfWeek
	                      },
	                      on: {
	                        changerange: _vm.handleChangeRange,
	                        pick: _vm.handleRangePick
	                      }
	                    })
	                  ],
	                  1
	                ),
	                _c(
	                  "div",
	                  {
	                    staticClass:
	                      "el-picker-panel__content el-date-range-picker__content is-right"
	                  },
	                  [
	                    _c("div", { staticClass: "el-date-range-picker__header" }, [
	                      _vm.unlinkPanels
	                        ? _c("button", {
	                            staticClass:
	                              "el-picker-panel__icon-btn el-icon-d-arrow-left",
	                            class: { "is-disabled": !_vm.enableYearArrow },
	                            attrs: {
	                              type: "button",
	                              disabled: !_vm.enableYearArrow
	                            },
	                            on: { click: _vm.rightPrevYear }
	                          })
	                        : _vm._e(),
	                      _vm.unlinkPanels
	                        ? _c("button", {
	                            staticClass:
	                              "el-picker-panel__icon-btn el-icon-arrow-left",
	                            class: { "is-disabled": !_vm.enableMonthArrow },
	                            attrs: {
	                              type: "button",
	                              disabled: !_vm.enableMonthArrow
	                            },
	                            on: { click: _vm.rightPrevMonth }
	                          })
	                        : _vm._e(),
	                      _c("button", {
	                        staticClass:
	                          "el-picker-panel__icon-btn el-icon-d-arrow-right",
	                        attrs: { type: "button" },
	                        on: { click: _vm.rightNextYear }
	                      }),
	                      _c("button", {
	                        staticClass:
	                          "el-picker-panel__icon-btn el-icon-arrow-right",
	                        attrs: { type: "button" },
	                        on: { click: _vm.rightNextMonth }
	                      }),
	                      _c("div", [_vm._v(_vm._s(_vm.rightLabel))])
	                    ]),
	                    _c("date-table", {
	                      attrs: {
	                        "selection-mode": "range",
	                        date: _vm.rightDate,
	                        "default-value": _vm.defaultValue,
	                        "min-date": _vm.minDate,
	                        "max-date": _vm.maxDate,
	                        "range-state": _vm.rangeState,
	                        "disabled-date": _vm.disabledDate,
	                        "cell-class-name": _vm.cellClassName,
	                        "first-day-of-week": _vm.firstDayOfWeek
	                      },
	                      on: {
	                        changerange: _vm.handleChangeRange,
	                        pick: _vm.handleRangePick
	                      }
	                    })
	                  ],
	                  1
	                )
	              ])
	            ],
	            2
	          ),
	          _vm.showTime
	            ? _c(
	                "div",
	                { staticClass: "el-picker-panel__footer" },
	                [
	                  _c(
	                    "el-button",
	                    {
	                      staticClass: "el-picker-panel__link-btn",
	                      attrs: { size: "mini", type: "text" },
	                      on: { click: _vm.handleClear }
	                    },
	                    [
	                      _vm._v(
	                        "\n        " +
	                          _vm._s(_vm.t("el.datepicker.clear")) +
	                          "\n      "
	                      )
	                    ]
	                  ),
	                  _c(
	                    "el-button",
	                    {
	                      staticClass: "el-picker-panel__link-btn",
	                      attrs: {
	                        plain: "",
	                        size: "mini",
	                        disabled: _vm.btnDisabled
	                      },
	                      on: {
	                        click: function($event) {
	                          _vm.handleConfirm(false)
	                        }
	                      }
	                    },
	                    [
	                      _vm._v(
	                        "\n        " +
	                          _vm._s(_vm.t("el.datepicker.confirm")) +
	                          "\n      "
	                      )
	                    ]
	                  )
	                ],
	                1
	              )
	            : _vm._e()
	        ]
	      )
	    ]
	  )
	}
	var date_rangevue_type_template_id_2652849a_staticRenderFns = []
	date_rangevue_type_template_id_2652849a_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/date-range.vue?vue&type=template&id=2652849a&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/date-range.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	
	
	var date_rangevue_type_script_lang_js_calcDefaultValue = function calcDefaultValue(defaultValue) {
	  if (Array.isArray(defaultValue)) {
	    return [new Date(defaultValue[0]), new Date(defaultValue[1])];
	  } else if (defaultValue) {
	    return [new Date(defaultValue), Object(date_util_["nextDate"])(new Date(defaultValue), 1)];
	  } else {
	    return [new Date(), Object(date_util_["nextDate"])(new Date(), 1)];
	  }
	};
	
	/* harmony default export */ var date_rangevue_type_script_lang_js_ = ({
	  mixins: [locale_default.a],
	
	  directives: { Clickoutside: clickoutside_default.a },
	
	  computed: {
	    btnDisabled: function btnDisabled() {
	      return !(this.minDate && this.maxDate && !this.selecting && this.isValidValue([this.minDate, this.maxDate]));
	    },
	    leftLabel: function leftLabel() {
	      return this.leftDate.getFullYear() + ' ' + this.t('el.datepicker.year') + ' ' + this.t('el.datepicker.month' + (this.leftDate.getMonth() + 1));
	    },
	    rightLabel: function rightLabel() {
	      return this.rightDate.getFullYear() + ' ' + this.t('el.datepicker.year') + ' ' + this.t('el.datepicker.month' + (this.rightDate.getMonth() + 1));
	    },
	    leftYear: function leftYear() {
	      return this.leftDate.getFullYear();
	    },
	    leftMonth: function leftMonth() {
	      return this.leftDate.getMonth();
	    },
	    leftMonthDate: function leftMonthDate() {
	      return this.leftDate.getDate();
	    },
	    rightYear: function rightYear() {
	      return this.rightDate.getFullYear();
	    },
	    rightMonth: function rightMonth() {
	      return this.rightDate.getMonth();
	    },
	    rightMonthDate: function rightMonthDate() {
	      return this.rightDate.getDate();
	    },
	    minVisibleDate: function minVisibleDate() {
	      if (this.dateUserInput.min !== null) return this.dateUserInput.min;
	      if (this.minDate) return Object(date_util_["formatDate"])(this.minDate, this.dateFormat);
	      return '';
	    },
	    maxVisibleDate: function maxVisibleDate() {
	      if (this.dateUserInput.max !== null) return this.dateUserInput.max;
	      if (this.maxDate || this.minDate) return Object(date_util_["formatDate"])(this.maxDate || this.minDate, this.dateFormat);
	      return '';
	    },
	    minVisibleTime: function minVisibleTime() {
	      if (this.timeUserInput.min !== null) return this.timeUserInput.min;
	      if (this.minDate) return Object(date_util_["formatDate"])(this.minDate, this.timeFormat);
	      return '';
	    },
	    maxVisibleTime: function maxVisibleTime() {
	      if (this.timeUserInput.max !== null) return this.timeUserInput.max;
	      if (this.maxDate || this.minDate) return Object(date_util_["formatDate"])(this.maxDate || this.minDate, this.timeFormat);
	      return '';
	    },
	    timeFormat: function timeFormat() {
	      if (this.format) {
	        return Object(date_util_["extractTimeFormat"])(this.format);
	      } else {
	        return 'HH:mm:ss';
	      }
	    },
	    dateFormat: function dateFormat() {
	      if (this.format) {
	        return Object(date_util_["extractDateFormat"])(this.format);
	      } else {
	        return 'yyyy-MM-dd';
	      }
	    },
	    enableMonthArrow: function enableMonthArrow() {
	      var nextMonth = (this.leftMonth + 1) % 12;
	      var yearOffset = this.leftMonth + 1 >= 12 ? 1 : 0;
	      return this.unlinkPanels && new Date(this.leftYear + yearOffset, nextMonth) < new Date(this.rightYear, this.rightMonth);
	    },
	    enableYearArrow: function enableYearArrow() {
	      return this.unlinkPanels && this.rightYear * 12 + this.rightMonth - (this.leftYear * 12 + this.leftMonth + 1) >= 12;
	    }
	  },
	
	  data: function data() {
	    return {
	      popperClass: '',
	      value: [],
	      defaultValue: null,
	      defaultTime: null,
	      minDate: '',
	      maxDate: '',
	      leftDate: new Date(),
	      rightDate: Object(date_util_["nextMonth"])(new Date()),
	      rangeState: {
	        endDate: null,
	        selecting: false,
	        row: null,
	        column: null
	      },
	      showTime: false,
	      shortcuts: '',
	      visible: '',
	      disabledDate: '',
	      cellClassName: '',
	      firstDayOfWeek: 7,
	      minTimePickerVisible: false,
	      maxTimePickerVisible: false,
	      format: '',
	      arrowControl: false,
	      unlinkPanels: false,
	      dateUserInput: {
	        min: null,
	        max: null
	      },
	      timeUserInput: {
	        min: null,
	        max: null
	      }
	    };
	  },
	
	
	  watch: {
	    minDate: function minDate(val) {
	      var _this = this;
	
	      this.dateUserInput.min = null;
	      this.timeUserInput.min = null;
	      this.$nextTick(function () {
	        if (_this.$refs.maxTimePicker && _this.maxDate && _this.maxDate < _this.minDate) {
	          var format = 'HH:mm:ss';
	          _this.$refs.maxTimePicker.selectableRange = [[Object(date_util_["parseDate"])(Object(date_util_["formatDate"])(_this.minDate, format), format), Object(date_util_["parseDate"])('23:59:59', format)]];
	        }
	      });
	      if (val && this.$refs.minTimePicker) {
	        this.$refs.minTimePicker.date = val;
	        this.$refs.minTimePicker.value = val;
	      }
	    },
	    maxDate: function maxDate(val) {
	      this.dateUserInput.max = null;
	      this.timeUserInput.max = null;
	      if (val && this.$refs.maxTimePicker) {
	        this.$refs.maxTimePicker.date = val;
	        this.$refs.maxTimePicker.value = val;
	      }
	    },
	    minTimePickerVisible: function minTimePickerVisible(val) {
	      var _this2 = this;
	
	      if (val) {
	        this.$nextTick(function () {
	          _this2.$refs.minTimePicker.date = _this2.minDate;
	          _this2.$refs.minTimePicker.value = _this2.minDate;
	          _this2.$refs.minTimePicker.adjustSpinners();
	        });
	      }
	    },
	    maxTimePickerVisible: function maxTimePickerVisible(val) {
	      var _this3 = this;
	
	      if (val) {
	        this.$nextTick(function () {
	          _this3.$refs.maxTimePicker.date = _this3.maxDate;
	          _this3.$refs.maxTimePicker.value = _this3.maxDate;
	          _this3.$refs.maxTimePicker.adjustSpinners();
	        });
	      }
	    },
	    value: function value(newVal) {
	      if (!newVal) {
	        this.minDate = null;
	        this.maxDate = null;
	      } else if (Array.isArray(newVal)) {
	        this.minDate = Object(date_util_["isDate"])(newVal[0]) ? new Date(newVal[0]) : null;
	        this.maxDate = Object(date_util_["isDate"])(newVal[1]) ? new Date(newVal[1]) : null;
	        if (this.minDate) {
	          this.leftDate = this.minDate;
	          if (this.unlinkPanels && this.maxDate) {
	            var minDateYear = this.minDate.getFullYear();
	            var minDateMonth = this.minDate.getMonth();
	            var maxDateYear = this.maxDate.getFullYear();
	            var maxDateMonth = this.maxDate.getMonth();
	            this.rightDate = minDateYear === maxDateYear && minDateMonth === maxDateMonth ? Object(date_util_["nextMonth"])(this.maxDate) : this.maxDate;
	          } else {
	            this.rightDate = Object(date_util_["nextMonth"])(this.leftDate);
	          }
	        } else {
	          this.leftDate = date_rangevue_type_script_lang_js_calcDefaultValue(this.defaultValue)[0];
	          this.rightDate = Object(date_util_["nextMonth"])(this.leftDate);
	        }
	      }
	    },
	    defaultValue: function defaultValue(val) {
	      if (!Array.isArray(this.value)) {
	        var _calcDefaultValue = date_rangevue_type_script_lang_js_calcDefaultValue(val),
	            left = _calcDefaultValue[0],
	            right = _calcDefaultValue[1];
	
	        this.leftDate = left;
	        this.rightDate = val && val[1] && this.unlinkPanels ? right : Object(date_util_["nextMonth"])(this.leftDate);
	      }
	    }
	  },
	
	  methods: {
	    handleClear: function handleClear() {
	      this.minDate = null;
	      this.maxDate = null;
	      this.leftDate = date_rangevue_type_script_lang_js_calcDefaultValue(this.defaultValue)[0];
	      this.rightDate = Object(date_util_["nextMonth"])(this.leftDate);
	      this.$emit('pick', null);
	    },
	    handleChangeRange: function handleChangeRange(val) {
	      this.minDate = val.minDate;
	      this.maxDate = val.maxDate;
	      this.rangeState = val.rangeState;
	    },
	    handleDateInput: function handleDateInput(value, type) {
	      this.dateUserInput[type] = value;
	      if (value.length !== this.dateFormat.length) return;
	      var parsedValue = Object(date_util_["parseDate"])(value, this.dateFormat);
	
	      if (parsedValue) {
	        if (typeof this.disabledDate === 'function' && this.disabledDate(new Date(parsedValue))) {
	          return;
	        }
	        if (type === 'min') {
	          this.minDate = Object(date_util_["modifyDate"])(this.minDate || new Date(), parsedValue.getFullYear(), parsedValue.getMonth(), parsedValue.getDate());
	          this.leftDate = new Date(parsedValue);
	          if (!this.unlinkPanels) {
	            this.rightDate = Object(date_util_["nextMonth"])(this.leftDate);
	          }
	        } else {
	          this.maxDate = Object(date_util_["modifyDate"])(this.maxDate || new Date(), parsedValue.getFullYear(), parsedValue.getMonth(), parsedValue.getDate());
	          this.rightDate = new Date(parsedValue);
	          if (!this.unlinkPanels) {
	            this.leftDate = Object(date_util_["prevMonth"])(parsedValue);
	          }
	        }
	      }
	    },
	    handleDateChange: function handleDateChange(value, type) {
	      var parsedValue = Object(date_util_["parseDate"])(value, this.dateFormat);
	      if (parsedValue) {
	        if (type === 'min') {
	          this.minDate = Object(date_util_["modifyDate"])(this.minDate, parsedValue.getFullYear(), parsedValue.getMonth(), parsedValue.getDate());
	          if (this.minDate > this.maxDate) {
	            this.maxDate = this.minDate;
	          }
	        } else {
	          this.maxDate = Object(date_util_["modifyDate"])(this.maxDate, parsedValue.getFullYear(), parsedValue.getMonth(), parsedValue.getDate());
	          if (this.maxDate < this.minDate) {
	            this.minDate = this.maxDate;
	          }
	        }
	      }
	    },
	    handleTimeInput: function handleTimeInput(value, type) {
	      var _this4 = this;
	
	      this.timeUserInput[type] = value;
	      if (value.length !== this.timeFormat.length) return;
	      var parsedValue = Object(date_util_["parseDate"])(value, this.timeFormat);
	
	      if (parsedValue) {
	        if (type === 'min') {
	          this.minDate = Object(date_util_["modifyTime"])(this.minDate, parsedValue.getHours(), parsedValue.getMinutes(), parsedValue.getSeconds());
	          this.$nextTick(function (_) {
	            return _this4.$refs.minTimePicker.adjustSpinners();
	          });
	        } else {
	          this.maxDate = Object(date_util_["modifyTime"])(this.maxDate, parsedValue.getHours(), parsedValue.getMinutes(), parsedValue.getSeconds());
	          this.$nextTick(function (_) {
	            return _this4.$refs.maxTimePicker.adjustSpinners();
	          });
	        }
	      }
	    },
	    handleTimeChange: function handleTimeChange(value, type) {
	      var parsedValue = Object(date_util_["parseDate"])(value, this.timeFormat);
	      if (parsedValue) {
	        if (type === 'min') {
	          this.minDate = Object(date_util_["modifyTime"])(this.minDate, parsedValue.getHours(), parsedValue.getMinutes(), parsedValue.getSeconds());
	          if (this.minDate > this.maxDate) {
	            this.maxDate = this.minDate;
	          }
	          this.$refs.minTimePicker.value = this.minDate;
	          this.minTimePickerVisible = false;
	        } else {
	          this.maxDate = Object(date_util_["modifyTime"])(this.maxDate, parsedValue.getHours(), parsedValue.getMinutes(), parsedValue.getSeconds());
	          if (this.maxDate < this.minDate) {
	            this.minDate = this.maxDate;
	          }
	          this.$refs.maxTimePicker.value = this.minDate;
	          this.maxTimePickerVisible = false;
	        }
	      }
	    },
	    handleRangePick: function handleRangePick(val) {
	      var _this5 = this;
	
	      var close = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	      var defaultTime = this.defaultTime || [];
	      var minDate = Object(date_util_["modifyWithTimeString"])(val.minDate, defaultTime[0]);
	      var maxDate = Object(date_util_["modifyWithTimeString"])(val.maxDate, defaultTime[1]);
	
	      if (this.maxDate === maxDate && this.minDate === minDate) {
	        return;
	      }
	      this.onPick && this.onPick(val);
	      this.maxDate = maxDate;
	      this.minDate = minDate;
	
	      // workaround for https://github.com/ElemeFE/element/issues/7539, should remove this block when we don't have to care about Chromium 55 - 57
	      setTimeout(function () {
	        _this5.maxDate = maxDate;
	        _this5.minDate = minDate;
	      }, 10);
	      if (!close || this.showTime) return;
	      this.handleConfirm();
	    },
	    handleShortcutClick: function handleShortcutClick(shortcut) {
	      if (shortcut.onClick) {
	        shortcut.onClick(this);
	      }
	    },
	    handleMinTimePick: function handleMinTimePick(value, visible, first) {
	      this.minDate = this.minDate || new Date();
	      if (value) {
	        this.minDate = Object(date_util_["modifyTime"])(this.minDate, value.getHours(), value.getMinutes(), value.getSeconds());
	      }
	
	      if (!first) {
	        this.minTimePickerVisible = visible;
	      }
	
	      if (!this.maxDate || this.maxDate && this.maxDate.getTime() < this.minDate.getTime()) {
	        this.maxDate = new Date(this.minDate);
	      }
	    },
	    handleMinTimeClose: function handleMinTimeClose() {
	      this.minTimePickerVisible = false;
	    },
	    handleMaxTimePick: function handleMaxTimePick(value, visible, first) {
	      if (this.maxDate && value) {
	        this.maxDate = Object(date_util_["modifyTime"])(this.maxDate, value.getHours(), value.getMinutes(), value.getSeconds());
	      }
	
	      if (!first) {
	        this.maxTimePickerVisible = visible;
	      }
	
	      if (this.maxDate && this.minDate && this.minDate.getTime() > this.maxDate.getTime()) {
	        this.minDate = new Date(this.maxDate);
	      }
	    },
	    handleMaxTimeClose: function handleMaxTimeClose() {
	      this.maxTimePickerVisible = false;
	    },
	
	
	    // leftPrev*, rightNext* need to take care of `unlinkPanels`
	    leftPrevYear: function leftPrevYear() {
	      this.leftDate = Object(date_util_["prevYear"])(this.leftDate);
	      if (!this.unlinkPanels) {
	        this.rightDate = Object(date_util_["nextMonth"])(this.leftDate);
	      }
	    },
	    leftPrevMonth: function leftPrevMonth() {
	      this.leftDate = Object(date_util_["prevMonth"])(this.leftDate);
	      if (!this.unlinkPanels) {
	        this.rightDate = Object(date_util_["nextMonth"])(this.leftDate);
	      }
	    },
	    rightNextYear: function rightNextYear() {
	      if (!this.unlinkPanels) {
	        this.leftDate = Object(date_util_["nextYear"])(this.leftDate);
	        this.rightDate = Object(date_util_["nextMonth"])(this.leftDate);
	      } else {
	        this.rightDate = Object(date_util_["nextYear"])(this.rightDate);
	      }
	    },
	    rightNextMonth: function rightNextMonth() {
	      if (!this.unlinkPanels) {
	        this.leftDate = Object(date_util_["nextMonth"])(this.leftDate);
	        this.rightDate = Object(date_util_["nextMonth"])(this.leftDate);
	      } else {
	        this.rightDate = Object(date_util_["nextMonth"])(this.rightDate);
	      }
	    },
	
	
	    // leftNext*, rightPrev* are called when `unlinkPanels` is true
	    leftNextYear: function leftNextYear() {
	      this.leftDate = Object(date_util_["nextYear"])(this.leftDate);
	    },
	    leftNextMonth: function leftNextMonth() {
	      this.leftDate = Object(date_util_["nextMonth"])(this.leftDate);
	    },
	    rightPrevYear: function rightPrevYear() {
	      this.rightDate = Object(date_util_["prevYear"])(this.rightDate);
	    },
	    rightPrevMonth: function rightPrevMonth() {
	      this.rightDate = Object(date_util_["prevMonth"])(this.rightDate);
	    },
	    handleConfirm: function handleConfirm() {
	      var visible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      if (this.isValidValue([this.minDate, this.maxDate])) {
	        this.$emit('pick', [this.minDate, this.maxDate], visible);
	      }
	    },
	    isValidValue: function isValidValue(value) {
	      return Array.isArray(value) && value && value[0] && value[1] && Object(date_util_["isDate"])(value[0]) && Object(date_util_["isDate"])(value[1]) && value[0].getTime() <= value[1].getTime() && (typeof this.disabledDate === 'function' ? !this.disabledDate(value[0]) && !this.disabledDate(value[1]) : true);
	    },
	    resetView: function resetView() {
	      // NOTE: this is a hack to reset {min, max}Date on picker open.
	      // TODO: correct way of doing so is to refactor {min, max}Date to be dependent on value and internal selection state
	      //       an alternative would be resetView whenever picker becomes visible, should also investigate date-panel's resetView
	      if (this.minDate && this.maxDate == null) this.rangeState.selecting = false;
	      this.minDate = this.value && Object(date_util_["isDate"])(this.value[0]) ? new Date(this.value[0]) : null;
	      this.maxDate = this.value && Object(date_util_["isDate"])(this.value[0]) ? new Date(this.value[1]) : null;
	    }
	  },
	
	  components: { TimePicker: panel_time, DateTable: date_table, ElInput: input_default.a, ElButton: button_default.a }
	});
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/date-range.vue?vue&type=script&lang=js&
	 /* harmony default export */ var panel_date_rangevue_type_script_lang_js_ = (date_rangevue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/date-range.vue
	
	
	
	
	
	/* normalize component */
	
	var date_range_component = normalizeComponent(
	  panel_date_rangevue_type_script_lang_js_,
	  date_rangevue_type_template_id_2652849a_render,
	  date_rangevue_type_template_id_2652849a_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var date_range_api; }
	date_range_component.options.__file = "packages/date-picker/src/panel/date-range.vue"
	/* harmony default export */ var date_range = (date_range_component.exports);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/month-range.vue?vue&type=template&id=f2645fb8&
	var month_rangevue_type_template_id_f2645fb8_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "transition",
	    {
	      attrs: { name: "el-zoom-in-top" },
	      on: {
	        "after-leave": function($event) {
	          _vm.$emit("dodestroy")
	        }
	      }
	    },
	    [
	      _c(
	        "div",
	        {
	          directives: [
	            {
	              name: "show",
	              rawName: "v-show",
	              value: _vm.visible,
	              expression: "visible"
	            }
	          ],
	          staticClass: "el-picker-panel el-date-range-picker el-popper",
	          class: [
	            {
	              "has-sidebar": _vm.$slots.sidebar || _vm.shortcuts
	            },
	            _vm.popperClass
	          ]
	        },
	        [
	          _c(
	            "div",
	            { staticClass: "el-picker-panel__body-wrapper" },
	            [
	              _vm._t("sidebar"),
	              _vm.shortcuts
	                ? _c(
	                    "div",
	                    { staticClass: "el-picker-panel__sidebar" },
	                    _vm._l(_vm.shortcuts, function(shortcut, key) {
	                      return _c(
	                        "button",
	                        {
	                          key: key,
	                          staticClass: "el-picker-panel__shortcut",
	                          attrs: { type: "button" },
	                          on: {
	                            click: function($event) {
	                              _vm.handleShortcutClick(shortcut)
	                            }
	                          }
	                        },
	                        [_vm._v(_vm._s(shortcut.text))]
	                      )
	                    }),
	                    0
	                  )
	                : _vm._e(),
	              _c("div", { staticClass: "el-picker-panel__body" }, [
	                _c(
	                  "div",
	                  {
	                    staticClass:
	                      "el-picker-panel__content el-date-range-picker__content is-left"
	                  },
	                  [
	                    _c("div", { staticClass: "el-date-range-picker__header" }, [
	                      _c("button", {
	                        staticClass:
	                          "el-picker-panel__icon-btn el-icon-d-arrow-left",
	                        attrs: { type: "button" },
	                        on: { click: _vm.leftPrevYear }
	                      }),
	                      _vm.unlinkPanels
	                        ? _c("button", {
	                            staticClass:
	                              "el-picker-panel__icon-btn el-icon-d-arrow-right",
	                            class: { "is-disabled": !_vm.enableYearArrow },
	                            attrs: {
	                              type: "button",
	                              disabled: !_vm.enableYearArrow
	                            },
	                            on: { click: _vm.leftNextYear }
	                          })
	                        : _vm._e(),
	                      _c("div", [_vm._v(_vm._s(_vm.leftLabel))])
	                    ]),
	                    _c("month-table", {
	                      attrs: {
	                        "selection-mode": "range",
	                        date: _vm.leftDate,
	                        "default-value": _vm.defaultValue,
	                        "min-date": _vm.minDate,
	                        "max-date": _vm.maxDate,
	                        "range-state": _vm.rangeState,
	                        "disabled-date": _vm.disabledDate
	                      },
	                      on: {
	                        changerange: _vm.handleChangeRange,
	                        pick: _vm.handleRangePick
	                      }
	                    })
	                  ],
	                  1
	                ),
	                _c(
	                  "div",
	                  {
	                    staticClass:
	                      "el-picker-panel__content el-date-range-picker__content is-right"
	                  },
	                  [
	                    _c("div", { staticClass: "el-date-range-picker__header" }, [
	                      _vm.unlinkPanels
	                        ? _c("button", {
	                            staticClass:
	                              "el-picker-panel__icon-btn el-icon-d-arrow-left",
	                            class: { "is-disabled": !_vm.enableYearArrow },
	                            attrs: {
	                              type: "button",
	                              disabled: !_vm.enableYearArrow
	                            },
	                            on: { click: _vm.rightPrevYear }
	                          })
	                        : _vm._e(),
	                      _c("button", {
	                        staticClass:
	                          "el-picker-panel__icon-btn el-icon-d-arrow-right",
	                        attrs: { type: "button" },
	                        on: { click: _vm.rightNextYear }
	                      }),
	                      _c("div", [_vm._v(_vm._s(_vm.rightLabel))])
	                    ]),
	                    _c("month-table", {
	                      attrs: {
	                        "selection-mode": "range",
	                        date: _vm.rightDate,
	                        "default-value": _vm.defaultValue,
	                        "min-date": _vm.minDate,
	                        "max-date": _vm.maxDate,
	                        "range-state": _vm.rangeState,
	                        "disabled-date": _vm.disabledDate
	                      },
	                      on: {
	                        changerange: _vm.handleChangeRange,
	                        pick: _vm.handleRangePick
	                      }
	                    })
	                  ],
	                  1
	                )
	              ])
	            ],
	            2
	          )
	        ]
	      )
	    ]
	  )
	}
	var month_rangevue_type_template_id_f2645fb8_staticRenderFns = []
	month_rangevue_type_template_id_f2645fb8_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/month-range.vue?vue&type=template&id=f2645fb8&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/month-range.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	
	var month_rangevue_type_script_lang_js_calcDefaultValue = function calcDefaultValue(defaultValue) {
	  if (Array.isArray(defaultValue)) {
	    return [new Date(defaultValue[0]), new Date(defaultValue[1])];
	  } else if (defaultValue) {
	    return [new Date(defaultValue), Object(date_util_["nextMonth"])(new Date(defaultValue))];
	  } else {
	    return [new Date(), Object(date_util_["nextMonth"])(new Date())];
	  }
	};
	/* harmony default export */ var month_rangevue_type_script_lang_js_ = ({
	  mixins: [locale_default.a],
	
	  directives: { Clickoutside: clickoutside_default.a },
	
	  computed: {
	    btnDisabled: function btnDisabled() {
	      return !(this.minDate && this.maxDate && !this.selecting && this.isValidValue([this.minDate, this.maxDate]));
	    },
	    leftLabel: function leftLabel() {
	      return this.leftDate.getFullYear() + ' ' + this.t('el.datepicker.year');
	    },
	    rightLabel: function rightLabel() {
	      return this.rightDate.getFullYear() + ' ' + this.t('el.datepicker.year');
	    },
	    leftYear: function leftYear() {
	      return this.leftDate.getFullYear();
	    },
	    rightYear: function rightYear() {
	      return this.rightDate.getFullYear() === this.leftDate.getFullYear() ? this.leftDate.getFullYear() + 1 : this.rightDate.getFullYear();
	    },
	    enableYearArrow: function enableYearArrow() {
	      return this.unlinkPanels && this.rightYear > this.leftYear + 1;
	    }
	  },
	
	  data: function data() {
	    return {
	      popperClass: '',
	      value: [],
	      defaultValue: null,
	      defaultTime: null,
	      minDate: '',
	      maxDate: '',
	      leftDate: new Date(),
	      rightDate: Object(date_util_["nextYear"])(new Date()),
	      rangeState: {
	        endDate: null,
	        selecting: false,
	        row: null,
	        column: null
	      },
	      shortcuts: '',
	      visible: '',
	      disabledDate: '',
	      format: '',
	      arrowControl: false,
	      unlinkPanels: false
	    };
	  },
	
	
	  watch: {
	    value: function value(newVal) {
	      if (!newVal) {
	        this.minDate = null;
	        this.maxDate = null;
	      } else if (Array.isArray(newVal)) {
	        this.minDate = Object(date_util_["isDate"])(newVal[0]) ? new Date(newVal[0]) : null;
	        this.maxDate = Object(date_util_["isDate"])(newVal[1]) ? new Date(newVal[1]) : null;
	        if (this.minDate) {
	          this.leftDate = this.minDate;
	          if (this.unlinkPanels && this.maxDate) {
	            var minDateYear = this.minDate.getFullYear();
	            var maxDateYear = this.maxDate.getFullYear();
	            this.rightDate = minDateYear === maxDateYear ? Object(date_util_["nextYear"])(this.maxDate) : this.maxDate;
	          } else {
	            this.rightDate = Object(date_util_["nextYear"])(this.leftDate);
	          }
	        } else {
	          this.leftDate = month_rangevue_type_script_lang_js_calcDefaultValue(this.defaultValue)[0];
	          this.rightDate = Object(date_util_["nextYear"])(this.leftDate);
	        }
	      }
	    },
	    defaultValue: function defaultValue(val) {
	      if (!Array.isArray(this.value)) {
	        var _calcDefaultValue = month_rangevue_type_script_lang_js_calcDefaultValue(val),
	            left = _calcDefaultValue[0],
	            right = _calcDefaultValue[1];
	
	        this.leftDate = left;
	        this.rightDate = val && val[1] && left.getFullYear() !== right.getFullYear() && this.unlinkPanels ? right : Object(date_util_["nextYear"])(this.leftDate);
	      }
	    }
	  },
	
	  methods: {
	    handleClear: function handleClear() {
	      this.minDate = null;
	      this.maxDate = null;
	      this.leftDate = month_rangevue_type_script_lang_js_calcDefaultValue(this.defaultValue)[0];
	      this.rightDate = Object(date_util_["nextYear"])(this.leftDate);
	      this.$emit('pick', null);
	    },
	    handleChangeRange: function handleChangeRange(val) {
	      this.minDate = val.minDate;
	      this.maxDate = val.maxDate;
	      this.rangeState = val.rangeState;
	    },
	    handleRangePick: function handleRangePick(val) {
	      var _this = this;
	
	      var close = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	      var defaultTime = this.defaultTime || [];
	      var minDate = Object(date_util_["modifyWithTimeString"])(val.minDate, defaultTime[0]);
	      var maxDate = Object(date_util_["modifyWithTimeString"])(val.maxDate, defaultTime[1]);
	      if (this.maxDate === maxDate && this.minDate === minDate) {
	        return;
	      }
	      this.onPick && this.onPick(val);
	      this.maxDate = maxDate;
	      this.minDate = minDate;
	
	      // workaround for https://github.com/ElemeFE/element/issues/7539, should remove this block when we don't have to care about Chromium 55 - 57
	      setTimeout(function () {
	        _this.maxDate = maxDate;
	        _this.minDate = minDate;
	      }, 10);
	      if (!close) return;
	      this.handleConfirm();
	    },
	    handleShortcutClick: function handleShortcutClick(shortcut) {
	      if (shortcut.onClick) {
	        shortcut.onClick(this);
	      }
	    },
	
	
	    // leftPrev*, rightNext* need to take care of `unlinkPanels`
	    leftPrevYear: function leftPrevYear() {
	      this.leftDate = Object(date_util_["prevYear"])(this.leftDate);
	      if (!this.unlinkPanels) {
	        this.rightDate = Object(date_util_["prevYear"])(this.rightDate);
	      }
	    },
	    rightNextYear: function rightNextYear() {
	      if (!this.unlinkPanels) {
	        this.leftDate = Object(date_util_["nextYear"])(this.leftDate);
	      }
	      this.rightDate = Object(date_util_["nextYear"])(this.rightDate);
	    },
	
	
	    // leftNext*, rightPrev* are called when `unlinkPanels` is true
	    leftNextYear: function leftNextYear() {
	      this.leftDate = Object(date_util_["nextYear"])(this.leftDate);
	    },
	    rightPrevYear: function rightPrevYear() {
	      this.rightDate = Object(date_util_["prevYear"])(this.rightDate);
	    },
	    handleConfirm: function handleConfirm() {
	      var visible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      if (this.isValidValue([this.minDate, this.maxDate])) {
	        this.$emit('pick', [this.minDate, this.maxDate], visible);
	      }
	    },
	    isValidValue: function isValidValue(value) {
	      return Array.isArray(value) && value && value[0] && value[1] && Object(date_util_["isDate"])(value[0]) && Object(date_util_["isDate"])(value[1]) && value[0].getTime() <= value[1].getTime() && (typeof this.disabledDate === 'function' ? !this.disabledDate(value[0]) && !this.disabledDate(value[1]) : true);
	    },
	    resetView: function resetView() {
	      // NOTE: this is a hack to reset {min, max}Date on picker open.
	      // TODO: correct way of doing so is to refactor {min, max}Date to be dependent on value and internal selection state
	      //       an alternative would be resetView whenever picker becomes visible, should also investigate date-panel's resetView
	      this.minDate = this.value && Object(date_util_["isDate"])(this.value[0]) ? new Date(this.value[0]) : null;
	      this.maxDate = this.value && Object(date_util_["isDate"])(this.value[0]) ? new Date(this.value[1]) : null;
	    }
	  },
	
	  components: { MonthTable: month_table, ElInput: input_default.a, ElButton: button_default.a }
	});
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/month-range.vue?vue&type=script&lang=js&
	 /* harmony default export */ var panel_month_rangevue_type_script_lang_js_ = (month_rangevue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/month-range.vue
	
	
	
	
	
	/* normalize component */
	
	var month_range_component = normalizeComponent(
	  panel_month_rangevue_type_script_lang_js_,
	  month_rangevue_type_template_id_f2645fb8_render,
	  month_rangevue_type_template_id_f2645fb8_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var month_range_api; }
	month_range_component.options.__file = "packages/date-picker/src/panel/month-range.vue"
	/* harmony default export */ var month_range = (month_range_component.exports);
	// CONCATENATED MODULE: ./packages/date-picker/src/picker/date-picker.js
	
	
	
	
	
	var date_picker_getPanel = function getPanel(type) {
	  if (type === 'daterange' || type === 'datetimerange') {
	    return date_range;
	  } else if (type === 'monthrange') {
	    return month_range;
	  }
	  return panel_date;
	};
	
	/* harmony default export */ var date_picker = ({
	  mixins: [picker],
	
	  name: 'ElDatePicker',
	
	  props: {
	    type: {
	      type: String,
	      default: 'date'
	    },
	    timeArrowControl: Boolean
	  },
	
	  watch: {
	    type: function type(_type) {
	      if (this.picker) {
	        this.unmountPicker();
	        this.panel = date_picker_getPanel(_type);
	        this.mountPicker();
	      } else {
	        this.panel = date_picker_getPanel(_type);
	      }
	    }
	  },
	
	  created: function created() {
	    this.panel = date_picker_getPanel(this.type);
	  }
	});
	// CONCATENATED MODULE: ./packages/date-picker/index.js
	
	
	/* istanbul ignore next */
	date_picker.install = function install(Vue) {
	  Vue.component(date_picker.name, date_picker);
	};
	
	/* harmony default export */ var packages_date_picker = (date_picker);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/time-select.vue?vue&type=template&id=51ab9320&
	var time_selectvue_type_template_id_51ab9320_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "transition",
	    {
	      attrs: { name: "el-zoom-in-top" },
	      on: {
	        "before-enter": _vm.handleMenuEnter,
	        "after-leave": function($event) {
	          _vm.$emit("dodestroy")
	        }
	      }
	    },
	    [
	      _c(
	        "div",
	        {
	          directives: [
	            {
	              name: "show",
	              rawName: "v-show",
	              value: _vm.visible,
	              expression: "visible"
	            }
	          ],
	          ref: "popper",
	          staticClass: "el-picker-panel time-select el-popper",
	          class: _vm.popperClass,
	          style: { width: _vm.width + "px" }
	        },
	        [
	          _c(
	            "el-scrollbar",
	            {
	              attrs: { noresize: "", "wrap-class": "el-picker-panel__content" }
	            },
	            _vm._l(_vm.items, function(item) {
	              return _c(
	                "div",
	                {
	                  key: item.value,
	                  staticClass: "time-select-item",
	                  class: {
	                    selected: _vm.value === item.value,
	                    disabled: item.disabled,
	                    default: item.value === _vm.defaultValue
	                  },
	                  attrs: { disabled: item.disabled },
	                  on: {
	                    click: function($event) {
	                      _vm.handleClick(item)
	                    }
	                  }
	                },
	                [_vm._v(_vm._s(item.value))]
	              )
	            }),
	            0
	          )
	        ],
	        1
	      )
	    ]
	  )
	}
	var time_selectvue_type_template_id_51ab9320_staticRenderFns = []
	time_selectvue_type_template_id_51ab9320_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/time-select.vue?vue&type=template&id=51ab9320&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/time-select.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	var parseTime = function parseTime(time) {
	  var values = (time || '').split(':');
	  if (values.length >= 2) {
	    var hours = parseInt(values[0], 10);
	    var minutes = parseInt(values[1], 10);
	
	    return {
	      hours: hours,
	      minutes: minutes
	    };
	  }
	  /* istanbul ignore next */
	  return null;
	};
	
	var compareTime = function compareTime(time1, time2) {
	  var value1 = parseTime(time1);
	  var value2 = parseTime(time2);
	
	  var minutes1 = value1.minutes + value1.hours * 60;
	  var minutes2 = value2.minutes + value2.hours * 60;
	
	  if (minutes1 === minutes2) {
	    return 0;
	  }
	
	  return minutes1 > minutes2 ? 1 : -1;
	};
	
	var formatTime = function formatTime(time) {
	  return (time.hours < 10 ? '0' + time.hours : time.hours) + ':' + (time.minutes < 10 ? '0' + time.minutes : time.minutes);
	};
	
	var nextTime = function nextTime(time, step) {
	  var timeValue = parseTime(time);
	  var stepValue = parseTime(step);
	
	  var next = {
	    hours: timeValue.hours,
	    minutes: timeValue.minutes
	  };
	
	  next.minutes += stepValue.minutes;
	  next.hours += stepValue.hours;
	
	  next.hours += Math.floor(next.minutes / 60);
	  next.minutes = next.minutes % 60;
	
	  return formatTime(next);
	};
	
	/* harmony default export */ var time_selectvue_type_script_lang_js_ = ({
	  components: { ElScrollbar: scrollbar_default.a },
	
	  watch: {
	    value: function value(val) {
	      var _this = this;
	
	      if (!val) return;
	      this.$nextTick(function () {
	        return _this.scrollToOption();
	      });
	    }
	  },
	
	  methods: {
	    handleClick: function handleClick(item) {
	      if (!item.disabled) {
	        this.$emit('pick', item.value);
	      }
	    },
	    handleClear: function handleClear() {
	      this.$emit('pick', null);
	    },
	    scrollToOption: function scrollToOption() {
	      var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '.selected';
	
	      var menu = this.$refs.popper.querySelector('.el-picker-panel__content');
	      scroll_into_view_default()(menu, menu.querySelector(selector));
	    },
	    handleMenuEnter: function handleMenuEnter() {
	      var _this2 = this;
	
	      var selected = this.items.map(function (item) {
	        return item.value;
	      }).indexOf(this.value) !== -1;
	      var hasDefault = this.items.map(function (item) {
	        return item.value;
	      }).indexOf(this.defaultValue) !== -1;
	      var option = selected && '.selected' || hasDefault && '.default' || '.time-select-item:not(.disabled)';
	      this.$nextTick(function () {
	        return _this2.scrollToOption(option);
	      });
	    },
	    scrollDown: function scrollDown(step) {
	      var items = this.items;
	      var length = items.length;
	      var total = items.length;
	      var index = items.map(function (item) {
	        return item.value;
	      }).indexOf(this.value);
	      while (total--) {
	        index = (index + step + length) % length;
	        if (!items[index].disabled) {
	          this.$emit('pick', items[index].value, true);
	          return;
	        }
	      }
	    },
	    isValidValue: function isValidValue(date) {
	      return this.items.filter(function (item) {
	        return !item.disabled;
	      }).map(function (item) {
	        return item.value;
	      }).indexOf(date) !== -1;
	    },
	    handleKeydown: function handleKeydown(event) {
	      var keyCode = event.keyCode;
	      if (keyCode === 38 || keyCode === 40) {
	        var mapping = { 40: 1, 38: -1 };
	        var offset = mapping[keyCode.toString()];
	        this.scrollDown(offset);
	        event.stopPropagation();
	        return;
	      }
	    }
	  },
	
	  data: function data() {
	    return {
	      popperClass: '',
	      start: '09:00',
	      end: '18:00',
	      step: '00:30',
	      value: '',
	      defaultValue: '',
	      visible: false,
	      minTime: '',
	      maxTime: '',
	      width: 0
	    };
	  },
	
	
	  computed: {
	    items: function items() {
	      var start = this.start;
	      var end = this.end;
	      var step = this.step;
	
	      var result = [];
	
	      if (start && end && step) {
	        var current = start;
	        while (compareTime(current, end) <= 0) {
	          result.push({
	            value: current,
	            disabled: compareTime(current, this.minTime || '-1:-1') <= 0 || compareTime(current, this.maxTime || '100:100') >= 0
	          });
	          current = nextTime(current, step);
	        }
	      }
	
	      return result;
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/time-select.vue?vue&type=script&lang=js&
	 /* harmony default export */ var panel_time_selectvue_type_script_lang_js_ = (time_selectvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/time-select.vue
	
	
	
	
	
	/* normalize component */
	
	var time_select_component = normalizeComponent(
	  panel_time_selectvue_type_script_lang_js_,
	  time_selectvue_type_template_id_51ab9320_render,
	  time_selectvue_type_template_id_51ab9320_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var time_select_api; }
	time_select_component.options.__file = "packages/date-picker/src/panel/time-select.vue"
	/* harmony default export */ var time_select = (time_select_component.exports);
	// CONCATENATED MODULE: ./packages/date-picker/src/picker/time-select.js
	
	
	
	/* harmony default export */ var picker_time_select = ({
	  mixins: [picker],
	
	  name: 'ElTimeSelect',
	
	  componentName: 'ElTimeSelect',
	
	  props: {
	    type: {
	      type: String,
	      default: 'time-select'
	    }
	  },
	
	  beforeCreate: function beforeCreate() {
	    this.panel = time_select;
	  }
	});
	// CONCATENATED MODULE: ./packages/time-select/index.js
	
	
	/* istanbul ignore next */
	picker_time_select.install = function (Vue) {
	  Vue.component(picker_time_select.name, picker_time_select);
	};
	
	/* harmony default export */ var packages_time_select = (picker_time_select);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/time-range.vue?vue&type=template&id=fb28660e&
	var time_rangevue_type_template_id_fb28660e_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "transition",
	    {
	      attrs: { name: "el-zoom-in-top" },
	      on: {
	        "after-leave": function($event) {
	          _vm.$emit("dodestroy")
	        }
	      }
	    },
	    [
	      _c(
	        "div",
	        {
	          directives: [
	            {
	              name: "show",
	              rawName: "v-show",
	              value: _vm.visible,
	              expression: "visible"
	            }
	          ],
	          staticClass: "el-time-range-picker el-picker-panel el-popper",
	          class: _vm.popperClass
	        },
	        [
	          _c("div", { staticClass: "el-time-range-picker__content" }, [
	            _c("div", { staticClass: "el-time-range-picker__cell" }, [
	              _c("div", { staticClass: "el-time-range-picker__header" }, [
	                _vm._v(_vm._s(_vm.t("el.datepicker.startTime")))
	              ]),
	              _c(
	                "div",
	                {
	                  staticClass:
	                    "el-time-range-picker__body el-time-panel__content",
	                  class: {
	                    "has-seconds": _vm.showSeconds,
	                    "is-arrow": _vm.arrowControl
	                  }
	                },
	                [
	                  _c("time-spinner", {
	                    ref: "minSpinner",
	                    attrs: {
	                      "show-seconds": _vm.showSeconds,
	                      "am-pm-mode": _vm.amPmMode,
	                      "arrow-control": _vm.arrowControl,
	                      date: _vm.minDate
	                    },
	                    on: {
	                      change: _vm.handleMinChange,
	                      "select-range": _vm.setMinSelectionRange
	                    }
	                  })
	                ],
	                1
	              )
	            ]),
	            _c("div", { staticClass: "el-time-range-picker__cell" }, [
	              _c("div", { staticClass: "el-time-range-picker__header" }, [
	                _vm._v(_vm._s(_vm.t("el.datepicker.endTime")))
	              ]),
	              _c(
	                "div",
	                {
	                  staticClass:
	                    "el-time-range-picker__body el-time-panel__content",
	                  class: {
	                    "has-seconds": _vm.showSeconds,
	                    "is-arrow": _vm.arrowControl
	                  }
	                },
	                [
	                  _c("time-spinner", {
	                    ref: "maxSpinner",
	                    attrs: {
	                      "show-seconds": _vm.showSeconds,
	                      "am-pm-mode": _vm.amPmMode,
	                      "arrow-control": _vm.arrowControl,
	                      date: _vm.maxDate
	                    },
	                    on: {
	                      change: _vm.handleMaxChange,
	                      "select-range": _vm.setMaxSelectionRange
	                    }
	                  })
	                ],
	                1
	              )
	            ])
	          ]),
	          _c("div", { staticClass: "el-time-panel__footer" }, [
	            _c(
	              "button",
	              {
	                staticClass: "el-time-panel__btn cancel",
	                attrs: { type: "button" },
	                on: {
	                  click: function($event) {
	                    _vm.handleCancel()
	                  }
	                }
	              },
	              [_vm._v(_vm._s(_vm.t("el.datepicker.cancel")))]
	            ),
	            _c(
	              "button",
	              {
	                staticClass: "el-time-panel__btn confirm",
	                attrs: { type: "button", disabled: _vm.btnDisabled },
	                on: {
	                  click: function($event) {
	                    _vm.handleConfirm()
	                  }
	                }
	              },
	              [_vm._v(_vm._s(_vm.t("el.datepicker.confirm")))]
	            )
	          ])
	        ]
	      )
	    ]
	  )
	}
	var time_rangevue_type_template_id_fb28660e_staticRenderFns = []
	time_rangevue_type_template_id_fb28660e_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/time-range.vue?vue&type=template&id=fb28660e&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/time-range.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	var MIN_TIME = Object(date_util_["parseDate"])('00:00:00', 'HH:mm:ss');
	var MAX_TIME = Object(date_util_["parseDate"])('23:59:59', 'HH:mm:ss');
	
	var time_rangevue_type_script_lang_js_minTimeOfDay = function minTimeOfDay(date) {
	  return Object(date_util_["modifyDate"])(MIN_TIME, date.getFullYear(), date.getMonth(), date.getDate());
	};
	
	var time_rangevue_type_script_lang_js_maxTimeOfDay = function maxTimeOfDay(date) {
	  return Object(date_util_["modifyDate"])(MAX_TIME, date.getFullYear(), date.getMonth(), date.getDate());
	};
	
	// increase time by amount of milliseconds, but within the range of day
	var advanceTime = function advanceTime(date, amount) {
	  return new Date(Math.min(date.getTime() + amount, time_rangevue_type_script_lang_js_maxTimeOfDay(date).getTime()));
	};
	
	/* harmony default export */ var time_rangevue_type_script_lang_js_ = ({
	  mixins: [locale_default.a],
	
	  components: { TimeSpinner: time_spinner },
	
	  computed: {
	    showSeconds: function showSeconds() {
	      return (this.format || '').indexOf('ss') !== -1;
	    },
	    offset: function offset() {
	      return this.showSeconds ? 11 : 8;
	    },
	    spinner: function spinner() {
	      return this.selectionRange[0] < this.offset ? this.$refs.minSpinner : this.$refs.maxSpinner;
	    },
	    btnDisabled: function btnDisabled() {
	      return this.minDate.getTime() > this.maxDate.getTime();
	    },
	    amPmMode: function amPmMode() {
	      if ((this.format || '').indexOf('A') !== -1) return 'A';
	      if ((this.format || '').indexOf('a') !== -1) return 'a';
	      return '';
	    }
	  },
	
	  data: function data() {
	    return {
	      popperClass: '',
	      minDate: new Date(),
	      maxDate: new Date(),
	      value: [],
	      oldValue: [new Date(), new Date()],
	      defaultValue: null,
	      format: 'HH:mm:ss',
	      visible: false,
	      selectionRange: [0, 2],
	      arrowControl: false
	    };
	  },
	
	
	  watch: {
	    value: function value(_value) {
	      if (Array.isArray(_value)) {
	        this.minDate = new Date(_value[0]);
	        this.maxDate = new Date(_value[1]);
	      } else {
	        if (Array.isArray(this.defaultValue)) {
	          this.minDate = new Date(this.defaultValue[0]);
	          this.maxDate = new Date(this.defaultValue[1]);
	        } else if (this.defaultValue) {
	          this.minDate = new Date(this.defaultValue);
	          this.maxDate = advanceTime(new Date(this.defaultValue), 60 * 60 * 1000);
	        } else {
	          this.minDate = new Date();
	          this.maxDate = advanceTime(new Date(), 60 * 60 * 1000);
	        }
	      }
	    },
	    visible: function visible(val) {
	      var _this = this;
	
	      if (val) {
	        this.oldValue = this.value;
	        this.$nextTick(function () {
	          return _this.$refs.minSpinner.emitSelectRange('hours');
	        });
	      }
	    }
	  },
	
	  methods: {
	    handleClear: function handleClear() {
	      this.$emit('pick', null);
	    },
	    handleCancel: function handleCancel() {
	      this.$emit('pick', this.oldValue);
	    },
	    handleMinChange: function handleMinChange(date) {
	      this.minDate = Object(date_util_["clearMilliseconds"])(date);
	      this.handleChange();
	    },
	    handleMaxChange: function handleMaxChange(date) {
	      this.maxDate = Object(date_util_["clearMilliseconds"])(date);
	      this.handleChange();
	    },
	    handleChange: function handleChange() {
	      if (this.isValidValue([this.minDate, this.maxDate])) {
	        this.$refs.minSpinner.selectableRange = [[time_rangevue_type_script_lang_js_minTimeOfDay(this.minDate), this.maxDate]];
	        this.$refs.maxSpinner.selectableRange = [[this.minDate, time_rangevue_type_script_lang_js_maxTimeOfDay(this.maxDate)]];
	        this.$emit('pick', [this.minDate, this.maxDate], true);
	      }
	    },
	    setMinSelectionRange: function setMinSelectionRange(start, end) {
	      this.$emit('select-range', start, end, 'min');
	      this.selectionRange = [start, end];
	    },
	    setMaxSelectionRange: function setMaxSelectionRange(start, end) {
	      this.$emit('select-range', start, end, 'max');
	      this.selectionRange = [start + this.offset, end + this.offset];
	    },
	    handleConfirm: function handleConfirm() {
	      var visible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      var minSelectableRange = this.$refs.minSpinner.selectableRange;
	      var maxSelectableRange = this.$refs.maxSpinner.selectableRange;
	
	      this.minDate = Object(date_util_["limitTimeRange"])(this.minDate, minSelectableRange, this.format);
	      this.maxDate = Object(date_util_["limitTimeRange"])(this.maxDate, maxSelectableRange, this.format);
	
	      this.$emit('pick', [this.minDate, this.maxDate], visible);
	    },
	    adjustSpinners: function adjustSpinners() {
	      this.$refs.minSpinner.adjustSpinners();
	      this.$refs.maxSpinner.adjustSpinners();
	    },
	    changeSelectionRange: function changeSelectionRange(step) {
	      var list = this.showSeconds ? [0, 3, 6, 11, 14, 17] : [0, 3, 8, 11];
	      var mapping = ['hours', 'minutes'].concat(this.showSeconds ? ['seconds'] : []);
	      var index = list.indexOf(this.selectionRange[0]);
	      var next = (index + step + list.length) % list.length;
	      var half = list.length / 2;
	      if (next < half) {
	        this.$refs.minSpinner.emitSelectRange(mapping[next]);
	      } else {
	        this.$refs.maxSpinner.emitSelectRange(mapping[next - half]);
	      }
	    },
	    isValidValue: function isValidValue(date) {
	      return Array.isArray(date) && Object(date_util_["timeWithinRange"])(this.minDate, this.$refs.minSpinner.selectableRange) && Object(date_util_["timeWithinRange"])(this.maxDate, this.$refs.maxSpinner.selectableRange);
	    },
	    handleKeydown: function handleKeydown(event) {
	      var keyCode = event.keyCode;
	      var mapping = { 38: -1, 40: 1, 37: -1, 39: 1 };
	
	      // Left or Right
	      if (keyCode === 37 || keyCode === 39) {
	        var step = mapping[keyCode];
	        this.changeSelectionRange(step);
	        event.preventDefault();
	        return;
	      }
	
	      // Up or Down
	      if (keyCode === 38 || keyCode === 40) {
	        var _step = mapping[keyCode];
	        this.spinner.scrollDown(_step);
	        event.preventDefault();
	        return;
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/time-range.vue?vue&type=script&lang=js&
	 /* harmony default export */ var panel_time_rangevue_type_script_lang_js_ = (time_rangevue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/date-picker/src/panel/time-range.vue
	
	
	
	
	
	/* normalize component */
	
	var time_range_component = normalizeComponent(
	  panel_time_rangevue_type_script_lang_js_,
	  time_rangevue_type_template_id_fb28660e_render,
	  time_rangevue_type_template_id_fb28660e_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var time_range_api; }
	time_range_component.options.__file = "packages/date-picker/src/panel/time-range.vue"
	/* harmony default export */ var time_range = (time_range_component.exports);
	// CONCATENATED MODULE: ./packages/date-picker/src/picker/time-picker.js
	
	
	
	
	/* harmony default export */ var time_picker = ({
	  mixins: [picker],
	
	  name: 'ElTimePicker',
	
	  props: {
	    isRange: Boolean,
	    arrowControl: Boolean
	  },
	
	  data: function data() {
	    return {
	      type: ''
	    };
	  },
	
	
	  watch: {
	    isRange: function isRange(_isRange) {
	      if (this.picker) {
	        this.unmountPicker();
	        this.type = _isRange ? 'timerange' : 'time';
	        this.panel = _isRange ? time_range : panel_time;
	        this.mountPicker();
	      } else {
	        this.type = _isRange ? 'timerange' : 'time';
	        this.panel = _isRange ? time_range : panel_time;
	      }
	    }
	  },
	
	  created: function created() {
	    this.type = this.isRange ? 'timerange' : 'time';
	    this.panel = this.isRange ? time_range : panel_time;
	  }
	});
	// CONCATENATED MODULE: ./packages/time-picker/index.js
	
	
	/* istanbul ignore next */
	time_picker.install = function (Vue) {
	  Vue.component(time_picker.name, time_picker);
	};
	
	/* harmony default export */ var packages_time_picker = (time_picker);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/popover/src/main.vue?vue&type=template&id=52060272&
	var mainvue_type_template_id_52060272_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "span",
	    [
	      _c(
	        "transition",
	        {
	          attrs: { name: _vm.transition },
	          on: {
	            "after-enter": _vm.handleAfterEnter,
	            "after-leave": _vm.handleAfterLeave
	          }
	        },
	        [
	          _c(
	            "div",
	            {
	              directives: [
	                {
	                  name: "show",
	                  rawName: "v-show",
	                  value: !_vm.disabled && _vm.showPopper,
	                  expression: "!disabled && showPopper"
	                }
	              ],
	              ref: "popper",
	              staticClass: "el-popover el-popper",
	              class: [_vm.popperClass, _vm.content && "el-popover--plain"],
	              style: { width: _vm.width + "px" },
	              attrs: {
	                role: "tooltip",
	                id: _vm.tooltipId,
	                "aria-hidden":
	                  _vm.disabled || !_vm.showPopper ? "true" : "false"
	              }
	            },
	            [
	              _vm.title
	                ? _c("div", {
	                    staticClass: "el-popover__title",
	                    domProps: { textContent: _vm._s(_vm.title) }
	                  })
	                : _vm._e(),
	              _vm._t("default", [_vm._v(_vm._s(_vm.content))])
	            ],
	            2
	          )
	        ]
	      ),
	      _vm._t("reference")
	    ],
	    2
	  )
	}
	var mainvue_type_template_id_52060272_staticRenderFns = []
	mainvue_type_template_id_52060272_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/popover/src/main.vue?vue&type=template&id=52060272&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/popover/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	/* harmony default export */ var mainvue_type_script_lang_js_ = ({
	  name: 'ElPopover',
	
	  mixins: [vue_popper_default.a],
	
	  props: {
	    trigger: {
	      type: String,
	      default: 'click',
	      validator: function validator(value) {
	        return ['click', 'focus', 'hover', 'manual'].indexOf(value) > -1;
	      }
	    },
	    openDelay: {
	      type: Number,
	      default: 0
	    },
	    closeDelay: {
	      type: Number,
	      default: 200
	    },
	    title: String,
	    disabled: Boolean,
	    content: String,
	    reference: {},
	    popperClass: String,
	    width: {},
	    visibleArrow: {
	      default: true
	    },
	    arrowOffset: {
	      type: Number,
	      default: 0
	    },
	    transition: {
	      type: String,
	      default: 'fade-in-linear'
	    },
	    tabindex: {
	      type: Number,
	      default: 0
	    }
	  },
	
	  computed: {
	    tooltipId: function tooltipId() {
	      return 'el-popover-' + Object(util_["generateId"])();
	    }
	  },
	  watch: {
	    showPopper: function showPopper(val) {
	      if (this.disabled) {
	        return;
	      }
	      val ? this.$emit('show') : this.$emit('hide');
	    }
	  },
	
	  mounted: function mounted() {
	    var _this = this;
	
	    var reference = this.referenceElm = this.reference || this.$refs.reference;
	    var popper = this.popper || this.$refs.popper;
	
	    if (!reference && this.$slots.reference && this.$slots.reference[0]) {
	      reference = this.referenceElm = this.$slots.reference[0].elm;
	    }
	    // 可访问性
	    if (reference) {
	      Object(dom_["addClass"])(reference, 'el-popover__reference');
	      reference.setAttribute('aria-describedby', this.tooltipId);
	      reference.setAttribute('tabindex', this.tabindex); // tab序列
	      popper.setAttribute('tabindex', 0);
	
	      if (this.trigger !== 'click') {
	        Object(dom_["on"])(reference, 'focusin', function () {
	          _this.handleFocus();
	          var instance = reference.__vue__;
	          if (instance && typeof instance.focus === 'function') {
	            instance.focus();
	          }
	        });
	        Object(dom_["on"])(popper, 'focusin', this.handleFocus);
	        Object(dom_["on"])(reference, 'focusout', this.handleBlur);
	        Object(dom_["on"])(popper, 'focusout', this.handleBlur);
	      }
	      Object(dom_["on"])(reference, 'keydown', this.handleKeydown);
	      Object(dom_["on"])(reference, 'click', this.handleClick);
	    }
	    if (this.trigger === 'click') {
	      Object(dom_["on"])(reference, 'click', this.doToggle);
	      Object(dom_["on"])(document, 'click', this.handleDocumentClick);
	    } else if (this.trigger === 'hover') {
	      Object(dom_["on"])(reference, 'mouseenter', this.handleMouseEnter);
	      Object(dom_["on"])(popper, 'mouseenter', this.handleMouseEnter);
	      Object(dom_["on"])(reference, 'mouseleave', this.handleMouseLeave);
	      Object(dom_["on"])(popper, 'mouseleave', this.handleMouseLeave);
	    } else if (this.trigger === 'focus') {
	      if (this.tabindex < 0) {
	        console.warn('[Element Warn][Popover]a negative taindex means that the element cannot be focused by tab key');
	      }
	      if (reference.querySelector('input, textarea')) {
	        Object(dom_["on"])(reference, 'focusin', this.doShow);
	        Object(dom_["on"])(reference, 'focusout', this.doClose);
	      } else {
	        Object(dom_["on"])(reference, 'mousedown', this.doShow);
	        Object(dom_["on"])(reference, 'mouseup', this.doClose);
	      }
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.cleanup();
	  },
	  deactivated: function deactivated() {
	    this.cleanup();
	  },
	
	
	  methods: {
	    doToggle: function doToggle() {
	      this.showPopper = !this.showPopper;
	    },
	    doShow: function doShow() {
	      this.showPopper = true;
	    },
	    doClose: function doClose() {
	      this.showPopper = false;
	    },
	    handleFocus: function handleFocus() {
	      Object(dom_["addClass"])(this.referenceElm, 'focusing');
	      if (this.trigger === 'click' || this.trigger === 'focus') this.showPopper = true;
	    },
	    handleClick: function handleClick() {
	      Object(dom_["removeClass"])(this.referenceElm, 'focusing');
	    },
	    handleBlur: function handleBlur() {
	      Object(dom_["removeClass"])(this.referenceElm, 'focusing');
	      if (this.trigger === 'click' || this.trigger === 'focus') this.showPopper = false;
	    },
	    handleMouseEnter: function handleMouseEnter() {
	      var _this2 = this;
	
	      clearTimeout(this._timer);
	      if (this.openDelay) {
	        this._timer = setTimeout(function () {
	          _this2.showPopper = true;
	        }, this.openDelay);
	      } else {
	        this.showPopper = true;
	      }
	    },
	    handleKeydown: function handleKeydown(ev) {
	      if (ev.keyCode === 27 && this.trigger !== 'manual') {
	        // esc
	        this.doClose();
	      }
	    },
	    handleMouseLeave: function handleMouseLeave() {
	      var _this3 = this;
	
	      clearTimeout(this._timer);
	      if (this.closeDelay) {
	        this._timer = setTimeout(function () {
	          _this3.showPopper = false;
	        }, this.closeDelay);
	      } else {
	        this.showPopper = false;
	      }
	    },
	    handleDocumentClick: function handleDocumentClick(e) {
	      var reference = this.reference || this.$refs.reference;
	      var popper = this.popper || this.$refs.popper;
	
	      if (!reference && this.$slots.reference && this.$slots.reference[0]) {
	        reference = this.referenceElm = this.$slots.reference[0].elm;
	      }
	      if (!this.$el || !reference || this.$el.contains(e.target) || reference.contains(e.target) || !popper || popper.contains(e.target)) return;
	      this.showPopper = false;
	    },
	    handleAfterEnter: function handleAfterEnter() {
	      this.$emit('after-enter');
	    },
	    handleAfterLeave: function handleAfterLeave() {
	      this.$emit('after-leave');
	      this.doDestroy();
	    },
	    cleanup: function cleanup() {
	      if (this.openDelay || this.closeDelay) {
	        clearTimeout(this._timer);
	      }
	    }
	  },
	
	  destroyed: function destroyed() {
	    var reference = this.reference;
	
	    Object(dom_["off"])(reference, 'click', this.doToggle);
	    Object(dom_["off"])(reference, 'mouseup', this.doClose);
	    Object(dom_["off"])(reference, 'mousedown', this.doShow);
	    Object(dom_["off"])(reference, 'focusin', this.doShow);
	    Object(dom_["off"])(reference, 'focusout', this.doClose);
	    Object(dom_["off"])(reference, 'mousedown', this.doShow);
	    Object(dom_["off"])(reference, 'mouseup', this.doClose);
	    Object(dom_["off"])(reference, 'mouseleave', this.handleMouseLeave);
	    Object(dom_["off"])(reference, 'mouseenter', this.handleMouseEnter);
	    Object(dom_["off"])(document, 'click', this.handleDocumentClick);
	  }
	});
	// CONCATENATED MODULE: ./packages/popover/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_mainvue_type_script_lang_js_ = (mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/popover/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var main_component = normalizeComponent(
	  src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_52060272_render,
	  mainvue_type_template_id_52060272_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var main_api; }
	main_component.options.__file = "packages/popover/src/main.vue"
	/* harmony default export */ var main = (main_component.exports);
	// CONCATENATED MODULE: ./packages/popover/src/directive.js
	var getReference = function getReference(el, binding, vnode) {
	  var _ref = binding.expression ? binding.value : binding.arg;
	  var popper = vnode.context.$refs[_ref];
	  if (popper) {
	    if (Array.isArray(popper)) {
	      popper[0].$refs.reference = el;
	    } else {
	      popper.$refs.reference = el;
	    }
	  }
	};
	
	/* harmony default export */ var directive = ({
	  bind: function bind(el, binding, vnode) {
	    getReference(el, binding, vnode);
	  },
	  inserted: function inserted(el, binding, vnode) {
	    getReference(el, binding, vnode);
	  }
	});
	// CONCATENATED MODULE: ./packages/popover/index.js
	
	
	
	
	external_vue_default.a.directive('popover', directive);
	
	/* istanbul ignore next */
	main.install = function (Vue) {
	  Vue.directive('popover', directive);
	  Vue.component(main.name, main);
	};
	main.directive = directive;
	
	/* harmony default export */ var popover = (main);
	// CONCATENATED MODULE: ./packages/tooltip/src/main.js
	
	
	
	
	
	
	/* harmony default export */ var src_main = ({
	  name: 'ElTooltip',
	
	  mixins: [vue_popper_default.a],
	
	  props: {
	    openDelay: {
	      type: Number,
	      default: 0
	    },
	    disabled: Boolean,
	    manual: Boolean,
	    effect: {
	      type: String,
	      default: 'dark'
	    },
	    arrowOffset: {
	      type: Number,
	      default: 0
	    },
	    popperClass: String,
	    content: String,
	    visibleArrow: {
	      default: true
	    },
	    transition: {
	      type: String,
	      default: 'el-fade-in-linear'
	    },
	    popperOptions: {
	      default: function _default() {
	        return {
	          boundariesPadding: 10,
	          gpuAcceleration: false
	        };
	      }
	    },
	    enterable: {
	      type: Boolean,
	      default: true
	    },
	    hideAfter: {
	      type: Number,
	      default: 0
	    },
	    tabindex: {
	      type: Number,
	      default: 0
	    }
	  },
	
	  data: function data() {
	    return {
	      tooltipId: 'el-tooltip-' + Object(util_["generateId"])(),
	      timeoutPending: null,
	      focusing: false
	    };
	  },
	  beforeCreate: function beforeCreate() {
	    var _this = this;
	
	    if (this.$isServer) return;
	
	    this.popperVM = new external_vue_default.a({
	      data: { node: '' },
	      render: function render(h) {
	        return this.node;
	      }
	    }).$mount();
	
	    this.debounceClose = debounce_default()(200, function () {
	      return _this.handleClosePopper();
	    });
	  },
	  render: function render(h) {
	    var _this2 = this;
	
	    if (this.popperVM) {
	      this.popperVM.node = h(
	        'transition',
	        {
	          attrs: {
	            name: this.transition
	          },
	          on: {
	            'afterLeave': this.doDestroy
	          }
	        },
	        [h(
	          'div',
	          {
	            on: {
	              'mouseleave': function mouseleave() {
	                _this2.setExpectedState(false);_this2.debounceClose();
	              },
	              'mouseenter': function mouseenter() {
	                _this2.setExpectedState(true);
	              }
	            },
	
	            ref: 'popper',
	            attrs: { role: 'tooltip',
	              id: this.tooltipId,
	              'aria-hidden': this.disabled || !this.showPopper ? 'true' : 'false'
	            },
	            directives: [{
	              name: 'show',
	              value: !this.disabled && this.showPopper
	            }],
	
	            'class': ['el-tooltip__popper', 'is-' + this.effect, this.popperClass] },
	          [this.$slots.content || this.content]
	        )]
	      );
	    }
	
	    var firstElement = this.getFirstElement();
	    if (!firstElement) return null;
	
	    var data = firstElement.data = firstElement.data || {};
	    data.staticClass = this.addTooltipClass(data.staticClass);
	
	    return firstElement;
	  },
	  mounted: function mounted() {
	    var _this3 = this;
	
	    this.referenceElm = this.$el;
	    if (this.$el.nodeType === 1) {
	      this.$el.setAttribute('aria-describedby', this.tooltipId);
	      this.$el.setAttribute('tabindex', this.tabindex);
	      Object(dom_["on"])(this.referenceElm, 'mouseenter', this.show);
	      Object(dom_["on"])(this.referenceElm, 'mouseleave', this.hide);
	      Object(dom_["on"])(this.referenceElm, 'focus', function () {
	        if (!_this3.$slots.default || !_this3.$slots.default.length) {
	          _this3.handleFocus();
	          return;
	        }
	        var instance = _this3.$slots.default[0].componentInstance;
	        if (instance && instance.focus) {
	          instance.focus();
	        } else {
	          _this3.handleFocus();
	        }
	      });
	      Object(dom_["on"])(this.referenceElm, 'blur', this.handleBlur);
	      Object(dom_["on"])(this.referenceElm, 'click', this.removeFocusing);
	    }
	    // fix issue https://github.com/ElemeFE/element/issues/14424
	    if (this.value && this.popperVM) {
	      this.popperVM.$nextTick(function () {
	        if (_this3.value) {
	          _this3.updatePopper();
	        }
	      });
	    }
	  },
	
	  watch: {
	    focusing: function focusing(val) {
	      if (val) {
	        Object(dom_["addClass"])(this.referenceElm, 'focusing');
	      } else {
	        Object(dom_["removeClass"])(this.referenceElm, 'focusing');
	      }
	    }
	  },
	  methods: {
	    show: function show() {
	      this.setExpectedState(true);
	      this.handleShowPopper();
	    },
	    hide: function hide() {
	      this.setExpectedState(false);
	      this.debounceClose();
	    },
	    handleFocus: function handleFocus() {
	      this.focusing = true;
	      this.show();
	    },
	    handleBlur: function handleBlur() {
	      this.focusing = false;
	      this.hide();
	    },
	    removeFocusing: function removeFocusing() {
	      this.focusing = false;
	    },
	    addTooltipClass: function addTooltipClass(prev) {
	      if (!prev) {
	        return 'el-tooltip';
	      } else {
	        return 'el-tooltip ' + prev.replace('el-tooltip', '');
	      }
	    },
	    handleShowPopper: function handleShowPopper() {
	      var _this4 = this;
	
	      if (!this.expectedState || this.manual) return;
	      clearTimeout(this.timeout);
	      this.timeout = setTimeout(function () {
	        _this4.showPopper = true;
	      }, this.openDelay);
	
	      if (this.hideAfter > 0) {
	        this.timeoutPending = setTimeout(function () {
	          _this4.showPopper = false;
	        }, this.hideAfter);
	      }
	    },
	    handleClosePopper: function handleClosePopper() {
	      if (this.enterable && this.expectedState || this.manual) return;
	      clearTimeout(this.timeout);
	
	      if (this.timeoutPending) {
	        clearTimeout(this.timeoutPending);
	      }
	      this.showPopper = false;
	
	      if (this.disabled) {
	        this.doDestroy();
	      }
	    },
	    setExpectedState: function setExpectedState(expectedState) {
	      if (expectedState === false) {
	        clearTimeout(this.timeoutPending);
	      }
	      this.expectedState = expectedState;
	    },
	    getFirstElement: function getFirstElement() {
	      var slots = this.$slots.default;
	      if (!Array.isArray(slots)) return null;
	      var element = null;
	      for (var index = 0; index < slots.length; index++) {
	        if (slots[index] && slots[index].tag) {
	          element = slots[index];
	        };
	      }
	      return element;
	    }
	  },
	
	  beforeDestroy: function beforeDestroy() {
	    this.popperVM && this.popperVM.$destroy();
	  },
	  destroyed: function destroyed() {
	    var reference = this.referenceElm;
	    if (reference.nodeType === 1) {
	      Object(dom_["off"])(reference, 'mouseenter', this.show);
	      Object(dom_["off"])(reference, 'mouseleave', this.hide);
	      Object(dom_["off"])(reference, 'focus', this.handleFocus);
	      Object(dom_["off"])(reference, 'blur', this.handleBlur);
	      Object(dom_["off"])(reference, 'click', this.removeFocusing);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/tooltip/index.js
	
	
	/* istanbul ignore next */
	src_main.install = function (Vue) {
	  Vue.component(src_main.name, src_main);
	};
	
	/* harmony default export */ var packages_tooltip = (src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/message-box/src/main.vue?vue&type=template&id=6b29b012&
	var mainvue_type_template_id_6b29b012_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("transition", { attrs: { name: "msgbox-fade" } }, [
	    _c(
	      "div",
	      {
	        directives: [
	          {
	            name: "show",
	            rawName: "v-show",
	            value: _vm.visible,
	            expression: "visible"
	          }
	        ],
	        staticClass: "el-message-box__wrapper",
	        attrs: {
	          tabindex: "-1",
	          role: "dialog",
	          "aria-modal": "true",
	          "aria-label": _vm.title || "dialog"
	        },
	        on: {
	          click: function($event) {
	            if ($event.target !== $event.currentTarget) {
	              return null
	            }
	            return _vm.handleWrapperClick($event)
	          }
	        }
	      },
	      [
	        _c(
	          "div",
	          {
	            staticClass: "el-message-box",
	            class: [_vm.customClass, _vm.center && "el-message-box--center"]
	          },
	          [
	            _vm.title !== null
	              ? _c("div", { staticClass: "el-message-box__header" }, [
	                  _c("div", { staticClass: "el-message-box__title" }, [
	                    _vm.icon && _vm.center
	                      ? _c("div", {
	                          class: ["el-message-box__status", _vm.icon]
	                        })
	                      : _vm._e(),
	                    _c("span", [_vm._v(_vm._s(_vm.title))])
	                  ]),
	                  _vm.showClose
	                    ? _c(
	                        "button",
	                        {
	                          staticClass: "el-message-box__headerbtn",
	                          attrs: { type: "button", "aria-label": "Close" },
	                          on: {
	                            click: function($event) {
	                              _vm.handleAction(
	                                _vm.distinguishCancelAndClose
	                                  ? "close"
	                                  : "cancel"
	                              )
	                            },
	                            keydown: function($event) {
	                              if (
	                                !("button" in $event) &&
	                                _vm._k(
	                                  $event.keyCode,
	                                  "enter",
	                                  13,
	                                  $event.key,
	                                  "Enter"
	                                )
	                              ) {
	                                return null
	                              }
	                              _vm.handleAction(
	                                _vm.distinguishCancelAndClose
	                                  ? "close"
	                                  : "cancel"
	                              )
	                            }
	                          }
	                        },
	                        [
	                          _c("i", {
	                            staticClass: "el-message-box__close el-icon-close"
	                          })
	                        ]
	                      )
	                    : _vm._e()
	                ])
	              : _vm._e(),
	            _c("div", { staticClass: "el-message-box__content" }, [
	              _c("div", { staticClass: "el-message-box__container" }, [
	                _vm.icon && !_vm.center && _vm.message !== ""
	                  ? _c("div", { class: ["el-message-box__status", _vm.icon] })
	                  : _vm._e(),
	                _vm.message !== ""
	                  ? _c(
	                      "div",
	                      { staticClass: "el-message-box__message" },
	                      [
	                        _vm._t("default", [
	                          !_vm.dangerouslyUseHTMLString
	                            ? _c("p", [_vm._v(_vm._s(_vm.message))])
	                            : _c("p", {
	                                domProps: { innerHTML: _vm._s(_vm.message) }
	                              })
	                        ])
	                      ],
	                      2
	                    )
	                  : _vm._e()
	              ]),
	              _c(
	                "div",
	                {
	                  directives: [
	                    {
	                      name: "show",
	                      rawName: "v-show",
	                      value: _vm.showInput,
	                      expression: "showInput"
	                    }
	                  ],
	                  staticClass: "el-message-box__input"
	                },
	                [
	                  _c("el-input", {
	                    ref: "input",
	                    attrs: {
	                      type: _vm.inputType,
	                      placeholder: _vm.inputPlaceholder
	                    },
	                    nativeOn: {
	                      keydown: function($event) {
	                        if (
	                          !("button" in $event) &&
	                          _vm._k(
	                            $event.keyCode,
	                            "enter",
	                            13,
	                            $event.key,
	                            "Enter"
	                          )
	                        ) {
	                          return null
	                        }
	                        return _vm.handleInputEnter($event)
	                      }
	                    },
	                    model: {
	                      value: _vm.inputValue,
	                      callback: function($$v) {
	                        _vm.inputValue = $$v
	                      },
	                      expression: "inputValue"
	                    }
	                  }),
	                  _c(
	                    "div",
	                    {
	                      staticClass: "el-message-box__errormsg",
	                      style: {
	                        visibility: !!_vm.editorErrorMessage
	                          ? "visible"
	                          : "hidden"
	                      }
	                    },
	                    [_vm._v(_vm._s(_vm.editorErrorMessage))]
	                  )
	                ],
	                1
	              )
	            ]),
	            _c(
	              "div",
	              { staticClass: "el-message-box__btns" },
	              [
	                _vm.showCancelButton
	                  ? _c(
	                      "el-button",
	                      {
	                        class: [_vm.cancelButtonClasses],
	                        attrs: {
	                          loading: _vm.cancelButtonLoading,
	                          round: _vm.roundButton,
	                          size: "small"
	                        },
	                        on: {
	                          keydown: function($event) {
	                            if (
	                              !("button" in $event) &&
	                              _vm._k(
	                                $event.keyCode,
	                                "enter",
	                                13,
	                                $event.key,
	                                "Enter"
	                              )
	                            ) {
	                              return null
	                            }
	                            _vm.handleAction("cancel")
	                          }
	                        },
	                        nativeOn: {
	                          click: function($event) {
	                            _vm.handleAction("cancel")
	                          }
	                        }
	                      },
	                      [
	                        _vm._v(
	                          "\n          " +
	                            _vm._s(
	                              _vm.cancelButtonText ||
	                                _vm.t("el.messagebox.cancel")
	                            ) +
	                            "\n        "
	                        )
	                      ]
	                    )
	                  : _vm._e(),
	                _c(
	                  "el-button",
	                  {
	                    directives: [
	                      {
	                        name: "show",
	                        rawName: "v-show",
	                        value: _vm.showConfirmButton,
	                        expression: "showConfirmButton"
	                      }
	                    ],
	                    ref: "confirm",
	                    class: [_vm.confirmButtonClasses],
	                    attrs: {
	                      loading: _vm.confirmButtonLoading,
	                      round: _vm.roundButton,
	                      size: "small"
	                    },
	                    on: {
	                      keydown: function($event) {
	                        if (
	                          !("button" in $event) &&
	                          _vm._k(
	                            $event.keyCode,
	                            "enter",
	                            13,
	                            $event.key,
	                            "Enter"
	                          )
	                        ) {
	                          return null
	                        }
	                        _vm.handleAction("confirm")
	                      }
	                    },
	                    nativeOn: {
	                      click: function($event) {
	                        _vm.handleAction("confirm")
	                      }
	                    }
	                  },
	                  [
	                    _vm._v(
	                      "\n          " +
	                        _vm._s(
	                          _vm.confirmButtonText ||
	                            _vm.t("el.messagebox.confirm")
	                        ) +
	                        "\n        "
	                    )
	                  ]
	                )
	              ],
	              1
	            )
	          ]
	        )
	      ]
	    )
	  ])
	}
	var mainvue_type_template_id_6b29b012_staticRenderFns = []
	mainvue_type_template_id_6b29b012_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/message-box/src/main.vue?vue&type=template&id=6b29b012&
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/aria-dialog"
	var aria_dialog_ = __webpack_require__(39);
	var aria_dialog_default = /*#__PURE__*/__webpack_require__.n(aria_dialog_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/message-box/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	
	
	var messageBox = void 0;
	var typeMap = {
	  success: 'success',
	  info: 'info',
	  warning: 'warning',
	  error: 'error'
	};
	
	/* harmony default export */ var message_box_src_mainvue_type_script_lang_js_ = ({
	  mixins: [popup_default.a, locale_default.a],
	
	  props: {
	    modal: {
	      default: true
	    },
	    lockScroll: {
	      default: true
	    },
	    showClose: {
	      type: Boolean,
	      default: true
	    },
	    closeOnClickModal: {
	      default: true
	    },
	    closeOnPressEscape: {
	      default: true
	    },
	    closeOnHashChange: {
	      default: true
	    },
	    center: {
	      default: false,
	      type: Boolean
	    },
	    roundButton: {
	      default: false,
	      type: Boolean
	    }
	  },
	
	  components: {
	    ElInput: input_default.a,
	    ElButton: button_default.a
	  },
	
	  computed: {
	    icon: function icon() {
	      var type = this.type,
	          iconClass = this.iconClass;
	
	      return iconClass || (type && typeMap[type] ? 'el-icon-' + typeMap[type] : '');
	    },
	    confirmButtonClasses: function confirmButtonClasses() {
	      return 'el-button--primary ' + this.confirmButtonClass;
	    },
	    cancelButtonClasses: function cancelButtonClasses() {
	      return '' + this.cancelButtonClass;
	    }
	  },
	
	  methods: {
	    getSafeClose: function getSafeClose() {
	      var _this = this;
	
	      var currentId = this.uid;
	      return function () {
	        _this.$nextTick(function () {
	          if (currentId === _this.uid) _this.doClose();
	        });
	      };
	    },
	    doClose: function doClose() {
	      var _this2 = this;
	
	      if (!this.visible) return;
	      this.visible = false;
	      this._closing = true;
	
	      this.onClose && this.onClose();
	      messageBox.closeDialog(); // 解绑
	      if (this.lockScroll) {
	        setTimeout(this.restoreBodyStyle, 200);
	      }
	      this.opened = false;
	      this.doAfterClose();
	      setTimeout(function () {
	        if (_this2.action) _this2.callback(_this2.action, _this2);
	      });
	    },
	    handleWrapperClick: function handleWrapperClick() {
	      if (this.closeOnClickModal) {
	        this.handleAction(this.distinguishCancelAndClose ? 'close' : 'cancel');
	      }
	    },
	    handleInputEnter: function handleInputEnter() {
	      if (this.inputType !== 'textarea') {
	        return this.handleAction('confirm');
	      }
	    },
	    handleAction: function handleAction(action) {
	      if (this.$type === 'prompt' && action === 'confirm' && !this.validate()) {
	        return;
	      }
	      this.action = action;
	      if (typeof this.beforeClose === 'function') {
	        this.close = this.getSafeClose();
	        this.beforeClose(action, this, this.close);
	      } else {
	        this.doClose();
	      }
	    },
	    validate: function validate() {
	      if (this.$type === 'prompt') {
	        var inputPattern = this.inputPattern;
	        if (inputPattern && !inputPattern.test(this.inputValue || '')) {
	          this.editorErrorMessage = this.inputErrorMessage || Object(lib_locale_["t"])('el.messagebox.error');
	          Object(dom_["addClass"])(this.getInputElement(), 'invalid');
	          return false;
	        }
	        var inputValidator = this.inputValidator;
	        if (typeof inputValidator === 'function') {
	          var validateResult = inputValidator(this.inputValue);
	          if (validateResult === false) {
	            this.editorErrorMessage = this.inputErrorMessage || Object(lib_locale_["t"])('el.messagebox.error');
	            Object(dom_["addClass"])(this.getInputElement(), 'invalid');
	            return false;
	          }
	          if (typeof validateResult === 'string') {
	            this.editorErrorMessage = validateResult;
	            Object(dom_["addClass"])(this.getInputElement(), 'invalid');
	            return false;
	          }
	        }
	      }
	      this.editorErrorMessage = '';
	      Object(dom_["removeClass"])(this.getInputElement(), 'invalid');
	      return true;
	    },
	    getFirstFocus: function getFirstFocus() {
	      var btn = this.$el.querySelector('.el-message-box__btns .el-button');
	      var title = this.$el.querySelector('.el-message-box__btns .el-message-box__title');
	      return btn || title;
	    },
	    getInputElement: function getInputElement() {
	      var inputRefs = this.$refs.input.$refs;
	      return inputRefs.input || inputRefs.textarea;
	    },
	    handleClose: function handleClose() {
	      this.handleAction('close');
	    }
	  },
	
	  watch: {
	    inputValue: {
	      immediate: true,
	      handler: function handler(val) {
	        var _this3 = this;
	
	        this.$nextTick(function (_) {
	          if (_this3.$type === 'prompt' && val !== null) {
	            _this3.validate();
	          }
	        });
	      }
	    },
	
	    visible: function visible(val) {
	      var _this4 = this;
	
	      if (val) {
	        this.uid++;
	        if (this.$type === 'alert' || this.$type === 'confirm') {
	          this.$nextTick(function () {
	            _this4.$refs.confirm.$el.focus();
	          });
	        }
	        this.focusAfterClosed = document.activeElement;
	        messageBox = new aria_dialog_default.a(this.$el, this.focusAfterClosed, this.getFirstFocus());
	      }
	
	      // prompt
	      if (this.$type !== 'prompt') return;
	      if (val) {
	        setTimeout(function () {
	          if (_this4.$refs.input && _this4.$refs.input.$el) {
	            _this4.getInputElement().focus();
	          }
	        }, 500);
	      } else {
	        this.editorErrorMessage = '';
	        Object(dom_["removeClass"])(this.getInputElement(), 'invalid');
	      }
	    }
	  },
	
	  mounted: function mounted() {
	    var _this5 = this;
	
	    this.$nextTick(function () {
	      if (_this5.closeOnHashChange) {
	        window.addEventListener('hashchange', _this5.close);
	      }
	    });
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this.closeOnHashChange) {
	      window.removeEventListener('hashchange', this.close);
	    }
	    setTimeout(function () {
	      messageBox.closeDialog();
	    });
	  },
	  data: function data() {
	    return {
	      uid: 1,
	      title: undefined,
	      message: '',
	      type: '',
	      iconClass: '',
	      customClass: '',
	      showInput: false,
	      inputValue: null,
	      inputPlaceholder: '',
	      inputType: 'text',
	      inputPattern: null,
	      inputValidator: null,
	      inputErrorMessage: '',
	      showConfirmButton: true,
	      showCancelButton: false,
	      action: '',
	      confirmButtonText: '',
	      cancelButtonText: '',
	      confirmButtonLoading: false,
	      cancelButtonLoading: false,
	      confirmButtonClass: '',
	      confirmButtonDisabled: false,
	      cancelButtonClass: '',
	      editorErrorMessage: null,
	      callback: null,
	      dangerouslyUseHTMLString: false,
	      focusAfterClosed: null,
	      isOnComposition: false,
	      distinguishCancelAndClose: false
	    };
	  }
	});
	// CONCATENATED MODULE: ./packages/message-box/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_message_box_src_mainvue_type_script_lang_js_ = (message_box_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/message-box/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var src_main_component = normalizeComponent(
	  packages_message_box_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_6b29b012_render,
	  mainvue_type_template_id_6b29b012_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var src_main_api; }
	src_main_component.options.__file = "packages/message-box/src/main.vue"
	/* harmony default export */ var message_box_src_main = (src_main_component.exports);
	// EXTERNAL MODULE: external "element-ui/lib/utils/vdom"
	var vdom_ = __webpack_require__(23);
	
	// CONCATENATED MODULE: ./packages/message-box/src/main.js
	var main_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var main_defaults = {
	  title: null,
	  message: '',
	  type: '',
	  iconClass: '',
	  showInput: false,
	  showClose: true,
	  modalFade: true,
	  lockScroll: true,
	  closeOnClickModal: true,
	  closeOnPressEscape: true,
	  closeOnHashChange: true,
	  inputValue: null,
	  inputPlaceholder: '',
	  inputType: 'text',
	  inputPattern: null,
	  inputValidator: null,
	  inputErrorMessage: '',
	  showConfirmButton: true,
	  showCancelButton: false,
	  confirmButtonPosition: 'right',
	  confirmButtonHighlight: false,
	  cancelButtonHighlight: false,
	  confirmButtonText: '',
	  cancelButtonText: '',
	  confirmButtonClass: '',
	  cancelButtonClass: '',
	  customClass: '',
	  beforeClose: null,
	  dangerouslyUseHTMLString: false,
	  center: false,
	  roundButton: false,
	  distinguishCancelAndClose: false
	};
	
	
	
	
	
	
	var MessageBoxConstructor = external_vue_default.a.extend(message_box_src_main);
	
	var currentMsg = void 0,
	    main_instance = void 0;
	var msgQueue = [];
	
	var defaultCallback = function defaultCallback(action) {
	  if (currentMsg) {
	    var callback = currentMsg.callback;
	    if (typeof callback === 'function') {
	      if (main_instance.showInput) {
	        callback(main_instance.inputValue, action);
	      } else {
	        callback(action);
	      }
	    }
	    if (currentMsg.resolve) {
	      if (action === 'confirm') {
	        if (main_instance.showInput) {
	          currentMsg.resolve({ value: main_instance.inputValue, action: action });
	        } else {
	          currentMsg.resolve(action);
	        }
	      } else if (currentMsg.reject && (action === 'cancel' || action === 'close')) {
	        currentMsg.reject(action);
	      }
	    }
	  }
	};
	
	var initInstance = function initInstance() {
	  main_instance = new MessageBoxConstructor({
	    el: document.createElement('div')
	  });
	
	  main_instance.callback = defaultCallback;
	};
	
	var main_showNextMsg = function showNextMsg() {
	  if (!main_instance) {
	    initInstance();
	  }
	  main_instance.action = '';
	
	  if (!main_instance.visible || main_instance.closeTimer) {
	    if (msgQueue.length > 0) {
	      currentMsg = msgQueue.shift();
	
	      var options = currentMsg.options;
	      for (var prop in options) {
	        if (options.hasOwnProperty(prop)) {
	          main_instance[prop] = options[prop];
	        }
	      }
	      if (options.callback === undefined) {
	        main_instance.callback = defaultCallback;
	      }
	
	      var oldCb = main_instance.callback;
	      main_instance.callback = function (action, instance) {
	        oldCb(action, instance);
	        showNextMsg();
	      };
	      if (Object(vdom_["isVNode"])(main_instance.message)) {
	        main_instance.$slots.default = [main_instance.message];
	        main_instance.message = null;
	      } else {
	        delete main_instance.$slots.default;
	      }
	      ['modal', 'showClose', 'closeOnClickModal', 'closeOnPressEscape', 'closeOnHashChange'].forEach(function (prop) {
	        if (main_instance[prop] === undefined) {
	          main_instance[prop] = true;
	        }
	      });
	      document.body.appendChild(main_instance.$el);
	
	      external_vue_default.a.nextTick(function () {
	        main_instance.visible = true;
	      });
	    }
	  }
	};
	
	var main_MessageBox = function MessageBox(options, callback) {
	  if (external_vue_default.a.prototype.$isServer) return;
	  if (typeof options === 'string' || Object(vdom_["isVNode"])(options)) {
	    options = {
	      message: options
	    };
	    if (typeof arguments[1] === 'string') {
	      options.title = arguments[1];
	    }
	  } else if (options.callback && !callback) {
	    callback = options.callback;
	  }
	
	  if (typeof Promise !== 'undefined') {
	    return new Promise(function (resolve, reject) {
	      // eslint-disable-line
	      msgQueue.push({
	        options: merge_default()({}, main_defaults, MessageBox.defaults, options),
	        callback: callback,
	        resolve: resolve,
	        reject: reject
	      });
	
	      main_showNextMsg();
	    });
	  } else {
	    msgQueue.push({
	      options: merge_default()({}, main_defaults, MessageBox.defaults, options),
	      callback: callback
	    });
	
	    main_showNextMsg();
	  }
	};
	
	main_MessageBox.setDefaults = function (defaults) {
	  main_MessageBox.defaults = defaults;
	};
	
	main_MessageBox.alert = function (message, title, options) {
	  if ((typeof title === 'undefined' ? 'undefined' : main_typeof(title)) === 'object') {
	    options = title;
	    title = '';
	  } else if (title === undefined) {
	    title = '';
	  }
	  return main_MessageBox(merge_default()({
	    title: title,
	    message: message,
	    $type: 'alert',
	    closeOnPressEscape: false,
	    closeOnClickModal: false
	  }, options));
	};
	
	main_MessageBox.confirm = function (message, title, options) {
	  if ((typeof title === 'undefined' ? 'undefined' : main_typeof(title)) === 'object') {
	    options = title;
	    title = '';
	  } else if (title === undefined) {
	    title = '';
	  }
	  return main_MessageBox(merge_default()({
	    title: title,
	    message: message,
	    $type: 'confirm',
	    showCancelButton: true
	  }, options));
	};
	
	main_MessageBox.prompt = function (message, title, options) {
	  if ((typeof title === 'undefined' ? 'undefined' : main_typeof(title)) === 'object') {
	    options = title;
	    title = '';
	  } else if (title === undefined) {
	    title = '';
	  }
	  return main_MessageBox(merge_default()({
	    title: title,
	    message: message,
	    showCancelButton: true,
	    showInput: true,
	    $type: 'prompt'
	  }, options));
	};
	
	main_MessageBox.close = function () {
	  main_instance.doClose();
	  main_instance.visible = false;
	  msgQueue = [];
	  currentMsg = null;
	};
	
	/* harmony default export */ var packages_message_box_src_main = (main_MessageBox);
	
	// CONCATENATED MODULE: ./packages/message-box/index.js
	
	/* harmony default export */ var message_box = (packages_message_box_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/breadcrumb/src/breadcrumb.vue?vue&type=template&id=4b464c06&
	var breadcrumbvue_type_template_id_4b464c06_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-breadcrumb",
	      attrs: { "aria-label": "Breadcrumb", role: "navigation" }
	    },
	    [_vm._t("default")],
	    2
	  )
	}
	var breadcrumbvue_type_template_id_4b464c06_staticRenderFns = []
	breadcrumbvue_type_template_id_4b464c06_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/breadcrumb/src/breadcrumb.vue?vue&type=template&id=4b464c06&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/breadcrumb/src/breadcrumb.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	
	/* harmony default export */ var breadcrumbvue_type_script_lang_js_ = ({
	  name: 'ElBreadcrumb',
	
	  props: {
	    separator: {
	      type: String,
	      default: '/'
	    },
	    separatorClass: {
	      type: String,
	      default: ''
	    }
	  },
	
	  provide: function provide() {
	    return {
	      elBreadcrumb: this
	    };
	  },
	  mounted: function mounted() {
	    var items = this.$el.querySelectorAll('.el-breadcrumb__item');
	    if (items.length) {
	      items[items.length - 1].setAttribute('aria-current', 'page');
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/breadcrumb/src/breadcrumb.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_breadcrumbvue_type_script_lang_js_ = (breadcrumbvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/breadcrumb/src/breadcrumb.vue
	
	
	
	
	
	/* normalize component */
	
	var breadcrumb_component = normalizeComponent(
	  src_breadcrumbvue_type_script_lang_js_,
	  breadcrumbvue_type_template_id_4b464c06_render,
	  breadcrumbvue_type_template_id_4b464c06_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var breadcrumb_api; }
	breadcrumb_component.options.__file = "packages/breadcrumb/src/breadcrumb.vue"
	/* harmony default export */ var breadcrumb = (breadcrumb_component.exports);
	// CONCATENATED MODULE: ./packages/breadcrumb/index.js
	
	
	/* istanbul ignore next */
	breadcrumb.install = function (Vue) {
	  Vue.component(breadcrumb.name, breadcrumb);
	};
	
	/* harmony default export */ var packages_breadcrumb = (breadcrumb);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/breadcrumb/src/breadcrumb-item.vue?vue&type=template&id=fcf9eaac&
	var breadcrumb_itemvue_type_template_id_fcf9eaac_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("span", { staticClass: "el-breadcrumb__item" }, [
	    _c(
	      "span",
	      {
	        ref: "link",
	        class: ["el-breadcrumb__inner", _vm.to ? "is-link" : ""],
	        attrs: { role: "link" }
	      },
	      [_vm._t("default")],
	      2
	    ),
	    _vm.separatorClass
	      ? _c("i", {
	          staticClass: "el-breadcrumb__separator",
	          class: _vm.separatorClass
	        })
	      : _c(
	          "span",
	          {
	            staticClass: "el-breadcrumb__separator",
	            attrs: { role: "presentation" }
	          },
	          [_vm._v(_vm._s(_vm.separator))]
	        )
	  ])
	}
	var breadcrumb_itemvue_type_template_id_fcf9eaac_staticRenderFns = []
	breadcrumb_itemvue_type_template_id_fcf9eaac_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/breadcrumb/src/breadcrumb-item.vue?vue&type=template&id=fcf9eaac&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/breadcrumb/src/breadcrumb-item.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var breadcrumb_itemvue_type_script_lang_js_ = ({
	  name: 'ElBreadcrumbItem',
	  props: {
	    to: {},
	    replace: Boolean
	  },
	  data: function data() {
	    return {
	      separator: '',
	      separatorClass: ''
	    };
	  },
	
	
	  inject: ['elBreadcrumb'],
	
	  mounted: function mounted() {
	    var _this = this;
	
	    this.separator = this.elBreadcrumb.separator;
	    this.separatorClass = this.elBreadcrumb.separatorClass;
	    var link = this.$refs.link;
	    link.setAttribute('role', 'link');
	    link.addEventListener('click', function (_) {
	      var to = _this.to,
	          $router = _this.$router;
	
	      if (!to || !$router) return;
	      _this.replace ? $router.replace(to) : $router.push(to);
	    });
	  }
	});
	// CONCATENATED MODULE: ./packages/breadcrumb/src/breadcrumb-item.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_breadcrumb_itemvue_type_script_lang_js_ = (breadcrumb_itemvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/breadcrumb/src/breadcrumb-item.vue
	
	
	
	
	
	/* normalize component */
	
	var breadcrumb_item_component = normalizeComponent(
	  src_breadcrumb_itemvue_type_script_lang_js_,
	  breadcrumb_itemvue_type_template_id_fcf9eaac_render,
	  breadcrumb_itemvue_type_template_id_fcf9eaac_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var breadcrumb_item_api; }
	breadcrumb_item_component.options.__file = "packages/breadcrumb/src/breadcrumb-item.vue"
	/* harmony default export */ var breadcrumb_item = (breadcrumb_item_component.exports);
	// CONCATENATED MODULE: ./packages/breadcrumb-item/index.js
	
	
	/* istanbul ignore next */
	breadcrumb_item.install = function (Vue) {
	  Vue.component(breadcrumb_item.name, breadcrumb_item);
	};
	
	/* harmony default export */ var packages_breadcrumb_item = (breadcrumb_item);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/form/src/form.vue?vue&type=template&id=a1b5ff34&
	var formvue_type_template_id_a1b5ff34_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "form",
	    {
	      staticClass: "el-form",
	      class: [
	        _vm.labelPosition ? "el-form--label-" + _vm.labelPosition : "",
	        { "el-form--inline": _vm.inline }
	      ]
	    },
	    [_vm._t("default")],
	    2
	  )
	}
	var formvue_type_template_id_a1b5ff34_staticRenderFns = []
	formvue_type_template_id_a1b5ff34_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/form/src/form.vue?vue&type=template&id=a1b5ff34&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/form/src/form.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var formvue_type_script_lang_js_ = ({
	  name: 'ElForm',
	
	  componentName: 'ElForm',
	
	  provide: function provide() {
	    return {
	      elForm: this
	    };
	  },
	
	
	  props: {
	    model: Object,
	    rules: Object,
	    labelPosition: String,
	    labelWidth: String,
	    labelSuffix: {
	      type: String,
	      default: ''
	    },
	    inline: Boolean,
	    inlineMessage: Boolean,
	    statusIcon: Boolean,
	    showMessage: {
	      type: Boolean,
	      default: true
	    },
	    size: String,
	    disabled: Boolean,
	    validateOnRuleChange: {
	      type: Boolean,
	      default: true
	    },
	    hideRequiredAsterisk: {
	      type: Boolean,
	      default: false
	    }
	  },
	  watch: {
	    rules: function rules() {
	      // remove then add event listeners on form-item after form rules change
	      this.fields.forEach(function (field) {
	        field.removeValidateEvents();
	        field.addValidateEvents();
	      });
	
	      if (this.validateOnRuleChange) {
	        this.validate(function () {});
	      }
	    }
	  },
	  computed: {
	    autoLabelWidth: function autoLabelWidth() {
	      if (!this.potentialLabelWidthArr.length) return 0;
	      var max = Math.max.apply(Math, this.potentialLabelWidthArr);
	      return max ? max + 'px' : '';
	    }
	  },
	  data: function data() {
	    return {
	      fields: [],
	      potentialLabelWidthArr: [] // use this array to calculate auto width
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    this.$on('el.form.addField', function (field) {
	      if (field) {
	        _this.fields.push(field);
	      }
	    });
	    /* istanbul ignore next */
	    this.$on('el.form.removeField', function (field) {
	      if (field.prop) {
	        _this.fields.splice(_this.fields.indexOf(field), 1);
	      }
	    });
	  },
	
	  methods: {
	    resetFields: function resetFields() {
	      if (!this.model) {
	        console.warn('[Element Warn][Form]model is required for resetFields to work.');
	        return;
	      }
	      this.fields.forEach(function (field) {
	        field.resetField();
	      });
	    },
	    clearValidate: function clearValidate() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	      var fields = props.length ? typeof props === 'string' ? this.fields.filter(function (field) {
	        return props === field.prop;
	      }) : this.fields.filter(function (field) {
	        return props.indexOf(field.prop) > -1;
	      }) : this.fields;
	      fields.forEach(function (field) {
	        field.clearValidate();
	      });
	    },
	    validate: function validate(callback) {
	      var _this2 = this;
	
	      if (!this.model) {
	        console.warn('[Element Warn][Form]model is required for validate to work!');
	        return;
	      }
	
	      var promise = void 0;
	      // if no callback, return promise
	      if (typeof callback !== 'function' && window.Promise) {
	        promise = new window.Promise(function (resolve, reject) {
	          callback = function callback(valid) {
	            valid ? resolve(valid) : reject(valid);
	          };
	        });
	      }
	
	      var valid = true;
	      var count = 0;
	      // 如果需要验证的fields为空，调用验证时立刻返回callback
	      if (this.fields.length === 0 && callback) {
	        callback(true);
	      }
	      var invalidFields = {};
	      this.fields.forEach(function (field) {
	        field.validate('', function (message, field) {
	          if (message) {
	            valid = false;
	          }
	          invalidFields = merge_default()({}, invalidFields, field);
	          if (typeof callback === 'function' && ++count === _this2.fields.length) {
	            callback(valid, invalidFields);
	          }
	        });
	      });
	
	      if (promise) {
	        return promise;
	      }
	    },
	    validateField: function validateField(props, cb) {
	      props = [].concat(props);
	      var fields = this.fields.filter(function (field) {
	        return props.indexOf(field.prop) !== -1;
	      });
	      if (!fields.length) {
	        console.warn('[Element Warn]please pass correct props!');
	        return;
	      }
	
	      fields.forEach(function (field) {
	        field.validate('', cb);
	      });
	    },
	    getLabelWidthIndex: function getLabelWidthIndex(width) {
	      var index = this.potentialLabelWidthArr.indexOf(width);
	      // it's impossible
	      if (index === -1) {
	        throw new Error('[ElementForm]unpected width ', width);
	      }
	      return index;
	    },
	    registerLabelWidth: function registerLabelWidth(val, oldVal) {
	      if (val && oldVal) {
	        var index = this.getLabelWidthIndex(oldVal);
	        this.potentialLabelWidthArr.splice(index, 1, val);
	      } else if (val) {
	        this.potentialLabelWidthArr.push(val);
	      }
	    },
	    deregisterLabelWidth: function deregisterLabelWidth(val) {
	      var index = this.getLabelWidthIndex(val);
	      this.potentialLabelWidthArr.splice(index, 1);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/form/src/form.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_formvue_type_script_lang_js_ = (formvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/form/src/form.vue
	
	
	
	
	
	/* normalize component */
	
	var form_component = normalizeComponent(
	  src_formvue_type_script_lang_js_,
	  formvue_type_template_id_a1b5ff34_render,
	  formvue_type_template_id_a1b5ff34_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var form_api; }
	form_component.options.__file = "packages/form/src/form.vue"
	/* harmony default export */ var src_form = (form_component.exports);
	// CONCATENATED MODULE: ./packages/form/index.js
	
	
	/* istanbul ignore next */
	src_form.install = function (Vue) {
	  Vue.component(src_form.name, src_form);
	};
	
	/* harmony default export */ var packages_form = (src_form);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/form/src/form-item.vue?vue&type=template&id=b6f3db6c&
	var form_itemvue_type_template_id_b6f3db6c_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-form-item",
	      class: [
	        {
	          "el-form-item--feedback": _vm.elForm && _vm.elForm.statusIcon,
	          "is-error": _vm.validateState === "error",
	          "is-validating": _vm.validateState === "validating",
	          "is-success": _vm.validateState === "success",
	          "is-required": _vm.isRequired || _vm.required,
	          "is-no-asterisk": _vm.elForm && _vm.elForm.hideRequiredAsterisk
	        },
	        _vm.sizeClass ? "el-form-item--" + _vm.sizeClass : ""
	      ]
	    },
	    [
	      _c(
	        "label-wrap",
	        {
	          attrs: {
	            "is-auto-width": _vm.labelStyle && _vm.labelStyle.width === "auto",
	            "update-all": _vm.form.labelWidth === "auto"
	          }
	        },
	        [
	          _vm.label || _vm.$slots.label
	            ? _c(
	                "label",
	                {
	                  staticClass: "el-form-item__label",
	                  style: _vm.labelStyle,
	                  attrs: { for: _vm.labelFor }
	                },
	                [
	                  _vm._t("label", [
	                    _vm._v(_vm._s(_vm.label + _vm.form.labelSuffix))
	                  ])
	                ],
	                2
	              )
	            : _vm._e()
	        ]
	      ),
	      _c(
	        "div",
	        { staticClass: "el-form-item__content", style: _vm.contentStyle },
	        [
	          _vm._t("default"),
	          _c(
	            "transition",
	            { attrs: { name: "el-zoom-in-top" } },
	            [
	              _vm.validateState === "error" &&
	              _vm.showMessage &&
	              _vm.form.showMessage
	                ? _vm._t(
	                    "error",
	                    [
	                      _c(
	                        "div",
	                        {
	                          staticClass: "el-form-item__error",
	                          class: {
	                            "el-form-item__error--inline":
	                              typeof _vm.inlineMessage === "boolean"
	                                ? _vm.inlineMessage
	                                : (_vm.elForm && _vm.elForm.inlineMessage) ||
	                                  false
	                          }
	                        },
	                        [
	                          _vm._v(
	                            "\n          " +
	                              _vm._s(_vm.validateMessage) +
	                              "\n        "
	                          )
	                        ]
	                      )
	                    ],
	                    { error: _vm.validateMessage }
	                  )
	                : _vm._e()
	            ],
	            2
	          )
	        ],
	        2
	      )
	    ],
	    1
	  )
	}
	var form_itemvue_type_template_id_b6f3db6c_staticRenderFns = []
	form_itemvue_type_template_id_b6f3db6c_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/form/src/form-item.vue?vue&type=template&id=b6f3db6c&
	
	// EXTERNAL MODULE: external "async-validator"
	var external_async_validator_ = __webpack_require__(40);
	var external_async_validator_default = /*#__PURE__*/__webpack_require__.n(external_async_validator_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/form/src/label-wrap.vue?vue&type=script&lang=js&
	
	
	/* harmony default export */ var label_wrapvue_type_script_lang_js_ = ({
	  props: {
	    isAutoWidth: Boolean,
	    updateAll: Boolean
	  },
	
	  inject: ['elForm', 'elFormItem'],
	
	  render: function render() {
	    var h = arguments[0];
	
	    var slots = this.$slots.default;
	    if (!slots) return null;
	    if (this.isAutoWidth) {
	      var autoLabelWidth = this.elForm.autoLabelWidth;
	      var style = {};
	      if (autoLabelWidth && autoLabelWidth !== 'auto') {
	        var marginLeft = parseInt(autoLabelWidth, 10) - this.computedWidth;
	        if (marginLeft) {
	          style.marginLeft = marginLeft + 'px';
	        }
	      }
	      return h(
	        'div',
	        { 'class': 'el-form-item__label-wrap', style: style },
	        [slots]
	      );
	    } else {
	      return slots[0];
	    }
	  },
	
	
	  methods: {
	    getLabelWidth: function getLabelWidth() {
	      if (this.$el && this.$el.firstElementChild) {
	        var computedWidth = window.getComputedStyle(this.$el.firstElementChild).width;
	        return Math.ceil(parseFloat(computedWidth));
	      } else {
	        return 0;
	      }
	    },
	    updateLabelWidth: function updateLabelWidth() {
	      var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'update';
	
	      if (this.$slots.default && this.isAutoWidth && this.$el.firstElementChild) {
	        if (action === 'update') {
	          this.computedWidth = this.getLabelWidth();
	        } else if (action === 'remove') {
	          this.elForm.deregisterLabelWidth(this.computedWidth);
	        }
	      }
	    }
	  },
	
	  watch: {
	    computedWidth: function computedWidth(val, oldVal) {
	      if (this.updateAll) {
	        this.elForm.registerLabelWidth(val, oldVal);
	        this.elFormItem.updateComputedLabelWidth(val);
	      }
	    }
	  },
	
	  data: function data() {
	    return {
	      computedWidth: 0
	    };
	  },
	  mounted: function mounted() {
	    this.updateLabelWidth('update');
	  },
	  updated: function updated() {
	    this.updateLabelWidth('update');
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.updateLabelWidth('remove');
	  }
	});
	// CONCATENATED MODULE: ./packages/form/src/label-wrap.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_label_wrapvue_type_script_lang_js_ = (label_wrapvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/form/src/label-wrap.vue
	var label_wrap_render, label_wrap_staticRenderFns
	
	
	
	
	/* normalize component */
	
	var label_wrap_component = normalizeComponent(
	  src_label_wrapvue_type_script_lang_js_,
	  label_wrap_render,
	  label_wrap_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var label_wrap_api; }
	label_wrap_component.options.__file = "packages/form/src/label-wrap.vue"
	/* harmony default export */ var label_wrap = (label_wrap_component.exports);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/form/src/form-item.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	/* harmony default export */ var form_itemvue_type_script_lang_js_ = ({
	  name: 'ElFormItem',
	
	  componentName: 'ElFormItem',
	
	  mixins: [emitter_default.a],
	
	  provide: function provide() {
	    return {
	      elFormItem: this
	    };
	  },
	
	
	  inject: ['elForm'],
	
	  props: {
	    label: String,
	    labelWidth: String,
	    prop: String,
	    required: {
	      type: Boolean,
	      default: undefined
	    },
	    rules: [Object, Array],
	    error: String,
	    validateStatus: String,
	    for: String,
	    inlineMessage: {
	      type: [String, Boolean],
	      default: ''
	    },
	    showMessage: {
	      type: Boolean,
	      default: true
	    },
	    size: String
	  },
	  components: {
	    // use this component to calculate auto width
	    LabelWrap: label_wrap
	  },
	  watch: {
	    error: {
	      immediate: true,
	      handler: function handler(value) {
	        this.validateMessage = value;
	        this.validateState = value ? 'error' : '';
	      }
	    },
	    validateStatus: function validateStatus(value) {
	      this.validateState = value;
	    }
	  },
	  computed: {
	    labelFor: function labelFor() {
	      return this.for || this.prop;
	    },
	    labelStyle: function labelStyle() {
	      var ret = {};
	      if (this.form.labelPosition === 'top') return ret;
	      var labelWidth = this.labelWidth || this.form.labelWidth;
	      if (labelWidth) {
	        ret.width = labelWidth;
	      }
	      return ret;
	    },
	    contentStyle: function contentStyle() {
	      var ret = {};
	      var label = this.label;
	      if (this.form.labelPosition === 'top' || this.form.inline) return ret;
	      if (!label && !this.labelWidth && this.isNested) return ret;
	      var labelWidth = this.labelWidth || this.form.labelWidth;
	      if (labelWidth === 'auto') {
	        if (this.labelWidth === 'auto') {
	          ret.marginLeft = this.computedLabelWidth;
	        } else if (this.form.labelWidth === 'auto') {
	          ret.marginLeft = this.elForm.autoLabelWidth;
	        }
	      } else {
	        ret.marginLeft = labelWidth;
	      }
	      return ret;
	    },
	    form: function form() {
	      var parent = this.$parent;
	      var parentName = parent.$options.componentName;
	      while (parentName !== 'ElForm') {
	        if (parentName === 'ElFormItem') {
	          this.isNested = true;
	        }
	        parent = parent.$parent;
	        parentName = parent.$options.componentName;
	      }
	      return parent;
	    },
	    fieldValue: function fieldValue() {
	      var model = this.form.model;
	      if (!model || !this.prop) {
	        return;
	      }
	
	      var path = this.prop;
	      if (path.indexOf(':') !== -1) {
	        path = path.replace(/:/, '.');
	      }
	
	      return Object(util_["getPropByPath"])(model, path, true).v;
	    },
	    isRequired: function isRequired() {
	      var rules = this.getRules();
	      var isRequired = false;
	
	      if (rules && rules.length) {
	        rules.every(function (rule) {
	          if (rule.required) {
	            isRequired = true;
	            return false;
	          }
	          return true;
	        });
	      }
	      return isRequired;
	    },
	    _formSize: function _formSize() {
	      return this.elForm.size;
	    },
	    elFormItemSize: function elFormItemSize() {
	      return this.size || this._formSize;
	    },
	    sizeClass: function sizeClass() {
	      return this.elFormItemSize || (this.$ELEMENT || {}).size;
	    }
	  },
	  data: function data() {
	    return {
	      validateState: '',
	      validateMessage: '',
	      validateDisabled: false,
	      validator: {},
	      isNested: false,
	      computedLabelWidth: ''
	    };
	  },
	
	  methods: {
	    validate: function validate(trigger) {
	      var _this = this;
	
	      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : util_["noop"];
	
	      this.validateDisabled = false;
	      var rules = this.getFilteredRule(trigger);
	      if ((!rules || rules.length === 0) && this.required === undefined) {
	        callback();
	        return true;
	      }
	
	      this.validateState = 'validating';
	
	      var descriptor = {};
	      if (rules && rules.length > 0) {
	        rules.forEach(function (rule) {
	          delete rule.trigger;
	        });
	      }
	      descriptor[this.prop] = rules;
	
	      var validator = new external_async_validator_default.a(descriptor);
	      var model = {};
	
	      model[this.prop] = this.fieldValue;
	
	      validator.validate(model, { firstFields: true }, function (errors, invalidFields) {
	        _this.validateState = !errors ? 'success' : 'error';
	        _this.validateMessage = errors ? errors[0].message : '';
	
	        callback(_this.validateMessage, invalidFields);
	        _this.elForm && _this.elForm.$emit('validate', _this.prop, !errors, _this.validateMessage || null);
	      });
	    },
	    clearValidate: function clearValidate() {
	      this.validateState = '';
	      this.validateMessage = '';
	      this.validateDisabled = false;
	    },
	    resetField: function resetField() {
	      var _this2 = this;
	
	      this.validateState = '';
	      this.validateMessage = '';
	
	      var model = this.form.model;
	      var value = this.fieldValue;
	      var path = this.prop;
	      if (path.indexOf(':') !== -1) {
	        path = path.replace(/:/, '.');
	      }
	
	      var prop = Object(util_["getPropByPath"])(model, path, true);
	
	      this.validateDisabled = true;
	      if (Array.isArray(value)) {
	        prop.o[prop.k] = [].concat(this.initialValue);
	      } else {
	        prop.o[prop.k] = this.initialValue;
	      }
	
	      // reset validateDisabled after onFieldChange triggered
	      this.$nextTick(function () {
	        _this2.validateDisabled = false;
	      });
	
	      this.broadcast('ElTimeSelect', 'fieldReset', this.initialValue);
	    },
	    getRules: function getRules() {
	      var formRules = this.form.rules;
	      var selfRules = this.rules;
	      var requiredRule = this.required !== undefined ? { required: !!this.required } : [];
	
	      var prop = Object(util_["getPropByPath"])(formRules, this.prop || '');
	      formRules = formRules ? prop.o[this.prop || ''] || prop.v : [];
	
	      return [].concat(selfRules || formRules || []).concat(requiredRule);
	    },
	    getFilteredRule: function getFilteredRule(trigger) {
	      var rules = this.getRules();
	
	      return rules.filter(function (rule) {
	        if (!rule.trigger || trigger === '') return true;
	        if (Array.isArray(rule.trigger)) {
	          return rule.trigger.indexOf(trigger) > -1;
	        } else {
	          return rule.trigger === trigger;
	        }
	      }).map(function (rule) {
	        return merge_default()({}, rule);
	      });
	    },
	    onFieldBlur: function onFieldBlur() {
	      this.validate('blur');
	    },
	    onFieldChange: function onFieldChange() {
	      if (this.validateDisabled) {
	        this.validateDisabled = false;
	        return;
	      }
	
	      this.validate('change');
	    },
	    updateComputedLabelWidth: function updateComputedLabelWidth(width) {
	      this.computedLabelWidth = width ? width + 'px' : '';
	    },
	    addValidateEvents: function addValidateEvents() {
	      var rules = this.getRules();
	
	      if (rules.length || this.required !== undefined) {
	        this.$on('el.form.blur', this.onFieldBlur);
	        this.$on('el.form.change', this.onFieldChange);
	      }
	    },
	    removeValidateEvents: function removeValidateEvents() {
	      this.$off();
	    }
	  },
	  mounted: function mounted() {
	    if (this.prop) {
	      this.dispatch('ElForm', 'el.form.addField', [this]);
	
	      var initialValue = this.fieldValue;
	      if (Array.isArray(initialValue)) {
	        initialValue = [].concat(initialValue);
	      }
	      Object.defineProperty(this, 'initialValue', {
	        value: initialValue
	      });
	
	      this.addValidateEvents();
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.dispatch('ElForm', 'el.form.removeField', [this]);
	  }
	});
	// CONCATENATED MODULE: ./packages/form/src/form-item.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_form_itemvue_type_script_lang_js_ = (form_itemvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/form/src/form-item.vue
	
	
	
	
	
	/* normalize component */
	
	var form_item_component = normalizeComponent(
	  src_form_itemvue_type_script_lang_js_,
	  form_itemvue_type_template_id_b6f3db6c_render,
	  form_itemvue_type_template_id_b6f3db6c_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var form_item_api; }
	form_item_component.options.__file = "packages/form/src/form-item.vue"
	/* harmony default export */ var form_item = (form_item_component.exports);
	// CONCATENATED MODULE: ./packages/form-item/index.js
	
	
	/* istanbul ignore next */
	form_item.install = function (Vue) {
	  Vue.component(form_item.name, form_item);
	};
	
	/* harmony default export */ var packages_form_item = (form_item);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/tabs/src/tab-bar.vue?vue&type=template&id=2031f33a&
	var tab_barvue_type_template_id_2031f33a_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("div", {
	    staticClass: "el-tabs__active-bar",
	    class: "is-" + _vm.rootTabs.tabPosition,
	    style: _vm.barStyle
	  })
	}
	var tab_barvue_type_template_id_2031f33a_staticRenderFns = []
	tab_barvue_type_template_id_2031f33a_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/tabs/src/tab-bar.vue?vue&type=template&id=2031f33a&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/tabs/src/tab-bar.vue?vue&type=script&lang=js&
	//
	//
	//
	
	
	/* harmony default export */ var tab_barvue_type_script_lang_js_ = ({
	  name: 'TabBar',
	
	  props: {
	    tabs: Array
	  },
	
	  inject: ['rootTabs'],
	
	  computed: {
	    barStyle: {
	      get: function get() {
	        var _this = this;
	
	        var style = {};
	        var offset = 0;
	        var tabSize = 0;
	        var sizeName = ['top', 'bottom'].indexOf(this.rootTabs.tabPosition) !== -1 ? 'width' : 'height';
	        var sizeDir = sizeName === 'width' ? 'x' : 'y';
	        var firstUpperCase = function firstUpperCase(str) {
	          return str.toLowerCase().replace(/( |^)[a-z]/g, function (L) {
	            return L.toUpperCase();
	          });
	        };
	        this.tabs.every(function (tab, index) {
	          var $el = Object(util_["arrayFind"])(_this.$parent.$refs.tabs || [], function (t) {
	            return t.id.replace('tab-', '') === tab.paneName;
	          });
	          if (!$el) {
	            return false;
	          }
	
	          if (!tab.active) {
	            offset += $el['client' + firstUpperCase(sizeName)];
	            return true;
	          } else {
	            tabSize = $el['client' + firstUpperCase(sizeName)];
	            var tabStyles = window.getComputedStyle($el);
	            if (sizeName === 'width' && _this.tabs.length > 1) {
	              tabSize -= parseFloat(tabStyles.paddingLeft) + parseFloat(tabStyles.paddingRight);
	            }
	            if (sizeName === 'width') {
	              offset += parseFloat(tabStyles.paddingLeft);
	            }
	            return false;
	          }
	        });
	
	        var transform = 'translate' + firstUpperCase(sizeDir) + '(' + offset + 'px)';
	        style[sizeName] = tabSize + 'px';
	        style.transform = transform;
	        style.msTransform = transform;
	        style.webkitTransform = transform;
	
	        return style;
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/tabs/src/tab-bar.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_tab_barvue_type_script_lang_js_ = (tab_barvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/tabs/src/tab-bar.vue
	
	
	
	
	
	/* normalize component */
	
	var tab_bar_component = normalizeComponent(
	  src_tab_barvue_type_script_lang_js_,
	  tab_barvue_type_template_id_2031f33a_render,
	  tab_barvue_type_template_id_2031f33a_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var tab_bar_api; }
	tab_bar_component.options.__file = "packages/tabs/src/tab-bar.vue"
	/* harmony default export */ var tab_bar = (tab_bar_component.exports);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/tabs/src/tab-nav.vue?vue&type=script&lang=js&
	
	
	
	
	function noop() {}
	var tab_navvue_type_script_lang_js_firstUpperCase = function firstUpperCase(str) {
	  return str.toLowerCase().replace(/( |^)[a-z]/g, function (L) {
	    return L.toUpperCase();
	  });
	};
	
	/* harmony default export */ var tab_navvue_type_script_lang_js_ = ({
	  name: 'TabNav',
	
	  components: {
	    TabBar: tab_bar
	  },
	
	  inject: ['rootTabs'],
	
	  props: {
	    panes: Array,
	    currentName: String,
	    editable: Boolean,
	    onTabClick: {
	      type: Function,
	      default: noop
	    },
	    onTabRemove: {
	      type: Function,
	      default: noop
	    },
	    type: String,
	    stretch: Boolean
	  },
	
	  data: function data() {
	    return {
	      scrollable: false,
	      navOffset: 0,
	      isFocus: false,
	      focusable: true
	    };
	  },
	
	
	  computed: {
	    navStyle: function navStyle() {
	      var dir = ['top', 'bottom'].indexOf(this.rootTabs.tabPosition) !== -1 ? 'X' : 'Y';
	      return {
	        transform: 'translate' + dir + '(-' + this.navOffset + 'px)'
	      };
	    },
	    sizeName: function sizeName() {
	      return ['top', 'bottom'].indexOf(this.rootTabs.tabPosition) !== -1 ? 'width' : 'height';
	    }
	  },
	
	  methods: {
	    scrollPrev: function scrollPrev() {
	      var containerSize = this.$refs.navScroll['offset' + tab_navvue_type_script_lang_js_firstUpperCase(this.sizeName)];
	      var currentOffset = this.navOffset;
	
	      if (!currentOffset) return;
	
	      var newOffset = currentOffset > containerSize ? currentOffset - containerSize : 0;
	
	      this.navOffset = newOffset;
	    },
	    scrollNext: function scrollNext() {
	      var navSize = this.$refs.nav['offset' + tab_navvue_type_script_lang_js_firstUpperCase(this.sizeName)];
	      var containerSize = this.$refs.navScroll['offset' + tab_navvue_type_script_lang_js_firstUpperCase(this.sizeName)];
	      var currentOffset = this.navOffset;
	
	      if (navSize - currentOffset <= containerSize) return;
	
	      var newOffset = navSize - currentOffset > containerSize * 2 ? currentOffset + containerSize : navSize - containerSize;
	
	      this.navOffset = newOffset;
	    },
	    scrollToActiveTab: function scrollToActiveTab() {
	      if (!this.scrollable) return;
	      var nav = this.$refs.nav;
	      var activeTab = this.$el.querySelector('.is-active');
	      if (!activeTab) return;
	      var navScroll = this.$refs.navScroll;
	      var isHorizontal = ['top', 'bottom'].indexOf(this.rootTabs.tabPosition) !== -1;
	      var activeTabBounding = activeTab.getBoundingClientRect();
	      var navScrollBounding = navScroll.getBoundingClientRect();
	      var maxOffset = isHorizontal ? nav.offsetWidth - navScrollBounding.width : nav.offsetHeight - navScrollBounding.height;
	      var currentOffset = this.navOffset;
	      var newOffset = currentOffset;
	
	      if (isHorizontal) {
	        if (activeTabBounding.left < navScrollBounding.left) {
	          newOffset = currentOffset - (navScrollBounding.left - activeTabBounding.left);
	        }
	        if (activeTabBounding.right > navScrollBounding.right) {
	          newOffset = currentOffset + activeTabBounding.right - navScrollBounding.right;
	        }
	      } else {
	        if (activeTabBounding.top < navScrollBounding.top) {
	          newOffset = currentOffset - (navScrollBounding.top - activeTabBounding.top);
	        }
	        if (activeTabBounding.bottom > navScrollBounding.bottom) {
	          newOffset = currentOffset + (activeTabBounding.bottom - navScrollBounding.bottom);
	        }
	      }
	      newOffset = Math.max(newOffset, 0);
	      this.navOffset = Math.min(newOffset, maxOffset);
	    },
	    update: function update() {
	      if (!this.$refs.nav) return;
	      var sizeName = this.sizeName;
	      var navSize = this.$refs.nav['offset' + tab_navvue_type_script_lang_js_firstUpperCase(sizeName)];
	      var containerSize = this.$refs.navScroll['offset' + tab_navvue_type_script_lang_js_firstUpperCase(sizeName)];
	      var currentOffset = this.navOffset;
	
	      if (containerSize < navSize) {
	        var _currentOffset = this.navOffset;
	        this.scrollable = this.scrollable || {};
	        this.scrollable.prev = _currentOffset;
	        this.scrollable.next = _currentOffset + containerSize < navSize;
	        if (navSize - _currentOffset < containerSize) {
	          this.navOffset = navSize - containerSize;
	        }
	      } else {
	        this.scrollable = false;
	        if (currentOffset > 0) {
	          this.navOffset = 0;
	        }
	      }
	    },
	    changeTab: function changeTab(e) {
	      var keyCode = e.keyCode;
	      var nextIndex = void 0;
	      var currentIndex = void 0,
	          tabList = void 0;
	      if ([37, 38, 39, 40].indexOf(keyCode) !== -1) {
	        // 左右上下键更换tab
	        tabList = e.currentTarget.querySelectorAll('[role=tab]');
	        currentIndex = Array.prototype.indexOf.call(tabList, e.target);
	      } else {
	        return;
	      }
	      if (keyCode === 37 || keyCode === 38) {
	        // left
	        if (currentIndex === 0) {
	          // first
	          nextIndex = tabList.length - 1;
	        } else {
	          nextIndex = currentIndex - 1;
	        }
	      } else {
	        // right
	        if (currentIndex < tabList.length - 1) {
	          // not last
	          nextIndex = currentIndex + 1;
	        } else {
	          nextIndex = 0;
	        }
	      }
	      tabList[nextIndex].focus(); // 改变焦点元素
	      tabList[nextIndex].click(); // 选中下一个tab
	      this.setFocus();
	    },
	    setFocus: function setFocus() {
	      if (this.focusable) {
	        this.isFocus = true;
	      }
	    },
	    removeFocus: function removeFocus() {
	      this.isFocus = false;
	    },
	    visibilityChangeHandler: function visibilityChangeHandler() {
	      var _this = this;
	
	      var visibility = document.visibilityState;
	      if (visibility === 'hidden') {
	        this.focusable = false;
	      } else if (visibility === 'visible') {
	        setTimeout(function () {
	          _this.focusable = true;
	        }, 50);
	      }
	    },
	    windowBlurHandler: function windowBlurHandler() {
	      this.focusable = false;
	    },
	    windowFocusHandler: function windowFocusHandler() {
	      var _this2 = this;
	
	      setTimeout(function () {
	        _this2.focusable = true;
	      }, 50);
	    }
	  },
	
	  updated: function updated() {
	    this.update();
	  },
	  render: function render(h) {
	    var _this3 = this;
	
	    var type = this.type,
	        panes = this.panes,
	        editable = this.editable,
	        stretch = this.stretch,
	        onTabClick = this.onTabClick,
	        onTabRemove = this.onTabRemove,
	        navStyle = this.navStyle,
	        scrollable = this.scrollable,
	        scrollNext = this.scrollNext,
	        scrollPrev = this.scrollPrev,
	        changeTab = this.changeTab,
	        setFocus = this.setFocus,
	        removeFocus = this.removeFocus;
	
	    var scrollBtn = scrollable ? [h(
	      'span',
	      { 'class': ['el-tabs__nav-prev', scrollable.prev ? '' : 'is-disabled'], on: {
	          'click': scrollPrev
	        }
	      },
	      [h('i', { 'class': 'el-icon-arrow-left' })]
	    ), h(
	      'span',
	      { 'class': ['el-tabs__nav-next', scrollable.next ? '' : 'is-disabled'], on: {
	          'click': scrollNext
	        }
	      },
	      [h('i', { 'class': 'el-icon-arrow-right' })]
	    )] : null;
	
	    var tabs = this._l(panes, function (pane, index) {
	      var _ref;
	
	      var tabName = pane.name || pane.index || index;
	      var closable = pane.isClosable || editable;
	
	      pane.index = '' + index;
	
	      var btnClose = closable ? h('span', { 'class': 'el-icon-close', on: {
	          'click': function click(ev) {
	            onTabRemove(pane, ev);
	          }
	        }
	      }) : null;
	
	      var tabLabelContent = pane.$slots.label || pane.label;
	      var tabindex = pane.active ? 0 : -1;
	      return h(
	        'div',
	        {
	          'class': (_ref = {
	            'el-tabs__item': true
	          }, _ref['is-' + _this3.rootTabs.tabPosition] = true, _ref['is-active'] = pane.active, _ref['is-disabled'] = pane.disabled, _ref['is-closable'] = closable, _ref['is-focus'] = _this3.isFocus, _ref),
	          attrs: { id: 'tab-' + tabName,
	
	            'aria-controls': 'pane-' + tabName,
	            role: 'tab',
	            'aria-selected': pane.active,
	
	            tabindex: tabindex
	          },
	          key: 'tab-' + tabName, ref: 'tabs', refInFor: true,
	          on: {
	            'focus': function focus() {
	              setFocus();
	            },
	            'blur': function blur() {
	              removeFocus();
	            },
	            'click': function click(ev) {
	              removeFocus();onTabClick(pane, tabName, ev);
	            },
	            'keydown': function keydown(ev) {
	              if (closable && (ev.keyCode === 46 || ev.keyCode === 8)) {
	                onTabRemove(pane, ev);
	              }
	            }
	          }
	        },
	        [tabLabelContent, btnClose]
	      );
	    });
	    return h(
	      'div',
	      { 'class': ['el-tabs__nav-wrap', scrollable ? 'is-scrollable' : '', 'is-' + this.rootTabs.tabPosition] },
	      [scrollBtn, h(
	        'div',
	        { 'class': ['el-tabs__nav-scroll'], ref: 'navScroll' },
	        [h(
	          'div',
	          {
	            'class': ['el-tabs__nav', 'is-' + this.rootTabs.tabPosition, stretch && ['top', 'bottom'].indexOf(this.rootTabs.tabPosition) !== -1 ? 'is-stretch' : ''],
	            ref: 'nav',
	            style: navStyle,
	            attrs: { role: 'tablist'
	            },
	            on: {
	              'keydown': changeTab
	            }
	          },
	          [!type ? h('tab-bar', {
	            attrs: { tabs: panes }
	          }) : null, tabs]
	        )]
	      )]
	    );
	  },
	  mounted: function mounted() {
	    var _this4 = this;
	
	    Object(resize_event_["addResizeListener"])(this.$el, this.update);
	    document.addEventListener('visibilitychange', this.visibilityChangeHandler);
	    window.addEventListener('blur', this.windowBlurHandler);
	    window.addEventListener('focus', this.windowFocusHandler);
	    setTimeout(function () {
	      _this4.scrollToActiveTab();
	    }, 0);
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this.$el && this.update) Object(resize_event_["removeResizeListener"])(this.$el, this.update);
	    document.removeEventListener('visibilitychange', this.visibilityChangeHandler);
	    window.removeEventListener('blur', this.windowBlurHandler);
	    window.removeEventListener('focus', this.windowFocusHandler);
	  }
	});
	// CONCATENATED MODULE: ./packages/tabs/src/tab-nav.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_tab_navvue_type_script_lang_js_ = (tab_navvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/tabs/src/tab-nav.vue
	var tab_nav_render, tab_nav_staticRenderFns
	
	
	
	
	/* normalize component */
	
	var tab_nav_component = normalizeComponent(
	  src_tab_navvue_type_script_lang_js_,
	  tab_nav_render,
	  tab_nav_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var tab_nav_api; }
	tab_nav_component.options.__file = "packages/tabs/src/tab-nav.vue"
	/* harmony default export */ var tab_nav = (tab_nav_component.exports);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/tabs/src/tabs.vue?vue&type=script&lang=js&
	
	
	
	/* harmony default export */ var tabsvue_type_script_lang_js_ = ({
	  name: 'ElTabs',
	
	  components: {
	    TabNav: tab_nav
	  },
	
	  props: {
	    type: String,
	    activeName: String,
	    closable: Boolean,
	    addable: Boolean,
	    value: {},
	    editable: Boolean,
	    tabPosition: {
	      type: String,
	      default: 'top'
	    },
	    beforeLeave: Function,
	    stretch: Boolean
	  },
	
	  provide: function provide() {
	    return {
	      rootTabs: this
	    };
	  },
	  data: function data() {
	    return {
	      currentName: this.value || this.activeName,
	      panes: []
	    };
	  },
	
	
	  watch: {
	    activeName: function activeName(value) {
	      this.setCurrentName(value);
	    },
	    value: function value(_value) {
	      this.setCurrentName(_value);
	    },
	    currentName: function currentName(value) {
	      var _this = this;
	
	      if (this.$refs.nav) {
	        this.$nextTick(function () {
	          _this.$refs.nav.$nextTick(function (_) {
	            _this.$refs.nav.scrollToActiveTab();
	          });
	        });
	      }
	    }
	  },
	
	  methods: {
	    calcPaneInstances: function calcPaneInstances() {
	      var _this2 = this;
	
	      var isForceUpdate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      if (this.$slots.default) {
	        var paneSlots = this.$slots.default.filter(function (vnode) {
	          return vnode.tag && vnode.componentOptions && vnode.componentOptions.Ctor.options.name === 'ElTabPane';
	        });
	        // update indeed
	        var panes = paneSlots.map(function (_ref) {
	          var componentInstance = _ref.componentInstance;
	          return componentInstance;
	        });
	        var panesChanged = !(panes.length === this.panes.length && panes.every(function (pane, index) {
	          return pane === _this2.panes[index];
	        }));
	        if (isForceUpdate || panesChanged) {
	          this.panes = panes;
	        }
	      } else if (this.panes.length !== 0) {
	        this.panes = [];
	      }
	    },
	    handleTabClick: function handleTabClick(tab, tabName, event) {
	      if (tab.disabled) return;
	      this.setCurrentName(tabName);
	      this.$emit('tab-click', tab, event);
	    },
	    handleTabRemove: function handleTabRemove(pane, ev) {
	      if (pane.disabled) return;
	      ev.stopPropagation();
	      this.$emit('edit', pane.name, 'remove');
	      this.$emit('tab-remove', pane.name);
	    },
	    handleTabAdd: function handleTabAdd() {
	      this.$emit('edit', null, 'add');
	      this.$emit('tab-add');
	    },
	    setCurrentName: function setCurrentName(value) {
	      var _this3 = this;
	
	      var changeCurrentName = function changeCurrentName() {
	        _this3.currentName = value;
	        _this3.$emit('input', value);
	      };
	      if (this.currentName !== value && this.beforeLeave) {
	        var before = this.beforeLeave(value, this.currentName);
	        if (before && before.then) {
	          before.then(function () {
	            changeCurrentName();
	            _this3.$refs.nav && _this3.$refs.nav.removeFocus();
	          }, function () {
	            // https://github.com/ElemeFE/element/pull/14816
	            // ignore promise rejection in `before-leave` hook
	          });
	        } else if (before !== false) {
	          changeCurrentName();
	        }
	      } else {
	        changeCurrentName();
	      }
	    }
	  },
	
	  render: function render(h) {
	    var _ref2;
	
	    var type = this.type,
	        handleTabClick = this.handleTabClick,
	        handleTabRemove = this.handleTabRemove,
	        handleTabAdd = this.handleTabAdd,
	        currentName = this.currentName,
	        panes = this.panes,
	        editable = this.editable,
	        addable = this.addable,
	        tabPosition = this.tabPosition,
	        stretch = this.stretch;
	
	
	    var newButton = editable || addable ? h(
	      'span',
	      {
	        'class': 'el-tabs__new-tab',
	        on: {
	          'click': handleTabAdd,
	          'keydown': function keydown(ev) {
	            if (ev.keyCode === 13) {
	              handleTabAdd();
	            }
	          }
	        },
	        attrs: {
	          tabindex: '0'
	        }
	      },
	      [h('i', { 'class': 'el-icon-plus' })]
	    ) : null;
	
	    var navData = {
	      props: {
	        currentName: currentName,
	        onTabClick: handleTabClick,
	        onTabRemove: handleTabRemove,
	        editable: editable,
	        type: type,
	        panes: panes,
	        stretch: stretch
	      },
	      ref: 'nav'
	    };
	    var header = h(
	      'div',
	      { 'class': ['el-tabs__header', 'is-' + tabPosition] },
	      [newButton, h('tab-nav', navData)]
	    );
	    var panels = h(
	      'div',
	      { 'class': 'el-tabs__content' },
	      [this.$slots.default]
	    );
	
	    return h(
	      'div',
	      { 'class': (_ref2 = {
	          'el-tabs': true,
	          'el-tabs--card': type === 'card'
	        }, _ref2['el-tabs--' + tabPosition] = true, _ref2['el-tabs--border-card'] = type === 'border-card', _ref2) },
	      [tabPosition !== 'bottom' ? [header, panels] : [panels, header]]
	    );
	  },
	  created: function created() {
	    if (!this.currentName) {
	      this.setCurrentName('0');
	    }
	
	    this.$on('tab-nav-update', this.calcPaneInstances.bind(null, true));
	  },
	  mounted: function mounted() {
	    this.calcPaneInstances();
	  },
	  updated: function updated() {
	    this.calcPaneInstances();
	  }
	});
	// CONCATENATED MODULE: ./packages/tabs/src/tabs.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_tabsvue_type_script_lang_js_ = (tabsvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/tabs/src/tabs.vue
	var tabs_render, tabs_staticRenderFns
	
	
	
	
	/* normalize component */
	
	var tabs_component = normalizeComponent(
	  src_tabsvue_type_script_lang_js_,
	  tabs_render,
	  tabs_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var tabs_api; }
	tabs_component.options.__file = "packages/tabs/src/tabs.vue"
	/* harmony default export */ var tabs = (tabs_component.exports);
	// CONCATENATED MODULE: ./packages/tabs/index.js
	
	
	/* istanbul ignore next */
	tabs.install = function (Vue) {
	  Vue.component(tabs.name, tabs);
	};
	
	/* harmony default export */ var packages_tabs = (tabs);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/tabs/src/tab-pane.vue?vue&type=template&id=9145a070&
	var tab_panevue_type_template_id_9145a070_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return !_vm.lazy || _vm.loaded || _vm.active
	    ? _c(
	        "div",
	        {
	          directives: [
	            {
	              name: "show",
	              rawName: "v-show",
	              value: _vm.active,
	              expression: "active"
	            }
	          ],
	          staticClass: "el-tab-pane",
	          attrs: {
	            role: "tabpanel",
	            "aria-hidden": !_vm.active,
	            id: "pane-" + _vm.paneName,
	            "aria-labelledby": "tab-" + _vm.paneName
	          }
	        },
	        [_vm._t("default")],
	        2
	      )
	    : _vm._e()
	}
	var tab_panevue_type_template_id_9145a070_staticRenderFns = []
	tab_panevue_type_template_id_9145a070_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/tabs/src/tab-pane.vue?vue&type=template&id=9145a070&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/tabs/src/tab-pane.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var tab_panevue_type_script_lang_js_ = ({
	  name: 'ElTabPane',
	
	  componentName: 'ElTabPane',
	
	  props: {
	    label: String,
	    labelContent: Function,
	    name: String,
	    closable: Boolean,
	    disabled: Boolean,
	    lazy: Boolean
	  },
	
	  data: function data() {
	    return {
	      index: null,
	      loaded: false
	    };
	  },
	
	
	  computed: {
	    isClosable: function isClosable() {
	      return this.closable || this.$parent.closable;
	    },
	    active: function active() {
	      var active = this.$parent.currentName === (this.name || this.index);
	      if (active) {
	        this.loaded = true;
	      }
	      return active;
	    },
	    paneName: function paneName() {
	      return this.name || this.index;
	    }
	  },
	
	  updated: function updated() {
	    this.$parent.$emit('tab-nav-update');
	  }
	});
	// CONCATENATED MODULE: ./packages/tabs/src/tab-pane.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_tab_panevue_type_script_lang_js_ = (tab_panevue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/tabs/src/tab-pane.vue
	
	
	
	
	
	/* normalize component */
	
	var tab_pane_component = normalizeComponent(
	  src_tab_panevue_type_script_lang_js_,
	  tab_panevue_type_template_id_9145a070_render,
	  tab_panevue_type_template_id_9145a070_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var tab_pane_api; }
	tab_pane_component.options.__file = "packages/tabs/src/tab-pane.vue"
	/* harmony default export */ var tab_pane = (tab_pane_component.exports);
	// CONCATENATED MODULE: ./packages/tab-pane/index.js
	
	
	/* istanbul ignore next */
	tab_pane.install = function (Vue) {
	  Vue.component(tab_pane.name, tab_pane);
	};
	
	/* harmony default export */ var packages_tab_pane = (tab_pane);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/tag/src/tag.vue?vue&type=script&lang=js&
	
	/* harmony default export */ var tagvue_type_script_lang_js_ = ({
	  name: 'ElTag',
	  props: {
	    text: String,
	    closable: Boolean,
	    type: String,
	    hit: Boolean,
	    disableTransitions: Boolean,
	    color: String,
	    size: String,
	    effect: {
	      type: String,
	      default: 'light',
	      validator: function validator(val) {
	        return ['dark', 'light', 'plain'].indexOf(val) !== -1;
	      }
	    }
	  },
	  methods: {
	    handleClose: function handleClose(event) {
	      event.stopPropagation();
	      this.$emit('close', event);
	    },
	    handleClick: function handleClick(event) {
	      this.$emit('click', event);
	    }
	  },
	  computed: {
	    tagSize: function tagSize() {
	      return this.size || (this.$ELEMENT || {}).size;
	    }
	  },
	  render: function render(h) {
	    var type = this.type,
	        tagSize = this.tagSize,
	        hit = this.hit,
	        effect = this.effect;
	
	    var classes = ['el-tag', type ? 'el-tag--' + type : '', tagSize ? 'el-tag--' + tagSize : '', effect ? 'el-tag--' + effect : '', hit && 'is-hit'];
	    var tagEl = h(
	      'span',
	      {
	        'class': classes,
	        style: { backgroundColor: this.color },
	        on: {
	          'click': this.handleClick
	        }
	      },
	      [this.$slots.default, this.closable && h('i', { 'class': 'el-tag__close el-icon-close', on: {
	          'click': this.handleClose
	        }
	      })]
	    );
	
	    return this.disableTransitions ? tagEl : h(
	      'transition',
	      {
	        attrs: { name: 'el-zoom-in-center' }
	      },
	      [tagEl]
	    );
	  }
	});
	// CONCATENATED MODULE: ./packages/tag/src/tag.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_tagvue_type_script_lang_js_ = (tagvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/tag/src/tag.vue
	var tag_render, tag_staticRenderFns
	
	
	
	
	/* normalize component */
	
	var tag_component = normalizeComponent(
	  src_tagvue_type_script_lang_js_,
	  tag_render,
	  tag_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var tag_api; }
	tag_component.options.__file = "packages/tag/src/tag.vue"
	/* harmony default export */ var tag = (tag_component.exports);
	// CONCATENATED MODULE: ./packages/tag/index.js
	
	
	/* istanbul ignore next */
	tag.install = function (Vue) {
	  Vue.component(tag.name, tag);
	};
	
	/* harmony default export */ var packages_tag = (tag);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/tree/src/tree.vue?vue&type=template&id=547575a6&
	var treevue_type_template_id_547575a6_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-tree",
	      class: {
	        "el-tree--highlight-current": _vm.highlightCurrent,
	        "is-dragging": !!_vm.dragState.draggingNode,
	        "is-drop-not-allow": !_vm.dragState.allowDrop,
	        "is-drop-inner": _vm.dragState.dropType === "inner"
	      },
	      attrs: { role: "tree" }
	    },
	    [
	      _vm._l(_vm.root.childNodes, function(child) {
	        return _c("el-tree-node", {
	          key: _vm.getNodeKey(child),
	          attrs: {
	            node: child,
	            props: _vm.props,
	            "render-after-expand": _vm.renderAfterExpand,
	            "show-checkbox": _vm.showCheckbox,
	            "render-content": _vm.renderContent
	          },
	          on: { "node-expand": _vm.handleNodeExpand }
	        })
	      }),
	      _vm.isEmpty
	        ? _c("div", { staticClass: "el-tree__empty-block" }, [
	            _c("span", { staticClass: "el-tree__empty-text" }, [
	              _vm._v(_vm._s(_vm.emptyText))
	            ])
	          ])
	        : _vm._e(),
	      _c("div", {
	        directives: [
	          {
	            name: "show",
	            rawName: "v-show",
	            value: _vm.dragState.showDropIndicator,
	            expression: "dragState.showDropIndicator"
	          }
	        ],
	        ref: "dropIndicator",
	        staticClass: "el-tree__drop-indicator"
	      })
	    ],
	    2
	  )
	}
	var treevue_type_template_id_547575a6_staticRenderFns = []
	treevue_type_template_id_547575a6_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/tree/src/tree.vue?vue&type=template&id=547575a6&
	
	// CONCATENATED MODULE: ./packages/tree/src/model/util.js
	var NODE_KEY = '$treeNodeId';
	
	var markNodeData = function markNodeData(node, data) {
	  if (!data || data[NODE_KEY]) return;
	  Object.defineProperty(data, NODE_KEY, {
	    value: node.id,
	    enumerable: false,
	    configurable: false,
	    writable: false
	  });
	};
	
	var util_getNodeKey = function getNodeKey(key, data) {
	  if (!key) return data[NODE_KEY];
	  return data[key];
	};
	
	var findNearestComponent = function findNearestComponent(element, componentName) {
	  var target = element;
	  while (target && target.tagName !== 'BODY') {
	    if (target.__vue__ && target.__vue__.$options.name === componentName) {
	      return target.__vue__;
	    }
	    target = target.parentNode;
	  }
	  return null;
	};
	// CONCATENATED MODULE: ./packages/tree/src/model/node.js
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function node_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	
	
	
	
	var getChildState = function getChildState(node) {
	  var all = true;
	  var none = true;
	  var allWithoutDisable = true;
	  for (var i = 0, j = node.length; i < j; i++) {
	    var n = node[i];
	    if (n.checked !== true || n.indeterminate) {
	      all = false;
	      if (!n.disabled) {
	        allWithoutDisable = false;
	      }
	    }
	    if (n.checked !== false || n.indeterminate) {
	      none = false;
	    }
	  }
	
	  return { all: all, none: none, allWithoutDisable: allWithoutDisable, half: !all && !none };
	};
	
	var reInitChecked = function reInitChecked(node) {
	  if (node.childNodes.length === 0) return;
	
	  var _getChildState = getChildState(node.childNodes),
	      all = _getChildState.all,
	      none = _getChildState.none,
	      half = _getChildState.half;
	
	  if (all) {
	    node.checked = true;
	    node.indeterminate = false;
	  } else if (half) {
	    node.checked = false;
	    node.indeterminate = true;
	  } else if (none) {
	    node.checked = false;
	    node.indeterminate = false;
	  }
	
	  var parent = node.parent;
	  if (!parent || parent.level === 0) return;
	
	  if (!node.store.checkStrictly) {
	    reInitChecked(parent);
	  }
	};
	
	var getPropertyFromData = function getPropertyFromData(node, prop) {
	  var props = node.store.props;
	  var data = node.data || {};
	  var config = props[prop];
	
	  if (typeof config === 'function') {
	    return config(data, node);
	  } else if (typeof config === 'string') {
	    return data[config];
	  } else if (typeof config === 'undefined') {
	    var dataProp = data[prop];
	    return dataProp === undefined ? '' : dataProp;
	  }
	};
	
	var nodeIdSeed = 0;
	
	var node_Node = function () {
	  function Node(options) {
	    node_classCallCheck(this, Node);
	
	    this.id = nodeIdSeed++;
	    this.text = null;
	    this.checked = false;
	    this.indeterminate = false;
	    this.data = null;
	    this.expanded = false;
	    this.parent = null;
	    this.visible = true;
	    this.isCurrent = false;
	
	    for (var name in options) {
	      if (options.hasOwnProperty(name)) {
	        this[name] = options[name];
	      }
	    }
	
	    // internal
	    this.level = 0;
	    this.loaded = false;
	    this.childNodes = [];
	    this.loading = false;
	
	    if (this.parent) {
	      this.level = this.parent.level + 1;
	    }
	
	    var store = this.store;
	    if (!store) {
	      throw new Error('[Node]store is required!');
	    }
	    store.registerNode(this);
	
	    var props = store.props;
	    if (props && typeof props.isLeaf !== 'undefined') {
	      var isLeaf = getPropertyFromData(this, 'isLeaf');
	      if (typeof isLeaf === 'boolean') {
	        this.isLeafByUser = isLeaf;
	      }
	    }
	
	    if (store.lazy !== true && this.data) {
	      this.setData(this.data);
	
	      if (store.defaultExpandAll) {
	        this.expanded = true;
	      }
	    } else if (this.level > 0 && store.lazy && store.defaultExpandAll) {
	      this.expand();
	    }
	    if (!Array.isArray(this.data)) {
	      markNodeData(this, this.data);
	    }
	    if (!this.data) return;
	    var defaultExpandedKeys = store.defaultExpandedKeys;
	    var key = store.key;
	    if (key && defaultExpandedKeys && defaultExpandedKeys.indexOf(this.key) !== -1) {
	      this.expand(null, store.autoExpandParent);
	    }
	
	    if (key && store.currentNodeKey !== undefined && this.key === store.currentNodeKey) {
	      store.currentNode = this;
	      store.currentNode.isCurrent = true;
	    }
	
	    if (store.lazy) {
	      store._initDefaultCheckedNode(this);
	    }
	
	    this.updateLeafState();
	  }
	
	  Node.prototype.setData = function setData(data) {
	    if (!Array.isArray(data)) {
	      markNodeData(this, data);
	    }
	
	    this.data = data;
	    this.childNodes = [];
	
	    var children = void 0;
	    if (this.level === 0 && this.data instanceof Array) {
	      children = this.data;
	    } else {
	      children = getPropertyFromData(this, 'children') || [];
	    }
	
	    for (var i = 0, j = children.length; i < j; i++) {
	      this.insertChild({ data: children[i] });
	    }
	  };
	
	  Node.prototype.contains = function contains(target) {
	    var deep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    var walk = function walk(parent) {
	      var children = parent.childNodes || [];
	      var result = false;
	      for (var i = 0, j = children.length; i < j; i++) {
	        var child = children[i];
	        if (child === target || deep && walk(child)) {
	          result = true;
	          break;
	        }
	      }
	      return result;
	    };
	
	    return walk(this);
	  };
	
	  Node.prototype.remove = function remove() {
	    var parent = this.parent;
	    if (parent) {
	      parent.removeChild(this);
	    }
	  };
	
	  Node.prototype.insertChild = function insertChild(child, index, batch) {
	    if (!child) throw new Error('insertChild error: child is required.');
	
	    if (!(child instanceof Node)) {
	      if (!batch) {
	        var children = this.getChildren(true);
	        if (children.indexOf(child.data) === -1) {
	          if (typeof index === 'undefined' || index < 0) {
	            children.push(child.data);
	          } else {
	            children.splice(index, 0, child.data);
	          }
	        }
	      }
	      merge_default()(child, {
	        parent: this,
	        store: this.store
	      });
	      child = new Node(child);
	    }
	
	    child.level = this.level + 1;
	
	    if (typeof index === 'undefined' || index < 0) {
	      this.childNodes.push(child);
	    } else {
	      this.childNodes.splice(index, 0, child);
	    }
	
	    this.updateLeafState();
	  };
	
	  Node.prototype.insertBefore = function insertBefore(child, ref) {
	    var index = void 0;
	    if (ref) {
	      index = this.childNodes.indexOf(ref);
	    }
	    this.insertChild(child, index);
	  };
	
	  Node.prototype.insertAfter = function insertAfter(child, ref) {
	    var index = void 0;
	    if (ref) {
	      index = this.childNodes.indexOf(ref);
	      if (index !== -1) index += 1;
	    }
	    this.insertChild(child, index);
	  };
	
	  Node.prototype.removeChild = function removeChild(child) {
	    var children = this.getChildren() || [];
	    var dataIndex = children.indexOf(child.data);
	    if (dataIndex > -1) {
	      children.splice(dataIndex, 1);
	    }
	
	    var index = this.childNodes.indexOf(child);
	
	    if (index > -1) {
	      this.store && this.store.deregisterNode(child);
	      child.parent = null;
	      this.childNodes.splice(index, 1);
	    }
	
	    this.updateLeafState();
	  };
	
	  Node.prototype.removeChildByData = function removeChildByData(data) {
	    var targetNode = null;
	
	    for (var i = 0; i < this.childNodes.length; i++) {
	      if (this.childNodes[i].data === data) {
	        targetNode = this.childNodes[i];
	        break;
	      }
	    }
	
	    if (targetNode) {
	      this.removeChild(targetNode);
	    }
	  };
	
	  Node.prototype.expand = function expand(callback, expandParent) {
	    var _this = this;
	
	    var done = function done() {
	      if (expandParent) {
	        var parent = _this.parent;
	        while (parent.level > 0) {
	          parent.expanded = true;
	          parent = parent.parent;
	        }
	      }
	      _this.expanded = true;
	      if (callback) callback();
	    };
	
	    if (this.shouldLoadData()) {
	      this.loadData(function (data) {
	        if (data instanceof Array) {
	          if (_this.checked) {
	            _this.setChecked(true, true);
	          } else if (!_this.store.checkStrictly) {
	            reInitChecked(_this);
	          }
	          done();
	        }
	      });
	    } else {
	      done();
	    }
	  };
	
	  Node.prototype.doCreateChildren = function doCreateChildren(array) {
	    var _this2 = this;
	
	    var defaultProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    array.forEach(function (item) {
	      _this2.insertChild(merge_default()({ data: item }, defaultProps), undefined, true);
	    });
	  };
	
	  Node.prototype.collapse = function collapse() {
	    this.expanded = false;
	  };
	
	  Node.prototype.shouldLoadData = function shouldLoadData() {
	    return this.store.lazy === true && this.store.load && !this.loaded;
	  };
	
	  Node.prototype.updateLeafState = function updateLeafState() {
	    if (this.store.lazy === true && this.loaded !== true && typeof this.isLeafByUser !== 'undefined') {
	      this.isLeaf = this.isLeafByUser;
	      return;
	    }
	    var childNodes = this.childNodes;
	    if (!this.store.lazy || this.store.lazy === true && this.loaded === true) {
	      this.isLeaf = !childNodes || childNodes.length === 0;
	      return;
	    }
	    this.isLeaf = false;
	  };
	
	  Node.prototype.setChecked = function setChecked(value, deep, recursion, passValue) {
	    var _this3 = this;
	
	    this.indeterminate = value === 'half';
	    this.checked = value === true;
	
	    if (this.store.checkStrictly) return;
	
	    if (!(this.shouldLoadData() && !this.store.checkDescendants)) {
	      var _getChildState2 = getChildState(this.childNodes),
	          all = _getChildState2.all,
	          allWithoutDisable = _getChildState2.allWithoutDisable;
	
	      if (!this.isLeaf && !all && allWithoutDisable) {
	        this.checked = false;
	        value = false;
	      }
	
	      var handleDescendants = function handleDescendants() {
	        if (deep) {
	          var childNodes = _this3.childNodes;
	          for (var i = 0, j = childNodes.length; i < j; i++) {
	            var child = childNodes[i];
	            passValue = passValue || value !== false;
	            var isCheck = child.disabled ? child.checked : passValue;
	            child.setChecked(isCheck, deep, true, passValue);
	          }
	
	          var _getChildState3 = getChildState(childNodes),
	              half = _getChildState3.half,
	              _all = _getChildState3.all;
	
	          if (!_all) {
	            _this3.checked = _all;
	            _this3.indeterminate = half;
	          }
	        }
	      };
	
	      if (this.shouldLoadData()) {
	        // Only work on lazy load data.
	        this.loadData(function () {
	          handleDescendants();
	          reInitChecked(_this3);
	        }, {
	          checked: value !== false
	        });
	        return;
	      } else {
	        handleDescendants();
	      }
	    }
	
	    var parent = this.parent;
	    if (!parent || parent.level === 0) return;
	
	    if (!recursion) {
	      reInitChecked(parent);
	    }
	  };
	
	  Node.prototype.getChildren = function getChildren() {
	    var forceInit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	    // this is data
	    if (this.level === 0) return this.data;
	    var data = this.data;
	    if (!data) return null;
	
	    var props = this.store.props;
	    var children = 'children';
	    if (props) {
	      children = props.children || 'children';
	    }
	
	    if (data[children] === undefined) {
	      data[children] = null;
	    }
	
	    if (forceInit && !data[children]) {
	      data[children] = [];
	    }
	
	    return data[children];
	  };
	
	  Node.prototype.updateChildren = function updateChildren() {
	    var _this4 = this;
	
	    var newData = this.getChildren() || [];
	    var oldData = this.childNodes.map(function (node) {
	      return node.data;
	    });
	
	    var newDataMap = {};
	    var newNodes = [];
	
	    newData.forEach(function (item, index) {
	      var key = item[NODE_KEY];
	      var isNodeExists = !!key && Object(util_["arrayFindIndex"])(oldData, function (data) {
	        return data[NODE_KEY] === key;
	      }) >= 0;
	      if (isNodeExists) {
	        newDataMap[key] = { index: index, data: item };
	      } else {
	        newNodes.push({ index: index, data: item });
	      }
	    });
	
	    if (!this.store.lazy) {
	      oldData.forEach(function (item) {
	        if (!newDataMap[item[NODE_KEY]]) _this4.removeChildByData(item);
	      });
	    }
	
	    newNodes.forEach(function (_ref) {
	      var index = _ref.index,
	          data = _ref.data;
	
	      _this4.insertChild({ data: data }, index);
	    });
	
	    this.updateLeafState();
	  };
	
	  Node.prototype.loadData = function loadData(callback) {
	    var _this5 = this;
	
	    var defaultProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    if (this.store.lazy === true && this.store.load && !this.loaded && (!this.loading || Object.keys(defaultProps).length)) {
	      this.loading = true;
	
	      var resolve = function resolve(children) {
	        _this5.loaded = true;
	        _this5.loading = false;
	        _this5.childNodes = [];
	
	        _this5.doCreateChildren(children, defaultProps);
	
	        _this5.updateLeafState();
	        if (callback) {
	          callback.call(_this5, children);
	        }
	      };
	
	      this.store.load(this, resolve);
	    } else {
	      if (callback) {
	        callback.call(this);
	      }
	    }
	  };
	
	  _createClass(Node, [{
	    key: 'label',
	    get: function get() {
	      return getPropertyFromData(this, 'label');
	    }
	  }, {
	    key: 'key',
	    get: function get() {
	      var nodeKey = this.store.key;
	      if (this.data) return this.data[nodeKey];
	      return null;
	    }
	  }, {
	    key: 'disabled',
	    get: function get() {
	      return getPropertyFromData(this, 'disabled');
	    }
	  }, {
	    key: 'nextSibling',
	    get: function get() {
	      var parent = this.parent;
	      if (parent) {
	        var index = parent.childNodes.indexOf(this);
	        if (index > -1) {
	          return parent.childNodes[index + 1];
	        }
	      }
	      return null;
	    }
	  }, {
	    key: 'previousSibling',
	    get: function get() {
	      var parent = this.parent;
	      if (parent) {
	        var index = parent.childNodes.indexOf(this);
	        if (index > -1) {
	          return index > 0 ? parent.childNodes[index - 1] : null;
	        }
	      }
	      return null;
	    }
	  }]);
	
	  return Node;
	}();
	
	/* harmony default export */ var model_node = (node_Node);
	// CONCATENATED MODULE: ./packages/tree/src/model/tree-store.js
	var tree_store_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function tree_store_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	
	
	
	var tree_store_TreeStore = function () {
	  function TreeStore(options) {
	    var _this = this;
	
	    tree_store_classCallCheck(this, TreeStore);
	
	    this.currentNode = null;
	    this.currentNodeKey = null;
	
	    for (var option in options) {
	      if (options.hasOwnProperty(option)) {
	        this[option] = options[option];
	      }
	    }
	
	    this.nodesMap = {};
	
	    this.root = new model_node({
	      data: this.data,
	      store: this
	    });
	
	    if (this.lazy && this.load) {
	      var loadFn = this.load;
	      loadFn(this.root, function (data) {
	        _this.root.doCreateChildren(data);
	        _this._initDefaultCheckedNodes();
	      });
	    } else {
	      this._initDefaultCheckedNodes();
	    }
	  }
	
	  TreeStore.prototype.filter = function filter(value) {
	    var filterNodeMethod = this.filterNodeMethod;
	    var lazy = this.lazy;
	    var traverse = function traverse(node) {
	      var childNodes = node.root ? node.root.childNodes : node.childNodes;
	
	      childNodes.forEach(function (child) {
	        child.visible = filterNodeMethod.call(child, value, child.data, child);
	
	        traverse(child);
	      });
	
	      if (!node.visible && childNodes.length) {
	        var allHidden = true;
	        allHidden = !childNodes.some(function (child) {
	          return child.visible;
	        });
	
	        if (node.root) {
	          node.root.visible = allHidden === false;
	        } else {
	          node.visible = allHidden === false;
	        }
	      }
	      if (!value) return;
	
	      if (node.visible && !node.isLeaf && !lazy) node.expand();
	    };
	
	    traverse(this);
	  };
	
	  TreeStore.prototype.setData = function setData(newVal) {
	    var instanceChanged = newVal !== this.root.data;
	    if (instanceChanged) {
	      this.root.setData(newVal);
	      this._initDefaultCheckedNodes();
	    } else {
	      this.root.updateChildren();
	    }
	  };
	
	  TreeStore.prototype.getNode = function getNode(data) {
	    if (data instanceof model_node) return data;
	    var key = (typeof data === 'undefined' ? 'undefined' : tree_store_typeof(data)) !== 'object' ? data : util_getNodeKey(this.key, data);
	    return this.nodesMap[key] || null;
	  };
	
	  TreeStore.prototype.insertBefore = function insertBefore(data, refData) {
	    var refNode = this.getNode(refData);
	    refNode.parent.insertBefore({ data: data }, refNode);
	  };
	
	  TreeStore.prototype.insertAfter = function insertAfter(data, refData) {
	    var refNode = this.getNode(refData);
	    refNode.parent.insertAfter({ data: data }, refNode);
	  };
	
	  TreeStore.prototype.remove = function remove(data) {
	    var node = this.getNode(data);
	
	    if (node && node.parent) {
	      if (node === this.currentNode) {
	        this.currentNode = null;
	      }
	      node.parent.removeChild(node);
	    }
	  };
	
	  TreeStore.prototype.append = function append(data, parentData) {
	    var parentNode = parentData ? this.getNode(parentData) : this.root;
	
	    if (parentNode) {
	      parentNode.insertChild({ data: data });
	    }
	  };
	
	  TreeStore.prototype._initDefaultCheckedNodes = function _initDefaultCheckedNodes() {
	    var _this2 = this;
	
	    var defaultCheckedKeys = this.defaultCheckedKeys || [];
	    var nodesMap = this.nodesMap;
	
	    defaultCheckedKeys.forEach(function (checkedKey) {
	      var node = nodesMap[checkedKey];
	
	      if (node) {
	        node.setChecked(true, !_this2.checkStrictly);
	      }
	    });
	  };
	
	  TreeStore.prototype._initDefaultCheckedNode = function _initDefaultCheckedNode(node) {
	    var defaultCheckedKeys = this.defaultCheckedKeys || [];
	
	    if (defaultCheckedKeys.indexOf(node.key) !== -1) {
	      node.setChecked(true, !this.checkStrictly);
	    }
	  };
	
	  TreeStore.prototype.setDefaultCheckedKey = function setDefaultCheckedKey(newVal) {
	    if (newVal !== this.defaultCheckedKeys) {
	      this.defaultCheckedKeys = newVal;
	      this._initDefaultCheckedNodes();
	    }
	  };
	
	  TreeStore.prototype.registerNode = function registerNode(node) {
	    var key = this.key;
	    if (!key || !node || !node.data) return;
	
	    var nodeKey = node.key;
	    if (nodeKey !== undefined) this.nodesMap[node.key] = node;
	  };
	
	  TreeStore.prototype.deregisterNode = function deregisterNode(node) {
	    var _this3 = this;
	
	    var key = this.key;
	    if (!key || !node || !node.data) return;
	
	    node.childNodes.forEach(function (child) {
	      _this3.deregisterNode(child);
	    });
	
	    delete this.nodesMap[node.key];
	  };
	
	  TreeStore.prototype.getCheckedNodes = function getCheckedNodes() {
	    var leafOnly = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	    var includeHalfChecked = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    var checkedNodes = [];
	    var traverse = function traverse(node) {
	      var childNodes = node.root ? node.root.childNodes : node.childNodes;
	
	      childNodes.forEach(function (child) {
	        if ((child.checked || includeHalfChecked && child.indeterminate) && (!leafOnly || leafOnly && child.isLeaf)) {
	          checkedNodes.push(child.data);
	        }
	
	        traverse(child);
	      });
	    };
	
	    traverse(this);
	
	    return checkedNodes;
	  };
	
	  TreeStore.prototype.getCheckedKeys = function getCheckedKeys() {
	    var _this4 = this;
	
	    var leafOnly = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    return this.getCheckedNodes(leafOnly).map(function (data) {
	      return (data || {})[_this4.key];
	    });
	  };
	
	  TreeStore.prototype.getHalfCheckedNodes = function getHalfCheckedNodes() {
	    var nodes = [];
	    var traverse = function traverse(node) {
	      var childNodes = node.root ? node.root.childNodes : node.childNodes;
	
	      childNodes.forEach(function (child) {
	        if (child.indeterminate) {
	          nodes.push(child.data);
	        }
	
	        traverse(child);
	      });
	    };
	
	    traverse(this);
	
	    return nodes;
	  };
	
	  TreeStore.prototype.getHalfCheckedKeys = function getHalfCheckedKeys() {
	    var _this5 = this;
	
	    return this.getHalfCheckedNodes().map(function (data) {
	      return (data || {})[_this5.key];
	    });
	  };
	
	  TreeStore.prototype._getAllNodes = function _getAllNodes() {
	    var allNodes = [];
	    var nodesMap = this.nodesMap;
	    for (var nodeKey in nodesMap) {
	      if (nodesMap.hasOwnProperty(nodeKey)) {
	        allNodes.push(nodesMap[nodeKey]);
	      }
	    }
	
	    return allNodes;
	  };
	
	  TreeStore.prototype.updateChildren = function updateChildren(key, data) {
	    var node = this.nodesMap[key];
	    if (!node) return;
	    var childNodes = node.childNodes;
	    for (var i = childNodes.length - 1; i >= 0; i--) {
	      var child = childNodes[i];
	      this.remove(child.data);
	    }
	    for (var _i = 0, j = data.length; _i < j; _i++) {
	      var _child = data[_i];
	      this.append(_child, node.data);
	    }
	  };
	
	  TreeStore.prototype._setCheckedKeys = function _setCheckedKeys(key) {
	    var leafOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	    var checkedKeys = arguments[2];
	
	    var allNodes = this._getAllNodes().sort(function (a, b) {
	      return b.level - a.level;
	    });
	    var cache = Object.create(null);
	    var keys = Object.keys(checkedKeys);
	    allNodes.forEach(function (node) {
	      return node.setChecked(false, false);
	    });
	    for (var i = 0, j = allNodes.length; i < j; i++) {
	      var node = allNodes[i];
	      var nodeKey = node.data[key].toString();
	      var checked = keys.indexOf(nodeKey) > -1;
	      if (!checked) {
	        if (node.checked && !cache[nodeKey]) {
	          node.setChecked(false, false);
	        }
	        continue;
	      }
	
	      var parent = node.parent;
	      while (parent && parent.level > 0) {
	        cache[parent.data[key]] = true;
	        parent = parent.parent;
	      }
	
	      if (node.isLeaf || this.checkStrictly) {
	        node.setChecked(true, false);
	        continue;
	      }
	      node.setChecked(true, true);
	
	      if (leafOnly) {
	        (function () {
	          node.setChecked(false, false);
	          var traverse = function traverse(node) {
	            var childNodes = node.childNodes;
	            childNodes.forEach(function (child) {
	              if (!child.isLeaf) {
	                child.setChecked(false, false);
	              }
	              traverse(child);
	            });
	          };
	          traverse(node);
	        })();
	      }
	    }
	  };
	
	  TreeStore.prototype.setCheckedNodes = function setCheckedNodes(array) {
	    var leafOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    var key = this.key;
	    var checkedKeys = {};
	    array.forEach(function (item) {
	      checkedKeys[(item || {})[key]] = true;
	    });
	
	    this._setCheckedKeys(key, leafOnly, checkedKeys);
	  };
	
	  TreeStore.prototype.setCheckedKeys = function setCheckedKeys(keys) {
	    var leafOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    this.defaultCheckedKeys = keys;
	    var key = this.key;
	    var checkedKeys = {};
	    keys.forEach(function (key) {
	      checkedKeys[key] = true;
	    });
	
	    this._setCheckedKeys(key, leafOnly, checkedKeys);
	  };
	
	  TreeStore.prototype.setDefaultExpandedKeys = function setDefaultExpandedKeys(keys) {
	    var _this6 = this;
	
	    keys = keys || [];
	    this.defaultExpandedKeys = keys;
	
	    keys.forEach(function (key) {
	      var node = _this6.getNode(key);
	      if (node) node.expand(null, _this6.autoExpandParent);
	    });
	  };
	
	  TreeStore.prototype.setChecked = function setChecked(data, checked, deep) {
	    var node = this.getNode(data);
	
	    if (node) {
	      node.setChecked(!!checked, deep);
	    }
	  };
	
	  TreeStore.prototype.getCurrentNode = function getCurrentNode() {
	    return this.currentNode;
	  };
	
	  TreeStore.prototype.setCurrentNode = function setCurrentNode(currentNode) {
	    var prevCurrentNode = this.currentNode;
	    if (prevCurrentNode) {
	      prevCurrentNode.isCurrent = false;
	    }
	    this.currentNode = currentNode;
	    this.currentNode.isCurrent = true;
	  };
	
	  TreeStore.prototype.setUserCurrentNode = function setUserCurrentNode(node) {
	    var key = node[this.key];
	    var currNode = this.nodesMap[key];
	    this.setCurrentNode(currNode);
	  };
	
	  TreeStore.prototype.setCurrentNodeKey = function setCurrentNodeKey(key) {
	    if (key === null || key === undefined) {
	      this.currentNode && (this.currentNode.isCurrent = false);
	      this.currentNode = null;
	      return;
	    }
	    var node = this.getNode(key);
	    if (node) {
	      this.setCurrentNode(node);
	    }
	  };
	
	  return TreeStore;
	}();
	
	/* harmony default export */ var tree_store = (tree_store_TreeStore);
	;
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/tree/src/tree-node.vue?vue&type=template&id=3ba3ef0e&
	var tree_nodevue_type_template_id_3ba3ef0e_render = function() {
	  var this$1 = this
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      directives: [
	        {
	          name: "show",
	          rawName: "v-show",
	          value: _vm.node.visible,
	          expression: "node.visible"
	        }
	      ],
	      ref: "node",
	      staticClass: "el-tree-node",
	      class: {
	        "is-expanded": _vm.expanded,
	        "is-current": _vm.node.isCurrent,
	        "is-hidden": !_vm.node.visible,
	        "is-focusable": !_vm.node.disabled,
	        "is-checked": !_vm.node.disabled && _vm.node.checked
	      },
	      attrs: {
	        role: "treeitem",
	        tabindex: "-1",
	        "aria-expanded": _vm.expanded,
	        "aria-disabled": _vm.node.disabled,
	        "aria-checked": _vm.node.checked,
	        draggable: _vm.tree.draggable
	      },
	      on: {
	        click: function($event) {
	          $event.stopPropagation()
	          return _vm.handleClick($event)
	        },
	        contextmenu: function($event) {
	          return this$1.handleContextMenu($event)
	        },
	        dragstart: function($event) {
	          $event.stopPropagation()
	          return _vm.handleDragStart($event)
	        },
	        dragover: function($event) {
	          $event.stopPropagation()
	          return _vm.handleDragOver($event)
	        },
	        dragend: function($event) {
	          $event.stopPropagation()
	          return _vm.handleDragEnd($event)
	        },
	        drop: function($event) {
	          $event.stopPropagation()
	          return _vm.handleDrop($event)
	        }
	      }
	    },
	    [
	      _c(
	        "div",
	        {
	          staticClass: "el-tree-node__content",
	          style: {
	            "padding-left": (_vm.node.level - 1) * _vm.tree.indent + "px"
	          }
	        },
	        [
	          _c("span", {
	            class: [
	              {
	                "is-leaf": _vm.node.isLeaf,
	                expanded: !_vm.node.isLeaf && _vm.expanded
	              },
	              "el-tree-node__expand-icon",
	              _vm.tree.iconClass ? _vm.tree.iconClass : "el-icon-caret-right"
	            ],
	            on: {
	              click: function($event) {
	                $event.stopPropagation()
	                return _vm.handleExpandIconClick($event)
	              }
	            }
	          }),
	          _vm.showCheckbox
	            ? _c("el-checkbox", {
	                attrs: {
	                  indeterminate: _vm.node.indeterminate,
	                  disabled: !!_vm.node.disabled
	                },
	                on: { change: _vm.handleCheckChange },
	                nativeOn: {
	                  click: function($event) {
	                    $event.stopPropagation()
	                  }
	                },
	                model: {
	                  value: _vm.node.checked,
	                  callback: function($$v) {
	                    _vm.$set(_vm.node, "checked", $$v)
	                  },
	                  expression: "node.checked"
	                }
	              })
	            : _vm._e(),
	          _vm.node.loading
	            ? _c("span", {
	                staticClass: "el-tree-node__loading-icon el-icon-loading"
	              })
	            : _vm._e(),
	          _c("node-content", { attrs: { node: _vm.node } })
	        ],
	        1
	      ),
	      _c("el-collapse-transition", [
	        !_vm.renderAfterExpand || _vm.childNodeRendered
	          ? _c(
	              "div",
	              {
	                directives: [
	                  {
	                    name: "show",
	                    rawName: "v-show",
	                    value: _vm.expanded,
	                    expression: "expanded"
	                  }
	                ],
	                staticClass: "el-tree-node__children",
	                attrs: { role: "group", "aria-expanded": _vm.expanded }
	              },
	              _vm._l(_vm.node.childNodes, function(child) {
	                return _c("el-tree-node", {
	                  key: _vm.getNodeKey(child),
	                  attrs: {
	                    "render-content": _vm.renderContent,
	                    "render-after-expand": _vm.renderAfterExpand,
	                    "show-checkbox": _vm.showCheckbox,
	                    node: child
	                  },
	                  on: { "node-expand": _vm.handleChildNodeExpand }
	                })
	              }),
	              1
	            )
	          : _vm._e()
	      ])
	    ],
	    1
	  )
	}
	var tree_nodevue_type_template_id_3ba3ef0e_staticRenderFns = []
	tree_nodevue_type_template_id_3ba3ef0e_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/tree/src/tree-node.vue?vue&type=template&id=3ba3ef0e&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/tree/src/tree-node.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	/* harmony default export */ var tree_nodevue_type_script_lang_js_ = ({
	  name: 'ElTreeNode',
	
	  componentName: 'ElTreeNode',
	
	  mixins: [emitter_default.a],
	
	  props: {
	    node: {
	      default: function _default() {
	        return {};
	      }
	    },
	    props: {},
	    renderContent: Function,
	    renderAfterExpand: {
	      type: Boolean,
	      default: true
	    },
	    showCheckbox: {
	      type: Boolean,
	      default: false
	    }
	  },
	
	  components: {
	    ElCollapseTransition: collapse_transition_default.a,
	    ElCheckbox: checkbox_default.a,
	    NodeContent: {
	      props: {
	        node: {
	          required: true
	        }
	      },
	      render: function render(h) {
	        var parent = this.$parent;
	        var tree = parent.tree;
	        var node = this.node;
	        var data = node.data,
	            store = node.store;
	
	        return parent.renderContent ? parent.renderContent.call(parent._renderProxy, h, { _self: tree.$vnode.context, node: node, data: data, store: store }) : tree.$scopedSlots.default ? tree.$scopedSlots.default({ node: node, data: data }) : h(
	          'span',
	          { 'class': 'el-tree-node__label' },
	          [node.label]
	        );
	      }
	    }
	  },
	
	  data: function data() {
	    return {
	      tree: null,
	      expanded: false,
	      childNodeRendered: false,
	      oldChecked: null,
	      oldIndeterminate: null
	    };
	  },
	
	
	  watch: {
	    'node.indeterminate': function nodeIndeterminate(val) {
	      this.handleSelectChange(this.node.checked, val);
	    },
	    'node.checked': function nodeChecked(val) {
	      this.handleSelectChange(val, this.node.indeterminate);
	    },
	    'node.expanded': function nodeExpanded(val) {
	      var _this = this;
	
	      this.$nextTick(function () {
	        return _this.expanded = val;
	      });
	      if (val) {
	        this.childNodeRendered = true;
	      }
	    }
	  },
	
	  methods: {
	    getNodeKey: function getNodeKey(node) {
	      return util_getNodeKey(this.tree.nodeKey, node.data);
	    },
	    handleSelectChange: function handleSelectChange(checked, indeterminate) {
	      if (this.oldChecked !== checked && this.oldIndeterminate !== indeterminate) {
	        this.tree.$emit('check-change', this.node.data, checked, indeterminate);
	      }
	      this.oldChecked = checked;
	      this.indeterminate = indeterminate;
	    },
	    handleClick: function handleClick() {
	      var store = this.tree.store;
	      store.setCurrentNode(this.node);
	      this.tree.$emit('current-change', store.currentNode ? store.currentNode.data : null, store.currentNode);
	      this.tree.currentNode = this;
	      if (this.tree.expandOnClickNode) {
	        this.handleExpandIconClick();
	      }
	      if (this.tree.checkOnClickNode && !this.node.disabled) {
	        this.handleCheckChange(null, {
	          target: { checked: !this.node.checked }
	        });
	      }
	      this.tree.$emit('node-click', this.node.data, this.node, this);
	    },
	    handleContextMenu: function handleContextMenu(event) {
	      if (this.tree._events['node-contextmenu'] && this.tree._events['node-contextmenu'].length > 0) {
	        event.stopPropagation();
	        event.preventDefault();
	      }
	      this.tree.$emit('node-contextmenu', event, this.node.data, this.node, this);
	    },
	    handleExpandIconClick: function handleExpandIconClick() {
	      if (this.node.isLeaf) return;
	      if (this.expanded) {
	        this.tree.$emit('node-collapse', this.node.data, this.node, this);
	        this.node.collapse();
	      } else {
	        this.node.expand();
	        this.$emit('node-expand', this.node.data, this.node, this);
	      }
	    },
	    handleCheckChange: function handleCheckChange(value, ev) {
	      var _this2 = this;
	
	      this.node.setChecked(ev.target.checked, !this.tree.checkStrictly);
	      this.$nextTick(function () {
	        var store = _this2.tree.store;
	        _this2.tree.$emit('check', _this2.node.data, {
	          checkedNodes: store.getCheckedNodes(),
	          checkedKeys: store.getCheckedKeys(),
	          halfCheckedNodes: store.getHalfCheckedNodes(),
	          halfCheckedKeys: store.getHalfCheckedKeys()
	        });
	      });
	    },
	    handleChildNodeExpand: function handleChildNodeExpand(nodeData, node, instance) {
	      this.broadcast('ElTreeNode', 'tree-node-expand', node);
	      this.tree.$emit('node-expand', nodeData, node, instance);
	    },
	    handleDragStart: function handleDragStart(event) {
	      if (!this.tree.draggable) return;
	      this.tree.$emit('tree-node-drag-start', event, this);
	    },
	    handleDragOver: function handleDragOver(event) {
	      if (!this.tree.draggable) return;
	      this.tree.$emit('tree-node-drag-over', event, this);
	      event.preventDefault();
	    },
	    handleDrop: function handleDrop(event) {
	      event.preventDefault();
	    },
	    handleDragEnd: function handleDragEnd(event) {
	      if (!this.tree.draggable) return;
	      this.tree.$emit('tree-node-drag-end', event, this);
	    }
	  },
	
	  created: function created() {
	    var _this3 = this;
	
	    var parent = this.$parent;
	
	    if (parent.isTree) {
	      this.tree = parent;
	    } else {
	      this.tree = parent.tree;
	    }
	
	    var tree = this.tree;
	    if (!tree) {
	      console.warn('Can not find node\'s tree.');
	    }
	
	    var props = tree.props || {};
	    var childrenKey = props['children'] || 'children';
	
	    this.$watch('node.data.' + childrenKey, function () {
	      _this3.node.updateChildren();
	    });
	
	    if (this.node.expanded) {
	      this.expanded = true;
	      this.childNodeRendered = true;
	    }
	
	    if (this.tree.accordion) {
	      this.$on('tree-node-expand', function (node) {
	        if (_this3.node !== node) {
	          _this3.node.collapse();
	        }
	      });
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/tree/src/tree-node.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_tree_nodevue_type_script_lang_js_ = (tree_nodevue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/tree/src/tree-node.vue
	
	
	
	
	
	/* normalize component */
	
	var tree_node_component = normalizeComponent(
	  src_tree_nodevue_type_script_lang_js_,
	  tree_nodevue_type_template_id_3ba3ef0e_render,
	  tree_nodevue_type_template_id_3ba3ef0e_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var tree_node_api; }
	tree_node_component.options.__file = "packages/tree/src/tree-node.vue"
	/* harmony default export */ var tree_node = (tree_node_component.exports);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/tree/src/tree.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	
	/* harmony default export */ var treevue_type_script_lang_js_ = ({
	  name: 'ElTree',
	
	  mixins: [emitter_default.a],
	
	  components: {
	    ElTreeNode: tree_node
	  },
	
	  data: function data() {
	    return {
	      store: null,
	      root: null,
	      currentNode: null,
	      treeItems: null,
	      checkboxItems: [],
	      dragState: {
	        showDropIndicator: false,
	        draggingNode: null,
	        dropNode: null,
	        allowDrop: true
	      }
	    };
	  },
	
	
	  props: {
	    data: {
	      type: Array
	    },
	    emptyText: {
	      type: String,
	      default: function _default() {
	        return Object(lib_locale_["t"])('el.tree.emptyText');
	      }
	    },
	    renderAfterExpand: {
	      type: Boolean,
	      default: true
	    },
	    nodeKey: String,
	    checkStrictly: Boolean,
	    defaultExpandAll: Boolean,
	    expandOnClickNode: {
	      type: Boolean,
	      default: true
	    },
	    checkOnClickNode: Boolean,
	    checkDescendants: {
	      type: Boolean,
	      default: false
	    },
	    autoExpandParent: {
	      type: Boolean,
	      default: true
	    },
	    defaultCheckedKeys: Array,
	    defaultExpandedKeys: Array,
	    currentNodeKey: [String, Number],
	    renderContent: Function,
	    showCheckbox: {
	      type: Boolean,
	      default: false
	    },
	    draggable: {
	      type: Boolean,
	      default: false
	    },
	    allowDrag: Function,
	    allowDrop: Function,
	    props: {
	      default: function _default() {
	        return {
	          children: 'children',
	          label: 'label',
	          disabled: 'disabled'
	        };
	      }
	    },
	    lazy: {
	      type: Boolean,
	      default: false
	    },
	    highlightCurrent: Boolean,
	    load: Function,
	    filterNodeMethod: Function,
	    accordion: Boolean,
	    indent: {
	      type: Number,
	      default: 18
	    },
	    iconClass: String
	  },
	
	  computed: {
	    children: {
	      set: function set(value) {
	        this.data = value;
	      },
	      get: function get() {
	        return this.data;
	      }
	    },
	
	    treeItemArray: function treeItemArray() {
	      return Array.prototype.slice.call(this.treeItems);
	    },
	    isEmpty: function isEmpty() {
	      var childNodes = this.root.childNodes;
	
	      return !childNodes || childNodes.length === 0 || childNodes.every(function (_ref) {
	        var visible = _ref.visible;
	        return !visible;
	      });
	    }
	  },
	
	  watch: {
	    defaultCheckedKeys: function defaultCheckedKeys(newVal) {
	      this.store.setDefaultCheckedKey(newVal);
	    },
	    defaultExpandedKeys: function defaultExpandedKeys(newVal) {
	      this.store.defaultExpandedKeys = newVal;
	      this.store.setDefaultExpandedKeys(newVal);
	    },
	    data: function data(newVal) {
	      this.store.setData(newVal);
	    },
	    checkboxItems: function checkboxItems(val) {
	      Array.prototype.forEach.call(val, function (checkbox) {
	        checkbox.setAttribute('tabindex', -1);
	      });
	    },
	    checkStrictly: function checkStrictly(newVal) {
	      this.store.checkStrictly = newVal;
	    }
	  },
	
	  methods: {
	    filter: function filter(value) {
	      if (!this.filterNodeMethod) throw new Error('[Tree] filterNodeMethod is required when filter');
	      this.store.filter(value);
	    },
	    getNodeKey: function getNodeKey(node) {
	      return util_getNodeKey(this.nodeKey, node.data);
	    },
	    getNodePath: function getNodePath(data) {
	      if (!this.nodeKey) throw new Error('[Tree] nodeKey is required in getNodePath');
	      var node = this.store.getNode(data);
	      if (!node) return [];
	      var path = [node.data];
	      var parent = node.parent;
	      while (parent && parent !== this.root) {
	        path.push(parent.data);
	        parent = parent.parent;
	      }
	      return path.reverse();
	    },
	    getCheckedNodes: function getCheckedNodes(leafOnly, includeHalfChecked) {
	      return this.store.getCheckedNodes(leafOnly, includeHalfChecked);
	    },
	    getCheckedKeys: function getCheckedKeys(leafOnly) {
	      return this.store.getCheckedKeys(leafOnly);
	    },
	    getCurrentNode: function getCurrentNode() {
	      var currentNode = this.store.getCurrentNode();
	      return currentNode ? currentNode.data : null;
	    },
	    getCurrentKey: function getCurrentKey() {
	      if (!this.nodeKey) throw new Error('[Tree] nodeKey is required in getCurrentKey');
	      var currentNode = this.getCurrentNode();
	      return currentNode ? currentNode[this.nodeKey] : null;
	    },
	    setCheckedNodes: function setCheckedNodes(nodes, leafOnly) {
	      if (!this.nodeKey) throw new Error('[Tree] nodeKey is required in setCheckedNodes');
	      this.store.setCheckedNodes(nodes, leafOnly);
	    },
	    setCheckedKeys: function setCheckedKeys(keys, leafOnly) {
	      if (!this.nodeKey) throw new Error('[Tree] nodeKey is required in setCheckedKeys');
	      this.store.setCheckedKeys(keys, leafOnly);
	    },
	    setChecked: function setChecked(data, checked, deep) {
	      this.store.setChecked(data, checked, deep);
	    },
	    getHalfCheckedNodes: function getHalfCheckedNodes() {
	      return this.store.getHalfCheckedNodes();
	    },
	    getHalfCheckedKeys: function getHalfCheckedKeys() {
	      return this.store.getHalfCheckedKeys();
	    },
	    setCurrentNode: function setCurrentNode(node) {
	      if (!this.nodeKey) throw new Error('[Tree] nodeKey is required in setCurrentNode');
	      this.store.setUserCurrentNode(node);
	    },
	    setCurrentKey: function setCurrentKey(key) {
	      if (!this.nodeKey) throw new Error('[Tree] nodeKey is required in setCurrentKey');
	      this.store.setCurrentNodeKey(key);
	    },
	    getNode: function getNode(data) {
	      return this.store.getNode(data);
	    },
	    remove: function remove(data) {
	      this.store.remove(data);
	    },
	    append: function append(data, parentNode) {
	      this.store.append(data, parentNode);
	    },
	    insertBefore: function insertBefore(data, refNode) {
	      this.store.insertBefore(data, refNode);
	    },
	    insertAfter: function insertAfter(data, refNode) {
	      this.store.insertAfter(data, refNode);
	    },
	    handleNodeExpand: function handleNodeExpand(nodeData, node, instance) {
	      this.broadcast('ElTreeNode', 'tree-node-expand', node);
	      this.$emit('node-expand', nodeData, node, instance);
	    },
	    updateKeyChildren: function updateKeyChildren(key, data) {
	      if (!this.nodeKey) throw new Error('[Tree] nodeKey is required in updateKeyChild');
	      this.store.updateChildren(key, data);
	    },
	    initTabIndex: function initTabIndex() {
	      this.treeItems = this.$el.querySelectorAll('.is-focusable[role=treeitem]');
	      this.checkboxItems = this.$el.querySelectorAll('input[type=checkbox]');
	      var checkedItem = this.$el.querySelectorAll('.is-checked[role=treeitem]');
	      if (checkedItem.length) {
	        checkedItem[0].setAttribute('tabindex', 0);
	        return;
	      }
	      this.treeItems[0] && this.treeItems[0].setAttribute('tabindex', 0);
	    },
	    handleKeydown: function handleKeydown(ev) {
	      var currentItem = ev.target;
	      if (currentItem.className.indexOf('el-tree-node') === -1) return;
	      var keyCode = ev.keyCode;
	      this.treeItems = this.$el.querySelectorAll('.is-focusable[role=treeitem]');
	      var currentIndex = this.treeItemArray.indexOf(currentItem);
	      var nextIndex = void 0;
	      if ([38, 40].indexOf(keyCode) > -1) {
	        // up、down
	        ev.preventDefault();
	        if (keyCode === 38) {
	          // up
	          nextIndex = currentIndex !== 0 ? currentIndex - 1 : 0;
	        } else {
	          nextIndex = currentIndex < this.treeItemArray.length - 1 ? currentIndex + 1 : 0;
	        }
	        this.treeItemArray[nextIndex].focus(); // 选中
	      }
	      if ([37, 39].indexOf(keyCode) > -1) {
	        // left、right 展开
	        ev.preventDefault();
	        currentItem.click(); // 选中
	      }
	      var hasInput = currentItem.querySelector('[type="checkbox"]');
	      if ([13, 32].indexOf(keyCode) > -1 && hasInput) {
	        // space enter选中checkbox
	        ev.preventDefault();
	        hasInput.click();
	      }
	    }
	  },
	
	  created: function created() {
	    var _this = this;
	
	    this.isTree = true;
	
	    this.store = new tree_store({
	      key: this.nodeKey,
	      data: this.data,
	      lazy: this.lazy,
	      props: this.props,
	      load: this.load,
	      currentNodeKey: this.currentNodeKey,
	      checkStrictly: this.checkStrictly,
	      checkDescendants: this.checkDescendants,
	      defaultCheckedKeys: this.defaultCheckedKeys,
	      defaultExpandedKeys: this.defaultExpandedKeys,
	      autoExpandParent: this.autoExpandParent,
	      defaultExpandAll: this.defaultExpandAll,
	      filterNodeMethod: this.filterNodeMethod
	    });
	
	    this.root = this.store.root;
	
	    var dragState = this.dragState;
	    this.$on('tree-node-drag-start', function (event, treeNode) {
	      if (typeof _this.allowDrag === 'function' && !_this.allowDrag(treeNode.node)) {
	        event.preventDefault();
	        return false;
	      }
	      event.dataTransfer.effectAllowed = 'move';
	
	      // wrap in try catch to address IE's error when first param is 'text/plain'
	      try {
	        // setData is required for draggable to work in FireFox
	        // the content has to be '' so dragging a node out of the tree won't open a new tab in FireFox
	        event.dataTransfer.setData('text/plain', '');
	      } catch (e) {}
	      dragState.draggingNode = treeNode;
	      _this.$emit('node-drag-start', treeNode.node, event);
	    });
	
	    this.$on('tree-node-drag-over', function (event, treeNode) {
	      var dropNode = findNearestComponent(event.target, 'ElTreeNode');
	      var oldDropNode = dragState.dropNode;
	      if (oldDropNode && oldDropNode !== dropNode) {
	        Object(dom_["removeClass"])(oldDropNode.$el, 'is-drop-inner');
	      }
	      var draggingNode = dragState.draggingNode;
	      if (!draggingNode || !dropNode) return;
	
	      var dropPrev = true;
	      var dropInner = true;
	      var dropNext = true;
	      var userAllowDropInner = true;
	      if (typeof _this.allowDrop === 'function') {
	        dropPrev = _this.allowDrop(draggingNode.node, dropNode.node, 'prev');
	        userAllowDropInner = dropInner = _this.allowDrop(draggingNode.node, dropNode.node, 'inner');
	        dropNext = _this.allowDrop(draggingNode.node, dropNode.node, 'next');
	      }
	      event.dataTransfer.dropEffect = dropInner ? 'move' : 'none';
	      if ((dropPrev || dropInner || dropNext) && oldDropNode !== dropNode) {
	        if (oldDropNode) {
	          _this.$emit('node-drag-leave', draggingNode.node, oldDropNode.node, event);
	        }
	        _this.$emit('node-drag-enter', draggingNode.node, dropNode.node, event);
	      }
	
	      if (dropPrev || dropInner || dropNext) {
	        dragState.dropNode = dropNode;
	      }
	
	      if (dropNode.node.nextSibling === draggingNode.node) {
	        dropNext = false;
	      }
	      if (dropNode.node.previousSibling === draggingNode.node) {
	        dropPrev = false;
	      }
	      if (dropNode.node.contains(draggingNode.node, false)) {
	        dropInner = false;
	      }
	      if (draggingNode.node === dropNode.node || draggingNode.node.contains(dropNode.node)) {
	        dropPrev = false;
	        dropInner = false;
	        dropNext = false;
	      }
	
	      var targetPosition = dropNode.$el.getBoundingClientRect();
	      var treePosition = _this.$el.getBoundingClientRect();
	
	      var dropType = void 0;
	      var prevPercent = dropPrev ? dropInner ? 0.25 : dropNext ? 0.45 : 1 : -1;
	      var nextPercent = dropNext ? dropInner ? 0.75 : dropPrev ? 0.55 : 0 : 1;
	
	      var indicatorTop = -9999;
	      var distance = event.clientY - targetPosition.top;
	      if (distance < targetPosition.height * prevPercent) {
	        dropType = 'before';
	      } else if (distance > targetPosition.height * nextPercent) {
	        dropType = 'after';
	      } else if (dropInner) {
	        dropType = 'inner';
	      } else {
	        dropType = 'none';
	      }
	
	      var iconPosition = dropNode.$el.querySelector('.el-tree-node__expand-icon').getBoundingClientRect();
	      var dropIndicator = _this.$refs.dropIndicator;
	      if (dropType === 'before') {
	        indicatorTop = iconPosition.top - treePosition.top;
	      } else if (dropType === 'after') {
	        indicatorTop = iconPosition.bottom - treePosition.top;
	      }
	      dropIndicator.style.top = indicatorTop + 'px';
	      dropIndicator.style.left = iconPosition.right - treePosition.left + 'px';
	
	      if (dropType === 'inner') {
	        Object(dom_["addClass"])(dropNode.$el, 'is-drop-inner');
	      } else {
	        Object(dom_["removeClass"])(dropNode.$el, 'is-drop-inner');
	      }
	
	      dragState.showDropIndicator = dropType === 'before' || dropType === 'after';
	      dragState.allowDrop = dragState.showDropIndicator || userAllowDropInner;
	      dragState.dropType = dropType;
	      _this.$emit('node-drag-over', draggingNode.node, dropNode.node, event);
	    });
	
	    this.$on('tree-node-drag-end', function (event) {
	      var draggingNode = dragState.draggingNode,
	          dropType = dragState.dropType,
	          dropNode = dragState.dropNode;
	
	      event.preventDefault();
	      event.dataTransfer.dropEffect = 'move';
	
	      if (draggingNode && dropNode) {
	        var draggingNodeCopy = { data: draggingNode.node.data };
	        if (dropType !== 'none') {
	          draggingNode.node.remove();
	        }
	        if (dropType === 'before') {
	          dropNode.node.parent.insertBefore(draggingNodeCopy, dropNode.node);
	        } else if (dropType === 'after') {
	          dropNode.node.parent.insertAfter(draggingNodeCopy, dropNode.node);
	        } else if (dropType === 'inner') {
	          dropNode.node.insertChild(draggingNodeCopy);
	        }
	        if (dropType !== 'none') {
	          _this.store.registerNode(draggingNodeCopy);
	        }
	
	        Object(dom_["removeClass"])(dropNode.$el, 'is-drop-inner');
	
	        _this.$emit('node-drag-end', draggingNode.node, dropNode.node, dropType, event);
	        if (dropType !== 'none') {
	          _this.$emit('node-drop', draggingNode.node, dropNode.node, dropType, event);
	        }
	      }
	      if (draggingNode && !dropNode) {
	        _this.$emit('node-drag-end', draggingNode.node, null, dropType, event);
	      }
	
	      dragState.showDropIndicator = false;
	      dragState.draggingNode = null;
	      dragState.dropNode = null;
	      dragState.allowDrop = true;
	    });
	  },
	  mounted: function mounted() {
	    this.initTabIndex();
	    this.$el.addEventListener('keydown', this.handleKeydown);
	  },
	  updated: function updated() {
	    this.treeItems = this.$el.querySelectorAll('[role=treeitem]');
	    this.checkboxItems = this.$el.querySelectorAll('input[type=checkbox]');
	  }
	});
	// CONCATENATED MODULE: ./packages/tree/src/tree.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_treevue_type_script_lang_js_ = (treevue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/tree/src/tree.vue
	
	
	
	
	
	/* normalize component */
	
	var tree_component = normalizeComponent(
	  src_treevue_type_script_lang_js_,
	  treevue_type_template_id_547575a6_render,
	  treevue_type_template_id_547575a6_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var tree_api; }
	tree_component.options.__file = "packages/tree/src/tree.vue"
	/* harmony default export */ var src_tree = (tree_component.exports);
	// CONCATENATED MODULE: ./packages/tree/index.js
	
	
	/* istanbul ignore next */
	src_tree.install = function (Vue) {
	  Vue.component(src_tree.name, src_tree);
	};
	
	/* harmony default export */ var packages_tree = (src_tree);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/alert/src/main.vue?vue&type=template&id=6e53341b&
	var mainvue_type_template_id_6e53341b_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("transition", { attrs: { name: "el-alert-fade" } }, [
	    _c(
	      "div",
	      {
	        directives: [
	          {
	            name: "show",
	            rawName: "v-show",
	            value: _vm.visible,
	            expression: "visible"
	          }
	        ],
	        staticClass: "el-alert",
	        class: [
	          _vm.typeClass,
	          _vm.center ? "is-center" : "",
	          "is-" + _vm.effect
	        ],
	        attrs: { role: "alert" }
	      },
	      [
	        _vm.showIcon
	          ? _c("i", {
	              staticClass: "el-alert__icon",
	              class: [_vm.iconClass, _vm.isBigIcon]
	            })
	          : _vm._e(),
	        _c("div", { staticClass: "el-alert__content" }, [
	          _vm.title || _vm.$slots.title
	            ? _c(
	                "span",
	                { staticClass: "el-alert__title", class: [_vm.isBoldTitle] },
	                [_vm._t("title", [_vm._v(_vm._s(_vm.title))])],
	                2
	              )
	            : _vm._e(),
	          _vm.$slots.default && !_vm.description
	            ? _c(
	                "p",
	                { staticClass: "el-alert__description" },
	                [_vm._t("default")],
	                2
	              )
	            : _vm._e(),
	          _vm.description && !_vm.$slots.default
	            ? _c("p", { staticClass: "el-alert__description" }, [
	                _vm._v(_vm._s(_vm.description))
	              ])
	            : _vm._e(),
	          _c(
	            "i",
	            {
	              directives: [
	                {
	                  name: "show",
	                  rawName: "v-show",
	                  value: _vm.closable,
	                  expression: "closable"
	                }
	              ],
	              staticClass: "el-alert__closebtn",
	              class: {
	                "is-customed": _vm.closeText !== "",
	                "el-icon-close": _vm.closeText === ""
	              },
	              on: {
	                click: function($event) {
	                  _vm.close()
	                }
	              }
	            },
	            [_vm._v(_vm._s(_vm.closeText))]
	          )
	        ])
	      ]
	    )
	  ])
	}
	var mainvue_type_template_id_6e53341b_staticRenderFns = []
	mainvue_type_template_id_6e53341b_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/alert/src/main.vue?vue&type=template&id=6e53341b&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/alert/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	var TYPE_CLASSES_MAP = {
	  'success': 'el-icon-success',
	  'warning': 'el-icon-warning',
	  'error': 'el-icon-error'
	};
	/* harmony default export */ var alert_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElAlert',
	
	  props: {
	    title: {
	      type: String,
	      default: ''
	    },
	    description: {
	      type: String,
	      default: ''
	    },
	    type: {
	      type: String,
	      default: 'info'
	    },
	    closable: {
	      type: Boolean,
	      default: true
	    },
	    closeText: {
	      type: String,
	      default: ''
	    },
	    showIcon: Boolean,
	    center: Boolean,
	    effect: {
	      type: String,
	      default: 'light',
	      validator: function validator(value) {
	        return ['light', 'dark'].indexOf(value) !== -1;
	      }
	    }
	  },
	
	  data: function data() {
	    return {
	      visible: true
	    };
	  },
	
	
	  methods: {
	    close: function close() {
	      this.visible = false;
	      this.$emit('close');
	    }
	  },
	
	  computed: {
	    typeClass: function typeClass() {
	      return 'el-alert--' + this.type;
	    },
	    iconClass: function iconClass() {
	      return TYPE_CLASSES_MAP[this.type] || 'el-icon-info';
	    },
	    isBigIcon: function isBigIcon() {
	      return this.description || this.$slots.default ? 'is-big' : '';
	    },
	    isBoldTitle: function isBoldTitle() {
	      return this.description || this.$slots.default ? 'is-bold' : '';
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/alert/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_alert_src_mainvue_type_script_lang_js_ = (alert_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/alert/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var alert_src_main_component = normalizeComponent(
	  packages_alert_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_6e53341b_render,
	  mainvue_type_template_id_6e53341b_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var alert_src_main_api; }
	alert_src_main_component.options.__file = "packages/alert/src/main.vue"
	/* harmony default export */ var alert_src_main = (alert_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/alert/index.js
	
	
	/* istanbul ignore next */
	alert_src_main.install = function (Vue) {
	  Vue.component(alert_src_main.name, alert_src_main);
	};
	
	/* harmony default export */ var packages_alert = (alert_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/notification/src/main.vue?vue&type=template&id=43dbc3d8&
	var mainvue_type_template_id_43dbc3d8_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("transition", { attrs: { name: "el-notification-fade" } }, [
	    _c(
	      "div",
	      {
	        directives: [
	          {
	            name: "show",
	            rawName: "v-show",
	            value: _vm.visible,
	            expression: "visible"
	          }
	        ],
	        class: ["el-notification", _vm.customClass, _vm.horizontalClass],
	        style: _vm.positionStyle,
	        attrs: { role: "alert" },
	        on: {
	          mouseenter: function($event) {
	            _vm.clearTimer()
	          },
	          mouseleave: function($event) {
	            _vm.startTimer()
	          },
	          click: _vm.click
	        }
	      },
	      [
	        _vm.type || _vm.iconClass
	          ? _c("i", {
	              staticClass: "el-notification__icon",
	              class: [_vm.typeClass, _vm.iconClass]
	            })
	          : _vm._e(),
	        _c(
	          "div",
	          {
	            staticClass: "el-notification__group",
	            class: { "is-with-icon": _vm.typeClass || _vm.iconClass }
	          },
	          [
	            _c("h2", {
	              staticClass: "el-notification__title",
	              domProps: { textContent: _vm._s(_vm.title) }
	            }),
	            _c(
	              "div",
	              {
	                directives: [
	                  {
	                    name: "show",
	                    rawName: "v-show",
	                    value: _vm.message,
	                    expression: "message"
	                  }
	                ],
	                staticClass: "el-notification__content"
	              },
	              [
	                _vm._t("default", [
	                  !_vm.dangerouslyUseHTMLString
	                    ? _c("p", [_vm._v(_vm._s(_vm.message))])
	                    : _c("p", { domProps: { innerHTML: _vm._s(_vm.message) } })
	                ])
	              ],
	              2
	            ),
	            _vm.showClose
	              ? _c("div", {
	                  staticClass: "el-notification__closeBtn el-icon-close",
	                  on: {
	                    click: function($event) {
	                      $event.stopPropagation()
	                      return _vm.close($event)
	                    }
	                  }
	                })
	              : _vm._e()
	          ]
	        )
	      ]
	    )
	  ])
	}
	var mainvue_type_template_id_43dbc3d8_staticRenderFns = []
	mainvue_type_template_id_43dbc3d8_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/notification/src/main.vue?vue&type=template&id=43dbc3d8&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/notification/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	var mainvue_type_script_lang_js_typeMap = {
	  success: 'success',
	  info: 'info',
	  warning: 'warning',
	  error: 'error'
	};
	
	/* harmony default export */ var notification_src_mainvue_type_script_lang_js_ = ({
	  data: function data() {
	    return {
	      visible: false,
	      title: '',
	      message: '',
	      duration: 4500,
	      type: '',
	      showClose: true,
	      customClass: '',
	      iconClass: '',
	      onClose: null,
	      onClick: null,
	      closed: false,
	      verticalOffset: 0,
	      timer: null,
	      dangerouslyUseHTMLString: false,
	      position: 'top-right'
	    };
	  },
	
	
	  computed: {
	    typeClass: function typeClass() {
	      return this.type && mainvue_type_script_lang_js_typeMap[this.type] ? 'el-icon-' + mainvue_type_script_lang_js_typeMap[this.type] : '';
	    },
	    horizontalClass: function horizontalClass() {
	      return this.position.indexOf('right') > -1 ? 'right' : 'left';
	    },
	    verticalProperty: function verticalProperty() {
	      return (/^top-/.test(this.position) ? 'top' : 'bottom'
	      );
	    },
	    positionStyle: function positionStyle() {
	      var _ref;
	
	      return _ref = {}, _ref[this.verticalProperty] = this.verticalOffset + 'px', _ref;
	    }
	  },
	
	  watch: {
	    closed: function closed(newVal) {
	      if (newVal) {
	        this.visible = false;
	        this.$el.addEventListener('transitionend', this.destroyElement);
	      }
	    }
	  },
	
	  methods: {
	    destroyElement: function destroyElement() {
	      this.$el.removeEventListener('transitionend', this.destroyElement);
	      this.$destroy(true);
	      this.$el.parentNode.removeChild(this.$el);
	    },
	    click: function click() {
	      if (typeof this.onClick === 'function') {
	        this.onClick();
	      }
	    },
	    close: function close() {
	      this.closed = true;
	      if (typeof this.onClose === 'function') {
	        this.onClose();
	      }
	    },
	    clearTimer: function clearTimer() {
	      clearTimeout(this.timer);
	    },
	    startTimer: function startTimer() {
	      var _this = this;
	
	      if (this.duration > 0) {
	        this.timer = setTimeout(function () {
	          if (!_this.closed) {
	            _this.close();
	          }
	        }, this.duration);
	      }
	    },
	    keydown: function keydown(e) {
	      if (e.keyCode === 46 || e.keyCode === 8) {
	        this.clearTimer(); // detele 取消倒计时
	      } else if (e.keyCode === 27) {
	        // esc关闭消息
	        if (!this.closed) {
	          this.close();
	        }
	      } else {
	        this.startTimer(); // 恢复倒计时
	      }
	    }
	  },
	  mounted: function mounted() {
	    var _this2 = this;
	
	    if (this.duration > 0) {
	      this.timer = setTimeout(function () {
	        if (!_this2.closed) {
	          _this2.close();
	        }
	      }, this.duration);
	    }
	    document.addEventListener('keydown', this.keydown);
	  },
	  beforeDestroy: function beforeDestroy() {
	    document.removeEventListener('keydown', this.keydown);
	  }
	});
	// CONCATENATED MODULE: ./packages/notification/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_notification_src_mainvue_type_script_lang_js_ = (notification_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/notification/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var notification_src_main_component = normalizeComponent(
	  packages_notification_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_43dbc3d8_render,
	  mainvue_type_template_id_43dbc3d8_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var notification_src_main_api; }
	notification_src_main_component.options.__file = "packages/notification/src/main.vue"
	/* harmony default export */ var notification_src_main = (notification_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/notification/src/main.js
	
	
	
	
	
	var NotificationConstructor = external_vue_default.a.extend(notification_src_main);
	
	var src_main_instance = void 0;
	var instances = [];
	var seed = 1;
	
	var main_Notification = function Notification(options) {
	  if (external_vue_default.a.prototype.$isServer) return;
	  options = merge_default()({}, options);
	  var userOnClose = options.onClose;
	  var id = 'notification_' + seed++;
	  var position = options.position || 'top-right';
	
	  options.onClose = function () {
	    Notification.close(id, userOnClose);
	  };
	
	  src_main_instance = new NotificationConstructor({
	    data: options
	  });
	
	  if (Object(vdom_["isVNode"])(options.message)) {
	    src_main_instance.$slots.default = [options.message];
	    options.message = 'REPLACED_BY_VNODE';
	  }
	  src_main_instance.id = id;
	  src_main_instance.$mount();
	  document.body.appendChild(src_main_instance.$el);
	  src_main_instance.visible = true;
	  src_main_instance.dom = src_main_instance.$el;
	  src_main_instance.dom.style.zIndex = popup_["PopupManager"].nextZIndex();
	
	  var verticalOffset = options.offset || 0;
	  instances.filter(function (item) {
	    return item.position === position;
	  }).forEach(function (item) {
	    verticalOffset += item.$el.offsetHeight + 16;
	  });
	  verticalOffset += 16;
	  src_main_instance.verticalOffset = verticalOffset;
	  instances.push(src_main_instance);
	  return src_main_instance;
	};
	
	['success', 'warning', 'info', 'error'].forEach(function (type) {
	  main_Notification[type] = function (options) {
	    if (typeof options === 'string' || Object(vdom_["isVNode"])(options)) {
	      options = {
	        message: options
	      };
	    }
	    options.type = type;
	    return main_Notification(options);
	  };
	});
	
	main_Notification.close = function (id, userOnClose) {
	  var index = -1;
	  var len = instances.length;
	  var instance = instances.filter(function (instance, i) {
	    if (instance.id === id) {
	      index = i;
	      return true;
	    }
	    return false;
	  })[0];
	  if (!instance) return;
	
	  if (typeof userOnClose === 'function') {
	    userOnClose(instance);
	  }
	  instances.splice(index, 1);
	
	  if (len <= 1) return;
	  var position = instance.position;
	  var removedHeight = instance.dom.offsetHeight;
	  for (var i = index; i < len - 1; i++) {
	    if (instances[i].position === position) {
	      instances[i].dom.style[instance.verticalProperty] = parseInt(instances[i].dom.style[instance.verticalProperty], 10) - removedHeight - 16 + 'px';
	    }
	  }
	};
	
	main_Notification.closeAll = function () {
	  for (var i = instances.length - 1; i >= 0; i--) {
	    instances[i].close();
	  }
	};
	
	/* harmony default export */ var packages_notification_src_main = (main_Notification);
	// CONCATENATED MODULE: ./packages/notification/index.js
	
	/* harmony default export */ var notification = (packages_notification_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/slider/src/main.vue?vue&type=template&id=32708644&
	var mainvue_type_template_id_32708644_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-slider",
	      class: {
	        "is-vertical": _vm.vertical,
	        "el-slider--with-input": _vm.showInput
	      },
	      attrs: {
	        role: "slider",
	        "aria-valuemin": _vm.min,
	        "aria-valuemax": _vm.max,
	        "aria-orientation": _vm.vertical ? "vertical" : "horizontal",
	        "aria-disabled": _vm.sliderDisabled
	      }
	    },
	    [
	      _vm.showInput && !_vm.range
	        ? _c("el-input-number", {
	            ref: "input",
	            staticClass: "el-slider__input",
	            attrs: {
	              step: _vm.step,
	              disabled: _vm.sliderDisabled,
	              controls: _vm.showInputControls,
	              min: _vm.min,
	              max: _vm.max,
	              debounce: _vm.debounce,
	              size: _vm.inputSize
	            },
	            on: { change: _vm.emitChange },
	            model: {
	              value: _vm.firstValue,
	              callback: function($$v) {
	                _vm.firstValue = $$v
	              },
	              expression: "firstValue"
	            }
	          })
	        : _vm._e(),
	      _c(
	        "div",
	        {
	          ref: "slider",
	          staticClass: "el-slider__runway",
	          class: { "show-input": _vm.showInput, disabled: _vm.sliderDisabled },
	          style: _vm.runwayStyle,
	          on: { click: _vm.onSliderClick }
	        },
	        [
	          _c("div", { staticClass: "el-slider__bar", style: _vm.barStyle }),
	          _c("slider-button", {
	            ref: "button1",
	            attrs: {
	              vertical: _vm.vertical,
	              "tooltip-class": _vm.tooltipClass
	            },
	            model: {
	              value: _vm.firstValue,
	              callback: function($$v) {
	                _vm.firstValue = $$v
	              },
	              expression: "firstValue"
	            }
	          }),
	          _vm.range
	            ? _c("slider-button", {
	                ref: "button2",
	                attrs: {
	                  vertical: _vm.vertical,
	                  "tooltip-class": _vm.tooltipClass
	                },
	                model: {
	                  value: _vm.secondValue,
	                  callback: function($$v) {
	                    _vm.secondValue = $$v
	                  },
	                  expression: "secondValue"
	                }
	              })
	            : _vm._e(),
	          _vm._l(_vm.stops, function(item, key) {
	            return _vm.showStops
	              ? _c("div", {
	                  key: key,
	                  staticClass: "el-slider__stop",
	                  style: _vm.getStopStyle(item)
	                })
	              : _vm._e()
	          }),
	          _vm.markList.length > 0
	            ? [
	                _c(
	                  "div",
	                  _vm._l(_vm.markList, function(item, key) {
	                    return _c("div", {
	                      key: key,
	                      staticClass: "el-slider__stop el-slider__marks-stop",
	                      style: _vm.getStopStyle(item.position)
	                    })
	                  }),
	                  0
	                ),
	                _c(
	                  "div",
	                  { staticClass: "el-slider__marks" },
	                  _vm._l(_vm.markList, function(item, key) {
	                    return _c("slider-marker", {
	                      key: key,
	                      style: _vm.getStopStyle(item.position),
	                      attrs: { mark: item.mark }
	                    })
	                  }),
	                  1
	                )
	              ]
	            : _vm._e()
	        ],
	        2
	      )
	    ],
	    1
	  )
	}
	var mainvue_type_template_id_32708644_staticRenderFns = []
	mainvue_type_template_id_32708644_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/slider/src/main.vue?vue&type=template&id=32708644&
	
	// EXTERNAL MODULE: external "element-ui/lib/input-number"
	var input_number_ = __webpack_require__(41);
	var input_number_default = /*#__PURE__*/__webpack_require__.n(input_number_);
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/slider/src/button.vue?vue&type=template&id=e72d2ad2&
	var buttonvue_type_template_id_e72d2ad2_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      ref: "button",
	      staticClass: "el-slider__button-wrapper",
	      class: { hover: _vm.hovering, dragging: _vm.dragging },
	      style: _vm.wrapperStyle,
	      attrs: { tabindex: "0" },
	      on: {
	        mouseenter: _vm.handleMouseEnter,
	        mouseleave: _vm.handleMouseLeave,
	        mousedown: _vm.onButtonDown,
	        touchstart: _vm.onButtonDown,
	        focus: _vm.handleMouseEnter,
	        blur: _vm.handleMouseLeave,
	        keydown: [
	          function($event) {
	            if (
	              !("button" in $event) &&
	              _vm._k($event.keyCode, "left", 37, $event.key, [
	                "Left",
	                "ArrowLeft"
	              ])
	            ) {
	              return null
	            }
	            if ("button" in $event && $event.button !== 0) {
	              return null
	            }
	            return _vm.onLeftKeyDown($event)
	          },
	          function($event) {
	            if (
	              !("button" in $event) &&
	              _vm._k($event.keyCode, "right", 39, $event.key, [
	                "Right",
	                "ArrowRight"
	              ])
	            ) {
	              return null
	            }
	            if ("button" in $event && $event.button !== 2) {
	              return null
	            }
	            return _vm.onRightKeyDown($event)
	          },
	          function($event) {
	            if (
	              !("button" in $event) &&
	              _vm._k($event.keyCode, "down", 40, $event.key, [
	                "Down",
	                "ArrowDown"
	              ])
	            ) {
	              return null
	            }
	            $event.preventDefault()
	            return _vm.onLeftKeyDown($event)
	          },
	          function($event) {
	            if (
	              !("button" in $event) &&
	              _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])
	            ) {
	              return null
	            }
	            $event.preventDefault()
	            return _vm.onRightKeyDown($event)
	          }
	        ]
	      }
	    },
	    [
	      _c(
	        "el-tooltip",
	        {
	          ref: "tooltip",
	          attrs: {
	            placement: "top",
	            "popper-class": _vm.tooltipClass,
	            disabled: !_vm.showTooltip
	          }
	        },
	        [
	          _c("span", { attrs: { slot: "content" }, slot: "content" }, [
	            _vm._v(_vm._s(_vm.formatValue))
	          ]),
	          _c("div", {
	            staticClass: "el-slider__button",
	            class: { hover: _vm.hovering, dragging: _vm.dragging }
	          })
	        ]
	      )
	    ],
	    1
	  )
	}
	var buttonvue_type_template_id_e72d2ad2_staticRenderFns = []
	buttonvue_type_template_id_e72d2ad2_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/slider/src/button.vue?vue&type=template&id=e72d2ad2&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/slider/src/button.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var slider_src_buttonvue_type_script_lang_js_ = ({
	  name: 'ElSliderButton',
	
	  components: {
	    ElTooltip: tooltip_default.a
	  },
	
	  props: {
	    value: {
	      type: Number,
	      default: 0
	    },
	    vertical: {
	      type: Boolean,
	      default: false
	    },
	    tooltipClass: String
	  },
	
	  data: function data() {
	    return {
	      hovering: false,
	      dragging: false,
	      isClick: false,
	      startX: 0,
	      currentX: 0,
	      startY: 0,
	      currentY: 0,
	      startPosition: 0,
	      newPosition: null,
	      oldValue: this.value
	    };
	  },
	
	
	  computed: {
	    disabled: function disabled() {
	      return this.$parent.sliderDisabled;
	    },
	    max: function max() {
	      return this.$parent.max;
	    },
	    min: function min() {
	      return this.$parent.min;
	    },
	    step: function step() {
	      return this.$parent.step;
	    },
	    showTooltip: function showTooltip() {
	      return this.$parent.showTooltip;
	    },
	    precision: function precision() {
	      return this.$parent.precision;
	    },
	    currentPosition: function currentPosition() {
	      return (this.value - this.min) / (this.max - this.min) * 100 + '%';
	    },
	    enableFormat: function enableFormat() {
	      return this.$parent.formatTooltip instanceof Function;
	    },
	    formatValue: function formatValue() {
	      return this.enableFormat && this.$parent.formatTooltip(this.value) || this.value;
	    },
	    wrapperStyle: function wrapperStyle() {
	      return this.vertical ? { bottom: this.currentPosition } : { left: this.currentPosition };
	    }
	  },
	
	  watch: {
	    dragging: function dragging(val) {
	      this.$parent.dragging = val;
	    }
	  },
	
	  methods: {
	    displayTooltip: function displayTooltip() {
	      this.$refs.tooltip && (this.$refs.tooltip.showPopper = true);
	    },
	    hideTooltip: function hideTooltip() {
	      this.$refs.tooltip && (this.$refs.tooltip.showPopper = false);
	    },
	    handleMouseEnter: function handleMouseEnter() {
	      this.hovering = true;
	      this.displayTooltip();
	    },
	    handleMouseLeave: function handleMouseLeave() {
	      this.hovering = false;
	      this.hideTooltip();
	    },
	    onButtonDown: function onButtonDown(event) {
	      if (this.disabled) return;
	      event.preventDefault();
	      this.onDragStart(event);
	      window.addEventListener('mousemove', this.onDragging);
	      window.addEventListener('touchmove', this.onDragging);
	      window.addEventListener('mouseup', this.onDragEnd);
	      window.addEventListener('touchend', this.onDragEnd);
	      window.addEventListener('contextmenu', this.onDragEnd);
	    },
	    onLeftKeyDown: function onLeftKeyDown() {
	      if (this.disabled) return;
	      this.newPosition = parseFloat(this.currentPosition) - this.step / (this.max - this.min) * 100;
	      this.setPosition(this.newPosition);
	      this.$parent.emitChange();
	    },
	    onRightKeyDown: function onRightKeyDown() {
	      if (this.disabled) return;
	      this.newPosition = parseFloat(this.currentPosition) + this.step / (this.max - this.min) * 100;
	      this.setPosition(this.newPosition);
	      this.$parent.emitChange();
	    },
	    onDragStart: function onDragStart(event) {
	      this.dragging = true;
	      this.isClick = true;
	      if (event.type === 'touchstart') {
	        event.clientY = event.touches[0].clientY;
	        event.clientX = event.touches[0].clientX;
	      }
	      if (this.vertical) {
	        this.startY = event.clientY;
	      } else {
	        this.startX = event.clientX;
	      }
	      this.startPosition = parseFloat(this.currentPosition);
	      this.newPosition = this.startPosition;
	    },
	    onDragging: function onDragging(event) {
	      if (this.dragging) {
	        this.isClick = false;
	        this.displayTooltip();
	        this.$parent.resetSize();
	        var diff = 0;
	        if (event.type === 'touchmove') {
	          event.clientY = event.touches[0].clientY;
	          event.clientX = event.touches[0].clientX;
	        }
	        if (this.vertical) {
	          this.currentY = event.clientY;
	          diff = (this.startY - this.currentY) / this.$parent.sliderSize * 100;
	        } else {
	          this.currentX = event.clientX;
	          diff = (this.currentX - this.startX) / this.$parent.sliderSize * 100;
	        }
	        this.newPosition = this.startPosition + diff;
	        this.setPosition(this.newPosition);
	      }
	    },
	    onDragEnd: function onDragEnd() {
	      var _this = this;
	
	      if (this.dragging) {
	        /*
	         * 防止在 mouseup 后立即触发 click，导致滑块有几率产生一小段位移
	         * 不使用 preventDefault 是因为 mouseup 和 click 没有注册在同一个 DOM 上
	         */
	        setTimeout(function () {
	          _this.dragging = false;
	          _this.hideTooltip();
	          if (!_this.isClick) {
	            _this.setPosition(_this.newPosition);
	            _this.$parent.emitChange();
	          }
	        }, 0);
	        window.removeEventListener('mousemove', this.onDragging);
	        window.removeEventListener('touchmove', this.onDragging);
	        window.removeEventListener('mouseup', this.onDragEnd);
	        window.removeEventListener('touchend', this.onDragEnd);
	        window.removeEventListener('contextmenu', this.onDragEnd);
	      }
	    },
	    setPosition: function setPosition(newPosition) {
	      var _this2 = this;
	
	      if (newPosition === null || isNaN(newPosition)) return;
	      if (newPosition < 0) {
	        newPosition = 0;
	      } else if (newPosition > 100) {
	        newPosition = 100;
	      }
	      var lengthPerStep = 100 / ((this.max - this.min) / this.step);
	      var steps = Math.round(newPosition / lengthPerStep);
	      var value = steps * lengthPerStep * (this.max - this.min) * 0.01 + this.min;
	      value = parseFloat(value.toFixed(this.precision));
	      this.$emit('input', value);
	      this.$nextTick(function () {
	        _this2.displayTooltip();
	        _this2.$refs.tooltip && _this2.$refs.tooltip.updatePopper();
	      });
	      if (!this.dragging && this.value !== this.oldValue) {
	        this.oldValue = this.value;
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/slider/src/button.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_slider_src_buttonvue_type_script_lang_js_ = (slider_src_buttonvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/slider/src/button.vue
	
	
	
	
	
	/* normalize component */
	
	var src_button_component = normalizeComponent(
	  packages_slider_src_buttonvue_type_script_lang_js_,
	  buttonvue_type_template_id_e72d2ad2_render,
	  buttonvue_type_template_id_e72d2ad2_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var src_button_api; }
	src_button_component.options.__file = "packages/slider/src/button.vue"
	/* harmony default export */ var slider_src_button = (src_button_component.exports);
	// CONCATENATED MODULE: ./packages/slider/src/marker.js
	/* harmony default export */ var marker = ({
	  name: 'ElMarker',
	
	  props: {
	    mark: {
	      type: [String, Object]
	    }
	  },
	  render: function render() {
	    var h = arguments[0];
	
	    var label = typeof this.mark === 'string' ? this.mark : this.mark.label;
	
	    return h(
	      'div',
	      { 'class': 'el-slider__marks-text', style: this.mark.style || {} },
	      [label]
	    );
	  }
	});
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/slider/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	/* harmony default export */ var slider_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElSlider',
	
	  mixins: [emitter_default.a],
	
	  inject: {
	    elForm: {
	      default: ''
	    }
	  },
	
	  props: {
	    min: {
	      type: Number,
	      default: 0
	    },
	    max: {
	      type: Number,
	      default: 100
	    },
	    step: {
	      type: Number,
	      default: 1
	    },
	    value: {
	      type: [Number, Array],
	      default: 0
	    },
	    showInput: {
	      type: Boolean,
	      default: false
	    },
	    showInputControls: {
	      type: Boolean,
	      default: true
	    },
	    inputSize: {
	      type: String,
	      default: 'small'
	    },
	    showStops: {
	      type: Boolean,
	      default: false
	    },
	    showTooltip: {
	      type: Boolean,
	      default: true
	    },
	    formatTooltip: Function,
	    disabled: {
	      type: Boolean,
	      default: false
	    },
	    range: {
	      type: Boolean,
	      default: false
	    },
	    vertical: {
	      type: Boolean,
	      default: false
	    },
	    height: {
	      type: String
	    },
	    debounce: {
	      type: Number,
	      default: 300
	    },
	    label: {
	      type: String
	    },
	    tooltipClass: String,
	    marks: Object
	  },
	
	  components: {
	    ElInputNumber: input_number_default.a,
	    SliderButton: slider_src_button,
	    SliderMarker: marker
	  },
	
	  data: function data() {
	    return {
	      firstValue: null,
	      secondValue: null,
	      oldValue: null,
	      dragging: false,
	      sliderSize: 1
	    };
	  },
	
	
	  watch: {
	    value: function value(val, oldVal) {
	      if (this.dragging || Array.isArray(val) && Array.isArray(oldVal) && val.every(function (item, index) {
	        return item === oldVal[index];
	      })) {
	        return;
	      }
	      this.setValues();
	    },
	    dragging: function dragging(val) {
	      if (!val) {
	        this.setValues();
	      }
	    },
	    firstValue: function firstValue(val) {
	      if (this.range) {
	        this.$emit('input', [this.minValue, this.maxValue]);
	      } else {
	        this.$emit('input', val);
	      }
	    },
	    secondValue: function secondValue() {
	      if (this.range) {
	        this.$emit('input', [this.minValue, this.maxValue]);
	      }
	    },
	    min: function min() {
	      this.setValues();
	    },
	    max: function max() {
	      this.setValues();
	    }
	  },
	
	  methods: {
	    valueChanged: function valueChanged() {
	      var _this = this;
	
	      if (this.range) {
	        return ![this.minValue, this.maxValue].every(function (item, index) {
	          return item === _this.oldValue[index];
	        });
	      } else {
	        return this.value !== this.oldValue;
	      }
	    },
	    setValues: function setValues() {
	      if (this.min > this.max) {
	        console.error('[Element Error][Slider]min should not be greater than max.');
	        return;
	      }
	      var val = this.value;
	      if (this.range && Array.isArray(val)) {
	        if (val[1] < this.min) {
	          this.$emit('input', [this.min, this.min]);
	        } else if (val[0] > this.max) {
	          this.$emit('input', [this.max, this.max]);
	        } else if (val[0] < this.min) {
	          this.$emit('input', [this.min, val[1]]);
	        } else if (val[1] > this.max) {
	          this.$emit('input', [val[0], this.max]);
	        } else {
	          this.firstValue = val[0];
	          this.secondValue = val[1];
	          if (this.valueChanged()) {
	            this.dispatch('ElFormItem', 'el.form.change', [this.minValue, this.maxValue]);
	            this.oldValue = val.slice();
	          }
	        }
	      } else if (!this.range && typeof val === 'number' && !isNaN(val)) {
	        if (val < this.min) {
	          this.$emit('input', this.min);
	        } else if (val > this.max) {
	          this.$emit('input', this.max);
	        } else {
	          this.firstValue = val;
	          if (this.valueChanged()) {
	            this.dispatch('ElFormItem', 'el.form.change', val);
	            this.oldValue = val;
	          }
	        }
	      }
	    },
	    setPosition: function setPosition(percent) {
	      var targetValue = this.min + percent * (this.max - this.min) / 100;
	      if (!this.range) {
	        this.$refs.button1.setPosition(percent);
	        return;
	      }
	      var button = void 0;
	      if (Math.abs(this.minValue - targetValue) < Math.abs(this.maxValue - targetValue)) {
	        button = this.firstValue < this.secondValue ? 'button1' : 'button2';
	      } else {
	        button = this.firstValue > this.secondValue ? 'button1' : 'button2';
	      }
	      this.$refs[button].setPosition(percent);
	    },
	    onSliderClick: function onSliderClick(event) {
	      if (this.sliderDisabled || this.dragging) return;
	      this.resetSize();
	      if (this.vertical) {
	        var sliderOffsetBottom = this.$refs.slider.getBoundingClientRect().bottom;
	        this.setPosition((sliderOffsetBottom - event.clientY) / this.sliderSize * 100);
	      } else {
	        var sliderOffsetLeft = this.$refs.slider.getBoundingClientRect().left;
	        this.setPosition((event.clientX - sliderOffsetLeft) / this.sliderSize * 100);
	      }
	      this.emitChange();
	    },
	    resetSize: function resetSize() {
	      if (this.$refs.slider) {
	        this.sliderSize = this.$refs.slider['client' + (this.vertical ? 'Height' : 'Width')];
	      }
	    },
	    emitChange: function emitChange() {
	      var _this2 = this;
	
	      this.$nextTick(function () {
	        _this2.$emit('change', _this2.range ? [_this2.minValue, _this2.maxValue] : _this2.value);
	      });
	    },
	    getStopStyle: function getStopStyle(position) {
	      return this.vertical ? { 'bottom': position + '%' } : { 'left': position + '%' };
	    }
	  },
	
	  computed: {
	    stops: function stops() {
	      var _this3 = this;
	
	      if (!this.showStops || this.min > this.max) return [];
	      if (this.step === 0) {
	         false && false;
	        return [];
	      }
	      var stopCount = (this.max - this.min) / this.step;
	      var stepWidth = 100 * this.step / (this.max - this.min);
	      var result = [];
	      for (var i = 1; i < stopCount; i++) {
	        result.push(i * stepWidth);
	      }
	      if (this.range) {
	        return result.filter(function (step) {
	          return step < 100 * (_this3.minValue - _this3.min) / (_this3.max - _this3.min) || step > 100 * (_this3.maxValue - _this3.min) / (_this3.max - _this3.min);
	        });
	      } else {
	        return result.filter(function (step) {
	          return step > 100 * (_this3.firstValue - _this3.min) / (_this3.max - _this3.min);
	        });
	      }
	    },
	    markList: function markList() {
	      var _this4 = this;
	
	      if (!this.marks) {
	        return [];
	      }
	
	      var marksKeys = Object.keys(this.marks);
	      return marksKeys.map(parseFloat).sort(function (a, b) {
	        return a - b;
	      }).filter(function (point) {
	        return point <= _this4.max && point >= _this4.min;
	      }).map(function (point) {
	        return {
	          point: point,
	          position: (point - _this4.min) * 100 / (_this4.max - _this4.min),
	          mark: _this4.marks[point]
	        };
	      });
	    },
	    minValue: function minValue() {
	      return Math.min(this.firstValue, this.secondValue);
	    },
	    maxValue: function maxValue() {
	      return Math.max(this.firstValue, this.secondValue);
	    },
	    barSize: function barSize() {
	      return this.range ? 100 * (this.maxValue - this.minValue) / (this.max - this.min) + '%' : 100 * (this.firstValue - this.min) / (this.max - this.min) + '%';
	    },
	    barStart: function barStart() {
	      return this.range ? 100 * (this.minValue - this.min) / (this.max - this.min) + '%' : '0%';
	    },
	    precision: function precision() {
	      var precisions = [this.min, this.max, this.step].map(function (item) {
	        var decimal = ('' + item).split('.')[1];
	        return decimal ? decimal.length : 0;
	      });
	      return Math.max.apply(null, precisions);
	    },
	    runwayStyle: function runwayStyle() {
	      return this.vertical ? { height: this.height } : {};
	    },
	    barStyle: function barStyle() {
	      return this.vertical ? {
	        height: this.barSize,
	        bottom: this.barStart
	      } : {
	        width: this.barSize,
	        left: this.barStart
	      };
	    },
	    sliderDisabled: function sliderDisabled() {
	      return this.disabled || (this.elForm || {}).disabled;
	    }
	  },
	
	  mounted: function mounted() {
	    var valuetext = void 0;
	    if (this.range) {
	      if (Array.isArray(this.value)) {
	        this.firstValue = Math.max(this.min, this.value[0]);
	        this.secondValue = Math.min(this.max, this.value[1]);
	      } else {
	        this.firstValue = this.min;
	        this.secondValue = this.max;
	      }
	      this.oldValue = [this.firstValue, this.secondValue];
	      valuetext = this.firstValue + '-' + this.secondValue;
	    } else {
	      if (typeof this.value !== 'number' || isNaN(this.value)) {
	        this.firstValue = this.min;
	      } else {
	        this.firstValue = Math.min(this.max, Math.max(this.min, this.value));
	      }
	      this.oldValue = this.firstValue;
	      valuetext = this.firstValue;
	    }
	    this.$el.setAttribute('aria-valuetext', valuetext);
	
	    // label screen reader
	    this.$el.setAttribute('aria-label', this.label ? this.label : 'slider between ' + this.min + ' and ' + this.max);
	
	    this.resetSize();
	    window.addEventListener('resize', this.resetSize);
	  },
	  beforeDestroy: function beforeDestroy() {
	    window.removeEventListener('resize', this.resetSize);
	  }
	});
	// CONCATENATED MODULE: ./packages/slider/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_slider_src_mainvue_type_script_lang_js_ = (slider_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/slider/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var slider_src_main_component = normalizeComponent(
	  packages_slider_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_32708644_render,
	  mainvue_type_template_id_32708644_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var slider_src_main_api; }
	slider_src_main_component.options.__file = "packages/slider/src/main.vue"
	/* harmony default export */ var slider_src_main = (slider_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/slider/index.js
	
	
	/* istanbul ignore next */
	slider_src_main.install = function (Vue) {
	  Vue.component(slider_src_main.name, slider_src_main);
	};
	
	/* harmony default export */ var slider = (slider_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/loading/src/loading.vue?vue&type=template&id=eee0a7ac&
	var loadingvue_type_template_id_eee0a7ac_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "transition",
	    {
	      attrs: { name: "el-loading-fade" },
	      on: { "after-leave": _vm.handleAfterLeave }
	    },
	    [
	      _c(
	        "div",
	        {
	          directives: [
	            {
	              name: "show",
	              rawName: "v-show",
	              value: _vm.visible,
	              expression: "visible"
	            }
	          ],
	          staticClass: "el-loading-mask",
	          class: [_vm.customClass, { "is-fullscreen": _vm.fullscreen }],
	          style: { backgroundColor: _vm.background || "" }
	        },
	        [
	          _c("div", { staticClass: "el-loading-spinner" }, [
	            !_vm.spinner
	              ? _c(
	                  "svg",
	                  {
	                    staticClass: "circular",
	                    attrs: { viewBox: "25 25 50 50" }
	                  },
	                  [
	                    _c("circle", {
	                      staticClass: "path",
	                      attrs: { cx: "50", cy: "50", r: "20", fill: "none" }
	                    })
	                  ]
	                )
	              : _c("i", { class: _vm.spinner }),
	            _vm.text
	              ? _c("p", { staticClass: "el-loading-text" }, [
	                  _vm._v(_vm._s(_vm.text))
	                ])
	              : _vm._e()
	          ])
	        ]
	      )
	    ]
	  )
	}
	var loadingvue_type_template_id_eee0a7ac_staticRenderFns = []
	loadingvue_type_template_id_eee0a7ac_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/loading/src/loading.vue?vue&type=template&id=eee0a7ac&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/loading/src/loading.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var loadingvue_type_script_lang_js_ = ({
	  data: function data() {
	    return {
	      text: null,
	      spinner: null,
	      background: null,
	      fullscreen: true,
	      visible: false,
	      customClass: ''
	    };
	  },
	
	
	  methods: {
	    handleAfterLeave: function handleAfterLeave() {
	      this.$emit('after-leave');
	    },
	    setText: function setText(text) {
	      this.text = text;
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/loading/src/loading.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_loadingvue_type_script_lang_js_ = (loadingvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/loading/src/loading.vue
	
	
	
	
	
	/* normalize component */
	
	var loading_component = normalizeComponent(
	  src_loadingvue_type_script_lang_js_,
	  loadingvue_type_template_id_eee0a7ac_render,
	  loadingvue_type_template_id_eee0a7ac_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var loading_api; }
	loading_component.options.__file = "packages/loading/src/loading.vue"
	/* harmony default export */ var loading = (loading_component.exports);
	// EXTERNAL MODULE: external "element-ui/lib/utils/after-leave"
	var after_leave_ = __webpack_require__(33);
	var after_leave_default = /*#__PURE__*/__webpack_require__.n(after_leave_);
	
	// CONCATENATED MODULE: ./packages/loading/src/directive.js
	
	
	
	
	
	var Mask = external_vue_default.a.extend(loading);
	
	var loadingDirective = {};
	loadingDirective.install = function (Vue) {
	  if (Vue.prototype.$isServer) return;
	  var toggleLoading = function toggleLoading(el, binding) {
	    if (binding.value) {
	      Vue.nextTick(function () {
	        if (binding.modifiers.fullscreen) {
	          el.originalPosition = Object(dom_["getStyle"])(document.body, 'position');
	          el.originalOverflow = Object(dom_["getStyle"])(document.body, 'overflow');
	          el.maskStyle.zIndex = popup_["PopupManager"].nextZIndex();
	
	          Object(dom_["addClass"])(el.mask, 'is-fullscreen');
	          insertDom(document.body, el, binding);
	        } else {
	          Object(dom_["removeClass"])(el.mask, 'is-fullscreen');
	
	          if (binding.modifiers.body) {
	            el.originalPosition = Object(dom_["getStyle"])(document.body, 'position');
	
	            ['top', 'left'].forEach(function (property) {
	              var scroll = property === 'top' ? 'scrollTop' : 'scrollLeft';
	              el.maskStyle[property] = el.getBoundingClientRect()[property] + document.body[scroll] + document.documentElement[scroll] - parseInt(Object(dom_["getStyle"])(document.body, 'margin-' + property), 10) + 'px';
	            });
	            ['height', 'width'].forEach(function (property) {
	              el.maskStyle[property] = el.getBoundingClientRect()[property] + 'px';
	            });
	
	            insertDom(document.body, el, binding);
	          } else {
	            el.originalPosition = Object(dom_["getStyle"])(el, 'position');
	            insertDom(el, el, binding);
	          }
	        }
	      });
	    } else {
	      after_leave_default()(el.instance, function (_) {
	        if (!el.instance.hiding) return;
	        el.domVisible = false;
	        var target = binding.modifiers.fullscreen || binding.modifiers.body ? document.body : el;
	        Object(dom_["removeClass"])(target, 'el-loading-parent--relative');
	        Object(dom_["removeClass"])(target, 'el-loading-parent--hidden');
	        el.instance.hiding = false;
	      }, 300, true);
	      el.instance.visible = false;
	      el.instance.hiding = true;
	    }
	  };
	  var insertDom = function insertDom(parent, el, binding) {
	    if (!el.domVisible && Object(dom_["getStyle"])(el, 'display') !== 'none' && Object(dom_["getStyle"])(el, 'visibility') !== 'hidden') {
	      Object.keys(el.maskStyle).forEach(function (property) {
	        el.mask.style[property] = el.maskStyle[property];
	      });
	
	      if (el.originalPosition !== 'absolute' && el.originalPosition !== 'fixed') {
	        Object(dom_["addClass"])(parent, 'el-loading-parent--relative');
	      }
	      if (binding.modifiers.fullscreen && binding.modifiers.lock) {
	        Object(dom_["addClass"])(parent, 'el-loading-parent--hidden');
	      }
	      el.domVisible = true;
	
	      parent.appendChild(el.mask);
	      Vue.nextTick(function () {
	        if (el.instance.hiding) {
	          el.instance.$emit('after-leave');
	        } else {
	          el.instance.visible = true;
	        }
	      });
	      el.domInserted = true;
	    } else if (el.domVisible && el.instance.hiding === true) {
	      el.instance.visible = true;
	      el.instance.hiding = false;
	    }
	  };
	
	  Vue.directive('loading', {
	    bind: function bind(el, binding, vnode) {
	      var textExr = el.getAttribute('element-loading-text');
	      var spinnerExr = el.getAttribute('element-loading-spinner');
	      var backgroundExr = el.getAttribute('element-loading-background');
	      var customClassExr = el.getAttribute('element-loading-custom-class');
	      var vm = vnode.context;
	      var mask = new Mask({
	        el: document.createElement('div'),
	        data: {
	          text: vm && vm[textExr] || textExr,
	          spinner: vm && vm[spinnerExr] || spinnerExr,
	          background: vm && vm[backgroundExr] || backgroundExr,
	          customClass: vm && vm[customClassExr] || customClassExr,
	          fullscreen: !!binding.modifiers.fullscreen
	        }
	      });
	      el.instance = mask;
	      el.mask = mask.$el;
	      el.maskStyle = {};
	
	      binding.value && toggleLoading(el, binding);
	    },
	
	    update: function update(el, binding) {
	      el.instance.setText(el.getAttribute('element-loading-text'));
	      if (binding.oldValue !== binding.value) {
	        toggleLoading(el, binding);
	      }
	    },
	
	    unbind: function unbind(el, binding) {
	      if (el.domInserted) {
	        el.mask && el.mask.parentNode && el.mask.parentNode.removeChild(el.mask);
	        toggleLoading(el, { value: false, modifiers: binding.modifiers });
	      }
	      el.instance && el.instance.$destroy();
	    }
	  });
	};
	
	/* harmony default export */ var src_directive = (loadingDirective);
	// CONCATENATED MODULE: ./packages/loading/src/index.js
	
	
	
	
	
	
	
	var LoadingConstructor = external_vue_default.a.extend(loading);
	
	var src_defaults = {
	  text: null,
	  fullscreen: true,
	  body: false,
	  lock: false,
	  customClass: ''
	};
	
	var fullscreenLoading = void 0;
	
	LoadingConstructor.prototype.originalPosition = '';
	LoadingConstructor.prototype.originalOverflow = '';
	
	LoadingConstructor.prototype.close = function () {
	  var _this = this;
	
	  if (this.fullscreen) {
	    fullscreenLoading = undefined;
	  }
	  after_leave_default()(this, function (_) {
	    var target = _this.fullscreen || _this.body ? document.body : _this.target;
	    Object(dom_["removeClass"])(target, 'el-loading-parent--relative');
	    Object(dom_["removeClass"])(target, 'el-loading-parent--hidden');
	    if (_this.$el && _this.$el.parentNode) {
	      _this.$el.parentNode.removeChild(_this.$el);
	    }
	    _this.$destroy();
	  }, 300);
	  this.visible = false;
	};
	
	var src_addStyle = function addStyle(options, parent, instance) {
	  var maskStyle = {};
	  if (options.fullscreen) {
	    instance.originalPosition = Object(dom_["getStyle"])(document.body, 'position');
	    instance.originalOverflow = Object(dom_["getStyle"])(document.body, 'overflow');
	    maskStyle.zIndex = popup_["PopupManager"].nextZIndex();
	  } else if (options.body) {
	    instance.originalPosition = Object(dom_["getStyle"])(document.body, 'position');
	    ['top', 'left'].forEach(function (property) {
	      var scroll = property === 'top' ? 'scrollTop' : 'scrollLeft';
	      maskStyle[property] = options.target.getBoundingClientRect()[property] + document.body[scroll] + document.documentElement[scroll] + 'px';
	    });
	    ['height', 'width'].forEach(function (property) {
	      maskStyle[property] = options.target.getBoundingClientRect()[property] + 'px';
	    });
	  } else {
	    instance.originalPosition = Object(dom_["getStyle"])(parent, 'position');
	  }
	  Object.keys(maskStyle).forEach(function (property) {
	    instance.$el.style[property] = maskStyle[property];
	  });
	};
	
	var src_Loading = function Loading() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  if (external_vue_default.a.prototype.$isServer) return;
	  options = merge_default()({}, src_defaults, options);
	  if (typeof options.target === 'string') {
	    options.target = document.querySelector(options.target);
	  }
	  options.target = options.target || document.body;
	  if (options.target !== document.body) {
	    options.fullscreen = false;
	  } else {
	    options.body = true;
	  }
	  if (options.fullscreen && fullscreenLoading) {
	    return fullscreenLoading;
	  }
	
	  var parent = options.body ? document.body : options.target;
	  var instance = new LoadingConstructor({
	    el: document.createElement('div'),
	    data: options
	  });
	
	  src_addStyle(options, parent, instance);
	  if (instance.originalPosition !== 'absolute' && instance.originalPosition !== 'fixed') {
	    Object(dom_["addClass"])(parent, 'el-loading-parent--relative');
	  }
	  if (options.fullscreen && options.lock) {
	    Object(dom_["addClass"])(parent, 'el-loading-parent--hidden');
	  }
	  parent.appendChild(instance.$el);
	  external_vue_default.a.nextTick(function () {
	    instance.visible = true;
	  });
	  if (options.fullscreen) {
	    fullscreenLoading = instance;
	  }
	  return instance;
	};
	
	/* harmony default export */ var src = (src_Loading);
	// CONCATENATED MODULE: ./packages/loading/index.js
	
	
	
	/* harmony default export */ var packages_loading = ({
	  install: function install(Vue) {
	    Vue.use(src_directive);
	    Vue.prototype.$loading = src;
	  },
	
	  directive: src_directive,
	  service: src
	});
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/icon/src/icon.vue?vue&type=template&id=cb3fe7f4&
	var iconvue_type_template_id_cb3fe7f4_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("i", { class: "el-icon-" + _vm.name })
	}
	var iconvue_type_template_id_cb3fe7f4_staticRenderFns = []
	iconvue_type_template_id_cb3fe7f4_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/icon/src/icon.vue?vue&type=template&id=cb3fe7f4&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/icon/src/icon.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	
	/* harmony default export */ var iconvue_type_script_lang_js_ = ({
	  name: 'ElIcon',
	
	  props: {
	    name: String
	  }
	});
	// CONCATENATED MODULE: ./packages/icon/src/icon.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_iconvue_type_script_lang_js_ = (iconvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/icon/src/icon.vue
	
	
	
	
	
	/* normalize component */
	
	var icon_component = normalizeComponent(
	  src_iconvue_type_script_lang_js_,
	  iconvue_type_template_id_cb3fe7f4_render,
	  iconvue_type_template_id_cb3fe7f4_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var icon_api; }
	icon_component.options.__file = "packages/icon/src/icon.vue"
	/* harmony default export */ var icon = (icon_component.exports);
	// CONCATENATED MODULE: ./packages/icon/index.js
	
	
	/* istanbul ignore next */
	icon.install = function (Vue) {
	  Vue.component(icon.name, icon);
	};
	
	/* harmony default export */ var packages_icon = (icon);
	// CONCATENATED MODULE: ./packages/row/src/row.js
	/* harmony default export */ var src_row = ({
	  name: 'ElRow',
	
	  componentName: 'ElRow',
	
	  props: {
	    tag: {
	      type: String,
	      default: 'div'
	    },
	    gutter: Number,
	    type: String,
	    justify: {
	      type: String,
	      default: 'start'
	    },
	    align: {
	      type: String,
	      default: 'top'
	    }
	  },
	
	  computed: {
	    style: function style() {
	      var ret = {};
	
	      if (this.gutter) {
	        ret.marginLeft = '-' + this.gutter / 2 + 'px';
	        ret.marginRight = ret.marginLeft;
	      }
	
	      return ret;
	    }
	  },
	
	  render: function render(h) {
	    return h(this.tag, {
	      class: ['el-row', this.justify !== 'start' ? 'is-justify-' + this.justify : '', this.align !== 'top' ? 'is-align-' + this.align : '', { 'el-row--flex': this.type === 'flex' }],
	      style: this.style
	    }, this.$slots.default);
	  }
	});
	// CONCATENATED MODULE: ./packages/row/index.js
	
	
	/* istanbul ignore next */
	src_row.install = function (Vue) {
	  Vue.component(src_row.name, src_row);
	};
	
	/* harmony default export */ var packages_row = (src_row);
	// CONCATENATED MODULE: ./packages/col/src/col.js
	var col_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/* harmony default export */ var col = ({
	  name: 'ElCol',
	
	  props: {
	    span: {
	      type: Number,
	      default: 24
	    },
	    tag: {
	      type: String,
	      default: 'div'
	    },
	    offset: Number,
	    pull: Number,
	    push: Number,
	    xs: [Number, Object],
	    sm: [Number, Object],
	    md: [Number, Object],
	    lg: [Number, Object],
	    xl: [Number, Object]
	  },
	
	  computed: {
	    gutter: function gutter() {
	      var parent = this.$parent;
	      while (parent && parent.$options.componentName !== 'ElRow') {
	        parent = parent.$parent;
	      }
	      return parent ? parent.gutter : 0;
	    }
	  },
	  render: function render(h) {
	    var _this = this;
	
	    var classList = [];
	    var style = {};
	
	    if (this.gutter) {
	      style.paddingLeft = this.gutter / 2 + 'px';
	      style.paddingRight = style.paddingLeft;
	    }
	
	    ['span', 'offset', 'pull', 'push'].forEach(function (prop) {
	      if (_this[prop] || _this[prop] === 0) {
	        classList.push(prop !== 'span' ? 'el-col-' + prop + '-' + _this[prop] : 'el-col-' + _this[prop]);
	      }
	    });
	
	    ['xs', 'sm', 'md', 'lg', 'xl'].forEach(function (size) {
	      if (typeof _this[size] === 'number') {
	        classList.push('el-col-' + size + '-' + _this[size]);
	      } else if (col_typeof(_this[size]) === 'object') {
	        var props = _this[size];
	        Object.keys(props).forEach(function (prop) {
	          classList.push(prop !== 'span' ? 'el-col-' + size + '-' + prop + '-' + props[prop] : 'el-col-' + size + '-' + props[prop]);
	        });
	      }
	    });
	
	    return h(this.tag, {
	      class: ['el-col', classList],
	      style: style
	    }, this.$slots.default);
	  }
	});
	// CONCATENATED MODULE: ./packages/col/index.js
	
	
	/* istanbul ignore next */
	col.install = function (Vue) {
	  Vue.component(col.name, col);
	};
	
	/* harmony default export */ var packages_col = (col);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/upload/src/upload-list.vue?vue&type=template&id=173fedf5&
	var upload_listvue_type_template_id_173fedf5_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "transition-group",
	    {
	      class: [
	        "el-upload-list",
	        "el-upload-list--" + _vm.listType,
	        { "is-disabled": _vm.disabled }
	      ],
	      attrs: { tag: "ul", name: "el-list" }
	    },
	    _vm._l(_vm.files, function(file) {
	      return _c(
	        "li",
	        {
	          key: file.uid,
	          class: [
	            "el-upload-list__item",
	            "is-" + file.status,
	            _vm.focusing ? "focusing" : ""
	          ],
	          attrs: { tabindex: "0" },
	          on: {
	            keydown: function($event) {
	              if (
	                !("button" in $event) &&
	                _vm._k($event.keyCode, "delete", [8, 46], $event.key, [
	                  "Backspace",
	                  "Delete",
	                  "Del"
	                ])
	              ) {
	                return null
	              }
	              !_vm.disabled && _vm.$emit("remove", file)
	            },
	            focus: function($event) {
	              _vm.focusing = true
	            },
	            blur: function($event) {
	              _vm.focusing = false
	            },
	            click: function($event) {
	              _vm.focusing = false
	            }
	          }
	        },
	        [
	          _vm._t(
	            "default",
	            [
	              file.status !== "uploading" &&
	              ["picture-card", "picture"].indexOf(_vm.listType) > -1
	                ? _c("img", {
	                    staticClass: "el-upload-list__item-thumbnail",
	                    attrs: { src: file.url, alt: "" }
	                  })
	                : _vm._e(),
	              _c(
	                "a",
	                {
	                  staticClass: "el-upload-list__item-name",
	                  on: {
	                    click: function($event) {
	                      _vm.handleClick(file)
	                    }
	                  }
	                },
	                [
	                  _c("i", { staticClass: "el-icon-document" }),
	                  _vm._v(_vm._s(file.name) + "\n      ")
	                ]
	              ),
	              _c(
	                "label",
	                { staticClass: "el-upload-list__item-status-label" },
	                [
	                  _c("i", {
	                    class: {
	                      "el-icon-upload-success": true,
	                      "el-icon-circle-check": _vm.listType === "text",
	                      "el-icon-check":
	                        ["picture-card", "picture"].indexOf(_vm.listType) > -1
	                    }
	                  })
	                ]
	              ),
	              !_vm.disabled
	                ? _c("i", {
	                    staticClass: "el-icon-close",
	                    on: {
	                      click: function($event) {
	                        _vm.$emit("remove", file)
	                      }
	                    }
	                  })
	                : _vm._e(),
	              !_vm.disabled
	                ? _c("i", { staticClass: "el-icon-close-tip" }, [
	                    _vm._v(_vm._s(_vm.t("el.upload.deleteTip")))
	                  ])
	                : _vm._e(),
	              file.status === "uploading"
	                ? _c("el-progress", {
	                    attrs: {
	                      type: _vm.listType === "picture-card" ? "circle" : "line",
	                      "stroke-width": _vm.listType === "picture-card" ? 6 : 2,
	                      percentage: _vm.parsePercentage(file.percentage)
	                    }
	                  })
	                : _vm._e(),
	              _vm.listType === "picture-card"
	                ? _c("span", { staticClass: "el-upload-list__item-actions" }, [
	                    _vm.handlePreview && _vm.listType === "picture-card"
	                      ? _c(
	                          "span",
	                          {
	                            staticClass: "el-upload-list__item-preview",
	                            on: {
	                              click: function($event) {
	                                _vm.handlePreview(file)
	                              }
	                            }
	                          },
	                          [_c("i", { staticClass: "el-icon-zoom-in" })]
	                        )
	                      : _vm._e(),
	                    !_vm.disabled
	                      ? _c(
	                          "span",
	                          {
	                            staticClass: "el-upload-list__item-delete",
	                            on: {
	                              click: function($event) {
	                                _vm.$emit("remove", file)
	                              }
	                            }
	                          },
	                          [_c("i", { staticClass: "el-icon-delete" })]
	                        )
	                      : _vm._e()
	                  ])
	                : _vm._e()
	            ],
	            { file: file }
	          )
	        ],
	        2
	      )
	    }),
	    0
	  )
	}
	var upload_listvue_type_template_id_173fedf5_staticRenderFns = []
	upload_listvue_type_template_id_173fedf5_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/upload/src/upload-list.vue?vue&type=template&id=173fedf5&
	
	// EXTERNAL MODULE: external "element-ui/lib/progress"
	var progress_ = __webpack_require__(34);
	var progress_default = /*#__PURE__*/__webpack_require__.n(progress_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/upload/src/upload-list.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	/* harmony default export */ var upload_listvue_type_script_lang_js_ = ({
	
	  name: 'ElUploadList',
	
	  mixins: [locale_default.a],
	
	  data: function data() {
	    return {
	      focusing: false
	    };
	  },
	
	  components: { ElProgress: progress_default.a },
	
	  props: {
	    files: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    disabled: {
	      type: Boolean,
	      default: false
	    },
	    handlePreview: Function,
	    listType: String
	  },
	  methods: {
	    parsePercentage: function parsePercentage(val) {
	      return parseInt(val, 10);
	    },
	    handleClick: function handleClick(file) {
	      this.handlePreview && this.handlePreview(file);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/upload/src/upload-list.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_upload_listvue_type_script_lang_js_ = (upload_listvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/upload/src/upload-list.vue
	
	
	
	
	
	/* normalize component */
	
	var upload_list_component = normalizeComponent(
	  src_upload_listvue_type_script_lang_js_,
	  upload_listvue_type_template_id_173fedf5_render,
	  upload_listvue_type_template_id_173fedf5_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var upload_list_api; }
	upload_list_component.options.__file = "packages/upload/src/upload-list.vue"
	/* harmony default export */ var upload_list = (upload_list_component.exports);
	// EXTERNAL MODULE: external "babel-helper-vue-jsx-merge-props"
	var external_babel_helper_vue_jsx_merge_props_ = __webpack_require__(24);
	var external_babel_helper_vue_jsx_merge_props_default = /*#__PURE__*/__webpack_require__.n(external_babel_helper_vue_jsx_merge_props_);
	
	// CONCATENATED MODULE: ./packages/upload/src/ajax.js
	function getError(action, option, xhr) {
	  var msg = void 0;
	  if (xhr.response) {
	    msg = '' + (xhr.response.error || xhr.response);
	  } else if (xhr.responseText) {
	    msg = '' + xhr.responseText;
	  } else {
	    msg = 'fail to post ' + action + ' ' + xhr.status;
	  }
	
	  var err = new Error(msg);
	  err.status = xhr.status;
	  err.method = 'post';
	  err.url = action;
	  return err;
	}
	
	function getBody(xhr) {
	  var text = xhr.responseText || xhr.response;
	  if (!text) {
	    return text;
	  }
	
	  try {
	    return JSON.parse(text);
	  } catch (e) {
	    return text;
	  }
	}
	
	function upload(option) {
	  if (typeof XMLHttpRequest === 'undefined') {
	    return;
	  }
	
	  var xhr = new XMLHttpRequest();
	  var action = option.action;
	
	  if (xhr.upload) {
	    xhr.upload.onprogress = function progress(e) {
	      if (e.total > 0) {
	        e.percent = e.loaded / e.total * 100;
	      }
	      option.onProgress(e);
	    };
	  }
	
	  var formData = new FormData();
	
	  if (option.data) {
	    Object.keys(option.data).forEach(function (key) {
	      formData.append(key, option.data[key]);
	    });
	  }
	
	  formData.append(option.filename, option.file, option.file.name);
	
	  xhr.onerror = function error(e) {
	    option.onError(e);
	  };
	
	  xhr.onload = function onload() {
	    if (xhr.status < 200 || xhr.status >= 300) {
	      return option.onError(getError(action, option, xhr));
	    }
	
	    option.onSuccess(getBody(xhr));
	  };
	
	  xhr.open('post', action, true);
	
	  if (option.withCredentials && 'withCredentials' in xhr) {
	    xhr.withCredentials = true;
	  }
	
	  var headers = option.headers || {};
	
	  for (var item in headers) {
	    if (headers.hasOwnProperty(item) && headers[item] !== null) {
	      xhr.setRequestHeader(item, headers[item]);
	    }
	  }
	  xhr.send(formData);
	  return xhr;
	}
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/upload/src/upload-dragger.vue?vue&type=template&id=7ebbf219&
	var upload_draggervue_type_template_id_7ebbf219_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-upload-dragger",
	      class: {
	        "is-dragover": _vm.dragover
	      },
	      on: {
	        drop: function($event) {
	          $event.preventDefault()
	          return _vm.onDrop($event)
	        },
	        dragover: function($event) {
	          $event.preventDefault()
	          return _vm.onDragover($event)
	        },
	        dragleave: function($event) {
	          $event.preventDefault()
	          _vm.dragover = false
	        }
	      }
	    },
	    [_vm._t("default")],
	    2
	  )
	}
	var upload_draggervue_type_template_id_7ebbf219_staticRenderFns = []
	upload_draggervue_type_template_id_7ebbf219_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/upload/src/upload-dragger.vue?vue&type=template&id=7ebbf219&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/upload/src/upload-dragger.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var upload_draggervue_type_script_lang_js_ = ({
	  name: 'ElUploadDrag',
	  props: {
	    disabled: Boolean
	  },
	  inject: {
	    uploader: {
	      default: ''
	    }
	  },
	  data: function data() {
	    return {
	      dragover: false
	    };
	  },
	
	  methods: {
	    onDragover: function onDragover() {
	      if (!this.disabled) {
	        this.dragover = true;
	      }
	    },
	    onDrop: function onDrop(e) {
	      if (this.disabled || !this.uploader) return;
	      var accept = this.uploader.accept;
	      this.dragover = false;
	      if (!accept) {
	        this.$emit('file', e.dataTransfer.files);
	        return;
	      }
	      this.$emit('file', [].slice.call(e.dataTransfer.files).filter(function (file) {
	        var type = file.type,
	            name = file.name;
	
	        var extension = name.indexOf('.') > -1 ? '.' + name.split('.').pop() : '';
	        var baseType = type.replace(/\/.*$/, '');
	        return accept.split(',').map(function (type) {
	          return type.trim();
	        }).filter(function (type) {
	          return type;
	        }).some(function (acceptedType) {
	          if (/\..+$/.test(acceptedType)) {
	            return extension === acceptedType;
	          }
	          if (/\/\*$/.test(acceptedType)) {
	            return baseType === acceptedType.replace(/\/\*$/, '');
	          }
	          if (/^[^\/]+\/[^\/]+$/.test(acceptedType)) {
	            return type === acceptedType;
	          }
	          return false;
	        });
	      }));
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/upload/src/upload-dragger.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_upload_draggervue_type_script_lang_js_ = (upload_draggervue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/upload/src/upload-dragger.vue
	
	
	
	
	
	/* normalize component */
	
	var upload_dragger_component = normalizeComponent(
	  src_upload_draggervue_type_script_lang_js_,
	  upload_draggervue_type_template_id_7ebbf219_render,
	  upload_draggervue_type_template_id_7ebbf219_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var upload_dragger_api; }
	upload_dragger_component.options.__file = "packages/upload/src/upload-dragger.vue"
	/* harmony default export */ var upload_dragger = (upload_dragger_component.exports);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/upload/src/upload.vue?vue&type=script&lang=js&
	
	
	
	
	
	/* harmony default export */ var uploadvue_type_script_lang_js_ = ({
	  inject: ['uploader'],
	  components: {
	    UploadDragger: upload_dragger
	  },
	  props: {
	    type: String,
	    action: {
	      type: String,
	      required: true
	    },
	    name: {
	      type: String,
	      default: 'file'
	    },
	    data: Object,
	    headers: Object,
	    withCredentials: Boolean,
	    multiple: Boolean,
	    accept: String,
	    onStart: Function,
	    onProgress: Function,
	    onSuccess: Function,
	    onError: Function,
	    beforeUpload: Function,
	    drag: Boolean,
	    onPreview: {
	      type: Function,
	      default: function _default() {}
	    },
	    onRemove: {
	      type: Function,
	      default: function _default() {}
	    },
	    fileList: Array,
	    autoUpload: Boolean,
	    listType: String,
	    httpRequest: {
	      type: Function,
	      default: upload
	    },
	    disabled: Boolean,
	    limit: Number,
	    onExceed: Function
	  },
	
	  data: function data() {
	    return {
	      mouseover: false,
	      reqs: {}
	    };
	  },
	
	
	  methods: {
	    isImage: function isImage(str) {
	      return str.indexOf('image') !== -1;
	    },
	    handleChange: function handleChange(ev) {
	      var files = ev.target.files;
	
	      if (!files) return;
	      this.uploadFiles(files);
	    },
	    uploadFiles: function uploadFiles(files) {
	      var _this = this;
	
	      if (this.limit && this.fileList.length + files.length > this.limit) {
	        this.onExceed && this.onExceed(files, this.fileList);
	        return;
	      }
	
	      var postFiles = Array.prototype.slice.call(files);
	      if (!this.multiple) {
	        postFiles = postFiles.slice(0, 1);
	      }
	
	      if (postFiles.length === 0) {
	        return;
	      }
	
	      postFiles.forEach(function (rawFile) {
	        _this.onStart(rawFile);
	        if (_this.autoUpload) _this.upload(rawFile);
	      });
	    },
	    upload: function upload(rawFile) {
	      var _this2 = this;
	
	      this.$refs.input.value = null;
	
	      if (!this.beforeUpload) {
	        return this.post(rawFile);
	      }
	
	      var before = this.beforeUpload(rawFile);
	      if (before && before.then) {
	        before.then(function (processedFile) {
	          var fileType = Object.prototype.toString.call(processedFile);
	
	          if (fileType === '[object File]' || fileType === '[object Blob]') {
	            if (fileType === '[object Blob]') {
	              processedFile = new File([processedFile], rawFile.name, {
	                type: rawFile.type
	              });
	            }
	            for (var p in rawFile) {
	              if (rawFile.hasOwnProperty(p)) {
	                processedFile[p] = rawFile[p];
	              }
	            }
	            _this2.post(processedFile);
	          } else {
	            _this2.post(rawFile);
	          }
	        }, function () {
	          _this2.onRemove(null, rawFile);
	        });
	      } else if (before !== false) {
	        this.post(rawFile);
	      } else {
	        this.onRemove(null, rawFile);
	      }
	    },
	    abort: function abort(file) {
	      var reqs = this.reqs;
	
	      if (file) {
	        var uid = file;
	        if (file.uid) uid = file.uid;
	        if (reqs[uid]) {
	          reqs[uid].abort();
	        }
	      } else {
	        Object.keys(reqs).forEach(function (uid) {
	          if (reqs[uid]) reqs[uid].abort();
	          delete reqs[uid];
	        });
	      }
	    },
	    post: function post(rawFile) {
	      var _this3 = this;
	
	      var uid = rawFile.uid;
	
	      var options = {
	        headers: this.headers,
	        withCredentials: this.withCredentials,
	        file: rawFile,
	        data: this.data,
	        filename: this.name,
	        action: this.action,
	        onProgress: function onProgress(e) {
	          _this3.onProgress(e, rawFile);
	        },
	        onSuccess: function onSuccess(res) {
	          _this3.onSuccess(res, rawFile);
	          delete _this3.reqs[uid];
	        },
	        onError: function onError(err) {
	          _this3.onError(err, rawFile);
	          delete _this3.reqs[uid];
	        }
	      };
	      var req = this.httpRequest(options);
	      this.reqs[uid] = req;
	      if (req && req.then) {
	        req.then(options.onSuccess, options.onError);
	      }
	    },
	    handleClick: function handleClick() {
	      if (!this.disabled) {
	        this.$refs.input.value = null;
	        this.$refs.input.click();
	      }
	    },
	    handleKeydown: function handleKeydown(e) {
	      if (e.target !== e.currentTarget) return;
	      if (e.keyCode === 13 || e.keyCode === 32) {
	        this.handleClick();
	      }
	    }
	  },
	
	  render: function render(h) {
	    var handleClick = this.handleClick,
	        drag = this.drag,
	        name = this.name,
	        handleChange = this.handleChange,
	        multiple = this.multiple,
	        accept = this.accept,
	        listType = this.listType,
	        uploadFiles = this.uploadFiles,
	        disabled = this.disabled,
	        handleKeydown = this.handleKeydown;
	
	    var data = {
	      class: {
	        'el-upload': true
	      },
	      on: {
	        click: handleClick,
	        keydown: handleKeydown
	      }
	    };
	    data.class['el-upload--' + listType] = true;
	    return h(
	      'div',
	      external_babel_helper_vue_jsx_merge_props_default()([data, {
	        attrs: { tabindex: '0' }
	      }]),
	      [drag ? h(
	        'upload-dragger',
	        {
	          attrs: { disabled: disabled },
	          on: {
	            'file': uploadFiles
	          }
	        },
	        [this.$slots.default]
	      ) : this.$slots.default, h('input', { 'class': 'el-upload__input', attrs: { type: 'file', name: name, multiple: multiple, accept: accept },
	        ref: 'input', on: {
	          'change': handleChange
	        }
	      })]
	    );
	  }
	});
	// CONCATENATED MODULE: ./packages/upload/src/upload.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_uploadvue_type_script_lang_js_ = (uploadvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/upload/src/upload.vue
	var upload_render, upload_staticRenderFns
	
	
	
	
	/* normalize component */
	
	var upload_component = normalizeComponent(
	  src_uploadvue_type_script_lang_js_,
	  upload_render,
	  upload_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var upload_api; }
	upload_component.options.__file = "packages/upload/src/upload.vue"
	/* harmony default export */ var src_upload = (upload_component.exports);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/upload/src/index.vue?vue&type=script&lang=js&
	
	
	
	
	
	
	function srcvue_type_script_lang_js_noop() {}
	
	/* harmony default export */ var srcvue_type_script_lang_js_ = ({
	  name: 'ElUpload',
	
	  mixins: [migrating_default.a],
	
	  components: {
	    ElProgress: progress_default.a,
	    UploadList: upload_list,
	    Upload: src_upload
	  },
	
	  provide: function provide() {
	    return {
	      uploader: this
	    };
	  },
	
	
	  inject: {
	    elForm: {
	      default: ''
	    }
	  },
	
	  props: {
	    action: {
	      type: String,
	      required: true
	    },
	    headers: {
	      type: Object,
	      default: function _default() {
	        return {};
	      }
	    },
	    data: Object,
	    multiple: Boolean,
	    name: {
	      type: String,
	      default: 'file'
	    },
	    drag: Boolean,
	    dragger: Boolean,
	    withCredentials: Boolean,
	    showFileList: {
	      type: Boolean,
	      default: true
	    },
	    accept: String,
	    type: {
	      type: String,
	      default: 'select'
	    },
	    beforeUpload: Function,
	    beforeRemove: Function,
	    onRemove: {
	      type: Function,
	      default: srcvue_type_script_lang_js_noop
	    },
	    onChange: {
	      type: Function,
	      default: srcvue_type_script_lang_js_noop
	    },
	    onPreview: {
	      type: Function
	    },
	    onSuccess: {
	      type: Function,
	      default: srcvue_type_script_lang_js_noop
	    },
	    onProgress: {
	      type: Function,
	      default: srcvue_type_script_lang_js_noop
	    },
	    onError: {
	      type: Function,
	      default: srcvue_type_script_lang_js_noop
	    },
	    fileList: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    autoUpload: {
	      type: Boolean,
	      default: true
	    },
	    listType: {
	      type: String,
	      default: 'text' // text,picture,picture-card
	    },
	    httpRequest: Function,
	    disabled: Boolean,
	    limit: Number,
	    onExceed: {
	      type: Function,
	      default: srcvue_type_script_lang_js_noop
	    }
	  },
	
	  data: function data() {
	    return {
	      uploadFiles: [],
	      dragOver: false,
	      draging: false,
	      tempIndex: 1
	    };
	  },
	
	
	  computed: {
	    uploadDisabled: function uploadDisabled() {
	      return this.disabled || (this.elForm || {}).disabled;
	    }
	  },
	
	  watch: {
	    listType: function listType(type) {
	      if (type === 'picture-card' || type === 'picture') {
	        this.uploadFiles = this.uploadFiles.map(function (file) {
	          if (!file.url && file.raw) {
	            try {
	              file.url = URL.createObjectURL(file.raw);
	            } catch (err) {
	              console.error('[Element Error][Upload]', err);
	            }
	          }
	          return file;
	        });
	      }
	    },
	
	    fileList: {
	      immediate: true,
	      handler: function handler(fileList) {
	        var _this = this;
	
	        this.uploadFiles = fileList.map(function (item) {
	          item.uid = item.uid || Date.now() + _this.tempIndex++;
	          item.status = item.status || 'success';
	          return item;
	        });
	      }
	    }
	  },
	
	  methods: {
	    handleStart: function handleStart(rawFile) {
	      rawFile.uid = Date.now() + this.tempIndex++;
	      var file = {
	        status: 'ready',
	        name: rawFile.name,
	        size: rawFile.size,
	        percentage: 0,
	        uid: rawFile.uid,
	        raw: rawFile
	      };
	
	      if (this.listType === 'picture-card' || this.listType === 'picture') {
	        try {
	          file.url = URL.createObjectURL(rawFile);
	        } catch (err) {
	          console.error('[Element Error][Upload]', err);
	          return;
	        }
	      }
	
	      this.uploadFiles.push(file);
	      this.onChange(file, this.uploadFiles);
	    },
	    handleProgress: function handleProgress(ev, rawFile) {
	      var file = this.getFile(rawFile);
	      this.onProgress(ev, file, this.uploadFiles);
	      file.status = 'uploading';
	      file.percentage = ev.percent || 0;
	    },
	    handleSuccess: function handleSuccess(res, rawFile) {
	      var file = this.getFile(rawFile);
	
	      if (file) {
	        file.status = 'success';
	        file.response = res;
	
	        this.onSuccess(res, file, this.uploadFiles);
	        this.onChange(file, this.uploadFiles);
	      }
	    },
	    handleError: function handleError(err, rawFile) {
	      var file = this.getFile(rawFile);
	      var fileList = this.uploadFiles;
	
	      file.status = 'fail';
	
	      fileList.splice(fileList.indexOf(file), 1);
	
	      this.onError(err, file, this.uploadFiles);
	      this.onChange(file, this.uploadFiles);
	    },
	    handleRemove: function handleRemove(file, raw) {
	      var _this2 = this;
	
	      if (raw) {
	        file = this.getFile(raw);
	      }
	      var doRemove = function doRemove() {
	        _this2.abort(file);
	        var fileList = _this2.uploadFiles;
	        fileList.splice(fileList.indexOf(file), 1);
	        _this2.onRemove(file, fileList);
	      };
	
	      if (!this.beforeRemove) {
	        doRemove();
	      } else if (typeof this.beforeRemove === 'function') {
	        var before = this.beforeRemove(file, this.uploadFiles);
	        if (before && before.then) {
	          before.then(function () {
	            doRemove();
	          }, srcvue_type_script_lang_js_noop);
	        } else if (before !== false) {
	          doRemove();
	        }
	      }
	    },
	    getFile: function getFile(rawFile) {
	      var fileList = this.uploadFiles;
	      var target = void 0;
	      fileList.every(function (item) {
	        target = rawFile.uid === item.uid ? item : null;
	        return !target;
	      });
	      return target;
	    },
	    abort: function abort(file) {
	      this.$refs['upload-inner'].abort(file);
	    },
	    clearFiles: function clearFiles() {
	      this.uploadFiles = [];
	    },
	    submit: function submit() {
	      var _this3 = this;
	
	      this.uploadFiles.filter(function (file) {
	        return file.status === 'ready';
	      }).forEach(function (file) {
	        _this3.$refs['upload-inner'].upload(file.raw);
	      });
	    },
	    getMigratingConfig: function getMigratingConfig() {
	      return {
	        props: {
	          'default-file-list': 'default-file-list is renamed to file-list.',
	          'show-upload-list': 'show-upload-list is renamed to show-file-list.',
	          'thumbnail-mode': 'thumbnail-mode has been deprecated, you can implement the same effect according to this case: http://element.eleme.io/#/zh-CN/component/upload#yong-hu-tou-xiang-shang-chuan'
	        }
	      };
	    }
	  },
	
	  beforeDestroy: function beforeDestroy() {
	    this.uploadFiles.forEach(function (file) {
	      if (file.url && file.url.indexOf('blob:') === 0) {
	        URL.revokeObjectURL(file.url);
	      }
	    });
	  },
	  render: function render(h) {
	    var _this4 = this;
	
	    var uploadList = void 0;
	
	    if (this.showFileList) {
	      uploadList = h(
	        upload_list,
	        {
	          attrs: {
	            disabled: this.uploadDisabled,
	            listType: this.listType,
	            files: this.uploadFiles,
	
	            handlePreview: this.onPreview },
	          on: {
	            'remove': this.handleRemove
	          }
	        },
	        [function (props) {
	          if (_this4.$scopedSlots.file) {
	            return _this4.$scopedSlots.file({
	              file: props.file
	            });
	          }
	        }]
	      );
	    }
	
	    var uploadData = {
	      props: {
	        type: this.type,
	        drag: this.drag,
	        action: this.action,
	        multiple: this.multiple,
	        'before-upload': this.beforeUpload,
	        'with-credentials': this.withCredentials,
	        headers: this.headers,
	        name: this.name,
	        data: this.data,
	        accept: this.accept,
	        fileList: this.uploadFiles,
	        autoUpload: this.autoUpload,
	        listType: this.listType,
	        disabled: this.uploadDisabled,
	        limit: this.limit,
	        'on-exceed': this.onExceed,
	        'on-start': this.handleStart,
	        'on-progress': this.handleProgress,
	        'on-success': this.handleSuccess,
	        'on-error': this.handleError,
	        'on-preview': this.onPreview,
	        'on-remove': this.handleRemove,
	        'http-request': this.httpRequest
	      },
	      ref: 'upload-inner'
	    };
	
	    var trigger = this.$slots.trigger || this.$slots.default;
	    var uploadComponent = h(
	      'upload',
	      uploadData,
	      [trigger]
	    );
	
	    return h('div', [this.listType === 'picture-card' ? uploadList : '', this.$slots.trigger ? [uploadComponent, this.$slots.default] : uploadComponent, this.$slots.tip, this.listType !== 'picture-card' ? uploadList : '']);
	  }
	});
	// CONCATENATED MODULE: ./packages/upload/src/index.vue?vue&type=script&lang=js&
	 /* harmony default export */ var upload_srcvue_type_script_lang_js_ = (srcvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/upload/src/index.vue
	var src_render, src_staticRenderFns
	
	
	
	
	/* normalize component */
	
	var upload_src_component = normalizeComponent(
	  upload_srcvue_type_script_lang_js_,
	  src_render,
	  src_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var src_api; }
	upload_src_component.options.__file = "packages/upload/src/index.vue"
	/* harmony default export */ var upload_src = (upload_src_component.exports);
	// CONCATENATED MODULE: ./packages/upload/index.js
	
	
	/* istanbul ignore next */
	upload_src.install = function (Vue) {
	  Vue.component(upload_src.name, upload_src);
	};
	
	/* harmony default export */ var packages_upload = (upload_src);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/progress/src/progress.vue?vue&type=template&id=229ee406&
	var progressvue_type_template_id_229ee406_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-progress",
	      class: [
	        "el-progress--" + _vm.type,
	        _vm.status ? "is-" + _vm.status : "",
	        {
	          "el-progress--without-text": !_vm.showText,
	          "el-progress--text-inside": _vm.textInside
	        }
	      ],
	      attrs: {
	        role: "progressbar",
	        "aria-valuenow": _vm.percentage,
	        "aria-valuemin": "0",
	        "aria-valuemax": "100"
	      }
	    },
	    [
	      _vm.type === "line"
	        ? _c("div", { staticClass: "el-progress-bar" }, [
	            _c(
	              "div",
	              {
	                staticClass: "el-progress-bar__outer",
	                style: { height: _vm.strokeWidth + "px" }
	              },
	              [
	                _c(
	                  "div",
	                  {
	                    staticClass: "el-progress-bar__inner",
	                    style: _vm.barStyle
	                  },
	                  [
	                    _vm.showText && _vm.textInside
	                      ? _c(
	                          "div",
	                          { staticClass: "el-progress-bar__innerText" },
	                          [_vm._v(_vm._s(_vm.content))]
	                        )
	                      : _vm._e()
	                  ]
	                )
	              ]
	            )
	          ])
	        : _c(
	            "div",
	            {
	              staticClass: "el-progress-circle",
	              style: { height: _vm.width + "px", width: _vm.width + "px" }
	            },
	            [
	              _c("svg", { attrs: { viewBox: "0 0 100 100" } }, [
	                _c("path", {
	                  staticClass: "el-progress-circle__track",
	                  style: _vm.trailPathStyle,
	                  attrs: {
	                    d: _vm.trackPath,
	                    stroke: "#e5e9f2",
	                    "stroke-width": _vm.relativeStrokeWidth,
	                    fill: "none"
	                  }
	                }),
	                _c("path", {
	                  staticClass: "el-progress-circle__path",
	                  style: _vm.circlePathStyle,
	                  attrs: {
	                    d: _vm.trackPath,
	                    stroke: _vm.stroke,
	                    fill: "none",
	                    "stroke-linecap": _vm.strokeLinecap,
	                    "stroke-width": _vm.percentage ? _vm.relativeStrokeWidth : 0
	                  }
	                })
	              ])
	            ]
	          ),
	      _vm.showText && !_vm.textInside
	        ? _c(
	            "div",
	            {
	              staticClass: "el-progress__text",
	              style: { fontSize: _vm.progressTextSize + "px" }
	            },
	            [
	              !_vm.status
	                ? [_vm._v(_vm._s(_vm.content))]
	                : _c("i", { class: _vm.iconClass })
	            ],
	            2
	          )
	        : _vm._e()
	    ]
	  )
	}
	var progressvue_type_template_id_229ee406_staticRenderFns = []
	progressvue_type_template_id_229ee406_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/progress/src/progress.vue?vue&type=template&id=229ee406&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/progress/src/progress.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var progressvue_type_script_lang_js_ = ({
	  name: 'ElProgress',
	  props: {
	    type: {
	      type: String,
	      default: 'line',
	      validator: function validator(val) {
	        return ['line', 'circle', 'dashboard'].indexOf(val) > -1;
	      }
	    },
	    percentage: {
	      type: Number,
	      default: 0,
	      required: true,
	      validator: function validator(val) {
	        return val >= 0 && val <= 100;
	      }
	    },
	    status: {
	      type: String,
	      validator: function validator(val) {
	        return ['success', 'exception', 'warning'].indexOf(val) > -1;
	      }
	    },
	    strokeWidth: {
	      type: Number,
	      default: 6
	    },
	    strokeLinecap: {
	      type: String,
	      default: 'round'
	    },
	    textInside: {
	      type: Boolean,
	      default: false
	    },
	    width: {
	      type: Number,
	      default: 126
	    },
	    showText: {
	      type: Boolean,
	      default: true
	    },
	    color: {
	      type: [String, Array, Function],
	      default: ''
	    },
	    format: Function
	  },
	  computed: {
	    barStyle: function barStyle() {
	      var style = {};
	      style.width = this.percentage + '%';
	      style.backgroundColor = this.getCurrentColor(this.percentage);
	      return style;
	    },
	    relativeStrokeWidth: function relativeStrokeWidth() {
	      return (this.strokeWidth / this.width * 100).toFixed(1);
	    },
	    radius: function radius() {
	      if (this.type === 'circle' || this.type === 'dashboard') {
	        return parseInt(50 - parseFloat(this.relativeStrokeWidth) / 2, 10);
	      } else {
	        return 0;
	      }
	    },
	    trackPath: function trackPath() {
	      var radius = this.radius;
	      var isDashboard = this.type === 'dashboard';
	      return '\n        M 50 50\n        m 0 ' + (isDashboard ? '' : '-') + radius + '\n        a ' + radius + ' ' + radius + ' 0 1 1 0 ' + (isDashboard ? '-' : '') + radius * 2 + '\n        a ' + radius + ' ' + radius + ' 0 1 1 0 ' + (isDashboard ? '' : '-') + radius * 2 + '\n        ';
	    },
	    perimeter: function perimeter() {
	      return 2 * Math.PI * this.radius;
	    },
	    rate: function rate() {
	      return this.type === 'dashboard' ? 0.75 : 1;
	    },
	    strokeDashoffset: function strokeDashoffset() {
	      var offset = -1 * this.perimeter * (1 - this.rate) / 2;
	      return offset + 'px';
	    },
	    trailPathStyle: function trailPathStyle() {
	      return {
	        strokeDasharray: this.perimeter * this.rate + 'px, ' + this.perimeter + 'px',
	        strokeDashoffset: this.strokeDashoffset
	      };
	    },
	    circlePathStyle: function circlePathStyle() {
	      return {
	        strokeDasharray: this.perimeter * this.rate * (this.percentage / 100) + 'px, ' + this.perimeter + 'px',
	        strokeDashoffset: this.strokeDashoffset,
	        transition: 'stroke-dasharray 0.6s ease 0s, stroke 0.6s ease'
	      };
	    },
	    stroke: function stroke() {
	      var ret = void 0;
	      if (this.color) {
	        ret = this.getCurrentColor(this.percentage);
	      } else {
	        switch (this.status) {
	          case 'success':
	            ret = '#13ce66';
	            break;
	          case 'exception':
	            ret = '#ff4949';
	            break;
	          case 'warning':
	            ret = '#e6a23c';
	            break;
	          default:
	            ret = '#20a0ff';
	        }
	      }
	      return ret;
	    },
	    iconClass: function iconClass() {
	      if (this.status === 'warning') {
	        return 'el-icon-warning';
	      }
	      if (this.type === 'line') {
	        return this.status === 'success' ? 'el-icon-circle-check' : 'el-icon-circle-close';
	      } else {
	        return this.status === 'success' ? 'el-icon-check' : 'el-icon-close';
	      }
	    },
	    progressTextSize: function progressTextSize() {
	      return this.type === 'line' ? 12 + this.strokeWidth * 0.4 : this.width * 0.111111 + 2;
	    },
	    content: function content() {
	      if (typeof this.format === 'function') {
	        return this.format(this.percentage) || '';
	      } else {
	        return this.percentage + '%';
	      }
	    }
	  },
	  methods: {
	    getCurrentColor: function getCurrentColor(percentage) {
	      if (typeof this.color === 'function') {
	        return this.color(percentage);
	      } else if (typeof this.color === 'string') {
	        return this.color;
	      } else {
	        return this.getLevelColor(percentage);
	      }
	    },
	    getLevelColor: function getLevelColor(percentage) {
	      var colorArray = this.getColorArray().sort(function (a, b) {
	        return a.percentage - b.percentage;
	      });
	
	      for (var i = 0; i < colorArray.length; i++) {
	        if (colorArray[i].percentage > percentage) {
	          return colorArray[i].color;
	        }
	      }
	      return colorArray[colorArray.length - 1].color;
	    },
	    getColorArray: function getColorArray() {
	      var color = this.color;
	      var span = 100 / color.length;
	      return color.map(function (seriesColor, index) {
	        if (typeof seriesColor === 'string') {
	          return {
	            color: seriesColor,
	            progress: (index + 1) * span
	          };
	        }
	        return seriesColor;
	      });
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/progress/src/progress.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_progressvue_type_script_lang_js_ = (progressvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/progress/src/progress.vue
	
	
	
	
	
	/* normalize component */
	
	var progress_component = normalizeComponent(
	  src_progressvue_type_script_lang_js_,
	  progressvue_type_template_id_229ee406_render,
	  progressvue_type_template_id_229ee406_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var progress_api; }
	progress_component.options.__file = "packages/progress/src/progress.vue"
	/* harmony default export */ var progress = (progress_component.exports);
	// CONCATENATED MODULE: ./packages/progress/index.js
	
	
	/* istanbul ignore next */
	progress.install = function (Vue) {
	  Vue.component(progress.name, progress);
	};
	
	/* harmony default export */ var packages_progress = (progress);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/spinner/src/spinner.vue?vue&type=template&id=697b8538&
	var spinnervue_type_template_id_697b8538_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("span", { staticClass: "el-spinner" }, [
	    _c(
	      "svg",
	      {
	        staticClass: "el-spinner-inner",
	        style: { width: _vm.radius / 2 + "px", height: _vm.radius / 2 + "px" },
	        attrs: { viewBox: "0 0 50 50" }
	      },
	      [
	        _c("circle", {
	          staticClass: "path",
	          attrs: {
	            cx: "25",
	            cy: "25",
	            r: "20",
	            fill: "none",
	            stroke: _vm.strokeColor,
	            "stroke-width": _vm.strokeWidth
	          }
	        })
	      ]
	    )
	  ])
	}
	var spinnervue_type_template_id_697b8538_staticRenderFns = []
	spinnervue_type_template_id_697b8538_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/spinner/src/spinner.vue?vue&type=template&id=697b8538&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/spinner/src/spinner.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var spinnervue_type_script_lang_js_ = ({
	  name: 'ElSpinner',
	  props: {
	    type: String,
	    radius: {
	      type: Number,
	      default: 100
	    },
	    strokeWidth: {
	      type: Number,
	      default: 5
	    },
	    strokeColor: {
	      type: String,
	      default: '#efefef'
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/spinner/src/spinner.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_spinnervue_type_script_lang_js_ = (spinnervue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/spinner/src/spinner.vue
	
	
	
	
	
	/* normalize component */
	
	var spinner_component = normalizeComponent(
	  src_spinnervue_type_script_lang_js_,
	  spinnervue_type_template_id_697b8538_render,
	  spinnervue_type_template_id_697b8538_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var spinner_api; }
	spinner_component.options.__file = "packages/spinner/src/spinner.vue"
	/* harmony default export */ var spinner = (spinner_component.exports);
	// CONCATENATED MODULE: ./packages/spinner/index.js
	
	
	/* istanbul ignore next */
	spinner.install = function (Vue) {
	  Vue.component(spinner.name, spinner);
	};
	
	/* harmony default export */ var packages_spinner = (spinner);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/message/src/main.vue?vue&type=template&id=455b9f60&
	var mainvue_type_template_id_455b9f60_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "transition",
	    {
	      attrs: { name: "el-message-fade" },
	      on: { "after-leave": _vm.handleAfterLeave }
	    },
	    [
	      _c(
	        "div",
	        {
	          directives: [
	            {
	              name: "show",
	              rawName: "v-show",
	              value: _vm.visible,
	              expression: "visible"
	            }
	          ],
	          class: [
	            "el-message",
	            _vm.type && !_vm.iconClass ? "el-message--" + _vm.type : "",
	            _vm.center ? "is-center" : "",
	            _vm.showClose ? "is-closable" : "",
	            _vm.customClass
	          ],
	          style: _vm.positionStyle,
	          attrs: { role: "alert" },
	          on: { mouseenter: _vm.clearTimer, mouseleave: _vm.startTimer }
	        },
	        [
	          _vm.iconClass
	            ? _c("i", { class: _vm.iconClass })
	            : _c("i", { class: _vm.typeClass }),
	          _vm._t("default", [
	            !_vm.dangerouslyUseHTMLString
	              ? _c("p", { staticClass: "el-message__content" }, [
	                  _vm._v(_vm._s(_vm.message))
	                ])
	              : _c("p", {
	                  staticClass: "el-message__content",
	                  domProps: { innerHTML: _vm._s(_vm.message) }
	                })
	          ]),
	          _vm.showClose
	            ? _c("i", {
	                staticClass: "el-message__closeBtn el-icon-close",
	                on: { click: _vm.close }
	              })
	            : _vm._e()
	        ],
	        2
	      )
	    ]
	  )
	}
	var mainvue_type_template_id_455b9f60_staticRenderFns = []
	mainvue_type_template_id_455b9f60_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/message/src/main.vue?vue&type=template&id=455b9f60&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/message/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	var src_mainvue_type_script_lang_js_typeMap = {
	  success: 'success',
	  info: 'info',
	  warning: 'warning',
	  error: 'error'
	};
	
	/* harmony default export */ var message_src_mainvue_type_script_lang_js_ = ({
	  data: function data() {
	    return {
	      visible: false,
	      message: '',
	      duration: 3000,
	      type: 'info',
	      iconClass: '',
	      customClass: '',
	      onClose: null,
	      showClose: false,
	      closed: false,
	      verticalOffset: 20,
	      timer: null,
	      dangerouslyUseHTMLString: false,
	      center: false
	    };
	  },
	
	
	  computed: {
	    typeClass: function typeClass() {
	      return this.type && !this.iconClass ? 'el-message__icon el-icon-' + src_mainvue_type_script_lang_js_typeMap[this.type] : '';
	    },
	    positionStyle: function positionStyle() {
	      return {
	        'top': this.verticalOffset + 'px'
	      };
	    }
	  },
	
	  watch: {
	    closed: function closed(newVal) {
	      if (newVal) {
	        this.visible = false;
	      }
	    }
	  },
	
	  methods: {
	    handleAfterLeave: function handleAfterLeave() {
	      this.$destroy(true);
	      this.$el.parentNode.removeChild(this.$el);
	    },
	    close: function close() {
	      this.closed = true;
	      if (typeof this.onClose === 'function') {
	        this.onClose(this);
	      }
	    },
	    clearTimer: function clearTimer() {
	      clearTimeout(this.timer);
	    },
	    startTimer: function startTimer() {
	      var _this = this;
	
	      if (this.duration > 0) {
	        this.timer = setTimeout(function () {
	          if (!_this.closed) {
	            _this.close();
	          }
	        }, this.duration);
	      }
	    },
	    keydown: function keydown(e) {
	      if (e.keyCode === 27) {
	        // esc关闭消息
	        if (!this.closed) {
	          this.close();
	        }
	      }
	    }
	  },
	  mounted: function mounted() {
	    this.startTimer();
	    document.addEventListener('keydown', this.keydown);
	  },
	  beforeDestroy: function beforeDestroy() {
	    document.removeEventListener('keydown', this.keydown);
	  }
	});
	// CONCATENATED MODULE: ./packages/message/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_message_src_mainvue_type_script_lang_js_ = (message_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/message/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var message_src_main_component = normalizeComponent(
	  packages_message_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_455b9f60_render,
	  mainvue_type_template_id_455b9f60_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var message_src_main_api; }
	message_src_main_component.options.__file = "packages/message/src/main.vue"
	/* harmony default export */ var message_src_main = (message_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/message/src/main.js
	
	
	
	
	var MessageConstructor = external_vue_default.a.extend(message_src_main);
	
	var message_src_main_instance = void 0;
	var main_instances = [];
	var main_seed = 1;
	
	var main_Message = function Message(options) {
	  if (external_vue_default.a.prototype.$isServer) return;
	  options = options || {};
	  if (typeof options === 'string') {
	    options = {
	      message: options
	    };
	  }
	  var userOnClose = options.onClose;
	  var id = 'message_' + main_seed++;
	
	  options.onClose = function () {
	    Message.close(id, userOnClose);
	  };
	  message_src_main_instance = new MessageConstructor({
	    data: options
	  });
	  message_src_main_instance.id = id;
	  if (Object(vdom_["isVNode"])(message_src_main_instance.message)) {
	    message_src_main_instance.$slots.default = [message_src_main_instance.message];
	    message_src_main_instance.message = null;
	  }
	  message_src_main_instance.$mount();
	  document.body.appendChild(message_src_main_instance.$el);
	  var verticalOffset = options.offset || 20;
	  main_instances.forEach(function (item) {
	    verticalOffset += item.$el.offsetHeight + 16;
	  });
	  message_src_main_instance.verticalOffset = verticalOffset;
	  message_src_main_instance.visible = true;
	  message_src_main_instance.$el.style.zIndex = popup_["PopupManager"].nextZIndex();
	  main_instances.push(message_src_main_instance);
	  return message_src_main_instance;
	};
	
	['success', 'warning', 'info', 'error'].forEach(function (type) {
	  main_Message[type] = function (options) {
	    if (typeof options === 'string') {
	      options = {
	        message: options
	      };
	    }
	    options.type = type;
	    return main_Message(options);
	  };
	});
	
	main_Message.close = function (id, userOnClose) {
	  var len = main_instances.length;
	  var index = -1;
	  var removedHeight = void 0;
	  for (var i = 0; i < len; i++) {
	    if (id === main_instances[i].id) {
	      removedHeight = main_instances[i].$el.offsetHeight;
	      index = i;
	      if (typeof userOnClose === 'function') {
	        userOnClose(main_instances[i]);
	      }
	      main_instances.splice(i, 1);
	      break;
	    }
	  }
	  if (len <= 1 || index === -1 || index > main_instances.length - 1) return;
	  for (var _i = index; _i < len - 1; _i++) {
	    var dom = main_instances[_i].$el;
	    dom.style['top'] = parseInt(dom.style['top'], 10) - removedHeight - 16 + 'px';
	  }
	};
	
	main_Message.closeAll = function () {
	  for (var i = main_instances.length - 1; i >= 0; i--) {
	    main_instances[i].close();
	  }
	};
	
	/* harmony default export */ var packages_message_src_main = (main_Message);
	// CONCATENATED MODULE: ./packages/message/index.js
	
	/* harmony default export */ var packages_message = (packages_message_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/badge/src/main.vue?vue&type=template&id=7ccb6598&
	var mainvue_type_template_id_7ccb6598_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    { staticClass: "el-badge" },
	    [
	      _vm._t("default"),
	      _c("transition", { attrs: { name: "el-zoom-in-center" } }, [
	        _c("sup", {
	          directives: [
	            {
	              name: "show",
	              rawName: "v-show",
	              value:
	                !_vm.hidden && (_vm.content || _vm.content === 0 || _vm.isDot),
	              expression: "!hidden && (content || content === 0 || isDot)"
	            }
	          ],
	          staticClass: "el-badge__content",
	          class: [
	            "el-badge__content--" + _vm.type,
	            {
	              "is-fixed": _vm.$slots.default,
	              "is-dot": _vm.isDot
	            }
	          ],
	          domProps: { textContent: _vm._s(_vm.content) }
	        })
	      ])
	    ],
	    2
	  )
	}
	var mainvue_type_template_id_7ccb6598_staticRenderFns = []
	mainvue_type_template_id_7ccb6598_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/badge/src/main.vue?vue&type=template&id=7ccb6598&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/badge/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var badge_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElBadge',
	
	  props: {
	    value: [String, Number],
	    max: Number,
	    isDot: Boolean,
	    hidden: Boolean,
	    type: {
	      type: String,
	      validator: function validator(val) {
	        return ['primary', 'success', 'warning', 'info', 'danger'].indexOf(val) > -1;
	      }
	    }
	  },
	
	  computed: {
	    content: function content() {
	      if (this.isDot) return;
	
	      var value = this.value;
	      var max = this.max;
	
	      if (typeof value === 'number' && typeof max === 'number') {
	        return max < value ? max + '+' : value;
	      }
	
	      return value;
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/badge/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_badge_src_mainvue_type_script_lang_js_ = (badge_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/badge/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var badge_src_main_component = normalizeComponent(
	  packages_badge_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_7ccb6598_render,
	  mainvue_type_template_id_7ccb6598_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var badge_src_main_api; }
	badge_src_main_component.options.__file = "packages/badge/src/main.vue"
	/* harmony default export */ var badge_src_main = (badge_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/badge/index.js
	
	
	/* istanbul ignore next */
	badge_src_main.install = function (Vue) {
	  Vue.component(badge_src_main.name, badge_src_main);
	};
	
	/* harmony default export */ var badge = (badge_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/card/src/main.vue?vue&type=template&id=59a4a40f&
	var mainvue_type_template_id_59a4a40f_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-card",
	      class: _vm.shadow ? "is-" + _vm.shadow + "-shadow" : "is-always-shadow"
	    },
	    [
	      _vm.$slots.header || _vm.header
	        ? _c(
	            "div",
	            { staticClass: "el-card__header" },
	            [_vm._t("header", [_vm._v(_vm._s(_vm.header))])],
	            2
	          )
	        : _vm._e(),
	      _c(
	        "div",
	        { staticClass: "el-card__body", style: _vm.bodyStyle },
	        [_vm._t("default")],
	        2
	      )
	    ]
	  )
	}
	var mainvue_type_template_id_59a4a40f_staticRenderFns = []
	mainvue_type_template_id_59a4a40f_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/card/src/main.vue?vue&type=template&id=59a4a40f&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/card/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var card_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElCard',
	  props: {
	    header: {},
	    bodyStyle: {},
	    shadow: {
	      type: String
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/card/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_card_src_mainvue_type_script_lang_js_ = (card_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/card/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var card_src_main_component = normalizeComponent(
	  packages_card_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_59a4a40f_render,
	  mainvue_type_template_id_59a4a40f_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var card_src_main_api; }
	card_src_main_component.options.__file = "packages/card/src/main.vue"
	/* harmony default export */ var card_src_main = (card_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/card/index.js
	
	
	/* istanbul ignore next */
	card_src_main.install = function (Vue) {
	  Vue.component(card_src_main.name, card_src_main);
	};
	
	/* harmony default export */ var card = (card_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/rate/src/main.vue?vue&type=template&id=ada57782&
	var mainvue_type_template_id_ada57782_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-rate",
	      attrs: {
	        role: "slider",
	        "aria-valuenow": _vm.currentValue,
	        "aria-valuetext": _vm.text,
	        "aria-valuemin": "0",
	        "aria-valuemax": _vm.max,
	        tabindex: "0"
	      },
	      on: { keydown: _vm.handleKey }
	    },
	    [
	      _vm._l(_vm.max, function(item, key) {
	        return _c(
	          "span",
	          {
	            key: key,
	            staticClass: "el-rate__item",
	            style: { cursor: _vm.rateDisabled ? "auto" : "pointer" },
	            on: {
	              mousemove: function($event) {
	                _vm.setCurrentValue(item, $event)
	              },
	              mouseleave: _vm.resetCurrentValue,
	              click: function($event) {
	                _vm.selectValue(item)
	              }
	            }
	          },
	          [
	            _c(
	              "i",
	              {
	                staticClass: "el-rate__icon",
	                class: [
	                  _vm.classes[item - 1],
	                  { hover: _vm.hoverIndex === item }
	                ],
	                style: _vm.getIconStyle(item)
	              },
	              [
	                _vm.showDecimalIcon(item)
	                  ? _c("i", {
	                      staticClass: "el-rate__decimal",
	                      class: _vm.decimalIconClass,
	                      style: _vm.decimalStyle
	                    })
	                  : _vm._e()
	              ]
	            )
	          ]
	        )
	      }),
	      _vm.showText || _vm.showScore
	        ? _c(
	            "span",
	            { staticClass: "el-rate__text", style: { color: _vm.textColor } },
	            [_vm._v(_vm._s(_vm.text))]
	          )
	        : _vm._e()
	    ],
	    2
	  )
	}
	var mainvue_type_template_id_ada57782_staticRenderFns = []
	mainvue_type_template_id_ada57782_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/rate/src/main.vue?vue&type=template&id=ada57782&
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/types"
	var types_ = __webpack_require__(18);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/rate/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	/* harmony default export */ var rate_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElRate',
	
	  mixins: [migrating_default.a],
	
	  inject: {
	    elForm: {
	      default: ''
	    }
	  },
	
	  data: function data() {
	    return {
	      pointerAtLeftHalf: true,
	      currentValue: this.value,
	      hoverIndex: -1
	    };
	  },
	
	
	  props: {
	    value: {
	      type: Number,
	      default: 0
	    },
	    lowThreshold: {
	      type: Number,
	      default: 2
	    },
	    highThreshold: {
	      type: Number,
	      default: 4
	    },
	    max: {
	      type: Number,
	      default: 5
	    },
	    colors: {
	      type: [Array, Object],
	      default: function _default() {
	        return ['#F7BA2A', '#F7BA2A', '#F7BA2A'];
	      }
	    },
	    voidColor: {
	      type: String,
	      default: '#C6D1DE'
	    },
	    disabledVoidColor: {
	      type: String,
	      default: '#EFF2F7'
	    },
	    iconClasses: {
	      type: [Array, Object],
	      default: function _default() {
	        return ['el-icon-star-on', 'el-icon-star-on', 'el-icon-star-on'];
	      }
	    },
	    voidIconClass: {
	      type: String,
	      default: 'el-icon-star-off'
	    },
	    disabledVoidIconClass: {
	      type: String,
	      default: 'el-icon-star-on'
	    },
	    disabled: {
	      type: Boolean,
	      default: false
	    },
	    allowHalf: {
	      type: Boolean,
	      default: false
	    },
	    showText: {
	      type: Boolean,
	      default: false
	    },
	    showScore: {
	      type: Boolean,
	      default: false
	    },
	    textColor: {
	      type: String,
	      default: '#1f2d3d'
	    },
	    texts: {
	      type: Array,
	      default: function _default() {
	        return ['极差', '失望', '一般', '满意', '惊喜'];
	      }
	    },
	    scoreTemplate: {
	      type: String,
	      default: '{value}'
	    }
	  },
	
	  computed: {
	    text: function text() {
	      var result = '';
	      if (this.showScore) {
	        result = this.scoreTemplate.replace(/\{\s*value\s*\}/, this.rateDisabled ? this.value : this.currentValue);
	      } else if (this.showText) {
	        result = this.texts[Math.ceil(this.currentValue) - 1];
	      }
	      return result;
	    },
	    decimalStyle: function decimalStyle() {
	      var width = '';
	      if (this.rateDisabled) {
	        width = this.valueDecimal + '%';
	      } else if (this.allowHalf) {
	        width = '50%';
	      }
	      return {
	        color: this.activeColor,
	        width: width
	      };
	    },
	    valueDecimal: function valueDecimal() {
	      return this.value * 100 - Math.floor(this.value) * 100;
	    },
	    classMap: function classMap() {
	      var _ref;
	
	      return Array.isArray(this.iconClasses) ? (_ref = {}, _ref[this.lowThreshold] = this.iconClasses[0], _ref[this.highThreshold] = { value: this.iconClasses[1], excluded: true }, _ref[this.max] = this.iconClasses[2], _ref) : this.iconClasses;
	    },
	    decimalIconClass: function decimalIconClass() {
	      return this.getValueFromMap(this.value, this.classMap);
	    },
	    voidClass: function voidClass() {
	      return this.rateDisabled ? this.disabledVoidIconClass : this.voidIconClass;
	    },
	    activeClass: function activeClass() {
	      return this.getValueFromMap(this.currentValue, this.classMap);
	    },
	    colorMap: function colorMap() {
	      var _ref2;
	
	      return Array.isArray(this.colors) ? (_ref2 = {}, _ref2[this.lowThreshold] = this.colors[0], _ref2[this.highThreshold] = { value: this.colors[1], excluded: true }, _ref2[this.max] = this.colors[2], _ref2) : this.colors;
	    },
	    activeColor: function activeColor() {
	      return this.getValueFromMap(this.currentValue, this.colorMap);
	    },
	    classes: function classes() {
	      var result = [];
	      var i = 0;
	      var threshold = this.currentValue;
	      if (this.allowHalf && this.currentValue !== Math.floor(this.currentValue)) {
	        threshold--;
	      }
	      for (; i < threshold; i++) {
	        result.push(this.activeClass);
	      }
	      for (; i < this.max; i++) {
	        result.push(this.voidClass);
	      }
	      return result;
	    },
	    rateDisabled: function rateDisabled() {
	      return this.disabled || (this.elForm || {}).disabled;
	    }
	  },
	
	  watch: {
	    value: function value(val) {
	      this.currentValue = val;
	      this.pointerAtLeftHalf = this.value !== Math.floor(this.value);
	    }
	  },
	
	  methods: {
	    getMigratingConfig: function getMigratingConfig() {
	      return {
	        props: {
	          'text-template': 'text-template is renamed to score-template.'
	        }
	      };
	    },
	    getValueFromMap: function getValueFromMap(value, map) {
	      var matchedKeys = Object.keys(map).filter(function (key) {
	        var val = map[key];
	        var excluded = Object(types_["isObject"])(val) ? val.excluded : false;
	        return excluded ? value < key : value <= key;
	      }).sort(function (a, b) {
	        return a - b;
	      });
	      var matchedValue = map[matchedKeys[0]];
	      return Object(types_["isObject"])(matchedValue) ? matchedValue.value : matchedValue || '';
	    },
	    showDecimalIcon: function showDecimalIcon(item) {
	      var showWhenDisabled = this.rateDisabled && this.valueDecimal > 0 && item - 1 < this.value && item > this.value;
	      /* istanbul ignore next */
	      var showWhenAllowHalf = this.allowHalf && this.pointerAtLeftHalf && item - 0.5 <= this.currentValue && item > this.currentValue;
	      return showWhenDisabled || showWhenAllowHalf;
	    },
	    getIconStyle: function getIconStyle(item) {
	      var voidColor = this.rateDisabled ? this.disabledVoidColor : this.voidColor;
	      return {
	        color: item <= this.currentValue ? this.activeColor : voidColor
	      };
	    },
	    selectValue: function selectValue(value) {
	      if (this.rateDisabled) {
	        return;
	      }
	      if (this.allowHalf && this.pointerAtLeftHalf) {
	        this.$emit('input', this.currentValue);
	        this.$emit('change', this.currentValue);
	      } else {
	        this.$emit('input', value);
	        this.$emit('change', value);
	      }
	    },
	    handleKey: function handleKey(e) {
	      if (this.rateDisabled) {
	        return;
	      }
	      var currentValue = this.currentValue;
	      var keyCode = e.keyCode;
	      if (keyCode === 38 || keyCode === 39) {
	        // left / down
	        if (this.allowHalf) {
	          currentValue += 0.5;
	        } else {
	          currentValue += 1;
	        }
	        e.stopPropagation();
	        e.preventDefault();
	      } else if (keyCode === 37 || keyCode === 40) {
	        if (this.allowHalf) {
	          currentValue -= 0.5;
	        } else {
	          currentValue -= 1;
	        }
	        e.stopPropagation();
	        e.preventDefault();
	      }
	      currentValue = currentValue < 0 ? 0 : currentValue;
	      currentValue = currentValue > this.max ? this.max : currentValue;
	
	      this.$emit('input', currentValue);
	      this.$emit('change', currentValue);
	    },
	    setCurrentValue: function setCurrentValue(value, event) {
	      if (this.rateDisabled) {
	        return;
	      }
	      /* istanbul ignore if */
	      if (this.allowHalf) {
	        var target = event.target;
	        if (Object(dom_["hasClass"])(target, 'el-rate__item')) {
	          target = target.querySelector('.el-rate__icon');
	        }
	        if (Object(dom_["hasClass"])(target, 'el-rate__decimal')) {
	          target = target.parentNode;
	        }
	        this.pointerAtLeftHalf = event.offsetX * 2 <= target.clientWidth;
	        this.currentValue = this.pointerAtLeftHalf ? value - 0.5 : value;
	      } else {
	        this.currentValue = value;
	      }
	      this.hoverIndex = value;
	    },
	    resetCurrentValue: function resetCurrentValue() {
	      if (this.rateDisabled) {
	        return;
	      }
	      if (this.allowHalf) {
	        this.pointerAtLeftHalf = this.value !== Math.floor(this.value);
	      }
	      this.currentValue = this.value;
	      this.hoverIndex = -1;
	    }
	  },
	
	  created: function created() {
	    if (!this.value) {
	      this.$emit('input', 0);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/rate/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_rate_src_mainvue_type_script_lang_js_ = (rate_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/rate/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var rate_src_main_component = normalizeComponent(
	  packages_rate_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_ada57782_render,
	  mainvue_type_template_id_ada57782_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var rate_src_main_api; }
	rate_src_main_component.options.__file = "packages/rate/src/main.vue"
	/* harmony default export */ var rate_src_main = (rate_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/rate/index.js
	
	
	/* istanbul ignore next */
	rate_src_main.install = function (Vue) {
	  Vue.component(rate_src_main.name, rate_src_main);
	};
	
	/* harmony default export */ var rate = (rate_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/steps/src/steps.vue?vue&type=template&id=3c6b6dc0&
	var stepsvue_type_template_id_3c6b6dc0_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-steps",
	      class: [
	        !_vm.simple && "el-steps--" + _vm.direction,
	        _vm.simple && "el-steps--simple"
	      ]
	    },
	    [_vm._t("default")],
	    2
	  )
	}
	var stepsvue_type_template_id_3c6b6dc0_staticRenderFns = []
	stepsvue_type_template_id_3c6b6dc0_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/steps/src/steps.vue?vue&type=template&id=3c6b6dc0&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/steps/src/steps.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var stepsvue_type_script_lang_js_ = ({
	  name: 'ElSteps',
	
	  mixins: [migrating_default.a],
	
	  props: {
	    space: [Number, String],
	    active: Number,
	    direction: {
	      type: String,
	      default: 'horizontal'
	    },
	    alignCenter: Boolean,
	    simple: Boolean,
	    finishStatus: {
	      type: String,
	      default: 'finish'
	    },
	    processStatus: {
	      type: String,
	      default: 'process'
	    }
	  },
	
	  data: function data() {
	    return {
	      steps: [],
	      stepOffset: 0
	    };
	  },
	
	
	  methods: {
	    getMigratingConfig: function getMigratingConfig() {
	      return {
	        props: {
	          'center': 'center is removed.'
	        }
	      };
	    }
	  },
	
	  watch: {
	    active: function active(newVal, oldVal) {
	      this.$emit('change', newVal, oldVal);
	    },
	    steps: function steps(_steps) {
	      _steps.forEach(function (child, index) {
	        child.index = index;
	      });
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/steps/src/steps.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_stepsvue_type_script_lang_js_ = (stepsvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/steps/src/steps.vue
	
	
	
	
	
	/* normalize component */
	
	var steps_component = normalizeComponent(
	  src_stepsvue_type_script_lang_js_,
	  stepsvue_type_template_id_3c6b6dc0_render,
	  stepsvue_type_template_id_3c6b6dc0_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var steps_api; }
	steps_component.options.__file = "packages/steps/src/steps.vue"
	/* harmony default export */ var steps = (steps_component.exports);
	// CONCATENATED MODULE: ./packages/steps/index.js
	
	
	/* istanbul ignore next */
	steps.install = function (Vue) {
	  Vue.component(steps.name, steps);
	};
	
	/* harmony default export */ var packages_steps = (steps);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/steps/src/step.vue?vue&type=template&id=f414a87a&
	var stepvue_type_template_id_f414a87a_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-step",
	      class: [
	        !_vm.isSimple && "is-" + _vm.$parent.direction,
	        _vm.isSimple && "is-simple",
	        _vm.isLast && !_vm.space && !_vm.isCenter && "is-flex",
	        _vm.isCenter && !_vm.isVertical && !_vm.isSimple && "is-center"
	      ],
	      style: _vm.style
	    },
	    [
	      _c(
	        "div",
	        { staticClass: "el-step__head", class: "is-" + _vm.currentStatus },
	        [
	          _c(
	            "div",
	            {
	              staticClass: "el-step__line",
	              style: _vm.isLast
	                ? ""
	                : { marginRight: _vm.$parent.stepOffset + "px" }
	            },
	            [
	              _c("i", {
	                staticClass: "el-step__line-inner",
	                style: _vm.lineStyle
	              })
	            ]
	          ),
	          _c(
	            "div",
	            {
	              staticClass: "el-step__icon",
	              class: "is-" + (_vm.icon ? "icon" : "text")
	            },
	            [
	              _vm.currentStatus !== "success" && _vm.currentStatus !== "error"
	                ? _vm._t("icon", [
	                    _vm.icon
	                      ? _c("i", {
	                          staticClass: "el-step__icon-inner",
	                          class: [_vm.icon]
	                        })
	                      : _vm._e(),
	                    !_vm.icon && !_vm.isSimple
	                      ? _c("div", { staticClass: "el-step__icon-inner" }, [
	                          _vm._v(_vm._s(_vm.index + 1))
	                        ])
	                      : _vm._e()
	                  ])
	                : _c("i", {
	                    staticClass: "el-step__icon-inner is-status",
	                    class: [
	                      "el-icon-" +
	                        (_vm.currentStatus === "success" ? "check" : "close")
	                    ]
	                  })
	            ],
	            2
	          )
	        ]
	      ),
	      _c("div", { staticClass: "el-step__main" }, [
	        _c(
	          "div",
	          {
	            ref: "title",
	            staticClass: "el-step__title",
	            class: ["is-" + _vm.currentStatus]
	          },
	          [_vm._t("title", [_vm._v(_vm._s(_vm.title))])],
	          2
	        ),
	        _vm.isSimple
	          ? _c("div", { staticClass: "el-step__arrow" })
	          : _c(
	              "div",
	              {
	                staticClass: "el-step__description",
	                class: ["is-" + _vm.currentStatus]
	              },
	              [_vm._t("description", [_vm._v(_vm._s(_vm.description))])],
	              2
	            )
	      ])
	    ]
	  )
	}
	var stepvue_type_template_id_f414a87a_staticRenderFns = []
	stepvue_type_template_id_f414a87a_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/steps/src/step.vue?vue&type=template&id=f414a87a&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/steps/src/step.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var stepvue_type_script_lang_js_ = ({
	  name: 'ElStep',
	
	  props: {
	    title: String,
	    icon: String,
	    description: String,
	    status: String
	  },
	
	  data: function data() {
	    return {
	      index: -1,
	      lineStyle: {},
	      internalStatus: ''
	    };
	  },
	  beforeCreate: function beforeCreate() {
	    this.$parent.steps.push(this);
	  },
	  beforeDestroy: function beforeDestroy() {
	    var steps = this.$parent.steps;
	    var index = steps.indexOf(this);
	    if (index >= 0) {
	      steps.splice(index, 1);
	    }
	  },
	
	
	  computed: {
	    currentStatus: function currentStatus() {
	      return this.status || this.internalStatus;
	    },
	    prevStatus: function prevStatus() {
	      var prevStep = this.$parent.steps[this.index - 1];
	      return prevStep ? prevStep.currentStatus : 'wait';
	    },
	    isCenter: function isCenter() {
	      return this.$parent.alignCenter;
	    },
	    isVertical: function isVertical() {
	      return this.$parent.direction === 'vertical';
	    },
	    isSimple: function isSimple() {
	      return this.$parent.simple;
	    },
	    isLast: function isLast() {
	      var parent = this.$parent;
	      return parent.steps[parent.steps.length - 1] === this;
	    },
	    stepsCount: function stepsCount() {
	      return this.$parent.steps.length;
	    },
	    space: function space() {
	      var isSimple = this.isSimple,
	          space = this.$parent.space;
	
	      return isSimple ? '' : space;
	    },
	
	    style: function style() {
	      var style = {};
	      var parent = this.$parent;
	      var len = parent.steps.length;
	
	      var space = typeof this.space === 'number' ? this.space + 'px' : this.space ? this.space : 100 / (len - (this.isCenter ? 0 : 1)) + '%';
	      style.flexBasis = space;
	      if (this.isVertical) return style;
	      if (this.isLast) {
	        style.maxWidth = 100 / this.stepsCount + '%';
	      } else {
	        style.marginRight = -this.$parent.stepOffset + 'px';
	      }
	
	      return style;
	    }
	  },
	
	  methods: {
	    updateStatus: function updateStatus(val) {
	      var prevChild = this.$parent.$children[this.index - 1];
	
	      if (val > this.index) {
	        this.internalStatus = this.$parent.finishStatus;
	      } else if (val === this.index && this.prevStatus !== 'error') {
	        this.internalStatus = this.$parent.processStatus;
	      } else {
	        this.internalStatus = 'wait';
	      }
	
	      if (prevChild) prevChild.calcProgress(this.internalStatus);
	    },
	    calcProgress: function calcProgress(status) {
	      var step = 100;
	      var style = {};
	
	      style.transitionDelay = 150 * this.index + 'ms';
	      if (status === this.$parent.processStatus) {
	        step = this.currentStatus !== 'error' ? 0 : 0;
	      } else if (status === 'wait') {
	        step = 0;
	        style.transitionDelay = -150 * this.index + 'ms';
	      }
	
	      style.borderWidth = step && !this.isSimple ? '1px' : 0;
	      this.$parent.direction === 'vertical' ? style.height = step + '%' : style.width = step + '%';
	
	      this.lineStyle = style;
	    }
	  },
	
	  mounted: function mounted() {
	    var _this = this;
	
	    var unwatch = this.$watch('index', function (val) {
	      _this.$watch('$parent.active', _this.updateStatus, { immediate: true });
	      _this.$watch('$parent.processStatus', function () {
	        var activeIndex = _this.$parent.active;
	        _this.updateStatus(activeIndex);
	      }, { immediate: true });
	      unwatch();
	    });
	  }
	});
	// CONCATENATED MODULE: ./packages/steps/src/step.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_stepvue_type_script_lang_js_ = (stepvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/steps/src/step.vue
	
	
	
	
	
	/* normalize component */
	
	var step_component = normalizeComponent(
	  src_stepvue_type_script_lang_js_,
	  stepvue_type_template_id_f414a87a_render,
	  stepvue_type_template_id_f414a87a_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var step_api; }
	step_component.options.__file = "packages/steps/src/step.vue"
	/* harmony default export */ var step = (step_component.exports);
	// CONCATENATED MODULE: ./packages/step/index.js
	
	
	/* istanbul ignore next */
	step.install = function (Vue) {
	  Vue.component(step.name, step);
	};
	
	/* harmony default export */ var packages_step = (step);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/carousel/src/main.vue?vue&type=template&id=5d5d1482&
	var mainvue_type_template_id_5d5d1482_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      class: _vm.carouselClasses,
	      on: {
	        mouseenter: function($event) {
	          $event.stopPropagation()
	          return _vm.handleMouseEnter($event)
	        },
	        mouseleave: function($event) {
	          $event.stopPropagation()
	          return _vm.handleMouseLeave($event)
	        }
	      }
	    },
	    [
	      _c(
	        "div",
	        {
	          staticClass: "el-carousel__container",
	          style: { height: _vm.height }
	        },
	        [
	          _vm.arrowDisplay
	            ? _c("transition", { attrs: { name: "carousel-arrow-left" } }, [
	                _c(
	                  "button",
	                  {
	                    directives: [
	                      {
	                        name: "show",
	                        rawName: "v-show",
	                        value:
	                          (_vm.arrow === "always" || _vm.hover) &&
	                          (_vm.loop || _vm.activeIndex > 0),
	                        expression:
	                          "(arrow === 'always' || hover) && (loop || activeIndex > 0)"
	                      }
	                    ],
	                    staticClass: "el-carousel__arrow el-carousel__arrow--left",
	                    attrs: { type: "button" },
	                    on: {
	                      mouseenter: function($event) {
	                        _vm.handleButtonEnter("left")
	                      },
	                      mouseleave: _vm.handleButtonLeave,
	                      click: function($event) {
	                        $event.stopPropagation()
	                        _vm.throttledArrowClick(_vm.activeIndex - 1)
	                      }
	                    }
	                  },
	                  [_c("i", { staticClass: "el-icon-arrow-left" })]
	                )
	              ])
	            : _vm._e(),
	          _vm.arrowDisplay
	            ? _c("transition", { attrs: { name: "carousel-arrow-right" } }, [
	                _c(
	                  "button",
	                  {
	                    directives: [
	                      {
	                        name: "show",
	                        rawName: "v-show",
	                        value:
	                          (_vm.arrow === "always" || _vm.hover) &&
	                          (_vm.loop || _vm.activeIndex < _vm.items.length - 1),
	                        expression:
	                          "(arrow === 'always' || hover) && (loop || activeIndex < items.length - 1)"
	                      }
	                    ],
	                    staticClass: "el-carousel__arrow el-carousel__arrow--right",
	                    attrs: { type: "button" },
	                    on: {
	                      mouseenter: function($event) {
	                        _vm.handleButtonEnter("right")
	                      },
	                      mouseleave: _vm.handleButtonLeave,
	                      click: function($event) {
	                        $event.stopPropagation()
	                        _vm.throttledArrowClick(_vm.activeIndex + 1)
	                      }
	                    }
	                  },
	                  [_c("i", { staticClass: "el-icon-arrow-right" })]
	                )
	              ])
	            : _vm._e(),
	          _vm._t("default")
	        ],
	        2
	      ),
	      _vm.indicatorPosition !== "none"
	        ? _c(
	            "ul",
	            { class: _vm.indicatorsClasses },
	            _vm._l(_vm.items, function(item, index) {
	              return _c(
	                "li",
	                {
	                  key: index,
	                  class: [
	                    "el-carousel__indicator",
	                    "el-carousel__indicator--" + _vm.direction,
	                    { "is-active": index === _vm.activeIndex }
	                  ],
	                  on: {
	                    mouseenter: function($event) {
	                      _vm.throttledIndicatorHover(index)
	                    },
	                    click: function($event) {
	                      $event.stopPropagation()
	                      _vm.handleIndicatorClick(index)
	                    }
	                  }
	                },
	                [
	                  _c("button", { staticClass: "el-carousel__button" }, [
	                    _vm.hasLabel
	                      ? _c("span", [_vm._v(_vm._s(item.label))])
	                      : _vm._e()
	                  ])
	                ]
	              )
	            }),
	            0
	          )
	        : _vm._e()
	    ]
	  )
	}
	var mainvue_type_template_id_5d5d1482_staticRenderFns = []
	mainvue_type_template_id_5d5d1482_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/carousel/src/main.vue?vue&type=template&id=5d5d1482&
	
	// EXTERNAL MODULE: external "throttle-debounce/throttle"
	var throttle_ = __webpack_require__(25);
	var throttle_default = /*#__PURE__*/__webpack_require__.n(throttle_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/carousel/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	/* harmony default export */ var carousel_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElCarousel',
	
	  props: {
	    initialIndex: {
	      type: Number,
	      default: 0
	    },
	    height: String,
	    trigger: {
	      type: String,
	      default: 'hover'
	    },
	    autoplay: {
	      type: Boolean,
	      default: true
	    },
	    interval: {
	      type: Number,
	      default: 3000
	    },
	    indicatorPosition: String,
	    indicator: {
	      type: Boolean,
	      default: true
	    },
	    arrow: {
	      type: String,
	      default: 'hover'
	    },
	    type: String,
	    loop: {
	      type: Boolean,
	      default: true
	    },
	    direction: {
	      type: String,
	      default: 'horizontal',
	      validator: function validator(val) {
	        return ['horizontal', 'vertical'].indexOf(val) !== -1;
	      }
	    }
	  },
	
	  data: function data() {
	    return {
	      items: [],
	      activeIndex: -1,
	      containerWidth: 0,
	      timer: null,
	      hover: false
	    };
	  },
	
	
	  computed: {
	    arrowDisplay: function arrowDisplay() {
	      return this.arrow !== 'never' && this.direction !== 'vertical';
	    },
	    hasLabel: function hasLabel() {
	      return this.items.some(function (item) {
	        return item.label.toString().length > 0;
	      });
	    },
	    carouselClasses: function carouselClasses() {
	      var classes = ['el-carousel', 'el-carousel--' + this.direction];
	      if (this.type === 'card') {
	        classes.push('el-carousel--card');
	      }
	      return classes;
	    },
	    indicatorsClasses: function indicatorsClasses() {
	      var classes = ['el-carousel__indicators', 'el-carousel__indicators--' + this.direction];
	      if (this.hasLabel) {
	        classes.push('el-carousel__indicators--labels');
	      }
	      if (this.indicatorPosition === 'outside' || this.type === 'card') {
	        classes.push('el-carousel__indicators--outside');
	      }
	      return classes;
	    }
	  },
	
	  watch: {
	    items: function items(val) {
	      if (val.length > 0) this.setActiveItem(this.initialIndex);
	    },
	    activeIndex: function activeIndex(val, oldVal) {
	      this.resetItemPosition(oldVal);
	      if (oldVal > -1) {
	        this.$emit('change', val, oldVal);
	      }
	    },
	    autoplay: function autoplay(val) {
	      val ? this.startTimer() : this.pauseTimer();
	    },
	    loop: function loop() {
	      this.setActiveItem(this.activeIndex);
	    }
	  },
	
	  methods: {
	    handleMouseEnter: function handleMouseEnter() {
	      this.hover = true;
	      this.pauseTimer();
	    },
	    handleMouseLeave: function handleMouseLeave() {
	      this.hover = false;
	      this.startTimer();
	    },
	    itemInStage: function itemInStage(item, index) {
	      var length = this.items.length;
	      if (index === length - 1 && item.inStage && this.items[0].active || item.inStage && this.items[index + 1] && this.items[index + 1].active) {
	        return 'left';
	      } else if (index === 0 && item.inStage && this.items[length - 1].active || item.inStage && this.items[index - 1] && this.items[index - 1].active) {
	        return 'right';
	      }
	      return false;
	    },
	    handleButtonEnter: function handleButtonEnter(arrow) {
	      var _this = this;
	
	      if (this.direction === 'vertical') return;
	      this.items.forEach(function (item, index) {
	        if (arrow === _this.itemInStage(item, index)) {
	          item.hover = true;
	        }
	      });
	    },
	    handleButtonLeave: function handleButtonLeave() {
	      if (this.direction === 'vertical') return;
	      this.items.forEach(function (item) {
	        item.hover = false;
	      });
	    },
	    updateItems: function updateItems() {
	      this.items = this.$children.filter(function (child) {
	        return child.$options.name === 'ElCarouselItem';
	      });
	    },
	    resetItemPosition: function resetItemPosition(oldIndex) {
	      var _this2 = this;
	
	      this.items.forEach(function (item, index) {
	        item.translateItem(index, _this2.activeIndex, oldIndex);
	      });
	    },
	    playSlides: function playSlides() {
	      if (this.activeIndex < this.items.length - 1) {
	        this.activeIndex++;
	      } else if (this.loop) {
	        this.activeIndex = 0;
	      }
	    },
	    pauseTimer: function pauseTimer() {
	      if (this.timer) {
	        clearInterval(this.timer);
	        this.timer = null;
	      }
	    },
	    startTimer: function startTimer() {
	      if (this.interval <= 0 || !this.autoplay || this.timer) return;
	      this.timer = setInterval(this.playSlides, this.interval);
	    },
	    setActiveItem: function setActiveItem(index) {
	      if (typeof index === 'string') {
	        var filteredItems = this.items.filter(function (item) {
	          return item.name === index;
	        });
	        if (filteredItems.length > 0) {
	          index = this.items.indexOf(filteredItems[0]);
	        }
	      }
	      index = Number(index);
	      if (isNaN(index) || index !== Math.floor(index)) {
	        console.warn('[Element Warn][Carousel]index must be an integer.');
	        return;
	      }
	      var length = this.items.length;
	      var oldIndex = this.activeIndex;
	      if (index < 0) {
	        this.activeIndex = this.loop ? length - 1 : 0;
	      } else if (index >= length) {
	        this.activeIndex = this.loop ? 0 : length - 1;
	      } else {
	        this.activeIndex = index;
	      }
	      if (oldIndex === this.activeIndex) {
	        this.resetItemPosition(oldIndex);
	      }
	    },
	    prev: function prev() {
	      this.setActiveItem(this.activeIndex - 1);
	    },
	    next: function next() {
	      this.setActiveItem(this.activeIndex + 1);
	    },
	    handleIndicatorClick: function handleIndicatorClick(index) {
	      this.activeIndex = index;
	    },
	    handleIndicatorHover: function handleIndicatorHover(index) {
	      if (this.trigger === 'hover' && index !== this.activeIndex) {
	        this.activeIndex = index;
	      }
	    }
	  },
	
	  created: function created() {
	    var _this3 = this;
	
	    this.throttledArrowClick = throttle_default()(300, true, function (index) {
	      _this3.setActiveItem(index);
	    });
	    this.throttledIndicatorHover = throttle_default()(300, function (index) {
	      _this3.handleIndicatorHover(index);
	    });
	  },
	  mounted: function mounted() {
	    var _this4 = this;
	
	    this.updateItems();
	    this.$nextTick(function () {
	      Object(resize_event_["addResizeListener"])(_this4.$el, _this4.resetItemPosition);
	      if (_this4.initialIndex < _this4.items.length && _this4.initialIndex >= 0) {
	        _this4.activeIndex = _this4.initialIndex;
	      }
	      _this4.startTimer();
	    });
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this.$el) Object(resize_event_["removeResizeListener"])(this.$el, this.resetItemPosition);
	    this.pauseTimer();
	  }
	});
	// CONCATENATED MODULE: ./packages/carousel/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_carousel_src_mainvue_type_script_lang_js_ = (carousel_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/carousel/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var carousel_src_main_component = normalizeComponent(
	  packages_carousel_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_5d5d1482_render,
	  mainvue_type_template_id_5d5d1482_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var carousel_src_main_api; }
	carousel_src_main_component.options.__file = "packages/carousel/src/main.vue"
	/* harmony default export */ var carousel_src_main = (carousel_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/carousel/index.js
	
	
	/* istanbul ignore next */
	carousel_src_main.install = function (Vue) {
	  Vue.component(carousel_src_main.name, carousel_src_main);
	};
	
	/* harmony default export */ var carousel = (carousel_src_main);
	// CONCATENATED MODULE: ./packages/scrollbar/src/util.js
	var BAR_MAP = {
	  vertical: {
	    offset: 'offsetHeight',
	    scroll: 'scrollTop',
	    scrollSize: 'scrollHeight',
	    size: 'height',
	    key: 'vertical',
	    axis: 'Y',
	    client: 'clientY',
	    direction: 'top'
	  },
	  horizontal: {
	    offset: 'offsetWidth',
	    scroll: 'scrollLeft',
	    scrollSize: 'scrollWidth',
	    size: 'width',
	    key: 'horizontal',
	    axis: 'X',
	    client: 'clientX',
	    direction: 'left'
	  }
	};
	
	function renderThumbStyle(_ref) {
	  var move = _ref.move,
	      size = _ref.size,
	      bar = _ref.bar;
	
	  var style = {};
	  var translate = 'translate' + bar.axis + '(' + move + '%)';
	
	  style[bar.size] = size;
	  style.transform = translate;
	  style.msTransform = translate;
	  style.webkitTransform = translate;
	
	  return style;
	};
	// CONCATENATED MODULE: ./packages/scrollbar/src/bar.js
	
	
	
	/* istanbul ignore next */
	/* harmony default export */ var src_bar = ({
	  name: 'Bar',
	
	  props: {
	    vertical: Boolean,
	    size: String,
	    move: Number
	  },
	
	  computed: {
	    bar: function bar() {
	      return BAR_MAP[this.vertical ? 'vertical' : 'horizontal'];
	    },
	    wrap: function wrap() {
	      return this.$parent.wrap;
	    }
	  },
	
	  render: function render(h) {
	    var size = this.size,
	        move = this.move,
	        bar = this.bar;
	
	
	    return h(
	      'div',
	      {
	        'class': ['el-scrollbar__bar', 'is-' + bar.key],
	        on: {
	          'mousedown': this.clickTrackHandler
	        }
	      },
	      [h('div', {
	        ref: 'thumb',
	        'class': 'el-scrollbar__thumb',
	        on: {
	          'mousedown': this.clickThumbHandler
	        },
	
	        style: renderThumbStyle({ size: size, move: move, bar: bar }) })]
	    );
	  },
	
	
	  methods: {
	    clickThumbHandler: function clickThumbHandler(e) {
	      // prevent click event of right button
	      if (e.ctrlKey || e.button === 2) {
	        return;
	      }
	      this.startDrag(e);
	      this[this.bar.axis] = e.currentTarget[this.bar.offset] - (e[this.bar.client] - e.currentTarget.getBoundingClientRect()[this.bar.direction]);
	    },
	    clickTrackHandler: function clickTrackHandler(e) {
	      var offset = Math.abs(e.target.getBoundingClientRect()[this.bar.direction] - e[this.bar.client]);
	      var thumbHalf = this.$refs.thumb[this.bar.offset] / 2;
	      var thumbPositionPercentage = (offset - thumbHalf) * 100 / this.$el[this.bar.offset];
	
	      this.wrap[this.bar.scroll] = thumbPositionPercentage * this.wrap[this.bar.scrollSize] / 100;
	    },
	    startDrag: function startDrag(e) {
	      e.stopImmediatePropagation();
	      this.cursorDown = true;
	
	      Object(dom_["on"])(document, 'mousemove', this.mouseMoveDocumentHandler);
	      Object(dom_["on"])(document, 'mouseup', this.mouseUpDocumentHandler);
	      document.onselectstart = function () {
	        return false;
	      };
	    },
	    mouseMoveDocumentHandler: function mouseMoveDocumentHandler(e) {
	      if (this.cursorDown === false) return;
	      var prevPage = this[this.bar.axis];
	
	      if (!prevPage) return;
	
	      var offset = (this.$el.getBoundingClientRect()[this.bar.direction] - e[this.bar.client]) * -1;
	      var thumbClickPosition = this.$refs.thumb[this.bar.offset] - prevPage;
	      var thumbPositionPercentage = (offset - thumbClickPosition) * 100 / this.$el[this.bar.offset];
	
	      this.wrap[this.bar.scroll] = thumbPositionPercentage * this.wrap[this.bar.scrollSize] / 100;
	    },
	    mouseUpDocumentHandler: function mouseUpDocumentHandler(e) {
	      this.cursorDown = false;
	      this[this.bar.axis] = 0;
	      Object(dom_["off"])(document, 'mousemove', this.mouseMoveDocumentHandler);
	      document.onselectstart = null;
	    }
	  },
	
	  destroyed: function destroyed() {
	    Object(dom_["off"])(document, 'mouseup', this.mouseUpDocumentHandler);
	  }
	});
	// CONCATENATED MODULE: ./packages/scrollbar/src/main.js
	// reference https://github.com/noeldelgado/gemini-scrollbar/blob/master/index.js
	
	
	
	
	
	
	/* istanbul ignore next */
	/* harmony default export */ var scrollbar_src_main = ({
	  name: 'ElScrollbar',
	
	  components: { Bar: src_bar },
	
	  props: {
	    native: Boolean,
	    wrapStyle: {},
	    wrapClass: {},
	    viewClass: {},
	    viewStyle: {},
	    noresize: Boolean, // 如果 container 尺寸不会发生变化，最好设置它可以优化性能
	    tag: {
	      type: String,
	      default: 'div'
	    }
	  },
	
	  data: function data() {
	    return {
	      sizeWidth: '0',
	      sizeHeight: '0',
	      moveX: 0,
	      moveY: 0
	    };
	  },
	
	
	  computed: {
	    wrap: function wrap() {
	      return this.$refs.wrap;
	    }
	  },
	
	  render: function render(h) {
	    var gutter = scrollbar_width_default()();
	    var style = this.wrapStyle;
	
	    if (gutter) {
	      var gutterWith = '-' + gutter + 'px';
	      var gutterStyle = 'margin-bottom: ' + gutterWith + '; margin-right: ' + gutterWith + ';';
	
	      if (Array.isArray(this.wrapStyle)) {
	        style = Object(util_["toObject"])(this.wrapStyle);
	        style.marginRight = style.marginBottom = gutterWith;
	      } else if (typeof this.wrapStyle === 'string') {
	        style += gutterStyle;
	      } else {
	        style = gutterStyle;
	      }
	    }
	    var view = h(this.tag, {
	      class: ['el-scrollbar__view', this.viewClass],
	      style: this.viewStyle,
	      ref: 'resize'
	    }, this.$slots.default);
	    var wrap = h(
	      'div',
	      {
	        ref: 'wrap',
	        style: style,
	        on: {
	          'scroll': this.handleScroll
	        },
	
	        'class': [this.wrapClass, 'el-scrollbar__wrap', gutter ? '' : 'el-scrollbar__wrap--hidden-default'] },
	      [[view]]
	    );
	    var nodes = void 0;
	
	    if (!this.native) {
	      nodes = [wrap, h(src_bar, {
	        attrs: {
	          move: this.moveX,
	          size: this.sizeWidth }
	      }), h(src_bar, {
	        attrs: {
	          vertical: true,
	          move: this.moveY,
	          size: this.sizeHeight }
	      })];
	    } else {
	      nodes = [h(
	        'div',
	        {
	          ref: 'wrap',
	          'class': [this.wrapClass, 'el-scrollbar__wrap'],
	          style: style },
	        [[view]]
	      )];
	    }
	    return h('div', { class: 'el-scrollbar' }, nodes);
	  },
	
	
	  methods: {
	    handleScroll: function handleScroll() {
	      var wrap = this.wrap;
	
	      this.moveY = wrap.scrollTop * 100 / wrap.clientHeight;
	      this.moveX = wrap.scrollLeft * 100 / wrap.clientWidth;
	    },
	    update: function update() {
	      var heightPercentage = void 0,
	          widthPercentage = void 0;
	      var wrap = this.wrap;
	      if (!wrap) return;
	
	      heightPercentage = wrap.clientHeight * 100 / wrap.scrollHeight;
	      widthPercentage = wrap.clientWidth * 100 / wrap.scrollWidth;
	
	      this.sizeHeight = heightPercentage < 100 ? heightPercentage + '%' : '';
	      this.sizeWidth = widthPercentage < 100 ? widthPercentage + '%' : '';
	    }
	  },
	
	  mounted: function mounted() {
	    if (this.native) return;
	    this.$nextTick(this.update);
	    !this.noresize && Object(resize_event_["addResizeListener"])(this.$refs.resize, this.update);
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this.native) return;
	    !this.noresize && Object(resize_event_["removeResizeListener"])(this.$refs.resize, this.update);
	  }
	});
	// CONCATENATED MODULE: ./packages/scrollbar/index.js
	
	
	/* istanbul ignore next */
	scrollbar_src_main.install = function (Vue) {
	  Vue.component(scrollbar_src_main.name, scrollbar_src_main);
	};
	
	/* harmony default export */ var scrollbar = (scrollbar_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/carousel/src/item.vue?vue&type=template&id=1801ae19&
	var itemvue_type_template_id_1801ae19_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      directives: [
	        {
	          name: "show",
	          rawName: "v-show",
	          value: _vm.ready,
	          expression: "ready"
	        }
	      ],
	      staticClass: "el-carousel__item",
	      class: {
	        "is-active": _vm.active,
	        "el-carousel__item--card": _vm.$parent.type === "card",
	        "is-in-stage": _vm.inStage,
	        "is-hover": _vm.hover,
	        "is-animating": _vm.animating
	      },
	      style: _vm.itemStyle,
	      on: { click: _vm.handleItemClick }
	    },
	    [
	      _vm.$parent.type === "card"
	        ? _c("div", {
	            directives: [
	              {
	                name: "show",
	                rawName: "v-show",
	                value: !_vm.active,
	                expression: "!active"
	              }
	            ],
	            staticClass: "el-carousel__mask"
	          })
	        : _vm._e(),
	      _vm._t("default")
	    ],
	    2
	  )
	}
	var itemvue_type_template_id_1801ae19_staticRenderFns = []
	itemvue_type_template_id_1801ae19_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/carousel/src/item.vue?vue&type=template&id=1801ae19&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/carousel/src/item.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	var CARD_SCALE = 0.83;
	/* harmony default export */ var itemvue_type_script_lang_js_ = ({
	  name: 'ElCarouselItem',
	
	  props: {
	    name: String,
	    label: {
	      type: [String, Number],
	      default: ''
	    }
	  },
	
	  data: function data() {
	    return {
	      hover: false,
	      translate: 0,
	      scale: 1,
	      active: false,
	      ready: false,
	      inStage: false,
	      animating: false
	    };
	  },
	
	
	  methods: {
	    processIndex: function processIndex(index, activeIndex, length) {
	      if (activeIndex === 0 && index === length - 1) {
	        return -1;
	      } else if (activeIndex === length - 1 && index === 0) {
	        return length;
	      } else if (index < activeIndex - 1 && activeIndex - index >= length / 2) {
	        return length + 1;
	      } else if (index > activeIndex + 1 && index - activeIndex >= length / 2) {
	        return -2;
	      }
	      return index;
	    },
	    calcCardTranslate: function calcCardTranslate(index, activeIndex) {
	      var parentWidth = this.$parent.$el.offsetWidth;
	      if (this.inStage) {
	        return parentWidth * ((2 - CARD_SCALE) * (index - activeIndex) + 1) / 4;
	      } else if (index < activeIndex) {
	        return -(1 + CARD_SCALE) * parentWidth / 4;
	      } else {
	        return (3 + CARD_SCALE) * parentWidth / 4;
	      }
	    },
	    calcTranslate: function calcTranslate(index, activeIndex, isVertical) {
	      var distance = this.$parent.$el[isVertical ? 'offsetHeight' : 'offsetWidth'];
	      return distance * (index - activeIndex);
	    },
	    translateItem: function translateItem(index, activeIndex, oldIndex) {
	      var parentType = this.$parent.type;
	      var parentDirection = this.parentDirection;
	      var length = this.$parent.items.length;
	      if (parentType !== 'card' && oldIndex !== undefined) {
	        this.animating = index === activeIndex || index === oldIndex;
	      }
	      if (index !== activeIndex && length > 2 && this.$parent.loop) {
	        index = this.processIndex(index, activeIndex, length);
	      }
	      if (parentType === 'card') {
	        if (parentDirection === 'vertical') {
	          console.warn('[Element Warn][Carousel]vertical directionis not supported in card mode');
	        }
	        this.inStage = Math.round(Math.abs(index - activeIndex)) <= 1;
	        this.active = index === activeIndex;
	        this.translate = this.calcCardTranslate(index, activeIndex);
	        this.scale = this.active ? 1 : CARD_SCALE;
	      } else {
	        this.active = index === activeIndex;
	        var isVertical = parentDirection === 'vertical';
	        this.translate = this.calcTranslate(index, activeIndex, isVertical);
	      }
	      this.ready = true;
	    },
	    handleItemClick: function handleItemClick() {
	      var parent = this.$parent;
	      if (parent && parent.type === 'card') {
	        var index = parent.items.indexOf(this);
	        parent.setActiveItem(index);
	      }
	    }
	  },
	
	  computed: {
	    parentDirection: function parentDirection() {
	      return this.$parent.direction;
	    },
	    itemStyle: function itemStyle() {
	      var translateType = this.parentDirection === 'vertical' ? 'translateY' : 'translateX';
	      var value = translateType + '(' + this.translate + 'px) scale(' + this.scale + ')';
	      var style = {
	        transform: value
	      };
	      return Object(util_["autoprefixer"])(style);
	    }
	  },
	
	  created: function created() {
	    this.$parent && this.$parent.updateItems();
	  },
	  destroyed: function destroyed() {
	    this.$parent && this.$parent.updateItems();
	  }
	});
	// CONCATENATED MODULE: ./packages/carousel/src/item.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_itemvue_type_script_lang_js_ = (itemvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/carousel/src/item.vue
	
	
	
	
	
	/* normalize component */
	
	var item_component = normalizeComponent(
	  src_itemvue_type_script_lang_js_,
	  itemvue_type_template_id_1801ae19_render,
	  itemvue_type_template_id_1801ae19_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var item_api; }
	item_component.options.__file = "packages/carousel/src/item.vue"
	/* harmony default export */ var src_item = (item_component.exports);
	// CONCATENATED MODULE: ./packages/carousel-item/index.js
	
	
	/* istanbul ignore next */
	src_item.install = function (Vue) {
	  Vue.component(src_item.name, src_item);
	};
	
	/* harmony default export */ var carousel_item = (src_item);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/collapse/src/collapse.vue?vue&type=template&id=461d57f4&
	var collapsevue_type_template_id_461d57f4_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-collapse",
	      attrs: { role: "tablist", "aria-multiselectable": "true" }
	    },
	    [_vm._t("default")],
	    2
	  )
	}
	var collapsevue_type_template_id_461d57f4_staticRenderFns = []
	collapsevue_type_template_id_461d57f4_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/collapse/src/collapse.vue?vue&type=template&id=461d57f4&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/collapse/src/collapse.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	
	/* harmony default export */ var collapsevue_type_script_lang_js_ = ({
	  name: 'ElCollapse',
	
	  componentName: 'ElCollapse',
	
	  props: {
	    accordion: Boolean,
	    value: {
	      type: [Array, String, Number],
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	
	  data: function data() {
	    return {
	      activeNames: [].concat(this.value)
	    };
	  },
	  provide: function provide() {
	    return {
	      collapse: this
	    };
	  },
	
	
	  watch: {
	    value: function value(_value) {
	      this.activeNames = [].concat(_value);
	    }
	  },
	
	  methods: {
	    setActiveNames: function setActiveNames(activeNames) {
	      activeNames = [].concat(activeNames);
	      var value = this.accordion ? activeNames[0] : activeNames;
	      this.activeNames = activeNames;
	      this.$emit('input', value);
	      this.$emit('change', value);
	    },
	    handleItemClick: function handleItemClick(item) {
	      if (this.accordion) {
	        this.setActiveNames((this.activeNames[0] || this.activeNames[0] === 0) && this.activeNames[0] === item.name ? '' : item.name);
	      } else {
	        var activeNames = this.activeNames.slice(0);
	        var index = activeNames.indexOf(item.name);
	
	        if (index > -1) {
	          activeNames.splice(index, 1);
	        } else {
	          activeNames.push(item.name);
	        }
	        this.setActiveNames(activeNames);
	      }
	    }
	  },
	
	  created: function created() {
	    this.$on('item-click', this.handleItemClick);
	  }
	});
	// CONCATENATED MODULE: ./packages/collapse/src/collapse.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_collapsevue_type_script_lang_js_ = (collapsevue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/collapse/src/collapse.vue
	
	
	
	
	
	/* normalize component */
	
	var collapse_component = normalizeComponent(
	  src_collapsevue_type_script_lang_js_,
	  collapsevue_type_template_id_461d57f4_render,
	  collapsevue_type_template_id_461d57f4_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var collapse_api; }
	collapse_component.options.__file = "packages/collapse/src/collapse.vue"
	/* harmony default export */ var collapse = (collapse_component.exports);
	// CONCATENATED MODULE: ./packages/collapse/index.js
	
	
	/* istanbul ignore next */
	collapse.install = function (Vue) {
	  Vue.component(collapse.name, collapse);
	};
	
	/* harmony default export */ var packages_collapse = (collapse);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/collapse/src/collapse-item.vue?vue&type=template&id=2d05faac&
	var collapse_itemvue_type_template_id_2d05faac_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-collapse-item",
	      class: { "is-active": _vm.isActive, "is-disabled": _vm.disabled }
	    },
	    [
	      _c(
	        "div",
	        {
	          attrs: {
	            role: "tab",
	            "aria-expanded": _vm.isActive,
	            "aria-controls": "el-collapse-content-" + _vm.id,
	            "aria-describedby": "el-collapse-content-" + _vm.id
	          }
	        },
	        [
	          _c(
	            "div",
	            {
	              staticClass: "el-collapse-item__header",
	              class: {
	                focusing: _vm.focusing,
	                "is-active": _vm.isActive
	              },
	              attrs: {
	                role: "button",
	                id: "el-collapse-head-" + _vm.id,
	                tabindex: _vm.disabled ? undefined : 0
	              },
	              on: {
	                click: _vm.handleHeaderClick,
	                keyup: function($event) {
	                  if (
	                    !("button" in $event) &&
	                    _vm._k($event.keyCode, "space", 32, $event.key, [
	                      " ",
	                      "Spacebar"
	                    ]) &&
	                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
	                  ) {
	                    return null
	                  }
	                  $event.stopPropagation()
	                  return _vm.handleEnterClick($event)
	                },
	                focus: _vm.handleFocus,
	                blur: function($event) {
	                  _vm.focusing = false
	                }
	              }
	            },
	            [
	              _vm._t("title", [_vm._v(_vm._s(_vm.title))]),
	              _c("i", {
	                staticClass: "el-collapse-item__arrow el-icon-arrow-right",
	                class: { "is-active": _vm.isActive }
	              })
	            ],
	            2
	          )
	        ]
	      ),
	      _c("el-collapse-transition", [
	        _c(
	          "div",
	          {
	            directives: [
	              {
	                name: "show",
	                rawName: "v-show",
	                value: _vm.isActive,
	                expression: "isActive"
	              }
	            ],
	            staticClass: "el-collapse-item__wrap",
	            attrs: {
	              role: "tabpanel",
	              "aria-hidden": !_vm.isActive,
	              "aria-labelledby": "el-collapse-head-" + _vm.id,
	              id: "el-collapse-content-" + _vm.id
	            }
	          },
	          [
	            _c(
	              "div",
	              { staticClass: "el-collapse-item__content" },
	              [_vm._t("default")],
	              2
	            )
	          ]
	        )
	      ])
	    ],
	    1
	  )
	}
	var collapse_itemvue_type_template_id_2d05faac_staticRenderFns = []
	collapse_itemvue_type_template_id_2d05faac_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/collapse/src/collapse-item.vue?vue&type=template&id=2d05faac&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/collapse/src/collapse-item.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	/* harmony default export */ var collapse_itemvue_type_script_lang_js_ = ({
	  name: 'ElCollapseItem',
	
	  componentName: 'ElCollapseItem',
	
	  mixins: [emitter_default.a],
	
	  components: { ElCollapseTransition: collapse_transition_default.a },
	
	  data: function data() {
	    return {
	      contentWrapStyle: {
	        height: 'auto',
	        display: 'block'
	      },
	      contentHeight: 0,
	      focusing: false,
	      isClick: false,
	      id: Object(util_["generateId"])()
	    };
	  },
	
	
	  inject: ['collapse'],
	
	  props: {
	    title: String,
	    name: {
	      type: [String, Number],
	      default: function _default() {
	        return this._uid;
	      }
	    },
	    disabled: Boolean
	  },
	
	  computed: {
	    isActive: function isActive() {
	      return this.collapse.activeNames.indexOf(this.name) > -1;
	    }
	  },
	
	  methods: {
	    handleFocus: function handleFocus() {
	      var _this = this;
	
	      setTimeout(function () {
	        if (!_this.isClick) {
	          _this.focusing = true;
	        } else {
	          _this.isClick = false;
	        }
	      }, 50);
	    },
	    handleHeaderClick: function handleHeaderClick() {
	      if (this.disabled) return;
	      this.dispatch('ElCollapse', 'item-click', this);
	      this.focusing = false;
	      this.isClick = true;
	    },
	    handleEnterClick: function handleEnterClick() {
	      this.dispatch('ElCollapse', 'item-click', this);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/collapse/src/collapse-item.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_collapse_itemvue_type_script_lang_js_ = (collapse_itemvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/collapse/src/collapse-item.vue
	
	
	
	
	
	/* normalize component */
	
	var collapse_item_component = normalizeComponent(
	  src_collapse_itemvue_type_script_lang_js_,
	  collapse_itemvue_type_template_id_2d05faac_render,
	  collapse_itemvue_type_template_id_2d05faac_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var collapse_item_api; }
	collapse_item_component.options.__file = "packages/collapse/src/collapse-item.vue"
	/* harmony default export */ var collapse_item = (collapse_item_component.exports);
	// CONCATENATED MODULE: ./packages/collapse-item/index.js
	
	
	/* istanbul ignore next */
	collapse_item.install = function (Vue) {
	  Vue.component(collapse_item.name, collapse_item);
	};
	
	/* harmony default export */ var packages_collapse_item = (collapse_item);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader/src/cascader.vue?vue&type=template&id=032537a6&
	var cascadervue_type_template_id_032537a6_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      directives: [
	        {
	          name: "clickoutside",
	          rawName: "v-clickoutside",
	          value: function() {
	            return _vm.toggleDropDownVisible(false)
	          },
	          expression: "() => toggleDropDownVisible(false)"
	        }
	      ],
	      ref: "reference",
	      class: [
	        "el-cascader",
	        _vm.realSize && "el-cascader--" + _vm.realSize,
	        { "is-disabled": _vm.isDisabled }
	      ],
	      on: {
	        mouseenter: function($event) {
	          _vm.inputHover = true
	        },
	        mouseleave: function($event) {
	          _vm.inputHover = false
	        },
	        click: function() {
	          return _vm.toggleDropDownVisible(_vm.readonly ? undefined : true)
	        },
	        keydown: _vm.handleKeyDown
	      }
	    },
	    [
	      _c(
	        "el-input",
	        {
	          ref: "input",
	          class: { "is-focus": _vm.dropDownVisible },
	          attrs: {
	            size: _vm.realSize,
	            placeholder: _vm.placeholder,
	            readonly: _vm.readonly,
	            disabled: _vm.isDisabled,
	            "validate-event": false
	          },
	          on: {
	            focus: _vm.handleFocus,
	            blur: _vm.handleBlur,
	            input: _vm.handleInput
	          },
	          model: {
	            value: _vm.multiple ? _vm.presentText : _vm.inputValue,
	            callback: function($$v) {
	              _vm.multiple ? _vm.presentText : (_vm.inputValue = $$v)
	            },
	            expression: "multiple ? presentText : inputValue"
	          }
	        },
	        [
	          _c("template", { slot: "suffix" }, [
	            _vm.clearBtnVisible
	              ? _c("i", {
	                  key: "clear",
	                  staticClass: "el-input__icon el-icon-circle-close",
	                  on: {
	                    click: function($event) {
	                      $event.stopPropagation()
	                      return _vm.handleClear($event)
	                    }
	                  }
	                })
	              : _c("i", {
	                  key: "arrow-down",
	                  class: [
	                    "el-input__icon",
	                    "el-icon-arrow-down",
	                    _vm.dropDownVisible && "is-reverse"
	                  ],
	                  on: {
	                    click: function($event) {
	                      $event.stopPropagation()
	                      _vm.toggleDropDownVisible()
	                    }
	                  }
	                })
	          ])
	        ],
	        2
	      ),
	      _vm.multiple
	        ? _c(
	            "div",
	            { staticClass: "el-cascader__tags" },
	            [
	              _vm._l(_vm.presentTags, function(tag, index) {
	                return _c(
	                  "el-tag",
	                  {
	                    key: tag.key,
	                    attrs: {
	                      type: "info",
	                      size: _vm.tagSize,
	                      hit: tag.hitState,
	                      closable: tag.closable,
	                      "disable-transitions": ""
	                    },
	                    on: {
	                      close: function($event) {
	                        _vm.deleteTag(index)
	                      }
	                    }
	                  },
	                  [_c("span", [_vm._v(_vm._s(tag.text))])]
	                )
	              }),
	              _vm.filterable && !_vm.isDisabled
	                ? _c("input", {
	                    directives: [
	                      {
	                        name: "model",
	                        rawName: "v-model.trim",
	                        value: _vm.inputValue,
	                        expression: "inputValue",
	                        modifiers: { trim: true }
	                      }
	                    ],
	                    staticClass: "el-cascader__search-input",
	                    attrs: {
	                      type: "text",
	                      placeholder: _vm.presentTags.length ? "" : _vm.placeholder
	                    },
	                    domProps: { value: _vm.inputValue },
	                    on: {
	                      input: [
	                        function($event) {
	                          if ($event.target.composing) {
	                            return
	                          }
	                          _vm.inputValue = $event.target.value.trim()
	                        },
	                        function(e) {
	                          return _vm.handleInput(_vm.inputValue, e)
	                        }
	                      ],
	                      click: function($event) {
	                        $event.stopPropagation()
	                        _vm.toggleDropDownVisible(true)
	                      },
	                      keydown: function($event) {
	                        if (
	                          !("button" in $event) &&
	                          _vm._k(
	                            $event.keyCode,
	                            "delete",
	                            [8, 46],
	                            $event.key,
	                            ["Backspace", "Delete", "Del"]
	                          )
	                        ) {
	                          return null
	                        }
	                        return _vm.handleDelete($event)
	                      },
	                      blur: function($event) {
	                        _vm.$forceUpdate()
	                      }
	                    }
	                  })
	                : _vm._e()
	            ],
	            2
	          )
	        : _vm._e(),
	      _c(
	        "transition",
	        {
	          attrs: { name: "el-zoom-in-top" },
	          on: { "after-leave": _vm.handleDropdownLeave }
	        },
	        [
	          _c(
	            "div",
	            {
	              directives: [
	                {
	                  name: "show",
	                  rawName: "v-show",
	                  value: _vm.dropDownVisible,
	                  expression: "dropDownVisible"
	                }
	              ],
	              ref: "popper",
	              class: ["el-popper", "el-cascader__dropdown", _vm.popperClass]
	            },
	            [
	              _c("el-cascader-panel", {
	                directives: [
	                  {
	                    name: "show",
	                    rawName: "v-show",
	                    value: !_vm.filtering,
	                    expression: "!filtering"
	                  }
	                ],
	                ref: "panel",
	                attrs: {
	                  options: _vm.options,
	                  props: _vm.config,
	                  border: false,
	                  "render-label": _vm.$scopedSlots.default
	                },
	                on: {
	                  "expand-change": _vm.handleExpandChange,
	                  close: function($event) {
	                    _vm.toggleDropDownVisible(false)
	                  }
	                },
	                model: {
	                  value: _vm.checkedValue,
	                  callback: function($$v) {
	                    _vm.checkedValue = $$v
	                  },
	                  expression: "checkedValue"
	                }
	              }),
	              _vm.filterable
	                ? _c(
	                    "el-scrollbar",
	                    {
	                      directives: [
	                        {
	                          name: "show",
	                          rawName: "v-show",
	                          value: _vm.filtering,
	                          expression: "filtering"
	                        }
	                      ],
	                      ref: "suggestionPanel",
	                      staticClass: "el-cascader__suggestion-panel",
	                      attrs: {
	                        tag: "ul",
	                        "view-class": "el-cascader__suggestion-list"
	                      },
	                      nativeOn: {
	                        keydown: function($event) {
	                          return _vm.handleSuggestionKeyDown($event)
	                        }
	                      }
	                    },
	                    [
	                      _vm.suggestions.length
	                        ? _vm._l(_vm.suggestions, function(item, index) {
	                            return _c(
	                              "li",
	                              {
	                                key: item.uid,
	                                class: [
	                                  "el-cascader__suggestion-item",
	                                  item.checked && "is-checked"
	                                ],
	                                attrs: { tabindex: -1 },
	                                on: {
	                                  click: function($event) {
	                                    _vm.handleSuggestionClick(index)
	                                  }
	                                }
	                              },
	                              [
	                                _c("span", [_vm._v(_vm._s(item.text))]),
	                                item.checked
	                                  ? _c("i", { staticClass: "el-icon-check" })
	                                  : _vm._e()
	                              ]
	                            )
	                          })
	                        : _vm._t("empty", [
	                            _c(
	                              "li",
	                              { staticClass: "el-cascader__empty-text" },
	                              [_vm._v(_vm._s(_vm.t("el.cascader.noMatch")))]
	                            )
	                          ])
	                    ],
	                    2
	                  )
	                : _vm._e()
	            ],
	            1
	          )
	        ]
	      )
	    ],
	    1
	  )
	}
	var cascadervue_type_template_id_032537a6_staticRenderFns = []
	cascadervue_type_template_id_032537a6_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/cascader/src/cascader.vue?vue&type=template&id=032537a6&
	
	// EXTERNAL MODULE: external "element-ui/lib/cascader-panel"
	var cascader_panel_ = __webpack_require__(42);
	var cascader_panel_default = /*#__PURE__*/__webpack_require__.n(cascader_panel_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/aria-utils"
	var aria_utils_ = __webpack_require__(28);
	var aria_utils_default = /*#__PURE__*/__webpack_require__.n(aria_utils_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader/src/cascader.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var KeyCode = aria_utils_default.a.keys;
	
	var MigratingProps = {
	  expandTrigger: {
	    newProp: 'expandTrigger',
	    type: String
	  },
	  changeOnSelect: {
	    newProp: 'checkStrictly',
	    type: Boolean
	  },
	  hoverThreshold: {
	    newProp: 'hoverThreshold',
	    type: Number
	  }
	};
	
	var PopperMixin = {
	  props: {
	    placement: {
	      type: String,
	      default: 'bottom-start'
	    },
	    appendToBody: vue_popper_default.a.props.appendToBody,
	    visibleArrow: {
	      type: Boolean,
	      default: true
	    },
	    arrowOffset: vue_popper_default.a.props.arrowOffset,
	    offset: vue_popper_default.a.props.offset,
	    boundariesPadding: vue_popper_default.a.props.boundariesPadding,
	    popperOptions: vue_popper_default.a.props.popperOptions
	  },
	  methods: vue_popper_default.a.methods,
	  data: vue_popper_default.a.data,
	  beforeDestroy: vue_popper_default.a.beforeDestroy
	};
	
	var InputSizeMap = {
	  medium: 36,
	  small: 32,
	  mini: 28
	};
	
	/* harmony default export */ var cascadervue_type_script_lang_js_ = ({
	  name: 'ElCascader',
	
	  directives: { Clickoutside: clickoutside_default.a },
	
	  mixins: [PopperMixin, emitter_default.a, locale_default.a, migrating_default.a],
	
	  inject: {
	    elForm: {
	      default: ''
	    },
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  components: {
	    ElInput: input_default.a,
	    ElTag: tag_default.a,
	    ElScrollbar: scrollbar_default.a,
	    ElCascaderPanel: cascader_panel_default.a
	  },
	
	  props: {
	    value: {},
	    options: Array,
	    props: Object,
	    size: String,
	    placeholder: {
	      type: String,
	      default: function _default() {
	        return Object(lib_locale_["t"])('el.cascader.placeholder');
	      }
	    },
	    disabled: Boolean,
	    clearable: Boolean,
	    filterable: Boolean,
	    filterMethod: Function,
	    separator: {
	      type: String,
	      default: ' / '
	    },
	    showAllLevels: {
	      type: Boolean,
	      default: true
	    },
	    collapseTags: Boolean,
	    debounce: {
	      type: Number,
	      default: 300
	    },
	    beforeFilter: {
	      type: Function,
	      default: function _default() {
	        return function () {};
	      }
	    },
	    popperClass: String
	  },
	
	  data: function data() {
	    return {
	      dropDownVisible: false,
	      checkedValue: this.value || null,
	      inputHover: false,
	      inputValue: null,
	      presentText: null,
	      presentTags: [],
	      checkedNodes: [],
	      filtering: false,
	      suggestions: [],
	      inputInitialHeight: 0,
	      pressDeleteCount: 0
	    };
	  },
	
	
	  computed: {
	    realSize: function realSize() {
	      var _elFormItemSize = (this.elFormItem || {}).elFormItemSize;
	      return this.size || _elFormItemSize || (this.$ELEMENT || {}).size;
	    },
	    tagSize: function tagSize() {
	      return ['small', 'mini'].indexOf(this.realSize) > -1 ? 'mini' : 'small';
	    },
	    isDisabled: function isDisabled() {
	      return this.disabled || (this.elForm || {}).disabled;
	    },
	    config: function config() {
	      var config = this.props || {};
	      var $attrs = this.$attrs;
	
	
	      Object.keys(MigratingProps).forEach(function (oldProp) {
	        var _MigratingProps$oldPr = MigratingProps[oldProp],
	            newProp = _MigratingProps$oldPr.newProp,
	            type = _MigratingProps$oldPr.type;
	
	        var oldValue = $attrs[oldProp] || $attrs[Object(util_["kebabCase"])(oldProp)];
	        if (Object(shared_["isDef"])(oldProp) && !Object(shared_["isDef"])(config[newProp])) {
	          if (type === Boolean && oldValue === '') {
	            oldValue = true;
	          }
	          config[newProp] = oldValue;
	        }
	      });
	
	      return config;
	    },
	    multiple: function multiple() {
	      return this.config.multiple;
	    },
	    leafOnly: function leafOnly() {
	      return !this.config.checkStrictly;
	    },
	    readonly: function readonly() {
	      return !this.filterable || this.multiple;
	    },
	    clearBtnVisible: function clearBtnVisible() {
	      if (!this.clearable || this.isDisabled || this.filtering || !this.inputHover) {
	        return false;
	      }
	
	      return this.multiple ? !!this.checkedNodes.filter(function (node) {
	        return !node.isDisabled;
	      }).length : !!this.presentText;
	    },
	    panel: function panel() {
	      return this.$refs.panel;
	    }
	  },
	
	  watch: {
	    disabled: function disabled() {
	      this.computePresentContent();
	    },
	    value: function value(val) {
	      if (!Object(util_["isEqual"])(val, this.checkedValue)) {
	        this.checkedValue = val;
	        this.computePresentContent();
	      }
	    },
	    checkedValue: function checkedValue(val) {
	      var value = this.value,
	          dropDownVisible = this.dropDownVisible;
	      var _config = this.config,
	          checkStrictly = _config.checkStrictly,
	          multiple = _config.multiple;
	
	
	      if (!Object(util_["isEqual"])(val, value) || Object(types_["isUndefined"])(value)) {
	        this.computePresentContent();
	        // hide dropdown when single mode
	        if (!multiple && !checkStrictly && dropDownVisible) {
	          this.toggleDropDownVisible(false);
	        }
	
	        this.$emit('input', val);
	        this.$emit('change', val);
	        this.dispatch('ElFormItem', 'el.form.change', [val]);
	      }
	    },
	
	    options: {
	      handler: function handler() {
	        this.$nextTick(this.computePresentContent);
	      },
	      deep: true
	    },
	    presentText: function presentText(val) {
	      this.inputValue = val;
	    },
	    presentTags: function presentTags(val, oldVal) {
	      if (this.multiple && (val.length || oldVal.length)) {
	        this.$nextTick(this.updateStyle);
	      }
	    },
	    filtering: function filtering(val) {
	      this.$nextTick(this.updatePopper);
	    }
	  },
	
	  mounted: function mounted() {
	    var _this = this;
	
	    var input = this.$refs.input;
	
	    if (input && input.$el) {
	      this.inputInitialHeight = input.$el.offsetHeight || InputSizeMap[this.realSize] || 40;
	    }
	
	    if (!Object(util_["isEmpty"])(this.value)) {
	      this.computePresentContent();
	    }
	
	    this.filterHandler = debounce_default()(this.debounce, function () {
	      var inputValue = _this.inputValue;
	
	
	      if (!inputValue) {
	        _this.filtering = false;
	        return;
	      }
	
	      var before = _this.beforeFilter(inputValue);
	      if (before && before.then) {
	        before.then(_this.getSuggestions);
	      } else if (before !== false) {
	        _this.getSuggestions();
	      } else {
	        _this.filtering = false;
	      }
	    });
	
	    Object(resize_event_["addResizeListener"])(this.$el, this.updateStyle);
	  },
	  beforeDestroy: function beforeDestroy() {
	    Object(resize_event_["removeResizeListener"])(this.$el, this.updateStyle);
	  },
	
	
	  methods: {
	    getMigratingConfig: function getMigratingConfig() {
	      return {
	        props: {
	          'expand-trigger': 'expand-trigger is removed, use `props.expandTrigger` instead.',
	          'change-on-select': 'change-on-select is removed, use `props.checkStrictly` instead.',
	          'hover-threshold': 'hover-threshold is removed, use `props.hoverThreshold` instead'
	        },
	        events: {
	          'active-item-change': 'active-item-change is renamed to expand-change'
	        }
	      };
	    },
	    toggleDropDownVisible: function toggleDropDownVisible(visible) {
	      var _this2 = this;
	
	      if (this.isDisabled) return;
	
	      var dropDownVisible = this.dropDownVisible;
	      var input = this.$refs.input;
	
	      visible = Object(shared_["isDef"])(visible) ? visible : !dropDownVisible;
	      if (visible !== dropDownVisible) {
	        this.dropDownVisible = visible;
	        if (visible) {
	          this.$nextTick(function () {
	            _this2.updatePopper();
	            _this2.panel.scrollIntoView();
	          });
	        }
	        input.$refs.input.setAttribute('aria-expanded', visible);
	        this.$emit('visible-change', visible);
	      }
	    },
	    handleDropdownLeave: function handleDropdownLeave() {
	      this.filtering = false;
	      this.inputValue = this.presentText;
	    },
	    handleKeyDown: function handleKeyDown(event) {
	      switch (event.keyCode) {
	        case KeyCode.enter:
	          this.toggleDropDownVisible();
	          break;
	        case KeyCode.down:
	          this.toggleDropDownVisible(true);
	          this.focusFirstNode();
	          event.preventDefault();
	          break;
	        case KeyCode.esc:
	        case KeyCode.tab:
	          this.toggleDropDownVisible(false);
	          break;
	      }
	    },
	    handleFocus: function handleFocus(e) {
	      this.$emit('focus', e);
	    },
	    handleBlur: function handleBlur(e) {
	      this.$emit('blur', e);
	    },
	    handleInput: function handleInput(val, event) {
	      !this.dropDownVisible && this.toggleDropDownVisible(true);
	
	      if (event && event.isComposing) return;
	      if (val) {
	        this.filterHandler();
	      } else {
	        this.filtering = false;
	      }
	    },
	    handleClear: function handleClear() {
	      this.presentText = '';
	      this.panel.clearCheckedNodes();
	    },
	    handleExpandChange: function handleExpandChange(value) {
	      this.$nextTick(this.updatePopper.bind(this));
	      this.$emit('expand-change', value);
	      this.$emit('active-item-change', value); // Deprecated
	    },
	    focusFirstNode: function focusFirstNode() {
	      var _this3 = this;
	
	      this.$nextTick(function () {
	        var filtering = _this3.filtering;
	        var _$refs = _this3.$refs,
	            popper = _$refs.popper,
	            suggestionPanel = _$refs.suggestionPanel;
	
	        var firstNode = null;
	
	        if (filtering && suggestionPanel) {
	          firstNode = suggestionPanel.$el.querySelector('.el-cascader__suggestion-item');
	        } else {
	          var firstMenu = popper.querySelector('.el-cascader-menu');
	          firstNode = firstMenu.querySelector('.el-cascader-node[tabindex="-1"]');
	        }
	
	        if (firstNode) {
	          firstNode.focus();
	          !filtering && firstNode.click();
	        }
	      });
	    },
	    computePresentContent: function computePresentContent() {
	      var _this4 = this;
	
	      // nextTick is required, because checked nodes may not change right now
	      this.$nextTick(function () {
	        if (_this4.config.multiple) {
	          _this4.computePresentTags();
	          _this4.presentText = _this4.presentTags.length ? ' ' : null;
	        } else {
	          _this4.computePresentText();
	        }
	      });
	    },
	    computePresentText: function computePresentText() {
	      var checkedValue = this.checkedValue,
	          config = this.config;
	
	      if (!Object(util_["isEmpty"])(checkedValue)) {
	        var node = this.panel.getNodeByValue(checkedValue);
	        if (node && (config.checkStrictly || node.isLeaf)) {
	          this.presentText = node.getText(this.showAllLevels, this.separator);
	          return;
	        }
	      }
	      this.presentText = null;
	    },
	    computePresentTags: function computePresentTags() {
	      var isDisabled = this.isDisabled,
	          leafOnly = this.leafOnly,
	          showAllLevels = this.showAllLevels,
	          separator = this.separator,
	          collapseTags = this.collapseTags;
	
	      var checkedNodes = this.getCheckedNodes(leafOnly);
	      var tags = [];
	
	      var genTag = function genTag(node) {
	        return {
	          node: node,
	          key: node.uid,
	          text: node.getText(showAllLevels, separator),
	          hitState: false,
	          closable: !isDisabled && !node.isDisabled
	        };
	      };
	
	      if (checkedNodes.length) {
	        var first = checkedNodes[0],
	            rest = checkedNodes.slice(1);
	
	        var restCount = rest.length;
	        tags.push(genTag(first));
	
	        if (restCount) {
	          if (collapseTags) {
	            tags.push({
	              key: -1,
	              text: '+ ' + restCount,
	              closable: false
	            });
	          } else {
	            rest.forEach(function (node) {
	              return tags.push(genTag(node));
	            });
	          }
	        }
	      }
	
	      this.checkedNodes = checkedNodes;
	      this.presentTags = tags;
	    },
	    getSuggestions: function getSuggestions() {
	      var _this5 = this;
	
	      var filterMethod = this.filterMethod;
	
	
	      if (!Object(types_["isFunction"])(filterMethod)) {
	        filterMethod = function filterMethod(node, keyword) {
	          return node.text.includes(keyword);
	        };
	      }
	
	      var suggestions = this.panel.getFlattedNodes(this.leafOnly).filter(function (node) {
	        if (node.isDisabled) return false;
	        node.text = node.getText(_this5.showAllLevels, _this5.separator) || '';
	        return filterMethod(node, _this5.inputValue);
	      });
	
	      if (this.multiple) {
	        this.presentTags.forEach(function (tag) {
	          tag.hitState = false;
	        });
	      } else {
	        suggestions.forEach(function (node) {
	          node.checked = Object(util_["isEqual"])(_this5.checkedValue, node.getValueByOption());
	        });
	      }
	
	      this.filtering = true;
	      this.suggestions = suggestions;
	      this.$nextTick(this.updatePopper);
	    },
	    handleSuggestionKeyDown: function handleSuggestionKeyDown(event) {
	      var keyCode = event.keyCode,
	          target = event.target;
	
	      switch (keyCode) {
	        case KeyCode.enter:
	          target.click();
	          break;
	        case KeyCode.up:
	          var prev = target.previousElementSibling;
	          prev && prev.focus();
	          break;
	        case KeyCode.down:
	          var next = target.nextElementSibling;
	          next && next.focus();
	          break;
	        case KeyCode.esc:
	        case KeyCode.tab:
	          this.toggleDropDownVisible(false);
	          break;
	      }
	    },
	    handleDelete: function handleDelete() {
	      var inputValue = this.inputValue,
	          pressDeleteCount = this.pressDeleteCount,
	          presentTags = this.presentTags;
	
	      var lastIndex = presentTags.length - 1;
	      var lastTag = presentTags[lastIndex];
	      this.pressDeleteCount = inputValue ? 0 : pressDeleteCount + 1;
	
	      if (!lastTag) return;
	
	      if (this.pressDeleteCount) {
	        if (lastTag.hitState) {
	          this.deleteTag(lastIndex);
	        } else {
	          lastTag.hitState = true;
	        }
	      }
	    },
	    handleSuggestionClick: function handleSuggestionClick(index) {
	      var multiple = this.multiple;
	
	      var targetNode = this.suggestions[index];
	
	      if (multiple) {
	        var checked = targetNode.checked;
	
	        targetNode.doCheck(!checked);
	        this.panel.calculateMultiCheckedValue();
	      } else {
	        this.checkedValue = targetNode.getValueByOption();
	        this.toggleDropDownVisible(false);
	      }
	    },
	    deleteTag: function deleteTag(index) {
	      var checkedValue = this.checkedValue;
	
	      var val = checkedValue[index];
	      this.checkedValue = checkedValue.filter(function (n, i) {
	        return i !== index;
	      });
	      this.$emit('remove-tag', val);
	    },
	    updateStyle: function updateStyle() {
	      var $el = this.$el,
	          inputInitialHeight = this.inputInitialHeight;
	
	      if (this.$isServer || !$el) return;
	
	      var suggestionPanel = this.$refs.suggestionPanel;
	
	      var inputInner = $el.querySelector('.el-input__inner');
	
	      if (!inputInner) return;
	
	      var tags = $el.querySelector('.el-cascader__tags');
	      var suggestionPanelEl = null;
	
	      if (suggestionPanel && (suggestionPanelEl = suggestionPanel.$el)) {
	        var suggestionList = suggestionPanelEl.querySelector('.el-cascader__suggestion-list');
	        suggestionList.style.minWidth = inputInner.offsetWidth + 'px';
	      }
	
	      if (tags) {
	        var offsetHeight = tags.offsetHeight;
	
	        var height = Math.max(offsetHeight + 6, inputInitialHeight) + 'px';
	        inputInner.style.height = height;
	        this.updatePopper();
	      }
	    },
	
	
	    /**
	     * public methods
	    */
	    getCheckedNodes: function getCheckedNodes(leafOnly) {
	      return this.panel.getCheckedNodes(leafOnly);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/cascader/src/cascader.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_cascadervue_type_script_lang_js_ = (cascadervue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/cascader/src/cascader.vue
	
	
	
	
	
	/* normalize component */
	
	var cascader_component = normalizeComponent(
	  src_cascadervue_type_script_lang_js_,
	  cascadervue_type_template_id_032537a6_render,
	  cascadervue_type_template_id_032537a6_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var cascader_api; }
	cascader_component.options.__file = "packages/cascader/src/cascader.vue"
	/* harmony default export */ var cascader = (cascader_component.exports);
	// CONCATENATED MODULE: ./packages/cascader/index.js
	
	
	/* istanbul ignore next */
	cascader.install = function (Vue) {
	  Vue.component(cascader.name, cascader);
	};
	
	/* harmony default export */ var packages_cascader = (cascader);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/main.vue?vue&type=template&id=55c8ade7&
	var mainvue_type_template_id_55c8ade7_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      directives: [
	        {
	          name: "clickoutside",
	          rawName: "v-clickoutside",
	          value: _vm.hide,
	          expression: "hide"
	        }
	      ],
	      class: [
	        "el-color-picker",
	        _vm.colorDisabled ? "is-disabled" : "",
	        _vm.colorSize ? "el-color-picker--" + _vm.colorSize : ""
	      ]
	    },
	    [
	      _vm.colorDisabled
	        ? _c("div", { staticClass: "el-color-picker__mask" })
	        : _vm._e(),
	      _c(
	        "div",
	        {
	          staticClass: "el-color-picker__trigger",
	          on: { click: _vm.handleTrigger }
	        },
	        [
	          _c(
	            "span",
	            {
	              staticClass: "el-color-picker__color",
	              class: { "is-alpha": _vm.showAlpha }
	            },
	            [
	              _c("span", {
	                staticClass: "el-color-picker__color-inner",
	                style: {
	                  backgroundColor: _vm.displayedColor
	                }
	              }),
	              !_vm.value && !_vm.showPanelColor
	                ? _c("span", {
	                    staticClass: "el-color-picker__empty el-icon-close"
	                  })
	                : _vm._e()
	            ]
	          ),
	          _c("span", {
	            directives: [
	              {
	                name: "show",
	                rawName: "v-show",
	                value: _vm.value || _vm.showPanelColor,
	                expression: "value || showPanelColor"
	              }
	            ],
	            staticClass: "el-color-picker__icon el-icon-arrow-down"
	          })
	        ]
	      ),
	      _c("picker-dropdown", {
	        ref: "dropdown",
	        class: ["el-color-picker__panel", _vm.popperClass || ""],
	        attrs: {
	          color: _vm.color,
	          "show-alpha": _vm.showAlpha,
	          predefine: _vm.predefine
	        },
	        on: { pick: _vm.confirmValue, clear: _vm.clearValue },
	        model: {
	          value: _vm.showPicker,
	          callback: function($$v) {
	            _vm.showPicker = $$v
	          },
	          expression: "showPicker"
	        }
	      })
	    ],
	    1
	  )
	}
	var mainvue_type_template_id_55c8ade7_staticRenderFns = []
	mainvue_type_template_id_55c8ade7_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/color-picker/src/main.vue?vue&type=template&id=55c8ade7&
	
	// CONCATENATED MODULE: ./packages/color-picker/src/color.js
	var color_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function color_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var hsv2hsl = function hsv2hsl(hue, sat, val) {
	  return [hue, sat * val / ((hue = (2 - sat) * val) < 1 ? hue : 2 - hue) || 0, hue / 2];
	};
	
	// Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
	// <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
	var isOnePointZero = function isOnePointZero(n) {
	  return typeof n === 'string' && n.indexOf('.') !== -1 && parseFloat(n) === 1;
	};
	
	var isPercentage = function isPercentage(n) {
	  return typeof n === 'string' && n.indexOf('%') !== -1;
	};
	
	// Take input from [0, n] and return it as [0, 1]
	var bound01 = function bound01(value, max) {
	  if (isOnePointZero(value)) value = '100%';
	
	  var processPercent = isPercentage(value);
	  value = Math.min(max, Math.max(0, parseFloat(value)));
	
	  // Automatically convert percentage into number
	  if (processPercent) {
	    value = parseInt(value * max, 10) / 100;
	  }
	
	  // Handle floating point rounding errors
	  if (Math.abs(value - max) < 0.000001) {
	    return 1;
	  }
	
	  // Convert into [0, 1] range if it isn't already
	  return value % max / parseFloat(max);
	};
	
	var INT_HEX_MAP = { 10: 'A', 11: 'B', 12: 'C', 13: 'D', 14: 'E', 15: 'F' };
	
	var toHex = function toHex(_ref) {
	  var r = _ref.r,
	      g = _ref.g,
	      b = _ref.b;
	
	  var hexOne = function hexOne(value) {
	    value = Math.min(Math.round(value), 255);
	    var high = Math.floor(value / 16);
	    var low = value % 16;
	    return '' + (INT_HEX_MAP[high] || high) + (INT_HEX_MAP[low] || low);
	  };
	
	  if (isNaN(r) || isNaN(g) || isNaN(b)) return '';
	
	  return '#' + hexOne(r) + hexOne(g) + hexOne(b);
	};
	
	var HEX_INT_MAP = { A: 10, B: 11, C: 12, D: 13, E: 14, F: 15 };
	
	var parseHexChannel = function parseHexChannel(hex) {
	  if (hex.length === 2) {
	    return (HEX_INT_MAP[hex[0].toUpperCase()] || +hex[0]) * 16 + (HEX_INT_MAP[hex[1].toUpperCase()] || +hex[1]);
	  }
	
	  return HEX_INT_MAP[hex[1].toUpperCase()] || +hex[1];
	};
	
	var hsl2hsv = function hsl2hsv(hue, sat, light) {
	  sat = sat / 100;
	  light = light / 100;
	  var smin = sat;
	  var lmin = Math.max(light, 0.01);
	  var sv = void 0;
	  var v = void 0;
	
	  light *= 2;
	  sat *= light <= 1 ? light : 2 - light;
	  smin *= lmin <= 1 ? lmin : 2 - lmin;
	  v = (light + sat) / 2;
	  sv = light === 0 ? 2 * smin / (lmin + smin) : 2 * sat / (light + sat);
	
	  return {
	    h: hue,
	    s: sv * 100,
	    v: v * 100
	  };
	};
	
	// `rgbToHsv`
	// Converts an RGB color value to HSV
	// *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
	// *Returns:* { h, s, v } in [0,1]
	var rgb2hsv = function rgb2hsv(r, g, b) {
	  r = bound01(r, 255);
	  g = bound01(g, 255);
	  b = bound01(b, 255);
	
	  var max = Math.max(r, g, b);
	  var min = Math.min(r, g, b);
	  var h = void 0,
	      s = void 0;
	  var v = max;
	
	  var d = max - min;
	  s = max === 0 ? 0 : d / max;
	
	  if (max === min) {
	    h = 0; // achromatic
	  } else {
	    switch (max) {
	      case r:
	        h = (g - b) / d + (g < b ? 6 : 0);
	        break;
	      case g:
	        h = (b - r) / d + 2;
	        break;
	      case b:
	        h = (r - g) / d + 4;
	        break;
	    }
	    h /= 6;
	  }
	
	  return { h: h * 360, s: s * 100, v: v * 100 };
	};
	
	// `hsvToRgb`
	// Converts an HSV color value to RGB.
	// *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
	// *Returns:* { r, g, b } in the set [0, 255]
	var hsv2rgb = function hsv2rgb(h, s, v) {
	  h = bound01(h, 360) * 6;
	  s = bound01(s, 100);
	  v = bound01(v, 100);
	
	  var i = Math.floor(h);
	  var f = h - i;
	  var p = v * (1 - s);
	  var q = v * (1 - f * s);
	  var t = v * (1 - (1 - f) * s);
	  var mod = i % 6;
	  var r = [v, q, p, p, t, v][mod];
	  var g = [t, v, v, q, p, p][mod];
	  var b = [p, p, t, v, v, q][mod];
	
	  return {
	    r: Math.round(r * 255),
	    g: Math.round(g * 255),
	    b: Math.round(b * 255)
	  };
	};
	
	var Color = function () {
	  function Color(options) {
	    color_classCallCheck(this, Color);
	
	    this._hue = 0;
	    this._saturation = 100;
	    this._value = 100;
	    this._alpha = 100;
	
	    this.enableAlpha = false;
	    this.format = 'hex';
	    this.value = '';
	
	    options = options || {};
	
	    for (var option in options) {
	      if (options.hasOwnProperty(option)) {
	        this[option] = options[option];
	      }
	    }
	
	    this.doOnChange();
	  }
	
	  Color.prototype.set = function set(prop, value) {
	    if (arguments.length === 1 && (typeof prop === 'undefined' ? 'undefined' : color_typeof(prop)) === 'object') {
	      for (var p in prop) {
	        if (prop.hasOwnProperty(p)) {
	          this.set(p, prop[p]);
	        }
	      }
	
	      return;
	    }
	
	    this['_' + prop] = value;
	    this.doOnChange();
	  };
	
	  Color.prototype.get = function get(prop) {
	    return this['_' + prop];
	  };
	
	  Color.prototype.toRgb = function toRgb() {
	    return hsv2rgb(this._hue, this._saturation, this._value);
	  };
	
	  Color.prototype.fromString = function fromString(value) {
	    var _this = this;
	
	    if (!value) {
	      this._hue = 0;
	      this._saturation = 100;
	      this._value = 100;
	
	      this.doOnChange();
	      return;
	    }
	
	    var fromHSV = function fromHSV(h, s, v) {
	      _this._hue = Math.max(0, Math.min(360, h));
	      _this._saturation = Math.max(0, Math.min(100, s));
	      _this._value = Math.max(0, Math.min(100, v));
	
	      _this.doOnChange();
	    };
	
	    if (value.indexOf('hsl') !== -1) {
	      var parts = value.replace(/hsla|hsl|\(|\)/gm, '').split(/\s|,/g).filter(function (val) {
	        return val !== '';
	      }).map(function (val, index) {
	        return index > 2 ? parseFloat(val) : parseInt(val, 10);
	      });
	
	      if (parts.length === 4) {
	        this._alpha = Math.floor(parseFloat(parts[3]) * 100);
	      } else if (parts.length === 3) {
	        this._alpha = 100;
	      }
	      if (parts.length >= 3) {
	        var _hsl2hsv = hsl2hsv(parts[0], parts[1], parts[2]),
	            h = _hsl2hsv.h,
	            s = _hsl2hsv.s,
	            v = _hsl2hsv.v;
	
	        fromHSV(h, s, v);
	      }
	    } else if (value.indexOf('hsv') !== -1) {
	      var _parts = value.replace(/hsva|hsv|\(|\)/gm, '').split(/\s|,/g).filter(function (val) {
	        return val !== '';
	      }).map(function (val, index) {
	        return index > 2 ? parseFloat(val) : parseInt(val, 10);
	      });
	
	      if (_parts.length === 4) {
	        this._alpha = Math.floor(parseFloat(_parts[3]) * 100);
	      } else if (_parts.length === 3) {
	        this._alpha = 100;
	      }
	      if (_parts.length >= 3) {
	        fromHSV(_parts[0], _parts[1], _parts[2]);
	      }
	    } else if (value.indexOf('rgb') !== -1) {
	      var _parts2 = value.replace(/rgba|rgb|\(|\)/gm, '').split(/\s|,/g).filter(function (val) {
	        return val !== '';
	      }).map(function (val, index) {
	        return index > 2 ? parseFloat(val) : parseInt(val, 10);
	      });
	
	      if (_parts2.length === 4) {
	        this._alpha = Math.floor(parseFloat(_parts2[3]) * 100);
	      } else if (_parts2.length === 3) {
	        this._alpha = 100;
	      }
	      if (_parts2.length >= 3) {
	        var _rgb2hsv = rgb2hsv(_parts2[0], _parts2[1], _parts2[2]),
	            _h = _rgb2hsv.h,
	            _s = _rgb2hsv.s,
	            _v = _rgb2hsv.v;
	
	        fromHSV(_h, _s, _v);
	      }
	    } else if (value.indexOf('#') !== -1) {
	      var hex = value.replace('#', '').trim();
	      if (!/^(?:[0-9a-fA-F]{3}){1,2}$/.test(hex)) return;
	      var r = void 0,
	          g = void 0,
	          b = void 0;
	
	      if (hex.length === 3) {
	        r = parseHexChannel(hex[0] + hex[0]);
	        g = parseHexChannel(hex[1] + hex[1]);
	        b = parseHexChannel(hex[2] + hex[2]);
	      } else if (hex.length === 6 || hex.length === 8) {
	        r = parseHexChannel(hex.substring(0, 2));
	        g = parseHexChannel(hex.substring(2, 4));
	        b = parseHexChannel(hex.substring(4, 6));
	      }
	
	      if (hex.length === 8) {
	        this._alpha = Math.floor(parseHexChannel(hex.substring(6)) / 255 * 100);
	      } else if (hex.length === 3 || hex.length === 6) {
	        this._alpha = 100;
	      }
	
	      var _rgb2hsv2 = rgb2hsv(r, g, b),
	          _h2 = _rgb2hsv2.h,
	          _s2 = _rgb2hsv2.s,
	          _v2 = _rgb2hsv2.v;
	
	      fromHSV(_h2, _s2, _v2);
	    }
	  };
	
	  Color.prototype.compare = function compare(color) {
	    return Math.abs(color._hue - this._hue) < 2 && Math.abs(color._saturation - this._saturation) < 1 && Math.abs(color._value - this._value) < 1 && Math.abs(color._alpha - this._alpha) < 1;
	  };
	
	  Color.prototype.doOnChange = function doOnChange() {
	    var _hue = this._hue,
	        _saturation = this._saturation,
	        _value = this._value,
	        _alpha = this._alpha,
	        format = this.format;
	
	
	    if (this.enableAlpha) {
	      switch (format) {
	        case 'hsl':
	          var hsl = hsv2hsl(_hue, _saturation / 100, _value / 100);
	          this.value = 'hsla(' + _hue + ', ' + Math.round(hsl[1] * 100) + '%, ' + Math.round(hsl[2] * 100) + '%, ' + _alpha / 100 + ')';
	          break;
	        case 'hsv':
	          this.value = 'hsva(' + _hue + ', ' + Math.round(_saturation) + '%, ' + Math.round(_value) + '%, ' + _alpha / 100 + ')';
	          break;
	        default:
	          var _hsv2rgb = hsv2rgb(_hue, _saturation, _value),
	              r = _hsv2rgb.r,
	              g = _hsv2rgb.g,
	              b = _hsv2rgb.b;
	
	          this.value = 'rgba(' + r + ', ' + g + ', ' + b + ', ' + _alpha / 100 + ')';
	      }
	    } else {
	      switch (format) {
	        case 'hsl':
	          var _hsl = hsv2hsl(_hue, _saturation / 100, _value / 100);
	          this.value = 'hsl(' + _hue + ', ' + Math.round(_hsl[1] * 100) + '%, ' + Math.round(_hsl[2] * 100) + '%)';
	          break;
	        case 'hsv':
	          this.value = 'hsv(' + _hue + ', ' + Math.round(_saturation) + '%, ' + Math.round(_value) + '%)';
	          break;
	        case 'rgb':
	          var _hsv2rgb2 = hsv2rgb(_hue, _saturation, _value),
	              _r = _hsv2rgb2.r,
	              _g = _hsv2rgb2.g,
	              _b = _hsv2rgb2.b;
	
	          this.value = 'rgb(' + _r + ', ' + _g + ', ' + _b + ')';
	          break;
	        default:
	          this.value = toHex(hsv2rgb(_hue, _saturation, _value));
	      }
	    }
	  };
	
	  return Color;
	}();
	
	/* harmony default export */ var src_color = (Color);
	;
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/picker-dropdown.vue?vue&type=template&id=06601625&
	var picker_dropdownvue_type_template_id_06601625_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "transition",
	    { attrs: { name: "el-zoom-in-top" }, on: { "after-leave": _vm.doDestroy } },
	    [
	      _c(
	        "div",
	        {
	          directives: [
	            {
	              name: "show",
	              rawName: "v-show",
	              value: _vm.showPopper,
	              expression: "showPopper"
	            }
	          ],
	          staticClass: "el-color-dropdown"
	        },
	        [
	          _c(
	            "div",
	            { staticClass: "el-color-dropdown__main-wrapper" },
	            [
	              _c("hue-slider", {
	                ref: "hue",
	                staticStyle: { float: "right" },
	                attrs: { color: _vm.color, vertical: "" }
	              }),
	              _c("sv-panel", { ref: "sl", attrs: { color: _vm.color } })
	            ],
	            1
	          ),
	          _vm.showAlpha
	            ? _c("alpha-slider", { ref: "alpha", attrs: { color: _vm.color } })
	            : _vm._e(),
	          _vm.predefine
	            ? _c("predefine", {
	                attrs: { color: _vm.color, colors: _vm.predefine }
	              })
	            : _vm._e(),
	          _c(
	            "div",
	            { staticClass: "el-color-dropdown__btns" },
	            [
	              _c(
	                "span",
	                { staticClass: "el-color-dropdown__value" },
	                [
	                  _c("el-input", {
	                    attrs: { "validate-event": false, size: "mini" },
	                    on: { blur: _vm.handleConfirm },
	                    nativeOn: {
	                      keyup: function($event) {
	                        if (
	                          !("button" in $event) &&
	                          _vm._k(
	                            $event.keyCode,
	                            "enter",
	                            13,
	                            $event.key,
	                            "Enter"
	                          )
	                        ) {
	                          return null
	                        }
	                        return _vm.handleConfirm($event)
	                      }
	                    },
	                    model: {
	                      value: _vm.customInput,
	                      callback: function($$v) {
	                        _vm.customInput = $$v
	                      },
	                      expression: "customInput"
	                    }
	                  })
	                ],
	                1
	              ),
	              _c(
	                "el-button",
	                {
	                  staticClass: "el-color-dropdown__link-btn",
	                  attrs: { size: "mini", type: "text" },
	                  on: {
	                    click: function($event) {
	                      _vm.$emit("clear")
	                    }
	                  }
	                },
	                [
	                  _vm._v(
	                    "\n        " +
	                      _vm._s(_vm.t("el.colorpicker.clear")) +
	                      "\n      "
	                  )
	                ]
	              ),
	              _c(
	                "el-button",
	                {
	                  staticClass: "el-color-dropdown__btn",
	                  attrs: { plain: "", size: "mini" },
	                  on: { click: _vm.confirmValue }
	                },
	                [
	                  _vm._v(
	                    "\n        " +
	                      _vm._s(_vm.t("el.colorpicker.confirm")) +
	                      "\n      "
	                  )
	                ]
	              )
	            ],
	            1
	          )
	        ],
	        1
	      )
	    ]
	  )
	}
	var picker_dropdownvue_type_template_id_06601625_staticRenderFns = []
	picker_dropdownvue_type_template_id_06601625_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/color-picker/src/components/picker-dropdown.vue?vue&type=template&id=06601625&
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/sv-panel.vue?vue&type=template&id=d8583596&
	var sv_panelvue_type_template_id_d8583596_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-color-svpanel",
	      style: {
	        backgroundColor: _vm.background
	      }
	    },
	    [
	      _c("div", { staticClass: "el-color-svpanel__white" }),
	      _c("div", { staticClass: "el-color-svpanel__black" }),
	      _c(
	        "div",
	        {
	          staticClass: "el-color-svpanel__cursor",
	          style: {
	            top: _vm.cursorTop + "px",
	            left: _vm.cursorLeft + "px"
	          }
	        },
	        [_c("div")]
	      )
	    ]
	  )
	}
	var sv_panelvue_type_template_id_d8583596_staticRenderFns = []
	sv_panelvue_type_template_id_d8583596_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/color-picker/src/components/sv-panel.vue?vue&type=template&id=d8583596&
	
	// CONCATENATED MODULE: ./packages/color-picker/src/draggable.js
	
	var isDragging = false;
	
	/* harmony default export */ var draggable = (function (element, options) {
	  if (external_vue_default.a.prototype.$isServer) return;
	  var moveFn = function moveFn(event) {
	    if (options.drag) {
	      options.drag(event);
	    }
	  };
	  var upFn = function upFn(event) {
	    document.removeEventListener('mousemove', moveFn);
	    document.removeEventListener('mouseup', upFn);
	    document.onselectstart = null;
	    document.ondragstart = null;
	
	    isDragging = false;
	
	    if (options.end) {
	      options.end(event);
	    }
	  };
	  element.addEventListener('mousedown', function (event) {
	    if (isDragging) return;
	    document.onselectstart = function () {
	      return false;
	    };
	    document.ondragstart = function () {
	      return false;
	    };
	
	    document.addEventListener('mousemove', moveFn);
	    document.addEventListener('mouseup', upFn);
	    isDragging = true;
	
	    if (options.start) {
	      options.start(event);
	    }
	  });
	});
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/sv-panel.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var sv_panelvue_type_script_lang_js_ = ({
	  name: 'el-sl-panel',
	
	  props: {
	    color: {
	      required: true
	    }
	  },
	
	  computed: {
	    colorValue: function colorValue() {
	      var hue = this.color.get('hue');
	      var value = this.color.get('value');
	      return { hue: hue, value: value };
	    }
	  },
	
	  watch: {
	    colorValue: function colorValue() {
	      this.update();
	    }
	  },
	
	  methods: {
	    update: function update() {
	      var saturation = this.color.get('saturation');
	      var value = this.color.get('value');
	
	      var el = this.$el;
	      var width = el.clientWidth,
	          height = el.clientHeight;
	
	
	      this.cursorLeft = saturation * width / 100;
	      this.cursorTop = (100 - value) * height / 100;
	
	      this.background = 'hsl(' + this.color.get('hue') + ', 100%, 50%)';
	    },
	    handleDrag: function handleDrag(event) {
	      var el = this.$el;
	      var rect = el.getBoundingClientRect();
	
	      var left = event.clientX - rect.left;
	      var top = event.clientY - rect.top;
	      left = Math.max(0, left);
	      left = Math.min(left, rect.width);
	
	      top = Math.max(0, top);
	      top = Math.min(top, rect.height);
	
	      this.cursorLeft = left;
	      this.cursorTop = top;
	      this.color.set({
	        saturation: left / rect.width * 100,
	        value: 100 - top / rect.height * 100
	      });
	    }
	  },
	
	  mounted: function mounted() {
	    var _this = this;
	
	    draggable(this.$el, {
	      drag: function drag(event) {
	        _this.handleDrag(event);
	      },
	      end: function end(event) {
	        _this.handleDrag(event);
	      }
	    });
	
	    this.update();
	  },
	  data: function data() {
	    return {
	      cursorTop: 0,
	      cursorLeft: 0,
	      background: 'hsl(0, 100%, 50%)'
	    };
	  }
	});
	// CONCATENATED MODULE: ./packages/color-picker/src/components/sv-panel.vue?vue&type=script&lang=js&
	 /* harmony default export */ var components_sv_panelvue_type_script_lang_js_ = (sv_panelvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/color-picker/src/components/sv-panel.vue
	
	
	
	
	
	/* normalize component */
	
	var sv_panel_component = normalizeComponent(
	  components_sv_panelvue_type_script_lang_js_,
	  sv_panelvue_type_template_id_d8583596_render,
	  sv_panelvue_type_template_id_d8583596_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var sv_panel_api; }
	sv_panel_component.options.__file = "packages/color-picker/src/components/sv-panel.vue"
	/* harmony default export */ var sv_panel = (sv_panel_component.exports);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/hue-slider.vue?vue&type=template&id=5cdc43b1&
	var hue_slidervue_type_template_id_5cdc43b1_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-color-hue-slider",
	      class: { "is-vertical": _vm.vertical }
	    },
	    [
	      _c("div", {
	        ref: "bar",
	        staticClass: "el-color-hue-slider__bar",
	        on: { click: _vm.handleClick }
	      }),
	      _c("div", {
	        ref: "thumb",
	        staticClass: "el-color-hue-slider__thumb",
	        style: {
	          left: _vm.thumbLeft + "px",
	          top: _vm.thumbTop + "px"
	        }
	      })
	    ]
	  )
	}
	var hue_slidervue_type_template_id_5cdc43b1_staticRenderFns = []
	hue_slidervue_type_template_id_5cdc43b1_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/color-picker/src/components/hue-slider.vue?vue&type=template&id=5cdc43b1&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/hue-slider.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var hue_slidervue_type_script_lang_js_ = ({
	  name: 'el-color-hue-slider',
	
	  props: {
	    color: {
	      required: true
	    },
	
	    vertical: Boolean
	  },
	
	  data: function data() {
	    return {
	      thumbLeft: 0,
	      thumbTop: 0
	    };
	  },
	
	
	  computed: {
	    hueValue: function hueValue() {
	      var hue = this.color.get('hue');
	      return hue;
	    }
	  },
	
	  watch: {
	    hueValue: function hueValue() {
	      this.update();
	    }
	  },
	
	  methods: {
	    handleClick: function handleClick(event) {
	      var thumb = this.$refs.thumb;
	      var target = event.target;
	
	      if (target !== thumb) {
	        this.handleDrag(event);
	      }
	    },
	    handleDrag: function handleDrag(event) {
	      var rect = this.$el.getBoundingClientRect();
	      var thumb = this.$refs.thumb;
	
	      var hue = void 0;
	
	      if (!this.vertical) {
	        var left = event.clientX - rect.left;
	        left = Math.min(left, rect.width - thumb.offsetWidth / 2);
	        left = Math.max(thumb.offsetWidth / 2, left);
	
	        hue = Math.round((left - thumb.offsetWidth / 2) / (rect.width - thumb.offsetWidth) * 360);
	      } else {
	        var top = event.clientY - rect.top;
	        top = Math.min(top, rect.height - thumb.offsetHeight / 2);
	        top = Math.max(thumb.offsetHeight / 2, top);
	
	        hue = Math.round((top - thumb.offsetHeight / 2) / (rect.height - thumb.offsetHeight) * 360);
	      }
	
	      this.color.set('hue', hue);
	    },
	    getThumbLeft: function getThumbLeft() {
	      if (this.vertical) return 0;
	      var el = this.$el;
	      var hue = this.color.get('hue');
	
	      if (!el) return 0;
	      var thumb = this.$refs.thumb;
	      return Math.round(hue * (el.offsetWidth - thumb.offsetWidth / 2) / 360);
	    },
	    getThumbTop: function getThumbTop() {
	      if (!this.vertical) return 0;
	      var el = this.$el;
	      var hue = this.color.get('hue');
	
	      if (!el) return 0;
	      var thumb = this.$refs.thumb;
	      return Math.round(hue * (el.offsetHeight - thumb.offsetHeight / 2) / 360);
	    },
	    update: function update() {
	      this.thumbLeft = this.getThumbLeft();
	      this.thumbTop = this.getThumbTop();
	    }
	  },
	
	  mounted: function mounted() {
	    var _this = this;
	
	    var _$refs = this.$refs,
	        bar = _$refs.bar,
	        thumb = _$refs.thumb;
	
	
	    var dragConfig = {
	      drag: function drag(event) {
	        _this.handleDrag(event);
	      },
	      end: function end(event) {
	        _this.handleDrag(event);
	      }
	    };
	
	    draggable(bar, dragConfig);
	    draggable(thumb, dragConfig);
	    this.update();
	  }
	});
	// CONCATENATED MODULE: ./packages/color-picker/src/components/hue-slider.vue?vue&type=script&lang=js&
	 /* harmony default export */ var components_hue_slidervue_type_script_lang_js_ = (hue_slidervue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/color-picker/src/components/hue-slider.vue
	
	
	
	
	
	/* normalize component */
	
	var hue_slider_component = normalizeComponent(
	  components_hue_slidervue_type_script_lang_js_,
	  hue_slidervue_type_template_id_5cdc43b1_render,
	  hue_slidervue_type_template_id_5cdc43b1_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var hue_slider_api; }
	hue_slider_component.options.__file = "packages/color-picker/src/components/hue-slider.vue"
	/* harmony default export */ var hue_slider = (hue_slider_component.exports);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/alpha-slider.vue?vue&type=template&id=068c66cb&
	var alpha_slidervue_type_template_id_068c66cb_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-color-alpha-slider",
	      class: { "is-vertical": _vm.vertical }
	    },
	    [
	      _c("div", {
	        ref: "bar",
	        staticClass: "el-color-alpha-slider__bar",
	        style: {
	          background: _vm.background
	        },
	        on: { click: _vm.handleClick }
	      }),
	      _c("div", {
	        ref: "thumb",
	        staticClass: "el-color-alpha-slider__thumb",
	        style: {
	          left: _vm.thumbLeft + "px",
	          top: _vm.thumbTop + "px"
	        }
	      })
	    ]
	  )
	}
	var alpha_slidervue_type_template_id_068c66cb_staticRenderFns = []
	alpha_slidervue_type_template_id_068c66cb_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/color-picker/src/components/alpha-slider.vue?vue&type=template&id=068c66cb&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/alpha-slider.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var alpha_slidervue_type_script_lang_js_ = ({
	  name: 'el-color-alpha-slider',
	
	  props: {
	    color: {
	      required: true
	    },
	    vertical: Boolean
	  },
	
	  watch: {
	    'color._alpha': function color_alpha() {
	      this.update();
	    },
	    'color.value': function colorValue() {
	      this.update();
	    }
	  },
	
	  methods: {
	    handleClick: function handleClick(event) {
	      var thumb = this.$refs.thumb;
	      var target = event.target;
	
	      if (target !== thumb) {
	        this.handleDrag(event);
	      }
	    },
	    handleDrag: function handleDrag(event) {
	      var rect = this.$el.getBoundingClientRect();
	      var thumb = this.$refs.thumb;
	
	
	      if (!this.vertical) {
	        var left = event.clientX - rect.left;
	        left = Math.max(thumb.offsetWidth / 2, left);
	        left = Math.min(left, rect.width - thumb.offsetWidth / 2);
	
	        this.color.set('alpha', Math.round((left - thumb.offsetWidth / 2) / (rect.width - thumb.offsetWidth) * 100));
	      } else {
	        var top = event.clientY - rect.top;
	        top = Math.max(thumb.offsetHeight / 2, top);
	        top = Math.min(top, rect.height - thumb.offsetHeight / 2);
	
	        this.color.set('alpha', Math.round((top - thumb.offsetHeight / 2) / (rect.height - thumb.offsetHeight) * 100));
	      }
	    },
	    getThumbLeft: function getThumbLeft() {
	      if (this.vertical) return 0;
	      var el = this.$el;
	      var alpha = this.color._alpha;
	
	      if (!el) return 0;
	      var thumb = this.$refs.thumb;
	      return Math.round(alpha * (el.offsetWidth - thumb.offsetWidth / 2) / 100);
	    },
	    getThumbTop: function getThumbTop() {
	      if (!this.vertical) return 0;
	      var el = this.$el;
	      var alpha = this.color._alpha;
	
	      if (!el) return 0;
	      var thumb = this.$refs.thumb;
	      return Math.round(alpha * (el.offsetHeight - thumb.offsetHeight / 2) / 100);
	    },
	    getBackground: function getBackground() {
	      if (this.color && this.color.value) {
	        var _color$toRgb = this.color.toRgb(),
	            r = _color$toRgb.r,
	            g = _color$toRgb.g,
	            b = _color$toRgb.b;
	
	        return 'linear-gradient(to right, rgba(' + r + ', ' + g + ', ' + b + ', 0) 0%, rgba(' + r + ', ' + g + ', ' + b + ', 1) 100%)';
	      }
	      return null;
	    },
	    update: function update() {
	      this.thumbLeft = this.getThumbLeft();
	      this.thumbTop = this.getThumbTop();
	      this.background = this.getBackground();
	    }
	  },
	
	  data: function data() {
	    return {
	      thumbLeft: 0,
	      thumbTop: 0,
	      background: null
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    var _$refs = this.$refs,
	        bar = _$refs.bar,
	        thumb = _$refs.thumb;
	
	
	    var dragConfig = {
	      drag: function drag(event) {
	        _this.handleDrag(event);
	      },
	      end: function end(event) {
	        _this.handleDrag(event);
	      }
	    };
	
	    draggable(bar, dragConfig);
	    draggable(thumb, dragConfig);
	    this.update();
	  }
	});
	// CONCATENATED MODULE: ./packages/color-picker/src/components/alpha-slider.vue?vue&type=script&lang=js&
	 /* harmony default export */ var components_alpha_slidervue_type_script_lang_js_ = (alpha_slidervue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/color-picker/src/components/alpha-slider.vue
	
	
	
	
	
	/* normalize component */
	
	var alpha_slider_component = normalizeComponent(
	  components_alpha_slidervue_type_script_lang_js_,
	  alpha_slidervue_type_template_id_068c66cb_render,
	  alpha_slidervue_type_template_id_068c66cb_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var alpha_slider_api; }
	alpha_slider_component.options.__file = "packages/color-picker/src/components/alpha-slider.vue"
	/* harmony default export */ var alpha_slider = (alpha_slider_component.exports);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/predefine.vue?vue&type=template&id=06e03093&
	var predefinevue_type_template_id_06e03093_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("div", { staticClass: "el-color-predefine" }, [
	    _c(
	      "div",
	      { staticClass: "el-color-predefine__colors" },
	      _vm._l(_vm.rgbaColors, function(item, index) {
	        return _c(
	          "div",
	          {
	            key: _vm.colors[index],
	            staticClass: "el-color-predefine__color-selector",
	            class: { selected: item.selected, "is-alpha": item._alpha < 100 },
	            on: {
	              click: function($event) {
	                _vm.handleSelect(index)
	              }
	            }
	          },
	          [_c("div", { style: { "background-color": item.value } })]
	        )
	      }),
	      0
	    )
	  ])
	}
	var predefinevue_type_template_id_06e03093_staticRenderFns = []
	predefinevue_type_template_id_06e03093_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/color-picker/src/components/predefine.vue?vue&type=template&id=06e03093&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/predefine.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var predefinevue_type_script_lang_js_ = ({
	  props: {
	    colors: { type: Array, required: true },
	    color: { required: true }
	  },
	  data: function data() {
	    return {
	      rgbaColors: this.parseColors(this.colors, this.color)
	    };
	  },
	
	  methods: {
	    handleSelect: function handleSelect(index) {
	      this.color.fromString(this.colors[index]);
	    },
	    parseColors: function parseColors(colors, color) {
	      return colors.map(function (value) {
	        var c = new src_color();
	        c.enableAlpha = true;
	        c.format = 'rgba';
	        c.fromString(value);
	        c.selected = c.value === color.value;
	        return c;
	      });
	    }
	  },
	  watch: {
	    '$parent.currentColor': function $parentCurrentColor(val) {
	      var color = new src_color();
	      color.fromString(val);
	
	      this.rgbaColors.forEach(function (item) {
	        item.selected = color.compare(item);
	      });
	    },
	    colors: function colors(newVal) {
	      this.rgbaColors = this.parseColors(newVal, this.color);
	    },
	    color: function color(newVal) {
	      this.rgbaColors = this.parseColors(this.colors, newVal);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/color-picker/src/components/predefine.vue?vue&type=script&lang=js&
	 /* harmony default export */ var components_predefinevue_type_script_lang_js_ = (predefinevue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/color-picker/src/components/predefine.vue
	
	
	
	
	
	/* normalize component */
	
	var predefine_component = normalizeComponent(
	  components_predefinevue_type_script_lang_js_,
	  predefinevue_type_template_id_06e03093_render,
	  predefinevue_type_template_id_06e03093_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var predefine_api; }
	predefine_component.options.__file = "packages/color-picker/src/components/predefine.vue"
	/* harmony default export */ var predefine = (predefine_component.exports);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/picker-dropdown.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	
	
	
	/* harmony default export */ var picker_dropdownvue_type_script_lang_js_ = ({
	  name: 'el-color-picker-dropdown',
	
	  mixins: [vue_popper_default.a, locale_default.a],
	
	  components: {
	    SvPanel: sv_panel,
	    HueSlider: hue_slider,
	    AlphaSlider: alpha_slider,
	    ElInput: input_default.a,
	    ElButton: button_default.a,
	    Predefine: predefine
	  },
	
	  props: {
	    color: {
	      required: true
	    },
	    showAlpha: Boolean,
	    predefine: Array
	  },
	
	  data: function data() {
	    return {
	      customInput: ''
	    };
	  },
	
	
	  computed: {
	    currentColor: function currentColor() {
	      var parent = this.$parent;
	      return !parent.value && !parent.showPanelColor ? '' : parent.color.value;
	    }
	  },
	
	  methods: {
	    confirmValue: function confirmValue() {
	      this.$emit('pick');
	    },
	    handleConfirm: function handleConfirm() {
	      this.color.fromString(this.customInput);
	    }
	  },
	
	  mounted: function mounted() {
	    this.$parent.popperElm = this.popperElm = this.$el;
	    this.referenceElm = this.$parent.$el;
	  },
	
	
	  watch: {
	    showPopper: function showPopper(val) {
	      var _this = this;
	
	      if (val === true) {
	        this.$nextTick(function () {
	          var _$refs = _this.$refs,
	              sl = _$refs.sl,
	              hue = _$refs.hue,
	              alpha = _$refs.alpha;
	
	          sl && sl.update();
	          hue && hue.update();
	          alpha && alpha.update();
	        });
	      }
	    },
	
	
	    currentColor: {
	      immediate: true,
	      handler: function handler(val) {
	        this.customInput = val;
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/color-picker/src/components/picker-dropdown.vue?vue&type=script&lang=js&
	 /* harmony default export */ var components_picker_dropdownvue_type_script_lang_js_ = (picker_dropdownvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/color-picker/src/components/picker-dropdown.vue
	
	
	
	
	
	/* normalize component */
	
	var picker_dropdown_component = normalizeComponent(
	  components_picker_dropdownvue_type_script_lang_js_,
	  picker_dropdownvue_type_template_id_06601625_render,
	  picker_dropdownvue_type_template_id_06601625_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var picker_dropdown_api; }
	picker_dropdown_component.options.__file = "packages/color-picker/src/components/picker-dropdown.vue"
	/* harmony default export */ var picker_dropdown = (picker_dropdown_component.exports);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	/* harmony default export */ var color_picker_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElColorPicker',
	
	  mixins: [emitter_default.a],
	
	  props: {
	    value: String,
	    showAlpha: Boolean,
	    colorFormat: String,
	    disabled: Boolean,
	    size: String,
	    popperClass: String,
	    predefine: Array
	  },
	
	  inject: {
	    elForm: {
	      default: ''
	    },
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  directives: { Clickoutside: clickoutside_default.a },
	
	  computed: {
	    displayedColor: function displayedColor() {
	      if (!this.value && !this.showPanelColor) {
	        return 'transparent';
	      }
	
	      return this.displayedRgb(this.color, this.showAlpha);
	    },
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    colorSize: function colorSize() {
	      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
	    },
	    colorDisabled: function colorDisabled() {
	      return this.disabled || (this.elForm || {}).disabled;
	    }
	  },
	
	  watch: {
	    value: function value(val) {
	      if (!val) {
	        this.showPanelColor = false;
	      } else if (val && val !== this.color.value) {
	        this.color.fromString(val);
	      }
	    },
	
	    color: {
	      deep: true,
	      handler: function handler() {
	        this.showPanelColor = true;
	      }
	    },
	    displayedColor: function displayedColor(val) {
	      if (!this.showPicker) return;
	      var currentValueColor = new src_color({
	        enableAlpha: this.showAlpha,
	        format: this.colorFormat
	      });
	      currentValueColor.fromString(this.value);
	
	      var currentValueColorRgb = this.displayedRgb(currentValueColor, this.showAlpha);
	      if (val !== currentValueColorRgb) {
	        this.$emit('active-change', val);
	      }
	    }
	  },
	
	  methods: {
	    handleTrigger: function handleTrigger() {
	      if (this.colorDisabled) return;
	      this.showPicker = !this.showPicker;
	    },
	    confirmValue: function confirmValue() {
	      var value = this.color.value;
	      this.$emit('input', value);
	      this.$emit('change', value);
	      this.dispatch('ElFormItem', 'el.form.change', value);
	      this.showPicker = false;
	    },
	    clearValue: function clearValue() {
	      this.$emit('input', null);
	      this.$emit('change', null);
	      if (this.value !== null) {
	        this.dispatch('ElFormItem', 'el.form.change', null);
	      }
	      this.showPanelColor = false;
	      this.showPicker = false;
	      this.resetColor();
	    },
	    hide: function hide() {
	      this.showPicker = false;
	      this.resetColor();
	    },
	    resetColor: function resetColor() {
	      var _this = this;
	
	      this.$nextTick(function (_) {
	        if (_this.value) {
	          _this.color.fromString(_this.value);
	        } else {
	          _this.showPanelColor = false;
	        }
	      });
	    },
	    displayedRgb: function displayedRgb(color, showAlpha) {
	      if (!(color instanceof src_color)) {
	        throw Error('color should be instance of Color Class');
	      }
	
	      var _color$toRgb = color.toRgb(),
	          r = _color$toRgb.r,
	          g = _color$toRgb.g,
	          b = _color$toRgb.b;
	
	      return showAlpha ? 'rgba(' + r + ', ' + g + ', ' + b + ', ' + color.get('alpha') / 100 + ')' : 'rgb(' + r + ', ' + g + ', ' + b + ')';
	    }
	  },
	
	  mounted: function mounted() {
	    var value = this.value;
	    if (value) {
	      this.color.fromString(value);
	    }
	    this.popperElm = this.$refs.dropdown.$el;
	  },
	  data: function data() {
	    var color = new src_color({
	      enableAlpha: this.showAlpha,
	      format: this.colorFormat
	    });
	
	    return {
	      color: color,
	      showPicker: false,
	      showPanelColor: false
	    };
	  },
	
	
	  components: {
	    PickerDropdown: picker_dropdown
	  }
	});
	// CONCATENATED MODULE: ./packages/color-picker/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_color_picker_src_mainvue_type_script_lang_js_ = (color_picker_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/color-picker/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var color_picker_src_main_component = normalizeComponent(
	  packages_color_picker_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_55c8ade7_render,
	  mainvue_type_template_id_55c8ade7_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var color_picker_src_main_api; }
	color_picker_src_main_component.options.__file = "packages/color-picker/src/main.vue"
	/* harmony default export */ var color_picker_src_main = (color_picker_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/color-picker/index.js
	
	
	/* istanbul ignore next */
	color_picker_src_main.install = function (Vue) {
	  Vue.component(color_picker_src_main.name, color_picker_src_main);
	};
	
	/* harmony default export */ var color_picker = (color_picker_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/transfer/src/main.vue?vue&type=template&id=5c654dd8&
	var mainvue_type_template_id_5c654dd8_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    { staticClass: "el-transfer" },
	    [
	      _c(
	        "transfer-panel",
	        _vm._b(
	          {
	            ref: "leftPanel",
	            attrs: {
	              data: _vm.sourceData,
	              title: _vm.titles[0] || _vm.t("el.transfer.titles.0"),
	              "default-checked": _vm.leftDefaultChecked,
	              placeholder:
	                _vm.filterPlaceholder || _vm.t("el.transfer.filterPlaceholder")
	            },
	            on: { "checked-change": _vm.onSourceCheckedChange }
	          },
	          "transfer-panel",
	          _vm.$props,
	          false
	        ),
	        [_vm._t("left-footer")],
	        2
	      ),
	      _c(
	        "div",
	        { staticClass: "el-transfer__buttons" },
	        [
	          _c(
	            "el-button",
	            {
	              class: [
	                "el-transfer__button",
	                _vm.hasButtonTexts ? "is-with-texts" : ""
	              ],
	              attrs: {
	                type: "primary",
	                disabled: _vm.rightChecked.length === 0
	              },
	              nativeOn: {
	                click: function($event) {
	                  return _vm.addToLeft($event)
	                }
	              }
	            },
	            [
	              _c("i", { staticClass: "el-icon-arrow-left" }),
	              _vm.buttonTexts[0] !== undefined
	                ? _c("span", [_vm._v(_vm._s(_vm.buttonTexts[0]))])
	                : _vm._e()
	            ]
	          ),
	          _c(
	            "el-button",
	            {
	              class: [
	                "el-transfer__button",
	                _vm.hasButtonTexts ? "is-with-texts" : ""
	              ],
	              attrs: {
	                type: "primary",
	                disabled: _vm.leftChecked.length === 0
	              },
	              nativeOn: {
	                click: function($event) {
	                  return _vm.addToRight($event)
	                }
	              }
	            },
	            [
	              _vm.buttonTexts[1] !== undefined
	                ? _c("span", [_vm._v(_vm._s(_vm.buttonTexts[1]))])
	                : _vm._e(),
	              _c("i", { staticClass: "el-icon-arrow-right" })
	            ]
	          )
	        ],
	        1
	      ),
	      _c(
	        "transfer-panel",
	        _vm._b(
	          {
	            ref: "rightPanel",
	            attrs: {
	              data: _vm.targetData,
	              title: _vm.titles[1] || _vm.t("el.transfer.titles.1"),
	              "default-checked": _vm.rightDefaultChecked,
	              placeholder:
	                _vm.filterPlaceholder || _vm.t("el.transfer.filterPlaceholder")
	            },
	            on: { "checked-change": _vm.onTargetCheckedChange }
	          },
	          "transfer-panel",
	          _vm.$props,
	          false
	        ),
	        [_vm._t("right-footer")],
	        2
	      )
	    ],
	    1
	  )
	}
	var mainvue_type_template_id_5c654dd8_staticRenderFns = []
	mainvue_type_template_id_5c654dd8_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/transfer/src/main.vue?vue&type=template&id=5c654dd8&
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/transfer/src/transfer-panel.vue?vue&type=template&id=2ddab8bd&
	var transfer_panelvue_type_template_id_2ddab8bd_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("div", { staticClass: "el-transfer-panel" }, [
	    _c(
	      "p",
	      { staticClass: "el-transfer-panel__header" },
	      [
	        _c(
	          "el-checkbox",
	          {
	            attrs: { indeterminate: _vm.isIndeterminate },
	            on: { change: _vm.handleAllCheckedChange },
	            model: {
	              value: _vm.allChecked,
	              callback: function($$v) {
	                _vm.allChecked = $$v
	              },
	              expression: "allChecked"
	            }
	          },
	          [
	            _vm._v("\n      " + _vm._s(_vm.title) + "\n      "),
	            _c("span", [_vm._v(_vm._s(_vm.checkedSummary))])
	          ]
	        )
	      ],
	      1
	    ),
	    _c(
	      "div",
	      {
	        class: [
	          "el-transfer-panel__body",
	          _vm.hasFooter ? "is-with-footer" : ""
	        ]
	      },
	      [
	        _vm.filterable
	          ? _c(
	              "el-input",
	              {
	                staticClass: "el-transfer-panel__filter",
	                attrs: { size: "small", placeholder: _vm.placeholder },
	                nativeOn: {
	                  mouseenter: function($event) {
	                    _vm.inputHover = true
	                  },
	                  mouseleave: function($event) {
	                    _vm.inputHover = false
	                  }
	                },
	                model: {
	                  value: _vm.query,
	                  callback: function($$v) {
	                    _vm.query = $$v
	                  },
	                  expression: "query"
	                }
	              },
	              [
	                _c("i", {
	                  class: ["el-input__icon", "el-icon-" + _vm.inputIcon],
	                  attrs: { slot: "prefix" },
	                  on: { click: _vm.clearQuery },
	                  slot: "prefix"
	                })
	              ]
	            )
	          : _vm._e(),
	        _c(
	          "el-checkbox-group",
	          {
	            directives: [
	              {
	                name: "show",
	                rawName: "v-show",
	                value: !_vm.hasNoMatch && _vm.data.length > 0,
	                expression: "!hasNoMatch && data.length > 0"
	              }
	            ],
	            staticClass: "el-transfer-panel__list",
	            class: { "is-filterable": _vm.filterable },
	            model: {
	              value: _vm.checked,
	              callback: function($$v) {
	                _vm.checked = $$v
	              },
	              expression: "checked"
	            }
	          },
	          _vm._l(_vm.filteredData, function(item) {
	            return _c(
	              "el-checkbox",
	              {
	                key: item[_vm.keyProp],
	                staticClass: "el-transfer-panel__item",
	                attrs: {
	                  label: item[_vm.keyProp],
	                  disabled: item[_vm.disabledProp]
	                }
	              },
	              [_c("option-content", { attrs: { option: item } })],
	              1
	            )
	          }),
	          1
	        ),
	        _c(
	          "p",
	          {
	            directives: [
	              {
	                name: "show",
	                rawName: "v-show",
	                value: _vm.hasNoMatch,
	                expression: "hasNoMatch"
	              }
	            ],
	            staticClass: "el-transfer-panel__empty"
	          },
	          [_vm._v(_vm._s(_vm.t("el.transfer.noMatch")))]
	        ),
	        _c(
	          "p",
	          {
	            directives: [
	              {
	                name: "show",
	                rawName: "v-show",
	                value: _vm.data.length === 0 && !_vm.hasNoMatch,
	                expression: "data.length === 0 && !hasNoMatch"
	              }
	            ],
	            staticClass: "el-transfer-panel__empty"
	          },
	          [_vm._v(_vm._s(_vm.t("el.transfer.noData")))]
	        )
	      ],
	      1
	    ),
	    _vm.hasFooter
	      ? _c(
	          "p",
	          { staticClass: "el-transfer-panel__footer" },
	          [_vm._t("default")],
	          2
	        )
	      : _vm._e()
	  ])
	}
	var transfer_panelvue_type_template_id_2ddab8bd_staticRenderFns = []
	transfer_panelvue_type_template_id_2ddab8bd_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/transfer/src/transfer-panel.vue?vue&type=template&id=2ddab8bd&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/transfer/src/transfer-panel.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	/* harmony default export */ var transfer_panelvue_type_script_lang_js_ = ({
	  mixins: [locale_default.a],
	
	  name: 'ElTransferPanel',
	
	  componentName: 'ElTransferPanel',
	
	  components: {
	    ElCheckboxGroup: checkbox_group_default.a,
	    ElCheckbox: checkbox_default.a,
	    ElInput: input_default.a,
	    OptionContent: {
	      props: {
	        option: Object
	      },
	      render: function render(h) {
	        var getParent = function getParent(vm) {
	          if (vm.$options.componentName === 'ElTransferPanel') {
	            return vm;
	          } else if (vm.$parent) {
	            return getParent(vm.$parent);
	          } else {
	            return vm;
	          }
	        };
	        var panel = getParent(this);
	        var transfer = panel.$parent || panel;
	        return panel.renderContent ? panel.renderContent(h, this.option) : transfer.$scopedSlots.default ? transfer.$scopedSlots.default({ option: this.option }) : h('span', [this.option[panel.labelProp] || this.option[panel.keyProp]]);
	      }
	    }
	  },
	
	  props: {
	    data: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    renderContent: Function,
	    placeholder: String,
	    title: String,
	    filterable: Boolean,
	    format: Object,
	    filterMethod: Function,
	    defaultChecked: Array,
	    props: Object
	  },
	
	  data: function data() {
	    return {
	      checked: [],
	      allChecked: false,
	      query: '',
	      inputHover: false,
	      checkChangeByUser: true
	    };
	  },
	
	
	  watch: {
	    checked: function checked(val, oldVal) {
	      this.updateAllChecked();
	      if (this.checkChangeByUser) {
	        var movedKeys = val.concat(oldVal).filter(function (v) {
	          return val.indexOf(v) === -1 || oldVal.indexOf(v) === -1;
	        });
	        this.$emit('checked-change', val, movedKeys);
	      } else {
	        this.$emit('checked-change', val);
	        this.checkChangeByUser = true;
	      }
	    },
	    data: function data() {
	      var _this = this;
	
	      var checked = [];
	      var filteredDataKeys = this.filteredData.map(function (item) {
	        return item[_this.keyProp];
	      });
	      this.checked.forEach(function (item) {
	        if (filteredDataKeys.indexOf(item) > -1) {
	          checked.push(item);
	        }
	      });
	      this.checkChangeByUser = false;
	      this.checked = checked;
	    },
	    checkableData: function checkableData() {
	      this.updateAllChecked();
	    },
	
	
	    defaultChecked: {
	      immediate: true,
	      handler: function handler(val, oldVal) {
	        var _this2 = this;
	
	        if (oldVal && val.length === oldVal.length && val.every(function (item) {
	          return oldVal.indexOf(item) > -1;
	        })) return;
	        var checked = [];
	        var checkableDataKeys = this.checkableData.map(function (item) {
	          return item[_this2.keyProp];
	        });
	        val.forEach(function (item) {
	          if (checkableDataKeys.indexOf(item) > -1) {
	            checked.push(item);
	          }
	        });
	        this.checkChangeByUser = false;
	        this.checked = checked;
	      }
	    }
	  },
	
	  computed: {
	    filteredData: function filteredData() {
	      var _this3 = this;
	
	      return this.data.filter(function (item) {
	        if (typeof _this3.filterMethod === 'function') {
	          return _this3.filterMethod(_this3.query, item);
	        } else {
	          var label = item[_this3.labelProp] || item[_this3.keyProp].toString();
	          return label.toLowerCase().indexOf(_this3.query.toLowerCase()) > -1;
	        }
	      });
	    },
	    checkableData: function checkableData() {
	      var _this4 = this;
	
	      return this.filteredData.filter(function (item) {
	        return !item[_this4.disabledProp];
	      });
	    },
	    checkedSummary: function checkedSummary() {
	      var checkedLength = this.checked.length;
	      var dataLength = this.data.length;
	      var _format = this.format,
	          noChecked = _format.noChecked,
	          hasChecked = _format.hasChecked;
	
	      if (noChecked && hasChecked) {
	        return checkedLength > 0 ? hasChecked.replace(/\${checked}/g, checkedLength).replace(/\${total}/g, dataLength) : noChecked.replace(/\${total}/g, dataLength);
	      } else {
	        return checkedLength + '/' + dataLength;
	      }
	    },
	    isIndeterminate: function isIndeterminate() {
	      var checkedLength = this.checked.length;
	      return checkedLength > 0 && checkedLength < this.checkableData.length;
	    },
	    hasNoMatch: function hasNoMatch() {
	      return this.query.length > 0 && this.filteredData.length === 0;
	    },
	    inputIcon: function inputIcon() {
	      return this.query.length > 0 && this.inputHover ? 'circle-close' : 'search';
	    },
	    labelProp: function labelProp() {
	      return this.props.label || 'label';
	    },
	    keyProp: function keyProp() {
	      return this.props.key || 'key';
	    },
	    disabledProp: function disabledProp() {
	      return this.props.disabled || 'disabled';
	    },
	    hasFooter: function hasFooter() {
	      return !!this.$slots.default;
	    }
	  },
	
	  methods: {
	    updateAllChecked: function updateAllChecked() {
	      var _this5 = this;
	
	      var checkableDataKeys = this.checkableData.map(function (item) {
	        return item[_this5.keyProp];
	      });
	      this.allChecked = checkableDataKeys.length > 0 && checkableDataKeys.every(function (item) {
	        return _this5.checked.indexOf(item) > -1;
	      });
	    },
	    handleAllCheckedChange: function handleAllCheckedChange(value) {
	      var _this6 = this;
	
	      this.checked = value ? this.checkableData.map(function (item) {
	        return item[_this6.keyProp];
	      }) : [];
	    },
	    clearQuery: function clearQuery() {
	      if (this.inputIcon === 'circle-close') {
	        this.query = '';
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/transfer/src/transfer-panel.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_transfer_panelvue_type_script_lang_js_ = (transfer_panelvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/transfer/src/transfer-panel.vue
	
	
	
	
	
	/* normalize component */
	
	var transfer_panel_component = normalizeComponent(
	  src_transfer_panelvue_type_script_lang_js_,
	  transfer_panelvue_type_template_id_2ddab8bd_render,
	  transfer_panelvue_type_template_id_2ddab8bd_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var transfer_panel_api; }
	transfer_panel_component.options.__file = "packages/transfer/src/transfer-panel.vue"
	/* harmony default export */ var transfer_panel = (transfer_panel_component.exports);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/transfer/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	/* harmony default export */ var transfer_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElTransfer',
	
	  mixins: [emitter_default.a, locale_default.a, migrating_default.a],
	
	  components: {
	    TransferPanel: transfer_panel,
	    ElButton: button_default.a
	  },
	
	  props: {
	    data: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    titles: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    buttonTexts: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    filterPlaceholder: {
	      type: String,
	      default: ''
	    },
	    filterMethod: Function,
	    leftDefaultChecked: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    rightDefaultChecked: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    renderContent: Function,
	    value: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    format: {
	      type: Object,
	      default: function _default() {
	        return {};
	      }
	    },
	    filterable: Boolean,
	    props: {
	      type: Object,
	      default: function _default() {
	        return {
	          label: 'label',
	          key: 'key',
	          disabled: 'disabled'
	        };
	      }
	    },
	    targetOrder: {
	      type: String,
	      default: 'original'
	    }
	  },
	
	  data: function data() {
	    return {
	      leftChecked: [],
	      rightChecked: []
	    };
	  },
	
	
	  computed: {
	    dataObj: function dataObj() {
	      var key = this.props.key;
	      return this.data.reduce(function (o, cur) {
	        return (o[cur[key]] = cur) && o;
	      }, {});
	    },
	    sourceData: function sourceData() {
	      var _this = this;
	
	      return this.data.filter(function (item) {
	        return _this.value.indexOf(item[_this.props.key]) === -1;
	      });
	    },
	    targetData: function targetData() {
	      var _this2 = this;
	
	      if (this.targetOrder === 'original') {
	        return this.data.filter(function (item) {
	          return _this2.value.indexOf(item[_this2.props.key]) > -1;
	        });
	      } else {
	        return this.value.reduce(function (arr, cur) {
	          var val = _this2.dataObj[cur];
	          if (val) {
	            arr.push(val);
	          }
	          return arr;
	        }, []);
	      }
	    },
	    hasButtonTexts: function hasButtonTexts() {
	      return this.buttonTexts.length === 2;
	    }
	  },
	
	  watch: {
	    value: function value(val) {
	      this.dispatch('ElFormItem', 'el.form.change', val);
	    }
	  },
	
	  methods: {
	    getMigratingConfig: function getMigratingConfig() {
	      return {
	        props: {
	          'footer-format': 'footer-format is renamed to format.'
	        }
	      };
	    },
	    onSourceCheckedChange: function onSourceCheckedChange(val, movedKeys) {
	      this.leftChecked = val;
	      if (movedKeys === undefined) return;
	      this.$emit('left-check-change', val, movedKeys);
	    },
	    onTargetCheckedChange: function onTargetCheckedChange(val, movedKeys) {
	      this.rightChecked = val;
	      if (movedKeys === undefined) return;
	      this.$emit('right-check-change', val, movedKeys);
	    },
	    addToLeft: function addToLeft() {
	      var currentValue = this.value.slice();
	      this.rightChecked.forEach(function (item) {
	        var index = currentValue.indexOf(item);
	        if (index > -1) {
	          currentValue.splice(index, 1);
	        }
	      });
	      this.$emit('input', currentValue);
	      this.$emit('change', currentValue, 'left', this.rightChecked);
	    },
	    addToRight: function addToRight() {
	      var _this3 = this;
	
	      var currentValue = this.value.slice();
	      var itemsToBeMoved = [];
	      var key = this.props.key;
	      this.data.forEach(function (item) {
	        var itemKey = item[key];
	        if (_this3.leftChecked.indexOf(itemKey) > -1 && _this3.value.indexOf(itemKey) === -1) {
	          itemsToBeMoved.push(itemKey);
	        }
	      });
	      currentValue = this.targetOrder === 'unshift' ? itemsToBeMoved.concat(currentValue) : currentValue.concat(itemsToBeMoved);
	      this.$emit('input', currentValue);
	      this.$emit('change', currentValue, 'right', this.leftChecked);
	    },
	    clearQuery: function clearQuery(which) {
	      if (which === 'left') {
	        this.$refs.leftPanel.query = '';
	      } else if (which === 'right') {
	        this.$refs.rightPanel.query = '';
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/transfer/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_transfer_src_mainvue_type_script_lang_js_ = (transfer_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/transfer/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var transfer_src_main_component = normalizeComponent(
	  packages_transfer_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_5c654dd8_render,
	  mainvue_type_template_id_5c654dd8_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var transfer_src_main_api; }
	transfer_src_main_component.options.__file = "packages/transfer/src/main.vue"
	/* harmony default export */ var transfer_src_main = (transfer_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/transfer/index.js
	
	
	/* istanbul ignore next */
	transfer_src_main.install = function (Vue) {
	  Vue.component(transfer_src_main.name, transfer_src_main);
	};
	
	/* harmony default export */ var transfer = (transfer_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/container/src/main.vue?vue&type=template&id=5bf181d4&
	var mainvue_type_template_id_5bf181d4_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "section",
	    { staticClass: "el-container", class: { "is-vertical": _vm.isVertical } },
	    [_vm._t("default")],
	    2
	  )
	}
	var mainvue_type_template_id_5bf181d4_staticRenderFns = []
	mainvue_type_template_id_5bf181d4_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/container/src/main.vue?vue&type=template&id=5bf181d4&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/container/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var container_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElContainer',
	
	  componentName: 'ElContainer',
	
	  props: {
	    direction: String
	  },
	
	  computed: {
	    isVertical: function isVertical() {
	      if (this.direction === 'vertical') {
	        return true;
	      } else if (this.direction === 'horizontal') {
	        return false;
	      }
	      return this.$slots && this.$slots.default ? this.$slots.default.some(function (vnode) {
	        var tag = vnode.componentOptions && vnode.componentOptions.tag;
	        return tag === 'el-header' || tag === 'el-footer';
	      }) : false;
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/container/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_container_src_mainvue_type_script_lang_js_ = (container_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/container/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var container_src_main_component = normalizeComponent(
	  packages_container_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_5bf181d4_render,
	  mainvue_type_template_id_5bf181d4_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var container_src_main_api; }
	container_src_main_component.options.__file = "packages/container/src/main.vue"
	/* harmony default export */ var container_src_main = (container_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/container/index.js
	
	
	/* istanbul ignore next */
	container_src_main.install = function (Vue) {
	  Vue.component(container_src_main.name, container_src_main);
	};
	
	/* harmony default export */ var packages_container = (container_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/header/src/main.vue?vue&type=template&id=2b296ab2&
	var mainvue_type_template_id_2b296ab2_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "header",
	    { staticClass: "el-header", style: { height: _vm.height } },
	    [_vm._t("default")],
	    2
	  )
	}
	var mainvue_type_template_id_2b296ab2_staticRenderFns = []
	mainvue_type_template_id_2b296ab2_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/header/src/main.vue?vue&type=template&id=2b296ab2&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/header/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var header_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElHeader',
	
	  componentName: 'ElHeader',
	
	  props: {
	    height: {
	      type: String,
	      default: '60px'
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/header/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_header_src_mainvue_type_script_lang_js_ = (header_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/header/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var header_src_main_component = normalizeComponent(
	  packages_header_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_2b296ab2_render,
	  mainvue_type_template_id_2b296ab2_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var header_src_main_api; }
	header_src_main_component.options.__file = "packages/header/src/main.vue"
	/* harmony default export */ var header_src_main = (header_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/header/index.js
	
	
	/* istanbul ignore next */
	header_src_main.install = function (Vue) {
	  Vue.component(header_src_main.name, header_src_main);
	};
	
	/* harmony default export */ var header = (header_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/aside/src/main.vue?vue&type=template&id=03411dbf&
	var mainvue_type_template_id_03411dbf_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "aside",
	    { staticClass: "el-aside", style: { width: _vm.width } },
	    [_vm._t("default")],
	    2
	  )
	}
	var mainvue_type_template_id_03411dbf_staticRenderFns = []
	mainvue_type_template_id_03411dbf_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/aside/src/main.vue?vue&type=template&id=03411dbf&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/aside/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var aside_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElAside',
	
	  componentName: 'ElAside',
	
	  props: {
	    width: {
	      type: String,
	      default: '300px'
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/aside/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_aside_src_mainvue_type_script_lang_js_ = (aside_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/aside/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var aside_src_main_component = normalizeComponent(
	  packages_aside_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_03411dbf_render,
	  mainvue_type_template_id_03411dbf_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var aside_src_main_api; }
	aside_src_main_component.options.__file = "packages/aside/src/main.vue"
	/* harmony default export */ var aside_src_main = (aside_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/aside/index.js
	
	
	/* istanbul ignore next */
	aside_src_main.install = function (Vue) {
	  Vue.component(aside_src_main.name, aside_src_main);
	};
	
	/* harmony default export */ var aside = (aside_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/main/src/main.vue?vue&type=template&id=2a3a7406&
	var mainvue_type_template_id_2a3a7406_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("main", { staticClass: "el-main" }, [_vm._t("default")], 2)
	}
	var mainvue_type_template_id_2a3a7406_staticRenderFns = []
	mainvue_type_template_id_2a3a7406_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/main/src/main.vue?vue&type=template&id=2a3a7406&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/main/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var main_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElMain',
	  componentName: 'ElMain'
	});
	// CONCATENATED MODULE: ./packages/main/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_main_src_mainvue_type_script_lang_js_ = (main_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/main/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var main_src_main_component = normalizeComponent(
	  packages_main_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_2a3a7406_render,
	  mainvue_type_template_id_2a3a7406_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var main_src_main_api; }
	main_src_main_component.options.__file = "packages/main/src/main.vue"
	/* harmony default export */ var main_src_main = (main_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/main/index.js
	
	
	/* istanbul ignore next */
	main_src_main.install = function (Vue) {
	  Vue.component(main_src_main.name, main_src_main);
	};
	
	/* harmony default export */ var packages_main = (main_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/footer/src/main.vue?vue&type=template&id=80210338&
	var mainvue_type_template_id_80210338_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "footer",
	    { staticClass: "el-footer", style: { height: _vm.height } },
	    [_vm._t("default")],
	    2
	  )
	}
	var mainvue_type_template_id_80210338_staticRenderFns = []
	mainvue_type_template_id_80210338_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/footer/src/main.vue?vue&type=template&id=80210338&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/footer/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var footer_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElFooter',
	
	  componentName: 'ElFooter',
	
	  props: {
	    height: {
	      type: String,
	      default: '60px'
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/footer/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_footer_src_mainvue_type_script_lang_js_ = (footer_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/footer/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var footer_src_main_component = normalizeComponent(
	  packages_footer_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_80210338_render,
	  mainvue_type_template_id_80210338_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var footer_src_main_api; }
	footer_src_main_component.options.__file = "packages/footer/src/main.vue"
	/* harmony default export */ var footer_src_main = (footer_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/footer/index.js
	
	
	/* istanbul ignore next */
	footer_src_main.install = function (Vue) {
	  Vue.component(footer_src_main.name, footer_src_main);
	};
	
	/* harmony default export */ var footer = (footer_src_main);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/timeline/src/main.vue?vue&type=script&lang=js&
	
	/* harmony default export */ var timeline_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElTimeline',
	
	  props: {
	    reverse: {
	      type: Boolean,
	      default: false
	    }
	  },
	
	  provide: function provide() {
	    return {
	      timeline: this
	    };
	  },
	  render: function render() {
	    var h = arguments[0];
	
	    var reverse = this.reverse;
	    var classes = {
	      'el-timeline': true,
	      'is-reverse': reverse
	    };
	    var slots = this.$slots.default || [];
	    if (reverse) {
	      slots = slots.reverse();
	    }
	    return h(
	      'ul',
	      { 'class': classes },
	      [slots]
	    );
	  }
	});
	// CONCATENATED MODULE: ./packages/timeline/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_timeline_src_mainvue_type_script_lang_js_ = (timeline_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/timeline/src/main.vue
	var main_render, main_staticRenderFns
	
	
	
	
	/* normalize component */
	
	var timeline_src_main_component = normalizeComponent(
	  packages_timeline_src_mainvue_type_script_lang_js_,
	  main_render,
	  main_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var timeline_src_main_api; }
	timeline_src_main_component.options.__file = "packages/timeline/src/main.vue"
	/* harmony default export */ var timeline_src_main = (timeline_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/timeline/index.js
	
	
	/* istanbul ignore next */
	timeline_src_main.install = function (Vue) {
	  Vue.component(timeline_src_main.name, timeline_src_main);
	};
	
	/* harmony default export */ var timeline = (timeline_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/timeline/src/item.vue?vue&type=template&id=61a69e50&
	var itemvue_type_template_id_61a69e50_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("li", { staticClass: "el-timeline-item" }, [
	    _c("div", { staticClass: "el-timeline-item__tail" }),
	    !_vm.$slots.dot
	      ? _c(
	          "div",
	          {
	            staticClass: "el-timeline-item__node",
	            class: [
	              "el-timeline-item__node--" + (_vm.size || ""),
	              "el-timeline-item__node--" + (_vm.type || "")
	            ],
	            style: {
	              backgroundColor: _vm.color
	            }
	          },
	          [
	            _vm.icon
	              ? _c("i", {
	                  staticClass: "el-timeline-item__icon",
	                  class: _vm.icon
	                })
	              : _vm._e()
	          ]
	        )
	      : _vm._e(),
	    _vm.$slots.dot
	      ? _c("div", { staticClass: "el-timeline-item__dot" }, [_vm._t("dot")], 2)
	      : _vm._e(),
	    _c("div", { staticClass: "el-timeline-item__wrapper" }, [
	      !_vm.hideTimestamp && _vm.placement === "top"
	        ? _c("div", { staticClass: "el-timeline-item__timestamp is-top" }, [
	            _vm._v("\n      " + _vm._s(_vm.timestamp) + "\n    ")
	          ])
	        : _vm._e(),
	      _c(
	        "div",
	        { staticClass: "el-timeline-item__content" },
	        [_vm._t("default")],
	        2
	      ),
	      !_vm.hideTimestamp && _vm.placement === "bottom"
	        ? _c("div", { staticClass: "el-timeline-item__timestamp is-bottom" }, [
	            _vm._v("\n      " + _vm._s(_vm.timestamp) + "\n    ")
	          ])
	        : _vm._e()
	    ])
	  ])
	}
	var itemvue_type_template_id_61a69e50_staticRenderFns = []
	itemvue_type_template_id_61a69e50_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/timeline/src/item.vue?vue&type=template&id=61a69e50&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/timeline/src/item.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var timeline_src_itemvue_type_script_lang_js_ = ({
	  name: 'ElTimelineItem',
	
	  inject: ['timeline'],
	
	  props: {
	    timestamp: String,
	
	    hideTimestamp: {
	      type: Boolean,
	      default: false
	    },
	
	    placement: {
	      type: String,
	      default: 'bottom'
	    },
	
	    type: String,
	
	    color: String,
	
	    size: {
	      type: String,
	      default: 'normal'
	    },
	
	    icon: String
	  }
	});
	// CONCATENATED MODULE: ./packages/timeline/src/item.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_timeline_src_itemvue_type_script_lang_js_ = (timeline_src_itemvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/timeline/src/item.vue
	
	
	
	
	
	/* normalize component */
	
	var src_item_component = normalizeComponent(
	  packages_timeline_src_itemvue_type_script_lang_js_,
	  itemvue_type_template_id_61a69e50_render,
	  itemvue_type_template_id_61a69e50_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var src_item_api; }
	src_item_component.options.__file = "packages/timeline/src/item.vue"
	/* harmony default export */ var timeline_src_item = (src_item_component.exports);
	// CONCATENATED MODULE: ./packages/timeline-item/index.js
	
	
	/* istanbul ignore next */
	timeline_src_item.install = function (Vue) {
	  Vue.component(timeline_src_item.name, timeline_src_item);
	};
	
	/* harmony default export */ var timeline_item = (timeline_src_item);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/link/src/main.vue?vue&type=template&id=01cf3b65&
	var mainvue_type_template_id_01cf3b65_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "a",
	    _vm._b(
	      {
	        class: [
	          "el-link",
	          _vm.type ? "el-link--" + _vm.type : "",
	          _vm.disabled && "is-disabled",
	          _vm.underline && !_vm.disabled && "is-underline"
	        ],
	        attrs: { href: _vm.disabled ? null : _vm.href },
	        on: { click: _vm.handleClick }
	      },
	      "a",
	      _vm.$attrs,
	      false
	    ),
	    [
	      _vm.icon ? _c("i", { class: _vm.icon }) : _vm._e(),
	      _vm.$slots.default
	        ? _c("span", { staticClass: "el-link--inner" }, [_vm._t("default")], 2)
	        : _vm._e(),
	      _vm.$slots.icon ? [_vm.$slots.icon ? _vm._t("icon") : _vm._e()] : _vm._e()
	    ],
	    2
	  )
	}
	var mainvue_type_template_id_01cf3b65_staticRenderFns = []
	mainvue_type_template_id_01cf3b65_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/link/src/main.vue?vue&type=template&id=01cf3b65&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/link/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	/* harmony default export */ var link_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElLink',
	
	  props: {
	    type: {
	      type: String,
	      default: 'default'
	    },
	    underline: {
	      type: Boolean,
	      default: true
	    },
	    disabled: Boolean,
	    href: String,
	    icon: String
	  },
	
	  methods: {
	    handleClick: function handleClick(event) {
	      if (!this.disabled) {
	        if (!this.href) {
	          this.$emit('click', event);
	        }
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/link/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_link_src_mainvue_type_script_lang_js_ = (link_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/link/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var link_src_main_component = normalizeComponent(
	  packages_link_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_01cf3b65_render,
	  mainvue_type_template_id_01cf3b65_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var link_src_main_api; }
	link_src_main_component.options.__file = "packages/link/src/main.vue"
	/* harmony default export */ var link_src_main = (link_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/link/index.js
	
	
	/* istanbul ignore next */
	link_src_main.install = function (Vue) {
	  Vue.component(link_src_main.name, link_src_main);
	};
	
	/* harmony default export */ var packages_link = (link_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/divider/src/main.vue?vue&type=template&id=7fa02a7e&functional=true&
	var mainvue_type_template_id_7fa02a7e_functional_true_render = function(_h, _vm) {
	  var _c = _vm._c
	  return _c(
	    "div",
	    _vm._g(
	      _vm._b(
	        {
	          class: [
	            _vm.data.staticClass,
	            "el-divider",
	            "el-divider--" + _vm.props.direction
	          ]
	        },
	        "div",
	        _vm.data.attrs,
	        false
	      ),
	      _vm.listeners
	    ),
	    [
	      _vm.slots().default && _vm.props.direction !== "vertical"
	        ? _c(
	            "div",
	            { class: ["el-divider__text", "is-" + _vm.props.contentPosition] },
	            [_vm._t("default")],
	            2
	          )
	        : _vm._e()
	    ]
	  )
	}
	var mainvue_type_template_id_7fa02a7e_functional_true_staticRenderFns = []
	mainvue_type_template_id_7fa02a7e_functional_true_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/divider/src/main.vue?vue&type=template&id=7fa02a7e&functional=true&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/divider/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var divider_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElDivider',
	  props: {
	    direction: {
	      type: String,
	      default: 'horizontal',
	      validator: function validator(val) {
	        return ['horizontal', 'vertical'].indexOf(val) !== -1;
	      }
	    },
	    contentPosition: {
	      type: String,
	      default: 'center',
	      validator: function validator(val) {
	        return ['left', 'center', 'right'].indexOf(val) !== -1;
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/divider/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_divider_src_mainvue_type_script_lang_js_ = (divider_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/divider/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var divider_src_main_component = normalizeComponent(
	  packages_divider_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_7fa02a7e_functional_true_render,
	  mainvue_type_template_id_7fa02a7e_functional_true_staticRenderFns,
	  true,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var divider_src_main_api; }
	divider_src_main_component.options.__file = "packages/divider/src/main.vue"
	/* harmony default export */ var divider_src_main = (divider_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/divider/index.js
	
	
	/* istanbul ignore next */
	divider_src_main.install = function (Vue) {
	  Vue.component(divider_src_main.name, divider_src_main);
	};
	
	/* harmony default export */ var divider = (divider_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/image/src/main.vue?vue&type=template&id=44d84a7c&
	var mainvue_type_template_id_44d84a7c_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    { staticClass: "el-image" },
	    [
	      _vm.loading
	        ? _vm._t("placeholder", [
	            _c("div", { staticClass: "el-image__placeholder" })
	          ])
	        : _vm.error
	        ? _vm._t("error", [
	            _c("div", { staticClass: "el-image__error" }, [
	              _vm._v(_vm._s(_vm.t("el.image.error")))
	            ])
	          ])
	        : _c(
	            "img",
	            _vm._g(
	              _vm._b(
	                {
	                  staticClass: "el-image__inner",
	                  class: {
	                    "el-image__inner--center": _vm.alignCenter,
	                    "el-image__preview": _vm.preview
	                  },
	                  style: _vm.imageStyle,
	                  attrs: { src: _vm.src },
	                  on: { click: _vm.clickHandler }
	                },
	                "img",
	                _vm.$attrs,
	                false
	              ),
	              _vm.$listeners
	            )
	          ),
	      _vm.preview
	        ? [
	            _c("image-viewer", {
	              directives: [
	                {
	                  name: "show",
	                  rawName: "v-show",
	                  value: _vm.showViewer,
	                  expression: "showViewer"
	                }
	              ],
	              attrs: {
	                "z-index": _vm.zIndex,
	                "initial-index": _vm.imageIndex,
	                "on-close": _vm.closeViewer,
	                "url-list": _vm.previewSrcList
	              }
	            })
	          ]
	        : _vm._e()
	    ],
	    2
	  )
	}
	var mainvue_type_template_id_44d84a7c_staticRenderFns = []
	mainvue_type_template_id_44d84a7c_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/image/src/main.vue?vue&type=template&id=44d84a7c&
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/image/src/image-viewer.vue?vue&type=template&id=5e73b307&
	var image_viewervue_type_template_id_5e73b307_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("transition", { attrs: { name: "viewer-fade" } }, [
	    _c(
	      "div",
	      {
	        ref: "el-image-viewer__wrapper",
	        staticClass: "el-image-viewer__wrapper",
	        style: { "z-index": _vm.zIndex },
	        attrs: { tabindex: "-1" }
	      },
	      [
	        _c("div", { staticClass: "el-image-viewer__mask" }),
	        _c(
	          "span",
	          {
	            staticClass: "el-image-viewer__btn el-image-viewer__close",
	            on: { click: _vm.hide }
	          },
	          [_c("i", { staticClass: "el-icon-circle-close" })]
	        ),
	        !_vm.isSingle
	          ? [
	              _c(
	                "span",
	                {
	                  staticClass: "el-image-viewer__btn el-image-viewer__prev",
	                  class: { "is-disabled": !_vm.infinite && _vm.isFirst },
	                  on: { click: _vm.prev }
	                },
	                [_c("i", { staticClass: "el-icon-arrow-left" })]
	              ),
	              _c(
	                "span",
	                {
	                  staticClass: "el-image-viewer__btn el-image-viewer__next",
	                  class: { "is-disabled": !_vm.infinite && _vm.isLast },
	                  on: { click: _vm.next }
	                },
	                [_c("i", { staticClass: "el-icon-arrow-right" })]
	              )
	            ]
	          : _vm._e(),
	        _c(
	          "div",
	          { staticClass: "el-image-viewer__btn el-image-viewer__actions" },
	          [
	            _c("div", { staticClass: "el-image-viewer__actions__inner" }, [
	              _c("i", {
	                staticClass: "el-icon-zoom-out",
	                on: {
	                  click: function($event) {
	                    _vm.handleActions("zoomOut")
	                  }
	                }
	              }),
	              _c("i", {
	                staticClass: "el-icon-zoom-in",
	                on: {
	                  click: function($event) {
	                    _vm.handleActions("zoomIn")
	                  }
	                }
	              }),
	              _c("i", { staticClass: "el-image-viewer__actions__divider" }),
	              _c("i", { class: _vm.mode.icon, on: { click: _vm.toggleMode } }),
	              _c("i", { staticClass: "el-image-viewer__actions__divider" }),
	              _c("i", {
	                staticClass: "el-icon-refresh-left",
	                on: {
	                  click: function($event) {
	                    _vm.handleActions("anticlocelise")
	                  }
	                }
	              }),
	              _c("i", {
	                staticClass: "el-icon-refresh-right",
	                on: {
	                  click: function($event) {
	                    _vm.handleActions("clocelise")
	                  }
	                }
	              })
	            ])
	          ]
	        ),
	        _c(
	          "div",
	          { staticClass: "el-image-viewer__canvas" },
	          _vm._l(_vm.urlList, function(url, i) {
	            return i === _vm.index
	              ? _c("img", {
	                  key: url,
	                  ref: "img",
	                  refInFor: true,
	                  staticClass: "el-image-viewer__img",
	                  style: _vm.imgStyle,
	                  attrs: { src: _vm.currentImg },
	                  on: {
	                    load: _vm.handleImgLoad,
	                    error: _vm.handleImgError,
	                    mousedown: _vm.handleMouseDown
	                  }
	                })
	              : _vm._e()
	          }),
	          0
	        )
	      ],
	      2
	    )
	  ])
	}
	var image_viewervue_type_template_id_5e73b307_staticRenderFns = []
	image_viewervue_type_template_id_5e73b307_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/image/src/image-viewer.vue?vue&type=template&id=5e73b307&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/image/src/image-viewer.vue?vue&type=script&lang=js&
	var image_viewervue_type_script_lang_js_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	var Mode = {
	  CONTAIN: {
	    name: 'contain',
	    icon: 'el-icon-full-screen'
	  },
	  ORIGINAL: {
	    name: 'original',
	    icon: 'el-icon-c-scale-to-original'
	  }
	};
	
	var mousewheelEventName = Object(util_["isFirefox"])() ? 'DOMMouseScroll' : 'mousewheel';
	
	/* harmony default export */ var image_viewervue_type_script_lang_js_ = ({
	  name: 'elImageViewer',
	
	  props: {
	    urlList: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    zIndex: {
	      type: Number,
	      default: 2000
	    },
	    onSwitch: {
	      type: Function,
	      default: function _default() {}
	    },
	    onClose: {
	      type: Function,
	      default: function _default() {}
	    },
	    initialIndex: {
	      type: Number,
	      default: 0
	    }
	  },
	
	  data: function data() {
	    return {
	      index: this.initialIndex,
	      isShow: false,
	      infinite: true,
	      loading: false,
	      mode: Mode.CONTAIN,
	      transform: {
	        scale: 1,
	        deg: 0,
	        offsetX: 0,
	        offsetY: 0,
	        enableTransition: false
	      }
	    };
	  },
	
	  computed: {
	    isSingle: function isSingle() {
	      return this.urlList.length <= 1;
	    },
	    isFirst: function isFirst() {
	      return this.index === 0;
	    },
	    isLast: function isLast() {
	      return this.index === this.urlList.length - 1;
	    },
	    currentImg: function currentImg() {
	      return this.urlList[this.index];
	    },
	    imgStyle: function imgStyle() {
	      var _transform = this.transform,
	          scale = _transform.scale,
	          deg = _transform.deg,
	          offsetX = _transform.offsetX,
	          offsetY = _transform.offsetY,
	          enableTransition = _transform.enableTransition;
	
	      var style = {
	        transform: 'scale(' + scale + ') rotate(' + deg + 'deg)',
	        transition: enableTransition ? 'transform .3s' : '',
	        'margin-left': offsetX + 'px',
	        'margin-top': offsetY + 'px'
	      };
	      if (this.mode === Mode.CONTAIN) {
	        style.maxWidth = style.maxHeight = '100%';
	      }
	      return style;
	    }
	  },
	  watch: {
	    index: {
	      handler: function handler(val) {
	        this.reset();
	        this.onSwitch(val);
	      }
	    },
	    currentImg: function currentImg(val) {
	      var _this = this;
	
	      this.$nextTick(function (_) {
	        var $img = _this.$refs.img[0];
	        if (!$img.complete) {
	          _this.loading = true;
	        }
	      });
	    }
	  },
	  methods: {
	    hide: function hide() {
	      this.deviceSupportUninstall();
	      this.onClose();
	    },
	    deviceSupportInstall: function deviceSupportInstall() {
	      var _this2 = this;
	
	      this._keyDownHandler = Object(util_["rafThrottle"])(function (e) {
	        var keyCode = e.keyCode;
	        switch (keyCode) {
	          // ESC
	          case 27:
	            _this2.hide();
	            break;
	          // SPACE
	          case 32:
	            _this2.toggleMode();
	            break;
	          // LEFT_ARROW
	          case 37:
	            _this2.prev();
	            break;
	          // UP_ARROW
	          case 38:
	            _this2.handleActions('zoomIn');
	            break;
	          // RIGHT_ARROW
	          case 39:
	            _this2.next();
	            break;
	          // DOWN_ARROW
	          case 40:
	            _this2.handleActions('zoomOut');
	            break;
	        }
	      });
	      this._mouseWheelHandler = Object(util_["rafThrottle"])(function (e) {
	        var delta = e.wheelDelta ? e.wheelDelta : -e.detail;
	        if (delta > 0) {
	          _this2.handleActions('zoomIn', {
	            zoomRate: 0.015,
	            enableTransition: false
	          });
	        } else {
	          _this2.handleActions('zoomOut', {
	            zoomRate: 0.015,
	            enableTransition: false
	          });
	        }
	      });
	      Object(dom_["on"])(document, 'keydown', this._keyDownHandler);
	      Object(dom_["on"])(document, mousewheelEventName, this._mouseWheelHandler);
	    },
	    deviceSupportUninstall: function deviceSupportUninstall() {
	      Object(dom_["off"])(document, 'keydown', this._keyDownHandler);
	      Object(dom_["off"])(document, mousewheelEventName, this._mouseWheelHandler);
	      this._keyDownHandler = null;
	      this._mouseWheelHandler = null;
	    },
	    handleImgLoad: function handleImgLoad(e) {
	      this.loading = false;
	    },
	    handleImgError: function handleImgError(e) {
	      this.loading = false;
	      e.target.alt = '加载失败';
	    },
	    handleMouseDown: function handleMouseDown(e) {
	      var _this3 = this;
	
	      if (this.loading || e.button !== 0) return;
	
	      var _transform2 = this.transform,
	          offsetX = _transform2.offsetX,
	          offsetY = _transform2.offsetY;
	
	      var startX = e.pageX;
	      var startY = e.pageY;
	      this._dragHandler = Object(util_["rafThrottle"])(function (ev) {
	        _this3.transform.offsetX = offsetX + ev.pageX - startX;
	        _this3.transform.offsetY = offsetY + ev.pageY - startY;
	      });
	      Object(dom_["on"])(document, 'mousemove', this._dragHandler);
	      Object(dom_["on"])(document, 'mouseup', function (ev) {
	        Object(dom_["off"])(document, 'mousemove', _this3._dragHandler);
	      });
	
	      e.preventDefault();
	    },
	    reset: function reset() {
	      this.transform = {
	        scale: 1,
	        deg: 0,
	        offsetX: 0,
	        offsetY: 0,
	        enableTransition: false
	      };
	    },
	    toggleMode: function toggleMode() {
	      if (this.loading) return;
	
	      var modeNames = Object.keys(Mode);
	      var modeValues = Object.values(Mode);
	      var index = modeValues.indexOf(this.mode);
	      var nextIndex = (index + 1) % modeNames.length;
	      this.mode = Mode[modeNames[nextIndex]];
	      this.reset();
	    },
	    prev: function prev() {
	      if (this.isFirst && !this.infinite) return;
	      var len = this.urlList.length;
	      this.index = (this.index - 1 + len) % len;
	    },
	    next: function next() {
	      if (this.isLast && !this.infinite) return;
	      var len = this.urlList.length;
	      this.index = (this.index + 1) % len;
	    },
	    handleActions: function handleActions(action) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      if (this.loading) return;
	
	      var _zoomRate$rotateDeg$e = image_viewervue_type_script_lang_js_extends({
	        zoomRate: 0.2,
	        rotateDeg: 90,
	        enableTransition: true
	      }, options),
	          zoomRate = _zoomRate$rotateDeg$e.zoomRate,
	          rotateDeg = _zoomRate$rotateDeg$e.rotateDeg,
	          enableTransition = _zoomRate$rotateDeg$e.enableTransition;
	
	      var transform = this.transform;
	
	      switch (action) {
	        case 'zoomOut':
	          if (transform.scale > 0.2) {
	            transform.scale = parseFloat((transform.scale - zoomRate).toFixed(3));
	          }
	          break;
	        case 'zoomIn':
	          transform.scale = parseFloat((transform.scale + zoomRate).toFixed(3));
	          break;
	        case 'clocelise':
	          transform.deg += rotateDeg;
	          break;
	        case 'anticlocelise':
	          transform.deg -= rotateDeg;
	          break;
	      }
	      transform.enableTransition = enableTransition;
	    }
	  },
	  mounted: function mounted() {
	    this.deviceSupportInstall();
	    // add tabindex then wrapper can be focusable via Javascript
	    // focus wrapper so arrow key can't cause inner scroll behavior underneath
	    this.$refs['el-image-viewer__wrapper'].focus();
	  }
	});
	// CONCATENATED MODULE: ./packages/image/src/image-viewer.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_image_viewervue_type_script_lang_js_ = (image_viewervue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/image/src/image-viewer.vue
	
	
	
	
	
	/* normalize component */
	
	var image_viewer_component = normalizeComponent(
	  src_image_viewervue_type_script_lang_js_,
	  image_viewervue_type_template_id_5e73b307_render,
	  image_viewervue_type_template_id_5e73b307_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var image_viewer_api; }
	image_viewer_component.options.__file = "packages/image/src/image-viewer.vue"
	/* harmony default export */ var image_viewer = (image_viewer_component.exports);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/image/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	var isSupportObjectFit = function isSupportObjectFit() {
	  return document.documentElement.style.objectFit !== undefined;
	};
	
	var ObjectFit = {
	  NONE: 'none',
	  CONTAIN: 'contain',
	  COVER: 'cover',
	  FILL: 'fill',
	  SCALE_DOWN: 'scale-down'
	};
	
	var prevOverflow = '';
	
	/* harmony default export */ var image_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElImage',
	
	  mixins: [locale_default.a],
	  inheritAttrs: false,
	
	  components: {
	    ImageViewer: image_viewer
	  },
	
	  props: {
	    src: String,
	    fit: String,
	    lazy: Boolean,
	    scrollContainer: {},
	    previewSrcList: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    zIndex: {
	      type: Number,
	      default: 2000
	    }
	  },
	
	  data: function data() {
	    return {
	      loading: true,
	      error: false,
	      show: !this.lazy,
	      imageWidth: 0,
	      imageHeight: 0,
	      showViewer: false
	    };
	  },
	
	
	  computed: {
	    imageStyle: function imageStyle() {
	      var fit = this.fit;
	
	      if (!this.$isServer && fit) {
	        return isSupportObjectFit() ? { 'object-fit': fit } : this.getImageStyle(fit);
	      }
	      return {};
	    },
	    alignCenter: function alignCenter() {
	      return !this.$isServer && !isSupportObjectFit() && this.fit !== ObjectFit.FILL;
	    },
	    preview: function preview() {
	      var previewSrcList = this.previewSrcList;
	
	      return Array.isArray(previewSrcList) && previewSrcList.length > 0;
	    },
	    imageIndex: function imageIndex() {
	      return this.previewSrcList.indexOf(this.src);
	    }
	  },
	
	  watch: {
	    src: function src(val) {
	      this.show && this.loadImage();
	    },
	    show: function show(val) {
	      val && this.loadImage();
	    }
	  },
	
	  mounted: function mounted() {
	    if (this.lazy) {
	      this.addLazyLoadListener();
	    } else {
	      this.loadImage();
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.lazy && this.removeLazyLoadListener();
	  },
	
	
	  methods: {
	    loadImage: function loadImage() {
	      var _this = this;
	
	      if (this.$isServer) return;
	
	      // reset status
	      this.loading = true;
	      this.error = false;
	
	      var img = new Image();
	      img.onload = function (e) {
	        return _this.handleLoad(e, img);
	      };
	      img.onerror = this.handleError.bind(this);
	
	      // bind html attrs
	      // so it can behave consistently
	      Object.keys(this.$attrs).forEach(function (key) {
	        var value = _this.$attrs[key];
	        img.setAttribute(key, value);
	      });
	      img.src = this.src;
	    },
	    handleLoad: function handleLoad(e, img) {
	      this.imageWidth = img.width;
	      this.imageHeight = img.height;
	      this.loading = false;
	    },
	    handleError: function handleError(e) {
	      this.loading = false;
	      this.error = true;
	      this.$emit('error', e);
	    },
	    handleLazyLoad: function handleLazyLoad() {
	      if (Object(dom_["isInContainer"])(this.$el, this._scrollContainer)) {
	        this.show = true;
	        this.removeLazyLoadListener();
	      }
	    },
	    addLazyLoadListener: function addLazyLoadListener() {
	      if (this.$isServer) return;
	
	      var scrollContainer = this.scrollContainer;
	
	      var _scrollContainer = null;
	
	      if (Object(types_["isHtmlElement"])(scrollContainer)) {
	        _scrollContainer = scrollContainer;
	      } else if (Object(types_["isString"])(scrollContainer)) {
	        _scrollContainer = document.querySelector(scrollContainer);
	      } else {
	        _scrollContainer = Object(dom_["getScrollContainer"])(this.$el);
	      }
	
	      if (_scrollContainer) {
	        this._scrollContainer = _scrollContainer;
	        this._lazyLoadHandler = throttle_default()(200, this.handleLazyLoad);
	        Object(dom_["on"])(_scrollContainer, 'scroll', this._lazyLoadHandler);
	        this.handleLazyLoad();
	      }
	    },
	    removeLazyLoadListener: function removeLazyLoadListener() {
	      var _scrollContainer = this._scrollContainer,
	          _lazyLoadHandler = this._lazyLoadHandler;
	
	
	      if (this.$isServer || !_scrollContainer || !_lazyLoadHandler) return;
	
	      Object(dom_["off"])(_scrollContainer, 'scroll', _lazyLoadHandler);
	      this._scrollContainer = null;
	      this._lazyLoadHandler = null;
	    },
	
	    /**
	     * simulate object-fit behavior to compatible with IE11 and other browsers which not support object-fit
	     */
	    getImageStyle: function getImageStyle(fit) {
	      var imageWidth = this.imageWidth,
	          imageHeight = this.imageHeight;
	      var _$el = this.$el,
	          containerWidth = _$el.clientWidth,
	          containerHeight = _$el.clientHeight;
	
	
	      if (!imageWidth || !imageHeight || !containerWidth || !containerHeight) return {};
	
	      var vertical = imageWidth / imageHeight < 1;
	
	      if (fit === ObjectFit.SCALE_DOWN) {
	        var isSmaller = imageWidth < containerWidth && imageHeight < containerHeight;
	        fit = isSmaller ? ObjectFit.NONE : ObjectFit.CONTAIN;
	      }
	
	      switch (fit) {
	        case ObjectFit.NONE:
	          return { width: 'auto', height: 'auto' };
	        case ObjectFit.CONTAIN:
	          return vertical ? { width: 'auto' } : { height: 'auto' };
	        case ObjectFit.COVER:
	          return vertical ? { height: 'auto' } : { width: 'auto' };
	        default:
	          return {};
	      }
	    },
	    clickHandler: function clickHandler() {
	      // prevent body scroll
	      prevOverflow = document.body.style.overflow;
	      document.body.style.overflow = 'hidden';
	      this.showViewer = true;
	    },
	    closeViewer: function closeViewer() {
	      document.body.style.overflow = prevOverflow;
	      this.showViewer = false;
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/image/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_image_src_mainvue_type_script_lang_js_ = (image_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/image/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var image_src_main_component = normalizeComponent(
	  packages_image_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_44d84a7c_render,
	  mainvue_type_template_id_44d84a7c_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var image_src_main_api; }
	image_src_main_component.options.__file = "packages/image/src/main.vue"
	/* harmony default export */ var image_src_main = (image_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/image/index.js
	
	
	/* istanbul ignore next */
	image_src_main.install = function (Vue) {
	  Vue.component(image_src_main.name, image_src_main);
	};
	
	/* harmony default export */ var packages_image = (image_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/calendar/src/main.vue?vue&type=template&id=6d9756be&
	var mainvue_type_template_id_6d9756be_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("div", { staticClass: "el-calendar" }, [
	    _c("div", { staticClass: "el-calendar__header" }, [
	      _c("div", { staticClass: "el-calendar__title" }, [
	        _vm._v("\n      " + _vm._s(_vm.i18nDate) + "\n    ")
	      ]),
	      _vm.validatedRange.length === 0
	        ? _c(
	            "div",
	            { staticClass: "el-calendar__button-group" },
	            [
	              _c(
	                "el-button-group",
	                [
	                  _c(
	                    "el-button",
	                    {
	                      attrs: { type: "plain", size: "mini" },
	                      on: {
	                        click: function($event) {
	                          _vm.selectDate("prev-month")
	                        }
	                      }
	                    },
	                    [
	                      _vm._v(
	                        "\n          " +
	                          _vm._s(_vm.t("el.datepicker.prevMonth")) +
	                          "\n        "
	                      )
	                    ]
	                  ),
	                  _c(
	                    "el-button",
	                    {
	                      attrs: { type: "plain", size: "mini" },
	                      on: {
	                        click: function($event) {
	                          _vm.selectDate("today")
	                        }
	                      }
	                    },
	                    [
	                      _vm._v(
	                        "\n          " +
	                          _vm._s(_vm.t("el.datepicker.today")) +
	                          "\n        "
	                      )
	                    ]
	                  ),
	                  _c(
	                    "el-button",
	                    {
	                      attrs: { type: "plain", size: "mini" },
	                      on: {
	                        click: function($event) {
	                          _vm.selectDate("next-month")
	                        }
	                      }
	                    },
	                    [
	                      _vm._v(
	                        "\n          " +
	                          _vm._s(_vm.t("el.datepicker.nextMonth")) +
	                          "\n        "
	                      )
	                    ]
	                  )
	                ],
	                1
	              )
	            ],
	            1
	          )
	        : _vm._e()
	    ]),
	    _vm.validatedRange.length === 0
	      ? _c(
	          "div",
	          { key: "no-range", staticClass: "el-calendar__body" },
	          [
	            _c("date-table", {
	              attrs: {
	                date: _vm.date,
	                "selected-day": _vm.realSelectedDay,
	                "first-day-of-week": _vm.realFirstDayOfWeek
	              },
	              on: { pick: _vm.pickDay }
	            })
	          ],
	          1
	        )
	      : _c(
	          "div",
	          { key: "has-range", staticClass: "el-calendar__body" },
	          _vm._l(_vm.validatedRange, function(range, index) {
	            return _c("date-table", {
	              key: index,
	              attrs: {
	                date: range[0],
	                "selected-day": _vm.realSelectedDay,
	                range: range,
	                "hide-header": index !== 0,
	                "first-day-of-week": _vm.realFirstDayOfWeek
	              },
	              on: { pick: _vm.pickDay }
	            })
	          }),
	          1
	        )
	  ])
	}
	var mainvue_type_template_id_6d9756be_staticRenderFns = []
	mainvue_type_template_id_6d9756be_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/calendar/src/main.vue?vue&type=template&id=6d9756be&
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/date"
	var date_ = __webpack_require__(20);
	var date_default = /*#__PURE__*/__webpack_require__.n(date_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/calendar/src/date-table.vue?vue&type=script&lang=js&
	
	
	
	
	/* harmony default export */ var src_date_tablevue_type_script_lang_js_ = ({
	  props: {
	    selectedDay: String, // formated date yyyy-MM-dd
	    range: {
	      type: Array,
	      validator: function validator(val) {
	        if (!(val && val.length)) return true;
	        var start = val[0],
	            end = val[1];
	
	        return Object(date_util_["validateRangeInOneMonth"])(start, end);
	      }
	    },
	    date: Date,
	    hideHeader: Boolean,
	    firstDayOfWeek: Number
	  },
	
	  inject: ['elCalendar'],
	
	  data: function data() {
	    return {
	      WEEK_DAYS: Object(date_util_["getI18nSettings"])().dayNames
	    };
	  },
	
	
	  methods: {
	    toNestedArr: function toNestedArr(days) {
	      return Object(date_util_["range"])(days.length / 7).map(function (_, index) {
	        var start = index * 7;
	        return days.slice(start, start + 7);
	      });
	    },
	    getFormateDate: function getFormateDate(day, type) {
	      if (!day || ['prev', 'current', 'next'].indexOf(type) === -1) {
	        throw new Error('invalid day or type');
	      }
	      var prefix = this.curMonthDatePrefix;
	      if (type === 'prev') {
	        prefix = this.prevMonthDatePrefix;
	      } else if (type === 'next') {
	        prefix = this.nextMonthDatePrefix;
	      }
	      day = ('00' + day).slice(-2);
	      return prefix + '-' + day;
	    },
	    getCellClass: function getCellClass(_ref) {
	      var text = _ref.text,
	          type = _ref.type;
	
	      var classes = [type];
	      if (type === 'current') {
	        var date = this.getFormateDate(text, type);
	        if (date === this.selectedDay) {
	          classes.push('is-selected');
	        }
	        if (date === this.formatedToday) {
	          classes.push('is-today');
	        }
	      }
	      return classes;
	    },
	    pickDay: function pickDay(_ref2) {
	      var text = _ref2.text,
	          type = _ref2.type;
	
	      var date = this.getFormateDate(text, type);
	      this.$emit('pick', date);
	    },
	    cellRenderProxy: function cellRenderProxy(_ref3) {
	      var text = _ref3.text,
	          type = _ref3.type;
	      var h = this.$createElement;
	
	      var render = this.elCalendar.$scopedSlots.dateCell;
	      if (!render) return h('span', [text]);
	
	      var day = this.getFormateDate(text, type);
	      var date = new Date(day);
	      var data = {
	        isSelected: this.selectedDay === day,
	        type: type + '-month',
	        day: day
	      };
	      return render({ date: date, data: data });
	    }
	  },
	
	  computed: {
	    prevMonthDatePrefix: function prevMonthDatePrefix() {
	      var temp = new Date(this.date.getTime());
	      temp.setDate(0);
	      return date_default.a.format(temp, 'yyyy-MM');
	    },
	    curMonthDatePrefix: function curMonthDatePrefix() {
	      return date_default.a.format(this.date, 'yyyy-MM');
	    },
	    nextMonthDatePrefix: function nextMonthDatePrefix() {
	      var temp = new Date(this.date.getFullYear(), this.date.getMonth() + 1, 1);
	      return date_default.a.format(temp, 'yyyy-MM');
	    },
	    formatedToday: function formatedToday() {
	      return this.elCalendar.formatedToday;
	    },
	    isInRange: function isInRange() {
	      return this.range && this.range.length;
	    },
	    rows: function rows() {
	      var days = [];
	      // if range exists, should render days in range.
	      if (this.isInRange) {
	        var _range = this.range,
	            start = _range[0],
	            end = _range[1];
	
	        var currentMonthRange = Object(date_util_["range"])(end.getDate() - start.getDate() + 1).map(function (_, index) {
	          return {
	            text: start.getDate() + index,
	            type: 'current'
	          };
	        });
	        var remaining = currentMonthRange.length % 7;
	        remaining = remaining === 0 ? 0 : 7 - remaining;
	        var nextMonthRange = Object(date_util_["range"])(remaining).map(function (_, index) {
	          return {
	            text: index + 1,
	            type: 'next'
	          };
	        });
	        days = currentMonthRange.concat(nextMonthRange);
	      } else {
	        var date = this.date;
	        var firstDay = Object(date_util_["getFirstDayOfMonth"])(date);
	        firstDay = firstDay === 0 ? 7 : firstDay;
	        var firstDayOfWeek = typeof this.firstDayOfWeek === 'number' ? this.firstDayOfWeek : 1;
	        var prevMonthDays = Object(date_util_["getPrevMonthLastDays"])(date, firstDay - firstDayOfWeek).map(function (day) {
	          return {
	            text: day,
	            type: 'prev'
	          };
	        });
	        var currentMonthDays = Object(date_util_["getMonthDays"])(date).map(function (day) {
	          return {
	            text: day,
	            type: 'current'
	          };
	        });
	        days = [].concat(prevMonthDays, currentMonthDays);
	        var nextMonthDays = Object(date_util_["range"])(42 - days.length).map(function (_, index) {
	          return {
	            text: index + 1,
	            type: 'next'
	          };
	        });
	        days = days.concat(nextMonthDays);
	      }
	      return this.toNestedArr(days);
	    },
	    weekDays: function weekDays() {
	      var start = this.firstDayOfWeek;
	      var WEEK_DAYS = this.WEEK_DAYS;
	
	
	      if (typeof start !== 'number' || start === 0) {
	        return WEEK_DAYS.slice();
	      } else {
	        return WEEK_DAYS.slice(start).concat(WEEK_DAYS.slice(0, start));
	      }
	    }
	  },
	
	  render: function render() {
	    var _this = this;
	
	    var h = arguments[0];
	
	    var thead = this.hideHeader ? null : h('thead', [this.weekDays.map(function (day) {
	      return h(
	        'th',
	        { key: day },
	        [day]
	      );
	    })]);
	    return h(
	      'table',
	      {
	        'class': {
	          'el-calendar-table': true,
	          'is-range': this.isInRange
	        },
	        attrs: { cellspacing: '0',
	          cellpadding: '0' }
	      },
	      [thead, h('tbody', [this.rows.map(function (row, index) {
	        return h(
	          'tr',
	          {
	            'class': {
	              'el-calendar-table__row': true,
	              'el-calendar-table__row--hide-border': index === 0 && _this.hideHeader
	            },
	            key: index },
	          [row.map(function (cell, key) {
	            return h(
	              'td',
	              { key: key,
	                'class': _this.getCellClass(cell),
	                on: {
	                  'click': _this.pickDay.bind(_this, cell)
	                }
	              },
	              [h(
	                'div',
	                { 'class': 'el-calendar-day' },
	                [_this.cellRenderProxy(cell)]
	              )]
	            );
	          })]
	        );
	      })])]
	    );
	  }
	});
	// CONCATENATED MODULE: ./packages/calendar/src/date-table.vue?vue&type=script&lang=js&
	 /* harmony default export */ var calendar_src_date_tablevue_type_script_lang_js_ = (src_date_tablevue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/calendar/src/date-table.vue
	var date_table_render, date_table_staticRenderFns
	
	
	
	
	/* normalize component */
	
	var src_date_table_component = normalizeComponent(
	  calendar_src_date_tablevue_type_script_lang_js_,
	  date_table_render,
	  date_table_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var src_date_table_api; }
	src_date_table_component.options.__file = "packages/calendar/src/date-table.vue"
	/* harmony default export */ var src_date_table = (src_date_table_component.exports);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/calendar/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	
	var validTypes = ['prev-month', 'today', 'next-month'];
	var weekDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
	var oneDay = 86400000;
	
	/* harmony default export */ var calendar_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElCalendar',
	
	  mixins: [locale_default.a],
	
	  components: {
	    DateTable: src_date_table,
	    ElButton: button_default.a,
	    ElButtonGroup: button_group_default.a
	  },
	
	  props: {
	    value: [Date, String, Number],
	    range: {
	      type: Array,
	      validator: function validator(range) {
	        if (Array.isArray(range)) {
	          return range.length === 2 && range.every(function (item) {
	            return typeof item === 'string' || typeof item === 'number' || item instanceof Date;
	          });
	        } else {
	          return true;
	        }
	      }
	    },
	    firstDayOfWeek: {
	      type: Number,
	      default: 1
	    }
	  },
	
	  provide: function provide() {
	    return {
	      elCalendar: this
	    };
	  },
	
	
	  methods: {
	    pickDay: function pickDay(day) {
	      this.realSelectedDay = day;
	    },
	    selectDate: function selectDate(type) {
	      if (validTypes.indexOf(type) === -1) {
	        throw new Error('invalid type ' + type);
	      }
	      var day = '';
	      if (type === 'prev-month') {
	        day = this.prevMonthDatePrefix + '-01';
	      } else if (type === 'next-month') {
	        day = this.nextMonthDatePrefix + '-01';
	      } else {
	        day = this.formatedToday;
	      }
	
	      if (day === this.formatedDate) return;
	      this.pickDay(day);
	    },
	    toDate: function toDate(val) {
	      if (!val) {
	        throw new Error('invalid val');
	      }
	      return val instanceof Date ? val : new Date(val);
	    },
	    rangeValidator: function rangeValidator(date, isStart) {
	      var firstDayOfWeek = this.realFirstDayOfWeek;
	      var expected = isStart ? firstDayOfWeek : firstDayOfWeek === 0 ? 6 : firstDayOfWeek - 1;
	      var message = (isStart ? 'start' : 'end') + ' of range should be ' + weekDays[expected] + '.';
	      if (date.getDay() !== expected) {
	        console.warn('[ElementCalendar]', message, 'Invalid range will be ignored.');
	        return false;
	      }
	      return true;
	    }
	  },
	
	  computed: {
	    prevMonthDatePrefix: function prevMonthDatePrefix() {
	      var temp = new Date(this.date.getTime());
	      temp.setDate(0);
	      return date_default.a.format(temp, 'yyyy-MM');
	    },
	    curMonthDatePrefix: function curMonthDatePrefix() {
	      return date_default.a.format(this.date, 'yyyy-MM');
	    },
	    nextMonthDatePrefix: function nextMonthDatePrefix() {
	      var temp = new Date(this.date.getFullYear(), this.date.getMonth() + 1, 1);
	      return date_default.a.format(temp, 'yyyy-MM');
	    },
	    formatedDate: function formatedDate() {
	      return date_default.a.format(this.date, 'yyyy-MM-dd');
	    },
	    i18nDate: function i18nDate() {
	      var year = this.date.getFullYear();
	      var month = this.date.getMonth() + 1;
	      return year + ' ' + this.t('el.datepicker.year') + ' ' + this.t('el.datepicker.month' + month);
	    },
	    formatedToday: function formatedToday() {
	      return date_default.a.format(this.now, 'yyyy-MM-dd');
	    },
	
	
	    realSelectedDay: {
	      get: function get() {
	        if (!this.value) return this.selectedDay;
	        return this.formatedDate;
	      },
	      set: function set(val) {
	        this.selectedDay = val;
	        var date = new Date(val);
	        this.$emit('input', date);
	      }
	    },
	
	    date: function date() {
	      if (!this.value) {
	        if (this.realSelectedDay) {
	          var d = this.selectedDay.split('-');
	          return new Date(d[0], d[1] - 1, d[2]);
	        } else if (this.validatedRange.length) {
	          return this.validatedRange[0][0];
	        }
	        return this.now;
	      } else {
	        return this.toDate(this.value);
	      }
	    },
	
	
	    // if range is valid, we get a two-digit array
	    validatedRange: function validatedRange() {
	      var _this = this;
	
	      var range = this.range;
	      if (!range) return [];
	      range = range.reduce(function (prev, val, index) {
	        var date = _this.toDate(val);
	        if (_this.rangeValidator(date, index === 0)) {
	          prev = prev.concat(date);
	        }
	        return prev;
	      }, []);
	      if (range.length === 2) {
	        var _range = range,
	            start = _range[0],
	            end = _range[1];
	
	        if (start > end) {
	          console.warn('[ElementCalendar]end time should be greater than start time');
	          return [];
	        }
	        // start time and end time in one month
	        if (Object(date_util_["validateRangeInOneMonth"])(start, end)) {
	          return [[start, end]];
	        }
	        var data = [];
	        var startDay = new Date(start.getFullYear(), start.getMonth() + 1, 1);
	        var lastDay = this.toDate(startDay.getTime() - oneDay);
	        if (!Object(date_util_["validateRangeInOneMonth"])(startDay, end)) {
	          console.warn('[ElementCalendar]start time and end time interval must not exceed two months');
	          return [];
	        }
	        // 第一个月的时间范围
	        data.push([start, lastDay]);
	        // 下一月的时间范围，需要计算一下该月的第一个周起始日
	        var firstDayOfWeek = this.realFirstDayOfWeek;
	        var nextMontFirstDay = startDay.getDay();
	        var interval = 0;
	        if (nextMontFirstDay !== firstDayOfWeek) {
	          if (firstDayOfWeek === 0) {
	            interval = 7 - nextMontFirstDay;
	          } else {
	            interval = firstDayOfWeek - nextMontFirstDay;
	            interval = interval > 0 ? interval : 7 + interval;
	          }
	        }
	        startDay = this.toDate(startDay.getTime() + interval * oneDay);
	        if (startDay.getDate() < end.getDate()) {
	          data.push([startDay, end]);
	        }
	        return data;
	      }
	      return [];
	    },
	    realFirstDayOfWeek: function realFirstDayOfWeek() {
	      if (this.firstDayOfWeek < 1 || this.firstDayOfWeek > 6) {
	        return 0;
	      }
	      return Math.floor(this.firstDayOfWeek);
	    }
	  },
	
	  data: function data() {
	    return {
	      selectedDay: '',
	      now: new Date()
	    };
	  }
	});
	// CONCATENATED MODULE: ./packages/calendar/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_calendar_src_mainvue_type_script_lang_js_ = (calendar_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/calendar/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var calendar_src_main_component = normalizeComponent(
	  packages_calendar_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_6d9756be_render,
	  mainvue_type_template_id_6d9756be_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var calendar_src_main_api; }
	calendar_src_main_component.options.__file = "packages/calendar/src/main.vue"
	/* harmony default export */ var calendar_src_main = (calendar_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/calendar/index.js
	
	
	/* istanbul ignore next */
	calendar_src_main.install = function (Vue) {
	  Vue.component(calendar_src_main.name, calendar_src_main);
	};
	
	/* harmony default export */ var calendar = (calendar_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/backtop/src/main.vue?vue&type=template&id=257dd4a9&
	var mainvue_type_template_id_257dd4a9_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("transition", { attrs: { name: "el-fade-in" } }, [
	    _vm.visible
	      ? _c(
	          "div",
	          {
	            staticClass: "el-backtop",
	            style: {
	              right: _vm.styleRight,
	              bottom: _vm.styleBottom
	            },
	            on: {
	              click: function($event) {
	                $event.stopPropagation()
	                return _vm.handleClick($event)
	              }
	            }
	          },
	          [
	            _vm._t("default", [_c("el-icon", { attrs: { name: "caret-top" } })])
	          ],
	          2
	        )
	      : _vm._e()
	  ])
	}
	var mainvue_type_template_id_257dd4a9_staticRenderFns = []
	mainvue_type_template_id_257dd4a9_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/backtop/src/main.vue?vue&type=template&id=257dd4a9&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/backtop/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	var cubic = function cubic(value) {
	  return Math.pow(value, 3);
	};
	var easeInOutCubic = function easeInOutCubic(value) {
	  return value < 0.5 ? cubic(value * 2) / 2 : 1 - cubic((1 - value) * 2) / 2;
	};
	
	/* harmony default export */ var backtop_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElBacktop',
	
	  props: {
	    visibilityHeight: {
	      type: Number,
	      default: 200
	    },
	    target: [String],
	    right: {
	      type: Number,
	      default: 40
	    },
	    bottom: {
	      type: Number,
	      default: 40
	    }
	  },
	
	  data: function data() {
	    return {
	      el: null,
	      container: null,
	      visible: false
	    };
	  },
	
	
	  computed: {
	    styleBottom: function styleBottom() {
	      return this.bottom + 'px';
	    },
	    styleRight: function styleRight() {
	      return this.right + 'px';
	    }
	  },
	
	  mounted: function mounted() {
	    this.init();
	    this.throttledScrollHandler = throttle_default()(300, this.onScroll);
	    this.container.addEventListener('scroll', this.throttledScrollHandler);
	  },
	
	
	  methods: {
	    init: function init() {
	      this.container = document;
	      this.el = document.documentElement;
	      if (this.target) {
	        this.el = document.querySelector(this.target);
	        if (!this.el) {
	          throw new Error('target is not existed: ' + this.target);
	        }
	        this.container = this.el;
	      }
	    },
	    onScroll: function onScroll() {
	      var scrollTop = this.el.scrollTop;
	      this.visible = scrollTop >= this.visibilityHeight;
	    },
	    handleClick: function handleClick(e) {
	      this.scrollToTop();
	      this.$emit('click', e);
	    },
	    scrollToTop: function scrollToTop() {
	      var el = this.el;
	      var beginTime = Date.now();
	      var beginValue = el.scrollTop;
	      var rAF = window.requestAnimationFrame || function (func) {
	        return setTimeout(func, 16);
	      };
	      var frameFunc = function frameFunc() {
	        var progress = (Date.now() - beginTime) / 500;
	        if (progress < 1) {
	          el.scrollTop = beginValue * (1 - easeInOutCubic(progress));
	          rAF(frameFunc);
	        } else {
	          el.scrollTop = 0;
	        }
	      };
	      rAF(frameFunc);
	    }
	  },
	
	  beforeDestroy: function beforeDestroy() {
	    this.container.removeEventListener('scroll', this.throttledScrollHandler);
	  }
	});
	// CONCATENATED MODULE: ./packages/backtop/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_backtop_src_mainvue_type_script_lang_js_ = (backtop_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/backtop/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var backtop_src_main_component = normalizeComponent(
	  packages_backtop_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_257dd4a9_render,
	  mainvue_type_template_id_257dd4a9_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var backtop_src_main_api; }
	backtop_src_main_component.options.__file = "packages/backtop/src/main.vue"
	/* harmony default export */ var backtop_src_main = (backtop_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/backtop/index.js
	
	
	/* istanbul ignore next */
	backtop_src_main.install = function (Vue) {
	  Vue.component(backtop_src_main.name, backtop_src_main);
	};
	
	/* harmony default export */ var backtop = (backtop_src_main);
	// CONCATENATED MODULE: ./packages/infinite-scroll/src/main.js
	
	
	
	
	var getStyleComputedProperty = function getStyleComputedProperty(element, property) {
	  if (element === window) {
	    element = document.documentElement;
	  }
	
	  if (element.nodeType !== 1) {
	    return [];
	  }
	  // NOTE: 1 DOM access here
	  var css = window.getComputedStyle(element, null);
	  return property ? css[property] : css;
	};
	
	var entries = function entries(obj) {
	  return Object.keys(obj || {}).map(function (key) {
	    return [key, obj[key]];
	  });
	};
	
	var getPositionSize = function getPositionSize(el, prop) {
	  return el === window || el === document ? document.documentElement[prop] : el[prop];
	};
	
	var getOffsetHeight = function getOffsetHeight(el) {
	  return getPositionSize(el, 'offsetHeight');
	};
	
	var getClientHeight = function getClientHeight(el) {
	  return getPositionSize(el, 'clientHeight');
	};
	
	var scope = 'ElInfiniteScroll';
	var attributes = {
	  delay: {
	    type: Number,
	    default: 200
	  },
	  distance: {
	    type: Number,
	    default: 0
	  },
	  disabled: {
	    type: Boolean,
	    default: false
	  },
	  immediate: {
	    type: Boolean,
	    default: true
	  }
	};
	
	var main_getScrollOptions = function getScrollOptions(el, vm) {
	  if (!Object(types_["isHtmlElement"])(el)) return {};
	
	  return entries(attributes).reduce(function (map, _ref) {
	    var key = _ref[0],
	        option = _ref[1];
	    var type = option.type,
	        defaultValue = option.default;
	
	    var value = el.getAttribute('infinite-scroll-' + key);
	    value = Object(types_["isUndefined"])(vm[value]) ? value : vm[value];
	    switch (type) {
	      case Number:
	        value = Number(value);
	        value = Number.isNaN(value) ? defaultValue : value;
	        break;
	      case Boolean:
	        value = Object(types_["isDefined"])(value) ? value === 'false' ? false : Boolean(value) : defaultValue;
	        break;
	      default:
	        value = type(value);
	    }
	    map[key] = value;
	    return map;
	  }, {});
	};
	
	var getElementTop = function getElementTop(el) {
	  return el.getBoundingClientRect().top;
	};
	
	var main_handleScroll = function handleScroll(cb) {
	  var _scope = this[scope],
	      el = _scope.el,
	      vm = _scope.vm,
	      container = _scope.container,
	      observer = _scope.observer;
	
	  var _getScrollOptions = main_getScrollOptions(el, vm),
	      distance = _getScrollOptions.distance,
	      disabled = _getScrollOptions.disabled;
	
	  if (disabled) return;
	
	  var containerInfo = container.getBoundingClientRect();
	  if (!containerInfo.width && !containerInfo.height) return;
	
	  var shouldTrigger = false;
	
	  if (container === el) {
	    // be aware of difference between clientHeight & offsetHeight & window.getComputedStyle().height
	    var scrollBottom = container.scrollTop + getClientHeight(container);
	    shouldTrigger = container.scrollHeight - scrollBottom <= distance;
	  } else {
	    var heightBelowTop = getOffsetHeight(el) + getElementTop(el) - getElementTop(container);
	    var offsetHeight = getOffsetHeight(container);
	    var borderBottom = Number.parseFloat(getStyleComputedProperty(container, 'borderBottomWidth'));
	    shouldTrigger = heightBelowTop - offsetHeight + borderBottom <= distance;
	  }
	
	  if (shouldTrigger && Object(types_["isFunction"])(cb)) {
	    cb.call(vm);
	  } else if (observer) {
	    observer.disconnect();
	    this[scope].observer = null;
	  }
	};
	
	/* harmony default export */ var infinite_scroll_src_main = ({
	  name: 'InfiniteScroll',
	  inserted: function inserted(el, binding, vnode) {
	    var cb = binding.value;
	
	    var vm = vnode.context;
	    // only include vertical scroll
	    var container = Object(dom_["getScrollContainer"])(el, true);
	
	    var _getScrollOptions2 = main_getScrollOptions(el, vm),
	        delay = _getScrollOptions2.delay,
	        immediate = _getScrollOptions2.immediate;
	
	    var onScroll = debounce_default()(delay, main_handleScroll.bind(el, cb));
	
	    el[scope] = { el: el, vm: vm, container: container, onScroll: onScroll };
	
	    if (container) {
	      container.addEventListener('scroll', onScroll);
	
	      if (immediate) {
	        var observer = el[scope].observer = new MutationObserver(onScroll);
	        observer.observe(container, { childList: true, subtree: true });
	        onScroll();
	      }
	    }
	  },
	  unbind: function unbind(el) {
	    var _el$scope = el[scope],
	        container = _el$scope.container,
	        onScroll = _el$scope.onScroll;
	
	    if (container) {
	      container.removeEventListener('scroll', onScroll);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/infinite-scroll/index.js
	
	
	/* istanbul ignore next */
	infinite_scroll_src_main.install = function (Vue) {
	  Vue.directive(infinite_scroll_src_main.name, infinite_scroll_src_main);
	};
	
	/* harmony default export */ var infinite_scroll = (infinite_scroll_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/page-header/src/main.vue?vue&type=template&id=5070954c&
	var mainvue_type_template_id_5070954c_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c("div", { staticClass: "el-page-header" }, [
	    _c(
	      "div",
	      {
	        staticClass: "el-page-header__left",
	        on: {
	          click: function($event) {
	            _vm.$emit("back")
	          }
	        }
	      },
	      [
	        _c("i", { staticClass: "el-icon-back" }),
	        _c(
	          "div",
	          { staticClass: "el-page-header__title" },
	          [_vm._t("title", [_vm._v(_vm._s(_vm.title))])],
	          2
	        )
	      ]
	    ),
	    _c(
	      "div",
	      { staticClass: "el-page-header__content" },
	      [_vm._t("content", [_vm._v(_vm._s(_vm.content))])],
	      2
	    )
	  ])
	}
	var mainvue_type_template_id_5070954c_staticRenderFns = []
	mainvue_type_template_id_5070954c_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/page-header/src/main.vue?vue&type=template&id=5070954c&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/page-header/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	/* harmony default export */ var page_header_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElPageHeader',
	
	  props: {
	    title: {
	      type: String,
	      default: function _default() {
	        return Object(lib_locale_["t"])('el.pageHeader.title');
	      }
	    },
	    content: String
	  }
	});
	// CONCATENATED MODULE: ./packages/page-header/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_page_header_src_mainvue_type_script_lang_js_ = (page_header_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/page-header/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var page_header_src_main_component = normalizeComponent(
	  packages_page_header_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_5070954c_render,
	  mainvue_type_template_id_5070954c_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var page_header_src_main_api; }
	page_header_src_main_component.options.__file = "packages/page-header/src/main.vue"
	/* harmony default export */ var page_header_src_main = (page_header_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/page-header/index.js
	
	
	/* istanbul ignore next */
	page_header_src_main.install = function (Vue) {
	  Vue.component(page_header_src_main.name, page_header_src_main);
	};
	
	/* harmony default export */ var page_header = (page_header_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader-panel/src/cascader-panel.vue?vue&type=template&id=34932346&
	var cascader_panelvue_type_template_id_34932346_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      class: ["el-cascader-panel", _vm.border && "is-bordered"],
	      on: { keydown: _vm.handleKeyDown }
	    },
	    _vm._l(_vm.menus, function(menu, index) {
	      return _c("cascader-menu", {
	        key: index,
	        ref: "menu",
	        refInFor: true,
	        attrs: { index: index, nodes: menu }
	      })
	    }),
	    1
	  )
	}
	var cascader_panelvue_type_template_id_34932346_staticRenderFns = []
	cascader_panelvue_type_template_id_34932346_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-panel.vue?vue&type=template&id=34932346&
	
	// EXTERNAL MODULE: external "element-ui/lib/radio"
	var radio_ = __webpack_require__(43);
	var radio_default = /*#__PURE__*/__webpack_require__.n(radio_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader-panel/src/cascader-node.vue?vue&type=script&lang=js&
	
	
	
	
	
	
	var stopPropagation = function stopPropagation(e) {
	  return e.stopPropagation();
	};
	
	/* harmony default export */ var cascader_nodevue_type_script_lang_js_ = ({
	  inject: ['panel'],
	
	  components: {
	    ElCheckbox: checkbox_default.a,
	    ElRadio: radio_default.a
	  },
	
	  props: {
	    node: {
	      required: true
	    },
	    nodeId: String
	  },
	
	  computed: {
	    config: function config() {
	      return this.panel.config;
	    },
	    isLeaf: function isLeaf() {
	      return this.node.isLeaf;
	    },
	    isDisabled: function isDisabled() {
	      return this.node.isDisabled;
	    },
	    checkedValue: function checkedValue() {
	      return this.panel.checkedValue;
	    },
	    isChecked: function isChecked() {
	      return this.node.isSameNode(this.checkedValue);
	    },
	    inActivePath: function inActivePath() {
	      return this.isInPath(this.panel.activePath);
	    },
	    inCheckedPath: function inCheckedPath() {
	      var _this = this;
	
	      if (!this.config.checkStrictly) return false;
	
	      return this.panel.checkedNodePaths.some(function (checkedPath) {
	        return _this.isInPath(checkedPath);
	      });
	    },
	    value: function value() {
	      return this.node.getValueByOption();
	    }
	  },
	
	  methods: {
	    handleExpand: function handleExpand() {
	      var _this2 = this;
	
	      var panel = this.panel,
	          node = this.node,
	          isDisabled = this.isDisabled,
	          config = this.config;
	      var multiple = config.multiple,
	          checkStrictly = config.checkStrictly;
	
	
	      if (!checkStrictly && isDisabled || node.loading) return;
	
	      if (config.lazy && !node.loaded) {
	        panel.lazyLoad(node, function () {
	          // do not use cached leaf value here, invoke this.isLeaf to get new value.
	          var isLeaf = _this2.isLeaf;
	
	
	          if (!isLeaf) _this2.handleExpand();
	          if (multiple) {
	            // if leaf sync checked state, else clear checked state
	            var checked = isLeaf ? node.checked : false;
	            _this2.handleMultiCheckChange(checked);
	          }
	        });
	      } else {
	        panel.handleExpand(node);
	      }
	    },
	    handleCheckChange: function handleCheckChange() {
	      var panel = this.panel,
	          value = this.value,
	          node = this.node;
	
	      panel.handleCheckChange(value);
	      panel.handleExpand(node);
	    },
	    handleMultiCheckChange: function handleMultiCheckChange(checked) {
	      this.node.doCheck(checked);
	      this.panel.calculateMultiCheckedValue();
	    },
	    isInPath: function isInPath(pathNodes) {
	      var node = this.node;
	
	      var selectedPathNode = pathNodes[node.level - 1] || {};
	      return selectedPathNode.uid === node.uid;
	    },
	    renderPrefix: function renderPrefix(h) {
	      var isLeaf = this.isLeaf,
	          isChecked = this.isChecked,
	          config = this.config;
	      var checkStrictly = config.checkStrictly,
	          multiple = config.multiple;
	
	
	      if (multiple) {
	        return this.renderCheckbox(h);
	      } else if (checkStrictly) {
	        return this.renderRadio(h);
	      } else if (isLeaf && isChecked) {
	        return this.renderCheckIcon(h);
	      }
	
	      return null;
	    },
	    renderPostfix: function renderPostfix(h) {
	      var node = this.node,
	          isLeaf = this.isLeaf;
	
	
	      if (node.loading) {
	        return this.renderLoadingIcon(h);
	      } else if (!isLeaf) {
	        return this.renderExpandIcon(h);
	      }
	
	      return null;
	    },
	    renderCheckbox: function renderCheckbox(h) {
	      var node = this.node,
	          config = this.config,
	          isDisabled = this.isDisabled;
	
	      var events = {
	        on: { change: this.handleMultiCheckChange },
	        nativeOn: {}
	      };
	
	      if (config.checkStrictly) {
	        // when every node is selectable, click event should not trigger expand event.
	        events.nativeOn.click = stopPropagation;
	      }
	
	      return h('el-checkbox', external_babel_helper_vue_jsx_merge_props_default()([{
	        attrs: {
	          value: node.checked,
	          indeterminate: node.indeterminate,
	          disabled: isDisabled
	        }
	      }, events]));
	    },
	    renderRadio: function renderRadio(h) {
	      var checkedValue = this.checkedValue,
	          value = this.value,
	          isDisabled = this.isDisabled;
	
	      // to keep same reference if value cause radio's checked state is calculated by reference comparision;
	
	      if (Object(util_["isEqual"])(value, checkedValue)) {
	        value = checkedValue;
	      }
	
	      return h(
	        'el-radio',
	        {
	          attrs: {
	            value: checkedValue,
	            label: value,
	            disabled: isDisabled
	          },
	          on: {
	            'change': this.handleCheckChange
	          },
	          nativeOn: {
	            'click': stopPropagation
	          }
	        },
	        [h('span')]
	      );
	    },
	    renderCheckIcon: function renderCheckIcon(h) {
	      return h('i', { 'class': 'el-icon-check el-cascader-node__prefix' });
	    },
	    renderLoadingIcon: function renderLoadingIcon(h) {
	      return h('i', { 'class': 'el-icon-loading el-cascader-node__postfix' });
	    },
	    renderExpandIcon: function renderExpandIcon(h) {
	      return h('i', { 'class': 'el-icon-arrow-right el-cascader-node__postfix' });
	    },
	    renderContent: function renderContent(h) {
	      var panel = this.panel,
	          node = this.node;
	
	      var render = panel.renderLabelFn;
	      var vnode = render ? render({ node: node, data: node.data }) : null;
	
	      return h(
	        'span',
	        { 'class': 'el-cascader-node__label' },
	        [vnode || node.label]
	      );
	    }
	  },
	
	  render: function render(h) {
	    var _this3 = this;
	
	    var inActivePath = this.inActivePath,
	        inCheckedPath = this.inCheckedPath,
	        isChecked = this.isChecked,
	        isLeaf = this.isLeaf,
	        isDisabled = this.isDisabled,
	        config = this.config,
	        nodeId = this.nodeId;
	    var expandTrigger = config.expandTrigger,
	        checkStrictly = config.checkStrictly,
	        multiple = config.multiple;
	
	    var disabled = !checkStrictly && isDisabled;
	    var events = { on: {} };
	
	    if (expandTrigger === 'click') {
	      events.on.click = this.handleExpand;
	    } else {
	      events.on.mouseenter = function (e) {
	        _this3.handleExpand();
	        _this3.$emit('expand', e);
	      };
	      events.on.focus = function (e) {
	        _this3.handleExpand();
	        _this3.$emit('expand', e);
	      };
	    }
	    if (isLeaf && !isDisabled && !checkStrictly && !multiple) {
	      events.on.click = this.handleCheckChange;
	    }
	
	    return h(
	      'li',
	      external_babel_helper_vue_jsx_merge_props_default()([{
	        attrs: {
	          role: 'menuitem',
	          id: nodeId,
	          'aria-expanded': inActivePath,
	          tabindex: disabled ? null : -1
	        },
	        'class': {
	          'el-cascader-node': true,
	          'is-selectable': checkStrictly,
	          'in-active-path': inActivePath,
	          'in-checked-path': inCheckedPath,
	          'is-active': isChecked,
	          'is-disabled': disabled
	        }
	      }, events]),
	      [this.renderPrefix(h), this.renderContent(h), this.renderPostfix(h)]
	    );
	  }
	});
	// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-node.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_cascader_nodevue_type_script_lang_js_ = (cascader_nodevue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-node.vue
	var cascader_node_render, cascader_node_staticRenderFns
	
	
	
	
	/* normalize component */
	
	var cascader_node_component = normalizeComponent(
	  src_cascader_nodevue_type_script_lang_js_,
	  cascader_node_render,
	  cascader_node_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var cascader_node_api; }
	cascader_node_component.options.__file = "packages/cascader-panel/src/cascader-node.vue"
	/* harmony default export */ var cascader_node = (cascader_node_component.exports);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader-panel/src/cascader-menu.vue?vue&type=script&lang=js&
	
	
	
	
	
	
	
	/* harmony default export */ var cascader_menuvue_type_script_lang_js_ = ({
	  name: 'ElCascaderMenu',
	
	  mixins: [locale_default.a],
	
	  inject: ['panel'],
	
	  components: {
	    ElScrollbar: scrollbar_default.a,
	    CascaderNode: cascader_node
	  },
	
	  props: {
	    nodes: {
	      type: Array,
	      required: true
	    },
	    index: Number
	  },
	
	  data: function data() {
	    return {
	      activeNode: null,
	      hoverTimer: null,
	      id: Object(util_["generateId"])()
	    };
	  },
	
	
	  computed: {
	    isEmpty: function isEmpty() {
	      return !this.nodes.length;
	    },
	    menuId: function menuId() {
	      return 'cascader-menu-' + this.id + '-' + this.index;
	    }
	  },
	
	  methods: {
	    handleExpand: function handleExpand(e) {
	      this.activeNode = e.target;
	    },
	    handleMouseMove: function handleMouseMove(e) {
	      var activeNode = this.activeNode,
	          hoverTimer = this.hoverTimer;
	      var hoverZone = this.$refs.hoverZone;
	
	
	      if (!activeNode || !hoverZone) return;
	
	      if (activeNode.contains(e.target)) {
	        clearTimeout(hoverTimer);
	
	        var _$el$getBoundingClien = this.$el.getBoundingClientRect(),
	            left = _$el$getBoundingClien.left;
	
	        var startX = e.clientX - left;
	        var _$el = this.$el,
	            offsetWidth = _$el.offsetWidth,
	            offsetHeight = _$el.offsetHeight;
	
	        var top = activeNode.offsetTop;
	        var bottom = top + activeNode.offsetHeight;
	
	        hoverZone.innerHTML = '\n          <path style="pointer-events: auto;" fill="transparent" d="M' + startX + ' ' + top + ' L' + offsetWidth + ' 0 V' + top + ' Z" />\n          <path style="pointer-events: auto;" fill="transparent" d="M' + startX + ' ' + bottom + ' L' + offsetWidth + ' ' + offsetHeight + ' V' + bottom + ' Z" />\n        ';
	      } else if (!hoverTimer) {
	        this.hoverTimer = setTimeout(this.clearHoverZone, this.panel.config.hoverThreshold);
	      }
	    },
	    clearHoverZone: function clearHoverZone() {
	      var hoverZone = this.$refs.hoverZone;
	
	      if (!hoverZone) return;
	      hoverZone.innerHTML = '';
	    },
	    renderEmptyText: function renderEmptyText(h) {
	      return h(
	        'div',
	        { 'class': 'el-cascader-menu__empty-text' },
	        [this.t('el.cascader.noData')]
	      );
	    },
	    renderNodeList: function renderNodeList(h) {
	      var menuId = this.menuId;
	      var isHoverMenu = this.panel.isHoverMenu;
	
	      var events = { on: {} };
	
	      if (isHoverMenu) {
	        events.on.expand = this.handleExpand;
	      }
	
	      var nodes = this.nodes.map(function (node, index) {
	        var hasChildren = node.hasChildren;
	
	        return h('cascader-node', external_babel_helper_vue_jsx_merge_props_default()([{
	          key: node.uid,
	          attrs: { node: node,
	            'node-id': menuId + '-' + index,
	            'aria-haspopup': hasChildren,
	            'aria-owns': hasChildren ? menuId : null
	          }
	        }, events]));
	      });
	
	      return [].concat(nodes, [isHoverMenu ? h('svg', { ref: 'hoverZone', 'class': 'el-cascader-menu__hover-zone' }) : null]);
	    }
	  },
	
	  render: function render(h) {
	    var isEmpty = this.isEmpty,
	        menuId = this.menuId;
	
	    var events = { nativeOn: {} };
	
	    // optimize hover to expand experience (#8010)
	    if (this.panel.isHoverMenu) {
	      events.nativeOn.mousemove = this.handleMouseMove;
	      // events.nativeOn.mouseleave = this.clearHoverZone;
	    }
	
	    return h(
	      'el-scrollbar',
	      external_babel_helper_vue_jsx_merge_props_default()([{
	        attrs: {
	          tag: 'ul',
	          role: 'menu',
	          id: menuId,
	
	          'wrap-class': 'el-cascader-menu__wrap',
	          'view-class': {
	            'el-cascader-menu__list': true,
	            'is-empty': isEmpty
	          }
	        },
	        'class': 'el-cascader-menu' }, events]),
	      [isEmpty ? this.renderEmptyText(h) : this.renderNodeList(h)]
	    );
	  }
	});
	// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-menu.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_cascader_menuvue_type_script_lang_js_ = (cascader_menuvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-menu.vue
	var cascader_menu_render, cascader_menu_staticRenderFns
	
	
	
	
	/* normalize component */
	
	var cascader_menu_component = normalizeComponent(
	  src_cascader_menuvue_type_script_lang_js_,
	  cascader_menu_render,
	  cascader_menu_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var cascader_menu_api; }
	cascader_menu_component.options.__file = "packages/cascader-panel/src/cascader-menu.vue"
	/* harmony default export */ var cascader_menu = (cascader_menu_component.exports);
	// CONCATENATED MODULE: ./packages/cascader-panel/src/node.js
	var node_createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function src_node_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	
	
	
	var uid = 0;
	
	var src_node_Node = function () {
	  function Node(data, config, parentNode) {
	    src_node_classCallCheck(this, Node);
	
	    this.data = data;
	    this.config = config;
	    this.parent = parentNode || null;
	    this.level = !this.parent ? 1 : this.parent.level + 1;
	    this.uid = uid++;
	
	    this.initState();
	    this.initChildren();
	  }
	
	  Node.prototype.initState = function initState() {
	    var _config = this.config,
	        valueKey = _config.value,
	        labelKey = _config.label;
	
	
	    this.value = this.data[valueKey];
	    this.label = this.data[labelKey];
	    this.pathNodes = this.calculatePathNodes();
	    this.path = this.pathNodes.map(function (node) {
	      return node.value;
	    });
	    this.pathLabels = this.pathNodes.map(function (node) {
	      return node.label;
	    });
	
	    // lazy load
	    this.loading = false;
	    this.loaded = false;
	  };
	
	  Node.prototype.initChildren = function initChildren() {
	    var _this = this;
	
	    var config = this.config;
	
	    var childrenKey = config.children;
	    var childrenData = this.data[childrenKey];
	    this.hasChildren = Array.isArray(childrenData);
	    this.children = (childrenData || []).map(function (child) {
	      return new Node(child, config, _this);
	    });
	  };
	
	  Node.prototype.calculatePathNodes = function calculatePathNodes() {
	    var nodes = [this];
	    var parent = this.parent;
	
	    while (parent) {
	      nodes.unshift(parent);
	      parent = parent.parent;
	    }
	
	    return nodes;
	  };
	
	  Node.prototype.getPath = function getPath() {
	    return this.path;
	  };
	
	  Node.prototype.getValue = function getValue() {
	    return this.value;
	  };
	
	  Node.prototype.getValueByOption = function getValueByOption() {
	    return this.config.emitPath ? this.getPath() : this.getValue();
	  };
	
	  Node.prototype.getText = function getText(allLevels, separator) {
	    return allLevels ? this.pathLabels.join(separator) : this.label;
	  };
	
	  Node.prototype.isSameNode = function isSameNode(checkedValue) {
	    var value = this.getValueByOption();
	    return this.config.multiple && Array.isArray(checkedValue) ? checkedValue.some(function (val) {
	      return Object(util_["isEqual"])(val, value);
	    }) : Object(util_["isEqual"])(checkedValue, value);
	  };
	
	  Node.prototype.broadcast = function broadcast(event) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var handlerName = 'onParent' + Object(util_["capitalize"])(event);
	
	    this.children.forEach(function (child) {
	      if (child) {
	        // bottom up
	        child.broadcast.apply(child, [event].concat(args));
	        child[handlerName] && child[handlerName].apply(child, args);
	      }
	    });
	  };
	
	  Node.prototype.emit = function emit(event) {
	    var parent = this.parent;
	
	    var handlerName = 'onChild' + Object(util_["capitalize"])(event);
	    if (parent) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	        args[_key2 - 1] = arguments[_key2];
	      }
	
	      parent[handlerName] && parent[handlerName].apply(parent, args);
	      parent.emit.apply(parent, [event].concat(args));
	    }
	  };
	
	  Node.prototype.onParentCheck = function onParentCheck(checked) {
	    if (!this.isDisabled) {
	      this.setCheckState(checked);
	    }
	  };
	
	  Node.prototype.onChildCheck = function onChildCheck() {
	    var children = this.children;
	
	    var validChildren = children.filter(function (child) {
	      return !child.isDisabled;
	    });
	    var checked = validChildren.length ? validChildren.every(function (child) {
	      return child.checked;
	    }) : false;
	
	    this.setCheckState(checked);
	  };
	
	  Node.prototype.setCheckState = function setCheckState(checked) {
	    var totalNum = this.children.length;
	    var checkedNum = this.children.reduce(function (c, p) {
	      var num = p.checked ? 1 : p.indeterminate ? 0.5 : 0;
	      return c + num;
	    }, 0);
	
	    this.checked = checked;
	    this.indeterminate = checkedNum !== totalNum && checkedNum > 0;
	  };
	
	  Node.prototype.syncCheckState = function syncCheckState(checkedValue) {
	    var value = this.getValueByOption();
	    var checked = this.isSameNode(checkedValue, value);
	
	    this.doCheck(checked);
	  };
	
	  Node.prototype.doCheck = function doCheck(checked) {
	    if (this.checked !== checked) {
	      if (this.config.checkStrictly) {
	        this.checked = checked;
	      } else {
	        // bottom up to unify the calculation of the indeterminate state
	        this.broadcast('check', checked);
	        this.setCheckState(checked);
	        this.emit('check');
	      }
	    }
	  };
	
	  node_createClass(Node, [{
	    key: 'isDisabled',
	    get: function get() {
	      var data = this.data,
	          parent = this.parent,
	          config = this.config;
	
	      var disabledKey = config.disabled;
	      var checkStrictly = config.checkStrictly;
	
	      return data[disabledKey] || !checkStrictly && parent && parent.isDisabled;
	    }
	  }, {
	    key: 'isLeaf',
	    get: function get() {
	      var data = this.data,
	          loaded = this.loaded,
	          hasChildren = this.hasChildren,
	          children = this.children;
	      var _config2 = this.config,
	          lazy = _config2.lazy,
	          leafKey = _config2.leaf;
	
	      if (lazy) {
	        var isLeaf = Object(shared_["isDef"])(data[leafKey]) ? data[leafKey] : loaded ? !children.length : false;
	        this.hasChildren = !isLeaf;
	        return isLeaf;
	      }
	      return !hasChildren;
	    }
	  }]);
	
	  return Node;
	}();
	
	/* harmony default export */ var src_node = (src_node_Node);
	// CONCATENATED MODULE: ./packages/cascader-panel/src/store.js
	function store_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	
	
	
	var flatNodes = function flatNodes(data, leafOnly) {
	  return data.reduce(function (res, node) {
	    if (node.isLeaf) {
	      res.push(node);
	    } else {
	      !leafOnly && res.push(node);
	      res = res.concat(flatNodes(node.children, leafOnly));
	    }
	    return res;
	  }, []);
	};
	
	var store_Store = function () {
	  function Store(data, config) {
	    store_classCallCheck(this, Store);
	
	    this.config = config;
	    this.initNodes(data);
	  }
	
	  Store.prototype.initNodes = function initNodes(data) {
	    var _this = this;
	
	    data = Object(util_["coerceTruthyValueToArray"])(data);
	    this.nodes = data.map(function (nodeData) {
	      return new src_node(nodeData, _this.config);
	    });
	    this.flattedNodes = this.getFlattedNodes(false, false);
	    this.leafNodes = this.getFlattedNodes(true, false);
	  };
	
	  Store.prototype.appendNode = function appendNode(nodeData, parentNode) {
	    var node = new src_node(nodeData, this.config, parentNode);
	    var children = parentNode ? parentNode.children : this.nodes;
	
	    children.push(node);
	  };
	
	  Store.prototype.appendNodes = function appendNodes(nodeDataList, parentNode) {
	    var _this2 = this;
	
	    nodeDataList = Object(util_["coerceTruthyValueToArray"])(nodeDataList);
	    nodeDataList.forEach(function (nodeData) {
	      return _this2.appendNode(nodeData, parentNode);
	    });
	  };
	
	  Store.prototype.getNodes = function getNodes() {
	    return this.nodes;
	  };
	
	  Store.prototype.getFlattedNodes = function getFlattedNodes(leafOnly) {
	    var cached = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    var cachedNodes = leafOnly ? this.leafNodes : this.flattedNodes;
	    return cached ? cachedNodes : flatNodes(this.nodes, leafOnly);
	  };
	
	  Store.prototype.getNodeByValue = function getNodeByValue(value) {
	    if (value) {
	      var nodes = this.getFlattedNodes(false, !this.config.lazy).filter(function (node) {
	        return Object(util_["valueEquals"])(node.path, value) || node.value === value;
	      });
	      return nodes && nodes.length ? nodes[0] : null;
	    }
	    return null;
	  };
	
	  return Store;
	}();
	
	/* harmony default export */ var cascader_panel_src_store = (store_Store);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader-panel/src/cascader-panel.vue?vue&type=script&lang=js&
	var cascader_panelvue_type_script_lang_js_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	
	var cascader_panelvue_type_script_lang_js_KeyCode = aria_utils_default.a.keys;
	
	var DefaultProps = {
	  expandTrigger: 'click', // or hover
	  multiple: false,
	  checkStrictly: false, // whether all nodes can be selected
	  emitPath: true, // wether to emit an array of all levels value in which node is located
	  lazy: false,
	  lazyLoad: util_["noop"],
	  value: 'value',
	  label: 'label',
	  children: 'children',
	  leaf: 'leaf',
	  disabled: 'disabled',
	  hoverThreshold: 500
	};
	
	var cascader_panelvue_type_script_lang_js_isLeaf = function isLeaf(el) {
	  return !el.getAttribute('aria-owns');
	};
	
	var getSibling = function getSibling(el, distance) {
	  var parentNode = el.parentNode;
	
	  if (parentNode) {
	    var siblings = parentNode.querySelectorAll('.el-cascader-node[tabindex="-1"]');
	    var index = Array.prototype.indexOf.call(siblings, el);
	    return siblings[index + distance] || null;
	  }
	  return null;
	};
	
	var getMenuIndex = function getMenuIndex(el, distance) {
	  if (!el) return;
	  var pieces = el.id.split('-');
	  return Number(pieces[pieces.length - 2]);
	};
	
	var focusNode = function focusNode(el) {
	  if (!el) return;
	  el.focus();
	  !cascader_panelvue_type_script_lang_js_isLeaf(el) && el.click();
	};
	
	var checkNode = function checkNode(el) {
	  if (!el) return;
	
	  var input = el.querySelector('input');
	  if (input) {
	    input.click();
	  } else if (cascader_panelvue_type_script_lang_js_isLeaf(el)) {
	    el.click();
	  }
	};
	
	/* harmony default export */ var cascader_panelvue_type_script_lang_js_ = ({
	  name: 'ElCascaderPanel',
	
	  components: {
	    CascaderMenu: cascader_menu
	  },
	
	  props: {
	    value: {},
	    options: Array,
	    props: Object,
	    border: {
	      type: Boolean,
	      default: true
	    },
	    renderLabel: Function
	  },
	
	  provide: function provide() {
	    return {
	      panel: this
	    };
	  },
	  data: function data() {
	    return {
	      checkedValue: null,
	      checkedNodePaths: [],
	      store: [],
	      menus: [],
	      activePath: [],
	      loadCount: 0
	    };
	  },
	
	
	  computed: {
	    config: function config() {
	      return merge_default()(cascader_panelvue_type_script_lang_js_extends({}, DefaultProps), this.props || {});
	    },
	    multiple: function multiple() {
	      return this.config.multiple;
	    },
	    checkStrictly: function checkStrictly() {
	      return this.config.checkStrictly;
	    },
	    leafOnly: function leafOnly() {
	      return !this.checkStrictly;
	    },
	    isHoverMenu: function isHoverMenu() {
	      return this.config.expandTrigger === 'hover';
	    },
	    renderLabelFn: function renderLabelFn() {
	      return this.renderLabel || this.$scopedSlots.default;
	    }
	  },
	
	  watch: {
	    options: {
	      handler: function handler() {
	        this.initStore();
	      },
	      immediate: true,
	      deep: true
	    },
	    value: function value() {
	      this.syncCheckedValue();
	      this.checkStrictly && this.calculateCheckedNodePaths();
	    },
	    checkedValue: function checkedValue(val) {
	      if (!Object(util_["isEqual"])(val, this.value)) {
	        this.checkStrictly && this.calculateCheckedNodePaths();
	        this.$emit('input', val);
	        this.$emit('change', val);
	      }
	    }
	  },
	
	  mounted: function mounted() {
	    if (!Object(util_["isEmpty"])(this.value)) {
	      this.syncCheckedValue();
	    }
	  },
	
	
	  methods: {
	    initStore: function initStore() {
	      var config = this.config,
	          options = this.options;
	
	      if (config.lazy && Object(util_["isEmpty"])(options)) {
	        this.lazyLoad();
	      } else {
	        this.store = new cascader_panel_src_store(options, config);
	        this.menus = [this.store.getNodes()];
	        this.syncMenuState();
	      }
	    },
	    syncCheckedValue: function syncCheckedValue() {
	      var value = this.value,
	          checkedValue = this.checkedValue;
	
	      if (!Object(util_["isEqual"])(value, checkedValue)) {
	        this.checkedValue = value;
	        this.syncMenuState();
	      }
	    },
	    syncMenuState: function syncMenuState() {
	      var multiple = this.multiple,
	          checkStrictly = this.checkStrictly;
	
	      this.syncActivePath();
	      multiple && this.syncMultiCheckState();
	      checkStrictly && this.calculateCheckedNodePaths();
	      this.$nextTick(this.scrollIntoView);
	    },
	    syncMultiCheckState: function syncMultiCheckState() {
	      var _this = this;
	
	      var nodes = this.getFlattedNodes(this.leafOnly);
	
	      nodes.forEach(function (node) {
	        node.syncCheckState(_this.checkedValue);
	      });
	    },
	    syncActivePath: function syncActivePath() {
	      var _this2 = this;
	
	      var store = this.store,
	          multiple = this.multiple,
	          activePath = this.activePath,
	          checkedValue = this.checkedValue;
	
	
	      if (!Object(util_["isEmpty"])(activePath)) {
	        var nodes = activePath.map(function (node) {
	          return _this2.getNodeByValue(node.getValue());
	        });
	        this.expandNodes(nodes);
	      } else if (!Object(util_["isEmpty"])(checkedValue)) {
	        var value = multiple ? checkedValue[0] : checkedValue;
	        var checkedNode = this.getNodeByValue(value) || {};
	        var _nodes = (checkedNode.pathNodes || []).slice(0, -1);
	        this.expandNodes(_nodes);
	      } else {
	        this.activePath = [];
	        this.menus = [store.getNodes()];
	      }
	    },
	    expandNodes: function expandNodes(nodes) {
	      var _this3 = this;
	
	      nodes.forEach(function (node) {
	        return _this3.handleExpand(node, true /* silent */);
	      });
	    },
	    calculateCheckedNodePaths: function calculateCheckedNodePaths() {
	      var _this4 = this;
	
	      var checkedValue = this.checkedValue,
	          multiple = this.multiple;
	
	      var checkedValues = multiple ? Object(util_["coerceTruthyValueToArray"])(checkedValue) : [checkedValue];
	      this.checkedNodePaths = checkedValues.map(function (v) {
	        var checkedNode = _this4.getNodeByValue(v);
	        return checkedNode ? checkedNode.pathNodes : [];
	      });
	    },
	    handleKeyDown: function handleKeyDown(e) {
	      var target = e.target,
	          keyCode = e.keyCode;
	
	
	      switch (keyCode) {
	        case cascader_panelvue_type_script_lang_js_KeyCode.up:
	          var prev = getSibling(target, -1);
	          focusNode(prev);
	          break;
	        case cascader_panelvue_type_script_lang_js_KeyCode.down:
	          var next = getSibling(target, 1);
	          focusNode(next);
	          break;
	        case cascader_panelvue_type_script_lang_js_KeyCode.left:
	          var preMenu = this.$refs.menu[getMenuIndex(target) - 1];
	          if (preMenu) {
	            var expandedNode = preMenu.$el.querySelector('.el-cascader-node[aria-expanded="true"]');
	            focusNode(expandedNode);
	          }
	          break;
	        case cascader_panelvue_type_script_lang_js_KeyCode.right:
	          var nextMenu = this.$refs.menu[getMenuIndex(target) + 1];
	          if (nextMenu) {
	            var firstNode = nextMenu.$el.querySelector('.el-cascader-node[tabindex="-1"]');
	            focusNode(firstNode);
	          }
	          break;
	        case cascader_panelvue_type_script_lang_js_KeyCode.enter:
	          checkNode(target);
	          break;
	        case cascader_panelvue_type_script_lang_js_KeyCode.esc:
	        case cascader_panelvue_type_script_lang_js_KeyCode.tab:
	          this.$emit('close');
	          break;
	        default:
	          return;
	      }
	    },
	    handleExpand: function handleExpand(node, silent) {
	      var activePath = this.activePath;
	      var level = node.level;
	
	      var path = activePath.slice(0, level - 1);
	      var menus = this.menus.slice(0, level);
	
	      if (!node.isLeaf) {
	        path.push(node);
	        menus.push(node.children);
	      }
	
	      this.activePath = path;
	      this.menus = menus;
	
	      if (!silent) {
	        var pathValues = path.map(function (node) {
	          return node.getValue();
	        });
	        var activePathValues = activePath.map(function (node) {
	          return node.getValue();
	        });
	        if (!Object(util_["valueEquals"])(pathValues, activePathValues)) {
	          this.$emit('active-item-change', pathValues); // Deprecated
	          this.$emit('expand-change', pathValues);
	        }
	      }
	    },
	    handleCheckChange: function handleCheckChange(value) {
	      this.checkedValue = value;
	    },
	    lazyLoad: function lazyLoad(node, onFullfiled) {
	      var _this5 = this;
	
	      var config = this.config;
	
	      if (!node) {
	        node = node || { root: true, level: 0 };
	        this.store = new cascader_panel_src_store([], config);
	        this.menus = [this.store.getNodes()];
	      }
	      node.loading = true;
	      var resolve = function resolve(dataList) {
	        var parent = node.root ? null : node;
	        dataList && dataList.length && _this5.store.appendNodes(dataList, parent);
	        node.loading = false;
	        node.loaded = true;
	
	        // dispose default value on lazy load mode
	        if (Array.isArray(_this5.checkedValue)) {
	          var nodeValue = _this5.checkedValue[_this5.loadCount++];
	          var valueKey = _this5.config.value;
	          var leafKey = _this5.config.leaf;
	
	          if (Array.isArray(dataList) && dataList.filter(function (item) {
	            return item[valueKey] === nodeValue;
	          }).length > 0) {
	            var checkedNode = _this5.store.getNodeByValue(nodeValue);
	
	            if (!checkedNode.data[leafKey]) {
	              _this5.lazyLoad(checkedNode, function () {
	                _this5.handleExpand(checkedNode);
	              });
	            }
	
	            if (_this5.loadCount === _this5.checkedValue.length) {
	              _this5.$parent.computePresentText();
	            }
	          }
	        }
	
	        onFullfiled && onFullfiled(dataList);
	      };
	      config.lazyLoad(node, resolve);
	    },
	
	
	    /**
	     * public methods
	    */
	    calculateMultiCheckedValue: function calculateMultiCheckedValue() {
	      this.checkedValue = this.getCheckedNodes(this.leafOnly).map(function (node) {
	        return node.getValueByOption();
	      });
	    },
	    scrollIntoView: function scrollIntoView() {
	      if (this.$isServer) return;
	
	      var menus = this.$refs.menu || [];
	      menus.forEach(function (menu) {
	        var menuElement = menu.$el;
	        if (menuElement) {
	          var container = menuElement.querySelector('.el-scrollbar__wrap');
	          var activeNode = menuElement.querySelector('.el-cascader-node.is-active') || menuElement.querySelector('.el-cascader-node.in-active-path');
	          scroll_into_view_default()(container, activeNode);
	        }
	      });
	    },
	    getNodeByValue: function getNodeByValue(val) {
	      return this.store.getNodeByValue(val);
	    },
	    getFlattedNodes: function getFlattedNodes(leafOnly) {
	      var cached = !this.config.lazy;
	      return this.store.getFlattedNodes(leafOnly, cached);
	    },
	    getCheckedNodes: function getCheckedNodes(leafOnly) {
	      var checkedValue = this.checkedValue,
	          multiple = this.multiple;
	
	      if (multiple) {
	        var nodes = this.getFlattedNodes(leafOnly);
	        return nodes.filter(function (node) {
	          return node.checked;
	        });
	      } else {
	        return Object(util_["isEmpty"])(checkedValue) ? [] : [this.getNodeByValue(checkedValue)];
	      }
	    },
	    clearCheckedNodes: function clearCheckedNodes() {
	      var config = this.config,
	          leafOnly = this.leafOnly;
	      var multiple = config.multiple,
	          emitPath = config.emitPath;
	
	      if (multiple) {
	        this.getCheckedNodes(leafOnly).filter(function (node) {
	          return !node.isDisabled;
	        }).forEach(function (node) {
	          return node.doCheck(false);
	        });
	        this.calculateMultiCheckedValue();
	      } else {
	        this.checkedValue = emitPath ? [] : null;
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-panel.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_cascader_panelvue_type_script_lang_js_ = (cascader_panelvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-panel.vue
	
	
	
	
	
	/* normalize component */
	
	var cascader_panel_component = normalizeComponent(
	  src_cascader_panelvue_type_script_lang_js_,
	  cascader_panelvue_type_template_id_34932346_render,
	  cascader_panelvue_type_template_id_34932346_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var cascader_panel_api; }
	cascader_panel_component.options.__file = "packages/cascader-panel/src/cascader-panel.vue"
	/* harmony default export */ var cascader_panel = (cascader_panel_component.exports);
	// CONCATENATED MODULE: ./packages/cascader-panel/index.js
	
	
	/* istanbul ignore next */
	cascader_panel.install = function (Vue) {
	  Vue.component(cascader_panel.name, cascader_panel);
	};
	
	/* harmony default export */ var packages_cascader_panel = (cascader_panel);
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/avatar/src/main.vue?vue&type=script&lang=js&
	
	/* harmony default export */ var avatar_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElAvatar',
	
	  props: {
	    size: {
	      type: [Number, String],
	      validator: function validator(val) {
	        if (typeof val === 'string') {
	          return ['large', 'medium', 'small'].includes(val);
	        }
	        return typeof val === 'number';
	      }
	    },
	    shape: {
	      type: String,
	      default: 'circle',
	      validator: function validator(val) {
	        return ['circle', 'square'].includes(val);
	      }
	    },
	    icon: String,
	    src: String,
	    alt: String,
	    srcSet: String,
	    error: Function,
	    fit: {
	      type: String,
	      default: 'cover'
	    }
	  },
	
	  data: function data() {
	    return {
	      isImageExist: true
	    };
	  },
	
	
	  computed: {
	    avatarClass: function avatarClass() {
	      var size = this.size,
	          icon = this.icon,
	          shape = this.shape;
	
	      var classList = ['el-avatar'];
	
	      if (size && typeof size === 'string') {
	        classList.push('el-avatar--' + size);
	      }
	
	      if (icon) {
	        classList.push('el-avatar--icon');
	      }
	
	      if (shape) {
	        classList.push('el-avatar--' + shape);
	      }
	
	      return classList.join(' ');
	    }
	  },
	
	  methods: {
	    handleError: function handleError() {
	      var error = this.error;
	
	      var errorFlag = error ? error() : undefined;
	      if (errorFlag !== false) {
	        this.isImageExist = false;
	      }
	    },
	    renderAvatar: function renderAvatar() {
	      var h = this.$createElement;
	      var icon = this.icon,
	          src = this.src,
	          alt = this.alt,
	          isImageExist = this.isImageExist,
	          srcSet = this.srcSet,
	          fit = this.fit;
	
	
	      if (isImageExist && src) {
	        return h('img', {
	          attrs: {
	            src: src,
	
	            alt: alt,
	            srcSet: srcSet
	          },
	          on: {
	            'error': this.handleError
	          },
	          style: { 'object-fit': fit } });
	      }
	
	      if (icon) {
	        return h('i', { 'class': icon });
	      }
	
	      return this.$slots.default;
	    }
	  },
	
	  render: function render() {
	    var h = arguments[0];
	    var avatarClass = this.avatarClass,
	        size = this.size;
	
	
	    var sizeStyle = typeof size === 'number' ? {
	      height: size + 'px',
	      width: size + 'px',
	      lineHeight: size + 'px'
	    } : {};
	
	    return h(
	      'span',
	      { 'class': avatarClass, style: sizeStyle },
	      [this.renderAvatar()]
	    );
	  }
	});
	// CONCATENATED MODULE: ./packages/avatar/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_avatar_src_mainvue_type_script_lang_js_ = (avatar_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/avatar/src/main.vue
	var src_main_render, src_main_staticRenderFns
	
	
	
	
	/* normalize component */
	
	var avatar_src_main_component = normalizeComponent(
	  packages_avatar_src_mainvue_type_script_lang_js_,
	  src_main_render,
	  src_main_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var avatar_src_main_api; }
	avatar_src_main_component.options.__file = "packages/avatar/src/main.vue"
	/* harmony default export */ var avatar_src_main = (avatar_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/avatar/index.js
	
	
	/* istanbul ignore next */
	avatar_src_main.install = function (Vue) {
	  Vue.component(avatar_src_main.name, avatar_src_main);
	};
	
	/* harmony default export */ var avatar = (avatar_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/drawer/src/main.vue?vue&type=template&id=a4885264&
	var mainvue_type_template_id_a4885264_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "transition",
	    {
	      attrs: { name: "el-drawer-fade" },
	      on: { "after-enter": _vm.afterEnter, "after-leave": _vm.afterLeave }
	    },
	    [
	      _c(
	        "div",
	        {
	          directives: [
	            {
	              name: "show",
	              rawName: "v-show",
	              value: _vm.visible,
	              expression: "visible"
	            }
	          ],
	          staticClass: "el-drawer__wrapper",
	          attrs: { tabindex: "-1" }
	        },
	        [
	          _c(
	            "div",
	            {
	              staticClass: "el-drawer__container",
	              class: _vm.visible && "el-drawer__open",
	              attrs: { role: "document", tabindex: "-1" },
	              on: {
	                click: function($event) {
	                  if ($event.target !== $event.currentTarget) {
	                    return null
	                  }
	                  return _vm.handleWrapperClick($event)
	                }
	              }
	            },
	            [
	              _c(
	                "div",
	                {
	                  ref: "drawer",
	                  staticClass: "el-drawer",
	                  class: [_vm.direction, _vm.customClass],
	                  style: _vm.isHorizontal
	                    ? "width: " + _vm.size
	                    : "height: " + _vm.size,
	                  attrs: {
	                    "aria-modal": "true",
	                    "aria-labelledby": "el-drawer__title",
	                    "aria-label": _vm.title,
	                    role: "dialog",
	                    tabindex: "-1"
	                  }
	                },
	                [
	                  _vm.withHeader
	                    ? _c(
	                        "header",
	                        {
	                          staticClass: "el-drawer__header",
	                          attrs: { id: "el-drawer__title" }
	                        },
	                        [
	                          _vm._t("title", [
	                            _c(
	                              "span",
	                              {
	                                attrs: {
	                                  role: "heading",
	                                  tabindex: "0",
	                                  title: _vm.title
	                                }
	                              },
	                              [_vm._v(_vm._s(_vm.title))]
	                            )
	                          ]),
	                          _vm.showClose
	                            ? _c(
	                                "button",
	                                {
	                                  staticClass: "el-drawer__close-btn",
	                                  attrs: {
	                                    "aria-label":
	                                      "close " + (_vm.title || "drawer"),
	                                    type: "button"
	                                  },
	                                  on: { click: _vm.closeDrawer }
	                                },
	                                [
	                                  _c("i", {
	                                    staticClass:
	                                      "el-dialog__close el-icon el-icon-close"
	                                  })
	                                ]
	                              )
	                            : _vm._e()
	                        ],
	                        2
	                      )
	                    : _vm._e(),
	                  _vm.rendered
	                    ? _c(
	                        "section",
	                        { staticClass: "el-drawer__body" },
	                        [_vm._t("default")],
	                        2
	                      )
	                    : _vm._e()
	                ]
	              )
	            ]
	          )
	        ]
	      )
	    ]
	  )
	}
	var mainvue_type_template_id_a4885264_staticRenderFns = []
	mainvue_type_template_id_a4885264_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/drawer/src/main.vue?vue&type=template&id=a4885264&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/drawer/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	/* harmony default export */ var drawer_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElDrawer',
	  mixins: [popup_default.a, emitter_default.a],
	  props: {
	    appendToBody: {
	      type: Boolean,
	      default: false
	    },
	    beforeClose: {
	      type: Function
	    },
	    customClass: {
	      type: String,
	      default: ''
	    },
	    closeOnPressEscape: {
	      type: Boolean,
	      default: true
	    },
	    destroyOnClose: {
	      type: Boolean,
	      default: false
	    },
	    modal: {
	      type: Boolean,
	      default: true
	    },
	    direction: {
	      type: String,
	      default: 'rtl',
	      validator: function validator(val) {
	        return ['ltr', 'rtl', 'ttb', 'btt'].indexOf(val) !== -1;
	      }
	    },
	    modalAppendToBody: {
	      type: Boolean,
	      default: true
	    },
	    showClose: {
	      type: Boolean,
	      default: true
	    },
	    size: {
	      type: String,
	      default: '30%'
	    },
	    title: {
	      type: String,
	      default: ''
	    },
	    visible: {
	      type: Boolean
	    },
	    wrapperClosable: {
	      type: Boolean,
	      default: true
	    },
	    withHeader: {
	      type: Boolean,
	      default: true
	    }
	  },
	  computed: {
	    isHorizontal: function isHorizontal() {
	      return this.direction === 'rtl' || this.direction === 'ltr';
	    }
	  },
	  data: function data() {
	    return {
	      closed: false,
	      prevActiveElement: null
	    };
	  },
	
	  watch: {
	    visible: function visible(val) {
	      var _this = this;
	
	      if (val) {
	        this.closed = false;
	        this.$emit('open');
	        if (this.appendToBody) {
	          document.body.appendChild(this.$el);
	        }
	        this.prevActiveElement = document.activeElement;
	        this.$nextTick(function () {
	          aria_utils_default.a.focusFirstDescendant(_this.$refs.drawer);
	        });
	      } else {
	        if (!this.closed) this.$emit('close');
	        this.$nextTick(function () {
	          if (_this.prevActiveElement) {
	            _this.prevActiveElement.focus();
	          }
	        });
	      }
	    }
	  },
	  methods: {
	    afterEnter: function afterEnter() {
	      this.$emit('opened');
	    },
	    afterLeave: function afterLeave() {
	      this.$emit('closed');
	    },
	    hide: function hide(cancel) {
	      if (cancel !== false) {
	        this.$emit('update:visible', false);
	        this.$emit('close');
	        if (this.destroyOnClose === true) {
	          this.rendered = false;
	        }
	        this.closed = true;
	      }
	    },
	    handleWrapperClick: function handleWrapperClick() {
	      if (this.wrapperClosable) {
	        this.closeDrawer();
	      }
	    },
	    closeDrawer: function closeDrawer() {
	      if (typeof this.beforeClose === 'function') {
	        this.beforeClose(this.hide);
	      } else {
	        this.hide();
	      }
	    },
	    handleClose: function handleClose() {
	      // This method here will be called by PopupManger, when the `closeOnPressEscape` was set to true
	      // pressing `ESC` will call this method, and also close the drawer.
	      // This method also calls `beforeClose` if there was one.
	      this.closeDrawer();
	    }
	  },
	  mounted: function mounted() {
	    if (this.visible) {
	      this.rendered = true;
	      this.open();
	    }
	  },
	  destroyed: function destroyed() {
	    // if appendToBody is true, remove DOM node after destroy
	    if (this.appendToBody && this.$el && this.$el.parentNode) {
	      this.$el.parentNode.removeChild(this.$el);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/drawer/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_drawer_src_mainvue_type_script_lang_js_ = (drawer_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/drawer/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var drawer_src_main_component = normalizeComponent(
	  packages_drawer_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_a4885264_render,
	  mainvue_type_template_id_a4885264_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var drawer_src_main_api; }
	drawer_src_main_component.options.__file = "packages/drawer/src/main.vue"
	/* harmony default export */ var drawer_src_main = (drawer_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/drawer/index.js
	
	
	/* istanbul ignore next */
	drawer_src_main.install = function (Vue) {
	  Vue.component(drawer_src_main.name, drawer_src_main);
	};
	
	/* harmony default export */ var drawer = (drawer_src_main);
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/popconfirm/src/main.vue?vue&type=template&id=048de730&
	var mainvue_type_template_id_048de730_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "el-popover",
	    _vm._b(
	      {
	        attrs: { trigger: "click" },
	        model: {
	          value: _vm.visible,
	          callback: function($$v) {
	            _vm.visible = $$v
	          },
	          expression: "visible"
	        }
	      },
	      "el-popover",
	      _vm.$attrs,
	      false
	    ),
	    [
	      _c("div", { staticClass: "el-popconfirm" }, [
	        _c("p", { staticClass: "el-popconfirm__main" }, [
	          !_vm.hideIcon
	            ? _c("i", {
	                staticClass: "el-popconfirm__icon",
	                class: _vm.icon,
	                style: { color: _vm.iconColor }
	              })
	            : _vm._e(),
	          _vm._v("\n      " + _vm._s(_vm.title) + "\n    ")
	        ]),
	        _c(
	          "div",
	          { staticClass: "el-popconfirm__action" },
	          [
	            _c(
	              "el-button",
	              {
	                attrs: { size: "mini", type: _vm.cancelButtonType },
	                on: { click: _vm.cancel }
	              },
	              [_vm._v("\n        " + _vm._s(_vm.cancelButtonText) + "\n      ")]
	            ),
	            _c(
	              "el-button",
	              {
	                attrs: { size: "mini", type: _vm.confirmButtonType },
	                on: { click: _vm.confirm }
	              },
	              [
	                _vm._v(
	                  "\n        " + _vm._s(_vm.confirmButtonText) + "\n      "
	                )
	              ]
	            )
	          ],
	          1
	        )
	      ]),
	      _vm._t("reference", null, { slot: "reference" })
	    ],
	    2
	  )
	}
	var mainvue_type_template_id_048de730_staticRenderFns = []
	mainvue_type_template_id_048de730_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/popconfirm/src/main.vue?vue&type=template&id=048de730&
	
	// EXTERNAL MODULE: external "element-ui/lib/popover"
	var popover_ = __webpack_require__(44);
	var popover_default = /*#__PURE__*/__webpack_require__.n(popover_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/popconfirm/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	/* harmony default export */ var popconfirm_src_mainvue_type_script_lang_js_ = ({
	  name: 'ElPopconfirm',
	  props: {
	    title: {
	      type: String
	    },
	    confirmButtonText: {
	      type: String,
	      default: Object(lib_locale_["t"])('el.popconfirm.confirmButtonText')
	    },
	    cancelButtonText: {
	      type: String,
	      default: Object(lib_locale_["t"])('el.popconfirm.cancelButtonText')
	    },
	    confirmButtonType: {
	      type: String,
	      default: 'primary'
	    },
	    cancelButtonType: {
	      type: String,
	      default: 'text'
	    },
	    icon: {
	      type: String,
	      default: 'el-icon-question'
	    },
	    iconColor: {
	      type: String,
	      default: '#f90'
	    },
	    hideIcon: {
	      type: Boolean,
	      default: false
	    }
	  },
	  components: {
	    ElPopover: popover_default.a,
	    ElButton: button_default.a
	  },
	  data: function data() {
	    return {
	      visible: false
	    };
	  },
	
	  methods: {
	    confirm: function confirm() {
	      this.visible = false;
	      this.$emit('onConfirm');
	    },
	    cancel: function cancel() {
	      this.visible = false;
	      this.$emit('onCancel');
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/popconfirm/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var packages_popconfirm_src_mainvue_type_script_lang_js_ = (popconfirm_src_mainvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/popconfirm/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var popconfirm_src_main_component = normalizeComponent(
	  packages_popconfirm_src_mainvue_type_script_lang_js_,
	  mainvue_type_template_id_048de730_render,
	  mainvue_type_template_id_048de730_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var popconfirm_src_main_api; }
	popconfirm_src_main_component.options.__file = "packages/popconfirm/src/main.vue"
	/* harmony default export */ var popconfirm_src_main = (popconfirm_src_main_component.exports);
	// CONCATENATED MODULE: ./packages/popconfirm/index.js
	
	
	/* istanbul ignore next */
	popconfirm_src_main.install = function (Vue) {
	  Vue.component(popconfirm_src_main.name, popconfirm_src_main);
	};
	
	/* harmony default export */ var popconfirm = (popconfirm_src_main);
	// CONCATENATED MODULE: ./src/index.js
	/* Automatically generated by './build/bin/build-entry.js' */
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var components = [packages_pagination, dialog, packages_autocomplete, packages_dropdown, packages_dropdown_menu, packages_dropdown_item, packages_menu, packages_submenu, packages_menu_item, packages_menu_item_group, packages_input, packages_input_number, packages_radio, packages_radio_group, packages_radio_button, packages_checkbox, packages_checkbox_button, packages_checkbox_group, packages_switch, packages_select, packages_option, packages_option_group, packages_button, packages_button_group, packages_table, packages_table_column, packages_date_picker, packages_time_select, packages_time_picker, popover, packages_tooltip, packages_breadcrumb, packages_breadcrumb_item, packages_form, packages_form_item, packages_tabs, packages_tab_pane, packages_tag, packages_tree, packages_alert, slider, packages_icon, packages_row, packages_col, packages_upload, packages_progress, packages_spinner, badge, card, rate, packages_steps, packages_step, carousel, scrollbar, carousel_item, packages_collapse, packages_collapse_item, packages_cascader, color_picker, transfer, packages_container, header, aside, packages_main, footer, timeline, timeline_item, packages_link, divider, packages_image, calendar, backtop, page_header, packages_cascader_panel, avatar, drawer, popconfirm, collapse_transition_default.a];
	
	var src_install = function install(Vue) {
	  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  lib_locale_default.a.use(opts.locale);
	  lib_locale_default.a.i18n(opts.i18n);
	
	  components.forEach(function (component) {
	    Vue.component(component.name, component);
	  });
	
	  Vue.use(infinite_scroll);
	  Vue.use(packages_loading.directive);
	
	  Vue.prototype.$ELEMENT = {
	    size: opts.size || '',
	    zIndex: opts.zIndex || 2000
	  };
	
	  Vue.prototype.$loading = packages_loading.service;
	  Vue.prototype.$msgbox = message_box;
	  Vue.prototype.$alert = message_box.alert;
	  Vue.prototype.$confirm = message_box.confirm;
	  Vue.prototype.$prompt = message_box.prompt;
	  Vue.prototype.$notify = notification;
	  Vue.prototype.$message = packages_message;
	};
	
	/* istanbul ignore if */
	if (typeof window !== 'undefined' && window.Vue) {
	  src_install(window.Vue);
	}
	
	/* harmony default export */ var src_0 = __webpack_exports__["default"] = ({
	  version: '2.13.0',
	  locale: lib_locale_default.a.use,
	  i18n: lib_locale_default.a.i18n,
	  install: src_install,
	  CollapseTransition: collapse_transition_default.a,
	  Loading: packages_loading,
	  Pagination: packages_pagination,
	  Dialog: dialog,
	  Autocomplete: packages_autocomplete,
	  Dropdown: packages_dropdown,
	  DropdownMenu: packages_dropdown_menu,
	  DropdownItem: packages_dropdown_item,
	  Menu: packages_menu,
	  Submenu: packages_submenu,
	  MenuItem: packages_menu_item,
	  MenuItemGroup: packages_menu_item_group,
	  Input: packages_input,
	  InputNumber: packages_input_number,
	  Radio: packages_radio,
	  RadioGroup: packages_radio_group,
	  RadioButton: packages_radio_button,
	  Checkbox: packages_checkbox,
	  CheckboxButton: packages_checkbox_button,
	  CheckboxGroup: packages_checkbox_group,
	  Switch: packages_switch,
	  Select: packages_select,
	  Option: packages_option,
	  OptionGroup: packages_option_group,
	  Button: packages_button,
	  ButtonGroup: packages_button_group,
	  Table: packages_table,
	  TableColumn: packages_table_column,
	  DatePicker: packages_date_picker,
	  TimeSelect: packages_time_select,
	  TimePicker: packages_time_picker,
	  Popover: popover,
	  Tooltip: packages_tooltip,
	  MessageBox: message_box,
	  Breadcrumb: packages_breadcrumb,
	  BreadcrumbItem: packages_breadcrumb_item,
	  Form: packages_form,
	  FormItem: packages_form_item,
	  Tabs: packages_tabs,
	  TabPane: packages_tab_pane,
	  Tag: packages_tag,
	  Tree: packages_tree,
	  Alert: packages_alert,
	  Notification: notification,
	  Slider: slider,
	  Icon: packages_icon,
	  Row: packages_row,
	  Col: packages_col,
	  Upload: packages_upload,
	  Progress: packages_progress,
	  Spinner: packages_spinner,
	  Message: packages_message,
	  Badge: badge,
	  Card: card,
	  Rate: rate,
	  Steps: packages_steps,
	  Step: packages_step,
	  Carousel: carousel,
	  Scrollbar: scrollbar,
	  CarouselItem: carousel_item,
	  Collapse: packages_collapse,
	  CollapseItem: packages_collapse_item,
	  Cascader: packages_cascader,
	  ColorPicker: color_picker,
	  Transfer: transfer,
	  Container: packages_container,
	  Header: header,
	  Aside: aside,
	  Main: packages_main,
	  Footer: footer,
	  Timeline: timeline,
	  TimelineItem: timeline_item,
	  Link: packages_link,
	  Divider: divider,
	  Image: packages_image,
	  Calendar: calendar,
	  Backtop: backtop,
	  InfiniteScroll: infinite_scroll,
	  PageHeader: page_header,
	  CascaderPanel: packages_cascader_panel,
	  Avatar: avatar,
	  Drawer: drawer,
	  Popconfirm: popconfirm
	});
	
	/***/ })
	/******/ ])["default"];

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 114);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
	/* globals __VUE_SSR_CONTEXT__ */
	
	// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
	// This module is a runtime utility for cleaner component module output and will
	// be included in the final webpack user bundle.
	
	function normalizeComponent (
	  scriptExports,
	  render,
	  staticRenderFns,
	  functionalTemplate,
	  injectStyles,
	  scopeId,
	  moduleIdentifier, /* server only */
	  shadowMode /* vue-cli only */
	) {
	  // Vue.extend constructor export interop
	  var options = typeof scriptExports === 'function'
	    ? scriptExports.options
	    : scriptExports
	
	  // render functions
	  if (render) {
	    options.render = render
	    options.staticRenderFns = staticRenderFns
	    options._compiled = true
	  }
	
	  // functional template
	  if (functionalTemplate) {
	    options.functional = true
	  }
	
	  // scopedId
	  if (scopeId) {
	    options._scopeId = 'data-v-' + scopeId
	  }
	
	  var hook
	  if (moduleIdentifier) { // server build
	    hook = function (context) {
	      // 2.3 injection
	      context =
	        context || // cached call
	        (this.$vnode && this.$vnode.ssrContext) || // stateful
	        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
	      // 2.2 with runInNewContext: true
	      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
	        context = __VUE_SSR_CONTEXT__
	      }
	      // inject component styles
	      if (injectStyles) {
	        injectStyles.call(this, context)
	      }
	      // register component module identifier for async chunk inferrence
	      if (context && context._registeredComponents) {
	        context._registeredComponents.add(moduleIdentifier)
	      }
	    }
	    // used by ssr in case component is cached and beforeCreate
	    // never gets called
	    options._ssrRegister = hook
	  } else if (injectStyles) {
	    hook = shadowMode
	      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
	      : injectStyles
	  }
	
	  if (hook) {
	    if (options.functional) {
	      // for template-only hot-reload because in that case the render fn doesn't
	      // go through the normalizer
	      options._injectStyles = hook
	      // register for functioal component in vue file
	      var originalRender = options.render
	      options.render = function renderWithStyleInjection (h, context) {
	        hook.call(context)
	        return originalRender(h, context)
	      }
	    } else {
	      // inject component registration as beforeCreate hook
	      var existing = options.beforeCreate
	      options.beforeCreate = existing
	        ? [].concat(existing, hook)
	        : [hook]
	    }
	  }
	
	  return {
	    exports: scriptExports,
	    options: options
	  }
	}
	
	
	/***/ }),
	
	/***/ 10:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(125);
	
	/***/ }),
	
	/***/ 114:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/input-number/src/input-number.vue?vue&type=template&id=42f8cf66&
	var render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      class: [
	        "el-input-number",
	        _vm.inputNumberSize ? "el-input-number--" + _vm.inputNumberSize : "",
	        { "is-disabled": _vm.inputNumberDisabled },
	        { "is-without-controls": !_vm.controls },
	        { "is-controls-right": _vm.controlsAtRight }
	      ],
	      on: {
	        dragstart: function($event) {
	          $event.preventDefault()
	        }
	      }
	    },
	    [
	      _vm.controls
	        ? _c(
	            "span",
	            {
	              directives: [
	                {
	                  name: "repeat-click",
	                  rawName: "v-repeat-click",
	                  value: _vm.decrease,
	                  expression: "decrease"
	                }
	              ],
	              staticClass: "el-input-number__decrease",
	              class: { "is-disabled": _vm.minDisabled },
	              attrs: { role: "button" },
	              on: {
	                keydown: function($event) {
	                  if (
	                    !("button" in $event) &&
	                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
	                  ) {
	                    return null
	                  }
	                  return _vm.decrease($event)
	                }
	              }
	            },
	            [
	              _c("i", {
	                class:
	                  "el-icon-" + (_vm.controlsAtRight ? "arrow-down" : "minus")
	              })
	            ]
	          )
	        : _vm._e(),
	      _vm.controls
	        ? _c(
	            "span",
	            {
	              directives: [
	                {
	                  name: "repeat-click",
	                  rawName: "v-repeat-click",
	                  value: _vm.increase,
	                  expression: "increase"
	                }
	              ],
	              staticClass: "el-input-number__increase",
	              class: { "is-disabled": _vm.maxDisabled },
	              attrs: { role: "button" },
	              on: {
	                keydown: function($event) {
	                  if (
	                    !("button" in $event) &&
	                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
	                  ) {
	                    return null
	                  }
	                  return _vm.increase($event)
	                }
	              }
	            },
	            [
	              _c("i", {
	                class: "el-icon-" + (_vm.controlsAtRight ? "arrow-up" : "plus")
	              })
	            ]
	          )
	        : _vm._e(),
	      _c("el-input", {
	        ref: "input",
	        attrs: {
	          value: _vm.displayValue,
	          placeholder: _vm.placeholder,
	          disabled: _vm.inputNumberDisabled,
	          size: _vm.inputNumberSize,
	          max: _vm.max,
	          min: _vm.min,
	          name: _vm.name,
	          label: _vm.label
	        },
	        on: {
	          blur: _vm.handleBlur,
	          focus: _vm.handleFocus,
	          input: _vm.handleInput,
	          change: _vm.handleInputChange
	        },
	        nativeOn: {
	          keydown: [
	            function($event) {
	              if (
	                !("button" in $event) &&
	                _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])
	              ) {
	                return null
	              }
	              $event.preventDefault()
	              return _vm.increase($event)
	            },
	            function($event) {
	              if (
	                !("button" in $event) &&
	                _vm._k($event.keyCode, "down", 40, $event.key, [
	                  "Down",
	                  "ArrowDown"
	                ])
	              ) {
	                return null
	              }
	              $event.preventDefault()
	              return _vm.decrease($event)
	            }
	          ]
	        }
	      })
	    ],
	    1
	  )
	}
	var staticRenderFns = []
	render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/input-number/src/input-number.vue?vue&type=template&id=42f8cf66&
	
	// EXTERNAL MODULE: external "element-ui/lib/input"
	var input_ = __webpack_require__(10);
	var input_default = /*#__PURE__*/__webpack_require__.n(input_);
	
	// EXTERNAL MODULE: external "element-ui/lib/mixins/focus"
	var focus_ = __webpack_require__(22);
	var focus_default = /*#__PURE__*/__webpack_require__.n(focus_);
	
	// EXTERNAL MODULE: ./src/directives/repeat-click.js
	var repeat_click = __webpack_require__(30);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/input-number/src/input-number.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	/* harmony default export */ var input_numbervue_type_script_lang_js_ = ({
	  name: 'ElInputNumber',
	  mixins: [focus_default()('input')],
	  inject: {
	    elForm: {
	      default: ''
	    },
	    elFormItem: {
	      default: ''
	    }
	  },
	  directives: {
	    repeatClick: repeat_click["a" /* default */]
	  },
	  components: {
	    ElInput: input_default.a
	  },
	  props: {
	    step: {
	      type: Number,
	      default: 1
	    },
	    stepStrictly: {
	      type: Boolean,
	      default: false
	    },
	    max: {
	      type: Number,
	      default: Infinity
	    },
	    min: {
	      type: Number,
	      default: -Infinity
	    },
	    value: {},
	    disabled: Boolean,
	    size: String,
	    controls: {
	      type: Boolean,
	      default: true
	    },
	    controlsPosition: {
	      type: String,
	      default: ''
	    },
	    name: String,
	    label: String,
	    placeholder: String,
	    precision: {
	      type: Number,
	      validator: function validator(val) {
	        return val >= 0 && val === parseInt(val, 10);
	      }
	    }
	  },
	  data: function data() {
	    return {
	      currentValue: 0,
	      userInput: null
	    };
	  },
	
	  watch: {
	    value: {
	      immediate: true,
	      handler: function handler(value) {
	        var newVal = value === undefined ? value : Number(value);
	        if (newVal !== undefined) {
	          if (isNaN(newVal)) {
	            return;
	          }
	
	          if (this.stepStrictly) {
	            var stepPrecision = this.getPrecision(this.step);
	            var precisionFactor = Math.pow(10, stepPrecision);
	            newVal = Math.round(newVal / this.step) * precisionFactor * this.step / precisionFactor;
	          }
	
	          if (this.precision !== undefined) {
	            newVal = this.toPrecision(newVal, this.precision);
	          }
	        }
	        if (newVal >= this.max) newVal = this.max;
	        if (newVal <= this.min) newVal = this.min;
	        this.currentValue = newVal;
	        this.userInput = null;
	        this.$emit('input', newVal);
	      }
	    }
	  },
	  computed: {
	    minDisabled: function minDisabled() {
	      return this._decrease(this.value, this.step) < this.min;
	    },
	    maxDisabled: function maxDisabled() {
	      return this._increase(this.value, this.step) > this.max;
	    },
	    numPrecision: function numPrecision() {
	      var value = this.value,
	          step = this.step,
	          getPrecision = this.getPrecision,
	          precision = this.precision;
	
	      var stepPrecision = getPrecision(step);
	      if (precision !== undefined) {
	        if (stepPrecision > precision) {
	          console.warn('[Element Warn][InputNumber]precision should not be less than the decimal places of step');
	        }
	        return precision;
	      } else {
	        return Math.max(getPrecision(value), stepPrecision);
	      }
	    },
	    controlsAtRight: function controlsAtRight() {
	      return this.controls && this.controlsPosition === 'right';
	    },
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    inputNumberSize: function inputNumberSize() {
	      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
	    },
	    inputNumberDisabled: function inputNumberDisabled() {
	      return this.disabled || (this.elForm || {}).disabled;
	    },
	    displayValue: function displayValue() {
	      if (this.userInput !== null) {
	        return this.userInput;
	      }
	
	      var currentValue = this.currentValue;
	
	      if (typeof currentValue === 'number') {
	        if (this.stepStrictly) {
	          var stepPrecision = this.getPrecision(this.step);
	          var precisionFactor = Math.pow(10, stepPrecision);
	          currentValue = Math.round(currentValue / this.step) * precisionFactor * this.step / precisionFactor;
	        }
	
	        if (this.precision !== undefined) {
	          currentValue = currentValue.toFixed(this.precision);
	        }
	      }
	
	      return currentValue;
	    }
	  },
	  methods: {
	    toPrecision: function toPrecision(num, precision) {
	      if (precision === undefined) precision = this.numPrecision;
	      return parseFloat(Math.round(num * Math.pow(10, precision)) / Math.pow(10, precision));
	    },
	    getPrecision: function getPrecision(value) {
	      if (value === undefined) return 0;
	      var valueString = value.toString();
	      var dotPosition = valueString.indexOf('.');
	      var precision = 0;
	      if (dotPosition !== -1) {
	        precision = valueString.length - dotPosition - 1;
	      }
	      return precision;
	    },
	    _increase: function _increase(val, step) {
	      if (typeof val !== 'number' && val !== undefined) return this.currentValue;
	
	      var precisionFactor = Math.pow(10, this.numPrecision);
	      // Solve the accuracy problem of JS decimal calculation by converting the value to integer.
	      return this.toPrecision((precisionFactor * val + precisionFactor * step) / precisionFactor);
	    },
	    _decrease: function _decrease(val, step) {
	      if (typeof val !== 'number' && val !== undefined) return this.currentValue;
	
	      var precisionFactor = Math.pow(10, this.numPrecision);
	
	      return this.toPrecision((precisionFactor * val - precisionFactor * step) / precisionFactor);
	    },
	    increase: function increase() {
	      if (this.inputNumberDisabled || this.maxDisabled) return;
	      var value = this.value || 0;
	      var newVal = this._increase(value, this.step);
	      this.setCurrentValue(newVal);
	    },
	    decrease: function decrease() {
	      if (this.inputNumberDisabled || this.minDisabled) return;
	      var value = this.value || 0;
	      var newVal = this._decrease(value, this.step);
	      this.setCurrentValue(newVal);
	    },
	    handleBlur: function handleBlur(event) {
	      this.$emit('blur', event);
	    },
	    handleFocus: function handleFocus(event) {
	      this.$emit('focus', event);
	    },
	    setCurrentValue: function setCurrentValue(newVal) {
	      var oldVal = this.currentValue;
	      if (typeof newVal === 'number' && this.precision !== undefined) {
	        newVal = this.toPrecision(newVal, this.precision);
	      }
	      if (newVal >= this.max) newVal = this.max;
	      if (newVal <= this.min) newVal = this.min;
	      if (oldVal === newVal) return;
	      this.userInput = null;
	      this.$emit('input', newVal);
	      this.$emit('change', newVal, oldVal);
	      this.currentValue = newVal;
	    },
	    handleInput: function handleInput(value) {
	      this.userInput = value;
	    },
	    handleInputChange: function handleInputChange(value) {
	      var newVal = value === '' ? undefined : Number(value);
	      if (!isNaN(newVal) || value === '') {
	        this.setCurrentValue(newVal);
	      }
	      this.userInput = null;
	    },
	    select: function select() {
	      this.$refs.input.select();
	    }
	  },
	  mounted: function mounted() {
	    var innerInput = this.$refs.input.$refs.input;
	    innerInput.setAttribute('role', 'spinbutton');
	    innerInput.setAttribute('aria-valuemax', this.max);
	    innerInput.setAttribute('aria-valuemin', this.min);
	    innerInput.setAttribute('aria-valuenow', this.currentValue);
	    innerInput.setAttribute('aria-disabled', this.inputNumberDisabled);
	  },
	  updated: function updated() {
	    if (!this.$refs || !this.$refs.input) return;
	    var innerInput = this.$refs.input.$refs.input;
	    innerInput.setAttribute('aria-valuenow', this.currentValue);
	  }
	});
	// CONCATENATED MODULE: ./packages/input-number/src/input-number.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_input_numbervue_type_script_lang_js_ = (input_numbervue_type_script_lang_js_); 
	// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
	var componentNormalizer = __webpack_require__(0);
	
	// CONCATENATED MODULE: ./packages/input-number/src/input-number.vue
	
	
	
	
	
	/* normalize component */
	
	var component = Object(componentNormalizer["a" /* default */])(
	  src_input_numbervue_type_script_lang_js_,
	  render,
	  staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var api; }
	component.options.__file = "packages/input-number/src/input-number.vue"
	/* harmony default export */ var input_number = (component.exports);
	// CONCATENATED MODULE: ./packages/input-number/index.js
	
	
	/* istanbul ignore next */
	input_number.install = function (Vue) {
	  Vue.component(input_number.name, input_number);
	};
	
	/* harmony default export */ var packages_input_number = __webpack_exports__["default"] = (input_number);
	
	/***/ }),
	
	/***/ 2:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(42);
	
	/***/ }),
	
	/***/ 22:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(126);
	
	/***/ }),
	
	/***/ 30:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var element_ui_src_utils_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
	/* harmony import */ var element_ui_src_utils_dom__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(element_ui_src_utils_dom__WEBPACK_IMPORTED_MODULE_0__);
	
	
	/* harmony default export */ __webpack_exports__["a"] = ({
	  bind: function bind(el, binding, vnode) {
	    var interval = null;
	    var startTime = void 0;
	    var handler = function handler() {
	      return vnode.context[binding.expression].apply();
	    };
	    var clear = function clear() {
	      if (Date.now() - startTime < 100) {
	        handler();
	      }
	      clearInterval(interval);
	      interval = null;
	    };
	
	    Object(element_ui_src_utils_dom__WEBPACK_IMPORTED_MODULE_0__["on"])(el, 'mousedown', function (e) {
	      if (e.button !== 0) return;
	      startTime = Date.now();
	      Object(element_ui_src_utils_dom__WEBPACK_IMPORTED_MODULE_0__["once"])(document, 'mouseup', clear);
	      clearInterval(interval);
	      interval = setInterval(handler, 100);
	    });
	  }
	});
	
	/***/ })
	
	/******/ });

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = function (Vue) {
	
	  /**
	   * template
	   *
	   * @param {String} string
	   * @param {Array} ...args
	   * @return {String}
	   */
	
	  function template(string) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    if (args.length === 1 && _typeof(args[0]) === 'object') {
	      args = args[0];
	    }
	
	    if (!args || !args.hasOwnProperty) {
	      args = {};
	    }
	
	    return string.replace(RE_NARGS, function (match, prefix, i, index) {
	      var result = void 0;
	
	      if (string[index - 1] === '{' && string[index + match.length] === '}') {
	        return i;
	      } else {
	        result = (0, _util.hasOwn)(args, i) ? args[i] : null;
	        if (result === null || result === undefined) {
	          return '';
	        }
	
	        return result;
	      }
	    });
	  }
	
	  return template;
	};
	
	var _util = __webpack_require__(38);
	
	var RE_NARGS = /(%|)\{([0-9a-zA-Z_]+)\}/g;
	/**
	 *  String format template
	 *  - Inspired:
	 *    https://github.com/Matt-Esch/string-template/index.js
	 */

/***/ }),
/* 389 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  el: {
	    colorpicker: {
	      confirm: '确定',
	      clear: '清空'
	    },
	    datepicker: {
	      now: '此刻',
	      today: '今天',
	      cancel: '取消',
	      clear: '清空',
	      confirm: '确定',
	      selectDate: '选择日期',
	      selectTime: '选择时间',
	      startDate: '开始日期',
	      startTime: '开始时间',
	      endDate: '结束日期',
	      endTime: '结束时间',
	      prevYear: '前一年',
	      nextYear: '后一年',
	      prevMonth: '上个月',
	      nextMonth: '下个月',
	      year: '年',
	      month1: '1 月',
	      month2: '2 月',
	      month3: '3 月',
	      month4: '4 月',
	      month5: '5 月',
	      month6: '6 月',
	      month7: '7 月',
	      month8: '8 月',
	      month9: '9 月',
	      month10: '10 月',
	      month11: '11 月',
	      month12: '12 月',
	      // week: '周次',
	      weeks: {
	        sun: '日',
	        mon: '一',
	        tue: '二',
	        wed: '三',
	        thu: '四',
	        fri: '五',
	        sat: '六'
	      },
	      months: {
	        jan: '一月',
	        feb: '二月',
	        mar: '三月',
	        apr: '四月',
	        may: '五月',
	        jun: '六月',
	        jul: '七月',
	        aug: '八月',
	        sep: '九月',
	        oct: '十月',
	        nov: '十一月',
	        dec: '十二月'
	      }
	    },
	    select: {
	      loading: '加载中',
	      noMatch: '无匹配数据',
	      noData: '无数据',
	      placeholder: '请选择'
	    },
	    cascader: {
	      noMatch: '无匹配数据',
	      loading: '加载中',
	      placeholder: '请选择',
	      noData: '暂无数据'
	    },
	    pagination: {
	      goto: '前往',
	      pagesize: '条/页',
	      total: '共 {total} 条',
	      pageClassifier: '页'
	    },
	    messagebox: {
	      title: '提示',
	      confirm: '确定',
	      cancel: '取消',
	      error: '输入的数据不合法!'
	    },
	    upload: {
	      deleteTip: '按 delete 键可删除',
	      delete: '删除',
	      preview: '查看图片',
	      continue: '继续上传'
	    },
	    table: {
	      emptyText: '暂无数据',
	      confirmFilter: '筛选',
	      resetFilter: '重置',
	      clearFilter: '全部',
	      sumText: '合计'
	    },
	    tree: {
	      emptyText: '暂无数据'
	    },
	    transfer: {
	      noMatch: '无匹配数据',
	      noData: '无数据',
	      titles: ['列表 1', '列表 2'],
	      filterPlaceholder: '请输入搜索内容',
	      noCheckedFormat: '共 {total} 项',
	      hasCheckedFormat: '已选 {checked}/{total} 项'
	    },
	    image: {
	      error: '加载失败'
	    },
	    pageHeader: {
	      title: '返回'
	    },
	    popconfirm: {
	      confirmButtonText: '确定',
	      cancelButtonText: '取消'
	    }
	  }
	};

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 53);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
	/* globals __VUE_SSR_CONTEXT__ */
	
	// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
	// This module is a runtime utility for cleaner component module output and will
	// be included in the final webpack user bundle.
	
	function normalizeComponent (
	  scriptExports,
	  render,
	  staticRenderFns,
	  functionalTemplate,
	  injectStyles,
	  scopeId,
	  moduleIdentifier, /* server only */
	  shadowMode /* vue-cli only */
	) {
	  // Vue.extend constructor export interop
	  var options = typeof scriptExports === 'function'
	    ? scriptExports.options
	    : scriptExports
	
	  // render functions
	  if (render) {
	    options.render = render
	    options.staticRenderFns = staticRenderFns
	    options._compiled = true
	  }
	
	  // functional template
	  if (functionalTemplate) {
	    options.functional = true
	  }
	
	  // scopedId
	  if (scopeId) {
	    options._scopeId = 'data-v-' + scopeId
	  }
	
	  var hook
	  if (moduleIdentifier) { // server build
	    hook = function (context) {
	      // 2.3 injection
	      context =
	        context || // cached call
	        (this.$vnode && this.$vnode.ssrContext) || // stateful
	        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
	      // 2.2 with runInNewContext: true
	      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
	        context = __VUE_SSR_CONTEXT__
	      }
	      // inject component styles
	      if (injectStyles) {
	        injectStyles.call(this, context)
	      }
	      // register component module identifier for async chunk inferrence
	      if (context && context._registeredComponents) {
	        context._registeredComponents.add(moduleIdentifier)
	      }
	    }
	    // used by ssr in case component is cached and beforeCreate
	    // never gets called
	    options._ssrRegister = hook
	  } else if (injectStyles) {
	    hook = shadowMode
	      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
	      : injectStyles
	  }
	
	  if (hook) {
	    if (options.functional) {
	      // for template-only hot-reload because in that case the render fn doesn't
	      // go through the normalizer
	      options._injectStyles = hook
	      // register for functioal component in vue file
	      var originalRender = options.render
	      options.render = function renderWithStyleInjection (h, context) {
	        hook.call(context)
	        return originalRender(h, context)
	      }
	    } else {
	      // inject component registration as beforeCreate hook
	      var existing = options.beforeCreate
	      options.beforeCreate = existing
	        ? [].concat(existing, hook)
	        : [hook]
	    }
	  }
	
	  return {
	    exports: scriptExports,
	    options: options
	  }
	}
	
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(38);
	
	/***/ }),
	
	/***/ 34:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/option.vue?vue&type=template&id=7a44c642&
	var render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "li",
	    {
	      directives: [
	        {
	          name: "show",
	          rawName: "v-show",
	          value: _vm.visible,
	          expression: "visible"
	        }
	      ],
	      staticClass: "el-select-dropdown__item",
	      class: {
	        selected: _vm.itemSelected,
	        "is-disabled": _vm.disabled || _vm.groupDisabled || _vm.limitReached,
	        hover: _vm.hover
	      },
	      on: {
	        mouseenter: _vm.hoverItem,
	        click: function($event) {
	          $event.stopPropagation()
	          return _vm.selectOptionClick($event)
	        }
	      }
	    },
	    [_vm._t("default", [_c("span", [_vm._v(_vm._s(_vm.currentLabel))])])],
	    2
	  )
	}
	var staticRenderFns = []
	render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/select/src/option.vue?vue&type=template&id=7a44c642&
	
	// EXTERNAL MODULE: external "element-ui/lib/mixins/emitter"
	var emitter_ = __webpack_require__(4);
	var emitter_default = /*#__PURE__*/__webpack_require__.n(emitter_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/util"
	var util_ = __webpack_require__(3);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/option.vue?vue&type=script&lang=js&
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	/* harmony default export */ var optionvue_type_script_lang_js_ = ({
	  mixins: [emitter_default.a],
	
	  name: 'ElOption',
	
	  componentName: 'ElOption',
	
	  inject: ['select'],
	
	  props: {
	    value: {
	      required: true
	    },
	    label: [String, Number],
	    created: Boolean,
	    disabled: {
	      type: Boolean,
	      default: false
	    }
	  },
	
	  data: function data() {
	    return {
	      index: -1,
	      groupDisabled: false,
	      visible: true,
	      hitState: false,
	      hover: false
	    };
	  },
	
	
	  computed: {
	    isObject: function isObject() {
	      return Object.prototype.toString.call(this.value).toLowerCase() === '[object object]';
	    },
	    currentLabel: function currentLabel() {
	      return this.label || (this.isObject ? '' : this.value);
	    },
	    currentValue: function currentValue() {
	      return this.value || this.label || '';
	    },
	    itemSelected: function itemSelected() {
	      if (!this.select.multiple) {
	        return this.isEqual(this.value, this.select.value);
	      } else {
	        return this.contains(this.select.value, this.value);
	      }
	    },
	    limitReached: function limitReached() {
	      if (this.select.multiple) {
	        return !this.itemSelected && (this.select.value || []).length >= this.select.multipleLimit && this.select.multipleLimit > 0;
	      } else {
	        return false;
	      }
	    }
	  },
	
	  watch: {
	    currentLabel: function currentLabel() {
	      if (!this.created && !this.select.remote) this.dispatch('ElSelect', 'setSelected');
	    },
	    value: function value(val, oldVal) {
	      var _select = this.select,
	          remote = _select.remote,
	          valueKey = _select.valueKey;
	
	      if (!this.created && !remote) {
	        if (valueKey && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object' && (typeof oldVal === 'undefined' ? 'undefined' : _typeof(oldVal)) === 'object' && val[valueKey] === oldVal[valueKey]) {
	          return;
	        }
	        this.dispatch('ElSelect', 'setSelected');
	      }
	    }
	  },
	
	  methods: {
	    isEqual: function isEqual(a, b) {
	      if (!this.isObject) {
	        return a === b;
	      } else {
	        var valueKey = this.select.valueKey;
	        return Object(util_["getValueByPath"])(a, valueKey) === Object(util_["getValueByPath"])(b, valueKey);
	      }
	    },
	    contains: function contains() {
	      var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	      var target = arguments[1];
	
	      if (!this.isObject) {
	        return arr && arr.indexOf(target) > -1;
	      } else {
	        var valueKey = this.select.valueKey;
	        return arr && arr.some(function (item) {
	          return Object(util_["getValueByPath"])(item, valueKey) === Object(util_["getValueByPath"])(target, valueKey);
	        });
	      }
	    },
	    handleGroupDisabled: function handleGroupDisabled(val) {
	      this.groupDisabled = val;
	    },
	    hoverItem: function hoverItem() {
	      if (!this.disabled && !this.groupDisabled) {
	        this.select.hoverIndex = this.select.options.indexOf(this);
	      }
	    },
	    selectOptionClick: function selectOptionClick() {
	      if (this.disabled !== true && this.groupDisabled !== true) {
	        this.dispatch('ElSelect', 'handleOptionClick', [this, true]);
	      }
	    },
	    queryChange: function queryChange(query) {
	      this.visible = new RegExp(Object(util_["escapeRegexpString"])(query), 'i').test(this.currentLabel) || this.created;
	      if (!this.visible) {
	        this.select.filteredOptionsCount--;
	      }
	    }
	  },
	
	  created: function created() {
	    this.select.options.push(this);
	    this.select.cachedOptions.push(this);
	    this.select.optionsCount++;
	    this.select.filteredOptionsCount++;
	
	    this.$on('queryChange', this.queryChange);
	    this.$on('handleGroupDisabled', this.handleGroupDisabled);
	  },
	  beforeDestroy: function beforeDestroy() {
	    var _select2 = this.select,
	        selected = _select2.selected,
	        multiple = _select2.multiple;
	
	    var selectedOptions = multiple ? selected : [selected];
	    var index = this.select.cachedOptions.indexOf(this);
	    var selectedIndex = selectedOptions.indexOf(this);
	
	    // if option is not selected, remove it from cache
	    if (index > -1 && selectedIndex < 0) {
	      this.select.cachedOptions.splice(index, 1);
	    }
	    this.select.onOptionDestroy(this.select.options.indexOf(this));
	  }
	});
	// CONCATENATED MODULE: ./packages/select/src/option.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_optionvue_type_script_lang_js_ = (optionvue_type_script_lang_js_); 
	// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
	var componentNormalizer = __webpack_require__(0);
	
	// CONCATENATED MODULE: ./packages/select/src/option.vue
	
	
	
	
	
	/* normalize component */
	
	var component = Object(componentNormalizer["a" /* default */])(
	  src_optionvue_type_script_lang_js_,
	  render,
	  staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var api; }
	component.options.__file = "packages/select/src/option.vue"
	/* harmony default export */ var src_option = __webpack_exports__["a"] = (component.exports);
	
	/***/ }),
	
	/***/ 4:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(54);
	
	/***/ }),
	
	/***/ 53:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _select_src_option__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34);
	
	
	/* istanbul ignore next */
	_select_src_option__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].install = function (Vue) {
	  Vue.component(_select_src_option__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].name, _select_src_option__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);
	};
	
	/* harmony default export */ __webpack_exports__["default"] = (_select_src_option__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 74);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
	/* globals __VUE_SSR_CONTEXT__ */
	
	// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
	// This module is a runtime utility for cleaner component module output and will
	// be included in the final webpack user bundle.
	
	function normalizeComponent (
	  scriptExports,
	  render,
	  staticRenderFns,
	  functionalTemplate,
	  injectStyles,
	  scopeId,
	  moduleIdentifier, /* server only */
	  shadowMode /* vue-cli only */
	) {
	  // Vue.extend constructor export interop
	  var options = typeof scriptExports === 'function'
	    ? scriptExports.options
	    : scriptExports
	
	  // render functions
	  if (render) {
	    options.render = render
	    options.staticRenderFns = staticRenderFns
	    options._compiled = true
	  }
	
	  // functional template
	  if (functionalTemplate) {
	    options.functional = true
	  }
	
	  // scopedId
	  if (scopeId) {
	    options._scopeId = 'data-v-' + scopeId
	  }
	
	  var hook
	  if (moduleIdentifier) { // server build
	    hook = function (context) {
	      // 2.3 injection
	      context =
	        context || // cached call
	        (this.$vnode && this.$vnode.ssrContext) || // stateful
	        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
	      // 2.2 with runInNewContext: true
	      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
	        context = __VUE_SSR_CONTEXT__
	      }
	      // inject component styles
	      if (injectStyles) {
	        injectStyles.call(this, context)
	      }
	      // register component module identifier for async chunk inferrence
	      if (context && context._registeredComponents) {
	        context._registeredComponents.add(moduleIdentifier)
	      }
	    }
	    // used by ssr in case component is cached and beforeCreate
	    // never gets called
	    options._ssrRegister = hook
	  } else if (injectStyles) {
	    hook = shadowMode
	      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
	      : injectStyles
	  }
	
	  if (hook) {
	    if (options.functional) {
	      // for template-only hot-reload because in that case the render fn doesn't
	      // go through the normalizer
	      options._injectStyles = hook
	      // register for functioal component in vue file
	      var originalRender = options.render
	      options.render = function renderWithStyleInjection (h, context) {
	        hook.call(context)
	        return originalRender(h, context)
	      }
	    } else {
	      // inject component registration as beforeCreate hook
	      var existing = options.beforeCreate
	      options.beforeCreate = existing
	        ? [].concat(existing, hook)
	        : [hook]
	    }
	  }
	
	  return {
	    exports: scriptExports,
	    options: options
	  }
	}
	
	
	/***/ }),
	
	/***/ 2:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(42);
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(38);
	
	/***/ }),
	
	/***/ 5:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(93);
	
	/***/ }),
	
	/***/ 7:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(20);
	
	/***/ }),
	
	/***/ 74:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/popover/src/main.vue?vue&type=template&id=52060272&
	var render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "span",
	    [
	      _c(
	        "transition",
	        {
	          attrs: { name: _vm.transition },
	          on: {
	            "after-enter": _vm.handleAfterEnter,
	            "after-leave": _vm.handleAfterLeave
	          }
	        },
	        [
	          _c(
	            "div",
	            {
	              directives: [
	                {
	                  name: "show",
	                  rawName: "v-show",
	                  value: !_vm.disabled && _vm.showPopper,
	                  expression: "!disabled && showPopper"
	                }
	              ],
	              ref: "popper",
	              staticClass: "el-popover el-popper",
	              class: [_vm.popperClass, _vm.content && "el-popover--plain"],
	              style: { width: _vm.width + "px" },
	              attrs: {
	                role: "tooltip",
	                id: _vm.tooltipId,
	                "aria-hidden":
	                  _vm.disabled || !_vm.showPopper ? "true" : "false"
	              }
	            },
	            [
	              _vm.title
	                ? _c("div", {
	                    staticClass: "el-popover__title",
	                    domProps: { textContent: _vm._s(_vm.title) }
	                  })
	                : _vm._e(),
	              _vm._t("default", [_vm._v(_vm._s(_vm.content))])
	            ],
	            2
	          )
	        ]
	      ),
	      _vm._t("reference")
	    ],
	    2
	  )
	}
	var staticRenderFns = []
	render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/popover/src/main.vue?vue&type=template&id=52060272&
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/vue-popper"
	var vue_popper_ = __webpack_require__(5);
	var vue_popper_default = /*#__PURE__*/__webpack_require__.n(vue_popper_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/dom"
	var dom_ = __webpack_require__(2);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/util"
	var util_ = __webpack_require__(3);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/popover/src/main.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	/* harmony default export */ var mainvue_type_script_lang_js_ = ({
	  name: 'ElPopover',
	
	  mixins: [vue_popper_default.a],
	
	  props: {
	    trigger: {
	      type: String,
	      default: 'click',
	      validator: function validator(value) {
	        return ['click', 'focus', 'hover', 'manual'].indexOf(value) > -1;
	      }
	    },
	    openDelay: {
	      type: Number,
	      default: 0
	    },
	    closeDelay: {
	      type: Number,
	      default: 200
	    },
	    title: String,
	    disabled: Boolean,
	    content: String,
	    reference: {},
	    popperClass: String,
	    width: {},
	    visibleArrow: {
	      default: true
	    },
	    arrowOffset: {
	      type: Number,
	      default: 0
	    },
	    transition: {
	      type: String,
	      default: 'fade-in-linear'
	    },
	    tabindex: {
	      type: Number,
	      default: 0
	    }
	  },
	
	  computed: {
	    tooltipId: function tooltipId() {
	      return 'el-popover-' + Object(util_["generateId"])();
	    }
	  },
	  watch: {
	    showPopper: function showPopper(val) {
	      if (this.disabled) {
	        return;
	      }
	      val ? this.$emit('show') : this.$emit('hide');
	    }
	  },
	
	  mounted: function mounted() {
	    var _this = this;
	
	    var reference = this.referenceElm = this.reference || this.$refs.reference;
	    var popper = this.popper || this.$refs.popper;
	
	    if (!reference && this.$slots.reference && this.$slots.reference[0]) {
	      reference = this.referenceElm = this.$slots.reference[0].elm;
	    }
	    // 可访问性
	    if (reference) {
	      Object(dom_["addClass"])(reference, 'el-popover__reference');
	      reference.setAttribute('aria-describedby', this.tooltipId);
	      reference.setAttribute('tabindex', this.tabindex); // tab序列
	      popper.setAttribute('tabindex', 0);
	
	      if (this.trigger !== 'click') {
	        Object(dom_["on"])(reference, 'focusin', function () {
	          _this.handleFocus();
	          var instance = reference.__vue__;
	          if (instance && typeof instance.focus === 'function') {
	            instance.focus();
	          }
	        });
	        Object(dom_["on"])(popper, 'focusin', this.handleFocus);
	        Object(dom_["on"])(reference, 'focusout', this.handleBlur);
	        Object(dom_["on"])(popper, 'focusout', this.handleBlur);
	      }
	      Object(dom_["on"])(reference, 'keydown', this.handleKeydown);
	      Object(dom_["on"])(reference, 'click', this.handleClick);
	    }
	    if (this.trigger === 'click') {
	      Object(dom_["on"])(reference, 'click', this.doToggle);
	      Object(dom_["on"])(document, 'click', this.handleDocumentClick);
	    } else if (this.trigger === 'hover') {
	      Object(dom_["on"])(reference, 'mouseenter', this.handleMouseEnter);
	      Object(dom_["on"])(popper, 'mouseenter', this.handleMouseEnter);
	      Object(dom_["on"])(reference, 'mouseleave', this.handleMouseLeave);
	      Object(dom_["on"])(popper, 'mouseleave', this.handleMouseLeave);
	    } else if (this.trigger === 'focus') {
	      if (this.tabindex < 0) {
	        console.warn('[Element Warn][Popover]a negative taindex means that the element cannot be focused by tab key');
	      }
	      if (reference.querySelector('input, textarea')) {
	        Object(dom_["on"])(reference, 'focusin', this.doShow);
	        Object(dom_["on"])(reference, 'focusout', this.doClose);
	      } else {
	        Object(dom_["on"])(reference, 'mousedown', this.doShow);
	        Object(dom_["on"])(reference, 'mouseup', this.doClose);
	      }
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.cleanup();
	  },
	  deactivated: function deactivated() {
	    this.cleanup();
	  },
	
	
	  methods: {
	    doToggle: function doToggle() {
	      this.showPopper = !this.showPopper;
	    },
	    doShow: function doShow() {
	      this.showPopper = true;
	    },
	    doClose: function doClose() {
	      this.showPopper = false;
	    },
	    handleFocus: function handleFocus() {
	      Object(dom_["addClass"])(this.referenceElm, 'focusing');
	      if (this.trigger === 'click' || this.trigger === 'focus') this.showPopper = true;
	    },
	    handleClick: function handleClick() {
	      Object(dom_["removeClass"])(this.referenceElm, 'focusing');
	    },
	    handleBlur: function handleBlur() {
	      Object(dom_["removeClass"])(this.referenceElm, 'focusing');
	      if (this.trigger === 'click' || this.trigger === 'focus') this.showPopper = false;
	    },
	    handleMouseEnter: function handleMouseEnter() {
	      var _this2 = this;
	
	      clearTimeout(this._timer);
	      if (this.openDelay) {
	        this._timer = setTimeout(function () {
	          _this2.showPopper = true;
	        }, this.openDelay);
	      } else {
	        this.showPopper = true;
	      }
	    },
	    handleKeydown: function handleKeydown(ev) {
	      if (ev.keyCode === 27 && this.trigger !== 'manual') {
	        // esc
	        this.doClose();
	      }
	    },
	    handleMouseLeave: function handleMouseLeave() {
	      var _this3 = this;
	
	      clearTimeout(this._timer);
	      if (this.closeDelay) {
	        this._timer = setTimeout(function () {
	          _this3.showPopper = false;
	        }, this.closeDelay);
	      } else {
	        this.showPopper = false;
	      }
	    },
	    handleDocumentClick: function handleDocumentClick(e) {
	      var reference = this.reference || this.$refs.reference;
	      var popper = this.popper || this.$refs.popper;
	
	      if (!reference && this.$slots.reference && this.$slots.reference[0]) {
	        reference = this.referenceElm = this.$slots.reference[0].elm;
	      }
	      if (!this.$el || !reference || this.$el.contains(e.target) || reference.contains(e.target) || !popper || popper.contains(e.target)) return;
	      this.showPopper = false;
	    },
	    handleAfterEnter: function handleAfterEnter() {
	      this.$emit('after-enter');
	    },
	    handleAfterLeave: function handleAfterLeave() {
	      this.$emit('after-leave');
	      this.doDestroy();
	    },
	    cleanup: function cleanup() {
	      if (this.openDelay || this.closeDelay) {
	        clearTimeout(this._timer);
	      }
	    }
	  },
	
	  destroyed: function destroyed() {
	    var reference = this.reference;
	
	    Object(dom_["off"])(reference, 'click', this.doToggle);
	    Object(dom_["off"])(reference, 'mouseup', this.doClose);
	    Object(dom_["off"])(reference, 'mousedown', this.doShow);
	    Object(dom_["off"])(reference, 'focusin', this.doShow);
	    Object(dom_["off"])(reference, 'focusout', this.doClose);
	    Object(dom_["off"])(reference, 'mousedown', this.doShow);
	    Object(dom_["off"])(reference, 'mouseup', this.doClose);
	    Object(dom_["off"])(reference, 'mouseleave', this.handleMouseLeave);
	    Object(dom_["off"])(reference, 'mouseenter', this.handleMouseEnter);
	    Object(dom_["off"])(document, 'click', this.handleDocumentClick);
	  }
	});
	// CONCATENATED MODULE: ./packages/popover/src/main.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_mainvue_type_script_lang_js_ = (mainvue_type_script_lang_js_); 
	// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
	var componentNormalizer = __webpack_require__(0);
	
	// CONCATENATED MODULE: ./packages/popover/src/main.vue
	
	
	
	
	
	/* normalize component */
	
	var component = Object(componentNormalizer["a" /* default */])(
	  src_mainvue_type_script_lang_js_,
	  render,
	  staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var api; }
	component.options.__file = "packages/popover/src/main.vue"
	/* harmony default export */ var main = (component.exports);
	// CONCATENATED MODULE: ./packages/popover/src/directive.js
	var getReference = function getReference(el, binding, vnode) {
	  var _ref = binding.expression ? binding.value : binding.arg;
	  var popper = vnode.context.$refs[_ref];
	  if (popper) {
	    if (Array.isArray(popper)) {
	      popper[0].$refs.reference = el;
	    } else {
	      popper.$refs.reference = el;
	    }
	  }
	};
	
	/* harmony default export */ var directive = ({
	  bind: function bind(el, binding, vnode) {
	    getReference(el, binding, vnode);
	  },
	  inserted: function inserted(el, binding, vnode) {
	    getReference(el, binding, vnode);
	  }
	});
	// EXTERNAL MODULE: external "vue"
	var external_vue_ = __webpack_require__(7);
	var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);
	
	// CONCATENATED MODULE: ./packages/popover/index.js
	
	
	
	
	external_vue_default.a.directive('popover', directive);
	
	/* istanbul ignore next */
	main.install = function (Vue) {
	  Vue.directive('popover', directive);
	  Vue.component(main.name, main);
	};
	main.directive = directive;
	
	/* harmony default export */ var popover = __webpack_exports__["default"] = (main);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 392 */
/***/ (function(module, exports) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 119);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
	/* globals __VUE_SSR_CONTEXT__ */
	
	// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
	// This module is a runtime utility for cleaner component module output and will
	// be included in the final webpack user bundle.
	
	function normalizeComponent (
	  scriptExports,
	  render,
	  staticRenderFns,
	  functionalTemplate,
	  injectStyles,
	  scopeId,
	  moduleIdentifier, /* server only */
	  shadowMode /* vue-cli only */
	) {
	  // Vue.extend constructor export interop
	  var options = typeof scriptExports === 'function'
	    ? scriptExports.options
	    : scriptExports
	
	  // render functions
	  if (render) {
	    options.render = render
	    options.staticRenderFns = staticRenderFns
	    options._compiled = true
	  }
	
	  // functional template
	  if (functionalTemplate) {
	    options.functional = true
	  }
	
	  // scopedId
	  if (scopeId) {
	    options._scopeId = 'data-v-' + scopeId
	  }
	
	  var hook
	  if (moduleIdentifier) { // server build
	    hook = function (context) {
	      // 2.3 injection
	      context =
	        context || // cached call
	        (this.$vnode && this.$vnode.ssrContext) || // stateful
	        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
	      // 2.2 with runInNewContext: true
	      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
	        context = __VUE_SSR_CONTEXT__
	      }
	      // inject component styles
	      if (injectStyles) {
	        injectStyles.call(this, context)
	      }
	      // register component module identifier for async chunk inferrence
	      if (context && context._registeredComponents) {
	        context._registeredComponents.add(moduleIdentifier)
	      }
	    }
	    // used by ssr in case component is cached and beforeCreate
	    // never gets called
	    options._ssrRegister = hook
	  } else if (injectStyles) {
	    hook = shadowMode
	      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
	      : injectStyles
	  }
	
	  if (hook) {
	    if (options.functional) {
	      // for template-only hot-reload because in that case the render fn doesn't
	      // go through the normalizer
	      options._injectStyles = hook
	      // register for functioal component in vue file
	      var originalRender = options.render
	      options.render = function renderWithStyleInjection (h, context) {
	        hook.call(context)
	        return originalRender(h, context)
	      }
	    } else {
	      // inject component registration as beforeCreate hook
	      var existing = options.beforeCreate
	      options.beforeCreate = existing
	        ? [].concat(existing, hook)
	        : [hook]
	    }
	  }
	
	  return {
	    exports: scriptExports,
	    options: options
	  }
	}
	
	
	/***/ }),
	
	/***/ 119:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/progress/src/progress.vue?vue&type=template&id=229ee406&
	var render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-progress",
	      class: [
	        "el-progress--" + _vm.type,
	        _vm.status ? "is-" + _vm.status : "",
	        {
	          "el-progress--without-text": !_vm.showText,
	          "el-progress--text-inside": _vm.textInside
	        }
	      ],
	      attrs: {
	        role: "progressbar",
	        "aria-valuenow": _vm.percentage,
	        "aria-valuemin": "0",
	        "aria-valuemax": "100"
	      }
	    },
	    [
	      _vm.type === "line"
	        ? _c("div", { staticClass: "el-progress-bar" }, [
	            _c(
	              "div",
	              {
	                staticClass: "el-progress-bar__outer",
	                style: { height: _vm.strokeWidth + "px" }
	              },
	              [
	                _c(
	                  "div",
	                  {
	                    staticClass: "el-progress-bar__inner",
	                    style: _vm.barStyle
	                  },
	                  [
	                    _vm.showText && _vm.textInside
	                      ? _c(
	                          "div",
	                          { staticClass: "el-progress-bar__innerText" },
	                          [_vm._v(_vm._s(_vm.content))]
	                        )
	                      : _vm._e()
	                  ]
	                )
	              ]
	            )
	          ])
	        : _c(
	            "div",
	            {
	              staticClass: "el-progress-circle",
	              style: { height: _vm.width + "px", width: _vm.width + "px" }
	            },
	            [
	              _c("svg", { attrs: { viewBox: "0 0 100 100" } }, [
	                _c("path", {
	                  staticClass: "el-progress-circle__track",
	                  style: _vm.trailPathStyle,
	                  attrs: {
	                    d: _vm.trackPath,
	                    stroke: "#e5e9f2",
	                    "stroke-width": _vm.relativeStrokeWidth,
	                    fill: "none"
	                  }
	                }),
	                _c("path", {
	                  staticClass: "el-progress-circle__path",
	                  style: _vm.circlePathStyle,
	                  attrs: {
	                    d: _vm.trackPath,
	                    stroke: _vm.stroke,
	                    fill: "none",
	                    "stroke-linecap": _vm.strokeLinecap,
	                    "stroke-width": _vm.percentage ? _vm.relativeStrokeWidth : 0
	                  }
	                })
	              ])
	            ]
	          ),
	      _vm.showText && !_vm.textInside
	        ? _c(
	            "div",
	            {
	              staticClass: "el-progress__text",
	              style: { fontSize: _vm.progressTextSize + "px" }
	            },
	            [
	              !_vm.status
	                ? [_vm._v(_vm._s(_vm.content))]
	                : _c("i", { class: _vm.iconClass })
	            ],
	            2
	          )
	        : _vm._e()
	    ]
	  )
	}
	var staticRenderFns = []
	render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/progress/src/progress.vue?vue&type=template&id=229ee406&
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/progress/src/progress.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ var progressvue_type_script_lang_js_ = ({
	  name: 'ElProgress',
	  props: {
	    type: {
	      type: String,
	      default: 'line',
	      validator: function validator(val) {
	        return ['line', 'circle', 'dashboard'].indexOf(val) > -1;
	      }
	    },
	    percentage: {
	      type: Number,
	      default: 0,
	      required: true,
	      validator: function validator(val) {
	        return val >= 0 && val <= 100;
	      }
	    },
	    status: {
	      type: String,
	      validator: function validator(val) {
	        return ['success', 'exception', 'warning'].indexOf(val) > -1;
	      }
	    },
	    strokeWidth: {
	      type: Number,
	      default: 6
	    },
	    strokeLinecap: {
	      type: String,
	      default: 'round'
	    },
	    textInside: {
	      type: Boolean,
	      default: false
	    },
	    width: {
	      type: Number,
	      default: 126
	    },
	    showText: {
	      type: Boolean,
	      default: true
	    },
	    color: {
	      type: [String, Array, Function],
	      default: ''
	    },
	    format: Function
	  },
	  computed: {
	    barStyle: function barStyle() {
	      var style = {};
	      style.width = this.percentage + '%';
	      style.backgroundColor = this.getCurrentColor(this.percentage);
	      return style;
	    },
	    relativeStrokeWidth: function relativeStrokeWidth() {
	      return (this.strokeWidth / this.width * 100).toFixed(1);
	    },
	    radius: function radius() {
	      if (this.type === 'circle' || this.type === 'dashboard') {
	        return parseInt(50 - parseFloat(this.relativeStrokeWidth) / 2, 10);
	      } else {
	        return 0;
	      }
	    },
	    trackPath: function trackPath() {
	      var radius = this.radius;
	      var isDashboard = this.type === 'dashboard';
	      return '\n        M 50 50\n        m 0 ' + (isDashboard ? '' : '-') + radius + '\n        a ' + radius + ' ' + radius + ' 0 1 1 0 ' + (isDashboard ? '-' : '') + radius * 2 + '\n        a ' + radius + ' ' + radius + ' 0 1 1 0 ' + (isDashboard ? '' : '-') + radius * 2 + '\n        ';
	    },
	    perimeter: function perimeter() {
	      return 2 * Math.PI * this.radius;
	    },
	    rate: function rate() {
	      return this.type === 'dashboard' ? 0.75 : 1;
	    },
	    strokeDashoffset: function strokeDashoffset() {
	      var offset = -1 * this.perimeter * (1 - this.rate) / 2;
	      return offset + 'px';
	    },
	    trailPathStyle: function trailPathStyle() {
	      return {
	        strokeDasharray: this.perimeter * this.rate + 'px, ' + this.perimeter + 'px',
	        strokeDashoffset: this.strokeDashoffset
	      };
	    },
	    circlePathStyle: function circlePathStyle() {
	      return {
	        strokeDasharray: this.perimeter * this.rate * (this.percentage / 100) + 'px, ' + this.perimeter + 'px',
	        strokeDashoffset: this.strokeDashoffset,
	        transition: 'stroke-dasharray 0.6s ease 0s, stroke 0.6s ease'
	      };
	    },
	    stroke: function stroke() {
	      var ret = void 0;
	      if (this.color) {
	        ret = this.getCurrentColor(this.percentage);
	      } else {
	        switch (this.status) {
	          case 'success':
	            ret = '#13ce66';
	            break;
	          case 'exception':
	            ret = '#ff4949';
	            break;
	          case 'warning':
	            ret = '#e6a23c';
	            break;
	          default:
	            ret = '#20a0ff';
	        }
	      }
	      return ret;
	    },
	    iconClass: function iconClass() {
	      if (this.status === 'warning') {
	        return 'el-icon-warning';
	      }
	      if (this.type === 'line') {
	        return this.status === 'success' ? 'el-icon-circle-check' : 'el-icon-circle-close';
	      } else {
	        return this.status === 'success' ? 'el-icon-check' : 'el-icon-close';
	      }
	    },
	    progressTextSize: function progressTextSize() {
	      return this.type === 'line' ? 12 + this.strokeWidth * 0.4 : this.width * 0.111111 + 2;
	    },
	    content: function content() {
	      if (typeof this.format === 'function') {
	        return this.format(this.percentage) || '';
	      } else {
	        return this.percentage + '%';
	      }
	    }
	  },
	  methods: {
	    getCurrentColor: function getCurrentColor(percentage) {
	      if (typeof this.color === 'function') {
	        return this.color(percentage);
	      } else if (typeof this.color === 'string') {
	        return this.color;
	      } else {
	        return this.getLevelColor(percentage);
	      }
	    },
	    getLevelColor: function getLevelColor(percentage) {
	      var colorArray = this.getColorArray().sort(function (a, b) {
	        return a.percentage - b.percentage;
	      });
	
	      for (var i = 0; i < colorArray.length; i++) {
	        if (colorArray[i].percentage > percentage) {
	          return colorArray[i].color;
	        }
	      }
	      return colorArray[colorArray.length - 1].color;
	    },
	    getColorArray: function getColorArray() {
	      var color = this.color;
	      var span = 100 / color.length;
	      return color.map(function (seriesColor, index) {
	        if (typeof seriesColor === 'string') {
	          return {
	            color: seriesColor,
	            progress: (index + 1) * span
	          };
	        }
	        return seriesColor;
	      });
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/progress/src/progress.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_progressvue_type_script_lang_js_ = (progressvue_type_script_lang_js_); 
	// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
	var componentNormalizer = __webpack_require__(0);
	
	// CONCATENATED MODULE: ./packages/progress/src/progress.vue
	
	
	
	
	
	/* normalize component */
	
	var component = Object(componentNormalizer["a" /* default */])(
	  src_progressvue_type_script_lang_js_,
	  render,
	  staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var api; }
	component.options.__file = "packages/progress/src/progress.vue"
	/* harmony default export */ var progress = (component.exports);
	// CONCATENATED MODULE: ./packages/progress/index.js
	
	
	/* istanbul ignore next */
	progress.install = function (Vue) {
	  Vue.component(progress.name, progress);
	};
	
	/* harmony default export */ var packages_progress = __webpack_exports__["default"] = (progress);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 61);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
	/* globals __VUE_SSR_CONTEXT__ */
	
	// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
	// This module is a runtime utility for cleaner component module output and will
	// be included in the final webpack user bundle.
	
	function normalizeComponent (
	  scriptExports,
	  render,
	  staticRenderFns,
	  functionalTemplate,
	  injectStyles,
	  scopeId,
	  moduleIdentifier, /* server only */
	  shadowMode /* vue-cli only */
	) {
	  // Vue.extend constructor export interop
	  var options = typeof scriptExports === 'function'
	    ? scriptExports.options
	    : scriptExports
	
	  // render functions
	  if (render) {
	    options.render = render
	    options.staticRenderFns = staticRenderFns
	    options._compiled = true
	  }
	
	  // functional template
	  if (functionalTemplate) {
	    options.functional = true
	  }
	
	  // scopedId
	  if (scopeId) {
	    options._scopeId = 'data-v-' + scopeId
	  }
	
	  var hook
	  if (moduleIdentifier) { // server build
	    hook = function (context) {
	      // 2.3 injection
	      context =
	        context || // cached call
	        (this.$vnode && this.$vnode.ssrContext) || // stateful
	        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
	      // 2.2 with runInNewContext: true
	      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
	        context = __VUE_SSR_CONTEXT__
	      }
	      // inject component styles
	      if (injectStyles) {
	        injectStyles.call(this, context)
	      }
	      // register component module identifier for async chunk inferrence
	      if (context && context._registeredComponents) {
	        context._registeredComponents.add(moduleIdentifier)
	      }
	    }
	    // used by ssr in case component is cached and beforeCreate
	    // never gets called
	    options._ssrRegister = hook
	  } else if (injectStyles) {
	    hook = shadowMode
	      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
	      : injectStyles
	  }
	
	  if (hook) {
	    if (options.functional) {
	      // for template-only hot-reload because in that case the render fn doesn't
	      // go through the normalizer
	      options._injectStyles = hook
	      // register for functioal component in vue file
	      var originalRender = options.render
	      options.render = function renderWithStyleInjection (h, context) {
	        hook.call(context)
	        return originalRender(h, context)
	      }
	    } else {
	      // inject component registration as beforeCreate hook
	      var existing = options.beforeCreate
	      options.beforeCreate = existing
	        ? [].concat(existing, hook)
	        : [hook]
	    }
	  }
	
	  return {
	    exports: scriptExports,
	    options: options
	  }
	}
	
	
	/***/ }),
	/* 1 */,
	/* 2 */,
	/* 3 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(38);
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(54);
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(93);
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(127);
	
	/***/ }),
	/* 7 */,
	/* 8 */,
	/* 9 */,
	/* 10 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(125);
	
	/***/ }),
	/* 11 */,
	/* 12 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(178);
	
	/***/ }),
	/* 13 */,
	/* 14 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(128);
	
	/***/ }),
	/* 15 */,
	/* 16 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(130);
	
	/***/ }),
	/* 17 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(94);
	
	/***/ }),
	/* 18 */,
	/* 19 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(90);
	
	/***/ }),
	/* 20 */,
	/* 21 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(92);
	
	/***/ }),
	/* 22 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(126);
	
	/***/ }),
	/* 23 */,
	/* 24 */,
	/* 25 */,
	/* 26 */,
	/* 27 */,
	/* 28 */,
	/* 29 */,
	/* 30 */,
	/* 31 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(131);
	
	/***/ }),
	/* 32 */,
	/* 33 */,
	/* 34 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/option.vue?vue&type=template&id=7a44c642&
	var render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "li",
	    {
	      directives: [
	        {
	          name: "show",
	          rawName: "v-show",
	          value: _vm.visible,
	          expression: "visible"
	        }
	      ],
	      staticClass: "el-select-dropdown__item",
	      class: {
	        selected: _vm.itemSelected,
	        "is-disabled": _vm.disabled || _vm.groupDisabled || _vm.limitReached,
	        hover: _vm.hover
	      },
	      on: {
	        mouseenter: _vm.hoverItem,
	        click: function($event) {
	          $event.stopPropagation()
	          return _vm.selectOptionClick($event)
	        }
	      }
	    },
	    [_vm._t("default", [_c("span", [_vm._v(_vm._s(_vm.currentLabel))])])],
	    2
	  )
	}
	var staticRenderFns = []
	render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/select/src/option.vue?vue&type=template&id=7a44c642&
	
	// EXTERNAL MODULE: external "element-ui/lib/mixins/emitter"
	var emitter_ = __webpack_require__(4);
	var emitter_default = /*#__PURE__*/__webpack_require__.n(emitter_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/util"
	var util_ = __webpack_require__(3);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/option.vue?vue&type=script&lang=js&
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	/* harmony default export */ var optionvue_type_script_lang_js_ = ({
	  mixins: [emitter_default.a],
	
	  name: 'ElOption',
	
	  componentName: 'ElOption',
	
	  inject: ['select'],
	
	  props: {
	    value: {
	      required: true
	    },
	    label: [String, Number],
	    created: Boolean,
	    disabled: {
	      type: Boolean,
	      default: false
	    }
	  },
	
	  data: function data() {
	    return {
	      index: -1,
	      groupDisabled: false,
	      visible: true,
	      hitState: false,
	      hover: false
	    };
	  },
	
	
	  computed: {
	    isObject: function isObject() {
	      return Object.prototype.toString.call(this.value).toLowerCase() === '[object object]';
	    },
	    currentLabel: function currentLabel() {
	      return this.label || (this.isObject ? '' : this.value);
	    },
	    currentValue: function currentValue() {
	      return this.value || this.label || '';
	    },
	    itemSelected: function itemSelected() {
	      if (!this.select.multiple) {
	        return this.isEqual(this.value, this.select.value);
	      } else {
	        return this.contains(this.select.value, this.value);
	      }
	    },
	    limitReached: function limitReached() {
	      if (this.select.multiple) {
	        return !this.itemSelected && (this.select.value || []).length >= this.select.multipleLimit && this.select.multipleLimit > 0;
	      } else {
	        return false;
	      }
	    }
	  },
	
	  watch: {
	    currentLabel: function currentLabel() {
	      if (!this.created && !this.select.remote) this.dispatch('ElSelect', 'setSelected');
	    },
	    value: function value(val, oldVal) {
	      var _select = this.select,
	          remote = _select.remote,
	          valueKey = _select.valueKey;
	
	      if (!this.created && !remote) {
	        if (valueKey && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object' && (typeof oldVal === 'undefined' ? 'undefined' : _typeof(oldVal)) === 'object' && val[valueKey] === oldVal[valueKey]) {
	          return;
	        }
	        this.dispatch('ElSelect', 'setSelected');
	      }
	    }
	  },
	
	  methods: {
	    isEqual: function isEqual(a, b) {
	      if (!this.isObject) {
	        return a === b;
	      } else {
	        var valueKey = this.select.valueKey;
	        return Object(util_["getValueByPath"])(a, valueKey) === Object(util_["getValueByPath"])(b, valueKey);
	      }
	    },
	    contains: function contains() {
	      var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	      var target = arguments[1];
	
	      if (!this.isObject) {
	        return arr && arr.indexOf(target) > -1;
	      } else {
	        var valueKey = this.select.valueKey;
	        return arr && arr.some(function (item) {
	          return Object(util_["getValueByPath"])(item, valueKey) === Object(util_["getValueByPath"])(target, valueKey);
	        });
	      }
	    },
	    handleGroupDisabled: function handleGroupDisabled(val) {
	      this.groupDisabled = val;
	    },
	    hoverItem: function hoverItem() {
	      if (!this.disabled && !this.groupDisabled) {
	        this.select.hoverIndex = this.select.options.indexOf(this);
	      }
	    },
	    selectOptionClick: function selectOptionClick() {
	      if (this.disabled !== true && this.groupDisabled !== true) {
	        this.dispatch('ElSelect', 'handleOptionClick', [this, true]);
	      }
	    },
	    queryChange: function queryChange(query) {
	      this.visible = new RegExp(Object(util_["escapeRegexpString"])(query), 'i').test(this.currentLabel) || this.created;
	      if (!this.visible) {
	        this.select.filteredOptionsCount--;
	      }
	    }
	  },
	
	  created: function created() {
	    this.select.options.push(this);
	    this.select.cachedOptions.push(this);
	    this.select.optionsCount++;
	    this.select.filteredOptionsCount++;
	
	    this.$on('queryChange', this.queryChange);
	    this.$on('handleGroupDisabled', this.handleGroupDisabled);
	  },
	  beforeDestroy: function beforeDestroy() {
	    var _select2 = this.select,
	        selected = _select2.selected,
	        multiple = _select2.multiple;
	
	    var selectedOptions = multiple ? selected : [selected];
	    var index = this.select.cachedOptions.indexOf(this);
	    var selectedIndex = selectedOptions.indexOf(this);
	
	    // if option is not selected, remove it from cache
	    if (index > -1 && selectedIndex < 0) {
	      this.select.cachedOptions.splice(index, 1);
	    }
	    this.select.onOptionDestroy(this.select.options.indexOf(this));
	  }
	});
	// CONCATENATED MODULE: ./packages/select/src/option.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_optionvue_type_script_lang_js_ = (optionvue_type_script_lang_js_); 
	// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
	var componentNormalizer = __webpack_require__(0);
	
	// CONCATENATED MODULE: ./packages/select/src/option.vue
	
	
	
	
	
	/* normalize component */
	
	var component = Object(componentNormalizer["a" /* default */])(
	  src_optionvue_type_script_lang_js_,
	  render,
	  staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var api; }
	component.options.__file = "packages/select/src/option.vue"
	/* harmony default export */ var src_option = __webpack_exports__["a"] = (component.exports);
	
	/***/ }),
	/* 35 */,
	/* 36 */,
	/* 37 */,
	/* 38 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(177);
	
	/***/ }),
	/* 39 */,
	/* 40 */,
	/* 41 */,
	/* 42 */,
	/* 43 */,
	/* 44 */,
	/* 45 */,
	/* 46 */,
	/* 47 */,
	/* 48 */,
	/* 49 */,
	/* 50 */,
	/* 51 */,
	/* 52 */,
	/* 53 */,
	/* 54 */,
	/* 55 */,
	/* 56 */,
	/* 57 */,
	/* 58 */,
	/* 59 */,
	/* 60 */,
	/* 61 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/select.vue?vue&type=template&id=0e4aade6&
	var render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      directives: [
	        {
	          name: "clickoutside",
	          rawName: "v-clickoutside",
	          value: _vm.handleClose,
	          expression: "handleClose"
	        }
	      ],
	      staticClass: "el-select",
	      class: [_vm.selectSize ? "el-select--" + _vm.selectSize : ""],
	      on: {
	        click: function($event) {
	          $event.stopPropagation()
	          return _vm.toggleMenu($event)
	        }
	      }
	    },
	    [
	      _vm.multiple
	        ? _c(
	            "div",
	            {
	              ref: "tags",
	              staticClass: "el-select__tags",
	              style: { "max-width": _vm.inputWidth - 32 + "px", width: "100%" }
	            },
	            [
	              _vm.collapseTags && _vm.selected.length
	                ? _c(
	                    "span",
	                    [
	                      _c(
	                        "el-tag",
	                        {
	                          attrs: {
	                            closable: !_vm.selectDisabled,
	                            size: _vm.collapseTagSize,
	                            hit: _vm.selected[0].hitState,
	                            type: "info",
	                            "disable-transitions": ""
	                          },
	                          on: {
	                            close: function($event) {
	                              _vm.deleteTag($event, _vm.selected[0])
	                            }
	                          }
	                        },
	                        [
	                          _c("span", { staticClass: "el-select__tags-text" }, [
	                            _vm._v(_vm._s(_vm.selected[0].currentLabel))
	                          ])
	                        ]
	                      ),
	                      _vm.selected.length > 1
	                        ? _c(
	                            "el-tag",
	                            {
	                              attrs: {
	                                closable: false,
	                                size: _vm.collapseTagSize,
	                                type: "info",
	                                "disable-transitions": ""
	                              }
	                            },
	                            [
	                              _c(
	                                "span",
	                                { staticClass: "el-select__tags-text" },
	                                [_vm._v("+ " + _vm._s(_vm.selected.length - 1))]
	                              )
	                            ]
	                          )
	                        : _vm._e()
	                    ],
	                    1
	                  )
	                : _vm._e(),
	              !_vm.collapseTags
	                ? _c(
	                    "transition-group",
	                    { on: { "after-leave": _vm.resetInputHeight } },
	                    _vm._l(_vm.selected, function(item) {
	                      return _c(
	                        "el-tag",
	                        {
	                          key: _vm.getValueKey(item),
	                          attrs: {
	                            closable: !_vm.selectDisabled,
	                            size: _vm.collapseTagSize,
	                            hit: item.hitState,
	                            type: "info",
	                            "disable-transitions": ""
	                          },
	                          on: {
	                            close: function($event) {
	                              _vm.deleteTag($event, item)
	                            }
	                          }
	                        },
	                        [
	                          _c("span", { staticClass: "el-select__tags-text" }, [
	                            _vm._v(_vm._s(item.currentLabel))
	                          ])
	                        ]
	                      )
	                    }),
	                    1
	                  )
	                : _vm._e(),
	              _vm.filterable
	                ? _c("input", {
	                    directives: [
	                      {
	                        name: "model",
	                        rawName: "v-model",
	                        value: _vm.query,
	                        expression: "query"
	                      }
	                    ],
	                    ref: "input",
	                    staticClass: "el-select__input",
	                    class: [_vm.selectSize ? "is-" + _vm.selectSize : ""],
	                    style: {
	                      "flex-grow": "1",
	                      width: _vm.inputLength / (_vm.inputWidth - 32) + "%",
	                      "max-width": _vm.inputWidth - 42 + "px"
	                    },
	                    attrs: {
	                      type: "text",
	                      disabled: _vm.selectDisabled,
	                      autocomplete: _vm.autoComplete || _vm.autocomplete
	                    },
	                    domProps: { value: _vm.query },
	                    on: {
	                      focus: _vm.handleFocus,
	                      blur: function($event) {
	                        _vm.softFocus = false
	                      },
	                      keyup: _vm.managePlaceholder,
	                      keydown: [
	                        _vm.resetInputState,
	                        function($event) {
	                          if (
	                            !("button" in $event) &&
	                            _vm._k($event.keyCode, "down", 40, $event.key, [
	                              "Down",
	                              "ArrowDown"
	                            ])
	                          ) {
	                            return null
	                          }
	                          $event.preventDefault()
	                          _vm.navigateOptions("next")
	                        },
	                        function($event) {
	                          if (
	                            !("button" in $event) &&
	                            _vm._k($event.keyCode, "up", 38, $event.key, [
	                              "Up",
	                              "ArrowUp"
	                            ])
	                          ) {
	                            return null
	                          }
	                          $event.preventDefault()
	                          _vm.navigateOptions("prev")
	                        },
	                        function($event) {
	                          if (
	                            !("button" in $event) &&
	                            _vm._k(
	                              $event.keyCode,
	                              "enter",
	                              13,
	                              $event.key,
	                              "Enter"
	                            )
	                          ) {
	                            return null
	                          }
	                          $event.preventDefault()
	                          return _vm.selectOption($event)
	                        },
	                        function($event) {
	                          if (
	                            !("button" in $event) &&
	                            _vm._k($event.keyCode, "esc", 27, $event.key, [
	                              "Esc",
	                              "Escape"
	                            ])
	                          ) {
	                            return null
	                          }
	                          $event.stopPropagation()
	                          $event.preventDefault()
	                          _vm.visible = false
	                        },
	                        function($event) {
	                          if (
	                            !("button" in $event) &&
	                            _vm._k(
	                              $event.keyCode,
	                              "delete",
	                              [8, 46],
	                              $event.key,
	                              ["Backspace", "Delete", "Del"]
	                            )
	                          ) {
	                            return null
	                          }
	                          return _vm.deletePrevTag($event)
	                        },
	                        function($event) {
	                          if (
	                            !("button" in $event) &&
	                            _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
	                          ) {
	                            return null
	                          }
	                          _vm.visible = false
	                        }
	                      ],
	                      compositionstart: _vm.handleComposition,
	                      compositionupdate: _vm.handleComposition,
	                      compositionend: _vm.handleComposition,
	                      input: [
	                        function($event) {
	                          if ($event.target.composing) {
	                            return
	                          }
	                          _vm.query = $event.target.value
	                        },
	                        _vm.debouncedQueryChange
	                      ]
	                    }
	                  })
	                : _vm._e()
	            ],
	            1
	          )
	        : _vm._e(),
	      _c(
	        "el-input",
	        {
	          ref: "reference",
	          class: { "is-focus": _vm.visible },
	          attrs: {
	            type: "text",
	            placeholder: _vm.currentPlaceholder,
	            name: _vm.name,
	            id: _vm.id,
	            autocomplete: _vm.autoComplete || _vm.autocomplete,
	            size: _vm.selectSize,
	            disabled: _vm.selectDisabled,
	            readonly: _vm.readonly,
	            "validate-event": false,
	            tabindex: _vm.multiple && _vm.filterable ? "-1" : null
	          },
	          on: { focus: _vm.handleFocus, blur: _vm.handleBlur },
	          nativeOn: {
	            keyup: function($event) {
	              return _vm.debouncedOnInputChange($event)
	            },
	            keydown: [
	              function($event) {
	                if (
	                  !("button" in $event) &&
	                  _vm._k($event.keyCode, "down", 40, $event.key, [
	                    "Down",
	                    "ArrowDown"
	                  ])
	                ) {
	                  return null
	                }
	                $event.stopPropagation()
	                $event.preventDefault()
	                _vm.navigateOptions("next")
	              },
	              function($event) {
	                if (
	                  !("button" in $event) &&
	                  _vm._k($event.keyCode, "up", 38, $event.key, [
	                    "Up",
	                    "ArrowUp"
	                  ])
	                ) {
	                  return null
	                }
	                $event.stopPropagation()
	                $event.preventDefault()
	                _vm.navigateOptions("prev")
	              },
	              function($event) {
	                if (
	                  !("button" in $event) &&
	                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
	                ) {
	                  return null
	                }
	                $event.preventDefault()
	                return _vm.selectOption($event)
	              },
	              function($event) {
	                if (
	                  !("button" in $event) &&
	                  _vm._k($event.keyCode, "esc", 27, $event.key, [
	                    "Esc",
	                    "Escape"
	                  ])
	                ) {
	                  return null
	                }
	                $event.stopPropagation()
	                $event.preventDefault()
	                _vm.visible = false
	              },
	              function($event) {
	                if (
	                  !("button" in $event) &&
	                  _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
	                ) {
	                  return null
	                }
	                _vm.visible = false
	              }
	            ],
	            paste: function($event) {
	              return _vm.debouncedOnInputChange($event)
	            },
	            mouseenter: function($event) {
	              _vm.inputHovering = true
	            },
	            mouseleave: function($event) {
	              _vm.inputHovering = false
	            }
	          },
	          model: {
	            value: _vm.selectedLabel,
	            callback: function($$v) {
	              _vm.selectedLabel = $$v
	            },
	            expression: "selectedLabel"
	          }
	        },
	        [
	          _vm.$slots.prefix
	            ? _c("template", { slot: "prefix" }, [_vm._t("prefix")], 2)
	            : _vm._e(),
	          _c("template", { slot: "suffix" }, [
	            _c("i", {
	              directives: [
	                {
	                  name: "show",
	                  rawName: "v-show",
	                  value: !_vm.showClose,
	                  expression: "!showClose"
	                }
	              ],
	              class: [
	                "el-select__caret",
	                "el-input__icon",
	                "el-icon-" + _vm.iconClass
	              ]
	            }),
	            _vm.showClose
	              ? _c("i", {
	                  staticClass:
	                    "el-select__caret el-input__icon el-icon-circle-close",
	                  on: { click: _vm.handleClearClick }
	                })
	              : _vm._e()
	          ])
	        ],
	        2
	      ),
	      _c(
	        "transition",
	        {
	          attrs: { name: "el-zoom-in-top" },
	          on: {
	            "before-enter": _vm.handleMenuEnter,
	            "after-leave": _vm.doDestroy
	          }
	        },
	        [
	          _c(
	            "el-select-menu",
	            {
	              directives: [
	                {
	                  name: "show",
	                  rawName: "v-show",
	                  value: _vm.visible && _vm.emptyText !== false,
	                  expression: "visible && emptyText !== false"
	                }
	              ],
	              ref: "popper",
	              attrs: { "append-to-body": _vm.popperAppendToBody }
	            },
	            [
	              _c(
	                "el-scrollbar",
	                {
	                  directives: [
	                    {
	                      name: "show",
	                      rawName: "v-show",
	                      value: _vm.options.length > 0 && !_vm.loading,
	                      expression: "options.length > 0 && !loading"
	                    }
	                  ],
	                  ref: "scrollbar",
	                  class: {
	                    "is-empty":
	                      !_vm.allowCreate &&
	                      _vm.query &&
	                      _vm.filteredOptionsCount === 0
	                  },
	                  attrs: {
	                    tag: "ul",
	                    "wrap-class": "el-select-dropdown__wrap",
	                    "view-class": "el-select-dropdown__list"
	                  }
	                },
	                [
	                  _vm.showNewOption
	                    ? _c("el-option", {
	                        attrs: { value: _vm.query, created: "" }
	                      })
	                    : _vm._e(),
	                  _vm._t("default")
	                ],
	                2
	              ),
	              _vm.emptyText &&
	              (!_vm.allowCreate ||
	                _vm.loading ||
	                (_vm.allowCreate && _vm.options.length === 0))
	                ? [
	                    _vm.$slots.empty
	                      ? _vm._t("empty")
	                      : _c("p", { staticClass: "el-select-dropdown__empty" }, [
	                          _vm._v(
	                            "\n          " +
	                              _vm._s(_vm.emptyText) +
	                              "\n        "
	                          )
	                        ])
	                  ]
	                : _vm._e()
	            ],
	            2
	          )
	        ],
	        1
	      )
	    ],
	    1
	  )
	}
	var staticRenderFns = []
	render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/select/src/select.vue?vue&type=template&id=0e4aade6&
	
	// EXTERNAL MODULE: external "element-ui/lib/mixins/emitter"
	var emitter_ = __webpack_require__(4);
	var emitter_default = /*#__PURE__*/__webpack_require__.n(emitter_);
	
	// EXTERNAL MODULE: external "element-ui/lib/mixins/focus"
	var focus_ = __webpack_require__(22);
	var focus_default = /*#__PURE__*/__webpack_require__.n(focus_);
	
	// EXTERNAL MODULE: external "element-ui/lib/mixins/locale"
	var locale_ = __webpack_require__(6);
	var locale_default = /*#__PURE__*/__webpack_require__.n(locale_);
	
	// EXTERNAL MODULE: external "element-ui/lib/input"
	var input_ = __webpack_require__(10);
	var input_default = /*#__PURE__*/__webpack_require__.n(input_);
	
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/select-dropdown.vue?vue&type=template&id=06828748&
	var select_dropdownvue_type_template_id_06828748_render = function() {
	  var _vm = this
	  var _h = _vm.$createElement
	  var _c = _vm._self._c || _h
	  return _c(
	    "div",
	    {
	      staticClass: "el-select-dropdown el-popper",
	      class: [{ "is-multiple": _vm.$parent.multiple }, _vm.popperClass],
	      style: { minWidth: _vm.minWidth }
	    },
	    [_vm._t("default")],
	    2
	  )
	}
	var select_dropdownvue_type_template_id_06828748_staticRenderFns = []
	select_dropdownvue_type_template_id_06828748_render._withStripped = true
	
	
	// CONCATENATED MODULE: ./packages/select/src/select-dropdown.vue?vue&type=template&id=06828748&
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/vue-popper"
	var vue_popper_ = __webpack_require__(5);
	var vue_popper_default = /*#__PURE__*/__webpack_require__.n(vue_popper_);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/select-dropdown.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ var select_dropdownvue_type_script_lang_js_ = ({
	  name: 'ElSelectDropdown',
	
	  componentName: 'ElSelectDropdown',
	
	  mixins: [vue_popper_default.a],
	
	  props: {
	    placement: {
	      default: 'bottom-start'
	    },
	
	    boundariesPadding: {
	      default: 0
	    },
	
	    popperOptions: {
	      default: function _default() {
	        return {
	          gpuAcceleration: false
	        };
	      }
	    },
	
	    visibleArrow: {
	      default: true
	    },
	
	    appendToBody: {
	      type: Boolean,
	      default: true
	    }
	  },
	
	  data: function data() {
	    return {
	      minWidth: ''
	    };
	  },
	
	
	  computed: {
	    popperClass: function popperClass() {
	      return this.$parent.popperClass;
	    }
	  },
	
	  watch: {
	    '$parent.inputWidth': function $parentInputWidth() {
	      this.minWidth = this.$parent.$el.getBoundingClientRect().width + 'px';
	    }
	  },
	
	  mounted: function mounted() {
	    var _this = this;
	
	    this.referenceElm = this.$parent.$refs.reference.$el;
	    this.$parent.popperElm = this.popperElm = this.$el;
	    this.$on('updatePopper', function () {
	      if (_this.$parent.visible) _this.updatePopper();
	    });
	    this.$on('destroyPopper', this.destroyPopper);
	  }
	});
	// CONCATENATED MODULE: ./packages/select/src/select-dropdown.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_select_dropdownvue_type_script_lang_js_ = (select_dropdownvue_type_script_lang_js_); 
	// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
	var componentNormalizer = __webpack_require__(0);
	
	// CONCATENATED MODULE: ./packages/select/src/select-dropdown.vue
	
	
	
	
	
	/* normalize component */
	
	var component = Object(componentNormalizer["a" /* default */])(
	  src_select_dropdownvue_type_script_lang_js_,
	  select_dropdownvue_type_template_id_06828748_render,
	  select_dropdownvue_type_template_id_06828748_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var api; }
	component.options.__file = "packages/select/src/select-dropdown.vue"
	/* harmony default export */ var select_dropdown = (component.exports);
	// EXTERNAL MODULE: ./packages/select/src/option.vue + 4 modules
	var src_option = __webpack_require__(34);
	
	// EXTERNAL MODULE: external "element-ui/lib/tag"
	var tag_ = __webpack_require__(38);
	var tag_default = /*#__PURE__*/__webpack_require__.n(tag_);
	
	// EXTERNAL MODULE: external "element-ui/lib/scrollbar"
	var scrollbar_ = __webpack_require__(14);
	var scrollbar_default = /*#__PURE__*/__webpack_require__.n(scrollbar_);
	
	// EXTERNAL MODULE: external "throttle-debounce/debounce"
	var debounce_ = __webpack_require__(17);
	var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/clickoutside"
	var clickoutside_ = __webpack_require__(12);
	var clickoutside_default = /*#__PURE__*/__webpack_require__.n(clickoutside_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/resize-event"
	var resize_event_ = __webpack_require__(16);
	
	// EXTERNAL MODULE: external "element-ui/lib/locale"
	var lib_locale_ = __webpack_require__(19);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/scroll-into-view"
	var scroll_into_view_ = __webpack_require__(31);
	var scroll_into_view_default = /*#__PURE__*/__webpack_require__.n(scroll_into_view_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/util"
	var util_ = __webpack_require__(3);
	
	// CONCATENATED MODULE: ./packages/select/src/navigation-mixin.js
	/* harmony default export */ var navigation_mixin = ({
	  data: function data() {
	    return {
	      hoverOption: -1
	    };
	  },
	
	
	  computed: {
	    optionsAllDisabled: function optionsAllDisabled() {
	      return this.options.filter(function (option) {
	        return option.visible;
	      }).every(function (option) {
	        return option.disabled;
	      });
	    }
	  },
	
	  watch: {
	    hoverIndex: function hoverIndex(val) {
	      var _this = this;
	
	      if (typeof val === 'number' && val > -1) {
	        this.hoverOption = this.options[val] || {};
	      }
	      this.options.forEach(function (option) {
	        option.hover = _this.hoverOption === option;
	      });
	    }
	  },
	
	  methods: {
	    navigateOptions: function navigateOptions(direction) {
	      var _this2 = this;
	
	      if (!this.visible) {
	        this.visible = true;
	        return;
	      }
	      if (this.options.length === 0 || this.filteredOptionsCount === 0) return;
	      if (!this.optionsAllDisabled) {
	        if (direction === 'next') {
	          this.hoverIndex++;
	          if (this.hoverIndex === this.options.length) {
	            this.hoverIndex = 0;
	          }
	        } else if (direction === 'prev') {
	          this.hoverIndex--;
	          if (this.hoverIndex < 0) {
	            this.hoverIndex = this.options.length - 1;
	          }
	        }
	        var option = this.options[this.hoverIndex];
	        if (option.disabled === true || option.groupDisabled === true || !option.visible) {
	          this.navigateOptions(direction);
	        }
	        this.$nextTick(function () {
	          return _this2.scrollToOption(_this2.hoverOption);
	        });
	      }
	    }
	  }
	});
	// EXTERNAL MODULE: external "element-ui/lib/utils/shared"
	var shared_ = __webpack_require__(21);
	
	// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/select.vue?vue&type=script&lang=js&
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	/* harmony default export */ var selectvue_type_script_lang_js_ = ({
	  mixins: [emitter_default.a, locale_default.a, focus_default()('reference'), navigation_mixin],
	
	  name: 'ElSelect',
	
	  componentName: 'ElSelect',
	
	  inject: {
	    elForm: {
	      default: ''
	    },
	
	    elFormItem: {
	      default: ''
	    }
	  },
	
	  provide: function provide() {
	    return {
	      'select': this
	    };
	  },
	
	
	  computed: {
	    _elFormItemSize: function _elFormItemSize() {
	      return (this.elFormItem || {}).elFormItemSize;
	    },
	    readonly: function readonly() {
	      return !this.filterable || this.multiple || !Object(util_["isIE"])() && !Object(util_["isEdge"])() && !this.visible;
	    },
	    showClose: function showClose() {
	      var hasValue = this.multiple ? Array.isArray(this.value) && this.value.length > 0 : this.value !== undefined && this.value !== null && this.value !== '';
	      var criteria = this.clearable && !this.selectDisabled && this.inputHovering && hasValue;
	      return criteria;
	    },
	    iconClass: function iconClass() {
	      return this.remote && this.filterable ? '' : this.visible ? 'arrow-up is-reverse' : 'arrow-up';
	    },
	    debounce: function debounce() {
	      return this.remote ? 300 : 0;
	    },
	    emptyText: function emptyText() {
	      if (this.loading) {
	        return this.loadingText || this.t('el.select.loading');
	      } else {
	        if (this.remote && this.query === '' && this.options.length === 0) return false;
	        if (this.filterable && this.query && this.options.length > 0 && this.filteredOptionsCount === 0) {
	          return this.noMatchText || this.t('el.select.noMatch');
	        }
	        if (this.options.length === 0) {
	          return this.noDataText || this.t('el.select.noData');
	        }
	      }
	      return null;
	    },
	    showNewOption: function showNewOption() {
	      var _this = this;
	
	      var hasExistingOption = this.options.filter(function (option) {
	        return !option.created;
	      }).some(function (option) {
	        return option.currentLabel === _this.query;
	      });
	      return this.filterable && this.allowCreate && this.query !== '' && !hasExistingOption;
	    },
	    selectSize: function selectSize() {
	      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
	    },
	    selectDisabled: function selectDisabled() {
	      return this.disabled || (this.elForm || {}).disabled;
	    },
	    collapseTagSize: function collapseTagSize() {
	      return ['small', 'mini'].indexOf(this.selectSize) > -1 ? 'mini' : 'small';
	    }
	  },
	
	  components: {
	    ElInput: input_default.a,
	    ElSelectMenu: select_dropdown,
	    ElOption: src_option["a" /* default */],
	    ElTag: tag_default.a,
	    ElScrollbar: scrollbar_default.a
	  },
	
	  directives: { Clickoutside: clickoutside_default.a },
	
	  props: {
	    name: String,
	    id: String,
	    value: {
	      required: true
	    },
	    autocomplete: {
	      type: String,
	      default: 'off'
	    },
	    /** @Deprecated in next major version */
	    autoComplete: {
	      type: String,
	      validator: function validator(val) {
	         false && false;
	        return true;
	      }
	    },
	    automaticDropdown: Boolean,
	    size: String,
	    disabled: Boolean,
	    clearable: Boolean,
	    filterable: Boolean,
	    allowCreate: Boolean,
	    loading: Boolean,
	    popperClass: String,
	    remote: Boolean,
	    loadingText: String,
	    noMatchText: String,
	    noDataText: String,
	    remoteMethod: Function,
	    filterMethod: Function,
	    multiple: Boolean,
	    multipleLimit: {
	      type: Number,
	      default: 0
	    },
	    placeholder: {
	      type: String,
	      default: function _default() {
	        return Object(lib_locale_["t"])('el.select.placeholder');
	      }
	    },
	    defaultFirstOption: Boolean,
	    reserveKeyword: Boolean,
	    valueKey: {
	      type: String,
	      default: 'value'
	    },
	    collapseTags: Boolean,
	    popperAppendToBody: {
	      type: Boolean,
	      default: true
	    }
	  },
	
	  data: function data() {
	    return {
	      options: [],
	      cachedOptions: [],
	      createdLabel: null,
	      createdSelected: false,
	      selected: this.multiple ? [] : {},
	      inputLength: 20,
	      inputWidth: 0,
	      initialInputHeight: 0,
	      cachedPlaceHolder: '',
	      optionsCount: 0,
	      filteredOptionsCount: 0,
	      visible: false,
	      softFocus: false,
	      selectedLabel: '',
	      hoverIndex: -1,
	      query: '',
	      previousQuery: null,
	      inputHovering: false,
	      currentPlaceholder: '',
	      menuVisibleOnFocus: false,
	      isOnComposition: false,
	      isSilentBlur: false
	    };
	  },
	
	
	  watch: {
	    selectDisabled: function selectDisabled() {
	      var _this2 = this;
	
	      this.$nextTick(function () {
	        _this2.resetInputHeight();
	      });
	    },
	    placeholder: function placeholder(val) {
	      this.cachedPlaceHolder = this.currentPlaceholder = val;
	    },
	    value: function value(val, oldVal) {
	      if (this.multiple) {
	        this.resetInputHeight();
	        if (val && val.length > 0 || this.$refs.input && this.query !== '') {
	          this.currentPlaceholder = '';
	        } else {
	          this.currentPlaceholder = this.cachedPlaceHolder;
	        }
	        if (this.filterable && !this.reserveKeyword) {
	          this.query = '';
	          this.handleQueryChange(this.query);
	        }
	      }
	      this.setSelected();
	      if (this.filterable && !this.multiple) {
	        this.inputLength = 20;
	      }
	      if (!Object(util_["valueEquals"])(val, oldVal)) {
	        this.dispatch('ElFormItem', 'el.form.change', val);
	      }
	    },
	    visible: function visible(val) {
	      var _this3 = this;
	
	      if (!val) {
	        this.broadcast('ElSelectDropdown', 'destroyPopper');
	        if (this.$refs.input) {
	          this.$refs.input.blur();
	        }
	        this.query = '';
	        this.previousQuery = null;
	        this.selectedLabel = '';
	        this.inputLength = 20;
	        this.menuVisibleOnFocus = false;
	        this.resetHoverIndex();
	        this.$nextTick(function () {
	          if (_this3.$refs.input && _this3.$refs.input.value === '' && _this3.selected.length === 0) {
	            _this3.currentPlaceholder = _this3.cachedPlaceHolder;
	          }
	        });
	        if (!this.multiple) {
	          if (this.selected) {
	            if (this.filterable && this.allowCreate && this.createdSelected && this.createdLabel) {
	              this.selectedLabel = this.createdLabel;
	            } else {
	              this.selectedLabel = this.selected.currentLabel;
	            }
	            if (this.filterable) this.query = this.selectedLabel;
	          }
	
	          if (this.filterable) {
	            this.currentPlaceholder = this.cachedPlaceHolder;
	          }
	        }
	      } else {
	        this.broadcast('ElSelectDropdown', 'updatePopper');
	        if (this.filterable) {
	          this.query = this.remote ? '' : this.selectedLabel;
	          this.handleQueryChange(this.query);
	          if (this.multiple) {
	            this.$refs.input.focus();
	          } else {
	            if (!this.remote) {
	              this.broadcast('ElOption', 'queryChange', '');
	              this.broadcast('ElOptionGroup', 'queryChange');
	            }
	
	            if (this.selectedLabel) {
	              this.currentPlaceholder = this.selectedLabel;
	              this.selectedLabel = '';
	            }
	          }
	        }
	      }
	      this.$emit('visible-change', val);
	    },
	    options: function options() {
	      var _this4 = this;
	
	      if (this.$isServer) return;
	      this.$nextTick(function () {
	        _this4.broadcast('ElSelectDropdown', 'updatePopper');
	      });
	      if (this.multiple) {
	        this.resetInputHeight();
	      }
	      var inputs = this.$el.querySelectorAll('input');
	      if ([].indexOf.call(inputs, document.activeElement) === -1) {
	        this.setSelected();
	      }
	      if (this.defaultFirstOption && (this.filterable || this.remote) && this.filteredOptionsCount) {
	        this.checkDefaultFirstOption();
	      }
	    }
	  },
	
	  methods: {
	    handleComposition: function handleComposition(event) {
	      var _this5 = this;
	
	      var text = event.target.value;
	      if (event.type === 'compositionend') {
	        this.isOnComposition = false;
	        this.$nextTick(function (_) {
	          return _this5.handleQueryChange(text);
	        });
	      } else {
	        var lastCharacter = text[text.length - 1] || '';
	        this.isOnComposition = !Object(shared_["isKorean"])(lastCharacter);
	      }
	    },
	    handleQueryChange: function handleQueryChange(val) {
	      var _this6 = this;
	
	      if (this.previousQuery === val || this.isOnComposition) return;
	      if (this.previousQuery === null && (typeof this.filterMethod === 'function' || typeof this.remoteMethod === 'function')) {
	        this.previousQuery = val;
	        return;
	      }
	      this.previousQuery = val;
	      this.$nextTick(function () {
	        if (_this6.visible) _this6.broadcast('ElSelectDropdown', 'updatePopper');
	      });
	      this.hoverIndex = -1;
	      if (this.multiple && this.filterable) {
	        this.$nextTick(function () {
	          var length = _this6.$refs.input.value.length * 15 + 20;
	          _this6.inputLength = _this6.collapseTags ? Math.min(50, length) : length;
	          _this6.managePlaceholder();
	          _this6.resetInputHeight();
	        });
	      }
	      if (this.remote && typeof this.remoteMethod === 'function') {
	        this.hoverIndex = -1;
	        this.remoteMethod(val);
	      } else if (typeof this.filterMethod === 'function') {
	        this.filterMethod(val);
	        this.broadcast('ElOptionGroup', 'queryChange');
	      } else {
	        this.filteredOptionsCount = this.optionsCount;
	        this.broadcast('ElOption', 'queryChange', val);
	        this.broadcast('ElOptionGroup', 'queryChange');
	      }
	      if (this.defaultFirstOption && (this.filterable || this.remote) && this.filteredOptionsCount) {
	        this.checkDefaultFirstOption();
	      }
	    },
	    scrollToOption: function scrollToOption(option) {
	      var target = Array.isArray(option) && option[0] ? option[0].$el : option.$el;
	      if (this.$refs.popper && target) {
	        var menu = this.$refs.popper.$el.querySelector('.el-select-dropdown__wrap');
	        scroll_into_view_default()(menu, target);
	      }
	      this.$refs.scrollbar && this.$refs.scrollbar.handleScroll();
	    },
	    handleMenuEnter: function handleMenuEnter() {
	      var _this7 = this;
	
	      this.$nextTick(function () {
	        return _this7.scrollToOption(_this7.selected);
	      });
	    },
	    emitChange: function emitChange(val) {
	      if (!Object(util_["valueEquals"])(this.value, val)) {
	        this.$emit('change', val);
	      }
	    },
	    getOption: function getOption(value) {
	      var option = void 0;
	      var isObject = Object.prototype.toString.call(value).toLowerCase() === '[object object]';
	      var isNull = Object.prototype.toString.call(value).toLowerCase() === '[object null]';
	      var isUndefined = Object.prototype.toString.call(value).toLowerCase() === '[object undefined]';
	
	      for (var i = this.cachedOptions.length - 1; i >= 0; i--) {
	        var cachedOption = this.cachedOptions[i];
	        var isEqual = isObject ? Object(util_["getValueByPath"])(cachedOption.value, this.valueKey) === Object(util_["getValueByPath"])(value, this.valueKey) : cachedOption.value === value;
	        if (isEqual) {
	          option = cachedOption;
	          break;
	        }
	      }
	      if (option) return option;
	      var label = !isObject && !isNull && !isUndefined ? value : '';
	      var newOption = {
	        value: value,
	        currentLabel: label
	      };
	      if (this.multiple) {
	        newOption.hitState = false;
	      }
	      return newOption;
	    },
	    setSelected: function setSelected() {
	      var _this8 = this;
	
	      if (!this.multiple) {
	        var option = this.getOption(this.value);
	        if (option.created) {
	          this.createdLabel = option.currentLabel;
	          this.createdSelected = true;
	        } else {
	          this.createdSelected = false;
	        }
	        this.selectedLabel = option.currentLabel;
	        this.selected = option;
	        if (this.filterable) this.query = this.selectedLabel;
	        return;
	      }
	      var result = [];
	      if (Array.isArray(this.value)) {
	        this.value.forEach(function (value) {
	          result.push(_this8.getOption(value));
	        });
	      }
	      this.selected = result;
	      this.$nextTick(function () {
	        _this8.resetInputHeight();
	      });
	    },
	    handleFocus: function handleFocus(event) {
	      if (!this.softFocus) {
	        if (this.automaticDropdown || this.filterable) {
	          this.visible = true;
	          if (this.filterable) {
	            this.menuVisibleOnFocus = true;
	          }
	        }
	        this.$emit('focus', event);
	      } else {
	        this.softFocus = false;
	      }
	    },
	    blur: function blur() {
	      this.visible = false;
	      this.$refs.reference.blur();
	    },
	    handleBlur: function handleBlur(event) {
	      var _this9 = this;
	
	      setTimeout(function () {
	        if (_this9.isSilentBlur) {
	          _this9.isSilentBlur = false;
	        } else {
	          _this9.$emit('blur', event);
	        }
	      }, 50);
	      this.softFocus = false;
	    },
	    handleClearClick: function handleClearClick(event) {
	      this.deleteSelected(event);
	    },
	    doDestroy: function doDestroy() {
	      this.$refs.popper && this.$refs.popper.doDestroy();
	    },
	    handleClose: function handleClose() {
	      this.visible = false;
	    },
	    toggleLastOptionHitState: function toggleLastOptionHitState(hit) {
	      if (!Array.isArray(this.selected)) return;
	      var option = this.selected[this.selected.length - 1];
	      if (!option) return;
	
	      if (hit === true || hit === false) {
	        option.hitState = hit;
	        return hit;
	      }
	
	      option.hitState = !option.hitState;
	      return option.hitState;
	    },
	    deletePrevTag: function deletePrevTag(e) {
	      if (e.target.value.length <= 0 && !this.toggleLastOptionHitState()) {
	        var value = this.value.slice();
	        value.pop();
	        this.$emit('input', value);
	        this.emitChange(value);
	      }
	    },
	    managePlaceholder: function managePlaceholder() {
	      if (this.currentPlaceholder !== '') {
	        this.currentPlaceholder = this.$refs.input.value ? '' : this.cachedPlaceHolder;
	      }
	    },
	    resetInputState: function resetInputState(e) {
	      if (e.keyCode !== 8) this.toggleLastOptionHitState(false);
	      this.inputLength = this.$refs.input.value.length * 15 + 20;
	      this.resetInputHeight();
	    },
	    resetInputHeight: function resetInputHeight() {
	      var _this10 = this;
	
	      if (this.collapseTags && !this.filterable) return;
	      this.$nextTick(function () {
	        if (!_this10.$refs.reference) return;
	        var inputChildNodes = _this10.$refs.reference.$el.childNodes;
	        var input = [].filter.call(inputChildNodes, function (item) {
	          return item.tagName === 'INPUT';
	        })[0];
	        var tags = _this10.$refs.tags;
	        var sizeInMap = _this10.initialInputHeight || 40;
	        input.style.height = _this10.selected.length === 0 ? sizeInMap + 'px' : Math.max(tags ? tags.clientHeight + (tags.clientHeight > sizeInMap ? 6 : 0) : 0, sizeInMap) + 'px';
	        if (_this10.visible && _this10.emptyText !== false) {
	          _this10.broadcast('ElSelectDropdown', 'updatePopper');
	        }
	      });
	    },
	    resetHoverIndex: function resetHoverIndex() {
	      var _this11 = this;
	
	      setTimeout(function () {
	        if (!_this11.multiple) {
	          _this11.hoverIndex = _this11.options.indexOf(_this11.selected);
	        } else {
	          if (_this11.selected.length > 0) {
	            _this11.hoverIndex = Math.min.apply(null, _this11.selected.map(function (item) {
	              return _this11.options.indexOf(item);
	            }));
	          } else {
	            _this11.hoverIndex = -1;
	          }
	        }
	      }, 300);
	    },
	    handleOptionSelect: function handleOptionSelect(option, byClick) {
	      var _this12 = this;
	
	      if (this.multiple) {
	        var value = (this.value || []).slice();
	        var optionIndex = this.getValueIndex(value, option.value);
	        if (optionIndex > -1) {
	          value.splice(optionIndex, 1);
	        } else if (this.multipleLimit <= 0 || value.length < this.multipleLimit) {
	          value.push(option.value);
	        }
	        this.$emit('input', value);
	        this.emitChange(value);
	        if (option.created) {
	          this.query = '';
	          this.handleQueryChange('');
	          this.inputLength = 20;
	        }
	        if (this.filterable) this.$refs.input.focus();
	      } else {
	        this.$emit('input', option.value);
	        this.emitChange(option.value);
	        this.visible = false;
	      }
	      this.isSilentBlur = byClick;
	      this.setSoftFocus();
	      if (this.visible) return;
	      this.$nextTick(function () {
	        _this12.scrollToOption(option);
	      });
	    },
	    setSoftFocus: function setSoftFocus() {
	      this.softFocus = true;
	      var input = this.$refs.input || this.$refs.reference;
	      if (input) {
	        input.focus();
	      }
	    },
	    getValueIndex: function getValueIndex() {
	      var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	      var value = arguments[1];
	
	      var isObject = Object.prototype.toString.call(value).toLowerCase() === '[object object]';
	      if (!isObject) {
	        return arr.indexOf(value);
	      } else {
	        var valueKey = this.valueKey;
	        var index = -1;
	        arr.some(function (item, i) {
	          if (Object(util_["getValueByPath"])(item, valueKey) === Object(util_["getValueByPath"])(value, valueKey)) {
	            index = i;
	            return true;
	          }
	          return false;
	        });
	        return index;
	      }
	    },
	    toggleMenu: function toggleMenu() {
	      if (!this.selectDisabled) {
	        if (this.menuVisibleOnFocus) {
	          this.menuVisibleOnFocus = false;
	        } else {
	          this.visible = !this.visible;
	        }
	        if (this.visible) {
	          (this.$refs.input || this.$refs.reference).focus();
	        }
	      }
	    },
	    selectOption: function selectOption() {
	      if (!this.visible) {
	        this.toggleMenu();
	      } else {
	        if (this.options[this.hoverIndex]) {
	          this.handleOptionSelect(this.options[this.hoverIndex]);
	        }
	      }
	    },
	    deleteSelected: function deleteSelected(event) {
	      event.stopPropagation();
	      var value = this.multiple ? [] : '';
	      this.$emit('input', value);
	      this.emitChange(value);
	      this.visible = false;
	      this.$emit('clear');
	    },
	    deleteTag: function deleteTag(event, tag) {
	      var index = this.selected.indexOf(tag);
	      if (index > -1 && !this.selectDisabled) {
	        var value = this.value.slice();
	        value.splice(index, 1);
	        this.$emit('input', value);
	        this.emitChange(value);
	        this.$emit('remove-tag', tag.value);
	      }
	      event.stopPropagation();
	    },
	    onInputChange: function onInputChange() {
	      if (this.filterable && this.query !== this.selectedLabel) {
	        this.query = this.selectedLabel;
	        this.handleQueryChange(this.query);
	      }
	    },
	    onOptionDestroy: function onOptionDestroy(index) {
	      if (index > -1) {
	        this.optionsCount--;
	        this.filteredOptionsCount--;
	        this.options.splice(index, 1);
	      }
	    },
	    resetInputWidth: function resetInputWidth() {
	      this.inputWidth = this.$refs.reference.$el.getBoundingClientRect().width;
	    },
	    handleResize: function handleResize() {
	      this.resetInputWidth();
	      if (this.multiple) this.resetInputHeight();
	    },
	    checkDefaultFirstOption: function checkDefaultFirstOption() {
	      this.hoverIndex = -1;
	      // highlight the created option
	      var hasCreated = false;
	      for (var i = this.options.length - 1; i >= 0; i--) {
	        if (this.options[i].created) {
	          hasCreated = true;
	          this.hoverIndex = i;
	          break;
	        }
	      }
	      if (hasCreated) return;
	      for (var _i = 0; _i !== this.options.length; ++_i) {
	        var option = this.options[_i];
	        if (this.query) {
	          // highlight first options that passes the filter
	          if (!option.disabled && !option.groupDisabled && option.visible) {
	            this.hoverIndex = _i;
	            break;
	          }
	        } else {
	          // highlight currently selected option
	          if (option.itemSelected) {
	            this.hoverIndex = _i;
	            break;
	          }
	        }
	      }
	    },
	    getValueKey: function getValueKey(item) {
	      if (Object.prototype.toString.call(item.value).toLowerCase() !== '[object object]') {
	        return item.value;
	      } else {
	        return Object(util_["getValueByPath"])(item.value, this.valueKey);
	      }
	    }
	  },
	
	  created: function created() {
	    var _this13 = this;
	
	    this.cachedPlaceHolder = this.currentPlaceholder = this.placeholder;
	    if (this.multiple && !Array.isArray(this.value)) {
	      this.$emit('input', []);
	    }
	    if (!this.multiple && Array.isArray(this.value)) {
	      this.$emit('input', '');
	    }
	
	    this.debouncedOnInputChange = debounce_default()(this.debounce, function () {
	      _this13.onInputChange();
	    });
	
	    this.debouncedQueryChange = debounce_default()(this.debounce, function (e) {
	      _this13.handleQueryChange(e.target.value);
	    });
	
	    this.$on('handleOptionClick', this.handleOptionSelect);
	    this.$on('setSelected', this.setSelected);
	  },
	  mounted: function mounted() {
	    var _this14 = this;
	
	    if (this.multiple && Array.isArray(this.value) && this.value.length > 0) {
	      this.currentPlaceholder = '';
	    }
	    Object(resize_event_["addResizeListener"])(this.$el, this.handleResize);
	
	    var reference = this.$refs.reference;
	    if (reference && reference.$el) {
	      var sizeMap = {
	        medium: 36,
	        small: 32,
	        mini: 28
	      };
	      var input = reference.$el.querySelector('input');
	      this.initialInputHeight = input.getBoundingClientRect().height || sizeMap[this.selectSize];
	    }
	    if (this.remote && this.multiple) {
	      this.resetInputHeight();
	    }
	    this.$nextTick(function () {
	      if (reference && reference.$el) {
	        _this14.inputWidth = reference.$el.getBoundingClientRect().width;
	      }
	    });
	    this.setSelected();
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this.$el && this.handleResize) Object(resize_event_["removeResizeListener"])(this.$el, this.handleResize);
	  }
	});
	// CONCATENATED MODULE: ./packages/select/src/select.vue?vue&type=script&lang=js&
	 /* harmony default export */ var src_selectvue_type_script_lang_js_ = (selectvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./packages/select/src/select.vue
	
	
	
	
	
	/* normalize component */
	
	var select_component = Object(componentNormalizer["a" /* default */])(
	  src_selectvue_type_script_lang_js_,
	  render,
	  staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	/* hot reload */
	if (false) { var select_api; }
	select_component.options.__file = "packages/select/src/select.vue"
	/* harmony default export */ var src_select = (select_component.exports);
	// CONCATENATED MODULE: ./packages/select/index.js
	
	
	/* istanbul ignore next */
	src_select.install = function (Vue) {
	  Vue.component(src_select.name, src_select);
	};
	
	/* harmony default export */ var packages_select = __webpack_exports__["default"] = (src_select);
	
	/***/ })
	/******/ ]);

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 131);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 131:
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/vue-popper"
	var vue_popper_ = __webpack_require__(5);
	var vue_popper_default = /*#__PURE__*/__webpack_require__.n(vue_popper_);
	
	// EXTERNAL MODULE: external "throttle-debounce/debounce"
	var debounce_ = __webpack_require__(17);
	var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce_);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/dom"
	var dom_ = __webpack_require__(2);
	
	// EXTERNAL MODULE: external "element-ui/lib/utils/util"
	var util_ = __webpack_require__(3);
	
	// EXTERNAL MODULE: external "vue"
	var external_vue_ = __webpack_require__(7);
	var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);
	
	// CONCATENATED MODULE: ./packages/tooltip/src/main.js
	
	
	
	
	
	
	/* harmony default export */ var main = ({
	  name: 'ElTooltip',
	
	  mixins: [vue_popper_default.a],
	
	  props: {
	    openDelay: {
	      type: Number,
	      default: 0
	    },
	    disabled: Boolean,
	    manual: Boolean,
	    effect: {
	      type: String,
	      default: 'dark'
	    },
	    arrowOffset: {
	      type: Number,
	      default: 0
	    },
	    popperClass: String,
	    content: String,
	    visibleArrow: {
	      default: true
	    },
	    transition: {
	      type: String,
	      default: 'el-fade-in-linear'
	    },
	    popperOptions: {
	      default: function _default() {
	        return {
	          boundariesPadding: 10,
	          gpuAcceleration: false
	        };
	      }
	    },
	    enterable: {
	      type: Boolean,
	      default: true
	    },
	    hideAfter: {
	      type: Number,
	      default: 0
	    },
	    tabindex: {
	      type: Number,
	      default: 0
	    }
	  },
	
	  data: function data() {
	    return {
	      tooltipId: 'el-tooltip-' + Object(util_["generateId"])(),
	      timeoutPending: null,
	      focusing: false
	    };
	  },
	  beforeCreate: function beforeCreate() {
	    var _this = this;
	
	    if (this.$isServer) return;
	
	    this.popperVM = new external_vue_default.a({
	      data: { node: '' },
	      render: function render(h) {
	        return this.node;
	      }
	    }).$mount();
	
	    this.debounceClose = debounce_default()(200, function () {
	      return _this.handleClosePopper();
	    });
	  },
	  render: function render(h) {
	    var _this2 = this;
	
	    if (this.popperVM) {
	      this.popperVM.node = h(
	        'transition',
	        {
	          attrs: {
	            name: this.transition
	          },
	          on: {
	            'afterLeave': this.doDestroy
	          }
	        },
	        [h(
	          'div',
	          {
	            on: {
	              'mouseleave': function mouseleave() {
	                _this2.setExpectedState(false);_this2.debounceClose();
	              },
	              'mouseenter': function mouseenter() {
	                _this2.setExpectedState(true);
	              }
	            },
	
	            ref: 'popper',
	            attrs: { role: 'tooltip',
	              id: this.tooltipId,
	              'aria-hidden': this.disabled || !this.showPopper ? 'true' : 'false'
	            },
	            directives: [{
	              name: 'show',
	              value: !this.disabled && this.showPopper
	            }],
	
	            'class': ['el-tooltip__popper', 'is-' + this.effect, this.popperClass] },
	          [this.$slots.content || this.content]
	        )]
	      );
	    }
	
	    var firstElement = this.getFirstElement();
	    if (!firstElement) return null;
	
	    var data = firstElement.data = firstElement.data || {};
	    data.staticClass = this.addTooltipClass(data.staticClass);
	
	    return firstElement;
	  },
	  mounted: function mounted() {
	    var _this3 = this;
	
	    this.referenceElm = this.$el;
	    if (this.$el.nodeType === 1) {
	      this.$el.setAttribute('aria-describedby', this.tooltipId);
	      this.$el.setAttribute('tabindex', this.tabindex);
	      Object(dom_["on"])(this.referenceElm, 'mouseenter', this.show);
	      Object(dom_["on"])(this.referenceElm, 'mouseleave', this.hide);
	      Object(dom_["on"])(this.referenceElm, 'focus', function () {
	        if (!_this3.$slots.default || !_this3.$slots.default.length) {
	          _this3.handleFocus();
	          return;
	        }
	        var instance = _this3.$slots.default[0].componentInstance;
	        if (instance && instance.focus) {
	          instance.focus();
	        } else {
	          _this3.handleFocus();
	        }
	      });
	      Object(dom_["on"])(this.referenceElm, 'blur', this.handleBlur);
	      Object(dom_["on"])(this.referenceElm, 'click', this.removeFocusing);
	    }
	    // fix issue https://github.com/ElemeFE/element/issues/14424
	    if (this.value && this.popperVM) {
	      this.popperVM.$nextTick(function () {
	        if (_this3.value) {
	          _this3.updatePopper();
	        }
	      });
	    }
	  },
	
	  watch: {
	    focusing: function focusing(val) {
	      if (val) {
	        Object(dom_["addClass"])(this.referenceElm, 'focusing');
	      } else {
	        Object(dom_["removeClass"])(this.referenceElm, 'focusing');
	      }
	    }
	  },
	  methods: {
	    show: function show() {
	      this.setExpectedState(true);
	      this.handleShowPopper();
	    },
	    hide: function hide() {
	      this.setExpectedState(false);
	      this.debounceClose();
	    },
	    handleFocus: function handleFocus() {
	      this.focusing = true;
	      this.show();
	    },
	    handleBlur: function handleBlur() {
	      this.focusing = false;
	      this.hide();
	    },
	    removeFocusing: function removeFocusing() {
	      this.focusing = false;
	    },
	    addTooltipClass: function addTooltipClass(prev) {
	      if (!prev) {
	        return 'el-tooltip';
	      } else {
	        return 'el-tooltip ' + prev.replace('el-tooltip', '');
	      }
	    },
	    handleShowPopper: function handleShowPopper() {
	      var _this4 = this;
	
	      if (!this.expectedState || this.manual) return;
	      clearTimeout(this.timeout);
	      this.timeout = setTimeout(function () {
	        _this4.showPopper = true;
	      }, this.openDelay);
	
	      if (this.hideAfter > 0) {
	        this.timeoutPending = setTimeout(function () {
	          _this4.showPopper = false;
	        }, this.hideAfter);
	      }
	    },
	    handleClosePopper: function handleClosePopper() {
	      if (this.enterable && this.expectedState || this.manual) return;
	      clearTimeout(this.timeout);
	
	      if (this.timeoutPending) {
	        clearTimeout(this.timeoutPending);
	      }
	      this.showPopper = false;
	
	      if (this.disabled) {
	        this.doDestroy();
	      }
	    },
	    setExpectedState: function setExpectedState(expectedState) {
	      if (expectedState === false) {
	        clearTimeout(this.timeoutPending);
	      }
	      this.expectedState = expectedState;
	    },
	    getFirstElement: function getFirstElement() {
	      var slots = this.$slots.default;
	      if (!Array.isArray(slots)) return null;
	      var element = null;
	      for (var index = 0; index < slots.length; index++) {
	        if (slots[index] && slots[index].tag) {
	          element = slots[index];
	        };
	      }
	      return element;
	    }
	  },
	
	  beforeDestroy: function beforeDestroy() {
	    this.popperVM && this.popperVM.$destroy();
	  },
	  destroyed: function destroyed() {
	    var reference = this.referenceElm;
	    if (reference.nodeType === 1) {
	      Object(dom_["off"])(reference, 'mouseenter', this.show);
	      Object(dom_["off"])(reference, 'mouseleave', this.hide);
	      Object(dom_["off"])(reference, 'focus', this.handleFocus);
	      Object(dom_["off"])(reference, 'blur', this.handleBlur);
	      Object(dom_["off"])(reference, 'click', this.removeFocusing);
	    }
	  }
	});
	// CONCATENATED MODULE: ./packages/tooltip/index.js
	
	
	/* istanbul ignore next */
	main.install = function (Vue) {
	  Vue.component(main.name, main);
	};
	
	/* harmony default export */ var tooltip = __webpack_exports__["default"] = (main);
	
	/***/ }),
	
	/***/ 17:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(94);
	
	/***/ }),
	
	/***/ 2:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(42);
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(38);
	
	/***/ }),
	
	/***/ 5:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(93);
	
	/***/ }),
	
	/***/ 7:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(20);
	
	/***/ })
	
	/******/ });

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _dom = __webpack_require__(42);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Transition = function () {
	  function Transition() {
	    _classCallCheck(this, Transition);
	  }
	
	  Transition.prototype.beforeEnter = function beforeEnter(el) {
	    (0, _dom.addClass)(el, 'collapse-transition');
	    if (!el.dataset) el.dataset = {};
	
	    el.dataset.oldPaddingTop = el.style.paddingTop;
	    el.dataset.oldPaddingBottom = el.style.paddingBottom;
	
	    el.style.height = '0';
	    el.style.paddingTop = 0;
	    el.style.paddingBottom = 0;
	  };
	
	  Transition.prototype.enter = function enter(el) {
	    el.dataset.oldOverflow = el.style.overflow;
	    if (el.scrollHeight !== 0) {
	      el.style.height = el.scrollHeight + 'px';
	      el.style.paddingTop = el.dataset.oldPaddingTop;
	      el.style.paddingBottom = el.dataset.oldPaddingBottom;
	    } else {
	      el.style.height = '';
	      el.style.paddingTop = el.dataset.oldPaddingTop;
	      el.style.paddingBottom = el.dataset.oldPaddingBottom;
	    }
	
	    el.style.overflow = 'hidden';
	  };
	
	  Transition.prototype.afterEnter = function afterEnter(el) {
	    // for safari: remove class then reset height is necessary
	    (0, _dom.removeClass)(el, 'collapse-transition');
	    el.style.height = '';
	    el.style.overflow = el.dataset.oldOverflow;
	  };
	
	  Transition.prototype.beforeLeave = function beforeLeave(el) {
	    if (!el.dataset) el.dataset = {};
	    el.dataset.oldPaddingTop = el.style.paddingTop;
	    el.dataset.oldPaddingBottom = el.style.paddingBottom;
	    el.dataset.oldOverflow = el.style.overflow;
	
	    el.style.height = el.scrollHeight + 'px';
	    el.style.overflow = 'hidden';
	  };
	
	  Transition.prototype.leave = function leave(el) {
	    if (el.scrollHeight !== 0) {
	      // for safari: add class after set height, or it will jump to zero height suddenly, weired
	      (0, _dom.addClass)(el, 'collapse-transition');
	      el.style.height = 0;
	      el.style.paddingTop = 0;
	      el.style.paddingBottom = 0;
	    }
	  };
	
	  Transition.prototype.afterLeave = function afterLeave(el) {
	    (0, _dom.removeClass)(el, 'collapse-transition');
	    el.style.height = '';
	    el.style.overflow = el.dataset.oldOverflow;
	    el.style.paddingTop = el.dataset.oldPaddingTop;
	    el.style.paddingBottom = el.dataset.oldPaddingBottom;
	  };
	
	  return Transition;
	}();
	
	exports.default = {
	  name: 'ElCollapseTransition',
	  functional: true,
	  render: function render(h, _ref) {
	    var children = _ref.children;
	
	    var data = {
	      on: new Transition()
	    };
	
	    return h('transition', data, children);
	  }
	};

/***/ }),
/* 396 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (instance, callback) {
	  var speed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
	  var once = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	  if (!instance || !callback) throw new Error('instance & callback is required');
	  var called = false;
	  var afterLeaveCallback = function afterLeaveCallback() {
	    if (called) return;
	    called = true;
	    if (callback) {
	      callback.apply(null, arguments);
	    }
	  };
	  if (once) {
	    instance.$once('after-leave', afterLeaveCallback);
	  } else {
	    instance.$on('after-leave', afterLeaveCallback);
	  }
	  setTimeout(function () {
	    afterLeaveCallback();
	  }, speed + 100);
	};
	
	; /**
	   * Bind after-leave event for vue instance. Make sure after-leave is called in any browsers.
	   *
	   * @param {Vue} instance Vue instance.
	   * @param {Function} callback callback of after-leave event
	   * @param {Number} speed the speed of transition, default value is 300ms
	   * @param {Boolean} once weather bind after-leave once. default value is false.
	   */

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _ariaUtils = __webpack_require__(129);
	
	var _ariaUtils2 = _interopRequireDefault(_ariaUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @constructor
	 * @desc Dialog object providing modal focus management.
	 *
	 * Assumptions: The element serving as the dialog container is present in the
	 * DOM and hidden. The dialog container has role='dialog'.
	 *
	 * @param dialogId
	 *          The ID of the element serving as the dialog container.
	 * @param focusAfterClosed
	 *          Either the DOM node or the ID of the DOM node to focus when the
	 *          dialog closes.
	 * @param focusFirst
	 *          Optional parameter containing either the DOM node or the ID of the
	 *          DOM node to focus when the dialog opens. If not specified, the
	 *          first focusable element in the dialog will receive focus.
	 */
	var aria = aria || {};
	var tabEvent;
	
	aria.Dialog = function (dialog, focusAfterClosed, focusFirst) {
	  var _this = this;
	
	  this.dialogNode = dialog;
	  if (this.dialogNode === null || this.dialogNode.getAttribute('role') !== 'dialog') {
	    throw new Error('Dialog() requires a DOM element with ARIA role of dialog.');
	  }
	
	  if (typeof focusAfterClosed === 'string') {
	    this.focusAfterClosed = document.getElementById(focusAfterClosed);
	  } else if ((typeof focusAfterClosed === 'undefined' ? 'undefined' : _typeof(focusAfterClosed)) === 'object') {
	    this.focusAfterClosed = focusAfterClosed;
	  } else {
	    this.focusAfterClosed = null;
	  }
	
	  if (typeof focusFirst === 'string') {
	    this.focusFirst = document.getElementById(focusFirst);
	  } else if ((typeof focusFirst === 'undefined' ? 'undefined' : _typeof(focusFirst)) === 'object') {
	    this.focusFirst = focusFirst;
	  } else {
	    this.focusFirst = null;
	  }
	
	  if (this.focusFirst) {
	    this.focusFirst.focus();
	  } else {
	    _ariaUtils2.default.focusFirstDescendant(this.dialogNode);
	  }
	
	  this.lastFocus = document.activeElement;
	  tabEvent = function tabEvent(e) {
	    _this.trapFocus(e);
	  };
	  this.addListeners();
	};
	
	aria.Dialog.prototype.addListeners = function () {
	  document.addEventListener('focus', tabEvent, true);
	};
	
	aria.Dialog.prototype.removeListeners = function () {
	  document.removeEventListener('focus', tabEvent, true);
	};
	
	aria.Dialog.prototype.closeDialog = function () {
	  var _this2 = this;
	
	  this.removeListeners();
	  if (this.focusAfterClosed) {
	    setTimeout(function () {
	      _this2.focusAfterClosed.focus();
	    });
	  }
	};
	
	aria.Dialog.prototype.trapFocus = function (event) {
	  if (_ariaUtils2.default.IgnoreUtilFocusChanges) {
	    return;
	  }
	  if (this.dialogNode.contains(event.target)) {
	    this.lastFocus = event.target;
	  } else {
	    _ariaUtils2.default.focusFirstDescendant(this.dialogNode);
	    if (this.lastFocus === document.activeElement) {
	      _ariaUtils2.default.focusLastDescendant(this.dialogNode);
	    }
	    this.lastFocus = document.activeElement;
	  }
	};
	
	exports.default = aria.Dialog;

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.validateRangeInOneMonth = exports.extractTimeFormat = exports.extractDateFormat = exports.nextYear = exports.prevYear = exports.nextMonth = exports.prevMonth = exports.changeYearMonthAndClampDate = exports.timeWithinRange = exports.limitTimeRange = exports.clearMilliseconds = exports.clearTime = exports.modifyWithTimeString = exports.modifyTime = exports.modifyDate = exports.range = exports.getRangeMinutes = exports.getMonthDays = exports.getPrevMonthLastDays = exports.getRangeHours = exports.getWeekNumber = exports.getStartDateOfMonth = exports.nextDate = exports.prevDate = exports.getFirstDayOfMonth = exports.getDayCountOfYear = exports.getDayCountOfMonth = exports.parseDate = exports.formatDate = exports.isDateObject = exports.isDate = exports.toDate = exports.getI18nSettings = undefined;
	
	var _date = __webpack_require__(179);
	
	var _date2 = _interopRequireDefault(_date);
	
	var _locale = __webpack_require__(90);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var weeks = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
	var months = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
	
	var newArray = function newArray(start, end) {
	  var result = [];
	  for (var i = start; i <= end; i++) {
	    result.push(i);
	  }
	  return result;
	};
	
	var getI18nSettings = exports.getI18nSettings = function getI18nSettings() {
	  return {
	    dayNamesShort: weeks.map(function (week) {
	      return (0, _locale.t)('el.datepicker.weeks.' + week);
	    }),
	    dayNames: weeks.map(function (week) {
	      return (0, _locale.t)('el.datepicker.weeks.' + week);
	    }),
	    monthNamesShort: months.map(function (month) {
	      return (0, _locale.t)('el.datepicker.months.' + month);
	    }),
	    monthNames: months.map(function (month, index) {
	      return (0, _locale.t)('el.datepicker.month' + (index + 1));
	    }),
	    amPm: ['am', 'pm']
	  };
	};
	
	var toDate = exports.toDate = function toDate(date) {
	  return isDate(date) ? new Date(date) : null;
	};
	
	var isDate = exports.isDate = function isDate(date) {
	  if (date === null || date === undefined) return false;
	  if (isNaN(new Date(date).getTime())) return false;
	  if (Array.isArray(date)) return false; // deal with `new Date([ new Date() ]) -> new Date()`
	  return true;
	};
	
	var isDateObject = exports.isDateObject = function isDateObject(val) {
	  return val instanceof Date;
	};
	
	var formatDate = exports.formatDate = function formatDate(date, format) {
	  date = toDate(date);
	  if (!date) return '';
	  return _date2.default.format(date, format || 'yyyy-MM-dd', getI18nSettings());
	};
	
	var parseDate = exports.parseDate = function parseDate(string, format) {
	  return _date2.default.parse(string, format || 'yyyy-MM-dd', getI18nSettings());
	};
	
	var getDayCountOfMonth = exports.getDayCountOfMonth = function getDayCountOfMonth(year, month) {
	  if (month === 3 || month === 5 || month === 8 || month === 10) {
	    return 30;
	  }
	
	  if (month === 1) {
	    if (year % 4 === 0 && year % 100 !== 0 || year % 400 === 0) {
	      return 29;
	    } else {
	      return 28;
	    }
	  }
	
	  return 31;
	};
	
	var getDayCountOfYear = exports.getDayCountOfYear = function getDayCountOfYear(year) {
	  var isLeapYear = year % 400 === 0 || year % 100 !== 0 && year % 4 === 0;
	  return isLeapYear ? 366 : 365;
	};
	
	var getFirstDayOfMonth = exports.getFirstDayOfMonth = function getFirstDayOfMonth(date) {
	  var temp = new Date(date.getTime());
	  temp.setDate(1);
	  return temp.getDay();
	};
	
	// see: https://stackoverflow.com/questions/3674539/incrementing-a-date-in-javascript
	// {prev, next} Date should work for Daylight Saving Time
	// Adding 24 * 60 * 60 * 1000 does not work in the above scenario
	var prevDate = exports.prevDate = function prevDate(date) {
	  var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	
	  return new Date(date.getFullYear(), date.getMonth(), date.getDate() - amount);
	};
	
	var nextDate = exports.nextDate = function nextDate(date) {
	  var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	
	  return new Date(date.getFullYear(), date.getMonth(), date.getDate() + amount);
	};
	
	var getStartDateOfMonth = exports.getStartDateOfMonth = function getStartDateOfMonth(year, month) {
	  var result = new Date(year, month, 1);
	  var day = result.getDay();
	
	  if (day === 0) {
	    return prevDate(result, 7);
	  } else {
	    return prevDate(result, day);
	  }
	};
	
	var getWeekNumber = exports.getWeekNumber = function getWeekNumber(src) {
	  if (!isDate(src)) return null;
	  var date = new Date(src.getTime());
	  date.setHours(0, 0, 0, 0);
	  // Thursday in current week decides the year.
	  date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
	  // January 4 is always in week 1.
	  var week1 = new Date(date.getFullYear(), 0, 4);
	  // Adjust to Thursday in week 1 and count number of weeks from date to week 1.
	  // Rounding should be fine for Daylight Saving Time. Its shift should never be more than 12 hours.
	  return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
	};
	
	var getRangeHours = exports.getRangeHours = function getRangeHours(ranges) {
	  var hours = [];
	  var disabledHours = [];
	
	  (ranges || []).forEach(function (range) {
	    var value = range.map(function (date) {
	      return date.getHours();
	    });
	
	    disabledHours = disabledHours.concat(newArray(value[0], value[1]));
	  });
	
	  if (disabledHours.length) {
	    for (var i = 0; i < 24; i++) {
	      hours[i] = disabledHours.indexOf(i) === -1;
	    }
	  } else {
	    for (var _i = 0; _i < 24; _i++) {
	      hours[_i] = false;
	    }
	  }
	
	  return hours;
	};
	
	var getPrevMonthLastDays = exports.getPrevMonthLastDays = function getPrevMonthLastDays(date, amount) {
	  if (amount <= 0) return [];
	  var temp = new Date(date.getTime());
	  temp.setDate(0);
	  var lastDay = temp.getDate();
	  return range(amount).map(function (_, index) {
	    return lastDay - (amount - index - 1);
	  });
	};
	
	var getMonthDays = exports.getMonthDays = function getMonthDays(date) {
	  var temp = new Date(date.getFullYear(), date.getMonth() + 1, 0);
	  var days = temp.getDate();
	  return range(days).map(function (_, index) {
	    return index + 1;
	  });
	};
	
	function setRangeData(arr, start, end, value) {
	  for (var i = start; i < end; i++) {
	    arr[i] = value;
	  }
	}
	
	var getRangeMinutes = exports.getRangeMinutes = function getRangeMinutes(ranges, hour) {
	  var minutes = new Array(60);
	
	  if (ranges.length > 0) {
	    ranges.forEach(function (range) {
	      var start = range[0];
	      var end = range[1];
	      var startHour = start.getHours();
	      var startMinute = start.getMinutes();
	      var endHour = end.getHours();
	      var endMinute = end.getMinutes();
	      if (startHour === hour && endHour !== hour) {
	        setRangeData(minutes, startMinute, 60, true);
	      } else if (startHour === hour && endHour === hour) {
	        setRangeData(minutes, startMinute, endMinute + 1, true);
	      } else if (startHour !== hour && endHour === hour) {
	        setRangeData(minutes, 0, endMinute + 1, true);
	      } else if (startHour < hour && endHour > hour) {
	        setRangeData(minutes, 0, 60, true);
	      }
	    });
	  } else {
	    setRangeData(minutes, 0, 60, true);
	  }
	  return minutes;
	};
	
	var range = exports.range = function range(n) {
	  // see https://stackoverflow.com/questions/3746725/create-a-javascript-array-containing-1-n
	  return Array.apply(null, { length: n }).map(function (_, n) {
	    return n;
	  });
	};
	
	var modifyDate = exports.modifyDate = function modifyDate(date, y, m, d) {
	  return new Date(y, m, d, date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
	};
	
	var modifyTime = exports.modifyTime = function modifyTime(date, h, m, s) {
	  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), h, m, s, date.getMilliseconds());
	};
	
	var modifyWithTimeString = exports.modifyWithTimeString = function modifyWithTimeString(date, time) {
	  if (date == null || !time) {
	    return date;
	  }
	  time = parseDate(time, 'HH:mm:ss');
	  return modifyTime(date, time.getHours(), time.getMinutes(), time.getSeconds());
	};
	
	var clearTime = exports.clearTime = function clearTime(date) {
	  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
	};
	
	var clearMilliseconds = exports.clearMilliseconds = function clearMilliseconds(date) {
	  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), 0);
	};
	
	var limitTimeRange = exports.limitTimeRange = function limitTimeRange(date, ranges) {
	  var format = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'HH:mm:ss';
	
	  // TODO: refactory a more elegant solution
	  if (ranges.length === 0) return date;
	  var normalizeDate = function normalizeDate(date) {
	    return _date2.default.parse(_date2.default.format(date, format), format);
	  };
	  var ndate = normalizeDate(date);
	  var nranges = ranges.map(function (range) {
	    return range.map(normalizeDate);
	  });
	  if (nranges.some(function (nrange) {
	    return ndate >= nrange[0] && ndate <= nrange[1];
	  })) return date;
	
	  var minDate = nranges[0][0];
	  var maxDate = nranges[0][0];
	
	  nranges.forEach(function (nrange) {
	    minDate = new Date(Math.min(nrange[0], minDate));
	    maxDate = new Date(Math.max(nrange[1], minDate));
	  });
	
	  var ret = ndate < minDate ? minDate : maxDate;
	  // preserve Year/Month/Date
	  return modifyDate(ret, date.getFullYear(), date.getMonth(), date.getDate());
	};
	
	var timeWithinRange = exports.timeWithinRange = function timeWithinRange(date, selectableRange, format) {
	  var limitedDate = limitTimeRange(date, selectableRange, format);
	  return limitedDate.getTime() === date.getTime();
	};
	
	var changeYearMonthAndClampDate = exports.changeYearMonthAndClampDate = function changeYearMonthAndClampDate(date, year, month) {
	  // clamp date to the number of days in `year`, `month`
	  // eg: (2010-1-31, 2010, 2) => 2010-2-28
	  var monthDate = Math.min(date.getDate(), getDayCountOfMonth(year, month));
	  return modifyDate(date, year, month, monthDate);
	};
	
	var prevMonth = exports.prevMonth = function prevMonth(date) {
	  var year = date.getFullYear();
	  var month = date.getMonth();
	  return month === 0 ? changeYearMonthAndClampDate(date, year - 1, 11) : changeYearMonthAndClampDate(date, year, month - 1);
	};
	
	var nextMonth = exports.nextMonth = function nextMonth(date) {
	  var year = date.getFullYear();
	  var month = date.getMonth();
	  return month === 11 ? changeYearMonthAndClampDate(date, year + 1, 0) : changeYearMonthAndClampDate(date, year, month + 1);
	};
	
	var prevYear = exports.prevYear = function prevYear(date) {
	  var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	
	  var year = date.getFullYear();
	  var month = date.getMonth();
	  return changeYearMonthAndClampDate(date, year - amount, month);
	};
	
	var nextYear = exports.nextYear = function nextYear(date) {
	  var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	
	  var year = date.getFullYear();
	  var month = date.getMonth();
	  return changeYearMonthAndClampDate(date, year + amount, month);
	};
	
	var extractDateFormat = exports.extractDateFormat = function extractDateFormat(format) {
	  return format.replace(/\W?m{1,2}|\W?ZZ/g, '').replace(/\W?h{1,2}|\W?s{1,3}|\W?a/gi, '').trim();
	};
	
	var extractTimeFormat = exports.extractTimeFormat = function extractTimeFormat(format) {
	  return format.replace(/\W?D{1,2}|\W?Do|\W?d{1,4}|\W?M{1,4}|\W?y{2,4}/g, '').trim();
	};
	
	var validateRangeInOneMonth = exports.validateRangeInOneMonth = function validateRangeInOneMonth(start, end) {
	  return start.getMonth() === end.getMonth() && start.getFullYear() === end.getFullYear();
	};

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * @fileOverview Kickass library to create and place poppers near their reference elements.
	 * @version {{version}}
	 * @license
	 * Copyright (c) 2016 Federico Zivolo and contributors
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all
	 * copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	 * SOFTWARE.
	 */
	
	//
	// Cross module loader
	// Supported: Node, AMD, Browser globals
	//
	;(function (root, factory) {
	    if (true) {
	        // AMD. Register as an anonymous module.
	        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if ((typeof module === 'undefined' ? 'undefined' : _typeof(module)) === 'object' && module.exports) {
	        // Node. Does not work with strict CommonJS, but
	        // only CommonJS-like environments that support module.exports,
	        // like Node.
	        module.exports = factory();
	    } else {
	        // Browser globals (root is window)
	        root.Popper = factory();
	    }
	})(undefined, function () {
	
	    'use strict';
	
	    var root = window;
	
	    // default options
	    var DEFAULTS = {
	        // placement of the popper
	        placement: 'bottom',
	
	        gpuAcceleration: true,
	
	        // shift popper from its origin by the given amount of pixels (can be negative)
	        offset: 0,
	
	        // the element which will act as boundary of the popper
	        boundariesElement: 'viewport',
	
	        // amount of pixel used to define a minimum distance between the boundaries and the popper
	        boundariesPadding: 5,
	
	        // popper will try to prevent overflow following this order,
	        // by default, then, it could overflow on the left and on top of the boundariesElement
	        preventOverflowOrder: ['left', 'right', 'top', 'bottom'],
	
	        // the behavior used by flip to change the placement of the popper
	        flipBehavior: 'flip',
	
	        arrowElement: '[x-arrow]',
	
	        arrowOffset: 0,
	
	        // list of functions used to modify the offsets before they are applied to the popper
	        modifiers: ['shift', 'offset', 'preventOverflow', 'keepTogether', 'arrow', 'flip', 'applyStyle'],
	
	        modifiersIgnored: [],
	
	        forceAbsolute: false
	    };
	
	    /**
	     * Create a new Popper.js instance
	     * @constructor Popper
	     * @param {HTMLElement} reference - The reference element used to position the popper
	     * @param {HTMLElement|Object} popper
	     *      The HTML element used as popper, or a configuration used to generate the popper.
	     * @param {String} [popper.tagName='div'] The tag name of the generated popper.
	     * @param {Array} [popper.classNames=['popper']] Array of classes to apply to the generated popper.
	     * @param {Array} [popper.attributes] Array of attributes to apply, specify `attr:value` to assign a value to it.
	     * @param {HTMLElement|String} [popper.parent=window.document.body] The parent element, given as HTMLElement or as query string.
	     * @param {String} [popper.content=''] The content of the popper, it can be text, html, or node; if it is not text, set `contentType` to `html` or `node`.
	     * @param {String} [popper.contentType='text'] If `html`, the `content` will be parsed as HTML. If `node`, it will be appended as-is.
	     * @param {String} [popper.arrowTagName='div'] Same as `popper.tagName` but for the arrow element.
	     * @param {Array} [popper.arrowClassNames='popper__arrow'] Same as `popper.classNames` but for the arrow element.
	     * @param {String} [popper.arrowAttributes=['x-arrow']] Same as `popper.attributes` but for the arrow element.
	     * @param {Object} options
	     * @param {String} [options.placement=bottom]
	     *      Placement of the popper accepted values: `top(-start, -end), right(-start, -end), bottom(-start, -right),
	     *      left(-start, -end)`
	     *
	     * @param {HTMLElement|String} [options.arrowElement='[x-arrow]']
	     *      The DOM Node used as arrow for the popper, or a CSS selector used to get the DOM node. It must be child of
	     *      its parent Popper. Popper.js will apply to the given element the style required to align the arrow with its
	     *      reference element.
	     *      By default, it will look for a child node of the popper with the `x-arrow` attribute.
	     *
	     * @param {Boolean} [options.gpuAcceleration=true]
	     *      When this property is set to true, the popper position will be applied using CSS3 translate3d, allowing the
	     *      browser to use the GPU to accelerate the rendering.
	     *      If set to false, the popper will be placed using `top` and `left` properties, not using the GPU.
	     *
	     * @param {Number} [options.offset=0]
	     *      Amount of pixels the popper will be shifted (can be negative).
	     *
	     * @param {String|Element} [options.boundariesElement='viewport']
	     *      The element which will define the boundaries of the popper position, the popper will never be placed outside
	     *      of the defined boundaries (except if `keepTogether` is enabled)
	     *
	     * @param {Number} [options.boundariesPadding=5]
	     *      Additional padding for the boundaries
	     *
	     * @param {Array} [options.preventOverflowOrder=['left', 'right', 'top', 'bottom']]
	     *      Order used when Popper.js tries to avoid overflows from the boundaries, they will be checked in order,
	     *      this means that the last ones will never overflow
	     *
	     * @param {String|Array} [options.flipBehavior='flip']
	     *      The behavior used by the `flip` modifier to change the placement of the popper when the latter is trying to
	     *      overlap its reference element. Defining `flip` as value, the placement will be flipped on
	     *      its axis (`right - left`, `top - bottom`).
	     *      You can even pass an array of placements (eg: `['right', 'left', 'top']` ) to manually specify
	     *      how alter the placement when a flip is needed. (eg. in the above example, it would first flip from right to left,
	     *      then, if even in its new placement, the popper is overlapping its reference element, it will be moved to top)
	     *
	     * @param {Array} [options.modifiers=[ 'shift', 'offset', 'preventOverflow', 'keepTogether', 'arrow', 'flip', 'applyStyle']]
	     *      List of functions used to modify the data before they are applied to the popper, add your custom functions
	     *      to this array to edit the offsets and placement.
	     *      The function should reflect the @params and @returns of preventOverflow
	     *
	     * @param {Array} [options.modifiersIgnored=[]]
	     *      Put here any built-in modifier name you want to exclude from the modifiers list
	     *      The function should reflect the @params and @returns of preventOverflow
	     *
	     * @param {Boolean} [options.removeOnDestroy=false]
	     *      Set to true if you want to automatically remove the popper when you call the `destroy` method.
	     */
	    function Popper(reference, popper, options) {
	        this._reference = reference.jquery ? reference[0] : reference;
	        this.state = {};
	
	        // if the popper variable is a configuration object, parse it to generate an HTMLElement
	        // generate a default popper if is not defined
	        var isNotDefined = typeof popper === 'undefined' || popper === null;
	        var isConfig = popper && Object.prototype.toString.call(popper) === '[object Object]';
	        if (isNotDefined || isConfig) {
	            this._popper = this.parse(isConfig ? popper : {});
	        }
	        // otherwise, use the given HTMLElement as popper
	        else {
	                this._popper = popper.jquery ? popper[0] : popper;
	            }
	
	        // with {} we create a new object with the options inside it
	        this._options = Object.assign({}, DEFAULTS, options);
	
	        // refactoring modifiers' list
	        this._options.modifiers = this._options.modifiers.map(function (modifier) {
	            // remove ignored modifiers
	            if (this._options.modifiersIgnored.indexOf(modifier) !== -1) return;
	
	            // set the x-placement attribute before everything else because it could be used to add margins to the popper
	            // margins needs to be calculated to get the correct popper offsets
	            if (modifier === 'applyStyle') {
	                this._popper.setAttribute('x-placement', this._options.placement);
	            }
	
	            // return predefined modifier identified by string or keep the custom one
	            return this.modifiers[modifier] || modifier;
	        }.bind(this));
	
	        // make sure to apply the popper position before any computation
	        this.state.position = this._getPosition(this._popper, this._reference);
	        setStyle(this._popper, { position: this.state.position, top: 0 });
	
	        // fire the first update to position the popper in the right place
	        this.update();
	
	        // setup event listeners, they will take care of update the position in specific situations
	        this._setupEventListeners();
	        return this;
	    }
	
	    //
	    // Methods
	    //
	    /**
	     * Destroy the popper
	     * @method
	     * @memberof Popper
	     */
	    Popper.prototype.destroy = function () {
	        this._popper.removeAttribute('x-placement');
	        this._popper.style.left = '';
	        this._popper.style.position = '';
	        this._popper.style.top = '';
	        this._popper.style[getSupportedPropertyName('transform')] = '';
	        this._removeEventListeners();
	
	        // remove the popper if user explicity asked for the deletion on destroy
	        if (this._options.removeOnDestroy) {
	            this._popper.remove();
	        }
	        return this;
	    };
	
	    /**
	     * Updates the position of the popper, computing the new offsets and applying the new style
	     * @method
	     * @memberof Popper
	     */
	    Popper.prototype.update = function () {
	        var data = { instance: this, styles: {} };
	
	        // store placement inside the data object, modifiers will be able to edit `placement` if needed
	        // and refer to _originalPlacement to know the original value
	        data.placement = this._options.placement;
	        data._originalPlacement = this._options.placement;
	
	        // compute the popper and reference offsets and put them inside data.offsets
	        data.offsets = this._getOffsets(this._popper, this._reference, data.placement);
	
	        // get boundaries
	        data.boundaries = this._getBoundaries(data, this._options.boundariesPadding, this._options.boundariesElement);
	
	        data = this.runModifiers(data, this._options.modifiers);
	
	        if (typeof this.state.updateCallback === 'function') {
	            this.state.updateCallback(data);
	        }
	    };
	
	    /**
	     * If a function is passed, it will be executed after the initialization of popper with as first argument the Popper instance.
	     * @method
	     * @memberof Popper
	     * @param {Function} callback
	     */
	    Popper.prototype.onCreate = function (callback) {
	        // the createCallbacks return as first argument the popper instance
	        callback(this);
	        return this;
	    };
	
	    /**
	     * If a function is passed, it will be executed after each update of popper with as first argument the set of coordinates and informations
	     * used to style popper and its arrow.
	     * NOTE: it doesn't get fired on the first call of the `Popper.update()` method inside the `Popper` constructor!
	     * @method
	     * @memberof Popper
	     * @param {Function} callback
	     */
	    Popper.prototype.onUpdate = function (callback) {
	        this.state.updateCallback = callback;
	        return this;
	    };
	
	    /**
	     * Helper used to generate poppers from a configuration file
	     * @method
	     * @memberof Popper
	     * @param config {Object} configuration
	     * @returns {HTMLElement} popper
	     */
	    Popper.prototype.parse = function (config) {
	        var defaultConfig = {
	            tagName: 'div',
	            classNames: ['popper'],
	            attributes: [],
	            parent: root.document.body,
	            content: '',
	            contentType: 'text',
	            arrowTagName: 'div',
	            arrowClassNames: ['popper__arrow'],
	            arrowAttributes: ['x-arrow']
	        };
	        config = Object.assign({}, defaultConfig, config);
	
	        var d = root.document;
	
	        var popper = d.createElement(config.tagName);
	        addClassNames(popper, config.classNames);
	        addAttributes(popper, config.attributes);
	        if (config.contentType === 'node') {
	            popper.appendChild(config.content.jquery ? config.content[0] : config.content);
	        } else if (config.contentType === 'html') {
	            popper.innerHTML = config.content;
	        } else {
	            popper.textContent = config.content;
	        }
	
	        if (config.arrowTagName) {
	            var arrow = d.createElement(config.arrowTagName);
	            addClassNames(arrow, config.arrowClassNames);
	            addAttributes(arrow, config.arrowAttributes);
	            popper.appendChild(arrow);
	        }
	
	        var parent = config.parent.jquery ? config.parent[0] : config.parent;
	
	        // if the given parent is a string, use it to match an element
	        // if more than one element is matched, the first one will be used as parent
	        // if no elements are matched, the script will throw an error
	        if (typeof parent === 'string') {
	            parent = d.querySelectorAll(config.parent);
	            if (parent.length > 1) {
	                console.warn('WARNING: the given `parent` query(' + config.parent + ') matched more than one element, the first one will be used');
	            }
	            if (parent.length === 0) {
	                throw 'ERROR: the given `parent` doesn\'t exists!';
	            }
	            parent = parent[0];
	        }
	        // if the given parent is a DOM nodes list or an array of nodes with more than one element,
	        // the first one will be used as parent
	        if (parent.length > 1 && parent instanceof Element === false) {
	            console.warn('WARNING: you have passed as parent a list of elements, the first one will be used');
	            parent = parent[0];
	        }
	
	        // append the generated popper to its parent
	        parent.appendChild(popper);
	
	        return popper;
	
	        /**
	         * Adds class names to the given element
	         * @function
	         * @ignore
	         * @param {HTMLElement} target
	         * @param {Array} classes
	         */
	        function addClassNames(element, classNames) {
	            classNames.forEach(function (className) {
	                element.classList.add(className);
	            });
	        }
	
	        /**
	         * Adds attributes to the given element
	         * @function
	         * @ignore
	         * @param {HTMLElement} target
	         * @param {Array} attributes
	         * @example
	         * addAttributes(element, [ 'data-info:foobar' ]);
	         */
	        function addAttributes(element, attributes) {
	            attributes.forEach(function (attribute) {
	                element.setAttribute(attribute.split(':')[0], attribute.split(':')[1] || '');
	            });
	        }
	    };
	
	    /**
	     * Helper used to get the position which will be applied to the popper
	     * @method
	     * @memberof Popper
	     * @param config {HTMLElement} popper element
	     * @param reference {HTMLElement} reference element
	     * @returns {String} position
	     */
	    Popper.prototype._getPosition = function (popper, reference) {
	        var container = getOffsetParent(reference);
	
	        if (this._options.forceAbsolute) {
	            return 'absolute';
	        }
	
	        // Decide if the popper will be fixed
	        // If the reference element is inside a fixed context, the popper will be fixed as well to allow them to scroll together
	        var isParentFixed = isFixed(reference, container);
	        return isParentFixed ? 'fixed' : 'absolute';
	    };
	
	    /**
	     * Get offsets to the popper
	     * @method
	     * @memberof Popper
	     * @access private
	     * @param {Element} popper - the popper element
	     * @param {Element} reference - the reference element (the popper will be relative to this)
	     * @returns {Object} An object containing the offsets which will be applied to the popper
	     */
	    Popper.prototype._getOffsets = function (popper, reference, placement) {
	        placement = placement.split('-')[0];
	        var popperOffsets = {};
	
	        popperOffsets.position = this.state.position;
	        var isParentFixed = popperOffsets.position === 'fixed';
	
	        //
	        // Get reference element position
	        //
	        var referenceOffsets = getOffsetRectRelativeToCustomParent(reference, getOffsetParent(popper), isParentFixed);
	
	        //
	        // Get popper sizes
	        //
	        var popperRect = getOuterSizes(popper);
	
	        //
	        // Compute offsets of popper
	        //
	
	        // depending by the popper placement we have to compute its offsets slightly differently
	        if (['right', 'left'].indexOf(placement) !== -1) {
	            popperOffsets.top = referenceOffsets.top + referenceOffsets.height / 2 - popperRect.height / 2;
	            if (placement === 'left') {
	                popperOffsets.left = referenceOffsets.left - popperRect.width;
	            } else {
	                popperOffsets.left = referenceOffsets.right;
	            }
	        } else {
	            popperOffsets.left = referenceOffsets.left + referenceOffsets.width / 2 - popperRect.width / 2;
	            if (placement === 'top') {
	                popperOffsets.top = referenceOffsets.top - popperRect.height;
	            } else {
	                popperOffsets.top = referenceOffsets.bottom;
	            }
	        }
	
	        // Add width and height to our offsets object
	        popperOffsets.width = popperRect.width;
	        popperOffsets.height = popperRect.height;
	
	        return {
	            popper: popperOffsets,
	            reference: referenceOffsets
	        };
	    };
	
	    /**
	     * Setup needed event listeners used to update the popper position
	     * @method
	     * @memberof Popper
	     * @access private
	     */
	    Popper.prototype._setupEventListeners = function () {
	        // NOTE: 1 DOM access here
	        this.state.updateBound = this.update.bind(this);
	        root.addEventListener('resize', this.state.updateBound);
	        // if the boundariesElement is window we don't need to listen for the scroll event
	        if (this._options.boundariesElement !== 'window') {
	            var target = getScrollParent(this._reference);
	            // here it could be both `body` or `documentElement` thanks to Firefox, we then check both
	            if (target === root.document.body || target === root.document.documentElement) {
	                target = root;
	            }
	            target.addEventListener('scroll', this.state.updateBound);
	            this.state.scrollTarget = target;
	        }
	    };
	
	    /**
	     * Remove event listeners used to update the popper position
	     * @method
	     * @memberof Popper
	     * @access private
	     */
	    Popper.prototype._removeEventListeners = function () {
	        // NOTE: 1 DOM access here
	        root.removeEventListener('resize', this.state.updateBound);
	        if (this._options.boundariesElement !== 'window' && this.state.scrollTarget) {
	            this.state.scrollTarget.removeEventListener('scroll', this.state.updateBound);
	            this.state.scrollTarget = null;
	        }
	        this.state.updateBound = null;
	    };
	
	    /**
	     * Computed the boundaries limits and return them
	     * @method
	     * @memberof Popper
	     * @access private
	     * @param {Object} data - Object containing the property "offsets" generated by `_getOffsets`
	     * @param {Number} padding - Boundaries padding
	     * @param {Element} boundariesElement - Element used to define the boundaries
	     * @returns {Object} Coordinates of the boundaries
	     */
	    Popper.prototype._getBoundaries = function (data, padding, boundariesElement) {
	        // NOTE: 1 DOM access here
	        var boundaries = {};
	        var width, height;
	        if (boundariesElement === 'window') {
	            var body = root.document.body,
	                html = root.document.documentElement;
	
	            height = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
	            width = Math.max(body.scrollWidth, body.offsetWidth, html.clientWidth, html.scrollWidth, html.offsetWidth);
	
	            boundaries = {
	                top: 0,
	                right: width,
	                bottom: height,
	                left: 0
	            };
	        } else if (boundariesElement === 'viewport') {
	            var offsetParent = getOffsetParent(this._popper);
	            var scrollParent = getScrollParent(this._popper);
	            var offsetParentRect = getOffsetRect(offsetParent);
	
	            // Thanks the fucking native API, `document.body.scrollTop` & `document.documentElement.scrollTop`
	            var getScrollTopValue = function getScrollTopValue(element) {
	                return element == document.body ? Math.max(document.documentElement.scrollTop, document.body.scrollTop) : element.scrollTop;
	            };
	            var getScrollLeftValue = function getScrollLeftValue(element) {
	                return element == document.body ? Math.max(document.documentElement.scrollLeft, document.body.scrollLeft) : element.scrollLeft;
	            };
	
	            // if the popper is fixed we don't have to substract scrolling from the boundaries
	            var scrollTop = data.offsets.popper.position === 'fixed' ? 0 : getScrollTopValue(scrollParent);
	            var scrollLeft = data.offsets.popper.position === 'fixed' ? 0 : getScrollLeftValue(scrollParent);
	
	            boundaries = {
	                top: 0 - (offsetParentRect.top - scrollTop),
	                right: root.document.documentElement.clientWidth - (offsetParentRect.left - scrollLeft),
	                bottom: root.document.documentElement.clientHeight - (offsetParentRect.top - scrollTop),
	                left: 0 - (offsetParentRect.left - scrollLeft)
	            };
	        } else {
	            if (getOffsetParent(this._popper) === boundariesElement) {
	                boundaries = {
	                    top: 0,
	                    left: 0,
	                    right: boundariesElement.clientWidth,
	                    bottom: boundariesElement.clientHeight
	                };
	            } else {
	                boundaries = getOffsetRect(boundariesElement);
	            }
	        }
	        boundaries.left += padding;
	        boundaries.right -= padding;
	        boundaries.top = boundaries.top + padding;
	        boundaries.bottom = boundaries.bottom - padding;
	        return boundaries;
	    };
	
	    /**
	     * Loop trough the list of modifiers and run them in order, each of them will then edit the data object
	     * @method
	     * @memberof Popper
	     * @access public
	     * @param {Object} data
	     * @param {Array} modifiers
	     * @param {Function} ends
	     */
	    Popper.prototype.runModifiers = function (data, modifiers, ends) {
	        var modifiersToRun = modifiers.slice();
	        if (ends !== undefined) {
	            modifiersToRun = this._options.modifiers.slice(0, getArrayKeyIndex(this._options.modifiers, ends));
	        }
	
	        modifiersToRun.forEach(function (modifier) {
	            if (isFunction(modifier)) {
	                data = modifier.call(this, data);
	            }
	        }.bind(this));
	
	        return data;
	    };
	
	    /**
	     * Helper used to know if the given modifier depends from another one.
	     * @method
	     * @memberof Popper
	     * @param {String} requesting - name of requesting modifier
	     * @param {String} requested - name of requested modifier
	     * @returns {Boolean}
	     */
	    Popper.prototype.isModifierRequired = function (requesting, requested) {
	        var index = getArrayKeyIndex(this._options.modifiers, requesting);
	        return !!this._options.modifiers.slice(0, index).filter(function (modifier) {
	            return modifier === requested;
	        }).length;
	    };
	
	    //
	    // Modifiers
	    //
	
	    /**
	     * Modifiers list
	     * @namespace Popper.modifiers
	     * @memberof Popper
	     * @type {Object}
	     */
	    Popper.prototype.modifiers = {};
	
	    /**
	     * Apply the computed styles to the popper element
	     * @method
	     * @memberof Popper.modifiers
	     * @argument {Object} data - The data object generated by `update` method
	     * @returns {Object} The same data object
	     */
	    Popper.prototype.modifiers.applyStyle = function (data) {
	        // apply the final offsets to the popper
	        // NOTE: 1 DOM access here
	        var styles = {
	            position: data.offsets.popper.position
	        };
	
	        // round top and left to avoid blurry text
	        var left = Math.round(data.offsets.popper.left);
	        var top = Math.round(data.offsets.popper.top);
	
	        // if gpuAcceleration is set to true and transform is supported, we use `translate3d` to apply the position to the popper
	        // we automatically use the supported prefixed version if needed
	        var prefixedProperty;
	        if (this._options.gpuAcceleration && (prefixedProperty = getSupportedPropertyName('transform'))) {
	            styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
	            styles.top = 0;
	            styles.left = 0;
	        }
	        // othwerise, we use the standard `left` and `top` properties
	        else {
	                styles.left = left;
	                styles.top = top;
	            }
	
	        // any property present in `data.styles` will be applied to the popper,
	        // in this way we can make the 3rd party modifiers add custom styles to it
	        // Be aware, modifiers could override the properties defined in the previous
	        // lines of this modifier!
	        Object.assign(styles, data.styles);
	
	        setStyle(this._popper, styles);
	
	        // set an attribute which will be useful to style the tooltip (use it to properly position its arrow)
	        // NOTE: 1 DOM access here
	        this._popper.setAttribute('x-placement', data.placement);
	
	        // if the arrow modifier is required and the arrow style has been computed, apply the arrow style
	        if (this.isModifierRequired(this.modifiers.applyStyle, this.modifiers.arrow) && data.offsets.arrow) {
	            setStyle(data.arrowElement, data.offsets.arrow);
	        }
	
	        return data;
	    };
	
	    /**
	     * Modifier used to shift the popper on the start or end of its reference element side
	     * @method
	     * @memberof Popper.modifiers
	     * @argument {Object} data - The data object generated by `update` method
	     * @returns {Object} The data object, properly modified
	     */
	    Popper.prototype.modifiers.shift = function (data) {
	        var placement = data.placement;
	        var basePlacement = placement.split('-')[0];
	        var shiftVariation = placement.split('-')[1];
	
	        // if shift shiftVariation is specified, run the modifier
	        if (shiftVariation) {
	            var reference = data.offsets.reference;
	            var popper = getPopperClientRect(data.offsets.popper);
	
	            var shiftOffsets = {
	                y: {
	                    start: { top: reference.top },
	                    end: { top: reference.top + reference.height - popper.height }
	                },
	                x: {
	                    start: { left: reference.left },
	                    end: { left: reference.left + reference.width - popper.width }
	                }
	            };
	
	            var axis = ['bottom', 'top'].indexOf(basePlacement) !== -1 ? 'x' : 'y';
	
	            data.offsets.popper = Object.assign(popper, shiftOffsets[axis][shiftVariation]);
	        }
	
	        return data;
	    };
	
	    /**
	     * Modifier used to make sure the popper does not overflows from it's boundaries
	     * @method
	     * @memberof Popper.modifiers
	     * @argument {Object} data - The data object generated by `update` method
	     * @returns {Object} The data object, properly modified
	     */
	    Popper.prototype.modifiers.preventOverflow = function (data) {
	        var order = this._options.preventOverflowOrder;
	        var popper = getPopperClientRect(data.offsets.popper);
	
	        var check = {
	            left: function left() {
	                var left = popper.left;
	                if (popper.left < data.boundaries.left) {
	                    left = Math.max(popper.left, data.boundaries.left);
	                }
	                return { left: left };
	            },
	            right: function right() {
	                var left = popper.left;
	                if (popper.right > data.boundaries.right) {
	                    left = Math.min(popper.left, data.boundaries.right - popper.width);
	                }
	                return { left: left };
	            },
	            top: function top() {
	                var top = popper.top;
	                if (popper.top < data.boundaries.top) {
	                    top = Math.max(popper.top, data.boundaries.top);
	                }
	                return { top: top };
	            },
	            bottom: function bottom() {
	                var top = popper.top;
	                if (popper.bottom > data.boundaries.bottom) {
	                    top = Math.min(popper.top, data.boundaries.bottom - popper.height);
	                }
	                return { top: top };
	            }
	        };
	
	        order.forEach(function (direction) {
	            data.offsets.popper = Object.assign(popper, check[direction]());
	        });
	
	        return data;
	    };
	
	    /**
	     * Modifier used to make sure the popper is always near its reference
	     * @method
	     * @memberof Popper.modifiers
	     * @argument {Object} data - The data object generated by _update method
	     * @returns {Object} The data object, properly modified
	     */
	    Popper.prototype.modifiers.keepTogether = function (data) {
	        var popper = getPopperClientRect(data.offsets.popper);
	        var reference = data.offsets.reference;
	        var f = Math.floor;
	
	        if (popper.right < f(reference.left)) {
	            data.offsets.popper.left = f(reference.left) - popper.width;
	        }
	        if (popper.left > f(reference.right)) {
	            data.offsets.popper.left = f(reference.right);
	        }
	        if (popper.bottom < f(reference.top)) {
	            data.offsets.popper.top = f(reference.top) - popper.height;
	        }
	        if (popper.top > f(reference.bottom)) {
	            data.offsets.popper.top = f(reference.bottom);
	        }
	
	        return data;
	    };
	
	    /**
	     * Modifier used to flip the placement of the popper when the latter is starting overlapping its reference element.
	     * Requires the `preventOverflow` modifier before it in order to work.
	     * **NOTE:** This modifier will run all its previous modifiers everytime it tries to flip the popper!
	     * @method
	     * @memberof Popper.modifiers
	     * @argument {Object} data - The data object generated by _update method
	     * @returns {Object} The data object, properly modified
	     */
	    Popper.prototype.modifiers.flip = function (data) {
	        // check if preventOverflow is in the list of modifiers before the flip modifier.
	        // otherwise flip would not work as expected.
	        if (!this.isModifierRequired(this.modifiers.flip, this.modifiers.preventOverflow)) {
	            console.warn('WARNING: preventOverflow modifier is required by flip modifier in order to work, be sure to include it before flip!');
	            return data;
	        }
	
	        if (data.flipped && data.placement === data._originalPlacement) {
	            // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
	            return data;
	        }
	
	        var placement = data.placement.split('-')[0];
	        var placementOpposite = getOppositePlacement(placement);
	        var variation = data.placement.split('-')[1] || '';
	
	        var flipOrder = [];
	        if (this._options.flipBehavior === 'flip') {
	            flipOrder = [placement, placementOpposite];
	        } else {
	            flipOrder = this._options.flipBehavior;
	        }
	
	        flipOrder.forEach(function (step, index) {
	            if (placement !== step || flipOrder.length === index + 1) {
	                return;
	            }
	
	            placement = data.placement.split('-')[0];
	            placementOpposite = getOppositePlacement(placement);
	
	            var popperOffsets = getPopperClientRect(data.offsets.popper);
	
	            // this boolean is used to distinguish right and bottom from top and left
	            // they need different computations to get flipped
	            var a = ['right', 'bottom'].indexOf(placement) !== -1;
	
	            // using Math.floor because the reference offsets may contain decimals we are not going to consider here
	            if (a && Math.floor(data.offsets.reference[placement]) > Math.floor(popperOffsets[placementOpposite]) || !a && Math.floor(data.offsets.reference[placement]) < Math.floor(popperOffsets[placementOpposite])) {
	                // we'll use this boolean to detect any flip loop
	                data.flipped = true;
	                data.placement = flipOrder[index + 1];
	                if (variation) {
	                    data.placement += '-' + variation;
	                }
	                data.offsets.popper = this._getOffsets(this._popper, this._reference, data.placement).popper;
	
	                data = this.runModifiers(data, this._options.modifiers, this._flip);
	            }
	        }.bind(this));
	        return data;
	    };
	
	    /**
	     * Modifier used to add an offset to the popper, useful if you more granularity positioning your popper.
	     * The offsets will shift the popper on the side of its reference element.
	     * @method
	     * @memberof Popper.modifiers
	     * @argument {Object} data - The data object generated by _update method
	     * @returns {Object} The data object, properly modified
	     */
	    Popper.prototype.modifiers.offset = function (data) {
	        var offset = this._options.offset;
	        var popper = data.offsets.popper;
	
	        if (data.placement.indexOf('left') !== -1) {
	            popper.top -= offset;
	        } else if (data.placement.indexOf('right') !== -1) {
	            popper.top += offset;
	        } else if (data.placement.indexOf('top') !== -1) {
	            popper.left -= offset;
	        } else if (data.placement.indexOf('bottom') !== -1) {
	            popper.left += offset;
	        }
	        return data;
	    };
	
	    /**
	     * Modifier used to move the arrows on the edge of the popper to make sure them are always between the popper and the reference element
	     * It will use the CSS outer size of the arrow element to know how many pixels of conjuction are needed
	     * @method
	     * @memberof Popper.modifiers
	     * @argument {Object} data - The data object generated by _update method
	     * @returns {Object} The data object, properly modified
	     */
	    Popper.prototype.modifiers.arrow = function (data) {
	        var arrow = this._options.arrowElement;
	        var arrowOffset = this._options.arrowOffset;
	
	        // if the arrowElement is a string, suppose it's a CSS selector
	        if (typeof arrow === 'string') {
	            arrow = this._popper.querySelector(arrow);
	        }
	
	        // if arrow element is not found, don't run the modifier
	        if (!arrow) {
	            return data;
	        }
	
	        // the arrow element must be child of its popper
	        if (!this._popper.contains(arrow)) {
	            console.warn('WARNING: `arrowElement` must be child of its popper element!');
	            return data;
	        }
	
	        // arrow depends on keepTogether in order to work
	        if (!this.isModifierRequired(this.modifiers.arrow, this.modifiers.keepTogether)) {
	            console.warn('WARNING: keepTogether modifier is required by arrow modifier in order to work, be sure to include it before arrow!');
	            return data;
	        }
	
	        var arrowStyle = {};
	        var placement = data.placement.split('-')[0];
	        var popper = getPopperClientRect(data.offsets.popper);
	        var reference = data.offsets.reference;
	        var isVertical = ['left', 'right'].indexOf(placement) !== -1;
	
	        var len = isVertical ? 'height' : 'width';
	        var side = isVertical ? 'top' : 'left';
	        var translate = isVertical ? 'translateY' : 'translateX';
	        var altSide = isVertical ? 'left' : 'top';
	        var opSide = isVertical ? 'bottom' : 'right';
	        var arrowSize = getOuterSizes(arrow)[len];
	
	        //
	        // extends keepTogether behavior making sure the popper and its reference have enough pixels in conjuction
	        //
	
	        // top/left side
	        if (reference[opSide] - arrowSize < popper[side]) {
	            data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowSize);
	        }
	        // bottom/right side
	        if (reference[side] + arrowSize > popper[opSide]) {
	            data.offsets.popper[side] += reference[side] + arrowSize - popper[opSide];
	        }
	
	        // compute center of the popper
	        var center = reference[side] + (arrowOffset || reference[len] / 2 - arrowSize / 2);
	
	        var sideValue = center - popper[side];
	
	        // prevent arrow from being placed not contiguously to its popper
	        sideValue = Math.max(Math.min(popper[len] - arrowSize - 8, sideValue), 8);
	        arrowStyle[side] = sideValue;
	        arrowStyle[altSide] = ''; // make sure to remove any old style from the arrow
	
	        data.offsets.arrow = arrowStyle;
	        data.arrowElement = arrow;
	
	        return data;
	    };
	
	    //
	    // Helpers
	    //
	
	    /**
	     * Get the outer sizes of the given element (offset size + margins)
	     * @function
	     * @ignore
	     * @argument {Element} element
	     * @returns {Object} object containing width and height properties
	     */
	    function getOuterSizes(element) {
	        // NOTE: 1 DOM access here
	        var _display = element.style.display,
	            _visibility = element.style.visibility;
	        element.style.display = 'block';element.style.visibility = 'hidden';
	        var calcWidthToForceRepaint = element.offsetWidth;
	
	        // original method
	        var styles = root.getComputedStyle(element);
	        var x = parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);
	        var y = parseFloat(styles.marginLeft) + parseFloat(styles.marginRight);
	        var result = { width: element.offsetWidth + y, height: element.offsetHeight + x };
	
	        // reset element styles
	        element.style.display = _display;element.style.visibility = _visibility;
	        return result;
	    }
	
	    /**
	     * Get the opposite placement of the given one/
	     * @function
	     * @ignore
	     * @argument {String} placement
	     * @returns {String} flipped placement
	     */
	    function getOppositePlacement(placement) {
	        var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
	        return placement.replace(/left|right|bottom|top/g, function (matched) {
	            return hash[matched];
	        });
	    }
	
	    /**
	     * Given the popper offsets, generate an output similar to getBoundingClientRect
	     * @function
	     * @ignore
	     * @argument {Object} popperOffsets
	     * @returns {Object} ClientRect like output
	     */
	    function getPopperClientRect(popperOffsets) {
	        var offsets = Object.assign({}, popperOffsets);
	        offsets.right = offsets.left + offsets.width;
	        offsets.bottom = offsets.top + offsets.height;
	        return offsets;
	    }
	
	    /**
	     * Given an array and the key to find, returns its index
	     * @function
	     * @ignore
	     * @argument {Array} arr
	     * @argument keyToFind
	     * @returns index or null
	     */
	    function getArrayKeyIndex(arr, keyToFind) {
	        var i = 0,
	            key;
	        for (key in arr) {
	            if (arr[key] === keyToFind) {
	                return i;
	            }
	            i++;
	        }
	        return null;
	    }
	
	    /**
	     * Get CSS computed property of the given element
	     * @function
	     * @ignore
	     * @argument {Eement} element
	     * @argument {String} property
	     */
	    function getStyleComputedProperty(element, property) {
	        // NOTE: 1 DOM access here
	        var css = root.getComputedStyle(element, null);
	        return css[property];
	    }
	
	    /**
	     * Returns the offset parent of the given element
	     * @function
	     * @ignore
	     * @argument {Element} element
	     * @returns {Element} offset parent
	     */
	    function getOffsetParent(element) {
	        // NOTE: 1 DOM access here
	        var offsetParent = element.offsetParent;
	        return offsetParent === root.document.body || !offsetParent ? root.document.documentElement : offsetParent;
	    }
	
	    /**
	     * Returns the scrolling parent of the given element
	     * @function
	     * @ignore
	     * @argument {Element} element
	     * @returns {Element} offset parent
	     */
	    function getScrollParent(element) {
	        var parent = element.parentNode;
	
	        if (!parent) {
	            return element;
	        }
	
	        if (parent === root.document) {
	            // Firefox puts the scrollTOp value on `documentElement` instead of `body`, we then check which of them is
	            // greater than 0 and return the proper element
	            if (root.document.body.scrollTop || root.document.body.scrollLeft) {
	                return root.document.body;
	            } else {
	                return root.document.documentElement;
	            }
	        }
	
	        // Firefox want us to check `-x` and `-y` variations as well
	        if (['scroll', 'auto'].indexOf(getStyleComputedProperty(parent, 'overflow')) !== -1 || ['scroll', 'auto'].indexOf(getStyleComputedProperty(parent, 'overflow-x')) !== -1 || ['scroll', 'auto'].indexOf(getStyleComputedProperty(parent, 'overflow-y')) !== -1) {
	            // If the detected scrollParent is body, we perform an additional check on its parentNode
	            // in this way we'll get body if the browser is Chrome-ish, or documentElement otherwise
	            // fixes issue #65
	            return parent;
	        }
	        return getScrollParent(element.parentNode);
	    }
	
	    /**
	     * Check if the given element is fixed or is inside a fixed parent
	     * @function
	     * @ignore
	     * @argument {Element} element
	     * @argument {Element} customContainer
	     * @returns {Boolean} answer to "isFixed?"
	     */
	    function isFixed(element) {
	        if (element === root.document.body) {
	            return false;
	        }
	        if (getStyleComputedProperty(element, 'position') === 'fixed') {
	            return true;
	        }
	        return element.parentNode ? isFixed(element.parentNode) : element;
	    }
	
	    /**
	     * Set the style to the given popper
	     * @function
	     * @ignore
	     * @argument {Element} element - Element to apply the style to
	     * @argument {Object} styles - Object with a list of properties and values which will be applied to the element
	     */
	    function setStyle(element, styles) {
	        function is_numeric(n) {
	            return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
	        }
	        Object.keys(styles).forEach(function (prop) {
	            var unit = '';
	            // add unit if the value is numeric and is one of the following
	            if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && is_numeric(styles[prop])) {
	                unit = 'px';
	            }
	            element.style[prop] = styles[prop] + unit;
	        });
	    }
	
	    /**
	     * Check if the given variable is a function
	     * @function
	     * @ignore
	     * @argument {*} functionToCheck - variable to check
	     * @returns {Boolean} answer to: is a function?
	     */
	    function isFunction(functionToCheck) {
	        var getType = {};
	        return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
	    }
	
	    /**
	     * Get the position of the given element, relative to its offset parent
	     * @function
	     * @ignore
	     * @param {Element} element
	     * @return {Object} position - Coordinates of the element and its `scrollTop`
	     */
	    function getOffsetRect(element) {
	        var elementRect = {
	            width: element.offsetWidth,
	            height: element.offsetHeight,
	            left: element.offsetLeft,
	            top: element.offsetTop
	        };
	
	        elementRect.right = elementRect.left + elementRect.width;
	        elementRect.bottom = elementRect.top + elementRect.height;
	
	        // position
	        return elementRect;
	    }
	
	    /**
	     * Get bounding client rect of given element
	     * @function
	     * @ignore
	     * @param {HTMLElement} element
	     * @return {Object} client rect
	     */
	    function getBoundingClientRect(element) {
	        var rect = element.getBoundingClientRect();
	
	        // whether the IE version is lower than 11
	        var isIE = navigator.userAgent.indexOf("MSIE") != -1;
	
	        // fix ie document bounding top always 0 bug
	        var rectTop = isIE && element.tagName === 'HTML' ? -element.scrollTop : rect.top;
	
	        return {
	            left: rect.left,
	            top: rectTop,
	            right: rect.right,
	            bottom: rect.bottom,
	            width: rect.right - rect.left,
	            height: rect.bottom - rectTop
	        };
	    }
	
	    /**
	     * Given an element and one of its parents, return the offset
	     * @function
	     * @ignore
	     * @param {HTMLElement} element
	     * @param {HTMLElement} parent
	     * @return {Object} rect
	     */
	    function getOffsetRectRelativeToCustomParent(element, parent, fixed) {
	        var elementRect = getBoundingClientRect(element);
	        var parentRect = getBoundingClientRect(parent);
	
	        if (fixed) {
	            var scrollParent = getScrollParent(parent);
	            parentRect.top += scrollParent.scrollTop;
	            parentRect.bottom += scrollParent.scrollTop;
	            parentRect.left += scrollParent.scrollLeft;
	            parentRect.right += scrollParent.scrollLeft;
	        }
	
	        var rect = {
	            top: elementRect.top - parentRect.top,
	            left: elementRect.left - parentRect.left,
	            bottom: elementRect.top - parentRect.top + elementRect.height,
	            right: elementRect.left - parentRect.left + elementRect.width,
	            width: elementRect.width,
	            height: elementRect.height
	        };
	        return rect;
	    }
	
	    /**
	     * Get the prefixed supported property name
	     * @function
	     * @ignore
	     * @argument {String} property (camelCase)
	     * @returns {String} prefixed property (camelCase)
	     */
	    function getSupportedPropertyName(property) {
	        var prefixes = ['', 'ms', 'webkit', 'moz', 'o'];
	
	        for (var i = 0; i < prefixes.length; i++) {
	            var toCheck = prefixes[i] ? prefixes[i] + property.charAt(0).toUpperCase() + property.slice(1) : property;
	            if (typeof root.document.body.style[toCheck] !== 'undefined') {
	                return toCheck;
	            }
	        }
	        return null;
	    }
	
	    /**
	     * The Object.assign() method is used to copy the values of all enumerable own properties from one or more source
	     * objects to a target object. It will return the target object.
	     * This polyfill doesn't support symbol properties, since ES5 doesn't have symbols anyway
	     * Source: https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
	     * @function
	     * @ignore
	     */
	    if (!Object.assign) {
	        Object.defineProperty(Object, 'assign', {
	            enumerable: false,
	            configurable: true,
	            writable: true,
	            value: function value(target) {
	                if (target === undefined || target === null) {
	                    throw new TypeError('Cannot convert first argument to object');
	                }
	
	                var to = Object(target);
	                for (var i = 1; i < arguments.length; i++) {
	                    var nextSource = arguments[i];
	                    if (nextSource === undefined || nextSource === null) {
	                        continue;
	                    }
	                    nextSource = Object(nextSource);
	
	                    var keysArray = Object.keys(nextSource);
	                    for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
	                        var nextKey = keysArray[nextIndex];
	                        var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
	                        if (desc !== undefined && desc.enumerable) {
	                            to[nextKey] = nextSource[nextKey];
	                        }
	                    }
	                }
	                return to;
	            }
	        });
	    }
	
	    return Popper;
	});

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _vue = __webpack_require__(20);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _dom = __webpack_require__(42);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hasModal = false;
	var hasInitZIndex = false;
	var zIndex = void 0;
	
	var getModal = function getModal() {
	  if (_vue2.default.prototype.$isServer) return;
	  var modalDom = PopupManager.modalDom;
	  if (modalDom) {
	    hasModal = true;
	  } else {
	    hasModal = false;
	    modalDom = document.createElement('div');
	    PopupManager.modalDom = modalDom;
	
	    modalDom.addEventListener('touchmove', function (event) {
	      event.preventDefault();
	      event.stopPropagation();
	    });
	
	    modalDom.addEventListener('click', function () {
	      PopupManager.doOnModalClick && PopupManager.doOnModalClick();
	    });
	  }
	
	  return modalDom;
	};
	
	var instances = {};
	
	var PopupManager = {
	  modalFade: true,
	
	  getInstance: function getInstance(id) {
	    return instances[id];
	  },
	
	  register: function register(id, instance) {
	    if (id && instance) {
	      instances[id] = instance;
	    }
	  },
	
	  deregister: function deregister(id) {
	    if (id) {
	      instances[id] = null;
	      delete instances[id];
	    }
	  },
	
	  nextZIndex: function nextZIndex() {
	    return PopupManager.zIndex++;
	  },
	
	  modalStack: [],
	
	  doOnModalClick: function doOnModalClick() {
	    var topItem = PopupManager.modalStack[PopupManager.modalStack.length - 1];
	    if (!topItem) return;
	
	    var instance = PopupManager.getInstance(topItem.id);
	    if (instance && instance.closeOnClickModal) {
	      instance.close();
	    }
	  },
	
	  openModal: function openModal(id, zIndex, dom, modalClass, modalFade) {
	    if (_vue2.default.prototype.$isServer) return;
	    if (!id || zIndex === undefined) return;
	    this.modalFade = modalFade;
	
	    var modalStack = this.modalStack;
	
	    for (var i = 0, j = modalStack.length; i < j; i++) {
	      var item = modalStack[i];
	      if (item.id === id) {
	        return;
	      }
	    }
	
	    var modalDom = getModal();
	
	    (0, _dom.addClass)(modalDom, 'v-modal');
	    if (this.modalFade && !hasModal) {
	      (0, _dom.addClass)(modalDom, 'v-modal-enter');
	    }
	    if (modalClass) {
	      var classArr = modalClass.trim().split(/\s+/);
	      classArr.forEach(function (item) {
	        return (0, _dom.addClass)(modalDom, item);
	      });
	    }
	    setTimeout(function () {
	      (0, _dom.removeClass)(modalDom, 'v-modal-enter');
	    }, 200);
	
	    if (dom && dom.parentNode && dom.parentNode.nodeType !== 11) {
	      dom.parentNode.appendChild(modalDom);
	    } else {
	      document.body.appendChild(modalDom);
	    }
	
	    if (zIndex) {
	      modalDom.style.zIndex = zIndex;
	    }
	    modalDom.tabIndex = 0;
	    modalDom.style.display = '';
	
	    this.modalStack.push({ id: id, zIndex: zIndex, modalClass: modalClass });
	  },
	
	  closeModal: function closeModal(id) {
	    var modalStack = this.modalStack;
	    var modalDom = getModal();
	
	    if (modalStack.length > 0) {
	      var topItem = modalStack[modalStack.length - 1];
	      if (topItem.id === id) {
	        if (topItem.modalClass) {
	          var classArr = topItem.modalClass.trim().split(/\s+/);
	          classArr.forEach(function (item) {
	            return (0, _dom.removeClass)(modalDom, item);
	          });
	        }
	
	        modalStack.pop();
	        if (modalStack.length > 0) {
	          modalDom.style.zIndex = modalStack[modalStack.length - 1].zIndex;
	        }
	      } else {
	        for (var i = modalStack.length - 1; i >= 0; i--) {
	          if (modalStack[i].id === id) {
	            modalStack.splice(i, 1);
	            break;
	          }
	        }
	      }
	    }
	
	    if (modalStack.length === 0) {
	      if (this.modalFade) {
	        (0, _dom.addClass)(modalDom, 'v-modal-leave');
	      }
	      setTimeout(function () {
	        if (modalStack.length === 0) {
	          if (modalDom.parentNode) modalDom.parentNode.removeChild(modalDom);
	          modalDom.style.display = 'none';
	          PopupManager.modalDom = undefined;
	        }
	        (0, _dom.removeClass)(modalDom, 'v-modal-leave');
	      }, 200);
	    }
	  }
	};
	
	Object.defineProperty(PopupManager, 'zIndex', {
	  configurable: true,
	  get: function get() {
	    if (!hasInitZIndex) {
	      zIndex = zIndex || (_vue2.default.prototype.$ELEMENT || {}).zIndex || 2000;
	      hasInitZIndex = true;
	    }
	    return zIndex;
	  },
	  set: function set(value) {
	    zIndex = value;
	  }
	});
	
	var getTopPopup = function getTopPopup() {
	  if (_vue2.default.prototype.$isServer) return;
	  if (PopupManager.modalStack.length > 0) {
	    var topPopup = PopupManager.modalStack[PopupManager.modalStack.length - 1];
	    if (!topPopup) return;
	    var instance = PopupManager.getInstance(topPopup.id);
	
	    return instance;
	  }
	};
	
	if (!_vue2.default.prototype.$isServer) {
	  // handle `esc` key when the popup is shown
	  window.addEventListener('keydown', function (event) {
	    if (event.keyCode === 27) {
	      var topPopup = getTopPopup();
	
	      if (topPopup && topPopup.closeOnPressEscape) {
	        topPopup.handleClose ? topPopup.handleClose() : topPopup.handleAction ? topPopup.handleAction('cancel') : topPopup.close();
	      }
	    }
	  });
	}
	
	exports.default = PopupManager;

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.isVNode = isVNode;
	
	var _util = __webpack_require__(38);
	
	function isVNode(node) {
	  return node !== null && (typeof node === 'undefined' ? 'undefined' : _typeof(node)) === 'object' && (0, _util.hasOwn)(node, 'componentOptions');
	};

/***/ }),
/* 402 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 403 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 404 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 405 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 406 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 407 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 408 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 409 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 410 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 411 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 412 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 413 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 414 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 415 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 416 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 417 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 418 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 419 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 420 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 421 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 422 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 423 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 424 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 425 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 426 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 427 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 428 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 429 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 430 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 431 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 432 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 433 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 434 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 435 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 436 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 437 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 438 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 439 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 440 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 441 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 442 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 443 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 444 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 445 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 446 */
/***/ (function(module, exports) {

	/*!
	 * Determine if an object is a Buffer
	 *
	 * @author   Feross Aboukhadijeh <https://feross.org>
	 * @license  MIT
	 */
	
	// The _isBuffer check is for Safari 5-7 support, because it's missing
	// Object.prototype.constructor. Remove this eventually
	module.exports = function (obj) {
	  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
	}
	
	function isBuffer (obj) {
	  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
	}
	
	// For Node v0.10 support. Remove this eventually.
	function isSlowBuffer (obj) {
	  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
	}


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * JavaScript Cookie v2.2.1
	 * https://github.com/js-cookie/js-cookie
	 *
	 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
	 * Released under the MIT license
	 */
	;(function (factory) {
		var registeredInModuleLoader;
		if (true) {
			!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
			registeredInModuleLoader = true;
		}
		if (true) {
			module.exports = factory();
			registeredInModuleLoader = true;
		}
		if (!registeredInModuleLoader) {
			var OldCookies = window.Cookies;
			var api = window.Cookies = factory();
			api.noConflict = function () {
				window.Cookies = OldCookies;
				return api;
			};
		}
	}(function () {
		function extend () {
			var i = 0;
			var result = {};
			for (; i < arguments.length; i++) {
				var attributes = arguments[ i ];
				for (var key in attributes) {
					result[key] = attributes[key];
				}
			}
			return result;
		}
	
		function decode (s) {
			return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
		}
	
		function init (converter) {
			function api() {}
	
			function set (key, value, attributes) {
				if (typeof document === 'undefined') {
					return;
				}
	
				attributes = extend({
					path: '/'
				}, api.defaults, attributes);
	
				if (typeof attributes.expires === 'number') {
					attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
				}
	
				// We're using "expires" because "max-age" is not supported by IE
				attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';
	
				try {
					var result = JSON.stringify(value);
					if (/^[\{\[]/.test(result)) {
						value = result;
					}
				} catch (e) {}
	
				value = converter.write ?
					converter.write(value, key) :
					encodeURIComponent(String(value))
						.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
	
				key = encodeURIComponent(String(key))
					.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
					.replace(/[\(\)]/g, escape);
	
				var stringifiedAttributes = '';
				for (var attributeName in attributes) {
					if (!attributes[attributeName]) {
						continue;
					}
					stringifiedAttributes += '; ' + attributeName;
					if (attributes[attributeName] === true) {
						continue;
					}
	
					// Considers RFC 6265 section 5.2:
					// ...
					// 3.  If the remaining unparsed-attributes contains a %x3B (";")
					//     character:
					// Consume the characters of the unparsed-attributes up to,
					// not including, the first %x3B (";") character.
					// ...
					stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
				}
	
				return (document.cookie = key + '=' + value + stringifiedAttributes);
			}
	
			function get (key, json) {
				if (typeof document === 'undefined') {
					return;
				}
	
				var jar = {};
				// To prevent the for loop in the first place assign an empty array
				// in case there are no cookies at all.
				var cookies = document.cookie ? document.cookie.split('; ') : [];
				var i = 0;
	
				for (; i < cookies.length; i++) {
					var parts = cookies[i].split('=');
					var cookie = parts.slice(1).join('=');
	
					if (!json && cookie.charAt(0) === '"') {
						cookie = cookie.slice(1, -1);
					}
	
					try {
						var name = decode(parts[0]);
						cookie = (converter.read || converter)(cookie, name) ||
							decode(cookie);
	
						if (json) {
							try {
								cookie = JSON.parse(cookie);
							} catch (e) {}
						}
	
						jar[name] = cookie;
	
						if (key === name) {
							break;
						}
					} catch (e) {}
				}
	
				return key ? jar[key] : jar;
			}
	
			api.set = set;
			api.get = function (key) {
				return get(key, false /* read as raw */);
			};
			api.getJSON = function (key) {
				return get(key, true /* read as json */);
			};
			api.remove = function (key, attributes) {
				set(key, '', extend(attributes, {
					expires: -1
				}));
			};
	
			api.defaults = {};
	
			api.withConverter = init;
	
			return api;
		}
	
		return init(function () {});
	}));


/***/ }),
/* 448 */
/***/ (function(module, exports) {

	module.exports = {"_args":[["@mtfe/sso-web@1.1.11","/tmp/build/src"]],"_from":"@mtfe/sso-web@1.1.11","_id":"@mtfe/sso-web@1.1.11","_inBundle":false,"_integrity":"sha1-4hpFnaqxtIuPkAyGyK+rVogJbqw=","_location":"/@mtfe/sso-web","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"@mtfe/sso-web@1.1.11","name":"@mtfe/sso-web","escapedName":"@mtfe%2fsso-web","scope":"@mtfe","rawSpec":"1.1.11","saveSpec":null,"fetchSpec":"1.1.11"},"_requiredBy":["/"],"_resolved":"http://r.npm.sankuai.com/@mtfe/sso-web/download/@mtfe/sso-web-1.1.11.tgz","_spec":"1.1.11","_where":"/tmp/build/src","author":{"name":"Leon"},"dependencies":{"crypto-js":"^3.1.9-1","minimatch":"^3.0.4","ts-polyfill":"^3.0.1","whatwg-fetch":"^2.0.4"},"description":"An easy way to get access to SSO in browser end.","devDependencies":{"@types/crypto-js":"^3.1.43","@types/jest":"^24.0.15","@types/jsdom":"^11.12.0","@types/minimatch":"^3.0.3","@types/nock":"^10.0.3","@types/node":"^10.5.7","cross-env":"^5.2.0","jest":"^24.8.0","jsdom":"^11.12.0","mm":"^2.4.0","nock":"^10.0.1","ts-jest":"^24.0.2","ts-node":"^7.0.0","tsconfig-paths":"^3.5.0","tslint":"^5.10.0","typescript":"^3.5.3","v8n":"^1.2.3"},"jest":{"preset":"ts-jest","setupFiles":["./test/setUp.ts"],"coveragePathIgnorePatterns":["/node_modules/","<rootDir>/test/","<rootDir>/lib/"],"modulePathIgnorePatterns":["<rootDir>/example/"],"testEnvironment":"node","globals":{"ts-jest":{"tsConfig":"tsconfig.test.json"}}},"keywords":["SSO","web"],"license":"UNLICENSED","main":"index.js","name":"@mtfe/sso-web","repository":{"type":"git","url":"ssh://git@git.sankuai.com/it/web-sso-sdk.git"},"scripts":{"build":"tsc","lint":"tslint ./src/**/*","prepare":"npm run build","test":"cross-env NODE_ENV=test jest","test:cover":"cross-env NODE_ENV=test jest --coverage"},"version":"1.1.11"}

/***/ }),
/* 449 */
/***/ (function(module, exports) {

	module.exports = {"color":["#7CB5EC","#434348","#90ED7D","#F7A35C","#8085E9","#F15C80","#E4D354","#BC8FE4","#85E1E4"],"backgroundColor":"rgba(0,0,0,0)","textStyle":{},"title":{"textStyle":{"color":"#516b91"},"subtextStyle":{"color":"#93b7e3"}},"line":{"itemStyle":{"normal":{"borderWidth":"2"}},"lineStyle":{"normal":{"width":"2"}},"symbolSize":"6","symbol":"emptyCircle","smooth":true},"radar":{"itemStyle":{"normal":{"borderWidth":"2"}},"lineStyle":{"normal":{"width":"2"}},"symbolSize":"6","symbol":"emptyCircle","smooth":true},"bar":{"itemStyle":{"normal":{"barBorderWidth":0,"barBorderColor":"#ccc"},"emphasis":{"barBorderWidth":0,"barBorderColor":"#ccc"}}},"pie":{"itemStyle":{"normal":{"borderWidth":0,"borderColor":"#ccc"},"emphasis":{"borderWidth":0,"borderColor":"#ccc"}}},"scatter":{"itemStyle":{"normal":{"borderWidth":0,"borderColor":"#ccc"},"emphasis":{"borderWidth":0,"borderColor":"#ccc"}}},"boxplot":{"itemStyle":{"normal":{"borderWidth":0,"borderColor":"#ccc"},"emphasis":{"borderWidth":0,"borderColor":"#ccc"}}},"parallel":{"itemStyle":{"normal":{"borderWidth":0,"borderColor":"#ccc"},"emphasis":{"borderWidth":0,"borderColor":"#ccc"}}},"sankey":{"itemStyle":{"normal":{"borderWidth":0,"borderColor":"#ccc"},"emphasis":{"borderWidth":0,"borderColor":"#ccc"}}},"funnel":{"itemStyle":{"normal":{"borderWidth":0,"borderColor":"#ccc"},"emphasis":{"borderWidth":0,"borderColor":"#ccc"}}},"gauge":{"itemStyle":{"normal":{"borderWidth":0,"borderColor":"#ccc"},"emphasis":{"borderWidth":0,"borderColor":"#ccc"}}},"candlestick":{"itemStyle":{"normal":{"color":"#edafda","color0":"transparent","borderColor":"#d680bc","borderColor0":"#8fd3e8","borderWidth":"2"}}},"graph":{"itemStyle":{"normal":{"borderWidth":0,"borderColor":"#ccc"}},"lineStyle":{"normal":{"width":1,"color":"#aaaaaa"}},"symbolSize":"6","symbol":"emptyCircle","smooth":true,"color":["#516b91","#59c4e6","#edafda","#93b7e3","#a5e7f0","#cbb0e3"],"label":{"normal":{"textStyle":{"color":"#eeeeee"}}}},"map":{"itemStyle":{"normal":{"areaColor":"#f3f3f3","borderColor":"#516b91","borderWidth":0.5},"emphasis":{"areaColor":"rgba(165,231,240,1)","borderColor":"#516b91","borderWidth":1}},"label":{"normal":{"textStyle":{"color":"#000000"}},"emphasis":{"textStyle":{"color":"rgb(81,107,145)"}}}},"geo":{"itemStyle":{"normal":{"areaColor":"#f3f3f3","borderColor":"#516b91","borderWidth":0.5},"emphasis":{"areaColor":"rgba(165,231,240,1)","borderColor":"#516b91","borderWidth":1}},"label":{"normal":{"textStyle":{"color":"#000000"}},"emphasis":{"textStyle":{"color":"rgb(81,107,145)"}}}},"categoryAxis":{"axisLine":{"show":true,"lineStyle":{"color":"#cccccc"}},"axisTick":{"show":false,"lineStyle":{"color":"#333"}},"axisLabel":{"show":true,"textStyle":{"color":"#999999"}},"splitLine":{"show":true,"lineStyle":{"color":["#eeeeee"]}},"splitArea":{"show":false,"areaStyle":{"color":["rgba(250,250,250,0.05)","rgba(200,200,200,0.02)"]}}},"valueAxis":{"axisLine":{"show":true,"lineStyle":{"color":"#cccccc"}},"axisTick":{"show":false,"lineStyle":{"color":"#333"}},"axisLabel":{"show":true,"textStyle":{"color":"#999999"}},"splitLine":{"show":true,"lineStyle":{"color":["#eeeeee"]}},"splitArea":{"show":false,"areaStyle":{"color":["rgba(250,250,250,0.05)","rgba(200,200,200,0.02)"]}}},"logAxis":{"axisLine":{"show":true,"lineStyle":{"color":"#cccccc"}},"axisTick":{"show":false,"lineStyle":{"color":"#333"}},"axisLabel":{"show":true,"textStyle":{"color":"#999999"}},"splitLine":{"show":true,"lineStyle":{"color":["#eeeeee"]}},"splitArea":{"show":false,"areaStyle":{"color":["rgba(250,250,250,0.05)","rgba(200,200,200,0.02)"]}}},"timeAxis":{"axisLine":{"show":true,"lineStyle":{"color":"#cccccc"}},"axisTick":{"show":false,"lineStyle":{"color":"#333"}},"axisLabel":{"show":true,"textStyle":{"color":"#999999"}},"splitLine":{"show":true,"lineStyle":{"color":["#eeeeee"]}},"splitArea":{"show":false,"areaStyle":{"color":["rgba(250,250,250,0.05)","rgba(200,200,200,0.02)"]}}},"toolbox":{"iconStyle":{"normal":{"borderColor":"#999999"},"emphasis":{"borderColor":"#666666"}}},"legend":{"textStyle":{"color":"#999999"}},"tooltip":{"axisPointer":{"lineStyle":{"color":"#cccccc","width":1},"crossStyle":{"color":"#cccccc","width":1}}},"timeline":{"lineStyle":{"color":"#8fd3e8","width":1},"itemStyle":{"normal":{"color":"#8fd3e8","borderWidth":1},"emphasis":{"color":"#8fd3e8"}},"controlStyle":{"normal":{"color":"#8fd3e8","borderColor":"#8fd3e8","borderWidth":0.5},"emphasis":{"color":"#8fd3e8","borderColor":"#8fd3e8","borderWidth":0.5}},"checkpointStyle":{"color":"#8fd3e8","borderColor":"rgba(138,124,168,0.37)"},"label":{"normal":{"textStyle":{"color":"#8fd3e8"}},"emphasis":{"textStyle":{"color":"#8fd3e8"}}}},"visualMap":{"color":["#516b91","#59c4e6","#a5e7f0"]},"dataZoom":{"backgroundColor":"rgba(0,0,0,0)","dataBackgroundColor":"rgba(255,255,255,0.3)","fillerColor":"rgba(167,183,204,0.4)","handleColor":"#a7b7cc","handleSize":"100%","textStyle":{"color":"#333333"}},"markPoint":{"label":{"normal":{"textStyle":{"color":"#eeeeee"}},"emphasis":{"textStyle":{"color":"#eeeeee"}}}}}

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = minimatch
	minimatch.Minimatch = Minimatch
	
	var path = { sep: '/' }
	try {
	  path = __webpack_require__(457)
	} catch (er) {}
	
	var GLOBSTAR = minimatch.GLOBSTAR = Minimatch.GLOBSTAR = {}
	var expand = __webpack_require__(282)
	
	var plTypes = {
	  '!': { open: '(?:(?!(?:', close: '))[^/]*?)'},
	  '?': { open: '(?:', close: ')?' },
	  '+': { open: '(?:', close: ')+' },
	  '*': { open: '(?:', close: ')*' },
	  '@': { open: '(?:', close: ')' }
	}
	
	// any single thing other than /
	// don't need to escape / when using new RegExp()
	var qmark = '[^/]'
	
	// * => any number of characters
	var star = qmark + '*?'
	
	// ** when dots are allowed.  Anything goes, except .. and .
	// not (^ or / followed by one or two dots followed by $ or /),
	// followed by anything, any number of times.
	var twoStarDot = '(?:(?!(?:\\\/|^)(?:\\.{1,2})($|\\\/)).)*?'
	
	// not a ^ or / followed by a dot,
	// followed by anything, any number of times.
	var twoStarNoDot = '(?:(?!(?:\\\/|^)\\.).)*?'
	
	// characters that need to be escaped in RegExp.
	var reSpecials = charSet('().*{}+?[]^$\\!')
	
	// "abc" -> { a:true, b:true, c:true }
	function charSet (s) {
	  return s.split('').reduce(function (set, c) {
	    set[c] = true
	    return set
	  }, {})
	}
	
	// normalizes slashes.
	var slashSplit = /\/+/
	
	minimatch.filter = filter
	function filter (pattern, options) {
	  options = options || {}
	  return function (p, i, list) {
	    return minimatch(p, pattern, options)
	  }
	}
	
	function ext (a, b) {
	  a = a || {}
	  b = b || {}
	  var t = {}
	  Object.keys(b).forEach(function (k) {
	    t[k] = b[k]
	  })
	  Object.keys(a).forEach(function (k) {
	    t[k] = a[k]
	  })
	  return t
	}
	
	minimatch.defaults = function (def) {
	  if (!def || !Object.keys(def).length) return minimatch
	
	  var orig = minimatch
	
	  var m = function minimatch (p, pattern, options) {
	    return orig.minimatch(p, pattern, ext(def, options))
	  }
	
	  m.Minimatch = function Minimatch (pattern, options) {
	    return new orig.Minimatch(pattern, ext(def, options))
	  }
	
	  return m
	}
	
	Minimatch.defaults = function (def) {
	  if (!def || !Object.keys(def).length) return Minimatch
	  return minimatch.defaults(def).Minimatch
	}
	
	function minimatch (p, pattern, options) {
	  if (typeof pattern !== 'string') {
	    throw new TypeError('glob pattern string required')
	  }
	
	  if (!options) options = {}
	
	  // shortcut: comments match nothing.
	  if (!options.nocomment && pattern.charAt(0) === '#') {
	    return false
	  }
	
	  // "" only matches ""
	  if (pattern.trim() === '') return p === ''
	
	  return new Minimatch(pattern, options).match(p)
	}
	
	function Minimatch (pattern, options) {
	  if (!(this instanceof Minimatch)) {
	    return new Minimatch(pattern, options)
	  }
	
	  if (typeof pattern !== 'string') {
	    throw new TypeError('glob pattern string required')
	  }
	
	  if (!options) options = {}
	  pattern = pattern.trim()
	
	  // windows support: need to use /, not \
	  if (path.sep !== '/') {
	    pattern = pattern.split(path.sep).join('/')
	  }
	
	  this.options = options
	  this.set = []
	  this.pattern = pattern
	  this.regexp = null
	  this.negate = false
	  this.comment = false
	  this.empty = false
	
	  // make the set of regexps etc.
	  this.make()
	}
	
	Minimatch.prototype.debug = function () {}
	
	Minimatch.prototype.make = make
	function make () {
	  // don't do it more than once.
	  if (this._made) return
	
	  var pattern = this.pattern
	  var options = this.options
	
	  // empty patterns and comments match nothing.
	  if (!options.nocomment && pattern.charAt(0) === '#') {
	    this.comment = true
	    return
	  }
	  if (!pattern) {
	    this.empty = true
	    return
	  }
	
	  // step 1: figure out negation, etc.
	  this.parseNegate()
	
	  // step 2: expand braces
	  var set = this.globSet = this.braceExpand()
	
	  if (options.debug) this.debug = console.error
	
	  this.debug(this.pattern, set)
	
	  // step 3: now we have a set, so turn each one into a series of path-portion
	  // matching patterns.
	  // These will be regexps, except in the case of "**", which is
	  // set to the GLOBSTAR object for globstar behavior,
	  // and will not contain any / characters
	  set = this.globParts = set.map(function (s) {
	    return s.split(slashSplit)
	  })
	
	  this.debug(this.pattern, set)
	
	  // glob --> regexps
	  set = set.map(function (s, si, set) {
	    return s.map(this.parse, this)
	  }, this)
	
	  this.debug(this.pattern, set)
	
	  // filter out everything that didn't compile properly.
	  set = set.filter(function (s) {
	    return s.indexOf(false) === -1
	  })
	
	  this.debug(this.pattern, set)
	
	  this.set = set
	}
	
	Minimatch.prototype.parseNegate = parseNegate
	function parseNegate () {
	  var pattern = this.pattern
	  var negate = false
	  var options = this.options
	  var negateOffset = 0
	
	  if (options.nonegate) return
	
	  for (var i = 0, l = pattern.length
	    ; i < l && pattern.charAt(i) === '!'
	    ; i++) {
	    negate = !negate
	    negateOffset++
	  }
	
	  if (negateOffset) this.pattern = pattern.substr(negateOffset)
	  this.negate = negate
	}
	
	// Brace expansion:
	// a{b,c}d -> abd acd
	// a{b,}c -> abc ac
	// a{0..3}d -> a0d a1d a2d a3d
	// a{b,c{d,e}f}g -> abg acdfg acefg
	// a{b,c}d{e,f}g -> abdeg acdeg abdeg abdfg
	//
	// Invalid sets are not expanded.
	// a{2..}b -> a{2..}b
	// a{b}c -> a{b}c
	minimatch.braceExpand = function (pattern, options) {
	  return braceExpand(pattern, options)
	}
	
	Minimatch.prototype.braceExpand = braceExpand
	
	function braceExpand (pattern, options) {
	  if (!options) {
	    if (this instanceof Minimatch) {
	      options = this.options
	    } else {
	      options = {}
	    }
	  }
	
	  pattern = typeof pattern === 'undefined'
	    ? this.pattern : pattern
	
	  if (typeof pattern === 'undefined') {
	    throw new TypeError('undefined pattern')
	  }
	
	  if (options.nobrace ||
	    !pattern.match(/\{.*\}/)) {
	    // shortcut. no need to expand.
	    return [pattern]
	  }
	
	  return expand(pattern)
	}
	
	// parse a component of the expanded set.
	// At this point, no pattern may contain "/" in it
	// so we're going to return a 2d array, where each entry is the full
	// pattern, split on '/', and then turned into a regular expression.
	// A regexp is made at the end which joins each array with an
	// escaped /, and another full one which joins each regexp with |.
	//
	// Following the lead of Bash 4.1, note that "**" only has special meaning
	// when it is the *only* thing in a path portion.  Otherwise, any series
	// of * is equivalent to a single *.  Globstar behavior is enabled by
	// default, and can be disabled by setting options.noglobstar.
	Minimatch.prototype.parse = parse
	var SUBPARSE = {}
	function parse (pattern, isSub) {
	  if (pattern.length > 1024 * 64) {
	    throw new TypeError('pattern is too long')
	  }
	
	  var options = this.options
	
	  // shortcuts
	  if (!options.noglobstar && pattern === '**') return GLOBSTAR
	  if (pattern === '') return ''
	
	  var re = ''
	  var hasMagic = !!options.nocase
	  var escaping = false
	  // ? => one single character
	  var patternListStack = []
	  var negativeLists = []
	  var stateChar
	  var inClass = false
	  var reClassStart = -1
	  var classStart = -1
	  // . and .. never match anything that doesn't start with .,
	  // even when options.dot is set.
	  var patternStart = pattern.charAt(0) === '.' ? '' // anything
	  // not (start or / followed by . or .. followed by / or end)
	  : options.dot ? '(?!(?:^|\\\/)\\.{1,2}(?:$|\\\/))'
	  : '(?!\\.)'
	  var self = this
	
	  function clearStateChar () {
	    if (stateChar) {
	      // we had some state-tracking character
	      // that wasn't consumed by this pass.
	      switch (stateChar) {
	        case '*':
	          re += star
	          hasMagic = true
	        break
	        case '?':
	          re += qmark
	          hasMagic = true
	        break
	        default:
	          re += '\\' + stateChar
	        break
	      }
	      self.debug('clearStateChar %j %j', stateChar, re)
	      stateChar = false
	    }
	  }
	
	  for (var i = 0, len = pattern.length, c
	    ; (i < len) && (c = pattern.charAt(i))
	    ; i++) {
	    this.debug('%s\t%s %s %j', pattern, i, re, c)
	
	    // skip over any that are escaped.
	    if (escaping && reSpecials[c]) {
	      re += '\\' + c
	      escaping = false
	      continue
	    }
	
	    switch (c) {
	      case '/':
	        // completely not allowed, even escaped.
	        // Should already be path-split by now.
	        return false
	
	      case '\\':
	        clearStateChar()
	        escaping = true
	      continue
	
	      // the various stateChar values
	      // for the "extglob" stuff.
	      case '?':
	      case '*':
	      case '+':
	      case '@':
	      case '!':
	        this.debug('%s\t%s %s %j <-- stateChar', pattern, i, re, c)
	
	        // all of those are literals inside a class, except that
	        // the glob [!a] means [^a] in regexp
	        if (inClass) {
	          this.debug('  in class')
	          if (c === '!' && i === classStart + 1) c = '^'
	          re += c
	          continue
	        }
	
	        // if we already have a stateChar, then it means
	        // that there was something like ** or +? in there.
	        // Handle the stateChar, then proceed with this one.
	        self.debug('call clearStateChar %j', stateChar)
	        clearStateChar()
	        stateChar = c
	        // if extglob is disabled, then +(asdf|foo) isn't a thing.
	        // just clear the statechar *now*, rather than even diving into
	        // the patternList stuff.
	        if (options.noext) clearStateChar()
	      continue
	
	      case '(':
	        if (inClass) {
	          re += '('
	          continue
	        }
	
	        if (!stateChar) {
	          re += '\\('
	          continue
	        }
	
	        patternListStack.push({
	          type: stateChar,
	          start: i - 1,
	          reStart: re.length,
	          open: plTypes[stateChar].open,
	          close: plTypes[stateChar].close
	        })
	        // negation is (?:(?!js)[^/]*)
	        re += stateChar === '!' ? '(?:(?!(?:' : '(?:'
	        this.debug('plType %j %j', stateChar, re)
	        stateChar = false
	      continue
	
	      case ')':
	        if (inClass || !patternListStack.length) {
	          re += '\\)'
	          continue
	        }
	
	        clearStateChar()
	        hasMagic = true
	        var pl = patternListStack.pop()
	        // negation is (?:(?!js)[^/]*)
	        // The others are (?:<pattern>)<type>
	        re += pl.close
	        if (pl.type === '!') {
	          negativeLists.push(pl)
	        }
	        pl.reEnd = re.length
	      continue
	
	      case '|':
	        if (inClass || !patternListStack.length || escaping) {
	          re += '\\|'
	          escaping = false
	          continue
	        }
	
	        clearStateChar()
	        re += '|'
	      continue
	
	      // these are mostly the same in regexp and glob
	      case '[':
	        // swallow any state-tracking char before the [
	        clearStateChar()
	
	        if (inClass) {
	          re += '\\' + c
	          continue
	        }
	
	        inClass = true
	        classStart = i
	        reClassStart = re.length
	        re += c
	      continue
	
	      case ']':
	        //  a right bracket shall lose its special
	        //  meaning and represent itself in
	        //  a bracket expression if it occurs
	        //  first in the list.  -- POSIX.2 2.8.3.2
	        if (i === classStart + 1 || !inClass) {
	          re += '\\' + c
	          escaping = false
	          continue
	        }
	
	        // handle the case where we left a class open.
	        // "[z-a]" is valid, equivalent to "\[z-a\]"
	        if (inClass) {
	          // split where the last [ was, make sure we don't have
	          // an invalid re. if so, re-walk the contents of the
	          // would-be class to re-translate any characters that
	          // were passed through as-is
	          // TODO: It would probably be faster to determine this
	          // without a try/catch and a new RegExp, but it's tricky
	          // to do safely.  For now, this is safe and works.
	          var cs = pattern.substring(classStart + 1, i)
	          try {
	            RegExp('[' + cs + ']')
	          } catch (er) {
	            // not a valid class!
	            var sp = this.parse(cs, SUBPARSE)
	            re = re.substr(0, reClassStart) + '\\[' + sp[0] + '\\]'
	            hasMagic = hasMagic || sp[1]
	            inClass = false
	            continue
	          }
	        }
	
	        // finish up the class.
	        hasMagic = true
	        inClass = false
	        re += c
	      continue
	
	      default:
	        // swallow any state char that wasn't consumed
	        clearStateChar()
	
	        if (escaping) {
	          // no need
	          escaping = false
	        } else if (reSpecials[c]
	          && !(c === '^' && inClass)) {
	          re += '\\'
	        }
	
	        re += c
	
	    } // switch
	  } // for
	
	  // handle the case where we left a class open.
	  // "[abc" is valid, equivalent to "\[abc"
	  if (inClass) {
	    // split where the last [ was, and escape it
	    // this is a huge pita.  We now have to re-walk
	    // the contents of the would-be class to re-translate
	    // any characters that were passed through as-is
	    cs = pattern.substr(classStart + 1)
	    sp = this.parse(cs, SUBPARSE)
	    re = re.substr(0, reClassStart) + '\\[' + sp[0]
	    hasMagic = hasMagic || sp[1]
	  }
	
	  // handle the case where we had a +( thing at the *end*
	  // of the pattern.
	  // each pattern list stack adds 3 chars, and we need to go through
	  // and escape any | chars that were passed through as-is for the regexp.
	  // Go through and escape them, taking care not to double-escape any
	  // | chars that were already escaped.
	  for (pl = patternListStack.pop(); pl; pl = patternListStack.pop()) {
	    var tail = re.slice(pl.reStart + pl.open.length)
	    this.debug('setting tail', re, pl)
	    // maybe some even number of \, then maybe 1 \, followed by a |
	    tail = tail.replace(/((?:\\{2}){0,64})(\\?)\|/g, function (_, $1, $2) {
	      if (!$2) {
	        // the | isn't already escaped, so escape it.
	        $2 = '\\'
	      }
	
	      // need to escape all those slashes *again*, without escaping the
	      // one that we need for escaping the | character.  As it works out,
	      // escaping an even number of slashes can be done by simply repeating
	      // it exactly after itself.  That's why this trick works.
	      //
	      // I am sorry that you have to see this.
	      return $1 + $1 + $2 + '|'
	    })
	
	    this.debug('tail=%j\n   %s', tail, tail, pl, re)
	    var t = pl.type === '*' ? star
	      : pl.type === '?' ? qmark
	      : '\\' + pl.type
	
	    hasMagic = true
	    re = re.slice(0, pl.reStart) + t + '\\(' + tail
	  }
	
	  // handle trailing things that only matter at the very end.
	  clearStateChar()
	  if (escaping) {
	    // trailing \\
	    re += '\\\\'
	  }
	
	  // only need to apply the nodot start if the re starts with
	  // something that could conceivably capture a dot
	  var addPatternStart = false
	  switch (re.charAt(0)) {
	    case '.':
	    case '[':
	    case '(': addPatternStart = true
	  }
	
	  // Hack to work around lack of negative lookbehind in JS
	  // A pattern like: *.!(x).!(y|z) needs to ensure that a name
	  // like 'a.xyz.yz' doesn't match.  So, the first negative
	  // lookahead, has to look ALL the way ahead, to the end of
	  // the pattern.
	  for (var n = negativeLists.length - 1; n > -1; n--) {
	    var nl = negativeLists[n]
	
	    var nlBefore = re.slice(0, nl.reStart)
	    var nlFirst = re.slice(nl.reStart, nl.reEnd - 8)
	    var nlLast = re.slice(nl.reEnd - 8, nl.reEnd)
	    var nlAfter = re.slice(nl.reEnd)
	
	    nlLast += nlAfter
	
	    // Handle nested stuff like *(*.js|!(*.json)), where open parens
	    // mean that we should *not* include the ) in the bit that is considered
	    // "after" the negated section.
	    var openParensBefore = nlBefore.split('(').length - 1
	    var cleanAfter = nlAfter
	    for (i = 0; i < openParensBefore; i++) {
	      cleanAfter = cleanAfter.replace(/\)[+*?]?/, '')
	    }
	    nlAfter = cleanAfter
	
	    var dollar = ''
	    if (nlAfter === '' && isSub !== SUBPARSE) {
	      dollar = '$'
	    }
	    var newRe = nlBefore + nlFirst + nlAfter + dollar + nlLast
	    re = newRe
	  }
	
	  // if the re is not "" at this point, then we need to make sure
	  // it doesn't match against an empty path part.
	  // Otherwise a/* will match a/, which it should not.
	  if (re !== '' && hasMagic) {
	    re = '(?=.)' + re
	  }
	
	  if (addPatternStart) {
	    re = patternStart + re
	  }
	
	  // parsing just a piece of a larger pattern.
	  if (isSub === SUBPARSE) {
	    return [re, hasMagic]
	  }
	
	  // skip the regexp for non-magical patterns
	  // unescape anything in it, though, so that it'll be
	  // an exact match against a file etc.
	  if (!hasMagic) {
	    return globUnescape(pattern)
	  }
	
	  var flags = options.nocase ? 'i' : ''
	  try {
	    var regExp = new RegExp('^' + re + '$', flags)
	  } catch (er) {
	    // If it was an invalid regular expression, then it can't match
	    // anything.  This trick looks for a character after the end of
	    // the string, which is of course impossible, except in multi-line
	    // mode, but it's not a /m regex.
	    return new RegExp('$.')
	  }
	
	  regExp._glob = pattern
	  regExp._src = re
	
	  return regExp
	}
	
	minimatch.makeRe = function (pattern, options) {
	  return new Minimatch(pattern, options || {}).makeRe()
	}
	
	Minimatch.prototype.makeRe = makeRe
	function makeRe () {
	  if (this.regexp || this.regexp === false) return this.regexp
	
	  // at this point, this.set is a 2d array of partial
	  // pattern strings, or "**".
	  //
	  // It's better to use .match().  This function shouldn't
	  // be used, really, but it's pretty convenient sometimes,
	  // when you just want to work with a regex.
	  var set = this.set
	
	  if (!set.length) {
	    this.regexp = false
	    return this.regexp
	  }
	  var options = this.options
	
	  var twoStar = options.noglobstar ? star
	    : options.dot ? twoStarDot
	    : twoStarNoDot
	  var flags = options.nocase ? 'i' : ''
	
	  var re = set.map(function (pattern) {
	    return pattern.map(function (p) {
	      return (p === GLOBSTAR) ? twoStar
	      : (typeof p === 'string') ? regExpEscape(p)
	      : p._src
	    }).join('\\\/')
	  }).join('|')
	
	  // must match entire pattern
	  // ending in a * or ** will make it less strict.
	  re = '^(?:' + re + ')$'
	
	  // can match anything, as long as it's not this.
	  if (this.negate) re = '^(?!' + re + ').*$'
	
	  try {
	    this.regexp = new RegExp(re, flags)
	  } catch (ex) {
	    this.regexp = false
	  }
	  return this.regexp
	}
	
	minimatch.match = function (list, pattern, options) {
	  options = options || {}
	  var mm = new Minimatch(pattern, options)
	  list = list.filter(function (f) {
	    return mm.match(f)
	  })
	  if (mm.options.nonull && !list.length) {
	    list.push(pattern)
	  }
	  return list
	}
	
	Minimatch.prototype.match = match
	function match (f, partial) {
	  this.debug('match', f, this.pattern)
	  // short-circuit in the case of busted things.
	  // comments, etc.
	  if (this.comment) return false
	  if (this.empty) return f === ''
	
	  if (f === '/' && partial) return true
	
	  var options = this.options
	
	  // windows: need to use /, not \
	  if (path.sep !== '/') {
	    f = f.split(path.sep).join('/')
	  }
	
	  // treat the test path as a set of pathparts.
	  f = f.split(slashSplit)
	  this.debug(this.pattern, 'split', f)
	
	  // just ONE of the pattern sets in this.set needs to match
	  // in order for it to be valid.  If negating, then just one
	  // match means that we have failed.
	  // Either way, return on the first hit.
	
	  var set = this.set
	  this.debug(this.pattern, 'set', set)
	
	  // Find the basename of the path by looking for the last non-empty segment
	  var filename
	  var i
	  for (i = f.length - 1; i >= 0; i--) {
	    filename = f[i]
	    if (filename) break
	  }
	
	  for (i = 0; i < set.length; i++) {
	    var pattern = set[i]
	    var file = f
	    if (options.matchBase && pattern.length === 1) {
	      file = [filename]
	    }
	    var hit = this.matchOne(file, pattern, partial)
	    if (hit) {
	      if (options.flipNegate) return true
	      return !this.negate
	    }
	  }
	
	  // didn't get any hits.  this is success if it's a negative
	  // pattern, failure otherwise.
	  if (options.flipNegate) return false
	  return this.negate
	}
	
	// set partial to true to test if, for example,
	// "/a/b" matches the start of "/*/b/*/d"
	// Partial means, if you run out of file before you run
	// out of pattern, then that's fine, as long as all
	// the parts match.
	Minimatch.prototype.matchOne = function (file, pattern, partial) {
	  var options = this.options
	
	  this.debug('matchOne',
	    { 'this': this, file: file, pattern: pattern })
	
	  this.debug('matchOne', file.length, pattern.length)
	
	  for (var fi = 0,
	      pi = 0,
	      fl = file.length,
	      pl = pattern.length
	      ; (fi < fl) && (pi < pl)
	      ; fi++, pi++) {
	    this.debug('matchOne loop')
	    var p = pattern[pi]
	    var f = file[fi]
	
	    this.debug(pattern, p, f)
	
	    // should be impossible.
	    // some invalid regexp stuff in the set.
	    if (p === false) return false
	
	    if (p === GLOBSTAR) {
	      this.debug('GLOBSTAR', [pattern, p, f])
	
	      // "**"
	      // a/**/b/**/c would match the following:
	      // a/b/x/y/z/c
	      // a/x/y/z/b/c
	      // a/b/x/b/x/c
	      // a/b/c
	      // To do this, take the rest of the pattern after
	      // the **, and see if it would match the file remainder.
	      // If so, return success.
	      // If not, the ** "swallows" a segment, and try again.
	      // This is recursively awful.
	      //
	      // a/**/b/**/c matching a/b/x/y/z/c
	      // - a matches a
	      // - doublestar
	      //   - matchOne(b/x/y/z/c, b/**/c)
	      //     - b matches b
	      //     - doublestar
	      //       - matchOne(x/y/z/c, c) -> no
	      //       - matchOne(y/z/c, c) -> no
	      //       - matchOne(z/c, c) -> no
	      //       - matchOne(c, c) yes, hit
	      var fr = fi
	      var pr = pi + 1
	      if (pr === pl) {
	        this.debug('** at the end')
	        // a ** at the end will just swallow the rest.
	        // We have found a match.
	        // however, it will not swallow /.x, unless
	        // options.dot is set.
	        // . and .. are *never* matched by **, for explosively
	        // exponential reasons.
	        for (; fi < fl; fi++) {
	          if (file[fi] === '.' || file[fi] === '..' ||
	            (!options.dot && file[fi].charAt(0) === '.')) return false
	        }
	        return true
	      }
	
	      // ok, let's see if we can swallow whatever we can.
	      while (fr < fl) {
	        var swallowee = file[fr]
	
	        this.debug('\nglobstar while', file, fr, pattern, pr, swallowee)
	
	        // XXX remove this slice.  Just pass the start index.
	        if (this.matchOne(file.slice(fr), pattern.slice(pr), partial)) {
	          this.debug('globstar found match!', fr, fl, swallowee)
	          // found a match.
	          return true
	        } else {
	          // can't swallow "." or ".." ever.
	          // can only swallow ".foo" when explicitly asked.
	          if (swallowee === '.' || swallowee === '..' ||
	            (!options.dot && swallowee.charAt(0) === '.')) {
	            this.debug('dot detected!', file, fr, pattern, pr)
	            break
	          }
	
	          // ** swallows a segment, and continue.
	          this.debug('globstar swallow a segment, and continue')
	          fr++
	        }
	      }
	
	      // no match was found.
	      // However, in partial mode, we can't say this is necessarily over.
	      // If there's more *pattern* left, then
	      if (partial) {
	        // ran out of file
	        this.debug('\n>>> no match, partial?', file, fr, pattern, pr)
	        if (fr === fl) return true
	      }
	      return false
	    }
	
	    // something other than **
	    // non-magic patterns just have to match exactly
	    // patterns with magic have been turned into regexps.
	    var hit
	    if (typeof p === 'string') {
	      if (options.nocase) {
	        hit = f.toLowerCase() === p.toLowerCase()
	      } else {
	        hit = f === p
	      }
	      this.debug('string match', p, f, hit)
	    } else {
	      hit = f.match(p)
	      this.debug('pattern match', p, f, hit)
	    }
	
	    if (!hit) return false
	  }
	
	  // Note: ending in / means that we'll get a final ""
	  // at the end of the pattern.  This can only match a
	  // corresponding "" at the end of the file.
	  // If the file ends in /, then it can only match a
	  // a pattern that ends in /, unless the pattern just
	  // doesn't have any more for it. But, a/b/ should *not*
	  // match "a/b/*", even though "" matches against the
	  // [^/]*? pattern, except in partial mode, where it might
	  // simply not be reached yet.
	  // However, a/b/ should still satisfy a/*
	
	  // now either we fell off the end of the pattern, or we're done.
	  if (fi === fl && pi === pl) {
	    // ran out of pattern and filename at the same time.
	    // an exact hit!
	    return true
	  } else if (fi === fl) {
	    // ran out of file, but still had pattern left.
	    // this is ok if we're doing the match as part of
	    // a glob fs traversal.
	    return partial
	  } else if (pi === pl) {
	    // ran out of pattern, still have file left.
	    // this is only acceptable if we're on the very last
	    // empty segment of a file with a trailing slash.
	    // a/* should match a/b/
	    var emptyFileEnd = (fi === fl - 1) && (file[fi] === '')
	    return emptyFileEnd
	  }
	
	  // should be unreachable.
	  throw new Error('wtf?')
	}
	
	// replace stuff like \* with *
	function globUnescape (s) {
	  return s.replace(/\\(.)/g, '$1')
	}
	
	function regExpEscape (s) {
	  return s.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&')
	}


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(455);


/***/ }),
/* 452 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ExecutionEnvironment
	 */
	
	/*jslint evil: true */
	
	'use strict';
	
	var canUseDOM = !!(
	  typeof window !== 'undefined' &&
	  window.document &&
	  window.document.createElement
	);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners:
	    canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;


/***/ }),
/* 453 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2004-present Facebook. All Rights Reserved.
	 *
	 * @providesModule UserAgent_DEPRECATED
	 */
	
	/**
	 *  Provides entirely client-side User Agent and OS detection. You should prefer
	 *  the non-deprecated UserAgent module when possible, which exposes our
	 *  authoritative server-side PHP-based detection to the client.
	 *
	 *  Usage is straightforward:
	 *
	 *    if (UserAgent_DEPRECATED.ie()) {
	 *      //  IE
	 *    }
	 *
	 *  You can also do version checks:
	 *
	 *    if (UserAgent_DEPRECATED.ie() >= 7) {
	 *      //  IE7 or better
	 *    }
	 *
	 *  The browser functions will return NaN if the browser does not match, so
	 *  you can also do version compares the other way:
	 *
	 *    if (UserAgent_DEPRECATED.ie() < 7) {
	 *      //  IE6 or worse
	 *    }
	 *
	 *  Note that the version is a float and may include a minor version number,
	 *  so you should always use range operators to perform comparisons, not
	 *  strict equality.
	 *
	 *  **Note:** You should **strongly** prefer capability detection to browser
	 *  version detection where it's reasonable:
	 *
	 *    http://www.quirksmode.org/js/support.html
	 *
	 *  Further, we have a large number of mature wrapper functions and classes
	 *  which abstract away many browser irregularities. Check the documentation,
	 *  grep for things, or ask on javascript@lists.facebook.com before writing yet
	 *  another copy of "event || window.event".
	 *
	 */
	
	var _populated = false;
	
	// Browsers
	var _ie, _firefox, _opera, _webkit, _chrome;
	
	// Actual IE browser for compatibility mode
	var _ie_real_version;
	
	// Platforms
	var _osx, _windows, _linux, _android;
	
	// Architectures
	var _win64;
	
	// Devices
	var _iphone, _ipad, _native;
	
	var _mobile;
	
	function _populate() {
	  if (_populated) {
	    return;
	  }
	
	  _populated = true;
	
	  // To work around buggy JS libraries that can't handle multi-digit
	  // version numbers, Opera 10's user agent string claims it's Opera
	  // 9, then later includes a Version/X.Y field:
	  //
	  // Opera/9.80 (foo) Presto/2.2.15 Version/10.10
	  var uas = navigator.userAgent;
	  var agent = /(?:MSIE.(\d+\.\d+))|(?:(?:Firefox|GranParadiso|Iceweasel).(\d+\.\d+))|(?:Opera(?:.+Version.|.)(\d+\.\d+))|(?:AppleWebKit.(\d+(?:\.\d+)?))|(?:Trident\/\d+\.\d+.*rv:(\d+\.\d+))/.exec(uas);
	  var os    = /(Mac OS X)|(Windows)|(Linux)/.exec(uas);
	
	  _iphone = /\b(iPhone|iP[ao]d)/.exec(uas);
	  _ipad = /\b(iP[ao]d)/.exec(uas);
	  _android = /Android/i.exec(uas);
	  _native = /FBAN\/\w+;/i.exec(uas);
	  _mobile = /Mobile/i.exec(uas);
	
	  // Note that the IE team blog would have you believe you should be checking
	  // for 'Win64; x64'.  But MSDN then reveals that you can actually be coming
	  // from either x64 or ia64;  so ultimately, you should just check for Win64
	  // as in indicator of whether you're in 64-bit IE.  32-bit IE on 64-bit
	  // Windows will send 'WOW64' instead.
	  _win64 = !!(/Win64/.exec(uas));
	
	  if (agent) {
	    _ie = agent[1] ? parseFloat(agent[1]) : (
	          agent[5] ? parseFloat(agent[5]) : NaN);
	    // IE compatibility mode
	    if (_ie && document && document.documentMode) {
	      _ie = document.documentMode;
	    }
	    // grab the "true" ie version from the trident token if available
	    var trident = /(?:Trident\/(\d+.\d+))/.exec(uas);
	    _ie_real_version = trident ? parseFloat(trident[1]) + 4 : _ie;
	
	    _firefox = agent[2] ? parseFloat(agent[2]) : NaN;
	    _opera   = agent[3] ? parseFloat(agent[3]) : NaN;
	    _webkit  = agent[4] ? parseFloat(agent[4]) : NaN;
	    if (_webkit) {
	      // We do not add the regexp to the above test, because it will always
	      // match 'safari' only since 'AppleWebKit' appears before 'Chrome' in
	      // the userAgent string.
	      agent = /(?:Chrome\/(\d+\.\d+))/.exec(uas);
	      _chrome = agent && agent[1] ? parseFloat(agent[1]) : NaN;
	    } else {
	      _chrome = NaN;
	    }
	  } else {
	    _ie = _firefox = _opera = _chrome = _webkit = NaN;
	  }
	
	  if (os) {
	    if (os[1]) {
	      // Detect OS X version.  If no version number matches, set _osx to true.
	      // Version examples:  10, 10_6_1, 10.7
	      // Parses version number as a float, taking only first two sets of
	      // digits.  If only one set of digits is found, returns just the major
	      // version number.
	      var ver = /(?:Mac OS X (\d+(?:[._]\d+)?))/.exec(uas);
	
	      _osx = ver ? parseFloat(ver[1].replace('_', '.')) : true;
	    } else {
	      _osx = false;
	    }
	    _windows = !!os[2];
	    _linux   = !!os[3];
	  } else {
	    _osx = _windows = _linux = false;
	  }
	}
	
	var UserAgent_DEPRECATED = {
	
	  /**
	   *  Check if the UA is Internet Explorer.
	   *
	   *
	   *  @return float|NaN Version number (if match) or NaN.
	   */
	  ie: function() {
	    return _populate() || _ie;
	  },
	
	  /**
	   * Check if we're in Internet Explorer compatibility mode.
	   *
	   * @return bool true if in compatibility mode, false if
	   * not compatibility mode or not ie
	   */
	  ieCompatibilityMode: function() {
	    return _populate() || (_ie_real_version > _ie);
	  },
	
	
	  /**
	   * Whether the browser is 64-bit IE.  Really, this is kind of weak sauce;  we
	   * only need this because Skype can't handle 64-bit IE yet.  We need to remove
	   * this when we don't need it -- tracked by #601957.
	   */
	  ie64: function() {
	    return UserAgent_DEPRECATED.ie() && _win64;
	  },
	
	  /**
	   *  Check if the UA is Firefox.
	   *
	   *
	   *  @return float|NaN Version number (if match) or NaN.
	   */
	  firefox: function() {
	    return _populate() || _firefox;
	  },
	
	
	  /**
	   *  Check if the UA is Opera.
	   *
	   *
	   *  @return float|NaN Version number (if match) or NaN.
	   */
	  opera: function() {
	    return _populate() || _opera;
	  },
	
	
	  /**
	   *  Check if the UA is WebKit.
	   *
	   *
	   *  @return float|NaN Version number (if match) or NaN.
	   */
	  webkit: function() {
	    return _populate() || _webkit;
	  },
	
	  /**
	   *  For Push
	   *  WILL BE REMOVED VERY SOON. Use UserAgent_DEPRECATED.webkit
	   */
	  safari: function() {
	    return UserAgent_DEPRECATED.webkit();
	  },
	
	  /**
	   *  Check if the UA is a Chrome browser.
	   *
	   *
	   *  @return float|NaN Version number (if match) or NaN.
	   */
	  chrome : function() {
	    return _populate() || _chrome;
	  },
	
	
	  /**
	   *  Check if the user is running Windows.
	   *
	   *  @return bool `true' if the user's OS is Windows.
	   */
	  windows: function() {
	    return _populate() || _windows;
	  },
	
	
	  /**
	   *  Check if the user is running Mac OS X.
	   *
	   *  @return float|bool   Returns a float if a version number is detected,
	   *                       otherwise true/false.
	   */
	  osx: function() {
	    return _populate() || _osx;
	  },
	
	  /**
	   * Check if the user is running Linux.
	   *
	   * @return bool `true' if the user's OS is some flavor of Linux.
	   */
	  linux: function() {
	    return _populate() || _linux;
	  },
	
	  /**
	   * Check if the user is running on an iPhone or iPod platform.
	   *
	   * @return bool `true' if the user is running some flavor of the
	   *    iPhone OS.
	   */
	  iphone: function() {
	    return _populate() || _iphone;
	  },
	
	  mobile: function() {
	    return _populate() || (_iphone || _ipad || _android || _mobile);
	  },
	
	  nativeApp: function() {
	    // webviews inside of the native apps
	    return _populate() || _native;
	  },
	
	  android: function() {
	    return _populate() || _android;
	  },
	
	  ipad: function() {
	    return _populate() || _ipad;
	  }
	};
	
	module.exports = UserAgent_DEPRECATED;


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isEventSupported
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(452);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature =
	    document.implementation &&
	    document.implementation.hasFeature &&
	    // always returns true in newer browsers as per the standard.
	    // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	    document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM ||
	      capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule normalizeWheel
	 * @typechecks
	 */
	
	'use strict';
	
	var UserAgent_DEPRECATED = __webpack_require__(453);
	
	var isEventSupported = __webpack_require__(454);
	
	
	// Reasonable defaults
	var PIXEL_STEP  = 10;
	var LINE_HEIGHT = 40;
	var PAGE_HEIGHT = 800;
	
	/**
	 * Mouse wheel (and 2-finger trackpad) support on the web sucks.  It is
	 * complicated, thus this doc is long and (hopefully) detailed enough to answer
	 * your questions.
	 *
	 * If you need to react to the mouse wheel in a predictable way, this code is
	 * like your bestest friend. * hugs *
	 *
	 * As of today, there are 4 DOM event types you can listen to:
	 *
	 *   'wheel'                -- Chrome(31+), FF(17+), IE(9+)
	 *   'mousewheel'           -- Chrome, IE(6+), Opera, Safari
	 *   'MozMousePixelScroll'  -- FF(3.5 only!) (2010-2013) -- don't bother!
	 *   'DOMMouseScroll'       -- FF(0.9.7+) since 2003
	 *
	 * So what to do?  The is the best:
	 *
	 *   normalizeWheel.getEventType();
	 *
	 * In your event callback, use this code to get sane interpretation of the
	 * deltas.  This code will return an object with properties:
	 *
	 *   spinX   -- normalized spin speed (use for zoom) - x plane
	 *   spinY   -- " - y plane
	 *   pixelX  -- normalized distance (to pixels) - x plane
	 *   pixelY  -- " - y plane
	 *
	 * Wheel values are provided by the browser assuming you are using the wheel to
	 * scroll a web page by a number of lines or pixels (or pages).  Values can vary
	 * significantly on different platforms and browsers, forgetting that you can
	 * scroll at different speeds.  Some devices (like trackpads) emit more events
	 * at smaller increments with fine granularity, and some emit massive jumps with
	 * linear speed or acceleration.
	 *
	 * This code does its best to normalize the deltas for you:
	 *
	 *   - spin is trying to normalize how far the wheel was spun (or trackpad
	 *     dragged).  This is super useful for zoom support where you want to
	 *     throw away the chunky scroll steps on the PC and make those equal to
	 *     the slow and smooth tiny steps on the Mac. Key data: This code tries to
	 *     resolve a single slow step on a wheel to 1.
	 *
	 *   - pixel is normalizing the desired scroll delta in pixel units.  You'll
	 *     get the crazy differences between browsers, but at least it'll be in
	 *     pixels!
	 *
	 *   - positive value indicates scrolling DOWN/RIGHT, negative UP/LEFT.  This
	 *     should translate to positive value zooming IN, negative zooming OUT.
	 *     This matches the newer 'wheel' event.
	 *
	 * Why are there spinX, spinY (or pixels)?
	 *
	 *   - spinX is a 2-finger side drag on the trackpad, and a shift + wheel turn
	 *     with a mouse.  It results in side-scrolling in the browser by default.
	 *
	 *   - spinY is what you expect -- it's the classic axis of a mouse wheel.
	 *
	 *   - I dropped spinZ/pixelZ.  It is supported by the DOM 3 'wheel' event and
	 *     probably is by browsers in conjunction with fancy 3D controllers .. but
	 *     you know.
	 *
	 * Implementation info:
	 *
	 * Examples of 'wheel' event if you scroll slowly (down) by one step with an
	 * average mouse:
	 *
	 *   OS X + Chrome  (mouse)     -    4   pixel delta  (wheelDelta -120)
	 *   OS X + Safari  (mouse)     -  N/A   pixel delta  (wheelDelta  -12)
	 *   OS X + Firefox (mouse)     -    0.1 line  delta  (wheelDelta  N/A)
	 *   Win8 + Chrome  (mouse)     -  100   pixel delta  (wheelDelta -120)
	 *   Win8 + Firefox (mouse)     -    3   line  delta  (wheelDelta -120)
	 *
	 * On the trackpad:
	 *
	 *   OS X + Chrome  (trackpad)  -    2   pixel delta  (wheelDelta   -6)
	 *   OS X + Firefox (trackpad)  -    1   pixel delta  (wheelDelta  N/A)
	 *
	 * On other/older browsers.. it's more complicated as there can be multiple and
	 * also missing delta values.
	 *
	 * The 'wheel' event is more standard:
	 *
	 * http://www.w3.org/TR/DOM-Level-3-Events/#events-wheelevents
	 *
	 * The basics is that it includes a unit, deltaMode (pixels, lines, pages), and
	 * deltaX, deltaY and deltaZ.  Some browsers provide other values to maintain
	 * backward compatibility with older events.  Those other values help us
	 * better normalize spin speed.  Example of what the browsers provide:
	 *
	 *                          | event.wheelDelta | event.detail
	 *        ------------------+------------------+--------------
	 *          Safari v5/OS X  |       -120       |       0
	 *          Safari v5/Win7  |       -120       |       0
	 *         Chrome v17/OS X  |       -120       |       0
	 *         Chrome v17/Win7  |       -120       |       0
	 *                IE9/Win7  |       -120       |   undefined
	 *         Firefox v4/OS X  |     undefined    |       1
	 *         Firefox v4/Win7  |     undefined    |       3
	 *
	 */
	function normalizeWheel(/*object*/ event) /*object*/ {
	  var sX = 0, sY = 0,       // spinX, spinY
	      pX = 0, pY = 0;       // pixelX, pixelY
	
	  // Legacy
	  if ('detail'      in event) { sY = event.detail; }
	  if ('wheelDelta'  in event) { sY = -event.wheelDelta / 120; }
	  if ('wheelDeltaY' in event) { sY = -event.wheelDeltaY / 120; }
	  if ('wheelDeltaX' in event) { sX = -event.wheelDeltaX / 120; }
	
	  // side scrolling on FF with DOMMouseScroll
	  if ( 'axis' in event && event.axis === event.HORIZONTAL_AXIS ) {
	    sX = sY;
	    sY = 0;
	  }
	
	  pX = sX * PIXEL_STEP;
	  pY = sY * PIXEL_STEP;
	
	  if ('deltaY' in event) { pY = event.deltaY; }
	  if ('deltaX' in event) { pX = event.deltaX; }
	
	  if ((pX || pY) && event.deltaMode) {
	    if (event.deltaMode == 1) {          // delta in LINE units
	      pX *= LINE_HEIGHT;
	      pY *= LINE_HEIGHT;
	    } else {                             // delta in PAGE units
	      pX *= PAGE_HEIGHT;
	      pY *= PAGE_HEIGHT;
	    }
	  }
	
	  // Fall-back if spin cannot be determined
	  if (pX && !sX) { sX = (pX < 1) ? -1 : 1; }
	  if (pY && !sY) { sY = (pY < 1) ? -1 : 1; }
	
	  return { spinX  : sX,
	           spinY  : sY,
	           pixelX : pX,
	           pixelY : pY };
	}
	
	
	/**
	 * The best combination if you prefer spinX + spinY normalization.  It favors
	 * the older DOMMouseScroll for Firefox, as FF does not include wheelDelta with
	 * 'wheel' event, making spin speed determination impossible.
	 */
	normalizeWheel.getEventType = function() /*string*/ {
	  return (UserAgent_DEPRECATED.firefox())
	           ? 'DOMMouseScroll'
	           : (isEventSupported('wheel'))
	               ? 'wheel'
	               : 'mousewheel';
	};
	
	module.exports = normalizeWheel;


/***/ }),
/* 456 */
/***/ (function(module, exports) {

	// ::- Persistent data structure representing an ordered mapping from
	// strings to values, with some convenient update methods.
	function OrderedMap(content) {
	  this.content = content
	}
	
	OrderedMap.prototype = {
	  constructor: OrderedMap,
	
	  find: function(key) {
	    for (var i = 0; i < this.content.length; i += 2)
	      if (this.content[i] === key) return i
	    return -1
	  },
	
	  // :: (string) → ?any
	  // Retrieve the value stored under `key`, or return undefined when
	  // no such key exists.
	  get: function(key) {
	    var found = this.find(key)
	    return found == -1 ? undefined : this.content[found + 1]
	  },
	
	  // :: (string, any, ?string) → OrderedMap
	  // Create a new map by replacing the value of `key` with a new
	  // value, or adding a binding to the end of the map. If `newKey` is
	  // given, the key of the binding will be replaced with that key.
	  update: function(key, value, newKey) {
	    var self = newKey && newKey != key ? this.remove(newKey) : this
	    var found = self.find(key), content = self.content.slice()
	    if (found == -1) {
	      content.push(newKey || key, value)
	    } else {
	      content[found + 1] = value
	      if (newKey) content[found] = newKey
	    }
	    return new OrderedMap(content)
	  },
	
	  // :: (string) → OrderedMap
	  // Return a map with the given key removed, if it existed.
	  remove: function(key) {
	    var found = this.find(key)
	    if (found == -1) return this
	    var content = this.content.slice()
	    content.splice(found, 2)
	    return new OrderedMap(content)
	  },
	
	  // :: (string, any) → OrderedMap
	  // Add a new key to the start of the map.
	  addToStart: function(key, value) {
	    return new OrderedMap([key, value].concat(this.remove(key).content))
	  },
	
	  // :: (string, any) → OrderedMap
	  // Add a new key to the end of the map.
	  addToEnd: function(key, value) {
	    var content = this.remove(key).content.slice()
	    content.push(key, value)
	    return new OrderedMap(content)
	  },
	
	  // :: (string, string, any) → OrderedMap
	  // Add a key after the given key. If `place` is not found, the new
	  // key is added to the end.
	  addBefore: function(place, key, value) {
	    var without = this.remove(key), content = without.content.slice()
	    var found = without.find(place)
	    content.splice(found == -1 ? content.length : found, 0, key, value)
	    return new OrderedMap(content)
	  },
	
	  // :: ((key: string, value: any))
	  // Call the given function for each key/value pair in the map, in
	  // order.
	  forEach: function(f) {
	    for (var i = 0; i < this.content.length; i += 2)
	      f(this.content[i], this.content[i + 1])
	  },
	
	  // :: (union<Object, OrderedMap>) → OrderedMap
	  // Create a new map by prepending the keys in this map that don't
	  // appear in `map` before the keys in `map`.
	  prepend: function(map) {
	    map = OrderedMap.from(map)
	    if (!map.size) return this
	    return new OrderedMap(map.content.concat(this.subtract(map).content))
	  },
	
	  // :: (union<Object, OrderedMap>) → OrderedMap
	  // Create a new map by appending the keys in this map that don't
	  // appear in `map` after the keys in `map`.
	  append: function(map) {
	    map = OrderedMap.from(map)
	    if (!map.size) return this
	    return new OrderedMap(this.subtract(map).content.concat(map.content))
	  },
	
	  // :: (union<Object, OrderedMap>) → OrderedMap
	  // Create a map containing all the keys in this map that don't
	  // appear in `map`.
	  subtract: function(map) {
	    var result = this
	    map = OrderedMap.from(map)
	    for (var i = 0; i < map.content.length; i += 2)
	      result = result.remove(map.content[i])
	    return result
	  },
	
	  // :: number
	  // The amount of keys in this map.
	  get size() {
	    return this.content.length >> 1
	  }
	}
	
	// :: (?union<Object, OrderedMap>) → OrderedMap
	// Return a map with the given content. If null, create an empty
	// map. If given an ordered map, return that map itself. If given an
	// object, create a map from the object's properties.
	OrderedMap.from = function(value) {
	  if (value instanceof OrderedMap) return value
	  var content = []
	  if (value) for (var prop in value) content.push(prop, value[prop])
	  return new OrderedMap(content)
	}
	
	module.exports = OrderedMap


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// resolves . and .. elements in a path array with directory names there
	// must be no slashes, empty elements, or device names (c:\) in the array
	// (so also no leading and trailing slashes - it does not distinguish
	// relative and absolute paths)
	function normalizeArray(parts, allowAboveRoot) {
	  // if the path tries to go above the root, `up` ends up > 0
	  var up = 0;
	  for (var i = parts.length - 1; i >= 0; i--) {
	    var last = parts[i];
	    if (last === '.') {
	      parts.splice(i, 1);
	    } else if (last === '..') {
	      parts.splice(i, 1);
	      up++;
	    } else if (up) {
	      parts.splice(i, 1);
	      up--;
	    }
	  }
	
	  // if the path is allowed to go above the root, restore leading ..s
	  if (allowAboveRoot) {
	    for (; up--; up) {
	      parts.unshift('..');
	    }
	  }
	
	  return parts;
	}
	
	// Split a filename into [root, dir, basename, ext], unix version
	// 'root' is just a slash, or nothing.
	var splitPathRe =
	    /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
	var splitPath = function(filename) {
	  return splitPathRe.exec(filename).slice(1);
	};
	
	// path.resolve([from ...], to)
	// posix version
	exports.resolve = function() {
	  var resolvedPath = '',
	      resolvedAbsolute = false;
	
	  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
	    var path = (i >= 0) ? arguments[i] : process.cwd();
	
	    // Skip empty and invalid entries
	    if (typeof path !== 'string') {
	      throw new TypeError('Arguments to path.resolve must be strings');
	    } else if (!path) {
	      continue;
	    }
	
	    resolvedPath = path + '/' + resolvedPath;
	    resolvedAbsolute = path.charAt(0) === '/';
	  }
	
	  // At this point the path should be resolved to a full absolute path, but
	  // handle relative paths to be safe (might happen when process.cwd() fails)
	
	  // Normalize the path
	  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
	    return !!p;
	  }), !resolvedAbsolute).join('/');
	
	  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
	};
	
	// path.normalize(path)
	// posix version
	exports.normalize = function(path) {
	  var isAbsolute = exports.isAbsolute(path),
	      trailingSlash = substr(path, -1) === '/';
	
	  // Normalize the path
	  path = normalizeArray(filter(path.split('/'), function(p) {
	    return !!p;
	  }), !isAbsolute).join('/');
	
	  if (!path && !isAbsolute) {
	    path = '.';
	  }
	  if (path && trailingSlash) {
	    path += '/';
	  }
	
	  return (isAbsolute ? '/' : '') + path;
	};
	
	// posix version
	exports.isAbsolute = function(path) {
	  return path.charAt(0) === '/';
	};
	
	// posix version
	exports.join = function() {
	  var paths = Array.prototype.slice.call(arguments, 0);
	  return exports.normalize(filter(paths, function(p, index) {
	    if (typeof p !== 'string') {
	      throw new TypeError('Arguments to path.join must be strings');
	    }
	    return p;
	  }).join('/'));
	};
	
	
	// path.relative(from, to)
	// posix version
	exports.relative = function(from, to) {
	  from = exports.resolve(from).substr(1);
	  to = exports.resolve(to).substr(1);
	
	  function trim(arr) {
	    var start = 0;
	    for (; start < arr.length; start++) {
	      if (arr[start] !== '') break;
	    }
	
	    var end = arr.length - 1;
	    for (; end >= 0; end--) {
	      if (arr[end] !== '') break;
	    }
	
	    if (start > end) return [];
	    return arr.slice(start, end - start + 1);
	  }
	
	  var fromParts = trim(from.split('/'));
	  var toParts = trim(to.split('/'));
	
	  var length = Math.min(fromParts.length, toParts.length);
	  var samePartsLength = length;
	  for (var i = 0; i < length; i++) {
	    if (fromParts[i] !== toParts[i]) {
	      samePartsLength = i;
	      break;
	    }
	  }
	
	  var outputParts = [];
	  for (var i = samePartsLength; i < fromParts.length; i++) {
	    outputParts.push('..');
	  }
	
	  outputParts = outputParts.concat(toParts.slice(samePartsLength));
	
	  return outputParts.join('/');
	};
	
	exports.sep = '/';
	exports.delimiter = ':';
	
	exports.dirname = function(path) {
	  var result = splitPath(path),
	      root = result[0],
	      dir = result[1];
	
	  if (!root && !dir) {
	    // No dirname whatsoever
	    return '.';
	  }
	
	  if (dir) {
	    // It has a dirname, strip trailing slash
	    dir = dir.substr(0, dir.length - 1);
	  }
	
	  return root + dir;
	};
	
	
	exports.basename = function(path, ext) {
	  var f = splitPath(path)[2];
	  // TODO: make this comparison case-insensitive on windows?
	  if (ext && f.substr(-1 * ext.length) === ext) {
	    f = f.substr(0, f.length - ext.length);
	  }
	  return f;
	};
	
	
	exports.extname = function(path) {
	  return splitPath(path)[3];
	};
	
	function filter (xs, f) {
	    if (xs.filter) return xs.filter(f);
	    var res = [];
	    for (var i = 0; i < xs.length; i++) {
	        if (f(xs[i], i, xs)) res.push(xs[i]);
	    }
	    return res;
	}
	
	// String.prototype.substr - negative index don't work in IE8
	var substr = 'ab'.substr(-1) === 'b'
	    ? function (str, start, len) { return str.substr(start, len) }
	    : function (str, start, len) {
	        if (start < 0) start = str.length + start;
	        return str.substr(start, len);
	    }
	;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(133)))

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = {
	  encode: __webpack_require__(460).encode,
	  decode: __webpack_require__(459).decode
	}


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	var require;var require;(function(f){if(true){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.plantumlEncoder = f()}})(function(){var define,module,exports;return (function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return require(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
	'use strict'
	
	var pako = require('pako/lib/inflate.js')
	
	module.exports = function (data) {
	  return pako.inflateRaw(data, { to: 'string' })
	}
	
	},{"pako/lib/inflate.js":4}],2:[function(require,module,exports){
	'use strict'
	
	// Reverse of
	// http://plantuml.sourceforge.net/codejavascript2.html
	
	// It is described as being "a transformation close to base64"
	// The code has been slightly modified to pass linters
	
	function decode6bit (cc) {
	  var c = cc.charCodeAt(0)
	  if (cc === '_') return 63
	  if (cc === '-') return 62
	  if (c >= 97) return c - 61 // - 97 + 26 + 10
	  if (c >= 65) return c - 55 // - 65 + 10
	  if (c >= 48) return c - 48
	  return '?'
	}
	
	function extract3bytes (data) {
	  var c1 = decode6bit(data[0])
	  var c2 = decode6bit(data[1])
	  var c3 = decode6bit(data[2])
	  var c4 = decode6bit(data[3])
	  var b1 = c1 << 2 | (c2 >> 4) & 0x3F
	  var b2 = (c2 << 4) & 0xF0 | (c3 >> 2) & 0xF
	  var b3 = (c3 << 6) & 0xC0 | c4 & 0x3F
	
	  return [b1, b2, b3]
	}
	
	module.exports = function (data) {
	  var r = ''
	  var i = 0
	  for (i = 0; i < data.length; i += 4) {
	    var t = extract3bytes(data.substring(i, i + 4))
	    r = r + String.fromCharCode(t[0])
	    r = r + String.fromCharCode(t[1])
	    r = r + String.fromCharCode(t[2])
	  }
	  return r
	}
	
	},{}],3:[function(require,module,exports){
	'use strict'
	
	var inflate = require('./inflate')
	var decode64 = require('./decode64')
	
	module.exports.decode = function (encoded) {
	  var deflated = decode64(encoded)
	  return inflate(deflated)
	}
	
	},{"./decode64":2,"./inflate":1}],4:[function(require,module,exports){
	'use strict';
	
	
	var zlib_inflate = require('./zlib/inflate');
	var utils        = require('./utils/common');
	var strings      = require('./utils/strings');
	var c            = require('./zlib/constants');
	var msg          = require('./zlib/messages');
	var ZStream      = require('./zlib/zstream');
	var GZheader     = require('./zlib/gzheader');
	
	var toString = Object.prototype.toString;
	
	/**
	 * class Inflate
	 *
	 * Generic JS-style wrapper for zlib calls. If you don't need
	 * streaming behaviour - use more simple functions: [[inflate]]
	 * and [[inflateRaw]].
	 **/
	
	/* internal
	 * inflate.chunks -> Array
	 *
	 * Chunks of output data, if [[Inflate#onData]] not overridden.
	 **/
	
	/**
	 * Inflate.result -> Uint8Array|Array|String
	 *
	 * Uncompressed result, generated by default [[Inflate#onData]]
	 * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
	 * (call [[Inflate#push]] with `Z_FINISH` / `true` param) or if you
	 * push a chunk with explicit flush (call [[Inflate#push]] with
	 * `Z_SYNC_FLUSH` param).
	 **/
	
	/**
	 * Inflate.err -> Number
	 *
	 * Error code after inflate finished. 0 (Z_OK) on success.
	 * Should be checked if broken data possible.
	 **/
	
	/**
	 * Inflate.msg -> String
	 *
	 * Error message, if [[Inflate.err]] != 0
	 **/
	
	
	/**
	 * new Inflate(options)
	 * - options (Object): zlib inflate options.
	 *
	 * Creates new inflator instance with specified params. Throws exception
	 * on bad params. Supported options:
	 *
	 * - `windowBits`
	 * - `dictionary`
	 *
	 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
	 * for more information on these.
	 *
	 * Additional options, for internal needs:
	 *
	 * - `chunkSize` - size of generated data chunks (16K by default)
	 * - `raw` (Boolean) - do raw inflate
	 * - `to` (String) - if equal to 'string', then result will be converted
	 *   from utf8 to utf16 (javascript) string. When string output requested,
	 *   chunk length can differ from `chunkSize`, depending on content.
	 *
	 * By default, when no options set, autodetect deflate/gzip data format via
	 * wrapper header.
	 *
	 * ##### Example:
	 *
	 * ```javascript
	 * var pako = require('pako')
	 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
	 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
	 *
	 * var inflate = new pako.Inflate({ level: 3});
	 *
	 * inflate.push(chunk1, false);
	 * inflate.push(chunk2, true);  // true -> last chunk
	 *
	 * if (inflate.err) { throw new Error(inflate.err); }
	 *
	 * console.log(inflate.result);
	 * ```
	 **/
	function Inflate(options) {
	  if (!(this instanceof Inflate)) return new Inflate(options);
	
	  this.options = utils.assign({
	    chunkSize: 16384,
	    windowBits: 0,
	    to: ''
	  }, options || {});
	
	  var opt = this.options;
	
	  // Force window size for `raw` data, if not set directly,
	  // because we have no header for autodetect.
	  if (opt.raw && (opt.windowBits >= 0) && (opt.windowBits < 16)) {
	    opt.windowBits = -opt.windowBits;
	    if (opt.windowBits === 0) { opt.windowBits = -15; }
	  }
	
	  // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
	  if ((opt.windowBits >= 0) && (opt.windowBits < 16) &&
	      !(options && options.windowBits)) {
	    opt.windowBits += 32;
	  }
	
	  // Gzip header has no info about windows size, we can do autodetect only
	  // for deflate. So, if window size not set, force it to max when gzip possible
	  if ((opt.windowBits > 15) && (opt.windowBits < 48)) {
	    // bit 3 (16) -> gzipped data
	    // bit 4 (32) -> autodetect gzip/deflate
	    if ((opt.windowBits & 15) === 0) {
	      opt.windowBits |= 15;
	    }
	  }
	
	  this.err    = 0;      // error code, if happens (0 = Z_OK)
	  this.msg    = '';     // error message
	  this.ended  = false;  // used to avoid multiple onEnd() calls
	  this.chunks = [];     // chunks of compressed data
	
	  this.strm   = new ZStream();
	  this.strm.avail_out = 0;
	
	  var status  = zlib_inflate.inflateInit2(
	    this.strm,
	    opt.windowBits
	  );
	
	  if (status !== c.Z_OK) {
	    throw new Error(msg[status]);
	  }
	
	  this.header = new GZheader();
	
	  zlib_inflate.inflateGetHeader(this.strm, this.header);
	
	  // Setup dictionary
	  if (opt.dictionary) {
	    // Convert data if needed
	    if (typeof opt.dictionary === 'string') {
	      opt.dictionary = strings.string2buf(opt.dictionary);
	    } else if (toString.call(opt.dictionary) === '[object ArrayBuffer]') {
	      opt.dictionary = new Uint8Array(opt.dictionary);
	    }
	    if (opt.raw) { //In raw mode we need to set the dictionary early
	      status = zlib_inflate.inflateSetDictionary(this.strm, opt.dictionary);
	      if (status !== c.Z_OK) {
	        throw new Error(msg[status]);
	      }
	    }
	  }
	}
	
	/**
	 * Inflate#push(data[, mode]) -> Boolean
	 * - data (Uint8Array|Array|ArrayBuffer|String): input data
	 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
	 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
	 *
	 * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
	 * new output chunks. Returns `true` on success. The last data block must have
	 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
	 * [[Inflate#onEnd]]. For interim explicit flushes (without ending the stream) you
	 * can use mode Z_SYNC_FLUSH, keeping the decompression context.
	 *
	 * On fail call [[Inflate#onEnd]] with error code and return false.
	 *
	 * We strongly recommend to use `Uint8Array` on input for best speed (output
	 * format is detected automatically). Also, don't skip last param and always
	 * use the same type in your code (boolean or number). That will improve JS speed.
	 *
	 * For regular `Array`-s make sure all elements are [0..255].
	 *
	 * ##### Example
	 *
	 * ```javascript
	 * push(chunk, false); // push one of data chunks
	 * ...
	 * push(chunk, true);  // push last chunk
	 * ```
	 **/
	Inflate.prototype.push = function (data, mode) {
	  var strm = this.strm;
	  var chunkSize = this.options.chunkSize;
	  var dictionary = this.options.dictionary;
	  var status, _mode;
	  var next_out_utf8, tail, utf8str;
	
	  // Flag to properly process Z_BUF_ERROR on testing inflate call
	  // when we check that all output data was flushed.
	  var allowBufError = false;
	
	  if (this.ended) { return false; }
	  _mode = (mode === ~~mode) ? mode : ((mode === true) ? c.Z_FINISH : c.Z_NO_FLUSH);
	
	  // Convert data if needed
	  if (typeof data === 'string') {
	    // Only binary strings can be decompressed on practice
	    strm.input = strings.binstring2buf(data);
	  } else if (toString.call(data) === '[object ArrayBuffer]') {
	    strm.input = new Uint8Array(data);
	  } else {
	    strm.input = data;
	  }
	
	  strm.next_in = 0;
	  strm.avail_in = strm.input.length;
	
	  do {
	    if (strm.avail_out === 0) {
	      strm.output = new utils.Buf8(chunkSize);
	      strm.next_out = 0;
	      strm.avail_out = chunkSize;
	    }
	
	    status = zlib_inflate.inflate(strm, c.Z_NO_FLUSH);    /* no bad return value */
	
	    if (status === c.Z_NEED_DICT && dictionary) {
	      status = zlib_inflate.inflateSetDictionary(this.strm, dictionary);
	    }
	
	    if (status === c.Z_BUF_ERROR && allowBufError === true) {
	      status = c.Z_OK;
	      allowBufError = false;
	    }
	
	    if (status !== c.Z_STREAM_END && status !== c.Z_OK) {
	      this.onEnd(status);
	      this.ended = true;
	      return false;
	    }
	
	    if (strm.next_out) {
	      if (strm.avail_out === 0 || status === c.Z_STREAM_END || (strm.avail_in === 0 && (_mode === c.Z_FINISH || _mode === c.Z_SYNC_FLUSH))) {
	
	        if (this.options.to === 'string') {
	
	          next_out_utf8 = strings.utf8border(strm.output, strm.next_out);
	
	          tail = strm.next_out - next_out_utf8;
	          utf8str = strings.buf2string(strm.output, next_out_utf8);
	
	          // move tail
	          strm.next_out = tail;
	          strm.avail_out = chunkSize - tail;
	          if (tail) { utils.arraySet(strm.output, strm.output, next_out_utf8, tail, 0); }
	
	          this.onData(utf8str);
	
	        } else {
	          this.onData(utils.shrinkBuf(strm.output, strm.next_out));
	        }
	      }
	    }
	
	    // When no more input data, we should check that internal inflate buffers
	    // are flushed. The only way to do it when avail_out = 0 - run one more
	    // inflate pass. But if output data not exists, inflate return Z_BUF_ERROR.
	    // Here we set flag to process this error properly.
	    //
	    // NOTE. Deflate does not return error in this case and does not needs such
	    // logic.
	    if (strm.avail_in === 0 && strm.avail_out === 0) {
	      allowBufError = true;
	    }
	
	  } while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== c.Z_STREAM_END);
	
	  if (status === c.Z_STREAM_END) {
	    _mode = c.Z_FINISH;
	  }
	
	  // Finalize on the last chunk.
	  if (_mode === c.Z_FINISH) {
	    status = zlib_inflate.inflateEnd(this.strm);
	    this.onEnd(status);
	    this.ended = true;
	    return status === c.Z_OK;
	  }
	
	  // callback interim results if Z_SYNC_FLUSH.
	  if (_mode === c.Z_SYNC_FLUSH) {
	    this.onEnd(c.Z_OK);
	    strm.avail_out = 0;
	    return true;
	  }
	
	  return true;
	};
	
	
	/**
	 * Inflate#onData(chunk) -> Void
	 * - chunk (Uint8Array|Array|String): output data. Type of array depends
	 *   on js engine support. When string output requested, each chunk
	 *   will be string.
	 *
	 * By default, stores data blocks in `chunks[]` property and glue
	 * those in `onEnd`. Override this handler, if you need another behaviour.
	 **/
	Inflate.prototype.onData = function (chunk) {
	  this.chunks.push(chunk);
	};
	
	
	/**
	 * Inflate#onEnd(status) -> Void
	 * - status (Number): inflate status. 0 (Z_OK) on success,
	 *   other if not.
	 *
	 * Called either after you tell inflate that the input stream is
	 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
	 * or if an error happened. By default - join collected chunks,
	 * free memory and fill `results` / `err` properties.
	 **/
	Inflate.prototype.onEnd = function (status) {
	  // On success - join
	  if (status === c.Z_OK) {
	    if (this.options.to === 'string') {
	      // Glue & convert here, until we teach pako to send
	      // utf8 aligned strings to onData
	      this.result = this.chunks.join('');
	    } else {
	      this.result = utils.flattenChunks(this.chunks);
	    }
	  }
	  this.chunks = [];
	  this.err = status;
	  this.msg = this.strm.msg;
	};
	
	
	/**
	 * inflate(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to decompress.
	 * - options (Object): zlib inflate options.
	 *
	 * Decompress `data` with inflate/ungzip and `options`. Autodetect
	 * format via wrapper header by default. That's why we don't provide
	 * separate `ungzip` method.
	 *
	 * Supported options are:
	 *
	 * - windowBits
	 *
	 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
	 * for more information.
	 *
	 * Sugar (options):
	 *
	 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
	 *   negative windowBits implicitly.
	 * - `to` (String) - if equal to 'string', then result will be converted
	 *   from utf8 to utf16 (javascript) string. When string output requested,
	 *   chunk length can differ from `chunkSize`, depending on content.
	 *
	 *
	 * ##### Example:
	 *
	 * ```javascript
	 * var pako = require('pako')
	 *   , input = pako.deflate([1,2,3,4,5,6,7,8,9])
	 *   , output;
	 *
	 * try {
	 *   output = pako.inflate(input);
	 * } catch (err)
	 *   console.log(err);
	 * }
	 * ```
	 **/
	function inflate(input, options) {
	  var inflator = new Inflate(options);
	
	  inflator.push(input, true);
	
	  // That will never happens, if you don't cheat with options :)
	  if (inflator.err) { throw inflator.msg || msg[inflator.err]; }
	
	  return inflator.result;
	}
	
	
	/**
	 * inflateRaw(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to decompress.
	 * - options (Object): zlib inflate options.
	 *
	 * The same as [[inflate]], but creates raw data, without wrapper
	 * (header and adler32 crc).
	 **/
	function inflateRaw(input, options) {
	  options = options || {};
	  options.raw = true;
	  return inflate(input, options);
	}
	
	
	/**
	 * ungzip(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to decompress.
	 * - options (Object): zlib inflate options.
	 *
	 * Just shortcut to [[inflate]], because it autodetects format
	 * by header.content. Done for convenience.
	 **/
	
	
	exports.Inflate = Inflate;
	exports.inflate = inflate;
	exports.inflateRaw = inflateRaw;
	exports.ungzip  = inflate;
	
	},{"./utils/common":5,"./utils/strings":6,"./zlib/constants":8,"./zlib/gzheader":10,"./zlib/inflate":12,"./zlib/messages":14,"./zlib/zstream":15}],5:[function(require,module,exports){
	'use strict';
	
	
	var TYPED_OK =  (typeof Uint8Array !== 'undefined') &&
	                (typeof Uint16Array !== 'undefined') &&
	                (typeof Int32Array !== 'undefined');
	
	function _has(obj, key) {
	  return Object.prototype.hasOwnProperty.call(obj, key);
	}
	
	exports.assign = function (obj /*from1, from2, from3, ...*/) {
	  var sources = Array.prototype.slice.call(arguments, 1);
	  while (sources.length) {
	    var source = sources.shift();
	    if (!source) { continue; }
	
	    if (typeof source !== 'object') {
	      throw new TypeError(source + 'must be non-object');
	    }
	
	    for (var p in source) {
	      if (_has(source, p)) {
	        obj[p] = source[p];
	      }
	    }
	  }
	
	  return obj;
	};
	
	
	// reduce buffer size, avoiding mem copy
	exports.shrinkBuf = function (buf, size) {
	  if (buf.length === size) { return buf; }
	  if (buf.subarray) { return buf.subarray(0, size); }
	  buf.length = size;
	  return buf;
	};
	
	
	var fnTyped = {
	  arraySet: function (dest, src, src_offs, len, dest_offs) {
	    if (src.subarray && dest.subarray) {
	      dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
	      return;
	    }
	    // Fallback to ordinary array
	    for (var i = 0; i < len; i++) {
	      dest[dest_offs + i] = src[src_offs + i];
	    }
	  },
	  // Join array of chunks to single array.
	  flattenChunks: function (chunks) {
	    var i, l, len, pos, chunk, result;
	
	    // calculate data length
	    len = 0;
	    for (i = 0, l = chunks.length; i < l; i++) {
	      len += chunks[i].length;
	    }
	
	    // join chunks
	    result = new Uint8Array(len);
	    pos = 0;
	    for (i = 0, l = chunks.length; i < l; i++) {
	      chunk = chunks[i];
	      result.set(chunk, pos);
	      pos += chunk.length;
	    }
	
	    return result;
	  }
	};
	
	var fnUntyped = {
	  arraySet: function (dest, src, src_offs, len, dest_offs) {
	    for (var i = 0; i < len; i++) {
	      dest[dest_offs + i] = src[src_offs + i];
	    }
	  },
	  // Join array of chunks to single array.
	  flattenChunks: function (chunks) {
	    return [].concat.apply([], chunks);
	  }
	};
	
	
	// Enable/Disable typed arrays use, for testing
	//
	exports.setTyped = function (on) {
	  if (on) {
	    exports.Buf8  = Uint8Array;
	    exports.Buf16 = Uint16Array;
	    exports.Buf32 = Int32Array;
	    exports.assign(exports, fnTyped);
	  } else {
	    exports.Buf8  = Array;
	    exports.Buf16 = Array;
	    exports.Buf32 = Array;
	    exports.assign(exports, fnUntyped);
	  }
	};
	
	exports.setTyped(TYPED_OK);
	
	},{}],6:[function(require,module,exports){
	// String encode/decode helpers
	'use strict';
	
	
	var utils = require('./common');
	
	
	// Quick check if we can use fast array to bin string conversion
	//
	// - apply(Array) can fail on Android 2.2
	// - apply(Uint8Array) can fail on iOS 5.1 Safari
	//
	var STR_APPLY_OK = true;
	var STR_APPLY_UIA_OK = true;
	
	try { String.fromCharCode.apply(null, [ 0 ]); } catch (__) { STR_APPLY_OK = false; }
	try { String.fromCharCode.apply(null, new Uint8Array(1)); } catch (__) { STR_APPLY_UIA_OK = false; }
	
	
	// Table with utf8 lengths (calculated by first byte of sequence)
	// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
	// because max possible codepoint is 0x10ffff
	var _utf8len = new utils.Buf8(256);
	for (var q = 0; q < 256; q++) {
	  _utf8len[q] = (q >= 252 ? 6 : q >= 248 ? 5 : q >= 240 ? 4 : q >= 224 ? 3 : q >= 192 ? 2 : 1);
	}
	_utf8len[254] = _utf8len[254] = 1; // Invalid sequence start
	
	
	// convert string to array (typed, when possible)
	exports.string2buf = function (str) {
	  var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;
	
	  // count binary size
	  for (m_pos = 0; m_pos < str_len; m_pos++) {
	    c = str.charCodeAt(m_pos);
	    if ((c & 0xfc00) === 0xd800 && (m_pos + 1 < str_len)) {
	      c2 = str.charCodeAt(m_pos + 1);
	      if ((c2 & 0xfc00) === 0xdc00) {
	        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
	        m_pos++;
	      }
	    }
	    buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
	  }
	
	  // allocate buffer
	  buf = new utils.Buf8(buf_len);
	
	  // convert
	  for (i = 0, m_pos = 0; i < buf_len; m_pos++) {
	    c = str.charCodeAt(m_pos);
	    if ((c & 0xfc00) === 0xd800 && (m_pos + 1 < str_len)) {
	      c2 = str.charCodeAt(m_pos + 1);
	      if ((c2 & 0xfc00) === 0xdc00) {
	        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
	        m_pos++;
	      }
	    }
	    if (c < 0x80) {
	      /* one byte */
	      buf[i++] = c;
	    } else if (c < 0x800) {
	      /* two bytes */
	      buf[i++] = 0xC0 | (c >>> 6);
	      buf[i++] = 0x80 | (c & 0x3f);
	    } else if (c < 0x10000) {
	      /* three bytes */
	      buf[i++] = 0xE0 | (c >>> 12);
	      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
	      buf[i++] = 0x80 | (c & 0x3f);
	    } else {
	      /* four bytes */
	      buf[i++] = 0xf0 | (c >>> 18);
	      buf[i++] = 0x80 | (c >>> 12 & 0x3f);
	      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
	      buf[i++] = 0x80 | (c & 0x3f);
	    }
	  }
	
	  return buf;
	};
	
	// Helper (used in 2 places)
	function buf2binstring(buf, len) {
	  // On Chrome, the arguments in a function call that are allowed is `65534`.
	  // If the length of the buffer is smaller than that, we can use this optimization,
	  // otherwise we will take a slower path.
	  if (len < 65534) {
	    if ((buf.subarray && STR_APPLY_UIA_OK) || (!buf.subarray && STR_APPLY_OK)) {
	      return String.fromCharCode.apply(null, utils.shrinkBuf(buf, len));
	    }
	  }
	
	  var result = '';
	  for (var i = 0; i < len; i++) {
	    result += String.fromCharCode(buf[i]);
	  }
	  return result;
	}
	
	
	// Convert byte array to binary string
	exports.buf2binstring = function (buf) {
	  return buf2binstring(buf, buf.length);
	};
	
	
	// Convert binary string (typed, when possible)
	exports.binstring2buf = function (str) {
	  var buf = new utils.Buf8(str.length);
	  for (var i = 0, len = buf.length; i < len; i++) {
	    buf[i] = str.charCodeAt(i);
	  }
	  return buf;
	};
	
	
	// convert array to string
	exports.buf2string = function (buf, max) {
	  var i, out, c, c_len;
	  var len = max || buf.length;
	
	  // Reserve max possible length (2 words per char)
	  // NB: by unknown reasons, Array is significantly faster for
	  //     String.fromCharCode.apply than Uint16Array.
	  var utf16buf = new Array(len * 2);
	
	  for (out = 0, i = 0; i < len;) {
	    c = buf[i++];
	    // quick process ascii
	    if (c < 0x80) { utf16buf[out++] = c; continue; }
	
	    c_len = _utf8len[c];
	    // skip 5 & 6 byte codes
	    if (c_len > 4) { utf16buf[out++] = 0xfffd; i += c_len - 1; continue; }
	
	    // apply mask on first byte
	    c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
	    // join the rest
	    while (c_len > 1 && i < len) {
	      c = (c << 6) | (buf[i++] & 0x3f);
	      c_len--;
	    }
	
	    // terminated by end of string?
	    if (c_len > 1) { utf16buf[out++] = 0xfffd; continue; }
	
	    if (c < 0x10000) {
	      utf16buf[out++] = c;
	    } else {
	      c -= 0x10000;
	      utf16buf[out++] = 0xd800 | ((c >> 10) & 0x3ff);
	      utf16buf[out++] = 0xdc00 | (c & 0x3ff);
	    }
	  }
	
	  return buf2binstring(utf16buf, out);
	};
	
	
	// Calculate max possible position in utf8 buffer,
	// that will not break sequence. If that's not possible
	// - (very small limits) return max size as is.
	//
	// buf[] - utf8 bytes array
	// max   - length limit (mandatory);
	exports.utf8border = function (buf, max) {
	  var pos;
	
	  max = max || buf.length;
	  if (max > buf.length) { max = buf.length; }
	
	  // go back from last position, until start of sequence found
	  pos = max - 1;
	  while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) { pos--; }
	
	  // Very small and broken sequence,
	  // return max, because we should return something anyway.
	  if (pos < 0) { return max; }
	
	  // If we came to start of buffer - that means buffer is too small,
	  // return max too.
	  if (pos === 0) { return max; }
	
	  return (pos + _utf8len[buf[pos]] > max) ? pos : max;
	};
	
	},{"./common":5}],7:[function(require,module,exports){
	'use strict';
	
	// Note: adler32 takes 12% for level 0 and 2% for level 6.
	// It isn't worth it to make additional optimizations as in original.
	// Small size is preferable.
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	function adler32(adler, buf, len, pos) {
	  var s1 = (adler & 0xffff) |0,
	      s2 = ((adler >>> 16) & 0xffff) |0,
	      n = 0;
	
	  while (len !== 0) {
	    // Set limit ~ twice less than 5552, to keep
	    // s2 in 31-bits, because we force signed ints.
	    // in other case %= will fail.
	    n = len > 2000 ? 2000 : len;
	    len -= n;
	
	    do {
	      s1 = (s1 + buf[pos++]) |0;
	      s2 = (s2 + s1) |0;
	    } while (--n);
	
	    s1 %= 65521;
	    s2 %= 65521;
	  }
	
	  return (s1 | (s2 << 16)) |0;
	}
	
	
	module.exports = adler32;
	
	},{}],8:[function(require,module,exports){
	'use strict';
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	module.exports = {
	
	  /* Allowed flush values; see deflate() and inflate() below for details */
	  Z_NO_FLUSH:         0,
	  Z_PARTIAL_FLUSH:    1,
	  Z_SYNC_FLUSH:       2,
	  Z_FULL_FLUSH:       3,
	  Z_FINISH:           4,
	  Z_BLOCK:            5,
	  Z_TREES:            6,
	
	  /* Return codes for the compression/decompression functions. Negative values
	  * are errors, positive values are used for special but normal events.
	  */
	  Z_OK:               0,
	  Z_STREAM_END:       1,
	  Z_NEED_DICT:        2,
	  Z_ERRNO:           -1,
	  Z_STREAM_ERROR:    -2,
	  Z_DATA_ERROR:      -3,
	  //Z_MEM_ERROR:     -4,
	  Z_BUF_ERROR:       -5,
	  //Z_VERSION_ERROR: -6,
	
	  /* compression levels */
	  Z_NO_COMPRESSION:         0,
	  Z_BEST_SPEED:             1,
	  Z_BEST_COMPRESSION:       9,
	  Z_DEFAULT_COMPRESSION:   -1,
	
	
	  Z_FILTERED:               1,
	  Z_HUFFMAN_ONLY:           2,
	  Z_RLE:                    3,
	  Z_FIXED:                  4,
	  Z_DEFAULT_STRATEGY:       0,
	
	  /* Possible values of the data_type field (though see inflate()) */
	  Z_BINARY:                 0,
	  Z_TEXT:                   1,
	  //Z_ASCII:                1, // = Z_TEXT (deprecated)
	  Z_UNKNOWN:                2,
	
	  /* The deflate compression method */
	  Z_DEFLATED:               8
	  //Z_NULL:                 null // Use -1 or null inline, depending on var type
	};
	
	},{}],9:[function(require,module,exports){
	'use strict';
	
	// Note: we can't get significant speed boost here.
	// So write code to minimize size - no pregenerated tables
	// and array tools dependencies.
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	// Use ordinary array, since untyped makes no boost here
	function makeTable() {
	  var c, table = [];
	
	  for (var n = 0; n < 256; n++) {
	    c = n;
	    for (var k = 0; k < 8; k++) {
	      c = ((c & 1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
	    }
	    table[n] = c;
	  }
	
	  return table;
	}
	
	// Create table on load. Just 255 signed longs. Not a problem.
	var crcTable = makeTable();
	
	
	function crc32(crc, buf, len, pos) {
	  var t = crcTable,
	      end = pos + len;
	
	  crc ^= -1;
	
	  for (var i = pos; i < end; i++) {
	    crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xFF];
	  }
	
	  return (crc ^ (-1)); // >>> 0;
	}
	
	
	module.exports = crc32;
	
	},{}],10:[function(require,module,exports){
	'use strict';
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	function GZheader() {
	  /* true if compressed data believed to be text */
	  this.text       = 0;
	  /* modification time */
	  this.time       = 0;
	  /* extra flags (not used when writing a gzip file) */
	  this.xflags     = 0;
	  /* operating system */
	  this.os         = 0;
	  /* pointer to extra field or Z_NULL if none */
	  this.extra      = null;
	  /* extra field length (valid if extra != Z_NULL) */
	  this.extra_len  = 0; // Actually, we don't need it in JS,
	                       // but leave for few code modifications
	
	  //
	  // Setup limits is not necessary because in js we should not preallocate memory
	  // for inflate use constant limit in 65536 bytes
	  //
	
	  /* space at extra (only when reading header) */
	  // this.extra_max  = 0;
	  /* pointer to zero-terminated file name or Z_NULL */
	  this.name       = '';
	  /* space at name (only when reading header) */
	  // this.name_max   = 0;
	  /* pointer to zero-terminated comment or Z_NULL */
	  this.comment    = '';
	  /* space at comment (only when reading header) */
	  // this.comm_max   = 0;
	  /* true if there was or will be a header crc */
	  this.hcrc       = 0;
	  /* true when done reading gzip header (not used when writing a gzip file) */
	  this.done       = false;
	}
	
	module.exports = GZheader;
	
	},{}],11:[function(require,module,exports){
	'use strict';
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	// See state defs from inflate.js
	var BAD = 30;       /* got a data error -- remain here until reset */
	var TYPE = 12;      /* i: waiting for type bits, including last-flag bit */
	
	/*
	   Decode literal, length, and distance codes and write out the resulting
	   literal and match bytes until either not enough input or output is
	   available, an end-of-block is encountered, or a data error is encountered.
	   When large enough input and output buffers are supplied to inflate(), for
	   example, a 16K input buffer and a 64K output buffer, more than 95% of the
	   inflate execution time is spent in this routine.
	
	   Entry assumptions:
	
	        state.mode === LEN
	        strm.avail_in >= 6
	        strm.avail_out >= 258
	        start >= strm.avail_out
	        state.bits < 8
	
	   On return, state.mode is one of:
	
	        LEN -- ran out of enough output space or enough available input
	        TYPE -- reached end of block code, inflate() to interpret next block
	        BAD -- error in block data
	
	   Notes:
	
	    - The maximum input bits used by a length/distance pair is 15 bits for the
	      length code, 5 bits for the length extra, 15 bits for the distance code,
	      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
	      Therefore if strm.avail_in >= 6, then there is enough input to avoid
	      checking for available input while decoding.
	
	    - The maximum bytes that a single length/distance pair can output is 258
	      bytes, which is the maximum length that can be coded.  inflate_fast()
	      requires strm.avail_out >= 258 for each loop to avoid checking for
	      output space.
	 */
	module.exports = function inflate_fast(strm, start) {
	  var state;
	  var _in;                    /* local strm.input */
	  var last;                   /* have enough input while in < last */
	  var _out;                   /* local strm.output */
	  var beg;                    /* inflate()'s initial strm.output */
	  var end;                    /* while out < end, enough space available */
	//#ifdef INFLATE_STRICT
	  var dmax;                   /* maximum distance from zlib header */
	//#endif
	  var wsize;                  /* window size or zero if not using window */
	  var whave;                  /* valid bytes in the window */
	  var wnext;                  /* window write index */
	  // Use `s_window` instead `window`, avoid conflict with instrumentation tools
	  var s_window;               /* allocated sliding window, if wsize != 0 */
	  var hold;                   /* local strm.hold */
	  var bits;                   /* local strm.bits */
	  var lcode;                  /* local strm.lencode */
	  var dcode;                  /* local strm.distcode */
	  var lmask;                  /* mask for first level of length codes */
	  var dmask;                  /* mask for first level of distance codes */
	  var here;                   /* retrieved table entry */
	  var op;                     /* code bits, operation, extra bits, or */
	                              /*  window position, window bytes to copy */
	  var len;                    /* match length, unused bytes */
	  var dist;                   /* match distance */
	  var from;                   /* where to copy match from */
	  var from_source;
	
	
	  var input, output; // JS specific, because we have no pointers
	
	  /* copy state to local variables */
	  state = strm.state;
	  //here = state.here;
	  _in = strm.next_in;
	  input = strm.input;
	  last = _in + (strm.avail_in - 5);
	  _out = strm.next_out;
	  output = strm.output;
	  beg = _out - (start - strm.avail_out);
	  end = _out + (strm.avail_out - 257);
	//#ifdef INFLATE_STRICT
	  dmax = state.dmax;
	//#endif
	  wsize = state.wsize;
	  whave = state.whave;
	  wnext = state.wnext;
	  s_window = state.window;
	  hold = state.hold;
	  bits = state.bits;
	  lcode = state.lencode;
	  dcode = state.distcode;
	  lmask = (1 << state.lenbits) - 1;
	  dmask = (1 << state.distbits) - 1;
	
	
	  /* decode literals and length/distances until end-of-block or not enough
	     input data or output space */
	
	  top:
	  do {
	    if (bits < 15) {
	      hold += input[_in++] << bits;
	      bits += 8;
	      hold += input[_in++] << bits;
	      bits += 8;
	    }
	
	    here = lcode[hold & lmask];
	
	    dolen:
	    for (;;) { // Goto emulation
	      op = here >>> 24/*here.bits*/;
	      hold >>>= op;
	      bits -= op;
	      op = (here >>> 16) & 0xff/*here.op*/;
	      if (op === 0) {                          /* literal */
	        //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
	        //        "inflate:         literal '%c'\n" :
	        //        "inflate:         literal 0x%02x\n", here.val));
	        output[_out++] = here & 0xffff/*here.val*/;
	      }
	      else if (op & 16) {                     /* length base */
	        len = here & 0xffff/*here.val*/;
	        op &= 15;                           /* number of extra bits */
	        if (op) {
	          if (bits < op) {
	            hold += input[_in++] << bits;
	            bits += 8;
	          }
	          len += hold & ((1 << op) - 1);
	          hold >>>= op;
	          bits -= op;
	        }
	        //Tracevv((stderr, "inflate:         length %u\n", len));
	        if (bits < 15) {
	          hold += input[_in++] << bits;
	          bits += 8;
	          hold += input[_in++] << bits;
	          bits += 8;
	        }
	        here = dcode[hold & dmask];
	
	        dodist:
	        for (;;) { // goto emulation
	          op = here >>> 24/*here.bits*/;
	          hold >>>= op;
	          bits -= op;
	          op = (here >>> 16) & 0xff/*here.op*/;
	
	          if (op & 16) {                      /* distance base */
	            dist = here & 0xffff/*here.val*/;
	            op &= 15;                       /* number of extra bits */
	            if (bits < op) {
	              hold += input[_in++] << bits;
	              bits += 8;
	              if (bits < op) {
	                hold += input[_in++] << bits;
	                bits += 8;
	              }
	            }
	            dist += hold & ((1 << op) - 1);
	//#ifdef INFLATE_STRICT
	            if (dist > dmax) {
	              strm.msg = 'invalid distance too far back';
	              state.mode = BAD;
	              break top;
	            }
	//#endif
	            hold >>>= op;
	            bits -= op;
	            //Tracevv((stderr, "inflate:         distance %u\n", dist));
	            op = _out - beg;                /* max distance in output */
	            if (dist > op) {                /* see if copy from window */
	              op = dist - op;               /* distance back in window */
	              if (op > whave) {
	                if (state.sane) {
	                  strm.msg = 'invalid distance too far back';
	                  state.mode = BAD;
	                  break top;
	                }
	
	// (!) This block is disabled in zlib defaults,
	// don't enable it for binary compatibility
	//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
	//                if (len <= op - whave) {
	//                  do {
	//                    output[_out++] = 0;
	//                  } while (--len);
	//                  continue top;
	//                }
	//                len -= op - whave;
	//                do {
	//                  output[_out++] = 0;
	//                } while (--op > whave);
	//                if (op === 0) {
	//                  from = _out - dist;
	//                  do {
	//                    output[_out++] = output[from++];
	//                  } while (--len);
	//                  continue top;
	//                }
	//#endif
	              }
	              from = 0; // window index
	              from_source = s_window;
	              if (wnext === 0) {           /* very common case */
	                from += wsize - op;
	                if (op < len) {         /* some from window */
	                  len -= op;
	                  do {
	                    output[_out++] = s_window[from++];
	                  } while (--op);
	                  from = _out - dist;  /* rest from output */
	                  from_source = output;
	                }
	              }
	              else if (wnext < op) {      /* wrap around window */
	                from += wsize + wnext - op;
	                op -= wnext;
	                if (op < len) {         /* some from end of window */
	                  len -= op;
	                  do {
	                    output[_out++] = s_window[from++];
	                  } while (--op);
	                  from = 0;
	                  if (wnext < len) {  /* some from start of window */
	                    op = wnext;
	                    len -= op;
	                    do {
	                      output[_out++] = s_window[from++];
	                    } while (--op);
	                    from = _out - dist;      /* rest from output */
	                    from_source = output;
	                  }
	                }
	              }
	              else {                      /* contiguous in window */
	                from += wnext - op;
	                if (op < len) {         /* some from window */
	                  len -= op;
	                  do {
	                    output[_out++] = s_window[from++];
	                  } while (--op);
	                  from = _out - dist;  /* rest from output */
	                  from_source = output;
	                }
	              }
	              while (len > 2) {
	                output[_out++] = from_source[from++];
	                output[_out++] = from_source[from++];
	                output[_out++] = from_source[from++];
	                len -= 3;
	              }
	              if (len) {
	                output[_out++] = from_source[from++];
	                if (len > 1) {
	                  output[_out++] = from_source[from++];
	                }
	              }
	            }
	            else {
	              from = _out - dist;          /* copy direct from output */
	              do {                        /* minimum length is three */
	                output[_out++] = output[from++];
	                output[_out++] = output[from++];
	                output[_out++] = output[from++];
	                len -= 3;
	              } while (len > 2);
	              if (len) {
	                output[_out++] = output[from++];
	                if (len > 1) {
	                  output[_out++] = output[from++];
	                }
	              }
	            }
	          }
	          else if ((op & 64) === 0) {          /* 2nd level distance code */
	            here = dcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
	            continue dodist;
	          }
	          else {
	            strm.msg = 'invalid distance code';
	            state.mode = BAD;
	            break top;
	          }
	
	          break; // need to emulate goto via "continue"
	        }
	      }
	      else if ((op & 64) === 0) {              /* 2nd level length code */
	        here = lcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
	        continue dolen;
	      }
	      else if (op & 32) {                     /* end-of-block */
	        //Tracevv((stderr, "inflate:         end of block\n"));
	        state.mode = TYPE;
	        break top;
	      }
	      else {
	        strm.msg = 'invalid literal/length code';
	        state.mode = BAD;
	        break top;
	      }
	
	      break; // need to emulate goto via "continue"
	    }
	  } while (_in < last && _out < end);
	
	  /* return unused bytes (on entry, bits < 8, so in won't go too far back) */
	  len = bits >> 3;
	  _in -= len;
	  bits -= len << 3;
	  hold &= (1 << bits) - 1;
	
	  /* update state and return */
	  strm.next_in = _in;
	  strm.next_out = _out;
	  strm.avail_in = (_in < last ? 5 + (last - _in) : 5 - (_in - last));
	  strm.avail_out = (_out < end ? 257 + (end - _out) : 257 - (_out - end));
	  state.hold = hold;
	  state.bits = bits;
	  return;
	};
	
	},{}],12:[function(require,module,exports){
	'use strict';
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	var utils         = require('../utils/common');
	var adler32       = require('./adler32');
	var crc32         = require('./crc32');
	var inflate_fast  = require('./inffast');
	var inflate_table = require('./inftrees');
	
	var CODES = 0;
	var LENS = 1;
	var DISTS = 2;
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	
	/* Allowed flush values; see deflate() and inflate() below for details */
	//var Z_NO_FLUSH      = 0;
	//var Z_PARTIAL_FLUSH = 1;
	//var Z_SYNC_FLUSH    = 2;
	//var Z_FULL_FLUSH    = 3;
	var Z_FINISH        = 4;
	var Z_BLOCK         = 5;
	var Z_TREES         = 6;
	
	
	/* Return codes for the compression/decompression functions. Negative values
	 * are errors, positive values are used for special but normal events.
	 */
	var Z_OK            = 0;
	var Z_STREAM_END    = 1;
	var Z_NEED_DICT     = 2;
	//var Z_ERRNO         = -1;
	var Z_STREAM_ERROR  = -2;
	var Z_DATA_ERROR    = -3;
	var Z_MEM_ERROR     = -4;
	var Z_BUF_ERROR     = -5;
	//var Z_VERSION_ERROR = -6;
	
	/* The deflate compression method */
	var Z_DEFLATED  = 8;
	
	
	/* STATES ====================================================================*/
	/* ===========================================================================*/
	
	
	var    HEAD = 1;       /* i: waiting for magic header */
	var    FLAGS = 2;      /* i: waiting for method and flags (gzip) */
	var    TIME = 3;       /* i: waiting for modification time (gzip) */
	var    OS = 4;         /* i: waiting for extra flags and operating system (gzip) */
	var    EXLEN = 5;      /* i: waiting for extra length (gzip) */
	var    EXTRA = 6;      /* i: waiting for extra bytes (gzip) */
	var    NAME = 7;       /* i: waiting for end of file name (gzip) */
	var    COMMENT = 8;    /* i: waiting for end of comment (gzip) */
	var    HCRC = 9;       /* i: waiting for header crc (gzip) */
	var    DICTID = 10;    /* i: waiting for dictionary check value */
	var    DICT = 11;      /* waiting for inflateSetDictionary() call */
	var        TYPE = 12;      /* i: waiting for type bits, including last-flag bit */
	var        TYPEDO = 13;    /* i: same, but skip check to exit inflate on new block */
	var        STORED = 14;    /* i: waiting for stored size (length and complement) */
	var        COPY_ = 15;     /* i/o: same as COPY below, but only first time in */
	var        COPY = 16;      /* i/o: waiting for input or output to copy stored block */
	var        TABLE = 17;     /* i: waiting for dynamic block table lengths */
	var        LENLENS = 18;   /* i: waiting for code length code lengths */
	var        CODELENS = 19;  /* i: waiting for length/lit and distance code lengths */
	var            LEN_ = 20;      /* i: same as LEN below, but only first time in */
	var            LEN = 21;       /* i: waiting for length/lit/eob code */
	var            LENEXT = 22;    /* i: waiting for length extra bits */
	var            DIST = 23;      /* i: waiting for distance code */
	var            DISTEXT = 24;   /* i: waiting for distance extra bits */
	var            MATCH = 25;     /* o: waiting for output space to copy string */
	var            LIT = 26;       /* o: waiting for output space to write literal */
	var    CHECK = 27;     /* i: waiting for 32-bit check value */
	var    LENGTH = 28;    /* i: waiting for 32-bit length (gzip) */
	var    DONE = 29;      /* finished check, done -- remain here until reset */
	var    BAD = 30;       /* got a data error -- remain here until reset */
	var    MEM = 31;       /* got an inflate() memory error -- remain here until reset */
	var    SYNC = 32;      /* looking for synchronization bytes to restart inflate() */
	
	/* ===========================================================================*/
	
	
	
	var ENOUGH_LENS = 852;
	var ENOUGH_DISTS = 592;
	//var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);
	
	var MAX_WBITS = 15;
	/* 32K LZ77 window */
	var DEF_WBITS = MAX_WBITS;
	
	
	function zswap32(q) {
	  return  (((q >>> 24) & 0xff) +
	          ((q >>> 8) & 0xff00) +
	          ((q & 0xff00) << 8) +
	          ((q & 0xff) << 24));
	}
	
	
	function InflateState() {
	  this.mode = 0;             /* current inflate mode */
	  this.last = false;          /* true if processing last block */
	  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
	  this.havedict = false;      /* true if dictionary provided */
	  this.flags = 0;             /* gzip header method and flags (0 if zlib) */
	  this.dmax = 0;              /* zlib header max distance (INFLATE_STRICT) */
	  this.check = 0;             /* protected copy of check value */
	  this.total = 0;             /* protected copy of output count */
	  // TODO: may be {}
	  this.head = null;           /* where to save gzip header information */
	
	  /* sliding window */
	  this.wbits = 0;             /* log base 2 of requested window size */
	  this.wsize = 0;             /* window size or zero if not using window */
	  this.whave = 0;             /* valid bytes in the window */
	  this.wnext = 0;             /* window write index */
	  this.window = null;         /* allocated sliding window, if needed */
	
	  /* bit accumulator */
	  this.hold = 0;              /* input bit accumulator */
	  this.bits = 0;              /* number of bits in "in" */
	
	  /* for string and stored block copying */
	  this.length = 0;            /* literal or length of data to copy */
	  this.offset = 0;            /* distance back to copy string from */
	
	  /* for table and code decoding */
	  this.extra = 0;             /* extra bits needed */
	
	  /* fixed and dynamic code tables */
	  this.lencode = null;          /* starting table for length/literal codes */
	  this.distcode = null;         /* starting table for distance codes */
	  this.lenbits = 0;           /* index bits for lencode */
	  this.distbits = 0;          /* index bits for distcode */
	
	  /* dynamic table building */
	  this.ncode = 0;             /* number of code length code lengths */
	  this.nlen = 0;              /* number of length code lengths */
	  this.ndist = 0;             /* number of distance code lengths */
	  this.have = 0;              /* number of code lengths in lens[] */
	  this.next = null;              /* next available space in codes[] */
	
	  this.lens = new utils.Buf16(320); /* temporary storage for code lengths */
	  this.work = new utils.Buf16(288); /* work area for code table building */
	
	  /*
	   because we don't have pointers in js, we use lencode and distcode directly
	   as buffers so we don't need codes
	  */
	  //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
	  this.lendyn = null;              /* dynamic table for length/literal codes (JS specific) */
	  this.distdyn = null;             /* dynamic table for distance codes (JS specific) */
	  this.sane = 0;                   /* if false, allow invalid distance too far */
	  this.back = 0;                   /* bits back of last unprocessed length/lit */
	  this.was = 0;                    /* initial length of match */
	}
	
	function inflateResetKeep(strm) {
	  var state;
	
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	  strm.total_in = strm.total_out = state.total = 0;
	  strm.msg = ''; /*Z_NULL*/
	  if (state.wrap) {       /* to support ill-conceived Java test suite */
	    strm.adler = state.wrap & 1;
	  }
	  state.mode = HEAD;
	  state.last = 0;
	  state.havedict = 0;
	  state.dmax = 32768;
	  state.head = null/*Z_NULL*/;
	  state.hold = 0;
	  state.bits = 0;
	  //state.lencode = state.distcode = state.next = state.codes;
	  state.lencode = state.lendyn = new utils.Buf32(ENOUGH_LENS);
	  state.distcode = state.distdyn = new utils.Buf32(ENOUGH_DISTS);
	
	  state.sane = 1;
	  state.back = -1;
	  //Tracev((stderr, "inflate: reset\n"));
	  return Z_OK;
	}
	
	function inflateReset(strm) {
	  var state;
	
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	  state.wsize = 0;
	  state.whave = 0;
	  state.wnext = 0;
	  return inflateResetKeep(strm);
	
	}
	
	function inflateReset2(strm, windowBits) {
	  var wrap;
	  var state;
	
	  /* get the state */
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	
	  /* extract wrap request from windowBits parameter */
	  if (windowBits < 0) {
	    wrap = 0;
	    windowBits = -windowBits;
	  }
	  else {
	    wrap = (windowBits >> 4) + 1;
	    if (windowBits < 48) {
	      windowBits &= 15;
	    }
	  }
	
	  /* set number of window bits, free window if different */
	  if (windowBits && (windowBits < 8 || windowBits > 15)) {
	    return Z_STREAM_ERROR;
	  }
	  if (state.window !== null && state.wbits !== windowBits) {
	    state.window = null;
	  }
	
	  /* update state and reset the rest of it */
	  state.wrap = wrap;
	  state.wbits = windowBits;
	  return inflateReset(strm);
	}
	
	function inflateInit2(strm, windowBits) {
	  var ret;
	  var state;
	
	  if (!strm) { return Z_STREAM_ERROR; }
	  //strm.msg = Z_NULL;                 /* in case we return an error */
	
	  state = new InflateState();
	
	  //if (state === Z_NULL) return Z_MEM_ERROR;
	  //Tracev((stderr, "inflate: allocated\n"));
	  strm.state = state;
	  state.window = null/*Z_NULL*/;
	  ret = inflateReset2(strm, windowBits);
	  if (ret !== Z_OK) {
	    strm.state = null/*Z_NULL*/;
	  }
	  return ret;
	}
	
	function inflateInit(strm) {
	  return inflateInit2(strm, DEF_WBITS);
	}
	
	
	/*
	 Return state with length and distance decoding tables and index sizes set to
	 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
	 If BUILDFIXED is defined, then instead this routine builds the tables the
	 first time it's called, and returns those tables the first time and
	 thereafter.  This reduces the size of the code by about 2K bytes, in
	 exchange for a little execution time.  However, BUILDFIXED should not be
	 used for threaded applications, since the rewriting of the tables and virgin
	 may not be thread-safe.
	 */
	var virgin = true;
	
	var lenfix, distfix; // We have no pointers in JS, so keep tables separate
	
	function fixedtables(state) {
	  /* build fixed huffman tables if first call (may not be thread safe) */
	  if (virgin) {
	    var sym;
	
	    lenfix = new utils.Buf32(512);
	    distfix = new utils.Buf32(32);
	
	    /* literal/length table */
	    sym = 0;
	    while (sym < 144) { state.lens[sym++] = 8; }
	    while (sym < 256) { state.lens[sym++] = 9; }
	    while (sym < 280) { state.lens[sym++] = 7; }
	    while (sym < 288) { state.lens[sym++] = 8; }
	
	    inflate_table(LENS,  state.lens, 0, 288, lenfix,   0, state.work, { bits: 9 });
	
	    /* distance table */
	    sym = 0;
	    while (sym < 32) { state.lens[sym++] = 5; }
	
	    inflate_table(DISTS, state.lens, 0, 32,   distfix, 0, state.work, { bits: 5 });
	
	    /* do this just once */
	    virgin = false;
	  }
	
	  state.lencode = lenfix;
	  state.lenbits = 9;
	  state.distcode = distfix;
	  state.distbits = 5;
	}
	
	
	/*
	 Update the window with the last wsize (normally 32K) bytes written before
	 returning.  If window does not exist yet, create it.  This is only called
	 when a window is already in use, or when output has been written during this
	 inflate call, but the end of the deflate stream has not been reached yet.
	 It is also called to create a window for dictionary data when a dictionary
	 is loaded.
	
	 Providing output buffers larger than 32K to inflate() should provide a speed
	 advantage, since only the last 32K of output is copied to the sliding window
	 upon return from inflate(), and since all distances after the first 32K of
	 output will fall in the output data, making match copies simpler and faster.
	 The advantage may be dependent on the size of the processor's data caches.
	 */
	function updatewindow(strm, src, end, copy) {
	  var dist;
	  var state = strm.state;
	
	  /* if it hasn't been done already, allocate space for the window */
	  if (state.window === null) {
	    state.wsize = 1 << state.wbits;
	    state.wnext = 0;
	    state.whave = 0;
	
	    state.window = new utils.Buf8(state.wsize);
	  }
	
	  /* copy state->wsize or less output bytes into the circular window */
	  if (copy >= state.wsize) {
	    utils.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
	    state.wnext = 0;
	    state.whave = state.wsize;
	  }
	  else {
	    dist = state.wsize - state.wnext;
	    if (dist > copy) {
	      dist = copy;
	    }
	    //zmemcpy(state->window + state->wnext, end - copy, dist);
	    utils.arraySet(state.window, src, end - copy, dist, state.wnext);
	    copy -= dist;
	    if (copy) {
	      //zmemcpy(state->window, end - copy, copy);
	      utils.arraySet(state.window, src, end - copy, copy, 0);
	      state.wnext = copy;
	      state.whave = state.wsize;
	    }
	    else {
	      state.wnext += dist;
	      if (state.wnext === state.wsize) { state.wnext = 0; }
	      if (state.whave < state.wsize) { state.whave += dist; }
	    }
	  }
	  return 0;
	}
	
	function inflate(strm, flush) {
	  var state;
	  var input, output;          // input/output buffers
	  var next;                   /* next input INDEX */
	  var put;                    /* next output INDEX */
	  var have, left;             /* available input and output */
	  var hold;                   /* bit buffer */
	  var bits;                   /* bits in bit buffer */
	  var _in, _out;              /* save starting available input and output */
	  var copy;                   /* number of stored or match bytes to copy */
	  var from;                   /* where to copy match bytes from */
	  var from_source;
	  var here = 0;               /* current decoding table entry */
	  var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
	  //var last;                   /* parent table entry */
	  var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
	  var len;                    /* length to copy for repeats, bits to drop */
	  var ret;                    /* return code */
	  var hbuf = new utils.Buf8(4);    /* buffer for gzip header crc calculation */
	  var opts;
	
	  var n; // temporary var for NEED_BITS
	
	  var order = /* permutation of code lengths */
	    [ 16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15 ];
	
	
	  if (!strm || !strm.state || !strm.output ||
	      (!strm.input && strm.avail_in !== 0)) {
	    return Z_STREAM_ERROR;
	  }
	
	  state = strm.state;
	  if (state.mode === TYPE) { state.mode = TYPEDO; }    /* skip check */
	
	
	  //--- LOAD() ---
	  put = strm.next_out;
	  output = strm.output;
	  left = strm.avail_out;
	  next = strm.next_in;
	  input = strm.input;
	  have = strm.avail_in;
	  hold = state.hold;
	  bits = state.bits;
	  //---
	
	  _in = have;
	  _out = left;
	  ret = Z_OK;
	
	  inf_leave: // goto emulation
	  for (;;) {
	    switch (state.mode) {
	      case HEAD:
	        if (state.wrap === 0) {
	          state.mode = TYPEDO;
	          break;
	        }
	        //=== NEEDBITS(16);
	        while (bits < 16) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        if ((state.wrap & 2) && hold === 0x8b1f) {  /* gzip header */
	          state.check = 0/*crc32(0L, Z_NULL, 0)*/;
	          //=== CRC2(state.check, hold);
	          hbuf[0] = hold & 0xff;
	          hbuf[1] = (hold >>> 8) & 0xff;
	          state.check = crc32(state.check, hbuf, 2, 0);
	          //===//
	
	          //=== INITBITS();
	          hold = 0;
	          bits = 0;
	          //===//
	          state.mode = FLAGS;
	          break;
	        }
	        state.flags = 0;           /* expect zlib header */
	        if (state.head) {
	          state.head.done = false;
	        }
	        if (!(state.wrap & 1) ||   /* check if zlib header allowed */
	          (((hold & 0xff)/*BITS(8)*/ << 8) + (hold >> 8)) % 31) {
	          strm.msg = 'incorrect header check';
	          state.mode = BAD;
	          break;
	        }
	        if ((hold & 0x0f)/*BITS(4)*/ !== Z_DEFLATED) {
	          strm.msg = 'unknown compression method';
	          state.mode = BAD;
	          break;
	        }
	        //--- DROPBITS(4) ---//
	        hold >>>= 4;
	        bits -= 4;
	        //---//
	        len = (hold & 0x0f)/*BITS(4)*/ + 8;
	        if (state.wbits === 0) {
	          state.wbits = len;
	        }
	        else if (len > state.wbits) {
	          strm.msg = 'invalid window size';
	          state.mode = BAD;
	          break;
	        }
	        state.dmax = 1 << len;
	        //Tracev((stderr, "inflate:   zlib header ok\n"));
	        strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
	        state.mode = hold & 0x200 ? DICTID : TYPE;
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        break;
	      case FLAGS:
	        //=== NEEDBITS(16); */
	        while (bits < 16) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.flags = hold;
	        if ((state.flags & 0xff) !== Z_DEFLATED) {
	          strm.msg = 'unknown compression method';
	          state.mode = BAD;
	          break;
	        }
	        if (state.flags & 0xe000) {
	          strm.msg = 'unknown header flags set';
	          state.mode = BAD;
	          break;
	        }
	        if (state.head) {
	          state.head.text = ((hold >> 8) & 1);
	        }
	        if (state.flags & 0x0200) {
	          //=== CRC2(state.check, hold);
	          hbuf[0] = hold & 0xff;
	          hbuf[1] = (hold >>> 8) & 0xff;
	          state.check = crc32(state.check, hbuf, 2, 0);
	          //===//
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        state.mode = TIME;
	        /* falls through */
	      case TIME:
	        //=== NEEDBITS(32); */
	        while (bits < 32) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        if (state.head) {
	          state.head.time = hold;
	        }
	        if (state.flags & 0x0200) {
	          //=== CRC4(state.check, hold)
	          hbuf[0] = hold & 0xff;
	          hbuf[1] = (hold >>> 8) & 0xff;
	          hbuf[2] = (hold >>> 16) & 0xff;
	          hbuf[3] = (hold >>> 24) & 0xff;
	          state.check = crc32(state.check, hbuf, 4, 0);
	          //===
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        state.mode = OS;
	        /* falls through */
	      case OS:
	        //=== NEEDBITS(16); */
	        while (bits < 16) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        if (state.head) {
	          state.head.xflags = (hold & 0xff);
	          state.head.os = (hold >> 8);
	        }
	        if (state.flags & 0x0200) {
	          //=== CRC2(state.check, hold);
	          hbuf[0] = hold & 0xff;
	          hbuf[1] = (hold >>> 8) & 0xff;
	          state.check = crc32(state.check, hbuf, 2, 0);
	          //===//
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        state.mode = EXLEN;
	        /* falls through */
	      case EXLEN:
	        if (state.flags & 0x0400) {
	          //=== NEEDBITS(16); */
	          while (bits < 16) {
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	          }
	          //===//
	          state.length = hold;
	          if (state.head) {
	            state.head.extra_len = hold;
	          }
	          if (state.flags & 0x0200) {
	            //=== CRC2(state.check, hold);
	            hbuf[0] = hold & 0xff;
	            hbuf[1] = (hold >>> 8) & 0xff;
	            state.check = crc32(state.check, hbuf, 2, 0);
	            //===//
	          }
	          //=== INITBITS();
	          hold = 0;
	          bits = 0;
	          //===//
	        }
	        else if (state.head) {
	          state.head.extra = null/*Z_NULL*/;
	        }
	        state.mode = EXTRA;
	        /* falls through */
	      case EXTRA:
	        if (state.flags & 0x0400) {
	          copy = state.length;
	          if (copy > have) { copy = have; }
	          if (copy) {
	            if (state.head) {
	              len = state.head.extra_len - state.length;
	              if (!state.head.extra) {
	                // Use untyped array for more convenient processing later
	                state.head.extra = new Array(state.head.extra_len);
	              }
	              utils.arraySet(
	                state.head.extra,
	                input,
	                next,
	                // extra field is limited to 65536 bytes
	                // - no need for additional size check
	                copy,
	                /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
	                len
	              );
	              //zmemcpy(state.head.extra + len, next,
	              //        len + copy > state.head.extra_max ?
	              //        state.head.extra_max - len : copy);
	            }
	            if (state.flags & 0x0200) {
	              state.check = crc32(state.check, input, copy, next);
	            }
	            have -= copy;
	            next += copy;
	            state.length -= copy;
	          }
	          if (state.length) { break inf_leave; }
	        }
	        state.length = 0;
	        state.mode = NAME;
	        /* falls through */
	      case NAME:
	        if (state.flags & 0x0800) {
	          if (have === 0) { break inf_leave; }
	          copy = 0;
	          do {
	            // TODO: 2 or 1 bytes?
	            len = input[next + copy++];
	            /* use constant limit because in js we should not preallocate memory */
	            if (state.head && len &&
	                (state.length < 65536 /*state.head.name_max*/)) {
	              state.head.name += String.fromCharCode(len);
	            }
	          } while (len && copy < have);
	
	          if (state.flags & 0x0200) {
	            state.check = crc32(state.check, input, copy, next);
	          }
	          have -= copy;
	          next += copy;
	          if (len) { break inf_leave; }
	        }
	        else if (state.head) {
	          state.head.name = null;
	        }
	        state.length = 0;
	        state.mode = COMMENT;
	        /* falls through */
	      case COMMENT:
	        if (state.flags & 0x1000) {
	          if (have === 0) { break inf_leave; }
	          copy = 0;
	          do {
	            len = input[next + copy++];
	            /* use constant limit because in js we should not preallocate memory */
	            if (state.head && len &&
	                (state.length < 65536 /*state.head.comm_max*/)) {
	              state.head.comment += String.fromCharCode(len);
	            }
	          } while (len && copy < have);
	          if (state.flags & 0x0200) {
	            state.check = crc32(state.check, input, copy, next);
	          }
	          have -= copy;
	          next += copy;
	          if (len) { break inf_leave; }
	        }
	        else if (state.head) {
	          state.head.comment = null;
	        }
	        state.mode = HCRC;
	        /* falls through */
	      case HCRC:
	        if (state.flags & 0x0200) {
	          //=== NEEDBITS(16); */
	          while (bits < 16) {
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	          }
	          //===//
	          if (hold !== (state.check & 0xffff)) {
	            strm.msg = 'header crc mismatch';
	            state.mode = BAD;
	            break;
	          }
	          //=== INITBITS();
	          hold = 0;
	          bits = 0;
	          //===//
	        }
	        if (state.head) {
	          state.head.hcrc = ((state.flags >> 9) & 1);
	          state.head.done = true;
	        }
	        strm.adler = state.check = 0;
	        state.mode = TYPE;
	        break;
	      case DICTID:
	        //=== NEEDBITS(32); */
	        while (bits < 32) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        strm.adler = state.check = zswap32(hold);
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        state.mode = DICT;
	        /* falls through */
	      case DICT:
	        if (state.havedict === 0) {
	          //--- RESTORE() ---
	          strm.next_out = put;
	          strm.avail_out = left;
	          strm.next_in = next;
	          strm.avail_in = have;
	          state.hold = hold;
	          state.bits = bits;
	          //---
	          return Z_NEED_DICT;
	        }
	        strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
	        state.mode = TYPE;
	        /* falls through */
	      case TYPE:
	        if (flush === Z_BLOCK || flush === Z_TREES) { break inf_leave; }
	        /* falls through */
	      case TYPEDO:
	        if (state.last) {
	          //--- BYTEBITS() ---//
	          hold >>>= bits & 7;
	          bits -= bits & 7;
	          //---//
	          state.mode = CHECK;
	          break;
	        }
	        //=== NEEDBITS(3); */
	        while (bits < 3) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.last = (hold & 0x01)/*BITS(1)*/;
	        //--- DROPBITS(1) ---//
	        hold >>>= 1;
	        bits -= 1;
	        //---//
	
	        switch ((hold & 0x03)/*BITS(2)*/) {
	          case 0:                             /* stored block */
	            //Tracev((stderr, "inflate:     stored block%s\n",
	            //        state.last ? " (last)" : ""));
	            state.mode = STORED;
	            break;
	          case 1:                             /* fixed block */
	            fixedtables(state);
	            //Tracev((stderr, "inflate:     fixed codes block%s\n",
	            //        state.last ? " (last)" : ""));
	            state.mode = LEN_;             /* decode codes */
	            if (flush === Z_TREES) {
	              //--- DROPBITS(2) ---//
	              hold >>>= 2;
	              bits -= 2;
	              //---//
	              break inf_leave;
	            }
	            break;
	          case 2:                             /* dynamic block */
	            //Tracev((stderr, "inflate:     dynamic codes block%s\n",
	            //        state.last ? " (last)" : ""));
	            state.mode = TABLE;
	            break;
	          case 3:
	            strm.msg = 'invalid block type';
	            state.mode = BAD;
	        }
	        //--- DROPBITS(2) ---//
	        hold >>>= 2;
	        bits -= 2;
	        //---//
	        break;
	      case STORED:
	        //--- BYTEBITS() ---// /* go to byte boundary */
	        hold >>>= bits & 7;
	        bits -= bits & 7;
	        //---//
	        //=== NEEDBITS(32); */
	        while (bits < 32) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        if ((hold & 0xffff) !== ((hold >>> 16) ^ 0xffff)) {
	          strm.msg = 'invalid stored block lengths';
	          state.mode = BAD;
	          break;
	        }
	        state.length = hold & 0xffff;
	        //Tracev((stderr, "inflate:       stored length %u\n",
	        //        state.length));
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        state.mode = COPY_;
	        if (flush === Z_TREES) { break inf_leave; }
	        /* falls through */
	      case COPY_:
	        state.mode = COPY;
	        /* falls through */
	      case COPY:
	        copy = state.length;
	        if (copy) {
	          if (copy > have) { copy = have; }
	          if (copy > left) { copy = left; }
	          if (copy === 0) { break inf_leave; }
	          //--- zmemcpy(put, next, copy); ---
	          utils.arraySet(output, input, next, copy, put);
	          //---//
	          have -= copy;
	          next += copy;
	          left -= copy;
	          put += copy;
	          state.length -= copy;
	          break;
	        }
	        //Tracev((stderr, "inflate:       stored end\n"));
	        state.mode = TYPE;
	        break;
	      case TABLE:
	        //=== NEEDBITS(14); */
	        while (bits < 14) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.nlen = (hold & 0x1f)/*BITS(5)*/ + 257;
	        //--- DROPBITS(5) ---//
	        hold >>>= 5;
	        bits -= 5;
	        //---//
	        state.ndist = (hold & 0x1f)/*BITS(5)*/ + 1;
	        //--- DROPBITS(5) ---//
	        hold >>>= 5;
	        bits -= 5;
	        //---//
	        state.ncode = (hold & 0x0f)/*BITS(4)*/ + 4;
	        //--- DROPBITS(4) ---//
	        hold >>>= 4;
	        bits -= 4;
	        //---//
	//#ifndef PKZIP_BUG_WORKAROUND
	        if (state.nlen > 286 || state.ndist > 30) {
	          strm.msg = 'too many length or distance symbols';
	          state.mode = BAD;
	          break;
	        }
	//#endif
	        //Tracev((stderr, "inflate:       table sizes ok\n"));
	        state.have = 0;
	        state.mode = LENLENS;
	        /* falls through */
	      case LENLENS:
	        while (state.have < state.ncode) {
	          //=== NEEDBITS(3);
	          while (bits < 3) {
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	          }
	          //===//
	          state.lens[order[state.have++]] = (hold & 0x07);//BITS(3);
	          //--- DROPBITS(3) ---//
	          hold >>>= 3;
	          bits -= 3;
	          //---//
	        }
	        while (state.have < 19) {
	          state.lens[order[state.have++]] = 0;
	        }
	        // We have separate tables & no pointers. 2 commented lines below not needed.
	        //state.next = state.codes;
	        //state.lencode = state.next;
	        // Switch to use dynamic table
	        state.lencode = state.lendyn;
	        state.lenbits = 7;
	
	        opts = { bits: state.lenbits };
	        ret = inflate_table(CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
	        state.lenbits = opts.bits;
	
	        if (ret) {
	          strm.msg = 'invalid code lengths set';
	          state.mode = BAD;
	          break;
	        }
	        //Tracev((stderr, "inflate:       code lengths ok\n"));
	        state.have = 0;
	        state.mode = CODELENS;
	        /* falls through */
	      case CODELENS:
	        while (state.have < state.nlen + state.ndist) {
	          for (;;) {
	            here = state.lencode[hold & ((1 << state.lenbits) - 1)];/*BITS(state.lenbits)*/
	            here_bits = here >>> 24;
	            here_op = (here >>> 16) & 0xff;
	            here_val = here & 0xffff;
	
	            if ((here_bits) <= bits) { break; }
	            //--- PULLBYTE() ---//
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	            //---//
	          }
	          if (here_val < 16) {
	            //--- DROPBITS(here.bits) ---//
	            hold >>>= here_bits;
	            bits -= here_bits;
	            //---//
	            state.lens[state.have++] = here_val;
	          }
	          else {
	            if (here_val === 16) {
	              //=== NEEDBITS(here.bits + 2);
	              n = here_bits + 2;
	              while (bits < n) {
	                if (have === 0) { break inf_leave; }
	                have--;
	                hold += input[next++] << bits;
	                bits += 8;
	              }
	              //===//
	              //--- DROPBITS(here.bits) ---//
	              hold >>>= here_bits;
	              bits -= here_bits;
	              //---//
	              if (state.have === 0) {
	                strm.msg = 'invalid bit length repeat';
	                state.mode = BAD;
	                break;
	              }
	              len = state.lens[state.have - 1];
	              copy = 3 + (hold & 0x03);//BITS(2);
	              //--- DROPBITS(2) ---//
	              hold >>>= 2;
	              bits -= 2;
	              //---//
	            }
	            else if (here_val === 17) {
	              //=== NEEDBITS(here.bits + 3);
	              n = here_bits + 3;
	              while (bits < n) {
	                if (have === 0) { break inf_leave; }
	                have--;
	                hold += input[next++] << bits;
	                bits += 8;
	              }
	              //===//
	              //--- DROPBITS(here.bits) ---//
	              hold >>>= here_bits;
	              bits -= here_bits;
	              //---//
	              len = 0;
	              copy = 3 + (hold & 0x07);//BITS(3);
	              //--- DROPBITS(3) ---//
	              hold >>>= 3;
	              bits -= 3;
	              //---//
	            }
	            else {
	              //=== NEEDBITS(here.bits + 7);
	              n = here_bits + 7;
	              while (bits < n) {
	                if (have === 0) { break inf_leave; }
	                have--;
	                hold += input[next++] << bits;
	                bits += 8;
	              }
	              //===//
	              //--- DROPBITS(here.bits) ---//
	              hold >>>= here_bits;
	              bits -= here_bits;
	              //---//
	              len = 0;
	              copy = 11 + (hold & 0x7f);//BITS(7);
	              //--- DROPBITS(7) ---//
	              hold >>>= 7;
	              bits -= 7;
	              //---//
	            }
	            if (state.have + copy > state.nlen + state.ndist) {
	              strm.msg = 'invalid bit length repeat';
	              state.mode = BAD;
	              break;
	            }
	            while (copy--) {
	              state.lens[state.have++] = len;
	            }
	          }
	        }
	
	        /* handle error breaks in while */
	        if (state.mode === BAD) { break; }
	
	        /* check for end-of-block code (better have one) */
	        if (state.lens[256] === 0) {
	          strm.msg = 'invalid code -- missing end-of-block';
	          state.mode = BAD;
	          break;
	        }
	
	        /* build code tables -- note: do not change the lenbits or distbits
	           values here (9 and 6) without reading the comments in inftrees.h
	           concerning the ENOUGH constants, which depend on those values */
	        state.lenbits = 9;
	
	        opts = { bits: state.lenbits };
	        ret = inflate_table(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
	        // We have separate tables & no pointers. 2 commented lines below not needed.
	        // state.next_index = opts.table_index;
	        state.lenbits = opts.bits;
	        // state.lencode = state.next;
	
	        if (ret) {
	          strm.msg = 'invalid literal/lengths set';
	          state.mode = BAD;
	          break;
	        }
	
	        state.distbits = 6;
	        //state.distcode.copy(state.codes);
	        // Switch to use dynamic table
	        state.distcode = state.distdyn;
	        opts = { bits: state.distbits };
	        ret = inflate_table(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
	        // We have separate tables & no pointers. 2 commented lines below not needed.
	        // state.next_index = opts.table_index;
	        state.distbits = opts.bits;
	        // state.distcode = state.next;
	
	        if (ret) {
	          strm.msg = 'invalid distances set';
	          state.mode = BAD;
	          break;
	        }
	        //Tracev((stderr, 'inflate:       codes ok\n'));
	        state.mode = LEN_;
	        if (flush === Z_TREES) { break inf_leave; }
	        /* falls through */
	      case LEN_:
	        state.mode = LEN;
	        /* falls through */
	      case LEN:
	        if (have >= 6 && left >= 258) {
	          //--- RESTORE() ---
	          strm.next_out = put;
	          strm.avail_out = left;
	          strm.next_in = next;
	          strm.avail_in = have;
	          state.hold = hold;
	          state.bits = bits;
	          //---
	          inflate_fast(strm, _out);
	          //--- LOAD() ---
	          put = strm.next_out;
	          output = strm.output;
	          left = strm.avail_out;
	          next = strm.next_in;
	          input = strm.input;
	          have = strm.avail_in;
	          hold = state.hold;
	          bits = state.bits;
	          //---
	
	          if (state.mode === TYPE) {
	            state.back = -1;
	          }
	          break;
	        }
	        state.back = 0;
	        for (;;) {
	          here = state.lencode[hold & ((1 << state.lenbits) - 1)];  /*BITS(state.lenbits)*/
	          here_bits = here >>> 24;
	          here_op = (here >>> 16) & 0xff;
	          here_val = here & 0xffff;
	
	          if (here_bits <= bits) { break; }
	          //--- PULLBYTE() ---//
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	          //---//
	        }
	        if (here_op && (here_op & 0xf0) === 0) {
	          last_bits = here_bits;
	          last_op = here_op;
	          last_val = here_val;
	          for (;;) {
	            here = state.lencode[last_val +
	                    ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
	            here_bits = here >>> 24;
	            here_op = (here >>> 16) & 0xff;
	            here_val = here & 0xffff;
	
	            if ((last_bits + here_bits) <= bits) { break; }
	            //--- PULLBYTE() ---//
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	            //---//
	          }
	          //--- DROPBITS(last.bits) ---//
	          hold >>>= last_bits;
	          bits -= last_bits;
	          //---//
	          state.back += last_bits;
	        }
	        //--- DROPBITS(here.bits) ---//
	        hold >>>= here_bits;
	        bits -= here_bits;
	        //---//
	        state.back += here_bits;
	        state.length = here_val;
	        if (here_op === 0) {
	          //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
	          //        "inflate:         literal '%c'\n" :
	          //        "inflate:         literal 0x%02x\n", here.val));
	          state.mode = LIT;
	          break;
	        }
	        if (here_op & 32) {
	          //Tracevv((stderr, "inflate:         end of block\n"));
	          state.back = -1;
	          state.mode = TYPE;
	          break;
	        }
	        if (here_op & 64) {
	          strm.msg = 'invalid literal/length code';
	          state.mode = BAD;
	          break;
	        }
	        state.extra = here_op & 15;
	        state.mode = LENEXT;
	        /* falls through */
	      case LENEXT:
	        if (state.extra) {
	          //=== NEEDBITS(state.extra);
	          n = state.extra;
	          while (bits < n) {
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	          }
	          //===//
	          state.length += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
	          //--- DROPBITS(state.extra) ---//
	          hold >>>= state.extra;
	          bits -= state.extra;
	          //---//
	          state.back += state.extra;
	        }
	        //Tracevv((stderr, "inflate:         length %u\n", state.length));
	        state.was = state.length;
	        state.mode = DIST;
	        /* falls through */
	      case DIST:
	        for (;;) {
	          here = state.distcode[hold & ((1 << state.distbits) - 1)];/*BITS(state.distbits)*/
	          here_bits = here >>> 24;
	          here_op = (here >>> 16) & 0xff;
	          here_val = here & 0xffff;
	
	          if ((here_bits) <= bits) { break; }
	          //--- PULLBYTE() ---//
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	          //---//
	        }
	        if ((here_op & 0xf0) === 0) {
	          last_bits = here_bits;
	          last_op = here_op;
	          last_val = here_val;
	          for (;;) {
	            here = state.distcode[last_val +
	                    ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
	            here_bits = here >>> 24;
	            here_op = (here >>> 16) & 0xff;
	            here_val = here & 0xffff;
	
	            if ((last_bits + here_bits) <= bits) { break; }
	            //--- PULLBYTE() ---//
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	            //---//
	          }
	          //--- DROPBITS(last.bits) ---//
	          hold >>>= last_bits;
	          bits -= last_bits;
	          //---//
	          state.back += last_bits;
	        }
	        //--- DROPBITS(here.bits) ---//
	        hold >>>= here_bits;
	        bits -= here_bits;
	        //---//
	        state.back += here_bits;
	        if (here_op & 64) {
	          strm.msg = 'invalid distance code';
	          state.mode = BAD;
	          break;
	        }
	        state.offset = here_val;
	        state.extra = (here_op) & 15;
	        state.mode = DISTEXT;
	        /* falls through */
	      case DISTEXT:
	        if (state.extra) {
	          //=== NEEDBITS(state.extra);
	          n = state.extra;
	          while (bits < n) {
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	          }
	          //===//
	          state.offset += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
	          //--- DROPBITS(state.extra) ---//
	          hold >>>= state.extra;
	          bits -= state.extra;
	          //---//
	          state.back += state.extra;
	        }
	//#ifdef INFLATE_STRICT
	        if (state.offset > state.dmax) {
	          strm.msg = 'invalid distance too far back';
	          state.mode = BAD;
	          break;
	        }
	//#endif
	        //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
	        state.mode = MATCH;
	        /* falls through */
	      case MATCH:
	        if (left === 0) { break inf_leave; }
	        copy = _out - left;
	        if (state.offset > copy) {         /* copy from window */
	          copy = state.offset - copy;
	          if (copy > state.whave) {
	            if (state.sane) {
	              strm.msg = 'invalid distance too far back';
	              state.mode = BAD;
	              break;
	            }
	// (!) This block is disabled in zlib defaults,
	// don't enable it for binary compatibility
	//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
	//          Trace((stderr, "inflate.c too far\n"));
	//          copy -= state.whave;
	//          if (copy > state.length) { copy = state.length; }
	//          if (copy > left) { copy = left; }
	//          left -= copy;
	//          state.length -= copy;
	//          do {
	//            output[put++] = 0;
	//          } while (--copy);
	//          if (state.length === 0) { state.mode = LEN; }
	//          break;
	//#endif
	          }
	          if (copy > state.wnext) {
	            copy -= state.wnext;
	            from = state.wsize - copy;
	          }
	          else {
	            from = state.wnext - copy;
	          }
	          if (copy > state.length) { copy = state.length; }
	          from_source = state.window;
	        }
	        else {                              /* copy from output */
	          from_source = output;
	          from = put - state.offset;
	          copy = state.length;
	        }
	        if (copy > left) { copy = left; }
	        left -= copy;
	        state.length -= copy;
	        do {
	          output[put++] = from_source[from++];
	        } while (--copy);
	        if (state.length === 0) { state.mode = LEN; }
	        break;
	      case LIT:
	        if (left === 0) { break inf_leave; }
	        output[put++] = state.length;
	        left--;
	        state.mode = LEN;
	        break;
	      case CHECK:
	        if (state.wrap) {
	          //=== NEEDBITS(32);
	          while (bits < 32) {
	            if (have === 0) { break inf_leave; }
	            have--;
	            // Use '|' instead of '+' to make sure that result is signed
	            hold |= input[next++] << bits;
	            bits += 8;
	          }
	          //===//
	          _out -= left;
	          strm.total_out += _out;
	          state.total += _out;
	          if (_out) {
	            strm.adler = state.check =
	                /*UPDATE(state.check, put - _out, _out);*/
	                (state.flags ? crc32(state.check, output, _out, put - _out) : adler32(state.check, output, _out, put - _out));
	
	          }
	          _out = left;
	          // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
	          if ((state.flags ? hold : zswap32(hold)) !== state.check) {
	            strm.msg = 'incorrect data check';
	            state.mode = BAD;
	            break;
	          }
	          //=== INITBITS();
	          hold = 0;
	          bits = 0;
	          //===//
	          //Tracev((stderr, "inflate:   check matches trailer\n"));
	        }
	        state.mode = LENGTH;
	        /* falls through */
	      case LENGTH:
	        if (state.wrap && state.flags) {
	          //=== NEEDBITS(32);
	          while (bits < 32) {
	            if (have === 0) { break inf_leave; }
	            have--;
	            hold += input[next++] << bits;
	            bits += 8;
	          }
	          //===//
	          if (hold !== (state.total & 0xffffffff)) {
	            strm.msg = 'incorrect length check';
	            state.mode = BAD;
	            break;
	          }
	          //=== INITBITS();
	          hold = 0;
	          bits = 0;
	          //===//
	          //Tracev((stderr, "inflate:   length matches trailer\n"));
	        }
	        state.mode = DONE;
	        /* falls through */
	      case DONE:
	        ret = Z_STREAM_END;
	        break inf_leave;
	      case BAD:
	        ret = Z_DATA_ERROR;
	        break inf_leave;
	      case MEM:
	        return Z_MEM_ERROR;
	      case SYNC:
	        /* falls through */
	      default:
	        return Z_STREAM_ERROR;
	    }
	  }
	
	  // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
	
	  /*
	     Return from inflate(), updating the total counts and the check value.
	     If there was no progress during the inflate() call, return a buffer
	     error.  Call updatewindow() to create and/or update the window state.
	     Note: a memory error from inflate() is non-recoverable.
	   */
	
	  //--- RESTORE() ---
	  strm.next_out = put;
	  strm.avail_out = left;
	  strm.next_in = next;
	  strm.avail_in = have;
	  state.hold = hold;
	  state.bits = bits;
	  //---
	
	  if (state.wsize || (_out !== strm.avail_out && state.mode < BAD &&
	                      (state.mode < CHECK || flush !== Z_FINISH))) {
	    if (updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
	      state.mode = MEM;
	      return Z_MEM_ERROR;
	    }
	  }
	  _in -= strm.avail_in;
	  _out -= strm.avail_out;
	  strm.total_in += _in;
	  strm.total_out += _out;
	  state.total += _out;
	  if (state.wrap && _out) {
	    strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
	      (state.flags ? crc32(state.check, output, _out, strm.next_out - _out) : adler32(state.check, output, _out, strm.next_out - _out));
	  }
	  strm.data_type = state.bits + (state.last ? 64 : 0) +
	                    (state.mode === TYPE ? 128 : 0) +
	                    (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
	  if (((_in === 0 && _out === 0) || flush === Z_FINISH) && ret === Z_OK) {
	    ret = Z_BUF_ERROR;
	  }
	  return ret;
	}
	
	function inflateEnd(strm) {
	
	  if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/) {
	    return Z_STREAM_ERROR;
	  }
	
	  var state = strm.state;
	  if (state.window) {
	    state.window = null;
	  }
	  strm.state = null;
	  return Z_OK;
	}
	
	function inflateGetHeader(strm, head) {
	  var state;
	
	  /* check state */
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	  if ((state.wrap & 2) === 0) { return Z_STREAM_ERROR; }
	
	  /* save header structure */
	  state.head = head;
	  head.done = false;
	  return Z_OK;
	}
	
	function inflateSetDictionary(strm, dictionary) {
	  var dictLength = dictionary.length;
	
	  var state;
	  var dictid;
	  var ret;
	
	  /* check state */
	  if (!strm /* == Z_NULL */ || !strm.state /* == Z_NULL */) { return Z_STREAM_ERROR; }
	  state = strm.state;
	
	  if (state.wrap !== 0 && state.mode !== DICT) {
	    return Z_STREAM_ERROR;
	  }
	
	  /* check for correct dictionary identifier */
	  if (state.mode === DICT) {
	    dictid = 1; /* adler32(0, null, 0)*/
	    /* dictid = adler32(dictid, dictionary, dictLength); */
	    dictid = adler32(dictid, dictionary, dictLength, 0);
	    if (dictid !== state.check) {
	      return Z_DATA_ERROR;
	    }
	  }
	  /* copy dictionary to window using updatewindow(), which will amend the
	   existing dictionary if appropriate */
	  ret = updatewindow(strm, dictionary, dictLength, dictLength);
	  if (ret) {
	    state.mode = MEM;
	    return Z_MEM_ERROR;
	  }
	  state.havedict = 1;
	  // Tracev((stderr, "inflate:   dictionary set\n"));
	  return Z_OK;
	}
	
	exports.inflateReset = inflateReset;
	exports.inflateReset2 = inflateReset2;
	exports.inflateResetKeep = inflateResetKeep;
	exports.inflateInit = inflateInit;
	exports.inflateInit2 = inflateInit2;
	exports.inflate = inflate;
	exports.inflateEnd = inflateEnd;
	exports.inflateGetHeader = inflateGetHeader;
	exports.inflateSetDictionary = inflateSetDictionary;
	exports.inflateInfo = 'pako inflate (from Nodeca project)';
	
	/* Not implemented
	exports.inflateCopy = inflateCopy;
	exports.inflateGetDictionary = inflateGetDictionary;
	exports.inflateMark = inflateMark;
	exports.inflatePrime = inflatePrime;
	exports.inflateSync = inflateSync;
	exports.inflateSyncPoint = inflateSyncPoint;
	exports.inflateUndermine = inflateUndermine;
	*/
	
	},{"../utils/common":5,"./adler32":7,"./crc32":9,"./inffast":11,"./inftrees":13}],13:[function(require,module,exports){
	'use strict';
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	var utils = require('../utils/common');
	
	var MAXBITS = 15;
	var ENOUGH_LENS = 852;
	var ENOUGH_DISTS = 592;
	//var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
	
	var CODES = 0;
	var LENS = 1;
	var DISTS = 2;
	
	var lbase = [ /* Length codes 257..285 base */
	  3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31,
	  35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0
	];
	
	var lext = [ /* Length codes 257..285 extra */
	  16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18,
	  19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78
	];
	
	var dbase = [ /* Distance codes 0..29 base */
	  1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193,
	  257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145,
	  8193, 12289, 16385, 24577, 0, 0
	];
	
	var dext = [ /* Distance codes 0..29 extra */
	  16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22,
	  23, 23, 24, 24, 25, 25, 26, 26, 27, 27,
	  28, 28, 29, 29, 64, 64
	];
	
	module.exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts)
	{
	  var bits = opts.bits;
	      //here = opts.here; /* table entry for duplication */
	
	  var len = 0;               /* a code's length in bits */
	  var sym = 0;               /* index of code symbols */
	  var min = 0, max = 0;          /* minimum and maximum code lengths */
	  var root = 0;              /* number of index bits for root table */
	  var curr = 0;              /* number of index bits for current table */
	  var drop = 0;              /* code bits to drop for sub-table */
	  var left = 0;                   /* number of prefix codes available */
	  var used = 0;              /* code entries in table used */
	  var huff = 0;              /* Huffman code */
	  var incr;              /* for incrementing code, index */
	  var fill;              /* index for replicating entries */
	  var low;               /* low bits for current root entry */
	  var mask;              /* mask for low root bits */
	  var next;             /* next available space in table */
	  var base = null;     /* base value table to use */
	  var base_index = 0;
	//  var shoextra;    /* extra bits table to use */
	  var end;                    /* use base and extra for symbol > end */
	  var count = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
	  var offs = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
	  var extra = null;
	  var extra_index = 0;
	
	  var here_bits, here_op, here_val;
	
	  /*
	   Process a set of code lengths to create a canonical Huffman code.  The
	   code lengths are lens[0..codes-1].  Each length corresponds to the
	   symbols 0..codes-1.  The Huffman code is generated by first sorting the
	   symbols by length from short to long, and retaining the symbol order
	   for codes with equal lengths.  Then the code starts with all zero bits
	   for the first code of the shortest length, and the codes are integer
	   increments for the same length, and zeros are appended as the length
	   increases.  For the deflate format, these bits are stored backwards
	   from their more natural integer increment ordering, and so when the
	   decoding tables are built in the large loop below, the integer codes
	   are incremented backwards.
	
	   This routine assumes, but does not check, that all of the entries in
	   lens[] are in the range 0..MAXBITS.  The caller must assure this.
	   1..MAXBITS is interpreted as that code length.  zero means that that
	   symbol does not occur in this code.
	
	   The codes are sorted by computing a count of codes for each length,
	   creating from that a table of starting indices for each length in the
	   sorted table, and then entering the symbols in order in the sorted
	   table.  The sorted table is work[], with that space being provided by
	   the caller.
	
	   The length counts are used for other purposes as well, i.e. finding
	   the minimum and maximum length codes, determining if there are any
	   codes at all, checking for a valid set of lengths, and looking ahead
	   at length counts to determine sub-table sizes when building the
	   decoding tables.
	   */
	
	  /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */
	  for (len = 0; len <= MAXBITS; len++) {
	    count[len] = 0;
	  }
	  for (sym = 0; sym < codes; sym++) {
	    count[lens[lens_index + sym]]++;
	  }
	
	  /* bound code lengths, force root to be within code lengths */
	  root = bits;
	  for (max = MAXBITS; max >= 1; max--) {
	    if (count[max] !== 0) { break; }
	  }
	  if (root > max) {
	    root = max;
	  }
	  if (max === 0) {                     /* no symbols to code at all */
	    //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
	    //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
	    //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
	    table[table_index++] = (1 << 24) | (64 << 16) | 0;
	
	
	    //table.op[opts.table_index] = 64;
	    //table.bits[opts.table_index] = 1;
	    //table.val[opts.table_index++] = 0;
	    table[table_index++] = (1 << 24) | (64 << 16) | 0;
	
	    opts.bits = 1;
	    return 0;     /* no symbols, but wait for decoding to report error */
	  }
	  for (min = 1; min < max; min++) {
	    if (count[min] !== 0) { break; }
	  }
	  if (root < min) {
	    root = min;
	  }
	
	  /* check for an over-subscribed or incomplete set of lengths */
	  left = 1;
	  for (len = 1; len <= MAXBITS; len++) {
	    left <<= 1;
	    left -= count[len];
	    if (left < 0) {
	      return -1;
	    }        /* over-subscribed */
	  }
	  if (left > 0 && (type === CODES || max !== 1)) {
	    return -1;                      /* incomplete set */
	  }
	
	  /* generate offsets into symbol table for each length for sorting */
	  offs[1] = 0;
	  for (len = 1; len < MAXBITS; len++) {
	    offs[len + 1] = offs[len] + count[len];
	  }
	
	  /* sort symbols by length, by symbol order within each length */
	  for (sym = 0; sym < codes; sym++) {
	    if (lens[lens_index + sym] !== 0) {
	      work[offs[lens[lens_index + sym]]++] = sym;
	    }
	  }
	
	  /*
	   Create and fill in decoding tables.  In this loop, the table being
	   filled is at next and has curr index bits.  The code being used is huff
	   with length len.  That code is converted to an index by dropping drop
	   bits off of the bottom.  For codes where len is less than drop + curr,
	   those top drop + curr - len bits are incremented through all values to
	   fill the table with replicated entries.
	
	   root is the number of index bits for the root table.  When len exceeds
	   root, sub-tables are created pointed to by the root entry with an index
	   of the low root bits of huff.  This is saved in low to check for when a
	   new sub-table should be started.  drop is zero when the root table is
	   being filled, and drop is root when sub-tables are being filled.
	
	   When a new sub-table is needed, it is necessary to look ahead in the
	   code lengths to determine what size sub-table is needed.  The length
	   counts are used for this, and so count[] is decremented as codes are
	   entered in the tables.
	
	   used keeps track of how many table entries have been allocated from the
	   provided *table space.  It is checked for LENS and DIST tables against
	   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
	   the initial root table size constants.  See the comments in inftrees.h
	   for more information.
	
	   sym increments through all symbols, and the loop terminates when
	   all codes of length max, i.e. all codes, have been processed.  This
	   routine permits incomplete codes, so another loop after this one fills
	   in the rest of the decoding tables with invalid code markers.
	   */
	
	  /* set up for code type */
	  // poor man optimization - use if-else instead of switch,
	  // to avoid deopts in old v8
	  if (type === CODES) {
	    base = extra = work;    /* dummy value--not used */
	    end = 19;
	
	  } else if (type === LENS) {
	    base = lbase;
	    base_index -= 257;
	    extra = lext;
	    extra_index -= 257;
	    end = 256;
	
	  } else {                    /* DISTS */
	    base = dbase;
	    extra = dext;
	    end = -1;
	  }
	
	  /* initialize opts for loop */
	  huff = 0;                   /* starting code */
	  sym = 0;                    /* starting code symbol */
	  len = min;                  /* starting code length */
	  next = table_index;              /* current table to fill in */
	  curr = root;                /* current table index bits */
	  drop = 0;                   /* current bits to drop from code for index */
	  low = -1;                   /* trigger new sub-table when len > root */
	  used = 1 << root;          /* use root table entries */
	  mask = used - 1;            /* mask for comparing low */
	
	  /* check available table space */
	  if ((type === LENS && used > ENOUGH_LENS) ||
	    (type === DISTS && used > ENOUGH_DISTS)) {
	    return 1;
	  }
	
	  /* process all codes and make table entries */
	  for (;;) {
	    /* create table entry */
	    here_bits = len - drop;
	    if (work[sym] < end) {
	      here_op = 0;
	      here_val = work[sym];
	    }
	    else if (work[sym] > end) {
	      here_op = extra[extra_index + work[sym]];
	      here_val = base[base_index + work[sym]];
	    }
	    else {
	      here_op = 32 + 64;         /* end of block */
	      here_val = 0;
	    }
	
	    /* replicate for those indices with low len bits equal to huff */
	    incr = 1 << (len - drop);
	    fill = 1 << curr;
	    min = fill;                 /* save offset to next table */
	    do {
	      fill -= incr;
	      table[next + (huff >> drop) + fill] = (here_bits << 24) | (here_op << 16) | here_val |0;
	    } while (fill !== 0);
	
	    /* backwards increment the len-bit code huff */
	    incr = 1 << (len - 1);
	    while (huff & incr) {
	      incr >>= 1;
	    }
	    if (incr !== 0) {
	      huff &= incr - 1;
	      huff += incr;
	    } else {
	      huff = 0;
	    }
	
	    /* go to next symbol, update count, len */
	    sym++;
	    if (--count[len] === 0) {
	      if (len === max) { break; }
	      len = lens[lens_index + work[sym]];
	    }
	
	    /* create new sub-table if needed */
	    if (len > root && (huff & mask) !== low) {
	      /* if first time, transition to sub-tables */
	      if (drop === 0) {
	        drop = root;
	      }
	
	      /* increment past last table */
	      next += min;            /* here min is 1 << curr */
	
	      /* determine length of next table */
	      curr = len - drop;
	      left = 1 << curr;
	      while (curr + drop < max) {
	        left -= count[curr + drop];
	        if (left <= 0) { break; }
	        curr++;
	        left <<= 1;
	      }
	
	      /* check for enough space */
	      used += 1 << curr;
	      if ((type === LENS && used > ENOUGH_LENS) ||
	        (type === DISTS && used > ENOUGH_DISTS)) {
	        return 1;
	      }
	
	      /* point entry in root table to sub-table */
	      low = huff & mask;
	      /*table.op[low] = curr;
	      table.bits[low] = root;
	      table.val[low] = next - opts.table_index;*/
	      table[low] = (root << 24) | (curr << 16) | (next - table_index) |0;
	    }
	  }
	
	  /* fill in remaining table entry if code is incomplete (guaranteed to have
	   at most one remaining entry, since if the code is incomplete, the
	   maximum code length that was allowed to get this far is one bit) */
	  if (huff !== 0) {
	    //table.op[next + huff] = 64;            /* invalid code marker */
	    //table.bits[next + huff] = len - drop;
	    //table.val[next + huff] = 0;
	    table[next + huff] = ((len - drop) << 24) | (64 << 16) |0;
	  }
	
	  /* set return parameters */
	  //opts.table_index += used;
	  opts.bits = root;
	  return 0;
	};
	
	},{"../utils/common":5}],14:[function(require,module,exports){
	'use strict';
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	module.exports = {
	  2:      'need dictionary',     /* Z_NEED_DICT       2  */
	  1:      'stream end',          /* Z_STREAM_END      1  */
	  0:      '',                    /* Z_OK              0  */
	  '-1':   'file error',          /* Z_ERRNO         (-1) */
	  '-2':   'stream error',        /* Z_STREAM_ERROR  (-2) */
	  '-3':   'data error',          /* Z_DATA_ERROR    (-3) */
	  '-4':   'insufficient memory', /* Z_MEM_ERROR     (-4) */
	  '-5':   'buffer error',        /* Z_BUF_ERROR     (-5) */
	  '-6':   'incompatible version' /* Z_VERSION_ERROR (-6) */
	};
	
	},{}],15:[function(require,module,exports){
	'use strict';
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	function ZStream() {
	  /* next input byte */
	  this.input = null; // JS specific, because we have no pointers
	  this.next_in = 0;
	  /* number of bytes available at input */
	  this.avail_in = 0;
	  /* total number of input bytes read so far */
	  this.total_in = 0;
	  /* next output byte should be put there */
	  this.output = null; // JS specific, because we have no pointers
	  this.next_out = 0;
	  /* remaining free space at output */
	  this.avail_out = 0;
	  /* total number of bytes output so far */
	  this.total_out = 0;
	  /* last error message, NULL if no error */
	  this.msg = ''/*Z_NULL*/;
	  /* not visible by applications */
	  this.state = null;
	  /* best guess about the data type: binary or text */
	  this.data_type = 2/*Z_UNKNOWN*/;
	  /* adler32 value of the uncompressed data */
	  this.adler = 0;
	}
	
	module.exports = ZStream;
	
	},{}]},{},[3])(3)
	});


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	var require;var require;(function(f){if(true){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.plantumlEncoder = f()}})(function(){var define,module,exports;return (function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return require(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
	'use strict'
	
	var pako = require('pako/lib/deflate.js')
	
	module.exports = function (data) {
	  return pako.deflateRaw(data, { level: 9, to: 'string' })
	}
	
	},{"pako/lib/deflate.js":4}],2:[function(require,module,exports){
	'use strict'
	
	// Encode code taken from the PlantUML website:
	// http://plantuml.sourceforge.net/codejavascript2.html
	
	// It is described as being "a transformation close to base64"
	// The code has been slightly modified to pass linters
	
	function encode6bit (b) {
	  if (b < 10) {
	    return String.fromCharCode(48 + b)
	  }
	  b -= 10
	  if (b < 26) {
	    return String.fromCharCode(65 + b)
	  }
	  b -= 26
	  if (b < 26) {
	    return String.fromCharCode(97 + b)
	  }
	  b -= 26
	  if (b === 0) {
	    return '-'
	  }
	  if (b === 1) {
	    return '_'
	  }
	  return '?'
	}
	
	function append3bytes (b1, b2, b3) {
	  var c1 = b1 >> 2
	  var c2 = ((b1 & 0x3) << 4) | (b2 >> 4)
	  var c3 = ((b2 & 0xF) << 2) | (b3 >> 6)
	  var c4 = b3 & 0x3F
	  var r = ''
	  r += encode6bit(c1 & 0x3F)
	  r += encode6bit(c2 & 0x3F)
	  r += encode6bit(c3 & 0x3F)
	  r += encode6bit(c4 & 0x3F)
	  return r
	}
	
	module.exports = function (data) {
	  var r = ''
	  for (var i = 0; i < data.length; i += 3) {
	    if (i + 2 === data.length) {
	      r += append3bytes(data.charCodeAt(i), data.charCodeAt(i + 1), 0)
	    } else if (i + 1 === data.length) {
	      r += append3bytes(data.charCodeAt(i), 0, 0)
	    } else {
	      r += append3bytes(data.charCodeAt(i),
	        data.charCodeAt(i + 1),
	        data.charCodeAt(i + 2))
	    }
	  }
	  return r
	}
	
	},{}],3:[function(require,module,exports){
	'use strict'
	
	var deflate = require('./deflate')
	var encode64 = require('./encode64')
	
	module.exports.encode = function (puml) {
	  var deflated = deflate(puml)
	  return encode64(deflated)
	}
	
	},{"./deflate":1,"./encode64":2}],4:[function(require,module,exports){
	'use strict';
	
	
	var zlib_deflate = require('./zlib/deflate');
	var utils        = require('./utils/common');
	var strings      = require('./utils/strings');
	var msg          = require('./zlib/messages');
	var ZStream      = require('./zlib/zstream');
	
	var toString = Object.prototype.toString;
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	var Z_NO_FLUSH      = 0;
	var Z_FINISH        = 4;
	
	var Z_OK            = 0;
	var Z_STREAM_END    = 1;
	var Z_SYNC_FLUSH    = 2;
	
	var Z_DEFAULT_COMPRESSION = -1;
	
	var Z_DEFAULT_STRATEGY    = 0;
	
	var Z_DEFLATED  = 8;
	
	/* ===========================================================================*/
	
	
	/**
	 * class Deflate
	 *
	 * Generic JS-style wrapper for zlib calls. If you don't need
	 * streaming behaviour - use more simple functions: [[deflate]],
	 * [[deflateRaw]] and [[gzip]].
	 **/
	
	/* internal
	 * Deflate.chunks -> Array
	 *
	 * Chunks of output data, if [[Deflate#onData]] not overridden.
	 **/
	
	/**
	 * Deflate.result -> Uint8Array|Array
	 *
	 * Compressed result, generated by default [[Deflate#onData]]
	 * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
	 * (call [[Deflate#push]] with `Z_FINISH` / `true` param)  or if you
	 * push a chunk with explicit flush (call [[Deflate#push]] with
	 * `Z_SYNC_FLUSH` param).
	 **/
	
	/**
	 * Deflate.err -> Number
	 *
	 * Error code after deflate finished. 0 (Z_OK) on success.
	 * You will not need it in real life, because deflate errors
	 * are possible only on wrong options or bad `onData` / `onEnd`
	 * custom handlers.
	 **/
	
	/**
	 * Deflate.msg -> String
	 *
	 * Error message, if [[Deflate.err]] != 0
	 **/
	
	
	/**
	 * new Deflate(options)
	 * - options (Object): zlib deflate options.
	 *
	 * Creates new deflator instance with specified params. Throws exception
	 * on bad params. Supported options:
	 *
	 * - `level`
	 * - `windowBits`
	 * - `memLevel`
	 * - `strategy`
	 * - `dictionary`
	 *
	 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
	 * for more information on these.
	 *
	 * Additional options, for internal needs:
	 *
	 * - `chunkSize` - size of generated data chunks (16K by default)
	 * - `raw` (Boolean) - do raw deflate
	 * - `gzip` (Boolean) - create gzip wrapper
	 * - `to` (String) - if equal to 'string', then result will be "binary string"
	 *    (each char code [0..255])
	 * - `header` (Object) - custom header for gzip
	 *   - `text` (Boolean) - true if compressed data believed to be text
	 *   - `time` (Number) - modification time, unix timestamp
	 *   - `os` (Number) - operation system code
	 *   - `extra` (Array) - array of bytes with extra data (max 65536)
	 *   - `name` (String) - file name (binary string)
	 *   - `comment` (String) - comment (binary string)
	 *   - `hcrc` (Boolean) - true if header crc should be added
	 *
	 * ##### Example:
	 *
	 * ```javascript
	 * var pako = require('pako')
	 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
	 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
	 *
	 * var deflate = new pako.Deflate({ level: 3});
	 *
	 * deflate.push(chunk1, false);
	 * deflate.push(chunk2, true);  // true -> last chunk
	 *
	 * if (deflate.err) { throw new Error(deflate.err); }
	 *
	 * console.log(deflate.result);
	 * ```
	 **/
	function Deflate(options) {
	  if (!(this instanceof Deflate)) return new Deflate(options);
	
	  this.options = utils.assign({
	    level: Z_DEFAULT_COMPRESSION,
	    method: Z_DEFLATED,
	    chunkSize: 16384,
	    windowBits: 15,
	    memLevel: 8,
	    strategy: Z_DEFAULT_STRATEGY,
	    to: ''
	  }, options || {});
	
	  var opt = this.options;
	
	  if (opt.raw && (opt.windowBits > 0)) {
	    opt.windowBits = -opt.windowBits;
	  }
	
	  else if (opt.gzip && (opt.windowBits > 0) && (opt.windowBits < 16)) {
	    opt.windowBits += 16;
	  }
	
	  this.err    = 0;      // error code, if happens (0 = Z_OK)
	  this.msg    = '';     // error message
	  this.ended  = false;  // used to avoid multiple onEnd() calls
	  this.chunks = [];     // chunks of compressed data
	
	  this.strm = new ZStream();
	  this.strm.avail_out = 0;
	
	  var status = zlib_deflate.deflateInit2(
	    this.strm,
	    opt.level,
	    opt.method,
	    opt.windowBits,
	    opt.memLevel,
	    opt.strategy
	  );
	
	  if (status !== Z_OK) {
	    throw new Error(msg[status]);
	  }
	
	  if (opt.header) {
	    zlib_deflate.deflateSetHeader(this.strm, opt.header);
	  }
	
	  if (opt.dictionary) {
	    var dict;
	    // Convert data if needed
	    if (typeof opt.dictionary === 'string') {
	      // If we need to compress text, change encoding to utf8.
	      dict = strings.string2buf(opt.dictionary);
	    } else if (toString.call(opt.dictionary) === '[object ArrayBuffer]') {
	      dict = new Uint8Array(opt.dictionary);
	    } else {
	      dict = opt.dictionary;
	    }
	
	    status = zlib_deflate.deflateSetDictionary(this.strm, dict);
	
	    if (status !== Z_OK) {
	      throw new Error(msg[status]);
	    }
	
	    this._dict_set = true;
	  }
	}
	
	/**
	 * Deflate#push(data[, mode]) -> Boolean
	 * - data (Uint8Array|Array|ArrayBuffer|String): input data. Strings will be
	 *   converted to utf8 byte sequence.
	 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
	 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
	 *
	 * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
	 * new compressed chunks. Returns `true` on success. The last data block must have
	 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
	 * [[Deflate#onEnd]]. For interim explicit flushes (without ending the stream) you
	 * can use mode Z_SYNC_FLUSH, keeping the compression context.
	 *
	 * On fail call [[Deflate#onEnd]] with error code and return false.
	 *
	 * We strongly recommend to use `Uint8Array` on input for best speed (output
	 * array format is detected automatically). Also, don't skip last param and always
	 * use the same type in your code (boolean or number). That will improve JS speed.
	 *
	 * For regular `Array`-s make sure all elements are [0..255].
	 *
	 * ##### Example
	 *
	 * ```javascript
	 * push(chunk, false); // push one of data chunks
	 * ...
	 * push(chunk, true);  // push last chunk
	 * ```
	 **/
	Deflate.prototype.push = function (data, mode) {
	  var strm = this.strm;
	  var chunkSize = this.options.chunkSize;
	  var status, _mode;
	
	  if (this.ended) { return false; }
	
	  _mode = (mode === ~~mode) ? mode : ((mode === true) ? Z_FINISH : Z_NO_FLUSH);
	
	  // Convert data if needed
	  if (typeof data === 'string') {
	    // If we need to compress text, change encoding to utf8.
	    strm.input = strings.string2buf(data);
	  } else if (toString.call(data) === '[object ArrayBuffer]') {
	    strm.input = new Uint8Array(data);
	  } else {
	    strm.input = data;
	  }
	
	  strm.next_in = 0;
	  strm.avail_in = strm.input.length;
	
	  do {
	    if (strm.avail_out === 0) {
	      strm.output = new utils.Buf8(chunkSize);
	      strm.next_out = 0;
	      strm.avail_out = chunkSize;
	    }
	    status = zlib_deflate.deflate(strm, _mode);    /* no bad return value */
	
	    if (status !== Z_STREAM_END && status !== Z_OK) {
	      this.onEnd(status);
	      this.ended = true;
	      return false;
	    }
	    if (strm.avail_out === 0 || (strm.avail_in === 0 && (_mode === Z_FINISH || _mode === Z_SYNC_FLUSH))) {
	      if (this.options.to === 'string') {
	        this.onData(strings.buf2binstring(utils.shrinkBuf(strm.output, strm.next_out)));
	      } else {
	        this.onData(utils.shrinkBuf(strm.output, strm.next_out));
	      }
	    }
	  } while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== Z_STREAM_END);
	
	  // Finalize on the last chunk.
	  if (_mode === Z_FINISH) {
	    status = zlib_deflate.deflateEnd(this.strm);
	    this.onEnd(status);
	    this.ended = true;
	    return status === Z_OK;
	  }
	
	  // callback interim results if Z_SYNC_FLUSH.
	  if (_mode === Z_SYNC_FLUSH) {
	    this.onEnd(Z_OK);
	    strm.avail_out = 0;
	    return true;
	  }
	
	  return true;
	};
	
	
	/**
	 * Deflate#onData(chunk) -> Void
	 * - chunk (Uint8Array|Array|String): output data. Type of array depends
	 *   on js engine support. When string output requested, each chunk
	 *   will be string.
	 *
	 * By default, stores data blocks in `chunks[]` property and glue
	 * those in `onEnd`. Override this handler, if you need another behaviour.
	 **/
	Deflate.prototype.onData = function (chunk) {
	  this.chunks.push(chunk);
	};
	
	
	/**
	 * Deflate#onEnd(status) -> Void
	 * - status (Number): deflate status. 0 (Z_OK) on success,
	 *   other if not.
	 *
	 * Called once after you tell deflate that the input stream is
	 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
	 * or if an error happened. By default - join collected chunks,
	 * free memory and fill `results` / `err` properties.
	 **/
	Deflate.prototype.onEnd = function (status) {
	  // On success - join
	  if (status === Z_OK) {
	    if (this.options.to === 'string') {
	      this.result = this.chunks.join('');
	    } else {
	      this.result = utils.flattenChunks(this.chunks);
	    }
	  }
	  this.chunks = [];
	  this.err = status;
	  this.msg = this.strm.msg;
	};
	
	
	/**
	 * deflate(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to compress.
	 * - options (Object): zlib deflate options.
	 *
	 * Compress `data` with deflate algorithm and `options`.
	 *
	 * Supported options are:
	 *
	 * - level
	 * - windowBits
	 * - memLevel
	 * - strategy
	 * - dictionary
	 *
	 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
	 * for more information on these.
	 *
	 * Sugar (options):
	 *
	 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
	 *   negative windowBits implicitly.
	 * - `to` (String) - if equal to 'string', then result will be "binary string"
	 *    (each char code [0..255])
	 *
	 * ##### Example:
	 *
	 * ```javascript
	 * var pako = require('pako')
	 *   , data = Uint8Array([1,2,3,4,5,6,7,8,9]);
	 *
	 * console.log(pako.deflate(data));
	 * ```
	 **/
	function deflate(input, options) {
	  var deflator = new Deflate(options);
	
	  deflator.push(input, true);
	
	  // That will never happens, if you don't cheat with options :)
	  if (deflator.err) { throw deflator.msg || msg[deflator.err]; }
	
	  return deflator.result;
	}
	
	
	/**
	 * deflateRaw(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to compress.
	 * - options (Object): zlib deflate options.
	 *
	 * The same as [[deflate]], but creates raw data, without wrapper
	 * (header and adler32 crc).
	 **/
	function deflateRaw(input, options) {
	  options = options || {};
	  options.raw = true;
	  return deflate(input, options);
	}
	
	
	/**
	 * gzip(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to compress.
	 * - options (Object): zlib deflate options.
	 *
	 * The same as [[deflate]], but create gzip wrapper instead of
	 * deflate one.
	 **/
	function gzip(input, options) {
	  options = options || {};
	  options.gzip = true;
	  return deflate(input, options);
	}
	
	
	exports.Deflate = Deflate;
	exports.deflate = deflate;
	exports.deflateRaw = deflateRaw;
	exports.gzip = gzip;
	
	},{"./utils/common":5,"./utils/strings":6,"./zlib/deflate":9,"./zlib/messages":10,"./zlib/zstream":12}],5:[function(require,module,exports){
	'use strict';
	
	
	var TYPED_OK =  (typeof Uint8Array !== 'undefined') &&
	                (typeof Uint16Array !== 'undefined') &&
	                (typeof Int32Array !== 'undefined');
	
	function _has(obj, key) {
	  return Object.prototype.hasOwnProperty.call(obj, key);
	}
	
	exports.assign = function (obj /*from1, from2, from3, ...*/) {
	  var sources = Array.prototype.slice.call(arguments, 1);
	  while (sources.length) {
	    var source = sources.shift();
	    if (!source) { continue; }
	
	    if (typeof source !== 'object') {
	      throw new TypeError(source + 'must be non-object');
	    }
	
	    for (var p in source) {
	      if (_has(source, p)) {
	        obj[p] = source[p];
	      }
	    }
	  }
	
	  return obj;
	};
	
	
	// reduce buffer size, avoiding mem copy
	exports.shrinkBuf = function (buf, size) {
	  if (buf.length === size) { return buf; }
	  if (buf.subarray) { return buf.subarray(0, size); }
	  buf.length = size;
	  return buf;
	};
	
	
	var fnTyped = {
	  arraySet: function (dest, src, src_offs, len, dest_offs) {
	    if (src.subarray && dest.subarray) {
	      dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
	      return;
	    }
	    // Fallback to ordinary array
	    for (var i = 0; i < len; i++) {
	      dest[dest_offs + i] = src[src_offs + i];
	    }
	  },
	  // Join array of chunks to single array.
	  flattenChunks: function (chunks) {
	    var i, l, len, pos, chunk, result;
	
	    // calculate data length
	    len = 0;
	    for (i = 0, l = chunks.length; i < l; i++) {
	      len += chunks[i].length;
	    }
	
	    // join chunks
	    result = new Uint8Array(len);
	    pos = 0;
	    for (i = 0, l = chunks.length; i < l; i++) {
	      chunk = chunks[i];
	      result.set(chunk, pos);
	      pos += chunk.length;
	    }
	
	    return result;
	  }
	};
	
	var fnUntyped = {
	  arraySet: function (dest, src, src_offs, len, dest_offs) {
	    for (var i = 0; i < len; i++) {
	      dest[dest_offs + i] = src[src_offs + i];
	    }
	  },
	  // Join array of chunks to single array.
	  flattenChunks: function (chunks) {
	    return [].concat.apply([], chunks);
	  }
	};
	
	
	// Enable/Disable typed arrays use, for testing
	//
	exports.setTyped = function (on) {
	  if (on) {
	    exports.Buf8  = Uint8Array;
	    exports.Buf16 = Uint16Array;
	    exports.Buf32 = Int32Array;
	    exports.assign(exports, fnTyped);
	  } else {
	    exports.Buf8  = Array;
	    exports.Buf16 = Array;
	    exports.Buf32 = Array;
	    exports.assign(exports, fnUntyped);
	  }
	};
	
	exports.setTyped(TYPED_OK);
	
	},{}],6:[function(require,module,exports){
	// String encode/decode helpers
	'use strict';
	
	
	var utils = require('./common');
	
	
	// Quick check if we can use fast array to bin string conversion
	//
	// - apply(Array) can fail on Android 2.2
	// - apply(Uint8Array) can fail on iOS 5.1 Safari
	//
	var STR_APPLY_OK = true;
	var STR_APPLY_UIA_OK = true;
	
	try { String.fromCharCode.apply(null, [ 0 ]); } catch (__) { STR_APPLY_OK = false; }
	try { String.fromCharCode.apply(null, new Uint8Array(1)); } catch (__) { STR_APPLY_UIA_OK = false; }
	
	
	// Table with utf8 lengths (calculated by first byte of sequence)
	// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
	// because max possible codepoint is 0x10ffff
	var _utf8len = new utils.Buf8(256);
	for (var q = 0; q < 256; q++) {
	  _utf8len[q] = (q >= 252 ? 6 : q >= 248 ? 5 : q >= 240 ? 4 : q >= 224 ? 3 : q >= 192 ? 2 : 1);
	}
	_utf8len[254] = _utf8len[254] = 1; // Invalid sequence start
	
	
	// convert string to array (typed, when possible)
	exports.string2buf = function (str) {
	  var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;
	
	  // count binary size
	  for (m_pos = 0; m_pos < str_len; m_pos++) {
	    c = str.charCodeAt(m_pos);
	    if ((c & 0xfc00) === 0xd800 && (m_pos + 1 < str_len)) {
	      c2 = str.charCodeAt(m_pos + 1);
	      if ((c2 & 0xfc00) === 0xdc00) {
	        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
	        m_pos++;
	      }
	    }
	    buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
	  }
	
	  // allocate buffer
	  buf = new utils.Buf8(buf_len);
	
	  // convert
	  for (i = 0, m_pos = 0; i < buf_len; m_pos++) {
	    c = str.charCodeAt(m_pos);
	    if ((c & 0xfc00) === 0xd800 && (m_pos + 1 < str_len)) {
	      c2 = str.charCodeAt(m_pos + 1);
	      if ((c2 & 0xfc00) === 0xdc00) {
	        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
	        m_pos++;
	      }
	    }
	    if (c < 0x80) {
	      /* one byte */
	      buf[i++] = c;
	    } else if (c < 0x800) {
	      /* two bytes */
	      buf[i++] = 0xC0 | (c >>> 6);
	      buf[i++] = 0x80 | (c & 0x3f);
	    } else if (c < 0x10000) {
	      /* three bytes */
	      buf[i++] = 0xE0 | (c >>> 12);
	      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
	      buf[i++] = 0x80 | (c & 0x3f);
	    } else {
	      /* four bytes */
	      buf[i++] = 0xf0 | (c >>> 18);
	      buf[i++] = 0x80 | (c >>> 12 & 0x3f);
	      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
	      buf[i++] = 0x80 | (c & 0x3f);
	    }
	  }
	
	  return buf;
	};
	
	// Helper (used in 2 places)
	function buf2binstring(buf, len) {
	  // On Chrome, the arguments in a function call that are allowed is `65534`.
	  // If the length of the buffer is smaller than that, we can use this optimization,
	  // otherwise we will take a slower path.
	  if (len < 65534) {
	    if ((buf.subarray && STR_APPLY_UIA_OK) || (!buf.subarray && STR_APPLY_OK)) {
	      return String.fromCharCode.apply(null, utils.shrinkBuf(buf, len));
	    }
	  }
	
	  var result = '';
	  for (var i = 0; i < len; i++) {
	    result += String.fromCharCode(buf[i]);
	  }
	  return result;
	}
	
	
	// Convert byte array to binary string
	exports.buf2binstring = function (buf) {
	  return buf2binstring(buf, buf.length);
	};
	
	
	// Convert binary string (typed, when possible)
	exports.binstring2buf = function (str) {
	  var buf = new utils.Buf8(str.length);
	  for (var i = 0, len = buf.length; i < len; i++) {
	    buf[i] = str.charCodeAt(i);
	  }
	  return buf;
	};
	
	
	// convert array to string
	exports.buf2string = function (buf, max) {
	  var i, out, c, c_len;
	  var len = max || buf.length;
	
	  // Reserve max possible length (2 words per char)
	  // NB: by unknown reasons, Array is significantly faster for
	  //     String.fromCharCode.apply than Uint16Array.
	  var utf16buf = new Array(len * 2);
	
	  for (out = 0, i = 0; i < len;) {
	    c = buf[i++];
	    // quick process ascii
	    if (c < 0x80) { utf16buf[out++] = c; continue; }
	
	    c_len = _utf8len[c];
	    // skip 5 & 6 byte codes
	    if (c_len > 4) { utf16buf[out++] = 0xfffd; i += c_len - 1; continue; }
	
	    // apply mask on first byte
	    c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
	    // join the rest
	    while (c_len > 1 && i < len) {
	      c = (c << 6) | (buf[i++] & 0x3f);
	      c_len--;
	    }
	
	    // terminated by end of string?
	    if (c_len > 1) { utf16buf[out++] = 0xfffd; continue; }
	
	    if (c < 0x10000) {
	      utf16buf[out++] = c;
	    } else {
	      c -= 0x10000;
	      utf16buf[out++] = 0xd800 | ((c >> 10) & 0x3ff);
	      utf16buf[out++] = 0xdc00 | (c & 0x3ff);
	    }
	  }
	
	  return buf2binstring(utf16buf, out);
	};
	
	
	// Calculate max possible position in utf8 buffer,
	// that will not break sequence. If that's not possible
	// - (very small limits) return max size as is.
	//
	// buf[] - utf8 bytes array
	// max   - length limit (mandatory);
	exports.utf8border = function (buf, max) {
	  var pos;
	
	  max = max || buf.length;
	  if (max > buf.length) { max = buf.length; }
	
	  // go back from last position, until start of sequence found
	  pos = max - 1;
	  while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) { pos--; }
	
	  // Very small and broken sequence,
	  // return max, because we should return something anyway.
	  if (pos < 0) { return max; }
	
	  // If we came to start of buffer - that means buffer is too small,
	  // return max too.
	  if (pos === 0) { return max; }
	
	  return (pos + _utf8len[buf[pos]] > max) ? pos : max;
	};
	
	},{"./common":5}],7:[function(require,module,exports){
	'use strict';
	
	// Note: adler32 takes 12% for level 0 and 2% for level 6.
	// It isn't worth it to make additional optimizations as in original.
	// Small size is preferable.
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	function adler32(adler, buf, len, pos) {
	  var s1 = (adler & 0xffff) |0,
	      s2 = ((adler >>> 16) & 0xffff) |0,
	      n = 0;
	
	  while (len !== 0) {
	    // Set limit ~ twice less than 5552, to keep
	    // s2 in 31-bits, because we force signed ints.
	    // in other case %= will fail.
	    n = len > 2000 ? 2000 : len;
	    len -= n;
	
	    do {
	      s1 = (s1 + buf[pos++]) |0;
	      s2 = (s2 + s1) |0;
	    } while (--n);
	
	    s1 %= 65521;
	    s2 %= 65521;
	  }
	
	  return (s1 | (s2 << 16)) |0;
	}
	
	
	module.exports = adler32;
	
	},{}],8:[function(require,module,exports){
	'use strict';
	
	// Note: we can't get significant speed boost here.
	// So write code to minimize size - no pregenerated tables
	// and array tools dependencies.
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	// Use ordinary array, since untyped makes no boost here
	function makeTable() {
	  var c, table = [];
	
	  for (var n = 0; n < 256; n++) {
	    c = n;
	    for (var k = 0; k < 8; k++) {
	      c = ((c & 1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
	    }
	    table[n] = c;
	  }
	
	  return table;
	}
	
	// Create table on load. Just 255 signed longs. Not a problem.
	var crcTable = makeTable();
	
	
	function crc32(crc, buf, len, pos) {
	  var t = crcTable,
	      end = pos + len;
	
	  crc ^= -1;
	
	  for (var i = pos; i < end; i++) {
	    crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xFF];
	  }
	
	  return (crc ^ (-1)); // >>> 0;
	}
	
	
	module.exports = crc32;
	
	},{}],9:[function(require,module,exports){
	'use strict';
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	var utils   = require('../utils/common');
	var trees   = require('./trees');
	var adler32 = require('./adler32');
	var crc32   = require('./crc32');
	var msg     = require('./messages');
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	
	/* Allowed flush values; see deflate() and inflate() below for details */
	var Z_NO_FLUSH      = 0;
	var Z_PARTIAL_FLUSH = 1;
	//var Z_SYNC_FLUSH    = 2;
	var Z_FULL_FLUSH    = 3;
	var Z_FINISH        = 4;
	var Z_BLOCK         = 5;
	//var Z_TREES         = 6;
	
	
	/* Return codes for the compression/decompression functions. Negative values
	 * are errors, positive values are used for special but normal events.
	 */
	var Z_OK            = 0;
	var Z_STREAM_END    = 1;
	//var Z_NEED_DICT     = 2;
	//var Z_ERRNO         = -1;
	var Z_STREAM_ERROR  = -2;
	var Z_DATA_ERROR    = -3;
	//var Z_MEM_ERROR     = -4;
	var Z_BUF_ERROR     = -5;
	//var Z_VERSION_ERROR = -6;
	
	
	/* compression levels */
	//var Z_NO_COMPRESSION      = 0;
	//var Z_BEST_SPEED          = 1;
	//var Z_BEST_COMPRESSION    = 9;
	var Z_DEFAULT_COMPRESSION = -1;
	
	
	var Z_FILTERED            = 1;
	var Z_HUFFMAN_ONLY        = 2;
	var Z_RLE                 = 3;
	var Z_FIXED               = 4;
	var Z_DEFAULT_STRATEGY    = 0;
	
	/* Possible values of the data_type field (though see inflate()) */
	//var Z_BINARY              = 0;
	//var Z_TEXT                = 1;
	//var Z_ASCII               = 1; // = Z_TEXT
	var Z_UNKNOWN             = 2;
	
	
	/* The deflate compression method */
	var Z_DEFLATED  = 8;
	
	/*============================================================================*/
	
	
	var MAX_MEM_LEVEL = 9;
	/* Maximum value for memLevel in deflateInit2 */
	var MAX_WBITS = 15;
	/* 32K LZ77 window */
	var DEF_MEM_LEVEL = 8;
	
	
	var LENGTH_CODES  = 29;
	/* number of length codes, not counting the special END_BLOCK code */
	var LITERALS      = 256;
	/* number of literal bytes 0..255 */
	var L_CODES       = LITERALS + 1 + LENGTH_CODES;
	/* number of Literal or Length codes, including the END_BLOCK code */
	var D_CODES       = 30;
	/* number of distance codes */
	var BL_CODES      = 19;
	/* number of codes used to transfer the bit lengths */
	var HEAP_SIZE     = 2 * L_CODES + 1;
	/* maximum heap size */
	var MAX_BITS  = 15;
	/* All codes must not exceed MAX_BITS bits */
	
	var MIN_MATCH = 3;
	var MAX_MATCH = 258;
	var MIN_LOOKAHEAD = (MAX_MATCH + MIN_MATCH + 1);
	
	var PRESET_DICT = 0x20;
	
	var INIT_STATE = 42;
	var EXTRA_STATE = 69;
	var NAME_STATE = 73;
	var COMMENT_STATE = 91;
	var HCRC_STATE = 103;
	var BUSY_STATE = 113;
	var FINISH_STATE = 666;
	
	var BS_NEED_MORE      = 1; /* block not completed, need more input or more output */
	var BS_BLOCK_DONE     = 2; /* block flush performed */
	var BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */
	var BS_FINISH_DONE    = 4; /* finish done, accept no more input or output */
	
	var OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
	
	function err(strm, errorCode) {
	  strm.msg = msg[errorCode];
	  return errorCode;
	}
	
	function rank(f) {
	  return ((f) << 1) - ((f) > 4 ? 9 : 0);
	}
	
	function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }
	
	
	/* =========================================================================
	 * Flush as much pending output as possible. All deflate() output goes
	 * through this function so some applications may wish to modify it
	 * to avoid allocating a large strm->output buffer and copying into it.
	 * (See also read_buf()).
	 */
	function flush_pending(strm) {
	  var s = strm.state;
	
	  //_tr_flush_bits(s);
	  var len = s.pending;
	  if (len > strm.avail_out) {
	    len = strm.avail_out;
	  }
	  if (len === 0) { return; }
	
	  utils.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
	  strm.next_out += len;
	  s.pending_out += len;
	  strm.total_out += len;
	  strm.avail_out -= len;
	  s.pending -= len;
	  if (s.pending === 0) {
	    s.pending_out = 0;
	  }
	}
	
	
	function flush_block_only(s, last) {
	  trees._tr_flush_block(s, (s.block_start >= 0 ? s.block_start : -1), s.strstart - s.block_start, last);
	  s.block_start = s.strstart;
	  flush_pending(s.strm);
	}
	
	
	function put_byte(s, b) {
	  s.pending_buf[s.pending++] = b;
	}
	
	
	/* =========================================================================
	 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
	 * IN assertion: the stream state is correct and there is enough room in
	 * pending_buf.
	 */
	function putShortMSB(s, b) {
	//  put_byte(s, (Byte)(b >> 8));
	//  put_byte(s, (Byte)(b & 0xff));
	  s.pending_buf[s.pending++] = (b >>> 8) & 0xff;
	  s.pending_buf[s.pending++] = b & 0xff;
	}
	
	
	/* ===========================================================================
	 * Read a new buffer from the current input stream, update the adler32
	 * and total number of bytes read.  All deflate() input goes through
	 * this function so some applications may wish to modify it to avoid
	 * allocating a large strm->input buffer and copying from it.
	 * (See also flush_pending()).
	 */
	function read_buf(strm, buf, start, size) {
	  var len = strm.avail_in;
	
	  if (len > size) { len = size; }
	  if (len === 0) { return 0; }
	
	  strm.avail_in -= len;
	
	  // zmemcpy(buf, strm->next_in, len);
	  utils.arraySet(buf, strm.input, strm.next_in, len, start);
	  if (strm.state.wrap === 1) {
	    strm.adler = adler32(strm.adler, buf, len, start);
	  }
	
	  else if (strm.state.wrap === 2) {
	    strm.adler = crc32(strm.adler, buf, len, start);
	  }
	
	  strm.next_in += len;
	  strm.total_in += len;
	
	  return len;
	}
	
	
	/* ===========================================================================
	 * Set match_start to the longest match starting at the given string and
	 * return its length. Matches shorter or equal to prev_length are discarded,
	 * in which case the result is equal to prev_length and match_start is
	 * garbage.
	 * IN assertions: cur_match is the head of the hash chain for the current
	 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
	 * OUT assertion: the match length is not greater than s->lookahead.
	 */
	function longest_match(s, cur_match) {
	  var chain_length = s.max_chain_length;      /* max hash chain length */
	  var scan = s.strstart; /* current string */
	  var match;                       /* matched string */
	  var len;                           /* length of current match */
	  var best_len = s.prev_length;              /* best match length so far */
	  var nice_match = s.nice_match;             /* stop if match long enough */
	  var limit = (s.strstart > (s.w_size - MIN_LOOKAHEAD)) ?
	      s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0/*NIL*/;
	
	  var _win = s.window; // shortcut
	
	  var wmask = s.w_mask;
	  var prev  = s.prev;
	
	  /* Stop when cur_match becomes <= limit. To simplify the code,
	   * we prevent matches with the string of window index 0.
	   */
	
	  var strend = s.strstart + MAX_MATCH;
	  var scan_end1  = _win[scan + best_len - 1];
	  var scan_end   = _win[scan + best_len];
	
	  /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
	   * It is easy to get rid of this optimization if necessary.
	   */
	  // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
	
	  /* Do not waste too much time if we already have a good match: */
	  if (s.prev_length >= s.good_match) {
	    chain_length >>= 2;
	  }
	  /* Do not look for matches beyond the end of the input. This is necessary
	   * to make deflate deterministic.
	   */
	  if (nice_match > s.lookahead) { nice_match = s.lookahead; }
	
	  // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
	
	  do {
	    // Assert(cur_match < s->strstart, "no future");
	    match = cur_match;
	
	    /* Skip to next match if the match length cannot increase
	     * or if the match length is less than 2.  Note that the checks below
	     * for insufficient lookahead only occur occasionally for performance
	     * reasons.  Therefore uninitialized memory will be accessed, and
	     * conditional jumps will be made that depend on those values.
	     * However the length of the match is limited to the lookahead, so
	     * the output of deflate is not affected by the uninitialized values.
	     */
	
	    if (_win[match + best_len]     !== scan_end  ||
	        _win[match + best_len - 1] !== scan_end1 ||
	        _win[match]                !== _win[scan] ||
	        _win[++match]              !== _win[scan + 1]) {
	      continue;
	    }
	
	    /* The check at best_len-1 can be removed because it will be made
	     * again later. (This heuristic is not always a win.)
	     * It is not necessary to compare scan[2] and match[2] since they
	     * are always equal when the other bytes match, given that
	     * the hash keys are equal and that HASH_BITS >= 8.
	     */
	    scan += 2;
	    match++;
	    // Assert(*scan == *match, "match[2]?");
	
	    /* We check for insufficient lookahead only every 8th comparison;
	     * the 256th check will be made at strstart+258.
	     */
	    do {
	      /*jshint noempty:false*/
	    } while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             scan < strend);
	
	    // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
	
	    len = MAX_MATCH - (strend - scan);
	    scan = strend - MAX_MATCH;
	
	    if (len > best_len) {
	      s.match_start = cur_match;
	      best_len = len;
	      if (len >= nice_match) {
	        break;
	      }
	      scan_end1  = _win[scan + best_len - 1];
	      scan_end   = _win[scan + best_len];
	    }
	  } while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
	
	  if (best_len <= s.lookahead) {
	    return best_len;
	  }
	  return s.lookahead;
	}
	
	
	/* ===========================================================================
	 * Fill the window when the lookahead becomes insufficient.
	 * Updates strstart and lookahead.
	 *
	 * IN assertion: lookahead < MIN_LOOKAHEAD
	 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
	 *    At least one byte has been read, or avail_in == 0; reads are
	 *    performed for at least two bytes (required for the zip translate_eol
	 *    option -- not supported here).
	 */
	function fill_window(s) {
	  var _w_size = s.w_size;
	  var p, n, m, more, str;
	
	  //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
	
	  do {
	    more = s.window_size - s.lookahead - s.strstart;
	
	    // JS ints have 32 bit, block below not needed
	    /* Deal with !@#$% 64K limit: */
	    //if (sizeof(int) <= 2) {
	    //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
	    //        more = wsize;
	    //
	    //  } else if (more == (unsigned)(-1)) {
	    //        /* Very unlikely, but possible on 16 bit machine if
	    //         * strstart == 0 && lookahead == 1 (input done a byte at time)
	    //         */
	    //        more--;
	    //    }
	    //}
	
	
	    /* If the window is almost full and there is insufficient lookahead,
	     * move the upper half to the lower one to make room in the upper half.
	     */
	    if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {
	
	      utils.arraySet(s.window, s.window, _w_size, _w_size, 0);
	      s.match_start -= _w_size;
	      s.strstart -= _w_size;
	      /* we now have strstart >= MAX_DIST */
	      s.block_start -= _w_size;
	
	      /* Slide the hash table (could be avoided with 32 bit values
	       at the expense of memory usage). We slide even when level == 0
	       to keep the hash table consistent if we switch back to level > 0
	       later. (Using level 0 permanently is not an optimal usage of
	       zlib, so we don't care about this pathological case.)
	       */
	
	      n = s.hash_size;
	      p = n;
	      do {
	        m = s.head[--p];
	        s.head[p] = (m >= _w_size ? m - _w_size : 0);
	      } while (--n);
	
	      n = _w_size;
	      p = n;
	      do {
	        m = s.prev[--p];
	        s.prev[p] = (m >= _w_size ? m - _w_size : 0);
	        /* If n is not on any hash chain, prev[n] is garbage but
	         * its value will never be used.
	         */
	      } while (--n);
	
	      more += _w_size;
	    }
	    if (s.strm.avail_in === 0) {
	      break;
	    }
	
	    /* If there was no sliding:
	     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
	     *    more == window_size - lookahead - strstart
	     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
	     * => more >= window_size - 2*WSIZE + 2
	     * In the BIG_MEM or MMAP case (not yet supported),
	     *   window_size == input_size + MIN_LOOKAHEAD  &&
	     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
	     * Otherwise, window_size == 2*WSIZE so more >= 2.
	     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
	     */
	    //Assert(more >= 2, "more < 2");
	    n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
	    s.lookahead += n;
	
	    /* Initialize the hash value now that we have some input: */
	    if (s.lookahead + s.insert >= MIN_MATCH) {
	      str = s.strstart - s.insert;
	      s.ins_h = s.window[str];
	
	      /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + 1]) & s.hash_mask;
	//#if MIN_MATCH != 3
	//        Call update_hash() MIN_MATCH-3 more times
	//#endif
	      while (s.insert) {
	        /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
	        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;
	
	        s.prev[str & s.w_mask] = s.head[s.ins_h];
	        s.head[s.ins_h] = str;
	        str++;
	        s.insert--;
	        if (s.lookahead + s.insert < MIN_MATCH) {
	          break;
	        }
	      }
	    }
	    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
	     * but this is not important since only literal bytes will be emitted.
	     */
	
	  } while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);
	
	  /* If the WIN_INIT bytes after the end of the current data have never been
	   * written, then zero those bytes in order to avoid memory check reports of
	   * the use of uninitialized (or uninitialised as Julian writes) bytes by
	   * the longest match routines.  Update the high water mark for the next
	   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
	   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
	   */
	//  if (s.high_water < s.window_size) {
	//    var curr = s.strstart + s.lookahead;
	//    var init = 0;
	//
	//    if (s.high_water < curr) {
	//      /* Previous high water mark below current data -- zero WIN_INIT
	//       * bytes or up to end of window, whichever is less.
	//       */
	//      init = s.window_size - curr;
	//      if (init > WIN_INIT)
	//        init = WIN_INIT;
	//      zmemzero(s->window + curr, (unsigned)init);
	//      s->high_water = curr + init;
	//    }
	//    else if (s->high_water < (ulg)curr + WIN_INIT) {
	//      /* High water mark at or above current data, but below current data
	//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
	//       * to end of window, whichever is less.
	//       */
	//      init = (ulg)curr + WIN_INIT - s->high_water;
	//      if (init > s->window_size - s->high_water)
	//        init = s->window_size - s->high_water;
	//      zmemzero(s->window + s->high_water, (unsigned)init);
	//      s->high_water += init;
	//    }
	//  }
	//
	//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
	//    "not enough room for search");
	}
	
	/* ===========================================================================
	 * Copy without compression as much as possible from the input stream, return
	 * the current block state.
	 * This function does not insert new strings in the dictionary since
	 * uncompressible data is probably not useful. This function is used
	 * only for the level=0 compression option.
	 * NOTE: this function should be optimized to avoid extra copying from
	 * window to pending_buf.
	 */
	function deflate_stored(s, flush) {
	  /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
	   * to pending_buf_size, and each stored block has a 5 byte header:
	   */
	  var max_block_size = 0xffff;
	
	  if (max_block_size > s.pending_buf_size - 5) {
	    max_block_size = s.pending_buf_size - 5;
	  }
	
	  /* Copy as much as possible from input to output: */
	  for (;;) {
	    /* Fill the window as much as possible: */
	    if (s.lookahead <= 1) {
	
	      //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
	      //  s->block_start >= (long)s->w_size, "slide too late");
	//      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
	//        s.block_start >= s.w_size)) {
	//        throw  new Error("slide too late");
	//      }
	
	      fill_window(s);
	      if (s.lookahead === 0 && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	
	      if (s.lookahead === 0) {
	        break;
	      }
	      /* flush the current block */
	    }
	    //Assert(s->block_start >= 0L, "block gone");
	//    if (s.block_start < 0) throw new Error("block gone");
	
	    s.strstart += s.lookahead;
	    s.lookahead = 0;
	
	    /* Emit a stored block if pending_buf will be full: */
	    var max_start = s.block_start + max_block_size;
	
	    if (s.strstart === 0 || s.strstart >= max_start) {
	      /* strstart == 0 is possible when wraparound on 16-bit machine */
	      s.lookahead = s.strstart - max_start;
	      s.strstart = max_start;
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	
	
	    }
	    /* Flush if we may have to slide, otherwise block_start may become
	     * negative and the data will be gone:
	     */
	    if (s.strstart - s.block_start >= (s.w_size - MIN_LOOKAHEAD)) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	
	  s.insert = 0;
	
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	
	  if (s.strstart > s.block_start) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	
	  return BS_NEED_MORE;
	}
	
	/* ===========================================================================
	 * Compress as much as possible from the input stream, return the current
	 * block state.
	 * This function does not perform lazy evaluation of matches and inserts
	 * new strings in the dictionary only for unmatched strings or for short
	 * matches. It is used only for the fast compression options.
	 */
	function deflate_fast(s, flush) {
	  var hash_head;        /* head of the hash chain */
	  var bflush;           /* set if current block must be flushed */
	
	  for (;;) {
	    /* Make sure that we always have enough lookahead, except
	     * at the end of the input file. We need MAX_MATCH bytes
	     * for the next match, plus MIN_MATCH bytes to insert the
	     * string following the next match.
	     */
	    if (s.lookahead < MIN_LOOKAHEAD) {
	      fill_window(s);
	      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	      if (s.lookahead === 0) {
	        break; /* flush the current block */
	      }
	    }
	
	    /* Insert the string window[strstart .. strstart+2] in the
	     * dictionary, and set hash_head to the head of the hash chain:
	     */
	    hash_head = 0/*NIL*/;
	    if (s.lookahead >= MIN_MATCH) {
	      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	      s.head[s.ins_h] = s.strstart;
	      /***/
	    }
	
	    /* Find the longest match, discarding those <= prev_length.
	     * At this point we have always match_length < MIN_MATCH
	     */
	    if (hash_head !== 0/*NIL*/ && ((s.strstart - hash_head) <= (s.w_size - MIN_LOOKAHEAD))) {
	      /* To simplify the code, we prevent matches with the string
	       * of window index 0 (in particular we have to avoid a match
	       * of the string with itself at the start of the input file).
	       */
	      s.match_length = longest_match(s, hash_head);
	      /* longest_match() sets match_start */
	    }
	    if (s.match_length >= MIN_MATCH) {
	      // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
	
	      /*** _tr_tally_dist(s, s.strstart - s.match_start,
	                     s.match_length - MIN_MATCH, bflush); ***/
	      bflush = trees._tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);
	
	      s.lookahead -= s.match_length;
	
	      /* Insert new strings in the hash table only if the match length
	       * is not too large. This saves time but degrades compression.
	       */
	      if (s.match_length <= s.max_lazy_match/*max_insert_length*/ && s.lookahead >= MIN_MATCH) {
	        s.match_length--; /* string at strstart already in table */
	        do {
	          s.strstart++;
	          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	          s.head[s.ins_h] = s.strstart;
	          /***/
	          /* strstart never exceeds WSIZE-MAX_MATCH, so there are
	           * always MIN_MATCH bytes ahead.
	           */
	        } while (--s.match_length !== 0);
	        s.strstart++;
	      } else
	      {
	        s.strstart += s.match_length;
	        s.match_length = 0;
	        s.ins_h = s.window[s.strstart];
	        /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */
	        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + 1]) & s.hash_mask;
	
	//#if MIN_MATCH != 3
	//                Call UPDATE_HASH() MIN_MATCH-3 more times
	//#endif
	        /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
	         * matter since it will be recomputed at next deflate call.
	         */
	      }
	    } else {
	      /* No match, output a literal byte */
	      //Tracevv((stderr,"%c", s.window[s.strstart]));
	      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
	
	      s.lookahead--;
	      s.strstart++;
	    }
	    if (bflush) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	  s.insert = ((s.strstart < (MIN_MATCH - 1)) ? s.strstart : MIN_MATCH - 1);
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	  return BS_BLOCK_DONE;
	}
	
	/* ===========================================================================
	 * Same as above, but achieves better compression. We use a lazy
	 * evaluation for matches: a match is finally adopted only if there is
	 * no better match at the next window position.
	 */
	function deflate_slow(s, flush) {
	  var hash_head;          /* head of hash chain */
	  var bflush;              /* set if current block must be flushed */
	
	  var max_insert;
	
	  /* Process the input block. */
	  for (;;) {
	    /* Make sure that we always have enough lookahead, except
	     * at the end of the input file. We need MAX_MATCH bytes
	     * for the next match, plus MIN_MATCH bytes to insert the
	     * string following the next match.
	     */
	    if (s.lookahead < MIN_LOOKAHEAD) {
	      fill_window(s);
	      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	      if (s.lookahead === 0) { break; } /* flush the current block */
	    }
	
	    /* Insert the string window[strstart .. strstart+2] in the
	     * dictionary, and set hash_head to the head of the hash chain:
	     */
	    hash_head = 0/*NIL*/;
	    if (s.lookahead >= MIN_MATCH) {
	      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	      s.head[s.ins_h] = s.strstart;
	      /***/
	    }
	
	    /* Find the longest match, discarding those <= prev_length.
	     */
	    s.prev_length = s.match_length;
	    s.prev_match = s.match_start;
	    s.match_length = MIN_MATCH - 1;
	
	    if (hash_head !== 0/*NIL*/ && s.prev_length < s.max_lazy_match &&
	        s.strstart - hash_head <= (s.w_size - MIN_LOOKAHEAD)/*MAX_DIST(s)*/) {
	      /* To simplify the code, we prevent matches with the string
	       * of window index 0 (in particular we have to avoid a match
	       * of the string with itself at the start of the input file).
	       */
	      s.match_length = longest_match(s, hash_head);
	      /* longest_match() sets match_start */
	
	      if (s.match_length <= 5 &&
	         (s.strategy === Z_FILTERED || (s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096/*TOO_FAR*/))) {
	
	        /* If prev_match is also MIN_MATCH, match_start is garbage
	         * but we will ignore the current match anyway.
	         */
	        s.match_length = MIN_MATCH - 1;
	      }
	    }
	    /* If there was a match at the previous step and the current
	     * match is not better, output the previous match:
	     */
	    if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
	      max_insert = s.strstart + s.lookahead - MIN_MATCH;
	      /* Do not insert strings in hash table beyond this. */
	
	      //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
	
	      /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
	                     s.prev_length - MIN_MATCH, bflush);***/
	      bflush = trees._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH);
	      /* Insert in hash table all strings up to the end of the match.
	       * strstart-1 and strstart are already inserted. If there is not
	       * enough lookahead, the last two strings are not inserted in
	       * the hash table.
	       */
	      s.lookahead -= s.prev_length - 1;
	      s.prev_length -= 2;
	      do {
	        if (++s.strstart <= max_insert) {
	          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	          s.head[s.ins_h] = s.strstart;
	          /***/
	        }
	      } while (--s.prev_length !== 0);
	      s.match_available = 0;
	      s.match_length = MIN_MATCH - 1;
	      s.strstart++;
	
	      if (bflush) {
	        /*** FLUSH_BLOCK(s, 0); ***/
	        flush_block_only(s, false);
	        if (s.strm.avail_out === 0) {
	          return BS_NEED_MORE;
	        }
	        /***/
	      }
	
	    } else if (s.match_available) {
	      /* If there was no match at the previous position, output a
	       * single literal. If there was a match but the current match
	       * is longer, truncate the previous match to a single literal.
	       */
	      //Tracevv((stderr,"%c", s->window[s->strstart-1]));
	      /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
	      bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);
	
	      if (bflush) {
	        /*** FLUSH_BLOCK_ONLY(s, 0) ***/
	        flush_block_only(s, false);
	        /***/
	      }
	      s.strstart++;
	      s.lookahead--;
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	    } else {
	      /* There is no previous match to compare with, wait for
	       * the next step to decide.
	       */
	      s.match_available = 1;
	      s.strstart++;
	      s.lookahead--;
	    }
	  }
	  //Assert (flush != Z_NO_FLUSH, "no flush?");
	  if (s.match_available) {
	    //Tracevv((stderr,"%c", s->window[s->strstart-1]));
	    /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
	    bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);
	
	    s.match_available = 0;
	  }
	  s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	
	  return BS_BLOCK_DONE;
	}
	
	
	/* ===========================================================================
	 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
	 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
	 * deflate switches away from Z_RLE.)
	 */
	function deflate_rle(s, flush) {
	  var bflush;            /* set if current block must be flushed */
	  var prev;              /* byte at distance one to match */
	  var scan, strend;      /* scan goes up to strend for length of run */
	
	  var _win = s.window;
	
	  for (;;) {
	    /* Make sure that we always have enough lookahead, except
	     * at the end of the input file. We need MAX_MATCH bytes
	     * for the longest run, plus one for the unrolled loop.
	     */
	    if (s.lookahead <= MAX_MATCH) {
	      fill_window(s);
	      if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	      if (s.lookahead === 0) { break; } /* flush the current block */
	    }
	
	    /* See how many times the previous byte repeats */
	    s.match_length = 0;
	    if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
	      scan = s.strstart - 1;
	      prev = _win[scan];
	      if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
	        strend = s.strstart + MAX_MATCH;
	        do {
	          /*jshint noempty:false*/
	        } while (prev === _win[++scan] && prev === _win[++scan] &&
	                 prev === _win[++scan] && prev === _win[++scan] &&
	                 prev === _win[++scan] && prev === _win[++scan] &&
	                 prev === _win[++scan] && prev === _win[++scan] &&
	                 scan < strend);
	        s.match_length = MAX_MATCH - (strend - scan);
	        if (s.match_length > s.lookahead) {
	          s.match_length = s.lookahead;
	        }
	      }
	      //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
	    }
	
	    /* Emit match if have run of MIN_MATCH or longer, else emit literal */
	    if (s.match_length >= MIN_MATCH) {
	      //check_match(s, s.strstart, s.strstart - 1, s.match_length);
	
	      /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/
	      bflush = trees._tr_tally(s, 1, s.match_length - MIN_MATCH);
	
	      s.lookahead -= s.match_length;
	      s.strstart += s.match_length;
	      s.match_length = 0;
	    } else {
	      /* No match, output a literal byte */
	      //Tracevv((stderr,"%c", s->window[s->strstart]));
	      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
	
	      s.lookahead--;
	      s.strstart++;
	    }
	    if (bflush) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	  s.insert = 0;
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	  return BS_BLOCK_DONE;
	}
	
	/* ===========================================================================
	 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
	 * (It will be regenerated if this run of deflate switches away from Huffman.)
	 */
	function deflate_huff(s, flush) {
	  var bflush;             /* set if current block must be flushed */
	
	  for (;;) {
	    /* Make sure that we have a literal to write. */
	    if (s.lookahead === 0) {
	      fill_window(s);
	      if (s.lookahead === 0) {
	        if (flush === Z_NO_FLUSH) {
	          return BS_NEED_MORE;
	        }
	        break;      /* flush the current block */
	      }
	    }
	
	    /* Output a literal byte */
	    s.match_length = 0;
	    //Tracevv((stderr,"%c", s->window[s->strstart]));
	    /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	    bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
	    s.lookahead--;
	    s.strstart++;
	    if (bflush) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	  s.insert = 0;
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	  return BS_BLOCK_DONE;
	}
	
	/* Values for max_lazy_match, good_match and max_chain_length, depending on
	 * the desired pack level (0..9). The values given below have been tuned to
	 * exclude worst case performance for pathological files. Better values may be
	 * found for specific files.
	 */
	function Config(good_length, max_lazy, nice_length, max_chain, func) {
	  this.good_length = good_length;
	  this.max_lazy = max_lazy;
	  this.nice_length = nice_length;
	  this.max_chain = max_chain;
	  this.func = func;
	}
	
	var configuration_table;
	
	configuration_table = [
	  /*      good lazy nice chain */
	  new Config(0, 0, 0, 0, deflate_stored),          /* 0 store only */
	  new Config(4, 4, 8, 4, deflate_fast),            /* 1 max speed, no lazy matches */
	  new Config(4, 5, 16, 8, deflate_fast),           /* 2 */
	  new Config(4, 6, 32, 32, deflate_fast),          /* 3 */
	
	  new Config(4, 4, 16, 16, deflate_slow),          /* 4 lazy matches */
	  new Config(8, 16, 32, 32, deflate_slow),         /* 5 */
	  new Config(8, 16, 128, 128, deflate_slow),       /* 6 */
	  new Config(8, 32, 128, 256, deflate_slow),       /* 7 */
	  new Config(32, 128, 258, 1024, deflate_slow),    /* 8 */
	  new Config(32, 258, 258, 4096, deflate_slow)     /* 9 max compression */
	];
	
	
	/* ===========================================================================
	 * Initialize the "longest match" routines for a new zlib stream
	 */
	function lm_init(s) {
	  s.window_size = 2 * s.w_size;
	
	  /*** CLEAR_HASH(s); ***/
	  zero(s.head); // Fill with NIL (= 0);
	
	  /* Set the default configuration parameters:
	   */
	  s.max_lazy_match = configuration_table[s.level].max_lazy;
	  s.good_match = configuration_table[s.level].good_length;
	  s.nice_match = configuration_table[s.level].nice_length;
	  s.max_chain_length = configuration_table[s.level].max_chain;
	
	  s.strstart = 0;
	  s.block_start = 0;
	  s.lookahead = 0;
	  s.insert = 0;
	  s.match_length = s.prev_length = MIN_MATCH - 1;
	  s.match_available = 0;
	  s.ins_h = 0;
	}
	
	
	function DeflateState() {
	  this.strm = null;            /* pointer back to this zlib stream */
	  this.status = 0;            /* as the name implies */
	  this.pending_buf = null;      /* output still pending */
	  this.pending_buf_size = 0;  /* size of pending_buf */
	  this.pending_out = 0;       /* next pending byte to output to the stream */
	  this.pending = 0;           /* nb of bytes in the pending buffer */
	  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
	  this.gzhead = null;         /* gzip header information to write */
	  this.gzindex = 0;           /* where in extra, name, or comment */
	  this.method = Z_DEFLATED; /* can only be DEFLATED */
	  this.last_flush = -1;   /* value of flush param for previous deflate call */
	
	  this.w_size = 0;  /* LZ77 window size (32K by default) */
	  this.w_bits = 0;  /* log2(w_size)  (8..16) */
	  this.w_mask = 0;  /* w_size - 1 */
	
	  this.window = null;
	  /* Sliding window. Input bytes are read into the second half of the window,
	   * and move to the first half later to keep a dictionary of at least wSize
	   * bytes. With this organization, matches are limited to a distance of
	   * wSize-MAX_MATCH bytes, but this ensures that IO is always
	   * performed with a length multiple of the block size.
	   */
	
	  this.window_size = 0;
	  /* Actual size of window: 2*wSize, except when the user input buffer
	   * is directly used as sliding window.
	   */
	
	  this.prev = null;
	  /* Link to older string with same hash index. To limit the size of this
	   * array to 64K, this link is maintained only for the last 32K strings.
	   * An index in this array is thus a window index modulo 32K.
	   */
	
	  this.head = null;   /* Heads of the hash chains or NIL. */
	
	  this.ins_h = 0;       /* hash index of string to be inserted */
	  this.hash_size = 0;   /* number of elements in hash table */
	  this.hash_bits = 0;   /* log2(hash_size) */
	  this.hash_mask = 0;   /* hash_size-1 */
	
	  this.hash_shift = 0;
	  /* Number of bits by which ins_h must be shifted at each input
	   * step. It must be such that after MIN_MATCH steps, the oldest
	   * byte no longer takes part in the hash key, that is:
	   *   hash_shift * MIN_MATCH >= hash_bits
	   */
	
	  this.block_start = 0;
	  /* Window position at the beginning of the current output block. Gets
	   * negative when the window is moved backwards.
	   */
	
	  this.match_length = 0;      /* length of best match */
	  this.prev_match = 0;        /* previous match */
	  this.match_available = 0;   /* set if previous match exists */
	  this.strstart = 0;          /* start of string to insert */
	  this.match_start = 0;       /* start of matching string */
	  this.lookahead = 0;         /* number of valid bytes ahead in window */
	
	  this.prev_length = 0;
	  /* Length of the best match at previous step. Matches not greater than this
	   * are discarded. This is used in the lazy match evaluation.
	   */
	
	  this.max_chain_length = 0;
	  /* To speed up deflation, hash chains are never searched beyond this
	   * length.  A higher limit improves compression ratio but degrades the
	   * speed.
	   */
	
	  this.max_lazy_match = 0;
	  /* Attempt to find a better match only when the current match is strictly
	   * smaller than this value. This mechanism is used only for compression
	   * levels >= 4.
	   */
	  // That's alias to max_lazy_match, don't use directly
	  //this.max_insert_length = 0;
	  /* Insert new strings in the hash table only if the match length is not
	   * greater than this length. This saves time but degrades compression.
	   * max_insert_length is used only for compression levels <= 3.
	   */
	
	  this.level = 0;     /* compression level (1..9) */
	  this.strategy = 0;  /* favor or force Huffman coding*/
	
	  this.good_match = 0;
	  /* Use a faster search when the previous match is longer than this */
	
	  this.nice_match = 0; /* Stop searching when current match exceeds this */
	
	              /* used by trees.c: */
	
	  /* Didn't use ct_data typedef below to suppress compiler warning */
	
	  // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
	  // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
	  // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
	
	  // Use flat array of DOUBLE size, with interleaved fata,
	  // because JS does not support effective
	  this.dyn_ltree  = new utils.Buf16(HEAP_SIZE * 2);
	  this.dyn_dtree  = new utils.Buf16((2 * D_CODES + 1) * 2);
	  this.bl_tree    = new utils.Buf16((2 * BL_CODES + 1) * 2);
	  zero(this.dyn_ltree);
	  zero(this.dyn_dtree);
	  zero(this.bl_tree);
	
	  this.l_desc   = null;         /* desc. for literal tree */
	  this.d_desc   = null;         /* desc. for distance tree */
	  this.bl_desc  = null;         /* desc. for bit length tree */
	
	  //ush bl_count[MAX_BITS+1];
	  this.bl_count = new utils.Buf16(MAX_BITS + 1);
	  /* number of codes at each bit length for an optimal tree */
	
	  //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
	  this.heap = new utils.Buf16(2 * L_CODES + 1);  /* heap used to build the Huffman trees */
	  zero(this.heap);
	
	  this.heap_len = 0;               /* number of elements in the heap */
	  this.heap_max = 0;               /* element of largest frequency */
	  /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
	   * The same heap array is used to build all trees.
	   */
	
	  this.depth = new utils.Buf16(2 * L_CODES + 1); //uch depth[2*L_CODES+1];
	  zero(this.depth);
	  /* Depth of each subtree used as tie breaker for trees of equal frequency
	   */
	
	  this.l_buf = 0;          /* buffer index for literals or lengths */
	
	  this.lit_bufsize = 0;
	  /* Size of match buffer for literals/lengths.  There are 4 reasons for
	   * limiting lit_bufsize to 64K:
	   *   - frequencies can be kept in 16 bit counters
	   *   - if compression is not successful for the first block, all input
	   *     data is still in the window so we can still emit a stored block even
	   *     when input comes from standard input.  (This can also be done for
	   *     all blocks if lit_bufsize is not greater than 32K.)
	   *   - if compression is not successful for a file smaller than 64K, we can
	   *     even emit a stored file instead of a stored block (saving 5 bytes).
	   *     This is applicable only for zip (not gzip or zlib).
	   *   - creating new Huffman trees less frequently may not provide fast
	   *     adaptation to changes in the input data statistics. (Take for
	   *     example a binary file with poorly compressible code followed by
	   *     a highly compressible string table.) Smaller buffer sizes give
	   *     fast adaptation but have of course the overhead of transmitting
	   *     trees more frequently.
	   *   - I can't count above 4
	   */
	
	  this.last_lit = 0;      /* running index in l_buf */
	
	  this.d_buf = 0;
	  /* Buffer index for distances. To simplify the code, d_buf and l_buf have
	   * the same number of elements. To use different lengths, an extra flag
	   * array would be necessary.
	   */
	
	  this.opt_len = 0;       /* bit length of current block with optimal trees */
	  this.static_len = 0;    /* bit length of current block with static trees */
	  this.matches = 0;       /* number of string matches in current block */
	  this.insert = 0;        /* bytes at end of window left to insert */
	
	
	  this.bi_buf = 0;
	  /* Output buffer. bits are inserted starting at the bottom (least
	   * significant bits).
	   */
	  this.bi_valid = 0;
	  /* Number of valid bits in bi_buf.  All bits above the last valid bit
	   * are always zero.
	   */
	
	  // Used for window memory init. We safely ignore it for JS. That makes
	  // sense only for pointers and memory check tools.
	  //this.high_water = 0;
	  /* High water mark offset in window for initialized bytes -- bytes above
	   * this are set to zero in order to avoid memory check warnings when
	   * longest match routines access bytes past the input.  This is then
	   * updated to the new high water mark.
	   */
	}
	
	
	function deflateResetKeep(strm) {
	  var s;
	
	  if (!strm || !strm.state) {
	    return err(strm, Z_STREAM_ERROR);
	  }
	
	  strm.total_in = strm.total_out = 0;
	  strm.data_type = Z_UNKNOWN;
	
	  s = strm.state;
	  s.pending = 0;
	  s.pending_out = 0;
	
	  if (s.wrap < 0) {
	    s.wrap = -s.wrap;
	    /* was made negative by deflate(..., Z_FINISH); */
	  }
	  s.status = (s.wrap ? INIT_STATE : BUSY_STATE);
	  strm.adler = (s.wrap === 2) ?
	    0  // crc32(0, Z_NULL, 0)
	  :
	    1; // adler32(0, Z_NULL, 0)
	  s.last_flush = Z_NO_FLUSH;
	  trees._tr_init(s);
	  return Z_OK;
	}
	
	
	function deflateReset(strm) {
	  var ret = deflateResetKeep(strm);
	  if (ret === Z_OK) {
	    lm_init(strm.state);
	  }
	  return ret;
	}
	
	
	function deflateSetHeader(strm, head) {
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  if (strm.state.wrap !== 2) { return Z_STREAM_ERROR; }
	  strm.state.gzhead = head;
	  return Z_OK;
	}
	
	
	function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
	  if (!strm) { // === Z_NULL
	    return Z_STREAM_ERROR;
	  }
	  var wrap = 1;
	
	  if (level === Z_DEFAULT_COMPRESSION) {
	    level = 6;
	  }
	
	  if (windowBits < 0) { /* suppress zlib wrapper */
	    wrap = 0;
	    windowBits = -windowBits;
	  }
	
	  else if (windowBits > 15) {
	    wrap = 2;           /* write gzip wrapper instead */
	    windowBits -= 16;
	  }
	
	
	  if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED ||
	    windowBits < 8 || windowBits > 15 || level < 0 || level > 9 ||
	    strategy < 0 || strategy > Z_FIXED) {
	    return err(strm, Z_STREAM_ERROR);
	  }
	
	
	  if (windowBits === 8) {
	    windowBits = 9;
	  }
	  /* until 256-byte window bug fixed */
	
	  var s = new DeflateState();
	
	  strm.state = s;
	  s.strm = strm;
	
	  s.wrap = wrap;
	  s.gzhead = null;
	  s.w_bits = windowBits;
	  s.w_size = 1 << s.w_bits;
	  s.w_mask = s.w_size - 1;
	
	  s.hash_bits = memLevel + 7;
	  s.hash_size = 1 << s.hash_bits;
	  s.hash_mask = s.hash_size - 1;
	  s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);
	
	  s.window = new utils.Buf8(s.w_size * 2);
	  s.head = new utils.Buf16(s.hash_size);
	  s.prev = new utils.Buf16(s.w_size);
	
	  // Don't need mem init magic for JS.
	  //s.high_water = 0;  /* nothing written to s->window yet */
	
	  s.lit_bufsize = 1 << (memLevel + 6); /* 16K elements by default */
	
	  s.pending_buf_size = s.lit_bufsize * 4;
	
	  //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
	  //s->pending_buf = (uchf *) overlay;
	  s.pending_buf = new utils.Buf8(s.pending_buf_size);
	
	  // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
	  //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
	  s.d_buf = 1 * s.lit_bufsize;
	
	  //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
	  s.l_buf = (1 + 2) * s.lit_bufsize;
	
	  s.level = level;
	  s.strategy = strategy;
	  s.method = method;
	
	  return deflateReset(strm);
	}
	
	function deflateInit(strm, level) {
	  return deflateInit2(strm, level, Z_DEFLATED, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY);
	}
	
	
	function deflate(strm, flush) {
	  var old_flush, s;
	  var beg, val; // for gzip header write only
	
	  if (!strm || !strm.state ||
	    flush > Z_BLOCK || flush < 0) {
	    return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
	  }
	
	  s = strm.state;
	
	  if (!strm.output ||
	      (!strm.input && strm.avail_in !== 0) ||
	      (s.status === FINISH_STATE && flush !== Z_FINISH)) {
	    return err(strm, (strm.avail_out === 0) ? Z_BUF_ERROR : Z_STREAM_ERROR);
	  }
	
	  s.strm = strm; /* just in case */
	  old_flush = s.last_flush;
	  s.last_flush = flush;
	
	  /* Write the header */
	  if (s.status === INIT_STATE) {
	
	    if (s.wrap === 2) { // GZIP header
	      strm.adler = 0;  //crc32(0L, Z_NULL, 0);
	      put_byte(s, 31);
	      put_byte(s, 139);
	      put_byte(s, 8);
	      if (!s.gzhead) { // s->gzhead == Z_NULL
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, s.level === 9 ? 2 :
	                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
	                     4 : 0));
	        put_byte(s, OS_CODE);
	        s.status = BUSY_STATE;
	      }
	      else {
	        put_byte(s, (s.gzhead.text ? 1 : 0) +
	                    (s.gzhead.hcrc ? 2 : 0) +
	                    (!s.gzhead.extra ? 0 : 4) +
	                    (!s.gzhead.name ? 0 : 8) +
	                    (!s.gzhead.comment ? 0 : 16)
	        );
	        put_byte(s, s.gzhead.time & 0xff);
	        put_byte(s, (s.gzhead.time >> 8) & 0xff);
	        put_byte(s, (s.gzhead.time >> 16) & 0xff);
	        put_byte(s, (s.gzhead.time >> 24) & 0xff);
	        put_byte(s, s.level === 9 ? 2 :
	                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
	                     4 : 0));
	        put_byte(s, s.gzhead.os & 0xff);
	        if (s.gzhead.extra && s.gzhead.extra.length) {
	          put_byte(s, s.gzhead.extra.length & 0xff);
	          put_byte(s, (s.gzhead.extra.length >> 8) & 0xff);
	        }
	        if (s.gzhead.hcrc) {
	          strm.adler = crc32(strm.adler, s.pending_buf, s.pending, 0);
	        }
	        s.gzindex = 0;
	        s.status = EXTRA_STATE;
	      }
	    }
	    else // DEFLATE header
	    {
	      var header = (Z_DEFLATED + ((s.w_bits - 8) << 4)) << 8;
	      var level_flags = -1;
	
	      if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) {
	        level_flags = 0;
	      } else if (s.level < 6) {
	        level_flags = 1;
	      } else if (s.level === 6) {
	        level_flags = 2;
	      } else {
	        level_flags = 3;
	      }
	      header |= (level_flags << 6);
	      if (s.strstart !== 0) { header |= PRESET_DICT; }
	      header += 31 - (header % 31);
	
	      s.status = BUSY_STATE;
	      putShortMSB(s, header);
	
	      /* Save the adler32 of the preset dictionary: */
	      if (s.strstart !== 0) {
	        putShortMSB(s, strm.adler >>> 16);
	        putShortMSB(s, strm.adler & 0xffff);
	      }
	      strm.adler = 1; // adler32(0L, Z_NULL, 0);
	    }
	  }
	
	//#ifdef GZIP
	  if (s.status === EXTRA_STATE) {
	    if (s.gzhead.extra/* != Z_NULL*/) {
	      beg = s.pending;  /* start of bytes to update crc */
	
	      while (s.gzindex < (s.gzhead.extra.length & 0xffff)) {
	        if (s.pending === s.pending_buf_size) {
	          if (s.gzhead.hcrc && s.pending > beg) {
	            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	          }
	          flush_pending(strm);
	          beg = s.pending;
	          if (s.pending === s.pending_buf_size) {
	            break;
	          }
	        }
	        put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
	        s.gzindex++;
	      }
	      if (s.gzhead.hcrc && s.pending > beg) {
	        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	      }
	      if (s.gzindex === s.gzhead.extra.length) {
	        s.gzindex = 0;
	        s.status = NAME_STATE;
	      }
	    }
	    else {
	      s.status = NAME_STATE;
	    }
	  }
	  if (s.status === NAME_STATE) {
	    if (s.gzhead.name/* != Z_NULL*/) {
	      beg = s.pending;  /* start of bytes to update crc */
	      //int val;
	
	      do {
	        if (s.pending === s.pending_buf_size) {
	          if (s.gzhead.hcrc && s.pending > beg) {
	            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	          }
	          flush_pending(strm);
	          beg = s.pending;
	          if (s.pending === s.pending_buf_size) {
	            val = 1;
	            break;
	          }
	        }
	        // JS specific: little magic to add zero terminator to end of string
	        if (s.gzindex < s.gzhead.name.length) {
	          val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
	        } else {
	          val = 0;
	        }
	        put_byte(s, val);
	      } while (val !== 0);
	
	      if (s.gzhead.hcrc && s.pending > beg) {
	        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	      }
	      if (val === 0) {
	        s.gzindex = 0;
	        s.status = COMMENT_STATE;
	      }
	    }
	    else {
	      s.status = COMMENT_STATE;
	    }
	  }
	  if (s.status === COMMENT_STATE) {
	    if (s.gzhead.comment/* != Z_NULL*/) {
	      beg = s.pending;  /* start of bytes to update crc */
	      //int val;
	
	      do {
	        if (s.pending === s.pending_buf_size) {
	          if (s.gzhead.hcrc && s.pending > beg) {
	            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	          }
	          flush_pending(strm);
	          beg = s.pending;
	          if (s.pending === s.pending_buf_size) {
	            val = 1;
	            break;
	          }
	        }
	        // JS specific: little magic to add zero terminator to end of string
	        if (s.gzindex < s.gzhead.comment.length) {
	          val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
	        } else {
	          val = 0;
	        }
	        put_byte(s, val);
	      } while (val !== 0);
	
	      if (s.gzhead.hcrc && s.pending > beg) {
	        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	      }
	      if (val === 0) {
	        s.status = HCRC_STATE;
	      }
	    }
	    else {
	      s.status = HCRC_STATE;
	    }
	  }
	  if (s.status === HCRC_STATE) {
	    if (s.gzhead.hcrc) {
	      if (s.pending + 2 > s.pending_buf_size) {
	        flush_pending(strm);
	      }
	      if (s.pending + 2 <= s.pending_buf_size) {
	        put_byte(s, strm.adler & 0xff);
	        put_byte(s, (strm.adler >> 8) & 0xff);
	        strm.adler = 0; //crc32(0L, Z_NULL, 0);
	        s.status = BUSY_STATE;
	      }
	    }
	    else {
	      s.status = BUSY_STATE;
	    }
	  }
	//#endif
	
	  /* Flush as much pending output as possible */
	  if (s.pending !== 0) {
	    flush_pending(strm);
	    if (strm.avail_out === 0) {
	      /* Since avail_out is 0, deflate will be called again with
	       * more output space, but possibly with both pending and
	       * avail_in equal to zero. There won't be anything to do,
	       * but this is not an error situation so make sure we
	       * return OK instead of BUF_ERROR at next call of deflate:
	       */
	      s.last_flush = -1;
	      return Z_OK;
	    }
	
	    /* Make sure there is something to do and avoid duplicate consecutive
	     * flushes. For repeated and useless calls with Z_FINISH, we keep
	     * returning Z_STREAM_END instead of Z_BUF_ERROR.
	     */
	  } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) &&
	    flush !== Z_FINISH) {
	    return err(strm, Z_BUF_ERROR);
	  }
	
	  /* User must not provide more input after the first FINISH: */
	  if (s.status === FINISH_STATE && strm.avail_in !== 0) {
	    return err(strm, Z_BUF_ERROR);
	  }
	
	  /* Start a new block or continue the current one.
	   */
	  if (strm.avail_in !== 0 || s.lookahead !== 0 ||
	    (flush !== Z_NO_FLUSH && s.status !== FINISH_STATE)) {
	    var bstate = (s.strategy === Z_HUFFMAN_ONLY) ? deflate_huff(s, flush) :
	      (s.strategy === Z_RLE ? deflate_rle(s, flush) :
	        configuration_table[s.level].func(s, flush));
	
	    if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) {
	      s.status = FINISH_STATE;
	    }
	    if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
	      if (strm.avail_out === 0) {
	        s.last_flush = -1;
	        /* avoid BUF_ERROR next call, see above */
	      }
	      return Z_OK;
	      /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
	       * of deflate should use the same flush parameter to make sure
	       * that the flush is complete. So we don't have to output an
	       * empty block here, this will be done at next call. This also
	       * ensures that for a very small output buffer, we emit at most
	       * one empty block.
	       */
	    }
	    if (bstate === BS_BLOCK_DONE) {
	      if (flush === Z_PARTIAL_FLUSH) {
	        trees._tr_align(s);
	      }
	      else if (flush !== Z_BLOCK) { /* FULL_FLUSH or SYNC_FLUSH */
	
	        trees._tr_stored_block(s, 0, 0, false);
	        /* For a full flush, this empty block will be recognized
	         * as a special marker by inflate_sync().
	         */
	        if (flush === Z_FULL_FLUSH) {
	          /*** CLEAR_HASH(s); ***/             /* forget history */
	          zero(s.head); // Fill with NIL (= 0);
	
	          if (s.lookahead === 0) {
	            s.strstart = 0;
	            s.block_start = 0;
	            s.insert = 0;
	          }
	        }
	      }
	      flush_pending(strm);
	      if (strm.avail_out === 0) {
	        s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */
	        return Z_OK;
	      }
	    }
	  }
	  //Assert(strm->avail_out > 0, "bug2");
	  //if (strm.avail_out <= 0) { throw new Error("bug2");}
	
	  if (flush !== Z_FINISH) { return Z_OK; }
	  if (s.wrap <= 0) { return Z_STREAM_END; }
	
	  /* Write the trailer */
	  if (s.wrap === 2) {
	    put_byte(s, strm.adler & 0xff);
	    put_byte(s, (strm.adler >> 8) & 0xff);
	    put_byte(s, (strm.adler >> 16) & 0xff);
	    put_byte(s, (strm.adler >> 24) & 0xff);
	    put_byte(s, strm.total_in & 0xff);
	    put_byte(s, (strm.total_in >> 8) & 0xff);
	    put_byte(s, (strm.total_in >> 16) & 0xff);
	    put_byte(s, (strm.total_in >> 24) & 0xff);
	  }
	  else
	  {
	    putShortMSB(s, strm.adler >>> 16);
	    putShortMSB(s, strm.adler & 0xffff);
	  }
	
	  flush_pending(strm);
	  /* If avail_out is zero, the application will call deflate again
	   * to flush the rest.
	   */
	  if (s.wrap > 0) { s.wrap = -s.wrap; }
	  /* write the trailer only once! */
	  return s.pending !== 0 ? Z_OK : Z_STREAM_END;
	}
	
	function deflateEnd(strm) {
	  var status;
	
	  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
	    return Z_STREAM_ERROR;
	  }
	
	  status = strm.state.status;
	  if (status !== INIT_STATE &&
	    status !== EXTRA_STATE &&
	    status !== NAME_STATE &&
	    status !== COMMENT_STATE &&
	    status !== HCRC_STATE &&
	    status !== BUSY_STATE &&
	    status !== FINISH_STATE
	  ) {
	    return err(strm, Z_STREAM_ERROR);
	  }
	
	  strm.state = null;
	
	  return status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK;
	}
	
	
	/* =========================================================================
	 * Initializes the compression dictionary from the given byte
	 * sequence without producing any compressed output.
	 */
	function deflateSetDictionary(strm, dictionary) {
	  var dictLength = dictionary.length;
	
	  var s;
	  var str, n;
	  var wrap;
	  var avail;
	  var next;
	  var input;
	  var tmpDict;
	
	  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
	    return Z_STREAM_ERROR;
	  }
	
	  s = strm.state;
	  wrap = s.wrap;
	
	  if (wrap === 2 || (wrap === 1 && s.status !== INIT_STATE) || s.lookahead) {
	    return Z_STREAM_ERROR;
	  }
	
	  /* when using zlib wrappers, compute Adler-32 for provided dictionary */
	  if (wrap === 1) {
	    /* adler32(strm->adler, dictionary, dictLength); */
	    strm.adler = adler32(strm.adler, dictionary, dictLength, 0);
	  }
	
	  s.wrap = 0;   /* avoid computing Adler-32 in read_buf */
	
	  /* if dictionary would fill window, just replace the history */
	  if (dictLength >= s.w_size) {
	    if (wrap === 0) {            /* already empty otherwise */
	      /*** CLEAR_HASH(s); ***/
	      zero(s.head); // Fill with NIL (= 0);
	      s.strstart = 0;
	      s.block_start = 0;
	      s.insert = 0;
	    }
	    /* use the tail */
	    // dictionary = dictionary.slice(dictLength - s.w_size);
	    tmpDict = new utils.Buf8(s.w_size);
	    utils.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
	    dictionary = tmpDict;
	    dictLength = s.w_size;
	  }
	  /* insert dictionary into window and hash */
	  avail = strm.avail_in;
	  next = strm.next_in;
	  input = strm.input;
	  strm.avail_in = dictLength;
	  strm.next_in = 0;
	  strm.input = dictionary;
	  fill_window(s);
	  while (s.lookahead >= MIN_MATCH) {
	    str = s.strstart;
	    n = s.lookahead - (MIN_MATCH - 1);
	    do {
	      /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;
	
	      s.prev[str & s.w_mask] = s.head[s.ins_h];
	
	      s.head[s.ins_h] = str;
	      str++;
	    } while (--n);
	    s.strstart = str;
	    s.lookahead = MIN_MATCH - 1;
	    fill_window(s);
	  }
	  s.strstart += s.lookahead;
	  s.block_start = s.strstart;
	  s.insert = s.lookahead;
	  s.lookahead = 0;
	  s.match_length = s.prev_length = MIN_MATCH - 1;
	  s.match_available = 0;
	  strm.next_in = next;
	  strm.input = input;
	  strm.avail_in = avail;
	  s.wrap = wrap;
	  return Z_OK;
	}
	
	
	exports.deflateInit = deflateInit;
	exports.deflateInit2 = deflateInit2;
	exports.deflateReset = deflateReset;
	exports.deflateResetKeep = deflateResetKeep;
	exports.deflateSetHeader = deflateSetHeader;
	exports.deflate = deflate;
	exports.deflateEnd = deflateEnd;
	exports.deflateSetDictionary = deflateSetDictionary;
	exports.deflateInfo = 'pako deflate (from Nodeca project)';
	
	/* Not implemented
	exports.deflateBound = deflateBound;
	exports.deflateCopy = deflateCopy;
	exports.deflateParams = deflateParams;
	exports.deflatePending = deflatePending;
	exports.deflatePrime = deflatePrime;
	exports.deflateTune = deflateTune;
	*/
	
	},{"../utils/common":5,"./adler32":7,"./crc32":8,"./messages":10,"./trees":11}],10:[function(require,module,exports){
	'use strict';
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	module.exports = {
	  2:      'need dictionary',     /* Z_NEED_DICT       2  */
	  1:      'stream end',          /* Z_STREAM_END      1  */
	  0:      '',                    /* Z_OK              0  */
	  '-1':   'file error',          /* Z_ERRNO         (-1) */
	  '-2':   'stream error',        /* Z_STREAM_ERROR  (-2) */
	  '-3':   'data error',          /* Z_DATA_ERROR    (-3) */
	  '-4':   'insufficient memory', /* Z_MEM_ERROR     (-4) */
	  '-5':   'buffer error',        /* Z_BUF_ERROR     (-5) */
	  '-6':   'incompatible version' /* Z_VERSION_ERROR (-6) */
	};
	
	},{}],11:[function(require,module,exports){
	'use strict';
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	/* eslint-disable space-unary-ops */
	
	var utils = require('../utils/common');
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	
	//var Z_FILTERED          = 1;
	//var Z_HUFFMAN_ONLY      = 2;
	//var Z_RLE               = 3;
	var Z_FIXED               = 4;
	//var Z_DEFAULT_STRATEGY  = 0;
	
	/* Possible values of the data_type field (though see inflate()) */
	var Z_BINARY              = 0;
	var Z_TEXT                = 1;
	//var Z_ASCII             = 1; // = Z_TEXT
	var Z_UNKNOWN             = 2;
	
	/*============================================================================*/
	
	
	function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }
	
	// From zutil.h
	
	var STORED_BLOCK = 0;
	var STATIC_TREES = 1;
	var DYN_TREES    = 2;
	/* The three kinds of block type */
	
	var MIN_MATCH    = 3;
	var MAX_MATCH    = 258;
	/* The minimum and maximum match lengths */
	
	// From deflate.h
	/* ===========================================================================
	 * Internal compression state.
	 */
	
	var LENGTH_CODES  = 29;
	/* number of length codes, not counting the special END_BLOCK code */
	
	var LITERALS      = 256;
	/* number of literal bytes 0..255 */
	
	var L_CODES       = LITERALS + 1 + LENGTH_CODES;
	/* number of Literal or Length codes, including the END_BLOCK code */
	
	var D_CODES       = 30;
	/* number of distance codes */
	
	var BL_CODES      = 19;
	/* number of codes used to transfer the bit lengths */
	
	var HEAP_SIZE     = 2 * L_CODES + 1;
	/* maximum heap size */
	
	var MAX_BITS      = 15;
	/* All codes must not exceed MAX_BITS bits */
	
	var Buf_size      = 16;
	/* size of bit buffer in bi_buf */
	
	
	/* ===========================================================================
	 * Constants
	 */
	
	var MAX_BL_BITS = 7;
	/* Bit length codes must not exceed MAX_BL_BITS bits */
	
	var END_BLOCK   = 256;
	/* end of block literal code */
	
	var REP_3_6     = 16;
	/* repeat previous bit length 3-6 times (2 bits of repeat count) */
	
	var REPZ_3_10   = 17;
	/* repeat a zero length 3-10 times  (3 bits of repeat count) */
	
	var REPZ_11_138 = 18;
	/* repeat a zero length 11-138 times  (7 bits of repeat count) */
	
	/* eslint-disable comma-spacing,array-bracket-spacing */
	var extra_lbits =   /* extra bits for each length code */
	  [0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0];
	
	var extra_dbits =   /* extra bits for each distance code */
	  [0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13];
	
	var extra_blbits =  /* extra bits for each bit length code */
	  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7];
	
	var bl_order =
	  [16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];
	/* eslint-enable comma-spacing,array-bracket-spacing */
	
	/* The lengths of the bit length codes are sent in order of decreasing
	 * probability, to avoid transmitting the lengths for unused bit length codes.
	 */
	
	/* ===========================================================================
	 * Local data. These are initialized only once.
	 */
	
	// We pre-fill arrays with 0 to avoid uninitialized gaps
	
	var DIST_CODE_LEN = 512; /* see definition of array dist_code below */
	
	// !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
	var static_ltree  = new Array((L_CODES + 2) * 2);
	zero(static_ltree);
	/* The static literal tree. Since the bit lengths are imposed, there is no
	 * need for the L_CODES extra codes used during heap construction. However
	 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
	 * below).
	 */
	
	var static_dtree  = new Array(D_CODES * 2);
	zero(static_dtree);
	/* The static distance tree. (Actually a trivial tree since all codes use
	 * 5 bits.)
	 */
	
	var _dist_code    = new Array(DIST_CODE_LEN);
	zero(_dist_code);
	/* Distance codes. The first 256 values correspond to the distances
	 * 3 .. 258, the last 256 values correspond to the top 8 bits of
	 * the 15 bit distances.
	 */
	
	var _length_code  = new Array(MAX_MATCH - MIN_MATCH + 1);
	zero(_length_code);
	/* length code for each normalized match length (0 == MIN_MATCH) */
	
	var base_length   = new Array(LENGTH_CODES);
	zero(base_length);
	/* First normalized length for each code (0 = MIN_MATCH) */
	
	var base_dist     = new Array(D_CODES);
	zero(base_dist);
	/* First normalized distance for each code (0 = distance of 1) */
	
	
	function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
	
	  this.static_tree  = static_tree;  /* static tree or NULL */
	  this.extra_bits   = extra_bits;   /* extra bits for each code or NULL */
	  this.extra_base   = extra_base;   /* base index for extra_bits */
	  this.elems        = elems;        /* max number of elements in the tree */
	  this.max_length   = max_length;   /* max bit length for the codes */
	
	  // show if `static_tree` has data or dummy - needed for monomorphic objects
	  this.has_stree    = static_tree && static_tree.length;
	}
	
	
	var static_l_desc;
	var static_d_desc;
	var static_bl_desc;
	
	
	function TreeDesc(dyn_tree, stat_desc) {
	  this.dyn_tree = dyn_tree;     /* the dynamic tree */
	  this.max_code = 0;            /* largest code with non zero frequency */
	  this.stat_desc = stat_desc;   /* the corresponding static tree */
	}
	
	
	
	function d_code(dist) {
	  return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
	}
	
	
	/* ===========================================================================
	 * Output a short LSB first on the stream.
	 * IN assertion: there is enough room in pendingBuf.
	 */
	function put_short(s, w) {
	//    put_byte(s, (uch)((w) & 0xff));
	//    put_byte(s, (uch)((ush)(w) >> 8));
	  s.pending_buf[s.pending++] = (w) & 0xff;
	  s.pending_buf[s.pending++] = (w >>> 8) & 0xff;
	}
	
	
	/* ===========================================================================
	 * Send a value on a given number of bits.
	 * IN assertion: length <= 16 and value fits in length bits.
	 */
	function send_bits(s, value, length) {
	  if (s.bi_valid > (Buf_size - length)) {
	    s.bi_buf |= (value << s.bi_valid) & 0xffff;
	    put_short(s, s.bi_buf);
	    s.bi_buf = value >> (Buf_size - s.bi_valid);
	    s.bi_valid += length - Buf_size;
	  } else {
	    s.bi_buf |= (value << s.bi_valid) & 0xffff;
	    s.bi_valid += length;
	  }
	}
	
	
	function send_code(s, c, tree) {
	  send_bits(s, tree[c * 2]/*.Code*/, tree[c * 2 + 1]/*.Len*/);
	}
	
	
	/* ===========================================================================
	 * Reverse the first len bits of a code, using straightforward code (a faster
	 * method would use a table)
	 * IN assertion: 1 <= len <= 15
	 */
	function bi_reverse(code, len) {
	  var res = 0;
	  do {
	    res |= code & 1;
	    code >>>= 1;
	    res <<= 1;
	  } while (--len > 0);
	  return res >>> 1;
	}
	
	
	/* ===========================================================================
	 * Flush the bit buffer, keeping at most 7 bits in it.
	 */
	function bi_flush(s) {
	  if (s.bi_valid === 16) {
	    put_short(s, s.bi_buf);
	    s.bi_buf = 0;
	    s.bi_valid = 0;
	
	  } else if (s.bi_valid >= 8) {
	    s.pending_buf[s.pending++] = s.bi_buf & 0xff;
	    s.bi_buf >>= 8;
	    s.bi_valid -= 8;
	  }
	}
	
	
	/* ===========================================================================
	 * Compute the optimal bit lengths for a tree and update the total bit length
	 * for the current block.
	 * IN assertion: the fields freq and dad are set, heap[heap_max] and
	 *    above are the tree nodes sorted by increasing frequency.
	 * OUT assertions: the field len is set to the optimal bit length, the
	 *     array bl_count contains the frequencies for each bit length.
	 *     The length opt_len is updated; static_len is also updated if stree is
	 *     not null.
	 */
	function gen_bitlen(s, desc)
	//    deflate_state *s;
	//    tree_desc *desc;    /* the tree descriptor */
	{
	  var tree            = desc.dyn_tree;
	  var max_code        = desc.max_code;
	  var stree           = desc.stat_desc.static_tree;
	  var has_stree       = desc.stat_desc.has_stree;
	  var extra           = desc.stat_desc.extra_bits;
	  var base            = desc.stat_desc.extra_base;
	  var max_length      = desc.stat_desc.max_length;
	  var h;              /* heap index */
	  var n, m;           /* iterate over the tree elements */
	  var bits;           /* bit length */
	  var xbits;          /* extra bits */
	  var f;              /* frequency */
	  var overflow = 0;   /* number of elements with bit length too large */
	
	  for (bits = 0; bits <= MAX_BITS; bits++) {
	    s.bl_count[bits] = 0;
	  }
	
	  /* In a first pass, compute the optimal bit lengths (which may
	   * overflow in the case of the bit length tree).
	   */
	  tree[s.heap[s.heap_max] * 2 + 1]/*.Len*/ = 0; /* root of the heap */
	
	  for (h = s.heap_max + 1; h < HEAP_SIZE; h++) {
	    n = s.heap[h];
	    bits = tree[tree[n * 2 + 1]/*.Dad*/ * 2 + 1]/*.Len*/ + 1;
	    if (bits > max_length) {
	      bits = max_length;
	      overflow++;
	    }
	    tree[n * 2 + 1]/*.Len*/ = bits;
	    /* We overwrite tree[n].Dad which is no longer needed */
	
	    if (n > max_code) { continue; } /* not a leaf node */
	
	    s.bl_count[bits]++;
	    xbits = 0;
	    if (n >= base) {
	      xbits = extra[n - base];
	    }
	    f = tree[n * 2]/*.Freq*/;
	    s.opt_len += f * (bits + xbits);
	    if (has_stree) {
	      s.static_len += f * (stree[n * 2 + 1]/*.Len*/ + xbits);
	    }
	  }
	  if (overflow === 0) { return; }
	
	  // Trace((stderr,"\nbit length overflow\n"));
	  /* This happens for example on obj2 and pic of the Calgary corpus */
	
	  /* Find the first bit length which could increase: */
	  do {
	    bits = max_length - 1;
	    while (s.bl_count[bits] === 0) { bits--; }
	    s.bl_count[bits]--;      /* move one leaf down the tree */
	    s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */
	    s.bl_count[max_length]--;
	    /* The brother of the overflow item also moves one step up,
	     * but this does not affect bl_count[max_length]
	     */
	    overflow -= 2;
	  } while (overflow > 0);
	
	  /* Now recompute all bit lengths, scanning in increasing frequency.
	   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
	   * lengths instead of fixing only the wrong ones. This idea is taken
	   * from 'ar' written by Haruhiko Okumura.)
	   */
	  for (bits = max_length; bits !== 0; bits--) {
	    n = s.bl_count[bits];
	    while (n !== 0) {
	      m = s.heap[--h];
	      if (m > max_code) { continue; }
	      if (tree[m * 2 + 1]/*.Len*/ !== bits) {
	        // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
	        s.opt_len += (bits - tree[m * 2 + 1]/*.Len*/) * tree[m * 2]/*.Freq*/;
	        tree[m * 2 + 1]/*.Len*/ = bits;
	      }
	      n--;
	    }
	  }
	}
	
	
	/* ===========================================================================
	 * Generate the codes for a given tree and bit counts (which need not be
	 * optimal).
	 * IN assertion: the array bl_count contains the bit length statistics for
	 * the given tree and the field len is set for all tree elements.
	 * OUT assertion: the field code is set for all tree elements of non
	 *     zero code length.
	 */
	function gen_codes(tree, max_code, bl_count)
	//    ct_data *tree;             /* the tree to decorate */
	//    int max_code;              /* largest code with non zero frequency */
	//    ushf *bl_count;            /* number of codes at each bit length */
	{
	  var next_code = new Array(MAX_BITS + 1); /* next code value for each bit length */
	  var code = 0;              /* running code value */
	  var bits;                  /* bit index */
	  var n;                     /* code index */
	
	  /* The distribution counts are first used to generate the code values
	   * without bit reversal.
	   */
	  for (bits = 1; bits <= MAX_BITS; bits++) {
	    next_code[bits] = code = (code + bl_count[bits - 1]) << 1;
	  }
	  /* Check that the bit counts in bl_count are consistent. The last code
	   * must be all ones.
	   */
	  //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
	  //        "inconsistent bit counts");
	  //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
	
	  for (n = 0;  n <= max_code; n++) {
	    var len = tree[n * 2 + 1]/*.Len*/;
	    if (len === 0) { continue; }
	    /* Now reverse the bits */
	    tree[n * 2]/*.Code*/ = bi_reverse(next_code[len]++, len);
	
	    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
	    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
	  }
	}
	
	
	/* ===========================================================================
	 * Initialize the various 'constant' tables.
	 */
	function tr_static_init() {
	  var n;        /* iterates over tree elements */
	  var bits;     /* bit counter */
	  var length;   /* length value */
	  var code;     /* code value */
	  var dist;     /* distance index */
	  var bl_count = new Array(MAX_BITS + 1);
	  /* number of codes at each bit length for an optimal tree */
	
	  // do check in _tr_init()
	  //if (static_init_done) return;
	
	  /* For some embedded targets, global variables are not initialized: */
	/*#ifdef NO_INIT_GLOBAL_POINTERS
	  static_l_desc.static_tree = static_ltree;
	  static_l_desc.extra_bits = extra_lbits;
	  static_d_desc.static_tree = static_dtree;
	  static_d_desc.extra_bits = extra_dbits;
	  static_bl_desc.extra_bits = extra_blbits;
	#endif*/
	
	  /* Initialize the mapping length (0..255) -> length code (0..28) */
	  length = 0;
	  for (code = 0; code < LENGTH_CODES - 1; code++) {
	    base_length[code] = length;
	    for (n = 0; n < (1 << extra_lbits[code]); n++) {
	      _length_code[length++] = code;
	    }
	  }
	  //Assert (length == 256, "tr_static_init: length != 256");
	  /* Note that the length 255 (match length 258) can be represented
	   * in two different ways: code 284 + 5 bits or code 285, so we
	   * overwrite length_code[255] to use the best encoding:
	   */
	  _length_code[length - 1] = code;
	
	  /* Initialize the mapping dist (0..32K) -> dist code (0..29) */
	  dist = 0;
	  for (code = 0; code < 16; code++) {
	    base_dist[code] = dist;
	    for (n = 0; n < (1 << extra_dbits[code]); n++) {
	      _dist_code[dist++] = code;
	    }
	  }
	  //Assert (dist == 256, "tr_static_init: dist != 256");
	  dist >>= 7; /* from now on, all distances are divided by 128 */
	  for (; code < D_CODES; code++) {
	    base_dist[code] = dist << 7;
	    for (n = 0; n < (1 << (extra_dbits[code] - 7)); n++) {
	      _dist_code[256 + dist++] = code;
	    }
	  }
	  //Assert (dist == 256, "tr_static_init: 256+dist != 512");
	
	  /* Construct the codes of the static literal tree */
	  for (bits = 0; bits <= MAX_BITS; bits++) {
	    bl_count[bits] = 0;
	  }
	
	  n = 0;
	  while (n <= 143) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 8;
	    n++;
	    bl_count[8]++;
	  }
	  while (n <= 255) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 9;
	    n++;
	    bl_count[9]++;
	  }
	  while (n <= 279) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 7;
	    n++;
	    bl_count[7]++;
	  }
	  while (n <= 287) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 8;
	    n++;
	    bl_count[8]++;
	  }
	  /* Codes 286 and 287 do not exist, but we must include them in the
	   * tree construction to get a canonical Huffman tree (longest code
	   * all ones)
	   */
	  gen_codes(static_ltree, L_CODES + 1, bl_count);
	
	  /* The static distance tree is trivial: */
	  for (n = 0; n < D_CODES; n++) {
	    static_dtree[n * 2 + 1]/*.Len*/ = 5;
	    static_dtree[n * 2]/*.Code*/ = bi_reverse(n, 5);
	  }
	
	  // Now data ready and we can init static trees
	  static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS + 1, L_CODES, MAX_BITS);
	  static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0,          D_CODES, MAX_BITS);
	  static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0,         BL_CODES, MAX_BL_BITS);
	
	  //static_init_done = true;
	}
	
	
	/* ===========================================================================
	 * Initialize a new block.
	 */
	function init_block(s) {
	  var n; /* iterates over tree elements */
	
	  /* Initialize the trees. */
	  for (n = 0; n < L_CODES;  n++) { s.dyn_ltree[n * 2]/*.Freq*/ = 0; }
	  for (n = 0; n < D_CODES;  n++) { s.dyn_dtree[n * 2]/*.Freq*/ = 0; }
	  for (n = 0; n < BL_CODES; n++) { s.bl_tree[n * 2]/*.Freq*/ = 0; }
	
	  s.dyn_ltree[END_BLOCK * 2]/*.Freq*/ = 1;
	  s.opt_len = s.static_len = 0;
	  s.last_lit = s.matches = 0;
	}
	
	
	/* ===========================================================================
	 * Flush the bit buffer and align the output on a byte boundary
	 */
	function bi_windup(s)
	{
	  if (s.bi_valid > 8) {
	    put_short(s, s.bi_buf);
	  } else if (s.bi_valid > 0) {
	    //put_byte(s, (Byte)s->bi_buf);
	    s.pending_buf[s.pending++] = s.bi_buf;
	  }
	  s.bi_buf = 0;
	  s.bi_valid = 0;
	}
	
	/* ===========================================================================
	 * Copy a stored block, storing first the length and its
	 * one's complement if requested.
	 */
	function copy_block(s, buf, len, header)
	//DeflateState *s;
	//charf    *buf;    /* the input data */
	//unsigned len;     /* its length */
	//int      header;  /* true if block header must be written */
	{
	  bi_windup(s);        /* align on byte boundary */
	
	  if (header) {
	    put_short(s, len);
	    put_short(s, ~len);
	  }
	//  while (len--) {
	//    put_byte(s, *buf++);
	//  }
	  utils.arraySet(s.pending_buf, s.window, buf, len, s.pending);
	  s.pending += len;
	}
	
	/* ===========================================================================
	 * Compares to subtrees, using the tree depth as tie breaker when
	 * the subtrees have equal frequency. This minimizes the worst case length.
	 */
	function smaller(tree, n, m, depth) {
	  var _n2 = n * 2;
	  var _m2 = m * 2;
	  return (tree[_n2]/*.Freq*/ < tree[_m2]/*.Freq*/ ||
	         (tree[_n2]/*.Freq*/ === tree[_m2]/*.Freq*/ && depth[n] <= depth[m]));
	}
	
	/* ===========================================================================
	 * Restore the heap property by moving down the tree starting at node k,
	 * exchanging a node with the smallest of its two sons if necessary, stopping
	 * when the heap property is re-established (each father smaller than its
	 * two sons).
	 */
	function pqdownheap(s, tree, k)
	//    deflate_state *s;
	//    ct_data *tree;  /* the tree to restore */
	//    int k;               /* node to move down */
	{
	  var v = s.heap[k];
	  var j = k << 1;  /* left son of k */
	  while (j <= s.heap_len) {
	    /* Set j to the smallest of the two sons: */
	    if (j < s.heap_len &&
	      smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) {
	      j++;
	    }
	    /* Exit if v is smaller than both sons */
	    if (smaller(tree, v, s.heap[j], s.depth)) { break; }
	
	    /* Exchange v with the smallest son */
	    s.heap[k] = s.heap[j];
	    k = j;
	
	    /* And continue down the tree, setting j to the left son of k */
	    j <<= 1;
	  }
	  s.heap[k] = v;
	}
	
	
	// inlined manually
	// var SMALLEST = 1;
	
	/* ===========================================================================
	 * Send the block data compressed using the given Huffman trees
	 */
	function compress_block(s, ltree, dtree)
	//    deflate_state *s;
	//    const ct_data *ltree; /* literal tree */
	//    const ct_data *dtree; /* distance tree */
	{
	  var dist;           /* distance of matched string */
	  var lc;             /* match length or unmatched char (if dist == 0) */
	  var lx = 0;         /* running index in l_buf */
	  var code;           /* the code to send */
	  var extra;          /* number of extra bits to send */
	
	  if (s.last_lit !== 0) {
	    do {
	      dist = (s.pending_buf[s.d_buf + lx * 2] << 8) | (s.pending_buf[s.d_buf + lx * 2 + 1]);
	      lc = s.pending_buf[s.l_buf + lx];
	      lx++;
	
	      if (dist === 0) {
	        send_code(s, lc, ltree); /* send a literal byte */
	        //Tracecv(isgraph(lc), (stderr," '%c' ", lc));
	      } else {
	        /* Here, lc is the match length - MIN_MATCH */
	        code = _length_code[lc];
	        send_code(s, code + LITERALS + 1, ltree); /* send the length code */
	        extra = extra_lbits[code];
	        if (extra !== 0) {
	          lc -= base_length[code];
	          send_bits(s, lc, extra);       /* send the extra length bits */
	        }
	        dist--; /* dist is now the match distance - 1 */
	        code = d_code(dist);
	        //Assert (code < D_CODES, "bad d_code");
	
	        send_code(s, code, dtree);       /* send the distance code */
	        extra = extra_dbits[code];
	        if (extra !== 0) {
	          dist -= base_dist[code];
	          send_bits(s, dist, extra);   /* send the extra distance bits */
	        }
	      } /* literal or match pair ? */
	
	      /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */
	      //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
	      //       "pendingBuf overflow");
	
	    } while (lx < s.last_lit);
	  }
	
	  send_code(s, END_BLOCK, ltree);
	}
	
	
	/* ===========================================================================
	 * Construct one Huffman tree and assigns the code bit strings and lengths.
	 * Update the total bit length for the current block.
	 * IN assertion: the field freq is set for all tree elements.
	 * OUT assertions: the fields len and code are set to the optimal bit length
	 *     and corresponding code. The length opt_len is updated; static_len is
	 *     also updated if stree is not null. The field max_code is set.
	 */
	function build_tree(s, desc)
	//    deflate_state *s;
	//    tree_desc *desc; /* the tree descriptor */
	{
	  var tree     = desc.dyn_tree;
	  var stree    = desc.stat_desc.static_tree;
	  var has_stree = desc.stat_desc.has_stree;
	  var elems    = desc.stat_desc.elems;
	  var n, m;          /* iterate over heap elements */
	  var max_code = -1; /* largest code with non zero frequency */
	  var node;          /* new node being created */
	
	  /* Construct the initial heap, with least frequent element in
	   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
	   * heap[0] is not used.
	   */
	  s.heap_len = 0;
	  s.heap_max = HEAP_SIZE;
	
	  for (n = 0; n < elems; n++) {
	    if (tree[n * 2]/*.Freq*/ !== 0) {
	      s.heap[++s.heap_len] = max_code = n;
	      s.depth[n] = 0;
	
	    } else {
	      tree[n * 2 + 1]/*.Len*/ = 0;
	    }
	  }
	
	  /* The pkzip format requires that at least one distance code exists,
	   * and that at least one bit should be sent even if there is only one
	   * possible code. So to avoid special checks later on we force at least
	   * two codes of non zero frequency.
	   */
	  while (s.heap_len < 2) {
	    node = s.heap[++s.heap_len] = (max_code < 2 ? ++max_code : 0);
	    tree[node * 2]/*.Freq*/ = 1;
	    s.depth[node] = 0;
	    s.opt_len--;
	
	    if (has_stree) {
	      s.static_len -= stree[node * 2 + 1]/*.Len*/;
	    }
	    /* node is 0 or 1 so it does not have extra bits */
	  }
	  desc.max_code = max_code;
	
	  /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
	   * establish sub-heaps of increasing lengths:
	   */
	  for (n = (s.heap_len >> 1/*int /2*/); n >= 1; n--) { pqdownheap(s, tree, n); }
	
	  /* Construct the Huffman tree by repeatedly combining the least two
	   * frequent nodes.
	   */
	  node = elems;              /* next internal node of the tree */
	  do {
	    //pqremove(s, tree, n);  /* n = node of least frequency */
	    /*** pqremove ***/
	    n = s.heap[1/*SMALLEST*/];
	    s.heap[1/*SMALLEST*/] = s.heap[s.heap_len--];
	    pqdownheap(s, tree, 1/*SMALLEST*/);
	    /***/
	
	    m = s.heap[1/*SMALLEST*/]; /* m = node of next least frequency */
	
	    s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */
	    s.heap[--s.heap_max] = m;
	
	    /* Create a new node father of n and m */
	    tree[node * 2]/*.Freq*/ = tree[n * 2]/*.Freq*/ + tree[m * 2]/*.Freq*/;
	    s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
	    tree[n * 2 + 1]/*.Dad*/ = tree[m * 2 + 1]/*.Dad*/ = node;
	
	    /* and insert the new node in the heap */
	    s.heap[1/*SMALLEST*/] = node++;
	    pqdownheap(s, tree, 1/*SMALLEST*/);
	
	  } while (s.heap_len >= 2);
	
	  s.heap[--s.heap_max] = s.heap[1/*SMALLEST*/];
	
	  /* At this point, the fields freq and dad are set. We can now
	   * generate the bit lengths.
	   */
	  gen_bitlen(s, desc);
	
	  /* The field len is now set, we can generate the bit codes */
	  gen_codes(tree, max_code, s.bl_count);
	}
	
	
	/* ===========================================================================
	 * Scan a literal or distance tree to determine the frequencies of the codes
	 * in the bit length tree.
	 */
	function scan_tree(s, tree, max_code)
	//    deflate_state *s;
	//    ct_data *tree;   /* the tree to be scanned */
	//    int max_code;    /* and its largest code of non zero frequency */
	{
	  var n;                     /* iterates over all tree elements */
	  var prevlen = -1;          /* last emitted length */
	  var curlen;                /* length of current code */
	
	  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */
	
	  var count = 0;             /* repeat count of the current code */
	  var max_count = 7;         /* max repeat count */
	  var min_count = 4;         /* min repeat count */
	
	  if (nextlen === 0) {
	    max_count = 138;
	    min_count = 3;
	  }
	  tree[(max_code + 1) * 2 + 1]/*.Len*/ = 0xffff; /* guard */
	
	  for (n = 0; n <= max_code; n++) {
	    curlen = nextlen;
	    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;
	
	    if (++count < max_count && curlen === nextlen) {
	      continue;
	
	    } else if (count < min_count) {
	      s.bl_tree[curlen * 2]/*.Freq*/ += count;
	
	    } else if (curlen !== 0) {
	
	      if (curlen !== prevlen) { s.bl_tree[curlen * 2]/*.Freq*/++; }
	      s.bl_tree[REP_3_6 * 2]/*.Freq*/++;
	
	    } else if (count <= 10) {
	      s.bl_tree[REPZ_3_10 * 2]/*.Freq*/++;
	
	    } else {
	      s.bl_tree[REPZ_11_138 * 2]/*.Freq*/++;
	    }
	
	    count = 0;
	    prevlen = curlen;
	
	    if (nextlen === 0) {
	      max_count = 138;
	      min_count = 3;
	
	    } else if (curlen === nextlen) {
	      max_count = 6;
	      min_count = 3;
	
	    } else {
	      max_count = 7;
	      min_count = 4;
	    }
	  }
	}
	
	
	/* ===========================================================================
	 * Send a literal or distance tree in compressed form, using the codes in
	 * bl_tree.
	 */
	function send_tree(s, tree, max_code)
	//    deflate_state *s;
	//    ct_data *tree; /* the tree to be scanned */
	//    int max_code;       /* and its largest code of non zero frequency */
	{
	  var n;                     /* iterates over all tree elements */
	  var prevlen = -1;          /* last emitted length */
	  var curlen;                /* length of current code */
	
	  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */
	
	  var count = 0;             /* repeat count of the current code */
	  var max_count = 7;         /* max repeat count */
	  var min_count = 4;         /* min repeat count */
	
	  /* tree[max_code+1].Len = -1; */  /* guard already set */
	  if (nextlen === 0) {
	    max_count = 138;
	    min_count = 3;
	  }
	
	  for (n = 0; n <= max_code; n++) {
	    curlen = nextlen;
	    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;
	
	    if (++count < max_count && curlen === nextlen) {
	      continue;
	
	    } else if (count < min_count) {
	      do { send_code(s, curlen, s.bl_tree); } while (--count !== 0);
	
	    } else if (curlen !== 0) {
	      if (curlen !== prevlen) {
	        send_code(s, curlen, s.bl_tree);
	        count--;
	      }
	      //Assert(count >= 3 && count <= 6, " 3_6?");
	      send_code(s, REP_3_6, s.bl_tree);
	      send_bits(s, count - 3, 2);
	
	    } else if (count <= 10) {
	      send_code(s, REPZ_3_10, s.bl_tree);
	      send_bits(s, count - 3, 3);
	
	    } else {
	      send_code(s, REPZ_11_138, s.bl_tree);
	      send_bits(s, count - 11, 7);
	    }
	
	    count = 0;
	    prevlen = curlen;
	    if (nextlen === 0) {
	      max_count = 138;
	      min_count = 3;
	
	    } else if (curlen === nextlen) {
	      max_count = 6;
	      min_count = 3;
	
	    } else {
	      max_count = 7;
	      min_count = 4;
	    }
	  }
	}
	
	
	/* ===========================================================================
	 * Construct the Huffman tree for the bit lengths and return the index in
	 * bl_order of the last bit length code to send.
	 */
	function build_bl_tree(s) {
	  var max_blindex;  /* index of last bit length code of non zero freq */
	
	  /* Determine the bit length frequencies for literal and distance trees */
	  scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
	  scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
	
	  /* Build the bit length tree: */
	  build_tree(s, s.bl_desc);
	  /* opt_len now includes the length of the tree representations, except
	   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
	   */
	
	  /* Determine the number of bit length codes to send. The pkzip format
	   * requires that at least 4 bit length codes be sent. (appnote.txt says
	   * 3 but the actual value used is 4.)
	   */
	  for (max_blindex = BL_CODES - 1; max_blindex >= 3; max_blindex--) {
	    if (s.bl_tree[bl_order[max_blindex] * 2 + 1]/*.Len*/ !== 0) {
	      break;
	    }
	  }
	  /* Update opt_len to include the bit length tree and counts */
	  s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
	  //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
	  //        s->opt_len, s->static_len));
	
	  return max_blindex;
	}
	
	
	/* ===========================================================================
	 * Send the header for a block using dynamic Huffman trees: the counts, the
	 * lengths of the bit length codes, the literal tree and the distance tree.
	 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
	 */
	function send_all_trees(s, lcodes, dcodes, blcodes)
	//    deflate_state *s;
	//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
	{
	  var rank;                    /* index in bl_order */
	
	  //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
	  //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
	  //        "too many codes");
	  //Tracev((stderr, "\nbl counts: "));
	  send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */
	  send_bits(s, dcodes - 1,   5);
	  send_bits(s, blcodes - 4,  4); /* not -3 as stated in appnote.txt */
	  for (rank = 0; rank < blcodes; rank++) {
	    //Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
	    send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1]/*.Len*/, 3);
	  }
	  //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
	
	  send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */
	  //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
	
	  send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */
	  //Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
	}
	
	
	/* ===========================================================================
	 * Check if the data type is TEXT or BINARY, using the following algorithm:
	 * - TEXT if the two conditions below are satisfied:
	 *    a) There are no non-portable control characters belonging to the
	 *       "black list" (0..6, 14..25, 28..31).
	 *    b) There is at least one printable character belonging to the
	 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
	 * - BINARY otherwise.
	 * - The following partially-portable control characters form a
	 *   "gray list" that is ignored in this detection algorithm:
	 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
	 * IN assertion: the fields Freq of dyn_ltree are set.
	 */
	function detect_data_type(s) {
	  /* black_mask is the bit mask of black-listed bytes
	   * set bits 0..6, 14..25, and 28..31
	   * 0xf3ffc07f = binary 11110011111111111100000001111111
	   */
	  var black_mask = 0xf3ffc07f;
	  var n;
	
	  /* Check for non-textual ("black-listed") bytes. */
	  for (n = 0; n <= 31; n++, black_mask >>>= 1) {
	    if ((black_mask & 1) && (s.dyn_ltree[n * 2]/*.Freq*/ !== 0)) {
	      return Z_BINARY;
	    }
	  }
	
	  /* Check for textual ("white-listed") bytes. */
	  if (s.dyn_ltree[9 * 2]/*.Freq*/ !== 0 || s.dyn_ltree[10 * 2]/*.Freq*/ !== 0 ||
	      s.dyn_ltree[13 * 2]/*.Freq*/ !== 0) {
	    return Z_TEXT;
	  }
	  for (n = 32; n < LITERALS; n++) {
	    if (s.dyn_ltree[n * 2]/*.Freq*/ !== 0) {
	      return Z_TEXT;
	    }
	  }
	
	  /* There are no "black-listed" or "white-listed" bytes:
	   * this stream either is empty or has tolerated ("gray-listed") bytes only.
	   */
	  return Z_BINARY;
	}
	
	
	var static_init_done = false;
	
	/* ===========================================================================
	 * Initialize the tree data structures for a new zlib stream.
	 */
	function _tr_init(s)
	{
	
	  if (!static_init_done) {
	    tr_static_init();
	    static_init_done = true;
	  }
	
	  s.l_desc  = new TreeDesc(s.dyn_ltree, static_l_desc);
	  s.d_desc  = new TreeDesc(s.dyn_dtree, static_d_desc);
	  s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);
	
	  s.bi_buf = 0;
	  s.bi_valid = 0;
	
	  /* Initialize the first block of the first file: */
	  init_block(s);
	}
	
	
	/* ===========================================================================
	 * Send a stored block
	 */
	function _tr_stored_block(s, buf, stored_len, last)
	//DeflateState *s;
	//charf *buf;       /* input block */
	//ulg stored_len;   /* length of input block */
	//int last;         /* one if this is the last block for a file */
	{
	  send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3);    /* send block type */
	  copy_block(s, buf, stored_len, true); /* with header */
	}
	
	
	/* ===========================================================================
	 * Send one empty static block to give enough lookahead for inflate.
	 * This takes 10 bits, of which 7 may remain in the bit buffer.
	 */
	function _tr_align(s) {
	  send_bits(s, STATIC_TREES << 1, 3);
	  send_code(s, END_BLOCK, static_ltree);
	  bi_flush(s);
	}
	
	
	/* ===========================================================================
	 * Determine the best encoding for the current block: dynamic trees, static
	 * trees or store, and output the encoded block to the zip file.
	 */
	function _tr_flush_block(s, buf, stored_len, last)
	//DeflateState *s;
	//charf *buf;       /* input block, or NULL if too old */
	//ulg stored_len;   /* length of input block */
	//int last;         /* one if this is the last block for a file */
	{
	  var opt_lenb, static_lenb;  /* opt_len and static_len in bytes */
	  var max_blindex = 0;        /* index of last bit length code of non zero freq */
	
	  /* Build the Huffman trees unless a stored block is forced */
	  if (s.level > 0) {
	
	    /* Check if the file is binary or text */
	    if (s.strm.data_type === Z_UNKNOWN) {
	      s.strm.data_type = detect_data_type(s);
	    }
	
	    /* Construct the literal and distance trees */
	    build_tree(s, s.l_desc);
	    // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
	    //        s->static_len));
	
	    build_tree(s, s.d_desc);
	    // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
	    //        s->static_len));
	    /* At this point, opt_len and static_len are the total bit lengths of
	     * the compressed block data, excluding the tree representations.
	     */
	
	    /* Build the bit length tree for the above two trees, and get the index
	     * in bl_order of the last bit length code to send.
	     */
	    max_blindex = build_bl_tree(s);
	
	    /* Determine the best encoding. Compute the block lengths in bytes. */
	    opt_lenb = (s.opt_len + 3 + 7) >>> 3;
	    static_lenb = (s.static_len + 3 + 7) >>> 3;
	
	    // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
	    //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
	    //        s->last_lit));
	
	    if (static_lenb <= opt_lenb) { opt_lenb = static_lenb; }
	
	  } else {
	    // Assert(buf != (char*)0, "lost buf");
	    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */
	  }
	
	  if ((stored_len + 4 <= opt_lenb) && (buf !== -1)) {
	    /* 4: two words for the lengths */
	
	    /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
	     * Otherwise we can't have processed more than WSIZE input bytes since
	     * the last block flush, because compression would have been
	     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
	     * transform a block into a stored block.
	     */
	    _tr_stored_block(s, buf, stored_len, last);
	
	  } else if (s.strategy === Z_FIXED || static_lenb === opt_lenb) {
	
	    send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
	    compress_block(s, static_ltree, static_dtree);
	
	  } else {
	    send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
	    send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
	    compress_block(s, s.dyn_ltree, s.dyn_dtree);
	  }
	  // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
	  /* The above check is made mod 2^32, for files larger than 512 MB
	   * and uLong implemented on 32 bits.
	   */
	  init_block(s);
	
	  if (last) {
	    bi_windup(s);
	  }
	  // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
	  //       s->compressed_len-7*last));
	}
	
	/* ===========================================================================
	 * Save the match info and tally the frequency counts. Return true if
	 * the current block must be flushed.
	 */
	function _tr_tally(s, dist, lc)
	//    deflate_state *s;
	//    unsigned dist;  /* distance of matched string */
	//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
	{
	  //var out_length, in_length, dcode;
	
	  s.pending_buf[s.d_buf + s.last_lit * 2]     = (dist >>> 8) & 0xff;
	  s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;
	
	  s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
	  s.last_lit++;
	
	  if (dist === 0) {
	    /* lc is the unmatched char */
	    s.dyn_ltree[lc * 2]/*.Freq*/++;
	  } else {
	    s.matches++;
	    /* Here, lc is the match length - MIN_MATCH */
	    dist--;             /* dist = match distance - 1 */
	    //Assert((ush)dist < (ush)MAX_DIST(s) &&
	    //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
	    //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
	
	    s.dyn_ltree[(_length_code[lc] + LITERALS + 1) * 2]/*.Freq*/++;
	    s.dyn_dtree[d_code(dist) * 2]/*.Freq*/++;
	  }
	
	// (!) This block is disabled in zlib defaults,
	// don't enable it for binary compatibility
	
	//#ifdef TRUNCATE_BLOCK
	//  /* Try to guess if it is profitable to stop the current block here */
	//  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
	//    /* Compute an upper bound for the compressed length */
	//    out_length = s.last_lit*8;
	//    in_length = s.strstart - s.block_start;
	//
	//    for (dcode = 0; dcode < D_CODES; dcode++) {
	//      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
	//    }
	//    out_length >>>= 3;
	//    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
	//    //       s->last_lit, in_length, out_length,
	//    //       100L - out_length*100L/in_length));
	//    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
	//      return true;
	//    }
	//  }
	//#endif
	
	  return (s.last_lit === s.lit_bufsize - 1);
	  /* We avoid equality with lit_bufsize because of wraparound at 64K
	   * on 16 bit machines and because stored blocks are restricted to
	   * 64K-1 bytes.
	   */
	}
	
	exports._tr_init  = _tr_init;
	exports._tr_stored_block = _tr_stored_block;
	exports._tr_flush_block  = _tr_flush_block;
	exports._tr_tally = _tr_tally;
	exports._tr_align = _tr_align;
	
	},{"../utils/common":5}],12:[function(require,module,exports){
	'use strict';
	
	// (C) 1995-2013 Jean-loup Gailly and Mark Adler
	// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
	//
	// This software is provided 'as-is', without any express or implied
	// warranty. In no event will the authors be held liable for any damages
	// arising from the use of this software.
	//
	// Permission is granted to anyone to use this software for any purpose,
	// including commercial applications, and to alter it and redistribute it
	// freely, subject to the following restrictions:
	//
	// 1. The origin of this software must not be misrepresented; you must not
	//   claim that you wrote the original software. If you use this software
	//   in a product, an acknowledgment in the product documentation would be
	//   appreciated but is not required.
	// 2. Altered source versions must be plainly marked as such, and must not be
	//   misrepresented as being the original software.
	// 3. This notice may not be removed or altered from any source distribution.
	
	function ZStream() {
	  /* next input byte */
	  this.input = null; // JS specific, because we have no pointers
	  this.next_in = 0;
	  /* number of bytes available at input */
	  this.avail_in = 0;
	  /* total number of input bytes read so far */
	  this.total_in = 0;
	  /* next output byte should be put there */
	  this.output = null; // JS specific, because we have no pointers
	  this.next_out = 0;
	  /* remaining free space at output */
	  this.avail_out = 0;
	  /* total number of bytes output so far */
	  this.total_out = 0;
	  /* last error message, NULL if no error */
	  this.msg = ''/*Z_NULL*/;
	  /* not visible by applications */
	  this.state = null;
	  /* best guess about the data type: binary or text */
	  this.data_type = 2/*Z_UNKNOWN*/;
	  /* adler32 value of the uncompressed data */
	  this.adler = 0;
	}
	
	module.exports = ZStream;
	
	},{}]},{},[3])(3)
	});


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.ResizeObserver = factory());
	}(this, (function () { 'use strict';
	
	    /**
	     * A collection of shims that provide minimal functionality of the ES6 collections.
	     *
	     * These implementations are not meant to be used outside of the ResizeObserver
	     * modules as they cover only a limited range of use cases.
	     */
	    /* eslint-disable require-jsdoc, valid-jsdoc */
	    var MapShim = (function () {
	        if (typeof Map !== 'undefined') {
	            return Map;
	        }
	        /**
	         * Returns index in provided array that matches the specified key.
	         *
	         * @param {Array<Array>} arr
	         * @param {*} key
	         * @returns {number}
	         */
	        function getIndex(arr, key) {
	            var result = -1;
	            arr.some(function (entry, index) {
	                if (entry[0] === key) {
	                    result = index;
	                    return true;
	                }
	                return false;
	            });
	            return result;
	        }
	        return /** @class */ (function () {
	            function class_1() {
	                this.__entries__ = [];
	            }
	            Object.defineProperty(class_1.prototype, "size", {
	                /**
	                 * @returns {boolean}
	                 */
	                get: function () {
	                    return this.__entries__.length;
	                },
	                enumerable: true,
	                configurable: true
	            });
	            /**
	             * @param {*} key
	             * @returns {*}
	             */
	            class_1.prototype.get = function (key) {
	                var index = getIndex(this.__entries__, key);
	                var entry = this.__entries__[index];
	                return entry && entry[1];
	            };
	            /**
	             * @param {*} key
	             * @param {*} value
	             * @returns {void}
	             */
	            class_1.prototype.set = function (key, value) {
	                var index = getIndex(this.__entries__, key);
	                if (~index) {
	                    this.__entries__[index][1] = value;
	                }
	                else {
	                    this.__entries__.push([key, value]);
	                }
	            };
	            /**
	             * @param {*} key
	             * @returns {void}
	             */
	            class_1.prototype.delete = function (key) {
	                var entries = this.__entries__;
	                var index = getIndex(entries, key);
	                if (~index) {
	                    entries.splice(index, 1);
	                }
	            };
	            /**
	             * @param {*} key
	             * @returns {void}
	             */
	            class_1.prototype.has = function (key) {
	                return !!~getIndex(this.__entries__, key);
	            };
	            /**
	             * @returns {void}
	             */
	            class_1.prototype.clear = function () {
	                this.__entries__.splice(0);
	            };
	            /**
	             * @param {Function} callback
	             * @param {*} [ctx=null]
	             * @returns {void}
	             */
	            class_1.prototype.forEach = function (callback, ctx) {
	                if (ctx === void 0) { ctx = null; }
	                for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
	                    var entry = _a[_i];
	                    callback.call(ctx, entry[1], entry[0]);
	                }
	            };
	            return class_1;
	        }());
	    })();
	
	    /**
	     * Detects whether window and document objects are available in current environment.
	     */
	    var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
	
	    // Returns global object of a current environment.
	    var global$1 = (function () {
	        if (typeof global !== 'undefined' && global.Math === Math) {
	            return global;
	        }
	        if (typeof self !== 'undefined' && self.Math === Math) {
	            return self;
	        }
	        if (typeof window !== 'undefined' && window.Math === Math) {
	            return window;
	        }
	        // eslint-disable-next-line no-new-func
	        return Function('return this')();
	    })();
	
	    /**
	     * A shim for the requestAnimationFrame which falls back to the setTimeout if
	     * first one is not supported.
	     *
	     * @returns {number} Requests' identifier.
	     */
	    var requestAnimationFrame$1 = (function () {
	        if (typeof requestAnimationFrame === 'function') {
	            // It's required to use a bounded function because IE sometimes throws
	            // an "Invalid calling object" error if rAF is invoked without the global
	            // object on the left hand side.
	            return requestAnimationFrame.bind(global$1);
	        }
	        return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
	    })();
	
	    // Defines minimum timeout before adding a trailing call.
	    var trailingTimeout = 2;
	    /**
	     * Creates a wrapper function which ensures that provided callback will be
	     * invoked only once during the specified delay period.
	     *
	     * @param {Function} callback - Function to be invoked after the delay period.
	     * @param {number} delay - Delay after which to invoke callback.
	     * @returns {Function}
	     */
	    function throttle (callback, delay) {
	        var leadingCall = false, trailingCall = false, lastCallTime = 0;
	        /**
	         * Invokes the original callback function and schedules new invocation if
	         * the "proxy" was called during current request.
	         *
	         * @returns {void}
	         */
	        function resolvePending() {
	            if (leadingCall) {
	                leadingCall = false;
	                callback();
	            }
	            if (trailingCall) {
	                proxy();
	            }
	        }
	        /**
	         * Callback invoked after the specified delay. It will further postpone
	         * invocation of the original function delegating it to the
	         * requestAnimationFrame.
	         *
	         * @returns {void}
	         */
	        function timeoutCallback() {
	            requestAnimationFrame$1(resolvePending);
	        }
	        /**
	         * Schedules invocation of the original function.
	         *
	         * @returns {void}
	         */
	        function proxy() {
	            var timeStamp = Date.now();
	            if (leadingCall) {
	                // Reject immediately following calls.
	                if (timeStamp - lastCallTime < trailingTimeout) {
	                    return;
	                }
	                // Schedule new call to be in invoked when the pending one is resolved.
	                // This is important for "transitions" which never actually start
	                // immediately so there is a chance that we might miss one if change
	                // happens amids the pending invocation.
	                trailingCall = true;
	            }
	            else {
	                leadingCall = true;
	                trailingCall = false;
	                setTimeout(timeoutCallback, delay);
	            }
	            lastCallTime = timeStamp;
	        }
	        return proxy;
	    }
	
	    // Minimum delay before invoking the update of observers.
	    var REFRESH_DELAY = 20;
	    // A list of substrings of CSS properties used to find transition events that
	    // might affect dimensions of observed elements.
	    var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
	    // Check if MutationObserver is available.
	    var mutationObserverSupported = typeof MutationObserver !== 'undefined';
	    /**
	     * Singleton controller class which handles updates of ResizeObserver instances.
	     */
	    var ResizeObserverController = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserverController.
	         *
	         * @private
	         */
	        function ResizeObserverController() {
	            /**
	             * Indicates whether DOM listeners have been added.
	             *
	             * @private {boolean}
	             */
	            this.connected_ = false;
	            /**
	             * Tells that controller has subscribed for Mutation Events.
	             *
	             * @private {boolean}
	             */
	            this.mutationEventsAdded_ = false;
	            /**
	             * Keeps reference to the instance of MutationObserver.
	             *
	             * @private {MutationObserver}
	             */
	            this.mutationsObserver_ = null;
	            /**
	             * A list of connected observers.
	             *
	             * @private {Array<ResizeObserverSPI>}
	             */
	            this.observers_ = [];
	            this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
	            this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
	        }
	        /**
	         * Adds observer to observers list.
	         *
	         * @param {ResizeObserverSPI} observer - Observer to be added.
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.addObserver = function (observer) {
	            if (!~this.observers_.indexOf(observer)) {
	                this.observers_.push(observer);
	            }
	            // Add listeners if they haven't been added yet.
	            if (!this.connected_) {
	                this.connect_();
	            }
	        };
	        /**
	         * Removes observer from observers list.
	         *
	         * @param {ResizeObserverSPI} observer - Observer to be removed.
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.removeObserver = function (observer) {
	            var observers = this.observers_;
	            var index = observers.indexOf(observer);
	            // Remove observer if it's present in registry.
	            if (~index) {
	                observers.splice(index, 1);
	            }
	            // Remove listeners if controller has no connected observers.
	            if (!observers.length && this.connected_) {
	                this.disconnect_();
	            }
	        };
	        /**
	         * Invokes the update of observers. It will continue running updates insofar
	         * it detects changes.
	         *
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.refresh = function () {
	            var changesDetected = this.updateObservers_();
	            // Continue running updates if changes have been detected as there might
	            // be future ones caused by CSS transitions.
	            if (changesDetected) {
	                this.refresh();
	            }
	        };
	        /**
	         * Updates every observer from observers list and notifies them of queued
	         * entries.
	         *
	         * @private
	         * @returns {boolean} Returns "true" if any observer has detected changes in
	         *      dimensions of it's elements.
	         */
	        ResizeObserverController.prototype.updateObservers_ = function () {
	            // Collect observers that have active observations.
	            var activeObservers = this.observers_.filter(function (observer) {
	                return observer.gatherActive(), observer.hasActive();
	            });
	            // Deliver notifications in a separate cycle in order to avoid any
	            // collisions between observers, e.g. when multiple instances of
	            // ResizeObserver are tracking the same element and the callback of one
	            // of them changes content dimensions of the observed target. Sometimes
	            // this may result in notifications being blocked for the rest of observers.
	            activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
	            return activeObservers.length > 0;
	        };
	        /**
	         * Initializes DOM listeners.
	         *
	         * @private
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.connect_ = function () {
	            // Do nothing if running in a non-browser environment or if listeners
	            // have been already added.
	            if (!isBrowser || this.connected_) {
	                return;
	            }
	            // Subscription to the "Transitionend" event is used as a workaround for
	            // delayed transitions. This way it's possible to capture at least the
	            // final state of an element.
	            document.addEventListener('transitionend', this.onTransitionEnd_);
	            window.addEventListener('resize', this.refresh);
	            if (mutationObserverSupported) {
	                this.mutationsObserver_ = new MutationObserver(this.refresh);
	                this.mutationsObserver_.observe(document, {
	                    attributes: true,
	                    childList: true,
	                    characterData: true,
	                    subtree: true
	                });
	            }
	            else {
	                document.addEventListener('DOMSubtreeModified', this.refresh);
	                this.mutationEventsAdded_ = true;
	            }
	            this.connected_ = true;
	        };
	        /**
	         * Removes DOM listeners.
	         *
	         * @private
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.disconnect_ = function () {
	            // Do nothing if running in a non-browser environment or if listeners
	            // have been already removed.
	            if (!isBrowser || !this.connected_) {
	                return;
	            }
	            document.removeEventListener('transitionend', this.onTransitionEnd_);
	            window.removeEventListener('resize', this.refresh);
	            if (this.mutationsObserver_) {
	                this.mutationsObserver_.disconnect();
	            }
	            if (this.mutationEventsAdded_) {
	                document.removeEventListener('DOMSubtreeModified', this.refresh);
	            }
	            this.mutationsObserver_ = null;
	            this.mutationEventsAdded_ = false;
	            this.connected_ = false;
	        };
	        /**
	         * "Transitionend" event handler.
	         *
	         * @private
	         * @param {TransitionEvent} event
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
	            var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
	            // Detect whether transition may affect dimensions of an element.
	            var isReflowProperty = transitionKeys.some(function (key) {
	                return !!~propertyName.indexOf(key);
	            });
	            if (isReflowProperty) {
	                this.refresh();
	            }
	        };
	        /**
	         * Returns instance of the ResizeObserverController.
	         *
	         * @returns {ResizeObserverController}
	         */
	        ResizeObserverController.getInstance = function () {
	            if (!this.instance_) {
	                this.instance_ = new ResizeObserverController();
	            }
	            return this.instance_;
	        };
	        /**
	         * Holds reference to the controller's instance.
	         *
	         * @private {ResizeObserverController}
	         */
	        ResizeObserverController.instance_ = null;
	        return ResizeObserverController;
	    }());
	
	    /**
	     * Defines non-writable/enumerable properties of the provided target object.
	     *
	     * @param {Object} target - Object for which to define properties.
	     * @param {Object} props - Properties to be defined.
	     * @returns {Object} Target object.
	     */
	    var defineConfigurable = (function (target, props) {
	        for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
	            var key = _a[_i];
	            Object.defineProperty(target, key, {
	                value: props[key],
	                enumerable: false,
	                writable: false,
	                configurable: true
	            });
	        }
	        return target;
	    });
	
	    /**
	     * Returns the global object associated with provided element.
	     *
	     * @param {Object} target
	     * @returns {Object}
	     */
	    var getWindowOf = (function (target) {
	        // Assume that the element is an instance of Node, which means that it
	        // has the "ownerDocument" property from which we can retrieve a
	        // corresponding global object.
	        var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
	        // Return the local global object if it's not possible extract one from
	        // provided element.
	        return ownerGlobal || global$1;
	    });
	
	    // Placeholder of an empty content rectangle.
	    var emptyRect = createRectInit(0, 0, 0, 0);
	    /**
	     * Converts provided string to a number.
	     *
	     * @param {number|string} value
	     * @returns {number}
	     */
	    function toFloat(value) {
	        return parseFloat(value) || 0;
	    }
	    /**
	     * Extracts borders size from provided styles.
	     *
	     * @param {CSSStyleDeclaration} styles
	     * @param {...string} positions - Borders positions (top, right, ...)
	     * @returns {number}
	     */
	    function getBordersSize(styles) {
	        var positions = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            positions[_i - 1] = arguments[_i];
	        }
	        return positions.reduce(function (size, position) {
	            var value = styles['border-' + position + '-width'];
	            return size + toFloat(value);
	        }, 0);
	    }
	    /**
	     * Extracts paddings sizes from provided styles.
	     *
	     * @param {CSSStyleDeclaration} styles
	     * @returns {Object} Paddings box.
	     */
	    function getPaddings(styles) {
	        var positions = ['top', 'right', 'bottom', 'left'];
	        var paddings = {};
	        for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
	            var position = positions_1[_i];
	            var value = styles['padding-' + position];
	            paddings[position] = toFloat(value);
	        }
	        return paddings;
	    }
	    /**
	     * Calculates content rectangle of provided SVG element.
	     *
	     * @param {SVGGraphicsElement} target - Element content rectangle of which needs
	     *      to be calculated.
	     * @returns {DOMRectInit}
	     */
	    function getSVGContentRect(target) {
	        var bbox = target.getBBox();
	        return createRectInit(0, 0, bbox.width, bbox.height);
	    }
	    /**
	     * Calculates content rectangle of provided HTMLElement.
	     *
	     * @param {HTMLElement} target - Element for which to calculate the content rectangle.
	     * @returns {DOMRectInit}
	     */
	    function getHTMLElementContentRect(target) {
	        // Client width & height properties can't be
	        // used exclusively as they provide rounded values.
	        var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
	        // By this condition we can catch all non-replaced inline, hidden and
	        // detached elements. Though elements with width & height properties less
	        // than 0.5 will be discarded as well.
	        //
	        // Without it we would need to implement separate methods for each of
	        // those cases and it's not possible to perform a precise and performance
	        // effective test for hidden elements. E.g. even jQuery's ':visible' filter
	        // gives wrong results for elements with width & height less than 0.5.
	        if (!clientWidth && !clientHeight) {
	            return emptyRect;
	        }
	        var styles = getWindowOf(target).getComputedStyle(target);
	        var paddings = getPaddings(styles);
	        var horizPad = paddings.left + paddings.right;
	        var vertPad = paddings.top + paddings.bottom;
	        // Computed styles of width & height are being used because they are the
	        // only dimensions available to JS that contain non-rounded values. It could
	        // be possible to utilize the getBoundingClientRect if only it's data wasn't
	        // affected by CSS transformations let alone paddings, borders and scroll bars.
	        var width = toFloat(styles.width), height = toFloat(styles.height);
	        // Width & height include paddings and borders when the 'border-box' box
	        // model is applied (except for IE).
	        if (styles.boxSizing === 'border-box') {
	            // Following conditions are required to handle Internet Explorer which
	            // doesn't include paddings and borders to computed CSS dimensions.
	            //
	            // We can say that if CSS dimensions + paddings are equal to the "client"
	            // properties then it's either IE, and thus we don't need to subtract
	            // anything, or an element merely doesn't have paddings/borders styles.
	            if (Math.round(width + horizPad) !== clientWidth) {
	                width -= getBordersSize(styles, 'left', 'right') + horizPad;
	            }
	            if (Math.round(height + vertPad) !== clientHeight) {
	                height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
	            }
	        }
	        // Following steps can't be applied to the document's root element as its
	        // client[Width/Height] properties represent viewport area of the window.
	        // Besides, it's as well not necessary as the <html> itself neither has
	        // rendered scroll bars nor it can be clipped.
	        if (!isDocumentElement(target)) {
	            // In some browsers (only in Firefox, actually) CSS width & height
	            // include scroll bars size which can be removed at this step as scroll
	            // bars are the only difference between rounded dimensions + paddings
	            // and "client" properties, though that is not always true in Chrome.
	            var vertScrollbar = Math.round(width + horizPad) - clientWidth;
	            var horizScrollbar = Math.round(height + vertPad) - clientHeight;
	            // Chrome has a rather weird rounding of "client" properties.
	            // E.g. for an element with content width of 314.2px it sometimes gives
	            // the client width of 315px and for the width of 314.7px it may give
	            // 314px. And it doesn't happen all the time. So just ignore this delta
	            // as a non-relevant.
	            if (Math.abs(vertScrollbar) !== 1) {
	                width -= vertScrollbar;
	            }
	            if (Math.abs(horizScrollbar) !== 1) {
	                height -= horizScrollbar;
	            }
	        }
	        return createRectInit(paddings.left, paddings.top, width, height);
	    }
	    /**
	     * Checks whether provided element is an instance of the SVGGraphicsElement.
	     *
	     * @param {Element} target - Element to be checked.
	     * @returns {boolean}
	     */
	    var isSVGGraphicsElement = (function () {
	        // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
	        // interface.
	        if (typeof SVGGraphicsElement !== 'undefined') {
	            return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
	        }
	        // If it's so, then check that element is at least an instance of the
	        // SVGElement and that it has the "getBBox" method.
	        // eslint-disable-next-line no-extra-parens
	        return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
	            typeof target.getBBox === 'function'); };
	    })();
	    /**
	     * Checks whether provided element is a document element (<html>).
	     *
	     * @param {Element} target - Element to be checked.
	     * @returns {boolean}
	     */
	    function isDocumentElement(target) {
	        return target === getWindowOf(target).document.documentElement;
	    }
	    /**
	     * Calculates an appropriate content rectangle for provided html or svg element.
	     *
	     * @param {Element} target - Element content rectangle of which needs to be calculated.
	     * @returns {DOMRectInit}
	     */
	    function getContentRect(target) {
	        if (!isBrowser) {
	            return emptyRect;
	        }
	        if (isSVGGraphicsElement(target)) {
	            return getSVGContentRect(target);
	        }
	        return getHTMLElementContentRect(target);
	    }
	    /**
	     * Creates rectangle with an interface of the DOMRectReadOnly.
	     * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
	     *
	     * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
	     * @returns {DOMRectReadOnly}
	     */
	    function createReadOnlyRect(_a) {
	        var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
	        // If DOMRectReadOnly is available use it as a prototype for the rectangle.
	        var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
	        var rect = Object.create(Constr.prototype);
	        // Rectangle's properties are not writable and non-enumerable.
	        defineConfigurable(rect, {
	            x: x, y: y, width: width, height: height,
	            top: y,
	            right: x + width,
	            bottom: height + y,
	            left: x
	        });
	        return rect;
	    }
	    /**
	     * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
	     * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
	     *
	     * @param {number} x - X coordinate.
	     * @param {number} y - Y coordinate.
	     * @param {number} width - Rectangle's width.
	     * @param {number} height - Rectangle's height.
	     * @returns {DOMRectInit}
	     */
	    function createRectInit(x, y, width, height) {
	        return { x: x, y: y, width: width, height: height };
	    }
	
	    /**
	     * Class that is responsible for computations of the content rectangle of
	     * provided DOM element and for keeping track of it's changes.
	     */
	    var ResizeObservation = /** @class */ (function () {
	        /**
	         * Creates an instance of ResizeObservation.
	         *
	         * @param {Element} target - Element to be observed.
	         */
	        function ResizeObservation(target) {
	            /**
	             * Broadcasted width of content rectangle.
	             *
	             * @type {number}
	             */
	            this.broadcastWidth = 0;
	            /**
	             * Broadcasted height of content rectangle.
	             *
	             * @type {number}
	             */
	            this.broadcastHeight = 0;
	            /**
	             * Reference to the last observed content rectangle.
	             *
	             * @private {DOMRectInit}
	             */
	            this.contentRect_ = createRectInit(0, 0, 0, 0);
	            this.target = target;
	        }
	        /**
	         * Updates content rectangle and tells whether it's width or height properties
	         * have changed since the last broadcast.
	         *
	         * @returns {boolean}
	         */
	        ResizeObservation.prototype.isActive = function () {
	            var rect = getContentRect(this.target);
	            this.contentRect_ = rect;
	            return (rect.width !== this.broadcastWidth ||
	                rect.height !== this.broadcastHeight);
	        };
	        /**
	         * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
	         * from the corresponding properties of the last observed content rectangle.
	         *
	         * @returns {DOMRectInit} Last observed content rectangle.
	         */
	        ResizeObservation.prototype.broadcastRect = function () {
	            var rect = this.contentRect_;
	            this.broadcastWidth = rect.width;
	            this.broadcastHeight = rect.height;
	            return rect;
	        };
	        return ResizeObservation;
	    }());
	
	    var ResizeObserverEntry = /** @class */ (function () {
	        /**
	         * Creates an instance of ResizeObserverEntry.
	         *
	         * @param {Element} target - Element that is being observed.
	         * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
	         */
	        function ResizeObserverEntry(target, rectInit) {
	            var contentRect = createReadOnlyRect(rectInit);
	            // According to the specification following properties are not writable
	            // and are also not enumerable in the native implementation.
	            //
	            // Property accessors are not being used as they'd require to define a
	            // private WeakMap storage which may cause memory leaks in browsers that
	            // don't support this type of collections.
	            defineConfigurable(this, { target: target, contentRect: contentRect });
	        }
	        return ResizeObserverEntry;
	    }());
	
	    var ResizeObserverSPI = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserver.
	         *
	         * @param {ResizeObserverCallback} callback - Callback function that is invoked
	         *      when one of the observed elements changes it's content dimensions.
	         * @param {ResizeObserverController} controller - Controller instance which
	         *      is responsible for the updates of observer.
	         * @param {ResizeObserver} callbackCtx - Reference to the public
	         *      ResizeObserver instance which will be passed to callback function.
	         */
	        function ResizeObserverSPI(callback, controller, callbackCtx) {
	            /**
	             * Collection of resize observations that have detected changes in dimensions
	             * of elements.
	             *
	             * @private {Array<ResizeObservation>}
	             */
	            this.activeObservations_ = [];
	            /**
	             * Registry of the ResizeObservation instances.
	             *
	             * @private {Map<Element, ResizeObservation>}
	             */
	            this.observations_ = new MapShim();
	            if (typeof callback !== 'function') {
	                throw new TypeError('The callback provided as parameter 1 is not a function.');
	            }
	            this.callback_ = callback;
	            this.controller_ = controller;
	            this.callbackCtx_ = callbackCtx;
	        }
	        /**
	         * Starts observing provided element.
	         *
	         * @param {Element} target - Element to be observed.
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.observe = function (target) {
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            // Do nothing if current environment doesn't have the Element interface.
	            if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	                return;
	            }
	            if (!(target instanceof getWindowOf(target).Element)) {
	                throw new TypeError('parameter 1 is not of type "Element".');
	            }
	            var observations = this.observations_;
	            // Do nothing if element is already being observed.
	            if (observations.has(target)) {
	                return;
	            }
	            observations.set(target, new ResizeObservation(target));
	            this.controller_.addObserver(this);
	            // Force the update of observations.
	            this.controller_.refresh();
	        };
	        /**
	         * Stops observing provided element.
	         *
	         * @param {Element} target - Element to stop observing.
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.unobserve = function (target) {
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            // Do nothing if current environment doesn't have the Element interface.
	            if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	                return;
	            }
	            if (!(target instanceof getWindowOf(target).Element)) {
	                throw new TypeError('parameter 1 is not of type "Element".');
	            }
	            var observations = this.observations_;
	            // Do nothing if element is not being observed.
	            if (!observations.has(target)) {
	                return;
	            }
	            observations.delete(target);
	            if (!observations.size) {
	                this.controller_.removeObserver(this);
	            }
	        };
	        /**
	         * Stops observing all elements.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.disconnect = function () {
	            this.clearActive();
	            this.observations_.clear();
	            this.controller_.removeObserver(this);
	        };
	        /**
	         * Collects observation instances the associated element of which has changed
	         * it's content rectangle.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.gatherActive = function () {
	            var _this = this;
	            this.clearActive();
	            this.observations_.forEach(function (observation) {
	                if (observation.isActive()) {
	                    _this.activeObservations_.push(observation);
	                }
	            });
	        };
	        /**
	         * Invokes initial callback function with a list of ResizeObserverEntry
	         * instances collected from active resize observations.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.broadcastActive = function () {
	            // Do nothing if observer doesn't have active observations.
	            if (!this.hasActive()) {
	                return;
	            }
	            var ctx = this.callbackCtx_;
	            // Create ResizeObserverEntry instance for every active observation.
	            var entries = this.activeObservations_.map(function (observation) {
	                return new ResizeObserverEntry(observation.target, observation.broadcastRect());
	            });
	            this.callback_.call(ctx, entries, ctx);
	            this.clearActive();
	        };
	        /**
	         * Clears the collection of active observations.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.clearActive = function () {
	            this.activeObservations_.splice(0);
	        };
	        /**
	         * Tells whether observer has active observations.
	         *
	         * @returns {boolean}
	         */
	        ResizeObserverSPI.prototype.hasActive = function () {
	            return this.activeObservations_.length > 0;
	        };
	        return ResizeObserverSPI;
	    }());
	
	    // Registry of internal observers. If WeakMap is not available use current shim
	    // for the Map collection as it has all required methods and because WeakMap
	    // can't be fully polyfilled anyway.
	    var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
	    /**
	     * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
	     * exposing only those methods and properties that are defined in the spec.
	     */
	    var ResizeObserver = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserver.
	         *
	         * @param {ResizeObserverCallback} callback - Callback that is invoked when
	         *      dimensions of the observed elements change.
	         */
	        function ResizeObserver(callback) {
	            if (!(this instanceof ResizeObserver)) {
	                throw new TypeError('Cannot call a class as a function.');
	            }
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            var controller = ResizeObserverController.getInstance();
	            var observer = new ResizeObserverSPI(callback, controller, this);
	            observers.set(this, observer);
	        }
	        return ResizeObserver;
	    }());
	    // Expose public methods of ResizeObserver.
	    [
	        'observe',
	        'unobserve',
	        'disconnect'
	    ].forEach(function (method) {
	        ResizeObserver.prototype[method] = function () {
	            var _a;
	            return (_a = observers.get(this))[method].apply(_a, arguments);
	        };
	    });
	
	    var index = (function () {
	        // Export existing implementation if available.
	        if (typeof global$1.ResizeObserver !== 'undefined') {
	            return global$1.ResizeObserver;
	        }
	        return ResizeObserver;
	    })();
	
	    return index;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 462 */
/***/ (function(module, exports) {

	'use strict';
	
	var GOOD_LEAF_SIZE = 200;
	
	// :: class<T> A rope sequence is a persistent sequence data structure
	// that supports appending, prepending, and slicing without doing a
	// full copy. It is represented as a mostly-balanced tree.
	var RopeSequence = function RopeSequence () {};
	
	RopeSequence.prototype.append = function append (other) {
	  if (!other.length) { return this }
	  other = RopeSequence.from(other);
	
	  return (!this.length && other) ||
	    (other.length < GOOD_LEAF_SIZE && this.leafAppend(other)) ||
	    (this.length < GOOD_LEAF_SIZE && other.leafPrepend(this)) ||
	    this.appendInner(other)
	};
	
	// :: (union<[T], RopeSequence<T>>) → RopeSequence<T>
	// Prepend an array or other rope to this one, returning a new rope.
	RopeSequence.prototype.prepend = function prepend (other) {
	  if (!other.length) { return this }
	  return RopeSequence.from(other).append(this)
	};
	
	RopeSequence.prototype.appendInner = function appendInner (other) {
	  return new Append(this, other)
	};
	
	// :: (?number, ?number) → RopeSequence<T>
	// Create a rope repesenting a sub-sequence of this rope.
	RopeSequence.prototype.slice = function slice (from, to) {
	    if ( from === void 0 ) from = 0;
	    if ( to === void 0 ) to = this.length;
	
	  if (from >= to) { return RopeSequence.empty }
	  return this.sliceInner(Math.max(0, from), Math.min(this.length, to))
	};
	
	// :: (number) → T
	// Retrieve the element at the given position from this rope.
	RopeSequence.prototype.get = function get (i) {
	  if (i < 0 || i >= this.length) { return undefined }
	  return this.getInner(i)
	};
	
	// :: ((element: T, index: number) → ?bool, ?number, ?number)
	// Call the given function for each element between the given
	// indices. This tends to be more efficient than looping over the
	// indices and calling `get`, because it doesn't have to descend the
	// tree for every element.
	RopeSequence.prototype.forEach = function forEach (f, from, to) {
	    if ( from === void 0 ) from = 0;
	    if ( to === void 0 ) to = this.length;
	
	  if (from <= to)
	    { this.forEachInner(f, from, to, 0); }
	  else
	    { this.forEachInvertedInner(f, from, to, 0); }
	};
	
	// :: ((element: T, index: number) → U, ?number, ?number) → [U]
	// Map the given functions over the elements of the rope, producing
	// a flat array.
	RopeSequence.prototype.map = function map (f, from, to) {
	    if ( from === void 0 ) from = 0;
	    if ( to === void 0 ) to = this.length;
	
	  var result = [];
	  this.forEach(function (elt, i) { return result.push(f(elt, i)); }, from, to);
	  return result
	};
	
	// :: (?union<[T], RopeSequence<T>>) → RopeSequence<T>
	// Create a rope representing the given array, or return the rope
	// itself if a rope was given.
	RopeSequence.from = function from (values) {
	  if (values instanceof RopeSequence) { return values }
	  return values && values.length ? new Leaf(values) : RopeSequence.empty
	};
	
	var Leaf = /*@__PURE__*/(function (RopeSequence) {
	  function Leaf(values) {
	    RopeSequence.call(this);
	    this.values = values;
	  }
	
	  if ( RopeSequence ) Leaf.__proto__ = RopeSequence;
	  Leaf.prototype = Object.create( RopeSequence && RopeSequence.prototype );
	  Leaf.prototype.constructor = Leaf;
	
	  var prototypeAccessors = { length: { configurable: true },depth: { configurable: true } };
	
	  Leaf.prototype.flatten = function flatten () {
	    return this.values
	  };
	
	  Leaf.prototype.sliceInner = function sliceInner (from, to) {
	    if (from == 0 && to == this.length) { return this }
	    return new Leaf(this.values.slice(from, to))
	  };
	
	  Leaf.prototype.getInner = function getInner (i) {
	    return this.values[i]
	  };
	
	  Leaf.prototype.forEachInner = function forEachInner (f, from, to, start) {
	    for (var i = from; i < to; i++)
	      { if (f(this.values[i], start + i) === false) { return false } }
	  };
	
	  Leaf.prototype.forEachInvertedInner = function forEachInvertedInner (f, from, to, start) {
	    for (var i = from - 1; i >= to; i--)
	      { if (f(this.values[i], start + i) === false) { return false } }
	  };
	
	  Leaf.prototype.leafAppend = function leafAppend (other) {
	    if (this.length + other.length <= GOOD_LEAF_SIZE)
	      { return new Leaf(this.values.concat(other.flatten())) }
	  };
	
	  Leaf.prototype.leafPrepend = function leafPrepend (other) {
	    if (this.length + other.length <= GOOD_LEAF_SIZE)
	      { return new Leaf(other.flatten().concat(this.values)) }
	  };
	
	  prototypeAccessors.length.get = function () { return this.values.length };
	
	  prototypeAccessors.depth.get = function () { return 0 };
	
	  Object.defineProperties( Leaf.prototype, prototypeAccessors );
	
	  return Leaf;
	}(RopeSequence));
	
	// :: RopeSequence
	// The empty rope sequence.
	RopeSequence.empty = new Leaf([]);
	
	var Append = /*@__PURE__*/(function (RopeSequence) {
	  function Append(left, right) {
	    RopeSequence.call(this);
	    this.left = left;
	    this.right = right;
	    this.length = left.length + right.length;
	    this.depth = Math.max(left.depth, right.depth) + 1;
	  }
	
	  if ( RopeSequence ) Append.__proto__ = RopeSequence;
	  Append.prototype = Object.create( RopeSequence && RopeSequence.prototype );
	  Append.prototype.constructor = Append;
	
	  Append.prototype.flatten = function flatten () {
	    return this.left.flatten().concat(this.right.flatten())
	  };
	
	  Append.prototype.getInner = function getInner (i) {
	    return i < this.left.length ? this.left.get(i) : this.right.get(i - this.left.length)
	  };
	
	  Append.prototype.forEachInner = function forEachInner (f, from, to, start) {
	    var leftLen = this.left.length;
	    if (from < leftLen &&
	        this.left.forEachInner(f, from, Math.min(to, leftLen), start) === false)
	      { return false }
	    if (to > leftLen &&
	        this.right.forEachInner(f, Math.max(from - leftLen, 0), Math.min(this.length, to) - leftLen, start + leftLen) === false)
	      { return false }
	  };
	
	  Append.prototype.forEachInvertedInner = function forEachInvertedInner (f, from, to, start) {
	    var leftLen = this.left.length;
	    if (from > leftLen &&
	        this.right.forEachInvertedInner(f, from - leftLen, Math.max(to, leftLen) - leftLen, start + leftLen) === false)
	      { return false }
	    if (to < leftLen &&
	        this.left.forEachInvertedInner(f, Math.min(from, leftLen), to, start) === false)
	      { return false }
	  };
	
	  Append.prototype.sliceInner = function sliceInner (from, to) {
	    if (from == 0 && to == this.length) { return this }
	    var leftLen = this.left.length;
	    if (to <= leftLen) { return this.left.slice(from, to) }
	    if (from >= leftLen) { return this.right.slice(from - leftLen, to - leftLen) }
	    return this.left.slice(from, leftLen).append(this.right.slice(0, to - leftLen))
	  };
	
	  Append.prototype.leafAppend = function leafAppend (other) {
	    var inner = this.right.leafAppend(other);
	    if (inner) { return new Append(this.left, inner) }
	  };
	
	  Append.prototype.leafPrepend = function leafPrepend (other) {
	    var inner = this.left.leafPrepend(other);
	    if (inner) { return new Append(inner, this.right) }
	  };
	
	  Append.prototype.appendInner = function appendInner (other) {
	    if (this.left.depth >= Math.max(this.right.depth, other.depth) + 1)
	      { return new Append(this.left, new Append(this.right, other)) }
	    return new Append(this, other)
	  };
	
	  return Append;
	}(RopeSequence));
	
	var ropeSequence = RopeSequence;
	
	module.exports = ropeSequence;


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(133)))

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	var throttle = __webpack_require__(134);
	var debounce = __webpack_require__(94);
	
	module.exports = {
		throttle: throttle,
		debounce: debounce
	};


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
	            (typeof self !== "undefined" && self) ||
	            window;
	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(scope, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(463);
	// On some exotic environments, it's not clear which object `setimmediate` was
	// able to install onto.  Search each possibility in the same order as the
	// `setimmediate` library.
	exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
	                       (typeof global !== "undefined" && global.setImmediate) ||
	                       (this && this.setImmediate);
	exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
	                         (typeof global !== "undefined" && global.clearImmediate) ||
	                         (this && this.clearImmediate);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/baselineRepair_pic01.b686b56.png";

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/baselineRepair_pic02.872c72e.png";

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/baselineRepair_pic03.8fddb7e.png";

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/baselineRepair_pic04.c3faefa.png";

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/baselineRepair_pic05.e043abd.png";

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/baselineRepair_pic06.2c4ab5a.png";

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/baselineRepair_pic07.cb5fad3.png";

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/baselineRepair_pic08.982db5b.png";

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/dataLeakInstallForMac_pic1.575a571.png";

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/dataLeakInstallForMac_pic10.c28bdd0.png";

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/dataLeakInstallForMac_pic11.7dc3d03.png";

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/dataLeakInstallForMac_pic12.5dfa464.png";

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/dataLeakInstallForMac_pic13.eff394a.png";

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/dataLeakInstallForMac_pic14.aaf66a3.png";

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/dataLeakInstallForMac_pic15.fa1e8ec.png";

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/dataLeakInstallForMac_pic2.72c70ab.png";

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/dataLeakInstallForMac_pic3.be84e0d.png";

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/dataLeakInstallForMac_pic4.bc66e82.png";

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/dataLeakInstallForMac_pic5.c1e0809.png";

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/dataLeakInstallForMac_pic6.37f1d79.png";

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/dataLeakInstallForMac_pic7.1c919b9.png";

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/dataLeakInstallForMac_pic8.95e94e5.png";

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/dataLeakInstallForMac_pic9.086e45d.png";

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/dataLeakInstallForWin_pic10.e3c4102.png";

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/dataLeakInstallForWin_pic11.d95a926.png";

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/dataLeakInstallForWin_pic12.3d591ed.png";

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/dataLeakInstallForWin_pic14.5dfa464.png";

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/dataLeakInstallForWin_pic15.aaf66a3.png";

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/dataLeakInstallForWin_pic16.fa1e8ec.png";

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/dataLeakInstallForWin_pic3.0b3ca05.png";

/***/ }),
/* 496 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/dataLeakInstallForWin_pic6.7f02100.png";

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/dataLeakInstallForWin_pic7.bf1a16b.png";

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/dataLeakInstallForWin_pic8.4f2e4c7.png";

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/dataLeakInstallForWin_pic9.6807dff.png";

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/macOS_FAQ_pic01.0968331.png";

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/macOS_FAQ_pic02.486ee27.png";

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/macOS_FAQ_pic03.d94a35e.png";

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/macOS_FAQ_pic04.c315976.png";

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/macOS_FAQ_pic05.4a1d0b8.png";

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/macOS_FAQ_pic06.2f7b951.png";

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/macOS_FAQ_pic07.074b431.jpg";

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/macOS_FAQ_pic08.f588dce.png";

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/macOS_FAQ_pic10.fb87a27.png";

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/macOS_FAQ_pic11.822d1aa.png";

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/macOS_FAQ_pic12.a6c6566.png";

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/macOS_FAQ_pic13.976a682.png";

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/macOS_FAQ_pic14.f2c4fb8.png";

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/macOS_FAQ_pic15.d593f80.png";

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/macOS_FAQ_pic16.3664787.png";

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/macOS_FAQ_pic17.f671fac.png";

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/macOS_FAQ_pic18.7945faf.png";

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/macOS_FAQ_pic19.a59c4db.png";

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/moaInstallForMac_pic01.a94bd2e.png";

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/moaInstallForMac_pic02.3f98a57.png";

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/moaInstallForMac_pic03.82b658d.png";

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/moaInstallForMac_pic04.54c8721.png";

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/moaInstallForMac_pic05.a99643e.png";

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/moaInstallForMac_pic06.84f2aa6.png";

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/moaInstallForMac_pic07.3c332a9.png";

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/moaInstallForMac_pic08.459985b.png";

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/moaInstallForMac_pic09.e07fe33.png";

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/moaInstallForMac_pic10.5a27458.png";

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/moaInstallForMac_pic11.020b7b3.png";

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/moaInstallForMac_pic12.8dcb9a2.png";

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/moaInstallForMac_pic13.486ee27.png";

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/moaInstallForMac_pic14.d94a35e.png";

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/moaInstallForMac_pic15.c315976.png";

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/moaInstallForMac_pic16.73ef0d4.png";

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/moaInstallForWin_pic01.2e219b7.png";

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/moaInstallForWin_pic02.579b258.png";

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/moaInstallForWin_pic03.4dd1ac6.png";

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/moaInstallForWin_pic04.16f4902.png";

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/moaInstallForWin_pic05.cf94ab6.png";

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/moaInstallForWin_pic06.f56fe2d.png";

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/moaInstallForWin_pic07.10a5f92.png";

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/moaInstallForWin_pic08.ed2e3c0.png";

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/moaInstallForWin_pic09.2cebec4.png";

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/moaInstallForWin_pic10.cb2c608.png";

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/moaInstallForWin_pic11.c060e67.png";

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/moaUninstall_pic01.70c3cdc.png";

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/moaUninstall_pic02.2bfebe3.png";

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/moaUninstall_pic03.c0ba923.png";

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/moaVersionView_pic01.f671fac.png";

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/moaVersionView_pic02.752f443.png";

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/moaVersionView_pic03.c29a489.png";

/***/ }),
/* 552 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/other_FAQ_pic01.77e8fa5.png";

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/other_FAQ_pic02.2a60198.png";

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/other_FAQ_pic03.def2afb.png";

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/other_FAQ_pic04.282ffbc.png";

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/other_FAQ_pic05.18b8f82.png";

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/other_FAQ_pic06.ed6f6ed.png";

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/other_FAQ_pic07.6c1f3c1.png";

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/saimenInstallForMac_pic1.bc97e28.png";

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/saimenInstallForMac_pic10.8cd84f1.png";

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/saimenInstallForMac_pic11.f4f6511.png";

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/saimenInstallForMac_pic12.fc6f1ec.png";

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/saimenInstallForMac_pic13.c3b7000.png";

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/saimenInstallForMac_pic14.7eba77d.png";

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/saimenInstallForMac_pic15.0cdbf10.png";

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/saimenInstallForMac_pic16.bdd9423.png";

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/saimenInstallForMac_pic2.5f16acd.png";

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/saimenInstallForMac_pic3.9b0f7fb.png";

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/saimenInstallForMac_pic4.892578d.png";

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/saimenInstallForMac_pic5.f00a8c2.png";

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/saimenInstallForMac_pic6.0be8a20.png";

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/saimenInstallForMac_pic7.e0353c3.png";

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/saimenInstallForMac_pic8.7eba77d.png";

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/saimenInstallForMac_pic9.173c30a.png";

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/saimenInstallForWin_pic1.1f71d52.png";

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/saimenInstallForWin_pic10.19f32f8.png";

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/saimenInstallForWin_pic11.32c61e9.png";

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/saimenInstallForWin_pic12.fc6f1ec.png";

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/saimenInstallForWin_pic13.c3b7000.png";

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/saimenInstallForWin_pic14.b05398b.png";

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/saimenInstallForWin_pic15.7eba77d.png";

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/saimenInstallForWin_pic16.0cdbf10.png";

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/saimenInstallForWin_pic17.bdd9423.png";

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/saimenInstallForWin_pic2.0bc3812.png";

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/saimenInstallForWin_pic3.3373b4a.png";

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/saimenInstallForWin_pic4.c208865.png";

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/saimenInstallForWin_pic5.ef2fcfb.png";

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/saimenInstallForWin_pic6.3680b28.png";

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/saimenInstallForWin_pic7.2097c5e.png";

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/saimenInstallForWin_pic8.3d6f0f9.png";

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/saimenInstallForWin_pic9.173c30a.png";

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/terminalIllegal_pic01.46c8d9a.png";

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/terminalIllegal_pic02.ed3313e.png";

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/terminalIllegal_pic03.e043abd.png";

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/terminalIllegal_pic04.7ac946d.png";

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/verifyMoaIsInstall_pic01.cb3d8d8.png";

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/windows_FAQ_pic01.0ffc825.png";

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/windows_FAQ_pic02.58d1a21.jpg";

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/windows_FAQ_pic03.1c9b86e.jpg";

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/windows_FAQ_pic04.6554728.jpg";

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/windows_FAQ_pic05.d4bd97a.png";

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/windows_FAQ_pic06.09a35e6.png";

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/windows_FAQ_pic07.752f443.png";

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {!function(t,e){ true?module.exports=e(__webpack_require__(20)):"function"==typeof define&&define.amd?define(["vue"],e):t.VueECharts=e(t.Vue)}(this,function(t){"use strict";function e(t,e){return e={exports:{}},t(e,e.exports),e.exports}function i(t){if(null==t||"object"!=typeof t)return t;var e=t,n=Ys.call(t);if("[object Array]"===n){e=[];for(var a=0,o=t.length;a<o;a++)e[a]=i(t[a])}else if(Xs[n]){var r=t.constructor;if(t.constructor.from)e=r.from(t);else{e=new r(t.length);for(var a=0,o=t.length;a<o;a++)e[a]=i(t[a])}}else if(!qs[n]&&!c(t)&&!u(t)){e={};for(var s in t)t.hasOwnProperty(s)&&(e[s]=i(t[s]))}return e}function n(t,e,a){if(!l(e)||!l(t))return a?i(e):t;for(var o in e)if(e.hasOwnProperty(o)){var r=t[o],d=e[o];!l(d)||!l(r)||s(d)||s(r)||u(d)||u(r)||h(d)||h(r)||c(d)||c(r)?!a&&o in t||(t[o]=i(e[o])):n(r,d,a)}return t}function a(t,e,i){for(var n in e)e.hasOwnProperty(n)&&(i?null!=e[n]:null==t[n])&&(t[n]=e[n]);return t}function o(t,e,i){if(t&&e)if(t.forEach&&t.forEach===Ks)t.forEach(e,i);else if(t.length===+t.length)for(var n=0,a=t.length;n<a;n++)e.call(i,t[n],n,t);else for(var o in t)t.hasOwnProperty(o)&&e.call(i,t[o],o,t)}function r(t,e){var i=Qs.call(arguments,2);return function(){return t.apply(e,i.concat(Qs.call(arguments)))}}function s(t){return"[object Array]"===Ys.call(t)}function l(t){var e=typeof t;return"function"===e||!!t&&"object"==e}function h(t){return!!qs[Ys.call(t)]}function u(t){return"object"==typeof t&&"number"==typeof t.nodeType&&"object"==typeof t.ownerDocument}function c(t){return t[ol]}function d(t){t&&o(t,function(t,e){this.set(e,t)},this)}function p(t){return Math.sqrt(f(t))}function f(t){return t[0]*t[0]+t[1]*t[1]}function g(t,e){return Math.sqrt((t[0]-e[0])*(t[0]-e[0])+(t[1]-e[1])*(t[1]-e[1]))}function m(t,e){return(t[0]-e[0])*(t[0]-e[0])+(t[1]-e[1])*(t[1]-e[1])}function v(){this.on("mousedown",this._dragStart,this),this.on("mousemove",this._drag,this),this.on("mouseup",this._dragEnd,this),this.on("globalout",this._dragEnd,this)}function y(t,e){return{target:t,topTarget:e&&e.topTarget}}function x(){}function _(t){return t[0]=1,t[1]=0,t[2]=0,t[3]=1,t[4]=0,t[5]=0,t}function b(t){return t>_l||t<-_l}function w(t){this._target=t.target,this._life=t.life||1e3,this._delay=t.delay||0,this._initialized=!1,this.loop=null!=t.loop&&t.loop,this.gap=t.gap||0,this.easing=t.easing||"Linear",this.onframe=t.onframe,this.ondestroy=t.ondestroy,this.onrestart=t.onrestart,this._pausedTime=0,this._paused=!1}function S(t){return(t=Math.round(t))<0?0:t>255?255:t}function M(t){return t<0?0:t>1?1:t}function I(t){return S(t.length&&"%"===t.charAt(t.length-1)?parseFloat(t)/100*255:parseInt(t,10))}function T(t){return M(t.length&&"%"===t.charAt(t.length-1)?parseFloat(t)/100:parseFloat(t))}function A(t,e,i){return i<0?i+=1:i>1&&(i-=1),6*i<1?t+(e-t)*i*6:2*i<1?e:3*i<2?t+(e-t)*(2/3-i)*6:t}function C(t,e,i){return t+(e-t)*i}function L(t,e,i,n,a){return t[0]=e,t[1]=i,t[2]=n,t[3]=a,t}function D(t,e){return t[0]=e[0],t[1]=e[1],t[2]=e[2],t[3]=e[3],t}function P(t,e){Rl&&D(Rl,e),Rl=El.put(t,Rl||e.slice())}function k(t,e){if(t){e=e||[];var i=El.get(t);if(i)return D(e,i);var n=(t+="").replace(/ /g,"").toLowerCase();if(n in zl)return D(e,zl[n]),P(t,e),e;if("#"!==n.charAt(0)){var a=n.indexOf("("),o=n.indexOf(")");if(-1!==a&&o+1===n.length){var r=n.substr(0,a),s=n.substr(a+1,o-(a+1)).split(","),l=1;switch(r){case"rgba":if(4!==s.length)return void L(e,0,0,0,1);l=T(s.pop());case"rgb":return 3!==s.length?void L(e,0,0,0,1):(L(e,I(s[0]),I(s[1]),I(s[2]),l),P(t,e),e);case"hsla":return 4!==s.length?void L(e,0,0,0,1):(s[3]=T(s[3]),O(s,e),P(t,e),e);case"hsl":return 3!==s.length?void L(e,0,0,0,1):(O(s,e),P(t,e),e);default:return}}L(e,0,0,0,1)}else{if(4===n.length){return(h=parseInt(n.substr(1),16))>=0&&h<=4095?(L(e,(3840&h)>>4|(3840&h)>>8,240&h|(240&h)>>4,15&h|(15&h)<<4,1),P(t,e),e):void L(e,0,0,0,1)}if(7===n.length){var h=parseInt(n.substr(1),16);return h>=0&&h<=16777215?(L(e,(16711680&h)>>16,(65280&h)>>8,255&h,1),P(t,e),e):void L(e,0,0,0,1)}}}}function O(t,e){var i=(parseFloat(t[0])%360+360)%360/360,n=T(t[1]),a=T(t[2]),o=a<=.5?a*(n+1):a+n-a*n,r=2*a-o;return e=e||[],L(e,S(255*A(r,o,i+1/3)),S(255*A(r,o,i)),S(255*A(r,o,i-1/3)),1),4===t.length&&(e[3]=t[3]),e}function z(t,e,i){if(e&&e.length&&t>=0&&t<=1){i=i||[];var n=t*(e.length-1),a=Math.floor(n),o=Math.ceil(n),r=e[a],s=e[o],l=n-a;return i[0]=S(C(r[0],s[0],l)),i[1]=S(C(r[1],s[1],l)),i[2]=S(C(r[2],s[2],l)),i[3]=M(C(r[3],s[3],l)),i}}function E(t,e,i){if(e&&e.length&&t>=0&&t<=1){var n=t*(e.length-1),a=Math.floor(n),o=Math.ceil(n),r=k(e[a]),s=k(e[o]),l=n-a,h=R([S(C(r[0],s[0],l)),S(C(r[1],s[1],l)),S(C(r[2],s[2],l)),M(C(r[3],s[3],l))],"rgba");return i?{color:h,leftIndex:a,rightIndex:o,value:n}:h}}function R(t,e){if(t&&t.length){var i=t[0]+","+t[1]+","+t[2];return"rgba"!==e&&"hsva"!==e&&"hsla"!==e||(i+=","+t[3]),e+"("+i+")"}}function N(t,e,i){return(e-t)*i+t}function V(t,e,i){return i>.5?e:t}function B(t,e,i,n,a){var o=t.length;if(1==a)for(s=0;s<o;s++)n[s]=N(t[s],e[s],i);else for(var r=o&&t[0].length,s=0;s<o;s++)for(var l=0;l<r;l++)n[s][l]=N(t[s][l],e[s][l],i)}function G(t,e,i){var n=t.length,a=e.length;if(n!==a){if(n>a)t.length=a;else for(r=n;r<a;r++)t.push(1===i?e[r]:Bl.call(e[r]))}for(var o=t[0]&&t[0].length,r=0;r<t.length;r++)if(1===i)isNaN(t[r])&&(t[r]=e[r]);else for(var s=0;s<o;s++)isNaN(t[r][s])&&(t[r][s]=e[r][s])}function H(t,e,i,n,a,o,r,s,l){var h=t.length;if(1==l)for(c=0;c<h;c++)s[c]=W(t[c],e[c],i[c],n[c],a,o,r);else for(var u=t[0].length,c=0;c<h;c++)for(var d=0;d<u;d++)s[c][d]=W(t[c][d],e[c][d],i[c][d],n[c][d],a,o,r)}function W(t,e,i,n,a,o,r){var s=.5*(i-t),l=.5*(n-e);return(2*(e-i)+s+l)*r+(-3*(e-i)-2*s-l)*o+s*a+e}function F(t){return t[0]=Math.floor(t[0]),t[1]=Math.floor(t[1]),t[2]=Math.floor(t[2]),"rgba("+t.join(",")+")"}function Z(t,e,i,n){i<0&&(t+=i,i=-i),n<0&&(e+=n,n=-n),this.x=t,this.y=e,this.width=i,this.height=n}function j(t,e,i,n){var a=e+1;if(a===i)return 1;if(n(t[a++],t[e])<0){for(;a<i&&n(t[a],t[a-1])<0;)a++;!function(t,e,i){i--;for(;e<i;){var n=t[e];t[e++]=t[i],t[i--]=n}}(t,e,a)}else for(;a<i&&n(t[a],t[a-1])>=0;)a++;return a-e}function U(t,e,i,n,a){for(n===e&&n++;n<i;n++){for(var o,r=t[n],s=e,l=n;s<l;)a(r,t[o=s+l>>>1])<0?l=o:s=o+1;var h=n-s;switch(h){case 3:t[s+3]=t[s+2];case 2:t[s+2]=t[s+1];case 1:t[s+1]=t[s];break;default:for(;h>0;)t[s+h]=t[s+h-1],h--}t[s]=r}}function q(t,e,i,n,a,o){var r=0,s=0,l=1;if(o(t,e[i+a])>0){for(s=n-a;l<s&&o(t,e[i+a+l])>0;)r=l,(l=1+(l<<1))<=0&&(l=s);l>s&&(l=s),r+=a,l+=a}else{for(s=a+1;l<s&&o(t,e[i+a-l])<=0;)r=l,(l=1+(l<<1))<=0&&(l=s);l>s&&(l=s);var h=r;r=a-l,l=a-h}for(r++;r<l;){var u=r+(l-r>>>1);o(t,e[i+u])>0?r=u+1:l=u}return l}function X(t,e,i,n,a,o){var r=0,s=0,l=1;if(o(t,e[i+a])<0){for(s=a+1;l<s&&o(t,e[i+a-l])<0;)r=l,(l=1+(l<<1))<=0&&(l=s);l>s&&(l=s);var h=r;r=a-l,l=a-h}else{for(s=n-a;l<s&&o(t,e[i+a+l])>=0;)r=l,(l=1+(l<<1))<=0&&(l=s);l>s&&(l=s),r+=a,l+=a}for(r++;r<l;){var u=r+(l-r>>>1);o(t,e[i+u])<0?l=u:r=u+1}return l}function Y(t,e){return t.zlevel===e.zlevel?t.z===e.z?t.z2-e.z2:t.z-e.z:t.zlevel-e.zlevel}function $(t,e,i){var n=rl.createCanvas(),a=e.getWidth(),o=e.getHeight(),r=n.style;return r.position="absolute",r.left=0,r.top=0,r.width=a+"px",r.height=o+"px",n.width=a*i,n.height=o*i,n.setAttribute("data-zr-dom-id",t),n}function K(t){return t&&t.width&&t.height}function J(t,e){var i=t+":"+(e=e||Eh);if(Ph[i])return Ph[i];for(var n=(t+"").split("\n"),a=0,o=0,r=n.length;o<r;o++)a=Math.max(ot(n[o],e).width,a);return kh>Oh&&(kh=0,Ph={}),kh++,Ph[i]=a,a}function Q(t,e,i){return"right"===i?t-=e:"center"===i&&(t-=e/2),t}function tt(t,e,i){return"middle"===i?t-=e/2:"bottom"===i&&(t-=e),t}function et(t,e,i,n,a){if(!e)return"";var o=(t+"").split("\n");a=it(e,i,n,a);for(var r=0,s=o.length;r<s;r++)o[r]=nt(o[r],a);return o.join("\n")}function it(t,e,i,n){(n=Ch({},n)).font=e;i=Lh(i,"...");n.maxIterations=Lh(n.maxIterations,2);var a=n.minChar=Lh(n.minChar,0);n.cnCharWidth=J("国",e);var o=n.ascCharWidth=J("a",e);n.placeholder=Lh(n.placeholder,"");for(var r=t=Math.max(0,t-1),s=0;s<a&&r>=o;s++)r-=o;var l=J(i);return l>r&&(i="",l=0),r=t-l,n.ellipsis=i,n.ellipsisWidth=l,n.contentWidth=r,n.containerWidth=t,n}function nt(t,e){var i=e.containerWidth,n=e.font,a=e.contentWidth;if(!i)return"";var o=J(t,n);if(o<=i)return t;for(var r=0;;r++){if(o<=a||r>=e.maxIterations){t+=e.ellipsis;break}var s=0===r?function(t,e,i,n){for(var a=0,o=0,r=t.length;o<r&&a<e;o++){var s=t.charCodeAt(o);a+=0<=s&&s<=127?i:n}return o}(t,a,e.ascCharWidth,e.cnCharWidth):o>0?Math.floor(t.length*a/o):0;o=J(t=t.substr(0,s),n)}return""===t&&(t=e.placeholder),t}function at(t){return J("国",t)}function ot(t,e){return Rh.measureText(t,e)}function rt(t,e,i,n){null!=t&&(t+="");var a=at(e),o=t?t.split("\n"):[],r=o.length*a,s=r;if(i&&(s+=i[0]+i[2]),t&&n){var l=n.outerHeight,h=n.outerWidth;if(null!=l&&s>l)t="",o=[];else if(null!=h)for(var u=it(h-(i?i[1]+i[3]:0),e,n.ellipsis,{minChar:n.minChar,placeholder:n.placeholder}),c=0,d=o.length;c<d;c++)o[c]=nt(o[c],u)}return{lines:o,height:r,outerHeight:s,lineHeight:a}}function st(t,e){var i={lines:[],width:0,height:0};if(null!=t&&(t+=""),!t)return i;for(var n,a=zh.lastIndex=0;null!=(n=zh.exec(t));){var o=n.index;o>a&&lt(i,t.substring(a,o)),lt(i,n[2],n[1]),a=zh.lastIndex}a<t.length&&lt(i,t.substring(a,t.length));var r=i.lines,s=0,l=0,h=[],u=e.textPadding,c=e.truncate,d=c&&c.outerWidth,p=c&&c.outerHeight;u&&(null!=d&&(d-=u[1]+u[3]),null!=p&&(p-=u[0]+u[2]));for(C=0;C<r.length;C++){for(var f=r[C],g=0,m=0,v=0;v<f.tokens.length;v++){var y=(L=f.tokens[v]).styleName&&e.rich[L.styleName]||{},x=L.textPadding=y.textPadding,_=L.font=y.font||e.font,b=L.textHeight=Lh(y.textHeight,at(_));if(x&&(b+=x[0]+x[2]),L.height=b,L.lineHeight=Dh(y.textLineHeight,e.textLineHeight,b),L.textAlign=y&&y.textAlign||e.textAlign,L.textVerticalAlign=y&&y.textVerticalAlign||"middle",null!=p&&s+L.lineHeight>p)return{lines:[],width:0,height:0};L.textWidth=J(L.text,_);var w=y.textWidth,S=null==w||"auto"===w;if("string"==typeof w&&"%"===w.charAt(w.length-1))L.percentWidth=w,h.push(L),w=0;else{if(S){w=L.textWidth;var M=y.textBackgroundColor,I=M&&M.image;I&&(I=Th.findExistImage(I),Th.isImageReady(I)&&(w=Math.max(w,I.width*b/I.height)))}var T=x?x[1]+x[3]:0;w+=T;var A=null!=d?d-m:null;null!=A&&A<w&&(!S||A<T?(L.text="",L.textWidth=w=0):(L.text=et(L.text,A-T,_,c.ellipsis,{minChar:c.minChar}),L.textWidth=J(L.text,_),w=L.textWidth+T))}m+=L.width=w,y&&(g=Math.max(g,L.lineHeight))}f.width=m,f.lineHeight=g,s+=g,l=Math.max(l,m)}i.outerWidth=i.width=Lh(e.textWidth,l),i.outerHeight=i.height=Lh(e.textHeight,s),u&&(i.outerWidth+=u[1]+u[3],i.outerHeight+=u[0]+u[2]);for(var C=0;C<h.length;C++){var L=h[C],D=L.percentWidth;L.width=parseInt(D,10)/100*l}return i}function lt(t,e,i){for(var n=""===e,a=e.split("\n"),o=t.lines,r=0;r<a.length;r++){var s=a[r],l={styleName:i,text:s,isLineHolder:!s&&!n};if(r)o.push({tokens:[l]});else{var h=(o[o.length-1]||(o[0]={tokens:[]})).tokens,u=h.length;1===u&&h[0].isLineHolder?h[0]=l:(s||!u||n)&&h.push(l)}}}function ht(t){if(t){t.font=Nh.makeFont(t);var e=t.textAlign;"middle"===e&&(e="center"),t.textAlign=null==e||jh[e]?e:"left";var i=t.textVerticalAlign||t.textBaseline;"center"===i&&(i="middle"),t.textVerticalAlign=null==i||Uh[i]?i:"top";t.textPadding&&(t.textPadding=Wh(t.textPadding))}}function ut(t,e,i,n,a){if(i&&e.textRotation){var o=e.textOrigin;"center"===o?(n=i.width/2+i.x,a=i.height/2+i.y):o&&(n=o[0]+i.x,a=o[1]+i.y),t.translate(n,a),t.rotate(-e.textRotation),t.translate(-n,-a)}}function ct(t,e,i,n,a,o,r,s){var l=n.rich[i.styleName]||{},h=i.textVerticalAlign,u=o+a/2;"top"===h?u=o+i.height/2:"bottom"===h&&(u=o+a-i.height/2),!i.isLineHolder&&dt(l)&&pt(t,e,l,"right"===s?r-i.width:"center"===s?r-i.width/2:r,u-i.height/2,i.width,i.height);var c=i.textPadding;c&&(r=xt(r,s,c),u-=i.height/2-c[2]-i.textHeight/2),gt(e,"shadowBlur",Gh(l.textShadowBlur,n.textShadowBlur,0)),gt(e,"shadowColor",l.textShadowColor||n.textShadowColor||"transparent"),gt(e,"shadowOffsetX",Gh(l.textShadowOffsetX,n.textShadowOffsetX,0)),gt(e,"shadowOffsetY",Gh(l.textShadowOffsetY,n.textShadowOffsetY,0)),gt(e,"textAlign",s),gt(e,"textBaseline","middle"),gt(e,"font",i.font||Nh.DEFAULT_FONT);var d=mt(l.textStroke||n.textStroke,f),p=vt(l.textFill||n.textFill),f=Bh(l.textStrokeWidth,n.textStrokeWidth);d&&(gt(e,"lineWidth",f),gt(e,"strokeStyle",d),e.strokeText(i.text,r,u)),p&&(gt(e,"fillStyle",p),e.fillText(i.text,r,u))}function dt(t){return t.textBackgroundColor||t.textBorderWidth&&t.textBorderColor}function pt(t,e,i,n,a,o,r){var s=i.textBackgroundColor,l=i.textBorderWidth,h=i.textBorderColor,u=Fh(s);if(gt(e,"shadowBlur",i.textBoxShadowBlur||0),gt(e,"shadowColor",i.textBoxShadowColor||"transparent"),gt(e,"shadowOffsetX",i.textBoxShadowOffsetX||0),gt(e,"shadowOffsetY",i.textBoxShadowOffsetY||0),u||l&&h){e.beginPath();var c=i.textBorderRadius;c?Vh.buildPath(e,{x:n,y:a,width:o,height:r,r:c}):e.rect(n,a,o,r),e.closePath()}if(u)gt(e,"fillStyle",s),e.fill();else if(Zh(s)){var d=s.image;(d=Th.createOrUpdateImage(d,null,t,function(t,e){e.image=t},s))&&Th.isImageReady(d)&&e.drawImage(d,n,a,o,r)}l&&h&&(gt(e,"lineWidth",l),gt(e,"strokeStyle",h),e.stroke())}function ft(t,e,i){var n=e.x||0,a=e.y||0,o=e.textAlign,r=e.textVerticalAlign;if(i){var s=e.textPosition;if(s instanceof Array)n=i.x+yt(s[0],i.width),a=i.y+yt(s[1],i.height);else{var l=Nh.adjustTextPositionOnRect(s,i,e.textDistance);n=l.x,a=l.y,o=o||l.textAlign,r=r||l.textVerticalAlign}var h=e.textOffset;h&&(n+=h[0],a+=h[1])}return{baseX:n,baseY:a,textAlign:o,textVerticalAlign:r}}function gt(t,e,i){return t[e]=i,t[e]}function mt(t,e){return null==t||e<=0||"transparent"===t||"none"===t?null:t.image||t.colorStops?"#000":t}function vt(t){return null==t||"none"===t?null:t.image||t.colorStops?"#000":t}function yt(t,e){return"string"==typeof t?t.lastIndexOf("%")>=0?parseFloat(t)/100*e:parseFloat(t):t}function xt(t,e,i){return"right"===e?t-i[1]:"center"===e?t+i[3]/2-i[1]/2:t+i[3]}function _t(t){t=t||{},eh.call(this,t);for(var e in t)t.hasOwnProperty(e)&&"style"!==e&&(this[e]=t[e]);this.style=new yh(t.style,this),this._rect=null,this.__clipPaths=[]}function bt(t){Kh.call(this,t)}function wt(t){return parseInt(t,10)}function St(t,e,i,n){return i=i||{},n||!Us.canvasSupported?Mt(t,e,i):Us.browser.firefox&&null!=e.layerX&&e.layerX!==e.offsetX?(i.zrX=e.layerX,i.zrY=e.layerY):null!=e.offsetX?(i.zrX=e.offsetX,i.zrY=e.offsetY):Mt(t,e,i),i}function Mt(t,e,i){var n=function(t){return t.getBoundingClientRect?t.getBoundingClientRect():{left:0,top:0}}(t);i.zrX=e.clientX-n.left,i.zrY=e.clientY-n.top}function It(t){var e=t[1][0]-t[0][0],i=t[1][1]-t[0][1];return Math.sqrt(e*e+i*i)}function Tt(t){return"mousewheel"===t&&Us.browser.firefox?"DOMMouseScroll":t}function At(t,e,i){var n=t._gestureMgr;"start"===i&&n.clear();var a=n.recognize(e,t.handler.findHover(e.zrX,e.zrY,null).target,t.dom);if("end"===i&&n.clear(),a){var o=a.type;e.gestureEvent=o,t.handler.dispatchToElement({target:a.target},o,a.event)}}function Ct(t){t._touching=!0,clearTimeout(t._touchTimer),t._touchTimer=setTimeout(function(){t._touching=!1},700)}function Lt(t){var e=t.pointerType;return"pen"===e||"touch"===e}function Dt(t){function e(e,i){rl.each(e,function(e){fu(t,Tt(e),i._handlers[e])},i)}dl.call(this),this.dom=t,this._touching=!1,this._touchTimer,this._gestureMgr=new pu,this._handlers={},function(t){rl.each(yu,function(e){t._handlers[e]=rl.bind(bu[e],t)}),rl.each(_u,function(e){t._handlers[e]=rl.bind(bu[e],t)}),rl.each(vu,function(e){t._handlers[e]=function(t,e){return function(){if(!e._touching)return t.apply(e,arguments)}}(bu[e],t)})}(this),Us.pointerEventsSupported?e(_u,this):(Us.touchEventsSupported&&e(yu,this),e(vu,this))}function Pt(t){return Math.floor(Math.log(t)/Math.LN10)}function kt(t){return String(t).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#39;")}function Ot(t){var e={main:"",sub:""};return t&&(t=t.split(Ru),e.main=t[0]||"",e.sub=t[1]||""),e}function zt(t){return t>-Yu&&t<Yu}function Et(t){return t>Yu||t<-Yu}function Rt(t,e,i,n,a){var o=1-a;return o*o*(o*t+3*a*e)+a*a*(a*n+3*o*i)}function Nt(t,e,i,n){var a=1-n;return a*(a*t+2*n*e)+n*n*i}function Vt(t,e,i,n,a){for(var o=0,r=0,s=0,l=0,h=0,u=0;u<t.length;){var c=t[u++];switch(c===Gc.M&&u>1&&(i||(o+=Vc(r,s,l,h,n,a))),1==u&&(l=r=t[u],h=s=t[u+1]),c){case Gc.M:r=l=t[u++],s=h=t[u++];break;case Gc.L:if(i){if(Lc.containStroke(r,s,t[u],t[u+1],e,n,a))return!0}else o+=Vc(r,s,t[u],t[u+1],n,a)||0;r=t[u++],s=t[u++];break;case Gc.C:if(i){if(Dc.containStroke(r,s,t[u++],t[u++],t[u++],t[u++],t[u],t[u+1],e,n,a))return!0}else o+=function(t,e,i,n,a,o,r,s,l,h){if(h>e&&h>n&&h>o&&h>s||h<e&&h<n&&h<o&&h<s)return 0;var u=ic.cubicRootAt(e,n,o,s,h,Fc);if(0===u)return 0;for(var c,d,p=0,f=-1,g=0;g<u;g++){var m=Fc[g],v=0===m||1===m?.5:1;ic.cubicAt(t,i,a,r,m)<l||(f<0&&(f=ic.cubicExtrema(e,n,o,s,Zc),Zc[1]<Zc[0]&&f>1&&function(){var t=Zc[0];Zc[0]=Zc[1],Zc[1]=t}(),c=ic.cubicAt(e,n,o,s,Zc[0]),f>1&&(d=ic.cubicAt(e,n,o,s,Zc[1]))),2==f?m<Zc[0]?p+=c<e?v:-v:m<Zc[1]?p+=d<c?v:-v:p+=s<d?v:-v:m<Zc[0]?p+=c<e?v:-v:p+=s<c?v:-v)}return p}(r,s,t[u++],t[u++],t[u++],t[u++],t[u],t[u+1],n,a)||0;r=t[u++],s=t[u++];break;case Gc.Q:if(i){if(kc.containStroke(r,s,t[u++],t[u++],t[u],t[u+1],e,n,a))return!0}else o+=function(t,e,i,n,a,o,r,s){if(s>e&&s>n&&s>o||s<e&&s<n&&s<o)return 0;var l=ic.quadraticRootAt(e,n,o,s,Fc);if(0===l)return 0;var h=ic.quadraticExtremum(e,n,o);if(h>=0&&h<=1){for(var u=0,c=ic.quadraticAt(e,n,o,h),d=0;d<l;d++)p=0===Fc[d]||1===Fc[d]?.5:1,(f=ic.quadraticAt(t,i,a,Fc[d]))<r||(Fc[d]<h?u+=c<e?p:-p:u+=o<c?p:-p);return u}var p=0===Fc[0]||1===Fc[0]?.5:1,f=ic.quadraticAt(t,i,a,Fc[0]);return f<r?0:o<e?p:-p}(r,s,t[u++],t[u++],t[u],t[u+1],n,a)||0;r=t[u++],s=t[u++];break;case Gc.A:var d=t[u++],p=t[u++],f=t[u++],g=t[u++],m=t[u++],v=t[u++],y=(t[u++],1-t[u++]),x=Math.cos(m)*f+d,_=Math.sin(m)*g+p;u>1?o+=Vc(r,s,x,_,n,a):(l=x,h=_);var b=(n-d)*g/f+d;if(i){if(Nc.containStroke(d,p,g,m,m+v,y,e,b,a))return!0}else o+=function(t,e,i,n,a,o,r,s){if((s-=e)>i||s<-i)return 0;h=Math.sqrt(i*i-s*s),Fc[0]=-h,Fc[1]=h;var l=Math.abs(n-a);if(l<1e-4)return 0;if(l%Hc<1e-4)return n=0,a=Hc,f=o?1:-1,r>=Fc[0]+t&&r<=Fc[1]+t?f:0;if(o){var h=n;n=Bc(a),a=Bc(h)}else n=Bc(n),a=Bc(a);n>a&&(a+=Hc);for(var u=0,c=0;c<2;c++){var d=Fc[c];if(d+t>r){var p=Math.atan2(s,d),f=o?1:-1;p<0&&(p=Hc+p),(p>=n&&p<=a||p+Hc>=n&&p+Hc<=a)&&(p>Math.PI/2&&p<1.5*Math.PI&&(f=-f),u+=f)}}return u}(d,p,g,m,m+v,y,b,a);r=Math.cos(m+v)*f+d,s=Math.sin(m+v)*g+p;break;case Gc.R:l=r=t[u++],h=s=t[u++];var x=l+t[u++],_=h+t[u++];if(i){if(Lc.containStroke(l,h,x,h,e,n,a)||Lc.containStroke(x,h,x,_,e,n,a)||Lc.containStroke(x,_,l,_,e,n,a)||Lc.containStroke(l,_,l,h,e,n,a))return!0}else o+=Vc(x,h,x,_,n,a),o+=Vc(l,_,l,h,n,a);break;case Gc.Z:if(i){if(Lc.containStroke(r,s,l,h,e,n,a))return!0}else o+=Vc(r,s,l,h,n,a);r=l,s=h}}return i||function(t,e){return Math.abs(t-e)<Wc}(s,h)||(o+=Vc(r,s,l,h,n,a)||0),0!==o}function Bt(t){Kh.call(this,t),this.path=null}function Gt(t,e,i,n,a,o,r,s,l,h,u){var c=l*(rd/180),d=od(c)*(t-i)/2+ad(c)*(e-n)/2,p=-1*ad(c)*(t-i)/2+od(c)*(e-n)/2,f=d*d/(r*r)+p*p/(s*s);f>1&&(r*=nd(f),s*=nd(f));var g=(a===o?-1:1)*nd((r*r*(s*s)-r*r*(p*p)-s*s*(d*d))/(r*r*(p*p)+s*s*(d*d)))||0,m=g*r*p/s,v=g*-s*d/r,y=(t+i)/2+od(c)*m-ad(c)*v,x=(e+n)/2+ad(c)*m+od(c)*v,_=hd([1,0],[(d-m)/r,(p-v)/s]),b=[(d-m)/r,(p-v)/s],w=[(-1*d-m)/r,(-1*p-v)/s],S=hd(b,w);ld(b,w)<=-1&&(S=rd),ld(b,w)>=1&&(S=0),0===o&&S>0&&(S-=2*rd),1===o&&S<0&&(S+=2*rd),u.addData(h,y,x,r,s,_,S,c,o)}function Ht(t,e){var i=function(t){if(!t)return[];var e,i=t.replace(/-/g," -").replace(/  /g," ").replace(/ /g,",").replace(/,,/g,",");for(e=0;e<id.length;e++)i=i.replace(new RegExp(id[e],"g"),"|"+id[e]);var n,a=i.split("|"),o=0,r=0,s=new Cc,l=Cc.CMD;for(e=1;e<a.length;e++){var h,u=a[e],c=u.charAt(0),d=0,p=u.slice(1).replace(/e,-/g,"e-").split(",");p.length>0&&""===p[0]&&p.shift();for(var f=0;f<p.length;f++)p[f]=parseFloat(p[f]);for(;d<p.length&&!isNaN(p[d])&&!isNaN(p[0]);){var g,m,v,y,x,_,b,w=o,S=r;switch(c){case"l":o+=p[d++],r+=p[d++],h=l.L,s.addData(h,o,r);break;case"L":o=p[d++],r=p[d++],h=l.L,s.addData(h,o,r);break;case"m":o+=p[d++],r+=p[d++],h=l.M,s.addData(h,o,r),c="l";break;case"M":o=p[d++],r=p[d++],h=l.M,s.addData(h,o,r),c="L";break;case"h":o+=p[d++],h=l.L,s.addData(h,o,r);break;case"H":o=p[d++],h=l.L,s.addData(h,o,r);break;case"v":r+=p[d++],h=l.L,s.addData(h,o,r);break;case"V":r=p[d++],h=l.L,s.addData(h,o,r);break;case"C":h=l.C,s.addData(h,p[d++],p[d++],p[d++],p[d++],p[d++],p[d++]),o=p[d-2],r=p[d-1];break;case"c":h=l.C,s.addData(h,p[d++]+o,p[d++]+r,p[d++]+o,p[d++]+r,p[d++]+o,p[d++]+r),o+=p[d-2],r+=p[d-1];break;case"S":g=o,m=r;var M=s.len(),I=s.data;n===l.C&&(g+=o-I[M-4],m+=r-I[M-3]),h=l.C,w=p[d++],S=p[d++],o=p[d++],r=p[d++],s.addData(h,g,m,w,S,o,r);break;case"s":g=o,m=r;var M=s.len(),I=s.data;n===l.C&&(g+=o-I[M-4],m+=r-I[M-3]),h=l.C,w=o+p[d++],S=r+p[d++],o+=p[d++],r+=p[d++],s.addData(h,g,m,w,S,o,r);break;case"Q":w=p[d++],S=p[d++],o=p[d++],r=p[d++],h=l.Q,s.addData(h,w,S,o,r);break;case"q":w=p[d++]+o,S=p[d++]+r,o+=p[d++],r+=p[d++],h=l.Q,s.addData(h,w,S,o,r);break;case"T":g=o,m=r;var M=s.len(),I=s.data;n===l.Q&&(g+=o-I[M-4],m+=r-I[M-3]),o=p[d++],r=p[d++],h=l.Q,s.addData(h,g,m,o,r);break;case"t":g=o,m=r;var M=s.len(),I=s.data;n===l.Q&&(g+=o-I[M-4],m+=r-I[M-3]),o+=p[d++],r+=p[d++],h=l.Q,s.addData(h,g,m,o,r);break;case"A":v=p[d++],y=p[d++],x=p[d++],_=p[d++],b=p[d++],Gt(w=o,S=r,o=p[d++],r=p[d++],_,b,v,y,x,h=l.A,s);break;case"a":v=p[d++],y=p[d++],x=p[d++],_=p[d++],b=p[d++],Gt(w=o,S=r,o+=p[d++],r+=p[d++],_,b,v,y,x,h=l.A,s)}}"z"!==c&&"Z"!==c||(h=l.Z,s.addData(h)),n=h}return s.toStatic(),s}(t);return e=e||{},e.buildPath=function(t){if(t.setData){t.setData(i.data);(e=t.getContext())&&t.rebuildPath(e)}else{var e=t;i.rebuildPath(e)}},e.applyTransform=function(t){ed(i,t),this.dirty(!0)},e}function Wt(t,e,i,n,a,o,r){var s=.5*(i-t),l=.5*(n-e);return(2*(e-i)+s+l)*r+(-3*(e-i)-2*s-l)*o+s*a+e}function Ft(t,e,i){var n=t.cpx2,a=t.cpy2;return null===n||null===a?[(i?Vd:Rd)(t.x1,t.cpx1,t.cpx2,t.x2,e),(i?Vd:Rd)(t.y1,t.cpy1,t.cpy2,t.y2,e)]:[(i?Nd:Ed)(t.x1,t.cpx1,t.x2,e),(i?Nd:Ed)(t.y1,t.cpy1,t.y2,e)]}function Zt(t,e,i,n){var a=ud.createFromString(t,e),o=a.getBoundingRect();return i&&("center"===n&&(i=jt(i,o)),Ut(a,i)),a}function jt(t,e){var i,n=e.width/e.height,a=t.height*n;i=a<=t.width?t.height:(a=t.width)/n;return{x:t.x+t.width/2-a/2,y:t.y+t.height/2-i/2,width:a,height:i}}function Ut(t,e){if(t.applyTransform){var i=t.getBoundingRect().calculateTransform(e);t.applyTransform(i)}}function qt(t,e,i){var n=up(2*t);return(n+up(e))%2==0?n/2:(n+(i?1:-1))/2}function Xt(t){return null!=t&&"none"!=t}function Yt(t){return"string"==typeof t?Nl.lift(t,-.1):t}function $t(t){if(t.__hoverStlDirty){var e=t.style.stroke,i=t.style.fill,n=t.__hoverStl;n.fill=n.fill||(Xt(i)?Yt(i):null),n.stroke=n.stroke||(Xt(e)?Yt(e):null);var a={};for(var o in n)null!=n[o]&&(a[o]=t.style[o]);t.__normalStl=a,t.__hoverStlDirty=!1}}function Kt(t){if(!t.__isHover){if($t(t),t.useHoverLayer)t.__zr&&t.__zr.addHover(t,t.__hoverStl);else{var e=t.style,i=e.insideRollbackOpt;i&&function(t){var e=t.insideRollback;e&&(t.textFill=e.textFill,t.textStroke=e.textStroke,t.textStrokeWidth=e.textStrokeWidth)}(e),e.extendFrom(t.__hoverStl),i&&(re(e,e.insideOriginalTextPosition,i),null==e.textFill&&(e.textFill=i.autoColor)),t.dirty(!1),t.z2+=1}t.__isHover=!0}}function Jt(t){if(t.__isHover){var e=t.__normalStl;t.useHoverLayer?t.__zr&&t.__zr.removeHover(t):(e&&t.setStyle(e),t.z2-=1),t.__isHover=!1}}function Qt(t){"group"===t.type?t.traverse(function(t){"group"!==t.type&&Kt(t)}):Kt(t)}function te(t){"group"===t.type?t.traverse(function(t){"group"!==t.type&&Jt(t)}):Jt(t)}function ee(t,e){t.__hoverStl=t.hoverStyle||e||{},t.__hoverStlDirty=!0,t.__isHover&&$t(t)}function ie(t,e,i,n,a){return ne(t,e,n,a),i&&rl.extend(t,i),t.host&&t.host.dirty&&t.host.dirty(!1),t}function ne(t,e,i,n){if((i=i||pp).isRectText){var a=e.getShallow("position")||(n?null:"inside");"outside"===a&&(a="top"),t.textPosition=a,t.textOffset=e.getShallow("offset");var o=e.getShallow("rotate");null!=o&&(o*=Math.PI/180),t.textRotation=o,t.textDistance=rl.retrieve2(e.getShallow("distance"),n?null:5)}var r,s=e.ecModel,l=s&&s.option.textStyle,h=function(t){var e;for(;t&&t!==t.ecModel;){var i=(t.option||pp).rich;if(i){e=e||{};for(var n in i)i.hasOwnProperty(n)&&(e[n]=1)}t=t.parentModel}return e}(e);if(h){r={};for(var u in h)if(h.hasOwnProperty(u)){var c=e.getModel(["rich",u]);ae(r[u]={},c,l,i,n)}}return t.rich=r,ae(t,e,l,i,n,!0),i.forceRich&&!i.textStyle&&(i.textStyle={}),t}function ae(t,e,i,n,a,o){if(i=!a&&i||pp,t.textFill=oe(e.getShallow("color"),n)||i.color,t.textStroke=oe(e.getShallow("textBorderColor"),n)||i.textBorderColor,t.textStrokeWidth=rl.retrieve2(e.getShallow("textBorderWidth"),i.textBorderWidth),!a){if(o){var r=t.textPosition;t.insideRollback=re(t,r,n),t.insideOriginalTextPosition=r,t.insideRollbackOpt=n}null==t.textFill&&(t.textFill=n.autoColor)}t.fontStyle=e.getShallow("fontStyle")||i.fontStyle,t.fontWeight=e.getShallow("fontWeight")||i.fontWeight,t.fontSize=e.getShallow("fontSize")||i.fontSize,t.fontFamily=e.getShallow("fontFamily")||i.fontFamily,t.textAlign=e.getShallow("align"),t.textVerticalAlign=e.getShallow("verticalAlign")||e.getShallow("baseline"),t.textLineHeight=e.getShallow("lineHeight"),t.textWidth=e.getShallow("width"),t.textHeight=e.getShallow("height"),t.textTag=e.getShallow("tag"),o&&n.disableBox||(t.textBackgroundColor=oe(e.getShallow("backgroundColor"),n),t.textPadding=e.getShallow("padding"),t.textBorderColor=oe(e.getShallow("borderColor"),n),t.textBorderWidth=e.getShallow("borderWidth"),t.textBorderRadius=e.getShallow("borderRadius"),t.textBoxShadowColor=e.getShallow("shadowColor"),t.textBoxShadowBlur=e.getShallow("shadowBlur"),t.textBoxShadowOffsetX=e.getShallow("shadowOffsetX"),t.textBoxShadowOffsetY=e.getShallow("shadowOffsetY")),t.textShadowColor=e.getShallow("textShadowColor")||i.textShadowColor,t.textShadowBlur=e.getShallow("textShadowBlur")||i.textShadowBlur,t.textShadowOffsetX=e.getShallow("textShadowOffsetX")||i.textShadowOffsetX,t.textShadowOffsetY=e.getShallow("textShadowOffsetY")||i.textShadowOffsetY}function oe(t,e){return"auto"!==t?t:e&&e.autoColor?e.autoColor:null}function re(t,e,i){var n,a=i.useInsideStyle;return null==t.textFill&&!1!==a&&(!0===a||i.isRectText&&e&&"string"==typeof e&&e.indexOf("inside")>=0)&&(n={textFill:null,textStroke:t.textStroke,textStrokeWidth:t.textStrokeWidth},t.textFill="#fff",null==t.textStroke&&(t.textStroke=i.autoColor,null==t.textStrokeWidth&&(t.textStrokeWidth=2))),n}function se(t,e,i,n,a,o){"function"==typeof a&&(o=a,a=null);if(n&&n.isAnimationEnabled()){var r=t?"Update":"",s=n.getShallow("animationDuration"+r),l=n.getShallow("animationEasing"+r),h=n.getShallow("animationDelay"+r);"function"==typeof h&&(h=h(a,n.getAnimationDelayParams?n.getAnimationDelayParams(e,a):null)),"function"==typeof s&&(s=s(a)),s>0?e.animateTo(i,s,h||0,l,o,!!o):(e.stopAnimation(),e.attr(i),o&&o())}else e.stopAnimation(),e.attr(i),o&&o()}function le(t,e,i,n,a){se(!0,t,e,i,n,a)}function he(t,e,i){return e&&!rl.isArrayLike(e)&&(e=Ml.getLocalTransform(e)),i&&(e=yl.invert([],e)),ll.applyTransform([],t,e)}function ue(t,e,i){this.parentModel=e,this.ecModel=i,this.option=t}function ce(t,e,i){for(var n=0;n<e.length&&(!e[n]||null!=(t=t&&"object"==typeof t?t[e[n]]:null));n++);return null==t&&i&&(t=i.get(e)),t}function de(t,e){var i=Bu.get(t,"getParent");return i?i.call(t,e):t.parentModel}function pe(t){return t instanceof Array?t:null==t?[]:[t]}function fe(t){return wp(t)&&t.id&&0===(t.id+"").indexOf("\0_ec_\0")}function ge(t,e){return t&&t.hasOwnProperty(e)}function me(t,e,i,n,a){var o=0,r=0;null==n&&(n=1/0),null==a&&(a=1/0);var s=0;e.eachChild(function(l,h){var u,c,d=l.position,p=l.getBoundingRect(),f=e.childAt(h+1),g=f&&f.getBoundingRect();if("horizontal"===t){var m=p.width+(g?-g.x+p.x:0);(u=o+m)>n||l.newline?(o=0,u=m,r+=s+i,s=p.height):s=Math.max(s,p.height)}else{var v=p.height+(g?-g.y+p.y:0);(c=r+v)>a||l.newline?(o+=s+i,r=0,c=v,s=p.width):s=Math.max(s,p.width)}l.newline||(d[0]=o,d[1]=r,"horizontal"===t?o=u+i:r=c+i)})}function ve(t,e,i){i=Eu.normalizeCssArray(i||0);var n=e.width,a=e.height,o=Dp(t.left,n),r=Dp(t.top,a),s=Dp(t.right,n),l=Dp(t.bottom,a),h=Dp(t.width,n),u=Dp(t.height,a),c=i[2]+i[0],d=i[1]+i[3],p=t.aspect;switch(isNaN(h)&&(h=n-s-d-o),isNaN(u)&&(u=a-l-c-r),null!=p&&(isNaN(h)&&isNaN(u)&&(p>n/a?h=.8*n:u=.8*a),isNaN(h)&&(h=p*u),isNaN(u)&&(u=h/p)),isNaN(o)&&(o=n-s-h-d),isNaN(r)&&(r=a-l-u-c),t.left||t.right){case"center":o=n/2-h/2-i[3];break;case"right":o=n-h-d}switch(t.top||t.bottom){case"middle":case"center":r=a/2-u/2-i[0];break;case"bottom":r=a-u-c}o=o||0,r=r||0,isNaN(h)&&(h=n-d-o-(s||0)),isNaN(u)&&(u=a-c-r-(l||0));var f=new oh(o+i[3],r+i[0],h,u);return f.margin=i,f}function ye(t,e){return e&&t&&Pp(kp,function(i){e.hasOwnProperty(i)&&(t[i]=e[i])}),t}function xe(t){return Yp(t,function(t){return t.componentIndex})||[]}function _e(t,e){return e.hasOwnProperty("subType")?Xp(t,function(t){return t.subType===e.subType}):t}function be(t){}function we(){this._coordinateSystems=[]}function Se(t){this._api=t,this._timelineOptions=[],this._mediaList=[],this._mediaDefault,this._currentMediaIndices=[],this._optionBackup,this._newBaseOption}function Me(t){var e=t&&t.itemStyle;if(e)for(var i=0,n=gf.length;i<n;i++){var a=gf[i],o=e.normal,r=e.emphasis;o&&o[a]&&(t[a]=t[a]||{},t[a].normal?rl.merge(t[a].normal,o[a]):t[a].normal=o[a],o[a]=null),r&&r[a]&&(t[a]=t[a]||{},t[a].emphasis?rl.merge(t[a].emphasis,r[a]):t[a].emphasis=r[a],r[a]=null)}}function Ie(t,e){var i=ff(t)&&t[e],n=ff(i)&&i.textStyle;if(n)for(var a=0,o=Ip.TEXT_STYLE_OPTIONS.length;a<o;a++){e=Ip.TEXT_STYLE_OPTIONS[a];n.hasOwnProperty(e)&&(i[e]=n[e])}}function Te(t){ff(t)&&(Ie(t,"normal"),Ie(t,"emphasis"))}function Ae(t){return rl.isArray(t)?t:t?[t]:[]}function Ce(t){return(rl.isArray(t)?t[0]:t)||{}}function Le(t){vf(bf,function(e){e[0]in t&&!(e[1]in t)&&(t[e[1]]=t[e[0]])})}function De(){this.group=new sh,this.uid=Lp.getUID("viewChart")}function Pe(t,e){if(t&&(t.trigger(e),"group"===t.type))for(var i=0;i<t.childCount();i++)Pe(t.childAt(i),e)}function ke(t,e,i){var n=Ip.queryDataIndex(t,e);null!=n?rl.each(Ip.normalizeToArray(n),function(e){Pe(t.getItemGraphicEl(e),i)}):t.eachItemGraphicEl(function(t){Pe(t,i)})}function Oe(t,e,i){function n(){u=(new Date).getTime(),c=null,t.apply(r,s||[])}var a,o,r,s,l,h=0,u=0,c=null;e=e||0;var d=function(){a=(new Date).getTime(),r=this,s=arguments;var t=l||e,d=l||i;l=null,o=a-(d?h:u)-t,clearTimeout(c),d?c=setTimeout(n,t):o>=0?n():c=setTimeout(n,-o),h=a};return d.clear=function(){c&&(clearTimeout(c),c=null)},d.debounceNextCall=function(t){l=t},d}function ze(t){return t}function Ee(t,e,i,n,a){this._old=t,this._new=e,this._oldKeyGetter=i||ze,this._newKeyGetter=n||ze,this.context=a}function Re(t,e,i,n,a){for(var o=0;o<t.length;o++){var r="_ec_"+a[n](t[o],o),s=e[r];null==s?(i.push(r),e[r]=o):(s.length||(e[r]=s=[s]),s.push(o))}}function Ne(t,e){rl.each(Kf.concat(e.__wrappedMethods||[]),function(i){e.hasOwnProperty(i)&&(t[i]=e[i])}),t.__wrappedMethods=e.__wrappedMethods}function Ve(t){this._array=t||[]}function Be(t){return rl.isArray(t)||(t=[t]),t}function Ge(t,e){var i=t.dimensions,n=new Jf(rl.map(i,t.getDimensionInfo,t),t.hostModel);Ne(n,t);for(var a=n._storage={},o=t._storage,r=0;r<i.length;r++){var s=i[r],l=o[s];rl.indexOf(e,s)>=0?a[s]=new l.constructor(o[s].length):a[s]=o[s]}return n}function He(t,e,i){function n(t,e,i){og[e]?t.otherDims[e]=i:(t.coordDim=e,t.coordDimIndex=i,l.set(e,!0))}function a(t,e,i){if(i||null!=e.get(t)){for(var n=0;null!=e.get(t+n);)n++;t+=n}return e.set(t,!0),t}e=e||[],i=i||{},t=(t||[]).slice();var o=(i.dimsDef||[]).slice(),r=rl.createHashMap(i.encodeDef),s=rl.createHashMap(),l=rl.createHashMap(),h=[],u=i.dimCount;if(null==u){var c=We(e[0]);u=Math.max(rl.isArray(c)&&c.length||1,t.length,o.length),ig(t,function(t){var e=t.dimsDef;e&&(u=Math.max(u,e.length))})}for(var d=0;d<u;d++){var p=ng(o[d])?{name:o[d]}:o[d]||{},f=p.name,g=h[d]={otherDims:{}};null!=f&&null==s.get(f)&&(g.name=g.tooltipName=f,s.set(f,d)),null!=p.type&&(g.type=p.type)}r.each(function(t,e){t=r.set(e,eg(t).slice()),ig(t,function(i,a){ng(i)&&(i=s.get(i)),null!=i&&i<u&&(t[a]=i,n(h[i],e,a))})});var m=0;ig(t,function(t,e){var i,a,o;ng(t)?(i=t,t={}):(i=t.name,t=rl.clone(t),a=t.dimsDef,o=t.otherDims,t.name=t.coordDim=t.coordDimIndex=t.dimsDef=t.otherDims=null);var s=eg(r.get(i));if(!s.length)for(var l=0;l<(a&&a.length||1);l++){for(;m<h.length&&null!=h[m].coordDim;)m++;m<h.length&&s.push(m++)}ig(s,function(e,r){var s=h[e];n(ag(s,t),i,r),null==s.name&&a&&(s.name=s.tooltipName=a[r]),o&&ag(s.otherDims,o)})});for(var v=i.extraPrefix||"value",y=0;y<u;y++){null==(g=h[y]=h[y]||{}).coordDim&&(g.coordDim=a(v,l,i.extraFromZero),g.coordDimIndex=0,g.isExtraCoord=!0),null==g.name&&(g.name=a(g.coordDim,s)),null==g.type&&rg(e,y)&&(g.type="ordinal")}return h}function We(t){return rl.isArray(t)?t:rl.isObject(t)?t.value:t}function Fe(t){return"category"!==t&&"time"!==t}function Ze(t){return"category"===t?"ordinal":"time"===t?"time":"float"}function je(t){this._setting=t||{},this._extent=[1/0,-1/0],this._interval=0,this.init&&this.init.apply(this,arguments)}function Ue(t){return Pu.getPrecisionSafe(t)+2}function qe(t,e,i){t[e]=Math.max(Math.min(t[e],i[1]),i[0])}function Xe(t,e){!isFinite(t[0])&&(t[0]=e[0]),!isFinite(t[1])&&(t[1]=e[1]),qe(t,0,e),qe(t,1,e),t[0]>t[1]&&(t[0]=t[1])}function Ye(t,e){return Dg(t,Lg(e))}function $e(t,e){var i,n,a,o=t.type,r=e.getMin(),s=e.getMax(),l=null!=r,h=null!=s,u=t.getExtent();return"ordinal"===o?i=(e.get("data")||[]).length:(n=e.get("boundaryGap"),rl.isArray(n)||(n=[n||0,n||0]),"boolean"==typeof n[0]&&(n=[0,0]),n[0]=Pu.parsePercent(n[0],1),n[1]=Pu.parsePercent(n[1],1),a=u[1]-u[0]||Math.abs(u[0])),null==r&&(r="ordinal"===o?i?0:NaN:u[0]-n[0]*a),null==s&&(s="ordinal"===o?i?i-1:NaN:u[1]+n[1]*a),"dataMin"===r?r=u[0]:"function"==typeof r&&(r=r({min:u[0],max:u[1]})),"dataMax"===s?s=u[1]:"function"==typeof s&&(s=s({min:u[0],max:u[1]})),(null==r||!isFinite(r))&&(r=NaN),(null==s||!isFinite(s))&&(s=NaN),t.setBlank(rl.eqNaN(r)||rl.eqNaN(s)),e.getNeedCrossZero()&&(r>0&&s>0&&!l&&(r=0),r<0&&s<0&&!h&&(s=0)),[r,s]}function Ke(t,e){return"category"===t.type?t.scale.getLabel(e):e}function Je(t,e){var i=(t[1]-t[0])/e/2;t[0]+=i,t[1]-=i}function Qe(t,e){return Math.abs(t-e)<Jg}function ti(t,e,i){if(this.name=t,this.geometries=e,i)i=[i[0],i[1]];else{var n=this.getBoundingRect();i=[n.x+n.width/2,n.y+n.height/2]}this.center=i}function ei(t,e,i){for(var n=[],a=e[0],o=e[1],r=0;r<t.length;r+=2){var s=t.charCodeAt(r)-64,l=t.charCodeAt(r+1)-64;s=s>>1^-(1&s),l=l>>1^-(1&l),a=s+=a,o=l+=o,n.push([s/i,l/i])}return n}function ii(t){return[t[0]/2,t[1]/2]}function ni(t,e,i){fp.Group.call(this),this.updateData(t,e,i)}function ai(t){this.group=new fp.Group,this._symbolCtor=t||Lm}function oi(t,e,i){var n=t.getItemLayout(e);return n&&!isNaN(n[0])&&!isNaN(n[1])&&!(i&&i(e))&&"none"!==t.getItemVisual(e,"symbol")}function ri(t){return t>=0?1:-1}function si(t,e,i){for(var n,a=t.getBaseAxis(),o=t.getOtherAxis(a),r=a.onZero?0:o.scale.getExtent()[0],s=o.dim,l="x"===s||"radius"===s?1:0,h=e.stackedOn,u=e.get(s,i);h&&ri(h.get(s,i))===ri(u);){n=h;break}var c=[];return c[l]=e.get(a.dim,i),c[1-l]=n?n.get(s,i,!0):r,t.dataToPoint(c)}function li(t){return isNaN(t[0])||isNaN(t[1])}function hi(t,e,i,n,a,o,r,s,l,h,u){for(var c=0,d=i,p=0;p<n;p++){var f=e[d];if(d>=a||d<0)break;if(li(f)){if(u){d+=o;continue}break}if(d===i)t[o>0?"moveTo":"lineTo"](f[0],f[1]),Rm(Vm,f);else if(l>0){var g=d+o,m=e[g];if(u)for(;m&&li(e[g]);)m=e[g+=o];var v=.5,y=e[c];if(!(m=e[g])||li(m))Rm(Bm,f);else{li(m)&&!u&&(m=f),ll.sub(Nm,m,y);var x,_;if("x"===h||"y"===h){var b="x"===h?0:1;x=Math.abs(f[b]-y[b]),_=Math.abs(f[b]-m[b])}else x=ll.dist(f,y),_=ll.dist(f,m);Em(Bm,f,Nm,-l*(1-(v=_/(_+x))))}Om(Vm,Vm,s),zm(Vm,Vm,r),Om(Bm,Bm,s),zm(Bm,Bm,r),t.bezierCurveTo(Vm[0],Vm[1],Bm[0],Bm[1],f[0],f[1]),Em(Vm,f,Nm,l*v)}else t.lineTo(f[0],f[1]);c=d,d+=o}return p}function ui(t,e){var i=[1/0,1/0],n=[-1/0,-1/0];if(e)for(var a=0;a<t.length;a++){var o=t[a];o[0]<i[0]&&(i[0]=o[0]),o[1]<i[1]&&(i[1]=o[1]),o[0]>n[0]&&(n[0]=o[0]),o[1]>n[1]&&(n[1]=o[1])}return{min:e?i:n,max:e?n:i}}function ci(t,e){if(t.length===e.length){for(var i=0;i<t.length;i++){var n=t[i],a=e[i];if(n[0]!==a[0]||n[1]!==a[1])return}return!0}}function di(t){return"number"==typeof t?t:t?.3:0}function pi(t){var e=t.getGlobalExtent();if(t.onBand){var i=t.getBandWidth()/2-1,n=e[1]>e[0]?1:-1;e[0]+=n*i,e[1]-=n*i}return e}function fi(t){return t>=0?1:-1}function gi(t,e,i){return"polar"===t.type?function(t,e,i){var n=t.getAngleAxis(),a=t.getRadiusAxis().getExtent(),o=n.getExtent(),r=Math.PI/180,s=new fp.Sector({shape:{cx:t.cx,cy:t.cy,r0:a[0],r:a[1],startAngle:-o[0]*r,endAngle:-o[1]*r,clockwise:n.inverse}});return e&&(s.shape.endAngle=-o[0]*r,fp.initProps(s,{shape:{endAngle:-o[1]*r}},i)),s}(t,e,i):function(t,e,i){var n=pi(t.getAxis("x")),a=pi(t.getAxis("y")),o=t.getBaseAxis().isHorizontal(),r=Math.min(n[0],n[1]),s=Math.min(a[0],a[1]),l=Math.max(n[0],n[1])-r,h=Math.max(a[0],a[1])-s,u=i.get("lineStyle.normal.width")||2,c=i.get("clipOverflow")?u/2:Math.max(l,h);o?(s-=c,h+=2*c):(r-=c,l+=2*c);var d=new fp.Rect({shape:{x:r,y:s,width:l,height:h}});return e&&(d.shape[o?"width":"height"]=0,fp.initProps(d,{shape:{width:l,height:h}},i)),d}(t,e,i)}function mi(t,e,i){for(var n=e.getBaseAxis(),a="x"===n.dim||"radius"===n.dim?0:1,o=[],r=0;r<t.length-1;r++){var s=t[r+1],l=t[r];o.push(l);var h=[];switch(i){case"end":h[a]=s[a],h[1-a]=l[1-a],o.push(h);break;case"middle":var u=(l[a]+s[a])/2,c=[];h[a]=c[a]=u,h[1-a]=l[1-a],c[1-a]=s[1-a],o.push(h),o.push(c);break;default:h[a]=l[a],h[1-a]=s[1-a],o.push(h)}}return t[r]&&o.push(t[r]),o}function vi(t){Ym.call(this,t)}function yi(t,e){return e.type||(e.data?"category":"value")}function xi(t,e,i){return t.getCoordSysModel()===e}function _i(t,e,i){this._coordsMap={},this._coordsList=[],this._axesMap={},this._axesList=[],this._initCartesian(t,e,i),this.model=t}function bi(t,e,i){var n=t[e];if(i.onZero){var a=i.onZeroAxisIndex;if(null==a){for(var o in n)if(n.hasOwnProperty(o)){r=n[o];if(r&&!wi(r)){a=+o;break}}null==a&&(i.onZero=!1),i.onZeroAxisIndex=a}else{var r;(r=n[a])&&wi(r)&&(i.onZero=!1)}}}function wi(t){return"category"===t.type||"time"===t.type||!uv(t)}function Si(t,e){return rl.map(pv,function(e){return t.getReferringComponents(e)[0]})}function Mi(t){return"cartesian2d"===t.get("coordinateSystem")}function Ii(t){var e={componentType:t.mainType};return e[t.mainType+"Index"]=t.componentIndex,e}function Ti(t){var e=t.get("tooltip");return t.get("silent")||!(t.get("triggerEvent")||e&&e.show)}function Ai(t){t&&(t.ignore=!0)}function Ci(t,e,i){var n=t&&t.getBoundingRect().clone(),a=e&&e.getBoundingRect().clone();if(n&&a){var o=yl.identity([]);return yl.rotate(o,o,-t.rotation),n.applyTransform(yl.mul([],o,t.getLocalTransform())),a.applyTransform(yl.mul([],o,e.getLocalTransform())),n.intersect(a)}}function Li(t){return"middle"===t||"center"===t}function Di(t,e){return"all"===t||rl.isArray(t)&&rl.indexOf(t,e)>=0||t===e}function Pi(t){var e=(t.ecModel.getComponent("axisPointer")||{}).coordSysAxesInfo;return e&&e.axesInfo[Oi(t)]}function ki(t){return!!t.get("handle.show")}function Oi(t){return t.type+"||"+t.id}function zi(t,e,i,n,a,o){var r=kv.getAxisPointerClass(t.axisPointerClass);if(r){var s=Pv.getAxisPointerModel(e);s?(t._axisPointer||(t._axisPointer=new r)).render(e,s,n,o):Ei(t,n)}}function Ei(t,e,i){var n=t._axisPointer;n&&n.dispose(e,i),t._axisPointer=null}function Ri(t){return t.get("stack")||Wv+t.seriesIndex}function Ni(t){return t.dim+t.index}function Vi(t,e){var i={};rl.each(t,function(t,e){var n=t.axisKey,a=t.bandWidth,o=i[n]||{bandWidth:a,remainedWidth:a,autoWidthCount:0,categoryGap:"20%",gap:"30%",stacks:{}},r=o.stacks;i[n]=o;var s=t.stackId;r[s]||o.autoWidthCount++,r[s]=r[s]||{width:0,maxWidth:0};var l=t.barWidth;l&&!r[s].width&&(r[s].width=l,l=Math.min(o.remainedWidth,l),o.remainedWidth-=l);var h=t.barMaxWidth;h&&(r[s].maxWidth=h);var u=t.barGap;null!=u&&(o.gap=u);var c=t.barCategoryGap;null!=c&&(o.categoryGap=c)});var n={};return rl.each(i,function(t,e){n[e]={};var i=t.stacks,a=t.bandWidth,o=Hv(t.categoryGap,a),r=Hv(t.gap,1),s=t.remainedWidth,l=t.autoWidthCount,h=(s-o)/(l+(l-1)*r);h=Math.max(h,0),rl.each(i,function(t,e){var i=t.maxWidth;i&&i<h&&(i=Math.min(i,s),t.width&&(i=Math.min(i,t.width)),s-=i,t.width=i,l--)}),h=(s-o)/(l+(l-1)*r),h=Math.max(h,0);var u,c=0;rl.each(i,function(t,e){t.width||(t.width=h),u=t,c+=t.width*(1+r)}),u&&(c-=u.width*r);var d=-c/2;rl.each(i,function(t,i){n[e][i]=n[e][i]||{offset:d,width:t.width},d+=t.width*(1+r)})}),n}function Bi(t,e,i){var n=function(t,e){return Vi(rl.map(t,function(t){var e=t.getData(),i=t.coordinateSystem.getBaseAxis(),n=i.getExtent(),a="category"===i.type?i.getBandWidth():Math.abs(n[1]-n[0])/e.count();return{bandWidth:a,barWidth:Hv(t.get("barWidth"),a),barMaxWidth:Hv(t.get("barMaxWidth"),a),barGap:t.get("barGap"),barCategoryGap:t.get("barCategoryGap"),axisKey:Ni(i),stackId:Ri(t)}}))}(rl.filter(e.getSeriesByType(t),function(t){return!e.isSeriesFiltered(t)&&t.coordinateSystem&&"cartesian2d"===t.coordinateSystem.type})),a={},o={};e.eachSeriesByType(t,function(t){if("cartesian2d"===t.coordinateSystem.type){var e=t.getData(),i=t.coordinateSystem,r=i.getBaseAxis(),s=Ri(t),l=n[Ni(r)][s],h=l.offset,u=l.width,c=i.getOtherAxis(r),d=t.get("barMinHeight")||0,p=r.onZero?c.toGlobalCoord(c.dataToCoord(0)):c.getGlobalExtent()[0],f=[t.coordDimToDataDim("x")[0],t.coordDimToDataDim("y")[0]],g=e.mapArray(f,function(t,e){return i.dataToPoint([t,e])},!0);a[s]=a[s]||[],o[s]=o[s]||[],e.setLayout({offset:h,size:u}),e.each(t.coordDimToDataDim(c.dim)[0],function(t,i){if(!isNaN(t)){a[s][i]||(a[s][i]={p:p,n:p},o[s][i]={p:p,n:p});var n,r,l,f,m=t>=0?"p":"n",v=g[i],y=a[s][i][m],x=o[s][i][m];c.isHorizontal()?(n=y,r=v[1]+h,l=v[0]-x,f=u,o[s][i][m]+=l,Math.abs(l)<d&&(l=(l<0?-1:1)*d),a[s][i][m]+=l):(n=v[0]+h,r=y,l=u,f=v[1]-x,o[s][i][m]+=f,Math.abs(f)<d&&(f=(f<=0?-1:1)*d),a[s][i][m]+=f),e.setItemLayout(i,{x:n,y:r,width:l,height:f})}},!0)}},this)}function Gi(t,e){"outside"===t.textPosition&&(t.textPosition=e)}function Hi(t,e,i){i.style.text=null,fp.updateProps(i,{shape:{width:0}},e,t,function(){i.parent&&i.parent.remove(i)})}function Wi(t,e,i){i.style.text=null,fp.updateProps(i,{shape:{r:i.shape.r0}},e,t,function(){i.parent&&i.parent.remove(i)})}function Fi(t,e,i,n,a,o,r,s){var l=e.getItemVisual(i,"color"),h=e.getItemVisual(i,"opacity"),u=n.getModel("itemStyle.normal"),c=n.getModel("itemStyle.emphasis").getBarItemStyle();s||t.setShape("r",u.get("barBorderRadius")||0),t.useStyle(rl.defaults({fill:l,opacity:h},u.getBarItemStyle()));var d=n.getShallow("cursor");d&&t.attr("cursor",d);var p=r?a.height>0?"bottom":"top":a.width>0?"left":"right";s||Xv(t.style,c,n,l,o,i,p),fp.setHoverStyle(t,c)}function Zi(t,e,i,n,a){var o=(e.startAngle+e.endAngle)/2,r=Math.cos(o),s=Math.sin(o),l=i?n:0,h=[r*l,s*l];a?t.animate().when(200,{position:h}).start("bounceOut"):t.attr("position",h)}function ji(t,e){function i(){o.ignore=o.hoverIgnore,r.ignore=r.hoverIgnore}function n(){o.ignore=o.normalIgnore,r.ignore=r.normalIgnore}fp.Group.call(this);var a=new fp.Sector({z2:2}),o=new fp.Polyline,r=new fp.Text;this.add(a),this.add(o),this.add(r),this.updateData(t,e,!0),this.on("emphasis",i).on("normal",n).on("mouseover",i).on("mouseout",n)}function Ui(t,e,i,n,a,o,r){function s(e,i){for(var n=e;n>=0&&(t[n].y-=i,!(n>0&&t[n].y>t[n-1].y+t[n-1].height));n--);}function l(t,e,i,n,a,o){for(var r=e?Number.MAX_VALUE:0,s=0,l=t.length;s<l;s++)if("center"!==t[s].position){var h=Math.abs(t[s].y-n),u=t[s].len,c=t[s].len2,d=h<a+u?Math.sqrt((a+u+c)*(a+u+c)-h*h):Math.abs(t[s].x-i);e&&d>=r&&(d=r-10),!e&&d<=r&&(d=r+10),t[s].x=i+d*o,r=d}}t.sort(function(t,e){return t.y-e.y});for(var h,u=0,c=t.length,d=[],p=[],f=0;f<c;f++)(h=t[f].y-u)<0&&function(e,i,n,a){for(var o=e;o<i;o++)if(t[o].y+=n,o>e&&o+1<i&&t[o+1].y>t[o].y+t[o].height)return void s(o,n/2);s(i-1,n/2)}(f,c,-h),u=t[f].y+t[f].height;r-u<0&&s(c-1,u-r);for(f=0;f<c;f++)t[f].y>=i?p.push(t[f]):d.push(t[f]);l(d,!1,e,i,n,a),l(p,!0,e,i,n,a)}function qi(){this.group=new fp.Group,this._symbolEl=new dy({})}function Xi(t,e,i){Kg.call(this,t,e,i),this.type="value",this.angle=0,this.name="",this.model}function Yi(t,e,i){this._model=t,this.dimensions=[],this._indicatorAxes=rl.map(t.getIndicatorModels(),function(t,e){var i="indicator_"+e,n=new gy(i,new bg);return n.name=t.get("name"),n.model=t,t.axis=n,this.dimensions.push(i),n},this),this.resize(t,i),this.cx,this.cy,this.r,this.startAngle}function $i(t,e){return rl.defaults({show:e},t)}function Ki(){Ml.call(this)}function Ji(t){this.name=t,this.zoomLimit,Ml.call(this),this._roamTransform=new Ki,this._viewTransform=new Ki,this._center,this._zoom}function Qi(t,e,i,n){var a=i.seriesModel,o=a?a.coordinateSystem:null;return o===this?o[t](n):null}function tn(t,e,i,n,a){Iy.call(this,t),this.map=e,this._nameCoordMap=rl.createHashMap(),this.loadGeoJson(i,n,a)}function en(t,e,i,n){var a=i.geoModel,o=i.seriesModel,r=a?a.coordinateSystem:o?o.coordinateSystem||(o.getReferringComponents("geo")[0]||{}).coordinateSystem:null;return r===this?r[t](n):null}function nn(t,e){var i=t.get("boundingCoords");if(null!=i){var n=i[0],a=i[1];isNaN(n[0])||isNaN(n[1])||isNaN(a[0])||isNaN(a[1])||this.setBoundingRect(n[0],n[1],a[0]-n[0],a[1]-n[1])}var o,r=this.getBoundingRect(),s=t.get("layoutCenter"),l=t.get("layoutSize"),h=e.getWidth(),u=e.getHeight(),c=t.get("aspectScale")||.75,d=r.width/r.height*c,p=!1;s&&l&&(s=[Pu.parsePercent(s[0],h),Pu.parsePercent(s[1],u)],l=Pu.parsePercent(l,Math.min(h,u)),isNaN(s[0])||isNaN(s[1])||isNaN(l)||(p=!0));if(p){var f={};d>1?(f.width=l,f.height=l/d):(f.height=l,f.width=l*d),f.y=s[1]-f.height/2,f.x=s[0]-f.width/2}else(o=t.getBoxLayoutParams()).aspect=d,f=Np.getLayoutRect(o,{width:h,height:u});this.setViewRect(f.x,f.y,f.width,f.height),this.setCenter(t.get("center")),this.setZoom(t.get("zoom"))}function an(t,e){rl.each(e.get("geoCoord"),function(e,i){t.addGeoCoord(i,e)})}function on(t){return t[Gy]||(t[Gy]={})}function rn(t){this.pointerChecker,this._zr=t,this._opt={};var e=rl.bind,i=e(function(t){if(su.notLeftMouse(t)||t.target&&t.target.draggable)return;var e=t.offsetX,i=t.offsetY;this.pointerChecker&&this.pointerChecker(t,e,i)&&(this._x=e,this._y=i,this._dragging=!0)},this),n=e(function(t){if(su.notLeftMouse(t)||!ln(this,"moveOnMouseMove",t)||!this._dragging||"pinch"===t.gestureEvent||Hy.isTaken(this._zr,"globalPan"))return;var e=t.offsetX,i=t.offsetY,n=this._x,a=this._y,o=e-n,r=i-a;this._x=e,this._y=i,this._opt.preventDefaultMouseMove&&su.stop(t.event),this.trigger("pan",o,r,n,a,e,i)},this),a=e(function(t){su.notLeftMouse(t)||(this._dragging=!1)},this),o=e(function(t){if(!ln(this,"zoomOnMouseWheel",t)||0===t.wheelDelta)return;var e=t.wheelDelta>0?1.1:1/1.1;sn.call(this,t,e,t.offsetX,t.offsetY)},this),r=e(function(t){if(Hy.isTaken(this._zr,"globalPan"))return;var e=t.pinchScale>1?1.1:1/1.1;sn.call(this,t,e,t.pinchX,t.pinchY)},this);dl.call(this),this.setPointerChecker=function(t){this.pointerChecker=t},this.enable=function(e,s){this.disable(),this._opt=rl.defaults(rl.clone(s)||{},{zoomOnMouseWheel:!0,moveOnMouseMove:!0,preventDefaultMouseMove:!0}),null==e&&(e=!0),!0!==e&&"move"!==e&&"pan"!==e||(t.on("mousedown",i),t.on("mousemove",n),t.on("mouseup",a)),!0!==e&&"scale"!==e&&"zoom"!==e||(t.on("mousewheel",o),t.on("pinch",r))},this.disable=function(){t.off("mousedown",i),t.off("mousemove",n),t.off("mouseup",a),t.off("mousewheel",o),t.off("pinch",r)},this.dispose=this.disable,this.isDragging=function(){return this._dragging},this.isPinching=function(){return this._pinching}}function sn(t,e,i,n){this.pointerChecker&&this.pointerChecker(t,i,n)&&(su.stop(t.event),this.trigger("zoom",e,i,n))}function ln(t,e,i){var n=t._opt[e];return n&&(!rl.isString(n)||i.event[n+"Key"])}function hn(t,e){var i=t.getItemStyle(),n=t.get("areaColor");return null!=n&&(i.fill=n),i}function un(t,e){e.eachChild(function(e){rl.each(e.__regions,function(i){e.trigger(t.isSelected(i.name)?"emphasis":"normal")})})}function cn(t,e){var i=new fp.Group;this._controller=new Wy(t.getZr()),this._controllerHost={target:e?i:null},this.group=i,this._updateGroup=e,this._mouseDownFlag}function dn(t,e,i){t[ex]={},tx(e,function(e,n){pn(e,n,t,i)})}function pn(t,e,i,n){i[ex][e]=t,t[ix]=i,t.dataType=e,n.struct&&(t[n.structAttr]=n.struct,n.struct[n.datasAttr[e]]=t),t.getLinkedData=function(t){var e=this[ix];return null==t||null==e?e:e[ex][t]}}function fn(t,e,i){this.root,this.data,this._nodes=[],this.hostModel=t,this.levelModels=rl.map(e||[],function(e){return new _p(e,t,t.ecModel)}),this.leavesModel=new _p(i||{},t,t.ecModel)}function gn(t){var e=t.children;return e.length&&t.isExpand?e[e.length-1]:t.hierNode.thread}function mn(t){var e=t.children;return e.length&&t.isExpand?e[0]:t.hierNode.thread}function vn(t,e){var i=t.getItemLayout(e);return i&&!isNaN(i.x)&&!isNaN(i.y)&&"none"!==t.getItemVisual(e,"symbol")}function yn(t,e,i){return i.itemModel=e,i.itemStyle=e.getModel("itemStyle.normal").getItemStyle(),i.hoverItemStyle=e.getModel("itemStyle.emphasis").getItemStyle(),i.lineStyle=e.getModel("lineStyle.normal").getLineStyle(),i.labelModel=e.getModel("label.normal"),i.hoverLabelModel=e.getModel("label.emphasis"),!1===t.isExpand&&0!==t.children.length?i.symbolInnerColor=i.itemStyle.fill:i.symbolInnerColor="#fff",i}function xn(t,e,i,n,a,o){var r=!i,s=t.tree.getNodeByDataIndex(e),o=yn(s,s.getModel(),o),l=t.tree.root,h=s.parentNode===l?s:s.parentNode||s,u=t.getItemGraphicEl(h.dataIndex),c=h.getLayout(),d=u?{x:u.position[0],y:u.position[1],rawX:u.__radialOldRawX,rawY:u.__radialOldRawY}:c,p=s.getLayout();r?(i=new Lm(t,e,o)).attr("position",[d.x,d.y]):i.updateData(t,e,o),i.__radialOldRawX=i.__radialRawX,i.__radialOldRawY=i.__radialRawY,i.__radialRawX=p.rawX,i.__radialRawY=p.rawY,n.add(i),t.setItemGraphicEl(e,i),fp.updateProps(i,{position:[p.x,p.y]},a);var f=i.getSymbolPath();if("radial"===o.layout){var g,m,v=l.children[0],y=v.getLayout(),x=v.children.length;if(p.x===y.x&&!0===s.isExpand){var _={};_.x=(v.children[0].getLayout().x+v.children[x-1].getLayout().x)/2,_.y=(v.children[0].getLayout().y+v.children[x-1].getLayout().y)/2,(g=Math.atan2(_.y-y.y,_.x-y.x))<0&&(g=2*Math.PI+g),(m=_.x<y.x)&&(g-=Math.PI)}else(g=Math.atan2(p.y-y.y,p.x-y.x))<0&&(g=2*Math.PI+g),0===s.children.length||0!==s.children.length&&!1===s.isExpand?(m=p.x<y.x)&&(g-=Math.PI):(m=p.x>y.x)||(g-=Math.PI);var b=m?"left":"right";f.setStyle({textPosition:b,textRotation:-g,textOrigin:"center",verticalAlign:"middle"})}if(s.parentNode&&s.parentNode!==l){var w=i.__edge;w||(w=i.__edge=new fp.BezierCurve({shape:bn(o,d,d),style:rl.defaults({opacity:0},o.lineStyle)})),fp.updateProps(w,{shape:bn(o,c,p),style:{opacity:1}},a),n.add(w)}}function _n(t,e,i,n,a,o){for(var r,s=t.tree.getNodeByDataIndex(e),l=t.tree.root,o=yn(s,s.getModel(),o),h=s.parentNode===l?s:s.parentNode||s;null==(r=h.getLayout());)h=h.parentNode===l?h:h.parentNode||h;fp.updateProps(i,{position:[r.x+1,r.y+1]},a,function(){n.remove(i),t.setItemGraphicEl(e,null)}),i.fadeOut(null,{keepLabel:!0});var u=i.__edge;u&&fp.updateProps(u,{shape:bn(o,r,r),style:{opacity:0}},a,function(){n.remove(u)})}function bn(t,e,i){var n,a,o,r,s=t.orient;if("radial"===t.layout){var l=e.rawX,h=e.rawY,u=i.rawX,c=i.rawY,d=lx(l,h),p=lx(l,h+(c-h)*t.curvature),f=lx(u,c+(h-c)*t.curvature),g=lx(u,c);return{x1:d.x,y1:d.y,x2:g.x,y2:g.y,cpx1:p.x,cpy1:p.y,cpx2:f.x,cpy2:f.y}}var l=e.x,h=e.y,u=i.x,c=i.y;return"horizontal"===s&&(n=l+(u-l)*t.curvature,a=h,o=u+(l-u)*t.curvature,r=c),"vertical"===s&&(n=l,a=h+(c-h)*t.curvature,o=u,r=c+(h-c)*t.curvature),{x1:l,y1:h,x2:u,y2:c,cpx1:n,cpy1:a,cpx2:o,cpy2:r}}function wn(t){for(var e=[];t;)(t=t.parentNode)&&e.push(t);return e.reverse()}function Sn(t){var e=0;rl.each(t.children,function(t){Sn(t);var i=t.value;rl.isArray(i)&&(i=i[0]),e+=i});var i=t.value;rl.isArray(i)&&(i=i[0]),(null==i||isNaN(i))&&(i=e),i<0&&(i=0),rl.isArray(t.value)?t.value[0]=i:t.value=i}function Mn(t){this.group=new fp.Group,t.add(this.group)}function In(t,e){var i=t.visual,n=[];rl.isObject(i)?jx(i,function(t){n.push(t)}):null!=i&&n.push(i);e||1!==n.length||{color:1,symbol:1}.hasOwnProperty(t.type)||(n[1]=n[0]),On(t,n)}function Tn(t){return{applyVisual:function(e,i,n){e=this.mapValueToVisual(e),n("color",t(i("color"),e))},_doMap:Pn([0,1])}}function An(t){var e=this.option.visual;return e[Math.round(Zx(t,[0,1],[0,e.length-1],!0))]||{}}function Cn(t){return function(e,i,n){n(t,this.mapValueToVisual(e))}}function Ln(t){var e=this.option.visual;return e[this.option.loop&&t!==qx?t%e.length:t]}function Dn(){return this.option.visual[0]}function Pn(t){return{linear:function(e){return Zx(e,t,this.option.visual,!0)},category:Ln,piecewise:function(e,i){var n=kn.call(this,i);return null==n&&(n=Zx(e,t,this.option.visual,!0)),n},fixed:Dn}}function kn(t){var e=this.option,i=e.pieceList;if(e.hasSpecialVisual){var n=i[Xx.findPieceIndex(t,i)];if(n&&n.visual)return n.visual[this.type]}}function On(t,e){return t.visual=e,"color"===t.type&&(t.parsedVisual=rl.map(e,function(t){return Nl.parse(t)})),e}function zn(t,e,i){return t?e<=i:e<i}function En(t,e,i,n,a,o){var r=t.getModel(),s=t.getLayout();if(s&&!s.invisible&&s.isInView){var l,h=t.getModel(Qx),u=function(t,e,i,n){var a=rl.extend({},e);return rl.each(["color","colorAlpha","colorSaturation"],function(o){var r=t.get(o,!0);null==r&&i&&(r=i[o]),null==r&&(r=e[o]),null==r&&(r=n.get(o)),null!=r&&(a[o]=r)}),a}(h,e,i[t.depth],n),c=h.get("borderColor"),d=h.get("borderColorSaturation");null!=d&&(c=function(t,e){return null!=e?Nl.modifyHSL(e,null,null,t):null}(d,l=Rn(u))),t.setVisual("borderColor",c);var p=t.viewChildren;if(p&&p.length){var f=function(t,e,i,n,a,o){if(!o||!o.length)return;var r=Vn(e,"color")||null!=a.color&&"none"!==a.color&&(Vn(e,"colorAlpha")||Vn(e,"colorSaturation"));if(!r)return;var s=e.get("visualMin"),l=e.get("visualMax"),h=i.dataExtent.slice();null!=s&&s<h[0]&&(h[0]=s),null!=l&&l>h[1]&&(h[1]=l);var u=e.get("colorMappingBy"),c={type:r.name,dataExtent:h,visual:r.range};"color"!==c.type||"index"!==u&&"id"!==u?c.mappingMethod="linear":(c.mappingMethod="category",c.loop=!0);var d=new Kx(c);return d.__drColorMappingBy=u,d}(0,r,s,0,u,p);rl.each(p,function(t,e){if(t.depth>=a.length||t===a[t.depth]){En(t,function(t,e,i,n,a,o){var r=rl.extend({},e);if(a){var s=a.type,l="color"===s&&a.__drColorMappingBy,h="index"===l?n:"id"===l?o.mapIdToIndex(i.getId()):i.getValue(t.get("visualDimension"));r[s]=a.mapValueToVisual(h)}return r}(r,u,t,e,f,o),i,n,a,o)}})}else l=Rn(u),t.setVisual("color",l)}}function Rn(t){var e=Nn(t,"color");if(e){var i=Nn(t,"colorAlpha"),n=Nn(t,"colorSaturation");return n&&(e=Nl.modifyHSL(e,null,null,n)),i&&(e=Nl.modifyAlpha(e,i)),e}}function Nn(t,e){var i=t[e];if(null!=i&&"none"!==i)return i}function Vn(t,e){var i=t.get(e);return Jx(i)&&i.length?{name:e,range:i}:null}function Bn(t,e,i,n){var a,o;if(!t.isRemoved()){var r=t.getLayout();a=r.width,o=r.height;var s=(p=t.getModel()).get(s_),l=p.get(l_)/2,h=Wn(p),u=Math.max(s,h),c=s-l,d=u-l,p=t.getModel();t.setLayout({borderWidth:s,upperHeight:u,upperLabelHeight:h},!0);var f=(a=n_(a-2*c,0))*(o=n_(o-c-d,0)),g=function(t,e,i,n,a,o){var r=t.children||[],s=n.sort;"asc"!==s&&"desc"!==s&&(s=null);var l=null!=n.leafDepth&&n.leafDepth<=o;if(a&&!l)return t.viewChildren=[];!function(t,e){e&&t.sort(function(t,i){var n="asc"===e?t.getValue()-i.getValue():i.getValue()-t.getValue();return 0===n?"asc"===e?t.dataIndex-i.dataIndex:i.dataIndex-t.dataIndex:n})}(r=rl.filter(r,function(t){return!t.isRemoved()}),s);var h=function(t,e,i){for(var n=0,a=0,o=e.length;a<o;a++)n+=e[a].getValue();var r=t.get("visualDimension");if(e&&e.length)if("value"===r&&i)s=[e[e.length-1].getValue(),e[0].getValue()],"asc"===i&&s.reverse();else{var s=[1/0,-1/0];r_(e,function(t){var e=t.getValue(r);e<s[0]&&(s[0]=e),e>s[1]&&(s[1]=e)})}else s=[NaN,NaN];return{sum:n,dataExtent:s}}(e,r,s);if(0===h.sum)return t.viewChildren=[];if(h.sum=function(t,e,i,n,a){if(!n)return i;for(var o=t.get("visibleMin"),r=a.length,s=r,l=r-1;l>=0;l--){var h=a["asc"===n?r-l-1:l].getValue();h/i*e<o&&(s=l,i-=h)}return"asc"===n?a.splice(0,r-s):a.splice(s,r-s),i}(e,i,h.sum,s,r),0===h.sum)return t.viewChildren=[];for(var u=0,c=r.length;u<c;u++){var d=r[u].getValue()/h.sum*i;r[u].setLayout({area:d})}l&&(r.length&&t.setLayout({isLeafRoot:!0},!0),r.length=0);return t.viewChildren=r,t.setLayout({dataExtent:h.dataExtent},!0),r}(t,p,f,e,i,n);if(g.length){var m={x:c,y:d,width:a,height:o},v=a_(a,o),y=1/0,x=[];x.area=0;for(var _=0,b=g.length;_<b;){var w=g[_];x.push(w),x.area+=w.getLayout().area;var S=function(t,e,i){for(var n,a=0,o=1/0,r=0,s=t.length;r<s;r++)(n=t[r].getLayout().area)&&(n<o&&(o=n),n>a&&(a=n));var l=t.area*t.area,h=e*e*i;return l?n_(h*a/l,l/(h*o)):1/0}(x,v,e.squareRatio);S<=y?(_++,y=S):(x.area-=x.pop().getLayout().area,Gn(x,v,m,l,!1),v=a_(m.width,m.height),x.length=x.area=0,y=1/0)}if(x.length&&Gn(x,v,m,l,!0),!i){var M=p.get("childrenVisibleMin");null!=M&&f<M&&(i=!0)}for(var _=0,b=g.length;_<b;_++)Bn(g[_],e,i,n+1)}}}function Gn(t,e,i,n,a){var o=e===i.width?0:1,r=1-o,s=["x","y"],l=["width","height"],h=i[s[o]],u=e?t.area/e:0;(a||u>i[l[r]])&&(u=i[l[r]]);for(var c=0,d=t.length;c<d;c++){var p=t[c],f={},g=u?p.getLayout().area/u:0,m=f[l[r]]=n_(u-2*n,0),v=i[s[o]]+i[l[o]]-h,y=c===d-1||v<g?v:g,x=f[l[o]]=n_(y-2*n,0);f[s[r]]=i[s[r]]+a_(n,m/2),f[s[o]]=h+a_(n,x/2),h+=y,p.setLayout(f,!0)}i[s[r]]+=u,i[l[r]]-=u}function Hn(t,e,i,n,a){var o=t.getLayout(),r=i[a],s=r&&r===t;if(!(r&&!s||a===i.length&&t!==n)){t.setLayout({isInView:!0,invisible:!s&&!e.intersect(o),isAboveViewRoot:s},!0);var l=new oh(e.x-o.x,e.y-o.y,e.width,e.height);r_(t.viewChildren||[],function(t){Hn(t,l,i,n,a+1)})}}function Wn(t){return t.get(h_)?t.get(u_):0}function Fn(t){return"_EC_"+t}function Zn(t,e){this.id=null==t?"":t,this.inEdges=[],this.outEdges=[],this.edges=[],this.hostGraph,this.dataIndex=null==e?-1:e}function jn(t,e,i){this.node1=t,this.node2=e,this.dataIndex=null==i?-1:i}function Un(t){return isNaN(+t.cpx1)||isNaN(+t.cpy1)}function qn(t){return"_"+t+"Type"}function Xn(t,e,i){var n=e.getItemVisual(i,"color"),a=e.getItemVisual(i,t),o=e.getItemVisual(i,t+"Size");if(a&&"none"!==a){rl.isArray(o)||(o=[o,o]);var r=Ug.createSymbol(a,-o[0]/2,-o[1]/2,o[0],o[1],n);return r.name=t,r}}function Yn(t,e){var i=e[0],n=e[1],a=e[2];t.x1=i[0],t.y1=i[1],t.x2=n[0],t.y2=n[1],t.percent=1,a?(t.cpx1=a[0],t.cpy1=a[1]):(t.cpx1=NaN,t.cpy1=NaN)}function $n(t,e,i){fp.Group.call(this),this._createLine(t,e,i)}function Kn(t){return isNaN(t[0])||isNaN(t[1])}function Jn(t){return!Kn(t[0])&&!Kn(t[1])}function Qn(t){this._ctor=t||T_,this.group=new fp.Group}function ta(t,e,i){for(var n,a=t[0],o=t[1],r=t[2],s=1/0,l=i*i,h=.1,u=.1;u<=.9;u+=.1){L_[0]=k_(a[0],o[0],r[0],u),L_[1]=k_(a[1],o[1],r[1],u);(p=z_(O_(L_,e)-l))<s&&(s=p,n=u)}for(var c=0;c<32;c++){var d=n+h;D_[0]=k_(a[0],o[0],r[0],n),D_[1]=k_(a[1],o[1],r[1],n),P_[0]=k_(a[0],o[0],r[0],d),P_[1]=k_(a[1],o[1],r[1],d);var p=O_(D_,e)-l;if(z_(p)<.01)break;var f=O_(P_,e)-l;h/=2,p<0?f>=0?n+=h:n-=h:f>=0?n-=h:n+=h}return n}function ea(t,e){return t.getVisual("opacity")||t.getModel().get(e)}function ia(t,e,i){var n=t.getGraphicEl(),a=ea(t,e);null!=i&&(null==a&&(a=1),a*=i),n.downplay&&n.downplay(),n.traverse(function(t){"group"!==t.type&&t.setStyle("opacity",a)})}function na(t,e){var i=ea(t,e),n=t.getGraphicEl();n.highlight&&n.highlight(),n.traverse(function(t){"group"!==t.type&&t.setStyle("opacity",i)})}function aa(t){return t instanceof Array||(t=[t,t]),t}function oa(t){t.eachEdge(function(t){var e=t.getModel().get("lineStyle.normal.curveness")||0,i=ll.clone(t.node1.getLayout()),n=ll.clone(t.node2.getLayout()),a=[i,n];+e&&a.push([(i[0]+n[0])/2-(i[1]-n[1])*e,(i[1]+n[1])/2-(n[0]-i[0])*e]),t.setLayout(a)})}function ra(t,e){return e&&("string"==typeof e?t=e.replace("{value}",null!=t?t:""):"function"==typeof e&&(t=e(t))),t}function sa(t,e){function i(){o.ignore=o.hoverIgnore,r.ignore=r.hoverIgnore}function n(){o.ignore=o.normalIgnore,r.ignore=r.normalIgnore}fp.Group.call(this);var a=new fp.Polygon,o=new fp.Polyline,r=new fp.Text;this.add(a),this.add(o),this.add(r),this.updateData(t,e,!0),this.on("emphasis",i).on("normal",n).on("mouseover",i).on("mouseout",n)}function la(t,e){var i=t[e]-t[1-e];return{span:Math.abs(i),sign:i>0?-1:i<0?1:e?-1:1}}function ha(t,e){return Math.min(e[1],Math.max(e[0],t))}function ua(t,e,i){this._axesMap=rl.createHashMap(),this._axesLayout={},this.dimensions=t.dimensions,this._rect,this._model=t,this._init(t,e,i)}function ca(t,e){return bb(wb(t,e[0]),e[1])}function da(t){dl.call(this),this._zr=t,this.group=new fp.Group,this._brushType,this._brushOption,this._panels,this._track=[],this._dragging,this._covers=[],this._creatingCover,this._creatingPanel,this._enableGlobalPan,this._uid="brushController_"+Wb++,this._handlers={},Db(Fb,function(t,e){this._handlers[e]=rl.bind(t,this)},this)}function pa(t,e){var i=Zb[e.brushType].createCover(t,e);return i.__brushOption=e,ma(i,e),t.group.add(i),i}function fa(t,e){var i=ya(e);return i.endCreating&&(i.endCreating(t,e),ma(e,e.__brushOption)),e}function ga(t,e){var i=e.__brushOption;ya(e).updateCoverShape(t,e,i.range,i)}function ma(t,e){var i=e.z;null==i&&(i=Eb),t.traverse(function(t){t.z=i,t.z2=i})}function va(t,e){ya(e).updateCommon(t,e),ga(t,e)}function ya(t){return Zb[t.__brushOption.brushType]}function xa(t,e,i){var n=t._panels;if(!n)return!0;var a,o=t._transform;return Db(n,function(t){t.isTargetByCursor(e,i,o)&&(a=t)}),a}function _a(t,e){var i=t._panels;if(!i)return!0;var n=e.__brushOption.panelId;return null==n||i[n]}function ba(t){var e=t._covers,i=e.length;return Db(e,function(e){t.group.remove(e)},t),e.length=0,!!i}function wa(t,e){var i=Pb(t._covers,function(t){var e=t.__brushOption,i=rl.clone(e.range);return{brushType:e.brushType,panelId:e.panelId,range:i}});t.trigger("brush",i,{isEnd:!!e.isEnd,removeOnClick:!!e.removeOnClick})}function Sa(t){var e=t.length-1;return e<0&&(e=0),[t[0],t[e]]}function Ma(t,e,i,n){var a=new fp.Group;return a.add(new fp.Rect({name:"main",style:Ca(i),silent:!0,draggable:!0,cursor:"move",drift:Lb(t,e,a,"nswe"),ondragend:Lb(wa,e,{isEnd:!0})})),Db(n,function(i){a.add(new fp.Rect({name:i,style:{opacity:0},draggable:!0,silent:!0,invisible:!0,drift:Lb(t,e,a,i),ondragend:Lb(wa,e,{isEnd:!0})}))}),a}function Ia(t,e,i,n){var a=n.brushStyle.lineWidth||0,o=Ob(a,Nb),r=i[0][0],s=i[1][0],l=r-a/2,h=s-a/2,u=i[0][1],c=i[1][1],d=u-o+a/2,p=c-o+a/2,f=u-r,g=c-s,m=f+a,v=g+a;Aa(t,e,"main",r,s,f,g),n.transformable&&(Aa(t,e,"w",l,h,o,v),Aa(t,e,"e",d,h,o,v),Aa(t,e,"n",l,h,m,o),Aa(t,e,"s",l,p,m,o),Aa(t,e,"nw",l,h,o,o),Aa(t,e,"ne",d,h,o,o),Aa(t,e,"sw",l,p,o,o),Aa(t,e,"se",d,p,o,o))}function Ta(t,e){var i=e.__brushOption,n=i.transformable,a=e.childAt(0);a.useStyle(Ca(i)),a.attr({silent:!n,cursor:n?"move":"default"}),Db(["w","e","n","s","se","sw","ne","nw"],function(i){var a=e.childOfName(i),o=Da(t,i);a&&a.attr({silent:!n,invisible:!n,cursor:n?Gb[o]+"-resize":null})})}function Aa(t,e,i,n,a,o,r){var s=e.childOfName(i);s&&s.setShape(function(t){var e=kb(t[0][0],t[1][0]),i=kb(t[0][1],t[1][1]),n=Ob(t[0][0],t[1][0]),a=Ob(t[0][1],t[1][1]);return{x:e,y:i,width:n-e,height:a-i}}(Oa(t,e,[[n,a],[n+o,a+r]])))}function Ca(t){return rl.defaults({strokeNoScale:!0},t.brushStyle)}function La(t,e,i,n){var a=[kb(t,i),kb(e,n)],o=[Ob(t,i),Ob(e,n)];return[[a[0],o[0]],[a[1],o[1]]]}function Da(t,e){if(e.length>1){return("e"===(i=[Da(t,(e=e.split(""))[0]),Da(t,e[1])])[0]||"w"===i[0])&&i.reverse(),i.join("")}var i=fp.transformDirection({w:"left",e:"right",n:"top",s:"bottom"}[e],function(t){return fp.getTransform(t.group)}(t));return{left:"w",right:"e",top:"n",bottom:"s"}[i]}function Pa(t,e,i,n,a,o,r,s){var l=n.__brushOption,h=t(l.range),u=ka(i,o,r);Db(a.split(""),function(t){var e=Bb[t];h[e[0]][e[1]]+=u[e[0]]}),l.range=e(La(h[0][0],h[1][0],h[0][1],h[1][1])),va(i,n),wa(i,{isEnd:!1})}function ka(t,e,i){var n=t.group,a=n.transformCoordToLocal(e,i),o=n.transformCoordToLocal(0,0);return[a[0]-o[0],a[1]-o[1]]}function Oa(t,e,i){var n=_a(t,e);return n&&!0!==n?n.clipPath(i,t._transform):rl.clone(i)}function za(t){var e=t.event;e.preventDefault&&e.preventDefault()}function Ea(t,e,i){return t.childOfName("main").contain(e,i)}function Ra(t,e,i,n){var a,o=t._creatingCover,r=t._creatingPanel,s=t._brushOption;if(t._track.push(i.slice()),function(t){var e=t._track;if(!e.length)return!1;var i=e[e.length-1],n=e[0],a=i[0]-n[0],o=i[1]-n[1];return zb(a*a+o*o,.5)>Rb}(t)||o){if(r&&!o){"single"===s.brushMode&&ba(t);var l=rl.clone(s);l.brushType=Na(l.brushType,r),l.panelId=!0===r?null:r.panelId,o=t._creatingCover=pa(t,l),t._covers.push(o)}if(o){var h=Zb[Na(t._brushType,r)];o.__brushOption.range=h.getCreatingRange(Oa(t,o,t._track)),n&&(fa(t,o),h.updateCommon(t,o)),ga(t,o),a={isEnd:n}}}else n&&"single"===s.brushMode&&s.removeOnClick&&xa(t,e,i)&&ba(t)&&(a={isEnd:n,removeOnClick:!0});return a}function Na(t,e){return"auto"===t?e.defaultBrushType:t}function Va(t){if(this._dragging){za(t);var e=Ra(this,t,this.group.transformCoordToLocal(t.offsetX,t.offsetY),!0);this._dragging=!1,this._track=[],this._creatingCover=null,e&&wa(this,e)}}function Ba(t){return{createCover:function(e,i){return Ma(Lb(Pa,function(e){var i=[e,[0,100]];return t&&i.reverse(),i},function(e){return e[t]}),e,i,[["w","e"],["n","s"]][t])},getCreatingRange:function(e){var i=Sa(e);return[kb(i[0][t],i[1][t]),Ob(i[0][t],i[1][t])]},updateCoverShape:function(e,i,n,a){var o,r=_a(e,i);if(!0!==r&&r.getLinearBrushOtherExtent)o=r.getLinearBrushOtherExtent(t,e._transform);else{var s=e._zr;o=[0,[s.getWidth(),s.getHeight()][1-t]]}var l=[n,o];t&&l.reverse(),Ia(e,i,l,a)},updateCommon:Ta,contain:Ea}}function Ga(t){return oh.create(t)}function Ha(t){var e=t.axis;return rl.map(t.activeIntervals,function(t){return{brushType:"lineX",panelId:"pl",range:[e.dataToCoord(t[0],!0),e.dataToCoord(t[1],!0)]}})}function Wa(t,e){var i=t._model;return i.get("axisExpandable")&&i.get("axisExpandTriggerOn")===e}function Fa(t){return+t.replace("dim","")}function Za(t,e,i,n){for(var a=[],o=0;o<i.length;o++){var r=i[o],s=t.get(r,e);(function(t,e){return"category"===e?null==t:null==t||isNaN(t)})(s,n.getAxis(r).type)||a.push(n.dataToPoint(s,r))}return a}function ja(t,e,i){rl.each(t,function(t){var n,a,o,r=0,s=t.length;for(t.sort(function(t,e){return t.getLayout().y-e.getLayout().y}),o=0;o<s;o++){if(n=t[o],(a=r-n.getLayout().y)>0){l=n.getLayout().y+a;n.setLayout({y:l},!0)}r=n.getLayout().y+n.getLayout().dy+e}if((a=r-e-i)>0){var l=n.getLayout().y-a;for(n.setLayout({y:l},!0),r=n.getLayout().y,o=s-2;o>=0;--o)(a=(n=t[o]).getLayout().y+n.getLayout().dy+e-r)>0&&(l=n.getLayout().y-a,n.setLayout({y:l},!0)),r=n.getLayout().y}})}function Ua(t,e){for(var i=0,n=t.length,a=-1;++a<n;){var o=+e.call(t,t[a],a);isNaN(o)||(i+=o)}return i}function qa(t){return t.getLayout().y+t.getLayout().dy/2}function Xa(t){return t.getValue()}function Ya(t,e,i,n){fp.Group.call(this),this.bodyIndex,this.whiskerIndex,this.styleUpdater=i,this._createContent(t,e,n),this.updateData(t,e,n),this._seriesModel}function $a(t,e,i){return rl.map(t,function(t){return t=t.slice(),t[e]=i.initBaseline,t})}function Ka(t){var e={};return rl.each(t,function(t,i){e["ends"+i]=t}),e}function Ja(t){this.group=new fp.Group,this.styleUpdater=t}function Qa(t,e){t.eachChild(function(t){t.attr({z:e.z,zlevel:e.zlevel,style:{stroke:"stroke"===e.brushType?e.color:null,fill:"fill"===e.brushType?e.color:null}})})}function to(t,e){Vw.call(this);var i=new Lm(t,e),n=new Vw;this.add(i),this.add(n),n.beforeUpdate=function(){this.attr(i.getScale())},this.updateData(t,e)}function eo(t){var e=t.data;e&&e[0]&&e[0][0]&&e[0][0].coord&&(t.data=rl.map(e,function(t){var e={coords:[t[0].coord,t[1].coord]};return t[0].name&&(e.fromName=t[0].name),t[1].name&&(e.toName=t[1].name),rl.mergeAll([e,t[0],t[1]])}))}function io(t,e,i){fp.Group.call(this),this.add(this.createLine(t,e,i)),this._updateEffectSymbol(t,e)}function no(t,e,i){fp.Group.call(this),this._createPolyline(t,e,i)}function ao(t,e,i){Uw.call(this,t,e,i),this._lastFrame=0,this._lastFramePercent=0}function oo(){this.group=new fp.Group,this._lineEl=new Kw}function ro(t){return t instanceof Array||(t=[t,t]),t}function so(){var t=rl.createCanvas();this.canvas=t,this.blurSize=30,this.pointSize=20,this.maxOpacity=1,this.minOpacity=0,this._gradientPixels={}}function lo(t,e,i,n){var a=t.getItemLayout(e),o=i.get("symbolRepeat"),r=i.get("symbolClip"),s=i.get("symbolPosition")||"start",l=(i.get("symbolRotate")||0)*Math.PI/180||0,h=i.get("symbolPatternSize")||2,u=i.isAnimationEnabled(),c={dataIndex:e,layout:a,itemModel:i,symbolType:t.getItemVisual(e,"symbol")||"circle",color:t.getItemVisual(e,"color"),symbolClip:r,symbolRepeat:o,symbolRepeatDirection:i.get("symbolRepeatDirection"),symbolPatternSize:h,rotation:l,animationModel:u?i:null,hoverAnimation:u&&i.get("hoverAnimation"),z2:i.getShallow("z",!0)||0};!function(t,e,i,n,a){var o,r=n.valueDim,s=t.get("symbolBoundingData"),l=n.coordSys.getOtherAxis(n.coordSys.getBaseAxis()),h=l.toGlobalCoord(l.dataToCoord(0)),u=1-+(i[r.wh]<=0);if(rl.isArray(s)){var c=[ho(l,s[0])-h,ho(l,s[1])-h];c[1]<c[0]&&c.reverse(),o=c[u]}else o=null!=s?ho(l,s)-h:e?n.coordSysExtent[r.index][u]-h:i[r.wh];a.boundingLength=o,e&&(a.repeatCutLength=i[r.wh]);a.pxSign=o>0?1:o<0?-1:0}(i,o,a,n,c),function(t,e,i,n,a,o,r,s,l,h){var u=l.valueDim,c=l.categoryDim,d=Math.abs(i[c.wh]),p=t.getItemVisual(e,"symbolSize");rl.isArray(p)?p=p.slice():(null==p&&(p="100%"),p=[p,p]);p[c.index]=oS(p[c.index],d),p[u.index]=oS(p[u.index],n?d:Math.abs(o)),h.symbolSize=p;(h.symbolScale=[p[0]/s,p[1]/s])[u.index]*=(l.isHorizontal?-1:1)*r}(t,e,a,o,0,c.boundingLength,c.pxSign,h,n,c),function(t,e,i,n,a){var o=t.get(lS)||0;o&&(uS.attr({scale:e.slice(),rotation:i}),uS.updateTransform(),o/=uS.getLineScale(),o*=e[n.valueDim.index]);a.valueLineWidth=o}(i,c.symbolScale,l,n,c);var d=c.symbolSize,p=i.get("symbolOffset");return rl.isArray(p)&&(p=[oS(p[0],d[0]),oS(p[1],d[1])]),function(t,e,i,n,a,o,r,s,l,h,u,c){var d=u.categoryDim,p=u.valueDim,f=c.pxSign,g=Math.max(e[p.index]+s,0),m=g;if(n){var v=Math.abs(l),y=rl.retrieve(t.get("symbolMargin"),"15%")+"",x=!1;y.lastIndexOf("!")===y.length-1&&(x=!0,y=y.slice(0,y.length-1)),y=oS(y,e[p.index]);var _=Math.max(g+2*y,0),b=x?0:2*y,w=rS(n),S=w?n:Mo((v+b)/_);_=g+2*(y=(v-S*g)/2/(x?S:S-1)),b=x?0:2*y,w||"fixed"===n||(S=h?Mo((Math.abs(h)+b)/_):0),m=S*_-b,c.repeatTimes=S,c.symbolMargin=y}var M=f*(m/2),I=c.pathPosition=[];I[d.index]=i[d.wh]/2,I[p.index]="start"===r?M:"end"===r?l-M:l/2,o&&(I[0]+=o[0],I[1]+=o[1]);var T=c.bundlePosition=[];T[d.index]=i[d.xy],T[p.index]=i[p.xy];var A=c.barRectShape=rl.extend({},i);A[p.wh]=f*Math.max(Math.abs(i[p.wh]),Math.abs(I[p.index]+M)),A[d.wh]=i[d.wh];var C=c.clipShape={};C[d.xy]=-i[d.xy],C[d.wh]=u.ecSize[d.wh],C[p.xy]=0,C[p.wh]=i[p.wh]}(i,d,a,o,0,p,s,c.valueLineWidth,c.boundingLength,c.repeatCutLength,n,c),c}function ho(t,e){return t.toGlobalCoord(t.dataToCoord(t.scale.parse(e)))}function uo(t){var e=t.symbolPatternSize,i=aS(t.symbolType,-e/2,-e/2,e,e,t.color);return i.attr({culling:!0}),"image"!==i.type&&i.setStyle({strokeNoScale:!0}),i}function co(t,e,i,n){function a(t){var e=l.slice(),n=i.pxSign,a=t;return("start"===i.symbolRepeatDirection?n>0:n<0)&&(a=u-1-t),e[h.index]=d*(a-u/2+.5)+l[h.index],{position:e,scale:i.symbolScale.slice(),rotation:i.rotation}}var o=t.__pictorialBundle,r=i.symbolSize,s=i.valueLineWidth,l=i.pathPosition,h=e.valueDim,u=i.repeatTimes||0,c=0,d=r[e.valueDim.index]+s+2*i.symbolMargin;for(bo(t,function(t){t.__pictorialAnimationIndex=c,t.__pictorialRepeatTimes=u,c<u?wo(t,null,a(c),i,n):wo(t,null,{scale:[0,0]},i,n,function(){o.remove(t)}),vo(t,i),c++});c<u;c++){var p=uo(i);p.__pictorialAnimationIndex=c,p.__pictorialRepeatTimes=u,o.add(p);var f=a(c);wo(p,{position:f.position,scale:[0,0]},{scale:f.scale,rotation:f.rotation},i,n),p.on("mouseover",function(){bo(t,function(t){t.trigger("emphasis")})}).on("mouseout",function(){bo(t,function(t){t.trigger("normal")})}),vo(p,i)}}function po(t,e,i,n){var a=t.__pictorialBundle,o=t.__pictorialMainPath;o?wo(o,null,{position:i.pathPosition.slice(),scale:i.symbolScale.slice(),rotation:i.rotation},i,n):(o=t.__pictorialMainPath=uo(i),a.add(o),wo(o,{position:i.pathPosition.slice(),scale:[0,0],rotation:i.rotation},{scale:i.symbolScale.slice()},i,n),o.on("mouseover",function(){this.trigger("emphasis")}).on("mouseout",function(){this.trigger("normal")})),vo(o,i)}function fo(t,e,i){var n=rl.extend({},e.barRectShape),a=t.__pictorialBarRect;a?wo(a,null,{shape:n},e,i):(a=t.__pictorialBarRect=new fp.Rect({z2:2,shape:n,silent:!0,style:{stroke:"transparent",fill:"transparent",lineWidth:0}}),t.add(a))}function go(t,e,i,n){if(i.symbolClip){var a=t.__pictorialClipPath,o=rl.extend({},i.clipShape),r=e.valueDim,s=i.animationModel,l=i.dataIndex;if(a)fp.updateProps(a,{shape:o},s,l);else{o[r.wh]=0,a=new fp.Rect({shape:o}),t.__pictorialBundle.setClipPath(a),t.__pictorialClipPath=a;var h={};h[r.wh]=i.clipShape[r.wh],fp[n?"updateProps":"initProps"](a,{shape:h},s,l)}}}function mo(t,e){var i=t.getItemModel(e);return i.getAnimationDelayParams=function(t){return{index:t.__pictorialAnimationIndex,count:t.__pictorialRepeatTimes}},i.isAnimationEnabled=function(){return this.parentModel.isAnimationEnabled()&&!!this.getShallow("animation")},i}function vo(t,e){t.off("emphasis").off("normal");var i=e.symbolScale.slice();e.hoverAnimation&&t.on("emphasis",function(){this.animateTo({scale:[1.1*i[0],1.1*i[1]]},400,"elasticOut")}).on("normal",function(){this.animateTo({scale:i.slice()},400,"elasticOut")})}function yo(t,e,i,n){var a=new fp.Group,o=new fp.Group;return a.add(o),a.__pictorialBundle=o,o.attr("position",i.bundlePosition.slice()),i.symbolRepeat?co(a,e,i):po(a,0,i),fo(a,i,n),go(a,e,i,n),a.__pictorialShapeStr=_o(t,i),a.__pictorialSymbolMeta=i,a}function xo(t,e,i,n){var a=n.__pictorialBarRect;a&&(a.style.text=null);var o=[];bo(n,function(t){o.push(t)}),n.__pictorialMainPath&&o.push(n.__pictorialMainPath),n.__pictorialClipPath&&(i=null),rl.each(o,function(t){fp.updateProps(t,{scale:[0,0]},i,e,function(){n.parent&&n.parent.remove(n)})}),t.setItemGraphicEl(e,null)}function _o(t,e){return[t.getItemVisual(e.dataIndex,"symbol")||"none",!!e.symbolRepeat,!!e.symbolClip].join(":")}function bo(t,e,i){rl.each(t.__pictorialBundle.children(),function(n){n!==t.__pictorialBarRect&&e.call(i,n)})}function wo(t,e,i,n,a,o){e&&t.attr(e),n.symbolClip&&!a?i&&t.attr(i):i&&fp[a?"updateProps":"initProps"](t,i,n.animationModel,n.dataIndex,o)}function So(t,e,i){var n=i.color,a=i.dataIndex,o=i.itemModel,r=o.getModel("itemStyle.normal").getItemStyle(["color"]),s=o.getModel("itemStyle.emphasis").getItemStyle(),l=o.getShallow("cursor");bo(t,function(t){t.setColor(n),t.setStyle(rl.defaults({fill:n,opacity:i.opacity},r)),fp.setHoverStyle(t,s),l&&(t.cursor=l),t.z2=i.z2});var h={},u=e.valueDim.posDesc[+(i.boundingLength>0)],c=t.__pictorialBarRect;sS(c.style,h,o,n,e.seriesModel,a,u),fp.setHoverStyle(c,h)}function Mo(t){var e=Math.round(t);return Math.abs(t-e)<1e-4?e:Math.ceil(t)}function Io(t,e,i){this.dimension="single",this.dimensions=["single"],this._axis=null,this._rect,this._init(t,e,i),this.model=t}function To(t,e,i,n,a){var o=t.axis;if(!o.scale.isBlank()&&o.containData(e))if(t.involveSeries){var r=function(t,e){var i=e.axis,n=i.dim,a=t,o=[],r=Number.MAX_VALUE,s=-1;return wS(e.seriesModels,function(e,l){var h,u,c=e.coordDimToDataDim(n);if(e.getAxisTooltipData){var d=e.getAxisTooltipData(c,t,i);u=d.dataIndices,h=d.nestestValue}else{if(!(u=e.getData().indicesOfNearest(c[0],t,!1,"category"===i.type?.5:null)).length)return;h=e.getData().get(c[0],u[0])}if(null!=h&&isFinite(h)){var p=t-h,f=Math.abs(p);f<=r&&((f<r||p>=0&&s<0)&&(r=f,s=p,a=h,o.length=0),wS(u,function(t){o.push({seriesIndex:e.seriesIndex,dataIndexInside:t,dataIndex:e.getData().getRawIndex(t)})}))}}),{payloadBatch:o,snapToValue:a}}(e,t),s=r.payloadBatch,l=r.snapToValue;s[0]&&null==a.seriesIndex&&rl.extend(a,s[0]),!n&&t.snap&&o.containData(l)&&null!=l&&(e=l),i.showPointer(t,e,s,a),i.showTooltip(t,r,l)}else i.showPointer(t,e)}function Ao(t){var e=t.axis.model,i={},n=i.axisDim=t.axis.dim;return i.axisIndex=i[n+"AxisIndex"]=e.componentIndex,i.axisName=i[n+"AxisName"]=e.name,i.axisId=i[n+"AxisId"]=e.id,i}function Co(t){return!t||null==t[0]||isNaN(t[0])||null==t[1]||isNaN(t[1])}function Lo(t,e,i,n){e.handler(t,i,n)}function Do(){}function Po(t,e,i,n){ko(DS(i).lastProp,n)||(DS(i).lastProp=n,e?fp.updateProps(i,n,t):(i.stopAnimation(),i.attr(n)))}function ko(t,e){if(rl.isObject(t)&&rl.isObject(e)){var i=!0;return rl.each(e,function(e,n){i=i&&ko(t[n],e)}),!!i}return t===e}function Oo(t,e){t[e.get("label.show")?"show":"hide"]()}function zo(t){return{position:t.position.slice(),rotation:t.rotation||0}}function Eo(t,e,i){var n=e.get("z"),a=e.get("zlevel");t&&t.traverse(function(t){"group"!==t.type&&(null!=n&&(t.z=n),null!=a&&(t.zlevel=a),t.silent=i)})}function Ro(t,e,i,n,a){var o=No(i.get("value"),e.axis,e.ecModel,i.get("seriesDataIndices"),{precision:i.get("label.precision"),formatter:i.get("label.formatter")}),r=i.getModel("label"),s=Eu.normalizeCssArray(r.get("padding")||0),l=r.getFont(),h=Nh.getBoundingRect(o,l),u=a.position,c=h.width+s[1]+s[3],d=h.height+s[0]+s[2],p=a.align;"right"===p&&(u[0]-=c),"center"===p&&(u[0]-=c/2);var f=a.verticalAlign;"bottom"===f&&(u[1]-=d),"middle"===f&&(u[1]-=d/2),function(t,e,i,n){var a=n.getWidth(),o=n.getHeight();t[0]=Math.min(t[0]+e,a)-e,t[1]=Math.min(t[1]+i,o)-i,t[0]=Math.max(t[0],0),t[1]=Math.max(t[1],0)}(u,c,d,n);var g=r.get("backgroundColor");g&&"auto"!==g||(g=e.get("axisLine.lineStyle.color")),t.label={shape:{x:0,y:0,width:c,height:d,r:r.get("borderRadius")},position:u.slice(),style:{text:o,textFont:l,textFill:r.getTextColor(),textPosition:"inside",fill:g,stroke:r.get("borderColor")||"transparent",lineWidth:r.get("borderWidth")||0,shadowBlur:r.get("shadowBlur"),shadowColor:r.get("shadowColor"),shadowOffsetX:r.get("shadowOffsetX"),shadowOffsetY:r.get("shadowOffsetY")},z2:10}}function No(t,e,i,n,a){var o=e.scale.getLabel(t,{precision:a.precision}),r=a.formatter;if(r){var s={value:Rg.getAxisRawValue(e,t),seriesData:[]};rl.each(n,function(t){var e=i.getSeriesByIndex(t.seriesIndex),n=t.dataIndexInside,a=e&&e.getDataParams(n);a&&s.seriesData.push(a)}),rl.isString(r)?o=r.replace("{value}",o):rl.isFunction(r)&&(o=r(s))}return o}function Vo(t,e,i){var n=yl.create();return yl.rotate(n,n,i.rotation),yl.translate(n,n,i.position),fp.applyTransform([t.dataToCoord(e),(i.labelOffset||0)+(i.labelDirection||1)*(i.labelMargin||0)],n)}function Bo(t,e){var i={};return i[e.dim+"AxisIndex"]=e.index,t.getCartesian(i)}function Go(t){return"x"===t.dim?0:1}function Ho(t){return t.isHorizontal()?0:1}function Wo(t,e){var i=t.getRect();return[i[NS[e]],i[NS[e]]+i[VS[e]]]}function Fo(t,e,i){if(t.count())for(var n,a=e.coordinateSystem,o=e.getLayerSeries(),r=rl.map(o,function(e){return rl.map(e.indices,function(e){var i=a.dataToPoint(t.get("time",e));return i[1]=t.get("value",e),i})}),s=function(t){for(var e=t.length,i=t[0].length,n=[],a=[],o=0,r={},s=0;s<i;++s){for(var l=0,h=0;l<e;++l)h+=t[l][s][1];h>o&&(o=h),n.push(h)}for(var u=0;u<i;++u)a[u]=(o-n[u])/2;o=0;for(var c=0;c<i;++c){var d=n[c]+a[c];d>o&&(o=d)}return r.y0=a,r.max=o,r}(r),l=s.y0,h=i/s.max,u=o.length,c=o[0].indices.length,d=0;d<c;++d){n=l[d]*h,t.setItemLayout(o[0].indices[d],{layerIndex:0,x:r[0][d][0],y0:n,y:r[0][d][1]*h});for(var p=1;p<u;++p)n+=r[p-1][d][1]*h,t.setItemLayout(o[p].indices[d],{layerIndex:p,x:r[p][d][0],y0:n,y:r[p][d][1]*h})}}function Zo(t,e,i,n,a){null==i[t]||a||(e[t]=i[t],i[t]=n[t])}function jo(t,e,i,n,a,o){(t=Uo(t,e,i,n,a,o))&&o.setItemGraphicEl(e,t)}function Uo(t,e,i,n,a,o){var r=i.type;if(!t||r===t.__customGraphicType||"path"===r&&i.pathData===t.__customPathData||"image"===r&&i.style.image===t.__customImagePath||"text"===r&&i.style.text===t.__customText||(a.remove(t),t=null),null!=r){var s=!t;if(!t&&(t=function(t){var e,i=t.type;if("path"===i){var n=t.shape;(e=fp.makePath(n.pathData,null,{x:n.x||0,y:n.y||0,width:n.width||0,height:n.height||0},"center")).__customPathData=t.pathData}else"image"===i?(e=new fp.Image({})).__customImagePath=t.style.image:"text"===i?(e=new fp.Text({})).__customText=t.style.text:e=new(0,fp[i.charAt(0).toUpperCase()+i.slice(1)]);return e.__customGraphicType=i,e.name=t.name,e}(i)),function(t,e,i,n,a,o){var r={},s=i.style||{};i.shape&&(r.shape=rl.clone(i.shape)),i.position&&(r.position=i.position.slice()),i.scale&&(r.scale=i.scale.slice()),i.origin&&(r.origin=i.origin.slice()),i.rotation&&(r.rotation=i.rotation),"image"===t.type&&i.style&&(l=r.style={},rl.each(["x","y","width","height"],function(e){Zo(e,l,s,t.style,o)}));if("text"===t.type&&i.style){var l=r.style={};rl.each(["x","y"],function(e){Zo(e,l,s,t.style,o)}),!s.hasOwnProperty("textFill")&&s.fill&&(s.textFill=s.fill),!s.hasOwnProperty("textStroke")&&s.stroke&&(s.textStroke=s.stroke)}if("group"!==t.type&&(t.useStyle(s),o)){t.style.opacity=0;var h=s.opacity;null==h&&(h=1),fp.initProps(t,{style:{opacity:h}},n,e)}o?t.attr(r):fp.updateProps(t,r,n,e),t.attr({z2:i.z2||0,silent:i.silent}),!1!==i.styleEmphasis&&fp.setHoverStyle(t,i.styleEmphasis)}(t,e,i,n,0,s),"group"===r){var l=t.children()||[],h=i.children||[];if(i.diffChildrenByName)!function(t){new qf(t.oldChildren,t.newChildren,qo,qo,t).add(Xo).update(Xo).remove(function(t){var e=this.context,i=e.oldChildren[t];i&&e.group.remove(i)}).execute()}({oldChildren:l,newChildren:h,dataIndex:e,animatableModel:n,group:t,data:o});else{for(var u=0;u<h.length;u++)Uo(t.childAt(u),e,h[u],n,t,o);for(;u<l.length;u++)l[u]&&t.remove(l[u])}}return a.add(t),t}}function qo(t,e){var i=t&&t.name;return null!=i?i:tM+e}function Xo(t,e){var i=this.context,n=null!=t?i.newChildren[t]:null;Uo(null!=e?i.oldChildren[e]:null,i.dataIndex,n,i.animatableModel,i.group,i.data)}function Yo(t,e,i,n){var a=i.type,o=new(0,fp[a.charAt(0).toUpperCase()+a.slice(1)])(i);e.add(o),n.set(t,o),o.__ecGraphicId=t}function $o(t,e){var i=t&&t.parent;i&&("group"===t.type&&t.traverse(function(t){$o(t,e)}),e.removeKey(t.__ecGraphicId),i.remove(t))}function Ko(t,e){var i;return rl.each(e,function(e){null!=t[e]&&"auto"!==t[e]&&(i=!0)}),i}function Jo(t,e,i){var n,a={},o="toggleSelected"===t;return i.eachComponent("legend",function(i){o&&null!=n?i[n?"select":"unSelect"](e.name):(i[t](e.name),n=i.isSelected(e.name));var r=i.getData();rl.each(r,function(t){var e=t.get("name");if("\n"!==e&&""!==e){var n=i.isSelected(e);a.hasOwnProperty(e)?a[e]=a[e]&&n:a[e]=n}})}),{name:e.name,selected:a}}function Qo(t,e){e.dispatchAction({type:"legendToggleSelect",name:t})}function tr(t,e,i){var n=i.getZr().storage.getDisplayList()[0];n&&n.useHoverLayer||t.get("legendHoverLink")&&i.dispatchAction({type:"highlight",seriesName:t.name,name:e})}function er(t,e,i){var n=i.getZr().storage.getDisplayList()[0];n&&n.useHoverLayer||t.get("legendHoverLink")&&i.dispatchAction({type:"downplay",seriesName:t.name,name:e})}function ir(t,e,i){var n=[1,1];n[t.getOrient().index]=0,mM(e,i,{type:"box",ignoreSize:n})}function nr(t,e){var i=document.createElement("div"),n=this._zr=e.getZr();this.el=i,this._x=e.getWidth()/2,this._y=e.getHeight()/2,t.appendChild(i),this._container=t,this._show=!1,this._hideTimeout;var a=this;i.onmouseenter=function(){a._enterable&&(clearTimeout(a._hideTimeout),a._show=!0),a._inContent=!0},i.onmousemove=function(e){if(e=e||window.event,!a._enterable){var i=n.handler;su.normalizeEvent(t,e,!0),i.dispatch("mousemove",e)}},i.onmouseleave=function(){a._enterable&&a._show&&a.hideLater(a._hideDelay),a._inContent=!1}}function ar(t){for(var e=t.pop();t.length;){var i=t.pop();i&&(i instanceof _p&&(i=i.get("tooltip",!0)),"string"==typeof i&&(i={formatter:i}),e=new _p(i,e,e.ecModel))}return e}function or(t,e){return t.dispatchAction||rl.bind(e.dispatchAction,e)}function rr(t){var e=t.clientWidth,i=t.clientHeight;if(document.defaultView&&document.defaultView.getComputedStyle){var n=document.defaultView.getComputedStyle(t);n&&(e+=parseInt(n.paddingLeft,10)+parseInt(n.paddingRight,10)+parseInt(n.borderLeftWidth,10)+parseInt(n.borderRightWidth,10),i+=parseInt(n.paddingTop,10)+parseInt(n.paddingBottom,10)+parseInt(n.borderTopWidth,10)+parseInt(n.borderBottomWidth,10))}return{width:e,height:i}}function sr(t){return"center"===t||"middle"===t}function lr(t){return t.get("stack")||"__ec_stack_"+t.seriesIndex}function hr(t){return t.dim}function ur(t,e){Kg.call(this,"radius",t,e),this.type="category"}function cr(t,e){e=e||[0,360],Kg.call(this,"angle",t,e),this.type="category"}function dr(t,e){return e.type||(e.data?"category":"value")}function pr(t,e){if(t.type=e.get("type"),t.scale=GM(e),t.onBand=e.get("boundaryGap")&&"category"===t.type,t.inverse=e.get("inverse"),"angleAxis"===e.mainType){t.inverse^=e.get("clockwise");var i=e.get("startAngle");t.setExtent(i,i+(t.inverse?-360:360))}e.axis=t,t.model=e}function fr(t,e,i){e[1]>e[0]&&(e=e.slice().reverse());var n=t.coordToPoint([e[0],i]),a=t.coordToPoint([e[1],i]);return{x1:n[0],y1:n[1],x2:a[0],y2:a[1]}}function gr(t){return t.getRadiusAxis().inverse?0:1}function mr(t,e){e.update="updateView",ym.registerAction(e,function(e,i){var n={};return i.eachComponent({mainType:"geo",query:e},function(i){i[t](e.name);var a=i.coordinateSystem;rl.each(a.regions,function(t){n[t.name]=i.isSelected(t.name)||!1})}),{selected:n,name:e.name}})}function vr(t){if(t)for(var e in t)if(t.hasOwnProperty(e))return!0}function yr(t){var e=["x","y"],i=["width","height"];return{point:function(e,i,n){if(e){var a=n.range;return xr(e[t],a)}},rect:function(n,a,o){if(n){var r=o.range,s=[n[e[t]],n[e[t]]+n[i[t]]];return s[1]<s[0]&&s.reverse(),xr(s[0],r)||xr(s[1],r)||xr(r[0],s)||xr(r[1],s)}}}}function xr(t,e){return e[0]<=t&&t<=e[1]}function _r(t,e,i,n,a){for(var o=0,r=a[a.length-1];o<a.length;o++){var s=a[o];if(function(t,e,i,n,a,o,r,s){var l=br(i-t,a-r,n-e,o-s);if(function(t){return t<=1e-6&&t>=-1e-6}(l))return!1;var h=br(a-t,a-r,o-e,o-s)/l;if(h<0||h>1)return!1;var u=br(i-t,a-t,n-e,o-e)/l;if(u<0||u>1)return!1;return!0}(t,e,i,n,s[0],s[1],r[0],r[1]))return!0;r=s}}function br(t,e,i,n){return t*n-e*i}function wr(t,e,i){var n=this._targetInfoList=[],a={},o=Mr(e,t);tI(rI,function(t,e){(!i||!i.include||eI(i.include,e)>=0)&&t(o,n,a)})}function Sr(t){return t[0]>t[1]&&t.reverse(),t}function Mr(t,e){return Ip.parseFinder(t,e,{includeMainTypes:aI})}function Ir(t,e,i,n){var a=i.getAxis(["x","y"][t]),o=Sr(rl.map([0,1],function(t){return e?a.coordToData(a.toLocalCoord(n[t])):a.toGlobalCoord(a.dataToCoord(n[t]))})),r=[];return r[t]=o,r[1-t]=[NaN,NaN],{values:o,xyMinMax:r}}function Tr(t,e,i,n){return[e[0]-n[t]*i[0],e[1]-n[t]*i[1]]}function Ar(t){return t?[t[0][1]-t[0][0],t[1][1]-t[1][0]]:[NaN,NaN]}function Cr(t,e,i,n){for(var a=0,o=e.length;a<o;a++){var r=e[a];if(t[r.brushType](n,i,r.selectors,r))return!0}}function Lr(t){var e=t.brushSelector;if(rl.isString(e)){var i=[];return rl.each(QM,function(t,n){i[n]=function(i,n,a,o){var r=n.getItemLayout(i);return t[e](r,a,o)}}),i}if(rl.isFunction(e)){var n={};return rl.each(QM,function(t,i){n[i]=e}),n}return e}function Dr(t){return new oh(t[0][0],t[1][0],t[0][1]-t[0][0],t[1][1]-t[1][0])}function Pr(t,e){return rl.merge({brushType:t.brushType,brushMode:t.brushMode,transformable:t.transformable,brushStyle:new _p(t.brushStyle).getItemStyle(),removeOnClick:t.removeOnClick,z:t.z},e,!0)}function kr(t,e,i,n){(!n||n.$from!==t.id)&&this._brushController.setPanels(t.brushTargetManager.makePanelOpts(i)).enableBrush(t.brushOption).updateCovers(t.areas.slice())}function Or(t,e,i){this.model=t,this.ecModel=e,this.api=i,this._brushType,this._brushMode}function zr(t,e,i){this._model=t}function Er(t,e,i,n){var a=i.calendarModel,o=i.seriesModel,r=a?a.coordinateSystem:o?o.coordinateSystem:null;return r===this?r[t](n):null}function Rr(t,e){var i=t.cellSize;rl.isArray(i)?1===i.length&&(i[1]=i[0]):i=t.cellSize=[i,i];var n=rl.map([0,1],function(t){return MI(e,t)&&(i[t]="auto"),null!=i[t]&&"auto"!==i[t]});II(t,e,{type:"box",ignoreSize:n})}function Nr(t,e){t=t.slice();var i=rl.map(t,Eu.capitalFirst);e=(e||[]).slice();var n=rl.map(e,Eu.capitalFirst);return function(a,o){rl.each(t,function(t,r){for(var s={name:t,capital:i[r]},l=0;l<e.length;l++)s[e[l]]=t+n[l];a.call(o,s)})}}function Vr(t,e){var i=t.getAxisModel(),n=t._percentWindow,a=t._valueWindow;if(n){var o=Pu.getPixelPrecision(a,[0,500]);o=Math.min(o,20);var r=e||0===n[0]&&100===n[1];i.setRange(r?null:+a[0].toFixed(o),r?null:+a[1].toFixed(o))}}function Br(t){var e={};return RI(["start","end","startValue","endValue","throttle"],function(i){t.hasOwnProperty(i)&&(e[i]=t[i])}),e}function Gr(t,e){var i=t._rangePropMode,n=t.get("rangeMode");RI([["start","startValue"],["end","endValue"]],function(t,a){var o=null!=e[t[0]],r=null!=e[t[1]];o&&!r?i[a]="percent":!o&&r?i[a]="value":n?i[a]=n[a]:o&&(i[a]="percent")})}function Hr(t){return"vertical"===t?"ns-resize":"ew-resize"}function Wr(t){var e=t.getZr();return e[$I]||(e[$I]={})}function Fr(t){rl.each(t,function(e,i){e.count||(e.controller.dispose(),delete t[i])})}function Zr(t,e){var i=[];rl.each(t.dataZoomInfos,function(t){var n=e(t);!t.disabled&&n&&i.push({dataZoomId:t.dataZoomId,start:n[0],end:n[1]})}),t.dispatchAction(i)}function jr(t,e){return t&&t.hasOwnProperty&&t.hasOwnProperty(e)}function Ur(t,e,i){if(i[0]===i[1])return i.slice();for(var n=(i[1]-i[0])/200,a=i[0],o=[],r=0;r<=200&&a<i[1];r++)o.push(a),a+=n;return o.push(i[1]),o}function qr(t,e,i,n){return new fp.Polygon({shape:{points:t},draggable:!!i,cursor:e,drift:i,onmousemove:function(t){su.stop(t.event)},ondragend:n})}function Xr(t){var e=t.get("hoverLinkOnHandle");return!!(null==e?t.get("realtime"):e)}function Yr(t){return"vertical"===t?"ns-resize":"ew-resize"}function $r(t,e){var i=t.inverse;("vertical"===t.orient?!i:i)&&e.reverse()}function Kr(t){Ip.defaultEmphasis(t.label,["show"])}function Jr(t,e,i,n,a,o){var r=[],s=ts(e,n,t),l=e.indicesOfNearest(n,s,!0)[0];r[a]=e.get(i,l,!0),r[o]=e.get(n,l,!0);var h=function(t,e,i){var n=-1;do{n=Math.max(Pu.getPrecision(t.get(e,i)),n),t=t.stackedOn}while(t);return n}(e,n,l);return(h=Math.min(h,20))>=0&&(r[o]=+r[o].toFixed(h)),r}function Qr(t,e,i,n){var a={};return null!=t.valueIndex||null!=t.valueDim?(a.valueDataDim=null!=t.valueIndex?e.getDimension(t.valueIndex):t.valueDim,a.valueAxis=i.getAxis(n.dataDimToCoordDim(a.valueDataDim)),a.baseAxis=i.getOtherAxis(a.valueAxis),a.baseDataDim=n.coordDimToDataDim(a.baseAxis.dim)[0]):(a.baseAxis=n.getBaseAxis(),a.valueAxis=i.getOtherAxis(a.baseAxis),a.baseDataDim=n.coordDimToDataDim(a.baseAxis.dim)[0],a.valueDataDim=n.coordDimToDataDim(a.valueAxis.dim)[0]),a}function ts(t,e,i){if("average"===i){var n=0,a=0;return t.each(e,function(t,e){isNaN(t)||(n+=t,a++)},!0),n/a}return t.getDataExtent(e,!0)["max"===i?1:0]}function es(t,e,i){var n=e.coordinateSystem;t.each(function(a){var o,r=t.getItemModel(a),s=Pu.parsePercent(r.get("x"),i.getWidth()),l=Pu.parsePercent(r.get("y"),i.getHeight());if(isNaN(s)||isNaN(l)){if(e.getMarkerPosition)o=e.getMarkerPosition(t.getValues(t.dimensions,a));else if(n){var h=t.get(n.dimensions[0],a),u=t.get(n.dimensions[1],a);o=n.dataToPoint([h,u])}}else o=[s,l];isNaN(s)||(o[0]=s),isNaN(l)||(o[1]=l),t.setItemLayout(a,o)})}function is(t){return!isNaN(t)&&!isFinite(t)}function ns(t,e,i,n){var a=1-t,o=n.dimensions[t];return is(e[a])&&is(i[a])&&e[t]===i[t]&&n.getAxis(o).containData(e[t])}function as(t,e,i,n,a){var o,r=n.coordinateSystem,s=t.getItemModel(e),l=Pu.parsePercent(s.get("x"),a.getWidth()),h=Pu.parsePercent(s.get("y"),a.getHeight());if(isNaN(l)||isNaN(h)){if(n.getMarkerPosition)o=n.getMarkerPosition(t.getValues(t.dimensions,e));else{var u=r.dimensions,c=t.get(u[0],e),d=t.get(u[1],e);o=r.dataToPoint([c,d])}if("cartesian2d"===r.type){var p=r.getAxis("x"),f=r.getAxis("y"),u=r.dimensions;is(t.get(u[0],e))?o[0]=p.toGlobalCoord(p.getExtent()[i?0:1]):is(t.get(u[1],e))&&(o[1]=f.toGlobalCoord(f.getExtent()[i?0:1]))}isNaN(l)||(o[0]=l),isNaN(h)||(o[1]=h)}else o=[l,h];t.setItemLayout(e,o)}function os(t){return!isNaN(t)&&!isFinite(t)}function rs(t,e,i,n){var a=1-t;return os(e[a])&&os(i[a])}function ss(t,e,i,n,a){var o,r=n.coordinateSystem,s=t.getItemModel(e),l=Pu.parsePercent(s.get(i[0]),a.getWidth()),h=Pu.parsePercent(s.get(i[1]),a.getHeight());if(isNaN(l)||isNaN(h)){if(n.getMarkerPosition)o=n.getMarkerPosition(t.getValues(i,e));else{var u=t.get(i[0],e),c=t.get(i[1],e);o=r.dataToPoint([u,c],!0)}if("cartesian2d"===r.type){var d=r.getAxis("x"),p=r.getAxis("y"),u=t.get(i[0],e),c=t.get(i[1],e);os(u)?o[0]=d.toGlobalCoord(d.getExtent()["x0"===i[0]?0:1]):os(c)&&(o[1]=p.toGlobalCoord(p.getExtent()["y0"===i[1]?0:1]))}isNaN(l)||(o[0]=l),isNaN(h)||(o[1]=h)}else o=[l,h];return o}function ls(t){var e=t.itemStyle||(t.itemStyle={}),i=e.emphasis||(e.emphasis={}),n=t.label||t.label||{},a=n.normal||(n.normal={}),o={normal:1,emphasis:1};rl.each(n,function(t,e){o[e]||hs(a,e)||(a[e]=t)}),i.label&&!hs(n,"emphasis")&&(n.emphasis=i.label,delete i.label)}function hs(t,e){return t.hasOwnProperty(e)}function us(t,e,i,n,a,o){var r=e.get("color");if(a)a.setColor(r),i.add(a),o&&o.onUpdate(a);else{var s=t.get("symbol");(a=YT(s,-1,-1,2,2,r)).setStyle("strokeNoScale",!0),i.add(a),o&&o.onCreate(a)}var l=e.getItemStyle(["color","symbol","symbolSize"]);a.setStyle(l),n=rl.merge({rectHover:!0,z2:100},n,!0);var h=t.get("symbolSize");(h=h instanceof Array?h.slice():[+h,+h])[0]/=2,h[1]/=2,n.scale=h;var u=t.get("symbolOffset");if(u){var c=n.position=n.position||[0,0];c[0]+=Pu.parsePercent(u[0],h[0]),c[1]+=Pu.parsePercent(u[1],h[1])}var d=t.get("symbolRotate");return n.rotation=(d||0)*Math.PI/180||0,a.attr(n),a.updateTransform(),a}function cs(t,e,i,n,a){if(!t.dragging){var o=n.getModel("checkpointStyle"),r=i.dataToCoord(n.getData().get(["value"],e));a||!o.get("animation",!0)?t.attr({position:[r,0]}):(t.stopAnimation(!0),t.animateTo({position:[r,0]},o.get("animationDuration",!0),o.get("animationEasing",!0)))}}function ds(t){this.model=t}function ps(t){this.model=t}function fs(t){return t.replace(/^\s\s*/,"").replace(/\s\s*$/,"")}function gs(t){this._dom=null,this.model=t}function ms(t){var e=t[cA];return e||(e=t[cA]=[{}]),e}function vs(t,e,i){(this._brushController=new jb(i.getZr())).on("brush",rl.bind(this._onBrush,this)).mount(),this._isZoomActive}function ys(t){var e={};return rl.each(["xAxisIndex","yAxisIndex"],function(i){e[i]=t[i],null==e[i]&&(e[i]="all"),(!1===e[i]||"none"===e[i])&&(e[i]=[])}),e}function xs(t){this.model=t}function _s(t){return parseInt(t,10)}function bs(t,e){MA.initVML(),this.root=t,this.storage=e;var i=document.createElement("div"),n=document.createElement("div");i.style.cssText="display:inline-block;overflow:hidden;position:relative;width:300px;height:150px;",n.style.cssText="position:absolute;left:0;top:0;",t.appendChild(i),this._vmlRoot=n,this._vmlViewport=i,this.resize();var a=e.delFromStorage,o=e.addToStorage;e.delFromStorage=function(t){a.call(e,t),t&&t.onRemove&&t.onRemove(n)},e.addToStorage=function(t){t.onAdd&&t.onAdd(n),o.call(e,t)},this._firstPaint=!0}function ws(t){return rC(1e4*t)/1e4}function Ss(t){return t<dC&&t>-dC}function Ms(t,e){e&&Is(t,"transform","matrix("+aC.call(e,",")+")")}function Is(t,e,i){(!i||"linear"!==i.type&&"radial"!==i.type)&&t.setAttribute(e,i)}function Ts(t,e,i){if(function(t,e){var i=e?t.textFill:t.fill;return null!=i&&i!==oC}(e,i)){var n=i?e.textFill:e.fill;n="transparent"===n?oC:n,"none"!==t.getAttribute("clip-path")&&n===oC&&(n="rgba(0, 0, 0, 0.002)"),Is(t,"fill",n),Is(t,"fill-opacity",e.opacity)}else Is(t,"fill",oC);if(function(t,e){var i=e?t.textStroke:t.stroke;return null!=i&&i!==oC}(e,i)){var a=i?e.textStroke:e.stroke;Is(t,"stroke",a="transparent"===a?oC:a);Is(t,"stroke-width",(i?e.textStrokeWidth:e.lineWidth)/(e.strokeNoScale?e.host.getLineScale():1)),Is(t,"paint-order","stroke"),Is(t,"stroke-opacity",e.opacity);e.lineDash?(Is(t,"stroke-dasharray",e.lineDash.join(",")),Is(t,"stroke-dashoffset",rC(e.lineDashOffset||0))):Is(t,"stroke-dasharray",""),e.lineCap&&Is(t,"stroke-linecap",e.lineCap),e.lineJoin&&Is(t,"stroke-linejoin",e.lineJoin),e.miterLimit&&Is(t,"stroke-miterlimit",e.miterLimit)}else Is(t,"stroke",oC)}function As(t){return"middle"===t?"middle":"bottom"===t?"baseline":"hanging"}function Cs(){}function Ls(t,e,i){this._svgRoot=t,this._tagNames="string"==typeof e?[e]:e,this._markLabel=i,this.nextId=0}function Ds(t){IC.call(this,t,["linearGradient","radialGradient"],"__gradient_in_use__")}function Ps(t){IC.call(this,t,"clipPath","__clippath_in_use__")}function ks(t){return parseInt(t,10)}function Os(t,e){return e&&t&&e.parentNode!==t}function zs(t,e,i){if(Os(t,e)&&i){var n=i.nextSibling;n?t.insertBefore(e,n):t.appendChild(e)}}function Es(t,e){if(Os(t,e)){var i=t.firstChild;i?t.insertBefore(e,i):t.appendChild(e)}}function Rs(t,e){e&&t&&e.parentNode===t&&t.removeChild(e)}function Ns(t){return t.__textSvgEl}function Vs(t){return t.__svgEl}function Bs(t){var e=typeof t;return!!t&&("object"==e||"function"==e)}function Gs(t){if("number"==typeof t)return t;if(function(t){return"symbol"==typeof t||function(t){return!!t&&"object"==typeof t}(t)&&UC.call(t)==NC}(t))return RC;if(Bs(t)){var e="function"==typeof t.valueOf?t.valueOf():t;t=Bs(e)?e+"":e}if("string"!=typeof t)return 0===t?t:+t;t=t.replace(VC,"");var i=GC.test(t);return i||HC.test(t)?WC(t.slice(2),i?2:8):BC.test(t)?RC:+t}t="default"in t?t.default:t;var Hs,Ws="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{};"undefined"!=typeof window?Hs=window.__DEV__:void 0!==Ws&&(Hs=Ws),void 0===Hs&&(Hs=!0);var Fs=2311,Zs=function(){return Fs++},js={},Us=js="undefined"==typeof navigator?{browser:{},os:{},node:!0,canvasSupported:!0,svgSupported:!0}:function(t){var e={},i=t.match(/Firefox\/([\d.]+)/),n=t.match(/MSIE\s([\d.]+)/)||t.match(/Trident\/.+?rv:(([\d.]+))/),a=t.match(/Edge\/([\d.]+)/),o=/micromessenger/i.test(t);return i&&(e.firefox=!0,e.version=i[1]),n&&(e.ie=!0,e.version=n[1]),a&&(e.edge=!0,e.version=a[1]),o&&(e.weChat=!0),{browser:e,os:{},node:!1,canvasSupported:!!document.createElement("canvas").getContext,svgSupported:"undefined"!=typeof SVGRect,touchEventsSupported:"ontouchstart"in window&&!e.ie&&!e.edge,pointerEventsSupported:"onpointerdown"in window&&(e.edge||e.ie&&e.version>=11)}}(navigator.userAgent),qs={"[object Function]":1,"[object RegExp]":1,"[object Date]":1,"[object Error]":1,"[object CanvasGradient]":1,"[object CanvasPattern]":1,"[object Image]":1,"[object Canvas]":1},Xs={"[object Int8Array]":1,"[object Uint8Array]":1,"[object Uint8ClampedArray]":1,"[object Int16Array]":1,"[object Uint16Array]":1,"[object Int32Array]":1,"[object Uint32Array]":1,"[object Float32Array]":1,"[object Float64Array]":1},Ys=Object.prototype.toString,$s=Array.prototype,Ks=$s.forEach,Js=$s.filter,Qs=$s.slice,tl=$s.map,el=$s.reduce,il={},nl=function(){return il.createCanvas()};il.createCanvas=function(){return document.createElement("canvas")};var al,ol="__ec_primitive__";d.prototype={constructor:d,get:function(t){return this["_ec_"+t]},set:function(t,e){return this["_ec_"+t]=e,e},each:function(t,e){void 0!==e&&(t=r(t,e));for(var i in this)this.hasOwnProperty(i)&&t(this[i],i.slice(4))},removeKey:function(t){delete this["_ec_"+t]}};var rl={$override:function(t,e){il[t]=e},clone:i,merge:n,mergeAll:function(t,e){for(var i=t[0],a=1,o=t.length;a<o;a++)i=n(i,t[a],e);return i},extend:function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i]);return t},defaults:a,createCanvas:nl,getContext:function(){return al||(al=nl().getContext("2d")),al},indexOf:function(t,e){if(t){if(t.indexOf)return t.indexOf(e);for(var i=0,n=t.length;i<n;i++)if(t[i]===e)return i}return-1},inherits:function(t,e){function i(){}var n=t.prototype;i.prototype=e.prototype,t.prototype=new i;for(var a in n)t.prototype[a]=n[a];t.prototype.constructor=t,t.superClass=e},mixin:function(t,e,i){a(t="prototype"in t?t.prototype:t,e="prototype"in e?e.prototype:e,i)},isArrayLike:function(t){if(t)return"string"!=typeof t&&"number"==typeof t.length},each:o,map:function(t,e,i){if(t&&e){if(t.map&&t.map===tl)return t.map(e,i);for(var n=[],a=0,o=t.length;a<o;a++)n.push(e.call(i,t[a],a,t));return n}},reduce:function(t,e,i,n){if(t&&e){if(t.reduce&&t.reduce===el)return t.reduce(e,i,n);for(var a=0,o=t.length;a<o;a++)i=e.call(n,i,t[a],a,t);return i}},filter:function(t,e,i){if(t&&e){if(t.filter&&t.filter===Js)return t.filter(e,i);for(var n=[],a=0,o=t.length;a<o;a++)e.call(i,t[a],a,t)&&n.push(t[a]);return n}},find:function(t,e,i){if(t&&e)for(var n=0,a=t.length;n<a;n++)if(e.call(i,t[n],n,t))return t[n]},bind:r,curry:function(t){var e=Qs.call(arguments,1);return function(){return t.apply(this,e.concat(Qs.call(arguments)))}},isArray:s,isFunction:function(t){return"function"==typeof t},isString:function(t){return"[object String]"===Ys.call(t)},isObject:l,isBuiltInObject:h,isDom:u,eqNaN:function(t){return t!=t},retrieve:function(t){for(var e=arguments,i=0,n=arguments.length;i<n;i++)if(null!=e[i])return e[i]},retrieve2:function(t,e){return null!=t?t:e},retrieve3:function(t,e,i){return null!=t?t:null!=e?e:i},slice:function(){return Function.call.apply(Qs,arguments)},normalizeCssArray:function(t){if("number"==typeof t)return[t,t,t,t];var e=t.length;return 2===e?[t[0],t[1],t[0],t[1]]:3===e?[t[0],t[1],t[2],t[1]]:t},assert:function(t,e){if(!t)throw new Error(e)},setAsPrimitive:function(t){t[ol]=!0},isPrimitive:c,createHashMap:function(t){return new d(t)},noop:function(){}},sl="undefined"==typeof Float32Array?Array:Float32Array,ll={create:function(t,e){var i=new sl(2);return null==t&&(t=0),null==e&&(e=0),i[0]=t,i[1]=e,i},copy:function(t,e){return t[0]=e[0],t[1]=e[1],t},clone:function(t){var e=new sl(2);return e[0]=t[0],e[1]=t[1],e},set:function(t,e,i){return t[0]=e,t[1]=i,t},add:function(t,e,i){return t[0]=e[0]+i[0],t[1]=e[1]+i[1],t},scaleAndAdd:function(t,e,i,n){return t[0]=e[0]+i[0]*n,t[1]=e[1]+i[1]*n,t},sub:function(t,e,i){return t[0]=e[0]-i[0],t[1]=e[1]-i[1],t},len:p,length:p,lenSquare:f,lengthSquare:f,mul:function(t,e,i){return t[0]=e[0]*i[0],t[1]=e[1]*i[1],t},div:function(t,e,i){return t[0]=e[0]/i[0],t[1]=e[1]/i[1],t},dot:function(t,e){return t[0]*e[0]+t[1]*e[1]},scale:function(t,e,i){return t[0]=e[0]*i,t[1]=e[1]*i,t},normalize:function(t,e){var i=p(e);return 0===i?(t[0]=0,t[1]=0):(t[0]=e[0]/i,t[1]=e[1]/i),t},distance:g,dist:g,distanceSquare:m,distSquare:m,negate:function(t,e){return t[0]=-e[0],t[1]=-e[1],t},lerp:function(t,e,i,n){return t[0]=e[0]+n*(i[0]-e[0]),t[1]=e[1]+n*(i[1]-e[1]),t},applyTransform:function(t,e,i){var n=e[0],a=e[1];return t[0]=i[0]*n+i[2]*a+i[4],t[1]=i[1]*n+i[3]*a+i[5],t},min:function(t,e,i){return t[0]=Math.min(e[0],i[0]),t[1]=Math.min(e[1],i[1]),t},max:function(t,e,i){return t[0]=Math.max(e[0],i[0]),t[1]=Math.max(e[1],i[1]),t}};v.prototype={constructor:v,_dragStart:function(t){var e=t.target;e&&e.draggable&&(this._draggingTarget=e,e.dragging=!0,this._x=t.offsetX,this._y=t.offsetY,this.dispatchToElement(y(e,t),"dragstart",t.event))},_drag:function(t){var e=this._draggingTarget;if(e){var i=t.offsetX,n=t.offsetY,a=i-this._x,o=n-this._y;this._x=i,this._y=n,e.drift(a,o,t),this.dispatchToElement(y(e,t),"drag",t.event);var r=this.findHover(i,n,e).target,s=this._dropTarget;this._dropTarget=r,e!==r&&(s&&r!==s&&this.dispatchToElement(y(s,t),"dragleave",t.event),r&&r!==s&&this.dispatchToElement(y(r,t),"dragenter",t.event))}},_dragEnd:function(t){var e=this._draggingTarget;e&&(e.dragging=!1),this.dispatchToElement(y(e,t),"dragend",t.event),this._dropTarget&&this.dispatchToElement(y(this._dropTarget,t),"drop",t.event),this._draggingTarget=null,this._dropTarget=null}};var hl=v,ul=Array.prototype.slice,cl=function(){this._$handlers={}};cl.prototype={constructor:cl,one:function(t,e,i){var n=this._$handlers;if(!e||!t)return this;n[t]||(n[t]=[]);for(var a=0;a<n[t].length;a++)if(n[t][a].h===e)return this;return n[t].push({h:e,one:!0,ctx:i||this}),this},on:function(t,e,i){var n=this._$handlers;if(!e||!t)return this;n[t]||(n[t]=[]);for(var a=0;a<n[t].length;a++)if(n[t][a].h===e)return this;return n[t].push({h:e,one:!1,ctx:i||this}),this},isSilent:function(t){var e=this._$handlers;return e[t]&&e[t].length},off:function(t,e){var i=this._$handlers;if(!t)return this._$handlers={},this;if(e){if(i[t]){for(var n=[],a=0,o=i[t].length;a<o;a++)i[t][a].h!=e&&n.push(i[t][a]);i[t]=n}i[t]&&0===i[t].length&&delete i[t]}else delete i[t];return this},trigger:function(t){if(this._$handlers[t]){var e=arguments,i=e.length;i>3&&(e=ul.call(e,1));for(var n=this._$handlers[t],a=n.length,o=0;o<a;){switch(i){case 1:n[o].h.call(n[o].ctx);break;case 2:n[o].h.call(n[o].ctx,e[1]);break;case 3:n[o].h.call(n[o].ctx,e[1],e[2]);break;default:n[o].h.apply(n[o].ctx,e)}n[o].one?(n.splice(o,1),a--):o++}}return this},triggerWithContext:function(t){if(this._$handlers[t]){var e=arguments,i=e.length;i>4&&(e=ul.call(e,1,e.length-1));for(var n=e[e.length-1],a=this._$handlers[t],o=a.length,r=0;r<o;){switch(i){case 1:a[r].h.call(n);break;case 2:a[r].h.call(n,e[1]);break;case 3:a[r].h.call(n,e[1],e[2]);break;default:a[r].h.apply(n,e)}a[r].one?(a.splice(r,1),o--):r++}}return this}};var dl=cl,pl="silent";x.prototype.dispose=function(){};var fl=["click","dblclick","mousewheel","mouseout","mouseup","mousedown","mousemove","contextmenu"],gl=function(t,e,i,n){dl.call(this),this.storage=t,this.painter=e,this.painterRoot=n,i=i||new x,this.proxy=i,i.handler=this,this._hovered={},this._lastTouchMoment,this._lastX,this._lastY,hl.call(this),rl.each(fl,function(t){i.on&&i.on(t,this[t],this)},this)};gl.prototype={constructor:gl,mousemove:function(t){var e=t.zrX,i=t.zrY,n=this._hovered,a=n.target;a&&!a.__zr&&(a=(n=this.findHover(n.x,n.y)).target);var o=this._hovered=this.findHover(e,i),r=o.target,s=this.proxy;s.setCursor&&s.setCursor(r?r.cursor:"default"),a&&r!==a&&this.dispatchToElement(n,"mouseout",t),this.dispatchToElement(o,"mousemove",t),r&&r!==a&&this.dispatchToElement(o,"mouseover",t)},mouseout:function(t){this.dispatchToElement(this._hovered,"mouseout",t);var e,i=t.toElement||t.relatedTarget;do{i=i&&i.parentNode}while(i&&9!=i.nodeType&&!(e=i===this.painterRoot));!e&&this.trigger("globalout",{event:t})},resize:function(t){this._hovered={}},dispatch:function(t,e){var i=this[t];i&&i.call(this,e)},dispose:function(){this.proxy.dispose(),this.storage=this.proxy=this.painter=null},setCursorStyle:function(t){var e=this.proxy;e.setCursor&&e.setCursor(t)},dispatchToElement:function(t,e,i){var n=(t=t||{}).target;if(!n||!n.silent){for(var a="on"+e,o=function(t,e,i){return{type:t,event:i,target:e.target,topTarget:e.topTarget,cancelBubble:!1,offsetX:i.zrX,offsetY:i.zrY,gestureEvent:i.gestureEvent,pinchX:i.pinchX,pinchY:i.pinchY,pinchScale:i.pinchScale,wheelDelta:i.zrDelta,zrByTouch:i.zrByTouch,which:i.which}}(e,t,i);n&&(n[a]&&(o.cancelBubble=n[a].call(n,o)),n.trigger(e,o),n=n.parent,!o.cancelBubble););o.cancelBubble||(this.trigger(e,o),this.painter&&this.painter.eachOtherLayer(function(t){"function"==typeof t[a]&&t[a].call(t,o),t.trigger&&t.trigger(e,o)}))}},findHover:function(t,e,i){for(var n=this.storage.getDisplayList(),a={x:t,y:e},o=n.length-1;o>=0;o--){var r;if(n[o]!==i&&!n[o].ignore&&(r=function(t,e,i){if(t[t.rectHover?"rectContain":"contain"](e,i)){for(var n,a=t;a;){if(a.clipPath&&!a.clipPath.contain(e,i))return!1;a.silent&&(n=!0),a=a.parent}return!n||pl}return!1}(n[o],t,e))&&(!a.topTarget&&(a.topTarget=n[o]),r!==pl)){a.target=n[o];break}}return a}},rl.each(["click","mousedown","mouseup","mousewheel","dblclick","contextmenu"],function(t){gl.prototype[t]=function(e){var i=this.findHover(e.zrX,e.zrY),n=i.target;if("mousedown"===t)this._downEl=n,this._downPoint=[e.zrX,e.zrY],this._upEl=n;else if("mosueup"===t)this._upEl=n;else if("click"===t){if(this._downEl!==this._upEl||!this._downPoint||ll.dist(this._downPoint,[e.zrX,e.zrY])>4)return;this._downPoint=null}this.dispatchToElement(i,t,e)}}),rl.mixin(gl,dl),rl.mixin(gl,hl);var ml=gl,vl="undefined"==typeof Float32Array?Array:Float32Array,yl={create:function(){var t=new vl(6);return _(t),t},identity:_,copy:function(t,e){return t[0]=e[0],t[1]=e[1],t[2]=e[2],t[3]=e[3],t[4]=e[4],t[5]=e[5],t},mul:function(t,e,i){var n=e[0]*i[0]+e[2]*i[1],a=e[1]*i[0]+e[3]*i[1],o=e[0]*i[2]+e[2]*i[3],r=e[1]*i[2]+e[3]*i[3],s=e[0]*i[4]+e[2]*i[5]+e[4],l=e[1]*i[4]+e[3]*i[5]+e[5];return t[0]=n,t[1]=a,t[2]=o,t[3]=r,t[4]=s,t[5]=l,t},translate:function(t,e,i){return t[0]=e[0],t[1]=e[1],t[2]=e[2],t[3]=e[3],t[4]=e[4]+i[0],t[5]=e[5]+i[1],t},rotate:function(t,e,i){var n=e[0],a=e[2],o=e[4],r=e[1],s=e[3],l=e[5],h=Math.sin(i),u=Math.cos(i);return t[0]=n*u+r*h,t[1]=-n*h+r*u,t[2]=a*u+s*h,t[3]=-a*h+u*s,t[4]=u*o+h*l,t[5]=u*l-h*o,t},scale:function(t,e,i){var n=i[0],a=i[1];return t[0]=e[0]*n,t[1]=e[1]*a,t[2]=e[2]*n,t[3]=e[3]*a,t[4]=e[4]*n,t[5]=e[5]*a,t},invert:function(t,e){var i=e[0],n=e[2],a=e[4],o=e[1],r=e[3],s=e[5],l=i*r-o*n;return l?(l=1/l,t[0]=r*l,t[1]=-o*l,t[2]=-n*l,t[3]=i*l,t[4]=(n*s-r*a)*l,t[5]=(o*a-i*s)*l,t):null}},xl=yl.identity,_l=5e-5,bl=function(t){(t=t||{}).position||(this.position=[0,0]),null==t.rotation&&(this.rotation=0),t.scale||(this.scale=[1,1]),this.origin=this.origin||null},wl=bl.prototype;wl.transform=null,wl.needLocalTransform=function(){return b(this.rotation)||b(this.position[0])||b(this.position[1])||b(this.scale[0]-1)||b(this.scale[1]-1)},wl.updateTransform=function(){var t=this.parent,e=t&&t.transform,i=this.needLocalTransform(),n=this.transform;i||e?(n=n||yl.create(),i?this.getLocalTransform(n):xl(n),e&&(i?yl.mul(n,t.transform,n):yl.copy(n,t.transform)),this.transform=n,this.invTransform=this.invTransform||yl.create(),yl.invert(this.invTransform,n)):n&&xl(n)},wl.getLocalTransform=function(t){return bl.getLocalTransform(this,t)},wl.setTransform=function(t){var e=this.transform,i=t.dpr||1;e?t.setTransform(i*e[0],i*e[1],i*e[2],i*e[3],i*e[4],i*e[5]):t.setTransform(i,0,0,i,0,0)},wl.restoreTransform=function(t){var e=t.dpr||1;t.setTransform(e,0,0,e,0,0)};var Sl=[];wl.decomposeTransform=function(){if(this.transform){var t=this.parent,e=this.transform;t&&t.transform&&(yl.mul(Sl,t.invTransform,e),e=Sl);var i=e[0]*e[0]+e[1]*e[1],n=e[2]*e[2]+e[3]*e[3],a=this.position,o=this.scale;b(i-1)&&(i=Math.sqrt(i)),b(n-1)&&(n=Math.sqrt(n)),e[0]<0&&(i=-i),e[3]<0&&(n=-n),a[0]=e[4],a[1]=e[5],o[0]=i,o[1]=n,this.rotation=Math.atan2(-e[1]/n,e[0]/i)}},wl.getGlobalScale=function(){var t=this.transform;if(!t)return[1,1];var e=Math.sqrt(t[0]*t[0]+t[1]*t[1]),i=Math.sqrt(t[2]*t[2]+t[3]*t[3]);return t[0]<0&&(e=-e),t[3]<0&&(i=-i),[e,i]},wl.transformCoordToLocal=function(t,e){var i=[t,e],n=this.invTransform;return n&&ll.applyTransform(i,i,n),i},wl.transformCoordToGlobal=function(t,e){var i=[t,e],n=this.transform;return n&&ll.applyTransform(i,i,n),i},bl.getLocalTransform=function(t,e){xl(e=e||[]);var i=t.origin,n=t.scale||[1,1],a=t.rotation||0,o=t.position||[0,0];return i&&(e[4]-=i[0],e[5]-=i[1]),yl.scale(e,e,n),a&&yl.rotate(e,e,a),i&&(e[4]+=i[0],e[5]+=i[1]),e[4]+=o[0],e[5]+=o[1],e};var Ml=bl,Il={linear:function(t){return t},quadraticIn:function(t){return t*t},quadraticOut:function(t){return t*(2-t)},quadraticInOut:function(t){return(t*=2)<1?.5*t*t:-.5*(--t*(t-2)-1)},cubicIn:function(t){return t*t*t},cubicOut:function(t){return--t*t*t+1},cubicInOut:function(t){return(t*=2)<1?.5*t*t*t:.5*((t-=2)*t*t+2)},quarticIn:function(t){return t*t*t*t},quarticOut:function(t){return 1- --t*t*t*t},quarticInOut:function(t){return(t*=2)<1?.5*t*t*t*t:-.5*((t-=2)*t*t*t-2)},quinticIn:function(t){return t*t*t*t*t},quinticOut:function(t){return--t*t*t*t*t+1},quinticInOut:function(t){return(t*=2)<1?.5*t*t*t*t*t:.5*((t-=2)*t*t*t*t+2)},sinusoidalIn:function(t){return 1-Math.cos(t*Math.PI/2)},sinusoidalOut:function(t){return Math.sin(t*Math.PI/2)},sinusoidalInOut:function(t){return.5*(1-Math.cos(Math.PI*t))},exponentialIn:function(t){return 0===t?0:Math.pow(1024,t-1)},exponentialOut:function(t){return 1===t?1:1-Math.pow(2,-10*t)},exponentialInOut:function(t){return 0===t?0:1===t?1:(t*=2)<1?.5*Math.pow(1024,t-1):.5*(2-Math.pow(2,-10*(t-1)))},circularIn:function(t){return 1-Math.sqrt(1-t*t)},circularOut:function(t){return Math.sqrt(1- --t*t)},circularInOut:function(t){return(t*=2)<1?-.5*(Math.sqrt(1-t*t)-1):.5*(Math.sqrt(1-(t-=2)*t)+1)},elasticIn:function(t){var e,i=.1;return 0===t?0:1===t?1:(!i||i<1?(i=1,e=.1):e=.4*Math.asin(1/i)/(2*Math.PI),-i*Math.pow(2,10*(t-=1))*Math.sin((t-e)*(2*Math.PI)/.4))},elasticOut:function(t){var e,i=.1;return 0===t?0:1===t?1:(!i||i<1?(i=1,e=.1):e=.4*Math.asin(1/i)/(2*Math.PI),i*Math.pow(2,-10*t)*Math.sin((t-e)*(2*Math.PI)/.4)+1)},elasticInOut:function(t){var e,i=.1;return 0===t?0:1===t?1:(!i||i<1?(i=1,e=.1):e=.4*Math.asin(1/i)/(2*Math.PI),(t*=2)<1?i*Math.pow(2,10*(t-=1))*Math.sin((t-e)*(2*Math.PI)/.4)*-.5:i*Math.pow(2,-10*(t-=1))*Math.sin((t-e)*(2*Math.PI)/.4)*.5+1)},backIn:function(t){var e=1.70158;return t*t*((e+1)*t-e)},backOut:function(t){var e=1.70158;return--t*t*((e+1)*t+e)+1},backInOut:function(t){var e=2.5949095;return(t*=2)<1?t*t*((e+1)*t-e)*.5:.5*((t-=2)*t*((e+1)*t+e)+2)},bounceIn:function(t){return 1-Il.bounceOut(1-t)},bounceOut:function(t){return t<1/2.75?7.5625*t*t:t<2/2.75?7.5625*(t-=1.5/2.75)*t+.75:t<2.5/2.75?7.5625*(t-=2.25/2.75)*t+.9375:7.5625*(t-=2.625/2.75)*t+.984375},bounceInOut:function(t){return t<.5?.5*Il.bounceIn(2*t):.5*Il.bounceOut(2*t-1)+.5}},Tl=Il;w.prototype={constructor:w,step:function(t,e){if(this._initialized||(this._startTime=t+this._delay,this._initialized=!0),this._paused)this._pausedTime+=e;else{var i=(t-this._startTime-this._pausedTime)/this._life;if(!(i<0)){i=Math.min(i,1);var n=this.easing,a="string"==typeof n?Tl[n]:n,o="function"==typeof a?a(i):i;return this.fire("frame",o),1==i?this.loop?(this.restart(t),"restart"):(this._needsRemove=!0,"destroy"):null}}},restart:function(t){var e=(t-this._startTime-this._pausedTime)%this._life;this._startTime=t-e+this.gap,this._pausedTime=0,this._needsRemove=!1},fire:function(t,e){this[t="on"+t]&&this[t](this._target,e)},pause:function(){this._paused=!0},resume:function(){this._paused=!1}};var Al=w,Cl=function(){this.head=null,this.tail=null,this._len=0},Ll=Cl.prototype;Ll.insert=function(t){var e=new Dl(t);return this.insertEntry(e),e},Ll.insertEntry=function(t){this.head?(this.tail.next=t,t.prev=this.tail,t.next=null,this.tail=t):this.head=this.tail=t,this._len++},Ll.remove=function(t){var e=t.prev,i=t.next;e?e.next=i:this.head=i,i?i.prev=e:this.tail=e,t.next=t.prev=null,this._len--},Ll.len=function(){return this._len},Ll.clear=function(){this.head=this.tail=null,this._len=0};var Dl=function(t){this.value=t,this.next,this.prev},Pl=function(t){this._list=new Cl,this._map={},this._maxSize=t||10,this._lastRemovedEntry=null},kl=Pl.prototype;kl.put=function(t,e){var i=this._list,n=this._map,a=null;if(null==n[t]){var o=i.len(),r=this._lastRemovedEntry;if(o>=this._maxSize&&o>0){var s=i.head;i.remove(s),delete n[s.key],a=s.value,this._lastRemovedEntry=s}r?r.value=e:r=new Dl(e),r.key=t,i.insertEntry(r),n[t]=r}return a},kl.get=function(t){var e=this._map[t],i=this._list;if(null!=e)return e!==i.tail&&(i.remove(e),i.insertEntry(e)),e.value},kl.clear=function(){this._list.clear(),this._map={}};var Ol=Pl,zl={transparent:[0,0,0,0],aliceblue:[240,248,255,1],antiquewhite:[250,235,215,1],aqua:[0,255,255,1],aquamarine:[127,255,212,1],azure:[240,255,255,1],beige:[245,245,220,1],bisque:[255,228,196,1],black:[0,0,0,1],blanchedalmond:[255,235,205,1],blue:[0,0,255,1],blueviolet:[138,43,226,1],brown:[165,42,42,1],burlywood:[222,184,135,1],cadetblue:[95,158,160,1],chartreuse:[127,255,0,1],chocolate:[210,105,30,1],coral:[255,127,80,1],cornflowerblue:[100,149,237,1],cornsilk:[255,248,220,1],crimson:[220,20,60,1],cyan:[0,255,255,1],darkblue:[0,0,139,1],darkcyan:[0,139,139,1],darkgoldenrod:[184,134,11,1],darkgray:[169,169,169,1],darkgreen:[0,100,0,1],darkgrey:[169,169,169,1],darkkhaki:[189,183,107,1],darkmagenta:[139,0,139,1],darkolivegreen:[85,107,47,1],darkorange:[255,140,0,1],darkorchid:[153,50,204,1],darkred:[139,0,0,1],darksalmon:[233,150,122,1],darkseagreen:[143,188,143,1],darkslateblue:[72,61,139,1],darkslategray:[47,79,79,1],darkslategrey:[47,79,79,1],darkturquoise:[0,206,209,1],darkviolet:[148,0,211,1],deeppink:[255,20,147,1],deepskyblue:[0,191,255,1],dimgray:[105,105,105,1],dimgrey:[105,105,105,1],dodgerblue:[30,144,255,1],firebrick:[178,34,34,1],floralwhite:[255,250,240,1],forestgreen:[34,139,34,1],fuchsia:[255,0,255,1],gainsboro:[220,220,220,1],ghostwhite:[248,248,255,1],gold:[255,215,0,1],goldenrod:[218,165,32,1],gray:[128,128,128,1],green:[0,128,0,1],greenyellow:[173,255,47,1],grey:[128,128,128,1],honeydew:[240,255,240,1],hotpink:[255,105,180,1],indianred:[205,92,92,1],indigo:[75,0,130,1],ivory:[255,255,240,1],khaki:[240,230,140,1],lavender:[230,230,250,1],lavenderblush:[255,240,245,1],lawngreen:[124,252,0,1],lemonchiffon:[255,250,205,1],lightblue:[173,216,230,1],lightcoral:[240,128,128,1],lightcyan:[224,255,255,1],lightgoldenrodyellow:[250,250,210,1],lightgray:[211,211,211,1],lightgreen:[144,238,144,1],lightgrey:[211,211,211,1],lightpink:[255,182,193,1],lightsalmon:[255,160,122,1],lightseagreen:[32,178,170,1],lightskyblue:[135,206,250,1],lightslategray:[119,136,153,1],lightslategrey:[119,136,153,1],lightsteelblue:[176,196,222,1],lightyellow:[255,255,224,1],lime:[0,255,0,1],limegreen:[50,205,50,1],linen:[250,240,230,1],magenta:[255,0,255,1],maroon:[128,0,0,1],mediumaquamarine:[102,205,170,1],mediumblue:[0,0,205,1],mediumorchid:[186,85,211,1],mediumpurple:[147,112,219,1],mediumseagreen:[60,179,113,1],mediumslateblue:[123,104,238,1],mediumspringgreen:[0,250,154,1],mediumturquoise:[72,209,204,1],mediumvioletred:[199,21,133,1],midnightblue:[25,25,112,1],mintcream:[245,255,250,1],mistyrose:[255,228,225,1],moccasin:[255,228,181,1],navajowhite:[255,222,173,1],navy:[0,0,128,1],oldlace:[253,245,230,1],olive:[128,128,0,1],olivedrab:[107,142,35,1],orange:[255,165,0,1],orangered:[255,69,0,1],orchid:[218,112,214,1],palegoldenrod:[238,232,170,1],palegreen:[152,251,152,1],paleturquoise:[175,238,238,1],palevioletred:[219,112,147,1],papayawhip:[255,239,213,1],peachpuff:[255,218,185,1],peru:[205,133,63,1],pink:[255,192,203,1],plum:[221,160,221,1],powderblue:[176,224,230,1],purple:[128,0,128,1],red:[255,0,0,1],rosybrown:[188,143,143,1],royalblue:[65,105,225,1],saddlebrown:[139,69,19,1],salmon:[250,128,114,1],sandybrown:[244,164,96,1],seagreen:[46,139,87,1],seashell:[255,245,238,1],sienna:[160,82,45,1],silver:[192,192,192,1],skyblue:[135,206,235,1],slateblue:[106,90,205,1],slategray:[112,128,144,1],slategrey:[112,128,144,1],snow:[255,250,250,1],springgreen:[0,255,127,1],steelblue:[70,130,180,1],tan:[210,180,140,1],teal:[0,128,128,1],thistle:[216,191,216,1],tomato:[255,99,71,1],turquoise:[64,224,208,1],violet:[238,130,238,1],wheat:[245,222,179,1],white:[255,255,255,1],whitesmoke:[245,245,245,1],yellow:[255,255,0,1],yellowgreen:[154,205,50,1]},El=new Ol(20),Rl=null,Nl={parse:k,lift:function(t,e){var i=k(t);if(i){for(var n=0;n<3;n++)i[n]=e<0?i[n]*(1-e)|0:(255-i[n])*e+i[n]|0;return R(i,4===i.length?"rgba":"rgb")}},toHex:function(t){var e=k(t);if(e)return((1<<24)+(e[0]<<16)+(e[1]<<8)+ +e[2]).toString(16).slice(1)},fastLerp:z,fastMapToColor:z,lerp:E,mapToColor:E,modifyHSL:function(t,e,i,n){if(t=k(t))return t=function(t){if(t){var e,i,n=t[0]/255,a=t[1]/255,o=t[2]/255,r=Math.min(n,a,o),s=Math.max(n,a,o),l=s-r,h=(s+r)/2;if(0===l)e=0,i=0;else{i=h<.5?l/(s+r):l/(2-s-r);var u=((s-n)/6+l/2)/l,c=((s-a)/6+l/2)/l,d=((s-o)/6+l/2)/l;n===s?e=d-c:a===s?e=1/3+u-d:o===s&&(e=2/3+c-u),e<0&&(e+=1),e>1&&(e-=1)}var p=[360*e,i,h];return null!=t[3]&&p.push(t[3]),p}}(t),null!=e&&(t[0]=function(t){return(t=Math.round(t))<0?0:t>360?360:t}(e)),null!=i&&(t[1]=T(i)),null!=n&&(t[2]=T(n)),R(O(t),"rgba")},modifyAlpha:function(t,e){if((t=k(t))&&null!=e)return t[3]=M(e),R(t,"rgba")},stringify:R},Vl=rl.isArrayLike,Bl=Array.prototype.slice,Gl=function(t,e,i,n){this._tracks={},this._target=t,this._loop=e||!1,this._getter=i||function(t,e){return t[e]},this._setter=n||function(t,e,i){t[e]=i},this._clipCount=0,this._delay=0,this._doneList=[],this._onframeList=[],this._clipList=[]};Gl.prototype={when:function(t,e){var i=this._tracks;for(var n in e)if(e.hasOwnProperty(n)){if(!i[n]){i[n]=[];var a=this._getter(this._target,n);if(null==a)continue;0!==t&&i[n].push({time:0,value:function(t){if(Vl(t)){var e=t.length;if(Vl(t[0])){for(var i=[],n=0;n<e;n++)i.push(Bl.call(t[n]));return i}return Bl.call(t)}return t}(a)})}i[n].push({time:t,value:e[n]})}return this},during:function(t){return this._onframeList.push(t),this},pause:function(){for(var t=0;t<this._clipList.length;t++)this._clipList[t].pause();this._paused=!0},resume:function(){for(var t=0;t<this._clipList.length;t++)this._clipList[t].resume();this._paused=!1},isPaused:function(){return!!this._paused},_doneCallback:function(){this._tracks={},this._clipList.length=0;for(var t=this._doneList,e=t.length,i=0;i<e;i++)t[i].call(this)},start:function(t,e){var i,n=this,a=0;for(var o in this._tracks)if(this._tracks.hasOwnProperty(o)){var r=function(t,e,i,n,a,o){var r=t._getter,s=t._setter,l="spline"===e,h=n.length;if(h){var u,c=n[0].value,d=Vl(c),p=!1,f=!1,g=d?function(t){var e=t[t.length-1].value;return Vl(e&&e[0])?2:1}(n):0;n.sort(function(t,e){return t.time-e.time}),u=n[h-1].time;for(var m=[],v=[],y=n[0].value,x=!0,_=0;_<h;_++){m.push(n[_].time/u);var b=n[_].value;if(d&&function(t,e,i){if(t===e)return!0;var n=t.length;if(n!==e.length)return!1;if(1===i){for(o=0;o<n;o++)if(t[o]!==e[o])return!1}else for(var a=t[0].length,o=0;o<n;o++)for(var r=0;r<a;r++)if(t[o][r]!==e[o][r])return!1;return!0}(b,y,g)||!d&&b===y||(x=!1),y=b,"string"==typeof b){var w=Nl.parse(b);w?(b=w,p=!0):f=!0}v.push(b)}if(o||!x){for(var S=v[h-1],_=0;_<h-1;_++)d?G(v[_],S,g):!isNaN(v[_])||isNaN(S)||f||p||(v[_]=S);d&&G(r(t._target,a),S,g);var M,I,T,A,C,L,D=0,P=0;if(p)var k=[0,0,0,0];var O=new Al({target:t._target,life:u,loop:t._loop,delay:t._delay,onframe:function(t,e){var i;if(e<0)i=0;else if(e<P){for(i=M=Math.min(D+1,h-1);i>=0&&!(m[i]<=e);i--);i=Math.min(i,h-2)}else{for(i=D;i<h&&!(m[i]>e);i++);i=Math.min(i-1,h-2)}D=i,P=e;var n=m[i+1]-m[i];if(0!==n)if(I=(e-m[i])/n,l)if(A=v[i],T=v[0===i?i:i-1],C=v[i>h-2?h-1:i+1],L=v[i>h-3?h-1:i+2],d)H(T,A,C,L,I,I*I,I*I*I,r(t,a),g);else{if(p)o=H(T,A,C,L,I,I*I,I*I*I,k,1),o=F(k);else{if(f)return V(A,C,I);o=W(T,A,C,L,I,I*I,I*I*I)}s(t,a,o)}else if(d)B(v[i],v[i+1],I,r(t,a),g);else{var o;if(p)B(v[i],v[i+1],I,k,1),o=F(k);else{if(f)return V(v[i],v[i+1],I);o=N(v[i],v[i+1],I)}s(t,a,o)}},ondestroy:i});return e&&"spline"!==e&&(O.easing=e),O}}}(this,t,function(){--a||n._doneCallback()},this._tracks[o],o,e);r&&(this._clipList.push(r),a++,this.animation&&this.animation.addClip(r),i=r)}if(i){var s=i.onframe;i.onframe=function(t,e){s(t,e);for(var i=0;i<n._onframeList.length;i++)n._onframeList[i](t,e)}}return a||this._doneCallback(),this},stop:function(t){for(var e=this._clipList,i=this.animation,n=0;n<e.length;n++){var a=e[n];t&&a.onframe(this._target,1),i&&i.removeClip(a)}e.length=0},delay:function(t){return this._delay=t,this},done:function(t){return t&&this._doneList.push(t),this},getClips:function(){return this._clipList}};var Hl=Gl,Wl=1;"undefined"!=typeof window&&(Wl=Math.max(window.devicePixelRatio||1,1));var Fl={debugMode:0,devicePixelRatio:Wl},Zl=Fl.debugMode,jl=function(){};1===Zl?jl=function(){var t=arguments;for(var e in arguments)throw new Error(t[e])}:Zl>1&&(jl=function(){var t=arguments;for(var e in arguments)console.log(t[e])});var Ul=jl,ql=rl.isString,Xl=rl.isFunction,Yl=rl.isObject,$l=rl.isArrayLike,Kl=rl.indexOf,Jl=function(){this.animators=[]};Jl.prototype={constructor:Jl,animate:function(t,e){var i,n=!1,a=this,o=this.__zr;if(t){var r=t.split("."),s=a;n="shape"===r[0];for(var l=0,h=r.length;l<h;l++)s&&(s=s[r[l]]);s&&(i=s)}else i=a;if(i){var u=a.animators,c=new Hl(i,e);return c.during(function(t){a.dirty(n)}).done(function(){u.splice(Kl(u,c),1)}),u.push(c),o&&o.animation.addAnimator(c),c}Ul('Property "'+t+'" is not existed in element '+a.id)},stopAnimation:function(t){for(var e=this.animators,i=e.length,n=0;n<i;n++)e[n].stop(t);return e.length=0,this},animateTo:function(t,e,i,n,a,o){ql(i)?(a=n,n=i,i=0):Xl(n)?(a=n,n="linear",i=0):Xl(i)?(a=i,i=0):Xl(e)?(a=e,e=500):e||(e=500),this.stopAnimation(),this._animateToShallow("",this,t,e,i);var r=this.animators.slice(),s=r.length;s||a&&a();for(var l=0;l<r.length;l++)r[l].done(function(){--s||a&&a()}).start(n,o)},_animateToShallow:function(t,e,i,n,a){var o={},r=0;for(var s in i)if(i.hasOwnProperty(s))if(null!=e[s])Yl(i[s])&&!$l(i[s])?this._animateToShallow(t?t+"."+s:s,e[s],i[s],n,a):(o[s]=i[s],r++);else if(null!=i[s])if(t){var l={};l[t]={},l[t][s]=i[s],this.attr(l)}else this.attr(s,i[s]);return r>0&&this.animate(t,!1).when(null==n?500:n,o).delay(a||0),this}};var Ql=Jl,th=function(t){Ml.call(this,t),dl.call(this,t),Ql.call(this,t),this.id=t.id||Zs()};th.prototype={type:"element",name:"",__zr:null,ignore:!1,clipPath:null,drift:function(t,e){switch(this.draggable){case"horizontal":e=0;break;case"vertical":t=0}var i=this.transform;i||(i=this.transform=[1,0,0,1,0,0]),i[4]+=t,i[5]+=e,this.decomposeTransform(),this.dirty(!1)},beforeUpdate:function(){},afterUpdate:function(){},update:function(){this.updateTransform()},traverse:function(t,e){},attrKV:function(t,e){if("position"===t||"scale"===t||"origin"===t){if(e){var i=this[t];i||(i=this[t]=[]),i[0]=e[0],i[1]=e[1]}}else this[t]=e},hide:function(){this.ignore=!0,this.__zr&&this.__zr.refresh()},show:function(){this.ignore=!1,this.__zr&&this.__zr.refresh()},attr:function(t,e){if("string"==typeof t)this.attrKV(t,e);else if(rl.isObject(t))for(var i in t)t.hasOwnProperty(i)&&this.attrKV(i,t[i]);return this.dirty(!1),this},setClipPath:function(t){var e=this.__zr;e&&t.addSelfToZr(e),this.clipPath&&this.clipPath!==t&&this.removeClipPath(),this.clipPath=t,t.__zr=e,t.__clipTarget=this,this.dirty(!1)},removeClipPath:function(){var t=this.clipPath;t&&(t.__zr&&t.removeSelfFromZr(t.__zr),t.__zr=null,t.__clipTarget=null,this.clipPath=null,this.dirty(!1))},addSelfToZr:function(t){this.__zr=t;var e=this.animators;if(e)for(var i=0;i<e.length;i++)t.animation.addAnimator(e[i]);this.clipPath&&this.clipPath.addSelfToZr(t)},removeSelfFromZr:function(t){this.__zr=null;var e=this.animators;if(e)for(var i=0;i<e.length;i++)t.animation.removeAnimator(e[i]);this.clipPath&&this.clipPath.removeSelfFromZr(t)}},rl.mixin(th,Ql),rl.mixin(th,Ml),rl.mixin(th,dl);var eh=th,ih=ll.applyTransform,nh=Math.min,ah=Math.max;Z.prototype={constructor:Z,union:function(t){var e=nh(t.x,this.x),i=nh(t.y,this.y);this.width=ah(t.x+t.width,this.x+this.width)-e,this.height=ah(t.y+t.height,this.y+this.height)-i,this.x=e,this.y=i},applyTransform:function(){var t=[],e=[],i=[],n=[];return function(a){if(a){t[0]=i[0]=this.x,t[1]=n[1]=this.y,e[0]=n[0]=this.x+this.width,e[1]=i[1]=this.y+this.height,ih(t,t,a),ih(e,e,a),ih(i,i,a),ih(n,n,a),this.x=nh(t[0],e[0],i[0],n[0]),this.y=nh(t[1],e[1],i[1],n[1]);var o=ah(t[0],e[0],i[0],n[0]),r=ah(t[1],e[1],i[1],n[1]);this.width=o-this.x,this.height=r-this.y}}}(),calculateTransform:function(t){var e=this,i=t.width/e.width,n=t.height/e.height,a=yl.create();return yl.translate(a,a,[-e.x,-e.y]),yl.scale(a,a,[i,n]),yl.translate(a,a,[t.x,t.y]),a},intersect:function(t){if(!t)return!1;t instanceof Z||(t=Z.create(t));var e=this,i=e.x,n=e.x+e.width,a=e.y,o=e.y+e.height,r=t.x,s=t.x+t.width,l=t.y,h=t.y+t.height;return!(n<r||s<i||o<l||h<a)},contain:function(t,e){return t>=this.x&&t<=this.x+this.width&&e>=this.y&&e<=this.y+this.height},clone:function(){return new Z(this.x,this.y,this.width,this.height)},copy:function(t){this.x=t.x,this.y=t.y,this.width=t.width,this.height=t.height},plain:function(){return{x:this.x,y:this.y,width:this.width,height:this.height}}},Z.create=function(t){return new Z(t.x,t.y,t.width,t.height)};var oh=Z,rh=function(t){t=t||{},eh.call(this,t);for(var e in t)t.hasOwnProperty(e)&&(this[e]=t[e]);this._children=[],this.__storage=null,this.__dirty=!0};rh.prototype={constructor:rh,isGroup:!0,type:"group",silent:!1,children:function(){return this._children.slice()},childAt:function(t){return this._children[t]},childOfName:function(t){for(var e=this._children,i=0;i<e.length;i++)if(e[i].name===t)return e[i]},childCount:function(){return this._children.length},add:function(t){return t&&t!==this&&t.parent!==this&&(this._children.push(t),this._doAdd(t)),this},addBefore:function(t,e){if(t&&t!==this&&t.parent!==this&&e&&e.parent===this){var i=this._children,n=i.indexOf(e);n>=0&&(i.splice(n,0,t),this._doAdd(t))}return this},_doAdd:function(t){t.parent&&t.parent.remove(t),t.parent=this;var e=this.__storage,i=this.__zr;e&&e!==t.__storage&&(e.addToStorage(t),t instanceof rh&&t.addChildrenToStorage(e)),i&&i.refresh()},remove:function(t){var e=this.__zr,i=this.__storage,n=this._children,a=rl.indexOf(n,t);return a<0?this:(n.splice(a,1),t.parent=null,i&&(i.delFromStorage(t),t instanceof rh&&t.delChildrenFromStorage(i)),e&&e.refresh(),this)},removeAll:function(){var t,e,i=this._children,n=this.__storage;for(e=0;e<i.length;e++)t=i[e],n&&(n.delFromStorage(t),t instanceof rh&&t.delChildrenFromStorage(n)),t.parent=null;return i.length=0,this},eachChild:function(t,e){for(var i=this._children,n=0;n<i.length;n++){var a=i[n];t.call(e,a,n)}return this},traverse:function(t,e){for(var i=0;i<this._children.length;i++){var n=this._children[i];t.call(e,n),"group"===n.type&&n.traverse(t,e)}return this},addChildrenToStorage:function(t){for(var e=0;e<this._children.length;e++){var i=this._children[e];t.addToStorage(i),i instanceof rh&&i.addChildrenToStorage(t)}},delChildrenFromStorage:function(t){for(var e=0;e<this._children.length;e++){var i=this._children[e];t.delFromStorage(i),i instanceof rh&&i.delChildrenFromStorage(t)}},dirty:function(){return this.__dirty=!0,this.__zr&&this.__zr.refresh(),this},getBoundingRect:function(t){for(var e=null,i=new oh(0,0,0,0),n=t||this._children,a=[],o=0;o<n.length;o++){var r=n[o];if(!r.ignore&&!r.invisible){var s=r.getBoundingRect(),l=r.getLocalTransform(a);l?(i.copy(s),i.applyTransform(l),(e=e||i.clone()).union(i)):(e=e||s.clone()).union(s)}}return e||i}},rl.inherits(rh,eh);var sh=rh,lh=32,hh=7,uh=function(t,e,i,n){i||(i=0),n||(n=t.length);var a=n-i;if(!(a<2)){var o=0;if(a<lh)return o=j(t,i,n,e),void U(t,i,n,i+o,e);var r=new function(t,e){function i(i){var l=n[i],h=a[i],u=n[i+1],c=a[i+1];a[i]=h+c,i===r-3&&(n[i+1]=n[i+2],a[i+1]=a[i+2]),r--;var d=X(t[u],t,l,h,0,e);l+=d,0!=(h-=d)&&0!==(c=q(t[l+h-1],t,u,c,c-1,e))&&(h<=c?function(i,n,a,r){var l=0;for(l=0;l<n;l++)s[l]=t[i+l];var h=0,u=a,c=i;if(t[c++]=t[u++],0!=--r)if(1!==n){for(var d,p,f,g=o;;){d=0,p=0,f=!1;do{if(e(t[u],s[h])<0){if(t[c++]=t[u++],p++,d=0,0==--r){f=!0;break}}else if(t[c++]=s[h++],d++,p=0,1==--n){f=!0;break}}while((d|p)<g);if(f)break;do{if(0!==(d=X(t[u],s,h,n,0,e))){for(l=0;l<d;l++)t[c+l]=s[h+l];if(c+=d,h+=d,(n-=d)<=1){f=!0;break}}if(t[c++]=t[u++],0==--r){f=!0;break}if(0!==(p=q(s[h],t,u,r,0,e))){for(l=0;l<p;l++)t[c+l]=t[u+l];if(c+=p,u+=p,0==(r-=p)){f=!0;break}}if(t[c++]=s[h++],1==--n){f=!0;break}g--}while(d>=hh||p>=hh);if(f)break;g<0&&(g=0),g+=2}if((o=g)<1&&(o=1),1===n){for(l=0;l<r;l++)t[c+l]=t[u+l];t[c+r]=s[h]}else{if(0===n)throw new Error;for(l=0;l<n;l++)t[c+l]=s[h+l]}}else{for(l=0;l<r;l++)t[c+l]=t[u+l];t[c+r]=s[h]}else for(l=0;l<n;l++)t[c+l]=s[h+l]}(l,h,u,c):function(i,n,a,r){var l=0;for(l=0;l<r;l++)s[l]=t[a+l];var h=i+n-1,u=r-1,c=a+r-1,d=0,p=0;if(t[c--]=t[h--],0!=--n)if(1!==r){for(var f=o;;){var g=0,m=0,v=!1;do{if(e(s[u],t[h])<0){if(t[c--]=t[h--],g++,m=0,0==--n){v=!0;break}}else if(t[c--]=s[u--],m++,g=0,1==--r){v=!0;break}}while((g|m)<f);if(v)break;do{if(0!=(g=n-X(s[u],t,i,n,n-1,e))){for(n-=g,p=1+(c-=g),d=1+(h-=g),l=g-1;l>=0;l--)t[p+l]=t[d+l];if(0===n){v=!0;break}}if(t[c--]=s[u--],1==--r){v=!0;break}if(0!=(m=r-q(t[h],s,0,r,r-1,e))){for(r-=m,p=1+(c-=m),d=1+(u-=m),l=0;l<m;l++)t[p+l]=s[d+l];if(r<=1){v=!0;break}}if(t[c--]=t[h--],0==--n){v=!0;break}f--}while(g>=hh||m>=hh);if(v)break;f<0&&(f=0),f+=2}if((o=f)<1&&(o=1),1===r){for(p=1+(c-=n),d=1+(h-=n),l=n-1;l>=0;l--)t[p+l]=t[d+l];t[c]=s[u]}else{if(0===r)throw new Error;for(d=c-(r-1),l=0;l<r;l++)t[d+l]=s[l]}}else{for(p=1+(c-=n),d=1+(h-=n),l=n-1;l>=0;l--)t[p+l]=t[d+l];t[c]=s[u]}else for(d=c-(r-1),l=0;l<r;l++)t[d+l]=s[l]}(l,h,u,c))}var n,a,o=hh,r=0;t.length;var s=[];n=[],a=[],this.mergeRuns=function(){for(;r>1;){var t=r-2;if(t>=1&&a[t-1]<=a[t]+a[t+1]||t>=2&&a[t-2]<=a[t]+a[t-1])a[t-1]<a[t+1]&&t--;else if(a[t]>a[t+1])break;i(t)}},this.forceMergeRuns=function(){for(;r>1;){var t=r-2;t>0&&a[t-1]<a[t+1]&&t--,i(t)}},this.pushRun=function(t,e){n[r]=t,a[r]=e,r+=1}}(t,e),s=function(t){for(var e=0;t>=lh;)e|=1&t,t>>=1;return t+e}(a);do{if((o=j(t,i,n,e))<s){var l=a;l>s&&(l=s),U(t,i,i+l,i+o,e),o=l}r.pushRun(i,o),r.mergeRuns(),a-=o,i+=o}while(0!==a);r.forceMergeRuns()}},ch=function(){this._roots=[],this._displayList=[],this._displayListLen=0};ch.prototype={constructor:ch,traverse:function(t,e){for(var i=0;i<this._roots.length;i++)this._roots[i].traverse(t,e)},getDisplayList:function(t,e){return e=e||!1,t&&this.updateDisplayList(e),this._displayList},updateDisplayList:function(t){this._displayListLen=0;for(var e=this._roots,i=this._displayList,n=0,a=e.length;n<a;n++)this._updateAndAddDisplayable(e[n],null,t);i.length=this._displayListLen,Us.canvasSupported&&uh(i,Y)},_updateAndAddDisplayable:function(t,e,i){if(!t.ignore||i){t.beforeUpdate(),t.__dirty&&t.update(),t.afterUpdate();var n=t.clipPath;if(n){e=e?e.slice():[];for(var a=n,o=t;a;)a.parent=o,a.updateTransform(),e.push(a),o=a,a=a.clipPath}if(t.isGroup){for(var r=t._children,s=0;s<r.length;s++){var l=r[s];t.__dirty&&(l.__dirty=!0),this._updateAndAddDisplayable(l,e,i)}t.__dirty=!1}else t.__clipPaths=e,this._displayList[this._displayListLen++]=t}},addRoot:function(t){t.__storage!==this&&(t instanceof sh&&t.addChildrenToStorage(this),this.addToStorage(t),this._roots.push(t))},delRoot:function(t){if(null==t){for(i=0;i<this._roots.length;i++){var e=this._roots[i];e instanceof sh&&e.delChildrenFromStorage(this)}return this._roots=[],this._displayList=[],void(this._displayListLen=0)}if(t instanceof Array)for(var i=0,n=t.length;i<n;i++)this.delRoot(t[i]);else{var a=rl.indexOf(this._roots,t);a>=0&&(this.delFromStorage(t),this._roots.splice(a,1),t instanceof sh&&t.delChildrenFromStorage(this))}},addToStorage:function(t){return t.__storage=this,t.dirty(!1),this},delFromStorage:function(t){return t&&(t.__storage=null),this},dispose:function(){this._renderList=this._roots=null},displayableSortFunc:Y};for(var dh=ch,ph=[["shadowBlur",0],["shadowOffsetX",0],["shadowOffsetY",0],["shadowColor","#000"],["lineCap","butt"],["lineJoin","miter"],["miterLimit",10]],fh=function(t,e){this.extendFrom(t,!1),this.host=e},gh=fh.prototype={constructor:fh,host:null,fill:"#000",stroke:null,opacity:1,lineDash:null,lineDashOffset:0,shadowBlur:0,shadowOffsetX:0,shadowOffsetY:0,lineWidth:1,strokeNoScale:!1,text:null,font:null,textFont:null,fontStyle:null,fontWeight:null,fontSize:null,fontFamily:null,textTag:null,textFill:"#000",textStroke:null,textWidth:null,textHeight:null,textStrokeWidth:0,textLineHeight:null,textPosition:"inside",textRect:null,textOffset:null,textAlign:null,textVerticalAlign:null,textDistance:5,textShadowColor:"transparent",textShadowBlur:0,textShadowOffsetX:0,textShadowOffsetY:0,textBoxShadowColor:"transparent",textBoxShadowBlur:0,textBoxShadowOffsetX:0,textBoxShadowOffsetY:0,transformText:!1,textRotation:0,textOrigin:null,textBackgroundColor:null,textBorderColor:null,textBorderWidth:0,textBorderRadius:0,textPadding:null,rich:null,truncate:null,blend:null,bind:function(t,e,i){for(var n=i&&i.style,a=!n,o=0;o<ph.length;o++){var r=ph[o],s=r[0];(a||this[s]!==n[s])&&(t[s]=this[s]||r[1])}if((a||this.fill!==n.fill)&&(t.fillStyle=this.fill),(a||this.stroke!==n.stroke)&&(t.strokeStyle=this.stroke),(a||this.opacity!==n.opacity)&&(t.globalAlpha=null==this.opacity?1:this.opacity),(a||this.blend!==n.blend)&&(t.globalCompositeOperation=this.blend||"source-over"),this.hasStroke()){var l=this.lineWidth;t.lineWidth=l/(this.strokeNoScale&&e&&e.getLineScale?e.getLineScale():1)}},hasFill:function(){var t=this.fill;return null!=t&&"none"!==t},hasStroke:function(){var t=this.stroke;return null!=t&&"none"!==t&&this.lineWidth>0},extendFrom:function(t,e){if(t)for(var i in t)!t.hasOwnProperty(i)||!0!==e&&(!1===e?this.hasOwnProperty(i):null==t[i])||(this[i]=t[i])},set:function(t,e){"string"==typeof t?this[t]=e:this.extendFrom(t,!0)},clone:function(){var t=new this.constructor;return t.extendFrom(this,!0),t},getGradient:function(t,e,i){for(var n=("radial"===e.type?function(t,e,i){var n=i.width,a=i.height,o=Math.min(n,a),r=null==e.x?.5:e.x,s=null==e.y?.5:e.y,l=null==e.r?.5:e.r;return e.global||(r=r*n+i.x,s=s*a+i.y,l*=o),t.createRadialGradient(r,s,0,r,s,l)}:function(t,e,i){var n=null==e.x?0:e.x,a=null==e.x2?1:e.x2,o=null==e.y?0:e.y,r=null==e.y2?0:e.y2;return e.global||(n=n*i.width+i.x,a=a*i.width+i.x,o=o*i.height+i.y,r=r*i.height+i.y),t.createLinearGradient(n,o,a,r)})(t,e,i),a=e.colorStops,o=0;o<a.length;o++)n.addColorStop(a[o].offset,a[o].color);return n}},mh=0;mh<ph.length;mh++){var vh=ph[mh];vh[0]in gh||(gh[vh[0]]=vh[1])}fh.getGradient=gh.getGradient;var yh=fh,xh=function(t,e){this.image=t,this.repeat=e,this.type="pattern"};xh.prototype.getCanvasPattern=function(t){return t.createPattern(this.image,this.repeat||"repeat")};var _h=xh,bh=Fl.devicePixelRatio,wh=function(t,e,i){var n;i=i||bh,"string"==typeof t?n=$(t,e,i):rl.isObject(t)&&(t=(n=t).id),this.id=t,this.dom=n;var a=n.style;a&&(n.onselectstart=function(){return!1},a["-webkit-user-select"]="none",a["user-select"]="none",a["-webkit-touch-callout"]="none",a["-webkit-tap-highlight-color"]="rgba(0,0,0,0)",a.padding=0,a.margin=0,a["border-width"]=0),this.domBack=null,this.ctxBack=null,this.painter=e,this.config=null,this.clearColor=0,this.motionBlur=!1,this.lastFrameAlpha=.7,this.dpr=i};wh.prototype={constructor:wh,elCount:0,__dirty:!0,initContext:function(){this.ctx=this.dom.getContext("2d"),this.ctx.__currentValues={},this.ctx.dpr=this.dpr},createBackBuffer:function(){var t=this.dpr;this.domBack=$("back-"+this.id,this.painter,t),this.ctxBack=this.domBack.getContext("2d"),this.ctxBack.__currentValues={},1!=t&&this.ctxBack.scale(t,t)},resize:function(t,e){var i=this.dpr,n=this.dom,a=n.style,o=this.domBack;a.width=t+"px",a.height=e+"px",n.width=t*i,n.height=e*i,o&&(o.width=t*i,o.height=e*i,1!=i&&this.ctxBack.scale(i,i))},clear:function(t){var e=this.dom,i=this.ctx,n=e.width,a=e.height,o=this.clearColor,r=this.motionBlur&&!t,s=this.lastFrameAlpha,l=this.dpr;if(r&&(this.domBack||this.createBackBuffer(),this.ctxBack.globalCompositeOperation="copy",this.ctxBack.drawImage(e,0,0,n/l,a/l)),i.clearRect(0,0,n,a),o){var h;o.colorStops?(h=o.__canvasGradient||yh.getGradient(i,o,{x:0,y:0,width:n,height:a}),o.__canvasGradient=h):o.image&&(h=_h.prototype.getCanvasPattern.call(o,i)),i.save(),i.fillStyle=h||o,i.fillRect(0,0,n,a),i.restore()}if(r){var u=this.domBack;i.save(),i.globalAlpha=s,i.drawImage(u,0,0,n,a),i.restore()}}};var Sh=wh,Mh="undefined"!=typeof window&&(window.requestAnimationFrame&&window.requestAnimationFrame.bind(window)||window.msRequestAnimationFrame&&window.msRequestAnimationFrame.bind(window)||window.mozRequestAnimationFrame||window.webkitRequestAnimationFrame)||function(t){setTimeout(t,16)},Ih=new Ol(50),Th={findExistImage:function(t){if("string"==typeof t){var e=Ih.get(t);return e&&e.image}return t},createOrUpdateImage:function(t,e,i,n,a){if(t){if("string"==typeof t){if(e&&e.__zrImageSrc===t||!i)return e;var o=Ih.get(t),r={hostEl:i,cb:n,cbPayload:a};return o?!K(e=o.image)&&o.pending.push(r):(!e&&(e=new Image),e.onload=function(){var t=this.__cachedImgObj;this.onload=this.__cachedImgObj=null;for(var e=0;e<t.pending.length;e++){var i=t.pending[e],n=i.cb;n&&n(this,i.cbPayload),i.hostEl.dirty()}t.pending.length=0},Ih.put(t,e.__cachedImgObj={image:e,pending:[r]}),e.src=e.__zrImageSrc=t),e}return t}return e},isImageReady:K},Ah=rl.getContext,Ch=rl.extend,Lh=rl.retrieve2,Dh=rl.retrieve3,Ph={},kh=0,Oh=5e3,zh=/\{([a-zA-Z0-9_]+)\|([^}]*)\}/g,Eh="12px sans-serif",Rh={};Rh.measureText=function(t,e){var i=Ah();return i.font=e||Eh,i.measureText(t)};var Nh={DEFAULT_FONT:Eh,$override:function(t,e){Rh[t]=e},getWidth:J,getBoundingRect:function(t,e,i,n,a,o,r){return o?function(t,e,i,n,a,o,r){var s=st(t,{rich:o,truncate:r,font:e,textAlign:i,textPadding:a}),l=s.outerWidth,h=s.outerHeight,u=Q(0,l,i),c=tt(0,h,n);return new oh(u,c,l,h)}(t,e,i,n,a,o,r):function(t,e,i,n,a,o){var r=rt(t,e,a,o),s=J(t,e);a&&(s+=a[1]+a[3]);var l=r.outerHeight,h=Q(0,s,i),u=tt(0,l,n),c=new oh(h,u,s,l);return c.lineHeight=r.lineHeight,c}(t,e,i,n,a,r)},adjustTextX:Q,adjustTextY:tt,adjustTextPositionOnRect:function(t,e,i){var n=e.x,a=e.y,o=e.height,r=e.width,s=o/2,l="left",h="top";switch(t){case"left":n-=i,a+=s,l="right",h="middle";break;case"right":n+=i+r,a+=s,h="middle";break;case"top":n+=r/2,a-=i,l="center",h="bottom";break;case"bottom":n+=r/2,a+=o+i,l="center";break;case"inside":n+=r/2,a+=s,l="center",h="middle";break;case"insideLeft":n+=i,a+=s,h="middle";break;case"insideRight":n+=r-i,a+=s,l="right",h="middle";break;case"insideTop":n+=r/2,a+=i,l="center";break;case"insideBottom":n+=r/2,a+=o-i,l="center",h="bottom";break;case"insideTopLeft":n+=i,a+=i;break;case"insideTopRight":n+=r-i,a+=i,l="right";break;case"insideBottomLeft":n+=i,a+=o-i,h="bottom";break;case"insideBottomRight":n+=r-i,a+=o-i,l="right",h="bottom"}return{x:n,y:a,textAlign:l,textVerticalAlign:h}},truncateText:et,getLineHeight:at,measureText:ot,parsePlainText:rt,parseRichText:st,makeFont:function(t){return(t.fontSize||t.fontFamily)&&[t.fontStyle,t.fontWeight,(t.fontSize||12)+"px",t.fontFamily||"sans-serif"].join(" ")||t.textFont||t.font}},Vh={buildPath:function(t,e){var i,n,a,o,r=e.x,s=e.y,l=e.width,h=e.height,u=e.r;l<0&&(r+=l,l=-l),h<0&&(s+=h,h=-h),"number"==typeof u?i=n=a=o=u:u instanceof Array?1===u.length?i=n=a=o=u[0]:2===u.length?(i=a=u[0],n=o=u[1]):3===u.length?(i=u[0],n=o=u[1],a=u[2]):(i=u[0],n=u[1],a=u[2],o=u[3]):i=n=a=o=0;var c;i+n>l&&(i*=l/(c=i+n),n*=l/c),a+o>l&&(a*=l/(c=a+o),o*=l/c),n+a>h&&(n*=h/(c=n+a),a*=h/c),i+o>h&&(i*=h/(c=i+o),o*=h/c),t.moveTo(r+i,s),t.lineTo(r+l-n,s),0!==n&&t.quadraticCurveTo(r+l,s,r+l,s+n),t.lineTo(r+l,s+h-a),0!==a&&t.quadraticCurveTo(r+l,s+h,r+l-a,s+h),t.lineTo(r+o,s+h),0!==o&&t.quadraticCurveTo(r,s+h,r,s+h-o),t.lineTo(r,s+i),0!==i&&t.quadraticCurveTo(r,s,r+i,s)}},Bh=rl.retrieve2,Gh=rl.retrieve3,Hh=rl.each,Wh=rl.normalizeCssArray,Fh=rl.isString,Zh=rl.isObject,jh={left:1,right:1,center:1},Uh={top:1,bottom:1,middle:1},qh={normalizeTextStyle:function(t){return ht(t),Hh(t.rich,ht),t},renderText:function(t,e,i,n,a){n.rich?function(t,e,i,n,a){var o=t.__textCotentBlock;o&&!t.__dirty||(o=t.__textCotentBlock=Nh.parseRichText(i,n)),function(t,e,i,n,a){var o=i.width,r=i.outerWidth,s=i.outerHeight,l=n.textPadding,h=ft(0,n,a),u=h.baseX,c=h.baseY,d=h.textAlign,p=h.textVerticalAlign;ut(e,n,a,u,c);var f=Nh.adjustTextX(u,r,d),g=Nh.adjustTextY(c,s,p),m=f,v=g;l&&(m+=l[3],v+=l[0]);var y=m+o;dt(n)&&pt(t,e,n,f,g,r,s);for(var x=0;x<i.lines.length;x++){for(var _,b=i.lines[x],w=b.tokens,S=w.length,M=b.lineHeight,I=b.width,T=0,A=m,C=y,L=S-1;T<S&&(!(_=w[T]).textAlign||"left"===_.textAlign);)ct(t,e,_,n,M,v,A,"left"),I-=_.width,A+=_.width,T++;for(;L>=0&&"right"===(_=w[L]).textAlign;)ct(t,e,_,n,M,v,C,"right"),I-=_.width,C-=_.width,L--;for(A+=(o-(A-m)-(y-C)-I)/2;T<=L;)_=w[T],ct(t,e,_,n,M,v,A+_.width/2,"center"),A+=_.width,T++;v+=M}}(t,e,o,n,a)}(t,e,i,n,a):function(t,e,i,n,a){var o=gt(e,"font",n.font||Nh.DEFAULT_FONT),r=n.textPadding,s=t.__textCotentBlock;s&&!t.__dirty||(s=t.__textCotentBlock=Nh.parsePlainText(i,o,r,n.truncate));var l=s.outerHeight,h=s.lines,u=s.lineHeight,c=ft(0,n,a),d=c.baseX,p=c.baseY,f=c.textAlign,g=c.textVerticalAlign;ut(e,n,a,d,p);var m=Nh.adjustTextY(p,l,g),v=d,y=m,x=dt(n);if(x||r){var _=Nh.getWidth(i,o);r&&(_+=r[1]+r[3]);var b=Nh.adjustTextX(d,_,f);x&&pt(t,e,n,b,m,_,l),r&&(v=xt(d,f,r),y+=r[0])}gt(e,"textAlign",f||"left"),gt(e,"textBaseline","middle"),gt(e,"shadowBlur",n.textShadowBlur||0),gt(e,"shadowColor",n.textShadowColor||"transparent"),gt(e,"shadowOffsetX",n.textShadowOffsetX||0),gt(e,"shadowOffsetY",n.textShadowOffsetY||0),y+=u/2;var w=n.textStrokeWidth,S=mt(n.textStroke,w),M=vt(n.textFill);S&&(gt(e,"lineWidth",w),gt(e,"strokeStyle",S)),M&&gt(e,"fillStyle",M);for(var I=0;I<h.length;I++)S&&e.strokeText(h[I],v,y),M&&e.fillText(h[I],v,y),y+=u}(t,e,i,n,a)},getStroke:mt,getFill:vt,needDrawText:function(t,e){return null!=t&&(t||e.textBackgroundColor||e.textBorderWidth&&e.textBorderColor||e.textPadding)}},Xh=new oh,Yh=function(){};Yh.prototype={constructor:Yh,drawRectText:function(t,e){var i=this.style;e=i.textRect||e,this.__dirty&&qh.normalizeTextStyle(i,!0);var n=i.text;if(null!=n&&(n+=""),qh.needDrawText(n,i)){t.save();var a=this.transform;i.transformText?this.setTransform(t):a&&(Xh.copy(e),Xh.applyTransform(a),e=Xh),qh.renderText(this,t,n,i,e),t.restore()}}};var $h=Yh;_t.prototype={constructor:_t,type:"displayable",__dirty:!0,invisible:!1,z:0,z2:0,zlevel:0,draggable:!1,dragging:!1,silent:!1,culling:!1,cursor:"pointer",rectHover:!1,progressive:-1,beforeBrush:function(t){},afterBrush:function(t){},brush:function(t,e){},getBoundingRect:function(){},contain:function(t,e){return this.rectContain(t,e)},traverse:function(t,e){t.call(e,this)},rectContain:function(t,e){var i=this.transformCoordToLocal(t,e);return this.getBoundingRect().contain(i[0],i[1])},dirty:function(){this.__dirty=!0,this._rect=null,this.__zr&&this.__zr.refresh()},animateStyle:function(t){return this.animate("style",t)},attrKV:function(t,e){"style"!==t?eh.prototype.attrKV.call(this,t,e):this.style.set(e)},setStyle:function(t,e){return this.style.set(t,e),this.dirty(!1),this},useStyle:function(t){return this.style=new yh(t,this),this.dirty(!1),this}},rl.inherits(_t,eh),rl.mixin(_t,$h);var Kh=_t;bt.prototype={constructor:bt,type:"image",brush:function(t,e){var i=this.style,n=i.image;i.bind(t,this,e);var a=this._image=Th.createOrUpdateImage(n,this._image,this,this.onload);if(a&&Th.isImageReady(a)){var o=i.x||0,r=i.y||0,s=i.width,l=i.height,h=a.width/a.height;if(null==s&&null!=l?s=l*h:null==l&&null!=s?l=s/h:null==s&&null==l&&(s=a.width,l=a.height),this.setTransform(t),i.sWidth&&i.sHeight){var u=i.sx||0,c=i.sy||0;t.drawImage(a,u,c,i.sWidth,i.sHeight,o,r,s,l)}else if(i.sx&&i.sy){var d=s-(u=i.sx),p=l-(c=i.sy);t.drawImage(a,u,c,d,p,o,r,s,l)}else t.drawImage(a,o,r,s,l);this.restoreTransform(t),null!=i.text&&this.drawRectText(t,this.getBoundingRect())}},getBoundingRect:function(){var t=this.style;return this._rect||(this._rect=new oh(t.x||0,t.y||0,t.width||0,t.height||0)),this._rect}},rl.inherits(bt,Kh);var Jh=bt,Qh=Fl.devicePixelRatio,tu=new oh(0,0,0,0),eu=new oh(0,0,0,0),iu=function(t,e,i){this.type="canvas";var n=!t.nodeName||"CANVAS"===t.nodeName.toUpperCase();this._opts=i=rl.extend({},i||{}),this.dpr=i.devicePixelRatio||Qh,this._singleCanvas=n,this.root=t;var a=t.style;a&&(a["-webkit-tap-highlight-color"]="transparent",a["-webkit-user-select"]=a["user-select"]=a["-webkit-touch-callout"]="none",t.innerHTML=""),this.storage=e;var o=this._zlevelList=[],r=this._layers={};if(this._layerConfig={},n){null!=i.width&&(t.width=i.width),null!=i.height&&(t.height=i.height);var s=t.width,l=t.height;this._width=s,this._height=l;var h=new Sh(t,this,1);h.initContext(),r[0]=h,o.push(0),this._domRoot=t}else{this._width=this._getSize(0),this._height=this._getSize(1);var u=this._domRoot=function(t,e){var i=document.createElement("div");return i.style.cssText=["position:relative","overflow:hidden","width:"+t+"px","height:"+e+"px","padding:0","margin:0","border-width:0"].join(";")+";",i}(this._width,this._height);t.appendChild(u)}this._progressiveLayers=[],this._hoverlayer,this._hoverElements=[]};iu.prototype={constructor:iu,getType:function(){return"canvas"},isSingleCanvas:function(){return this._singleCanvas},getViewportRoot:function(){return this._domRoot},getViewportRootOffset:function(){var t=this.getViewportRoot();if(t)return{offsetLeft:t.offsetLeft||0,offsetTop:t.offsetTop||0}},refresh:function(t){var e=this.storage.getDisplayList(!0),i=this._zlevelList;this._paintList(e,t);for(var n=0;n<i.length;n++){var a=i[n],o=this._layers[a];!o.__builtin__&&o.refresh&&o.refresh()}return this.refreshHover(),this._progressiveLayers.length&&this._startProgessive(),this},addHover:function(t,e){if(!t.__hoverMir){var i=new t.constructor({style:t.style,shape:t.shape});i.__from=t,t.__hoverMir=i,i.setStyle(e),this._hoverElements.push(i)}},removeHover:function(t){var e=t.__hoverMir,i=this._hoverElements,n=rl.indexOf(i,e);n>=0&&i.splice(n,1),t.__hoverMir=null},clearHover:function(t){for(var e=this._hoverElements,i=0;i<e.length;i++){var n=e[i].__from;n&&(n.__hoverMir=null)}e.length=0},refreshHover:function(){var t=this._hoverElements,e=t.length,i=this._hoverlayer;if(i&&i.clear(),e){uh(t,this.storage.displayableSortFunc),i||(i=this._hoverlayer=this.getLayer(1e5));var n={};i.ctx.save();for(var a=0;a<e;){var o=t[a],r=o.__from;r&&r.__zr?(a++,r.invisible||(o.transform=r.transform,o.invTransform=r.invTransform,o.__clipPaths=r.__clipPaths,this._doPaintEl(o,i,!0,n))):(t.splice(a,1),r.__hoverMir=null,e--)}i.ctx.restore()}},_startProgessive:function(){function t(){i===e._progressiveToken&&e.storage&&(e._doPaintList(e.storage.getDisplayList()),e._furtherProgressive?(e._progress++,Mh(t)):e._progressiveToken=-1)}var e=this;if(e._furtherProgressive){var i=e._progressiveToken=+new Date;e._progress++,Mh(t)}},_clearProgressive:function(){this._progressiveToken=-1,this._progress=0,rl.each(this._progressiveLayers,function(t){t.__dirty&&t.clear()})},_paintList:function(t,e){null==e&&(e=!1),this._updateLayerStatus(t),this._clearProgressive(),this.eachBuiltinLayer(function(t){t.__unusedCount++}),this._doPaintList(t,e),this.eachBuiltinLayer(function(t){1==t.__unusedCount&&t.clear()})},_doPaintList:function(t,e){function i(t){var e=o.dpr||1;o.save(),o.globalAlpha=1,o.shadowBlur=0,n.__dirty=!0,o.setTransform(1,0,0,1,0,0),o.drawImage(t.dom,0,0,u*e,c*e),o.restore()}for(var n,a,o,r,s,l,h=0,u=this._width,c=this._height,d=this._progress,p=0,f=t.length;p<f;p++){var g=t[p],m=this._singleCanvas?0:g.zlevel,v=g.__frame;if(v<0&&s&&(i(s),s=null),a!==m&&(o&&o.restore(),r={},a=m,(n=this.getLayer(a)).__builtin__||Ul("ZLevel "+a+" has been used by unkown layer "+n.id),(o=n.ctx).save(),n.__unusedCount=0,(n.__dirty||e)&&n.clear()),n.__dirty||e){if(v>=0){if(!s){if((s=this._progressiveLayers[Math.min(h++,4)]).ctx.save(),s.renderScope={},s&&s.__progress>s.__maxProgress){p=s.__nextIdxNotProg-1;continue}l=s.__progress,s.__dirty||(d=l),s.__progress=d+1}v===d&&this._doPaintEl(g,s,!0,s.renderScope)}else this._doPaintEl(g,n,e,r);g.__dirty=!1}}s&&i(s),o&&o.restore(),this._furtherProgressive=!1,rl.each(this._progressiveLayers,function(t){t.__maxProgress>=t.__progress&&(this._furtherProgressive=!0)},this)},_doPaintEl:function(t,e,i,n){var a=e.ctx,o=t.transform;if((e.__dirty||i)&&!t.invisible&&0!==t.style.opacity&&(!o||o[0]||o[3])&&(!t.culling||!function(t,e,i){return tu.copy(t.getBoundingRect()),t.transform&&tu.applyTransform(t.transform),eu.width=e,eu.height=i,!tu.intersect(eu)}(t,this._width,this._height))){var r=t.__clipPaths;(n.prevClipLayer!==e||function(t,e){if(t==e)return!1;if(!t||!e||t.length!==e.length)return!0;for(var i=0;i<t.length;i++)if(t[i]!==e[i])return!0}(r,n.prevElClipPaths))&&(n.prevElClipPaths&&(n.prevClipLayer.ctx.restore(),n.prevClipLayer=n.prevElClipPaths=null,n.prevEl=null),r&&(a.save(),function(t,e){for(var i=0;i<t.length;i++){var n=t[i];n.setTransform(e),e.beginPath(),n.buildPath(e,n.shape),e.clip(),n.restoreTransform(e)}}(r,a),n.prevClipLayer=e,n.prevElClipPaths=r)),t.beforeBrush&&t.beforeBrush(a),t.brush(a,n.prevEl||null),n.prevEl=t,t.afterBrush&&t.afterBrush(a)}},getLayer:function(t){if(this._singleCanvas)return this._layers[0];var e=this._layers[t];return e||((e=new Sh("zr_"+t,this,this.dpr)).__builtin__=!0,this._layerConfig[t]&&rl.merge(e,this._layerConfig[t],!0),this.insertLayer(t,e),e.initContext()),e},insertLayer:function(t,e){var i=this._layers,n=this._zlevelList,a=n.length,o=null,r=-1,s=this._domRoot;if(i[t])Ul("ZLevel "+t+" has been used already");else if(function(t){return!!t&&(!!t.__builtin__||"function"==typeof t.resize&&"function"==typeof t.refresh)}(e)){if(a>0&&t>n[0]){for(r=0;r<a-1&&!(n[r]<t&&n[r+1]>t);r++);o=i[n[r]]}if(n.splice(r+1,0,t),i[t]=e,!e.virtual)if(o){var l=o.dom;l.nextSibling?s.insertBefore(e.dom,l.nextSibling):s.appendChild(e.dom)}else s.firstChild?s.insertBefore(e.dom,s.firstChild):s.appendChild(e.dom)}else Ul("Layer of zlevel "+t+" is not valid")},eachLayer:function(t,e){var i,n,a=this._zlevelList;for(n=0;n<a.length;n++)i=a[n],t.call(e,this._layers[i],i)},eachBuiltinLayer:function(t,e){var i,n,a,o=this._zlevelList;for(a=0;a<o.length;a++)n=o[a],(i=this._layers[n]).__builtin__&&t.call(e,i,n)},eachOtherLayer:function(t,e){var i,n,a,o=this._zlevelList;for(a=0;a<o.length;a++)n=o[a],(i=this._layers[n]).__builtin__||t.call(e,i,n)},getLayers:function(){return this._layers},_updateLayerStatus:function(t){var e=this._layers,i=this._progressiveLayers,n={},a={};this.eachBuiltinLayer(function(t,e){n[e]=t.elCount,t.elCount=0,t.__dirty=!1}),rl.each(i,function(t,e){a[e]=t.elCount,t.elCount=0,t.__dirty=!1});for(var o,r,s=0,l=0,h=0,u=t.length;h<u;h++){var c=t[h],d=e[this._singleCanvas?0:c.zlevel],p=c.progressive;if(d&&(d.elCount++,d.__dirty=d.__dirty||c.__dirty),p>=0){r!==p&&(r=p,l++);var f=c.__frame=l-1;if(!o){var g=Math.min(s,4);(o=i[g])||(o=i[g]=new Sh("progressive",this,this.dpr)).initContext(),o.__maxProgress=0}o.__dirty=o.__dirty||c.__dirty,o.elCount++,o.__maxProgress=Math.max(o.__maxProgress,f),o.__maxProgress>=o.__progress&&(d.__dirty=!0)}else c.__frame=-1,o&&(o.__nextIdxNotProg=h,s++,o=null)}o&&(s++,o.__nextIdxNotProg=h),this.eachBuiltinLayer(function(t,e){n[e]!==t.elCount&&(t.__dirty=!0)}),i.length=Math.min(s,5),rl.each(i,function(t,e){a[e]!==t.elCount&&(c.__dirty=!0),t.__dirty&&(t.__progress=0)})},clear:function(){return this.eachBuiltinLayer(this._clearLayer),this},_clearLayer:function(t){t.clear()},configLayer:function(t,e){if(e){var i=this._layerConfig;i[t]?rl.merge(i[t],e,!0):i[t]=e;var n=this._layers[t];n&&rl.merge(n,i[t],!0)}},delLayer:function(t){var e=this._layers,i=this._zlevelList,n=e[t];n&&(n.dom.parentNode.removeChild(n.dom),delete e[t],i.splice(rl.indexOf(i,t),1))},resize:function(t,e){var i=this._domRoot;i.style.display="none";var n=this._opts;if(null!=t&&(n.width=t),null!=e&&(n.height=e),t=this._getSize(0),e=this._getSize(1),i.style.display="",this._width!=t||e!=this._height){i.style.width=t+"px",i.style.height=e+"px";for(var a in this._layers)this._layers.hasOwnProperty(a)&&this._layers[a].resize(t,e);rl.each(this._progressiveLayers,function(i){i.resize(t,e)}),this.refresh(!0)}return this._width=t,this._height=e,this},clearLayer:function(t){var e=this._layers[t];e&&e.clear()},dispose:function(){this.root.innerHTML="",this.root=this.storage=this._domRoot=this._layers=null},getRenderedCanvas:function(t){function e(t,e){var n=r._zlevelList;null==t&&(t=-1/0);for(var a,o=0;o<n.length;o++){var s=n[o],l=r._layers[s];if(!l.__builtin__&&s>t&&s<e){a=l;break}}a&&a.renderToCanvas&&(i.ctx.save(),a.renderToCanvas(i.ctx),i.ctx.restore())}if(t=t||{},this._singleCanvas)return this._layers[0].dom;var i=new Sh("image",this,t.pixelRatio||this.dpr);i.initContext(),i.clearColor=t.backgroundColor,i.clear();for(var n,a=this.storage.getDisplayList(!0),o={},r=this,s=0;s<a.length;s++){var l=a[s];l.zlevel!==n&&(e(n,l.zlevel),n=l.zlevel),this._doPaintEl(l,i,!0,o)}return e(n,1/0),i.dom},getWidth:function(){return this._width},getHeight:function(){return this._height},_getSize:function(t){var e=this._opts,i=["width","height"][t],n=["clientWidth","clientHeight"][t],a=["paddingLeft","paddingTop"][t],o=["paddingRight","paddingBottom"][t];if(null!=e[i]&&"auto"!==e[i])return parseFloat(e[i]);var r=this.root,s=document.defaultView.getComputedStyle(r);return(r[n]||wt(s[i])||wt(r.style[i]))-(wt(s[a])||0)-(wt(s[o])||0)|0},pathToImage:function(t,e){e=e||this.dpr;var i=document.createElement("canvas"),n=i.getContext("2d"),a=t.getBoundingRect(),o=t.style,r=o.shadowBlur,s=o.shadowOffsetX,l=o.shadowOffsetY,h=o.hasStroke()?o.lineWidth:0,u=Math.max(h/2,-s+r),c=Math.max(h/2,s+r),d=Math.max(h/2,-l+r),p=Math.max(h/2,l+r),f=a.width+u+c,g=a.height+d+p;i.width=f*e,i.height=g*e,n.scale(e,e),n.clearRect(0,0,f,g),n.dpr=e;var m={position:t.position,rotation:t.rotation,scale:t.scale};t.position=[u-a.x,d-a.y],t.rotation=0,t.scale=[1,1],t.updateTransform(),t&&t.brush(n);var v=new Jh({style:{x:0,y:0,image:i}});return null!=m.position&&(v.position=t.position=m.position),null!=m.rotation&&(v.rotation=t.rotation=m.rotation),null!=m.scale&&(v.scale=t.scale=m.scale),v}};var nu=iu,au=dl,ou="undefined"!=typeof window&&!!window.addEventListener,ru=/^(?:mouse|pointer|contextmenu|drag|drop)|click/,su={Dispatcher:au,clientToLocal:St,normalizeEvent:function(t,e,i){if(null!=(e=e||window.event).zrX)return e;var n=e.type;if(n&&n.indexOf("touch")>=0){var a="touchend"!=n?e.targetTouches[0]:e.changedTouches[0];a&&St(t,a,e,i)}else St(t,e,e,i),e.zrDelta=e.wheelDelta?e.wheelDelta/120:-(e.detail||0)/3;var o=e.button;return null==e.which&&void 0!==o&&ru.test(e.type)&&(e.which=1&o?1:2&o?3:4&o?2:0),e},addEventListener:function(t,e,i){ou?t.addEventListener(e,i):t.attachEvent("on"+e,i)},removeEventListener:function(t,e,i){ou?t.removeEventListener(e,i):t.detachEvent("on"+e,i)},stop:ou?function(t){t.preventDefault(),t.stopPropagation(),t.cancelBubble=!0}:function(t){t.returnValue=!1,t.cancelBubble=!0},notLeftMouse:function(t){return t.which>1}},lu=su.Dispatcher,hu=function(t){t=t||{},this.stage=t.stage||{},this.onframe=t.onframe||function(){},this._clips=[],this._running=!1,this._time,this._pausedTime,this._pauseStart,this._paused=!1,lu.call(this)};hu.prototype={constructor:hu,addClip:function(t){this._clips.push(t)},addAnimator:function(t){t.animation=this;for(var e=t.getClips(),i=0;i<e.length;i++)this.addClip(e[i])},removeClip:function(t){var e=rl.indexOf(this._clips,t);e>=0&&this._clips.splice(e,1)},removeAnimator:function(t){for(var e=t.getClips(),i=0;i<e.length;i++)this.removeClip(e[i]);t.animation=null},_update:function(){for(var t=(new Date).getTime()-this._pausedTime,e=t-this._time,i=this._clips,n=i.length,a=[],o=[],r=0;r<n;r++){var s=i[r],l=s.step(t,e);l&&(a.push(l),o.push(s))}for(r=0;r<n;)i[r]._needsRemove?(i[r]=i[n-1],i.pop(),n--):r++;n=a.length;for(r=0;r<n;r++)o[r].fire(a[r]);this._time=t,this.onframe(e),this.trigger("frame",e),this.stage.update&&this.stage.update()},_startLoop:function(){function t(){e._running&&(Mh(t),!e._paused&&e._update())}var e=this;this._running=!0,Mh(t)},start:function(){this._time=(new Date).getTime(),this._pausedTime=0,this._startLoop()},stop:function(){this._running=!1},pause:function(){this._paused||(this._pauseStart=(new Date).getTime(),this._paused=!0)},resume:function(){this._paused&&(this._pausedTime+=(new Date).getTime()-this._pauseStart,this._paused=!1)},clear:function(){this._clips=[]},animate:function(t,e){var i=new Hl(t,(e=e||{}).loop,e.getter,e.setter);return this.addAnimator(i),i}},rl.mixin(hu,lu);var uu=hu,cu=function(){this._track=[]};cu.prototype={constructor:cu,recognize:function(t,e,i){return this._doTrack(t,e,i),this._recognize(t)},clear:function(){return this._track.length=0,this},_doTrack:function(t,e,i){var n=t.touches;if(n){for(var a={points:[],touches:[],target:e,event:t},o=0,r=n.length;o<r;o++){var s=n[o],l=su.clientToLocal(i,s,{});a.points.push([l.zrX,l.zrY]),a.touches.push(s)}this._track.push(a)}},_recognize:function(t){for(var e in du)if(du.hasOwnProperty(e)){var i=du[e](this._track,t);if(i)return i}}};var du={pinch:function(t,e){var i=t.length;if(i){var n=(t[i-1]||{}).points,a=(t[i-2]||{}).points||n;if(a&&a.length>1&&n&&n.length>1){var o=It(n)/It(a);!isFinite(o)&&(o=1),e.pinchScale=o;var r=function(t){return[(t[0][0]+t[1][0])/2,(t[0][1]+t[1][1])/2]}(n);return e.pinchX=r[0],e.pinchY=r[1],{type:"pinch",target:t[0].target,event:e}}}}},pu=cu,fu=su.addEventListener,gu=su.removeEventListener,mu=su.normalizeEvent,vu=["click","dblclick","mousewheel","mouseout","mouseup","mousedown","mousemove","contextmenu"],yu=["touchstart","touchend","touchmove"],xu={pointerdown:1,pointerup:1,pointermove:1,pointerout:1},_u=rl.map(vu,function(t){var e=t.replace("mouse","pointer");return xu[e]?e:t}),bu={mousemove:function(t){t=mu(this.dom,t),this.trigger("mousemove",t)},mouseout:function(t){var e=(t=mu(this.dom,t)).toElement||t.relatedTarget;if(e!=this.dom)for(;e&&9!=e.nodeType;){if(e===this.dom)return;e=e.parentNode}this.trigger("mouseout",t)},touchstart:function(t){(t=mu(this.dom,t)).zrByTouch=!0,this._lastTouchMoment=new Date,At(this,t,"start"),bu.mousemove.call(this,t),bu.mousedown.call(this,t),Ct(this)},touchmove:function(t){(t=mu(this.dom,t)).zrByTouch=!0,At(this,t,"change"),bu.mousemove.call(this,t),Ct(this)},touchend:function(t){(t=mu(this.dom,t)).zrByTouch=!0,At(this,t,"end"),bu.mouseup.call(this,t),+new Date-this._lastTouchMoment<300&&bu.click.call(this,t),Ct(this)},pointerdown:function(t){bu.mousedown.call(this,t)},pointermove:function(t){Lt(t)||bu.mousemove.call(this,t)},pointerup:function(t){bu.mouseup.call(this,t)},pointerout:function(t){Lt(t)||bu.mouseout.call(this,t)}};rl.each(["click","mousedown","mouseup","mousewheel","dblclick","contextmenu"],function(t){bu[t]=function(e){e=mu(this.dom,e),this.trigger(t,e)}});var wu=Dt.prototype;wu.dispose=function(){for(var t=vu.concat(yu),e=0;e<t.length;e++){var i=t[e];gu(this.dom,Tt(i),this._handlers[i])}},wu.setCursor=function(t){this.dom.style.cursor=t||"default"},rl.mixin(Dt,dl);var Su=Dt,Mu=!Us.canvasSupported,Iu={canvas:nu},Tu={},Au=function(t,e,i){i=i||{},this.dom=e,this.id=t;var n=this,a=new dh,o=i.renderer;if(Mu){if(!Iu.vml)throw new Error("You need to require 'zrender/vml/vml' to support IE8");o="vml"}else o&&Iu[o]||(o="canvas");var r=new Iu[o](e,a,i);this.storage=a,this.painter=r;var s=Us.node?null:new Su(r.getViewportRoot());this.handler=new ml(a,r,s,r.root),this.animation=new uu({stage:{update:rl.bind(this.flush,this)}}),this.animation.start(),this._needsRefresh;var l=a.delFromStorage,h=a.addToStorage;a.delFromStorage=function(t){l.call(a,t),t&&t.removeSelfFromZr(n)},a.addToStorage=function(t){h.call(a,t),t.addSelfToZr(n)}};Au.prototype={constructor:Au,getId:function(){return this.id},add:function(t){this.storage.addRoot(t),this._needsRefresh=!0},remove:function(t){this.storage.delRoot(t),this._needsRefresh=!0},configLayer:function(t,e){this.painter.configLayer(t,e),this._needsRefresh=!0},refreshImmediately:function(){this._needsRefresh=!1,this.painter.refresh(),this._needsRefresh=!1},refresh:function(){this._needsRefresh=!0},flush:function(){this._needsRefresh&&this.refreshImmediately(),this._needsRefreshHover&&this.refreshHoverImmediately()},addHover:function(t,e){this.painter.addHover&&(this.painter.addHover(t,e),this.refreshHover())},removeHover:function(t){this.painter.removeHover&&(this.painter.removeHover(t),this.refreshHover())},clearHover:function(){this.painter.clearHover&&(this.painter.clearHover(),this.refreshHover())},refreshHover:function(){this._needsRefreshHover=!0},refreshHoverImmediately:function(){this._needsRefreshHover=!1,this.painter.refreshHover&&this.painter.refreshHover()},resize:function(t){t=t||{},this.painter.resize(t.width,t.height),this.handler.resize()},clearAnimation:function(){this.animation.clear()},getWidth:function(){return this.painter.getWidth()},getHeight:function(){return this.painter.getHeight()},pathToImage:function(t,e){return this.painter.pathToImage(t,e)},setCursorStyle:function(t){this.handler.setCursorStyle(t)},findHover:function(t,e){return this.handler.findHover(t,e)},on:function(t,e,i){this.handler.on(t,e,i)},off:function(t,e){this.handler.off(t,e)},trigger:function(t,e){this.handler.trigger(t,e)},clear:function(){this.storage.delRoot(),this.painter.clear()},dispose:function(){this.animation.stop(),this.clear(),this.storage.dispose(),this.painter.dispose(),this.handler.dispose(),this.animation=this.storage=this.painter=this.handler=null,function(t){delete Tu[t]}(this.id)}};var Cu={version:"3.7.4",init:function(t,e){var i=new Au(Zs(),t,e);return Tu[i.id]=i,i},dispose:function(t){if(t)t.dispose();else{for(var e in Tu)Tu.hasOwnProperty(e)&&Tu[e].dispose();Tu={}}return this},getInstance:function(t){return Tu[t]},registerPainter:function(t,e){Iu[t]=e}},Lu=1e-4,Du=/^(?:(\d{4})(?:[-\/](\d{1,2})(?:[-\/](\d{1,2})(?:[T ](\d{1,2})(?::(\d\d)(?::(\d\d)(?:[.,](\d+))?)?)?(Z|[\+\-]\d\d:?\d\d)?)?)?)?)?$/,Pu={linearMap:function(t,e,i,n){var a=e[1]-e[0],o=i[1]-i[0];if(0===a)return 0===o?i[0]:(i[0]+i[1])/2;if(n)if(a>0){if(t<=e[0])return i[0];if(t>=e[1])return i[1]}else{if(t>=e[0])return i[0];if(t<=e[1])return i[1]}else{if(t===e[0])return i[0];if(t===e[1])return i[1]}return(t-e[0])/a*o+i[0]},parsePercent:function(t,e){switch(t){case"center":case"middle":t="50%";break;case"left":case"top":t="0%";break;case"right":case"bottom":t="100%"}return"string"==typeof t?t.replace(/^\s+/,"").replace(/\s+$/,"").match(/%$/)?parseFloat(t)/100*e:parseFloat(t):null==t?NaN:+t},round:function(t,e,i){return null==e&&(e=10),e=Math.min(Math.max(0,e),20),t=(+t).toFixed(e),i?t:+t},asc:function(t){return t.sort(function(t,e){return t-e}),t},getPrecision:function(t){if(t=+t,isNaN(t))return 0;for(var e=1,i=0;Math.round(t*e)/e!==t;)e*=10,i++;return i},getPrecisionSafe:function(t){var e=t.toString(),i=e.indexOf("e");if(i>0){var n=+e.slice(i+1);return n<0?-n:0}var a=e.indexOf(".");return a<0?0:e.length-1-a},getPixelPrecision:function(t,e){var i=Math.log,n=Math.LN10,a=Math.floor(i(t[1]-t[0])/n),o=Math.round(i(Math.abs(e[1]-e[0]))/n),r=Math.min(Math.max(-a+o,0),20);return isFinite(r)?r:20},getPercentWithPrecision:function(t,e,i){if(!t[e])return 0;var n=rl.reduce(t,function(t,e){return t+(isNaN(e)?0:e)},0);if(0===n)return 0;for(var a=Math.pow(10,i),o=rl.map(t,function(t){return(isNaN(t)?0:t)/n*a*100}),r=100*a,s=rl.map(o,function(t){return Math.floor(t)}),l=rl.reduce(s,function(t,e){return t+e},0),h=rl.map(o,function(t,e){return t-s[e]});l<r;){for(var u=Number.NEGATIVE_INFINITY,c=null,d=0,p=h.length;d<p;++d)h[d]>u&&(u=h[d],c=d);++s[c],h[c]=0,++l}return s[e]/a},MAX_SAFE_INTEGER:9007199254740991,remRadian:function(t){var e=2*Math.PI;return(t%e+e)%e},isRadianAroundZero:function(t){return t>-Lu&&t<Lu},parseDate:function(t){if(t instanceof Date)return t;if("string"==typeof t){var e=Du.exec(t);if(!e)return new Date(NaN);if(e[8]){var i=+e[4]||0;return"Z"!==e[8].toUpperCase()&&(i-=e[8].slice(0,3)),new Date(Date.UTC(+e[1],+(e[2]||1)-1,+e[3]||1,i,+(e[5]||0),+e[6]||0,+e[7]||0))}return new Date(+e[1],+(e[2]||1)-1,+e[3]||1,+e[4]||0,+(e[5]||0),+e[6]||0,+e[7]||0)}return null==t?new Date(NaN):new Date(Math.round(t))},quantity:function(t){return Math.pow(10,Pt(t))},nice:function(t,e){var i,n=Pt(t),a=Math.pow(10,n),o=t/a;return i=e?o<1.5?1:o<2.5?2:o<4?3:o<7?5:10:o<1?1:o<2?2:o<3?3:o<5?5:10,t=i*a,n>=-20?+t.toFixed(n<0?-n:0):t},reformIntervals:function(t){function e(t,i,n){return t.interval[n]<i.interval[n]||t.interval[n]===i.interval[n]&&(t.close[n]-i.close[n]==(n?-1:1)||!n&&e(t,i,1))}t.sort(function(t,i){return e(t,i,0)?-1:1});for(var i=-1/0,n=1,a=0;a<t.length;){for(var o=t[a].interval,r=t[a].close,s=0;s<2;s++)o[s]<=i&&(o[s]=i,r[s]=s?1:1-n),i=o[s],n=r[s];o[0]===o[1]&&r[0]*r[1]!=1?t.splice(a,1):a++}return t},isNumeric:function(t){return t-parseFloat(t)>=0}},ku=["a","b","c","d","e","f","g"],Ou=function(t,e){return"{"+t+(null==e?"":e)+"}"},zu=function(t){return t<10?"0"+t:t},Eu={addCommas:function(t){return isNaN(t)?"-":(t=(t+"").split("."))[0].replace(/(\d{1,3})(?=(?:\d{3})+(?!\d))/g,"$1,")+(t.length>1?"."+t[1]:"")},toCamelCase:function(t,e){return t=(t||"").toLowerCase().replace(/-(.)/g,function(t,e){return e.toUpperCase()}),e&&t&&(t=t.charAt(0).toUpperCase()+t.slice(1)),t},normalizeCssArray:rl.normalizeCssArray,encodeHTML:kt,formatTpl:function(t,e,i){rl.isArray(e)||(e=[e]);var n=e.length;if(!n)return"";for(var a=e[0].$vars||[],o=0;o<a.length;o++){var r=ku[o],s=Ou(r,0);t=t.replace(Ou(r),i?kt(s):s)}for(var l=0;l<n;l++)for(var h=0;h<a.length;h++)s=e[l][a[h]],t=t.replace(Ou(ku[h],l),i?kt(s):s);return t},formatTplSimple:function(t,e,i){return rl.each(e,function(e,n){t=t.replace("{"+n+"}",i?kt(e):e)}),t},getTooltipMarker:function(t,e){return t?'<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:'+kt(t)+";"+(e||"")+'"></span>':""},formatTime:function(t,e,i){"week"!==t&&"month"!==t&&"quarter"!==t&&"half-year"!==t&&"year"!==t||(t="MM-dd\nyyyy");var n=Pu.parseDate(e),a=i?"UTC":"",o=n["get"+a+"FullYear"](),r=n["get"+a+"Month"]()+1,s=n["get"+a+"Date"](),l=n["get"+a+"Hours"](),h=n["get"+a+"Minutes"](),u=n["get"+a+"Seconds"]();return t=t.replace("MM",zu(r)).replace("M",r).replace("yyyy",o).replace("yy",o%100).replace("dd",zu(s)).replace("d",s).replace("hh",zu(l)).replace("h",l).replace("mm",zu(h)).replace("m",h).replace("ss",zu(u)).replace("s",u)},capitalFirst:function(t){return t?t.charAt(0).toUpperCase()+t.substr(1):t},truncateText:Nh.truncateText,getTextRect:Nh.getBoundingRect},Ru=".",Nu="___EC__COMPONENT__CONTAINER___",Vu="\0ec_\0",Bu={set:function(t,e,i){return t[Vu+e]=i},get:function(t,e){return t[Vu+e]},hasOwn:function(t,e){return t.hasOwnProperty(Vu+e)},parseClassType:Ot,enableClassExtend:function(t,e){t.$constructor=t,t.extend=function(t){var e=this,i=function(){t.$constructor?t.$constructor.apply(this,arguments):e.apply(this,arguments)};return rl.extend(i.prototype,t),i.extend=this.extend,i.superCall=function(t,e){var i=rl.slice(arguments,2);return this.superClass.prototype[e].apply(t,i)},i.superApply=function(t,e,i){return this.superClass.prototype[e].apply(t,i)},rl.inherits(i,this),i.superClass=e,i}},enableClassManagement:function(t,e){e=e||{};var i={};if(t.registerClass=function(t,e){return e&&(function(t){rl.assert(/^[a-zA-Z0-9_]+([.][a-zA-Z0-9_]+)?$/.test(t),'componentType "'+t+'" illegal')}(e),(e=Ot(e)).sub?e.sub!==Nu&&((function(t){var e=i[t.main];return e&&e[Nu]||((e=i[t.main]={})[Nu]=!0),e}(e))[e.sub]=t):i[e.main]=t),t},t.getClass=function(t,e,n){var a=i[t];if(a&&a[Nu]&&(a=e?a[e]:null),n&&!a)throw new Error(e?"Component "+t+"."+(e||"")+" not exists. Load it first.":t+".type should be specified.");return a},t.getClassesByMainType=function(t){t=Ot(t);var e=[],n=i[t.main];return n&&n[Nu]?rl.each(n,function(t,i){i!==Nu&&e.push(t)}):e.push(n),e},t.hasClass=function(t){return t=Ot(t),!!i[t.main]},t.getAllClassMainTypes=function(){var t=[];return rl.each(i,function(e,i){t.push(i)}),t},t.hasSubTypes=function(t){t=Ot(t);var e=i[t.main];return e&&e[Nu]},t.parseClassType=Ot,e.registerWhenExtend){var n=t.extend;n&&(t.extend=function(e){var i=n.call(this,e);return t.registerClass(i,e.type)})}return t},setReadOnly:function(t,e){}},Gu=function(t){for(var e=0;e<t.length;e++)t[e][1]||(t[e][1]=t[e][0]);return function(e,i,n){for(var a={},o=0;o<t.length;o++){var r=t[o][1];if(!(i&&rl.indexOf(i,r)>=0||n&&rl.indexOf(n,r)<0)){var s=e.getShallow(r);null!=s&&(a[t[o][0]]=s)}}return a}},Hu=Gu([["lineWidth","width"],["stroke","color"],["opacity"],["shadowBlur"],["shadowOffsetX"],["shadowOffsetY"],["shadowColor"]]),Wu={getLineStyle:function(t){var e=Hu(this,t),i=this.getLineDash(e.lineWidth);return i&&(e.lineDash=i),e},getLineDash:function(t){null==t&&(t=1);var e=this.get("type"),i=Math.max(t,2),n=4*t;return"solid"===e||null==e?null:"dashed"===e?[n,n]:[i,i]}},Fu=Gu([["fill","color"],["shadowBlur"],["shadowOffsetX"],["shadowOffsetY"],["opacity"],["shadowColor"]]),Zu={getAreaStyle:function(t,e){return Fu(this,t,e)}},ju=ll.create,Uu=ll.distSquare,qu=Math.pow,Xu=Math.sqrt,Yu=1e-8,$u=1e-4,Ku=Xu(3),Ju=1/3,Qu=ju(),tc=ju(),ec=ju(),ic={cubicAt:Rt,cubicDerivativeAt:function(t,e,i,n,a){var o=1-a;return 3*(((e-t)*o+2*(i-e)*a)*o+(n-i)*a*a)},cubicRootAt:function(t,e,i,n,a,o){var r=n+3*(e-i)-t,s=3*(i-2*e+t),l=3*(e-t),h=t-a,u=s*s-3*r*l,c=s*l-9*r*h,d=l*l-3*s*h,p=0;if(zt(u)&&zt(c))zt(s)?o[0]=0:(M=-l/s)>=0&&M<=1&&(o[p++]=M);else{var f=c*c-4*u*d;if(zt(f)){var g=c/u,m=-g/2;(M=-s/r+g)>=0&&M<=1&&(o[p++]=M),m>=0&&m<=1&&(o[p++]=m)}else if(f>0){var v=Xu(f),y=u*s+1.5*r*(-c+v),x=u*s+1.5*r*(-c-v);(M=(-s-((y=y<0?-qu(-y,Ju):qu(y,Ju))+(x=x<0?-qu(-x,Ju):qu(x,Ju))))/(3*r))>=0&&M<=1&&(o[p++]=M)}else{var _=(2*u*s-3*r*c)/(2*Xu(u*u*u)),b=Math.acos(_)/3,w=Xu(u),S=Math.cos(b),M=(-s-2*w*S)/(3*r),m=(-s+w*(S+Ku*Math.sin(b)))/(3*r),I=(-s+w*(S-Ku*Math.sin(b)))/(3*r);M>=0&&M<=1&&(o[p++]=M),m>=0&&m<=1&&(o[p++]=m),I>=0&&I<=1&&(o[p++]=I)}}return p},cubicExtrema:function(t,e,i,n,a){var o=6*i-12*e+6*t,r=9*e+3*n-3*t-9*i,s=3*e-3*t,l=0;if(zt(r))Et(o)&&(c=-s/o)>=0&&c<=1&&(a[l++]=c);else{var h=o*o-4*r*s;if(zt(h))a[0]=-o/(2*r);else if(h>0){var u=Xu(h),c=(-o+u)/(2*r),d=(-o-u)/(2*r);c>=0&&c<=1&&(a[l++]=c),d>=0&&d<=1&&(a[l++]=d)}}return l},cubicSubdivide:function(t,e,i,n,a,o){var r=(e-t)*a+t,s=(i-e)*a+e,l=(n-i)*a+i,h=(s-r)*a+r,u=(l-s)*a+s,c=(u-h)*a+h;o[0]=t,o[1]=r,o[2]=h,o[3]=c,o[4]=c,o[5]=u,o[6]=l,o[7]=n},cubicProjectPoint:function(t,e,i,n,a,o,r,s,l,h,u){var c,d,p,f,g,m=.005,v=1/0;Qu[0]=l,Qu[1]=h;for(var y=0;y<1;y+=.05)tc[0]=Rt(t,i,a,r,y),tc[1]=Rt(e,n,o,s,y),(f=Uu(Qu,tc))<v&&(c=y,v=f);v=1/0;for(var x=0;x<32&&!(m<$u);x++)d=c-m,p=c+m,tc[0]=Rt(t,i,a,r,d),tc[1]=Rt(e,n,o,s,d),f=Uu(tc,Qu),d>=0&&f<v?(c=d,v=f):(ec[0]=Rt(t,i,a,r,p),ec[1]=Rt(e,n,o,s,p),g=Uu(ec,Qu),p<=1&&g<v?(c=p,v=g):m*=.5);return u&&(u[0]=Rt(t,i,a,r,c),u[1]=Rt(e,n,o,s,c)),Xu(v)},quadraticAt:Nt,quadraticDerivativeAt:function(t,e,i,n){return 2*((1-n)*(e-t)+n*(i-e))},quadraticRootAt:function(t,e,i,n,a){var o=t-2*e+i,r=2*(e-t),s=t-n,l=0;if(zt(o))Et(r)&&(c=-s/r)>=0&&c<=1&&(a[l++]=c);else{var h=r*r-4*o*s;if(zt(h))(c=-r/(2*o))>=0&&c<=1&&(a[l++]=c);else if(h>0){var u=Xu(h),c=(-r+u)/(2*o),d=(-r-u)/(2*o);c>=0&&c<=1&&(a[l++]=c),d>=0&&d<=1&&(a[l++]=d)}}return l},quadraticExtremum:function(t,e,i){var n=t+i-2*e;return 0===n?.5:(t-e)/n},quadraticSubdivide:function(t,e,i,n,a){var o=(e-t)*n+t,r=(i-e)*n+e,s=(r-o)*n+o;a[0]=t,a[1]=o,a[2]=s,a[3]=s,a[4]=r,a[5]=i},quadraticProjectPoint:function(t,e,i,n,a,o,r,s,l){var h,u=.005,c=1/0;Qu[0]=r,Qu[1]=s;for(var d=0;d<1;d+=.05)tc[0]=Nt(t,i,a,d),tc[1]=Nt(e,n,o,d),(m=Uu(Qu,tc))<c&&(h=d,c=m);c=1/0;for(var p=0;p<32&&!(u<$u);p++){var f=h-u,g=h+u;tc[0]=Nt(t,i,a,f),tc[1]=Nt(e,n,o,f);var m=Uu(tc,Qu);if(f>=0&&m<c)h=f,c=m;else{ec[0]=Nt(t,i,a,g),ec[1]=Nt(e,n,o,g);var v=Uu(ec,Qu);g<=1&&v<c?(h=g,c=v):u*=.5}}return l&&(l[0]=Nt(t,i,a,h),l[1]=Nt(e,n,o,h)),Xu(c)}},nc=Math.min,ac=Math.max,oc=Math.sin,rc=Math.cos,sc=2*Math.PI,lc=ll.create(),hc=ll.create(),uc=ll.create(),cc=[],dc=[],pc={fromPoints:function(t,e,i){if(0!==t.length){var n,a=t[0],o=a[0],r=a[0],s=a[1],l=a[1];for(n=1;n<t.length;n++)a=t[n],o=nc(o,a[0]),r=ac(r,a[0]),s=nc(s,a[1]),l=ac(l,a[1]);e[0]=o,e[1]=s,i[0]=r,i[1]=l}},fromLine:function(t,e,i,n,a,o){a[0]=nc(t,i),a[1]=nc(e,n),o[0]=ac(t,i),o[1]=ac(e,n)},fromCubic:function(t,e,i,n,a,o,r,s,l,h){var u,c=ic.cubicExtrema,d=ic.cubicAt,p=c(t,i,a,r,cc);for(l[0]=1/0,l[1]=1/0,h[0]=-1/0,h[1]=-1/0,u=0;u<p;u++){var f=d(t,i,a,r,cc[u]);l[0]=nc(f,l[0]),h[0]=ac(f,h[0])}for(p=c(e,n,o,s,dc),u=0;u<p;u++){var g=d(e,n,o,s,dc[u]);l[1]=nc(g,l[1]),h[1]=ac(g,h[1])}l[0]=nc(t,l[0]),h[0]=ac(t,h[0]),l[0]=nc(r,l[0]),h[0]=ac(r,h[0]),l[1]=nc(e,l[1]),h[1]=ac(e,h[1]),l[1]=nc(s,l[1]),h[1]=ac(s,h[1])},fromQuadratic:function(t,e,i,n,a,o,r,s){var l=ic.quadraticExtremum,h=ic.quadraticAt,u=ac(nc(l(t,i,a),1),0),c=ac(nc(l(e,n,o),1),0),d=h(t,i,a,u),p=h(e,n,o,c);r[0]=nc(t,a,d),r[1]=nc(e,o,p),s[0]=ac(t,a,d),s[1]=ac(e,o,p)},fromArc:function(t,e,i,n,a,o,r,s,l){var h=ll.min,u=ll.max,c=Math.abs(a-o);if(c%sc<1e-4&&c>1e-4)return s[0]=t-i,s[1]=e-n,l[0]=t+i,void(l[1]=e+n);if(lc[0]=rc(a)*i+t,lc[1]=oc(a)*n+e,hc[0]=rc(o)*i+t,hc[1]=oc(o)*n+e,h(s,lc,hc),u(l,lc,hc),(a%=sc)<0&&(a+=sc),(o%=sc)<0&&(o+=sc),a>o&&!r?o+=sc:a<o&&r&&(a+=sc),r){var d=o;o=a,a=d}for(var p=0;p<o;p+=Math.PI/2)p>a&&(uc[0]=rc(p)*i+t,uc[1]=oc(p)*n+e,h(s,uc,s),u(l,uc,l))}},fc=Fl.devicePixelRatio,gc={M:1,L:2,C:3,Q:4,A:5,Z:6,R:7},mc=[],vc=[],yc=[],xc=[],_c=Math.min,bc=Math.max,wc=Math.cos,Sc=Math.sin,Mc=Math.sqrt,Ic=Math.abs,Tc="undefined"!=typeof Float32Array,Ac=function(t){this._saveData=!t,this._saveData&&(this.data=[]),this._ctx=null};Ac.prototype={constructor:Ac,_xi:0,_yi:0,_x0:0,_y0:0,_ux:0,_uy:0,_len:0,_lineDash:null,_dashOffset:0,_dashIdx:0,_dashSum:0,setScale:function(t,e){this._ux=Ic(1/fc/t)||0,this._uy=Ic(1/fc/e)||0},getContext:function(){return this._ctx},beginPath:function(t){return this._ctx=t,t&&t.beginPath(),t&&(this.dpr=t.dpr),this._saveData&&(this._len=0),this._lineDash&&(this._lineDash=null,this._dashOffset=0),this},moveTo:function(t,e){return this.addData(gc.M,t,e),this._ctx&&this._ctx.moveTo(t,e),this._x0=t,this._y0=e,this._xi=t,this._yi=e,this},lineTo:function(t,e){var i=Ic(t-this._xi)>this._ux||Ic(e-this._yi)>this._uy||this._len<5;return this.addData(gc.L,t,e),this._ctx&&i&&(this._needsDash()?this._dashedLineTo(t,e):this._ctx.lineTo(t,e)),i&&(this._xi=t,this._yi=e),this},bezierCurveTo:function(t,e,i,n,a,o){return this.addData(gc.C,t,e,i,n,a,o),this._ctx&&(this._needsDash()?this._dashedBezierTo(t,e,i,n,a,o):this._ctx.bezierCurveTo(t,e,i,n,a,o)),this._xi=a,this._yi=o,this},quadraticCurveTo:function(t,e,i,n){return this.addData(gc.Q,t,e,i,n),this._ctx&&(this._needsDash()?this._dashedQuadraticTo(t,e,i,n):this._ctx.quadraticCurveTo(t,e,i,n)),this._xi=i,this._yi=n,this},arc:function(t,e,i,n,a,o){return this.addData(gc.A,t,e,i,i,n,a-n,0,o?0:1),this._ctx&&this._ctx.arc(t,e,i,n,a,o),this._xi=wc(a)*i+t,this._yi=Sc(a)*i+t,this},arcTo:function(t,e,i,n,a){return this._ctx&&this._ctx.arcTo(t,e,i,n,a),this},rect:function(t,e,i,n){return this._ctx&&this._ctx.rect(t,e,i,n),this.addData(gc.R,t,e,i,n),this},closePath:function(){this.addData(gc.Z);var t=this._ctx,e=this._x0,i=this._y0;return t&&(this._needsDash()&&this._dashedLineTo(e,i),t.closePath()),this._xi=e,this._yi=i,this},fill:function(t){t&&t.fill(),this.toStatic()},stroke:function(t){t&&t.stroke(),this.toStatic()},setLineDash:function(t){if(t instanceof Array){this._lineDash=t,this._dashIdx=0;for(var e=0,i=0;i<t.length;i++)e+=t[i];this._dashSum=e}return this},setLineDashOffset:function(t){return this._dashOffset=t,this},len:function(){return this._len},setData:function(t){var e=t.length;this.data&&this.data.length==e||!Tc||(this.data=new Float32Array(e));for(var i=0;i<e;i++)this.data[i]=t[i];this._len=e},appendPath:function(t){t instanceof Array||(t=[t]);for(var e=t.length,i=0,n=this._len,a=0;a<e;a++)i+=t[a].len();Tc&&this.data instanceof Float32Array&&(this.data=new Float32Array(n+i));for(a=0;a<e;a++)for(var o=t[a].data,r=0;r<o.length;r++)this.data[n++]=o[r];this._len=n},addData:function(t){var e=arguments;if(this._saveData){var i=this.data;this._len+arguments.length>i.length&&(this._expandData(),i=this.data);for(var n=0;n<arguments.length;n++)i[this._len++]=e[n];this._prevCmd=t}},_expandData:function(){if(!(this.data instanceof Array)){for(var t=[],e=0;e<this._len;e++)t[e]=this.data[e];this.data=t}},_needsDash:function(){return this._lineDash},_dashedLineTo:function(t,e){var i,n,a=this._dashSum,o=this._dashOffset,r=this._lineDash,s=this._ctx,l=this._xi,h=this._yi,u=t-l,c=e-h,d=Mc(u*u+c*c),p=l,f=h,g=r.length;for(u/=d,c/=d,o<0&&(o=a+o),p-=(o%=a)*u,f-=o*c;u>0&&p<=t||u<0&&p>=t||0==u&&(c>0&&f<=e||c<0&&f>=e);)p+=u*(i=r[n=this._dashIdx]),f+=c*i,this._dashIdx=(n+1)%g,u>0&&p<l||u<0&&p>l||c>0&&f<h||c<0&&f>h||s[n%2?"moveTo":"lineTo"](u>=0?_c(p,t):bc(p,t),c>=0?_c(f,e):bc(f,e));u=p-t,c=f-e,this._dashOffset=-Mc(u*u+c*c)},_dashedBezierTo:function(t,e,i,n,a,o){var r,s,l,h,u,c=this._dashSum,d=this._dashOffset,p=this._lineDash,f=this._ctx,g=this._xi,m=this._yi,v=ic.cubicAt,y=0,x=this._dashIdx,_=p.length,b=0;for(d<0&&(d=c+d),d%=c,r=0;r<1;r+=.1)s=v(g,t,i,a,r+.1)-v(g,t,i,a,r),l=v(m,e,n,o,r+.1)-v(m,e,n,o,r),y+=Mc(s*s+l*l);for(;x<_&&!((b+=p[x])>d);x++);for(r=(b-d)/y;r<=1;)h=v(g,t,i,a,r),u=v(m,e,n,o,r),x%2?f.moveTo(h,u):f.lineTo(h,u),r+=p[x]/y,x=(x+1)%_;x%2!=0&&f.lineTo(a,o),s=a-h,l=o-u,this._dashOffset=-Mc(s*s+l*l)},_dashedQuadraticTo:function(t,e,i,n){var a=i,o=n;i=(i+2*t)/3,n=(n+2*e)/3,t=(this._xi+2*t)/3,e=(this._yi+2*e)/3,this._dashedBezierTo(t,e,i,n,a,o)},toStatic:function(){var t=this.data;t instanceof Array&&(t.length=this._len,Tc&&(this.data=new Float32Array(t)))},getBoundingRect:function(){mc[0]=mc[1]=yc[0]=yc[1]=Number.MAX_VALUE,vc[0]=vc[1]=xc[0]=xc[1]=-Number.MAX_VALUE;for(var t=this.data,e=0,i=0,n=0,a=0,o=0;o<t.length;){var r=t[o++];switch(1==o&&(n=e=t[o],a=i=t[o+1]),r){case gc.M:e=n=t[o++],i=a=t[o++],yc[0]=n,yc[1]=a,xc[0]=n,xc[1]=a;break;case gc.L:pc.fromLine(e,i,t[o],t[o+1],yc,xc),e=t[o++],i=t[o++];break;case gc.C:pc.fromCubic(e,i,t[o++],t[o++],t[o++],t[o++],t[o],t[o+1],yc,xc),e=t[o++],i=t[o++];break;case gc.Q:pc.fromQuadratic(e,i,t[o++],t[o++],t[o],t[o+1],yc,xc),e=t[o++],i=t[o++];break;case gc.A:var s=t[o++],l=t[o++],h=t[o++],u=t[o++],c=t[o++],d=t[o++]+c,p=(t[o++],1-t[o++]);1==o&&(n=wc(c)*h+s,a=Sc(c)*u+l),pc.fromArc(s,l,h,u,c,d,p,yc,xc),e=wc(d)*h+s,i=Sc(d)*u+l;break;case gc.R:n=e=t[o++],a=i=t[o++];var f=t[o++],g=t[o++];pc.fromLine(n,a,n+f,a+g,yc,xc);break;case gc.Z:e=n,i=a}ll.min(mc,mc,yc),ll.max(vc,vc,xc)}return 0===o&&(mc[0]=mc[1]=vc[0]=vc[1]=0),new oh(mc[0],mc[1],vc[0]-mc[0],vc[1]-mc[1])},rebuildPath:function(t){for(var e,i,n,a,o,r,s=this.data,l=this._ux,h=this._uy,u=this._len,c=0;c<u;){var d=s[c++];switch(1==c&&(e=n=s[c],i=a=s[c+1]),d){case gc.M:e=n=s[c++],i=a=s[c++],t.moveTo(n,a);break;case gc.L:o=s[c++],r=s[c++],(Ic(o-n)>l||Ic(r-a)>h||c===u-1)&&(t.lineTo(o,r),n=o,a=r);break;case gc.C:t.bezierCurveTo(s[c++],s[c++],s[c++],s[c++],s[c++],s[c++]),n=s[c-2],a=s[c-1];break;case gc.Q:t.quadraticCurveTo(s[c++],s[c++],s[c++],s[c++]),n=s[c-2],a=s[c-1];break;case gc.A:var p=s[c++],f=s[c++],g=s[c++],m=s[c++],v=s[c++],y=s[c++],x=s[c++],_=s[c++],b=g>m?g:m,w=g>m?1:g/m,S=g>m?m/g:1,M=v+y;Math.abs(g-m)>.001?(t.translate(p,f),t.rotate(x),t.scale(w,S),t.arc(0,0,b,v,M,1-_),t.scale(1/w,1/S),t.rotate(-x),t.translate(-p,-f)):t.arc(p,f,b,v,M,1-_),1==c&&(e=wc(v)*g+p,i=Sc(v)*m+f),n=wc(M)*g+p,a=Sc(M)*m+f;break;case gc.R:e=n=s[c],i=a=s[c+1],t.rect(s[c++],s[c++],s[c++],s[c++]);break;case gc.Z:t.closePath(),n=e,a=i}}}},Ac.CMD=gc;var Cc=Ac,Lc={containStroke:function(t,e,i,n,a,o,r){if(0===a)return!1;var s=a,l=0,h=t;if(r>e+s&&r>n+s||r<e-s&&r<n-s||o>t+s&&o>i+s||o<t-s&&o<i-s)return!1;if(t===i)return Math.abs(o-t)<=s/2;var u=(l=(e-n)/(t-i))*o-r+(h=(t*n-i*e)/(t-i));return u*u/(l*l+1)<=s/2*s/2}},Dc={containStroke:function(t,e,i,n,a,o,r,s,l,h,u){if(0===l)return!1;var c=l;return!(u>e+c&&u>n+c&&u>o+c&&u>s+c||u<e-c&&u<n-c&&u<o-c&&u<s-c||h>t+c&&h>i+c&&h>a+c&&h>r+c||h<t-c&&h<i-c&&h<a-c&&h<r-c)&&ic.cubicProjectPoint(t,e,i,n,a,o,r,s,h,u,null)<=c/2}},Pc=ic.quadraticProjectPoint,kc={containStroke:function(t,e,i,n,a,o,r,s,l){if(0===r)return!1;var h=r;return!(l>e+h&&l>n+h&&l>o+h||l<e-h&&l<n-h&&l<o-h||s>t+h&&s>i+h&&s>a+h||s<t-h&&s<i-h&&s<a-h)&&Pc(t,e,i,n,a,o,s,l,null)<=h/2}},Oc=2*Math.PI,zc={normalizeRadian:function(t){return(t%=Oc)<0&&(t+=Oc),t}},Ec=zc.normalizeRadian,Rc=2*Math.PI,Nc={containStroke:function(t,e,i,n,a,o,r,s,l){if(0===r)return!1;var h=r;s-=t,l-=e;var u=Math.sqrt(s*s+l*l);if(u-h>i||u+h<i)return!1;if(Math.abs(n-a)%Rc<1e-4)return!0;if(o){var c=n;n=Ec(a),a=Ec(c)}else n=Ec(n),a=Ec(a);n>a&&(a+=Rc);var d=Math.atan2(l,s);return d<0&&(d+=Rc),d>=n&&d<=a||d+Rc>=n&&d+Rc<=a}},Vc=function(t,e,i,n,a,o){if(o>e&&o>n||o<e&&o<n)return 0;if(n===e)return 0;var r=n<e?1:-1,s=(o-e)/(n-e);return 1!==s&&0!==s||(r=n<e?.5:-.5),s*(i-t)+t>a?r:0},Bc=zc.normalizeRadian,Gc=Cc.CMD,Hc=2*Math.PI,Wc=1e-4,Fc=[-1,-1,-1],Zc=[-1,-1],jc={contain:function(t,e,i){return Vt(t,0,!1,e,i)},containStroke:function(t,e,i,n){return Vt(t,e,!0,i,n)}},Uc=_h.prototype.getCanvasPattern,qc=Math.abs,Xc=new Cc(!0);Bt.prototype={constructor:Bt,type:"path",__dirtyPath:!0,strokeContainThreshold:5,brush:function(t,e){var i=this.style,n=this.path||Xc,a=i.hasStroke(),o=i.hasFill(),r=i.fill,s=i.stroke,l=o&&!!r.colorStops,h=a&&!!s.colorStops,u=o&&!!r.image,c=a&&!!s.image;if(i.bind(t,this,e),this.setTransform(t),this.__dirty){var d;l&&(d=d||this.getBoundingRect(),this._fillGradient=i.getGradient(t,r,d)),h&&(d=d||this.getBoundingRect(),this._strokeGradient=i.getGradient(t,s,d))}l?t.fillStyle=this._fillGradient:u&&(t.fillStyle=Uc.call(r,t)),h?t.strokeStyle=this._strokeGradient:c&&(t.strokeStyle=Uc.call(s,t));var p=i.lineDash,f=i.lineDashOffset,g=!!t.setLineDash,m=this.getGlobalScale();n.setScale(m[0],m[1]),this.__dirtyPath||p&&!g&&a?(n.beginPath(t),p&&!g&&(n.setLineDash(p),n.setLineDashOffset(f)),this.buildPath(n,this.shape,!1),this.path&&(this.__dirtyPath=!1)):(t.beginPath(),this.path.rebuildPath(t)),o&&n.fill(t),p&&g&&(t.setLineDash(p),t.lineDashOffset=f),a&&n.stroke(t),p&&g&&t.setLineDash([]),this.restoreTransform(t),null!=i.text&&this.drawRectText(t,this.getBoundingRect())},buildPath:function(t,e,i){},createPathProxy:function(){this.path=new Cc},getBoundingRect:function(){var t=this._rect,e=this.style,i=!t;if(i){var n=this.path;n||(n=this.path=new Cc),this.__dirtyPath&&(n.beginPath(),this.buildPath(n,this.shape,!1)),t=n.getBoundingRect()}if(this._rect=t,e.hasStroke()){var a=this._rectWithStroke||(this._rectWithStroke=t.clone());if(this.__dirty||i){a.copy(t);var o=e.lineWidth,r=e.strokeNoScale?this.getLineScale():1;e.hasFill()||(o=Math.max(o,this.strokeContainThreshold||4)),r>1e-10&&(a.width+=o/r,a.height+=o/r,a.x-=o/r/2,a.y-=o/r/2)}return a}return t},contain:function(t,e){var i=this.transformCoordToLocal(t,e),n=this.getBoundingRect(),a=this.style;if(t=i[0],e=i[1],n.contain(t,e)){var o=this.path.data;if(a.hasStroke()){var r=a.lineWidth,s=a.strokeNoScale?this.getLineScale():1;if(s>1e-10&&(a.hasFill()||(r=Math.max(r,this.strokeContainThreshold)),jc.containStroke(o,r/s,t,e)))return!0}if(a.hasFill())return jc.contain(o,t,e)}return!1},dirty:function(t){null==t&&(t=!0),t&&(this.__dirtyPath=t,this._rect=null),this.__dirty=!0,this.__zr&&this.__zr.refresh(),this.__clipTarget&&this.__clipTarget.dirty()},animateShape:function(t){return this.animate("shape",t)},attrKV:function(t,e){"shape"===t?(this.setShape(e),this.__dirtyPath=!0,this._rect=null):Kh.prototype.attrKV.call(this,t,e)},setShape:function(t,e){var i=this.shape;if(i){if(rl.isObject(t))for(var n in t)t.hasOwnProperty(n)&&(i[n]=t[n]);else i[t]=e;this.dirty(!0)}return this},getLineScale:function(){var t=this.transform;return t&&qc(t[0]-1)>1e-10&&qc(t[3]-1)>1e-10?Math.sqrt(qc(t[0]*t[3]-t[2]*t[1])):1}},Bt.extend=function(t){var e=function(e){Bt.call(this,e),t.style&&this.style.extendFrom(t.style,!1);var i=t.shape;if(i){this.shape=this.shape||{};var n=this.shape;for(var a in i)!n.hasOwnProperty(a)&&i.hasOwnProperty(a)&&(n[a]=i[a])}t.init&&t.init.call(this,e)};rl.inherits(e,Bt);for(var i in t)"style"!==i&&"shape"!==i&&(e.prototype[i]=t[i]);return e},rl.inherits(Bt,Kh);var Yc=Bt,$c=ll.applyTransform,Kc=Cc.CMD,Jc=[[],[],[]],Qc=Math.sqrt,td=Math.atan2,ed=function(t,e){var i,n,a,o,r,s=t.data,l=Kc.M,h=Kc.C,u=Kc.L,c=Kc.R,d=Kc.A,p=Kc.Q;for(a=0,o=0;a<s.length;){switch(i=s[a++],o=a,n=0,i){case l:case u:n=1;break;case h:n=3;break;case p:n=2;break;case d:var f=e[4],g=e[5],m=Qc(e[0]*e[0]+e[1]*e[1]),v=Qc(e[2]*e[2]+e[3]*e[3]),y=td(-e[1]/v,e[0]/m);s[a]*=m,s[a++]+=f,s[a]*=v,s[a++]+=g,s[a++]*=m,s[a++]*=v,s[a++]+=y,s[a++]+=y,o=a+=2;break;case c:x[0]=s[a++],x[1]=s[a++],$c(x,x,e),s[o++]=x[0],s[o++]=x[1],x[0]+=s[a++],x[1]+=s[a++],$c(x,x,e),s[o++]=x[0],s[o++]=x[1]}for(r=0;r<n;r++){var x;(x=Jc[r])[0]=s[a++],x[1]=s[a++],$c(x,x,e),s[o++]=x[0],s[o++]=x[1]}}},id=["m","M","l","L","v","V","h","H","z","Z","c","C","q","Q","t","T","s","S","a","A"],nd=Math.sqrt,ad=Math.sin,od=Math.cos,rd=Math.PI,sd=function(t){return Math.sqrt(t[0]*t[0]+t[1]*t[1])},ld=function(t,e){return(t[0]*e[0]+t[1]*e[1])/(sd(t)*sd(e))},hd=function(t,e){return(t[0]*e[1]<t[1]*e[0]?-1:1)*Math.acos(ld(t,e))},ud={createFromString:function(t,e){return new Yc(Ht(t,e))},extendFromString:function(t,e){return Yc.extend(Ht(t,e))},mergePath:function(t,e){for(var i=[],n=t.length,a=0;a<n;a++){var o=t[a];o.path||o.createPathProxy(),o.__dirtyPath&&o.buildPath(o.path,o.shape,!0),i.push(o.path)}var r=new Yc(e);return r.createPathProxy(),r.buildPath=function(t){t.appendPath(i);var e=t.getContext();e&&t.rebuildPath(e)},r}},cd=function(t){Kh.call(this,t)};cd.prototype={constructor:cd,type:"text",brush:function(t,e){var i=this.style;this.__dirty&&qh.normalizeTextStyle(i,!0),i.fill=i.stroke=i.shadowBlur=i.shadowColor=i.shadowOffsetX=i.shadowOffsetY=null;var n=i.text;null!=n&&(n+=""),i.bind(t,this,e),qh.needDrawText(n,i)&&(this.setTransform(t),qh.renderText(this,t,n,i),this.restoreTransform(t))},getBoundingRect:function(){var t=this.style;if(this.__dirty&&qh.normalizeTextStyle(t,!0),!this._rect){var e=t.text;null!=e?e+="":e="";var i=Nh.getBoundingRect(t.text+"",t.font,t.textAlign,t.textVerticalAlign,t.textPadding,t.rich);if(i.x+=t.x||0,i.y+=t.y||0,qh.getStroke(t.textStroke,t.textStrokeWidth)){var n=t.textStrokeWidth;i.x-=n/2,i.y-=n/2,i.width+=n,i.height+=n}this._rect=i}return this._rect}},rl.inherits(cd,Kh);var dd=cd,pd=Yc.extend({type:"circle",shape:{cx:0,cy:0,r:0},buildPath:function(t,e,i){i&&t.moveTo(e.cx+e.r,e.cy),t.arc(e.cx,e.cy,e.r,0,2*Math.PI,!0)}}),fd=[["shadowBlur",0],["shadowColor","#000"],["shadowOffsetX",0],["shadowOffsetY",0]],gd=function(t){return Us.browser.ie&&Us.browser.version>=11?function(){var e,i=this.__clipPaths,n=this.style;if(i)for(var a=0;a<i.length;a++){var o=i[a],r=o&&o.shape,s=o&&o.type;if(r&&("sector"===s&&r.startAngle===r.endAngle||"rect"===s&&(!r.width||!r.height))){for(l=0;l<fd.length;l++)fd[l][2]=n[fd[l][0]],n[fd[l][0]]=fd[l][1];e=!0;break}}if(t.apply(this,arguments),e)for(var l=0;l<fd.length;l++)n[fd[l][0]]=fd[l][2]}:t},md=Yc.extend({type:"sector",shape:{cx:0,cy:0,r0:0,r:0,startAngle:0,endAngle:2*Math.PI,clockwise:!0},brush:gd(Yc.prototype.brush),buildPath:function(t,e){var i=e.cx,n=e.cy,a=Math.max(e.r0||0,0),o=Math.max(e.r,0),r=e.startAngle,s=e.endAngle,l=e.clockwise,h=Math.cos(r),u=Math.sin(r);t.moveTo(h*a+i,u*a+n),t.lineTo(h*o+i,u*o+n),t.arc(i,n,o,r,s,!l),t.lineTo(Math.cos(s)*a+i,Math.sin(s)*a+n),0!==a&&t.arc(i,n,a,s,r,l),t.closePath()}}),vd=Yc.extend({type:"ring",shape:{cx:0,cy:0,r:0,r0:0},buildPath:function(t,e){var i=e.cx,n=e.cy,a=2*Math.PI;t.moveTo(i+e.r,n),t.arc(i,n,e.r,0,a,!1),t.moveTo(i+e.r0,n),t.arc(i,n,e.r0,0,a,!0)}}),yd=ll.distance,xd=function(t,e){for(var i=t.length,n=[],a=0,o=1;o<i;o++)a+=yd(t[o-1],t[o]);var r=a/2;for(r=r<i?i:r,o=0;o<r;o++){var s,l,h,u=o/(r-1)*(e?i:i-1),c=Math.floor(u),d=u-c,p=t[c%i];e?(s=t[(c-1+i)%i],l=t[(c+1)%i],h=t[(c+2)%i]):(s=t[0===c?c:c-1],l=t[c>i-2?i-1:c+1],h=t[c>i-3?i-1:c+2]);var f=d*d,g=d*f;n.push([Wt(s[0],p[0],l[0],h[0],d,f,g),Wt(s[1],p[1],l[1],h[1],d,f,g)])}return n},_d=ll.min,bd=ll.max,wd=ll.scale,Sd=ll.distance,Md=ll.add,Id=ll.clone,Td=ll.sub,Ad=function(t,e,i,n){var a,o,r,s,l=[],h=[],u=[],c=[];if(n){r=[1/0,1/0],s=[-1/0,-1/0];for(var d=0,p=t.length;d<p;d++)_d(r,r,t[d]),bd(s,s,t[d]);_d(r,r,n[0]),bd(s,s,n[1])}for(var d=0,p=t.length;d<p;d++){var f=t[d];if(i)a=t[d?d-1:p-1],o=t[(d+1)%p];else{if(0===d||d===p-1){l.push(Id(t[d]));continue}a=t[d-1],o=t[d+1]}Td(h,o,a),wd(h,h,e);var g=Sd(f,a),m=Sd(f,o),v=g+m;0!==v&&(g/=v,m/=v),wd(u,h,-g),wd(c,h,m);var y=Md([],f,u),x=Md([],f,c);n&&(bd(y,y,r),_d(y,y,s),bd(x,x,r),_d(x,x,s)),l.push(y),l.push(x)}return i&&l.push(l.shift()),l},Cd={buildPath:function(t,e,i){var n=e.points,a=e.smooth;if(n&&n.length>=2){if(a&&"spline"!==a){var o=Ad(n,a,i,e.smoothConstraint);t.moveTo(n[0][0],n[0][1]);for(var r=n.length,s=0;s<(i?r:r-1);s++){var l=o[2*s],h=o[2*s+1],u=n[(s+1)%r];t.bezierCurveTo(l[0],l[1],h[0],h[1],u[0],u[1])}}else{"spline"===a&&(n=xd(n,i)),t.moveTo(n[0][0],n[0][1]);for(var s=1,c=n.length;s<c;s++)t.lineTo(n[s][0],n[s][1])}i&&t.closePath()}}},Ld=Yc.extend({type:"polygon",shape:{points:null,smooth:!1,smoothConstraint:null},buildPath:function(t,e){Cd.buildPath(t,e,!0)}}),Dd=Yc.extend({type:"polyline",shape:{points:null,smooth:!1,smoothConstraint:null},style:{stroke:"#000",fill:null},buildPath:function(t,e){Cd.buildPath(t,e,!1)}}),Pd=Yc.extend({type:"rect",shape:{r:0,x:0,y:0,width:0,height:0},buildPath:function(t,e){var i=e.x,n=e.y,a=e.width,o=e.height;e.r?Vh.buildPath(t,e):t.rect(i,n,a,o),t.closePath()}}),kd=Yc.extend({type:"line",shape:{x1:0,y1:0,x2:0,y2:0,percent:1},style:{stroke:"#000",fill:null},buildPath:function(t,e){var i=e.x1,n=e.y1,a=e.x2,o=e.y2,r=e.percent;0!==r&&(t.moveTo(i,n),r<1&&(a=i*(1-r)+a*r,o=n*(1-r)+o*r),t.lineTo(a,o))},pointAt:function(t){var e=this.shape;return[e.x1*(1-t)+e.x2*t,e.y1*(1-t)+e.y2*t]}}),Od=ic.quadraticSubdivide,zd=ic.cubicSubdivide,Ed=ic.quadraticAt,Rd=ic.cubicAt,Nd=ic.quadraticDerivativeAt,Vd=ic.cubicDerivativeAt,Bd=[],Gd=Yc.extend({type:"bezier-curve",shape:{x1:0,y1:0,x2:0,y2:0,cpx1:0,cpy1:0,percent:1},style:{stroke:"#000",fill:null},buildPath:function(t,e){var i=e.x1,n=e.y1,a=e.x2,o=e.y2,r=e.cpx1,s=e.cpy1,l=e.cpx2,h=e.cpy2,u=e.percent;0!==u&&(t.moveTo(i,n),null==l||null==h?(u<1&&(Od(i,r,a,u,Bd),r=Bd[1],a=Bd[2],Od(n,s,o,u,Bd),s=Bd[1],o=Bd[2]),t.quadraticCurveTo(r,s,a,o)):(u<1&&(zd(i,r,l,a,u,Bd),r=Bd[1],l=Bd[2],a=Bd[3],zd(n,s,h,o,u,Bd),s=Bd[1],h=Bd[2],o=Bd[3]),t.bezierCurveTo(r,s,l,h,a,o)))},pointAt:function(t){return Ft(this.shape,t,!1)},tangentAt:function(t){var e=Ft(this.shape,t,!0);return ll.normalize(e,e)}}),Hd=Yc.extend({type:"arc",shape:{cx:0,cy:0,r:0,startAngle:0,endAngle:2*Math.PI,clockwise:!0},style:{stroke:"#000",fill:null},buildPath:function(t,e){var i=e.cx,n=e.cy,a=Math.max(e.r,0),o=e.startAngle,r=e.endAngle,s=e.clockwise,l=Math.cos(o),h=Math.sin(o);t.moveTo(l*a+i,h*a+n),t.arc(i,n,a,o,r,!s)}}),Wd=Yc.extend({type:"compound",shape:{paths:null},_updatePathDirty:function(){for(var t=this.__dirtyPath,e=this.shape.paths,i=0;i<e.length;i++)t=t||e[i].__dirtyPath;this.__dirtyPath=t,this.__dirty=this.__dirty||t},beforeBrush:function(){this._updatePathDirty();for(var t=this.shape.paths||[],e=this.getGlobalScale(),i=0;i<t.length;i++)t[i].path||t[i].createPathProxy(),t[i].path.setScale(e[0],e[1])},buildPath:function(t,e){for(var i=e.paths||[],n=0;n<i.length;n++)i[n].buildPath(t,i[n].shape,!0)},afterBrush:function(){for(var t=this.shape.paths||[],e=0;e<t.length;e++)t[e].__dirtyPath=!1},getBoundingRect:function(){return this._updatePathDirty(),Yc.prototype.getBoundingRect.call(this)}}),Fd=function(t){this.colorStops=t||[]};Fd.prototype={constructor:Fd,addColorStop:function(t,e){this.colorStops.push({offset:t,color:e})}};var Zd=Fd,jd=function(t,e,i,n,a,o){this.x=null==t?0:t,this.y=null==e?0:e,this.x2=null==i?1:i,this.y2=null==n?0:n,this.type="linear",this.global=o||!1,Zd.call(this,a)};jd.prototype={constructor:jd},rl.inherits(jd,Zd);var Ud=jd,qd=function(t,e,i,n,a){this.x=null==t?.5:t,this.y=null==e?.5:e,this.r=null==i?.5:i,this.type="radial",this.global=a||!1,Zd.call(this,n)};qd.prototype={constructor:qd},rl.inherits(qd,Zd);var Xd=Jh,Yd=sh,$d=dd,Kd=pd,Jd=md,Qd=vd,tp=Ld,ep=Dd,ip=Pd,np=kd,ap=Gd,op=Hd,rp=Wd,sp=Ud,lp=qd,hp=oh,up=Math.round,cp=Math.max,dp=Math.min,pp={},fp={Image:Xd,Group:Yd,Text:$d,Circle:Kd,Sector:Jd,Ring:Qd,Polygon:tp,Polyline:ep,Rect:ip,Line:np,BezierCurve:ap,Arc:op,CompoundPath:rp,LinearGradient:sp,RadialGradient:lp,BoundingRect:hp,extendShape:function(t){return Yc.extend(t)},extendPath:function(t,e){return ud.extendFromString(t,e)},makePath:Zt,makeImage:function(t,e,i){var n=new Jh({style:{image:t,x:e.x,y:e.y,width:e.width,height:e.height},onload:function(t){if("center"===i){var a={width:t.width,height:t.height};n.setStyle(jt(e,a))}}});return n},mergePath:ud.mergePath,resizePath:Ut,subPixelOptimizeLine:function(t){var e=t.shape,i=t.style.lineWidth;return up(2*e.x1)===up(2*e.x2)&&(e.x1=e.x2=qt(e.x1,i,!0)),up(2*e.y1)===up(2*e.y2)&&(e.y1=e.y2=qt(e.y1,i,!0)),t},subPixelOptimizeRect:function(t){var e=t.shape,i=t.style.lineWidth,n=e.x,a=e.y,o=e.width,r=e.height;return e.x=qt(e.x,i,!0),e.y=qt(e.y,i,!0),e.width=Math.max(qt(n+o,i,!1)-e.x,0===o?0:1),e.height=Math.max(qt(a+r,i,!1)-e.y,0===r?0:1),t},subPixelOptimize:qt,setHoverStyle:function(t,e,i){t.__hoverSilentOnTouch=i&&i.hoverSilentOnTouch,"group"===t.type?t.traverse(function(t){"group"!==t.type&&ee(t,e)}):ee(t,e),t.on("mouseover",function(t){this.__hoverSilentOnTouch&&t.zrByTouch||!this.__isEmphasis&&Qt(this)}).on("mouseout",function(t){this.__hoverSilentOnTouch&&t.zrByTouch||!this.__isEmphasis&&te(this)}),t.on("emphasis",function(){this.__isEmphasis=!0,Qt(this)}).on("normal",function(){this.__isEmphasis=!1,te(this)})},setLabelStyle:function(t,e,i,n,a,o,r){var s=(a=a||pp).labelFetcher,l=a.labelDataIndex,h=a.labelDimIndex,u=i.getShallow("show"),c=n.getShallow("show"),d=u||c?rl.retrieve2(s?s.getFormattedLabel(l,"normal",null,h):null,a.defaultText):null,p=u?d:null,f=c?rl.retrieve2(s?s.getFormattedLabel(l,"emphasis",null,h):null,d):null;null==p&&null==f||(ie(t,i,o,a),ie(e,n,r,a,!0)),t.text=p,e.text=f},setTextStyle:ie,setText:function(t,e,i){var n,a={isRectText:!0};!1===i?n=!0:a.autoColor=i,ne(t,e,a,n),t.host&&t.host.dirty&&t.host.dirty(!1)},getFont:function(t,e){var i=e||e.getModel("textStyle");return[t.fontStyle||i&&i.getShallow("fontStyle")||"",t.fontWeight||i&&i.getShallow("fontWeight")||"",(t.fontSize||i&&i.getShallow("fontSize")||12)+"px",t.fontFamily||i&&i.getShallow("fontFamily")||"sans-serif"].join(" ")},updateProps:le,initProps:function(t,e,i,n,a){se(!1,t,e,i,n,a)},getTransform:function(t,e){for(var i=yl.identity([]);t&&t!==e;)yl.mul(i,t.getLocalTransform(),i),t=t.parent;return i},applyTransform:he,transformDirection:function(t,e,i){var n=0===e[4]||0===e[5]||0===e[0]?1:Math.abs(2*e[4]/e[0]),a=0===e[4]||0===e[5]||0===e[2]?1:Math.abs(2*e[4]/e[2]),o=["left"===t?-n:"right"===t?n:0,"top"===t?-a:"bottom"===t?a:0];return o=he(o,e,i),Math.abs(o[0])>Math.abs(o[1])?o[0]>0?"right":"left":o[1]>0?"bottom":"top"},groupTransition:function(t,e,i,n){function a(t){var e={position:ll.clone(t.position),rotation:t.rotation};return t.shape&&(e.shape=rl.extend({},t.shape)),e}if(t&&e){var o=function(e){var i={};return t.traverse(function(t){!t.isGroup&&t.anid&&(i[t.anid]=t)}),i}();e.traverse(function(t){if(!t.isGroup&&t.anid){var e=o[t.anid];if(e){var n=a(t);t.attr(a(e)),le(t,n,i,t.dataIndex)}}})}},clipPointsByRect:function(t,e){return rl.map(t,function(t){var i=t[0];i=cp(i,e.x),i=dp(i,e.x+e.width);var n=t[1];return n=cp(n,e.y),n=dp(n,e.y+e.height),[i,n]})},clipRectByRect:function(t,e){var i=cp(t.x,e.x),n=dp(t.x+t.width,e.x+e.width),a=cp(t.y,e.y),o=dp(t.y+t.height,e.y+e.height);if(n>=i&&o>=a)return{x:i,y:a,width:n-i,height:o-a}},createIcon:function(t,e,i){var n=(e=rl.extend({rectHover:!0},e)).style={strokeNoScale:!0};if(i=i||{x:-1,y:-1,width:2,height:2},t)return 0===t.indexOf("image://")?(n.image=t.slice(8),rl.defaults(n,i),new Jh(e)):Zt(t.replace("path://",""),e,i,"center")}},gp=["textStyle","color"],mp={getTextColor:function(t){var e=this.ecModel;return this.getShallow("color")||(!t&&e?e.get(gp):null)},getFont:function(){return fp.getFont({fontStyle:this.getShallow("fontStyle"),fontWeight:this.getShallow("fontWeight"),fontSize:this.getShallow("fontSize"),fontFamily:this.getShallow("fontFamily")},this.ecModel)},getTextRect:function(t){return Nh.getBoundingRect(t,this.getFont(),this.getShallow("align"),this.getShallow("verticalAlign")||this.getShallow("baseline"),this.getShallow("padding"),this.getShallow("rich"),this.getShallow("truncateText"))}},vp=Gu([["fill","color"],["stroke","borderColor"],["lineWidth","borderWidth"],["opacity"],["shadowBlur"],["shadowOffsetX"],["shadowOffsetY"],["shadowColor"],["textPosition"],["textAlign"]]),yp={getItemStyle:function(t,e){var i=vp(this,t,e),n=this.getBorderLineDash();return n&&(i.lineDash=n),i},getBorderLineDash:function(){var t=this.get("borderType");return"solid"===t||null==t?null:"dashed"===t?[5,5]:[1,1]}},xp=rl.mixin;ue.prototype={constructor:ue,init:null,mergeOption:function(t){rl.merge(this.option,t,!0)},get:function(t,e){return null==t?this.option:ce(this.option,this.parsePath(t),!e&&de(this,t))},getShallow:function(t,e){var i=this.option,n=null==i?i:i[t],a=!e&&de(this,t);return null==n&&a&&(n=a.getShallow(t)),n},getModel:function(t,e){var i,n=null==t?this.option:ce(this.option,t=this.parsePath(t));return e=e||(i=de(this,t))&&i.getModel(t),new ue(n,e,this.ecModel)},isEmpty:function(){return null==this.option},restoreData:function(){},clone:function(){return new(0,this.constructor)(rl.clone(this.option))},setReadOnly:function(t){Bu.setReadOnly(this,t)},parsePath:function(t){return"string"==typeof t&&(t=t.split(".")),t},customizeGetParent:function(t){Bu.set(this,"getParent",t)},isAnimationEnabled:function(){if(!Us.node){if(null!=this.option.animation)return!!this.option.animation;if(this.parentModel)return this.parentModel.isAnimationEnabled()}}},Bu.enableClassExtend(ue),xp(ue,Wu),xp(ue,Zu),xp(ue,mp),xp(ue,yp);var _p=ue,bp=rl.each,wp=rl.isObject,Sp={getDataParams:function(t,e){var i=this.getData(e),n=this.getRawValue(t,e),a=i.getRawIndex(t),o=i.getName(t,!0),r=i.getRawDataItem(t),s=i.getItemVisual(t,"color");return{componentType:this.mainType,componentSubType:this.subType,seriesType:"series"===this.mainType?this.subType:null,seriesIndex:this.seriesIndex,seriesId:this.id,seriesName:this.name,name:o,dataIndex:a,data:r,dataType:e,value:n,color:s,marker:Eu.getTooltipMarker(s),$vars:["seriesName","name","value"]}},getFormattedLabel:function(t,e,i,n,a){e=e||"normal";var o=this.getData(i).getItemModel(t),r=this.getDataParams(t,i);null!=n&&r.value instanceof Array&&(r.value=r.value[n]);var s=o.get([a||"label",e,"formatter"]);return"function"==typeof s?(r.status=e,s(r)):"string"==typeof s?Eu.formatTpl(s,r):void 0},getRawValue:function(t,e){var i=this.getData(e).getRawDataItem(t);if(null!=i)return!wp(i)||i instanceof Array?i:i.value},formatTooltip:rl.noop},Mp=function(){var t=0;return function(){var e="\0__ec_prop_getter_"+t++;return function(t){return t[e]||(t[e]={})}}}(),Ip={normalizeToArray:pe,defaultEmphasis:function(t,e){if(t)for(var i=t.emphasis=t.emphasis||{},n=t.normal=t.normal||{},a=0,o=e.length;a<o;a++){var r=e[a];!i.hasOwnProperty(r)&&n.hasOwnProperty(r)&&(i[r]=n[r])}},TEXT_STYLE_OPTIONS:["fontStyle","fontWeight","fontSize","fontFamily","rich","tag","color","textBorderColor","textBorderWidth","width","height","lineHeight","align","verticalAlign","baseline","shadowColor","shadowBlur","shadowOffsetX","shadowOffsetY","textShadowColor","textShadowBlur","textShadowOffsetX","textShadowOffsetY","backgroundColor","borderColor","borderWidth","borderRadius","padding"],getDataItemValue:function(t){return t&&(null==t.value?t:t.value)},isDataItemOption:function(t){return wp(t)&&!(t instanceof Array)},converDataValue:function(t,e){var i=e&&e.type;return"ordinal"===i?t:("time"===i&&"number"!=typeof t&&null!=t&&"-"!==t&&(t=+Pu.parseDate(t)),null==t||""===t?NaN:+t)},createDataFormatModel:function(t,e){var i=new _p;return rl.mixin(i,Sp),i.seriesIndex=e.seriesIndex,i.name=e.name||"",i.mainType=e.mainType,i.subType=e.subType,i.getData=function(){return t},i},dataFormatMixin:Sp,mappingToExists:function(t,e){e=(e||[]).slice();var i=rl.map(t||[],function(t,e){return{exist:t}});return bp(e,function(t,n){if(wp(t)){for(a=0;a<i.length;a++)if(!i[a].option&&null!=t.id&&i[a].exist.id===t.id+"")return i[a].option=t,void(e[n]=null);for(var a=0;a<i.length;a++){var o=i[a].exist;if(!(i[a].option||null!=o.id&&null!=t.id||null==t.name||fe(t)||fe(o)||o.name!==t.name+""))return i[a].option=t,void(e[n]=null)}}}),bp(e,function(t,e){if(wp(t)){for(var n=0;n<i.length;n++){var a=i[n].exist;if(!i[n].option&&!fe(a)&&null==t.id){i[n].option=t;break}}n>=i.length&&i.push({option:t})}}),i},makeIdAndName:function(t){var e=rl.createHashMap();bp(t,function(t,i){var n=t.exist;n&&e.set(n.id,t)}),bp(t,function(t,i){var n=t.option;rl.assert(!n||null==n.id||!e.get(n.id)||e.get(n.id)===t,"id duplicates: "+(n&&n.id)),n&&null!=n.id&&e.set(n.id,t),!t.keyInfo&&(t.keyInfo={})}),bp(t,function(t,i){var n=t.exist,a=t.option,o=t.keyInfo;if(wp(a)){if(o.name=null!=a.name?a.name+"":n?n.name:"\0-",n)o.id=n.id;else if(null!=a.id)o.id=a.id+"";else{var r=0;do{o.id="\0"+o.name+"\0"+r++}while(e.get(o.id))}e.set(o.id,t)}})},isIdInner:fe,compressBatches:function(t,e){function i(t,e,i){for(var n=0,a=t.length;n<a;n++)for(var o=t[n].seriesId,r=pe(t[n].dataIndex),s=i&&i[o],l=0,h=r.length;l<h;l++){var u=r[l];s&&s[u]?s[u]=null:(e[o]||(e[o]={}))[u]=1}}function n(t,e){var i=[];for(var a in t)if(t.hasOwnProperty(a)&&null!=t[a])if(e)i.push(+a);else{var o=n(t[a],!0);o.length&&i.push({seriesId:a,dataIndex:o})}return i}var a={},o={};return i(t||[],a),i(e||[],o,a),[n(a),n(o)]},queryDataIndex:function(t,e){return null!=e.dataIndexInside?e.dataIndexInside:null!=e.dataIndex?rl.isArray(e.dataIndex)?rl.map(e.dataIndex,function(e){return t.indexOfRawIndex(e)}):t.indexOfRawIndex(e.dataIndex):null!=e.name?rl.isArray(e.name)?rl.map(e.name,function(e){return t.indexOfName(e)}):t.indexOfName(e.name):void 0},makeGetter:Mp,parseFinder:function(t,e,i){if(rl.isString(e)){var n={};n[e+"Index"]=0,e=n}var a=i&&i.defaultMainType;!a||ge(e,a+"Index")||ge(e,a+"Id")||ge(e,a+"Name")||(e[a+"Index"]=0);var o={};return bp(e,function(n,a){if(n=e[a],"dataIndex"!==a&&"dataIndexInside"!==a){var r=a.match(/^(\w+)(Index|Id|Name)$/)||[],s=r[1],l=(r[2]||"").toLowerCase();if(!(!s||!l||null==n||"index"===l&&"none"===n||i&&i.includeMainTypes&&rl.indexOf(i.includeMainTypes,s)<0)){var h={mainType:s};"index"===l&&"all"===n||(h[l]=n);var u=t.queryComponents(h);o[s+"Models"]=u,o[s+"Model"]=u[0]}}else o[a]=n}),o},dataDimToCoordDim:function(t,e){var i=t.dimensions;e=t.getDimension(e);for(var n=0;n<i.length;n++){var a=t.getDimensionInfo(i[n]);if(a.name===e)return a.coordDim}},coordDimToDataDim:function(t,e){var i=[];return bp(t.dimensions,function(n){var a=t.getDimensionInfo(n);a.coordDim===e&&(i[a.coordDimIndex]=a.name)}),i},otherDimToDataDim:function(t,e){var i=[];return bp(t.dimensions,function(n){var a=t.getDimensionInfo(n),o=a.otherDims[e];null!=o&&!1!==o&&(i[o]=a.name)}),i}},Tp=Bu.parseClassType,Ap=0,Cp="_",Lp={getUID:function(t){return[t||"",Ap++,Math.random()].join(Cp)},enableSubTypeDefaulter:function(t){var e={};return t.registerSubTypeDefaulter=function(t,i){t=Tp(t),e[t.main]=i},t.determineSubType=function(i,n){var a=n.type;if(!a){var o=Tp(i).main;t.hasSubTypes(i)&&e[o]&&(a=e[o](n))}return a},t},enableTopologicalTravel:function(t,e){function i(t,e){return t[e]||(t[e]={predecessor:[],successor:[]}),t[e]}t.topologicalTravel=function(t,n,a,o){function r(t){l[t].entryCount--,0===l[t].entryCount&&h.push(t)}if(t.length){var s=function(t){var n={},a=[];return rl.each(t,function(o){var r=i(n,o),s=function(t,e){var i=[];return rl.each(t,function(t){rl.indexOf(e,t)>=0&&i.push(t)}),i}(r.originalDeps=e(o),t);r.entryCount=s.length,0===r.entryCount&&a.push(o),rl.each(s,function(t){rl.indexOf(r.predecessor,t)<0&&r.predecessor.push(t);var e=i(n,t);rl.indexOf(e.successor,t)<0&&e.successor.push(o)})}),{graph:n,noEntryList:a}}(n),l=s.graph,h=s.noEntryList,u={};for(rl.each(t,function(t){u[t]=!0});h.length;){var c=h.pop(),d=l[c],p=!!u[c];p&&(a.call(o,c,d.originalDeps.slice()),delete u[c]),rl.each(d.successor,p?function(t){u[t]=!0,r(t)}:r)}rl.each(u,function(){throw new Error("Circle dependency may exists")})}}}},Dp=Pu.parsePercent,Pp=rl.each,kp=["left","right","top","bottom","width","height"],Op=[["width","left","right"],["height","top","bottom"]],zp=me,Ep=rl.curry(me,"vertical"),Rp=rl.curry(me,"horizontal"),Np={LOCATION_PARAMS:kp,HV_NAMES:Op,box:zp,vbox:Ep,hbox:Rp,getAvailableSize:function(t,e,i){var n=e.width,a=e.height,o=Dp(t.x,n),r=Dp(t.y,a),s=Dp(t.x2,n),l=Dp(t.y2,a);return(isNaN(o)||isNaN(parseFloat(t.x)))&&(o=0),(isNaN(s)||isNaN(parseFloat(t.x2)))&&(s=n),(isNaN(r)||isNaN(parseFloat(t.y)))&&(r=0),(isNaN(l)||isNaN(parseFloat(t.y2)))&&(l=a),i=Eu.normalizeCssArray(i||0),{width:Math.max(s-o-i[1]-i[3],0),height:Math.max(l-r-i[0]-i[2],0)}},getLayoutRect:ve,positionElement:function(t,e,i,n,a){var o=!a||!a.hv||a.hv[0],r=!a||!a.hv||a.hv[1],s=a&&a.boundingMode||"all";if(o||r){var l;if("raw"===s)l="group"===t.type?new oh(0,0,+e.width||0,+e.height||0):t.getBoundingRect();else if(l=t.getBoundingRect(),t.needLocalTransform()){var h=t.getLocalTransform();(l=l.clone()).applyTransform(h)}e=ve(rl.defaults({width:l.width,height:l.height},e),i,n);var u=t.position,c=o?e.x-l.x:0,d=r?e.y-l.y:0;t.attr("position","raw"===s?[c,d]:[u[0]+c,u[1]+d])}},sizeCalculable:function(t,e){return null!=t[Op[e][0]]||null!=t[Op[e][1]]&&null!=t[Op[e][2]]},mergeLayoutParam:function(t,e,i){function n(i,n){var r={},l=0,h={},u=0;if(Pp(i,function(e){h[e]=t[e]}),Pp(i,function(t){a(e,t)&&(r[t]=h[t]=e[t]),o(r,t)&&l++,o(h,t)&&u++}),s[n])return o(e,i[1])?h[i[2]]=null:o(e,i[2])&&(h[i[1]]=null),h;if(2!==u&&l){if(l>=2)return r;for(var c=0;c<i.length;c++){var d=i[c];if(!a(r,d)&&a(t,d)){r[d]=t[d];break}}return r}return h}function a(t,e){return t.hasOwnProperty(e)}function o(t,e){return null!=t[e]&&"auto"!==t[e]}function r(t,e,i){Pp(t,function(t){e[t]=i[t]})}!rl.isObject(i)&&(i={});var s=i.ignoreSize;!rl.isArray(s)&&(s=[s,s]);var l=n(Op[0],0),h=n(Op[1],1);r(Op[0],t,l),r(Op[1],t,h)},getLayoutParams:function(t){return ye({},t)},copyLayoutParams:ye},Vp={getBoxLayoutParams:function(){return{left:this.get("left"),top:this.get("top"),right:this.get("right"),bottom:this.get("bottom"),width:this.get("width"),height:this.get("height")}}},Bp=Array.prototype.push,Gp=_p.extend({type:"component",id:"",name:"",mainType:"",subType:"",componentIndex:0,defaultOption:null,ecModel:null,dependentModels:[],uid:null,layoutMode:null,$constructor:function(t,e,i,n){_p.call(this,t,e,i,n),this.uid=Lp.getUID("componentModel")},init:function(t,e,i,n){this.mergeDefaultAndTheme(t,i)},mergeDefaultAndTheme:function(t,e){var i=this.layoutMode,n=i?Np.getLayoutParams(t):{},a=e.getTheme();rl.merge(t,a.get(this.mainType)),rl.merge(t,this.getDefaultOption()),i&&Np.mergeLayoutParam(t,n,i)},mergeOption:function(t,e){rl.merge(this.option,t,!0);var i=this.layoutMode;i&&Np.mergeLayoutParam(this.option,t,i)},optionUpdated:function(t,e){},getDefaultOption:function(){if(!Bu.hasOwn(this,"__defaultOption")){for(var t=[],e=this.constructor;e;){var i=e.prototype.defaultOption;i&&t.push(i),e=e.superClass}for(var n={},a=t.length-1;a>=0;a--)n=rl.merge(n,t[a],!0);Bu.set(this,"__defaultOption",n)}return Bu.get(this,"__defaultOption")},getReferringComponents:function(t){return this.ecModel.queryComponents({mainType:t,index:this.get(t+"Index",!0),id:this.get(t+"Id",!0)})}});Bu.enableClassManagement(Gp,{registerWhenExtend:!0}),Lp.enableSubTypeDefaulter(Gp),Lp.enableTopologicalTravel(Gp,function(t){var e=[];return rl.each(Gp.getClassesByMainType(t),function(t){Bp.apply(e,t.prototype.dependencies||[])}),rl.map(e,function(t){return Bu.parseClassType(t).main})}),rl.mixin(Gp,Vp);var Hp=Gp,Wp="";"undefined"!=typeof navigator&&(Wp=navigator.platform||"");var Fp={color:["#c23531","#2f4554","#61a0a8","#d48265","#91c7ae","#749f83","#ca8622","#bda29a","#6e7074","#546570","#c4ccd3"],textStyle:{fontFamily:Wp.match(/^Win/)?"Microsoft YaHei":"sans-serif",fontSize:12,fontStyle:"normal",fontWeight:"normal"},blendMode:null,animation:"auto",animationDuration:1e3,animationDurationUpdate:300,animationEasing:"exponentialOut",animationEasingUpdate:"cubicOut",animationThreshold:2e3,progressiveThreshold:3e3,progressive:400,hoverLayerThreshold:3e3,useUTC:!1},Zp=Bu.set,jp=Bu.get,Up={clearColorPalette:function(){Zp(this,"colorIdx",0),Zp(this,"colorNameMap",{})},getColorFromPalette:function(t,e){var i=jp(e=e||this,"colorIdx")||0,n=jp(e,"colorNameMap")||Zp(e,"colorNameMap",{});if(n.hasOwnProperty(t))return n[t];var a=this.get("color",!0)||[];if(a.length){var o=a[i];return t&&(n[t]=o),Zp(e,"colorIdx",(i+1)%a.length),o}}},qp=rl.each,Xp=rl.filter,Yp=rl.map,$p=rl.isArray,Kp=rl.indexOf,Jp=rl.isObject,Qp="\0_ec_inner",tf=_p.extend({constructor:tf,init:function(t,e,i,n){i=i||{},this.option=null,this._theme=new _p(i),this._optionManager=n},setOption:function(t,e){rl.assert(!(Qp in t),"please use chart.getOption()"),this._optionManager.setOption(t,e),this.resetOption(null)},resetOption:function(t){var e=!1,i=this._optionManager;if(!t||"recreate"===t){var n=i.mountOption("recreate"===t);this.option&&"recreate"!==t?(this.restoreData(),this.mergeOption(n)):function(t){t=t,this.option={},this.option[Qp]=1,this._componentsMap=rl.createHashMap({series:[]}),this._seriesIndices=null,function(t,e){rl.each(e,function(e,i){Hp.hasClass(i)||("object"==typeof e?t[i]=t[i]?rl.merge(t[i],e,!1):rl.clone(e):null==t[i]&&(t[i]=e))})}(t,this._theme.option),rl.merge(t,Fp,!1),this.mergeOption(t)}.call(this,n),e=!0}if("timeline"!==t&&"media"!==t||this.restoreData(),!t||"recreate"===t||"timeline"===t){var a=i.getTimelineOption(this);a&&(this.mergeOption(a),e=!0)}if(!t||"recreate"===t||"media"===t){var o=i.getMediaOption(this,this._api);o.length&&qp(o,function(t){this.mergeOption(t,e=!0)},this)}return e},mergeOption:function(t){var e=this.option,i=this._componentsMap,n=[];qp(t,function(t,i){null!=t&&(Hp.hasClass(i)?n.push(i):e[i]=null==e[i]?rl.clone(t):rl.merge(e[i],t,!0))}),Hp.topologicalTravel(n,Hp.getAllClassMainTypes(),function(n,a){var o=Ip.normalizeToArray(t[n]),r=Ip.mappingToExists(i.get(n),o);Ip.makeIdAndName(r),qp(r,function(t,e){var i=t.option;Jp(i)&&(t.keyInfo.mainType=n,t.keyInfo.subType=function(t,e,i){return e.type?e.type:i?i.subType:Hp.determineSubType(t,e)}(n,i,t.exist))});var s=function(t,e){rl.isArray(e)||(e=e?[e]:[]);var i={};return qp(e,function(e){i[e]=(t.get(e)||[]).slice()}),i}(i,a);e[n]=[],i.set(n,[]),qp(r,function(t,a){var o=t.exist,r=t.option;if(rl.assert(Jp(r)||o,"Empty component definition"),r){var l=Hp.getClass(n,t.keyInfo.subType,!0);if(o&&o instanceof l)o.name=t.keyInfo.name,o.mergeOption(r,this),o.optionUpdated(r,!1);else{var h=rl.extend({dependentModels:s,componentIndex:a},t.keyInfo);o=new l(r,this,this,h),rl.extend(o,h),o.init(r,this,this,h),o.optionUpdated(null,!0)}}else o.mergeOption({},this),o.optionUpdated({},!1);i.get(n)[a]=o,e[n][a]=o.option},this),"series"===n&&(this._seriesIndices=xe(i.get("series")))},this),this._seriesIndices=this._seriesIndices||[]},getOption:function(){var t=rl.clone(this.option);return qp(t,function(e,i){if(Hp.hasClass(i)){for(var n=(e=Ip.normalizeToArray(e)).length-1;n>=0;n--)Ip.isIdInner(e[n])&&e.splice(n,1);t[i]=e}}),delete t[Qp],t},getTheme:function(){return this._theme},getComponent:function(t,e){var i=this._componentsMap.get(t);if(i)return i[e||0]},queryComponents:function(t){var e=t.mainType;if(!e)return[];var i=t.index,n=t.id,a=t.name,o=this._componentsMap.get(e);if(!o||!o.length)return[];var r;if(null!=i)$p(i)||(i=[i]),r=Xp(Yp(i,function(t){return o[t]}),function(t){return!!t});else if(null!=n){var s=$p(n);r=Xp(o,function(t){return s&&Kp(n,t.id)>=0||!s&&t.id===n})}else if(null!=a){var l=$p(a);r=Xp(o,function(t){return l&&Kp(a,t.name)>=0||!l&&t.name===a})}else r=o.slice();return _e(r,t)},findComponents:function(t){var e=t.query,i=t.mainType,n=function(t){var e=i+"Index",n=i+"Id",a=i+"Name";return!t||null==t[e]&&null==t[n]&&null==t[a]?null:{mainType:i,index:t[e],id:t[n],name:t[a]}}(e);return function(e){return t.filter?Xp(e,t.filter):e}(_e(n?this.queryComponents(n):this._componentsMap.get(i),t))},eachComponent:function(t,e,i){var n=this._componentsMap;if("function"==typeof t)i=e,e=t,n.each(function(t,n){qp(t,function(t,a){e.call(i,n,t,a)})});else if(rl.isString(t))qp(n.get(t),e,i);else if(Jp(t)){var a=this.findComponents(t);qp(a,e,i)}},getSeriesByName:function(t){var e=this._componentsMap.get("series");return Xp(e,function(e){return e.name===t})},getSeriesByIndex:function(t){return this._componentsMap.get("series")[t]},getSeriesByType:function(t){var e=this._componentsMap.get("series");return Xp(e,function(e){return e.subType===t})},getSeries:function(){return this._componentsMap.get("series").slice()},eachSeries:function(t,e){be(),qp(this._seriesIndices,function(i){var n=this._componentsMap.get("series")[i];t.call(e,n,i)},this)},eachRawSeries:function(t,e){qp(this._componentsMap.get("series"),t,e)},eachSeriesByType:function(t,e,i){be(),qp(this._seriesIndices,function(n){var a=this._componentsMap.get("series")[n];a.subType===t&&e.call(i,a,n)},this)},eachRawSeriesByType:function(t,e,i){return qp(this.getSeriesByType(t),e,i)},isSeriesFiltered:function(t){return be(),rl.indexOf(this._seriesIndices,t.componentIndex)<0},getCurrentSeriesIndices:function(){return(this._seriesIndices||[]).slice()},filterSeries:function(t,e){be();var i=Xp(this._componentsMap.get("series"),t,e);this._seriesIndices=xe(i)},restoreData:function(){var t=this._componentsMap;this._seriesIndices=xe(t.get("series"));var e=[];t.each(function(t,i){e.push(i)}),Hp.topologicalTravel(e,Hp.getAllClassMainTypes(),function(e,i){qp(t.get(e),function(t){t.restoreData()})})}});rl.mixin(tf,Up);var ef=tf,nf=["getDom","getZr","getWidth","getHeight","getDevicePixelRatio","dispatchAction","isDisposed","on","off","getDataURL","getConnectedDataURL","getModel","getOption","getViewOfComponentModel","getViewOfSeriesModel"],af=function(t){rl.each(nf,function(e){this[e]=rl.bind(t[e],t)},this)},of={};we.prototype={constructor:we,create:function(t,e){var i=[];rl.each(of,function(n,a){var o=n.create(t,e);i=i.concat(o||[])}),this._coordinateSystems=i},update:function(t,e){rl.each(this._coordinateSystems,function(i){i.update&&i.update(t,e)})},getCoordinateSystems:function(){return this._coordinateSystems.slice()}},we.register=function(t,e){of[t]=e},we.get=function(t){return of[t]};var rf=we,sf=rl.each,lf=rl.clone,hf=rl.map,uf=rl.merge,cf=/^(min|max)?(.+)$/;Se.prototype={constructor:Se,setOption:function(t,e){t=lf(t,!0);var i=this._optionBackup,n=function(t,e,i){var n,a,o=[],r=[],s=t.timeline;if(t.baseOption&&(a=t.baseOption),(s||t.options)&&(a=a||{},o=(t.options||[]).slice()),t.media){a=a||{};var l=t.media;sf(l,function(t){t&&t.option&&(t.query?r.push(t):n||(n=t))})}return a||(a=t),a.timeline||(a.timeline=s),sf([a].concat(o).concat(rl.map(r,function(t){return t.option})),function(t){sf(e,function(e){e(t,i)})}),{baseOption:a,timelineOptions:o,mediaDefault:n,mediaList:r}}.call(this,t,e,!i);this._newBaseOption=n.baseOption,i?(!function(t,e){sf(e=e||{},function(e,i){if(null!=e){var n=t[i];if(Hp.hasClass(i)){e=Ip.normalizeToArray(e),n=Ip.normalizeToArray(n);var a=Ip.mappingToExists(n,e);t[i]=hf(a,function(t){return t.option&&t.exist?uf(t.exist,t.option,!0):t.exist||t.option})}else t[i]=uf(n,e,!0)}})}(i.baseOption,n.baseOption),n.timelineOptions.length&&(i.timelineOptions=n.timelineOptions),n.mediaList.length&&(i.mediaList=n.mediaList),n.mediaDefault&&(i.mediaDefault=n.mediaDefault)):this._optionBackup=n},mountOption:function(t){var e=this._optionBackup;return this._timelineOptions=hf(e.timelineOptions,lf),this._mediaList=hf(e.mediaList,lf),this._mediaDefault=lf(e.mediaDefault),this._currentMediaIndices=[],lf(t?e.baseOption:this._newBaseOption)},getTimelineOption:function(t){var e,i=this._timelineOptions;if(i.length){var n=t.getComponent("timeline");n&&(e=lf(i[n.getCurrentIndex()],!0))}return e},getMediaOption:function(t){var e=this._api.getWidth(),i=this._api.getHeight(),n=this._mediaList,a=this._mediaDefault,o=[],r=[];if(!n.length&&!a)return r;for(var s=0,l=n.length;s<l;s++)(function(t,e,i){var n={width:e,height:i,aspectratio:e/i},a=!0;return rl.each(t,function(t,e){var i=e.match(cf);if(i&&i[1]&&i[2]){var o=i[1],r=i[2].toLowerCase();(function(t,e,i){return"min"===i?t>=e:"max"===i?t<=e:t===e})(n[r],t,o)||(a=!1)}}),a})(n[s].query,e,i)&&o.push(s);return!o.length&&a&&(o=[-1]),o.length&&!function(t,e){return t.join(",")===e.join(",")}(o,this._currentMediaIndices)&&(r=hf(o,function(t){return lf(-1===t?a.option:n[t].option)})),this._currentMediaIndices=o,r}};var df=Se,pf=rl.each,ff=rl.isObject,gf=["areaStyle","lineStyle","nodeStyle","linkStyle","chordStyle","label","labelLine"],mf=function(t,e){pf(Ae(t.series),function(t){ff(t)&&function(t){if(ff(t)){Me(t),Te(t.label),Te(t.upperLabel),Te(t.edgeLabel),Me(n=t.markPoint),Te(n&&n.label),r=t.markLine,Me(t.markLine),Te(r&&r.label);var e=t.markArea;Te(e&&e.label),Ie(t,"axisLabel"),Ie(t,"title"),Ie(t,"detail");var i=t.data;if(i)for(o=0;o<i.length;o++)Me(i[o]),Te(i[o]&&i[o].label);var n;if((n=t.markPoint)&&n.data)for(var a=n.data,o=0;o<a.length;o++)Me(a[o]),Te(a[o]&&a[o].label);var r;if((r=t.markLine)&&r.data)for(var s=r.data,o=0;o<s.length;o++)rl.isArray(s[o])?(Me(s[o][0]),Te(s[o][0]&&s[o][0].label),Me(s[o][1]),Te(s[o][1]&&s[o][1].label)):(Me(s[o]),Te(s[o]&&s[o].label))}}(t)});var i=["xAxis","yAxis","radiusAxis","angleAxis","singleAxis","parallelAxis","radar"];e&&i.push("valueAxis","categoryAxis","logAxis","timeAxis"),pf(i,function(e){pf(Ae(t[e]),function(t){t&&(Ie(t,"axisLabel"),Ie(t.axisPointer,"label"))})}),pf(Ae(t.parallel),function(t){var e=t&&t.parallelAxisDefault;Ie(e,"axisLabel"),Ie(e&&e.axisPointer,"label")}),pf(Ae(t.calendar),function(t){Ie(t,"dayLabel"),Ie(t,"monthLabel"),Ie(t,"yearLabel")}),pf(Ae(t.radar),function(t){Ie(t,"name")}),pf(Ae(t.geo),function(t){ff(t)&&(Te(t.label),pf(Ae(t.regions),function(t){Te(t.label)}))}),Te(Ce(t.timeline).label),Ie(Ce(t.axisPointer),"label"),Ie(Ce(t.tooltip).axisPointer,"label")},vf=rl.each,yf=rl.isArray,xf=rl.isObject,_f=Ip.normalizeToArray,bf=[["x","left"],["y","top"],["x2","right"],["y2","bottom"]],wf=["grid","geo","parallel","legend","toolbox","title","visualMap","dataZoom","timeline"],Sf=["bar","boxplot","candlestick","chord","effectScatter","funnel","gauge","lines","graph","heatmap","line","map","parallel","pie","radar","sankey","scatter","treemap"],Mf=function(t,e){mf(t,e),t.series=_f(t.series),vf(t.series,function(t){if(xf(t)){var e=t.type;if("pie"!==e&&"gauge"!==e||null!=t.clockWise&&(t.clockwise=t.clockWise),"gauge"===e){var i=function(t,e){e=e.split(",");for(var i=t,n=0;n<e.length&&null!=(i=i&&i[e[n]]);n++);return i}(t,"pointer.color");null!=i&&function(t,e,i,n){e=e.split(",");for(var a,o=t,r=0;r<e.length-1;r++)null==o[a=e[r]]&&(o[a]={}),o=o[a];(n||null==o[e[r]])&&(o[e[r]]=i)}(t,"itemStyle.normal.color",i)}for(var n=0;n<Sf.length;n++)if(Sf[n]===t.type){Le(t);break}}}),t.dataRange&&(t.visualMap=t.dataRange),vf(wf,function(e){var i=t[e];i&&(yf(i)||(i=[i]),vf(i,function(t){Le(t)}))})},If=Eu.formatTime,Tf=Eu.encodeHTML,Af=Eu.addCommas,Cf=Eu.getTooltipMarker,Lf=Bu.set,Df=Bu.get,Pf=Np.getLayoutParams,kf=Np.mergeLayoutParam,Of=Hp.extend({type:"series.__base__",seriesIndex:0,coordinateSystem:null,defaultOption:null,legendDataProvider:null,visualColorAccessPath:"itemStyle.normal.color",layoutMode:null,init:function(t,e,i,n){this.seriesIndex=this.componentIndex,this.mergeDefaultAndTheme(t,i);var a=this.getInitialData(t,i);Lf(this,"dataBeforeProcessed",a),this.restoreData()},mergeDefaultAndTheme:function(t,e){var i=this.layoutMode,n=i?Pf(t):{},a=this.subType;Hp.hasClass(a)&&(a+="Series"),rl.merge(t,e.getTheme().get(this.subType)),rl.merge(t,this.getDefaultOption()),Ip.defaultEmphasis(t.label,["show"]),this.fillDataTextStyle(t.data),i&&kf(t,n,i)},mergeOption:function(t,e){t=rl.merge(this.option,t,!0),this.fillDataTextStyle(t.data);var i=this.layoutMode;i&&kf(this.option,t,i);var n=this.getInitialData(t,e);n&&(Lf(this,"data",n),Lf(this,"dataBeforeProcessed",n.cloneShallow()))},fillDataTextStyle:function(t){if(t)for(var e=["show"],i=0;i<t.length;i++)t[i]&&t[i].label&&Ip.defaultEmphasis(t[i].label,e)},getInitialData:function(){},getData:function(t){var e=Df(this,"data");return null==t?e:e.getLinkedData(t)},setData:function(t){Lf(this,"data",t)},getRawData:function(){return Df(this,"dataBeforeProcessed")},coordDimToDataDim:function(t){return Ip.coordDimToDataDim(this.getData(),t)},dataDimToCoordDim:function(t){return Ip.dataDimToCoordDim(this.getData(),t)},getBaseAxis:function(){var t=this.coordinateSystem;return t&&t.getBaseAxis&&t.getBaseAxis()},formatTooltip:function(t,e,i){var n=Df(this,"data"),a=this.getRawValue(t),o=rl.isArray(a)?function(i){function a(t,i){var a=n.getDimensionInfo(i);if(a&&!1!==a.otherDims.tooltip){var s=a.type,l=(o?"- "+(a.tooltipName||a.name)+": ":"")+("ordinal"===s?t+"":"time"===s?e?"":If("yyyy/MM/dd hh:mm:ss",t):Af(t));l&&r.push(Tf(l))}}var o=rl.reduce(i,function(t,e,i){var a=n.getDimensionInfo(i);return t|=a&&!1!==a.tooltip&&null!=a.tooltipName},0),r=[],s=Ip.otherDimToDataDim(n,"tooltip");return s.length?rl.each(s,function(e){a(n.get(e,t),e)}):rl.each(i,a),(o?"<br/>":"")+r.join(o?"<br/>":", ")}(a):Tf(Af(a)),r=n.getName(t),s=n.getItemVisual(t,"color");rl.isObject(s)&&s.colorStops&&(s=(s.colorStops[0]||{}).color);var l=Cf(s=s||"transparent"),h=this.name;return"\0-"===h&&(h=""),h=h?Tf(h)+(e?": ":"<br/>"):"",e?l+h+o:h+l+(r?Tf(r)+": "+o:o)},isAnimationEnabled:function(){if(Us.node)return!1;var t=this.getShallow("animation");return t&&this.getData().count()>this.getShallow("animationThreshold")&&(t=!1),t},restoreData:function(){Lf(this,"data",Df(this,"dataBeforeProcessed").cloneShallow())},getColorFromPalette:function(t,e){var i=this.ecModel,n=Up.getColorFromPalette.call(this,t,e);return n||(n=i.getColorFromPalette(t,e)),n},getAxisTooltipData:null,getTooltipPosition:null});rl.mixin(Of,Ip.dataFormatMixin),rl.mixin(Of,Up);var zf=Of,Ef=function(){this.group=new sh,this.uid=Lp.getUID("viewComponent")},Rf=Ef.prototype={constructor:Ef,init:function(t,e){},render:function(t,e,i,n){},dispose:function(){}};Rf.updateView=Rf.updateLayout=Rf.updateVisual=function(t,e,i,n){},Bu.enableClassExtend(Ef),Bu.enableClassManagement(Ef,{registerWhenExtend:!0});var Nf=Ef,Vf=De.prototype={type:"chart",init:function(t,e){},render:function(t,e,i,n){},highlight:function(t,e,i,n){ke(t.getData(),n,"emphasis")},downplay:function(t,e,i,n){ke(t.getData(),n,"normal")},remove:function(t,e){this.group.removeAll()},dispose:function(){}};Vf.updateView=Vf.updateLayout=Vf.updateVisual=function(t,e,i,n){this.render(t,e,i,n)},Bu.enableClassExtend(De,["dispose"]),Bu.enableClassManagement(De,{registerWhenExtend:!0});var Bf=De,Gf="\0__throttleOriginMethod",Hf="\0__throttleRate",Wf="\0__throttleType",Ff={throttle:Oe,createOrUpdate:function(t,e,i,n){var a=t[e];if(a){var o=a[Gf]||a,r=a[Wf];if(a[Hf]!==i||r!==n){if(null==i||!n)return t[e]=o;(a=t[e]=Oe(o,i,"debounce"===n))[Gf]=o,a[Wf]=n,a[Hf]=i}return a}},clear:function(t,e){var i=t[e];i&&i[Gf]&&(t[e]=i[Gf])}},Zf=function(t){t.eachRawSeries(function(e){var i=(e.visualColorAccessPath||"itemStyle.normal.color").split("."),n=e.getData(),a=e.get(i)||e.getColorFromPalette(e.get("name"));n.setVisual("color",a),t.isSeriesFiltered(e)||("function"!=typeof a||a instanceof Zd||n.each(function(t){n.setItemVisual(t,"color",a(e.getDataParams(t)))}),n.each(function(t){var e=n.getItemModel(t).get(i,!0);null!=e&&n.setItemVisual(t,"color",e)}))})},jf=Math.PI,Uf=function(t,e){e=e||{},rl.defaults(e,{text:"loading",color:"#c23531",textColor:"#000",maskColor:"rgba(255, 255, 255, 0.8)",zlevel:0});var i=new fp.Rect({style:{fill:e.maskColor},zlevel:e.zlevel,z:1e4}),n=new fp.Arc({shape:{startAngle:-jf/2,endAngle:-jf/2+.1,r:10},style:{stroke:e.color,lineCap:"round",lineWidth:5},zlevel:e.zlevel,z:10001}),a=new fp.Rect({style:{fill:"none",text:e.text,textPosition:"right",textDistance:10,textFill:e.textColor},zlevel:e.zlevel,z:10001});n.animateShape(!0).when(1e3,{endAngle:3*jf/2}).start("circularInOut"),n.animateShape(!0).when(1e3,{startAngle:3*jf/2}).delay(300).start("circularInOut");var o=new fp.Group;return o.add(n),o.add(a),o.add(i),o.resize=function(){var e=t.getWidth()/2,o=t.getHeight()/2;n.setShape({cx:e,cy:o});var r=n.shape.r;a.setShape({x:e-r,y:o-r,width:2*r,height:2*r}),i.setShape({x:0,y:0,width:t.getWidth(),height:t.getHeight()})},o.resize(),o};Ee.prototype={constructor:Ee,add:function(t){return this._add=t,this},update:function(t){return this._update=t,this},remove:function(t){return this._remove=t,this},execute:function(){var t=this._old,e=this._new,i={},n=[],a=[];for(Re(t,{},n,"_oldKeyGetter",this),Re(e,i,a,"_newKeyGetter",this),o=0;o<t.length;o++){if(null!=(s=i[r=n[o]])){(h=s.length)?(1===h&&(i[r]=null),s=s.unshift()):i[r]=null,this._update&&this._update(s,o)}else this._remove&&this._remove(o)}for(var o=0;o<a.length;o++){var r=a[o];if(i.hasOwnProperty(r)){var s=i[r];if(null==s)continue;if(s.length)for(var l=0,h=s.length;l<h;l++)this._add&&this._add(s[l]);else this._add&&this._add(s)}}}};var qf=Ee,Xf=rl.isObject,Yf="undefined"==typeof window?Ws:window,$f={float:void 0===Yf.Float64Array?Array:Yf.Float64Array,int:void 0===Yf.Int32Array?Array:Yf.Int32Array,ordinal:Array,number:Array,time:Array},Kf=["stackedOn","hasItemOption","_nameList","_idList","_rawData"];Ve.prototype.pure=!1,Ve.prototype.count=function(){return this._array.length},Ve.prototype.getItem=function(t){return this._array[t]};var Jf=function(t,e){t=t||["x","y"];for(var i={},n=[],a=0;a<t.length;a++){var o,r={};"string"==typeof t[a]?r={name:o=t[a],coordDim:o,coordDimIndex:0,stackable:!1,type:"number"}:(o=(r=t[a]).name,r.type=r.type||"number",r.coordDim||(r.coordDim=o,r.coordDimIndex=0)),r.otherDims=r.otherDims||{},n.push(o),i[o]=r}this.dimensions=n,this._dimensionInfos=i,this.hostModel=e,this.dataType,this.indices=[],this._storage={},this._nameList=[],this._idList=[],this._optionModels=[],this.stackedOn=null,this._visual={},this._layout={},this._itemVisuals=[],this._itemLayouts=[],this._graphicEls=[],this._rawData,this._extent},Qf=Jf.prototype;Qf.type="list",Qf.hasItemOption=!0,Qf.getDimension=function(t){return isNaN(t)||(t=this.dimensions[t]||t),t},Qf.getDimensionInfo=function(t){return rl.clone(this._dimensionInfos[this.getDimension(t)])},Qf.initData=function(t,e,i){t=t||[];rl.isArray(t)&&(t=new Ve(t)),this._rawData=t;var n,a=this._storage={},o=this.indices=[],r=this.dimensions,s=this._dimensionInfos,l=t.count(),h=[],u={};e=e||[];for(v=0;v<r.length;v++){var c=s[r[v]];0===c.otherDims.itemName&&(n=v);var d=$f[c.type];a[r[v]]=new d(l)}var p=this;i||(p.hasItemOption=!1),i=i||function(t,e,i,n){var a=Ip.getDataItemValue(t);return Ip.isDataItemOption(t)&&(p.hasItemOption=!0),Ip.converDataValue(a instanceof Array?a[n]:a,s[e])};for(v=0;v<l;v++){for(var f=t.getItem(v),g=0;g<r.length;g++){var m=r[g];a[m][v]=i(f,m,v,g)}o.push(v)}for(var v=0;v<l;v++){f=t.getItem(v);!e[v]&&f&&(null!=f.name?e[v]=f.name:null!=n&&(e[v]=a[r[n]][v]));var y=e[v]||"",x=f&&f.id;!x&&y&&(u[y]=u[y]||0,x=y,u[y]>0&&(x+="__ec__"+u[y]),u[y]++),x&&(h[v]=x)}this._nameList=e,this._idList=h},Qf.count=function(){return this.indices.length},Qf.get=function(t,e,i){var n=this._storage,a=this.indices[e];if(null==a||!n[t])return NaN;var o=n[t][a];if(i){var r=this._dimensionInfos[t];if(r&&r.stackable)for(var s=this.stackedOn;s;){var l=s.get(t,e);(o>=0&&l>0||o<=0&&l<0)&&(o+=l),s=s.stackedOn}}return o},Qf.getValues=function(t,e,i){var n=[];rl.isArray(t)||(i=e,e=t,t=this.dimensions);for(var a=0,o=t.length;a<o;a++)n.push(this.get(t[a],e,i));return n},Qf.hasValue=function(t){for(var e=this.dimensions,i=this._dimensionInfos,n=0,a=e.length;n<a;n++)if("ordinal"!==i[e[n]].type&&isNaN(this.get(e[n],t)))return!1;return!0},Qf.getDataExtent=function(t,e,i){t=this.getDimension(t);var n=this._storage[t],a=this.getDimensionInfo(t);e=a&&a.stackable&&e;var o,r=(this._extent||(this._extent={}))[t+!!e];if(r)return r;if(n){for(var s=1/0,l=-1/0,h=0,u=this.count();h<u;h++)o=this.get(t,h,e),i&&!i(o,t,h)||(o<s&&(s=o),o>l&&(l=o));return this._extent[t+!!e]=[s,l]}return[1/0,-1/0]},Qf.getSum=function(t,e){var i=0;if(this._storage[t])for(var n=0,a=this.count();n<a;n++){var o=this.get(t,n,e);isNaN(o)||(i+=o)}return i},Qf.indexOf=function(t,e){var i=this._storage[t],n=this.indices;if(i)for(var a=0,o=n.length;a<o;a++){if(i[n[a]]===e)return a}return-1},Qf.indexOfName=function(t){for(var e=this.indices,i=this._nameList,n=0,a=e.length;n<a;n++){if(i[e[n]]===t)return n}return-1},Qf.indexOfRawIndex=function(t){var e=this.indices,i=e[t];if(null!=i&&i===t)return t;for(var n=0,a=e.length-1;n<=a;){var o=(n+a)/2|0;if(e[o]<t)n=o+1;else{if(!(e[o]>t))return o;a=o-1}}return-1},Qf.indicesOfNearest=function(t,e,i,n){var a=[];if(!this._storage[t])return a;null==n&&(n=1/0);for(var o=Number.MAX_VALUE,r=-1,s=0,l=this.count();s<l;s++){var h=e-this.get(t,s,i),u=Math.abs(h);h<=n&&u<=o&&((u<o||h>=0&&r<0)&&(o=u,r=h,a.length=0),a.push(s))}return a},Qf.getRawIndex=function(t){var e=this.indices[t];return null==e?-1:e},Qf.getRawDataItem=function(t){return this._rawData.getItem(this.getRawIndex(t))},Qf.getName=function(t){return this._nameList[this.indices[t]]||""},Qf.getId=function(t){return this._idList[this.indices[t]]||this.getRawIndex(t)+""},Qf.each=function(t,e,i,n){"function"==typeof t&&(n=i,i=e,e=t,t=[]);var a=[],o=(t=rl.map(Be(t),this.getDimension,this)).length,r=this.indices;n=n||this;for(var s=0;s<r.length;s++)switch(o){case 0:e.call(n,s);break;case 1:e.call(n,this.get(t[0],s,i),s);break;case 2:e.call(n,this.get(t[0],s,i),this.get(t[1],s,i),s);break;default:for(var l=0;l<o;l++)a[l]=this.get(t[l],s,i);a[l]=s,e.apply(n,a)}},Qf.filterSelf=function(t,e,i,n){"function"==typeof t&&(n=i,i=e,e=t,t=[]);var a=[],o=[],r=(t=rl.map(Be(t),this.getDimension,this)).length,s=this.indices;n=n||this;for(var l=0;l<s.length;l++){var h;if(r)if(1===r)h=e.call(n,this.get(t[0],l,i),l);else{for(var u=0;u<r;u++)o[u]=this.get(t[u],l,i);o[u]=l,h=e.apply(n,o)}else h=e.call(n,l);h&&a.push(s[l])}return this.indices=a,this._extent={},this},Qf.mapArray=function(t,e,i,n){"function"==typeof t&&(n=i,i=e,e=t,t=[]);var a=[];return this.each(t,function(){a.push(e&&e.apply(this,arguments))},i,n),a},Qf.map=function(t,e,i,n){var a=Ge(this,t=rl.map(Be(t),this.getDimension,this)),o=a.indices=this.indices,r=a._storage,s=[];return this.each(t,function(){var i=arguments[arguments.length-1],n=e&&e.apply(this,arguments);if(null!=n){"number"==typeof n&&(s[0]=n,n=s);for(var a=0;a<n.length;a++){var l=t[a],h=r[l],u=o[i];h&&(h[u]=n[a])}}},i,n),a},Qf.downSample=function(t,e,i,n){for(var a=Ge(this,[t]),o=this._storage,r=a._storage,s=this.indices,l=a.indices=[],h=[],u=[],c=Math.floor(1/e),d=r[t],p=this.count(),f=0;f<o[t].length;f++)r[t][f]=o[t][f];for(f=0;f<p;f+=c){c>p-f&&(c=p-f,h.length=c);for(var g=0;g<c;g++){m=s[f+g];h[g]=d[m],u[g]=m}var m,v=i(h);d[m=u[n(h,v)||0]]=v,l.push(m)}return a},Qf.getItemModel=function(t){var e=this.hostModel;return t=this.indices[t],new _p(this._rawData.getItem(t),e,e&&e.ecModel)},Qf.diff=function(t){var e,i=this._idList,n=t&&t._idList;return new qf(t?t.indices:[],this.indices,function(t){return null!=(e=n[t])?e:"e\0\0"+t},function(t){return null!=(e=i[t])?e:"e\0\0"+t})},Qf.getVisual=function(t){var e=this._visual;return e&&e[t]},Qf.setVisual=function(t,e){if(Xf(t))for(var i in t)t.hasOwnProperty(i)&&this.setVisual(i,t[i]);else this._visual=this._visual||{},this._visual[t]=e},Qf.setLayout=function(t,e){if(Xf(t))for(var i in t)t.hasOwnProperty(i)&&this.setLayout(i,t[i]);else this._layout[t]=e},Qf.getLayout=function(t){return this._layout[t]},Qf.getItemLayout=function(t){return this._itemLayouts[t]},Qf.setItemLayout=function(t,e,i){this._itemLayouts[t]=i?rl.extend(this._itemLayouts[t]||{},e):e},Qf.clearItemLayouts=function(){this._itemLayouts.length=0},Qf.getItemVisual=function(t,e,i){var n=this._itemVisuals[t],a=n&&n[e];return null!=a||i?a:this.getVisual(e)},Qf.setItemVisual=function(t,e,i){var n=this._itemVisuals[t]||{};if(this._itemVisuals[t]=n,Xf(e))for(var a in e)e.hasOwnProperty(a)&&(n[a]=e[a]);else n[e]=i},Qf.clearAllVisual=function(){this._visual={},this._itemVisuals=[]};Qf.setItemGraphicEl=function(t,e){var i=this.hostModel;e&&(e.dataIndex=t,e.dataType=this.dataType,e.seriesIndex=i&&i.seriesIndex,"group"===e.type&&e.traverse(function(t){t.seriesIndex=this.seriesIndex,t.dataIndex=this.dataIndex,t.dataType=this.dataType},e)),this._graphicEls[t]=e},Qf.getItemGraphicEl=function(t){return this._graphicEls[t]},Qf.eachItemGraphicEl=function(t,e){rl.each(this._graphicEls,function(i,n){i&&t&&t.call(e,i,n)})},Qf.cloneShallow=function(){var t=rl.map(this.dimensions,this.getDimensionInfo,this),e=new Jf(t,this.hostModel);return e._storage=this._storage,Ne(e,this),e.indices=this.indices.slice(),this._extent&&(e._extent=rl.extend({},this._extent)),e},Qf.wrapMethod=function(t,e){var i=this[t];"function"==typeof i&&(this.__wrappedMethods=this.__wrappedMethods||[],this.__wrappedMethods.push(t),this[t]=function(){var t=i.apply(this,arguments);return e.apply(this,[t].concat(rl.slice(arguments)))})},Qf.TRANSFERABLE_METHODS=["cloneShallow","downSample","map"],Qf.CHANGABLE_METHODS=["filterSelf"];var tg=Jf,eg=Ip.normalizeToArray,ig=rl.each,ng=rl.isString,ag=rl.defaults,og={tooltip:1,label:1,itemName:1},rg=He.guessOrdinal=function(t,e){for(var i=0,n=t.length;i<n;i++){a=We(t[i]);if(!rl.isArray(a))return!1;var a;if(null!=(a=a[e])&&isFinite(a)&&""!==a)return!1;if(ng(a)&&"-"!==a)return!0}return!1},sg=He,lg=Ip.getDataItemValue,hg=Ip.converDataValue,ug=Ip.isDataItemOption,cg={cartesian2d:function(t,e,i,n){var a=rl.map(["xAxis","yAxis"],function(t){return i.queryComponents({mainType:t,index:e.get(t+"Index"),id:e.get(t+"Id")})[0]}),o=a[0],r=a[1],s=o.get("type"),l=r.get("type"),h=[{name:"x",type:Ze(s),stackable:Fe(s)},{name:"y",type:Ze(l),stackable:Fe(l)}],u="category"===s,c="category"===l;h=sg(h,t,n);var d={};return u&&(d.x=o),c&&(d.y=r),{dimensions:h,categoryIndex:u?0:c?1:-1,categoryAxesModels:d}},singleAxis:function(t,e,i,n){var a=i.queryComponents({mainType:"singleAxis",index:e.get("singleAxisIndex"),id:e.get("singleAxisId")})[0],o=a.get("type"),r="category"===o,s=[{name:"single",type:Ze(o),stackable:Fe(o)}];s=sg(s,t,n);var l={};return r&&(l.single=a),{dimensions:s,categoryIndex:r?0:-1,categoryAxesModels:l}},polar:function(t,e,i,n){var a=i.queryComponents({mainType:"polar",index:e.get("polarIndex"),id:e.get("polarId")})[0],o=a.findAxisModel("angleAxis"),r=a.findAxisModel("radiusAxis"),s=r.get("type"),l=o.get("type"),h=[{name:"radius",type:Ze(s),stackable:Fe(s)},{name:"angle",type:Ze(l),stackable:Fe(l)}],u="category"===l,c="category"===s;h=sg(h,t,n);var d={};return c&&(d.radius=r),u&&(d.angle=o),{dimensions:h,categoryIndex:u?1:c?0:-1,categoryAxesModels:d}},geo:function(t,e,i,n){return{dimensions:sg([{name:"lng"},{name:"lat"}],t,n)}}},dg=function(t,e,i){t=t||[];var n=e.get("coordinateSystem"),a=cg[n],o=rf.get(n),r={encodeDef:e.get("encode"),dimsDef:e.get("dimensions")},s=a&&a(t,e,i,r),l=s&&s.dimensions;l||(l=o&&(o.getDimensionsInfo?o.getDimensionsInfo():o.dimensions.slice())||["x","y"],l=sg(l,t,r));var h=s?s.categoryIndex:-1,u=new tg(l,e),c=function(t,e){var i,n=[],a=t&&t.dimensions[t.categoryIndex];if(a&&(i=t.categoryAxesModels[a.name]),i){var o=i.getCategories();if(o){var r=e.length;if(rl.isArray(e[0])&&e[0].length>1){n=[];for(var s=0;s<r;s++)n[s]=o[e[s][t.categoryIndex||0]]}else n=o.slice(0)}}return n}(s,t),d={},p=h>=0&&function(t){var e=function(t){for(var e=0;e<t.length&&null==t[e];)e++;return t[e]}(t);return null!=e&&!rl.isArray(lg(e))}(t)?function(t,e,i,n){return ug(t)&&(u.hasItemOption=!0),n===h?i:hg(lg(t),l[n])}:function(t,e,i,n){var a=lg(t),o=hg(a&&a[n],l[n]);ug(t)&&(u.hasItemOption=!0);var r=s&&s.categoryAxesModels;return r&&r[e]&&"string"==typeof o&&(d[e]=d[e]||r[e].getCategories(),(o=rl.indexOf(d[e],o))<0&&!isNaN(o)&&(o=+o)),o};return u.hasItemOption=!1,u.initData(t,c,p),u};je.prototype.parse=function(t){return t},je.prototype.getSetting=function(t){return this._setting[t]},je.prototype.contain=function(t){var e=this._extent;return t>=e[0]&&t<=e[1]},je.prototype.normalize=function(t){var e=this._extent;return e[1]===e[0]?.5:(t-e[0])/(e[1]-e[0])},je.prototype.scale=function(t){var e=this._extent;return t*(e[1]-e[0])+e[0]},je.prototype.unionExtent=function(t){var e=this._extent;t[0]<e[0]&&(e[0]=t[0]),t[1]>e[1]&&(e[1]=t[1])},je.prototype.unionExtentFromData=function(t,e){this.unionExtent(t.getDataExtent(e,!0))},je.prototype.getExtent=function(){return this._extent.slice()},je.prototype.setExtent=function(t,e){var i=this._extent;isNaN(t)||(i[0]=t),isNaN(e)||(i[1]=e)},je.prototype.getTicksLabels=function(){for(var t=[],e=this.getTicks(),i=0;i<e.length;i++)t.push(this.getLabel(e[i]));return t},je.prototype.isBlank=function(){return this._isBlank},je.prototype.setBlank=function(t){this._isBlank=t},Bu.enableClassExtend(je),Bu.enableClassManagement(je,{registerWhenExtend:!0});var pg=je,fg=pg.prototype,gg=pg.extend({type:"ordinal",init:function(t,e){this._data=t,this._extent=e||[0,t.length-1]},parse:function(t){return"string"==typeof t?rl.indexOf(this._data,t):Math.round(t)},contain:function(t){return t=this.parse(t),fg.contain.call(this,t)&&null!=this._data[t]},normalize:function(t){return fg.normalize.call(this,this.parse(t))},scale:function(t){return Math.round(fg.scale.call(this,t))},getTicks:function(){for(var t=[],e=this._extent,i=e[0];i<=e[1];)t.push(i),i++;return t},getLabel:function(t){return this._data[t]},count:function(){return this._extent[1]-this._extent[0]+1},unionExtentFromData:function(t,e){this.unionExtent(t.getDataExtent(e,!1))},niceTicks:rl.noop,niceExtent:rl.noop});gg.create=function(){return new gg};var mg=gg,vg=Pu.round,yg={intervalScaleNiceTicks:function(t,e,i,n){var a={},o=t[1]-t[0],r=a.interval=Pu.nice(o/e,!0);null!=i&&r<i&&(r=a.interval=i),null!=n&&r>n&&(r=a.interval=n);var s=a.intervalPrecision=Ue(r);return Xe(a.niceTickExtent=[vg(Math.ceil(t[0]/r)*r,s),vg(Math.floor(t[1]/r)*r,s)],t),a},getIntervalPrecision:Ue,fixExtent:Xe,intervalScaleGetTicks:function(t,e,i,n){var a=[];if(!t)return a;e[0]<i[0]&&a.push(e[0]);for(var o=i[0];o<=i[1]&&(a.push(o),(o=vg(o+t,n))!==a[a.length-1]);)if(a.length>1e4)return[];return e[1]>(a.length?a[a.length-1]:i[1])&&a.push(e[1]),a}},xg=Pu.round,_g=pg.extend({type:"interval",_interval:0,_intervalPrecision:2,setExtent:function(t,e){var i=this._extent;isNaN(t)||(i[0]=parseFloat(t)),isNaN(e)||(i[1]=parseFloat(e))},unionExtent:function(t){var e=this._extent;t[0]<e[0]&&(e[0]=t[0]),t[1]>e[1]&&(e[1]=t[1]),_g.prototype.setExtent.call(this,e[0],e[1])},getInterval:function(){return this._interval},setInterval:function(t){this._interval=t,this._niceExtent=this._extent.slice(),this._intervalPrecision=yg.getIntervalPrecision(t)},getTicks:function(){return yg.intervalScaleGetTicks(this._interval,this._extent,this._niceExtent,this._intervalPrecision)},getTicksLabels:function(){for(var t=[],e=this.getTicks(),i=0;i<e.length;i++)t.push(this.getLabel(e[i]));return t},getLabel:function(t,e){if(null==t)return"";var i=e&&e.precision;return null==i?i=Pu.getPrecisionSafe(t)||0:"auto"===i&&(i=this._intervalPrecision),t=xg(t,i,!0),Eu.addCommas(t)},niceTicks:function(t,e,i){t=t||5;var n=this._extent,a=n[1]-n[0];if(isFinite(a)){a<0&&(a=-a,n.reverse());var o=yg.intervalScaleNiceTicks(n,t,e,i);this._intervalPrecision=o.intervalPrecision,this._interval=o.interval,this._niceExtent=o.niceTickExtent}},niceExtent:function(t){var e=this._extent;if(e[0]===e[1])if(0!==e[0]){var i=e[0];t.fixMax?e[0]-=i/2:(e[1]+=i/2,e[0]-=i/2)}else e[1]=1;var n=e[1]-e[0];isFinite(n)||(e[0]=0,e[1]=1),this.niceTicks(t.splitNumber,t.minInterval,t.maxInterval);var a=this._interval;t.fixMin||(e[0]=xg(Math.floor(e[0]/a)*a)),t.fixMax||(e[1]=xg(Math.ceil(e[1]/a)*a))}});_g.create=function(){return new _g};var bg=_g,wg=bg.prototype,Sg=Math.ceil,Mg=Math.floor,Ig=bg.extend({type:"time",getLabel:function(t){var e=this._stepLvl,i=new Date(t);return Eu.formatTime(e[0],i,this.getSetting("useUTC"))},niceExtent:function(t){var e=this._extent;if(e[0]===e[1]&&(e[0]-=864e5,e[1]+=864e5),e[1]===-1/0&&e[0]===1/0){var i=new Date;e[1]=+new Date(i.getFullYear(),i.getMonth(),i.getDate()),e[0]=e[1]-864e5}this.niceTicks(t.splitNumber,t.minInterval,t.maxInterval);var n=this._interval;t.fixMin||(e[0]=Pu.round(Mg(e[0]/n)*n)),t.fixMax||(e[1]=Pu.round(Sg(e[1]/n)*n))},niceTicks:function(t,e,i){t=t||10;var n=this._extent,a=n[1]-n[0],o=a/t;null!=e&&o<e&&(o=e),null!=i&&o>i&&(o=i);var r=Tg.length,s=function(t,e,i,n){for(;i<n;){var a=i+n>>>1;t[a][1]<e?i=a+1:n=a}return i}(Tg,o,0,r),l=Tg[Math.min(s,r-1)],h=l[1];if("year"===l[0]){var u=a/h;h*=Pu.nice(u/t,!0)}var c=this.getSetting("useUTC")?0:60*new Date(+n[0]||+n[1]).getTimezoneOffset()*1e3,d=[Math.round(Sg((n[0]-c)/h)*h+c),Math.round(Mg((n[1]-c)/h)*h+c)];yg.fixExtent(d,n),this._stepLvl=l,this._interval=h,this._niceExtent=d},parse:function(t){return+Pu.parseDate(t)}});rl.each(["contain","normalize"],function(t){Ig.prototype[t]=function(e){return wg[t].call(this,this.parse(e))}});var Tg=[["hh:mm:ss",1e3],["hh:mm:ss",5e3],["hh:mm:ss",1e4],["hh:mm:ss",15e3],["hh:mm:ss",3e4],["hh:mm\nMM-dd",6e4],["hh:mm\nMM-dd",3e5],["hh:mm\nMM-dd",6e5],["hh:mm\nMM-dd",9e5],["hh:mm\nMM-dd",18e5],["hh:mm\nMM-dd",36e5],["hh:mm\nMM-dd",72e5],["hh:mm\nMM-dd",216e5],["hh:mm\nMM-dd",432e5],["MM-dd\nyyyy",864e5],["MM-dd\nyyyy",1728e5],["MM-dd\nyyyy",2592e5],["MM-dd\nyyyy",3456e5],["MM-dd\nyyyy",432e6],["MM-dd\nyyyy",5184e5],["week",6048e5],["MM-dd\nyyyy",864e6],["week",12096e5],["week",18144e5],["month",26784e5],["week",36288e5],["month",53568e5],["week",36288e5],["quarter",8208e6],["month",107136e5],["month",13392e6],["half-year",16416e6],["month",214272e5],["month",26784e6],["year",32832e6]];Ig.create=function(t){return new Ig({useUTC:t.ecModel.get("useUTC")})};var Ag=pg.prototype,Cg=bg.prototype,Lg=Pu.getPrecisionSafe,Dg=Pu.round,Pg=Math.floor,kg=Math.ceil,Og=Math.pow,zg=Math.log,Eg=pg.extend({type:"log",base:10,$constructor:function(){pg.apply(this,arguments),this._originalScale=new bg},getTicks:function(){var t=this._originalScale,e=this._extent,i=t.getExtent();return rl.map(Cg.getTicks.call(this),function(n){var a=Pu.round(Og(this.base,n));return a=n===e[0]&&t.__fixMin?Ye(a,i[0]):a,a=n===e[1]&&t.__fixMax?Ye(a,i[1]):a},this)},getLabel:Cg.getLabel,scale:function(t){return t=Ag.scale.call(this,t),Og(this.base,t)},setExtent:function(t,e){var i=this.base;t=zg(t)/zg(i),e=zg(e)/zg(i),Cg.setExtent.call(this,t,e)},getExtent:function(){var t=this.base,e=Ag.getExtent.call(this);e[0]=Og(t,e[0]),e[1]=Og(t,e[1]);var i=this._originalScale,n=i.getExtent();return i.__fixMin&&(e[0]=Ye(e[0],n[0])),i.__fixMax&&(e[1]=Ye(e[1],n[1])),e},unionExtent:function(t){this._originalScale.unionExtent(t);var e=this.base;t[0]=zg(t[0])/zg(e),t[1]=zg(t[1])/zg(e),Ag.unionExtent.call(this,t)},unionExtentFromData:function(t,e){this.unionExtent(t.getDataExtent(e,!0,function(t){return t>0}))},niceTicks:function(t){t=t||10;var e=this._extent,i=e[1]-e[0];if(!(i===1/0||i<=0)){var n=Pu.quantity(i);for(t/i*n<=.5&&(n*=10);!isNaN(n)&&Math.abs(n)<1&&Math.abs(n)>0;)n*=10;var a=[Pu.round(kg(e[0]/n)*n),Pu.round(Pg(e[1]/n)*n)];this._interval=n,this._niceExtent=a}},niceExtent:function(t){Cg.niceExtent.call(this,t);var e=this._originalScale;e.__fixMin=t.fixMin,e.__fixMax=t.fixMax}});rl.each(["contain","normalize"],function(t){Eg.prototype[t]=function(e){return e=zg(e)/zg(this.base),Ag[t].call(this,e)}}),Eg.create=function(){return new Eg};var Rg={getScaleExtent:$e,niceScaleExtent:function(t,e){var i=$e(t,e),n=null!=e.getMin(),a=null!=e.getMax(),o=e.get("splitNumber");"log"===t.type&&(t.base=e.get("logBase"));var r=t.type;t.setExtent(i[0],i[1]),t.niceExtent({splitNumber:o,fixMin:n,fixMax:a,minInterval:"interval"===r||"time"===r?e.get("minInterval"):null,maxInterval:"interval"===r||"time"===r?e.get("maxInterval"):null});var s=e.get("interval");null!=s&&t.setInterval&&t.setInterval(s)},createScaleByModel:function(t,e){if(e=e||t.get("type"))switch(e){case"category":return new mg(t.getCategories(),[1/0,-1/0]);case"value":return new bg;default:return(pg.getClass(e)||bg).create(t)}},ifAxisCrossZero:function(t){var e=t.scale.getExtent(),i=e[0],n=e[1];return!(i>0&&n>0||i<0&&n<0)},getAxisLabelInterval:function(t,e,i,n,a){var o,r=0,s=0,l=(n-a)/180*Math.PI,h=1;e.length>40&&(h=Math.floor(e.length/40));for(var u=0;u<t.length;u+=h){var c=t[u],d=Nh.getBoundingRect(e[u],i,"center","top");d.x+=c*Math.cos(l),d.y+=c*Math.sin(l),d.width*=1.3,d.height*=1.3,o?o.intersect(d)?(s++,r=Math.max(r,s)):(o.union(d),s=0):o=d.clone()}return 0===r&&h>1?h:(r+1)*h-1},getFormattedLabels:function(t,e){var i=t.scale,n=i.getTicksLabels(),a=i.getTicks();return"string"==typeof e?(e=function(t){return function(e){return t.replace("{value}",null!=e?e:"")}}(e),rl.map(n,e)):"function"==typeof e?rl.map(a,function(i,n){return e(Ke(t,i),n)},this):n},getAxisRawValue:Ke},Ng={getFormattedLabels:function(){return Rg.getFormattedLabels(this.axis,this.get("axisLabel.formatter"))},getCategories:function(){return"category"===this.get("type")&&rl.map(this.get("data"),function(t){return rl.isObject(t)&&null!=t.value?t.value:t+""})},getMin:function(t){var e=this.option,i=t||null==e.rangeStart?e.min:e.rangeStart;return this.axis&&null!=i&&"dataMin"!==i&&"function"!=typeof i&&!rl.eqNaN(i)&&(i=this.axis.scale.parse(i)),i},getMax:function(t){var e=this.option,i=t||null==e.rangeEnd?e.max:e.rangeEnd;return this.axis&&null!=i&&"dataMax"!==i&&"function"!=typeof i&&!rl.eqNaN(i)&&(i=this.axis.scale.parse(i)),i},getNeedCrossZero:function(){var t=this.option;return null==t.rangeStart&&null==t.rangeEnd&&!t.scale},getCoordSysModel:rl.noop,setRange:function(t,e){this.option.rangeStart=t,this.option.rangeEnd=e},resetRange:function(){this.option.rangeStart=this.option.rangeEnd=null}},Vg=fp.extendShape({type:"triangle",shape:{cx:0,cy:0,width:0,height:0},buildPath:function(t,e){var i=e.cx,n=e.cy,a=e.width/2,o=e.height/2;t.moveTo(i,n-o),t.lineTo(i+a,n+o),t.lineTo(i-a,n+o),t.closePath()}}),Bg=fp.extendShape({type:"diamond",shape:{cx:0,cy:0,width:0,height:0},buildPath:function(t,e){var i=e.cx,n=e.cy,a=e.width/2,o=e.height/2;t.moveTo(i,n-o),t.lineTo(i+a,n),t.lineTo(i,n+o),t.lineTo(i-a,n),t.closePath()}}),Gg=fp.extendShape({type:"pin",shape:{x:0,y:0,width:0,height:0},buildPath:function(t,e){var i=e.x,n=e.y,a=e.width/5*3,o=Math.max(a,e.height),r=a/2,s=r*r/(o-r),l=n-o+r+s,h=Math.asin(s/r),u=Math.cos(h)*r,c=Math.sin(h),d=Math.cos(h),p=.6*r,f=.7*r;t.moveTo(i-u,l+s),t.arc(i,l,r,Math.PI-h,2*Math.PI+h),t.bezierCurveTo(i+u-c*p,l+s+d*p,i,n-f,i,n),t.bezierCurveTo(i,n-f,i-u+c*p,l+s+d*p,i-u,l+s),t.closePath()}}),Hg=fp.extendShape({type:"arrow",shape:{x:0,y:0,width:0,height:0},buildPath:function(t,e){var i=e.height,n=e.width,a=e.x,o=e.y,r=n/3*2;t.moveTo(a,o),t.lineTo(a+r,o+i),t.lineTo(a,o+i/4*3),t.lineTo(a-r,o+i),t.lineTo(a,o),t.closePath()}}),Wg={line:fp.Line,rect:fp.Rect,roundRect:fp.Rect,square:fp.Rect,circle:fp.Circle,diamond:Bg,pin:Gg,arrow:Hg,triangle:Vg},Fg={line:function(t,e,i,n,a){a.x1=t,a.y1=e+n/2,a.x2=t+i,a.y2=e+n/2},rect:function(t,e,i,n,a){a.x=t,a.y=e,a.width=i,a.height=n},roundRect:function(t,e,i,n,a){a.x=t,a.y=e,a.width=i,a.height=n,a.r=Math.min(i,n)/4},square:function(t,e,i,n,a){var o=Math.min(i,n);a.x=t,a.y=e,a.width=o,a.height=o},circle:function(t,e,i,n,a){a.cx=t+i/2,a.cy=e+n/2,a.r=Math.min(i,n)/2},diamond:function(t,e,i,n,a){a.cx=t+i/2,a.cy=e+n/2,a.width=i,a.height=n},pin:function(t,e,i,n,a){a.x=t+i/2,a.y=e+n/2,a.width=i,a.height=n},arrow:function(t,e,i,n,a){a.x=t+i/2,a.y=e+n/2,a.width=i,a.height=n},triangle:function(t,e,i,n,a){a.cx=t+i/2,a.cy=e+n/2,a.width=i,a.height=n}},Zg={};rl.each(Wg,function(t,e){Zg[e]=new t});var jg=fp.extendShape({type:"symbol",shape:{symbolType:"",x:0,y:0,width:0,height:0},beforeBrush:function(){var t=this.style;"pin"===this.shape.symbolType&&"inside"===t.textPosition&&(t.textPosition=["50%","40%"],t.textAlign="center",t.textVerticalAlign="middle")},buildPath:function(t,e,i){var n=e.symbolType,a=Zg[n];"none"!==e.symbolType&&(a||(a=Zg[n="rect"]),Fg[n](e.x,e.y,e.width,e.height,a.shape),a.buildPath(t,a.shape,i))}}),Ug={createSymbol:function(t,e,i,n,a,o,r){var s=0===t.indexOf("empty");s&&(t=t.substr(5,1).toLowerCase()+t.substr(6));var l;return l=0===t.indexOf("image://")?fp.makeImage(t.slice(8),new oh(e,i,n,a),r?"center":"cover"):0===t.indexOf("path://")?fp.makePath(t.slice(7),{},new oh(e,i,n,a),r?"center":"cover"):new jg({shape:{symbolType:t,x:e,y:i,width:n,height:a}}),l.__isEmptyBrush=s,l.setColor=function(t,e){if("image"!==this.type){var i=this.style,n=this.shape;n&&"line"===n.symbolType?i.stroke=t:this.__isEmptyBrush?(i.stroke=t,i.fill=e||"#fff"):(i.fill&&(i.fill=t),i.stroke&&(i.stroke=t)),this.dirty(!1)}},l.setColor(o),l}},qg={completeDimensions:sg,createSymbol:Ug.createSymbol,createList:function(t){var e=t.get("data");return dg(e,t,t.ecModel)},createScale:function(t,e){var i=e;e instanceof _p||(i=new _p(e),rl.mixin(i,Ng));var n=Rg.createScaleByModel(i);return n.setExtent(t[0],t[1]),Rg.niceScaleExtent(n,i),n},mixinAxisModelCommonMethods:function(t){rl.mixin(t,Ng)}},Xg=Pu.linearMap,Yg=[0,1],$g=function(t,e,i){this.dim=t,this.scale=e,this._extent=i||[0,0],this.inverse=!1,this.onBand=!1,this._labelInterval};$g.prototype={constructor:$g,contain:function(t){var e=this._extent,i=Math.min(e[0],e[1]),n=Math.max(e[0],e[1]);return t>=i&&t<=n},containData:function(t){return this.contain(this.dataToCoord(t))},getExtent:function(){return this._extent.slice()},getPixelPrecision:function(t){return Pu.getPixelPrecision(t||this.scale.getExtent(),this._extent)},setExtent:function(t,e){var i=this._extent;i[0]=t,i[1]=e},dataToCoord:function(t,e){var i=this._extent,n=this.scale;return t=n.normalize(t),this.onBand&&"ordinal"===n.type&&Je(i=i.slice(),n.count()),Xg(t,Yg,i,e)},coordToData:function(t,e){var i=this._extent,n=this.scale;this.onBand&&"ordinal"===n.type&&Je(i=i.slice(),n.count());var a=Xg(t,i,Yg,e);return this.scale.scale(a)},pointToData:function(t,e){},getTicksCoords:function(t){if(this.onBand&&!t){for(var e=this.getBands(),i=[],n=0;n<e.length;n++)i.push(e[n][0]);return e[n-1]&&i.push(e[n-1][1]),i}return rl.map(this.scale.getTicks(),this.dataToCoord,this)},getLabelsCoords:function(){return rl.map(this.scale.getTicks(),this.dataToCoord,this)},getBands:function(){for(var t=this.getExtent(),e=[],i=this.scale.count(),n=t[0],a=t[1]-n,o=0;o<i;o++)e.push([a*o/i+n,a*(o+1)/i+n]);return e},getBandWidth:function(){var t=this._extent,e=this.scale.getExtent(),i=e[1]-e[0]+(this.onBand?1:0);0===i&&(i=1);var n=Math.abs(t[1]-t[0]);return Math.abs(n)/i},isHorizontal:null,getRotate:null,getLabelInterval:function(){var t=this._labelInterval;if(!t){var e=this.model,i=e.getModel("axisLabel");t=i.get("interval"),"category"!==this.type||null!=t&&"auto"!==t||(t=Rg.getAxisLabelInterval(rl.map(this.scale.getTicks(),this.dataToCoord,this),e.getFormattedLabels(),i.getFont(),this.getRotate?this.getRotate():this.isHorizontal&&!this.isHorizontal()?90:0,i.get("rotate"))),this._labelInterval=t}return t}};var Kg=$g,Jg=1e-8,Qg={contain:function(t,e,i){var n=0,a=t[0];if(!a)return!1;for(var o=1;o<t.length;o++){var r=t[o];n+=Vc(a[0],a[1],r[0],r[1],e,i),a=r}var s=t[0];return Qe(a[0],s[0])&&Qe(a[1],s[1])||(n+=Vc(a[0],a[1],s[0],s[1],e,i)),0!==n}};ti.prototype={constructor:ti,properties:null,getBoundingRect:function(){var t=this._rect;if(t)return t;for(var e=Number.MAX_VALUE,i=[e,e],n=[-e,-e],a=[],o=[],r=this.geometries,s=0;s<r.length;s++)if("polygon"===r[s].type){var l=r[s].exterior;pc.fromPoints(l,a,o),ll.min(i,i,a),ll.max(n,n,o)}return 0===s&&(i[0]=i[1]=n[0]=n[1]=0),this._rect=new oh(i[0],i[1],n[0]-i[0],n[1]-i[1])},contain:function(t){var e=this.getBoundingRect(),i=this.geometries;if(!e.contain(t[0],t[1]))return!1;t:for(var n=0,a=i.length;n<a;n++)if("polygon"===i[n].type){var o=i[n].exterior,r=i[n].interiors;if(Qg.contain(o,t[0],t[1])){for(var s=0;s<(r?r.length:0);s++)if(Qg.contain(r[s]))continue t;return!0}}return!1},transformTo:function(t,e,i,n){var a=this.getBoundingRect(),o=a.width/a.height;i?n||(n=i/o):i=o*n;for(var r=new oh(t,e,i,n),s=a.calculateTransform(r),l=this.geometries,h=0;h<l.length;h++)if("polygon"===l[h].type){for(var u=l[h].exterior,c=l[h].interiors,d=0;d<u.length;d++)ll.applyTransform(u[d],u[d],s);for(var p=0;p<(c?c.length:0);p++)for(d=0;d<c[p].length;d++)ll.applyTransform(c[p][d],c[p][d],s)}(a=this._rect).copy(r),this.center=[a.x+a.width/2,a.y+a.height/2]}};var tm=ti,em=function(t){return function(t){if(!t.UTF8Encoding)return t;var e=t.UTF8Scale;null==e&&(e=1024);for(var i=t.features,n=0;n<i.length;n++)for(var a=i[n].geometry,o=a.coordinates,r=a.encodeOffsets,s=0;s<o.length;s++){var l=o[s];if("Polygon"===a.type)o[s]=ei(l,r[s],e);else if("MultiPolygon"===a.type)for(var h=0;h<l.length;h++){var u=l[h];l[h]=ei(u,r[s][h],e)}}t.UTF8Encoding=!1}(t),rl.map(rl.filter(t.features,function(t){return t.geometry&&t.properties&&t.geometry.coordinates.length>0}),function(t){var e=t.properties,i=t.geometry,n=i.coordinates,a=[];"Polygon"===i.type&&a.push({type:"polygon",exterior:n[0],interiors:n.slice(1)}),"MultiPolygon"===i.type&&rl.each(n,function(t){t[0]&&a.push({type:"polygon",exterior:t[0],interiors:t.slice(1)})});var o=new tm(e.name,a,e.cp);return o.properties=e,o})},im=Cu,nm=yl,am=ll,om=Nl,rm=fp,sm=Pu,lm=Eu,hm=(Ff.throttle,Ff.throttle),um=qg,cm=tg,dm=_p,pm=Kg,fm=Us,gm=em,mm={};rl.each(["map","each","filter","indexOf","inherits","reduce","filter","bind","curry","isArray","isString","isObject","isFunction","extend","defaults","clone","merge"],function(t){mm[t]=rl[t]});var vm={zrender:im,matrix:nm,vector:am,color:om,graphic:rm,number:sm,format:lm,throttle:hm,helper:um,List:cm,Model:dm,Axis:pm,env:fm,parseGeoJson:gm,util:mm},ym=e(function(t,e){function i(t){return function(e,i,n){e=e&&e.toLowerCase(),dl.prototype[t].call(this,e,i,n)}}function n(){dl.call(this)}function a(t,e,i){function a(t,e){return t.prio-e.prio}i=i||{},"string"==typeof e&&(e=H[e]),this.id,this.group,this._dom=t;var o=this._zr=Cu.init(t,{renderer:i.renderer||"canvas",devicePixelRatio:i.devicePixelRatio,width:i.width,height:i.height});this._throttledZrFlush=w(rl.bind(o.flush,o),17);(e=rl.clone(e))&&Mf(e,!0),this._theme=e,this._chartsViews=[],this._chartsMap={},this._componentsViews=[],this._componentsMap={},this._coordSysMgr=new rf,this._api=function(t){var e=t._coordSysMgr;return rl.extend(new af(t),{getCoordinateSystems:rl.bind(e.getCoordinateSystems,e),getComponentByElement:function(e){for(;e;){var i=e.__ecComponentInfo;if(null!=i)return t._model.getComponent(i.mainType,i.index);e=e.parent}}})}(this),dl.call(this),this._messageCenter=new n,this._initEvents(),this.resize=rl.bind(this.resize,this),this._pendingActions=[],uh(G,a),uh(N,a),o.animation.on("frame",this._onframe,this),rl.setAsPrimitive(this)}function o(t,e,i){var n,a=this._model,o=this._coordSysMgr.getCoordinateSystems();e=Ip.parseFinder(a,e);for(var r=0;r<o.length;r++){var s=o[r];if(s[t]&&null!=(n=s[t](a,e,i)))return n}}function r(t,e,i,n,a){function o(n){n&&n.__alive&&n[e]&&n[e](n.__model,r,t._api,i)}var r=t._model;if(n){var s={};s[n+"Id"]=i[n+"Id"],s[n+"Index"]=i[n+"Index"],s[n+"Name"]=i[n+"Name"];var l={mainType:n,query:s};a&&(l.subType=a),r&&r.eachComponent(l,function(e,i){o(t["series"===n?"_chartsMap":"_componentsMap"][e.__viewId])},t)}else S(t._componentsViews.concat(t._chartsViews),o)}function s(t,e){var i=t.type,n=t.escapeConnect,a=E[i],o=a.actionInfo,s=(o.update||"update").split(":"),l=s.pop();s=null!=s[0]&&M(s[0]),this[L]=!0;var h=[t],u=!1;t.batch&&(u=!0,h=rl.map(t.batch,function(e){return e=rl.defaults(rl.extend({},e),t),e.batch=null,e}));var c,d=[],p="highlight"===i||"downplay"===i;S(h,function(t){c=a.action(t,this._model,this._api),(c=c||rl.extend({},t)).type=o.event||c.type,d.push(c),p?r(this,l,t,"series"):s&&r(this,l,t,s.main,s.sub)},this),"none"===l||p||s||(this[D]?(O.prepareAndUpdate.call(this,t),this[D]=!1):O[l].call(this,t)),c=u?{type:o.event||i,escapeConnect:n,batch:d}:d[0],this[L]=!1,!e&&this._messageCenter.trigger(c.type,c)}function l(t){for(var e=this._pendingActions;e.length;){var i=e.shift();s.call(this,i,t)}}function h(t){!t&&this.trigger("updated")}function u(t,e,i){var n=this._api;S(this._componentsViews,function(a){var o=a.__model;a[t](o,e,n,i),g(o,a)},this),e.eachSeries(function(a,o){var r=this._chartsMap[a.__viewId];r[t](a,e,n,i),g(a,r),f(a,r)},this),p(this._zr,e),S(B,function(t){t(e,n)})}function c(t,e){for(var i="component"===t,n=i?this._componentsViews:this._chartsViews,a=i?this._componentsMap:this._chartsMap,o=this._zr,r=0;r<n.length;r++)n[r].__alive=!1;e[i?"eachComponent":"eachSeries"](function(t,r){if(i){if("series"===t)return}else r=t;var s="_ec_"+r.id+"_"+r.type,l=a[s];if(!l){var h=M(r.type),u=i?Nf.getClass(h.main,h.sub):Bf.getClass(h.sub);if(!u)return;(l=new u).init(e,this._api),a[s]=l,n.push(l),o.add(l.group)}r.__viewId=l.__id=s,l.__alive=!0,l.__model=r,l.group.__ecComponentInfo={mainType:r.mainType,index:r.componentIndex}},this);for(r=0;r<n.length;){var s=n[r];s.__alive?r++:(o.remove(s.group),s.dispose(e,this._api),n.splice(r,1),delete a[s.__id],s.__id=s.group.__ecComponentInfo=null)}}function d(t,e,i){var n=this._api;t.clearColorPalette(),t.eachSeries(function(t){t.clearColorPalette()}),S(G,function(a){(!i||!a.isLayout)&&a.func(t,n,e)})}function p(t,e){var i=t.storage,n=0;i.traverse(function(t){t.isGroup||n++}),n>e.get("hoverLayerThreshold")&&!Us.node&&i.traverse(function(t){t.isGroup||(t.useHoverLayer=!0)})}function f(t,e){var i=0;e.group.traverse(function(t){"group"===t.type||t.ignore||i++});var n=+t.get("progressive"),a=i>t.get("progressiveThreshold")&&n&&!Us.node;a&&e.group.traverse(function(t){t.isGroup||(t.progressive=a?Math.floor(i++/n):-1,a&&t.stopAnimation(!0))});var o=t.get("blendMode")||null;e.group.traverse(function(t){t.isGroup||t.setStyle("blend",o)})}function g(t,e){var i=t.get("z"),n=t.get("zlevel");e.group.traverse(function(t){"group"!==t.type&&(null!=i&&(t.z=i),null!=n&&(t.zlevel=n))})}function m(t){Z[t]=!1}function v(t){var e;return e=t.getAttribute?t.getAttribute(q):t[q],F[e]}function y(t){V.push(t)}function x(t,e,i){"function"==typeof e&&(i=e,e="");var n=rl.isObject(t)?t.type:[t,t={event:e}][0];t.event=(t.event||n).toLowerCase(),e=t.event,rl.assert(P.test(n)&&P.test(e)),E[n]||(E[n]={action:i,actionInfo:t}),R[e]=n}function _(t,e){"function"==typeof t&&(e=t,t=A),G.push({prio:t,func:e})}function b(t,e){W[t]=e}var w=Ff.throttle,S=rl.each,M=Hp.parseClassType,I=1e3,T=1e3,A=3e3,C={PROCESSOR:{FILTER:I,STATISTIC:5e3},VISUAL:{LAYOUT:T,GLOBAL:2e3,CHART:A,COMPONENT:4e3,BRUSH:5e3}},L="__flagInMainProcess",D="__optionUpdated",P=/^[a-zA-Z0-9_]+$/;n.prototype.on=i("on"),n.prototype.off=i("off"),n.prototype.one=i("one"),rl.mixin(n,dl);var k=a.prototype;k._onframe=function(){if(this[D]){var t=this[D].silent;this[L]=!0,O.prepareAndUpdate.call(this),this[L]=!1,this[D]=!1,l.call(this,t),h.call(this,t)}},k.getDom=function(){return this._dom},k.getZr=function(){return this._zr},k.setOption=function(t,e,i){var n;if(rl.isObject(e)&&(i=e.lazyUpdate,n=e.silent,e=e.notMerge),this[L]=!0,!this._model||e){var a=new df(this._api),o=this._theme;(this._model=new ef(null,null,o,a)).init(null,null,o,a)}this._model.setOption(t,V),i?(this[D]={silent:n},this[L]=!1):(O.prepareAndUpdate.call(this),this._zr.flush(),this[D]=!1,this[L]=!1,l.call(this,n),h.call(this,n))},k.setTheme=function(){console.log("ECharts#setTheme() is DEPRECATED in ECharts 3.0")},k.getModel=function(){return this._model},k.getOption=function(){return this._model&&this._model.getOption()},k.getWidth=function(){return this._zr.getWidth()},k.getHeight=function(){return this._zr.getHeight()},k.getDevicePixelRatio=function(){return this._zr.painter.dpr||window.devicePixelRatio||1},k.getRenderedCanvas=function(t){if(Us.canvasSupported){(t=t||{}).pixelRatio=t.pixelRatio||1,t.backgroundColor=t.backgroundColor||this._model.get("backgroundColor");var e=this._zr,i=e.storage.getDisplayList();return rl.each(i,function(t){t.stopAnimation(!0)}),e.painter.getRenderedCanvas(t)}},k.getSvgDataUrl=function(){if(Us.svgSupported){var t=this._zr,e=t.storage.getDisplayList();return rl.each(e,function(t){t.stopAnimation(!0)}),t.painter.pathToSvg()}},k.getDataURL=function(t){var e=(t=t||{}).excludeComponents,i=this._model,n=[],a=this;S(e,function(t){i.eachComponent({mainType:t},function(t){var e=a._componentsMap[t.__viewId];e.group.ignore||(n.push(e),e.group.ignore=!0)})});var o="svg"===this._zr.painter.getType()?this.getSvgDataUrl():this.getRenderedCanvas(t).toDataURL("image/"+(t&&t.type||"png"));return S(n,function(t){t.group.ignore=!1}),o},k.getConnectedDataURL=function(t){if(Us.canvasSupported){var e=this.group,i=Math.min,n=Math.max;if(Z[e]){var a=1/0,o=1/0,r=-1/0,s=-1/0,l=[],h=t&&t.pixelRatio||1;rl.each(F,function(h,u){if(h.group===e){var c=h.getRenderedCanvas(rl.clone(t)),d=h.getDom().getBoundingClientRect();a=i(d.left,a),o=i(d.top,o),r=n(d.right,r),s=n(d.bottom,s),l.push({dom:c,left:d.left,top:d.top})}});var u=(r*=h)-(a*=h),c=(s*=h)-(o*=h),d=rl.createCanvas();d.width=u,d.height=c;var p=Cu.init(d);return S(l,function(t){var e=new fp.Image({style:{x:t.left*h-a,y:t.top*h-o,image:t.dom}});p.add(e)}),p.refreshImmediately(),d.toDataURL("image/"+(t&&t.type||"png"))}return this.getDataURL(t)}},k.convertToPixel=rl.curry(o,"convertToPixel"),k.convertFromPixel=rl.curry(o,"convertFromPixel"),k.containPixel=function(t,e){var i,n=this._model;return t=Ip.parseFinder(n,t),rl.each(t,function(t,n){n.indexOf("Models")>=0&&rl.each(t,function(t){var a=t.coordinateSystem;if(a&&a.containPoint)i|=!!a.containPoint(e);else if("seriesModels"===n){var o=this._chartsMap[t.__viewId];o&&o.containPoint&&(i|=o.containPoint(e,t))}},this)},this),!!i},k.getVisual=function(t,e){var i=this._model,n=(t=Ip.parseFinder(i,t,{defaultMainType:"series"})).seriesModel.getData(),a=t.hasOwnProperty("dataIndexInside")?t.dataIndexInside:t.hasOwnProperty("dataIndex")?n.indexOfRawIndex(t.dataIndex):null;return null!=a?n.getItemVisual(a,e):n.getVisual(e)},k.getViewOfComponentModel=function(t){return this._componentsMap[t.__viewId]},k.getViewOfSeriesModel=function(t){return this._chartsMap[t.__viewId]};var O={update:function(t){var e=this._model,i=this._api,n=this._coordSysMgr,a=this._zr;if(e){e.restoreData(),n.create(this._model,this._api),function(t,e){S(N,function(i){i.func(t,e)})}.call(this,e,i),function(t){var e={};t.eachSeries(function(t){var i=t.get("stack"),n=t.getData();if(i&&"list"===n.type){var a=e[i];e.hasOwnProperty(i)&&a&&(n.stackedOn=a),e[i]=n}})}.call(this,e),n.update(e,i),d.call(this,e,t),function(t,e){var i=this._api;S(this._componentsViews,function(n){var a=n.__model;n.render(a,t,i,e),g(a,n)},this),S(this._chartsViews,function(t){t.__alive=!1},this),t.eachSeries(function(n,a){var o=this._chartsMap[n.__viewId];o.__alive=!0,o.render(n,t,i,e),o.group.silent=!!n.get("silent"),g(n,o),f(n,o)},this),p(this._zr,t),S(this._chartsViews,function(e){e.__alive||e.remove(t,i)},this)}.call(this,e,t);var o=e.get("backgroundColor")||"transparent",r=a.painter;if(r.isSingleCanvas&&r.isSingleCanvas())a.configLayer(0,{clearColor:o});else{if(!Us.canvasSupported){var s=Nl.parse(o);o=Nl.stringify(s,"rgb"),0===s[3]&&(o="transparent")}o.colorStops||o.image?(a.configLayer(0,{clearColor:o}),this.__hasGradientOrPatternBg=!0,this._dom.style.background="transparent"):(this.__hasGradientOrPatternBg&&a.configLayer(0,{clearColor:null}),this.__hasGradientOrPatternBg=!1,this._dom.style.background=o)}S(B,function(t){t(e,i)})}},updateView:function(t){var e=this._model;e&&(e.eachSeries(function(t){t.getData().clearAllVisual()}),d.call(this,e,t),u.call(this,"updateView",e,t))},updateVisual:function(t){var e=this._model;e&&(e.eachSeries(function(t){t.getData().clearAllVisual()}),d.call(this,e,t,!0),u.call(this,"updateVisual",e,t))},updateLayout:function(t){var e=this._model;e&&(function(t,e){var i=this._api;S(G,function(n){n.isLayout&&n.func(t,i,e)})}.call(this,e,t),u.call(this,"updateLayout",e,t))},prepareAndUpdate:function(t){var e=this._model;c.call(this,"component",e),c.call(this,"chart",e),O.update.call(this,t)}};k.resize=function(t){this[L]=!0,this._zr.resize(t);var e=this._model&&this._model.resetOption("media");O[e?"prepareAndUpdate":"update"].call(this),this._loadingFX&&this._loadingFX.resize(),this[L]=!1;var i=t&&t.silent;l.call(this,i),h.call(this,i)},k.showLoading=function(t,e){if(rl.isObject(t)&&(e=t,t=""),t=t||"default",this.hideLoading(),W[t]){var i=W[t](this._api,e),n=this._zr;this._loadingFX=i,n.add(i)}},k.hideLoading=function(){this._loadingFX&&this._zr.remove(this._loadingFX),this._loadingFX=null},k.makeActionFromEvent=function(t){var e=rl.extend({},t);return e.type=R[t.type],e},k.dispatchAction=function(t,e){rl.isObject(e)||(e={silent:!!e}),E[t.type]&&this._model&&(this[L]?this._pendingActions.push(t):(s.call(this,t,e.silent),e.flush?this._zr.flush(!0):!1!==e.flush&&Us.browser.weChat&&this._throttledZrFlush(),l.call(this,e.silent),h.call(this,e.silent)))},k.on=i("on"),k.off=i("off"),k.one=i("one");var z=["click","dblclick","mouseover","mouseout","mousemove","mousedown","mouseup","globalout","contextmenu"];k._initEvents=function(){S(z,function(t){this._zr.on(t,function(e){var i,n=this.getModel(),a=e.target;if("globalout"===t)i={};else if(a&&null!=a.dataIndex){var o=a.dataModel||n.getSeriesByIndex(a.seriesIndex);i=o&&o.getDataParams(a.dataIndex,a.dataType)||{}}else a&&a.eventData&&(i=rl.extend({},a.eventData));i&&(i.event=e,i.type=t,this.trigger(t,i))},this)},this),S(R,function(t,e){this._messageCenter.on(e,function(t){this.trigger(e,t)},this)},this)},k.isDisposed=function(){return this._disposed},k.clear=function(){this.setOption({series:[]},!0)},k.dispose=function(){if(!this._disposed){this._disposed=!0;var t=this._api,e=this._model;S(this._componentsViews,function(i){i.dispose(e,t)}),S(this._chartsViews,function(i){i.dispose(e,t)}),this._zr.dispose(),delete F[this.id]}},rl.mixin(a,dl);var E={},R={},N=[],V=[],B=[],G=[],H={},W={},F={},Z={},j=new Date-0,U=new Date-0,q="_echarts_instance_",X={},Y=m;_(2e3,Zf),y(Mf),b("default",Uf),x({type:"highlight",event:"highlight",update:"highlight"},rl.noop),x({type:"downplay",event:"downplay",update:"downplay"},rl.noop);e.version="3.8.5",e.dependencies={zrender:"3.7.4"},e.PRIORITY=C,e.init=function(t,e,i){var n=v(t);if(n)return n;var o=new a(t,e,i);return o.id="ec_"+j++,F[o.id]=o,t.setAttribute?t.setAttribute(q,o.id):t[q]=o.id,function(t){function e(t,e){for(var n=0;n<t.length;n++)t[n][i]=e}var i="__connectUpdateStatus";rl.each(R,function(n,a){t._messageCenter.on(a,function(n){if(Z[t.group]&&0!==t[i]){if(n&&n.escapeConnect)return;var a=t.makeActionFromEvent(n),o=[];rl.each(F,function(e){e!==t&&e.group===t.group&&o.push(e)}),e(o,0),S(o,function(t){1!==t[i]&&t.dispatchAction(a)}),e(o,2)}})})}(o),o},e.connect=function(t){if(rl.isArray(t)){var e=t;t=null,rl.each(e,function(e){null!=e.group&&(t=e.group)}),t=t||"g_"+U++,rl.each(e,function(e){e.group=t})}return Z[t]=!0,t},e.disConnect=m,e.disconnect=Y,e.dispose=function(t){"string"==typeof t?t=F[t]:t instanceof a||(t=v(t)),t instanceof a&&!t.isDisposed()&&t.dispose()},e.getInstanceByDom=v,e.getInstanceById=function(t){return F[t]},e.registerTheme=function(t,e){H[t]=e},e.registerPreprocessor=y,e.registerProcessor=function(t,e){"function"==typeof t&&(e=t,t=I),N.push({prio:t,func:e})},e.registerPostUpdate=function(t){B.push(t)},e.registerAction=x,e.registerCoordinateSystem=function(t,e){rf.register(t,e)},e.getCoordinateSystemDimensions=function(t){var e=rf.get(t);if(e)return e.getDimensionsInfo?e.getDimensionsInfo():e.dimensions.slice()},e.registerLayout=function(t,e){"function"==typeof t&&(e=t,t=T),G.push({prio:t,func:e,isLayout:!0})},e.registerVisual=_,e.registerLoading=b,e.extendComponentModel=function(t){return Hp.extend(t)},e.extendComponentView=function(t){return Nf.extend(t)},e.extendSeriesModel=function(t){return zf.extend(t)},e.extendChartView=function(t){return Bf.extend(t)},e.setCanvasCreator=function(t){rl.$override("createCanvas",t)},e.registerMap=function(t,e,i){e.geoJson&&!e.features&&(i=e.specialAreas,e=e.geoJson),"string"==typeof e&&(e="undefined"!=typeof JSON&&JSON.parse?JSON.parse(e):new Function("return ("+e+");")()),X[t]={geoJson:e,specialAreas:i}},e.getMap=function(t){return X[t]},e.dataTool={},function(){for(var t in vm)vm.hasOwnProperty(t)&&(e[t]=vm[t])}()}),xm=(ym.version,ym.dependencies,ym.PRIORITY,ym.init,ym.connect,ym.disConnect,ym.disconnect,ym.dispose,ym.getInstanceByDom,ym.getInstanceById,ym.registerTheme,ym.registerPreprocessor,ym.registerProcessor,ym.registerPostUpdate,ym.registerAction,ym.registerCoordinateSystem,ym.getCoordinateSystemDimensions,ym.registerLayout,ym.registerVisual,ym.registerLoading,ym.extendComponentModel,ym.extendComponentView,ym.extendSeriesModel,ym.extendChartView,ym.setCanvasCreator,ym.registerMap,ym.getMap,ym.dataTool,zf.extend({type:"series.line",dependencies:["grid","polar"],getInitialData:function(t,e){return dg(t.data,this,e)},defaultOption:{zlevel:0,z:2,coordinateSystem:"cartesian2d",legendHoverLink:!0,hoverAnimation:!0,clipOverflow:!0,label:{normal:{position:"top"}},lineStyle:{normal:{width:2,type:"solid"}},step:!1,smooth:!1,smoothMonotone:null,symbol:"emptyCircle",symbolSize:4,symbolRotate:null,showSymbol:!0,showAllSymbol:!1,connectNulls:!1,sampling:"none",animationEasing:"linear",progressive:0,hoverLayerThreshold:1/0}}),Ip.otherDimToDataDim),_m={findLabelValueDim:function(t){var e,i=xm(t,"label");if(i.length)e=i[0];else for(var n,a=t.dimensions.slice();a.length&&(e=a.pop(),"ordinal"===(n=t.getDimensionInfo(e).type)||"time"===n););return e}},bm=Ug.createSymbol,wm=Pu.parsePercent,Sm=_m.findLabelValueDim,Mm=ni.prototype;Mm._createSymbol=function(t,e,i,n){this.removeAll();var a=e.getItemVisual(i,"color"),o=bm(t,-1,-1,2,2,a);o.attr({z2:100,culling:!0,scale:ii(n)}),o.drift=function(t,e){this.parent.drift(t,e)},this._symbolType=t,this.add(o)},Mm.stopSymbolAnimation=function(t){this.childAt(0).stopAnimation(t)},Mm.getSymbolPath=function(){return this.childAt(0)},Mm.getScale=function(){return this.childAt(0).scale},Mm.highlight=function(){this.childAt(0).trigger("emphasis")},Mm.downplay=function(){this.childAt(0).trigger("normal")},Mm.setZ=function(t,e){var i=this.childAt(0);i.zlevel=t,i.z=e},Mm.setDraggable=function(t){var e=this.childAt(0);e.draggable=t,e.cursor=t?"move":"pointer"},Mm.updateData=function(t,e,i){this.silent=!1;var n=t.getItemVisual(e,"symbol")||"circle",a=t.hostModel,o=function(t,e){var i=t.getItemVisual(e,"symbolSize");return i instanceof Array?i.slice():[+i,+i]}(t,e),r=n!==this._symbolType;if(r)this._createSymbol(n,t,e,o);else{(s=this.childAt(0)).silent=!1,fp.updateProps(s,{scale:ii(o)},a,e)}if(this._updateCommon(t,e,o,i),r){var s=this.childAt(0),l=i&&i.fadeIn,h={scale:s.scale.slice()};l&&(h.style={opacity:s.style.opacity}),s.scale=[0,0],l&&(s.style.opacity=0),fp.initProps(s,h,a,e)}this._seriesModel=a};var Im=["itemStyle","normal"],Tm=["itemStyle","emphasis"],Am=["label","normal"],Cm=["label","emphasis"];Mm._updateCommon=function(t,e,i,n){var a=this.childAt(0),o=t.hostModel,r=t.getItemVisual(e,"color");"image"!==a.type&&a.useStyle({strokeNoScale:!0});var s=n&&n.itemStyle,l=n&&n.hoverItemStyle,h=n&&n.symbolRotate,u=n&&n.symbolOffset,c=n&&n.labelModel,d=n&&n.hoverLabelModel,p=n&&n.hoverAnimation,f=n&&n.cursorStyle;if(!n||t.hasItemOption){var g=n&&n.itemModel?n.itemModel:t.getItemModel(e);s=g.getModel(Im).getItemStyle(["color"]),l=g.getModel(Tm).getItemStyle(),h=g.getShallow("symbolRotate"),u=g.getShallow("symbolOffset"),c=g.getModel(Am),d=g.getModel(Cm),p=g.getShallow("hoverAnimation"),f=g.getShallow("cursor")}else l=rl.extend({},l);var m=a.style;a.attr("rotation",(h||0)*Math.PI/180||0),u&&a.attr("position",[wm(u[0],i[0]),wm(u[1],i[1])]),f&&a.attr("cursor",f),a.setColor(r,n&&n.symbolInnerColor),a.setStyle(s);var v=t.getItemVisual(e,"opacity");null!=v&&(m.opacity=v);var y=n&&n.useNameLabel,x=!y&&Sm(t);(y||null!=x)&&fp.setLabelStyle(m,l,c,d,{labelFetcher:o,labelDataIndex:e,defaultText:y?t.getName(e):t.get(x,e),isRectText:!0,autoColor:r}),a.off("mouseover").off("mouseout").off("emphasis").off("normal"),a.hoverStyle=l,fp.setHoverStyle(a);var _=ii(i);if(p&&o.isAnimationEnabled()){var b=function(){var t=_[1]/_[0];this.animateTo({scale:[Math.max(1.1*_[0],_[0]+3),Math.max(1.1*_[1],_[1]+3*t)]},400,"elasticOut")},w=function(){this.animateTo({scale:_},400,"elasticOut")};a.on("mouseover",b).on("mouseout",w).on("emphasis",b).on("normal",w)}},Mm.fadeOut=function(t,e){var i=this.childAt(0);this.silent=i.silent=!0,!(e&&e.keepLabel)&&(i.style.text=null),fp.updateProps(i,{style:{opacity:0},scale:[0,0]},this._seriesModel,this.dataIndex,t)},rl.inherits(ni,fp.Group);var Lm=ni,Dm=ai.prototype;Dm.updateData=function(t,e){var i=this.group,n=t.hostModel,a=this._data,o=this._symbolCtor,r={itemStyle:n.getModel("itemStyle.normal").getItemStyle(["color"]),hoverItemStyle:n.getModel("itemStyle.emphasis").getItemStyle(),symbolRotate:n.get("symbolRotate"),symbolOffset:n.get("symbolOffset"),hoverAnimation:n.get("hoverAnimation"),labelModel:n.getModel("label.normal"),hoverLabelModel:n.getModel("label.emphasis"),cursorStyle:n.get("cursor")};t.diff(a).add(function(n){var a=t.getItemLayout(n);if(oi(t,n,e)){var s=new o(t,n,r);s.attr("position",a),t.setItemGraphicEl(n,s),i.add(s)}}).update(function(s,l){var h=a.getItemGraphicEl(l),u=t.getItemLayout(s);oi(t,s,e)?(h?(h.updateData(t,s,r),fp.updateProps(h,{position:u},n)):(h=new o(t,s)).attr("position",u),i.add(h),t.setItemGraphicEl(s,h)):i.remove(h)}).remove(function(t){var e=a.getItemGraphicEl(t);e&&e.fadeOut(function(){i.remove(e)})}).execute(),this._data=t},Dm.updateLayout=function(){var t=this._data;t&&t.eachItemGraphicEl(function(e,i){var n=t.getItemLayout(i);e.attr("position",n)})},Dm.remove=function(t){var e=this.group,i=this._data;i&&(t?i.eachItemGraphicEl(function(t){t.fadeOut(function(){e.remove(t)})}):e.removeAll())};var Pm=ai,km=function(t,e,i,n,a,o){for(var r=function(t,e){var i=[];return e.diff(t).add(function(t){i.push({cmd:"+",idx:t})}).update(function(t,e){i.push({cmd:"=",idx:e,idx1:t})}).remove(function(t){i.push({cmd:"-",idx:t})}).execute(),i}(t,e),s=[],l=[],h=[],u=[],c=[],d=[],p=[],f=o.dimensions,g=0;g<r.length;g++){var m=r[g],v=!0;switch(m.cmd){case"=":var y=t.getItemLayout(m.idx),x=e.getItemLayout(m.idx1);(isNaN(y[0])||isNaN(y[1]))&&(y=x.slice()),s.push(y),l.push(x),h.push(i[m.idx]),u.push(n[m.idx1]),p.push(e.getRawIndex(m.idx1));break;case"+":_=m.idx,s.push(a.dataToPoint([e.get(f[0],_,!0),e.get(f[1],_,!0)])),l.push(e.getItemLayout(_).slice()),h.push(si(a,e,_)),u.push(n[_]),p.push(e.getRawIndex(_));break;case"-":var _=m.idx,b=t.getRawIndex(_);b!==_?(s.push(t.getItemLayout(_)),l.push(o.dataToPoint([t.get(f[0],_,!0),t.get(f[1],_,!0)])),h.push(i[_]),u.push(si(o,t,_)),p.push(b)):v=!1}v&&(c.push(m),d.push(d.length))}d.sort(function(t,e){return p[t]-p[e]});for(var w=[],S=[],M=[],I=[],T=[],g=0;g<d.length;g++)_=d[g],w[g]=s[_],S[g]=l[_],M[g]=h[_],I[g]=u[_],T[g]=c[_];return{current:w,next:S,stackedOnCurrent:M,stackedOnNext:I,status:T}},Om=ll.min,zm=ll.max,Em=ll.scaleAndAdd,Rm=ll.copy,Nm=[],Vm=[],Bm=[],Gm={Polyline:Yc.extend({type:"ec-polyline",shape:{points:[],smooth:0,smoothConstraint:!0,smoothMonotone:null,connectNulls:!1},style:{fill:null,stroke:"#000"},brush:gd(Yc.prototype.brush),buildPath:function(t,e){var i=e.points,n=0,a=i.length,o=ui(i,e.smoothConstraint);if(e.connectNulls){for(;a>0&&li(i[a-1]);a--);for(;n<a&&li(i[n]);n++);}for(;n<a;)n+=hi(t,i,n,a,a,1,o.min,o.max,e.smooth,e.smoothMonotone,e.connectNulls)+1}}),Polygon:Yc.extend({type:"ec-polygon",shape:{points:[],stackedOnPoints:[],smooth:0,stackedOnSmooth:0,smoothConstraint:!0,smoothMonotone:null,connectNulls:!1},brush:gd(Yc.prototype.brush),buildPath:function(t,e){var i=e.points,n=e.stackedOnPoints,a=0,o=i.length,r=e.smoothMonotone,s=ui(i,e.smoothConstraint),l=ui(n,e.smoothConstraint);if(e.connectNulls){for(;o>0&&li(i[o-1]);o--);for(;a<o&&li(i[a]);a++);}for(;a<o;){var h=hi(t,i,a,o,o,1,s.min,s.max,e.smooth,r,e.connectNulls);hi(t,n,a+h-1,h,o,-1,l.min,l.max,e.stackedOnSmooth,r,e.connectNulls),a+=h+1,t.closePath()}}})},Hm=Gm.Polyline,Wm=Gm.Polygon,Fm=(Bf.extend({type:"line",init:function(){var t=new fp.Group,e=new Pm;this.group.add(e.group),this._symbolDraw=e,this._lineGroup=t},render:function(t,e,i){var n=t.coordinateSystem,a=this.group,o=t.getData(),r=t.getModel("lineStyle.normal"),s=t.getModel("areaStyle.normal"),l=o.mapArray(o.getItemLayout,!0),h="polar"===n.type,u=this._coordSys,c=this._symbolDraw,d=this._polyline,p=this._polygon,f=this._lineGroup,g=t.get("animation"),m=!s.isEmpty(),v=function(t,e){var i=t.getBaseAxis(),n=t.getOtherAxis(i),a=0;if(!i.onZero){var o=n.scale.getExtent();o[0]>0?a=o[0]:o[1]<0&&(a=o[1])}var r=n.dim,s="x"===r||"radius"===r?1:0;return e.mapArray([r],function(n,o){for(var l,h=e.stackedOn;h&&fi(h.get(r,o))===fi(n);){l=h;break}var u=[];return u[s]=e.get(i.dim,o),u[1-s]=l?l.get(r,o,!0):a,t.dataToPoint(u)},!0)}(n,o),y=t.get("showSymbol"),x=y&&!h&&!t.get("showAllSymbol")&&this._getSymbolIgnoreFunc(o,n),_=this._data;_&&_.eachItemGraphicEl(function(t,e){t.__temp&&(a.remove(t),_.setItemGraphicEl(e,null))}),y||c.remove(),a.add(f);var b=!h&&t.get("step");d&&u.type===n.type&&b===this._step?(m&&!p?p=this._newPolygon(l,v,n,g):p&&!m&&(f.remove(p),p=this._polygon=null),f.setClipPath(gi(n,!1,t)),y&&c.updateData(o,x),o.eachItemGraphicEl(function(t){t.stopAnimation(!0)}),ci(this._stackedOnPoints,v)&&ci(this._points,l)||(g?this._updateAnimation(o,v,n,i,b):(b&&(l=mi(l,n,b),v=mi(v,n,b)),d.setShape({points:l}),p&&p.setShape({points:l,stackedOnPoints:v})))):(y&&c.updateData(o,x),b&&(l=mi(l,n,b),v=mi(v,n,b)),d=this._newPolyline(l,n,g),m&&(p=this._newPolygon(l,v,n,g)),f.setClipPath(gi(n,!0,t)));var w=function(t,e){var i=t.getVisual("visualMeta");if(i&&i.length&&t.count()){for(var n,a=i.length-1;a>=0;a--)if(i[a].dimension<2){n=i[a];break}if(n&&"cartesian2d"===e.type){var o=n.dimension,r=t.dimensions[o],s=e.getAxis(r),l=rl.map(n.stops,function(t){return{coord:s.toGlobalCoord(s.dataToCoord(t.value)),color:t.color}}),h=l.length,u=n.outerColors.slice();h&&l[0].coord>l[h-1].coord&&(l.reverse(),u.reverse());var c=l[0].coord-10,d=l[h-1].coord+10,p=d-c;if(p<.001)return"transparent";rl.each(l,function(t){t.offset=(t.coord-c)/p}),l.push({offset:h?l[h-1].offset:.5,color:u[1]||"transparent"}),l.unshift({offset:h?l[0].offset:.5,color:u[0]||"transparent"});var f=new fp.LinearGradient(0,0,0,0,l,!0);return f[r]=c,f[r+"2"]=d,f}}}(o,n)||o.getVisual("color");d.useStyle(rl.defaults(r.getLineStyle(),{fill:"none",stroke:w,lineJoin:"bevel"}));var S=t.get("smooth");if(S=di(t.get("smooth")),d.setShape({smooth:S,smoothMonotone:t.get("smoothMonotone"),connectNulls:t.get("connectNulls")}),p){var M=o.stackedOn,I=0;if(p.useStyle(rl.defaults(s.getAreaStyle(),{fill:w,opacity:.7,lineJoin:"bevel"})),M){I=di(M.hostModel.get("smooth"))}p.setShape({smooth:S,stackedOnSmooth:I,smoothMonotone:t.get("smoothMonotone"),connectNulls:t.get("connectNulls")})}this._data=o,this._coordSys=n,this._stackedOnPoints=v,this._points=l,this._step=b},dispose:function(){},highlight:function(t,e,i,n){var a=t.getData(),o=Ip.queryDataIndex(a,n);if(!(o instanceof Array)&&null!=o&&o>=0){var r=a.getItemGraphicEl(o);if(!r){var s=a.getItemLayout(o);if(!s)return;(r=new Lm(a,o)).position=s,r.setZ(t.get("zlevel"),t.get("z")),r.ignore=isNaN(s[0])||isNaN(s[1]),r.__temp=!0,a.setItemGraphicEl(o,r),r.stopSymbolAnimation(!0),this.group.add(r)}r.highlight()}else Bf.prototype.highlight.call(this,t,e,i,n)},downplay:function(t,e,i,n){var a=t.getData(),o=Ip.queryDataIndex(a,n);if(null!=o&&o>=0){var r=a.getItemGraphicEl(o);r&&(r.__temp?(a.setItemGraphicEl(o,null),this.group.remove(r)):r.downplay())}else Bf.prototype.downplay.call(this,t,e,i,n)},_newPolyline:function(t){var e=this._polyline;return e&&this._lineGroup.remove(e),e=new Hm({shape:{points:t},silent:!0,z2:10}),this._lineGroup.add(e),this._polyline=e,e},_newPolygon:function(t,e){var i=this._polygon;return i&&this._lineGroup.remove(i),i=new Wm({shape:{points:t,stackedOnPoints:e},silent:!0}),this._lineGroup.add(i),this._polygon=i,i},_getSymbolIgnoreFunc:function(t,e){var i=e.getAxesByScale("ordinal")[0];if(i&&i.isLabelIgnored)return rl.bind(i.isLabelIgnored,i)},_updateAnimation:function(t,e,i,n,a){var o=this._polyline,r=this._polygon,s=t.hostModel,l=km(this._data,t,this._stackedOnPoints,e,this._coordSys,i),h=l.current,u=l.stackedOnCurrent,c=l.next,d=l.stackedOnNext;a&&(h=mi(l.current,i,a),u=mi(l.stackedOnCurrent,i,a),c=mi(l.next,i,a),d=mi(l.stackedOnNext,i,a)),o.shape.__points=l.current,o.shape.points=h,fp.updateProps(o,{shape:{points:c}},s),r&&(r.setShape({points:h,stackedOnPoints:u}),fp.updateProps(r,{shape:{points:c,stackedOnPoints:d}},s));for(var p=[],f=l.status,g=0;g<f.length;g++){if("="===f[g].cmd){var m=t.getItemGraphicEl(f[g].idx1);m&&p.push({el:m,ptIdx:g})}}o.animators&&o.animators.length&&o.animators[0].during(function(){for(var t=0;t<p.length;t++){p[t].el.attr("position",o.shape.__points[p[t].ptIdx])}})},remove:function(t){var e=this.group,i=this._data;this._lineGroup.removeAll(),this._symbolDraw.remove(!0),i&&i.eachItemGraphicEl(function(t,n){t.__temp&&(e.remove(t),i.setItemGraphicEl(n,null))}),this._polyline=this._polygon=this._coordSys=this._points=this._stackedOnPoints=this._data=null}}),function(t,e,i,n,a){n.eachRawSeriesByType(t,function(t){var a=t.getData(),o=t.get("symbol")||e,r=t.get("symbolSize");a.setVisual({legendSymbol:i||o,symbol:o,symbolSize:r}),n.isSeriesFiltered(t)||("function"==typeof r&&a.each(function(e){var i=t.getRawValue(e),n=t.getDataParams(e);a.setItemVisual(e,"symbolSize",r(i,n))}),a.each(function(t){var e=a.getItemModel(t),i=e.getShallow("symbol",!0),n=e.getShallow("symbolSize",!0);null!=i&&a.setItemVisual(t,"symbol",i),null!=n&&a.setItemVisual(t,"symbolSize",n)}))})}),Zm=function(t,e){e.eachSeriesByType(t,function(t){var e=t.getData(),i=t.coordinateSystem;if(i){for(var n=[],a=i.dimensions,o=0;o<a.length;o++)n.push(t.coordDimToDataDim(i.dimensions[o])[0]);1===n.length?e.each(n[0],function(t,n){e.setItemLayout(n,isNaN(t)?[NaN,NaN]:i.dataToPoint(t))}):2===n.length&&e.each(n,function(t,n,a){e.setItemLayout(a,isNaN(t)||isNaN(n)?[NaN,NaN]:i.dataToPoint([t,n]))},!0)}})},jm={average:function(t){for(var e=0,i=0,n=0;n<t.length;n++)isNaN(t[n])||(e+=t[n],i++);return 0===i?NaN:e/i},sum:function(t){for(var e=0,i=0;i<t.length;i++)e+=t[i]||0;return e},max:function(t){for(var e=-1/0,i=0;i<t.length;i++)t[i]>e&&(e=t[i]);return e},min:function(t){for(var e=1/0,i=0;i<t.length;i++)t[i]<e&&(e=t[i]);return e},nearest:function(t){return t[0]}},Um=function(t,e){return Math.round(t.length/2)},qm=function(t,e,i){e.eachSeriesByType(t,function(t){var e=t.getData(),i=t.get("sampling"),n=t.coordinateSystem;if("cartesian2d"===n.type&&i){var a=n.getBaseAxis(),o=n.getOtherAxis(a),r=a.getExtent(),s=r[1]-r[0],l=Math.round(e.count()/s);if(l>1){var h;"string"==typeof i?h=jm[i]:"function"==typeof i&&(h=i),h&&(e=e.downSample(o.dim,1/l,h,Um),t.setData(e))}}},this)},Xm=function(t){this._axes={},this._dimList=[],this.name=t||""};Xm.prototype={constructor:Xm,type:"cartesian",getAxis:function(t){return this._axes[t]},getAxes:function(){return rl.map(this._dimList,function(t){return this._axes[t]},this)},getAxesByScale:function(t){return t=t.toLowerCase(),rl.filter(this.getAxes(),function(e){return e.scale.type===t})},addAxis:function(t){var e=t.dim;this._axes[e]=t,this._dimList.push(e)},dataToCoord:function(t){return this._dataCoordConvert(t,"dataToCoord")},coordToData:function(t){return this._dataCoordConvert(t,"coordToData")},_dataCoordConvert:function(t,e){for(var i=this._dimList,n=t instanceof Array?[]:{},a=0;a<i.length;a++){var o=i[a],r=this._axes[o];n[o]=r[e](t[o])}return n}};var Ym=Xm;vi.prototype={constructor:vi,type:"cartesian2d",dimensions:["x","y"],getBaseAxis:function(){return this.getAxesByScale("ordinal")[0]||this.getAxesByScale("time")[0]||this.getAxis("x")},containPoint:function(t){var e=this.getAxis("x"),i=this.getAxis("y");return e.contain(e.toLocalCoord(t[0]))&&i.contain(i.toLocalCoord(t[1]))},containData:function(t){return this.getAxis("x").containData(t[0])&&this.getAxis("y").containData(t[1])},dataToPoint:function(t,e){var i=this.getAxis("x"),n=this.getAxis("y");return[i.toGlobalCoord(i.dataToCoord(t[0],e)),n.toGlobalCoord(n.dataToCoord(t[1],e))]},pointToData:function(t,e){var i=this.getAxis("x"),n=this.getAxis("y");return[i.coordToData(i.toLocalCoord(t[0]),e),n.coordToData(n.toLocalCoord(t[1]),e)]},getOtherAxis:function(t){return this.getAxis("x"===t.dim?"y":"x")}},rl.inherits(vi,Ym);var $m=vi,Km=function(t,e,i,n,a){Kg.call(this,t,e,i),this.type=n||"value",this.position=a||"bottom"};Km.prototype={constructor:Km,index:0,onZero:!1,model:null,isHorizontal:function(){var t=this.position;return"top"===t||"bottom"===t},getGlobalExtent:function(t){var e=this.getExtent();return e[0]=this.toGlobalCoord(e[0]),e[1]=this.toGlobalCoord(e[1]),t&&e[0]>e[1]&&e.reverse(),e},getOtherAxis:function(){this.grid.getOtherAxis()},isLabelIgnored:function(t){if("category"===this.type){var e=this.getLabelInterval();return"function"==typeof e&&!e(t,this.scale.getLabel(t))||t%(e+1)}},pointToData:function(t,e){return this.coordToData(this.toLocalCoord(t["x"===this.dim?0:1]),e)},toLocalCoord:null,toGlobalCoord:null},rl.inherits(Km,Kg);var Jm=Km,Qm={show:!0,zlevel:0,z:0,inverse:!1,name:"",nameLocation:"end",nameRotate:null,nameTruncate:{maxWidth:null,ellipsis:"...",placeholder:"."},nameTextStyle:{},nameGap:15,silent:!1,triggerEvent:!1,tooltip:{show:!1},axisPointer:{},axisLine:{show:!0,onZero:!0,onZeroAxisIndex:null,lineStyle:{color:"#333",width:1,type:"solid"},symbol:["none","none"],symbolSize:[10,15]},axisTick:{show:!0,inside:!1,length:5,lineStyle:{width:1}},axisLabel:{show:!0,inside:!1,rotate:0,showMinLabel:null,showMaxLabel:null,margin:8,fontSize:12},splitLine:{show:!0,lineStyle:{color:["#ccc"],width:1,type:"solid"}},splitArea:{show:!1,areaStyle:{color:["rgba(250,250,250,0.3)","rgba(200,200,200,0.3)"]}}},tv={};tv.categoryAxis=rl.merge({boundaryGap:!0,splitLine:{show:!1},axisTick:{alignWithLabel:!1,interval:"auto"},axisLabel:{interval:"auto"}},Qm),tv.valueAxis=rl.merge({boundaryGap:[0,0],splitNumber:5},Qm),tv.timeAxis=rl.defaults({scale:!0,min:"dataMin",max:"dataMax"},tv.valueAxis),tv.logAxis=rl.defaults({scale:!0,logBase:10},tv.valueAxis);var ev=tv,iv=Np.getLayoutParams,nv=Np.mergeLayoutParam,av=["value","category","time","log"],ov=function(t,e,i,n){rl.each(av,function(a){e.extend({type:t+"Axis."+a,mergeDefaultAndTheme:function(e,n){var o=this.layoutMode,r=o?iv(e):{},s=n.getTheme();rl.merge(e,s.get(a+"Axis")),rl.merge(e,this.getDefaultOption()),e.type=i(t,e),o&&nv(e,r,o)},defaultOption:rl.mergeAll([{},ev[a+"Axis"],n],!0)})}),Hp.registerSubTypeDefaulter(t+"Axis",rl.curry(i,t))},rv=Hp.extend({type:"cartesian2dAxis",axis:null,init:function(){rv.superApply(this,"init",arguments),this.resetRange()},mergeOption:function(){rv.superApply(this,"mergeOption",arguments),this.resetRange()},restoreData:function(){rv.superApply(this,"restoreData",arguments),this.resetRange()},getCoordSysModel:function(){return this.ecModel.queryComponents({mainType:"grid",index:this.option.gridIndex,id:this.option.gridId})[0]}});rl.merge(rv.prototype,Ng);var sv={offset:0};ov("x",rv,yi,sv),ov("y",rv,yi,sv);Hp.extend({type:"grid",dependencies:["xAxis","yAxis"],layoutMode:"box",coordinateSystem:null,defaultOption:{show:!1,zlevel:0,z:0,left:"10%",top:60,right:"10%",bottom:60,containLabel:!1,backgroundColor:"rgba(0,0,0,0)",borderWidth:1,borderColor:"#ccc"}});var lv=Np.getLayoutRect,hv=rl.each,uv=Rg.ifAxisCrossZero,cv=Rg.niceScaleExtent,dv=_i.prototype;dv.type="grid",dv.axisPointerEnabled=!0,dv.getRect=function(){return this._rect},dv.update=function(t,e){var i=this._axesMap;this._updateScale(t,this.model),hv(i.x,function(t){cv(t.scale,t.model)}),hv(i.y,function(t){cv(t.scale,t.model)}),hv(i.x,function(t){bi(i,"y",t)}),hv(i.y,function(t){bi(i,"x",t)}),this.resize(this.model,e)},dv.resize=function(t,e,i){function n(){hv(o,function(t){var e=t.isHorizontal(),i=e?[0,a.width]:[0,a.height],n=t.inverse?1:0;t.setExtent(i[n],i[1-n]),function(t,e){var i=t.getExtent(),n=i[0]+i[1];t.toGlobalCoord="x"===t.dim?function(t){return t+e}:function(t){return n-t+e},t.toLocalCoord="x"===t.dim?function(t){return t-e}:function(t){return n-t+e}}(t,e?a.x:a.y)})}var a=lv(t.getBoxLayoutParams(),{width:e.getWidth(),height:e.getHeight()});this._rect=a;var o=this._axesList;n(),!i&&t.get("containLabel")&&(hv(o,function(t){if(!t.model.get("axisLabel.inside")){var e=function(t){var e,i=t.model,n=i.getFormattedLabels(),a=i.getModel("axisLabel"),o=1,r=n.length;r>40&&(o=Math.ceil(r/40));for(var s=0;s<r;s+=o)if(!t.isLabelIgnored(s)){var l=function(t,e){var i=(a.get("rotate")||0)*Math.PI/180,n=t.plain(),o=n.width,r=n.height,s=o*Math.cos(i)+r*Math.sin(i),l=o*Math.sin(i)+r*Math.cos(i);return new oh(n.x,n.y,s,l)}(a.getTextRect(n[s]));e?e.union(l):e=l}return e}(t);if(e){var i=t.isHorizontal()?"height":"width",n=t.model.get("axisLabel.margin");a[i]-=e[i]+n,"top"===t.position?a.y+=e.height+n:"left"===t.position&&(a.x+=e.width+n)}}}),n())},dv.getAxis=function(t,e){var i=this._axesMap[t];if(null!=i){if(null==e)for(var n in i)if(i.hasOwnProperty(n))return i[n];return i[e]}},dv.getAxes=function(){return this._axesList.slice()},dv.getCartesian=function(t,e){if(null!=t&&null!=e){var i="x"+t+"y"+e;return this._coordsMap[i]}rl.isObject(t)&&(e=t.yAxisIndex,t=t.xAxisIndex);for(var n=0,a=this._coordsList;n<a.length;n++)if(a[n].getAxis("x").index===t||a[n].getAxis("y").index===e)return a[n]},dv.getCartesians=function(){return this._coordsList.slice()},dv.convertToPixel=function(t,e,i){var n=this._findConvertTarget(t,e);return n.cartesian?n.cartesian.dataToPoint(i):n.axis?n.axis.toGlobalCoord(n.axis.dataToCoord(i)):null},dv.convertFromPixel=function(t,e,i){var n=this._findConvertTarget(t,e);return n.cartesian?n.cartesian.pointToData(i):n.axis?n.axis.coordToData(n.axis.toLocalCoord(i)):null},dv._findConvertTarget=function(t,e){var i,n,a=e.seriesModel,o=e.xAxisModel||a&&a.getReferringComponents("xAxis")[0],r=e.yAxisModel||a&&a.getReferringComponents("yAxis")[0],s=e.gridModel,l=this._coordsList;if(a)i=a.coordinateSystem,rl.indexOf(l,i)<0&&(i=null);else if(o&&r)i=this.getCartesian(o.componentIndex,r.componentIndex);else if(o)n=this.getAxis("x",o.componentIndex);else if(r)n=this.getAxis("y",r.componentIndex);else if(s){s.coordinateSystem===this&&(i=this._coordsList[0])}return{cartesian:i,axis:n}},dv.containPoint=function(t){var e=this._coordsList[0];if(e)return e.containPoint(t)},dv._initCartesian=function(t,e,i){function n(e){return function(i,n){if(xi(i,t)){var s=i.get("position");"x"===e?"top"!==s&&"bottom"!==s&&a[s="bottom"]&&(s="top"===s?"bottom":"top"):"left"!==s&&"right"!==s&&a[s="left"]&&(s="left"===s?"right":"left"),a[s]=!0;var l=new Jm(e,Rg.createScaleByModel(i),[0,0],i.get("type"),s),h="category"===l.type;l.onBand=h&&i.get("boundaryGap"),l.inverse=i.get("inverse"),l.onZero=i.get("axisLine.onZero"),l.onZeroAxisIndex=i.get("axisLine.onZeroAxisIndex"),i.axis=l,l.model=i,l.grid=this,l.index=n,this._axesList.push(l),o[e][n]=l,r[e]++}}}var a={left:!1,right:!1,top:!1,bottom:!1},o={x:{},y:{}},r={x:0,y:0};if(e.eachComponent("xAxis",n("x"),this),e.eachComponent("yAxis",n("y"),this),!r.x||!r.y)return this._axesMap={},void(this._axesList=[]);this._axesMap=o,hv(o.x,function(e,i){hv(o.y,function(n,a){var o="x"+i+"y"+a,r=new $m(o);r.grid=this,r.model=t,this._coordsMap[o]=r,this._coordsList.push(r),r.addAxis(e),r.addAxis(n)},this)},this)},dv._updateScale=function(t,e){function i(t,e,i){hv(i.coordDimToDataDim(e.dim),function(i){e.scale.unionExtentFromData(t,i)})}rl.each(this._axesList,function(t){t.scale.setExtent(1/0,-1/0)}),t.eachSeries(function(t){if(Mi(t)){var n=Si(t),a=n[0],o=n[1];if(!xi(a,e)||!xi(o,e))return;var r=this.getCartesian(a.componentIndex,o.componentIndex),s=t.getData(),l=r.getAxis("x"),h=r.getAxis("y");"list"===s.type&&(i(s,l,t),i(s,h,t))}},this)},dv.getTooltipAxes=function(t){var e=[],i=[];return hv(this.getCartesians(),function(n){var a=null!=t&&"auto"!==t?n.getAxis(t):n.getBaseAxis(),o=n.getOtherAxis(a);rl.indexOf(e,a)<0&&e.push(a),rl.indexOf(i,o)<0&&i.push(o)}),{baseAxes:e,otherAxes:i}};var pv=["xAxis","yAxis"];_i.create=function(t,e){var i=[];return t.eachComponent("grid",function(n,a){var o=new _i(n,t,e);o.name="grid_"+a,o.resize(n,e,!0),n.coordinateSystem=o,i.push(o)}),t.eachSeries(function(t){if(Mi(t)){var e=Si(t),i=e[0],n=e[1],a=i.getCoordSysModel().coordinateSystem;t.coordinateSystem=a.getCartesian(i.componentIndex,n.componentIndex)}}),i},_i.dimensions=_i.prototype.dimensions=$m.prototype.dimensions,rf.register("cartesian2d",_i);var fv=rl.retrieve,gv=rl.defaults,mv=rl.extend,vv=rl.each,yv=Pu.isRadianAroundZero,xv=Pu.remRadian,_v=Ug.createSymbol,bv=ll.applyTransform,wv=Math.PI,Sv=function(t,e){this.opt=e,this.axisModel=t,gv(e,{labelOffset:0,nameDirection:1,tickDirection:1,labelDirection:1,silent:!0}),this.group=new fp.Group;var i=new fp.Group({position:e.position.slice(),rotation:e.rotation});i.updateTransform(),this._transform=i.transform,this._dumbGroup=i};Sv.prototype={constructor:Sv,hasBuilder:function(t){return!!Mv[t]},add:function(t){Mv[t].call(this)},getGroup:function(){return this.group}};var Mv={axisLine:function(){var t=this.opt,e=this.axisModel;if(e.get("axisLine.show")){var i=this.axisModel.axis.getExtent(),n=this._transform,a=[i[0],0],o=[i[1],0];n&&(bv(a,a,n),bv(o,o,n));var r=mv({lineCap:"round"},e.getModel("axisLine.lineStyle").getLineStyle());this.group.add(new fp.Line(fp.subPixelOptimizeLine({anid:"line",shape:{x1:a[0],y1:a[1],x2:o[0],y2:o[1]},style:r,strokeContainThreshold:t.strokeContainThreshold||5,silent:!0,z2:1})));var s=e.get("axisLine.symbol"),l=e.get("axisLine.symbolSize");if(null!=s){"string"==typeof s&&(s=[s,s]),"string"!=typeof l&&"number"!=typeof l||(l=[l,l]);var h=l[0],u=l[1];vv([[t.rotation+Math.PI/2,a],[t.rotation-Math.PI/2,o]],function(t,e){if("none"!==s[e]&&null!=s[e]){var i=_v(s[e],-h/2,-u/2,h,u,r.stroke,!0);i.attr({rotation:t[0],position:t[1],silent:!0}),this.group.add(i)}},this)}}},axisTickLabel:function(){var t=this.axisModel,e=this.opt,i=function(t,e,i){var n=e.axis;if(e.get("axisTick.show")&&!n.scale.isBlank()){for(var a=e.getModel("axisTick"),o=a.getModel("lineStyle"),r=a.get("length"),s=Av(a,i.labelInterval),l=n.getTicksCoords(a.get("alignWithLabel")),h=n.scale.getTicks(),u=e.get("axisLabel.showMinLabel"),c=e.get("axisLabel.showMaxLabel"),d=[],p=[],f=t._transform,g=[],m=l.length,v=0;v<m;v++)if(!Tv(n,v,s,m,u,c)){var y=l[v];d[0]=y,d[1]=0,p[0]=y,p[1]=i.tickDirection*r,f&&(bv(d,d,f),bv(p,p,f));var x=new fp.Line(fp.subPixelOptimizeLine({anid:"tick_"+h[v],shape:{x1:d[0],y1:d[1],x2:p[0],y2:p[1]},style:gv(o.getLineStyle(),{stroke:e.get("axisLine.lineStyle.color")}),z2:2,silent:!0}));t.group.add(x),g.push(x)}return g}}(this,t,e);!function(t,e,i){var n=t.get("axisLabel.showMinLabel"),a=t.get("axisLabel.showMaxLabel");e=e||[],i=i||[];var o=e[0],r=e[1],s=e[e.length-1],l=e[e.length-2],h=i[0],u=i[1],c=i[i.length-1],d=i[i.length-2];!1===n?(Ai(o),Ai(h)):Ci(o,r)&&(n?(Ai(r),Ai(u)):(Ai(o),Ai(h))),!1===a?(Ai(s),Ai(c)):Ci(l,s)&&(a?(Ai(l),Ai(d)):(Ai(s),Ai(c)))}(t,function(t,e,i){var n=e.axis;if(fv(i.axisLabelShow,e.get("axisLabel.show"))&&!n.scale.isBlank()){var a=e.getModel("axisLabel"),o=a.get("margin"),r=n.scale.getTicks(),s=e.getFormattedLabels(),l=(fv(i.labelRotate,a.get("rotate"))||0)*wv/180,h=Iv(i.rotation,l,i.labelDirection),u=e.get("data"),c=[],d=Ti(e),p=e.get("triggerEvent"),f=e.get("axisLabel.showMinLabel"),g=e.get("axisLabel.showMaxLabel");return vv(r,function(l,m){if(!Tv(n,m,i.labelInterval,r.length,f,g)){var v=a;u&&u[l]&&u[l].textStyle&&(v=new _p(u[l].textStyle,a,e.ecModel));var y=v.getTextColor()||e.get("axisLine.lineStyle.color"),x=[n.dataToCoord(l),i.labelOffset+i.labelDirection*o],_=n.scale.getLabel(l),b=new fp.Text({anid:"label_"+l,position:x,rotation:h.rotation,silent:d,z2:10});fp.setTextStyle(b.style,v,{text:s[m],textAlign:v.getShallow("align",!0)||h.textAlign,textVerticalAlign:v.getShallow("verticalAlign",!0)||v.getShallow("baseline",!0)||h.textVerticalAlign,textFill:"function"==typeof y?y("category"===n.type?_:"value"===n.type?l+"":l,m):y}),p&&(b.eventData=Ii(e),b.eventData.targetType="axisLabel",b.eventData.value=_),t._dumbGroup.add(b),b.updateTransform(),c.push(b),t.group.add(b),b.decomposeTransform()}}),c}}(this,t,e),i)},axisName:function(){var t=this.opt,e=this.axisModel,i=fv(t.axisName,e.get("name"));if(i){var n,a=e.get("nameLocation"),o=t.nameDirection,r=e.getModel("nameTextStyle"),s=e.get("nameGap")||0,l=this.axisModel.axis.getExtent(),h=l[0]>l[1]?-1:1,u=["start"===a?l[0]-h*s:"end"===a?l[1]+h*s:(l[0]+l[1])/2,Li(a)?t.labelOffset+o*s:0],c=e.get("nameRotate");null!=c&&(c=c*wv/180);var d;Li(a)?n=Iv(t.rotation,null!=c?c:t.rotation,o):(n=function(t,e,i,n){var a,o,r=xv(i-t.rotation),s=n[0]>n[1],l="start"===e&&!s||"start"!==e&&s;return yv(r-wv/2)?(o=l?"bottom":"top",a="center"):yv(r-1.5*wv)?(o=l?"top":"bottom",a="center"):(o="middle",a=r<1.5*wv&&r>wv/2?l?"left":"right":l?"right":"left"),{rotation:r,textAlign:a,textVerticalAlign:o}}(t,a,c||0,l),null!=(d=t.axisNameAvailableWidth)&&(d=Math.abs(d/Math.sin(n.rotation)),!isFinite(d)&&(d=null)));var p=r.getFont(),f=e.get("nameTruncate",!0)||{},g=f.ellipsis,m=fv(t.nameTruncateMaxWidth,f.maxWidth,d),v=null!=g&&null!=m?Eu.truncateText(i,m,p,g,{minChar:2,placeholder:f.placeholder}):i,y=e.get("tooltip",!0),x=e.mainType,_={componentType:x,name:i,$vars:["name"]};_[x+"Index"]=e.componentIndex;var b=new fp.Text({anid:"name",__fullText:i,__truncatedText:v,position:u,rotation:n.rotation,silent:Ti(e),z2:1,tooltip:y&&y.show?mv({content:i,formatter:function(){return i},formatterParams:_},y):null});fp.setTextStyle(b.style,r,{text:v,textFont:p,textFill:r.getTextColor()||e.get("axisLine.lineStyle.color"),textAlign:n.textAlign,textVerticalAlign:n.textVerticalAlign}),e.get("triggerEvent")&&(b.eventData=Ii(e),b.eventData.targetType="axisName",b.eventData.name=i),this._dumbGroup.add(b),b.updateTransform(),this.group.add(b),b.decomposeTransform()}}},Iv=Sv.innerTextLayout=function(t,e,i){var n,a,o=xv(e-t);return yv(o)?(a=i>0?"top":"bottom",n="center"):yv(o-wv)?(a=i>0?"bottom":"top",n="center"):(a="middle",n=o>0&&o<wv?i>0?"right":"left":i>0?"left":"right"),{rotation:o,textAlign:n,textVerticalAlign:a}},Tv=Sv.ifIgnoreOnTick=function(t,e,i,n,a,o){if(0===e&&a||e===n-1&&o)return!1;var r,s=t.scale;return"ordinal"===s.type&&("function"==typeof i?(r=s.getTicks()[e],!i(r,s.getLabel(r))):e%(i+1))},Av=Sv.getInterval=function(t,e){var i=t.get("interval");return null!=i&&"auto"!=i||(i=e),i},Cv=Sv,Lv=rl.each,Dv=rl.curry,Pv={collect:function(t,e){var i={axesInfo:{},seriesInvolved:!1,coordSysAxesInfo:{},coordSysMap:{}};return function(t,e,i){var n=e.getComponent("tooltip"),a=e.getComponent("axisPointer"),o=a.get("link",!0)||[],r=[];Lv(i.getCoordinateSystems(),function(i){function s(n,s,l){var c=l.model.getModel("axisPointer",a),d=c.get("show");if(d&&("auto"!==d||n||ki(c))){null==s&&(s=c.get("triggerTooltip"));var p=(c=n?function(t,e,i,n,a,o){var r=e.getModel("axisPointer"),s={};Lv(["type","snap","lineStyle","shadowStyle","label","animation","animationDurationUpdate","animationEasingUpdate","z"],function(t){s[t]=rl.clone(r.get(t))}),s.snap="category"!==t.type&&!!o,"cross"===r.get("type")&&(s.type="line");var l=s.label||(s.label={});if(null==l.show&&(l.show=!1),"cross"===a&&(l.show=!0,!o)){var h=s.lineStyle=r.get("crossStyle");h&&rl.defaults(l,h.textStyle)}return t.model.getModel("axisPointer",new _p(s,i,n))}(l,u,a,e,n,s):c).get("snap"),f=Oi(l.model),g=s||p||"category"===l.type,m=t.axesInfo[f]={key:f,axis:l,coordSys:i,axisPointerModel:c,triggerTooltip:s,involveSeries:g,snap:p,useHandle:ki(c),seriesModels:[]};h[f]=m,t.seriesInvolved|=g;var v=function(t,e){for(var i=e.model,n=e.dim,a=0;a<t.length;a++){var o=t[a]||{};if(Di(o[n+"AxisId"],i.id)||Di(o[n+"AxisIndex"],i.componentIndex)||Di(o[n+"AxisName"],i.name))return a}}(o,l);if(null!=v){var y=r[v]||(r[v]={axesInfo:{}});y.axesInfo[f]=m,y.mapper=o[v].mapper,m.linkGroup=y}}}if(i.axisPointerEnabled){var l=Oi(i.model),h=t.coordSysAxesInfo[l]={};t.coordSysMap[l]=i;var u=i.model.getModel("tooltip",n);if(Lv(i.getAxes(),Dv(s,!1,null)),i.getTooltipAxes&&n&&u.get("show")){var c="axis"===u.get("trigger"),d="cross"===u.get("axisPointer.type"),p=i.getTooltipAxes(u.get("axisPointer.axis"));(c||d)&&Lv(p.baseAxes,Dv(s,!d||"cross",c)),d&&Lv(p.otherAxes,Dv(s,"cross",!1))}}})}(i,t,e),i.seriesInvolved&&function(t,e){e.eachSeries(function(e){var i=e.coordinateSystem,n=e.get("tooltip.trigger",!0),a=e.get("tooltip.show",!0);i&&"none"!==n&&!1!==n&&"item"!==n&&!1!==a&&!1!==e.get("axisPointer.show",!0)&&Lv(t.coordSysAxesInfo[Oi(i.model)],function(t){var n=t.axis;i.getAxis(n.dim)===n&&(t.seriesModels.push(e),null==t.seriesDataCount&&(t.seriesDataCount=0),t.seriesDataCount+=e.getData().count())})},this)}(i,t),i},fixValue:function(t){var e=Pi(t);if(e){var i=e.axisPointerModel,n=e.axis.scale,a=i.option,o=i.get("status"),r=i.get("value");null!=r&&(r=n.parse(r));var s=ki(i);null==o&&(a.status=s?"show":"hide");var l=n.getExtent().slice();l[0]>l[1]&&l.reverse(),(null==r||r>l[1])&&(r=l[1]),r<l[0]&&(r=l[0]),a.value=r,s&&(a.status=e.axis.scale.isBlank()?"hide":"show")}},getAxisInfo:Pi,getAxisPointerModel:function(t){var e=Pi(t);return e&&e.axisPointerModel},makeKey:Oi},kv=ym.extendComponentView({type:"axis",_axisPointer:null,axisPointerClass:null,render:function(t,e,i,n){this.axisPointerClass&&Pv.fixValue(t),kv.superApply(this,"render",arguments),zi(this,t,0,i,0,!0)},updateAxisPointer:function(t,e,i,n,a){zi(this,t,0,i,0,!1)},remove:function(t,e){var i=this._axisPointer;i&&i.remove(e),kv.superApply(this,"remove",arguments)},dispose:function(t,e){Ei(this,e),kv.superApply(this,"dispose",arguments)}}),Ov=[];kv.registerAxisPointerClass=function(t,e){Ov[t]=e},kv.getAxisPointerClass=function(t){return t&&Ov[t]};var zv=kv,Ev={layout:function(t,e,i){i=i||{};var n=t.coordinateSystem,a=e.axis,o={},r=a.position,s=a.onZero?"onZero":r,l=a.dim,h=n.getRect(),u=[h.x,h.x+h.width,h.y,h.y+h.height],c={left:0,right:1,top:0,bottom:1,onZero:2},d=e.get("offset")||0,p="x"===l?[u[2]-d,u[3]+d]:[u[0]-d,u[1]+d];if(a.onZero){var f=n.getAxis("x"===l?"y":"x",a.onZeroAxisIndex),g=f.toGlobalCoord(f.dataToCoord(0));p[c.onZero]=Math.max(Math.min(g,p[1]),p[0])}o.position=["y"===l?p[c[s]]:u[0],"x"===l?p[c[s]]:u[3]],o.rotation=Math.PI/2*("x"===l?0:1),o.labelDirection=o.tickDirection=o.nameDirection={top:-1,bottom:1,left:-1,right:1}[r],o.labelOffset=a.onZero?p[c[r]]-p[c.onZero]:0,e.get("axisTick.inside")&&(o.tickDirection=-o.tickDirection),rl.retrieve(i.labelInside,e.get("axisLabel.inside"))&&(o.labelDirection=-o.labelDirection);var m=e.get("axisLabel.rotate");return o.labelRotate="top"===s?-m:m,o.labelInterval=a.getLabelInterval(),o.z2=1,o}},Rv=Cv.ifIgnoreOnTick,Nv=Cv.getInterval,Vv=["axisLine","axisTickLabel","axisName"],Bv=["splitArea","splitLine"],Gv=zv.extend({type:"cartesianAxis",axisPointerClass:"CartesianAxisPointer",render:function(t,e,i,n){this.group.removeAll();var a=this._axisGroup;if(this._axisGroup=new fp.Group,this.group.add(this._axisGroup),t.get("show")){var o=t.getCoordSysModel(),r=Ev.layout(o,t),s=new Cv(t,r);rl.each(Vv,s.add,s),this._axisGroup.add(s.getGroup()),rl.each(Bv,function(e){t.get(e+".show")&&this["_"+e](t,o,r.labelInterval)},this),fp.groupTransition(a,this._axisGroup,t),Gv.superCall(this,"render",t,e,i,n)}},_splitLine:function(t,e,i){var n=t.axis;if(!n.scale.isBlank()){var a=t.getModel("splitLine"),o=a.getModel("lineStyle"),r=o.get("color"),s=Nv(a,i);r=rl.isArray(r)?r:[r];for(var l=e.coordinateSystem.getRect(),h=n.isHorizontal(),u=0,c=n.getTicksCoords(),d=n.scale.getTicks(),p=t.get("axisLabel.showMinLabel"),f=t.get("axisLabel.showMaxLabel"),g=[],m=[],v=o.getLineStyle(),y=0;y<c.length;y++)if(!Rv(n,y,s,c.length,p,f)){var x=n.toGlobalCoord(c[y]);h?(g[0]=x,g[1]=l.y,m[0]=x,m[1]=l.y+l.height):(g[0]=l.x,g[1]=x,m[0]=l.x+l.width,m[1]=x);var _=u++%r.length;this._axisGroup.add(new fp.Line(fp.subPixelOptimizeLine({anid:"line_"+d[y],shape:{x1:g[0],y1:g[1],x2:m[0],y2:m[1]},style:rl.defaults({stroke:r[_]},v),silent:!0})))}}},_splitArea:function(t,e,i){var n=t.axis;if(!n.scale.isBlank()){var a=t.getModel("splitArea"),o=a.getModel("areaStyle"),r=o.get("color"),s=e.coordinateSystem.getRect(),l=n.getTicksCoords(),h=n.scale.getTicks(),u=n.toGlobalCoord(l[0]),c=n.toGlobalCoord(l[0]),d=0,p=Nv(a,i),f=o.getAreaStyle();r=rl.isArray(r)?r:[r];for(var g=t.get("axisLabel.showMinLabel"),m=t.get("axisLabel.showMaxLabel"),v=1;v<l.length;v++)if(!Rv(n,v,p,l.length,g,m)){var y,x,_,b,w=n.toGlobalCoord(l[v]);n.isHorizontal()?(y=u,x=s.y,_=w-y,b=s.height):(y=s.x,x=c,_=s.width,b=w-x);var S=d++%r.length;this._axisGroup.add(new fp.Rect({anid:"area_"+h[v],shape:{x:y,y:x,width:_,height:b},style:rl.defaults({fill:r[S]},f),silent:!0})),u=y+_,c=x+b}}}});Gv.extend({type:"xAxis"}),Gv.extend({type:"yAxis"}),ym.extendComponentView({type:"grid",render:function(t,e){this.group.removeAll(),t.get("show")&&this.group.add(new fp.Rect({shape:t.coordinateSystem.getRect(),style:rl.defaults({fill:t.get("backgroundColor")},t.getItemStyle()),silent:!0,z2:-1}))}}),ym.registerPreprocessor(function(t){t.xAxis&&t.yAxis&&!t.grid&&(t.grid={})}),ym.registerVisual(rl.curry(Fm,"line","circle","line")),ym.registerLayout(rl.curry(Zm,"line")),ym.registerProcessor(ym.PRIORITY.PROCESSOR.STATISTIC,rl.curry(qm,"line"));var Hv=Pu.parsePercent,Wv="__ec_stack_";Bi.getLayoutOnAxis=function(t,e){var i=[],n=t.axis;if("category"===n.type){for(var a=n.getBandWidth(),o=0;o<t.count;o++)i.push(rl.defaults({bandWidth:a,axisKey:"axis0",stackId:Wv+o},t));for(var r=Vi(i),s=[],o=0;o<t.count;o++){var l=r.axis0[Wv+o];l.offsetCenter=l.offset+l.width/2,s.push(l)}return s}};var Fv=Bi,Zv=zf.extend({type:"series.__base_bar__",getInitialData:function(t,e){return dg(t.data,this,e)},getMarkerPosition:function(t){var e=this.coordinateSystem;if(e){var i=e.dataToPoint(t,!0),n=this.getData(),a=n.getLayout("offset"),o=n.getLayout("size");return i[e.getBaseAxis().isHorizontal()?0:1]+=a+o/2,i}return[NaN,NaN]},defaultOption:{zlevel:0,z:2,coordinateSystem:"cartesian2d",legendHoverLink:!0,barMinHeight:0,barMinAngle:0,itemStyle:{}}}),jv=(Zv.extend({type:"series.bar",dependencies:["grid","polar"],brushSelector:"rect"}),{setLabel:function(t,e,i,n,a,o,r){var s=i.getModel("label.normal"),l=i.getModel("label.emphasis");fp.setLabelStyle(t,e,s,l,{labelFetcher:a,labelDataIndex:o,defaultText:a.getRawValue(o),isRectText:!0,autoColor:n}),Gi(t),Gi(e)}}),Uv=Gu([["fill","color"],["stroke","borderColor"],["lineWidth","borderWidth"],["stroke","barBorderColor"],["lineWidth","barBorderWidth"],["opacity"],["shadowBlur"],["shadowOffsetX"],["shadowOffsetY"],["shadowColor"]]),qv={getBarItemStyle:function(t){var e=Uv(this,t);if(this.getBorderLineDash){var i=this.getBorderLineDash();i&&(e.lineDash=i)}return e}},Xv=jv.setLabel,Yv=["itemStyle","normal","barBorderWidth"];rl.extend(_p.prototype,qv);ym.extendChartView({type:"bar",render:function(t,e,i){var n=t.get("coordinateSystem");return"cartesian2d"!==n&&"polar"!==n||this._render(t,e,i),this.group},dispose:rl.noop,_render:function(t,e,i){var n,a=this.group,o=t.getData(),r=this._data,s=t.coordinateSystem,l=s.getBaseAxis();"cartesian2d"===s.type?n=l.isHorizontal():"polar"===s.type&&(n="angle"===l.dim);var h=t.isAnimationEnabled()?t:null;o.diff(r).add(function(e){if(o.hasValue(e)){var i=o.getItemModel(e),r=Kv[s.type](o,e,i),l=$v[s.type](o,e,i,r,n,h);o.setItemGraphicEl(e,l),a.add(l),Fi(l,o,e,i,r,t,n,"polar"===s.type)}}).update(function(e,i){var l=r.getItemGraphicEl(i);if(o.hasValue(e)){var u=o.getItemModel(e),c=Kv[s.type](o,e,u);l?fp.updateProps(l,{shape:c},h,e):l=$v[s.type](o,e,u,c,n,h,!0),o.setItemGraphicEl(e,l),a.add(l),Fi(l,o,e,u,c,t,n,"polar"===s.type)}else a.remove(l)}).remove(function(t){var e=r.getItemGraphicEl(t);"cartesian2d"===s.type?e&&Hi(t,h,e):e&&Wi(t,h,e)}).execute(),this._data=o},remove:function(t,e){var i=this.group,n=this._data;t.get("animation")?n&&n.eachItemGraphicEl(function(e){"sector"===e.type?Wi(e.dataIndex,t,e):Hi(e.dataIndex,t,e)}):i.removeAll()}});var $v={cartesian2d:function(t,e,i,n,a,o,r){var s=new fp.Rect({shape:rl.extend({},n)});if(o){var l=s.shape,h=a?"height":"width",u={};l[h]=0,u[h]=n[h],fp[r?"updateProps":"initProps"](s,{shape:u},o,e)}return s},polar:function(t,e,i,n,a,o,r){var s=new fp.Sector({shape:rl.extend({},n)});if(o){var l=s.shape,h=a?"r":"endAngle",u={};l[h]=a?0:n.startAngle,u[h]=n[h],fp[r?"updateProps":"initProps"](s,{shape:u},o,e)}return s}},Kv={cartesian2d:function(t,e,i){var n=t.getItemLayout(e),a=function(t,e){var i=t.get(Yv)||0;return Math.min(i,Math.abs(e.width),Math.abs(e.height))}(i,n),o=n.width>0?1:-1,r=n.height>0?1:-1;return{x:n.x+o*a/2,y:n.y+r*a/2,width:n.width-o*a,height:n.height-r*a}},polar:function(t,e,i){var n=t.getItemLayout(e);return{cx:n.cx,cy:n.cy,r0:n.r0,r:n.r,startAngle:n.startAngle,endAngle:n.endAngle}}};ym.registerLayout(rl.curry(Fv,"bar")),ym.registerVisual(function(t){t.eachSeriesByType("bar",function(t){t.getData().setVisual("legendSymbol","roundRect")})});var Jv={updateSelectedMap:function(t){this._targetList=t.slice(),this._selectTargetMap=rl.reduce(t||[],function(t,e){return t.set(e.name,e),t},rl.createHashMap())},select:function(t,e){var i=null!=e?this._targetList[e]:this._selectTargetMap.get(t);"single"===this.get("selectedMode")&&this._selectTargetMap.each(function(t){t.selected=!1}),i&&(i.selected=!0)},unSelect:function(t,e){var i=null!=e?this._targetList[e]:this._selectTargetMap.get(t);i&&(i.selected=!1)},toggleSelected:function(t,e){var i=null!=e?this._targetList[e]:this._selectTargetMap.get(t);if(null!=i)return this[i.selected?"unSelect":"select"](t,e),i.selected},isSelected:function(t,e){var i=null!=e?this._targetList[e]:this._selectTargetMap.get(t);return i&&i.selected}},Qv=Pu.getPercentWithPrecision,ty=ym.extendSeriesModel({type:"series.pie",init:function(t){ty.superApply(this,"init",arguments),this.legendDataProvider=function(){return this.getRawData()},this.updateSelectedMap(t.data),this._defaultLabelLine(t)},mergeOption:function(t){ty.superCall(this,"mergeOption",t),this.updateSelectedMap(this.option.data)},getInitialData:function(t,e){var i=sg(["value"],t.data),n=new tg(i,this);return n.initData(t.data),n},getDataParams:function(t){var e=this.getData(),i=ty.superCall(this,"getDataParams",t),n=[];return e.each("value",function(t){n.push(t)}),i.percent=Qv(n,t,e.hostModel.get("percentPrecision")),i.$vars.push("percent"),i},_defaultLabelLine:function(t){Ip.defaultEmphasis(t.labelLine,["show"]);var e=t.labelLine.normal,i=t.labelLine.emphasis;e.show=e.show&&t.label.normal.show,i.show=i.show&&t.label.emphasis.show},defaultOption:{zlevel:0,z:2,legendHoverLink:!0,hoverAnimation:!0,center:["50%","50%"],radius:[0,"75%"],clockwise:!0,startAngle:90,minAngle:0,selectedOffset:10,hoverOffset:10,avoidLabelOverlap:!0,percentPrecision:2,stillShowZeroSum:!0,label:{normal:{rotate:!1,show:!0,position:"outer"},emphasis:{}},labelLine:{normal:{show:!0,length:15,length2:15,smooth:!1,lineStyle:{width:1,type:"solid"}}},itemStyle:{normal:{borderWidth:1},emphasis:{}},animationType:"expansion",animationEasing:"cubicOut",data:[]}});rl.mixin(ty,Jv);var ey=ji.prototype;ey.updateData=function(t,e,i){function n(){o.stopAnimation(!0),o.animateTo({shape:{r:l.r+r.get("hoverOffset")}},300,"elasticOut")}function a(){o.stopAnimation(!0),o.animateTo({shape:{r:l.r}},300,"elasticOut")}var o=this.childAt(0),r=t.hostModel,s=t.getItemModel(e),l=t.getItemLayout(e),h=rl.extend({},l);if(h.label=null,i){o.setShape(h);"scale"===r.getShallow("animationType")?(o.shape.r=l.r0,fp.initProps(o,{shape:{r:l.r}},r,e)):(o.shape.endAngle=l.startAngle,fp.updateProps(o,{shape:{endAngle:l.endAngle}},r,e))}else fp.updateProps(o,{shape:h},r,e);var u=s.getModel("itemStyle"),c=t.getItemVisual(e,"color");o.useStyle(rl.defaults({lineJoin:"bevel",fill:c},u.getModel("normal").getItemStyle())),o.hoverStyle=u.getModel("emphasis").getItemStyle();var d=s.getShallow("cursor");d&&o.attr("cursor",d),Zi(this,t.getItemLayout(e),s.get("selected"),r.get("selectedOffset"),r.get("animation")),o.off("mouseover").off("mouseout").off("emphasis").off("normal"),s.get("hoverAnimation")&&r.isAnimationEnabled()&&o.on("mouseover",n).on("mouseout",a).on("emphasis",n).on("normal",a),this._updateLabel(t,e),fp.setHoverStyle(this)},ey._updateLabel=function(t,e){var i=this.childAt(1),n=this.childAt(2),a=t.hostModel,o=t.getItemModel(e),r=t.getItemLayout(e).label,s=t.getItemVisual(e,"color");fp.updateProps(i,{shape:{points:r.linePoints||[[r.x,r.y],[r.x,r.y],[r.x,r.y]]}},a,e),fp.updateProps(n,{style:{x:r.x,y:r.y}},a,e),n.attr({rotation:r.rotation,origin:[r.x,r.y],z2:10});var l=o.getModel("label.normal"),h=o.getModel("label.emphasis"),u=o.getModel("labelLine.normal"),c=o.getModel("labelLine.emphasis"),s=t.getItemVisual(e,"color");fp.setLabelStyle(n.style,n.hoverStyle={},l,h,{labelFetcher:t.hostModel,labelDataIndex:e,defaultText:t.getName(e),autoColor:s,useInsideStyle:!!r.inside},{textAlign:r.textAlign,textVerticalAlign:r.verticalAlign,opacity:t.getItemVisual(e,"opacity")}),n.ignore=n.normalIgnore=!l.get("show"),n.hoverIgnore=!h.get("show"),i.ignore=i.normalIgnore=!u.get("show"),i.hoverIgnore=!c.get("show"),i.setStyle({stroke:s,opacity:t.getItemVisual(e,"opacity")}),i.setStyle(u.getModel("lineStyle").getLineStyle()),i.hoverStyle=c.getModel("lineStyle").getLineStyle();var d=u.get("smooth");d&&!0===d&&(d=.4),i.setShape({smooth:d})},rl.inherits(ji,fp.Group);Bf.extend({type:"pie",init:function(){var t=new fp.Group;this._sectorGroup=t},render:function(t,e,i,n){if(!n||n.from!==this.uid){var a=t.getData(),o=this._data,r=this.group,s=e.get("animation"),l=!o,h=t.get("animationType"),u=rl.curry(function(t,e,i,n){var a=e.getData(),o=this.dataIndex,r=a.getName(o),s=e.get("selectedOffset");n.dispatchAction({type:"pieToggleSelect",from:t,name:r,seriesId:e.id}),a.each(function(t){Zi(a.getItemGraphicEl(t),a.getItemLayout(t),e.isSelected(a.getName(t)),s,i)})},this.uid,t,s,i),c=t.get("selectedMode");if(a.diff(o).add(function(t){var e=new ji(a,t);l&&"scale"!==h&&e.eachChild(function(t){t.stopAnimation(!0)}),c&&e.on("click",u),a.setItemGraphicEl(t,e),r.add(e)}).update(function(t,e){var i=o.getItemGraphicEl(e);i.updateData(a,t),i.off("click"),c&&i.on("click",u),r.add(i),a.setItemGraphicEl(t,i)}).remove(function(t){var e=o.getItemGraphicEl(t);r.remove(e)}).execute(),s&&l&&a.count()>0&&"scale"!==h){var d=a.getItemLayout(0),p=Math.max(i.getWidth(),i.getHeight())/2,f=rl.bind(r.removeClipPath,r);r.setClipPath(this._createClipPath(d.cx,d.cy,p,d.startAngle,d.clockwise,f,t))}this._data=a}},dispose:function(){},_createClipPath:function(t,e,i,n,a,o,r){var s=new fp.Sector({shape:{cx:t,cy:e,r0:0,r:i,startAngle:n,endAngle:n,clockwise:a}});return fp.initProps(s,{shape:{endAngle:n+(a?1:-1)*Math.PI*2}},r,o),s},containPoint:function(t,e){var i=e.getData().getItemLayout(0);if(i){var n=t[0]-i.cx,a=t[1]-i.cy,o=Math.sqrt(n*n+a*a);return o<=i.r&&o>=i.r0}}});var iy=function(t,e){rl.each(e,function(e){e.update="updateView",ym.registerAction(e,function(i,n){var a={};return n.eachComponent({mainType:"series",subType:t,query:i},function(t){t[e.method]&&t[e.method](i.name,i.dataIndex);var n=t.getData();n.each(function(e){var i=n.getName(e);a[i]=t.isSelected(i)||!1})}),{name:i.name,selected:a}})})},ny=function(t,e){var i={};e.eachRawSeriesByType(t,function(t){var n=t.getRawData(),a={};if(!e.isSeriesFiltered(t)){var o=t.getData();o.each(function(t){var e=o.getRawIndex(t);a[e]=t}),n.each(function(e){var r=a[e],s=null!=r&&o.getItemVisual(r,"color",!0);if(s)n.setItemVisual(e,"color",s);else{var l=n.getItemModel(e).get("itemStyle.normal.color")||t.getColorFromPalette(n.getName(e),i);n.setItemVisual(e,"color",l),null!=r&&o.setItemVisual(r,"color",l)}})}})},ay=function(t,e,i,n){var a,o,r=t.getData(),s=[],l=!1;r.each(function(i){var n,h,u,c,d=r.getItemLayout(i),p=r.getItemModel(i),f=p.getModel("label.normal"),g=f.get("position")||p.get("label.emphasis.position"),m=p.getModel("labelLine.normal"),v=m.get("length"),y=m.get("length2"),x=(d.startAngle+d.endAngle)/2,_=Math.cos(x),b=Math.sin(x);a=d.cx,o=d.cy;var w="inside"===g||"inner"===g;if("center"===g)n=d.cx,h=d.cy,c="center";else{var S=(w?(d.r+d.r0)/2*_:d.r*_)+a,M=(w?(d.r+d.r0)/2*b:d.r*b)+o;if(n=S+3*_,h=M+3*b,!w){var I=S+_*(v+e-d.r),T=M+b*(v+e-d.r),A=I+(_<0?-1:1)*y,C=T;n=A+(_<0?-5:5),h=C,u=[[S,M],[I,T],[A,C]]}c=w?"center":_>0?"left":"right"}var L=f.getFont(),D=f.get("rotate")?_<0?-x+Math.PI:-x:0,P=t.getFormattedLabel(i,"normal")||r.getName(i),k=Nh.getBoundingRect(P,L,c,"top");l=!!D,d.label={x:n,y:h,position:g,height:k.height,len:v,len2:y,linePoints:u,textAlign:c,verticalAlign:"middle",rotation:D,inside:w},w||s.push(d.label)}),!l&&t.get("avoidLabelOverlap")&&function(t,e,i,n,a,o){for(var r=[],s=[],l=0;l<t.length;l++)t[l].x<e?r.push(t[l]):s.push(t[l]);for(Ui(s,e,i,n,1,0,o),Ui(r,e,i,n,-1,0,o),l=0;l<t.length;l++){var h=t[l].linePoints;if(h){var u=h[1][0]-h[2][0];t[l].x<e?h[2][0]=t[l].x+3:h[2][0]=t[l].x-3,h[1][1]=h[2][1]=t[l].y,h[1][0]=h[2][0]+u}}}(s,a,o,e,0,n)},oy=Pu.parsePercent,ry=Pu.linearMap,sy=2*Math.PI,ly=Math.PI/180,hy=function(t,e,i,n){e.eachSeriesByType(t,function(t){var e=t.get("center"),n=t.get("radius");rl.isArray(n)||(n=[0,n]),rl.isArray(e)||(e=[e,e]);var a=i.getWidth(),o=i.getHeight(),r=Math.min(a,o),s=oy(e[0],a),l=oy(e[1],o),h=oy(n[0],r/2),u=oy(n[1],r/2),c=t.getData(),d=-t.get("startAngle")*ly,p=t.get("minAngle")*ly,f=0;c.each("value",function(t){!isNaN(t)&&f++});var g=c.getSum("value"),m=Math.PI/(g||f)*2,v=t.get("clockwise"),y=t.get("roseType"),x=t.get("stillShowZeroSum"),_=c.getDataExtent("value");_[0]=0;var b=sy,w=0,S=d,M=v?1:-1;if(c.each("value",function(t,e){var i;if(isNaN(t))c.setItemLayout(e,{angle:NaN,startAngle:NaN,endAngle:NaN,clockwise:v,cx:s,cy:l,r0:h,r:y?NaN:u});else{(i="area"!==y?0===g&&x?m:t*m:sy/f)<p?(i=p,b-=p):w+=t;var n=S+M*i;c.setItemLayout(e,{angle:i,startAngle:S,endAngle:n,clockwise:v,cx:s,cy:l,r0:h,r:y?ry(t,_,[h,u]):u}),S=n}},!0),b<sy&&f)if(b<=.001){var I=sy/f;c.each("value",function(t,e){if(!isNaN(t)){var i=c.getItemLayout(e);i.angle=I,i.startAngle=d+M*e*I,i.endAngle=d+M*(e+1)*I}})}else m=b/w,S=d,c.each("value",function(t,e){if(!isNaN(t)){var i=c.getItemLayout(e),n=i.angle===p?p:t*m;i.startAngle=S,i.endAngle=S+M*n,S+=M*n}});ay(t,u,a,o)})},uy=function(t,e){var i=e.findComponents({mainType:"legend"});i&&i.length&&e.eachSeriesByType(t,function(t){var e=t.getData();e.filterSelf(function(t){for(var n=e.getName(t),a=0;a<i.length;a++)if(!i[a].isSelected(n))return!1;return!0},this)},this)};iy("pie",[{type:"pieToggleSelect",event:"pieselectchanged",method:"toggleSelected"},{type:"pieSelect",event:"pieselected",method:"select"},{type:"pieUnSelect",event:"pieunselected",method:"unSelect"}]),ym.registerVisual(rl.curry(ny,"pie")),ym.registerLayout(rl.curry(hy,"pie")),ym.registerProcessor(rl.curry(uy,"pie"));zf.extend({type:"series.scatter",dependencies:["grid","polar","geo","singleAxis","calendar"],getInitialData:function(t,e){return dg(t.data,this,e)},brushSelector:"point",defaultOption:{coordinateSystem:"cartesian2d",zlevel:0,z:2,legendHoverLink:!0,hoverAnimation:!0,symbolSize:10,large:!1,largeThreshold:2e3,itemStyle:{normal:{opacity:.8}}}});var cy=Ug.createSymbol,dy=fp.extendShape({shape:{points:null,sizes:null},symbolProxy:null,buildPath:function(t,e){for(var i=e.points,n=e.sizes,a=this.symbolProxy,o=a.shape,r=0;r<i.length;r++){var s=i[r];if(!isNaN(s[0])&&!isNaN(s[1])){var l=n[r];l[0]<4?t.rect(s[0]-l[0]/2,s[1]-l[1]/2,l[0],l[1]):(o.x=s[0]-l[0]/2,o.y=s[1]-l[1]/2,o.width=l[0],o.height=l[1],a.buildPath(t,o,!0))}}},findDataIndex:function(t,e){for(var i=this.shape,n=i.points,a=i.sizes,o=n.length-1;o>=0;o--){var r=n[o],s=a[o],l=r[0]-s[0]/2,h=r[1]-s[1]/2;if(t>=l&&e>=h&&t<=l+s[0]&&e<=h+s[1])return o}return-1}}),py=qi.prototype;py.updateData=function(t){this.group.removeAll();var e=this._symbolEl,i=t.hostModel;e.setShape({points:t.mapArray(t.getItemLayout),sizes:t.mapArray(function(e){var i=t.getItemVisual(e,"symbolSize");return i instanceof Array||(i=[i,i]),i})}),e.symbolProxy=cy(t.getVisual("symbol"),0,0,0,0),e.setColor=e.symbolProxy.setColor,e.useStyle(i.getModel("itemStyle.normal").getItemStyle(["color"]));var n=t.getVisual("color");n&&e.setColor(n),e.seriesIndex=i.seriesIndex,e.on("mousemove",function(t){e.dataIndex=null;var i=e.findDataIndex(t.offsetX,t.offsetY);i>=0&&(e.dataIndex=i)}),this.group.add(e)},py.updateLayout=function(t){var e=t.getData();this._symbolEl.setShape({points:e.mapArray(e.getItemLayout)})},py.remove=function(){this.group.removeAll()};var fy=qi;ym.extendChartView({type:"scatter",init:function(){this._normalSymbolDraw=new Pm,this._largeSymbolDraw=new fy},render:function(t,e,i){var n=t.getData(),a=this._largeSymbolDraw,o=this._normalSymbolDraw,r=this.group,s=t.get("large")&&n.count()>t.get("largeThreshold")?a:o;this._symbolDraw=s,s.updateData(n),r.add(s.group),r.remove(s===a?o.group:a.group)},updateLayout:function(t){this._symbolDraw.updateLayout(t)},remove:function(t,e){this._symbolDraw&&this._symbolDraw.remove(e,!0)},dispose:function(){}}),ym.registerVisual(rl.curry(Fm,"scatter","circle",null)),ym.registerLayout(rl.curry(Zm,"scatter")),rl.inherits(Xi,Kg);var gy=Xi,my=Rg.getScaleExtent,vy=Rg.niceScaleExtent;Yi.prototype.getIndicatorAxes=function(){return this._indicatorAxes},Yi.prototype.dataToPoint=function(t,e){var i=this._indicatorAxes[e];return this.coordToPoint(i.dataToCoord(t),e)},Yi.prototype.coordToPoint=function(t,e){var i=this._indicatorAxes[e].angle;return[this.cx+t*Math.cos(i),this.cy-t*Math.sin(i)]},Yi.prototype.pointToData=function(t){var e=t[0]-this.cx,i=t[1]-this.cy,n=Math.sqrt(e*e+i*i);e/=n,i/=n;for(var a,o=Math.atan2(-i,e),r=1/0,s=-1,l=0;l<this._indicatorAxes.length;l++){var h=this._indicatorAxes[l],u=Math.abs(o-h.angle);u<r&&(a=h,s=l,r=u)}return[s,+(a&&a.coodToData(n))]},Yi.prototype.resize=function(t,e){var i=t.get("center"),n=e.getWidth(),a=e.getHeight(),o=Math.min(n,a)/2;this.cx=Pu.parsePercent(i[0],n),this.cy=Pu.parsePercent(i[1],a),this.startAngle=t.get("startAngle")*Math.PI/180,this.r=Pu.parsePercent(t.get("radius"),o),rl.each(this._indicatorAxes,function(t,e){t.setExtent(0,this.r);var i=this.startAngle+e*Math.PI*2/this._indicatorAxes.length;i=Math.atan2(Math.sin(i),Math.cos(i)),t.angle=i},this)},Yi.prototype.update=function(t,e){function i(t){var e=Math.pow(10,Math.floor(Math.log(t)/Math.LN10)),i=t/e;return 2===i?i=5:i*=2,i*e}var n=this._indicatorAxes,a=this._model;rl.each(n,function(t){t.scale.setExtent(1/0,-1/0)}),t.eachSeriesByType("radar",function(e,i){if("radar"===e.get("coordinateSystem")&&t.getComponent("radar",e.get("radarIndex"))===a){var o=e.getData();rl.each(n,function(t){t.scale.unionExtentFromData(o,t.dim)})}},this);var o=a.get("splitNumber");rl.each(n,function(t,e){var n=my(t.scale,t.model);vy(t.scale,t.model);var a=t.model,r=t.scale,s=a.getMin(),l=a.getMax(),h=r.getInterval();if(null!=s&&null!=l)r.setExtent(+s,+l),r.setInterval((l-s)/o);else if(null!=s){var u;do{u=s+h*o,r.setExtent(+s,u),r.setInterval(h),h=i(h)}while(u<n[1]&&isFinite(u)&&isFinite(n[1]))}else if(null!=l){var c;do{c=l-h*o,r.setExtent(c,+l),r.setInterval(h),h=i(h)}while(c>n[0]&&isFinite(c)&&isFinite(n[0]))}else{r.getTicks().length-1>o&&(h=i(h));var d=Math.round((n[0]+n[1])/2/h)*h,p=Math.round(o/2);r.setExtent(Pu.round(d-p*h),Pu.round(d+(o-p)*h)),r.setInterval(h)}})},Yi.dimensions=[],Yi.create=function(t,e){var i=[];return t.eachComponent("radar",function(n){var a=new Yi(n,t,e);i.push(a),n.coordinateSystem=a}),t.eachSeriesByType("radar",function(t){"radar"===t.get("coordinateSystem")&&(t.coordinateSystem=i[t.get("radarIndex")||0])}),i},rf.register("radar",Yi);var yy=ev.valueAxis,xy=(ym.extendComponentModel({type:"radar",optionUpdated:function(){var t=this.get("boundaryGap"),e=this.get("splitNumber"),i=this.get("scale"),n=this.get("axisLine"),a=this.get("axisTick"),o=this.get("axisLabel"),r=this.get("name"),s=this.get("name.show"),l=this.get("name.formatter"),h=this.get("nameGap"),u=this.get("triggerEvent"),c=rl.map(this.get("indicator")||[],function(c){null!=c.max&&c.max>0&&!c.min?c.min=0:null!=c.min&&c.min<0&&!c.max&&(c.max=0);var d=r;if(null!=c.color&&(d=rl.defaults({color:c.color},r)),c=rl.merge(rl.clone(c),{boundaryGap:t,splitNumber:e,scale:i,axisLine:n,axisTick:a,axisLabel:o,name:c.text,nameLocation:"end",nameGap:h,nameTextStyle:d,triggerEvent:u},!1),s||(c.name=""),"string"==typeof l){var p=c.name;c.name=l.replace("{value}",null!=p?p:"")}else"function"==typeof l&&(c.name=l(c.name,c));var f=rl.extend(new _p(c,null,this.ecModel),Ng);return f.mainType="radar",f.componentIndex=this.componentIndex,f},this);this.getIndicatorModels=function(){return c}},defaultOption:{zlevel:0,z:0,center:["50%","50%"],radius:"75%",startAngle:90,name:{show:!0},boundaryGap:[0,0],splitNumber:5,nameGap:15,scale:!1,shape:"polygon",axisLine:rl.merge({lineStyle:{color:"#bbb"}},yy.axisLine),axisLabel:$i(yy.axisLabel,!1),axisTick:$i(yy.axisTick,!1),splitLine:$i(yy.splitLine,!0),splitArea:$i(yy.splitArea,!0),indicator:[]}}),["axisLine","axisTickLabel","axisName"]),_y=(ym.extendComponentView({type:"radar",render:function(t,e,i){this.group.removeAll(),this._buildAxes(t),this._buildSplitLineAndArea(t)},_buildAxes:function(t){var e=t.coordinateSystem,i=e.getIndicatorAxes(),n=rl.map(i,function(t){return new Cv(t.model,{position:[e.cx,e.cy],rotation:t.angle,labelDirection:-1,tickDirection:-1,nameDirection:1})});rl.each(n,function(t){rl.each(xy,t.add,t),this.group.add(t.getGroup())},this)},_buildSplitLineAndArea:function(t){function e(t,e,i){var n=i%e.length;return t[n]=t[n]||[],n}var i=t.coordinateSystem,n=i.getIndicatorAxes();if(n.length){var a=t.get("shape"),o=t.getModel("splitLine"),r=t.getModel("splitArea"),s=o.getModel("lineStyle"),l=r.getModel("areaStyle"),h=o.get("show"),u=r.get("show"),c=s.get("color"),d=l.get("color");c=rl.isArray(c)?c:[c],d=rl.isArray(d)?d:[d];var p=[],f=[];if("circle"===a)for(var g=n[0].getTicksCoords(),m=i.cx,v=i.cy,y=0;y<g.length;y++){if(h){p[M=e(p,c,y)].push(new fp.Circle({shape:{cx:m,cy:v,r:g[y]}}))}if(u&&y<g.length-1){f[M=e(f,d,y)].push(new fp.Ring({shape:{cx:m,cy:v,r0:g[y],r:g[y+1]}}))}}else for(var x,_=rl.map(n,function(t,e){var n=t.getTicksCoords();return x=null==x?n.length-1:Math.min(n.length-1,x),rl.map(n,function(t){return i.coordToPoint(t,e)})}),b=[],y=0;y<=x;y++){for(var w=[],S=0;S<n.length;S++)w.push(_[S][y]);if(w[0]&&w.push(w[0].slice()),h){p[M=e(p,c,y)].push(new fp.Polyline({shape:{points:w}}))}if(u&&b){var M=e(f,d,y-1);f[M].push(new fp.Polygon({shape:{points:w.concat(b)}}))}b=w.slice().reverse()}var I=s.getLineStyle(),T=l.getAreaStyle();rl.each(f,function(t,e){this.group.add(fp.mergePath(t,{style:rl.defaults({stroke:"none",fill:d[e%d.length]},T),silent:!0}))},this),rl.each(p,function(t,e){this.group.add(fp.mergePath(t,{style:rl.defaults({fill:"none",stroke:c[e%c.length]},I),silent:!0}))},this)}}}),Eu.encodeHTML),by=zf.extend({type:"series.radar",dependencies:["radar"],init:function(t){by.superApply(this,"init",arguments),this.legendDataProvider=function(){return this.getRawData()}},getInitialData:function(t,e){var i=t.data||[],n=sg([],i,{extraPrefix:"indicator_",extraFromZero:!0}),a=new tg(n,this);return a.initData(i),a},formatTooltip:function(t){var e=this.getRawValue(t),i=this.coordinateSystem.getIndicatorAxes(),n=this.getData().getName(t);return _y(""===n?this.name:n)+"<br/>"+rl.map(i,function(t,i){return _y(t.name+" : "+e[i])}).join("<br />")},defaultOption:{zlevel:0,z:2,coordinateSystem:"radar",legendHoverLink:!0,radarIndex:0,lineStyle:{normal:{width:2,type:"solid"}},label:{normal:{position:"top"}},symbol:"emptyCircle",symbolSize:4}}),wy=(ym.extendChartView({type:"radar",render:function(t,e,i){function n(e,i,n,a,o,r){n.removeAll();for(var s=0;s<i.length-1;s++){var l=function(t,e){var i=t.getItemVisual(e,"symbol")||"circle",n=t.getItemVisual(e,"color");if("none"!==i){var a=function(t){return rl.isArray(t)||(t=[+t,+t]),t}(t.getItemVisual(e,"symbolSize")),o=Ug.createSymbol(i,-1,-1,2,2,n);return o.attr({style:{strokeNoScale:!0},z2:100,scale:[a[0]/2,a[1]/2]}),o}}(a,o);l&&(l.__dimIdx=s,e[s]?(l.attr("position",e[s]),fp[r?"initProps":"updateProps"](l,{position:i[s]},t,o)):l.attr("position",i[s]),n.add(l))}}function a(t){return rl.map(t,function(t){return[o.cx,o.cy]})}var o=t.coordinateSystem,r=this.group,s=t.getData(),l=this._data;s.diff(l).add(function(e){var i=s.getItemLayout(e);if(i){var o=new fp.Polygon,r=new fp.Polyline,l={shape:{points:i}};o.shape.points=a(i),r.shape.points=a(i),fp.initProps(o,l,t,e),fp.initProps(r,l,t,e);var h=new fp.Group,u=new fp.Group;h.add(r),h.add(o),h.add(u),n(r.shape.points,i,u,s,e,!0),s.setItemGraphicEl(e,h)}}).update(function(e,i){var a=l.getItemGraphicEl(i),o=a.childAt(0),r=a.childAt(1),h=a.childAt(2),u={shape:{points:s.getItemLayout(e)}};u.shape.points&&(n(o.shape.points,u.shape.points,h,s,e,!1),fp.updateProps(o,u,t),fp.updateProps(r,u,t),s.setItemGraphicEl(e,a))}).remove(function(t){r.remove(l.getItemGraphicEl(t))}).execute(),s.eachItemGraphicEl(function(t,e){function i(){l.attr("ignore",f)}function n(){l.attr("ignore",p)}var a=s.getItemModel(e),o=t.childAt(0),l=t.childAt(1),h=t.childAt(2),u=s.getItemVisual(e,"color");r.add(t),o.useStyle(rl.defaults(a.getModel("lineStyle.normal").getLineStyle(),{fill:"none",stroke:u})),o.hoverStyle=a.getModel("lineStyle.emphasis").getLineStyle();var c=a.getModel("areaStyle.normal"),d=a.getModel("areaStyle.emphasis"),p=c.isEmpty()&&c.parentModel.isEmpty(),f=d.isEmpty()&&d.parentModel.isEmpty();f=f&&p,l.ignore=p,l.useStyle(rl.defaults(c.getAreaStyle(),{fill:u,opacity:.7})),l.hoverStyle=d.getAreaStyle();var g=a.getModel("itemStyle.normal").getItemStyle(["color"]),m=a.getModel("itemStyle.emphasis").getItemStyle(),v=a.getModel("label.normal"),y=a.getModel("label.emphasis");h.eachChild(function(t){t.setStyle(g),t.hoverStyle=rl.clone(m),fp.setLabelStyle(t.style,t.hoverStyle,v,y,{labelFetcher:s.hostModel,labelDataIndex:e,labelDimIndex:t.__dimIdx,defaultText:s.get(s.dimensions[t.__dimIdx],e),autoColor:u,isRectText:!0})}),t.off("mouseover").off("mouseout").off("normal").off("emphasis"),t.on("emphasis",i).on("mouseover",i).on("normal",n).on("mouseout",n),fp.setHoverStyle(t)}),this._data=s},remove:function(){this.group.removeAll(),this._data=null},dispose:function(){}}),function(t){t.eachSeriesByType("radar",function(t){var e=t.getData(),i=[],n=t.coordinateSystem;if(n){for(var a=0;a<n.getIndicatorAxes().length;a++){var o=e.dimensions[a];e.each(o,function(t,e){i[e]=i[e]||[],i[e][a]=n.dataToPoint(t,a)})}e.each(function(t){i[t][0]&&i[t].push(i[t][0].slice()),e.setItemLayout(t,i[t])})}})}),Sy=function(t){var e=t.polar;if(e){rl.isArray(e)||(e=[e]);var i=[];rl.each(e,function(e,n){e.indicator?(e.type&&!e.shape&&(e.shape=e.type),t.radar=t.radar||[],rl.isArray(t.radar)||(t.radar=[t.radar]),t.radar.push(e)):i.push(e)}),t.polar=i}rl.each(t.series,function(t){t&&"radar"===t.type&&t.polarIndex&&(t.radarIndex=t.polarIndex)})};ym.registerVisual(rl.curry(ny,"radar")),ym.registerVisual(rl.curry(Fm,"radar","circle",null)),ym.registerLayout(wy),ym.registerProcessor(rl.curry(uy,"radar")),ym.registerPreprocessor(Sy);var My=ll.applyTransform;rl.mixin(Ki,Ml),Ji.prototype={constructor:Ji,type:"view",dimensions:["x","y"],setBoundingRect:function(t,e,i,n){return this._rect=new oh(t,e,i,n),this._rect},getBoundingRect:function(){return this._rect},setViewRect:function(t,e,i,n){this.transformTo(t,e,i,n),this._viewRect=new oh(t,e,i,n)},transformTo:function(t,e,i,n){var a=this.getBoundingRect(),o=this._viewTransform;o.transform=a.calculateTransform(new oh(t,e,i,n)),o.decomposeTransform(),this._updateTransform()},setCenter:function(t){t&&(this._center=t,this._updateCenterAndZoom())},setZoom:function(t){t=t||1;var e=this.zoomLimit;e&&(null!=e.max&&(t=Math.min(e.max,t)),null!=e.min&&(t=Math.max(e.min,t))),this._zoom=t,this._updateCenterAndZoom()},getDefaultCenter:function(){var t=this.getBoundingRect();return[t.x+t.width/2,t.y+t.height/2]},getCenter:function(){return this._center||this.getDefaultCenter()},getZoom:function(){return this._zoom||1},getRoamTransform:function(){return this._roamTransform},_updateCenterAndZoom:function(){var t=this._viewTransform.getLocalTransform(),e=this._roamTransform,i=this.getDefaultCenter(),n=this.getCenter(),a=this.getZoom();n=ll.applyTransform([],n,t),i=ll.applyTransform([],i,t),e.origin=n,e.position=[i[0]-n[0],i[1]-n[1]],e.scale=[a,a],this._updateTransform()},_updateTransform:function(){var t=this._roamTransform,e=this._viewTransform;e.parent=t,t.updateTransform(),e.updateTransform(),e.transform&&yl.copy(this.transform||(this.transform=[]),e.transform),this.transform?(this.invTransform=this.invTransform||[],yl.invert(this.invTransform,this.transform)):this.invTransform=null,this.decomposeTransform()},getViewRect:function(){return this._viewRect},getViewRectAfterRoam:function(){var t=this.getBoundingRect().clone();return t.applyTransform(this.transform),t},dataToPoint:function(t){var e=this.transform;return e?My([],t,e):[t[0],t[1]]},pointToData:function(t){var e=this.invTransform;return e?My([],t,e):[t[0],t[1]]},convertToPixel:rl.curry(Qi,"dataToPoint"),convertFromPixel:rl.curry(Qi,"pointToData"),containPoint:function(t){return this.getViewRectAfterRoam().contain(t[0],t[1])}},rl.mixin(Ji,Ml);for(var Iy=Ji,Ty=[126,25],Ay=[[[0,3.5],[7,11.2],[15,11.9],[30,7],[42,.7],[52,.7],[56,7.7],[59,.7],[64,.7],[64,0],[5,0],[0,3.5]],[[13,16.1],[19,14.7],[16,21.7],[11,23.1],[13,16.1]],[[12,32.2],[14,38.5],[15,38.5],[13,32.2],[12,32.2]],[[16,47.6],[12,53.2],[13,53.2],[18,47.6],[16,47.6]],[[6,64.4],[8,70],[9,70],[8,64.4],[6,64.4]],[[23,82.6],[29,79.8],[30,79.8],[25,82.6],[23,82.6]],[[37,70.7],[43,62.3],[44,62.3],[39,70.7],[37,70.7]],[[48,51.1],[51,45.5],[53,45.5],[50,51.1],[48,51.1]],[[51,35],[51,28.7],[53,28.7],[53,35],[51,35]],[[52,22.4],[55,17.5],[56,17.5],[53,22.4],[52,22.4]],[[58,12.6],[62,7],[63,7],[60,12.6],[58,12.6]],[[0,3.5],[0,93.1],[64,93.1],[64,0],[63,0],[63,92.4],[1,92.4],[1,3.5],[0,3.5]]],Cy=0;Cy<Ay.length;Cy++)for(var Ly=0;Ly<Ay[Cy].length;Ly++)Ay[Cy][Ly][0]/=10.5,Ay[Cy][Ly][1]/=-14,Ay[Cy][Ly][0]+=Ty[0],Ay[Cy][Ly][1]+=Ty[1];var Dy={"南海诸岛":[32,80],"广东":[0,-10],"香港":[10,5],"澳门":[-10,10],"天津":[5,5]},Py={Russia:[100,60],"United States":[-99,38],"United States of America":[-99,38]},ky=[[[123.45165252685547,25.73527164402261],[123.49731445312499,25.73527164402261],[123.49731445312499,25.750734064600884],[123.45165252685547,25.750734064600884],[123.45165252685547,25.73527164402261]]],Oy=[function(t){"china"===t.map&&t.regions.push(new tm("南海诸岛",rl.map(Ay,function(t){return{type:"polygon",exterior:t}}),Ty))},function(t){rl.each(t.regions,function(t){var e=Dy[t.name];if(e){var i=t.center;i[0]+=e[0]/10.5,i[1]+=-e[1]/14}})},function(t){rl.each(t.regions,function(t){var e=Py[t.name];if(e){var i=t.center;i[0]=e[0],i[1]=e[1]}})},function(t){if("china"===t.map)for(var e=0,i=t.regions.length;e<i;++e)"台湾"===t.regions[e].name&&t.regions[e].geometries.push({type:"polygon",exterior:ky[0]})}];tn.prototype={constructor:tn,type:"geo",dimensions:["lng","lat"],containCoord:function(t){for(var e=this.regions,i=0;i<e.length;i++)if(e[i].contain(t))return!0;return!1},loadGeoJson:function(t,e,i){try{this.regions=t?em(t):[]}catch(t){throw"Invalid geoJson format\n"+t.message}e=e||{},i=i||{};for(var n=this.regions,a=rl.createHashMap(),o=0;o<n.length;o++){var r=n[o].name;r=i.hasOwnProperty(r)?i[r]:r,n[o].name=r,a.set(r,n[o]),this.addGeoCoord(r,n[o].center);var s=e[r];s&&n[o].transformTo(s.left,s.top,s.width,s.height)}this._regionsMap=a,this._rect=null,rl.each(Oy,function(t){t(this)},this)},transformTo:function(t,e,i,n){var a=this.getBoundingRect();(a=a.clone()).y=-a.y-a.height;var o=this._viewTransform;o.transform=a.calculateTransform(new oh(t,e,i,n)),o.decomposeTransform();var r=o.scale;r[1]=-r[1],o.updateTransform(),this._updateTransform()},getRegion:function(t){return this._regionsMap.get(t)},getRegionByCoord:function(t){for(var e=this.regions,i=0;i<e.length;i++)if(e[i].contain(t))return e[i]},addGeoCoord:function(t,e){this._nameCoordMap.set(t,e)},getGeoCoord:function(t){return this._nameCoordMap.get(t)},getBoundingRect:function(){if(this._rect)return this._rect;for(var t,e=this.regions,i=0;i<e.length;i++){var n=e[i].getBoundingRect();(t=t||n.clone()).union(n)}return this._rect=t||new oh(0,0,0,0)},dataToPoint:function(t){if("string"==typeof t&&(t=this.getGeoCoord(t)),t)return Iy.prototype.dataToPoint.call(this,t)},convertToPixel:rl.curry(en,"dataToPoint"),convertFromPixel:rl.curry(en,"pointToData")},rl.mixin(tn,Iy);var zy=tn,Ey={dimensions:zy.prototype.dimensions,create:function(t,e){var i=[];t.eachComponent("geo",function(t,n){var a=t.get("map"),o=ym.getMap(a),r=new zy(a+n,a,o&&o.geoJson,o&&o.specialAreas,t.get("nameMap"));r.zoomLimit=t.get("scaleLimit"),i.push(r),an(r,t),t.coordinateSystem=r,r.model=t,r.resize=nn,r.resize(t,e)}),t.eachSeries(function(t){if("geo"===t.get("coordinateSystem")){var e=t.get("geoIndex")||0;t.coordinateSystem=i[e]}});var n={};return t.eachSeriesByType("map",function(t){if(!t.getHostGeoModel()){var e=t.getMapType();n[e]=n[e]||[],n[e].push(t)}}),rl.each(n,function(t,n){var a=ym.getMap(n),o=rl.map(t,function(t){return t.get("nameMap")}),r=new zy(n,n,a&&a.geoJson,a&&a.specialAreas,rl.mergeAll(o));r.zoomLimit=rl.retrieve.apply(null,rl.map(t,function(t){return t.get("scaleLimit")})),i.push(r),r.resize=nn,r.resize(t[0],e),rl.each(t,function(t){t.coordinateSystem=r,an(r,t)})}),i},getFilledRegions:function(t,e,i){var n=(t||[]).slice();i=i||{};var a=ym.getMap(e),o=a&&a.geoJson;if(!o)return t;for(var r=rl.createHashMap(),s=o.features,l=0;l<n.length;l++)r.set(n[l].name,n[l]);for(l=0;l<s.length;l++){var h=s[l].properties.name;r.get(h)||(i.hasOwnProperty(h)&&(h=i[h]),n.push({name:h}))}return n}};ym.registerCoordinateSystem("geo",Ey);var Ry=Ey,Ny=Eu.encodeHTML,Vy=Eu.addCommas,By=zf.extend({type:"series.map",dependencies:["geo"],layoutMode:"box",needsDrawMap:!1,seriesGroup:[],init:function(t){this._fillOption(t,this.getMapType()),By.superApply(this,"init",arguments),this.updateSelectedMap(t.data)},getInitialData:function(t){var e=sg(["value"],t.data||[]),i=new tg(e,this);return i.initData(t.data),i},mergeOption:function(t){this._fillOption(t,this.getMapType()),By.superApply(this,"mergeOption",arguments),this.updateSelectedMap(this.option.data)},getHostGeoModel:function(){var t=this.option.geoIndex;return null!=t?this.dependentModels.geo[t]:null},getMapType:function(){return(this.getHostGeoModel()||this).option.map},_fillOption:function(t,e){t.data=Ry.getFilledRegions(t.data,e,t.nameMap)},getRawValue:function(t){return this.getData().get("value",t)},getRegionModel:function(t){var e=this.getData();return e.getItemModel(e.indexOfName(t))},formatTooltip:function(t){for(var e=this.getData(),i=Vy(this.getRawValue(t)),n=e.getName(t),a=this.seriesGroup,o=[],r=0;r<a.length;r++){var s=a[r].originalData.indexOfName(n);isNaN(a[r].originalData.get("value",s))||o.push(Ny(a[r].name))}return o.join(", ")+"<br />"+Ny(n+" : "+i)},getTooltipPosition:function(t){if(null!=t){var e=this.getData().getName(t),i=this.coordinateSystem,n=i.getRegion(e);return n&&i.dataToPoint(n.center)}},setZoom:function(t){this.option.zoom=t},setCenter:function(t){this.option.center=t},defaultOption:{zlevel:0,z:2,coordinateSystem:"geo",map:"",left:"center",top:"center",aspectScale:.75,showLegendSymbol:!0,dataRangeHoverLink:!0,boundingCoords:null,center:null,zoom:1,scaleLimit:null,label:{normal:{show:!1,color:"#000"},emphasis:{show:!0,color:"rgb(100,0,0)"}},itemStyle:{normal:{borderWidth:.5,borderColor:"#444",areaColor:"#eee"},emphasis:{areaColor:"rgba(255,215,0,0.8)"}}}});rl.mixin(By,Jv);var Gy="\0_ec_interaction_mutex";ym.registerAction({type:"takeGlobalCursor",event:"globalCursorTaken",update:"update"},function(){});var Hy={take:function(t,e,i){on(t)[e]=i},release:function(t,e,i){var n=on(t);n[e]===i&&(n[e]=null)},isTaken:function(t,e){return!!on(t)[e]}};rl.mixin(rn,dl);var Wy=rn,Fy={updateViewOnPan:function(t,e,i){var n=t.target,a=n.position;a[0]+=e,a[1]+=i,n.dirty()},updateViewOnZoom:function(t,e,i,n){var a=t.target,o=t.zoomLimit,r=a.position,s=a.scale,l=t.zoom=t.zoom||1;if(l*=e,o){var h=o.min||0,u=o.max||1/0;l=Math.max(Math.min(u,l),h)}var c=l/t.zoom;t.zoom=l,r[0]-=(i-r[0])*(c-1),r[1]-=(n-r[1])*(c-1),s[0]*=c,s[1]*=c,a.dirty()}},Zy={axisPointer:1,tooltip:1,brush:1},jy={onIrrelevantElement:function(t,e,i){var n=e.getComponentByElement(t.topTarget),a=n&&n.coordinateSystem;return n&&n!==i&&!Zy[n.mainType]&&a&&a.model!==i}},Uy=jy.onIrrelevantElement;cn.prototype={constructor:cn,draw:function(t,e,i,n,a){var o="geo"===t.mainType,r=t.getData&&t.getData();o&&e.eachComponent({mainType:"series",subType:"map"},function(e){r||e.getHostGeoModel()!==t||(r=e.getData())});var s=t.coordinateSystem,l=this.group,h=s.scale,u={position:s.position,scale:h};!l.childAt(0)||a?l.attr(u):fp.updateProps(l,u,t),l.removeAll();var c=["itemStyle","normal"],d=["itemStyle","emphasis"],p=["label","normal"],f=["label","emphasis"],g=rl.createHashMap();rl.each(s.regions,function(e){var i=g.get(e.name)||g.set(e.name,new fp.Group),n=new fp.CompoundPath({shape:{paths:[]}});i.add(n);var a,s=(C=t.getRegionModel(e.name)||t).getModel(c),u=C.getModel(d),m=hn(s),v=hn(u),y=C.getModel(p),x=C.getModel(f);if(r){a=r.indexOfName(e.name);var _=r.getItemVisual(a,"color",!0);_&&(m.fill=_)}rl.each(e.geometries,function(t){if("polygon"===t.type){n.shape.paths.push(new fp.Polygon({shape:{points:t.exterior}}));for(var e=0;e<(t.interiors?t.interiors.length:0);e++)n.shape.paths.push(new fp.Polygon({shape:{points:t.interiors[e]}}))}}),n.setStyle(m),n.style.strokeNoScale=!0,n.culling=!0;var b=y.get("show"),w=x.get("show"),S=r&&isNaN(r.get("value",a)),M=r&&r.getItemLayout(a);if(o||S&&(b||w)||M&&M.showLabel){var I,T=o?e.name:a;(!r||a>=0)&&(I=t);var A=new fp.Text({position:e.center.slice(),scale:[1/h[0],1/h[1]],z2:10,silent:!0});fp.setLabelStyle(A.style,A.hoverStyle={},y,x,{labelFetcher:I,labelDataIndex:T,defaultText:e.name,useInsideStyle:!1},{textAlign:"center",textVerticalAlign:"middle"}),i.add(A)}if(r)r.setItemGraphicEl(a,i);else{var C=t.getRegionModel(e.name);n.eventData={componentType:"geo",geoIndex:t.componentIndex,name:e.name,region:C&&C.option||{}}}(i.__regions||(i.__regions=[])).push(e),fp.setHoverStyle(i,v,{hoverSilentOnTouch:!!t.get("selectedMode")}),l.add(i)}),this._updateController(t,e,i),function(t,e,i,n,a){i.off("click"),i.off("mousedown"),e.get("selectedMode")&&(i.on("mousedown",function(){t._mouseDownFlag=!0}),i.on("click",function(o){if(t._mouseDownFlag){t._mouseDownFlag=!1;for(var r=o.target;!r.__regions;)r=r.parent;if(r){var s={type:("geo"===e.mainType?"geo":"map")+"ToggleSelect",batch:rl.map(r.__regions,function(t){return{name:t.name,from:a.uid}})};s[e.mainType+"Id"]=e.id,n.dispatchAction(s),un(e,i)}}}))}(this,t,l,i,n),un(t,l)},remove:function(){this.group.removeAll(),this._controller.dispose(),this._controllerHost={}},_updateController:function(t,e,i){function n(){var e={type:"geoRoam",componentType:s};return e[s+"Id"]=t.id,e}var a=t.coordinateSystem,o=this._controller,r=this._controllerHost;r.zoomLimit=t.get("scaleLimit"),r.zoom=a.getZoom(),o.enable(t.get("roam")||!1);var s=t.mainType;o.off("pan").on("pan",function(t,e){this._mouseDownFlag=!1,Fy.updateViewOnPan(r,t,e),i.dispatchAction(rl.extend(n(),{dx:t,dy:e}))},this),o.off("zoom").on("zoom",function(t,e,a){if(this._mouseDownFlag=!1,Fy.updateViewOnZoom(r,t,e,a),i.dispatchAction(rl.extend(n(),{zoom:t,originX:e,originY:a})),this._updateGroup){var o=this.group,s=o.scale;o.traverse(function(t){"text"===t.type&&t.attr("scale",[1/s[0],1/s[1]])})}},this),o.setPointerChecker(function(e,n,o){return a.getViewRectAfterRoam().contain(n,o)&&!Uy(e,i,t)})}};var qy=cn,Xy=(ym.extendChartView({type:"map",render:function(t,e,i,n){if(!n||"mapToggleSelect"!==n.type||n.from!==this.uid){var a=this.group;if(a.removeAll(),!t.getHostGeoModel()){if(n&&"geoRoam"===n.type&&"series"===n.componentType&&n.seriesId===t.id){(o=this._mapDraw)&&a.add(o.group)}else if(t.needsDrawMap){var o=this._mapDraw||new qy(i,!0);a.add(o.group),o.draw(t,e,i,this,n),this._mapDraw=o}else this._mapDraw&&this._mapDraw.remove(),this._mapDraw=null;t.get("showLegendSymbol")&&e.getComponent("legend")&&this._renderSymbols(t,e,i)}}},remove:function(){this._mapDraw&&this._mapDraw.remove(),this._mapDraw=null,this.group.removeAll()},dispose:function(){this._mapDraw&&this._mapDraw.remove(),this._mapDraw=null},_renderSymbols:function(t,e,i){var n=t.originalData,a=this.group;n.each("value",function(e,i){if(!isNaN(e)){var o=n.getItemLayout(i);if(o&&o.point){var r=o.point,s=o.offset,l=new fp.Circle({style:{fill:t.getData().getVisual("color")},shape:{cx:r[0]+9*s,cy:r[1],r:3},silent:!0,z2:s?8:10});if(!s){var h=t.mainSeries.getData(),u=n.getName(i),c=h.indexOfName(u),d=n.getItemModel(i),p=d.getModel("label.normal"),f=d.getModel("label.emphasis"),g=h.getItemGraphicEl(c),m=rl.retrieve2(t.getFormattedLabel(i,"normal"),u),v=rl.retrieve2(t.getFormattedLabel(i,"emphasis"),m),y=function(){var t=fp.setTextStyle({},f,{text:f.get("show")?v:null},{isRectText:!0,useInsideStyle:!1},!0);l.style.extendFrom(t),l.__mapOriginalZ2=l.z2,l.z2+=1},x=function(){fp.setTextStyle(l.style,p,{text:p.get("show")?m:null,textPosition:p.getShallow("position")||"bottom"},{isRectText:!0,useInsideStyle:!1}),null!=l.__mapOriginalZ2&&(l.z2=l.__mapOriginalZ2,l.__mapOriginalZ2=null)};g.on("mouseover",y).on("mouseout",x).on("emphasis",y).on("normal",x),x()}a.add(l)}}})}}),{updateCenterAndZoom:function(t,e,i){var n=t.getZoom(),a=t.getCenter(),o=e.zoom,r=t.dataToPoint(a);null!=e.dx&&null!=e.dy&&(r[0]-=e.dx,r[1]-=e.dy,a=t.pointToData(r),t.setCenter(a));if(null!=o){if(i){var s=i.min||0,l=i.max||1/0;o=Math.max(Math.min(n*o,l),s)/n}t.scale[0]*=o,t.scale[1]*=o;var h=t.position,u=(e.originX-h[0])*(o-1),c=(e.originY-h[1])*(o-1);h[0]-=u,h[1]-=c,t.updateTransform(),a=t.pointToData(r),t.setCenter(a),t.setZoom(o*n)}return{center:t.getCenter(),zoom:t.getZoom()}}}),Yy=Xy.updateCenterAndZoom;ym.registerAction({type:"geoRoam",event:"geoRoam",update:"updateLayout"},function(t,e){var i=t.componentType||"series";e.eachComponent({mainType:i,query:t},function(e){var n=e.coordinateSystem;if("geo"===n.type){var a=Yy(n,t,e.get("scaleLimit"));e.setCenter&&e.setCenter(a.center),e.setZoom&&e.setZoom(a.zoom),"series"===i&&rl.each(e.seriesGroup,function(t){t.setCenter(a.center),t.setZoom(a.zoom)})}})});var $y=function(t){var e={};t.eachSeriesByType("map",function(i){var n=i.getMapType();if(!i.getHostGeoModel()&&!e[n]){var a={};rl.each(i.seriesGroup,function(e){var i=e.coordinateSystem,n=e.originalData;e.get("showLegendSymbol")&&t.getComponent("legend")&&n.each("value",function(t,e){var o=n.getName(e),r=i.getRegion(o);if(r&&!isNaN(t)){var s=a[o]||0,l=i.dataToPoint(r.center);a[o]=s+1,n.setItemLayout(e,{point:l,offset:s})}})});var o=i.getData();o.each(function(t){var e=o.getName(t),i=o.getItemLayout(t)||{};i.showLabel=!a[e],o.setItemLayout(t,i)}),e[n]=!0}})},Ky=function(t){t.eachSeriesByType("map",function(t){var e=t.get("color"),i=t.getModel("itemStyle.normal"),n=i.get("areaColor"),a=i.get("color")||e[t.seriesIndex%e.length];t.getData().setVisual({areaColor:n,color:a})})},Jy=function(t){var e={};t.eachSeriesByType("map",function(t){var i=t.getHostGeoModel(),n=i?"o"+i.id:"i"+t.getMapType();(e[n]=e[n]||[]).push(t)}),rl.each(e,function(t,e){for(var i=function(t,e){var i={},n=["value"];return rl.each(t,function(t){t.each(n,function(e,n){var a="ec-"+t.getName(n);i[a]=i[a]||[],isNaN(e)||i[a].push(e)})}),t[0].map(n,function(n,a){for(var o="ec-"+t[0].getName(a),r=0,s=1/0,l=-1/0,h=i[o].length,u=0;u<h;u++)s=Math.min(s,i[o][u]),l=Math.max(l,i[o][u]),r+=i[o][u];var c;return c="min"===e?s:"max"===e?l:"average"===e?r/h:r,0===h?NaN:c})}(rl.map(t,function(t){return t.getData()}),t[0].get("mapValueCalculation")),n=0;n<t.length;n++)t[n].originalData=t[n].getData();for(n=0;n<t.length;n++)t[n].seriesGroup=t,t[n].needsDrawMap=0===n&&!t[n].getHostGeoModel(),t[n].setData(i.cloneShallow()),t[n].mainSeries=t[0]})},Qy=function(t){var e=[];rl.each(t.series,function(t){t&&"map"===t.type&&(e.push(t),t.map=t.map||t.mapType,rl.defaults(t,t.mapLocation))})};ym.registerLayout($y),ym.registerVisual(Ky),ym.registerProcessor(ym.PRIORITY.PROCESSOR.STATISTIC,Jy),ym.registerPreprocessor(Qy),iy("map",[{type:"mapToggleSelect",event:"mapselectchanged",method:"toggleSelected"},{type:"mapSelect",event:"mapselected",method:"select"},{type:"mapUnSelect",event:"mapunselected",method:"unSelect"}]);var tx=rl.each,ex="\0__link_datas",ix="\0__link_mainData",nx=function(t){var e=t.mainData,i=t.datas;i||(i={main:e},t.datasAttr={main:"data"}),t.datas=t.mainData=null,dn(e,i,t),tx(i,function(i){tx(e.TRANSFERABLE_METHODS,function(e){i.wrapMethod(e,rl.curry(function(t,e){if(function(t){return t[ix]===t}(this)){var i=rl.extend({},this[ex]);i[this.dataType]=e,dn(e,i,t)}else pn(e,this.dataType,this[ix],t);return e},t))})}),e.wrapMethod("cloneShallow",rl.curry(function(t,e){return tx(e[ex],function(i,n){i!==e&&pn(i.cloneShallow(),n,e,t)}),e},t)),tx(e.CHANGABLE_METHODS,function(i){e.wrapMethod(i,rl.curry(function(t,e){return t.struct&&t.struct.update(this),e},t))}),rl.assert(i[e.dataType]===e)},ax=function(t,e){this.name=t||"",this.depth=0,this.height=0,this.parentNode=null,this.dataIndex=-1,this.children=[],this.viewChildren=[],this.hostTree=e};ax.prototype={constructor:ax,isRemoved:function(){return this.dataIndex<0},eachNode:function(t,e,i){"function"==typeof t&&(i=e,e=t,t=null),t=t||{},rl.isString(t)&&(t={order:t});var n,a=t.order||"preorder",o=this[t.attr||"children"];"preorder"===a&&(n=e.call(i,this));for(var r=0;!n&&r<o.length;r++)o[r].eachNode(t,e,i);"postorder"===a&&e.call(i,this)},updateDepthAndHeight:function(t){var e=0;this.depth=t;for(var i=0;i<this.children.length;i++){var n=this.children[i];n.updateDepthAndHeight(t+1),n.height>e&&(e=n.height)}this.height=e+1},getNodeById:function(t){if(this.getId()===t)return this;for(var e=0,i=this.children,n=i.length;e<n;e++){var a=i[e].getNodeById(t);if(a)return a}},contains:function(t){if(t===this)return!0;for(var e=0,i=this.children,n=i.length;e<n;e++){var a=i[e].contains(t);if(a)return a}},getAncestors:function(t){for(var e=[],i=t?this:this.parentNode;i;)e.push(i),i=i.parentNode;return e.reverse(),e},getValue:function(t){var e=this.hostTree.data;return e.get(e.getDimension(t||"value"),this.dataIndex)},setLayout:function(t,e){this.dataIndex>=0&&this.hostTree.data.setItemLayout(this.dataIndex,t,e)},getLayout:function(){return this.hostTree.data.getItemLayout(this.dataIndex)},getModel:function(t){if(!(this.dataIndex<0)){var e,i=this.hostTree,n=i.data.getItemModel(this.dataIndex),a=this.getLevelModel();return a||0!==this.children.length&&(0===this.children.length||!1!==this.isExpand)||(e=this.getLeavesModel()),n.getModel(t,(a||e||i.hostModel).getModel(t))}},getLevelModel:function(){return(this.hostTree.levelModels||[])[this.depth]},getLeavesModel:function(){return this.hostTree.leavesModel},setVisual:function(t,e){this.dataIndex>=0&&this.hostTree.data.setItemVisual(this.dataIndex,t,e)},getVisual:function(t,e){return this.hostTree.data.getItemVisual(this.dataIndex,t,e)},getRawIndex:function(){return this.hostTree.data.getRawIndex(this.dataIndex)},getId:function(){return this.hostTree.data.getId(this.dataIndex)}},fn.prototype={constructor:fn,type:"tree",eachNode:function(t,e,i){this.root.eachNode(t,e,i)},getNodeByDataIndex:function(t){var e=this.data.getRawIndex(t);return this._nodes[e]},getNodeByName:function(t){return this.root.getNodeByName(t)},update:function(){for(var t=this.data,e=this._nodes,i=0,n=e.length;i<n;i++)e[i].dataIndex=-1;for(var i=0,n=t.count();i<n;i++)e[t.getRawIndex(i)].dataIndex=i},clearLayouts:function(){this.data.clearItemLayouts()}},fn.createTree=function(t,e,i){function n(t,e){var i=t.value;r=Math.max(r,rl.isArray(i)?i.length:1),o.push(t);var s=new ax(t.name,a);e?function(t,e){var i=e.children;t.parentNode!==e&&(i.push(t),t.parentNode=e)}(s,e):a.root=s,a._nodes.push(s);var l=t.children;if(l)for(var h=0;h<l.length;h++)n(l[h],s)}var a=new fn(e,i.levels,i.leaves),o=[],r=1;n(t),a.root.updateDepthAndHeight(0);var s=sg([{name:"value"}],o,{dimCount:r}),l=new tg(s,e);return l.initData(o),nx({mainData:l,struct:a,structAttr:"tree"}),a.update(),a};var ox=fn,rx=Eu.encodeHTML,sx=(zf.extend({type:"series.tree",layoutInfo:null,layoutMode:"box",getInitialData:function(t){var e={name:t.name,children:t.data},i=t.leaves||{},n={};n.leaves=i;var a=ox.createTree(e,this,n),o=0;a.eachNode("preorder",function(t){t.depth>o&&(o=t.depth)});var r=t.expandAndCollapse&&t.initialTreeDepth>=0?t.initialTreeDepth:o;return a.root.eachNode("preorder",function(t){var e=t.hostTree.data.getRawDataItem(t.dataIndex);t.isExpand=e&&null!=e.collapsed?!e.collapsed:t.depth<=r}),a.data},formatTooltip:function(t){for(var e=this.getData().tree,i=e.root.children[0],n=e.getNodeByDataIndex(t),a=n.getValue(),o=n.name;n&&n!==i;)o=n.parentNode.name+"."+o,n=n.parentNode;return rx(o+(isNaN(a)||null==a?"":" : "+a))},defaultOption:{zlevel:0,z:2,left:"12%",top:"12%",right:"12%",bottom:"12%",layout:"orthogonal",orient:"horizontal",symbol:"emptyCircle",symbolSize:7,expandAndCollapse:!0,initialTreeDepth:2,lineStyle:{normal:{color:"#ccc",width:1.5,curveness:.5}},itemStyle:{normal:{color:"lightsteelblue",borderColor:"#c23531",borderWidth:1.5}},label:{normal:{show:!0,color:"#555"}},leaves:{label:{normal:{show:!0}}},animationEasing:"linear",animationDuration:700,animationDurationUpdate:1e3}}),{init:function(t){t.hierNode={defaultAncestor:null,ancestor:t,prelim:0,modifier:0,change:0,shift:0,i:0,thread:null};for(var e,i,n=[t];e=n.pop();)if(i=e.children,e.isExpand&&i.length)for(var a=i.length-1;a>=0;a--){var o=i[a];o.hierNode={defaultAncestor:null,ancestor:o,prelim:0,modifier:0,change:0,shift:0,i:a,thread:null},n.push(o)}},firstWalk:function(t,e){var i=t.isExpand?t.children:[],n=t.parentNode.children,a=t.hierNode.i?n[t.hierNode.i-1]:null;if(i.length){!function(t){for(var e=t.children,i=e.length,n=0,a=0;--i>=0;){var o=e[i];o.hierNode.prelim+=n,o.hierNode.modifier+=n,a+=o.hierNode.change,n+=o.hierNode.shift+a}}(t);var o=(i[0].hierNode.prelim+i[i.length-1].hierNode.prelim)/2;a?(t.hierNode.prelim=a.hierNode.prelim+e(t,a),t.hierNode.modifier=t.hierNode.prelim-o):t.hierNode.prelim=o}else a&&(t.hierNode.prelim=a.hierNode.prelim+e(t,a));t.parentNode.hierNode.defaultAncestor=function(t,e,i,n){if(e){for(var a=t,o=t,r=o.parentNode.children[0],s=e,l=a.hierNode.modifier,h=o.hierNode.modifier,u=r.hierNode.modifier,c=s.hierNode.modifier;s=gn(s),o=mn(o),s&&o;){a=gn(a),r=mn(r),a.hierNode.ancestor=t;var d=s.hierNode.prelim+c-o.hierNode.prelim-h+n(s,o);d>0&&(function(t,e,i){var n=i/(e.hierNode.i-t.hierNode.i);e.hierNode.change-=n,e.hierNode.shift+=i,e.hierNode.modifier+=i,e.hierNode.prelim+=i,t.hierNode.change+=n}(function(t,e,i){return t.hierNode.ancestor.parentNode===e.parentNode?t.hierNode.ancestor:i}(s,t,i),t,d),h+=d,l+=d),c+=s.hierNode.modifier,h+=o.hierNode.modifier,l+=a.hierNode.modifier,u+=r.hierNode.modifier}s&&!gn(a)&&(a.hierNode.thread=s,a.hierNode.modifier+=c-l),o&&!mn(r)&&(r.hierNode.thread=o,r.hierNode.modifier+=h-u,i=t)}return i}(t,a,t.parentNode.hierNode.defaultAncestor||n[0],e)},secondWalk:function(t){var e=t.hierNode.prelim+t.parentNode.hierNode.modifier;t.setLayout({x:e},!0),t.hierNode.modifier+=t.parentNode.hierNode.modifier},separation:function(t){return arguments.length?t:function(t,e){return t.parentNode===e.parentNode?1:2}},radialCoordinate:function(t,e){var i={};return t-=Math.PI/2,i.x=e*Math.cos(t),i.y=e*Math.sin(t),i},getViewRect:function(t,e){return Np.getLayoutRect(t.getBoxLayoutParams(),{width:e.getWidth(),height:e.getHeight()})}}),lx=sx.radialCoordinate;ym.extendChartView({type:"tree",init:function(t,e){this._oldTree,this._mainGroup=new fp.Group,this.group.add(this._mainGroup)},render:function(t,e,i,n){var a=t.getData(),o=t.layoutInfo,r=this._mainGroup,s=t.get("layout");"radial"===s?r.attr("position",[o.x+o.width/2,o.y+o.height/2]):r.attr("position",[o.x,o.y]);var l=this._data,h={expandAndCollapse:t.get("expandAndCollapse"),layout:s,orient:t.get("orient"),curvature:t.get("lineStyle.normal.curveness"),symbolRotate:t.get("symbolRotate"),symbolOffset:t.get("symbolOffset"),hoverAnimation:t.get("hoverAnimation"),useNameLabel:!0,fadeIn:!0};a.diff(l).add(function(e){vn(a,e)&&xn(a,e,null,r,t,h)}).update(function(e,i){var n=l.getItemGraphicEl(i);vn(a,e)?xn(a,e,n,r,t,h):n&&_n(a,e,n,r,t,h)}).remove(function(e){var i=l.getItemGraphicEl(e);_n(a,e,i,r,t,h)}).execute(),!0===h.expandAndCollapse&&a.eachItemGraphicEl(function(e,n){e.off("click").on("click",function(){i.dispatchAction({type:"treeExpandAndCollapse",seriesId:t.id,dataIndex:n})})}),this._data=a},dispose:function(){},remove:function(){this._mainGroup.removeAll(),this._data=null}});ym.registerAction({type:"treeExpandAndCollapse",event:"treeExpandAndCollapse",update:"update"},function(t,e){e.eachComponent({mainType:"series",subType:"tree",query:t},function(e){var i=t.dataIndex,n=e.getData().tree.getNodeByDataIndex(i);n.isExpand=!n.isExpand})});var hx={eachAfter:function(t,e,i){for(var n,a=[t],o=[];n=a.pop();)if(o.push(n),n.isExpand){var r=n.children;if(r.length)for(var s=0;s<r.length;s++)a.push(r[s])}for(;n=o.pop();)e(n,i)},eachBefore:function(t,e){for(var i,n=[t];i=n.pop();)if(e(i),i.isExpand){var a=i.children;if(a.length)for(var o=a.length-1;o>=0;o--)n.push(a[o])}}},ux=hx.eachAfter,cx=hx.eachBefore,dx=sx.init,px=sx.firstWalk,fx=sx.secondWalk,gx=sx.separation,mx=sx.radialCoordinate,vx=sx.getViewRect,yx=function(t,e){var i=vx(t,e);t.layoutInfo=i;var n=t.get("layout"),a=0,o=0,r=null;"radial"===n?(a=2*Math.PI,o=Math.min(i.height,i.width)/2,r=gx(function(t,e){return(t.parentNode===e.parentNode?1:2)/t.depth})):(a=i.width,o=i.height,r=gx());var s=t.getData().tree.root,l=s.children[0];dx(s),ux(l,px,r),s.hierNode.modifier=-l.hierNode.prelim,cx(l,fx);var h=l,u=l,c=l;cx(l,function(t){var e=t.getLayout().x;e<h.getLayout().x&&(h=t),e>u.getLayout().x&&(u=t),t.depth>c.depth&&(c=t)});var d=h===u?1:r(h,u)/2,p=d-h.getLayout().x,f=0,g=0,m=0,v=0;"radial"===n?(f=a/(u.getLayout().x+d+p),g=o/(c.depth-1||1),cx(l,function(t){m=(t.getLayout().x+p)*f,v=(t.depth-1)*g;var e=mx(m,v);t.setLayout({x:e.x,y:e.y,rawX:m,rawY:v},!0)})):"horizontal"===t.get("orient")?(g=o/(u.getLayout().x+d+p),f=a/(c.depth-1||1),cx(l,function(t){v=(t.getLayout().x+p)*g,m=(t.depth-1)*f,t.setLayout({x:m,y:v},!0)})):(f=a/(u.getLayout().x+d+p),g=o/(c.depth-1||1),cx(l,function(t){m=(t.getLayout().x+p)*f,v=(t.depth-1)*g,t.setLayout({x:m,y:v},!0)}))},xx=function(t,e){t.eachSeriesByType("tree",function(t){yx(t,e)})},_x=function(t,e){t.eachSeriesByType("tree",function(t){yx(t,e)})};ym.registerVisual(rl.curry(Fm,"tree","circle",null)),ym.registerLayout(xx),ym.registerLayout(_x);var bx={retrieveTargetInfo:function(t,e){if(t&&("treemapZoomToNode"===t.type||"treemapRootToNode"===t.type)){var i=e.getData().tree.root,n=t.targetNode;if(n&&i.contains(n))return{node:n};var a=t.targetNodeId;if(null!=a&&(n=i.getNodeById(a)))return{node:n}}},getPathToRoot:wn,aboveViewRoot:function(t,e){var i=wn(t);return rl.indexOf(i,e)>=0},wrapTreePathInfo:function(t,e){for(var i=[];t;){var n=t.dataIndex;i.push({name:t.name,dataIndex:n,value:e.getRawValue(n)}),t=t.parentNode}return i.reverse(),i}},wx=Eu.encodeHTML,Sx=Eu.addCommas,Mx=bx.wrapTreePathInfo,Ix=(zf.extend({type:"series.treemap",layoutMode:"box",dependencies:["grid","polar"],_viewRoot:null,defaultOption:{progressive:0,hoverLayerThreshold:1/0,left:"center",top:"middle",right:null,bottom:null,width:"80%",height:"80%",sort:!0,clipWindow:"origin",squareRatio:.5*(1+Math.sqrt(5)),leafDepth:null,drillDownIcon:"▶",zoomToNodeRatio:.1024,roam:!0,nodeClick:"zoomToNode",animation:!0,animationDurationUpdate:900,animationEasing:"quinticInOut",breadcrumb:{show:!0,height:22,left:"center",top:"bottom",emptyItemWidth:25,itemStyle:{normal:{color:"rgba(0,0,0,0.7)",borderColor:"rgba(255,255,255,0.7)",borderWidth:1,shadowColor:"rgba(150,150,150,1)",shadowBlur:3,shadowOffsetX:0,shadowOffsetY:0,textStyle:{color:"#fff"}},emphasis:{textStyle:{}}}},label:{normal:{show:!0,distance:0,padding:5,position:"inside",color:"#fff",ellipsis:!0}},upperLabel:{normal:{show:!1,position:[0,"50%"],height:20,color:"#fff",ellipsis:!0,verticalAlign:"middle"},emphasis:{show:!0,position:[0,"50%"],color:"#fff",ellipsis:!0,verticalAlign:"middle"}},itemStyle:{normal:{color:null,colorAlpha:null,colorSaturation:null,borderWidth:0,gapWidth:0,borderColor:"#fff",borderColorSaturation:null},emphasis:{}},visualDimension:0,visualMin:null,visualMax:null,color:[],colorAlpha:null,colorSaturation:null,colorMappingBy:"index",visibleMin:10,childrenVisibleMin:null,levels:[]},getInitialData:function(t,e){var i={name:t.name,children:t.data};Sn(i);var n=t.levels||[];n=t.levels=function(t,e){var i=e.get("color");if(i){t=t||[];var n;return rl.each(t,function(t){var e=new _p(t),i=e.get("color");(e.get("itemStyle.normal.color")||i&&"none"!==i)&&(n=!0)}),n||((t[0]||(t[0]={})).color=i.slice()),t}}(n,e);var a={};return a.levels=n,ox.createTree(i,this,a).data},optionUpdated:function(){this.resetViewRoot()},formatTooltip:function(t){var e=this.getData(),i=this.getRawValue(t),n=Sx(rl.isArray(i)?i[0]:i),a=e.getName(t);return wx(a+": "+n)},getDataParams:function(t){var e=zf.prototype.getDataParams.apply(this,arguments),i=this.getData().tree.getNodeByDataIndex(t);return e.treePathInfo=Mx(i,this),e},setLayoutInfo:function(t){this.layoutInfo=this.layoutInfo||{},rl.extend(this.layoutInfo,t)},mapIdToIndex:function(t){var e=this._idIndexMap;e||(e=this._idIndexMap=rl.createHashMap(),this._idIndexMapCount=0);var i=e.get(t);return null==i&&e.set(t,i=this._idIndexMapCount++),i},getViewRoot:function(){return this._viewRoot},resetViewRoot:function(t){t?this._viewRoot=t:t=this._viewRoot;var e=this.getData().tree.root;t&&(t===e||e.contains(t))||(this._viewRoot=e)}}),bx.wrapTreePathInfo),Tx=5;Mn.prototype={constructor:Mn,render:function(t,e,i,n){var a=t.getModel("breadcrumb"),o=this.group;if(o.removeAll(),a.get("show")&&i){var r=a.getModel("itemStyle.normal"),s=r.getModel("textStyle"),l={pos:{left:a.get("left"),right:a.get("right"),top:a.get("top"),bottom:a.get("bottom")},box:{width:e.getWidth(),height:e.getHeight()},emptyItemWidth:a.get("emptyItemWidth"),totalWidth:0,renderList:[]};this._prepare(i,l,s),this._renderContent(t,l,r,s,n),Np.positionElement(o,l.pos,l.box)}},_prepare:function(t,e,i){for(var n=t;n;n=n.parentNode){var a=n.getModel().get("name"),o=i.getTextRect(a),r=Math.max(o.width+16,e.emptyItemWidth);e.totalWidth+=r+8,e.renderList.push({node:n,text:a,width:r})}},_renderContent:function(t,e,i,n,a){for(var o=0,r=e.emptyItemWidth,s=t.get("breadcrumb.height"),l=Np.getAvailableSize(e.pos,e.box),h=e.totalWidth,u=e.renderList,c=u.length-1;c>=0;c--){var d=u[c],p=d.node,f=d.width,g=d.text;h>l.width&&(h-=f-r,f=r,g=null);var m=new fp.Polygon({shape:{points:function(t,e,i,n,a,o){var r=[[a?t:t-Tx,e],[t+i,e],[t+i,e+n],[a?t:t-Tx,e+n]];return!o&&r.splice(2,0,[t+i+Tx,e+n/2]),!a&&r.push([t,e+n/2]),r}(o,0,f,s,c===u.length-1,0===c)},style:rl.defaults(i.getItemStyle(),{lineJoin:"bevel",text:g,textFill:n.getTextColor(),textFont:n.getFont()}),z:10,onclick:rl.curry(a,p)});this.group.add(m),function(t,e,i){t.eventData={componentType:"series",componentSubType:"treemap",seriesIndex:e.componentIndex,seriesName:e.name,seriesType:"treemap",selfType:"breadcrumb",nodeData:{dataIndex:i&&i.dataIndex,name:i&&i.name},treePathInfo:i&&Ix(i,e)}}(m,t,p),o+=f+8}},remove:function(){this.group.removeAll()}};for(var Ax=Mn,Cx={createWrap:function(){var t,e=[],i={};return{add:function(t,n,a,o,r){return rl.isString(o)&&(r=o,o=0),!i[t.id]&&(i[t.id]=1,e.push({el:t,target:n,time:a,delay:o,easing:r}),!0)},done:function(e){return t=e,this},start:function(){for(var n=e.length,a=0,o=e.length;a<o;a++){var r=e[a];r.el.animateTo(r.target,r.time,r.delay,r.easing,function(){--n||(e.length=0,i={},t&&t())})}return this}}}},Lx=rl.bind,Dx=fp.Group,Px=fp.Rect,kx=rl.each,Ox=["label","normal"],zx=["label","emphasis"],Ex=["upperLabel","normal"],Rx=["upperLabel","emphasis"],Nx=10,Vx=1,Bx=2,Gx=Gu([["fill","color"],["stroke","strokeColor"],["lineWidth","strokeWidth"],["shadowBlur"],["shadowOffsetX"],["shadowOffsetY"],["shadowColor"]]),Hx=function(t){var e=Gx(t);return e.stroke=e.fill=e.lineWidth=null,e},Wx=(ym.extendChartView({type:"treemap",init:function(t,e){this._containerGroup,this._storage={nodeGroup:[],background:[],content:[]},this._oldTree,this._breadcrumb,this._controller,this._state="ready"},render:function(t,e,i,n){var a=e.findComponents({mainType:"series",subType:"treemap",query:n});if(!(rl.indexOf(a,t)<0)){this.seriesModel=t,this.api=i,this.ecModel=e;var o=bx.retrieveTargetInfo(n,t),r=n&&n.type,s=t.layoutInfo,l=!this._oldTree,h=this._storage,u="treemapRootToNode"===r&&o&&h?{rootNodeGroup:h.nodeGroup[o.node.getRawIndex()],direction:n.direction}:null,c=this._giveContainerGroup(s),d=this._doRender(c,t,u);l||r&&"treemapZoomToNode"!==r&&"treemapRootToNode"!==r?d.renderFinally():this._doAnimation(c,d,t,u),this._resetController(i),this._renderBreadcrumb(t,i,o)}},_giveContainerGroup:function(t){var e=this._containerGroup;return e||(e=this._containerGroup=new Dx,this._initEvents(e),this.group.add(e)),e.attr("position",[t.x,t.y]),e},_doRender:function(t,e,i){function n(t,e,i,a,o){function r(t){return t.getId()}function s(r,s){var l=null!=r?t[r]:null,h=null!=s?e[s]:null,c=u(l,h,i,o);c&&n(l&&l.viewChildren||[],h&&h.viewChildren||[],c,a,o+1)}a?(e=t,kx(t,function(t,e){!t.isRemoved()&&s(e,e)})):new qf(e,t,r,r).add(s).update(s).remove(rl.curry(s,null)).execute()}var a=e.getData().tree,o=this._oldTree,r={nodeGroup:[],background:[],content:[]},s={nodeGroup:[],background:[],content:[]},l=this._storage,h=[],u=rl.curry(function(t,e,i,n,a,o,r,s,l,h){function u(t,e){v?!t.invisible&&o.push(t):(e(),t.__tmWillVisible||(t.invisible=!1))}function c(e,i,n,a,o,s){var l=r.getModel(),h=rl.retrieve(t.getFormattedLabel(r.dataIndex,"normal",null,null,s?"upperLabel":"label"),l.get("name"));if(!s&&p.isLeafRoot){var u=t.get("drillDownIcon",!0);h=u?u+" "+h:h}var c=l.getModel(s?Ex:Ox),d=l.getModel(s?Rx:zx),f=c.getShallow("show");fp.setLabelStyle(e,i,c,d,{defaultText:f?h:null,autoColor:n,isRectText:!0}),s&&(e.textRect=rl.clone(s)),e.truncate=f&&c.get("ellipsis")?{outerWidth:a,outerHeight:o,minChar:2}:null}function d(t,o,s,l){var h=null!=x&&i[t][x],u=a[t];return h?(i[t][x]=null,function(t,e,i){(t[y]={}).old="nodeGroup"===i?e.position.slice():rl.extend({},e.shape)}(u,h,t)):v||((h=new o({z:function(t,e){var i=t*Nx+l;return(i-1)/i}(s)})).__tmDepth=s,h.__tmStorageName=t,function(t,e,i){var o=t[y]={},s=r.parentNode;if(s&&(!n||"drillDown"===n.direction)){var l=0,h=0,u=a.background[s.getRawIndex()];!n&&u&&u.old&&(l=u.old.width,h=u.old.height),o.old="nodeGroup"===i?[0,h]:{x:l,y:h,width:0,height:0}}o.fadein="nodeGroup"!==i}(u,0,t)),e[t][y]=h}if(r){var p=r.getLayout();if(p&&p.isInView){var f=p.width,g=p.height,m=p.borderWidth,v=p.invisible,y=r.getRawIndex(),x=s&&s.getRawIndex(),_=r.viewChildren,b=p.upperHeight,w=_&&_.length,S=r.getModel("itemStyle.normal"),M=r.getModel("itemStyle.emphasis"),I=d("nodeGroup",Dx);if(I){if(l.add(I),I.attr("position",[p.x||0,p.y||0]),I.__tmNodeWidth=f,I.__tmNodeHeight=g,p.isAboveViewRoot)return I;var T=d("background",Px,h,Vx);if(T&&function(e,i,n){i.dataIndex=r.dataIndex,i.seriesIndex=t.seriesIndex,i.setShape({x:0,y:0,width:f,height:g});var a=r.getVisual("borderColor",!0),o=M.get("borderColor");u(i,function(){var t=Hx(S);t.fill=a;var e=Gx(M);if(e.fill=o,n){var r=f-2*m;c(t,e,a,r,b,{x:m,y:0,width:r,height:b})}else t.text=e.text=null;i.setStyle(t),fp.setHoverStyle(i,e)}),e.add(i)}(I,T,w&&p.upperHeight),!w){var A=d("content",Px,h,Bx);A&&function(e,i){i.dataIndex=r.dataIndex,i.seriesIndex=t.seriesIndex;var n=Math.max(f-2*m,0),a=Math.max(g-2*m,0);i.culling=!0,i.setShape({x:m,y:m,width:n,height:a});var o=r.getVisual("color",!0);u(i,function(){var t=Hx(S);t.fill=o;var e=Gx(M);c(t,e,o,n,a),i.setStyle(t),fp.setHoverStyle(i,e)}),e.add(i)}(I,A)}return I}}}},e,s,l,i,r,h);n(a.root?[a.root]:[],o&&o.root?[o.root]:[],t,a===o||!o,0);var c=function(t){var e={nodeGroup:[],background:[],content:[]};return t&&kx(t,function(t,i){var n=e[i];kx(t,function(t){t&&(n.push(t),t.__tmWillDelete=1)})}),e}(l);return this._oldTree=a,this._storage=s,{lastsForAnimation:r,willDeleteEls:c,renderFinally:function(){kx(c,function(t){kx(t,function(t){t.parent&&t.parent.remove(t)})}),kx(h,function(t){t.invisible=!0,t.dirty()})}}},_doAnimation:function(t,e,i,n){if(i.get("animation")){var a=i.get("animationDurationUpdate"),o=i.get("animationEasing"),r=Cx.createWrap();kx(e.willDeleteEls,function(t,e){kx(t,function(t,i){if(!t.invisible){var s,l=t.parent;if(n&&"drillDown"===n.direction)s=l===n.rootNodeGroup?{shape:{x:0,y:0,width:l.__tmNodeWidth,height:l.__tmNodeHeight},style:{opacity:0}}:{style:{opacity:0}};else{var h=0,u=0;l.__tmWillDelete||(h=l.__tmNodeWidth/2,u=l.__tmNodeHeight/2),s="nodeGroup"===e?{position:[h,u],style:{opacity:0}}:{shape:{x:h,y:u,width:0,height:0},style:{opacity:0}}}s&&r.add(t,s,a,o)}})}),kx(this._storage,function(t,i){kx(t,function(t,n){var s=e.lastsForAnimation[i][n],l={};s&&("nodeGroup"===i?s.old&&(l.position=t.position.slice(),t.attr("position",s.old)):(s.old&&(l.shape=rl.extend({},t.shape),t.setShape(s.old)),s.fadein?(t.setStyle("opacity",0),l.style={opacity:1}):1!==t.style.opacity&&(l.style={opacity:1})),r.add(t,l,a,o))})},this),this._state="animating",r.done(Lx(function(){this._state="ready",e.renderFinally()},this)).start()}},_resetController:function(t){var e=this._controller;e||((e=this._controller=new Wy(t.getZr())).enable(this.seriesModel.get("roam")),e.on("pan",Lx(this._onPan,this)),e.on("zoom",Lx(this._onZoom,this)));var i=new oh(0,0,t.getWidth(),t.getHeight());e.setPointerChecker(function(t,e,n){return i.contain(e,n)})},_clearController:function(){var t=this._controller;t&&(t.dispose(),t=null)},_onPan:function(t,e){if("animating"!==this._state&&(Math.abs(t)>3||Math.abs(e)>3)){var i=this.seriesModel.getData().tree.root;if(!i)return;var n=i.getLayout();if(!n)return;this.api.dispatchAction({type:"treemapMove",from:this.uid,seriesId:this.seriesModel.id,rootRect:{x:n.x+t,y:n.y+e,width:n.width,height:n.height}})}},_onZoom:function(t,e,i){if("animating"!==this._state){var n=this.seriesModel.getData().tree.root;if(!n)return;var a=n.getLayout();if(!a)return;var o=new oh(a.x,a.y,a.width,a.height),r=this.seriesModel.layoutInfo;e-=r.x,i-=r.y;var s=yl.create();yl.translate(s,s,[-e,-i]),yl.scale(s,s,[t,t]),yl.translate(s,s,[e,i]),o.applyTransform(s),this.api.dispatchAction({type:"treemapRender",from:this.uid,seriesId:this.seriesModel.id,rootRect:{x:o.x,y:o.y,width:o.width,height:o.height}})}},_initEvents:function(t){t.on("click",function(t){if("ready"===this._state){var e=this.seriesModel.get("nodeClick",!0);if(e){var i=this.findTarget(t.offsetX,t.offsetY);if(i){var n=i.node;if(n.getLayout().isLeafRoot)this._rootToNode(i);else if("zoomToNode"===e)this._zoomToNode(i);else if("link"===e){var a=n.hostTree.data.getItemModel(n.dataIndex),o=a.get("link",!0),r=a.get("target",!0)||"blank";o&&window.open(o,r)}}}}},this)},_renderBreadcrumb:function(t,e,i){i||(i=null!=t.get("leafDepth",!0)?{node:t.getViewRoot()}:this.findTarget(e.getWidth()/2,e.getHeight()/2))||(i={node:t.getData().tree.root}),(this._breadcrumb||(this._breadcrumb=new Ax(this.group))).render(t,e,i.node,Lx(function(e){"animating"!==this._state&&(bx.aboveViewRoot(t.getViewRoot(),e)?this._rootToNode({node:e}):this._zoomToNode({node:e}))},this))},remove:function(){this._clearController(),this._containerGroup&&this._containerGroup.removeAll(),this._storage={nodeGroup:[],background:[],content:[]},this._state="ready",this._breadcrumb&&this._breadcrumb.remove()},dispose:function(){this._clearController()},_zoomToNode:function(t){this.api.dispatchAction({type:"treemapZoomToNode",from:this.uid,seriesId:this.seriesModel.id,targetNode:t.node})},_rootToNode:function(t){this.api.dispatchAction({type:"treemapRootToNode",from:this.uid,seriesId:this.seriesModel.id,targetNode:t.node})},findTarget:function(t,e){var i;return this.seriesModel.getViewRoot().eachNode({attr:"viewChildren",order:"preorder"},function(n){var a=this._storage.background[n.getRawIndex()];if(a){var o=a.transformCoordToLocal(t,e),r=a.shape;if(!(r.x<=o[0]&&o[0]<=r.x+r.width&&r.y<=o[1]&&o[1]<=r.y+r.height))return!1;i={node:n,offsetX:o[0],offsetY:o[1]}}},this),i}}),["treemapZoomToNode","treemapRender","treemapMove"]),Fx=0;Fx<Wx.length;Fx++)ym.registerAction({type:Wx[Fx],update:"updateView"},function(){});ym.registerAction({type:"treemapRootToNode",update:"updateView"},function(t,e){e.eachComponent({mainType:"series",subType:"treemap",query:t},function(e,i){var n=bx.retrieveTargetInfo(t,e);if(n){var a=e.getViewRoot();a&&(t.direction=bx.aboveViewRoot(a,n.node)?"rollUp":"drillDown"),e.resetViewRoot(n.node)}})});var Zx=Pu.linearMap,jx=rl.each,Ux=rl.isObject,qx=-1,Xx=function(t){var e=t.mappingMethod,i=t.type,n=this.option=rl.clone(t);this.type=i,this.mappingMethod=e,this._normalizeData=$x[e];var a=Yx[i];this.applyVisual=a.applyVisual,this.getColorMapper=a.getColorMapper,this._doMap=a._doMap[e],"piecewise"===e?(In(n),function(t){var e=t.pieceList;t.hasSpecialVisual=!1,rl.each(e,function(e,i){e.originIndex=i,null!=e.visual&&(t.hasSpecialVisual=!0)})}(n)):"category"===e?n.categories?function(t){var e=t.categories,i=t.visual,n=t.categoryMap={};if(jx(e,function(t,e){n[t]=e}),!rl.isArray(i)){var a=[];rl.isObject(i)?jx(i,function(t,e){var i=n[e];a[null!=i?i:qx]=t}):a[qx]=i,i=On(t,a)}for(var o=e.length-1;o>=0;o--)null==i[o]&&(delete n[e[o]],e.pop())}(n):In(n,!0):(rl.assert("linear"!==e||n.dataExtent),In(n))};Xx.prototype={constructor:Xx,mapValueToVisual:function(t){var e=this._normalizeData(t);return this._doMap(e,t)},getNormalizer:function(){return rl.bind(this._normalizeData,this)}};var Yx=Xx.visualHandlers={color:{applyVisual:Cn("color"),getColorMapper:function(){var t=this.option;return rl.bind("category"===t.mappingMethod?function(t,e){return!e&&(t=this._normalizeData(t)),Ln.call(this,t)}:function(e,i,n){var a=!!n;return!i&&(e=this._normalizeData(e)),n=Nl.fastLerp(e,t.parsedVisual,n),a?n:Nl.stringify(n,"rgba")},this)},_doMap:{linear:function(t){return Nl.stringify(Nl.fastLerp(t,this.option.parsedVisual),"rgba")},category:Ln,piecewise:function(t,e){var i=kn.call(this,e);return null==i&&(i=Nl.stringify(Nl.fastLerp(t,this.option.parsedVisual),"rgba")),i},fixed:Dn}},colorHue:Tn(function(t,e){return Nl.modifyHSL(t,e)}),colorSaturation:Tn(function(t,e){return Nl.modifyHSL(t,null,e)}),colorLightness:Tn(function(t,e){return Nl.modifyHSL(t,null,null,e)}),colorAlpha:Tn(function(t,e){return Nl.modifyAlpha(t,e)}),opacity:{applyVisual:Cn("opacity"),_doMap:Pn([0,1])},symbol:{applyVisual:function(t,e,i){var n=this.mapValueToVisual(t);if(rl.isString(n))i("symbol",n);else if(Ux(n))for(var a in n)n.hasOwnProperty(a)&&i(a,n[a])},_doMap:{linear:An,category:Ln,piecewise:function(t,e){var i=kn.call(this,e);return null==i&&(i=An.call(this,t)),i},fixed:Dn}},symbolSize:{applyVisual:Cn("symbolSize"),_doMap:Pn([0,1])}},$x={linear:function(t){return Zx(t,this.option.dataExtent,[0,1],!0)},piecewise:function(t){var e=this.option.pieceList,i=Xx.findPieceIndex(t,e,!0);if(null!=i)return Zx(i,[0,e.length-1],[0,1],!0)},category:function(t){var e=this.option.categories?this.option.categoryMap[t]:t;return null==e?qx:e},fixed:rl.noop};Xx.listVisualTypes=function(){var t=[];return rl.each(Yx,function(e,i){t.push(i)}),t},Xx.addVisualHandler=function(t,e){Yx[t]=e},Xx.isValidType=function(t){return Yx.hasOwnProperty(t)},Xx.eachVisual=function(t,e,i){rl.isObject(t)?rl.each(t,e,i):e.call(i,t)},Xx.mapVisual=function(t,e,i){var n,a=rl.isArray(t)?[]:rl.isObject(t)?{}:(n=!0,null);return Xx.eachVisual(t,function(t,o){var r=e.call(i,t,o);n?a=r:a[o]=r}),a},Xx.retrieveVisuals=function(t){var e,i={};return t&&jx(Yx,function(n,a){t.hasOwnProperty(a)&&(i[a]=t[a],e=!0)}),e?i:null},Xx.prepareVisualTypes=function(t){if(Ux(t)){var e=[];jx(t,function(t,i){e.push(i)}),t=e}else{if(!rl.isArray(t))return[];t=t.slice()}return t.sort(function(t,e){return"color"===e&&"color"!==t&&0===t.indexOf("color")?1:-1}),t},Xx.dependsOn=function(t,e){return"color"===e?!(!t||0!==t.indexOf(e)):t===e},Xx.findPieceIndex=function(t,e,i){function n(e,i){var n=Math.abs(e-t);n<o&&(o=n,a=i)}for(var a,o=1/0,r=0,s=e.length;r<s;r++){var l=e[r].value;if(null!=l){if(l===t||"string"==typeof l&&l===t+"")return r;i&&n(l,r)}}for(var r=0,s=e.length;r<s;r++){var h=e[r],u=h.interval,c=h.close;if(u){if(u[0]===-1/0){if(zn(c[1],t,u[1]))return r}else if(u[1]===1/0){if(zn(c[0],u[0],t))return r}else if(zn(c[0],u[0],t)&&zn(c[1],t,u[1]))return r;i&&n(u[0],r),i&&n(u[1],r)}}if(i)return t===1/0?e.length-1:t===-1/0?0:a};var Kx=Xx,Jx=rl.isArray,Qx="itemStyle.normal",t_=function(t,e,i){var n={mainType:"series",subType:"treemap",query:i};t.eachComponent(n,function(t){var e=t.getData().tree,i=e.root,n=t.getModel(Qx);i.isRemoved()||En(i,{},rl.map(e.levelModels,function(t){return t?t.get(Qx):null}),n,t.getViewRoot().getAncestors(),t)})},e_=Pu.parsePercent,i_=Pu.MAX_SAFE_INTEGER,n_=Math.max,a_=Math.min,o_=rl.retrieve,r_=rl.each,s_=["itemStyle","normal","borderWidth"],l_=["itemStyle","normal","gapWidth"],h_=["upperLabel","normal","show"],u_=["upperLabel","normal","height"],c_=function(t,e,i){var n={mainType:"series",subType:"treemap",query:i};t.eachComponent(n,function(t){var n=e.getWidth(),a=e.getHeight(),o=t.option,r=Np.getLayoutRect(t.getBoxLayoutParams(),{width:e.getWidth(),height:e.getHeight()}),s=o.size||[],l=e_(o_(r.width,s[0]),n),h=e_(o_(r.height,s[1]),a),u=i&&i.type,c=bx.retrieveTargetInfo(i,t),d="treemapRender"===u||"treemapMove"===u?i.rootRect:null,p=t.getViewRoot(),f=bx.getPathToRoot(p);if("treemapMove"!==u){var g="treemapZoomToNode"===u?function(t,e,i,n,a){var o=(e||{}).node,r=[n,a];if(!o||o===i)return r;for(var s,l=n*a,h=l*t.option.zoomToNodeRatio;s=o.parentNode;){for(var u=0,c=s.children,d=0,p=c.length;d<p;d++)u+=c[d].getValue();var f=o.getValue();if(0===f)return r;h*=u/f;var g=s.getModel(),m=g.get(s_),v=Math.max(m,Wn(g));(h+=4*m*m+(3*m+v)*Math.pow(h,.5))>i_&&(h=i_),o=s}h<l&&(h=l);var y=Math.pow(h/l,.5);return[n*y,a*y]}(t,c,p,l,h):d?[d.width,d.height]:[l,h],m=o.sort;m&&"asc"!==m&&"desc"!==m&&(m="desc");var v={squareRatio:o.squareRatio,sort:m,leafDepth:o.leafDepth};p.hostTree.clearLayouts(),y={x:0,y:0,width:g[0],height:g[1],area:g[0]*g[1]},p.setLayout(y),Bn(p,v,!1,0);var y=p.getLayout();r_(f,function(t,e){var i=(f[e+1]||p).getValue();t.setLayout(rl.extend({dataExtent:[i,i],borderWidth:0,upperHeight:0},y))})}var x=t.getData().tree.root;x.setLayout(function(t,e,i){if(e)return{x:e.x,y:e.y};var n={x:0,y:0};if(!i)return n;var a=i.node,o=a.getLayout();if(!o)return n;for(var r=[o.width/2,o.height/2],s=a;s;){var l=s.getLayout();r[0]+=l.x,r[1]+=l.y,s=s.parentNode}return{x:t.width/2-r[0],y:t.height/2-r[1]}}(r,d,c),!0),t.setLayoutInfo(r),Hn(x,new oh(-r.x,-r.y,n,a),f,p,0)})};ym.registerVisual(t_),ym.registerLayout(c_);var d_=function(t){this._directed=t||!1,this.nodes=[],this.edges=[],this._nodesMap={},this._edgesMap={},this.data,this.edgeData},p_=d_.prototype;p_.type="graph",p_.isDirected=function(){return this._directed},p_.addNode=function(t,e){t=t||""+e;var i=this._nodesMap;if(!i[Fn(t)]){var n=new Zn(t,e);return n.hostGraph=this,this.nodes.push(n),i[Fn(t)]=n,n}},p_.getNodeByIndex=function(t){var e=this.data.getRawIndex(t);return this.nodes[e]},p_.getNodeById=function(t){return this._nodesMap[Fn(t)]},p_.addEdge=function(t,e,i){var n=this._nodesMap,a=this._edgesMap;if("number"==typeof t&&(t=this.nodes[t]),"number"==typeof e&&(e=this.nodes[e]),t instanceof Zn||(t=n[Fn(t)]),e instanceof Zn||(e=n[Fn(e)]),t&&e){var o=t.id+"-"+e.id;if(!a[o]){var r=new jn(t,e,i);return r.hostGraph=this,this._directed&&(t.outEdges.push(r),e.inEdges.push(r)),t.edges.push(r),t!==e&&e.edges.push(r),this.edges.push(r),a[o]=r,r}}},p_.getEdgeByIndex=function(t){var e=this.edgeData.getRawIndex(t);return this.edges[e]},p_.getEdge=function(t,e){t instanceof Zn&&(t=t.id),e instanceof Zn&&(e=e.id);var i=this._edgesMap;return this._directed?i[t+"-"+e]:i[t+"-"+e]||i[e+"-"+t]},p_.eachNode=function(t,e){for(var i=this.nodes,n=i.length,a=0;a<n;a++)i[a].dataIndex>=0&&t.call(e,i[a],a)},p_.eachEdge=function(t,e){for(var i=this.edges,n=i.length,a=0;a<n;a++)i[a].dataIndex>=0&&i[a].node1.dataIndex>=0&&i[a].node2.dataIndex>=0&&t.call(e,i[a],a)},p_.breadthFirstTraverse=function(t,e,i,n){if(e instanceof Zn||(e=this._nodesMap[Fn(e)]),e){for(var a="out"===i?"outEdges":"in"===i?"inEdges":"edges",o=0;o<this.nodes.length;o++)this.nodes[o].__visited=!1;if(!t.call(n,e,null))for(var r=[e];r.length;)for(var s=r.shift(),l=s[a],o=0;o<l.length;o++){var h=l[o],u=h.node1===s?h.node2:h.node1;if(!u.__visited){if(t.call(n,u,s))return;r.push(u),u.__visited=!0}}}},p_.update=function(){for(var t=this.data,e=this.edgeData,i=this.nodes,n=this.edges,a=0,o=i.length;a<o;a++)i[a].dataIndex=-1;for(var a=0,o=t.count();a<o;a++)i[t.getRawIndex(a)].dataIndex=a;e.filterSelf(function(t){var i=n[e.getRawIndex(t)];return i.node1.dataIndex>=0&&i.node2.dataIndex>=0});for(var a=0,o=n.length;a<o;a++)n[a].dataIndex=-1;for(var a=0,o=e.count();a<o;a++)n[e.getRawIndex(a)].dataIndex=a},p_.clone=function(){for(var t=new d_(this._directed),e=this.nodes,i=this.edges,n=0;n<e.length;n++)t.addNode(e[n].id,e[n].dataIndex);for(n=0;n<i.length;n++){var a=i[n];t.addEdge(a.node1.id,a.node2.id,a.dataIndex)}return t},Zn.prototype={constructor:Zn,degree:function(){return this.edges.length},inDegree:function(){return this.inEdges.length},outDegree:function(){return this.outEdges.length},getModel:function(t){if(!(this.dataIndex<0)){return this.hostGraph.data.getItemModel(this.dataIndex).getModel(t)}}},jn.prototype.getModel=function(t){if(!(this.dataIndex<0)){return this.hostGraph.edgeData.getItemModel(this.dataIndex).getModel(t)}};var f_=function(t,e){return{getValue:function(i){var n=this[t][e];return n.get(n.getDimension(i||"value"),this.dataIndex)},setVisual:function(i,n){this.dataIndex>=0&&this[t][e].setItemVisual(this.dataIndex,i,n)},getVisual:function(i,n){return this[t][e].getItemVisual(this.dataIndex,i,n)},setLayout:function(i,n){this.dataIndex>=0&&this[t][e].setItemLayout(this.dataIndex,i,n)},getLayout:function(){return this[t][e].getItemLayout(this.dataIndex)},getGraphicEl:function(){return this[t][e].getItemGraphicEl(this.dataIndex)},getRawIndex:function(){return this[t][e].getRawIndex(this.dataIndex)}}};rl.mixin(Zn,f_("hostGraph","data")),rl.mixin(jn,f_("hostGraph","edgeData")),d_.Node=Zn,d_.Edge=jn;var g_=d_,m_=function(t,e,i,n,a){for(var o=new g_(n),r=0;r<t.length;r++)o.addNode(rl.retrieve(t[r].id,t[r].name,r),r);for(var s=[],l=[],h=0,r=0;r<e.length;r++){var u=e[r],c=u.source,d=u.target;o.addEdge(c,d,h)&&(l.push(u),s.push(rl.retrieve(u.id,c+" > "+d)),h++)}var p,f=i.get("coordinateSystem");if("cartesian2d"===f||"polar"===f)p=dg(t,i,i.ecModel);else{var g=rf.get(f),m=sg((g&&"view"!==g.type?g.dimensions||[]:[]).concat(["value"]),t);(p=new tg(m,i)).initData(t)}var v=new tg(["value"],i);return v.initData(l,s),a&&a(p,v),nx({mainData:p,struct:o,structAttr:"graph",datas:{node:p,edge:v},datasAttr:{node:"data",edge:"edgeData"}}),o.update(),o},v_=Ip.defaultEmphasis,y_=Eu.encodeHTML,x_=ym.extendSeriesModel({type:"series.graph",init:function(t){x_.superApply(this,"init",arguments),this.legendDataProvider=function(){return this._categoriesData},this.fillDataTextStyle(t.edges||t.links),this._updateCategoriesData()},mergeOption:function(t){x_.superApply(this,"mergeOption",arguments),this.fillDataTextStyle(t.edges||t.links),this._updateCategoriesData()},mergeDefaultAndTheme:function(t){x_.superApply(this,"mergeDefaultAndTheme",arguments),v_(t.edgeLabel,["show"])},getInitialData:function(t,e){var i=t.edges||t.links||[],n=t.data||t.nodes||[],a=this;if(n&&i)return m_(n,i,this,!0,function(t,i){t.wrapMethod("getItemModel",function(t){var e=a._categoriesModels[t.getShallow("category")];return e&&(e.parentModel=t.parentModel,t.parentModel=e),t});var n=a.getModel("edgeLabel"),o=new _p({label:n.option},n.parentModel,e);i.wrapMethod("getItemModel",function(t){return t.customizeGetParent(function(t){return(t=this.parsePath(t))&&"label"===t[0]?o:this.parentModel}),t})}).data},getGraph:function(){return this.getData().graph},getEdgeData:function(){return this.getGraph().edgeData},getCategoriesData:function(){return this._categoriesData},formatTooltip:function(t,e,i){if("edge"===i){var n=this.getData(),a=this.getDataParams(t,i),o=n.graph.getEdgeByIndex(t),r=n.getName(o.node1.dataIndex),s=n.getName(o.node2.dataIndex),l=[];return null!=r&&l.push(r),null!=s&&l.push(s),l=y_(l.join(" > ")),a.value&&(l+=" : "+y_(a.value)),l}return x_.superApply(this,"formatTooltip",arguments)},_updateCategoriesData:function(){var t=rl.map(this.option.categories||[],function(t){return null!=t.value?t:rl.extend({value:0},t)}),e=new tg(["value"],this);e.initData(t),this._categoriesData=e,this._categoriesModels=e.mapArray(function(t){return e.getItemModel(t,!0)})},setZoom:function(t){this.option.zoom=t},setCenter:function(t){this.option.center=t},isAnimationEnabled:function(){return x_.superCall(this,"isAnimationEnabled")&&!("force"===this.get("layout")&&this.get("force.layoutAnimation"))},defaultOption:{zlevel:0,z:2,coordinateSystem:"view",legendHoverLink:!0,hoverAnimation:!0,layout:null,focusNodeAdjacency:!1,circular:{rotateLabel:!1},force:{initLayout:null,repulsion:[0,50],gravity:.1,edgeLength:30,layoutAnimation:!0},left:"center",top:"center",symbol:"circle",symbolSize:10,edgeSymbol:["none","none"],edgeSymbolSize:10,edgeLabel:{normal:{position:"middle"},emphasis:{}},draggable:!1,roam:!1,center:null,zoom:1,nodeScaleRatio:.6,label:{normal:{show:!1,formatter:"{b}"},emphasis:{show:!0}},itemStyle:{normal:{},emphasis:{}},lineStyle:{normal:{color:"#aaa",width:1,curveness:0,opacity:.5},emphasis:{}}}}),__=fp.Line.prototype,b_=fp.BezierCurve.prototype,w_=fp.extendShape({type:"ec-line",style:{stroke:"#000",fill:null},shape:{x1:0,y1:0,x2:0,y2:0,percent:1,cpx1:null,cpy1:null},buildPath:function(t,e){(Un(e)?__:b_).buildPath(t,e)},pointAt:function(t){return Un(this.shape)?__.pointAt.call(this,t):b_.pointAt.call(this,t)},tangentAt:function(t){var e=this.shape,i=Un(e)?[e.x2-e.x1,e.y2-e.y1]:b_.tangentAt.call(this,t);return ll.normalize(i,i)}}),S_=Pu.round,M_=["fromSymbol","toSymbol"],I_=$n.prototype;I_.beforeUpdate=function(){var t=this.childOfName("fromSymbol"),e=this.childOfName("toSymbol"),i=this.childOfName("label");if(t||e||!i.ignore){for(var n=1,a=this.parent;a;)a.scale&&(n/=a.scale[0]),a=a.parent;var o=this.childOfName("line");if(this.__dirty||o.__dirty){var r=o.shape.percent,s=o.pointAt(0),l=o.pointAt(r),h=ll.sub([],l,s);if(ll.normalize(h,h),t&&(t.attr("position",s),f=o.tangentAt(0),t.attr("rotation",Math.PI/2-Math.atan2(f[1],f[0])),t.attr("scale",[n*r,n*r])),e&&(e.attr("position",l),f=o.tangentAt(1),e.attr("rotation",-Math.PI/2-Math.atan2(f[1],f[0])),e.attr("scale",[n*r,n*r])),!i.ignore){i.attr("position",l);var u,c,d,p=5*n;if("end"===i.__position)u=[h[0]*p+l[0],h[1]*p+l[1]],c=h[0]>.8?"left":h[0]<-.8?"right":"center",d=h[1]>.8?"top":h[1]<-.8?"bottom":"middle";else if("middle"===i.__position){var f,g=r/2,m=[(f=o.tangentAt(g))[1],-f[0]],v=o.pointAt(g);m[1]>0&&(m[0]=-m[0],m[1]=-m[1]),u=[v[0]+m[0]*p,v[1]+m[1]*p],c="center",d="bottom";var y=-Math.atan2(f[1],f[0]);l[0]<s[0]&&(y=Math.PI+y),i.attr("rotation",y)}else u=[-h[0]*p+s[0],-h[1]*p+s[1]],c=h[0]>.8?"right":h[0]<-.8?"left":"center",d=h[1]>.8?"bottom":h[1]<-.8?"top":"middle";i.attr({style:{textVerticalAlign:i.__verticalAlign||d,textAlign:i.__textAlign||c},position:u,scale:[n,n]})}}}},I_._createLine=function(t,e,i){var n=t.hostModel,a=function(t){var e=new w_({name:"line"});return Yn(e.shape,t),e}(t.getItemLayout(e));a.shape.percent=0,fp.initProps(a,{shape:{percent:1}},n,e),this.add(a);var o=new fp.Text({name:"label"});this.add(o),rl.each(M_,function(i){var n=Xn(i,t,e);this.add(n),this[qn(i)]=t.getItemVisual(e,i)},this),this._updateCommonStl(t,e,i)},I_.updateData=function(t,e,i){var n=t.hostModel,a=this.childOfName("line"),o=t.getItemLayout(e),r={shape:{}};Yn(r.shape,o),fp.updateProps(a,r,n,e),rl.each(M_,function(i){var n=t.getItemVisual(e,i),a=qn(i);if(this[a]!==n){this.remove(this.childOfName(i));var o=Xn(i,t,e);this.add(o)}this[a]=n},this),this._updateCommonStl(t,e,i)},I_._updateCommonStl=function(t,e,i){var n=t.hostModel,a=this.childOfName("line"),o=i&&i.lineStyle,r=i&&i.hoverLineStyle,s=i&&i.labelModel,l=i&&i.hoverLabelModel;if(!i||t.hasItemOption){var h=t.getItemModel(e);o=h.getModel("lineStyle.normal").getLineStyle(),r=h.getModel("lineStyle.emphasis").getLineStyle(),s=h.getModel("label.normal"),l=h.getModel("label.emphasis")}var u=t.getItemVisual(e,"color"),c=rl.retrieve3(t.getItemVisual(e,"opacity"),o.opacity,1);a.useStyle(rl.defaults({strokeNoScale:!0,fill:"none",stroke:u,opacity:c},o)),a.hoverStyle=r,rl.each(M_,function(t){var e=this.childOfName(t);e&&(e.setColor(u),e.setStyle({opacity:c}))},this);var d,p,f,g,m=s.getShallow("show"),v=l.getShallow("show"),y=this.childOfName("label");if(m||v){var x=n.getRawValue(e);p=null==x?p=t.getName(e):isFinite(x)?S_(x):x,d=u||"#000",f=rl.retrieve2(n.getFormattedLabel(e,"normal",t.dataType),p),g=rl.retrieve2(n.getFormattedLabel(e,"emphasis",t.dataType),f)}if(m){var _=fp.setTextStyle(y.style,s,{text:f},{autoColor:d});y.__textAlign=_.textAlign,y.__verticalAlign=_.textVerticalAlign,y.__position=s.get("position")||"middle"}else y.setStyle("text",null);y.hoverStyle=v?{text:g,textFill:l.getTextColor(!0),fontStyle:l.getShallow("fontStyle"),fontWeight:l.getShallow("fontWeight"),fontSize:l.getShallow("fontSize"),fontFamily:l.getShallow("fontFamily")}:{text:null},y.ignore=!m&&!v,fp.setHoverStyle(this)},I_.highlight=function(){this.trigger("emphasis")},I_.downplay=function(){this.trigger("normal")},I_.updateLayout=function(t,e){this.setLinePoints(t.getItemLayout(e))},I_.setLinePoints=function(t){var e=this.childOfName("line");Yn(e.shape,t),e.dirty()},rl.inherits($n,fp.Group);var T_=$n,A_=Qn.prototype;A_.updateData=function(t){var e=this._lineData,i=this.group,n=this._ctor,a=t.hostModel,o={lineStyle:a.getModel("lineStyle.normal").getLineStyle(),hoverLineStyle:a.getModel("lineStyle.emphasis").getLineStyle(),labelModel:a.getModel("label.normal"),hoverLabelModel:a.getModel("label.emphasis")};t.diff(e).add(function(e){if(Jn(t.getItemLayout(e))){var a=new n(t,e,o);t.setItemGraphicEl(e,a),i.add(a)}}).update(function(a,r){var s=e.getItemGraphicEl(r);Jn(t.getItemLayout(a))?(s?s.updateData(t,a,o):s=new n(t,a,o),t.setItemGraphicEl(a,s),i.add(s)):i.remove(s)}).remove(function(t){i.remove(e.getItemGraphicEl(t))}).execute(),this._lineData=t},A_.updateLayout=function(){var t=this._lineData;t.eachItemGraphicEl(function(e,i){e.updateLayout(t,i)},this)},A_.remove=function(){this.group.removeAll()};var C_=Qn,L_=[],D_=[],P_=[],k_=ic.quadraticAt,O_=ll.distSquare,z_=Math.abs,E_=function(t,e){function i(t){var e=t.getVisual("symbolSize");return e instanceof Array&&(e=(e[0]+e[1])/2),e}var n=[],a=ic.quadraticSubdivide,o=[[],[],[]],r=[[],[]],s=[];e/=2,t.eachEdge(function(t,l){var h=t.getLayout(),u=t.getVisual("fromSymbol"),c=t.getVisual("toSymbol");h.__original||(h.__original=[ll.clone(h[0]),ll.clone(h[1])],h[2]&&h.__original.push(ll.clone(h[2])));var d=h.__original;if(null!=h[2]){if(ll.copy(o[0],d[0]),ll.copy(o[1],d[2]),ll.copy(o[2],d[1]),u&&"none"!=u){var p=i(t.node1),f=ta(o,d[0],p*e);a(o[0][0],o[1][0],o[2][0],f,n),o[0][0]=n[3],o[1][0]=n[4],a(o[0][1],o[1][1],o[2][1],f,n),o[0][1]=n[3],o[1][1]=n[4]}if(c&&"none"!=c){var p=i(t.node2),f=ta(o,d[1],p*e);a(o[0][0],o[1][0],o[2][0],f,n),o[1][0]=n[1],o[2][0]=n[2],a(o[0][1],o[1][1],o[2][1],f,n),o[1][1]=n[1],o[2][1]=n[2]}ll.copy(h[0],o[0]),ll.copy(h[1],o[2]),ll.copy(h[2],o[1])}else ll.copy(r[0],d[0]),ll.copy(r[1],d[1]),ll.sub(s,r[1],r[0]),ll.normalize(s,s),u&&"none"!=u&&(p=i(t.node1),ll.scaleAndAdd(r[0],r[0],s,p*e)),c&&"none"!=c&&(p=i(t.node2),ll.scaleAndAdd(r[1],r[1],s,-p*e)),ll.copy(h[0],r[0]),ll.copy(h[1],r[1])})},R_=jy.onIrrelevantElement,N_=["itemStyle","normal","opacity"],V_=["lineStyle","normal","opacity"],B_=(ym.extendChartView({type:"graph",init:function(t,e){var i=new Pm,n=new C_,a=this.group;this._controller=new Wy(e.getZr()),this._controllerHost={target:a},a.add(i.group),a.add(n.group),this._symbolDraw=i,this._lineDraw=n,this._firstRender=!0},render:function(t,e,i){var n=t.coordinateSystem;this._model=t,this._nodeScaleRatio=t.get("nodeScaleRatio");var a=this._symbolDraw,o=this._lineDraw,r=this.group;if("view"===n.type){var s={position:n.position,scale:n.scale};this._firstRender?r.attr(s):fp.updateProps(r,s,t)}E_(t.getGraph(),this._getNodeGlobalScale(t));var l=t.getData();a.updateData(l);var h=t.getEdgeData();o.updateData(h),this._updateNodeAndLinkScale(),this._updateController(t,e,i),clearTimeout(this._layoutTimeout);var u=t.forceLayout,c=t.get("force.layoutAnimation");u&&this._startForceLayoutIteration(u,c),l.eachItemGraphicEl(function(e,n){var a=l.getItemModel(n);e.off("drag").off("dragend");var o=l.getItemModel(n).get("draggable");o&&e.on("drag",function(){u&&(u.warmUp(),!this._layouting&&this._startForceLayoutIteration(u,c),u.setFixed(n),l.setItemLayout(n,e.position))},this).on("dragend",function(){u&&u.setUnfixed(n)},this),e.setDraggable(o&&u),e.off("mouseover",e.__focusNodeAdjacency),e.off("mouseout",e.__unfocusNodeAdjacency),a.get("focusNodeAdjacency")&&(e.on("mouseover",e.__focusNodeAdjacency=function(){i.dispatchAction({type:"focusNodeAdjacency",seriesId:t.id,dataIndex:e.dataIndex})}),e.on("mouseout",e.__unfocusNodeAdjacency=function(){i.dispatchAction({type:"unfocusNodeAdjacency",seriesId:t.id})}))},this),l.graph.eachEdge(function(e){var n=e.getGraphicEl();n.off("mouseover",n.__focusNodeAdjacency),n.off("mouseout",n.__unfocusNodeAdjacency),e.getModel().get("focusNodeAdjacency")&&(n.on("mouseover",n.__focusNodeAdjacency=function(){i.dispatchAction({type:"focusNodeAdjacency",seriesId:t.id,edgeDataIndex:e.dataIndex})}),n.on("mouseout",n.__unfocusNodeAdjacency=function(){i.dispatchAction({type:"unfocusNodeAdjacency",seriesId:t.id})}))});var d="circular"===t.get("layout")&&t.get("circular.rotateLabel"),p=l.getLayout("cx"),f=l.getLayout("cy");l.eachItemGraphicEl(function(t,e){var i=t.getSymbolPath();if(d){var n=l.getItemLayout(e),a=Math.atan2(n[1]-f,n[0]-p);a<0&&(a=2*Math.PI+a);var o=n[0]<p;o&&(a-=Math.PI);var r=o?"left":"right";i.setStyle({textRotation:-a,textPosition:r,textOrigin:"center"}),i.hoverStyle&&(i.hoverStyle.textPosition=r)}else i.setStyle({textRotation:0})}),this._firstRender=!1},dispose:function(){this._controller&&this._controller.dispose(),this._controllerHost={}},focusNodeAdjacency:function(t,e,i,n){var a=this._model.getData().graph,o=n.dataIndex,r=n.edgeDataIndex,s=a.getNodeByIndex(o),l=a.getEdgeByIndex(r);(s||l)&&(a.eachNode(function(t){ia(t,N_,.1)}),a.eachEdge(function(t){ia(t,V_,.1)}),s&&(na(s,N_),rl.each(s.edges,function(t){t.dataIndex<0||(na(t,V_),na(t.node1,N_),na(t.node2,N_))})),l&&(na(l,V_),na(l.node1,N_),na(l.node2,N_)))},unfocusNodeAdjacency:function(t,e,i,n){var a=this._model.getData().graph;a.eachNode(function(t){ia(t,N_)}),a.eachEdge(function(t){ia(t,V_)})},_startForceLayoutIteration:function(t,e){var i=this;!function n(){t.step(function(t){i.updateLayout(i._model),(i._layouting=!t)&&(e?i._layoutTimeout=setTimeout(n,16):n())})}()},_updateController:function(t,e,i){var n=this._controller,a=this._controllerHost,o=this.group;n.setPointerChecker(function(e,n,a){var r=o.getBoundingRect();return r.applyTransform(o.transform),r.contain(n,a)&&!R_(e,i,t)}),"view"===t.coordinateSystem.type?(n.enable(t.get("roam")),a.zoomLimit=t.get("scaleLimit"),a.zoom=t.coordinateSystem.getZoom(),n.off("pan").off("zoom").on("pan",function(e,n){Fy.updateViewOnPan(a,e,n),i.dispatchAction({seriesId:t.id,type:"graphRoam",dx:e,dy:n})}).on("zoom",function(e,n,o){Fy.updateViewOnZoom(a,e,n,o),i.dispatchAction({seriesId:t.id,type:"graphRoam",zoom:e,originX:n,originY:o}),this._updateNodeAndLinkScale(),E_(t.getGraph(),this._getNodeGlobalScale(t)),this._lineDraw.updateLayout()},this)):n.disable()},_updateNodeAndLinkScale:function(){var t=this._model,e=t.getData(),i=this._getNodeGlobalScale(t),n=[i,i];e.eachItemGraphicEl(function(t,e){t.attr("scale",n)})},_getNodeGlobalScale:function(t){var e=t.coordinateSystem;if("view"!==e.type)return 1;var i=this._nodeScaleRatio,n=e.scale,a=n&&n[0]||1;return((e.getZoom()-1)*i+1)/a},updateLayout:function(t){E_(t.getGraph(),this._getNodeGlobalScale(t)),this._symbolDraw.updateLayout(),this._lineDraw.updateLayout()},remove:function(t,e){this._symbolDraw&&this._symbolDraw.remove(),this._lineDraw&&this._lineDraw.remove()}}),Xy.updateCenterAndZoom);ym.registerAction({type:"graphRoam",event:"graphRoam",update:"none"},function(t,e){e.eachComponent({mainType:"series",query:t},function(e){var i=e.coordinateSystem,n=B_(i,t);e.setCenter&&e.setCenter(n.center),e.setZoom&&e.setZoom(n.zoom)})}),ym.registerAction({type:"focusNodeAdjacency",event:"focusNodeAdjacency",update:"series.graph:focusNodeAdjacency"},function(){}),ym.registerAction({type:"unfocusNodeAdjacency",event:"unfocusNodeAdjacency",update:"series.graph:unfocusNodeAdjacency"},function(){});var G_=function(t){var e=t.findComponents({mainType:"legend"});e&&e.length&&t.eachSeriesByType("graph",function(t){var i=t.getCategoriesData(),n=t.getGraph().data,a=i.mapArray(i.getName);n.filterSelf(function(t){var i=n.getItemModel(t).getShallow("category");if(null!=i){"number"==typeof i&&(i=a[i]);for(var o=0;o<e.length;o++)if(!e[o].isSelected(i))return!1}return!0})},this)},H_=function(t){var e={};t.eachSeriesByType("graph",function(t){var i=t.getCategoriesData(),n=t.getData(),a={};i.each(function(n){var o=i.getName(n);a["ec-"+o]=n;var r=i.getItemModel(n).get("itemStyle.normal.color")||t.getColorFromPalette(o,e);i.setItemVisual(n,"color",r)}),i.count()&&n.each(function(t){var e=n.getItemModel(t).getShallow("category");null!=e&&("string"==typeof e&&(e=a["ec-"+e]),n.getItemVisual(t,"color",!0)||n.setItemVisual(t,"color",i.getItemVisual(e,"color")))})})},W_=function(t){t.eachSeriesByType("graph",function(t){var e=t.getGraph(),i=t.getEdgeData(),n=aa(t.get("edgeSymbol")),a=aa(t.get("edgeSymbolSize")),o="lineStyle.normal.color".split("."),r="lineStyle.normal.opacity".split(".");i.setVisual("fromSymbol",n&&n[0]),i.setVisual("toSymbol",n&&n[1]),i.setVisual("fromSymbolSize",a&&a[0]),i.setVisual("toSymbolSize",a&&a[1]),i.setVisual("color",t.get(o)),i.setVisual("opacity",t.get(r)),i.each(function(t){var n=i.getItemModel(t),a=e.getEdgeByIndex(t),s=aa(n.getShallow("symbol",!0)),l=aa(n.getShallow("symbolSize",!0)),h=n.get(o),u=n.get(r);switch(h){case"source":h=a.node1.getVisual("color");break;case"target":h=a.node2.getVisual("color")}s[0]&&a.setVisual("fromSymbol",s[0]),s[1]&&a.setVisual("toSymbol",s[1]),l[0]&&a.setVisual("fromSymbolSize",l[0]),l[1]&&a.setVisual("toSymbolSize",l[1]),a.setVisual("color",h),a.setVisual("opacity",u)})})},F_={simpleLayout:function(t){var e=t.coordinateSystem;if(!e||"view"===e.type){var i=t.getGraph();i.eachNode(function(t){var e=t.getModel();t.setLayout([+e.get("x"),+e.get("y")])}),oa(i)}},simpleLayoutEdge:oa},Z_=F_.simpleLayout,j_=F_.simpleLayoutEdge,U_=function(t,e){t.eachSeriesByType("graph",function(t){var e=t.get("layout"),i=t.coordinateSystem;if(i&&"view"!==i.type){var n=t.getData(),a=i.dimensions;n.each(a,function(){for(var t,e=arguments,o=[],r=0;r<a.length;r++)isNaN(e[r])||(t=!0),o.push(e[r]);var s=e[e.length-1];t?n.setItemLayout(s,i.dataToPoint(o)):n.setItemLayout(s,[NaN,NaN])}),j_(n.graph)}else e&&"none"!==e||Z_(t)})},q_={circularLayout:function(t){var e=t.coordinateSystem;if(!e||"view"===e.type){var i=e.getBoundingRect(),n=t.getData(),a=n.graph,o=0,r=n.getSum("value"),s=2*Math.PI/(r||n.count()),l=i.width/2+i.x,h=i.height/2+i.y,u=Math.min(i.width,i.height)/2;a.eachNode(function(t){var e=t.getValue("value");o+=s*(r?e:1)/2,t.setLayout([u*Math.cos(o)+l,u*Math.sin(o)+h]),o+=s*(r?e:1)/2}),n.setLayout({cx:l,cy:h}),a.eachEdge(function(t){var e,i=t.getModel().get("lineStyle.normal.curveness")||0,n=ll.clone(t.node1.getLayout()),a=ll.clone(t.node2.getLayout()),o=(n[0]+a[0])/2,r=(n[1]+a[1])/2;+i&&(e=[l*(i*=3)+o*(1-i),h*i+r*(1-i)]),t.setLayout([n,a,e])})}}},X_=q_.circularLayout,Y_=function(t){t.eachSeriesByType("graph",function(t){"circular"===t.get("layout")&&X_(t)})},$_=ll.scaleAndAdd,K_={forceLayout:function(t,e,i){for(var n=i.rect,a=n.width,o=n.height,r=[n.x+a/2,n.y+o/2],s=null==i.gravity?.1:i.gravity,l=0;l<t.length;l++){var h=t[l];h.p||(h.p=ll.create(a*(Math.random()-.5)+r[0],o*(Math.random()-.5)+r[1])),h.pp=ll.clone(h.p),h.edges=null}var u=.6;return{warmUp:function(){u=.5},setFixed:function(e){t[e].fixed=!0},setUnfixed:function(e){t[e].fixed=!1},step:function(i){for(var n=[],a=t.length,o=0;o<e.length;o++){var l=e[o],h=l.n1,c=l.n2;ll.sub(n,c.p,h.p);var d=ll.len(n)-l.d,p=c.w/(h.w+c.w);isNaN(p)&&(p=0),ll.normalize(n,n),!h.fixed&&$_(h.p,h.p,n,p*d*u),!c.fixed&&$_(c.p,c.p,n,-(1-p)*d*u)}for(o=0;o<a;o++)(v=t[o]).fixed||(ll.sub(n,r,v.p),$_(v.p,v.p,n,s*u));for(o=0;o<a;o++)for(var h=t[o],f=o+1;f<a;f++){c=t[f],ll.sub(n,c.p,h.p),0===(d=ll.len(n))&&(ll.set(n,Math.random()-.5,Math.random()-.5),d=1);var g=(h.rep+c.rep)/d/d;!h.fixed&&$_(h.pp,h.pp,n,g),!c.fixed&&$_(c.pp,c.pp,n,-g)}for(var m=[],o=0;o<a;o++){var v=t[o];v.fixed||(ll.sub(m,v.p,v.pp),$_(v.p,v.p,m,u),ll.copy(v.pp,v.p))}u*=.992,i&&i(t,e,u<.01)}}}}.forceLayout,J_=F_.simpleLayout,Q_=q_.circularLayout,tb=Pu.linearMap,eb=function(t){t.eachSeriesByType("graph",function(t){if(!(c=t.coordinateSystem)||"view"===c.type)if("force"===t.get("layout")){var e=t.preservedPoints||{},i=t.getGraph(),n=i.data,a=i.edgeData,o=t.getModel("force"),r=o.get("initLayout");t.preservedPoints?n.each(function(t){var i=n.getId(t);n.setItemLayout(t,e[i]||[NaN,NaN])}):r&&"none"!==r?"circular"===r&&Q_(t):J_(t);var s=n.getDataExtent("value"),l=a.getDataExtent("value"),h=o.get("repulsion"),u=o.get("edgeLength");rl.isArray(h)||(h=[h,h]),rl.isArray(u)||(u=[u,u]),u=[u[1],u[0]];var c,d=n.mapArray("value",function(t,e){var i=n.getItemLayout(e),a=tb(t,s,h);return isNaN(a)&&(a=(h[0]+h[1])/2),{w:a,rep:a,fixed:n.getItemModel(e).get("fixed"),p:!i||isNaN(i[0])||isNaN(i[1])?null:i}}),p=a.mapArray("value",function(t,e){var n=i.getEdgeByIndex(e),a=tb(t,l,u);return isNaN(a)&&(a=(u[0]+u[1])/2),{n1:d[n.node1.dataIndex],n2:d[n.node2.dataIndex],d:a,curveness:n.getModel().get("lineStyle.normal.curveness")||0}}),f=(c=t.coordinateSystem).getBoundingRect(),g=K_(d,p,{rect:f,gravity:o.get("gravity")}),m=g.step;g.step=function(t){for(var a=0,o=d.length;a<o;a++)d[a].fixed&&ll.copy(d[a].p,i.getNodeByIndex(a).getLayout());m(function(a,o,r){for(var s=0,l=a.length;s<l;s++)a[s].fixed||i.getNodeByIndex(s).setLayout(a[s].p),e[n.getId(s)]=a[s].p;for(var s=0,l=o.length;s<l;s++){var h=o[s],u=i.getEdgeByIndex(s),c=h.n1.p,d=h.n2.p,p=u.getLayout();(p=p?p.slice():[])[0]=p[0]||[],p[1]=p[1]||[],ll.copy(p[0],c),ll.copy(p[1],d),+h.curveness&&(p[2]=[(c[0]+d[0])/2-(c[1]-d[1])*h.curveness,(c[1]+d[1])/2-(d[0]-c[0])*h.curveness]),u.setLayout(p)}t&&t(r)})},t.forceLayout=g,t.preservedPoints=e,g.step()}else t.forceLayout=null})},ib=Np.getLayoutRect,nb=function(t,e){var i=[];return t.eachSeriesByType("graph",function(t){var n=t.get("coordinateSystem");if(!n||"view"===n){var a=t.getData(),o=a.mapArray(function(t){var e=a.getItemModel(t);return[+e.get("x"),+e.get("y")]}),r=[],s=[];pc.fromPoints(o,r,s),s[0]-r[0]==0&&(s[0]+=1,r[0]-=1),s[1]-r[1]==0&&(s[1]+=1,r[1]-=1);var l=(s[0]-r[0])/(s[1]-r[1]),h=function(t,e,i){var n=t.getBoxLayoutParams();return n.aspect=i,ib(n,{width:e.getWidth(),height:e.getHeight()})}(t,e,l);isNaN(l)&&(r=[h.x,h.y],s=[h.x+h.width,h.y+h.height]);var u=s[0]-r[0],c=s[1]-r[1],d=h.width,p=h.height,f=t.coordinateSystem=new Iy;f.zoomLimit=t.get("scaleLimit"),f.setBoundingRect(r[0],r[1],u,c),f.setViewRect(h.x,h.y,d,p),f.setCenter(t.get("center")),f.setZoom(t.get("zoom")),i.push(f)}}),i};ym.registerProcessor(G_),ym.registerVisual(rl.curry(Fm,"graph","circle",null)),ym.registerVisual(H_),ym.registerVisual(W_),ym.registerLayout(U_),ym.registerLayout(Y_),ym.registerLayout(eb),ym.registerCoordinateSystem("graphView",{create:nb});zf.extend({type:"series.gauge",getInitialData:function(t,e){var i=new tg(["value"],this),n=t.data||[];return rl.isArray(n)||(n=[n]),i.initData(n),i},defaultOption:{zlevel:0,z:2,center:["50%","50%"],legendHoverLink:!0,radius:"75%",startAngle:225,endAngle:-45,clockwise:!0,min:0,max:100,splitNumber:10,axisLine:{show:!0,lineStyle:{color:[[.2,"#91c7ae"],[.8,"#63869e"],[1,"#c23531"]],width:30}},splitLine:{show:!0,length:30,lineStyle:{color:"#eee",width:2,type:"solid"}},axisTick:{show:!0,splitNumber:5,length:8,lineStyle:{color:"#eee",width:1,type:"solid"}},axisLabel:{show:!0,distance:5,color:"auto"},pointer:{show:!0,length:"80%",width:8},itemStyle:{normal:{color:"auto"}},title:{show:!0,offsetCenter:[0,"-40%"],color:"#333",fontSize:15},detail:{show:!0,backgroundColor:"rgba(0,0,0,0)",borderWidth:0,borderColor:"#ccc",width:100,height:null,padding:[5,10],offsetCenter:[0,"40%"],color:"auto",fontSize:30}}});var ab=Yc.extend({type:"echartsGaugePointer",shape:{angle:0,width:10,r:10,x:0,y:0},buildPath:function(t,e){var i=Math.cos,n=Math.sin,a=e.r,o=e.width,r=e.angle,s=e.x-i(r)*o*(o>=a/3?1:2),l=e.y-n(r)*o*(o>=a/3?1:2);r=e.angle-Math.PI/2,t.moveTo(s,l),t.lineTo(e.x+i(r)*o,e.y+n(r)*o),t.lineTo(e.x+i(e.angle)*a,e.y+n(e.angle)*a),t.lineTo(e.x-i(r)*o,e.y-n(r)*o),t.lineTo(s,l)}}),ob=Pu.parsePercent,rb=Pu.round,sb=Pu.linearMap,lb=2*Math.PI,hb=(Bf.extend({type:"gauge",render:function(t,e,i){this.group.removeAll();var n=t.get("axisLine.lineStyle.color"),a=function(t,e){var i=t.get("center"),n=e.getWidth(),a=e.getHeight(),o=Math.min(n,a);return{cx:ob(i[0],e.getWidth()),cy:ob(i[1],e.getHeight()),r:ob(t.get("radius"),o/2)}}(t,i);this._renderMain(t,e,i,n,a)},dispose:function(){},_renderMain:function(t,e,i,n,a){for(var o=this.group,r=t.getModel("axisLine").getModel("lineStyle"),s=t.get("clockwise"),l=-t.get("startAngle")/180*Math.PI,h=((p=-t.get("endAngle")/180*Math.PI)-l)%lb,u=l,c=r.get("width"),d=0;d<n.length;d++){var p=l+h*Math.min(Math.max(n[d][0],0),1),f=new fp.Sector({shape:{startAngle:u,endAngle:p,cx:a.cx,cy:a.cy,clockwise:s,r0:a.r-c,r:a.r},silent:!0});f.setStyle({fill:n[d][1]}),f.setStyle(r.getLineStyle(["color","borderWidth","borderColor"])),o.add(f),u=p}var g=function(t){if(t<=0)return n[0][1];for(var e=0;e<n.length;e++)if(n[e][0]>=t&&(0===e?0:n[e-1][0])<t)return n[e][1];return n[e-1][1]};if(!s){var m=l;l=p,p=m}this._renderTicks(t,e,i,g,a,l,p,s),this._renderPointer(t,e,i,g,a,l,p,s),this._renderTitle(t,e,i,g,a),this._renderDetail(t,e,i,g,a)},_renderTicks:function(t,e,i,n,a,o,r,s){for(var l=this.group,h=a.cx,u=a.cy,c=a.r,d=+t.get("min"),p=+t.get("max"),f=t.getModel("splitLine"),g=t.getModel("axisTick"),m=t.getModel("axisLabel"),v=t.get("splitNumber"),y=g.get("splitNumber"),x=ob(f.get("length"),c),_=ob(g.get("length"),c),b=o,w=(r-o)/v,S=w/y,M=f.getModel("lineStyle").getLineStyle(),I=g.getModel("lineStyle").getLineStyle(),T=0;T<=v;T++){var A=Math.cos(b),C=Math.sin(b);if(f.get("show")){var L=new fp.Line({shape:{x1:A*c+h,y1:C*c+u,x2:A*(c-x)+h,y2:C*(c-x)+u},style:M,silent:!0});"auto"===M.stroke&&L.setStyle({stroke:n(T/v)}),l.add(L)}if(m.get("show")){var D=ra(rb(T/v*(p-d)+d),m.get("formatter")),P=m.get("distance"),k=n(T/v);l.add(new fp.Text({style:fp.setTextStyle({},m,{text:D,x:A*(c-x-P)+h,y:C*(c-x-P)+u,textVerticalAlign:C<-.4?"top":C>.4?"bottom":"middle",textAlign:A<-.4?"left":A>.4?"right":"center"},{autoColor:k}),silent:!0}))}if(g.get("show")&&T!==v){for(var O=0;O<=y;O++){var A=Math.cos(b),C=Math.sin(b),z=new fp.Line({shape:{x1:A*c+h,y1:C*c+u,x2:A*(c-_)+h,y2:C*(c-_)+u},silent:!0,style:I});"auto"===I.stroke&&z.setStyle({stroke:n((T+O/y)/v)}),l.add(z),b+=S}b-=S}else b+=w}},_renderPointer:function(t,e,i,n,a,o,r,s){var l=this.group,h=this._data;if(t.get("pointer.show")){var u=[+t.get("min"),+t.get("max")],c=[o,r],d=t.getData();d.diff(h).add(function(e){var i=new ab({shape:{angle:o}});fp.initProps(i,{shape:{angle:sb(d.get("value",e),u,c,!0)}},t),l.add(i),d.setItemGraphicEl(e,i)}).update(function(e,i){var n=h.getItemGraphicEl(i);fp.updateProps(n,{shape:{angle:sb(d.get("value",e),u,c,!0)}},t),l.add(n),d.setItemGraphicEl(e,n)}).remove(function(t){var e=h.getItemGraphicEl(t);l.remove(e)}).execute(),d.eachItemGraphicEl(function(t,e){var i=d.getItemModel(e),o=i.getModel("pointer");t.setShape({x:a.cx,y:a.cy,width:ob(o.get("width"),a.r),r:ob(o.get("length"),a.r)}),t.useStyle(i.getModel("itemStyle.normal").getItemStyle()),"auto"===t.style.fill&&t.setStyle("fill",n(sb(d.get("value",e),u,[0,1],!0))),fp.setHoverStyle(t,i.getModel("itemStyle.emphasis").getItemStyle())}),this._data=d}else h&&h.eachItemGraphicEl(function(t){l.remove(t)})},_renderTitle:function(t,e,i,n,a){var o=t.getModel("title");if(o.get("show")){var r=o.get("offsetCenter"),s=a.cx+ob(r[0],a.r),l=a.cy+ob(r[1],a.r),h=+t.get("min"),u=+t.get("max"),c=t.getData().get("value",0),d=n(sb(c,[h,u],[0,1],!0));this.group.add(new fp.Text({silent:!0,style:fp.setTextStyle({},o,{x:s,y:l,text:t.getData().getName(0),textAlign:"center",textVerticalAlign:"middle"},{autoColor:d,forceRich:!0})}))}},_renderDetail:function(t,e,i,n,a){var o=t.getModel("detail"),r=+t.get("min"),s=+t.get("max");if(o.get("show")){var l=o.get("offsetCenter"),h=a.cx+ob(l[0],a.r),u=a.cy+ob(l[1],a.r),c=ob(o.get("width"),a.r),d=ob(o.get("height"),a.r),p=t.getData().get("value",0),f=n(sb(p,[r,s],[0,1],!0));this.group.add(new fp.Text({silent:!0,style:fp.setTextStyle({},o,{x:h,y:u,text:ra(p,o.get("formatter")),textWidth:isNaN(c)?null:c,textHeight:isNaN(d)?null:d,textAlign:"center",textVerticalAlign:"middle"},{autoColor:f,forceRich:!0})}))}}}),Ip.defaultEmphasis),ub=ym.extendSeriesModel({type:"series.funnel",init:function(t){ub.superApply(this,"init",arguments),this.legendDataProvider=function(){return this.getRawData()},this._defaultLabelLine(t)},getInitialData:function(t,e){var i=sg(["value"],t.data),n=new tg(i,this);return n.initData(t.data),n},_defaultLabelLine:function(t){hb(t.labelLine,["show"]);var e=t.labelLine.normal,i=t.labelLine.emphasis;e.show=e.show&&t.label.normal.show,i.show=i.show&&t.label.emphasis.show},getDataParams:function(t){var e=this.getData(),i=ub.superCall(this,"getDataParams",t),n=e.getSum("value");return i.percent=n?+(e.get("value",t)/n*100).toFixed(2):0,i.$vars.push("percent"),i},defaultOption:{zlevel:0,z:2,legendHoverLink:!0,left:80,top:60,right:80,bottom:60,minSize:"0%",maxSize:"100%",sort:"descending",gap:0,funnelAlign:"center",label:{normal:{show:!0,position:"outer"},emphasis:{show:!0}},labelLine:{normal:{show:!0,length:20,lineStyle:{width:1,type:"solid"}},emphasis:{}},itemStyle:{normal:{borderColor:"#fff",borderWidth:1},emphasis:{}}}}),cb=sa.prototype,db=["itemStyle","normal","opacity"];cb.updateData=function(t,e,i){var n=this.childAt(0),a=t.hostModel,o=t.getItemModel(e),r=t.getItemLayout(e),s=t.getItemModel(e).get(db);s=null==s?1:s,n.useStyle({}),i?(n.setShape({points:r.points}),n.setStyle({opacity:0}),fp.initProps(n,{style:{opacity:s}},a,e)):fp.updateProps(n,{style:{opacity:s},shape:{points:r.points}},a,e);var l=o.getModel("itemStyle"),h=t.getItemVisual(e,"color");n.setStyle(rl.defaults({lineJoin:"round",fill:h},l.getModel("normal").getItemStyle(["opacity"]))),n.hoverStyle=l.getModel("emphasis").getItemStyle(),this._updateLabel(t,e),fp.setHoverStyle(this)},cb._updateLabel=function(t,e){var i=this.childAt(1),n=this.childAt(2),a=t.hostModel,o=t.getItemModel(e),r=t.getItemLayout(e).label,s=t.getItemVisual(e,"color");fp.updateProps(i,{shape:{points:r.linePoints||r.linePoints}},a,e),fp.updateProps(n,{style:{x:r.x,y:r.y}},a,e),n.attr({rotation:r.rotation,origin:[r.x,r.y],z2:10});var l=o.getModel("label.normal"),h=o.getModel("label.emphasis"),u=o.getModel("labelLine.normal"),c=o.getModel("labelLine.emphasis"),s=t.getItemVisual(e,"color");fp.setLabelStyle(n.style,n.hoverStyle={},l,h,{labelFetcher:t.hostModel,labelDataIndex:e,defaultText:t.getName(e),autoColor:s,useInsideStyle:!!r.inside},{textAlign:r.textAlign,textVerticalAlign:r.verticalAlign}),n.ignore=n.normalIgnore=!l.get("show"),n.hoverIgnore=!h.get("show"),i.ignore=i.normalIgnore=!u.get("show"),i.hoverIgnore=!c.get("show"),i.setStyle({stroke:s}),i.setStyle(u.getModel("lineStyle").getLineStyle()),i.hoverStyle=c.getModel("lineStyle").getLineStyle()},rl.inherits(sa,fp.Group);Bf.extend({type:"funnel",render:function(t,e,i){var n=t.getData(),a=this._data,o=this.group;n.diff(a).add(function(t){var e=new sa(n,t);n.setItemGraphicEl(t,e),o.add(e)}).update(function(t,e){var i=a.getItemGraphicEl(e);i.updateData(n,t),o.add(i),n.setItemGraphicEl(t,i)}).remove(function(t){var e=a.getItemGraphicEl(t);o.remove(e)}).execute(),this._data=n},remove:function(){this.group.removeAll(),this._data=null},dispose:function(){}});var pb=Pu.parsePercent,fb=Pu.linearMap,gb=function(t,e,i){t.eachSeriesByType("funnel",function(t){var i=t.getData(),n=t.get("sort"),a=function(t,e){return Np.getLayoutRect(t.getBoxLayoutParams(),{width:e.getWidth(),height:e.getHeight()})}(t,e),o=function(t,e){for(var i=t.mapArray("value",function(t){return t}),n=[],a="ascending"===e,o=0,r=t.count();o<r;o++)n[o]=o;return"function"==typeof e?n.sort(e):"none"!==e&&n.sort(function(t,e){return a?i[t]-i[e]:i[e]-i[t]}),n}(i,n),r=[pb(t.get("minSize"),a.width),pb(t.get("maxSize"),a.width)],s=i.getDataExtent("value"),l=t.get("min"),h=t.get("max");null==l&&(l=Math.min(s[0],0)),null==h&&(h=s[1]);var u=t.get("funnelAlign"),c=t.get("gap"),d=(a.height-c*(i.count()-1))/i.count(),p=a.y,f=function(t,e){var n,o=i.get("value",t)||0,s=fb(o,[l,h],r,!0);switch(u){case"left":n=a.x;break;case"center":n=a.x+(a.width-s)/2;break;case"right":n=a.x+a.width-s}return[[n,e],[n+s,e]]};"ascending"===n&&(d=-d,c=-c,p+=a.height,o=o.reverse());for(var g=0;g<o.length;g++){var m=o[g],v=o[g+1],y=f(m,p),x=f(v,p+d);p+=d+c,i.setItemLayout(m,{points:y.concat(x.slice().reverse())})}!function(t){t.each(function(e){var i,n,a,o,r=t.getItemModel(e),s=r.getModel("label.normal").get("position"),l=r.getModel("labelLine.normal"),h=t.getItemLayout(e),u=h.points,c="inner"===s||"inside"===s||"center"===s;if(c)i="center",o=[[n=(u[0][0]+u[1][0]+u[2][0]+u[3][0])/4,a=(u[0][1]+u[1][1]+u[2][1]+u[3][1])/4],[n,a]];else{var d,p,f,g=l.get("length");"left"===s?(d=(u[3][0]+u[0][0])/2,p=(u[3][1]+u[0][1])/2,n=(f=d-g)-5,i="right"):(d=(u[1][0]+u[2][0])/2,p=(u[1][1]+u[2][1])/2,n=(f=d+g)+5,i="left");var m=p;o=[[d,p],[f,m]],a=m}h.label={linePoints:o,x:n,y:a,verticalAlign:"middle",textAlign:i,inside:c}})}(i)})};ym.registerVisual(rl.curry(ny,"funnel")),ym.registerLayout(gb),ym.registerProcessor(rl.curry(uy,"funnel"));var mb=function(t){!function(t){if(!t.parallel){var e=!1;rl.each(t.series,function(t){t&&"parallel"===t.type&&(e=!0)}),e&&(t.parallel=[{}])}}(t),function(t){var e=Ip.normalizeToArray(t.parallelAxis);rl.each(e,function(e){if(rl.isObject(e)){var i=e.parallelIndex||0,n=Ip.normalizeToArray(t.parallel)[i];n&&n.parallelAxisDefault&&rl.merge(e,n.parallelAxisDefault,!1)}})}(t)},vb=function(t,e,i,n,a){Kg.call(this,t,e,i),this.type=n||"value",this.axisIndex=a};vb.prototype={constructor:vb,model:null,isHorizontal:function(){return"horizontal"!==this.coordinateSystem.getModel().get("layout")}},rl.inherits(vb,Kg);var yb=vb,xb=function(t,e,i,n,a,o){e[0]=ha(e[0],i),e[1]=ha(e[1],i),t=t||0;var r=i[1]-i[0];null!=a&&(a=ha(a,[0,r])),null!=o&&(o=Math.max(o,null!=a?a:0)),"all"===n&&(a=o=Math.abs(e[1]-e[0]),n=0);var s=la(e,n);e[n]+=t;var l=a||0,h=i.slice();s.sign<0?h[0]+=l:h[1]-=l,e[n]=ha(e[n],h),u=la(e,n),null!=a&&(u.sign!==s.sign||u.span<a)&&(e[1-n]=e[n]+s.sign*a);var u=la(e,n);return null!=o&&u.span>o&&(e[1-n]=e[n]+u.sign*o),e},_b=rl.each,bb=Math.min,wb=Math.max,Sb=Math.floor,Mb=Math.ceil,Ib=Pu.round,Tb=Math.PI;ua.prototype={type:"parallel",constructor:ua,_init:function(t,e,i){var n=t.dimensions,a=t.parallelAxisIndex;_b(n,function(t,i){var n=a[i],o=e.getComponent("parallelAxis",n),r=this._axesMap.set(t,new yb(t,Rg.createScaleByModel(o),[0,0],o.get("type"),n)),s="category"===r.type;r.onBand=s&&o.get("boundaryGap"),r.inverse=o.get("inverse"),o.axis=r,r.model=o,r.coordinateSystem=o.coordinateSystem=this},this)},update:function(t,e){this._updateAxesFromSeries(this._model,t)},containPoint:function(t){var e=this._makeLayoutInfo(),i=e.axisBase,n=e.layoutBase,a=e.pixelDimIndex,o=t[1-a],r=t[a];return o>=i&&o<=i+e.axisLength&&r>=n&&r<=n+e.layoutLength},getModel:function(){return this._model},_updateAxesFromSeries:function(t,e){e.eachSeries(function(i){if(t.contains(i,e)){var n=i.getData();_b(this.dimensions,function(t){var e=this._axesMap.get(t);e.scale.unionExtentFromData(n,t),Rg.niceScaleExtent(e.scale,e.model)},this)}},this)},resize:function(t,e){this._rect=Np.getLayoutRect(t.getBoxLayoutParams(),{width:e.getWidth(),height:e.getHeight()}),this._layoutAxes()},getRect:function(){return this._rect},_makeLayoutInfo:function(){var t,e=this._model,i=this._rect,n=["x","y"],a=["width","height"],o=e.get("layout"),r="horizontal"===o?0:1,s=i[a[r]],l=[0,s],h=this.dimensions.length,u=ca(e.get("axisExpandWidth"),l),c=ca(e.get("axisExpandCount")||0,[0,h]),d=e.get("axisExpandable")&&h>3&&h>c&&c>1&&u>0&&s>0,p=e.get("axisExpandWindow");if(p)t=ca(p[1]-p[0],l),p[1]=p[0]+t;else{t=ca(u*(c-1),l);(p=[u*(e.get("axisExpandCenter")||Sb(h/2))-t/2])[1]=p[0]+t}var f=(s-t)/(h-c);f<3&&(f=0);var g=[Sb(Ib(p[0]/u,1))+1,Mb(Ib(p[1]/u,1))-1],m=f/u*p[0];return{layout:o,pixelDimIndex:r,layoutBase:i[n[r]],layoutLength:s,axisBase:i[n[1-r]],axisLength:i[a[1-r]],axisExpandable:d,axisExpandWidth:u,axisCollapseWidth:f,axisExpandWindow:p,axisCount:h,winInnerIndices:g,axisExpandWindow0Pos:m}},_layoutAxes:function(){var t=this._rect,e=this._axesMap,i=this.dimensions,n=this._makeLayoutInfo(),a=n.layout;e.each(function(t){var e=[0,n.axisLength],i=t.inverse?1:0;t.setExtent(e[i],e[1-i])}),_b(i,function(i,o){var r=(n.axisExpandable?function(t,e){var i,n,a=e.layoutLength,o=e.axisExpandWidth,r=e.axisCount,s=e.axisCollapseWidth,l=e.winInnerIndices,h=s,u=!1;return t<l[0]?(i=t*s,n=s):t<=l[1]?(i=e.axisExpandWindow0Pos+t*o-e.axisExpandWindow[0],h=o,u=!0):(i=a-(r-1-t)*s,n=s),{position:i,axisNameAvailableWidth:h,axisLabelShow:u,nameTruncateMaxWidth:n}}:function(t,e){var i=e.layoutLength/(e.axisCount-1);return{position:i*t,axisNameAvailableWidth:i,axisLabelShow:!0}})(o,n),s={horizontal:{x:r.position,y:n.axisLength},vertical:{x:0,y:r.position}},l={horizontal:Tb/2,vertical:0},h=[s[a].x+t.x,s[a].y+t.y],u=l[a],c=yl.create();yl.rotate(c,c,u),yl.translate(c,c,h),this._axesLayout[i]={position:h,rotation:u,transform:c,axisNameAvailableWidth:r.axisNameAvailableWidth,axisLabelShow:r.axisLabelShow,nameTruncateMaxWidth:r.nameTruncateMaxWidth,tickDirection:1,labelDirection:1,labelInterval:e.get(i).getLabelInterval()}},this)},getAxis:function(t){return this._axesMap.get(t)},dataToPoint:function(t,e){return this.axisCoordToPoint(this._axesMap.get(e).dataToCoord(t),e)},eachActiveState:function(t,e,i){for(var n=this.dimensions,a=this._axesMap,o=this.hasAxisBrushed(),r=0,s=t.count();r<s;r++){var l,h=t.getValues(n,r);if(o){l="active";for(var u=0,c=n.length;u<c;u++){var d=n[u];if("inactive"===a.get(d).model.getActiveState(h[u],u)){l="inactive";break}}}else l="normal";e.call(i,l,r)}},hasAxisBrushed:function(){for(var t=this.dimensions,e=this._axesMap,i=!1,n=0,a=t.length;n<a;n++)"normal"!==e.get(t[n]).model.getActiveState()&&(i=!0);return i},axisCoordToPoint:function(t,e){var i=this._axesLayout[e];return fp.applyTransform([t,0],i.transform)},getAxisLayout:function(t){return rl.clone(this._axesLayout[t])},getSlidedAxisExpandWindow:function(t){var e=this._makeLayoutInfo(),i=e.pixelDimIndex,n=e.axisExpandWindow.slice(),a=n[1]-n[0],o=[0,e.axisExpandWidth*(e.axisCount-1)];if(!this.containPoint(t))return{behavior:"none",axisExpandWindow:n};var r,s=t[i]-e.layoutBase-e.axisExpandWindow0Pos,l="slide",h=e.axisCollapseWidth,u=this._model.get("axisExpandSlideTriggerArea"),c=null!=u[0];if(h)c&&h&&s<a*u[0]?(l="jump",r=s-a*u[2]):c&&h&&s>a*(1-u[0])?(l="jump",r=s-a*(1-u[2])):(r=s-a*u[1])>=0&&(r=s-a*(1-u[1]))<=0&&(r=0),(r*=e.axisExpandWidth/h)?xb(r,n,o,"all"):l="none";else{a=n[1]-n[0];(n=[wb(0,o[1]*s/a-a/2)])[1]=bb(o[1],n[0]+a),n[0]=n[1]-a}return{axisExpandWindow:n,behavior:l}}};var Ab=ua;rf.register("parallel",{create:function(t,e){var i=[];return t.eachComponent("parallel",function(n,a){var o=new Ab(n,t,e);o.name="parallel_"+a,o.resize(n,e),n.coordinateSystem=o,o.model=n,i.push(o)}),t.eachSeries(function(e){if("parallel"===e.get("coordinateSystem")){var i=t.queryComponents({mainType:"parallel",index:e.get("parallelIndex"),id:e.get("parallelId")})[0];e.coordinateSystem=i.coordinateSystem}}),i}});var Cb=Hp.extend({type:"baseParallelAxis",axis:null,activeIntervals:[],getAreaSelectStyle:function(){return Gu([["fill","color"],["lineWidth","borderWidth"],["stroke","borderColor"],["width","width"],["opacity","opacity"]])(this.getModel("areaSelectStyle"))},setActiveIntervals:function(t){var e=this.activeIntervals=rl.clone(t);if(e)for(var i=e.length-1;i>=0;i--)Pu.asc(e[i])},getActiveState:function(t){var e=this.activeIntervals;if(!e.length)return"normal";if(null==t)return"inactive";for(var i=0,n=e.length;i<n;i++)if(e[i][0]<=t&&t<=e[i][1])return"active";return"inactive"}});rl.merge(Cb.prototype,Ng),ov("parallel",Cb,function(t,e){return e.type||(e.data?"category":"value")},{type:"value",dim:null,areaSelectStyle:{width:20,borderWidth:1,borderColor:"rgba(160,197,232)",color:"rgba(160,197,232)",opacity:.3},realtime:!0,z:10});Hp.extend({type:"parallel",dependencies:["parallelAxis"],coordinateSystem:null,dimensions:null,parallelAxisIndex:null,layoutMode:"box",defaultOption:{zlevel:0,z:0,left:80,top:60,right:80,bottom:60,layout:"horizontal",axisExpandable:!1,axisExpandCenter:null,axisExpandCount:0,axisExpandWidth:50,axisExpandRate:17,axisExpandDebounce:50,axisExpandSlideTriggerArea:[-.15,.05,.4],axisExpandTriggerOn:"click",parallelAxisDefault:null},init:function(){Hp.prototype.init.apply(this,arguments),this.mergeOption({})},mergeOption:function(t){var e=this.option;t&&rl.merge(e,t,!0),this._initDimensions()},contains:function(t,e){var i=t.get("parallelIndex");return null!=i&&e.getComponent("parallel",i)===this},setAxisExpand:function(t){rl.each(["axisExpandable","axisExpandCenter","axisExpandCount","axisExpandWidth","axisExpandWindow"],function(e){t.hasOwnProperty(e)&&(this.option[e]=t[e])},this)},_initDimensions:function(){var t=this.dimensions=[],e=this.parallelAxisIndex=[],i=rl.filter(this.dependentModels.parallelAxis,function(t){return(t.get("parallelIndex")||0)===this.componentIndex},this);rl.each(i,function(i){t.push("dim"+i.get("dim")),e.push(i.componentIndex)})}});ym.registerAction({type:"axisAreaSelect",event:"axisAreaSelected",update:"updateVisual"},function(t,e){e.eachComponent({mainType:"parallelAxis",query:t},function(e){e.axis.model.setActiveIntervals(t.intervals)})}),ym.registerAction("parallelAxisExpand",function(t,e){e.eachComponent({mainType:"parallel",query:t},function(e){e.setAxisExpand(t)})});var Lb=rl.curry,Db=rl.each,Pb=rl.map,kb=Math.min,Ob=Math.max,zb=Math.pow,Eb=1e4,Rb=6,Nb=6,Vb="globalPan",Bb={w:[0,0],e:[0,1],n:[1,0],s:[1,1]},Gb={w:"ew",e:"ew",n:"ns",s:"ns",ne:"nesw",sw:"nesw",nw:"nwse",se:"nwse"},Hb={brushStyle:{lineWidth:2,stroke:"rgba(0,0,0,0.3)",fill:"rgba(0,0,0,0.1)"},transformable:!0,brushMode:"single",removeOnClick:!1},Wb=0;da.prototype={constructor:da,enableBrush:function(t){return this._brushType&&function(t){var e=t._zr;Hy.release(e,Vb,t._uid),Db(t._handlers,function(t,i){e.off(i,t)}),t._brushType=t._brushOption=null}(this),t.brushType&&function(t,e){var i=t._zr;t._enableGlobalPan||Hy.take(i,Vb,t._uid),Db(t._handlers,function(t,e){i.on(e,t)}),t._brushType=e.brushType,t._brushOption=rl.merge(rl.clone(Hb),e,!0)}(this,t),this},setPanels:function(t){if(t&&t.length){var e=this._panels={};rl.each(t,function(t){e[t.panelId]=rl.clone(t)})}else this._panels=null;return this},mount:function(t){t=t||{},this._enableGlobalPan=t.enableGlobalPan;var e=this.group;return this._zr.add(e),e.attr({position:t.position||[0,0],rotation:t.rotation||0,scale:t.scale||[1,1]}),this._transform=e.getLocalTransform(),this},eachCover:function(t,e){Db(this._covers,t,e)},updateCovers:function(t){function e(t,e){return(null!=t.id?t.id:n+e)+"-"+t.brushType}function i(e,i){var n=t[e];if(null!=i&&a[i]===s)o[e]=a[i];else{var l=o[e]=null!=i?(a[i].__brushOption=n,a[i]):fa(r,pa(r,n));va(r,l)}}t=rl.map(t,function(t){return rl.merge(rl.clone(Hb),t,!0)});var n="\0-brush-index-",a=this._covers,o=this._covers=[],r=this,s=this._creatingCover;return new qf(a,t,function(t,i){return e(t.__brushOption,i)},e).add(i).update(i).remove(function(t){a[t]!==s&&r.group.remove(a[t])}).execute(),this},unmount:function(){return this.enableBrush(!1),ba(this),this._zr.remove(this.group),this},dispose:function(){this.unmount(),this.off()}},rl.mixin(da,dl);var Fb={mousedown:function(t){if(this._dragging)Va.call(this,t);else if(!t.target||!t.target.draggable){za(t);var e=this.group.transformCoordToLocal(t.offsetX,t.offsetY);this._creatingCover=null;(this._creatingPanel=xa(this,t,e))&&(this._dragging=!0,this._track=[e.slice()])}},mousemove:function(t){var e=this.group.transformCoordToLocal(t.offsetX,t.offsetY);if(function(t,e,i){if(t._brushType){var n=t._zr,a=t._covers,o=xa(t,e,i);if(!t._dragging)for(var r=0;r<a.length;r++){var s=a[r].__brushOption;if(o&&(!0===o||s.panelId===o.panelId)&&Zb[s.brushType].contain(a[r],i[0],i[1]))return}o&&n.setCursorStyle("crosshair")}}(this,t,e),this._dragging){za(t);var i=Ra(this,t,e,!1);i&&wa(this,i)}},mouseup:Va},Zb={lineX:Ba(0),lineY:Ba(1),rect:{createCover:function(t,e){return Ma(Lb(Pa,function(t){return t},function(t){return t}),t,e,["w","e","n","s","se","sw","ne","nw"])},getCreatingRange:function(t){var e=Sa(t);return La(e[1][0],e[1][1],e[0][0],e[0][1])},updateCoverShape:function(t,e,i,n){Ia(t,e,i,n)},updateCommon:Ta,contain:Ea},polygon:{createCover:function(t,e){var i=new fp.Group;return i.add(new fp.Polyline({name:"main",style:Ca(e),silent:!0})),i},getCreatingRange:function(t){return t},endCreating:function(t,e){e.remove(e.childAt(0)),e.add(new fp.Polygon({name:"main",draggable:!0,drift:Lb(function(t,e,i,n,a){var o=e.__brushOption.range,r=ka(t,i,n);Db(o,function(t){t[0]+=r[0],t[1]+=r[1]}),va(t,e),wa(t,{isEnd:!1})},t,e),ondragend:Lb(wa,t,{isEnd:!0})}))},updateCoverShape:function(t,e,i,n){e.childAt(0).setShape({points:Oa(t,e,i)})},updateCommon:Ta,contain:Ea}},jb=da,Ub=jy.onIrrelevantElement,qb={makeRectPanelClipPath:function(t){return t=Ga(t),function(e,i){return fp.clipPointsByRect(e,t)}},makeLinearBrushOtherExtent:function(t,e){return t=Ga(t),function(i){var n=null!=e?e:i,a=n?t.width:t.height,o=n?t.x:t.y;return[o,o+(a||0)]}},makeRectIsTargetByCursor:function(t,e,i){return t=Ga(t),function(n,a,o){return t.contain(a[0],a[1])&&!Ub(n,e,i)}}},Xb=["axisLine","axisTickLabel","axisName"],Yb=ym.extendComponentView({type:"parallelAxis",init:function(t,e){Yb.superApply(this,"init",arguments),(this._brushController=new jb(e.getZr())).on("brush",rl.bind(this._onBrush,this))},render:function(t,e,i,n){if(!function(t,e,i){return i&&"axisAreaSelect"===i.type&&e.findComponents({mainType:"parallelAxis",query:i})[0]===t}(t,e,n)){this.axisModel=t,this.api=i,this.group.removeAll();var a=this._axisGroup;if(this._axisGroup=new fp.Group,this.group.add(this._axisGroup),t.get("show")){var o=function(t,e){return e.getComponent("parallel",t.get("parallelIndex"))}(t,e),r=o.coordinateSystem,s=t.getAreaSelectStyle(),l=s.width,h=t.axis.dim,u=r.getAxisLayout(h),c=rl.extend({strokeContainThreshold:l},u),d=new Cv(t,c);rl.each(Xb,d.add,d),this._axisGroup.add(d.getGroup()),this._refreshBrushController(c,s,t,o,l,i);var p=n&&!1===n.animation?null:t;fp.groupTransition(a,this._axisGroup,p)}}},updateVisual:function(t,e,i,n){this._brushController&&this._brushController.updateCovers(Ha(t))},_refreshBrushController:function(t,e,i,n,a,o){var r=i.axis.getExtent(),s=r[1]-r[0],l=Math.min(30,.1*Math.abs(s)),h=fp.BoundingRect.create({x:r[0],y:-a/2,width:s,height:a});h.x-=l,h.width+=2*l,this._brushController.mount({enableGlobalPan:!0,rotation:t.rotation,position:t.position}).setPanels([{panelId:"pl",clipPath:qb.makeRectPanelClipPath(h),isTargetByCursor:qb.makeRectIsTargetByCursor(h,o,n),getLinearBrushOtherExtent:qb.makeLinearBrushOtherExtent(h,0)}]).enableBrush({brushType:"lineX",brushStyle:e,removeOnClick:!0}).updateCovers(Ha(i))},_onBrush:function(t,e){var i=this.axisModel,n=i.axis,a=rl.map(t,function(t){return[n.coordToData(t.range[0],!0),n.coordToData(t.range[1],!0)]});(!i.option.realtime===e.isEnd||e.removeOnClick)&&this.api.dispatchAction({type:"axisAreaSelect",parallelAxisId:i.id,intervals:a})},dispose:function(){this._brushController.dispose()}});ym.extendComponentView({type:"parallel",render:function(t,e,i){this._model=t,this._api=i,this._handlers||(this._handlers={},rl.each($b,function(t,e){i.getZr().on(e,this._handlers[e]=rl.bind(t,this))},this)),Ff.createOrUpdate(this,"_throttledDispatchExpand",t.get("axisExpandRate"),"fixRate")},dispose:function(t,e){rl.each(this._handlers,function(t,i){e.getZr().off(i,t)}),this._handlers=null},_throttledDispatchExpand:function(t){this._dispatchExpand(t)},_dispatchExpand:function(t){t&&this._api.dispatchAction(rl.extend({type:"parallelAxisExpand"},t))}});var $b={mousedown:function(t){Wa(this,"click")&&(this._mouseDownPoint=[t.offsetX,t.offsetY])},mouseup:function(t){var e=this._mouseDownPoint;if(Wa(this,"click")&&e){var i=[t.offsetX,t.offsetY];if(Math.pow(e[0]-i[0],2)+Math.pow(e[1]-i[1],2)>5)return;var n=this._model.coordinateSystem.getSlidedAxisExpandWindow([t.offsetX,t.offsetY]);"none"!==n.behavior&&this._dispatchExpand({axisExpandWindow:n.axisExpandWindow})}this._mouseDownPoint=null},mousemove:function(t){if(!this._mouseDownPoint&&Wa(this,"mousemove")){var e=this._model,i=e.coordinateSystem.getSlidedAxisExpandWindow([t.offsetX,t.offsetY]),n=i.behavior;"jump"===n&&this._throttledDispatchExpand.debounceNextCall(e.get("axisExpandDebounce")),this._throttledDispatchExpand("none"===n?null:{axisExpandWindow:i.axisExpandWindow,animation:"jump"===n&&null})}}};ym.registerPreprocessor(mb);zf.extend({type:"series.parallel",dependencies:["parallel"],visualColorAccessPath:"lineStyle.normal.color",getInitialData:function(t,e){var i=e.getComponent("parallel",this.get("parallelIndex")),n=i.parallelAxisIndex,a=t.data,o=i.dimensions,r=function(t,e){var i=0;rl.each(t,function(t){var e=Fa(t);e>i&&(i=e)});var n=e[0];n&&n.length-1>i&&(i=n.length-1);for(var a=[],o=0;o<=i;o++)a.push("dim"+o);return a}(o,a),s=rl.map(r,function(t,i){var r=rl.indexOf(o,t),s=r>=0&&e.getComponent("parallelAxis",n[r]);return s&&"category"===s.get("type")?(function(t,e,i){var n=t.get("data"),a=Fa(e);n&&n.length&&rl.each(i,function(t){if(t){var e=rl.indexOf(n,t[a]);t[a]=e>=0?e:NaN}})}(s,t,a),{name:t,type:"ordinal"}):r<0&&sg.guessOrdinal(a,i)?{name:t,type:"ordinal"}:t}),l=new tg(s,this);return l.initData(a),this.option.progressive&&(this.option.animation=!1),l},getRawIndicesByActiveState:function(t){var e=this.coordinateSystem,i=this.getData(),n=[];return e.eachActiveState(i,function(e,a){t===e&&n.push(i.getRawIndex(a))}),n},defaultOption:{zlevel:0,z:2,coordinateSystem:"parallel",parallelIndex:0,label:{normal:{show:!1},emphasis:{show:!1}},inactiveOpacity:.05,activeOpacity:1,lineStyle:{normal:{width:1,opacity:.45,type:"solid"}},progressive:!1,smooth:!1,animationEasing:"linear"}}),Bf.extend({type:"parallel",init:function(){this._dataGroup=new fp.Group,this.group.add(this._dataGroup),this._data},render:function(t,e,i,n){this._renderForNormal(t,n)},dispose:function(){},_renderForNormal:function(t,e){var i=this._dataGroup,n=t.getData(),a=this._data,o=t.coordinateSystem,r=o.dimensions,s=t.option.smooth?.3:null;if(n.diff(a).add(function(t){!function(t,e,i,n,a){var o=Za(t,i,n,a),r=new fp.Polyline({shape:{points:o},silent:!0,z2:10});e.add(r),t.setItemGraphicEl(i,r)}(n,i,t,r,o)}).update(function(i,s){var l=a.getItemGraphicEl(s),h=Za(n,i,r,o);n.setItemGraphicEl(i,l);var u=e&&!1===e.animation?null:t;fp.updateProps(l,{shape:{points:h}},u,i)}).remove(function(t){var e=a.getItemGraphicEl(t);i.remove(e)}).execute(),function(t,e){var i=t.hostModel.getModel("lineStyle.normal"),n=i.getLineStyle();t.eachItemGraphicEl(function(a,o){if(t.hasItemOption){var r=t.getItemModel(o).getModel("lineStyle.normal",i);n=r.getLineStyle(["color","stroke"])}a.useStyle(rl.extend(n,{fill:null,stroke:t.getItemVisual(o,"color"),opacity:t.getItemVisual(o,"opacity")})),a.shape.smooth=e})}(n,s),!this._data){var l=function(t,e,i){var n=t.model,a=t.getRect(),o=new fp.Rect({shape:{x:a.x,y:a.y,width:a.width,height:a.height}}),r="horizontal"===n.get("layout")?"width":"height";return o.setShape(r,0),fp.initProps(o,{shape:{width:a.width,height:a.height}},e,i),o}(o,t,function(){setTimeout(function(){i.removeClipPath()})});i.setClipPath(l)}this._data=n},remove:function(){this._dataGroup&&this._dataGroup.removeAll(),this._data=null}});var Kb=["lineStyle","normal","opacity"],Jb=function(t){t.eachSeriesByType("parallel",function(e){var i=e.getModel("itemStyle.normal"),n=e.getModel("lineStyle.normal"),a=t.get("color"),o=n.get("color")||i.get("color")||a[e.seriesIndex%a.length],r=e.get("inactiveOpacity"),s=e.get("activeOpacity"),l=e.getModel("lineStyle.normal").getLineStyle(),h=e.coordinateSystem,u=e.getData(),c={normal:l.opacity,active:s,inactive:r};h.eachActiveState(u,function(t,e){var i=u.getItemModel(e),n=c[t];if("normal"===t){var a=i.get(Kb,!0);null!=a&&(n=a)}u.setItemVisual(e,"opacity",n)}),u.setVisual("color",o)})};ym.registerVisual(Jb);var Qb=Eu.encodeHTML,tw=zf.extend({type:"series.sankey",layoutInfo:null,getInitialData:function(t){var e=t.edges||t.links,i=t.data||t.nodes;if(i&&e){return m_(i,e,this,!0).data}},getGraph:function(){return this.getData().graph},getEdgeData:function(){return this.getGraph().edgeData},formatTooltip:function(t,e,i){if("edge"===i){var n=this.getDataParams(t,i),a=n.data,o=a.source+" -- "+a.target;return n.value&&(o+=" : "+n.value),Qb(o)}return tw.superCall(this,"formatTooltip",t,e)},defaultOption:{zlevel:0,z:2,coordinateSystem:"view",layout:null,left:"5%",top:"5%",right:"20%",bottom:"5%",nodeWidth:20,nodeGap:8,layoutIterations:32,label:{normal:{show:!0,position:"right",color:"#000",fontSize:12},emphasis:{show:!0}},itemStyle:{normal:{borderWidth:1,borderColor:"#333"}},lineStyle:{normal:{color:"#314656",opacity:.2,curveness:.5},emphasis:{opacity:.6}},animationEasing:"linear",animationDuration:1e3}}),ew=fp.extendShape({shape:{x1:0,y1:0,x2:0,y2:0,cpx1:0,cpy1:0,cpx2:0,cpy2:0,extent:0},buildPath:function(t,e){var i=e.extent/2;t.moveTo(e.x1,e.y1-i),t.bezierCurveTo(e.cpx1,e.cpy1-i,e.cpx2,e.cpy2-i,e.x2,e.y2-i),t.lineTo(e.x2,e.y2+i),t.bezierCurveTo(e.cpx2,e.cpy2+i,e.cpx1,e.cpy1+i,e.x1,e.y1+i),t.closePath()}}),iw=(ym.extendChartView({type:"sankey",_model:null,render:function(t,e,i){var n=t.getGraph(),a=this.group,o=t.layoutInfo,r=t.getData(),s=t.getData("edge");this._model=t,a.removeAll(),a.attr("position",[o.x,o.y]),n.eachEdge(function(e){var i=new ew;i.dataIndex=e.dataIndex,i.seriesIndex=t.seriesIndex,i.dataType="edge";var n=e.getModel("lineStyle.normal"),o=n.get("curveness"),r=e.node1.getLayout(),l=e.node2.getLayout(),h=e.getLayout();i.shape.extent=Math.max(1,h.dy);var u=r.x+r.dx,c=r.y+h.sy+h.dy/2,d=l.x,p=l.y+h.ty+h.dy/2,f=u*(1-o)+d*o,g=c,m=u*o+d*(1-o),v=p;switch(i.setShape({x1:u,y1:c,x2:d,y2:p,cpx1:f,cpy1:g,cpx2:m,cpy2:v}),i.setStyle(n.getItemStyle()),i.style.fill){case"source":i.style.fill=e.node1.getVisual("color");break;case"target":i.style.fill=e.node2.getVisual("color")}fp.setHoverStyle(i,e.getModel("lineStyle.emphasis").getItemStyle()),a.add(i),s.setItemGraphicEl(e.dataIndex,i)}),n.eachNode(function(e){var i=e.getLayout(),n=e.getModel(),o=n.getModel("label.normal"),s=n.getModel("label.emphasis"),l=new fp.Rect({shape:{x:i.x,y:i.y,width:e.getLayout().dx,height:e.getLayout().dy},style:n.getModel("itemStyle.normal").getItemStyle()}),h=e.getModel("itemStyle.emphasis").getItemStyle();fp.setLabelStyle(l.style,h,o,s,{labelFetcher:t,labelDataIndex:e.dataIndex,defaultText:e.id,isRectText:!0}),l.setStyle("fill",e.getVisual("color")),fp.setHoverStyle(l,h),a.add(l),r.setItemGraphicEl(e.dataIndex,l),l.dataType="node"}),!this._data&&t.get("animation")&&a.setClipPath(function(t,e,i){var n=new fp.Rect({shape:{x:t.x-10,y:t.y-10,width:0,height:t.height+20}});return fp.initProps(n,{shape:{width:t.width+20,height:t.height+20}},e,i),n}(a.getBoundingRect(),t,function(){a.removeClipPath()})),this._data=t.getData()},dispose:function(){}}),function(){function t(e,n){if(n>=i.length)return e;for(var a=-1,o=e.length,r=i[n++],s={},l={};++a<o;){var h=r(e[a]),u=l[h];u?u.push(e[a]):l[h]=[e[a]]}return rl.each(l,function(e,i){s[i]=t(e,n)}),s}function e(t,a){if(a>=i.length)return t;var o=[],r=n[a++];return rl.each(t,function(t,i){o.push({key:i,values:e(t,a)})}),r?o.sort(function(t,e){return r(t.key,e.key)}):o}var i=[],n=[];return{key:function(t){return i.push(t),this},sortKeys:function(t){return n[i.length-1]=t,this},entries:function(i){return e(t(i,0),0)}}}),nw=function(t,e,i){t.eachSeriesByType("sankey",function(t){var i=t.get("nodeWidth"),n=t.get("nodeGap"),a=function(t,e){return Np.getLayoutRect(t.getBoxLayoutParams(),{width:e.getWidth(),height:e.getHeight()})}(t,e);t.layoutInfo=a;var o=a.width,r=a.height,s=t.getGraph(),l=s.nodes,h=s.edges;!function(t){rl.each(t,function(t){var e=Ua(t.outEdges,Xa),i=Ua(t.inEdges,Xa),n=Math.max(e,i);t.setLayout({value:n},!0)})}(l),function(t,e,i,n,a,o,r){(function(t,e,i){for(var n=t,a=null,o=0;n.length;){a=[];for(var r=0,s=n.length;r<s;r++){var l=n[r];l.setLayout({x:o},!0),l.setLayout({dx:e},!0);for(var h=0,u=l.outEdges.length;h<u;h++)a.push(l.outEdges[h].node2)}n=a,++o}(function(t,e){rl.each(t,function(t){t.outEdges.length||t.setLayout({x:e-1},!0)})})(t,o),function(t,e){rl.each(t,function(t){var i=t.getLayout().x*e;t.setLayout({x:i},!0)})}(t,(i-e)/(o-1))})(t,i,a),function(t,e,i,n,a){var o=iw().key(function(t){return t.getLayout().x}).sortKeys(function(t,e){return t<e?-1:t>e?1:t===e?0:NaN}).entries(t).map(function(t){return t.values});(function(t,e,i,n,a){var o=[];rl.each(e,function(t){var e=t.length,i=0;rl.each(t,function(t){i+=t.getLayout().value});var r=(n-(e-1)*a)/i;o.push(r)}),o.sort(function(t,e){return t-e});var r=o[0];rl.each(e,function(t){rl.each(t,function(t,e){t.setLayout({y:e},!0);var i=t.getLayout().value*r;t.setLayout({dy:i},!0)})}),rl.each(i,function(t){var e=+t.getValue()*r;t.setLayout({dy:e},!0)})})(0,o,e,i,n),ja(o,n,i);for(var r=1;a>0;a--)(function(t,e){rl.each(t.slice().reverse(),function(t){rl.each(t,function(t){if(t.outEdges.length){var i=Ua(t.outEdges,function(t){return qa(t.node2)*t.getValue()})/Ua(t.outEdges,Xa),n=t.getLayout().y+(i-qa(t))*e;t.setLayout({y:n},!0)}})})})(o,r*=.99),ja(o,n,i),function(t,e){rl.each(t,function(t){rl.each(t,function(t){if(t.inEdges.length){var i=Ua(t.inEdges,function(t){return qa(t.node1)*t.getValue()})/Ua(t.inEdges,Xa),n=t.getLayout().y+(i-qa(t))*e;t.setLayout({y:n},!0)}})})}(o,r),ja(o,n,i)}(t,e,o,n,r),function(t){rl.each(t,function(t){t.outEdges.sort(function(t,e){return t.node2.getLayout().y-e.node2.getLayout().y}),t.inEdges.sort(function(t,e){return t.node1.getLayout().y-e.node1.getLayout().y})}),rl.each(t,function(t){var e=0,i=0;rl.each(t.outEdges,function(t){t.setLayout({sy:e},!0),e+=t.getLayout().dy}),rl.each(t.inEdges,function(t){t.setLayout({ty:i},!0),i+=t.getLayout().dy})})}(t)}(l,h,i,n,o,r,0!==rl.filter(l,function(t){return 0===t.getLayout().value}).length?0:t.get("layoutIterations"))})},aw=function(t,e){t.eachSeriesByType("sankey",function(t){var e=t.getGraph().nodes;e.sort(function(t,e){return t.getLayout().value-e.getLayout().value});var i=e[0].getLayout().value,n=e[e.length-1].getLayout().value;rl.each(e,function(e){var a=new Kx({type:"color",mappingMethod:"linear",dataExtent:[i,n],visual:t.get("color")}).mapValueToVisual(e.getLayout().value);e.setVisual("color",a);var o=e.getModel().get("itemStyle.normal.color");null!=o&&e.setVisual("color",o)})})};ym.registerLayout(nw),ym.registerVisual(aw);var ow=Yc.extend({type:"whiskerInBox",shape:{},buildPath:function(t,e){for(var i in e)if(e.hasOwnProperty(i)&&0===i.indexOf("ends")){var n=e[i];t.moveTo(n[0][0],n[0][1]),t.lineTo(n[1][0],n[1][1])}}}),rw=Ya.prototype;rw._createContent=function(t,e,i){var n=t.getItemLayout(e),a="horizontal"===n.chartLayout?1:0,o=0;this.add(new fp.Polygon({shape:{points:i?$a(n.bodyEnds,a,n):n.bodyEnds},style:{strokeNoScale:!0},z2:100})),this.bodyIndex=o++;var r=rl.map(n.whiskerEnds,function(t){return i?$a(t,a,n):t});this.add(new ow({shape:Ka(r),style:{strokeNoScale:!0},z2:100})),this.whiskerIndex=o++},rw.updateData=function(t,e,i){var n=this._seriesModel=t.hostModel,a=t.getItemLayout(e),o=fp[i?"initProps":"updateProps"];o(this.childAt(this.bodyIndex),{shape:{points:a.bodyEnds}},n,e),o(this.childAt(this.whiskerIndex),{shape:Ka(a.whiskerEnds)},n,e),this.styleUpdater.call(null,this,t,e)},rl.inherits(Ya,fp.Group);var sw=Ja.prototype;sw.updateData=function(t){var e=this.group,i=this._data,n=this.styleUpdater;t.diff(i).add(function(i){if(t.hasValue(i)){var a=new Ya(t,i,n,!0);t.setItemGraphicEl(i,a),e.add(a)}}).update(function(a,o){var r=i.getItemGraphicEl(o);t.hasValue(a)?(r?r.updateData(t,a):r=new Ya(t,a,n),e.add(r),t.setItemGraphicEl(a,r)):e.remove(r)}).remove(function(t){var n=i.getItemGraphicEl(t);n&&e.remove(n)}).execute(),this._data=t},sw.remove=function(){var t=this.group,e=this._data;this._data=null,e&&e.eachItemGraphicEl(function(e){e&&t.remove(e)})};var lw=Ja,hw={seriesModelMixin:{_baseAxisDim:null,getInitialData:function(t,e){var i,n,a=e.getComponent("xAxis",this.get("xAxisIndex")),o=e.getComponent("yAxis",this.get("yAxisIndex")),r=a.get("type"),s=o.get("type");"category"===r?(t.layout="horizontal",i=a.getCategories(),n=!0):"category"===s?(t.layout="vertical",i=o.getCategories(),n=!0):t.layout=t.layout||"horizontal";var l=["x","y"],h="horizontal"===t.layout?0:1,u=this._baseAxisDim=l[h],c=l[1-h],d=t.data;n&&rl.each(d,function(t,e){t.value&&rl.isArray(t.value)?t.value.unshift(e):rl.isArray(t)&&t.unshift(e)});var p=this.defaultValueDimensions,f=[{name:u,otherDims:{tooltip:!1},dimsDef:["base"]},{name:c,dimsDef:p.slice()}];f=sg(f,d,{encodeDef:this.get("encode"),dimsDef:this.get("dimensions"),dimCount:p.length+1});var g=new tg(f,this);return g.initData(d,i?i.slice():null),g},getBaseAxis:function(){var t=this._baseAxisDim;return this.ecModel.getComponent(t+"Axis",this.get(t+"AxisIndex")).axis}},viewMixin:{init:function(){var t=this._whiskerBoxDraw=new lw(this.getStyleUpdater());this.group.add(t.group)},render:function(t,e,i){this._whiskerBoxDraw.updateData(t.getData())},remove:function(t){this._whiskerBoxDraw.remove()}}},uw=hw.seriesModelMixin,cw=zf.extend({type:"series.boxplot",dependencies:["xAxis","yAxis","grid"],defaultValueDimensions:["min","Q1","median","Q3","max"],dimensions:null,defaultOption:{zlevel:0,z:2,coordinateSystem:"cartesian2d",legendHoverLink:!0,hoverAnimation:!0,layout:null,boxWidth:[7,50],itemStyle:{normal:{color:"#fff",borderWidth:1},emphasis:{borderWidth:2,shadowBlur:5,shadowOffsetX:2,shadowOffsetY:2,shadowColor:"rgba(0,0,0,0.4)"}},animationEasing:"elasticOut",animationDuration:800}});rl.mixin(cw,uw,!0);var dw=hw.viewMixin,pw=Bf.extend({type:"boxplot",getStyleUpdater:function(){return function(t,e,i){var n=e.getItemModel(i),a=n.getModel(fw),o=e.getItemVisual(i,"color"),r=a.getItemStyle(["borderColor"]),s=t.childAt(t.whiskerIndex);s.style.set(r),s.style.stroke=o,s.dirty();var l=t.childAt(t.bodyIndex);l.style.set(r),l.style.stroke=o,l.dirty();var h=n.getModel(gw).getItemStyle();fp.setHoverStyle(t,h)}},dispose:rl.noop});rl.mixin(pw,dw,!0);var fw=["itemStyle","normal"],gw=["itemStyle","emphasis"],mw=["itemStyle","normal","borderColor"],vw=function(t,e){var i=t.get("color");t.eachRawSeriesByType("boxplot",function(e){var n=i[e.seriesIndex%i.length],a=e.getData();a.setVisual({legendSymbol:"roundRect",color:e.get(mw)||n}),t.isSeriesFiltered(e)||a.each(function(t){var e=a.getItemModel(t);a.setItemVisual(t,{color:e.get(mw,!0)})})})},yw=Pu.parsePercent,xw=rl.each,_w=function(t){var e=function(t){var e=[],i=[];return t.eachSeriesByType("boxplot",function(t){var n=t.getBaseAxis(),a=rl.indexOf(i,n);a<0&&(a=i.length,i[a]=n,e[a]={axis:n,seriesModels:[]}),e[a].seriesModels.push(t)}),e}(t);xw(e,function(t){var e=t.seriesModels;e.length&&(function(t){var e,i,n=t.axis,a=t.seriesModels,o=a.length,r=t.boxWidthList=[],s=t.boxOffsetList=[],l=[];if("category"===n.type)i=n.getBandWidth();else{var h=0;xw(a,function(t){h=Math.max(h,t.getData().count())}),e=n.getExtent(),Math.abs(e[1]-e[0])}xw(a,function(t){var e=t.get("boxWidth");rl.isArray(e)||(e=[e,e]),l.push([yw(e[0],i)||0,yw(e[1],i)||0])});var u=.8*i-2,c=u/o*.3,d=(u-c*(o-1))/o,p=d/2-u/2;xw(a,function(t,e){s.push(p),p+=c+d,r.push(Math.min(Math.max(d,l[e][0]),l[e][1]))})}(t),xw(e,function(e,i){!function(t,e,i){var n,a=t.coordinateSystem,o=t.getData(),r=i/2,s=t.get("layout"),l="horizontal"===s?0:1,h=1-l,u=["x","y"],c=[];rl.each(o.dimensions,function(t){var e=o.getDimensionInfo(t).coordDim;e===u[h]?c.push(t):e===u[l]&&(n=t)}),null==n||c.length<5||o.each([n].concat(c),function(){function t(t){var i=[];i[l]=d,i[h]=t;var n;return isNaN(d)||isNaN(t)?n=[NaN,NaN]:(n=a.dataToPoint(i))[l]+=e,n}function i(t,e){var i=t.slice(),n=t.slice();i[l]+=r,n[l]-=r,e?y.push(i,n):y.push(n,i)}function n(t){var e=[t.slice(),t.slice()];e[0][l]-=r,e[1][l]+=r,v.push(e)}var u=arguments,d=u[0],p=u[c.length+1],f=t(u[3]),g=t(u[1]),m=t(u[5]),v=[[g,t(u[2])],[m,t(u[4])]];n(g),n(m),n(f);var y=[];i(v[0][1],0),i(v[1][1],1),o.setItemLayout(p,{chartLayout:s,initBaseline:f[h],median:f,bodyEnds:y,whiskerEnds:v})})}(e,t.boxOffsetList[i],t.boxWidthList[i])}))})};ym.registerVisual(vw),ym.registerLayout(_w);var bw=hw.seriesModelMixin,ww=zf.extend({type:"series.candlestick",dependencies:["xAxis","yAxis","grid"],defaultValueDimensions:["open","close","lowest","highest"],dimensions:null,defaultOption:{zlevel:0,z:2,coordinateSystem:"cartesian2d",legendHoverLink:!0,hoverAnimation:!0,layout:null,itemStyle:{normal:{color:"#c23531",color0:"#314656",borderWidth:1,borderColor:"#c23531",borderColor0:"#314656"},emphasis:{borderWidth:2}},barMaxWidth:null,barMinWidth:null,barWidth:null,animationUpdate:!1,animationEasing:"linear",animationDuration:300},getShadowDim:function(){return"open"},brushSelector:function(t,e,i){var n=e.getItemLayout(t);return i.rect(n.brushRect)}});rl.mixin(ww,bw,!0);var Sw=hw.viewMixin,Mw=Bf.extend({type:"candlestick",getStyleUpdater:function(){return function(t,e,i){var n=e.getItemModel(i),a=n.getModel(Iw),o=e.getItemVisual(i,"color"),r=e.getItemVisual(i,"borderColor")||o,s=a.getItemStyle(["color","color0","borderColor","borderColor0"]),l=t.childAt(t.whiskerIndex);l.useStyle(s),l.style.stroke=r;var h=t.childAt(t.bodyIndex);h.useStyle(s),h.style.fill=o,h.style.stroke=r;var u=n.getModel(Tw).getItemStyle();fp.setHoverStyle(t,u)}},dispose:rl.noop});rl.mixin(Mw,Sw,!0);var Iw=["itemStyle","normal"],Tw=["itemStyle","emphasis"],Aw=function(t){t&&rl.isArray(t.series)&&rl.each(t.series,function(t){rl.isObject(t)&&"k"===t.type&&(t.type="candlestick")})},Cw=["itemStyle","normal","borderColor"],Lw=["itemStyle","normal","borderColor0"],Dw=["itemStyle","normal","color"],Pw=["itemStyle","normal","color0"],kw=function(t,e){t.eachRawSeriesByType("candlestick",function(e){var i=e.getData();i.setVisual({legendSymbol:"roundRect"}),t.isSeriesFiltered(e)||i.each(function(t){var e=i.getItemModel(t),n=i.getItemLayout(t).sign;i.setItemVisual(t,{color:e.get(n>0?Dw:Pw),borderColor:e.get(n>0?Cw:Lw)})})})},Ow=Pu.parsePercent,zw=fp.subPixelOptimize,Ew=rl.retrieve2,Rw=function(t){t.eachSeriesByType("candlestick",function(t){var e,i=t.coordinateSystem,n=t.getData(),a=function(t,e){var i,n=t.getBaseAxis(),a="category"===n.type?n.getBandWidth():(i=n.getExtent(),Math.abs(i[1]-i[0])/e.count()),o=Ow(Ew(t.get("barMaxWidth"),a),a),r=Ow(Ew(t.get("barMinWidth"),1),a),s=t.get("barWidth");return null!=s?Ow(s,a):Math.max(Math.min(a/2,o),r)}(t,n),o=t.get("layout"),r="horizontal"===o?0:1,s=1-r,l=["x","y"],h=[];if(rl.each(n.dimensions,function(t){var i=n.getDimensionInfo(t).coordDim;i===l[s]?h.push(t):i===l[r]&&(e=t)}),!(null==e||h.length<4)){var u=0;n.each([e].concat(h),function(){function t(t){var e=[];return e[r]=d,e[s]=t,isNaN(d)||isNaN(t)?[NaN,NaN]:i.dataToPoint(e)}function e(t,e){var i=t.slice(),n=t.slice();i[r]=zw(i[r]+a/2,1,!1),n[r]=zw(n[r]-a/2,1,!0),e?M.push(i,n):M.push(n,i)}function l(t){return t[r]=zw(t[r],1),t}var c=arguments,d=c[0],p=c[h.length+1],f=c[1],g=c[2],m=c[3],v=c[4],y=Math.min(f,g),x=Math.max(f,g),_=t(y),b=t(x),w=t(m),S=[[l(t(v)),l(b)],[l(w),l(_)]],M=[];e(b,0),e(_,1);var I;I=f>g?-1:f<g?1:u>0?n.getItemModel(u-1).get()[2]<=g?1:-1:1,n.setItemLayout(p,{chartLayout:o,sign:I,initBaseline:f>g?b[s]:_[s],bodyEnds:M,whiskerEnds:S,brushRect:function(){var e=t(Math.min(f,g,m,v)),i=t(Math.max(f,g,m,v));return e[r]-=a/2,i[r]-=a/2,{x:e[0],y:e[1],width:s?a:i[0]-e[0],height:s?i[1]-e[1]:a}}()}),++u},!0)}})};ym.registerPreprocessor(Aw),ym.registerVisual(kw),ym.registerLayout(Rw);zf.extend({type:"series.effectScatter",dependencies:["grid","polar"],getInitialData:function(t,e){return dg(t.data,this,e)},brushSelector:"point",defaultOption:{coordinateSystem:"cartesian2d",zlevel:0,z:2,legendHoverLink:!0,effectType:"ripple",progressive:0,showEffectOn:"render",rippleEffect:{period:4,scale:2.5,brushType:"fill"},symbolSize:10}});var Nw=Ug.createSymbol,Vw=fp.Group,Bw=Pu.parsePercent,Gw=to.prototype;Gw.stopEffectAnimation=function(){this.childAt(1).removeAll()},Gw.startEffectAnimation=function(t){for(var e=t.symbolType,i=t.color,n=this.childAt(1),a=0;a<3;a++){var o=Nw(e,-1,-1,2,2,i);o.attr({style:{strokeNoScale:!0},z2:99,silent:!0,scale:[.5,.5]});var r=-a/3*t.period+t.effectOffset;o.animate("",!0).when(t.period,{scale:[t.rippleScale/2,t.rippleScale/2]}).delay(r).start(),o.animateStyle(!0).when(t.period,{opacity:0}).delay(r).start(),n.add(o)}Qa(n,t)},Gw.updateEffectAnimation=function(t){for(var e=this._effectCfg,i=this.childAt(1),n=["symbolType","period","rippleScale"],a=0;a<n.length;a++){var o=n[a];if(e[o]!==t[o])return this.stopEffectAnimation(),void this.startEffectAnimation(t)}Qa(i,t)},Gw.highlight=function(){this.trigger("emphasis")},Gw.downplay=function(){this.trigger("normal")},Gw.updateData=function(t,e){var i=t.hostModel;this.childAt(0).updateData(t,e);var n=this.childAt(1),a=t.getItemModel(e),o=t.getItemVisual(e,"symbol"),r=function(t){return rl.isArray(t)||(t=[+t,+t]),t}(t.getItemVisual(e,"symbolSize")),s=t.getItemVisual(e,"color");n.attr("scale",r),n.traverse(function(t){t.attr({fill:s})});var l=a.getShallow("symbolOffset");if(l){var h=n.position;h[0]=Bw(l[0],r[0]),h[1]=Bw(l[1],r[1])}n.rotation=(a.getShallow("symbolRotate")||0)*Math.PI/180||0;var u={};if(u.showEffectOn=i.get("showEffectOn"),u.rippleScale=a.get("rippleEffect.scale"),u.brushType=a.get("rippleEffect.brushType"),u.period=1e3*a.get("rippleEffect.period"),u.effectOffset=e/t.count(),u.z=a.getShallow("z")||0,u.zlevel=a.getShallow("zlevel")||0,u.symbolType=o,u.color=s,this.off("mouseover").off("mouseout").off("emphasis").off("normal"),"render"===u.showEffectOn)this._effectCfg?this.updateEffectAnimation(u):this.startEffectAnimation(u),this._effectCfg=u;else{this._effectCfg=null,this.stopEffectAnimation();var c=this.childAt(0),d=function(){c.highlight(),"render"!==u.showEffectOn&&this.startEffectAnimation(u)},p=function(){c.downplay(),"render"!==u.showEffectOn&&this.stopEffectAnimation()};this.on("mouseover",d,this).on("mouseout",p,this).on("emphasis",d,this).on("normal",p,this)}this._effectCfg=u},Gw.fadeOut=function(t){this.off("mouseover").off("mouseout").off("emphasis").off("normal"),t&&t()},rl.inherits(to,Vw);var Hw=to;ym.extendChartView({type:"effectScatter",init:function(){this._symbolDraw=new Pm(Hw)},render:function(t,e,i){var n=t.getData(),a=this._symbolDraw;a.updateData(n),this.group.add(a.group)},updateLayout:function(){this._symbolDraw.updateLayout()},remove:function(t,e){this._symbolDraw&&this._symbolDraw.remove(e)},dispose:function(){}});ym.registerVisual(rl.curry(Fm,"effectScatter","circle",null)),ym.registerLayout(rl.curry(Zm,"effectScatter"));var Ww=Eu.encodeHTML,Fw=zf.extend({type:"series.lines",dependencies:["grid","polar"],visualColorAccessPath:"lineStyle.normal.color",init:function(t){eo(t),Fw.superApply(this,"init",arguments)},mergeOption:function(t){eo(t),Fw.superApply(this,"mergeOption",arguments)},getInitialData:function(t,e){var i=new tg(["value"],this);return i.hasItemOption=!1,i.initData(t.data,[],function(t,e,n,a){if(t instanceof Array)return NaN;i.hasItemOption=!0;var o=t.value;return null!=o?o instanceof Array?o[a]:o:void 0}),i},formatTooltip:function(t){var e=this.getData().getItemModel(t),i=e.get("name");if(i)return i;var n=e.get("fromName"),a=e.get("toName"),o=[];return null!=n&&o.push(n),null!=a&&o.push(a),Ww(o.join(" > "))},defaultOption:{coordinateSystem:"geo",zlevel:0,z:2,legendHoverLink:!0,hoverAnimation:!0,xAxisIndex:0,yAxisIndex:0,symbol:["none","none"],symbolSize:[10,10],geoIndex:0,effect:{show:!1,period:4,constantSpeed:0,symbol:"circle",symbolSize:3,loop:!0,trailLength:.2},large:!1,largeThreshold:2e3,polyline:!1,label:{normal:{show:!1,position:"end"}},lineStyle:{normal:{opacity:.5}}}}),Zw=Ug.createSymbol,jw=io.prototype;jw.createLine=function(t,e,i){return new T_(t,e,i)},jw._updateEffectSymbol=function(t,e){var i=t.getItemModel(e).getModel("effect"),n=i.get("symbolSize"),a=i.get("symbol");rl.isArray(n)||(n=[n,n]);var o=i.get("color")||t.getItemVisual(e,"color"),r=this.childAt(1);this._symbolType!==a&&(this.remove(r),(r=Zw(a,-.5,-.5,1,1,o)).z2=100,r.culling=!0,this.add(r)),r&&(r.setStyle("shadowColor",o),r.setStyle(i.getItemStyle(["color"])),r.attr("scale",n),r.setColor(o),r.attr("scale",n),this._symbolType=a,this._updateEffectAnimation(t,i,e))},jw._updateEffectAnimation=function(t,e,i){var n=this.childAt(1);if(n){var a=this,o=t.getItemLayout(i),r=1e3*e.get("period"),s=e.get("loop"),l=e.get("constantSpeed"),h=rl.retrieve(e.get("delay"),function(e){return e/t.count()*r/3}),u="function"==typeof h;if(n.ignore=!0,this.updateAnimationPoints(n,o),l>0&&(r=this.getLineLength(n)/l*1e3),r!==this._period||s!==this._loop){n.stopAnimation();var c=h;u&&(c=h(i)),n.__t>0&&(c=-r*n.__t),n.__t=0;var d=n.animate("",s).when(r,{__t:1}).delay(c).during(function(){a.updateSymbolPosition(n)});s||d.done(function(){a.remove(n)}),d.start()}this._period=r,this._loop=s}},jw.getLineLength=function(t){return ll.dist(t.__p1,t.__cp1)+ll.dist(t.__cp1,t.__p2)},jw.updateAnimationPoints=function(t,e){t.__p1=e[0],t.__p2=e[1],t.__cp1=e[2]||[(e[0][0]+e[1][0])/2,(e[0][1]+e[1][1])/2]},jw.updateData=function(t,e,i){this.childAt(0).updateData(t,e,i),this._updateEffectSymbol(t,e)},jw.updateSymbolPosition=function(t){var e=t.__p1,i=t.__p2,n=t.__cp1,a=t.__t,o=t.position,r=ic.quadraticAt,s=ic.quadraticDerivativeAt;o[0]=r(e[0],n[0],i[0],a),o[1]=r(e[1],n[1],i[1],a);var l=s(e[0],n[0],i[0],a),h=s(e[1],n[1],i[1],a);t.rotation=-Math.atan2(h,l)-Math.PI/2,t.ignore=!1},jw.updateLayout=function(t,e){this.childAt(0).updateLayout(t,e);var i=t.getItemModel(e).getModel("effect");this._updateEffectAnimation(t,i,e)},rl.inherits(io,fp.Group);var Uw=io,qw=no.prototype;qw._createPolyline=function(t,e,i){var n=t.getItemLayout(e),a=new fp.Polyline({shape:{points:n}});this.add(a),this._updateCommonStl(t,e,i)},qw.updateData=function(t,e,i){var n=t.hostModel,a=this.childAt(0),o={shape:{points:t.getItemLayout(e)}};fp.updateProps(a,o,n,e),this._updateCommonStl(t,e,i)},qw._updateCommonStl=function(t,e,i){var n=this.childAt(0),a=t.getItemModel(e),o=t.getItemVisual(e,"color"),r=i&&i.lineStyle,s=i&&i.hoverLineStyle;i&&!t.hasItemOption||(r=a.getModel("lineStyle.normal").getLineStyle(),s=a.getModel("lineStyle.emphasis").getLineStyle()),n.useStyle(rl.defaults({strokeNoScale:!0,fill:"none",stroke:o},r)),n.hoverStyle=s,fp.setHoverStyle(this)},qw.updateLayout=function(t,e){this.childAt(0).setShape("points",t.getItemLayout(e))},rl.inherits(no,fp.Group);var Xw=no,Yw=ao.prototype;Yw.createLine=function(t,e,i){return new Xw(t,e,i)},Yw.updateAnimationPoints=function(t,e){this._points=e;for(var i=[0],n=0,a=1;a<e.length;a++){var o=e[a-1],r=e[a];n+=ll.dist(o,r),i.push(n)}if(0!==n){for(a=0;a<i.length;a++)i[a]/=n;this._offsets=i,this._length=n}},Yw.getLineLength=function(t){return this._length},Yw.updateSymbolPosition=function(t){var e=t.__t,i=this._points,n=this._offsets,a=i.length;if(n){var o=this._lastFrame;if(e<this._lastFramePercent){for(r=Math.min(o+1,a-1);r>=0&&!(n[r]<=e);r--);r=Math.min(r,a-2)}else{for(var r=o;r<a&&!(n[r]>e);r++);r=Math.min(r-1,a-2)}ll.lerp(t.position,i[r],i[r+1],(e-n[r])/(n[r+1]-n[r]));var s=i[r+1][0]-i[r][0],l=i[r+1][1]-i[r][1];t.rotation=-Math.atan2(l,s)-Math.PI/2,this._lastFrame=r,this._lastFramePercent=e,t.ignore=!1}},rl.inherits(ao,Uw);var $w=ao,Kw=fp.extendShape({shape:{polyline:!1,segs:[]},buildPath:function(t,e){for(var i=e.segs,n=e.polyline,a=0;a<i.length;a++){var o=i[a];if(n){t.moveTo(o[0][0],o[0][1]);for(var r=1;r<o.length;r++)t.lineTo(o[r][0],o[r][1])}else t.moveTo(o[0][0],o[0][1]),o.length>2?t.quadraticCurveTo(o[2][0],o[2][1],o[1][0],o[1][1]):t.lineTo(o[1][0],o[1][1])}},findDataIndex:function(t,e){for(var i=this.shape,n=i.segs,a=i.polyline,o=Math.max(this.style.lineWidth,1),r=0;r<n.length;r++){var s=n[r];if(a){for(var l=1;l<s.length;l++)if(Lc.containStroke(s[l-1][0],s[l-1][1],s[l][0],s[l][1],o,t,e))return r}else if(s.length>2){if(kc.containStroke(s[0][0],s[0][1],s[2][0],s[2][1],s[1][0],s[1][1],o,t,e))return r}else if(Lc.containStroke(s[0][0],s[0][1],s[1][0],s[1][1],o,t,e))return r}return-1}}),Jw=oo.prototype;Jw.updateData=function(t){this.group.removeAll();var e=this._lineEl,i=t.hostModel;e.setShape({segs:t.mapArray(t.getItemLayout),polyline:i.get("polyline")}),e.useStyle(i.getModel("lineStyle.normal").getLineStyle());var n=t.getVisual("color");n&&e.setStyle("stroke",n),e.setStyle("fill"),e.seriesIndex=i.seriesIndex,e.on("mousemove",function(t){e.dataIndex=null;var i=e.findDataIndex(t.offsetX,t.offsetY);i>0&&(e.dataIndex=i)}),this.group.add(e)},Jw.updateLayout=function(t){var e=t.getData();this._lineEl.setShape({segs:e.mapArray(e.getItemLayout)})},Jw.remove=function(){this.group.removeAll()};var Qw=oo,tS=(ym.extendChartView({type:"lines",init:function(){},render:function(t,e,i){var n=t.getData(),a=this._lineDraw,o=t.get("effect.show"),r=t.get("polyline"),s=t.get("large")&&n.count()>=t.get("largeThreshold");o===this._hasEffet&&r===this._isPolyline&&s===this._isLarge||(a&&a.remove(),a=this._lineDraw=s?new Qw:new C_(r?o?$w:Xw:o?Uw:T_),this._hasEffet=o,this._isPolyline=r,this._isLarge=s);var l=t.get("zlevel"),h=t.get("effect.trailLength"),u=i.getZr(),c="svg"===u.painter.getType();c||u.painter.getLayer(l).clear(!0),null==this._lastZlevel||c||u.configLayer(this._lastZlevel,{motionBlur:!1}),o&&h&&(c||u.configLayer(l,{motionBlur:!0,lastFrameAlpha:Math.max(Math.min(h/10+.9,1),0)})),this.group.add(a.group),a.updateData(n),this._lastZlevel=l},updateLayout:function(t,e,i){this._lineDraw.updateLayout(t);var n=i.getZr();"svg"===n.painter.getType()||n.painter.getLayer(this._lastZlevel).clear(!0)},remove:function(t,e){this._lineDraw&&this._lineDraw.remove(e,!0);var i=e.getZr();"svg"===i.painter.getType()||i.painter.getLayer(this._lastZlevel).clear(!0)},dispose:function(){}}),function(t){t.eachSeriesByType("lines",function(t){var e=t.coordinateSystem,i=t.getData();i.each(function(n){var a=i.getItemModel(n),o=a.option instanceof Array?a.option:a.get("coords"),r=[];if(t.get("polyline"))for(var s=0;s<o.length;s++)r.push(e.dataToPoint(o[s]));else{r[0]=e.dataToPoint(o[0]),r[1]=e.dataToPoint(o[1]);var l=a.get("lineStyle.normal.curveness");+l&&(r[2]=[(r[0][0]+r[1][0])/2-(r[0][1]-r[1][1])*l,(r[0][1]+r[1][1])/2-(r[1][0]-r[0][0])*l])}i.setItemLayout(n,r)})})}),eS=function(t){t.eachSeriesByType("lines",function(t){var e=t.getData(),i=ro(t.get("symbol")),n=ro(t.get("symbolSize")),a="lineStyle.normal.opacity".split(".");e.setVisual("fromSymbol",i&&i[0]),e.setVisual("toSymbol",i&&i[1]),e.setVisual("fromSymbolSize",n&&n[0]),e.setVisual("toSymbolSize",n&&n[1]),e.setVisual("opacity",t.get(a)),e.each(function(t){var i=e.getItemModel(t),n=ro(i.getShallow("symbol",!0)),o=ro(i.getShallow("symbolSize",!0)),r=i.get(a);n[0]&&e.setItemVisual(t,"fromSymbol",n[0]),n[1]&&e.setItemVisual(t,"toSymbol",n[1]),o[0]&&e.setItemVisual(t,"fromSymbolSize",o[0]),o[1]&&e.setItemVisual(t,"toSymbolSize",o[1]),e.setItemVisual(t,"opacity",r)})})};ym.registerLayout(tS),ym.registerVisual(eS);zf.extend({type:"series.heatmap",getInitialData:function(t,e){return dg(t.data,this,e)},defaultOption:{coordinateSystem:"cartesian2d",zlevel:0,z:2,geoIndex:0,blurSize:30,pointSize:20,maxOpacity:1,minOpacity:0}});so.prototype={update:function(t,e,i,n,a,o){var r=this._getBrush(),s=this._getGradient(t,a,"inRange"),l=this._getGradient(t,a,"outOfRange"),h=this.pointSize+this.blurSize,u=this.canvas,c=u.getContext("2d"),d=t.length;u.width=e,u.height=i;for(var p=0;p<d;++p){var f=t[p],g=f[0],m=f[1],v=n(f[2]);c.globalAlpha=v,c.drawImage(r,g-h,m-h)}if(!u.width||!u.height)return u;for(var y=c.getImageData(0,0,u.width,u.height),x=y.data,_=0,b=x.length,w=this.minOpacity,S=this.maxOpacity-w;_<b;){var v=x[_+3]/256,M=4*Math.floor(255*v);if(v>0){var I=o(v)?s:l;v>0&&(v=v*S+w),x[_++]=I[M],x[_++]=I[M+1],x[_++]=I[M+2],x[_++]=I[M+3]*v*256}else _+=4}return c.putImageData(y,0,0),u},_getBrush:function(){var t=this._brushCanvas||(this._brushCanvas=rl.createCanvas()),e=this.pointSize+this.blurSize,i=2*e;t.width=i,t.height=i;var n=t.getContext("2d");return n.clearRect(0,0,i,i),n.shadowOffsetX=i,n.shadowBlur=this.blurSize,n.shadowColor="#000",n.beginPath(),n.arc(-e,e,this.pointSize,0,2*Math.PI,!0),n.closePath(),n.fill(),t},_getGradient:function(t,e,i){for(var n=this._gradientPixels,a=n[i]||(n[i]=new Uint8ClampedArray(1024)),o=[0,0,0,0],r=0,s=0;s<256;s++)e[i](s/255,!0,o),a[r++]=o[0],a[r++]=o[1],a[r++]=o[2],a[r++]=o[3];return a}};var iS=so,nS=(ym.extendChartView({type:"heatmap",render:function(t,e,i){var n;e.eachComponent("visualMap",function(e){e.eachTargetSeries(function(i){i===t&&(n=e)})}),this.group.removeAll();var a=t.coordinateSystem;"cartesian2d"===a.type||"calendar"===a.type?this._renderOnCartesianAndCalendar(a,t,i):function(t){var e=t.dimensions;return"lng"===e[0]&&"lat"===e[1]}(a)&&this._renderOnGeo(a,t,n,i)},dispose:function(){},_renderOnCartesianAndCalendar:function(t,e,i){if("cartesian2d"===t.type)var n=t.getAxis("x"),a=t.getAxis("y"),o=n.getBandWidth(),r=a.getBandWidth();var s=this.group,l=e.getData(),h=e.getModel("itemStyle.normal").getItemStyle(["color"]),u=e.getModel("itemStyle.emphasis").getItemStyle(),c=e.getModel("label.normal"),d=e.getModel("label.emphasis"),p=t.type,f="cartesian2d"===p?[e.coordDimToDataDim("x")[0],e.coordDimToDataDim("y")[0],e.coordDimToDataDim("value")[0]]:[e.coordDimToDataDim("time")[0],e.coordDimToDataDim("value")[0]];l.each(function(i){var n;if("cartesian2d"===p){if(isNaN(l.get(f[2],i)))return;var a=t.dataToPoint([l.get(f[0],i),l.get(f[1],i)]);n=new fp.Rect({shape:{x:a[0]-o/2,y:a[1]-r/2,width:o,height:r},style:{fill:l.getItemVisual(i,"color"),opacity:l.getItemVisual(i,"opacity")}})}else{if(isNaN(l.get(f[1],i)))return;n=new fp.Rect({z2:1,shape:t.dataToRect([l.get(f[0],i)]).contentShape,style:{fill:l.getItemVisual(i,"color"),opacity:l.getItemVisual(i,"opacity")}})}var g=l.getItemModel(i);l.hasItemOption&&(h=g.getModel("itemStyle.normal").getItemStyle(["color"]),u=g.getModel("itemStyle.emphasis").getItemStyle(),c=g.getModel("label.normal"),d=g.getModel("label.emphasis"));var m=e.getRawValue(i),v="-";m&&null!=m[2]&&(v=m[2]),fp.setLabelStyle(h,u,c,d,{labelFetcher:e,labelDataIndex:i,defaultText:v,isRectText:!0}),n.setStyle(h),fp.setHoverStyle(n,l.hasItemOption?u:rl.extend({},u)),s.add(n),l.setItemGraphicEl(i,n)})},_renderOnGeo:function(t,e,i,n){var a=i.targetVisuals.inRange,o=i.targetVisuals.outOfRange,r=e.getData(),s=this._hmLayer||this._hmLayer||new iS;s.blurSize=e.get("blurSize"),s.pointSize=e.get("pointSize"),s.minOpacity=e.get("minOpacity"),s.maxOpacity=e.get("maxOpacity");var l=t.getViewRect().clone(),h=t.getRoamTransform().transform;l.applyTransform(h);var u=Math.max(l.x,0),c=Math.max(l.y,0),d=Math.min(l.width+l.x,n.getWidth()),p=Math.min(l.height+l.y,n.getHeight()),f=d-u,g=p-c,m=r.mapArray(["lng","lat","value"],function(e,i,n){var a=t.dataToPoint([e,i]);return a[0]-=u,a[1]-=c,a.push(n),a}),v=i.getExtent(),y="visualMap.continuous"===i.type?function(t,e){var i=t[1]-t[0];return e=[(e[0]-t[0])/i,(e[1]-t[0])/i],function(t){return t>=e[0]&&t<=e[1]}}(v,i.option.range):function(t,e,i){var n=t[1]-t[0],a=(e=rl.map(e,function(e){return{interval:[(e.interval[0]-t[0])/n,(e.interval[1]-t[0])/n]}})).length,o=0;return function(t){for(n=o;n<a;n++)if((r=e[n].interval)[0]<=t&&t<=r[1]){o=n;break}if(n===a)for(var n=o-1;n>=0;n--){var r=e[n].interval;if(r[0]<=t&&t<=r[1]){o=n;break}}return n>=0&&n<a&&i[n]}}(v,i.getPieceList(),i.option.selected);s.update(m,f,g,a.color.getNormalizer(),{inRange:a.color.getColorMapper(),outOfRange:o.color.getColorMapper()},y);var x=new fp.Image({style:{width:f,height:g,x:u,y:c,image:s.canvas},silent:!0});this.group.add(x)}}),Zv.extend({type:"series.pictorialBar",dependencies:["grid"],defaultOption:{symbol:"circle",symbolSize:null,symbolRotate:null,symbolPosition:null,symbolOffset:null,symbolMargin:null,symbolRepeat:!1,symbolRepeatDirection:"end",symbolClip:!1,symbolBoundingData:null,symbolPatternSize:400,barGap:"-100%",progressive:0,hoverAnimation:!1},getInitialData:function(t){return t.stack=null,nS.superApply(this,"getInitialData",arguments)}})),aS=Ug.createSymbol,oS=Pu.parsePercent,rS=Pu.isNumeric,sS=jv.setLabel,lS=["itemStyle","normal","borderWidth"],hS=[{xy:"x",wh:"width",index:0,posDesc:["left","right"]},{xy:"y",wh:"height",index:1,posDesc:["top","bottom"]}],uS=new fp.Circle;ym.extendChartView({type:"pictorialBar",render:function(t,e,i){var n=this.group,a=t.getData(),o=this._data,r=t.coordinateSystem,s=!!r.getBaseAxis().isHorizontal(),l=r.grid.getRect(),h={ecSize:{width:i.getWidth(),height:i.getHeight()},seriesModel:t,coordSys:r,coordSysExtent:[[l.x,l.x+l.width],[l.y,l.y+l.height]],isHorizontal:s,valueDim:hS[+s],categoryDim:hS[1-s]};return a.diff(o).add(function(t){if(a.hasValue(t)){var e=mo(a,t),i=lo(a,t,e,h),o=yo(a,h,i);a.setItemGraphicEl(t,o),n.add(o),So(o,h,i)}}).update(function(t,e){var i=o.getItemGraphicEl(e);if(a.hasValue(t)){var r=mo(a,t),s=lo(a,t,r,h),l=_o(a,s);i&&l!==i.__pictorialShapeStr&&(n.remove(i),a.setItemGraphicEl(t,null),i=null),i?function(t,e,i){var n=i.animationModel,a=i.dataIndex,o=t.__pictorialBundle;fp.updateProps(o,{position:i.bundlePosition.slice()},n,a),i.symbolRepeat?co(t,e,i,!0):po(t,0,i,!0),fo(t,i,!0),go(t,e,i,!0)}(i,h,s):i=yo(a,h,s,!0),a.setItemGraphicEl(t,i),i.__pictorialSymbolMeta=s,n.add(i),So(i,h,s)}else n.remove(i)}).remove(function(t){var e=o.getItemGraphicEl(t);e&&xo(o,t,e.__pictorialSymbolMeta.animationModel,e)}).execute(),this._data=a,this.group},dispose:rl.noop,remove:function(t,e){var i=this.group,n=this._data;t.get("animation")?n&&n.eachItemGraphicEl(function(e){xo(n,e.dataIndex,t,e)}):i.removeAll()}});ym.registerLayout(rl.curry(Fv,"pictorialBar")),ym.registerVisual(rl.curry(Fm,"pictorialBar","roundRect",null));var cS=function(t,e,i,n,a){Kg.call(this,t,e,i),this.type=n||"value",this.position=a||"bottom",this.orient=null,this._labelInterval=null};cS.prototype={constructor:cS,model:null,isHorizontal:function(){var t=this.position;return"top"===t||"bottom"===t},pointToData:function(t,e){return this.coordinateSystem.pointToData(t,e)[0]},toGlobalCoord:null,toLocalCoord:null},rl.inherits(cS,Kg);var dS=cS,pS=Np.getLayoutRect;Io.prototype={type:"singleAxis",axisPointerEnabled:!0,constructor:Io,_init:function(t,e,i){var n=this.dimension,a=new dS(n,Rg.createScaleByModel(t),[0,0],t.get("type"),t.get("position")),o="category"===a.type;a.onBand=o&&t.get("boundaryGap"),a.inverse=t.get("inverse"),a.orient=t.get("orient"),t.axis=a,a.model=t,a.coordinateSystem=this,this._axis=a},update:function(t,e){t.eachSeries(function(t){if(t.coordinateSystem===this){var e=t.getData(),i=this.dimension;this._axis.scale.unionExtentFromData(e,t.coordDimToDataDim(i)),Rg.niceScaleExtent(this._axis.scale,this._axis.model)}},this)},resize:function(t,e){this._rect=pS({left:t.get("left"),top:t.get("top"),right:t.get("right"),bottom:t.get("bottom"),width:t.get("width"),height:t.get("height")},{width:e.getWidth(),height:e.getHeight()}),this._adjustAxis()},getRect:function(){return this._rect},_adjustAxis:function(){var t=this._rect,e=this._axis,i=e.isHorizontal(),n=i?[0,t.width]:[0,t.height],a=e.reverse?1:0;e.setExtent(n[a],n[1-a]),this._updateAxisTransform(e,i?t.x:t.y)},_updateAxisTransform:function(t,e){var i=t.getExtent(),n=i[0]+i[1],a=t.isHorizontal();t.toGlobalCoord=a?function(t){return t+e}:function(t){return n-t+e},t.toLocalCoord=a?function(t){return t-e}:function(t){return n-t+e}},getAxis:function(){return this._axis},getBaseAxis:function(){return this._axis},getAxes:function(){return[this._axis]},getTooltipAxes:function(){return{baseAxes:[this.getAxis()]}},containPoint:function(t){var e=this.getRect(),i=this.getAxis();return"horizontal"===i.orient?i.contain(i.toLocalCoord(t[0]))&&t[1]>=e.y&&t[1]<=e.y+e.height:i.contain(i.toLocalCoord(t[1]))&&t[0]>=e.y&&t[0]<=e.y+e.height},pointToData:function(t){var e=this.getAxis();return[e.coordToData(e.toLocalCoord(t["horizontal"===e.orient?0:1]))]},dataToPoint:function(t){var e=this.getAxis(),i=this.getRect(),n=[],a="horizontal"===e.orient?0:1;return t instanceof Array&&(t=t[0]),n[a]=e.toGlobalCoord(e.dataToCoord(+t)),n[1-a]=0===a?i.y+i.height/2:i.x+i.width/2,n}};var fS=Io;rf.register("single",{create:function(t,e){var i=[];return t.eachComponent("singleAxis",function(n,a){var o=new fS(n,t,e);o.name="single_"+a,o.resize(n,e),n.coordinateSystem=o,i.push(o)}),t.eachSeries(function(e){if("singleAxis"===e.get("coordinateSystem")){var i=t.queryComponents({mainType:"singleAxis",index:e.get("singleAxisIndex"),id:e.get("singleAxisId")})[0];e.coordinateSystem=i&&i.coordinateSystem}}),i},dimensions:fS.prototype.dimensions});var gS={layout:function(t,e){e=e||{};var i=t.coordinateSystem,n=t.axis,a={},o=n.position,r=n.orient,s=i.getRect(),l=[s.x,s.x+s.width,s.y,s.y+s.height],h={horizontal:{top:l[2],bottom:l[3]},vertical:{left:l[0],right:l[1]}};a.position=["vertical"===r?h.vertical[o]:l[0],"horizontal"===r?h.horizontal[o]:l[3]],a.rotation=Math.PI/2*{horizontal:0,vertical:1}[r],a.labelDirection=a.tickDirection=a.nameDirection={top:-1,bottom:1,right:1,left:-1}[o],t.get("axisTick.inside")&&(a.tickDirection=-a.tickDirection),rl.retrieve(e.labelInside,t.get("axisLabel.inside"))&&(a.labelDirection=-a.labelDirection);var u=e.rotate;return null==u&&(u=t.get("axisLabel.rotate")),a.labelRotation="top"===o?-u:u,a.labelInterval=n.getLabelInterval(),a.z2=1,a}},mS=Cv.getInterval,vS=Cv.ifIgnoreOnTick,yS=["axisLine","axisTickLabel","axisName"],xS=zv.extend({type:"singleAxis",axisPointerClass:"SingleAxisPointer",render:function(t,e,i,n){var a=this.group;a.removeAll();var o=gS.layout(t),r=new Cv(t,o);rl.each(yS,r.add,r),a.add(r.getGroup()),t.get("splitLine.show")&&this._splitLine(t,o.labelInterval),xS.superCall(this,"render",t,e,i,n)},_splitLine:function(t,e){var i=t.axis;if(!i.scale.isBlank()){var n=t.getModel("splitLine"),a=n.getModel("lineStyle"),o=a.get("width"),r=a.get("color"),s=mS(n,e);r=r instanceof Array?r:[r];for(var l=t.coordinateSystem.getRect(),h=i.isHorizontal(),u=[],c=0,d=i.getTicksCoords(),p=[],f=[],g=t.get("axisLabel.showMinLabel"),m=t.get("axisLabel.showMaxLabel"),v=0;v<d.length;++v)if(!vS(i,v,s,d.length,g,m)){var y=i.toGlobalCoord(d[v]);h?(p[0]=y,p[1]=l.y,f[0]=y,f[1]=l.y+l.height):(p[0]=l.x,p[1]=y,f[0]=l.x+l.width,f[1]=y);var x=c++%r.length;u[x]=u[x]||[],u[x].push(new fp.Line(fp.subPixelOptimizeLine({shape:{x1:p[0],y1:p[1],x2:f[0],y2:f[1]},style:{lineWidth:o},silent:!0})))}for(v=0;v<u.length;++v)this.group.add(fp.mergePath(u[v],{style:{stroke:r[v%r.length],lineDash:a.getLineDash(o),lineWidth:o},silent:!0}))}}}),_S=Hp.extend({type:"singleAxis",layoutMode:"box",axis:null,coordinateSystem:null,getCoordSysModel:function(){return this}});rl.merge(_S.prototype,Ng),ov("single",_S,function(t,e){return e.type||(e.data?"category":"value")},{left:"5%",top:"5%",right:"5%",bottom:"5%",type:"value",position:"bottom",orient:"horizontal",axisLine:{show:!0,lineStyle:{width:2,type:"solid"}},tooltip:{show:!0},axisTick:{show:!0,length:6,lineStyle:{width:2}},axisLabel:{show:!0,interval:"auto"},splitLine:{show:!0,lineStyle:{type:"dashed",opacity:.2}}});var bS=function(t,e){var i,n=[],a=t.seriesIndex;if(null==a||!(i=e.getSeriesByIndex(a)))return{point:[]};var o=i.getData(),r=Ip.queryDataIndex(o,t);if(null==r||rl.isArray(r))return{point:[]};var s=o.getItemGraphicEl(r),l=i.coordinateSystem;if(i.getTooltipPosition)n=i.getTooltipPosition(r)||[];else if(l&&l.dataToPoint)n=l.dataToPoint(o.getValues(rl.map(l.dimensions,function(t){return i.coordDimToDataDim(t)[0]}),r,!0))||[];else if(s){var h=s.getBoundingRect().clone();h.applyTransform(s.transform),n=[h.x+h.width/2,h.y+h.height/2]}return{point:n,el:s}},wS=rl.each,SS=rl.curry,MS=Ip.makeGetter(),IS=function(t,e,i){var n=t.currTrigger,a=[t.x,t.y],o=t,r=t.dispatchAction||rl.bind(i.dispatchAction,i),s=e.getComponent("axisPointer").coordSysAxesInfo;if(s){Co(a)&&(a=bS({seriesIndex:o.seriesIndex,dataIndex:o.dataIndex},e).point);var l=Co(a),h=o.axesInfo,u=s.axesInfo,c="leave"===n||Co(a),d={},p={},f={list:[],map:{}},g={showPointer:SS(function(t,e,i,n){t[e.key]={value:i,payloadBatch:n}},p),showTooltip:SS(function(t,e,i,n){var a=i.payloadBatch,o=e.axis,r=o.model,s=e.axisPointerModel;if(e.triggerTooltip&&a.length){var l=e.coordSys.model,h=Pv.makeKey(l),u=t.map[h];u||(u=t.map[h]={coordSysId:l.id,coordSysIndex:l.componentIndex,coordSysType:l.type,coordSysMainType:l.mainType,dataByAxis:[]},t.list.push(u)),u.dataByAxis.push({axisDim:o.dim,axisIndex:r.componentIndex,axisType:r.type,axisId:r.id,value:n,valueLabelOpt:{precision:s.get("label.precision"),formatter:s.get("label.formatter")},seriesDataIndices:a.slice()})}},f)};wS(s.coordSysMap,function(t,e){var i=l||t.containPoint(a);wS(s.coordSysAxesInfo[e],function(t,e){var n=t.axis,o=function(t,e){for(var i=0;i<(t||[]).length;i++){var n=t[i];if(e.axis.dim===n.axisDim&&e.axis.model.componentIndex===n.axisIndex)return n}}(h,t);if(!c&&i&&(!h||o)){var r=o&&o.value;null!=r||l||(r=n.pointToData(a)),null!=r&&To(t,r,g,!1,d)}})});var m={};return wS(u,function(t,e){var i=t.linkGroup;i&&!p[e]&&wS(i.axesInfo,function(e,n){var a=p[n];if(e!==t&&a){var o=a.value;i.mapper&&(o=t.axis.scale.parse(i.mapper(o,Ao(e),Ao(t)))),m[t.key]=o}})}),wS(m,function(t,e){To(u[e],t,g,!0,d)}),function(t,e,i){var n=i.axesInfo=[];wS(e,function(e,i){var a=e.axisPointerModel.option,o=t[i];o?(!e.useHandle&&(a.status="show"),a.value=o.value,a.seriesDataIndices=(o.payloadBatch||[]).slice()):!e.useHandle&&(a.status="hide"),"show"===a.status&&n.push({axisDim:e.axis.dim,axisIndex:e.axis.model.componentIndex,value:a.value})})}(p,u,d),function(t,e,i,n){if(!Co(e)&&t.list.length){var a=((t.list[0].dataByAxis[0]||{}).seriesDataIndices||[])[0]||{};n({type:"showTip",escapeConnect:!0,x:e[0],y:e[1],tooltipOption:i.tooltipOption,position:i.position,dataIndexInside:a.dataIndexInside,dataIndex:a.dataIndex,seriesIndex:a.seriesIndex,dataByCoordSys:t.list})}else n({type:"hideTip"})}(f,a,t,r),function(t,e,i){var n=i.getZr(),a=MS(n).axisPointerLastHighlights||{},o=MS(n).axisPointerLastHighlights={};wS(t,function(t,e){var i=t.axisPointerModel.option;"show"===i.status&&wS(i.seriesDataIndices,function(t){var e=t.seriesIndex+" | "+t.dataIndex;o[e]=t})});var r=[],s=[];rl.each(a,function(t,e){!o[e]&&s.push(t)}),rl.each(o,function(t,e){!a[e]&&r.push(t)}),s.length&&i.dispatchAction({type:"downplay",escapeConnect:!0,batch:s}),r.length&&i.dispatchAction({type:"highlight",escapeConnect:!0,batch:r})}(u,0,i),d}},TS=(ym.extendComponentModel({type:"axisPointer",coordSysAxesInfo:null,defaultOption:{show:"auto",triggerOn:null,zlevel:0,z:50,type:"line",snap:!1,triggerTooltip:!0,value:null,status:null,link:[],animation:null,animationDurationUpdate:200,lineStyle:{color:"#aaa",width:1,type:"solid"},shadowStyle:{color:"rgba(150,150,150,0.3)"},label:{show:!0,formatter:null,precision:"auto",margin:3,color:"#fff",padding:[5,7,5,7],backgroundColor:"auto",borderColor:null,borderWidth:0,shadowBlur:3,shadowColor:"#aaa"},handle:{show:!1,icon:"M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7v-1.2h6.6z M13.3,22H6.7v-1.2h6.6z M13.3,19.6H6.7v-1.2h6.6z",size:45,margin:50,color:"#333",shadowBlur:3,shadowColor:"#aaa",shadowOffsetX:0,shadowOffsetY:2,throttle:40}}}),Ip.makeGetter()),AS=rl.each,CS={register:function(t,e,i){if(!Us.node){var n=e.getZr();TS(n).records||(TS(n).records={}),function(t,e){function i(i,n){t.on(i,function(i){var a=function(t){var e={showTip:[],hideTip:[]},i=function(n){var a=e[n.type];a?a.push(n):(n.dispatchAction=i,t.dispatchAction(n))};return{dispatchAction:i,pendings:e}}(e);AS(TS(t).records,function(t){t&&n(t,i,a.dispatchAction)}),function(t,e){var i,n=t.showTip.length,a=t.hideTip.length;n?i=t.showTip[n-1]:a&&(i=t.hideTip[a-1]),i&&(i.dispatchAction=null,e.dispatchAction(i))}(a.pendings,e)})}TS(t).initialized||(TS(t).initialized=!0,i("click",rl.curry(Lo,"click")),i("mousemove",rl.curry(Lo,"mousemove")),i("globalout",function(t,e,i){t.handler("leave",null,i)}))}(n,e),(TS(n).records[t]||(TS(n).records[t]={})).handler=i}},unregister:function(t,e){if(!Us.node){var i=e.getZr();(TS(i).records||{})[t]&&(TS(i).records[t]=null)}}},LS=ym.extendComponentView({type:"axisPointer",render:function(t,e,i){var n=e.getComponent("tooltip"),a=t.get("triggerOn")||n&&n.get("triggerOn")||"mousemove|click";CS.register("axisPointer",i,function(t,e,i){"none"!==a&&("leave"===t||a.indexOf(t)>=0)&&i({type:"updateAxisPointer",currTrigger:t,x:e&&e.offsetX,y:e&&e.offsetY})})},remove:function(t,e){CS.unregister(e.getZr(),"axisPointer"),LS.superApply(this._model,"remove",arguments)},dispose:function(t,e){CS.unregister("axisPointer",e),LS.superApply(this._model,"dispose",arguments)}}),DS=Ip.makeGetter(),PS=rl.clone,kS=rl.bind;(Do.prototype={_group:null,_lastGraphicKey:null,_handle:null,_dragging:!1,_lastValue:null,_lastStatus:null,_payloadInfo:null,animationThreshold:15,render:function(t,e,i,n){var a=e.get("value"),o=e.get("status");if(this._axisModel=t,this._axisPointerModel=e,this._api=i,n||this._lastValue!==a||this._lastStatus!==o){this._lastValue=a,this._lastStatus=o;var r=this._group,s=this._handle;if(!o||"hide"===o)return r&&r.hide(),void(s&&s.hide());r&&r.show(),s&&s.show();var l={};this.makeElOption(l,a,t,e,i);var h=l.graphicKey;h!==this._lastGraphicKey&&this.clear(i),this._lastGraphicKey=h;var u=this._moveAnimation=this.determineAnimation(t,e);if(r){var c=rl.curry(Po,e,u);this.updatePointerEl(r,l,c,e),this.updateLabelEl(r,l,c,e)}else r=this._group=new fp.Group,this.createPointerEl(r,l,t,e),this.createLabelEl(r,l,t,e),i.getZr().add(r);Eo(r,e,!0),this._renderHandle(a)}},remove:function(t){this.clear(t)},dispose:function(t){this.clear(t)},determineAnimation:function(t,e){var i=e.get("animation"),n=t.axis,a="category"===n.type,o=e.get("snap");if(!o&&!a)return!1;if("auto"===i||null==i){var r=this.animationThreshold;if(a&&n.getBandWidth()>r)return!0;if(o){var s=Pv.getAxisInfo(t).seriesDataCount,l=n.getExtent();return Math.abs(l[0]-l[1])/s>r}return!1}return!0===i},makeElOption:function(t,e,i,n,a){},createPointerEl:function(t,e,i,n){var a=e.pointer;if(a){var o=DS(t).pointerEl=new fp[a.type](PS(e.pointer));t.add(o)}},createLabelEl:function(t,e,i,n){if(e.label){var a=DS(t).labelEl=new fp.Rect(PS(e.label));t.add(a),Oo(a,n)}},updatePointerEl:function(t,e,i){var n=DS(t).pointerEl;n&&(n.setStyle(e.pointer.style),i(n,{shape:e.pointer.shape}))},updateLabelEl:function(t,e,i,n){var a=DS(t).labelEl;a&&(a.setStyle(e.label.style),i(a,{shape:e.label.shape,position:e.label.position}),Oo(a,n))},_renderHandle:function(t){if(!this._dragging&&this.updateHandleTransform){var e=this._axisPointerModel,i=this._api.getZr(),n=this._handle,a=e.getModel("handle"),o=e.get("status");if(!a.get("show")||!o||"hide"===o)return n&&i.remove(n),void(this._handle=null);var r;this._handle||(r=!0,n=this._handle=fp.createIcon(a.get("icon"),{cursor:"move",draggable:!0,onmousemove:function(t){su.stop(t.event)},onmousedown:kS(this._onHandleDragMove,this,0,0),drift:kS(this._onHandleDragMove,this),ondragend:kS(this._onHandleDragEnd,this)}),i.add(n)),Eo(n,e,!1);n.setStyle(a.getItemStyle(null,["color","borderColor","borderWidth","opacity","shadowColor","shadowBlur","shadowOffsetX","shadowOffsetY"]));var s=a.get("size");rl.isArray(s)||(s=[s,s]),n.attr("scale",[s[0]/2,s[1]/2]),Ff.createOrUpdate(this,"_doDispatchAxisPointer",a.get("throttle")||0,"fixRate"),this._moveHandleToValue(t,r)}},_moveHandleToValue:function(t,e){Po(this._axisPointerModel,!e&&this._moveAnimation,this._handle,zo(this.getHandleTransform(t,this._axisModel,this._axisPointerModel)))},_onHandleDragMove:function(t,e){var i=this._handle;if(i){this._dragging=!0;var n=this.updateHandleTransform(zo(i),[t,e],this._axisModel,this._axisPointerModel);this._payloadInfo=n,i.stopAnimation(),i.attr(zo(n)),DS(i).lastProp=null,this._doDispatchAxisPointer()}},_doDispatchAxisPointer:function(){if(this._handle){var t=this._payloadInfo,e=this._axisModel;this._api.dispatchAction({type:"updateAxisPointer",x:t.cursorPoint[0],y:t.cursorPoint[1],tooltipOption:t.tooltipOption,axesInfo:[{axisDim:e.axis.dim,axisIndex:e.componentIndex}]})}},_onHandleDragEnd:function(t){this._dragging=!1;if(this._handle){var e=this._axisPointerModel.get("value");this._moveHandleToValue(e),this._api.dispatchAction({type:"hideTip"})}},getHandleTransform:null,updateHandleTransform:null,clear:function(t){this._lastValue=null,this._lastStatus=null;var e=t.getZr(),i=this._group,n=this._handle;e&&i&&(this._lastGraphicKey=null,i&&e.remove(i),n&&e.remove(n),this._group=null,this._handle=null,this._payloadInfo=null)},doClear:function(){},buildLabel:function(t,e,i){return i=i||0,{x:t[i],y:t[1-i],width:e[i],height:e[1-i]}}}).constructor=Do,Bu.enableClassExtend(Do);var OS=Do,zS={buildElStyle:function(t){var e,i=t.get("type"),n=t.getModel(i+"Style");return"line"===i?(e=n.getLineStyle()).fill=null:"shadow"===i&&((e=n.getAreaStyle()).stroke=null),e},buildLabelElOption:Ro,getValueLabel:No,getTransformedPosition:Vo,buildCartesianSingleLabelElOption:function(t,e,i,n,a,o){var r=Cv.innerTextLayout(i.rotation,0,i.labelDirection);i.labelMargin=a.get("label.margin"),Ro(e,n,a,o,{position:Vo(n.axis,t,i),align:r.textAlign,verticalAlign:r.textVerticalAlign})},makeLineShape:function(t,e,i){return i=i||0,{x1:t[i],y1:t[1-i],x2:e[i],y2:e[1-i]}},makeRectShape:function(t,e,i){return i=i||0,{x:t[i],y:t[1-i],width:e[i],height:e[1-i]}},makeSectorShape:function(t,e,i,n,a,o){return{cx:t,cy:e,r0:i,r:n,startAngle:a,endAngle:o,clockwise:!0}}},ES=OS.extend({makeElOption:function(t,e,i,n,a){var o=i.axis,r=o.grid,s=n.get("type"),l=Bo(r,o).getOtherAxis(o).getGlobalExtent(),h=o.toGlobalCoord(o.dataToCoord(e,!0));if(s&&"none"!==s){var u=zS.buildElStyle(n),c=RS[s](o,h,l,u);c.style=u,t.graphicKey=c.type,t.pointer=c}var d=Ev.layout(r.model,i);zS.buildCartesianSingleLabelElOption(e,t,d,i,n,a)},getHandleTransform:function(t,e,i){var n=Ev.layout(e.axis.grid.model,e,{labelInside:!1});return n.labelMargin=i.get("handle.margin"),{position:zS.getTransformedPosition(e.axis,t,n),rotation:n.rotation+(n.labelDirection<0?Math.PI:0)}},updateHandleTransform:function(t,e,i,n){var a=i.axis,o=a.grid,r=a.getGlobalExtent(!0),s=Bo(o,a).getOtherAxis(a).getGlobalExtent(),l="x"===a.dim?0:1,h=t.position;h[l]+=e[l],h[l]=Math.min(r[1],h[l]),h[l]=Math.max(r[0],h[l]);var u=(s[1]+s[0])/2,c=[u,u];c[l]=h[l];return{position:h,rotation:t.rotation,cursorPoint:c,tooltipOption:[{verticalAlign:"middle"},{align:"center"}][l]}}}),RS={line:function(t,e,i,n){var a=zS.makeLineShape([e,i[0]],[e,i[1]],Go(t));return fp.subPixelOptimizeLine({shape:a,style:n}),{type:"Line",shape:a}},shadow:function(t,e,i,n){var a=t.getBandWidth(),o=i[1]-i[0];return{type:"Rect",shape:zS.makeRectShape([e-a/2,i[0]],[a,o],Go(t))}}};zv.registerAxisPointerClass("CartesianAxisPointer",ES);ym.registerPreprocessor(function(t){if(t){(!t.axisPointer||0===t.axisPointer.length)&&(t.axisPointer={});var e=t.axisPointer.link;e&&!rl.isArray(e)&&(t.axisPointer.link=[e])}}),ym.registerProcessor(ym.PRIORITY.PROCESSOR.STATISTIC,function(t,e){t.getComponent("axisPointer").coordSysAxesInfo=Pv.collect(t,e)}),ym.registerAction({type:"updateAxisPointer",event:"updateAxisPointer",update:":updateAxisPointer"},IS);var NS=["x","y"],VS=["width","height"],BS=OS.extend({makeElOption:function(t,e,i,n,a){var o=i.axis,r=o.coordinateSystem,s=Wo(r,1-Ho(o)),l=r.dataToPoint(e)[0],h=n.get("type");if(h&&"none"!==h){var u=zS.buildElStyle(n),c=GS[h](o,l,s,u);c.style=u,t.graphicKey=c.type,t.pointer=c}var d=gS.layout(i);zS.buildCartesianSingleLabelElOption(e,t,d,i,n,a)},getHandleTransform:function(t,e,i){var n=gS.layout(e,{labelInside:!1});return n.labelMargin=i.get("handle.margin"),{position:zS.getTransformedPosition(e.axis,t,n),rotation:n.rotation+(n.labelDirection<0?Math.PI:0)}},updateHandleTransform:function(t,e,i,n){var a=i.axis,o=a.coordinateSystem,r=Ho(a),s=Wo(o,r),l=t.position;l[r]+=e[r],l[r]=Math.min(s[1],l[r]),l[r]=Math.max(s[0],l[r]);var h=Wo(o,1-r),u=(h[1]+h[0])/2,c=[u,u];return c[r]=l[r],{position:l,rotation:t.rotation,cursorPoint:c,tooltipOption:{verticalAlign:"middle"}}}}),GS={line:function(t,e,i,n){var a=zS.makeLineShape([e,i[0]],[e,i[1]],Ho(t));return fp.subPixelOptimizeLine({shape:a,style:n}),{type:"Line",shape:a}},shadow:function(t,e,i,n){var a=t.getBandWidth(),o=i[1]-i[0];return{type:"Rect",shape:zS.makeRectShape([e-a/2,i[0]],[a,o],Ho(t))}}};zv.registerAxisPointerClass("SingleAxisPointer",BS);ym.extendComponentView({type:"single"});var HS=Eu.encodeHTML,WS=zf.extend({type:"series.themeRiver",dependencies:["singleAxis"],nameMap:null,init:function(t){WS.superApply(this,"init",arguments),this.legendDataProvider=function(){return this.getRawData()}},fixData:function(t){for(var e=t.length,i=iw().key(function(t){return t[2]}).entries(t),n=rl.map(i,function(t){return{name:t.key,dataList:t.values}}),a=n.length,o=-1,r=-1,s=0;s<a;++s){var l=n[s].dataList.length;l>o&&(o=l,r=s)}for(var h=0;h<a;++h)if(h!==r)for(var u=n[h].name,c=0;c<o;++c){for(var d=n[r].dataList[c][0],p=n[h].dataList.length,f=-1,g=0;g<p;++g){if(n[h].dataList[g][0]===d){f=g;break}}-1===f&&(t[e]=[],t[e][0]=d,t[e][1]=0,t[e][2]=u,e++)}return t},getInitialData:function(t,e){var i=[],n=e.queryComponents({mainType:"singleAxis",index:this.get("singleAxisIndex"),id:this.get("singleAxisId")})[0].get("type");i=[{name:"time",type:"category"===n?"ordinal":"time"===n?"time":"float"},{name:"value",type:"float"},{name:"name",type:"ordinal"}];for(var a=rl.filter(t.data,function(t){return void 0!==t[2]}),o=this.fixData(a||[]),r=[],s=this.nameMap=rl.createHashMap(),l=0,h=0;h<o.length;++h)r.push(o[h][2]),s.get(o[h][2])||(s.set(o[h][2],l),l++);i=sg(i,o);var u=new tg(i,this);return u.initData(o,r),u},coordDimToDataDim:function(t){return["time"]},getLayerSeries:function(){for(var t=this.getData(),e=t.count(),i=[],n=0;n<e;++n)i[n]=n;for(var a=iw().key(function(e){return t.get("name",e)}).entries(i),o=rl.map(a,function(t){return{name:t.key,indices:t.values}}),r=0;r<o.length;++r)o[r].indices.sort(function(e,i){return t.get("time",e)-t.get("time",i)});return o},getAxisTooltipData:function(t,e,i){rl.isArray(t)||(t=t?[t]:[]);for(var n,a=this.getData(),o=this.getLayerSeries(),r=[],s=o.length,l=0;l<s;++l){for(var h=Number.MAX_VALUE,u=-1,c=o[l].indices.length,d=0;d<c;++d){var p=a.get(t[0],o[l].indices[d]),f=Math.abs(p-e);f<=h&&(n=p,h=f,u=o[l].indices[d])}r.push(u)}return{dataIndices:r,nestestValue:n}},formatTooltip:function(t){var e=this.getData(),i=e.get("name",t),n=e.get("value",t);return(isNaN(n)||null==n)&&(n="-"),HS(i+" : "+n)},defaultOption:{zlevel:0,z:2,coordinateSystem:"singleAxis",boundaryGap:["10%","10%"],singleAxisIndex:0,animationEasing:"linear",label:{normal:{margin:4,textAlign:"right",show:!0,position:"left",color:"#000",fontSize:11},emphasis:{show:!0}}}}),FS=Gm.Polygon,ZS=rl.bind,jS=rl.extend,US=(ym.extendChartView({type:"themeRiver",init:function(){this._layers=[]},render:function(t,e,i){function n(t){return t.name}function a(e,i,n){var a=this._layers;if("remove"!==e){for(var l,h=[],u=[],d=s[i].indices,p=0;p<d.length;p++){var f=o.getItemLayout(d[p]),g=f.x,m=f.y0,v=f.y;h.push([g,m]),u.push([g,m+v]),l=o.getItemVisual(d[p],"color")}var y,x,_=o.getItemLayout(d[0]),b=o.getItemModel(d[p-1]),w=b.getModel("label.normal"),S=w.get("margin");if("add"===e){M=c[i]=new fp.Group;y=new FS({shape:{points:h,stackedOnPoints:u,smooth:.4,stackedOnSmooth:.4,smoothConstraint:!1},z2:0}),x=new fp.Text({style:{x:_.x-S,y:_.y0+_.y/2}}),M.add(y),M.add(x),r.add(M),y.setClipPath(function(t,e,i){var n=new fp.Rect({shape:{x:t.x-10,y:t.y-10,width:0,height:t.height+20}});return fp.initProps(n,{shape:{width:t.width+20,height:t.height+20}},e,i),n}(y.getBoundingRect(),t,function(){y.removeClipPath()}))}else{var M=a[n];y=M.childAt(0),x=M.childAt(1),r.add(M),c[i]=M,fp.updateProps(y,{shape:{points:h,stackedOnPoints:u}},t),fp.updateProps(x,{style:{x:_.x-S,y:_.y0+_.y/2}},t)}var I=b.getModel("itemStyle.emphasis"),T=b.getModel("itemStyle.normal");fp.setTextStyle(x.style,w,{text:w.get("show")?t.getFormattedLabel(d[p-1],"normal")||o.getName(d[p-1]):null,textVerticalAlign:"middle"}),y.setStyle(jS({fill:l},T.getItemStyle(["color"]))),fp.setHoverStyle(y,I.getItemStyle())}else r.remove(a[i])}var o=t.getData(),r=this.group,s=t.getLayerSeries(),l=o.getLayout("layoutInfo"),h=l.rect,u=l.boundaryGap;r.attr("position",[0,h.y+u[0]]);var c={};new qf(this._layersSeries||[],s,n,n).add(ZS(a,this,"add")).update(ZS(a,this,"update")).remove(ZS(a,this,"remove")).execute(),this._layersSeries=s,this._layers=c},dispose:function(){}}),function(t,e){t.eachSeriesByType("themeRiver",function(t){var e=t.getData(),i=t.coordinateSystem,n={},a=i.getRect();n.rect=a;var o=t.get("boundaryGap"),r=i.getAxis();n.boundaryGap=o,"horizontal"===r.orient?(o[0]=Pu.parsePercent(o[0],a.height),o[1]=Pu.parsePercent(o[1],a.height),Fo(e,t,a.height-o[0]-o[1])):(o[0]=Pu.parsePercent(o[0],a.width),o[1]=Pu.parsePercent(o[1],a.width),Fo(e,t,a.width-o[0]-o[1])),e.setLayout("layoutInfo",n)})}),qS=rl.createHashMap,XS=function(t){t.eachSeriesByType("themeRiver",function(t){var e=t.getData(),i=t.getRawData(),n=t.get("color"),a=qS();e.each(function(t){a.set(e.getRawIndex(t),t)}),i.each(function(o){var r=i.getName(o),s=n[(t.nameMap.get(r)-1)%n.length];i.setItemVisual(o,"color",s);var l=a.get(o);null!=l&&e.setItemVisual(l,"color",s)})})};ym.registerLayout(US),ym.registerVisual(XS),ym.registerProcessor(rl.curry(uy,"themeRiver"));var YS=_m.findLabelValueDim,$S=["itemStyle","normal"],KS=["itemStyle","emphasis"],JS=["label","normal"],QS=["label","emphasis"],tM="e\0\0",eM={cartesian2d:function(t){var e=t.grid.getRect();return{coordSys:{type:"cartesian2d",x:e.x,y:e.y,width:e.width,height:e.height},api:{coord:rl.bind(t.dataToPoint,t),size:rl.bind(function(t,e){return e=e||[0,0],rl.map(["x","y"],function(i,n){var a=this.getAxis(i),o=e[n],r=t[n]/2;return"category"===a.type?a.getBandWidth():Math.abs(a.dataToCoord(o-r)-a.dataToCoord(o+r))},this)},t)}}},geo:function(t){var e=t.getBoundingRect();return{coordSys:{type:"geo",x:e.x,y:e.y,width:e.width,height:e.height},api:{coord:rl.bind(t.dataToPoint,t),size:rl.bind(function(t,e){return e=e||[0,0],rl.map([0,1],function(i){var n=e[i],a=t[i]/2,o=[],r=[];return o[i]=n-a,r[i]=n+a,o[1-i]=r[1-i]=e[1-i],Math.abs(this.dataToPoint(o)[i]-this.dataToPoint(r)[i])},this)},t)}}},singleAxis:function(t){var e=t.getRect();return{coordSys:{type:"singleAxis",x:e.x,y:e.y,width:e.width,height:e.height},api:{coord:rl.bind(t.dataToPoint,t),size:rl.bind(function(t,e){var i=this.getAxis(),n=e instanceof Array?e[0]:e,a=(t instanceof Array?t[0]:t)/2;return"category"===i.type?i.getBandWidth():Math.abs(i.dataToCoord(n-a)-i.dataToCoord(n+a))},t)}}},polar:function(t){var e=t.getRadiusAxis(),i=t.getAngleAxis(),n=e.getExtent();return n[0]>n[1]&&n.reverse(),{coordSys:{type:"polar",cx:t.cx,cy:t.cy,r:n[1],r0:n[0]},api:{coord:rl.bind(function(n){var a=e.dataToRadius(n[0]),o=i.dataToAngle(n[1]),r=t.coordToPoint([a,o]);return r.push(a,o*Math.PI/180),r}),size:rl.bind(function(t,e){return rl.map(["Radius","Angle"],function(i,n){var a=this["get"+i+"Axis"](),o=e[n],r=t[n]/2,s="dataTo"+i,l="category"===a.type?a.getBandWidth():Math.abs(a[s](o-r)-a[s](o+r));return"Angle"===i&&(l=l*Math.PI/180),l},this)},t)}}},calendar:function(t){var e=t.getRect(),i=t.getRangeInfo();return{coordSys:{type:"calendar",x:e.x,y:e.y,width:e.width,height:e.height,cellWidth:t.getCellWidth(),cellHeight:t.getCellHeight(),rangeInfo:{start:i.start,end:i.end,weeks:i.weeks,dayCount:i.allDay}},api:{coord:rl.bind(t.dataToPoint,t)}}}};ym.extendSeriesModel({type:"series.custom",dependencies:["grid","polar","geo","singleAxis","calendar"],defaultOption:{coordinateSystem:"cartesian2d",zlevel:0,z:2,legendHoverLink:!0},getInitialData:function(t,e){return dg(t.data,this,e)}}),ym.extendChartView({type:"custom",_data:null,render:function(t,e,i){var n=this._data,a=t.getData(),o=this.group,r=function(t,e,i,n){function a(t){null==t&&(t=l),m&&(h=e.getItemModel(t),u=h.getModel(JS),c=h.getModel(QS),d=YS(e),p=e.getItemVisual(t,"color"),m=!1)}var o=t.get("renderItem"),r=t.coordinateSystem,s={};r&&(s=r.prepareCustoms?r.prepareCustoms():eM[r.type](r));var l,h,u,c,d,p,f=rl.defaults({getWidth:n.getWidth,getHeight:n.getHeight,getZr:n.getZr,getDevicePixelRatio:n.getDevicePixelRatio,value:function(t,i){return null==i&&(i=l),e.get(e.getDimension(t||0),i)},style:function(i,n){null==n&&(n=l),a(n);var o=h.getModel($S).getItemStyle();null!=p&&(o.fill=p);var r=e.getItemVisual(n,"opacity");return null!=r&&(o.opacity=r),null!=d&&(fp.setTextStyle(o,u,null,{autoColor:p,isRectText:!0}),o.text=u.getShallow("show")?rl.retrieve2(t.getFormattedLabel(n,"normal"),e.get(d,n)):null),i&&rl.extend(o,i),o},styleEmphasis:function(i,n){null==n&&(n=l),a(n);var o=h.getModel(KS).getItemStyle();return null!=d&&(fp.setTextStyle(o,c,null,{isRectText:!0},!0),o.text=c.getShallow("show")?rl.retrieve3(t.getFormattedLabel(n,"emphasis"),t.getFormattedLabel(n,"normal"),e.get(d,n)):null),i&&rl.extend(o,i),o},visual:function(t,i){return null==i&&(i=l),e.getItemVisual(i,t)},barLayout:function(t){if(r.getBaseAxis){var e=r.getBaseAxis();return Fv.getLayoutOnAxis(rl.defaults({axis:e},t),n)}},currentSeriesIndices:function(){return i.getCurrentSeriesIndices()},font:function(t){return fp.getFont(t,i)}},s.api||{}),g={context:{},seriesId:t.id,seriesName:t.name,seriesIndex:t.seriesIndex,coordSys:s.coordSys,dataInsideLength:e.count(),encode:function(t){var e={};return rl.each(t.dimensions,function(i,n){var a=t.getDimensionInfo(i);if(!a.isExtraCoord){var o=a.coordDim;(e[o]=e[o]||[])[a.coordDimIndex]=n}}),e}(t.getData())},m=!0;return function(t){return l=t,m=!0,o&&o(rl.defaults({dataIndexInside:t,dataIndex:e.getRawIndex(t)},g),f)||{}}}(t,a,e,i);a.diff(n).add(function(e){a.hasValue(e)&&jo(null,e,r(e),t,o,a)}).update(function(e,i){var s=n.getItemGraphicEl(i);a.hasValue(e)?jo(s,e,r(e),t,o,a):s&&o.remove(s)}).remove(function(t){var e=n.getItemGraphicEl(t);e&&o.remove(e)}).execute(),this._data=a},dispose:rl.noop});ym.registerPreprocessor(function(t){var e=t.graphic;rl.isArray(e)?e[0]&&e[0].elements?t.graphic=[t.graphic[0]]:t.graphic=[{elements:e}]:e&&!e.elements&&(t.graphic=[{elements:[e]}])});var iM=ym.extendComponentModel({type:"graphic",defaultOption:{elements:[],parentId:null},_elOptionsToUpdate:null,mergeOption:function(t){var e=this.option.elements;this.option.elements=null,iM.superApply(this,"mergeOption",arguments),this.option.elements=e},optionUpdated:function(t,e){var i=this.option,n=(e?i:t).elements,a=i.elements=e?[]:i.elements,o=[];this._flatten(n,o);var r=Ip.mappingToExists(a,o);Ip.makeIdAndName(r);var s=this._elOptionsToUpdate=[];rl.each(r,function(t,e){var i=t.option;i&&(s.push(i),function(t,e){var i=t.exist;if(e.id=t.keyInfo.id,!e.type&&i&&(e.type=i.type),null==e.parentId){var n=e.parentOption;n?e.parentId=n.id:i&&(e.parentId=i.parentId)}e.parentOption=null}(t,i),function(t,e,i){var n=rl.extend({},i),a=t[e],o=i.$action||"merge";"merge"===o?a?(rl.merge(a,n,!0),Np.mergeLayoutParam(a,n,{ignoreSize:!0}),Np.copyLayoutParams(i,a)):t[e]=n:"replace"===o?t[e]=n:"remove"===o&&a&&(t[e]=null)}(a,e,i),function(t,e){t&&(t.hv=e.hv=[Ko(e,["left","right"]),Ko(e,["top","bottom"])],"group"===t.type&&(null==t.width&&(t.width=e.width=0),null==t.height&&(t.height=e.height=0)))}(a[e],i))},this);for(var l=a.length-1;l>=0;l--)null==a[l]?a.splice(l,1):delete a[l].$action},_flatten:function(t,e,i){rl.each(t,function(t){if(t){i&&(t.parentOption=i),e.push(t);var n=t.children;"group"===t.type&&n&&this._flatten(n,e,t),delete t.children}},this)},useElOptionsToUpdate:function(){var t=this._elOptionsToUpdate;return this._elOptionsToUpdate=null,t}});ym.extendComponentView({type:"graphic",init:function(t,e){this._elMap=rl.createHashMap(),this._lastGraphicModel},render:function(t,e,i){t!==this._lastGraphicModel&&this._clear(),this._lastGraphicModel=t,this._updateElements(t,i),this._relocate(t,i)},_updateElements:function(t,e){var i=t.useElOptionsToUpdate();if(i){var n=this._elMap,a=this.group;rl.each(i,function(t){var e=t.$action,i=t.id,o=n.get(i),r=t.parentId,s=null!=r?n.get(r):a;if("text"===t.type){var l=t.style;t.hv&&t.hv[1]&&(l.textVerticalAlign=l.textBaseline=null),!l.hasOwnProperty("textFill")&&l.fill&&(l.textFill=l.fill),!l.hasOwnProperty("textStroke")&&l.stroke&&(l.textStroke=l.stroke)}var h=function(t){return t=rl.extend({},t),rl.each(["id","parentId","$action","hv","bounding"].concat(Np.LOCATION_PARAMS),function(e){delete t[e]}),t}(t);e&&"merge"!==e?"replace"===e?($o(o,n),Yo(i,s,h,n)):"remove"===e&&$o(o,n):o?o.attr(h):Yo(i,s,h,n);var u=n.get(i);u&&(u.__ecGraphicWidth=t.width,u.__ecGraphicHeight=t.height)})}},_relocate:function(t,e){for(var i=t.option.elements,n=this.group,a=this._elMap,o=i.length-1;o>=0;o--){var r=i[o],s=a.get(r.id);if(s){var l=s.parent,h=l===n?{width:e.getWidth(),height:e.getHeight()}:{width:l.__ecGraphicWidth||0,height:l.__ecGraphicHeight||0};Np.positionElement(s,r,h,null,{hv:r.hv,boundingMode:r.bounding})}}},_clear:function(){var t=this._elMap;t.each(function(e){$o(e,t)}),this._elMap=rl.createHashMap()},dispose:function(){this._clear()}});var nM=ym.extendComponentModel({type:"legend.plain",dependencies:["series"],layoutMode:{type:"box",ignoreSize:!0},init:function(t,e,i){this.mergeDefaultAndTheme(t,i),t.selected=t.selected||{}},mergeOption:function(t){nM.superCall(this,"mergeOption",t)},optionUpdated:function(){this._updateData(this.ecModel);var t=this._data;if(t[0]&&"single"===this.get("selectedMode")){for(var e=!1,i=0;i<t.length;i++){var n=t[i].get("name");if(this.isSelected(n)){this.select(n),e=!0;break}}!e&&this.select(t[0].get("name"))}},_updateData:function(t){var e=rl.map(this.get("data")||[],function(t){return"string"!=typeof t&&"number"!=typeof t||(t={name:t}),new _p(t,this,this.ecModel)},this);this._data=e;var i=rl.map(t.getSeries(),function(t){return t.name});t.eachSeries(function(t){if(t.legendDataProvider){var e=t.legendDataProvider();i=i.concat(e.mapArray(e.getName))}}),this._availableNames=i},getData:function(){return this._data},select:function(t){var e=this.option.selected;if("single"===this.get("selectedMode")){var i=this._data;rl.each(i,function(t){e[t.get("name")]=!1})}e[t]=!0},unSelect:function(t){"single"!==this.get("selectedMode")&&(this.option.selected[t]=!1)},toggleSelected:function(t){var e=this.option.selected;e.hasOwnProperty(t)||(e[t]=!0),this[e[t]?"unSelect":"select"](t)},isSelected:function(t){var e=this.option.selected;return!(e.hasOwnProperty(t)&&!e[t])&&rl.indexOf(this._availableNames,t)>=0},defaultOption:{zlevel:0,z:4,show:!0,orient:"horizontal",left:"center",top:0,align:"auto",backgroundColor:"rgba(0,0,0,0)",borderColor:"#ccc",borderRadius:0,borderWidth:0,padding:5,itemGap:10,itemWidth:25,itemHeight:14,inactiveColor:"#ccc",textStyle:{color:"#333"},selectedMode:!0,tooltip:{show:!1}}}),aM=nM;ym.registerAction("legendToggleSelect","legendselectchanged",rl.curry(Jo,"toggleSelected")),ym.registerAction("legendSelect","legendselected",rl.curry(Jo,"select")),ym.registerAction("legendUnSelect","legendunselected",rl.curry(Jo,"unSelect"));var oM=Np.getLayoutRect,rM=Np.box,sM=Np.positionElement,lM={layout:function(t,e,i){var n=e.getBoxLayoutParams(),a=e.get("padding"),o={width:i.getWidth(),height:i.getHeight()},r=oM(n,o,a);rM(e.get("orient"),t,e.get("itemGap"),r.width,r.height),sM(t,n,o,a)},makeBackground:function(t,e){var i=Eu.normalizeCssArray(e.get("padding")),n=e.getItemStyle(["color","opacity"]);return n.fill=e.get("backgroundColor"),t=new fp.Rect({shape:{x:t.x-i[3],y:t.y-i[0],width:t.width+i[1]+i[3],height:t.height+i[0]+i[2],r:e.get("borderRadius")},style:n,silent:!0,z2:-1})}},hM=Ug.createSymbol,uM=lM.makeBackground,cM=rl.curry,dM=rl.each,pM=fp.Group,fM=ym.extendComponentView({type:"legend.plain",newlineDisabled:!1,init:function(){this.group.add(this._contentGroup=new pM),this._backgroundEl},getContentGroup:function(){return this._contentGroup},render:function(t,e,i){if(this.resetInner(),t.get("show",!0)){var n=t.get("align");n&&"auto"!==n||(n="right"===t.get("left")&&"vertical"===t.get("orient")?"right":"left"),this.renderInner(n,t,e,i);var a=t.getBoxLayoutParams(),o={width:i.getWidth(),height:i.getHeight()},r=t.get("padding"),s=Np.getLayoutRect(a,o,r),l=this.layoutInner(t,n,s),h=Np.getLayoutRect(rl.defaults({width:l.width,height:l.height},a),o,r);this.group.attr("position",[h.x-l.x,h.y-l.y]),this.group.add(this._backgroundEl=uM(l,t))}},resetInner:function(){this.getContentGroup().removeAll(),this._backgroundEl&&this.group.remove(this._backgroundEl)},renderInner:function(t,e,i,n){var a=this.getContentGroup(),o=rl.createHashMap(),r=e.get("selectedMode");dM(e.getData(),function(s,l){var h=s.get("name");if(this.newlineDisabled||""!==h&&"\n"!==h){var u=i.getSeriesByName(h)[0];if(!o.get(h))if(u){var c=u.getData(),d=c.getVisual("color");"function"==typeof d&&(d=d(u.getDataParams(0)));var p=c.getVisual("legendSymbol")||"roundRect",f=c.getVisual("symbol");this._createItem(h,l,s,e,p,f,t,d,r).on("click",cM(Qo,h,n)).on("mouseover",cM(tr,u,null,n)).on("mouseout",cM(er,u,null,n)),o.set(h,!0)}else i.eachRawSeries(function(i){if(!o.get(h)&&i.legendDataProvider){var a=i.legendDataProvider(),u=a.indexOfName(h);if(u<0)return;var c=a.getItemVisual(u,"color");this._createItem(h,l,s,e,"roundRect",null,t,c,r).on("click",cM(Qo,h,n)).on("mouseover",cM(tr,i,h,n)).on("mouseout",cM(er,i,h,n)),o.set(h,!0)}},this)}else a.add(new pM({newline:!0}))},this)},_createItem:function(t,e,i,n,a,o,r,s,l){var h=n.get("itemWidth"),u=n.get("itemHeight"),c=n.get("inactiveColor"),d=n.isSelected(t),p=new pM,f=i.getModel("textStyle"),g=i.get("icon"),m=i.getModel("tooltip"),v=m.parentModel;if(a=g||a,p.add(hM(a,0,0,h,u,d?s:c,!0)),!g&&o&&(o!==a||"none"==o)){var y=.8*u;"none"===o&&(o="circle"),p.add(hM(o,(h-y)/2,(u-y)/2,y,y,d?s:c))}var x="left"===r?h+5:-5,_=r,b=n.get("formatter"),w=t;"string"==typeof b&&b?w=b.replace("{name}",null!=t?t:""):"function"==typeof b&&(w=b(t)),p.add(new fp.Text({style:fp.setTextStyle({},f,{text:w,x:x,y:u/2,textFill:d?f.getTextColor():c,textAlign:_,textVerticalAlign:"middle"})}));var S=new fp.Rect({shape:p.getBoundingRect(),invisible:!0,tooltip:m.get("show")?rl.extend({content:t,formatter:v.get("formatter",!0)||function(){return t},formatterParams:{componentType:"legend",legendIndex:n.componentIndex,name:t,$vars:["name"]}},m.option):null});return p.add(S),p.eachChild(function(t){t.silent=!0}),S.silent=!l,this.getContentGroup().add(p),fp.setHoverStyle(p),p.__legendDataIndex=e,p},layoutInner:function(t,e,i){var n=this.getContentGroup();Np.box(t.get("orient"),n,t.get("itemGap"),i.width,i.height);var a=n.getBoundingRect();return n.attr("position",[-a.x,-a.y]),this.group.getBoundingRect()}}),gM=function(t){var e=t.findComponents({mainType:"legend"});e&&e.length&&t.filterSeries(function(t){for(var i=0;i<e.length;i++)if(!e[i].isSelected(t.name))return!1;return!0})};ym.registerProcessor(gM),Hp.registerSubTypeDefaulter("legend",function(){return"plain"});var mM=Np.mergeLayoutParam,vM=Np.getLayoutParams,yM=aM.extend({type:"legend.scroll",setScrollDataIndex:function(t){this.option.scrollDataIndex=t},defaultOption:{scrollDataIndex:0,pageButtonItemGap:5,pageButtonGap:null,pageButtonPosition:"end",pageFormatter:"{current}/{total}",pageIcons:{horizontal:["M0,0L12,-10L12,10z","M0,0L-12,-10L-12,10z"],vertical:["M0,0L20,0L10,-20z","M0,0L20,0L10,20z"]},pageIconColor:"#2f4554",pageIconInactiveColor:"#aaa",pageIconSize:15,pageTextStyle:{color:"#333"},animationDurationUpdate:800},init:function(t,e,i,n){var a=vM(t);yM.superCall(this,"init",t,e,i,n),ir(this,t,a)},mergeOption:function(t,e){yM.superCall(this,"mergeOption",t,e),ir(this,this.option,t)},getOrient:function(){return"vertical"===this.get("orient")?{index:1,name:"vertical"}:{index:0,name:"horizontal"}}}),xM=fp.Group,_M=["width","height"],bM=["x","y"],wM=fM.extend({type:"legend.scroll",newlineDisabled:!0,init:function(){wM.superCall(this,"init"),this._currentIndex=0,this.group.add(this._containerGroup=new xM),this._containerGroup.add(this.getContentGroup()),this.group.add(this._controllerGroup=new xM),this._showController},resetInner:function(){wM.superCall(this,"resetInner"),this._controllerGroup.removeAll(),this._containerGroup.removeClipPath(),this._containerGroup.__rectSize=null},renderInner:function(t,e,i,n){function a(t,i){var a=t+"DataIndex",l=fp.createIcon(e.get("pageIcons",!0)[e.getOrient().name][i],{onclick:rl.bind(o._pageGo,o,a,e,n)},{x:-s[0]/2,y:-s[1]/2,width:s[0],height:s[1]});l.name=t,r.add(l)}var o=this;wM.superCall(this,"renderInner",t,e,i,n);var r=this._controllerGroup,s=e.get("pageIconSize",!0);rl.isArray(s)||(s=[s,s]),a("pagePrev",0);var l=e.getModel("pageTextStyle");r.add(new fp.Text({name:"pageText",style:{textFill:l.getTextColor(),font:l.getFont(),textVerticalAlign:"middle",textAlign:"center"},silent:!0})),a("pageNext",1)},layoutInner:function(t,e,i){var n=this.getContentGroup(),a=this._containerGroup,o=this._controllerGroup,r=t.getOrient().index,s=_M[r],l=_M[1-r],h=bM[1-r];Np.box(t.get("orient"),n,t.get("itemGap"),r?i.width:null,r?null:i.height),Np.box("horizontal",o,t.get("pageButtonItemGap",!0));var u=n.getBoundingRect(),c=o.getBoundingRect(),d=this._showController=u[s]>i[s],p=[-u.x,-u.y];p[r]=n.position[r];var f=[0,0],g=[-c.x,-c.y],m=rl.retrieve2(t.get("pageButtonGap",!0),t.get("itemGap",!0));if(d){"end"===t.get("pageButtonPosition",!0)?g[r]+=i[s]-c[s]:f[r]+=c[s]+m}g[1-r]+=u[l]/2-c[l]/2,n.attr("position",p),a.attr("position",f),o.attr("position",g);var v=this.group.getBoundingRect();if((v={x:0,y:0})[s]=d?i[s]:u[s],v[l]=Math.max(u[l],c[l]),v[h]=Math.min(0,c[h]+g[1-r]),a.__rectSize=i[s],d){var y={x:0,y:0};y[s]=Math.max(i[s]-c[s]-m,0),y[l]=v[l],a.setClipPath(new fp.Rect({shape:y})),a.__rectSize=y[s]}else o.eachChild(function(t){t.attr({invisible:!0,silent:!0})});var x=this._getPageInfo(t);return null!=x.pageIndex&&fp.updateProps(n,{position:x.contentPosition},!!d&&t),this._updatePageInfoView(t,x),v},_pageGo:function(t,e,i){var n=this._getPageInfo(e)[t];null!=n&&i.dispatchAction({type:"legendScroll",scrollDataIndex:n,legendId:e.id})},_updatePageInfoView:function(t,e){var i=this._controllerGroup;rl.each(["pagePrev","pageNext"],function(n){var a=null!=e[n+"DataIndex"],o=i.childOfName(n);o&&(o.setStyle("fill",a?t.get("pageIconColor",!0):t.get("pageIconInactiveColor",!0)),o.cursor=a?"pointer":"default")});var n=i.childOfName("pageText"),a=t.get("pageFormatter"),o=e.pageIndex,r=null!=o?o+1:0,s=e.pageCount;n&&a&&n.setStyle("text",rl.isString(a)?a.replace("{current}",r).replace("{total}",s):a({current:r,total:s}))},_getPageInfo:function(t){function e(t){var e=t.getBoundingRect().clone();return e[p]+=t.position[u],e}var i,n,a,o,r=t.get("scrollDataIndex",!0),s=this.getContentGroup(),l=s.getBoundingRect(),h=this._containerGroup.__rectSize,u=t.getOrient().index,c=_M[u],d=_M[1-u],p=bM[u],f=s.position.slice();this._showController?s.eachChild(function(t){t.__legendDataIndex===r&&(o=t)}):o=s.childAt(0);var g=h?Math.ceil(l[c]/h):0;if(o){var m=o.getBoundingRect(),v=o.position[u]+m[p];f[u]=-v-l[p],i=Math.floor(g*(v+m[p]+h/2)/l[c]),i=l[c]&&g?Math.max(0,Math.min(g-1,i)):-1;var y={x:0,y:0};y[c]=h,y[d]=l[d],y[p]=-f[u]-l[p];var x,_=s.children();if(s.eachChild(function(t,i){var n=e(t);n.intersect(y)&&(null==x&&(x=i),a=t.__legendDataIndex),i===_.length-1&&n[p]+n[c]<=y[p]+y[c]&&(a=null)}),null!=x){var b=e(_[x]);if(y[p]=b[p]+b[c]-y[c],x<=0&&b[p]>=y[p])n=null;else{for(;x>0&&e(_[x-1]).intersect(y);)x--;n=_[x].__legendDataIndex}}}return{contentPosition:f,pageIndex:i,pageCount:g,pagePrevDataIndex:n,pageNextDataIndex:a}}});ym.registerAction("legendScroll","legendscroll",function(t,e){var i=t.scrollDataIndex;null!=i&&e.eachComponent({mainType:"legend",subType:"scroll",query:t},function(t){t.setScrollDataIndex(i)})});ym.extendComponentModel({type:"tooltip",dependencies:["axisPointer"],defaultOption:{zlevel:0,z:8,show:!0,showContent:!0,trigger:"item",triggerOn:"mousemove|click",alwaysShowContent:!1,displayMode:"single",confine:!1,showDelay:0,hideDelay:100,transitionDuration:.4,enterable:!1,backgroundColor:"rgba(50,50,50,0.7)",borderColor:"#333",borderRadius:4,borderWidth:0,padding:5,extraCssText:"",axisPointer:{type:"line",axis:"auto",animation:"auto",animationDurationUpdate:200,animationEasingUpdate:"exponentialOut",crossStyle:{color:"#999",width:1,type:"dashed",textStyle:{}}},textStyle:{color:"#fff",fontSize:14}}});var SM=rl.each,MM=Eu.toCamelCase,IM=["","-webkit-","-moz-","-o-"];nr.prototype={constructor:nr,_enterable:!0,update:function(){var t=this._container,e=t.currentStyle||document.defaultView.getComputedStyle(t),i=t.style;"absolute"!==i.position&&"absolute"!==e.position&&(i.position="relative")},show:function(t){clearTimeout(this._hideTimeout);var e=this.el;e.style.cssText="position:absolute;display:block;border-style:solid;white-space:nowrap;z-index:9999999;"+function(t){var e=[],i=t.get("transitionDuration"),n=t.get("backgroundColor"),a=t.getModel("textStyle"),o=t.get("padding");return i&&e.push(function(t){var e="left "+t+"s cubic-bezier(0.23, 1, 0.32, 1),top "+t+"s cubic-bezier(0.23, 1, 0.32, 1)";return rl.map(IM,function(t){return t+"transition:"+e}).join(";")}(i)),n&&(Us.canvasSupported?e.push("background-Color:"+n):(e.push("background-Color:#"+Nl.toHex(n)),e.push("filter:alpha(opacity=70)"))),SM(["width","color","radius"],function(i){var n="border-"+i,a=MM(n),o=t.get(a);null!=o&&e.push(n+":"+o+("color"===i?"":"px"))}),e.push(function(t){var e=[],i=t.get("fontSize"),n=t.getTextColor();return n&&e.push("color:"+n),e.push("font:"+t.getFont()),i&&e.push("line-height:"+Math.round(3*i/2)+"px"),SM(["decoration","align"],function(i){var n=t.get(i);n&&e.push("text-"+i+":"+n)}),e.join(";")}(a)),null!=o&&e.push("padding:"+Eu.normalizeCssArray(o).join("px ")+"px"),e.join(";")+";"}(t)+";left:"+this._x+"px;top:"+this._y+"px;"+(t.get("extraCssText")||""),e.style.display=e.innerHTML?"block":"none",this._show=!0},setContent:function(t){this.el.innerHTML=null==t?"":t},setEnterable:function(t){this._enterable=t},getSize:function(){var t=this.el;return[t.clientWidth,t.clientHeight]},moveTo:function(t,e){var i,n=this._zr;n&&n.painter&&(i=n.painter.getViewportRootOffset())&&(t+=i.offsetLeft,e+=i.offsetTop);var a=this.el.style;a.left=t+"px",a.top=e+"px",this._x=t,this._y=e},hide:function(){this.el.style.display="none",this._show=!1},hideLater:function(t){!this._show||this._inContent&&this._enterable||(t?(this._hideDelay=t,this._show=!1,this._hideTimeout=setTimeout(rl.bind(this.hide,this),t)):this.hide())},isShow:function(){return this._show}};var TM=nr,AM=rl.bind,CM=rl.each,LM=Pu.parsePercent,DM=new fp.Rect({shape:{x:-1,y:-1,width:2,height:2}});ym.extendComponentView({type:"tooltip",init:function(t,e){if(!Us.node){var i=new TM(e.getDom(),e);this._tooltipContent=i}},render:function(t,e,i){if(!Us.node){this.group.removeAll(),this._tooltipModel=t,this._ecModel=e,this._api=i,this._lastDataByCoordSys=null,this._alwaysShowContent=t.get("alwaysShowContent");var n=this._tooltipContent;n.update(),n.setEnterable(t.get("enterable")),this._initGlobalListener(),this._keepShow()}},_initGlobalListener:function(){var t=this._tooltipModel.get("triggerOn");CS.register("itemTooltip",this._api,AM(function(e,i,n){"none"!==t&&(t.indexOf(e)>=0?this._tryShow(i,n):"leave"===e&&this._hide(n))},this))},_keepShow:function(){var t=this._tooltipModel,e=this._ecModel,i=this._api;if(null!=this._lastX&&null!=this._lastY&&"none"!==t.get("triggerOn")){var n=this;clearTimeout(this._refreshUpdateTimeout),this._refreshUpdateTimeout=setTimeout(function(){n.manuallyShowTip(t,e,i,{x:n._lastX,y:n._lastY})})}},manuallyShowTip:function(t,e,i,n){if(n.from!==this.uid&&!Us.node){var a=or(n,i);this._ticket="";var o=n.dataByCoordSys;if(n.tooltip&&null!=n.x&&null!=n.y){var r=DM;r.position=[n.x,n.y],r.update(),r.tooltip=n.tooltip,this._tryShow({offsetX:n.x,offsetY:n.y,target:r},a)}else if(o)this._tryShow({offsetX:n.x,offsetY:n.y,position:n.position,event:{},dataByCoordSys:n.dataByCoordSys,tooltipOption:n.tooltipOption},a);else if(null!=n.seriesIndex){if(this._manuallyAxisShowTip(t,e,i,n))return;var s=bS(n,e),l=s.point[0],h=s.point[1];null!=l&&null!=h&&this._tryShow({offsetX:l,offsetY:h,position:n.position,target:s.el,event:{}},a)}else null!=n.x&&null!=n.y&&(i.dispatchAction({type:"updateAxisPointer",x:n.x,y:n.y}),this._tryShow({offsetX:n.x,offsetY:n.y,position:n.position,target:i.getZr().findHover(n.x,n.y).target,event:{}},a))}},manuallyHideTip:function(t,e,i,n){var a=this._tooltipContent;this._alwaysShowContent||a.hideLater(this._tooltipModel.get("hideDelay")),this._lastX=this._lastY=null,n.from!==this.uid&&this._hide(or(n,i))},_manuallyAxisShowTip:function(t,e,i,n){var a=n.seriesIndex,o=n.dataIndex,r=e.getComponent("axisPointer").coordSysAxesInfo;if(null!=a&&null!=o&&null!=r){var s=e.getSeriesByIndex(a);if(s){if("axis"===(t=ar([s.getData().getItemModel(o),s,(s.coordinateSystem||{}).model,t])).get("trigger"))return i.dispatchAction({type:"updateAxisPointer",seriesIndex:a,dataIndex:o,position:n.position}),!0}}},_tryShow:function(t,e){var i=t.target;if(this._tooltipModel){this._lastX=t.offsetX,this._lastY=t.offsetY;var n=t.dataByCoordSys;n&&n.length?this._showAxisTooltip(n,t):i&&null!=i.dataIndex?(this._lastDataByCoordSys=null,this._showSeriesItemTooltip(t,i,e)):i&&i.tooltip?(this._lastDataByCoordSys=null,this._showComponentItemTooltip(t,i,e)):(this._lastDataByCoordSys=null,this._hide(e))}},_showOrMove:function(t,e){var i=t.get("showDelay");e=rl.bind(e,this),clearTimeout(this._showTimout),i>0?this._showTimout=setTimeout(e,i):e()},_showAxisTooltip:function(t,e){var i=this._ecModel,n=this._tooltipModel,a=[e.offsetX,e.offsetY],o=[],r=[],s=ar([e.tooltipOption,n]);CM(t,function(t){CM(t.dataByAxis,function(t){var e=i.getComponent(t.axisDim+"Axis",t.axisIndex),n=t.value,a=[];if(e&&null!=n){var s=zS.getValueLabel(n,e.axis,i,t.seriesDataIndices,t.valueLabelOpt);rl.each(t.seriesDataIndices,function(o){var l=i.getSeriesByIndex(o.seriesIndex),h=o.dataIndexInside,u=l&&l.getDataParams(h);u.axisDim=t.axisDim,u.axisIndex=t.axisIndex,u.axisType=t.axisType,u.axisId=t.axisId,u.axisValue=Rg.getAxisRawValue(e.axis,n),u.axisValueLabel=s,u&&(r.push(u),a.push(l.formatTooltip(h,!0)))});var l=s;o.push((l?Eu.encodeHTML(l)+"<br />":"")+a.join("<br />"))}})},this),o.reverse(),o=o.join("<br /><br />");var l=e.position;this._showOrMove(s,function(){this._updateContentNotChangedOnAxis(t)?this._updatePosition(s,l,a[0],a[1],this._tooltipContent,r):this._showTooltipContent(s,o,r,Math.random(),a[0],a[1],l)})},_showSeriesItemTooltip:function(t,e,i){var n=this._ecModel,a=e.seriesIndex,o=n.getSeriesByIndex(a),r=e.dataModel||o,s=e.dataIndex,l=e.dataType,h=r.getData(),u=ar([h.getItemModel(s),r,o&&(o.coordinateSystem||{}).model,this._tooltipModel]),c=u.get("trigger");if(null==c||"item"===c){var d=r.getDataParams(s,l),p=r.formatTooltip(s,!1,l),f="item_"+r.name+"_"+s;this._showOrMove(u,function(){this._showTooltipContent(u,p,d,f,t.offsetX,t.offsetY,t.position,t.target)}),i({type:"showTip",dataIndexInside:s,dataIndex:h.getRawIndex(s),seriesIndex:a,from:this.uid})}},_showComponentItemTooltip:function(t,e,i){var n=e.tooltip;if("string"==typeof n){var a=n;n={content:a,formatter:a}}var o=new _p(n,this._tooltipModel,this._ecModel),r=o.get("content"),s=Math.random();this._showOrMove(o,function(){this._showTooltipContent(o,r,o.get("formatterParams")||{},s,t.offsetX,t.offsetY,t.position,e)}),i({type:"showTip",from:this.uid})},_showTooltipContent:function(t,e,i,n,a,o,r,s){if(this._ticket="",t.get("showContent")&&t.get("show")){var l=this._tooltipContent,h=t.get("formatter");r=r||t.get("position");var u=e;if(h&&"string"==typeof h)u=Eu.formatTpl(h,i,!0);else if("function"==typeof h){var c=AM(function(e,n){e===this._ticket&&(l.setContent(n),this._updatePosition(t,r,a,o,l,i,s))},this);this._ticket=n,u=h(i,n,c)}l.setContent(u),l.show(t),this._updatePosition(t,r,a,o,l,i,s)}},_updatePosition:function(t,e,i,n,a,o,r){var s=this._api.getWidth(),l=this._api.getHeight();e=e||t.get("position");var h=a.getSize(),u=t.get("align"),c=t.get("verticalAlign"),d=r&&r.getBoundingRect().clone();if(r&&d.applyTransform(r.transform),"function"==typeof e&&(e=e([i,n],o,a.el,d,{viewSize:[s,l],contentSize:h.slice()})),rl.isArray(e))i=LM(e[0],s),n=LM(e[1],l);else if(rl.isObject(e)){e.width=h[0],e.height=h[1];var p=Np.getLayoutRect(e,{width:s,height:l});i=p.x,n=p.y,u=null,c=null}else if("string"==typeof e&&r){f=function(t,e,i){var n=i[0],a=i[1],o=0,r=0,s=e.width,l=e.height;switch(t){case"inside":o=e.x+s/2-n/2,r=e.y+l/2-a/2;break;case"top":o=e.x+s/2-n/2,r=e.y-a-5;break;case"bottom":o=e.x+s/2-n/2,r=e.y+l+5;break;case"left":o=e.x-n-5,r=e.y+l/2-a/2;break;case"right":o=e.x+s+5,r=e.y+l/2-a/2}return[o,r]}(e,d,h);i=f[0],n=f[1]}else{f=function(t,e,i,n,a,o,r){var s=rr(i),l=s.width,h=s.height;return null!=o&&(t+l+o>n?t-=l+o:t+=o),null!=r&&(e+h+r>a?e-=h+r:e+=r),[t,e]}(i,n,a.el,s,l,u?null:20,c?null:20);i=f[0],n=f[1]}if(u&&(i-=sr(u)?h[0]/2:"right"===u?h[0]:0),c&&(n-=sr(c)?h[1]/2:"bottom"===c?h[1]:0),t.get("confine")){var f=function(t,e,i,n,a){var o=rr(i),r=o.width,s=o.height;return t=Math.min(t+r,n)-r,e=Math.min(e+s,a)-s,t=Math.max(t,0),e=Math.max(e,0),[t,e]}(i,n,a.el,s,l);i=f[0],n=f[1]}a.moveTo(i,n)},_updateContentNotChangedOnAxis:function(t){var e=this._lastDataByCoordSys,i=!!e&&e.length===t.length;return i&&CM(e,function(e,n){var a=e.dataByAxis||{},o=(t[n]||{}).dataByAxis||[];(i&=a.length===o.length)&&CM(a,function(t,e){var n=o[e]||{},a=t.seriesDataIndices||[],r=n.seriesDataIndices||[];(i&=t.value===n.value&&t.axisType===n.axisType&&t.axisId===n.axisId&&a.length===r.length)&&CM(a,function(t,e){var n=r[e];i&=t.seriesIndex===n.seriesIndex&&t.dataIndex===n.dataIndex})})}),this._lastDataByCoordSys=t,!!i},_hide:function(t){this._lastDataByCoordSys=null,t({type:"hideTip",from:this.uid})},dispose:function(t,e){Us.node||(this._tooltipContent.hide(),CS.unregister("itemTooltip",e))}});ym.registerAction({type:"showTip",event:"showTip",update:"tooltip:manuallyShowTip"},function(){}),ym.registerAction({type:"hideTip",event:"hideTip",update:"tooltip:manuallyHideTip"},function(){});var PM=Pu.parsePercent,kM=function(t,e,i){var n=i.getWidth(),a=i.getHeight(),o={},r={},s=function(t,e){var i={};rl.each(t,function(t,e){var n=t.getData(),a=t.coordinateSystem.getBaseAxis(),o=a.getExtent(),r="category"===a.type?a.getBandWidth():Math.abs(o[1]-o[0])/n.count(),s=i[hr(a)]||{bandWidth:r,remainedWidth:r,autoWidthCount:0,categoryGap:"20%",gap:"30%",stacks:{}},l=s.stacks;i[hr(a)]=s;var h=lr(t);l[h]||s.autoWidthCount++,l[h]=l[h]||{width:0,maxWidth:0};var u=PM(t.get("barWidth"),r),c=PM(t.get("barMaxWidth"),r),d=t.get("barGap"),p=t.get("barCategoryGap");u&&!l[h].width&&(u=Math.min(s.remainedWidth,u),l[h].width=u,s.remainedWidth-=u),c&&(l[h].maxWidth=c),null!=d&&(s.gap=d),null!=p&&(s.categoryGap=p)});var n={};return rl.each(i,function(t,e){n[e]={};var i=t.stacks,a=t.bandWidth,o=PM(t.categoryGap,a),r=PM(t.gap,1),s=t.remainedWidth,l=t.autoWidthCount,h=(s-o)/(l+(l-1)*r);h=Math.max(h,0),rl.each(i,function(t,e){var i=t.maxWidth;i&&i<h&&(i=Math.min(i,s),t.width&&(i=Math.min(i,t.width)),s-=i,t.width=i,l--)}),h=(s-o)/(l+(l-1)*r),h=Math.max(h,0);var u,c=0;rl.each(i,function(t,e){t.width||(t.width=h),u=t,c+=t.width*(1+r)}),u&&(c-=u.width*r);var d=-c/2;rl.each(i,function(t,i){n[e][i]=n[e][i]||{offset:d,width:t.width},d+=t.width*(1+r)})}),n}(rl.filter(e.getSeriesByType(t),function(t){return!e.isSeriesFiltered(t)&&t.coordinateSystem&&"polar"===t.coordinateSystem.type}));e.eachSeriesByType(t,function(t){if("polar"===t.coordinateSystem.type){var e=t.getData(),i=t.coordinateSystem,l=i.getAngleAxis(),h=i.getBaseAxis(),u=lr(t),c=s[hr(h)][u],d=c.offset,p=c.width,f=i.getOtherAxis(h),g=t.get("center")||["50%","50%"],m=PM(g[0],n),v=PM(g[1],a),y=t.get("barMinHeight")||0,x=t.get("barMinAngle")||0,_=f.getExtent()[0],b=f.model.get("max"),w=f.model.get("min"),S=[t.coordDimToDataDim("radius")[0],t.coordDimToDataDim("angle")[0]],M=e.mapArray(S,function(t,e){return i.dataToPoint([t,e])},!0);o[u]=o[u]||[],r[u]=r[u]||[],e.each(t.coordDimToDataDim(f.dim)[0],function(t,n){if(!isNaN(t)){o[u][n]||(o[u][n]={p:_,n:_},r[u][n]={p:_,n:_});var a,s,h,c,g=t>=0?"p":"n",S=i.pointToCoord(M[n]),I=r[u][n][g];if("radius"===f.dim)a=I,s=S[0],c=(h=(-S[1]+d)*Math.PI/180)+p*Math.PI/180,Math.abs(s)<y&&(s=a+(s<0?-1:1)*y),r[u][n][g]=s;else{s=(a=S[0]+d)+p,null!=b&&(t=Math.min(t,b)),null!=w&&(t=Math.max(t,w));var T=l.dataToAngle(t);Math.abs(T-I)<x&&(T=I-(t<0?-1:1)*x),h=-I*Math.PI/180,c=-T*Math.PI/180;var A=l.getExtent(),C=T;C===A[0]&&t>0?C=A[1]:C===A[1]&&t<0&&(C=A[0]),r[u][n][g]=C}e.setItemLayout(n,{cx:m,cy:v,r0:a,r:s,startAngle:h,endAngle:c})}},!0)}},this)};ur.prototype={constructor:ur,pointToData:function(t,e){return this.polar.pointToData(t,e)["radius"===this.dim?0:1]},dataToRadius:Kg.prototype.dataToCoord,radiusToData:Kg.prototype.coordToData},rl.inherits(ur,Kg);var OM=ur;cr.prototype={constructor:cr,pointToData:function(t,e){return this.polar.pointToData(t,e)["radius"===this.dim?0:1]},dataToAngle:Kg.prototype.dataToCoord,angleToData:Kg.prototype.coordToData},rl.inherits(cr,Kg);var zM=cr,EM=function(t){this.name=t||"",this.cx=0,this.cy=0,this._radiusAxis=new OM,this._angleAxis=new zM,this._radiusAxis.polar=this._angleAxis.polar=this};EM.prototype={type:"polar",axisPointerEnabled:!0,constructor:EM,dimensions:["radius","angle"],model:null,containPoint:function(t){var e=this.pointToCoord(t);return this._radiusAxis.contain(e[0])&&this._angleAxis.contain(e[1])},containData:function(t){return this._radiusAxis.containData(t[0])&&this._angleAxis.containData(t[1])},getAxis:function(t){return this["_"+t+"Axis"]},getAxes:function(){return[this._radiusAxis,this._angleAxis]},getAxesByScale:function(t){var e=[],i=this._angleAxis,n=this._radiusAxis;return i.scale.type===t&&e.push(i),n.scale.type===t&&e.push(n),e},getAngleAxis:function(){return this._angleAxis},getRadiusAxis:function(){return this._radiusAxis},getOtherAxis:function(t){var e=this._angleAxis;return t===e?this._radiusAxis:e},getBaseAxis:function(){return this.getAxesByScale("ordinal")[0]||this.getAxesByScale("time")[0]||this.getAngleAxis()},getTooltipAxes:function(t){var e=null!=t&&"auto"!==t?this.getAxis(t):this.getBaseAxis();return{baseAxes:[e],otherAxes:[this.getOtherAxis(e)]}},dataToPoint:function(t,e){return this.coordToPoint([this._radiusAxis.dataToRadius(t[0],e),this._angleAxis.dataToAngle(t[1],e)])},pointToData:function(t,e){var i=this.pointToCoord(t);return[this._radiusAxis.radiusToData(i[0],e),this._angleAxis.angleToData(i[1],e)]},pointToCoord:function(t){var e=t[0]-this.cx,i=t[1]-this.cy,n=this.getAngleAxis(),a=n.getExtent(),o=Math.min(a[0],a[1]),r=Math.max(a[0],a[1]);n.inverse?o=r-360:r=o+360;var s=Math.sqrt(e*e+i*i);e/=s,i/=s;for(var l=Math.atan2(-i,e)/Math.PI*180,h=l<o?1:-1;l<o||l>r;)l+=360*h;return[s,l]},coordToPoint:function(t){var e=t[0],i=t[1]/180*Math.PI;return[Math.cos(i)*e+this.cx,-Math.sin(i)*e+this.cy]}};var RM=EM,NM=Hp.extend({type:"polarAxis",axis:null,getCoordSysModel:function(){return this.ecModel.queryComponents({mainType:"polar",index:this.option.polarIndex,id:this.option.polarId})[0]}});rl.merge(NM.prototype,Ng);var VM={angle:{startAngle:90,clockwise:!0,splitNumber:12,axisLabel:{rotate:!1}},radius:{splitNumber:5}};ov("angle",NM,dr,VM.angle),ov("radius",NM,dr,VM.radius);ym.extendComponentModel({type:"polar",dependencies:["polarAxis","angleAxis"],coordinateSystem:null,findAxisModel:function(t){var e;return this.ecModel.eachComponent(t,function(t){t.getCoordSysModel()===this&&(e=t)},this),e},defaultOption:{zlevel:0,z:0,center:["50%","50%"],radius:"80%"}});var BM=Pu.parsePercent,GM=Rg.createScaleByModel,HM=Rg.niceScaleExtent,WM={dimensions:RM.prototype.dimensions,create:function(t,e){var i=[];return t.eachComponent("polar",function(t,n){var a=new RM(n);a.update=function(t,e){var i=this,n=i.getAngleAxis(),a=i.getRadiusAxis();if(n.scale.setExtent(1/0,-1/0),a.scale.setExtent(1/0,-1/0),t.eachSeries(function(t){if(t.coordinateSystem===i){var e=t.getData();a.scale.unionExtentFromData(e,"radius"),n.scale.unionExtentFromData(e,"angle")}}),HM(n.scale,n.model),HM(a.scale,a.model),"category"===n.type&&!n.onBand){var o=n.getExtent(),r=360/n.scale.count();n.inverse?o[1]+=r:o[1]-=r,n.setExtent(o[0],o[1])}};var o=a.getRadiusAxis(),r=a.getAngleAxis(),s=t.findAxisModel("radiusAxis"),l=t.findAxisModel("angleAxis");pr(o,s),pr(r,l),function(t,e,i){var n=e.get("center"),a=i.getWidth(),o=i.getHeight();t.cx=BM(n[0],a),t.cy=BM(n[1],o);var r=t.getRadiusAxis(),s=Math.min(a,o)/2,l=BM(e.get("radius"),s);r.inverse?r.setExtent(l,0):r.setExtent(0,l)}(a,t,e),i.push(a),t.coordinateSystem=a,a.model=t}),t.eachSeries(function(e){if("polar"===e.get("coordinateSystem")){var i=t.queryComponents({mainType:"polar",index:e.get("polarIndex"),id:e.get("polarId")})[0];e.coordinateSystem=i.coordinateSystem}}),i}};rf.register("polar",WM);var FM=["axisLine","axisLabel","axisTick","splitLine","splitArea"],ZM=(zv.extend({type:"angleAxis",axisPointerClass:"PolarAxisPointer",render:function(t,e){if(this.group.removeAll(),t.get("show")){var i=t.axis,n=i.polar,a=n.getRadiusAxis().getExtent(),o=i.getTicksCoords();"category"!==i.type&&o.pop(),rl.each(FM,function(e){!t.get(e+".show")||i.scale.isBlank()&&"axisLine"!==e||this["_"+e](t,n,o,a)},this)}},_axisLine:function(t,e,i,n){var a=t.getModel("axisLine.lineStyle"),o=new fp.Circle({shape:{cx:e.cx,cy:e.cy,r:n[gr(e)]},style:a.getLineStyle(),z2:1,silent:!0});o.style.fill=null,this.group.add(o)},_axisTick:function(t,e,i,n){var a=t.getModel("axisTick"),o=(a.get("inside")?-1:1)*a.get("length"),r=n[gr(e)],s=rl.map(i,function(t){return new fp.Line({shape:fr(e,[r,r+o],t)})});this.group.add(fp.mergePath(s,{style:rl.defaults(a.getModel("lineStyle").getLineStyle(),{stroke:t.get("axisLine.lineStyle.color")})}))},_axisLabel:function(t,e,i,n){for(var a=t.axis,o=t.get("data"),r=t.getModel("axisLabel"),s=t.getFormattedLabels(),l=r.get("margin"),h=a.getLabelsCoords(),u=0;u<i.length;u++){var c=n[gr(e)],d=e.coordToPoint([c+l,h[u]]),p=e.cx,f=e.cy,g=Math.abs(d[0]-p)/c<.3?"center":d[0]>p?"left":"right",m=Math.abs(d[1]-f)/c<.3?"middle":d[1]>f?"top":"bottom";o&&o[u]&&o[u].textStyle&&(r=new _p(o[u].textStyle,r,r.ecModel));var v=new fp.Text({silent:!0});this.group.add(v),fp.setTextStyle(v.style,r,{x:d[0],y:d[1],textFill:r.getTextColor()||t.get("axisLine.lineStyle.color"),text:s[u],textAlign:g,textVerticalAlign:m})}},_splitLine:function(t,e,i,n){var a=t.getModel("splitLine").getModel("lineStyle"),o=a.get("color"),r=0;o=o instanceof Array?o:[o];for(var s=[],l=0;l<i.length;l++){var h=r++%o.length;s[h]=s[h]||[],s[h].push(new fp.Line({shape:fr(e,n,i[l])}))}for(l=0;l<s.length;l++)this.group.add(fp.mergePath(s[l],{style:rl.defaults({stroke:o[l%o.length]},a.getLineStyle()),silent:!0,z:t.get("z")}))},_splitArea:function(t,e,i,n){var a=t.getModel("splitArea").getModel("areaStyle"),o=a.get("color"),r=0;o=o instanceof Array?o:[o];for(var s=[],l=Math.PI/180,h=-i[0]*l,u=Math.min(n[0],n[1]),c=Math.max(n[0],n[1]),d=t.get("clockwise"),p=1;p<i.length;p++){var f=r++%o.length;s[f]=s[f]||[],s[f].push(new fp.Sector({shape:{cx:e.cx,cy:e.cy,r0:u,r:c,startAngle:h,endAngle:-i[p]*l,clockwise:d},silent:!0})),h=-i[p]*l}for(p=0;p<s.length;p++)this.group.add(fp.mergePath(s[p],{style:rl.defaults({fill:o[p%o.length]},a.getAreaStyle()),silent:!0}))}}),["axisLine","axisTickLabel","axisName"]),jM=["splitLine","splitArea"],UM=(zv.extend({type:"radiusAxis",axisPointerClass:"PolarAxisPointer",render:function(t,e){if(this.group.removeAll(),t.get("show")){var i=t.axis,n=i.polar,a=n.getAngleAxis(),o=i.getTicksCoords(),r=a.getExtent()[0],s=i.getExtent(),l=function(t,e,i){return{position:[t.cx,t.cy],rotation:i/180*Math.PI,labelDirection:-1,tickDirection:-1,nameDirection:1,labelRotate:e.getModel("axisLabel").get("rotate"),z2:1}}(n,t,r),h=new Cv(t,l);rl.each(ZM,h.add,h),this.group.add(h.getGroup()),rl.each(jM,function(e){t.get(e+".show")&&!i.scale.isBlank()&&this["_"+e](t,n,r,s,o)},this)}},_splitLine:function(t,e,i,n,a){var o=t.getModel("splitLine").getModel("lineStyle"),r=o.get("color"),s=0;r=r instanceof Array?r:[r];for(var l=[],h=0;h<a.length;h++){var u=s++%r.length;l[u]=l[u]||[],l[u].push(new fp.Circle({shape:{cx:e.cx,cy:e.cy,r:a[h]},silent:!0}))}for(h=0;h<l.length;h++)this.group.add(fp.mergePath(l[h],{style:rl.defaults({stroke:r[h%r.length],fill:null},o.getLineStyle()),silent:!0}))},_splitArea:function(t,e,i,n,a){var o=t.getModel("splitArea").getModel("areaStyle"),r=o.get("color"),s=0;r=r instanceof Array?r:[r];for(var l=[],h=a[0],u=1;u<a.length;u++){var c=s++%r.length;l[c]=l[c]||[],l[c].push(new fp.Sector({shape:{cx:e.cx,cy:e.cy,r0:h,r:a[u],startAngle:0,endAngle:2*Math.PI},silent:!0})),h=a[u]}for(u=0;u<l.length;u++)this.group.add(fp.mergePath(l[u],{style:rl.defaults({fill:r[u%r.length]},o.getAreaStyle()),silent:!0}))}}),OS.extend({makeElOption:function(t,e,i,n,a){var o=i.axis;"angle"===o.dim&&(this.animationThreshold=Math.PI/18);var r,s=o.polar,l=s.getOtherAxis(o).getExtent();r=o["dataTo"+Eu.capitalFirst(o.dim)](e);var h=n.get("type");if(h&&"none"!==h){var u=zS.buildElStyle(n),c=qM[h](o,s,r,l,u);c.style=u,t.graphicKey=c.type,t.pointer=c}var d=function(t,e,i,n,a){var o=e.axis,r=o.dataToCoord(t),s=n.getAngleAxis().getExtent()[0];s=s/180*Math.PI;var l,h,u,c=n.getRadiusAxis().getExtent();if("radius"===o.dim){var d=yl.create();yl.rotate(d,d,s),yl.translate(d,d,[n.cx,n.cy]),l=fp.applyTransform([r,-a],d);var p=e.getModel("axisLabel").get("rotate")||0,f=Cv.innerTextLayout(s,p*Math.PI/180,-1);h=f.textAlign,u=f.textVerticalAlign}else{var g=c[1];l=n.coordToPoint([g+a,r]);var m=n.cx,v=n.cy;h=Math.abs(l[0]-m)/g<.3?"center":l[0]>m?"left":"right",u=Math.abs(l[1]-v)/g<.3?"middle":l[1]>v?"top":"bottom"}return{position:l,align:h,verticalAlign:u}}(e,i,0,s,n.get("label.margin"));zS.buildLabelElOption(t,i,n,a,d)}})),qM={line:function(t,e,i,n,a){return"angle"===t.dim?{type:"Line",shape:zS.makeLineShape(e.coordToPoint([n[0],i]),e.coordToPoint([n[1],i]))}:{type:"Circle",shape:{cx:e.cx,cy:e.cy,r:i}}},shadow:function(t,e,i,n,a){var o=t.getBandWidth(),r=Math.PI/180;return"angle"===t.dim?{type:"Sector",shape:zS.makeSectorShape(e.cx,e.cy,n[0],n[1],(-i-o/2)*r,(o/2-i)*r)}:{type:"Sector",shape:zS.makeSectorShape(e.cx,e.cy,i-o/2,i+o/2,0,2*Math.PI)}}};zv.registerAxisPointerClass("PolarAxisPointer",UM);ym.registerLayout(rl.curry(kM,"bar")),ym.extendComponentView({type:"polar"});var XM=Hp.extend({type:"geo",coordinateSystem:null,layoutMode:"box",init:function(t){Hp.prototype.init.apply(this,arguments),Ip.defaultEmphasis(t.label,["show"])},optionUpdated:function(){var t=this.option,e=this;t.regions=Ry.getFilledRegions(t.regions,t.map,t.nameMap),this._optionModelMap=rl.reduce(t.regions||[],function(t,i){return i.name&&t.set(i.name,new _p(i,e)),t},rl.createHashMap()),this.updateSelectedMap(t.regions)},defaultOption:{zlevel:0,z:0,show:!0,left:"center",top:"center",aspectScale:.75,silent:!1,map:"",boundingCoords:null,center:null,zoom:1,scaleLimit:null,label:{normal:{show:!1,color:"#000"},emphasis:{show:!0,color:"rgb(100,0,0)"}},itemStyle:{normal:{borderWidth:.5,borderColor:"#444",color:"#eee"},emphasis:{color:"rgba(255,215,0,0.8)"}},regions:[]},getRegionModel:function(t){return this._optionModelMap.get(t)||new _p(null,this,this.ecModel)},getFormattedLabel:function(t,e){var i=this.getRegionModel(t).get("label."+e+".formatter"),n={name:t};return"function"==typeof i?(n.status=e,i(n)):"string"==typeof i?i.replace("{a}",null!=t?t:""):void 0},setZoom:function(t){this.option.zoom=t},setCenter:function(t){this.option.center=t}});rl.mixin(XM,Jv);ym.extendComponentView({type:"geo",init:function(t,e){var i=new qy(e,!0);this._mapDraw=i,this.group.add(i.group)},render:function(t,e,i,n){if(!n||"geoToggleSelect"!==n.type||n.from!==this.uid){var a=this._mapDraw;t.get("show")?a.draw(t,e,i,this,n):this._mapDraw.group.removeAll(),this.group.silent=t.get("silent")}},dispose:function(){this._mapDraw&&this._mapDraw.remove()}});mr("toggleSelected",{type:"geoToggleSelect",event:"geoselectchanged"}),mr("select",{type:"geoSelect",event:"geoselected"}),mr("unSelect",{type:"geoUnSelect",event:"geounselected"});var YM=["rect","polygon","keep","clear"],$M=function(t,e){var i=t&&t.brush;if(rl.isArray(i)||(i=i?[i]:[]),i.length){var n=[];rl.each(i,function(t){var e=t.hasOwnProperty("toolbox")?t.toolbox:[];e instanceof Array&&(n=n.concat(e))});var a=t&&t.toolbox;rl.isArray(a)&&(a=a[0]),a||(a={feature:{}},t.toolbox=[a]);var o=a.feature||(a.feature={}),r=o.brush||(o.brush={}),s=r.type||(r.type=[]);s.push.apply(s,n),function(t){var e={};rl.each(t,function(t){e[t]=1}),t.length=0,rl.each(e,function(e,i){t.push(i)})}(s),e&&!s.length&&s.push.apply(s,YM)}},KM=rl.each,JM={createVisualMappings:function(t,e,i){var n={};return KM(e,function(e){var a=n[e]=function(){var t=function(){};return t.prototype.__hidden=t.prototype,new t}();KM(t[e],function(t,n){if(Kx.isValidType(n)){var o={type:n,visual:t};i&&i(o,e),a[n]=new Kx(o),"opacity"===n&&((o=rl.clone(o)).type="colorAlpha",a.__hidden.__alphaForOpacity=new Kx(o))}})}),n},replaceVisualOption:function(t,e,i){var n;rl.each(i,function(t){e.hasOwnProperty(t)&&vr(e[t])&&(n=!0)}),n&&rl.each(i,function(i){e.hasOwnProperty(i)&&vr(e[i])?t[i]=rl.clone(e[i]):delete t[i]})},applyVisual:function(t,e,i,n,a,o){function r(t,r){l=null==o?t:r;var h=i.getRawDataItem(l);if(!h||!1!==h.visualMap)for(var u=n.call(a,t),c=e[u],d=s[u],p=0,f=d.length;p<f;p++){var g=d[p];c[g]&&c[g].applyVisual(t,function(t){return i.getItemVisual(l,t)},function(t,e){i.setItemVisual(l,t,e)})}}var s={};rl.each(t,function(t){var i=Kx.prepareVisualTypes(e[t]);s[t]=i});var l;null==o?i.each(r,!0):i.each([o],r,!0)}},QM={lineX:yr(0),lineY:yr(1),rect:{point:function(t,e,i){return t&&i.boundingRect.contain(t[0],t[1])},rect:function(t,e,i){return t&&i.boundingRect.intersect(t)}},polygon:{point:function(t,e,i){return t&&i.boundingRect.contain(t[0],t[1])&&Qg.contain(i.range,t[0],t[1])},rect:function(t,e,i){var n=i.range;if(!t||n.length<=1)return!1;var a=t.x,o=t.y,r=t.width,s=t.height,l=n[0];return!!(Qg.contain(n,a,o)||Qg.contain(n,a+r,o)||Qg.contain(n,a,o+s)||Qg.contain(n,a+r,o+s)||oh.create(t).contain(l[0],l[1])||_r(a,o,a+r,o,n)||_r(a,o,a,o+s,n)||_r(a+r,o,a+r,o+s,n)||_r(a,o+s,a+r,o+s,n))||void 0}}},tI=rl.each,eI=rl.indexOf,iI=rl.curry,nI=["dataToPoint","pointToData"],aI=["grid","xAxis","yAxis","geo","graph","polar","radiusAxis","angleAxis","bmap"],oI=wr.prototype;oI.setOutputRanges=function(t,e){this.matchOutputRanges(t,e,function(t,e,i){if((t.coordRanges||(t.coordRanges=[])).push(e),!t.coordRange){t.coordRange=e;var n=hI[t.brushType](0,i,e);t.__rangeOffset={offset:uI[t.brushType](n.values,t.range,[1,1]),xyMinMax:n.xyMinMax}}})},oI.matchOutputRanges=function(t,e,i){tI(t,function(t){var n=this.findTargetInfo(t,e);n&&!0!==n&&rl.each(n.coordSyses,function(n){var a=hI[t.brushType](1,n,t.range);i(t,a.values,n,e)})},this)},oI.setInputRanges=function(t,e){tI(t,function(t){var i=this.findTargetInfo(t,e);if(t.range=t.range||[],i&&!0!==i){t.panelId=i.panelId;var n=hI[t.brushType](0,i.coordSys,t.coordRange),a=t.__rangeOffset;t.range=a?uI[t.brushType](n.values,a.offset,function(t,e){var i=Ar(t),n=Ar(e),a=[i[0]/n[0],i[1]/n[1]];return isNaN(a[0])&&(a[0]=1),isNaN(a[1])&&(a[1]=1),a}(n.xyMinMax,a.xyMinMax)):n.values}},this)},oI.makePanelOpts=function(t,e){return rl.map(this._targetInfoList,function(i){var n=i.getPanelRect();return{panelId:i.panelId,defaultBrushType:e&&e(i),clipPath:qb.makeRectPanelClipPath(n),isTargetByCursor:qb.makeRectIsTargetByCursor(n,t,i.coordSysModel),getLinearBrushOtherExtent:qb.makeLinearBrushOtherExtent(n)}})},oI.controlSeries=function(t,e,i){var n=this.findTargetInfo(t,i);return!0===n||n&&eI(n.coordSyses,e.coordinateSystem)>=0},oI.findTargetInfo=function(t,e){for(var i=this._targetInfoList,n=Mr(e,t),a=0;a<i.length;a++){var o=i[a],r=t.panelId;if(r){if(o.panelId===r)return o}else for(a=0;a<sI.length;a++)if(sI[a](n,o))return o}return!0};var rI={grid:function(t,e){var i=t.xAxisModels,n=t.yAxisModels,a=t.gridModels,o=rl.createHashMap(),r={},s={};(i||n||a)&&(tI(i,function(t){var e=t.axis.grid.model;o.set(e.id,e),r[e.id]=!0}),tI(n,function(t){var e=t.axis.grid.model;o.set(e.id,e),s[e.id]=!0}),tI(a,function(t){o.set(t.id,t),r[t.id]=!0,s[t.id]=!0}),o.each(function(t){var a=t.coordinateSystem,o=[];tI(a.getCartesians(),function(t,e){(eI(i,t.getAxis("x").model)>=0||eI(n,t.getAxis("y").model)>=0)&&o.push(t)}),e.push({panelId:"grid--"+t.id,gridModel:t,coordSysModel:t,coordSys:o[0],coordSyses:o,getPanelRect:lI.grid,xAxisDeclared:r[t.id],yAxisDeclared:s[t.id]})}))},geo:function(t,e){tI(t.geoModels,function(t){var i=t.coordinateSystem;e.push({panelId:"geo--"+t.id,geoModel:t,coordSysModel:t,coordSys:i,coordSyses:[i],getPanelRect:lI.geo})})}},sI=[function(t,e){var i=t.xAxisModel,n=t.yAxisModel,a=t.gridModel;return!a&&i&&(a=i.axis.grid.model),!a&&n&&(a=n.axis.grid.model),a&&a===e.gridModel},function(t,e){var i=t.geoModel;return i&&i===e.geoModel}],lI={grid:function(){return this.coordSys.grid.getRect().clone()},geo:function(){var t=this.coordSys,e=t.getBoundingRect().clone();return e.applyTransform(fp.getTransform(t)),e}},hI={lineX:iI(Ir,0),lineY:iI(Ir,1),rect:function(t,e,i){var n=e[nI[t]]([i[0][0],i[1][0]]),a=e[nI[t]]([i[0][1],i[1][1]]),o=[Sr([n[0],a[0]]),Sr([n[1],a[1]])];return{values:o,xyMinMax:o}},polygon:function(t,e,i){var n=[[1/0,-1/0],[1/0,-1/0]];return{values:rl.map(i,function(i){var a=e[nI[t]](i);return n[0][0]=Math.min(n[0][0],a[0]),n[1][0]=Math.min(n[1][0],a[1]),n[0][1]=Math.max(n[0][1],a[0]),n[1][1]=Math.max(n[1][1],a[1]),a}),xyMinMax:n}}},uI={lineX:iI(Tr,0),lineY:iI(Tr,1),rect:function(t,e,i){return[[t[0][0]-i[0]*e[0][0],t[0][1]-i[0]*e[0][1]],[t[1][0]-i[1]*e[1][0],t[1][1]-i[1]*e[1][1]]]},polygon:function(t,e,i){return rl.map(t,function(t,n){return[t[0]-i[0]*e[n][0],t[1]-i[1]*e[n][1]]})}},cI=wr,dI=["inBrush","outOfBrush"],pI="__ecBrushSelect",fI="__ecInBrushSelectEvent",gI=ym.PRIORITY.VISUAL.BRUSH;ym.registerLayout(gI,function(t,e,i){t.eachComponent({mainType:"brush"},function(e){i&&"takeGlobalCursor"===i.type&&e.setBrushOption("brush"===i.key?i.brushOption:{brushType:!1});(e.brushTargetManager=new cI(e.option,t)).setInputRanges(e.areas,t)})}),ym.registerVisual(gI,function(t,e,i){var n,a,o=[];t.eachComponent({mainType:"brush"},function(e,i){function r(t){return"all"===u||c[t]}function s(t){return!!t.length}var l={brushId:e.id,brushIndex:i,brushName:e.name,areas:rl.clone(e.areas),selected:[]};o.push(l);var h=e.option,u=h.brushLink,c=[],d=[],p=[],f=0;i||(n=h.throttleType,a=h.throttleDelay);var g=rl.map(e.areas,function(t){return function(t){var e=t.selectors={};return rl.each(QM[t.brushType],function(i,n){e[n]=function(n){return i(n,e,t)}}),t}(rl.defaults({boundingRect:mI[t.brushType](t)},t))}),m=JM.createVisualMappings(e.option,dI,function(t){t.mappingMethod="fixed"});rl.isArray(u)&&rl.each(u,function(t){c[t]=1}),t.eachSeries(function(i,n){var a=p[n]=[];"parallel"===i.subType?function(t,e){var i=t.coordinateSystem;f|=i.hasAxisBrushed(),r(e)&&i.eachActiveState(t.getData(),function(t,e){"active"===t&&(d[e]=1)})}(i,n):function(i,n,a){var o=Lr(i);if(o&&!function(t,e){var i=t.option.seriesIndex;return null!=i&&"all"!==i&&(rl.isArray(i)?rl.indexOf(i,e)<0:e!==i)}(e,n)&&(rl.each(g,function(n){o[n.brushType]&&e.brushTargetManager.controlSeries(n,i,t)&&a.push(n),f|=s(a)}),r(n)&&s(a))){var l=i.getData();l.each(function(t){Cr(o,a,l,t)&&(d[t]=1)})}}(i,n,a)}),t.eachSeries(function(t,e){var i={seriesId:t.id,seriesIndex:e,seriesName:t.name,dataIndex:[]};l.selected.push(i);var n=Lr(t),a=p[e],o=t.getData(),h=r(e)?function(t){return d[t]?(i.dataIndex.push(o.getRawIndex(t)),"inBrush"):"outOfBrush"}:function(t){return Cr(n,a,o,t)?(i.dataIndex.push(o.getRawIndex(t)),"inBrush"):"outOfBrush"};(r(e)?f:s(a))&&JM.applyVisual(dI,m,o,h)})}),function(t,e,i,n,a){if(a){var o=t.getZr();o[fI]||(o[pI]||(o[pI]=function(t,e){if(!t.isDisposed()){var i=t.getZr();i[fI]=!0,t.dispatchAction({type:"brushSelect",batch:e}),i[fI]=!1}}),Ff.createOrUpdate(o,pI,i,e)(t,n))}}(e,n,a,o,i)});var mI={lineX:rl.noop,lineY:rl.noop,rect:function(t){return Dr(t.range)},polygon:function(t){for(var e,i=t.range,n=0,a=i.length;n<a;n++){e=e||[[1/0,-1/0],[1/0,-1/0]];var o=i[n];o[0]<e[0][0]&&(e[0][0]=o[0]),o[0]>e[0][1]&&(e[0][1]=o[0]),o[1]<e[1][0]&&(e[1][0]=o[1]),o[1]>e[1][1]&&(e[1][1]=o[1])}return e&&Dr(e)}},vI=["#ddd"];ym.extendComponentModel({type:"brush",dependencies:["geo","grid","xAxis","yAxis","parallel","series"],defaultOption:{toolbox:null,brushLink:null,seriesIndex:"all",geoIndex:null,xAxisIndex:null,yAxisIndex:null,brushType:"rect",brushMode:"single",transformable:!0,brushStyle:{borderWidth:1,color:"rgba(120,140,180,0.3)",borderColor:"rgba(120,140,180,0.8)"},throttleType:"fixRate",throttleDelay:0,removeOnClick:!0,z:1e4},areas:[],brushType:null,brushOption:{},coordInfoList:[],optionUpdated:function(t,e){var i=this.option;!e&&JM.replaceVisualOption(i,t,["inBrush","outOfBrush"]),i.inBrush=i.inBrush||{},i.outOfBrush=i.outOfBrush||{color:vI}},setAreas:function(t){t&&(this.areas=rl.map(t,function(t){return Pr(this.option,t)},this))},setBrushOption:function(t){this.brushOption=Pr(this.option,t),this.brushType=this.brushOption.brushType}}),ym.extendComponentView({type:"brush",init:function(t,e){this.ecModel=t,this.api=e,this.model,(this._brushController=new jb(e.getZr())).on("brush",rl.bind(this._onBrush,this)).mount()},render:function(t){return this.model=t,kr.apply(this,arguments)},updateView:kr,updateLayout:kr,updateVisual:kr,dispose:function(){this._brushController.dispose()},_onBrush:function(t,e){var i=this.model.id;this.model.brushTargetManager.setOutputRanges(t,this.ecModel),(!e.isEnd||e.removeOnClick)&&this.api.dispatchAction({type:"brush",brushId:i,areas:rl.clone(t),$from:i})}});ym.registerAction({type:"brush",event:"brush",update:"updateView"},function(t,e){e.eachComponent({mainType:"brush",query:t},function(e){e.setAreas(t.areas)})}),ym.registerAction({type:"brushSelect",event:"brushSelected",update:"none"},function(){});var yI={},xI={register:function(t,e){yI[t]=e},get:function(t){return yI[t]}},_I={toolbox:{brush:{title:{rect:"矩形选择",polygon:"圈选",lineX:"横向选择",lineY:"纵向选择",keep:"保持选择",clear:"清除选择"}},dataView:{title:"数据视图",lang:["数据视图","关闭","刷新"]},dataZoom:{title:{zoom:"区域缩放",back:"区域缩放还原"}},magicType:{title:{line:"切换为折线图",bar:"切换为柱状图",stack:"切换为堆叠",tiled:"切换为平铺"}},restore:{title:"还原"},saveAsImage:{title:"保存为图片",lang:["右键另存为图片"]}}},bI=_I.toolbox.brush;Or.defaultOption={show:!0,type:["rect","polygon","lineX","lineY","keep","clear"],icon:{rect:"M7.3,34.7 M0.4,10V-0.2h9.8 M89.6,10V-0.2h-9.8 M0.4,60v10.2h9.8 M89.6,60v10.2h-9.8 M12.3,22.4V10.5h13.1 M33.6,10.5h7.8 M49.1,10.5h7.8 M77.5,22.4V10.5h-13 M12.3,31.1v8.2 M77.7,31.1v8.2 M12.3,47.6v11.9h13.1 M33.6,59.5h7.6 M49.1,59.5 h7.7 M77.5,47.6v11.9h-13",polygon:"M55.2,34.9c1.7,0,3.1,1.4,3.1,3.1s-1.4,3.1-3.1,3.1 s-3.1-1.4-3.1-3.1S53.5,34.9,55.2,34.9z M50.4,51c1.7,0,3.1,1.4,3.1,3.1c0,1.7-1.4,3.1-3.1,3.1c-1.7,0-3.1-1.4-3.1-3.1 C47.3,52.4,48.7,51,50.4,51z M55.6,37.1l1.5-7.8 M60.1,13.5l1.6-8.7l-7.8,4 M59,19l-1,5.3 M24,16.1l6.4,4.9l6.4-3.3 M48.5,11.6 l-5.9,3.1 M19.1,12.8L9.7,5.1l1.1,7.7 M13.4,29.8l1,7.3l6.6,1.6 M11.6,18.4l1,6.1 M32.8,41.9 M26.6,40.4 M27.3,40.2l6.1,1.6 M49.9,52.1l-5.6-7.6l-4.9-1.2",lineX:"M15.2,30 M19.7,15.6V1.9H29 M34.8,1.9H40.4 M55.3,15.6V1.9H45.9 M19.7,44.4V58.1H29 M34.8,58.1H40.4 M55.3,44.4 V58.1H45.9 M12.5,20.3l-9.4,9.6l9.6,9.8 M3.1,29.9h16.5 M62.5,20.3l9.4,9.6L62.3,39.7 M71.9,29.9H55.4",lineY:"M38.8,7.7 M52.7,12h13.2v9 M65.9,26.6V32 M52.7,46.3h13.2v-9 M24.9,12H11.8v9 M11.8,26.6V32 M24.9,46.3H11.8v-9 M48.2,5.1l-9.3-9l-9.4,9.2 M38.9-3.9V12 M48.2,53.3l-9.3,9l-9.4-9.2 M38.9,62.3V46.4",keep:"M4,10.5V1h10.3 M20.7,1h6.1 M33,1h6.1 M55.4,10.5V1H45.2 M4,17.3v6.6 M55.6,17.3v6.6 M4,30.5V40h10.3 M20.7,40 h6.1 M33,40h6.1 M55.4,30.5V40H45.2 M21,18.9h62.9v48.6H21V18.9z",clear:"M22,14.7l30.9,31 M52.9,14.7L22,45.7 M4.7,16.8V4.2h13.1 M26,4.2h7.8 M41.6,4.2h7.8 M70.3,16.8V4.2H57.2 M4.7,25.9v8.6 M70.3,25.9v8.6 M4.7,43.2v12.6h13.1 M26,55.8h7.8 M41.6,55.8h7.8 M70.3,43.2v12.6H57.2"},title:rl.clone(bI.title)};var wI=Or.prototype;wI.render=wI.updateView=wI.updateLayout=function(t,e,i){var n,a,o;e.eachComponent({mainType:"brush"},function(t){n=t.brushType,a=t.brushOption.brushMode||"single",o|=t.areas.length}),this._brushType=n,this._brushMode=a,rl.each(t.get("type",!0),function(e){t.setIconStatus(e,("keep"===e?"multiple"===a:"clear"===e?o:e===n)?"emphasis":"normal")})},wI.getIcons=function(){var t=this.model,e=t.get("icon",!0),i={};return rl.each(t.get("type",!0),function(t){e[t]&&(i[t]=e[t])}),i},wI.onclick=function(t,e,i){var n=this._brushType,a=this._brushMode;"clear"===i?(e.dispatchAction({type:"axisAreaSelect",intervals:[]}),e.dispatchAction({type:"brush",command:"clear",areas:[]})):e.dispatchAction({type:"takeGlobalCursor",key:"brush",brushOption:{brushType:"keep"===i?n:n!==i&&i,brushMode:"keep"===i?"multiple"===a?"single":"multiple":a}})},xI.register("brush",Or);ym.registerPreprocessor($M);zr.prototype={constructor:zr,type:"calendar",dimensions:["time","value"],getDimensionsInfo:function(){return[{name:"time",type:"time"}]},getRangeInfo:function(){return this._rangeInfo},getModel:function(){return this._model},getRect:function(){return this._rect},getCellWidth:function(){return this._sw},getCellHeight:function(){return this._sh},getOrient:function(){return this._orient},getFirstDayOfWeek:function(){return this._firstDayOfWeek},getDateInfo:function(t){var e=(t=Pu.parseDate(t)).getFullYear(),i=t.getMonth()+1;i=i<10?"0"+i:i;var n=t.getDate();n=n<10?"0"+n:n;var a=t.getDay();return a=Math.abs((a+7-this.getFirstDayOfWeek())%7),{y:e,m:i,d:n,day:a,time:t.getTime(),formatedDate:e+"-"+i+"-"+n,date:t}},getNextNDay:function(t,e){return 0===(e=e||0)?this.getDateInfo(t):((t=new Date(this.getDateInfo(t).time)).setDate(t.getDate()+e),this.getDateInfo(t))},update:function(t,e){function i(t,e){return null!=t[e]&&"auto"!==t[e]}this._firstDayOfWeek=+this._model.getModel("dayLabel").get("firstDay"),this._orient=this._model.get("orient"),this._lineWidth=this._model.getModel("itemStyle.normal").getItemStyle().lineWidth||0,this._rangeInfo=this._getRangeInfo(this._initRangeOption());var n=this._rangeInfo.weeks||1,a=["width","height"],o=this._model.get("cellSize").slice(),r=this._model.getBoxLayoutParams(),s="horizontal"===this._orient?[n,7]:[7,n];rl.each([0,1],function(t){i(o,t)&&(r[a[t]]=o[t]*s[t])});var l={width:e.getWidth(),height:e.getHeight()},h=this._rect=Np.getLayoutRect(r,l);rl.each([0,1],function(t){i(o,t)||(o[t]=h[a[t]]/s[t])}),this._sw=o[0],this._sh=o[1]},dataToPoint:function(t,e){rl.isArray(t)&&(t=t[0]),null==e&&(e=!0);var i=this.getDateInfo(t),n=this._rangeInfo,a=i.formatedDate;if(e&&!(i.time>=n.start.time&&i.time<=n.end.time))return[NaN,NaN];var o=i.day,r=this._getRangeInfo([n.start.time,a]).nthWeek;return"vertical"===this._orient?[this._rect.x+o*this._sw+this._sw/2,this._rect.y+r*this._sh+this._sh/2]:[this._rect.x+r*this._sw+this._sw/2,this._rect.y+o*this._sh+this._sh/2]},pointToData:function(t){var e=this.pointToDate(t);return e&&e.time},dataToRect:function(t,e){var i=this.dataToPoint(t,e);return{contentShape:{x:i[0]-(this._sw-this._lineWidth)/2,y:i[1]-(this._sh-this._lineWidth)/2,width:this._sw-this._lineWidth,height:this._sh-this._lineWidth},center:i,tl:[i[0]-this._sw/2,i[1]-this._sh/2],tr:[i[0]+this._sw/2,i[1]-this._sh/2],br:[i[0]+this._sw/2,i[1]+this._sh/2],bl:[i[0]-this._sw/2,i[1]+this._sh/2]}},pointToDate:function(t){var e=Math.floor((t[0]-this._rect.x)/this._sw)+1,i=Math.floor((t[1]-this._rect.y)/this._sh)+1,n=this._rangeInfo.range;return"vertical"===this._orient?this._getDateByWeeksAndDay(i,e-1,n):this._getDateByWeeksAndDay(e,i-1,n)},convertToPixel:rl.curry(Er,"dataToPoint"),convertFromPixel:rl.curry(Er,"pointToData"),_initRangeOption:function(){var t=this._model.get("range"),e=t;if(rl.isArray(e)&&1===e.length&&(e=e[0]),/^\d{4}$/.test(e)&&(t=[e+"-01-01",e+"-12-31"]),/^\d{4}[\/|-]\d{1,2}$/.test(e)){var i=this.getDateInfo(e),n=i.date;n.setMonth(n.getMonth()+1);var a=this.getNextNDay(n,-1);t=[i.formatedDate,a.formatedDate]}/^\d{4}[\/|-]\d{1,2}[\/|-]\d{1,2}$/.test(e)&&(t=[e,e]);var o=this._getRangeInfo(t);return o.start.time>o.end.time&&t.reverse(),t},_getRangeInfo:function(t){var e;(t=[this.getDateInfo(t[0]),this.getDateInfo(t[1])])[0].time>t[1].time&&(e=!0,t.reverse());var i=Math.floor(t[1].time/864e5)-Math.floor(t[0].time/864e5)+1,n=new Date(t[0].time),a=n.getDate(),o=t[1].date.getDate();if(n.setDate(a+i-1),n.getDate()!==o)for(var r=n.getTime()-t[1].time>0?1:-1;n.getDate()!==o&&(n.getTime()-t[1].time)*r>0;)i-=r,n.setDate(a+i-1);var s=Math.floor((i+t[0].day+6)/7),l=e?1-s:s-1;return e&&t.reverse(),{range:[t[0].formatedDate,t[1].formatedDate],start:t[0],end:t[1],allDay:i,weeks:s,nthWeek:l,fweek:t[0].day,lweek:t[1].day}},_getDateByWeeksAndDay:function(t,e,i){var n=this._getRangeInfo(i);if(t>n.weeks||0===t&&e<n.fweek||t===n.weeks&&e>n.lweek)return!1;var a=7*(t-1)-n.fweek+e,o=new Date(n.start.time);return o.setDate(n.start.d+a),this.getDateInfo(o)}},zr.dimensions=zr.prototype.dimensions,zr.getDimensionsInfo=zr.prototype.getDimensionsInfo,zr.create=function(t,e){var i=[];return t.eachComponent("calendar",function(n){var a=new zr(n,t,e);i.push(a),n.coordinateSystem=a}),t.eachSeries(function(t){"calendar"===t.get("coordinateSystem")&&(t.coordinateSystem=i[t.get("calendarIndex")||0])}),i},rf.register("calendar",zr);var SI=Np.getLayoutParams,MI=Np.sizeCalculable,II=Np.mergeLayoutParam,TI=Hp.extend({type:"calendar",coordinateSystem:null,defaultOption:{zlevel:0,z:2,left:80,top:60,cellSize:20,orient:"horizontal",splitLine:{show:!0,lineStyle:{color:"#000",width:1,type:"solid"}},itemStyle:{normal:{color:"#fff",borderWidth:1,borderColor:"#ccc"}},dayLabel:{show:!0,firstDay:0,position:"start",margin:"50%",nameMap:"en",color:"#000"},monthLabel:{show:!0,position:"start",margin:5,align:"center",nameMap:"en",formatter:null,color:"#000"},yearLabel:{show:!0,position:null,margin:30,formatter:null,color:"#ccc",fontFamily:"sans-serif",fontWeight:"bolder",fontSize:20}},init:function(t,e,i,n){var a=SI(t);TI.superApply(this,"init",arguments),Rr(t,a)},mergeOption:function(t,e){TI.superApply(this,"mergeOption",arguments),Rr(this.option,t)}}),AI={EN:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],CN:["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月"]},CI={EN:["S","M","T","W","T","F","S"],CN:["日","一","二","三","四","五","六"]},LI=(ym.extendComponentView({type:"calendar",_tlpoints:null,_blpoints:null,_firstDayOfMonth:null,_firstDayPoints:null,render:function(t,e,i){var n=this.group;n.removeAll();var a=t.coordinateSystem,o=a.getRangeInfo(),r=a.getOrient();this._renderDayRect(t,o,n),this._renderLines(t,o,r,n),this._renderYearText(t,o,r,n),this._renderMonthText(t,r,n),this._renderWeekText(t,o,r,n)},_renderDayRect:function(t,e,i){for(var n=t.coordinateSystem,a=t.getModel("itemStyle.normal").getItemStyle(),o=n.getCellWidth(),r=n.getCellHeight(),s=e.start.time;s<=e.end.time;s=n.getNextNDay(s,1).time){var l=n.dataToRect([s],!1).tl,h=new fp.Rect({shape:{x:l[0],y:l[1],width:o,height:r},cursor:"default",style:a});i.add(h)}},_renderLines:function(t,e,i,n){function a(e){o._firstDayOfMonth.push(r.getDateInfo(e)),o._firstDayPoints.push(r.dataToRect([e],!1).tl);var a=o._getLinePointsOfOneWeek(t,e,i);o._tlpoints.push(a[0]),o._blpoints.push(a[a.length-1]),l&&o._drawSplitline(a,s,n)}var o=this,r=t.coordinateSystem,s=t.getModel("splitLine.lineStyle").getLineStyle(),l=t.get("splitLine.show"),h=s.lineWidth;this._tlpoints=[],this._blpoints=[],this._firstDayOfMonth=[],this._firstDayPoints=[];for(var u=e.start,c=0;u.time<=e.end.time;c++){a(u.formatedDate),0===c&&(u=r.getDateInfo(e.start.y+"-"+e.start.m));var d=u.date;d.setMonth(d.getMonth()+1),u=r.getDateInfo(d)}a(r.getNextNDay(e.end.time,1).formatedDate),l&&this._drawSplitline(o._getEdgesPoints(o._tlpoints,h,i),s,n),l&&this._drawSplitline(o._getEdgesPoints(o._blpoints,h,i),s,n)},_getEdgesPoints:function(t,e,i){var n=[t[0].slice(),t[t.length-1].slice()],a="horizontal"===i?0:1;return n[0][a]=n[0][a]-e/2,n[1][a]=n[1][a]+e/2,n},_drawSplitline:function(t,e,i){var n=new fp.Polyline({z2:20,shape:{points:t},style:e});i.add(n)},_getLinePointsOfOneWeek:function(t,e,i){var n=t.coordinateSystem;e=n.getDateInfo(e);for(var a=[],o=0;o<7;o++){var r=n.getNextNDay(e.time,o),s=n.dataToRect([r.time],!1);a[2*r.day]=s.tl,a[2*r.day+1]=s["horizontal"===i?"bl":"tr"]}return a},_formatterLabel:function(t,e){return"string"==typeof t&&t?Eu.formatTplSimple(t,e):"function"==typeof t?t(e):e.nameMap},_yearTextPositionControl:function(t,e,i,n,a){e=e.slice();var o=["center","bottom"];"bottom"===n?(e[1]+=a,o=["center","top"]):"left"===n?e[0]-=a:"right"===n?(e[0]+=a,o=["center","top"]):e[1]-=a;var r=0;return"left"!==n&&"right"!==n||(r=Math.PI/2),{rotation:r,position:e,style:{textAlign:o[0],textVerticalAlign:o[1]}}},_renderYearText:function(t,e,i,n){var a=t.getModel("yearLabel");if(a.get("show")){var o=a.get("margin"),r=a.get("position");r||(r="horizontal"!==i?"top":"left");var s=[this._tlpoints[this._tlpoints.length-1],this._blpoints[0]],l=(s[0][0]+s[1][0])/2,h=(s[0][1]+s[1][1])/2,u="horizontal"===i?0:1,c={top:[l,s[u][1]],bottom:[l,s[1-u][1]],left:[s[1-u][0],h],right:[s[u][0],h]},d=e.start.y;+e.end.y>+e.start.y&&(d=d+"-"+e.end.y);var p=a.get("formatter"),f={start:e.start.y,end:e.end.y,nameMap:d},g=this._formatterLabel(p,f),m=new fp.Text({z2:30});fp.setTextStyle(m.style,a,{text:g}),m.attr(this._yearTextPositionControl(m,c[r],i,r,o)),n.add(m)}},_monthTextPositionControl:function(t,e,i,n,a){var o="left",r="top",s=t[0],l=t[1];return"horizontal"===i?(l+=a,e&&(o="center"),"start"===n&&(r="bottom")):(s+=a,e&&(r="middle"),"start"===n&&(o="right")),{x:s,y:l,textAlign:o,textVerticalAlign:r}},_renderMonthText:function(t,e,i){var n=t.getModel("monthLabel");if(n.get("show")){var a=n.get("nameMap"),o=n.get("margin"),r=n.get("position"),s=n.get("align"),l=[this._tlpoints,this._blpoints];rl.isString(a)&&(a=AI[a.toUpperCase()]||[]);var h="start"===r?0:1,u="horizontal"===e?0:1;o="start"===r?-o:o;for(var c="center"===s,d=0;d<l[h].length-1;d++){var p=l[h][d].slice(),f=this._firstDayOfMonth[d];if(c){var g=this._firstDayPoints[d];p[u]=(g[u]+l[0][d+1][u])/2}var m=n.get("formatter"),v=a[+f.m-1],y={yyyy:f.y,yy:(f.y+"").slice(2),MM:f.m,M:+f.m,nameMap:v},x=this._formatterLabel(m,y),_=new fp.Text({z2:30});rl.extend(fp.setTextStyle(_.style,n,{text:x}),this._monthTextPositionControl(p,c,e,r,o)),i.add(_)}}},_weekTextPositionControl:function(t,e,i,n,a){var o="center",r="middle",s=t[0],l=t[1],h="start"===i;return"horizontal"===e?(s=s+n+(h?1:-1)*a[0]/2,o=h?"right":"left"):(l=l+n+(h?1:-1)*a[1]/2,r=h?"bottom":"top"),{x:s,y:l,textAlign:o,textVerticalAlign:r}},_renderWeekText:function(t,e,i,n){var a=t.getModel("dayLabel");if(a.get("show")){var o=t.coordinateSystem,r=a.get("position"),s=a.get("nameMap"),l=a.get("margin"),h=o.getFirstDayOfWeek();rl.isString(s)&&(s=CI[s.toUpperCase()]||[]);var u=o.getNextNDay(e.end.time,7-e.lweek).time,c=[o.getCellWidth(),o.getCellHeight()];l=Pu.parsePercent(l,c["horizontal"===i?0:1]),"start"===r&&(u=o.getNextNDay(e.start.time,-(7+e.fweek)).time,l=-l);for(var d=0;d<7;d++){var p=o.getNextNDay(u,d),f=o.dataToRect([p.time],!1).center,g=d;g=Math.abs((d+h)%7);var m=new fp.Text({z2:30});rl.extend(fp.setTextStyle(m.style,a,{text:s[g]}),this._weekTextPositionControl(f,i,r,l,c)),n.add(m)}}}}),Np.getLayoutRect);ym.extendComponentModel({type:"title",layoutMode:{type:"box",ignoreSize:!0},defaultOption:{zlevel:0,z:6,show:!0,text:"",target:"blank",subtext:"",subtarget:"blank",left:0,top:0,backgroundColor:"rgba(0,0,0,0)",borderColor:"#ccc",borderWidth:0,padding:5,itemGap:10,textStyle:{fontSize:18,fontWeight:"bolder",color:"#333"},subtextStyle:{color:"#aaa"}}}),ym.extendComponentView({type:"title",render:function(t,e,i){if(this.group.removeAll(),t.get("show")){var n=this.group,a=t.getModel("textStyle"),o=t.getModel("subtextStyle"),r=t.get("textAlign"),s=t.get("textBaseline"),l=new fp.Text({style:fp.setTextStyle({},a,{text:t.get("text"),textFill:a.getTextColor()},{disableBox:!0}),z2:10}),h=l.getBoundingRect(),u=t.get("subtext"),c=new fp.Text({style:fp.setTextStyle({},o,{text:u,textFill:o.getTextColor(),y:h.height+t.get("itemGap"),textVerticalAlign:"top"},{disableBox:!0}),z2:10}),d=t.get("link"),p=t.get("sublink");l.silent=!d,c.silent=!p,d&&l.on("click",function(){window.open(d,"_"+t.get("target"))}),p&&c.on("click",function(){window.open(p,"_"+t.get("subtarget"))}),n.add(l),u&&n.add(c);var f=n.getBoundingRect(),g=t.getBoxLayoutParams();g.width=f.width,g.height=f.height;var m=LI(g,{width:i.getWidth(),height:i.getHeight()},t.get("padding"));r||("middle"===(r=t.get("left")||t.get("right"))&&(r="center"),"right"===r?m.x+=m.width:"center"===r&&(m.x+=m.width/2)),s||("center"===(s=t.get("top")||t.get("bottom"))&&(s="middle"),"bottom"===s?m.y+=m.height:"middle"===s&&(m.y+=m.height/2),s=s||"top"),n.attr("position",[m.x,m.y]);var v={textAlign:r,textVerticalAlign:s};l.setStyle(v),c.setStyle(v),f=n.getBoundingRect();var y=m.margin,x=t.getItemStyle(["color","opacity"]);x.fill=t.get("backgroundColor");var _=new fp.Rect({shape:{x:f.x-y[3],y:f.y-y[0],width:f.width+y[1]+y[3],height:f.height+y[0]+y[2],r:t.get("borderRadius")},style:x,silent:!0});fp.subPixelOptimizeRect(_),n.add(_)}}}),Hp.registerSubTypeDefaulter("dataZoom",function(){return"slider"});var DI=["cartesian2d","polar","singleAxis"],PI={isCoordSupported:function(t){return rl.indexOf(DI,t)>=0},createNameEach:Nr,eachAxisDim:Nr(["x","y","z","radius","angle","single"],["axisIndex","axis","index","id"]),createLinkedNodesFinder:function(t,e,i){function n(t,n){n.nodes.push(t),e(function(e){rl.each(i(t,e)||[],function(t){n.records[e.name][t]=!0})})}return function(a){var o={nodes:[],records:{}};if(e(function(t){o.records[t.name]={}}),!a)return o;n(a,o);var r;do{r=!1,t(function(t){!function(t,e){return rl.indexOf(e.nodes,t)>=0}(t,o)&&function(t,n){var a=!1;return e(function(e){rl.each(i(t,e)||[],function(t){n.records[e.name][t]&&(a=!0)})}),a}(t,o)&&(n(t,o),r=!0)})}while(r);return o}}},kI=rl.each,OI=Pu.asc,zI=function(t,e,i,n){this._dimName=t,this._axisIndex=e,this._valueWindow,this._percentWindow,this._dataExtent,this._minMaxSpan,this.ecModel=n,this._dataZoomModel=i};zI.prototype={constructor:zI,hostedBy:function(t){return this._dataZoomModel===t},getDataValueWindow:function(){return this._valueWindow.slice()},getDataPercentWindow:function(){return this._percentWindow.slice()},getTargetSeriesModels:function(){var t=[],e=this.ecModel;return e.eachSeries(function(i){if(PI.isCoordSupported(i.get("coordinateSystem"))){var n=this._dimName,a=e.queryComponents({mainType:n+"Axis",index:i.get(n+"AxisIndex"),id:i.get(n+"AxisId")})[0];this._axisIndex===(a&&a.componentIndex)&&t.push(i)}},this),t},getAxisModel:function(){return this.ecModel.getComponent(this._dimName+"Axis",this._axisIndex)},getOtherAxisModel:function(){var t,e,i=this._dimName,n=this.ecModel,a=this.getAxisModel();"x"===i||"y"===i?(e="gridIndex",t="x"===i?"y":"x"):(e="polarIndex",t="angle"===i?"radius":"angle");var o;return n.eachComponent(t+"Axis",function(t){(t.get(e)||0)===(a.get(e)||0)&&(o=t)}),o},getMinMaxSpan:function(){return rl.clone(this._minMaxSpan)},calculateDataWindow:function(t){var e=this._dataExtent,i=this.getAxisModel().axis.scale,n=this._dataZoomModel.getRangePropMode(),a=[0,100],o=[t.start,t.end],r=[];return kI(["startValue","endValue"],function(e){r.push(null!=t[e]?i.parse(t[e]):null)}),kI([0,1],function(t){var s=r[t],l=o[t];"percent"===n[t]?(null==l&&(l=a[t]),s=i.parse(Pu.linearMap(l,a,e,!0))):l=Pu.linearMap(s,e,a,!0),r[t]=s,o[t]=l}),{valueWindow:OI(r),percentWindow:OI(o)}},reset:function(t){if(t===this._dataZoomModel){this._dataExtent=function(t,e,i){var n=[1/0,-1/0];return kI(i,function(t){var i=t.getData();i&&kI(t.coordDimToDataDim(e),function(t){var e=i.getDataExtent(t);e[0]<n[0]&&(n[0]=e[0]),e[1]>n[1]&&(n[1]=e[1])})}),n[1]<n[0]&&(n=[NaN,NaN]),function(t,e){var i=t.getAxisModel(),n=i.getMin(!0),a="category"===i.get("type"),o=a&&(i.get("data")||[]).length;null!=n&&"dataMin"!==n&&"function"!=typeof n?e[0]=n:a&&(e[0]=o>0?0:NaN);var r=i.getMax(!0);null!=r&&"dataMax"!==r&&"function"!=typeof r?e[1]=r:a&&(e[1]=o>0?o-1:NaN),i.get("scale",!0)||(e[0]>0&&(e[0]=0),e[1]<0&&(e[1]=0))}(t,n),n}(this,this._dimName,this.getTargetSeriesModels());var e=this.calculateDataWindow(t.option);this._valueWindow=e.valueWindow,this._percentWindow=e.percentWindow,function(t){var e=t._minMaxSpan={},i=t._dataZoomModel;kI(["min","max"],function(n){e[n+"Span"]=i.get(n+"Span");var a=i.get(n+"ValueSpan");if(null!=a&&(e[n+"ValueSpan"]=a,null!=(a=t.getAxisModel().axis.scale.parse(a)))){var o=t._dataExtent;e[n+"Span"]=Pu.linearMap(o[0]+a,o,[0,100],!0)}})}(this),Vr(this)}},restore:function(t){t===this._dataZoomModel&&(this._valueWindow=this._percentWindow=null,Vr(this,!0))},filterData:function(t){function e(t){return t>=o[0]&&t<=o[1]}if(t===this._dataZoomModel){var i=this._dimName,n=this.getTargetSeriesModels(),a=t.get("filterMode"),o=this._valueWindow;if("none"!==a){var r=this.getOtherAxisModel();t.get("$fromToolbox")&&r&&"category"===r.get("type")&&(a="empty"),kI(n,function(t){var n=t.getData(),r=t.coordDimToDataDim(i);"weakFilter"===a?n&&n.filterSelf(function(t){for(var e,i,a,s=0;s<r.length;s++){var l=n.get(r[s],t),h=!isNaN(l),u=l<o[0],c=l>o[1];if(h&&!u&&!c)return!0;h&&(a=!0),u&&(e=!0),c&&(i=!0)}return a&&e&&i}):n&&kI(r,function(i){"empty"===a?t.setData(n.map(i,function(t){return e(t)?t:NaN})):n.filterSelf(i,e)})})}}}};var EI=zI,RI=rl.each,NI=PI.eachAxisDim,VI=ym.extendComponentModel({type:"dataZoom",dependencies:["xAxis","yAxis","zAxis","radiusAxis","angleAxis","singleAxis","series"],defaultOption:{zlevel:0,z:4,orient:null,xAxisIndex:null,yAxisIndex:null,filterMode:"filter",throttle:null,start:0,end:100,startValue:null,endValue:null,minSpan:null,maxSpan:null,minValueSpan:null,maxValueSpan:null,rangeMode:null},init:function(t,e,i){this._dataIntervalByAxis={},this._dataInfo={},this._axisProxies={},this.textStyleModel,this._autoThrottle=!0,this._rangePropMode=["percent","percent"];var n=Br(t);this.mergeDefaultAndTheme(t,i),this.doInit(n)},mergeOption:function(t){var e=Br(t);rl.merge(this.option,t,!0),this.doInit(e)},doInit:function(t){var e=this.option;Us.canvasSupported||(e.realtime=!1),this._setDefaultThrottle(t),Gr(this,t),RI([["start","startValue"],["end","endValue"]],function(t,i){"value"===this._rangePropMode[i]&&(e[t[0]]=null)},this),this.textStyleModel=this.getModel("textStyle"),this._resetTarget(),this._giveAxisProxies()},_giveAxisProxies:function(){var t=this._axisProxies;this.eachTargetAxis(function(e,i,n,a){var o=this.dependentModels[e.axis][i],r=o.__dzAxisProxy||(o.__dzAxisProxy=new EI(e.name,i,this,a));t[e.name+"_"+i]=r},this)},_resetTarget:function(){var t=this.option,e=this._judgeAutoMode();NI(function(e){var i=e.axisIndex;t[i]=Ip.normalizeToArray(t[i])},this),"axisIndex"===e?this._autoSetAxisIndex():"orient"===e&&this._autoSetOrient()},_judgeAutoMode:function(){var t=this.option,e=!1;NI(function(i){null!=t[i.axisIndex]&&(e=!0)},this);var i=t.orient;return null==i&&e?"orient":e?void 0:(null==i&&(t.orient="horizontal"),"axisIndex")},_autoSetAxisIndex:function(){var t=!0,e=this.get("orient",!0),i=this.option,n=this.dependentModels;if(t){var a="vertical"===e?"y":"x";n[a+"Axis"].length?(i[a+"AxisIndex"]=[0],t=!1):RI(n.singleAxis,function(n){t&&n.get("orient",!0)===e&&(i.singleAxisIndex=[n.componentIndex],t=!1)})}t&&NI(function(e){if(t){var n=[],a=this.dependentModels[e.axis];if(a.length&&!n.length)for(var o=0,r=a.length;o<r;o++)"category"===a[o].get("type")&&n.push(o);i[e.axisIndex]=n,n.length&&(t=!1)}},this),t&&this.ecModel.eachSeries(function(t){this._isSeriesHasAllAxesTypeOf(t,"value")&&NI(function(e){var n=i[e.axisIndex],a=t.get(e.axisIndex),o=t.get(e.axisId);a=t.ecModel.queryComponents({mainType:e.axis,index:a,id:o})[0].componentIndex,rl.indexOf(n,a)<0&&n.push(a)})},this)},_autoSetOrient:function(){var t;this.eachTargetAxis(function(e){!t&&(t=e.name)},this),this.option.orient="y"===t?"vertical":"horizontal"},_isSeriesHasAllAxesTypeOf:function(t,e){var i=!0;return NI(function(n){var a=t.get(n.axisIndex),o=this.dependentModels[n.axis][a];o&&o.get("type")===e||(i=!1)},this),i},_setDefaultThrottle:function(t){if(t.hasOwnProperty("throttle")&&(this._autoThrottle=!1),this._autoThrottle){var e=this.ecModel.option;this.option.throttle=e.animation&&e.animationDurationUpdate>0?100:20}},getFirstTargetAxisModel:function(){var t;return NI(function(e){if(null==t){var i=this.get(e.axisIndex);i.length&&(t=this.dependentModels[e.axis][i[0]])}},this),t},eachTargetAxis:function(t,e){var i=this.ecModel;NI(function(n){RI(this.get(n.axisIndex),function(a){t.call(e,n,a,this,i)},this)},this)},getAxisProxy:function(t,e){return this._axisProxies[t+"_"+e]},getAxisModel:function(t,e){var i=this.getAxisProxy(t,e);return i&&i.getAxisModel()},setRawRange:function(t,e){var i=this.option;RI([["start","startValue"],["end","endValue"]],function(e){null==t[e[0]]&&null==t[e[1]]||(i[e[0]]=t[e[0]],i[e[1]]=t[e[1]])},this),!e&&Gr(this,t)},getPercentRange:function(){var t=this.findRepresentativeAxisProxy();if(t)return t.getDataPercentWindow()},getValueRange:function(t,e){if(null!=t||null!=e)return this.getAxisProxy(t,e).getDataValueWindow();var i=this.findRepresentativeAxisProxy();return i?i.getDataValueWindow():void 0},findRepresentativeAxisProxy:function(t){if(t)return t.__dzAxisProxy;var e=this._axisProxies;for(var i in e)if(e.hasOwnProperty(i)&&e[i].hostedBy(this))return e[i];for(var i in e)if(e.hasOwnProperty(i)&&!e[i].hostedBy(this))return e[i]},getRangePropMode:function(){return this._rangePropMode.slice()}}),BI=Nf.extend({type:"dataZoom",render:function(t,e,i,n){this.dataZoomModel=t,this.ecModel=e,this.api=i},getTargetCoordInfo:function(){var t=this.dataZoomModel,e=this.ecModel,i={};return t.eachTargetAxis(function(t,n){var a=e.getComponent(t.axis,n);if(a){var o=a.getCoordSysModel();o&&function(t,e,i,n){for(var a,o=0;o<i.length;o++)if(i[o].model===t){a=i[o];break}a||i.push(a={model:t,axisModels:[],coordIndex:n}),a.axisModels.push(e)}(o,a,i[o.mainType]||(i[o.mainType]=[]),o.componentIndex)}},this),i}}),GI=(VI.extend({type:"dataZoom.slider",layoutMode:"box",defaultOption:{show:!0,right:"ph",top:"ph",width:"ph",height:"ph",left:null,bottom:null,backgroundColor:"rgba(47,69,84,0)",dataBackground:{lineStyle:{color:"#2f4554",width:.5,opacity:.3},areaStyle:{color:"rgba(47,69,84,0.3)",opacity:.3}},borderColor:"#ddd",fillerColor:"rgba(167,183,204,0.4)",handleIcon:"M8.2,13.6V3.9H6.3v9.7H3.1v14.9h3.3v9.7h1.8v-9.7h3.3V13.6H8.2z M9.7,24.4H4.8v-1.4h4.9V24.4z M9.7,19.1H4.8v-1.4h4.9V19.1z",handleSize:"100%",handleStyle:{color:"#a7b7cc"},labelPrecision:null,labelFormatter:null,showDetail:!0,showDataShadow:"auto",realtime:!0,zoomLock:!1,textStyle:{color:"#333"}}}),fp.Rect),HI=Pu.linearMap,WI=Pu.asc,FI=rl.bind,ZI=rl.each,jI="horizontal",UI=5,qI=["line","bar","candlestick","scatter"],XI=BI.extend({type:"dataZoom.slider",init:function(t,e){this._displayables={},this._orient,this._range,this._handleEnds,this._size,this._handleWidth,this._handleHeight,this._location,this._dragging,this._dataShadowInfo,this.api=e},render:function(t,e,i,n){XI.superApply(this,"render",arguments),Ff.createOrUpdate(this,"_dispatchZoomAction",this.dataZoomModel.get("throttle"),"fixRate"),this._orient=t.get("orient"),!1!==this.dataZoomModel.get("show")?(n&&"dataZoom"===n.type&&n.from===this.uid||this._buildView(),this._updateView()):this.group.removeAll()},remove:function(){XI.superApply(this,"remove",arguments),Ff.clear(this,"_dispatchZoomAction")},dispose:function(){XI.superApply(this,"dispose",arguments),Ff.clear(this,"_dispatchZoomAction")},_buildView:function(){var t=this.group;t.removeAll(),this._resetLocation(),this._resetInterval();var e=this._displayables.barGroup=new fp.Group;this._renderBackground(),this._renderHandle(),this._renderDataShadow(),t.add(e),this._positionGroup()},_resetLocation:function(){var t=this.dataZoomModel,e=this.api,i=this._findCoordRect(),n={width:e.getWidth(),height:e.getHeight()},a=this._orient===jI?{right:n.width-i.x-i.width,top:n.height-30-7,width:i.width,height:30}:{right:7,top:i.y,width:30,height:i.height},o=Np.getLayoutParams(t.option);rl.each(["right","top","width","height"],function(t){"ph"===o[t]&&(o[t]=a[t])});var r=Np.getLayoutRect(o,n,t.padding);this._location={x:r.x,y:r.y},this._size=[r.width,r.height],"vertical"===this._orient&&this._size.reverse()},_positionGroup:function(){var t=this.group,e=this._location,i=this._orient,n=this.dataZoomModel.getFirstTargetAxisModel(),a=n&&n.get("inverse"),o=this._displayables.barGroup,r=(this._dataShadowInfo||{}).otherAxisInverse;o.attr(i!==jI||a?i===jI&&a?{scale:r?[-1,1]:[-1,-1]}:"vertical"!==i||a?{scale:r?[-1,-1]:[-1,1],rotation:Math.PI/2}:{scale:r?[1,-1]:[1,1],rotation:Math.PI/2}:{scale:r?[1,1]:[1,-1]});var s=t.getBoundingRect([o]);t.attr("position",[e.x-s.x,e.y-s.y])},_getViewExtent:function(){return[0,this._size[0]]},_renderBackground:function(){var t=this.dataZoomModel,e=this._size,i=this._displayables.barGroup;i.add(new GI({silent:!0,shape:{x:0,y:0,width:e[0],height:e[1]},style:{fill:t.get("backgroundColor")},z2:-40})),i.add(new GI({shape:{x:0,y:0,width:e[0],height:e[1]},style:{fill:"transparent"},z2:0,onclick:rl.bind(this._onClickPanelClick,this)}))},_renderDataShadow:function(){var t=this._dataShadowInfo=this._prepareDataShadowInfo();if(t){var e=this._size,i=t.series,n=i.getRawData(),a=i.getShadowDim?i.getShadowDim():t.otherDim;if(null!=a){var o=n.getDataExtent(a),r=.3*(o[1]-o[0]);o=[o[0]-r,o[1]+r];var s,l=[0,e[1]],h=[0,e[0]],u=[[e[0],0],[0,0]],c=[],d=h[1]/(n.count()-1),p=0,f=Math.round(n.count()/e[0]);n.each([a],function(t,e){if(f>0&&e%f)p+=d;else{var i=null==t||isNaN(t)||""===t,n=i?0:HI(t,o,l,!0);i&&!s&&e?(u.push([u[u.length-1][0],0]),c.push([c[c.length-1][0],0])):!i&&s&&(u.push([p,0]),c.push([p,0])),u.push([p,n]),c.push([p,n]),p+=d,s=i}});var g=this.dataZoomModel;this._displayables.barGroup.add(new fp.Polygon({shape:{points:u},style:rl.defaults({fill:g.get("dataBackgroundColor")},g.getModel("dataBackground.areaStyle").getAreaStyle()),silent:!0,z2:-20})),this._displayables.barGroup.add(new fp.Polyline({shape:{points:c},style:g.getModel("dataBackground.lineStyle").getLineStyle(),silent:!0,z2:-19}))}}},_prepareDataShadowInfo:function(){var t=this.dataZoomModel,e=t.get("showDataShadow");if(!1!==e){var i,n=this.ecModel;return t.eachTargetAxis(function(a,o){var r=t.getAxisProxy(a.name,o).getTargetSeriesModels();rl.each(r,function(t){if(!(i||!0!==e&&rl.indexOf(qI,t.get("type"))<0)){var r,s=n.getComponent(a.axis,o).axis,l=function(t){return{x:"y",y:"x",radius:"angle",angle:"radius"}[t]}(a.name),h=t.coordinateSystem;null!=l&&h.getOtherAxis&&(r=h.getOtherAxis(s).inverse),i={thisAxis:s,series:t,thisDim:a.name,otherDim:l,otherAxisInverse:r}}},this)},this),i}},_renderHandle:function(){var t=this._displayables,e=t.handles=[],i=t.handleLabels=[],n=this._displayables.barGroup,a=this._size,o=this.dataZoomModel;n.add(t.filler=new GI({draggable:!0,cursor:Hr(this._orient),drift:FI(this._onDragMove,this,"all"),onmousemove:function(t){su.stop(t.event)},ondragstart:FI(this._showDataInfo,this,!0),ondragend:FI(this._onDragEnd,this),onmouseover:FI(this._showDataInfo,this,!0),onmouseout:FI(this._showDataInfo,this,!1),style:{fill:o.get("fillerColor"),textPosition:"inside"}})),n.add(new GI(fp.subPixelOptimizeRect({silent:!0,shape:{x:0,y:0,width:a[0],height:a[1]},style:{stroke:o.get("dataBackgroundColor")||o.get("borderColor"),lineWidth:1,fill:"rgba(0,0,0,0)"}}))),ZI([0,1],function(t){var a=fp.createIcon(o.get("handleIcon"),{cursor:Hr(this._orient),draggable:!0,drift:FI(this._onDragMove,this,t),onmousemove:function(t){su.stop(t.event)},ondragend:FI(this._onDragEnd,this),onmouseover:FI(this._showDataInfo,this,!0),onmouseout:FI(this._showDataInfo,this,!1)},{x:-1,y:0,width:2,height:2}),r=a.getBoundingRect();this._handleHeight=Pu.parsePercent(o.get("handleSize"),this._size[1]),this._handleWidth=r.width/r.height*this._handleHeight,a.setStyle(o.getModel("handleStyle").getItemStyle());var s=o.get("handleColor");null!=s&&(a.style.fill=s),n.add(e[t]=a);var l=o.textStyleModel;this.group.add(i[t]=new fp.Text({silent:!0,invisible:!0,style:{x:0,y:0,text:"",textVerticalAlign:"middle",textAlign:"center",textFill:l.getTextColor(),textFont:l.getFont()},z2:10}))},this)},_resetInterval:function(){var t=this._range=this.dataZoomModel.getPercentRange(),e=this._getViewExtent();this._handleEnds=[HI(t[0],[0,100],e,!0),HI(t[1],[0,100],e,!0)]},_updateInterval:function(t,e){var i=this.dataZoomModel,n=this._handleEnds,a=this._getViewExtent(),o=i.findRepresentativeAxisProxy().getMinMaxSpan(),r=[0,100];xb(e,n,a,i.get("zoomLock")?"all":t,null!=o.minSpan?HI(o.minSpan,r,a,!0):null,null!=o.maxSpan?HI(o.maxSpan,r,a,!0):null),this._range=WI([HI(n[0],a,r,!0),HI(n[1],a,r,!0)])},_updateView:function(t){var e=this._displayables,i=this._handleEnds,n=WI(i.slice()),a=this._size;ZI([0,1],function(t){var n=e.handles[t],o=this._handleHeight;n.attr({scale:[o/2,o/2],position:[i[t],a[1]/2-o/2]})},this),e.filler.setShape({x:n[0],y:0,width:n[1]-n[0],height:a[1]}),this._updateDataInfo(t)},_updateDataInfo:function(t){function e(t){var e=fp.getTransform(n.handles[t].parent,this.group),i=fp.transformDirection(0===t?"right":"left",e),s=this._handleWidth/2+UI,l=fp.applyTransform([c[t]+(0===t?-s:s),this._size[1]/2],e);a[t].setStyle({x:l[0],y:l[1],textVerticalAlign:o===jI?"middle":i,textAlign:o===jI?i:"center",text:r[t]})}var i=this.dataZoomModel,n=this._displayables,a=n.handleLabels,o=this._orient,r=["",""];if(i.get("showDetail")){var s=i.findRepresentativeAxisProxy();if(s){var l=s.getAxisModel().axis,h=this._range,u=t?s.calculateDataWindow({start:h[0],end:h[1]}).valueWindow:s.getDataValueWindow();r=[this._formatLabel(u[0],l),this._formatLabel(u[1],l)]}}var c=WI(this._handleEnds.slice());e.call(this,0),e.call(this,1)},_formatLabel:function(t,e){var i=this.dataZoomModel,n=i.get("labelFormatter"),a=i.get("labelPrecision");null!=a&&"auto"!==a||(a=e.getPixelPrecision());var o=null==t||isNaN(t)?"":"category"===e.type||"time"===e.type?e.scale.getLabel(Math.round(t)):t.toFixed(Math.min(a,20));return rl.isFunction(n)?n(t,o):rl.isString(n)?n.replace("{value}",o):o},_showDataInfo:function(t){t=this._dragging||t;var e=this._displayables.handleLabels;e[0].attr("invisible",!t),e[1].attr("invisible",!t)},_onDragMove:function(t,e,i){this._dragging=!0;var n=this._displayables.barGroup.getLocalTransform(),a=fp.applyTransform([e,i],n,!0);this._updateInterval(t,a[0]);var o=this.dataZoomModel.get("realtime");this._updateView(!o),o&&o&&this._dispatchZoomAction()},_onDragEnd:function(){this._dragging=!1,this._showDataInfo(!1),this._dispatchZoomAction()},_onClickPanelClick:function(t){var e=this._size,i=this._displayables.barGroup.transformCoordToLocal(t.offsetX,t.offsetY);if(!(i[0]<0||i[0]>e[0]||i[1]<0||i[1]>e[1])){var n=this._handleEnds,a=(n[0]+n[1])/2;this._updateInterval("all",i[0]-a),this._updateView(),this._dispatchZoomAction()}},_dispatchZoomAction:function(){var t=this._range;this.api.dispatchAction({type:"dataZoom",from:this.uid,dataZoomId:this.dataZoomModel.id,start:t[0],end:t[1]})},_findCoordRect:function(){var t;if(ZI(this.getTargetCoordInfo(),function(e){if(!t&&e.length){var i=e[0].model.coordinateSystem;t=i.getRect&&i.getRect()}}),!t){var e=this.api.getWidth(),i=this.api.getHeight();t={x:.2*e,y:.2*i,width:.6*e,height:.6*i}}return t}}),YI=(VI.extend({type:"dataZoom.inside",defaultOption:{disabled:!1,zoomLock:!1,zoomOnMouseWheel:!0,moveOnMouseMove:!0,preventDefaultMouseMove:!0}}),rl.curry),$I="\0_ec_dataZoom_roams",KI={register:function(t,e){var i=Wr(t),n=e.dataZoomId,a=e.coordId;rl.each(i,function(t,i){var o=t.dataZoomInfos;o[n]&&rl.indexOf(e.allCoordIds,a)<0&&(delete o[n],t.count--)}),Fr(i);var o=i[a];o||((o=i[a]={coordId:a,dataZoomInfos:{},count:0}).controller=function(t,e){var i=new Wy(t.getZr());return i.on("pan",YI(function(t,e,i,n,a,o,r){Zr(t,function(s){return s.panGetRange(t.controller,e,i,n,a,o,r)})},e)),i.on("zoom",YI(function(t,e,i,n){Zr(t,function(a){return a.zoomGetRange(t.controller,e,i,n)})},e)),i}(t,o),o.dispatchAction=rl.curry(function(t,e){t.dispatchAction({type:"dataZoom",batch:e})},t)),!o.dataZoomInfos[n]&&o.count++,o.dataZoomInfos[n]=e;var r=function(t){var e,i={},n={true:2,move:1,false:0,undefined:-1};return rl.each(t,function(t){var a=!t.disabled&&(!t.zoomLock||"move");n[a]>n[e]&&(e=a),rl.extend(i,t.roamControllerOpt)}),{controlType:e,opt:i}}(o.dataZoomInfos);o.controller.enable(r.controlType,r.opt),o.controller.setPointerChecker(e.containsPoint),Ff.createOrUpdate(o,"dispatchAction",e.throttleRate,"fixRate")},unregister:function(t,e){var i=Wr(t);rl.each(i,function(t){t.controller.dispose();var i=t.dataZoomInfos;i[e]&&(delete i[e],t.count--)}),Fr(i)},shouldRecordRange:function(t,e){if(t&&"dataZoom"===t.type&&t.batch)for(var i=0,n=t.batch.length;i<n;i++)if(t.batch[i].dataZoomId===e)return!1;return!0},generateCoordId:function(t){return t.type+"\0_"+t.id}},JI=rl.bind,QI=BI.extend({type:"dataZoom.inside",init:function(t,e){this._range},render:function(t,e,i,n){QI.superApply(this,"render",arguments),KI.shouldRecordRange(n,t.id)&&(this._range=t.getPercentRange()),rl.each(this.getTargetCoordInfo(),function(e,n){var a=rl.map(e,function(t){return KI.generateCoordId(t.model)});rl.each(e,function(e){var o=e.model,r=t.option;KI.register(i,{coordId:KI.generateCoordId(o),allCoordIds:a,containsPoint:function(t,e,i){return o.coordinateSystem.containPoint([e,i])},dataZoomId:t.id,throttleRate:t.get("throttle",!0),panGetRange:JI(this._onPan,this,e,n),zoomGetRange:JI(this._onZoom,this,e,n),zoomLock:r.zoomLock,disabled:r.disabled,roamControllerOpt:{zoomOnMouseWheel:r.zoomOnMouseWheel,moveOnMouseMove:r.moveOnMouseMove,preventDefaultMouseMove:r.preventDefaultMouseMove}})},this)},this)},dispose:function(){KI.unregister(this.api,this.dataZoomModel.id),QI.superApply(this,"dispose",arguments),this._range=null},_onPan:function(t,e,i,n,a,o,r,s,l){var h=this._range.slice(),u=t.axisModels[0];if(u){var c=tT[e]([o,r],[s,l],u,i,t),d=c.signal*(h[1]-h[0])*c.pixel/c.pixelLength;return xb(d,h,[0,100],"all"),this._range=h}},_onZoom:function(t,e,i,n,a,o){var r=this._range.slice(),s=t.axisModels[0];if(s){var l=tT[e](null,[a,o],s,i,t),h=(l.signal>0?l.pixelStart+l.pixelLength-l.pixel:l.pixel-l.pixelStart)/l.pixelLength*(r[1]-r[0])+r[0];n=Math.max(1/n,0),r[0]=(r[0]-h)*n+h,r[1]=(r[1]-h)*n+h;var u=this.dataZoomModel.findRepresentativeAxisProxy().getMinMaxSpan();return xb(0,r,[0,100],0,u.minSpan,u.maxSpan),this._range=r}}}),tT={grid:function(t,e,i,n,a){var o=i.axis,r={},s=a.model.coordinateSystem.getRect();return t=t||[0,0],"x"===o.dim?(r.pixel=e[0]-t[0],r.pixelLength=s.width,r.pixelStart=s.x,r.signal=o.inverse?1:-1):(r.pixel=e[1]-t[1],r.pixelLength=s.height,r.pixelStart=s.y,r.signal=o.inverse?-1:1),r},polar:function(t,e,i,n,a){var o=i.axis,r={},s=a.model.coordinateSystem,l=s.getRadiusAxis().getExtent(),h=s.getAngleAxis().getExtent();return t=t?s.pointToCoord(t):[0,0],e=s.pointToCoord(e),"radiusAxis"===i.mainType?(r.pixel=e[0]-t[0],r.pixelLength=l[1]-l[0],r.pixelStart=l[0],r.signal=o.inverse?1:-1):(r.pixel=e[1]-t[1],r.pixelLength=h[1]-h[0],r.pixelStart=h[0],r.signal=o.inverse?-1:1),r},singleAxis:function(t,e,i,n,a){var o=i.axis,r=a.model.coordinateSystem.getRect(),s={};return t=t||[0,0],"horizontal"===o.orient?(s.pixel=e[0]-t[0],s.pixelLength=r.width,s.pixelStart=r.x,s.signal=o.inverse?1:-1):(s.pixel=e[1]-t[1],s.pixelLength=r.height,s.pixelStart=r.y,s.signal=o.inverse?-1:1),s}};ym.registerProcessor(function(t,e){t.eachComponent("dataZoom",function(t){t.eachTargetAxis(function(t,e,i){i.getAxisProxy(t.name,e).reset(i)}),t.eachTargetAxis(function(t,e,i){i.getAxisProxy(t.name,e).filterData(i)})}),t.eachComponent("dataZoom",function(t){var e=t.findRepresentativeAxisProxy(),i=e.getDataPercentWindow(),n=e.getDataValueWindow();t.setRawRange({start:i[0],end:i[1],startValue:n[0],endValue:n[1]},!0)})}),ym.registerAction("dataZoom",function(t,e){var i=PI.createLinkedNodesFinder(rl.bind(e.eachComponent,e,"dataZoom"),PI.eachAxisDim,function(t,e){return t.get(e.axisIndex)}),n=[];e.eachComponent({mainType:"dataZoom",query:t},function(t,e){n.push.apply(n,i(t).nodes)}),rl.each(n,function(e,i){e.setRawRange({start:t.start,end:t.end,startValue:t.startValue,endValue:t.endValue})})});var eT=rl.each,iT=function(t){var e=t&&t.visualMap;rl.isArray(e)||(e=e?[e]:[]),eT(e,function(t){if(t){jr(t,"splitList")&&!jr(t,"pieces")&&(t.pieces=t.splitList,delete t.splitList);var e=t.pieces;e&&rl.isArray(e)&&eT(e,function(t){rl.isObject(t)&&(jr(t,"start")&&!jr(t,"min")&&(t.min=t.start),jr(t,"end")&&!jr(t,"max")&&(t.max=t.end))})}})};Hp.registerSubTypeDefaulter("visualMap",function(t){return t.categories||(t.pieces?t.pieces.length>0:t.splitNumber>0)&&!t.calculable?"piecewise":"continuous"}),ym.registerVisual(ym.PRIORITY.VISUAL.COMPONENT,function(t){t.eachComponent("visualMap",function(t){!function(t,e){t.eachTargetSeries(function(e){var i=e.getData();JM.applyVisual(t.stateList,t.targetVisuals,i,t.getValueState,t,t.getDataDimension(i))})}(t)}),function(t){t.eachSeries(function(e){var i=e.getData(),n=[];t.eachComponent("visualMap",function(t){if(t.isTargetSeries(e)){var a=t.getVisualMeta(rl.bind(function(t,e,i,n){for(var a=e.targetVisuals[n],o=Kx.prepareVisualTypes(a),r={color:t.getData().getVisual("color")},s=0,l=o.length;s<l;s++){var h=o[s],u=a["opacity"===h?"__alphaForOpacity":h];u&&u.applyVisual(i,function(t){return r[t]},function(t,e){r[t]=e})}return r.color},null,e,t))||{stops:[],outerColors:[]};a.dimension=t.getDataDimension(i),n.push(a)}}),e.getData().setVisual("visualMeta",n)})}(t)});var nT={get:function(t,e,i){var n=rl.clone((aT[t]||{})[e]);return i&&rl.isArray(n)?n[n.length-1]:n}},aT={color:{active:["#006edd","#e0ffff"],inactive:["rgba(0,0,0,0)"]},colorHue:{active:[0,360],inactive:[0,0]},colorSaturation:{active:[.3,1],inactive:[0,0]},colorLightness:{active:[.9,.5],inactive:[0,0]},colorAlpha:{active:[.3,1],inactive:[0,0]},opacity:{active:[.3,1],inactive:[0,0]},symbol:{active:["circle","roundRect","diamond"],inactive:["none"]},symbolSize:{active:[10,50],inactive:[0,0]}},oT=nT,rT=Kx.mapVisual,sT=Kx.eachVisual,lT=rl.isArray,hT=rl.each,uT=Pu.asc,cT=Pu.linearMap,dT=rl.noop,pT=["#f6efa6","#d88273","#bf444c"],fT=ym.extendComponentModel({type:"visualMap",dependencies:["series"],stateList:["inRange","outOfRange"],replacableOptionKeys:["inRange","outOfRange","target","controller","color"],dataBound:[-1/0,1/0],layoutMode:{type:"box",ignoreSize:!0},defaultOption:{show:!0,zlevel:0,z:4,seriesIndex:"all",min:0,max:200,dimension:null,inRange:null,outOfRange:null,left:0,right:null,top:null,bottom:0,itemWidth:null,itemHeight:null,inverse:!1,orient:"vertical",backgroundColor:"rgba(0,0,0,0)",borderColor:"#ccc",contentColor:"#5793f3",inactiveColor:"#aaa",borderWidth:0,padding:5,textGap:10,precision:0,color:null,formatter:null,text:null,textStyle:{color:"#333"}},init:function(t,e,i){this._dataExtent,this.targetVisuals={},this.controllerVisuals={},this.textStyleModel,this.itemSize,this.mergeDefaultAndTheme(t,i)},optionUpdated:function(t,e){var i=this.option;Us.canvasSupported||(i.realtime=!1),!e&&JM.replaceVisualOption(i,t,this.replacableOptionKeys),this.textStyleModel=this.getModel("textStyle"),this.resetItemSize(),this.completeVisualOption()},resetVisual:function(t){var e=this.stateList;t=rl.bind(t,this),this.controllerVisuals=JM.createVisualMappings(this.option.controller,e,t),this.targetVisuals=JM.createVisualMappings(this.option.target,e,t)},getTargetSeriesIndices:function(){var t=this.option.seriesIndex,e=[];return null==t||"all"===t?this.ecModel.eachSeries(function(t,i){e.push(i)}):e=Ip.normalizeToArray(t),e},eachTargetSeries:function(t,e){rl.each(this.getTargetSeriesIndices(),function(i){t.call(e,this.ecModel.getSeriesByIndex(i))},this)},isTargetSeries:function(t){var e=!1;return this.eachTargetSeries(function(i){i===t&&(e=!0)}),e},formatValueText:function(t,e,i){function n(t){return t===l[0]?"min":t===l[1]?"max":(+t).toFixed(Math.min(s,20))}var a,o,r=this.option,s=r.precision,l=this.dataBound,h=r.formatter;return i=i||["<",">"],rl.isArray(t)&&(t=t.slice(),a=!0),o=e?t:a?[n(t[0]),n(t[1])]:n(t),rl.isString(h)?h.replace("{value}",a?o[0]:o).replace("{value2}",a?o[1]:o):rl.isFunction(h)?a?h(t[0],t[1]):h(t):a?t[0]===l[0]?i[0]+" "+o[1]:t[1]===l[1]?i[1]+" "+o[0]:o[0]+" - "+o[1]:o},resetExtent:function(){var t=this.option,e=uT([t.min,t.max]);this._dataExtent=e},getDataDimension:function(t){var e=this.option.dimension;return null!=e?e:t.dimensions.length-1},getExtent:function(){return this._dataExtent.slice()},completeVisualOption:function(){function t(t){lT(e.color)&&!t.inRange&&(t.inRange={color:e.color.slice().reverse()}),t.inRange=t.inRange||{color:pT},hT(this.stateList,function(e){var i=t[e];if(rl.isString(i)){var n=oT.get(i,"active",o);n?(t[e]={},t[e][i]=n):delete t[e]}},this)}var e=this.option,i={inRange:e.inRange,outOfRange:e.outOfRange},n=e.target||(e.target={}),a=e.controller||(e.controller={});rl.merge(n,i),rl.merge(a,i);var o=this.isCategory();t.call(this,n),t.call(this,a),function(t,e,i){var n=t[e],a=t[i];n&&!a&&(a=t[i]={},hT(n,function(t,e){if(Kx.isValidType(e)){var i=oT.get(e,"inactive",o);null!=i&&(a[e]=i,"color"!==e||a.hasOwnProperty("opacity")||a.hasOwnProperty("colorAlpha")||(a.opacity=[0,0]))}}))}.call(this,n,"inRange","outOfRange"),function(t){var e=(t.inRange||{}).symbol||(t.outOfRange||{}).symbol,i=(t.inRange||{}).symbolSize||(t.outOfRange||{}).symbolSize,n=this.get("inactiveColor");hT(this.stateList,function(a){var r=this.itemSize,s=t[a];s||(s=t[a]={color:o?n:[n]}),null==s.symbol&&(s.symbol=e&&rl.clone(e)||(o?"roundRect":["roundRect"])),null==s.symbolSize&&(s.symbolSize=i&&rl.clone(i)||(o?r[0]:[r[0],r[0]])),s.symbol=rT(s.symbol,function(t){return"none"===t||"square"===t?"roundRect":t});var l=s.symbolSize;if(null!=l){var h=-1/0;sT(l,function(t){t>h&&(h=t)}),s.symbolSize=rT(l,function(t){return cT(t,[0,h],[0,r[0]],!0)})}},this)}.call(this,a)},resetItemSize:function(){this.itemSize=[parseFloat(this.get("itemWidth")),parseFloat(this.get("itemHeight"))]},isCategory:function(){return!!this.option.categories},setSelected:dT,getValueState:dT,getVisualMeta:dT}),gT=[20,140],mT=fT.extend({type:"visualMap.continuous",defaultOption:{align:"auto",calculable:!1,range:null,realtime:!0,itemHeight:null,itemWidth:null,hoverLink:!0,hoverLinkDataSize:null,hoverLinkOnHandle:null},optionUpdated:function(t,e){mT.superApply(this,"optionUpdated",arguments),this.resetExtent(),this.resetVisual(function(t){t.mappingMethod="linear",t.dataExtent=this.getExtent()}),this._resetRange()},resetItemSize:function(){mT.superApply(this,"resetItemSize",arguments);var t=this.itemSize;"horizontal"===this._orient&&t.reverse(),(null==t[0]||isNaN(t[0]))&&(t[0]=gT[0]),(null==t[1]||isNaN(t[1]))&&(t[1]=gT[1])},_resetRange:function(){var t=this.getExtent(),e=this.option.range;!e||e.auto?(t.auto=1,this.option.range=t):rl.isArray(e)&&(e[0]>e[1]&&e.reverse(),e[0]=Math.max(e[0],t[0]),e[1]=Math.min(e[1],t[1]))},completeVisualOption:function(){fT.prototype.completeVisualOption.apply(this,arguments),rl.each(this.stateList,function(t){var e=this.option.controller[t].symbolSize;e&&e[0]!==e[1]&&(e[0]=0)},this)},setSelected:function(t){this.option.range=t.slice(),this._resetRange()},getSelected:function(){var t=this.getExtent(),e=Pu.asc((this.get("range")||[]).slice());return e[0]>t[1]&&(e[0]=t[1]),e[1]>t[1]&&(e[1]=t[1]),e[0]<t[0]&&(e[0]=t[0]),e[1]<t[0]&&(e[1]=t[0]),e},getValueState:function(t){var e=this.option.range,i=this.getExtent();return(e[0]<=i[0]||e[0]<=t)&&(e[1]>=i[1]||t<=e[1])?"inRange":"outOfRange"},findTargetDataIndices:function(t){var e=[];return this.eachTargetSeries(function(i){var n=[],a=i.getData();a.each(this.getDataDimension(a),function(e,i){t[0]<=e&&e<=t[1]&&n.push(i)},!0,this),e.push({seriesId:i.id,dataIndex:n})},this),e},getVisualMeta:function(t){function e(e,i){a.push({value:e,color:t(e,i)})}for(var i=Ur(0,0,this.getExtent()),n=Ur(0,0,this.option.range.slice()),a=[],o=0,r=0,s=n.length,l=i.length;r<l&&(!n.length||i[r]<=n[0]);r++)i[r]<n[o]&&e(i[r],"outOfRange");for(h=1;o<s;o++,h=0)h&&a.length&&e(n[o],"outOfRange"),e(n[o],"inRange");for(var h=1;r<l;r++)(!n.length||n[n.length-1]<i[r])&&(h&&(a.length&&e(a[a.length-1].value,"outOfRange"),h=0),e(i[r],"outOfRange"));var u=a.length;return{stops:a,outerColors:[u?a[0].color:"transparent",u?a[u-1].color:"transparent"]}}}),vT=ym.extendComponentView({type:"visualMap",autoPositionValues:{left:1,right:1,top:1,bottom:1},init:function(t,e){this.ecModel=t,this.api=e,this.visualMapModel},render:function(t,e,i,n){this.visualMapModel=t,!1!==t.get("show")?this.doRender.apply(this,arguments):this.group.removeAll()},renderBackground:function(t){var e=this.visualMapModel,i=Eu.normalizeCssArray(e.get("padding")||0),n=t.getBoundingRect();t.add(new fp.Rect({z2:-1,silent:!0,shape:{x:n.x-i[3],y:n.y-i[0],width:n.width+i[3]+i[1],height:n.height+i[0]+i[2]},style:{fill:e.get("backgroundColor"),stroke:e.get("borderColor"),lineWidth:e.get("borderWidth")}}))},getControllerVisual:function(t,e,i){var n=(i=i||{}).forceState,a=this.visualMapModel,o={};if("symbol"===e&&(o.symbol=a.get("itemSymbol")),"color"===e){var r=a.get("contentColor");o.color=r}var s=a.controllerVisuals[n||a.getValueState(t)],l=Kx.prepareVisualTypes(s);return rl.each(l,function(n){var a=s[n];i.convertOpacityToAlpha&&"opacity"===n&&(n="colorAlpha",a=s.__alphaForOpacity),Kx.dependsOn(n,e)&&a&&a.applyVisual(t,function(t){return o[t]},function(t,e){o[t]=e})}),o[e]},positionGroup:function(t){var e=this.visualMapModel,i=this.api;Np.positionElement(t,e.getBoxLayoutParams(),{width:i.getWidth(),height:i.getHeight()})},doRender:rl.noop}),yT=Np.getLayoutRect,xT={getItemAlign:function(t,e,i){var n=t.option,a=n.align;if(null!=a&&"auto"!==a)return a;for(var o={width:e.getWidth(),height:e.getHeight()},r="horizontal"===n.orient?1:0,s=[["left","right","width"],["top","bottom","height"]],l=s[r],h=[0,null,10],u={},c=0;c<3;c++)u[s[1-r][c]]=h[c],u[l[c]]=2===c?i[0]:n[l[c]];var d=[["x","width",3],["y","height",0]][r],p=yT(u,o,n.padding);return l[(p.margin[d[2]]||0)+p[d[0]]+.5*p[d[1]]<.5*o[d[1]]?0:1]},convertDataIndex:function(t){return rl.each(t||[],function(e){null!=t.dataIndex&&(t.dataIndexInside=t.dataIndex,t.dataIndex=null)}),t}},_T=Pu.linearMap,bT=rl.each,wT=Math.min,ST=Math.max,MT=12,IT=6,TT=vT.extend({type:"visualMap.continuous",init:function(){TT.superApply(this,"init",arguments),this._shapes={},this._dataInterval=[],this._handleEnds=[],this._orient,this._useHandle,this._hoverLinkDataIndices=[],this._dragging,this._hovering},doRender:function(t,e,i,n){n&&"selectDataRange"===n.type&&n.from===this.uid||this._buildView()},_buildView:function(){this.group.removeAll();var t=this.visualMapModel,e=this.group;this._orient=t.get("orient"),this._useHandle=t.get("calculable"),this._resetInterval(),this._renderBar(e);var i=t.get("text");this._renderEndsText(e,i,0),this._renderEndsText(e,i,1),this._updateView(!0),this.renderBackground(e),this._updateView(),this._enableHoverLinkToSeries(),this._enableHoverLinkFromSeries(),this.positionGroup(e)},_renderEndsText:function(t,e,i){if(e){var n=e[1-i];n=null!=n?n+"":"";var a=this.visualMapModel,o=a.get("textGap"),r=a.itemSize,s=this._shapes.barGroup,l=this._applyTransform([r[0]/2,0===i?-o:r[1]+o],s),h=this._applyTransform(0===i?"bottom":"top",s),u=this._orient,c=this.visualMapModel.textStyleModel;this.group.add(new fp.Text({style:{x:l[0],y:l[1],textVerticalAlign:"horizontal"===u?"middle":h,textAlign:"horizontal"===u?h:"center",text:n,textFont:c.getFont(),textFill:c.getTextColor()}}))}},_renderBar:function(t){var e=this.visualMapModel,i=this._shapes,n=e.itemSize,a=this._orient,o=this._useHandle,r=xT.getItemAlign(e,this.api,n),s=i.barGroup=this._createBarGroup(r);s.add(i.outOfRange=qr()),s.add(i.inRange=qr(null,o?Yr(this._orient):null,rl.bind(this._dragHandle,this,"all",!1),rl.bind(this._dragHandle,this,"all",!0)));var l=e.textStyleModel.getTextRect("国"),h=ST(l.width,l.height);o&&(i.handleThumbs=[],i.handleLabels=[],i.handleLabelPoints=[],this._createHandle(s,0,n,h,a,r),this._createHandle(s,1,n,h,a,r)),this._createIndicator(s,n,h,a),t.add(s)},_createHandle:function(t,e,i,n,a){var o=rl.bind(this._dragHandle,this,e,!1),r=rl.bind(this._dragHandle,this,e,!0),s=qr(function(t,e){return 0===t?[[0,0],[e,0],[e,-e]]:[[0,0],[e,0],[e,e]]}(e,n),Yr(this._orient),o,r);s.position[0]=i[0],t.add(s);var l=this.visualMapModel.textStyleModel,h=new fp.Text({draggable:!0,drift:o,onmousemove:function(t){su.stop(t.event)},ondragend:r,style:{x:0,y:0,text:"",textFont:l.getFont(),textFill:l.getTextColor()}});this.group.add(h);var u=["horizontal"===a?n/2:1.5*n,"horizontal"===a?0===e?-1.5*n:1.5*n:0===e?-n/2:n/2],c=this._shapes;c.handleThumbs[e]=s,c.handleLabelPoints[e]=u,c.handleLabels[e]=h},_createIndicator:function(t,e,i,n){var a=qr([[0,0]],"move");a.position[0]=e[0],a.attr({invisible:!0,silent:!0}),t.add(a);var o=this.visualMapModel.textStyleModel,r=new fp.Text({silent:!0,invisible:!0,style:{x:0,y:0,text:"",textFont:o.getFont(),textFill:o.getTextColor()}});this.group.add(r);var s=["horizontal"===n?i/2:IT+3,0],l=this._shapes;l.indicator=a,l.indicatorLabel=r,l.indicatorLabelPoint=s},_dragHandle:function(t,e,i,n){if(this._useHandle){if(this._dragging=!e,!e){var a=this._applyTransform([i,n],this._shapes.barGroup,!0);this._updateInterval(t,a[1]),this._updateView()}e===!this.visualMapModel.get("realtime")&&this.api.dispatchAction({type:"selectDataRange",from:this.uid,visualMapId:this.visualMapModel.id,selected:this._dataInterval.slice()}),e?!this._hovering&&this._clearHoverLinkToSeries():Xr(this.visualMapModel)&&this._doHoverLinkToSeries(this._handleEnds[t],!1)}},_resetInterval:function(){var t=this.visualMapModel,e=this._dataInterval=t.getSelected(),i=t.getExtent(),n=[0,t.itemSize[1]];this._handleEnds=[_T(e[0],i,n,!0),_T(e[1],i,n,!0)]},_updateInterval:function(t,e){e=e||0;var i=this.visualMapModel,n=this._handleEnds,a=[0,i.itemSize[1]];xb(e,n,a,t,0);var o=i.getExtent();this._dataInterval=[_T(n[0],a,o,!0),_T(n[1],a,o,!0)]},_updateView:function(t){var e=this.visualMapModel,i=e.getExtent(),n=this._shapes,a=[0,e.itemSize[1]],o=t?a:this._handleEnds,r=this._createBarVisual(this._dataInterval,i,o,"inRange"),s=this._createBarVisual(i,i,a,"outOfRange");n.inRange.setStyle({fill:r.barColor,opacity:r.opacity}).setShape("points",r.barPoints),n.outOfRange.setStyle({fill:s.barColor,opacity:s.opacity}).setShape("points",s.barPoints),this._updateHandle(o,r)},_createBarVisual:function(t,e,i,n){var a={forceState:n,convertOpacityToAlpha:!0},o=this._makeColorGradient(t,a),r=[this.getControllerVisual(t[0],"symbolSize",a),this.getControllerVisual(t[1],"symbolSize",a)],s=this._createBarPoints(i,r);return{barColor:new Ud(0,0,0,1,o),barPoints:s,handlesColor:[o[0].color,o[o.length-1].color]}},_makeColorGradient:function(t,e){var i=[],n=(t[1]-t[0])/100;i.push({color:this.getControllerVisual(t[0],"color",e),offset:0});for(var a=1;a<100;a++){var o=t[0]+n*a;if(o>t[1])break;i.push({color:this.getControllerVisual(o,"color",e),offset:a/100})}return i.push({color:this.getControllerVisual(t[1],"color",e),offset:1}),i},_createBarPoints:function(t,e){var i=this.visualMapModel.itemSize;return[[i[0]-e[0],t[0]],[i[0],t[0]],[i[0],t[1]],[i[0]-e[1],t[1]]]},_createBarGroup:function(t){var e=this._orient,i=this.visualMapModel.get("inverse");return new fp.Group("horizontal"!==e||i?"horizontal"===e&&i?{scale:"bottom"===t?[-1,1]:[1,1],rotation:-Math.PI/2}:"vertical"!==e||i?{scale:"left"===t?[1,1]:[-1,1]}:{scale:"left"===t?[1,-1]:[-1,-1]}:{scale:"bottom"===t?[1,1]:[-1,1],rotation:Math.PI/2})},_updateHandle:function(t,e){if(this._useHandle){var i=this._shapes,n=this.visualMapModel,a=i.handleThumbs,o=i.handleLabels;bT([0,1],function(r){var s=a[r];s.setStyle("fill",e.handlesColor[r]),s.position[1]=t[r];var l=fp.applyTransform(i.handleLabelPoints[r],fp.getTransform(s,this.group));o[r].setStyle({x:l[0],y:l[1],text:n.formatValueText(this._dataInterval[r]),textVerticalAlign:"middle",textAlign:this._applyTransform("horizontal"===this._orient?0===r?"bottom":"top":"left",i.barGroup)})},this)}},_showIndicator:function(t,e,i,n){var a=this.visualMapModel,o=a.getExtent(),r=a.itemSize,s=[0,r[1]],l=_T(t,o,s,!0),h=this._shapes,u=h.indicator;if(u){u.position[1]=l,u.attr("invisible",!1),u.setShape("points",function(t,e,i,n){return t?[[0,-wT(e,ST(i,0))],[IT,0],[0,wT(e,ST(n-i,0))]]:[[0,0],[5,-5],[5,5]]}(!!i,n,l,r[1]));var c=this.getControllerVisual(t,"color",{convertOpacityToAlpha:!0});u.setStyle("fill",c);var d=fp.applyTransform(h.indicatorLabelPoint,fp.getTransform(u,this.group)),p=h.indicatorLabel;p.attr("invisible",!1);var f=this._applyTransform("left",h.barGroup),g=this._orient;p.setStyle({text:(i||"")+a.formatValueText(e),textVerticalAlign:"horizontal"===g?f:"middle",textAlign:"horizontal"===g?"center":f,x:d[0],y:d[1]})}},_enableHoverLinkToSeries:function(){var t=this;this._shapes.barGroup.on("mousemove",function(e){if(t._hovering=!0,!t._dragging){var i=t.visualMapModel.itemSize,n=t._applyTransform([e.offsetX,e.offsetY],t._shapes.barGroup,!0,!0);n[1]=wT(ST(0,n[1]),i[1]),t._doHoverLinkToSeries(n[1],0<=n[0]&&n[0]<=i[0])}}).on("mouseout",function(){t._hovering=!1,!t._dragging&&t._clearHoverLinkToSeries()})},_enableHoverLinkFromSeries:function(){var t=this.api.getZr();this.visualMapModel.option.hoverLink?(t.on("mouseover",this._hoverLinkFromSeriesMouseOver,this),t.on("mouseout",this._hideIndicator,this)):this._clearHoverLinkFromSeries()},_doHoverLinkToSeries:function(t,e){var i=this.visualMapModel,n=i.itemSize;if(i.option.hoverLink){var a=[0,n[1]],o=i.getExtent();t=wT(ST(a[0],t),a[1]);var r=function(t,e,i){var n=MT/2,a=t.get("hoverLinkDataSize");return a&&(n=_T(a,e,i,!0)/2),n}(i,o,a),s=[t-r,t+r],l=_T(t,a,o,!0),h=[_T(s[0],a,o,!0),_T(s[1],a,o,!0)];s[0]<a[0]&&(h[0]=-1/0),s[1]>a[1]&&(h[1]=1/0),e&&(h[0]===-1/0?this._showIndicator(l,h[1],"< ",r):h[1]===1/0?this._showIndicator(l,h[0],"> ",r):this._showIndicator(l,l,"≈ ",r));var u=this._hoverLinkDataIndices,c=[];(e||Xr(i))&&(c=this._hoverLinkDataIndices=i.findTargetDataIndices(h));var d=Ip.compressBatches(u,c);this._dispatchHighDown("downplay",xT.convertDataIndex(d[0])),this._dispatchHighDown("highlight",xT.convertDataIndex(d[1]))}},_hoverLinkFromSeriesMouseOver:function(t){var e=t.target,i=this.visualMapModel;if(e&&null!=e.dataIndex){var n=this.ecModel.getSeriesByIndex(e.seriesIndex);if(i.isTargetSeries(n)){var a=n.getData(e.dataType),o=a.getDimension(i.getDataDimension(a)),r=a.get(o,e.dataIndex,!0);isNaN(r)||this._showIndicator(r,r)}}},_hideIndicator:function(){var t=this._shapes;t.indicator&&t.indicator.attr("invisible",!0),t.indicatorLabel&&t.indicatorLabel.attr("invisible",!0)},_clearHoverLinkToSeries:function(){this._hideIndicator();var t=this._hoverLinkDataIndices;this._dispatchHighDown("downplay",xT.convertDataIndex(t)),t.length=0},_clearHoverLinkFromSeries:function(){this._hideIndicator();var t=this.api.getZr();t.off("mouseover",this._hoverLinkFromSeriesMouseOver),t.off("mouseout",this._hideIndicator)},_applyTransform:function(t,e,i,n){var a=fp.getTransform(e,n?null:this.group);return fp[rl.isArray(t)?"applyTransform":"transformDirection"](t,a,i)},_dispatchHighDown:function(t,e){e&&e.length&&this.api.dispatchAction({type:t,batch:e})},dispose:function(){this._clearHoverLinkFromSeries(),this._clearHoverLinkToSeries()},remove:function(){this._clearHoverLinkFromSeries(),this._clearHoverLinkToSeries()}});ym.registerAction({type:"selectDataRange",event:"dataRangeSelected",update:"update"},function(t,e){e.eachComponent({mainType:"visualMap",query:t},function(e){e.setSelected(t.selected)})}),ym.registerPreprocessor(iT);var AT=Pu.reformIntervals,CT=fT.extend({type:"visualMap.piecewise",defaultOption:{selected:null,minOpen:!1,maxOpen:!1,align:"auto",itemWidth:20,itemHeight:14,itemSymbol:"roundRect",pieceList:null,categories:null,splitNumber:5,selectedMode:"multiple",itemGap:10,hoverLink:!0,showLabel:null},optionUpdated:function(t,e){CT.superApply(this,"optionUpdated",arguments),this._pieceList=[],this.resetExtent();var i=this._mode=this._determineMode();LT[this._mode].call(this),this._resetSelected(t,e);var n=this.option.categories;this.resetVisual(function(t,e){"categories"===i?(t.mappingMethod="category",t.categories=rl.clone(n)):(t.dataExtent=this.getExtent(),t.mappingMethod="piecewise",t.pieceList=rl.map(this._pieceList,function(t){t=rl.clone(t);return"inRange"!==e&&(t.visual=null),t}))})},completeVisualOption:function(){function t(t,e,i){return t&&t[e]&&(rl.isObject(t[e])?t[e].hasOwnProperty(i):t[e]===i)}var e=this.option,i={},n=Kx.listVisualTypes(),a=this.isCategory();rl.each(e.pieces,function(t){rl.each(n,function(e){t.hasOwnProperty(e)&&(i[e]=1)})}),rl.each(i,function(i,n){var o=0;rl.each(this.stateList,function(i){o|=t(e,i,n)||t(e.target,i,n)},this),!o&&rl.each(this.stateList,function(t){(e[t]||(e[t]={}))[n]=oT.get(n,"inRange"===t?"active":"inactive",a)})},this),fT.prototype.completeVisualOption.apply(this,arguments)},_resetSelected:function(t,e){var i=this.option,n=this._pieceList,a=(e?i:t).selected||{};if(i.selected=a,rl.each(n,function(t,e){var i=this.getSelectedMapKey(t);a.hasOwnProperty(i)||(a[i]=!0)},this),"single"===i.selectedMode){var o=!1;rl.each(n,function(t,e){var i=this.getSelectedMapKey(t);a[i]&&(o?a[i]=!1:o=!0)},this)}},getSelectedMapKey:function(t){return"categories"===this._mode?t.value+"":t.index+""},getPieceList:function(){return this._pieceList},_determineMode:function(){var t=this.option;return t.pieces&&t.pieces.length>0?"pieces":this.option.categories?"categories":"splitNumber"},setSelected:function(t){this.option.selected=rl.clone(t)},getValueState:function(t){var e=Kx.findPieceIndex(t,this._pieceList);return null!=e&&this.option.selected[this.getSelectedMapKey(this._pieceList[e])]?"inRange":"outOfRange"},findTargetDataIndices:function(t){var e=[];return this.eachTargetSeries(function(i){var n=[],a=i.getData();a.each(this.getDataDimension(a),function(e,i){Kx.findPieceIndex(e,this._pieceList)===t&&n.push(i)},!0,this),e.push({seriesId:i.id,dataIndex:n})},this),e},getRepresentValue:function(t){var e;if(this.isCategory())e=t.value;else if(null!=t.value)e=t.value;else{var i=t.interval||[];e=i[0]===-1/0&&i[1]===1/0?0:(i[0]+i[1])/2}return e},getVisualMeta:function(t){function e(e,o){var r=a.getRepresentValue({interval:e});o||(o=a.getValueState(r));var s=t(r,o);e[0]===-1/0?n[0]=s:e[1]===1/0?n[1]=s:i.push({value:e[0],color:s},{value:e[1],color:s})}if(!this.isCategory()){var i=[],n=[],a=this,o=this._pieceList.slice();if(o.length){var r=o[0].interval[0];r!==-1/0&&o.unshift({interval:[-1/0,r]}),(r=o[o.length-1].interval[1])!==1/0&&o.push({interval:[r,1/0]})}else o.push({interval:[-1/0,1/0]});var s=-1/0;return rl.each(o,function(t){var i=t.interval;i&&(i[0]>s&&e([s,i[0]],"outOfRange"),e(i.slice()),s=i[1])},this),{stops:i,outerColors:n}}}}),LT={splitNumber:function(){var t=this.option,e=this._pieceList,i=Math.min(t.precision,20),n=this.getExtent(),a=t.splitNumber;a=Math.max(parseInt(a,10),1),t.splitNumber=a;for(var o=(n[1]-n[0])/a;+o.toFixed(i)!==o&&i<5;)i++;t.precision=i,o=+o.toFixed(i);var r=0;t.minOpen&&e.push({index:r++,interval:[-1/0,n[0]],close:[0,0]});for(var s=n[0],l=r+a;r<l;s+=o){var h=r===a-1?n[1]:s+o;e.push({index:r++,interval:[s,h],close:[1,1]})}t.maxOpen&&e.push({index:r++,interval:[n[1],1/0],close:[0,0]}),AT(e),rl.each(e,function(t){t.text=this.formatValueText(t.interval)},this)},categories:function(){var t=this.option;rl.each(t.categories,function(t){this._pieceList.push({text:this.formatValueText(t,!0),value:t})},this),$r(t,this._pieceList)},pieces:function(){var t=this.option,e=this._pieceList;rl.each(t.pieces,function(t,i){rl.isObject(t)||(t={value:t});var n={text:"",index:i};if(null!=t.label&&(n.text=t.label),t.hasOwnProperty("value")){var a=n.value=t.value;n.interval=[a,a],n.close=[1,1]}else{for(var o=n.interval=[],r=n.close=[0,0],s=[1,0,1],l=[-1/0,1/0],h=[],u=0;u<2;u++){for(var c=[["gte","gt","min"],["lte","lt","max"]][u],d=0;d<3&&null==o[u];d++)o[u]=t[c[d]],r[u]=s[d],h[u]=2===d;null==o[u]&&(o[u]=l[u])}h[0]&&o[1]===1/0&&(r[0]=0),h[1]&&o[0]===-1/0&&(r[1]=0),o[0]===o[1]&&r[0]&&r[1]&&(n.value=o[0])}n.visual=Kx.retrieveVisuals(t),e.push(n)},this),$r(t,e),AT(e),rl.each(e,function(t){var e=t.close,i=[["<","≤"][e[1]],[">","≥"][e[0]]];t.text=t.text||this.formatValueText(null!=t.value?t.value:t.interval,!1,i)},this)}},DT=Ug.createSymbol;vT.extend({type:"visualMap.piecewise",doRender:function(){var t=this.group;t.removeAll();var e=this.visualMapModel,i=e.get("textGap"),n=e.textStyleModel,a=n.getFont(),o=n.getTextColor(),r=this._getItemAlign(),s=e.itemSize,l=this._getViewData(),h=l.endsText,u=rl.retrieve(e.get("showLabel",!0),!h);h&&this._renderEndsText(t,h[0],s,u,r),rl.each(l.viewPieceList,function(n){var l=n.piece,h=new fp.Group;h.onclick=rl.bind(this._onItemClick,this,l),this._enableHoverLink(h,n.indexInModelPieceList);var c=e.getRepresentValue(l);if(this._createItemSymbol(h,c,[0,0,s[0],s[1]]),u){var d=this.visualMapModel.getValueState(c);h.add(new fp.Text({style:{x:"right"===r?-i:s[0]+i,y:s[1]/2,text:l.text,textVerticalAlign:"middle",textAlign:r,textFont:a,textFill:o,opacity:"outOfRange"===d?.5:1}}))}t.add(h)},this),h&&this._renderEndsText(t,h[1],s,u,r),Np.box(e.get("orient"),t,e.get("itemGap")),this.renderBackground(t),this.positionGroup(t)},_enableHoverLink:function(t,e){function i(t){var i=this.visualMapModel;i.option.hoverLink&&this.api.dispatchAction({type:t,batch:xT.convertDataIndex(i.findTargetDataIndices(e))})}t.on("mouseover",rl.bind(i,this,"highlight")).on("mouseout",rl.bind(i,this,"downplay"))},_getItemAlign:function(){var t=this.visualMapModel,e=t.option;if("vertical"===e.orient)return xT.getItemAlign(t,this.api,t.itemSize);var i=e.align;return i&&"auto"!==i||(i="left"),i},_renderEndsText:function(t,e,i,n,a){if(e){var o=new fp.Group,r=this.visualMapModel.textStyleModel;o.add(new fp.Text({style:{x:n?"right"===a?i[0]:0:i[0]/2,y:i[1]/2,textVerticalAlign:"middle",textAlign:n?a:"center",text:e,textFont:r.getFont(),textFill:r.getTextColor()}})),t.add(o)}},_getViewData:function(){var t=this.visualMapModel,e=rl.map(t.getPieceList(),function(t,e){return{piece:t,indexInModelPieceList:e}}),i=t.get("text"),n=t.get("orient"),a=t.get("inverse");return("horizontal"===n?a:!a)?e.reverse():i&&(i=i.slice().reverse()),{viewPieceList:e,endsText:i}},_createItemSymbol:function(t,e,i){t.add(DT(this.getControllerVisual(e,"symbol"),i[0],i[1],i[2],i[3],this.getControllerVisual(e,"color")))},_onItemClick:function(t){var e=this.visualMapModel,i=e.option,n=rl.clone(i.selected),a=e.getSelectedMapKey(t);"single"===i.selectedMode?(n[a]=!0,rl.each(n,function(t,e){n[e]=e===a})):n[a]=!n[a],this.api.dispatchAction({type:"selectDataRange",from:this.uid,visualMapId:this.visualMapModel.id,selected:n})}});ym.registerPreprocessor(iT);var PT=Eu.addCommas,kT=Eu.encodeHTML,OT=ym.extendComponentModel({type:"marker",dependencies:["series","grid","polar","geo"],init:function(t,e,i,n){this.mergeDefaultAndTheme(t,i),this.mergeOption(t,i,n.createdBySelf,!0)},isAnimationEnabled:function(){if(Us.node)return!1;var t=this.__hostSeries;return this.getShallow("animation")&&t&&t.isAnimationEnabled()},mergeOption:function(t,e,i,n){var a=this.constructor,o=this.mainType+"Model";i||e.eachSeries(function(t){var i=t.get(this.mainType),r=t[o];i&&i.data?(r?r.mergeOption(i,e,!0):(n&&Kr(i),rl.each(i.data,function(t){t instanceof Array?(Kr(t[0]),Kr(t[1])):Kr(t)}),r=new a(i,this,e),rl.extend(r,{mainType:this.mainType,seriesIndex:t.seriesIndex,name:t.name,createdBySelf:!0}),r.__hostSeries=t),t[o]=r):t[o]=null},this)},formatTooltip:function(t){var e=this.getData(),i=this.getRawValue(t),n=rl.isArray(i)?rl.map(i,PT).join(", "):PT(i),a=e.getName(t),o=kT(this.name);return(null!=i||a)&&(o+="<br />"),a&&(o+=kT(a),null!=i&&(o+=" : ")),null!=i&&(o+=kT(n)),o},getData:function(){return this._data},setData:function(t){this._data=t}});rl.mixin(OT,Ip.dataFormatMixin);var zT=OT,ET=(zT.extend({type:"markPoint",defaultOption:{zlevel:0,z:5,symbol:"pin",symbolSize:50,tooltip:{trigger:"item"},label:{normal:{show:!0,position:"inside"},emphasis:{show:!0}},itemStyle:{normal:{borderWidth:2}}}}),rl.indexOf),RT=rl.curry,NT={min:RT(Jr,"min"),max:RT(Jr,"max"),average:RT(Jr,"average")},VT={dataTransform:function(t,e){var i=t.getData(),n=t.coordinateSystem;if(e&&!function(t){return!isNaN(parseFloat(t.x))&&!isNaN(parseFloat(t.y))}(e)&&!rl.isArray(e.coord)&&n){var a=n.dimensions,o=Qr(e,i,n,t);if((e=rl.clone(e)).type&&NT[e.type]&&o.baseAxis&&o.valueAxis){var r=ET(a,o.baseAxis.dim),s=ET(a,o.valueAxis.dim);e.coord=NT[e.type](i,o.baseDataDim,o.valueDataDim,r,s),e.value=e.coord[s]}else{for(var l=[null!=e.xAxis?e.xAxis:e.radiusAxis,null!=e.yAxis?e.yAxis:e.angleAxis],h=0;h<2;h++)if(NT[l[h]]){var u=t.coordDimToDataDim(a[h])[0];l[h]=ts(i,u,l[h])}e.coord=l}}return e},getAxisInfo:Qr,dataFilter:function(t,e){return!(t&&t.containData&&e.coord&&!function(t){return!(isNaN(parseFloat(t.x))&&isNaN(parseFloat(t.y)))}(e))||t.containData(e.coord)},dimValueGetter:function(t,e,i,n){return n<2?t.coord&&t.coord[n]:t.value},numCalculate:ts},BT=ym.extendComponentView({type:"marker",init:function(){this.markerGroupMap=rl.createHashMap()},render:function(t,e,i){var n=this.markerGroupMap;n.each(function(t){t.__keep=!1});var a=this.type+"Model";e.eachSeries(function(t){var n=t[a];n&&this.renderSeries(t,n,e,i)},this),n.each(function(t){!t.__keep&&this.group.remove(t.group)},this)},renderSeries:function(){}});BT.extend({type:"markPoint",updateLayout:function(t,e,i){e.eachSeries(function(t){var e=t.markPointModel;e&&(es(e.getData(),t,i),this.markerGroupMap.get(t.id).updateLayout(e))},this)},renderSeries:function(t,e,i,n){var a=t.coordinateSystem,o=t.id,r=t.getData(),s=this.markerGroupMap,l=s.get(o)||s.set(o,new Pm),h=function(t,e,i){var n;n=t?rl.map(t&&t.dimensions,function(t){var i=e.getData().getDimensionInfo(e.coordDimToDataDim(t)[0])||{};return i.name=t,i}):[{name:"value",type:"float"}];var a=new tg(n,i),o=rl.map(i.get("data"),rl.curry(VT.dataTransform,e));return t&&(o=rl.filter(o,rl.curry(VT.dataFilter,t))),a.initData(o,null,t?VT.dimValueGetter:function(t){return t.value}),a}(a,t,e);e.setData(h),es(e.getData(),t,n),h.each(function(t){var i=h.getItemModel(t),n=i.getShallow("symbolSize");"function"==typeof n&&(n=n(e.getRawValue(t),e.getDataParams(t))),h.setItemVisual(t,{symbolSize:n,color:i.get("itemStyle.normal.color")||r.getVisual("color"),symbol:i.getShallow("symbol")})}),l.updateData(h),this.group.add(l.group),h.eachItemGraphicEl(function(t){t.traverse(function(t){t.dataModel=e})}),l.__keep=!0,l.group.silent=e.get("silent")||t.get("silent")}});ym.registerPreprocessor(function(t){t.markPoint=t.markPoint||{}});zT.extend({type:"markLine",defaultOption:{zlevel:0,z:5,symbol:["circle","arrow"],symbolSize:[8,16],precision:2,tooltip:{trigger:"item"},label:{normal:{show:!0,position:"end"},emphasis:{show:!0}},lineStyle:{normal:{type:"dashed"},emphasis:{width:3}},animationEasing:"linear"}});var GT=function(t,e,i,n){var a=t.getData(),o=n.type;if(!rl.isArray(n)&&("min"===o||"max"===o||"average"===o||null!=n.xAxis||null!=n.yAxis)){var r,s;if(null!=n.yAxis||null!=n.xAxis)r=null!=n.yAxis?"y":"x",e.getAxis(r),s=rl.retrieve(n.yAxis,n.xAxis);else{var l=VT.getAxisInfo(n,a,e,t);r=l.valueDataDim,l.valueAxis,s=VT.numCalculate(a,r,o)}var h="x"===r?0:1,u=1-h,c=rl.clone(n),d={};c.type=null,c.coord=[],d.coord=[],c.coord[u]=-1/0,d.coord[u]=1/0;var p=i.get("precision");p>=0&&"number"==typeof s&&(s=+s.toFixed(Math.min(p,20))),c.coord[h]=d.coord[h]=s,n=[c,d,{type:o,valueIndex:n.valueIndex,value:s}]}return n=[VT.dataTransform(t,n[0]),VT.dataTransform(t,n[1]),rl.extend({},n[2])],n[2].type=n[2].type||"",rl.merge(n[2],n[0]),rl.merge(n[2],n[1]),n};BT.extend({type:"markLine",updateLayout:function(t,e,i){e.eachSeries(function(t){var e=t.markLineModel;if(e){var n=e.getData(),a=e.__from,o=e.__to;a.each(function(e){as(a,e,!0,t,i),as(o,e,!1,t,i)}),n.each(function(t){n.setItemLayout(t,[a.getItemLayout(t),o.getItemLayout(t)])}),this.markerGroupMap.get(t.id).updateLayout()}},this)},renderSeries:function(t,e,i,n){function a(e,i,a){var o=e.getItemModel(i);as(e,i,a,t,n),e.setItemVisual(i,{symbolSize:o.get("symbolSize")||g[a?0:1],symbol:o.get("symbol",!0)||f[a?0:1],color:o.get("itemStyle.normal.color")||s.getVisual("color")})}var o=t.coordinateSystem,r=t.id,s=t.getData(),l=this.markerGroupMap,h=l.get(r)||l.set(r,new C_);this.group.add(h.group);var u=function(t,e,i){var n;n=t?rl.map(t&&t.dimensions,function(t){var i=e.getData().getDimensionInfo(e.coordDimToDataDim(t)[0])||{};return i.name=t,i}):[{name:"value",type:"float"}];var a=new tg(n,i),o=new tg(n,i),r=new tg([],i),s=rl.map(i.get("data"),rl.curry(GT,e,t,i));t&&(s=rl.filter(s,rl.curry(function(t,e){if("cartesian2d"===t.type){var i=e[0].coord,n=e[1].coord;if(i&&n&&(ns(1,i,n,t)||ns(0,i,n,t)))return!0}return VT.dataFilter(t,e[0])&&VT.dataFilter(t,e[1])},t)));var l=t?VT.dimValueGetter:function(t){return t.value};return a.initData(rl.map(s,function(t){return t[0]}),null,l),o.initData(rl.map(s,function(t){return t[1]}),null,l),r.initData(rl.map(s,function(t){return t[2]})),r.hasItemOption=!0,{from:a,to:o,line:r}}(o,t,e),c=u.from,d=u.to,p=u.line;e.__from=c,e.__to=d,e.setData(p);var f=e.get("symbol"),g=e.get("symbolSize");rl.isArray(f)||(f=[f,f]),"number"==typeof g&&(g=[g,g]),u.from.each(function(t){a(c,t,!0),a(d,t,!1)}),p.each(function(t){var e=p.getItemModel(t).get("lineStyle.normal.color");p.setItemVisual(t,{color:e||c.getItemVisual(t,"color")}),p.setItemLayout(t,[c.getItemLayout(t),d.getItemLayout(t)]),p.setItemVisual(t,{fromSymbolSize:c.getItemVisual(t,"symbolSize"),fromSymbol:c.getItemVisual(t,"symbol"),toSymbolSize:d.getItemVisual(t,"symbolSize"),toSymbol:d.getItemVisual(t,"symbol")})}),h.updateData(p),u.line.eachItemGraphicEl(function(t,i){t.traverse(function(t){t.dataModel=e})}),h.__keep=!0,h.group.silent=e.get("silent")||t.get("silent")}});ym.registerPreprocessor(function(t){t.markLine=t.markLine||{}});zT.extend({type:"markArea",defaultOption:{zlevel:0,z:1,tooltip:{trigger:"item"},animation:!1,label:{normal:{show:!0,position:"top"},emphasis:{show:!0,position:"top"}},itemStyle:{normal:{borderWidth:0}}}});var HT=function(t,e,i,n){var a=VT.dataTransform(t,n[0]),o=VT.dataTransform(t,n[1]),r=rl.retrieve,s=a.coord,l=o.coord;s[0]=r(s[0],-1/0),s[1]=r(s[1],-1/0),l[0]=r(l[0],1/0),l[1]=r(l[1],1/0);var h=rl.mergeAll([{},a,o]);return h.coord=[a.coord,o.coord],h.x0=a.x,h.y0=a.y,h.x1=o.x,h.y1=o.y,h},WT=[["x0","y0"],["x1","y0"],["x1","y1"],["x0","y1"]];BT.extend({type:"markArea",updateLayout:function(t,e,i){e.eachSeries(function(t){var e=t.markAreaModel;if(e){var n=e.getData();n.each(function(e){var a=rl.map(WT,function(a){return ss(n,e,a,t,i)});n.setItemLayout(e,a);n.getItemGraphicEl(e).setShape("points",a)})}},this)},renderSeries:function(t,e,i,n){var a=t.coordinateSystem,o=t.name,r=t.getData(),s=this.markerGroupMap,l=s.get(o)||s.set(o,{group:new fp.Group});this.group.add(l.group),l.__keep=!0;var h=function(t,e,i){var n,a;t?(n=rl.map(t&&t.dimensions,function(t){var i=e.getData().getDimensionInfo(e.coordDimToDataDim(t)[0])||{};return i.name=t,i}),a=new tg(rl.map(["x0","y0","x1","y1"],function(t,e){return{name:t,type:n[e%2].type}}),i)):a=new tg(n=[{name:"value",type:"float"}],i);var o=rl.map(i.get("data"),rl.curry(HT,e,t,i));t&&(o=rl.filter(o,rl.curry(function(t,e){var i=e.coord[0],n=e.coord[1];return!("cartesian2d"!==t.type||!i||!n||!rs(1,i,n)&&!rs(0,i,n))||VT.dataFilter(t,{coord:i,x:e.x0,y:e.y0})||VT.dataFilter(t,{coord:n,x:e.x1,y:e.y1})},t)));var r=t?function(t,e,i,n){return t.coord[Math.floor(n/2)][n%2]}:function(t){return t.value};return a.initData(o,null,r),a.hasItemOption=!0,a}(a,t,e);e.setData(h),h.each(function(e){h.setItemLayout(e,rl.map(WT,function(i){return ss(h,e,i,t,n)})),h.setItemVisual(e,{color:r.getVisual("color")})}),h.diff(l.__data).add(function(t){var e=new fp.Polygon({shape:{points:h.getItemLayout(t)}});h.setItemGraphicEl(t,e),l.group.add(e)}).update(function(t,i){var n=l.__data.getItemGraphicEl(i);fp.updateProps(n,{shape:{points:h.getItemLayout(t)}},e,t),l.group.add(n),h.setItemGraphicEl(t,n)}).remove(function(t){var e=l.__data.getItemGraphicEl(t);l.group.remove(e)}).execute(),h.eachItemGraphicEl(function(t,i){var n=h.getItemModel(i),a=n.getModel("label.normal"),o=n.getModel("label.emphasis"),r=h.getItemVisual(i,"color");t.useStyle(rl.defaults(n.getModel("itemStyle.normal").getItemStyle(),{fill:Nl.modifyAlpha(r,.4),stroke:r})),t.hoverStyle=n.getModel("itemStyle.emphasis").getItemStyle(),fp.setLabelStyle(t.style,t.hoverStyle,a,o,{labelFetcher:e,labelDataIndex:i,defaultText:h.getName(i)||"",isRectText:!0,autoColor:r}),fp.setHoverStyle(t,{}),t.dataModel=e}),l.__data=h,l.group.silent=e.get("silent")||t.get("silent")}}),ym.registerPreprocessor(function(t){t.markArea=t.markArea||{}});var FT=function(t){var e=t&&t.timeline;rl.isArray(e)||(e=e?[e]:[]),rl.each(e,function(t){t&&function(t){var e=t.type,i={number:"value",time:"time"};if(i[e]&&(t.axisType=i[e],delete t.type),ls(t),hs(t,"controlPosition")){var n=t.controlStyle||(t.controlStyle={});hs(n,"position")||(n.position=t.controlPosition),"none"!==n.position||hs(n,"show")||(n.show=!1,delete n.position),delete t.controlPosition}rl.each(t.data||[],function(t){rl.isObject(t)&&!rl.isArray(t)&&(!hs(t,"value")&&hs(t,"name")&&(t.value=t.name),ls(t))})}(t)})};Hp.registerSubTypeDefaulter("timeline",function(){return"slider"}),ym.registerAction({type:"timelineChange",event:"timelineChanged",update:"prepareAndUpdate"},function(t,e){var i=e.getComponent("timeline");return i&&null!=t.currentIndex&&(i.setCurrentIndex(t.currentIndex),!i.get("loop",!0)&&i.isIndexMax()&&i.setPlayState(!1)),e.resetOption("timeline"),rl.defaults({currentIndex:i.option.currentIndex},t)}),ym.registerAction({type:"timelinePlayChange",event:"timelinePlayChanged",update:"update"},function(t,e){var i=e.getComponent("timeline");i&&null!=t.playState&&i.setPlayState(t.playState)});var ZT=Hp.extend({type:"timeline",layoutMode:"box",defaultOption:{zlevel:0,z:4,show:!0,axisType:"time",realtime:!0,left:"20%",top:null,right:"20%",bottom:0,width:null,height:40,padding:5,controlPosition:"left",autoPlay:!1,rewind:!1,loop:!0,playInterval:2e3,currentIndex:0,itemStyle:{normal:{},emphasis:{}},label:{normal:{color:"#000"},emphasis:{}},data:[]},init:function(t,e,i){this._data,this._names,this.mergeDefaultAndTheme(t,i),this._initData()},mergeOption:function(t){ZT.superApply(this,"mergeOption",arguments),this._initData()},setCurrentIndex:function(t){null==t&&(t=this.option.currentIndex);var e=this._data.count();this.option.loop?t=(t%e+e)%e:(t>=e&&(t=e-1),t<0&&(t=0)),this.option.currentIndex=t},getCurrentIndex:function(){return this.option.currentIndex},isIndexMax:function(){return this.getCurrentIndex()>=this._data.count()-1},setPlayState:function(t){this.option.autoPlay=!!t},getPlayState:function(){return!!this.option.autoPlay},_initData:function(){var t=this.option,e=t.data||[],i=t.axisType,n=this._names=[];if("category"===i){var a=[];rl.each(e,function(t,e){var i,o=Ip.getDataItemValue(t);rl.isObject(t)?(i=rl.clone(t)).value=e:i=e,a.push(i),rl.isString(o)||null!=o&&!isNaN(o)||(o=""),n.push(o+"")}),e=a}var o={category:"ordinal",time:"time"}[i]||"number";(this._data=new tg([{name:"value",type:o}],this)).initData(e,n)},getData:function(){return this._data},getCategories:function(){if("category"===this.get("axisType"))return this._names.slice()}}),jT=ZT.extend({type:"timeline.slider",defaultOption:{backgroundColor:"rgba(0,0,0,0)",borderColor:"#ccc",borderWidth:0,orient:"horizontal",inverse:!1,tooltip:{trigger:"item"},symbol:"emptyCircle",symbolSize:10,lineStyle:{show:!0,width:2,color:"#304654"},label:{position:"auto",normal:{show:!0,interval:"auto",rotate:0,color:"#304654"},emphasis:{show:!0,color:"#c23531"}},itemStyle:{normal:{color:"#304654",borderWidth:1},emphasis:{color:"#c23531"}},checkpointStyle:{symbol:"circle",symbolSize:13,color:"#c23531",borderWidth:5,borderColor:"rgba(194,53,49, 0.5)",animation:!0,animationDuration:300,animationEasing:"quinticInOut"},controlStyle:{show:!0,showPlayBtn:!0,showPrevBtn:!0,showNextBtn:!0,itemSize:22,itemGap:12,position:"left",playIcon:"path://M31.6,53C17.5,53,6,41.5,6,27.4S17.5,1.8,31.6,1.8C45.7,1.8,57.2,13.3,57.2,27.4S45.7,53,31.6,53z M31.6,3.3 C18.4,3.3,7.5,14.1,7.5,27.4c0,13.3,10.8,24.1,24.1,24.1C44.9,51.5,55.7,40.7,55.7,27.4C55.7,14.1,44.9,3.3,31.6,3.3z M24.9,21.3 c0-2.2,1.6-3.1,3.5-2l10.5,6.1c1.899,1.1,1.899,2.9,0,4l-10.5,6.1c-1.9,1.1-3.5,0.2-3.5-2V21.3z",stopIcon:"path://M30.9,53.2C16.8,53.2,5.3,41.7,5.3,27.6S16.8,2,30.9,2C45,2,56.4,13.5,56.4,27.6S45,53.2,30.9,53.2z M30.9,3.5C17.6,3.5,6.8,14.4,6.8,27.6c0,13.3,10.8,24.1,24.101,24.1C44.2,51.7,55,40.9,55,27.6C54.9,14.4,44.1,3.5,30.9,3.5z M36.9,35.8c0,0.601-0.4,1-0.9,1h-1.3c-0.5,0-0.9-0.399-0.9-1V19.5c0-0.6,0.4-1,0.9-1H36c0.5,0,0.9,0.4,0.9,1V35.8z M27.8,35.8 c0,0.601-0.4,1-0.9,1h-1.3c-0.5,0-0.9-0.399-0.9-1V19.5c0-0.6,0.4-1,0.9-1H27c0.5,0,0.9,0.4,0.9,1L27.8,35.8L27.8,35.8z",nextIcon:"path://M18.6,50.8l22.5-22.5c0.2-0.2,0.3-0.4,0.3-0.7c0-0.3-0.1-0.5-0.3-0.7L18.7,4.4c-0.1-0.1-0.2-0.3-0.2-0.5 c0-0.4,0.3-0.8,0.8-0.8c0.2,0,0.5,0.1,0.6,0.3l23.5,23.5l0,0c0.2,0.2,0.3,0.4,0.3,0.7c0,0.3-0.1,0.5-0.3,0.7l-0.1,0.1L19.7,52 c-0.1,0.1-0.3,0.2-0.5,0.2c-0.4,0-0.8-0.3-0.8-0.8C18.4,51.2,18.5,51,18.6,50.8z",prevIcon:"path://M43,52.8L20.4,30.3c-0.2-0.2-0.3-0.4-0.3-0.7c0-0.3,0.1-0.5,0.3-0.7L42.9,6.4c0.1-0.1,0.2-0.3,0.2-0.5 c0-0.4-0.3-0.8-0.8-0.8c-0.2,0-0.5,0.1-0.6,0.3L18.3,28.8l0,0c-0.2,0.2-0.3,0.4-0.3,0.7c0,0.3,0.1,0.5,0.3,0.7l0.1,0.1L41.9,54 c0.1,0.1,0.3,0.2,0.5,0.2c0.4,0,0.8-0.3,0.8-0.8C43.2,53.2,43.1,53,43,52.8z",normal:{color:"#304654",borderColor:"#304654",borderWidth:1},emphasis:{color:"#c23531",borderColor:"#c23531",borderWidth:2}},data:[]}});rl.mixin(jT,Ip.dataFormatMixin);var UT=Nf.extend({type:"timeline"}),qT=function(t,e,i,n){Kg.call(this,t,e,i),this.type=n||"value",this._autoLabelInterval,this.model=null};qT.prototype={constructor:qT,getLabelInterval:function(){var t=this.model,e=t.getModel("label.normal"),i=e.get("interval");if(null!=i&&"auto"!=i)return i;return(i=this._autoLabelInterval)||(i=this._autoLabelInterval=Rg.getAxisLabelInterval(rl.map(this.scale.getTicks(),this.dataToCoord,this),Rg.getFormattedLabels(this,e.get("formatter")),e.getFont(),"horizontal"===t.get("orient")?0:90,e.get("rotate"))),i},isLabelIgnored:function(t){if("category"===this.type){var e=this.getLabelInterval();return"function"==typeof e&&!e(t,this.scale.getLabel(t))||t%(e+1)}}},rl.inherits(qT,Kg);var XT=qT,YT=Ug.createSymbol,$T=Eu.encodeHTML,KT=rl.bind,JT=rl.each,QT=Math.PI;UT.extend({type:"timeline.slider",init:function(t,e){this.api=e,this._axis,this._viewRect,this._timer,this._currentPointer,this._mainGroup,this._labelGroup},render:function(t,e,i,n){if(this.model=t,this.api=i,this.ecModel=e,this.group.removeAll(),t.get("show",!0)){var a=this._layout(t,i),o=this._createGroup("mainGroup"),r=this._createGroup("labelGroup"),s=this._axis=this._createAxis(a,t);t.formatTooltip=function(t){return $T(s.scale.getLabel(t))},JT(["AxisLine","AxisTick","Control","CurrentPointer"],function(e){this["_render"+e](a,o,s,t)},this),this._renderAxisLabel(a,r,s,t),this._position(a,t)}this._doPlayStop()},remove:function(){this._clearTimer(),this.group.removeAll()},dispose:function(){this._clearTimer()},_layout:function(t,e){var i=t.get("label.normal.position"),n=t.get("orient"),a=function(t,e){return Np.getLayoutRect(t.getBoxLayoutParams(),{width:e.getWidth(),height:e.getHeight()},t.get("padding"))}(t,e);null==i||"auto"===i?i="horizontal"===n?a.y+a.height/2<e.getHeight()/2?"-":"+":a.x+a.width/2<e.getWidth()/2?"+":"-":isNaN(i)&&(i={horizontal:{top:"-",bottom:"+"},vertical:{left:"-",right:"+"}}[n][i]);var o={horizontal:"center",vertical:i>=0||"+"===i?"left":"right"},r={horizontal:i>=0||"+"===i?"top":"bottom",vertical:"middle"},s={horizontal:0,vertical:QT/2},l="vertical"===n?a.height:a.width,h=t.getModel("controlStyle"),u=h.get("show"),c=u?h.get("itemSize"):0,d=u?h.get("itemGap"):0,p=c+d,f=t.get("label.normal.rotate")||0;f=f*QT/180;var g,m,v,y,x=h.get("position",!0),_=(u=h.get("show",!0))&&h.get("showPlayBtn",!0),b=u&&h.get("showPrevBtn",!0),w=u&&h.get("showNextBtn",!0),S=0,M=l;return"left"===x||"bottom"===x?(_&&(g=[0,0],S+=p),b&&(m=[S,0],S+=p),w&&(v=[M-c,0],M-=p)):(_&&(g=[M-c,0],M-=p),b&&(m=[0,0],S+=p),w&&(v=[M-c,0],M-=p)),y=[S,M],t.get("inverse")&&y.reverse(),{viewRect:a,mainLength:l,orient:n,rotation:s[n],labelRotation:f,labelPosOpt:i,labelAlign:t.get("label.normal.align")||o[n],labelBaseline:t.get("label.normal.verticalAlign")||t.get("label.normal.baseline")||r[n],playPosition:g,prevBtnPosition:m,nextBtnPosition:v,axisExtent:y,controlSize:c,controlGap:d}},_position:function(t,e){function i(t){var e=t.position;t.origin=[c[0][0]-e[0],c[1][0]-e[1]]}function n(t){return[[t.x,t.x+t.width],[t.y,t.y+t.height]]}function a(t,e,i,n,a){t[n]+=i[n][a]-e[n][a]}var o=this._mainGroup,r=this._labelGroup,s=t.viewRect;if("vertical"===t.orient){var l=yl.create(),h=s.x,u=s.y+s.height;yl.translate(l,l,[-h,-u]),yl.rotate(l,l,-QT/2),yl.translate(l,l,[h,u]),(s=s.clone()).applyTransform(l)}var c=n(s),d=n(o.getBoundingRect()),p=n(r.getBoundingRect()),f=o.position,g=r.position;g[0]=f[0]=c[0][0];var m=t.labelPosOpt;if(isNaN(m)){a(f,d,c,1,v="+"===m?0:1),a(g,p,c,1,1-v)}else{var v=m>=0?0:1;a(f,d,c,1,v),g[1]=f[1]+m}o.attr("position",f),r.attr("position",g),o.rotation=r.rotation=t.rotation,i(o),i(r)},_createAxis:function(t,e){var i=e.getData(),n=e.get("axisType"),a=Rg.createScaleByModel(e,n),o=i.getDataExtent("value");a.setExtent(o[0],o[1]),this._customizeScale(a,i),a.niceTicks();var r=new XT("value",a,t.axisExtent,n);return r.model=e,r},_customizeScale:function(t,e){t.getTicks=function(){return e.mapArray(["value"],function(t){return t})},t.getTicksLabels=function(){return rl.map(this.getTicks(),t.getLabel,t)}},_createGroup:function(t){var e=this["_"+t]=new fp.Group;return this.group.add(e),e},_renderAxisLine:function(t,e,i,n){var a=i.getExtent();n.get("lineStyle.show")&&e.add(new fp.Line({shape:{x1:a[0],y1:0,x2:a[1],y2:0},style:rl.extend({lineCap:"round"},n.getModel("lineStyle").getLineStyle()),silent:!0,z2:1}))},_renderAxisTick:function(t,e,i,n){var a=n.getData(),o=i.scale.getTicks();JT(o,function(t,o){var r=i.dataToCoord(t),s=a.getItemModel(o),l=s.getModel("itemStyle.normal"),h=s.getModel("itemStyle.emphasis"),u={position:[r,0],onclick:KT(this._changeTimeline,this,o)},c=us(s,l,e,u);fp.setHoverStyle(c,h.getItemStyle()),s.get("tooltip")?(c.dataIndex=o,c.dataModel=n):c.dataIndex=c.dataModel=null},this)},_renderAxisLabel:function(t,e,i,n){var a=n.getModel("label.normal");if(a.get("show")){var o=n.getData(),r=i.scale.getTicks(),s=Rg.getFormattedLabels(i,a.get("formatter")),l=i.getLabelInterval();JT(r,function(n,a){if(!i.isLabelIgnored(a,l)){var r=o.getItemModel(a),h=r.getModel("label.normal"),u=r.getModel("label.emphasis"),c=i.dataToCoord(n),d=new fp.Text({position:[c,0],rotation:t.labelRotation-t.rotation,onclick:KT(this._changeTimeline,this,a),silent:!1});fp.setTextStyle(d.style,h,{text:s[a],textAlign:t.labelAlign,textVerticalAlign:t.labelBaseline}),e.add(d),fp.setHoverStyle(d,fp.setTextStyle({},u))}},this)}},_renderControl:function(t,e,i,n){function a(t,i,a,u){if(t){var c=function(t,e,i,n){return fp.makePath(t.get(e).replace(/^path:\/\//,""),rl.clone(n||{}),new oh(i[0],i[1],i[2],i[3]),"center")}(n,i,h,{position:t,origin:[o/2,0],rotation:u?-r:0,rectHover:!0,style:s,onclick:a});e.add(c),fp.setHoverStyle(c,l)}}var o=t.controlSize,r=t.rotation,s=n.getModel("controlStyle.normal").getItemStyle(),l=n.getModel("controlStyle.emphasis").getItemStyle(),h=[0,-o/2,o,o],u=n.getPlayState(),c=n.get("inverse",!0);a(t.nextBtnPosition,"controlStyle.nextIcon",KT(this._changeTimeline,this,c?"-":"+")),a(t.prevBtnPosition,"controlStyle.prevIcon",KT(this._changeTimeline,this,c?"+":"-")),a(t.playPosition,"controlStyle."+(u?"stopIcon":"playIcon"),KT(this._handlePlayClick,this,!u),!0)},_renderCurrentPointer:function(t,e,i,n){var a=n.getData(),o=n.getCurrentIndex(),r=a.getItemModel(o).getModel("checkpointStyle"),s=this,l={onCreate:function(t){t.draggable=!0,t.drift=KT(s._handlePointerDrag,s),t.ondragend=KT(s._handlePointerDragend,s),cs(t,o,i,n,!0)},onUpdate:function(t){cs(t,o,i,n)}};this._currentPointer=us(r,r,this._mainGroup,{},this._currentPointer,l)},_handlePlayClick:function(t){this._clearTimer(),this.api.dispatchAction({type:"timelinePlayChange",playState:t,from:this.uid})},_handlePointerDrag:function(t,e,i){this._clearTimer(),this._pointerChangeTimeline([i.offsetX,i.offsetY])},_handlePointerDragend:function(t){this._pointerChangeTimeline([t.offsetX,t.offsetY],!0)},_pointerChangeTimeline:function(t,e){var i=this._toAxisCoord(t)[0],n=this._axis,a=Pu.asc(n.getExtent().slice());i>a[1]&&(i=a[1]),i<a[0]&&(i=a[0]),this._currentPointer.position[0]=i,this._currentPointer.dirty();var o=this._findNearestTick(i),r=this.model;(e||o!==r.getCurrentIndex()&&r.get("realtime"))&&this._changeTimeline(o)},_doPlayStop:function(){this._clearTimer(),this.model.getPlayState()&&(this._timer=setTimeout(KT(function(){var t=this.model;this._changeTimeline(t.getCurrentIndex()+(t.get("rewind",!0)?-1:1))},this),this.model.get("playInterval")))},_toAxisCoord:function(t){var e=this._mainGroup.getLocalTransform();return fp.applyTransform(t,e,!0)},_findNearestTick:function(t){var e,i=this.model.getData(),n=1/0,a=this._axis;return i.each(["value"],function(i,o){var r=a.dataToCoord(i),s=Math.abs(r-t);s<n&&(n=s,e=o)}),e},_clearTimer:function(){this._timer&&(clearTimeout(this._timer),this._timer=null)},_changeTimeline:function(t){var e=this.model.getCurrentIndex();"+"===t?t=e+1:"-"===t&&(t=e-1),this.api.dispatchAction({type:"timelineChange",currentIndex:t,from:this.uid})}});ym.registerPreprocessor(FT);var tA=ym.extendComponentModel({type:"toolbox",layoutMode:{type:"box",ignoreSize:!0},mergeDefaultAndTheme:function(t){tA.superApply(this,"mergeDefaultAndTheme",arguments),rl.each(this.option.feature,function(t,e){var i=xI.get(e);i&&rl.merge(t,i.defaultOption)})},defaultOption:{show:!0,z:6,zlevel:0,orient:"horizontal",left:"right",top:"top",backgroundColor:"transparent",borderColor:"#ccc",borderRadius:0,borderWidth:0,padding:5,itemSize:15,itemGap:8,showTitle:!0,iconStyle:{normal:{borderColor:"#666",color:"none"},emphasis:{borderColor:"#3E98C5"}}}}),eA=(ym.extendComponentView({type:"toolbox",render:function(t,e,i,n){function a(a,u){var c,d=h[a],p=h[u],f=s[d],g=new _p(f,t,t.ecModel);if(d&&!p){if(function(t){return 0===t.indexOf("my")}(d))c={model:g,onclick:g.option.onclick,featureName:d};else{var m=xI.get(d);if(!m)return;c=new m(g,e,i)}l[d]=c}else{if(!(c=l[p]))return;c.model=g,c.ecModel=e,c.api=i}d||!p?g.get("show")&&!c.unusable?(!function(n,a,s){var l=n.getModel("iconStyle"),h=a.getIcons?a.getIcons():n.get("icon"),u=n.get("title")||{};if("string"==typeof h){var c=h,d=u;u={},(h={})[s]=c,u[s]=d}var p=n.iconPaths={};rl.each(h,function(s,h){var c=fp.createIcon(s,{},{x:-r/2,y:-r/2,width:r,height:r});c.setStyle(l.getModel("normal").getItemStyle()),c.hoverStyle=l.getModel("emphasis").getItemStyle(),fp.setHoverStyle(c),t.get("showTitle")&&(c.__title=u[h],c.on("mouseover",function(){var t=l.getModel("emphasis").getItemStyle();c.setStyle({text:u[h],textPosition:t.textPosition||"bottom",textFill:t.fill||t.stroke||"#000",textAlign:t.textAlign||"center"})}).on("mouseout",function(){c.setStyle({textFill:null})})),c.trigger(n.get("iconStatus."+h)||"normal"),o.add(c),c.on("click",rl.bind(a.onclick,a,e,i,h)),p[h]=c})}(g,c,d),g.setIconStatus=function(t,e){var i=this.option,n=this.iconPaths;i.iconStatus=i.iconStatus||{},i.iconStatus[t]=e,n[t]&&n[t].trigger(e)},c.render&&c.render(g,e,i,n)):c.remove&&c.remove(e,i):c.dispose&&c.dispose(e,i)}var o=this.group;if(o.removeAll(),t.get("show")){var r=+t.get("itemSize"),s=t.get("feature")||{},l=this._features||(this._features={}),h=[];rl.each(s,function(t,e){h.push(e)}),new qf(this._featureNames||[],h).add(a).update(a).remove(rl.curry(a,null)).execute(),this._featureNames=h,lM.layout(o,t,i),o.add(lM.makeBackground(o.getBoundingRect(),t)),o.eachChild(function(t){var e=t.__title,n=t.hoverStyle;if(n&&e){var a=Nh.getBoundingRect(e,Nh.makeFont(n)),s=t.position[0]+o.position[0],l=!1;t.position[1]+o.position[1]+r+a.height>i.getHeight()&&(n.textPosition="top",l=!0);var h=l?-5-a.height:r+8;s+a.width/2>i.getWidth()?(n.textPosition=["100%",h],n.textAlign="right"):s-a.width/2<0&&(n.textPosition=[0,h],n.textAlign="left")}})}},updateView:function(t,e,i,n){rl.each(this._features,function(t){t.updateView&&t.updateView(t.model,e,i,n)})},updateLayout:function(t,e,i,n){rl.each(this._features,function(t){t.updateLayout&&t.updateLayout(t.model,e,i,n)})},remove:function(t,e){rl.each(this._features,function(i){i.remove&&i.remove(t,e)}),this.group.removeAll()},dispose:function(t,e){rl.each(this._features,function(i){i.dispose&&i.dispose(t,e)})}}),_I.toolbox.saveAsImage);ds.defaultOption={show:!0,icon:"M4.7,22.9L29.3,45.5L54.7,23.4M4.6,43.6L4.6,58L53.8,58L53.8,43.6M29.2,45.1L29.2,0",title:eA.title,type:"png",name:"",excludeComponents:["toolbox"],pixelRatio:1,lang:eA.lang.slice()},ds.prototype.unusable=!Us.canvasSupported;ds.prototype.onclick=function(t,e){var i=this.model,n=i.get("name")||t.get("title.0.text")||"echarts",a=document.createElement("a"),o=i.get("type",!0)||"png";a.download=n+"."+o,a.target="_blank";var r=e.getConnectedDataURL({type:o,backgroundColor:i.get("backgroundColor",!0)||t.get("backgroundColor")||"#fff",excludeComponents:i.get("excludeComponents"),pixelRatio:i.get("pixelRatio")});if(a.href=r,"function"!=typeof MouseEvent||Us.browser.ie||Us.browser.edge)if(window.navigator.msSaveOrOpenBlob){for(var s=atob(r.split(",")[1]),l=s.length,h=new Uint8Array(l);l--;)h[l]=s.charCodeAt(l);var u=new Blob([h]);window.navigator.msSaveOrOpenBlob(u,n+"."+o)}else{var c=i.get("lang"),d='<body style="margin:0;"><img src="'+r+'" style="max-width:100%;" title="'+(c&&c[0]||"")+'" /></body>';window.open().document.write(d)}else{var p=new MouseEvent("click",{view:window,bubbles:!0,cancelable:!1});a.dispatchEvent(p)}},xI.register("saveAsImage",ds);var iA=_I.toolbox.magicType;ps.defaultOption={show:!0,type:[],icon:{line:"M4.1,28.9h7.1l9.3-22l7.4,38l9.7-19.7l3,12.8h14.9M4.1,58h51.4",bar:"M6.7,22.9h10V48h-10V22.9zM24.9,13h10v35h-10V13zM43.2,2h10v46h-10V2zM3.1,58h53.7",stack:"M8.2,38.4l-8.4,4.1l30.6,15.3L60,42.5l-8.1-4.1l-21.5,11L8.2,38.4z M51.9,30l-8.1,4.2l-13.4,6.9l-13.9-6.9L8.2,30l-8.4,4.2l8.4,4.2l22.2,11l21.5-11l8.1-4.2L51.9,30z M51.9,21.7l-8.1,4.2L35.7,30l-5.3,2.8L24.9,30l-8.4-4.1l-8.3-4.2l-8.4,4.2L8.2,30l8.3,4.2l13.9,6.9l13.4-6.9l8.1-4.2l8.1-4.1L51.9,21.7zM30.4,2.2L-0.2,17.5l8.4,4.1l8.3,4.2l8.4,4.2l5.5,2.7l5.3-2.7l8.1-4.2l8.1-4.2l8.1-4.1L30.4,2.2z",tiled:"M2.3,2.2h22.8V25H2.3V2.2z M35,2.2h22.8V25H35V2.2zM2.3,35h22.8v22.8H2.3V35z M35,35h22.8v22.8H35V35z"},title:rl.clone(iA.title),option:{},seriesIndex:{}};var nA=ps.prototype;nA.getIcons=function(){var t=this.model,e=t.get("icon"),i={};return rl.each(t.get("type"),function(t){e[t]&&(i[t]=e[t])}),i};var aA={line:function(t,e,i,n){if("bar"===t)return rl.merge({id:e,type:"line",data:i.get("data"),stack:i.get("stack"),markPoint:i.get("markPoint"),markLine:i.get("markLine")},n.get("option.line")||{},!0)},bar:function(t,e,i,n){if("line"===t)return rl.merge({id:e,type:"bar",data:i.get("data"),stack:i.get("stack"),markPoint:i.get("markPoint"),markLine:i.get("markLine")},n.get("option.bar")||{},!0)},stack:function(t,e,i,n){if("line"===t||"bar"===t)return rl.merge({id:e,stack:"__ec_magicType_stack__"},n.get("option.stack")||{},!0)},tiled:function(t,e,i,n){if("line"===t||"bar"===t)return rl.merge({id:e,stack:""},n.get("option.tiled")||{},!0)}},oA=[["line","bar"],["stack","tiled"]];nA.onclick=function(t,e,i){var n=this.model,a=n.get("seriesIndex."+i);if(aA[i]){var o={series:[]};rl.each(oA,function(t){rl.indexOf(t,i)>=0&&rl.each(t,function(t){n.setIconStatus(t,"normal")})}),n.setIconStatus(i,"emphasis"),t.eachComponent({mainType:"series",query:null==a?null:{seriesIndex:a}},function(e){var a=e.subType,r=e.id,s=aA[i](a,r,e,n);s&&(rl.defaults(s,e.option),o.series.push(s));var l=e.coordinateSystem;if(l&&"cartesian2d"===l.type&&("line"===i||"bar"===i)){var h=l.getAxesByScale("ordinal")[0];if(h){var u=h.dim+"Axis",c=t.queryComponents({mainType:u,index:e.get(name+"Index"),id:e.get(name+"Id")})[0].componentIndex;o[u]=o[u]||[];for(var d=0;d<=c;d++)o[u][c]=o[u][c]||{};o[u][c].boundaryGap="bar"===i}}}),e.dispatchAction({type:"changeMagicType",currentType:i,newOption:o})}},ym.registerAction({type:"changeMagicType",event:"magicTypeChanged",update:"prepareAndUpdate"},function(t,e){e.mergeOption(t.newOption)}),xI.register("magicType",ps);var rA=_I.toolbox.dataView,sA=new Array(60).join("-"),lA="\t",hA=new RegExp("["+lA+"]+","g");gs.defaultOption={show:!0,readOnly:!1,optionToContent:null,contentToOption:null,icon:"M17.5,17.3H33 M17.5,17.3H33 M45.4,29.5h-28 M11.5,2v56H51V14.8L38.4,2H11.5z M38.4,2.2v12.7H51 M45.4,41.7h-28",title:rl.clone(rA.title),lang:rl.clone(rA.lang),backgroundColor:"#fff",textColor:"#000",textareaColor:"#fff",textareaBorderColor:"#333",buttonColor:"#c23531",buttonTextColor:"#fff"},gs.prototype.onclick=function(t,e){function i(){n.removeChild(o),x._dom=null}var n=e.getDom(),a=this.model;this._dom&&n.removeChild(this._dom);var o=document.createElement("div");o.style.cssText="position:absolute;left:5px;top:5px;bottom:5px;right:5px;",o.style.backgroundColor=a.get("backgroundColor")||"#fff";var r=document.createElement("h4"),s=a.get("lang")||[];r.innerHTML=s[0]||a.get("title"),r.style.cssText="margin: 10px 20px;",r.style.color=a.get("textColor");var l=document.createElement("div"),h=document.createElement("textarea");l.style.cssText="display:block;width:100%;overflow:auto;";var u=a.get("optionToContent"),c=a.get("contentToOption"),d=function(t){var e=function(t){var e={},i=[],n=[];return t.eachRawSeries(function(t){var a=t.coordinateSystem;if(!a||"cartesian2d"!==a.type&&"polar"!==a.type)i.push(t);else{var o=a.getBaseAxis();if("category"===o.type){var r=o.dim+"_"+o.index;e[r]||(e[r]={categoryAxis:o,valueAxis:a.getOtherAxis(o),series:[]},n.push({axisDim:o.dim,axisIndex:o.index})),e[r].series.push(t)}else i.push(t)}}),{seriesGroupByCategoryAxis:e,other:i,meta:n}}(t);return{value:rl.filter([function(t){var e=[];return rl.each(t,function(t,i){var n=t.categoryAxis,a=t.valueAxis.dim,o=[" "].concat(rl.map(t.series,function(t){return t.name})),r=[n.model.getCategories()];rl.each(t.series,function(t){r.push(t.getRawData().mapArray(a,function(t){return t}))});for(var s=[o.join(lA)],l=0;l<r[0].length;l++){for(var h=[],u=0;u<r.length;u++)h.push(r[u][l]);s.push(h.join(lA))}e.push(s.join("\n"))}),e.join("\n\n"+sA+"\n\n")}(e.seriesGroupByCategoryAxis),function(t){return rl.map(t,function(t){var e=t.getRawData(),i=[t.name],n=[];return e.each(e.dimensions,function(){for(var t=arguments,a=arguments.length,o=arguments[a-1],r=e.getName(o),s=0;s<a-1;s++)n[s]=t[s];i.push((r?r+lA:"")+n.join(lA))}),i.join("\n")}).join("\n\n"+sA+"\n\n")}(e.other)],function(t){return t.replace(/[\n\t\s]/g,"")}).join("\n\n"+sA+"\n\n"),meta:e.meta}}(t);if("function"==typeof u){var p=u(e.getOption());"string"==typeof p?l.innerHTML=p:rl.isDom(p)&&l.appendChild(p)}else l.appendChild(h),h.readOnly=a.get("readOnly"),h.style.cssText="width:100%;height:100%;font-family:monospace;font-size:14px;line-height:1.6rem;",h.style.color=a.get("textColor"),h.style.borderColor=a.get("textareaBorderColor"),h.style.backgroundColor=a.get("textareaColor"),h.value=d.value;var f=d.meta,g=document.createElement("div");g.style.cssText="position:absolute;bottom:0;left:0;right:0;";var m="float:right;margin-right:20px;border:none;cursor:pointer;padding:2px 5px;font-size:12px;border-radius:3px",v=document.createElement("div"),y=document.createElement("div");m+=";background-color:"+a.get("buttonColor"),m+=";color:"+a.get("buttonTextColor");var x=this;su.addEventListener(v,"click",i),su.addEventListener(y,"click",function(){var t;try{t="function"==typeof c?c(l,e.getOption()):function(t,e){var i=t.split(new RegExp("\n*"+sA+"\n*","g")),n={series:[]};return rl.each(i,function(t,i){if(function(t){if(t.slice(0,t.indexOf("\n")).indexOf(lA)>=0)return!0}(t)){var a=function(e){for(var i=t.split(/\n+/g),n=fs(i.shift()).split(hA),a=[],o=rl.map(n,function(t){return{name:t,data:[]}}),r=0;r<i.length;r++){var s=fs(i[r]).split(hA);a.push(s.shift());for(var l=0;l<s.length;l++)o[l]&&(o[l].data[r]=s[l])}return{series:o,categories:a}}(),o=e[i],r=o.axisDim+"Axis";o&&(n[r]=n[r]||[],n[r][o.axisIndex]={data:a.categories},n.series=n.series.concat(a.series))}else a=function(e){for(var i=t.split(/\n+/g),n=fs(i.shift()),a=[],o=0;o<i.length;o++){var r,s=fs(i[o]).split(hA),l="",h=!1;isNaN(s[0])?(h=!0,l=s[0],s=s.slice(1),a[o]={name:l,value:[]},r=a[o].value):r=a[o]=[];for(var u=0;u<s.length;u++)r.push(+s[u]);1===r.length&&(h?a[o].value=r[0]:a[o]=r[0])}return{name:n,data:a}}(),n.series.push(a)}),n}(h.value,f)}catch(t){throw i(),new Error("Data view format error "+t)}t&&e.dispatchAction({type:"changeDataView",newOption:t}),i()}),v.innerHTML=s[1],y.innerHTML=s[2],y.style.cssText=m,v.style.cssText=m,!a.get("readOnly")&&g.appendChild(y),g.appendChild(v),su.addEventListener(h,"keydown",function(t){if(9===(t.keyCode||t.which)){var e=this.value,i=this.selectionStart,n=this.selectionEnd;this.value=e.substring(0,i)+lA+e.substring(n),this.selectionStart=this.selectionEnd=i+1,su.stop(t)}}),o.appendChild(r),o.appendChild(l),o.appendChild(g),l.style.height=n.clientHeight-80+"px",n.appendChild(o),this._dom=o},gs.prototype.remove=function(t,e){this._dom&&e.getDom().removeChild(this._dom)},gs.prototype.dispose=function(t,e){this.remove(t,e)},xI.register("dataView",gs),ym.registerAction({type:"changeDataView",event:"dataViewChanged",update:"prepareAndUpdate"},function(t,e){var i=[];rl.each(t.newOption.series,function(t){var n=e.getSeriesByName(t.name)[0];if(n){var a=n.get("data");i.push({name:t.name,data:function(t,e){return rl.map(t,function(t,i){var n=e&&e[i];return rl.isObject(n)&&!rl.isArray(n)?(rl.isObject(t)&&!rl.isArray(t)&&(t=t.value),rl.defaults({value:t},n)):t})}(t.data,a)})}else i.push(rl.extend({type:"scatter"},t))}),e.mergeOption(rl.defaults({series:i},t.newOption))});var uA=rl.each,cA="\0_ec_hist_store",dA={push:function(t,e){var i=ms(t);uA(e,function(e,n){for(var a=i.length-1;a>=0&&!i[a][n];a--);if(a<0){var o=t.queryComponents({mainType:"dataZoom",subType:"select",id:n})[0];if(o){var r=o.getPercentRange();i[0][n]={dataZoomId:n,start:r[0],end:r[1]}}}}),i.push(e)},pop:function(t){var e=ms(t),i=e[e.length-1];e.length>1&&e.pop();var n={};return uA(i,function(t,i){for(var a=e.length-1;a>=0;a--)if(t=e[a][i]){n[i]=t;break}}),n},clear:function(t){t[cA]=null},count:function(t){return ms(t).length}},pA=(VI.extend({type:"dataZoom.select"}),BI.extend({type:"dataZoom.select"}),_I.toolbox.dataZoom),fA=rl.each,gA="\0_ec_\0toolbox-dataZoom_";vs.defaultOption={show:!0,icon:{zoom:"M0,13.5h26.9 M13.5,26.9V0 M32.1,13.5H58V58H13.5 V32.1",back:"M22,1.4L9.9,13.5l12.3,12.3 M10.3,13.5H54.9v44.6 H10.3v-26"},title:rl.clone(pA.title)};var mA=vs.prototype;mA.render=function(t,e,i,n){this.model=t,this.ecModel=e,this.api=i,function(t,e,i,n,a){var o=i._isZoomActive;n&&"takeGlobalCursor"===n.type&&(o="dataZoomSelect"===n.key&&n.dataZoomSelectActive),i._isZoomActive=o,t.setIconStatus("zoom",o?"emphasis":"normal");var r=new cI(ys(t.option),e,{include:["grid"]});i._brushController.setPanels(r.makePanelOpts(a,function(t){return t.xAxisDeclared&&!t.yAxisDeclared?"lineX":!t.xAxisDeclared&&t.yAxisDeclared?"lineY":"rect"})).enableBrush(!!o&&{brushType:"auto",brushStyle:{lineWidth:0,fill:"rgba(0,0,0,0.2)"}})}(t,e,this,n,i),function(t,e){t.setIconStatus("back",dA.count(e)>1?"emphasis":"normal")}(t,e)},mA.onclick=function(t,e,i){vA[i].call(this)},mA.remove=function(t,e){this._brushController.unmount()},mA.dispose=function(t,e){this._brushController.dispose()};var vA={zoom:function(){var t=!this._isZoomActive;this.api.dispatchAction({type:"takeGlobalCursor",key:"dataZoomSelect",dataZoomSelectActive:t})},back:function(){this._dispatchZoomAction(dA.pop(this.ecModel))}};mA._onBrush=function(t,e){function i(t,e,i){var o=e.getAxis(t),r=o.model,s=function(t,e,i){var n;return i.eachComponent({mainType:"dataZoom",subType:"select"},function(i){i.getAxisModel(t,e.componentIndex)&&(n=i)}),n}(t,r,a),l=s.findRepresentativeAxisProxy(r).getMinMaxSpan();null==l.minValueSpan&&null==l.maxValueSpan||(i=xb(0,i.slice(),o.scale.getExtent(),0,l.minValueSpan,l.maxValueSpan)),s&&(n[s.id]={dataZoomId:s.id,startValue:i[0],endValue:i[1]})}if(e.isEnd&&t.length){var n={},a=this.ecModel;this._brushController.updateCovers([]);new cI(ys(this.model.option),a,{include:["grid"]}).matchOutputRanges(t,a,function(t,e,n){if("cartesian2d"===n.type){var a=t.brushType;"rect"===a?(i("x",n,e[0]),i("y",n,e[1])):i({lineX:"x",lineY:"y"}[a],n,e)}}),dA.push(a,n),this._dispatchZoomAction(n)}},mA._dispatchZoomAction=function(t){var e=[];fA(t,function(t,i){e.push(rl.clone(t))}),e.length&&this.api.dispatchAction({type:"dataZoom",from:this.uid,batch:e})},xI.register("dataZoom",vs),ym.registerPreprocessor(function(t){function e(e,n){if(n){var a=e+"Index",o=n[a];null==o||"all"==o||rl.isArray(o)||(o=!1===o||"none"===o?[]:[o]),function(e,i){var n=t[e];rl.isArray(n)||(n=n?[n]:[]);fA(n,i)}(e,function(t,n){if(null==o||"all"==o||-1!==rl.indexOf(o,n)){var r={type:"select",$fromToolbox:!0,id:gA+e+n};r[a]=n,i.push(r)}})}}if(t){var i=t.dataZoom||(t.dataZoom=[]);rl.isArray(i)||(t.dataZoom=i=[i]);var n=t.toolbox;if(n&&(rl.isArray(n)&&(n=n[0]),n&&n.feature)){var a=n.feature.dataZoom;e("xAxis",a),e("yAxis",a)}}});var yA=_I.toolbox.restore;xs.defaultOption={show:!0,icon:"M3.8,33.4 M47,18.9h9.8V8.7 M56.3,20.1 C52.1,9,40.5,0.6,26.8,2.1C12.6,3.7,1.6,16.2,2.1,30.6 M13,41.1H3.1v10.2 M3.7,39.9c4.2,11.1,15.8,19.5,29.5,18 c14.2-1.6,25.2-14.1,24.7-28.5",title:yA.title};xs.prototype.onclick=function(t,e,i){dA.clear(t),e.dispatchAction({type:"restore",from:this.uid})},xI.register("restore",xs),ym.registerAction({type:"restore",event:"restore",update:"prepareAndUpdate"},function(t,e){e.resetOption("recreate")});var xA,_A="urn:schemas-microsoft-com:vml",bA="undefined"==typeof window?null:window,wA=!1,SA=bA&&bA.document;if(SA&&!Us.canvasSupported)try{!SA.namespaces.zrvml&&SA.namespaces.add("zrvml",_A),xA=function(t){return SA.createElement("<zrvml:"+t+' class="zrvml">')}}catch(t){xA=function(t){return SA.createElement("<"+t+' xmlns="'+_A+'" class="zrvml">')}}var MA={doc:SA,createNode:function(t){return xA(t)},initVML:function(){if(!wA&&SA){wA=!0;var t=SA.styleSheets;t.length<31?SA.createStyleSheet().addRule(".zrvml","behavior:url(#default#VML)"):t[0].addRule(".zrvml","behavior:url(#default#VML)")}}},IA=ll.applyTransform,TA=Cc.CMD,AA=Math.round,CA=Math.sqrt,LA=Math.abs,DA=Math.cos,PA=Math.sin,kA=Math.max;if(!Us.canvasSupported){var OA=21600,zA=OA/2,EA=function(t){t.style.cssText="position:absolute;left:0;top:0;width:1px;height:1px;",t.coordsize=OA+","+OA,t.coordorigin="0,0"},RA=function(t,e,i){return"rgb("+[t,e,i].join(",")+")"},NA=function(t,e){e&&t&&e.parentNode!==t&&t.appendChild(e)},VA=function(t,e){e&&t&&e.parentNode===t&&t.removeChild(e)},BA=function(t,e,i){return 1e5*(parseFloat(t)||0)+1e3*(parseFloat(e)||0)+i},GA=function(t,e){return"string"==typeof t?t.lastIndexOf("%")>=0?parseFloat(t)/100*e:parseFloat(t):t},HA=function(t,e,i){var n=Nl.parse(e);i=+i,isNaN(i)&&(i=1),n&&(t.color=RA(n[0],n[1],n[2]),t.opacity=i*n[3])},WA=function(t,e,i,n){var a="fill"==e,o=t.getElementsByTagName(e)[0];null!=i[e]&&"none"!==i[e]&&(a||!a&&i.lineWidth)?(t[a?"filled":"stroked"]="true",i[e]instanceof Zd&&VA(t,o),o||(o=MA.createNode(e)),a?function(t,e,i){var n=e.fill;if(null!=n)if(n instanceof Zd){var a,o=0,r=[0,0],s=0,l=1,h=i.getBoundingRect(),u=h.width,c=h.height;if("linear"===n.type){a="gradient";var d=i.transform,p=[n.x*u,n.y*c],f=[n.x2*u,n.y2*c];d&&(IA(p,p,d),IA(f,f,d));var g=f[0]-p[0],m=f[1]-p[1];(o=180*Math.atan2(g,m)/Math.PI)<0&&(o+=360),o<1e-6&&(o=0)}else{a="gradientradial";var p=[n.x*u,n.y*c],d=i.transform,v=i.scale,y=u,x=c;r=[(p[0]-h.x)/y,(p[1]-h.y)/x],d&&IA(p,p,d),y/=v[0]*OA,x/=v[1]*OA;var _=kA(y,x);s=0/_,l=2*n.r/_-s}var b=n.colorStops.slice();b.sort(function(t,e){return t.offset-e.offset});for(var w=b.length,S=[],M=[],I=0;I<w;I++){var T=b[I],A=function(t){var e=Nl.parse(t);return[RA(e[0],e[1],e[2]),e[3]]}(T.color);M.push(T.offset*l+s+" "+A[0]),0!==I&&I!==w-1||S.push(A)}if(w>=2){var C=S[0][0],L=S[1][0],D=S[0][1]*e.opacity,P=S[1][1]*e.opacity;t.type=a,t.method="none",t.focus="100%",t.angle=o,t.color=C,t.color2=L,t.colors=M.join(","),t.opacity=P,t.opacity2=D}"radial"===a&&(t.focusposition=r.join(","))}else HA(t,n,e.opacity)}(o,i,n):function(t,e){null!=e.lineDash&&(t.dashstyle=e.lineDash.join(" ")),null==e.stroke||e.stroke instanceof Zd||HA(t,e.stroke,e.opacity)}(o,i),NA(t,o)):(t[a?"filled":"stroked"]="false",VA(t,o))},FA=[[],[],[]];Yc.prototype.brushVML=function(t){var e=this.style,i=this._vmlEl;i||(i=MA.createNode("shape"),EA(i),this._vmlEl=i),WA(i,"fill",e,this),WA(i,"stroke",e,this);var n=this.transform,a=null!=n,o=i.getElementsByTagName("stroke")[0];if(o){var r=e.lineWidth;if(a&&!e.strokeNoScale){var s=n[0]*n[3]-n[1]*n[2];r*=CA(LA(s))}o.weight=r+"px"}var l=this.path||(this.path=new Cc);this.__dirtyPath&&(l.beginPath(),this.buildPath(l,this.shape),l.toStatic(),this.__dirtyPath=!1),i.path=function(t,e){var i,n,a,o,r,s,l=TA.M,h=TA.C,u=TA.L,c=TA.A,d=TA.Q,p=[],f=t.data,g=t.len();for(o=0;o<g;){switch(a=f[o++],n="",i=0,a){case l:n=" m ",i=1,r=f[o++],s=f[o++],FA[0][0]=r,FA[0][1]=s;break;case u:n=" l ",i=1,r=f[o++],s=f[o++],FA[0][0]=r,FA[0][1]=s;break;case d:case h:n=" c ",i=3;var m,v,y=f[o++],x=f[o++],_=f[o++],b=f[o++];a===d?(m=_,v=b,_=(_+2*y)/3,b=(b+2*x)/3,y=(r+2*y)/3,x=(s+2*x)/3):(m=f[o++],v=f[o++]),FA[0][0]=y,FA[0][1]=x,FA[1][0]=_,FA[1][1]=b,FA[2][0]=m,FA[2][1]=v,r=m,s=v;break;case c:var w=0,S=0,M=1,I=1,T=0;e&&(w=e[4],S=e[5],M=CA(e[0]*e[0]+e[1]*e[1]),I=CA(e[2]*e[2]+e[3]*e[3]),T=Math.atan2(-e[1]/I,e[0]/M));var A=f[o++],C=f[o++],L=f[o++],D=f[o++],P=f[o++]+T,k=f[o++]+P+T;o++;var O=f[o++],z=A+DA(P)*L,E=C+PA(P)*D,y=A+DA(k)*L,x=C+PA(k)*D,R=O?" wa ":" at ";Math.abs(z-y)<1e-4&&(Math.abs(k-P)>.01?O&&(z+=.0125):Math.abs(E-C)<1e-4?O&&z<A||!O&&z>A?x-=.0125:x+=.0125:O&&E<C||!O&&E>C?y+=.0125:y-=.0125),p.push(R,AA(((A-L)*M+w)*OA-zA),",",AA(((C-D)*I+S)*OA-zA),",",AA(((A+L)*M+w)*OA-zA),",",AA(((C+D)*I+S)*OA-zA),",",AA((z*M+w)*OA-zA),",",AA((E*I+S)*OA-zA),",",AA((y*M+w)*OA-zA),",",AA((x*I+S)*OA-zA)),r=y,s=x;break;case TA.R:var N=FA[0],V=FA[1];N[0]=f[o++],N[1]=f[o++],V[0]=N[0]+f[o++],V[1]=N[1]+f[o++],e&&(IA(N,N,e),IA(V,V,e)),N[0]=AA(N[0]*OA-zA),V[0]=AA(V[0]*OA-zA),N[1]=AA(N[1]*OA-zA),V[1]=AA(V[1]*OA-zA),p.push(" m ",N[0],",",N[1]," l ",V[0],",",N[1]," l ",V[0],",",V[1]," l ",N[0],",",V[1]);break;case TA.Z:p.push(" x ")}if(i>0){p.push(n);for(var B=0;B<i;B++){var G=FA[B];e&&IA(G,G,e),p.push(AA(G[0]*OA-zA),",",AA(G[1]*OA-zA),B<i-1?",":"")}}}return p.join("")}(l,this.transform),i.style.zIndex=BA(this.zlevel,this.z,this.z2),NA(t,i),null!=e.text?this.drawRectText(t,this.getBoundingRect()):this.removeRectText(t)},Yc.prototype.onRemove=function(t){VA(t,this._vmlEl),this.removeRectText(t)},Yc.prototype.onAdd=function(t){NA(t,this._vmlEl),this.appendRectText(t)};Jh.prototype.brushVML=function(t){var e,i,n=this.style,a=n.image;if(function(t){return"object"==typeof t&&t.tagName&&"IMG"===t.tagName.toUpperCase()}(a)){var o=a.src;if(o===this._imageSrc)e=this._imageWidth,i=this._imageHeight;else{var r=a.runtimeStyle,s=r.width,l=r.height;r.width="auto",r.height="auto",e=a.width,i=a.height,r.width=s,r.height=l,this._imageSrc=o,this._imageWidth=e,this._imageHeight=i}a=o}else a===this._imageSrc&&(e=this._imageWidth,i=this._imageHeight);if(a){var h=n.x||0,u=n.y||0,c=n.width,d=n.height,p=n.sWidth,f=n.sHeight,g=n.sx||0,m=n.sy||0,v=p&&f,y=this._vmlEl;y||(y=MA.doc.createElement("div"),EA(y),this._vmlEl=y);var x,_=y.style,b=!1,w=1,S=1;if(this.transform&&(x=this.transform,w=CA(x[0]*x[0]+x[1]*x[1]),S=CA(x[2]*x[2]+x[3]*x[3]),b=x[1]||x[2]),b){var M=[h,u],I=[h+c,u],T=[h,u+d],A=[h+c,u+d];IA(M,M,x),IA(I,I,x),IA(T,T,x),IA(A,A,x);var C=kA(M[0],I[0],T[0],A[0]),L=kA(M[1],I[1],T[1],A[1]),D=[];D.push("M11=",x[0]/w,",","M12=",x[2]/S,",","M21=",x[1]/w,",","M22=",x[3]/S,",","Dx=",AA(h*w+x[4]),",","Dy=",AA(u*S+x[5])),_.padding="0 "+AA(C)+"px "+AA(L)+"px 0",_.filter="progid:DXImageTransform.Microsoft.Matrix("+D.join("")+", SizingMethod=clip)"}else x&&(h=h*w+x[4],u=u*S+x[5]),_.filter="",_.left=AA(h)+"px",_.top=AA(u)+"px";var P=this._imageEl,k=this._cropEl;P||(P=MA.doc.createElement("div"),this._imageEl=P);var O=P.style;if(v){if(e&&i)O.width=AA(w*e*c/p)+"px",O.height=AA(S*i*d/f)+"px";else{var z=new Image,E=this;z.onload=function(){z.onload=null,e=z.width,i=z.height,O.width=AA(w*e*c/p)+"px",O.height=AA(S*i*d/f)+"px",E._imageWidth=e,E._imageHeight=i,E._imageSrc=a},z.src=a}k||((k=MA.doc.createElement("div")).style.overflow="hidden",this._cropEl=k);var R=k.style;R.width=AA((c+g*c/p)*w),R.height=AA((d+m*d/f)*S),R.filter="progid:DXImageTransform.Microsoft.Matrix(Dx="+-g*c/p*w+",Dy="+-m*d/f*S+")",k.parentNode||y.appendChild(k),P.parentNode!=k&&k.appendChild(P)}else O.width=AA(w*c)+"px",O.height=AA(S*d)+"px",y.appendChild(P),k&&k.parentNode&&(y.removeChild(k),this._cropEl=null);var N="",V=n.opacity;V<1&&(N+=".Alpha(opacity="+AA(100*V)+") "),N+="progid:DXImageTransform.Microsoft.AlphaImageLoader(src="+a+", SizingMethod=scale)",O.filter=N,y.style.zIndex=BA(this.zlevel,this.z,this.z2),NA(t,y),null!=n.text&&this.drawRectText(t,this.getBoundingRect())}},Jh.prototype.onRemove=function(t){VA(t,this._vmlEl),this._vmlEl=null,this._cropEl=null,this._imageEl=null,this.removeRectText(t)},Jh.prototype.onAdd=function(t){NA(t,this._vmlEl),this.appendRectText(t)};var ZA,jA={},UA=0,qA=document.createElement("div");Nh.$override("measureText",function(t,e){var i=MA.doc;ZA||((ZA=i.createElement("div")).style.cssText="position:absolute;top:-20000px;left:0;padding:0;margin:0;border:none;white-space:pre;",MA.doc.body.appendChild(ZA));try{ZA.style.font=e}catch(t){}return ZA.innerHTML="",ZA.appendChild(i.createTextNode(t)),{width:ZA.offsetWidth}});for(var XA=new oh,YA=[$h,Kh,Jh,Yc,dd],$A=0;$A<YA.length;$A++){var KA=YA[$A].prototype;KA.drawRectText=function(t,e,i,n){var a=this.style;this.__dirty&&qh.normalizeTextStyle(a,!0);var o=a.text;if(null!=o&&(o+=""),o){if(a.rich){var r=Nh.parseRichText(o,a);o=[];for(var s=0;s<r.lines.length;s++){for(var l=r.lines[s].tokens,h=[],u=0;u<l.length;u++)h.push(l[u].text);o.push(h.join(""))}o=o.join("\n")}var c,d,p=a.textAlign,f=a.textVerticalAlign,g=function(t){var e=jA[t];if(!e){UA>100&&(UA=0,jA={});var i,n=qA.style;try{n.font=t,i=n.fontFamily.split(",")[0]}catch(t){}e={style:n.fontStyle||"normal",variant:n.fontVariant||"normal",weight:n.fontWeight||"normal",size:0|parseFloat(n.fontSize||12),family:i||"Microsoft YaHei"},jA[t]=e,UA++}return e}(a.font),m=g.style+" "+g.variant+" "+g.weight+" "+g.size+'px "'+g.family+'"';i=i||Nh.getBoundingRect(o,m,p,f);var v=this.transform;if(v&&!n&&(XA.copy(e),XA.applyTransform(v),e=XA),n)c=e.x,d=e.y;else{var y=a.textPosition,x=a.textDistance;if(y instanceof Array)c=e.x+GA(y[0],e.width),d=e.y+GA(y[1],e.height),p=p||"left";else{var _=Nh.adjustTextPositionOnRect(y,e,x);c=_.x,d=_.y,p=p||_.textAlign,f=f||_.textVerticalAlign}}c=Nh.adjustTextX(c,i.width,p),d=Nh.adjustTextY(d,i.height,f),d+=i.height/2;var b,w,S,M=MA.createNode,I=this._textVmlEl;I?w=(b=(S=I.firstChild).nextSibling).nextSibling:(I=M("line"),b=M("path"),w=M("textpath"),S=M("skew"),w.style["v-text-align"]="left",EA(I),b.textpathok=!0,w.on=!0,I.from="0 0",I.to="1000 0.05",NA(I,S),NA(I,b),NA(I,w),this._textVmlEl=I);var T=[c,d],A=I.style;v&&n?(IA(T,T,v),S.on=!0,S.matrix=v[0].toFixed(3)+","+v[2].toFixed(3)+","+v[1].toFixed(3)+","+v[3].toFixed(3)+",0,0",S.offset=(AA(T[0])||0)+","+(AA(T[1])||0),S.origin="0 0",A.left="0px",A.top="0px"):(S.on=!1,A.left=AA(c)+"px",A.top=AA(d)+"px"),w.string=function(t){return String(t).replace(/&/g,"&amp;").replace(/"/g,"&quot;")}(o);try{w.style.font=m}catch(t){}WA(I,"fill",{fill:a.textFill,opacity:a.opacity},this),WA(I,"stroke",{stroke:a.textStroke,opacity:a.opacity,lineDash:a.lineDash},this),I.style.zIndex=BA(this.zlevel,this.z,this.z2),NA(t,I)}},KA.removeRectText=function(t){VA(t,this._textVmlEl),this._textVmlEl=null},KA.appendRectText=function(t){NA(t,this._textVmlEl)}}dd.prototype.brushVML=function(t){var e=this.style;null!=e.text?this.drawRectText(t,{x:e.x||0,y:e.y||0,width:0,height:0},this.getBoundingRect(),!0):this.removeRectText(t)},dd.prototype.onRemove=function(t){this.removeRectText(t)},dd.prototype.onAdd=function(t){this.appendRectText(t)}}var JA=rl.each;bs.prototype={constructor:bs,getType:function(){return"vml"},getViewportRoot:function(){return this._vmlViewport},getViewportRootOffset:function(){var t=this.getViewportRoot();if(t)return{offsetLeft:t.offsetLeft||0,offsetTop:t.offsetTop||0}},refresh:function(){var t=this.storage.getDisplayList(!0,!0);this._paintList(t)},_paintList:function(t){for(var e=this._vmlRoot,i=0;i<t.length;i++){var n=t[i];n.invisible||n.ignore?(n.__alreadyNotVisible||n.onRemove(e),n.__alreadyNotVisible=!0):(n.__alreadyNotVisible&&n.onAdd(e),n.__alreadyNotVisible=!1,n.__dirty&&(n.beforeBrush&&n.beforeBrush(),(n.brushVML||n.brush).call(n,e),n.afterBrush&&n.afterBrush())),n.__dirty=!1}this._firstPaint&&(this._vmlViewport.appendChild(e),this._firstPaint=!1)},resize:function(t,e){var t=null==t?this._getWidth():t,e=null==e?this._getHeight():e;if(this._width!=t||this._height!=e){this._width=t,this._height=e;var i=this._vmlViewport.style;i.width=t+"px",i.height=e+"px"}},dispose:function(){this.root.innerHTML="",this._vmlRoot=this._vmlViewport=this.storage=null},getWidth:function(){return this._width},getHeight:function(){return this._height},clear:function(){this._vmlViewport&&this.root.removeChild(this._vmlViewport)},_getWidth:function(){var t=this.root,e=t.currentStyle;return(t.clientWidth||_s(e.width))-_s(e.paddingLeft)-_s(e.paddingRight)|0},_getHeight:function(){var t=this.root,e=t.currentStyle;return(t.clientHeight||_s(e.height))-_s(e.paddingTop)-_s(e.paddingBottom)|0}},JA(["getLayer","insertLayer","eachLayer","eachBuiltinLayer","eachOtherLayer","getLayers","modLayer","delLayer","clearLayer","toDataURL","pathToImage"],function(t){bs.prototype[t]=function(t){return function(){Ul('In IE8.0 VML mode painter not support method "'+t+'"')}}(t)});var QA=bs;(0,Cu.registerPainter)("vml",QA);var tC="http://www.w3.org/2000/svg",eC={createElement:function(t){return document.createElementNS(tC,t)}},iC=eC.createElement,nC=Cc.CMD,aC=Array.prototype.join,oC="none",rC=Math.round,sC=Math.sin,lC=Math.cos,hC=Math.PI,uC=2*Math.PI,cC=180/hC,dC=1e-4,pC={};pC.brush=function(t){var e=t.style,i=t.__svgEl;i||(i=iC("path"),t.__svgEl=i),t.path||t.createPathProxy();var n=t.path;if(t.__dirtyPath){n.beginPath(),t.buildPath(n,t.shape),t.__dirtyPath=!1;var a=function(t){for(var e=[],i=t.data,n=t.len(),a=0;a<n;){var o="",r=0;switch(i[a++]){case nC.M:o="M",r=2;break;case nC.L:o="L",r=2;break;case nC.Q:o="Q",r=4;break;case nC.C:o="C",r=6;break;case nC.A:var s=i[a++],l=i[a++],h=i[a++],u=i[a++],c=i[a++],d=i[a++],p=i[a++],f=i[a++],g=Math.abs(d),m=Ss(g%uC)&&!Ss(g),v=!1;v=g>=uC||!Ss(g)&&(d>-hC&&d<0||d>hC)==!!f;var y=ws(s+h*lC(c)),x=ws(l+u*sC(c));m&&(d=f?uC-1e-4:1e-4-uC,v=!0,9===a&&e.push("M",y,x));var _=ws(s+h*lC(c+d)),b=ws(l+u*sC(c+d));e.push("A",ws(h),ws(u),rC(p*cC),+v,+f,_,b);break;case nC.Z:o="Z";break;case nC.R:var _=ws(i[a++]),b=ws(i[a++]),w=ws(i[a++]),S=ws(i[a++]);e.push("M",_,b,"L",_+w,b,"L",_+w,b+S,"L",_,b+S,"L",_,b)}o&&e.push(o);for(var M=0;M<r;M++)e.push(ws(i[a++]))}return e.join(" ")}(n);a.indexOf("NaN")<0&&Is(i,"d",a)}Ts(i,e),Ms(i,t.transform),null!=e.text&&vC(t,t.getBoundingRect())};var fC={};fC.brush=function(t){var e=t.style,i=e.image;if(i instanceof HTMLImageElement){i=i.src}if(i){var n=e.x||0,a=e.y||0,o=e.width,r=e.height,s=t.__svgEl;s||(s=iC("image"),t.__svgEl=s),i!==t.__imageSrc&&(!function(t,e,i){t.setAttributeNS("http://www.w3.org/1999/xlink",e,i)}(s,"href",i),t.__imageSrc=i),Is(s,"width",o),Is(s,"height",r),Is(s,"x",n),Is(s,"y",a),Ms(s,t.transform),null!=e.text&&vC(t,t.getBoundingRect())}};var gC={},mC=new oh,vC=function(t,e,i){var n=t.style;t.__dirty&&qh.normalizeTextStyle(n,!0);var a=n.text;if(null!=a){a+="";var o=t.__textSvgEl;if(o||(o=iC("text"),t.__textSvgEl=o),Ts(o,n,!0),t instanceof dd||t.style.transformText)Ms(o,t.transform);else if(t.transform)mC.copy(e),mC.applyTransform(t.transform),e=mC;else{var r=t.transformCoordToGlobal(e.x,e.y);e.x=r[0],e.y=r[1]}var s,l,h=n.textPosition,u=n.textDistance,c=n.textAlign||"left";"number"==typeof n.fontSize&&(n.fontSize+="px");var d=n.font||[n.fontStyle||"",n.fontWeight||"",n.fontSize||"",n.fontFamily||""].join(" ")||Nh.DEFAULT_FONT,p=As(n.textVerticalAlign),f=(i=Nh.getBoundingRect(a,d,c,p)).lineHeight;if(h instanceof Array)s=e.x+h[0],l=e.y+h[1];else{var g=Nh.adjustTextPositionOnRect(h,e,u);s=g.x,l=g.y,p=As(g.textVerticalAlign),c=g.textAlign}Is(o,"alignment-baseline",p),d&&(o.style.font=d);var m=n.textPadding;Is(o,"x",s),Is(o,"y",l);var v=a.split("\n"),y=v.length,x=c;"left"===x?(x="start",m&&(s+=m[3])):"right"===x?(x="end",m&&(s-=m[1])):"center"===x&&(x="middle",m&&(s+=(m[3]-m[1])/2));var _=0;if("baseline"===p?(_=-i.height+f,m&&(_-=m[2])):"middle"===p?(_=(-i.height+f)/2,m&&(l+=(m[0]-m[2])/2)):m&&(_+=m[0]),t.__text!==a||t.__textFont!==d){var b=t.__tspanList||[];t.__tspanList=b;for(S=0;S<y;S++){(M=b[S])?M.innerHTML="":(M=b[S]=iC("tspan"),o.appendChild(M),Is(M,"alignment-baseline",p),Is(M,"text-anchor",x)),Is(M,"x",s),Is(M,"y",l+S*f+_),M.appendChild(document.createTextNode(v[S]))}for(;S<b.length;S++)o.removeChild(b[S]);b.length=y,t.__text=a,t.__textFont=d}else if(t.__tspanList.length)for(var w=t.__tspanList.length,S=0;S<w;++S){var M=t.__tspanList[S];M&&(Is(M,"x",s),Is(M,"y",l+S*f+_))}}};gC.drawRectText=vC,gC.brush=function(t){var e=t.style;null!=e.text&&(e.textPosition=[0,0],vC(t,{x:e.x||0,y:e.y||0,width:0,height:0},t.getBoundingRect()))};var yC={path:pC,image:fC,text:gC};Cs.prototype={diff:function(t,e,i){i||(i=function(t,e){return t===e}),this.equals=i;var n=this;t=t.slice();var a=(e=e.slice()).length,o=t.length,r=1,s=a+o,l=[{newPos:-1,components:[]}],h=this.extractCommon(l[0],e,t,0);if(l[0].newPos+1>=a&&h+1>=o){for(var u=[],c=0;c<e.length;c++)u.push(c);return[{indices:u,count:e.length}]}for(;r<=s;){var d=function(){for(var i=-1*r;i<=r;i+=2){var s,h=l[i-1],u=l[i+1],c=(u?u.newPos:0)-i;h&&(l[i-1]=void 0);var d=h&&h.newPos+1<a,p=u&&0<=c&&c<o;if(d||p){if(!d||p&&h.newPos<u.newPos?(s=function(t){return{newPos:t.newPos,components:t.components.slice(0)}}(u),n.pushComponent(s.components,void 0,!0)):((s=h).newPos++,n.pushComponent(s.components,!0,void 0)),c=n.extractCommon(s,e,t,i),s.newPos+1>=a&&c+1>=o)return function(t,e,i,n){for(var a=0,o=e.length,r=0,s=0;a<o;a++){var l=e[a];if(l.removed){for(var h=[],u=s;u<s+l.count;u++)h.push(u);l.indices=h,s+=l.count}else{for(var h=[],u=r;u<r+l.count;u++)h.push(u);l.indices=h,r+=l.count,l.added||(s+=l.count)}}return e}(0,s.components);l[i]=s}else l[i]=void 0}r++}();if(d)return d}},pushComponent:function(t,e,i){var n=t[t.length-1];n&&n.added===e&&n.removed===i?t[t.length-1]={count:n.count+1,added:e,removed:i}:t.push({count:1,added:e,removed:i})},extractCommon:function(t,e,i,n){for(var a=e.length,o=i.length,r=t.newPos,s=r-n,l=0;r+1<a&&s+1<o&&this.equals(e[r+1],i[s+1]);)r++,s++,l++;return l&&t.components.push({count:l}),t.newPos=r,s},tokenize:function(t){return t.slice()},join:function(t){return t.slice()}};var xC=new Cs,_C=function(t,e,i){return xC.diff(t,e,i)},bC=eC.createElement,wC=yC.path,SC=yC.image,MC=yC.text;Ls.prototype.createElement=bC,Ls.prototype.getDefs=function(t){var e=this._svgRoot,i=this._svgRoot.getElementsByTagName("defs");return 0===i.length?t?((i=e.insertBefore(this.createElement("defs"),e.firstChild)).contains||(i.contains=function(t){var e=i.children;if(!e)return!1;for(var n=e.length-1;n>=0;--n)if(e[n]===t)return!0;return!1}),i):null:i[0]},Ls.prototype.update=function(t,e){if(t){var i=this.getDefs(!1);if(t._dom&&i.contains(t._dom))"function"==typeof e&&e();else{var n=this.add(t);n&&(t._dom=n)}}},Ls.prototype.addDom=function(t){this.getDefs(!0).appendChild(t)},Ls.prototype.removeDom=function(t){this.getDefs(!1).removeChild(t._dom)},Ls.prototype.getDoms=function(){var t=this.getDefs(!1);if(!t)return[];var e=[];return rl.each(this._tagNames,function(i){var n=t.getElementsByTagName(i);e=e.concat([].slice.call(n))}),e},Ls.prototype.markAllUnused=function(){var t=this.getDoms(),e=this;rl.each(t,function(t){t[e._markLabel]="0"})},Ls.prototype.markUsed=function(t){t&&(t[this._markLabel]="1")},Ls.prototype.removeUnused=function(){var t=this.getDefs(!1);if(t){var e=this.getDoms(),i=this;rl.each(e,function(e){"1"!==e[i._markLabel]&&t.removeChild(e)})}},Ls.prototype.getSvgProxy=function(t){return t instanceof Yc?wC:t instanceof Jh?SC:t instanceof dd?MC:wC},Ls.prototype.getTextSvgElement=function(t){return t.__textSvgEl},Ls.prototype.getSvgElement=function(t){return t.__svgEl};var IC=Ls;rl.inherits(Ds,IC),Ds.prototype.addWithoutUpdate=function(t,e){if(e&&e.style){var i=this;rl.each(["fill","stroke"],function(n){if(e.style[n]&&("linear"===e.style[n].type||"radial"===e.style[n].type)){var a,o=e.style[n],r=i.getDefs(!0);o._dom?(a=o._dom,r.contains(o._dom)||i.addDom(a)):a=i.add(o),i.markUsed(e);var s=a.getAttribute("id");t.setAttribute(n,"url(#"+s+")")}})}},Ds.prototype.add=function(t){var e;if("linear"===t.type)e=this.createElement("linearGradient");else{if("radial"!==t.type)return Ul("Illegal gradient type."),null;e=this.createElement("radialGradient")}return t.id=t.id||this.nextId++,e.setAttribute("id","zr-gradient-"+t.id),this.updateDom(t,e),this.addDom(e),e},Ds.prototype.update=function(t){var e=this;IC.prototype.update.call(this,t,function(){var i=t.type,n=t._dom.tagName;"linear"===i&&"linearGradient"===n||"radial"===i&&"radialGradient"===n?e.updateDom(t,t._dom):(e.removeDom(t),e.add(t))})},Ds.prototype.updateDom=function(t,e){if("linear"===t.type)e.setAttribute("x1",t.x),e.setAttribute("y1",t.y),e.setAttribute("x2",t.x2),e.setAttribute("y2",t.y2);else{if("radial"!==t.type)return void Ul("Illegal gradient type.");e.setAttribute("cx",t.x),e.setAttribute("cy",t.y),e.setAttribute("r",t.r)}t.global?e.setAttribute("gradientUnits","userSpaceOnUse"):e.setAttribute("gradientUnits","objectBoundingBox"),e.innerHTML="";for(var i=t.colorStops,n=0,a=i.length;n<a;++n){var o=this.createElement("stop");o.setAttribute("offset",100*i[n].offset+"%"),o.setAttribute("stop-color",i[n].color),e.appendChild(o)}t._dom=e},Ds.prototype.markUsed=function(t){if(t.style){var e=t.style.fill;e&&e._dom&&IC.prototype.markUsed.call(this,e._dom),(e=t.style.stroke)&&e._dom&&IC.prototype.markUsed.call(this,e._dom)}};var TC=Ds;rl.inherits(Ps,IC),Ps.prototype.update=function(t){var e=this.getSvgElement(t);e&&this.updateDom(e,t.__clipPaths,!1);var i=this.getTextSvgElement(t);i&&this.updateDom(i,t.__clipPaths,!0),this.markUsed(t)},Ps.prototype.updateDom=function(t,e,i){if(e&&e.length>0){var n,a,o=this.getDefs(!0),r=e[0],s=i?"_textDom":"_dom";r[s]?(a=r[s].getAttribute("id"),n=r[s],o.contains(n)||o.appendChild(n)):(a="zr-clip-"+this.nextId,++this.nextId,(n=this.createElement("clipPath")).setAttribute("id",a),o.appendChild(n),r[s]=n);var l=this.getSvgProxy(r);if(r.transform&&r.parent.invTransform&&!i){var h=Array.prototype.slice.call(r.transform);yl.mul(r.transform,r.parent.invTransform,r.transform),l.brush(r),r.transform=h}else l.brush(r);var u=this.getSvgElement(r);n.appendChild(u.cloneNode()),t.setAttribute("clip-path","url(#"+a+")"),e.length>1&&this.updateDom(n,e.slice(1),i)}else t&&t.setAttribute("clip-path","none")},Ps.prototype.markUsed=function(t){var e=this;t.__clipPaths&&t.__clipPaths.length>0&&rl.each(t.__clipPaths,function(t){t._dom&&IC.prototype.markUsed.call(e,t._dom),t._textDom&&IC.prototype.markUsed.call(e,t._textDom)})};var AC=Ps,CC=eC.createElement,LC=rl.each,DC=yC.path,PC=yC.image,kC=yC.text,OC=function(t,e,i){this.root=t,this.storage=e,this._opts=i=rl.extend({},i||{});var n=CC("svg");n.setAttribute("xmlns","http://www.w3.org/2000/svg"),n.setAttribute("version","1.1"),n.setAttribute("baseProfile","full"),n.style["user-select"]="none",n.style.cssText="position:absolute;left:0;top:0;",this.gradientManager=new TC(n),this.clipPathManager=new AC(n);var a=document.createElement("div");a.style.cssText="overflow:hidden;position:relative",this._svgRoot=n,this._viewport=a,t.appendChild(a),a.appendChild(n),this.resize(i.width,i.height),this._visibleList=[]};OC.prototype={constructor:OC,getType:function(){return"svg"},getViewportRoot:function(){return this._viewport},getViewportRootOffset:function(){var t=this.getViewportRoot();if(t)return{offsetLeft:t.offsetLeft||0,offsetTop:t.offsetTop||0}},refresh:function(){var t=this.storage.getDisplayList(!0);this._paintList(t)},_paintList:function(t){this.gradientManager.markAllUnused(),this.clipPathManager.markAllUnused();var e,i=this._svgRoot,n=this._visibleList,a=t.length,o=[];for(e=0;e<a;e++){var r=function(t){return t instanceof Yc?DC:t instanceof Jh?PC:t instanceof dd?kC:DC}(p=t[e]);p.invisible||(p.__dirty&&(r&&r.brush(p),this.clipPathManager.update(p),p.style&&(this.gradientManager.update(p.style.fill),this.gradientManager.update(p.style.stroke)),p.__dirty=!1),o.push(p))}var s,l=_C(n,o);for(e=0;e<l.length;e++){if((c=l[e]).removed)for(d=0;d<c.count;d++){var h=Vs(p=n[c.indices[d]]),u=Ns(p);Rs(i,h),Rs(i,u)}}for(e=0;e<l.length;e++){var c=l[e];if(c.added)for(d=0;d<c.count;d++){var h=Vs(p=o[c.indices[d]]),u=Ns(p);s?zs(i,h,s):Es(i,h),h?zs(i,u,h):s?zs(i,u,s):Es(i,u),zs(i,u,h),s=u||h||s,this.gradientManager.addWithoutUpdate(h,p),this.clipPathManager.markUsed(p)}else if(!c.removed)for(var d=0;d<c.count;d++){var p=o[c.indices[d]];s=h=Ns(p)||Vs(p)||s,this.gradientManager.markUsed(p),this.gradientManager.addWithoutUpdate(h,p),this.clipPathManager.markUsed(p)}}this.gradientManager.removeUnused(),this.clipPathManager.removeUnused(),this._visibleList=o},_getDefs:function(t){var e=this._svgRoot,i=this._svgRoot.getElementsByTagName("defs");if(0===i.length){if(t){return(i=e.insertBefore(CC("defs"),e.firstChild)).contains||(i.contains=function(t){var e=i.children;if(!e)return!1;for(var n=e.length-1;n>=0;--n)if(e[n]===t)return!0;return!1}),i}return null}return i[0]},resize:function(t,e){var i=this._viewport;i.style.display="none";var n=this._opts;if(null!=t&&(n.width=t),null!=e&&(n.height=e),t=this._getSize(0),e=this._getSize(1),i.style.display="",this._width!==t&&this._height!==e){this._width=t,this._height=e;var a=i.style;a.width=t+"px",a.height=e+"px";var o=this._svgRoot;o.setAttribute("width",t),o.setAttribute("height",e)}},getWidth:function(){return this._width},getHeight:function(){return this._height},_getSize:function(t){var e=this._opts,i=["width","height"][t],n=["clientWidth","clientHeight"][t],a=["paddingLeft","paddingTop"][t],o=["paddingRight","paddingBottom"][t];if(null!=e[i]&&"auto"!==e[i])return parseFloat(e[i]);var r=this.root,s=document.defaultView.getComputedStyle(r);return(r[n]||ks(s[i])||ks(r.style[i]))-(ks(s[a])||0)-(ks(s[o])||0)|0},dispose:function(){this.root.innerHTML="",this._svgRoot=this._viewport=this.storage=null},clear:function(){this._viewport&&this.root.removeChild(this._viewport)},pathToSvg:function(){this.refresh();var t=this._svgRoot.outerHTML;return"data:img/svg+xml;utf-8,"+unescape(t)}},LC(["getLayer","insertLayer","eachLayer","eachBuiltinLayer","eachOtherLayer","getLayers","modLayer","delLayer","clearLayer","toDataURL","pathToImage"],function(t){OC.prototype[t]=function(t){return function(){Ul('In SVG mode painter not support method "'+t+'"')}}(t)});var zC=OC;(0,Cu.registerPainter)("svg",zC);!function(t){t&&t.__esModule&&Object.prototype.hasOwnProperty.call(t,"default")&&t.default}(e(function(t,e){!function(){for(var t in ym){if(null==ym||!ym.hasOwnProperty(t)||"default"===t||"__esModule"===t)return;e[t]=ym[t]}}(),function(){for(var t in vm){if(null==vm||!vm.hasOwnProperty(t)||"default"===t||"__esModule"===t)return;e[t]=vm[t]}}()}));var EC="Expected a function",RC=NaN,NC="[object Symbol]",VC=/^\s+|\s+$/g,BC=/^[-+]0x[0-9a-f]+$/i,GC=/^0b[01]+$/i,HC=/^0o[0-7]+$/i,WC=parseInt,FC="object"==typeof Ws&&Ws&&Ws===Object&&Ws,ZC="object"==typeof self&&self&&self.Object===Object&&self,jC=FC||ZC||Function("return this")(),UC=Object.prototype.toString,qC=Math.max,XC=Math.min,YC=function(){return jC.Date.now()},$C=function(t,e,i){function n(e){var i=l,n=h;return l=h=void 0,f=e,c=t.apply(n,i)}function a(t){var i=t-p;return void 0===p||i>=e||i<0||m&&t-f>=u}function o(){var t=YC();if(a(t))return r(t);d=setTimeout(o,function(t){var i=e-(t-p);return m?XC(i,u-(t-f)):i}(t))}function r(t){return d=void 0,v&&l?n(t):(l=h=void 0,c)}function s(){var t=YC(),i=a(t);if(l=arguments,h=this,p=t,i){if(void 0===d)return function(t){return f=t,d=setTimeout(o,e),g?n(t):c}(p);if(m)return d=setTimeout(o,e),n(p)}return void 0===d&&(d=setTimeout(o,e)),c}var l,h,u,c,d,p,f=0,g=!1,m=!1,v=!0;if("function"!=typeof t)throw new TypeError(EC);return e=Gs(e)||0,Bs(i)&&(g=!!i.leading,u=(m="maxWait"in i)?qC(Gs(i.maxWait)||0,e):u,v="trailing"in i?!!i.trailing:v),s.cancel=function(){void 0!==d&&clearTimeout(d),f=0,l=p=h=d=void 0},s.flush=function(){return void 0===d?c:r(YC())},s};!function(){if("undefined"!=typeof document){var t=document.head||document.getElementsByTagName("head")[0],e=document.createElement("style"),i=" .echarts { width: 600px; height: 400px; } ";e.type="text/css",e.styleSheet?e.styleSheet.cssText=i:e.appendChild(document.createTextNode(i)),t.appendChild(e)}}();var KC=["legendselectchanged","legendselected","legendunselected","datazoom","datarangeselected","timelinechanged","timelineplaychanged","restore","dataviewchanged","magictypechanged","geoselectchanged","geoselected","geounselected","pieselectchanged","pieselected","pieunselected","mapselectchanged","mapselected","mapunselected","axisareaselected","focusnodeadjacency","unfocusnodeadjacency","brush","brushselected"],JC=["click","dblclick","mouseover","mouseout","mousedown","mouseup","globalout"];return{render:function(){var t=this.$createElement;return(this._self._c||t)("div",{staticClass:"echarts"})},staticRenderFns:[],props:{options:Object,theme:[String,Object],initOptions:Object,group:String,autoResize:Boolean,watchShallow:Boolean},data:function(){return{chart:null}},computed:{width:{cache:!1,get:function(){return this.delegateGet("width","getWidth")}},height:{cache:!1,get:function(){return this.delegateGet("height","getHeight")}},isDisposed:{cache:!1,get:function(){return!!this.delegateGet("isDisposed","isDisposed")}},computedOptions:{cache:!1,get:function(){return this.delegateGet("computedOptions","getOption")}}},watch:{group:function(t){this.chart.group=t}},methods:{mergeOptions:function(t,e,i){this.delegateMethod("setOption",t,e,i)},resize:function(t){this.delegateMethod("resize",t)},dispatchAction:function(t){this.delegateMethod("dispatchAction",t)},convertToPixel:function(t,e){return this.delegateMethod("convertToPixel",t,e)},convertFromPixel:function(t,e){return this.delegateMethod("convertFromPixel",t,e)},containPixel:function(t,e){return this.delegateMethod("containPixel",t,e)},showLoading:function(t,e){this.delegateMethod("showLoading",t,e)},hideLoading:function(){this.delegateMethod("hideLoading")},getDataURL:function(t){return this.delegateMethod("getDataURL",t)},getConnectedDataURL:function(t){return this.delegateMethod("getConnectedDataURL",t)},clear:function(){this.delegateMethod("clear")},dispose:function(){this.delegateMethod("dispose")},delegateMethod:function(e){for(var i=[],n=arguments.length-1;n-- >0;)i[n]=arguments[n+1];if(this.chart){return(a=this.chart)[e].apply(a,i);var a}else t.util.warn("Cannot call ["+e+"] before the chart is initialized. Set prop [options] first.",this)},delegateGet:function(e,i){return this.chart||t.util.warn("Cannot get ["+e+"] before the chart is initialized. Set prop [options] first.",this),this.chart[i]()},init:function(){var t=this;if(!this.chart){var e=ym.init(this.$el,this.theme,this.initOptions);this.group&&(e.group=this.group),e.setOption(this.options,!0),KC.forEach(function(i){e.on(i,function(e){t.$emit(i,e)})}),JC.forEach(function(i){e.on(i,function(e){t.$emit(i,e),t.$emit("chart"+i,e)})}),this.autoResize&&(this.__resizeHanlder=$C(function(){e.resize()},100,{leading:!0}),window.addEventListener("resize",this.__resizeHanlder)),this.chart=e}},destroy:function(){this.autoResize&&window.removeEventListener("resize",this.__resizeHanlder),this.dispose(),this.chart=null},refresh:function(){this.destroy(),this.init()}},created:function(){var t=this;this.$watch("options",function(e){!t.chart&&e?t.init():t.chart.setOption(t.options,!0)},{deep:!this.watchShallow});["theme","initOptions","autoResize","watchShallow"].forEach(function(e){t.$watch(e,function(){t.refresh()},{deep:!0})})},mounted:function(){this.options&&this.init()},activated:function(){this.autoResize&&this.chart&&this.chart.resize()},beforeDestroy:function(){this.chart&&this.destroy()},connect:function(t){"string"!=typeof t&&(t=t.map(function(t){return t.chart})),ym.connect(t)},disconnect:function(t){ym.disConnect(t)},registerMap:function(){for(var t=[],e=arguments.length;e--;)t[e]=arguments[e];ym.registerMap.apply(ym,t)},registerTheme:function(){for(var t=[],e=arguments.length;e--;)t[e]=arguments[e];ym.registerTheme.apply(ym,t)}}});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(414)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(248),
	  /* template */
	  __webpack_require__(638),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(249),
	  /* template */
	  __webpack_require__(650),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(438)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(251),
	  /* template */
	  __webpack_require__(654),
	  /* scopeId */
	  "data-v-7df4dd3f",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(423)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(252),
	  /* template */
	  __webpack_require__(644),
	  /* scopeId */
	  "data-v-48501788",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(437)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(253),
	  /* template */
	  __webpack_require__(653),
	  /* scopeId */
	  "data-v-7d745d8d",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(434)
	__webpack_require__(435)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(254),
	  /* template */
	  __webpack_require__(651),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(416)
	__webpack_require__(417)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(255),
	  /* template */
	  __webpack_require__(640),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(404)
	__webpack_require__(405)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(256),
	  /* template */
	  __webpack_require__(632),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(444)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(257),
	  /* template */
	  __webpack_require__(658),
	  /* scopeId */
	  "data-v-eae95e7a",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(418)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(258),
	  /* template */
	  __webpack_require__(641),
	  /* scopeId */
	  "data-v-3b7beaf6",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(442)
	__webpack_require__(443)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(259),
	  /* template */
	  __webpack_require__(657),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(411)
	__webpack_require__(412)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(260),
	  /* template */
	  __webpack_require__(636),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(426)
	__webpack_require__(427)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(261),
	  /* template */
	  __webpack_require__(646),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(432)
	__webpack_require__(433)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(262),
	  /* template */
	  __webpack_require__(649),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(421)
	__webpack_require__(422)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(263),
	  /* template */
	  __webpack_require__(643),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(424)
	__webpack_require__(425)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(264),
	  /* template */
	  __webpack_require__(645),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(419)
	__webpack_require__(420)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(265),
	  /* template */
	  __webpack_require__(642),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(439)
	__webpack_require__(440)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(266),
	  /* template */
	  __webpack_require__(655),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(430)
	__webpack_require__(431)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(267),
	  /* template */
	  __webpack_require__(648),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(408)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(268),
	  /* template */
	  __webpack_require__(634),
	  /* scopeId */
	  "data-v-2f6899ea",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(406)
	__webpack_require__(407)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(269),
	  /* template */
	  __webpack_require__(633),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(436)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(270),
	  /* template */
	  __webpack_require__(652),
	  /* scopeId */
	  "data-v-7cd84ce9",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(415)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(271),
	  /* template */
	  __webpack_require__(639),
	  /* scopeId */
	  "data-v-38c705e1",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(428)
	__webpack_require__(429)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(272),
	  /* template */
	  __webpack_require__(647),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(441)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(273),
	  /* template */
	  __webpack_require__(656),
	  /* scopeId */
	  "data-v-c382d2ac",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(409)
	__webpack_require__(410)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(274),
	  /* template */
	  __webpack_require__(635),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "select-container clearfix",
	    staticStyle: {
	      "margin-top": "2%",
	      "margin-left": "2%",
	      "float": "left"
	    }
	  }, [_c('span', {
	    staticStyle: {
	      "font-size": "30px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("DLP安装指南 for windows")]), _c('br'), _c('br'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(493),
	      "width": "850px",
	      "height": "280px"
	    }
	  }), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(494),
	      "width": "850px",
	      "height": "330px"
	    }
	  }), _c('br'), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', [_vm._v("二、绑定用户名")]), _vm._v(" "), _vm._m(3), _vm._v("\n  已安装赛门铁克杀毒软件的电脑双击下载好的安装包若弹出如下弹框，"), _c('span', {
	    staticStyle: {
	      "font-weight": "bold"
	    }
	  }, [_vm._v("选择“允许使用此文件”")]), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"../assets/dataLeakInstallForWin/dataLeakInstallForWin_pic1.jpg\""); e.code = 'MODULE_NOT_FOUND'; throw e; }())),
	      "width": "600px",
	      "height": "600px"
	    }
	  }), _c('br'), _vm._v("\n  点击“确定”"), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"../assets/dataLeakInstallForWin/dataLeakInstallForWin_pic2.jpg\""); e.code = 'MODULE_NOT_FOUND'; throw e; }())),
	      "width": "600px",
	      "height": "600px"
	    }
	  }), _c('br'), _vm._v("\n  双击下载后的文件出现解压信息如下图，选择需要解压到的文件夹点击“解压”："), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(495),
	      "width": "600px",
	      "height": "400px"
	    }
	  }), _c('br'), _c('br'), _vm._v("\n  解压终端安装包后文件包括："), _c('br'), _vm._v("\n 1) 终端安装程序 MT-DLP.exe     用于进行终端完整安装"), _c('br'), _vm._v("\n 2）msec.dat 文件"), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(496),
	      "width": "300px",
	      "height": "150px"
	    }
	  }), _c('br'), _c('br'), _vm._v("\n 终端安装步骤如下："), _c('br'), _vm._v("\n 1、 右键— MT-DLP.exe，"), _c('span', {
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v("以管理员身份安装")]), _vm._v("，弹出框图填写mis账号（外包职场用户在本步骤中请填写meituan）"), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"../assets/dataLeakInstallForWin/dataLeakInstallForWin_pic5.jpg\""); e.code = 'MODULE_NOT_FOUND'; throw e; }())),
	      "width": "350px",
	      "height": "120px"
	    }
	  }), _c('br'), _c('br'), _vm._v("\n 进入安装界面"), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(497),
	      "width": "600px",
	      "height": "450px"
	    }
	  }), _c('br'), _vm._v("\n 2、点击“浏览”按钮，选择安装目录。默认安装目录为：C:\\Program Files\\CirrusGate\\dlp3.0"), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(498),
	      "width": "600px",
	      "height": "400px"
	    }
	  }), _c('br'), _vm._v("\n 3、 点击“下一步”按钮，如果此计算机安装过DLP3.0，卸载后会有残余文件，忽略这些文件。"), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(499),
	      "width": "500px",
	      "height": "350px"
	    }
	  }), _c('br'), _vm._v("\n 4、 点击“是”，进入下一安装界面"), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(500),
	      "width": "500px",
	      "height": "350px"
	    }
	  }), _c('br'), _vm._v("\n 5、点击“下一步”，进入“准备开始安装”界面。"), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(489),
	      "width": "500px",
	      "height": "350px"
	    }
	  }), _c('br'), _vm._v("\n 6、 点击“安装”按钮，显示安装进度条。"), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(490),
	      "width": "500px",
	      "height": "350px"
	    }
	  }), _c('br'), _vm._v("\n 7、 安装完成后提示界面， 点击“完成”按钮，完成DLP3.0的Windows终端安装。"), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(491),
	      "width": "500px",
	      "height": "350px"
	    }
	  }), _c('br'), _c('br'), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "20px",
	      "color": "red"
	    }
	  }, [_vm._v("二、绑定账号")]), _c('br'), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "18px",
	      "color": "red"
	    }
	  }, [_vm._v("注意 ：部分域内WINDOWS用户会自动绑定，无需以下步骤！！！！！！")]), _c('br'), _vm._v("\n  安装完成后 会跳出如下界面"), _c('br'), _c('br'), _vm._v(" "), _vm._m(4), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"../assets/dataLeakInstallForWin/dataLeakInstallForWin_pic13.png\""); e.code = 'MODULE_NOT_FOUND'; throw e; }())),
	      "width": "400px",
	      "height": "300px"
	    }
	  }), _c('br'), _c('br'), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "25px",
	      "color": "red"
	    }
	  }, [_vm._v("安装过程中，程序会自动识别您的mis账号，若无法识别，程序会打开一个浏览器，并打开一个如下的注册页面，请务必真实填写您的真实信息！！"), _c('br'), _vm._v("\n  如果未出现弹窗说明被系统识别mis账号，忽略此步骤（"), _c('span', {
	    staticStyle: {
	      "color": "blue"
	    }
	  }, [_vm._v("已安装却仍收到SSO消息提醒 ，解决方法详见")]), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "color": "#63B8FF",
	      "text-decoration": "underline",
	      "cursor": "pointer"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.kmUrl('https://km.sankuai.com/page/19884626')
	      }
	    }
	  }, [_vm._v("已安装却仍收到SSO消息提醒")]), _vm._v("\n  ）")]), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(492),
	      "width": "500px",
	      "height": "400px"
	    }
	  }), _c('br'), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "15px",
	      "color": "red"
	    }
	  }, [_vm._v("有问题可以直接大象6000或者私聊huawei02。")]), _vm._v(" "), _c('br'), _c('br')])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', {
	    staticStyle: {
	      "text-align": "start"
	    }
	  }, [_vm._v("软件下载地址："), _c('a', {
	    staticClass: "ct-link",
	    staticStyle: {
	      "color": "#1890ff"
	    },
	    attrs: {
	      "title": "https://itportal.sankuai.com/",
	      "href": "https://itportal.sankuai.com/",
	      "rel": "noopener",
	      "target": "_blank"
	    }
	  }, [_vm._v("https://itportal.sankuai.com/")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_c('span', {
	    staticStyle: {
	      "color": "rgb(112, 112, 112)"
	    }
	  }, [_vm._v("一、软件安装")]), _vm._v("DLP主要安装过程包含三部分内容：")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_c('span', {
	    staticStyle: {
	      "color": "rgb(112, 112, 112)"
	    }
	  }, [_vm._v("一、软件安装")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', {
	    staticStyle: {
	      "text-align": "start"
	    }
	  }, [_c('span', {
	    staticStyle: {
	      "color": "rgb(255, 0, 0)"
	    }
	  }, [_vm._v("一、软件安装")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticStyle: {
	      "font-size": "25px",
	      "color": "red"
	    }
	  }, [_vm._v("注意 ："), _c('br'), _vm._v("\n （1）账号为mis账号，请填写正确的mis账号；"), _c('br'), _vm._v("\n （2）如使用自己的mis帐号提示用户名不存在，请输入meituan。"), _c('br'), _vm._v("\n  如：用户名：meituan")])
	}]}

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "select-container clearfix",
	    staticStyle: {
	      "margin-top": "2%",
	      "margin-left": "2%",
	      "float": "left"
	    }
	  }, [_c('span', {
	    staticStyle: {
	      "font-size": "30px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("终端安全不合规")]), _c('br'), _c('br'), _vm._v("\n               "), _c('span', {
	    staticStyle: {
	      "font-weight": "bold",
	      "color": "red"
	    }
	  }, [_vm._v("同学你好，你的PC终端安全不合规")]), _vm._v("。为规范我公司办公网计算机风险威胁防范工作，保证办公网络和办公信息系统的安全稳定运行，\n        特推广落实终端安全管理解决方案，请务必保证PC终端已安装和运行赛门铁克杀毒软件、数据防泄漏客户端（DLP）和美团安全管理客户端（MOA），\n        请根据以下步骤进行检查终端不合规的详细原因并进行修复。"), _c('br'), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "15px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("1、打开MOA客户端页面，点击“安全基线检查”按钮；")]), _c('br'), _c('br'), _vm._v("\n        a.windows打开MOA客户端方法，如下图所示单击以下图标；"), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(593),
	      "width": "500px",
	      "height": "150px"
	    }
	  }), _c('br'), _vm._v("\n        在跳出的MOA客户端界面上选择“安全基线检查”选项，查看安全基线检查结果。"), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(594),
	      "width": "600px",
	      "height": "400px"
	    }
	  }), _c('br'), _vm._v("\n        b、Mac系统打开MOA客户端方法：点击运行的MOA图标。在跳出的MOA客户端界面上选择“安全基线检测”选项，查看安全基线检查结果。"), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(595),
	      "width": "600px",
	      "height": "400px"
	    }
	  }), _c('br'), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "15px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("2、排查“安全基线检查”。")]), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(596),
	      "width": "800px",
	      "height": "500px"
	    }
	  }), _c('br'), _c('br'), _vm._v("\n        a.赛门铁克杀毒软件已安装 显示红色\n        "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(55),
	      "width": "40px",
	      "height": "30px"
	    }
	  }), _vm._v("\n        ，表示赛门铁克杀毒软件未安装，请从此处进入\n        "), _c('span', {
	    staticStyle: {
	      "color": "#63B8FF",
	      "text-decoration": "underline",
	      "cursor": "pointer"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.routerUrl('/saimenInstallForWin')
	      }
	    }
	  }, [_vm._v("杀软安装指南—Windows")]), _vm._v("，\n        "), _c('span', {
	    staticStyle: {
	      "color": "#63B8FF",
	      "text-decoration": "underline",
	      "cursor": "pointer"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.routerUrl('/saimenInstallForMac')
	      }
	    }
	  }, [_vm._v("杀软安装指南--macOS")]), _vm._v("。"), _c('br'), _vm._v("\n        b.数据防泄漏客户端已安装 显示红色\n        "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(55),
	      "width": "40px",
	      "height": "30px"
	    }
	  }), _vm._v("\n        ，表示数据防泄漏客户端未安装，请从此处进入\n        "), _c('span', {
	    staticStyle: {
	      "color": "#63B8FF",
	      "text-decoration": "underline",
	      "cursor": "pointer"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.routerUrl('/dataLeakInstallForWin')
	      }
	    }
	  }, [_vm._v("DLP安装指南--Windows")]), _vm._v("，\n        "), _c('span', {
	    staticStyle: {
	      "color": "#63B8FF",
	      "text-decoration": "underline",
	      "cursor": "pointer"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.routerUrl('/dataLeakInstallForMac')
	      }
	    }
	  }, [_vm._v("DLP安装指南--macOS")]), _vm._v("。"), _c('br'), _vm._v("\n        c.赛门铁克杀毒软件已运行 显示红色\n        "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(55),
	      "width": "40px",
	      "height": "30px"
	    }
	  }), _vm._v("\n        ，表示数据防泄漏客户端未安装，请从此处进入\n        "), _c('span', {
	    staticStyle: {
	      "color": "#63B8FF",
	      "text-decoration": "underline",
	      "cursor": "pointer"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.routerUrl('/windowRepairUnstart')
	      }
	    }
	  }, [_vm._v("杀软安装指南—Windows")]), _vm._v("，\n        "), _c('span', {
	    staticStyle: {
	      "color": "#63B8FF",
	      "text-decoration": "underline",
	      "cursor": "pointer"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.routerUrl('/macRepairUnstart')
	      }
	    }
	  }, [_vm._v("杀软安装指南--macOS")]), _vm._v("。"), _c('br'), _vm._v("\n        d.数据防泄漏客户端已运行 显示红色\n        "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(55),
	      "width": "40px",
	      "height": "30px"
	    }
	  }), _vm._v("\n        ，表示数据防泄漏客户端未安装，请从此处进入\n        "), _c('span', {
	    staticStyle: {
	      "color": "#63B8FF",
	      "text-decoration": "underline",
	      "cursor": "pointer"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.routerUrl('/dataLeakInstallForWin')
	      }
	    }
	  }, [_vm._v("DLP安装指南--Windows")]), _vm._v("，\n        "), _c('span', {
	    staticStyle: {
	      "color": "#63B8FF",
	      "text-decoration": "underline",
	      "cursor": "pointer"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.routerUrl('/dataLeakInstallForMac')
	      }
	    }
	  }, [_vm._v("DLP安装指南--macOS")]), _vm._v("。"), _c('br'), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "15px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("3、以上提示的红色修复完成后，请重新登录应用系统，如还有问题，请大象联系6000")]), _c('br'), _vm._v("\n        a.如遇特殊情紧急情况，员工可申请临时白名单，申请页面请从此进入\n        "), _c('span', {
	    staticStyle: {
	      "color": "#63B8FF",
	      "text-decoration": "underline",
	      "cursor": "pointer"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.routerUrl('/whiteApply')
	      }
	    }
	  }, [_vm._v("临时白名单")])])])
	},staticRenderFns: []}

/***/ }),
/* 634 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "document-container"
	  }, [(_vm.$store.state.is_manager) ? _c('div', {
	    staticClass: "edit-document-button"
	  }, [_c('el-button', {
	    staticClass: "circle-button",
	    attrs: {
	      "type": "primary",
	      "icon": "el-icon-edit",
	      "title": "编辑"
	    },
	    on: {
	      "click": _vm.editorDocument
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('a', {
	    staticClass: "el-link el-link--danger is-underline",
	    on: {
	      "click": function($event) {
	        _vm.centerDialogVisible = true
	      }
	    }
	  }, [_c('span', {
	    staticClass: "el-link--inner"
	  }, [_vm._v("如果图片无法显示，请点击。（Click here to refresh the image.）")])]), _vm._v(" "), _c('div', {
	    staticClass: "document-title"
	  }, [_c('p', {
	    staticClass: "documentTitle",
	    domProps: {
	      "textContent": _vm._s(_vm.title)
	    }
	  })]), _vm._v(" "), _c('div', {
	    ref: "contentWrapper",
	    staticClass: "document-content"
	  }), _vm._v(" "), _c('el-dialog', {
	    attrs: {
	      "title": "学城图片认证（Citadel Image Verification）",
	      "visible": _vm.centerDialogVisible,
	      "width": "500px",
	      "center": "",
	      "show-close": false
	    },
	    on: {
	      "update:visible": function($event) {
	        _vm.centerDialogVisible = $event
	      }
	    }
	  }, [_c('iframe', {
	    staticClass: "iframe",
	    attrs: {
	      "src": "https://km.sankuai.com/api/file/cdn/277659316/277785340?contentType=1&isNewContent=true&isNewContent=false"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "success-message"
	  }, [_vm._v("认证成功（Verified）")]), _vm._v(" "), _c('span', {
	    staticClass: "dialog-footer",
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [_c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": _vm.closeDialogFun
	    }
	  }, [_vm._v("确 定（Confirm）")])], 1)])], 1)
	},staticRenderFns: []}

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "select-container clearfix",
	    staticStyle: {
	      "margin-top": "2%",
	      "margin-left": "2%",
	      "float": "left"
	    }
	  }, [_c('span', {
	    staticStyle: {
	      "font-size": "38px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("Windows FAQ")]), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "30px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("1、Windows端MOA安装包打不开怎么办？")]), _c('br'), _c('br'), _vm._v(" "), _c('p', [_c('strong', [_vm._v("解决办法：")])]), _vm._v(" "), _c('p', [_vm._v("    a、先到安装包下载目录刷新一下。")]), _vm._v(" "), _c('p', [_vm._v("    b、右键安装包-->\"属性\",查看安装包大小是否正确，如果不正确则重新下载。")]), _vm._v(" "), _c('p', [_vm._v("    c、将安装包加入杀毒软件信任白名单。")]), _vm._v(" "), _c('p', [_vm._v("    d、如果还打不开，请联系信息安全部 jijuntao，yuyutang。")]), _c('br'), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "30px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("2、Windows端MOA如何进行手动更新？")]), _c('br'), _c('br'), _vm._v(" "), _c('p', [_c('strong', [_vm._v("解决办法：")])]), _c('p'), _c('p', [_vm._v("    “以管理员身份运行”运行安装包，直接覆盖安装即可。")]), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "30px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("3、Windows端MOA安装时被杀毒软件报为病毒")]), _c('br'), _c('br'), _vm._v(" "), _c('p', [_c('strong', [_vm._v("解决办法：")])]), _vm._v(" "), _c('p', [_vm._v("    此为杀毒软件误报，将安装包加入信任白名单即可。")]), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "30px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("4、Windows端MOA安装时提示需要输入管理员用户名和密码")]), _c('br'), _c('br'), _vm._v(" "), _c('p', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(598),
	      "width": "400px",
	      "height": "420px"
	    }
	  })]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("解决办法：")])]), _vm._v(" "), _c('p', [_vm._v("    此为当前用户没有管理员权限，输入管理员密码即可。")]), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "30px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("5、提示“禁止重复运行itsecClient 程序！”")]), _c('br'), _c('br'), _vm._v(" "), _c('p', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(599),
	      "width": "330px",
	      "height": "220px"
	    }
	  })]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("原因：")])]), _vm._v(" "), _c('p', [_vm._v("    遇到这种情况说明MOA客户端程序已经运行。如果仍然不能看到MOA运行界面，则重新运行MOA客户端程序。")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("解决办法：")])]), _vm._v(" "), _c('p', [_vm._v("    a、先杀掉当前的MOA进程，在任务管理器中结束 itsecClient.exe和itsecClientUpdate.exe。")]), _vm._v(" "), _c('p', [_vm._v("    b、以管理员权限运行itsecClient.exe。")]), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "30px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("6、提示“duang！程序遇到问题即将要关闭”")]), _c('br'), _c('br'), _vm._v(" "), _c('p', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(600),
	      "width": "400px",
	      "height": "200px"
	    }
	  })]), _vm._v(" "), _c('p', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(601),
	      "width": "500px",
	      "height": "200px"
	    }
	  })]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("解决办法：")])]), _vm._v(" "), _c('p', [_vm._v("    a、尝试重新运行moa客户端程序。")]), _vm._v(" "), _c('p', [_vm._v("    b、请联系信息安全部 jijuntao，yuyutang。")]), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "30px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("7、MOA界面上显示“客户端状态 离线”")]), _c('br'), _c('br'), _vm._v(" "), _c('p', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(602),
	      "width": "600px",
	      "height": "400px"
	    }
	  })]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("解决办法：")])]), _vm._v(" "), _c('p', [_vm._v("    a、检查网络是否正常，是否能正常访问互联网和公司办公系统。")]), _vm._v(" "), _c('p', [_vm._v("    b、询问是否被其他同事扫码。")]), _vm._v(" "), _c('p', [_vm._v("    c、使用新的安装包重新安装。/p>\n  ")]), _c('p', [_vm._v("    d、请联系信息安全部 jijuntao，yuyutang。")]), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "30px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("8、提示“加载资源文件失败”")]), _c('br'), _c('br'), _vm._v(" "), _c('p', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(603),
	      "width": "700px",
	      "height": "450px"
	    }
	  })]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("原因：")])]), _vm._v(" "), _c('p', [_vm._v("    组件缺失，卸载时删掉了资源文件，但是进程还在运行。")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("解决办法：")])]), _vm._v(" "), _c('p', [_vm._v("    使用最新的安装包覆盖安装即可。")]), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "30px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("9、MOA版本查看")]), _c('br'), _c('br'), _vm._v(" "), _c('p', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(604),
	      "width": "900px",
	      "height": "660px"
	    }
	  })])])])
	}]}

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "select-container clearfix",
	    staticStyle: {
	      "margin-top": "2%",
	      "margin-left": "2%",
	      "float": "left"
	    }
	  }, [_c('span', {
	    staticStyle: {
	      "font-size": "30px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("macOS操作系统安装MOA")]), _c('br'), _c('br'), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "28px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("1、macOS操作系统版本要求")]), _c('br'), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "background": "#CCFFFF",
	      "width": "100%",
	      "height": "30px"
	    }
	  }, [_c('span', [_c('p', [_vm._v("macOS操作系统版本 > 10.11")])])]), _vm._v(" "), _c('span', [_vm._v("查看macOS操作系统版本：")]), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(519),
	      "width": "740px",
	      "height": "360px"
	    }
	  }), _c('br'), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "28px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("2、MAC版MOA下载")]), _c('br'), _vm._v(" "), _c('table', {
	    attrs: {
	      "border": "1",
	      "cellpadding": "10",
	      "cellspacing": "0",
	      "width": "100%"
	    }
	  }, [_c('tr', [_c('th', [_vm._v("下载地址")])]), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
	    staticClass: "ct-link",
	    staticStyle: {
	      "color": "#1890ff"
	    },
	    attrs: {
	      "data-auto_update": "0",
	      "data-pageid": "",
	      "href": "https://itportal.sankuai.com/",
	      "target": "_blank",
	      "rel": "noopener"
	    }
	  }, [_vm._v("\n        https://itportal.sankuai.com/")]), _vm._v("（移步IT门户）")])])]), _c('br'), _c('br'), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "28px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("3、MOA安装流程")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("a、双击打开安装包")]), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(520),
	      "width": "540px",
	      "height": "160px"
	    }
	  }), _c('br'), _vm._v(" "), _c('span', [_vm._v("b、一路“继续”，直到需要输入本地管理员密码授权安装，请您输入正确的本地管理员密码。")]), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(521),
	      "width": "640px",
	      "height": "360px"
	    }
	  }), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(522),
	      "width": "640px",
	      "height": "360px"
	    }
	  }), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(523),
	      "width": "640px",
	      "height": "360px"
	    }
	  }), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(524),
	      "width": "640px",
	      "height": "360px"
	    }
	  }), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(525),
	      "width": "640px",
	      "height": "360px"
	    }
	  }), _c('br'), _vm._v(" "), _c('span', [_vm._v("c、安装成功后会跳出扫码登陆界面，如果未跳出该界面，请在“应用程序”中找到MOA客户端，点击打开。使用大象扫码登陆或选择输入账号密码登陆。")]), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(526),
	      "width": "640px",
	      "height": "360px"
	    }
	  }), _c('br'), _vm._v(" "), _c('span', [_vm._v("扫码登陆成功后会跳出“协议签署”，请仔细阅读“安全管理客户端用户协议”后，然后选择“同意”。")]), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(527),
	      "width": "640px",
	      "height": "360px"
	    }
	  }), _c('br'), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "28px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("4、安装完成确认")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("a、客户端在线确认")]), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(528),
	      "width": "640px",
	      "height": "360px"
	    }
	  }), _c('br'), _vm._v(" "), _c('span', [_vm._v("b、安装版本确认")]), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(529),
	      "width": "640px",
	      "height": "360px"
	    }
	  }), _c('br'), _vm._v(" "), _c('span', [_vm._v("c、绑定MOA账号确认")]), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(530),
	      "width": "640px",
	      "height": "360px"
	    }
	  }), _c('br'), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "28px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("5、安装异常解决")]), _c('br'), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "25px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("5.1 打不开MOA安装包，因为它来自身份不明的开发者。")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("安装时报错如图：“打不开“办公软件_企业内部软件_MOA_MOA-1.2.2.10-release.pkg”，因为它来自身份不明的开发者。“")]), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(531),
	      "width": "640px",
	      "height": "360px"
	    }
	  }), _c('br'), _vm._v(" "), _c('span', [_vm._v("解决方法：在“系统偏好设置“-->”“安全性与隐私”-->\"通用\" 中找到阻止MOA打开的选项， 选择“仍然打开”。")]), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(532),
	      "width": "540px",
	      "height": "360px"
	    }
	  }), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(533),
	      "width": "540px",
	      "height": "360px"
	    }
	  }), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(534),
	      "width": "440px",
	      "height": "300px"
	    }
	  }), _c('br')])])
	}]}

/***/ }),
/* 637 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    ref: "home_main",
	    staticStyle: {
	      "display": "block"
	    },
	    attrs: {
	      "id": "home"
	    }
	  }, [_c('el-container', {
	    staticClass: "con_section"
	  }, [_c('el-header', {
	    staticClass: "blueheader"
	  }, [_c('el-row', {
	    staticStyle: {
	      "height": "60px"
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 4
	    }
	  }, [_c('h2', {
	    staticClass: "headlogo"
	  }, [_vm._v("美团安全修复提示（Meituan Security Fix Guide）")])]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "text-align": "right",
	      "float": "right"
	    }
	  }, [_c('el-dropdown', {
	    staticStyle: {
	      "height": "60px"
	    },
	    attrs: {
	      "placement": "top",
	      "trigger": "click"
	    },
	    on: {
	      "command": _vm.handleCommand
	    }
	  }, [_c('img', {
	    staticClass: "el-dropdown-link",
	    staticStyle: {
	      "margin": "10px",
	      "border-radius": "50%",
	      "width": "40px",
	      "height": "auto"
	    },
	    attrs: {
	      "src": _vm.imgUrl
	    }
	  }), _vm._v(" "), _c('el-dropdown-menu', {
	    staticStyle: {
	      "margin-top": "0"
	    },
	    attrs: {
	      "slot": "dropdown"
	    },
	    slot: "dropdown"
	  }, [_c('el-dropdown-item', {
	    attrs: {
	      "disabled": _vm.dropdown_item.disabled
	    }
	  }, [_vm._v(_vm._s(_vm.userName) + " " + _vm._s(_vm.mis_id) + "\n                                ")]), _vm._v(" "), _c('el-dropdown-item', {
	    attrs: {
	      "command": "2-0",
	      "divided": _vm.dropdown_item.divided
	    }
	  }, [_vm._v("退出")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "text-align": "center",
	      "float": "right"
	    }
	  }, [_c('el-menu', {
	    staticClass: "el-menu",
	    attrs: {
	      "mode": "horizontal"
	    }
	  }, [_c('el-menu-item', {
	    attrs: {
	      "index": "whitelist_apply"
	    },
	    on: {
	      "click": _vm.whitelist_apply
	    }
	  }, [_vm._v("\n                                白名单申请 ( Whitelist Application )\n                            ")])], 1)], 1), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "text-align": "center",
	      "float": "right",
	      "padding": "0 20px"
	    }
	  }, [_c('el-dropdown', {
	    attrs: {
	      "trigger": "click"
	    },
	    on: {
	      "command": _vm.handleLanguageChange
	    }
	  }, [_c('span', {
	    staticClass: "lang-switcher"
	  }, [_c('i', {
	    staticClass: "el-icon-global"
	  }), _vm._v("\n                          Language"), _c('i', {
	    staticClass: "el-icon-arrow-down"
	  })]), _vm._v(" "), _c('el-dropdown-menu', {
	    attrs: {
	      "slot": "dropdown"
	    },
	    slot: "dropdown"
	  }, _vm._l((_vm.languages), function(lang) {
	    return _c('el-dropdown-item', {
	      key: lang.value,
	      class: {
	        'selected': lang.value === _vm.currentLang
	      },
	      attrs: {
	        "command": lang.value
	      }
	    }, [_vm._v("\n                            " + _vm._s(lang.label) + "\n                          ")])
	  }), 1)], 1)], 1), _vm._v(" "), (_vm.is_manager) ? _c('div', {
	    staticStyle: {
	      "text-align": "center",
	      "float": "right",
	      "padding": "0 20px"
	    }
	  }, [_c('el-dropdown', {
	    attrs: {
	      "trigger": "click"
	    },
	    on: {
	      "command": _vm.handleMenuSelect
	    }
	  }, [_c('span', {
	    staticClass: "el-dropdown-link"
	  }, [_c('i', {
	    staticClass: "el-icon-setting"
	  }), _vm._v("\n                                      菜单管理\n                                  "), _c('i', {
	    staticClass: "el-icon-arrow-down el-icon--right"
	  })]), _vm._v(" "), _c('el-dropdown-menu', {
	    attrs: {
	      "slot": "dropdown"
	    },
	    slot: "dropdown"
	  }, [_c('el-dropdown-item', {
	    attrs: {
	      "command": "addItem"
	    }
	  }, [_vm._v("添加菜单")]), _vm._v(" "), _c('el-dropdown-item', {
	    attrs: {
	      "command": "updateItem"
	    }
	  }, [_vm._v("编辑菜单")]), _vm._v(" "), _c('el-dropdown-item', {
	    attrs: {
	      "command": "deleteItem"
	    }
	  }, [_vm._v("删除菜单")]), _vm._v(" "), _c('el-dropdown-item', {
	    attrs: {
	      "command": "addLangIndex"
	    }
	  }, [_vm._v("添加页面语言映射")])], 1)], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-container', {
	    staticStyle: {
	      "margin-top": "60px"
	    }
	  }, [_c('div', {
	    staticStyle: {
	      "width": "300px"
	    }
	  }, [_c('el-scrollbar', [_c('el-aside', {
	    staticStyle: {
	      "width": "300px"
	    }
	  }, [_c('el-menu', {
	    staticClass: "el-menu-vertical",
	    staticStyle: {
	      "height": "calc(100% - 40px)",
	      "overflow-y": "auto",
	      "width": "300px"
	    },
	    attrs: {
	      "default-active": _vm.activeItem,
	      "default-openeds": _vm.openItems,
	      "unique-opened": ""
	    },
	    on: {
	      "select": _vm.handleSelect
	    }
	  }, [_vm._l((_vm.documentItems), function(item) {
	    return _c('el-submenu', {
	      attrs: {
	        "index": item.value + ''
	      }
	    }, [_c('template', {
	      slot: "title"
	    }, [_c('i', {
	      staticClass: "el-icon-menu"
	    }), _vm._v(_vm._s(item.label))]), _vm._v(" "), _vm._l((item.children), function(child) {
	      return _c('div', [(child.children == null) ? _c('el-menu-item', {
	        staticStyle: {
	          "overflow": "hidden",
	          "text-overflow": "ellipsis",
	          "white-space": "nowrap"
	        },
	        attrs: {
	          "index": child.value + ''
	        }
	      }, [_vm._v("\n                                                " + _vm._s(child.label) + "\n                                            ")]) : _c('el-submenu', {
	        attrs: {
	          "index": child.value + ''
	        }
	      }, [_c('template', {
	        slot: "title"
	      }, [_c('i', {
	        staticClass: "el-icon-menu"
	      }), _vm._v(_vm._s(child.label))]), _vm._v(" "), _vm._l((child.children), function(childOne) {
	        return _c('div', [(childOne.children == null) ? _c('el-menu-item', {
	          staticStyle: {
	            "overflow": "hidden",
	            "text-overflow": "ellipsis",
	            "white-space": "nowrap"
	          },
	          attrs: {
	            "index": childOne.value + ''
	          }
	        }, [_vm._v("\n                                                        " + _vm._s(childOne.label) + "\n                                                    ")]) : _c('el-submenu', {
	          attrs: {
	            "index": childOne.value + ''
	          }
	        }, [_c('template', {
	          slot: "title"
	        }, [_c('i', {
	          staticClass: "el-icon-menu"
	        }), _vm._v(_vm._s(childOne.label) + "\n                                                        ")]), _vm._v(" "), _vm._l((childOne.children), function(childTwo) {
	          return _c('el-menu-item', {
	            attrs: {
	              "index": childTwo.value + ''
	            }
	          }, [_vm._v(_vm._s(childTwo.label) + "\n                                                        ")])
	        })], 2)], 1)
	      })], 2)], 1)
	    })], 2)
	  })], 2)], 1)], 1)], 1), _vm._v(" "), _c('el-main', {
	    staticClass: "home_main"
	  }, [_c('div', {
	    staticClass: "router-view-container"
	  }, [_c('router-view')], 1)])], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 638 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('menus')], 1)
	},staticRenderFns: []}

/***/ }),
/* 639 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.$store.state.is_manager) ? _c('div', [_c('div', {
	    staticClass: "select-container clearfix",
	    staticStyle: {
	      "margin-top": "6%",
	      "margin-left": "33%",
	      "float": "center"
	    }
	  }, [_c('el-form', {
	    ref: "form",
	    attrs: {
	      "model": _vm.form,
	      "label-width": "130px"
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "修改目录："
	    }
	  }, [_c('el-select', {
	    attrs: {
	      "placeholder": "请选择"
	    },
	    model: {
	      value: (_vm.value),
	      callback: function($$v) {
	        _vm.value = $$v
	      },
	      expression: "value"
	    }
	  }, _vm._l((_vm.form.options), function(item) {
	    return _c('el-option', {
	      key: item.value,
	      attrs: {
	        "label": item.label,
	        "value": item.value,
	        "disabled": item.disabled
	      }
	    })
	  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "目录名："
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 6
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "placeholder": "请输入您要修改的目录名"
	    },
	    model: {
	      value: (_vm.form.title),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "title", $$v)
	      },
	      expression: "form.title"
	    }
	  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": _vm.onSubmit
	    }
	  }, [_vm._v("确认修改")])], 1)], 1)], 1)]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "select-container clearfix",
	    staticStyle: {
	      "margin-top": "2%",
	      "margin-left": "2%",
	      "float": "left"
	    }
	  }, [_c('span', {
	    staticStyle: {
	      "font-size": "30px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("DLP安装指南 for mac")]), _c('br'), _c('br'), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "30px",
	      "font-weight": "bold",
	      "color": "red"
	    }
	  }, [_vm._v("MAC终端包安装完成后会重启操作系统，请勿在安装过程中升级操作系统~")]), _c('br'), _c('br'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(479),
	      "width": "850px",
	      "height": "200px"
	    }
	  }), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(480),
	      "width": "850px",
	      "height": "330px"
	    }
	  }), _c('br'), _vm._v("\n    一、软件安装"), _c('br'), _vm._v("\n    二、绑定用户名"), _c('br'), _c('br'), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "20px",
	      "color": "red"
	    }
	  }, [_vm._v("一、软件安装")]), _c('br'), _vm._v("\n  解压文件， 双击安装包MTDLP.pkg，若弹出一下窗口："), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(474),
	      "width": "500px",
	      "height": "230px"
	    }
	  }), _c('br'), _vm._v("\n  则打开 “系统偏好设置” -“安全性与隐私”，选择“通用”，点击 “仍要打开”。"), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(481),
	      "width": "500px",
	      "height": "450px"
	    }
	  }), _c('br'), _vm._v("\n  再次双击安装包MTDLP.pkg，弹出框图填写mis账号（外包职场用户在本步骤中请填写meituan）"), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(482),
	      "width": "380px",
	      "height": "150px"
	    }
	  }), _c('br'), _vm._v("\n  1. 点击“继续”"), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(483),
	      "width": "550px",
	      "height": "400px"
	    }
	  }), _c('br'), _vm._v("\n  2. 点击“继续”，并同意协议条款"), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(484),
	      "width": "550px",
	      "height": "400px"
	    }
	  }), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(485),
	      "width": "550px",
	      "height": "400px"
	    }
	  }), _c('br'), _vm._v("\n  3. 点击“继续”"), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(486),
	      "width": "550px",
	      "height": "400px"
	    }
	  }), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(487),
	      "width": "550px",
	      "height": "400px"
	    }
	  }), _c('br'), _vm._v("\n  此处密码使用"), _c('span', {
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v("登录电脑系统的密码")]), _vm._v("。"), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(488),
	      "width": "550px",
	      "height": "400px"
	    }
	  }), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(475),
	      "width": "550px",
	      "height": "400px"
	    }
	  }), _c('br'), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "20px",
	      "color": "red"
	    }
	  }, [_vm._v("二、绑定账号")]), _c('br'), _c('br'), _vm._v("\n  安装完成后 会跳出如下界面"), _c('br'), _c('br'), _vm._v(" "), _vm._m(1), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(476),
	      "width": "550px",
	      "height": "400px"
	    }
	  }), _c('br'), _c('br'), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "15px",
	      "color": "red"
	    }
	  }, [_vm._v("输入用户名，点击确认后，窗口会自动缩小，代表已经绑定成功了。")]), _c('br'), _c('br'), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "25px",
	      "color": "red"
	    }
	  }, [_vm._v("安装过程中，程序会自动识别您的mis账号，若无法识别，程序会打开一个浏览器，并打开一个如下的注册页面，请务必真实填写您的真实信息！！"), _c('br'), _vm._v("\n  如果未出现弹窗说明被系统识别mis账号，忽略此步骤（已安装却仍收到SSO消息提醒 ，解决方法详见\n  "), _c('span', {
	    staticStyle: {
	      "color": "#63B8FF",
	      "text-decoration": "underline",
	      "cursor": "pointer"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.kmUrl('https://km.sankuai.com/page/19884626')
	      }
	    }
	  }, [_vm._v("已安装却仍收到SSO消息提醒")]), _vm._v("）")]), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(477),
	      "width": "550px",
	      "height": "400px"
	    }
	  }), _c('br'), _vm._v(" "), _vm._m(2), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(478),
	      "width": "600px",
	      "height": "450px"
	    }
	  }), _c('br'), _vm._v("\n  解决方法：是因为mac系统语言使用的是英文，出现内容乱码，直接continue即可（不影响后续使用）。"), _c('br'), _c('br'), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v("由于评论较多，可能不能及时回复，有问题可以直接大象6000或者私聊huawei02。")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_vm._v("软件下载地址："), _c('a', {
	    staticClass: "ct-link",
	    staticStyle: {
	      "color": "#1890ff"
	    },
	    attrs: {
	      "title": "https://itportal.sankuai.com/",
	      "href": "https://itportal.sankuai.com/",
	      "rel": "noopener",
	      "target": "_blank"
	    }
	  }, [_vm._v("https://itportal.sankuai.com/")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticStyle: {
	      "font-size": "30px",
	      "color": "red"
	    }
	  }, [_vm._v("注意 ："), _c('br'), _vm._v("\n （1）账号为mis账号，请填写正确的mis账号；"), _c('br'), _vm._v("\n （2）如使用自己的mis帐号提示用户名不存在，请输入meituan。"), _c('br'), _vm._v("\n  如：用户名：meituan ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticStyle: {
	      "font-size": "25px",
	      "color": "green"
	    }
	  }, [_vm._v("MAC版本安装过程TIPS："), _c('br'), _vm._v("\n  mac终端安装过程中出现如下内容乱码情况")])
	}]}

/***/ }),
/* 641 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.$store.state.is_manager) ? _c('div', [_c('div', {
	    staticClass: "edit-document-button",
	    class: _vm.scroll.headerFixed ? 'fix-button-top' : ''
	  }, [_c('el-button', {
	    staticClass: "circle-button",
	    attrs: {
	      "type": "success",
	      "icon": "el-icon-check",
	      "title": "保存"
	    },
	    on: {
	      "click": _vm.addContent
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "document-title"
	  }, [_c('el-row', {
	    staticStyle: {
	      "height": "60px"
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 20
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.currentTitle),
	      expression: "currentTitle"
	    }],
	    staticClass: "documentTitle",
	    staticStyle: {
	      "outline": "none"
	    },
	    attrs: {
	      "placeholder": "标题"
	    },
	    domProps: {
	      "value": (_vm.currentTitle)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.currentTitle = $event.target.value
	      }
	    }
	  })])], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	    staticClass: "toolbar",
	    attrs: {
	      "id": "toolbar"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "wrapper"
	  }, [_c('div', {
	    ref: "content",
	    staticClass: "editor",
	    attrs: {
	      "id": "editor"
	    }
	  })])]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "select-container clearfix",
	    staticStyle: {
	      "margin-top": "2%",
	      "margin-left": "2%",
	      "float": "left"
	    }
	  }, [_c('span', {
	    staticStyle: {
	      "font-size": "38px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("其它 FAQ")]), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "30px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("1、如何判断是否成功安装MOA")]), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("MOA安装完成后，首次运行需要"), _c('span', {
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v("使用自己的手机大象扫码")]), _vm._v("，在看到类似如下的MOA界面后，说明安装成功。")]), _vm._v(" "), _c('p', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(553),
	      "width": "600px",
	      "height": "370px"
	    }
	  })]), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "30px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("2、提供给6000同学安装状态查询接口")]), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("安装状态查询接口："), _c('a', {
	    staticClass: "ct-link",
	    staticStyle: {
	      "color": "#1890ff"
	    },
	    attrs: {
	      "data-auto_update": "0",
	      "data-pageid": "",
	      "href": "https://report-mon.sankuai.com/report/api/check_status?mis_id=wangzepeng05",
	      "target": "_blank",
	      "rel": "noopener"
	    }
	  }, [_vm._v("https://report-mon.sankuai.com/report/api/check_status?mis_id=wangzepeng05")])]), _vm._v(" "), _c('p', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(554),
	      "width": "1000px",
	      "height": "80px"
	    }
	  })]), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "30px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("3、如何修改MOA绑定的mis号")]), _c('br'), _c('br'), _vm._v(" "), _c('p', [_c('span', {
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v("当前不支持mis号修改")]), _vm._v("，所以一定要提醒同事安装时"), _c('span', {
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v("用自己的手机大象扫码")]), _vm._v("。")]), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "30px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("4、申请MOA白名单条件及申请流程")]), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("MOA不支持的系统：Windows xp、Linux（Ubuntu等）")]), _vm._v(" "), _c('p', [_vm._v("申请流程：如工作需要，不能从Windows XP 升级到Windows 7或Windows 10，可参考"), _c('a', {
	    staticClass: "ct-link",
	    staticStyle: {
	      "color": "#1890ff"
	    },
	    attrs: {
	      "data-auto_update": "0",
	      "data-pageid": "64163063",
	      "href": "https://km.sankuai.com/page/64163063",
	      "target": "_blank",
	      "rel": "noopener"
	    }
	  }, [_vm._v("MOA/DLP白名单申请流程")]), _vm._v(" 。")]), _vm._v(" "), _c('p', [_vm._v("说明：因为微软已不维护Windows XP、Windows 2003、Windows 8系统，即将不支持维护Windows 10，所以"), _c('strong', [_vm._v("如果这些系统曝出存在新的漏洞，微软也不会对这些系统提供安全补丁")]), _vm._v("，存在很大的安全风险。对Windows用户，我们"), _c('strong', [_vm._v("强烈建议使用Windows10系统进行办公")]), _vm._v("。")]), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "30px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("5、临时不安装MOA的条件及申请流程")]), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("临时条件：产假、长期病假")]), _vm._v(" "), _c('p', [_vm._v("流程：请提交名单列表给信息安全部 jijuntao、pengzhengmao、wangzepeng05。")]), _vm._v(" "), _c('p', [_vm._v("说明：员工在返回岗位后，仍然需要安装MOA，否则"), _c('strong', [_vm._v("会影响对公司办公网络和业务系统的正常访问，影响员工正常办公")]), _vm._v("。")]), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "30px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("6、正在申请离职的员工是否可以不安装或是否可以申请白名单？")]), _c('br'), _c('br'), _vm._v(" "), _c('p', [_c('span', {
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v("a、严禁正在申请离职的员工申请MOA和DLP白名单。")])]), _vm._v(" "), _c('p', [_vm._v("b、如已提交离职申请，但是工作交接还有一周以上的员工，"), _c('span', {
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v("仍需安装MOA和DLP。")])]), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "30px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("7、私人电脑是否需要安装公司MOA？")]), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("私人电脑如果用于正常办公，就需要安装公司的MOA。比如:有些同事的公司电脑、私人电脑都用于正常办公，那两台电脑都需要安装MOA。")]), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "30px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("8、如果MOA被其他同事扫码，该怎么处理？")]), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("说明：参考FAQ 3")]), _vm._v(" "), _c('p', [_vm._v("解决方法：将 当前同事 及 扫码同事 的mis号提交给 信息安全部 jijuntao、pengzhengmao、wangzepeng05 处理。")]), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "30px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("9、使用了已离职同事的电脑，MOA已安装好，该怎么处理？")]), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("将 当前同事 及 已离职同事 的mis号提交给信息安全部 jijuntao、pengzhengmao、wangzepeng05 处理。")]), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "30px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("10、非电脑设备用于办公，如手机、pad等，是否需要安装MOA？")]), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("MOA目前支持Windows 7，Windows 10及苹果电脑部署，暂不支持移动端部署。")]), _vm._v(" "), _c('p', [_vm._v("解决办法：由当事人领导提供名单列表，联系信息安全部 jijuntao、pengzhengmao、wangzepeng05 处理。")]), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "30px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("11、MOA阻断策略上线后，被限制访问处理方法")]), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("a、用户被阻断策略阻断后，会出现如下限制访问提示页面，根据提示检查自己电脑上MOA和DLP的安装和运行状态。")]), _vm._v(" "), _c('p', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(555),
	      "width": "900px",
	      "height": "500px"
	    }
	  })]), _vm._v(" "), _c('p', [_vm._v("b、针对不能立即安装MOA，但是又需要访问内部系统的用户，建议走临时白名单申请，请参考限制访问提示页面中白名单申请：【MOA: "), _c('a', {
	    staticClass: "ct-link",
	    staticStyle: {
	      "color": "#1890ff"
	    },
	    attrs: {
	      "data-auto_update": "0",
	      "data-pageid": "",
	      "href": "https://reg-sec.meituan.com/moa/bypass?token=moa",
	      "target": "_blank",
	      "rel": "noopener"
	    }
	  }, [_vm._v("https://reg-sec.meituan.com/moa/bypass?token=moa")]), _vm._v(" 】临时申请白名单。")]), _vm._v(" "), _c('p', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(556),
	      "width": "700px",
	      "height": "110px"
	    }
	  })]), _vm._v(" "), _c('p', [_vm._v("c、请注意，白名单时效为四小时，四小时后就时效，请及时安装MOA。白名单只允许申请三次。")]), _vm._v(" "), _c('p', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(557),
	      "width": "750px",
	      "height": "370px"
	    }
	  })]), _vm._v(" "), _c('p', [_vm._v("d、用户完成安装MOA后，由于MOA数据同步需要10分钟左右，建议可先自行申请临时白名单保证当前可正常访问网络，再安装MOA。")]), _vm._v(" "), _c('p', [_vm._v("      白名单生效时间为五分钟，生效后，关闭浏览器所有页面后再重新打开需要访问的内部系统即可。")]), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "30px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("12、MOA已安装，仍被限制访问，如何解决？")]), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("a、判断大象扫码登录或申请白名单时间，以上生效时间分别为10分钟（MOA安装），5分钟（白名单申请）。")]), _vm._v(" "), _c('p', [_vm._v("b、查询mis号安装状态:"), _c('a', {
	    staticClass: "ct-link",
	    staticStyle: {
	      "color": "#1890ff"
	    },
	    attrs: {
	      "data-auto_update": "0",
	      "data-pageid": "",
	      "href": "https://report-mon.sankuai.com/report/api/check_status?mis_id=wangzepeng05",
	      "target": "_blank",
	      "rel": "noopener"
	    }
	  }, [_vm._v("https://report-mon.sankuai.com/report/api/check_status?mis_id=wangzepeng05")]), _vm._v(" ，查看MOA和DLP的安装状态，是否DLP未正常安装。")]), _vm._v(" "), _c('p', [_vm._v("c、如果MOA安装时间，或者白名单申请时间已超过正常时间，MOA安装状态仍然是“N”，请联系信息安全部 wangzepeng05、jijuntao、pengzhengmao。")]), _vm._v(" "), _c('p', [_vm._v("d、如果mis号查询MOA安装状态为“Y”，员工仍被限制访问，请员工重启系统，重新打开Chrome浏览器，使用无痕模式尝试访问。")]), _vm._v(" "), _c('p', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(558),
	      "width": "250px",
	      "height": "300px"
	    }
	  })]), _vm._v(" "), _c('p', [_vm._v("e、彻底解决无法登陆的问题，请清除浏览器Cookie，具体方法可参考：")]), _vm._v(" "), _c('p', [_c('a', {
	    staticClass: "ct-link",
	    staticStyle: {
	      "color": "#1890ff"
	    },
	    attrs: {
	      "data-auto_update": "0",
	      "href": "https://jingyan.baidu.com/article/09ea3ede4a4127c0aede39a7.html",
	      "target": "_blank",
	      "rel": "noopener"
	    }
	  }, [_vm._v("https://jingyan.baidu.com/article/09ea3ede4a4127c0aede39a7.html")])]), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "30px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("13、覆盖安装未跳出签署协议")]), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("默认该电脑签署过一次MOA用户协议后，覆盖安装或升级，不会再跳出签署用户协议页面。")]), _vm._v(" "), _c('p', [_vm._v("除非彻底卸载MOA后的安装，才会跳出签署用户协议页面。")]), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "30px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("14、拒绝签署“安全管理客户端用户协议”")]), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("拒绝签署“安全管理客户端用户协议”，则表示退出MOA，MOA未正常运行，该电脑将无法登陆SSO，影响正常办公。")]), _vm._v(" "), _c('p', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(559),
	      "width": "900px",
	      "height": "630px"
	    }
	  })]), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "30px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("15、MOA版本过旧导致更新失败")]), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("MOA版本过旧在更新时会有更新失败的问题，请直接下载最新稳定版MOA进行覆盖安装即可。")]), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "30px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("16、已安装最新版本MOA，仍然被限制访问")]), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("如果当前检测MOA已经是最新版本，但仍然被限制访问。请重启电脑后再尝试访问内网。")])])])
	}]}

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "select-container clearfix",
	    staticStyle: {
	      "margin-top": "2%",
	      "margin-left": "2%",
	      "float": "left"
	    }
	  }, [_c('span', {
	    staticStyle: {
	      "font-size": "30px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("1、MAC上MOA版本查看")]), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("双击菜单栏的MOA图标打开MOA：")]), _vm._v(" "), _c('p', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(551),
	      "width": "480px",
	      "height": "170px"
	    }
	  })]), _vm._v(" "), _c('p', [_vm._v("「帮助」-->「版本更新」-->「更新版本」")]), _vm._v(" "), _c('p', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(549),
	      "width": "940px",
	      "height": "500px"
	    }
	  })]), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "30px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("2、Windows上MOA版本查看")]), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("双击菜单栏中已运行的MOA图标打开MOA：")]), _vm._v(" "), _c('p', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(552),
	      "width": "480px",
	      "height": "170px"
	    }
	  })]), _vm._v(" "), _c('p', [_vm._v("查看版本信息：")]), _vm._v(" "), _c('p', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(550),
	      "width": "940px",
	      "height": "500px"
	    }
	  })]), _vm._v(" "), _c('h1', {
	    staticStyle: {
	      "font-size": "30px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("3、如果无法打开MOA，或者更新不到最新版本")]), _vm._v(" "), _c('p', [_vm._v("如果无法打开MOA或者更新不到最新版本，请直接按照安装指导，下载最新版MOA覆盖安装即可。")])])])
	}]}

/***/ }),
/* 644 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.$store.state.is_manager) ? _c('div', [_c('div', {
	    staticClass: "select-container clearfix",
	    staticStyle: {
	      "margin-top": "6%",
	      "margin-left": "33%",
	      "float": "center"
	    }
	  }, [_c('el-form', {
	    ref: "form",
	    attrs: {
	      "label-width": "80px"
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "基础文档"
	    }
	  }, [_c('el-cascader', {
	    ref: "cascader",
	    attrs: {
	      "change-on-select": "",
	      "options": _vm.form.options,
	      "clearable": ""
	    },
	    model: {
	      value: (_vm.basePage),
	      callback: function($$v) {
	        _vm.basePage = $$v
	      },
	      expression: "basePage"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "映射文档"
	    }
	  }, [_c('el-cascader', {
	    ref: "cascader",
	    attrs: {
	      "change-on-select": "",
	      "options": _vm.form.options,
	      "clearable": ""
	    },
	    model: {
	      value: (_vm.relaPage),
	      callback: function($$v) {
	        _vm.relaPage = $$v
	      },
	      expression: "relaPage"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": _vm.checkSubmit
	    }
	  }, [_vm._v("提交")])], 1)], 1)], 1)]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "select-container clearfix",
	    staticStyle: {
	      "margin-top": "2%",
	      "margin-left": "2%",
	      "float": "left"
	    }
	  }, [_c('span', {
	    staticStyle: {
	      "font-size": "30px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("MOA客户端未安装")]), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("打开浏览器，复制粘贴如下URL：")]), _vm._v(" "), _c('p', [_vm._v("https://report-mon.sankuai.com/report/api/check_status?mis_id=pengzhengmao")]), _vm._v(" "), _c('p', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(597),
	      "width": "1040px",
	      "height": "100px"
	    }
	  })]), _vm._v(" "), _c('p', [_vm._v("将“pengzhengmao” 更换为自己的MIS账号，“MOA”：“Y” 则表示该MIS号已正常安装MOA。")])])])
	}]}

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "select-container clearfix",
	    staticStyle: {
	      "margin-top": "2%",
	      "margin-left": "2%",
	      "float": "left"
	    }
	  }, [_c('span', {
	    staticStyle: {
	      "font-size": "30px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("Windows操作系统安装MOA")]), _c('br'), _c('br'), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "28px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("1、Windows操作系统版本要求")]), _c('br'), _c('br'), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "background": "#CCFFFF",
	      "width": "100%",
	      "height": "30px"
	    }
	  }, [_c('span', [_c('p', [_vm._v("Windows 7及以上版本")])])]), _vm._v(" "), _c('span', [_vm._v("查看Windows操作系统版本：右键“计算机”，选择“属性”，查看计算机版本。")]), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(535),
	      "width": "840px",
	      "height": "360px"
	    }
	  }), _c('br'), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "28px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("2、Windows版MOA下载")]), _c('br'), _c('br'), _vm._v(" "), _c('table', {
	    attrs: {
	      "border": "1",
	      "cellpadding": "10",
	      "cellspacing": "0",
	      "width": "100%"
	    }
	  }, [_c('tr', [_c('th', [_vm._v("下载地址")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1、"), _c('a', {
	    staticClass: "ct-link",
	    staticStyle: {
	      "color": "#1890ff"
	    },
	    attrs: {
	      "data-auto_update": "0",
	      "data-pageid": "",
	      "href": "https://itportal.sankuai.com/",
	      "target": "_blank",
	      "rel": "noopener"
	    }
	  }, [_vm._v("https://itportal.sankuai.com/")]), _vm._v("\n            （首选从IT门户下载最新稳定版）")])])]), _c('br'), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "28px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("3、MOA安装流程")]), _c('br'), _c('br'), _vm._v(" "), _c('span', [_vm._v("a、双击运行安装包或者右键安装包选择“以管理员身份运行”，然后一路“下一步”进行安装。")]), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(536),
	      "width": "540px",
	      "height": "360px"
	    }
	  }), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(537),
	      "width": "540px",
	      "height": "360px"
	    }
	  }), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(538),
	      "width": "540px",
	      "height": "360px"
	    }
	  }), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(539),
	      "width": "540px",
	      "height": "360px"
	    }
	  }), _c('br'), _vm._v(" "), _c('br'), _vm._v("b、安装成功后会跳出扫码登陆界面，如果未跳出该界面，请找到MOA客户端，点击打开。使用大象扫码登陆或选择输入账号密码登陆。"), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(540),
	      "width": "540px",
	      "height": "360px"
	    }
	  }), _c('br'), _vm._v(" "), _c('br'), _vm._v("扫码登陆成功后会跳出“用户协议签署”，请仔细阅读“安全管理客户端用户协议”后，然后选择“同意”。"), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(541),
	      "width": "540px",
	      "height": "360px"
	    }
	  }), _c('br'), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "28px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("4、安装完成确认")]), _c('br'), _c('br'), _vm._v(" "), _c('span', [_vm._v("a、客户端在线确认")]), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(542),
	      "width": "540px",
	      "height": "360px"
	    }
	  }), _c('br'), _vm._v(" "), _c('span', [_vm._v("b、安装版本确认")]), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(543),
	      "width": "540px",
	      "height": "360px"
	    }
	  }), _c('br'), _vm._v(" "), _c('span', [_vm._v("c、绑定MOA账号确认")]), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(544),
	      "width": "540px",
	      "height": "360px"
	    }
	  }), _c('br'), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "28px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("5、安装异常解决")]), _c('br'), _c('br'), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "25px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("5.1  SSO登陆超时")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("未及时扫码登陆MOA，重新启动MOA客户端即可。")]), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(545),
	      "width": "280px",
	      "height": "200px"
	    }
	  }), _c('br')])])
	}]}

/***/ }),
/* 647 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "select-container clearfix",
	    staticStyle: {
	      "margin-top": "6%",
	      "margin-left": "1%",
	      "float": "center"
	    }
	  }, [_c('el-form', {
	    ref: "ruleForm",
	    staticClass: "demo-ruleForm",
	    attrs: {
	      "model": _vm.userCertApply,
	      "rules": _vm.checkNull,
	      "label-width": "40%"
	    }
	  }, [_c('el-form-item', {
	    staticStyle: {
	      "width": "60%",
	      "margin-left": "7%"
	    },
	    attrs: {
	      "label": "Mis账号:",
	      "prop": "mis"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "disabled": "",
	      "placeholder": "mis账号"
	    },
	    model: {
	      value: (_vm.userCertApply.mis_id),
	      callback: function($$v) {
	        _vm.$set(_vm.userCertApply, "mis_id", $$v)
	      },
	      expression: "userCertApply.mis_id"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', {
	    staticStyle: {
	      "width": "60%",
	      "margin-left": "7%"
	    },
	    attrs: {
	      "label": "MAC地址:",
	      "prop": "mis"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "placeholder": "00:00:00:00:00:00"
	    },
	    model: {
	      value: (_vm.userCertApply.device_id),
	      callback: function($$v) {
	        _vm.$set(_vm.userCertApply, "device_id", $$v)
	      },
	      expression: "userCertApply.device_id"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "margin-left": "45%"
	    }
	  }, [_c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.commitMisApply(_vm.userCertApply)
	      }
	    }
	  }, [_vm._v("提交")])], 1)], 1)], 1)])
	},staticRenderFns: []}

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "select-container clearfix",
	    staticStyle: {
	      "margin-top": "2%",
	      "margin-left": "2%",
	      "float": "left"
	    }
	  }, [_c('span', {
	    staticStyle: {
	      "font-size": "30px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("赛门铁克杀毒软件—windows客户端")]), _c('br'), _c('br'), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v("请根据具体的操作系统选择相应的软件包，参考 “"), _c('span', {
	    staticStyle: {
	      "color": "#63B8FF",
	      "text-decoration": "underline",
	      "cursor": "pointer"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.kmUrl('https://km.sankuai.com/page/18286732#id-%E7%B3%BB%E7%BB%9F%E7%89%88%E6%9C%AC%E6%9F%A5%E7%9C%8B%E6%96%B9%E6%B3%95')
	      }
	    }
	  }, [_vm._v("系统版本查看方法")]), _vm._v("”")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "30px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("一、系统要求")]), _c('br'), _c('br'), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v("该软件目前支持 windows (vista/7/8/10) 32位和64位。")]), _c('br'), _c('br'), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "30px"
	    }
	  }, [_vm._v("系统版本查看方法")]), _c('br'), _c('br'), _vm._v("\n  1.在桌面“计算机”图标上右键，点击“属性”："), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(576),
	      "width": "230px",
	      "height": "230px"
	    }
	  }), _c('br'), _vm._v("\n  2.如果桌面上没有“计算机”图标，则点击左下角“开始”图标->“计算机”->右键“属性”："), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(585),
	      "width": "400px",
	      "height": "330px"
	    }
	  }), _c('br'), _vm._v("\n  3.在弹出的窗口中可以看到系统是32位还是64位："), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(586),
	      "width": "550px",
	      "height": "380px"
	    }
	  }), _c('br'), _c('br'), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "30px"
	    }
	  }, [_vm._v("二、注意事项")]), _c('br'), _c('br'), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v("如果系统安装有第三方安全软件如（包含但不仅限）：360安全卫士、百度杀毒、腾讯管家等，请先卸载")]), _c('br'), _c('br'), _vm._v("\n  如果安装失败或有任何软件问题，请联系6000"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "30px"
	    }
	  }, [_vm._v("三、下载地址")]), _c('br'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', [_vm._v("点击SEP图标，根据操作系统类型选择安装包：")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "30px"
	    }
	  }, [_vm._v("四、安装步骤 ")]), _c('br'), _c('br'), _vm._v("\n  1.在下载地址 ，根据不同的系统类型下载安装包，双击打开"), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(587),
	      "width": "550px",
	      "height": "380px"
	    }
	  }), _c('br'), _vm._v("\n  2.选择目标文件夹，点击解压"), _c('br'), _vm._v("\n  3.右键，选择“以管理员身份运行”，运行 MTSymantec-32(64).exe"), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(588),
	      "width": "110px",
	      "height": "110px"
	    }
	  }), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(589),
	      "width": "400px",
	      "height": "300px"
	    }
	  }), _c('br'), _vm._v("\n  4.双击setup.exe,弹出如下界面，等待一会儿"), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(590),
	      "width": "550px",
	      "height": "300px"
	    }
	  }), _c('br'), _vm._v("\n  5."), _c('span', {
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v("安装过程中，程序会自动识别您的mis账号并注册，若无法识别，程序会打开一个浏览器，并打开一个如下的注册页面，需要登陆SSO后方可成功注册，若未登陆SSO，将自动跳转至登陆页面")]), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(591),
	      "width": "550px",
	      "height": "300px"
	    }
	  }), _c('br'), _vm._v("\n  6.若注册成功，页面显示如下："), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(592),
	      "width": "550px",
	      "height": "250px"
	    }
	  }), _c('br'), _vm._v("\n  7.安装完毕弹出如下界面，点击立即重启"), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(577),
	      "width": "550px",
	      "height": "250px"
	    }
	  }), _c('br'), _vm._v("\n  8.安装并重启完成，右下角会出现sep的图标："), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(578),
	      "width": "350px",
	      "height": "250px"
	    }
	  }), _c('br'), _c('br'), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "30px"
	    }
	  }, [_vm._v("五、注册结果查询 ")]), _c('br'), _c('br'), _vm._v(" "), _vm._m(2), _c('br'), _c('br'), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "25px"
	    }
	  }, [_vm._v("1.注册结果查询")]), _c('br'), _vm._v("\n  请到以下地址查询是否注册成功："), _c('br'), _vm._v("\n  https://reg-sec.meituan.com/api/symantec/status?mis=请输入你的mis账号"), _c('br'), _vm._v("\n  如图："), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(579),
	      "width": "700px",
	      "height": "100px"
	    }
	  }), _c('br'), _c('br'), _vm._v("\n  如果出现 symantec: installed 字样，代表已经安装并成功注册。"), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(580),
	      "width": "700px",
	      "height": "100px"
	    }
	  }), _c('br'), _c('br'), _vm._v("\n  如显示symantec:uninstalled，说明未注册成功"), _c('br'), _vm._v("\n  未注册成功解决办法：请参考本wiki内的，未注册成功"), _c('br'), _c('br'), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "25px"
	    }
	  }, [_vm._v("2.Windows未注册成功")]), _c('br'), _c('br'), _vm._v(" "), _vm._m(3), _c('br'), _c('br'), _vm._v("\n    1.请下载windows版的工具：\n  "), _c('span', {
	    staticStyle: {
	      "color": "#63B8FF",
	      "text-decoration": "underline",
	      "cursor": "pointer"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.kmUrl('https://share.neixin.cn/link/CK4vW683')
	      }
	    }
	  }, [_vm._v("windows工具下载地址")]), _c('br'), _vm._v("\n    2.下载后，双击运行，若出现如下图的提示，请选择“允许使用此文件”"), _c('br'), _vm._v("\n    "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(581),
	      "width": "800px",
	      "height": "500px"
	    }
	  }), _c('br'), _c('br'), _vm._v("\n  3.运行之后，会自动打开浏览器并打开注册页面（如下图），"), _c('span', {
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v("需要登陆SSO后方可成功注册，若未登陆SSO，将自动跳转至登陆页面")]), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(582),
	      "width": "600px",
	      "height": "380px"
	    }
	  }), _c('br'), _c('br'), _vm._v("\n  4.若注册成功，页面显示如下："), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(583),
	      "width": "600px",
	      "height": "300px"
	    }
	  }), _c('br'), _c('br'), _vm._v("\n  5.操作后请到以下地址查询是否注册成功（SEP查询注册结果使用方法）"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(4), _c('br'), _vm._v("\n  6.使用工具重新注册后请再次查询注册结果，如仍未注册成功的，请将【mis账号+软件安装成功的图标截图】提供给【6000帮助台】"), _c('br'), _c('br'), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "30px"
	    }
	  }, [_vm._v("六、常见问题FAQ ")]), _c('br'), _c('br'), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "color": "#0099FF"
	    }
	  }, [_vm._v("Q：我为什么要安装？不安装又会怎么样呢？ ")]), _c('br'), _vm._v("\n  A：近半年来，公司办公网几乎每月都有多起病毒感染事件发生，导致电脑无法正常运行、电脑中的文件被删除、信息被窃取等，不仅影响自身办公，还可能病毒传播影响他人电脑，影响公司安全！"), _c('br'), _vm._v("\n  另外，根据公司制度规定，员工应做好本人使用和管理的计算机的防病毒工作，不得随意卸载防病毒软件或改变安全配置。若重新安装了计算机操作系统，应及时安装防病毒软件。"), _c('br'), _c('br'), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "color": "#0099FF"
	    }
	  }, [_vm._v("Q: 怎样区分我的电脑是否需要安装？")]), _c('br'), _vm._v("\n  A：符合以下任意一个条件的电脑都需要安装，无论是自己买的电脑，还是公司配的。若有多台，均需安装。"), _c('br'), _vm._v("\n  1. 用于办公用途的电脑，包括但不限于:"), _c('br'), _vm._v("\n  使用浏览器登录使用任何公司web系统，包括但不限于web邮件、sankuai门户、HR平台等"), _c('br'), _vm._v("\n  使用outlook、apple mail等邮件客户端软件收发邮件"), _c('br'), _vm._v("\n  使用git等软件链接代码仓库进行开发工作"), _c('br'), _vm._v("\n  直接登录或跳板登录公司服务器"), _c('br'), _vm._v("\n  存储公司资料的机器"), _c('br'), _vm._v("\n  其他"), _c('br'), _vm._v("\n  2. 接入公司网络"), _c('br'), _vm._v("\n  通过有线连接公司网络"), _c('br'), _vm._v("\n  通过无线连接公司网络"), _c('br'), _c('br'), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "color": "#0099FF"
	    }
	  }, [_vm._v("Q：安装了杀毒软件会对我的电脑造成什么影响？ ")]), _c('br'), _vm._v("\n  A：公司采购的杀毒软件是国际知名安全厂商软件，已在各大公司有非常多年普及的经验。信息安全中心自Q1试点推广以来，低于1‰的员工可能遇到异常，包括电脑性能不足、蓝屏等，可能影响办公。当发生这些情况时，请及时联系6000或当地IT解决，或禁用、卸载。"), _c('br'), _c('br'), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "color": "#0099FF"
	    }
	  }, [_vm._v("Q：杀毒软件会做什么事情，会监控我的电脑吗？")]), _c('br'), _vm._v("\n  A：杀毒软件的主要功能为防范电脑病毒、木马或恶意软件，保护终端安全。为了实现其安全功能，杀毒软件会检测系统运行的程序，使用不限于特征匹配等方式检测恶意程序；同时，杀毒软件也会监控网络流量，防止恶意攻击等。请大家放心，"), _c('span', {
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v("杀毒软件不会监控员工操作电脑行为、聊天记录、隐私数据等。")]), _c('br'), _c('br'), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v("如大家还有别的疑问，请及时反馈给我们，我们将及时为您解答。谢谢！")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_vm._v("访问IT门户："), _c('a', {
	    staticClass: "ct-link",
	    staticStyle: {
	      "color": "#1890ff"
	    },
	    attrs: {
	      "data-auto_update": "0",
	      "href": "https://itportal.sankuai.com/",
	      "target": "_blank",
	      "rel": "noopener"
	    }
	  }, [_vm._v("https://itportal.sankuai.com")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(584),
	      "width": "700px",
	      "height": "380px"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "background": "#F0FFF0"
	    }
	  }, [_c('span', [_vm._v("杀毒软件安装时，会提示填写mis账号，或通过资产信息识别使用者，可通过以下方式查看是否注册成功。 ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "background": "#FFF5EE"
	    }
	  }, [_c('span', [_vm._v("运行信息安全中心提供的注册工具，重新注册一下即可。无须重新安装杀毒软件！"), _c('br'), _vm._v("\n  此工具请在连接MTDP网络状态下使用")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('table', {
	    attrs: {
	      "border": "1",
	      "cellpadding": "10",
	      "cellspacing": "0",
	      "width": "90%"
	    }
	  }, [_c('tr', {
	    staticStyle: {
	      "background": "#F5F5F5"
	    },
	    attrs: {
	      "align": "left"
	    }
	  }, [_c('th', [_vm._v("代码块")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("https://reg-sec.meituan.com/api/symantec/status?mis=请输入你的mis账号")])])])
	}]}

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "select-container clearfix",
	    staticStyle: {
	      "margin-top": "2%",
	      "margin-left": "2%",
	      "float": "left"
	    }
	  }, [_c('span', {
	    staticStyle: {
	      "font-size": "30px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("MOA未安装或版本不是最新")]), _c('br'), _c('br'), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "28px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("一、背景")]), _c('br'), _c('br'), _vm._v(" "), _vm._m(0), _vm._v("\n          当前公司有几万员工，人员变动频繁，存在几万台个人终端和便携式电子设备，缺乏对入网终端统一的管理。我们无法得知究竟有多少终端连入我们的网络，无法对每台\n  接入网络的终端做认证，终端健康状态难以掌控。这给公司的IT安全带来很大风险，当出现类似于WannaCry勒索病毒时，我们无法快速得知哪些机器存在风险，也无法快速禁\n  止被感染或有风险的机器接入网络。基于此，我们希望做一个统一的终端安全管理系统，做到安全可视化，对设备做统一的认证和管控，提升IT安全。"), _c('br'), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "28px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("二、自查方法")]), _c('br'), _c('br'), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', [_vm._v("1、请确认是否已安装MOA。")]), _vm._v(" "), _c('p', [_vm._v("    如未安装，请参照MOA 安装指导：美团安全管理客户端（MOA）安装\n  ("), _c('span', {
	    staticStyle: {
	      "color": "#63B8FF",
	      "text-decoration": "underline",
	      "cursor": "pointer"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.routerUrl('/moaInstallForWin')
	      }
	    }
	  }, [_vm._v("Windows操作系统安装MOA")]), _vm._v("，\n  "), _c('span', {
	    staticStyle: {
	      "color": "#63B8FF",
	      "text-decoration": "underline",
	      "cursor": "pointer"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.routerUrl('/moaInstallForMac')
	      }
	    }
	  }, [_vm._v("macOS操作系统安装MOA")]), _vm._v(")\n  ")]), _vm._v(" "), _c('p', [_vm._v("2、若已安装，请确认是否是最新版MOA。")]), _vm._v(" "), _c('p', [_vm._v("    查看MOA版本方式：MOA版本查看（"), _c('span', {
	    staticStyle: {
	      "color": "#63B8FF",
	      "text-decoration": "underline",
	      "cursor": "pointer"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.routerUrl('/moaVersionView')
	      }
	    }
	  }, [_vm._v("MOA版本查看")]), _vm._v("）。\n  ")]), _c('p', {
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v("注意：因MOA部分旧版本不支持自动更新升级，在查看版本时获取不到最新版信息，MOA当前最新版本为：")]), _vm._v(" "), _c('p', [_vm._v("        MAC 上MOA最新版本：【1.3.1.0 】（要求macOS操作系统版本 > 10.11）")]), _vm._v(" "), _c('p', [_vm._v("        Windows上MOA最新版本： 【1.3.0.0 】（要求 Windows 7及以上操作系统版本）")]), _vm._v("\n  3、安装时若遇到问题，请参考（\n  "), _c('span', {
	    staticStyle: {
	      "color": "#63B8FF",
	      "text-decoration": "underline",
	      "cursor": "pointer"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.routerUrl('/macOS_FAQ')
	      }
	    }
	  }, [_vm._v("macOS FAQ")]), _vm._v("，\n  "), _c('span', {
	    staticStyle: {
	      "color": "#63B8FF",
	      "text-decoration": "underline",
	      "cursor": "pointer"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.routerUrl('/windows_FAQ')
	      }
	    }
	  }, [_vm._v("windows FAQ")]), _vm._v("，\n  "), _c('span', {
	    staticStyle: {
	      "color": "#63B8FF",
	      "text-decoration": "underline",
	      "cursor": "pointer"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.routerUrl('/other_FAQ')
	      }
	    }
	  }, [_vm._v("其他 FAQ")]), _vm._v("）或联系6000工作台协助解决。 "), _c('br'), _vm._v(" "), _c('p', [_vm._v("若以上没有解决您的问题，请联系6000帮助台进行协助解决")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('p', [_vm._v("2、若您本机已经安装了DLP和MOA，仍然跳出该提示，可能是您有多台机器用于过办公，另外机器上未安装DLP，请在另一台用于办公电脑上也安装运行DLP。")]), _vm._v(" "), _c('p', [_vm._v("    可通过：https://report-mon.sankuai.com/report/api/check_status?mis_id=您的mis号 排查，DLP安装状态是否是“Y“。")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('p', [_vm._v("若以上没有解决您的问题，请联系6000帮助台进行协助解决")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "28px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("三、常见问题")]), _c('br'), _c('br'), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "color": "rgb(29, 120, 205)"
	    }
	  }, [_vm._v("Q：我有紧急的事情需要访问线上系统，但是暂时无法安装MOA，怎么办？")]), _c('br'), _vm._v("\n  A：可以点击【\n  "), _c('span', {
	    staticStyle: {
	      "color": "#63B8FF",
	      "text-decoration": "underline",
	      "cursor": "pointer"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.routerUrl('/whiteApply')
	      }
	    }
	  }, [_vm._v("临时白名单申请地址")]), _vm._v("\n  】，申请临时白名单。"), _c('span', {
	    staticStyle: {
	      "color": "rgb(240, 94, 80)"
	    }
	  }, [_vm._v("有效期4小时，最多申请3次。")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "color": "rgb(29, 120, 205)"
	    }
	  }, [_vm._v("Q：我已经安装了MOA，为什么还是无法访问办公系统？")]), _c('br'), _vm._v(" "), _c('p', {
	    staticStyle: {
	      "text-align": "start"
	    }
	  }, [_vm._v("A：请确认安装MOA后，是否已打开MOA界面根据提示使用大象扫码登录完成注册工作。")]), _vm._v(" "), _c('p', {
	    staticStyle: {
	      "text-align": "start",
	      "margin-left": "20px"
	    }
	  }, [_vm._v("查看MOA是否安装："), _c('span', {
	    staticStyle: {
	      "color": "#63B8FF",
	      "text-decoration": "underline",
	      "cursor": "pointer"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.routerUrl('/verifyMoaIsInstall')
	      }
	    }
	  }, [_vm._v("如何判断MOA是否已经安装")]), _vm._v("（确定安装5分钟后，数据同步完成）。")]), _vm._v(" "), _c('p', {
	    staticStyle: {
	      "text-align": "start",
	      "margin-left": "20px"
	    }
	  }, [_vm._v("如还有问题可联系6000协助您解决。")]), _c('br'), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('p', {
	    staticStyle: {
	      "text-align": "start"
	    }
	  }, [_vm._v("    2、需要接入公司网络")]), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _vm._m(16)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "background": "#FFE4E1",
	      "width": "100%",
	      "height": "30px"
	    }
	  }, [_c('span', [_c('p', [_vm._v("根据公司安全规定，未安装安全管理客户端（MOA），会被限制访问办公系统。")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "background": "#b3fff2",
	      "width": "100%",
	      "height": "30px"
	    }
	  }, [_c('span', [_c('p', [_vm._v("如果是「请检查当前计算机MOA是否安装或MOA版本是否最新」 拦截提示，如下：")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(546),
	      "width": "540px",
	      "height": "360px"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "background": "#b3fff2",
	      "width": "100%",
	      "height": "30px"
	    }
	  }, [_c('span', [_c('p', [_vm._v("如果是「您已被限制访问办公系统，请及时安装MOA/DLP产品」拦截提示，如下：")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(547),
	      "width": "740px",
	      "height": "500px"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_vm._v("1、跳出该提示说明您本地电脑未安装DLP或MOA产品，请按照拦截提示指导移步IT门户(\n  "), _c('a', {
	    staticClass: "ct-link",
	    staticStyle: {
	      "color": "#1890ff"
	    },
	    attrs: {
	      "data-auto_update": "0",
	      "data-pageid": "",
	      "href": "https://itportal.sankuai.com/",
	      "target": "_blank",
	      "rel": "noopener"
	    }
	  }, [_vm._v("https://itportal.sankuai.com/")]), _vm._v("\n  )下载安装。")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(548),
	      "width": "1040px",
	      "height": "100px"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "background": "#e5f5c9",
	      "width": "100%",
	      "height": "30px"
	    }
	  }, [_vm._v("申请临时白名单，仅有4小时有效期。"), _c('span', {
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v("若因特殊原因，需要较长时间，请联系6000。")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_c('span', {
	    staticStyle: {
	      "color": "rgb(0, 0, 0)"
	    }
	  }, [_vm._v("为什么安装杀毒软件还要安装MOA？")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_c('span', {
	    staticStyle: {
	      "color": "rgb(0, 0, 0)"
	    }
	  }, [_vm._v("A：杀毒软件主要用于终端病毒和恶意软件的查杀。MOA是公司终端设备统一认证和管控的客户端，主要用于检测员工PC 终端的安全状态以及辅助员工网络接入，对员工业务操作不会影响，不会收集员工个人隐私信息。")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_c('span', {
	    staticStyle: {
	      "color": "rgb(29, 120, 205)"
	    }
	  }, [_vm._v("Q: 怎样区分我的电脑是否需要安装MOA？")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_c('span', {
	    staticStyle: {
	      "color": "rgb(0, 0, 0)"
	    }
	  }, [_vm._v("A：符合以下任意一个条件的电脑都需要安装，无论是私人电脑，还是公司配发的电脑。若有多台，均需安装MOA。")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_c('span', {
	    staticStyle: {
	      "color": "rgb(0, 0, 0)"
	    }
	  }, [_vm._v("    1、用于办公用途的电脑，办公用途包括但不限于:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('ul', {
	    staticStyle: {
	      "margin-left": "40px"
	    }
	  }, [_c('li', [_c('p', [_vm._v("使用浏览器登录使用任何公司web系统，包括但不限于web邮件、sankuai门户、HR平台等")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("使用outlook、apple mail等邮件客户端软件收发邮件")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("使用git等软件连接代码仓库进行开发工作")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("直接登录或使用跳板机登录公司服务器")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("存储公司资料的机器")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("其它")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('ul', {
	    staticStyle: {
	      "margin-left": "40px"
	    }
	  }, [_c('li', [_c('p', [_vm._v("通过有线连接公司网络")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("通过无线连接公司网络")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_c('span', {
	    staticStyle: {
	      "color": "rgb(29, 120, 205)"
	    }
	  }, [_vm._v("Q：MOA会做什么事情，会监控我的电脑吗？")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', {
	    staticStyle: {
	      "text-align": "start"
	    }
	  }, [_vm._v("A："), _c('span', {
	    staticStyle: {
	      "color": "rgb(0, 0, 0)"
	    }
	  }, [_vm._v("MOA是公司终端设备统一认证和管控的客户端，主要用于检测员工PC 终端的安全状态以及辅助员工网络接入，对员工业务操作不会影响。")]), _c('strong', [_c('span', {
	    staticStyle: {
	      "color": "rgb(240, 94, 80)"
	    }
	  }, [_vm._v("请大家放心，MOA不会监控员工操作电脑行为、聊天记录、隐私数据等。")])])])
	}]}

/***/ }),
/* 650 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div')
	},staticRenderFns: []}

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "select-container clearfix",
	    staticStyle: {
	      "margin-top": "2%",
	      "margin-left": "2%",
	      "float": "left"
	    }
	  }, [_c('span', {
	    staticStyle: {
	      "font-size": "30px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("安全基线检查修复")]), _c('br'), _c('br'), _c('br'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('br'), _vm._v(" "), _c('h1', {
	    staticStyle: {
	      "font-size": "28px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("一、终端安全软件下载安装")]), _c('br'), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(466),
	      "width": "540px",
	      "height": "360px"
	    }
	  }), _c('br'), _c('br'), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(473),
	      "width": "540px",
	      "height": "660px"
	    }
	  }), _c('br'), _c('br'), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(472),
	      "width": "100%",
	      "height": "500px"
	    }
	  }), _c('br'), _c('br'), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _vm._m(16), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _vm._m(17), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(467),
	      "width": "100%",
	      "height": "500px"
	    }
	  }), _c('br'), _c('br'), _vm._v(" "), _c('h1', {
	    staticStyle: {
	      "font-size": "28px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("二、通过MOA排查“安全基线检查”结果。")]), _c('br'), _vm._v(" "), _c('h2', {
	    staticStyle: {
	      "font-size": "24px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("1、打开MOA客户端页面，查看“安全基线检查”检查结果。")]), _vm._v(" "), _c('p', {
	    staticStyle: {
	      "text-align": "start",
	      "margin-left": "20px"
	    }
	  }, [_vm._v("a、Windows系统打开MOA客户端方法：点击运行的MOA图标。")]), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(468),
	      "width": "540px",
	      "height": "160px"
	    }
	  }), _c('br'), _vm._v(" "), _c('p', {
	    staticStyle: {
	      "text-align": "start",
	      "margin-left": "20px"
	    }
	  }, [_vm._v("在跳出的MOA客户端界面上选择“安全基线检查”选项，查看安全基线检查结果。")]), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(469),
	      "width": "640px",
	      "height": "440px"
	    }
	  }), _c('br'), _vm._v(" "), _c('p', {
	    staticStyle: {
	      "text-align": "start",
	      "margin-left": "20px"
	    }
	  }, [_vm._v("b、Mac系统打开MOA客户端方法：点击运行的MOA图标。在跳出的MOA客户端界面上选择“安全基线检测”选项，查看安全基线检查结果。")]), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(470),
	      "width": "940px",
	      "height": "600px"
	    }
	  }), _c('br'), _c('br'), _vm._v(" "), _c('h2', {
	    staticStyle: {
	      "font-size": "24px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("2、排查“安全基线检测”。")]), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(471),
	      "width": "660px",
	      "height": "420px"
	    }
	  }), _c('br'), _vm._v("\n  a、赛门铁克杀毒软件相关基线   显示红色\n  "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(55),
	      "width": "40px",
	      "height": "30px"
	    }
	  }), _vm._v("\n  ，表示赛门铁克杀毒软件未安装或未正常运行，请进入\n  "), _c('span', {
	    staticStyle: {
	      "color": "#63B8FF",
	      "text-decoration": "underline",
	      "cursor": "pointer"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.routerUrl('/saimenInstallForWin')
	      }
	    }
	  }, [_vm._v("杀软安装指南—Windows")]), _vm._v("，\n  "), _c('span', {
	    staticStyle: {
	      "color": "#63B8FF",
	      "text-decoration": "underline",
	      "cursor": "pointer"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.routerUrl('/saimenInstallForMac')
	      }
	    }
	  }, [_vm._v("杀软安装指南--macOS")]), _vm._v("进行排查。"), _c('br'), _vm._v("\n  b、数据防泄漏客户端相关基线  显示红色\n  "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(55),
	      "width": "40px",
	      "height": "30px"
	    }
	  }), _vm._v("\n  ，表示数据防泄漏客户端未安装、未注册、或未正常运行，请进入\n  "), _c('span', {
	    staticStyle: {
	      "color": "#63B8FF",
	      "text-decoration": "underline",
	      "cursor": "pointer"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.routerUrl('/dataLeakInstallForWin')
	      }
	    }
	  }, [_vm._v("DLP安装指南--Windows")]), _vm._v("，\n  "), _c('span', {
	    staticStyle: {
	      "color": "#63B8FF",
	      "text-decoration": "underline",
	      "cursor": "pointer"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.routerUrl('/dataLeakInstallForMac')
	      }
	    }
	  }, [_vm._v("DLP安装指南--macOS")]), _vm._v("进行排查。"), _c('br'), _c('br'), _vm._v(" "), _vm._m(18), _vm._v(" "), _c('p', {
	    staticStyle: {
	      "text-align": "start"
	    }
	  }, [_vm._v("a、如遇特殊情紧急情况，员工可申请临时白名单，请从此进入"), _c('span', {
	    staticStyle: {
	      "color": "#63B8FF",
	      "text-decoration": "underline",
	      "cursor": "pointer"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.routerUrl('/whiteApply')
	      }
	    }
	  }, [_vm._v("临时白名单")]), _vm._v("。")])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_c('strong', [_c('span', {
	    staticStyle: {
	      "color": "rgb(250, 84, 28)"
	    }
	  }, [_vm._v("同学您好，您的PC终端安全不合规")])]), _vm._v("。请您根据拦截提示页面选择对应安全合规软件进行修复。")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h2', {
	    staticStyle: {
	      "font-size": "26px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("1、"), _c('strong', [_vm._v("美团安全管理客户端（MOA）")]), _vm._v("下载安装")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_c('strong', [_c('span', {
	    staticStyle: {
	      "color": "rgb(255, 77, 79)"
	    }
	  }, [_vm._v("解决方法")]), _vm._v("：请确认您的操作系统后下载对应安装包。")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "background": "#CCFFFF",
	      "width": "100%",
	      "height": "100px"
	    }
	  }, [_c('p', [_vm._v("Mac："), _c('a', {
	    staticStyle: {
	      "color": "#1890ff"
	    },
	    attrs: {
	      "data-auto_update": "0",
	      "href": "https://s3plus.sankuai.com/v1/mss_4964a1f571bb46daa9dbb9a0821e2f58/itmenhu/%E5%8A%9E%E5%85%AC%E8%BD%AF%E4%BB%B6/%E4%BC%81%E4%B8%9A%E5%86%85%E9%83%A8%E8%BD%AF%E4%BB%B6/MOA/mac-for-1.3.1.0-release.pkg",
	      "target": "_blank",
	      "rel": "noopener"
	    }
	  }, [_vm._v("Mac下MOA下载")]), _vm._v(" 。"), _c('strong', [_vm._v("注意：MAC 上MOA最新版本：【1.3.1.0 】（要求macOS操作系统版本>=10.11）")])]), _vm._v(" "), _c('p', [_c('span', {
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v("MAC操作系统10.11以下版本存有多个安全漏洞，需要升级到10.11后才能修复，所以MOA、SEP、DLP最新版本对于10.10及以下操作系统不再提供兼容，必需要升级操作系统。升级MAC操作系统请联系6000帮助台协助。")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "background": "#CCFFFF",
	      "width": "100%",
	      "height": "30px"
	    }
	  }, [_c('p', [_vm._v("Windows: "), _c('a', {
	    staticClass: "ct-link",
	    staticStyle: {
	      "color": "#1890ff"
	    },
	    attrs: {
	      "data-auto_update": "0",
	      "href": "https://s3plus.sankuai.com/v1/mss_4964a1f571bb46daa9dbb9a0821e2f58/itmenhu/%E5%8A%9E%E5%85%AC%E8%BD%AF%E4%BB%B6/%E4%BC%81%E4%B8%9A%E5%86%85%E9%83%A8%E8%BD%AF%E4%BB%B6/MOA/MOA%20for%20Windows%201.3.0.0.exe",
	      "target": "_blank",
	      "rel": "noopener"
	    }
	  }, [_vm._v("Win下MOA下载")]), _vm._v("。  "), _c('strong', [_vm._v("注意：Windows上MOA最新版本：【1.3.0.0 】（要求Windows 7及以上版本）")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_vm._v("安装遇到问题请在左侧菜单栏"), _c('span', {
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v("【常见问题FQA】")]), _vm._v("查看，若以上没有解决您的问题，请联系6000帮助台进行协助。"), _c('br')])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "background": "#EEF977",
	      "width": "100%",
	      "height": "30px"
	    }
	  }, [_c('p', [_vm._v("拦截提示："), _c('strong', [_vm._v("「"), _c('span', {
	    staticStyle: {}
	  }, [_vm._v("当前计算机MOA未安装或不是最新版本，请点击「立即处理」")])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "background": "#EEF977",
	      "width": "100%",
	      "height": "30px"
	    }
	  }, [_c('p', [_vm._v("拦截提示："), _c('strong', [_vm._v("「"), _c('span', {
	    staticStyle: {}
	  }, [_vm._v("拦截提示：「终端安全不合规，请点击「立即处理」")])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h2', {
	    staticStyle: {
	      "font-size": "26px",
	      "font-weight": "bold"
	    },
	    attrs: {
	      "id": "id-2、赛门铁克杀毒软件（SEP）下载安装"
	    }
	  }, [_vm._v("2、"), _c('strong', [_vm._v("赛门铁克杀毒软件（SEP）")]), _vm._v("下载安装")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_c('strong', [_c('span', {
	    staticStyle: {
	      "color": "rgb(255, 77, 79)"
	    }
	  }, [_vm._v("解决方法")]), _vm._v("：请确认您的操作系统后下载对应安装包。")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "background": "#CCFFFF",
	      "width": "100%",
	      "height": "30px"
	    }
	  }, [_c('p', [_vm._v("Mac："), _c('a', {
	    staticClass: "ct-link",
	    staticStyle: {
	      "color": "#1890ff"
	    },
	    attrs: {
	      "data-auto_update": "0",
	      "href": "https://s3plus.sankuai.com/v1/mss_4964a1f571bb46daa9dbb9a0821e2f58/itmenhu/%E5%8A%9E%E5%85%AC%E8%BD%AF%E4%BB%B6/%E4%BC%81%E4%B8%9A%E5%86%85%E9%83%A8%E8%BD%AF%E4%BB%B6/SEP/14.2.2%20RU%202%20SEPRemote.pkg",
	      "target": "_blank",
	      "rel": "noopener"
	    }
	  }, [_vm._v("Mac下SEP下载")]), _vm._v("。")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "background": "#CCFFFF",
	      "width": "100%",
	      "height": "30px"
	    }
	  }, [_c('p', [_vm._v("Windows 32位操作系统: "), _c('a', {
	    staticClass: "ct-link",
	    staticStyle: {
	      "color": "#1890ff"
	    },
	    attrs: {
	      "data-auto_update": "0",
	      "href": "https://s3plus.sankuai.com/v1/mss_4964a1f571bb46daa9dbb9a0821e2f58/itmenhu/%E5%8A%9E%E5%85%AC%E8%BD%AF%E4%BB%B6/%E4%BC%81%E4%B8%9A%E5%86%85%E9%83%A8%E8%BD%AF%E4%BB%B6/SEP/14.2.5323.2000_x86_setup.exe",
	      "target": "_blank",
	      "rel": "noopener"
	    }
	  }, [_vm._v("Win下32位SEP下载")]), _vm._v("。Windows 64位操作系统: "), _c('a', {
	    staticClass: "ct-link",
	    staticStyle: {
	      "color": "#1890ff"
	    },
	    attrs: {
	      "data-auto_update": "0",
	      "href": "https://s3plus.sankuai.com/v1/mss_4964a1f571bb46daa9dbb9a0821e2f58/itmenhu/%E5%8A%9E%E5%85%AC%E8%BD%AF%E4%BB%B6/%E4%BC%81%E4%B8%9A%E5%86%85%E9%83%A8%E8%BD%AF%E4%BB%B6/SEP/14.2.5323.2000_x64_setup.exe",
	      "target": "_blank",
	      "rel": "noopener"
	    }
	  }, [_vm._v("Win下64位SEP下载")]), _vm._v("。")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "background": "#EEF977",
	      "width": "100%",
	      "height": "30px"
	    }
	  }, [_c('p', [_vm._v("拦截提示："), _c('strong', [_vm._v("您已被限制访问办公系统，请及时安装杀毒软件")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h2', {
	    staticStyle: {
	      "font-size": "26px",
	      "font-weight": "bold"
	    },
	    attrs: {
	      "id": "id-3、数据防泄漏客户端（DLP）下载安装"
	    }
	  }, [_vm._v("3、"), _c('strong', [_vm._v("数据防泄漏客户端（DLP）")]), _vm._v("下载安装")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_c('strong', [_c('span', {
	    staticStyle: {
	      "color": "rgb(255, 77, 79)"
	    }
	  }, [_vm._v("解决方法")]), _vm._v("：请确认您的操作系统后下载对应安装包。")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "background": "#CCFFFF",
	      "width": "100%",
	      "height": "30px"
	    }
	  }, [_c('p', [_vm._v("Mac："), _c('a', {
	    staticClass: "ct-link",
	    staticStyle: {
	      "color": "#1890ff"
	    },
	    attrs: {
	      "data-auto_update": "0",
	      "href": "https://s3plus.sankuai.com/v1/mss_4964a1f571bb46daa9dbb9a0821e2f58/itmenhu/%E5%8A%9E%E5%85%AC%E8%BD%AF%E4%BB%B6/%E4%BC%81%E4%B8%9A%E5%86%85%E9%83%A8%E8%BD%AF%E4%BB%B6/DLP/mac%20new.zip",
	      "target": "_blank",
	      "rel": "noopener"
	    }
	  }, [_vm._v("Mac下DLP下载")]), _vm._v("。")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "background": "#CCFFFF",
	      "width": "100%",
	      "height": "30px"
	    }
	  }, [_c('p', [_vm._v("Windows: "), _c('a', {
	    staticClass: "ct-link",
	    staticStyle: {
	      "color": "#1890ff"
	    },
	    attrs: {
	      "data-auto_update": "0",
	      "href": "https://s3plus.sankuai.com/v1/mss_4964a1f571bb46daa9dbb9a0821e2f58/itmenhu/%E5%8A%9E%E5%85%AC%E8%BD%AF%E4%BB%B6/%E4%BC%81%E4%B8%9A%E5%86%85%E9%83%A8%E8%BD%AF%E4%BB%B6/DLP/DLP.exe",
	      "target": "_blank",
	      "rel": "noopener"
	    }
	  }, [_vm._v("Win下DLP下载")]), _vm._v("。")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "background": "#EEF977",
	      "width": "100%",
	      "height": "30px"
	    }
	  }, [_c('p', [_vm._v("拦截提示："), _c('strong', [_vm._v("您已被限制访问办公系统，请及时安装杀毒软件")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h1', {
	    staticStyle: {
	      "font-size": "24px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("3、以上提示的红色"), _c('img', {
	    attrs: {
	      "src": __webpack_require__(55),
	      "width": "40px",
	      "height": "30px"
	    }
	  }), _vm._v("修复完成后，请重新登录应用系统，如还有问题，请大象联系6000协助")])
	}]}

/***/ }),
/* 652 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.$store.state.is_manager) ? _c('div', {
	    staticClass: "document-container"
	  }, [_c('div', {
	    staticClass: "edit-document-button",
	    class: _vm.scroll.headerFixed ? 'fix-button-top' : ''
	  }, [_c('el-button', {
	    staticClass: "circle-button",
	    attrs: {
	      "type": "success",
	      "icon": "el-icon-check",
	      "title": "保存"
	    },
	    on: {
	      "click": _vm.updateContent
	    }
	  }), _vm._v(" "), _c('el-button', {
	    staticClass: "circle-button",
	    attrs: {
	      "type": "danger",
	      "icon": "el-icon-close",
	      "title": "取消"
	    },
	    on: {
	      "click": _vm.goBack
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "document-title"
	  }, [_c('el-row', {
	    staticStyle: {
	      "height": "60px"
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 20
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.title),
	      expression: "title"
	    }],
	    staticClass: "documentTitle",
	    staticStyle: {
	      "outline": "none"
	    },
	    attrs: {
	      "placeholder": "标题"
	    },
	    domProps: {
	      "value": (_vm.title)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.title = $event.target.value
	      }
	    }
	  })])], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	    staticClass: "document-content"
	  }, [_c('div', {
	    staticClass: "toolbar",
	    class: _vm.scroll.headerFixed ? 'isFixed' : '',
	    attrs: {
	      "id": "toolbar"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "wrapper"
	  }, [_c('div', {
	    ref: "content",
	    staticClass: "editor",
	    attrs: {
	      "id": "editor"
	    }
	  })])])]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 653 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "text-align": "center",
	      "margin-top": "6%",
	      "margin-left": "1%"
	    }
	  }, [_c('div', {
	    staticStyle: {
	      "margin-top": "10px"
	    }
	  }, [_vm._v("我们将为您跳转至用户引导页面，同时为您启动MOA AI诊修工具修复您的问题...")]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "margin-top": "10px"
	    }
	  }, [_vm._v("若AI诊修工具启动不成功，请您根据引导页面进行手动修复.")]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "margin-top": "10px"
	    }
	  }, [_vm._v("（We will redirect you to the user guide and launch the MOA AI Agent tool to resolve the issue...")]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "margin-top": "10px"
	    }
	  }, [_vm._v("If the tool fails to start, please refer to the guide for manual repair）")])])
	}]}

/***/ }),
/* 654 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.$store.state.is_manager) ? _c('div', [_c('div', {
	    staticClass: "select-container clearfix",
	    staticStyle: {
	      "margin-top": "6%",
	      "margin-left": "33%",
	      "float": "center"
	    }
	  }, [_c('el-form', {
	    ref: "form",
	    attrs: {
	      "model": _vm.form,
	      "label-width": "80px"
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "文档标题"
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 6
	    }
	  }, [_c('el-input', {
	    model: {
	      value: (_vm.form.title),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "title", $$v)
	      },
	      expression: "form.title"
	    }
	  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "父目录"
	    }
	  }, [_c('el-cascader', {
	    attrs: {
	      "change-on-select": "",
	      "options": _vm.form.options,
	      "clearable": ""
	    },
	    model: {
	      value: (_vm.selectedItemList),
	      callback: function($$v) {
	        _vm.selectedItemList = $$v
	      },
	      expression: "selectedItemList"
	    }
	  }), _vm._v("\n                若需创建在根目录下则无需选择\n            ")], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "文档类型"
	    }
	  }, [_c('el-radio-group', {
	    model: {
	      value: (_vm.form.type),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "type", $$v)
	      },
	      expression: "form.type"
	    }
	  }, [_c('el-radio', {
	    attrs: {
	      "label": "目录"
	    }
	  }), _vm._v(" "), _c('el-radio', {
	    attrs: {
	      "label": "文本"
	    }
	  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "语言"
	    }
	  }, [_c('el-radio-group', {
	    model: {
	      value: (_vm.form.language),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "language", $$v)
	      },
	      expression: "form.language"
	    }
	  }, [_c('el-radio', {
	    attrs: {
	      "label": "zh"
	    }
	  }, [_vm._v("中文")]), _vm._v(" "), _c('el-radio', {
	    attrs: {
	      "label": "en"
	    }
	  }, [_vm._v("英文")])], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": _vm.onSubmit
	    }
	  }, [_vm._v("立即创建")])], 1)], 1)], 1)]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "select-container clearfix",
	    staticStyle: {
	      "margin-top": "2%",
	      "margin-left": "2%",
	      "float": "left"
	    }
	  }, [_c('span', {
	    staticStyle: {
	      "font-size": "30px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("赛门铁克杀毒软件—mac客户端")]), _c('br'), _c('br'), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v("请注意：在安装之前请务必保存已有工作，安装完成后必须重启电脑！！")]), _c('br'), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v("请注意：在安装之前请务必保存已有工作，安装完成后必须重启电脑！！")]), _c('br'), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v("请注意：在安装之前请务必保存已有工作，安装完成后必须重启电脑！！")]), _c('br'), _c('br'), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "25px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("一、安装前注意事项")]), _c('br'), _c('br'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('br'), _vm._v("\n        查看当前系统版本的方法："), _c('br'), _vm._v("\n        1.点击左上角“苹果”图标，点击“关于本机”"), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(560),
	      "width": "280px",
	      "height": "300px"
	    }
	  }), _c('br'), _vm._v("\n        2.在弹出的窗口中可以看到版本号"), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(568),
	      "width": "500px",
	      "height": "300px"
	    }
	  }), _c('br'), _vm._v("\n        3.若不符合要求的系统版本，需将系统升级，升级方式：请联系6000协助"), _c('br'), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "25px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("二、软件下载地址")]), _c('br'), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', [_vm._v("点击SEP图标，根据操作系统类型选择安装包：")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "25px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("三、安装方法")]), _c('br'), _c('br'), _vm._v("\n        1.下载程序后，解压文件，双击 symantec.app， 若弹出以下窗口"), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(569),
	      "width": "500px",
	      "height": "200px"
	    }
	  }), _c('br'), _vm._v("\n        2.打开 “系统偏好设置” -“安全性与隐私”，选择“通用”，点击 “仍要打开”"), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(570),
	      "width": "500px",
	      "height": "400px"
	    }
	  }), _c('br'), _vm._v("\n        3.再次双击Symantec.app-出现如下界面后-点击“开始安装”"), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(571),
	      "width": "500px",
	      "height": "300px"
	    }
	  }), _c('br'), _vm._v("\n        4.会弹出窗口提示输入mis账号，请输入您的mis账号（不是邮箱，不是中文）"), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(572),
	      "width": "380px",
	      "height": "120px"
	    }
	  }), _c('br'), _vm._v("\n        5.输入mis账号后，要求输入本机的账号和密码（非mis账号）"), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(573),
	      "width": "450px",
	      "height": "320px"
	    }
	  }), _c('br'), _vm._v("\n        6.输入用户名和密码后，程序会继续安装。安装过程会持续3-5分钟，请耐心等待。"), _c('br'), _vm._v("\n        7."), _c('span', {
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v("安装过程中，程序会自动识别您的mis账号并注册，若无法识别，程序会打开一个浏览器，并打开一个如下的注册页面，需要登陆SSO后方可成功注册，若未登陆SSO，将自动跳转至登陆页面")]), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(574),
	      "width": "550px",
	      "height": "320px"
	    }
	  }), _c('br'), _vm._v("\n        8.若注册成功，页面显示如下："), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(575),
	      "width": "550px",
	      "height": "220px"
	    }
	  }), _c('br'), _vm._v("\n        9.软件安装完成后，界面如下："), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(561),
	      "width": "550px",
	      "height": "300px"
	    }
	  }), _c('br'), _vm._v("\n        10.点击立即重启即可。"), _c('br'), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v("请注意：点击“立即重启”之后，mac会立即重启！！")]), _c('br'), _vm._v("\n        11.重启之后，右上角会出现sep的图标（黄色小盾牌）：若出现小图标，则表示安装完成。"), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(562),
	      "width": "550px",
	      "height": "90px"
	    }
	  }), _c('br'), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "25px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("四、注册结果查询")]), _c('br'), _c('br'), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "background": "#F0FFF0"
	    }
	  }, [_vm._v("杀毒软件安装时，会提示填写mis账号，或通过资产信息识别使用者，可通过以下方式查看是否注册成功。")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "20px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("1.注册结果查询")]), _c('br'), _c('br'), _vm._v("\n        请到以下地址查询是否注册成功："), _c('br'), _vm._v("\n        https://reg-sec.meituan.com/api/symantec/status?mis=请输入你的mis账号"), _c('br'), _vm._v("\n        如图："), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(563),
	      "width": "600px",
	      "height": "90px"
	    }
	  }), _c('br'), _vm._v("\n        如果出现 symantec: installed 字样，代表已经安装并成功注册。"), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(564),
	      "width": "600px",
	      "height": "90px"
	    }
	  }), _c('br'), _vm._v("\n        如显示symantec:uninstalled，说明未注册成功"), _c('br'), _vm._v("\n        未注册成功解决办法：请参考本wiki内的，\n        "), _c('span', {
	    staticStyle: {
	      "color": "#63B8FF",
	      "text-decoration": "underline",
	      "cursor": "pointer"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.kmUrl('https://km.sankuai.com/page/18286751#id-2.%E6%9C%AA%E6%B3%A8%E5%86%8C%E6%88%90%E5%8A%9F')
	      }
	    }
	  }, [_vm._v("未注册成功")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "20px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("2.未注册成功")]), _c('br'), _c('br'), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-weight": "bold"
	    }
	  }, [_vm._v("①Mac")]), _c('br'), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "background": "#FFF5EE"
	    }
	  }, [_vm._v("若您是Mac电脑，但是安装了Windows系统，请使用\n            "), _c('span', {
	    staticStyle: {
	      "color": "#63B8FF",
	      "text-decoration": "underline",
	      "cursor": "pointer"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.kmUrl('https://km.sankuai.com/page/18286732#id-2.Windows%E6%9C%AA%E6%B3%A8%E5%86%8C%E6%88%90%E5%8A%9F')
	      }
	    }
	  }, [_vm._v("Windows版工具")]), _vm._v("。\n        ")]), _vm._v(" "), _c('br'), _vm._v("\n        1.请下载mac版工具：\n        "), _c('span', {
	    staticStyle: {
	      "color": "#63B8FF",
	      "text-decoration": "underline",
	      "cursor": "pointer"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.kmUrl('https://share.neixin.cn/link/CK4vW683')
	      }
	    }
	  }, [_vm._v("mac工具下载地址")]), _c('br'), _vm._v("\n        2.下载后，解压文件到任意目录，"), _c('span', {
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v("一定要解压")]), _vm._v("，"), _c('br'), _vm._v("\n        3.运行之后，会自动打开浏览器并打开注册页面（如下图），"), _c('span', {
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v("需要登陆SSO后方可成功注册，若未登陆SSO，将自动跳转至登陆页面")]), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(565),
	      "width": "600px",
	      "height": "350px"
	    }
	  }), _c('br'), _vm._v("\n        4.若注册成功，页面显示如下："), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(566),
	      "width": "550px",
	      "height": "250px"
	    }
	  }), _c('br'), _vm._v("\n        5.操作后请到以下地址查询是否注册成功（\n        "), _c('span', {
	    staticStyle: {
	      "color": "#63B8FF",
	      "text-decoration": "underline",
	      "cursor": "pointer"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.kmUrl('https://km.sankuai.com/page/18286751#id-1.%E6%B3%A8%E5%86%8C%E7%BB%93%E6%9E%9C%E6%9F%A5%E8%AF%A2')
	      }
	    }
	  }, [_vm._v("SEP查询注册结果使用方法")]), _vm._v("）"), _c('br'), _vm._v(" "), _vm._m(4), _vm._v("\n        6.使用工具重新注册后请再次查询注册结果，如仍未注册成功的，请将【mis账号+软件安装成功的图标截图】提供给【6000帮助台】"), _c('br'), _c('br'), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "25px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("五、常见问题FAQ")]), _c('br'), _c('br'), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "color": "#0099FF"
	    }
	  }, [_vm._v("Q：我为什么要安装？不安装又会怎么样呢？")]), _c('br'), _vm._v("\n        A：近半年来，公司办公网几乎每月都有多起病毒感染事件发生，导致电脑无法正常运行、电脑中的文件被删除、信息被窃取等，不仅影响自身办公，还可能病毒传播影响他人电脑，影响公司安全！"), _c('br'), _vm._v("\n        另外，根据公司制度规定，员工应做好本人使用和管理的计算机的防病毒工作，不得随意卸载防病毒软件或改变安全配置。若重新安装了计算机操作系统，应及时安装防病毒软件。"), _c('br'), _c('br'), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "color": "#0099FF"
	    }
	  }, [_vm._v("Q: 怎样区分我的电脑是否需要安装？")]), _c('br'), _vm._v("\n        A：符合以下任意一个条件的电脑都需要安装，无论是自己买的电脑，还是公司配的。若有多台，均需安装。"), _c('br'), _vm._v("\n          1. 用于办公用途的电脑，包括但不限于:"), _c('br'), _vm._v("\n              使用浏览器登录使用任何公司web系统，包括但不限于web邮件、sankuai门户、HR平台等"), _c('br'), _vm._v("\n              使用outlook、apple mail等邮件客户端软件收发邮件"), _c('br'), _vm._v("\n              使用git等软件链接代码仓库进行开发工作"), _c('br'), _vm._v("\n              直接登录或跳板登录公司服务器"), _c('br'), _vm._v("\n              存储公司资料的机器"), _c('br'), _vm._v("\n              其他"), _c('br'), _vm._v("\n          2. 接入公司网络"), _c('br'), _vm._v("\n              通过有线连接公司网络"), _c('br'), _vm._v("\n              通过无线连接公司网络"), _c('br'), _c('br'), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "color": "#0099FF"
	    }
	  }, [_vm._v("Q：安装了杀毒软件会对我的电脑造成什么影响？")]), _c('br'), _vm._v("\n        A：公司采购的杀毒软件是国际知名安全厂商软件，已在各大公司有非常多年普及的经验。信息安全中心自Q1试点推广以来，低于1‰的员工可能遇到异常，包括电脑性能不足、蓝屏等，可能影响办公。当发生这些情况时，请及时联系6000或当地IT解决，或禁用、卸载。"), _c('br'), _c('br'), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "color": "#0099FF"
	    }
	  }, [_vm._v("Q：杀毒软件会做什么事情，会监控我的电脑吗？")]), _c('br'), _vm._v("\n        A：杀毒软件的主要功能为防范电脑病毒、木马或恶意软件，保护终端安全。为了实现其安全功能，杀毒软件会检测系统运行的程序，使用不限于特征匹配等方式检测恶意程序；同时，杀毒软件也会监控网络流量，防止恶意攻击等。\n        "), _c('span', {
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v("请大家放心，杀毒软件不会监控员工操作电脑行为、聊天记录、隐私数据等。")]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v("如大家还有别的疑问，请及时反馈给我们，我们将及时为您解答。谢谢！")]), _c('br'), _vm._v(" "), _c('br')])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "background": "#FFF5EE"
	    }
	  }, [_vm._v("请先判断Mac系统版本方法,是否符合软件要求"), _c('br'), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v("当前支持系统版本号>=10.10")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_vm._v("访问IT门户："), _c('a', {
	    staticClass: "ct-link",
	    staticStyle: {
	      "color": "#1890ff"
	    },
	    attrs: {
	      "data-auto_update": "0",
	      "href": "https://itportal.sankuai.com/",
	      "target": "_blank",
	      "rel": "noopener"
	    }
	  }, [_vm._v("https://itportal.sankuai.com")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(567),
	      "width": "700px",
	      "height": "380px"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "background": "#FFF5EE"
	    }
	  }, [_c('span', {
	    staticStyle: {
	      "font-weight": "bold"
	    }
	  }, [_vm._v("运行信息安全中心提供的注册工具，重新注册一下即可。"), _c('span', {
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v("无须重新安装杀毒软件！")])]), _c('br'), _vm._v("\n            此工具请在连接MTDP网络状态下使用\n        ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('table', {
	    attrs: {
	      "border": "1",
	      "cellpadding": "10",
	      "cellspacing": "0",
	      "width": "90%"
	    }
	  }, [_c('tr', {
	    staticStyle: {
	      "background": "#F5F5F5"
	    },
	    attrs: {
	      "align": "left"
	    }
	  }, [_c('th', [_vm._v("代码块")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("https://reg-sec.meituan.com/api/symantec/status?mis=请输入你的mis账号")])])])
	}]}

/***/ }),
/* 656 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "select-container clearfix",
	    staticStyle: {
	      "margin-top": "2%"
	    }
	  }, [_c('el-form', {
	    ref: "ruleForm",
	    staticClass: "demo-ruleForm",
	    attrs: {
	      "model": _vm.moaAccessWhiteApply,
	      "rules": _vm.checkNull,
	      "label-width": "250px"
	    }
	  }, [_c('div', {
	    staticStyle: {
	      "margin-left": "23%"
	    }
	  }, [_c('span', {
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v("请务必真实填写个人信息，否则将影响安全防护效果！")])]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "margin-left": "10%",
	      "margin-bottom": "15px"
	    }
	  }, [_c('span', {
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v("( Please be sure to fill in your personal information truthfully, otherwise it will affect the security protection effect! )")])]), _vm._v(" "), _c('el-form-item', {
	    staticStyle: {
	      "width": "60%"
	    },
	    attrs: {
	      "label": "账号 ( Mis ) :",
	      "prop": "misId"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "disabled": "",
	      "placeholder": "账号 ( Mis )"
	    },
	    model: {
	      value: (_vm.moaAccessWhiteApply.misId),
	      callback: function($$v) {
	        _vm.$set(_vm.moaAccessWhiteApply, "misId", $$v)
	      },
	      expression: "moaAccessWhiteApply.misId"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "加白场景 ( Whiten the scene ):",
	      "required": "",
	      "prop": "scene"
	    }
	  }, [_c('el-radio-group', {
	    model: {
	      value: (_vm.moaAccessWhiteApply.scene),
	      callback: function($$v) {
	        _vm.$set(_vm.moaAccessWhiteApply, "scene", $$v)
	      },
	      expression: "moaAccessWhiteApply.scene"
	    }
	  }, [_c('el-radio', {
	    attrs: {
	      "label": 1
	    }
	  }, [_vm._v(" 短期加白( Short term whitening ) ")]), _vm._v(" "), _c('el-radio', {
	    attrs: {
	      "label": 2
	    }
	  }, [_vm._v(" 长期加白( Long term whitening ) ")])], 1)], 1), _vm._v(" "), (_vm.moaAccessWhiteApply.scene == 2) ? _c('el-form-item', {
	    attrs: {
	      "required": "",
	      "label": "加白到期时间( The expiration date for the whitelist ):"
	    }
	  }, [_c('el-date-picker', {
	    attrs: {
	      "type": "date",
	      "value-format": "yyyy-MM-dd",
	      "placeholder": "选择时间",
	      "picker-options": _vm.dateLineOptions
	    },
	    model: {
	      value: (_vm.moaAccessWhiteApply.dateLine),
	      callback: function($$v) {
	        _vm.$set(_vm.moaAccessWhiteApply, "dateLine", $$v)
	      },
	      expression: "moaAccessWhiteApply.dateLine"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "操作系统 ( System ):",
	      "required": ""
	    }
	  }, [_c('el-checkbox-group', {
	    attrs: {
	      "placeholder": "请选择"
	    },
	    model: {
	      value: (_vm.moaAccessWhiteApply.deviceOsList),
	      callback: function($$v) {
	        _vm.$set(_vm.moaAccessWhiteApply, "deviceOsList", $$v)
	      },
	      expression: "moaAccessWhiteApply.deviceOsList"
	    }
	  }, [_c('el-checkbox', {
	    attrs: {
	      "label": 1
	    }
	  }, [_vm._v(" PC端: macOS（需要说明不能按照要求安装合规软件的原因） ( PC: macOS, the reason why compliant software cannot be installed as required needs to be explained )")]), _vm._v(" "), _c('el-checkbox', {
	    attrs: {
	      "label": 2
	    }
	  }, [_vm._v(" PC端: Windows（需要说明不能按照要求安装合规软件的原因）( PC: Windows, you need to explain why you cannot install compliant software as required ) ")]), _vm._v(" "), _c('el-checkbox', {
	    attrs: {
	      "label": 7
	    }
	  }, [_vm._v(" 其他 ( other ) ")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "申请安全准入加白项目 ( Access Whitelist Application ):",
	      "required": ""
	    }
	  }, [_c('el-checkbox-group', {
	    attrs: {
	      "placeholder": "请选择"
	    },
	    model: {
	      value: (_vm.moaAccessWhiteApply.items),
	      callback: function($$v) {
	        _vm.$set(_vm.moaAccessWhiteApply, "items", $$v)
	      },
	      expression: "moaAccessWhiteApply.items"
	    }
	  }, [_c('el-checkbox', {
	    attrs: {
	      "label": 1
	    }
	  }, [_vm._v(" MOA不安装加白 ( MOA not installed, add white ) ")]), _vm._v(" "), _c('el-checkbox', {
	    attrs: {
	      "label": 2
	    }
	  }, [_vm._v(" 杀毒软件不安装加白 ( Add whitelist if antivirus software is not installed ) ")]), _vm._v(" "), _c('el-checkbox', {
	    attrs: {
	      "label": 3
	    }
	  }, [_vm._v(" 数据防泄漏不安装加白 ( Data leak prevention without installation and whitelisting ) ")]), _vm._v(" "), _c('el-checkbox', {
	    attrs: {
	      "label": 4
	    }
	  }, [_vm._v(" MDM不安装加白 ( MDM not installed, add white ) ")]), _vm._v(" "), _c('el-checkbox', {
	    attrs: {
	      "label": 5
	    }
	  }, [_vm._v(" 不合规软件不卸载加白 ( Unregister non-compliant software and add it to the whitelist ) ")]), _vm._v(" "), _c('el-checkbox', {
	    attrs: {
	      "label": 6
	    }
	  }, [_vm._v(" 其他 ( other ) ")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
	    staticStyle: {
	      "width": "60%"
	    },
	    attrs: {
	      "label": "申请原因 ( Reason for application ) :",
	      "prop": "reason"
	    }
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.moaAccessWhiteApply.reason),
	      expression: "moaAccessWhiteApply.reason"
	    }],
	    staticStyle: {
	      "width": "98%",
	      "height": "100px",
	      "border": "solid 1px #C0C0C0",
	      "border-radius": "3px",
	      "resize": "none"
	    },
	    attrs: {
	      "maxlength": "2000",
	      "placeholder": "申请原因 ( Reason for application )"
	    },
	    domProps: {
	      "value": (_vm.moaAccessWhiteApply.reason)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.moaAccessWhiteApply, "reason", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "margin-left": "35%"
	    }
	  }, [_c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.commitMisApply(_vm.moaAccessWhiteApply)
	      }
	    }
	  }, [_vm._v(" 提交审批 ( Submit for approval )")])], 1)], 1)], 1)])
	},staticRenderFns: []}

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "select-container clearfix",
	    staticStyle: {
	      "margin-top": "2%",
	      "margin-left": "2%",
	      "float": "left"
	    }
	  }, [_c('span', {
	    staticStyle: {
	      "font-size": "38px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("macOS FAQ")]), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "font-size": "30px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("1. 已安装了MOA但是后台提示未安装")]), _c('br'), _c('br'), _vm._v(" "), _c('p', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(501),
	      "width": "740px",
	      "height": "400px"
	    }
	  })]), _vm._v(" "), _c('p', [_vm._v("原因：MOA安装后需要使用大象扫码登录后才算完全安装完毕。")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("解决方法：请打开MOA客户端，使用大象扫码登陆。")])]), _vm._v(" "), _c('p', [_c('span', {
	    staticStyle: {
	      "font-size": "30px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("2. macOS操作系统安装MOA时提示“打不开MOA安装包，因为它来自身份不明的开发者”")])]), _vm._v(" "), _c('p', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(502),
	      "width": "640px",
	      "height": "320px"
	    }
	  })]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("解决方法：在“系统偏好设置“-->”“安全性与隐私”-->\"通用\" 中找到阻止MOA打开的选项， 选择“仍然打开”。")])]), _vm._v(" "), _c('p', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(503),
	      "width": "540px",
	      "height": "400px"
	    }
	  })]), _vm._v(" "), _c('p', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(504),
	      "width": "450px",
	      "height": "400px"
	    }
	  })]), _vm._v(" "), _c('p', [_c('span', {
	    staticStyle: {
	      "font-size": "30px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("3. 应用打开页面空白")])]), _vm._v(" "), _c('p', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(505),
	      "width": "650px",
	      "height": "400px"
	    }
	  })]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("解决方法：")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("a、检查电脑的网络状况，待网络畅通后点击右上角“刷新页面”按钮刷新。")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("b、确认使用的MOA版本，使用最新稳定版MOA。（移步IT门户，确认或下载最新版MOA\n  "), _c('a', {
	    staticClass: "ct-link",
	    staticStyle: {
	      "color": "#1890ff"
	    },
	    attrs: {
	      "data-auto_update": "0",
	      "data-pageid": "",
	      "href": "https://itportal.sankuai.com/",
	      "target": "_blank",
	      "rel": "noopener"
	    }
	  }, [_vm._v("https://itportal.sankuai.com/")]), _vm._v("）\n  ")])]), _vm._v(" "), _c('p', [_c('span', {
	    staticStyle: {
	      "font-size": "30px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("4.电脑网络正常但软件的客户端界面显示离线")])]), _vm._v(" "), _c('p', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(506),
	      "width": "750px",
	      "height": "400px"
	    }
	  })]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("解决方法：显示客户端离线是指软件与后台服务器的连接失败。此情况常见于电脑断网后的几分钟，软件会在十分钟之内重连服务器。")])]), _vm._v(" "), _c('p', [_c('span', {
	    staticStyle: {
	      "font-size": "30px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("5.运行后“界面显示异常或空白”")])]), _vm._v(" "), _c('p', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(507),
	      "width": "650px",
	      "height": "400px"
	    }
	  })]), _vm._v(" "), _c('p', [_vm._v("原因：macOS 10.10版本的bug，不影响软件使用和统计，MOA新版本已修复。")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("解决方法：")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("a.检查MOA是否最新版本，升级到最新版本；")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("b.联系信息安全中心 ganlubing,zhaoliyang02。")])]), _vm._v(" "), _c('p', [_c('span', {
	    staticStyle: {
	      "font-size": "30px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("6.首页网络接入处显示“无网络”")])]), _vm._v(" "), _c('p', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(508),
	      "width": "750px",
	      "height": "400px"
	    }
	  })]), _vm._v(" "), _c('p', [_vm._v("原因：macOS10.10的显示bug，不影响其他功能，可以忽略。显示在线就代表正常了，MOA新版本已修复。")]), _vm._v(" "), _c('p', [_c('span', {
	    staticStyle: {
	      "font-size": "30px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("7.阻断策略开启后，提示证书安装失败，需要手动输入密码")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("解决办法：")])]), _vm._v(" "), _c('p', [_vm._v("a、打开“钥匙串访问”app，打开方式：“启动台”-->“其他“-->”钥匙串访问“。")]), _vm._v(" "), _c('p', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(509),
	      "width": "280px",
	      "height": "220px"
	    }
	  })]), _vm._v(" "), _c('p', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(510),
	      "width": "600px",
	      "height": "220px"
	    }
	  })]), _vm._v(" "), _c('p', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(511),
	      "width": "600px",
	      "height": "300px"
	    }
	  })]), _vm._v(" "), _c('p', [_vm._v("b、选择菜单栏，“文件”-->\"锁定钥匙串'登陆'“。")]), _vm._v(" "), _c('p', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(512),
	      "width": "580px",
	      "height": "350px"
	    }
	  })]), _vm._v(" "), _c('p', [_vm._v("c、选择菜单栏，“文件” -->“解锁钥匙串'登陆'\"。")]), _vm._v(" "), _c('p', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(513),
	      "width": "500px",
	      "height": "390px"
	    }
	  })]), _vm._v(" "), _c('p', [_c('span', {
	    staticStyle: {
	      "font-size": "30px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("8.阻断策略开启后，无法登录SSO")])]), _vm._v(" "), _c('p', [_vm._v("打开系统“钥匙串访问”，搜索local，如图所示，查看证书“"), _c('strong', [_vm._v("localhost.moa.sankuai.com")]), _vm._v("”（下图红框标示）是否存在，")]), _vm._v(" "), _c('p', [_vm._v("若不存在，参考「9」中解决办法。")]), _vm._v(" "), _c('p', [_vm._v("若存在进一步抓取日记：切换到 ~/Library/Logs/itsec-agent/目录下。打开日期最近的一次日志，在日志中搜索\"SSLIdentityAndCertificates: Creating New Identity\"，如果搜索到关键字，")]), _vm._v(" "), _c('p', [_vm._v("解决方法参考「7」，如果没有，联系RD （信息安全中心：ganlubing,zhaoliyang02）")]), _vm._v(" "), _c('p', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(514),
	      "width": "850px",
	      "height": "500px"
	    }
	  })]), _vm._v(" "), _c('p', [_c('span', {
	    staticStyle: {
	      "font-size": "30px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("9.阻断策略开启后，提示需要输入"), _c('span', {
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v("本地管理员")]), _vm._v("密码弹框")])]), _vm._v(" "), _c('p', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(515),
	      "width": "330px",
	      "height": "150px"
	    }
	  })]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("解决方法：")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("1、需要输入的是"), _c('span', {
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v("本地管理员密码")]), _vm._v("。")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("2、如果出现这种弹框，选择“始终允许”。")])]), _vm._v(" "), _c('p', [_c('span', {
	    staticStyle: {
	      "font-size": "30px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("10.安装MOA后无法打开")])]), _vm._v(" "), _c('p', [_vm._v("如果MOA安装后无法打开，需确认macOS的操作系统版本，MOA的支持macOS版本为 >=10.11。如果您的操作系统是10.11,您需要安装最新版本的MOA，并"), _c('strong', [_vm._v("重启")]), _vm._v("您的操作系统。")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("点击左上角苹果图标，查看「关于本机」显示操作系统版本")])]), _vm._v(" "), _c('p', [_vm._v("如果操作系统版本满足要求，还有问题，联系RD（信息安全中心：ganlubing,zhaoliyang02）")]), _vm._v(" "), _c('p', [_c('span', {
	    staticStyle: {
	      "font-size": "30px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("11、查看MOA版本")])]), _vm._v(" "), _c('p', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(516),
	      "width": "1000px",
	      "height": "600px"
	    }
	  })]), _vm._v(" "), _c('p', [_c('span', {
	    staticStyle: {
	      "font-size": "30px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("12、MOA扫码后账户显示“unknow”")])]), _vm._v(" "), _c('p', [_vm._v("旧版本MOA未彻底卸载，MOA新版本运行异常。")]), _vm._v(" "), _c('p', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(517),
	      "width": "200px",
	      "height": "200px"
	    }
	  })]), _vm._v(" "), _c('p', [_vm._v("请在终端中执行：rm -rf /Applications/MOA.app ，删除掉旧版本MOA残留文件后，重新安装最新版MOA，即可扫码成功。")]), _vm._v(" "), _c('p', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(518),
	      "width": "900px",
	      "height": "150px"
	    }
	  })]), _vm._v(" "), _c('p', [_c('span', {
	    staticStyle: {
	      "font-size": "30px",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("13、MOA已经是最新版本，仍然跳出拦截。")])]), _vm._v(" "), _c('p', [_vm._v("旧版本MOA未彻底卸载，MOA新版本运行异常。")]), _vm._v(" "), _c('p', [_vm._v("解决方法：请在终端中执行： rm -rf /Applications/MOA.app 后，删除掉旧版本MOA残留文件后，重新安装最新版MOA。")])])])
	}]}

/***/ }),
/* 658 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.$store.state.is_manager) ? _c('div', [_c('div', {
	    staticClass: "select-container clearfix",
	    staticStyle: {
	      "margin-top": "6%",
	      "margin-left": "33%",
	      "float": "center"
	    }
	  }, [_c('el-form', {
	    ref: "form",
	    attrs: {
	      "model": _vm.form,
	      "label-width": "80px"
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "删除文档"
	    }
	  }, [_c('el-cascader', {
	    ref: "cascader",
	    attrs: {
	      "change-on-select": "",
	      "options": _vm.form.options,
	      "clearable": ""
	    },
	    model: {
	      value: (_vm.selectedItemList),
	      callback: function($$v) {
	        _vm.selectedItemList = $$v
	      },
	      expression: "selectedItemList"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": _vm.open
	    }
	  }, [_vm._v("删除")])], 1)], 1)], 1)]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * vue-resource v1.5.1
	 * https://github.com/pagekit/vue-resource
	 * Released under the MIT License.
	 */
	
	'use strict';
	
	/**
	 * Promises/A+ polyfill v1.1.4 (https://github.com/bramstein/promis)
	 */
	
	var RESOLVED = 0;
	var REJECTED = 1;
	var PENDING = 2;
	
	function Promise$1(executor) {
	
	    this.state = PENDING;
	    this.value = undefined;
	    this.deferred = [];
	
	    var promise = this;
	
	    try {
	        executor(function (x) {
	            promise.resolve(x);
	        }, function (r) {
	            promise.reject(r);
	        });
	    } catch (e) {
	        promise.reject(e);
	    }
	}
	
	Promise$1.reject = function (r) {
	    return new Promise$1(function (resolve, reject) {
	        reject(r);
	    });
	};
	
	Promise$1.resolve = function (x) {
	    return new Promise$1(function (resolve, reject) {
	        resolve(x);
	    });
	};
	
	Promise$1.all = function all(iterable) {
	    return new Promise$1(function (resolve, reject) {
	        var count = 0, result = [];
	
	        if (iterable.length === 0) {
	            resolve(result);
	        }
	
	        function resolver(i) {
	            return function (x) {
	                result[i] = x;
	                count += 1;
	
	                if (count === iterable.length) {
	                    resolve(result);
	                }
	            };
	        }
	
	        for (var i = 0; i < iterable.length; i += 1) {
	            Promise$1.resolve(iterable[i]).then(resolver(i), reject);
	        }
	    });
	};
	
	Promise$1.race = function race(iterable) {
	    return new Promise$1(function (resolve, reject) {
	        for (var i = 0; i < iterable.length; i += 1) {
	            Promise$1.resolve(iterable[i]).then(resolve, reject);
	        }
	    });
	};
	
	var p = Promise$1.prototype;
	
	p.resolve = function resolve(x) {
	    var promise = this;
	
	    if (promise.state === PENDING) {
	        if (x === promise) {
	            throw new TypeError('Promise settled with itself.');
	        }
	
	        var called = false;
	
	        try {
	            var then = x && x['then'];
	
	            if (x !== null && typeof x === 'object' && typeof then === 'function') {
	                then.call(x, function (x) {
	                    if (!called) {
	                        promise.resolve(x);
	                    }
	                    called = true;
	
	                }, function (r) {
	                    if (!called) {
	                        promise.reject(r);
	                    }
	                    called = true;
	                });
	                return;
	            }
	        } catch (e) {
	            if (!called) {
	                promise.reject(e);
	            }
	            return;
	        }
	
	        promise.state = RESOLVED;
	        promise.value = x;
	        promise.notify();
	    }
	};
	
	p.reject = function reject(reason) {
	    var promise = this;
	
	    if (promise.state === PENDING) {
	        if (reason === promise) {
	            throw new TypeError('Promise settled with itself.');
	        }
	
	        promise.state = REJECTED;
	        promise.value = reason;
	        promise.notify();
	    }
	};
	
	p.notify = function notify() {
	    var promise = this;
	
	    nextTick(function () {
	        if (promise.state !== PENDING) {
	            while (promise.deferred.length) {
	                var deferred = promise.deferred.shift(),
	                    onResolved = deferred[0],
	                    onRejected = deferred[1],
	                    resolve = deferred[2],
	                    reject = deferred[3];
	
	                try {
	                    if (promise.state === RESOLVED) {
	                        if (typeof onResolved === 'function') {
	                            resolve(onResolved.call(undefined, promise.value));
	                        } else {
	                            resolve(promise.value);
	                        }
	                    } else if (promise.state === REJECTED) {
	                        if (typeof onRejected === 'function') {
	                            resolve(onRejected.call(undefined, promise.value));
	                        } else {
	                            reject(promise.value);
	                        }
	                    }
	                } catch (e) {
	                    reject(e);
	                }
	            }
	        }
	    });
	};
	
	p.then = function then(onResolved, onRejected) {
	    var promise = this;
	
	    return new Promise$1(function (resolve, reject) {
	        promise.deferred.push([onResolved, onRejected, resolve, reject]);
	        promise.notify();
	    });
	};
	
	p.catch = function (onRejected) {
	    return this.then(undefined, onRejected);
	};
	
	/**
	 * Promise adapter.
	 */
	
	if (typeof Promise === 'undefined') {
	    window.Promise = Promise$1;
	}
	
	function PromiseObj(executor, context) {
	
	    if (executor instanceof Promise) {
	        this.promise = executor;
	    } else {
	        this.promise = new Promise(executor.bind(context));
	    }
	
	    this.context = context;
	}
	
	PromiseObj.all = function (iterable, context) {
	    return new PromiseObj(Promise.all(iterable), context);
	};
	
	PromiseObj.resolve = function (value, context) {
	    return new PromiseObj(Promise.resolve(value), context);
	};
	
	PromiseObj.reject = function (reason, context) {
	    return new PromiseObj(Promise.reject(reason), context);
	};
	
	PromiseObj.race = function (iterable, context) {
	    return new PromiseObj(Promise.race(iterable), context);
	};
	
	var p$1 = PromiseObj.prototype;
	
	p$1.bind = function (context) {
	    this.context = context;
	    return this;
	};
	
	p$1.then = function (fulfilled, rejected) {
	
	    if (fulfilled && fulfilled.bind && this.context) {
	        fulfilled = fulfilled.bind(this.context);
	    }
	
	    if (rejected && rejected.bind && this.context) {
	        rejected = rejected.bind(this.context);
	    }
	
	    return new PromiseObj(this.promise.then(fulfilled, rejected), this.context);
	};
	
	p$1.catch = function (rejected) {
	
	    if (rejected && rejected.bind && this.context) {
	        rejected = rejected.bind(this.context);
	    }
	
	    return new PromiseObj(this.promise.catch(rejected), this.context);
	};
	
	p$1.finally = function (callback) {
	
	    return this.then(function (value) {
	        callback.call(this);
	        return value;
	    }, function (reason) {
	        callback.call(this);
	        return Promise.reject(reason);
	    }
	    );
	};
	
	/**
	 * Utility functions.
	 */
	
	var ref = {};
	var hasOwnProperty = ref.hasOwnProperty;
	var ref$1 = [];
	var slice = ref$1.slice;
	var debug = false, ntick;
	
	var inBrowser = typeof window !== 'undefined';
	
	function Util (ref) {
	    var config = ref.config;
	    var nextTick = ref.nextTick;
	
	    ntick = nextTick;
	    debug = config.debug || !config.silent;
	}
	
	function warn(msg) {
	    if (typeof console !== 'undefined' && debug) {
	        console.warn('[VueResource warn]: ' + msg);
	    }
	}
	
	function error(msg) {
	    if (typeof console !== 'undefined') {
	        console.error(msg);
	    }
	}
	
	function nextTick(cb, ctx) {
	    return ntick(cb, ctx);
	}
	
	function trim(str) {
	    return str ? str.replace(/^\s*|\s*$/g, '') : '';
	}
	
	function trimEnd(str, chars) {
	
	    if (str && chars === undefined) {
	        return str.replace(/\s+$/, '');
	    }
	
	    if (!str || !chars) {
	        return str;
	    }
	
	    return str.replace(new RegExp(("[" + chars + "]+$")), '');
	}
	
	function toLower(str) {
	    return str ? str.toLowerCase() : '';
	}
	
	function toUpper(str) {
	    return str ? str.toUpperCase() : '';
	}
	
	var isArray = Array.isArray;
	
	function isString(val) {
	    return typeof val === 'string';
	}
	
	function isFunction(val) {
	    return typeof val === 'function';
	}
	
	function isObject(obj) {
	    return obj !== null && typeof obj === 'object';
	}
	
	function isPlainObject(obj) {
	    return isObject(obj) && Object.getPrototypeOf(obj) == Object.prototype;
	}
	
	function isBlob(obj) {
	    return typeof Blob !== 'undefined' && obj instanceof Blob;
	}
	
	function isFormData(obj) {
	    return typeof FormData !== 'undefined' && obj instanceof FormData;
	}
	
	function when(value, fulfilled, rejected) {
	
	    var promise = PromiseObj.resolve(value);
	
	    if (arguments.length < 2) {
	        return promise;
	    }
	
	    return promise.then(fulfilled, rejected);
	}
	
	function options(fn, obj, opts) {
	
	    opts = opts || {};
	
	    if (isFunction(opts)) {
	        opts = opts.call(obj);
	    }
	
	    return merge(fn.bind({$vm: obj, $options: opts}), fn, {$options: opts});
	}
	
	function each(obj, iterator) {
	
	    var i, key;
	
	    if (isArray(obj)) {
	        for (i = 0; i < obj.length; i++) {
	            iterator.call(obj[i], obj[i], i);
	        }
	    } else if (isObject(obj)) {
	        for (key in obj) {
	            if (hasOwnProperty.call(obj, key)) {
	                iterator.call(obj[key], obj[key], key);
	            }
	        }
	    }
	
	    return obj;
	}
	
	var assign = Object.assign || _assign;
	
	function merge(target) {
	
	    var args = slice.call(arguments, 1);
	
	    args.forEach(function (source) {
	        _merge(target, source, true);
	    });
	
	    return target;
	}
	
	function defaults(target) {
	
	    var args = slice.call(arguments, 1);
	
	    args.forEach(function (source) {
	
	        for (var key in source) {
	            if (target[key] === undefined) {
	                target[key] = source[key];
	            }
	        }
	
	    });
	
	    return target;
	}
	
	function _assign(target) {
	
	    var args = slice.call(arguments, 1);
	
	    args.forEach(function (source) {
	        _merge(target, source);
	    });
	
	    return target;
	}
	
	function _merge(target, source, deep) {
	    for (var key in source) {
	        if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
	            if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
	                target[key] = {};
	            }
	            if (isArray(source[key]) && !isArray(target[key])) {
	                target[key] = [];
	            }
	            _merge(target[key], source[key], deep);
	        } else if (source[key] !== undefined) {
	            target[key] = source[key];
	        }
	    }
	}
	
	/**
	 * Root Prefix Transform.
	 */
	
	function root (options$$1, next) {
	
	    var url = next(options$$1);
	
	    if (isString(options$$1.root) && !/^(https?:)?\//.test(url)) {
	        url = trimEnd(options$$1.root, '/') + '/' + url;
	    }
	
	    return url;
	}
	
	/**
	 * Query Parameter Transform.
	 */
	
	function query (options$$1, next) {
	
	    var urlParams = Object.keys(Url.options.params), query = {}, url = next(options$$1);
	
	    each(options$$1.params, function (value, key) {
	        if (urlParams.indexOf(key) === -1) {
	            query[key] = value;
	        }
	    });
	
	    query = Url.params(query);
	
	    if (query) {
	        url += (url.indexOf('?') == -1 ? '?' : '&') + query;
	    }
	
	    return url;
	}
	
	/**
	 * URL Template v2.0.6 (https://github.com/bramstein/url-template)
	 */
	
	function expand(url, params, variables) {
	
	    var tmpl = parse(url), expanded = tmpl.expand(params);
	
	    if (variables) {
	        variables.push.apply(variables, tmpl.vars);
	    }
	
	    return expanded;
	}
	
	function parse(template) {
	
	    var operators = ['+', '#', '.', '/', ';', '?', '&'], variables = [];
	
	    return {
	        vars: variables,
	        expand: function expand(context) {
	            return template.replace(/\{([^{}]+)\}|([^{}]+)/g, function (_, expression, literal) {
	                if (expression) {
	
	                    var operator = null, values = [];
	
	                    if (operators.indexOf(expression.charAt(0)) !== -1) {
	                        operator = expression.charAt(0);
	                        expression = expression.substr(1);
	                    }
	
	                    expression.split(/,/g).forEach(function (variable) {
	                        var tmp = /([^:*]*)(?::(\d+)|(\*))?/.exec(variable);
	                        values.push.apply(values, getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
	                        variables.push(tmp[1]);
	                    });
	
	                    if (operator && operator !== '+') {
	
	                        var separator = ',';
	
	                        if (operator === '?') {
	                            separator = '&';
	                        } else if (operator !== '#') {
	                            separator = operator;
	                        }
	
	                        return (values.length !== 0 ? operator : '') + values.join(separator);
	                    } else {
	                        return values.join(',');
	                    }
	
	                } else {
	                    return encodeReserved(literal);
	                }
	            });
	        }
	    };
	}
	
	function getValues(context, operator, key, modifier) {
	
	    var value = context[key], result = [];
	
	    if (isDefined(value) && value !== '') {
	        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
	            value = value.toString();
	
	            if (modifier && modifier !== '*') {
	                value = value.substring(0, parseInt(modifier, 10));
	            }
	
	            result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
	        } else {
	            if (modifier === '*') {
	                if (Array.isArray(value)) {
	                    value.filter(isDefined).forEach(function (value) {
	                        result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
	                    });
	                } else {
	                    Object.keys(value).forEach(function (k) {
	                        if (isDefined(value[k])) {
	                            result.push(encodeValue(operator, value[k], k));
	                        }
	                    });
	                }
	            } else {
	                var tmp = [];
	
	                if (Array.isArray(value)) {
	                    value.filter(isDefined).forEach(function (value) {
	                        tmp.push(encodeValue(operator, value));
	                    });
	                } else {
	                    Object.keys(value).forEach(function (k) {
	                        if (isDefined(value[k])) {
	                            tmp.push(encodeURIComponent(k));
	                            tmp.push(encodeValue(operator, value[k].toString()));
	                        }
	                    });
	                }
	
	                if (isKeyOperator(operator)) {
	                    result.push(encodeURIComponent(key) + '=' + tmp.join(','));
	                } else if (tmp.length !== 0) {
	                    result.push(tmp.join(','));
	                }
	            }
	        }
	    } else {
	        if (operator === ';') {
	            result.push(encodeURIComponent(key));
	        } else if (value === '' && (operator === '&' || operator === '?')) {
	            result.push(encodeURIComponent(key) + '=');
	        } else if (value === '') {
	            result.push('');
	        }
	    }
	
	    return result;
	}
	
	function isDefined(value) {
	    return value !== undefined && value !== null;
	}
	
	function isKeyOperator(operator) {
	    return operator === ';' || operator === '&' || operator === '?';
	}
	
	function encodeValue(operator, value, key) {
	
	    value = (operator === '+' || operator === '#') ? encodeReserved(value) : encodeURIComponent(value);
	
	    if (key) {
	        return encodeURIComponent(key) + '=' + value;
	    } else {
	        return value;
	    }
	}
	
	function encodeReserved(str) {
	    return str.split(/(%[0-9A-Fa-f]{2})/g).map(function (part) {
	        if (!/%[0-9A-Fa-f]/.test(part)) {
	            part = encodeURI(part);
	        }
	        return part;
	    }).join('');
	}
	
	/**
	 * URL Template (RFC 6570) Transform.
	 */
	
	function template (options) {
	
	    var variables = [], url = expand(options.url, options.params, variables);
	
	    variables.forEach(function (key) {
	        delete options.params[key];
	    });
	
	    return url;
	}
	
	/**
	 * Service for URL templating.
	 */
	
	function Url(url, params) {
	
	    var self = this || {}, options$$1 = url, transform;
	
	    if (isString(url)) {
	        options$$1 = {url: url, params: params};
	    }
	
	    options$$1 = merge({}, Url.options, self.$options, options$$1);
	
	    Url.transforms.forEach(function (handler) {
	
	        if (isString(handler)) {
	            handler = Url.transform[handler];
	        }
	
	        if (isFunction(handler)) {
	            transform = factory(handler, transform, self.$vm);
	        }
	
	    });
	
	    return transform(options$$1);
	}
	
	/**
	 * Url options.
	 */
	
	Url.options = {
	    url: '',
	    root: null,
	    params: {}
	};
	
	/**
	 * Url transforms.
	 */
	
	Url.transform = {template: template, query: query, root: root};
	Url.transforms = ['template', 'query', 'root'];
	
	/**
	 * Encodes a Url parameter string.
	 *
	 * @param {Object} obj
	 */
	
	Url.params = function (obj) {
	
	    var params = [], escape = encodeURIComponent;
	
	    params.add = function (key, value) {
	
	        if (isFunction(value)) {
	            value = value();
	        }
	
	        if (value === null) {
	            value = '';
	        }
	
	        this.push(escape(key) + '=' + escape(value));
	    };
	
	    serialize(params, obj);
	
	    return params.join('&').replace(/%20/g, '+');
	};
	
	/**
	 * Parse a URL and return its components.
	 *
	 * @param {String} url
	 */
	
	Url.parse = function (url) {
	
	    var el = document.createElement('a');
	
	    if (document.documentMode) {
	        el.href = url;
	        url = el.href;
	    }
	
	    el.href = url;
	
	    return {
	        href: el.href,
	        protocol: el.protocol ? el.protocol.replace(/:$/, '') : '',
	        port: el.port,
	        host: el.host,
	        hostname: el.hostname,
	        pathname: el.pathname.charAt(0) === '/' ? el.pathname : '/' + el.pathname,
	        search: el.search ? el.search.replace(/^\?/, '') : '',
	        hash: el.hash ? el.hash.replace(/^#/, '') : ''
	    };
	};
	
	function factory(handler, next, vm) {
	    return function (options$$1) {
	        return handler.call(vm, options$$1, next);
	    };
	}
	
	function serialize(params, obj, scope) {
	
	    var array = isArray(obj), plain = isPlainObject(obj), hash;
	
	    each(obj, function (value, key) {
	
	        hash = isObject(value) || isArray(value);
	
	        if (scope) {
	            key = scope + '[' + (plain || hash ? key : '') + ']';
	        }
	
	        if (!scope && array) {
	            params.add(value.name, value.value);
	        } else if (hash) {
	            serialize(params, value, key);
	        } else {
	            params.add(key, value);
	        }
	    });
	}
	
	/**
	 * XDomain client (Internet Explorer).
	 */
	
	function xdrClient (request) {
	    return new PromiseObj(function (resolve) {
	
	        var xdr = new XDomainRequest(), handler = function (ref) {
	                var type = ref.type;
	
	
	                var status = 0;
	
	                if (type === 'load') {
	                    status = 200;
	                } else if (type === 'error') {
	                    status = 500;
	                }
	
	                resolve(request.respondWith(xdr.responseText, {status: status}));
	            };
	
	        request.abort = function () { return xdr.abort(); };
	
	        xdr.open(request.method, request.getUrl());
	
	        if (request.timeout) {
	            xdr.timeout = request.timeout;
	        }
	
	        xdr.onload = handler;
	        xdr.onabort = handler;
	        xdr.onerror = handler;
	        xdr.ontimeout = handler;
	        xdr.onprogress = function () {};
	        xdr.send(request.getBody());
	    });
	}
	
	/**
	 * CORS Interceptor.
	 */
	
	var SUPPORTS_CORS = inBrowser && 'withCredentials' in new XMLHttpRequest();
	
	function cors (request) {
	
	    if (inBrowser) {
	
	        var orgUrl = Url.parse(location.href);
	        var reqUrl = Url.parse(request.getUrl());
	
	        if (reqUrl.protocol !== orgUrl.protocol || reqUrl.host !== orgUrl.host) {
	
	            request.crossOrigin = true;
	            request.emulateHTTP = false;
	
	            if (!SUPPORTS_CORS) {
	                request.client = xdrClient;
	            }
	        }
	    }
	
	}
	
	/**
	 * Form data Interceptor.
	 */
	
	function form (request) {
	
	    if (isFormData(request.body)) {
	        request.headers.delete('Content-Type');
	    } else if (isObject(request.body) && request.emulateJSON) {
	        request.body = Url.params(request.body);
	        request.headers.set('Content-Type', 'application/x-www-form-urlencoded');
	    }
	
	}
	
	/**
	 * JSON Interceptor.
	 */
	
	function json (request) {
	
	    var type = request.headers.get('Content-Type') || '';
	
	    if (isObject(request.body) && type.indexOf('application/json') === 0) {
	        request.body = JSON.stringify(request.body);
	    }
	
	    return function (response) {
	
	        return response.bodyText ? when(response.text(), function (text) {
	
	            var type = response.headers.get('Content-Type') || '';
	
	            if (type.indexOf('application/json') === 0 || isJson(text)) {
	
	                try {
	                    response.body = JSON.parse(text);
	                } catch (e) {
	                    response.body = null;
	                }
	
	            } else {
	                response.body = text;
	            }
	
	            return response;
	
	        }) : response;
	
	    };
	}
	
	function isJson(str) {
	
	    var start = str.match(/^\s*(\[|\{)/);
	    var end = {'[': /]\s*$/, '{': /}\s*$/};
	
	    return start && end[start[1]].test(str);
	}
	
	/**
	 * JSONP client (Browser).
	 */
	
	function jsonpClient (request) {
	    return new PromiseObj(function (resolve) {
	
	        var name = request.jsonp || 'callback', callback = request.jsonpCallback || '_jsonp' + Math.random().toString(36).substr(2), body = null, handler, script;
	
	        handler = function (ref) {
	            var type = ref.type;
	
	
	            var status = 0;
	
	            if (type === 'load' && body !== null) {
	                status = 200;
	            } else if (type === 'error') {
	                status = 500;
	            }
	
	            if (status && window[callback]) {
	                delete window[callback];
	                document.body.removeChild(script);
	            }
	
	            resolve(request.respondWith(body, {status: status}));
	        };
	
	        window[callback] = function (result) {
	            body = JSON.stringify(result);
	        };
	
	        request.abort = function () {
	            handler({type: 'abort'});
	        };
	
	        request.params[name] = callback;
	
	        if (request.timeout) {
	            setTimeout(request.abort, request.timeout);
	        }
	
	        script = document.createElement('script');
	        script.src = request.getUrl();
	        script.type = 'text/javascript';
	        script.async = true;
	        script.onload = handler;
	        script.onerror = handler;
	
	        document.body.appendChild(script);
	    });
	}
	
	/**
	 * JSONP Interceptor.
	 */
	
	function jsonp (request) {
	
	    if (request.method == 'JSONP') {
	        request.client = jsonpClient;
	    }
	
	}
	
	/**
	 * Before Interceptor.
	 */
	
	function before (request) {
	
	    if (isFunction(request.before)) {
	        request.before.call(this, request);
	    }
	
	}
	
	/**
	 * HTTP method override Interceptor.
	 */
	
	function method (request) {
	
	    if (request.emulateHTTP && /^(PUT|PATCH|DELETE)$/i.test(request.method)) {
	        request.headers.set('X-HTTP-Method-Override', request.method);
	        request.method = 'POST';
	    }
	
	}
	
	/**
	 * Header Interceptor.
	 */
	
	function header (request) {
	
	    var headers = assign({}, Http.headers.common,
	        !request.crossOrigin ? Http.headers.custom : {},
	        Http.headers[toLower(request.method)]
	    );
	
	    each(headers, function (value, name) {
	        if (!request.headers.has(name)) {
	            request.headers.set(name, value);
	        }
	    });
	
	}
	
	/**
	 * XMLHttp client (Browser).
	 */
	
	function xhrClient (request) {
	    return new PromiseObj(function (resolve) {
	
	        var xhr = new XMLHttpRequest(), handler = function (event) {
	
	                var response = request.respondWith(
	                'response' in xhr ? xhr.response : xhr.responseText, {
	                    status: xhr.status === 1223 ? 204 : xhr.status, // IE9 status bug
	                    statusText: xhr.status === 1223 ? 'No Content' : trim(xhr.statusText)
	                });
	
	                each(trim(xhr.getAllResponseHeaders()).split('\n'), function (row) {
	                    response.headers.append(row.slice(0, row.indexOf(':')), row.slice(row.indexOf(':') + 1));
	                });
	
	                resolve(response);
	            };
	
	        request.abort = function () { return xhr.abort(); };
	
	        xhr.open(request.method, request.getUrl(), true);
	
	        if (request.timeout) {
	            xhr.timeout = request.timeout;
	        }
	
	        if (request.responseType && 'responseType' in xhr) {
	            xhr.responseType = request.responseType;
	        }
	
	        if (request.withCredentials || request.credentials) {
	            xhr.withCredentials = true;
	        }
	
	        if (!request.crossOrigin) {
	            request.headers.set('X-Requested-With', 'XMLHttpRequest');
	        }
	
	        // deprecated use downloadProgress
	        if (isFunction(request.progress) && request.method === 'GET') {
	            xhr.addEventListener('progress', request.progress);
	        }
	
	        if (isFunction(request.downloadProgress)) {
	            xhr.addEventListener('progress', request.downloadProgress);
	        }
	
	        // deprecated use uploadProgress
	        if (isFunction(request.progress) && /^(POST|PUT)$/i.test(request.method)) {
	            xhr.upload.addEventListener('progress', request.progress);
	        }
	
	        if (isFunction(request.uploadProgress) && xhr.upload) {
	            xhr.upload.addEventListener('progress', request.uploadProgress);
	        }
	
	        request.headers.forEach(function (value, name) {
	            xhr.setRequestHeader(name, value);
	        });
	
	        xhr.onload = handler;
	        xhr.onabort = handler;
	        xhr.onerror = handler;
	        xhr.ontimeout = handler;
	        xhr.send(request.getBody());
	    });
	}
	
	/**
	 * Http client (Node).
	 */
	
	function nodeClient (request) {
	
	    var client = __webpack_require__(664);
	
	    return new PromiseObj(function (resolve) {
	
	        var url = request.getUrl();
	        var body = request.getBody();
	        var method = request.method;
	        var headers = {}, handler;
	
	        request.headers.forEach(function (value, name) {
	            headers[name] = value;
	        });
	
	        client(url, {body: body, method: method, headers: headers}).then(handler = function (resp) {
	
	            var response = request.respondWith(resp.body, {
	                status: resp.statusCode,
	                statusText: trim(resp.statusMessage)
	            });
	
	            each(resp.headers, function (value, name) {
	                response.headers.set(name, value);
	            });
	
	            resolve(response);
	
	        }, function (error$$1) { return handler(error$$1.response); });
	    });
	}
	
	/**
	 * Base client.
	 */
	
	function Client (context) {
	
	    var reqHandlers = [sendRequest], resHandlers = [];
	
	    if (!isObject(context)) {
	        context = null;
	    }
	
	    function Client(request) {
	        while (reqHandlers.length) {
	
	            var handler = reqHandlers.pop();
	
	            if (isFunction(handler)) {
	
	                var response = (void 0), next = (void 0);
	
	                response = handler.call(context, request, function (val) { return next = val; }) || next;
	
	                if (isObject(response)) {
	                    return new PromiseObj(function (resolve, reject) {
	
	                        resHandlers.forEach(function (handler) {
	                            response = when(response, function (response) {
	                                return handler.call(context, response) || response;
	                            }, reject);
	                        });
	
	                        when(response, resolve, reject);
	
	                    }, context);
	                }
	
	                if (isFunction(response)) {
	                    resHandlers.unshift(response);
	                }
	
	            } else {
	                warn(("Invalid interceptor of type " + (typeof handler) + ", must be a function"));
	            }
	        }
	    }
	
	    Client.use = function (handler) {
	        reqHandlers.push(handler);
	    };
	
	    return Client;
	}
	
	function sendRequest(request) {
	
	    var client = request.client || (inBrowser ? xhrClient : nodeClient);
	
	    return client(request);
	}
	
	/**
	 * HTTP Headers.
	 */
	
	var Headers = function Headers(headers) {
	    var this$1 = this;
	
	
	    this.map = {};
	
	    each(headers, function (value, name) { return this$1.append(name, value); });
	};
	
	Headers.prototype.has = function has (name) {
	    return getName(this.map, name) !== null;
	};
	
	Headers.prototype.get = function get (name) {
	
	    var list = this.map[getName(this.map, name)];
	
	    return list ? list.join() : null;
	};
	
	Headers.prototype.getAll = function getAll (name) {
	    return this.map[getName(this.map, name)] || [];
	};
	
	Headers.prototype.set = function set (name, value) {
	    this.map[normalizeName(getName(this.map, name) || name)] = [trim(value)];
	};
	
	Headers.prototype.append = function append (name, value) {
	
	    var list = this.map[getName(this.map, name)];
	
	    if (list) {
	        list.push(trim(value));
	    } else {
	        this.set(name, value);
	    }
	};
	
	Headers.prototype.delete = function delete$1 (name) {
	    delete this.map[getName(this.map, name)];
	};
	
	Headers.prototype.deleteAll = function deleteAll () {
	    this.map = {};
	};
	
	Headers.prototype.forEach = function forEach (callback, thisArg) {
	        var this$1 = this;
	
	    each(this.map, function (list, name) {
	        each(list, function (value) { return callback.call(thisArg, value, name, this$1); });
	    });
	};
	
	function getName(map, name) {
	    return Object.keys(map).reduce(function (prev, curr) {
	        return toLower(name) === toLower(curr) ? curr : prev;
	    }, null);
	}
	
	function normalizeName(name) {
	
	    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
	        throw new TypeError('Invalid character in header field name');
	    }
	
	    return trim(name);
	}
	
	/**
	 * HTTP Response.
	 */
	
	var Response = function Response(body, ref) {
	    var url = ref.url;
	    var headers = ref.headers;
	    var status = ref.status;
	    var statusText = ref.statusText;
	
	
	    this.url = url;
	    this.ok = status >= 200 && status < 300;
	    this.status = status || 0;
	    this.statusText = statusText || '';
	    this.headers = new Headers(headers);
	    this.body = body;
	
	    if (isString(body)) {
	
	        this.bodyText = body;
	
	    } else if (isBlob(body)) {
	
	        this.bodyBlob = body;
	
	        if (isBlobText(body)) {
	            this.bodyText = blobText(body);
	        }
	    }
	};
	
	Response.prototype.blob = function blob () {
	    return when(this.bodyBlob);
	};
	
	Response.prototype.text = function text () {
	    return when(this.bodyText);
	};
	
	Response.prototype.json = function json () {
	    return when(this.text(), function (text) { return JSON.parse(text); });
	};
	
	Object.defineProperty(Response.prototype, 'data', {
	
	    get: function get() {
	        return this.body;
	    },
	
	    set: function set(body) {
	        this.body = body;
	    }
	
	});
	
	function blobText(body) {
	    return new PromiseObj(function (resolve) {
	
	        var reader = new FileReader();
	
	        reader.readAsText(body);
	        reader.onload = function () {
	            resolve(reader.result);
	        };
	
	    });
	}
	
	function isBlobText(body) {
	    return body.type.indexOf('text') === 0 || body.type.indexOf('json') !== -1;
	}
	
	/**
	 * HTTP Request.
	 */
	
	var Request = function Request(options$$1) {
	
	    this.body = null;
	    this.params = {};
	
	    assign(this, options$$1, {
	        method: toUpper(options$$1.method || 'GET')
	    });
	
	    if (!(this.headers instanceof Headers)) {
	        this.headers = new Headers(this.headers);
	    }
	};
	
	Request.prototype.getUrl = function getUrl () {
	    return Url(this);
	};
	
	Request.prototype.getBody = function getBody () {
	    return this.body;
	};
	
	Request.prototype.respondWith = function respondWith (body, options$$1) {
	    return new Response(body, assign(options$$1 || {}, {url: this.getUrl()}));
	};
	
	/**
	 * Service for sending network requests.
	 */
	
	var COMMON_HEADERS = {'Accept': 'application/json, text/plain, */*'};
	var JSON_CONTENT_TYPE = {'Content-Type': 'application/json;charset=utf-8'};
	
	function Http(options$$1) {
	
	    var self = this || {}, client = Client(self.$vm);
	
	    defaults(options$$1 || {}, self.$options, Http.options);
	
	    Http.interceptors.forEach(function (handler) {
	
	        if (isString(handler)) {
	            handler = Http.interceptor[handler];
	        }
	
	        if (isFunction(handler)) {
	            client.use(handler);
	        }
	
	    });
	
	    return client(new Request(options$$1)).then(function (response) {
	
	        return response.ok ? response : PromiseObj.reject(response);
	
	    }, function (response) {
	
	        if (response instanceof Error) {
	            error(response);
	        }
	
	        return PromiseObj.reject(response);
	    });
	}
	
	Http.options = {};
	
	Http.headers = {
	    put: JSON_CONTENT_TYPE,
	    post: JSON_CONTENT_TYPE,
	    patch: JSON_CONTENT_TYPE,
	    delete: JSON_CONTENT_TYPE,
	    common: COMMON_HEADERS,
	    custom: {}
	};
	
	Http.interceptor = {before: before, method: method, jsonp: jsonp, json: json, form: form, header: header, cors: cors};
	Http.interceptors = ['before', 'method', 'jsonp', 'json', 'form', 'header', 'cors'];
	
	['get', 'delete', 'head', 'jsonp'].forEach(function (method$$1) {
	
	    Http[method$$1] = function (url, options$$1) {
	        return this(assign(options$$1 || {}, {url: url, method: method$$1}));
	    };
	
	});
	
	['post', 'put', 'patch'].forEach(function (method$$1) {
	
	    Http[method$$1] = function (url, body, options$$1) {
	        return this(assign(options$$1 || {}, {url: url, method: method$$1, body: body}));
	    };
	
	});
	
	/**
	 * Service for interacting with RESTful services.
	 */
	
	function Resource(url, params, actions, options$$1) {
	
	    var self = this || {}, resource = {};
	
	    actions = assign({},
	        Resource.actions,
	        actions
	    );
	
	    each(actions, function (action, name) {
	
	        action = merge({url: url, params: assign({}, params)}, options$$1, action);
	
	        resource[name] = function () {
	            return (self.$http || Http)(opts(action, arguments));
	        };
	    });
	
	    return resource;
	}
	
	function opts(action, args) {
	
	    var options$$1 = assign({}, action), params = {}, body;
	
	    switch (args.length) {
	
	        case 2:
	
	            params = args[0];
	            body = args[1];
	
	            break;
	
	        case 1:
	
	            if (/^(POST|PUT|PATCH)$/i.test(options$$1.method)) {
	                body = args[0];
	            } else {
	                params = args[0];
	            }
	
	            break;
	
	        case 0:
	
	            break;
	
	        default:
	
	            throw 'Expected up to 2 arguments [params, body], got ' + args.length + ' arguments';
	    }
	
	    options$$1.body = body;
	    options$$1.params = assign({}, options$$1.params, params);
	
	    return options$$1;
	}
	
	Resource.actions = {
	
	    get: {method: 'GET'},
	    save: {method: 'POST'},
	    query: {method: 'GET'},
	    update: {method: 'PUT'},
	    remove: {method: 'DELETE'},
	    delete: {method: 'DELETE'}
	
	};
	
	/**
	 * Install plugin.
	 */
	
	function plugin(Vue) {
	
	    if (plugin.installed) {
	        return;
	    }
	
	    Util(Vue);
	
	    Vue.url = Url;
	    Vue.http = Http;
	    Vue.resource = Resource;
	    Vue.Promise = PromiseObj;
	
	    Object.defineProperties(Vue.prototype, {
	
	        $url: {
	            get: function get() {
	                return options(Vue.url, this, this.$options.url);
	            }
	        },
	
	        $http: {
	            get: function get() {
	                return options(Vue.http, this, this.$options.http);
	            }
	        },
	
	        $resource: {
	            get: function get() {
	                return Vue.resource.bind(this);
	            }
	        },
	
	        $promise: {
	            get: function get() {
	                var this$1 = this;
	
	                return function (executor) { return new Vue.Promise(executor, this$1); };
	            }
	        }
	
	    });
	}
	
	if (typeof window !== 'undefined' && window.Vue) {
	    window.Vue.use(plugin);
	}
	
	module.exports = plugin;


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	  * vue-router v2.8.1
	  * (c) 2017 Evan You
	  * @license MIT
	  */
	'use strict';
	
	/*  */
	
	function assert (condition, message) {
	  if (!condition) {
	    throw new Error(("[vue-router] " + message))
	  }
	}
	
	function warn (condition, message) {
	  if (false) {
	    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
	  }
	}
	
	function isError (err) {
	  return Object.prototype.toString.call(err).indexOf('Error') > -1
	}
	
	var View = {
	  name: 'router-view',
	  functional: true,
	  props: {
	    name: {
	      type: String,
	      default: 'default'
	    }
	  },
	  render: function render (_, ref) {
	    var props = ref.props;
	    var children = ref.children;
	    var parent = ref.parent;
	    var data = ref.data;
	
	    data.routerView = true;
	
	    // directly use parent context's createElement() function
	    // so that components rendered by router-view can resolve named slots
	    var h = parent.$createElement;
	    var name = props.name;
	    var route = parent.$route;
	    var cache = parent._routerViewCache || (parent._routerViewCache = {});
	
	    // determine current view depth, also check to see if the tree
	    // has been toggled inactive but kept-alive.
	    var depth = 0;
	    var inactive = false;
	    while (parent && parent._routerRoot !== parent) {
	      if (parent.$vnode && parent.$vnode.data.routerView) {
	        depth++;
	      }
	      if (parent._inactive) {
	        inactive = true;
	      }
	      parent = parent.$parent;
	    }
	    data.routerViewDepth = depth;
	
	    // render previous view if the tree is inactive and kept-alive
	    if (inactive) {
	      return h(cache[name], data, children)
	    }
	
	    var matched = route.matched[depth];
	    // render empty node if no matched route
	    if (!matched) {
	      cache[name] = null;
	      return h()
	    }
	
	    var component = cache[name] = matched.components[name];
	
	    // attach instance registration hook
	    // this will be called in the instance's injected lifecycle hooks
	    data.registerRouteInstance = function (vm, val) {
	      // val could be undefined for unregistration
	      var current = matched.instances[name];
	      if (
	        (val && current !== vm) ||
	        (!val && current === vm)
	      ) {
	        matched.instances[name] = val;
	      }
	    }
	
	    // also register instance in prepatch hook
	    // in case the same component instance is reused across different routes
	    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
	      matched.instances[name] = vnode.componentInstance;
	    };
	
	    // resolve props
	    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
	    if (propsToPass) {
	      // clone to prevent mutation
	      propsToPass = data.props = extend({}, propsToPass);
	      // pass non-declared props as attrs
	      var attrs = data.attrs = data.attrs || {};
	      for (var key in propsToPass) {
	        if (!component.props || !(key in component.props)) {
	          attrs[key] = propsToPass[key];
	          delete propsToPass[key];
	        }
	      }
	    }
	
	    return h(component, data, children)
	  }
	};
	
	function resolveProps (route, config) {
	  switch (typeof config) {
	    case 'undefined':
	      return
	    case 'object':
	      return config
	    case 'function':
	      return config(route)
	    case 'boolean':
	      return config ? route.params : undefined
	    default:
	      if (false) {
	        warn(
	          false,
	          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
	          "expecting an object, function or boolean."
	        );
	      }
	  }
	}
	
	function extend (to, from) {
	  for (var key in from) {
	    to[key] = from[key];
	  }
	  return to
	}
	
	/*  */
	
	var encodeReserveRE = /[!'()*]/g;
	var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
	var commaRE = /%2C/g;
	
	// fixed encodeURIComponent which is more conformant to RFC3986:
	// - escapes [!'()*]
	// - preserve commas
	var encode = function (str) { return encodeURIComponent(str)
	  .replace(encodeReserveRE, encodeReserveReplacer)
	  .replace(commaRE, ','); };
	
	var decode = decodeURIComponent;
	
	function resolveQuery (
	  query,
	  extraQuery,
	  _parseQuery
	) {
	  if ( extraQuery === void 0 ) extraQuery = {};
	
	  var parse = _parseQuery || parseQuery;
	  var parsedQuery;
	  try {
	    parsedQuery = parse(query || '');
	  } catch (e) {
	    ("production") !== 'production' && warn(false, e.message);
	    parsedQuery = {};
	  }
	  for (var key in extraQuery) {
	    parsedQuery[key] = extraQuery[key];
	  }
	  return parsedQuery
	}
	
	function parseQuery (query) {
	  var res = {};
	
	  query = query.trim().replace(/^(\?|#|&)/, '');
	
	  if (!query) {
	    return res
	  }
	
	  query.split('&').forEach(function (param) {
	    var parts = param.replace(/\+/g, ' ').split('=');
	    var key = decode(parts.shift());
	    var val = parts.length > 0
	      ? decode(parts.join('='))
	      : null;
	
	    if (res[key] === undefined) {
	      res[key] = val;
	    } else if (Array.isArray(res[key])) {
	      res[key].push(val);
	    } else {
	      res[key] = [res[key], val];
	    }
	  });
	
	  return res
	}
	
	function stringifyQuery (obj) {
	  var res = obj ? Object.keys(obj).map(function (key) {
	    var val = obj[key];
	
	    if (val === undefined) {
	      return ''
	    }
	
	    if (val === null) {
	      return encode(key)
	    }
	
	    if (Array.isArray(val)) {
	      var result = [];
	      val.forEach(function (val2) {
	        if (val2 === undefined) {
	          return
	        }
	        if (val2 === null) {
	          result.push(encode(key));
	        } else {
	          result.push(encode(key) + '=' + encode(val2));
	        }
	      });
	      return result.join('&')
	    }
	
	    return encode(key) + '=' + encode(val)
	  }).filter(function (x) { return x.length > 0; }).join('&') : null;
	  return res ? ("?" + res) : ''
	}
	
	/*  */
	
	
	var trailingSlashRE = /\/?$/;
	
	function createRoute (
	  record,
	  location,
	  redirectedFrom,
	  router
	) {
	  var stringifyQuery$$1 = router && router.options.stringifyQuery;
	
	  var query = location.query || {};
	  try {
	    query = clone(query);
	  } catch (e) {}
	
	  var route = {
	    name: location.name || (record && record.name),
	    meta: (record && record.meta) || {},
	    path: location.path || '/',
	    hash: location.hash || '',
	    query: query,
	    params: location.params || {},
	    fullPath: getFullPath(location, stringifyQuery$$1),
	    matched: record ? formatMatch(record) : []
	  };
	  if (redirectedFrom) {
	    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
	  }
	  return Object.freeze(route)
	}
	
	function clone (value) {
	  if (Array.isArray(value)) {
	    return value.map(clone)
	  } else if (value && typeof value === 'object') {
	    var res = {};
	    for (var key in value) {
	      res[key] = clone(value[key]);
	    }
	    return res
	  } else {
	    return value
	  }
	}
	
	// the starting route that represents the initial state
	var START = createRoute(null, {
	  path: '/'
	});
	
	function formatMatch (record) {
	  var res = [];
	  while (record) {
	    res.unshift(record);
	    record = record.parent;
	  }
	  return res
	}
	
	function getFullPath (
	  ref,
	  _stringifyQuery
	) {
	  var path = ref.path;
	  var query = ref.query; if ( query === void 0 ) query = {};
	  var hash = ref.hash; if ( hash === void 0 ) hash = '';
	
	  var stringify = _stringifyQuery || stringifyQuery;
	  return (path || '/') + stringify(query) + hash
	}
	
	function isSameRoute (a, b) {
	  if (b === START) {
	    return a === b
	  } else if (!b) {
	    return false
	  } else if (a.path && b.path) {
	    return (
	      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
	      a.hash === b.hash &&
	      isObjectEqual(a.query, b.query)
	    )
	  } else if (a.name && b.name) {
	    return (
	      a.name === b.name &&
	      a.hash === b.hash &&
	      isObjectEqual(a.query, b.query) &&
	      isObjectEqual(a.params, b.params)
	    )
	  } else {
	    return false
	  }
	}
	
	function isObjectEqual (a, b) {
	  if ( a === void 0 ) a = {};
	  if ( b === void 0 ) b = {};
	
	  // handle null value #1566
	  if (!a || !b) { return a === b }
	  var aKeys = Object.keys(a);
	  var bKeys = Object.keys(b);
	  if (aKeys.length !== bKeys.length) {
	    return false
	  }
	  return aKeys.every(function (key) {
	    var aVal = a[key];
	    var bVal = b[key];
	    // check nested equality
	    if (typeof aVal === 'object' && typeof bVal === 'object') {
	      return isObjectEqual(aVal, bVal)
	    }
	    return String(aVal) === String(bVal)
	  })
	}
	
	function isIncludedRoute (current, target) {
	  return (
	    current.path.replace(trailingSlashRE, '/').indexOf(
	      target.path.replace(trailingSlashRE, '/')
	    ) === 0 &&
	    (!target.hash || current.hash === target.hash) &&
	    queryIncludes(current.query, target.query)
	  )
	}
	
	function queryIncludes (current, target) {
	  for (var key in target) {
	    if (!(key in current)) {
	      return false
	    }
	  }
	  return true
	}
	
	/*  */
	
	// work around weird flow bug
	var toTypes = [String, Object];
	var eventTypes = [String, Array];
	
	var Link = {
	  name: 'router-link',
	  props: {
	    to: {
	      type: toTypes,
	      required: true
	    },
	    tag: {
	      type: String,
	      default: 'a'
	    },
	    exact: Boolean,
	    append: Boolean,
	    replace: Boolean,
	    activeClass: String,
	    exactActiveClass: String,
	    event: {
	      type: eventTypes,
	      default: 'click'
	    }
	  },
	  render: function render (h) {
	    var this$1 = this;
	
	    var router = this.$router;
	    var current = this.$route;
	    var ref = router.resolve(this.to, current, this.append);
	    var location = ref.location;
	    var route = ref.route;
	    var href = ref.href;
	
	    var classes = {};
	    var globalActiveClass = router.options.linkActiveClass;
	    var globalExactActiveClass = router.options.linkExactActiveClass;
	    // Support global empty active class
	    var activeClassFallback = globalActiveClass == null
	            ? 'router-link-active'
	            : globalActiveClass;
	    var exactActiveClassFallback = globalExactActiveClass == null
	            ? 'router-link-exact-active'
	            : globalExactActiveClass;
	    var activeClass = this.activeClass == null
	            ? activeClassFallback
	            : this.activeClass;
	    var exactActiveClass = this.exactActiveClass == null
	            ? exactActiveClassFallback
	            : this.exactActiveClass;
	    var compareTarget = location.path
	      ? createRoute(null, location, null, router)
	      : route;
	
	    classes[exactActiveClass] = isSameRoute(current, compareTarget);
	    classes[activeClass] = this.exact
	      ? classes[exactActiveClass]
	      : isIncludedRoute(current, compareTarget);
	
	    var handler = function (e) {
	      if (guardEvent(e)) {
	        if (this$1.replace) {
	          router.replace(location);
	        } else {
	          router.push(location);
	        }
	      }
	    };
	
	    var on = { click: guardEvent };
	    if (Array.isArray(this.event)) {
	      this.event.forEach(function (e) { on[e] = handler; });
	    } else {
	      on[this.event] = handler;
	    }
	
	    var data = {
	      class: classes
	    };
	
	    if (this.tag === 'a') {
	      data.on = on;
	      data.attrs = { href: href };
	    } else {
	      // find the first <a> child and apply listener and href
	      var a = findAnchor(this.$slots.default);
	      if (a) {
	        // in case the <a> is a static node
	        a.isStatic = false;
	        var extend = _Vue.util.extend;
	        var aData = a.data = extend({}, a.data);
	        aData.on = on;
	        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
	        aAttrs.href = href;
	      } else {
	        // doesn't have <a> child, apply listener to self
	        data.on = on;
	      }
	    }
	
	    return h(this.tag, data, this.$slots.default)
	  }
	};
	
	function guardEvent (e) {
	  // don't redirect with control keys
	  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
	  // don't redirect when preventDefault called
	  if (e.defaultPrevented) { return }
	  // don't redirect on right click
	  if (e.button !== undefined && e.button !== 0) { return }
	  // don't redirect if `target="_blank"`
	  if (e.currentTarget && e.currentTarget.getAttribute) {
	    var target = e.currentTarget.getAttribute('target');
	    if (/\b_blank\b/i.test(target)) { return }
	  }
	  // this may be a Weex event which doesn't have this method
	  if (e.preventDefault) {
	    e.preventDefault();
	  }
	  return true
	}
	
	function findAnchor (children) {
	  if (children) {
	    var child;
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      if (child.tag === 'a') {
	        return child
	      }
	      if (child.children && (child = findAnchor(child.children))) {
	        return child
	      }
	    }
	  }
	}
	
	var _Vue;
	
	function install (Vue) {
	  if (install.installed && _Vue === Vue) { return }
	  install.installed = true;
	
	  _Vue = Vue;
	
	  var isDef = function (v) { return v !== undefined; };
	
	  var registerInstance = function (vm, callVal) {
	    var i = vm.$options._parentVnode;
	    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
	      i(vm, callVal);
	    }
	  };
	
	  Vue.mixin({
	    beforeCreate: function beforeCreate () {
	      if (isDef(this.$options.router)) {
	        this._routerRoot = this;
	        this._router = this.$options.router;
	        this._router.init(this);
	        Vue.util.defineReactive(this, '_route', this._router.history.current);
	      } else {
	        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
	      }
	      registerInstance(this, this);
	    },
	    destroyed: function destroyed () {
	      registerInstance(this);
	    }
	  });
	
	  Object.defineProperty(Vue.prototype, '$router', {
	    get: function get () { return this._routerRoot._router }
	  });
	
	  Object.defineProperty(Vue.prototype, '$route', {
	    get: function get () { return this._routerRoot._route }
	  });
	
	  Vue.component('router-view', View);
	  Vue.component('router-link', Link);
	
	  var strats = Vue.config.optionMergeStrategies;
	  // use the same hook merging strategy for route hooks
	  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
	}
	
	/*  */
	
	var inBrowser = typeof window !== 'undefined';
	
	/*  */
	
	function resolvePath (
	  relative,
	  base,
	  append
	) {
	  var firstChar = relative.charAt(0);
	  if (firstChar === '/') {
	    return relative
	  }
	
	  if (firstChar === '?' || firstChar === '#') {
	    return base + relative
	  }
	
	  var stack = base.split('/');
	
	  // remove trailing segment if:
	  // - not appending
	  // - appending to trailing slash (last segment is empty)
	  if (!append || !stack[stack.length - 1]) {
	    stack.pop();
	  }
	
	  // resolve relative path
	  var segments = relative.replace(/^\//, '').split('/');
	  for (var i = 0; i < segments.length; i++) {
	    var segment = segments[i];
	    if (segment === '..') {
	      stack.pop();
	    } else if (segment !== '.') {
	      stack.push(segment);
	    }
	  }
	
	  // ensure leading slash
	  if (stack[0] !== '') {
	    stack.unshift('');
	  }
	
	  return stack.join('/')
	}
	
	function parsePath (path) {
	  var hash = '';
	  var query = '';
	
	  var hashIndex = path.indexOf('#');
	  if (hashIndex >= 0) {
	    hash = path.slice(hashIndex);
	    path = path.slice(0, hashIndex);
	  }
	
	  var queryIndex = path.indexOf('?');
	  if (queryIndex >= 0) {
	    query = path.slice(queryIndex + 1);
	    path = path.slice(0, queryIndex);
	  }
	
	  return {
	    path: path,
	    query: query,
	    hash: hash
	  }
	}
	
	function cleanPath (path) {
	  return path.replace(/\/\//g, '/')
	}
	
	var isarray = Array.isArray || function (arr) {
	  return Object.prototype.toString.call(arr) == '[object Array]';
	};
	
	/**
	 * Expose `pathToRegexp`.
	 */
	var pathToRegexp_1 = pathToRegexp;
	var parse_1 = parse;
	var compile_1 = compile;
	var tokensToFunction_1 = tokensToFunction;
	var tokensToRegExp_1 = tokensToRegExp;
	
	/**
	 * The main path matching regexp utility.
	 *
	 * @type {RegExp}
	 */
	var PATH_REGEXP = new RegExp([
	  // Match escaped characters that would otherwise appear in future matches.
	  // This allows the user to escape special characters that won't transform.
	  '(\\\\.)',
	  // Match Express-style parameters and un-named parameters with a prefix
	  // and optional suffixes. Matches appear as:
	  //
	  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
	  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
	  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
	  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
	].join('|'), 'g');
	
	/**
	 * Parse a string for the raw tokens.
	 *
	 * @param  {string}  str
	 * @param  {Object=} options
	 * @return {!Array}
	 */
	function parse (str, options) {
	  var tokens = [];
	  var key = 0;
	  var index = 0;
	  var path = '';
	  var defaultDelimiter = options && options.delimiter || '/';
	  var res;
	
	  while ((res = PATH_REGEXP.exec(str)) != null) {
	    var m = res[0];
	    var escaped = res[1];
	    var offset = res.index;
	    path += str.slice(index, offset);
	    index = offset + m.length;
	
	    // Ignore already escaped sequences.
	    if (escaped) {
	      path += escaped[1];
	      continue
	    }
	
	    var next = str[index];
	    var prefix = res[2];
	    var name = res[3];
	    var capture = res[4];
	    var group = res[5];
	    var modifier = res[6];
	    var asterisk = res[7];
	
	    // Push the current path onto the tokens.
	    if (path) {
	      tokens.push(path);
	      path = '';
	    }
	
	    var partial = prefix != null && next != null && next !== prefix;
	    var repeat = modifier === '+' || modifier === '*';
	    var optional = modifier === '?' || modifier === '*';
	    var delimiter = res[2] || defaultDelimiter;
	    var pattern = capture || group;
	
	    tokens.push({
	      name: name || key++,
	      prefix: prefix || '',
	      delimiter: delimiter,
	      optional: optional,
	      repeat: repeat,
	      partial: partial,
	      asterisk: !!asterisk,
	      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
	    });
	  }
	
	  // Match any characters still remaining.
	  if (index < str.length) {
	    path += str.substr(index);
	  }
	
	  // If the path exists, push it onto the end.
	  if (path) {
	    tokens.push(path);
	  }
	
	  return tokens
	}
	
	/**
	 * Compile a string to a template function for the path.
	 *
	 * @param  {string}             str
	 * @param  {Object=}            options
	 * @return {!function(Object=, Object=)}
	 */
	function compile (str, options) {
	  return tokensToFunction(parse(str, options))
	}
	
	/**
	 * Prettier encoding of URI path segments.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeURIComponentPretty (str) {
	  return encodeURI(str).replace(/[\/?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeAsterisk (str) {
	  return encodeURI(str).replace(/[?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Expose a method for transforming tokens into the path function.
	 */
	function tokensToFunction (tokens) {
	  // Compile all the tokens into regexps.
	  var matches = new Array(tokens.length);
	
	  // Compile all the patterns before compilation.
	  for (var i = 0; i < tokens.length; i++) {
	    if (typeof tokens[i] === 'object') {
	      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
	    }
	  }
	
	  return function (obj, opts) {
	    var path = '';
	    var data = obj || {};
	    var options = opts || {};
	    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;
	
	    for (var i = 0; i < tokens.length; i++) {
	      var token = tokens[i];
	
	      if (typeof token === 'string') {
	        path += token;
	
	        continue
	      }
	
	      var value = data[token.name];
	      var segment;
	
	      if (value == null) {
	        if (token.optional) {
	          // Prepend partial segment prefixes.
	          if (token.partial) {
	            path += token.prefix;
	          }
	
	          continue
	        } else {
	          throw new TypeError('Expected "' + token.name + '" to be defined')
	        }
	      }
	
	      if (isarray(value)) {
	        if (!token.repeat) {
	          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
	        }
	
	        if (value.length === 0) {
	          if (token.optional) {
	            continue
	          } else {
	            throw new TypeError('Expected "' + token.name + '" to not be empty')
	          }
	        }
	
	        for (var j = 0; j < value.length; j++) {
	          segment = encode(value[j]);
	
	          if (!matches[i].test(segment)) {
	            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
	          }
	
	          path += (j === 0 ? token.prefix : token.delimiter) + segment;
	        }
	
	        continue
	      }
	
	      segment = token.asterisk ? encodeAsterisk(value) : encode(value);
	
	      if (!matches[i].test(segment)) {
	        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
	      }
	
	      path += token.prefix + segment;
	    }
	
	    return path
	  }
	}
	
	/**
	 * Escape a regular expression string.
	 *
	 * @param  {string} str
	 * @return {string}
	 */
	function escapeString (str) {
	  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
	}
	
	/**
	 * Escape the capturing group by escaping special characters and meaning.
	 *
	 * @param  {string} group
	 * @return {string}
	 */
	function escapeGroup (group) {
	  return group.replace(/([=!:$\/()])/g, '\\$1')
	}
	
	/**
	 * Attach the keys as a property of the regexp.
	 *
	 * @param  {!RegExp} re
	 * @param  {Array}   keys
	 * @return {!RegExp}
	 */
	function attachKeys (re, keys) {
	  re.keys = keys;
	  return re
	}
	
	/**
	 * Get the flags for a regexp from the options.
	 *
	 * @param  {Object} options
	 * @return {string}
	 */
	function flags (options) {
	  return options.sensitive ? '' : 'i'
	}
	
	/**
	 * Pull out keys from a regexp.
	 *
	 * @param  {!RegExp} path
	 * @param  {!Array}  keys
	 * @return {!RegExp}
	 */
	function regexpToRegexp (path, keys) {
	  // Use a negative lookahead to match only capturing groups.
	  var groups = path.source.match(/\((?!\?)/g);
	
	  if (groups) {
	    for (var i = 0; i < groups.length; i++) {
	      keys.push({
	        name: i,
	        prefix: null,
	        delimiter: null,
	        optional: false,
	        repeat: false,
	        partial: false,
	        asterisk: false,
	        pattern: null
	      });
	    }
	  }
	
	  return attachKeys(path, keys)
	}
	
	/**
	 * Transform an array into a regexp.
	 *
	 * @param  {!Array}  path
	 * @param  {Array}   keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function arrayToRegexp (path, keys, options) {
	  var parts = [];
	
	  for (var i = 0; i < path.length; i++) {
	    parts.push(pathToRegexp(path[i], keys, options).source);
	  }
	
	  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));
	
	  return attachKeys(regexp, keys)
	}
	
	/**
	 * Create a path regexp from string input.
	 *
	 * @param  {string}  path
	 * @param  {!Array}  keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function stringToRegexp (path, keys, options) {
	  return tokensToRegExp(parse(path, options), keys, options)
	}
	
	/**
	 * Expose a function for taking tokens and returning a RegExp.
	 *
	 * @param  {!Array}          tokens
	 * @param  {(Array|Object)=} keys
	 * @param  {Object=}         options
	 * @return {!RegExp}
	 */
	function tokensToRegExp (tokens, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options);
	    keys = [];
	  }
	
	  options = options || {};
	
	  var strict = options.strict;
	  var end = options.end !== false;
	  var route = '';
	
	  // Iterate over the tokens and create our regexp string.
	  for (var i = 0; i < tokens.length; i++) {
	    var token = tokens[i];
	
	    if (typeof token === 'string') {
	      route += escapeString(token);
	    } else {
	      var prefix = escapeString(token.prefix);
	      var capture = '(?:' + token.pattern + ')';
	
	      keys.push(token);
	
	      if (token.repeat) {
	        capture += '(?:' + prefix + capture + ')*';
	      }
	
	      if (token.optional) {
	        if (!token.partial) {
	          capture = '(?:' + prefix + '(' + capture + '))?';
	        } else {
	          capture = prefix + '(' + capture + ')?';
	        }
	      } else {
	        capture = prefix + '(' + capture + ')';
	      }
	
	      route += capture;
	    }
	  }
	
	  var delimiter = escapeString(options.delimiter || '/');
	  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
	
	  // In non-strict mode we allow a slash at the end of match. If the path to
	  // match already ends with a slash, we remove it for consistency. The slash
	  // is valid at the end of a path match, not in the middle. This is important
	  // in non-ending mode, where "/test/" shouldn't match "/test//route".
	  if (!strict) {
	    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
	  }
	
	  if (end) {
	    route += '$';
	  } else {
	    // In non-ending mode, we need the capturing groups to match as much as
	    // possible by using a positive lookahead to the end or next path segment.
	    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
	  }
	
	  return attachKeys(new RegExp('^' + route, flags(options)), keys)
	}
	
	/**
	 * Normalize the given path string, returning a regular expression.
	 *
	 * An empty array can be passed in for the keys, which will hold the
	 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
	 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
	 *
	 * @param  {(string|RegExp|Array)} path
	 * @param  {(Array|Object)=}       keys
	 * @param  {Object=}               options
	 * @return {!RegExp}
	 */
	function pathToRegexp (path, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options);
	    keys = [];
	  }
	
	  options = options || {};
	
	  if (path instanceof RegExp) {
	    return regexpToRegexp(path, /** @type {!Array} */ (keys))
	  }
	
	  if (isarray(path)) {
	    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
	  }
	
	  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
	}
	
	pathToRegexp_1.parse = parse_1;
	pathToRegexp_1.compile = compile_1;
	pathToRegexp_1.tokensToFunction = tokensToFunction_1;
	pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;
	
	/*  */
	
	// $flow-disable-line
	var regexpCompileCache = Object.create(null);
	
	function fillParams (
	  path,
	  params,
	  routeMsg
	) {
	  try {
	    var filler =
	      regexpCompileCache[path] ||
	      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
	    return filler(params || {}, { pretty: true })
	  } catch (e) {
	    if (false) {
	      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
	    }
	    return ''
	  }
	}
	
	/*  */
	
	function createRouteMap (
	  routes,
	  oldPathList,
	  oldPathMap,
	  oldNameMap
	) {
	  // the path list is used to control path matching priority
	  var pathList = oldPathList || [];
	  // $flow-disable-line
	  var pathMap = oldPathMap || Object.create(null);
	  // $flow-disable-line
	  var nameMap = oldNameMap || Object.create(null);
	
	  routes.forEach(function (route) {
	    addRouteRecord(pathList, pathMap, nameMap, route);
	  });
	
	  // ensure wildcard routes are always at the end
	  for (var i = 0, l = pathList.length; i < l; i++) {
	    if (pathList[i] === '*') {
	      pathList.push(pathList.splice(i, 1)[0]);
	      l--;
	      i--;
	    }
	  }
	
	  return {
	    pathList: pathList,
	    pathMap: pathMap,
	    nameMap: nameMap
	  }
	}
	
	function addRouteRecord (
	  pathList,
	  pathMap,
	  nameMap,
	  route,
	  parent,
	  matchAs
	) {
	  var path = route.path;
	  var name = route.name;
	  if (false) {
	    assert(path != null, "\"path\" is required in a route configuration.");
	    assert(
	      typeof route.component !== 'string',
	      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
	      "string id. Use an actual component instead."
	    );
	  }
	
	  var pathToRegexpOptions = route.pathToRegexpOptions || {};
	  var normalizedPath = normalizePath(
	    path,
	    parent,
	    pathToRegexpOptions.strict
	  );
	
	  if (typeof route.caseSensitive === 'boolean') {
	    pathToRegexpOptions.sensitive = route.caseSensitive;
	  }
	
	  var record = {
	    path: normalizedPath,
	    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
	    components: route.components || { default: route.component },
	    instances: {},
	    name: name,
	    parent: parent,
	    matchAs: matchAs,
	    redirect: route.redirect,
	    beforeEnter: route.beforeEnter,
	    meta: route.meta || {},
	    props: route.props == null
	      ? {}
	      : route.components
	        ? route.props
	        : { default: route.props }
	  };
	
	  if (route.children) {
	    // Warn if route is named, does not redirect and has a default child route.
	    // If users navigate to this route by name, the default child will
	    // not be rendered (GH Issue #629)
	    if (false) {
	      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
	        warn(
	          false,
	          "Named Route '" + (route.name) + "' has a default child route. " +
	          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
	          "the default child route will not be rendered. Remove the name from " +
	          "this route and use the name of the default child route for named " +
	          "links instead."
	        );
	      }
	    }
	    route.children.forEach(function (child) {
	      var childMatchAs = matchAs
	        ? cleanPath((matchAs + "/" + (child.path)))
	        : undefined;
	      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
	    });
	  }
	
	  if (route.alias !== undefined) {
	    var aliases = Array.isArray(route.alias)
	      ? route.alias
	      : [route.alias];
	
	    aliases.forEach(function (alias) {
	      var aliasRoute = {
	        path: alias,
	        children: route.children
	      };
	      addRouteRecord(
	        pathList,
	        pathMap,
	        nameMap,
	        aliasRoute,
	        parent,
	        record.path || '/' // matchAs
	      );
	    });
	  }
	
	  if (!pathMap[record.path]) {
	    pathList.push(record.path);
	    pathMap[record.path] = record;
	  }
	
	  if (name) {
	    if (!nameMap[name]) {
	      nameMap[name] = record;
	    } else if (false) {
	      warn(
	        false,
	        "Duplicate named routes definition: " +
	        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
	      );
	    }
	  }
	}
	
	function compileRouteRegex (path, pathToRegexpOptions) {
	  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
	  if (false) {
	    var keys = Object.create(null);
	    regex.keys.forEach(function (key) {
	      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
	      keys[key.name] = true;
	    });
	  }
	  return regex
	}
	
	function normalizePath (path, parent, strict) {
	  if (!strict) { path = path.replace(/\/$/, ''); }
	  if (path[0] === '/') { return path }
	  if (parent == null) { return path }
	  return cleanPath(((parent.path) + "/" + path))
	}
	
	/*  */
	
	
	function normalizeLocation (
	  raw,
	  current,
	  append,
	  router
	) {
	  var next = typeof raw === 'string' ? { path: raw } : raw;
	  // named target
	  if (next.name || next._normalized) {
	    return next
	  }
	
	  // relative params
	  if (!next.path && next.params && current) {
	    next = assign({}, next);
	    next._normalized = true;
	    var params = assign(assign({}, current.params), next.params);
	    if (current.name) {
	      next.name = current.name;
	      next.params = params;
	    } else if (current.matched.length) {
	      var rawPath = current.matched[current.matched.length - 1].path;
	      next.path = fillParams(rawPath, params, ("path " + (current.path)));
	    } else if (false) {
	      warn(false, "relative params navigation requires a current route.");
	    }
	    return next
	  }
	
	  var parsedPath = parsePath(next.path || '');
	  var basePath = (current && current.path) || '/';
	  var path = parsedPath.path
	    ? resolvePath(parsedPath.path, basePath, append || next.append)
	    : basePath;
	
	  var query = resolveQuery(
	    parsedPath.query,
	    next.query,
	    router && router.options.parseQuery
	  );
	
	  var hash = next.hash || parsedPath.hash;
	  if (hash && hash.charAt(0) !== '#') {
	    hash = "#" + hash;
	  }
	
	  return {
	    _normalized: true,
	    path: path,
	    query: query,
	    hash: hash
	  }
	}
	
	function assign (a, b) {
	  for (var key in b) {
	    a[key] = b[key];
	  }
	  return a
	}
	
	/*  */
	
	
	function createMatcher (
	  routes,
	  router
	) {
	  var ref = createRouteMap(routes);
	  var pathList = ref.pathList;
	  var pathMap = ref.pathMap;
	  var nameMap = ref.nameMap;
	
	  function addRoutes (routes) {
	    createRouteMap(routes, pathList, pathMap, nameMap);
	  }
	
	  function match (
	    raw,
	    currentRoute,
	    redirectedFrom
	  ) {
	    var location = normalizeLocation(raw, currentRoute, false, router);
	    var name = location.name;
	
	    if (name) {
	      var record = nameMap[name];
	      if (false) {
	        warn(record, ("Route with name '" + name + "' does not exist"));
	      }
	      if (!record) { return _createRoute(null, location) }
	      var paramNames = record.regex.keys
	        .filter(function (key) { return !key.optional; })
	        .map(function (key) { return key.name; });
	
	      if (typeof location.params !== 'object') {
	        location.params = {};
	      }
	
	      if (currentRoute && typeof currentRoute.params === 'object') {
	        for (var key in currentRoute.params) {
	          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
	            location.params[key] = currentRoute.params[key];
	          }
	        }
	      }
	
	      if (record) {
	        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
	        return _createRoute(record, location, redirectedFrom)
	      }
	    } else if (location.path) {
	      location.params = {};
	      for (var i = 0; i < pathList.length; i++) {
	        var path = pathList[i];
	        var record$1 = pathMap[path];
	        if (matchRoute(record$1.regex, location.path, location.params)) {
	          return _createRoute(record$1, location, redirectedFrom)
	        }
	      }
	    }
	    // no match
	    return _createRoute(null, location)
	  }
	
	  function redirect (
	    record,
	    location
	  ) {
	    var originalRedirect = record.redirect;
	    var redirect = typeof originalRedirect === 'function'
	        ? originalRedirect(createRoute(record, location, null, router))
	        : originalRedirect;
	
	    if (typeof redirect === 'string') {
	      redirect = { path: redirect };
	    }
	
	    if (!redirect || typeof redirect !== 'object') {
	      if (false) {
	        warn(
	          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
	        );
	      }
	      return _createRoute(null, location)
	    }
	
	    var re = redirect;
	    var name = re.name;
	    var path = re.path;
	    var query = location.query;
	    var hash = location.hash;
	    var params = location.params;
	    query = re.hasOwnProperty('query') ? re.query : query;
	    hash = re.hasOwnProperty('hash') ? re.hash : hash;
	    params = re.hasOwnProperty('params') ? re.params : params;
	
	    if (name) {
	      // resolved named direct
	      var targetRecord = nameMap[name];
	      if (false) {
	        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
	      }
	      return match({
	        _normalized: true,
	        name: name,
	        query: query,
	        hash: hash,
	        params: params
	      }, undefined, location)
	    } else if (path) {
	      // 1. resolve relative redirect
	      var rawPath = resolveRecordPath(path, record);
	      // 2. resolve params
	      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
	      // 3. rematch with existing query and hash
	      return match({
	        _normalized: true,
	        path: resolvedPath,
	        query: query,
	        hash: hash
	      }, undefined, location)
	    } else {
	      if (false) {
	        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
	      }
	      return _createRoute(null, location)
	    }
	  }
	
	  function alias (
	    record,
	    location,
	    matchAs
	  ) {
	    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
	    var aliasedMatch = match({
	      _normalized: true,
	      path: aliasedPath
	    });
	    if (aliasedMatch) {
	      var matched = aliasedMatch.matched;
	      var aliasedRecord = matched[matched.length - 1];
	      location.params = aliasedMatch.params;
	      return _createRoute(aliasedRecord, location)
	    }
	    return _createRoute(null, location)
	  }
	
	  function _createRoute (
	    record,
	    location,
	    redirectedFrom
	  ) {
	    if (record && record.redirect) {
	      return redirect(record, redirectedFrom || location)
	    }
	    if (record && record.matchAs) {
	      return alias(record, location, record.matchAs)
	    }
	    return createRoute(record, location, redirectedFrom, router)
	  }
	
	  return {
	    match: match,
	    addRoutes: addRoutes
	  }
	}
	
	function matchRoute (
	  regex,
	  path,
	  params
	) {
	  var m = path.match(regex);
	
	  if (!m) {
	    return false
	  } else if (!params) {
	    return true
	  }
	
	  for (var i = 1, len = m.length; i < len; ++i) {
	    var key = regex.keys[i - 1];
	    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
	    if (key) {
	      params[key.name] = val;
	    }
	  }
	
	  return true
	}
	
	function resolveRecordPath (path, record) {
	  return resolvePath(path, record.parent ? record.parent.path : '/', true)
	}
	
	/*  */
	
	
	var positionStore = Object.create(null);
	
	function setupScroll () {
	  // Fix for #1585 for Firefox
	  window.history.replaceState({ key: getStateKey() }, '');
	  window.addEventListener('popstate', function (e) {
	    saveScrollPosition();
	    if (e.state && e.state.key) {
	      setStateKey(e.state.key);
	    }
	  });
	}
	
	function handleScroll (
	  router,
	  to,
	  from,
	  isPop
	) {
	  if (!router.app) {
	    return
	  }
	
	  var behavior = router.options.scrollBehavior;
	  if (!behavior) {
	    return
	  }
	
	  if (false) {
	    assert(typeof behavior === 'function', "scrollBehavior must be a function");
	  }
	
	  // wait until re-render finishes before scrolling
	  router.app.$nextTick(function () {
	    var position = getScrollPosition();
	    var shouldScroll = behavior(to, from, isPop ? position : null);
	
	    if (!shouldScroll) {
	      return
	    }
	
	    if (typeof shouldScroll.then === 'function') {
	      shouldScroll.then(function (shouldScroll) {
	        scrollToPosition((shouldScroll), position);
	      }).catch(function (err) {
	        if (false) {
	          assert(false, err.toString());
	        }
	      });
	    } else {
	      scrollToPosition(shouldScroll, position);
	    }
	  });
	}
	
	function saveScrollPosition () {
	  var key = getStateKey();
	  if (key) {
	    positionStore[key] = {
	      x: window.pageXOffset,
	      y: window.pageYOffset
	    };
	  }
	}
	
	function getScrollPosition () {
	  var key = getStateKey();
	  if (key) {
	    return positionStore[key]
	  }
	}
	
	function getElementPosition (el, offset) {
	  var docEl = document.documentElement;
	  var docRect = docEl.getBoundingClientRect();
	  var elRect = el.getBoundingClientRect();
	  return {
	    x: elRect.left - docRect.left - offset.x,
	    y: elRect.top - docRect.top - offset.y
	  }
	}
	
	function isValidPosition (obj) {
	  return isNumber(obj.x) || isNumber(obj.y)
	}
	
	function normalizePosition (obj) {
	  return {
	    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
	    y: isNumber(obj.y) ? obj.y : window.pageYOffset
	  }
	}
	
	function normalizeOffset (obj) {
	  return {
	    x: isNumber(obj.x) ? obj.x : 0,
	    y: isNumber(obj.y) ? obj.y : 0
	  }
	}
	
	function isNumber (v) {
	  return typeof v === 'number'
	}
	
	function scrollToPosition (shouldScroll, position) {
	  var isObject = typeof shouldScroll === 'object';
	  if (isObject && typeof shouldScroll.selector === 'string') {
	    var el = document.querySelector(shouldScroll.selector);
	    if (el) {
	      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
	      offset = normalizeOffset(offset);
	      position = getElementPosition(el, offset);
	    } else if (isValidPosition(shouldScroll)) {
	      position = normalizePosition(shouldScroll);
	    }
	  } else if (isObject && isValidPosition(shouldScroll)) {
	    position = normalizePosition(shouldScroll);
	  }
	
	  if (position) {
	    window.scrollTo(position.x, position.y);
	  }
	}
	
	/*  */
	
	var supportsPushState = inBrowser && (function () {
	  var ua = window.navigator.userAgent;
	
	  if (
	    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
	    ua.indexOf('Mobile Safari') !== -1 &&
	    ua.indexOf('Chrome') === -1 &&
	    ua.indexOf('Windows Phone') === -1
	  ) {
	    return false
	  }
	
	  return window.history && 'pushState' in window.history
	})();
	
	// use User Timing api (if present) for more accurate key precision
	var Time = inBrowser && window.performance && window.performance.now
	  ? window.performance
	  : Date;
	
	var _key = genKey();
	
	function genKey () {
	  return Time.now().toFixed(3)
	}
	
	function getStateKey () {
	  return _key
	}
	
	function setStateKey (key) {
	  _key = key;
	}
	
	function pushState (url, replace) {
	  saveScrollPosition();
	  // try...catch the pushState call to get around Safari
	  // DOM Exception 18 where it limits to 100 pushState calls
	  var history = window.history;
	  try {
	    if (replace) {
	      history.replaceState({ key: _key }, '', url);
	    } else {
	      _key = genKey();
	      history.pushState({ key: _key }, '', url);
	    }
	  } catch (e) {
	    window.location[replace ? 'replace' : 'assign'](url);
	  }
	}
	
	function replaceState (url) {
	  pushState(url, true);
	}
	
	/*  */
	
	function runQueue (queue, fn, cb) {
	  var step = function (index) {
	    if (index >= queue.length) {
	      cb();
	    } else {
	      if (queue[index]) {
	        fn(queue[index], function () {
	          step(index + 1);
	        });
	      } else {
	        step(index + 1);
	      }
	    }
	  };
	  step(0);
	}
	
	/*  */
	
	function resolveAsyncComponents (matched) {
	  return function (to, from, next) {
	    var hasAsync = false;
	    var pending = 0;
	    var error = null;
	
	    flatMapComponents(matched, function (def, _, match, key) {
	      // if it's a function and doesn't have cid attached,
	      // assume it's an async component resolve function.
	      // we are not using Vue's default async resolving mechanism because
	      // we want to halt the navigation until the incoming component has been
	      // resolved.
	      if (typeof def === 'function' && def.cid === undefined) {
	        hasAsync = true;
	        pending++;
	
	        var resolve = once(function (resolvedDef) {
	          if (isESModule(resolvedDef)) {
	            resolvedDef = resolvedDef.default;
	          }
	          // save resolved on async factory in case it's used elsewhere
	          def.resolved = typeof resolvedDef === 'function'
	            ? resolvedDef
	            : _Vue.extend(resolvedDef);
	          match.components[key] = resolvedDef;
	          pending--;
	          if (pending <= 0) {
	            next();
	          }
	        });
	
	        var reject = once(function (reason) {
	          var msg = "Failed to resolve async component " + key + ": " + reason;
	          ("production") !== 'production' && warn(false, msg);
	          if (!error) {
	            error = isError(reason)
	              ? reason
	              : new Error(msg);
	            next(error);
	          }
	        });
	
	        var res;
	        try {
	          res = def(resolve, reject);
	        } catch (e) {
	          reject(e);
	        }
	        if (res) {
	          if (typeof res.then === 'function') {
	            res.then(resolve, reject);
	          } else {
	            // new syntax in Vue 2.3
	            var comp = res.component;
	            if (comp && typeof comp.then === 'function') {
	              comp.then(resolve, reject);
	            }
	          }
	        }
	      }
	    });
	
	    if (!hasAsync) { next(); }
	  }
	}
	
	function flatMapComponents (
	  matched,
	  fn
	) {
	  return flatten(matched.map(function (m) {
	    return Object.keys(m.components).map(function (key) { return fn(
	      m.components[key],
	      m.instances[key],
	      m, key
	    ); })
	  }))
	}
	
	function flatten (arr) {
	  return Array.prototype.concat.apply([], arr)
	}
	
	var hasSymbol =
	  typeof Symbol === 'function' &&
	  typeof Symbol.toStringTag === 'symbol';
	
	function isESModule (obj) {
	  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
	}
	
	// in Webpack 2, require.ensure now also returns a Promise
	// so the resolve/reject functions may get called an extra time
	// if the user uses an arrow function shorthand that happens to
	// return that Promise.
	function once (fn) {
	  var called = false;
	  return function () {
	    var args = [], len = arguments.length;
	    while ( len-- ) args[ len ] = arguments[ len ];
	
	    if (called) { return }
	    called = true;
	    return fn.apply(this, args)
	  }
	}
	
	/*  */
	
	var History = function History (router, base) {
	  this.router = router;
	  this.base = normalizeBase(base);
	  // start with a route object that stands for "nowhere"
	  this.current = START;
	  this.pending = null;
	  this.ready = false;
	  this.readyCbs = [];
	  this.readyErrorCbs = [];
	  this.errorCbs = [];
	};
	
	History.prototype.listen = function listen (cb) {
	  this.cb = cb;
	};
	
	History.prototype.onReady = function onReady (cb, errorCb) {
	  if (this.ready) {
	    cb();
	  } else {
	    this.readyCbs.push(cb);
	    if (errorCb) {
	      this.readyErrorCbs.push(errorCb);
	    }
	  }
	};
	
	History.prototype.onError = function onError (errorCb) {
	  this.errorCbs.push(errorCb);
	};
	
	History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
	    var this$1 = this;
	
	  var route = this.router.match(location, this.current);
	  this.confirmTransition(route, function () {
	    this$1.updateRoute(route);
	    onComplete && onComplete(route);
	    this$1.ensureURL();
	
	    // fire ready cbs once
	    if (!this$1.ready) {
	      this$1.ready = true;
	      this$1.readyCbs.forEach(function (cb) { cb(route); });
	    }
	  }, function (err) {
	    if (onAbort) {
	      onAbort(err);
	    }
	    if (err && !this$1.ready) {
	      this$1.ready = true;
	      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
	    }
	  });
	};
	
	History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
	    var this$1 = this;
	
	  var current = this.current;
	  var abort = function (err) {
	    if (isError(err)) {
	      if (this$1.errorCbs.length) {
	        this$1.errorCbs.forEach(function (cb) { cb(err); });
	      } else {
	        warn(false, 'uncaught error during route navigation:');
	        console.error(err);
	      }
	    }
	    onAbort && onAbort(err);
	  };
	  if (
	    isSameRoute(route, current) &&
	    // in the case the route map has been dynamically appended to
	    route.matched.length === current.matched.length
	  ) {
	    this.ensureURL();
	    return abort()
	  }
	
	  var ref = resolveQueue(this.current.matched, route.matched);
	    var updated = ref.updated;
	    var deactivated = ref.deactivated;
	    var activated = ref.activated;
	
	  var queue = [].concat(
	    // in-component leave guards
	    extractLeaveGuards(deactivated),
	    // global before hooks
	    this.router.beforeHooks,
	    // in-component update hooks
	    extractUpdateHooks(updated),
	    // in-config enter guards
	    activated.map(function (m) { return m.beforeEnter; }),
	    // async components
	    resolveAsyncComponents(activated)
	  );
	
	  this.pending = route;
	  var iterator = function (hook, next) {
	    if (this$1.pending !== route) {
	      return abort()
	    }
	    try {
	      hook(route, current, function (to) {
	        if (to === false || isError(to)) {
	          // next(false) -> abort navigation, ensure current URL
	          this$1.ensureURL(true);
	          abort(to);
	        } else if (
	          typeof to === 'string' ||
	          (typeof to === 'object' && (
	            typeof to.path === 'string' ||
	            typeof to.name === 'string'
	          ))
	        ) {
	          // next('/') or next({ path: '/' }) -> redirect
	          abort();
	          if (typeof to === 'object' && to.replace) {
	            this$1.replace(to);
	          } else {
	            this$1.push(to);
	          }
	        } else {
	          // confirm transition and pass on the value
	          next(to);
	        }
	      });
	    } catch (e) {
	      abort(e);
	    }
	  };
	
	  runQueue(queue, iterator, function () {
	    var postEnterCbs = [];
	    var isValid = function () { return this$1.current === route; };
	    // wait until async components are resolved before
	    // extracting in-component enter guards
	    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
	    var queue = enterGuards.concat(this$1.router.resolveHooks);
	    runQueue(queue, iterator, function () {
	      if (this$1.pending !== route) {
	        return abort()
	      }
	      this$1.pending = null;
	      onComplete(route);
	      if (this$1.router.app) {
	        this$1.router.app.$nextTick(function () {
	          postEnterCbs.forEach(function (cb) { cb(); });
	        });
	      }
	    });
	  });
	};
	
	History.prototype.updateRoute = function updateRoute (route) {
	  var prev = this.current;
	  this.current = route;
	  this.cb && this.cb(route);
	  this.router.afterHooks.forEach(function (hook) {
	    hook && hook(route, prev);
	  });
	};
	
	function normalizeBase (base) {
	  if (!base) {
	    if (inBrowser) {
	      // respect <base> tag
	      var baseEl = document.querySelector('base');
	      base = (baseEl && baseEl.getAttribute('href')) || '/';
	      // strip full URL origin
	      base = base.replace(/^https?:\/\/[^\/]+/, '');
	    } else {
	      base = '/';
	    }
	  }
	  // make sure there's the starting slash
	  if (base.charAt(0) !== '/') {
	    base = '/' + base;
	  }
	  // remove trailing slash
	  return base.replace(/\/$/, '')
	}
	
	function resolveQueue (
	  current,
	  next
	) {
	  var i;
	  var max = Math.max(current.length, next.length);
	  for (i = 0; i < max; i++) {
	    if (current[i] !== next[i]) {
	      break
	    }
	  }
	  return {
	    updated: next.slice(0, i),
	    activated: next.slice(i),
	    deactivated: current.slice(i)
	  }
	}
	
	function extractGuards (
	  records,
	  name,
	  bind,
	  reverse
	) {
	  var guards = flatMapComponents(records, function (def, instance, match, key) {
	    var guard = extractGuard(def, name);
	    if (guard) {
	      return Array.isArray(guard)
	        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
	        : bind(guard, instance, match, key)
	    }
	  });
	  return flatten(reverse ? guards.reverse() : guards)
	}
	
	function extractGuard (
	  def,
	  key
	) {
	  if (typeof def !== 'function') {
	    // extend now so that global mixins are applied.
	    def = _Vue.extend(def);
	  }
	  return def.options[key]
	}
	
	function extractLeaveGuards (deactivated) {
	  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
	}
	
	function extractUpdateHooks (updated) {
	  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
	}
	
	function bindGuard (guard, instance) {
	  if (instance) {
	    return function boundRouteGuard () {
	      return guard.apply(instance, arguments)
	    }
	  }
	}
	
	function extractEnterGuards (
	  activated,
	  cbs,
	  isValid
	) {
	  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
	    return bindEnterGuard(guard, match, key, cbs, isValid)
	  })
	}
	
	function bindEnterGuard (
	  guard,
	  match,
	  key,
	  cbs,
	  isValid
	) {
	  return function routeEnterGuard (to, from, next) {
	    return guard(to, from, function (cb) {
	      next(cb);
	      if (typeof cb === 'function') {
	        cbs.push(function () {
	          // #750
	          // if a router-view is wrapped with an out-in transition,
	          // the instance may not have been registered at this time.
	          // we will need to poll for registration until current route
	          // is no longer valid.
	          poll(cb, match.instances, key, isValid);
	        });
	      }
	    })
	  }
	}
	
	function poll (
	  cb, // somehow flow cannot infer this is a function
	  instances,
	  key,
	  isValid
	) {
	  if (instances[key]) {
	    cb(instances[key]);
	  } else if (isValid()) {
	    setTimeout(function () {
	      poll(cb, instances, key, isValid);
	    }, 16);
	  }
	}
	
	/*  */
	
	
	var HTML5History = (function (History$$1) {
	  function HTML5History (router, base) {
	    var this$1 = this;
	
	    History$$1.call(this, router, base);
	
	    var expectScroll = router.options.scrollBehavior;
	
	    if (expectScroll) {
	      setupScroll();
	    }
	
	    var initLocation = getLocation(this.base);
	    window.addEventListener('popstate', function (e) {
	      var current = this$1.current;
	
	      // Avoiding first `popstate` event dispatched in some browsers but first
	      // history route not updated since async guard at the same time.
	      var location = getLocation(this$1.base);
	      if (this$1.current === START && location === initLocation) {
	        return
	      }
	
	      this$1.transitionTo(location, function (route) {
	        if (expectScroll) {
	          handleScroll(router, route, current, true);
	        }
	      });
	    });
	  }
	
	  if ( History$$1 ) HTML5History.__proto__ = History$$1;
	  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
	  HTML5History.prototype.constructor = HTML5History;
	
	  HTML5History.prototype.go = function go (n) {
	    window.history.go(n);
	  };
	
	  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
	    var this$1 = this;
	
	    var ref = this;
	    var fromRoute = ref.current;
	    this.transitionTo(location, function (route) {
	      pushState(cleanPath(this$1.base + route.fullPath));
	      handleScroll(this$1.router, route, fromRoute, false);
	      onComplete && onComplete(route);
	    }, onAbort);
	  };
	
	  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
	    var this$1 = this;
	
	    var ref = this;
	    var fromRoute = ref.current;
	    this.transitionTo(location, function (route) {
	      replaceState(cleanPath(this$1.base + route.fullPath));
	      handleScroll(this$1.router, route, fromRoute, false);
	      onComplete && onComplete(route);
	    }, onAbort);
	  };
	
	  HTML5History.prototype.ensureURL = function ensureURL (push) {
	    if (getLocation(this.base) !== this.current.fullPath) {
	      var current = cleanPath(this.base + this.current.fullPath);
	      push ? pushState(current) : replaceState(current);
	    }
	  };
	
	  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
	    return getLocation(this.base)
	  };
	
	  return HTML5History;
	}(History));
	
	function getLocation (base) {
	  var path = window.location.pathname;
	  if (base && path.indexOf(base) === 0) {
	    path = path.slice(base.length);
	  }
	  return (path || '/') + window.location.search + window.location.hash
	}
	
	/*  */
	
	
	var HashHistory = (function (History$$1) {
	  function HashHistory (router, base, fallback) {
	    History$$1.call(this, router, base);
	    // check history fallback deeplinking
	    if (fallback && checkFallback(this.base)) {
	      return
	    }
	    ensureSlash();
	  }
	
	  if ( History$$1 ) HashHistory.__proto__ = History$$1;
	  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
	  HashHistory.prototype.constructor = HashHistory;
	
	  // this is delayed until the app mounts
	  // to avoid the hashchange listener being fired too early
	  HashHistory.prototype.setupListeners = function setupListeners () {
	    var this$1 = this;
	
	    var router = this.router;
	    var expectScroll = router.options.scrollBehavior;
	    var supportsScroll = supportsPushState && expectScroll;
	
	    if (supportsScroll) {
	      setupScroll();
	    }
	
	    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
	      var current = this$1.current;
	      if (!ensureSlash()) {
	        return
	      }
	      this$1.transitionTo(getHash(), function (route) {
	        if (supportsScroll) {
	          handleScroll(this$1.router, route, current, true);
	        }
	        if (!supportsPushState) {
	          replaceHash(route.fullPath);
	        }
	      });
	    });
	  };
	
	  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
	    var this$1 = this;
	
	    var ref = this;
	    var fromRoute = ref.current;
	    this.transitionTo(location, function (route) {
	      pushHash(route.fullPath);
	      handleScroll(this$1.router, route, fromRoute, false);
	      onComplete && onComplete(route);
	    }, onAbort);
	  };
	
	  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
	    var this$1 = this;
	
	    var ref = this;
	    var fromRoute = ref.current;
	    this.transitionTo(location, function (route) {
	      replaceHash(route.fullPath);
	      handleScroll(this$1.router, route, fromRoute, false);
	      onComplete && onComplete(route);
	    }, onAbort);
	  };
	
	  HashHistory.prototype.go = function go (n) {
	    window.history.go(n);
	  };
	
	  HashHistory.prototype.ensureURL = function ensureURL (push) {
	    var current = this.current.fullPath;
	    if (getHash() !== current) {
	      push ? pushHash(current) : replaceHash(current);
	    }
	  };
	
	  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
	    return getHash()
	  };
	
	  return HashHistory;
	}(History));
	
	function checkFallback (base) {
	  var location = getLocation(base);
	  if (!/^\/#/.test(location)) {
	    window.location.replace(
	      cleanPath(base + '/#' + location)
	    );
	    return true
	  }
	}
	
	function ensureSlash () {
	  var path = getHash();
	  if (path.charAt(0) === '/') {
	    return true
	  }
	  replaceHash('/' + path);
	  return false
	}
	
	function getHash () {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  var href = window.location.href;
	  var index = href.indexOf('#');
	  return index === -1 ? '' : href.slice(index + 1)
	}
	
	function getUrl (path) {
	  var href = window.location.href;
	  var i = href.indexOf('#');
	  var base = i >= 0 ? href.slice(0, i) : href;
	  return (base + "#" + path)
	}
	
	function pushHash (path) {
	  if (supportsPushState) {
	    pushState(getUrl(path));
	  } else {
	    window.location.hash = path;
	  }
	}
	
	function replaceHash (path) {
	  if (supportsPushState) {
	    replaceState(getUrl(path));
	  } else {
	    window.location.replace(getUrl(path));
	  }
	}
	
	/*  */
	
	
	var AbstractHistory = (function (History$$1) {
	  function AbstractHistory (router, base) {
	    History$$1.call(this, router, base);
	    this.stack = [];
	    this.index = -1;
	  }
	
	  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
	  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
	  AbstractHistory.prototype.constructor = AbstractHistory;
	
	  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
	    var this$1 = this;
	
	    this.transitionTo(location, function (route) {
	      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
	      this$1.index++;
	      onComplete && onComplete(route);
	    }, onAbort);
	  };
	
	  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
	    var this$1 = this;
	
	    this.transitionTo(location, function (route) {
	      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
	      onComplete && onComplete(route);
	    }, onAbort);
	  };
	
	  AbstractHistory.prototype.go = function go (n) {
	    var this$1 = this;
	
	    var targetIndex = this.index + n;
	    if (targetIndex < 0 || targetIndex >= this.stack.length) {
	      return
	    }
	    var route = this.stack[targetIndex];
	    this.confirmTransition(route, function () {
	      this$1.index = targetIndex;
	      this$1.updateRoute(route);
	    });
	  };
	
	  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
	    var current = this.stack[this.stack.length - 1];
	    return current ? current.fullPath : '/'
	  };
	
	  AbstractHistory.prototype.ensureURL = function ensureURL () {
	    // noop
	  };
	
	  return AbstractHistory;
	}(History));
	
	/*  */
	
	var VueRouter = function VueRouter (options) {
	  if ( options === void 0 ) options = {};
	
	  this.app = null;
	  this.apps = [];
	  this.options = options;
	  this.beforeHooks = [];
	  this.resolveHooks = [];
	  this.afterHooks = [];
	  this.matcher = createMatcher(options.routes || [], this);
	
	  var mode = options.mode || 'hash';
	  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
	  if (this.fallback) {
	    mode = 'hash';
	  }
	  if (!inBrowser) {
	    mode = 'abstract';
	  }
	  this.mode = mode;
	
	  switch (mode) {
	    case 'history':
	      this.history = new HTML5History(this, options.base);
	      break
	    case 'hash':
	      this.history = new HashHistory(this, options.base, this.fallback);
	      break
	    case 'abstract':
	      this.history = new AbstractHistory(this, options.base);
	      break
	    default:
	      if (false) {
	        assert(false, ("invalid mode: " + mode));
	      }
	  }
	};
	
	var prototypeAccessors = { currentRoute: { configurable: true } };
	
	VueRouter.prototype.match = function match (
	  raw,
	  current,
	  redirectedFrom
	) {
	  return this.matcher.match(raw, current, redirectedFrom)
	};
	
	prototypeAccessors.currentRoute.get = function () {
	  return this.history && this.history.current
	};
	
	VueRouter.prototype.init = function init (app /* Vue component instance */) {
	    var this$1 = this;
	
	  ("production") !== 'production' && assert(
	    install.installed,
	    "not installed. Make sure to call `Vue.use(VueRouter)` " +
	    "before creating root instance."
	  );
	
	  this.apps.push(app);
	
	  // main app already initialized.
	  if (this.app) {
	    return
	  }
	
	  this.app = app;
	
	  var history = this.history;
	
	  if (history instanceof HTML5History) {
	    history.transitionTo(history.getCurrentLocation());
	  } else if (history instanceof HashHistory) {
	    var setupHashListener = function () {
	      history.setupListeners();
	    };
	    history.transitionTo(
	      history.getCurrentLocation(),
	      setupHashListener,
	      setupHashListener
	    );
	  }
	
	  history.listen(function (route) {
	    this$1.apps.forEach(function (app) {
	      app._route = route;
	    });
	  });
	};
	
	VueRouter.prototype.beforeEach = function beforeEach (fn) {
	  return registerHook(this.beforeHooks, fn)
	};
	
	VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
	  return registerHook(this.resolveHooks, fn)
	};
	
	VueRouter.prototype.afterEach = function afterEach (fn) {
	  return registerHook(this.afterHooks, fn)
	};
	
	VueRouter.prototype.onReady = function onReady (cb, errorCb) {
	  this.history.onReady(cb, errorCb);
	};
	
	VueRouter.prototype.onError = function onError (errorCb) {
	  this.history.onError(errorCb);
	};
	
	VueRouter.prototype.push = function push (location, onComplete, onAbort) {
	  this.history.push(location, onComplete, onAbort);
	};
	
	VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
	  this.history.replace(location, onComplete, onAbort);
	};
	
	VueRouter.prototype.go = function go (n) {
	  this.history.go(n);
	};
	
	VueRouter.prototype.back = function back () {
	  this.go(-1);
	};
	
	VueRouter.prototype.forward = function forward () {
	  this.go(1);
	};
	
	VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
	  var route = to
	    ? to.matched
	      ? to
	      : this.resolve(to).route
	    : this.currentRoute;
	  if (!route) {
	    return []
	  }
	  return [].concat.apply([], route.matched.map(function (m) {
	    return Object.keys(m.components).map(function (key) {
	      return m.components[key]
	    })
	  }))
	};
	
	VueRouter.prototype.resolve = function resolve (
	  to,
	  current,
	  append
	) {
	  var location = normalizeLocation(
	    to,
	    current || this.history.current,
	    append,
	    this
	  );
	  var route = this.match(location, current);
	  var fullPath = route.redirectedFrom || route.fullPath;
	  var base = this.history.base;
	  var href = createHref(base, fullPath, this.mode);
	  return {
	    location: location,
	    route: route,
	    href: href,
	    // for backwards compat
	    normalizedTo: location,
	    resolved: route
	  }
	};
	
	VueRouter.prototype.addRoutes = function addRoutes (routes) {
	  this.matcher.addRoutes(routes);
	  if (this.history.current !== START) {
	    this.history.transitionTo(this.history.getCurrentLocation());
	  }
	};
	
	Object.defineProperties( VueRouter.prototype, prototypeAccessors );
	
	function registerHook (list, fn) {
	  list.push(fn);
	  return function () {
	    var i = list.indexOf(fn);
	    if (i > -1) { list.splice(i, 1); }
	  }
	}
	
	function createHref (base, fullPath, mode) {
	  var path = mode === 'hash' ? '#' + fullPath : fullPath;
	  return base ? cleanPath(base + '/' + path) : path
	}
	
	VueRouter.install = install;
	VueRouter.version = '2.8.1';
	
	if (inBrowser && window.Vue) {
	  window.Vue.use(VueRouter);
	}
	
	module.exports = VueRouter;


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
	 * Vue.js v2.6.11
	 * (c) 2014-2019 Evan You
	 * Released under the MIT License.
	 */
	"use strict";var e=Object.freeze({});function t(e){return null==e}function n(e){return null!=e}function r(e){return!0===e}function i(e){return"string"==typeof e||"number"==typeof e||"symbol"==typeof e||"boolean"==typeof e}function o(e){return null!==e&&"object"==typeof e}var a=Object.prototype.toString;function s(e){return"[object Object]"===a.call(e)}function c(e){var t=parseFloat(String(e));return t>=0&&Math.floor(t)===t&&isFinite(e)}function u(e){return n(e)&&"function"==typeof e.then&&"function"==typeof e.catch}function l(e){return null==e?"":Array.isArray(e)||s(e)&&e.toString===a?JSON.stringify(e,null,2):String(e)}function f(e){var t=parseFloat(e);return isNaN(t)?e:t}function p(e,t){for(var n=Object.create(null),r=e.split(","),i=0;i<r.length;i++)n[r[i]]=!0;return t?function(e){return n[e.toLowerCase()]}:function(e){return n[e]}}var d=p("slot,component",!0),v=p("key,ref,slot,slot-scope,is");function h(e,t){if(e.length){var n=e.indexOf(t);if(n>-1)return e.splice(n,1)}}var m=Object.prototype.hasOwnProperty;function y(e,t){return m.call(e,t)}function g(e){var t=Object.create(null);return function(n){return t[n]||(t[n]=e(n))}}var _=/-(\w)/g,b=g(function(e){return e.replace(_,function(e,t){return t?t.toUpperCase():""})}),$=g(function(e){return e.charAt(0).toUpperCase()+e.slice(1)}),w=/\B([A-Z])/g,C=g(function(e){return e.replace(w,"-$1").toLowerCase()});var x=Function.prototype.bind?function(e,t){return e.bind(t)}:function(e,t){function n(n){var r=arguments.length;return r?r>1?e.apply(t,arguments):e.call(t,n):e.call(t)}return n._length=e.length,n};function k(e,t){t=t||0;for(var n=e.length-t,r=new Array(n);n--;)r[n]=e[n+t];return r}function A(e,t){for(var n in t)e[n]=t[n];return e}function O(e){for(var t={},n=0;n<e.length;n++)e[n]&&A(t,e[n]);return t}function S(e,t,n){}var T=function(e,t,n){return!1},E=function(e){return e};function N(e,t){if(e===t)return!0;var n=o(e),r=o(t);if(!n||!r)return!n&&!r&&String(e)===String(t);try{var i=Array.isArray(e),a=Array.isArray(t);if(i&&a)return e.length===t.length&&e.every(function(e,n){return N(e,t[n])});if(e instanceof Date&&t instanceof Date)return e.getTime()===t.getTime();if(i||a)return!1;var s=Object.keys(e),c=Object.keys(t);return s.length===c.length&&s.every(function(n){return N(e[n],t[n])})}catch(e){return!1}}function j(e,t){for(var n=0;n<e.length;n++)if(N(e[n],t))return n;return-1}function D(e){var t=!1;return function(){t||(t=!0,e.apply(this,arguments))}}var L="data-server-rendered",M=["component","directive","filter"],I=["beforeCreate","created","beforeMount","mounted","beforeUpdate","updated","beforeDestroy","destroyed","activated","deactivated","errorCaptured","serverPrefetch"],F={optionMergeStrategies:Object.create(null),silent:!1,productionTip:!1,devtools:!1,performance:!1,errorHandler:null,warnHandler:null,ignoredElements:[],keyCodes:Object.create(null),isReservedTag:T,isReservedAttr:T,isUnknownElement:T,getTagNamespace:S,parsePlatformTagName:E,mustUseProp:T,async:!0,_lifecycleHooks:I},P=/a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;function R(e,t,n,r){Object.defineProperty(e,t,{value:n,enumerable:!!r,writable:!0,configurable:!0})}var H=new RegExp("[^"+P.source+".$_\\d]");var B,U="__proto__"in{},z="undefined"!=typeof window,V="undefined"!=typeof WXEnvironment&&!!WXEnvironment.platform,K=V&&WXEnvironment.platform.toLowerCase(),J=z&&window.navigator.userAgent.toLowerCase(),q=J&&/msie|trident/.test(J),W=J&&J.indexOf("msie 9.0")>0,Z=J&&J.indexOf("edge/")>0,G=(J&&J.indexOf("android"),J&&/iphone|ipad|ipod|ios/.test(J)||"ios"===K),X=(J&&/chrome\/\d+/.test(J),J&&/phantomjs/.test(J),J&&J.match(/firefox\/(\d+)/)),Y={}.watch,Q=!1;if(z)try{var ee={};Object.defineProperty(ee,"passive",{get:function(){Q=!0}}),window.addEventListener("test-passive",null,ee)}catch(e){}var te=function(){return void 0===B&&(B=!z&&!V&&"undefined"!=typeof global&&(global.process&&"server"===global.process.env.VUE_ENV)),B},ne=z&&window.__VUE_DEVTOOLS_GLOBAL_HOOK__;function re(e){return"function"==typeof e&&/native code/.test(e.toString())}var ie,oe="undefined"!=typeof Symbol&&re(Symbol)&&"undefined"!=typeof Reflect&&re(Reflect.ownKeys);ie="undefined"!=typeof Set&&re(Set)?Set:function(){function e(){this.set=Object.create(null)}return e.prototype.has=function(e){return!0===this.set[e]},e.prototype.add=function(e){this.set[e]=!0},e.prototype.clear=function(){this.set=Object.create(null)},e}();var ae=S,se=0,ce=function(){this.id=se++,this.subs=[]};ce.prototype.addSub=function(e){this.subs.push(e)},ce.prototype.removeSub=function(e){h(this.subs,e)},ce.prototype.depend=function(){ce.target&&ce.target.addDep(this)},ce.prototype.notify=function(){for(var e=this.subs.slice(),t=0,n=e.length;t<n;t++)e[t].update()},ce.target=null;var ue=[];function le(e){ue.push(e),ce.target=e}function fe(){ue.pop(),ce.target=ue[ue.length-1]}var pe=function(e,t,n,r,i,o,a,s){this.tag=e,this.data=t,this.children=n,this.text=r,this.elm=i,this.ns=void 0,this.context=o,this.fnContext=void 0,this.fnOptions=void 0,this.fnScopeId=void 0,this.key=t&&t.key,this.componentOptions=a,this.componentInstance=void 0,this.parent=void 0,this.raw=!1,this.isStatic=!1,this.isRootInsert=!0,this.isComment=!1,this.isCloned=!1,this.isOnce=!1,this.asyncFactory=s,this.asyncMeta=void 0,this.isAsyncPlaceholder=!1},de={child:{configurable:!0}};de.child.get=function(){return this.componentInstance},Object.defineProperties(pe.prototype,de);var ve=function(e){void 0===e&&(e="");var t=new pe;return t.text=e,t.isComment=!0,t};function he(e){return new pe(void 0,void 0,void 0,String(e))}function me(e){var t=new pe(e.tag,e.data,e.children&&e.children.slice(),e.text,e.elm,e.context,e.componentOptions,e.asyncFactory);return t.ns=e.ns,t.isStatic=e.isStatic,t.key=e.key,t.isComment=e.isComment,t.fnContext=e.fnContext,t.fnOptions=e.fnOptions,t.fnScopeId=e.fnScopeId,t.asyncMeta=e.asyncMeta,t.isCloned=!0,t}var ye=Array.prototype,ge=Object.create(ye);["push","pop","shift","unshift","splice","sort","reverse"].forEach(function(e){var t=ye[e];R(ge,e,function(){for(var n=[],r=arguments.length;r--;)n[r]=arguments[r];var i,o=t.apply(this,n),a=this.__ob__;switch(e){case"push":case"unshift":i=n;break;case"splice":i=n.slice(2)}return i&&a.observeArray(i),a.dep.notify(),o})});var _e=Object.getOwnPropertyNames(ge),be=!0;function $e(e){be=e}var we=function(e){var t;this.value=e,this.dep=new ce,this.vmCount=0,R(e,"__ob__",this),Array.isArray(e)?(U?(t=ge,e.__proto__=t):function(e,t,n){for(var r=0,i=n.length;r<i;r++){var o=n[r];R(e,o,t[o])}}(e,ge,_e),this.observeArray(e)):this.walk(e)};function Ce(e,t){var n;if(o(e)&&!(e instanceof pe))return y(e,"__ob__")&&e.__ob__ instanceof we?n=e.__ob__:be&&!te()&&(Array.isArray(e)||s(e))&&Object.isExtensible(e)&&!e._isVue&&(n=new we(e)),t&&n&&n.vmCount++,n}function xe(e,t,n,r,i){var o=new ce,a=Object.getOwnPropertyDescriptor(e,t);if(!a||!1!==a.configurable){var s=a&&a.get,c=a&&a.set;s&&!c||2!==arguments.length||(n=e[t]);var u=!i&&Ce(n);Object.defineProperty(e,t,{enumerable:!0,configurable:!0,get:function(){var t=s?s.call(e):n;return ce.target&&(o.depend(),u&&(u.dep.depend(),Array.isArray(t)&&function e(t){for(var n=void 0,r=0,i=t.length;r<i;r++)(n=t[r])&&n.__ob__&&n.__ob__.dep.depend(),Array.isArray(n)&&e(n)}(t))),t},set:function(t){var r=s?s.call(e):n;t===r||t!=t&&r!=r||s&&!c||(c?c.call(e,t):n=t,u=!i&&Ce(t),o.notify())}})}}function ke(e,t,n){if(Array.isArray(e)&&c(t))return e.length=Math.max(e.length,t),e.splice(t,1,n),n;if(t in e&&!(t in Object.prototype))return e[t]=n,n;var r=e.__ob__;return e._isVue||r&&r.vmCount?n:r?(xe(r.value,t,n),r.dep.notify(),n):(e[t]=n,n)}function Ae(e,t){if(Array.isArray(e)&&c(t))e.splice(t,1);else{var n=e.__ob__;e._isVue||n&&n.vmCount||y(e,t)&&(delete e[t],n&&n.dep.notify())}}we.prototype.walk=function(e){for(var t=Object.keys(e),n=0;n<t.length;n++)xe(e,t[n])},we.prototype.observeArray=function(e){for(var t=0,n=e.length;t<n;t++)Ce(e[t])};var Oe=F.optionMergeStrategies;function Se(e,t){if(!t)return e;for(var n,r,i,o=oe?Reflect.ownKeys(t):Object.keys(t),a=0;a<o.length;a++)"__ob__"!==(n=o[a])&&(r=e[n],i=t[n],y(e,n)?r!==i&&s(r)&&s(i)&&Se(r,i):ke(e,n,i));return e}function Te(e,t,n){return n?function(){var r="function"==typeof t?t.call(n,n):t,i="function"==typeof e?e.call(n,n):e;return r?Se(r,i):i}:t?e?function(){return Se("function"==typeof t?t.call(this,this):t,"function"==typeof e?e.call(this,this):e)}:t:e}function Ee(e,t){var n=t?e?e.concat(t):Array.isArray(t)?t:[t]:e;return n?function(e){for(var t=[],n=0;n<e.length;n++)-1===t.indexOf(e[n])&&t.push(e[n]);return t}(n):n}function Ne(e,t,n,r){var i=Object.create(e||null);return t?A(i,t):i}Oe.data=function(e,t,n){return n?Te(e,t,n):t&&"function"!=typeof t?e:Te(e,t)},I.forEach(function(e){Oe[e]=Ee}),M.forEach(function(e){Oe[e+"s"]=Ne}),Oe.watch=function(e,t,n,r){if(e===Y&&(e=void 0),t===Y&&(t=void 0),!t)return Object.create(e||null);if(!e)return t;var i={};for(var o in A(i,e),t){var a=i[o],s=t[o];a&&!Array.isArray(a)&&(a=[a]),i[o]=a?a.concat(s):Array.isArray(s)?s:[s]}return i},Oe.props=Oe.methods=Oe.inject=Oe.computed=function(e,t,n,r){if(!e)return t;var i=Object.create(null);return A(i,e),t&&A(i,t),i},Oe.provide=Te;var je=function(e,t){return void 0===t?e:t};function De(e,t,n){if("function"==typeof t&&(t=t.options),function(e,t){var n=e.props;if(n){var r,i,o={};if(Array.isArray(n))for(r=n.length;r--;)"string"==typeof(i=n[r])&&(o[b(i)]={type:null});else if(s(n))for(var a in n)i=n[a],o[b(a)]=s(i)?i:{type:i};e.props=o}}(t),function(e,t){var n=e.inject;if(n){var r=e.inject={};if(Array.isArray(n))for(var i=0;i<n.length;i++)r[n[i]]={from:n[i]};else if(s(n))for(var o in n){var a=n[o];r[o]=s(a)?A({from:o},a):{from:a}}}}(t),function(e){var t=e.directives;if(t)for(var n in t){var r=t[n];"function"==typeof r&&(t[n]={bind:r,update:r})}}(t),!t._base&&(t.extends&&(e=De(e,t.extends,n)),t.mixins))for(var r=0,i=t.mixins.length;r<i;r++)e=De(e,t.mixins[r],n);var o,a={};for(o in e)c(o);for(o in t)y(e,o)||c(o);function c(r){var i=Oe[r]||je;a[r]=i(e[r],t[r],n,r)}return a}function Le(e,t,n,r){if("string"==typeof n){var i=e[t];if(y(i,n))return i[n];var o=b(n);if(y(i,o))return i[o];var a=$(o);return y(i,a)?i[a]:i[n]||i[o]||i[a]}}function Me(e,t,n,r){var i=t[e],o=!y(n,e),a=n[e],s=Pe(Boolean,i.type);if(s>-1)if(o&&!y(i,"default"))a=!1;else if(""===a||a===C(e)){var c=Pe(String,i.type);(c<0||s<c)&&(a=!0)}if(void 0===a){a=function(e,t,n){if(!y(t,"default"))return;var r=t.default;if(e&&e.$options.propsData&&void 0===e.$options.propsData[n]&&void 0!==e._props[n])return e._props[n];return"function"==typeof r&&"Function"!==Ie(t.type)?r.call(e):r}(r,i,e);var u=be;$e(!0),Ce(a),$e(u)}return a}function Ie(e){var t=e&&e.toString().match(/^\s*function (\w+)/);return t?t[1]:""}function Fe(e,t){return Ie(e)===Ie(t)}function Pe(e,t){if(!Array.isArray(t))return Fe(t,e)?0:-1;for(var n=0,r=t.length;n<r;n++)if(Fe(t[n],e))return n;return-1}function Re(e,t,n){le();try{if(t)for(var r=t;r=r.$parent;){var i=r.$options.errorCaptured;if(i)for(var o=0;o<i.length;o++)try{if(!1===i[o].call(r,e,t,n))return}catch(e){Be(e,r,"errorCaptured hook")}}Be(e,t,n)}finally{fe()}}function He(e,t,n,r,i){var o;try{(o=n?e.apply(t,n):e.call(t))&&!o._isVue&&u(o)&&!o._handled&&(o.catch(function(e){return Re(e,r,i+" (Promise/async)")}),o._handled=!0)}catch(e){Re(e,r,i)}return o}function Be(e,t,n){if(F.errorHandler)try{return F.errorHandler.call(null,e,t,n)}catch(t){t!==e&&Ue(t,null,"config.errorHandler")}Ue(e,t,n)}function Ue(e,t,n){if(!z&&!V||"undefined"==typeof console)throw e;console.error(e)}var ze,Ve=!1,Ke=[],Je=!1;function qe(){Je=!1;var e=Ke.slice(0);Ke.length=0;for(var t=0;t<e.length;t++)e[t]()}if("undefined"!=typeof Promise&&re(Promise)){var We=Promise.resolve();ze=function(){We.then(qe),G&&setTimeout(S)},Ve=!0}else if(q||"undefined"==typeof MutationObserver||!re(MutationObserver)&&"[object MutationObserverConstructor]"!==MutationObserver.toString())ze="undefined"!=typeof setImmediate&&re(setImmediate)?function(){setImmediate(qe)}:function(){setTimeout(qe,0)};else{var Ze=1,Ge=new MutationObserver(qe),Xe=document.createTextNode(String(Ze));Ge.observe(Xe,{characterData:!0}),ze=function(){Ze=(Ze+1)%2,Xe.data=String(Ze)},Ve=!0}function Ye(e,t){var n;if(Ke.push(function(){if(e)try{e.call(t)}catch(e){Re(e,t,"nextTick")}else n&&n(t)}),Je||(Je=!0,ze()),!e&&"undefined"!=typeof Promise)return new Promise(function(e){n=e})}var Qe=new ie;function et(e){!function e(t,n){var r,i;var a=Array.isArray(t);if(!a&&!o(t)||Object.isFrozen(t)||t instanceof pe)return;if(t.__ob__){var s=t.__ob__.dep.id;if(n.has(s))return;n.add(s)}if(a)for(r=t.length;r--;)e(t[r],n);else for(i=Object.keys(t),r=i.length;r--;)e(t[i[r]],n)}(e,Qe),Qe.clear()}var tt=g(function(e){var t="&"===e.charAt(0),n="~"===(e=t?e.slice(1):e).charAt(0),r="!"===(e=n?e.slice(1):e).charAt(0);return{name:e=r?e.slice(1):e,once:n,capture:r,passive:t}});function nt(e,t){function n(){var e=arguments,r=n.fns;if(!Array.isArray(r))return He(r,null,arguments,t,"v-on handler");for(var i=r.slice(),o=0;o<i.length;o++)He(i[o],null,e,t,"v-on handler")}return n.fns=e,n}function rt(e,n,i,o,a,s){var c,u,l,f;for(c in e)u=e[c],l=n[c],f=tt(c),t(u)||(t(l)?(t(u.fns)&&(u=e[c]=nt(u,s)),r(f.once)&&(u=e[c]=a(f.name,u,f.capture)),i(f.name,u,f.capture,f.passive,f.params)):u!==l&&(l.fns=u,e[c]=l));for(c in n)t(e[c])&&o((f=tt(c)).name,n[c],f.capture)}function it(e,i,o){var a;e instanceof pe&&(e=e.data.hook||(e.data.hook={}));var s=e[i];function c(){o.apply(this,arguments),h(a.fns,c)}t(s)?a=nt([c]):n(s.fns)&&r(s.merged)?(a=s).fns.push(c):a=nt([s,c]),a.merged=!0,e[i]=a}function ot(e,t,r,i,o){if(n(t)){if(y(t,r))return e[r]=t[r],o||delete t[r],!0;if(y(t,i))return e[r]=t[i],o||delete t[i],!0}return!1}function at(e){return i(e)?[he(e)]:Array.isArray(e)?function e(o,a){var s=[];var c,u,l,f;for(c=0;c<o.length;c++)t(u=o[c])||"boolean"==typeof u||(l=s.length-1,f=s[l],Array.isArray(u)?u.length>0&&(st((u=e(u,(a||"")+"_"+c))[0])&&st(f)&&(s[l]=he(f.text+u[0].text),u.shift()),s.push.apply(s,u)):i(u)?st(f)?s[l]=he(f.text+u):""!==u&&s.push(he(u)):st(u)&&st(f)?s[l]=he(f.text+u.text):(r(o._isVList)&&n(u.tag)&&t(u.key)&&n(a)&&(u.key="__vlist"+a+"_"+c+"__"),s.push(u)));return s}(e):void 0}function st(e){return n(e)&&n(e.text)&&!1===e.isComment}function ct(e,t){if(e){for(var n=Object.create(null),r=oe?Reflect.ownKeys(e):Object.keys(e),i=0;i<r.length;i++){var o=r[i];if("__ob__"!==o){for(var a=e[o].from,s=t;s;){if(s._provided&&y(s._provided,a)){n[o]=s._provided[a];break}s=s.$parent}if(!s&&"default"in e[o]){var c=e[o].default;n[o]="function"==typeof c?c.call(t):c}}}return n}}function ut(e,t){if(!e||!e.length)return{};for(var n={},r=0,i=e.length;r<i;r++){var o=e[r],a=o.data;if(a&&a.attrs&&a.attrs.slot&&delete a.attrs.slot,o.context!==t&&o.fnContext!==t||!a||null==a.slot)(n.default||(n.default=[])).push(o);else{var s=a.slot,c=n[s]||(n[s]=[]);"template"===o.tag?c.push.apply(c,o.children||[]):c.push(o)}}for(var u in n)n[u].every(lt)&&delete n[u];return n}function lt(e){return e.isComment&&!e.asyncFactory||" "===e.text}function ft(t,n,r){var i,o=Object.keys(n).length>0,a=t?!!t.$stable:!o,s=t&&t.$key;if(t){if(t._normalized)return t._normalized;if(a&&r&&r!==e&&s===r.$key&&!o&&!r.$hasNormal)return r;for(var c in i={},t)t[c]&&"$"!==c[0]&&(i[c]=pt(n,c,t[c]))}else i={};for(var u in n)u in i||(i[u]=dt(n,u));return t&&Object.isExtensible(t)&&(t._normalized=i),R(i,"$stable",a),R(i,"$key",s),R(i,"$hasNormal",o),i}function pt(e,t,n){var r=function(){var e=arguments.length?n.apply(null,arguments):n({});return(e=e&&"object"==typeof e&&!Array.isArray(e)?[e]:at(e))&&(0===e.length||1===e.length&&e[0].isComment)?void 0:e};return n.proxy&&Object.defineProperty(e,t,{get:r,enumerable:!0,configurable:!0}),r}function dt(e,t){return function(){return e[t]}}function vt(e,t){var r,i,a,s,c;if(Array.isArray(e)||"string"==typeof e)for(r=new Array(e.length),i=0,a=e.length;i<a;i++)r[i]=t(e[i],i);else if("number"==typeof e)for(r=new Array(e),i=0;i<e;i++)r[i]=t(i+1,i);else if(o(e))if(oe&&e[Symbol.iterator]){r=[];for(var u=e[Symbol.iterator](),l=u.next();!l.done;)r.push(t(l.value,r.length)),l=u.next()}else for(s=Object.keys(e),r=new Array(s.length),i=0,a=s.length;i<a;i++)c=s[i],r[i]=t(e[c],c,i);return n(r)||(r=[]),r._isVList=!0,r}function ht(e,t,n,r){var i,o=this.$scopedSlots[e];o?(n=n||{},r&&(n=A(A({},r),n)),i=o(n)||t):i=this.$slots[e]||t;var a=n&&n.slot;return a?this.$createElement("template",{slot:a},i):i}function mt(e){return Le(this.$options,"filters",e)||E}function yt(e,t){return Array.isArray(e)?-1===e.indexOf(t):e!==t}function gt(e,t,n,r,i){var o=F.keyCodes[t]||n;return i&&r&&!F.keyCodes[t]?yt(i,r):o?yt(o,e):r?C(r)!==t:void 0}function _t(e,t,n,r,i){if(n)if(o(n)){var a;Array.isArray(n)&&(n=O(n));var s=function(o){if("class"===o||"style"===o||v(o))a=e;else{var s=e.attrs&&e.attrs.type;a=r||F.mustUseProp(t,s,o)?e.domProps||(e.domProps={}):e.attrs||(e.attrs={})}var c=b(o),u=C(o);c in a||u in a||(a[o]=n[o],i&&((e.on||(e.on={}))["update:"+o]=function(e){n[o]=e}))};for(var c in n)s(c)}else;return e}function bt(e,t){var n=this._staticTrees||(this._staticTrees=[]),r=n[e];return r&&!t?r:(wt(r=n[e]=this.$options.staticRenderFns[e].call(this._renderProxy,null,this),"__static__"+e,!1),r)}function $t(e,t,n){return wt(e,"__once__"+t+(n?"_"+n:""),!0),e}function wt(e,t,n){if(Array.isArray(e))for(var r=0;r<e.length;r++)e[r]&&"string"!=typeof e[r]&&Ct(e[r],t+"_"+r,n);else Ct(e,t,n)}function Ct(e,t,n){e.isStatic=!0,e.key=t,e.isOnce=n}function xt(e,t){if(t)if(s(t)){var n=e.on=e.on?A({},e.on):{};for(var r in t){var i=n[r],o=t[r];n[r]=i?[].concat(i,o):o}}else;return e}function kt(e,t,n,r){t=t||{$stable:!n};for(var i=0;i<e.length;i++){var o=e[i];Array.isArray(o)?kt(o,t,n):o&&(o.proxy&&(o.fn.proxy=!0),t[o.key]=o.fn)}return r&&(t.$key=r),t}function At(e,t){for(var n=0;n<t.length;n+=2){var r=t[n];"string"==typeof r&&r&&(e[t[n]]=t[n+1])}return e}function Ot(e,t){return"string"==typeof e?t+e:e}function St(e){e._o=$t,e._n=f,e._s=l,e._l=vt,e._t=ht,e._q=N,e._i=j,e._m=bt,e._f=mt,e._k=gt,e._b=_t,e._v=he,e._e=ve,e._u=kt,e._g=xt,e._d=At,e._p=Ot}function Tt(t,n,i,o,a){var s,c=this,u=a.options;y(o,"_uid")?(s=Object.create(o))._original=o:(s=o,o=o._original);var l=r(u._compiled),f=!l;this.data=t,this.props=n,this.children=i,this.parent=o,this.listeners=t.on||e,this.injections=ct(u.inject,o),this.slots=function(){return c.$slots||ft(t.scopedSlots,c.$slots=ut(i,o)),c.$slots},Object.defineProperty(this,"scopedSlots",{enumerable:!0,get:function(){return ft(t.scopedSlots,this.slots())}}),l&&(this.$options=u,this.$slots=this.slots(),this.$scopedSlots=ft(t.scopedSlots,this.$slots)),u._scopeId?this._c=function(e,t,n,r){var i=Pt(s,e,t,n,r,f);return i&&!Array.isArray(i)&&(i.fnScopeId=u._scopeId,i.fnContext=o),i}:this._c=function(e,t,n,r){return Pt(s,e,t,n,r,f)}}function Et(e,t,n,r,i){var o=me(e);return o.fnContext=n,o.fnOptions=r,t.slot&&((o.data||(o.data={})).slot=t.slot),o}function Nt(e,t){for(var n in t)e[b(n)]=t[n]}St(Tt.prototype);var jt={init:function(e,t){if(e.componentInstance&&!e.componentInstance._isDestroyed&&e.data.keepAlive){var r=e;jt.prepatch(r,r)}else{(e.componentInstance=function(e,t){var r={_isComponent:!0,_parentVnode:e,parent:t},i=e.data.inlineTemplate;n(i)&&(r.render=i.render,r.staticRenderFns=i.staticRenderFns);return new e.componentOptions.Ctor(r)}(e,Wt)).$mount(t?e.elm:void 0,t)}},prepatch:function(t,n){var r=n.componentOptions;!function(t,n,r,i,o){var a=i.data.scopedSlots,s=t.$scopedSlots,c=!!(a&&!a.$stable||s!==e&&!s.$stable||a&&t.$scopedSlots.$key!==a.$key),u=!!(o||t.$options._renderChildren||c);t.$options._parentVnode=i,t.$vnode=i,t._vnode&&(t._vnode.parent=i);if(t.$options._renderChildren=o,t.$attrs=i.data.attrs||e,t.$listeners=r||e,n&&t.$options.props){$e(!1);for(var l=t._props,f=t.$options._propKeys||[],p=0;p<f.length;p++){var d=f[p],v=t.$options.props;l[d]=Me(d,v,n,t)}$e(!0),t.$options.propsData=n}r=r||e;var h=t.$options._parentListeners;t.$options._parentListeners=r,qt(t,r,h),u&&(t.$slots=ut(o,i.context),t.$forceUpdate())}(n.componentInstance=t.componentInstance,r.propsData,r.listeners,n,r.children)},insert:function(e){var t,n=e.context,r=e.componentInstance;r._isMounted||(r._isMounted=!0,Yt(r,"mounted")),e.data.keepAlive&&(n._isMounted?((t=r)._inactive=!1,en.push(t)):Xt(r,!0))},destroy:function(e){var t=e.componentInstance;t._isDestroyed||(e.data.keepAlive?function e(t,n){if(n&&(t._directInactive=!0,Gt(t)))return;if(!t._inactive){t._inactive=!0;for(var r=0;r<t.$children.length;r++)e(t.$children[r]);Yt(t,"deactivated")}}(t,!0):t.$destroy())}},Dt=Object.keys(jt);function Lt(i,a,s,c,l){if(!t(i)){var f=s.$options._base;if(o(i)&&(i=f.extend(i)),"function"==typeof i){var p;if(t(i.cid)&&void 0===(i=function(e,i){if(r(e.error)&&n(e.errorComp))return e.errorComp;if(n(e.resolved))return e.resolved;var a=Ht;a&&n(e.owners)&&-1===e.owners.indexOf(a)&&e.owners.push(a);if(r(e.loading)&&n(e.loadingComp))return e.loadingComp;if(a&&!n(e.owners)){var s=e.owners=[a],c=!0,l=null,f=null;a.$on("hook:destroyed",function(){return h(s,a)});var p=function(e){for(var t=0,n=s.length;t<n;t++)s[t].$forceUpdate();e&&(s.length=0,null!==l&&(clearTimeout(l),l=null),null!==f&&(clearTimeout(f),f=null))},d=D(function(t){e.resolved=Bt(t,i),c?s.length=0:p(!0)}),v=D(function(t){n(e.errorComp)&&(e.error=!0,p(!0))}),m=e(d,v);return o(m)&&(u(m)?t(e.resolved)&&m.then(d,v):u(m.component)&&(m.component.then(d,v),n(m.error)&&(e.errorComp=Bt(m.error,i)),n(m.loading)&&(e.loadingComp=Bt(m.loading,i),0===m.delay?e.loading=!0:l=setTimeout(function(){l=null,t(e.resolved)&&t(e.error)&&(e.loading=!0,p(!1))},m.delay||200)),n(m.timeout)&&(f=setTimeout(function(){f=null,t(e.resolved)&&v(null)},m.timeout)))),c=!1,e.loading?e.loadingComp:e.resolved}}(p=i,f)))return function(e,t,n,r,i){var o=ve();return o.asyncFactory=e,o.asyncMeta={data:t,context:n,children:r,tag:i},o}(p,a,s,c,l);a=a||{},$n(i),n(a.model)&&function(e,t){var r=e.model&&e.model.prop||"value",i=e.model&&e.model.event||"input";(t.attrs||(t.attrs={}))[r]=t.model.value;var o=t.on||(t.on={}),a=o[i],s=t.model.callback;n(a)?(Array.isArray(a)?-1===a.indexOf(s):a!==s)&&(o[i]=[s].concat(a)):o[i]=s}(i.options,a);var d=function(e,r,i){var o=r.options.props;if(!t(o)){var a={},s=e.attrs,c=e.props;if(n(s)||n(c))for(var u in o){var l=C(u);ot(a,c,u,l,!0)||ot(a,s,u,l,!1)}return a}}(a,i);if(r(i.options.functional))return function(t,r,i,o,a){var s=t.options,c={},u=s.props;if(n(u))for(var l in u)c[l]=Me(l,u,r||e);else n(i.attrs)&&Nt(c,i.attrs),n(i.props)&&Nt(c,i.props);var f=new Tt(i,c,a,o,t),p=s.render.call(null,f._c,f);if(p instanceof pe)return Et(p,i,f.parent,s);if(Array.isArray(p)){for(var d=at(p)||[],v=new Array(d.length),h=0;h<d.length;h++)v[h]=Et(d[h],i,f.parent,s);return v}}(i,d,a,s,c);var v=a.on;if(a.on=a.nativeOn,r(i.options.abstract)){var m=a.slot;a={},m&&(a.slot=m)}!function(e){for(var t=e.hook||(e.hook={}),n=0;n<Dt.length;n++){var r=Dt[n],i=t[r],o=jt[r];i===o||i&&i._merged||(t[r]=i?Mt(o,i):o)}}(a);var y=i.options.name||l;return new pe("vue-component-"+i.cid+(y?"-"+y:""),a,void 0,void 0,void 0,s,{Ctor:i,propsData:d,listeners:v,tag:l,children:c},p)}}}function Mt(e,t){var n=function(n,r){e(n,r),t(n,r)};return n._merged=!0,n}var It=1,Ft=2;function Pt(e,a,s,c,u,l){return(Array.isArray(s)||i(s))&&(u=c,c=s,s=void 0),r(l)&&(u=Ft),function(e,i,a,s,c){if(n(a)&&n(a.__ob__))return ve();n(a)&&n(a.is)&&(i=a.is);if(!i)return ve();Array.isArray(s)&&"function"==typeof s[0]&&((a=a||{}).scopedSlots={default:s[0]},s.length=0);c===Ft?s=at(s):c===It&&(s=function(e){for(var t=0;t<e.length;t++)if(Array.isArray(e[t]))return Array.prototype.concat.apply([],e);return e}(s));var u,l;if("string"==typeof i){var f;l=e.$vnode&&e.$vnode.ns||F.getTagNamespace(i),u=F.isReservedTag(i)?new pe(F.parsePlatformTagName(i),a,s,void 0,void 0,e):a&&a.pre||!n(f=Le(e.$options,"components",i))?new pe(i,a,s,void 0,void 0,e):Lt(f,a,e,s,i)}else u=Lt(i,a,e,s);return Array.isArray(u)?u:n(u)?(n(l)&&function e(i,o,a){i.ns=o;"foreignObject"===i.tag&&(o=void 0,a=!0);if(n(i.children))for(var s=0,c=i.children.length;s<c;s++){var u=i.children[s];n(u.tag)&&(t(u.ns)||r(a)&&"svg"!==u.tag)&&e(u,o,a)}}(u,l),n(a)&&function(e){o(e.style)&&et(e.style);o(e.class)&&et(e.class)}(a),u):ve()}(e,a,s,c,u)}var Rt,Ht=null;function Bt(e,t){return(e.__esModule||oe&&"Module"===e[Symbol.toStringTag])&&(e=e.default),o(e)?t.extend(e):e}function Ut(e){return e.isComment&&e.asyncFactory}function zt(e){if(Array.isArray(e))for(var t=0;t<e.length;t++){var r=e[t];if(n(r)&&(n(r.componentOptions)||Ut(r)))return r}}function Vt(e,t){Rt.$on(e,t)}function Kt(e,t){Rt.$off(e,t)}function Jt(e,t){var n=Rt;return function r(){null!==t.apply(null,arguments)&&n.$off(e,r)}}function qt(e,t,n){Rt=e,rt(t,n||{},Vt,Kt,Jt,e),Rt=void 0}var Wt=null;function Zt(e){var t=Wt;return Wt=e,function(){Wt=t}}function Gt(e){for(;e&&(e=e.$parent);)if(e._inactive)return!0;return!1}function Xt(e,t){if(t){if(e._directInactive=!1,Gt(e))return}else if(e._directInactive)return;if(e._inactive||null===e._inactive){e._inactive=!1;for(var n=0;n<e.$children.length;n++)Xt(e.$children[n]);Yt(e,"activated")}}function Yt(e,t){le();var n=e.$options[t],r=t+" hook";if(n)for(var i=0,o=n.length;i<o;i++)He(n[i],e,null,e,r);e._hasHookEvent&&e.$emit("hook:"+t),fe()}var Qt=[],en=[],tn={},nn=!1,rn=!1,on=0;var an=0,sn=Date.now;if(z&&!q){var cn=window.performance;cn&&"function"==typeof cn.now&&sn()>document.createEvent("Event").timeStamp&&(sn=function(){return cn.now()})}function un(){var e,t;for(an=sn(),rn=!0,Qt.sort(function(e,t){return e.id-t.id}),on=0;on<Qt.length;on++)(e=Qt[on]).before&&e.before(),t=e.id,tn[t]=null,e.run();var n=en.slice(),r=Qt.slice();on=Qt.length=en.length=0,tn={},nn=rn=!1,function(e){for(var t=0;t<e.length;t++)e[t]._inactive=!0,Xt(e[t],!0)}(n),function(e){var t=e.length;for(;t--;){var n=e[t],r=n.vm;r._watcher===n&&r._isMounted&&!r._isDestroyed&&Yt(r,"updated")}}(r),ne&&F.devtools&&ne.emit("flush")}var ln=0,fn=function(e,t,n,r,i){this.vm=e,i&&(e._watcher=this),e._watchers.push(this),r?(this.deep=!!r.deep,this.user=!!r.user,this.lazy=!!r.lazy,this.sync=!!r.sync,this.before=r.before):this.deep=this.user=this.lazy=this.sync=!1,this.cb=n,this.id=++ln,this.active=!0,this.dirty=this.lazy,this.deps=[],this.newDeps=[],this.depIds=new ie,this.newDepIds=new ie,this.expression="","function"==typeof t?this.getter=t:(this.getter=function(e){if(!H.test(e)){var t=e.split(".");return function(e){for(var n=0;n<t.length;n++){if(!e)return;e=e[t[n]]}return e}}}(t),this.getter||(this.getter=S)),this.value=this.lazy?void 0:this.get()};fn.prototype.get=function(){var e;le(this);var t=this.vm;try{e=this.getter.call(t,t)}catch(e){if(!this.user)throw e;Re(e,t,'getter for watcher "'+this.expression+'"')}finally{this.deep&&et(e),fe(),this.cleanupDeps()}return e},fn.prototype.addDep=function(e){var t=e.id;this.newDepIds.has(t)||(this.newDepIds.add(t),this.newDeps.push(e),this.depIds.has(t)||e.addSub(this))},fn.prototype.cleanupDeps=function(){for(var e=this.deps.length;e--;){var t=this.deps[e];this.newDepIds.has(t.id)||t.removeSub(this)}var n=this.depIds;this.depIds=this.newDepIds,this.newDepIds=n,this.newDepIds.clear(),n=this.deps,this.deps=this.newDeps,this.newDeps=n,this.newDeps.length=0},fn.prototype.update=function(){this.lazy?this.dirty=!0:this.sync?this.run():function(e){var t=e.id;if(null==tn[t]){if(tn[t]=!0,rn){for(var n=Qt.length-1;n>on&&Qt[n].id>e.id;)n--;Qt.splice(n+1,0,e)}else Qt.push(e);nn||(nn=!0,Ye(un))}}(this)},fn.prototype.run=function(){if(this.active){var e=this.get();if(e!==this.value||o(e)||this.deep){var t=this.value;if(this.value=e,this.user)try{this.cb.call(this.vm,e,t)}catch(e){Re(e,this.vm,'callback for watcher "'+this.expression+'"')}else this.cb.call(this.vm,e,t)}}},fn.prototype.evaluate=function(){this.value=this.get(),this.dirty=!1},fn.prototype.depend=function(){for(var e=this.deps.length;e--;)this.deps[e].depend()},fn.prototype.teardown=function(){if(this.active){this.vm._isBeingDestroyed||h(this.vm._watchers,this);for(var e=this.deps.length;e--;)this.deps[e].removeSub(this);this.active=!1}};var pn={enumerable:!0,configurable:!0,get:S,set:S};function dn(e,t,n){pn.get=function(){return this[t][n]},pn.set=function(e){this[t][n]=e},Object.defineProperty(e,n,pn)}function vn(e){e._watchers=[];var t=e.$options;t.props&&function(e,t){var n=e.$options.propsData||{},r=e._props={},i=e.$options._propKeys=[];e.$parent&&$e(!1);var o=function(o){i.push(o);var a=Me(o,t,n,e);xe(r,o,a),o in e||dn(e,"_props",o)};for(var a in t)o(a);$e(!0)}(e,t.props),t.methods&&function(e,t){e.$options.props;for(var n in t)e[n]="function"!=typeof t[n]?S:x(t[n],e)}(e,t.methods),t.data?function(e){var t=e.$options.data;s(t=e._data="function"==typeof t?function(e,t){le();try{return e.call(t,t)}catch(e){return Re(e,t,"data()"),{}}finally{fe()}}(t,e):t||{})||(t={});var n=Object.keys(t),r=e.$options.props,i=(e.$options.methods,n.length);for(;i--;){var o=n[i];r&&y(r,o)||(a=void 0,36!==(a=(o+"").charCodeAt(0))&&95!==a&&dn(e,"_data",o))}var a;Ce(t,!0)}(e):Ce(e._data={},!0),t.computed&&function(e,t){var n=e._computedWatchers=Object.create(null),r=te();for(var i in t){var o=t[i],a="function"==typeof o?o:o.get;r||(n[i]=new fn(e,a||S,S,hn)),i in e||mn(e,i,o)}}(e,t.computed),t.watch&&t.watch!==Y&&function(e,t){for(var n in t){var r=t[n];if(Array.isArray(r))for(var i=0;i<r.length;i++)_n(e,n,r[i]);else _n(e,n,r)}}(e,t.watch)}var hn={lazy:!0};function mn(e,t,n){var r=!te();"function"==typeof n?(pn.get=r?yn(t):gn(n),pn.set=S):(pn.get=n.get?r&&!1!==n.cache?yn(t):gn(n.get):S,pn.set=n.set||S),Object.defineProperty(e,t,pn)}function yn(e){return function(){var t=this._computedWatchers&&this._computedWatchers[e];if(t)return t.dirty&&t.evaluate(),ce.target&&t.depend(),t.value}}function gn(e){return function(){return e.call(this,this)}}function _n(e,t,n,r){return s(n)&&(r=n,n=n.handler),"string"==typeof n&&(n=e[n]),e.$watch(t,n,r)}var bn=0;function $n(e){var t=e.options;if(e.super){var n=$n(e.super);if(n!==e.superOptions){e.superOptions=n;var r=function(e){var t,n=e.options,r=e.sealedOptions;for(var i in n)n[i]!==r[i]&&(t||(t={}),t[i]=n[i]);return t}(e);r&&A(e.extendOptions,r),(t=e.options=De(n,e.extendOptions)).name&&(t.components[t.name]=e)}}return t}function wn(e){this._init(e)}function Cn(e){e.cid=0;var t=1;e.extend=function(e){e=e||{};var n=this,r=n.cid,i=e._Ctor||(e._Ctor={});if(i[r])return i[r];var o=e.name||n.options.name,a=function(e){this._init(e)};return(a.prototype=Object.create(n.prototype)).constructor=a,a.cid=t++,a.options=De(n.options,e),a.super=n,a.options.props&&function(e){var t=e.options.props;for(var n in t)dn(e.prototype,"_props",n)}(a),a.options.computed&&function(e){var t=e.options.computed;for(var n in t)mn(e.prototype,n,t[n])}(a),a.extend=n.extend,a.mixin=n.mixin,a.use=n.use,M.forEach(function(e){a[e]=n[e]}),o&&(a.options.components[o]=a),a.superOptions=n.options,a.extendOptions=e,a.sealedOptions=A({},a.options),i[r]=a,a}}function xn(e){return e&&(e.Ctor.options.name||e.tag)}function kn(e,t){return Array.isArray(e)?e.indexOf(t)>-1:"string"==typeof e?e.split(",").indexOf(t)>-1:(n=e,"[object RegExp]"===a.call(n)&&e.test(t));var n}function An(e,t){var n=e.cache,r=e.keys,i=e._vnode;for(var o in n){var a=n[o];if(a){var s=xn(a.componentOptions);s&&!t(s)&&On(n,o,r,i)}}}function On(e,t,n,r){var i=e[t];!i||r&&i.tag===r.tag||i.componentInstance.$destroy(),e[t]=null,h(n,t)}!function(t){t.prototype._init=function(t){var n=this;n._uid=bn++,n._isVue=!0,t&&t._isComponent?function(e,t){var n=e.$options=Object.create(e.constructor.options),r=t._parentVnode;n.parent=t.parent,n._parentVnode=r;var i=r.componentOptions;n.propsData=i.propsData,n._parentListeners=i.listeners,n._renderChildren=i.children,n._componentTag=i.tag,t.render&&(n.render=t.render,n.staticRenderFns=t.staticRenderFns)}(n,t):n.$options=De($n(n.constructor),t||{},n),n._renderProxy=n,n._self=n,function(e){var t=e.$options,n=t.parent;if(n&&!t.abstract){for(;n.$options.abstract&&n.$parent;)n=n.$parent;n.$children.push(e)}e.$parent=n,e.$root=n?n.$root:e,e.$children=[],e.$refs={},e._watcher=null,e._inactive=null,e._directInactive=!1,e._isMounted=!1,e._isDestroyed=!1,e._isBeingDestroyed=!1}(n),function(e){e._events=Object.create(null),e._hasHookEvent=!1;var t=e.$options._parentListeners;t&&qt(e,t)}(n),function(t){t._vnode=null,t._staticTrees=null;var n=t.$options,r=t.$vnode=n._parentVnode,i=r&&r.context;t.$slots=ut(n._renderChildren,i),t.$scopedSlots=e,t._c=function(e,n,r,i){return Pt(t,e,n,r,i,!1)},t.$createElement=function(e,n,r,i){return Pt(t,e,n,r,i,!0)};var o=r&&r.data;xe(t,"$attrs",o&&o.attrs||e,null,!0),xe(t,"$listeners",n._parentListeners||e,null,!0)}(n),Yt(n,"beforeCreate"),function(e){var t=ct(e.$options.inject,e);t&&($e(!1),Object.keys(t).forEach(function(n){xe(e,n,t[n])}),$e(!0))}(n),vn(n),function(e){var t=e.$options.provide;t&&(e._provided="function"==typeof t?t.call(e):t)}(n),Yt(n,"created"),n.$options.el&&n.$mount(n.$options.el)}}(wn),function(e){var t={get:function(){return this._data}},n={get:function(){return this._props}};Object.defineProperty(e.prototype,"$data",t),Object.defineProperty(e.prototype,"$props",n),e.prototype.$set=ke,e.prototype.$delete=Ae,e.prototype.$watch=function(e,t,n){if(s(t))return _n(this,e,t,n);(n=n||{}).user=!0;var r=new fn(this,e,t,n);if(n.immediate)try{t.call(this,r.value)}catch(e){Re(e,this,'callback for immediate watcher "'+r.expression+'"')}return function(){r.teardown()}}}(wn),function(e){var t=/^hook:/;e.prototype.$on=function(e,n){var r=this;if(Array.isArray(e))for(var i=0,o=e.length;i<o;i++)r.$on(e[i],n);else(r._events[e]||(r._events[e]=[])).push(n),t.test(e)&&(r._hasHookEvent=!0);return r},e.prototype.$once=function(e,t){var n=this;function r(){n.$off(e,r),t.apply(n,arguments)}return r.fn=t,n.$on(e,r),n},e.prototype.$off=function(e,t){var n=this;if(!arguments.length)return n._events=Object.create(null),n;if(Array.isArray(e)){for(var r=0,i=e.length;r<i;r++)n.$off(e[r],t);return n}var o,a=n._events[e];if(!a)return n;if(!t)return n._events[e]=null,n;for(var s=a.length;s--;)if((o=a[s])===t||o.fn===t){a.splice(s,1);break}return n},e.prototype.$emit=function(e){var t=this._events[e];if(t){t=t.length>1?k(t):t;for(var n=k(arguments,1),r='event handler for "'+e+'"',i=0,o=t.length;i<o;i++)He(t[i],this,n,this,r)}return this}}(wn),function(e){e.prototype._update=function(e,t){var n=this,r=n.$el,i=n._vnode,o=Zt(n);n._vnode=e,n.$el=i?n.__patch__(i,e):n.__patch__(n.$el,e,t,!1),o(),r&&(r.__vue__=null),n.$el&&(n.$el.__vue__=n),n.$vnode&&n.$parent&&n.$vnode===n.$parent._vnode&&(n.$parent.$el=n.$el)},e.prototype.$forceUpdate=function(){this._watcher&&this._watcher.update()},e.prototype.$destroy=function(){var e=this;if(!e._isBeingDestroyed){Yt(e,"beforeDestroy"),e._isBeingDestroyed=!0;var t=e.$parent;!t||t._isBeingDestroyed||e.$options.abstract||h(t.$children,e),e._watcher&&e._watcher.teardown();for(var n=e._watchers.length;n--;)e._watchers[n].teardown();e._data.__ob__&&e._data.__ob__.vmCount--,e._isDestroyed=!0,e.__patch__(e._vnode,null),Yt(e,"destroyed"),e.$off(),e.$el&&(e.$el.__vue__=null),e.$vnode&&(e.$vnode.parent=null)}}}(wn),function(e){St(e.prototype),e.prototype.$nextTick=function(e){return Ye(e,this)},e.prototype._render=function(){var e,t=this,n=t.$options,r=n.render,i=n._parentVnode;i&&(t.$scopedSlots=ft(i.data.scopedSlots,t.$slots,t.$scopedSlots)),t.$vnode=i;try{Ht=t,e=r.call(t._renderProxy,t.$createElement)}catch(n){Re(n,t,"render"),e=t._vnode}finally{Ht=null}return Array.isArray(e)&&1===e.length&&(e=e[0]),e instanceof pe||(e=ve()),e.parent=i,e}}(wn);var Sn=[String,RegExp,Array],Tn={KeepAlive:{name:"keep-alive",abstract:!0,props:{include:Sn,exclude:Sn,max:[String,Number]},created:function(){this.cache=Object.create(null),this.keys=[]},destroyed:function(){for(var e in this.cache)On(this.cache,e,this.keys)},mounted:function(){var e=this;this.$watch("include",function(t){An(e,function(e){return kn(t,e)})}),this.$watch("exclude",function(t){An(e,function(e){return!kn(t,e)})})},render:function(){var e=this.$slots.default,t=zt(e),n=t&&t.componentOptions;if(n){var r=xn(n),i=this.include,o=this.exclude;if(i&&(!r||!kn(i,r))||o&&r&&kn(o,r))return t;var a=this.cache,s=this.keys,c=null==t.key?n.Ctor.cid+(n.tag?"::"+n.tag:""):t.key;a[c]?(t.componentInstance=a[c].componentInstance,h(s,c),s.push(c)):(a[c]=t,s.push(c),this.max&&s.length>parseInt(this.max)&&On(a,s[0],s,this._vnode)),t.data.keepAlive=!0}return t||e&&e[0]}}};!function(e){var t={get:function(){return F}};Object.defineProperty(e,"config",t),e.util={warn:ae,extend:A,mergeOptions:De,defineReactive:xe},e.set=ke,e.delete=Ae,e.nextTick=Ye,e.observable=function(e){return Ce(e),e},e.options=Object.create(null),M.forEach(function(t){e.options[t+"s"]=Object.create(null)}),e.options._base=e,A(e.options.components,Tn),function(e){e.use=function(e){var t=this._installedPlugins||(this._installedPlugins=[]);if(t.indexOf(e)>-1)return this;var n=k(arguments,1);return n.unshift(this),"function"==typeof e.install?e.install.apply(e,n):"function"==typeof e&&e.apply(null,n),t.push(e),this}}(e),function(e){e.mixin=function(e){return this.options=De(this.options,e),this}}(e),Cn(e),function(e){M.forEach(function(t){e[t]=function(e,n){return n?("component"===t&&s(n)&&(n.name=n.name||e,n=this.options._base.extend(n)),"directive"===t&&"function"==typeof n&&(n={bind:n,update:n}),this.options[t+"s"][e]=n,n):this.options[t+"s"][e]}})}(e)}(wn),Object.defineProperty(wn.prototype,"$isServer",{get:te}),Object.defineProperty(wn.prototype,"$ssrContext",{get:function(){return this.$vnode&&this.$vnode.ssrContext}}),Object.defineProperty(wn,"FunctionalRenderContext",{value:Tt}),wn.version="2.6.11";var En=p("style,class"),Nn=p("input,textarea,option,select,progress"),jn=function(e,t,n){return"value"===n&&Nn(e)&&"button"!==t||"selected"===n&&"option"===e||"checked"===n&&"input"===e||"muted"===n&&"video"===e},Dn=p("contenteditable,draggable,spellcheck"),Ln=p("events,caret,typing,plaintext-only"),Mn=function(e,t){return Hn(t)||"false"===t?"false":"contenteditable"===e&&Ln(t)?t:"true"},In=p("allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,default,defaultchecked,defaultmuted,defaultselected,defer,disabled,enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,required,reversed,scoped,seamless,selected,sortable,translate,truespeed,typemustmatch,visible"),Fn="http://www.w3.org/1999/xlink",Pn=function(e){return":"===e.charAt(5)&&"xlink"===e.slice(0,5)},Rn=function(e){return Pn(e)?e.slice(6,e.length):""},Hn=function(e){return null==e||!1===e};function Bn(e){for(var t=e.data,r=e,i=e;n(i.componentInstance);)(i=i.componentInstance._vnode)&&i.data&&(t=Un(i.data,t));for(;n(r=r.parent);)r&&r.data&&(t=Un(t,r.data));return function(e,t){if(n(e)||n(t))return zn(e,Vn(t));return""}(t.staticClass,t.class)}function Un(e,t){return{staticClass:zn(e.staticClass,t.staticClass),class:n(e.class)?[e.class,t.class]:t.class}}function zn(e,t){return e?t?e+" "+t:e:t||""}function Vn(e){return Array.isArray(e)?function(e){for(var t,r="",i=0,o=e.length;i<o;i++)n(t=Vn(e[i]))&&""!==t&&(r&&(r+=" "),r+=t);return r}(e):o(e)?function(e){var t="";for(var n in e)e[n]&&(t&&(t+=" "),t+=n);return t}(e):"string"==typeof e?e:""}var Kn={svg:"http://www.w3.org/2000/svg",math:"http://www.w3.org/1998/Math/MathML"},Jn=p("html,body,base,head,link,meta,style,title,address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,menuitem,summary,content,element,shadow,template,blockquote,iframe,tfoot"),qn=p("svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view",!0),Wn=function(e){return Jn(e)||qn(e)};function Zn(e){return qn(e)?"svg":"math"===e?"math":void 0}var Gn=Object.create(null);var Xn=p("text,number,password,search,email,tel,url");function Yn(e){if("string"==typeof e){var t=document.querySelector(e);return t||document.createElement("div")}return e}var Qn=Object.freeze({createElement:function(e,t){var n=document.createElement(e);return"select"!==e?n:(t.data&&t.data.attrs&&void 0!==t.data.attrs.multiple&&n.setAttribute("multiple","multiple"),n)},createElementNS:function(e,t){return document.createElementNS(Kn[e],t)},createTextNode:function(e){return document.createTextNode(e)},createComment:function(e){return document.createComment(e)},insertBefore:function(e,t,n){e.insertBefore(t,n)},removeChild:function(e,t){e.removeChild(t)},appendChild:function(e,t){e.appendChild(t)},parentNode:function(e){return e.parentNode},nextSibling:function(e){return e.nextSibling},tagName:function(e){return e.tagName},setTextContent:function(e,t){e.textContent=t},setStyleScope:function(e,t){e.setAttribute(t,"")}}),er={create:function(e,t){tr(t)},update:function(e,t){e.data.ref!==t.data.ref&&(tr(e,!0),tr(t))},destroy:function(e){tr(e,!0)}};function tr(e,t){var r=e.data.ref;if(n(r)){var i=e.context,o=e.componentInstance||e.elm,a=i.$refs;t?Array.isArray(a[r])?h(a[r],o):a[r]===o&&(a[r]=void 0):e.data.refInFor?Array.isArray(a[r])?a[r].indexOf(o)<0&&a[r].push(o):a[r]=[o]:a[r]=o}}var nr=new pe("",{},[]),rr=["create","activate","update","remove","destroy"];function ir(e,i){return e.key===i.key&&(e.tag===i.tag&&e.isComment===i.isComment&&n(e.data)===n(i.data)&&function(e,t){if("input"!==e.tag)return!0;var r,i=n(r=e.data)&&n(r=r.attrs)&&r.type,o=n(r=t.data)&&n(r=r.attrs)&&r.type;return i===o||Xn(i)&&Xn(o)}(e,i)||r(e.isAsyncPlaceholder)&&e.asyncFactory===i.asyncFactory&&t(i.asyncFactory.error))}function or(e,t,r){var i,o,a={};for(i=t;i<=r;++i)n(o=e[i].key)&&(a[o]=i);return a}var ar={create:sr,update:sr,destroy:function(e){sr(e,nr)}};function sr(e,t){(e.data.directives||t.data.directives)&&function(e,t){var n,r,i,o=e===nr,a=t===nr,s=ur(e.data.directives,e.context),c=ur(t.data.directives,t.context),u=[],l=[];for(n in c)r=s[n],i=c[n],r?(i.oldValue=r.value,i.oldArg=r.arg,fr(i,"update",t,e),i.def&&i.def.componentUpdated&&l.push(i)):(fr(i,"bind",t,e),i.def&&i.def.inserted&&u.push(i));if(u.length){var f=function(){for(var n=0;n<u.length;n++)fr(u[n],"inserted",t,e)};o?it(t,"insert",f):f()}l.length&&it(t,"postpatch",function(){for(var n=0;n<l.length;n++)fr(l[n],"componentUpdated",t,e)});if(!o)for(n in s)c[n]||fr(s[n],"unbind",e,e,a)}(e,t)}var cr=Object.create(null);function ur(e,t){var n,r,i=Object.create(null);if(!e)return i;for(n=0;n<e.length;n++)(r=e[n]).modifiers||(r.modifiers=cr),i[lr(r)]=r,r.def=Le(t.$options,"directives",r.name);return i}function lr(e){return e.rawName||e.name+"."+Object.keys(e.modifiers||{}).join(".")}function fr(e,t,n,r,i){var o=e.def&&e.def[t];if(o)try{o(n.elm,e,n,r,i)}catch(r){Re(r,n.context,"directive "+e.name+" "+t+" hook")}}var pr=[er,ar];function dr(e,r){var i=r.componentOptions;if(!(n(i)&&!1===i.Ctor.options.inheritAttrs||t(e.data.attrs)&&t(r.data.attrs))){var o,a,s=r.elm,c=e.data.attrs||{},u=r.data.attrs||{};for(o in n(u.__ob__)&&(u=r.data.attrs=A({},u)),u)a=u[o],c[o]!==a&&vr(s,o,a);for(o in(q||Z)&&u.value!==c.value&&vr(s,"value",u.value),c)t(u[o])&&(Pn(o)?s.removeAttributeNS(Fn,Rn(o)):Dn(o)||s.removeAttribute(o))}}function vr(e,t,n){e.tagName.indexOf("-")>-1?hr(e,t,n):In(t)?Hn(n)?e.removeAttribute(t):(n="allowfullscreen"===t&&"EMBED"===e.tagName?"true":t,e.setAttribute(t,n)):Dn(t)?e.setAttribute(t,Mn(t,n)):Pn(t)?Hn(n)?e.removeAttributeNS(Fn,Rn(t)):e.setAttributeNS(Fn,t,n):hr(e,t,n)}function hr(e,t,n){if(Hn(n))e.removeAttribute(t);else{if(q&&!W&&"TEXTAREA"===e.tagName&&"placeholder"===t&&""!==n&&!e.__ieph){var r=function(t){t.stopImmediatePropagation(),e.removeEventListener("input",r)};e.addEventListener("input",r),e.__ieph=!0}e.setAttribute(t,n)}}var mr={create:dr,update:dr};function yr(e,r){var i=r.elm,o=r.data,a=e.data;if(!(t(o.staticClass)&&t(o.class)&&(t(a)||t(a.staticClass)&&t(a.class)))){var s=Bn(r),c=i._transitionClasses;n(c)&&(s=zn(s,Vn(c))),s!==i._prevClass&&(i.setAttribute("class",s),i._prevClass=s)}}var gr,_r,br,$r,wr,Cr,xr={create:yr,update:yr},kr=/[\w).+\-_$\]]/;function Ar(e){var t,n,r,i,o,a=!1,s=!1,c=!1,u=!1,l=0,f=0,p=0,d=0;for(r=0;r<e.length;r++)if(n=t,t=e.charCodeAt(r),a)39===t&&92!==n&&(a=!1);else if(s)34===t&&92!==n&&(s=!1);else if(c)96===t&&92!==n&&(c=!1);else if(u)47===t&&92!==n&&(u=!1);else if(124!==t||124===e.charCodeAt(r+1)||124===e.charCodeAt(r-1)||l||f||p){switch(t){case 34:s=!0;break;case 39:a=!0;break;case 96:c=!0;break;case 40:p++;break;case 41:p--;break;case 91:f++;break;case 93:f--;break;case 123:l++;break;case 125:l--}if(47===t){for(var v=r-1,h=void 0;v>=0&&" "===(h=e.charAt(v));v--);h&&kr.test(h)||(u=!0)}}else void 0===i?(d=r+1,i=e.slice(0,r).trim()):m();function m(){(o||(o=[])).push(e.slice(d,r).trim()),d=r+1}if(void 0===i?i=e.slice(0,r).trim():0!==d&&m(),o)for(r=0;r<o.length;r++)i=Or(i,o[r]);return i}function Or(e,t){var n=t.indexOf("(");if(n<0)return'_f("'+t+'")('+e+")";var r=t.slice(0,n),i=t.slice(n+1);return'_f("'+r+'")('+e+(")"!==i?","+i:i)}function Sr(e,t){console.error("[Vue compiler]: "+e)}function Tr(e,t){return e?e.map(function(e){return e[t]}).filter(function(e){return e}):[]}function Er(e,t,n,r,i){(e.props||(e.props=[])).push(Rr({name:t,value:n,dynamic:i},r)),e.plain=!1}function Nr(e,t,n,r,i){(i?e.dynamicAttrs||(e.dynamicAttrs=[]):e.attrs||(e.attrs=[])).push(Rr({name:t,value:n,dynamic:i},r)),e.plain=!1}function jr(e,t,n,r){e.attrsMap[t]=n,e.attrsList.push(Rr({name:t,value:n},r))}function Dr(e,t,n,r,i,o,a,s){(e.directives||(e.directives=[])).push(Rr({name:t,rawName:n,value:r,arg:i,isDynamicArg:o,modifiers:a},s)),e.plain=!1}function Lr(e,t,n){return n?"_p("+t+',"'+e+'")':e+t}function Mr(t,n,r,i,o,a,s,c){var u;(i=i||e).right?c?n="("+n+")==='click'?'contextmenu':("+n+")":"click"===n&&(n="contextmenu",delete i.right):i.middle&&(c?n="("+n+")==='click'?'mouseup':("+n+")":"click"===n&&(n="mouseup")),i.capture&&(delete i.capture,n=Lr("!",n,c)),i.once&&(delete i.once,n=Lr("~",n,c)),i.passive&&(delete i.passive,n=Lr("&",n,c)),i.native?(delete i.native,u=t.nativeEvents||(t.nativeEvents={})):u=t.events||(t.events={});var l=Rr({value:r.trim(),dynamic:c},s);i!==e&&(l.modifiers=i);var f=u[n];Array.isArray(f)?o?f.unshift(l):f.push(l):u[n]=f?o?[l,f]:[f,l]:l,t.plain=!1}function Ir(e,t,n){var r=Fr(e,":"+t)||Fr(e,"v-bind:"+t);if(null!=r)return Ar(r);if(!1!==n){var i=Fr(e,t);if(null!=i)return JSON.stringify(i)}}function Fr(e,t,n){var r;if(null!=(r=e.attrsMap[t]))for(var i=e.attrsList,o=0,a=i.length;o<a;o++)if(i[o].name===t){i.splice(o,1);break}return n&&delete e.attrsMap[t],r}function Pr(e,t){for(var n=e.attrsList,r=0,i=n.length;r<i;r++){var o=n[r];if(t.test(o.name))return n.splice(r,1),o}}function Rr(e,t){return t&&(null!=t.start&&(e.start=t.start),null!=t.end&&(e.end=t.end)),e}function Hr(e,t,n){var r=n||{},i=r.number,o="$$v";r.trim&&(o="(typeof $$v === 'string'? $$v.trim(): $$v)"),i&&(o="_n("+o+")");var a=Br(t,o);e.model={value:"("+t+")",expression:JSON.stringify(t),callback:"function ($$v) {"+a+"}"}}function Br(e,t){var n=function(e){if(e=e.trim(),gr=e.length,e.indexOf("[")<0||e.lastIndexOf("]")<gr-1)return($r=e.lastIndexOf("."))>-1?{exp:e.slice(0,$r),key:'"'+e.slice($r+1)+'"'}:{exp:e,key:null};_r=e,$r=wr=Cr=0;for(;!zr();)Vr(br=Ur())?Jr(br):91===br&&Kr(br);return{exp:e.slice(0,wr),key:e.slice(wr+1,Cr)}}(e);return null===n.key?e+"="+t:"$set("+n.exp+", "+n.key+", "+t+")"}function Ur(){return _r.charCodeAt(++$r)}function zr(){return $r>=gr}function Vr(e){return 34===e||39===e}function Kr(e){var t=1;for(wr=$r;!zr();)if(Vr(e=Ur()))Jr(e);else if(91===e&&t++,93===e&&t--,0===t){Cr=$r;break}}function Jr(e){for(var t=e;!zr()&&(e=Ur())!==t;);}var qr,Wr="__r",Zr="__c";function Gr(e,t,n){var r=qr;return function i(){null!==t.apply(null,arguments)&&Qr(e,i,n,r)}}var Xr=Ve&&!(X&&Number(X[1])<=53);function Yr(e,t,n,r){if(Xr){var i=an,o=t;t=o._wrapper=function(e){if(e.target===e.currentTarget||e.timeStamp>=i||e.timeStamp<=0||e.target.ownerDocument!==document)return o.apply(this,arguments)}}qr.addEventListener(e,t,Q?{capture:n,passive:r}:n)}function Qr(e,t,n,r){(r||qr).removeEventListener(e,t._wrapper||t,n)}function ei(e,r){if(!t(e.data.on)||!t(r.data.on)){var i=r.data.on||{},o=e.data.on||{};qr=r.elm,function(e){if(n(e[Wr])){var t=q?"change":"input";e[t]=[].concat(e[Wr],e[t]||[]),delete e[Wr]}n(e[Zr])&&(e.change=[].concat(e[Zr],e.change||[]),delete e[Zr])}(i),rt(i,o,Yr,Qr,Gr,r.context),qr=void 0}}var ti,ni={create:ei,update:ei};function ri(e,r){if(!t(e.data.domProps)||!t(r.data.domProps)){var i,o,a=r.elm,s=e.data.domProps||{},c=r.data.domProps||{};for(i in n(c.__ob__)&&(c=r.data.domProps=A({},c)),s)i in c||(a[i]="");for(i in c){if(o=c[i],"textContent"===i||"innerHTML"===i){if(r.children&&(r.children.length=0),o===s[i])continue;1===a.childNodes.length&&a.removeChild(a.childNodes[0])}if("value"===i&&"PROGRESS"!==a.tagName){a._value=o;var u=t(o)?"":String(o);ii(a,u)&&(a.value=u)}else if("innerHTML"===i&&qn(a.tagName)&&t(a.innerHTML)){(ti=ti||document.createElement("div")).innerHTML="<svg>"+o+"</svg>";for(var l=ti.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;l.firstChild;)a.appendChild(l.firstChild)}else if(o!==s[i])try{a[i]=o}catch(e){}}}}function ii(e,t){return!e.composing&&("OPTION"===e.tagName||function(e,t){var n=!0;try{n=document.activeElement!==e}catch(e){}return n&&e.value!==t}(e,t)||function(e,t){var r=e.value,i=e._vModifiers;if(n(i)){if(i.number)return f(r)!==f(t);if(i.trim)return r.trim()!==t.trim()}return r!==t}(e,t))}var oi={create:ri,update:ri},ai=g(function(e){var t={},n=/:(.+)/;return e.split(/;(?![^(]*\))/g).forEach(function(e){if(e){var r=e.split(n);r.length>1&&(t[r[0].trim()]=r[1].trim())}}),t});function si(e){var t=ci(e.style);return e.staticStyle?A(e.staticStyle,t):t}function ci(e){return Array.isArray(e)?O(e):"string"==typeof e?ai(e):e}var ui,li=/^--/,fi=/\s*!important$/,pi=function(e,t,n){if(li.test(t))e.style.setProperty(t,n);else if(fi.test(n))e.style.setProperty(C(t),n.replace(fi,""),"important");else{var r=vi(t);if(Array.isArray(n))for(var i=0,o=n.length;i<o;i++)e.style[r]=n[i];else e.style[r]=n}},di=["Webkit","Moz","ms"],vi=g(function(e){if(ui=ui||document.createElement("div").style,"filter"!==(e=b(e))&&e in ui)return e;for(var t=e.charAt(0).toUpperCase()+e.slice(1),n=0;n<di.length;n++){var r=di[n]+t;if(r in ui)return r}});function hi(e,r){var i=r.data,o=e.data;if(!(t(i.staticStyle)&&t(i.style)&&t(o.staticStyle)&&t(o.style))){var a,s,c=r.elm,u=o.staticStyle,l=o.normalizedStyle||o.style||{},f=u||l,p=ci(r.data.style)||{};r.data.normalizedStyle=n(p.__ob__)?A({},p):p;var d=function(e,t){var n,r={};if(t)for(var i=e;i.componentInstance;)(i=i.componentInstance._vnode)&&i.data&&(n=si(i.data))&&A(r,n);(n=si(e.data))&&A(r,n);for(var o=e;o=o.parent;)o.data&&(n=si(o.data))&&A(r,n);return r}(r,!0);for(s in f)t(d[s])&&pi(c,s,"");for(s in d)(a=d[s])!==f[s]&&pi(c,s,null==a?"":a)}}var mi={create:hi,update:hi},yi=/\s+/;function gi(e,t){if(t&&(t=t.trim()))if(e.classList)t.indexOf(" ")>-1?t.split(yi).forEach(function(t){return e.classList.add(t)}):e.classList.add(t);else{var n=" "+(e.getAttribute("class")||"")+" ";n.indexOf(" "+t+" ")<0&&e.setAttribute("class",(n+t).trim())}}function _i(e,t){if(t&&(t=t.trim()))if(e.classList)t.indexOf(" ")>-1?t.split(yi).forEach(function(t){return e.classList.remove(t)}):e.classList.remove(t),e.classList.length||e.removeAttribute("class");else{for(var n=" "+(e.getAttribute("class")||"")+" ",r=" "+t+" ";n.indexOf(r)>=0;)n=n.replace(r," ");(n=n.trim())?e.setAttribute("class",n):e.removeAttribute("class")}}function bi(e){if(e){if("object"==typeof e){var t={};return!1!==e.css&&A(t,$i(e.name||"v")),A(t,e),t}return"string"==typeof e?$i(e):void 0}}var $i=g(function(e){return{enterClass:e+"-enter",enterToClass:e+"-enter-to",enterActiveClass:e+"-enter-active",leaveClass:e+"-leave",leaveToClass:e+"-leave-to",leaveActiveClass:e+"-leave-active"}}),wi=z&&!W,Ci="transition",xi="animation",ki="transition",Ai="transitionend",Oi="animation",Si="animationend";wi&&(void 0===window.ontransitionend&&void 0!==window.onwebkittransitionend&&(ki="WebkitTransition",Ai="webkitTransitionEnd"),void 0===window.onanimationend&&void 0!==window.onwebkitanimationend&&(Oi="WebkitAnimation",Si="webkitAnimationEnd"));var Ti=z?window.requestAnimationFrame?window.requestAnimationFrame.bind(window):setTimeout:function(e){return e()};function Ei(e){Ti(function(){Ti(e)})}function Ni(e,t){var n=e._transitionClasses||(e._transitionClasses=[]);n.indexOf(t)<0&&(n.push(t),gi(e,t))}function ji(e,t){e._transitionClasses&&h(e._transitionClasses,t),_i(e,t)}function Di(e,t,n){var r=Mi(e,t),i=r.type,o=r.timeout,a=r.propCount;if(!i)return n();var s=i===Ci?Ai:Si,c=0,u=function(){e.removeEventListener(s,l),n()},l=function(t){t.target===e&&++c>=a&&u()};setTimeout(function(){c<a&&u()},o+1),e.addEventListener(s,l)}var Li=/\b(transform|all)(,|$)/;function Mi(e,t){var n,r=window.getComputedStyle(e),i=(r[ki+"Delay"]||"").split(", "),o=(r[ki+"Duration"]||"").split(", "),a=Ii(i,o),s=(r[Oi+"Delay"]||"").split(", "),c=(r[Oi+"Duration"]||"").split(", "),u=Ii(s,c),l=0,f=0;return t===Ci?a>0&&(n=Ci,l=a,f=o.length):t===xi?u>0&&(n=xi,l=u,f=c.length):f=(n=(l=Math.max(a,u))>0?a>u?Ci:xi:null)?n===Ci?o.length:c.length:0,{type:n,timeout:l,propCount:f,hasTransform:n===Ci&&Li.test(r[ki+"Property"])}}function Ii(e,t){for(;e.length<t.length;)e=e.concat(e);return Math.max.apply(null,t.map(function(t,n){return Fi(t)+Fi(e[n])}))}function Fi(e){return 1e3*Number(e.slice(0,-1).replace(",","."))}function Pi(e,r){var i=e.elm;n(i._leaveCb)&&(i._leaveCb.cancelled=!0,i._leaveCb());var a=bi(e.data.transition);if(!t(a)&&!n(i._enterCb)&&1===i.nodeType){for(var s=a.css,c=a.type,u=a.enterClass,l=a.enterToClass,p=a.enterActiveClass,d=a.appearClass,v=a.appearToClass,h=a.appearActiveClass,m=a.beforeEnter,y=a.enter,g=a.afterEnter,_=a.enterCancelled,b=a.beforeAppear,$=a.appear,w=a.afterAppear,C=a.appearCancelled,x=a.duration,k=Wt,A=Wt.$vnode;A&&A.parent;)k=A.context,A=A.parent;var O=!k._isMounted||!e.isRootInsert;if(!O||$||""===$){var S=O&&d?d:u,T=O&&h?h:p,E=O&&v?v:l,N=O&&b||m,j=O&&"function"==typeof $?$:y,L=O&&w||g,M=O&&C||_,I=f(o(x)?x.enter:x),F=!1!==s&&!W,P=Bi(j),R=i._enterCb=D(function(){F&&(ji(i,E),ji(i,T)),R.cancelled?(F&&ji(i,S),M&&M(i)):L&&L(i),i._enterCb=null});e.data.show||it(e,"insert",function(){var t=i.parentNode,n=t&&t._pending&&t._pending[e.key];n&&n.tag===e.tag&&n.elm._leaveCb&&n.elm._leaveCb(),j&&j(i,R)}),N&&N(i),F&&(Ni(i,S),Ni(i,T),Ei(function(){ji(i,S),R.cancelled||(Ni(i,E),P||(Hi(I)?setTimeout(R,I):Di(i,c,R)))})),e.data.show&&(r&&r(),j&&j(i,R)),F||P||R()}}}function Ri(e,r){var i=e.elm;n(i._enterCb)&&(i._enterCb.cancelled=!0,i._enterCb());var a=bi(e.data.transition);if(t(a)||1!==i.nodeType)return r();if(!n(i._leaveCb)){var s=a.css,c=a.type,u=a.leaveClass,l=a.leaveToClass,p=a.leaveActiveClass,d=a.beforeLeave,v=a.leave,h=a.afterLeave,m=a.leaveCancelled,y=a.delayLeave,g=a.duration,_=!1!==s&&!W,b=Bi(v),$=f(o(g)?g.leave:g),w=i._leaveCb=D(function(){i.parentNode&&i.parentNode._pending&&(i.parentNode._pending[e.key]=null),_&&(ji(i,l),ji(i,p)),w.cancelled?(_&&ji(i,u),m&&m(i)):(r(),h&&h(i)),i._leaveCb=null});y?y(C):C()}function C(){w.cancelled||(!e.data.show&&i.parentNode&&((i.parentNode._pending||(i.parentNode._pending={}))[e.key]=e),d&&d(i),_&&(Ni(i,u),Ni(i,p),Ei(function(){ji(i,u),w.cancelled||(Ni(i,l),b||(Hi($)?setTimeout(w,$):Di(i,c,w)))})),v&&v(i,w),_||b||w())}}function Hi(e){return"number"==typeof e&&!isNaN(e)}function Bi(e){if(t(e))return!1;var r=e.fns;return n(r)?Bi(Array.isArray(r)?r[0]:r):(e._length||e.length)>1}function Ui(e,t){!0!==t.data.show&&Pi(t)}var zi=function(e){var o,a,s={},c=e.modules,u=e.nodeOps;for(o=0;o<rr.length;++o)for(s[rr[o]]=[],a=0;a<c.length;++a)n(c[a][rr[o]])&&s[rr[o]].push(c[a][rr[o]]);function l(e){var t=u.parentNode(e);n(t)&&u.removeChild(t,e)}function f(e,t,i,o,a,c,l){if(n(e.elm)&&n(c)&&(e=c[l]=me(e)),e.isRootInsert=!a,!function(e,t,i,o){var a=e.data;if(n(a)){var c=n(e.componentInstance)&&a.keepAlive;if(n(a=a.hook)&&n(a=a.init)&&a(e,!1),n(e.componentInstance))return d(e,t),v(i,e.elm,o),r(c)&&function(e,t,r,i){for(var o,a=e;a.componentInstance;)if(a=a.componentInstance._vnode,n(o=a.data)&&n(o=o.transition)){for(o=0;o<s.activate.length;++o)s.activate[o](nr,a);t.push(a);break}v(r,e.elm,i)}(e,t,i,o),!0}}(e,t,i,o)){var f=e.data,p=e.children,m=e.tag;n(m)?(e.elm=e.ns?u.createElementNS(e.ns,m):u.createElement(m,e),g(e),h(e,p,t),n(f)&&y(e,t),v(i,e.elm,o)):r(e.isComment)?(e.elm=u.createComment(e.text),v(i,e.elm,o)):(e.elm=u.createTextNode(e.text),v(i,e.elm,o))}}function d(e,t){n(e.data.pendingInsert)&&(t.push.apply(t,e.data.pendingInsert),e.data.pendingInsert=null),e.elm=e.componentInstance.$el,m(e)?(y(e,t),g(e)):(tr(e),t.push(e))}function v(e,t,r){n(e)&&(n(r)?u.parentNode(r)===e&&u.insertBefore(e,t,r):u.appendChild(e,t))}function h(e,t,n){if(Array.isArray(t))for(var r=0;r<t.length;++r)f(t[r],n,e.elm,null,!0,t,r);else i(e.text)&&u.appendChild(e.elm,u.createTextNode(String(e.text)))}function m(e){for(;e.componentInstance;)e=e.componentInstance._vnode;return n(e.tag)}function y(e,t){for(var r=0;r<s.create.length;++r)s.create[r](nr,e);n(o=e.data.hook)&&(n(o.create)&&o.create(nr,e),n(o.insert)&&t.push(e))}function g(e){var t;if(n(t=e.fnScopeId))u.setStyleScope(e.elm,t);else for(var r=e;r;)n(t=r.context)&&n(t=t.$options._scopeId)&&u.setStyleScope(e.elm,t),r=r.parent;n(t=Wt)&&t!==e.context&&t!==e.fnContext&&n(t=t.$options._scopeId)&&u.setStyleScope(e.elm,t)}function _(e,t,n,r,i,o){for(;r<=i;++r)f(n[r],o,e,t,!1,n,r)}function b(e){var t,r,i=e.data;if(n(i))for(n(t=i.hook)&&n(t=t.destroy)&&t(e),t=0;t<s.destroy.length;++t)s.destroy[t](e);if(n(t=e.children))for(r=0;r<e.children.length;++r)b(e.children[r])}function $(e,t,r){for(;t<=r;++t){var i=e[t];n(i)&&(n(i.tag)?(w(i),b(i)):l(i.elm))}}function w(e,t){if(n(t)||n(e.data)){var r,i=s.remove.length+1;for(n(t)?t.listeners+=i:t=function(e,t){function n(){0==--n.listeners&&l(e)}return n.listeners=t,n}(e.elm,i),n(r=e.componentInstance)&&n(r=r._vnode)&&n(r.data)&&w(r,t),r=0;r<s.remove.length;++r)s.remove[r](e,t);n(r=e.data.hook)&&n(r=r.remove)?r(e,t):t()}else l(e.elm)}function C(e,t,r,i){for(var o=r;o<i;o++){var a=t[o];if(n(a)&&ir(e,a))return o}}function x(e,i,o,a,c,l){if(e!==i){n(i.elm)&&n(a)&&(i=a[c]=me(i));var p=i.elm=e.elm;if(r(e.isAsyncPlaceholder))n(i.asyncFactory.resolved)?O(e.elm,i,o):i.isAsyncPlaceholder=!0;else if(r(i.isStatic)&&r(e.isStatic)&&i.key===e.key&&(r(i.isCloned)||r(i.isOnce)))i.componentInstance=e.componentInstance;else{var d,v=i.data;n(v)&&n(d=v.hook)&&n(d=d.prepatch)&&d(e,i);var h=e.children,y=i.children;if(n(v)&&m(i)){for(d=0;d<s.update.length;++d)s.update[d](e,i);n(d=v.hook)&&n(d=d.update)&&d(e,i)}t(i.text)?n(h)&&n(y)?h!==y&&function(e,r,i,o,a){for(var s,c,l,p=0,d=0,v=r.length-1,h=r[0],m=r[v],y=i.length-1,g=i[0],b=i[y],w=!a;p<=v&&d<=y;)t(h)?h=r[++p]:t(m)?m=r[--v]:ir(h,g)?(x(h,g,o,i,d),h=r[++p],g=i[++d]):ir(m,b)?(x(m,b,o,i,y),m=r[--v],b=i[--y]):ir(h,b)?(x(h,b,o,i,y),w&&u.insertBefore(e,h.elm,u.nextSibling(m.elm)),h=r[++p],b=i[--y]):ir(m,g)?(x(m,g,o,i,d),w&&u.insertBefore(e,m.elm,h.elm),m=r[--v],g=i[++d]):(t(s)&&(s=or(r,p,v)),t(c=n(g.key)?s[g.key]:C(g,r,p,v))?f(g,o,e,h.elm,!1,i,d):ir(l=r[c],g)?(x(l,g,o,i,d),r[c]=void 0,w&&u.insertBefore(e,l.elm,h.elm)):f(g,o,e,h.elm,!1,i,d),g=i[++d]);p>v?_(e,t(i[y+1])?null:i[y+1].elm,i,d,y,o):d>y&&$(r,p,v)}(p,h,y,o,l):n(y)?(n(e.text)&&u.setTextContent(p,""),_(p,null,y,0,y.length-1,o)):n(h)?$(h,0,h.length-1):n(e.text)&&u.setTextContent(p,""):e.text!==i.text&&u.setTextContent(p,i.text),n(v)&&n(d=v.hook)&&n(d=d.postpatch)&&d(e,i)}}}function k(e,t,i){if(r(i)&&n(e.parent))e.parent.data.pendingInsert=t;else for(var o=0;o<t.length;++o)t[o].data.hook.insert(t[o])}var A=p("attrs,class,staticClass,staticStyle,key");function O(e,t,i,o){var a,s=t.tag,c=t.data,u=t.children;if(o=o||c&&c.pre,t.elm=e,r(t.isComment)&&n(t.asyncFactory))return t.isAsyncPlaceholder=!0,!0;if(n(c)&&(n(a=c.hook)&&n(a=a.init)&&a(t,!0),n(a=t.componentInstance)))return d(t,i),!0;if(n(s)){if(n(u))if(e.hasChildNodes())if(n(a=c)&&n(a=a.domProps)&&n(a=a.innerHTML)){if(a!==e.innerHTML)return!1}else{for(var l=!0,f=e.firstChild,p=0;p<u.length;p++){if(!f||!O(f,u[p],i,o)){l=!1;break}f=f.nextSibling}if(!l||f)return!1}else h(t,u,i);if(n(c)){var v=!1;for(var m in c)if(!A(m)){v=!0,y(t,i);break}!v&&c.class&&et(c.class)}}else e.data!==t.text&&(e.data=t.text);return!0}return function(e,i,o,a){if(!t(i)){var c,l=!1,p=[];if(t(e))l=!0,f(i,p);else{var d=n(e.nodeType);if(!d&&ir(e,i))x(e,i,p,null,null,a);else{if(d){if(1===e.nodeType&&e.hasAttribute(L)&&(e.removeAttribute(L),o=!0),r(o)&&O(e,i,p))return k(i,p,!0),e;c=e,e=new pe(u.tagName(c).toLowerCase(),{},[],void 0,c)}var v=e.elm,h=u.parentNode(v);if(f(i,p,v._leaveCb?null:h,u.nextSibling(v)),n(i.parent))for(var y=i.parent,g=m(i);y;){for(var _=0;_<s.destroy.length;++_)s.destroy[_](y);if(y.elm=i.elm,g){for(var w=0;w<s.create.length;++w)s.create[w](nr,y);var C=y.data.hook.insert;if(C.merged)for(var A=1;A<C.fns.length;A++)C.fns[A]()}else tr(y);y=y.parent}n(h)?$([e],0,0):n(e.tag)&&b(e)}}return k(i,p,l),i.elm}n(e)&&b(e)}}({nodeOps:Qn,modules:[mr,xr,ni,oi,mi,z?{create:Ui,activate:Ui,remove:function(e,t){!0!==e.data.show?Ri(e,t):t()}}:{}].concat(pr)});W&&document.addEventListener("selectionchange",function(){var e=document.activeElement;e&&e.vmodel&&Xi(e,"input")});var Vi={inserted:function(e,t,n,r){"select"===n.tag?(r.elm&&!r.elm._vOptions?it(n,"postpatch",function(){Vi.componentUpdated(e,t,n)}):Ki(e,t,n.context),e._vOptions=[].map.call(e.options,Wi)):("textarea"===n.tag||Xn(e.type))&&(e._vModifiers=t.modifiers,t.modifiers.lazy||(e.addEventListener("compositionstart",Zi),e.addEventListener("compositionend",Gi),e.addEventListener("change",Gi),W&&(e.vmodel=!0)))},componentUpdated:function(e,t,n){if("select"===n.tag){Ki(e,t,n.context);var r=e._vOptions,i=e._vOptions=[].map.call(e.options,Wi);if(i.some(function(e,t){return!N(e,r[t])}))(e.multiple?t.value.some(function(e){return qi(e,i)}):t.value!==t.oldValue&&qi(t.value,i))&&Xi(e,"change")}}};function Ki(e,t,n){Ji(e,t,n),(q||Z)&&setTimeout(function(){Ji(e,t,n)},0)}function Ji(e,t,n){var r=t.value,i=e.multiple;if(!i||Array.isArray(r)){for(var o,a,s=0,c=e.options.length;s<c;s++)if(a=e.options[s],i)o=j(r,Wi(a))>-1,a.selected!==o&&(a.selected=o);else if(N(Wi(a),r))return void(e.selectedIndex!==s&&(e.selectedIndex=s));i||(e.selectedIndex=-1)}}function qi(e,t){return t.every(function(t){return!N(t,e)})}function Wi(e){return"_value"in e?e._value:e.value}function Zi(e){e.target.composing=!0}function Gi(e){e.target.composing&&(e.target.composing=!1,Xi(e.target,"input"))}function Xi(e,t){var n=document.createEvent("HTMLEvents");n.initEvent(t,!0,!0),e.dispatchEvent(n)}function Yi(e){return!e.componentInstance||e.data&&e.data.transition?e:Yi(e.componentInstance._vnode)}var Qi={model:Vi,show:{bind:function(e,t,n){var r=t.value,i=(n=Yi(n)).data&&n.data.transition,o=e.__vOriginalDisplay="none"===e.style.display?"":e.style.display;r&&i?(n.data.show=!0,Pi(n,function(){e.style.display=o})):e.style.display=r?o:"none"},update:function(e,t,n){var r=t.value;!r!=!t.oldValue&&((n=Yi(n)).data&&n.data.transition?(n.data.show=!0,r?Pi(n,function(){e.style.display=e.__vOriginalDisplay}):Ri(n,function(){e.style.display="none"})):e.style.display=r?e.__vOriginalDisplay:"none")},unbind:function(e,t,n,r,i){i||(e.style.display=e.__vOriginalDisplay)}}},eo={name:String,appear:Boolean,css:Boolean,mode:String,type:String,enterClass:String,leaveClass:String,enterToClass:String,leaveToClass:String,enterActiveClass:String,leaveActiveClass:String,appearClass:String,appearActiveClass:String,appearToClass:String,duration:[Number,String,Object]};function to(e){var t=e&&e.componentOptions;return t&&t.Ctor.options.abstract?to(zt(t.children)):e}function no(e){var t={},n=e.$options;for(var r in n.propsData)t[r]=e[r];var i=n._parentListeners;for(var o in i)t[b(o)]=i[o];return t}function ro(e,t){if(/\d-keep-alive$/.test(t.tag))return e("keep-alive",{props:t.componentOptions.propsData})}var io=function(e){return e.tag||Ut(e)},oo=function(e){return"show"===e.name},ao={name:"transition",props:eo,abstract:!0,render:function(e){var t=this,n=this.$slots.default;if(n&&(n=n.filter(io)).length){var r=this.mode,o=n[0];if(function(e){for(;e=e.parent;)if(e.data.transition)return!0}(this.$vnode))return o;var a=to(o);if(!a)return o;if(this._leaving)return ro(e,o);var s="__transition-"+this._uid+"-";a.key=null==a.key?a.isComment?s+"comment":s+a.tag:i(a.key)?0===String(a.key).indexOf(s)?a.key:s+a.key:a.key;var c=(a.data||(a.data={})).transition=no(this),u=this._vnode,l=to(u);if(a.data.directives&&a.data.directives.some(oo)&&(a.data.show=!0),l&&l.data&&!function(e,t){return t.key===e.key&&t.tag===e.tag}(a,l)&&!Ut(l)&&(!l.componentInstance||!l.componentInstance._vnode.isComment)){var f=l.data.transition=A({},c);if("out-in"===r)return this._leaving=!0,it(f,"afterLeave",function(){t._leaving=!1,t.$forceUpdate()}),ro(e,o);if("in-out"===r){if(Ut(a))return u;var p,d=function(){p()};it(c,"afterEnter",d),it(c,"enterCancelled",d),it(f,"delayLeave",function(e){p=e})}}return o}}},so=A({tag:String,moveClass:String},eo);function co(e){e.elm._moveCb&&e.elm._moveCb(),e.elm._enterCb&&e.elm._enterCb()}function uo(e){e.data.newPos=e.elm.getBoundingClientRect()}function lo(e){var t=e.data.pos,n=e.data.newPos,r=t.left-n.left,i=t.top-n.top;if(r||i){e.data.moved=!0;var o=e.elm.style;o.transform=o.WebkitTransform="translate("+r+"px,"+i+"px)",o.transitionDuration="0s"}}delete so.mode;var fo={Transition:ao,TransitionGroup:{props:so,beforeMount:function(){var e=this,t=this._update;this._update=function(n,r){var i=Zt(e);e.__patch__(e._vnode,e.kept,!1,!0),e._vnode=e.kept,i(),t.call(e,n,r)}},render:function(e){for(var t=this.tag||this.$vnode.data.tag||"span",n=Object.create(null),r=this.prevChildren=this.children,i=this.$slots.default||[],o=this.children=[],a=no(this),s=0;s<i.length;s++){var c=i[s];c.tag&&null!=c.key&&0!==String(c.key).indexOf("__vlist")&&(o.push(c),n[c.key]=c,(c.data||(c.data={})).transition=a)}if(r){for(var u=[],l=[],f=0;f<r.length;f++){var p=r[f];p.data.transition=a,p.data.pos=p.elm.getBoundingClientRect(),n[p.key]?u.push(p):l.push(p)}this.kept=e(t,null,u),this.removed=l}return e(t,null,o)},updated:function(){var e=this.prevChildren,t=this.moveClass||(this.name||"v")+"-move";e.length&&this.hasMove(e[0].elm,t)&&(e.forEach(co),e.forEach(uo),e.forEach(lo),this._reflow=document.body.offsetHeight,e.forEach(function(e){if(e.data.moved){var n=e.elm,r=n.style;Ni(n,t),r.transform=r.WebkitTransform=r.transitionDuration="",n.addEventListener(Ai,n._moveCb=function e(r){r&&r.target!==n||r&&!/transform$/.test(r.propertyName)||(n.removeEventListener(Ai,e),n._moveCb=null,ji(n,t))})}}))},methods:{hasMove:function(e,t){if(!wi)return!1;if(this._hasMove)return this._hasMove;var n=e.cloneNode();e._transitionClasses&&e._transitionClasses.forEach(function(e){_i(n,e)}),gi(n,t),n.style.display="none",this.$el.appendChild(n);var r=Mi(n);return this.$el.removeChild(n),this._hasMove=r.hasTransform}}}};wn.config.mustUseProp=jn,wn.config.isReservedTag=Wn,wn.config.isReservedAttr=En,wn.config.getTagNamespace=Zn,wn.config.isUnknownElement=function(e){if(!z)return!0;if(Wn(e))return!1;if(e=e.toLowerCase(),null!=Gn[e])return Gn[e];var t=document.createElement(e);return e.indexOf("-")>-1?Gn[e]=t.constructor===window.HTMLUnknownElement||t.constructor===window.HTMLElement:Gn[e]=/HTMLUnknownElement/.test(t.toString())},A(wn.options.directives,Qi),A(wn.options.components,fo),wn.prototype.__patch__=z?zi:S,wn.prototype.$mount=function(e,t){return function(e,t,n){var r;return e.$el=t,e.$options.render||(e.$options.render=ve),Yt(e,"beforeMount"),r=function(){e._update(e._render(),n)},new fn(e,r,S,{before:function(){e._isMounted&&!e._isDestroyed&&Yt(e,"beforeUpdate")}},!0),n=!1,null==e.$vnode&&(e._isMounted=!0,Yt(e,"mounted")),e}(this,e=e&&z?Yn(e):void 0,t)},z&&setTimeout(function(){F.devtools&&ne&&ne.emit("init",wn)},0);var po=/\{\{((?:.|\r?\n)+?)\}\}/g,vo=/[-.*+?^${}()|[\]\/\\]/g,ho=g(function(e){var t=e[0].replace(vo,"\\$&"),n=e[1].replace(vo,"\\$&");return new RegExp(t+"((?:.|\\n)+?)"+n,"g")});var mo={staticKeys:["staticClass"],transformNode:function(e,t){t.warn;var n=Fr(e,"class");n&&(e.staticClass=JSON.stringify(n));var r=Ir(e,"class",!1);r&&(e.classBinding=r)},genData:function(e){var t="";return e.staticClass&&(t+="staticClass:"+e.staticClass+","),e.classBinding&&(t+="class:"+e.classBinding+","),t}};var yo,go={staticKeys:["staticStyle"],transformNode:function(e,t){t.warn;var n=Fr(e,"style");n&&(e.staticStyle=JSON.stringify(ai(n)));var r=Ir(e,"style",!1);r&&(e.styleBinding=r)},genData:function(e){var t="";return e.staticStyle&&(t+="staticStyle:"+e.staticStyle+","),e.styleBinding&&(t+="style:("+e.styleBinding+"),"),t}},_o=function(e){return(yo=yo||document.createElement("div")).innerHTML=e,yo.textContent},bo=p("area,base,br,col,embed,frame,hr,img,input,isindex,keygen,link,meta,param,source,track,wbr"),$o=p("colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source"),wo=p("address,article,aside,base,blockquote,body,caption,col,colgroup,dd,details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,title,tr,track"),Co=/^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/,xo=/^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/,ko="[a-zA-Z_][\\-\\.0-9_a-zA-Z"+P.source+"]*",Ao="((?:"+ko+"\\:)?"+ko+")",Oo=new RegExp("^<"+Ao),So=/^\s*(\/?)>/,To=new RegExp("^<\\/"+Ao+"[^>]*>"),Eo=/^<!DOCTYPE [^>]+>/i,No=/^<!\--/,jo=/^<!\[/,Do=p("script,style,textarea",!0),Lo={},Mo={"&lt;":"<","&gt;":">","&quot;":'"',"&amp;":"&","&#10;":"\n","&#9;":"\t","&#39;":"'"},Io=/&(?:lt|gt|quot|amp|#39);/g,Fo=/&(?:lt|gt|quot|amp|#39|#10|#9);/g,Po=p("pre,textarea",!0),Ro=function(e,t){return e&&Po(e)&&"\n"===t[0]};function Ho(e,t){var n=t?Fo:Io;return e.replace(n,function(e){return Mo[e]})}var Bo,Uo,zo,Vo,Ko,Jo,qo,Wo,Zo=/^@|^v-on:/,Go=/^v-|^@|^:|^#/,Xo=/([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/,Yo=/,([^,\}\]]*)(?:,([^,\}\]]*))?$/,Qo=/^\(|\)$/g,ea=/^\[.*\]$/,ta=/:(.*)$/,na=/^:|^\.|^v-bind:/,ra=/\.[^.\]]+(?=[^\]]*$)/g,ia=/^v-slot(:|$)|^#/,oa=/[\r\n]/,aa=/\s+/g,sa=g(_o),ca="_empty_";function ua(e,t,n){return{type:1,tag:e,attrsList:t,attrsMap:ma(t),rawAttrsMap:{},parent:n,children:[]}}function la(e,t){Bo=t.warn||Sr,Jo=t.isPreTag||T,qo=t.mustUseProp||T,Wo=t.getTagNamespace||T;t.isReservedTag;zo=Tr(t.modules,"transformNode"),Vo=Tr(t.modules,"preTransformNode"),Ko=Tr(t.modules,"postTransformNode"),Uo=t.delimiters;var n,r,i=[],o=!1!==t.preserveWhitespace,a=t.whitespace,s=!1,c=!1;function u(e){if(l(e),s||e.processed||(e=fa(e,t)),i.length||e===n||n.if&&(e.elseif||e.else)&&da(n,{exp:e.elseif,block:e}),r&&!e.forbidden)if(e.elseif||e.else)a=e,(u=function(e){var t=e.length;for(;t--;){if(1===e[t].type)return e[t];e.pop()}}(r.children))&&u.if&&da(u,{exp:a.elseif,block:a});else{if(e.slotScope){var o=e.slotTarget||'"default"';(r.scopedSlots||(r.scopedSlots={}))[o]=e}r.children.push(e),e.parent=r}var a,u;e.children=e.children.filter(function(e){return!e.slotScope}),l(e),e.pre&&(s=!1),Jo(e.tag)&&(c=!1);for(var f=0;f<Ko.length;f++)Ko[f](e,t)}function l(e){if(!c)for(var t;(t=e.children[e.children.length-1])&&3===t.type&&" "===t.text;)e.children.pop()}return function(e,t){for(var n,r,i=[],o=t.expectHTML,a=t.isUnaryTag||T,s=t.canBeLeftOpenTag||T,c=0;e;){if(n=e,r&&Do(r)){var u=0,l=r.toLowerCase(),f=Lo[l]||(Lo[l]=new RegExp("([\\s\\S]*?)(</"+l+"[^>]*>)","i")),p=e.replace(f,function(e,n,r){return u=r.length,Do(l)||"noscript"===l||(n=n.replace(/<!\--([\s\S]*?)-->/g,"$1").replace(/<!\[CDATA\[([\s\S]*?)]]>/g,"$1")),Ro(l,n)&&(n=n.slice(1)),t.chars&&t.chars(n),""});c+=e.length-p.length,e=p,A(l,c-u,c)}else{var d=e.indexOf("<");if(0===d){if(No.test(e)){var v=e.indexOf("--\x3e");if(v>=0){t.shouldKeepComment&&t.comment(e.substring(4,v),c,c+v+3),C(v+3);continue}}if(jo.test(e)){var h=e.indexOf("]>");if(h>=0){C(h+2);continue}}var m=e.match(Eo);if(m){C(m[0].length);continue}var y=e.match(To);if(y){var g=c;C(y[0].length),A(y[1],g,c);continue}var _=x();if(_){k(_),Ro(_.tagName,e)&&C(1);continue}}var b=void 0,$=void 0,w=void 0;if(d>=0){for($=e.slice(d);!(To.test($)||Oo.test($)||No.test($)||jo.test($)||(w=$.indexOf("<",1))<0);)d+=w,$=e.slice(d);b=e.substring(0,d)}d<0&&(b=e),b&&C(b.length),t.chars&&b&&t.chars(b,c-b.length,c)}if(e===n){t.chars&&t.chars(e);break}}function C(t){c+=t,e=e.substring(t)}function x(){var t=e.match(Oo);if(t){var n,r,i={tagName:t[1],attrs:[],start:c};for(C(t[0].length);!(n=e.match(So))&&(r=e.match(xo)||e.match(Co));)r.start=c,C(r[0].length),r.end=c,i.attrs.push(r);if(n)return i.unarySlash=n[1],C(n[0].length),i.end=c,i}}function k(e){var n=e.tagName,c=e.unarySlash;o&&("p"===r&&wo(n)&&A(r),s(n)&&r===n&&A(n));for(var u=a(n)||!!c,l=e.attrs.length,f=new Array(l),p=0;p<l;p++){var d=e.attrs[p],v=d[3]||d[4]||d[5]||"",h="a"===n&&"href"===d[1]?t.shouldDecodeNewlinesForHref:t.shouldDecodeNewlines;f[p]={name:d[1],value:Ho(v,h)}}u||(i.push({tag:n,lowerCasedTag:n.toLowerCase(),attrs:f,start:e.start,end:e.end}),r=n),t.start&&t.start(n,f,u,e.start,e.end)}function A(e,n,o){var a,s;if(null==n&&(n=c),null==o&&(o=c),e)for(s=e.toLowerCase(),a=i.length-1;a>=0&&i[a].lowerCasedTag!==s;a--);else a=0;if(a>=0){for(var u=i.length-1;u>=a;u--)t.end&&t.end(i[u].tag,n,o);i.length=a,r=a&&i[a-1].tag}else"br"===s?t.start&&t.start(e,[],!0,n,o):"p"===s&&(t.start&&t.start(e,[],!1,n,o),t.end&&t.end(e,n,o))}A()}(e,{warn:Bo,expectHTML:t.expectHTML,isUnaryTag:t.isUnaryTag,canBeLeftOpenTag:t.canBeLeftOpenTag,shouldDecodeNewlines:t.shouldDecodeNewlines,shouldDecodeNewlinesForHref:t.shouldDecodeNewlinesForHref,shouldKeepComment:t.comments,outputSourceRange:t.outputSourceRange,start:function(e,o,a,l,f){var p=r&&r.ns||Wo(e);q&&"svg"===p&&(o=function(e){for(var t=[],n=0;n<e.length;n++){var r=e[n];ya.test(r.name)||(r.name=r.name.replace(ga,""),t.push(r))}return t}(o));var d,v=ua(e,o,r);p&&(v.ns=p),"style"!==(d=v).tag&&("script"!==d.tag||d.attrsMap.type&&"text/javascript"!==d.attrsMap.type)||te()||(v.forbidden=!0);for(var h=0;h<Vo.length;h++)v=Vo[h](v,t)||v;s||(!function(e){null!=Fr(e,"v-pre")&&(e.pre=!0)}(v),v.pre&&(s=!0)),Jo(v.tag)&&(c=!0),s?function(e){var t=e.attrsList,n=t.length;if(n)for(var r=e.attrs=new Array(n),i=0;i<n;i++)r[i]={name:t[i].name,value:JSON.stringify(t[i].value)},null!=t[i].start&&(r[i].start=t[i].start,r[i].end=t[i].end);else e.pre||(e.plain=!0)}(v):v.processed||(pa(v),function(e){var t=Fr(e,"v-if");if(t)e.if=t,da(e,{exp:t,block:e});else{null!=Fr(e,"v-else")&&(e.else=!0);var n=Fr(e,"v-else-if");n&&(e.elseif=n)}}(v),function(e){null!=Fr(e,"v-once")&&(e.once=!0)}(v)),n||(n=v),a?u(v):(r=v,i.push(v))},end:function(e,t,n){var o=i[i.length-1];i.length-=1,r=i[i.length-1],u(o)},chars:function(e,t,n){if(r&&(!q||"textarea"!==r.tag||r.attrsMap.placeholder!==e)){var i,u,l,f=r.children;if(e=c||e.trim()?"script"===(i=r).tag||"style"===i.tag?e:sa(e):f.length?a?"condense"===a&&oa.test(e)?"":" ":o?" ":"":"")c||"condense"!==a||(e=e.replace(aa," ")),!s&&" "!==e&&(u=function(e,t){var n=t?ho(t):po;if(n.test(e)){for(var r,i,o,a=[],s=[],c=n.lastIndex=0;r=n.exec(e);){(i=r.index)>c&&(s.push(o=e.slice(c,i)),a.push(JSON.stringify(o)));var u=Ar(r[1].trim());a.push("_s("+u+")"),s.push({"@binding":u}),c=i+r[0].length}return c<e.length&&(s.push(o=e.slice(c)),a.push(JSON.stringify(o))),{expression:a.join("+"),tokens:s}}}(e,Uo))?l={type:2,expression:u.expression,tokens:u.tokens,text:e}:" "===e&&f.length&&" "===f[f.length-1].text||(l={type:3,text:e}),l&&f.push(l)}},comment:function(e,t,n){if(r){var i={type:3,text:e,isComment:!0};r.children.push(i)}}}),n}function fa(e,t){var n,r;(r=Ir(n=e,"key"))&&(n.key=r),e.plain=!e.key&&!e.scopedSlots&&!e.attrsList.length,function(e){var t=Ir(e,"ref");t&&(e.ref=t,e.refInFor=function(e){var t=e;for(;t;){if(void 0!==t.for)return!0;t=t.parent}return!1}(e))}(e),function(e){var t;"template"===e.tag?(t=Fr(e,"scope"),e.slotScope=t||Fr(e,"slot-scope")):(t=Fr(e,"slot-scope"))&&(e.slotScope=t);var n=Ir(e,"slot");n&&(e.slotTarget='""'===n?'"default"':n,e.slotTargetDynamic=!(!e.attrsMap[":slot"]&&!e.attrsMap["v-bind:slot"]),"template"===e.tag||e.slotScope||Nr(e,"slot",n,function(e,t){return e.rawAttrsMap[":"+t]||e.rawAttrsMap["v-bind:"+t]||e.rawAttrsMap[t]}(e,"slot")));if("template"===e.tag){var r=Pr(e,ia);if(r){var i=va(r),o=i.name,a=i.dynamic;e.slotTarget=o,e.slotTargetDynamic=a,e.slotScope=r.value||ca}}else{var s=Pr(e,ia);if(s){var c=e.scopedSlots||(e.scopedSlots={}),u=va(s),l=u.name,f=u.dynamic,p=c[l]=ua("template",[],e);p.slotTarget=l,p.slotTargetDynamic=f,p.children=e.children.filter(function(e){if(!e.slotScope)return e.parent=p,!0}),p.slotScope=s.value||ca,e.children=[],e.plain=!1}}}(e),function(e){"slot"===e.tag&&(e.slotName=Ir(e,"name"))}(e),function(e){var t;(t=Ir(e,"is"))&&(e.component=t);null!=Fr(e,"inline-template")&&(e.inlineTemplate=!0)}(e);for(var i=0;i<zo.length;i++)e=zo[i](e,t)||e;return function(e){var t,n,r,i,o,a,s,c,u=e.attrsList;for(t=0,n=u.length;t<n;t++)if(r=i=u[t].name,o=u[t].value,Go.test(r))if(e.hasBindings=!0,(a=ha(r.replace(Go,"")))&&(r=r.replace(ra,"")),na.test(r))r=r.replace(na,""),o=Ar(o),(c=ea.test(r))&&(r=r.slice(1,-1)),a&&(a.prop&&!c&&"innerHtml"===(r=b(r))&&(r="innerHTML"),a.camel&&!c&&(r=b(r)),a.sync&&(s=Br(o,"$event"),c?Mr(e,'"update:"+('+r+")",s,null,!1,0,u[t],!0):(Mr(e,"update:"+b(r),s,null,!1,0,u[t]),C(r)!==b(r)&&Mr(e,"update:"+C(r),s,null,!1,0,u[t])))),a&&a.prop||!e.component&&qo(e.tag,e.attrsMap.type,r)?Er(e,r,o,u[t],c):Nr(e,r,o,u[t],c);else if(Zo.test(r))r=r.replace(Zo,""),(c=ea.test(r))&&(r=r.slice(1,-1)),Mr(e,r,o,a,!1,0,u[t],c);else{var l=(r=r.replace(Go,"")).match(ta),f=l&&l[1];c=!1,f&&(r=r.slice(0,-(f.length+1)),ea.test(f)&&(f=f.slice(1,-1),c=!0)),Dr(e,r,i,o,f,c,a,u[t])}else Nr(e,r,JSON.stringify(o),u[t]),!e.component&&"muted"===r&&qo(e.tag,e.attrsMap.type,r)&&Er(e,r,"true",u[t])}(e),e}function pa(e){var t;if(t=Fr(e,"v-for")){var n=function(e){var t=e.match(Xo);if(!t)return;var n={};n.for=t[2].trim();var r=t[1].trim().replace(Qo,""),i=r.match(Yo);i?(n.alias=r.replace(Yo,"").trim(),n.iterator1=i[1].trim(),i[2]&&(n.iterator2=i[2].trim())):n.alias=r;return n}(t);n&&A(e,n)}}function da(e,t){e.ifConditions||(e.ifConditions=[]),e.ifConditions.push(t)}function va(e){var t=e.name.replace(ia,"");return t||"#"!==e.name[0]&&(t="default"),ea.test(t)?{name:t.slice(1,-1),dynamic:!0}:{name:'"'+t+'"',dynamic:!1}}function ha(e){var t=e.match(ra);if(t){var n={};return t.forEach(function(e){n[e.slice(1)]=!0}),n}}function ma(e){for(var t={},n=0,r=e.length;n<r;n++)t[e[n].name]=e[n].value;return t}var ya=/^xmlns:NS\d+/,ga=/^NS\d+:/;function _a(e){return ua(e.tag,e.attrsList.slice(),e.parent)}var ba=[mo,go,{preTransformNode:function(e,t){if("input"===e.tag){var n,r=e.attrsMap;if(!r["v-model"])return;if((r[":type"]||r["v-bind:type"])&&(n=Ir(e,"type")),r.type||n||!r["v-bind"]||(n="("+r["v-bind"]+").type"),n){var i=Fr(e,"v-if",!0),o=i?"&&("+i+")":"",a=null!=Fr(e,"v-else",!0),s=Fr(e,"v-else-if",!0),c=_a(e);pa(c),jr(c,"type","checkbox"),fa(c,t),c.processed=!0,c.if="("+n+")==='checkbox'"+o,da(c,{exp:c.if,block:c});var u=_a(e);Fr(u,"v-for",!0),jr(u,"type","radio"),fa(u,t),da(c,{exp:"("+n+")==='radio'"+o,block:u});var l=_a(e);return Fr(l,"v-for",!0),jr(l,":type",n),fa(l,t),da(c,{exp:i,block:l}),a?c.else=!0:s&&(c.elseif=s),c}}}}];var $a,wa,Ca={expectHTML:!0,modules:ba,directives:{model:function(e,t,n){var r=t.value,i=t.modifiers,o=e.tag,a=e.attrsMap.type;if(e.component)return Hr(e,r,i),!1;if("select"===o)!function(e,t,n){var r='var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return '+(n&&n.number?"_n(val)":"val")+"});";r=r+" "+Br(t,"$event.target.multiple ? $$selectedVal : $$selectedVal[0]"),Mr(e,"change",r,null,!0)}(e,r,i);else if("input"===o&&"checkbox"===a)!function(e,t,n){var r=n&&n.number,i=Ir(e,"value")||"null",o=Ir(e,"true-value")||"true",a=Ir(e,"false-value")||"false";Er(e,"checked","Array.isArray("+t+")?_i("+t+","+i+")>-1"+("true"===o?":("+t+")":":_q("+t+","+o+")")),Mr(e,"change","var $$a="+t+",$$el=$event.target,$$c=$$el.checked?("+o+"):("+a+");if(Array.isArray($$a)){var $$v="+(r?"_n("+i+")":i)+",$$i=_i($$a,$$v);if($$el.checked){$$i<0&&("+Br(t,"$$a.concat([$$v])")+")}else{$$i>-1&&("+Br(t,"$$a.slice(0,$$i).concat($$a.slice($$i+1))")+")}}else{"+Br(t,"$$c")+"}",null,!0)}(e,r,i);else if("input"===o&&"radio"===a)!function(e,t,n){var r=n&&n.number,i=Ir(e,"value")||"null";Er(e,"checked","_q("+t+","+(i=r?"_n("+i+")":i)+")"),Mr(e,"change",Br(t,i),null,!0)}(e,r,i);else if("input"===o||"textarea"===o)!function(e,t,n){var r=e.attrsMap.type,i=n||{},o=i.lazy,a=i.number,s=i.trim,c=!o&&"range"!==r,u=o?"change":"range"===r?Wr:"input",l="$event.target.value";s&&(l="$event.target.value.trim()"),a&&(l="_n("+l+")");var f=Br(t,l);c&&(f="if($event.target.composing)return;"+f),Er(e,"value","("+t+")"),Mr(e,u,f,null,!0),(s||a)&&Mr(e,"blur","$forceUpdate()")}(e,r,i);else if(!F.isReservedTag(o))return Hr(e,r,i),!1;return!0},text:function(e,t){t.value&&Er(e,"textContent","_s("+t.value+")",t)},html:function(e,t){t.value&&Er(e,"innerHTML","_s("+t.value+")",t)}},isPreTag:function(e){return"pre"===e},isUnaryTag:bo,mustUseProp:jn,canBeLeftOpenTag:$o,isReservedTag:Wn,getTagNamespace:Zn,staticKeys:function(e){return e.reduce(function(e,t){return e.concat(t.staticKeys||[])},[]).join(",")}(ba)},xa=g(function(e){return p("type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap"+(e?","+e:""))});function ka(e,t){e&&($a=xa(t.staticKeys||""),wa=t.isReservedTag||T,function e(t){t.static=function(e){if(2===e.type)return!1;if(3===e.type)return!0;return!(!e.pre&&(e.hasBindings||e.if||e.for||d(e.tag)||!wa(e.tag)||function(e){for(;e.parent;){if("template"!==(e=e.parent).tag)return!1;if(e.for)return!0}return!1}(e)||!Object.keys(e).every($a)))}(t);if(1===t.type){if(!wa(t.tag)&&"slot"!==t.tag&&null==t.attrsMap["inline-template"])return;for(var n=0,r=t.children.length;n<r;n++){var i=t.children[n];e(i),i.static||(t.static=!1)}if(t.ifConditions)for(var o=1,a=t.ifConditions.length;o<a;o++){var s=t.ifConditions[o].block;e(s),s.static||(t.static=!1)}}}(e),function e(t,n){if(1===t.type){if((t.static||t.once)&&(t.staticInFor=n),t.static&&t.children.length&&(1!==t.children.length||3!==t.children[0].type))return void(t.staticRoot=!0);if(t.staticRoot=!1,t.children)for(var r=0,i=t.children.length;r<i;r++)e(t.children[r],n||!!t.for);if(t.ifConditions)for(var o=1,a=t.ifConditions.length;o<a;o++)e(t.ifConditions[o].block,n)}}(e,!1))}var Aa=/^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/,Oa=/\([^)]*?\);*$/,Sa=/^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/,Ta={esc:27,tab:9,enter:13,space:32,up:38,left:37,right:39,down:40,delete:[8,46]},Ea={esc:["Esc","Escape"],tab:"Tab",enter:"Enter",space:[" ","Spacebar"],up:["Up","ArrowUp"],left:["Left","ArrowLeft"],right:["Right","ArrowRight"],down:["Down","ArrowDown"],delete:["Backspace","Delete","Del"]},Na=function(e){return"if("+e+")return null;"},ja={stop:"$event.stopPropagation();",prevent:"$event.preventDefault();",self:Na("$event.target !== $event.currentTarget"),ctrl:Na("!$event.ctrlKey"),shift:Na("!$event.shiftKey"),alt:Na("!$event.altKey"),meta:Na("!$event.metaKey"),left:Na("'button' in $event && $event.button !== 0"),middle:Na("'button' in $event && $event.button !== 1"),right:Na("'button' in $event && $event.button !== 2")};function Da(e,t){var n=t?"nativeOn:":"on:",r="",i="";for(var o in e){var a=La(e[o]);e[o]&&e[o].dynamic?i+=o+","+a+",":r+='"'+o+'":'+a+","}return r="{"+r.slice(0,-1)+"}",i?n+"_d("+r+",["+i.slice(0,-1)+"])":n+r}function La(e){if(!e)return"function(){}";if(Array.isArray(e))return"["+e.map(function(e){return La(e)}).join(",")+"]";var t=Sa.test(e.value),n=Aa.test(e.value),r=Sa.test(e.value.replace(Oa,""));if(e.modifiers){var i="",o="",a=[];for(var s in e.modifiers)if(ja[s])o+=ja[s],Ta[s]&&a.push(s);else if("exact"===s){var c=e.modifiers;o+=Na(["ctrl","shift","alt","meta"].filter(function(e){return!c[e]}).map(function(e){return"$event."+e+"Key"}).join("||"))}else a.push(s);return a.length&&(i+=function(e){return"if(!$event.type.indexOf('key')&&"+e.map(Ma).join("&&")+")return null;"}(a)),o&&(i+=o),"function($event){"+i+(t?"return "+e.value+"($event)":n?"return ("+e.value+")($event)":r?"return "+e.value:e.value)+"}"}return t||n?e.value:"function($event){"+(r?"return "+e.value:e.value)+"}"}function Ma(e){var t=parseInt(e,10);if(t)return"$event.keyCode!=="+t;var n=Ta[e],r=Ea[e];return"_k($event.keyCode,"+JSON.stringify(e)+","+JSON.stringify(n)+",$event.key,"+JSON.stringify(r)+")"}var Ia={on:function(e,t){e.wrapListeners=function(e){return"_g("+e+","+t.value+")"}},bind:function(e,t){e.wrapData=function(n){return"_b("+n+",'"+e.tag+"',"+t.value+","+(t.modifiers&&t.modifiers.prop?"true":"false")+(t.modifiers&&t.modifiers.sync?",true":"")+")"}},cloak:S},Fa=function(e){this.options=e,this.warn=e.warn||Sr,this.transforms=Tr(e.modules,"transformCode"),this.dataGenFns=Tr(e.modules,"genData"),this.directives=A(A({},Ia),e.directives);var t=e.isReservedTag||T;this.maybeComponent=function(e){return!!e.component||!t(e.tag)},this.onceId=0,this.staticRenderFns=[],this.pre=!1};function Pa(e,t){var n=new Fa(t);return{render:"with(this){return "+(e?Ra(e,n):'_c("div")')+"}",staticRenderFns:n.staticRenderFns}}function Ra(e,t){if(e.parent&&(e.pre=e.pre||e.parent.pre),e.staticRoot&&!e.staticProcessed)return Ha(e,t);if(e.once&&!e.onceProcessed)return Ba(e,t);if(e.for&&!e.forProcessed)return za(e,t);if(e.if&&!e.ifProcessed)return Ua(e,t);if("template"!==e.tag||e.slotTarget||t.pre){if("slot"===e.tag)return function(e,t){var n=e.slotName||'"default"',r=qa(e,t),i="_t("+n+(r?","+r:""),o=e.attrs||e.dynamicAttrs?Ga((e.attrs||[]).concat(e.dynamicAttrs||[]).map(function(e){return{name:b(e.name),value:e.value,dynamic:e.dynamic}})):null,a=e.attrsMap["v-bind"];!o&&!a||r||(i+=",null");o&&(i+=","+o);a&&(i+=(o?"":",null")+","+a);return i+")"}(e,t);var n;if(e.component)n=function(e,t,n){var r=t.inlineTemplate?null:qa(t,n,!0);return"_c("+e+","+Va(t,n)+(r?","+r:"")+")"}(e.component,e,t);else{var r;(!e.plain||e.pre&&t.maybeComponent(e))&&(r=Va(e,t));var i=e.inlineTemplate?null:qa(e,t,!0);n="_c('"+e.tag+"'"+(r?","+r:"")+(i?","+i:"")+")"}for(var o=0;o<t.transforms.length;o++)n=t.transforms[o](e,n);return n}return qa(e,t)||"void 0"}function Ha(e,t){e.staticProcessed=!0;var n=t.pre;return e.pre&&(t.pre=e.pre),t.staticRenderFns.push("with(this){return "+Ra(e,t)+"}"),t.pre=n,"_m("+(t.staticRenderFns.length-1)+(e.staticInFor?",true":"")+")"}function Ba(e,t){if(e.onceProcessed=!0,e.if&&!e.ifProcessed)return Ua(e,t);if(e.staticInFor){for(var n="",r=e.parent;r;){if(r.for){n=r.key;break}r=r.parent}return n?"_o("+Ra(e,t)+","+t.onceId+++","+n+")":Ra(e,t)}return Ha(e,t)}function Ua(e,t,n,r){return e.ifProcessed=!0,function e(t,n,r,i){if(!t.length)return i||"_e()";var o=t.shift();return o.exp?"("+o.exp+")?"+a(o.block)+":"+e(t,n,r,i):""+a(o.block);function a(e){return r?r(e,n):e.once?Ba(e,n):Ra(e,n)}}(e.ifConditions.slice(),t,n,r)}function za(e,t,n,r){var i=e.for,o=e.alias,a=e.iterator1?","+e.iterator1:"",s=e.iterator2?","+e.iterator2:"";return e.forProcessed=!0,(r||"_l")+"(("+i+"),function("+o+a+s+"){return "+(n||Ra)(e,t)+"})"}function Va(e,t){var n="{",r=function(e,t){var n=e.directives;if(!n)return;var r,i,o,a,s="directives:[",c=!1;for(r=0,i=n.length;r<i;r++){o=n[r],a=!0;var u=t.directives[o.name];u&&(a=!!u(e,o,t.warn)),a&&(c=!0,s+='{name:"'+o.name+'",rawName:"'+o.rawName+'"'+(o.value?",value:("+o.value+"),expression:"+JSON.stringify(o.value):"")+(o.arg?",arg:"+(o.isDynamicArg?o.arg:'"'+o.arg+'"'):"")+(o.modifiers?",modifiers:"+JSON.stringify(o.modifiers):"")+"},")}if(c)return s.slice(0,-1)+"]"}(e,t);r&&(n+=r+","),e.key&&(n+="key:"+e.key+","),e.ref&&(n+="ref:"+e.ref+","),e.refInFor&&(n+="refInFor:true,"),e.pre&&(n+="pre:true,"),e.component&&(n+='tag:"'+e.tag+'",');for(var i=0;i<t.dataGenFns.length;i++)n+=t.dataGenFns[i](e);if(e.attrs&&(n+="attrs:"+Ga(e.attrs)+","),e.props&&(n+="domProps:"+Ga(e.props)+","),e.events&&(n+=Da(e.events,!1)+","),e.nativeEvents&&(n+=Da(e.nativeEvents,!0)+","),e.slotTarget&&!e.slotScope&&(n+="slot:"+e.slotTarget+","),e.scopedSlots&&(n+=function(e,t,n){var r=e.for||Object.keys(t).some(function(e){var n=t[e];return n.slotTargetDynamic||n.if||n.for||Ka(n)}),i=!!e.if;if(!r)for(var o=e.parent;o;){if(o.slotScope&&o.slotScope!==ca||o.for){r=!0;break}o.if&&(i=!0),o=o.parent}var a=Object.keys(t).map(function(e){return Ja(t[e],n)}).join(",");return"scopedSlots:_u(["+a+"]"+(r?",null,true":"")+(!r&&i?",null,false,"+function(e){var t=5381,n=e.length;for(;n;)t=33*t^e.charCodeAt(--n);return t>>>0}(a):"")+")"}(e,e.scopedSlots,t)+","),e.model&&(n+="model:{value:"+e.model.value+",callback:"+e.model.callback+",expression:"+e.model.expression+"},"),e.inlineTemplate){var o=function(e,t){var n=e.children[0];if(n&&1===n.type){var r=Pa(n,t.options);return"inlineTemplate:{render:function(){"+r.render+"},staticRenderFns:["+r.staticRenderFns.map(function(e){return"function(){"+e+"}"}).join(",")+"]}"}}(e,t);o&&(n+=o+",")}return n=n.replace(/,$/,"")+"}",e.dynamicAttrs&&(n="_b("+n+',"'+e.tag+'",'+Ga(e.dynamicAttrs)+")"),e.wrapData&&(n=e.wrapData(n)),e.wrapListeners&&(n=e.wrapListeners(n)),n}function Ka(e){return 1===e.type&&("slot"===e.tag||e.children.some(Ka))}function Ja(e,t){var n=e.attrsMap["slot-scope"];if(e.if&&!e.ifProcessed&&!n)return Ua(e,t,Ja,"null");if(e.for&&!e.forProcessed)return za(e,t,Ja);var r=e.slotScope===ca?"":String(e.slotScope),i="function("+r+"){return "+("template"===e.tag?e.if&&n?"("+e.if+")?"+(qa(e,t)||"undefined")+":undefined":qa(e,t)||"undefined":Ra(e,t))+"}",o=r?"":",proxy:true";return"{key:"+(e.slotTarget||'"default"')+",fn:"+i+o+"}"}function qa(e,t,n,r,i){var o=e.children;if(o.length){var a=o[0];if(1===o.length&&a.for&&"template"!==a.tag&&"slot"!==a.tag){var s=n?t.maybeComponent(a)?",1":",0":"";return""+(r||Ra)(a,t)+s}var c=n?function(e,t){for(var n=0,r=0;r<e.length;r++){var i=e[r];if(1===i.type){if(Wa(i)||i.ifConditions&&i.ifConditions.some(function(e){return Wa(e.block)})){n=2;break}(t(i)||i.ifConditions&&i.ifConditions.some(function(e){return t(e.block)}))&&(n=1)}}return n}(o,t.maybeComponent):0,u=i||Za;return"["+o.map(function(e){return u(e,t)}).join(",")+"]"+(c?","+c:"")}}function Wa(e){return void 0!==e.for||"template"===e.tag||"slot"===e.tag}function Za(e,t){return 1===e.type?Ra(e,t):3===e.type&&e.isComment?(r=e,"_e("+JSON.stringify(r.text)+")"):"_v("+(2===(n=e).type?n.expression:Xa(JSON.stringify(n.text)))+")";var n,r}function Ga(e){for(var t="",n="",r=0;r<e.length;r++){var i=e[r],o=Xa(i.value);i.dynamic?n+=i.name+","+o+",":t+='"'+i.name+'":'+o+","}return t="{"+t.slice(0,-1)+"}",n?"_d("+t+",["+n.slice(0,-1)+"])":t}function Xa(e){return e.replace(/\u2028/g,"\\u2028").replace(/\u2029/g,"\\u2029")}new RegExp("\\b"+"do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,super,throw,while,yield,delete,export,import,return,switch,default,extends,finally,continue,debugger,function,arguments".split(",").join("\\b|\\b")+"\\b");function Ya(e,t){try{return new Function(e)}catch(n){return t.push({err:n,code:e}),S}}function Qa(e){var t=Object.create(null);return function(n,r,i){(r=A({},r)).warn;delete r.warn;var o=r.delimiters?String(r.delimiters)+n:n;if(t[o])return t[o];var a=e(n,r),s={},c=[];return s.render=Ya(a.render,c),s.staticRenderFns=a.staticRenderFns.map(function(e){return Ya(e,c)}),t[o]=s}}var es,ts,ns=(es=function(e,t){var n=la(e.trim(),t);!1!==t.optimize&&ka(n,t);var r=Pa(n,t);return{ast:n,render:r.render,staticRenderFns:r.staticRenderFns}},function(e){function t(t,n){var r=Object.create(e),i=[],o=[];if(n)for(var a in n.modules&&(r.modules=(e.modules||[]).concat(n.modules)),n.directives&&(r.directives=A(Object.create(e.directives||null),n.directives)),n)"modules"!==a&&"directives"!==a&&(r[a]=n[a]);r.warn=function(e,t,n){(n?o:i).push(e)};var s=es(t.trim(),r);return s.errors=i,s.tips=o,s}return{compile:t,compileToFunctions:Qa(t)}})(Ca),rs=(ns.compile,ns.compileToFunctions);function is(e){return(ts=ts||document.createElement("div")).innerHTML=e?'<a href="\n"/>':'<div a="\n"/>',ts.innerHTML.indexOf("&#10;")>0}var os=!!z&&is(!1),as=!!z&&is(!0),ss=g(function(e){var t=Yn(e);return t&&t.innerHTML}),cs=wn.prototype.$mount;wn.prototype.$mount=function(e,t){if((e=e&&Yn(e))===document.body||e===document.documentElement)return this;var n=this.$options;if(!n.render){var r=n.template;if(r)if("string"==typeof r)"#"===r.charAt(0)&&(r=ss(r));else{if(!r.nodeType)return this;r=r.innerHTML}else e&&(r=function(e){if(e.outerHTML)return e.outerHTML;var t=document.createElement("div");return t.appendChild(e.cloneNode(!0)),t.innerHTML}(e));if(r){var i=rs(r,{outputSourceRange:!1,shouldDecodeNewlines:os,shouldDecodeNewlinesForHref:as,delimiters:n.delimiters,comments:n.comments},this),o=i.render,a=i.staticRenderFns;n.render=o,n.staticRenderFns=a}}return cs.call(this,e,t)},wn.compile=rs,module.exports=wn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(465).setImmediate))

/***/ }),
/* 662 */
/***/ (function(module, exports) {

	var base = {
	  8: "Backspace",
	  9: "Tab",
	  10: "Enter",
	  12: "NumLock",
	  13: "Enter",
	  16: "Shift",
	  17: "Control",
	  18: "Alt",
	  20: "CapsLock",
	  27: "Escape",
	  32: " ",
	  33: "PageUp",
	  34: "PageDown",
	  35: "End",
	  36: "Home",
	  37: "ArrowLeft",
	  38: "ArrowUp",
	  39: "ArrowRight",
	  40: "ArrowDown",
	  44: "PrintScreen",
	  45: "Insert",
	  46: "Delete",
	  59: ";",
	  61: "=",
	  91: "Meta",
	  92: "Meta",
	  106: "*",
	  107: "+",
	  108: ",",
	  109: "-",
	  110: ".",
	  111: "/",
	  144: "NumLock",
	  145: "ScrollLock",
	  160: "Shift",
	  161: "Shift",
	  162: "Control",
	  163: "Control",
	  164: "Alt",
	  165: "Alt",
	  173: "-",
	  186: ";",
	  187: "=",
	  188: ",",
	  189: "-",
	  190: ".",
	  191: "/",
	  192: "`",
	  219: "[",
	  220: "\\",
	  221: "]",
	  222: "'",
	  229: "q"
	}
	exports.base = base
	
	var shift = {
	  48: ")",
	  49: "!",
	  50: "@",
	  51: "#",
	  52: "$",
	  53: "%",
	  54: "^",
	  55: "&",
	  56: "*",
	  57: "(",
	  59: ";",
	  61: "+",
	  173: "_",
	  186: ":",
	  187: "+",
	  188: "<",
	  189: "_",
	  190: ">",
	  191: "?",
	  192: "~",
	  219: "{",
	  220: "|",
	  221: "}",
	  222: "\"",
	  229: "Q"
	}
	exports.shift = shift
	
	var chrome = typeof navigator != "undefined" && /Chrome\/(\d+)/.exec(navigator.userAgent)
	var safari = typeof navigator != "undefined" && /Apple Computer/.test(navigator.vendor)
	var gecko = typeof navigator != "undefined" && /Gecko\/\d+/.test(navigator.userAgent)
	var mac = typeof navigator != "undefined" && /Mac/.test(navigator.platform)
	var ie = typeof navigator != "undefined" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent)
	var brokenModifierNames = chrome && (mac || +chrome[1] < 57) || gecko && mac
	
	// Fill in the digit keys
	for (var i = 0; i < 10; i++) base[48 + i] = base[96 + i] = String(i)
	
	// The function keys
	for (var i = 1; i <= 24; i++) base[i + 111] = "F" + i
	
	// And the alphabetic keys
	for (var i = 65; i <= 90; i++) {
	  base[i] = String.fromCharCode(i + 32)
	  shift[i] = String.fromCharCode(i)
	}
	
	// For each code that doesn't have a shift-equivalent, copy the base name
	for (var code in base) if (!shift.hasOwnProperty(code)) shift[code] = base[code]
	
	exports.keyName = function(event) {
	  // Don't trust event.key in Chrome when there are modifiers until
	  // they fix https://bugs.chromium.org/p/chromium/issues/detail?id=633838
	  var ignoreKey = brokenModifierNames && (event.ctrlKey || event.altKey || event.metaKey) ||
	    (safari || ie) && event.shiftKey && event.key && event.key.length == 1
	  var name = (!ignoreKey && event.key) ||
	    (event.shiftKey ? shift : base)[event.keyCode] ||
	    event.key || "Unidentified"
	  // Edge sometimes produces wrong names (Issue #3)
	  if (name == "Esc") name = "Escape"
	  if (name == "Del") name = "Delete"
	  // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/8860571/
	  if (name == "Left") name = "ArrowLeft"
	  if (name == "Up") name = "ArrowUp"
	  if (name == "Right") name = "ArrowRight"
	  if (name == "Down") name = "ArrowDown"
	  return name
	}


/***/ }),
/* 663 */
/***/ (function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	    } else if (Array.isArray(headers)) {
	      headers.forEach(function(header) {
	        this.append(header[0], header[1])
	      }, this)
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
	    // https://tools.ietf.org/html/rfc7230#section-3.2
	    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
	    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = options.status === undefined ? 200 : options.status
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      } else if (request.credentials === 'omit') {
	        xhr.withCredentials = false
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 664 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })
]);


// WEBPACK FOOTER //
// static/js/app.bca3af969a449119d745.js